var _H = Object.defineProperty;
var wH = (t, e, n) => e in t ? _H(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Ao = (t, e, n) => wH(t, typeof e != "symbol" ? e + "" : e, n);
var vr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Et(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Iw(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var s = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, s.get ? s : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var BA = { exports: {} }, SH = "Function.prototype.bind called on incompatible ", IH = Object.prototype.toString, EH = Math.max, xH = "[object Function]", hE = function(e, n) {
  for (var r = [], s = 0; s < e.length; s += 1)
    r[s] = e[s];
  for (var i = 0; i < n.length; i += 1)
    r[i + e.length] = n[i];
  return r;
}, CH = function(e, n) {
  for (var r = [], s = n, i = 0; s < e.length; s += 1, i += 1)
    r[i] = e[s];
  return r;
}, TH = function(t, e) {
  for (var n = "", r = 0; r < t.length; r += 1)
    n += t[r], r + 1 < t.length && (n += e);
  return n;
}, PH = function(e) {
  var n = this;
  if (typeof n != "function" || IH.apply(n) !== xH)
    throw new TypeError(SH + n);
  for (var r = CH(arguments, 1), s, i = function() {
    if (this instanceof s) {
      var u = n.apply(
        this,
        hE(r, arguments)
      );
      return Object(u) === u ? u : this;
    }
    return n.apply(
      e,
      hE(r, arguments)
    );
  }, o = EH(0, n.length - r.length), a = [], l = 0; l < o; l++)
    a[l] = "$" + l;
  if (s = Function("binder", "return function (" + TH(a, ",") + "){ return binder.apply(this,arguments); }")(i), n.prototype) {
    var c = function() {
    };
    c.prototype = n.prototype, s.prototype = new c(), c.prototype = null;
  }
  return s;
}, kH = PH, Ew = Function.prototype.bind || kH, NH = Error, $H = EvalError, DH = RangeError, AH = ReferenceError, jA = SyntaxError, ii = TypeError, OH = URIError, WA = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, n = Symbol("test"), r = Object(n);
  if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
    return !1;
  var s = 42;
  e[n] = s;
  for (n in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(e);
  if (i.length !== 1 || i[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(e, n);
    if (o.value !== s || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, mE = typeof Symbol < "u" && Symbol, MH = WA, HA = function() {
  return typeof mE != "function" || typeof Symbol != "function" || typeof mE("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : MH();
}, Tg = {
  __proto__: null,
  foo: {}
}, RH = Object, LH = function() {
  return { __proto__: Tg }.foo === Tg.foo && !(Tg instanceof RH);
}, FH = Function.prototype.call, BH = Object.prototype.hasOwnProperty, jH = Ew, VA = jH.call(FH, BH), Ft, WH = NH, HH = $H, VH = DH, zH = AH, Qc = jA, Uc = ii, UH = OH, zA = Function, Pg = function(t) {
  try {
    return zA('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, Ol = Object.getOwnPropertyDescriptor;
if (Ol)
  try {
    Ol({}, "");
  } catch {
    Ol = null;
  }
var kg = function() {
  throw new Uc();
}, GH = Ol ? function() {
  try {
    return arguments.callee, kg;
  } catch {
    try {
      return Ol(arguments, "callee").get;
    } catch {
      return kg;
    }
  }
}() : kg, bc = HA(), YH = LH(), Lr = Object.getPrototypeOf || (YH ? function(t) {
  return t.__proto__;
} : null), Ac = {}, ZH = typeof Uint8Array > "u" || !Lr ? Ft : Lr(Uint8Array), Ml = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? Ft : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Ft : ArrayBuffer,
  "%ArrayIteratorPrototype%": bc && Lr ? Lr([][Symbol.iterator]()) : Ft,
  "%AsyncFromSyncIteratorPrototype%": Ft,
  "%AsyncFunction%": Ac,
  "%AsyncGenerator%": Ac,
  "%AsyncGeneratorFunction%": Ac,
  "%AsyncIteratorPrototype%": Ac,
  "%Atomics%": typeof Atomics > "u" ? Ft : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Ft : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? Ft : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? Ft : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Ft : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": WH,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": HH,
  "%Float32Array%": typeof Float32Array > "u" ? Ft : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Ft : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Ft : FinalizationRegistry,
  "%Function%": zA,
  "%GeneratorFunction%": Ac,
  "%Int8Array%": typeof Int8Array > "u" ? Ft : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Ft : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Ft : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": bc && Lr ? Lr(Lr([][Symbol.iterator]())) : Ft,
  "%JSON%": typeof JSON == "object" ? JSON : Ft,
  "%Map%": typeof Map > "u" ? Ft : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !bc || !Lr ? Ft : Lr((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Ft : Promise,
  "%Proxy%": typeof Proxy > "u" ? Ft : Proxy,
  "%RangeError%": VH,
  "%ReferenceError%": zH,
  "%Reflect%": typeof Reflect > "u" ? Ft : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Ft : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !bc || !Lr ? Ft : Lr((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Ft : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": bc && Lr ? Lr(""[Symbol.iterator]()) : Ft,
  "%Symbol%": bc ? Symbol : Ft,
  "%SyntaxError%": Qc,
  "%ThrowTypeError%": GH,
  "%TypedArray%": ZH,
  "%TypeError%": Uc,
  "%Uint8Array%": typeof Uint8Array > "u" ? Ft : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Ft : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Ft : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Ft : Uint32Array,
  "%URIError%": UH,
  "%WeakMap%": typeof WeakMap > "u" ? Ft : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Ft : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Ft : WeakSet
};
if (Lr)
  try {
    null.error;
  } catch (t) {
    var XH = Lr(Lr(t));
    Ml["%Error.prototype%"] = XH;
  }
var KH = function t(e) {
  var n;
  if (e === "%AsyncFunction%")
    n = Pg("async function () {}");
  else if (e === "%GeneratorFunction%")
    n = Pg("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    n = Pg("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var r = t("%AsyncGeneratorFunction%");
    r && (n = r.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var s = t("%AsyncGenerator%");
    s && Lr && (n = Lr(s.prototype));
  }
  return Ml[e] = n, n;
}, vE = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, xf = Ew, Wh = VA, JH = xf.call(Function.call, Array.prototype.concat), qH = xf.call(Function.apply, Array.prototype.splice), gE = xf.call(Function.call, String.prototype.replace), Hh = xf.call(Function.call, String.prototype.slice), QH = xf.call(Function.call, RegExp.prototype.exec), eV = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, tV = /\\(\\)?/g, nV = function(e) {
  var n = Hh(e, 0, 1), r = Hh(e, -1);
  if (n === "%" && r !== "%")
    throw new Qc("invalid intrinsic syntax, expected closing `%`");
  if (r === "%" && n !== "%")
    throw new Qc("invalid intrinsic syntax, expected opening `%`");
  var s = [];
  return gE(e, eV, function(i, o, a, l) {
    s[s.length] = a ? gE(l, tV, "$1") : o || i;
  }), s;
}, rV = function(e, n) {
  var r = e, s;
  if (Wh(vE, r) && (s = vE[r], r = "%" + s[0] + "%"), Wh(Ml, r)) {
    var i = Ml[r];
    if (i === Ac && (i = KH(r)), typeof i > "u" && !n)
      throw new Uc("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: s,
      name: r,
      value: i
    };
  }
  throw new Qc("intrinsic " + e + " does not exist!");
}, Jo = function(e, n) {
  if (typeof e != "string" || e.length === 0)
    throw new Uc("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof n != "boolean")
    throw new Uc('"allowMissing" argument must be a boolean');
  if (QH(/^%?[^%]*%?$/, e) === null)
    throw new Qc("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var r = nV(e), s = r.length > 0 ? r[0] : "", i = rV("%" + s + "%", n), o = i.name, a = i.value, l = !1, c = i.alias;
  c && (s = c[0], qH(r, JH([0, 1], c)));
  for (var u = 1, d = !0; u < r.length; u += 1) {
    var f = r[u], p = Hh(f, 0, 1), h = Hh(f, -1);
    if ((p === '"' || p === "'" || p === "`" || h === '"' || h === "'" || h === "`") && p !== h)
      throw new Qc("property names with quotes must have matching quotes");
    if ((f === "constructor" || !d) && (l = !0), s += "." + f, o = "%" + s + "%", Wh(Ml, o))
      a = Ml[o];
    else if (a != null) {
      if (!(f in a)) {
        if (!n)
          throw new Uc("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Ol && u + 1 >= r.length) {
        var m = Ol(a, f);
        d = !!m, d && "get" in m && !("originalValue" in m.get) ? a = m.get : a = a[f];
      } else
        d = Wh(a, f), a = a[f];
      d && !l && (Ml[o] = a);
    }
  }
  return a;
}, Ng, yE;
function xw() {
  if (yE) return Ng;
  yE = 1;
  var t = Jo, e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Ng = e, Ng;
}
var sV = Jo, Zp = sV("%Object.getOwnPropertyDescriptor%", !0);
if (Zp)
  try {
    Zp([], "length");
  } catch {
    Zp = null;
  }
var UA = Zp, bE = xw(), iV = jA, _c = ii, _E = UA, GA = function(e, n, r) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new _c("`obj` must be an object or a function`");
  if (typeof n != "string" && typeof n != "symbol")
    throw new _c("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new _c("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new _c("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new _c("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new _c("`loose`, if provided, must be a boolean");
  var s = arguments.length > 3 ? arguments[3] : null, i = arguments.length > 4 ? arguments[4] : null, o = arguments.length > 5 ? arguments[5] : null, a = arguments.length > 6 ? arguments[6] : !1, l = !!_E && _E(e, n);
  if (bE)
    bE(e, n, {
      configurable: o === null && l ? l.configurable : !o,
      enumerable: s === null && l ? l.enumerable : !s,
      value: r,
      writable: i === null && l ? l.writable : !i
    });
  else if (a || !s && !i && !o)
    e[n] = r;
  else
    throw new iV("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Gb = xw(), YA = function() {
  return !!Gb;
};
YA.hasArrayLengthDefineBug = function() {
  if (!Gb)
    return null;
  try {
    return Gb([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var ZA = YA, oV = Jo, wE = GA, aV = ZA(), SE = UA, IE = ii, lV = oV("%Math.floor%"), cV = function(e, n) {
  if (typeof e != "function")
    throw new IE("`fn` is not a function");
  if (typeof n != "number" || n < 0 || n > 4294967295 || lV(n) !== n)
    throw new IE("`length` must be a positive 32-bit integer");
  var r = arguments.length > 2 && !!arguments[2], s = !0, i = !0;
  if ("length" in e && SE) {
    var o = SE(e, "length");
    o && !o.configurable && (s = !1), o && !o.writable && (i = !1);
  }
  return (s || i || !r) && (aV ? wE(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    n,
    !0,
    !0
  ) : wE(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    n
  )), e;
};
(function(t) {
  var e = Ew, n = Jo, r = cV, s = ii, i = n("%Function.prototype.apply%"), o = n("%Function.prototype.call%"), a = n("%Reflect.apply%", !0) || e.call(o, i), l = xw(), c = n("%Math.max%");
  t.exports = function(f) {
    if (typeof f != "function")
      throw new s("a function is required");
    var p = a(e, o, arguments);
    return r(
      p,
      1 + c(0, f.length - (arguments.length - 1)),
      !0
    );
  };
  var u = function() {
    return a(e, i, arguments);
  };
  l ? l(t.exports, "apply", { value: u }) : t.exports.apply = u;
})(BA);
var Cw = BA.exports, EE = Object.prototype.toString, XA = function(e) {
  var n = EE.call(e), r = n === "[object Arguments]";
  return r || (r = n !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && EE.call(e.callee) === "[object Function]"), r;
}, $g, xE;
function uV() {
  if (xE) return $g;
  xE = 1;
  var t;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = XA, s = Object.prototype.propertyIsEnumerable, i = !s.call({ toString: null }, "toString"), o = s.call(function() {
    }, "prototype"), a = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], l = function(f) {
      var p = f.constructor;
      return p && p.prototype === f;
    }, c = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, u = function() {
      if (typeof window > "u")
        return !1;
      for (var f in window)
        try {
          if (!c["$" + f] && e.call(window, f) && window[f] !== null && typeof window[f] == "object")
            try {
              l(window[f]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), d = function(f) {
      if (typeof window > "u" || !u)
        return l(f);
      try {
        return l(f);
      } catch {
        return !1;
      }
    };
    t = function(p) {
      var h = p !== null && typeof p == "object", m = n.call(p) === "[object Function]", v = r(p), y = h && n.call(p) === "[object String]", _ = [];
      if (!h && !m && !v)
        throw new TypeError("Object.keys called on a non-object");
      var w = o && m;
      if (y && p.length > 0 && !e.call(p, 0))
        for (var S = 0; S < p.length; ++S)
          _.push(String(S));
      if (v && p.length > 0)
        for (var E = 0; E < p.length; ++E)
          _.push(String(E));
      else
        for (var x in p)
          !(w && x === "prototype") && e.call(p, x) && _.push(String(x));
      if (i)
        for (var T = d(p), C = 0; C < a.length; ++C)
          !(T && a[C] === "constructor") && e.call(p, a[C]) && _.push(a[C]);
      return _;
    };
  }
  return $g = t, $g;
}
var dV = Array.prototype.slice, fV = XA, CE = Object.keys, Xp = CE ? function(e) {
  return CE(e);
} : uV(), TE = Object.keys;
Xp.shim = function() {
  if (Object.keys) {
    var e = function() {
      var n = Object.keys(arguments);
      return n && n.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(r) {
      return fV(r) ? TE(dV.call(r)) : TE(r);
    });
  } else
    Object.keys = Xp;
  return Object.keys || Xp;
};
var pV = Xp, hV = pV, mV = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", vV = Object.prototype.toString, gV = Array.prototype.concat, PE = GA, yV = function(t) {
  return typeof t == "function" && vV.call(t) === "[object Function]";
}, KA = ZA(), bV = function(t, e, n, r) {
  if (e in t) {
    if (r === !0) {
      if (t[e] === n)
        return;
    } else if (!yV(r) || !r())
      return;
  }
  KA ? PE(t, e, n, !0) : PE(t, e, n);
}, JA = function(t, e) {
  var n = arguments.length > 2 ? arguments[2] : {}, r = hV(e);
  mV && (r = gV.call(r, Object.getOwnPropertySymbols(e)));
  for (var s = 0; s < r.length; s += 1)
    bV(t, r[s], e[r[s]], n[r[s]]);
};
JA.supportsDescriptors = !!KA;
var iv = JA, _V = ii, ov = function(e) {
  if (e == null)
    throw new _V(arguments.length > 0 && arguments[1] || "Cannot call method on " + e);
  return e;
};
const wV = {}, SV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wV
}, Symbol.toStringTag, { value: "Module" })), IV = /* @__PURE__ */ Iw(SV);
var Tw = typeof Map == "function" && Map.prototype, Dg = Object.getOwnPropertyDescriptor && Tw ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Vh = Tw && Dg && typeof Dg.get == "function" ? Dg.get : null, kE = Tw && Map.prototype.forEach, Pw = typeof Set == "function" && Set.prototype, Ag = Object.getOwnPropertyDescriptor && Pw ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, zh = Pw && Ag && typeof Ag.get == "function" ? Ag.get : null, NE = Pw && Set.prototype.forEach, EV = typeof WeakMap == "function" && WeakMap.prototype, Ld = EV ? WeakMap.prototype.has : null, xV = typeof WeakSet == "function" && WeakSet.prototype, Fd = xV ? WeakSet.prototype.has : null, CV = typeof WeakRef == "function" && WeakRef.prototype, $E = CV ? WeakRef.prototype.deref : null, TV = Boolean.prototype.valueOf, PV = Object.prototype.toString, kV = Function.prototype.toString, NV = String.prototype.match, kw = String.prototype.slice, wa = String.prototype.replace, $V = String.prototype.toUpperCase, DE = String.prototype.toLowerCase, qA = RegExp.prototype.test, AE = Array.prototype.concat, oo = Array.prototype.join, DV = Array.prototype.slice, OE = Math.floor, Yb = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Og = Object.getOwnPropertySymbols, Zb = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, eu = typeof Symbol == "function" && typeof Symbol.iterator == "object", ps = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === eu || !0) ? Symbol.toStringTag : null, QA = Object.prototype.propertyIsEnumerable, ME = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function RE(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || qA.call(/e/, e))
    return e;
  var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var r = t < 0 ? -OE(-t) : OE(t);
    if (r !== t) {
      var s = String(r), i = kw.call(e, s.length + 1);
      return wa.call(s, n, "$&_") + "." + wa.call(wa.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return wa.call(e, n, "$&_");
}
var Xb = IV, LE = Xb.custom, FE = nO(LE) ? LE : null, eO = function t(e, n, r, s) {
  var i = n || {};
  if (ma(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (ma(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = ma(i, "customInspect") ? i.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (ma(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (ma(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var a = i.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return sO(e, i);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var l = String(e);
    return a ? RE(e, l) : l;
  }
  if (typeof e == "bigint") {
    var c = String(e) + "n";
    return a ? RE(e, c) : c;
  }
  var u = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof r > "u" && (r = 0), r >= u && u > 0 && typeof e == "object")
    return Kb(e) ? "[Array]" : "[Object]";
  var d = KV(i, r);
  if (typeof s > "u")
    s = [];
  else if (rO(s, e) >= 0)
    return "[Circular]";
  function f(D, H, Y) {
    if (H && (s = DV.call(s), s.push(H)), Y) {
      var te = {
        depth: i.depth
      };
      return ma(i, "quoteStyle") && (te.quoteStyle = i.quoteStyle), t(D, te, r + 1, s);
    }
    return t(D, i, r + 1, s);
  }
  if (typeof e == "function" && !BE(e)) {
    var p = WV(e), h = up(e, f);
    return "[Function" + (p ? ": " + p : " (anonymous)") + "]" + (h.length > 0 ? " { " + oo.call(h, ", ") + " }" : "");
  }
  if (nO(e)) {
    var m = eu ? wa.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : Zb.call(e);
    return typeof e == "object" && !eu ? Qu(m) : m;
  }
  if (YV(e)) {
    for (var v = "<" + DE.call(String(e.nodeName)), y = e.attributes || [], _ = 0; _ < y.length; _++)
      v += " " + y[_].name + "=" + tO(AV(y[_].value), "double", i);
    return v += ">", e.childNodes && e.childNodes.length && (v += "..."), v += "</" + DE.call(String(e.nodeName)) + ">", v;
  }
  if (Kb(e)) {
    if (e.length === 0)
      return "[]";
    var w = up(e, f);
    return d && !XV(w) ? "[" + Jb(w, d) + "]" : "[ " + oo.call(w, ", ") + " ]";
  }
  if (MV(e)) {
    var S = up(e, f);
    return !("cause" in Error.prototype) && "cause" in e && !QA.call(e, "cause") ? "{ [" + String(e) + "] " + oo.call(AE.call("[cause]: " + f(e.cause), S), ", ") + " }" : S.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + oo.call(S, ", ") + " }";
  }
  if (typeof e == "object" && o) {
    if (FE && typeof e[FE] == "function" && Xb)
      return Xb(e, { depth: u - r });
    if (o !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (HV(e)) {
    var E = [];
    return kE && kE.call(e, function(D, H) {
      E.push(f(H, e, !0) + " => " + f(D, e));
    }), jE("Map", Vh.call(e), E, d);
  }
  if (UV(e)) {
    var x = [];
    return NE && NE.call(e, function(D) {
      x.push(f(D, e));
    }), jE("Set", zh.call(e), x, d);
  }
  if (VV(e))
    return Mg("WeakMap");
  if (GV(e))
    return Mg("WeakSet");
  if (zV(e))
    return Mg("WeakRef");
  if (LV(e))
    return Qu(f(Number(e)));
  if (BV(e))
    return Qu(f(Yb.call(e)));
  if (FV(e))
    return Qu(TV.call(e));
  if (RV(e))
    return Qu(f(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && e === globalThis || typeof vr < "u" && e === vr)
    return "{ [object globalThis] }";
  if (!OV(e) && !BE(e)) {
    var T = up(e, f), C = ME ? ME(e) === Object.prototype : e instanceof Object || e.constructor === Object, k = e instanceof Object ? "" : "null prototype", b = !C && ps && Object(e) === e && ps in e ? kw.call(Za(e), 8, -1) : k ? "Object" : "", P = C || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", N = P + (b || k ? "[" + oo.call(AE.call([], b || [], k || []), ": ") + "] " : "");
    return T.length === 0 ? N + "{}" : d ? N + "{" + Jb(T, d) + "}" : N + "{ " + oo.call(T, ", ") + " }";
  }
  return String(e);
};
function tO(t, e, n) {
  var r = (n.quoteStyle || e) === "double" ? '"' : "'";
  return r + t + r;
}
function AV(t) {
  return wa.call(String(t), /"/g, "&quot;");
}
function Kb(t) {
  return Za(t) === "[object Array]" && (!ps || !(typeof t == "object" && ps in t));
}
function OV(t) {
  return Za(t) === "[object Date]" && (!ps || !(typeof t == "object" && ps in t));
}
function BE(t) {
  return Za(t) === "[object RegExp]" && (!ps || !(typeof t == "object" && ps in t));
}
function MV(t) {
  return Za(t) === "[object Error]" && (!ps || !(typeof t == "object" && ps in t));
}
function RV(t) {
  return Za(t) === "[object String]" && (!ps || !(typeof t == "object" && ps in t));
}
function LV(t) {
  return Za(t) === "[object Number]" && (!ps || !(typeof t == "object" && ps in t));
}
function FV(t) {
  return Za(t) === "[object Boolean]" && (!ps || !(typeof t == "object" && ps in t));
}
function nO(t) {
  if (eu)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !Zb)
    return !1;
  try {
    return Zb.call(t), !0;
  } catch {
  }
  return !1;
}
function BV(t) {
  if (!t || typeof t != "object" || !Yb)
    return !1;
  try {
    return Yb.call(t), !0;
  } catch {
  }
  return !1;
}
var jV = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function ma(t, e) {
  return jV.call(t, e);
}
function Za(t) {
  return PV.call(t);
}
function WV(t) {
  if (t.name)
    return t.name;
  var e = NV.call(kV.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function rO(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var n = 0, r = t.length; n < r; n++)
    if (t[n] === e)
      return n;
  return -1;
}
function HV(t) {
  if (!Vh || !t || typeof t != "object")
    return !1;
  try {
    Vh.call(t);
    try {
      zh.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function VV(t) {
  if (!Ld || !t || typeof t != "object")
    return !1;
  try {
    Ld.call(t, Ld);
    try {
      Fd.call(t, Fd);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function zV(t) {
  if (!$E || !t || typeof t != "object")
    return !1;
  try {
    return $E.call(t), !0;
  } catch {
  }
  return !1;
}
function UV(t) {
  if (!zh || !t || typeof t != "object")
    return !1;
  try {
    zh.call(t);
    try {
      Vh.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function GV(t) {
  if (!Fd || !t || typeof t != "object")
    return !1;
  try {
    Fd.call(t, Fd);
    try {
      Ld.call(t, Ld);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function YV(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function sO(t, e) {
  if (t.length > e.maxStringLength) {
    var n = t.length - e.maxStringLength, r = "... " + n + " more character" + (n > 1 ? "s" : "");
    return sO(kw.call(t, 0, e.maxStringLength), e) + r;
  }
  var s = wa.call(wa.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, ZV);
  return tO(s, "single", e);
}
function ZV(t) {
  var e = t.charCodeAt(0), n = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return n ? "\\" + n : "\\x" + (e < 16 ? "0" : "") + $V.call(e.toString(16));
}
function Qu(t) {
  return "Object(" + t + ")";
}
function Mg(t) {
  return t + " { ? }";
}
function jE(t, e, n, r) {
  var s = r ? Jb(n, r) : oo.call(n, ", ");
  return t + " (" + e + ") {" + s + "}";
}
function XV(t) {
  for (var e = 0; e < t.length; e++)
    if (rO(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function KV(t, e) {
  var n;
  if (t.indent === "	")
    n = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    n = oo.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: n,
    prev: oo.call(Array(e + 1), n)
  };
}
function Jb(t, e) {
  if (t.length === 0)
    return "";
  var n = `
` + e.prev + e.base;
  return n + oo.call(t, "," + n) + `
` + e.prev;
}
function up(t, e) {
  var n = Kb(t), r = [];
  if (n) {
    r.length = t.length;
    for (var s = 0; s < t.length; s++)
      r[s] = ma(t, s) ? e(t[s], t) : "";
  }
  var i = typeof Og == "function" ? Og(t) : [], o;
  if (eu) {
    o = {};
    for (var a = 0; a < i.length; a++)
      o["$" + i[a]] = i[a];
  }
  for (var l in t)
    ma(t, l) && (n && String(Number(l)) === l && l < t.length || eu && o["$" + l] instanceof Symbol || (qA.call(/[^\w$]/, l) ? r.push(e(l, t) + ": " + e(t[l], t)) : r.push(l + ": " + e(t[l], t))));
  if (typeof Og == "function")
    for (var c = 0; c < i.length; c++)
      QA.call(t, i[c]) && r.push("[" + e(i[c]) + "]: " + e(t[i[c]], t));
  return r;
}
var JV = function(e) {
  return typeof e == "string" || typeof e == "symbol";
}, qV = function(e) {
  if (e === null)
    return "Null";
  if (typeof e > "u")
    return "Undefined";
  if (typeof e == "function" || typeof e == "object")
    return "Object";
  if (typeof e == "number")
    return "Number";
  if (typeof e == "boolean")
    return "Boolean";
  if (typeof e == "string")
    return "String";
}, QV = qV, iO = function(e) {
  return typeof e == "symbol" ? "Symbol" : typeof e == "bigint" ? "BigInt" : QV(e);
}, WE = ii, ez = eO, tz = JV, nz = iO, oO = function(e, n) {
  if (nz(e) !== "Object")
    throw new WE("Assertion failed: Type(O) is not Object");
  if (!tz(n))
    throw new WE("Assertion failed: IsPropertyKey(P) is not true, got " + ez(n));
  return e[n];
}, rz = Number.MAX_SAFE_INTEGER || 9007199254740991, Rg, HE;
function sz() {
  return HE || (HE = 1, Rg = function(e) {
    return e === null || typeof e != "function" && typeof e != "object";
  }), Rg;
}
var Lg, VE;
function iz() {
  return VE || (VE = 1, Lg = function(e) {
    return e === null || typeof e != "function" && typeof e != "object";
  }), Lg;
}
var Fg, zE;
function oz() {
  if (zE) return Fg;
  zE = 1;
  var t = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, r;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, e(function() {
        throw 42;
      }, null, n);
    } catch (_) {
      _ !== r && (e = null);
    }
  else
    e = null;
  var s = /^\s*class\b/, i = function(w) {
    try {
      var S = t.call(w);
      return s.test(S);
    } catch {
      return !1;
    }
  }, o = function(w) {
    try {
      return i(w) ? !1 : (t.call(w), !0);
    } catch {
      return !1;
    }
  }, a = Object.prototype.toString, l = "[object Object]", c = "[object Function]", u = "[object GeneratorFunction]", d = "[object HTMLAllCollection]", f = "[object HTML document.all class]", p = "[object HTMLCollection]", h = typeof Symbol == "function" && !!Symbol.toStringTag, m = !(0 in [,]), v = function() {
    return !1;
  };
  if (typeof document == "object") {
    var y = document.all;
    a.call(y) === a.call(document.all) && (v = function(w) {
      if ((m || !w) && (typeof w > "u" || typeof w == "object"))
        try {
          var S = a.call(w);
          return (S === d || S === f || S === p || S === l) && w("") == null;
        } catch {
        }
      return !1;
    });
  }
  return Fg = e ? function(w) {
    if (v(w))
      return !0;
    if (!w || typeof w != "function" && typeof w != "object")
      return !1;
    try {
      e(w, null, n);
    } catch (S) {
      if (S !== r)
        return !1;
    }
    return !i(w) && o(w);
  } : function(w) {
    if (v(w))
      return !0;
    if (!w || typeof w != "function" && typeof w != "object")
      return !1;
    if (h)
      return o(w);
    if (i(w))
      return !1;
    var S = a.call(w);
    return S !== c && S !== u && !/^\[object HTML/.test(S) ? !1 : o(w);
  }, Fg;
}
var Bg, UE;
function aO() {
  if (UE) return Bg;
  UE = 1;
  var t = WA;
  return Bg = function() {
    return t() && !!Symbol.toStringTag;
  }, Bg;
}
var jg, GE;
function az() {
  if (GE) return jg;
  GE = 1;
  var t = Date.prototype.getDay, e = function(o) {
    try {
      return t.call(o), !0;
    } catch {
      return !1;
    }
  }, n = Object.prototype.toString, r = "[object Date]", s = aO()();
  return jg = function(o) {
    return typeof o != "object" || o === null ? !1 : s ? e(o) : n.call(o) === r;
  }, jg;
}
var dp = { exports: {} }, YE;
function lz() {
  if (YE) return dp.exports;
  YE = 1;
  var t = Object.prototype.toString, e = HA();
  if (e) {
    var n = Symbol.prototype.toString, r = /^Symbol\(.*\)$/, s = function(o) {
      return typeof o.valueOf() != "symbol" ? !1 : r.test(n.call(o));
    };
    dp.exports = function(o) {
      if (typeof o == "symbol")
        return !0;
      if (t.call(o) !== "[object Symbol]")
        return !1;
      try {
        return s(o);
      } catch {
        return !1;
      }
    };
  } else
    dp.exports = function(o) {
      return !1;
    };
  return dp.exports;
}
var Wg, ZE;
function cz() {
  if (ZE) return Wg;
  ZE = 1;
  var t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol", e = iz(), n = oz(), r = az(), s = lz(), i = function(l, c) {
    if (typeof l > "u" || l === null)
      throw new TypeError("Cannot call method on " + l);
    if (typeof c != "string" || c !== "number" && c !== "string")
      throw new TypeError('hint must be "string" or "number"');
    var u = c === "string" ? ["toString", "valueOf"] : ["valueOf", "toString"], d, f, p;
    for (p = 0; p < u.length; ++p)
      if (d = l[u[p]], n(d) && (f = d.call(l), e(f)))
        return f;
    throw new TypeError("No default value");
  }, o = function(l, c) {
    var u = l[c];
    if (u !== null && typeof u < "u") {
      if (!n(u))
        throw new TypeError(u + " returned for property " + c + " of object " + l + " is not a function");
      return u;
    }
  };
  return Wg = function(l) {
    if (e(l))
      return l;
    var c = "default";
    arguments.length > 1 && (arguments[1] === String ? c = "string" : arguments[1] === Number && (c = "number"));
    var u;
    if (t && (Symbol.toPrimitive ? u = o(l, Symbol.toPrimitive) : s(l) && (u = Symbol.prototype.valueOf)), typeof u < "u") {
      var d = u.call(l, c);
      if (e(d))
        return d;
      throw new TypeError("unable to convert exotic object to primitive");
    }
    return c === "default" && (r(l) || s(l)) && (c = "string"), i(l, c === "default" ? "number" : c);
  }, Wg;
}
var Hg, XE;
function uz() {
  if (XE) return Hg;
  XE = 1;
  var t = cz();
  return Hg = function(n) {
    return arguments.length > 1 ? t(n, arguments[1]) : t(n);
  }, Hg;
}
var Vg, KE;
function Cf() {
  if (KE) return Vg;
  KE = 1;
  var t = Jo, e = Cw, n = e(t("String.prototype.indexOf"));
  return Vg = function(s, i) {
    var o = t(s, !!i);
    return typeof o == "function" && n(s, ".prototype.") > -1 ? e(o) : o;
  }, Vg;
}
var zg, JE;
function dz() {
  if (JE) return zg;
  JE = 1;
  var t = Cf(), e = aO()(), n, r, s, i;
  if (e) {
    n = t("Object.prototype.hasOwnProperty"), r = t("RegExp.prototype.exec"), s = {};
    var o = function() {
      throw s;
    };
    i = {
      toString: o,
      valueOf: o
    }, typeof Symbol.toPrimitive == "symbol" && (i[Symbol.toPrimitive] = o);
  }
  var a = t("Object.prototype.toString"), l = Object.getOwnPropertyDescriptor, c = "[object RegExp]";
  return zg = e ? function(d) {
    if (!d || typeof d != "object")
      return !1;
    var f = l(d, "lastIndex"), p = f && n(f, "value");
    if (!p)
      return !1;
    try {
      r(d, i);
    } catch (h) {
      return h === s;
    }
  } : function(d) {
    return !d || typeof d != "object" && typeof d != "function" ? !1 : a(d) === c;
  }, zg;
}
var Ug, qE;
function fz() {
  if (qE) return Ug;
  qE = 1;
  var t = Cf(), e = dz(), n = t("RegExp.prototype.exec"), r = ii;
  return Ug = function(i) {
    if (!e(i))
      throw new r("`regex` must be a RegExp");
    return function(a) {
      return n(i, a) !== null;
    };
  }, Ug;
}
var pz = Jo, hz = pz("%String%"), mz = ii, lO = function(e) {
  if (typeof e == "symbol")
    throw new mz("Cannot convert a Symbol value to a string");
  return hz(e);
}, Gg, QE;
function cO() {
  if (QE) return Gg;
  QE = 1;
  var t = ov, e = lO, n = Cf(), r = n("String.prototype.replace"), s = /^\s$/.test("᠎"), i = s ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/, o = s ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
  return Gg = function() {
    var l = e(t(this));
    return r(r(l, i, ""), o, "");
  }, Gg;
}
var Yg, ex;
function uO() {
  if (ex) return Yg;
  ex = 1;
  var t = cO(), e = "​", n = "᠎";
  return Yg = function() {
    return String.prototype.trim && e.trim() === e && n.trim() === n && ("_" + n).trim() === "_" + n && (n + "_").trim() === n + "_" ? String.prototype.trim : t;
  }, Yg;
}
var Zg, tx;
function vz() {
  if (tx) return Zg;
  tx = 1;
  var t = iv, e = uO();
  return Zg = function() {
    var r = e();
    return t(String.prototype, { trim: r }, {
      trim: function() {
        return String.prototype.trim !== r;
      }
    }), r;
  }, Zg;
}
var Xg, nx;
function gz() {
  if (nx) return Xg;
  nx = 1;
  var t = Cw, e = iv, n = ov, r = cO(), s = uO(), i = vz(), o = t(s()), a = function(c) {
    return n(c), o(c);
  };
  return e(a, {
    getPolyfill: s,
    implementation: r,
    shim: i
  }), Xg = a, Xg;
}
var Kg, rx;
function yz() {
  if (rx) return Kg;
  rx = 1;
  var t = Jo, e = t("%Number%"), n = t("%RegExp%"), r = ii, s = t("%parseInt%"), i = Cf(), o = fz(), a = i("String.prototype.slice"), l = o(/^0b[01]+$/i), c = o(/^0o[0-7]+$/i), u = o(/^[-+]0x[0-9a-f]+$/i), d = ["", "​", "￾"].join(""), f = new n("[" + d + "]", "g"), p = o(f), h = gz();
  return Kg = function m(v) {
    if (typeof v != "string")
      throw new r("Assertion failed: `argument` is not a String");
    if (l(v))
      return e(s(a(v, 2), 2));
    if (c(v))
      return e(s(a(v, 2), 8));
    if (p(v) || u(v))
      return NaN;
    var y = h(v);
    return y !== v ? m(y) : e(v);
  }, Kg;
}
var bz = Jo, sx = ii, ix = bz("%Number%"), _z = sz(), wz = uz(), Sz = yz(), Iz = function(e) {
  var n = _z(e) ? e : wz(e, ix);
  if (typeof n == "symbol")
    throw new sx("Cannot convert a Symbol value to a number");
  if (typeof n == "bigint")
    throw new sx("Conversion from 'BigInt' to 'number' is not allowed.");
  return typeof n == "string" ? Sz(n) : ix(n);
}, Ez = Math.floor, xz = function(e) {
  return typeof e == "bigint" ? e : Ez(e);
}, ox = xz, Cz = ii, Tz = function(e) {
  if (typeof e != "number" && typeof e != "bigint")
    throw new Cz("argument must be a Number or a BigInt");
  var n = e < 0 ? -ox(-e) : ox(e);
  return n === 0 ? 0 : n;
}, dO = Number.isNaN || function(e) {
  return e !== e;
}, Pz = dO, kz = function(t) {
  return (typeof t == "number" || typeof t == "bigint") && !Pz(t) && t !== 1 / 0 && t !== -1 / 0;
}, Nz = Iz, $z = Tz, Dz = dO, Az = kz, fO = function(e) {
  var n = Nz(e);
  return Dz(n) || n === 0 ? 0 : Az(n) ? $z(n) : n;
}, ax = rz, Oz = fO, Mz = function(e) {
  var n = Oz(e);
  return n <= 0 ? 0 : n > ax ? ax : n;
}, Rz = ii, Lz = oO, Fz = Mz, Bz = iO, jz = function(e) {
  if (Bz(e) !== "Object")
    throw new Rz("Assertion failed: `obj` must be an Object");
  return Fz(Lz(e, "length"));
}, Wz = Object, Hz = Wz, Vz = ov, zz = function(e) {
  return Vz(e), Hz(e);
}, Uz = oO, Gz = jz, Yz = fO, Zz = zz, Xz = lO, pO = function(e) {
  var n = Zz(this), r = Gz(n), s = Yz(e), i = s >= 0 ? s : r + s;
  if (!(i < 0 || i >= r))
    return Uz(n, Xz(i));
}, Kz = pO, hO = function() {
  return Array.prototype.at || Kz;
}, Jg, lx;
function Jz() {
  if (lx) return Jg;
  lx = 1;
  var t = VA, e = typeof Symbol == "function" && typeof Symbol.unscopables == "symbol", n = e && Array.prototype[Symbol.unscopables], r = TypeError;
  return Jg = function(i) {
    if (typeof i != "string" || !i)
      throw new r("method must be a non-empty string");
    if (!t(Array.prototype, i))
      throw new r("method must be on Array.prototype");
    e && (n[i] = !0);
  }, Jg;
}
var qg, cx;
function qz() {
  if (cx) return qg;
  cx = 1;
  var t = iv, e = Jz(), n = hO;
  return qg = function() {
    var s = n();
    return t(
      Array.prototype,
      { at: s },
      { at: function() {
        return Array.prototype.at !== s;
      } }
    ), e("at"), s;
  }, qg;
}
var Qz = Cw, eU = iv, tU = ov, nU = pO, mO = hO, rU = Qz(mO()), sU = qz(), iU = function(e, n) {
  return tU(e), rU(e, n);
};
eU(iU, {
  getPolyfill: mO,
  implementation: nU,
  shim: sU
});
/*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */
var Fr = Object.freeze({}), mt = Array.isArray;
function ht(t) {
  return t == null;
}
function me(t) {
  return t != null;
}
function Yn(t) {
  return t === !0;
}
function oU(t) {
  return t === !1;
}
function qo(t) {
  return typeof t == "string" || typeof t == "number" || // $flow-disable-line
  typeof t == "symbol" || typeof t == "boolean";
}
function an(t) {
  return typeof t == "function";
}
function Mr(t) {
  return t !== null && typeof t == "object";
}
var av = Object.prototype.toString;
function Tf(t) {
  return av.call(t).slice(8, -1);
}
function Qr(t) {
  return av.call(t) === "[object Object]";
}
function vO(t) {
  return av.call(t) === "[object RegExp]";
}
function gO(t) {
  var e = parseFloat(String(t));
  return e >= 0 && Math.floor(e) === e && isFinite(t);
}
function qb(t) {
  return me(t) && typeof t.then == "function" && typeof t.catch == "function";
}
function aU(t) {
  return t == null ? "" : Array.isArray(t) || Qr(t) && t.toString === av ? JSON.stringify(t, lU, 2) : String(t);
}
function lU(t, e) {
  return e && e.__v_isRef ? e.value : e;
}
function ef(t) {
  var e = parseFloat(t);
  return isNaN(e) ? t : e;
}
function si(t, e) {
  for (var n = /* @__PURE__ */ Object.create(null), r = t.split(","), s = 0; s < r.length; s++)
    n[r[s]] = !0;
  return e ? function(i) {
    return n[i.toLowerCase()];
  } : function(i) {
    return n[i];
  };
}
var cU = si("slot,component", !0), yO = si("key,ref,slot,slot-scope,is");
function Xa(t, e) {
  var n = t.length;
  if (n) {
    if (e === t[n - 1]) {
      t.length = n - 1;
      return;
    }
    var r = t.indexOf(e);
    if (r > -1)
      return t.splice(r, 1);
  }
}
var uU = Object.prototype.hasOwnProperty;
function Br(t, e) {
  return uU.call(t, e);
}
function Jl(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    var s = e[r];
    return s || (e[r] = t(r));
  };
}
var dU = /-(\w)/g, zl = Jl(function(t) {
  return t.replace(dU, function(e, n) {
    return n ? n.toUpperCase() : "";
  });
}), bO = Jl(function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}), fU = /\B([A-Z])/g, ql = Jl(function(t) {
  return t.replace(fU, "-$1").toLowerCase();
});
function pU(t, e) {
  function n(r) {
    var s = arguments.length;
    return s ? s > 1 ? t.apply(e, arguments) : t.call(e, r) : t.call(e);
  }
  return n._length = t.length, n;
}
function hU(t, e) {
  return t.bind(e);
}
var _O = Function.prototype.bind ? hU : pU;
function Qb(t, e) {
  e = e || 0;
  for (var n = t.length - e, r = new Array(n); n--; )
    r[n] = t[n + e];
  return r;
}
function $n(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}
function wO(t) {
  for (var e = {}, n = 0; n < t.length; n++)
    t[n] && $n(e, t[n]);
  return e;
}
function Nn(t, e, n) {
}
var fp = function(t, e, n) {
  return !1;
}, SO = function(t) {
  return t;
};
function Ul(t, e) {
  if (t === e)
    return !0;
  var n = Mr(t), r = Mr(e);
  if (n && r)
    try {
      var s = Array.isArray(t), i = Array.isArray(e);
      if (s && i)
        return t.length === e.length && t.every(function(l, c) {
          return Ul(l, e[c]);
        });
      if (t instanceof Date && e instanceof Date)
        return t.getTime() === e.getTime();
      if (!s && !i) {
        var o = Object.keys(t), a = Object.keys(e);
        return o.length === a.length && o.every(function(l) {
          return Ul(t[l], e[l]);
        });
      } else
        return !1;
    } catch {
      return !1;
    }
  else return !n && !r ? String(t) === String(e) : !1;
}
function IO(t, e) {
  for (var n = 0; n < t.length; n++)
    if (Ul(t[n], e))
      return n;
  return -1;
}
function Uh(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(this, arguments));
  };
}
function e_(t, e) {
  return t === e ? t === 0 && 1 / t !== 1 / e : t === t || e === e;
}
var ux = "data-server-rendered", lv = ["component", "directive", "filter"], EO = [
  "beforeCreate",
  "created",
  "beforeMount",
  "mounted",
  "beforeUpdate",
  "updated",
  "beforeDestroy",
  "destroyed",
  "activated",
  "deactivated",
  "errorCaptured",
  "serverPrefetch",
  "renderTracked",
  "renderTriggered"
], vn = {
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: /* @__PURE__ */ Object.create(null),
  /**
   * Whether to suppress warnings.
   */
  silent: !1,
  /**
   * Show production mode tip message on boot?
   */
  productionTip: process.env.NODE_ENV !== "production",
  /**
   * Whether to enable devtools
   */
  devtools: process.env.NODE_ENV !== "production",
  /**
   * Whether to record perf
   */
  performance: !1,
  /**
   * Error handler for watcher errors
   */
  errorHandler: null,
  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,
  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],
  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: /* @__PURE__ */ Object.create(null),
  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: fp,
  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: fp,
  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: fp,
  /**
   * Get the namespace of an element
   */
  getTagNamespace: Nn,
  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: SO,
  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: fp,
  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: !0,
  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: EO
}, xO = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
function Nw(t) {
  var e = (t + "").charCodeAt(0);
  return e === 36 || e === 95;
}
function mr(t, e, n, r) {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !!r,
    writable: !0,
    configurable: !0
  });
}
var mU = new RegExp("[^".concat(xO.source, ".$_\\d]"));
function vU(t) {
  if (!mU.test(t)) {
    var e = t.split(".");
    return function(n) {
      for (var r = 0; r < e.length; r++) {
        if (!n)
          return;
        n = n[e[r]];
      }
      return n;
    };
  }
}
var gU = "__proto__" in {}, Os = typeof window < "u", wi = Os && window.navigator.userAgent.toLowerCase(), hu = wi && /msie|trident/.test(wi), mu = wi && wi.indexOf("msie 9.0") > 0, CO = wi && wi.indexOf("edge/") > 0;
wi && wi.indexOf("android") > 0;
var yU = wi && /iphone|ipad|ipod|ios/.test(wi), dx = wi && wi.match(/firefox\/(\d+)/), t_ = {}.watch, TO = !1;
if (Os)
  try {
    var fx = {};
    Object.defineProperty(fx, "passive", {
      get: function() {
        TO = !0;
      }
    }), window.addEventListener("test-passive", null, fx);
  } catch {
  }
var pp, Ka = function() {
  return pp === void 0 && (!Os && typeof global < "u" ? pp = global.process && global.process.env.VUE_ENV === "server" : pp = !1), pp;
}, Gh = Os && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
function Rl(t) {
  return typeof t == "function" && /native code/.test(t.toString());
}
var Pf = typeof Symbol < "u" && Rl(Symbol) && typeof Reflect < "u" && Rl(Reflect.ownKeys), tf;
typeof Set < "u" && Rl(Set) ? tf = Set : tf = /** @class */
function() {
  function t() {
    this.set = /* @__PURE__ */ Object.create(null);
  }
  return t.prototype.has = function(e) {
    return this.set[e] === !0;
  }, t.prototype.add = function(e) {
    this.set[e] = !0;
  }, t.prototype.clear = function() {
    this.set = /* @__PURE__ */ Object.create(null);
  }, t;
}();
var jn = null;
function bU() {
  return jn && { proxy: jn };
}
function Ba(t) {
  t === void 0 && (t = null), t || jn && jn._scope.off(), jn = t, t && t._scope.on();
}
var Hs = (
  /** @class */
  function() {
    function t(e, n, r, s, i, o, a, l) {
      this.tag = e, this.data = n, this.children = r, this.text = s, this.elm = i, this.ns = void 0, this.context = o, this.fnContext = void 0, this.fnOptions = void 0, this.fnScopeId = void 0, this.key = n && n.key, this.componentOptions = a, this.componentInstance = void 0, this.parent = void 0, this.raw = !1, this.isStatic = !1, this.isRootInsert = !0, this.isComment = !1, this.isCloned = !1, this.isOnce = !1, this.asyncFactory = l, this.asyncMeta = void 0, this.isAsyncPlaceholder = !1;
    }
    return Object.defineProperty(t.prototype, "child", {
      // DEPRECATED: alias for componentInstance for backwards compat.
      /* istanbul ignore next */
      get: function() {
        return this.componentInstance;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
), Ll = function(t) {
  t === void 0 && (t = "");
  var e = new Hs();
  return e.text = t, e.isComment = !0, e;
};
function Bc(t) {
  return new Hs(void 0, void 0, void 0, String(t));
}
function n_(t) {
  var e = new Hs(
    t.tag,
    t.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    t.children && t.children.slice(),
    t.text,
    t.elm,
    t.context,
    t.componentOptions,
    t.asyncFactory
  );
  return e.ns = t.ns, e.isStatic = t.isStatic, e.key = t.key, e.isComment = t.isComment, e.fnContext = t.fnContext, e.fnOptions = t.fnOptions, e.fnScopeId = t.fnScopeId, e.asyncMeta = t.asyncMeta, e.isCloned = !0, e;
}
var ja = function() {
  return ja = Object.assign || function(e) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, ja.apply(this, arguments);
};
var _U = 0, Kp = [], wU = function() {
  for (var t = 0; t < Kp.length; t++) {
    var e = Kp[t];
    e.subs = e.subs.filter(function(n) {
      return n;
    }), e._pending = !1;
  }
  Kp.length = 0;
}, ds = (
  /** @class */
  function() {
    function t() {
      this._pending = !1, this.id = _U++, this.subs = [];
    }
    return t.prototype.addSub = function(e) {
      this.subs.push(e);
    }, t.prototype.removeSub = function(e) {
      this.subs[this.subs.indexOf(e)] = null, this._pending || (this._pending = !0, Kp.push(this));
    }, t.prototype.depend = function(e) {
      t.target && (t.target.addDep(this), process.env.NODE_ENV !== "production" && e && t.target.onTrack && t.target.onTrack(ja({ effect: t.target }, e)));
    }, t.prototype.notify = function(e) {
      var n = this.subs.filter(function(o) {
        return o;
      });
      process.env.NODE_ENV !== "production" && !vn.async && n.sort(function(o, a) {
        return o.id - a.id;
      });
      for (var r = 0, s = n.length; r < s; r++) {
        var i = n[r];
        process.env.NODE_ENV !== "production" && e && i.onTrigger && i.onTrigger(ja({ effect: n[r] }, e)), i.update();
      }
    }, t;
  }()
);
ds.target = null;
var Jp = [];
function vu(t) {
  Jp.push(t), ds.target = t;
}
function gu() {
  Jp.pop(), ds.target = Jp[Jp.length - 1];
}
var PO = Array.prototype, Yh = Object.create(PO), SU = [
  "push",
  "pop",
  "shift",
  "unshift",
  "splice",
  "sort",
  "reverse"
];
SU.forEach(function(t) {
  var e = PO[t];
  mr(Yh, t, function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    var i = e.apply(this, r), o = this.__ob__, a;
    switch (t) {
      case "push":
      case "unshift":
        a = r;
        break;
      case "splice":
        a = r.slice(2);
        break;
    }
    return a && o.observeArray(a), process.env.NODE_ENV !== "production" ? o.dep.notify({
      type: "array mutation",
      target: this,
      key: t
    }) : o.dep.notify(), i;
  });
});
var px = Object.getOwnPropertyNames(Yh), kO = {}, $w = !0;
function Wa(t) {
  $w = t;
}
var IU = {
  notify: Nn,
  depend: Nn,
  addSub: Nn,
  removeSub: Nn
}, hx = (
  /** @class */
  function() {
    function t(e, n, r) {
      if (n === void 0 && (n = !1), r === void 0 && (r = !1), this.value = e, this.shallow = n, this.mock = r, this.dep = r ? IU : new ds(), this.vmCount = 0, mr(e, "__ob__", this), mt(e)) {
        if (!r)
          if (gU)
            e.__proto__ = Yh;
          else
            for (var s = 0, i = px.length; s < i; s++) {
              var o = px[s];
              mr(e, o, Yh[o]);
            }
        n || this.observeArray(e);
      } else
        for (var a = Object.keys(e), s = 0; s < a.length; s++) {
          var o = a[s];
          gi(e, o, kO, void 0, n, r);
        }
    }
    return t.prototype.observeArray = function(e) {
      for (var n = 0, r = e.length; n < r; n++)
        Vo(e[n], !1, this.mock);
    }, t;
  }()
);
function Vo(t, e, n) {
  if (t && Br(t, "__ob__") && t.__ob__ instanceof hx)
    return t.__ob__;
  if ($w && (n || !Ka()) && (mt(t) || Qr(t)) && Object.isExtensible(t) && !t.__v_skip && !Jr(t) && !(t instanceof Hs))
    return new hx(t, e, n);
}
function gi(t, e, n, r, s, i, o) {
  o === void 0 && (o = !1);
  var a = new ds(), l = Object.getOwnPropertyDescriptor(t, e);
  if (!(l && l.configurable === !1)) {
    var c = l && l.get, u = l && l.set;
    (!c || u) && (n === kO || arguments.length === 2) && (n = t[e]);
    var d = s ? n && n.__ob__ : Vo(n, !1, i);
    return Object.defineProperty(t, e, {
      enumerable: !0,
      configurable: !0,
      get: function() {
        var p = c ? c.call(t) : n;
        return ds.target && (process.env.NODE_ENV !== "production" ? a.depend({
          target: t,
          type: "get",
          key: e
        }) : a.depend(), d && (d.dep.depend(), mt(p) && NO(p))), Jr(p) && !s ? p.value : p;
      },
      set: function(p) {
        var h = c ? c.call(t) : n;
        if (e_(h, p)) {
          if (process.env.NODE_ENV !== "production" && r && r(), u)
            u.call(t, p);
          else {
            if (c)
              return;
            if (!s && Jr(h) && !Jr(p)) {
              h.value = p;
              return;
            } else
              n = p;
          }
          d = s ? p && p.__ob__ : Vo(p, !1, i), process.env.NODE_ENV !== "production" ? a.notify({
            type: "set",
            target: t,
            key: e,
            newValue: p,
            oldValue: h
          }) : a.notify();
        }
      }
    }), a;
  }
}
function cv(t, e, n) {
  if (process.env.NODE_ENV !== "production" && (ht(t) || qo(t)) && Te("Cannot set reactive property on undefined, null, or primitive value: ".concat(t)), Ql(t)) {
    process.env.NODE_ENV !== "production" && Te('Set operation on key "'.concat(e, '" failed: target is readonly.'));
    return;
  }
  var r = t.__ob__;
  return mt(t) && gO(e) ? (t.length = Math.max(t.length, e), t.splice(e, 1, n), r && !r.shallow && r.mock && Vo(n, !1, !0), n) : e in t && !(e in Object.prototype) ? (t[e] = n, n) : t._isVue || r && r.vmCount ? (process.env.NODE_ENV !== "production" && Te("Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option."), n) : r ? (gi(r.value, e, n, void 0, r.shallow, r.mock), process.env.NODE_ENV !== "production" ? r.dep.notify({
    type: "add",
    target: t,
    key: e,
    newValue: n,
    oldValue: void 0
  }) : r.dep.notify(), n) : (t[e] = n, n);
}
function Dw(t, e) {
  if (process.env.NODE_ENV !== "production" && (ht(t) || qo(t)) && Te("Cannot delete reactive property on undefined, null, or primitive value: ".concat(t)), mt(t) && gO(e)) {
    t.splice(e, 1);
    return;
  }
  var n = t.__ob__;
  if (t._isVue || n && n.vmCount) {
    process.env.NODE_ENV !== "production" && Te("Avoid deleting properties on a Vue instance or its root $data - just set it to null.");
    return;
  }
  if (Ql(t)) {
    process.env.NODE_ENV !== "production" && Te('Delete operation on key "'.concat(e, '" failed: target is readonly.'));
    return;
  }
  Br(t, e) && (delete t[e], n && (process.env.NODE_ENV !== "production" ? n.dep.notify({
    type: "delete",
    target: t,
    key: e
  }) : n.dep.notify()));
}
function NO(t) {
  for (var e = void 0, n = 0, r = t.length; n < r; n++)
    e = t[n], e && e.__ob__ && e.__ob__.dep.depend(), mt(e) && NO(e);
}
function Xn(t) {
  return $O(t, !1), t;
}
function Aw(t) {
  return $O(t, !0), mr(t, "__v_isShallow", !0), t;
}
function $O(t, e) {
  if (!Ql(t)) {
    if (process.env.NODE_ENV !== "production") {
      mt(t) && Te("Avoid using Array as root value for ".concat(e ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(e ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
      var n = t && t.__ob__;
      n && n.shallow !== e && Te("Target is already a ".concat(n.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(e ? "" : "non-", "shallow."));
    }
    var r = Vo(
      t,
      e,
      Ka()
      /* ssr mock reactivity */
    );
    process.env.NODE_ENV !== "production" && !r && ((t == null || qo(t)) && Te("value cannot be made reactive: ".concat(String(t))), AO(t) && Te("Vue 2 does not support reactive collection types such as Map or Set."));
  }
}
function Ta(t) {
  return Ql(t) ? Ta(t.__v_raw) : !!(t && t.__ob__);
}
function Zh(t) {
  return !!(t && t.__v_isShallow);
}
function Ql(t) {
  return !!(t && t.__v_isReadonly);
}
function EU(t) {
  return Ta(t) || Ql(t);
}
function DO(t) {
  var e = t && t.__v_raw;
  return e ? DO(e) : t;
}
function xU(t) {
  return Object.isExtensible(t) && mr(t, "__v_skip", !0), t;
}
function AO(t) {
  var e = Tf(t);
  return e === "Map" || e === "WeakMap" || e === "Set" || e === "WeakSet";
}
var kf = "__v_isRef";
function Jr(t) {
  return !!(t && t.__v_isRef === !0);
}
function et(t) {
  return OO(t, !1);
}
function CU(t) {
  return OO(t, !0);
}
function OO(t, e) {
  if (Jr(t))
    return t;
  var n = {};
  return mr(n, kf, !0), mr(n, "__v_isShallow", e), mr(n, "dep", gi(n, "value", t, null, e, Ka())), n;
}
function TU(t) {
  process.env.NODE_ENV !== "production" && !t.dep && Te("received object is not a triggerable ref."), process.env.NODE_ENV !== "production" ? t.dep && t.dep.notify({
    type: "set",
    target: t,
    key: "value"
  }) : t.dep && t.dep.notify();
}
function Ow(t) {
  return Jr(t) ? t.value : t;
}
function PU(t) {
  if (Ta(t))
    return t;
  for (var e = {}, n = Object.keys(t), r = 0; r < n.length; r++)
    Xh(e, t, n[r]);
  return e;
}
function Xh(t, e, n) {
  Object.defineProperty(t, n, {
    enumerable: !0,
    configurable: !0,
    get: function() {
      var r = e[n];
      if (Jr(r))
        return r.value;
      var s = r && r.__ob__;
      return s && s.dep.depend(), r;
    },
    set: function(r) {
      var s = e[n];
      Jr(s) && !Jr(r) ? s.value = r : e[n] = r;
    }
  });
}
function kU(t) {
  var e = new ds(), n = t(function() {
    process.env.NODE_ENV !== "production" ? e.depend({
      target: i,
      type: "get",
      key: "value"
    }) : e.depend();
  }, function() {
    process.env.NODE_ENV !== "production" ? e.notify({
      target: i,
      type: "set",
      key: "value"
    }) : e.notify();
  }), r = n.get, s = n.set, i = {
    get value() {
      return r();
    },
    set value(o) {
      s(o);
    }
  };
  return mr(i, kf, !0), i;
}
function ts(t) {
  process.env.NODE_ENV !== "production" && !Ta(t) && Te("toRefs() expects a reactive object but received a plain one.");
  var e = mt(t) ? new Array(t.length) : {};
  for (var n in t)
    e[n] = Mw(t, n);
  return e;
}
function Mw(t, e, n) {
  var r = t[e];
  if (Jr(r))
    return r;
  var s = {
    get value() {
      var i = t[e];
      return i === void 0 ? n : i;
    },
    set value(i) {
      t[e] = i;
    }
  };
  return mr(s, kf, !0), s;
}
var NU = "__v_rawToReadonly", $U = "__v_rawToShallowReadonly";
function MO(t) {
  return RO(t, !1);
}
function RO(t, e) {
  if (!Qr(t))
    return process.env.NODE_ENV !== "production" && (mt(t) ? Te("Vue 2 does not support readonly arrays.") : AO(t) ? Te("Vue 2 does not support readonly collection types such as Map or Set.") : Te("value cannot be made readonly: ".concat(typeof t))), t;
  if (process.env.NODE_ENV !== "production" && !Object.isExtensible(t) && Te("Vue 2 does not support creating readonly proxy for non-extensible object."), Ql(t))
    return t;
  var n = e ? $U : NU, r = t[n];
  if (r)
    return r;
  var s = Object.create(Object.getPrototypeOf(t));
  mr(t, n, s), mr(s, "__v_isReadonly", !0), mr(s, "__v_raw", t), Jr(t) && mr(s, kf, !0), (e || Zh(t)) && mr(s, "__v_isShallow", !0);
  for (var i = Object.keys(t), o = 0; o < i.length; o++)
    DU(s, t, i[o], e);
  return s;
}
function DU(t, e, n, r) {
  Object.defineProperty(t, n, {
    enumerable: !0,
    configurable: !0,
    get: function() {
      var s = e[n];
      return r || !Qr(s) ? s : MO(s);
    },
    set: function() {
      process.env.NODE_ENV !== "production" && Te('Set operation on key "'.concat(n, '" failed: target is readonly.'));
    }
  });
}
function AU(t) {
  return RO(t, !0);
}
function le(t, e) {
  var n, r, s = an(t);
  s ? (n = t, r = process.env.NODE_ENV !== "production" ? function() {
    Te("Write operation failed: computed value is readonly");
  } : Nn) : (n = t.get, r = t.set);
  var i = Ka() ? null : new $f(jn, n, Nn, { lazy: !0 });
  process.env.NODE_ENV !== "production" && i && e && (i.onTrack = e.onTrack, i.onTrigger = e.onTrigger);
  var o = {
    // some libs rely on the presence effect for checking computed refs
    // from normal refs, but the implementation doesn't matter
    effect: i,
    get value() {
      return i ? (i.dirty && i.evaluate(), ds.target && (process.env.NODE_ENV !== "production" && ds.target.onTrack && ds.target.onTrack({
        effect: ds.target,
        target: o,
        type: "get",
        key: "value"
      }), i.depend()), i.value) : n();
    },
    set value(a) {
      r(a);
    }
  };
  return mr(o, kf, !0), mr(o, "__v_isReadonly", s), o;
}
var uv = "watcher", mx = "".concat(uv, " callback"), vx = "".concat(uv, " getter"), OU = "".concat(uv, " cleanup");
function Rw(t, e) {
  return dv(t, null, e);
}
function LO(t, e) {
  return dv(t, null, process.env.NODE_ENV !== "production" ? ja(ja({}, e), { flush: "post" }) : { flush: "post" });
}
function MU(t, e) {
  return dv(t, null, process.env.NODE_ENV !== "production" ? ja(ja({}, e), { flush: "sync" }) : { flush: "sync" });
}
var gx = {};
function or(t, e, n) {
  return process.env.NODE_ENV !== "production" && typeof e != "function" && Te("`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."), dv(t, e, n);
}
function dv(t, e, n) {
  var r = n === void 0 ? Fr : n, s = r.immediate, i = r.deep, o = r.flush, a = o === void 0 ? "pre" : o, l = r.onTrack, c = r.onTrigger;
  process.env.NODE_ENV !== "production" && !e && (s !== void 0 && Te('watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'), i !== void 0 && Te('watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'));
  var u = function(E) {
    Te("Invalid watch source: ".concat(E, ". A watch source can only be a getter/effect ") + "function, a ref, a reactive object, or an array of these types.");
  }, d = jn, f = function(E, x, T) {
    T === void 0 && (T = null);
    var C = zo(E, null, T, d, x);
    return i && C && C.__ob__ && C.__ob__.dep.depend(), C;
  }, p, h = !1, m = !1;
  if (Jr(t) ? (p = function() {
    return t.value;
  }, h = Zh(t)) : Ta(t) ? (p = function() {
    return t.__ob__.dep.depend(), t;
  }, i = !0) : mt(t) ? (m = !0, h = t.some(function(E) {
    return Ta(E) || Zh(E);
  }), p = function() {
    return t.map(function(E) {
      if (Jr(E))
        return E.value;
      if (Ta(E))
        return E.__ob__.dep.depend(), tu(E);
      if (an(E))
        return f(E, vx);
      process.env.NODE_ENV !== "production" && u(E);
    });
  }) : an(t) ? e ? p = function() {
    return f(t, vx);
  } : p = function() {
    if (!(d && d._isDestroyed))
      return y && y(), f(t, uv, [_]);
  } : (p = Nn, process.env.NODE_ENV !== "production" && u(t)), e && i) {
    var v = p;
    p = function() {
      return tu(v());
    };
  }
  var y, _ = function(E) {
    y = w.onStop = function() {
      f(E, OU);
    };
  };
  if (Ka())
    return _ = Nn, e ? s && f(e, mx, [
      p(),
      m ? [] : void 0,
      _
    ]) : p(), Nn;
  var w = new $f(jn, p, Nn, {
    lazy: !0
  });
  w.noRecurse = !e;
  var S = m ? [] : gx;
  return w.run = function() {
    if (w.active)
      if (e) {
        var E = w.get();
        (i || h || (m ? E.some(function(x, T) {
          return e_(x, S[T]);
        }) : e_(E, S))) && (y && y(), f(e, mx, [
          E,
          // pass undefined as the old value when it's changed for the first time
          S === gx ? void 0 : S,
          _
        ]), S = E);
      } else
        w.get();
  }, a === "sync" ? w.update = w.run : a === "post" ? (w.post = !0, w.update = function() {
    return c_(w);
  }) : w.update = function() {
    if (d && d === jn && !d._isMounted) {
      var E = d._preWatchers || (d._preWatchers = []);
      E.indexOf(w) < 0 && E.push(w);
    } else
      c_(w);
  }, process.env.NODE_ENV !== "production" && (w.onTrack = l, w.onTrigger = c), e ? s ? w.run() : S = w.get() : a === "post" && d ? d.$once("hook:mounted", function() {
    return w.get();
  }) : w.get(), function() {
    w.teardown();
  };
}
var ls, Lw = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = !1), this.detached = e, this.active = !0, this.effects = [], this.cleanups = [], this.parent = ls, !e && ls && (this.index = (ls.scopes || (ls.scopes = [])).push(this) - 1);
    }
    return t.prototype.run = function(e) {
      if (this.active) {
        var n = ls;
        try {
          return ls = this, e();
        } finally {
          ls = n;
        }
      } else process.env.NODE_ENV !== "production" && Te("cannot run an inactive effect scope.");
    }, t.prototype.on = function() {
      ls = this;
    }, t.prototype.off = function() {
      ls = this.parent;
    }, t.prototype.stop = function(e) {
      if (this.active) {
        var n = void 0, r = void 0;
        for (n = 0, r = this.effects.length; n < r; n++)
          this.effects[n].teardown();
        for (n = 0, r = this.cleanups.length; n < r; n++)
          this.cleanups[n]();
        if (this.scopes)
          for (n = 0, r = this.scopes.length; n < r; n++)
            this.scopes[n].stop(!0);
        if (!this.detached && this.parent && !e) {
          var s = this.parent.scopes.pop();
          s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
        }
        this.parent = void 0, this.active = !1;
      }
    }, t;
  }()
);
function RU(t) {
  return new Lw(t);
}
function LU(t, e) {
  e === void 0 && (e = ls), e && e.active && e.effects.push(t);
}
function FO() {
  return ls;
}
function FU(t) {
  ls ? ls.cleanups.push(t) : process.env.NODE_ENV !== "production" && Te("onScopeDispose() is called when there is no active effect scope to be associated with.");
}
function BO(t, e) {
  jn ? jO(jn)[t] = e : process.env.NODE_ENV !== "production" && Te("provide() can only be used inside setup().");
}
function jO(t) {
  var e = t._provided, n = t.$parent && t.$parent._provided;
  return n === e ? t._provided = Object.create(n) : e;
}
function Jt(t, e, n) {
  n === void 0 && (n = !1);
  var r = jn;
  if (r) {
    var s = r.$parent && r.$parent._provided;
    if (s && t in s)
      return s[t];
    if (arguments.length > 1)
      return n && an(e) ? e.call(r) : e;
    process.env.NODE_ENV !== "production" && Te('injection "'.concat(String(t), '" not found.'));
  } else process.env.NODE_ENV !== "production" && Te("inject() can only be used inside setup() or functional components.");
}
var yx = Jl(function(t) {
  var e = t.charAt(0) === "&";
  t = e ? t.slice(1) : t;
  var n = t.charAt(0) === "~";
  t = n ? t.slice(1) : t;
  var r = t.charAt(0) === "!";
  return t = r ? t.slice(1) : t, {
    name: t,
    once: n,
    capture: r,
    passive: e
  };
});
function r_(t, e) {
  function n() {
    var r = n.fns;
    if (mt(r))
      for (var s = r.slice(), i = 0; i < s.length; i++)
        zo(s[i], null, arguments, e, "v-on handler");
    else
      return zo(r, null, arguments, e, "v-on handler");
  }
  return n.fns = t, n;
}
function WO(t, e, n, r, s, i) {
  var o, a, l, c;
  for (o in t)
    a = t[o], l = e[o], c = yx(o), ht(a) ? process.env.NODE_ENV !== "production" && Te('Invalid handler for event "'.concat(c.name, '": got ') + String(a), i) : ht(l) ? (ht(a.fns) && (a = t[o] = r_(a, i)), Yn(c.once) && (a = t[o] = s(c.name, a, c.capture)), n(c.name, a, c.capture, c.passive, c.params)) : a !== l && (l.fns = a, t[o] = l);
  for (o in e)
    ht(t[o]) && (c = yx(o), r(c.name, e[o], c.capture));
}
function Sa(t, e, n) {
  t instanceof Hs && (t = t.data.hook || (t.data.hook = {}));
  var r, s = t[e];
  function i() {
    n.apply(this, arguments), Xa(r.fns, i);
  }
  ht(s) ? r = r_([i]) : me(s.fns) && Yn(s.merged) ? (r = s, r.fns.push(i)) : r = r_([s, i]), r.merged = !0, t[e] = r;
}
function BU(t, e, n) {
  var r = e.options.props;
  if (!ht(r)) {
    var s = {}, i = t.attrs, o = t.props;
    if (me(i) || me(o))
      for (var a in r) {
        var l = ql(a);
        if (process.env.NODE_ENV !== "production") {
          var c = a.toLowerCase();
          a !== c && i && Br(i, c) && Gw('Prop "'.concat(c, '" is passed to component ') + "".concat($l(
            // @ts-expect-error tag is string
            n || e
          ), ", but the declared prop name is") + ' "'.concat(a, '". ') + "Note that HTML attributes are case-insensitive and camelCased props need to use their kebab-case equivalents when using in-DOM " + 'templates. You should probably use "'.concat(l, '" instead of "').concat(a, '".'));
        }
        bx(s, o, a, l, !0) || bx(s, i, a, l, !1);
      }
    return s;
  }
}
function bx(t, e, n, r, s) {
  if (me(e)) {
    if (Br(e, n))
      return t[n] = e[n], s || delete e[n], !0;
    if (Br(e, r))
      return t[n] = e[r], s || delete e[r], !0;
  }
  return !1;
}
function jU(t) {
  for (var e = 0; e < t.length; e++)
    if (mt(t[e]))
      return Array.prototype.concat.apply([], t);
  return t;
}
function Fw(t) {
  return qo(t) ? [Bc(t)] : mt(t) ? HO(t) : void 0;
}
function ed(t) {
  return me(t) && me(t.text) && oU(t.isComment);
}
function HO(t, e) {
  var n = [], r, s, i, o;
  for (r = 0; r < t.length; r++)
    s = t[r], !(ht(s) || typeof s == "boolean") && (i = n.length - 1, o = n[i], mt(s) ? s.length > 0 && (s = HO(s, "".concat(e || "", "_").concat(r)), ed(s[0]) && ed(o) && (n[i] = Bc(o.text + s[0].text), s.shift()), n.push.apply(n, s)) : qo(s) ? ed(o) ? n[i] = Bc(o.text + s) : s !== "" && n.push(Bc(s)) : ed(s) && ed(o) ? n[i] = Bc(o.text + s.text) : (Yn(t._isVList) && me(s.tag) && ht(s.key) && me(e) && (s.key = "__vlist".concat(e, "_").concat(r, "__")), n.push(s)));
  return n;
}
function WU(t, e) {
  var n = null, r, s, i, o;
  if (mt(t) || typeof t == "string")
    for (n = new Array(t.length), r = 0, s = t.length; r < s; r++)
      n[r] = e(t[r], r);
  else if (typeof t == "number")
    for (n = new Array(t), r = 0; r < t; r++)
      n[r] = e(r + 1, r);
  else if (Mr(t))
    if (Pf && t[Symbol.iterator]) {
      n = [];
      for (var a = t[Symbol.iterator](), l = a.next(); !l.done; )
        n.push(e(l.value, n.length)), l = a.next();
    } else
      for (i = Object.keys(t), n = new Array(i.length), r = 0, s = i.length; r < s; r++)
        o = i[r], n[r] = e(t[o], o, r);
  return me(n) || (n = []), n._isVList = !0, n;
}
function HU(t, e, n, r) {
  var s = this.$scopedSlots[t], i;
  s ? (n = n || {}, r && (process.env.NODE_ENV !== "production" && !Mr(r) && Te("slot v-bind without argument expects an Object", this), n = $n($n({}, r), n)), i = s(n) || (an(e) ? e() : e)) : i = this.$slots[t] || (an(e) ? e() : e);
  var o = n && n.slot;
  return o ? this.$createElement("template", { slot: o }, i) : i;
}
function VU(t) {
  return qh(this.$options, "filters", t, !0) || SO;
}
function _x(t, e) {
  return mt(t) ? t.indexOf(e) === -1 : t !== e;
}
function zU(t, e, n, r, s) {
  var i = vn.keyCodes[e] || n;
  return s && r && !vn.keyCodes[e] ? _x(s, r) : i ? _x(i, t) : r ? ql(r) !== e : t === void 0;
}
function UU(t, e, n, r, s) {
  if (n)
    if (!Mr(n))
      process.env.NODE_ENV !== "production" && Te("v-bind without argument expects an Object or Array value", this);
    else {
      mt(n) && (n = wO(n));
      var i = void 0, o = function(l) {
        if (l === "class" || l === "style" || yO(l))
          i = t;
        else {
          var c = t.attrs && t.attrs.type;
          i = r || vn.mustUseProp(e, c, l) ? t.domProps || (t.domProps = {}) : t.attrs || (t.attrs = {});
        }
        var u = zl(l), d = ql(l);
        if (!(u in i) && !(d in i) && (i[l] = n[l], s)) {
          var f = t.on || (t.on = {});
          f["update:".concat(l)] = function(p) {
            n[l] = p;
          };
        }
      };
      for (var a in n)
        o(a);
    }
  return t;
}
function GU(t, e) {
  var n = this._staticTrees || (this._staticTrees = []), r = n[t];
  return r && !e || (r = n[t] = this.$options.staticRenderFns[t].call(
    this._renderProxy,
    this._c,
    this
    // for render fns generated for functional component templates
  ), VO(r, "__static__".concat(t), !1)), r;
}
function YU(t, e, n) {
  return VO(t, "__once__".concat(e).concat(n ? "_".concat(n) : ""), !0), t;
}
function VO(t, e, n) {
  if (mt(t))
    for (var r = 0; r < t.length; r++)
      t[r] && typeof t[r] != "string" && wx(t[r], "".concat(e, "_").concat(r), n);
  else
    wx(t, e, n);
}
function wx(t, e, n) {
  t.isStatic = !0, t.key = e, t.isOnce = n;
}
function ZU(t, e) {
  if (e)
    if (!Qr(e))
      process.env.NODE_ENV !== "production" && Te("v-on without argument expects an Object value", this);
    else {
      var n = t.on = t.on ? $n({}, t.on) : {};
      for (var r in e) {
        var s = n[r], i = e[r];
        n[r] = s ? [].concat(s, i) : i;
      }
    }
  return t;
}
function zO(t, e, n, r) {
  e = e || { $stable: !n };
  for (var s = 0; s < t.length; s++) {
    var i = t[s];
    mt(i) ? zO(i, e, n) : i && (i.proxy && (i.fn.proxy = !0), e[i.key] = i.fn);
  }
  return r && (e.$key = r), e;
}
function XU(t, e) {
  for (var n = 0; n < e.length; n += 2) {
    var r = e[n];
    typeof r == "string" && r ? t[e[n]] = e[n + 1] : process.env.NODE_ENV !== "production" && r !== "" && r !== null && Te("Invalid value for dynamic directive argument (expected string or null): ".concat(r), this);
  }
  return t;
}
function KU(t, e) {
  return typeof t == "string" ? e + t : t;
}
function UO(t) {
  t._o = YU, t._n = ef, t._s = aU, t._l = WU, t._t = HU, t._q = Ul, t._i = IO, t._m = GU, t._f = VU, t._k = zU, t._b = UU, t._v = Bc, t._e = Ll, t._u = zO, t._g = ZU, t._d = XU, t._p = KU;
}
function Bw(t, e) {
  if (!t || !t.length)
    return {};
  for (var n = {}, r = 0, s = t.length; r < s; r++) {
    var i = t[r], o = i.data;
    if (o && o.attrs && o.attrs.slot && delete o.attrs.slot, (i.context === e || i.fnContext === e) && o && o.slot != null) {
      var a = o.slot, l = n[a] || (n[a] = []);
      i.tag === "template" ? l.push.apply(l, i.children || []) : l.push(i);
    } else
      (n.default || (n.default = [])).push(i);
  }
  for (var c in n)
    n[c].every(JU) && delete n[c];
  return n;
}
function JU(t) {
  return t.isComment && !t.asyncFactory || t.text === " ";
}
function nf(t) {
  return t.isComment && t.asyncFactory;
}
function Bd(t, e, n, r) {
  var s, i = Object.keys(n).length > 0, o = e ? !!e.$stable : !i, a = e && e.$key;
  if (!e)
    s = {};
  else {
    if (e._normalized)
      return e._normalized;
    if (o && r && r !== Fr && a === r.$key && !i && !r.$hasNormal)
      return r;
    s = {};
    for (var l in e)
      e[l] && l[0] !== "$" && (s[l] = qU(t, n, l, e[l]));
  }
  for (var c in n)
    c in s || (s[c] = QU(n, c));
  return e && Object.isExtensible(e) && (e._normalized = s), mr(s, "$stable", o), mr(s, "$key", a), mr(s, "$hasNormal", i), s;
}
function qU(t, e, n, r) {
  var s = function() {
    var i = jn;
    Ba(t);
    var o = arguments.length ? r.apply(null, arguments) : r({});
    o = o && typeof o == "object" && !mt(o) ? [o] : Fw(o);
    var a = o && o[0];
    return Ba(i), o && (!a || o.length === 1 && a.isComment && !nf(a)) ? void 0 : o;
  };
  return r.proxy && Object.defineProperty(e, n, {
    get: s,
    enumerable: !0,
    configurable: !0
  }), s;
}
function QU(t, e) {
  return function() {
    return t[e];
  };
}
function eG(t) {
  var e = t.$options, n = e.setup;
  if (n) {
    var r = t._setupContext = GO(t);
    Ba(t), vu();
    var s = zo(n, null, [t._props || Aw({}), r], t, "setup");
    if (gu(), Ba(), an(s))
      e.render = s;
    else if (Mr(s))
      if (process.env.NODE_ENV !== "production" && s instanceof Hs && Te("setup() should not return VNodes directly - return a render function instead."), t._setupState = s, s.__sfc) {
        var o = t._setupProxy = {};
        for (var i in s)
          i !== "__sfc" && Xh(o, s, i);
      } else
        for (var i in s)
          Nw(i) ? process.env.NODE_ENV !== "production" && Te("Avoid using variables that start with _ or $ in setup().") : Xh(t, s, i);
    else process.env.NODE_ENV !== "production" && s !== void 0 && Te("setup() should return an object. Received: ".concat(s === null ? "null" : typeof s));
  }
}
function GO(t) {
  var e = !1;
  return {
    get attrs() {
      if (!t._attrsProxy) {
        var n = t._attrsProxy = {};
        mr(n, "_v_attr_proxy", !0), Kh(n, t.$attrs, Fr, t, "$attrs");
      }
      return t._attrsProxy;
    },
    get listeners() {
      if (!t._listenersProxy) {
        var n = t._listenersProxy = {};
        Kh(n, t.$listeners, Fr, t, "$listeners");
      }
      return t._listenersProxy;
    },
    get slots() {
      return nG(t);
    },
    emit: _O(t.$emit, t),
    expose: function(n) {
      process.env.NODE_ENV !== "production" && (e && Te("expose() should be called only once per setup().", t), e = !0), n && Object.keys(n).forEach(function(r) {
        return Xh(t, n, r);
      });
    }
  };
}
function Kh(t, e, n, r, s) {
  var i = !1;
  for (var o in e)
    o in t ? e[o] !== n[o] && (i = !0) : (i = !0, tG(t, o, r, s));
  for (var o in t)
    o in e || (i = !0, delete t[o]);
  return i;
}
function tG(t, e, n, r) {
  Object.defineProperty(t, e, {
    enumerable: !0,
    configurable: !0,
    get: function() {
      return n[r][e];
    }
  });
}
function nG(t) {
  return t._slotsProxy || YO(t._slotsProxy = {}, t.$scopedSlots), t._slotsProxy;
}
function YO(t, e) {
  for (var n in e)
    t[n] = e[n];
  for (var n in t)
    n in e || delete t[n];
}
function rG() {
  return jw().slots;
}
function sG() {
  return jw().attrs;
}
function iG() {
  return jw().listeners;
}
function jw() {
  process.env.NODE_ENV !== "production" && !jn && Te("useContext() called without active instance.");
  var t = jn;
  return t._setupContext || (t._setupContext = GO(t));
}
function oG(t, e) {
  var n = mt(t) ? t.reduce(function(i, o) {
    return i[o] = {}, i;
  }, {}) : t;
  for (var r in e) {
    var s = n[r];
    s ? mt(s) || an(s) ? n[r] = { type: s, default: e[r] } : s.default = e[r] : s === null ? n[r] = { default: e[r] } : process.env.NODE_ENV !== "production" && Te('props default key "'.concat(r, '" has no corresponding declaration.'));
  }
  return n;
}
function aG(t) {
  t._vnode = null, t._staticTrees = null;
  var e = t.$options, n = t.$vnode = e._parentVnode, r = n && n.context;
  t.$slots = Bw(e._renderChildren, r), t.$scopedSlots = n ? Bd(t.$parent, n.data.scopedSlots, t.$slots) : Fr, t._c = function(i, o, a, l) {
    return rf(t, i, o, a, l, !1);
  }, t.$createElement = function(i, o, a, l) {
    return rf(t, i, o, a, l, !0);
  };
  var s = n && n.data;
  process.env.NODE_ENV !== "production" ? (gi(t, "$attrs", s && s.attrs || Fr, function() {
    !of && Te("$attrs is readonly.", t);
  }, !0), gi(t, "$listeners", e._parentListeners || Fr, function() {
    !of && Te("$listeners is readonly.", t);
  }, !0)) : (gi(t, "$attrs", s && s.attrs || Fr, null, !0), gi(t, "$listeners", e._parentListeners || Fr, null, !0));
}
var qp = null;
function lG(t) {
  UO(t.prototype), t.prototype.$nextTick = function(e) {
    return Ar(e, this);
  }, t.prototype._render = function() {
    var e = this, n = e.$options, r = n.render, s = n._parentVnode;
    s && e._isMounted && (e.$scopedSlots = Bd(e.$parent, s.data.scopedSlots, e.$slots, e.$scopedSlots), e._slotsProxy && YO(e._slotsProxy, e.$scopedSlots)), e.$vnode = s;
    var i = jn, o = qp, a;
    try {
      Ba(e), qp = e, a = r.call(e._renderProxy, e.$createElement);
    } catch (l) {
      if (Ha(l, e, "render"), process.env.NODE_ENV !== "production" && e.$options.renderError)
        try {
          a = e.$options.renderError.call(e._renderProxy, e.$createElement, l);
        } catch (c) {
          Ha(c, e, "renderError"), a = e._vnode;
        }
      else
        a = e._vnode;
    } finally {
      qp = o, Ba(i);
    }
    return mt(a) && a.length === 1 && (a = a[0]), a instanceof Hs || (process.env.NODE_ENV !== "production" && mt(a) && Te("Multiple root nodes returned from render function. Render function should return a single root node.", e), a = Ll()), a.parent = s, a;
  };
}
function Qg(t, e) {
  return (t.__esModule || Pf && t[Symbol.toStringTag] === "Module") && (t = t.default), Mr(t) ? e.extend(t) : t;
}
function cG(t, e, n, r, s) {
  var i = Ll();
  return i.asyncFactory = t, i.asyncMeta = { data: e, context: n, children: r, tag: s }, i;
}
function uG(t, e) {
  if (Yn(t.error) && me(t.errorComp))
    return t.errorComp;
  if (me(t.resolved))
    return t.resolved;
  var n = qp;
  if (n && me(t.owners) && t.owners.indexOf(n) === -1 && t.owners.push(n), Yn(t.loading) && me(t.loadingComp))
    return t.loadingComp;
  if (n && !me(t.owners)) {
    var r = t.owners = [n], s = !0, i = null, o = null;
    n.$on("hook:destroyed", function() {
      return Xa(r, n);
    });
    var a = function(d) {
      for (var f = 0, p = r.length; f < p; f++)
        r[f].$forceUpdate();
      d && (r.length = 0, i !== null && (clearTimeout(i), i = null), o !== null && (clearTimeout(o), o = null));
    }, l = Uh(function(d) {
      t.resolved = Qg(d, e), s ? r.length = 0 : a(!0);
    }), c = Uh(function(d) {
      process.env.NODE_ENV !== "production" && Te("Failed to resolve async component: ".concat(String(t)) + (d ? `
Reason: `.concat(d) : "")), me(t.errorComp) && (t.error = !0, a(!0));
    }), u = t(l, c);
    return Mr(u) && (qb(u) ? ht(t.resolved) && u.then(l, c) : qb(u.component) && (u.component.then(l, c), me(u.error) && (t.errorComp = Qg(u.error, e)), me(u.loading) && (t.loadingComp = Qg(u.loading, e), u.delay === 0 ? t.loading = !0 : i = setTimeout(function() {
      i = null, ht(t.resolved) && ht(t.error) && (t.loading = !0, a(!1));
    }, u.delay || 200)), me(u.timeout) && (o = setTimeout(function() {
      o = null, ht(t.resolved) && c(process.env.NODE_ENV !== "production" ? "timeout (".concat(u.timeout, "ms)") : null);
    }, u.timeout)))), s = !1, t.loading ? t.loadingComp : t.resolved;
  }
}
function ZO(t) {
  if (mt(t))
    for (var e = 0; e < t.length; e++) {
      var n = t[e];
      if (me(n) && (me(n.componentOptions) || nf(n)))
        return n;
    }
}
var dG = 1, XO = 2;
function rf(t, e, n, r, s, i) {
  return (mt(n) || qo(n)) && (s = r, r = n, n = void 0), Yn(i) && (s = XO), fG(t, e, n, r, s);
}
function fG(t, e, n, r, s) {
  if (me(n) && me(n.__ob__))
    return process.env.NODE_ENV !== "production" && Te("Avoid using observed data object as vnode data: ".concat(JSON.stringify(n), `
`) + "Always create fresh vnode data objects in each render!", t), Ll();
  if (me(n) && me(n.is) && (e = n.is), !e)
    return Ll();
  process.env.NODE_ENV !== "production" && me(n) && me(n.key) && !qo(n.key) && Te("Avoid using non-primitive value as key, use string/number value instead.", t), mt(r) && an(r[0]) && (n = n || {}, n.scopedSlots = { default: r[0] }, r.length = 0), s === XO ? r = Fw(r) : s === dG && (r = jU(r));
  var i, o;
  if (typeof e == "string") {
    var a = void 0;
    o = t.$vnode && t.$vnode.ns || vn.getTagNamespace(e), vn.isReservedTag(e) ? (process.env.NODE_ENV !== "production" && me(n) && me(n.nativeOn) && n.tag !== "component" && Te("The .native modifier for v-on is only valid on components but it was used on <".concat(e, ">."), t), i = new Hs(vn.parsePlatformTagName(e), n, r, void 0, void 0, t)) : (!n || !n.pre) && me(a = qh(t.$options, "components", e)) ? i = Nx(a, n, t, r, e) : i = new Hs(e, n, r, void 0, void 0, t);
  } else
    i = Nx(e, n, t, r);
  return mt(i) ? i : me(i) ? (me(o) && KO(i, o), me(n) && pG(n), i) : Ll();
}
function KO(t, e, n) {
  if (t.ns = e, t.tag === "foreignObject" && (e = void 0, n = !0), me(t.children))
    for (var r = 0, s = t.children.length; r < s; r++) {
      var i = t.children[r];
      me(i.tag) && (ht(i.ns) || Yn(n) && i.tag !== "svg") && KO(i, e, n);
    }
}
function pG(t) {
  Mr(t.style) && tu(t.style), Mr(t.class) && tu(t.class);
}
function JO(t, e, n) {
  return jn || process.env.NODE_ENV !== "production" && Te("globally imported h() can only be invoked when there is an active component instance, e.g. synchronously in a component's render or setup function."), rf(jn, t, e, n, 2, !0);
}
function Ha(t, e, n) {
  vu();
  try {
    if (e)
      for (var r = e; r = r.$parent; ) {
        var s = r.$options.errorCaptured;
        if (s)
          for (var i = 0; i < s.length; i++)
            try {
              var o = s[i].call(r, t, e, n) === !1;
              if (o)
                return;
            } catch (a) {
              Sx(a, r, "errorCaptured hook");
            }
      }
    Sx(t, e, n);
  } finally {
    gu();
  }
}
function zo(t, e, n, r, s) {
  var i;
  try {
    i = n ? t.apply(e, n) : t.call(e), i && !i._isVue && qb(i) && !i._handled && (i.catch(function(o) {
      return Ha(o, r, s + " (Promise/async)");
    }), i._handled = !0);
  } catch (o) {
    Ha(o, r, s);
  }
  return i;
}
function Sx(t, e, n) {
  if (vn.errorHandler)
    try {
      return vn.errorHandler.call(null, t, e, n);
    } catch (r) {
      r !== t && Ix(r, null, "config.errorHandler");
    }
  Ix(t, e, n);
}
function Ix(t, e, n) {
  if (process.env.NODE_ENV !== "production" && Te("Error in ".concat(n, ': "').concat(t.toString(), '"'), e), Os && typeof console < "u")
    console.error(t);
  else
    throw t;
}
var s_ = !1, i_ = [], o_ = !1;
function hp() {
  o_ = !1;
  var t = i_.slice(0);
  i_.length = 0;
  for (var e = 0; e < t.length; e++)
    t[e]();
}
var Sd;
if (typeof Promise < "u" && Rl(Promise)) {
  var hG = Promise.resolve();
  Sd = function() {
    hG.then(hp), yU && setTimeout(Nn);
  }, s_ = !0;
} else if (!hu && typeof MutationObserver < "u" && (Rl(MutationObserver) || // PhantomJS and iOS 7.x
MutationObserver.toString() === "[object MutationObserverConstructor]")) {
  var mp = 1, mG = new MutationObserver(hp), Ex = document.createTextNode(String(mp));
  mG.observe(Ex, {
    characterData: !0
  }), Sd = function() {
    mp = (mp + 1) % 2, Ex.data = String(mp);
  }, s_ = !0;
} else typeof setImmediate < "u" && Rl(setImmediate) ? Sd = function() {
  setImmediate(hp);
} : Sd = function() {
  setTimeout(hp, 0);
};
function Ar(t, e) {
  var n;
  if (i_.push(function() {
    if (t)
      try {
        t.call(e);
      } catch (r) {
        Ha(r, e, "nextTick");
      }
    else n && n(e);
  }), o_ || (o_ = !0, Sd()), !t && typeof Promise < "u")
    return new Promise(function(r) {
      n = r;
    });
}
function qO(t) {
  t === void 0 && (t = "$style");
  {
    if (!jn)
      return process.env.NODE_ENV !== "production" && Te("useCssModule must be called inside setup()"), Fr;
    var e = jn[t];
    return e || (process.env.NODE_ENV !== "production" && Te('Current instance does not have CSS module named "'.concat(t, '".')), Fr);
  }
}
function vG(t) {
  if (Os) {
    var e = jn;
    if (!e) {
      process.env.NODE_ENV !== "production" && Te("useCssVars is called without current active component instance.");
      return;
    }
    LO(function() {
      var n = e.$el, r = t(e, e._setupProxy);
      if (n && n.nodeType === 1) {
        var s = n.style;
        for (var i in r)
          s.setProperty("--".concat(i), r[i]);
      }
    });
  }
}
function gG(t) {
  an(t) && (t = { loader: t });
  var e = t.loader, n = t.loadingComponent, r = t.errorComponent, s = t.delay, i = s === void 0 ? 200 : s, o = t.timeout, a = t.suspensible, l = a === void 0 ? !1 : a, c = t.onError;
  process.env.NODE_ENV !== "production" && l && Te("The suspensible option for async components is not supported in Vue2. It is ignored.");
  var u = null, d = 0, f = function() {
    return d++, u = null, p();
  }, p = function() {
    var h;
    return u || (h = u = e().catch(function(m) {
      if (m = m instanceof Error ? m : new Error(String(m)), c)
        return new Promise(function(v, y) {
          var _ = function() {
            return v(f());
          }, w = function() {
            return y(m);
          };
          c(m, _, w, d + 1);
        });
      throw m;
    }).then(function(m) {
      if (h !== u && u)
        return u;
      if (process.env.NODE_ENV !== "production" && !m && Te("Async component loader resolved to undefined. If you are using retry(), make sure to return its return value."), m && (m.__esModule || m[Symbol.toStringTag] === "Module") && (m = m.default), process.env.NODE_ENV !== "production" && m && !Mr(m) && !an(m))
        throw new Error("Invalid async component load result: ".concat(m));
      return m;
    }));
  };
  return function() {
    var h = p();
    return {
      component: h,
      delay: i,
      timeout: o,
      error: r,
      loading: n
    };
  };
}
function Ci(t) {
  return function(e, n) {
    if (n === void 0 && (n = jn), !n) {
      process.env.NODE_ENV !== "production" && Te("".concat(yG(t), " is called when there is no active component instance to be ") + "associated with. Lifecycle injection APIs can only be used during execution of setup().");
      return;
    }
    return bG(n, t, e);
  };
}
function yG(t) {
  return t === "beforeDestroy" ? t = "beforeUnmount" : t === "destroyed" && (t = "unmounted"), "on".concat(t[0].toUpperCase() + t.slice(1));
}
function bG(t, e, n) {
  var r = t.$options;
  r[e] = lM(r[e], n);
}
var _G = Ci("beforeMount"), Io = Ci("mounted"), QO = Ci("beforeUpdate"), eM = Ci("updated"), Nf = Ci("beforeDestroy"), wG = Ci("destroyed"), SG = Ci("activated"), IG = Ci("deactivated"), EG = Ci("serverPrefetch"), xG = Ci("renderTracked"), CG = Ci("renderTriggered"), TG = Ci("errorCaptured");
function PG(t, e) {
  e === void 0 && (e = jn), TG(t, e);
}
var tM = "2.7.16";
function kG(t) {
  return t;
}
var xx = new tf();
function tu(t) {
  return Qp(t, xx), xx.clear(), t;
}
function Qp(t, e) {
  var n, r, s = mt(t);
  if (!(!s && !Mr(t) || t.__v_skip || Object.isFrozen(t) || t instanceof Hs)) {
    if (t.__ob__) {
      var i = t.__ob__.dep.id;
      if (e.has(i))
        return;
      e.add(i);
    }
    if (s)
      for (n = t.length; n--; )
        Qp(t[n], e);
    else if (Jr(t))
      Qp(t.value, e);
    else
      for (r = Object.keys(t), n = r.length; n--; )
        Qp(t[r[n]], e);
  }
}
var NG = 0, $f = (
  /** @class */
  function() {
    function t(e, n, r, s, i) {
      LU(
        this,
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        ls && !ls._vm ? ls : e ? e._scope : void 0
      ), (this.vm = e) && i && (e._watcher = this), s ? (this.deep = !!s.deep, this.user = !!s.user, this.lazy = !!s.lazy, this.sync = !!s.sync, this.before = s.before, process.env.NODE_ENV !== "production" && (this.onTrack = s.onTrack, this.onTrigger = s.onTrigger)) : this.deep = this.user = this.lazy = this.sync = !1, this.cb = r, this.id = ++NG, this.active = !0, this.post = !1, this.dirty = this.lazy, this.deps = [], this.newDeps = [], this.depIds = new tf(), this.newDepIds = new tf(), this.expression = process.env.NODE_ENV !== "production" ? n.toString() : "", an(n) ? this.getter = n : (this.getter = vU(n), this.getter || (this.getter = Nn, process.env.NODE_ENV !== "production" && Te('Failed watching path: "'.concat(n, '" ') + "Watcher only accepts simple dot-delimited paths. For full control, use a function instead.", e))), this.value = this.lazy ? void 0 : this.get();
    }
    return t.prototype.get = function() {
      vu(this);
      var e, n = this.vm;
      try {
        e = this.getter.call(n, n);
      } catch (r) {
        if (this.user)
          Ha(r, n, 'getter for watcher "'.concat(this.expression, '"'));
        else
          throw r;
      } finally {
        this.deep && tu(e), gu(), this.cleanupDeps();
      }
      return e;
    }, t.prototype.addDep = function(e) {
      var n = e.id;
      this.newDepIds.has(n) || (this.newDepIds.add(n), this.newDeps.push(e), this.depIds.has(n) || e.addSub(this));
    }, t.prototype.cleanupDeps = function() {
      for (var e = this.deps.length; e--; ) {
        var n = this.deps[e];
        this.newDepIds.has(n.id) || n.removeSub(this);
      }
      var r = this.depIds;
      this.depIds = this.newDepIds, this.newDepIds = r, this.newDepIds.clear(), r = this.deps, this.deps = this.newDeps, this.newDeps = r, this.newDeps.length = 0;
    }, t.prototype.update = function() {
      this.lazy ? this.dirty = !0 : this.sync ? this.run() : c_(this);
    }, t.prototype.run = function() {
      if (this.active) {
        var e = this.get();
        if (e !== this.value || // Deep watchers and watchers on Object/Arrays should fire even
        // when the value is the same, because the value may
        // have mutated.
        Mr(e) || this.deep) {
          var n = this.value;
          if (this.value = e, this.user) {
            var r = 'callback for watcher "'.concat(this.expression, '"');
            zo(this.cb, this.vm, [e, n], this.vm, r);
          } else
            this.cb.call(this.vm, e, n);
        }
      }
    }, t.prototype.evaluate = function() {
      this.value = this.get(), this.dirty = !1;
    }, t.prototype.depend = function() {
      for (var e = this.deps.length; e--; )
        this.deps[e].depend();
    }, t.prototype.teardown = function() {
      if (this.vm && !this.vm._isBeingDestroyed && Xa(this.vm._scope.effects, this), this.active) {
        for (var e = this.deps.length; e--; )
          this.deps[e].removeSub(this);
        this.active = !1, this.onStop && this.onStop();
      }
    }, t;
  }()
), lo, Jh;
if (process.env.NODE_ENV !== "production") {
  var Oo = Os && window.performance;
  Oo && // @ts-ignore
  Oo.mark && // @ts-ignore
  Oo.measure && // @ts-ignore
  Oo.clearMarks && // @ts-ignore
  Oo.clearMeasures && (lo = function(t) {
    return Oo.mark(t);
  }, Jh = function(t, e, n) {
    Oo.measure(t, e, n), Oo.clearMarks(e), Oo.clearMarks(n);
  });
}
function $G(t) {
  t._events = /* @__PURE__ */ Object.create(null), t._hasHookEvent = !1;
  var e = t.$options._parentListeners;
  e && nM(t, e);
}
var sf;
function DG(t, e) {
  sf.$on(t, e);
}
function AG(t, e) {
  sf.$off(t, e);
}
function OG(t, e) {
  var n = sf;
  return function r() {
    var s = e.apply(null, arguments);
    s !== null && n.$off(t, r);
  };
}
function nM(t, e, n) {
  sf = t, WO(e, n || {}, DG, AG, OG, t), sf = void 0;
}
function MG(t) {
  var e = /^hook:/;
  t.prototype.$on = function(n, r) {
    var s = this;
    if (mt(n))
      for (var i = 0, o = n.length; i < o; i++)
        s.$on(n[i], r);
    else
      (s._events[n] || (s._events[n] = [])).push(r), e.test(n) && (s._hasHookEvent = !0);
    return s;
  }, t.prototype.$once = function(n, r) {
    var s = this;
    function i() {
      s.$off(n, i), r.apply(s, arguments);
    }
    return i.fn = r, s.$on(n, i), s;
  }, t.prototype.$off = function(n, r) {
    var s = this;
    if (!arguments.length)
      return s._events = /* @__PURE__ */ Object.create(null), s;
    if (mt(n)) {
      for (var i = 0, o = n.length; i < o; i++)
        s.$off(n[i], r);
      return s;
    }
    var a = s._events[n];
    if (!a)
      return s;
    if (!r)
      return s._events[n] = null, s;
    for (var l, c = a.length; c--; )
      if (l = a[c], l === r || l.fn === r) {
        a.splice(c, 1);
        break;
      }
    return s;
  }, t.prototype.$emit = function(n) {
    var r = this;
    if (process.env.NODE_ENV !== "production") {
      var s = n.toLowerCase();
      s !== n && r._events[s] && Gw('Event "'.concat(s, '" is emitted in component ') + "".concat($l(r), ' but the handler is registered for "').concat(n, '". ') + "Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. " + 'You should probably use "'.concat(ql(n), '" instead of "').concat(n, '".'));
    }
    var i = r._events[n];
    if (i) {
      i = i.length > 1 ? Qb(i) : i;
      for (var o = Qb(arguments, 1), a = 'event handler for "'.concat(n, '"'), l = 0, c = i.length; l < c; l++)
        zo(i[l], r, o, r, a);
    }
    return r;
  };
}
var Fl = null, of = !1;
function rM(t) {
  var e = Fl;
  return Fl = t, function() {
    Fl = e;
  };
}
function RG(t) {
  var e = t.$options, n = e.parent;
  if (n && !e.abstract) {
    for (; n.$options.abstract && n.$parent; )
      n = n.$parent;
    n.$children.push(t);
  }
  t.$parent = n, t.$root = n ? n.$root : t, t.$children = [], t.$refs = {}, t._provided = n ? n._provided : /* @__PURE__ */ Object.create(null), t._watcher = null, t._inactive = null, t._directInactive = !1, t._isMounted = !1, t._isDestroyed = !1, t._isBeingDestroyed = !1;
}
function LG(t) {
  t.prototype._update = function(e, n) {
    var r = this, s = r.$el, i = r._vnode, o = rM(r);
    r._vnode = e, i ? r.$el = r.__patch__(i, e) : r.$el = r.__patch__(
      r.$el,
      e,
      n,
      !1
      /* removeOnly */
    ), o(), s && (s.__vue__ = null), r.$el && (r.$el.__vue__ = r);
    for (var a = r; a && a.$vnode && a.$parent && a.$vnode === a.$parent._vnode; )
      a.$parent.$el = a.$el, a = a.$parent;
  }, t.prototype.$forceUpdate = function() {
    var e = this;
    e._watcher && e._watcher.update();
  }, t.prototype.$destroy = function() {
    var e = this;
    if (!e._isBeingDestroyed) {
      Qs(e, "beforeDestroy"), e._isBeingDestroyed = !0;
      var n = e.$parent;
      n && !n._isBeingDestroyed && !e.$options.abstract && Xa(n.$children, e), e._scope.stop(), e._data.__ob__ && e._data.__ob__.vmCount--, e._isDestroyed = !0, e.__patch__(e._vnode, null), Qs(e, "destroyed"), e.$off(), e.$el && (e.$el.__vue__ = null), e.$vnode && (e.$vnode.parent = null);
    }
  };
}
function FG(t, e, n) {
  t.$el = e, t.$options.render || (t.$options.render = Ll, process.env.NODE_ENV !== "production" && (t.$options.template && t.$options.template.charAt(0) !== "#" || t.$options.el || e ? Te("You are using the runtime-only build of Vue where the template compiler is not available. Either pre-compile the templates into render functions, or use the compiler-included build.", t) : Te("Failed to mount component: template or render function not defined.", t))), Qs(t, "beforeMount");
  var r;
  process.env.NODE_ENV !== "production" && vn.performance && lo ? r = function() {
    var a = t._name, l = t._uid, c = "vue-perf-start:".concat(l), u = "vue-perf-end:".concat(l);
    lo(c);
    var d = t._render();
    lo(u), Jh("vue ".concat(a, " render"), c, u), lo(c), t._update(d, n), lo(u), Jh("vue ".concat(a, " patch"), c, u);
  } : r = function() {
    t._update(t._render(), n);
  };
  var s = {
    before: function() {
      t._isMounted && !t._isDestroyed && Qs(t, "beforeUpdate");
    }
  };
  process.env.NODE_ENV !== "production" && (s.onTrack = function(a) {
    return Qs(t, "renderTracked", [a]);
  }, s.onTrigger = function(a) {
    return Qs(t, "renderTriggered", [a]);
  }), new $f(
    t,
    r,
    Nn,
    s,
    !0
    /* isRenderWatcher */
  ), n = !1;
  var i = t._preWatchers;
  if (i)
    for (var o = 0; o < i.length; o++)
      i[o].run();
  return t.$vnode == null && (t._isMounted = !0, Qs(t, "mounted")), t;
}
function BG(t, e, n, r, s) {
  process.env.NODE_ENV !== "production" && (of = !0);
  var i = r.data.scopedSlots, o = t.$scopedSlots, a = !!(i && !i.$stable || o !== Fr && !o.$stable || i && t.$scopedSlots.$key !== i.$key || !i && t.$scopedSlots.$key), l = !!(s || // has new static slots
  t.$options._renderChildren || // has old static slots
  a), c = t.$vnode;
  t.$options._parentVnode = r, t.$vnode = r, t._vnode && (t._vnode.parent = r), t.$options._renderChildren = s;
  var u = r.data.attrs || Fr;
  t._attrsProxy && Kh(t._attrsProxy, u, c.data && c.data.attrs || Fr, t, "$attrs") && (l = !0), t.$attrs = u, n = n || Fr;
  var d = t.$options._parentListeners;
  if (t._listenersProxy && Kh(t._listenersProxy, n, d || Fr, t, "$listeners"), t.$listeners = t.$options._parentListeners = n, nM(t, n, d), e && t.$options.props) {
    Wa(!1);
    for (var f = t._props, p = t.$options._propKeys || [], h = 0; h < p.length; h++) {
      var m = p[h], v = t.$options.props;
      f[m] = Xw(m, v, e, t);
    }
    Wa(!0), t.$options.propsData = e;
  }
  l && (t.$slots = Bw(s, r.context), t.$forceUpdate()), process.env.NODE_ENV !== "production" && (of = !1);
}
function sM(t) {
  for (; t && (t = t.$parent); )
    if (t._inactive)
      return !0;
  return !1;
}
function Ww(t, e) {
  if (e) {
    if (t._directInactive = !1, sM(t))
      return;
  } else if (t._directInactive)
    return;
  if (t._inactive || t._inactive === null) {
    t._inactive = !1;
    for (var n = 0; n < t.$children.length; n++)
      Ww(t.$children[n]);
    Qs(t, "activated");
  }
}
function iM(t, e) {
  if (!(e && (t._directInactive = !0, sM(t))) && !t._inactive) {
    t._inactive = !0;
    for (var n = 0; n < t.$children.length; n++)
      iM(t.$children[n]);
    Qs(t, "deactivated");
  }
}
function Qs(t, e, n, r) {
  r === void 0 && (r = !0), vu();
  var s = jn, i = FO();
  r && Ba(t);
  var o = t.$options[e], a = "".concat(e, " hook");
  if (o)
    for (var l = 0, c = o.length; l < c; l++)
      zo(o[l], t, n || null, t, a);
  t._hasHookEvent && t.$emit("hook:" + e), r && (Ba(s), i && i.on()), gu();
}
var jG = 100, Bo = [], Hw = [], af = {}, eh = {}, a_ = !1, Vw = !1, jc = 0;
function WG() {
  jc = Bo.length = Hw.length = 0, af = {}, process.env.NODE_ENV !== "production" && (eh = {}), a_ = Vw = !1;
}
var oM = 0, l_ = Date.now;
if (Os && !hu) {
  var ey = window.performance;
  ey && typeof ey.now == "function" && l_() > document.createEvent("Event").timeStamp && (l_ = function() {
    return ey.now();
  });
}
var HG = function(t, e) {
  if (t.post) {
    if (!e.post)
      return 1;
  } else if (e.post)
    return -1;
  return t.id - e.id;
};
function Cx() {
  oM = l_(), Vw = !0;
  var t, e;
  for (Bo.sort(HG), jc = 0; jc < Bo.length; jc++)
    if (t = Bo[jc], t.before && t.before(), e = t.id, af[e] = null, t.run(), process.env.NODE_ENV !== "production" && af[e] != null && (eh[e] = (eh[e] || 0) + 1, eh[e] > jG)) {
      Te("You may have an infinite update loop " + (t.user ? 'in watcher with expression "'.concat(t.expression, '"') : "in a component render function."), t.vm);
      break;
    }
  var n = Hw.slice(), r = Bo.slice();
  WG(), UG(n), VG(r), wU(), Gh && vn.devtools && Gh.emit("flush");
}
function VG(t) {
  for (var e = t.length; e--; ) {
    var n = t[e], r = n.vm;
    r && r._watcher === n && r._isMounted && !r._isDestroyed && Qs(r, "updated");
  }
}
function zG(t) {
  t._inactive = !1, Hw.push(t);
}
function UG(t) {
  for (var e = 0; e < t.length; e++)
    t[e]._inactive = !0, Ww(
      t[e],
      !0
      /* true */
    );
}
function c_(t) {
  var e = t.id;
  if (af[e] == null && !(t === ds.target && t.noRecurse)) {
    if (af[e] = !0, !Vw)
      Bo.push(t);
    else {
      for (var n = Bo.length - 1; n > jc && Bo[n].id > t.id; )
        n--;
      Bo.splice(n + 1, 0, t);
    }
    if (!a_) {
      if (a_ = !0, process.env.NODE_ENV !== "production" && !vn.async) {
        Cx();
        return;
      }
      Ar(Cx);
    }
  }
}
function GG(t) {
  var e = t.$options.provide;
  if (e) {
    var n = an(e) ? e.call(t) : e;
    if (!Mr(n))
      return;
    for (var r = jO(t), s = Pf ? Reflect.ownKeys(n) : Object.keys(n), i = 0; i < s.length; i++) {
      var o = s[i];
      Object.defineProperty(r, o, Object.getOwnPropertyDescriptor(n, o));
    }
  }
}
function YG(t) {
  var e = aM(t.$options.inject, t);
  e && (Wa(!1), Object.keys(e).forEach(function(n) {
    process.env.NODE_ENV !== "production" ? gi(t, n, e[n], function() {
      Te("Avoid mutating an injected value directly since the changes will be overwritten whenever the provided component re-renders. " + 'injection being mutated: "'.concat(n, '"'), t);
    }) : gi(t, n, e[n]);
  }), Wa(!0));
}
function aM(t, e) {
  if (t) {
    for (var n = /* @__PURE__ */ Object.create(null), r = Pf ? Reflect.ownKeys(t) : Object.keys(t), s = 0; s < r.length; s++) {
      var i = r[s];
      if (i !== "__ob__") {
        var o = t[i].from;
        if (o in e._provided)
          n[i] = e._provided[o];
        else if ("default" in t[i]) {
          var a = t[i].default;
          n[i] = an(a) ? a.call(e) : a;
        } else process.env.NODE_ENV !== "production" && Te('Injection "'.concat(i, '" not found'), e);
      }
    }
    return n;
  }
}
function zw(t, e, n, r, s) {
  var i = this, o = s.options, a;
  Br(r, "_uid") ? (a = Object.create(r), a._original = r) : (a = r, r = r._original);
  var l = Yn(o._compiled), c = !l;
  this.data = t, this.props = e, this.children = n, this.parent = r, this.listeners = t.on || Fr, this.injections = aM(o.inject, r), this.slots = function() {
    return i.$slots || Bd(r, t.scopedSlots, i.$slots = Bw(n, r)), i.$slots;
  }, Object.defineProperty(this, "scopedSlots", {
    enumerable: !0,
    get: function() {
      return Bd(r, t.scopedSlots, this.slots());
    }
  }), l && (this.$options = o, this.$slots = this.slots(), this.$scopedSlots = Bd(r, t.scopedSlots, this.$slots)), o._scopeId ? this._c = function(u, d, f, p) {
    var h = rf(a, u, d, f, p, c);
    return h && !mt(h) && (h.fnScopeId = o._scopeId, h.fnContext = r), h;
  } : this._c = function(u, d, f, p) {
    return rf(a, u, d, f, p, c);
  };
}
UO(zw.prototype);
function ZG(t, e, n, r, s) {
  var i = t.options, o = {}, a = i.props;
  if (me(a))
    for (var l in a)
      o[l] = Xw(l, a, e || Fr);
  else
    me(n.attrs) && Px(o, n.attrs), me(n.props) && Px(o, n.props);
  var c = new zw(n, o, s, r, t), u = i.render.call(null, c._c, c);
  if (u instanceof Hs)
    return Tx(u, n, c.parent, i, c);
  if (mt(u)) {
    for (var d = Fw(u) || [], f = new Array(d.length), p = 0; p < d.length; p++)
      f[p] = Tx(d[p], n, c.parent, i, c);
    return f;
  }
}
function Tx(t, e, n, r, s) {
  var i = n_(t);
  return i.fnContext = n, i.fnOptions = r, process.env.NODE_ENV !== "production" && ((i.devtoolsMeta = i.devtoolsMeta || {}).renderContext = s), e.slot && ((i.data || (i.data = {})).slot = e.slot), i;
}
function Px(t, e) {
  for (var n in e)
    t[zl(n)] = e[n];
}
function nu(t) {
  return t.name || t.__name || t._componentTag;
}
var Uw = {
  init: function(t, e) {
    if (t.componentInstance && !t.componentInstance._isDestroyed && t.data.keepAlive) {
      var n = t;
      Uw.prepatch(n, n);
    } else {
      var r = t.componentInstance = XG(t, Fl);
      r.$mount(e ? t.elm : void 0, e);
    }
  },
  prepatch: function(t, e) {
    var n = e.componentOptions, r = e.componentInstance = t.componentInstance;
    BG(
      r,
      n.propsData,
      // updated props
      n.listeners,
      // updated listeners
      e,
      // new parent vnode
      n.children
      // new children
    );
  },
  insert: function(t) {
    var e = t.context, n = t.componentInstance;
    n._isMounted || (n._isMounted = !0, Qs(n, "mounted")), t.data.keepAlive && (e._isMounted ? zG(n) : Ww(
      n,
      !0
      /* direct */
    ));
  },
  destroy: function(t) {
    var e = t.componentInstance;
    e._isDestroyed || (t.data.keepAlive ? iM(
      e,
      !0
      /* direct */
    ) : e.$destroy());
  }
}, kx = Object.keys(Uw);
function Nx(t, e, n, r, s) {
  if (!ht(t)) {
    var i = n.$options._base;
    if (Mr(t) && (t = i.extend(t)), typeof t != "function") {
      process.env.NODE_ENV !== "production" && Te("Invalid Component definition: ".concat(String(t)), n);
      return;
    }
    var o;
    if (ht(t.cid) && (o = t, t = uG(o, i), t === void 0))
      return cG(o, e, n, r, s);
    e = e || {}, Jw(t), me(e.model) && qG(t.options, e);
    var a = BU(e, t, s);
    if (Yn(t.options.functional))
      return ZG(t, a, e, n, r);
    var l = e.on;
    if (e.on = e.nativeOn, Yn(t.options.abstract)) {
      var c = e.slot;
      e = {}, c && (e.slot = c);
    }
    KG(e);
    var u = nu(t.options) || s, d = new Hs(
      // @ts-expect-error
      "vue-component-".concat(t.cid).concat(u ? "-".concat(u) : ""),
      e,
      void 0,
      void 0,
      void 0,
      n,
      // @ts-expect-error
      { Ctor: t, propsData: a, listeners: l, tag: s, children: r },
      o
    );
    return d;
  }
}
function XG(t, e) {
  var n = {
    _isComponent: !0,
    _parentVnode: t,
    parent: e
  }, r = t.data.inlineTemplate;
  return me(r) && (n.render = r.render, n.staticRenderFns = r.staticRenderFns), new t.componentOptions.Ctor(n);
}
function KG(t) {
  for (var e = t.hook || (t.hook = {}), n = 0; n < kx.length; n++) {
    var r = kx[n], s = e[r], i = Uw[r];
    s !== i && !(s && s._merged) && (e[r] = s ? JG(i, s) : i);
  }
}
function JG(t, e) {
  var n = function(r, s) {
    t(r, s), e(r, s);
  };
  return n._merged = !0, n;
}
function qG(t, e) {
  var n = t.model && t.model.prop || "value", r = t.model && t.model.event || "input";
  (e.attrs || (e.attrs = {}))[n] = e.model.value;
  var s = e.on || (e.on = {}), i = s[r], o = e.model.callback;
  me(i) ? (mt(i) ? i.indexOf(o) === -1 : i !== o) && (s[r] = [o].concat(i)) : s[r] = o;
}
var Te = Nn, Gw = Nn, ty, $l;
if (process.env.NODE_ENV !== "production") {
  var $x = typeof console < "u", QG = /(?:^|[-_])(\w)/g, eY = function(t) {
    return t.replace(QG, function(e) {
      return e.toUpperCase();
    }).replace(/[-_]/g, "");
  };
  Te = function(t, e) {
    e === void 0 && (e = jn);
    var n = e ? ty(e) : "";
    vn.warnHandler ? vn.warnHandler.call(null, t, e, n) : $x && !vn.silent && console.error("[Vue warn]: ".concat(t).concat(n));
  }, Gw = function(t, e) {
    $x && !vn.silent && console.warn("[Vue tip]: ".concat(t) + (e ? ty(e) : ""));
  }, $l = function(t, e) {
    if (t.$root === t)
      return "<Root>";
    var n = an(t) && t.cid != null ? t.options : t._isVue ? t.$options || t.constructor.options : t, r = nu(n), s = n.__file;
    if (!r && s) {
      var i = s.match(/([^/\\]+)\.vue$/);
      r = i && i[1];
    }
    return (r ? "<".concat(eY(r), ">") : "<Anonymous>") + (s && e !== !1 ? " at ".concat(s) : "");
  };
  var tY = function(t, e) {
    for (var n = ""; e; )
      e % 2 === 1 && (n += t), e > 1 && (t += t), e >>= 1;
    return n;
  };
  ty = function(t) {
    if (t._isVue && t.$parent) {
      for (var e = [], n = 0; t; ) {
        if (e.length > 0) {
          var r = e[e.length - 1];
          if (r.constructor === t.constructor) {
            n++, t = t.$parent;
            continue;
          } else n > 0 && (e[e.length - 1] = [r, n], n = 0);
        }
        e.push(t), t = t.$parent;
      }
      return `

found in

` + e.map(function(s, i) {
        return "".concat(i === 0 ? "---> " : tY(" ", 5 + i * 2)).concat(mt(s) ? "".concat($l(s[0]), "... (").concat(s[1], " recursive calls)") : $l(s));
      }).join(`
`);
    } else
      return `

(found in `.concat($l(t), ")");
  };
}
var yi = vn.optionMergeStrategies;
process.env.NODE_ENV !== "production" && (yi.el = yi.propsData = function(t, e, n, r) {
  return n || Te('option "'.concat(r, '" can only be used during instance ') + "creation with the `new` keyword."), cM(t, e);
});
function lf(t, e, n) {
  if (n === void 0 && (n = !0), !e)
    return t;
  for (var r, s, i, o = Pf ? Reflect.ownKeys(e) : Object.keys(e), a = 0; a < o.length; a++)
    r = o[a], r !== "__ob__" && (s = t[r], i = e[r], !n || !Br(t, r) ? cv(t, r, i) : s !== i && Qr(s) && Qr(i) && lf(s, i));
  return t;
}
function Dx(t, e, n) {
  return n ? function() {
    var s = an(e) ? e.call(n, n) : e, i = an(t) ? t.call(n, n) : t;
    return s ? lf(s, i) : i;
  } : e ? t ? function() {
    return lf(an(e) ? e.call(this, this) : e, an(t) ? t.call(this, this) : t);
  } : e : t;
}
yi.data = function(t, e, n) {
  return n ? Dx(t, e, n) : e && typeof e != "function" ? (process.env.NODE_ENV !== "production" && Te('The "data" option should be a function that returns a per-instance value in component definitions.', n), t) : Dx(t, e);
};
function lM(t, e) {
  var n = e ? t ? t.concat(e) : mt(e) ? e : [e] : t;
  return n && nY(n);
}
function nY(t) {
  for (var e = [], n = 0; n < t.length; n++)
    e.indexOf(t[n]) === -1 && e.push(t[n]);
  return e;
}
EO.forEach(function(t) {
  yi[t] = lM;
});
function rY(t, e, n, r) {
  var s = Object.create(t || null);
  return e ? (process.env.NODE_ENV !== "production" && Zw(r, e, n), $n(s, e)) : s;
}
lv.forEach(function(t) {
  yi[t + "s"] = rY;
});
yi.watch = function(t, e, n, r) {
  if (t === t_ && (t = void 0), e === t_ && (e = void 0), !e)
    return Object.create(t || null);
  if (process.env.NODE_ENV !== "production" && Zw(r, e, n), !t)
    return e;
  var s = {};
  $n(s, t);
  for (var i in e) {
    var o = s[i], a = e[i];
    o && !mt(o) && (o = [o]), s[i] = o ? o.concat(a) : mt(a) ? a : [a];
  }
  return s;
};
yi.props = yi.methods = yi.inject = yi.computed = function(t, e, n, r) {
  if (e && process.env.NODE_ENV !== "production" && Zw(r, e, n), !t)
    return e;
  var s = /* @__PURE__ */ Object.create(null);
  return $n(s, t), e && $n(s, e), s;
};
yi.provide = function(t, e) {
  return t ? function() {
    var n = /* @__PURE__ */ Object.create(null);
    return lf(n, an(t) ? t.call(this) : t), e && lf(
      n,
      an(e) ? e.call(this) : e,
      !1
      // non-recursive
    ), n;
  } : e;
};
var cM = function(t, e) {
  return e === void 0 ? t : e;
};
function sY(t) {
  for (var e in t.components)
    Yw(e);
}
function Yw(t) {
  new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(xO.source, "]*$")).test(t) || Te('Invalid component name: "' + t + '". Component names should conform to valid custom element name in html5 specification.'), (cU(t) || vn.isReservedTag(t)) && Te("Do not use built-in or reserved HTML elements as component id: " + t);
}
function iY(t, e) {
  var n = t.props;
  if (n) {
    var r = {}, s, i, o;
    if (mt(n))
      for (s = n.length; s--; )
        i = n[s], typeof i == "string" ? (o = zl(i), r[o] = { type: null }) : process.env.NODE_ENV !== "production" && Te("props must be strings when using array syntax.");
    else if (Qr(n))
      for (var a in n)
        i = n[a], o = zl(a), r[o] = Qr(i) ? i : { type: i };
    else process.env.NODE_ENV !== "production" && Te('Invalid value for option "props": expected an Array or an Object, ' + "but got ".concat(Tf(n), "."), e);
    t.props = r;
  }
}
function oY(t, e) {
  var n = t.inject;
  if (n) {
    var r = t.inject = {};
    if (mt(n))
      for (var s = 0; s < n.length; s++)
        r[n[s]] = { from: n[s] };
    else if (Qr(n))
      for (var i in n) {
        var o = n[i];
        r[i] = Qr(o) ? $n({ from: i }, o) : { from: o };
      }
    else process.env.NODE_ENV !== "production" && Te('Invalid value for option "inject": expected an Array or an Object, ' + "but got ".concat(Tf(n), "."), e);
  }
}
function aY(t) {
  var e = t.directives;
  if (e)
    for (var n in e) {
      var r = e[n];
      an(r) && (e[n] = { bind: r, update: r });
    }
}
function Zw(t, e, n) {
  Qr(e) || Te('Invalid value for option "'.concat(t, '": expected an Object, ') + "but got ".concat(Tf(e), "."), n);
}
function Gl(t, e, n) {
  if (process.env.NODE_ENV !== "production" && sY(e), an(e) && (e = e.options), iY(e, n), oY(e, n), aY(e), !e._base && (e.extends && (t = Gl(t, e.extends, n)), e.mixins))
    for (var r = 0, s = e.mixins.length; r < s; r++)
      t = Gl(t, e.mixins[r], n);
  var i = {}, o;
  for (o in t)
    a(o);
  for (o in e)
    Br(t, o) || a(o);
  function a(l) {
    var c = yi[l] || cM;
    i[l] = c(t[l], e[l], n, l);
  }
  return i;
}
function qh(t, e, n, r) {
  if (typeof n == "string") {
    var s = t[e];
    if (Br(s, n))
      return s[n];
    var i = zl(n);
    if (Br(s, i))
      return s[i];
    var o = bO(i);
    if (Br(s, o))
      return s[o];
    var a = s[n] || s[i] || s[o];
    return process.env.NODE_ENV !== "production" && r && !a && Te("Failed to resolve " + e.slice(0, -1) + ": " + n), a;
  }
}
function Xw(t, e, n, r) {
  var s = e[t], i = !Br(n, t), o = n[t], a = Ox(Boolean, s.type);
  if (a > -1) {
    if (i && !Br(s, "default"))
      o = !1;
    else if (o === "" || o === ql(t)) {
      var l = Ox(String, s.type);
      (l < 0 || a < l) && (o = !0);
    }
  }
  if (o === void 0) {
    o = lY(r, s, t);
    var c = $w;
    Wa(!0), Vo(o), Wa(c);
  }
  return process.env.NODE_ENV !== "production" && cY(s, t, o, r, i), o;
}
function lY(t, e, n) {
  if (Br(e, "default")) {
    var r = e.default;
    return process.env.NODE_ENV !== "production" && Mr(r) && Te('Invalid default value for prop "' + n + '": Props with type Object/Array must use a factory function to return the default value.', t), t && t.$options.propsData && t.$options.propsData[n] === void 0 && t._props[n] !== void 0 ? t._props[n] : an(r) && Qh(e.type) !== "Function" ? r.call(t) : r;
  }
}
function cY(t, e, n, r, s) {
  if (t.required && s) {
    Te('Missing required prop: "' + e + '"', r);
    return;
  }
  if (!(n == null && !t.required)) {
    var i = t.type, o = !i || i === !0, a = [];
    if (i) {
      mt(i) || (i = [i]);
      for (var l = 0; l < i.length && !o; l++) {
        var c = dY(n, i[l], r);
        a.push(c.expectedType || ""), o = c.valid;
      }
    }
    var u = a.some(function(f) {
      return f;
    });
    if (!o && u) {
      Te(pY(e, n, a), r);
      return;
    }
    var d = t.validator;
    d && (d(n) || Te('Invalid prop: custom validator check failed for prop "' + e + '".', r));
  }
}
var uY = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function dY(t, e, n) {
  var r, s = Qh(e);
  if (uY.test(s)) {
    var i = typeof t;
    r = i === s.toLowerCase(), !r && i === "object" && (r = t instanceof e);
  } else if (s === "Object")
    r = Qr(t);
  else if (s === "Array")
    r = mt(t);
  else
    try {
      r = t instanceof e;
    } catch {
      Te('Invalid prop type: "' + String(e) + '" is not a constructor', n), r = !1;
    }
  return {
    valid: r,
    expectedType: s
  };
}
var fY = /^\s*function (\w+)/;
function Qh(t) {
  var e = t && t.toString().match(fY);
  return e ? e[1] : "";
}
function Ax(t, e) {
  return Qh(t) === Qh(e);
}
function Ox(t, e) {
  if (!mt(e))
    return Ax(e, t) ? 0 : -1;
  for (var n = 0, r = e.length; n < r; n++)
    if (Ax(e[n], t))
      return n;
  return -1;
}
function pY(t, e, n) {
  var r = 'Invalid prop: type check failed for prop "'.concat(t, '".') + " Expected ".concat(n.map(bO).join(", ")), s = n[0], i = Tf(e);
  return n.length === 1 && ny(s) && ny(typeof e) && !mY(s, i) && (r += " with value ".concat(Mx(e, s))), r += ", got ".concat(i, " "), ny(i) && (r += "with value ".concat(Mx(e, i), ".")), r;
}
function Mx(t, e) {
  return e === "String" ? '"'.concat(t, '"') : e === "Number" ? "".concat(Number(t)) : "".concat(t);
}
var hY = ["string", "number", "boolean"];
function ny(t) {
  return hY.some(function(e) {
    return t.toLowerCase() === e;
  });
}
function mY() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return t.some(function(n) {
    return n.toLowerCase() === "boolean";
  });
}
var uM;
if (process.env.NODE_ENV !== "production") {
  var vY = si(
    "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,require"
    // for Webpack/Browserify
  ), Rx = function(t, e) {
    Te('Property or method "'.concat(e, '" is not defined on the instance but ') + "referenced during render. Make sure that this property is reactive, either in the data option, or for class-based components, by initializing the property. See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.", t);
  }, Lx = function(t, e) {
    Te('Property "'.concat(e, '" must be accessed with "$data.').concat(e, '" because ') + 'properties starting with "$" or "_" are not proxied in the Vue instance to prevent conflicts with Vue internals. See: https://v2.vuejs.org/v2/api/#data', t);
  }, Fx = typeof Proxy < "u" && Rl(Proxy);
  if (Fx) {
    var gY = si("stop,prevent,self,ctrl,shift,alt,meta,exact");
    vn.keyCodes = new Proxy(vn.keyCodes, {
      set: function(t, e, n) {
        return gY(e) ? (Te("Avoid overwriting built-in modifier in config.keyCodes: .".concat(e)), !1) : (t[e] = n, !0);
      }
    });
  }
  var yY = {
    has: function(t, e) {
      var n = e in t, r = vY(e) || typeof e == "string" && e.charAt(0) === "_" && !(e in t.$data);
      return !n && !r && (e in t.$data ? Lx(t, e) : Rx(t, e)), n || !r;
    }
  }, bY = {
    get: function(t, e) {
      return typeof e == "string" && !(e in t) && (e in t.$data ? Lx(t, e) : Rx(t, e)), t[e];
    }
  };
  uM = function(e) {
    if (Fx) {
      var n = e.$options, r = n.render && n.render._withStripped ? bY : yY;
      e._renderProxy = new Proxy(e, r);
    } else
      e._renderProxy = e;
  };
}
var so = {
  enumerable: !0,
  configurable: !0,
  get: Nn,
  set: Nn
};
function Kw(t, e, n) {
  so.get = function() {
    return this[e][n];
  }, so.set = function(s) {
    this[e][n] = s;
  }, Object.defineProperty(t, n, so);
}
function _Y(t) {
  var e = t.$options;
  if (e.props && wY(t, e.props), eG(t), e.methods && CY(t, e.methods), e.data)
    SY(t);
  else {
    var n = Vo(t._data = {});
    n && n.vmCount++;
  }
  e.computed && xY(t, e.computed), e.watch && e.watch !== t_ && TY(t, e.watch);
}
function wY(t, e) {
  var n = t.$options.propsData || {}, r = t._props = Aw({}), s = t.$options._propKeys = [], i = !t.$parent;
  i || Wa(!1);
  var o = function(l) {
    s.push(l);
    var c = Xw(l, e, n, t);
    if (process.env.NODE_ENV !== "production") {
      var u = ql(l);
      (yO(u) || vn.isReservedAttr(u)) && Te('"'.concat(u, '" is a reserved attribute and cannot be used as component prop.'), t), gi(
        r,
        l,
        c,
        function() {
          !i && !of && Te("Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders. Instead, use a data or computed property based on the prop's " + 'value. Prop being mutated: "'.concat(l, '"'), t);
        },
        !0
        /* shallow */
      );
    } else
      gi(
        r,
        l,
        c,
        void 0,
        !0
        /* shallow */
      );
    l in t || Kw(t, "_props", l);
  };
  for (var a in e)
    o(a);
  Wa(!0);
}
function SY(t) {
  var e = t.$options.data;
  e = t._data = an(e) ? IY(e, t) : e || {}, Qr(e) || (e = {}, process.env.NODE_ENV !== "production" && Te(`data functions should return an object:
https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function`, t));
  for (var n = Object.keys(e), r = t.$options.props, s = t.$options.methods, i = n.length; i--; ) {
    var o = n[i];
    process.env.NODE_ENV !== "production" && s && Br(s, o) && Te('Method "'.concat(o, '" has already been defined as a data property.'), t), r && Br(r, o) ? process.env.NODE_ENV !== "production" && Te('The data property "'.concat(o, '" is already declared as a prop. ') + "Use prop default value instead.", t) : Nw(o) || Kw(t, "_data", o);
  }
  var a = Vo(e);
  a && a.vmCount++;
}
function IY(t, e) {
  vu();
  try {
    return t.call(e, e);
  } catch (n) {
    return Ha(n, e, "data()"), {};
  } finally {
    gu();
  }
}
var EY = { lazy: !0 };
function xY(t, e) {
  var n = t._computedWatchers = /* @__PURE__ */ Object.create(null), r = Ka();
  for (var s in e) {
    var i = e[s], o = an(i) ? i : i.get;
    process.env.NODE_ENV !== "production" && o == null && Te('Getter is missing for computed property "'.concat(s, '".'), t), r || (n[s] = new $f(t, o || Nn, Nn, EY)), s in t ? process.env.NODE_ENV !== "production" && (s in t.$data ? Te('The computed property "'.concat(s, '" is already defined in data.'), t) : t.$options.props && s in t.$options.props ? Te('The computed property "'.concat(s, '" is already defined as a prop.'), t) : t.$options.methods && s in t.$options.methods && Te('The computed property "'.concat(s, '" is already defined as a method.'), t)) : dM(t, s, i);
  }
}
function dM(t, e, n) {
  var r = !Ka();
  an(n) ? (so.get = r ? Bx(e) : jx(n), so.set = Nn) : (so.get = n.get ? r && n.cache !== !1 ? Bx(e) : jx(n.get) : Nn, so.set = n.set || Nn), process.env.NODE_ENV !== "production" && so.set === Nn && (so.set = function() {
    Te('Computed property "'.concat(e, '" was assigned to but it has no setter.'), this);
  }), Object.defineProperty(t, e, so);
}
function Bx(t) {
  return function() {
    var n = this._computedWatchers && this._computedWatchers[t];
    if (n)
      return n.dirty && n.evaluate(), ds.target && (process.env.NODE_ENV !== "production" && ds.target.onTrack && ds.target.onTrack({
        effect: ds.target,
        target: this,
        type: "get",
        key: t
      }), n.depend()), n.value;
  };
}
function jx(t) {
  return function() {
    return t.call(this, this);
  };
}
function CY(t, e) {
  var n = t.$options.props;
  for (var r in e)
    process.env.NODE_ENV !== "production" && (typeof e[r] != "function" && Te('Method "'.concat(r, '" has type "').concat(typeof e[r], '" in the component definition. ') + "Did you reference the function correctly?", t), n && Br(n, r) && Te('Method "'.concat(r, '" has already been defined as a prop.'), t), r in t && Nw(r) && Te('Method "'.concat(r, '" conflicts with an existing Vue instance method. ') + "Avoid defining component methods that start with _ or $.")), t[r] = typeof e[r] != "function" ? Nn : _O(e[r], t);
}
function TY(t, e) {
  for (var n in e) {
    var r = e[n];
    if (mt(r))
      for (var s = 0; s < r.length; s++)
        u_(t, n, r[s]);
    else
      u_(t, n, r);
  }
}
function u_(t, e, n, r) {
  return Qr(n) && (r = n, n = n.handler), typeof n == "string" && (n = t[n]), t.$watch(e, n, r);
}
function PY(t) {
  var e = {};
  e.get = function() {
    return this._data;
  };
  var n = {};
  n.get = function() {
    return this._props;
  }, process.env.NODE_ENV !== "production" && (e.set = function() {
    Te("Avoid replacing instance root $data. Use nested data properties instead.", this);
  }, n.set = function() {
    Te("$props is readonly.", this);
  }), Object.defineProperty(t.prototype, "$data", e), Object.defineProperty(t.prototype, "$props", n), t.prototype.$set = cv, t.prototype.$delete = Dw, t.prototype.$watch = function(r, s, i) {
    var o = this;
    if (Qr(s))
      return u_(o, r, s, i);
    i = i || {}, i.user = !0;
    var a = new $f(o, r, s, i);
    if (i.immediate) {
      var l = 'callback for immediate watcher "'.concat(a.expression, '"');
      vu(), zo(s, o, [a.value], o, l), gu();
    }
    return function() {
      a.teardown();
    };
  };
}
var kY = 0;
function NY(t) {
  t.prototype._init = function(e) {
    var n = this;
    n._uid = kY++;
    var r, s;
    process.env.NODE_ENV !== "production" && vn.performance && lo && (r = "vue-perf-start:".concat(n._uid), s = "vue-perf-end:".concat(n._uid), lo(r)), n._isVue = !0, n.__v_skip = !0, n._scope = new Lw(
      !0
      /* detached */
    ), n._scope.parent = void 0, n._scope._vm = !0, e && e._isComponent ? $Y(n, e) : n.$options = Gl(Jw(n.constructor), e || {}, n), process.env.NODE_ENV !== "production" ? uM(n) : n._renderProxy = n, n._self = n, RG(n), $G(n), aG(n), Qs(
      n,
      "beforeCreate",
      void 0,
      !1
      /* setContext */
    ), YG(n), _Y(n), GG(n), Qs(n, "created"), process.env.NODE_ENV !== "production" && vn.performance && lo && (n._name = $l(n, !1), lo(s), Jh("vue ".concat(n._name, " init"), r, s)), n.$options.el && n.$mount(n.$options.el);
  };
}
function $Y(t, e) {
  var n = t.$options = Object.create(t.constructor.options), r = e._parentVnode;
  n.parent = e.parent, n._parentVnode = r;
  var s = r.componentOptions;
  n.propsData = s.propsData, n._parentListeners = s.listeners, n._renderChildren = s.children, n._componentTag = s.tag, e.render && (n.render = e.render, n.staticRenderFns = e.staticRenderFns);
}
function Jw(t) {
  var e = t.options;
  if (t.super) {
    var n = Jw(t.super), r = t.superOptions;
    if (n !== r) {
      t.superOptions = n;
      var s = DY(t);
      s && $n(t.extendOptions, s), e = t.options = Gl(n, t.extendOptions), e.name && (e.components[e.name] = t);
    }
  }
  return e;
}
function DY(t) {
  var e, n = t.options, r = t.sealedOptions;
  for (var s in n)
    n[s] !== r[s] && (e || (e = {}), e[s] = n[s]);
  return e;
}
function U(t) {
  process.env.NODE_ENV !== "production" && !(this instanceof U) && Te("Vue is a constructor and should be called with the `new` keyword"), this._init(t);
}
NY(U);
PY(U);
MG(U);
LG(U);
lG(U);
function AY(t) {
  t.use = function(e) {
    var n = this._installedPlugins || (this._installedPlugins = []);
    if (n.indexOf(e) > -1)
      return this;
    var r = Qb(arguments, 1);
    return r.unshift(this), an(e.install) ? e.install.apply(e, r) : an(e) && e.apply(null, r), n.push(e), this;
  };
}
function OY(t) {
  t.mixin = function(e) {
    return this.options = Gl(this.options, e), this;
  };
}
function MY(t) {
  t.cid = 0;
  var e = 1;
  t.extend = function(n) {
    n = n || {};
    var r = this, s = r.cid, i = n._Ctor || (n._Ctor = {});
    if (i[s])
      return i[s];
    var o = nu(n) || nu(r.options);
    process.env.NODE_ENV !== "production" && o && Yw(o);
    var a = function(c) {
      this._init(c);
    };
    return a.prototype = Object.create(r.prototype), a.prototype.constructor = a, a.cid = e++, a.options = Gl(r.options, n), a.super = r, a.options.props && RY(a), a.options.computed && LY(a), a.extend = r.extend, a.mixin = r.mixin, a.use = r.use, lv.forEach(function(l) {
      a[l] = r[l];
    }), o && (a.options.components[o] = a), a.superOptions = r.options, a.extendOptions = n, a.sealedOptions = $n({}, a.options), i[s] = a, a;
  };
}
function RY(t) {
  var e = t.options.props;
  for (var n in e)
    Kw(t.prototype, "_props", n);
}
function LY(t) {
  var e = t.options.computed;
  for (var n in e)
    dM(t.prototype, n, e[n]);
}
function FY(t) {
  lv.forEach(function(e) {
    t[e] = function(n, r) {
      return r ? (process.env.NODE_ENV !== "production" && e === "component" && Yw(n), e === "component" && Qr(r) && (r.name = r.name || n, r = this.options._base.extend(r)), e === "directive" && an(r) && (r = { bind: r, update: r }), this.options[e + "s"][n] = r, r) : this.options[e + "s"][n];
    };
  });
}
function Wx(t) {
  return t && (nu(t.Ctor.options) || t.tag);
}
function vp(t, e) {
  return mt(t) ? t.indexOf(e) > -1 : typeof t == "string" ? t.split(",").indexOf(e) > -1 : vO(t) ? t.test(e) : !1;
}
function Hx(t, e) {
  var n = t.cache, r = t.keys, s = t._vnode, i = t.$vnode;
  for (var o in n) {
    var a = n[o];
    if (a) {
      var l = a.name;
      l && !e(l) && d_(n, o, r, s);
    }
  }
  i.componentOptions.children = void 0;
}
function d_(t, e, n, r) {
  var s = t[e];
  s && (!r || s.tag !== r.tag) && s.componentInstance.$destroy(), t[e] = null, Xa(n, e);
}
var Vx = [String, RegExp, Array], BY = {
  name: "keep-alive",
  abstract: !0,
  props: {
    include: Vx,
    exclude: Vx,
    max: [String, Number]
  },
  methods: {
    cacheVNode: function() {
      var t = this, e = t.cache, n = t.keys, r = t.vnodeToCache, s = t.keyToCache;
      if (r) {
        var i = r.tag, o = r.componentInstance, a = r.componentOptions;
        e[s] = {
          name: Wx(a),
          tag: i,
          componentInstance: o
        }, n.push(s), this.max && n.length > parseInt(this.max) && d_(e, n[0], n, this._vnode), this.vnodeToCache = null;
      }
    }
  },
  created: function() {
    this.cache = /* @__PURE__ */ Object.create(null), this.keys = [];
  },
  destroyed: function() {
    for (var t in this.cache)
      d_(this.cache, t, this.keys);
  },
  mounted: function() {
    var t = this;
    this.cacheVNode(), this.$watch("include", function(e) {
      Hx(t, function(n) {
        return vp(e, n);
      });
    }), this.$watch("exclude", function(e) {
      Hx(t, function(n) {
        return !vp(e, n);
      });
    });
  },
  updated: function() {
    this.cacheVNode();
  },
  render: function() {
    var t = this.$slots.default, e = ZO(t), n = e && e.componentOptions;
    if (n) {
      var r = Wx(n), s = this, i = s.include, o = s.exclude;
      if (
        // not included
        i && (!r || !vp(i, r)) || // excluded
        o && r && vp(o, r)
      )
        return e;
      var a = this, l = a.cache, c = a.keys, u = e.key == null ? (
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        n.Ctor.cid + (n.tag ? "::".concat(n.tag) : "")
      ) : e.key;
      l[u] ? (e.componentInstance = l[u].componentInstance, Xa(c, u), c.push(u)) : (this.vnodeToCache = e, this.keyToCache = u), e.data.keepAlive = !0;
    }
    return e || t && t[0];
  }
}, jY = {
  KeepAlive: BY
};
function WY(t) {
  var e = {};
  e.get = function() {
    return vn;
  }, process.env.NODE_ENV !== "production" && (e.set = function() {
    Te("Do not replace the Vue.config object, set individual fields instead.");
  }), Object.defineProperty(t, "config", e), t.util = {
    warn: Te,
    extend: $n,
    mergeOptions: Gl,
    defineReactive: gi
  }, t.set = cv, t.delete = Dw, t.nextTick = Ar, t.observable = function(n) {
    return Vo(n), n;
  }, t.options = /* @__PURE__ */ Object.create(null), lv.forEach(function(n) {
    t.options[n + "s"] = /* @__PURE__ */ Object.create(null);
  }), t.options._base = t, $n(t.options.components, jY), AY(t), OY(t), MY(t), FY(t);
}
WY(U);
Object.defineProperty(U.prototype, "$isServer", {
  get: Ka
});
Object.defineProperty(U.prototype, "$ssrContext", {
  get: function() {
    return this.$vnode && this.$vnode.ssrContext;
  }
});
Object.defineProperty(U, "FunctionalRenderContext", {
  value: zw
});
U.version = tM;
var HY = si("style,class"), VY = si("input,textarea,option,select,progress"), zY = function(t, e, n) {
  return n === "value" && VY(t) && e !== "button" || n === "selected" && t === "option" || n === "checked" && t === "input" || n === "muted" && t === "video";
}, fM = si("contenteditable,draggable,spellcheck"), UY = si("events,caret,typing,plaintext-only"), GY = function(t, e) {
  return em(e) || e === "false" ? "false" : (
    // allow arbitrary string value for contenteditable
    t === "contenteditable" && UY(e) ? e : "true"
  );
}, YY = si("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"), f_ = "http://www.w3.org/1999/xlink", qw = function(t) {
  return t.charAt(5) === ":" && t.slice(0, 5) === "xlink";
}, pM = function(t) {
  return qw(t) ? t.slice(6, t.length) : "";
}, em = function(t) {
  return t == null || t === !1;
};
function ZY(t) {
  for (var e = t.data, n = t, r = t; me(r.componentInstance); )
    r = r.componentInstance._vnode, r && r.data && (e = zx(r.data, e));
  for (; me(n = n.parent); )
    n && n.data && (e = zx(e, n.data));
  return XY(e.staticClass, e.class);
}
function zx(t, e) {
  return {
    staticClass: Qw(t.staticClass, e.staticClass),
    class: me(t.class) ? [t.class, e.class] : e.class
  };
}
function XY(t, e) {
  return me(t) || me(e) ? Qw(t, eS(e)) : "";
}
function Qw(t, e) {
  return t ? e ? t + " " + e : t : e || "";
}
function eS(t) {
  return Array.isArray(t) ? KY(t) : Mr(t) ? JY(t) : typeof t == "string" ? t : "";
}
function KY(t) {
  for (var e = "", n, r = 0, s = t.length; r < s; r++)
    me(n = eS(t[r])) && n !== "" && (e && (e += " "), e += n);
  return e;
}
function JY(t) {
  var e = "";
  for (var n in t)
    t[n] && (e && (e += " "), e += n);
  return e;
}
var qY = {
  svg: "http://www.w3.org/2000/svg",
  math: "http://www.w3.org/1998/Math/MathML"
}, QY = si("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"), tS = si("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0), hM = function(t) {
  return QY(t) || tS(t);
};
function eZ(t) {
  if (tS(t))
    return "svg";
  if (t === "math")
    return "math";
}
var gp = /* @__PURE__ */ Object.create(null);
function tZ(t) {
  if (!Os)
    return !0;
  if (hM(t))
    return !1;
  if (t = t.toLowerCase(), gp[t] != null)
    return gp[t];
  var e = document.createElement(t);
  return t.indexOf("-") > -1 ? gp[t] = e.constructor === window.HTMLUnknownElement || e.constructor === window.HTMLElement : gp[t] = /HTMLUnknownElement/.test(e.toString());
}
var p_ = si("text,number,password,search,email,tel,url");
function nZ(t) {
  if (typeof t == "string") {
    var e = document.querySelector(t);
    return e || (process.env.NODE_ENV !== "production" && Te("Cannot find element: " + t), document.createElement("div"));
  } else
    return t;
}
function rZ(t, e) {
  var n = document.createElement(t);
  return t !== "select" || e.data && e.data.attrs && e.data.attrs.multiple !== void 0 && n.setAttribute("multiple", "multiple"), n;
}
function sZ(t, e) {
  return document.createElementNS(qY[t], e);
}
function iZ(t) {
  return document.createTextNode(t);
}
function oZ(t) {
  return document.createComment(t);
}
function aZ(t, e, n) {
  t.insertBefore(e, n);
}
function lZ(t, e) {
  t.removeChild(e);
}
function cZ(t, e) {
  t.appendChild(e);
}
function uZ(t) {
  return t.parentNode;
}
function dZ(t) {
  return t.nextSibling;
}
function fZ(t) {
  return t.tagName;
}
function pZ(t, e) {
  t.textContent = e;
}
function hZ(t, e) {
  t.setAttribute(e, "");
}
var mZ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createElement: rZ,
  createElementNS: sZ,
  createTextNode: iZ,
  createComment: oZ,
  insertBefore: aZ,
  removeChild: lZ,
  appendChild: cZ,
  parentNode: uZ,
  nextSibling: dZ,
  tagName: fZ,
  setTextContent: pZ,
  setStyleScope: hZ
}), vZ = {
  create: function(t, e) {
    Wc(e);
  },
  update: function(t, e) {
    t.data.ref !== e.data.ref && (Wc(t, !0), Wc(e));
  },
  destroy: function(t) {
    Wc(t, !0);
  }
};
function Wc(t, e) {
  var n = t.data.ref;
  if (me(n)) {
    var r = t.context, s = t.componentInstance || t.elm, i = e ? null : s, o = e ? void 0 : s;
    if (an(n)) {
      zo(n, r, [i], r, "template ref function");
      return;
    }
    var a = t.data.refInFor, l = typeof n == "string" || typeof n == "number", c = Jr(n), u = r.$refs;
    if (l || c)
      if (a) {
        var d = l ? u[n] : n.value;
        e ? mt(d) && Xa(d, s) : mt(d) ? d.includes(s) || d.push(s) : l ? (u[n] = [s], Ux(r, n, u[n])) : n.value = [s];
      } else if (l) {
        if (e && u[n] !== s)
          return;
        u[n] = o, Ux(r, n, i);
      } else if (c) {
        if (e && n.value !== s)
          return;
        n.value = i;
      } else process.env.NODE_ENV !== "production" && Te("Invalid template ref type: ".concat(typeof n));
  }
}
function Ux(t, e, n) {
  var r = t._setupState;
  r && Br(r, e) && (Jr(r[e]) ? r[e].value = n : r[e] = n);
}
var Ia = new Hs("", {}, []), td = ["create", "activate", "update", "remove", "destroy"];
function yl(t, e) {
  return t.key === e.key && t.asyncFactory === e.asyncFactory && (t.tag === e.tag && t.isComment === e.isComment && me(t.data) === me(e.data) && gZ(t, e) || Yn(t.isAsyncPlaceholder) && ht(e.asyncFactory.error));
}
function gZ(t, e) {
  if (t.tag !== "input")
    return !0;
  var n, r = me(n = t.data) && me(n = n.attrs) && n.type, s = me(n = e.data) && me(n = n.attrs) && n.type;
  return r === s || p_(r) && p_(s);
}
function yZ(t, e, n) {
  var r, s, i = {};
  for (r = e; r <= n; ++r)
    s = t[r].key, me(s) && (i[s] = r);
  return i;
}
function bZ(t) {
  var e, n, r = {}, s = t.modules, i = t.nodeOps;
  for (e = 0; e < td.length; ++e)
    for (r[td[e]] = [], n = 0; n < s.length; ++n)
      me(s[n][td[e]]) && r[td[e]].push(s[n][td[e]]);
  function o(A) {
    return new Hs(i.tagName(A).toLowerCase(), {}, [], void 0, A);
  }
  function a(A, j) {
    function L() {
      --L.listeners === 0 && l(A);
    }
    return L.listeners = j, L;
  }
  function l(A) {
    var j = i.parentNode(A);
    me(j) && i.removeChild(j, A);
  }
  function c(A, j) {
    return !j && !A.ns && !(vn.ignoredElements.length && vn.ignoredElements.some(function(L) {
      return vO(L) ? L.test(A.tag) : L === A.tag;
    })) && vn.isUnknownElement(A.tag);
  }
  var u = 0;
  function d(A, j, L, se, V, ee, O) {
    if (me(A.elm) && me(ee) && (A = ee[O] = n_(A)), A.isRootInsert = !V, !f(A, j, L, se)) {
      var K = A.data, z = A.children, q = A.tag;
      me(q) ? (process.env.NODE_ENV !== "production" && (K && K.pre && u++, c(A, u) && Te("Unknown custom element: <" + q + '> - did you register the component correctly? For recursive components, make sure to provide the "name" option.', A.context)), A.elm = A.ns ? i.createElementNS(A.ns, q) : i.createElement(q, A), w(A), v(A, z, j), me(K) && _(A, j), m(L, A.elm, se), process.env.NODE_ENV !== "production" && K && K.pre && u--) : Yn(A.isComment) ? (A.elm = i.createComment(A.text), m(L, A.elm, se)) : (A.elm = i.createTextNode(A.text), m(L, A.elm, se));
    }
  }
  function f(A, j, L, se) {
    var V = A.data;
    if (me(V)) {
      var ee = me(A.componentInstance) && V.keepAlive;
      if (me(V = V.hook) && me(V = V.init) && V(
        A,
        !1
        /* hydrating */
      ), me(A.componentInstance))
        return p(A, j), m(L, A.elm, se), Yn(ee) && h(A, j, L, se), !0;
    }
  }
  function p(A, j) {
    me(A.data.pendingInsert) && (j.push.apply(j, A.data.pendingInsert), A.data.pendingInsert = null), A.elm = A.componentInstance.$el, y(A) ? (_(A, j), w(A)) : (Wc(A), j.push(A));
  }
  function h(A, j, L, se) {
    for (var V, ee = A; ee.componentInstance; )
      if (ee = ee.componentInstance._vnode, me(V = ee.data) && me(V = V.transition)) {
        for (V = 0; V < r.activate.length; ++V)
          r.activate[V](Ia, ee);
        j.push(ee);
        break;
      }
    m(L, A.elm, se);
  }
  function m(A, j, L) {
    me(A) && (me(L) ? i.parentNode(L) === A && i.insertBefore(A, j, L) : i.appendChild(A, j));
  }
  function v(A, j, L) {
    if (mt(j)) {
      process.env.NODE_ENV !== "production" && k(j);
      for (var se = 0; se < j.length; ++se)
        d(j[se], L, A.elm, null, !0, j, se);
    } else qo(A.text) && i.appendChild(A.elm, i.createTextNode(String(A.text)));
  }
  function y(A) {
    for (; A.componentInstance; )
      A = A.componentInstance._vnode;
    return me(A.tag);
  }
  function _(A, j) {
    for (var L = 0; L < r.create.length; ++L)
      r.create[L](Ia, A);
    e = A.data.hook, me(e) && (me(e.create) && e.create(Ia, A), me(e.insert) && j.push(A));
  }
  function w(A) {
    var j;
    if (me(j = A.fnScopeId))
      i.setStyleScope(A.elm, j);
    else
      for (var L = A; L; )
        me(j = L.context) && me(j = j.$options._scopeId) && i.setStyleScope(A.elm, j), L = L.parent;
    me(j = Fl) && j !== A.context && j !== A.fnContext && me(j = j.$options._scopeId) && i.setStyleScope(A.elm, j);
  }
  function S(A, j, L, se, V, ee) {
    for (; se <= V; ++se)
      d(L[se], ee, A, j, !1, L, se);
  }
  function E(A) {
    var j, L, se = A.data;
    if (me(se))
      for (me(j = se.hook) && me(j = j.destroy) && j(A), j = 0; j < r.destroy.length; ++j)
        r.destroy[j](A);
    if (me(j = A.children))
      for (L = 0; L < A.children.length; ++L)
        E(A.children[L]);
  }
  function x(A, j, L) {
    for (; j <= L; ++j) {
      var se = A[j];
      me(se) && (me(se.tag) ? (T(se), E(se)) : l(se.elm));
    }
  }
  function T(A, j) {
    if (me(j) || me(A.data)) {
      var L, se = r.remove.length + 1;
      for (me(j) ? j.listeners += se : j = a(A.elm, se), me(L = A.componentInstance) && me(L = L._vnode) && me(L.data) && T(L, j), L = 0; L < r.remove.length; ++L)
        r.remove[L](A, j);
      me(L = A.data.hook) && me(L = L.remove) ? L(A, j) : j();
    } else
      l(A.elm);
  }
  function C(A, j, L, se, V) {
    var ee = 0, O = 0, K = j.length - 1, z = j[0], q = j[K], ae = L.length - 1, Ee = L[0], Ae = L[ae], Ue, qe, Qe, Lt, Yt = !V;
    for (process.env.NODE_ENV !== "production" && k(L); ee <= K && O <= ae; )
      ht(z) ? z = j[++ee] : ht(q) ? q = j[--K] : yl(z, Ee) ? (P(z, Ee, se, L, O), z = j[++ee], Ee = L[++O]) : yl(q, Ae) ? (P(q, Ae, se, L, ae), q = j[--K], Ae = L[--ae]) : yl(z, Ae) ? (P(z, Ae, se, L, ae), Yt && i.insertBefore(A, z.elm, i.nextSibling(q.elm)), z = j[++ee], Ae = L[--ae]) : yl(q, Ee) ? (P(q, Ee, se, L, O), Yt && i.insertBefore(A, q.elm, z.elm), q = j[--K], Ee = L[++O]) : (ht(Ue) && (Ue = yZ(j, ee, K)), qe = me(Ee.key) ? Ue[Ee.key] : b(Ee, j, ee, K), ht(qe) ? d(Ee, se, A, z.elm, !1, L, O) : (Qe = j[qe], yl(Qe, Ee) ? (P(Qe, Ee, se, L, O), j[qe] = void 0, Yt && i.insertBefore(A, Qe.elm, z.elm)) : d(Ee, se, A, z.elm, !1, L, O)), Ee = L[++O]);
    ee > K ? (Lt = ht(L[ae + 1]) ? null : L[ae + 1].elm, S(A, Lt, L, O, ae, se)) : O > ae && x(j, ee, K);
  }
  function k(A) {
    for (var j = {}, L = 0; L < A.length; L++) {
      var se = A[L], V = se.key;
      me(V) && (j[V] ? Te("Duplicate keys detected: '".concat(V, "'. This may cause an update error."), se.context) : j[V] = !0);
    }
  }
  function b(A, j, L, se) {
    for (var V = L; V < se; V++) {
      var ee = j[V];
      if (me(ee) && yl(A, ee))
        return V;
    }
  }
  function P(A, j, L, se, V, ee) {
    if (A !== j) {
      me(j.elm) && me(se) && (j = se[V] = n_(j));
      var O = j.elm = A.elm;
      if (Yn(A.isAsyncPlaceholder)) {
        me(j.asyncFactory.resolved) ? Y(A.elm, j, L) : j.isAsyncPlaceholder = !0;
        return;
      }
      if (Yn(j.isStatic) && Yn(A.isStatic) && j.key === A.key && (Yn(j.isCloned) || Yn(j.isOnce))) {
        j.componentInstance = A.componentInstance;
        return;
      }
      var K, z = j.data;
      me(z) && me(K = z.hook) && me(K = K.prepatch) && K(A, j);
      var q = A.children, ae = j.children;
      if (me(z) && y(j)) {
        for (K = 0; K < r.update.length; ++K)
          r.update[K](A, j);
        me(K = z.hook) && me(K = K.update) && K(A, j);
      }
      ht(j.text) ? me(q) && me(ae) ? q !== ae && C(O, q, ae, L, ee) : me(ae) ? (process.env.NODE_ENV !== "production" && k(ae), me(A.text) && i.setTextContent(O, ""), S(O, null, ae, 0, ae.length - 1, L)) : me(q) ? x(q, 0, q.length - 1) : me(A.text) && i.setTextContent(O, "") : A.text !== j.text && i.setTextContent(O, j.text), me(z) && me(K = z.hook) && me(K = K.postpatch) && K(A, j);
    }
  }
  function N(A, j, L) {
    if (Yn(L) && me(A.parent))
      A.parent.data.pendingInsert = j;
    else
      for (var se = 0; se < j.length; ++se)
        j[se].data.hook.insert(j[se]);
  }
  var D = !1, H = si("attrs,class,staticClass,staticStyle,key");
  function Y(A, j, L, se) {
    var V, ee = j.tag, O = j.data, K = j.children;
    if (se = se || O && O.pre, j.elm = A, Yn(j.isComment) && me(j.asyncFactory))
      return j.isAsyncPlaceholder = !0, !0;
    if (process.env.NODE_ENV !== "production" && !te(A, j, se))
      return !1;
    if (me(O) && (me(V = O.hook) && me(V = V.init) && V(
      j,
      !0
      /* hydrating */
    ), me(V = j.componentInstance)))
      return p(j, L), !0;
    if (me(ee)) {
      if (me(K))
        if (!A.hasChildNodes())
          v(j, K, L);
        else if (me(V = O) && me(V = V.domProps) && me(V = V.innerHTML)) {
          if (V !== A.innerHTML)
            return process.env.NODE_ENV !== "production" && typeof console < "u" && !D && (D = !0, console.warn("Parent: ", A), console.warn("server innerHTML: ", V), console.warn("client innerHTML: ", A.innerHTML)), !1;
        } else {
          for (var z = !0, q = A.firstChild, ae = 0; ae < K.length; ae++) {
            if (!q || !Y(q, K[ae], L, se)) {
              z = !1;
              break;
            }
            q = q.nextSibling;
          }
          if (!z || q)
            return process.env.NODE_ENV !== "production" && typeof console < "u" && !D && (D = !0, console.warn("Parent: ", A), console.warn("Mismatching childNodes vs. VNodes: ", A.childNodes, K)), !1;
        }
      if (me(O)) {
        var Ee = !1;
        for (var Ae in O)
          if (!H(Ae)) {
            Ee = !0, _(j, L);
            break;
          }
        !Ee && O.class && tu(O.class);
      }
    } else A.data !== j.text && (A.data = j.text);
    return !0;
  }
  function te(A, j, L) {
    return me(j.tag) ? j.tag.indexOf("vue-component") === 0 || !c(j, L) && j.tag.toLowerCase() === (A.tagName && A.tagName.toLowerCase()) : A.nodeType === (j.isComment ? 8 : 3);
  }
  return function(j, L, se, V) {
    if (ht(L)) {
      me(j) && E(j);
      return;
    }
    var ee = !1, O = [];
    if (ht(j))
      ee = !0, d(L, O);
    else {
      var K = me(j.nodeType);
      if (!K && yl(j, L))
        P(j, L, O, null, null, V);
      else {
        if (K) {
          if (j.nodeType === 1 && j.hasAttribute(ux) && (j.removeAttribute(ux), se = !0), Yn(se)) {
            if (Y(j, L, O))
              return N(L, O, !0), j;
            process.env.NODE_ENV !== "production" && Te("The client-side rendered virtual DOM tree is not matching server-rendered content. This is likely caused by incorrect HTML markup, for example nesting block-level elements inside <p>, or missing <tbody>. Bailing hydration and performing full client-side render.");
          }
          j = o(j);
        }
        var z = j.elm, q = i.parentNode(z);
        if (d(
          L,
          O,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          z._leaveCb ? null : q,
          i.nextSibling(z)
        ), me(L.parent))
          for (var ae = L.parent, Ee = y(L); ae; ) {
            for (var Ae = 0; Ae < r.destroy.length; ++Ae)
              r.destroy[Ae](ae);
            if (ae.elm = L.elm, Ee) {
              for (var Ue = 0; Ue < r.create.length; ++Ue)
                r.create[Ue](Ia, ae);
              var qe = ae.data.hook.insert;
              if (qe.merged)
                for (var Qe = qe.fns.slice(1), Lt = 0; Lt < Qe.length; Lt++)
                  Qe[Lt]();
            } else
              Wc(ae);
            ae = ae.parent;
          }
        me(q) ? x([j], 0, 0) : me(j.tag) && E(j);
      }
    }
    return N(L, O, ee), L.elm;
  };
}
var _Z = {
  create: ry,
  update: ry,
  destroy: function(e) {
    ry(e, Ia);
  }
};
function ry(t, e) {
  (t.data.directives || e.data.directives) && wZ(t, e);
}
function wZ(t, e) {
  var n = t === Ia, r = e === Ia, s = Gx(t.data.directives, t.context), i = Gx(e.data.directives, e.context), o = [], a = [], l, c, u;
  for (l in i)
    c = s[l], u = i[l], c ? (u.oldValue = c.value, u.oldArg = c.arg, nd(u, "update", e, t), u.def && u.def.componentUpdated && a.push(u)) : (nd(u, "bind", e, t), u.def && u.def.inserted && o.push(u));
  if (o.length) {
    var d = function() {
      for (var f = 0; f < o.length; f++)
        nd(o[f], "inserted", e, t);
    };
    n ? Sa(e, "insert", d) : d();
  }
  if (a.length && Sa(e, "postpatch", function() {
    for (var f = 0; f < a.length; f++)
      nd(a[f], "componentUpdated", e, t);
  }), !n)
    for (l in s)
      i[l] || nd(s[l], "unbind", t, t, r);
}
var SZ = /* @__PURE__ */ Object.create(null);
function Gx(t, e) {
  var n = /* @__PURE__ */ Object.create(null);
  if (!t)
    return n;
  var r, s;
  for (r = 0; r < t.length; r++) {
    if (s = t[r], s.modifiers || (s.modifiers = SZ), n[IZ(s)] = s, e._setupState && e._setupState.__sfc) {
      var i = s.def || qh(e, "_setupState", "v-" + s.name);
      typeof i == "function" ? s.def = {
        bind: i,
        update: i
      } : s.def = i;
    }
    s.def = s.def || qh(e.$options, "directives", s.name, !0);
  }
  return n;
}
function IZ(t) {
  return t.rawName || "".concat(t.name, ".").concat(Object.keys(t.modifiers || {}).join("."));
}
function nd(t, e, n, r, s) {
  var i = t.def && t.def[e];
  if (i)
    try {
      i(n.elm, t, n, r, s);
    } catch (o) {
      Ha(o, n.context, "directive ".concat(t.name, " ").concat(e, " hook"));
    }
}
var EZ = [vZ, _Z];
function Yx(t, e) {
  var n = e.componentOptions;
  if (!(me(n) && n.Ctor.options.inheritAttrs === !1) && !(ht(t.data.attrs) && ht(e.data.attrs))) {
    var r, s, i, o = e.elm, a = t.data.attrs || {}, l = e.data.attrs || {};
    (me(l.__ob__) || Yn(l._v_attr_proxy)) && (l = e.data.attrs = $n({}, l));
    for (r in l)
      s = l[r], i = a[r], i !== s && Zx(o, r, s, e.data.pre);
    (hu || CO) && l.value !== a.value && Zx(o, "value", l.value);
    for (r in a)
      ht(l[r]) && (qw(r) ? o.removeAttributeNS(f_, pM(r)) : fM(r) || o.removeAttribute(r));
  }
}
function Zx(t, e, n, r) {
  r || t.tagName.indexOf("-") > -1 ? Xx(t, e, n) : YY(e) ? em(n) ? t.removeAttribute(e) : (n = e === "allowfullscreen" && t.tagName === "EMBED" ? "true" : e, t.setAttribute(e, n)) : fM(e) ? t.setAttribute(e, GY(e, n)) : qw(e) ? em(n) ? t.removeAttributeNS(f_, pM(e)) : t.setAttributeNS(f_, e, n) : Xx(t, e, n);
}
function Xx(t, e, n) {
  if (em(n))
    t.removeAttribute(e);
  else {
    if (hu && !mu && t.tagName === "TEXTAREA" && e === "placeholder" && n !== "" && !t.__ieph) {
      var r = function(s) {
        s.stopImmediatePropagation(), t.removeEventListener("input", r);
      };
      t.addEventListener("input", r), t.__ieph = !0;
    }
    t.setAttribute(e, n);
  }
}
var xZ = {
  create: Yx,
  update: Yx
};
function Kx(t, e) {
  var n = e.elm, r = e.data, s = t.data;
  if (!(ht(r.staticClass) && ht(r.class) && (ht(s) || ht(s.staticClass) && ht(s.class)))) {
    var i = ZY(e), o = n._transitionClasses;
    me(o) && (i = Qw(i, eS(o))), i !== n._prevClass && (n.setAttribute("class", i), n._prevClass = i);
  }
}
var CZ = {
  create: Kx,
  update: Kx
}, sy = "__r", iy = "__c";
function TZ(t) {
  if (me(t[sy])) {
    var e = hu ? "change" : "input";
    t[e] = [].concat(t[sy], t[e] || []), delete t[sy];
  }
  me(t[iy]) && (t.change = [].concat(t[iy], t.change || []), delete t[iy]);
}
var cf;
function PZ(t, e, n) {
  var r = cf;
  return function s() {
    var i = e.apply(null, arguments);
    i !== null && mM(t, s, n, r);
  };
}
var kZ = s_ && !(dx && Number(dx[1]) <= 53);
function NZ(t, e, n, r) {
  if (kZ) {
    var s = oM, i = e;
    e = i._wrapper = function(o) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        o.target === o.currentTarget || // event is fired after handler attachment
        o.timeStamp >= s || // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        o.timeStamp <= 0 || // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        o.target.ownerDocument !== document
      )
        return i.apply(this, arguments);
    };
  }
  cf.addEventListener(t, e, TO ? { capture: n, passive: r } : n);
}
function mM(t, e, n, r) {
  (r || cf).removeEventListener(
    t,
    //@ts-expect-error
    e._wrapper || e,
    n
  );
}
function oy(t, e) {
  if (!(ht(t.data.on) && ht(e.data.on))) {
    var n = e.data.on || {}, r = t.data.on || {};
    cf = e.elm || t.elm, TZ(n), WO(n, r, NZ, mM, PZ, e.context), cf = void 0;
  }
}
var $Z = {
  create: oy,
  update: oy,
  // @ts-expect-error emptyNode has actually data
  destroy: function(t) {
    return oy(t, Ia);
  }
}, yp;
function Jx(t, e) {
  if (!(ht(t.data.domProps) && ht(e.data.domProps))) {
    var n, r, s = e.elm, i = t.data.domProps || {}, o = e.data.domProps || {};
    (me(o.__ob__) || Yn(o._v_attr_proxy)) && (o = e.data.domProps = $n({}, o));
    for (n in i)
      n in o || (s[n] = "");
    for (n in o) {
      if (r = o[n], n === "textContent" || n === "innerHTML") {
        if (e.children && (e.children.length = 0), r === i[n])
          continue;
        s.childNodes.length === 1 && s.removeChild(s.childNodes[0]);
      }
      if (n === "value" && s.tagName !== "PROGRESS") {
        s._value = r;
        var a = ht(r) ? "" : String(r);
        DZ(s, a) && (s.value = a);
      } else if (n === "innerHTML" && tS(s.tagName) && ht(s.innerHTML)) {
        yp = yp || document.createElement("div"), yp.innerHTML = "<svg>".concat(r, "</svg>");
        for (var l = yp.firstChild; s.firstChild; )
          s.removeChild(s.firstChild);
        for (; l.firstChild; )
          s.appendChild(l.firstChild);
      } else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        r !== i[n]
      )
        try {
          s[n] = r;
        } catch {
        }
    }
  }
}
function DZ(t, e) {
  return (
    //@ts-expect-error
    !t.composing && (t.tagName === "OPTION" || AZ(t, e) || OZ(t, e))
  );
}
function AZ(t, e) {
  var n = !0;
  try {
    n = document.activeElement !== t;
  } catch {
  }
  return n && t.value !== e;
}
function OZ(t, e) {
  var n = t.value, r = t._vModifiers;
  if (me(r)) {
    if (r.number)
      return ef(n) !== ef(e);
    if (r.trim)
      return n.trim() !== e.trim();
  }
  return n !== e;
}
var MZ = {
  create: Jx,
  update: Jx
}, RZ = Jl(function(t) {
  var e = {}, n = /;(?![^(]*\))/g, r = /:(.+)/;
  return t.split(n).forEach(function(s) {
    if (s) {
      var i = s.split(r);
      i.length > 1 && (e[i[0].trim()] = i[1].trim());
    }
  }), e;
});
function ay(t) {
  var e = vM(t.style);
  return t.staticStyle ? $n(t.staticStyle, e) : e;
}
function vM(t) {
  return Array.isArray(t) ? wO(t) : typeof t == "string" ? RZ(t) : t;
}
function LZ(t, e) {
  for (var n = {}, r, s = t; s.componentInstance; )
    s = s.componentInstance._vnode, s && s.data && (r = ay(s.data)) && $n(n, r);
  (r = ay(t.data)) && $n(n, r);
  for (var i = t; i = i.parent; )
    i.data && (r = ay(i.data)) && $n(n, r);
  return n;
}
var FZ = /^--/, qx = /\s*!important$/, Qx = function(t, e, n) {
  if (FZ.test(e))
    t.style.setProperty(e, n);
  else if (qx.test(n))
    t.style.setProperty(ql(e), n.replace(qx, ""), "important");
  else {
    var r = BZ(e);
    if (Array.isArray(n))
      for (var s = 0, i = n.length; s < i; s++)
        t.style[r] = n[s];
    else
      t.style[r] = n;
  }
}, eC = ["Webkit", "Moz", "ms"], bp, BZ = Jl(function(t) {
  if (bp = bp || document.createElement("div").style, t = zl(t), t !== "filter" && t in bp)
    return t;
  for (var e = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < eC.length; n++) {
    var r = eC[n] + e;
    if (r in bp)
      return r;
  }
});
function tC(t, e) {
  var n = e.data, r = t.data;
  if (!(ht(n.staticStyle) && ht(n.style) && ht(r.staticStyle) && ht(r.style))) {
    var s, i, o = e.elm, a = r.staticStyle, l = r.normalizedStyle || r.style || {}, c = a || l, u = vM(e.data.style) || {};
    e.data.normalizedStyle = me(u.__ob__) ? $n({}, u) : u;
    var d = LZ(e);
    for (i in c)
      ht(d[i]) && Qx(o, i, "");
    for (i in d)
      s = d[i], Qx(o, i, s ?? "");
  }
}
var jZ = {
  create: tC,
  update: tC
}, gM = /\s+/;
function yM(t, e) {
  if (!(!e || !(e = e.trim())))
    if (t.classList)
      e.indexOf(" ") > -1 ? e.split(gM).forEach(function(r) {
        return t.classList.add(r);
      }) : t.classList.add(e);
    else {
      var n = " ".concat(t.getAttribute("class") || "", " ");
      n.indexOf(" " + e + " ") < 0 && t.setAttribute("class", (n + e).trim());
    }
}
function bM(t, e) {
  if (!(!e || !(e = e.trim())))
    if (t.classList)
      e.indexOf(" ") > -1 ? e.split(gM).forEach(function(s) {
        return t.classList.remove(s);
      }) : t.classList.remove(e), t.classList.length || t.removeAttribute("class");
    else {
      for (var n = " ".concat(t.getAttribute("class") || "", " "), r = " " + e + " "; n.indexOf(r) >= 0; )
        n = n.replace(r, " ");
      n = n.trim(), n ? t.setAttribute("class", n) : t.removeAttribute("class");
    }
}
function _M(t) {
  if (t) {
    if (typeof t == "object") {
      var e = {};
      return t.css !== !1 && $n(e, nC(t.name || "v")), $n(e, t), e;
    } else if (typeof t == "string")
      return nC(t);
  }
}
var nC = Jl(function(t) {
  return {
    enterClass: "".concat(t, "-enter"),
    enterToClass: "".concat(t, "-enter-to"),
    enterActiveClass: "".concat(t, "-enter-active"),
    leaveClass: "".concat(t, "-leave"),
    leaveToClass: "".concat(t, "-leave-to"),
    leaveActiveClass: "".concat(t, "-leave-active")
  };
}), wM = Os && !mu, Oc = "transition", ly = "animation", th = "transition", tm = "transitionend", h_ = "animation", SM = "animationend";
wM && (window.ontransitionend === void 0 && window.onwebkittransitionend !== void 0 && (th = "WebkitTransition", tm = "webkitTransitionEnd"), window.onanimationend === void 0 && window.onwebkitanimationend !== void 0 && (h_ = "WebkitAnimation", SM = "webkitAnimationEnd"));
var rC = Os ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : (
  /* istanbul ignore next */
  function(t) {
    return t();
  }
);
function IM(t) {
  rC(function() {
    rC(t);
  });
}
function Bl(t, e) {
  var n = t._transitionClasses || (t._transitionClasses = []);
  n.indexOf(e) < 0 && (n.push(e), yM(t, e));
}
function jo(t, e) {
  t._transitionClasses && Xa(t._transitionClasses, e), bM(t, e);
}
function EM(t, e, n) {
  var r = xM(t, e), s = r.type, i = r.timeout, o = r.propCount;
  if (!s)
    return n();
  var a = s === Oc ? tm : SM, l = 0, c = function() {
    t.removeEventListener(a, u), n();
  }, u = function(d) {
    d.target === t && ++l >= o && c();
  };
  setTimeout(function() {
    l < o && c();
  }, i + 1), t.addEventListener(a, u);
}
var WZ = /\b(transform|all)(,|$)/;
function xM(t, e) {
  var n = window.getComputedStyle(t), r = (n[th + "Delay"] || "").split(", "), s = (n[th + "Duration"] || "").split(", "), i = sC(r, s), o = (n[h_ + "Delay"] || "").split(", "), a = (n[h_ + "Duration"] || "").split(", "), l = sC(o, a), c, u = 0, d = 0;
  e === Oc ? i > 0 && (c = Oc, u = i, d = s.length) : e === ly ? l > 0 && (c = ly, u = l, d = a.length) : (u = Math.max(i, l), c = u > 0 ? i > l ? Oc : ly : null, d = c ? c === Oc ? s.length : a.length : 0);
  var f = c === Oc && WZ.test(n[th + "Property"]);
  return {
    type: c,
    timeout: u,
    propCount: d,
    hasTransform: f
  };
}
function sC(t, e) {
  for (; t.length < e.length; )
    t = t.concat(t);
  return Math.max.apply(null, e.map(function(n, r) {
    return iC(n) + iC(t[r]);
  }));
}
function iC(t) {
  return Number(t.slice(0, -1).replace(",", ".")) * 1e3;
}
function m_(t, e) {
  var n = t.elm;
  me(n._leaveCb) && (n._leaveCb.cancelled = !0, n._leaveCb());
  var r = _M(t.data.transition);
  if (!ht(r) && !(me(n._enterCb) || n.nodeType !== 1)) {
    for (var s = r.css, i = r.type, o = r.enterClass, a = r.enterToClass, l = r.enterActiveClass, c = r.appearClass, u = r.appearToClass, d = r.appearActiveClass, f = r.beforeEnter, p = r.enter, h = r.afterEnter, m = r.enterCancelled, v = r.beforeAppear, y = r.appear, _ = r.afterAppear, w = r.appearCancelled, S = r.duration, E = Fl, x = Fl.$vnode; x && x.parent; )
      E = x.context, x = x.parent;
    var T = !E._isMounted || !t.isRootInsert;
    if (!(T && !y && y !== "")) {
      var C = T && c ? c : o, k = T && d ? d : l, b = T && u ? u : a, P = T && v || f, N = T && an(y) ? y : p, D = T && _ || h, H = T && w || m, Y = ef(Mr(S) ? S.enter : S);
      process.env.NODE_ENV !== "production" && Y != null && TM(Y, "enter", t);
      var te = s !== !1 && !mu, A = nS(N), j = n._enterCb = Uh(function() {
        te && (jo(n, b), jo(n, k)), j.cancelled ? (te && jo(n, C), H && H(n)) : D && D(n), n._enterCb = null;
      });
      t.data.show || Sa(t, "insert", function() {
        var L = n.parentNode, se = L && L._pending && L._pending[t.key];
        se && se.tag === t.tag && se.elm._leaveCb && se.elm._leaveCb(), N && N(n, j);
      }), P && P(n), te && (Bl(n, C), Bl(n, k), IM(function() {
        jo(n, C), j.cancelled || (Bl(n, b), A || (PM(Y) ? setTimeout(j, Y) : EM(n, i, j)));
      })), t.data.show && (e && e(), N && N(n, j)), !te && !A && j();
    }
  }
}
function CM(t, e) {
  var n = t.elm;
  me(n._enterCb) && (n._enterCb.cancelled = !0, n._enterCb());
  var r = _M(t.data.transition);
  if (ht(r) || n.nodeType !== 1)
    return e();
  if (me(n._leaveCb))
    return;
  var s = r.css, i = r.type, o = r.leaveClass, a = r.leaveToClass, l = r.leaveActiveClass, c = r.beforeLeave, u = r.leave, d = r.afterLeave, f = r.leaveCancelled, p = r.delayLeave, h = r.duration, m = s !== !1 && !mu, v = nS(u), y = ef(Mr(h) ? h.leave : h);
  process.env.NODE_ENV !== "production" && me(y) && TM(y, "leave", t);
  var _ = n._leaveCb = Uh(function() {
    n.parentNode && n.parentNode._pending && (n.parentNode._pending[t.key] = null), m && (jo(n, a), jo(n, l)), _.cancelled ? (m && jo(n, o), f && f(n)) : (e(), d && d(n)), n._leaveCb = null;
  });
  p ? p(w) : w();
  function w() {
    _.cancelled || (!t.data.show && n.parentNode && ((n.parentNode._pending || (n.parentNode._pending = {}))[t.key] = t), c && c(n), m && (Bl(n, o), Bl(n, l), IM(function() {
      jo(n, o), _.cancelled || (Bl(n, a), v || (PM(y) ? setTimeout(_, y) : EM(n, i, _)));
    })), u && u(n, _), !m && !v && _());
  }
}
function TM(t, e, n) {
  typeof t != "number" ? Te("<transition> explicit ".concat(e, " duration is not a valid number - ") + "got ".concat(JSON.stringify(t), "."), n.context) : isNaN(t) && Te("<transition> explicit ".concat(e, " duration is NaN - ") + "the duration expression might be incorrect.", n.context);
}
function PM(t) {
  return typeof t == "number" && !isNaN(t);
}
function nS(t) {
  if (ht(t))
    return !1;
  var e = t.fns;
  return me(e) ? nS(Array.isArray(e) ? e[0] : e) : (t._length || t.length) > 1;
}
function oC(t, e) {
  e.data.show !== !0 && m_(e);
}
var HZ = Os ? {
  create: oC,
  activate: oC,
  remove: function(t, e) {
    t.data.show !== !0 ? CM(t, e) : e();
  }
} : {}, VZ = [xZ, CZ, $Z, MZ, jZ, HZ], zZ = VZ.concat(EZ), UZ = bZ({ nodeOps: mZ, modules: zZ });
mu && document.addEventListener("selectionchange", function() {
  var t = document.activeElement;
  t && t.vmodel && rS(t, "input");
});
var kM = {
  inserted: function(t, e, n, r) {
    n.tag === "select" ? (r.elm && !r.elm._vOptions ? Sa(n, "postpatch", function() {
      kM.componentUpdated(t, e, n);
    }) : aC(t, e, n.context), t._vOptions = [].map.call(t.options, nm)) : (n.tag === "textarea" || p_(t.type)) && (t._vModifiers = e.modifiers, e.modifiers.lazy || (t.addEventListener("compositionstart", GZ), t.addEventListener("compositionend", uC), t.addEventListener("change", uC), mu && (t.vmodel = !0)));
  },
  componentUpdated: function(t, e, n) {
    if (n.tag === "select") {
      aC(t, e, n.context);
      var r = t._vOptions, s = t._vOptions = [].map.call(t.options, nm);
      if (s.some(function(o, a) {
        return !Ul(o, r[a]);
      })) {
        var i = t.multiple ? e.value.some(function(o) {
          return cC(o, s);
        }) : e.value !== e.oldValue && cC(e.value, s);
        i && rS(t, "change");
      }
    }
  }
};
function aC(t, e, n) {
  lC(t, e, n), (hu || CO) && setTimeout(function() {
    lC(t, e, n);
  }, 0);
}
function lC(t, e, n) {
  var r = e.value, s = t.multiple;
  if (s && !Array.isArray(r)) {
    process.env.NODE_ENV !== "production" && Te('<select multiple v-model="'.concat(e.expression, '"> ') + "expects an Array value for its binding, but got ".concat(Object.prototype.toString.call(r).slice(8, -1)), n);
    return;
  }
  for (var i, o, a = 0, l = t.options.length; a < l; a++)
    if (o = t.options[a], s)
      i = IO(r, nm(o)) > -1, o.selected !== i && (o.selected = i);
    else if (Ul(nm(o), r)) {
      t.selectedIndex !== a && (t.selectedIndex = a);
      return;
    }
  s || (t.selectedIndex = -1);
}
function cC(t, e) {
  return e.every(function(n) {
    return !Ul(n, t);
  });
}
function nm(t) {
  return "_value" in t ? t._value : t.value;
}
function GZ(t) {
  t.target.composing = !0;
}
function uC(t) {
  t.target.composing && (t.target.composing = !1, rS(t.target, "input"));
}
function rS(t, e) {
  var n = document.createEvent("HTMLEvents");
  n.initEvent(e, !0, !0), t.dispatchEvent(n);
}
function v_(t) {
  return t.componentInstance && (!t.data || !t.data.transition) ? v_(t.componentInstance._vnode) : t;
}
var YZ = {
  bind: function(t, e, n) {
    var r = e.value;
    n = v_(n);
    var s = n.data && n.data.transition, i = t.__vOriginalDisplay = t.style.display === "none" ? "" : t.style.display;
    r && s ? (n.data.show = !0, m_(n, function() {
      t.style.display = i;
    })) : t.style.display = r ? i : "none";
  },
  update: function(t, e, n) {
    var r = e.value, s = e.oldValue;
    if (!r != !s) {
      n = v_(n);
      var i = n.data && n.data.transition;
      i ? (n.data.show = !0, r ? m_(n, function() {
        t.style.display = t.__vOriginalDisplay;
      }) : CM(n, function() {
        t.style.display = "none";
      })) : t.style.display = r ? t.__vOriginalDisplay : "none";
    }
  },
  unbind: function(t, e, n, r, s) {
    s || (t.style.display = t.__vOriginalDisplay);
  }
}, ZZ = {
  model: kM,
  show: YZ
}, NM = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};
function g_(t) {
  var e = t && t.componentOptions;
  return e && e.Ctor.options.abstract ? g_(ZO(e.children)) : t;
}
function $M(t) {
  var e = {}, n = t.$options;
  for (var r in n.propsData)
    e[r] = t[r];
  var s = n._parentListeners;
  for (var r in s)
    e[zl(r)] = s[r];
  return e;
}
function dC(t, e) {
  if (/\d-keep-alive$/.test(e.tag))
    return t("keep-alive", {
      props: e.componentOptions.propsData
    });
}
function XZ(t) {
  for (; t = t.parent; )
    if (t.data.transition)
      return !0;
}
function KZ(t, e) {
  return e.key === t.key && e.tag === t.tag;
}
var JZ = function(t) {
  return t.tag || nf(t);
}, qZ = function(t) {
  return t.name === "show";
}, QZ = {
  name: "transition",
  props: NM,
  abstract: !0,
  render: function(t) {
    var e = this, n = this.$slots.default;
    if (n && (n = n.filter(JZ), !!n.length)) {
      process.env.NODE_ENV !== "production" && n.length > 1 && Te("<transition> can only be used on a single element. Use <transition-group> for lists.", this.$parent);
      var r = this.mode;
      process.env.NODE_ENV !== "production" && r && r !== "in-out" && r !== "out-in" && Te("invalid <transition> mode: " + r, this.$parent);
      var s = n[0];
      if (XZ(this.$vnode))
        return s;
      var i = g_(s);
      if (!i)
        return s;
      if (this._leaving)
        return dC(t, s);
      var o = "__transition-".concat(this._uid, "-");
      i.key = i.key == null ? i.isComment ? o + "comment" : o + i.tag : qo(i.key) ? String(i.key).indexOf(o) === 0 ? i.key : o + i.key : i.key;
      var a = (i.data || (i.data = {})).transition = $M(this), l = this._vnode, c = g_(l);
      if (i.data.directives && i.data.directives.some(qZ) && (i.data.show = !0), c && c.data && !KZ(i, c) && !nf(c) && // #6687 component root is a comment node
      !(c.componentInstance && c.componentInstance._vnode.isComment)) {
        var u = c.data.transition = $n({}, a);
        if (r === "out-in")
          return this._leaving = !0, Sa(u, "afterLeave", function() {
            e._leaving = !1, e.$forceUpdate();
          }), dC(t, s);
        if (r === "in-out") {
          if (nf(i))
            return l;
          var d, f = function() {
            d();
          };
          Sa(a, "afterEnter", f), Sa(a, "enterCancelled", f), Sa(u, "delayLeave", function(p) {
            d = p;
          });
        }
      }
      return s;
    }
  }
}, DM = $n({
  tag: String,
  moveClass: String
}, NM);
delete DM.mode;
var eX = {
  props: DM,
  beforeMount: function() {
    var t = this, e = this._update;
    this._update = function(n, r) {
      var s = rM(t);
      t.__patch__(
        t._vnode,
        t.kept,
        !1,
        // hydrating
        !0
        // removeOnly (!important, avoids unnecessary moves)
      ), t._vnode = t.kept, s(), e.call(t, n, r);
    };
  },
  render: function(t) {
    for (var e = this.tag || this.$vnode.data.tag || "span", n = /* @__PURE__ */ Object.create(null), r = this.prevChildren = this.children, s = this.$slots.default || [], i = this.children = [], o = $M(this), a = 0; a < s.length; a++) {
      var l = s[a];
      if (l.tag) {
        if (l.key != null && String(l.key).indexOf("__vlist") !== 0)
          i.push(l), n[l.key] = l, (l.data || (l.data = {})).transition = o;
        else if (process.env.NODE_ENV !== "production") {
          var c = l.componentOptions, u = c ? nu(c.Ctor.options) || c.tag || "" : l.tag;
          Te("<transition-group> children must be keyed: <".concat(u, ">"));
        }
      }
    }
    if (r) {
      for (var d = [], f = [], a = 0; a < r.length; a++) {
        var l = r[a];
        l.data.transition = o, l.data.pos = l.elm.getBoundingClientRect(), n[l.key] ? d.push(l) : f.push(l);
      }
      this.kept = t(e, null, d), this.removed = f;
    }
    return t(e, null, i);
  },
  updated: function() {
    var t = this.prevChildren, e = this.moveClass || (this.name || "v") + "-move";
    !t.length || !this.hasMove(t[0].elm, e) || (t.forEach(tX), t.forEach(nX), t.forEach(rX), this._reflow = document.body.offsetHeight, t.forEach(function(n) {
      if (n.data.moved) {
        var r = n.elm, s = r.style;
        Bl(r, e), s.transform = s.WebkitTransform = s.transitionDuration = "", r.addEventListener(tm, r._moveCb = function i(o) {
          o && o.target !== r || (!o || /transform$/.test(o.propertyName)) && (r.removeEventListener(tm, i), r._moveCb = null, jo(r, e));
        });
      }
    }));
  },
  methods: {
    hasMove: function(t, e) {
      if (!wM)
        return !1;
      if (this._hasMove)
        return this._hasMove;
      var n = t.cloneNode();
      t._transitionClasses && t._transitionClasses.forEach(function(s) {
        bM(n, s);
      }), yM(n, e), n.style.display = "none", this.$el.appendChild(n);
      var r = xM(n);
      return this.$el.removeChild(n), this._hasMove = r.hasTransform;
    }
  }
};
function tX(t) {
  t.elm._moveCb && t.elm._moveCb(), t.elm._enterCb && t.elm._enterCb();
}
function nX(t) {
  t.data.newPos = t.elm.getBoundingClientRect();
}
function rX(t) {
  var e = t.data.pos, n = t.data.newPos, r = e.left - n.left, s = e.top - n.top;
  if (r || s) {
    t.data.moved = !0;
    var i = t.elm.style;
    i.transform = i.WebkitTransform = "translate(".concat(r, "px,").concat(s, "px)"), i.transitionDuration = "0s";
  }
}
var sX = {
  Transition: QZ,
  TransitionGroup: eX
};
U.config.mustUseProp = zY;
U.config.isReservedTag = hM;
U.config.isReservedAttr = HY;
U.config.getTagNamespace = eZ;
U.config.isUnknownElement = tZ;
$n(U.options.directives, ZZ);
$n(U.options.components, sX);
U.prototype.__patch__ = Os ? UZ : Nn;
U.prototype.$mount = function(t, e) {
  return t = t && Os ? nZ(t) : void 0, FG(this, t, e);
};
Os && setTimeout(function() {
  vn.devtools && (Gh ? Gh.emit("init", U) : process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && console[console.info ? "info" : "log"](`Download the Vue Devtools extension for a better development experience:
https://github.com/vuejs/vue-devtools`)), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && vn.productionTip !== !1 && typeof console < "u" && console[console.info ? "info" : "log"](`You are running Vue in development mode.
Make sure to turn on production mode when deploying for production.
See more tips at https://vuejs.org/guide/deployment.html`);
}, 0);
const iX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EffectScope: Lw,
  computed: le,
  customRef: kU,
  default: U,
  defineAsyncComponent: gG,
  defineComponent: kG,
  del: Dw,
  effectScope: RU,
  getCurrentInstance: bU,
  getCurrentScope: FO,
  h: JO,
  inject: Jt,
  isProxy: EU,
  isReactive: Ta,
  isReadonly: Ql,
  isRef: Jr,
  isShallow: Zh,
  markRaw: xU,
  mergeDefaults: oG,
  nextTick: Ar,
  onActivated: SG,
  onBeforeMount: _G,
  onBeforeUnmount: Nf,
  onBeforeUpdate: QO,
  onDeactivated: IG,
  onErrorCaptured: PG,
  onMounted: Io,
  onRenderTracked: xG,
  onRenderTriggered: CG,
  onScopeDispose: FU,
  onServerPrefetch: EG,
  onUnmounted: wG,
  onUpdated: eM,
  provide: BO,
  proxyRefs: PU,
  reactive: Xn,
  readonly: MO,
  ref: et,
  set: cv,
  shallowReactive: Aw,
  shallowReadonly: AU,
  shallowRef: CU,
  toRaw: DO,
  toRef: Mw,
  toRefs: ts,
  triggerRef: TU,
  unref: Ow,
  useAttrs: sG,
  useCssModule: qO,
  useCssVars: vG,
  useListeners: iG,
  useSlots: rG,
  version: tM,
  watch: or,
  watchEffect: Rw,
  watchPostEffect: LO,
  watchSyncEffect: MU
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
function Yl(t, e) {
  if (!t)
    throw new Error("[vue-router] " + e);
}
function ar(t, e) {
  t || typeof console < "u" && console.warn("[vue-router] " + e);
}
function Fi(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}
var oX = /[!'()*]/g, aX = function(t) {
  return "%" + t.charCodeAt(0).toString(16);
}, lX = /%2C/g, wc = function(t) {
  return encodeURIComponent(t).replace(oX, aX).replace(lX, ",");
};
function y_(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    process.env.NODE_ENV !== "production" && ar(!1, 'Error decoding "' + t + '". Leaving it intact.');
  }
  return t;
}
function cX(t, e, n) {
  e === void 0 && (e = {});
  var r = n || uX, s;
  try {
    s = r(t || "");
  } catch (a) {
    process.env.NODE_ENV !== "production" && ar(!1, a.message), s = {};
  }
  for (var i in e) {
    var o = e[i];
    s[i] = Array.isArray(o) ? o.map(fC) : fC(o);
  }
  return s;
}
var fC = function(t) {
  return t == null || typeof t == "object" ? t : String(t);
};
function uX(t) {
  var e = {};
  return t = t.trim().replace(/^(\?|#|&)/, ""), t && t.split("&").forEach(function(n) {
    var r = n.replace(/\+/g, " ").split("="), s = y_(r.shift()), i = r.length > 0 ? y_(r.join("=")) : null;
    e[s] === void 0 ? e[s] = i : Array.isArray(e[s]) ? e[s].push(i) : e[s] = [e[s], i];
  }), e;
}
function dX(t) {
  var e = t ? Object.keys(t).map(function(n) {
    var r = t[n];
    if (r === void 0)
      return "";
    if (r === null)
      return wc(n);
    if (Array.isArray(r)) {
      var s = [];
      return r.forEach(function(i) {
        i !== void 0 && (i === null ? s.push(wc(n)) : s.push(wc(n) + "=" + wc(i)));
      }), s.join("&");
    }
    return wc(n) + "=" + wc(r);
  }).filter(function(n) {
    return n.length > 0;
  }).join("&") : null;
  return e ? "?" + e : "";
}
var rm = /\/?$/;
function sm(t, e, n, r) {
  var s = r && r.options.stringifyQuery, i = e.query || {};
  try {
    i = b_(i);
  } catch {
  }
  var o = {
    name: e.name || t && t.name,
    meta: t && t.meta || {},
    path: e.path || "/",
    hash: e.hash || "",
    query: i,
    params: e.params || {},
    fullPath: pC(e, s),
    matched: t ? fX(t) : []
  };
  return n && (o.redirectedFrom = pC(n, s)), Object.freeze(o);
}
function b_(t) {
  if (Array.isArray(t))
    return t.map(b_);
  if (t && typeof t == "object") {
    var e = {};
    for (var n in t)
      e[n] = b_(t[n]);
    return e;
  } else
    return t;
}
var Ja = sm(null, {
  path: "/"
});
function fX(t) {
  for (var e = []; t; )
    e.unshift(t), t = t.parent;
  return e;
}
function pC(t, e) {
  var n = t.path, r = t.query;
  r === void 0 && (r = {});
  var s = t.hash;
  s === void 0 && (s = "");
  var i = e || dX;
  return (n || "/") + i(r) + s;
}
function AM(t, e, n) {
  return e === Ja ? t === e : e ? t.path && e.path ? t.path.replace(rm, "") === e.path.replace(rm, "") && (n || t.hash === e.hash && nh(t.query, e.query)) : t.name && e.name ? t.name === e.name && (n || t.hash === e.hash && nh(t.query, e.query) && nh(t.params, e.params)) : !1 : !1;
}
function nh(t, e) {
  if (t === void 0 && (t = {}), e === void 0 && (e = {}), !t || !e)
    return t === e;
  var n = Object.keys(t).sort(), r = Object.keys(e).sort();
  return n.length !== r.length ? !1 : n.every(function(s, i) {
    var o = t[s], a = r[i];
    if (a !== s)
      return !1;
    var l = e[s];
    return o == null || l == null ? o === l : typeof o == "object" && typeof l == "object" ? nh(o, l) : String(o) === String(l);
  });
}
function pX(t, e) {
  return t.path.replace(rm, "/").indexOf(
    e.path.replace(rm, "/")
  ) === 0 && (!e.hash || t.hash === e.hash) && hX(t.query, e.query);
}
function hX(t, e) {
  for (var n in e)
    if (!(n in t))
      return !1;
  return !0;
}
function OM(t) {
  for (var e = 0; e < t.matched.length; e++) {
    var n = t.matched[e];
    for (var r in n.instances) {
      var s = n.instances[r], i = n.enteredCbs[r];
      if (!(!s || !i)) {
        delete n.enteredCbs[r];
        for (var o = 0; o < i.length; o++)
          s._isBeingDestroyed || i[o](s);
      }
    }
  }
}
var mX = {
  name: "RouterView",
  functional: !0,
  props: {
    name: {
      type: String,
      default: "default"
    }
  },
  render: function(e, n) {
    var r = n.props, s = n.children, i = n.parent, o = n.data;
    o.routerView = !0;
    for (var a = i.$createElement, l = r.name, c = i.$route, u = i._routerViewCache || (i._routerViewCache = {}), d = 0, f = !1; i && i._routerRoot !== i; ) {
      var p = i.$vnode ? i.$vnode.data : {};
      p.routerView && d++, p.keepAlive && i._directInactive && i._inactive && (f = !0), i = i.$parent;
    }
    if (o.routerViewDepth = d, f) {
      var h = u[l], m = h && h.component;
      return m ? (h.configProps && hC(m, o, h.route, h.configProps), a(m, o, s)) : a();
    }
    var v = c.matched[d], y = v && v.components[l];
    if (!v || !y)
      return u[l] = null, a();
    u[l] = { component: y }, o.registerRouteInstance = function(w, S) {
      var E = v.instances[l];
      (S && E !== w || !S && E === w) && (v.instances[l] = S);
    }, (o.hook || (o.hook = {})).prepatch = function(w, S) {
      v.instances[l] = S.componentInstance;
    }, o.hook.init = function(w) {
      w.data.keepAlive && w.componentInstance && w.componentInstance !== v.instances[l] && (v.instances[l] = w.componentInstance), OM(c);
    };
    var _ = v.props && v.props[l];
    return _ && (Fi(u[l], {
      route: c,
      configProps: _
    }), hC(y, o, c, _)), a(y, o, s);
  }
};
function hC(t, e, n, r) {
  var s = e.props = vX(n, r);
  if (s) {
    s = e.props = Fi({}, s);
    var i = e.attrs = e.attrs || {};
    for (var o in s)
      (!t.props || !(o in t.props)) && (i[o] = s[o], delete s[o]);
  }
}
function vX(t, e) {
  switch (typeof e) {
    case "undefined":
      return;
    case "object":
      return e;
    case "function":
      return e(t);
    case "boolean":
      return e ? t.params : void 0;
    default:
      process.env.NODE_ENV !== "production" && ar(
        !1,
        'props in "' + t.path + '" is a ' + typeof e + ", expecting an object, function or boolean."
      );
  }
}
function MM(t, e, n) {
  var r = t.charAt(0);
  if (r === "/")
    return t;
  if (r === "?" || r === "#")
    return e + t;
  var s = e.split("/");
  (!n || !s[s.length - 1]) && s.pop();
  for (var i = t.replace(/^\//, "").split("/"), o = 0; o < i.length; o++) {
    var a = i[o];
    a === ".." ? s.pop() : a !== "." && s.push(a);
  }
  return s[0] !== "" && s.unshift(""), s.join("/");
}
function gX(t) {
  var e = "", n = "", r = t.indexOf("#");
  r >= 0 && (e = t.slice(r), t = t.slice(0, r));
  var s = t.indexOf("?");
  return s >= 0 && (n = t.slice(s + 1), t = t.slice(0, s)), {
    path: t,
    query: n,
    hash: e
  };
}
function Pa(t) {
  return t.replace(/\/(?:\s*\/)+/g, "/");
}
var im = Array.isArray || function(t) {
  return Object.prototype.toString.call(t) == "[object Array]";
}, yu = FM, yX = sS, bX = IX, _X = RM, wX = LM, SX = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  "(\\\\.)",
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
function sS(t, e) {
  for (var n = [], r = 0, s = 0, i = "", o = e && e.delimiter || "/", a; (a = SX.exec(t)) != null; ) {
    var l = a[0], c = a[1], u = a.index;
    if (i += t.slice(s, u), s = u + l.length, c) {
      i += c[1];
      continue;
    }
    var d = t[s], f = a[2], p = a[3], h = a[4], m = a[5], v = a[6], y = a[7];
    i && (n.push(i), i = "");
    var _ = f != null && d != null && d !== f, w = v === "+" || v === "*", S = v === "?" || v === "*", E = a[2] || o, x = h || m;
    n.push({
      name: p || r++,
      prefix: f || "",
      delimiter: E,
      optional: S,
      repeat: w,
      partial: _,
      asterisk: !!y,
      pattern: x ? CX(x) : y ? ".*" : "[^" + rh(E) + "]+?"
    });
  }
  return s < t.length && (i += t.substr(s)), i && n.push(i), n;
}
function IX(t, e) {
  return RM(sS(t, e), e);
}
function EX(t) {
  return encodeURI(t).replace(/[\/?#]/g, function(e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function xX(t) {
  return encodeURI(t).replace(/[?#]/g, function(e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function RM(t, e) {
  for (var n = new Array(t.length), r = 0; r < t.length; r++)
    typeof t[r] == "object" && (n[r] = new RegExp("^(?:" + t[r].pattern + ")$", oS(e)));
  return function(s, i) {
    for (var o = "", a = s || {}, l = i || {}, c = l.pretty ? EX : encodeURIComponent, u = 0; u < t.length; u++) {
      var d = t[u];
      if (typeof d == "string") {
        o += d;
        continue;
      }
      var f = a[d.name], p;
      if (f == null)
        if (d.optional) {
          d.partial && (o += d.prefix);
          continue;
        } else
          throw new TypeError('Expected "' + d.name + '" to be defined');
      if (im(f)) {
        if (!d.repeat)
          throw new TypeError('Expected "' + d.name + '" to not repeat, but received `' + JSON.stringify(f) + "`");
        if (f.length === 0) {
          if (d.optional)
            continue;
          throw new TypeError('Expected "' + d.name + '" to not be empty');
        }
        for (var h = 0; h < f.length; h++) {
          if (p = c(f[h]), !n[u].test(p))
            throw new TypeError('Expected all "' + d.name + '" to match "' + d.pattern + '", but received `' + JSON.stringify(p) + "`");
          o += (h === 0 ? d.prefix : d.delimiter) + p;
        }
        continue;
      }
      if (p = d.asterisk ? xX(f) : c(f), !n[u].test(p))
        throw new TypeError('Expected "' + d.name + '" to match "' + d.pattern + '", but received "' + p + '"');
      o += d.prefix + p;
    }
    return o;
  };
}
function rh(t) {
  return t.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
function CX(t) {
  return t.replace(/([=!:$\/()])/g, "\\$1");
}
function iS(t, e) {
  return t.keys = e, t;
}
function oS(t) {
  return t && t.sensitive ? "" : "i";
}
function TX(t, e) {
  var n = t.source.match(/\((?!\?)/g);
  if (n)
    for (var r = 0; r < n.length; r++)
      e.push({
        name: r,
        prefix: null,
        delimiter: null,
        optional: !1,
        repeat: !1,
        partial: !1,
        asterisk: !1,
        pattern: null
      });
  return iS(t, e);
}
function PX(t, e, n) {
  for (var r = [], s = 0; s < t.length; s++)
    r.push(FM(t[s], e, n).source);
  var i = new RegExp("(?:" + r.join("|") + ")", oS(n));
  return iS(i, e);
}
function kX(t, e, n) {
  return LM(sS(t, n), e, n);
}
function LM(t, e, n) {
  im(e) || (n = /** @type {!Object} */
  e || n, e = []), n = n || {};
  for (var r = n.strict, s = n.end !== !1, i = "", o = 0; o < t.length; o++) {
    var a = t[o];
    if (typeof a == "string")
      i += rh(a);
    else {
      var l = rh(a.prefix), c = "(?:" + a.pattern + ")";
      e.push(a), a.repeat && (c += "(?:" + l + c + ")*"), a.optional ? a.partial ? c = l + "(" + c + ")?" : c = "(?:" + l + "(" + c + "))?" : c = l + "(" + c + ")", i += c;
    }
  }
  var u = rh(n.delimiter || "/"), d = i.slice(-u.length) === u;
  return r || (i = (d ? i.slice(0, -u.length) : i) + "(?:" + u + "(?=$))?"), s ? i += "$" : i += r && d ? "" : "(?=" + u + "|$)", iS(new RegExp("^" + i, oS(n)), e);
}
function FM(t, e, n) {
  return im(e) || (n = /** @type {!Object} */
  e || n, e = []), n = n || {}, t instanceof RegExp ? TX(
    t,
    /** @type {!Array} */
    e
  ) : im(t) ? PX(
    /** @type {!Array} */
    t,
    /** @type {!Array} */
    e,
    n
  ) : kX(
    /** @type {string} */
    t,
    /** @type {!Array} */
    e,
    n
  );
}
yu.parse = yX;
yu.compile = bX;
yu.tokensToFunction = _X;
yu.tokensToRegExp = wX;
var mC = /* @__PURE__ */ Object.create(null);
function sh(t, e, n) {
  e = e || {};
  try {
    var r = mC[t] || (mC[t] = yu.compile(t));
    return typeof e.pathMatch == "string" && (e[0] = e.pathMatch), r(e, { pretty: !0 });
  } catch (s) {
    return process.env.NODE_ENV !== "production" && ar(typeof e.pathMatch == "string", "missing param for " + n + ": " + s.message), "";
  } finally {
    delete e[0];
  }
}
function aS(t, e, n, r) {
  var s = typeof t == "string" ? { path: t } : t;
  if (s._normalized)
    return s;
  if (s.name) {
    s = Fi({}, t);
    var i = s.params;
    return i && typeof i == "object" && (s.params = Fi({}, i)), s;
  }
  if (!s.path && s.params && e) {
    s = Fi({}, s), s._normalized = !0;
    var o = Fi(Fi({}, e.params), s.params);
    if (e.name)
      s.name = e.name, s.params = o;
    else if (e.matched.length) {
      var a = e.matched[e.matched.length - 1].path;
      s.path = sh(a, o, "path " + e.path);
    } else process.env.NODE_ENV !== "production" && ar(!1, "relative params navigation requires a current route.");
    return s;
  }
  var l = gX(s.path || ""), c = e && e.path || "/", u = l.path ? MM(l.path, c, n || s.append) : c, d = cX(
    l.query,
    s.query,
    r && r.options.parseQuery
  ), f = s.hash || l.hash;
  return f && f.charAt(0) !== "#" && (f = "#" + f), {
    _normalized: !0,
    path: u,
    query: d,
    hash: f
  };
}
var NX = [String, Object], $X = [String, Array], vC = function() {
}, gC, yC, bC, DX = {
  name: "RouterLink",
  props: {
    to: {
      type: NX,
      required: !0
    },
    tag: {
      type: String,
      default: "a"
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: "page"
    },
    event: {
      type: $X,
      default: "click"
    }
  },
  render: function(e) {
    var n = this, r = this.$router, s = this.$route, i = r.resolve(
      this.to,
      s,
      this.append
    ), o = i.location, a = i.route, l = i.href, c = {}, u = r.options.linkActiveClass, d = r.options.linkExactActiveClass, f = u ?? "router-link-active", p = d ?? "router-link-exact-active", h = this.activeClass == null ? f : this.activeClass, m = this.exactActiveClass == null ? p : this.exactActiveClass, v = a.redirectedFrom ? sm(null, aS(a.redirectedFrom), null, r) : a;
    c[m] = AM(s, v, this.exactPath), c[h] = this.exact || this.exactPath ? c[m] : pX(s, v);
    var y = c[m] ? this.ariaCurrentValue : null, _ = function(N) {
      _C(N) && (n.replace ? r.replace(o, vC) : r.push(o, vC));
    }, w = { click: _C };
    Array.isArray(this.event) ? this.event.forEach(function(N) {
      w[N] = _;
    }) : w[this.event] = _;
    var S = { class: c }, E = !this.$scopedSlots.$hasNormal && this.$scopedSlots.default && this.$scopedSlots.default({
      href: l,
      route: a,
      navigate: _,
      isActive: c[h],
      isExactActive: c[m]
    });
    if (E) {
      if (process.env.NODE_ENV !== "production" && !this.custom && (!gC && ar(!1, `In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:
<router-link v-slot="{ navigate, href }" custom></router-link>
`), gC = !0), E.length === 1)
        return E[0];
      if (E.length > 1 || !E.length)
        return process.env.NODE_ENV !== "production" && ar(
          !1,
          '<router-link> with to="' + this.to + `" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.`
        ), E.length === 0 ? e() : e("span", {}, E);
    }
    if (process.env.NODE_ENV !== "production" && ("tag" in this.$options.propsData && !yC && (ar(
      !1,
      "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
    ), yC = !0), "event" in this.$options.propsData && !bC && (ar(
      !1,
      "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
    ), bC = !0)), this.tag === "a")
      S.on = w, S.attrs = { href: l, "aria-current": y };
    else {
      var x = BM(this.$slots.default);
      if (x) {
        x.isStatic = !1;
        var T = x.data = Fi({}, x.data);
        T.on = T.on || {};
        for (var C in T.on) {
          var k = T.on[C];
          C in w && (T.on[C] = Array.isArray(k) ? k : [k]);
        }
        for (var b in w)
          b in T.on ? T.on[b].push(w[b]) : T.on[b] = _;
        var P = x.data.attrs = Fi({}, x.data.attrs);
        P.href = l, P["aria-current"] = y;
      } else
        S.on = w;
    }
    return e(this.tag, S, this.$slots.default);
  }
};
function _C(t) {
  if (!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey) && !t.defaultPrevented && !(t.button !== void 0 && t.button !== 0)) {
    if (t.currentTarget && t.currentTarget.getAttribute) {
      var e = t.currentTarget.getAttribute("target");
      if (/\b_blank\b/i.test(e))
        return;
    }
    return t.preventDefault && t.preventDefault(), !0;
  }
}
function BM(t) {
  if (t) {
    for (var e, n = 0; n < t.length; n++)
      if (e = t[n], e.tag === "a" || e.children && (e = BM(e.children)))
        return e;
  }
}
var om;
function am(t) {
  if (!(am.installed && om === t)) {
    am.installed = !0, om = t;
    var e = function(s) {
      return s !== void 0;
    }, n = function(s, i) {
      var o = s.$options._parentVnode;
      e(o) && e(o = o.data) && e(o = o.registerRouteInstance) && o(s, i);
    };
    t.mixin({
      beforeCreate: function() {
        e(this.$options.router) ? (this._routerRoot = this, this._router = this.$options.router, this._router.init(this), t.util.defineReactive(this, "_route", this._router.history.current)) : this._routerRoot = this.$parent && this.$parent._routerRoot || this, n(this, this);
      },
      destroyed: function() {
        n(this);
      }
    }), Object.defineProperty(t.prototype, "$router", {
      get: function() {
        return this._routerRoot._router;
      }
    }), Object.defineProperty(t.prototype, "$route", {
      get: function() {
        return this._routerRoot._route;
      }
    }), t.component("RouterView", mX), t.component("RouterLink", DX);
    var r = t.config.optionMergeStrategies;
    r.beforeRouteEnter = r.beforeRouteLeave = r.beforeRouteUpdate = r.created;
  }
}
var Df = typeof window < "u";
function _p(t, e, n, r, s) {
  var i = e || [], o = n || /* @__PURE__ */ Object.create(null), a = r || /* @__PURE__ */ Object.create(null);
  t.forEach(function(f) {
    __(i, o, a, f, s);
  });
  for (var l = 0, c = i.length; l < c; l++)
    i[l] === "*" && (i.push(i.splice(l, 1)[0]), c--, l--);
  if (process.env.NODE_ENV === "development") {
    var u = i.filter(function(f) {
      return f && f.charAt(0) !== "*" && f.charAt(0) !== "/";
    });
    if (u.length > 0) {
      var d = u.map(function(f) {
        return "- " + f;
      }).join(`
`);
      ar(!1, `Non-nested routes must include a leading slash character. Fix the following routes: 
` + d);
    }
  }
  return {
    pathList: i,
    pathMap: o,
    nameMap: a
  };
}
function __(t, e, n, r, s, i) {
  var o = r.path, a = r.name;
  process.env.NODE_ENV !== "production" && (Yl(o != null, '"path" is required in a route configuration.'), Yl(
    typeof r.component != "string",
    'route config "component" for path: ' + String(
      o || a
    ) + " cannot be a string id. Use an actual component instead."
  ), ar(
    // eslint-disable-next-line no-control-regex
    !/[^\u0000-\u007F]+/.test(o),
    'Route with path "' + o + '" contains unencoded characters, make sure your path is correctly encoded before passing it to the router. Use encodeURI to encode static segments of your path.'
  ));
  var l = r.pathToRegexpOptions || {}, c = OX(o, s, l.strict);
  typeof r.caseSensitive == "boolean" && (l.sensitive = r.caseSensitive);
  var u = {
    path: c,
    regex: AX(c, l),
    components: r.components || { default: r.component },
    alias: r.alias ? typeof r.alias == "string" ? [r.alias] : r.alias : [],
    instances: {},
    enteredCbs: {},
    name: a,
    parent: s,
    matchAs: i,
    redirect: r.redirect,
    beforeEnter: r.beforeEnter,
    meta: r.meta || {},
    props: r.props == null ? {} : r.components ? r.props : { default: r.props }
  };
  if (r.children && (process.env.NODE_ENV !== "production" && r.name && !r.redirect && r.children.some(function(m) {
    return /^\/?$/.test(m.path);
  }) && ar(
    !1,
    "Named Route '" + r.name + `' has a default child route. When navigating to this named route (:to="{name: '` + r.name + `'}"), the default child route will not be rendered. Remove the name from this route and use the name of the default child route for named links instead.`
  ), r.children.forEach(function(m) {
    var v = i ? Pa(i + "/" + m.path) : void 0;
    __(t, e, n, m, u, v);
  })), e[u.path] || (t.push(u.path), e[u.path] = u), r.alias !== void 0)
    for (var d = Array.isArray(r.alias) ? r.alias : [r.alias], f = 0; f < d.length; ++f) {
      var p = d[f];
      if (process.env.NODE_ENV !== "production" && p === o) {
        ar(
          !1,
          'Found an alias with the same value as the path: "' + o + '". You have to remove that alias. It will be ignored in development.'
        );
        continue;
      }
      var h = {
        path: p,
        children: r.children
      };
      __(
        t,
        e,
        n,
        h,
        s,
        u.path || "/"
        // matchAs
      );
    }
  a && (n[a] ? process.env.NODE_ENV !== "production" && !i && ar(
    !1,
    'Duplicate named routes definition: { name: "' + a + '", path: "' + u.path + '" }'
  ) : n[a] = u);
}
function AX(t, e) {
  var n = yu(t, [], e);
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ Object.create(null);
    n.keys.forEach(function(s) {
      ar(
        !r[s.name],
        'Duplicate param keys in route with path: "' + t + '"'
      ), r[s.name] = !0;
    });
  }
  return n;
}
function OX(t, e, n) {
  return n || (t = t.replace(/\/$/, "")), t[0] === "/" || e == null ? t : Pa(e.path + "/" + t);
}
function MX(t, e) {
  var n = _p(t), r = n.pathList, s = n.pathMap, i = n.nameMap;
  function o(p) {
    _p(p, r, s, i);
  }
  function a(p, h) {
    var m = typeof p != "object" ? i[p] : void 0;
    _p([h || p], r, s, i, m), m && m.alias.length && _p(
      // $flow-disable-line route is defined if parent is
      m.alias.map(function(v) {
        return { path: v, children: [h] };
      }),
      r,
      s,
      i,
      m
    );
  }
  function l() {
    return r.map(function(p) {
      return s[p];
    });
  }
  function c(p, h, m) {
    var v = aS(p, h, !1, e), y = v.name;
    if (y) {
      var _ = i[y];
      if (process.env.NODE_ENV !== "production" && ar(_, "Route with name '" + y + "' does not exist"), !_)
        return f(null, v);
      var w = _.regex.keys.filter(function(C) {
        return !C.optional;
      }).map(function(C) {
        return C.name;
      });
      if (typeof v.params != "object" && (v.params = {}), h && typeof h.params == "object")
        for (var S in h.params)
          !(S in v.params) && w.indexOf(S) > -1 && (v.params[S] = h.params[S]);
      return v.path = sh(_.path, v.params, 'named route "' + y + '"'), f(_, v, m);
    } else if (v.path) {
      v.params = {};
      for (var E = 0; E < r.length; E++) {
        var x = r[E], T = s[x];
        if (RX(T.regex, v.path, v.params))
          return f(T, v, m);
      }
    }
    return f(null, v);
  }
  function u(p, h) {
    var m = p.redirect, v = typeof m == "function" ? m(sm(p, h, null, e)) : m;
    if (typeof v == "string" && (v = { path: v }), !v || typeof v != "object")
      return process.env.NODE_ENV !== "production" && ar(
        !1,
        "invalid redirect option: " + JSON.stringify(v)
      ), f(null, h);
    var y = v, _ = y.name, w = y.path, S = h.query, E = h.hash, x = h.params;
    if (S = y.hasOwnProperty("query") ? y.query : S, E = y.hasOwnProperty("hash") ? y.hash : E, x = y.hasOwnProperty("params") ? y.params : x, _) {
      var T = i[_];
      return process.env.NODE_ENV !== "production" && Yl(T, 'redirect failed: named route "' + _ + '" not found.'), c({
        _normalized: !0,
        name: _,
        query: S,
        hash: E,
        params: x
      }, void 0, h);
    } else if (w) {
      var C = LX(w, p), k = sh(C, x, 'redirect route with path "' + C + '"');
      return c({
        _normalized: !0,
        path: k,
        query: S,
        hash: E
      }, void 0, h);
    } else
      return process.env.NODE_ENV !== "production" && ar(!1, "invalid redirect option: " + JSON.stringify(v)), f(null, h);
  }
  function d(p, h, m) {
    var v = sh(m, h.params, 'aliased route with path "' + m + '"'), y = c({
      _normalized: !0,
      path: v
    });
    if (y) {
      var _ = y.matched, w = _[_.length - 1];
      return h.params = y.params, f(w, h);
    }
    return f(null, h);
  }
  function f(p, h, m) {
    return p && p.redirect ? u(p, m || h) : p && p.matchAs ? d(p, h, p.matchAs) : sm(p, h, m, e);
  }
  return {
    match: c,
    addRoute: a,
    getRoutes: l,
    addRoutes: o
  };
}
function RX(t, e, n) {
  var r = e.match(t);
  if (r) {
    if (!n)
      return !0;
  } else return !1;
  for (var s = 1, i = r.length; s < i; ++s) {
    var o = t.keys[s - 1];
    o && (n[o.name || "pathMatch"] = typeof r[s] == "string" ? y_(r[s]) : r[s]);
  }
  return !0;
}
function LX(t, e) {
  return MM(t, e.parent ? e.parent.path : "/", !0);
}
var FX = Df && window.performance && window.performance.now ? window.performance : Date;
function jM() {
  return FX.now().toFixed(3);
}
var WM = jM();
function fv() {
  return WM;
}
function HM(t) {
  return WM = t;
}
var VM = /* @__PURE__ */ Object.create(null);
function zM() {
  "scrollRestoration" in window.history && (window.history.scrollRestoration = "manual");
  var t = window.location.protocol + "//" + window.location.host, e = window.location.href.replace(t, ""), n = Fi({}, window.history.state);
  return n.key = fv(), window.history.replaceState(n, "", e), window.addEventListener("popstate", wC), function() {
    window.removeEventListener("popstate", wC);
  };
}
function ka(t, e, n, r) {
  if (t.app) {
    var s = t.options.scrollBehavior;
    s && (process.env.NODE_ENV !== "production" && Yl(typeof s == "function", "scrollBehavior must be a function"), t.app.$nextTick(function() {
      var i = BX(), o = s.call(
        t,
        e,
        n,
        r ? i : null
      );
      o && (typeof o.then == "function" ? o.then(function(a) {
        EC(a, i);
      }).catch(function(a) {
        process.env.NODE_ENV !== "production" && Yl(!1, a.toString());
      }) : EC(o, i));
    }));
  }
}
function UM() {
  var t = fv();
  t && (VM[t] = {
    x: window.pageXOffset,
    y: window.pageYOffset
  });
}
function wC(t) {
  UM(), t.state && t.state.key && HM(t.state.key);
}
function BX() {
  var t = fv();
  if (t)
    return VM[t];
}
function jX(t, e) {
  var n = document.documentElement, r = n.getBoundingClientRect(), s = t.getBoundingClientRect();
  return {
    x: s.left - r.left - e.x,
    y: s.top - r.top - e.y
  };
}
function SC(t) {
  return ru(t.x) || ru(t.y);
}
function IC(t) {
  return {
    x: ru(t.x) ? t.x : window.pageXOffset,
    y: ru(t.y) ? t.y : window.pageYOffset
  };
}
function WX(t) {
  return {
    x: ru(t.x) ? t.x : 0,
    y: ru(t.y) ? t.y : 0
  };
}
function ru(t) {
  return typeof t == "number";
}
var HX = /^#\d/;
function EC(t, e) {
  var n = typeof t == "object";
  if (n && typeof t.selector == "string") {
    var r = HX.test(t.selector) ? document.getElementById(t.selector.slice(1)) : document.querySelector(t.selector);
    if (r) {
      var s = t.offset && typeof t.offset == "object" ? t.offset : {};
      s = WX(s), e = jX(r, s);
    } else SC(t) && (e = IC(t));
  } else n && SC(t) && (e = IC(t));
  e && ("scrollBehavior" in document.documentElement.style ? window.scrollTo({
    left: e.x,
    top: e.y,
    // $flow-disable-line
    behavior: t.behavior
  }) : window.scrollTo(e.x, e.y));
}
var Na = Df && function() {
  var t = window.navigator.userAgent;
  return (t.indexOf("Android 2.") !== -1 || t.indexOf("Android 4.0") !== -1) && t.indexOf("Mobile Safari") !== -1 && t.indexOf("Chrome") === -1 && t.indexOf("Windows Phone") === -1 ? !1 : window.history && typeof window.history.pushState == "function";
}();
function lm(t, e) {
  UM();
  var n = window.history;
  try {
    if (e) {
      var r = Fi({}, n.state);
      r.key = fv(), n.replaceState(r, "", t);
    } else
      n.pushState({ key: HM(jM()) }, "", t);
  } catch {
    window.location[e ? "replace" : "assign"](t);
  }
}
function w_(t) {
  lm(t, !0);
}
var ec = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};
function VX(t, e) {
  return pv(
    t,
    e,
    ec.redirected,
    'Redirected when going from "' + t.fullPath + '" to "' + YX(
      e
    ) + '" via a navigation guard.'
  );
}
function zX(t, e) {
  var n = pv(
    t,
    e,
    ec.duplicated,
    'Avoided redundant navigation to current location: "' + t.fullPath + '".'
  );
  return n.name = "NavigationDuplicated", n;
}
function xC(t, e) {
  return pv(
    t,
    e,
    ec.cancelled,
    'Navigation cancelled from "' + t.fullPath + '" to "' + e.fullPath + '" with a new navigation.'
  );
}
function UX(t, e) {
  return pv(
    t,
    e,
    ec.aborted,
    'Navigation aborted from "' + t.fullPath + '" to "' + e.fullPath + '" via a navigation guard.'
  );
}
function pv(t, e, n, r) {
  var s = new Error(r);
  return s._isRouter = !0, s.from = t, s.to = e, s.type = n, s;
}
var GX = ["params", "query", "hash"];
function YX(t) {
  if (typeof t == "string")
    return t;
  if ("path" in t)
    return t.path;
  var e = {};
  return GX.forEach(function(n) {
    n in t && (e[n] = t[n]);
  }), JSON.stringify(e, null, 2);
}
function cm(t) {
  return Object.prototype.toString.call(t).indexOf("Error") > -1;
}
function hv(t, e) {
  return cm(t) && t._isRouter && (e == null || t.type === e);
}
function CC(t, e, n) {
  var r = function(s) {
    s >= t.length ? n() : t[s] ? e(t[s], function() {
      r(s + 1);
    }) : r(s + 1);
  };
  r(0);
}
function ZX(t) {
  return function(e, n, r) {
    var s = !1, i = 0, o = null;
    GM(t, function(a, l, c, u) {
      if (typeof a == "function" && a.cid === void 0) {
        s = !0, i++;
        var d = TC(function(m) {
          KX(m) && (m = m.default), a.resolved = typeof m == "function" ? m : om.extend(m), c.components[u] = m, i--, i <= 0 && r();
        }), f = TC(function(m) {
          var v = "Failed to resolve async component " + u + ": " + m;
          process.env.NODE_ENV !== "production" && ar(!1, v), o || (o = cm(m) ? m : new Error(v), r(o));
        }), p;
        try {
          p = a(d, f);
        } catch (m) {
          f(m);
        }
        if (p)
          if (typeof p.then == "function")
            p.then(d, f);
          else {
            var h = p.component;
            h && typeof h.then == "function" && h.then(d, f);
          }
      }
    }), s || r();
  };
}
function GM(t, e) {
  return YM(t.map(function(n) {
    return Object.keys(n.components).map(function(r) {
      return e(
        n.components[r],
        n.instances[r],
        n,
        r
      );
    });
  }));
}
function YM(t) {
  return Array.prototype.concat.apply([], t);
}
var XX = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol";
function KX(t) {
  return t.__esModule || XX && t[Symbol.toStringTag] === "Module";
}
function TC(t) {
  var e = !1;
  return function() {
    for (var n = [], r = arguments.length; r--; ) n[r] = arguments[r];
    if (!e)
      return e = !0, t.apply(this, n);
  };
}
var Ui = function(e, n) {
  this.router = e, this.base = JX(n), this.current = Ja, this.pending = null, this.ready = !1, this.readyCbs = [], this.readyErrorCbs = [], this.errorCbs = [], this.listeners = [];
};
Ui.prototype.listen = function(e) {
  this.cb = e;
};
Ui.prototype.onReady = function(e, n) {
  this.ready ? e() : (this.readyCbs.push(e), n && this.readyErrorCbs.push(n));
};
Ui.prototype.onError = function(e) {
  this.errorCbs.push(e);
};
Ui.prototype.transitionTo = function(e, n, r) {
  var s = this, i;
  try {
    i = this.router.match(e, this.current);
  } catch (a) {
    throw this.errorCbs.forEach(function(l) {
      l(a);
    }), a;
  }
  var o = this.current;
  this.confirmTransition(
    i,
    function() {
      s.updateRoute(i), n && n(i), s.ensureURL(), s.router.afterHooks.forEach(function(a) {
        a && a(i, o);
      }), s.ready || (s.ready = !0, s.readyCbs.forEach(function(a) {
        a(i);
      }));
    },
    function(a) {
      r && r(a), a && !s.ready && (!hv(a, ec.redirected) || o !== Ja) && (s.ready = !0, s.readyErrorCbs.forEach(function(l) {
        l(a);
      }));
    }
  );
};
Ui.prototype.confirmTransition = function(e, n, r) {
  var s = this, i = this.current;
  this.pending = e;
  var o = function(m) {
    !hv(m) && cm(m) && (s.errorCbs.length ? s.errorCbs.forEach(function(v) {
      v(m);
    }) : (process.env.NODE_ENV !== "production" && ar(!1, "uncaught error during route navigation:"), console.error(m))), r && r(m);
  }, a = e.matched.length - 1, l = i.matched.length - 1;
  if (AM(e, i) && // in the case the route map has been dynamically appended to
  a === l && e.matched[a] === i.matched[l])
    return this.ensureURL(), e.hash && ka(this.router, i, e, !1), o(zX(i, e));
  var c = qX(
    this.current.matched,
    e.matched
  ), u = c.updated, d = c.deactivated, f = c.activated, p = [].concat(
    // in-component leave guards
    eK(d),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    tK(u),
    // in-config enter guards
    f.map(function(m) {
      return m.beforeEnter;
    }),
    // async components
    ZX(f)
  ), h = function(m, v) {
    if (s.pending !== e)
      return o(xC(i, e));
    try {
      m(e, i, function(y) {
        y === !1 ? (s.ensureURL(!0), o(UX(i, e))) : cm(y) ? (s.ensureURL(!0), o(y)) : typeof y == "string" || typeof y == "object" && (typeof y.path == "string" || typeof y.name == "string") ? (o(VX(i, e)), typeof y == "object" && y.replace ? s.replace(y) : s.push(y)) : v(y);
      });
    } catch (y) {
      o(y);
    }
  };
  CC(p, h, function() {
    var m = nK(f), v = m.concat(s.router.resolveHooks);
    CC(v, h, function() {
      if (s.pending !== e)
        return o(xC(i, e));
      s.pending = null, n(e), s.router.app && s.router.app.$nextTick(function() {
        OM(e);
      });
    });
  });
};
Ui.prototype.updateRoute = function(e) {
  this.current = e, this.cb && this.cb(e);
};
Ui.prototype.setupListeners = function() {
};
Ui.prototype.teardown = function() {
  this.listeners.forEach(function(e) {
    e();
  }), this.listeners = [], this.current = Ja, this.pending = null;
};
function JX(t) {
  if (!t)
    if (Df) {
      var e = document.querySelector("base");
      t = e && e.getAttribute("href") || "/", t = t.replace(/^https?:\/\/[^\/]+/, "");
    } else
      t = "/";
  return t.charAt(0) !== "/" && (t = "/" + t), t.replace(/\/$/, "");
}
function qX(t, e) {
  var n, r = Math.max(t.length, e.length);
  for (n = 0; n < r && t[n] === e[n]; n++)
    ;
  return {
    updated: e.slice(0, n),
    activated: e.slice(n),
    deactivated: t.slice(n)
  };
}
function lS(t, e, n, r) {
  var s = GM(t, function(i, o, a, l) {
    var c = QX(i, e);
    if (c)
      return Array.isArray(c) ? c.map(function(u) {
        return n(u, o, a, l);
      }) : n(c, o, a, l);
  });
  return YM(r ? s.reverse() : s);
}
function QX(t, e) {
  return typeof t != "function" && (t = om.extend(t)), t.options[e];
}
function eK(t) {
  return lS(t, "beforeRouteLeave", ZM, !0);
}
function tK(t) {
  return lS(t, "beforeRouteUpdate", ZM);
}
function ZM(t, e) {
  if (e)
    return function() {
      return t.apply(e, arguments);
    };
}
function nK(t) {
  return lS(
    t,
    "beforeRouteEnter",
    function(e, n, r, s) {
      return rK(e, r, s);
    }
  );
}
function rK(t, e, n) {
  return function(s, i, o) {
    return t(s, i, function(a) {
      typeof a == "function" && (e.enteredCbs[n] || (e.enteredCbs[n] = []), e.enteredCbs[n].push(a)), o(a);
    });
  };
}
var XM = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this, n, r), this._startLocation = Id(this.base);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setupListeners = function() {
    var r = this;
    if (!(this.listeners.length > 0)) {
      var s = this.router, i = s.options.scrollBehavior, o = Na && i;
      o && this.listeners.push(zM());
      var a = function() {
        var l = r.current, c = Id(r.base);
        r.current === Ja && c === r._startLocation || r.transitionTo(c, function(u) {
          o && ka(s, u, l, !0);
        });
      };
      window.addEventListener("popstate", a), this.listeners.push(function() {
        window.removeEventListener("popstate", a);
      });
    }
  }, e.prototype.go = function(r) {
    window.history.go(r);
  }, e.prototype.push = function(r, s, i) {
    var o = this, a = this, l = a.current;
    this.transitionTo(r, function(c) {
      lm(Pa(o.base + c.fullPath)), ka(o.router, c, l, !1), s && s(c);
    }, i);
  }, e.prototype.replace = function(r, s, i) {
    var o = this, a = this, l = a.current;
    this.transitionTo(r, function(c) {
      w_(Pa(o.base + c.fullPath)), ka(o.router, c, l, !1), s && s(c);
    }, i);
  }, e.prototype.ensureURL = function(r) {
    if (Id(this.base) !== this.current.fullPath) {
      var s = Pa(this.base + this.current.fullPath);
      r ? lm(s) : w_(s);
    }
  }, e.prototype.getCurrentLocation = function() {
    return Id(this.base);
  }, e;
}(Ui);
function Id(t) {
  var e = window.location.pathname, n = e.toLowerCase(), r = t.toLowerCase();
  return t && (n === r || n.indexOf(Pa(r + "/")) === 0) && (e = e.slice(t.length)), (e || "/") + window.location.search + window.location.hash;
}
var KM = /* @__PURE__ */ function(t) {
  function e(n, r, s) {
    t.call(this, n, r), !(s && sK(this.base)) && PC();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setupListeners = function() {
    var r = this;
    if (!(this.listeners.length > 0)) {
      var s = this.router, i = s.options.scrollBehavior, o = Na && i;
      o && this.listeners.push(zM());
      var a = function() {
        var c = r.current;
        PC() && r.transitionTo(ih(), function(u) {
          o && ka(r.router, u, c, !0), Na || oh(u.fullPath);
        });
      }, l = Na ? "popstate" : "hashchange";
      window.addEventListener(
        l,
        a
      ), this.listeners.push(function() {
        window.removeEventListener(l, a);
      });
    }
  }, e.prototype.push = function(r, s, i) {
    var o = this, a = this, l = a.current;
    this.transitionTo(
      r,
      function(c) {
        kC(c.fullPath), ka(o.router, c, l, !1), s && s(c);
      },
      i
    );
  }, e.prototype.replace = function(r, s, i) {
    var o = this, a = this, l = a.current;
    this.transitionTo(
      r,
      function(c) {
        oh(c.fullPath), ka(o.router, c, l, !1), s && s(c);
      },
      i
    );
  }, e.prototype.go = function(r) {
    window.history.go(r);
  }, e.prototype.ensureURL = function(r) {
    var s = this.current.fullPath;
    ih() !== s && (r ? kC(s) : oh(s));
  }, e.prototype.getCurrentLocation = function() {
    return ih();
  }, e;
}(Ui);
function sK(t) {
  var e = Id(t);
  if (!/^\/#/.test(e))
    return window.location.replace(Pa(t + "/#" + e)), !0;
}
function PC() {
  var t = ih();
  return t.charAt(0) === "/" ? !0 : (oh("/" + t), !1);
}
function ih() {
  var t = window.location.href, e = t.indexOf("#");
  return e < 0 ? "" : (t = t.slice(e + 1), t);
}
function S_(t) {
  var e = window.location.href, n = e.indexOf("#"), r = n >= 0 ? e.slice(0, n) : e;
  return r + "#" + t;
}
function kC(t) {
  Na ? lm(S_(t)) : window.location.hash = t;
}
function oh(t) {
  Na ? w_(S_(t)) : window.location.replace(S_(t));
}
var iK = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this, n, r), this.stack = [], this.index = -1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.push = function(r, s, i) {
    var o = this;
    this.transitionTo(
      r,
      function(a) {
        o.stack = o.stack.slice(0, o.index + 1).concat(a), o.index++, s && s(a);
      },
      i
    );
  }, e.prototype.replace = function(r, s, i) {
    var o = this;
    this.transitionTo(
      r,
      function(a) {
        o.stack = o.stack.slice(0, o.index).concat(a), s && s(a);
      },
      i
    );
  }, e.prototype.go = function(r) {
    var s = this, i = this.index + r;
    if (!(i < 0 || i >= this.stack.length)) {
      var o = this.stack[i];
      this.confirmTransition(
        o,
        function() {
          var a = s.current;
          s.index = i, s.updateRoute(o), s.router.afterHooks.forEach(function(l) {
            l && l(o, a);
          });
        },
        function(a) {
          hv(a, ec.duplicated) && (s.index = i);
        }
      );
    }
  }, e.prototype.getCurrentLocation = function() {
    var r = this.stack[this.stack.length - 1];
    return r ? r.fullPath : "/";
  }, e.prototype.ensureURL = function() {
  }, e;
}(Ui), Wn = function t(e) {
  e === void 0 && (e = {}), process.env.NODE_ENV !== "production" && ar(this instanceof t, "Router must be called with the new operator."), this.app = null, this.apps = [], this.options = e, this.beforeHooks = [], this.resolveHooks = [], this.afterHooks = [], this.matcher = MX(e.routes || [], this);
  var n = e.mode || "hash";
  switch (this.fallback = n === "history" && !Na && e.fallback !== !1, this.fallback && (n = "hash"), Df || (n = "abstract"), this.mode = n, n) {
    case "history":
      this.history = new XM(this, e.base);
      break;
    case "hash":
      this.history = new KM(this, e.base, this.fallback);
      break;
    case "abstract":
      this.history = new iK(this, e.base);
      break;
    default:
      process.env.NODE_ENV !== "production" && Yl(!1, "invalid mode: " + n);
  }
}, JM = { currentRoute: { configurable: !0 } };
Wn.prototype.match = function(e, n, r) {
  return this.matcher.match(e, n, r);
};
JM.currentRoute.get = function() {
  return this.history && this.history.current;
};
Wn.prototype.init = function(e) {
  var n = this;
  if (process.env.NODE_ENV !== "production" && Yl(
    am.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` before creating root instance."
  ), this.apps.push(e), e.$once("hook:destroyed", function() {
    var o = n.apps.indexOf(e);
    o > -1 && n.apps.splice(o, 1), n.app === e && (n.app = n.apps[0] || null), n.app || n.history.teardown();
  }), !this.app) {
    this.app = e;
    var r = this.history;
    if (r instanceof XM || r instanceof KM) {
      var s = function(o) {
        var a = r.current, l = n.options.scrollBehavior, c = Na && l;
        c && "fullPath" in o && ka(n, o, a, !1);
      }, i = function(o) {
        r.setupListeners(), s(o);
      };
      r.transitionTo(
        r.getCurrentLocation(),
        i,
        i
      );
    }
    r.listen(function(o) {
      n.apps.forEach(function(a) {
        a._route = o;
      });
    });
  }
};
Wn.prototype.beforeEach = function(e) {
  return cS(this.beforeHooks, e);
};
Wn.prototype.beforeResolve = function(e) {
  return cS(this.resolveHooks, e);
};
Wn.prototype.afterEach = function(e) {
  return cS(this.afterHooks, e);
};
Wn.prototype.onReady = function(e, n) {
  this.history.onReady(e, n);
};
Wn.prototype.onError = function(e) {
  this.history.onError(e);
};
Wn.prototype.push = function(e, n, r) {
  var s = this;
  if (!n && !r && typeof Promise < "u")
    return new Promise(function(i, o) {
      s.history.push(e, i, o);
    });
  this.history.push(e, n, r);
};
Wn.prototype.replace = function(e, n, r) {
  var s = this;
  if (!n && !r && typeof Promise < "u")
    return new Promise(function(i, o) {
      s.history.replace(e, i, o);
    });
  this.history.replace(e, n, r);
};
Wn.prototype.go = function(e) {
  this.history.go(e);
};
Wn.prototype.back = function() {
  this.go(-1);
};
Wn.prototype.forward = function() {
  this.go(1);
};
Wn.prototype.getMatchedComponents = function(e) {
  var n = e ? e.matched ? e : this.resolve(e).route : this.currentRoute;
  return n ? [].concat.apply(
    [],
    n.matched.map(function(r) {
      return Object.keys(r.components).map(function(s) {
        return r.components[s];
      });
    })
  ) : [];
};
Wn.prototype.resolve = function(e, n, r) {
  n = n || this.history.current;
  var s = aS(e, n, r, this), i = this.match(s, n), o = i.redirectedFrom || i.fullPath, a = this.history.base, l = oK(a, o, this.mode);
  return {
    location: s,
    route: i,
    href: l,
    // for backwards compat
    normalizedTo: s,
    resolved: i
  };
};
Wn.prototype.getRoutes = function() {
  return this.matcher.getRoutes();
};
Wn.prototype.addRoute = function(e, n) {
  this.matcher.addRoute(e, n), this.history.current !== Ja && this.history.transitionTo(this.history.getCurrentLocation());
};
Wn.prototype.addRoutes = function(e) {
  process.env.NODE_ENV !== "production" && ar(!1, "router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead."), this.matcher.addRoutes(e), this.history.current !== Ja && this.history.transitionTo(this.history.getCurrentLocation());
};
Object.defineProperties(Wn.prototype, JM);
var qM = Wn;
function cS(t, e) {
  return t.push(e), function() {
    var n = t.indexOf(e);
    n > -1 && t.splice(n, 1);
  };
}
function oK(t, e, n) {
  var r = n === "hash" ? "#" + e : e;
  return t ? Pa(t + "/" + r) : r;
}
Wn.install = am;
Wn.version = "3.6.5";
Wn.isNavigationFailure = hv;
Wn.NavigationFailureType = ec;
Wn.START_LOCATION = Ja;
Df && window.Vue && window.Vue.use(Wn);
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function aK(t) {
  var e = Number(t.version.split(".")[0]);
  if (e >= 2)
    t.mixin({ beforeCreate: r });
  else {
    var n = t.prototype._init;
    t.prototype._init = function(s) {
      s === void 0 && (s = {}), s.init = s.init ? [r].concat(s.init) : r, n.call(this, s);
    };
  }
  function r() {
    var s = this.$options;
    s.store ? this.$store = typeof s.store == "function" ? s.store() : s.store : s.parent && s.parent.$store && (this.$store = s.parent.$store);
  }
}
var lK = typeof window < "u" ? window : typeof global < "u" ? global : {}, Sc = lK.__VUE_DEVTOOLS_GLOBAL_HOOK__;
function cK(t) {
  Sc && (t._devtoolHook = Sc, Sc.emit("vuex:init", t), Sc.on("vuex:travel-to-state", function(e) {
    t.replaceState(e);
  }), t.subscribe(function(e, n) {
    Sc.emit("vuex:mutation", e, n);
  }, { prepend: !0 }), t.subscribeAction(function(e, n) {
    Sc.emit("vuex:action", e, n);
  }, { prepend: !0 }));
}
function uK(t, e) {
  return t.filter(e)[0];
}
function I_(t, e) {
  if (e === void 0 && (e = []), t === null || typeof t != "object")
    return t;
  var n = uK(e, function(s) {
    return s.original === t;
  });
  if (n)
    return n.copy;
  var r = Array.isArray(t) ? [] : {};
  return e.push({
    original: t,
    copy: r
  }), Object.keys(t).forEach(function(s) {
    r[s] = I_(t[s], e);
  }), r;
}
function tc(t, e) {
  Object.keys(t).forEach(function(n) {
    return e(t[n], n);
  });
}
function QM(t) {
  return t !== null && typeof t == "object";
}
function dK(t) {
  return t && typeof t.then == "function";
}
function _i(t, e) {
  if (!t)
    throw new Error("[vuex] " + e);
}
function fK(t, e) {
  return function() {
    return t(e);
  };
}
var Gi = function(e, n) {
  this.runtime = n, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = e;
  var r = e.state;
  this.state = (typeof r == "function" ? r() : r) || {};
}, e5 = { namespaced: { configurable: !0 } };
e5.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
Gi.prototype.addChild = function(e, n) {
  this._children[e] = n;
};
Gi.prototype.removeChild = function(e) {
  delete this._children[e];
};
Gi.prototype.getChild = function(e) {
  return this._children[e];
};
Gi.prototype.hasChild = function(e) {
  return e in this._children;
};
Gi.prototype.update = function(e) {
  this._rawModule.namespaced = e.namespaced, e.actions && (this._rawModule.actions = e.actions), e.mutations && (this._rawModule.mutations = e.mutations), e.getters && (this._rawModule.getters = e.getters);
};
Gi.prototype.forEachChild = function(e) {
  tc(this._children, e);
};
Gi.prototype.forEachGetter = function(e) {
  this._rawModule.getters && tc(this._rawModule.getters, e);
};
Gi.prototype.forEachAction = function(e) {
  this._rawModule.actions && tc(this._rawModule.actions, e);
};
Gi.prototype.forEachMutation = function(e) {
  this._rawModule.mutations && tc(this._rawModule.mutations, e);
};
Object.defineProperties(Gi.prototype, e5);
var nc = function(e) {
  this.register([], e, !1);
};
nc.prototype.get = function(e) {
  return e.reduce(function(n, r) {
    return n.getChild(r);
  }, this.root);
};
nc.prototype.getNamespace = function(e) {
  var n = this.root;
  return e.reduce(function(r, s) {
    return n = n.getChild(s), r + (n.namespaced ? s + "/" : "");
  }, "");
};
nc.prototype.update = function(e) {
  t5([], this.root, e);
};
nc.prototype.register = function(e, n, r) {
  var s = this;
  r === void 0 && (r = !0), process.env.NODE_ENV !== "production" && n5(e, n);
  var i = new Gi(n, r);
  if (e.length === 0)
    this.root = i;
  else {
    var o = this.get(e.slice(0, -1));
    o.addChild(e[e.length - 1], i);
  }
  n.modules && tc(n.modules, function(a, l) {
    s.register(e.concat(l), a, r);
  });
};
nc.prototype.unregister = function(e) {
  var n = this.get(e.slice(0, -1)), r = e[e.length - 1], s = n.getChild(r);
  if (!s) {
    process.env.NODE_ENV !== "production" && console.warn(
      "[vuex] trying to unregister module '" + r + "', which is not registered"
    );
    return;
  }
  s.runtime && n.removeChild(r);
};
nc.prototype.isRegistered = function(e) {
  var n = this.get(e.slice(0, -1)), r = e[e.length - 1];
  return n ? n.hasChild(r) : !1;
};
function t5(t, e, n) {
  if (process.env.NODE_ENV !== "production" && n5(t, n), e.update(n), n.modules)
    for (var r in n.modules) {
      if (!e.getChild(r)) {
        process.env.NODE_ENV !== "production" && console.warn(
          "[vuex] trying to add a new module '" + r + "' on hot reloading, manual reload is needed"
        );
        return;
      }
      t5(
        t.concat(r),
        e.getChild(r),
        n.modules[r]
      );
    }
}
var NC = {
  assert: function(t) {
    return typeof t == "function";
  },
  expected: "function"
}, pK = {
  assert: function(t) {
    return typeof t == "function" || typeof t == "object" && typeof t.handler == "function";
  },
  expected: 'function or object with "handler" function'
}, $C = {
  getters: NC,
  mutations: NC,
  actions: pK
};
function n5(t, e) {
  Object.keys($C).forEach(function(n) {
    if (e[n]) {
      var r = $C[n];
      tc(e[n], function(s, i) {
        _i(
          r.assert(s),
          hK(t, n, i, s, r.expected)
        );
      });
    }
  });
}
function hK(t, e, n, r, s) {
  var i = e + " should be " + s + ' but "' + e + "." + n + '"';
  return t.length > 0 && (i += ' in module "' + t.join(".") + '"'), i += " is " + JSON.stringify(r) + ".", i;
}
var Cs, oi = function t(e) {
  var n = this;
  e === void 0 && (e = {}), !Cs && typeof window < "u" && window.Vue && i5(window.Vue), process.env.NODE_ENV !== "production" && (_i(Cs, "must call Vue.use(Vuex) before creating a store instance."), _i(typeof Promise < "u", "vuex requires a Promise polyfill in this browser."), _i(this instanceof t, "store must be called with the new operator."));
  var r = e.plugins;
  r === void 0 && (r = []);
  var s = e.strict;
  s === void 0 && (s = !1), this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new nc(e), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._watcherVM = new Cs(), this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var i = this, o = this, a = o.dispatch, l = o.commit;
  this.dispatch = function(f, p) {
    return a.call(i, f, p);
  }, this.commit = function(f, p, h) {
    return l.call(i, f, p, h);
  }, this.strict = s;
  var c = this._modules.root.state;
  mv(this, c, [], this._modules.root), dS(this, c), r.forEach(function(d) {
    return d(n);
  });
  var u = e.devtools !== void 0 ? e.devtools : Cs.config.devtools;
  u && cK(this);
}, uS = { state: { configurable: !0 } };
uS.state.get = function() {
  return this._vm._data.$$state;
};
uS.state.set = function(t) {
  process.env.NODE_ENV !== "production" && _i(!1, "use store.replaceState() to explicit replace store state.");
};
oi.prototype.commit = function(e, n, r) {
  var s = this, i = um(e, n, r), o = i.type, a = i.payload, l = i.options, c = { type: o, payload: a }, u = this._mutations[o];
  if (!u) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown mutation type: " + o);
    return;
  }
  this._withCommit(function() {
    u.forEach(function(f) {
      f(a);
    });
  }), this._subscribers.slice().forEach(function(d) {
    return d(c, s.state);
  }), process.env.NODE_ENV !== "production" && l && l.silent && console.warn(
    "[vuex] mutation type: " + o + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
  );
};
oi.prototype.dispatch = function(e, n) {
  var r = this, s = um(e, n), i = s.type, o = s.payload, a = { type: i, payload: o }, l = this._actions[i];
  if (!l) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown action type: " + i);
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(u) {
      return u.before;
    }).forEach(function(u) {
      return u.before(a, r.state);
    });
  } catch (u) {
    process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in before action subscribers: "), console.error(u));
  }
  var c = l.length > 1 ? Promise.all(l.map(function(u) {
    return u(o);
  })) : l[0](o);
  return new Promise(function(u, d) {
    c.then(function(f) {
      try {
        r._actionSubscribers.filter(function(p) {
          return p.after;
        }).forEach(function(p) {
          return p.after(a, r.state);
        });
      } catch (p) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in after action subscribers: "), console.error(p));
      }
      u(f);
    }, function(f) {
      try {
        r._actionSubscribers.filter(function(p) {
          return p.error;
        }).forEach(function(p) {
          return p.error(a, r.state, f);
        });
      } catch (p) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in error action subscribers: "), console.error(p));
      }
      d(f);
    });
  });
};
oi.prototype.subscribe = function(e, n) {
  return r5(e, this._subscribers, n);
};
oi.prototype.subscribeAction = function(e, n) {
  var r = typeof e == "function" ? { before: e } : e;
  return r5(r, this._actionSubscribers, n);
};
oi.prototype.watch = function(e, n, r) {
  var s = this;
  return process.env.NODE_ENV !== "production" && _i(typeof e == "function", "store.watch only accepts a function."), this._watcherVM.$watch(function() {
    return e(s.state, s.getters);
  }, n, r);
};
oi.prototype.replaceState = function(e) {
  var n = this;
  this._withCommit(function() {
    n._vm._data.$$state = e;
  });
};
oi.prototype.registerModule = function(e, n, r) {
  r === void 0 && (r = {}), typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && (_i(Array.isArray(e), "module path must be a string or an Array."), _i(e.length > 0, "cannot register the root module by using registerModule.")), this._modules.register(e, n), mv(this, this.state, e, this._modules.get(e), r.preserveState), dS(this, this.state);
};
oi.prototype.unregisterModule = function(e) {
  var n = this;
  typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && _i(Array.isArray(e), "module path must be a string or an Array."), this._modules.unregister(e), this._withCommit(function() {
    var r = fS(n.state, e.slice(0, -1));
    Cs.delete(r, e[e.length - 1]);
  }), s5(this);
};
oi.prototype.hasModule = function(e) {
  return typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && _i(Array.isArray(e), "module path must be a string or an Array."), this._modules.isRegistered(e);
};
oi.prototype.hotUpdate = function(e) {
  this._modules.update(e), s5(this, !0);
};
oi.prototype._withCommit = function(e) {
  var n = this._committing;
  this._committing = !0, e(), this._committing = n;
};
Object.defineProperties(oi.prototype, uS);
function r5(t, e, n) {
  return e.indexOf(t) < 0 && (n && n.prepend ? e.unshift(t) : e.push(t)), function() {
    var r = e.indexOf(t);
    r > -1 && e.splice(r, 1);
  };
}
function s5(t, e) {
  t._actions = /* @__PURE__ */ Object.create(null), t._mutations = /* @__PURE__ */ Object.create(null), t._wrappedGetters = /* @__PURE__ */ Object.create(null), t._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var n = t.state;
  mv(t, n, [], t._modules.root, !0), dS(t, n, e);
}
function dS(t, e, n) {
  var r = t._vm;
  t.getters = {}, t._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var s = t._wrappedGetters, i = {};
  tc(s, function(a, l) {
    i[l] = fK(a, t), Object.defineProperty(t.getters, l, {
      get: function() {
        return t._vm[l];
      },
      enumerable: !0
      // for local getters
    });
  });
  var o = Cs.config.silent;
  Cs.config.silent = !0, t._vm = new Cs({
    data: {
      $$state: e
    },
    computed: i
  }), Cs.config.silent = o, t.strict && _K(t), r && (n && t._withCommit(function() {
    r._data.$$state = null;
  }), Cs.nextTick(function() {
    return r.$destroy();
  }));
}
function mv(t, e, n, r, s) {
  var i = !n.length, o = t._modules.getNamespace(n);
  if (r.namespaced && (t._modulesNamespaceMap[o] && process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + o + " for the namespaced module " + n.join("/")), t._modulesNamespaceMap[o] = r), !i && !s) {
    var a = fS(e, n.slice(0, -1)), l = n[n.length - 1];
    t._withCommit(function() {
      process.env.NODE_ENV !== "production" && l in a && console.warn(
        '[vuex] state field "' + l + '" was overridden by a module with the same name at "' + n.join(".") + '"'
      ), Cs.set(a, l, r.state);
    });
  }
  var c = r.context = mK(t, o, n);
  r.forEachMutation(function(u, d) {
    var f = o + d;
    gK(t, f, u, c);
  }), r.forEachAction(function(u, d) {
    var f = u.root ? d : o + d, p = u.handler || u;
    yK(t, f, p, c);
  }), r.forEachGetter(function(u, d) {
    var f = o + d;
    bK(t, f, u, c);
  }), r.forEachChild(function(u, d) {
    mv(t, e, n.concat(d), u, s);
  });
}
function mK(t, e, n) {
  var r = e === "", s = {
    dispatch: r ? t.dispatch : function(i, o, a) {
      var l = um(i, o, a), c = l.payload, u = l.options, d = l.type;
      if ((!u || !u.root) && (d = e + d, process.env.NODE_ENV !== "production" && !t._actions[d])) {
        console.error("[vuex] unknown local action type: " + l.type + ", global type: " + d);
        return;
      }
      return t.dispatch(d, c);
    },
    commit: r ? t.commit : function(i, o, a) {
      var l = um(i, o, a), c = l.payload, u = l.options, d = l.type;
      if ((!u || !u.root) && (d = e + d, process.env.NODE_ENV !== "production" && !t._mutations[d])) {
        console.error("[vuex] unknown local mutation type: " + l.type + ", global type: " + d);
        return;
      }
      t.commit(d, c, u);
    }
  };
  return Object.defineProperties(s, {
    getters: {
      get: r ? function() {
        return t.getters;
      } : function() {
        return vK(t, e);
      }
    },
    state: {
      get: function() {
        return fS(t.state, n);
      }
    }
  }), s;
}
function vK(t, e) {
  if (!t._makeLocalGettersCache[e]) {
    var n = {}, r = e.length;
    Object.keys(t.getters).forEach(function(s) {
      if (s.slice(0, r) === e) {
        var i = s.slice(r);
        Object.defineProperty(n, i, {
          get: function() {
            return t.getters[s];
          },
          enumerable: !0
        });
      }
    }), t._makeLocalGettersCache[e] = n;
  }
  return t._makeLocalGettersCache[e];
}
function gK(t, e, n, r) {
  var s = t._mutations[e] || (t._mutations[e] = []);
  s.push(function(o) {
    n.call(t, r.state, o);
  });
}
function yK(t, e, n, r) {
  var s = t._actions[e] || (t._actions[e] = []);
  s.push(function(o) {
    var a = n.call(t, {
      dispatch: r.dispatch,
      commit: r.commit,
      getters: r.getters,
      state: r.state,
      rootGetters: t.getters,
      rootState: t.state
    }, o);
    return dK(a) || (a = Promise.resolve(a)), t._devtoolHook ? a.catch(function(l) {
      throw t._devtoolHook.emit("vuex:error", l), l;
    }) : a;
  });
}
function bK(t, e, n, r) {
  if (t._wrappedGetters[e]) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate getter key: " + e);
    return;
  }
  t._wrappedGetters[e] = function(i) {
    return n(
      r.state,
      // local state
      r.getters,
      // local getters
      i.state,
      // root state
      i.getters
      // root getters
    );
  };
}
function _K(t) {
  t._vm.$watch(function() {
    return this._data.$$state;
  }, function() {
    process.env.NODE_ENV !== "production" && _i(t._committing, "do not mutate vuex store state outside mutation handlers.");
  }, { deep: !0, sync: !0 });
}
function fS(t, e) {
  return e.reduce(function(n, r) {
    return n[r];
  }, t);
}
function um(t, e, n) {
  return QM(t) && t.type && (n = e, e = t, t = t.type), process.env.NODE_ENV !== "production" && _i(typeof t == "string", "expects string as the type, but found " + typeof t + "."), { type: t, payload: e, options: n };
}
function i5(t) {
  if (Cs && t === Cs) {
    process.env.NODE_ENV !== "production" && console.error(
      "[vuex] already installed. Vue.use(Vuex) should be called only once."
    );
    return;
  }
  Cs = t, aK(Cs);
}
var st = gv(function(t, e) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !Af(e) && console.error("[vuex] mapState: mapper parameter must be either an Array or an Object"), vv(e).forEach(function(r) {
    var s = r.key, i = r.val;
    n[s] = function() {
      var a = this.$store.state, l = this.$store.getters;
      if (t) {
        var c = yv(this.$store, "mapState", t);
        if (!c)
          return;
        a = c.context.state, l = c.context.getters;
      }
      return typeof i == "function" ? i.call(this, a, l) : a[i];
    }, n[s].vuex = !0;
  }), n;
}), o5 = gv(function(t, e) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !Af(e) && console.error("[vuex] mapMutations: mapper parameter must be either an Array or an Object"), vv(e).forEach(function(r) {
    var s = r.key, i = r.val;
    n[s] = function() {
      for (var a = [], l = arguments.length; l--; ) a[l] = arguments[l];
      var c = this.$store.commit;
      if (t) {
        var u = yv(this.$store, "mapMutations", t);
        if (!u)
          return;
        c = u.context.commit;
      }
      return typeof i == "function" ? i.apply(this, [c].concat(a)) : c.apply(this.$store, [i].concat(a));
    };
  }), n;
}), pe = gv(function(t, e) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !Af(e) && console.error("[vuex] mapGetters: mapper parameter must be either an Array or an Object"), vv(e).forEach(function(r) {
    var s = r.key, i = r.val;
    i = t + i, n[s] = function() {
      if (!(t && !yv(this.$store, "mapGetters", t))) {
        if (process.env.NODE_ENV !== "production" && !(i in this.$store.getters)) {
          console.error("[vuex] unknown getter: " + i);
          return;
        }
        return this.$store.getters[i];
      }
    }, n[s].vuex = !0;
  }), n;
}), ge = gv(function(t, e) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !Af(e) && console.error("[vuex] mapActions: mapper parameter must be either an Array or an Object"), vv(e).forEach(function(r) {
    var s = r.key, i = r.val;
    n[s] = function() {
      for (var a = [], l = arguments.length; l--; ) a[l] = arguments[l];
      var c = this.$store.dispatch;
      if (t) {
        var u = yv(this.$store, "mapActions", t);
        if (!u)
          return;
        c = u.context.dispatch;
      }
      return typeof i == "function" ? i.apply(this, [c].concat(a)) : c.apply(this.$store, [i].concat(a));
    };
  }), n;
}), wK = function(t) {
  return {
    mapState: st.bind(null, t),
    mapGetters: pe.bind(null, t),
    mapMutations: o5.bind(null, t),
    mapActions: ge.bind(null, t)
  };
};
function vv(t) {
  return Af(t) ? Array.isArray(t) ? t.map(function(e) {
    return { key: e, val: e };
  }) : Object.keys(t).map(function(e) {
    return { key: e, val: t[e] };
  }) : [];
}
function Af(t) {
  return Array.isArray(t) || QM(t);
}
function gv(t) {
  return function(e, n) {
    return typeof e != "string" ? (n = e, e = "") : e.charAt(e.length - 1) !== "/" && (e += "/"), t(e, n);
  };
}
function yv(t, e, n) {
  var r = t._modulesNamespaceMap[n];
  return process.env.NODE_ENV !== "production" && !r && console.error("[vuex] module namespace not found in " + e + "(): " + n), r;
}
function SK(t) {
  t === void 0 && (t = {});
  var e = t.collapsed;
  e === void 0 && (e = !0);
  var n = t.filter;
  n === void 0 && (n = function(u, d, f) {
    return !0;
  });
  var r = t.transformer;
  r === void 0 && (r = function(u) {
    return u;
  });
  var s = t.mutationTransformer;
  s === void 0 && (s = function(u) {
    return u;
  });
  var i = t.actionFilter;
  i === void 0 && (i = function(u, d) {
    return !0;
  });
  var o = t.actionTransformer;
  o === void 0 && (o = function(u) {
    return u;
  });
  var a = t.logMutations;
  a === void 0 && (a = !0);
  var l = t.logActions;
  l === void 0 && (l = !0);
  var c = t.logger;
  return c === void 0 && (c = console), function(u) {
    var d = I_(u.state);
    typeof c > "u" || (a && u.subscribe(function(f, p) {
      var h = I_(p);
      if (n(f, d, h)) {
        var m = OC(), v = s(f), y = "mutation " + f.type + m;
        DC(c, y, e), c.log("%c prev state", "color: #9E9E9E; font-weight: bold", r(d)), c.log("%c mutation", "color: #03A9F4; font-weight: bold", v), c.log("%c next state", "color: #4CAF50; font-weight: bold", r(h)), AC(c);
      }
      d = h;
    }), l && u.subscribeAction(function(f, p) {
      if (i(f, p)) {
        var h = OC(), m = o(f), v = "action " + f.type + h;
        DC(c, v, e), c.log("%c action", "color: #03A9F4; font-weight: bold", m), AC(c);
      }
    }));
  };
}
function DC(t, e, n) {
  var r = n ? t.groupCollapsed : t.group;
  try {
    r.call(t, e);
  } catch {
    t.log(e);
  }
}
function AC(t) {
  try {
    t.groupEnd();
  } catch {
    t.log("—— log end ——");
  }
}
function OC() {
  var t = /* @__PURE__ */ new Date();
  return " @ " + wp(t.getHours(), 2) + ":" + wp(t.getMinutes(), 2) + ":" + wp(t.getSeconds(), 2) + "." + wp(t.getMilliseconds(), 3);
}
function IK(t, e) {
  return new Array(e + 1).join(t);
}
function wp(t, e) {
  return IK("0", e - t.toString().length) + t;
}
var EK = {
  Store: oi,
  install: i5,
  version: "3.6.2",
  mapState: st,
  mapMutations: o5,
  mapGetters: pe,
  mapActions: ge,
  createNamespacedHelpers: wK,
  createLogger: SK
};
const a5 = EK;
function MC(t, e) {
  t.style.transform = e, t.style.webkitTransform = e;
}
const pS = {
  /**
   * @param {Event} e
   * @param {Element} el
   * @param {{ class?: string, center?: boolean }} [value={}]
   */
  show: (t, e, n = {}) => {
    if (!e._ripple || !e._ripple.enabled)
      return;
    const r = document.createElement("span"), s = document.createElement("span");
    r.appendChild(s), r.className = "rippler__container", n.class && (r.className += ` ${n.class}`);
    const i = e.clientWidth > e.clientHeight ? e.clientWidth : e.clientHeight;
    s.className = "rippler__animation", s.style.width = `${i * (n.center ? 1 : 2)}px`, s.style.height = s.style.width, e.appendChild(r);
    const o = window.getComputedStyle(e);
    o.position !== "absolute" && o.position !== "fixed" && (e.style.position = "relative");
    const a = e.getBoundingClientRect(), l = n.center ? "50%" : `${t.clientX - a.left}px`, c = n.center ? "50%" : `${t.clientY - a.top}px`;
    s.classList.add("rippler__animation--enter"), s.classList.add("rippler__animation--visible"), MC(
      s,
      `translate(-50%, -50%) translate(${l}, ${c}) scale3d(0.01,0.01,0.01)`
    ), s.dataset.activated = Date.now(), setTimeout(() => {
      s.classList.remove("rippler__animation--enter"), MC(
        s,
        `translate(-50%, -50%) translate(${l}, ${c})  scale3d(0.99,0.99,0.99)`
      );
    }, 0);
  },
  hide: (t) => {
    if (!t._ripple || !t._ripple.enabled) return;
    const e = t.getElementsByClassName("rippler__animation");
    if (e.length === 0) return;
    const n = e[e.length - 1];
    let s = 400 - (Date.now() - Number(n.dataset.activated));
    s = s < 0 ? 0 : s, setTimeout(() => {
      n.classList.remove("rippler__animation--visible"), setTimeout(() => {
        try {
          e.length < 1 && (t.style.position = null), n.parentNode && t.removeChild(n.parentNode);
        } catch {
          return;
        }
      }, 300);
    }, s);
  }
};
function l5(t) {
  return typeof t > "u" || !!t;
}
function E_(t) {
  const e = {}, n = t.currentTarget;
  e.center = n._ripple.centered, n._ripple.class && (e.class = n._ripple.class), pS.show(t, n, e);
}
function co(t) {
  pS.hide(t.currentTarget);
}
function c5(t, e, n) {
  const r = l5(e.value);
  r || pS.hide(t), t._ripple = t._ripple || {}, t._ripple.enabled = r;
  const s = e.value || {};
  s.center && (t._ripple.centered = !0), s.class && (t._ripple.class = e.value.class), r && !n ? ("ontouchstart" in window && (t.addEventListener("touchend", co, !1), t.addEventListener("touchcancel", co, !1)), t.addEventListener("mousedown", E_, !1), t.addEventListener("mouseup", co, !1), t.addEventListener("mouseleave", co, !1), t.addEventListener("dragstart", co, !1)) : !r && n && u5(t);
}
function u5(t) {
  t.removeEventListener("touchstart", E_, !1), t.removeEventListener("mousedown", E_, !1), t.removeEventListener("touchend", co, !1), t.removeEventListener("touchcancel", co, !1), t.removeEventListener("mouseup", co, !1), t.removeEventListener("mouseleave", co, !1), t.removeEventListener("dragstart", co, !1);
}
function xK(t, e) {
  c5(t, e, !1);
}
function CK(t) {
  delete t._ripple, u5(t);
}
function TK(t, e) {
  if (e.value === e.oldValue)
    return;
  const n = l5(e.oldValue);
  c5(t, e, n);
}
const hS = {
  name: "rippler",
  bind: xK,
  unbind: CK,
  update: TK
}, PK = "_root_1t4xo_1", kK = "_root_disabled_1t4xo_13", NK = "_root_falselyDisabled_1t4xo_17", $K = "_root_round_1t4xo_21", DK = "_content_1t4xo_24", AK = {
  root: PK,
  root_disabled: kK,
  root_falselyDisabled: NK,
  root_round: $K,
  content: DK
};
function B(t, e, n, r, s, i, o, a) {
  var l = typeof t == "function" ? t.options : t;
  e && (l.render = e, l.staticRenderFns = n, l._compiled = !0), r && (l.functional = !0), i && (l._scopeId = "data-v-" + i);
  var c;
  if (s && (c = s), c)
    if (l.functional) {
      l._injectStyles = c;
      var u = l.render;
      l.render = function(p, h) {
        return c.call(h), u(p, h);
      };
    } else {
      var d = l.beforeCreate;
      l.beforeCreate = d ? [].concat(d, c) : [c];
    }
  return {
    exports: t,
    options: l
  };
}
const OK = {
  name: "PbButton",
  directives: {
    rippler: hS
  },
  props: {
    type: {
      type: String,
      default: "button"
    },
    value: null,
    activeClass: String,
    buttonClass: String,
    contentClass: String,
    title: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    falselyDisabled: {
      // для случаев, когда нужна имитация disable, например, чтобы у заблоченной кнопки отображать тултипы
      type: Boolean,
      default: !1
    },
    round: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    classes() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_active]: this.active,
        [this.$style.root_disabled]: this.disabled,
        [this.$style.root_falselyDisabled]: this.falselyDisabled,
        [this.$style.root_round]: this.round,
        [this.activeClass]: this.activeClass && this.active,
        [this.buttonClass]: this.buttonClass
      };
    }
  },
  methods: {
    onClick(t) {
      if (this.falselyDisabled) {
        t.stopPropagation();
        return;
      }
      this.$emit("click", t);
    }
  }
};
var MK = function() {
  var e = this, n = e._self._c;
  return n("button", { directives: [{ name: "rippler", rawName: "v-rippler" }], class: e.classes, attrs: { type: e.type, title: e.title, disabled: e.disabled, falselyDisabled: e.falselyDisabled }, on: { click: e.onClick, contextmenu: function(r) {
    return e.$emit("menu", r);
  } } }, [n("div", { class: [e.$style.content, e.contentClass] }, [e._t("default")], 2)]);
}, RK = [];
const RC = {
  $style: AK
};
function LK(t) {
  for (var e in RC)
    this[e] = RC[e];
}
var FK = /* @__PURE__ */ B(
  OK,
  MK,
  RK,
  !1,
  LK,
  null
);
const nt = FK.exports, BK = "_root_dblgb_1", jK = "_root_checked_dblgb_6", WK = "_mark_dblgb_6", HK = "_root_disabled_dblgb_9", VK = "_input_dblgb_13", zK = "_label_dblgb_28", UK = {
  root: BK,
  root_checked: jK,
  mark: WK,
  root_disabled: HK,
  input: VK,
  label: zK
}, GK = {
  name: "PbCheckboxLabeled",
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    checked: Boolean,
    disabled: Boolean,
    label: String,
    attributes: Object,
    styleLabel: Object,
    iconProps: {
      type: Object,
      default: () => ({ type: "svg", size: 20 })
    }
  },
  computed: {
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_checked]: this.checked,
        [this.$style.root_disabled]: this.disabled
      };
    }
  },
  methods: {
    handleChange(t) {
      this.$emit("change", t.target.checked);
    }
  }
};
var YK = function() {
  var e = this, n = e._self._c;
  return n("label", e._b({ class: e.rootClass, on: { click: function(r) {
    r.stopPropagation();
  } } }, "label", e.attributes, !1), [n("input", { class: e.$style.input, attrs: { disabled: e.disabled, type: "checkbox" }, domProps: { checked: e.checked }, on: { change: e.handleChange } }), n("span", { class: e.$style.mark }, [n("icon", { style: e.disabled ? { opacity: 0.5 } : {}, attrs: { type: e.iconProps.type, name: e.checked ? "outline/checked" : "outline/checked-un", size: e.iconProps.size, color: e.iconProps.color } })], 1), e.label ? n("span", { class: e.$style.label, style: e.styleLabel }, [e._t("default", function() {
    return [e._v(e._s(e.label))];
  })], 2) : e._e()]);
}, ZK = [];
const LC = {
  $style: UK
};
function XK(t) {
  for (var e in LC)
    this[e] = LC[e];
}
var KK = /* @__PURE__ */ B(
  GK,
  YK,
  ZK,
  !1,
  XK,
  null
);
const qa = KK.exports, JK = "_root_1dku1_1", qK = "_wrapper_1dku1_10", QK = "_title_1dku1_16", eJ = "_field_1dku1_17", tJ = "_label_1dku1_40", nJ = "_input_1dku1_41", rJ = "_checkbox_1dku1_60", sJ = "_error_1dku1_64", iJ = "_supportLink_1dku1_73", oJ = "_button_1dku1_88", aJ = {
  root: JK,
  wrapper: qK,
  title: QK,
  field: eJ,
  label: tJ,
  input: nJ,
  checkbox: rJ,
  error: sJ,
  supportLink: iJ,
  button: oJ
}, lJ = {
  name: "AuthForm",
  components: {
    PbButton: nt,
    PbCheckbox: qa
  },
  data() {
    return {
      username: "",
      password: "",
      keepLoggedIn: !1,
      errors: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    ...ge("auth", ["login"]),
    async handleLogin() {
      if (this.username || (this.errors.username = "Введите логин"), this.password || (this.errors.password = "Введите пароль"), !this.username || !this.password) return;
      const t = await this.login({
        username: this.username,
        password: this.password,
        keepLoggedIn: this.keepLoggedIn
      });
      if (t.errors)
        t.errors.map(({ code: e }) => e).find((e) => e === "AUTH_INVALID_PASSWORD") || (this.errors.password = ""), t.errors.map(({ code: e }) => e).find(
          (e) => e === "AUTH_USER_NOT_FOUND" || e === "AUTH_USER_BLOCKED"
        ) || (this.errors.username = ""), t.errors.forEach((e) => {
          e.code === "AUTH_INVALID_PASSWORD" && (this.errors.password = e.title), (e.code === "AUTH_USER_NOT_FOUND" || e.code === "AUTH_USER_BLOCKED") && (this.errors.username = e.title), e.code === "UNPROCESSABLE_ENTITY" && e.source && e.source.pointer === "/data/attributes/username" && (this.errors.username = e.detail);
        });
      else {
        const e = this.$route.query.next;
        e ? this.$router.push({ path: e }).catch(() => null) : this.$router.push({ name: "workspace" }).catch(() => null);
      }
    }
  },
  watch: {
    username: function(t, e) {
      t !== e && (this.errors.username = "");
    },
    password: function(t, e) {
      t !== e && (this.errors.password = "");
    }
  }
};
var cJ = function() {
  var e = this, n = e._self._c;
  return n("section", { class: e.$style.root, attrs: { "data-test-selector": "auth-form" } }, [n("div", { class: e.$style.wrapper }, [n("h1", { class: e.$style.title, attrs: { "data-test-selector": "auth-form-title" } }, [e._v(" Авторизация "), e._l(e.errors, function(r, s) {
    return n("span", { key: s, class: e.$style.error }, [e._v(e._s(r && r.detail ? r.detail : null))]);
  })], 2), n("form", { class: e.$style.form, on: { keyup: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "enter", 13, r.key, "Enter") || r.ctrlKey || r.shiftKey || r.altKey || r.metaKey ? null : e.handleLogin.apply(null, arguments);
  } } }, [n("div", { class: e.$style.field }, [n("label", { class: e.$style.label, attrs: { for: "username" } }, [e._v("Логин")]), n("input", { directives: [{ name: "model", rawName: "v-model.trim", value: e.username, expression: "username", modifiers: { trim: !0 } }], ref: "username", class: e.$style.input, attrs: { id: "username", name: "username", type: "email", title: "Логин", autocomplete: "email", maxlength: "255", "data-test-selector": "username-field" }, domProps: { value: e.username }, on: { keypress: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "tab", 9, r.key, "Tab") ? null : e.selectNextInput.bind(this, "username");
  }, input: function(r) {
    r.target.composing || (e.username = r.target.value.trim());
  }, blur: function(r) {
    return e.$forceUpdate();
  } } }), e.errors.username ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "username-error" } }, [e._v(" " + e._s(e.errors.username) + " ")]) : e._e()]), n("div", { class: e.$style.field }, [n("label", { class: e.$style.label, attrs: { for: "password" } }, [e._v("Пароль")]), n("input", { directives: [{ name: "model", rawName: "v-model.trim", value: e.password, expression: "password", modifiers: { trim: !0 } }], ref: "password", class: e.$style.input, attrs: { id: "password", name: "password", type: "password", title: "Пароль", autocomplete: "current-password", "data-test-selector": "password-field" }, domProps: { value: e.password }, on: { input: function(r) {
    r.target.composing || (e.password = r.target.value.trim());
  }, blur: function(r) {
    return e.$forceUpdate();
  } } }), e.errors.password ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "password-error" } }, [e._v(" " + e._s(e.errors.password) + " ")]) : e._e()]), n("div", { class: e.$style.field }, [n("PbCheckbox", { ref: "keepLoggedIn", class: e.$style.checkbox, attrs: { label: "Запомнить меня", color: "primary", attributes: { "data-test-selector": "remember-me-field" } }, model: { value: e.keepLoggedIn, callback: function(r) {
    e.keepLoggedIn = r;
  }, expression: "keepLoggedIn" } })], 1), n("div", { class: e.$style.field }, [n("PbButton", { class: e.$style.button, attrs: { "data-test-selector": "submit-button" }, on: { click: e.handleLogin } }, [e._v("Войти в систему")])], 1)])]), n("div", { class: e.$style.supportLink }, [e._v(" Если вы забыли пароль," + e._s(" ") + " "), n("router-link", { attrs: { to: { name: "resetPassword" } } }, [e._v("восстановите его")])], 1)]);
}, uJ = [];
const FC = {
  $style: aJ
};
function dJ(t) {
  for (var e in FC)
    this[e] = FC[e];
}
var fJ = /* @__PURE__ */ B(
  lJ,
  cJ,
  uJ,
  !1,
  dJ,
  null
);
const d5 = fJ.exports, pJ = "_root_jq30a_1", hJ = "_root_isOverlay_jq30a_8", mJ = {
  root: pJ,
  root_isOverlay: hJ
}, vJ = {
  name: "Auth",
  props: {
    isOverlay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      errors: []
    };
  },
  computed: {
    component() {
      return this.isOverlay ? d5 : this.$route.meta.component;
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_isOverlay]: this.isOverlay
      };
    }
  }
};
var gJ = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass, attrs: { "data-test-selector": "auth-page" } }, [n(e.component, { tag: "component" })], 1);
}, yJ = [];
const BC = {
  $style: mJ
};
function bJ(t) {
  for (var e in BC)
    this[e] = BC[e];
}
var _J = /* @__PURE__ */ B(
  vJ,
  gJ,
  yJ,
  !1,
  bJ,
  null
);
const x_ = _J.exports, wJ = [
  "#4D3400",
  "#751102",
  "#743E01",
  "#999100",
  "#B47A00",
  "#E92308",
  "#FF6907",
  "#FF8A04",
  "#FFAD00",
  "#F3C500",
  "#00F49F",
  "#00C0B4",
  "#C16A26",
  "#A94D24",
  "#B52E29",
  "#3BA900",
  "#00E926",
  "#A2FF1E",
  "#CEDD15",
  "#719A11",
  "#007681",
  "#0084A8",
  "#009DF5",
  "#0000C2",
  "#9E00A9",
  "#560082",
  "#670060",
  "#E500F6",
  "#B50360",
  "#E90F3A",
  "#DC6C6B",
  "#F63C6C",
  "#81212C",
  "#F533B8",
  "#711DCF",
  "#367EF5",
  "#142F5A",
  "#116657",
  "#158234",
  "#FF0889",
  "#A77550",
  "#DC6C6B",
  "#FFC67B",
  "#DC8A69",
  "#95DC65",
  "#4D682F",
  "#53B487",
  "#72E9F3",
  "#74C8F4",
  "#567AB5",
  "#F3BFB5",
  "#CDAE98",
  "#FFECBD",
  "#D2E8A9",
  "#826BE9",
  "#D778FF",
  "#E971A2",
  "#743668",
  "#385674",
  "#8C7C68",
  "#A0D9CE",
  "#BCFFBC",
  "#737B9A",
  "#ABB9E8",
  "#B4DDF3",
  "#A0D9CE",
  "#E2BCFF",
  "#A47AA7",
  "#E8ABBB",
  "#57499B"
], SJ = [
  "#4D3400",
  "#751102",
  "#743E01",
  "#999100",
  "#B47A00",
  "#E92308",
  "#FF6907",
  "#FF8A04",
  "#FFAD00",
  "#F3C500",
  "#00F49F",
  "#00C0B4",
  "#C16A26",
  "#A94D24",
  "#B52E29",
  "#3BA900",
  "#00E926",
  "#A2FF1E",
  "#CEDD15",
  "#719A11",
  "#007681",
  "#0084A8",
  "#009DF5",
  "#0000C2",
  "#9E00A9",
  "#560082",
  "#670060",
  "#E500F6",
  "#B50360",
  "#E90F3A",
  "#DC6C6B",
  "#F63C6C",
  "#81212C",
  "#F533B8",
  "#711DCF",
  "#367EF5",
  "#142F5A",
  "#116657",
  "#158234",
  "#A77550",
  "#4D682F",
  "#53B487",
  "#567AB5",
  "#E971A2",
  "#743668",
  "#385674",
  "#8C7C68",
  "#737B9A",
  "#A47AA7",
  "#57499B"
], IJ = {
  TERRORIST_GROUPS: "#ED5C5C",
  UNWANTED_FOREIGN_ORGANIZATIONS: "#B8B233",
  NONPROFIT_EXTREMIST_ORGANIZATIONS: "#4DBB4B",
  RELIGIOUS_OR_PUBLIC_EXTREMIST_ACTIVITIES: "#604D1E",
  MEDIA_FOREIGN_AGENTS: "#EEC45C",
  NONPROFIT_FOREIGN_AGENTS: "#5C85EE",
  UNREGISTERED_FOREIGN_AGENTS: "#5C85EE",
  PERSON_FOREIGN_AGENTS: "#50889E",
  UNIVERSAL_REGISTRY_OF_FOREIGN_AGENTS: "#9607b2"
};
function jC(t = 0, e = 0, n = 300) {
  const r = Date.now(), s = document.querySelector("#legacy-app"), i = s.scrollLeft, o = t - i;
  let a;
  const l = () => {
    const c = Date.now() - r, u = c / n - 1, d = u * u * u + 1, f = Math.round(i + o * d);
    c < n && f !== t ? (s.scrollTo({ left: f, top: e, behavior: "auto" }), a = requestAnimationFrame(l)) : (s.scrollTo({ top: e, left: t, behavior: "auto" }), cancelAnimationFrame(a));
  };
  a = requestAnimationFrame(l);
}
function su(t, e) {
  return e[t % 10 === 1 && t % 100 !== 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2];
}
function cy(t, e) {
  const n = parseInt(t.slice(1, 3), 16), r = parseInt(t.slice(3, 5), 16), s = parseInt(t.slice(5, 7), 16);
  return e ? "rgba(" + n + ", " + r + ", " + s + ", " + e + ")" : "rgb(" + n + ", " + r + ", " + s + ")";
}
function EJ(t) {
  var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t), n = parseInt(e[1], 16), r = parseInt(e[2], 16), s = parseInt(e[3], 16);
  n /= 255, r /= 255, s /= 255;
  var i = Math.max(n, r, s), o = Math.min(n, r, s), a, l, c = (i + o) / 2;
  if (i == o)
    a = l = 0;
  else {
    var u = i - o;
    switch (l = c > 0.5 ? u / (2 - i - o) : u / (i + o), i) {
      case n:
        a = (r - s) / u + (r < s ? 6 : 0);
        break;
      case r:
        a = (s - n) / u + 2;
        break;
      case s:
        a = (n - r) / u + 4;
        break;
    }
    a /= 6;
  }
  return a *= 360, l *= 100, c *= 100, new dm({ h: a, s: l, l: c });
}
class dm {
  constructor({ h: e = 0, s: n = 0, l: r = 0 }) {
    return this.h = e, this.s = n, this.l = r, this;
  }
  shift({ h: e = 0, s: n = 0, l: r = 0 }) {
    const s = new dm(this);
    return s.h += e, s.s += n, s.l += r, s;
  }
  set({ h: e, s: n, l: r }) {
    const s = new dm(this);
    return e && (s.h = e), n && (s.s = n), r && (s.l = r), s;
  }
  toString() {
    return `hsl(${this.h}, ${this.s}%, ${this.l}%)`;
  }
}
function xJ(t) {
  let e = 0, n = 0, r = 0;
  function s(o, a) {
    let l = "";
    if ((a === "seconds" || a === "minutes") && (o < 10 || o > 20)) {
      let c = +("" + o)[("" + o).length - 1];
      c === 1 && (l = "у"), (c === 2 || c === 3 || c === 4) && (l = "ы");
    }
    if (a === "hours" && (l = "ов", o < 10 || o > 20)) {
      let c = +("" + o)[("" + o).length - 1];
      c === 1 && (l = ""), (c === 2 || c === 3 || c === 4) && (l = "а");
    }
    return l;
  }
  if (t >= 3600) {
    r = Math.floor(t / 3600);
    let o = t % 3600;
    n = Math.floor(o / 60), e = o % 60;
  } else
    r = 0;
  t >= 60 ? (n = Math.floor(t % 3600 / 60), e = t % 60 % 60) : (n = 0, e = t);
  let i = "";
  return r && (i = i + r + ` час${s(r, "hours")}`), n && (i = i + " " + n + ` минут${s(n, "minutes")}`), e && (i = i + " " + e + ` секунд${s(e, "seconds")}`), i.trim();
}
var C_ = { exports: {} }, T_ = { exports: {} }, f5 = { exports: {} };
(function(t) {
  function e(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(f5);
var Jn = f5.exports, P_ = { exports: {} }, k_ = { exports: {} }, p5 = { exports: {} };
(function(t) {
  function e(n) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(p5);
var h5 = p5.exports, N_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, s) {
    if (s.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + s.length + " present");
  }
  t.exports = e.default;
})(N_, N_.exports);
var Ms = N_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = n(h5), s = n(Ms);
  function i(o) {
    return (0, s.default)(1, arguments), o instanceof Date || (0, r.default)(o) === "object" && Object.prototype.toString.call(o) === "[object Date]";
  }
  t.exports = e.default;
})(k_, k_.exports);
var CJ = k_.exports, $_ = { exports: {} };
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = n(h5), s = n(Ms);
  function i(o) {
    (0, s.default)(1, arguments);
    var a = Object.prototype.toString.call(o);
    return o instanceof Date || (0, r.default)(o) === "object" && a === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || a === "[object Number]" ? new Date(o) : ((typeof o == "string" || a === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})($_, $_.exports);
var Eo = $_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = n(CJ), s = n(Eo), i = n(Ms);
  function o(a) {
    if ((0, i.default)(1, arguments), !(0, r.default)(a) && typeof a != "number")
      return !1;
    var l = (0, s.default)(a);
    return !isNaN(Number(l));
  }
  t.exports = e.default;
})(P_, P_.exports);
var TJ = P_.exports, D_ = { exports: {} }, A_ = { exports: {} }, O_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var s = Number(r);
    return isNaN(s) ? s : s < 0 ? Math.ceil(s) : Math.floor(s);
  }
  t.exports = e.default;
})(O_, O_.exports);
var rc = O_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = n(rc), s = n(Eo), i = n(Ms);
  function o(a, l) {
    (0, i.default)(2, arguments);
    var c = (0, s.default)(a).getTime(), u = (0, r.default)(l);
    return new Date(c + u);
  }
  t.exports = e.default;
})(A_, A_.exports);
var PJ = A_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = n(PJ), s = n(Ms), i = n(rc);
  function o(a, l) {
    (0, s.default)(2, arguments);
    var c = (0, i.default)(l);
    return (0, r.default)(a, -c);
  }
  t.exports = e.default;
})(D_, D_.exports);
var kJ = D_.exports, M_ = { exports: {} }, R_ = { exports: {} };
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = n(Eo), s = n(Ms), i = 864e5;
  function o(a) {
    (0, s.default)(1, arguments);
    var l = (0, r.default)(a), c = l.getTime();
    l.setUTCMonth(0, 1), l.setUTCHours(0, 0, 0, 0);
    var u = l.getTime(), d = c - u;
    return Math.floor(d / i) + 1;
  }
  t.exports = e.default;
})(R_, R_.exports);
var NJ = R_.exports, L_ = { exports: {} }, F_ = { exports: {} };
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = n(Eo), s = n(Ms);
  function i(o) {
    (0, s.default)(1, arguments);
    var a = 1, l = (0, r.default)(o), c = l.getUTCDay(), u = (c < a ? 7 : 0) + c - a;
    return l.setUTCDate(l.getUTCDate() - u), l.setUTCHours(0, 0, 0, 0), l;
  }
  t.exports = e.default;
})(F_, F_.exports);
var mS = F_.exports, B_ = { exports: {} }, j_ = { exports: {} };
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = n(Eo), s = n(Ms), i = n(mS);
  function o(a) {
    (0, s.default)(1, arguments);
    var l = (0, r.default)(a), c = l.getUTCFullYear(), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(c + 1, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var d = (0, i.default)(u), f = /* @__PURE__ */ new Date(0);
    f.setUTCFullYear(c, 0, 4), f.setUTCHours(0, 0, 0, 0);
    var p = (0, i.default)(f);
    return l.getTime() >= d.getTime() ? c + 1 : l.getTime() >= p.getTime() ? c : c - 1;
  }
  t.exports = e.default;
})(j_, j_.exports);
var m5 = j_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = n(m5), s = n(mS), i = n(Ms);
  function o(a) {
    (0, i.default)(1, arguments);
    var l = (0, r.default)(a), c = /* @__PURE__ */ new Date(0);
    c.setUTCFullYear(l, 0, 4), c.setUTCHours(0, 0, 0, 0);
    var u = (0, s.default)(c);
    return u;
  }
  t.exports = e.default;
})(B_, B_.exports);
var $J = B_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(Eo), s = n(mS), i = n($J), o = n(Ms), a = 6048e5;
  function l(c) {
    (0, o.default)(1, arguments);
    var u = (0, r.default)(c), d = (0, s.default)(u).getTime() - (0, i.default)(u).getTime();
    return Math.round(d / a) + 1;
  }
  t.exports = e.default;
})(L_, L_.exports);
var DJ = L_.exports, W_ = { exports: {} }, H_ = { exports: {} }, sc = {};
Object.defineProperty(sc, "__esModule", {
  value: !0
});
sc.getDefaultOptions = AJ;
sc.setDefaultOptions = OJ;
var v5 = {};
function AJ() {
  return v5;
}
function OJ(t) {
  v5 = t;
}
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(Eo), s = n(Ms), i = n(rc), o = sc;
  function a(l, c) {
    var u, d, f, p, h, m, v, y;
    (0, s.default)(1, arguments);
    var _ = (0, o.getDefaultOptions)(), w = (0, i.default)((u = (d = (f = (p = c == null ? void 0 : c.weekStartsOn) !== null && p !== void 0 ? p : c == null || (h = c.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && f !== void 0 ? f : _.weekStartsOn) !== null && d !== void 0 ? d : (v = _.locale) === null || v === void 0 || (y = v.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && u !== void 0 ? u : 0);
    if (!(w >= 0 && w <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var S = (0, r.default)(l), E = S.getUTCDay(), x = (E < w ? 7 : 0) + E - w;
    return S.setUTCDate(S.getUTCDate() - x), S.setUTCHours(0, 0, 0, 0), S;
  }
  t.exports = e.default;
})(H_, H_.exports);
var vS = H_.exports, V_ = { exports: {} }, z_ = { exports: {} };
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(Eo), s = n(Ms), i = n(vS), o = n(rc), a = sc;
  function l(c, u) {
    var d, f, p, h, m, v, y, _;
    (0, s.default)(1, arguments);
    var w = (0, r.default)(c), S = w.getUTCFullYear(), E = (0, a.getDefaultOptions)(), x = (0, o.default)((d = (f = (p = (h = u == null ? void 0 : u.firstWeekContainsDate) !== null && h !== void 0 ? h : u == null || (m = u.locale) === null || m === void 0 || (v = m.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && p !== void 0 ? p : E.firstWeekContainsDate) !== null && f !== void 0 ? f : (y = E.locale) === null || y === void 0 || (_ = y.options) === null || _ === void 0 ? void 0 : _.firstWeekContainsDate) !== null && d !== void 0 ? d : 1);
    if (!(x >= 1 && x <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var T = /* @__PURE__ */ new Date(0);
    T.setUTCFullYear(S + 1, 0, x), T.setUTCHours(0, 0, 0, 0);
    var C = (0, i.default)(T, u), k = /* @__PURE__ */ new Date(0);
    k.setUTCFullYear(S, 0, x), k.setUTCHours(0, 0, 0, 0);
    var b = (0, i.default)(k, u);
    return w.getTime() >= C.getTime() ? S + 1 : w.getTime() >= b.getTime() ? S : S - 1;
  }
  t.exports = e.default;
})(z_, z_.exports);
var g5 = z_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(g5), s = n(Ms), i = n(vS), o = n(rc), a = sc;
  function l(c, u) {
    var d, f, p, h, m, v, y, _;
    (0, s.default)(1, arguments);
    var w = (0, a.getDefaultOptions)(), S = (0, o.default)((d = (f = (p = (h = u == null ? void 0 : u.firstWeekContainsDate) !== null && h !== void 0 ? h : u == null || (m = u.locale) === null || m === void 0 || (v = m.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && p !== void 0 ? p : w.firstWeekContainsDate) !== null && f !== void 0 ? f : (y = w.locale) === null || y === void 0 || (_ = y.options) === null || _ === void 0 ? void 0 : _.firstWeekContainsDate) !== null && d !== void 0 ? d : 1), E = (0, r.default)(c, u), x = /* @__PURE__ */ new Date(0);
    x.setUTCFullYear(E, 0, S), x.setUTCHours(0, 0, 0, 0);
    var T = (0, i.default)(x, u);
    return T;
  }
  t.exports = e.default;
})(V_, V_.exports);
var MJ = V_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(Eo), s = n(vS), i = n(MJ), o = n(Ms), a = 6048e5;
  function l(c, u) {
    (0, o.default)(1, arguments);
    var d = (0, r.default)(c), f = (0, s.default)(d, u).getTime() - (0, i.default)(d, u).getTime();
    return Math.round(f / a) + 1;
  }
  t.exports = e.default;
})(W_, W_.exports);
var RJ = W_.exports, U_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, s) {
    for (var i = r < 0 ? "-" : "", o = Math.abs(r).toString(); o.length < s; )
      o = "0" + o;
    return i + o;
  }
  t.exports = e.default;
})(U_, U_.exports);
var y5 = U_.exports, G_ = { exports: {} };
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(y5), s = {
    // Year
    y: function(a, l) {
      var c = a.getUTCFullYear(), u = c > 0 ? c : 1 - c;
      return (0, r.default)(l === "yy" ? u % 100 : u, l.length);
    },
    // Month
    M: function(a, l) {
      var c = a.getUTCMonth();
      return l === "M" ? String(c + 1) : (0, r.default)(c + 1, 2);
    },
    // Day of the month
    d: function(a, l) {
      return (0, r.default)(a.getUTCDate(), l.length);
    },
    // AM or PM
    a: function(a, l) {
      var c = a.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (l) {
        case "a":
        case "aa":
          return c.toUpperCase();
        case "aaa":
          return c;
        case "aaaaa":
          return c[0];
        case "aaaa":
        default:
          return c === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(a, l) {
      return (0, r.default)(a.getUTCHours() % 12 || 12, l.length);
    },
    // Hour [0-23]
    H: function(a, l) {
      return (0, r.default)(a.getUTCHours(), l.length);
    },
    // Minute
    m: function(a, l) {
      return (0, r.default)(a.getUTCMinutes(), l.length);
    },
    // Second
    s: function(a, l) {
      return (0, r.default)(a.getUTCSeconds(), l.length);
    },
    // Fraction of second
    S: function(a, l) {
      var c = l.length, u = a.getUTCMilliseconds(), d = Math.floor(u * Math.pow(10, c - 3));
      return (0, r.default)(d, l.length);
    }
  }, i = s;
  e.default = i, t.exports = e.default;
})(G_, G_.exports);
var LJ = G_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(NJ), s = n(DJ), i = n(m5), o = n(RJ), a = n(g5), l = n(y5), c = n(LJ), u = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, d = {
    // Era
    G: function(y, _, w) {
      var S = y.getUTCFullYear() > 0 ? 1 : 0;
      switch (_) {
        case "G":
        case "GG":
        case "GGG":
          return w.era(S, {
            width: "abbreviated"
          });
        case "GGGGG":
          return w.era(S, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return w.era(S, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(y, _, w) {
      if (_ === "yo") {
        var S = y.getUTCFullYear(), E = S > 0 ? S : 1 - S;
        return w.ordinalNumber(E, {
          unit: "year"
        });
      }
      return c.default.y(y, _);
    },
    // Local week-numbering year
    Y: function(y, _, w, S) {
      var E = (0, a.default)(y, S), x = E > 0 ? E : 1 - E;
      if (_ === "YY") {
        var T = x % 100;
        return (0, l.default)(T, 2);
      }
      return _ === "Yo" ? w.ordinalNumber(x, {
        unit: "year"
      }) : (0, l.default)(x, _.length);
    },
    // ISO week-numbering year
    R: function(y, _) {
      var w = (0, i.default)(y);
      return (0, l.default)(w, _.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(y, _) {
      var w = y.getUTCFullYear();
      return (0, l.default)(w, _.length);
    },
    // Quarter
    Q: function(y, _, w) {
      var S = Math.ceil((y.getUTCMonth() + 1) / 3);
      switch (_) {
        case "Q":
          return String(S);
        case "QQ":
          return (0, l.default)(S, 2);
        case "Qo":
          return w.ordinalNumber(S, {
            unit: "quarter"
          });
        case "QQQ":
          return w.quarter(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return w.quarter(S, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return w.quarter(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(y, _, w) {
      var S = Math.ceil((y.getUTCMonth() + 1) / 3);
      switch (_) {
        case "q":
          return String(S);
        case "qq":
          return (0, l.default)(S, 2);
        case "qo":
          return w.ordinalNumber(S, {
            unit: "quarter"
          });
        case "qqq":
          return w.quarter(S, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return w.quarter(S, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return w.quarter(S, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(y, _, w) {
      var S = y.getUTCMonth();
      switch (_) {
        case "M":
        case "MM":
          return c.default.M(y, _);
        case "Mo":
          return w.ordinalNumber(S + 1, {
            unit: "month"
          });
        case "MMM":
          return w.month(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return w.month(S, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return w.month(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(y, _, w) {
      var S = y.getUTCMonth();
      switch (_) {
        case "L":
          return String(S + 1);
        case "LL":
          return (0, l.default)(S + 1, 2);
        case "Lo":
          return w.ordinalNumber(S + 1, {
            unit: "month"
          });
        case "LLL":
          return w.month(S, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return w.month(S, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return w.month(S, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(y, _, w, S) {
      var E = (0, o.default)(y, S);
      return _ === "wo" ? w.ordinalNumber(E, {
        unit: "week"
      }) : (0, l.default)(E, _.length);
    },
    // ISO week of year
    I: function(y, _, w) {
      var S = (0, s.default)(y);
      return _ === "Io" ? w.ordinalNumber(S, {
        unit: "week"
      }) : (0, l.default)(S, _.length);
    },
    // Day of the month
    d: function(y, _, w) {
      return _ === "do" ? w.ordinalNumber(y.getUTCDate(), {
        unit: "date"
      }) : c.default.d(y, _);
    },
    // Day of year
    D: function(y, _, w) {
      var S = (0, r.default)(y);
      return _ === "Do" ? w.ordinalNumber(S, {
        unit: "dayOfYear"
      }) : (0, l.default)(S, _.length);
    },
    // Day of week
    E: function(y, _, w) {
      var S = y.getUTCDay();
      switch (_) {
        case "E":
        case "EE":
        case "EEE":
          return w.day(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return w.day(S, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return w.day(S, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return w.day(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(y, _, w, S) {
      var E = y.getUTCDay(), x = (E - S.weekStartsOn + 8) % 7 || 7;
      switch (_) {
        case "e":
          return String(x);
        case "ee":
          return (0, l.default)(x, 2);
        case "eo":
          return w.ordinalNumber(x, {
            unit: "day"
          });
        case "eee":
          return w.day(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return w.day(E, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return w.day(E, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return w.day(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(y, _, w, S) {
      var E = y.getUTCDay(), x = (E - S.weekStartsOn + 8) % 7 || 7;
      switch (_) {
        case "c":
          return String(x);
        case "cc":
          return (0, l.default)(x, _.length);
        case "co":
          return w.ordinalNumber(x, {
            unit: "day"
          });
        case "ccc":
          return w.day(E, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return w.day(E, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return w.day(E, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return w.day(E, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(y, _, w) {
      var S = y.getUTCDay(), E = S === 0 ? 7 : S;
      switch (_) {
        case "i":
          return String(E);
        case "ii":
          return (0, l.default)(E, _.length);
        case "io":
          return w.ordinalNumber(E, {
            unit: "day"
          });
        case "iii":
          return w.day(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return w.day(S, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return w.day(S, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return w.day(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(y, _, w) {
      var S = y.getUTCHours(), E = S / 12 >= 1 ? "pm" : "am";
      switch (_) {
        case "a":
        case "aa":
          return w.dayPeriod(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return w.dayPeriod(E, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return w.dayPeriod(E, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return w.dayPeriod(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(y, _, w) {
      var S = y.getUTCHours(), E;
      switch (S === 12 ? E = u.noon : S === 0 ? E = u.midnight : E = S / 12 >= 1 ? "pm" : "am", _) {
        case "b":
        case "bb":
          return w.dayPeriod(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return w.dayPeriod(E, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return w.dayPeriod(E, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return w.dayPeriod(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(y, _, w) {
      var S = y.getUTCHours(), E;
      switch (S >= 17 ? E = u.evening : S >= 12 ? E = u.afternoon : S >= 4 ? E = u.morning : E = u.night, _) {
        case "B":
        case "BB":
        case "BBB":
          return w.dayPeriod(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return w.dayPeriod(E, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return w.dayPeriod(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(y, _, w) {
      if (_ === "ho") {
        var S = y.getUTCHours() % 12;
        return S === 0 && (S = 12), w.ordinalNumber(S, {
          unit: "hour"
        });
      }
      return c.default.h(y, _);
    },
    // Hour [0-23]
    H: function(y, _, w) {
      return _ === "Ho" ? w.ordinalNumber(y.getUTCHours(), {
        unit: "hour"
      }) : c.default.H(y, _);
    },
    // Hour [0-11]
    K: function(y, _, w) {
      var S = y.getUTCHours() % 12;
      return _ === "Ko" ? w.ordinalNumber(S, {
        unit: "hour"
      }) : (0, l.default)(S, _.length);
    },
    // Hour [1-24]
    k: function(y, _, w) {
      var S = y.getUTCHours();
      return S === 0 && (S = 24), _ === "ko" ? w.ordinalNumber(S, {
        unit: "hour"
      }) : (0, l.default)(S, _.length);
    },
    // Minute
    m: function(y, _, w) {
      return _ === "mo" ? w.ordinalNumber(y.getUTCMinutes(), {
        unit: "minute"
      }) : c.default.m(y, _);
    },
    // Second
    s: function(y, _, w) {
      return _ === "so" ? w.ordinalNumber(y.getUTCSeconds(), {
        unit: "second"
      }) : c.default.s(y, _);
    },
    // Fraction of second
    S: function(y, _) {
      return c.default.S(y, _);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(y, _, w, S) {
      var E = S._originalDate || y, x = E.getTimezoneOffset();
      if (x === 0)
        return "Z";
      switch (_) {
        case "X":
          return p(x);
        case "XXXX":
        case "XX":
          return h(x);
        case "XXXXX":
        case "XXX":
        default:
          return h(x, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(y, _, w, S) {
      var E = S._originalDate || y, x = E.getTimezoneOffset();
      switch (_) {
        case "x":
          return p(x);
        case "xxxx":
        case "xx":
          return h(x);
        case "xxxxx":
        case "xxx":
        default:
          return h(x, ":");
      }
    },
    // Timezone (GMT)
    O: function(y, _, w, S) {
      var E = S._originalDate || y, x = E.getTimezoneOffset();
      switch (_) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + f(x, ":");
        case "OOOO":
        default:
          return "GMT" + h(x, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(y, _, w, S) {
      var E = S._originalDate || y, x = E.getTimezoneOffset();
      switch (_) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + f(x, ":");
        case "zzzz":
        default:
          return "GMT" + h(x, ":");
      }
    },
    // Seconds timestamp
    t: function(y, _, w, S) {
      var E = S._originalDate || y, x = Math.floor(E.getTime() / 1e3);
      return (0, l.default)(x, _.length);
    },
    // Milliseconds timestamp
    T: function(y, _, w, S) {
      var E = S._originalDate || y, x = E.getTime();
      return (0, l.default)(x, _.length);
    }
  };
  function f(v, y) {
    var _ = v > 0 ? "-" : "+", w = Math.abs(v), S = Math.floor(w / 60), E = w % 60;
    if (E === 0)
      return _ + String(S);
    var x = y;
    return _ + String(S) + x + (0, l.default)(E, 2);
  }
  function p(v, y) {
    if (v % 60 === 0) {
      var _ = v > 0 ? "-" : "+";
      return _ + (0, l.default)(Math.abs(v) / 60, 2);
    }
    return h(v, y);
  }
  function h(v, y) {
    var _ = y || "", w = v > 0 ? "-" : "+", S = Math.abs(v), E = (0, l.default)(Math.floor(S / 60), 2), x = (0, l.default)(S % 60, 2);
    return w + E + _ + x;
  }
  var m = d;
  e.default = m, t.exports = e.default;
})(M_, M_.exports);
var FJ = M_.exports, Y_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = function(l, c) {
    switch (l) {
      case "P":
        return c.date({
          width: "short"
        });
      case "PP":
        return c.date({
          width: "medium"
        });
      case "PPP":
        return c.date({
          width: "long"
        });
      case "PPPP":
      default:
        return c.date({
          width: "full"
        });
    }
  }, r = function(l, c) {
    switch (l) {
      case "p":
        return c.time({
          width: "short"
        });
      case "pp":
        return c.time({
          width: "medium"
        });
      case "ppp":
        return c.time({
          width: "long"
        });
      case "pppp":
      default:
        return c.time({
          width: "full"
        });
    }
  }, s = function(l, c) {
    var u = l.match(/(P+)(p+)?/) || [], d = u[1], f = u[2];
    if (!f)
      return n(l, c);
    var p;
    switch (d) {
      case "P":
        p = c.dateTime({
          width: "short"
        });
        break;
      case "PP":
        p = c.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        p = c.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        p = c.dateTime({
          width: "full"
        });
        break;
    }
    return p.replace("{{date}}", n(d, c)).replace("{{time}}", r(f, c));
  }, i = {
    p: r,
    P: s
  }, o = i;
  e.default = o, t.exports = e.default;
})(Y_, Y_.exports);
var BJ = Y_.exports, Z_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    var s = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return s.setUTCFullYear(r.getFullYear()), r.getTime() - s.getTime();
  }
  t.exports = e.default;
})(Z_, Z_.exports);
var b5 = Z_.exports, Of = {};
Object.defineProperty(Of, "__esModule", {
  value: !0
});
Of.isProtectedDayOfYearToken = HJ;
Of.isProtectedWeekYearToken = VJ;
Of.throwProtectedError = zJ;
var jJ = ["D", "DD"], WJ = ["YY", "YYYY"];
function HJ(t) {
  return jJ.indexOf(t) !== -1;
}
function VJ(t) {
  return WJ.indexOf(t) !== -1;
}
function zJ(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var X_ = { exports: {} }, K_ = { exports: {} }, J_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(o, a, l) {
    var c, u = n[o];
    return typeof u == "string" ? c = u : a === 1 ? c = u.one : c = u.other.replace("{{count}}", a.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + c : c + " ago" : c;
  }, s = r;
  e.default = s, t.exports = e.default;
})(J_, J_.exports);
var UJ = J_.exports, q_ = { exports: {} }, Q_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = s.width ? String(s.width) : r.defaultWidth, o = r.formats[i] || r.formats[r.defaultWidth];
      return o;
    };
  }
  t.exports = e.default;
})(Q_, Q_.exports);
var GJ = Q_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(GJ), s = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, o = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, a = {
    date: (0, r.default)({
      formats: s,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    })
  }, l = a;
  e.default = l, t.exports = e.default;
})(q_, q_.exports);
var YJ = q_.exports, e0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(o, a, l, c) {
    return n[o];
  }, s = r;
  e.default = s, t.exports = e.default;
})(e0, e0.exports);
var ZJ = e0.exports, t0 = { exports: {} }, n0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function(s, i) {
      var o = i != null && i.context ? String(i.context) : "standalone", a;
      if (o === "formatting" && r.formattingValues) {
        var l = r.defaultFormattingWidth || r.defaultWidth, c = i != null && i.width ? String(i.width) : l;
        a = r.formattingValues[c] || r.formattingValues[l];
      } else {
        var u = r.defaultWidth, d = i != null && i.width ? String(i.width) : r.defaultWidth;
        a = r.values[d] || r.values[u];
      }
      var f = r.argumentCallback ? r.argumentCallback(s) : s;
      return a[f];
    };
  }
  t.exports = e.default;
})(n0, n0.exports);
var XJ = n0.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(XJ), s = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, o = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, a = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, c = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, u = function(h, m) {
    var v = Number(h), y = v % 100;
    if (y > 20 || y < 10)
      switch (y % 10) {
        case 1:
          return v + "st";
        case 2:
          return v + "nd";
        case 3:
          return v + "rd";
      }
    return v + "th";
  }, d = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(h) {
        return h - 1;
      }
    }),
    month: (0, r.default)({
      values: o,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: a,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: c,
      defaultFormattingWidth: "wide"
    })
  }, f = d;
  e.default = f, t.exports = e.default;
})(t0, t0.exports);
var KJ = t0.exports, r0 = { exports: {} }, s0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(i) {
    return function(o) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = a.width, c = l && i.matchPatterns[l] || i.matchPatterns[i.defaultMatchWidth], u = o.match(c);
      if (!u)
        return null;
      var d = u[0], f = l && i.parsePatterns[l] || i.parsePatterns[i.defaultParseWidth], p = Array.isArray(f) ? s(f, function(v) {
        return v.test(d);
      }) : r(f, function(v) {
        return v.test(d);
      }), h;
      h = i.valueCallback ? i.valueCallback(p) : p, h = a.valueCallback ? a.valueCallback(h) : h;
      var m = o.slice(d.length);
      return {
        value: h,
        rest: m
      };
    };
  }
  function r(i, o) {
    for (var a in i)
      if (i.hasOwnProperty(a) && o(i[a]))
        return a;
  }
  function s(i, o) {
    for (var a = 0; a < i.length; a++)
      if (o(i[a]))
        return a;
  }
  t.exports = e.default;
})(s0, s0.exports);
var JJ = s0.exports, i0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function(s) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = s.match(r.matchPattern);
      if (!o) return null;
      var a = o[0], l = s.match(r.parsePattern);
      if (!l) return null;
      var c = r.valueCallback ? r.valueCallback(l[0]) : l[0];
      c = i.valueCallback ? i.valueCallback(c) : c;
      var u = s.slice(a.length);
      return {
        value: c,
        rest: u
      };
    };
  }
  t.exports = e.default;
})(i0, i0.exports);
var qJ = i0.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(JJ), s = n(qJ), i = /^(\d+)(th|st|nd|rd)?/i, o = /\d+/i, a = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, l = {
    any: [/^b/i, /^(a|c)/i]
  }, c = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, d = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, f = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, p = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, h = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, m = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, v = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, y = {
    ordinalNumber: (0, s.default)({
      matchPattern: i,
      parsePattern: o,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: a,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: p,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: m,
      defaultMatchWidth: "any",
      parsePatterns: v,
      defaultParseWidth: "any"
    })
  }, _ = y;
  e.default = _, t.exports = e.default;
})(r0, r0.exports);
var QJ = r0.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(UJ), s = n(YJ), i = n(ZJ), o = n(KJ), a = n(QJ), l = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: i.default,
    localize: o.default,
    match: a.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, c = l;
  e.default = c, t.exports = e.default;
})(K_, K_.exports);
var eq = K_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(eq), s = r.default;
  e.default = s, t.exports = e.default;
})(X_, X_.exports);
var tq = X_.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = w;
  var r = n(TJ), s = n(kJ), i = n(Eo), o = n(FJ), a = n(BJ), l = n(b5), c = Of, u = n(rc), d = n(Ms), f = sc, p = n(tq), h = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, m = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, v = /^'([^]*?)'?$/, y = /''/g, _ = /[a-zA-Z]/;
  function w(E, x, T) {
    var C, k, b, P, N, D, H, Y, te, A, j, L, se, V, ee, O, K, z;
    (0, d.default)(2, arguments);
    var q = String(x), ae = (0, f.getDefaultOptions)(), Ee = (C = (k = T == null ? void 0 : T.locale) !== null && k !== void 0 ? k : ae.locale) !== null && C !== void 0 ? C : p.default, Ae = (0, u.default)((b = (P = (N = (D = T == null ? void 0 : T.firstWeekContainsDate) !== null && D !== void 0 ? D : T == null || (H = T.locale) === null || H === void 0 || (Y = H.options) === null || Y === void 0 ? void 0 : Y.firstWeekContainsDate) !== null && N !== void 0 ? N : ae.firstWeekContainsDate) !== null && P !== void 0 ? P : (te = ae.locale) === null || te === void 0 || (A = te.options) === null || A === void 0 ? void 0 : A.firstWeekContainsDate) !== null && b !== void 0 ? b : 1);
    if (!(Ae >= 1 && Ae <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var Ue = (0, u.default)((j = (L = (se = (V = T == null ? void 0 : T.weekStartsOn) !== null && V !== void 0 ? V : T == null || (ee = T.locale) === null || ee === void 0 || (O = ee.options) === null || O === void 0 ? void 0 : O.weekStartsOn) !== null && se !== void 0 ? se : ae.weekStartsOn) !== null && L !== void 0 ? L : (K = ae.locale) === null || K === void 0 || (z = K.options) === null || z === void 0 ? void 0 : z.weekStartsOn) !== null && j !== void 0 ? j : 0);
    if (!(Ue >= 0 && Ue <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!Ee.localize)
      throw new RangeError("locale must contain localize property");
    if (!Ee.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var qe = (0, i.default)(E);
    if (!(0, r.default)(qe))
      throw new RangeError("Invalid time value");
    var Qe = (0, l.default)(qe), Lt = (0, s.default)(qe, Qe), Yt = {
      firstWeekContainsDate: Ae,
      weekStartsOn: Ue,
      locale: Ee,
      _originalDate: qe
    }, nn = q.match(m).map(function(qt) {
      var rn = qt[0];
      if (rn === "p" || rn === "P") {
        var sn = a.default[rn];
        return sn(qt, Ee.formatLong);
      }
      return qt;
    }).join("").match(h).map(function(qt) {
      if (qt === "''")
        return "'";
      var rn = qt[0];
      if (rn === "'")
        return S(qt);
      var sn = o.default[rn];
      if (sn)
        return !(T != null && T.useAdditionalWeekYearTokens) && (0, c.isProtectedWeekYearToken)(qt) && (0, c.throwProtectedError)(qt, x, String(E)), !(T != null && T.useAdditionalDayOfYearTokens) && (0, c.isProtectedDayOfYearToken)(qt) && (0, c.throwProtectedError)(qt, x, String(E)), sn(Lt, qt, Ee.localize, Yt);
      if (rn.match(_))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + rn + "`");
      return qt;
    }).join("");
    return nn;
  }
  function S(E) {
    var x = E.match(v);
    return x ? x[1].replace(y, "'") : E;
  }
  t.exports = e.default;
})(T_, T_.exports);
var nq = T_.exports, o0 = { exports: {} }, a0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(o, a, l) {
    var c = i(o, l.timeZone, l.locale);
    return c.formatToParts ? r(c, a) : s(c, a);
  }
  function r(o, a) {
    for (var l = o.formatToParts(a), c = l.length - 1; c >= 0; --c)
      if (l[c].type === "timeZoneName")
        return l[c].value;
  }
  function s(o, a) {
    var l = o.format(a).replace(/\u200E/g, ""), c = / [\w-+ ]+$/.exec(l);
    return c ? c[0].substr(1) : "";
  }
  function i(o, a, l) {
    if (l && !l.code)
      throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(l ? [l.code, "en-US"] : void 0, {
      timeZone: a,
      timeZoneName: o
    });
  }
  t.exports = e.default;
})(a0, a0.exports);
var rq = a0.exports, l0 = { exports: {} }, c0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(l, c) {
    var u = a(c);
    return u.formatToParts ? s(u, l) : i(u, l);
  }
  var r = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
  };
  function s(l, c) {
    try {
      for (var u = l.formatToParts(c), d = [], f = 0; f < u.length; f++) {
        var p = r[u[f].type];
        p >= 0 && (d[p] = parseInt(u[f].value, 10));
      }
      return d;
    } catch (h) {
      if (h instanceof RangeError)
        return [NaN];
      throw h;
    }
  }
  function i(l, c) {
    var u = l.format(c).replace(/\u200E/g, ""), d = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(u);
    return [d[3], d[1], d[2], d[4], d[5], d[6]];
  }
  var o = {};
  function a(l) {
    if (!o[l]) {
      var c = new Intl.DateTimeFormat("en-US", {
        hour12: !1,
        timeZone: "America/New_York",
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), u = c === "06/25/2014, 00:00:00" || c === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
      o[l] = u ? new Intl.DateTimeFormat("en-US", {
        hour12: !1,
        timeZone: l,
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      }) : new Intl.DateTimeFormat("en-US", {
        hourCycle: "h23",
        timeZone: l,
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    }
    return o[l];
  }
  t.exports = e.default;
})(c0, c0.exports);
var sq = c0.exports, u0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, s, i, o, a, l, c) {
    var u = /* @__PURE__ */ new Date(0);
    return u.setUTCFullYear(r, s, i), u.setUTCHours(o, a, l, c), u;
  }
  t.exports = e.default;
})(u0, u0.exports);
var _5 = u0.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var n = s(sq), r = s(_5);
  function s(m) {
    return m && m.__esModule ? m : { default: m };
  }
  var i = 36e5, o = 6e4, a = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
  };
  function l(m, v, y) {
    var _, w;
    if (!m || (_ = a.timezoneZ.exec(m), _))
      return 0;
    var S;
    if (_ = a.timezoneHH.exec(m), _)
      return S = parseInt(_[1], 10), f(S) ? -(S * i) : NaN;
    if (_ = a.timezoneHHMM.exec(m), _) {
      S = parseInt(_[1], 10);
      var E = parseInt(_[2], 10);
      return f(S, E) ? (w = Math.abs(S) * i + E * o, S > 0 ? -w : w) : NaN;
    }
    if (h(m)) {
      v = new Date(v || Date.now());
      var x = y ? v : c(v), T = u(x, m), C = y ? T : d(v, T, m);
      return -C;
    }
    return NaN;
  }
  function c(m) {
    return (0, r.default)(m.getFullYear(), m.getMonth(), m.getDate(), m.getHours(), m.getMinutes(), m.getSeconds(), m.getMilliseconds());
  }
  function u(m, v) {
    var y = (0, n.default)(m, v), _ = (0, r.default)(y[0], y[1] - 1, y[2], y[3] % 24, y[4], y[5], 0).getTime(), w = m.getTime(), S = w % 1e3;
    return w -= S >= 0 ? S : 1e3 + S, _ - w;
  }
  function d(m, v, y) {
    var _ = m.getTime(), w = _ - v, S = u(new Date(w), y);
    if (v === S)
      return v;
    w -= S - v;
    var E = u(new Date(w), y);
    return S === E ? S : Math.max(S, E);
  }
  function f(m, v) {
    return -23 <= m && m <= 23 && (v == null || 0 <= v && v <= 59);
  }
  var p = {};
  function h(m) {
    if (p[m]) return !0;
    try {
      return new Intl.DateTimeFormat(void 0, {
        timeZone: m
      }), p[m] = !0, !0;
    } catch {
      return !1;
    }
  }
  t.exports = e.default;
})(l0, l0.exports);
var Mf = l0.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = s(rq), r = s(Mf);
  function s(p) {
    return p && p.__esModule ? p : { default: p };
  }
  var i = 60 * 1e3, o = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(p, h, m, v) {
      var y = a(v.timeZone, v._originalDate || p);
      if (y === 0)
        return "Z";
      switch (h) {
        case "X":
          return u(y);
        case "XXXX":
        case "XX":
          return c(y);
        case "XXXXX":
        case "XXX":
        default:
          return c(y, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(p, h, m, v) {
      var y = a(v.timeZone, v._originalDate || p);
      switch (h) {
        case "x":
          return u(y);
        case "xxxx":
        case "xx":
          return c(y);
        case "xxxxx":
        case "xxx":
        default:
          return c(y, ":");
      }
    },
    // Timezone (GMT)
    O: function(p, h, m, v) {
      var y = a(v.timeZone, v._originalDate || p);
      switch (h) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + d(y, ":");
        case "OOOO":
        default:
          return "GMT" + c(y, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(p, h, m, v) {
      var y = v._originalDate || p;
      switch (h) {
        case "z":
        case "zz":
        case "zzz":
          return (0, n.default)("short", y, v);
        case "zzzz":
        default:
          return (0, n.default)("long", y, v);
      }
    }
  };
  function a(p, h) {
    var m = p ? (0, r.default)(p, h, !0) / i : h.getTimezoneOffset();
    if (Number.isNaN(m))
      throw new RangeError("Invalid time zone specified: " + p);
    return m;
  }
  function l(p, h) {
    for (var m = p < 0 ? "-" : "", v = Math.abs(p).toString(); v.length < h; )
      v = "0" + v;
    return m + v;
  }
  function c(p, h) {
    var m = h || "", v = p > 0 ? "-" : "+", y = Math.abs(p), _ = l(Math.floor(y / 60), 2), w = l(Math.floor(y % 60), 2);
    return v + _ + m + w;
  }
  function u(p, h) {
    if (p % 60 === 0) {
      var m = p > 0 ? "-" : "+";
      return m + l(Math.abs(p) / 60, 2);
    }
    return c(p, h);
  }
  function d(p, h) {
    var m = p > 0 ? "-" : "+", v = Math.abs(p), y = Math.floor(v / 60), _ = v % 60;
    if (_ === 0)
      return m + String(y);
    var w = h;
    return m + String(y) + w + l(_, 2);
  }
  var f = o;
  e.default = f, t.exports = e.default;
})(o0, o0.exports);
var iq = o0.exports, d0 = { exports: {} }, f0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, r = n;
  e.default = r, t.exports = e.default;
})(f0, f0.exports);
var w5 = f0.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var n = o(rc), r = o(b5), s = o(Mf), i = o(w5);
  function o(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var a = 36e5, l = 6e4, c = 2, u = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
      /^([+-]\d{2})$/,
      // 0 additional digits
      /^([+-]\d{3})$/,
      // 1 additional digit
      /^([+-]\d{4})$/
      // 2 additional digits
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
      /^([+-]\d{4})/,
      // 0 additional digits
      /^([+-]\d{5})/,
      // 1 additional digit
      /^([+-]\d{6})/
      // 2 additional digits
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: i.default
  };
  function d(C, k) {
    if (arguments.length < 1)
      throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (C === null)
      return /* @__PURE__ */ new Date(NaN);
    var b = k || {}, P = b.additionalDigits == null ? c : (0, n.default)(b.additionalDigits);
    if (P !== 2 && P !== 1 && P !== 0)
      throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (C instanceof Date || typeof C == "object" && Object.prototype.toString.call(C) === "[object Date]")
      return new Date(C.getTime());
    if (typeof C == "number" || Object.prototype.toString.call(C) === "[object Number]")
      return new Date(C);
    if (!(typeof C == "string" || Object.prototype.toString.call(C) === "[object String]"))
      return /* @__PURE__ */ new Date(NaN);
    var N = f(C), D = p(N.date, P), H = D.year, Y = D.restDateString, te = h(Y, H);
    if (isNaN(te))
      return /* @__PURE__ */ new Date(NaN);
    if (te) {
      var A = te.getTime(), j = 0, L;
      if (N.time && (j = m(N.time), isNaN(j)))
        return /* @__PURE__ */ new Date(NaN);
      if (N.timeZone || b.timeZone) {
        if (L = (0, s.default)(N.timeZone || b.timeZone, new Date(A + j)), isNaN(L))
          return /* @__PURE__ */ new Date(NaN);
      } else
        L = (0, r.default)(new Date(A + j)), L = (0, r.default)(new Date(A + j + L));
      return new Date(A + j + L);
    } else
      return /* @__PURE__ */ new Date(NaN);
  }
  function f(C) {
    var k = {}, b = u.dateTimePattern.exec(C), P;
    if (b ? (k.date = b[1], P = b[3]) : (b = u.datePattern.exec(C), b ? (k.date = b[1], P = b[2]) : (k.date = null, P = C)), P) {
      var N = u.timeZone.exec(P);
      N ? (k.time = P.replace(N[1], ""), k.timeZone = N[1].trim()) : k.time = P;
    }
    return k;
  }
  function p(C, k) {
    var b = u.YYY[k], P = u.YYYYY[k], N;
    if (N = u.YYYY.exec(C) || P.exec(C), N) {
      var D = N[1];
      return {
        year: parseInt(D, 10),
        restDateString: C.slice(D.length)
      };
    }
    if (N = u.YY.exec(C) || b.exec(C), N) {
      var H = N[1];
      return {
        year: parseInt(H, 10) * 100,
        restDateString: C.slice(H.length)
      };
    }
    return {
      year: null
    };
  }
  function h(C, k) {
    if (k === null)
      return null;
    var b, P, N, D;
    if (C.length === 0)
      return P = /* @__PURE__ */ new Date(0), P.setUTCFullYear(k), P;
    if (b = u.MM.exec(C), b)
      return P = /* @__PURE__ */ new Date(0), N = parseInt(b[1], 10) - 1, S(k, N) ? (P.setUTCFullYear(k, N), P) : /* @__PURE__ */ new Date(NaN);
    if (b = u.DDD.exec(C), b) {
      P = /* @__PURE__ */ new Date(0);
      var H = parseInt(b[1], 10);
      return E(k, H) ? (P.setUTCFullYear(k, 0, H), P) : /* @__PURE__ */ new Date(NaN);
    }
    if (b = u.MMDD.exec(C), b) {
      P = /* @__PURE__ */ new Date(0), N = parseInt(b[1], 10) - 1;
      var Y = parseInt(b[2], 10);
      return S(k, N, Y) ? (P.setUTCFullYear(k, N, Y), P) : /* @__PURE__ */ new Date(NaN);
    }
    if (b = u.Www.exec(C), b)
      return D = parseInt(b[1], 10) - 1, x(k, D) ? v(k, D) : /* @__PURE__ */ new Date(NaN);
    if (b = u.WwwD.exec(C), b) {
      D = parseInt(b[1], 10) - 1;
      var te = parseInt(b[2], 10) - 1;
      return x(k, D, te) ? v(k, D, te) : /* @__PURE__ */ new Date(NaN);
    }
    return null;
  }
  function m(C) {
    var k, b, P;
    if (k = u.HH.exec(C), k)
      return b = parseFloat(k[1].replace(",", ".")), T(b) ? b % 24 * a : NaN;
    if (k = u.HHMM.exec(C), k)
      return b = parseInt(k[1], 10), P = parseFloat(k[2].replace(",", ".")), T(b, P) ? b % 24 * a + P * l : NaN;
    if (k = u.HHMMSS.exec(C), k) {
      b = parseInt(k[1], 10), P = parseInt(k[2], 10);
      var N = parseFloat(k[3].replace(",", "."));
      return T(b, P, N) ? b % 24 * a + P * l + N * 1e3 : NaN;
    }
    return null;
  }
  function v(C, k, b) {
    k = k || 0, b = b || 0;
    var P = /* @__PURE__ */ new Date(0);
    P.setUTCFullYear(C, 0, 4);
    var N = P.getUTCDay() || 7, D = k * 7 + b + 1 - N;
    return P.setUTCDate(P.getUTCDate() + D), P;
  }
  var y = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function w(C) {
    return C % 400 === 0 || C % 4 === 0 && C % 100 !== 0;
  }
  function S(C, k, b) {
    if (k < 0 || k > 11)
      return !1;
    if (b != null) {
      if (b < 1)
        return !1;
      var P = w(C);
      if (P && b > _[k] || !P && b > y[k])
        return !1;
    }
    return !0;
  }
  function E(C, k) {
    if (k < 1)
      return !1;
    var b = w(C);
    return !(b && k > 366 || !b && k > 365);
  }
  function x(C, k, b) {
    return !(k < 0 || k > 52 || b != null && (b < 0 || b > 6));
  }
  function T(C, k, b) {
    return !(C != null && (C < 0 || C >= 25) || k != null && (k < 0 || k >= 60) || b != null && (b < 0 || b >= 60));
  }
  t.exports = e.default;
})(d0, d0.exports);
var bv = d0.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var n = i(nq), r = i(iq), s = i(bv);
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
  function a(l, c, u) {
    var d = String(c), f = u || {}, p = d.match(o);
    if (p) {
      var h = (0, s.default)(l, f);
      d = p.reduce(function(m, v) {
        if (v[0] === "'")
          return m;
        var y = m.indexOf(v), _ = m[y - 1] === "'", w = m.replace(v, "'" + r.default[v[0]](h, v, null, f) + "'");
        return _ ? w.substring(0, y - 1) + w.substring(y + 1) : w;
      }, d);
    }
    return (0, n.default)(l, d, f);
  }
  t.exports = e.default;
})(C_, C_.exports);
var S5 = C_.exports, p0 = { exports: {} }, h0 = { exports: {} }, m0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, s) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in s)
      Object.prototype.hasOwnProperty.call(s, i) && (r[i] = s[i]);
    return r;
  }
  t.exports = e.default;
})(m0, m0.exports);
var oq = m0.exports;
(function(t, e) {
  var n = Jn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var r = n(oq);
  function s(i) {
    return (0, r.default)({}, i);
  }
  t.exports = e.default;
})(h0, h0.exports);
var I5 = h0.exports, v0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var n = s(Mf), r = s(bv);
  function s(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a, l) {
    var c = (0, r.default)(o, l), u = (0, n.default)(a, c, !0), d = new Date(c.getTime() - u), f = /* @__PURE__ */ new Date(0);
    return f.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), f.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), f;
  }
  t.exports = e.default;
})(v0, v0.exports);
var E5 = v0.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = i(I5), r = i(S5), s = i(E5);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, l, c, u) {
    var d = (0, n.default)(u);
    return d.timeZone = l, (0, r.default)((0, s.default)(a, l), c, d);
  }
  t.exports = e.default;
})(p0, p0.exports);
var aq = p0.exports, g0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var n = r(Mf);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function s(i, o) {
    return -(0, n.default)(i, o);
  }
  t.exports = e.default;
})(g0, g0.exports);
var lq = g0.exports, y0 = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var n = a(I5), r = a(bv), s = a(w5), i = a(Mf), o = a(_5);
  function a(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function l(c, u, d) {
    if (typeof c == "string" && !c.match(s.default)) {
      var f = (0, n.default)(d);
      return f.timeZone = u, (0, r.default)(c, f);
    }
    var p = (0, r.default)(c, d), h = (0, o.default)(p.getFullYear(), p.getMonth(), p.getDate(), p.getHours(), p.getMinutes(), p.getSeconds(), p.getMilliseconds()).getTime(), m = (0, i.default)(u, new Date(h));
    return new Date(h + m);
  }
  t.exports = e.default;
})(y0, y0.exports);
var cq = y0.exports, b0 = {
  format: S5,
  formatInTimeZone: aq,
  getTimezoneOffset: lq,
  toDate: bv,
  utcToZonedTime: E5,
  zonedTimeToUtc: cq
};
function Gc(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
function uo(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", s;
    if (r === "formatting" && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      s = t.formattingValues[o] || t.formattingValues[i];
    } else {
      var a = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      s = t.values[l] || t.values[a];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return s[c];
  };
}
function fo(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, s = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(s);
    if (!i)
      return null;
    var o = i[0], a = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(a) ? dq(a, function(d) {
      return d.test(o);
    }) : uq(a, function(d) {
      return d.test(o);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = e.slice(o.length);
    return {
      value: c,
      rest: u
    };
  };
}
function uq(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function dq(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function x5(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r) return null;
    var s = r[0], i = e.match(t.parsePattern);
    if (!i) return null;
    var o = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var a = e.slice(s.length);
    return {
      value: o,
      rest: a
    };
  };
}
function wo(t) {
  "@babel/helpers - typeof";
  return wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wo(t);
}
function Bn(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function ot(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function ut(t) {
  ot(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || wo(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function gS(t, e) {
  ot(2, arguments);
  var n = ut(t), r = Bn(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function fq(t, e) {
  ot(2, arguments);
  var n = ut(t), r = Bn(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var s = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var o = i.getDate();
  return s >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), s), n);
}
function pq(t, e) {
  ot(2, arguments);
  var n = ut(t).getTime(), r = Bn(e);
  return new Date(n + r);
}
var hq = {};
function ic() {
  return hq;
}
function iu(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function uf(t) {
  ot(1, arguments);
  var e = ut(t);
  return e.setHours(0, 0, 0, 0), e;
}
var mq = 864e5;
function vq(t, e) {
  ot(2, arguments);
  var n = uf(t), r = uf(e), s = n.getTime() - iu(n), i = r.getTime() - iu(r);
  return Math.round((s - i) / mq);
}
function ah(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e), s = n.getTime() - r.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
var yS = 6e4, bS = 36e5, gq = 1e3;
function yo(t, e) {
  ot(2, arguments);
  var n = uf(t), r = uf(e);
  return n.getTime() === r.getTime();
}
function yq(t) {
  return ot(1, arguments), t instanceof Date || wo(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function bq(t) {
  if (ot(1, arguments), !yq(t) && typeof t != "number")
    return !1;
  var e = ut(t);
  return !isNaN(Number(e));
}
function _q(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e), s = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return s * 12 + i;
}
function WC(t, e) {
  var n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function C5(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e), s = WC(n, r), i = Math.abs(vq(n, r));
  n.setDate(n.getDate() - s * i);
  var o = +(WC(n, r) === -s), a = s * (i - o);
  return a === 0 ? 0 : a;
}
function _S(t, e) {
  return ot(2, arguments), ut(t).getTime() - ut(e).getTime();
}
var HC = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, wq = "trunc";
function Sq(t) {
  return t ? HC[t] : HC[wq];
}
function T5(t) {
  ot(1, arguments);
  var e = ut(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Iq(t) {
  ot(1, arguments);
  var e = ut(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Eq(t) {
  ot(1, arguments);
  var e = ut(t);
  return T5(e).getTime() === Iq(e).getTime();
}
function xq(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e), s = ah(n, r), i = Math.abs(_q(n, r)), o;
  if (i < 1)
    o = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - s * i);
    var a = ah(n, r) === -s;
    Eq(ut(t)) && i === 1 && ah(t, r) === 1 && (a = !1), o = s * (i - Number(a));
  }
  return o === 0 ? 0 : o;
}
function Cq(t, e, n) {
  ot(2, arguments);
  var r = _S(t, e) / 1e3;
  return Sq(void 0)(r);
}
function Tq(t) {
  ot(1, arguments);
  var e = ut(t), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Yc() {
  return T5(Date.now());
}
function Pq() {
  var t = /* @__PURE__ */ new Date(), e = t.getFullYear(), n = t.getMonth(), r = t.getDate(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(e, n, r - 1), s.setHours(23, 59, 59, 999), s;
}
function P5(t, e) {
  ot(2, arguments);
  var n = Bn(e);
  return pq(t, -n);
}
var kq = 864e5;
function Nq(t) {
  ot(1, arguments);
  var e = ut(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), s = n - r;
  return Math.floor(s / kq) + 1;
}
function ou(t) {
  ot(1, arguments);
  var e = 1, n = ut(t), r = n.getUTCDay(), s = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - s), n.setUTCHours(0, 0, 0, 0), n;
}
function k5(t) {
  ot(1, arguments);
  var e = ut(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var s = ou(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = ou(i);
  return e.getTime() >= s.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function $q(t) {
  ot(1, arguments);
  var e = k5(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = ou(n);
  return r;
}
var Dq = 6048e5;
function N5(t) {
  ot(1, arguments);
  var e = ut(t), n = ou(e).getTime() - $q(e).getTime();
  return Math.round(n / Dq) + 1;
}
function Uo(t, e) {
  var n, r, s, i, o, a, l, c;
  ot(1, arguments);
  var u = ic(), d = Bn((n = (r = (s = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (a = o.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && s !== void 0 ? s : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ut(t), p = f.getUTCDay(), h = (p < d ? 7 : 0) + p - d;
  return f.setUTCDate(f.getUTCDate() - h), f.setUTCHours(0, 0, 0, 0), f;
}
function wS(t, e) {
  var n, r, s, i, o, a, l, c;
  ot(1, arguments);
  var u = ut(t), d = u.getUTCFullYear(), f = ic(), p = Bn((n = (r = (s = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (a = o.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && s !== void 0 ? s : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d + 1, 0, p), h.setUTCHours(0, 0, 0, 0);
  var m = Uo(h, e), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(d, 0, p), v.setUTCHours(0, 0, 0, 0);
  var y = Uo(v, e);
  return u.getTime() >= m.getTime() ? d + 1 : u.getTime() >= y.getTime() ? d : d - 1;
}
function Aq(t, e) {
  var n, r, s, i, o, a, l, c;
  ot(1, arguments);
  var u = ic(), d = Bn((n = (r = (s = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (a = o.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && s !== void 0 ? s : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = wS(t, e), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(f, 0, d), p.setUTCHours(0, 0, 0, 0);
  var h = Uo(p, e);
  return h;
}
var Oq = 6048e5;
function $5(t, e) {
  ot(1, arguments);
  var n = ut(t), r = Uo(n, e).getTime() - Aq(n, e).getTime();
  return Math.round(r / Oq) + 1;
}
function mn(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var la = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), s = r > 0 ? r : 1 - r;
    return mn(n === "yy" ? s % 100 : s, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : mn(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return mn(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return mn(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return mn(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return mn(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return mn(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, s = e.getUTCMilliseconds(), i = Math.floor(s * Math.pow(10, r - 3));
    return mn(i, n.length);
  }
}, Ic = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Mq = {
  // Era
  G: function(e, n, r) {
    var s = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var s = e.getUTCFullYear(), i = s > 0 ? s : 1 - s;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return la.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, s) {
    var i = wS(e, s), o = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var a = o % 100;
      return mn(a, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : mn(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = k5(e);
    return mn(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return mn(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var s = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(s);
      case "QQ":
        return mn(s, 2);
      case "Qo":
        return r.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var s = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(s);
      case "qq":
        return mn(s, 2);
      case "qo":
        return r.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var s = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return la.M(e, n);
      case "Mo":
        return r.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var s = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(s + 1);
      case "LL":
        return mn(s + 1, 2);
      case "Lo":
        return r.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, s) {
    var i = $5(e, s);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : mn(i, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var s = N5(e);
    return n === "Io" ? r.ordinalNumber(s, {
      unit: "week"
    }) : mn(s, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : la.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var s = Nq(e);
    return n === "Do" ? r.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : mn(s, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var s = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, s) {
    var i = e.getUTCDay(), o = (i - s.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return mn(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, s) {
    var i = e.getUTCDay(), o = (i - s.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return mn(o, n.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var s = e.getUTCDay(), i = s === 0 ? 7 : s;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return mn(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var s = e.getUTCHours(), i = s / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var s = e.getUTCHours(), i;
    switch (s === 12 ? i = Ic.noon : s === 0 ? i = Ic.midnight : i = s / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var s = e.getUTCHours(), i;
    switch (s >= 17 ? i = Ic.evening : s >= 12 ? i = Ic.afternoon : s >= 4 ? i = Ic.morning : i = Ic.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var s = e.getUTCHours() % 12;
      return s === 0 && (s = 12), r.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return la.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : la.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var s = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(s, {
      unit: "hour"
    }) : mn(s, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var s = e.getUTCHours();
    return s === 0 && (s = 24), n === "ko" ? r.ordinalNumber(s, {
      unit: "hour"
    }) : mn(s, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : la.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : la.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return la.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, s) {
    var i = s._originalDate || e, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return zC(o);
      case "XXXX":
      case "XX":
        return Il(o);
      case "XXXXX":
      case "XXX":
      default:
        return Il(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, s) {
    var i = s._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return zC(o);
      case "xxxx":
      case "xx":
        return Il(o);
      case "xxxxx":
      case "xxx":
      default:
        return Il(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, s) {
    var i = s._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + VC(o, ":");
      case "OOOO":
      default:
        return "GMT" + Il(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, s) {
    var i = s._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + VC(o, ":");
      case "zzzz":
      default:
        return "GMT" + Il(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, s) {
    var i = s._originalDate || e, o = Math.floor(i.getTime() / 1e3);
    return mn(o, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, s) {
    var i = s._originalDate || e, o = i.getTime();
    return mn(o, n.length);
  }
};
function VC(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), s = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(s);
  var o = e;
  return n + String(s) + o + mn(i, 2);
}
function zC(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + mn(Math.abs(t) / 60, 2);
  }
  return Il(t, e);
}
function Il(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", s = Math.abs(t), i = mn(Math.floor(s / 60), 2), o = mn(s % 60, 2);
  return r + i + n + o;
}
var UC = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, D5 = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Rq = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], s = r[1], i = r[2];
  if (!i)
    return UC(e, n);
  var o;
  switch (s) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", UC(s, n)).replace("{{time}}", D5(i, n));
}, _0 = {
  p: D5,
  P: Rq
}, Lq = ["D", "DD"], Fq = ["YY", "YYYY"];
function A5(t) {
  return Lq.indexOf(t) !== -1;
}
function O5(t) {
  return Fq.indexOf(t) !== -1;
}
function fm(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Bq = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, jq = function(e, n, r) {
  var s, i = Bq[e];
  return typeof i == "string" ? s = i : n === 1 ? s = i.one : s = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + s : s + " ago" : s;
}, Wq = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Hq = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Vq = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zq = {
  date: Gc({
    formats: Wq,
    defaultWidth: "full"
  }),
  time: Gc({
    formats: Hq,
    defaultWidth: "full"
  }),
  dateTime: Gc({
    formats: Vq,
    defaultWidth: "full"
  })
}, Uq = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Gq = function(e, n, r, s) {
  return Uq[e];
}, Yq = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Zq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Xq = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Kq = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Jq = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qq = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Qq = function(e, n) {
  var r = Number(e), s = r % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, eQ = {
  ordinalNumber: Qq,
  era: uo({
    values: Yq,
    defaultWidth: "wide"
  }),
  quarter: uo({
    values: Zq,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: uo({
    values: Xq,
    defaultWidth: "wide"
  }),
  day: uo({
    values: Kq,
    defaultWidth: "wide"
  }),
  dayPeriod: uo({
    values: Jq,
    defaultWidth: "wide",
    formattingValues: qq,
    defaultFormattingWidth: "wide"
  })
}, tQ = /^(\d+)(th|st|nd|rd)?/i, nQ = /\d+/i, rQ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, sQ = {
  any: [/^b/i, /^(a|c)/i]
}, iQ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, oQ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, aQ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, lQ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, cQ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, uQ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, dQ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, fQ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, pQ = {
  ordinalNumber: x5({
    matchPattern: tQ,
    parsePattern: nQ,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: fo({
    matchPatterns: rQ,
    defaultMatchWidth: "wide",
    parsePatterns: sQ,
    defaultParseWidth: "any"
  }),
  quarter: fo({
    matchPatterns: iQ,
    defaultMatchWidth: "wide",
    parsePatterns: oQ,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: fo({
    matchPatterns: aQ,
    defaultMatchWidth: "wide",
    parsePatterns: lQ,
    defaultParseWidth: "any"
  }),
  day: fo({
    matchPatterns: cQ,
    defaultMatchWidth: "wide",
    parsePatterns: uQ,
    defaultParseWidth: "any"
  }),
  dayPeriod: fo({
    matchPatterns: dQ,
    defaultMatchWidth: "any",
    parsePatterns: fQ,
    defaultParseWidth: "any"
  })
}, SS = {
  code: "en-US",
  formatDistance: jq,
  formatLong: zq,
  formatRelative: Gq,
  localize: eQ,
  match: pQ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, hQ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, mQ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vQ = /^'([^]*?)'?$/, gQ = /''/g, yQ = /[a-zA-Z]/;
function on(t, e, n) {
  var r, s, i, o, a, l, c, u, d, f, p, h, m, v, y, _, w, S;
  ot(2, arguments);
  var E = String(e), x = ic(), T = (r = (s = n == null ? void 0 : n.locale) !== null && s !== void 0 ? s : x.locale) !== null && r !== void 0 ? r : SS, C = Bn((i = (o = (a = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : x.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = x.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(C >= 1 && C <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = Bn((p = (h = (m = (v = n == null ? void 0 : n.weekStartsOn) !== null && v !== void 0 ? v : n == null || (y = n.locale) === null || y === void 0 || (_ = y.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && m !== void 0 ? m : x.weekStartsOn) !== null && h !== void 0 ? h : (w = x.locale) === null || w === void 0 || (S = w.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(k >= 0 && k <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!T.localize)
    throw new RangeError("locale must contain localize property");
  if (!T.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var b = ut(t);
  if (!bq(b))
    throw new RangeError("Invalid time value");
  var P = iu(b), N = P5(b, P), D = {
    firstWeekContainsDate: C,
    weekStartsOn: k,
    locale: T,
    _originalDate: b
  }, H = E.match(mQ).map(function(Y) {
    var te = Y[0];
    if (te === "p" || te === "P") {
      var A = _0[te];
      return A(Y, T.formatLong);
    }
    return Y;
  }).join("").match(hQ).map(function(Y) {
    if (Y === "''")
      return "'";
    var te = Y[0];
    if (te === "'")
      return bQ(Y);
    var A = Mq[te];
    if (A)
      return !(n != null && n.useAdditionalWeekYearTokens) && O5(Y) && fm(Y, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && A5(Y) && fm(Y, e, String(t)), A(N, Y, T.localize, D);
    if (te.match(yQ))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + te + "`");
    return Y;
  }).join("");
  return H;
}
function bQ(t) {
  var e = t.match(vQ);
  return e ? e[1].replace(gQ, "'") : t;
}
function IS(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function _Q(t) {
  return IS({}, t);
}
var GC = 1440, wQ = 2520, uy = 43200, SQ = 86400;
function IQ(t, e, n) {
  var r, s;
  ot(2, arguments);
  var i = ic(), o = (r = (s = n == null ? void 0 : n.locale) !== null && s !== void 0 ? s : i.locale) !== null && r !== void 0 ? r : SS;
  if (!o.formatDistance)
    throw new RangeError("locale must contain formatDistance property");
  var a = ah(t, e);
  if (isNaN(a))
    throw new RangeError("Invalid time value");
  var l = IS(_Q(n), {
    addSuffix: !!(n != null && n.addSuffix),
    comparison: a
  }), c, u;
  a > 0 ? (c = ut(e), u = ut(t)) : (c = ut(t), u = ut(e));
  var d = Cq(u, c), f = (iu(u) - iu(c)) / 1e3, p = Math.round((d - f) / 60), h;
  if (p < 2)
    return n != null && n.includeSeconds ? d < 5 ? o.formatDistance("lessThanXSeconds", 5, l) : d < 10 ? o.formatDistance("lessThanXSeconds", 10, l) : d < 20 ? o.formatDistance("lessThanXSeconds", 20, l) : d < 40 ? o.formatDistance("halfAMinute", 0, l) : d < 60 ? o.formatDistance("lessThanXMinutes", 1, l) : o.formatDistance("xMinutes", 1, l) : p === 0 ? o.formatDistance("lessThanXMinutes", 1, l) : o.formatDistance("xMinutes", p, l);
  if (p < 45)
    return o.formatDistance("xMinutes", p, l);
  if (p < 90)
    return o.formatDistance("aboutXHours", 1, l);
  if (p < GC) {
    var m = Math.round(p / 60);
    return o.formatDistance("aboutXHours", m, l);
  } else {
    if (p < wQ)
      return o.formatDistance("xDays", 1, l);
    if (p < uy) {
      var v = Math.round(p / GC);
      return o.formatDistance("xDays", v, l);
    } else if (p < SQ)
      return h = Math.round(p / uy), o.formatDistance("aboutXMonths", h, l);
  }
  if (h = xq(u, c), h < 12) {
    var y = Math.round(p / uy);
    return o.formatDistance("xMonths", y, l);
  } else {
    var _ = h % 12, w = Math.floor(h / 12);
    return _ < 3 ? o.formatDistance("aboutXYears", w, l) : _ < 9 ? o.formatDistance("overXYears", w, l) : o.formatDistance("almostXYears", w + 1, l);
  }
}
function M5(t, e) {
  return ot(1, arguments), IQ(t, Date.now(), e);
}
function EQ(t) {
  ot(1, arguments);
  var e = ut(t), n = e.getFullYear(), r = e.getMonth(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(n, r + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function xQ(t) {
  return ot(1, arguments), ut(t).getFullYear();
}
function YC(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e);
  return n.getTime() > r.getTime();
}
function ZC(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function CQ(t, e) {
  if (t) {
    if (typeof t == "string") return ZC(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ZC(t, e) : void 0;
  }
}
function XC(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = CQ(t)) || e) {
      n && (t = n);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, a = !1;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var c = n.next();
      return o = c.done, c;
    },
    e: function(c) {
      a = !0, i = c;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (a) throw i;
      }
    }
  };
}
function Ye(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function w0(t, e) {
  return w0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, w0(t, e);
}
function en(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && w0(t, e);
}
function pm(t) {
  return pm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, pm(t);
}
function R5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (R5 = function() {
    return !!t;
  })();
}
function TQ(t, e) {
  if (e && (wo(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Ye(t);
}
function tn(t) {
  var e = R5();
  return function() {
    var n, r = pm(t);
    if (e) {
      var s = pm(this).constructor;
      n = Reflect.construct(r, arguments, s);
    } else n = r.apply(this, arguments);
    return TQ(this, n);
  };
}
function Ut(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function PQ(t, e) {
  if (wo(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (wo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function L5(t) {
  var e = PQ(t, "string");
  return wo(e) == "symbol" ? e : e + "";
}
function kQ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, L5(r.key), r);
  }
}
function Gt(t, e, n) {
  return e && kQ(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Ge(t, e, n) {
  return (e = L5(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var NQ = 10, F5 = /* @__PURE__ */ function() {
  function t() {
    Ut(this, t), Ge(this, "priority", void 0), Ge(this, "subPriority", 0);
  }
  return Gt(t, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), t;
}(), $Q = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n(r, s, i, o, a) {
    var l;
    return Ut(this, n), l = e.call(this), l.value = r, l.validateValue = s, l.setValue = i, l.priority = o, a && (l.subPriority = a), l;
  }
  return Gt(n, [{
    key: "validate",
    value: function(s, i) {
      return this.validateValue(s, this.value, i);
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return this.setValue(s, i, this.value, o);
    }
  }]), n;
}(F5), DQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", NQ), Ge(Ye(r), "subPriority", -1), r;
  }
  return Gt(n, [{
    key: "set",
    value: function(s, i) {
      if (i.timestampIsSet)
        return s;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), o.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), o;
    }
  }]), n;
}(F5), dn = /* @__PURE__ */ function() {
  function t() {
    Ut(this, t), Ge(this, "incompatibleTokens", void 0), Ge(this, "priority", void 0), Ge(this, "subPriority", void 0);
  }
  return Gt(t, [{
    key: "run",
    value: function(n, r, s, i) {
      var o = this.parse(n, r, s, i);
      return o ? {
        setter: new $Q(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, s) {
      return !0;
    }
  }]), t;
}(), AQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 140), Ge(Ye(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(s, {
            width: "abbreviated"
          }) || o.era(s, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(s, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(s, {
            width: "wide"
          }) || o.era(s, {
            width: "abbreviated"
          }) || o.era(s, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return i.era = o, s.setUTCFullYear(o, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), gr = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, po = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function yr(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Zn(t, e) {
  var n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function ho(t, e) {
  var n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, s = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (s * bS + i * yS + o * gq),
    rest: e.slice(n[0].length)
  };
}
function B5(t) {
  return Zn(gr.anyDigitsSigned, t);
}
function cr(t, e) {
  switch (t) {
    case 1:
      return Zn(gr.singleDigit, e);
    case 2:
      return Zn(gr.twoDigits, e);
    case 3:
      return Zn(gr.threeDigits, e);
    case 4:
      return Zn(gr.fourDigits, e);
    default:
      return Zn(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function hm(t, e) {
  switch (t) {
    case 1:
      return Zn(gr.singleDigitSigned, e);
    case 2:
      return Zn(gr.twoDigitsSigned, e);
    case 3:
      return Zn(gr.threeDigitsSigned, e);
    case 4:
      return Zn(gr.fourDigitsSigned, e);
    default:
      return Zn(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function ES(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function j5(t, e) {
  var n = e > 0, r = n ? e : 1 - e, s;
  if (r <= 50)
    s = t || 100;
  else {
    var i = r + 50, o = Math.floor(i / 100) * 100, a = t >= i % 100;
    s = t + o - (a ? 100 : 0);
  }
  return n ? s : 1 - s;
}
function W5(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var OQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 130), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return yr(cr(4, s), a);
        case "yo":
          return yr(o.ordinalNumber(s, {
            unit: "year"
          }), a);
        default:
          return yr(cr(i.length, s), a);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      var a = s.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = j5(o.year, a);
        return s.setUTCFullYear(l, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), MQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 130), Ge(Ye(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return yr(cr(4, s), a);
        case "Yo":
          return yr(o.ordinalNumber(s, {
            unit: "year"
          }), a);
        default:
          return yr(cr(i.length, s), a);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(s, i, o, a) {
      var l = wS(s, a);
      if (o.isTwoDigitYear) {
        var c = j5(o.year, l);
        return s.setUTCFullYear(c, 0, a.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), Uo(s, a);
      }
      var u = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return s.setUTCFullYear(u, 0, a.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), Uo(s, a);
    }
  }]), n;
}(dn), RQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 130), Ge(Ye(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i) {
      return hm(i === "R" ? 4 : i.length, s);
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      var a = /* @__PURE__ */ new Date(0);
      return a.setUTCFullYear(o, 0, 4), a.setUTCHours(0, 0, 0, 0), ou(a);
    }
  }]), n;
}(dn), LQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 130), Ge(Ye(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i) {
      return hm(i === "u" ? 4 : i.length, s);
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCFullYear(o, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), FQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 120), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return cr(i.length, s);
        case "Qo":
          return o.ordinalNumber(s, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(s, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMonth((o - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), BQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 120), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return cr(i.length, s);
        case "qo":
          return o.ordinalNumber(s, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(s, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMonth((o - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), jQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Ge(Ye(r), "priority", 110), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return yr(Zn(gr.month, s), a);
        case "MM":
          return yr(cr(2, s), a);
        case "Mo":
          return yr(o.ordinalNumber(s, {
            unit: "month"
          }), a);
        case "MMM":
          return o.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(s, {
            width: "wide",
            context: "formatting"
          }) || o.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMonth(o, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), WQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 110), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return yr(Zn(gr.month, s), a);
        case "LL":
          return yr(cr(2, s), a);
        case "Lo":
          return yr(o.ordinalNumber(s, {
            unit: "month"
          }), a);
        case "LLL":
          return o.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(s, {
            width: "wide",
            context: "standalone"
          }) || o.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMonth(o, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn);
function HQ(t, e, n) {
  ot(2, arguments);
  var r = ut(t), s = Bn(e), i = $5(r, n) - s;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var VQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 100), Ge(Ye(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "w":
          return Zn(gr.week, s);
        case "wo":
          return o.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(s, i, o, a) {
      return Uo(HQ(s, o, a), a);
    }
  }]), n;
}(dn);
function zQ(t, e) {
  ot(2, arguments);
  var n = ut(t), r = Bn(e), s = N5(n) - r;
  return n.setUTCDate(n.getUTCDate() - s * 7), n;
}
var UQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 100), Ge(Ye(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "I":
          return Zn(gr.week, s);
        case "Io":
          return o.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return ou(zQ(s, o));
    }
  }]), n;
}(dn), GQ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], YQ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ZQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 90), Ge(Ye(r), "subPriority", 1), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "d":
          return Zn(gr.date, s);
        case "do":
          return o.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      var o = s.getUTCFullYear(), a = W5(o), l = s.getUTCMonth();
      return a ? i >= 1 && i <= YQ[l] : i >= 1 && i <= GQ[l];
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCDate(o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), XQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 90), Ge(Ye(r), "subpriority", 1), Ge(Ye(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return Zn(gr.dayOfYear, s);
        case "Do":
          return o.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      var o = s.getUTCFullYear(), a = W5(o);
      return a ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMonth(0, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn);
function xS(t, e, n) {
  var r, s, i, o, a, l, c, u;
  ot(2, arguments);
  var d = ic(), f = Bn((r = (s = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (a = n.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = ut(t), h = Bn(e), m = p.getUTCDay(), v = h % 7, y = (v + 7) % 7, _ = (y < f ? 7 : 0) + h - m;
  return p.setUTCDate(p.getUTCDate() + _), p;
}
var KQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 90), Ge(Ye(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(s, {
            width: "wide",
            context: "formatting"
          }) || o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(s, i, o, a) {
      return s = xS(s, o, a), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), JQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 90), Ge(Ye(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "e":
        case "ee":
          return yr(cr(i.length, s), l);
        case "eo":
          return yr(o.ordinalNumber(s, {
            unit: "day"
          }), l);
        case "eee":
          return o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(s, {
            width: "wide",
            context: "formatting"
          }) || o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(s, i, o, a) {
      return s = xS(s, o, a), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), qQ = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 90), Ge(Ye(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "c":
        case "cc":
          return yr(cr(i.length, s), l);
        case "co":
          return yr(o.ordinalNumber(s, {
            unit: "day"
          }), l);
        case "ccc":
          return o.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(s, {
            width: "short",
            context: "standalone"
          }) || o.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(s, {
            width: "short",
            context: "standalone"
          }) || o.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(s, {
            width: "wide",
            context: "standalone"
          }) || o.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(s, {
            width: "short",
            context: "standalone"
          }) || o.day(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(s, i, o, a) {
      return s = xS(s, o, a), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn);
function QQ(t, e) {
  ot(2, arguments);
  var n = Bn(e);
  n % 7 === 0 && (n = n - 7);
  var r = 1, s = ut(t), i = s.getUTCDay(), o = n % 7, a = (o + 7) % 7, l = (a < r ? 7 : 0) + n - i;
  return s.setUTCDate(s.getUTCDate() + l), s;
}
var eee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 90), Ge(Ye(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      var a = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return cr(i.length, s);
        case "io":
          return o.ordinalNumber(s, {
            unit: "day"
          });
        case "iii":
          return yr(o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return yr(o.day(s, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return yr(o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return yr(o.day(s, {
            width: "wide",
            context: "formatting"
          }) || o.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(s, {
            width: "short",
            context: "formatting"
          }) || o.day(s, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s = QQ(s, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(dn), tee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 80), Ge(Ye(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCHours(ES(o), 0, 0, 0), s;
    }
  }]), n;
}(dn), nee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 80), Ge(Ye(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCHours(ES(o), 0, 0, 0), s;
    }
  }]), n;
}(dn), ree = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 80), Ge(Ye(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCHours(ES(o), 0, 0, 0), s;
    }
  }]), n;
}(dn), see = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 70), Ge(Ye(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "h":
          return Zn(gr.hour12h, s);
        case "ho":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      var a = s.getUTCHours() >= 12;
      return a && o < 12 ? s.setUTCHours(o + 12, 0, 0, 0) : !a && o === 12 ? s.setUTCHours(0, 0, 0, 0) : s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), n;
}(dn), iee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 70), Ge(Ye(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "H":
          return Zn(gr.hour23h, s);
        case "Ho":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), n;
}(dn), oee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 70), Ge(Ye(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "K":
          return Zn(gr.hour11h, s);
        case "Ko":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      var a = s.getUTCHours() >= 12;
      return a && o < 12 ? s.setUTCHours(o + 12, 0, 0, 0) : s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), n;
}(dn), aee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 70), Ge(Ye(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "k":
          return Zn(gr.hour24h, s);
        case "ko":
          return o.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      var a = o <= 24 ? o % 24 : o;
      return s.setUTCHours(a, 0, 0, 0), s;
    }
  }]), n;
}(dn), lee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 60), Ge(Ye(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "m":
          return Zn(gr.minute, s);
        case "mo":
          return o.ordinalNumber(s, {
            unit: "minute"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMinutes(o, 0, 0), s;
    }
  }]), n;
}(dn), cee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 50), Ge(Ye(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i, o) {
      switch (i) {
        case "s":
          return Zn(gr.second, s);
        case "so":
          return o.ordinalNumber(s, {
            unit: "second"
          });
        default:
          return cr(i.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCSeconds(o, 0), s;
    }
  }]), n;
}(dn), uee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 30), Ge(Ye(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return yr(cr(i.length, s), o);
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return s.setUTCMilliseconds(o), s;
    }
  }]), n;
}(dn), dee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 10), Ge(Ye(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i) {
      switch (i) {
        case "X":
          return ho(po.basicOptionalMinutes, s);
        case "XX":
          return ho(po.basic, s);
        case "XXXX":
          return ho(po.basicOptionalSeconds, s);
        case "XXXXX":
          return ho(po.extendedOptionalSeconds, s);
        case "XXX":
        default:
          return ho(po.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return i.timestampIsSet ? s : new Date(s.getTime() - o);
    }
  }]), n;
}(dn), fee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 10), Ge(Ye(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s, i) {
      switch (i) {
        case "x":
          return ho(po.basicOptionalMinutes, s);
        case "xx":
          return ho(po.basic, s);
        case "xxxx":
          return ho(po.basicOptionalSeconds, s);
        case "xxxxx":
          return ho(po.extendedOptionalSeconds, s);
        case "xxx":
        default:
          return ho(po.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return i.timestampIsSet ? s : new Date(s.getTime() - o);
    }
  }]), n;
}(dn), pee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 40), Ge(Ye(r), "incompatibleTokens", "*"), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s) {
      return B5(s);
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(dn), hee = /* @__PURE__ */ function(t) {
  en(n, t);
  var e = tn(n);
  function n() {
    var r;
    Ut(this, n);
    for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ge(Ye(r), "priority", 20), Ge(Ye(r), "incompatibleTokens", "*"), r;
  }
  return Gt(n, [{
    key: "parse",
    value: function(s) {
      return B5(s);
    }
  }, {
    key: "set",
    value: function(s, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(dn), mee = {
  G: new AQ(),
  y: new OQ(),
  Y: new MQ(),
  R: new RQ(),
  u: new LQ(),
  Q: new FQ(),
  q: new BQ(),
  M: new jQ(),
  L: new WQ(),
  w: new VQ(),
  I: new UQ(),
  d: new ZQ(),
  D: new XQ(),
  E: new KQ(),
  e: new JQ(),
  c: new qQ(),
  i: new eee(),
  a: new tee(),
  b: new nee(),
  B: new ree(),
  h: new see(),
  H: new iee(),
  K: new oee(),
  k: new aee(),
  m: new lee(),
  s: new cee(),
  S: new uee(),
  X: new dee(),
  x: new fee(),
  t: new pee(),
  T: new hee()
}, vee = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, gee = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yee = /^'([^]*?)'?$/, bee = /''/g, _ee = /\S/, wee = /[a-zA-Z]/;
function S0(t, e, n, r) {
  var s, i, o, a, l, c, u, d, f, p, h, m, v, y;
  ot(3, arguments);
  var _ = String(t), w = String(e), S = ic(), E = (s = (i = void 0) !== null && i !== void 0 ? i : S.locale) !== null && s !== void 0 ? s : SS;
  if (!E.match)
    throw new RangeError("locale must contain match property");
  var x = Bn((o = (a = (l = (c = void 0) !== null && c !== void 0 ? c : void 0) !== null && l !== void 0 ? l : S.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = S.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(x >= 1 && x <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = Bn((f = (p = (h = (m = void 0) !== null && m !== void 0 ? m : void 0) !== null && h !== void 0 ? h : S.weekStartsOn) !== null && p !== void 0 ? p : (v = S.locale) === null || v === void 0 || (y = v.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (w === "")
    return _ === "" ? ut(n) : /* @__PURE__ */ new Date(NaN);
  var C = {
    firstWeekContainsDate: x,
    weekStartsOn: T,
    locale: E
  }, k = [new DQ()], b = w.match(gee).map(function(K) {
    var z = K[0];
    if (z in _0) {
      var q = _0[z];
      return q(K, E.formatLong);
    }
    return K;
  }).join("").match(vee), P = [], N = XC(b), D;
  try {
    var H = function() {
      var z = D.value;
      !(r != null && r.useAdditionalWeekYearTokens) && O5(z) && fm(z, w, t), !(r != null && r.useAdditionalDayOfYearTokens) && A5(z) && fm(z, w, t);
      var q = z[0], ae = mee[q];
      if (ae) {
        var Ee = ae.incompatibleTokens;
        if (Array.isArray(Ee)) {
          var Ae = P.find(function(qe) {
            return Ee.includes(qe.token) || qe.token === q;
          });
          if (Ae)
            throw new RangeError("The format string mustn't contain `".concat(Ae.fullToken, "` and `").concat(z, "` at the same time"));
        } else if (ae.incompatibleTokens === "*" && P.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(z, "` and any other token at the same time"));
        P.push({
          token: q,
          fullToken: z
        });
        var Ue = ae.run(_, z, E.match, C);
        if (!Ue)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        k.push(Ue.setter), _ = Ue.rest;
      } else {
        if (q.match(wee))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + q + "`");
        if (z === "''" ? z = "'" : q === "'" && (z = See(z)), _.indexOf(z) === 0)
          _ = _.slice(z.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (N.s(); !(D = N.n()).done; ) {
      var Y = H();
      if (wo(Y) === "object") return Y.v;
    }
  } catch (K) {
    N.e(K);
  } finally {
    N.f();
  }
  if (_.length > 0 && _ee.test(_))
    return /* @__PURE__ */ new Date(NaN);
  var te = k.map(function(K) {
    return K.priority;
  }).sort(function(K, z) {
    return z - K;
  }).filter(function(K, z, q) {
    return q.indexOf(K) === z;
  }).map(function(K) {
    return k.filter(function(z) {
      return z.priority === K;
    }).sort(function(z, q) {
      return q.subPriority - z.subPriority;
    });
  }).map(function(K) {
    return K[0];
  }), A = ut(n);
  if (isNaN(A.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var j = P5(A, iu(A)), L = {}, se = XC(te), V;
  try {
    for (se.s(); !(V = se.n()).done; ) {
      var ee = V.value;
      if (!ee.validate(j, C))
        return /* @__PURE__ */ new Date(NaN);
      var O = ee.set(j, L, C);
      Array.isArray(O) ? (j = O[0], IS(L, O[1])) : j = O;
    }
  } catch (K) {
    se.e(K);
  } finally {
    se.f();
  }
  return j;
}
function See(t) {
  return t.match(yee)[1].replace(bee, "'");
}
function Iee(t) {
  return ot(1, arguments), ut(t).getTime() < Date.now();
}
function Eee(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function xee(t, e) {
  ot(2, arguments);
  var n = ut(t), r = ut(e);
  return n.getFullYear() === r.getFullYear();
}
function H5(t) {
  return ot(1, arguments), Eee(Date.now(), t);
}
function Rf(t) {
  return ot(1, arguments), xee(t, Date.now());
}
function mm(t) {
  return ot(1, arguments), yo(t, Date.now());
}
function Cee(t, e) {
  ot(2, arguments);
  var n = ut(t).getTime(), r = ut(e.start).getTime(), s = ut(e.end).getTime();
  if (!(r <= s))
    throw new RangeError("Invalid interval");
  return n >= r && n <= s;
}
function go(t, e) {
  ot(2, arguments);
  var n = Bn(e);
  return gS(t, -n);
}
function Tr(t, e) {
  var n;
  ot(1, arguments);
  var r = Bn((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = Nee(t), i;
  if (s.date) {
    var o = $ee(s.date, r);
    i = Dee(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var a = i.getTime(), l = 0, c;
  if (s.time && (l = Aee(s.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (s.timezone) {
    if (c = Oee(s.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(a + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(a + l + c);
}
var Sp = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Tee = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Pee = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, kee = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Nee(t) {
  var e = {}, n = t.split(Sp.dateTimeDelimiter), r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Sp.timeZoneDelimiter.test(e.date) && (e.date = t.split(Sp.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
    var s = Sp.timezone.exec(r);
    s ? (e.time = r.replace(s[1], ""), e.timezone = s[1]) : e.time = r;
  }
  return e;
}
function $ee(t, e) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(n);
  if (!r) return {
    year: NaN,
    restDateString: ""
  };
  var s = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? s : i * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function Dee(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  var n = t.match(Tee);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], s = rd(n[1]), i = rd(n[2]) - 1, o = rd(n[3]), a = rd(n[4]), l = rd(n[5]) - 1;
  if (r)
    return Bee(e, a, l) ? Mee(e, a, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !Lee(e, i, o) || !Fee(e, s) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, i, Math.max(s, o)), c);
}
function rd(t) {
  return t ? parseInt(t) : 1;
}
function Aee(t) {
  var e = t.match(Pee);
  if (!e) return NaN;
  var n = dy(e[1]), r = dy(e[2]), s = dy(e[3]);
  return jee(n, r, s) ? n * bS + r * yS + s * 1e3 : NaN;
}
function dy(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function Oee(t) {
  if (t === "Z") return 0;
  var e = t.match(kee);
  if (!e) return 0;
  var n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), s = e[3] && parseInt(e[3]) || 0;
  return Wee(r, s) ? n * (r * bS + s * yS) : NaN;
}
function Mee(t, e, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var s = r.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - s;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var Ree = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function V5(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Lee(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (Ree[e] || (V5(t) ? 29 : 28));
}
function Fee(t, e) {
  return e >= 1 && e <= (V5(t) ? 366 : 365);
}
function Bee(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function jee(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function Wee(t, e) {
  return e >= 0 && e <= 59;
}
function Hee(t, e) {
  ot(2, arguments);
  var n = ut(t), r = Bn(e), s = n.getFullYear(), i = n.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(s, r, 15), o.setHours(0, 0, 0, 0);
  var a = EQ(o);
  return n.setMonth(r, Math.min(i, a)), n;
}
function Ed(t, e) {
  if (ot(2, arguments), wo(e) !== "object" || e === null)
    throw new RangeError("values parameter must be an object");
  var n = ut(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (e.year != null && n.setFullYear(e.year), e.month != null && (n = Hee(n, e.month)), e.date != null && n.setDate(Bn(e.date)), e.hours != null && n.setHours(Bn(e.hours)), e.minutes != null && n.setMinutes(Bn(e.minutes)), e.seconds != null && n.setSeconds(Bn(e.seconds)), e.milliseconds != null && n.setMilliseconds(Bn(e.milliseconds)), n);
}
function bi() {
  return uf(Date.now());
}
function z5() {
  var t = /* @__PURE__ */ new Date(), e = t.getFullYear(), n = t.getMonth(), r = t.getDate(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(e, n, r + 1), s.setHours(0, 0, 0, 0), s;
}
function U5() {
  var t = /* @__PURE__ */ new Date(), e = t.getFullYear(), n = t.getMonth(), r = t.getDate(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(e, n, r - 1), s.setHours(0, 0, 0, 0), s;
}
function Vee(t, e) {
  ot(2, arguments);
  var n = Bn(e);
  return fq(t, -n);
}
function KC(t, e, n) {
  ot(2, arguments);
  var r = Uo(t, n), s = Uo(e, n);
  return r.getTime() === s.getTime();
}
function sd(t, e) {
  if (t.one !== void 0 && e === 1)
    return t.one;
  var n = e % 10, r = e % 100;
  return n === 1 && r !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
function Ss(t) {
  return function(e, n) {
    return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? t.future ? sd(t.future, e) : "через " + sd(t.regular, e) : t.past ? sd(t.past, e) : sd(t.regular, e) + " назад" : sd(t.regular, e);
  };
}
var zee = {
  lessThanXSeconds: Ss({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Ss({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: function(e, n) {
    return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты";
  },
  lessThanXMinutes: Ss({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Ss({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Ss({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Ss({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Ss({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Ss({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Ss({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Ss({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Ss({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Ss({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Ss({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Ss({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Ss({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Uee = function(e, n, r) {
  return zee[e](n, r);
}, Gee = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Yee = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Zee = {
  any: "{{date}}, {{time}}"
}, Xee = {
  date: Gc({
    formats: Gee,
    defaultWidth: "full"
  }),
  time: Gc({
    formats: Yee,
    defaultWidth: "full"
  }),
  dateTime: Gc({
    formats: Zee,
    defaultWidth: "any"
  })
}, CS = ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
function Kee(t) {
  var e = CS[t];
  switch (t) {
    case 0:
      return "'в прошлое " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + e + " в' p";
  }
}
function JC(t) {
  var e = CS[t];
  return t === 2 ? "'во " + e + " в' p" : "'в " + e + " в' p";
}
function Jee(t) {
  var e = CS[t];
  switch (t) {
    case 0:
      return "'в следующее " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + e + " в' p";
  }
}
var qee = {
  lastWeek: function(e, n, r) {
    var s = e.getUTCDay();
    return KC(e, n, r) ? JC(s) : Kee(s);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function(e, n, r) {
    var s = e.getUTCDay();
    return KC(e, n, r) ? JC(s) : Jee(s);
  },
  other: "P"
}, Qee = function(e, n, r, s) {
  var i = qee[e];
  return typeof i == "function" ? i(n, r, s) : i;
}, ete = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, tte = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, nte = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "март", "апр.", "май", "июнь", "июль", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
}, rte = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "мар.", "апр.", "мая", "июн.", "июл.", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
}, ste = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"]
}, ite = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, ote = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, ate = function(e, n) {
  var r = Number(e), s = n == null ? void 0 : n.unit, i;
  return s === "date" ? i = "-е" : s === "week" || s === "minute" || s === "second" ? i = "-я" : i = "-й", r + i;
}, lte = {
  ordinalNumber: ate,
  era: uo({
    values: ete,
    defaultWidth: "wide"
  }),
  quarter: uo({
    values: tte,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: uo({
    values: nte,
    defaultWidth: "wide",
    formattingValues: rte,
    defaultFormattingWidth: "wide"
  }),
  day: uo({
    values: ste,
    defaultWidth: "wide"
  }),
  dayPeriod: uo({
    values: ite,
    defaultWidth: "any",
    formattingValues: ote,
    defaultFormattingWidth: "wide"
  })
}, cte = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, ute = /\d+/i, dte = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, fte = {
  any: [/^д/i, /^н/i]
}, pte = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, hte = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mte = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, vte = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, gte = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, yte = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, bte = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, _te = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, wte = {
  ordinalNumber: x5({
    matchPattern: cte,
    parsePattern: ute,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: fo({
    matchPatterns: dte,
    defaultMatchWidth: "wide",
    parsePatterns: fte,
    defaultParseWidth: "any"
  }),
  quarter: fo({
    matchPatterns: pte,
    defaultMatchWidth: "wide",
    parsePatterns: hte,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: fo({
    matchPatterns: mte,
    defaultMatchWidth: "wide",
    parsePatterns: vte,
    defaultParseWidth: "any"
  }),
  day: fo({
    matchPatterns: gte,
    defaultMatchWidth: "wide",
    parsePatterns: yte,
    defaultParseWidth: "any"
  }),
  dayPeriod: fo({
    matchPatterns: bte,
    defaultMatchWidth: "wide",
    parsePatterns: _te,
    defaultParseWidth: "any"
  })
}, xn = {
  code: "ru",
  formatDistance: Uee,
  formatLong: Xee,
  formatRelative: Qee,
  localize: lte,
  match: wte,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function Go(t, e = "yyyy-MM-dd'T'HH:mm:ssXXX") {
  if (!t) return null;
  const n = b0.utcToZonedTime(t, "Europe/Moscow");
  return b0.format(n, e, {
    timeZone: "Europe/Moscow",
    locale: xn
  });
}
const Ste = (t) => t.replace("&amp;", "&").replace("&lt;", "<").replace("&gt;", ">").replace("&nbsp;", " ").replace("&quot;", '"');
function I0(t) {
  return typeof t != "string" ? "" : t.replace(/<\/?[^>]+(>|$)/g, "").replace(/&([^;\s]+);/g, Ste).trim();
}
var Ite = function(e) {
  return Ete(e) && !xte(e);
};
function Ete(t) {
  return !!t && typeof t == "object";
}
function xte(t) {
  var e = Object.prototype.toString.call(t);
  return e === "[object RegExp]" || e === "[object Date]" || Pte(t);
}
var Cte = typeof Symbol == "function" && Symbol.for, Tte = Cte ? Symbol.for("react.element") : 60103;
function Pte(t) {
  return t.$$typeof === Tte;
}
const kte = /* @__PURE__ */ Et(Ite);
var Nte = typeof vr == "object" && vr && vr.Object === Object && vr, G5 = Nte, $te = G5, Dte = typeof self == "object" && self && self.Object === Object && self, Ate = $te || Dte || Function("return this")(), Rs = Ate, Ote = Rs, Mte = Ote.Symbol, bu = Mte, qC = bu, Y5 = Object.prototype, Rte = Y5.hasOwnProperty, Lte = Y5.toString, od = qC ? qC.toStringTag : void 0;
function Fte(t) {
  var e = Rte.call(t, od), n = t[od];
  try {
    t[od] = void 0;
    var r = !0;
  } catch {
  }
  var s = Lte.call(t);
  return r && (e ? t[od] = n : delete t[od]), s;
}
var Bte = Fte, jte = Object.prototype, Wte = jte.toString;
function Hte(t) {
  return Wte.call(t);
}
var Vte = Hte, QC = bu, zte = Bte, Ute = Vte, Gte = "[object Null]", Yte = "[object Undefined]", eT = QC ? QC.toStringTag : void 0;
function Zte(t) {
  return t == null ? t === void 0 ? Yte : Gte : eT && eT in Object(t) ? zte(t) : Ute(t);
}
var oc = Zte;
function Xte(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Yi = Xte, Kte = oc, Jte = Yi, qte = "[object AsyncFunction]", Qte = "[object Function]", ene = "[object GeneratorFunction]", tne = "[object Proxy]";
function nne(t) {
  if (!Jte(t))
    return !1;
  var e = Kte(t);
  return e == Qte || e == ene || e == qte || e == tne;
}
var TS = nne, rne = Rs, sne = rne["__core-js_shared__"], ine = sne, fy = ine, tT = function() {
  var t = /[^.]+$/.exec(fy && fy.keys && fy.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function one(t) {
  return !!tT && tT in t;
}
var ane = one, lne = Function.prototype, cne = lne.toString;
function une(t) {
  if (t != null) {
    try {
      return cne.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Z5 = une, dne = TS, fne = ane, pne = Yi, hne = Z5, mne = /[\\^$.*+?()[\]{}|]/g, vne = /^\[object .+?Constructor\]$/, gne = Function.prototype, yne = Object.prototype, bne = gne.toString, _ne = yne.hasOwnProperty, wne = RegExp(
  "^" + bne.call(_ne).replace(mne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Sne(t) {
  if (!pne(t) || fne(t))
    return !1;
  var e = dne(t) ? wne : vne;
  return e.test(hne(t));
}
var Ine = Sne;
function Ene(t, e) {
  return t == null ? void 0 : t[e];
}
var xne = Ene, Cne = Ine, Tne = xne;
function Pne(t, e) {
  var n = Tne(t, e);
  return Cne(n) ? n : void 0;
}
var ac = Pne, kne = ac, Nne = kne(Object, "create"), _v = Nne, nT = _v;
function $ne() {
  this.__data__ = nT ? nT(null) : {}, this.size = 0;
}
var Dne = $ne;
function Ane(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var One = Ane, Mne = _v, Rne = "__lodash_hash_undefined__", Lne = Object.prototype, Fne = Lne.hasOwnProperty;
function Bne(t) {
  var e = this.__data__;
  if (Mne) {
    var n = e[t];
    return n === Rne ? void 0 : n;
  }
  return Fne.call(e, t) ? e[t] : void 0;
}
var jne = Bne, Wne = _v, Hne = Object.prototype, Vne = Hne.hasOwnProperty;
function zne(t) {
  var e = this.__data__;
  return Wne ? e[t] !== void 0 : Vne.call(e, t);
}
var Une = zne, Gne = _v, Yne = "__lodash_hash_undefined__";
function Zne(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Gne && e === void 0 ? Yne : e, this;
}
var Xne = Zne, Kne = Dne, Jne = One, qne = jne, Qne = Une, ere = Xne;
function _u(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
_u.prototype.clear = Kne;
_u.prototype.delete = Jne;
_u.prototype.get = qne;
_u.prototype.has = Qne;
_u.prototype.set = ere;
var tre = _u;
function nre() {
  this.__data__ = [], this.size = 0;
}
var rre = nre;
function sre(t, e) {
  return t === e || t !== t && e !== e;
}
var PS = sre, ire = PS;
function ore(t, e) {
  for (var n = t.length; n--; )
    if (ire(t[n][0], e))
      return n;
  return -1;
}
var wv = ore, are = wv, lre = Array.prototype, cre = lre.splice;
function ure(t) {
  var e = this.__data__, n = are(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : cre.call(e, n, 1), --this.size, !0;
}
var dre = ure, fre = wv;
function pre(t) {
  var e = this.__data__, n = fre(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var hre = pre, mre = wv;
function vre(t) {
  return mre(this.__data__, t) > -1;
}
var gre = vre, yre = wv;
function bre(t, e) {
  var n = this.__data__, r = yre(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var _re = bre, wre = rre, Sre = dre, Ire = hre, Ere = gre, xre = _re;
function wu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
wu.prototype.clear = wre;
wu.prototype.delete = Sre;
wu.prototype.get = Ire;
wu.prototype.has = Ere;
wu.prototype.set = xre;
var Sv = wu, Cre = ac, Tre = Rs, Pre = Cre(Tre, "Map"), kS = Pre, rT = tre, kre = Sv, Nre = kS;
function $re() {
  this.size = 0, this.__data__ = {
    hash: new rT(),
    map: new (Nre || kre)(),
    string: new rT()
  };
}
var Dre = $re;
function Are(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var Ore = Are, Mre = Ore;
function Rre(t, e) {
  var n = t.__data__;
  return Mre(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Iv = Rre, Lre = Iv;
function Fre(t) {
  var e = Lre(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var Bre = Fre, jre = Iv;
function Wre(t) {
  return jre(this, t).get(t);
}
var Hre = Wre, Vre = Iv;
function zre(t) {
  return Vre(this, t).has(t);
}
var Ure = zre, Gre = Iv;
function Yre(t, e) {
  var n = Gre(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var Zre = Yre, Xre = Dre, Kre = Bre, Jre = Hre, qre = Ure, Qre = Zre;
function Su(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Su.prototype.clear = Xre;
Su.prototype.delete = Kre;
Su.prototype.get = Jre;
Su.prototype.has = qre;
Su.prototype.set = Qre;
var NS = Su, ese = "__lodash_hash_undefined__";
function tse(t) {
  return this.__data__.set(t, ese), this;
}
var nse = tse;
function rse(t) {
  return this.__data__.has(t);
}
var sse = rse, ise = NS, ose = nse, ase = sse;
function vm(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new ise(); ++e < n; )
    this.add(t[e]);
}
vm.prototype.add = vm.prototype.push = ose;
vm.prototype.has = ase;
var Ev = vm;
function lse(t, e, n, r) {
  for (var s = t.length, i = n + (r ? 1 : -1); r ? i-- : ++i < s; )
    if (e(t[i], i, t))
      return i;
  return -1;
}
var X5 = lse;
function cse(t) {
  return t !== t;
}
var use = cse;
function dse(t, e, n) {
  for (var r = n - 1, s = t.length; ++r < s; )
    if (t[r] === e)
      return r;
  return -1;
}
var fse = dse, pse = X5, hse = use, mse = fse;
function vse(t, e, n) {
  return e === e ? mse(t, e, n) : pse(t, hse, n);
}
var K5 = vse, gse = K5;
function yse(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && gse(t, e, 0) > -1;
}
var xv = yse;
function bse(t, e, n) {
  for (var r = -1, s = t == null ? 0 : t.length; ++r < s; )
    if (n(e, t[r]))
      return !0;
  return !1;
}
var $S = bse;
function _se(t, e) {
  return t.has(e);
}
var Cv = _se, wse = ac, Sse = Rs, Ise = wse(Sse, "Set"), J5 = Ise;
function Ese() {
}
var q5 = Ese;
function xse(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var DS = xse, py = J5, Cse = q5, Tse = DS, Pse = 1 / 0, kse = py && 1 / Tse(new py([, -0]))[1] == Pse ? function(t) {
  return new py(t);
} : Cse, Nse = kse, $se = Ev, Dse = xv, Ase = $S, Ose = Cv, Mse = Nse, Rse = DS, Lse = 200;
function Fse(t, e, n) {
  var r = -1, s = Dse, i = t.length, o = !0, a = [], l = a;
  if (n)
    o = !1, s = Ase;
  else if (i >= Lse) {
    var c = e ? null : Mse(t);
    if (c)
      return Rse(c);
    o = !1, s = Ose, l = new $se();
  } else
    l = e ? [] : a;
  e:
    for (; ++r < i; ) {
      var u = t[r], d = e ? e(u) : u;
      if (u = n || u !== 0 ? u : 0, o && d === d) {
        for (var f = l.length; f--; )
          if (l[f] === d)
            continue e;
        e && l.push(d), a.push(u);
      } else s(l, d, n) || (l !== a && l.push(d), a.push(u));
    }
  return a;
}
var Tv = Fse, Bse = Tv;
function jse(t, e) {
  return e = typeof e == "function" ? e : void 0, t && t.length ? Bse(t, void 0, e) : [];
}
var Wse = jse;
const AS = /* @__PURE__ */ Et(Wse);
var sT = Array.isArray, iT = Object.keys, Hse = Object.prototype.hasOwnProperty, Vse = function t(e, n) {
  if (e === n) return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    var r = sT(e), s = sT(n), i, o, a;
    if (r && s) {
      if (o = e.length, o != n.length) return !1;
      for (i = o; i-- !== 0; )
        if (!t(e[i], n[i])) return !1;
      return !0;
    }
    if (r != s) return !1;
    var l = e instanceof Date, c = n instanceof Date;
    if (l != c) return !1;
    if (l && c) return e.getTime() == n.getTime();
    var u = e instanceof RegExp, d = n instanceof RegExp;
    if (u != d) return !1;
    if (u && d) return e.toString() == n.toString();
    var f = iT(e);
    if (o = f.length, o !== iT(n).length)
      return !1;
    for (i = o; i-- !== 0; )
      if (!Hse.call(n, f[i])) return !1;
    for (i = o; i-- !== 0; )
      if (a = f[i], !t(e[a], n[a])) return !1;
    return !0;
  }
  return e !== e && n !== n;
};
const Q5 = /* @__PURE__ */ Et(Vse);
function zse(t) {
  return Array.isArray(t) ? [] : {};
}
function gm(t, e) {
  return e.clone !== !1 && e.isMergeableObject(t) ? df(zse(t), t, e) : t;
}
function Use(t, e, n) {
  const r = n.idProp || "id";
  return AS(
    t.concat(e).map((s) => gm(s, n)).reverse(),
    (s, i) => s[r] !== void 0 && i[r] !== void 0 ? s[r] === i[r] : Q5(s, i)
  ).reverse();
}
function Gse(t, e, n) {
  const r = {};
  return n.isMergeableObject(t) && Object.keys(t).forEach((s) => {
    r[s] = gm(t[s], n);
  }), Object.keys(e).forEach((s) => {
    !n.isMergeableObject(e[s]) || !t[s] ? e[s] !== void 0 && e[s] !== null && (r[s] = gm(e[s], n)) : r[s] = df(t[s], e[s], n);
  }), r;
}
const Yse = {
  arrayMerge: Use,
  isMergeableObject: kte
};
function df(t, e, n) {
  n = n || Yse;
  const r = Array.isArray(e), s = Array.isArray(t);
  return r === s ? r ? n.arrayMerge(t, e, n) : Gse(t, e, n) : gm(e, n);
}
df.all = function(e, n) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce((r, s) => df(r, s, n), {});
};
function E0(t, e) {
  let n = !1;
  t[0] === "#" && (t = t.slice(1), n = !0);
  let r = parseInt(t, 16), s = (r >> 16) + e;
  s > 255 ? s = 255 : s < 0 && (s = 0);
  let i = (r >> 8 & 255) + e;
  i > 255 ? i = 255 : i < 0 && (i = 0);
  let o = (r & 255) + e;
  return o > 255 ? o = 255 : o < 0 && (o = 0), (n ? "#" : "") + ("000000" + (o | i << 8 | s << 16).toString(16)).slice(-6);
}
function e4(t, e, n) {
  let r = 0;
  for (let i = 0; i < t.length; i++)
    r = t.charCodeAt(i) + ((r << 5) - r);
  return `hsl(${r % 360}, ${e}%, ${n}%)`;
}
function Ti(t) {
  return t && t.pathname || t;
}
function Zse(t) {
  return t.pathname.includes("/api/v1/") && !t.pathname.includes("swagger");
}
function Xse(t) {
  return Ti(t).includes("/entities/spb/");
}
function t4(t) {
  return Ti(t).includes("/leads/");
}
function Kse(t) {
  return Ti(t).includes("/auth/");
}
function Jse(t) {
  return Ti(t).endsWith("/auth/refresh/");
}
function qse(t) {
  return Ti(t).endsWith("/auth/");
}
function x0(t) {
  return Ti(t).includes("/newsbreaks/");
}
function Qse(t) {
  return Ti(t).includes("/news/");
}
function n4(t, e) {
  const n = Ti(t);
  return e === "get" && n.includes("/codes/");
}
function eie(t, e) {
  const n = Ti(t);
  return e === "get" && n.includes("/groups_and_users/");
}
function tie(t, e) {
  const n = Ti(t);
  return e === "get" && (n.includes("/asoi_notes/") || n.includes("USER_ASOI_NOTES"));
}
function r4(t, e) {
  return e === "get" && /\d{1,10}\/original\//.test(Ti(t));
}
function nie(t, e) {
  const n = Ti(t);
  return e === "get" && n.includes("/news/") && n.includes("/asoi_note/");
}
function rie(t) {
  return Xse(t);
}
const oT = {
  leads: t4,
  newsbreaks: x0,
  user_newsbreaks: x0,
  // news: isNews,
  flow: (t) => typeof t == "string" && t.toLowerCase().split(".")[0] === "flow",
  codes: n4,
  groupsAndUsers: eie,
  asoiNotes: tie,
  newsOriginal: r4,
  newsOriginalASOI: nie
};
function sie(t, e = "get") {
  if (typeof t == "string" && oT[t.toLowerCase()])
    return t.toLowerCase();
  const n = Object.entries(oT);
  for (let [r, s] of n)
    if (s(t, e.toLowerCase())) return r;
}
const C0 = {
  isAPIRequest: Zse,
  isNonGuardedRoute: rie,
  isAuth: Kse,
  isLeads: t4,
  isTokenRefresh: Jse,
  isLogin: qse,
  isNewsbreaks: x0,
  isNews: Qse,
  isCodes: n4,
  isNewsOriginal: r4,
  getDataKey: sie
}, s4 = (t) => P0.find((e) => e.name === t) || P0[0];
function Pv(t, e) {
  return t % 10 === 1 && t % 100 !== 11 ? e[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? e[1] : e[2];
}
const hy = {
  cyr: "аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ",
  lat: "fF,<dDuUlLtT`~;:pPbBqQrRkKvVyYjJgGhHcCnNeEaA[{wWxXiIoO]}sSmM'\".>zZ",
  except: "бБёЁжЖхХъЪэЭюЮ"
};
function i4(t) {
  const e = t.search(/[а-яА-ЯЁё]/g) !== -1, n = t.search(/[a-zA-Z]/g) !== -1;
  if (!(e ^ n)) return t;
  let r, s;
  return e && !n && (r = "cyr", s = "lat"), n && !e && (r = "lat", s = "cyr"), Array.from(t).map((i) => {
    if (hy.except.includes(i)) return i;
    const o = hy[r].indexOf(i);
    return o !== -1 ? hy[s][o] : i;
  }).join("");
}
function iie(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, s = Array(r); ++n < r; )
    s[n] = e(t[n], n, t);
  return s;
}
var Qa = iie, oie = Array.isArray, Wr = oie;
function aie(t) {
  return t != null && typeof t == "object";
}
var Pi = aie, lie = oc, cie = Pi, uie = "[object Symbol]";
function die(t) {
  return typeof t == "symbol" || cie(t) && lie(t) == uie;
}
var Iu = die, aT = bu, fie = Qa, pie = Wr, hie = Iu, mie = 1 / 0, lT = aT ? aT.prototype : void 0, cT = lT ? lT.toString : void 0;
function o4(t) {
  if (typeof t == "string")
    return t;
  if (pie(t))
    return fie(t, o4) + "";
  if (hie(t))
    return cT ? cT.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -mie ? "-0" : e;
}
var vie = o4, gie = vie;
function yie(t) {
  return t == null ? "" : gie(t);
}
var Lf = yie, bie = Lf, a4 = /[\\^$.*+?()[\]{}|]/g, _ie = RegExp(a4.source);
function wie(t) {
  return t = bie(t), t && _ie.test(t) ? t.replace(a4, "\\$&") : t;
}
var Sie = wie;
const ym = /* @__PURE__ */ Et(Sie);
function Ps(t) {
  return t && t.replaceAll ? t.replaceAll(".", "") : t;
}
function Iie(t) {
  return t.trim().split(" ").map((r) => {
    const s = Ps(r), i = i4(s);
    let o = ym(s);
    return o += "|" + ym(i), new RegExp(o, "gi");
  });
}
function T0(t) {
  return new Promise((e) => {
    const n = setTimeout(() => {
      clearTimeout(n), e(!0);
    }, t);
  });
}
const Eie = 280, l4 = [
  {
    name: "sepia",
    theme: "light",
    label: "Желтый",
    accentColor: "BD985C",
    backgroundColor: "FFF6E6",
    borderColor: "E99E18",
    color: "000000",
    control: "linear-gradient(180deg, #FFE091 0%, #FFD282 100%)",
    controlColor: "rgba(0, 0, 0, 0.6)"
  },
  {
    name: "blue",
    theme: "light",
    label: "Синий",
    accentColor: "A0CBF2",
    backgroundColor: "EEF7FF",
    borderColor: "1471DE",
    color: "000000",
    control: "linear-gradient(180deg, #78C6F2 0%, #78B8F2 100%)",
    controlColor: "rgba(255, 255, 255, 1)"
  },
  {
    name: "purple",
    theme: "light",
    label: "Фиолетовый",
    accentColor: "BE9DF2",
    backgroundColor: "F0ECF6",
    borderColor: "5D2BAD",
    color: "000000",
    control: "linear-gradient(180deg, #D38CFF 0%, #AA79F9 100%)",
    controlColor: "rgba(255, 255, 255, 1)"
  },
  {
    name: "green",
    theme: "light",
    label: "Зелёный",
    accentColor: "88DFA0",
    backgroundColor: "F0FBF3",
    borderColor: "1AA942",
    color: "000000",
    control: "linear-gradient(180deg, #6DF072 0%, #5BDF80 100%)",
    controlColor: "rgba(0, 0, 0, 0.6)"
  },
  {
    name: "red",
    theme: "light",
    label: "Красный",
    accentColor: "F39292",
    backgroundColor: "F9EFEF",
    borderColor: "BA3030",
    color: "000000",
    control: "linear-gradient(180deg, #FB997A 0%, #F36B6B 100%)",
    controlColor: "rgba(255, 255, 255, 1)"
  },
  {
    name: "black",
    theme: "dark",
    label: "Черный",
    accentColor: "464D53",
    backgroundColor: "596168",
    borderColor: "000000",
    color: "DCDCDC",
    control: "linear-gradient(180deg, #556266 0%, #383E43 100%)",
    controlColor: "rgba(255, 255, 255, 1)",
    codeColor: "519EF6",
    codeGroupColor: "B3B3B3",
    codeRecommendedColor: "55B45E"
  },
  {
    name: "white",
    theme: "light",
    label: "Белый",
    accentColor: "8C8C8C",
    backgroundColor: "FCFCFC",
    borderColor: "BBBBBB",
    color: "000000",
    control: "linear-gradient(180deg, #F0F0F0 0%, #DFDFDF 100%)",
    controlColor: "rgba(0, 0, 0, 0.6)"
  }
];
l4.forEach((t) => {
  t.messageTextColor = "4F4F4F", t.innerBorderColor = "0000001a", t.innerBorderColorLight = "0000000f", t.textColorLight = "FFFFFF";
  for (let s = 0; s < 11; s++)
    t["greyscale-" + s] = `hsl(0, 0%, ${s * 10}%)`;
  t.editorControlColor = "hsl(0, 0%, 30%)";
  const e = EJ(t.backgroundColor);
  t.editorControlBgColor = e.shift({ s: -10, l: -5 }), t.editorFooterBgColor = e.shift({ h: 2, l: 2 }), t.editorFooterColor = "hsl(0, 0%, 50%)", t.supplyBgColor = e.shift({ s: -e.s / 2, l: -3 }), t.supplyBgColorDarker = t.supplyBgColor.shift({ s: -7, l: -7 }), t.supplyBgColorGhost = e.shift({ s: -e.s * 0.89, l: -e.l * 0.21 }), t.supplyBgColorHover = e.shift({ s: -e.s * 0.37, l: -e.l * 0.08 }), t.lightAccentColor = e.shift({ s: -e.s * 0.1, l: -e.l * 0.32 }), t.messageColor = e.shift({ h: -1, s: -e.s * 0.26 }), t.messageSentColor = e.shift({ h: -1, s: -e.s * 0.31, l: -e.l * 0.1 }), t.messageHighlightColor = e.shift({ h: -1, s: -e.s * 0.07, l: -e.l * 0.17 });
  const n = {
    codeColor: "hsl(0, 0%, 20%)",
    codeColorHighlight: "#0069E4",
    codeBgColor: e.shift({ h: 4, s: -e.s * 0.2, l: -3 }),
    codeBorderColor: e.shift({ s: -e.s * 0.75, l: -15 }),
    codeGroupColor: "848484",
    codeRecommendedColor: "497041"
  };
  for (var r in n) t[r] || (t[r] = n[r]);
});
const xie = ["PT Astra Serif", "PT Astra Sans"], Cie = [120, 135, 150], c4 = {
  common: { default: 1, wide: 2 },
  newsItem: { default: 1.32, wide: 3.32 },
  canvas: { default: 1.32, wide: 3.32 }
}, Eu = {
  colors: wJ,
  panelWidth: Eie,
  schemes: l4,
  fonts: xie,
  lineHeights: Cie,
  panelScaleFactors: c4
}, Tie = "2.1.0", OS = !1, u4 = Tie, Pie = !0;
let kie = `https://${globalThis.location.host}/api/v1`, Nie = `https://${globalThis.location.host}/site_preview/v1/`, $ie = `https://${globalThis.location.host}/codes/v1`;
const d4 = kie, Die = Nie, Aie = $ie, uT = 1e3 * 60 * 2, Oie = Eu.colors, ji = Eu.panelWidth, P0 = Eu.schemes, Mie = Eu.fonts, Rie = Eu.lineHeights, Cr = Eu.panelScaleFactors, Lie = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, f4 = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, hr = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, Es = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, fa = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Ce {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(e, n) {
    const r = n.match(e);
    return r && r.length > 0 && r[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(e, n) {
    const r = n.match(e);
    return r && r.length > 1 && r[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(e, n, r) {
    if (e.test(n))
      return r;
  }
  static getWindowsVersionName(e) {
    switch (e) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(e) {
    const n = e.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), n[0] === 10)
      switch (n[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(e) {
    const n = e.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), !(n[0] === 1 && n[1] < 5)) {
      if (n[0] === 1 && n[1] < 6) return "Cupcake";
      if (n[0] === 1 && n[1] >= 6) return "Donut";
      if (n[0] === 2 && n[1] < 2) return "Eclair";
      if (n[0] === 2 && n[1] === 2) return "Froyo";
      if (n[0] === 2 && n[1] > 2) return "Gingerbread";
      if (n[0] === 3) return "Honeycomb";
      if (n[0] === 4 && n[1] < 1) return "Ice Cream Sandwich";
      if (n[0] === 4 && n[1] < 4) return "Jelly Bean";
      if (n[0] === 4 && n[1] >= 4) return "KitKat";
      if (n[0] === 5) return "Lollipop";
      if (n[0] === 6) return "Marshmallow";
      if (n[0] === 7) return "Nougat";
      if (n[0] === 8) return "Oreo";
      if (n[0] === 9) return "Pie";
    }
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(e) {
    return e.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(e, n, r = !1) {
    const s = Ce.getVersionPrecision(e), i = Ce.getVersionPrecision(n);
    let o = Math.max(s, i), a = 0;
    const l = Ce.map([e, n], (c) => {
      const u = o - Ce.getVersionPrecision(c), d = c + new Array(u + 1).join(".0");
      return Ce.map(d.split("."), (f) => new Array(20 - f.length).join("0") + f).reverse();
    });
    for (r && (a = o - Math.min(s, i)), o -= 1; o >= a; ) {
      if (l[0][o] > l[1][o])
        return 1;
      if (l[0][o] === l[1][o]) {
        if (o === a)
          return 0;
        o -= 1;
      } else if (l[0][o] < l[1][o])
        return -1;
    }
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(e, n) {
    const r = [];
    let s;
    if (Array.prototype.map)
      return Array.prototype.map.call(e, n);
    for (s = 0; s < e.length; s += 1)
      r.push(n(e[s]));
    return r;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(e, n) {
    let r, s;
    if (Array.prototype.find)
      return Array.prototype.find.call(e, n);
    for (r = 0, s = e.length; r < s; r += 1) {
      const i = e[r];
      if (n(i, r))
        return i;
    }
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(e, ...n) {
    const r = e;
    let s, i;
    if (Object.assign)
      return Object.assign(e, ...n);
    for (s = 0, i = n.length; s < i; s += 1) {
      const o = n[s];
      typeof o == "object" && o !== null && Object.keys(o).forEach((l) => {
        r[l] = o[l];
      });
    }
    return e;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(e) {
    return Lie[e];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(e) {
    return f4[e] || "";
  }
}
const En = /version\/(\d+(\.?_?\d+)+)/i, Fie = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(t) {
      const e = {
        name: "Googlebot"
      }, n = Ce.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, n = Ce.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(t) {
      const e = {
        name: "Samsung Internet for Android"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/Whale/i],
    describe(t) {
      const e = {
        name: "NAVER Whale Browser"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(t) {
      const e = {
        name: "MZ Browser"
      }, n = Ce.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/focus/i],
    describe(t) {
      const e = {
        name: "Focus"
      }, n = Ce.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/swing/i],
    describe(t) {
      const e = {
        name: "Swing"
      }, n = Ce.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/coast/i],
    describe(t) {
      const e = {
        name: "Opera Coast"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(t) {
      const e = {
        name: "Opera Touch"
      }, n = Ce.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/yabrowser/i],
    describe(t) {
      const e = {
        name: "Yandex Browser"
      }, n = Ce.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(t) {
      const e = {
        name: "UC Browser"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(t) {
      const e = {
        name: "Maxthon"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/epiphany/i],
    describe(t) {
      const e = {
        name: "Epiphany"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/puffin/i],
    describe(t) {
      const e = {
        name: "Puffin"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/sleipnir/i],
    describe(t) {
      const e = {
        name: "Sleipnir"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/k-meleon/i],
    describe(t) {
      const e = {
        name: "K-Meleon"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/micromessenger/i],
    describe(t) {
      const e = {
        name: "WeChat"
      }, n = Ce.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(t) {
      const e = {
        name: /qqbrowserlite/i.test(t) ? "QQ Browser Lite" : "QQ Browser"
      }, n = Ce.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/msie|trident/i],
    describe(t) {
      const e = {
        name: "Internet Explorer"
      }, n = Ce.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/\sedg\//i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, n = Ce.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, n = Ce.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/vivaldi/i],
    describe(t) {
      const e = {
        name: "Vivaldi"
      }, n = Ce.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/seamonkey/i],
    describe(t) {
      const e = {
        name: "SeaMonkey"
      }, n = Ce.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/sailfish/i],
    describe(t) {
      const e = {
        name: "Sailfish"
      }, n = Ce.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/silk/i],
    describe(t) {
      const e = {
        name: "Amazon Silk"
      }, n = Ce.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/phantom/i],
    describe(t) {
      const e = {
        name: "PhantomJS"
      }, n = Ce.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/slimerjs/i],
    describe(t) {
      const e = {
        name: "SlimerJS"
      }, n = Ce.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = {
        name: "BlackBerry"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = {
        name: "WebOS Browser"
      }, n = Ce.getFirstMatch(En, t) || Ce.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/bada/i],
    describe(t) {
      const e = {
        name: "Bada"
      }, n = Ce.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/tizen/i],
    describe(t) {
      const e = {
        name: "Tizen"
      }, n = Ce.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/qupzilla/i],
    describe(t) {
      const e = {
        name: "QupZilla"
      }, n = Ce.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(t) {
      const e = {
        name: "Firefox"
      }, n = Ce.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/electron/i],
    describe(t) {
      const e = {
        name: "Electron"
      }, n = Ce.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(t) {
      const e = {
        name: "Miui"
      }, n = Ce.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/chromium/i],
    describe(t) {
      const e = {
        name: "Chromium"
      }, n = Ce.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, t) || Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(t) {
      const e = {
        name: "Chrome"
      }, n = Ce.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/GSA/i],
    describe(t) {
      const e = {
        name: "Google Search"
      }, n = Ce.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Android Browser */
  {
    test(t) {
      const e = !t.test(/like android/i), n = t.test(/android/i);
      return e && n;
    },
    describe(t) {
      const e = {
        name: "Android Browser"
      }, n = Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(t) {
      const e = {
        name: "PlayStation 4"
      }, n = Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(t) {
      const e = {
        name: "Safari"
      }, n = Ce.getFirstMatch(En, t);
      return n && (e.version = n), e;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(t) {
      const e = /^(.*)\/(.*) /, n = /^(.*)\/(.*)[ \t]\((.*)/, s = t.search("\\(") !== -1 ? n : e;
      return {
        name: Ce.getFirstMatch(s, t),
        version: Ce.getSecondMatch(s, t)
      };
    }
  }
], Bie = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(t) {
      const e = Ce.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, t);
      return {
        name: Es.Roku,
        version: e
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(t) {
      const e = Ce.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, t);
      return {
        name: Es.WindowsPhone,
        version: e
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(t) {
      const e = Ce.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, t), n = Ce.getWindowsVersionName(e);
      return {
        name: Es.Windows,
        version: e,
        versionName: n
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(t) {
      const e = {
        name: Es.iOS
      }, n = Ce.getSecondMatch(/(Version\/)(\d[\d.]+)/, t);
      return n && (e.version = n), e;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(t) {
      const e = Ce.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, t).replace(/[_\s]/g, "."), n = Ce.getMacOSVersionName(e), r = {
        name: Es.MacOS,
        version: e
      };
      return n && (r.versionName = n), r;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(t) {
      const e = Ce.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, t).replace(/[_\s]/g, ".");
      return {
        name: Es.iOS,
        version: e
      };
    }
  },
  /* Android */
  {
    test(t) {
      const e = !t.test(/like android/i), n = t.test(/android/i);
      return e && n;
    },
    describe(t) {
      const e = Ce.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, t), n = Ce.getAndroidVersionName(e), r = {
        name: Es.Android,
        version: e
      };
      return n && (r.versionName = n), r;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = Ce.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, t), n = {
        name: Es.WebOS
      };
      return e && e.length && (n.version = e), n;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = Ce.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, t) || Ce.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, t) || Ce.getFirstMatch(/\bbb(\d+)/i, t);
      return {
        name: Es.BlackBerry,
        version: e
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(t) {
      const e = Ce.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, t);
      return {
        name: Es.Bada,
        version: e
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(t) {
      const e = Ce.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: Es.Tizen,
        version: e
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: Es.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: Es.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(t) {
      const e = Ce.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: Es.PlayStation4,
        version: e
      };
    }
  }
], jie = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(t) {
      const e = Ce.getFirstMatch(/(can-l01)/i, t) && "Nova", n = {
        type: hr.mobile,
        vendor: "Huawei"
      };
      return e && (n.model = e), n;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: hr.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: hr.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: hr.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: hr.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: hr.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: hr.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(t) {
      const e = t.test(/ipod|iphone/i), n = t.test(/like (ipod|iphone)/i);
      return e && !n;
    },
    describe(t) {
      const e = Ce.getFirstMatch(/(ipod|iphone)/i, t);
      return {
        type: hr.mobile,
        vendor: "Apple",
        model: e
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: hr.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: hr.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(t) {
      return t.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: hr.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(t) {
      return t.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: hr.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(t) {
      return t.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: hr.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(t) {
      const e = Number(String(t.getOSVersion()).split(".")[0]);
      return t.getOSName(!0) === "android" && e >= 3;
    },
    describe() {
      return {
        type: hr.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(t) {
      return t.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: hr.mobile
      };
    }
  },
  /* desktop */
  {
    test(t) {
      return t.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: hr.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(t) {
      return t.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: hr.desktop
      };
    }
  },
  /* Linux */
  {
    test(t) {
      return t.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: hr.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(t) {
      return t.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: hr.tv
      };
    }
  },
  /* Roku */
  {
    test(t) {
      return t.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: hr.tv
      };
    }
  }
], Wie = [
  /* EdgeHTML */
  {
    test(t) {
      return t.getBrowserName(!0) === "microsoft edge";
    },
    describe(t) {
      if (/\sedg\//i.test(t))
        return {
          name: fa.Blink
        };
      const n = Ce.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, t);
      return {
        name: fa.EdgeHTML,
        version: n
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(t) {
      const e = {
        name: fa.Trident
      }, n = Ce.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Presto */
  {
    test(t) {
      return t.test(/presto/i);
    },
    describe(t) {
      const e = {
        name: fa.Presto
      }, n = Ce.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Gecko */
  {
    test(t) {
      const e = t.test(/gecko/i), n = t.test(/like gecko/i);
      return e && !n;
    },
    describe(t) {
      const e = {
        name: fa.Gecko
      }, n = Ce.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: fa.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(t) {
      const e = {
        name: fa.WebKit
      }, n = Ce.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  }
];
class dT {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(e, n = !1) {
    if (e == null || e === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = e, this.parsedResult = {}, n !== !0 && this.parse();
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(e) {
    return e.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const e = Ce.find(Fie, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.browser = e.describe(this.getUA())), this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(e) {
    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const e = Ce.find(Bie, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(e) {
    const { name: n } = this.getOS();
    return e ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(e = !1) {
    const { type: n } = this.getPlatform();
    return e ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const e = Ce.find(jie, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.platform = e.describe(this.getUA())), this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(e) {
    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const e = Ce.find(Wie, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Ce.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(e) {
    const n = {};
    let r = 0;
    const s = {};
    let i = 0;
    if (Object.keys(e).forEach((a) => {
      const l = e[a];
      typeof l == "string" ? (s[a] = l, i += 1) : typeof l == "object" && (n[a] = l, r += 1);
    }), r > 0) {
      const a = Object.keys(n), l = Ce.find(a, (u) => this.isOS(u));
      if (l) {
        const u = this.satisfies(n[l]);
        if (u !== void 0)
          return u;
      }
      const c = Ce.find(
        a,
        (u) => this.isPlatform(u)
      );
      if (c) {
        const u = this.satisfies(n[c]);
        if (u !== void 0)
          return u;
      }
    }
    if (i > 0) {
      const a = Object.keys(s), l = Ce.find(a, (c) => this.isBrowser(c, !0));
      if (l !== void 0)
        return this.compareVersion(s[l]);
    }
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(e, n = !1) {
    const r = this.getBrowserName().toLowerCase();
    let s = e.toLowerCase();
    const i = Ce.getBrowserTypeByAlias(s);
    return n && i && (s = i.toLowerCase()), s === r;
  }
  compareVersion(e) {
    let n = [0], r = e, s = !1;
    const i = this.getBrowserVersion();
    if (typeof i == "string")
      return e[0] === ">" || e[0] === "<" ? (r = e.substr(1), e[1] === "=" ? (s = !0, r = e.substr(2)) : n = [], e[0] === ">" ? n.push(1) : n.push(-1)) : e[0] === "=" ? r = e.substr(1) : e[0] === "~" && (s = !0, r = e.substr(1)), n.indexOf(
        Ce.compareVersions(i, r, s)
      ) > -1;
  }
  isOS(e) {
    return this.getOSName(!0) === String(e).toLowerCase();
  }
  isPlatform(e) {
    return this.getPlatformType(!0) === String(e).toLowerCase();
  }
  isEngine(e) {
    return this.getEngineName(!0) === String(e).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(e, n = !1) {
    return this.isBrowser(e, n) || this.isOS(e) || this.isPlatform(e);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(e = []) {
    return e.some((n) => this.is(n));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class el {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(e, n = !1) {
    if (typeof e != "string")
      throw new Error("UserAgent should be a string");
    return new dT(e, n);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(e) {
    return new dT(e).getResult();
  }
  static get BROWSER_MAP() {
    return f4;
  }
  static get ENGINE_MAP() {
    return fa;
  }
  static get OS_MAP() {
    return Es;
  }
  static get PLATFORMS_MAP() {
    return hr;
  }
}
var p4 = { exports: {} };
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function lh(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lh = function(e) {
    return typeof e;
  } : lh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, lh(t);
}
function Hie(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Si() {
  return Si = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Si.apply(this, arguments);
}
function Va(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Hie(t, s, n[s]);
    });
  }
  return t;
}
function Vie(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), s, i;
  for (i = 0; i < r.length; i++)
    s = r[i], !(e.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function zie(t, e) {
  if (t == null) return {};
  var n = Vie(t, e), r, s;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (s = 0; s < i.length; s++)
      r = i[s], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Uie(t) {
  return Gie(t) || Yie(t) || Zie();
}
function Gie(t) {
  if (Array.isArray(t)) {
    for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
    return n;
  }
}
function Yie(t) {
  if (Symbol.iterator in Object(t) || Object.prototype.toString.call(t) === "[object Arguments]") return Array.from(t);
}
function Zie() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
var Xie = "1.10.2";
function Wo(t) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(t);
}
var Qo = Wo(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Ff = Wo(/Edge/i), fT = Wo(/firefox/i), k0 = Wo(/safari/i) && !Wo(/chrome/i) && !Wo(/android/i), h4 = Wo(/iP(ad|od|hone)/i), Kie = Wo(/chrome/i) && Wo(/android/i), m4 = {
  capture: !1,
  passive: !1
};
function Bt(t, e, n) {
  t.addEventListener(e, n, !Qo && m4);
}
function At(t, e, n) {
  t.removeEventListener(e, n, !Qo && m4);
}
function bm(t, e) {
  if (e) {
    if (e[0] === ">" && (e = e.substring(1)), t)
      try {
        if (t.matches)
          return t.matches(e);
        if (t.msMatchesSelector)
          return t.msMatchesSelector(e);
        if (t.webkitMatchesSelector)
          return t.webkitMatchesSelector(e);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Jie(t) {
  return t.host && t !== document && t.host.nodeType ? t.host : t.parentNode;
}
function Li(t, e, n, r) {
  if (t) {
    n = n || document;
    do {
      if (e != null && (e[0] === ">" ? t.parentNode === n && bm(t, e) : bm(t, e)) || r && t === n)
        return t;
      if (t === n) break;
    } while (t = Jie(t));
  }
  return null;
}
var pT = /\s+/g;
function Gn(t, e, n) {
  if (t && e)
    if (t.classList)
      t.classList[n ? "add" : "remove"](e);
    else {
      var r = (" " + t.className + " ").replace(pT, " ").replace(" " + e + " ", " ");
      t.className = (r + (n ? " " + e : "")).replace(pT, " ");
    }
}
function Ke(t, e, n) {
  var r = t && t.style;
  if (r) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(t, "") : t.currentStyle && (n = t.currentStyle), e === void 0 ? n : n[e];
    !(e in r) && e.indexOf("webkit") === -1 && (e = "-webkit-" + e), r[e] = n + (typeof n == "string" ? "" : "px");
  }
}
function jl(t, e) {
  var n = "";
  if (typeof t == "string")
    n = t;
  else
    do {
      var r = Ke(t, "transform");
      r && r !== "none" && (n = r + " " + n);
    } while (!e && (t = t.parentNode));
  var s = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return s && new s(n);
}
function v4(t, e, n) {
  if (t) {
    var r = t.getElementsByTagName(e), s = 0, i = r.length;
    if (n)
      for (; s < i; s++)
        n(r[s], s);
    return r;
  }
  return [];
}
function bo() {
  var t = document.scrollingElement;
  return t || document.documentElement;
}
function sr(t, e, n, r, s) {
  if (!(!t.getBoundingClientRect && t !== window)) {
    var i, o, a, l, c, u, d;
    if (t !== window && t !== bo() ? (i = t.getBoundingClientRect(), o = i.top, a = i.left, l = i.bottom, c = i.right, u = i.height, d = i.width) : (o = 0, a = 0, l = window.innerHeight, c = window.innerWidth, u = window.innerHeight, d = window.innerWidth), (e || n) && t !== window && (s = s || t.parentNode, !Qo))
      do
        if (s && s.getBoundingClientRect && (Ke(s, "transform") !== "none" || n && Ke(s, "position") !== "static")) {
          var f = s.getBoundingClientRect();
          o -= f.top + parseInt(Ke(s, "border-top-width")), a -= f.left + parseInt(Ke(s, "border-left-width")), l = o + i.height, c = a + i.width;
          break;
        }
      while (s = s.parentNode);
    if (r && t !== window) {
      var p = jl(s || t), h = p && p.a, m = p && p.d;
      p && (o /= m, a /= h, d /= h, u /= m, l = o + u, c = a + d);
    }
    return {
      top: o,
      left: a,
      bottom: l,
      right: c,
      width: d,
      height: u
    };
  }
}
function hT(t, e, n) {
  for (var r = Ea(t, !0), s = sr(t)[e]; r; ) {
    var i = sr(r)[n], o = void 0;
    if (o = s >= i, !o) return r;
    if (r === bo()) break;
    r = Ea(r, !1);
  }
  return !1;
}
function _m(t, e, n) {
  for (var r = 0, s = 0, i = t.children; s < i.length; ) {
    if (i[s].style.display !== "none" && i[s] !== pt.ghost && i[s] !== pt.dragged && Li(i[s], n.draggable, t, !1)) {
      if (r === e)
        return i[s];
      r++;
    }
    s++;
  }
  return null;
}
function MS(t, e) {
  for (var n = t.lastElementChild; n && (n === pt.ghost || Ke(n, "display") === "none" || e && !bm(n, e)); )
    n = n.previousElementSibling;
  return n || null;
}
function rr(t, e) {
  var n = 0;
  if (!t || !t.parentNode)
    return -1;
  for (; t = t.previousElementSibling; )
    t.nodeName.toUpperCase() !== "TEMPLATE" && t !== pt.clone && (!e || bm(t, e)) && n++;
  return n;
}
function mT(t) {
  var e = 0, n = 0, r = bo();
  if (t)
    do {
      var s = jl(t), i = s.a, o = s.d;
      e += t.scrollLeft * i, n += t.scrollTop * o;
    } while (t !== r && (t = t.parentNode));
  return [e, n];
}
function qie(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n)) {
      for (var r in e)
        if (e.hasOwnProperty(r) && e[r] === t[n][r]) return Number(n);
    }
  return -1;
}
function Ea(t, e) {
  if (!t || !t.getBoundingClientRect) return bo();
  var n = t, r = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var s = Ke(n);
      if (n.clientWidth < n.scrollWidth && (s.overflowX == "auto" || s.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (s.overflowY == "auto" || s.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body) return bo();
        if (r || e) return n;
        r = !0;
      }
    }
  while (n = n.parentNode);
  return bo();
}
function Qie(t, e) {
  if (t && e)
    for (var n in e)
      e.hasOwnProperty(n) && (t[n] = e[n]);
  return t;
}
function my(t, e) {
  return Math.round(t.top) === Math.round(e.top) && Math.round(t.left) === Math.round(e.left) && Math.round(t.height) === Math.round(e.height) && Math.round(t.width) === Math.round(e.width);
}
var jd;
function g4(t, e) {
  return function() {
    if (!jd) {
      var n = arguments, r = this;
      n.length === 1 ? t.call(r, n[0]) : t.apply(r, n), jd = setTimeout(function() {
        jd = void 0;
      }, e);
    }
  };
}
function eoe() {
  clearTimeout(jd), jd = void 0;
}
function y4(t, e, n) {
  t.scrollLeft += e, t.scrollTop += n;
}
function RS(t) {
  var e = window.Polymer, n = window.jQuery || window.Zepto;
  return e && e.dom ? e.dom(t).cloneNode(!0) : n ? n(t).clone(!0)[0] : t.cloneNode(!0);
}
function vT(t, e) {
  Ke(t, "position", "absolute"), Ke(t, "top", e.top), Ke(t, "left", e.left), Ke(t, "width", e.width), Ke(t, "height", e.height);
}
function vy(t) {
  Ke(t, "position", ""), Ke(t, "top", ""), Ke(t, "left", ""), Ke(t, "width", ""), Ke(t, "height", "");
}
var us = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function toe() {
  var t = [], e;
  return {
    captureAnimationState: function() {
      if (t = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(s) {
          if (!(Ke(s, "display") === "none" || s === pt.ghost)) {
            t.push({
              target: s,
              rect: sr(s)
            });
            var i = Va({}, t[t.length - 1].rect);
            if (s.thisAnimationDuration) {
              var o = jl(s, !0);
              o && (i.top -= o.f, i.left -= o.e);
            }
            s.fromRect = i;
          }
        });
      }
    },
    addAnimationState: function(r) {
      t.push(r);
    },
    removeAnimationState: function(r) {
      t.splice(qie(t, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var s = this;
      if (!this.options.animation) {
        clearTimeout(e), typeof r == "function" && r();
        return;
      }
      var i = !1, o = 0;
      t.forEach(function(a) {
        var l = 0, c = a.target, u = c.fromRect, d = sr(c), f = c.prevFromRect, p = c.prevToRect, h = a.rect, m = jl(c, !0);
        m && (d.top -= m.f, d.left -= m.e), c.toRect = d, c.thisAnimationDuration && my(f, d) && !my(u, d) && // Make sure animatingRect is on line between toRect & fromRect
        (h.top - d.top) / (h.left - d.left) === (u.top - d.top) / (u.left - d.left) && (l = roe(h, f, p, s.options)), my(d, u) || (c.prevFromRect = u, c.prevToRect = d, l || (l = s.options.animation), s.animate(c, h, d, l)), l && (i = !0, o = Math.max(o, l), clearTimeout(c.animationResetTimer), c.animationResetTimer = setTimeout(function() {
          c.animationTime = 0, c.prevFromRect = null, c.fromRect = null, c.prevToRect = null, c.thisAnimationDuration = null;
        }, l), c.thisAnimationDuration = l);
      }), clearTimeout(e), i ? e = setTimeout(function() {
        typeof r == "function" && r();
      }, o) : typeof r == "function" && r(), t = [];
    },
    animate: function(r, s, i, o) {
      if (o) {
        Ke(r, "transition", ""), Ke(r, "transform", "");
        var a = jl(this.el), l = a && a.a, c = a && a.d, u = (s.left - i.left) / (l || 1), d = (s.top - i.top) / (c || 1);
        r.animatingX = !!u, r.animatingY = !!d, Ke(r, "transform", "translate3d(" + u + "px," + d + "px,0)"), noe(r), Ke(r, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), Ke(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          Ke(r, "transition", ""), Ke(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, o);
      }
    }
  };
}
function noe(t) {
  return t.offsetWidth;
}
function roe(t, e, n, r) {
  return Math.sqrt(Math.pow(e.top - t.top, 2) + Math.pow(e.left - t.left, 2)) / Math.sqrt(Math.pow(e.top - n.top, 2) + Math.pow(e.left - n.left, 2)) * r.animation;
}
var ad = [], gy = {
  initializeByDefault: !0
}, Bf = {
  mount: function(e) {
    for (var n in gy)
      gy.hasOwnProperty(n) && !(n in e) && (e[n] = gy[n]);
    ad.push(e);
  },
  pluginEvent: function(e, n, r) {
    var s = this;
    this.eventCanceled = !1, r.cancel = function() {
      s.eventCanceled = !0;
    };
    var i = e + "Global";
    ad.forEach(function(o) {
      n[o.pluginName] && (n[o.pluginName][i] && n[o.pluginName][i](Va({
        sortable: n
      }, r)), n.options[o.pluginName] && n[o.pluginName][e] && n[o.pluginName][e](Va({
        sortable: n
      }, r)));
    });
  },
  initializePlugins: function(e, n, r, s) {
    ad.forEach(function(a) {
      var l = a.pluginName;
      if (!(!e.options[l] && !a.initializeByDefault)) {
        var c = new a(e, n, e.options);
        c.sortable = e, c.options = e.options, e[l] = c, Si(r, c.defaults);
      }
    });
    for (var i in e.options)
      if (e.options.hasOwnProperty(i)) {
        var o = this.modifyOption(e, i, e.options[i]);
        typeof o < "u" && (e.options[i] = o);
      }
  },
  getEventProperties: function(e, n) {
    var r = {};
    return ad.forEach(function(s) {
      typeof s.eventProperties == "function" && Si(r, s.eventProperties.call(n[s.pluginName], e));
    }), r;
  },
  modifyOption: function(e, n, r) {
    var s;
    return ad.forEach(function(i) {
      e[i.pluginName] && i.optionListeners && typeof i.optionListeners[n] == "function" && (s = i.optionListeners[n].call(e[i.pluginName], r));
    }), s;
  }
};
function xd(t) {
  var e = t.sortable, n = t.rootEl, r = t.name, s = t.targetEl, i = t.cloneEl, o = t.toEl, a = t.fromEl, l = t.oldIndex, c = t.newIndex, u = t.oldDraggableIndex, d = t.newDraggableIndex, f = t.originalEvent, p = t.putSortable, h = t.extraEventProperties;
  if (e = e || n && n[us], !!e) {
    var m, v = e.options, y = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !Qo && !Ff ? m = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (m = document.createEvent("Event"), m.initEvent(r, !0, !0)), m.to = o || n, m.from = a || n, m.item = s || n, m.clone = i, m.oldIndex = l, m.newIndex = c, m.oldDraggableIndex = u, m.newDraggableIndex = d, m.originalEvent = f, m.pullMode = p ? p.lastPutMode : void 0;
    var _ = Va({}, h, Bf.getEventProperties(r, e));
    for (var w in _)
      m[w] = _[w];
    n && n.dispatchEvent(m), v[y] && v[y].call(e, m);
  }
}
var js = function(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = r.evt, i = zie(r, ["evt"]);
  Bf.pluginEvent.bind(pt)(e, n, Va({
    dragEl: We,
    parentEl: Er,
    ghostEl: kt,
    rootEl: Un,
    nextEl: El,
    lastDownEl: ch,
    cloneEl: tr,
    cloneHidden: ya,
    dragStarted: Cd,
    putSortable: Yr,
    activeSortable: pt.active,
    originalEvent: s,
    oldIndex: Hc,
    oldDraggableIndex: Wd,
    newIndex: qs,
    newDraggableIndex: va,
    hideGhostForTarget: S4,
    unhideGhostForTarget: I4,
    cloneNowHidden: function() {
      ya = !0;
    },
    cloneNowShown: function() {
      ya = !1;
    },
    dispatchSortableEvent: function(a) {
      xs({
        sortable: n,
        name: a,
        originalEvent: s
      });
    }
  }, i));
};
function xs(t) {
  xd(Va({
    putSortable: Yr,
    cloneEl: tr,
    targetEl: We,
    rootEl: Un,
    oldIndex: Hc,
    oldDraggableIndex: Wd,
    newIndex: qs,
    newDraggableIndex: va
  }, t));
}
var We, Er, kt, Un, El, ch, tr, ya, Hc, qs, Wd, va, Ip, Yr, Mc = !1, wm = !1, Sm = [], bl, Di, yy, by, gT, yT, Cd, Ec, Hd, Vd = !1, Ep = !1, uh, as, _y = [], N0 = !1, Im = [], kv = typeof document < "u", xp = h4, bT = Ff || Qo ? "cssFloat" : "float", soe = kv && !Kie && !h4 && "draggable" in document.createElement("div"), b4 = function() {
  if (kv) {
    if (Qo)
      return !1;
    var t = document.createElement("x");
    return t.style.cssText = "pointer-events:auto", t.style.pointerEvents === "auto";
  }
}(), _4 = function(e, n) {
  var r = Ke(e), s = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), i = _m(e, 0, n), o = _m(e, 1, n), a = i && Ke(i), l = o && Ke(o), c = a && parseInt(a.marginLeft) + parseInt(a.marginRight) + sr(i).width, u = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + sr(o).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i && a.float && a.float !== "none") {
    var d = a.float === "left" ? "left" : "right";
    return o && (l.clear === "both" || l.clear === d) ? "vertical" : "horizontal";
  }
  return i && (a.display === "block" || a.display === "flex" || a.display === "table" || a.display === "grid" || c >= s && r[bT] === "none" || o && r[bT] === "none" && c + u > s) ? "vertical" : "horizontal";
}, ioe = function(e, n, r) {
  var s = r ? e.left : e.top, i = r ? e.right : e.bottom, o = r ? e.width : e.height, a = r ? n.left : n.top, l = r ? n.right : n.bottom, c = r ? n.width : n.height;
  return s === a || i === l || s + o / 2 === a + c / 2;
}, ooe = function(e, n) {
  var r;
  return Sm.some(function(s) {
    if (!MS(s)) {
      var i = sr(s), o = s[us].options.emptyInsertThreshold, a = e >= i.left - o && e <= i.right + o, l = n >= i.top - o && n <= i.bottom + o;
      if (o && a && l)
        return r = s;
    }
  }), r;
}, w4 = function(e) {
  function n(i, o) {
    return function(a, l, c, u) {
      var d = a.options.group.name && l.options.group.name && a.options.group.name === l.options.group.name;
      if (i == null && (o || d))
        return !0;
      if (i == null || i === !1)
        return !1;
      if (o && i === "clone")
        return i;
      if (typeof i == "function")
        return n(i(a, l, c, u), o)(a, l, c, u);
      var f = (o ? a : l).options.group.name;
      return i === !0 || typeof i == "string" && i === f || i.join && i.indexOf(f) > -1;
    };
  }
  var r = {}, s = e.group;
  (!s || lh(s) != "object") && (s = {
    name: s
  }), r.name = s.name, r.checkPull = n(s.pull, !0), r.checkPut = n(s.put), r.revertClone = s.revertClone, e.group = r;
}, S4 = function() {
  !b4 && kt && Ke(kt, "display", "none");
}, I4 = function() {
  !b4 && kt && Ke(kt, "display", "");
};
kv && document.addEventListener("click", function(t) {
  if (wm)
    return t.preventDefault(), t.stopPropagation && t.stopPropagation(), t.stopImmediatePropagation && t.stopImmediatePropagation(), wm = !1, !1;
}, !0);
var _l = function(e) {
  if (We) {
    e = e.touches ? e.touches[0] : e;
    var n = ooe(e.clientX, e.clientY);
    if (n) {
      var r = {};
      for (var s in e)
        e.hasOwnProperty(s) && (r[s] = e[s]);
      r.target = r.rootEl = n, r.preventDefault = void 0, r.stopPropagation = void 0, n[us]._onDragOver(r);
    }
  }
}, aoe = function(e) {
  We && We.parentNode[us]._isOutsideThisEl(e.target);
};
function pt(t, e) {
  if (!(t && t.nodeType && t.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t));
  this.el = t, this.options = e = Si({}, e), t[us] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(t.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return _4(t, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(o, a) {
      o.setData("Text", a.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: pt.supportPointer !== !1 && "PointerEvent" in window,
    emptyInsertThreshold: 5
  };
  Bf.initializePlugins(this, t, n);
  for (var r in n)
    !(r in e) && (e[r] = n[r]);
  w4(e);
  for (var s in this)
    s.charAt(0) === "_" && typeof this[s] == "function" && (this[s] = this[s].bind(this));
  this.nativeDraggable = e.forceFallback ? !1 : soe, this.nativeDraggable && (this.options.touchStartThreshold = 1), e.supportPointer ? Bt(t, "pointerdown", this._onTapStart) : (Bt(t, "mousedown", this._onTapStart), Bt(t, "touchstart", this._onTapStart)), this.nativeDraggable && (Bt(t, "dragover", this), Bt(t, "dragenter", this)), Sm.push(this.el), e.store && e.store.get && this.sort(e.store.get(this) || []), Si(this, toe());
}
pt.prototype = /** @lends Sortable.prototype */
{
  constructor: pt,
  _isOutsideThisEl: function(e) {
    !this.el.contains(e) && e !== this.el && (Ec = null);
  },
  _getDirection: function(e, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e, n, We) : this.options.direction;
  },
  _onTapStart: function(e) {
    if (e.cancelable) {
      var n = this, r = this.el, s = this.options, i = s.preventOnFilter, o = e.type, a = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, l = (a || e).target, c = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || l, u = s.filter;
      if (hoe(r), !We && !(/mousedown|pointerdown/.test(o) && e.button !== 0 || s.disabled) && !c.isContentEditable && (l = Li(l, s.draggable, r, !1), !(l && l.animated) && ch !== l)) {
        if (Hc = rr(l), Wd = rr(l, s.draggable), typeof u == "function") {
          if (u.call(this, e, l, this)) {
            xs({
              sortable: n,
              rootEl: c,
              name: "filter",
              targetEl: l,
              toEl: r,
              fromEl: r
            }), js("filter", n, {
              evt: e
            }), i && e.cancelable && e.preventDefault();
            return;
          }
        } else if (u && (u = u.split(",").some(function(d) {
          if (d = Li(c, d.trim(), r, !1), d)
            return xs({
              sortable: n,
              rootEl: d,
              name: "filter",
              targetEl: l,
              fromEl: r,
              toEl: r
            }), js("filter", n, {
              evt: e
            }), !0;
        }), u)) {
          i && e.cancelable && e.preventDefault();
          return;
        }
        s.handle && !Li(c, s.handle, r, !1) || this._prepareDragStart(e, a, l);
      }
    }
  },
  _prepareDragStart: function(e, n, r) {
    var s = this, i = s.el, o = s.options, a = i.ownerDocument, l;
    if (r && !We && r.parentNode === i) {
      var c = sr(r);
      if (Un = i, We = r, Er = We.parentNode, El = We.nextSibling, ch = r, Ip = o.group, pt.dragged = We, bl = {
        target: We,
        clientX: (n || e).clientX,
        clientY: (n || e).clientY
      }, gT = bl.clientX - c.left, yT = bl.clientY - c.top, this._lastX = (n || e).clientX, this._lastY = (n || e).clientY, We.style["will-change"] = "all", l = function() {
        if (js("delayEnded", s, {
          evt: e
        }), pt.eventCanceled) {
          s._onDrop();
          return;
        }
        s._disableDelayedDragEvents(), !fT && s.nativeDraggable && (We.draggable = !0), s._triggerDragStart(e, n), xs({
          sortable: s,
          name: "choose",
          originalEvent: e
        }), Gn(We, o.chosenClass, !0);
      }, o.ignore.split(",").forEach(function(u) {
        v4(We, u.trim(), Sy);
      }), Bt(a, "dragover", _l), Bt(a, "mousemove", _l), Bt(a, "touchmove", _l), Bt(a, "mouseup", s._onDrop), Bt(a, "touchend", s._onDrop), Bt(a, "touchcancel", s._onDrop), fT && this.nativeDraggable && (this.options.touchStartThreshold = 4, We.draggable = !0), js("delayStart", this, {
        evt: e
      }), o.delay && (!o.delayOnTouchOnly || n) && (!this.nativeDraggable || !(Ff || Qo))) {
        if (pt.eventCanceled) {
          this._onDrop();
          return;
        }
        Bt(a, "mouseup", s._disableDelayedDrag), Bt(a, "touchend", s._disableDelayedDrag), Bt(a, "touchcancel", s._disableDelayedDrag), Bt(a, "mousemove", s._delayedDragTouchMoveHandler), Bt(a, "touchmove", s._delayedDragTouchMoveHandler), o.supportPointer && Bt(a, "pointermove", s._delayedDragTouchMoveHandler), s._dragStartTimer = setTimeout(l, o.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(e) {
    var n = e.touches ? e.touches[0] : e;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    We && Sy(We), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e = this.el.ownerDocument;
    At(e, "mouseup", this._disableDelayedDrag), At(e, "touchend", this._disableDelayedDrag), At(e, "touchcancel", this._disableDelayedDrag), At(e, "mousemove", this._delayedDragTouchMoveHandler), At(e, "touchmove", this._delayedDragTouchMoveHandler), At(e, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e, n) {
    n = n || e.pointerType == "touch" && e, !this.nativeDraggable || n ? this.options.supportPointer ? Bt(document, "pointermove", this._onTouchMove) : n ? Bt(document, "touchmove", this._onTouchMove) : Bt(document, "mousemove", this._onTouchMove) : (Bt(We, "dragend", this), Bt(Un, "dragstart", this._onDragStart));
    try {
      document.selection ? dh(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(e, n) {
    if (Mc = !1, Un && We) {
      js("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && Bt(document, "dragover", aoe);
      var r = this.options;
      !e && Gn(We, r.dragClass, !1), Gn(We, r.ghostClass, !0), pt.active = this, e && this._appendGhost(), xs({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Di) {
      this._lastX = Di.clientX, this._lastY = Di.clientY, S4();
      for (var e = document.elementFromPoint(Di.clientX, Di.clientY), n = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(Di.clientX, Di.clientY), e !== n); )
        n = e;
      if (We.parentNode[us]._isOutsideThisEl(e), n)
        do {
          if (n[us]) {
            var r = void 0;
            if (r = n[us]._onDragOver({
              clientX: Di.clientX,
              clientY: Di.clientY,
              target: e,
              rootEl: n
            }), r && !this.options.dragoverBubble)
              break;
          }
          e = n;
        } while (n = n.parentNode);
      I4();
    }
  },
  _onTouchMove: function(e) {
    if (bl) {
      var n = this.options, r = n.fallbackTolerance, s = n.fallbackOffset, i = e.touches ? e.touches[0] : e, o = kt && jl(kt, !0), a = kt && o && o.a, l = kt && o && o.d, c = xp && as && mT(as), u = (i.clientX - bl.clientX + s.x) / (a || 1) + (c ? c[0] - _y[0] : 0) / (a || 1), d = (i.clientY - bl.clientY + s.y) / (l || 1) + (c ? c[1] - _y[1] : 0) / (l || 1);
      if (!pt.active && !Mc) {
        if (r && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < r)
          return;
        this._onDragStart(e, !0);
      }
      if (kt) {
        o ? (o.e += u - (yy || 0), o.f += d - (by || 0)) : o = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: u,
          f: d
        };
        var f = "matrix(".concat(o.a, ",").concat(o.b, ",").concat(o.c, ",").concat(o.d, ",").concat(o.e, ",").concat(o.f, ")");
        Ke(kt, "webkitTransform", f), Ke(kt, "mozTransform", f), Ke(kt, "msTransform", f), Ke(kt, "transform", f), yy = u, by = d, Di = i;
      }
      e.cancelable && e.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!kt) {
      var e = this.options.fallbackOnBody ? document.body : Un, n = sr(We, !0, xp, !0, e), r = this.options;
      if (xp) {
        for (as = e; Ke(as, "position") === "static" && Ke(as, "transform") === "none" && as !== document; )
          as = as.parentNode;
        as !== document.body && as !== document.documentElement ? (as === document && (as = bo()), n.top += as.scrollTop, n.left += as.scrollLeft) : as = bo(), _y = mT(as);
      }
      kt = We.cloneNode(!0), Gn(kt, r.ghostClass, !1), Gn(kt, r.fallbackClass, !0), Gn(kt, r.dragClass, !0), Ke(kt, "transition", ""), Ke(kt, "transform", ""), Ke(kt, "box-sizing", "border-box"), Ke(kt, "margin", 0), Ke(kt, "top", n.top), Ke(kt, "left", n.left), Ke(kt, "width", n.width), Ke(kt, "height", n.height), Ke(kt, "opacity", "0.8"), Ke(kt, "position", xp ? "absolute" : "fixed"), Ke(kt, "zIndex", "100000"), Ke(kt, "pointerEvents", "none"), pt.ghost = kt, e.appendChild(kt), Ke(kt, "transform-origin", gT / parseInt(kt.style.width) * 100 + "% " + yT / parseInt(kt.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e, n) {
    var r = this, s = e.dataTransfer, i = r.options;
    if (js("dragStart", this, {
      evt: e
    }), pt.eventCanceled) {
      this._onDrop();
      return;
    }
    js("setupClone", this), pt.eventCanceled || (tr = RS(We), tr.draggable = !1, tr.style["will-change"] = "", this._hideClone(), Gn(tr, this.options.chosenClass, !1), pt.clone = tr), r.cloneId = dh(function() {
      js("clone", r), !pt.eventCanceled && (r.options.removeCloneOnHide || Un.insertBefore(tr, We), r._hideClone(), xs({
        sortable: r,
        name: "clone"
      }));
    }), !n && Gn(We, i.dragClass, !0), n ? (wm = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (At(document, "mouseup", r._onDrop), At(document, "touchend", r._onDrop), At(document, "touchcancel", r._onDrop), s && (s.effectAllowed = "move", i.setData && i.setData.call(r, s, We)), Bt(document, "drop", r), Ke(We, "transform", "translateZ(0)")), Mc = !0, r._dragStartId = dh(r._dragStarted.bind(r, n, e)), Bt(document, "selectstart", r), Cd = !0, k0 && Ke(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e) {
    var n = this.el, r = e.target, s, i, o, a = this.options, l = a.group, c = pt.active, u = Ip === l, d = a.sort, f = Yr || c, p, h = this, m = !1;
    if (N0) return;
    function v(A, j) {
      js(A, h, Va({
        evt: e,
        isOwner: u,
        axis: p ? "vertical" : "horizontal",
        revert: o,
        dragRect: s,
        targetRect: i,
        canSort: d,
        fromSortable: f,
        target: r,
        completed: _,
        onMove: function(se, V) {
          return wy(Un, n, We, s, se, sr(se), e, V);
        },
        changed: w
      }, j));
    }
    function y() {
      v("dragOverAnimationCapture"), h.captureAnimationState(), h !== f && f.captureAnimationState();
    }
    function _(A) {
      return v("dragOverCompleted", {
        insertion: A
      }), A && (u ? c._hideClone() : c._showClone(h), h !== f && (Gn(We, Yr ? Yr.options.ghostClass : c.options.ghostClass, !1), Gn(We, a.ghostClass, !0)), Yr !== h && h !== pt.active ? Yr = h : h === pt.active && Yr && (Yr = null), f === h && (h._ignoreWhileAnimating = r), h.animateAll(function() {
        v("dragOverAnimationComplete"), h._ignoreWhileAnimating = null;
      }), h !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (r === We && !We.animated || r === n && !r.animated) && (Ec = null), !a.dragoverBubble && !e.rootEl && r !== document && (We.parentNode[us]._isOutsideThisEl(e.target), !A && _l(e)), !a.dragoverBubble && e.stopPropagation && e.stopPropagation(), m = !0;
    }
    function w() {
      qs = rr(We), va = rr(We, a.draggable), xs({
        sortable: h,
        name: "change",
        toEl: n,
        newIndex: qs,
        newDraggableIndex: va,
        originalEvent: e
      });
    }
    if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), r = Li(r, a.draggable, n, !0), v("dragOver"), pt.eventCanceled) return m;
    if (We.contains(e.target) || r.animated && r.animatingX && r.animatingY || h._ignoreWhileAnimating === r)
      return _(!1);
    if (wm = !1, c && !a.disabled && (u ? d || (o = !Un.contains(We)) : Yr === this || (this.lastPutMode = Ip.checkPull(this, c, We, e)) && l.checkPut(this, c, We, e))) {
      if (p = this._getDirection(e, r) === "vertical", s = sr(We), v("dragOverValid"), pt.eventCanceled) return m;
      if (o)
        return Er = Un, y(), this._hideClone(), v("revert"), pt.eventCanceled || (El ? Un.insertBefore(We, El) : Un.appendChild(We)), _(!0);
      var S = MS(n, a.draggable);
      if (!S || uoe(e, p, this) && !S.animated) {
        if (S === We)
          return _(!1);
        if (S && n === e.target && (r = S), r && (i = sr(r)), wy(Un, n, We, s, r, i, e, !!r) !== !1)
          return y(), n.appendChild(We), Er = n, w(), _(!0);
      } else if (r.parentNode === n) {
        i = sr(r);
        var E = 0, x, T = We.parentNode !== n, C = !ioe(We.animated && We.toRect || s, r.animated && r.toRect || i, p), k = p ? "top" : "left", b = hT(r, "top", "top") || hT(We, "top", "top"), P = b ? b.scrollTop : void 0;
        Ec !== r && (x = i[k], Vd = !1, Ep = !C && a.invertSwap || T), E = doe(e, r, i, p, C ? 1 : a.swapThreshold, a.invertedSwapThreshold == null ? a.swapThreshold : a.invertedSwapThreshold, Ep, Ec === r);
        var N;
        if (E !== 0) {
          var D = rr(We);
          do
            D -= E, N = Er.children[D];
          while (N && (Ke(N, "display") === "none" || N === kt));
        }
        if (E === 0 || N === r)
          return _(!1);
        Ec = r, Hd = E;
        var H = r.nextElementSibling, Y = !1;
        Y = E === 1;
        var te = wy(Un, n, We, s, r, i, e, Y);
        if (te !== !1)
          return (te === 1 || te === -1) && (Y = te === 1), N0 = !0, setTimeout(coe, 30), y(), Y && !H ? n.appendChild(We) : r.parentNode.insertBefore(We, Y ? H : r), b && y4(b, 0, P - b.scrollTop), Er = We.parentNode, x !== void 0 && !Ep && (uh = Math.abs(x - sr(r)[k])), w(), _(!0);
      }
      if (n.contains(We))
        return _(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    At(document, "mousemove", this._onTouchMove), At(document, "touchmove", this._onTouchMove), At(document, "pointermove", this._onTouchMove), At(document, "dragover", _l), At(document, "mousemove", _l), At(document, "touchmove", _l);
  },
  _offUpEvents: function() {
    var e = this.el.ownerDocument;
    At(e, "mouseup", this._onDrop), At(e, "touchend", this._onDrop), At(e, "pointerup", this._onDrop), At(e, "touchcancel", this._onDrop), At(document, "selectstart", this);
  },
  _onDrop: function(e) {
    var n = this.el, r = this.options;
    if (qs = rr(We), va = rr(We, r.draggable), js("drop", this, {
      evt: e
    }), Er = We && We.parentNode, qs = rr(We), va = rr(We, r.draggable), pt.eventCanceled) {
      this._nulling();
      return;
    }
    Mc = !1, Ep = !1, Vd = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), $0(this.cloneId), $0(this._dragStartId), this.nativeDraggable && (At(document, "drop", this), At(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), k0 && Ke(document.body, "user-select", ""), Ke(We, "transform", ""), e && (Cd && (e.cancelable && e.preventDefault(), !r.dropBubble && e.stopPropagation()), kt && kt.parentNode && kt.parentNode.removeChild(kt), (Un === Er || Yr && Yr.lastPutMode !== "clone") && tr && tr.parentNode && tr.parentNode.removeChild(tr), We && (this.nativeDraggable && At(We, "dragend", this), Sy(We), We.style["will-change"] = "", Cd && !Mc && Gn(We, Yr ? Yr.options.ghostClass : this.options.ghostClass, !1), Gn(We, this.options.chosenClass, !1), xs({
      sortable: this,
      name: "unchoose",
      toEl: Er,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e
    }), Un !== Er ? (qs >= 0 && (xs({
      rootEl: Er,
      name: "add",
      toEl: Er,
      fromEl: Un,
      originalEvent: e
    }), xs({
      sortable: this,
      name: "remove",
      toEl: Er,
      originalEvent: e
    }), xs({
      rootEl: Er,
      name: "sort",
      toEl: Er,
      fromEl: Un,
      originalEvent: e
    }), xs({
      sortable: this,
      name: "sort",
      toEl: Er,
      originalEvent: e
    })), Yr && Yr.save()) : qs !== Hc && qs >= 0 && (xs({
      sortable: this,
      name: "update",
      toEl: Er,
      originalEvent: e
    }), xs({
      sortable: this,
      name: "sort",
      toEl: Er,
      originalEvent: e
    })), pt.active && ((qs == null || qs === -1) && (qs = Hc, va = Wd), xs({
      sortable: this,
      name: "end",
      toEl: Er,
      originalEvent: e
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    js("nulling", this), Un = We = Er = kt = El = tr = ch = ya = bl = Di = Cd = qs = va = Hc = Wd = Ec = Hd = Yr = Ip = pt.dragged = pt.ghost = pt.clone = pt.active = null, Im.forEach(function(e) {
      e.checked = !0;
    }), Im.length = yy = by = 0;
  },
  handleEvent: function(e) {
    switch (e.type) {
      case "drop":
      case "dragend":
        this._onDrop(e);
        break;
      case "dragenter":
      case "dragover":
        We && (this._onDragOver(e), loe(e));
        break;
      case "selectstart":
        e.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e = [], n, r = this.el.children, s = 0, i = r.length, o = this.options; s < i; s++)
      n = r[s], Li(n, o.draggable, this.el, !1) && e.push(n.getAttribute(o.dataIdAttr) || poe(n));
    return e;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e) {
    var n = {}, r = this.el;
    this.toArray().forEach(function(s, i) {
      var o = r.children[i];
      Li(o, this.options.draggable, r, !1) && (n[s] = o);
    }, this), e.forEach(function(s) {
      n[s] && (r.removeChild(n[s]), r.appendChild(n[s]));
    });
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e = this.options.store;
    e && e.set && e.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e, n) {
    return Li(e, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e, n) {
    var r = this.options;
    if (n === void 0)
      return r[e];
    var s = Bf.modifyOption(this, e, n);
    typeof s < "u" ? r[e] = s : r[e] = n, e === "group" && w4(r);
  },
  /**
   * Destroy
   */
  destroy: function() {
    js("destroy", this);
    var e = this.el;
    e[us] = null, At(e, "mousedown", this._onTapStart), At(e, "touchstart", this._onTapStart), At(e, "pointerdown", this._onTapStart), this.nativeDraggable && (At(e, "dragover", this), At(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Sm.splice(Sm.indexOf(this.el), 1), this.el = e = null;
  },
  _hideClone: function() {
    if (!ya) {
      if (js("hideClone", this), pt.eventCanceled) return;
      Ke(tr, "display", "none"), this.options.removeCloneOnHide && tr.parentNode && tr.parentNode.removeChild(tr), ya = !0;
    }
  },
  _showClone: function(e) {
    if (e.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (ya) {
      if (js("showClone", this), pt.eventCanceled) return;
      Un.contains(We) && !this.options.group.revertClone ? Un.insertBefore(tr, We) : El ? Un.insertBefore(tr, El) : Un.appendChild(tr), this.options.group.revertClone && this.animate(We, tr), Ke(tr, "display", ""), ya = !1;
    }
  }
};
function loe(t) {
  t.dataTransfer && (t.dataTransfer.dropEffect = "move"), t.cancelable && t.preventDefault();
}
function wy(t, e, n, r, s, i, o, a) {
  var l, c = t[us], u = c.options.onMove, d;
  return window.CustomEvent && !Qo && !Ff ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = e, l.from = t, l.dragged = n, l.draggedRect = r, l.related = s || e, l.relatedRect = i || sr(e), l.willInsertAfter = a, l.originalEvent = o, t.dispatchEvent(l), u && (d = u.call(c, l, o)), d;
}
function Sy(t) {
  t.draggable = !1;
}
function coe() {
  N0 = !1;
}
function uoe(t, e, n) {
  var r = sr(MS(n.el, n.options.draggable)), s = 10;
  return e ? t.clientX > r.right + s || t.clientX <= r.right && t.clientY > r.bottom && t.clientX >= r.left : t.clientX > r.right && t.clientY > r.top || t.clientX <= r.right && t.clientY > r.bottom + s;
}
function doe(t, e, n, r, s, i, o, a) {
  var l = r ? t.clientY : t.clientX, c = r ? n.height : n.width, u = r ? n.top : n.left, d = r ? n.bottom : n.right, f = !1;
  if (!o) {
    if (a && uh < c * s) {
      if (!Vd && (Hd === 1 ? l > u + c * i / 2 : l < d - c * i / 2) && (Vd = !0), Vd)
        f = !0;
      else if (Hd === 1 ? l < u + uh : l > d - uh)
        return -Hd;
    } else if (l > u + c * (1 - s) / 2 && l < d - c * (1 - s) / 2)
      return foe(e);
  }
  return f = f || o, f && (l < u + c * i / 2 || l > d - c * i / 2) ? l > u + c / 2 ? 1 : -1 : 0;
}
function foe(t) {
  return rr(We) < rr(t) ? 1 : -1;
}
function poe(t) {
  for (var e = t.tagName + t.className + t.src + t.href + t.textContent, n = e.length, r = 0; n--; )
    r += e.charCodeAt(n);
  return r.toString(36);
}
function hoe(t) {
  Im.length = 0;
  for (var e = t.getElementsByTagName("input"), n = e.length; n--; ) {
    var r = e[n];
    r.checked && Im.push(r);
  }
}
function dh(t) {
  return setTimeout(t, 0);
}
function $0(t) {
  return clearTimeout(t);
}
kv && Bt(document, "touchmove", function(t) {
  (pt.active || Mc) && t.cancelable && t.preventDefault();
});
pt.utils = {
  on: Bt,
  off: At,
  css: Ke,
  find: v4,
  is: function(e, n) {
    return !!Li(e, n, e, !1);
  },
  extend: Qie,
  throttle: g4,
  closest: Li,
  toggleClass: Gn,
  clone: RS,
  index: rr,
  nextTick: dh,
  cancelNextTick: $0,
  detectDirection: _4,
  getChild: _m
};
pt.get = function(t) {
  return t[us];
};
pt.mount = function() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  e[0].constructor === Array && (e = e[0]), e.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && (pt.utils = Va({}, pt.utils, r.utils)), Bf.mount(r);
  });
};
pt.create = function(t, e) {
  return new pt(t, e);
};
pt.version = Xie;
var xr = [], Td, D0, A0 = !1, Iy, Ey, Em, Pd;
function moe() {
  function t() {
    this.defaults = {
      scroll: !0,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var e in this)
      e.charAt(0) === "_" && typeof this[e] == "function" && (this[e] = this[e].bind(this));
  }
  return t.prototype = {
    dragStarted: function(n) {
      var r = n.originalEvent;
      this.sortable.nativeDraggable ? Bt(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? Bt(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? Bt(document, "touchmove", this._handleFallbackAutoScroll) : Bt(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var r = n.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? At(document, "dragover", this._handleAutoScroll) : (At(document, "pointermove", this._handleFallbackAutoScroll), At(document, "touchmove", this._handleFallbackAutoScroll), At(document, "mousemove", this._handleFallbackAutoScroll)), _T(), fh(), eoe();
    },
    nulling: function() {
      Em = D0 = Td = A0 = Pd = Iy = Ey = null, xr.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, r) {
      var s = this, i = (n.touches ? n.touches[0] : n).clientX, o = (n.touches ? n.touches[0] : n).clientY, a = document.elementFromPoint(i, o);
      if (Em = n, r || Ff || Qo || k0) {
        xy(n, this.options, a, r);
        var l = Ea(a, !0);
        A0 && (!Pd || i !== Iy || o !== Ey) && (Pd && _T(), Pd = setInterval(function() {
          var c = Ea(document.elementFromPoint(i, o), !0);
          c !== l && (l = c, fh()), xy(n, s.options, c, r);
        }, 10), Iy = i, Ey = o);
      } else {
        if (!this.options.bubbleScroll || Ea(a, !0) === bo()) {
          fh();
          return;
        }
        xy(n, this.options, Ea(a, !1), !1);
      }
    }
  }, Si(t, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function fh() {
  xr.forEach(function(t) {
    clearInterval(t.pid);
  }), xr = [];
}
function _T() {
  clearInterval(Pd);
}
var xy = g4(function(t, e, n, r) {
  if (e.scroll) {
    var s = (t.touches ? t.touches[0] : t).clientX, i = (t.touches ? t.touches[0] : t).clientY, o = e.scrollSensitivity, a = e.scrollSpeed, l = bo(), c = !1, u;
    D0 !== n && (D0 = n, fh(), Td = e.scroll, u = e.scrollFn, Td === !0 && (Td = Ea(n, !0)));
    var d = 0, f = Td;
    do {
      var p = f, h = sr(p), m = h.top, v = h.bottom, y = h.left, _ = h.right, w = h.width, S = h.height, E = void 0, x = void 0, T = p.scrollWidth, C = p.scrollHeight, k = Ke(p), b = p.scrollLeft, P = p.scrollTop;
      p === l ? (E = w < T && (k.overflowX === "auto" || k.overflowX === "scroll" || k.overflowX === "visible"), x = S < C && (k.overflowY === "auto" || k.overflowY === "scroll" || k.overflowY === "visible")) : (E = w < T && (k.overflowX === "auto" || k.overflowX === "scroll"), x = S < C && (k.overflowY === "auto" || k.overflowY === "scroll"));
      var N = E && (Math.abs(_ - s) <= o && b + w < T) - (Math.abs(y - s) <= o && !!b), D = x && (Math.abs(v - i) <= o && P + S < C) - (Math.abs(m - i) <= o && !!P);
      if (!xr[d])
        for (var H = 0; H <= d; H++)
          xr[H] || (xr[H] = {});
      (xr[d].vx != N || xr[d].vy != D || xr[d].el !== p) && (xr[d].el = p, xr[d].vx = N, xr[d].vy = D, clearInterval(xr[d].pid), (N != 0 || D != 0) && (c = !0, xr[d].pid = setInterval((function() {
        r && this.layer === 0 && pt.active._onTouchMove(Em);
        var Y = xr[this.layer].vy ? xr[this.layer].vy * a : 0, te = xr[this.layer].vx ? xr[this.layer].vx * a : 0;
        typeof u == "function" && u.call(pt.dragged.parentNode[us], te, Y, t, Em, xr[this.layer].el) !== "continue" || y4(xr[this.layer].el, te, Y);
      }).bind({
        layer: d
      }), 24))), d++;
    } while (e.bubbleScroll && f !== l && (f = Ea(f, !1)));
    A0 = c;
  }
}, 30), E4 = function(e) {
  var n = e.originalEvent, r = e.putSortable, s = e.dragEl, i = e.activeSortable, o = e.dispatchSortableEvent, a = e.hideGhostForTarget, l = e.unhideGhostForTarget;
  if (n) {
    var c = r || i;
    a();
    var u = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, d = document.elementFromPoint(u.clientX, u.clientY);
    l(), c && !c.el.contains(d) && (o("spill"), this.onSpill({
      dragEl: s,
      putSortable: r
    }));
  }
};
function LS() {
}
LS.prototype = {
  startIndex: null,
  dragStart: function(e) {
    var n = e.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(e) {
    var n = e.dragEl, r = e.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var s = _m(this.sortable.el, this.startIndex, this.options);
    s ? this.sortable.el.insertBefore(n, s) : this.sortable.el.appendChild(n), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: E4
};
Si(LS, {
  pluginName: "revertOnSpill"
});
function FS() {
}
FS.prototype = {
  onSpill: function(e) {
    var n = e.dragEl, r = e.putSortable, s = r || this.sortable;
    s.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), s.animateAll();
  },
  drop: E4
};
Si(FS, {
  pluginName: "removeOnSpill"
});
var fi;
function voe() {
  function t() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return t.prototype = {
    dragStart: function(n) {
      var r = n.dragEl;
      fi = r;
    },
    dragOverValid: function(n) {
      var r = n.completed, s = n.target, i = n.onMove, o = n.activeSortable, a = n.changed, l = n.cancel;
      if (o.options.swap) {
        var c = this.sortable.el, u = this.options;
        if (s && s !== c) {
          var d = fi;
          i(s) !== !1 ? (Gn(s, u.swapClass, !0), fi = s) : fi = null, d && d !== fi && Gn(d, u.swapClass, !1);
        }
        a(), r(!0), l();
      }
    },
    drop: function(n) {
      var r = n.activeSortable, s = n.putSortable, i = n.dragEl, o = s || this.sortable, a = this.options;
      fi && Gn(fi, a.swapClass, !1), fi && (a.swap || s && s.options.swap) && i !== fi && (o.captureAnimationState(), o !== r && r.captureAnimationState(), goe(i, fi), o.animateAll(), o !== r && r.animateAll());
    },
    nulling: function() {
      fi = null;
    }
  }, Si(t, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: fi
      };
    }
  });
}
function goe(t, e) {
  var n = t.parentNode, r = e.parentNode, s, i;
  !n || !r || n.isEqualNode(e) || r.isEqualNode(t) || (s = rr(t), i = rr(e), n.isEqualNode(r) && s < i && i++, n.insertBefore(e, n.children[s]), r.insertBefore(t, r.children[i]));
}
var It = [], Js = [], ld, Ai, cd = !1, Xs = !1, xc = !1, Pn, ud, Cp;
function yoe() {
  function t(e) {
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
    e.options.supportPointer ? Bt(document, "pointerup", this._deselectMultiDrag) : (Bt(document, "mouseup", this._deselectMultiDrag), Bt(document, "touchend", this._deselectMultiDrag)), Bt(document, "keydown", this._checkKeyDown), Bt(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      setData: function(s, i) {
        var o = "";
        It.length && Ai === e ? It.forEach(function(a, l) {
          o += (l ? ", " : "") + a.textContent;
        }) : o = i.textContent, s.setData("Text", o);
      }
    };
  }
  return t.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(n) {
      var r = n.dragEl;
      Pn = r;
    },
    delayEnded: function() {
      this.isMultiDrag = ~It.indexOf(Pn);
    },
    setupClone: function(n) {
      var r = n.sortable, s = n.cancel;
      if (this.isMultiDrag) {
        for (var i = 0; i < It.length; i++)
          Js.push(RS(It[i])), Js[i].sortableIndex = It[i].sortableIndex, Js[i].draggable = !1, Js[i].style["will-change"] = "", Gn(Js[i], this.options.selectedClass, !1), It[i] === Pn && Gn(Js[i], this.options.chosenClass, !1);
        r._hideClone(), s();
      }
    },
    clone: function(n) {
      var r = n.sortable, s = n.rootEl, i = n.dispatchSortableEvent, o = n.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || It.length && Ai === r && (wT(!0, s), i("clone"), o()));
    },
    showClone: function(n) {
      var r = n.cloneNowShown, s = n.rootEl, i = n.cancel;
      this.isMultiDrag && (wT(!1, s), Js.forEach(function(o) {
        Ke(o, "display", "");
      }), r(), Cp = !1, i());
    },
    hideClone: function(n) {
      var r = this;
      n.sortable;
      var s = n.cloneNowHidden, i = n.cancel;
      this.isMultiDrag && (Js.forEach(function(o) {
        Ke(o, "display", "none"), r.options.removeCloneOnHide && o.parentNode && o.parentNode.removeChild(o);
      }), s(), Cp = !0, i());
    },
    dragStartGlobal: function(n) {
      n.sortable, !this.isMultiDrag && Ai && Ai.multiDrag._deselectMultiDrag(), It.forEach(function(r) {
        r.sortableIndex = rr(r);
      }), It = It.sort(function(r, s) {
        return r.sortableIndex - s.sortableIndex;
      }), xc = !0;
    },
    dragStarted: function(n) {
      var r = this, s = n.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (s.captureAnimationState(), this.options.animation)) {
          It.forEach(function(o) {
            o !== Pn && Ke(o, "position", "absolute");
          });
          var i = sr(Pn, !1, !0, !0);
          It.forEach(function(o) {
            o !== Pn && vT(o, i);
          }), Xs = !0, cd = !0;
        }
        s.animateAll(function() {
          Xs = !1, cd = !1, r.options.animation && It.forEach(function(o) {
            vy(o);
          }), r.options.sort && Tp();
        });
      }
    },
    dragOver: function(n) {
      var r = n.target, s = n.completed, i = n.cancel;
      Xs && ~It.indexOf(r) && (s(!1), i());
    },
    revert: function(n) {
      var r = n.fromSortable, s = n.rootEl, i = n.sortable, o = n.dragRect;
      It.length > 1 && (It.forEach(function(a) {
        i.addAnimationState({
          target: a,
          rect: Xs ? sr(a) : o
        }), vy(a), a.fromRect = o, r.removeAnimationState(a);
      }), Xs = !1, boe(!this.options.removeCloneOnHide, s));
    },
    dragOverCompleted: function(n) {
      var r = n.sortable, s = n.isOwner, i = n.insertion, o = n.activeSortable, a = n.parentEl, l = n.putSortable, c = this.options;
      if (i) {
        if (s && o._hideClone(), cd = !1, c.animation && It.length > 1 && (Xs || !s && !o.options.sort && !l)) {
          var u = sr(Pn, !1, !0, !0);
          It.forEach(function(f) {
            f !== Pn && (vT(f, u), a.appendChild(f));
          }), Xs = !0;
        }
        if (!s)
          if (Xs || Tp(), It.length > 1) {
            var d = Cp;
            o._showClone(r), o.options.animation && !Cp && d && Js.forEach(function(f) {
              o.addAnimationState({
                target: f,
                rect: ud
              }), f.fromRect = ud, f.thisAnimationDuration = null;
            });
          } else
            o._showClone(r);
      }
    },
    dragOverAnimationCapture: function(n) {
      var r = n.dragRect, s = n.isOwner, i = n.activeSortable;
      if (It.forEach(function(a) {
        a.thisAnimationDuration = null;
      }), i.options.animation && !s && i.multiDrag.isMultiDrag) {
        ud = Si({}, r);
        var o = jl(Pn, !0);
        ud.top -= o.f, ud.left -= o.e;
      }
    },
    dragOverAnimationComplete: function() {
      Xs && (Xs = !1, Tp());
    },
    drop: function(n) {
      var r = n.originalEvent, s = n.rootEl, i = n.parentEl, o = n.sortable, a = n.dispatchSortableEvent, l = n.oldIndex, c = n.putSortable, u = c || this.sortable;
      if (r) {
        var d = this.options, f = i.children;
        if (!xc)
          if (d.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), Gn(Pn, d.selectedClass, !~It.indexOf(Pn)), ~It.indexOf(Pn))
            It.splice(It.indexOf(Pn), 1), ld = null, xd({
              sortable: o,
              rootEl: s,
              name: "deselect",
              targetEl: Pn,
              originalEvt: r
            });
          else {
            if (It.push(Pn), xd({
              sortable: o,
              rootEl: s,
              name: "select",
              targetEl: Pn,
              originalEvt: r
            }), r.shiftKey && ld && o.el.contains(ld)) {
              var p = rr(ld), h = rr(Pn);
              if (~p && ~h && p !== h) {
                var m, v;
                for (h > p ? (v = p, m = h) : (v = h, m = p + 1); v < m; v++)
                  ~It.indexOf(f[v]) || (Gn(f[v], d.selectedClass, !0), It.push(f[v]), xd({
                    sortable: o,
                    rootEl: s,
                    name: "select",
                    targetEl: f[v],
                    originalEvt: r
                  }));
              }
            } else
              ld = Pn;
            Ai = u;
          }
        if (xc && this.isMultiDrag) {
          if ((i[us].options.sort || i !== s) && It.length > 1) {
            var y = sr(Pn), _ = rr(Pn, ":not(." + this.options.selectedClass + ")");
            if (!cd && d.animation && (Pn.thisAnimationDuration = null), u.captureAnimationState(), !cd && (d.animation && (Pn.fromRect = y, It.forEach(function(S) {
              if (S.thisAnimationDuration = null, S !== Pn) {
                var E = Xs ? sr(S) : y;
                S.fromRect = E, u.addAnimationState({
                  target: S,
                  rect: E
                });
              }
            })), Tp(), It.forEach(function(S) {
              f[_] ? i.insertBefore(S, f[_]) : i.appendChild(S), _++;
            }), l === rr(Pn))) {
              var w = !1;
              It.forEach(function(S) {
                if (S.sortableIndex !== rr(S)) {
                  w = !0;
                  return;
                }
              }), w && a("update");
            }
            It.forEach(function(S) {
              vy(S);
            }), u.animateAll();
          }
          Ai = u;
        }
        (s === i || c && c.lastPutMode !== "clone") && Js.forEach(function(S) {
          S.parentNode && S.parentNode.removeChild(S);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = xc = !1, Js.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), At(document, "pointerup", this._deselectMultiDrag), At(document, "mouseup", this._deselectMultiDrag), At(document, "touchend", this._deselectMultiDrag), At(document, "keydown", this._checkKeyDown), At(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(n) {
      if (!(typeof xc < "u" && xc) && Ai === this.sortable && !(n && Li(n.target, this.options.draggable, this.sortable.el, !1)) && !(n && n.button !== 0))
        for (; It.length; ) {
          var r = It[0];
          Gn(r, this.options.selectedClass, !1), It.shift(), xd({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: r,
            originalEvt: n
          });
        }
    },
    _checkKeyDown: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, Si(t, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(n) {
        var r = n.parentNode[us];
        !r || !r.options.multiDrag || ~It.indexOf(n) || (Ai && Ai !== r && (Ai.multiDrag._deselectMultiDrag(), Ai = r), Gn(n, r.options.selectedClass, !0), It.push(n));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(n) {
        var r = n.parentNode[us], s = It.indexOf(n);
        !r || !r.options.multiDrag || !~s || (Gn(n, r.options.selectedClass, !1), It.splice(s, 1));
      }
    },
    eventProperties: function() {
      var n = this, r = [], s = [];
      return It.forEach(function(i) {
        r.push({
          multiDragElement: i,
          index: i.sortableIndex
        });
        var o;
        Xs && i !== Pn ? o = -1 : Xs ? o = rr(i, ":not(." + n.options.selectedClass + ")") : o = rr(i), s.push({
          multiDragElement: i,
          index: o
        });
      }), {
        items: Uie(It),
        clones: [].concat(Js),
        oldIndicies: r,
        newIndicies: s
      };
    },
    optionListeners: {
      multiDragKey: function(n) {
        return n = n.toLowerCase(), n === "ctrl" ? n = "Control" : n.length > 1 && (n = n.charAt(0).toUpperCase() + n.substr(1)), n;
      }
    }
  });
}
function boe(t, e) {
  It.forEach(function(n, r) {
    var s = e.children[n.sortableIndex + (t ? Number(r) : 0)];
    s ? e.insertBefore(n, s) : e.appendChild(n);
  });
}
function wT(t, e) {
  Js.forEach(function(n, r) {
    var s = e.children[n.sortableIndex + (t ? Number(r) : 0)];
    s ? e.insertBefore(n, s) : e.appendChild(n);
  });
}
function Tp() {
  It.forEach(function(t) {
    t !== Pn && t.parentNode && t.parentNode.removeChild(t);
  });
}
pt.mount(new moe());
pt.mount(FS, LS);
const _oe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: yoe,
  Sortable: pt,
  Swap: voe,
  default: pt
}, Symbol.toStringTag, { value: "Module" })), woe = /* @__PURE__ */ Iw(_oe);
(function(t, e) {
  (function(r, s) {
    t.exports = s(woe);
  })(typeof self < "u" ? self : vr, function(n) {
    return (
      /******/
      function(r) {
        var s = {};
        function i(o) {
          if (s[o])
            return s[o].exports;
          var a = s[o] = {
            /******/
            i: o,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return r[o].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
        }
        return i.m = r, i.c = s, i.d = function(o, a, l) {
          i.o(o, a) || Object.defineProperty(o, a, { enumerable: !0, get: l });
        }, i.r = function(o) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
        }, i.t = function(o, a) {
          if (a & 1 && (o = i(o)), a & 8 || a & 4 && typeof o == "object" && o && o.__esModule) return o;
          var l = /* @__PURE__ */ Object.create(null);
          if (i.r(l), Object.defineProperty(l, "default", { enumerable: !0, value: o }), a & 2 && typeof o != "string") for (var c in o) i.d(l, c, (function(u) {
            return o[u];
          }).bind(null, c));
          return l;
        }, i.n = function(o) {
          var a = o && o.__esModule ? (
            /******/
            function() {
              return o.default;
            }
          ) : (
            /******/
            function() {
              return o;
            }
          );
          return i.d(a, "a", a), a;
        }, i.o = function(o, a) {
          return Object.prototype.hasOwnProperty.call(o, a);
        }, i.p = "", i(i.s = "fb15");
      }({
        /***/
        "01f9": (
          /***/
          function(r, s, i) {
            var o = i("2d00"), a = i("5ca1"), l = i("2aba"), c = i("32e9"), u = i("84f2"), d = i("41a0"), f = i("7f20"), p = i("38fd"), h = i("2b4c")("iterator"), m = !([].keys && "next" in [].keys()), v = "@@iterator", y = "keys", _ = "values", w = function() {
              return this;
            };
            r.exports = function(S, E, x, T, C, k, b) {
              d(x, E, T);
              var P = function(O) {
                if (!m && O in Y) return Y[O];
                switch (O) {
                  case y:
                    return function() {
                      return new x(this, O);
                    };
                  case _:
                    return function() {
                      return new x(this, O);
                    };
                }
                return function() {
                  return new x(this, O);
                };
              }, N = E + " Iterator", D = C == _, H = !1, Y = S.prototype, te = Y[h] || Y[v] || C && Y[C], A = te || P(C), j = C ? D ? P("entries") : A : void 0, L = E == "Array" && Y.entries || te, se, V, ee;
              if (L && (ee = p(L.call(new S())), ee !== Object.prototype && ee.next && (f(ee, N, !0), !o && typeof ee[h] != "function" && c(ee, h, w))), D && te && te.name !== _ && (H = !0, A = function() {
                return te.call(this);
              }), (!o || b) && (m || H || !Y[h]) && c(Y, h, A), u[E] = A, u[N] = w, C)
                if (se = {
                  values: D ? A : P(_),
                  keys: k ? A : P(y),
                  entries: j
                }, b) for (V in se)
                  V in Y || l(Y, V, se[V]);
                else a(a.P + a.F * (m || H), E, se);
              return se;
            };
          }
        ),
        /***/
        "02f4": (
          /***/
          function(r, s, i) {
            var o = i("4588"), a = i("be13");
            r.exports = function(l) {
              return function(c, u) {
                var d = String(a(c)), f = o(u), p = d.length, h, m;
                return f < 0 || f >= p ? l ? "" : void 0 : (h = d.charCodeAt(f), h < 55296 || h > 56319 || f + 1 === p || (m = d.charCodeAt(f + 1)) < 56320 || m > 57343 ? l ? d.charAt(f) : h : l ? d.slice(f, f + 2) : (h - 55296 << 10) + (m - 56320) + 65536);
              };
            };
          }
        ),
        /***/
        "0390": (
          /***/
          function(r, s, i) {
            var o = i("02f4")(!0);
            r.exports = function(a, l, c) {
              return l + (c ? o(a, l).length : 1);
            };
          }
        ),
        /***/
        "0bfb": (
          /***/
          function(r, s, i) {
            var o = i("cb7c");
            r.exports = function() {
              var a = o(this), l = "";
              return a.global && (l += "g"), a.ignoreCase && (l += "i"), a.multiline && (l += "m"), a.unicode && (l += "u"), a.sticky && (l += "y"), l;
            };
          }
        ),
        /***/
        "0d58": (
          /***/
          function(r, s, i) {
            var o = i("ce10"), a = i("e11e");
            r.exports = Object.keys || function(c) {
              return o(c, a);
            };
          }
        ),
        /***/
        1495: (
          /***/
          function(r, s, i) {
            var o = i("86cc"), a = i("cb7c"), l = i("0d58");
            r.exports = i("9e1e") ? Object.defineProperties : function(u, d) {
              a(u);
              for (var f = l(d), p = f.length, h = 0, m; p > h; ) o.f(u, m = f[h++], d[m]);
              return u;
            };
          }
        ),
        /***/
        "214f": (
          /***/
          function(r, s, i) {
            i("b0c5");
            var o = i("2aba"), a = i("32e9"), l = i("79e5"), c = i("be13"), u = i("2b4c"), d = i("520a"), f = u("species"), p = !l(function() {
              var m = /./;
              return m.exec = function() {
                var v = [];
                return v.groups = { a: "7" }, v;
              }, "".replace(m, "$<a>") !== "7";
            }), h = function() {
              var m = /(?:)/, v = m.exec;
              m.exec = function() {
                return v.apply(this, arguments);
              };
              var y = "ab".split(m);
              return y.length === 2 && y[0] === "a" && y[1] === "b";
            }();
            r.exports = function(m, v, y) {
              var _ = u(m), w = !l(function() {
                var k = {};
                return k[_] = function() {
                  return 7;
                }, ""[m](k) != 7;
              }), S = w ? !l(function() {
                var k = !1, b = /a/;
                return b.exec = function() {
                  return k = !0, null;
                }, m === "split" && (b.constructor = {}, b.constructor[f] = function() {
                  return b;
                }), b[_](""), !k;
              }) : void 0;
              if (!w || !S || m === "replace" && !p || m === "split" && !h) {
                var E = /./[_], x = y(
                  c,
                  _,
                  ""[m],
                  function(b, P, N, D, H) {
                    return P.exec === d ? w && !H ? { done: !0, value: E.call(P, N, D) } : { done: !0, value: b.call(N, P, D) } : { done: !1 };
                  }
                ), T = x[0], C = x[1];
                o(String.prototype, m, T), a(
                  RegExp.prototype,
                  _,
                  v == 2 ? function(k, b) {
                    return C.call(k, this, b);
                  } : function(k) {
                    return C.call(k, this);
                  }
                );
              }
            };
          }
        ),
        /***/
        "230e": (
          /***/
          function(r, s, i) {
            var o = i("d3f4"), a = i("7726").document, l = o(a) && o(a.createElement);
            r.exports = function(c) {
              return l ? a.createElement(c) : {};
            };
          }
        ),
        /***/
        "23c6": (
          /***/
          function(r, s, i) {
            var o = i("2d95"), a = i("2b4c")("toStringTag"), l = o(/* @__PURE__ */ function() {
              return arguments;
            }()) == "Arguments", c = function(u, d) {
              try {
                return u[d];
              } catch {
              }
            };
            r.exports = function(u) {
              var d, f, p;
              return u === void 0 ? "Undefined" : u === null ? "Null" : typeof (f = c(d = Object(u), a)) == "string" ? f : l ? o(d) : (p = o(d)) == "Object" && typeof d.callee == "function" ? "Arguments" : p;
            };
          }
        ),
        /***/
        2621: (
          /***/
          function(r, s) {
            s.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "2aba": (
          /***/
          function(r, s, i) {
            var o = i("7726"), a = i("32e9"), l = i("69a8"), c = i("ca5a")("src"), u = i("fa5b"), d = "toString", f = ("" + u).split(d);
            i("8378").inspectSource = function(p) {
              return u.call(p);
            }, (r.exports = function(p, h, m, v) {
              var y = typeof m == "function";
              y && (l(m, "name") || a(m, "name", h)), p[h] !== m && (y && (l(m, c) || a(m, c, p[h] ? "" + p[h] : f.join(String(h)))), p === o ? p[h] = m : v ? p[h] ? p[h] = m : a(p, h, m) : (delete p[h], a(p, h, m)));
            })(Function.prototype, d, function() {
              return typeof this == "function" && this[c] || u.call(this);
            });
          }
        ),
        /***/
        "2aeb": (
          /***/
          function(r, s, i) {
            var o = i("cb7c"), a = i("1495"), l = i("e11e"), c = i("613b")("IE_PROTO"), u = function() {
            }, d = "prototype", f = function() {
              var p = i("230e")("iframe"), h = l.length, m = "<", v = ">", y;
              for (p.style.display = "none", i("fab2").appendChild(p), p.src = "javascript:", y = p.contentWindow.document, y.open(), y.write(m + "script" + v + "document.F=Object" + m + "/script" + v), y.close(), f = y.F; h--; ) delete f[d][l[h]];
              return f();
            };
            r.exports = Object.create || function(h, m) {
              var v;
              return h !== null ? (u[d] = o(h), v = new u(), u[d] = null, v[c] = h) : v = f(), m === void 0 ? v : a(v, m);
            };
          }
        ),
        /***/
        "2b4c": (
          /***/
          function(r, s, i) {
            var o = i("5537")("wks"), a = i("ca5a"), l = i("7726").Symbol, c = typeof l == "function", u = r.exports = function(d) {
              return o[d] || (o[d] = c && l[d] || (c ? l : a)("Symbol." + d));
            };
            u.store = o;
          }
        ),
        /***/
        "2d00": (
          /***/
          function(r, s) {
            r.exports = !1;
          }
        ),
        /***/
        "2d95": (
          /***/
          function(r, s) {
            var i = {}.toString;
            r.exports = function(o) {
              return i.call(o).slice(8, -1);
            };
          }
        ),
        /***/
        "2fdb": (
          /***/
          function(r, s, i) {
            var o = i("5ca1"), a = i("d2c8"), l = "includes";
            o(o.P + o.F * i("5147")(l), "String", {
              includes: function(u) {
                return !!~a(this, u, l).indexOf(u, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "32e9": (
          /***/
          function(r, s, i) {
            var o = i("86cc"), a = i("4630");
            r.exports = i("9e1e") ? function(l, c, u) {
              return o.f(l, c, a(1, u));
            } : function(l, c, u) {
              return l[c] = u, l;
            };
          }
        ),
        /***/
        "38fd": (
          /***/
          function(r, s, i) {
            var o = i("69a8"), a = i("4bf8"), l = i("613b")("IE_PROTO"), c = Object.prototype;
            r.exports = Object.getPrototypeOf || function(u) {
              return u = a(u), o(u, l) ? u[l] : typeof u.constructor == "function" && u instanceof u.constructor ? u.constructor.prototype : u instanceof Object ? c : null;
            };
          }
        ),
        /***/
        "41a0": (
          /***/
          function(r, s, i) {
            var o = i("2aeb"), a = i("4630"), l = i("7f20"), c = {};
            i("32e9")(c, i("2b4c")("iterator"), function() {
              return this;
            }), r.exports = function(u, d, f) {
              u.prototype = o(c, { next: a(1, f) }), l(u, d + " Iterator");
            };
          }
        ),
        /***/
        "456d": (
          /***/
          function(r, s, i) {
            var o = i("4bf8"), a = i("0d58");
            i("5eda")("keys", function() {
              return function(c) {
                return a(o(c));
              };
            });
          }
        ),
        /***/
        4588: (
          /***/
          function(r, s) {
            var i = Math.ceil, o = Math.floor;
            r.exports = function(a) {
              return isNaN(a = +a) ? 0 : (a > 0 ? o : i)(a);
            };
          }
        ),
        /***/
        4630: (
          /***/
          function(r, s) {
            r.exports = function(i, o) {
              return {
                enumerable: !(i & 1),
                configurable: !(i & 2),
                writable: !(i & 4),
                value: o
              };
            };
          }
        ),
        /***/
        "4bf8": (
          /***/
          function(r, s, i) {
            var o = i("be13");
            r.exports = function(a) {
              return Object(o(a));
            };
          }
        ),
        /***/
        5147: (
          /***/
          function(r, s, i) {
            var o = i("2b4c")("match");
            r.exports = function(a) {
              var l = /./;
              try {
                "/./"[a](l);
              } catch {
                try {
                  return l[o] = !1, !"/./"[a](l);
                } catch {
                }
              }
              return !0;
            };
          }
        ),
        /***/
        "520a": (
          /***/
          function(r, s, i) {
            var o = i("0bfb"), a = RegExp.prototype.exec, l = String.prototype.replace, c = a, u = "lastIndex", d = function() {
              var h = /a/, m = /b*/g;
              return a.call(h, "a"), a.call(m, "a"), h[u] !== 0 || m[u] !== 0;
            }(), f = /()??/.exec("")[1] !== void 0, p = d || f;
            p && (c = function(m) {
              var v = this, y, _, w, S;
              return f && (_ = new RegExp("^" + v.source + "$(?!\\s)", o.call(v))), d && (y = v[u]), w = a.call(v, m), d && w && (v[u] = v.global ? w.index + w[0].length : y), f && w && w.length > 1 && l.call(w[0], _, function() {
                for (S = 1; S < arguments.length - 2; S++)
                  arguments[S] === void 0 && (w[S] = void 0);
              }), w;
            }), r.exports = c;
          }
        ),
        /***/
        "52a7": (
          /***/
          function(r, s) {
            s.f = {}.propertyIsEnumerable;
          }
        ),
        /***/
        5537: (
          /***/
          function(r, s, i) {
            var o = i("8378"), a = i("7726"), l = "__core-js_shared__", c = a[l] || (a[l] = {});
            (r.exports = function(u, d) {
              return c[u] || (c[u] = d !== void 0 ? d : {});
            })("versions", []).push({
              version: o.version,
              mode: i("2d00") ? "pure" : "global",
              copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "5ca1": (
          /***/
          function(r, s, i) {
            var o = i("7726"), a = i("8378"), l = i("32e9"), c = i("2aba"), u = i("9b43"), d = "prototype", f = function(p, h, m) {
              var v = p & f.F, y = p & f.G, _ = p & f.S, w = p & f.P, S = p & f.B, E = y ? o : _ ? o[h] || (o[h] = {}) : (o[h] || {})[d], x = y ? a : a[h] || (a[h] = {}), T = x[d] || (x[d] = {}), C, k, b, P;
              y && (m = h);
              for (C in m)
                k = !v && E && E[C] !== void 0, b = (k ? E : m)[C], P = S && k ? u(b, o) : w && typeof b == "function" ? u(Function.call, b) : b, E && c(E, C, b, p & f.U), x[C] != b && l(x, C, P), w && T[C] != b && (T[C] = b);
            };
            o.core = a, f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, r.exports = f;
          }
        ),
        /***/
        "5eda": (
          /***/
          function(r, s, i) {
            var o = i("5ca1"), a = i("8378"), l = i("79e5");
            r.exports = function(c, u) {
              var d = (a.Object || {})[c] || Object[c], f = {};
              f[c] = u(d), o(o.S + o.F * l(function() {
                d(1);
              }), "Object", f);
            };
          }
        ),
        /***/
        "5f1b": (
          /***/
          function(r, s, i) {
            var o = i("23c6"), a = RegExp.prototype.exec;
            r.exports = function(l, c) {
              var u = l.exec;
              if (typeof u == "function") {
                var d = u.call(l, c);
                if (typeof d != "object")
                  throw new TypeError("RegExp exec method returned something other than an Object or null");
                return d;
              }
              if (o(l) !== "RegExp")
                throw new TypeError("RegExp#exec called on incompatible receiver");
              return a.call(l, c);
            };
          }
        ),
        /***/
        "613b": (
          /***/
          function(r, s, i) {
            var o = i("5537")("keys"), a = i("ca5a");
            r.exports = function(l) {
              return o[l] || (o[l] = a(l));
            };
          }
        ),
        /***/
        "626a": (
          /***/
          function(r, s, i) {
            var o = i("2d95");
            r.exports = Object("z").propertyIsEnumerable(0) ? Object : function(a) {
              return o(a) == "String" ? a.split("") : Object(a);
            };
          }
        ),
        /***/
        6762: (
          /***/
          function(r, s, i) {
            var o = i("5ca1"), a = i("c366")(!0);
            o(o.P, "Array", {
              includes: function(c) {
                return a(this, c, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), i("9c6c")("includes");
          }
        ),
        /***/
        6821: (
          /***/
          function(r, s, i) {
            var o = i("626a"), a = i("be13");
            r.exports = function(l) {
              return o(a(l));
            };
          }
        ),
        /***/
        "69a8": (
          /***/
          function(r, s) {
            var i = {}.hasOwnProperty;
            r.exports = function(o, a) {
              return i.call(o, a);
            };
          }
        ),
        /***/
        "6a99": (
          /***/
          function(r, s, i) {
            var o = i("d3f4");
            r.exports = function(a, l) {
              if (!o(a)) return a;
              var c, u;
              if (l && typeof (c = a.toString) == "function" && !o(u = c.call(a)) || typeof (c = a.valueOf) == "function" && !o(u = c.call(a)) || !l && typeof (c = a.toString) == "function" && !o(u = c.call(a))) return u;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        7333: (
          /***/
          function(r, s, i) {
            var o = i("0d58"), a = i("2621"), l = i("52a7"), c = i("4bf8"), u = i("626a"), d = Object.assign;
            r.exports = !d || i("79e5")(function() {
              var f = {}, p = {}, h = Symbol(), m = "abcdefghijklmnopqrst";
              return f[h] = 7, m.split("").forEach(function(v) {
                p[v] = v;
              }), d({}, f)[h] != 7 || Object.keys(d({}, p)).join("") != m;
            }) ? function(p, h) {
              for (var m = c(p), v = arguments.length, y = 1, _ = a.f, w = l.f; v > y; )
                for (var S = u(arguments[y++]), E = _ ? o(S).concat(_(S)) : o(S), x = E.length, T = 0, C; x > T; ) w.call(S, C = E[T++]) && (m[C] = S[C]);
              return m;
            } : d;
          }
        ),
        /***/
        7726: (
          /***/
          function(r, s) {
            var i = r.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
            typeof __g == "number" && (__g = i);
          }
        ),
        /***/
        "77f1": (
          /***/
          function(r, s, i) {
            var o = i("4588"), a = Math.max, l = Math.min;
            r.exports = function(c, u) {
              return c = o(c), c < 0 ? a(c + u, 0) : l(c, u);
            };
          }
        ),
        /***/
        "79e5": (
          /***/
          function(r, s) {
            r.exports = function(i) {
              try {
                return !!i();
              } catch {
                return !0;
              }
            };
          }
        ),
        /***/
        "7f20": (
          /***/
          function(r, s, i) {
            var o = i("86cc").f, a = i("69a8"), l = i("2b4c")("toStringTag");
            r.exports = function(c, u, d) {
              c && !a(c = d ? c : c.prototype, l) && o(c, l, { configurable: !0, value: u });
            };
          }
        ),
        /***/
        8378: (
          /***/
          function(r, s) {
            var i = r.exports = { version: "2.6.5" };
            typeof __e == "number" && (__e = i);
          }
        ),
        /***/
        "84f2": (
          /***/
          function(r, s) {
            r.exports = {};
          }
        ),
        /***/
        "86cc": (
          /***/
          function(r, s, i) {
            var o = i("cb7c"), a = i("c69a"), l = i("6a99"), c = Object.defineProperty;
            s.f = i("9e1e") ? Object.defineProperty : function(d, f, p) {
              if (o(d), f = l(f, !0), o(p), a) try {
                return c(d, f, p);
              } catch {
              }
              if ("get" in p || "set" in p) throw TypeError("Accessors not supported!");
              return "value" in p && (d[f] = p.value), d;
            };
          }
        ),
        /***/
        "9b43": (
          /***/
          function(r, s, i) {
            var o = i("d8e8");
            r.exports = function(a, l, c) {
              if (o(a), l === void 0) return a;
              switch (c) {
                case 1:
                  return function(u) {
                    return a.call(l, u);
                  };
                case 2:
                  return function(u, d) {
                    return a.call(l, u, d);
                  };
                case 3:
                  return function(u, d, f) {
                    return a.call(l, u, d, f);
                  };
              }
              return function() {
                return a.apply(l, arguments);
              };
            };
          }
        ),
        /***/
        "9c6c": (
          /***/
          function(r, s, i) {
            var o = i("2b4c")("unscopables"), a = Array.prototype;
            a[o] == null && i("32e9")(a, o, {}), r.exports = function(l) {
              a[o][l] = !0;
            };
          }
        ),
        /***/
        "9def": (
          /***/
          function(r, s, i) {
            var o = i("4588"), a = Math.min;
            r.exports = function(l) {
              return l > 0 ? a(o(l), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        "9e1e": (
          /***/
          function(r, s, i) {
            r.exports = !i("79e5")(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        a352: (
          /***/
          function(r, s) {
            r.exports = n;
          }
        ),
        /***/
        a481: (
          /***/
          function(r, s, i) {
            var o = i("cb7c"), a = i("4bf8"), l = i("9def"), c = i("4588"), u = i("0390"), d = i("5f1b"), f = Math.max, p = Math.min, h = Math.floor, m = /\$([$&`']|\d\d?|<[^>]*>)/g, v = /\$([$&`']|\d\d?)/g, y = function(_) {
              return _ === void 0 ? _ : String(_);
            };
            i("214f")("replace", 2, function(_, w, S, E) {
              return [
                // `String.prototype.replace` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                function(C, k) {
                  var b = _(this), P = C == null ? void 0 : C[w];
                  return P !== void 0 ? P.call(C, b, k) : S.call(String(b), C, k);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                function(T, C) {
                  var k = E(S, T, this, C);
                  if (k.done) return k.value;
                  var b = o(T), P = String(this), N = typeof C == "function";
                  N || (C = String(C));
                  var D = b.global;
                  if (D) {
                    var H = b.unicode;
                    b.lastIndex = 0;
                  }
                  for (var Y = []; ; ) {
                    var te = d(b, P);
                    if (te === null || (Y.push(te), !D)) break;
                    var A = String(te[0]);
                    A === "" && (b.lastIndex = u(P, l(b.lastIndex), H));
                  }
                  for (var j = "", L = 0, se = 0; se < Y.length; se++) {
                    te = Y[se];
                    for (var V = String(te[0]), ee = f(p(c(te.index), P.length), 0), O = [], K = 1; K < te.length; K++) O.push(y(te[K]));
                    var z = te.groups;
                    if (N) {
                      var q = [V].concat(O, ee, P);
                      z !== void 0 && q.push(z);
                      var ae = String(C.apply(void 0, q));
                    } else
                      ae = x(V, P, ee, O, z, C);
                    ee >= L && (j += P.slice(L, ee) + ae, L = ee + V.length);
                  }
                  return j + P.slice(L);
                }
              ];
              function x(T, C, k, b, P, N) {
                var D = k + T.length, H = b.length, Y = v;
                return P !== void 0 && (P = a(P), Y = m), S.call(N, Y, function(te, A) {
                  var j;
                  switch (A.charAt(0)) {
                    case "$":
                      return "$";
                    case "&":
                      return T;
                    case "`":
                      return C.slice(0, k);
                    case "'":
                      return C.slice(D);
                    case "<":
                      j = P[A.slice(1, -1)];
                      break;
                    default:
                      var L = +A;
                      if (L === 0) return te;
                      if (L > H) {
                        var se = h(L / 10);
                        return se === 0 ? te : se <= H ? b[se - 1] === void 0 ? A.charAt(1) : b[se - 1] + A.charAt(1) : te;
                      }
                      j = b[L - 1];
                  }
                  return j === void 0 ? "" : j;
                });
              }
            });
          }
        ),
        /***/
        aae3: (
          /***/
          function(r, s, i) {
            var o = i("d3f4"), a = i("2d95"), l = i("2b4c")("match");
            r.exports = function(c) {
              var u;
              return o(c) && ((u = c[l]) !== void 0 ? !!u : a(c) == "RegExp");
            };
          }
        ),
        /***/
        ac6a: (
          /***/
          function(r, s, i) {
            for (var o = i("cadf"), a = i("0d58"), l = i("2aba"), c = i("7726"), u = i("32e9"), d = i("84f2"), f = i("2b4c"), p = f("iterator"), h = f("toStringTag"), m = d.Array, v = {
              CSSRuleList: !0,
              // TODO: Not spec compliant, should be false.
              CSSStyleDeclaration: !1,
              CSSValueList: !1,
              ClientRectList: !1,
              DOMRectList: !1,
              DOMStringList: !1,
              DOMTokenList: !0,
              DataTransferItemList: !1,
              FileList: !1,
              HTMLAllCollection: !1,
              HTMLCollection: !1,
              HTMLFormElement: !1,
              HTMLSelectElement: !1,
              MediaList: !0,
              // TODO: Not spec compliant, should be false.
              MimeTypeArray: !1,
              NamedNodeMap: !1,
              NodeList: !0,
              PaintRequestList: !1,
              Plugin: !1,
              PluginArray: !1,
              SVGLengthList: !1,
              SVGNumberList: !1,
              SVGPathSegList: !1,
              SVGPointList: !1,
              SVGStringList: !1,
              SVGTransformList: !1,
              SourceBufferList: !1,
              StyleSheetList: !0,
              // TODO: Not spec compliant, should be false.
              TextTrackCueList: !1,
              TextTrackList: !1,
              TouchList: !1
            }, y = a(v), _ = 0; _ < y.length; _++) {
              var w = y[_], S = v[w], E = c[w], x = E && E.prototype, T;
              if (x && (x[p] || u(x, p, m), x[h] || u(x, h, w), d[w] = m, S))
                for (T in o) x[T] || l(x, T, o[T], !0);
            }
          }
        ),
        /***/
        b0c5: (
          /***/
          function(r, s, i) {
            var o = i("520a");
            i("5ca1")({
              target: "RegExp",
              proto: !0,
              forced: o !== /./.exec
            }, {
              exec: o
            });
          }
        ),
        /***/
        be13: (
          /***/
          function(r, s) {
            r.exports = function(i) {
              if (i == null) throw TypeError("Can't call method on  " + i);
              return i;
            };
          }
        ),
        /***/
        c366: (
          /***/
          function(r, s, i) {
            var o = i("6821"), a = i("9def"), l = i("77f1");
            r.exports = function(c) {
              return function(u, d, f) {
                var p = o(u), h = a(p.length), m = l(f, h), v;
                if (c && d != d) {
                  for (; h > m; )
                    if (v = p[m++], v != v) return !0;
                } else for (; h > m; m++) if ((c || m in p) && p[m] === d)
                  return c || m || 0;
                return !c && -1;
              };
            };
          }
        ),
        /***/
        c649: (
          /***/
          function(r, s, i) {
            (function(o) {
              i.d(s, "c", function() {
                return p;
              }), i.d(s, "a", function() {
                return d;
              }), i.d(s, "b", function() {
                return l;
              }), i.d(s, "d", function() {
                return f;
              }), i("a481");
              function a() {
                return typeof window < "u" ? window.console : o.console;
              }
              var l = a();
              function c(h) {
                var m = /* @__PURE__ */ Object.create(null);
                return function(y) {
                  var _ = m[y];
                  return _ || (m[y] = h(y));
                };
              }
              var u = /-(\w)/g, d = c(function(h) {
                return h.replace(u, function(m, v) {
                  return v ? v.toUpperCase() : "";
                });
              });
              function f(h) {
                h.parentElement !== null && h.parentElement.removeChild(h);
              }
              function p(h, m, v) {
                var y = v === 0 ? h.children[0] : h.children[v - 1].nextSibling;
                h.insertBefore(m, y);
              }
            }).call(this, i("c8ba"));
          }
        ),
        /***/
        c69a: (
          /***/
          function(r, s, i) {
            r.exports = !i("9e1e") && !i("79e5")(function() {
              return Object.defineProperty(i("230e")("div"), "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        c8ba: (
          /***/
          function(r, s) {
            var i;
            i = /* @__PURE__ */ function() {
              return this;
            }();
            try {
              i = i || new Function("return this")();
            } catch {
              typeof window == "object" && (i = window);
            }
            r.exports = i;
          }
        ),
        /***/
        ca5a: (
          /***/
          function(r, s) {
            var i = 0, o = Math.random();
            r.exports = function(a) {
              return "Symbol(".concat(a === void 0 ? "" : a, ")_", (++i + o).toString(36));
            };
          }
        ),
        /***/
        cadf: (
          /***/
          function(r, s, i) {
            var o = i("9c6c"), a = i("d53b"), l = i("84f2"), c = i("6821");
            r.exports = i("01f9")(Array, "Array", function(u, d) {
              this._t = c(u), this._i = 0, this._k = d;
            }, function() {
              var u = this._t, d = this._k, f = this._i++;
              return !u || f >= u.length ? (this._t = void 0, a(1)) : d == "keys" ? a(0, f) : d == "values" ? a(0, u[f]) : a(0, [f, u[f]]);
            }, "values"), l.Arguments = l.Array, o("keys"), o("values"), o("entries");
          }
        ),
        /***/
        cb7c: (
          /***/
          function(r, s, i) {
            var o = i("d3f4");
            r.exports = function(a) {
              if (!o(a)) throw TypeError(a + " is not an object!");
              return a;
            };
          }
        ),
        /***/
        ce10: (
          /***/
          function(r, s, i) {
            var o = i("69a8"), a = i("6821"), l = i("c366")(!1), c = i("613b")("IE_PROTO");
            r.exports = function(u, d) {
              var f = a(u), p = 0, h = [], m;
              for (m in f) m != c && o(f, m) && h.push(m);
              for (; d.length > p; ) o(f, m = d[p++]) && (~l(h, m) || h.push(m));
              return h;
            };
          }
        ),
        /***/
        d2c8: (
          /***/
          function(r, s, i) {
            var o = i("aae3"), a = i("be13");
            r.exports = function(l, c, u) {
              if (o(c)) throw TypeError("String#" + u + " doesn't accept regex!");
              return String(a(l));
            };
          }
        ),
        /***/
        d3f4: (
          /***/
          function(r, s) {
            r.exports = function(i) {
              return typeof i == "object" ? i !== null : typeof i == "function";
            };
          }
        ),
        /***/
        d53b: (
          /***/
          function(r, s) {
            r.exports = function(i, o) {
              return { value: o, done: !!i };
            };
          }
        ),
        /***/
        d8e8: (
          /***/
          function(r, s) {
            r.exports = function(i) {
              if (typeof i != "function") throw TypeError(i + " is not a function!");
              return i;
            };
          }
        ),
        /***/
        e11e: (
          /***/
          function(r, s) {
            r.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
          }
        ),
        /***/
        f559: (
          /***/
          function(r, s, i) {
            var o = i("5ca1"), a = i("9def"), l = i("d2c8"), c = "startsWith", u = ""[c];
            o(o.P + o.F * i("5147")(c), "String", {
              startsWith: function(f) {
                var p = l(this, f, c), h = a(Math.min(arguments.length > 1 ? arguments[1] : void 0, p.length)), m = String(f);
                return u ? u.call(p, m, h) : p.slice(h, h + m.length) === m;
              }
            });
          }
        ),
        /***/
        f6fd: (
          /***/
          function(r, s) {
            (function(i) {
              var o = "currentScript", a = i.getElementsByTagName("script");
              o in i || Object.defineProperty(i, o, {
                get: function() {
                  try {
                    throw new Error();
                  } catch (u) {
                    var l, c = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(u.stack) || [!1])[1];
                    for (l in a)
                      if (a[l].src == c || a[l].readyState == "interactive")
                        return a[l];
                    return null;
                  }
                }
              });
            })(document);
          }
        ),
        /***/
        f751: (
          /***/
          function(r, s, i) {
            var o = i("5ca1");
            o(o.S + o.F, "Object", { assign: i("7333") });
          }
        ),
        /***/
        fa5b: (
          /***/
          function(r, s, i) {
            r.exports = i("5537")("native-function-to-string", Function.toString);
          }
        ),
        /***/
        fab2: (
          /***/
          function(r, s, i) {
            var o = i("7726").document;
            r.exports = o && o.documentElement;
          }
        ),
        /***/
        fb15: (
          /***/
          function(r, s, i) {
            if (i.r(s), typeof window < "u") {
              i("f6fd");
              var o;
              (o = window.document.currentScript) && (o = o.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) && (i.p = o[1]);
            }
            i("f751"), i("f559"), i("ac6a"), i("cadf"), i("456d");
            function a(V) {
              if (Array.isArray(V)) return V;
            }
            function l(V, ee) {
              if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(V)))) {
                var O = [], K = !0, z = !1, q = void 0;
                try {
                  for (var ae = V[Symbol.iterator](), Ee; !(K = (Ee = ae.next()).done) && (O.push(Ee.value), !(ee && O.length === ee)); K = !0)
                    ;
                } catch (Ae) {
                  z = !0, q = Ae;
                } finally {
                  try {
                    !K && ae.return != null && ae.return();
                  } finally {
                    if (z) throw q;
                  }
                }
                return O;
              }
            }
            function c(V, ee) {
              (ee == null || ee > V.length) && (ee = V.length);
              for (var O = 0, K = new Array(ee); O < ee; O++)
                K[O] = V[O];
              return K;
            }
            function u(V, ee) {
              if (V) {
                if (typeof V == "string") return c(V, ee);
                var O = Object.prototype.toString.call(V).slice(8, -1);
                if (O === "Object" && V.constructor && (O = V.constructor.name), O === "Map" || O === "Set") return Array.from(V);
                if (O === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(O)) return c(V, ee);
              }
            }
            function d() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function f(V, ee) {
              return a(V) || l(V, ee) || u(V, ee) || d();
            }
            i("6762"), i("2fdb");
            function p(V) {
              if (Array.isArray(V)) return c(V);
            }
            function h(V) {
              if (typeof Symbol < "u" && Symbol.iterator in Object(V)) return Array.from(V);
            }
            function m() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function v(V) {
              return p(V) || h(V) || u(V) || m();
            }
            var y = i("a352"), _ = /* @__PURE__ */ i.n(y), w = i("c649");
            function S(V, ee, O) {
              return O === void 0 || (V = V || {}, V[ee] = O), V;
            }
            function E(V, ee) {
              return V.map(function(O) {
                return O.elm;
              }).indexOf(ee);
            }
            function x(V, ee, O, K) {
              if (!V)
                return [];
              var z = V.map(function(Ee) {
                return Ee.elm;
              }), q = ee.length - K, ae = v(ee).map(function(Ee, Ae) {
                return Ae >= q ? z.length : z.indexOf(Ee);
              });
              return O ? ae.filter(function(Ee) {
                return Ee !== -1;
              }) : ae;
            }
            function T(V, ee) {
              var O = this;
              this.$nextTick(function() {
                return O.$emit(V.toLowerCase(), ee);
              });
            }
            function C(V) {
              var ee = this;
              return function(O) {
                ee.realList !== null && ee["onDrag" + V](O), T.call(ee, V, O);
              };
            }
            function k(V) {
              return ["transition-group", "TransitionGroup"].includes(V);
            }
            function b(V) {
              if (!V || V.length !== 1)
                return !1;
              var ee = f(V, 1), O = ee[0].componentOptions;
              return O ? k(O.tag) : !1;
            }
            function P(V, ee, O) {
              return V[O] || (ee[O] ? ee[O]() : void 0);
            }
            function N(V, ee, O) {
              var K = 0, z = 0, q = P(ee, O, "header");
              q && (K = q.length, V = V ? [].concat(v(q), v(V)) : v(q));
              var ae = P(ee, O, "footer");
              return ae && (z = ae.length, V = V ? [].concat(v(V), v(ae)) : v(ae)), {
                children: V,
                headerOffset: K,
                footerOffset: z
              };
            }
            function D(V, ee) {
              var O = null, K = function(Ue, qe) {
                O = S(O, Ue, qe);
              }, z = Object.keys(V).filter(function(Ae) {
                return Ae === "id" || Ae.startsWith("data-");
              }).reduce(function(Ae, Ue) {
                return Ae[Ue] = V[Ue], Ae;
              }, {});
              if (K("attrs", z), !ee)
                return O;
              var q = ee.on, ae = ee.props, Ee = ee.attrs;
              return K("on", q), K("props", ae), Object.assign(O.attrs, Ee), O;
            }
            var H = ["Start", "Add", "Remove", "Update", "End"], Y = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], te = ["Move"].concat(H, Y).map(function(V) {
              return "on" + V;
            }), A = null, j = {
              options: Object,
              list: {
                type: Array,
                required: !1,
                default: null
              },
              value: {
                type: Array,
                required: !1,
                default: null
              },
              noTransitionOnDrag: {
                type: Boolean,
                default: !1
              },
              clone: {
                type: Function,
                default: function(ee) {
                  return ee;
                }
              },
              element: {
                type: String,
                default: "div"
              },
              tag: {
                type: String,
                default: null
              },
              move: {
                type: Function,
                default: null
              },
              componentData: {
                type: Object,
                required: !1,
                default: null
              }
            }, L = {
              name: "draggable",
              inheritAttrs: !1,
              props: j,
              data: function() {
                return {
                  transitionMode: !1,
                  noneFunctionalComponentMode: !1
                };
              },
              render: function(ee) {
                var O = this.$slots.default;
                this.transitionMode = b(O);
                var K = N(O, this.$slots, this.$scopedSlots), z = K.children, q = K.headerOffset, ae = K.footerOffset;
                this.headerOffset = q, this.footerOffset = ae;
                var Ee = D(this.$attrs, this.componentData);
                return ee(this.getTag(), Ee, z);
              },
              created: function() {
                this.list !== null && this.value !== null && w.b.error("Value and list props are mutually exclusive! Please set one or another."), this.element !== "div" && w.b.warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props"), this.options !== void 0 && w.b.warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
              },
              mounted: function() {
                var ee = this;
                if (this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional(), this.noneFunctionalComponentMode && this.transitionMode)
                  throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
                var O = {};
                H.forEach(function(q) {
                  O["on" + q] = C.call(ee, q);
                }), Y.forEach(function(q) {
                  O["on" + q] = T.bind(ee, q);
                });
                var K = Object.keys(this.$attrs).reduce(function(q, ae) {
                  return q[Object(w.a)(ae)] = ee.$attrs[ae], q;
                }, {}), z = Object.assign({}, this.options, K, O, {
                  onMove: function(ae, Ee) {
                    return ee.onDragMove(ae, Ee);
                  }
                });
                !("draggable" in z) && (z.draggable = ">*"), this._sortable = new _.a(this.rootContainer, z), this.computeIndexes();
              },
              beforeDestroy: function() {
                this._sortable !== void 0 && this._sortable.destroy();
              },
              computed: {
                rootContainer: function() {
                  return this.transitionMode ? this.$el.children[0] : this.$el;
                },
                realList: function() {
                  return this.list ? this.list : this.value;
                }
              },
              watch: {
                options: {
                  handler: function(ee) {
                    this.updateOptions(ee);
                  },
                  deep: !0
                },
                $attrs: {
                  handler: function(ee) {
                    this.updateOptions(ee);
                  },
                  deep: !0
                },
                realList: function() {
                  this.computeIndexes();
                }
              },
              methods: {
                getIsFunctional: function() {
                  var ee = this._vnode.fnOptions;
                  return ee && ee.functional;
                },
                getTag: function() {
                  return this.tag || this.element;
                },
                updateOptions: function(ee) {
                  for (var O in ee) {
                    var K = Object(w.a)(O);
                    te.indexOf(K) === -1 && this._sortable.option(K, ee[O]);
                  }
                },
                getChildrenNodes: function() {
                  if (this.noneFunctionalComponentMode)
                    return this.$children[0].$slots.default;
                  var ee = this.$slots.default;
                  return this.transitionMode ? ee[0].child.$slots.default : ee;
                },
                computeIndexes: function() {
                  var ee = this;
                  this.$nextTick(function() {
                    ee.visibleIndexes = x(ee.getChildrenNodes(), ee.rootContainer.children, ee.transitionMode, ee.footerOffset);
                  });
                },
                getUnderlyingVm: function(ee) {
                  var O = E(this.getChildrenNodes() || [], ee);
                  if (O === -1)
                    return null;
                  var K = this.realList[O];
                  return {
                    index: O,
                    element: K
                  };
                },
                getUnderlyingPotencialDraggableComponent: function(ee) {
                  var O = ee.__vue__;
                  return !O || !O.$options || !k(O.$options._componentTag) ? !("realList" in O) && O.$children.length === 1 && "realList" in O.$children[0] ? O.$children[0] : O : O.$parent;
                },
                emitChanges: function(ee) {
                  var O = this;
                  this.$nextTick(function() {
                    O.$emit("change", ee);
                  });
                },
                alterList: function(ee) {
                  if (this.list) {
                    ee(this.list);
                    return;
                  }
                  var O = v(this.value);
                  ee(O), this.$emit("input", O);
                },
                spliceList: function() {
                  var ee = arguments, O = function(z) {
                    return z.splice.apply(z, v(ee));
                  };
                  this.alterList(O);
                },
                updatePosition: function(ee, O) {
                  var K = function(q) {
                    return q.splice(O, 0, q.splice(ee, 1)[0]);
                  };
                  this.alterList(K);
                },
                getRelatedContextFromMoveEvent: function(ee) {
                  var O = ee.to, K = ee.related, z = this.getUnderlyingPotencialDraggableComponent(O);
                  if (!z)
                    return {
                      component: z
                    };
                  var q = z.realList, ae = {
                    list: q,
                    component: z
                  };
                  if (O !== K && q && z.getUnderlyingVm) {
                    var Ee = z.getUnderlyingVm(K);
                    if (Ee)
                      return Object.assign(Ee, ae);
                  }
                  return ae;
                },
                getVmIndex: function(ee) {
                  var O = this.visibleIndexes, K = O.length;
                  return ee > K - 1 ? K : O[ee];
                },
                getComponent: function() {
                  return this.$slots.default[0].componentInstance;
                },
                resetTransitionData: function(ee) {
                  if (!(!this.noTransitionOnDrag || !this.transitionMode)) {
                    var O = this.getChildrenNodes();
                    O[ee].data = null;
                    var K = this.getComponent();
                    K.children = [], K.kept = void 0;
                  }
                },
                onDragStart: function(ee) {
                  this.context = this.getUnderlyingVm(ee.item), ee.item._underlying_vm_ = this.clone(this.context.element), A = ee.item;
                },
                onDragAdd: function(ee) {
                  var O = ee.item._underlying_vm_;
                  if (O !== void 0) {
                    Object(w.d)(ee.item);
                    var K = this.getVmIndex(ee.newIndex);
                    this.spliceList(K, 0, O), this.computeIndexes();
                    var z = {
                      element: O,
                      newIndex: K
                    };
                    this.emitChanges({
                      added: z
                    });
                  }
                },
                onDragRemove: function(ee) {
                  if (Object(w.c)(this.rootContainer, ee.item, ee.oldIndex), ee.pullMode === "clone") {
                    Object(w.d)(ee.clone);
                    return;
                  }
                  var O = this.context.index;
                  this.spliceList(O, 1);
                  var K = {
                    element: this.context.element,
                    oldIndex: O
                  };
                  this.resetTransitionData(O), this.emitChanges({
                    removed: K
                  });
                },
                onDragUpdate: function(ee) {
                  Object(w.d)(ee.item), Object(w.c)(ee.from, ee.item, ee.oldIndex);
                  var O = this.context.index, K = this.getVmIndex(ee.newIndex);
                  this.updatePosition(O, K);
                  var z = {
                    element: this.context.element,
                    oldIndex: O,
                    newIndex: K
                  };
                  this.emitChanges({
                    moved: z
                  });
                },
                updateProperty: function(ee, O) {
                  ee.hasOwnProperty(O) && (ee[O] += this.headerOffset);
                },
                computeFutureIndex: function(ee, O) {
                  if (!ee.element)
                    return 0;
                  var K = v(O.to.children).filter(function(Ee) {
                    return Ee.style.display !== "none";
                  }), z = K.indexOf(O.related), q = ee.component.getVmIndex(z), ae = K.indexOf(A) !== -1;
                  return ae || !O.willInsertAfter ? q : q + 1;
                },
                onDragMove: function(ee, O) {
                  var K = this.move;
                  if (!K || !this.realList)
                    return !0;
                  var z = this.getRelatedContextFromMoveEvent(ee), q = this.context, ae = this.computeFutureIndex(z, ee);
                  Object.assign(q, {
                    futureIndex: ae
                  });
                  var Ee = Object.assign({}, ee, {
                    relatedContext: z,
                    draggedContext: q
                  });
                  return K(Ee, O);
                },
                onDragEnd: function() {
                  this.computeIndexes(), A = null;
                }
              }
            };
            typeof window < "u" && "Vue" in window && window.Vue.component("draggable", L);
            var se = L;
            s.default = se;
          }
        )
        /******/
      }).default
    );
  });
})(p4);
var Soe = p4.exports;
const Ioe = /* @__PURE__ */ Et(Soe);
var Eoe = Wr, xoe = Iu, Coe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Toe = /^\w*$/;
function Poe(t, e) {
  if (Eoe(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || xoe(t) ? !0 : Toe.test(t) || !Coe.test(t) || e != null && t in Object(e);
}
var BS = Poe, x4 = NS, koe = "Expected a function";
function jS(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(koe);
  var n = function() {
    var r = arguments, s = e ? e.apply(this, r) : r[0], i = n.cache;
    if (i.has(s))
      return i.get(s);
    var o = t.apply(this, r);
    return n.cache = i.set(s, o) || i, o;
  };
  return n.cache = new (jS.Cache || x4)(), n;
}
jS.Cache = x4;
var Noe = jS, $oe = Noe, Doe = 500;
function Aoe(t) {
  var e = $oe(t, function(r) {
    return n.size === Doe && n.clear(), r;
  }), n = e.cache;
  return e;
}
var Ooe = Aoe, Moe = Ooe, Roe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Loe = /\\(\\)?/g, Foe = Moe(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(Roe, function(n, r, s, i) {
    e.push(s ? i.replace(Loe, "$1") : r || n);
  }), e;
}), C4 = Foe, Boe = Wr, joe = BS, Woe = C4, Hoe = Lf;
function Voe(t, e) {
  return Boe(t) ? t : joe(t, e) ? [t] : Woe(Hoe(t));
}
var Nv = Voe, zoe = Iu, Uoe = 1 / 0;
function Goe(t) {
  if (typeof t == "string" || zoe(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -Uoe ? "-0" : e;
}
var xu = Goe, Yoe = Nv, Zoe = xu;
function Xoe(t, e) {
  e = Yoe(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[Zoe(e[n++])];
  return n && n == r ? t : void 0;
}
var WS = Xoe, Koe = WS;
function Joe(t, e, n) {
  var r = t == null ? void 0 : Koe(t, e);
  return r === void 0 ? n : r;
}
var T4 = Joe;
const lt = /* @__PURE__ */ Et(T4);
var qoe = Sv;
function Qoe() {
  this.__data__ = new qoe(), this.size = 0;
}
var eae = Qoe;
function tae(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var nae = tae;
function rae(t) {
  return this.__data__.get(t);
}
var sae = rae;
function iae(t) {
  return this.__data__.has(t);
}
var oae = iae, aae = Sv, lae = kS, cae = NS, uae = 200;
function dae(t, e) {
  var n = this.__data__;
  if (n instanceof aae) {
    var r = n.__data__;
    if (!lae || r.length < uae - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new cae(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var fae = dae, pae = Sv, hae = eae, mae = nae, vae = sae, gae = oae, yae = fae;
function Cu(t) {
  var e = this.__data__ = new pae(t);
  this.size = e.size;
}
Cu.prototype.clear = hae;
Cu.prototype.delete = mae;
Cu.prototype.get = vae;
Cu.prototype.has = gae;
Cu.prototype.set = yae;
var HS = Cu;
function bae(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var _ae = bae, wae = Ev, Sae = _ae, Iae = Cv, Eae = 1, xae = 2;
function Cae(t, e, n, r, s, i) {
  var o = n & Eae, a = t.length, l = e.length;
  if (a != l && !(o && l > a))
    return !1;
  var c = i.get(t), u = i.get(e);
  if (c && u)
    return c == e && u == t;
  var d = -1, f = !0, p = n & xae ? new wae() : void 0;
  for (i.set(t, e), i.set(e, t); ++d < a; ) {
    var h = t[d], m = e[d];
    if (r)
      var v = o ? r(m, h, d, e, t, i) : r(h, m, d, t, e, i);
    if (v !== void 0) {
      if (v)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!Sae(e, function(y, _) {
        if (!Iae(p, _) && (h === y || s(h, y, n, r, i)))
          return p.push(_);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === m || s(h, m, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), f;
}
var P4 = Cae, Tae = Rs, Pae = Tae.Uint8Array, k4 = Pae;
function kae(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, s) {
    n[++e] = [s, r];
  }), n;
}
var Nae = kae, ST = bu, IT = k4, $ae = PS, Dae = P4, Aae = Nae, Oae = DS, Mae = 1, Rae = 2, Lae = "[object Boolean]", Fae = "[object Date]", Bae = "[object Error]", jae = "[object Map]", Wae = "[object Number]", Hae = "[object RegExp]", Vae = "[object Set]", zae = "[object String]", Uae = "[object Symbol]", Gae = "[object ArrayBuffer]", Yae = "[object DataView]", ET = ST ? ST.prototype : void 0, Cy = ET ? ET.valueOf : void 0;
function Zae(t, e, n, r, s, i, o) {
  switch (n) {
    case Yae:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case Gae:
      return !(t.byteLength != e.byteLength || !i(new IT(t), new IT(e)));
    case Lae:
    case Fae:
    case Wae:
      return $ae(+t, +e);
    case Bae:
      return t.name == e.name && t.message == e.message;
    case Hae:
    case zae:
      return t == e + "";
    case jae:
      var a = Aae;
    case Vae:
      var l = r & Mae;
      if (a || (a = Oae), t.size != e.size && !l)
        return !1;
      var c = o.get(t);
      if (c)
        return c == e;
      r |= Rae, o.set(t, e);
      var u = Dae(a(t), a(e), r, s, i, o);
      return o.delete(t), u;
    case Uae:
      if (Cy)
        return Cy.call(t) == Cy.call(e);
  }
  return !1;
}
var Xae = Zae;
function Kae(t, e) {
  for (var n = -1, r = e.length, s = t.length; ++n < r; )
    t[s + n] = e[n];
  return t;
}
var VS = Kae, Jae = VS, qae = Wr;
function Qae(t, e, n) {
  var r = e(t);
  return qae(t) ? r : Jae(r, n(t));
}
var N4 = Qae;
function ele(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, s = 0, i = []; ++n < r; ) {
    var o = t[n];
    e(o, n, t) && (i[s++] = o);
  }
  return i;
}
var zS = ele;
function tle() {
  return [];
}
var $4 = tle, nle = zS, rle = $4, sle = Object.prototype, ile = sle.propertyIsEnumerable, xT = Object.getOwnPropertySymbols, ole = xT ? function(t) {
  return t == null ? [] : (t = Object(t), nle(xT(t), function(e) {
    return ile.call(t, e);
  }));
} : rle, US = ole;
function ale(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var lle = ale, cle = oc, ule = Pi, dle = "[object Arguments]";
function fle(t) {
  return ule(t) && cle(t) == dle;
}
var ple = fle, CT = ple, hle = Pi, D4 = Object.prototype, mle = D4.hasOwnProperty, vle = D4.propertyIsEnumerable, gle = CT(/* @__PURE__ */ function() {
  return arguments;
}()) ? CT : function(t) {
  return hle(t) && mle.call(t, "callee") && !vle.call(t, "callee");
}, $v = gle, xm = { exports: {} };
function yle() {
  return !1;
}
var ble = yle;
xm.exports;
(function(t, e) {
  var n = Rs, r = ble, s = e && !e.nodeType && e, i = s && !0 && t && !t.nodeType && t, o = i && i.exports === s, a = o ? n.Buffer : void 0, l = a ? a.isBuffer : void 0, c = l || r;
  t.exports = c;
})(xm, xm.exports);
var Dv = xm.exports, _le = 9007199254740991, wle = /^(?:0|[1-9]\d*)$/;
function Sle(t, e) {
  var n = typeof t;
  return e = e ?? _le, !!e && (n == "number" || n != "symbol" && wle.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Av = Sle, Ile = 9007199254740991;
function Ele(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Ile;
}
var GS = Ele, xle = oc, Cle = GS, Tle = Pi, Ple = "[object Arguments]", kle = "[object Array]", Nle = "[object Boolean]", $le = "[object Date]", Dle = "[object Error]", Ale = "[object Function]", Ole = "[object Map]", Mle = "[object Number]", Rle = "[object Object]", Lle = "[object RegExp]", Fle = "[object Set]", Ble = "[object String]", jle = "[object WeakMap]", Wle = "[object ArrayBuffer]", Hle = "[object DataView]", Vle = "[object Float32Array]", zle = "[object Float64Array]", Ule = "[object Int8Array]", Gle = "[object Int16Array]", Yle = "[object Int32Array]", Zle = "[object Uint8Array]", Xle = "[object Uint8ClampedArray]", Kle = "[object Uint16Array]", Jle = "[object Uint32Array]", Fn = {};
Fn[Vle] = Fn[zle] = Fn[Ule] = Fn[Gle] = Fn[Yle] = Fn[Zle] = Fn[Xle] = Fn[Kle] = Fn[Jle] = !0;
Fn[Ple] = Fn[kle] = Fn[Wle] = Fn[Nle] = Fn[Hle] = Fn[$le] = Fn[Dle] = Fn[Ale] = Fn[Ole] = Fn[Mle] = Fn[Rle] = Fn[Lle] = Fn[Fle] = Fn[Ble] = Fn[jle] = !1;
function qle(t) {
  return Tle(t) && Cle(t.length) && !!Fn[xle(t)];
}
var Qle = qle;
function ece(t) {
  return function(e) {
    return t(e);
  };
}
var Tu = ece, Cm = { exports: {} };
Cm.exports;
(function(t, e) {
  var n = G5, r = e && !e.nodeType && e, s = r && !0 && t && !t.nodeType && t, i = s && s.exports === r, o = i && n.process, a = function() {
    try {
      var l = s && s.require && s.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  t.exports = a;
})(Cm, Cm.exports);
var YS = Cm.exports, tce = Qle, nce = Tu, TT = YS, PT = TT && TT.isTypedArray, rce = PT ? nce(PT) : tce, ZS = rce, sce = lle, ice = $v, oce = Wr, ace = Dv, lce = Av, cce = ZS, uce = Object.prototype, dce = uce.hasOwnProperty;
function fce(t, e) {
  var n = oce(t), r = !n && ice(t), s = !n && !r && ace(t), i = !n && !r && !s && cce(t), o = n || r || s || i, a = o ? sce(t.length, String) : [], l = a.length;
  for (var c in t)
    (e || dce.call(t, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    lce(c, l))) && a.push(c);
  return a;
}
var A4 = fce, pce = Object.prototype;
function hce(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || pce;
  return t === n;
}
var Ov = hce;
function mce(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var O4 = mce, vce = O4, gce = vce(Object.keys, Object), yce = gce, bce = Ov, _ce = yce, wce = Object.prototype, Sce = wce.hasOwnProperty;
function Ice(t) {
  if (!bce(t))
    return _ce(t);
  var e = [];
  for (var n in Object(t))
    Sce.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var XS = Ice, Ece = TS, xce = GS;
function Cce(t) {
  return t != null && xce(t.length) && !Ece(t);
}
var lc = Cce, Tce = A4, Pce = XS, kce = lc;
function Nce(t) {
  return kce(t) ? Tce(t) : Pce(t);
}
var Pu = Nce, $ce = N4, Dce = US, Ace = Pu;
function Oce(t) {
  return $ce(t, Ace, Dce);
}
var M4 = Oce, kT = M4, Mce = 1, Rce = Object.prototype, Lce = Rce.hasOwnProperty;
function Fce(t, e, n, r, s, i) {
  var o = n & Mce, a = kT(t), l = a.length, c = kT(e), u = c.length;
  if (l != u && !o)
    return !1;
  for (var d = l; d--; ) {
    var f = a[d];
    if (!(o ? f in e : Lce.call(e, f)))
      return !1;
  }
  var p = i.get(t), h = i.get(e);
  if (p && h)
    return p == e && h == t;
  var m = !0;
  i.set(t, e), i.set(e, t);
  for (var v = o; ++d < l; ) {
    f = a[d];
    var y = t[f], _ = e[f];
    if (r)
      var w = o ? r(_, y, f, e, t, i) : r(y, _, f, t, e, i);
    if (!(w === void 0 ? y === _ || s(y, _, n, r, i) : w)) {
      m = !1;
      break;
    }
    v || (v = f == "constructor");
  }
  if (m && !v) {
    var S = t.constructor, E = e.constructor;
    S != E && "constructor" in t && "constructor" in e && !(typeof S == "function" && S instanceof S && typeof E == "function" && E instanceof E) && (m = !1);
  }
  return i.delete(t), i.delete(e), m;
}
var Bce = Fce, jce = ac, Wce = Rs, Hce = jce(Wce, "DataView"), Vce = Hce, zce = ac, Uce = Rs, Gce = zce(Uce, "Promise"), Yce = Gce, Zce = ac, Xce = Rs, Kce = Zce(Xce, "WeakMap"), R4 = Kce, O0 = Vce, M0 = kS, R0 = Yce, L0 = J5, F0 = R4, L4 = oc, ku = Z5, NT = "[object Map]", Jce = "[object Object]", $T = "[object Promise]", DT = "[object Set]", AT = "[object WeakMap]", OT = "[object DataView]", qce = ku(O0), Qce = ku(M0), eue = ku(R0), tue = ku(L0), nue = ku(F0), xl = L4;
(O0 && xl(new O0(new ArrayBuffer(1))) != OT || M0 && xl(new M0()) != NT || R0 && xl(R0.resolve()) != $T || L0 && xl(new L0()) != DT || F0 && xl(new F0()) != AT) && (xl = function(t) {
  var e = L4(t), n = e == Jce ? t.constructor : void 0, r = n ? ku(n) : "";
  if (r)
    switch (r) {
      case qce:
        return OT;
      case Qce:
        return NT;
      case eue:
        return $T;
      case tue:
        return DT;
      case nue:
        return AT;
    }
  return e;
});
var Nu = xl, Ty = HS, rue = P4, sue = Xae, iue = Bce, MT = Nu, RT = Wr, LT = Dv, oue = ZS, aue = 1, FT = "[object Arguments]", BT = "[object Array]", Pp = "[object Object]", lue = Object.prototype, jT = lue.hasOwnProperty;
function cue(t, e, n, r, s, i) {
  var o = RT(t), a = RT(e), l = o ? BT : MT(t), c = a ? BT : MT(e);
  l = l == FT ? Pp : l, c = c == FT ? Pp : c;
  var u = l == Pp, d = c == Pp, f = l == c;
  if (f && LT(t)) {
    if (!LT(e))
      return !1;
    o = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new Ty()), o || oue(t) ? rue(t, e, n, r, s, i) : sue(t, e, l, n, r, s, i);
  if (!(n & aue)) {
    var p = u && jT.call(t, "__wrapped__"), h = d && jT.call(e, "__wrapped__");
    if (p || h) {
      var m = p ? t.value() : t, v = h ? e.value() : e;
      return i || (i = new Ty()), s(m, v, n, r, i);
    }
  }
  return f ? (i || (i = new Ty()), iue(t, e, n, r, s, i)) : !1;
}
var uue = cue, due = uue, WT = Pi;
function F4(t, e, n, r, s) {
  return t === e ? !0 : t == null || e == null || !WT(t) && !WT(e) ? t !== t && e !== e : due(t, e, n, r, F4, s);
}
var KS = F4, fue = KS;
function pue(t, e) {
  return fue(t, e);
}
var hue = pue;
const $a = /* @__PURE__ */ Et(hue);
var mue = Rs, vue = function() {
  return mue.Date.now();
}, gue = vue, yue = /\s/;
function bue(t) {
  for (var e = t.length; e-- && yue.test(t.charAt(e)); )
    ;
  return e;
}
var _ue = bue, wue = _ue, Sue = /^\s+/;
function Iue(t) {
  return t && t.slice(0, wue(t) + 1).replace(Sue, "");
}
var Eue = Iue, xue = Eue, HT = Yi, Cue = Iu, VT = NaN, Tue = /^[-+]0x[0-9a-f]+$/i, Pue = /^0b[01]+$/i, kue = /^0o[0-7]+$/i, Nue = parseInt;
function $ue(t) {
  if (typeof t == "number")
    return t;
  if (Cue(t))
    return VT;
  if (HT(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = HT(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = xue(t);
  var n = Pue.test(t);
  return n || kue.test(t) ? Nue(t.slice(2), n ? 2 : 8) : Tue.test(t) ? VT : +t;
}
var B4 = $ue, Due = Yi, Py = gue, zT = B4, Aue = "Expected a function", Oue = Math.max, Mue = Math.min;
function Rue(t, e, n) {
  var r, s, i, o, a, l, c = 0, u = !1, d = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(Aue);
  e = zT(e) || 0, Due(n) && (u = !!n.leading, d = "maxWait" in n, i = d ? Oue(zT(n.maxWait) || 0, e) : i, f = "trailing" in n ? !!n.trailing : f);
  function p(x) {
    var T = r, C = s;
    return r = s = void 0, c = x, o = t.apply(C, T), o;
  }
  function h(x) {
    return c = x, a = setTimeout(y, e), u ? p(x) : o;
  }
  function m(x) {
    var T = x - l, C = x - c, k = e - T;
    return d ? Mue(k, i - C) : k;
  }
  function v(x) {
    var T = x - l, C = x - c;
    return l === void 0 || T >= e || T < 0 || d && C >= i;
  }
  function y() {
    var x = Py();
    if (v(x))
      return _(x);
    a = setTimeout(y, m(x));
  }
  function _(x) {
    return a = void 0, f && r ? p(x) : (r = s = void 0, o);
  }
  function w() {
    a !== void 0 && clearTimeout(a), c = 0, r = l = s = a = void 0;
  }
  function S() {
    return a === void 0 ? o : _(Py());
  }
  function E() {
    var x = Py(), T = v(x);
    if (r = arguments, s = this, l = x, T) {
      if (a === void 0)
        return h(l);
      if (d)
        return clearTimeout(a), a = setTimeout(y, e), p(l);
    }
    return a === void 0 && (a = setTimeout(y, e)), o;
  }
  return E.cancel = w, E.flush = S, E;
}
var j4 = Rue;
const jf = /* @__PURE__ */ Et(j4);
var Lue = j4, Fue = Yi, Bue = "Expected a function";
function jue(t, e, n) {
  var r = !0, s = !0;
  if (typeof t != "function")
    throw new TypeError(Bue);
  return Fue(n) && (r = "leading" in n ? !!n.leading : r, s = "trailing" in n ? !!n.trailing : s), Lue(t, e, {
    leading: r,
    maxWait: e,
    trailing: s
  });
}
var Wue = jue;
const za = /* @__PURE__ */ Et(Wue);
function W4() {
  const t = {};
  for (const e of Object.values(this.templates))
    t[e.name] = e({}, {}).settings.color;
  return t;
}
const ve = {
  asoiNotes: null,
  asoiNote: null,
  asoiNotesSent: null,
  asoiNoteSent: null,
  asoiNotesEmbargo: null,
  asoiNoteEmbargo: null,
  newsItem: null,
  tasks: null,
  awaitingPublication: null,
  search: null,
  disposed: null,
  newsbreak: null,
  lead: null,
  flow: null,
  originals: null,
  newsCanvas: null
}, gt = {
  delayedSupply: null,
  asoiNoteSupply: null,
  searchSupply: null,
  searchSecondSupply: null,
  newsItemNewsbreakSupply: null,
  newsItemAdditionalSupply: null,
  newsItemVersionsSupply: null,
  leadSupply: null,
  newsCanvasSupply: null
};
for (const t in ve) ve[t] = t;
for (const t in gt) gt[t] = t;
const JS = {
  getColorMap: W4,
  defaultSettings() {
    return {
      // FIXME: этот дефолт не подходит для узких панелей asoiNotes, asoiNotesSent, etc
      // compact: getDeps('panels').userProfile.defaultPanelWidth === 1,
      compact: !1,
      color: "333333",
      dateMode: 0,
      widthScaleFactor: Cr.common.default
    };
  },
  getTemplate(t, e) {
    const n = this.templates[t](e), r = {
      type: t,
      settings: {
        ...this.defaultSettings(),
        ...n.settings || {}
      },
      supply: {
        left: [],
        right: [],
        ...n.supply || {}
      }
    };
    return n.supply === null && (r.supply = null), r;
  },
  templates: {
    [ve.tasks]: () => ({
      settings: { name: null },
      supply: null
    }),
    [ve.awaitingPublication]: () => ({
      settings: {
        color: "E15C5C",
        name: "Эмбарго: Отложенные публикации",
        widthScaleFactor: Cr.common.wide,
        compact: !0
      },
      supply: {
        right: [gt.delayedSupply]
      }
    }),
    [ve.asoiNotesEmbargo]: () => ({
      settings: {
        color: "E15C1C",
        name: "Эмбарго: Заметки АСОИ",
        widthScaleFactor: Cr.common.wide,
        compact: !0
      },
      supply: {
        right: [gt.asoiNoteSupply]
      }
    }),
    [ve.asoiNotes]: () => ({
      settings: {
        color: "545454"
      },
      supply: {
        right: [gt.asoiNoteSupply]
      }
    }),
    [ve.asoiNotesSent]: () => ({
      settings: {
        color: "404040"
      },
      supply: {
        right: [gt.asoiNoteSupply]
      }
    }),
    [ve.search]: () => ({
      settings: {
        color: "0069E4",
        compact: !0,
        widthScaleFactor: Cr.common.wide
      },
      supply: {
        right: [gt.searchSupply, gt.searchSecondSupply]
      }
    }),
    [ve.disposed]: () => ({
      settings: {
        color: "333333"
      }
    }),
    [ve.newsbreak]: () => ({
      settings: {
        color: "333333"
      }
    }),
    [ve.lead]: () => ({
      settings: {
        color: "333333"
      },
      supply: null
      // явная отмена саплаев
    }),
    [ve.asoiNote]: () => ({
      settings: {
        color: "404040"
      }
    }),
    [ve.asoiNoteSent]: () => ({
      settings: {
        color: "404040"
      }
    }),
    [ve.asoiNoteEmbargo]: () => ({
      settings: {
        color: "E15C1C"
      }
    }),
    [ve.newsItem]: ({ isWide: t }) => ({
      settings: {
        // color: не работает, цвет редактора реализован как css:var(--theme-...)
        widthScaleFactor: Cr.newsItem[t ? "wide" : "default"]
      },
      supply: {
        left: [gt.newsItemNewsbreakSupply, gt.newsItemVersionsSupply],
        right: [gt.newsItemAdditionalSupply]
      }
    }),
    [ve.flow]: ({ color: t, name: e }) => ({
      settings: {
        color: t || "404040",
        name: e || null
      },
      supply: {
        right: [gt.leadSupply]
      }
    }),
    [ve.originals]: () => ({
      settings: {
        color: "00946B",
        compact: !0,
        widthScaleFactor: Cr.common.wide
      }
    }),
    [ve.newsCanvas]: () => ({
      settings: {
        color: "F4B650",
        widthScaleFactor: Cr.canvas.wide
      },
      supply: {
        right: [gt.newsCanvasSupply]
      }
    })
  }
}, Hue = {
  getColorMap: W4,
  defaultSettings() {
    return {
      ...JS.defaultSettings(),
      visible: !1,
      // убираем дефолт, по умолчанию саплаи наследуют цвет родителя
      color: null
    };
  },
  getTemplate(t, e, n) {
    const r = this.templates[t](e, n);
    return r ? {
      type: t,
      dataId: r.dataId ? String(r.dataId) : null,
      settings: {
        ...this.defaultSettings(),
        ...r.settings
      }
    } : null;
  },
  templates: {
    [gt.delayedSupply]() {
      return {
        settings: {
          widthScaleFactor: Cr.newsItem.default
        }
      };
    },
    [gt.asoiNoteSupply]() {
      return {
        settings: {
          // color: цвет наследуем от родителя
        }
      };
    },
    [gt.publishedSupply]() {
      return {
        settings: {
          widthScaleFactor: Cr.common.wide
        }
      };
    },
    [gt.searchSupply]() {
      return {
        settings: {
          color: "888888",
          widthScaleFactor: Cr.common.default
        }
      };
    },
    [gt.searchSecondSupply]() {
      return {
        settings: {
          color: "888888",
          widthScaleFactor: Cr.common.wide
        }
      };
    },
    [gt.newsItemNewsbreakSupply](t, { newsbreakId: e }) {
      return e ? {
        dataId: String(e),
        settings: { visible: !0 }
      } : null;
    },
    [gt.newsItemAdditionalSupply](t, { newsItem: e, isAdditionalSupplyAlwaysVisible: n }) {
      const r = !!e.first_comment;
      return {
        dataId: t.dataId,
        settings: r ? {
          visible: !0,
          activeTabIndex: 1
        } : {
          visible: n,
          activeTabIndex: 0
        }
      };
    },
    [gt.newsItemVersionsSupply](t) {
      return {
        dataId: t.dataId,
        // dataId должен быть строкой
        settings: {
          widthScaleFactor: 0.75
          // можно задать через panelScaleFactors
        }
      };
    },
    [gt.leadSupply]: () => ({ settings: {} }),
    [gt.newsCanvasSupply]: () => ({ settings: {} })
  }
};
function Vue(t, e) {
  if (!t.supply) return;
  let n = t.id;
  for (const r in t.supply)
    t.supply[r] = t.supply[r].map((s) => Hue.getTemplate(s, t, e)).filter(Boolean), t.supply[r].forEach((s) => {
      s.settings.color = s.settings.color || t.settings.color, s.id = ++n;
    });
  return t;
}
function UT({ id: t, type: e, dataId: n }, r = {}) {
  const s = JS.getTemplate(e, r);
  return s.id = t, s.dataId = n ? String(n) : null, Vue(s, r), s;
}
const zue = "received", Mv = "sent", H4 = (t) => [
  Mv,
  ve.asoiNotesSent,
  ve.asoiNoteSent
].includes(t), Uue = (t) => (e) => e === Mv ? ve.asoiNoteSent : ve.asoiNote, au = (t) => {
  const e = t.match(/(?:asoiNote(?:s*))(.*)/);
  return ((e ? e[1] : "") || "Received").toLowerCase();
}, Gue = (t) => {
  const e = t.match(/(?:asoiNote(?:s*))(.*)/);
  return ((e ? e[1] : "") || "").toLowerCase();
}, V4 = {
  mounted() {
    this.scrollEnabled && (this.$registerShortcut(
      "ArrowDown",
      this.scrollHandler.bind(this, "down"),
      {
        enabled: this.isFocused,
        capture: !0
      }
    ), this.$registerShortcut("ArrowUp", this.scrollHandler.bind(this, "up"), {
      enabled: this.isFocused,
      capture: !0
    })), this.isEmbargoFormVisible;
  },
  methods: {
    scrollHandler(t, e) {
      var i;
      e.preventDefault();
      const n = (i = this.$refs) == null ? void 0 : i.scrollableArea, r = (n == null ? void 0 : n.$el) ?? n, s = 36;
      if (!r) {
        console.warn(`No scrollable area ref in ${this._name}`);
        return;
      }
      if (!this.$store.state.uiState.modal)
        switch (t) {
          case "down":
            r.scrollBy(0, s);
            break;
          case "up":
            r.scrollBy(0, -s);
            break;
        }
    }
  }
};
var B0 = { exports: {} }, GT = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (GT) {
  var YT = new Uint8Array(16);
  B0.exports = function() {
    return GT(YT), YT;
  };
} else {
  var ZT = new Array(16);
  B0.exports = function() {
    for (var e = 0, n; e < 16; e++)
      e & 3 || (n = Math.random() * 4294967296), ZT[e] = n >>> ((e & 3) << 3) & 255;
    return ZT;
  };
}
var z4 = B0.exports, U4 = [];
for (var kp = 0; kp < 256; ++kp)
  U4[kp] = (kp + 256).toString(16).substr(1);
function Yue(t, e) {
  var n = e || 0, r = U4;
  return [
    r[t[n++]],
    r[t[n++]],
    r[t[n++]],
    r[t[n++]],
    "-",
    r[t[n++]],
    r[t[n++]],
    "-",
    r[t[n++]],
    r[t[n++]],
    "-",
    r[t[n++]],
    r[t[n++]],
    "-",
    r[t[n++]],
    r[t[n++]],
    r[t[n++]],
    r[t[n++]],
    r[t[n++]],
    r[t[n++]]
  ].join("");
}
var G4 = Yue, Zue = z4, Xue = G4, XT, ky, Ny = 0, $y = 0;
function Kue(t, e, n) {
  var r = e && n || 0, s = e || [];
  t = t || {};
  var i = t.node || XT, o = t.clockseq !== void 0 ? t.clockseq : ky;
  if (i == null || o == null) {
    var a = Zue();
    i == null && (i = XT = [
      a[0] | 1,
      a[1],
      a[2],
      a[3],
      a[4],
      a[5]
    ]), o == null && (o = ky = (a[6] << 8 | a[7]) & 16383);
  }
  var l = t.msecs !== void 0 ? t.msecs : (/* @__PURE__ */ new Date()).getTime(), c = t.nsecs !== void 0 ? t.nsecs : $y + 1, u = l - Ny + (c - $y) / 1e4;
  if (u < 0 && t.clockseq === void 0 && (o = o + 1 & 16383), (u < 0 || l > Ny) && t.nsecs === void 0 && (c = 0), c >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Ny = l, $y = c, ky = o, l += 122192928e5;
  var d = ((l & 268435455) * 1e4 + c) % 4294967296;
  s[r++] = d >>> 24 & 255, s[r++] = d >>> 16 & 255, s[r++] = d >>> 8 & 255, s[r++] = d & 255;
  var f = l / 4294967296 * 1e4 & 268435455;
  s[r++] = f >>> 8 & 255, s[r++] = f & 255, s[r++] = f >>> 24 & 15 | 16, s[r++] = f >>> 16 & 255, s[r++] = o >>> 8 | 128, s[r++] = o & 255;
  for (var p = 0; p < 6; ++p)
    s[r + p] = i[p];
  return e || Xue(s);
}
var Y4 = Kue;
const qS = /* @__PURE__ */ Et(Y4), Z4 = "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", Jue = (t) => Uint8Array.from(atob(t), (e) => e.charCodeAt(0)), KT = typeof self < "u" && self.Blob && new Blob([Jue(Z4)], { type: "text/javascript;charset=utf-8" });
function que(t) {
  let e;
  try {
    if (e = KT && (self.URL || self.webkitURL).createObjectURL(KT), !e) throw "";
    const n = new Worker(e, {
      name: t == null ? void 0 : t.name
    });
    return n.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), n;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + Z4,
      {
        name: t == null ? void 0 : t.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
class Que {
  constructor() {
    this._worker = new que(), this._listeners = {}, this._worker.onmessage = this._processMessage.bind(this);
  }
  _processMessage(e) {
    this._listeners[e.data.actionId] && this._listeners[e.data.actionId](e.data);
  }
  process(e, n) {
    return new Promise((r) => {
      const s = {
        key: e.toString().toLowerCase(),
        body: n,
        actionId: qS()
      }, i = (o) => {
        delete this._listeners[o.actionId], r(o.data);
      };
      this._listeners[s.actionId] = i, this._worker.postMessage(s);
    });
  }
}
const Kn = new Que(), ede = "_root_1n25v_1", tde = "_content_1n25v_6", nde = "_preTitle_1n25v_13", rde = "_title_1n25v_17", sde = "_titleText_1n25v_25", ide = "_extension_1n25v_40", ode = {
  root: ede,
  content: tde,
  preTitle: nde,
  title: rde,
  titleText: sde,
  extension: ide
}, ade = {
  name: "toolbar",
  inject: {
    toolbarStyles: { default: () => ({}) }
  },
  props: {
    /** Заголовок панели */
    title: {
      type: String,
      default: ""
    },
    /** Флаг, указывающий есть ли расширение вниз */
    extended: {
      type: Boolean,
      default: !1
    },
    /** Высота тулбара */
    height: {
      type: String,
      default: "40px"
    },
    /** Размер шрифта заголовка */
    fontSize: {
      type: String,
      default: "1rem"
    },
    /** Цвет для заголовка и тени */
    color: {
      type: String,
      default: "#0069e4"
    },
    /** Расположение элементов в контенте */
    align: {
      type: String,
      default: "flex-start"
    },
    styleRoot: {
      type: Object,
      default: () => ({})
    },
    styleContent: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    /** Стиль для тени. Цвет тени вычисляется на основании цвета панели */
    shadowStyle() {
      return `0 4px 6px 0 ${cy(this.color, 0.4)},
              0 6px 8px ${cy(this.color, 0.2)},
              0 10px 10px ${cy(this.color, 0.12)}`;
    }
  },
  asyncComputed: {
    trimmedTitle: {
      async get() {
        return await Kn.process("trimHTML", this.title);
      },
      default: ""
    }
  }
};
var lde = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "PbToolbar", class: e.$style.root, style: {
    backgroundColor: e.color,
    boxShadow: e.shadowStyle,
    color: "#fff",
    ...typeof e.toolbarStyles == "function" ? e.toolbarStyles() : e.toolbarStyles,
    ...e.styleRoot
  }, attrs: { extended: e.extended, "data-test-selector": "toolbar" } }, [n("div", { class: [e.$style.content, "draggable-handle"], style: { justifyContent: e.align, ...e.styleContent } }, [e._t("menu"), e.$slots["pre-title"] ? n("div", { class: e.$style.preTitle }, [e._t("pre-title")], 2) : e._e(), e.title ? n("div", { class: e.$style.title, style: { fontSize: e.fontSize }, attrs: { "data-test-selector": "toolbar-title" } }, [n("div", { class: e.$style.titleText }, [e._v(" " + e._s(e.trimmedTitle)), e._t("title-postfix")], 2)]) : e._e(), e._t("default")], 2), e.$slots.extension ? n("div", { staticClass: "extension", class: [e.$style.extension, "draggable-handle"], style: { height: e.height } }, [e._t("extension")], 2) : e._e()]);
}, cde = [];
const JT = {
  $style: ode
};
function ude(t) {
  for (var e in JT)
    this[e] = JT[e];
}
var dde = /* @__PURE__ */ B(
  ade,
  lde,
  cde,
  !1,
  ude,
  null
);
const xo = dde.exports, X4 = {
  data() {
    return {
      delayedClick: null,
      clickedOnce: !1
    };
  },
  methods: {
    clickHandler() {
      if (!this.delayedClick) {
        const t = this;
        this.delayedClick = jf(this.doClick.bind(t), 200);
      }
      this.clickedOnce ? (this.delayedClick.cancel(), this.$emit("dblclick"), this.clickedOnce = !1) : (this.delayedClick(), this.clickedOnce = !0);
    },
    doClick() {
      this.$emit("click"), this.clickedOnce = !1;
    },
    dblclickHandler() {
      this.delayedClick.cancel(), this.clickedOnce = !1, this.$emit("dblclick");
    }
  }
}, fde = "_root_97vcv_1", pde = "_inner_97vcv_6", hde = "_modes_97vcv_10", mde = "_bar_97vcv_16", vde = "_active_97vcv_38", gde = {
  root: fde,
  inner: pde,
  modes: hde,
  bar: mde,
  active: vde
}, yde = {
  name: "PbSizeToggle",
  mixins: [X4],
  props: {
    modesCount: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isMaximized: {
      type: Boolean,
      default: !1
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 17
    }
  },
  computed: {
    barWidth() {
      return `${Math.ceil(this.size * 10 / 17)}px`;
    },
    indicatorStyle() {
      let t = "100%";
      return this.modesCount === 2 && (t = this.isMaximized ? "100%" : "50%"), this.modesCount === 3 && (this.isFullscreen ? t = "100%" : t = this.isMaximized ? "calc(66.6% + 0.5px)" : "calc(33.3% + 1px)"), {
        width: t
      };
    }
  }
};
var bde = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, "draggable-ignore"], style: { height: `${e.size}px` }, on: { click: function(r) {
    !e.disabled && e.clickHandler();
  } } }, [n("div", { class: e.$style.modes }, e._l(e.modesCount, function(r) {
    return n("div", { key: r, class: e.$style.bar, style: { width: e.barWidth } }, [n("div", { class: e.$style.inner })]);
  }), 0), n("div", { class: e.$style.active, style: e.indicatorStyle })]);
}, _de = [];
const qT = {
  $style: gde
};
function wde(t) {
  for (var e in qT)
    this[e] = qT[e];
}
var Sde = /* @__PURE__ */ B(
  yde,
  bde,
  _de,
  !1,
  wde,
  null
);
const K4 = Sde.exports, Ide = "_root_pjv6h_1", Ede = {
  root: Ide
}, xde = {
  name: "PbEmpty",
  props: {
    text: {
      type: String,
      default: "Пусто"
    }
  }
};
var Cde = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e._t("default", function() {
    return [n("h3", [e._v(" " + e._s(e.text) + " ")])];
  })], 2);
}, Tde = [];
const QT = {
  $style: Ede
};
function Pde(t) {
  for (var e in QT)
    this[e] = QT[e];
}
var kde = /* @__PURE__ */ B(
  xde,
  Cde,
  Tde,
  !1,
  Pde,
  null
);
const tl = kde.exports, Nde = "_root_mzu86_1", $de = "_menu_mzu86_46", Dde = "_content_mzu86_50", Ade = "_appbar_mzu86_59", Ode = "_appbar_fullscreen_mzu86_68", Mde = "_body_mzu86_72", Rde = {
  root: Nde,
  menu: $de,
  content: Dde,
  appbar: Ade,
  appbar_fullscreen: Ode,
  body: Mde
}, Cc = el.getParser(globalThis.navigator.userAgent), Lde = {
  name: "Panel",
  components: {
    PbToolbar: xo,
    PbSizeToggle: K4,
    PbEmpty: tl
  },
  inject: {
    getColorScheme: { default: () => ({}) },
    toolbarStylesParent: { from: "toolbarStyles", default: () => ({}) }
  },
  provide() {
    return {
      toolbarStyles: () => {
        const t = typeof this.toolbarStylesParent == "function" ? this.toolbarStylesParent() : this.toolbarStylesParent;
        return this.isNewsItem ? {
          ...t,
          color: this.getColorScheme().theme === "dark" ? "#fff" : "#000"
        } : t;
      }
    };
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      default: null
    },
    isFocused: {
      type: Boolean,
      default: !1
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    backgroundColor: {
      type: String,
      default: "333"
    },
    resizeable: {
      type: Boolean,
      default: !0
    },
    hasTitleBar: {
      type: Boolean,
      default: !0
    },
    toolbarColor: {
      type: String,
      default: null
    },
    toolbarClasses: {
      // TODO peter: возможно стоит удалить, через классы сложно управлять стилями компонента, потому что внутри у него css-module и имена внутренних классов недоступны извне (поэтому стилизовать можно только корень) - проще передать прямые стили в toolbarProps.styleRoot
      type: Array,
      default: () => []
    },
    styles: {
      validator: (t) => t.body || t.content || t.footer,
      default: () => ({ body: {} })
    },
    toolbarProps: {
      type: Object,
      default: () => ({})
    },
    userHasPermissions: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    ...st({
      isFullscreenNarrowMode: (t) => t.userProfile.newsEditor.fullscreenNarrowMode,
      windowParams: (t) => t.uiState.windowParams
    }),
    ...pe(["getLayoutLeftOffset"]),
    ...pe("panels", [
      "getPanelIndex",
      "getIsPanelNewsType",
      "getIsPanelCanvas",
      "getIsPanelRightSupplyVisible"
    ]),
    widthBreakpointMet() {
      return this.windowParams.width >= 1520;
    },
    isRightSupplyVisible() {
      return this.getIsPanelRightSupplyVisible(this.panel.id);
    },
    rightSupplyRelatedStyles() {
      return !this.isBodyNarrow || !this.isRightSupplyVisible ? {} : this.widthBreakpointMet ? { position: "relative", left: ji / 2 + "px" } : {};
    },
    appBarStyle() {
      if (!this.isBodyNarrow) return {};
      let t = ji / 2;
      (!this.isRightSupplyVisible || !this.widthBreakpointMet) && (t = 0);
      const e = this.windowParams.width - this.getLayoutLeftOffset;
      let n = parseInt(
        getComputedStyle(this.$refs.panelBody).marginLeft.slice(0, -2)
      );
      const r = 64, s = 1367, i = 1087;
      return n <= r && this.isRightSupplyVisible && e <= s ? {} : n <= r && !this.isRightSupplyVisible && e <= i ? {} : {
        margin: "0 auto",
        maxWidth: "930px",
        position: "relative",
        left: -r / 2 + t + "px"
      };
    },
    index() {
      return this.getPanelIndex(this.panel);
    },
    scaleFactor() {
      return this.panel.settings.widthScaleFactor || 1;
    },
    panelWidth() {
      return this.isFullscreen ? "100%" : ji * this.scaleFactor + "px";
    },
    isMaximized() {
      return this.panel.settings.widthScaleFactor > this.scaleFactors.default;
    },
    isSupply() {
      return this.panel.type.toLowerCase().includes("supply");
    },
    isNewsItem() {
      return this.getIsPanelNewsType(this.panel);
    },
    isCanvas() {
      return this.getIsPanelCanvas(this.panel);
    },
    scaleFactors() {
      return this.isNewsItem ? Cr.newsItem : this.isCanvas ? Cr.canvas : Cr.common;
    },
    canFullscreen() {
      return this.isNewsItem && this.isCanvas && !(Cc.isOS("ios") || Cc.isOS("android"));
    },
    background() {
      return this.backgroundColor ? this.backgroundColor : this.isNewsItem ? "#" + this.getColorScheme().backgroundColor : "#fff";
    },
    toolbarBackground() {
      return this.toolbarColor ? /^([a-fA-F0-9]{3}){1,2}$/.test(this.toolbarColor) ? "#" + this.toolbarColor : this.toolbarColor : "#" + this.panel.settings.color;
    },
    isBodyNarrow() {
      return this.isFullscreen && this.isFullscreenNarrowMode;
    },
    classes() {
      const t = this.$style.root, e = this.panel.type, n = ["panel", t, e];
      return this.panel.settings.widthScaleFactor > 1 && n.push("maximized"), this.isFocused && n.push("focused"), this.isFullscreen && n.push("fullscreen"), n;
    }
  },
  watch: {
    "panel.dataId": function(t, e) {
      t && t !== e && this.$refs.panelBody && (this.$refs.panelBody.scrollTop = 0);
    }
  },
  beforeDestroy() {
    this.isFocused && this.$emit("focusedPanelDestroyed", this.index);
  },
  methods: {
    ...ge("panels", [
      "togglePanelSize",
      "setPanelFullscreen",
      "setDesiredScrollIndex"
    ]),
    toggleMaximized() {
      const { default: t, wide: e } = this.scaleFactors;
      this.togglePanelSize({
        panel: this.panel,
        scaleFactor: this.scaleFactor === t ? e : t,
        compact: this.scaleFactor < e
      });
      const n = this.getPanelIndex(this.panel);
      this.setDesiredScrollIndex(n);
    },
    toggleFullscreen() {
      if (Cc.isOS("ios") || Cc.isOS("android") || !(this.isNewsItem || this.isCanvas) || (this.setPanelFullscreen({
        panel: this.panel,
        fullscreen: !this.isFullscreen
      }), !this.isFullscreen)) return;
      const t = this.getPanelIndex(this.panel);
      this.setDesiredScrollIndex(t);
    },
    toggleSize() {
      if (Cc.isOS("ios") || Cc.isOS("android") || !this.isNewsItem)
        this.toggleMaximized();
      else {
        const t = this.isFullscreen;
        this.panel.settings.widthScaleFactor > 1 || t ? this.toggleFullscreen() : this.toggleMaximized();
      }
    }
  }
};
var Fde = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.classes, style: {
    width: e.panelWidth
  }, attrs: { id: `panel-${e.panel.id}`, "data-test-selector": `panel-${e.panel.type}`, "data-test-id": e.panel.id, "data-test-attrs": `panel-color__${e.panel.settings.color}`, isFocused: e.isFocused } }, [n("div", { class: [e.$style.content, "panel-content"], style: { backgroundColor: e.background }, attrs: { "data-test-selector": "panel-content", "data-test-id": e.panel.dataId || e.panel.type } }, [e._t("main-toolbar", function() {
    return [e.hasTitleBar ? n("PbToolbar", e._b({ class: {
      [e.$style.toolbar]: !0,
      [e.$style.toolbar_fullscreen]: e.isFullscreen
    }, attrs: { title: e.title, color: e.toolbarBackground }, scopedSlots: e._u([{ key: "menu", fn: function() {
      return [n("div", { class: {
        [e.$style.menu]: !0,
        [e.$style.menu_fullscreen]: e.isFullscreen
      } }, [e._t("menu")], 2)];
    }, proxy: !0 }, { key: "pre-title", fn: function() {
      return [e._t("pre-title")];
    }, proxy: !0 }, { key: "title-postfix", fn: function() {
      return [e._t("title-postfix", null, null, { isMaximized: e.isMaximized })];
    }, proxy: !0 }, { key: "extension", fn: function() {
      return [e._t("appbar-extension", null, null, { isMaximized: e.isMaximized })];
    }, proxy: !0 }], null, !0) }, "PbToolbar", e.toolbarProps, !1), [n("div", { class: [e.$style.appbar, "panel-appbar"], style: e.appBarStyle }, [e._t("appBar"), e.resizeable ? n("PbSizeToggle", { attrs: { modesCount: e.canFullscreen ? 3.32 : 2, isMaximized: e.panel.settings.widthScaleFactor > 1, isFullscreen: e.isFullscreen }, on: { click: e.toggleSize, dblclick: e.toggleFullscreen } }) : e._e(), e._t("appBarActions", null, null, {
      isFullscreen: e.isFullscreen,
      canFullscreen: e.canFullscreen,
      toggleFullscreen: e.toggleFullscreen,
      isMaximized: e.isMaximized,
      toggleMaximized: e.toggleMaximized,
      isSupply: e.isSupply,
      toggleSize: e.toggleSize
    })], 2)]) : e._e()];
  }), n("div", { ref: "panelBody", class: [e.$style.body, "panel-body", e.isBodyNarrow && "is-narrow"], style: [e.styles.body || {}, e.rightSupplyRelatedStyles] }, [e.userHasPermissions ? [e._t("content")] : [n("PbEmpty", { attrs: { text: "У вас нет прав на просмотр содержимого этой панели" } })]], 2), e.$slots.footer ? n("footer", [e._t("footer")], 2) : e._e()], 2), e._t("popups"), e._t("dialogs")], 2);
}, Bde = [];
const eP = {
  $style: Rde
};
function jde(t) {
  for (var e in eP)
    this[e] = eP[e];
}
var Wde = /* @__PURE__ */ B(
  Lde,
  Fde,
  Bde,
  !1,
  jde,
  null
);
const bs = Wde.exports, Hde = {
  name: "DateWidget",
  props: {
    mode: {
      type: Number,
      validator(t) {
        return [0, 1, 2].includes(t);
      },
      default: 0
    },
    date: [String, Number, Date],
    highlightColor: {
      type: String,
      default: "inherit"
    },
    onlyTime: {
      type: Boolean,
      default: !1
    },
    moscowTime: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    localDate() {
      return new Date(this.date);
    }
  },
  created() {
    this.$timer && this.$timer.registerListener(this.updateDistance);
  },
  beforeDestroy() {
    this.$timer && this.$timer.unregisterListener(this.updateDistance);
  },
  methods: {
    updateDistance() {
      this.mode === 1 && this.$forceUpdate();
    },
    dates() {
      return [
        (this.moscowTime ? Go : on)(this.localDate, this.makeFormatString(this.localDate), {
          locale: xn
        }),
        M5(this.localDate, { locale: xn, addSuffix: !0 })
      ];
    },
    makeFormatString(t) {
      if (this.onlyTime) return "/HH:mm:ss";
      let e = "";
      return (!H5(t) || !mm(t)) && (e += "d MMMM "), Rf(t) || (e += "yyyy "), e += "/HH:mm:ss", e;
    },
    makeHtmlString(t) {
      if (!/\//.test(t)) return t;
      const e = t.split("/");
      return `<span style="color: ${this.highlightColor}">${e[0]}</span><span>${e[1]}</span>`;
    },
    makeTitle(t) {
      return t.replace("/", "");
    },
    toggleMode(t) {
      t.stopPropagation(), t.preventDefault(), this.$emit("dateModeChanged", Math.abs(this.mode - 1));
    }
  }
};
var Vde = function() {
  var e = this, n = e._self._c;
  return e.date ? n("span", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: e.makeTitle(e.dates()[Math.abs(this.mode - 1)]), expression: "makeTitle(dates()[Math.abs(this.mode - 1)])" }], attrs: { "data-test-selector": "date-widget" }, domProps: { innerHTML: e._s(e.makeHtmlString(e.dates()[e.mode])) }, on: { click: e.toggleMode, dblclick: function(r) {
    r.stopPropagation();
  } } }) : e._e();
}, zde = [], Ude = /* @__PURE__ */ B(
  Hde,
  Vde,
  zde,
  !1,
  null,
  null
);
const Hr = Ude.exports, Gde = {
  name: "progress-circular",
  props: {
    color: String,
    indeterminate: {
      type: Boolean,
      default: !0
    },
    rotate: {
      type: Number,
      default: 0
    },
    size: {
      type: [Number, String],
      default: 32
    },
    width: {
      type: Number,
      default: 4
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultColor: null
    };
  },
  computed: {
    calculatedSize() {
      return Number(this.size);
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    computedColor() {
      return this.color || this.defaultColor;
    },
    classes() {
      return {
        "progress-circular": !0,
        "progress-circular--indeterminate": this.indeterminate
      };
    },
    normalizedValue() {
      return this.value < 0 ? 0 : this.value > 100 ? 100 : this.value;
    },
    radius() {
      return 20;
    },
    strokeDashArray() {
      return Math.round(this.circumference * 1e3) / 1e3;
    },
    strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + "px";
    },
    strokeWidth() {
      return this.width / this.size * this.viewBoxSize * 2;
    },
    styles() {
      return {
        height: `${this.calculatedSize}px`,
        width: `${this.calculatedSize}px`,
        color: `${this.computedColor}`
      };
    },
    svgStyles() {
      return {
        transform: `rotate(${this.rotate}deg)`
      };
    },
    viewBoxSize() {
      return this.radius / (1 - this.width / this.size);
    }
  },
  methods: {
    genCircle(t, e, n) {
      return t("circle", {
        class: `progress-circular__${e}`,
        attrs: {
          fill: "transparent",
          cx: 2 * this.viewBoxSize,
          cy: 2 * this.viewBoxSize,
          r: this.radius,
          "stroke-width": this.strokeWidth,
          "stroke-dasharray": this.strokeDashArray,
          "stroke-dashoffset": n
        }
      });
    },
    genSvg(t) {
      const e = [
        this.indeterminate || this.genCircle(t, "underlay", 0),
        this.genCircle(t, "overlay", this.strokeDashOffset)
      ];
      return t(
        "svg",
        {
          style: this.svgStyles,
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: `${this.viewBoxSize} ${this.viewBoxSize} ${2 * this.viewBoxSize} ${2 * this.viewBoxSize}`
          }
        },
        e
      );
    }
  },
  render(t) {
    const e = t("div", { class: "progress-circular__info" }, [
      this.$slots.default
    ]), n = this.genSvg(t);
    return t(
      "div",
      {
        class: this.classes,
        style: this.styles,
        on: this.$listeners
      },
      [n, e]
    );
  }
}, Yde = "_root_gl7vc_1", Zde = {
  root: Yde
}, Xde = {
  name: "PbCircularLoader",
  components: {
    ProgressCircular: Gde
  },
  props: {
    width: {
      type: Number,
      default: 2
    },
    color: {
      type: String,
      default: "#0069e4"
    },
    size: {
      type: [Number, String],
      default: 40
    }
  }
};
var Kde = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "circular-loader" } }, [n("ProgressCircular", { attrs: { size: e.size, width: e.width, color: e.color } })], 1);
}, Jde = [];
const tP = {
  $style: Zde
};
function qde(t) {
  for (var e in tP)
    this[e] = tP[e];
}
var Qde = /* @__PURE__ */ B(
  Xde,
  Kde,
  Jde,
  !1,
  qde,
  null
);
const br = Qde.exports, efe = "_root_1okl0_12", tfe = "_root_active_1okl0_23", nfe = "_root_highlighted_1okl0_26", rfe = "_content_1okl0_26", sfe = "_root_flat_1okl0_31", ife = "_label_1okl0_34", ofe = "_root_centered_1okl0_43", afe = {
  root: efe,
  root_active: tfe,
  root_highlighted: nfe,
  content: rfe,
  "highlight-animation": "_highlight-animation_1okl0_1",
  root_flat: sfe,
  label: ife,
  root_centered: ofe
}, lfe = {
  name: "PbTab",
  props: {
    isActive: Boolean,
    isHighlighted: Boolean,
    classNames: {
      type: Object,
      default: () => ({})
    },
    tabStyle: {
      type: String,
      default: "flat",
      validator: (t) => ["flat", "centered"].includes(t)
    },
    borderColor: {
      type: String,
      default: "#000"
    }
  },
  computed: {
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_active]: this.isActive,
        [this.classNames.main]: this.classNames.main,
        [this.classNames.active]: this.classNames.active && this.isActive,
        [this.$style.root_highlighted]: this.isHighlighted,
        [this.$style[`root_${this.tabStyle}`]]: this.tabStyle
      };
    }
  }
};
var cfe = function() {
  var e = this, n = e._self._c;
  return n("div", { directives: [{ name: "ripple", rawName: "v-ripple" }], class: e.rootClass, on: { click: function(r) {
    return e.$emit("change");
  } } }, [n("div", { class: e.$style.content, style: { borderColor: e.borderColor } }, [n("div", { class: e.$style.label }, [e._t("default")], 2)])]);
}, ufe = [];
const nP = {
  $style: afe
};
function dfe(t) {
  for (var e in nP)
    this[e] = nP[e];
}
var ffe = /* @__PURE__ */ B(
  lfe,
  cfe,
  ufe,
  !1,
  dfe,
  null
);
const pfe = ffe.exports, ai = {
  inject: ["getColorScheme"],
  computed: {
    ...st({
      settings: (t) => t.userProfile.newsEditor
    }),
    colorScheme() {
      return this.getColorScheme();
    },
    colorSchemeName() {
      var t;
      return (t = this.colorScheme) == null ? void 0 : t.name;
    },
    editorStyle() {
      const t = {};
      if (this.settings) {
        t.fontSize = this.settings.fontSize + "px", this.settings.fontFamily.toLowerCase().indexOf("sans") !== -1 && (t.fontFamily = this.settings.fontFamily + ", PT Sans, Verdana, sans-serif"), this.settings.fontFamily.toLowerCase().indexOf("serif") !== -1 && (t.fontFamily = this.settings.fontFamily + ", Georgia, serif");
        const e = this.colorScheme || {};
        t.color = "#" + e.color, t.backgroundColor = "#" + e.backgroundColor, t.lineHeight = this.settings.lineHeight / 100 + "em";
      }
      return t;
    }
  }
}, hfe = "_root_7crij_1", mfe = {
  root: hfe
}, vfe = {
  name: "PbTabs",
  mixins: [ai],
  components: {
    PbTab: pfe
  },
  model: {
    prop: "activeTab",
    event: "change"
  },
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    activeTab: String,
    highlightedTabs: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "flat",
      validator: (t) => ["flat", "centered"].includes(t)
    },
    height: {
      type: String,
      default: "auto"
    },
    classNames: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style[`root_${this.type}`]]: this.type,
        "draggable-ignore": !0
      };
    },
    borderColor() {
      return "#" + this.getColorScheme().innerBorderColor;
    }
  }
};
var gfe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass, style: {
    height: e.height,
    borderBottom: "1px solid " + e.borderColor
  } }, e._l(e.tabs, function(r) {
    return n("PbTab", { key: r.name, class: e.$style.tab, attrs: { classNames: e.classNames, borderColor: e.borderColor, tabStyle: e.type, isActive: r.name === e.activeTab, isHighlighted: e.highlightedTabs.includes(r.name) }, on: { change: function(s) {
      return e.$emit("change", r.name);
    } } }, [e._t("default", function() {
      return [e._v(e._s(r.label))];
    }, { tab: r })], 2);
  }), 1);
}, yfe = [];
const rP = {
  $style: mfe
};
function bfe(t) {
  for (var e in rP)
    this[e] = rP[e];
}
var _fe = /* @__PURE__ */ B(
  vfe,
  gfe,
  yfe,
  !1,
  bfe,
  null
);
const QS = _fe.exports, wfe = "_root_1a0a3_1", Sfe = "_header_1a0a3_5", Ife = "_header_inverted_1a0a3_13", Efe = "_date_1a0a3_17", xfe = "_origin_1a0a3_22", Cfe = "_tabs_1a0a3_34", Tfe = "_tabsItem_1a0a3_40", Pfe = "_tabLabel_1a0a3_46", kfe = "_toolbarExtension_1a0a3_50", Nfe = {
  root: wfe,
  header: Sfe,
  header_inverted: Ife,
  date: Efe,
  origin: xfe,
  tabs: Cfe,
  tabsItem: Tfe,
  tabLabel: Pfe,
  toolbarExtension: kfe
}, $fe = {
  name: "EntryPanel",
  mixins: [V4],
  components: {
    PbButton: nt,
    Panel: bs,
    PbCircularLoader: br,
    DateWidget: Hr,
    Tabs: QS
  },
  inject: ["getColorScheme"],
  props: {
    title: { type: String, required: !0 },
    entry: { type: Object, required: !0 },
    parent: { type: Object, default: null },
    isFocused: { type: Boolean, default: !1 },
    resizeable: { type: Boolean, default: !0 },
    panel: { type: Object, required: !0 },
    tabs: { type: Array, default: () => [] },
    error: { type: String, default: null },
    url: { type: String, default: null },
    contentTitle: { type: String, default: null },
    activeTab: { type: String, default: null },
    loading: { type: Boolean, default: !1 },
    userHasPermissions: { type: Boolean, default: !0 }
  },
  computed: {
    currentTab: {
      get() {
        return this.activeTab;
      },
      set(t) {
        this.$emit("update:activeTab", t);
      }
    },
    loaderColor() {
      return `#${this.getColorScheme().backgroundColor}`;
    },
    headerClass() {
      return {
        [this.$style.header]: !0,
        [this.$style.header_inverted]: this.getColorScheme().theme === "dark"
      };
    },
    panelStyle() {
      let t = ["6px", "6px", "6px", "6px"];
      return this.parent && (t[0] = "0", t[3] = "0"), {
        borderRadius: t.join(" ")
      };
    }
  },
  watch: {
    isFocused(t) {
      (!this.parent || !this.parent.id) && (t ? (this.$enableShortcut("ArrowDown"), this.$enableShortcut("ArrowUp")) : (this.$disableShortcut("ArrowDown"), this.$disableShortcut("ArrowUp")));
    },
    activeTab(t) {
      t && this.$refs.scrollableArea && (this.$refs.scrollableArea.scrollTop = 0);
    },
    "panel.dataId": function(t, e) {
      t && t !== e && this.$refs.scrollableArea && (this.$refs.scrollableArea.scrollTop = 0);
    }
  },
  created() {
    (!this.parent || !this.parent.id) && (this.scrollEnabled = !0);
  },
  methods: {
    ...ge("panels", ["hideSupply", "removePanel", "setPanelDateMode"]),
    setDateMode(t) {
      let e = this.parent && this.parent.id ? this.parent.id : this.panel.id;
      this.setPanelDateMode({ panelId: e, mode: t });
    },
    close({ focus: t } = { focus: !0 }) {
      this.parent && this.parent.id ? this.hideSupply({ panelId: this.parent.id, supplyId: this.panel.id }) : this.removePanel({ panelId: this.panel.id, setFocusOnParent: t });
    }
  }
};
var Dfe = function() {
  var e = this, n = e._self._c;
  return n("Panel", { class: e.$style.root, style: e.panelStyle, attrs: { title: e.title, panel: e.panel, isFocused: e.isFocused, resizeable: e.resizeable, "data-test-attrs": `entry-id__${e.panel.dataId}${e.isFocused ? " panel__focused" : ""}`, userHasPermissions: e.userHasPermissions }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [e._t("menu")];
  }, proxy: !0 }, { key: "appBarActions", fn: function() {
    return [n("PbButton", { staticClass: "appbar-button close-button draggable-ignore", attrs: { round: "", "data-test-selector": "panel-button-close" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.close.apply(null, arguments);
    } } }, [e.parent && e.parent.type === "newsItem" ? n("icon", { attrs: { name: "arrow-right-rounded", size: "12" } }) : n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)];
  }, proxy: !0 }, { key: "appbar-extension", fn: function() {
    return [n("div", { class: e.$style.toolbarExtension }, [e._t("appbar-extension", function() {
      return [n("tabs", { attrs: { tabs: e.tabs, height: "40px", type: "flat" }, scopedSlots: e._u([{ key: "default", fn: function({ tab: r }) {
        return [n("div", { attrs: { "data-test-attrs": `tab-name__${r.name}${r.name === e.currentTab ? " tab-active" : ""}`, "data-test-selector": "panel-entry-tabs-button" } }, [n("span", { class: e.$style.tabLabel }, [e._v(e._s(r.label))])])];
      } }]), model: { value: e.currentTab, callback: function(r) {
        e.currentTab = r;
      }, expression: "currentTab" } }), n("PbCircularLoader", { directives: [{ name: "show", rawName: "v-show", value: e.loading, expression: "loading" }], staticClass: "diff__loader", attrs: { size: 15, color: e.loaderColor } })];
    })], 2)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [e.error ? n("div", { staticClass: "no-content", attrs: { "data-test-selector": "panel-entry-error" } }, [n("h3", [e._v(e._s(e.error))])]) : n("div", { class: e.$style.tabs }, [n("div", { ref: "scrollableArea", class: e.$style.tabsItem }, [e._t("contentHeader", function() {
      return [e.entry.id ? n("div", { class: e.headerClass }, [e.url ? n("span", { class: e.$style.origin, attrs: { "data-test-selector": "entry-origin" } }, [n("a", { attrs: { href: e.url, title: e.contentTitle, target: "_blank" } }, [e._v(e._s(e.contentTitle))])]) : e._e(), n("DateWidget", { class: e.$style.date, attrs: { date: e.entry.created_at, mode: e.panel.settings.dateMode }, on: { dateModeChanged: e.setDateMode } })], 1) : e._e()];
    }), e._t("tabContent")], 2)])];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [e._t("entryFooter")];
  }, proxy: !0 }, { key: "dialogs", fn: function() {
    return [e._t("entryDialogs")];
  }, proxy: !0 }], null, !0) });
}, Afe = [];
const sP = {
  $style: Nfe
};
function Ofe(t) {
  for (var e in sP)
    this[e] = sP[e];
}
var Mfe = /* @__PURE__ */ B(
  $fe,
  Dfe,
  Afe,
  !1,
  Ofe,
  null
);
const e2 = Mfe.exports, Rfe = "_root_j3mq6_1", Lfe = "_root_active_j3mq6_7", Ffe = "_root_disabled_j3mq6_10", Bfe = "_text_j3mq6_15", jfe = {
  root: Rfe,
  root_active: Lfe,
  root_disabled: Ffe,
  "with-label": "_with-label_j3mq6_15",
  text: Bfe
}, Wfe = {
  name: "NewsTypeButton",
  components: {
    PbButton: nt
  },
  props: {
    typeId: {
      type: [Number, String],
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    showLabel: {
      type: Boolean,
      default: !1
    },
    iconSize: {
      type: Number,
      default: 20
    },
    color: {
      type: String
    },
    buttonStyle: {
      type: String,
      default: null
    },
    contentClass: {
      type: String,
      default: null
    },
    activeClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      delayedClick: null,
      clickedOnce: !1
    };
  },
  computed: {
    ...pe("references", ["newsTypes"]),
    rootClass() {
      return {
        "pb-news-type-button": !0,
        [this.$style.root]: !0,
        [this.$style.root_active]: this.active,
        [this.$style.root_disabled]: this.disabled,
        [this.activeClass]: this.active,
        [this.$style["with-label"]]: this.showLabel
      };
    },
    iconName() {
      var t;
      return "newstype-" + ((t = this.newsTypes[this.typeId].name) == null ? void 0 : t.toLowerCase());
    },
    label() {
      return this.newsTypes[this.typeId].description;
    }
  },
  methods: {
    clickHandler() {
      if (!this.delayedClick) {
        const t = this;
        this.delayedClick = jf(this.doClick.bind(t), 200);
      }
      this.clickedOnce ? (this.delayedClick.cancel(), this.clickedOnce = !1) : (this.delayedClick(), this.clickedOnce = !0);
    },
    doClick() {
      this.$emit("click"), this.clickedOnce = !1;
    },
    doubleClickHandler() {
      this.$emit("dblclick");
    }
  }
};
var Hfe = function() {
  var e = this, n = e._self._c;
  return n("PbButton", { class: e.rootClass, style: e.buttonStyle, attrs: { contentClass: e.contentClass, active: e.active, disabled: e.disabled, title: e.active ? null : e.label }, nativeOn: { click: function(r) {
    return e.clickHandler.apply(null, arguments);
  }, dblclick: function(r) {
    return r.stopPropagation(), r.preventDefault(), e.doubleClickHandler.apply(null, arguments);
  } } }, [e._t("icon", function() {
    return [e.iconName ? n("icon", { attrs: { color: e.color, name: e.iconName, size: e.iconSize } }) : e._e()];
  }), n("span", { class: e.$style.text }, [e._t("default", function() {
    return [e.showLabel ? [e._v(" " + e._s(e.label) + " ")] : e._e()];
  })], 2)], 2);
}, Vfe = [];
const iP = {
  $style: jfe
};
function zfe(t) {
  for (var e in iP)
    this[e] = iP[e];
}
var Ufe = /* @__PURE__ */ B(
  Wfe,
  Hfe,
  Vfe,
  !1,
  zfe,
  null
);
const ea = Ufe.exports;
function Gfe(t) {
  for (var e = -1, n = t == null ? 0 : t.length, r = 0, s = []; ++e < n; ) {
    var i = t[e];
    i && (s[r++] = i);
  }
  return s;
}
var Yfe = Gfe;
const J4 = /* @__PURE__ */ Et(Yfe), q4 = {
  asyncComputed: {
    /**
     * Количество слов в блоке
     * Преобразует все <br>, символы точки, тире, дефиса и минус в пробелы
     * @returns {number}
     */
    wordCounter: {
      async get() {
        if (this.type === "slugline")
          return (await Kn.process("trimHTML", this.content)).split("-").length;
        if (this.content) {
          const t = await Kn.process("trimHTML", this.content), e = J4(t.replace(/[.—–-]+/g, " ").split(/\s+/));
          try {
            return e.length;
          } catch {
            return 0;
          }
        }
        return 0;
      },
      default: 0,
      watch: ["content"]
    },
    /**
     * Количество символов в блоке
     * @returns {number}
     */
    symbolCounter: {
      async get() {
        try {
          const t = await Kn.process("trimHTML", this.content);
          let e = t ? t.length : 0;
          if (e > 0) {
            const n = this.content.match(/<p>/g);
            n && n.length > 1 && (e += n.length);
            const r = this.content.match(/<br/g);
            r && (e += r.length);
          }
          return e;
        } catch {
          return 0;
        }
      },
      watch: ["content"],
      default: 0
    }
  }
}, Zfe = {
  name: "PbTextCounters",
  props: {
    symbolCounter: {
      type: Number,
      default: 0
    },
    wordCounter: {
      type: Number,
      default: 0
    },
    maxSymbols: {
      type: Number,
      default: 1 / 0
    },
    maxWords: {
      type: Number,
      default: null
    }
  }
};
var Xfe = function() {
  var e = this, n = e._self._c;
  return n("span", [e.symbolCounter ? n("span", { staticClass: "counters", attrs: { "data-test-selector": "text-editor-counters" } }, [n("span", { staticClass: "symbol-counter", attrs: { "data-test-selector": "text-editor-counters-symbols" } }, [e._v("символов: " + e._s(e.symbolCounter) + " "), e.maxSymbols !== 1 / 0 ? n("span", [e._v("/" + e._s(e.maxSymbols))]) : e._e()]), n("span", { staticClass: "word-counter", attrs: { "data-test-selector": "text-editor-counters-words" } }, [e._v("слов: " + e._s(e.wordCounter) + " "), e.maxWords !== null ? n("span", [e._v("/" + e._s(e.maxWords))]) : e._e()])]) : n("span", { staticClass: "counters", attrs: { "data-test-selector": "text-editor-counters-empty" } }, [e._v("Пусто")])]);
}, Kfe = [], Jfe = /* @__PURE__ */ B(
  Zfe,
  Xfe,
  Kfe,
  !1,
  null,
  "e81f9d91"
);
const Q4 = Jfe.exports, qfe = {
  name: "TextViewer",
  mixins: [q4],
  components: {
    PbTextCounters: Q4
  },
  props: {
    /** Тип блока */
    type: String,
    /** Название блока */
    title: String,
    /** Содержимое блока */
    content: {
      type: String,
      default: ""
    }
  }
};
var Qfe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-text-editor editor view", class: e.type, attrs: { "data-test-selector": "text-viewer" } }, [n("header", [n("span", { staticClass: "block-title", attrs: { "data-test-selector": "text-viewer-title" } }, [e._v(" " + e._s(e.title) + " ")]), n("PbTextCounters", { attrs: { symbolCounter: e.symbolCounter, wordCounter: e.wordCounter } })], 1), n("main", [n("div", { staticClass: "editor__field", attrs: { "data-test-selector": "text-editor-field" }, domProps: { innerHTML: e._s(e.content) } })])]);
}, epe = [], tpe = /* @__PURE__ */ B(
  qfe,
  Qfe,
  epe,
  !1,
  null,
  null
);
const npe = tpe.exports;
var rpe = XS, spe = Nu, ipe = $v, ope = Wr, ape = lc, lpe = Dv, cpe = Ov, upe = ZS, dpe = "[object Map]", fpe = "[object Set]", ppe = Object.prototype, hpe = ppe.hasOwnProperty;
function mpe(t) {
  if (t == null)
    return !0;
  if (ape(t) && (ope(t) || typeof t == "string" || typeof t.splice == "function" || lpe(t) || upe(t) || ipe(t)))
    return !t.length;
  var e = spe(t);
  if (e == dpe || e == fpe)
    return !t.size;
  if (cpe(t))
    return !rpe(t).length;
  for (var n in t)
    if (hpe.call(t, n))
      return !1;
  return !0;
}
var vpe = mpe;
const fs = /* @__PURE__ */ Et(vpe), gpe = "_root_1r9rq_1", ype = "_root_inner_1r9rq_8", bpe = "_root_added_1r9rq_18", _pe = "_root_applied_1r9rq_18", wpe = "_root_removed_1r9rq_22", Spe = "_name_1r9rq_30", Ipe = "_group_1r9rq_35", Epe = "_check_1r9rq_44", xpe = "_check_apply_1r9rq_51", Cpe = "_check_delete_1r9rq_54", Tpe = {
  root: gpe,
  root_inner: ype,
  root_added: bpe,
  root_applied: _pe,
  root_removed: wpe,
  name: Spe,
  group: Ipe,
  check: Epe,
  check_apply: xpe,
  check_delete: Cpe
}, Ppe = {
  name: "NewsCodesListItem",
  inject: ["getColorScheme"],
  props: {
    code: {
      type: Object,
      required: !0
    },
    isEditable: {
      type: Boolean,
      default: !1
    },
    isApplicable: {
      type: Boolean,
      default: !1
    },
    isApplied: {
      type: Boolean,
      default: !1
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    colorScheme: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    codeColor() {
      const t = this.getColorScheme();
      return fs(this.colorScheme) ? this.code.isGroup ? `#${t.codeGroupColor}` : this.isApplied ? `#${t.codeRecommendedColor}` : `${t.codeColor}` : this.code.isGroup ? `#${this.colorScheme.groupColor}` : `#${this.colorScheme.codeColor}`;
    },
    isCodeExist() {
      var t;
      return this.newsCodes[(t = this.code) == null ? void 0 : t.id] ?? !1;
    },
    rootClass() {
      return this.code.isGroup ? this.$style.group : {
        [this.$style.root]: !0,
        [this.$style.root_applied]: this.isApplied,
        [this.$style.root_added]: this.code.added,
        [this.$style.root_removed]: this.code.removed
      };
    }
  },
  methods: {
    handleClick() {
      this.isApplicable ? this.$emit("codeChecked", this.code.id) : this.$emit("codeApplied", this.code.id);
    }
  }
};
var kpe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass, attrs: { "data-test-selector": "news-codes-list-item", "data-test-id": e.code.id, "data-test-attrs": `code-id__${e.code.id}` } }, [e.code.isGroup ? n("div", { class: e.$style.name, style: { color: e.codeColor }, attrs: { title: e.code.path, "data-test-selector": "news-codes-list-item-name" } }, [e._v(" " + e._s(e.code.name) + " ")]) : n("div", { class: e.$style.root_inner, on: { click: e.handleClick } }, [n("span", { class: e.$style.name, style: { color: e.codeColor }, attrs: { title: e.code.path, "data-test-selector": "news-codes-list-item-name" } }, [e._v(" " + e._s(e.code.name) + " ")]), e.isEditable && e.isCodeExist ? n("button", { class: [e.$style.check, e.$style.check_delete], style: { color: e.isApplied ? "#b9ac93" : null }, attrs: { type: "button", title: "Удалить код", "data-test-selector": "news-codes-list-item-remove" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.$emit("codeDeleted", e.code.id);
  } } }, [n("icon", { attrs: { name: "close", size: 9 } })], 1) : e._e()])]);
}, Npe = [];
const oP = {
  $style: Tpe
};
function $pe(t) {
  for (var e in oP)
    this[e] = oP[e];
}
var Dpe = /* @__PURE__ */ B(
  Ppe,
  kpe,
  Npe,
  !1,
  $pe,
  null
);
const eR = Dpe.exports, Ape = "_root_aafji_1", Ope = {
  root: Ape
}, Mpe = {
  name: "NewsCodesList",
  components: {
    NewsCodesListItem: eR
  },
  props: {
    codes: {
      type: Array,
      required: !0
    },
    isEditable: {
      type: Boolean,
      default: !1
    },
    isApplicable: {
      type: Boolean,
      default: !1
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    appliedCodeIds: {
      type: Array,
      default: () => []
    },
    colorScheme: {
      type: Object,
      default: () => ({})
    }
  }
};
var Rpe = function() {
  var e = this, n = e._self._c;
  return e.codes.length ? n("div", { class: e.$style.root }, e._l(e.codes, function(r) {
    return n("NewsCodesListItem", { key: r.id, attrs: { code: r, isEditable: e.isEditable, newsCodes: e.newsCodes, colorScheme: e.colorScheme, isApplicable: e.isApplicable, isApplied: e.appliedCodeIds.includes(r.id) }, on: { codeDeleted: function(s) {
      return e.$emit("codeDeleted", s);
    }, codeApplied: function(s) {
      return e.$emit("codeApplied", s);
    }, codeChecked: function(s) {
      return e.$emit("codeChecked", s);
    } } });
  }), 1) : e._e();
}, Lpe = [];
const aP = {
  $style: Ope
};
function Fpe(t) {
  for (var e in aP)
    this[e] = aP[e];
}
var Bpe = /* @__PURE__ */ B(
  Mpe,
  Rpe,
  Lpe,
  !1,
  Fpe,
  null
);
const $u = Bpe.exports, jpe = {
  name: "AsoiNoteBody",
  components: {
    TextViewer: npe,
    NewsCodesList: $u
  },
  props: {
    entry: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      allBlocks: [
        { title: "Слаглайн", type: "slugline" },
        { title: "Заголовок", type: "headline" },
        { title: "Текст", type: "body" }
      ],
      // NOTE: Не добавляем поля dateline, background и trashline, т.к. АСОИ не присылает их
      blockPresets: {
        1: ["slugline", "headline"],
        // Молния
        2: ["slugline", "headline", "body"],
        // Экспресс
        3: ["slugline", "headline", "body"],
        // Новость
        4: ["slugline", "headline", "body"]
        // Выпуск
      }
    };
  },
  computed: {
    ...pe("references", ["newsTypesByName"]),
    typeId() {
      return this.entry.type_id;
    },
    isOfTypeFlash() {
      return this.typeId === this.newsTypesByName.FLASH.id;
    },
    usedBlocks() {
      return this.allBlocks.filter(({ type: t }) => {
        const e = this.blockPresets[this.typeId];
        return e && e.includes(t);
      });
    },
    codes() {
      return this.entry.codes && this.entry.codes.length ? this.entry.codes.map(({ code: t }) => t) : [];
    }
  },
  methods: {
    getContent(t) {
      return this.isOfTypeFlash && t === "headline" ? this.entry.headline + (this.entry.body ?? "") : this.entry[t];
    }
  }
};
var Wpe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "news-draft _asoi-note", class: { "_type-flash": e.isOfTypeFlash }, attrs: { "data-test-selector": "asoi-note-body" } }, [e._l(e.usedBlocks, function(r) {
    return n("TextViewer", { key: r.type, ref: `editor-${r.type}`, refInFor: !0, attrs: { type: r.type, title: r.title, content: e.getContent(r.type), draftTypeId: e.typeId, "data-test-selector": "asoi-note-view-block", "data-test-attrs": `type__${r.type}` } });
  }), n("div", { staticClass: "codes" }, [n("NewsCodesList", { attrs: { codes: e.codes, isEditable: !1 } })], 1)], 2);
}, Hpe = [], Vpe = /* @__PURE__ */ B(
  jpe,
  Wpe,
  Hpe,
  !1,
  null,
  null
);
const zpe = Vpe.exports, Du = {
  props: {
    closeable: {
      type: Boolean,
      default: !0
    },
    transition: {
      type: String,
      default: "fade-transition"
    },
    withBackdrop: {
      type: Boolean,
      default: !1
    }
  },
  mounted() {
    this.$shortcuts ? this.$registerShortcut("Escape", this.bindEsc) : document.addEventListener("keyup", this.bindEsc);
  },
  beforeDestroy() {
    this.$shortcuts || document.removeEventListener("keyup", this.bindEsc);
  },
  methods: {
    bindEsc() {
      this.closeable && this.close();
    }
  }
}, Upe = "_container_73wxv_1", Gpe = "_modal_73wxv_15", Ype = "_close_73wxv_28", Zpe = "_backdrop_73wxv_35", Xpe = "_content_73wxv_41", Kpe = "_footer_73wxv_45", Jpe = "_dark_73wxv_53", qpe = {
  container: Upe,
  modal: Gpe,
  close: Ype,
  backdrop: Zpe,
  content: Xpe,
  footer: Kpe,
  dark: Jpe
}, Qpe = {
  name: "PbModal",
  mixins: [Du],
  components: {
    Toolbar: xo,
    PbButton: nt
  },
  props: {
    state: Boolean,
    title: String,
    portalTarget: {
      type: String,
      default: "modal"
    },
    maxWidth: {
      type: Number,
      default: 1240
    },
    minWidth: {
      type: Number,
      default: 0
    },
    autoWidth: {
      type: Boolean,
      default: !1
    },
    hasBackdrop: {
      type: Boolean,
      default: !0
    },
    hasHeader: {
      type: Boolean,
      default: !0
    },
    height: {
      type: String,
      default: "auto"
    },
    className: {
      type: String,
      default: ""
    },
    dataTestAttrs: {
      type: [String, null],
      default: null
    },
    dataTestId: {
      type: [String, null],
      default: null
    },
    dataTestSelector: {
      type: [String, null],
      default: null
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleOverlayClick() {
      this.closeOnOverlayClick && this.close();
    }
  }
};
var ehe = function() {
  var e = this, n = e._self._c;
  return e.state ? n("portal", { attrs: { to: e.portalTarget } }, [n("div", { key: e.title || "modal", class: e.$style.container, style: {
    background: !e.hasBackdrop && "none"
  }, on: { click: function(r) {
    return r.stopPropagation(), e.handleOverlayClick.apply(null, arguments);
  } } }, [n("div", { class: [e.$style.modal, e.className], style: {
    "max-width": e.maxWidth + "px",
    "min-width": e.minWidth + "px",
    height: e.height,
    width: e.autoWidth && "auto"
  }, attrs: { "data-test-id": e.dataTestId, "data-test-attrs": e.dataTestAttrs, "data-test-selector": e.dataTestSelector }, on: { click: function(r) {
    r.stopPropagation();
  } } }, [e.hasHeader ? n("Toolbar", { attrs: { title: e.title, fontSize: "20px" } }, [e._t("head"), e.closeable ? n("PbButton", { class: e.$style.close, attrs: { round: "", "data-test-selector": "close-modal-button" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.close.apply(null, arguments);
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1) : e._e()], 2) : e._e(), e._t("default")], 2)])]) : e._e();
}, the = [];
const lP = {
  $style: qpe
};
function nhe(t) {
  for (var e in lP)
    this[e] = lP[e];
}
var rhe = /* @__PURE__ */ B(
  Qpe,
  ehe,
  the,
  !1,
  nhe,
  null
);
const Au = rhe.exports, she = "_root_1vm9w_1", ihe = "_copy_1vm9w_13", ohe = {
  root: she,
  copy: ihe,
  "cell-inner-row": "_cell-inner-row_1vm9w_29"
}, ahe = {
  name: "PbTableCell",
  props: {
    column: {
      type: [String, Array],
      required: !0
    },
    colindex: {
      type: Number,
      default: 0
    },
    rowindex: {
      type: Number,
      default: 0
    },
    withCopying: {
      type: Boolean,
      default: !1
    },
    allowHtml: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      tdHovered: null,
      copyTooltipOpen: !1
    };
  },
  methods: {
    copyCellValue(t, e, n, r = null) {
      navigator.clipboard.writeText(t);
      const s = [e, n];
      r !== null && s.push(r), this.copyTooltipOpen = s, setTimeout(() => {
        this.copyTooltipOpen = !1;
      }, 750);
    }
  }
};
var lhe = function() {
  var e = this, n = e._self._c;
  return n("td", { key: e.colindex, class: e.$style.root, style: e.column && e.column.style, attrs: { colspan: e.column && e.column.colspan }, on: { mouseenter: function(r) {
    e.tdHovered = [e.rowindex, e.colindex];
  }, mouseleave: function(r) {
    e.tdHovered = null;
  } } }, [e.allowHtml ? [n("span", { domProps: { innerHTML: e._s(e.column) } })] : [e.column instanceof Array ? e._l(e.column, function(r, s) {
    return n("span", { key: s, class: e.$style["cell-inner-row"] }, [n("span", { class: e.$style["cell-inner-row-label"] }, [e._v(" " + e._s(r.label) + " ")]), n("span", { class: e.$style["cell-inner-row-value"] }, [e._v(" " + e._s(r.value) + " ")]), e.withCopying ? n("i", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: {
      content: "Значение скопировано",
      trigger: "manual",
      shown: e.copyTooltipOpen && e.copyTooltipOpen[0] === e.rowindex && e.copyTooltipOpen[1] === e.colindex && e.copyTooltipOpen[2] === r.label,
      delay: { show: 100, hide: 100 }
    }, expression: `{
            content: 'Значение скопировано',
            trigger: 'manual',
            shown:
              copyTooltipOpen &&
              copyTooltipOpen[0] === rowindex &&
              copyTooltipOpen[1] === colindex &&
              copyTooltipOpen[2] === innerRow.label,
            delay: { show: 100, hide: 100 }
          }` }], class: e.$style.copy, on: { click: function(i) {
      return e.copyCellValue(r.value, e.rowindex, e.colindex, r.label);
    } } }, [n("icon", { attrs: { type: "svg", name: "copy", size: "12" } })], 1) : e._e()]);
  }) : [n("span", [e._v(e._s(e.column))]), e.withCopying ? n("i", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: {
    content: "Значение скопировано",
    trigger: "manual",
    shown: e.copyTooltipOpen && e.copyTooltipOpen[0] === e.rowindex && e.copyTooltipOpen[1] === e.colindex,
    delay: { show: 100, hide: 100 }
  }, expression: `{
          content: 'Значение скопировано',
          trigger: 'manual',
          shown:
            copyTooltipOpen &&
            copyTooltipOpen[0] === rowindex &&
            copyTooltipOpen[1] === colindex,
          delay: { show: 100, hide: 100 }
        }` }], class: e.$style.copy, on: { click: function(r) {
    return e.copyCellValue(e.column, e.rowindex, e.colindex);
  } } }, [n("icon", { attrs: { type: "svg", name: "copy", size: "12" } })], 1) : e._e()]]], 2);
}, che = [];
const cP = {
  $style: ohe
};
function uhe(t) {
  for (var e in cP)
    this[e] = cP[e];
}
var dhe = /* @__PURE__ */ B(
  ahe,
  lhe,
  che,
  !1,
  uhe,
  null
);
const fhe = dhe.exports, phe = "_root_kfip4_2", hhe = "_table_kfip4_6", mhe = {
  root: phe,
  table: hhe
}, vhe = {
  name: "PbTable",
  components: {
    PbTableCell: fhe
  },
  props: {
    head: {
      type: Array,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    sort: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    allowHtml: {
      type: Boolean,
      default: !0
    },
    maxHeight: {
      type: [Number, null],
      default: 420
    },
    withCopying: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      sortBy: null,
      sortOrder: null,
      tdHovered: null,
      copyTooltipOpen: !1
    };
  },
  created() {
    this.sort ? (this.sortBy = this.sort.by, this.sortOrder = this.sort.order) : this.head.forEach((t) => {
      this.sortBy && this.sortOrder || t.sortable && (this.sortBy = t.id || t.toString(), this.sortOrder = "asc");
    });
  },
  computed: {
    height() {
      return this.maxHeight ? `${this.maxHeight}px` : "none";
    },
    thClass() {
      return (t) => ({
        "is-disabled": this.disabled,
        "is-sortable": !!t.sortable,
        "is-descending": [t.id, t].includes(this.sortBy) && this.sortOrder === "desc"
      });
    }
  },
  watch: {
    sort: {
      handler(t) {
        this.sortBy = t.by, this.sortOrder = t.order;
      },
      deep: !0
    }
  },
  methods: {
    changeSortOrder() {
      return this.sortOrder === "desc" ? "asc" : "desc";
    },
    copyCellValue(t, e, n) {
      navigator.clipboard.writeText(t), this.copyTooltipOpen = [e, n], setTimeout(() => {
        this.copyTooltipOpen = !1;
      }, 750);
    },
    handleThClick(t) {
      if (!t.sortable) return;
      const e = [t.id, t].includes(this.sortBy);
      this.sortBy = t.id || t, this.sortOrder = e ? this.changeSortOrder() : "asc", this.$emit("changeSorting", { col: this.sortBy, order: this.sortOrder });
    }
  }
};
var ghe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, style: { maxHeight: e.height } }, [n("table", { class: e.$style.table }, [n("thead", [n("tr", e._l(e.head, function(r, s) {
    return n("th", { key: s, class: e.thClass(r), style: r && r.style, on: { click: function(i) {
      return e.handleThClick(r);
    } } }, [e.allowHtml ? n("span", { domProps: { innerHTML: e._s(r) } }) : n("span", [e._v(e._s(r))])]);
  }), 0)]), n("tbody", e._l(e.data, function(r, s) {
    return n("tr", { key: s }, [e._l(r, function(i, o) {
      return [e._t("cell", function() {
        return [n("PbTableCell", { key: o, attrs: { column: i, colindex: o, rowindex: s, withCopying: e.withCopying, allowHtml: e.allowHtml } })];
      }, { column: i, colindex: o, rowindex: s })];
    })], 2);
  }), 0)])]);
}, yhe = [];
const uP = {
  $style: mhe
};
function bhe(t) {
  for (var e in uP)
    this[e] = uP[e];
}
var _he = /* @__PURE__ */ B(
  vhe,
  ghe,
  yhe,
  !1,
  bhe,
  null
);
const t2 = _he.exports, whe = "_close_12cks_1", She = "_body_12cks_8", Ihe = "_loader_12cks_12", Ehe = {
  close: whe,
  body: She,
  loader: Ihe
}, xhe = {
  name: "AsoiNotesModalHistory",
  components: {
    PbLoader: br,
    PbModal: Au,
    PbTable: t2
  },
  mixins: [Du],
  props: {
    state: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "История действий над заметкой в АСОИ"
    },
    tableData: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      tableHead: ["Дата и время", "Автор", "Операция", "Адресат", "Комментарий"]
    };
  },
  computed: {
    composedTableData() {
      return !this.tableData || !this.tableData.length ? [] : this.tableData.map((t) => {
        const e = new String(t.comment);
        return e.style = { textAlign: "left" }, [
          on(Tr(t.created_at), "dd.MM.yyyy HH:mm:ss"),
          t.user,
          t.action.name,
          t.recipient,
          e
        ];
      });
    }
  },
  methods: {
    handleEsc(t) {
      t.stopPropagation(), t.preventDefault(), this.close();
    },
    close() {
      this.$emit("update:state", !1);
    }
  }
};
var Che = function() {
  var e = this, n = e._self._c;
  return n("PbModal", { attrs: { state: e.state, title: e.title, "max-width": 800, "content-class": e.$style.root, "data-test-id": "dialog-asoi-history" }, on: { close: e.close } }, [n("div", { class: e.$style.body }, [n("transition", { attrs: { name: "fade", mode: "out-in" } }, [e.isLoading ? n("PbLoader", { class: e.$style.loader }) : n("PbTable", { attrs: { head: e.tableHead, data: e.composedTableData } })], 1)], 1)]);
}, The = [];
const dP = {
  $style: Ehe
};
function Phe(t) {
  for (var e in dP)
    this[e] = dP[e];
}
var khe = /* @__PURE__ */ B(
  xhe,
  Che,
  The,
  !1,
  Phe,
  null
);
const Nhe = khe.exports, $he = "_text_euba1_7", Dhe = "_root_euba1_20", Ahe = "_root_mini_euba1_38", Ohe = "_content_euba1_49", Mhe = "_icon_euba1_56", Rhe = {
  text: $he,
  root: Dhe,
  root_mini: Ahe,
  content: Ohe,
  icon: Mhe
}, Lhe = {
  name: "MainActionButton",
  components: {
    PbButton: nt
  },
  inject: {
    getColorScheme: "getColorScheme",
    isEditorPreview: { default: !1 }
  },
  props: {
    iconName: String,
    disabled: {
      type: Boolean,
      default: !1
    },
    falselyDisabled: {
      // для случаев, когда нужна имитация disable, например, чтобы у заблоченной кнопки отображать тултипы
      type: Boolean,
      default: !1
    },
    buttonStyle: {
      type: Object,
      default: () => ({})
    },
    textStyle: {
      type: Object,
      default: () => ({})
    },
    active: {
      type: Boolean,
      default: !1
    },
    mini: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 24
    },
    isTextHidden: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    rootClass() {
      return {
        "pb-main-action-button": !0,
        [this.$style.root]: !0,
        [this.$style.root_mini]: this.mini,
        [this.$style.root_active]: this.active
      };
    },
    backgroundColor() {
      return `#${this.getColorScheme().accentColor}`;
    }
  },
  methods: {
    handleClick(t) {
      if (this.isEditorPreview) {
        t.stopPropagation(), t.preventDefault();
        return;
      }
      this.$emit("click", t);
    }
  }
};
var Fhe = function() {
  var e = this, n = e._self._c;
  return n("PbButton", { class: e.rootClass, style: { ...e.buttonStyle, ...e.active ? { backgroundColor: e.backgroundColor } : {} }, attrs: { contentClass: e.$style.content, disabled: e.disabled, falselyDisabled: e.falselyDisabled, title: e.title }, on: { click: e.handleClick } }, [e._t("icon", function() {
    return [n("icon", { class: e.$style.icon, attrs: { name: e.iconName, size: e.size } })];
  }), !e.isTextHidden && e.$slots.default ? n("span", { class: e.$style.text, style: e.textStyle }, [e._t("default")], 2) : e._e(), e._t("extension")], 2);
}, Bhe = [];
const fP = {
  $style: Rhe
};
function jhe(t) {
  for (var e in fP)
    this[e] = fP[e];
}
var Whe = /* @__PURE__ */ B(
  Lhe,
  Fhe,
  Bhe,
  !1,
  jhe,
  null
);
const fn = Whe.exports, n2 = /* @__PURE__ */ Iw(iX);
var xa = n2;
xa = "default" in xa ? xa.default : xa;
var Hhe = "2.2.2", Vhe = /^2\./.test(xa.version);
Vhe || xa.util.warn("VueClickaway " + Hhe + " only supports Vue 2.x, and does not support Vue " + xa.version);
var Zc = "_vue_clickaway_handler";
function pP(t, e, n) {
  tR(t, e);
  var r = n.context, s = e.value;
  if (typeof s != "function") {
    process.env.NODE_ENV !== "production" && xa.util.warn(
      "v-" + e.name + '="' + e.expression + '" expects a function value, got ' + s
    );
    return;
  }
  var i = !1;
  setTimeout(function() {
    i = !0;
  }, 0), t[Zc] = function(o) {
    var a = o.path || (o.composedPath ? o.composedPath() : void 0);
    if (i && (a ? a.indexOf(t) < 0 : !t.contains(o.target)))
      return s.call(r, o);
  }, e.arg ? document.documentElement.addEventListener(e.arg, t[Zc], !1) : document.documentElement.addEventListener("click", t[Zc], !1);
}
function tR(t, e) {
  e.arg ? document.documentElement.removeEventListener(e.arg, t[Zc], !1) : document.documentElement.removeEventListener("click", t[Zc], !1), delete t[Zc];
}
var zhe = {
  bind: pP,
  update: function(t, e, n) {
    e.value !== e.oldValue && pP(t, e, n);
  },
  unbind: tR
}, Uhe = {
  directives: { onClickaway: zhe }
}, Vr = Uhe;
const Ghe = "_root_15u4e_1", Yhe = "_header_15u4e_8", Zhe = "_body_15u4e_16", Xhe = "_footer_15u4e_20", Khe = "_button_15u4e_26", Jhe = "_button_primary_15u4e_35", qhe = {
  root: Ghe,
  header: Yhe,
  body: Zhe,
  footer: Xhe,
  button: Khe,
  button_primary: Jhe
}, Qhe = {
  name: "PbDialogDelete",
  mixins: [Vr],
  components: {
    PbButton: nt
  },
  props: {
    state: {
      type: Boolean,
      required: !0
    }
  },
  created() {
    this.$registerShortcut("Escape", this.handleEsc, {
      enabled: !0,
      capture: !0
    }), this.$registerShortcut("Enter", this.handleEnter, {
      enabled: !0,
      capture: !0
    });
  },
  methods: {
    handleEnter(t) {
      if (t.composed) {
        t.stopPropagation(), t.preventDefault(), this.del();
        return;
      }
      return !0;
    },
    handleEsc(t) {
      if (t.composed) {
        t.stopPropagation(), t.preventDefault(), this.close();
        return;
      }
      return !0;
    },
    del() {
      this.$emit("delete"), this.close();
    },
    close() {
      this.$emit("update:state", !1);
    }
  }
};
var eme = function() {
  var e = this, n = e._self._c;
  return n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.close, expression: "close" }], class: e.$style.root, attrs: { "data-test-selector": "dialog-delete" } }, [n("div", { class: e.$style.header, attrs: { "data-test-selector": "dialog-delete-title" } }, [e._t("title", function() {
    return [e._v("Удаление")];
  })], 2), n("div", { class: e.$style.body, attrs: { "data-test-selector": "dialog-delete-text" } }, [e._t("default")], 2), n("div", { class: e.$style.footer, attrs: { "data-test-selector": "dialog-delete-actions" } }, [n("PbButton", { class: [e.$style.button, e.$style.button_primary], attrs: { "data-test-selector": "dialog-delete-accept" }, on: { click: e.del } }, [e._v(" Удалить / В отвал ")]), n("PbButton", { class: e.$style.button, attrs: { "data-test-selector": "dialog-delete-decline" }, on: { click: e.close } }, [e._v(" Отменить действие ")])], 1)]);
}, tme = [];
const hP = {
  $style: qhe
};
function nme(t) {
  for (var e in hP)
    this[e] = hP[e];
}
var rme = /* @__PURE__ */ B(
  Qhe,
  eme,
  tme,
  !1,
  nme,
  null
);
const nR = rme.exports, sme = {
  name: "AsoiNoteDeleteDialog",
  components: { DialogDelete: nR },
  props: {
    open: {
      type: Boolean,
      default: !1
    }
  }
};
var ime = function() {
  var e = this, n = e._self._c;
  return n("transition", { attrs: { name: "fade" } }, [e.open ? n("div", { staticClass: "entry-delete-dialog", attrs: { "data-test-selector": "asoi-entry-delete-dialog" } }, [n("DialogDelete", { attrs: { state: e.open }, on: { "update:state": function(r) {
    return e.$emit("close");
  }, delete: function(r) {
    return e.$emit("confirm");
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [e._v(" Удаление заметки из АСОИ ")];
  }, proxy: !0 }, { key: "default", fn: function() {
    return [e._v(" Вы уверены, что хотите удалить заметку из АСОИ? "), n("br"), e._v(" Она будет удалена без возможности восстановления ")];
  }, proxy: !0 }], null, !1, 4110774278) })], 1) : e._e()]);
}, ome = [], ame = /* @__PURE__ */ B(
  sme,
  ime,
  ome,
  !1,
  null,
  "651eb4d8"
);
const rR = ame.exports, lme = "_root_1i5g0_1", cme = "_root_compact_1i5g0_9", ume = {
  root: lme,
  root_compact: cme
}, dme = {
  name: "PbEntryDate",
  props: {
    attrs: {
      type: Object,
      default: () => ({})
    },
    compact: {
      type: Boolean,
      default: !1
    }
  }
};
var fme = function() {
  var e = this, n = e._self._c;
  return n("span", e._b({ class: { [e.$style.root]: !0, [e.$style.root_compact]: e.compact }, attrs: { "data-test-selector": "entry-date" } }, "span", e.attrs, !1), [e._t("default")], 2);
}, pme = [];
const mP = {
  $style: ume
};
function hme(t) {
  for (var e in mP)
    this[e] = mP[e];
}
var mme = /* @__PURE__ */ B(
  dme,
  fme,
  pme,
  !1,
  hme,
  null
);
const nl = mme.exports, vme = {
  name: "AsoiNoteEntryPanel",
  components: {
    EntryPanel: e2,
    NewsTypeButton: ea,
    DateWidget: Hr,
    AsoiNoteBody: zpe,
    AsoiNotesModalHistory: Nhe,
    MainActionButton: fn,
    AsoiNoteDeleteDialog: rR,
    PbEntryDate: nl
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      default: () => ({})
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loaded: !1,
      loading: !1,
      errors: [],
      isModalHistoryOpen: !1,
      isModalHistoryLoading: !1,
      isDeleteDialogOpen: !1
    };
  },
  computed: {
    ...st({
      panels: (t) => t.panels.data,
      settings: (t) => t.userProfile.newsEditor,
      asoiNoteHistory: (t) => t.asoi.sent.history
    }),
    ...pe("panels", ["getPanelIndex"]),
    ...pe({
      asoiNoteById: "getAsoiNoteById",
      asoiNoteSender: "getAsoiNoteSender",
      asoiNoteAuthors: "getAsoiNoteAuthors",
      asoiNoteRecipientName: "getAsoiNoteRecipientName",
      isEmbargoByNote: "isEmbargoByNote"
    }),
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    userHasPermissions() {
      const t = {
        received: "4.1",
        sent: "4.2",
        embargo: "4.3"
      };
      return this.getIsUserHasAllPermissions([t[this.type]]);
    },
    isEmbargo() {
      return this.isEmbargoByNote(this.note);
    },
    /* Оборачиваем геттеры чтобы прокинуть динамический параметр (тип) */
    getAsoiNoteById() {
      return this.asoiNoteById(this.type);
    },
    getAsoiNoteSender() {
      return this.asoiNoteSender(this.type);
    },
    getAsoiNoteAuthors() {
      return this.asoiNoteAuthors(this.type);
    },
    getAsoiNoteRecipientName() {
      return this.asoiNoteRecipientName(this.type);
    },
    /* --------------------------------------------------------------- */
    type() {
      return this.parent.type ? au(this.parent.type) : au(this.panel.type);
    },
    isPanelTypeSent() {
      return this.type === Mv;
    },
    isPanelTypeEmbargo() {
      return this.parent.type === ve.asoiNotesEmbargo || this.panel.type === ve.asoiNoteEmbargo;
    },
    title() {
      let t = "Пустая заметка";
      return this.note && (this.note.type_id !== 1 && this.note.textHeader ? t = this.note.textHeader : this.note.textBody && (t = this.note.textBody)), this.lastError && (t = this.lastError), t;
    },
    note() {
      return this.getAsoiNoteById(this.panel.dataId) || {};
    },
    sender() {
      if (this.note && this.note.id) {
        const t = this.getAsoiNoteSender(this.note.id);
        if (t && t.name) return this.formatUsername(t.name);
      }
      return null;
    },
    authors() {
      return this.note && this.note.id ? (this.getAsoiNoteAuthors(this.note.id) || []).join(", ") : null;
    },
    recipient() {
      var e;
      if (!((e = this == null ? void 0 : this.note) != null && e.id)) return null;
      const t = this.getAsoiNoteRecipientName(this.note.id);
      return t === null ? null : Array.isArray(t) ? t.map(this.formatUsername) : this.formatUsername(t);
    },
    lastError() {
      return this.errors.length ? this.errors[this.errors.length - 1].title : null;
    },
    // TODO: повтор src/lib/legacy/src/modules/News/NewsItemPanel/mixins/withColorScheme.js
    editorStyle() {
      const t = {};
      return t.fontSize = this.settings.fontSize + "px", this.settings.fontFamily.toLowerCase().indexOf("sans") !== -1 && (t.fontFamily = this.settings.fontFamily + ", PT Sans, Verdana, sans-serif"), this.settings.fontFamily.toLowerCase().indexOf("serif") !== -1 && (t.fontFamily = this.settings.fontFamily + ", Georgia, serif"), t.lineHeight = this.settings.lineHeight / 100 + "em", t;
    },
    canWork() {
      return this.isEmbargo || !this.isEmbargo && this.note.is_allowed;
    },
    canDelete() {
      return !this.isEmbargo && this.note.is_allowed;
    }
  },
  watch: {
    note(t, e) {
      t && t.id !== e.id && (this.errors = []);
    }
  },
  created() {
    this.panel.dataId ? this.fetchData() : this.loaded = !0;
  },
  methods: {
    ...ge([
      "getAsoiNote",
      "loadAsoiNotesSentHistory",
      "pickAsoiNote",
      "deleteAsoiNote"
    ]),
    ...ge("panels", ["setPanelDateMode", "addPanel", "hideSupply"]),
    setDateMode(t) {
      let e = this.parent && this.parent.id ? this.parent.id : this.panel.id;
      this.setPanelDateMode({ panelId: e, mode: t });
    },
    async pick() {
      await this.pickAsoiNote({ note: this.note }), this.$refs.entryPanel.close({ focus: !1 }), this.hideNotesSupply();
    },
    openRemoveDialog() {
      this.isDeleteDialogOpen = !0;
    },
    remove() {
      this.deleteAsoiNote(this.note), this.$refs.entryPanel.close({ focus: !1 }), this.hideNotesSupply();
    },
    openPanel() {
      const e = {
        received: ve.asoiNote,
        sent: ve.asoiNoteSent,
        embargo: ve.asoiNoteEmbargo
      }[this.type];
      this.addPanel({
        panel: { type: e, dataId: this.note.id },
        position: this.getPanelIndex(this.parent.id)
      });
    },
    async openRecipientHistory(t, e) {
      this.isModalHistoryOpen = !0, this.isModalHistoryLoading = !0, await this.loadAsoiNotesSentHistory({
        id: this.note.id,
        recepientId: t,
        isGroup: e
      }), this.isModalHistoryLoading = !1;
    },
    hideNotesSupply() {
      const t = this.panels.find(({ type: e }) => e === ve.asoiNotes);
      t && t.supply && t.supply.right[0].dataId === this.panel.dataId && this.hideSupply({
        panelId: t.id,
        supplyId: t.supply.right[0].id
      });
    },
    async fetchData() {
      this.loaded = !1, this.loading = !0;
      let t = this.note;
      return (!this.note || !this.note.id) && (t = await this.getAsoiNote({
        id: this.panel.dataId,
        isOutgoingPanel: this.isPanelTypeSent
      })), t.errors && (this.errors = t.errors), this.loaded = !0, this.loading = !1, t;
    }
  }
};
var gme = function() {
  var e = this, n = e._self._c;
  return n("EntryPanel", { ref: "entryPanel", attrs: { title: e.title, entry: e.note, panel: e.panel, parent: e.parent, loading: !e.loaded, error: e.lastError, contentTitle: e.note.headline || e.note.body, isFocused: e.isFocused, resizeable: !1, "data-test-attrs": `entry-id__${e.panel.dataId}`, userHasPermissions: e.userHasPermissions }, scopedSlots: e._u([e.note && e.note.id ? { key: "appbar-extension", fn: function() {
    return [n("NewsTypeButton", { attrs: { typeId: e.note.type_id, active: !1, disabled: !0, showLabel: !0, "data-test-selector": "panel-asoi-note-type-button", "data-test-id": e.note.type_id, "data-test-attrs": `type__${e.note.type_id}` } }), e.isEmbargo ? e.note.publish_at ? n("PbEntryDate", { staticClass: "date entry-date" }, [n("pre", [e._v("До ")]), n("DateWidget", { attrs: { date: e.note.publish_at, mode: e.panel.settings.dateMode }, on: { dateModeChanged: e.setDateMode } })], 1) : n("div", { staticClass: "date entry-date" }, [n("span", [e._v("До звонка")])]) : n("DateWidget", { staticClass: "entry-date", attrs: { date: e.note.created_at, mode: e.panel.settings.dateMode, "data-test-selector": "panel-asoi-note-date" }, on: { dateModeChanged: e.setDateMode } })];
  }, proxy: !0 } : null, { key: "contentHeader", fn: function() {
    return [n("div", { staticClass: "entry-header" }, [n("div", { staticClass: "entry-users", attrs: { "data-test-selector": "panel-asoi-note-users" } }, [e.isEmbargo && e.sender ? n("div", { staticClass: "entry-users__sender" }, [e._v(" Редактор: " + e._s(e.sender) + " ")]) : e.sender ? n("div", { staticClass: "entry-users__sender" }, [e._v(" От: " + e._s(e.sender) + " ")]) : e._e(), !e.isEmbargo && e.recipient ? n("div", { staticClass: "entry-users__recipient" }, [n("span", [e._v("Кому: ")]), e.isPanelTypeSent ? n("span", [e._l(e.recipient, function(r) {
      return n("span", { key: r.id, staticClass: "entry-recipient", on: { click: function(s) {
        return e.openRecipientHistory(r.id, r.isGroup);
      } } }, [e._v(" " + e._s(e.formatUsername(r.name)) + " ")]);
    }), n("AsoiNotesModalHistory", { attrs: { state: e.isModalHistoryOpen, "is-loading": e.isModalHistoryLoading, "table-data": e.asoiNoteHistory }, on: { "update:state": function(r) {
      e.isModalHistoryOpen = r;
    } } })], 2) : n("span", [e._v(e._s(e.recipient))])]) : e._e()]), (e.isPanelTypeSent || e.isPanelTypeEmbargo) && e.authors ? n("div", { staticClass: "entry-authors", attrs: { "data-test-selector": "panel-asoi-note-authors" } }, [e._v(" Авторы: " + e._s(e.authors) + " ")]) : e._e(), e.note.comment ? n("div", { staticClass: "entry-comment", attrs: { "data-test-selector": "panel-asoi-note-comment" } }, [e._v(" Комментарий: "), n("br"), e._v(" " + e._s(e.note.comment) + " ")]) : e._e()])];
  }, proxy: !0 }, { key: "tabContent", fn: function() {
    return [n("AsoiNoteBody", { style: e.editorStyle, attrs: { entry: e.note, loaded: e.loaded, isFocused: e.isFocused, "data-test-selector": "panel-asoi-note-content" } })];
  }, proxy: !0 }, !e.lastError && e.userHasPermissions ? { key: "entryFooter", fn: function() {
    return [n("div", { staticClass: "entry-panel-footer" }, [e.note ? n("div", { staticClass: "entry-panel-footer-row", style: { "background-color": "#" + e.panel.settings.color } }, [!e.isPanelTypeSent && !e.note.is_deleted ? [e.canWork ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "button-add" }, on: { click: e.pick } }, [e._v(" Взять в работу ")]) : e._e(), e.canDelete ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-trash", "data-test-selector": "button-remove" }, on: { click: e.openRemoveDialog } }, [e._v(" Удалить ")]) : e._e()] : e._e(), e.parent.id ? n("MainActionButton", { staticClass: "mini-button show-more pb-action-button-old", attrs: { iconName: "button-icon-show-more", title: "Открыть в отдельной панели", "data-test-selector": "button-show-more" }, on: { click: e.openPanel } }) : e._e()], 2) : e._e()])];
  }, proxy: !0 } : null, { key: "entryDialogs", fn: function() {
    return [n("AsoiNoteDeleteDialog", { attrs: { open: e.isDeleteDialogOpen }, on: { close: function(r) {
      e.isDeleteDialogOpen = !1;
    }, confirm: e.remove } })];
  }, proxy: !0 }], null, !0) });
}, yme = [], bme = /* @__PURE__ */ B(
  vme,
  gme,
  yme,
  !1,
  null,
  "85087252"
);
const Dy = bme.exports, _me = "_root_g0369_1", wme = "_icon_g0369_17", Sme = "_menu_g0369_22", Ime = "_content_g0369_36", Eme = "_item_g0369_41", xme = "_item_disabled_g0369_61", Cme = "_item_inactive_g0369_66", Tme = "_label_g0369_73", Pme = "_remove_g0369_77", kme = "_removeButton_g0369_84", Nme = "_subheader_g0369_89", $me = "_divider_g0369_96", Dme = {
  root: _me,
  icon: wme,
  menu: Sme,
  content: Ime,
  item: Eme,
  item_disabled: xme,
  item_inactive: Cme,
  label: Tme,
  remove: Pme,
  removeButton: kme,
  subheader: Nme,
  divider: $me
}, Ame = {
  name: "PanelMenu",
  components: {
    PbButton: nt
  },
  props: {
    items: Array,
    trigger: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#ffffff"
    },
    elementsColor: {
      type: String,
      default: "#ffffff"
    }
  },
  computed: {
    ...st({
      windowParams: (t) => t.uiState.windowParams
    }),
    itemClass() {
      return (t) => ({
        [this.$style.item]: !0,
        [this.$style.item_inactive]: t.inactive,
        [this.$style.item_disabled]: !t.enabled
      });
    },
    maxHeight() {
      return this.windowParams.height - 200 + "px";
    }
  },
  mounted() {
    document.addEventListener("mousedown", this.hide);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.hide);
  },
  methods: {
    handler(t) {
      t.handler && (t.enabled && t.handler(), this.hide());
    },
    hide(t) {
      if (t) {
        const e = t.target.closest('[data-role="menu-toggle"]'), n = t.target.closest('[data-role="menu-remove"]');
        if (e || n) return;
      }
      this.trigger && this.$emit("update:trigger", !1);
    }
  }
};
var Ome = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, "draggable-ignore"], style: {
    color: e.trigger ? e.color : e.elementsColor,
    "background-color": e.trigger ? e.elementsColor : e.color,
    "border-color": e.elementsColor
  }, attrs: { "data-test-selector": "panel-menu", "data-role": "menu-toggle" } }, [n("PbButton", { class: e.$style.icon, attrs: { round: "", "data-test-selector": "panel-menu-button" }, on: { click: function(r) {
    return r.preventDefault(), e.$emit("update:trigger", !e.trigger);
  } } }, [n("icon", { attrs: { type: "font", name: "menu", size: "16" } })], 1), n("transition", { attrs: { name: "slide-y-down" } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.trigger, expression: "trigger" }], class: e.$style.menu, style: { maxHeight: e.maxHeight } }, [n("div", { class: e.$style.content }, [e._l(e.items, function(r, s) {
    return [e._t("menuElement", function() {
      return [r.divider ? n("hr", { key: s, class: e.$style.divider }) : r.subheader ? n("div", { key: s, class: e.$style.subheader, attrs: { "data-test-selector": "panel-menu-item", "data-test-id": r.id, "data-test-attrs": `item__subheader item-code__${r.code} item-id__${r.id}` } }, [e._v(" " + e._s(r.label) + " ")]) : n("div", { key: s, class: e.itemClass(r), attrs: { "data-test-selector": "panel-menu-item", "data-test-attrs": `item-code__${r.code} item-id__${r.id}` }, on: { click: function(i) {
        return i.stopPropagation(), i.preventDefault(), e.handler(r);
      } } }, [n("span", { class: e.$style.label }, [e._v(e._s(r.label))]), r.is_removable ? n("span", { class: e.$style.remove, attrs: { "data-role": "menu-remove" } }, [n("PbButton", { class: e.$style.removeButton, attrs: { round: "", "data-test-selector": "panel-menu-item-remove" }, on: { click: function(i) {
        return i.preventDefault(), i.stopPropagation(), e.$emit("remove", r.id);
      } } }, [n("icon", { attrs: { name: "close", size: "7" } })], 1)], 1) : e._e()])];
    }, { item: r, index: s, elStyle: e.$style })];
  })], 2)])]), e._t("default")], 2);
}, Mme = [];
const vP = {
  $style: Dme
};
function Rme(t) {
  for (var e in vP)
    this[e] = vP[e];
}
var Lme = /* @__PURE__ */ B(
  Ame,
  Ome,
  Mme,
  !1,
  Rme,
  null
);
const Rv = Lme.exports;
function Fme(t, e, n) {
  var r = -1, s = t.length;
  e < 0 && (e = -e > s ? 0 : s + e), n = n > s ? s : n, n < 0 && (n += s), s = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var i = Array(s); ++r < s; )
    i[r] = t[r + e];
  return i;
}
var Bme = Fme, jme = Bme;
function Wme(t, e, n) {
  var r = t.length;
  return n = n === void 0 ? r : n, !e && n >= r ? t : jme(t, e, n);
}
var Hme = Wme, Vme = "\\ud800-\\udfff", zme = "\\u0300-\\u036f", Ume = "\\ufe20-\\ufe2f", Gme = "\\u20d0-\\u20ff", Yme = zme + Ume + Gme, Zme = "\\ufe0e\\ufe0f", Xme = "\\u200d", Kme = RegExp("[" + Xme + Vme + Yme + Zme + "]");
function Jme(t) {
  return Kme.test(t);
}
var sR = Jme;
function qme(t) {
  return t.split("");
}
var Qme = qme, iR = "\\ud800-\\udfff", eve = "\\u0300-\\u036f", tve = "\\ufe20-\\ufe2f", nve = "\\u20d0-\\u20ff", rve = eve + tve + nve, sve = "\\ufe0e\\ufe0f", ive = "[" + iR + "]", j0 = "[" + rve + "]", W0 = "\\ud83c[\\udffb-\\udfff]", ove = "(?:" + j0 + "|" + W0 + ")", oR = "[^" + iR + "]", aR = "(?:\\ud83c[\\udde6-\\uddff]){2}", lR = "[\\ud800-\\udbff][\\udc00-\\udfff]", ave = "\\u200d", cR = ove + "?", uR = "[" + sve + "]?", lve = "(?:" + ave + "(?:" + [oR, aR, lR].join("|") + ")" + uR + cR + ")*", cve = uR + cR + lve, uve = "(?:" + [oR + j0 + "?", j0, aR, lR, ive].join("|") + ")", dve = RegExp(W0 + "(?=" + W0 + ")|" + uve + cve, "g");
function fve(t) {
  return t.match(dve) || [];
}
var pve = fve, hve = Qme, mve = sR, vve = pve;
function gve(t) {
  return mve(t) ? vve(t) : hve(t);
}
var yve = gve, bve = Hme, _ve = sR, wve = yve, Sve = Lf;
function Ive(t) {
  return function(e) {
    e = Sve(e);
    var n = _ve(e) ? wve(e) : void 0, r = n ? n[0] : e.charAt(0), s = n ? bve(n, 1).join("") : e.slice(1);
    return r[t]() + s;
  };
}
var Eve = Ive, xve = Eve, Cve = xve("toUpperCase"), dR = Cve;
const Tve = /* @__PURE__ */ Et(dR);
var Pve = Lf, kve = dR;
function Nve(t) {
  return kve(Pve(t).toLowerCase());
}
var $ve = Nve;
const fR = /* @__PURE__ */ Et($ve), Lv = {
  name: "WithTwoWayLoading",
  props: {
    fetchData: {
      type: Function,
      required: !0
    },
    entryGetter: {
      type: Function,
      default: (t) => t
    },
    hasNew: {
      type: Boolean,
      default: !1
    },
    hasSelected: {
      type: Boolean,
      default: !1
    },
    isPaused: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    initialLoaded: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 90
    },
    entries: {
      type: Array,
      default: () => []
    },
    cursorField: {
      type: String,
      required: !0
    },
    scrollToUnread: {
      type: Function,
      required: !0
    },
    emptyText: {
      type: String,
      default: "Пусто"
    },
    limit: {
      type: Number,
      default: 30
    },
    showSpinnerOnSequentialLoads: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      loaded: !1,
      initialLoading: !0,
      sequentialLoading: !1
    };
  },
  watch: {
    initialLoaded(t, e) {
      t !== e && !t && this.active && (this.initialLoading = !0, this.initialLoad(!0));
    },
    active(t, e) {
      t !== e && t && (this.initialLoaded || this.initialLoad(!0));
    }
  },
  created() {
    this.active && !this.initialLoaded && this.initialLoad();
  },
  methods: {
    async initialLoad(t = !1) {
      this.cursorPrev = null, this.cursorNext = null, this.loaded = !1, await this.loadPrev({ force: t, replace: !0 }), this.$emit("initialLoaded", !0), this.$emit("setPaused", !1), this.$emit("setHasNew", !1);
    },
    async refresh(t = !0) {
      t && (this.sequentialLoading = !0);
      const e = await this.fetchData({
        limit: this.limit,
        reverse: !1,
        replace: !0
      });
      e && (this.cursorPrev = e.next_cursor, this.cursorNext = null, this.loaded = e.next_cursor === null, this.$emit("setPaused", !1), this.$emit("setHasNew", !1), this.scrollToUnread()), t && (this.sequentialLoading = !1);
    },
    async loadNext() {
      if (!this.loading)
        if (this.isPaused && this.hasNew) {
          this.loaded = !1, this.loading = !0;
          const t = this.entryGetter(this.entries[0].id);
          this.cursorNext = t[this.cursorField];
          const e = await this.fetchData({
            cursor: this.cursorNext,
            limit: this.limit + 1,
            // первый ИП в списке загрузится повторно + новые ИП
            reverse: !0
          });
          if (this.cursorNext = e.next_cursor, this.cursorNext === null && (this.$emit("setPaused", !1), this.$emit("setHasNew", !1)), this.cursorNext = e.next_cursor, this.entries.length >= this.maxLength) {
            const n = this.entries[this.entries.length - 1];
            n && (this.cursorPrev = this.entryGetter(n.id)[this.cursorField]);
          }
          this.$emit("scrollToEntry", t), this.$nextTick(() => {
            this.loading = !1;
          });
        } else this.isPaused && this.$emit("setPaused", !1);
    },
    async loadPrev({ force: t = !1, replace: e = !1 } = {}) {
      if (this.loading || this.loaded && !t) return;
      this.loaded = !1, this.loading = !0;
      const n = await this.fetchData({
        cursor: this.cursorPrev,
        limit: this.limit,
        reverse: !1,
        replace: e
      });
      this.initialLoading && (this.initialLoading = !1), n.data && (this.loaded = n.next_cursor === null, this.cursorPrev = n.next_cursor, this.entries.length >= this.maxLength ? this.$emit("setPaused", !0) : this.$emit("setPaused", !1), this.loading = !1);
    }
  },
  render(t) {
    const e = this.emptyText;
    return this.initialLoading || this.sequentialLoading ? t(br, {
      props: {
        size: 50
      }
    }) : this.entries.length ? this.$scopedSlots.default({
      loadNext: this.loadNext,
      loadPrev: this.loadPrev,
      refresh: this.refresh,
      paused: this.isPaused,
      hasNew: this.hasNew,
      loaded: this.loaded,
      loading: this.loading,
      entries: this.entries
    }) : t(
      "h3",
      {
        class: {
          empty: !0
        }
      },
      [e]
    );
  }
};
function Dve() {
  var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
  if (e > 0)
    return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
  var n = t.indexOf("Trident/");
  if (n > 0) {
    var r = t.indexOf("rv:");
    return parseInt(t.substring(r + 3, t.indexOf(".", r)), 10);
  }
  var s = t.indexOf("Edge/");
  return s > 0 ? parseInt(t.substring(s + 5, t.indexOf(".", s)), 10) : -1;
}
var ph = void 0;
function H0() {
  H0.init || (H0.init = !0, ph = Dve() !== -1);
}
var V0 = {
  render: function() {
    var e = this, n = e.$createElement, r = e._self._c || n;
    return r("div", { staticClass: "resize-observer", attrs: { tabindex: "-1" } });
  },
  staticRenderFns: [],
  _scopeId: "data-v-b329ee4c",
  name: "resize-observer",
  methods: {
    compareAndNotify: function() {
      (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.$emit("notify"));
    },
    addResizeHandlers: function() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers: function() {
      this._resizeObject && this._resizeObject.onload && (!ph && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), delete this._resizeObject.onload);
    }
  },
  mounted: function() {
    var e = this;
    H0(), this.$nextTick(function() {
      e._w = e.$el.offsetWidth, e._h = e.$el.offsetHeight;
    });
    var n = document.createElement("object");
    this._resizeObject = n, n.setAttribute("aria-hidden", "true"), n.setAttribute("tabindex", -1), n.onload = this.addResizeHandlers, n.type = "text/html", ph && this.$el.appendChild(n), n.data = "about:blank", ph || this.$el.appendChild(n);
  },
  beforeDestroy: function() {
    this.removeResizeHandlers();
  }
};
function Ave(t) {
  t.component("resize-observer", V0), t.component("ResizeObserver", V0);
}
var Ove = {
  // eslint-disable-next-line no-undef
  version: "0.4.5",
  install: Ave
}, Tm = null;
typeof window < "u" ? Tm = window.Vue : typeof global < "u" && (Tm = global.Vue);
Tm && Tm.use(Ove);
function hh(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hh = function(e) {
    return typeof e;
  } : hh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, hh(t);
}
function Mve(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Rve(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Lve(t, e, n) {
  return e && Rve(t.prototype, e), t;
}
function gP(t) {
  return Fve(t) || Bve(t) || jve();
}
function Fve(t) {
  if (Array.isArray(t)) {
    for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
    return n;
  }
}
function Bve(t) {
  if (Symbol.iterator in Object(t) || Object.prototype.toString.call(t) === "[object Arguments]") return Array.from(t);
}
function jve() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function Wve(t) {
  var e;
  return typeof t == "function" ? e = {
    callback: t
  } : e = t, e;
}
function Hve(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, s, i, o = function(l) {
    for (var c = arguments.length, u = new Array(c > 1 ? c - 1 : 0), d = 1; d < c; d++)
      u[d - 1] = arguments[d];
    if (i = u, !(r && l === s)) {
      var f = n.leading;
      typeof f == "function" && (f = f(l, s)), (!r || l !== s) && f && t.apply(void 0, [l].concat(gP(i))), s = l, clearTimeout(r), r = setTimeout(function() {
        t.apply(void 0, [l].concat(gP(i))), r = 0;
      }, e);
    }
  };
  return o._clear = function() {
    clearTimeout(r), r = null;
  }, o;
}
function pR(t, e) {
  if (t === e) return !0;
  if (hh(t) === "object") {
    for (var n in t)
      if (!pR(t[n], e[n]))
        return !1;
    return !0;
  }
  return !1;
}
var Vve = /* @__PURE__ */ function() {
  function t(e, n, r) {
    Mve(this, t), this.el = e, this.observer = null, this.frozen = !1, this.createObserver(n, r);
  }
  return Lve(t, [{
    key: "createObserver",
    value: function(n, r) {
      var s = this;
      if (this.observer && this.destroyObserver(), !this.frozen) {
        if (this.options = Wve(n), this.callback = function(a, l) {
          s.options.callback(a, l), a && s.options.once && (s.frozen = !0, s.destroyObserver());
        }, this.callback && this.options.throttle) {
          var i = this.options.throttleOptions || {}, o = i.leading;
          this.callback = Hve(this.callback, this.options.throttle, {
            leading: function(l) {
              return o === "both" || o === "visible" && l || o === "hidden" && !l;
            }
          });
        }
        this.oldResult = void 0, this.observer = new IntersectionObserver(function(a) {
          var l = a[0];
          if (a.length > 1) {
            var c = a.find(function(d) {
              return d.isIntersecting;
            });
            c && (l = c);
          }
          if (s.callback) {
            var u = l.isIntersecting && l.intersectionRatio >= s.threshold;
            if (u === s.oldResult) return;
            s.oldResult = u, s.callback(u, l);
          }
        }, this.options.intersection), r.context.$nextTick(function() {
          s.observer && s.observer.observe(s.el);
        });
      }
    }
  }, {
    key: "destroyObserver",
    value: function() {
      this.observer && (this.observer.disconnect(), this.observer = null), this.callback && this.callback._clear && (this.callback._clear(), this.callback = null);
    }
  }, {
    key: "threshold",
    get: function() {
      return this.options.intersection && this.options.intersection.threshold || 0;
    }
  }]), t;
}();
function hR(t, e, n) {
  var r = e.value;
  if (r)
    if (typeof IntersectionObserver > "u")
      console.warn("[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill");
    else {
      var s = new Vve(t, r, n);
      t._vue_visibilityState = s;
    }
}
function zve(t, e, n) {
  var r = e.value, s = e.oldValue;
  if (!pR(r, s)) {
    var i = t._vue_visibilityState;
    if (!r) {
      mR(t);
      return;
    }
    i ? i.createObserver(r, n) : hR(t, {
      value: r
    }, n);
  }
}
function mR(t) {
  var e = t._vue_visibilityState;
  e && (e.destroyObserver(), delete t._vue_visibilityState);
}
var vR = {
  bind: hR,
  update: zve,
  unbind: mR
};
function Uve(t) {
  t.directive("observe-visibility", vR);
}
var gR = {
  // eslint-disable-next-line no-undef
  version: "0.4.6",
  install: Uve
}, Pm = null;
typeof window < "u" ? Pm = window.Vue : typeof global < "u" && (Pm = global.Vue);
Pm && Pm.use(gR);
var yR = { exports: {} };
(function(t) {
  (function(e, n) {
    t.exports ? t.exports = n() : e.Scrollparent = n();
  })(vr, function() {
    function e(r) {
      var s = getComputedStyle(r, null).getPropertyValue("overflow");
      return s.indexOf("scroll") > -1 || s.indexOf("auto") > -1;
    }
    function n(r) {
      if (r instanceof HTMLElement || r instanceof SVGElement) {
        for (var s = r.parentNode; s.parentNode; ) {
          if (e(s))
            return s;
          s = s.parentNode;
        }
        return document.scrollingElement || document.documentElement;
      }
    }
    return n;
  });
})(yR);
var Gve = yR.exports;
const Yve = /* @__PURE__ */ Et(Gve);
var bR = {
  itemsLimit: 1e3
};
function mh(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mh = function(e) {
    return typeof e;
  } : mh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mh(t);
}
function Zve(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function yP(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function km(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yP(Object(n), !0).forEach(function(r) {
      Zve(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : yP(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Xve(t, e) {
  if (t) {
    if (typeof t == "string") return bP(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bP(t, e);
  }
}
function bP(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Kve(t, e) {
  var n;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (n = Xve(t)) || e) {
      n && (t = n);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, o = !1, a;
  return {
    s: function() {
      n = t[Symbol.iterator]();
    },
    n: function() {
      var l = n.next();
      return i = l.done, l;
    },
    e: function(l) {
      o = !0, a = l;
    },
    f: function() {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw a;
      }
    }
  };
}
var _R = {
  items: {
    type: Array,
    required: !0
  },
  keyField: {
    type: String,
    default: "id"
  },
  direction: {
    type: String,
    default: "vertical",
    validator: function(e) {
      return ["vertical", "horizontal"].includes(e);
    }
  }
};
function wR() {
  return this.items.length && mh(this.items[0]) !== "object";
}
var z0 = !1;
if (typeof window < "u") {
  z0 = !1;
  try {
    var Jve = Object.defineProperty({}, "passive", {
      get: function() {
        z0 = !0;
      }
    });
    window.addEventListener("test", null, Jve);
  } catch {
  }
}
var qve = 0, Qve = {
  name: "RecycleScroller",
  components: {
    ResizeObserver: V0
  },
  directives: {
    ObserveVisibility: vR
  },
  props: km(km({}, _R), {}, {
    itemSize: {
      type: Number,
      default: null
    },
    minItemSize: {
      type: [Number, String],
      default: null
    },
    sizeField: {
      type: String,
      default: "size"
    },
    typeField: {
      type: String,
      default: "type"
    },
    buffer: {
      type: Number,
      default: 200
    },
    pageMode: {
      type: Boolean,
      default: !1
    },
    prerender: {
      type: Number,
      default: 0
    },
    emitUpdate: {
      type: Boolean,
      default: !1
    }
  }),
  data: function() {
    return {
      pool: [],
      totalSize: 0,
      ready: !1,
      hoverKey: null
    };
  },
  computed: {
    sizes: function() {
      if (this.itemSize === null) {
        for (var e = {
          "-1": {
            accumulator: 0
          }
        }, n = this.items, r = this.sizeField, s = this.minItemSize, i = 1e4, o = 0, a, l = 0, c = n.length; l < c; l++)
          a = n[l][r] || s, a < i && (i = a), o += a, e[l] = {
            accumulator: o,
            size: a
          };
        return this.$_computedMinItemSize = i, e;
      }
      return [];
    },
    simpleArray: wR
  },
  watch: {
    items: function() {
      this.updateVisibleItems(!0);
    },
    pageMode: function() {
      this.applyPageMode(), this.updateVisibleItems(!1);
    },
    sizes: {
      handler: function() {
        this.updateVisibleItems(!1);
      },
      deep: !0
    }
  },
  created: function() {
    this.$_startIndex = 0, this.$_endIndex = 0, this.$_views = /* @__PURE__ */ new Map(), this.$_unusedViews = /* @__PURE__ */ new Map(), this.$_scrollDirty = !1, this.$_lastUpdateScrollPosition = 0, this.prerender && (this.$_prerender = !0, this.updateVisibleItems(!1));
  },
  mounted: function() {
    var e = this;
    this.applyPageMode(), this.$nextTick(function() {
      e.$_prerender = !1, e.updateVisibleItems(!0), e.ready = !0;
    });
  },
  updated: function() {
    this.$refs.wrapper && (this.$refs.wrapper.style[this.direction === "vertical" ? "minHeight" : "minWidth"] = this.totalSize + "px");
  },
  beforeDestroy: function() {
    this.removeListeners();
  },
  methods: {
    addView: function(e, n, r, s, i) {
      var o = {
        item: r,
        position: 0
      }, a = {
        id: qve++,
        index: n,
        used: !0,
        key: s,
        type: i
      };
      return Object.defineProperty(o, "nr", {
        configurable: !1,
        value: a
      }), e.push(o), o;
    },
    unuseView: function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = this.$_unusedViews, s = e.nr.type, i = r.get(s);
      i || (i = [], r.set(s, i)), i.push(e), n || (e.nr.used = !1, e.position = -9999, this.$_views.delete(e.nr.key));
    },
    handleResize: function() {
      this.$emit("resize"), this.ready && this.updateVisibleItems(!1);
    },
    handleScroll: function(e) {
      var n = this;
      this.$_scrollDirty || (this.$_scrollDirty = !0, requestAnimationFrame(function() {
        n.$_scrollDirty = !1;
        var r = n.updateVisibleItems(!1, !0), s = r.continuous;
        s || (clearTimeout(n.$_refreshTimout), n.$_refreshTimout = setTimeout(n.handleScroll, 100));
      }));
    },
    handleVisibilityChange: function(e, n) {
      var r = this;
      this.ready && (e || n.boundingClientRect.width !== 0 || n.boundingClientRect.height !== 0 ? (this.$emit("visible"), requestAnimationFrame(function() {
        r.updateVisibleItems(!1);
      })) : this.$emit("hidden"));
    },
    updateVisibleItems: function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = this.itemSize, s = this.$_computedMinItemSize, i = this.typeField, o = this.simpleArray ? null : this.keyField, a = this.items, l = a.length, c = this.sizes, u = this.$_views, d = this.$_unusedViews, f = this.pool, p, h, m;
      if (!l)
        p = h = m = 0;
      else if (this.$_prerender)
        p = 0, h = this.prerender, m = null;
      else {
        var v = this.getScroll();
        if (n) {
          var y = v.start - this.$_lastUpdateScrollPosition;
          if (y < 0 && (y = -y), r === null && y < s || y < r)
            return {
              continuous: !0
            };
        }
        this.$_lastUpdateScrollPosition = v.start;
        var _ = this.buffer;
        if (v.start -= _, v.end += _, r === null) {
          var w, S = 0, E = l - 1, x = ~~(l / 2), T;
          do
            T = x, w = c[x].accumulator, w < v.start ? S = x : x < l - 1 && c[x + 1].accumulator > v.start && (E = x), x = ~~((S + E) / 2);
          while (x !== T);
          for (x < 0 && (x = 0), p = x, m = c[l - 1].accumulator, h = x; h < l && c[h].accumulator < v.end; h++)
            ;
          h === -1 ? h = a.length - 1 : (h++, h > l && (h = l));
        } else
          p = ~~(v.start / r), h = Math.ceil(v.end / r), p < 0 && (p = 0), h > l && (h = l), m = l * r;
      }
      h - p > bR.itemsLimit && this.itemsLimitError(), this.totalSize = m;
      var C, k = p <= this.$_endIndex && h >= this.$_startIndex;
      if (this.$_continuous !== k) {
        if (k) {
          u.clear(), d.clear();
          for (var b = 0, P = f.length; b < P; b++)
            C = f[b], this.unuseView(C);
        }
        this.$_continuous = k;
      } else if (k)
        for (var N = 0, D = f.length; N < D; N++)
          C = f[N], C.nr.used && (e && (C.nr.index = a.findIndex(function(V) {
            return o ? V[o] === C.item[o] : V === C.item;
          })), (C.nr.index === -1 || C.nr.index < p || C.nr.index >= h) && this.unuseView(C));
      for (var H = k ? null : /* @__PURE__ */ new Map(), Y, te, A, j, L = p; L < h; L++) {
        Y = a[L];
        var se = o ? Y[o] : Y;
        if (se == null)
          throw new Error("Key is ".concat(se, " on item (keyField is '").concat(o, "')"));
        if (C = u.get(se), !r && !c[L].size) {
          C && this.unuseView(C);
          continue;
        }
        C ? (C.nr.used = !0, C.item = Y) : (te = Y[i], A = d.get(te), k ? A && A.length ? (C = A.pop(), C.item = Y, C.nr.used = !0, C.nr.index = L, C.nr.key = se, C.nr.type = te) : C = this.addView(f, L, Y, se, te) : (j = H.get(te) || 0, (!A || j >= A.length) && (C = this.addView(f, L, Y, se, te), this.unuseView(C, !0), A = d.get(te)), C = A[j], C.item = Y, C.nr.used = !0, C.nr.index = L, C.nr.key = se, C.nr.type = te, H.set(te, j + 1), j++), u.set(se, C)), r === null ? C.position = c[L - 1].accumulator : C.position = L * r;
      }
      return this.$_startIndex = p, this.$_endIndex = h, this.emitUpdate && this.$emit("update", p, h), clearTimeout(this.$_sortTimer), this.$_sortTimer = setTimeout(this.sortViews, 300), {
        continuous: k
      };
    },
    getListenerTarget: function() {
      var e = Yve(this.$el);
      return window.document && (e === window.document.documentElement || e === window.document.body) && (e = window), e;
    },
    getScroll: function() {
      var e = this.$el, n = this.direction, r = n === "vertical", s;
      if (this.pageMode) {
        var i = e.getBoundingClientRect(), o = r ? i.height : i.width, a = -(r ? i.top : i.left), l = r ? window.innerHeight : window.innerWidth;
        a < 0 && (l += a, a = 0), a + l > o && (l = o - a), s = {
          start: a,
          end: a + l
        };
      } else r ? s = {
        start: e.scrollTop,
        end: e.scrollTop + e.clientHeight
      } : s = {
        start: e.scrollLeft,
        end: e.scrollLeft + e.clientWidth
      };
      return s;
    },
    applyPageMode: function() {
      this.pageMode ? this.addListeners() : this.removeListeners();
    },
    addListeners: function() {
      this.listenerTarget = this.getListenerTarget(), this.listenerTarget.addEventListener("scroll", this.handleScroll, z0 ? {
        passive: !0
      } : !1), this.listenerTarget.addEventListener("resize", this.handleResize);
    },
    removeListeners: function() {
      this.listenerTarget && (this.listenerTarget.removeEventListener("scroll", this.handleScroll), this.listenerTarget.removeEventListener("resize", this.handleResize), this.listenerTarget = null);
    },
    scrollToItem: function(e) {
      var n;
      this.itemSize === null ? n = e > 0 ? this.sizes[e - 1].accumulator : 0 : n = e * this.itemSize, this.scrollToPosition(n);
    },
    scrollToPosition: function(e) {
      this.direction === "vertical" ? this.$el.scrollTop = e : this.$el.scrollLeft = e;
    },
    itemsLimitError: function() {
      var e = this;
      throw setTimeout(function() {
        console.log("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", e.$el), console.log("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
      }), new Error("Rendered items limit reached");
    },
    sortViews: function() {
      this.pool.sort(function(e, n) {
        return e.nr.index - n.nr.index;
      });
    }
  }
};
function r2(t, e, n, r, s, i, o, a, l, c) {
  const u = typeof n == "function" ? n.options : n;
  return t && t.render && (u.render = t.render, u.staticRenderFns = t.staticRenderFns, u._compiled = !0, s && (u.functional = !0)), n;
}
const ege = Qve;
var SR = function() {
  var t, e = this, n = e.$createElement, r = e._self._c || n;
  return r(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: e.handleVisibilityChange,
          expression: "handleVisibilityChange"
        }
      ],
      staticClass: "vue-recycle-scroller",
      class: (t = {
        ready: e.ready,
        "page-mode": e.pageMode
      }, t["direction-" + e.direction] = !0, t),
      on: {
        "&scroll": function(s) {
          return e.handleScroll(s);
        }
      }
    },
    [
      e.$slots.before ? r(
        "div",
        { staticClass: "vue-recycle-scroller__slot" },
        [e._t("before")],
        2
      ) : e._e(),
      e._v(" "),
      r(
        "div",
        { ref: "wrapper", staticClass: "vue-recycle-scroller__item-wrapper" },
        e._l(e.pool, function(s) {
          return r(
            "div",
            {
              key: s.nr.id,
              staticClass: "vue-recycle-scroller__item-view",
              class: { hover: e.hoverKey === s.nr.key },
              style: e.ready ? {
                transform: "translate" + (e.direction === "vertical" ? "Y" : "X") + "(" + s.position + "px)"
              } : null,
              on: {
                mouseenter: function(i) {
                  e.hoverKey = s.nr.key;
                },
                mouseleave: function(i) {
                  e.hoverKey = null;
                }
              }
            },
            [
              e._t("default", null, {
                item: s.item,
                index: s.nr.index,
                active: s.nr.used
              })
            ],
            2
          );
        }),
        0
      ),
      e._v(" "),
      e.$slots.after ? r(
        "div",
        { staticClass: "vue-recycle-scroller__slot" },
        [e._t("after")],
        2
      ) : e._e(),
      e._v(" "),
      r("ResizeObserver", { on: { notify: e.handleResize } })
    ],
    1
  );
}, tge = [];
SR._withStripped = !0;
const nge = void 0, rge = void 0, sge = !1, U0 = /* @__PURE__ */ r2(
  { render: SR, staticRenderFns: tge },
  nge,
  ege,
  rge,
  sge
);
var ige = {
  name: "DynamicScroller",
  components: {
    RecycleScroller: U0
  },
  inheritAttrs: !1,
  provide: function() {
    return typeof ResizeObserver < "u" && (this.$_resizeObserver = new ResizeObserver(function(e) {
      var n = Kve(e), r;
      try {
        for (n.s(); !(r = n.n()).done; ) {
          var s = r.value;
          if (s.target) {
            var i = new CustomEvent("resize", {
              detail: {
                contentRect: s.contentRect
              }
            });
            s.target.dispatchEvent(i);
          }
        }
      } catch (o) {
        n.e(o);
      } finally {
        n.f();
      }
    })), {
      vscrollData: this.vscrollData,
      vscrollParent: this,
      vscrollResizeObserver: this.$_resizeObserver
    };
  },
  props: km(km({}, _R), {}, {
    minItemSize: {
      type: [Number, String],
      required: !0
    }
  }),
  data: function() {
    return {
      vscrollData: {
        active: !0,
        sizes: {},
        validSizes: {},
        keyField: this.keyField,
        simpleArray: !1
      }
    };
  },
  computed: {
    simpleArray: wR,
    itemsWithSize: function() {
      for (var e = [], n = this.items, r = this.keyField, s = this.simpleArray, i = this.vscrollData.sizes, o = 0; o < n.length; o++) {
        var a = n[o], l = s ? o : a[r], c = i[l];
        typeof c > "u" && !this.$_undefinedMap[l] && (c = 0), e.push({
          item: a,
          id: l,
          size: c
        });
      }
      return e;
    },
    listeners: function() {
      var e = {};
      for (var n in this.$listeners)
        n !== "resize" && n !== "visible" && (e[n] = this.$listeners[n]);
      return e;
    }
  },
  watch: {
    items: function() {
      this.forceUpdate(!1);
    },
    simpleArray: {
      handler: function(e) {
        this.vscrollData.simpleArray = e;
      },
      immediate: !0
    },
    direction: function(e) {
      this.forceUpdate(!0);
    }
  },
  created: function() {
    this.$_updates = [], this.$_undefinedSizes = 0, this.$_undefinedMap = {};
  },
  activated: function() {
    this.vscrollData.active = !0;
  },
  deactivated: function() {
    this.vscrollData.active = !1;
  },
  methods: {
    onScrollerResize: function() {
      var e = this.$refs.scroller;
      e && this.forceUpdate(), this.$emit("resize");
    },
    onScrollerVisible: function() {
      this.$emit("vscroll:update", {
        force: !1
      }), this.$emit("visible");
    },
    forceUpdate: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      (e || this.simpleArray) && (this.vscrollData.validSizes = {}), this.$emit("vscroll:update", {
        force: !0
      });
    },
    scrollToItem: function(e) {
      var n = this.$refs.scroller;
      n && n.scrollToItem(e);
    },
    getItemSize: function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, r = this.simpleArray ? n ?? this.items.indexOf(e) : e[this.keyField];
      return this.vscrollData.sizes[r] || 0;
    },
    scrollToBottom: function() {
      var e = this;
      if (!this.$_scrollingToBottom) {
        this.$_scrollingToBottom = !0;
        var n = this.$el;
        this.$nextTick(function() {
          n.scrollTop = n.scrollHeight + 5e3;
          var r = function s() {
            n.scrollTop = n.scrollHeight + 5e3, requestAnimationFrame(function() {
              n.scrollTop = n.scrollHeight + 5e3, e.$_undefinedSizes === 0 ? e.$_scrollingToBottom = !1 : requestAnimationFrame(s);
            });
          };
          requestAnimationFrame(r);
        });
      }
    }
  }
};
const oge = ige;
var IR = function() {
  var t = this, e = t.$createElement, n = t._self._c || e;
  return n(
    "RecycleScroller",
    t._g(
      t._b(
        {
          ref: "scroller",
          attrs: {
            items: t.itemsWithSize,
            "min-item-size": t.minItemSize,
            direction: t.direction,
            "key-field": "id"
          },
          on: { resize: t.onScrollerResize, visible: t.onScrollerVisible },
          scopedSlots: t._u(
            [
              {
                key: "default",
                fn: function(r) {
                  var s = r.item, i = r.index, o = r.active;
                  return [
                    t._t("default", null, null, {
                      item: s.item,
                      index: i,
                      active: o,
                      itemWithSize: s
                    })
                  ];
                }
              }
            ],
            null,
            !0
          )
        },
        "RecycleScroller",
        t.$attrs,
        !1
      ),
      t.listeners
    ),
    [
      t._v(" "),
      n("template", { slot: "before" }, [t._t("before")], 2),
      t._v(" "),
      n("template", { slot: "after" }, [t._t("after")], 2)
    ],
    2
  );
}, age = [];
IR._withStripped = !0;
const lge = void 0, cge = void 0, uge = !1, Nm = /* @__PURE__ */ r2(
  { render: IR, staticRenderFns: age },
  lge,
  oge,
  cge,
  uge
);
var dge = {
  name: "DynamicScrollerItem",
  inject: ["vscrollData", "vscrollParent", "vscrollResizeObserver"],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    item: {
      required: !0
    },
    watchData: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates if the view is actively used to display an item.
     */
    active: {
      type: Boolean,
      required: !0
    },
    index: {
      type: Number,
      default: void 0
    },
    sizeDependencies: {
      type: [Array, Object],
      default: null
    },
    emitResize: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    id: function() {
      return this.vscrollData.simpleArray ? this.index : this.item[this.vscrollData.keyField];
    },
    size: function() {
      return this.vscrollData.validSizes[this.id] && this.vscrollData.sizes[this.id] || 0;
    },
    finalActive: function() {
      return this.active && this.vscrollData.active;
    }
  },
  watch: {
    watchData: "updateWatchData",
    id: function() {
      this.size || this.onDataUpdate();
    },
    finalActive: function(e) {
      this.size || (e ? this.vscrollParent.$_undefinedMap[this.id] || (this.vscrollParent.$_undefinedSizes++, this.vscrollParent.$_undefinedMap[this.id] = !0) : this.vscrollParent.$_undefinedMap[this.id] && (this.vscrollParent.$_undefinedSizes--, this.vscrollParent.$_undefinedMap[this.id] = !1)), this.vscrollResizeObserver ? e ? this.observeSize() : this.unobserveSize() : e && this.$_pendingVScrollUpdate === this.id && this.updateSize();
    }
  },
  created: function() {
    var e = this;
    if (!this.$isServer && (this.$_forceNextVScrollUpdate = null, this.updateWatchData(), !this.vscrollResizeObserver)) {
      var n = function(i) {
        e.$watch(function() {
          return e.sizeDependencies[i];
        }, e.onDataUpdate);
      };
      for (var r in this.sizeDependencies)
        n(r);
      this.vscrollParent.$on("vscroll:update", this.onVscrollUpdate), this.vscrollParent.$on("vscroll:update-size", this.onVscrollUpdateSize);
    }
  },
  mounted: function() {
    this.vscrollData.active && (this.updateSize(), this.observeSize());
  },
  beforeDestroy: function() {
    this.vscrollParent.$off("vscroll:update", this.onVscrollUpdate), this.vscrollParent.$off("vscroll:update-size", this.onVscrollUpdateSize), this.unobserveSize();
  },
  methods: {
    updateSize: function() {
      this.finalActive ? this.$_pendingSizeUpdate !== this.id && (this.$_pendingSizeUpdate = this.id, this.$_forceNextVScrollUpdate = null, this.$_pendingVScrollUpdate = null, this.computeSize(this.id)) : this.$_forceNextVScrollUpdate = this.id;
    },
    updateWatchData: function() {
      var e = this;
      this.watchData ? this.$_watchData = this.$watch("data", function() {
        e.onDataUpdate();
      }, {
        deep: !0
      }) : this.$_watchData && (this.$_watchData(), this.$_watchData = null);
    },
    onVscrollUpdate: function(e) {
      var n = e.force;
      !this.finalActive && n && (this.$_pendingVScrollUpdate = this.id), (this.$_forceNextVScrollUpdate === this.id || n || !this.size) && this.updateSize();
    },
    onDataUpdate: function() {
      this.updateSize();
    },
    computeSize: function(e) {
      var n = this;
      this.$nextTick(function() {
        if (n.id === e) {
          var r = n.$el.offsetWidth, s = n.$el.offsetHeight;
          n.applySize(r, s);
        }
        n.$_pendingSizeUpdate = null;
      });
    },
    applySize: function(e, n) {
      var r = Math.round(this.vscrollParent.direction === "vertical" ? n : e);
      r && this.size !== r && (this.vscrollParent.$_undefinedMap[this.id] && (this.vscrollParent.$_undefinedSizes--, this.vscrollParent.$_undefinedMap[this.id] = void 0), this.$set(this.vscrollData.sizes, this.id, r), this.$set(this.vscrollData.validSizes, this.id, !0), this.emitResize && this.$emit("resize", this.id));
    },
    observeSize: function() {
      this.vscrollResizeObserver && (this.vscrollResizeObserver.observe(this.$el.parentNode), this.$el.parentNode.addEventListener("resize", this.onResize));
    },
    unobserveSize: function() {
      this.vscrollResizeObserver && (this.vscrollResizeObserver.unobserve(this.$el.parentNode), this.$el.parentNode.removeEventListener("resize", this.onResize));
    },
    onResize: function(e) {
      var n = e.detail.contentRect, r = n.width, s = n.height;
      this.applySize(r, s);
    }
  },
  render: function(e) {
    return e(this.tag, this.$slots.default);
  }
};
const fge = dge, pge = void 0, hge = void 0, mge = void 0, $m = /* @__PURE__ */ r2(
  {},
  pge,
  fge,
  hge,
  mge
);
function vge(t, e) {
  t.component("".concat(e, "recycle-scroller"), U0), t.component("".concat(e, "RecycleScroller"), U0), t.component("".concat(e, "dynamic-scroller"), Nm), t.component("".concat(e, "DynamicScroller"), Nm), t.component("".concat(e, "dynamic-scroller-item"), $m), t.component("".concat(e, "DynamicScrollerItem"), $m);
}
var gge = {
  // eslint-disable-next-line no-undef
  version: "1.0.10",
  install: function(e, n) {
    var r = Object.assign({}, {
      installComponents: !0,
      componentsPrefix: ""
    }, n);
    for (var s in r)
      typeof r[s] < "u" && (bR[s] = r[s]);
    r.installComponents && vge(e, r.componentsPrefix);
  }
}, Dm = null;
typeof window < "u" ? Dm = window.Vue : typeof global < "u" && (Dm = global.Vue);
Dm && Dm.use(gge);
function yge(t, e, n, r, s, i, o = 1) {
  requestAnimationFrame(() => {
    var c, u, d, f;
    if (o === 0) return;
    let a = e.value;
    if (o > 0) {
      if (a = e.value === null ? 0 : e.value + 1, a > r.value.length)
        return;
      if (a === r.value.length)
        return (c = t.dynamicScroller.value) == null ? void 0 : c.scrollToBottom();
    }
    o < 0 && (a = e.value - 1), a < 0 && (a = 0, s(!0));
    const l = (d = (u = t.dynamicScroller.value) == null ? void 0 : u.$refs) == null ? void 0 : d.scroller;
    if (l) {
      const { accumulator: p, size: h } = l.sizes[a], m = (f = l == null ? void 0 : l.$el) == null ? void 0 : f.scrollTop, v = p > m + n.value, y = p - h < m;
      if (v && l.scrollToPosition(p - n.value), o > 0) {
        if (a < 0) return;
        p < m && l.scrollToPosition(p - h);
      }
      o < 0 && y && l.scrollToPosition(p - h), e.value = a;
    }
  });
}
function bge({
  selectedIndexRef: t,
  itemsRv: e,
  checkDisabled: n,
  toggleKeyboardScroll: r,
  heightRef: s,
  refs: i,
  onReachStart: o,
  onReachEnd: a
}, l) {
  var c;
  if (l.code === "ShiftRight") {
    r();
    return;
  }
  if (!n() && !(["j", "k", "о", "л"].includes(l.key) && (((c = l.target.tagName) == null ? void 0 : c.toLowerCase()) === "input" || l.target.hasAttribute("contenteditable") && l.target.getAttribute("contenteditable") === !0)) && ["ArrowUp", "ArrowDown", "j", "k", "о", "л"].includes(l.key)) {
    if (l.shiftKey || l.metaKey || l.ctrlKey || l.altKey)
      return;
    l.stopPropagation(), l.preventDefault();
    let u = 0;
    ["ArrowUp", "k", "л"].includes(l.key) && (u = -1), ["ArrowDown", "j", "о"].includes(l.key) && (u = 1), yge(
      i,
      t,
      s,
      e,
      o,
      a,
      u
    );
  }
}
function _ge({
  selectedIndexRef: t,
  itemsRv: e,
  checkDisabled: n,
  toggleKeyboardScroll: r,
  heightRef: s,
  refs: i,
  onReachStart: o,
  onReachEnd: a,
  throttle: l
}) {
  const c = za(
    bge.bind(null, {
      selectedIndexRef: t,
      itemsRv: e,
      heightRef: s,
      checkDisabled: n,
      toggleKeyboardScroll: r,
      refs: i,
      onReachStart: o,
      onReachEnd: a
    }),
    l
  );
  Io(() => {
    document.addEventListener("keydown", c);
  }), Nf(() => {
    document.removeEventListener("keydown", c);
  });
}
function wge({
  isHeadChangedRef: t,
  itemsListDataRv: e,
  refs: n,
  duration: r = 500
}) {
  QO(() => {
    var s, i, o;
    if (t.value) {
      const a = (i = (s = n.dynamicScroller) == null ? void 0 : s.$refs) == null ? void 0 : i.scroller, l = (o = a == null ? void 0 : a.$refs) == null ? void 0 : o.wrapper;
      if (l && (l.style.transition = ""), l && e.oldHeadInNewItemsIndex !== null) {
        const c = a.sizes[e.oldHeadInNewItemsIndex];
        if (!c) return;
        const { size: u, accumulator: d } = c;
        l.style.transform = `translateY(${-d + u}px)`, requestAnimationFrame(() => {
          l.style.transition = `transform ${r}ms cubic-bezier(0.33, 1, 0.68, 1)`, l.style.transform = "";
        });
      }
    }
  });
}
const Ay = {
  enabled: !0,
  item: {
    duration: 300
  },
  list: {
    duration: 300,
    name: "slide-y-down"
  }
};
function Mo(t) {
  return (t == null ? void 0 : t.id) ?? t ?? null;
}
const Sge = (t, e, { item: n, index: r, active: s }) => {
  const i = e.$scopedSlots.default ? e.$scopedSlots.default({
    index: r,
    item: n,
    active: s,
    selected: r === e.selectedIndex,
    stripBase: e.stripBase
  }) : null;
  return t(
    $m,
    {
      props: {
        item: n,
        index: r,
        active: s,
        sizeDependencies: e.sizeDeps(n)
      }
    },
    [
      t(
        "div",
        {
          on: {
            click: e.onClick.bind(e, { item: n, index: r }),
            dblclick: e.onDoubleClick.bind(e, { item: n, index: r })
          },
          attrs: {
            "data-active": s
          }
        },
        [i]
      )
    ]
  );
}, Ige = (t, e) => e.$slots["before-content"] ? e.$slots["before-content"] : null, Ege = (t, e) => e.$slots["after-content"] ? e.$slots["after-content"] : null, ER = (t, e) => t(
  "div",
  {
    class: "pskit__virtual-list",
    ref: "pskitVlistWrapper"
  },
  [
    t(
      Nm,
      {
        props: {
          items: e.internalItems,
          buffer: 300,
          minItemSize: e.minItemSize
        },
        class: "pskit__virtual-list_scroller pskit__scroller__popup",
        on: {
          resize: e.updateHeight
        },
        nativeOn: {
          "&scroll": e.onScroll
        },
        domProps: {
          tabindex: "-1",
          "data-test-selector": "dynamic-list"
        },
        ref: "dynamicScroller",
        scopedSlots: {
          default: ({ item: n, index: r, active: s }) => Sge(t, e, { item: n, index: r, active: s })
        }
      },
      [
        t(
          "div",
          {
            class: "pskit__virtual-list_before-content",
            directives: [
              {
                name: "observe-visibility",
                value: e.onReachStart
              }
            ],
            slot: "before"
          },
          [Ige(t, e)]
        ),
        t(
          "div",
          {
            class: "pskit__virtual-list_after-content",
            directives: [
              {
                name: "observe-visibility",
                value: e.onReachEnd
              }
            ],
            slot: "after"
          },
          [Ege(t, e)]
        )
      ]
    )
  ]
), xge = (t, e) => t(
  e.$options.components.Transition,
  {
    props: {
      name: e.animationsConfig.list.name,
      mode: "out-in",
      duration: e.animationsConfig.list.duration,
      appear: !0
    }
  },
  [ER(t, e)]
), Cge = (t, e) => e.animations.enabled ? xge(t, e) : ER(t, e), Tge = {
  name: "PsKitVirtualList",
  props: {
    items: {
      type: Array,
      required: !0,
      default: () => []
    },
    enableKeyboard: {
      type: Boolean,
      default: !1
    },
    /** Минимальная высота элемента списка */
    minItemSize: {
      type: Number,
      default: 138
    },
    /** Идентификатор выделенного элемента списка */
    selected: {
      type: [Number, String],
      default: null
    },
    // Рендер полностью остановлен
    freezed: {
      type: Boolean,
      default: !1
    },
    /** Функция проверки, что список выключен (в частности, не реагирует на нажатия клавиш) */
    checkDisabled: {
      type: Function,
      default: () => !1
    },
    /** Функция, для переключения keyboard-скролла */
    toggleKeyboardScroll: {
      type: Function,
      default: () => null
    },
    /** Устанавливает троттлинг для нажатий клавиш навигации.
      `0` означает слушать нажатия без троттлинга.
    */
    navigationThrottle: {
      type: Number,
      default: 16
    },
    /** Список полей, изменение которых приведёт к пересчёту высот элементов списка.
     */
    sizeDeps: {
      type: Function,
      default: () => []
    },
    animations: {
      type: Object,
      default: () => ({})
    },
    emitScroll: {
      type: Boolean,
      default: !1
    },
    autoselectIndex: {
      type: Number,
      default: null
    },
    /** Флаг, определяющий то, что выборку элемента списка нужно отменить */
    removeSelection: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, e) {
    const n = et(null), r = et(null);
    let s = null, i = null;
    const o = Xn({
      prev: {
        head: {
          id: null
        },
        tail: {
          id: null
        }
      },
      oldHeadInNewItemsIndex: null,
      oldTailInNewItemsIndex: null
    }), a = et(0);
    let l = le(
      () => Mo(t.items[t.items.length - 1]) !== o.prev.tail.id
    ), c = le(
      () => Mo(t.items[0]) !== o.prev.head.id
    );
    o.prev.head.id = Mo(t.items[0]), o.prev.tail.id = Mo(t.items[t.items.length - 1]);
    const u = le(() => t.items);
    let d = et(null), f = et(null), p = le({
      get: () => d.value > -1 ? d.value : null,
      set: (N) => {
        if (N > -1) {
          d.value = N;
          const D = u.value[N];
          D ? (f.value = Mo(D), e.emit("select", D, N)) : f.value = null;
        } else
          d.value = null, f.value = null;
      }
    });
    t.autoselectIndex !== null && (p.value = t.autoselectIndex), or(
      () => t.items,
      (N) => {
        let D = null, H = null;
        for (let Y = 0; Y < N.length; Y++) {
          const te = Mo(N[Y]);
          c.value && te === o.prev.head.id && (D = Y), l.value && te === o.prev.tail.id && (H = Y), f.value !== null && f.value !== Mo(N[d.value]) && te === f.value && (p.value = Y);
        }
        c.value && (a.value = (a.value + D) % 2), c.value && (o.oldHeadInNewItemsIndex = D, o.prev.head.id = Mo(N[0])), o.oldTailInNewItemsIndex = H, o.prev.tail.id = Mo(N.at(-1));
      }
    );
    const h = (N) => {
      N !== void 0 && (p.value = N);
    };
    or(
      () => t.removeSelection,
      (N) => {
        N && h(-1);
      }
    );
    let m = null;
    const v = () => {
      var D, H;
      const N = (H = (D = r.value) == null ? void 0 : D.$refs) == null ? void 0 : H.scroller.$el.scrollTop;
      e.emit("scroll", { scrollTop: N });
    }, y = () => {
      t.emitScroll && (clearTimeout(m), m = setTimeout(v, 100));
    }, _ = (N) => {
      N && e.emit("reachedEnd");
    }, w = (N) => {
      N && e.emit("reachedStart");
    }, S = ({ item: N, index: D }) => {
      i ? (clearTimeout(s), i = !1) : (s = setTimeout(() => {
        h(D), e.emit("click", { item: N, index: D }), i = !1;
      }, 200), i = !0);
    }, E = ({ item: N, index: D }) => {
      clearTimeout(s), i = !1, e.emit("dblclick", { item: N, index: D });
    };
    let x = et(0);
    function T() {
      var N, D;
      x.value = (D = (N = r.value) == null ? void 0 : N.$el) == null ? void 0 : D.getBoundingClientRect().height;
    }
    t.enableKeyboard && _ge({
      selectedIndexRef: p,
      itemsRv: u,
      heightRef: x,
      checkDisabled: t.checkDisabled,
      toggleKeyboardScroll: t.toggleKeyboardScroll,
      refs: {
        dynamicScroller: r,
        pskitVlistWrapper: n
      },
      onReachStart: w,
      onReachEnd: _,
      navigationThrottle: t.navigationThrottle
    }), Io(() => {
      T();
    });
    const C = {
      ...Ay,
      ...t.animations,
      list: {
        ...Ay.list,
        ...t.animations.list ? t.animations.list : {}
      },
      item: {
        ...Ay.item,
        ...t.animations.item ? t.animations.item : {}
      }
    };
    return C.enabled && wge({
      isHeadChangedRef: c,
      itemsListDataRv: o,
      refs: {
        dynamicScroller: r.value,
        pskitVlistWrapper: n.value
      },
      duration: C.item.duration
    }), {
      selectedId: f,
      internalItems: u,
      selectedIndex: p,
      pskitVlistWrapper: n,
      dynamicScroller: r,
      animationsConfig: C,
      onClick: S,
      onDoubleClick: E,
      updateHeight: T,
      onReachStart: w,
      onReachEnd: _,
      onScroll: y,
      scrollToPosition: (N) => {
        var D, H;
        (H = (D = r.value) == null ? void 0 : D.$refs) != null && H.scroller && r.value.$refs.scroller.scrollToPosition(N);
      },
      scrollToItem: (N) => {
        r.value && r.value.scrollToItem(N);
      },
      getScroll: () => r.value.$refs.scroller.getScroll(),
      stripBase: a
    };
  },
  render(t) {
    return Cge(t, this);
  }
}, Pge = null, kge = null;
var Nge = /* @__PURE__ */ B(
  Tge,
  Pge,
  kge,
  !1,
  null,
  null
);
const xR = Nge.exports, $ge = "_root_1bi4o_1", Dge = "_message_1bi4o_25", Age = "_loader_1bi4o_35", Oge = {
  root: $ge,
  "has-new": "_has-new_1bi4o_11",
  message: Dge,
  "after-content-loader": "_after-content-loader_1bi4o_31",
  loader: Age
}, Mge = {
  name: "PbPanelList",
  components: {
    PbCircularLoader: br,
    PbEmpty: tl,
    PsKitVirtualList: xR
  },
  mixins: [Vr],
  props: {
    isFocused: {
      type: Function,
      default: () => !1
    },
    entries: {
      type: Array,
      default: () => []
    },
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    loaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    initialLoaded: {
      type: Boolean,
      default: !1
    },
    newItemsMessage: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: !0
    },
    isDragging: {
      type: Boolean,
      default: !1
    },
    hasNew: {
      type: Boolean,
      default: !1
    },
    hasNewIndicator: {
      type: Boolean,
      default: !1
    },
    emptyText: {
      type: String,
      default: "Пусто"
    },
    sizeDeps: {
      type: Function,
      default: () => []
    },
    minimalHeight: {
      type: Number,
      default: null
    },
    navigationThrottle: {
      type: Number,
      default: 16
    },
    hasFixedScroll: {
      type: Boolean,
      default: !1
    },
    autoselectIndex: {
      type: Number,
      default: null
    },
    removeSelection: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      items: [],
      selectedEntry: null,
      isFocusedList: !0
    };
  },
  computed: {
    minHeight() {
      return this.isCompact ? 38 : this.minimalHeight || 157;
    }
  },
  watch: {
    entries: function(t) {
      this.active && (this.items = t);
    },
    active: function(t, e) {
      t === !0 && t !== e && (this.items = this.entries);
    },
    // FIXME
    isDragging: function(t, e) {
      t !== e && (t ? this.scrollTop = this.$refs.list.getScroll().top : e && this.$refs.list.scrollToPosition(this.scrollTop));
    },
    removeSelection: function(t) {
      t && (this.selectedEntry = null);
    }
  },
  created() {
    this.scrollTop = 0, this.items = this.entries;
  },
  methods: {
    onScroll({ scrollTop: t }) {
      this.$emit("scroll", { scrollTop: t });
    },
    isDisabled() {
      return !this.active || !this.isFocused();
    },
    isDisabledScroll() {
      return this.isDisabled() || !this.isFocusedList;
    },
    onClickAwayList() {
      this.isDisabled() || (this.isFocusedList = !1);
    },
    onClick() {
      this.isFocusedList = !0;
    },
    toggleKeyboardScroll() {
      this.isDisabled() || (this.isFocusedList = !this.isFocusedList);
    },
    select(t) {
      t && t.id === this.selectedEntry || (this.selectedEntry = t ? t.id : null, this.$emit("select", { entry: t, panelId: this.panelId }));
    },
    openPanel({ item: t }) {
      this.$emit("openPanel", t);
    },
    reachedEnd() {
      this.active && this.$emit("reachedEnd");
    },
    reachedTop() {
      !this.active || this.isDragging || this.$emit("reachedTop");
    },
    scrollToEntry(t) {
      this.$nextTick(() => {
        const e = this.items.findIndex(({ id: n }) => t.id === n);
        this.scrollToItem(e);
      });
    },
    scrollToItem(t) {
      this.$refs.list && this.$refs.list.scrollToItem(t);
    }
  }
};
var Rge = function() {
  var e = this, n = e._self._c;
  return e.items ? n("div", { class: e.$style.root, on: { click: e.onClick } }, [n("transition", { attrs: { appear: "", name: "slide-y-down", duration: 64 } }, [e.hasNewIndicator && e.hasNew ? n("div", { class: e.$style["has-new"], attrs: { "data-test-selector": "new-items" } }, [n("div", { class: e.$style.message, on: { click: function(r) {
    return e.$emit("unreadClick");
  } } }, [e._v(" " + e._s(e.newItemsMessage) + " ")]), n("div", { directives: [{ name: "show", rawName: "v-show", value: !e.loaded && e.loading, expression: "!loaded && loading" }], class: e.$style.loader, attrs: { "data-test-selector": "load-indicator", "data-test-attrs": `load-indicator__${!e.loaded && e.loading ? "visible" : "hidden"}` } }, [n("PbCircularLoader", { attrs: { size: 15, color: "white" } })], 1)]) : e._e()]), e.initialLoaded ? n("PsKitVirtualList", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: () => e.onClickAwayList(), expression: "() => onClickAwayList()" }], ref: "list", attrs: { items: e.items, minItemSize: e.minHeight, showLoader: !e.loaded && e.loading, enableKeyboard: !0, freezed: e.isDragging, checkDisabled: e.isDisabledScroll, toggleKeyboardScroll: e.toggleKeyboardScroll, navigationThrottle: e.navigationThrottle, sizeDeps: e.sizeDeps, animations: { enabled: !0 }, emitScroll: !0, autoselectIndex: e.autoselectIndex, removeSelection: e.removeSelection }, on: { select: e.select, dblclick: e.openPanel, scroll: e.onScroll, reachedEnd: e.reachedEnd, reachedStart: e.reachedTop }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, index: s, selected: i, stripBase: o }) {
    return [e._t("default", null, null, { item: r, index: s, stripBase: o, isSelected: i })];
  } }, { key: "after-content", fn: function() {
    return [!e.loaded && e.loading ? [n("PbCircularLoader", { class: e.$style["after-content-loader"], attrs: { size: 30 } })] : e._e()];
  }, proxy: !0 }], null, !0) }) : e._e(), e.initialLoaded && e.loaded && !e.entries.length ? n("PbEmpty", { attrs: { text: e.emptyText } }) : e._e()], 1) : e._e();
}, Lge = [];
const _P = {
  $style: Oge
};
function Fge(t) {
  for (var e in _P)
    this[e] = _P[e];
}
var Bge = /* @__PURE__ */ B(
  Mge,
  Rge,
  Lge,
  !1,
  Fge,
  null
);
const Fv = Bge.exports, jge = {
  "entry-comment": "_entry-comment_1tu02_1"
}, Wge = {
  name: "PbEntryComment",
  props: {
    comment: {
      type: String,
      default: ""
    }
  },
  computed: {
    commentProcessed() {
      let t = "";
      return this.comment && (t = I0(this.comment), t.length > 140 && (t = t.slice(0, 140) + "…")), t;
    }
  }
};
var Hge = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style["entry-comment"] }, [e._v(e._s(e.commentProcessed))]);
}, Vge = [];
const wP = {
  $style: jge
};
function zge(t) {
  for (var e in wP)
    this[e] = wP[e];
}
var Uge = /* @__PURE__ */ B(
  Wge,
  Hge,
  Vge,
  !1,
  zge,
  null
);
const Gge = Uge.exports, Yge = {
  name: "AsoiNoteEntry",
  components: {
    PbEntryComment: Gge,
    DateWidget: Hr,
    NewsTypeButton: ea,
    MainActionButton: fn
  },
  props: {
    item: Object,
    type: {
      type: String,
      required: !0
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    dateMode: {
      type: Number,
      default: 0
    },
    compact: {
      type: [Boolean, Number],
      deafult: !1
    },
    color: {
      type: String,
      default: "#404040"
    }
  },
  computed: {
    ...pe({
      asoiNoteById: "getAsoiNoteById",
      asoiNoteSender: "getAsoiNoteSender",
      asoiNoteRecipientName: "getAsoiNoteRecipientName"
    }),
    /* Оборачиваем геттеры чтобы прокинуть динамический параметр (тип) */
    getAsoiNoteById() {
      return this.asoiNoteById(this.type);
    },
    getAsoiNoteSender() {
      return this.asoiNoteSender(this.type);
    },
    getAsoiNoteRecipientName() {
      return this.asoiNoteRecipientName(this.type);
    },
    /* --------------------------------------------------------------- */
    entry() {
      return this.getAsoiNoteById(this.item.id) || {};
    },
    entryClasses() {
      let t = [];
      return this.isSelected && t.push("selected"), this.entry && this.entry.is_read && t.push("read"), this.compact && t.push("compact"), t;
    },
    sender() {
      const t = this.getAsoiNoteSender(this.item.id);
      return t && t.name ? this.formatUsername(t.name) : null;
    },
    recipient() {
      var e;
      if (!((e = this == null ? void 0 : this.item) != null && e.id)) return null;
      const t = this.getAsoiNoteRecipientName(this.item.id);
      return t === null ? null : Array.isArray(t) ? t.map((n) => n.name || n).map(this.formatUsername).join(", ") : this.formatUsername(t);
    },
    comment() {
      return this.entry.comment ? this.entry.comment.length > 140 ? this.entry.comment.slice(0, 140) + "…" : this.entry.comment : null;
    },
    isRead() {
      return this.entry.is_read;
    }
  }
};
var Zge = function() {
  var e = this, n = e._self._c;
  return e.entry && e.entry.id && e.compact ? n("div", { staticClass: "entry-asoi-note", class: e.entryClasses, attrs: { "data-test-selector": "asoi-note-entry-compact", "data-test-id": e.entry.id, "data-test-attrs": `entry-id__${e.entry.id} ${e.entryClasses.join(" ")}` } }, [n("div", { staticClass: "entry-header" }, [n("span", { staticClass: "entry-status", attrs: { "data-test-selector": "asoi-note-entry-compact-status", "data-test-attrs": `status__${e.isRead ? "read" : "unread"}` } }, [n("i", { directives: [{ name: "show", rawName: "v-show", value: !e.isRead, expression: "!isRead" }], style: { color: e.color } }, [e._v("●")])])]), n("div", { staticClass: "entry-text" }, [e.entry.textHeader ? n("span", [e._v(e._s(e.entry.textHeader))]) : e.entry.textBody ? n("span", [e._v(e._s(e.entry.textBody))]) : n("span", { staticClass: "no-text" }, [e._v("Пустая заметка")])]), n("div", { staticClass: "entry-date" }, [n("DateWidget", { attrs: { date: e.entry.created_at, mode: e.dateMode, "data-test-selector": "asoi-note-entry-compact-date" }, on: { dateModeChanged: function(r) {
    return e.$emit("dateModeChanged", r);
  } } })], 1)]) : e.entry && e.entry.id ? n("div", { staticClass: "entry-asoi-note", class: e.entryClasses, attrs: { "data-test-selector": "asoi-note-entry-full", "data-test-id": e.entry.id, "data-test-attrs": `entry-id__${e.entry.id} ${e.entryClasses.join(" ")}` } }, [n("div", { staticClass: "entry-header" }, [n("span", { staticClass: "entry-status", attrs: { "data-test-selector": "asoi-note-entry-full-status", "data-test-attrs": `status__${e.isRead ? "read" : "unread"}` } }, [n("i", { directives: [{ name: "show", rawName: "v-show", value: !e.isRead, expression: "!isRead" }], style: { color: e.color } }, [e._v("●")])]), n("span", { staticClass: "entry-date" }, [n("DateWidget", { attrs: { date: e.entry.created_at, mode: e.dateMode, "data-test-selector": "asoi-note-entry-full-date" }, on: { dateModeChanged: function(r) {
    return e.$emit("dateModeChanged", r);
  } } })], 1)]), n("div", { staticClass: "entry-body" }, [n("div", { staticClass: "entry-text", attrs: { "data-test-selector": "asoi-note-entry-full-text" } }, [e.entry.textHeader ? n("b", [e._v(e._s(e.entry.textHeader))]) : e.entry.textBody ? n("span", [e._v(e._s(e.entry.textBody))]) : n("span", { staticClass: "no-text" }, [e._v("Пустая заметка")])]), n("div", { staticClass: "entry-expansion" }, [n("div", { staticClass: "entry-users", attrs: { "data-test-selector": "asoi-note-entry-users" } }, [e.sender ? n("div", { staticClass: "entry-users__sender" }, [e._v("От: " + e._s(e.sender))]) : e._e(), e.recipient ? n("div", { staticClass: "entry-users__recipient" }, [e._v(" Кому: " + e._s(e.recipient) + " ")]) : e._e()]), e.entry.comment ? n("PbEntryComment", { attrs: { comment: e.entry.comment, "data-test-selector": "asoi-note-entry-comment" } }) : e._e(), n("NewsTypeButton", { attrs: { typeId: e.entry.type_id, disabled: !0, color: [1, 2].includes(e.entry.type_id) ? "#D0021B" : "#848484", "data-test-selector": "asoi-note-entry-type-button", "data-test-attrs": `type__${e.entry.type_id}` } })], 1)]), e.isSelected ? n("div", { staticClass: "entry-footer" }, [e.type !== "sent" ? [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "button-add" }, on: { click: function(r) {
    return e.$emit("pick", e.entry);
  } } }, [e._v(" Взять в работу ")]), n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-trash", "data-test-selector": "button-remove" }, on: { click: function(r) {
    return e.$emit("remove", e.entry);
  } } }, [e._v(" Удалить ")])] : e._e(), n("MainActionButton", { staticClass: "mini-button show-more pb-action-button-old", attrs: { iconName: "button-icon-show-more", title: "Открыть в отдельной панели", "data-test-selector": "button-show-more" }, on: { click: function(r) {
    return e.$emit("openPanel", e.entry);
  } } })], 2) : e._e()]) : e._e();
}, Xge = [], Kge = /* @__PURE__ */ B(
  Yge,
  Zge,
  Xge,
  !1,
  null,
  null
);
const Jge = Kge.exports, qge = {
  name: "AsoiNotesList",
  components: {
    WithTwoWayLoading: Lv,
    PanelList: Fv,
    AsoiNoteEntry: Jge,
    AsoiNoteDeleteDialog: rR
  },
  props: {
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#fff"
    },
    dateMode: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      required: !0
    },
    isFocused: {
      type: Function,
      default: () => !1
    }
  },
  data() {
    const t = fR(Gue(this.type));
    return {
      methodName: {
        load: `loadAsoiNotes${t}`,
        general: `asoiNote${t}`
      },
      /** stateName: string = 'received' | 'sent'  */
      stateName: au(this.type),
      isDeleteDialogOpen: !1
    };
  },
  computed: {
    ...st({
      modal: (t) => t.uiState.modal,
      isDragging: (t) => t.uiState.panelsDragging
    }),
    ...pe("panels", ["getPanelIndex", "getPanelById"]),
    ...pe({
      asoiNoteById: "getAsoiNoteById",
      getPanelIsActive: "getPanelIsActive"
    }),
    getAsoiNoteById() {
      return this.asoiNoteById(this.stateName);
    },
    items() {
      return this.$store.state.asoi[this.stateName].list.filter(
        (t) => !this.$store.state.asoi[this.stateName].items[t].is_deleted
      ).map((t) => ({ id: t }));
    },
    initialLoaded() {
      return this.$store.state.asoi[this.stateName].initialLoaded;
    },
    active() {
      return this.panelId && this.getPanelIsActive(this.panelId);
    },
    sizeDeps() {
      return () => [];
    }
  },
  beforeDestroy() {
    this.setInitialLoaded(!1);
  },
  methods: {
    ...ge([
      "setAsoiNoteAsRead",
      "pickAsoiNote",
      "deleteAsoiNote",
      "selectAsoiNote"
    ]),
    ...ge("panels", ["addPanel", "setPanelDateMode", "hideSupply"]),
    setInitialLoaded(t) {
      const e = this.stateName === "sent" ? "asoiNotesSentSetInitialLoaded" : "asoiNotesSetInitialLoaded";
      this.$store.dispatch(e, t), this.$nextTick(() => {
        this.$refs.panelList && this.$refs.panelList.scrollToItem(0);
      });
    },
    loadAsoiNotes(t) {
      return this.$store.dispatch(`${this.methodName.load}`, t);
    },
    async fetchData({ cursor: t, limit: e = 30, reverse: n = !1, replace: r = !1 }) {
      let s = {
        cursor: t,
        limit: e,
        reverse: n
      };
      return await this.loadAsoiNotes({ params: s, replace: r });
    },
    pick(t) {
      var n, r;
      const e = this.getPanelById(this.panelId);
      e && this.hideSupply({
        panelId: e.id,
        supplyId: (r = (n = e.supply) == null ? void 0 : n.right[0]) == null ? void 0 : r.id
      }), this.pickAsoiNote({ note: t });
    },
    handleRemove(t) {
      this.$once("confirmRemove", () => this.remove(t)), this.isDeleteDialogOpen = !0;
    },
    remove(t) {
      var n, r;
      const e = this.getPanelById(this.panelId);
      e && this.hideSupply({
        panelId: e.id,
        supplyId: (r = (n = e.supply) == null ? void 0 : n.right[0]) == null ? void 0 : r.id
      }), this.deleteAsoiNote(t);
    },
    handleDialogClose() {
      this.$off("confirmRemove"), this.isDeleteDialogOpen = !1;
    },
    setDateMode(t) {
      this.setPanelDateMode({ panelId: this.panelId, mode: t });
    },
    openPanel(t) {
      const e = Uue()(this.stateName);
      this.addPanel({
        panel: { dataId: t.id, type: e },
        position: this.getPanelIndex(this.panelId)
      });
      const n = this.getAsoiNoteById(t.id);
      n.is_read || this.setAsoiNoteAsRead(n);
    }
  }
};
var Qge = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "asoi-notes-list", attrs: { "data-test-selector": "asoi-notes-list" } }, [n("WithTwoWayLoading", { ref: "withLoading", attrs: { hasNew: !1, isPaused: !1, active: !0, fetchData: e.fetchData, scrollToUnread: () => {
  }, initialLoaded: e.initialLoaded, maxLength: 90, entries: e.items, entryGetter: e.getAsoiNoteById, cursorField: "id", emptyText: "Заметок нет" }, on: { setPaused: () => {
  }, setHasNew: () => {
  }, initialLoaded: e.setInitialLoaded }, scopedSlots: e._u([{ key: "default", fn: function({
    loadNext: r,
    loadPrev: s,
    refresh: i,
    hasNew: o,
    loaded: a,
    loading: l
  }) {
    return [e.items.length ? n("PanelList", { ref: "panelList", attrs: { entries: e.items, panelId: e.panelId, isCompact: e.isCompact, color: e.color, dateMode: e.dateMode, loaded: a, loading: l, isFocused: e.isFocused, modal: e.modal, active: !0, initialLoaded: e.initialLoaded, hasNew: o, isDragging: e.isDragging, sizeDeps: e.sizeDeps, minimalHeight: e.isCompact ? 38 : 165, emptyText: "Заметок нет", newItemsMessage: "Есть новые заметки" }, on: { select: e.selectAsoiNote, openPanel: e.openPanel, reachedEnd: s, reachedTop: r, unreadClick: i }, scopedSlots: e._u([{ key: "default", fn: function({ item: c, isSelected: u }) {
      return [n("AsoiNoteEntry", { attrs: { isSelected: u, color: "#" + e.color, compact: e.isCompact, dateMode: e.dateMode, item: c, type: e.stateName }, on: { pick: e.pick, remove: e.handleRemove, openPanel: e.openPanel, "!dateModeChanged": function(d) {
        return e.setDateMode.apply(null, arguments);
      } } })];
    } }], null, !0) }) : e._e()];
  } }]) }), n("AsoiNoteDeleteDialog", { attrs: { open: e.isDeleteDialogOpen }, on: { close: e.handleDialogClose, confirm: function(r) {
    return e.$emit("confirmRemove");
  } } })], 1);
}, eye = [], tye = /* @__PURE__ */ B(
  qge,
  Qge,
  eye,
  !1,
  null,
  null
);
const nye = tye.exports, rye = "_root_dhv19_1", sye = "_badge_dhv19_13", iye = {
  root: rye,
  badge: sye
}, oye = {
  name: "PbBadge",
  mixins: [X4],
  props: {
    limit: {
      type: Number,
      default: 100
    },
    bgColor: {
      type: String,
      default: "white"
    },
    color: {
      type: String,
      default: "#333"
    },
    unread: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    alwaysVisible: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    limited() {
      return typeof this.unread == "number" && this.unread >= this.limit ? this.limit - 1 + "+" : this.unread;
    }
  }
};
var aye = function() {
  var e = this, n = e._self._c;
  return n("span", { directives: [{ name: "show", rawName: "v-show", value: e.unread !== 0 && !e.loading || e.alwaysVisible, expression: "(unread !== 0 && !loading) || alwaysVisible" }], class: e.$style.root, style: { color: e.color, background: e.bgColor }, on: { click: e.clickHandler, dblclick: e.dblclickHandler } }, [n("span", { class: e.$style.badge, attrs: { "data-test-selector": "badge-unread-count" } }, [e._t("badge", function() {
    return [e._v(e._s(e.limited))];
  })], 2)]);
}, lye = [];
const SP = {
  $style: iye
};
function cye(t) {
  for (var e in SP)
    this[e] = SP[e];
}
var uye = /* @__PURE__ */ B(
  oye,
  aye,
  lye,
  !1,
  cye,
  null
);
const s2 = uye.exports, dye = "_root_1v35a_1", fye = {
  root: dye
}, pye = {
  name: "AsoiNotesUnreadBadge",
  components: {
    PbBadge: s2
  },
  props: {
    color: {
      type: String,
      default: "#333"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      initialCount: 0,
      initial: !1
    };
  },
  computed: {
    unread() {
      return this.$store.getters.getAsoiNotesUnreadCount;
    }
  }
};
var hye = function() {
  var e = this, n = e._self._c;
  return n("PbBadge", { directives: [{ name: "show", rawName: "v-show", value: e.unread, expression: "unread" }], class: e.$style.root, attrs: { color: e.color, loading: e.loading, unread: e.unread }, on: { click: function(r) {
    return e.$emit("click");
  }, dblclick: function(r) {
    return e.$emit("dblclick");
  } } });
}, mye = [];
const IP = {
  $style: fye
};
function vye(t) {
  for (var e in IP)
    this[e] = IP[e];
}
var gye = /* @__PURE__ */ B(
  pye,
  hye,
  mye,
  !1,
  vye,
  null
);
const CR = gye.exports, yye = {
  name: "AsoiNotesPanel",
  components: {
    Panel: bs,
    PanelMenu: Rv,
    AsoiNotesList: nye,
    AsoiNotesUnreadBadge: CR
  },
  props: {
    panel: Object,
    type: String,
    isFocused: Boolean
  },
  data() {
    return {
      menuShowed: !1,
      menuItems: [
        {
          label: "Закрыть панель",
          code: "close",
          handler: this.remove,
          enabled: !0
        }
      ]
    };
  },
  computed: {
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    userHasPermissions() {
      return this.getIsUserHasAllPermissions([
        this.isTypeNotesSent ? "4.2" : "4.1"
      ]);
    },
    isTypeNotesSent() {
      return H4(this.type);
    },
    title() {
      return this.isTypeNotesSent ? "Отправленные в АСОИ" : "Заметки из АСОИ";
    }
  },
  methods: {
    getIsFocused() {
      return this.isFocused;
    },
    remove() {
      this.$store.dispatch("panels/removePanel", { panelId: this.panel.id });
    }
  }
};
var bye = function() {
  var e = this, n = e._self._c;
  return n("Panel", { attrs: { title: e.title, panel: e.panel, isFocused: e.isFocused, userHasPermissions: e.userHasPermissions }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [n("PanelMenu", { attrs: { items: e.menuItems, trigger: e.menuShowed, color: "#" + e.panel.settings.color }, on: { "update:trigger": function(r) {
      e.menuShowed = r;
    }, click: function(r) {
      e.menuShowed = !e.menuShowed;
    } } })];
  }, proxy: !0 }, e.userHasPermissions ? { key: "appBar", fn: function() {
    return [e.isTypeNotesSent ? e._e() : n("AsoiNotesUnreadBadge", { attrs: { color: "#" + e.panel.settings.color } })];
  }, proxy: !0 } : null, { key: "content", fn: function() {
    return [n("AsoiNotesList", { attrs: { panelId: e.panel.id, color: e.panel.settings.color, dateMode: e.panel.settings.dateMode, isCompact: e.panel.settings.compact, isFocused: e.getIsFocused, type: e.type } })];
  }, proxy: !0 }], null, !0) });
}, _ye = [], wye = /* @__PURE__ */ B(
  yye,
  bye,
  _ye,
  !1,
  null,
  null
);
const Sye = wye.exports;
function Iye(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var i2 = Iye, Eye = ac, xye = function() {
  try {
    var t = Eye(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), TR = xye, EP = TR;
function Cye(t, e, n) {
  e == "__proto__" && EP ? EP(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var Bv = Cye, Tye = Bv, Pye = PS, kye = Object.prototype, Nye = kye.hasOwnProperty;
function $ye(t, e, n) {
  var r = t[e];
  (!(Nye.call(t, e) && Pye(r, n)) || n === void 0 && !(e in t)) && Tye(t, e, n);
}
var o2 = $ye, Dye = o2, Aye = Bv;
function Oye(t, e, n, r) {
  var s = !n;
  n || (n = {});
  for (var i = -1, o = e.length; ++i < o; ) {
    var a = e[i], l = r ? r(n[a], t[a], a, n, t) : void 0;
    l === void 0 && (l = t[a]), s ? Aye(n, a, l) : Dye(n, a, l);
  }
  return n;
}
var jv = Oye, Mye = jv, Rye = Pu;
function Lye(t, e) {
  return t && Mye(e, Rye(e), t);
}
var PR = Lye;
function Fye(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var Bye = Fye, jye = Yi, Wye = Ov, Hye = Bye, Vye = Object.prototype, zye = Vye.hasOwnProperty;
function Uye(t) {
  if (!jye(t))
    return Hye(t);
  var e = Wye(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !zye.call(t, r)) || n.push(r);
  return n;
}
var Gye = Uye, Yye = A4, Zye = Gye, Xye = lc;
function Kye(t) {
  return Xye(t) ? Yye(t, !0) : Zye(t);
}
var a2 = Kye, Jye = jv, qye = a2;
function Qye(t, e) {
  return t && Jye(e, qye(e), t);
}
var ebe = Qye, Am = { exports: {} };
Am.exports;
(function(t, e) {
  var n = Rs, r = e && !e.nodeType && e, s = r && !0 && t && !t.nodeType && t, i = s && s.exports === r, o = i ? n.Buffer : void 0, a = o ? o.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, f = a ? a(d) : new c.constructor(d);
    return c.copy(f), f;
  }
  t.exports = l;
})(Am, Am.exports);
var tbe = Am.exports;
function nbe(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var Wf = nbe, rbe = jv, sbe = US;
function ibe(t, e) {
  return rbe(t, sbe(t), e);
}
var obe = ibe, abe = O4, lbe = abe(Object.getPrototypeOf, Object), l2 = lbe, cbe = VS, ube = l2, dbe = US, fbe = $4, pbe = Object.getOwnPropertySymbols, hbe = pbe ? function(t) {
  for (var e = []; t; )
    cbe(e, dbe(t)), t = ube(t);
  return e;
} : fbe, kR = hbe, mbe = jv, vbe = kR;
function gbe(t, e) {
  return mbe(t, vbe(t), e);
}
var ybe = gbe, bbe = N4, _be = kR, wbe = a2;
function Sbe(t) {
  return bbe(t, wbe, _be);
}
var NR = Sbe, Ibe = Object.prototype, Ebe = Ibe.hasOwnProperty;
function xbe(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && Ebe.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var Cbe = xbe, xP = k4;
function Tbe(t) {
  var e = new t.constructor(t.byteLength);
  return new xP(e).set(new xP(t)), e;
}
var c2 = Tbe, Pbe = c2;
function kbe(t, e) {
  var n = e ? Pbe(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var Nbe = kbe, $be = /\w*$/;
function Dbe(t) {
  var e = new t.constructor(t.source, $be.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Abe = Dbe, CP = bu, TP = CP ? CP.prototype : void 0, PP = TP ? TP.valueOf : void 0;
function Obe(t) {
  return PP ? Object(PP.call(t)) : {};
}
var Mbe = Obe, Rbe = c2;
function Lbe(t, e) {
  var n = e ? Rbe(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var Fbe = Lbe, Bbe = c2, jbe = Nbe, Wbe = Abe, Hbe = Mbe, Vbe = Fbe, zbe = "[object Boolean]", Ube = "[object Date]", Gbe = "[object Map]", Ybe = "[object Number]", Zbe = "[object RegExp]", Xbe = "[object Set]", Kbe = "[object String]", Jbe = "[object Symbol]", qbe = "[object ArrayBuffer]", Qbe = "[object DataView]", e_e = "[object Float32Array]", t_e = "[object Float64Array]", n_e = "[object Int8Array]", r_e = "[object Int16Array]", s_e = "[object Int32Array]", i_e = "[object Uint8Array]", o_e = "[object Uint8ClampedArray]", a_e = "[object Uint16Array]", l_e = "[object Uint32Array]";
function c_e(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case qbe:
      return Bbe(t);
    case zbe:
    case Ube:
      return new r(+t);
    case Qbe:
      return jbe(t, n);
    case e_e:
    case t_e:
    case n_e:
    case r_e:
    case s_e:
    case i_e:
    case o_e:
    case a_e:
    case l_e:
      return Vbe(t, n);
    case Gbe:
      return new r();
    case Ybe:
    case Kbe:
      return new r(t);
    case Zbe:
      return Wbe(t);
    case Xbe:
      return new r();
    case Jbe:
      return Hbe(t);
  }
}
var u_e = c_e, d_e = Yi, kP = Object.create, f_e = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!d_e(e))
      return {};
    if (kP)
      return kP(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), Wv = f_e, p_e = Wv, h_e = l2, m_e = Ov;
function v_e(t) {
  return typeof t.constructor == "function" && !m_e(t) ? p_e(h_e(t)) : {};
}
var g_e = v_e, y_e = Nu, b_e = Pi, w_e = "[object Map]";
function S_e(t) {
  return b_e(t) && y_e(t) == w_e;
}
var I_e = S_e, E_e = I_e, x_e = Tu, NP = YS, $P = NP && NP.isMap, C_e = $P ? x_e($P) : E_e, T_e = C_e, P_e = Nu, k_e = Pi, N_e = "[object Set]";
function $_e(t) {
  return k_e(t) && P_e(t) == N_e;
}
var D_e = $_e, A_e = D_e, O_e = Tu, DP = YS, AP = DP && DP.isSet, M_e = AP ? O_e(AP) : A_e, R_e = M_e, L_e = HS, F_e = i2, B_e = o2, j_e = PR, W_e = ebe, H_e = tbe, V_e = Wf, z_e = obe, U_e = ybe, G_e = M4, Y_e = NR, Z_e = Nu, X_e = Cbe, K_e = u_e, J_e = g_e, q_e = Wr, Q_e = Dv, e0e = T_e, t0e = Yi, n0e = R_e, r0e = Pu, s0e = a2, i0e = 1, o0e = 2, a0e = 4, $R = "[object Arguments]", l0e = "[object Array]", c0e = "[object Boolean]", u0e = "[object Date]", d0e = "[object Error]", DR = "[object Function]", f0e = "[object GeneratorFunction]", p0e = "[object Map]", h0e = "[object Number]", AR = "[object Object]", m0e = "[object RegExp]", v0e = "[object Set]", g0e = "[object String]", y0e = "[object Symbol]", b0e = "[object WeakMap]", _0e = "[object ArrayBuffer]", w0e = "[object DataView]", S0e = "[object Float32Array]", I0e = "[object Float64Array]", E0e = "[object Int8Array]", x0e = "[object Int16Array]", C0e = "[object Int32Array]", T0e = "[object Uint8Array]", P0e = "[object Uint8ClampedArray]", k0e = "[object Uint16Array]", N0e = "[object Uint32Array]", kn = {};
kn[$R] = kn[l0e] = kn[_0e] = kn[w0e] = kn[c0e] = kn[u0e] = kn[S0e] = kn[I0e] = kn[E0e] = kn[x0e] = kn[C0e] = kn[p0e] = kn[h0e] = kn[AR] = kn[m0e] = kn[v0e] = kn[g0e] = kn[y0e] = kn[T0e] = kn[P0e] = kn[k0e] = kn[N0e] = !0;
kn[d0e] = kn[DR] = kn[b0e] = !1;
function vh(t, e, n, r, s, i) {
  var o, a = e & i0e, l = e & o0e, c = e & a0e;
  if (n && (o = s ? n(t, r, s, i) : n(t)), o !== void 0)
    return o;
  if (!t0e(t))
    return t;
  var u = q_e(t);
  if (u) {
    if (o = X_e(t), !a)
      return V_e(t, o);
  } else {
    var d = Z_e(t), f = d == DR || d == f0e;
    if (Q_e(t))
      return H_e(t, a);
    if (d == AR || d == $R || f && !s) {
      if (o = l || f ? {} : J_e(t), !a)
        return l ? U_e(t, W_e(o, t)) : z_e(t, j_e(o, t));
    } else {
      if (!kn[d])
        return s ? t : {};
      o = K_e(t, d, a);
    }
  }
  i || (i = new L_e());
  var p = i.get(t);
  if (p)
    return p;
  i.set(t, o), n0e(t) ? t.forEach(function(v) {
    o.add(vh(v, e, n, v, t, i));
  }) : e0e(t) && t.forEach(function(v, y) {
    o.set(y, vh(v, e, n, y, t, i));
  });
  var h = c ? l ? Y_e : G_e : l ? s0e : r0e, m = u ? void 0 : h(t);
  return F_e(m || t, function(v, y) {
    m && (y = v, v = t[y]), B_e(o, y, vh(v, e, n, y, t, i));
  }), o;
}
var u2 = vh, $0e = u2, D0e = 1, A0e = 4;
function O0e(t) {
  return $0e(t, D0e | A0e);
}
var M0e = O0e;
const Or = /* @__PURE__ */ Et(M0e);
function OR({ selectedItemsRef: t, isTwoWaySelectableRef: e }) {
  const n = le(() => e.value ? (f) => !!~t.value.findIndex(({ id: p }) => p === f.id) : (f) => t.value.includes(f.id)), r = (f) => [...f.track].reverse().reduce((m, v) => m || n.value({ id: v }), !1), s = (f) => {
    const p = t.value.find(({ id: h }) => h === f.id);
    return p && p.state === "included";
  }, i = (f) => !![...f.track].reverse().reduce((m, v) => m !== null ? m : n.value({ id: v }) ? s({ id: v }) : null, null), o = (f) => [...f.track].reverse().reduce((m, v) => m || (n.value({ id: v }) ? s({ id: v }) : !1), !1), a = (f) => {
    const p = t.value.find(({ id: h }) => h === f.id);
    return p && p.state === "ignored";
  }, l = (f) => !![...f.track].reverse().reduce((m, v) => m !== null ? m : n.value({ id: v }) ? a({ id: v }) : null, null), c = (f) => {
    const p = t.value.find(({ id: h }) => h === f.id);
    return p && p.state === "excluded";
  };
  return {
    isSelected: n,
    isParentSelected: r,
    isIncluded: s,
    isParentIncluded: i,
    isParentAncestorIncluded: o,
    isIgnored: a,
    isParentIgnored: l,
    isExcluded: c,
    isParentExcluded: (f) => !![...f.track].reverse().reduce((m, v) => m !== null ? m : n.value({ id: v }) ? c({ id: v }) : null, null),
    isParentAncestorExcluded: (f) => [...f.track].reverse().reduce((m, v) => m || (n.value({ id: v }) ? c({ id: v }) : !1), !1)
  };
}
function R0e(t, e, n) {
  function r(l) {
    const c = t.value.findIndex(({ id: u }) => u === l);
    ~c ? t.value[c].state === "excluded" && (t.value[c].state = "included") : t.value = [
      ...t.value,
      { id: l, state: "included" }
    ], a(l, "included");
  }
  function s(l) {
    const c = t.value.findIndex((u) => u.id === l);
    t.value[c] ? t.value[c].state = "excluded" : t.value.unshift({ id: l, state: "excluded" }), a(l, "excluded");
  }
  function i(l) {
    const c = t.value.findIndex((u) => u.id === l);
    t.value[c] ? t.value[c].state = "ignored" : t.value.unshift({ id: l, state: "ignored" });
  }
  function o(l) {
    t.value = t.value.filter(({ id: c }) => c !== l);
  }
  function a(l, c) {
    var d;
    const u = (d = e.value[l]) == null ? void 0 : d.children;
    !u || !u.length || u.forEach((f) => {
      const p = t.value.findIndex(
        ({ id: m }) => m === f
      );
      if (~p) {
        const m = c === "any";
        (t.value[p].state === c || m || n({ id: f })) && o(f);
      }
      a(f, c);
    });
  }
  return {
    includeItem: r,
    excludeItem: s,
    ignoreItem: i,
    removeItem: o,
    removeChildren: a
  };
}
function MR(t, e, n) {
  const r = OR({
    selectedItemsRef: e,
    isTwoWaySelectableRef: n
  }), s = R0e(e, t, r.isIgnored);
  return {
    ...r,
    ...s
  };
}
const L0e = "_root_hx2h0_1", F0e = "_mini_hx2h0_6", B0e = "_action_hx2h0_16", j0e = "_action_primary_hx2h0_23", W0e = {
  root: L0e,
  mini: F0e,
  default: "_default_hx2h0_11",
  action: B0e,
  action_primary: j0e
}, H0e = {
  name: "PbActionsButtonGroup",
  components: {
    PbButton: nt
  },
  props: {
    buttonsText: {
      type: Object,
      default: () => ({
        apply: "Применить",
        cancel: "Отмена"
      })
    },
    size: {
      type: String,
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    applyFn: {
      type: Function,
      required: !0
    },
    cancelFn: {
      type: Function,
      required: !0
    }
  }
};
var V0e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("PbButton", { class: [e.$style.action, e.$style.action_primary, e.$style[e.size]], attrs: { disabled: e.disabled, "data-test-selector": "apply-btn" }, on: { click: e.applyFn } }, [e._v(" " + e._s(e.buttonsText.apply) + " ")]), n("PbButton", { class: [e.$style.action, e.$style[e.size]], attrs: { "data-test-selector": "cancel-btn" }, on: { click: e.cancelFn } }, [e._v(" " + e._s(e.buttonsText.cancel) + " ")]), e._t("additional")], 2);
}, z0e = [];
const OP = {
  $style: W0e
};
function U0e(t) {
  for (var e in OP)
    this[e] = OP[e];
}
var G0e = /* @__PURE__ */ B(
  H0e,
  V0e,
  z0e,
  !1,
  U0e,
  null
);
const Ou = G0e.exports, Y0e = "_root_10knx_1", Z0e = "_button_10knx_8", X0e = "_button_active_10knx_20", K0e = "_content_10knx_25", J0e = {
  root: Y0e,
  button: Z0e,
  button_active: X0e,
  content: K0e
}, q0e = {
  name: "PbButtonSwitcher",
  components: { PbButton: nt },
  model: {
    prop: "activeButton",
    event: "change"
  },
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    activeButton: [Boolean, Number, String],
    activeClass: String,
    buttonClass: String,
    contentClass: String,
    height: {
      type: Number,
      default: 22
    }
  }
};
var Q0e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, style: { height: e.height + "px" } }, [e._t("default", function() {
    return e._l(e.buttons, function(r) {
      return n("PbButton", { key: r.type, class: e.buttonClass || e.$style.button, attrs: { activeClass: e.activeClass || e.$style.button_active, contentClass: e.contentClass || e.$style.content, value: r.value, disabled: r.disabled, active: e.activeButton === r.value, "data-test-selector": r.testSelector || null, "data-test-attrs": r.testAttrs || null }, on: { click: function(s) {
        return e.$emit("change", r.value);
      } } }, [e._v(" " + e._s(r.label) + " ")]);
    });
  })], 2);
}, e1e = [];
const MP = {
  $style: J0e
};
function t1e(t) {
  for (var e in MP)
    this[e] = MP[e];
}
var n1e = /* @__PURE__ */ B(
  q0e,
  Q0e,
  e1e,
  !1,
  t1e,
  null
);
const rl = n1e.exports, r1e = "_root_1n7cx_1", s1e = {
  root: r1e
}, i1e = {
  name: "icon",
  props: {
    type: {
      type: String,
      default: "svg",
      validator: (t) => ["svg", "font"].includes(t)
    },
    name: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "inherit"
    },
    size: {
      type: [String, Number],
      default: 20
    },
    css: {
      type: String,
      default: ""
    }
  },
  computed: {
    href() {
      if (this.type === "font") return null;
      if (this.name.includes("/")) {
        const t = this.name.split("/");
        return `#${t[0]}/pub-${t[1]}`;
      }
      return `#pub-${this.name}`;
    },
    cssBase() {
      return {
        // В Firefox `size` всегда строка, просто typeof this.size не поможет
        // Проверяем, что в size только цифры и точка, тогда добавляем `px`
        "font-size": /^(\d*|\.)*$/g.test(this.size) ? `${this.size}px` : this.size,
        color: this.color
      };
    },
    cssOverride() {
      return this.convertCSS(this.css);
    }
  },
  methods: {
    /**
     * Конвертирует CSS в объект
     * @param {string} cssText - строка CSS
     * @returns {Object}
     */
    convertCSS(t) {
      const e = new RegExp(/([\w-]*)\s*:\s*([^;]*)/g);
      let n, r = {};
      for (; (n = e.exec(t)) !== null; )
        r[n[1]] = n[2].trim();
      return r;
    }
  }
};
var o1e = function() {
  var e = this, n = e._self._c;
  return e.type === "svg" ? n("svg", { class: [e.$style.root, "pb-icon"], style: [e.cssBase, e.cssOverride] }, [n("use", { attrs: { "xlink:href": e.href } })]) : e.type === "font" ? n("i", { class: [e.$style.root, "pb-icon", "material-icons"], style: [e.cssBase, e.cssOverride] }, [e._v(e._s(e.name))]) : e._e();
}, a1e = [];
const RP = {
  $style: s1e
};
function l1e(t) {
  for (var e in RP)
    this[e] = RP[e];
}
var c1e = /* @__PURE__ */ B(
  i1e,
  o1e,
  a1e,
  !1,
  l1e,
  null
);
const cc = c1e.exports, u1e = "_root_1m85k_1", d1e = "_root_compact_1m85k_24", f1e = "_root_dark_1m85k_30", p1e = "_prependIcon_1m85k_33", h1e = "_appendIcon_1m85k_34", m1e = "_root_rounded_1m85k_57", v1e = "_root_slim_1m85k_60", g1e = "_wrapper_1m85k_64", y1e = "_prependIcon_clickable_1m85k_79", b1e = "_appendIcon_clickable_1m85k_80", _1e = {
  root: u1e,
  root_compact: d1e,
  root_dark: f1e,
  prependIcon: p1e,
  appendIcon: h1e,
  root_rounded: m1e,
  root_slim: v1e,
  wrapper: g1e,
  prependIcon_clickable: y1e,
  appendIcon_clickable: b1e
}, w1e = {
  name: "SearchField",
  components: {
    PbIcon: cc
  },
  props: {
    clearable: {
      type: Boolean,
      default: !0
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    throttle: {
      type: Number,
      default: 300
    },
    initialQuery: {
      type: String,
      default: ""
    },
    compact: {
      type: Boolean,
      default: !1
    },
    dark: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    slim: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      query: "",
      focused: !1
    };
  },
  computed: {
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_compact]: this.compact,
        [this.$style.root_dark]: this.dark,
        [this.$style.root_rounded]: this.rounded,
        [this.$style.root_slim]: this.slim
      };
    }
  },
  methods: {
    clearQuery() {
      this.query = "", this.$emit("input", this.query), this.focus();
    },
    emitUpdate() {
      this.$emit("input", this.query);
    },
    handleInput() {
      this.queryTimer && clearTimeout(this.queryTimer), this.queryTimer = setTimeout(this.emitUpdate.bind(this), this.throttle);
    },
    focus() {
      this.$refs.input && this.$refs.input.focus();
    },
    blur() {
      const t = this.$refs.input;
      t && t.blur();
    }
  },
  watch: {
    focused(t, e) {
      t !== e && (this.query && this.query.length ? t ? this.$enableShortcut("Escape") : this.$disableShortcut("Escape") : this.$disableShortcut("Escape"));
    },
    query(t, e) {
      t !== e && (this.query && this.query.length ? this.$enableShortcut("Escape") : this.$disableShortcut("Escape"));
    }
  },
  created() {
    this.queryTimer = null, this.$shortcuts && this.$registerShortcut("Escape", this.clearQuery, {
      enabled: !1,
      capture: !0
    }), this.query = this.initialQuery;
  },
  mounted() {
    this.$nextTick(() => {
      this.autofocus && this.$refs.input.focus();
    });
  }
};
var S1e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass, attrs: { "data-test-selector": "search-field" } }, [n("div", { class: e.$style.wrapper }, [n("PbIcon", { class: e.$style.prependIcon, attrs: { type: "font", name: "search", size: e.compact ? 18 : void 0 } }), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.query, expression: "query" }], ref: "input", attrs: { type: "search", disabled: e.disabled, placeholder: e.placeholder }, domProps: { value: e.query }, on: { input: [function(r) {
    r.target.composing || (e.query = r.target.value);
  }, e.handleInput], focus: function(r) {
    e.focused = !0;
  }, blur: function(r) {
    e.focused = !1;
  } } }), e.clearable ? n("transition", { attrs: { name: "fade-transition", duration: 100 } }, [n("PbIcon", { directives: [{ name: "show", rawName: "v-show", value: e.query, expression: "query" }], class: [e.$style.appendIcon, e.$style.appendIcon_clickable], attrs: { type: "font", name: "close" }, nativeOn: { click: function(r) {
    return e.clearQuery.apply(null, arguments);
  } } })], 1) : e._e()], 1)]);
}, I1e = [];
const LP = {
  $style: _1e
};
function E1e(t) {
  for (var e in LP)
    this[e] = LP[e];
}
var x1e = /* @__PURE__ */ B(
  w1e,
  S1e,
  I1e,
  !1,
  E1e,
  null
);
const Mu = x1e.exports, C1e = "_root_1kfda_1", T1e = "_root_dark_1kfda_7", P1e = "_item_disabled_1kfda_11", k1e = "_element_1kfda_19", N1e = "_option_1kfda_27", $1e = "_itemAdditional_1kfda_34", D1e = "_itemBlock_1kfda_38", A1e = "_itemBlock_label_1kfda_43", O1e = {
  root: C1e,
  root_dark: T1e,
  item_disabled: P1e,
  element: k1e,
  option: N1e,
  itemAdditional: $1e,
  itemBlock: D1e,
  itemBlock_label: A1e
}, M1e = {
  name: "PbVirtualTreeItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    titleName: {
      type: [String, Function],
      required: !0
    },
    isOpened: {
      type: Boolean,
      default: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isSelectable: {
      type: Boolean,
      default: !1
    },
    isParentSelectable: {
      type: Boolean,
      default: !1
    },
    margin: {
      type: Object,
      default: () => ({
        drop: 0,
        value: 2,
        unit: "em"
      })
    },
    elementClassFn: {
      type: Function,
      default: () => {
      }
    },
    stylesFn: {
      type: Function,
      default: () => {
      }
    },
    isDarkThemed: {
      type: Boolean,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      default: !1
    },
    disabledReason: {
      type: String,
      default: "Нельзя выбрать этот элемент"
    }
  },
  computed: {
    marginLeft() {
      const t = this.item, e = t.track.slice(1), n = Number(this.isParentSelectable) + 1, r = Number(this.isSelectable) + +!!t.children.length, s = n - r > 0 ? n - r : 0;
      return this.margin.value * e.length + this.margin.drop * s + this.margin.unit;
    },
    itemClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_dark]: this.isDarkThemed,
        [this.$style.item_disabled]: this.isDisabled
      };
    },
    title() {
      return typeof this.titleName == "string" ? this.item[this.titleName] ? `${this.item[this.titleName]}` : "" : typeof this.titleName == "function" ? `${this.titleName(this.item)}` : "";
    }
  }
};
var R1e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { ...e.itemClass, [`level-${e.item.track.length}`]: !0 }, attrs: { "data-test-selector": "tree-item", "data-test-attrs": `type__${e.item.children && e.item.children.length ? "branch" : "leaf"}`, "data-test-id": e.item.id, title: e.isDisabled && e.disabledReason } }, [n("div", { class: e.$style.option, style: {
    marginLeft: e.marginLeft,
    ...e.stylesFn(e.item)
  } }, [e._t("option", function() {
    return [e._t("toggle", function() {
      return [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.item.children && e.item.children.length, expression: "item.children && item.children.length" }], class: [e.$style.itemBlock, e.$style.itemBlock_toggle], attrs: { "data-test-selector": "tree-item-toggle", "data-test-attrs": e.isOpened ? "arrow-opened" : "arrow-closed" }, on: { click: function(r) {
        return r.stopPropagation(), e.$emit("toggle");
      } } }, [n("icon", { attrs: { name: e.isOpened ? "list-arrow-closed" : "list-arrow-opened", size: 15 } })], 1)];
    }, null, {
      item: e.item,
      isSelected: e.isSelected,
      isOpened: e.isOpened
    }), e._t("element", function() {
      return [n("div", { class: {
        [e.$style.element]: !0,
        ...e.elementClassFn(e.item)
      }, on: { click: function(r) {
        return r.stopPropagation(), e.$emit(e.isSelectable ? "select" : "toggle");
      } } }, [e.isSelectable ? [e._t("checkbox", function() {
        return [n("div", { class: [e.$style.itemBlock, e.$style.itemBlock_checkbox], attrs: { "data-test-selector": "tree-item-checkbox", "data-test-attrs": e.isSelected ? "minus" : "plus" }, on: { click: function(r) {
          return r.stopPropagation(), e.$emit("select");
        } } }, [e._t("item-icon", function() {
          return [n("icon", { attrs: { name: e.isSelected ? "minus" : "plus", size: 15 } })];
        }, null, { item: e.item })], 2)];
      }, null, {
        item: e.item,
        isSelected: e.isSelected,
        isOpened: e.isOpened
      })] : e._e(), n("div", { class: [e.$style.itemBlock, e.$style.itemBlock_label] }, [e._t("label", function() {
        return [n("span", { attrs: { title: e.title } }, [e._v(" " + e._s(e.title) + " ")])];
      }, { dataTestSelector: "tree-item-label" }, {
        item: e.item,
        isSelected: e.isSelected,
        isOpened: e.isOpened
      })], 2)], 2)];
    }, null, {
      item: e.item,
      isSelected: e.isSelected,
      isOpened: e.isOpened
    })];
  }, null, {
    item: e.item,
    isSelected: e.isSelected,
    isOpened: e.isOpened
  }), n("div", { class: e.$style.itemAdditional }, [e._t("item-additional", null, null, { item: e.item })], 2)], 2)]);
}, L1e = [];
const FP = {
  $style: O1e
};
function F1e(t) {
  for (var e in FP)
    this[e] = FP[e];
}
var B1e = /* @__PURE__ */ B(
  M1e,
  R1e,
  L1e,
  !1,
  F1e,
  null
);
const RR = B1e.exports, j1e = "_root_fjpyw_1", W1e = "_root_theme_dark_fjpyw_7", H1e = "_item_fjpyw_10", V1e = "_search_fjpyw_14", z1e = "_list_fjpyw_19", U1e = "_empty_fjpyw_25", G1e = "_scroller_fjpyw_33", Y1e = {
  root: j1e,
  root_theme_dark: W1e,
  item: H1e,
  search: V1e,
  list: z1e,
  empty: U1e,
  scroller: G1e
};
function LR(t, e, n) {
  const r = t[e];
  r && (r.track.length > 1 && (n.indexOf(
    r.track[r.track.length - 1].toString()
  ) === -1 || n.indexOf(e.toString()) > -1) || (n.push(e.toString()), r.children && r.children.length && r.children.forEach((s) => {
    LR(t, s, n);
  })));
}
function BP(t, e, n) {
  return typeof e[t] == "string" ? n[t].toLowerCase() > e[t].toLowerCase() ? -1 : 1 : e[t] - n[t];
}
function Z1e(t) {
  Object.keys(t).forEach((e) => {
    var n;
    if (isNaN(e) || (e = parseInt(e)), (n = t[e]) != null && n.track && t[e].track.length > 1) {
      const r = t[t[e].track[t[e].track.length - 1]];
      r && (r.children || (r.children = []), r.children.includes(e) || r.children.push(e));
    }
  });
}
function FR(t, e, n, r = null) {
  t.sort((s, i) => {
    const o = e[s], a = e[i];
    return !o || !a ? 1 : (o.children && FR(a.children, e, n, r), o[n] && a[n] ? typeof r == "function" ? r(BP, n, o, a) : BP(n, o, a) : 1);
  });
}
function X1e(t, e, n) {
  const r = Object.keys(t);
  FR(r, t, e, n);
  const s = [];
  return r.forEach((i) => {
    LR(t, i, s);
  }), s.map((i) => t[i]);
}
function BR(t, e = "children", n = {}, r = null) {
  return n[t.id] = t, r ? (t.track = [...r.track], t.track.push(r.id)) : t.track = [], t[e] && (t[e].forEach((s) => {
    BR(s, e, n, t);
  }), t[e] = t.children.map(({ id: s }) => s)), n;
}
function K1e({ searchString: t, params: e = { fields: ["name"] } }) {
  return (n) => e.fields.reduce((r, s) => {
    let i = n[s];
    return e.caseSensitive || (i = i ? i.toLowerCase() : null, t = t.toLowerCase()), r || !!(i && i.indexOf(t) !== -1);
  }, !1);
}
function J1e({ list: t, items: e, predicates: n = [] }) {
  const r = [], s = {};
  for (let i of t)
    n.reduce((a, l) => a && l(i), !0) && (i.track.length && i.track.forEach((a) => {
      const l = e[a];
      l && (s[a] || (s[a] = !0, r.push(l)));
    }), s[i.id] = !0, r.push(i));
  return r;
}
const jP = () => ({
  autofocus: !0,
  minimalQueryLength: 1,
  caseSensitive: !1,
  placeholder: "Поиск",
  fields: ["name", "label"],
  throttle: 300,
  useDefaultSearch: !0,
  searchFunction: J1e
}), WP = () => ({
  selection: !1,
  search: !1,
  filter: !1,
  openPreSelected: !1
}), q1e = {
  name: "PbVirtualTree",
  components: {
    PsKitVirtualList: xR,
    SearchField: Mu,
    PbVirtualTreeItem: RR
  },
  mixins: [Vr],
  inject: ["getColorScheme"],
  model: {
    prop: "query",
    event: "change"
  },
  props: {
    items: {
      type: [Object, Array],
      required: !0
    },
    titleName: {
      type: [String, Function],
      required: !0
    },
    sortField: {
      type: [String, Number],
      default: "id"
    },
    compareFunction: {
      type: Function,
      default: null
    },
    query: {
      type: [String, Number],
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    features: {
      type: Object,
      default: WP
    },
    search: {
      type: Object,
      default: jP
    },
    filter: {
      type: Object,
      default: () => ({
        predicates: []
      })
    },
    margin: {
      type: Object,
      default: () => ({
        value: 2,
        unit: "em",
        drop: 0
      })
    },
    showDepth: {
      type: Number,
      default: 0
    },
    trackShift: {
      type: Number,
      default: 0
    },
    searchFieldClass: {
      type: String
    },
    isThemed: {
      type: Boolean,
      default: !0
    },
    isSelectable: {
      type: Function,
      default: () => !0
    }
  },
  data() {
    return {
      searchString: "",
      searchMode: !1,
      filterMode: Array.isArray(this.filter.predicates) ? !!this.filter.predicates.length : !1,
      visibleList: []
    };
  },
  computed: {
    featureParams() {
      return {
        ...WP(),
        ...this.features
      };
    },
    searchParams() {
      return {
        ...jP(),
        ...this.search
      };
    },
    sortedList() {
      return X1e(
        this.normalizedItems,
        this.sortField,
        this.compareFunction
      );
    },
    sizeDeps() {
      return () => [];
    },
    normalizedItems() {
      const t = Or(this.items);
      return Z1e(t), t;
    },
    filteredList() {
      let t = this.sortedList;
      if ((!this.featureParams.search || !this.searchMode) && (!this.featureParams.filter || !this.filterMode))
        return t;
      const e = [];
      return this.featureParams.search && this.searchMode && this.searchParams.useDefaultSearch && e.push(
        K1e({
          searchString: this.searchString,
          params: {
            fields: this.searchParams.fields,
            caseSensitive: this.searchParams.caseSensitive
          }
        })
      ), this.featureParams.filter && this.filterMode && this.filter.predicates.length && this.filter.predicates.forEach((n) => {
        e.push(n);
      }), t = this.searchParams.searchFunction({
        list: this.sortedList,
        items: this.items,
        predicates: e
      }), t;
    },
    isSelected() {
      return (t) => this.selected.includes(t.id);
    },
    isOpened() {
      return (t) => this.visualMap[t.id];
    },
    isDarkThemed() {
      return this.isThemed && this.getColorScheme().theme === "dark";
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_theme_dark]: this.isDarkThemed
      };
    }
  },
  watch: {
    searchString(t, e) {
      t !== e && (t !== this.query && this.$emit("change:query", t), this.searchMode = !!(t && t.length >= this.search.minimalQueryLength), this.$_resetVisualMap(), this.$_updateVisibleList(), this.$nextTick(() => {
        var r, s, i, o, a;
        const n = ((a = (o = (i = (s = (r = this.$refs.list) == null ? void 0 : r.$refs) == null ? void 0 : s.list) == null ? void 0 : i.$refs) == null ? void 0 : o.scroller) == null ? void 0 : a.$el) ?? null;
        n && (n.scrollTop = 0);
      }));
    },
    searchMode(t, e) {
      t !== e && (this.$_resetVisualMap(), this.$_updateVisibleList());
    },
    filterMode(t, e) {
      t !== e && (this.$_resetVisualMap(), this.$_updateVisibleList());
    },
    filter: {
      handler(t) {
        this.filterMode = Array.isArray(t.predicates) && !!t.predicates.length, this.$_resetVisualMap(), this.$_updateVisibleList();
      },
      deep: !0
    },
    query(t, e) {
      t !== e && t !== this.searchString && (this.searchString = t);
    }
  },
  created() {
    this.initial = !0, this.visualMap = {}, this.query && (this.searchMode = !0), this.query !== null && (this.searchString = this.query);
  },
  mounted() {
    this.featureParams.openPreSelected && Object.values(this.normalizedItems).forEach((t) => {
      this.selected.includes(t.id) && t.track && t.track.length > 1 && t.track.forEach((e, n) => {
        n > 0 && U.set(this.visualMap, e, !0);
      });
    }), this.$_updateVisibleList();
  },
  methods: {
    /**
     * Обновляет список видимых элементов.
     * Видимость рассчитыватся в зависимости от
     * параметров компонента (showDepth и trackShift),
     * указаний в visualMap и состояния родительского элемента
     */
    $_updateVisibleList() {
      const t = [], e = [], n = (r) => {
        e.includes(r.id) || (e.push(r.id), t.push(r));
      };
      for (let r of this.filteredList) {
        if (this.searchMode || this.filterMode) {
          const s = this.items[r.track[r.track.length - 1]];
          if (s && this.visualMap[s.id] === !1)
            continue;
          t.push(r), this.visualMap[r.id] !== !1 && (this.visualMap[r.id] = !0);
          continue;
        }
        if (this.initial) {
          r.track.length - this.trackShift <= 0 && n(r), r.track.length <= this.showDepth && (this.visualMap[r.id] = !0, n(r));
          continue;
        }
        if (r.track.length - this.trackShift <= 0) {
          n(r);
          continue;
        }
        if (this.visualMap[r.id]) {
          n(r);
          continue;
        }
        this.visualMap[r.track[r.track.length - 1]] && n(r);
      }
      this.initial = !1, this.visibleList = t;
    },
    $_hideRecursive(t) {
      t == null || t.children.forEach((e) => {
        var r;
        const n = this.normalizedItems[e];
        if ((r = n == null ? void 0 : n.children) != null && r.length)
          return this.visualMap[e] = !1, this.$_hideRecursive(n);
      });
    },
    $_resetVisualMap() {
      this.visualMap = {};
    },
    toggle(t) {
      if (!t.children || !t.children.length) return;
      const e = !this.visualMap[t.id];
      e || this.$_hideRecursive(t), this.visualMap[t.id] = e, this.$_updateVisibleList();
    },
    select(t) {
      this.isSelectable(t) && (this.selected.includes(t.id) ? (this.$emit(
        "update:selected",
        this.selected.filter((e) => e !== t.id)
      ), this.$emit("unselect", t.id)) : (this.$emit("update:selected", [t.id, ...this.selected]), this.$emit("select", t.id)));
    },
    unselect(t) {
      this.$emit("update:selected", [
        ...this.selected.filter(({ id: e }) => e !== t.id)
      ]), this.$emit("unselect", t.id);
    },
    isSelectableFn(t) {
      return this.features.selection ? this.isSelectable(t) : !1;
    },
    isParentSelectableFn(t) {
      if (!this.features.selection) return !1;
      const e = t.track.slice(1), n = e.length && {
        id: e[e.length - 1],
        children: [t.id],
        track: [...e].slice(0, -1)
      };
      return !!n && this.isSelectable(n);
    }
  }
};
var Q1e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass }, [e.featureParams.search ? n("div", { class: e.$style.search, attrs: { "data-test-selector": "tree-search-field" } }, [e._t("search", function() {
    return [n("SearchField", { ref: "searchField", class: e.searchFieldClass, attrs: { clearable: !0, placeholder: e.search.placeholder, autofocus: e.search.autofocus, initialQuery: e.searchString, throttle: e.search.throttle }, on: { input: function(r) {
      e.searchString = r;
    } } })];
  }, null, {
    searchString: e.searchString,
    search: e.searchParams
  })], 2) : e._e(), n("div", { ref: "listWrapper", class: e.$style.list, attrs: { "data-test-selector": "tree-list" } }, [(e.searchMode || e.filterMode) && e.filteredList.length === 0 ? n("div", { class: e.$style.empty }, [e._v(" Ничего не найдено ")]) : n("PsKitVirtualList", { ref: "list", class: e.$style.scroller, attrs: { items: e.visibleList, minItemSize: 20, sizeDeps: e.sizeDeps, animations: { enabled: !1 }, emitScroll: !0 }, on: { scroll: (r) => e.$emit("scroll", r) }, scopedSlots: e._u([{ key: "before-content", fn: function() {
    return [n("portal-target", { attrs: { name: "itemMenu" } })];
  }, proxy: !0 }, { key: "default", fn: function({ item: r }) {
    return [e._t("item", function() {
      return [n("PbVirtualTreeItem", { attrs: { item: r, margin: e.margin, titleName: e.titleName, isOpened: e.isOpened(r), isSelected: e.isSelected(r), isSelectable: e.isSelectableFn(r), isParentSelectable: e.isParentSelectableFn(r), isDarkThemed: e.isDarkThemed }, on: { toggle: function(s) {
        return e.toggle(r);
      }, select: function(s) {
        return e.select(r);
      } } })];
    }, null, {
      item: r,
      isOpened: e.isOpened(r),
      isSelected: e.isSelected(r),
      isSelectable: e.isSelectableFn(r),
      isParentSelectable: e.isParentSelectableFn(r),
      isDarkThemed: e.isDarkThemed,
      toggle: e.toggle,
      select: e.select
    })];
  } }], null, !0) })], 1)]);
}, ewe = [];
const HP = {
  $style: Y1e
};
function twe(t) {
  for (var e in HP)
    this[e] = HP[e];
}
var nwe = /* @__PURE__ */ B(
  q1e,
  Q1e,
  ewe,
  !1,
  twe,
  null
);
const rwe = nwe.exports, swe = "_highlight_9gpw7_1", iwe = "_highlight_included_9gpw7_4", owe = "_highlight_included_light_9gpw7_8", awe = "_highlight_excluded_9gpw7_12", lwe = "_highlight_excluded_light_9gpw7_16", cwe = "_menu_9gpw7_21", uwe = "_menuDropdown_9gpw7_28", dwe = {
  highlight: swe,
  highlight_included: iwe,
  highlight_included_light: owe,
  highlight_excluded: awe,
  highlight_excluded_light: lwe,
  menu: cwe,
  menuDropdown: uwe
}, fwe = {
  components: {
    PbVirtualTree: rwe,
    PbVirtualTreeItem: RR
  },
  mixins: [Vr],
  props: {
    items: {
      type: [Object, Array],
      required: !0
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    titleName: {
      type: [String, Function],
      required: !0
    },
    sortField: {
      type: [String, Number],
      default: "id"
    },
    features: {
      type: Object,
      default: () => ({
        selection: !1,
        search: !1,
        filter: !1,
        openPreSelected: !1,
        highlight: !1,
        menu: !1
      })
    },
    margin: {
      type: Object,
      default: () => ({
        value: 2,
        unit: "em",
        drop: 0
      })
    },
    search: {
      type: Object,
      default: () => ({
        minimalQueryLength: 1,
        autofocus: !0,
        caseSensitive: !1,
        placeholder: "Поиск",
        useDefaultSearch: !0,
        predicates: [],
        fields: ["name", "label"],
        throttle: 300
      })
    },
    filter: {
      type: Object,
      default: () => ({
        predicates: []
      })
    },
    query: {
      type: [String, Number],
      default: ""
    },
    colors: {
      type: Object,
      default: () => ({})
    },
    showDepth: {
      type: Number,
      default: 0
    },
    trackShift: {
      type: Number,
      default: 0
    },
    searchFieldClass: {
      type: String
    },
    twoWaySelection: {
      type: Boolean,
      default: !1
    },
    isThemed: {
      type: Boolean,
      default: !0
    },
    isSelectable: {
      type: Function,
      default: () => !0
    },
    checkDisabled: {
      type: Function,
      default: () => !1
    },
    disabledReason: {
      type: String,
      default: "Нельзя выбрать этот элемент"
    }
  },
  model: {
    prop: "query",
    event: "change"
  },
  setup(t) {
    const {
      selectedItems: e,
      twoWaySelection: n
    } = ts(t);
    return { ...OR({ selectedItemsRef: e, isTwoWaySelectableRef: n }) };
  },
  data() {
    return {
      itemMenu: {
        hoveredId: null,
        visibleId: null,
        position: {
          top: 0,
          right: 0,
          bottom: 0
        }
      }
    };
  },
  computed: {
    elementClass() {
      return (t) => this.features.highlight ? {
        [this.$style.highlight]: !0,
        [this.$style.highlight_included]: this.isSelected(t) && this.isIncluded(t),
        [this.$style.highlight_included_light]: !this.isSelected(t) && !this.isIgnored(t) && this.isParentSelected(t) && this.isParentIncluded(t),
        [this.$style.highlight_excluded]: this.isSelected(t) && !this.isIncluded(t) && !this.isIgnored(t),
        [this.$style.highlight_excluded_light]: !this.isSelected(t) && !this.isIgnored(t) && this.isParentSelected(t) && !this.isParentIncluded(t) && !this.isParentIgnored(t)
      } : {};
    },
    isHovered() {
      return (t) => this.itemMenu.hoveredId === t.id;
    },
    itemColor() {
      return ({ id: t, track: e }) => {
        var r;
        let n = (r = this.colors[t]) == null ? void 0 : r.value;
        return n || (n = [...e].reverse().reduce((s, i) => s !== null ? s : this.colors[i] && this.colors[i].includeChildren ? this.colors[i].value : null, null), n);
      };
    },
    itemStyles() {
      return (t) => ({
        color: this.itemColor(t)
      });
    }
  },
  methods: {
    handleItemHover(t) {
      this.itemMenu.hoveredId = t;
    },
    handleItemBlur() {
      this.itemMenu.hoveredId = null;
    },
    showMenu(t, e) {
      const r = this.$refs.tree.$refs.list.$refs.dynamicScroller.$refs.scroller.$el, s = t.target.getBoundingClientRect(), i = r.getBoundingClientRect(), o = s.top + r.scrollTop + s.height + 2 - i.top;
      o + 200 >= i.top + i.height + 8 ? this.itemMenu.position.bottom = i.bottom - r.scrollTop - s.bottom + s.height + 2 : this.itemMenu.position.top = o, this.itemMenu.position.right = i.right - s.right - (r.offsetWidth - r.clientWidth), this.itemMenu.visibleId = e.id;
    },
    closeMenu() {
      this.itemMenu.visibleId = null, this.itemMenu.position = {
        top: 0,
        right: 0,
        bottom: 0
      };
    },
    select(t) {
      if (!(!this.isSelectable(t) || this.checkDisabled(t)))
        if (this.twoWaySelection) {
          const e = this.selectedItems.findIndex(
            ({ id: r }) => r === t.id
          ), n = this.selectedItems[e];
          e >= 0 ? n.state === "included" ? this.isParentIgnored(t) ? this.unselect(t) : this.isParentSelected(t) && !this.isParentIncluded(t) ? this.ignore(t) : this.exclude(t, e) : n.state === "excluded" ? this.isParentSelected(t) && !this.isParentIgnored(t) ? this.ignore(t, e) : this.unselect(t) : this.unselect(t) : this.isParentSelected(t) && this.isParentIncluded(t) ? this.exclude(t, e) : this.isParentSelected(t) && this.isParentIgnored(t) ? this.isParentAncestorIncluded(t) ? this.include(t) : this.exclude(t, e) : this.include(t);
        } else
          this.selectedItems.includes(t.id) ? (this.$emit(
            "update:selected",
            this.selectedItems.filter((e) => e !== t.id)
          ), this.$emit("unselect", t.id)) : (this.$emit("update:selected", [t.id, ...this.selectedItems]), this.$emit("select", t.id));
    },
    include(t) {
      this.$emit("update:selected", [
        { id: t.id, state: "included" },
        ...this.selectedItems
      ]), this.$emit("select:included", t.id);
    },
    exclude(t, e) {
      const n = [...this.selectedItems];
      n[e] ? n[e].state = "excluded" : n.unshift({ id: t.id, state: "excluded" }), this.$emit("update:selected", n), this.$emit("select:excluded", t.id);
    },
    ignore(t, e) {
      const n = [...this.selectedItems];
      n[e] ? n[e].state = "ignored" : n.unshift({ id: t.id, state: "ignored" }), this.$emit("update:selected", n), this.$emit("select:ignored", t.id);
    },
    unselect(t) {
      this.$emit("update:selected", [
        ...this.selectedItems.filter(({ id: e }) => e !== t.id)
      ]), this.$emit("unselect", t.id);
    }
  }
};
var pwe = function() {
  var e = this, n = e._self._c;
  return n("PbVirtualTree", { ref: "tree", attrs: { items: e.items, selected: e.selectedItems, titleName: e.titleName, features: e.features, search: e.search, filter: e.filter, margin: e.margin, sortField: e.sortField, trackShift: e.trackShift, searchFieldClass: e.searchFieldClass, isThemed: e.isThemed, isSelectable: e.isSelectable }, on: { scroll: (r) => e.$emit("scroll", r) }, scopedSlots: e._u([{ key: "item", fn: function({
    item: r,
    isOpened: s,
    isSelectable: i,
    isParentSelectable: o,
    isDarkThemed: a,
    toggle: l
  }) {
    return [n("PbVirtualTreeItem", { attrs: { item: r, margin: e.margin, titleName: e.titleName, isOpened: s, isSelected: e.isSelected(r), isSelectable: i, isDisabled: e.checkDisabled(r), disabledReason: e.disabledReason, isParentSelectable: o, isDarkThemed: a, stylesFn: e.itemStyles, elementClassFn: e.elementClass }, on: { toggle: () => {
      l(r), e.closeMenu();
    }, select: () => {
      e.select(r), e.closeMenu();
    } }, nativeOn: { mouseenter: function(c) {
      return e.handleItemHover(r.id);
    }, mouseleave: function(c) {
      return e.handleItemBlur.apply(null, arguments);
    }, focus: function(c) {
      return e.handleItemHover(r.id);
    }, blur: function(c) {
      return e.handleItemBlur.apply(null, arguments);
    } }, scopedSlots: e._u([e.twoWaySelection ? { key: "item-icon", fn: function({ item: c }) {
      return [n("icon", { attrs: { name: e.isSelected(c) ? e.isIncluded(c) ? "plus" : e.isIgnored(c) ? "source-leaf-icon" : "minus" : "source-leaf-icon", size: 15 } })];
    } } : null, e.features.menu ? { key: "item-additional", fn: function({ item: c }) {
      return [n("div", { class: e.$style.menu, attrs: { "data-test-selector": "tree-item-menu" }, on: { click: (u) => e.showMenu(u, c) } }, [n("icon", { directives: [{ name: "show", rawName: "v-show", value: e.isHovered(c) && !e.itemMenu.visibleId || e.itemMenu.visibleId === c.id, expression: `
              (isHovered(item) && !itemMenu.visibleId) ||
                itemMenu.visibleId === item.id
            ` }], attrs: { name: "menu", size: 15 } }), e.itemMenu.visibleId === c.id ? n("portal", { attrs: { to: "itemMenu" } }, [n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.closeMenu, expression: "closeMenu" }], ref: "itemMenuDropdown", class: e.$style.menuDropdown, style: {
        top: e.itemMenu.position.top ? e.itemMenu.position.top + "px" : null,
        right: e.itemMenu.position.right + "px",
        bottom: e.itemMenu.position.bottom ? e.itemMenu.position.bottom + "px" : null
      } }, [e._t("itemMenu", null, null, { item: c, closeMenu: e.closeMenu })], 2)]) : e._e()], 1)];
    } } : null], null, !0) })];
  } }]), model: { value: e.query, callback: function(r) {
    e.query = r;
  }, expression: "query" } });
}, hwe = [];
const VP = {
  $style: dwe
};
function mwe(t) {
  for (var e in VP)
    this[e] = VP[e];
}
var vwe = /* @__PURE__ */ B(
  fwe,
  pwe,
  hwe,
  !1,
  mwe,
  null
);
const jR = vwe.exports, gwe = "_root_bd27t_1", ywe = "_title_bd27t_13", bwe = "_items_bd27t_18", _we = "_item_bd27t_18", wwe = "_item_included_bd27t_32", Swe = "_item_excluded_bd27t_37", Iwe = "_label_bd27t_43", Ewe = "_remove_bd27t_48", xwe = "_empty_bd27t_59", Cwe = "_empty_warn_bd27t_64", Twe = "_menu_bd27t_68", Pwe = {
  root: gwe,
  title: ywe,
  items: bwe,
  item: _we,
  item_included: wwe,
  item_excluded: Swe,
  label: Iwe,
  remove: Ewe,
  empty: xwe,
  empty_warn: Cwe,
  menu: Twe
}, kwe = {
  name: "PbManagerSelectedItems",
  props: {
    availableItems: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Object,
      required: !0
    },
    selectedItems: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      default: null
    },
    labels: {
      type: Array,
      required: !0
    },
    isRemovable: {
      type: Boolean,
      default: !1
    },
    noItemsText: {
      type: String,
      default: "Нет выбранных элементов"
    },
    isNoItemsWarn: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    itemClass() {
      return (t) => ({
        [this.$style.item]: !0,
        [this.$style.item_included]: t.state === "included",
        [this.$style.item_excluded]: t.state === "excluded"
      });
    },
    label() {
      return (t) => this.labels.reduce((e, n) => {
        var r, s;
        return e || ((r = this.items[t.id]) == null ? void 0 : r[n]) || ((s = this.availableItems[t.id]) == null ? void 0 : s[n]);
      }, !1);
    },
    selectedItemsFiltered() {
      return this.selectedItems.filter((t) => t.state !== "ignored");
    },
    isItemExist() {
      return (t) => Object.values(this.availableItems).map((n) => n.id).includes(t);
    }
  }
};
var Nwe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e.title ? n("div", { class: e.$style.title }, [e._v(e._s(e.title) + ":")]) : e._e(), e.selectedItems.length > 0 ? n("div", { class: e.$style.items }, e._l(e.selectedItemsFiltered, function(r) {
    return n("div", { key: r.id, class: e.itemClass(r) }, [n("span", { class: e.$style.label, attrs: { "data-test-selector": `selected-item-${r.state}`, "data-test-attrs": `id__${r.id}` } }, [e._v(" " + e._s(e.label(r)) + " ")]), n("icon", { class: e.$style.remove, attrs: { type: "font", name: "close", size: "14" }, nativeOn: { click: function(s) {
      return e.$emit("remove", r.id);
    } } })], 1);
  }), 0) : n("div", { class: { [e.$style.empty]: !0, [e.$style.empty_warn]: e.isNoItemsWarn } }, [e._v(e._s(e.noItemsText))])]);
}, $we = [];
const zP = {
  $style: Pwe
};
function Dwe(t) {
  for (var e in zP)
    this[e] = zP[e];
}
var Awe = /* @__PURE__ */ B(
  kwe,
  Nwe,
  $we,
  !1,
  Dwe,
  null
);
const Ru = Awe.exports, Owe = "_manager_khzig_1", Mwe = "_root_khzig_1", Rwe = "_tree_khzig_8", Lwe = "_selected_khzig_11", Fwe = "_selectedList_khzig_14", Bwe = "_footer_khzig_17", jwe = "_checkbox_khzig_23", Wwe = "_search_khzig_27", Hwe = {
  manager: Owe,
  root: Mwe,
  tree: Rwe,
  selected: Lwe,
  selectedList: Fwe,
  footer: Bwe,
  checkbox: jwe,
  search: Wwe
}, Vwe = {
  name: "PbCodeManager",
  components: {
    PbVirtualTreeEnhanced: jR,
    PbManagerSelectedItems: Ru
  },
  inject: ["getColorScheme"],
  props: {
    query: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: "default",
      validator(t) {
        return ["default", "selected", "colored"].includes(t);
      }
    },
    pickedCodes: {
      type: Array,
      required: !0
    },
    visibleCodes: {
      type: Object,
      default: () => ({})
    },
    allCodes: {
      type: Object,
      default: () => ({})
    },
    colors: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: "Коды новости"
    },
    fontSize: {
      type: Number,
      default: 12
    },
    isSelectable: {
      type: Function,
      default: () => !0
    },
    isHighLighted: {
      type: Boolean,
      default: !1
    },
    isThemed: {
      type: Boolean,
      default: !0
    },
    withItemMenu: {
      type: Boolean,
      default: !1
    },
    withSelectedItems: {
      type: Boolean,
      default: !1
    },
    isSelectedItemsRemovable: {
      type: Boolean,
      default: !1
    },
    twoWaySelection: {
      type: Boolean,
      default: !1
    },
    checkDisabled: {
      type: Function,
      default: () => !1
    },
    disabledReason: {
      type: String,
      default: "Нельзя выбрать этот код"
    }
  },
  data() {
    return {
      plainValue: null,
      initial: !0,
      showed: !1,
      searchQuery: "",
      listScroll: 0
    };
  },
  computed: {
    selectedCodes() {
      return this.pickedCodes.filter((t) => (t == null ? void 0 : t.state) !== "ignored");
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.manager]: !0,
        [this.$style.root_theme_dark]: this.isThemed && this.getColorScheme().theme === "dark"
      };
    },
    filter() {
      switch (this.mode) {
        case "colored":
          return { predicates: [this.colorsPredicate] };
        case "selected":
          return { predicates: [this.selectedPredicate] };
        default:
          return { predicates: [] };
      }
    },
    style() {
      return {
        "font-size": this.fontSize + "px !important"
      };
    }
  },
  created() {
    this.isMultiple && (this.value = this.pickedCodes);
  },
  mounted() {
    const t = this.query.trim();
    t.length && (this.searchQuery = t);
  },
  activated() {
    var e, n, r, s, i, o, a, l, c;
    const t = (c = (l = (a = (o = (i = (s = (r = (n = (e = this.$refs.treeEnhanced) == null ? void 0 : e.$refs) == null ? void 0 : n.tree) == null ? void 0 : r.$refs) == null ? void 0 : s.list) == null ? void 0 : i.$refs) == null ? void 0 : o.list) == null ? void 0 : a.$refs) == null ? void 0 : l.scroller) == null ? void 0 : c.$el;
    this.listScroll !== 0 && t && (t.scrollTop = this.listScroll);
  },
  errorCaptured(t) {
    return console.error(t), !1;
  },
  methods: {
    colorsPredicate(t) {
      return Object.keys(this.colors).map((n) => parseInt(n)).includes(t == null ? void 0 : t.id);
    },
    selectedPredicate(t) {
      return this.pickedCodes.map((e) => e.id).includes(t == null ? void 0 : t.id);
    },
    select(t) {
      this.$emit("codeAdded", t);
    },
    unselect(t) {
      this.$emit("codeDeleted", t);
    },
    include(t) {
      this.$emit("codeIncluded", t);
    },
    exclude(t) {
      this.$emit("codeExcluded", t);
    },
    ignore(t) {
      this.$emit("codeIgnored", t);
    },
    handleListScroll(t) {
      this.listScroll = t;
    }
  }
};
var zwe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass, style: e.style, attrs: { "data-test-selector": "code-manager" }, on: { keydown: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "esc", 27, r.key, ["Esc", "Escape"]) ? null : (r.preventDefault(), r.stopPropagation(), e.$emit("hide"));
  } } }, [n("PbVirtualTreeEnhanced", { ref: "treeEnhanced", class: e.$style.tree, attrs: { items: e.visibleCodes, selectedItems: e.pickedCodes, colors: e.colors, features: {
    search: !0,
    filter: !0,
    selection: !0,
    highlight: e.isHighLighted,
    menu: e.withItemMenu
  }, search: {
    autofocus: !1,
    placeholder: "Поиск по кодам",
    fields: ["name"],
    useDefaultSearch: !0,
    predicates: [e.colorsPredicate],
    minimalQueryLength: 1
  }, filter: e.filter, titleName: "name", trackShift: 1, margin: { value: 1.3, unit: "rem", drop: 1.3 }, sortField: "pos", searchFieldClass: e.$style.search, isSelectable: e.isSelectable, isThemed: e.isThemed, twoWaySelection: e.twoWaySelection, checkDisabled: e.checkDisabled, disabledReason: e.disabledReason }, on: { select: e.select, "select:included": e.include, "select:excluded": e.exclude, "select:ignored": e.ignore, unselect: e.unselect, scroll: e.handleListScroll }, scopedSlots: e._u([{ key: "search", fn: function() {
    return [e._t("search")];
  }, proxy: !0 }, { key: "itemMenu", fn: function({ item: r, closeMenu: s }) {
    return [e._t("itemMenu", null, null, { item: r, closeMenu: s })];
  } }], null, !0), model: { value: e.searchQuery, callback: function(r) {
    e.searchQuery = r;
  }, expression: "searchQuery" } }), e.withSelectedItems && e.pickedCodes.length ? n("div", { class: e.$style.selected }, [n("PbManagerSelectedItems", { class: e.$style.selectedList, attrs: { availableItems: e.allCodes, items: e.allCodes, selectedItems: e.selectedCodes, title: "Добавленные коды", labels: ["name"], isRemovable: e.isSelectedItemsRemovable }, on: { remove: e.unselect } })], 1) : e._e(), e.$slots.prefooter ? n("div", { class: e.$style.footer }, [e._t("prefooter")], 2) : e._e(), e.$slots.footer ? n("div", { class: e.$style.footer }, [e._t("footer")], 2) : e._e()], 1);
}, Uwe = [];
const UP = {
  $style: Hwe
};
function Gwe(t) {
  for (var e in UP)
    this[e] = UP[e];
}
var Ywe = /* @__PURE__ */ B(
  Vwe,
  zwe,
  Uwe,
  !1,
  Gwe,
  null
);
const Hv = Ywe.exports;
function Zwe({ positionRef: t, maxHeightRef: e, anchorRef: n }, { maxWidth: r, shiftHeight: s = 0, forceAlignRight: i = !1 }) {
  return { positionStyles: le(() => {
    const { offsetHeight: a } = document.querySelector("#workspace-wrapper"), { offsetWidth: l } = document.querySelector("#content"), c = {
      height: e.value ? e.value + "px" : "auto",
      maxHeight: e.value ? e.value + "px" : "none"
    };
    if (t.value && typeof t.value == "object") {
      const u = t.value.left + r < l;
      let d = u ? "left" : "right", f = u ? t.value.left : 30;
      switch (i && (d = "right", f = 20), c[d] = f + "px", n.value) {
        case "top":
          c.top = t.value.top + "px";
          break;
        case "bottom":
          c.top = t.value.top - e.value + "px";
          break;
        default:
          t.value.top + e.value >= a ? c.top = t.value.top - e.value - s + "px" : c.top = t.value.top + "px";
          break;
      }
    }
    return c;
  }) };
}
const Xwe = "_root_1njxc_1", Kwe = "_colorCell_1njxc_6", Jwe = "_colorCell_picked_1njxc_15", qwe = {
  root: Xwe,
  colorCell: Kwe,
  colorCell_picked: Jwe
}, Qwe = {
  name: "palette",
  functional: !0,
  props: {
    usedColors: {
      type: Array,
      default: () => []
    },
    unusedColors: {
      type: Array,
      default: () => []
    },
    picked: {
      type: String,
      default: "#333333"
    },
    cellSize: {
      type: Number,
      default: 1.5
    },
    margin: {
      type: Number,
      default: 0
    }
  }
};
var eSe = function(e, n) {
  return e("div", { class: n.$style.root, style: {
    margin: "-" + n.props.margin + "rem"
  }, attrs: { "data-test-selector": "palette" } }, [n._l(n.props.usedColors, function(r, s) {
    return e("div", { key: s, class: {
      [n.$style.colorCell]: !0,
      [n.$style.colorCell_picked]: n.props.picked === r
    }, style: {
      backgroundColor: r,
      width: n.props.cellSize + "rem",
      height: n.props.cellSize + "rem",
      margin: n.props.margin + "rem",
      borderRadius: n.props.margin > 0 ? "2px" : "0"
    }, attrs: { "data-test-selector": "palette-color", "data-test-attrs": `color-${r}` }, on: { click: function(i) {
      return n.listeners.pickColor(r);
    } } });
  }), n._l(n.props.unusedColors, function(r, s) {
    return e("div", { key: s, staticClass: "color-cell", class: n.props.picked === r ? "picked" : null, style: {
      backgroundColor: r,
      width: n.props.cellSize + "rem",
      height: n.props.cellSize + "rem"
    }, attrs: { "data-test-selector": "palette-color", "data-test-attrs": `color-${r}` }, on: { click: function(i) {
      return n.listeners.pickColor(r);
    } } });
  })], 2);
}, tSe = [];
const GP = {
  $style: qwe
};
function nSe(t) {
  for (var e in GP)
    this[e] = GP[e];
}
var rSe = /* @__PURE__ */ B(
  Qwe,
  eSe,
  tSe,
  !0,
  nSe,
  null
);
const WR = rSe.exports, sSe = "_root_159pg_1", iSe = "_header_159pg_10", oSe = "_close_159pg_21", aSe = "_picked_159pg_25", lSe = "_picker_159pg_30", cSe = "_pickedInner_159pg_34", uSe = "_title_159pg_40", dSe = "_color_159pg_46", fSe = "_clear_159pg_52", pSe = "_palette_159pg_62", hSe = "_footer_159pg_66", mSe = "_actions_159pg_70", vSe = {
  root: sSe,
  header: iSe,
  close: oSe,
  picked: aSe,
  picker: lSe,
  pickedInner: cSe,
  title: uSe,
  color: dSe,
  clear: fSe,
  palette: pSe,
  footer: hSe,
  actions: mSe
}, gSe = {
  name: "PbCodeColorManager",
  mixins: [Vr],
  components: {
    PbActionsButtonGroup: Ou,
    PbButton: nt,
    PbCheckboxLabeled: qa,
    PbPalette: WR
  },
  props: {
    code: {
      type: [Number, String],
      required: !0
    },
    hasChildren: {
      type: Boolean,
      default: !0
    },
    position: {
      type: Object,
      required: !0
    },
    selected: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const { position: e } = ts(t), n = et(null), r = et("top"), { positionStyles: s } = Zwe(
      { positionRef: e, maxHeightRef: n, anchorRef: r },
      {
        maxWidth: 375,
        shiftHeight: 22
      }
    );
    return {
      positionStyles: s
    };
  },
  data() {
    return {
      colors: SJ,
      includeChildren: !1,
      pickedColor: null
    };
  },
  created() {
    this.selected.color && (this.pickedColor = this.selected.color), this.selected.includeChildren && (this.includeChildren = this.selected.includeChildren);
  },
  methods: {
    pickColor(t) {
      this.pickedColor = t;
    },
    resetColor() {
      this.pickedColor = null;
    },
    applyChanges() {
      this.$emit("applyColor", {
        code: this.code,
        color: this.pickedColor,
        includeChildren: this.includeChildren
      }), this.$emit("close");
    },
    cancelChanges() {
      this.$emit("close");
    }
  }
};
var ySe = function() {
  var e = this, n = e._self._c;
  return n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: () => e.$emit("close"), expression: "() => $emit('close')" }], class: e.$style.root, style: e.positionStyles }, [n("header", { class: e.$style.header }, [n("div", [e._v("Выделять материалы с этим кодом")]), n("PbButton", { class: e.$style.close, attrs: { round: "" }, on: { "!click": function(r) {
    return r.stopPropagation(), e.$emit("close");
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "16" } })], 1)], 1), n("main", { class: e.$style.body }, [e.pickedColor ? n("div", { class: e.$style.picked }, [n("div", { class: e.$style.title }, [e._v("Используемый цвет")]), n("div", { class: e.$style.pickedInner }, [n("div", { class: e.$style.color, style: { backgroundColor: e.pickedColor } }), n("div", { class: e.$style.clear, on: { click: e.resetColor } }, [n("icon", { attrs: { type: "font", name: "close", size: "16" } }), n("span", [e._v("Дефолтный цвет")])], 1)])]) : e._e(), n("div", { class: e.$style.picker }, [n("div", { class: e.$style.title }, [e._v("Основные цвета")]), n("PbPalette", { class: e.$style.palette, attrs: { usedColors: e.colors, margin: 0.35 }, on: { pickColor: e.pickColor } })], 1)]), n("footer", { class: e.$style.footer }, [e.hasChildren ? n("PbCheckboxLabeled", { attrs: { label: "Включая дочерние коды" }, model: { value: e.includeChildren, callback: function(r) {
    e.includeChildren = r;
  }, expression: "includeChildren" } }) : e._e(), n("PbActionsButtonGroup", { class: e.$style.actions, attrs: { "apply-fn": e.applyChanges, "cancel-fn": e.cancelChanges } })], 1)]);
}, bSe = [];
const YP = {
  $style: vSe
};
function _Se(t) {
  for (var e in YP)
    this[e] = YP[e];
}
var wSe = /* @__PURE__ */ B(
  gSe,
  ySe,
  bSe,
  !1,
  _Se,
  null
);
const SSe = wSe.exports;
function Lu(t) {
  return t.split("-")[0];
}
function HR(t) {
  return t.split("-")[1];
}
function Hf(t) {
  return ["top", "bottom"].includes(Lu(t)) ? "x" : "y";
}
function d2(t) {
  return t === "y" ? "height" : "width";
}
function ZP(t) {
  let { reference: e, floating: n, placement: r } = t;
  const s = e.x + e.width / 2 - n.width / 2, i = e.y + e.height / 2 - n.height / 2;
  let o;
  switch (Lu(r)) {
    case "top":
      o = { x: s, y: e.y - n.height };
      break;
    case "bottom":
      o = { x: s, y: e.y + e.height };
      break;
    case "right":
      o = { x: e.x + e.width, y: i };
      break;
    case "left":
      o = { x: e.x - n.width, y: i };
      break;
    default:
      o = { x: e.x, y: e.y };
  }
  const a = Hf(r), l = d2(a);
  switch (HR(r)) {
    case "start":
      o[a] = o[a] - (e[l] / 2 - n[l] / 2);
      break;
    case "end":
      o[a] = o[a] + (e[l] / 2 - n[l] / 2);
  }
  return o;
}
const ISe = async (t, e, n) => {
  const { placement: r = "bottom", strategy: s = "absolute", middleware: i = [], platform: o } = n;
  let a = await o.getElementRects({ reference: t, floating: e, strategy: s }), { x: l, y: c } = ZP({ ...a, placement: r }), u = r, d = {};
  for (let f = 0; f < i.length; f++) {
    const { name: p, fn: h } = i[f], { x: m, y: v, data: y, reset: _ } = await h({ x: l, y: c, initialPlacement: r, placement: u, strategy: s, middlewareData: d, rects: a, platform: o, elements: { reference: t, floating: e } });
    l = m ?? l, c = v ?? c, d = { ...d, [p]: y ?? {} }, _ && (typeof _ == "object" && (_.placement && (u = _.placement), _.rects && (a = _.rects === !0 ? await o.getElementRects({ reference: t, floating: e, strategy: s }) : _.rects), { x: l, y: c } = ZP({ ...a, placement: u })), f = -1);
  }
  return { x: l, y: c, placement: u, strategy: s, middlewareData: d };
};
function VR(t) {
  return typeof t != "number" ? function(e) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...e };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function G0(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
async function Om(t, e) {
  e === void 0 && (e = {});
  const { x: n, y: r, platform: s, rects: i, elements: o, strategy: a } = t, { boundary: l = "clippingParents", rootBoundary: c = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = e, p = VR(f), h = o[d ? u === "floating" ? "reference" : "floating" : u], m = await s.getClippingClientRect({ element: await s.isElement(h) ? h : h.contextElement || await s.getDocumentElement({ element: o.floating }), boundary: l, rootBoundary: c }), v = G0(await s.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: u === "floating" ? { ...i.floating, x: n, y: r } : i.reference, offsetParent: await s.getOffsetParent({ element: o.floating }), strategy: a }));
  return { top: m.top - v.top + p.top, bottom: v.bottom - m.bottom + p.bottom, left: m.left - v.left + p.left, right: v.right - m.right + p.right };
}
const ESe = Math.min, xSe = Math.max;
function Y0(t, e, n) {
  return xSe(t, ESe(e, n));
}
const CSe = (t) => ({ name: "arrow", options: t, async fn(e) {
  const { element: n, padding: r = 0 } = t ?? {}, { x: s, y: i, placement: o, rects: a, platform: l } = e;
  if (n == null) return {};
  const c = VR(r), u = { x: s, y: i }, d = Hf(Lu(o)), f = d2(d), p = await l.getDimensions({ element: n }), h = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", v = a.reference[f] + a.reference[d] - u[d] - a.floating[f], y = u[d] - a.reference[d], _ = await l.getOffsetParent({ element: n }), w = _ ? d === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, S = v / 2 - y / 2, E = c[h], x = w - p[f] - c[m], T = w / 2 - p[f] / 2 + S, C = Y0(E, T, x);
  return { data: { [d]: C, centerOffset: T - C } };
} }), TSe = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Mm(t) {
  return t.replace(/left|right|bottom|top/g, (e) => TSe[e]);
}
function PSe(t, e) {
  const n = HR(t) === "start", r = Hf(t), s = d2(r);
  let i = r === "x" ? n ? "right" : "left" : n ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (i = Mm(i)), { main: i, cross: Mm(i) };
}
const kSe = { start: "end", end: "start" };
function XP(t) {
  return t.replace(/start|end/g, (e) => kSe[e]);
}
const zR = ["top", "right", "bottom", "left"];
zR.reduce((t, e) => t.concat(e, e + "-start", e + "-end"), []);
const NSe = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, async fn(e) {
    var n, r;
    const { placement: s, middlewareData: i, rects: o, initialPlacement: a } = e;
    if ((n = i.flip) != null && n.skip) return {};
    const { mainAxis: l = !0, crossAxis: c = !0, fallbackPlacements: u, fallbackStrategy: d = "bestFit", flipAlignment: f = !0, ...p } = t, h = Lu(s), m = u || (h === a || !f ? [Mm(a)] : function(T) {
      const C = Mm(T);
      return [XP(T), C, XP(C)];
    }(a)), v = [a, ...m], y = await Om(e, p), _ = [];
    let w = ((r = i.flip) == null ? void 0 : r.overflows) || [];
    if (l && _.push(y[h]), c) {
      const { main: T, cross: C } = PSe(s, o);
      _.push(y[T], y[C]);
    }
    if (w = [...w, { placement: s, overflows: _ }], !_.every((T) => T <= 0)) {
      var S, E;
      const T = ((S = (E = i.flip) == null ? void 0 : E.index) != null ? S : 0) + 1, C = v[T];
      if (C) return { data: { index: T, overflows: w }, reset: { placement: C } };
      let k = "bottom";
      switch (d) {
        case "bestFit": {
          var x;
          const b = (x = w.slice().sort((P, N) => P.overflows.filter((D) => D > 0).reduce((D, H) => D + H, 0) - N.overflows.filter((D) => D > 0).reduce((D, H) => D + H, 0))[0]) == null ? void 0 : x.placement;
          b && (k = b);
          break;
        }
        case "initialPlacement":
          k = a;
      }
      return { data: { skip: !0 }, reset: { placement: k } };
    }
    return {};
  } };
};
function KP(t, e) {
  return { top: t.top - e.height, right: t.right - e.width, bottom: t.bottom - e.height, left: t.left - e.width };
}
function JP(t) {
  return zR.some((e) => t[e] >= 0);
}
const $Se = () => ({ name: "hide", async fn(t) {
  const e = await Om(t, { elementContext: "reference" }), n = await Om(t, { altBoundary: !0 }), r = KP(e, t.rects.reference), s = KP(n, t.rects.floating);
  return { data: { referenceHidden: JP(r), referenceHiddenOffsets: r, escaped: JP(s), escapedOffsets: s } };
} }), DSe = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, fn(e) {
    const { x: n, y: r, placement: s, rects: i } = e, o = function(a) {
      let { placement: l, rects: c, value: u } = a;
      const d = Lu(l), f = ["left", "top"].includes(d) ? -1 : 1, p = typeof u == "function" ? u({ ...c, placement: l }) : u, { mainAxis: h, crossAxis: m } = typeof p == "number" ? { mainAxis: p, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...p };
      return Hf(d) === "x" ? { x: m, y: h * f } : { x: h * f, y: m };
    }({ placement: s, rects: i, value: t });
    return { x: n + o.x, y: r + o.y, data: o };
  } };
};
function ASe(t) {
  return t === "x" ? "y" : "x";
}
const OSe = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, async fn(e) {
    const { x: n, y: r, placement: s } = e, { mainAxis: i = !0, crossAxis: o = !1, limiter: a = { fn: (v) => {
      let { x: y, y: _ } = v;
      return { x: y, y: _ };
    } }, ...l } = t, c = { x: n, y: r }, u = await Om(e, l), d = Hf(Lu(s)), f = ASe(d);
    let p = c[d], h = c[f];
    if (i) {
      const v = d === "y" ? "bottom" : "right";
      p = Y0(p + u[d === "y" ? "top" : "left"], p, p - u[v]);
    }
    if (o) {
      const v = f === "y" ? "bottom" : "right";
      h = Y0(h + u[f === "y" ? "top" : "left"], h, h - u[v]);
    }
    const m = a.fn({ ...e, [d]: p, [f]: h });
    return { ...m, data: { x: m.x - n, y: m.y - r } };
  } };
};
function f2(t) {
  return (t == null ? void 0 : t.toString()) === "[object Window]";
}
function sl(t) {
  if (t == null) return window;
  if (!f2(t)) {
    const e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Vv(t) {
  return sl(t).getComputedStyle(t);
}
function Ho(t) {
  return f2(t) ? "" : t ? (t.nodeName || "").toLowerCase() : "";
}
function Yo(t) {
  return t instanceof sl(t).HTMLElement;
}
function Rm(t) {
  return t instanceof sl(t).Element;
}
function UR(t) {
  return t instanceof sl(t).ShadowRoot || t instanceof ShadowRoot;
}
function zv(t) {
  const { overflow: e, overflowX: n, overflowY: r } = Vv(t);
  return /auto|scroll|overlay|hidden/.test(e + r + n);
}
function MSe(t) {
  return ["table", "td", "th"].includes(Ho(t));
}
function qP(t) {
  const e = navigator.userAgent.toLowerCase().includes("firefox"), n = Vv(t);
  return n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].includes(n.willChange) || e && n.willChange === "filter" || e && !!n.filter && n.filter !== "none";
}
const QP = Math.min, zd = Math.max, Lm = Math.round;
function Xc(t, e) {
  e === void 0 && (e = !1);
  const n = t.getBoundingClientRect();
  let r = 1, s = 1;
  return e && Yo(t) && (r = t.offsetWidth > 0 && Lm(n.width) / t.offsetWidth || 1, s = t.offsetHeight > 0 && Lm(n.height) / t.offsetHeight || 1), { width: n.width / r, height: n.height / s, top: n.top / s, right: n.right / r, bottom: n.bottom / s, left: n.left / r, x: n.left / r, y: n.top / s };
}
function Da(t) {
  return (e = t, (e instanceof sl(e).Node ? t.ownerDocument : t.document) || window.document).documentElement;
  var e;
}
function Uv(t) {
  return f2(t) ? { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset } : { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop };
}
function GR(t) {
  return Xc(Da(t)).left + Uv(t).scrollLeft;
}
function RSe(t, e, n) {
  const r = Yo(e), s = Da(e), i = Xc(t, r && function(l) {
    const c = Xc(l);
    return Lm(c.width) !== l.offsetWidth || Lm(c.height) !== l.offsetHeight;
  }(e));
  let o = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if (r || !r && n !== "fixed") if ((Ho(e) !== "body" || zv(s)) && (o = Uv(e)), Yo(e)) {
    const l = Xc(e, !0);
    a.x = l.x + e.clientLeft, a.y = l.y + e.clientTop;
  } else s && (a.x = GR(s));
  return { x: i.left + o.scrollLeft - a.x, y: i.top + o.scrollTop - a.y, width: i.width, height: i.height };
}
function Gv(t) {
  return Ho(t) === "html" ? t : t.assignedSlot || t.parentNode || (UR(t) ? t.host : null) || Da(t);
}
function ek(t) {
  return Yo(t) && getComputedStyle(t).position !== "fixed" ? t.offsetParent : null;
}
function Z0(t) {
  const e = sl(t);
  let n = ek(t);
  for (; n && MSe(n) && getComputedStyle(n).position === "static"; ) n = ek(n);
  return n && (Ho(n) === "html" || Ho(n) === "body" && getComputedStyle(n).position === "static" && !qP(n)) ? e : n || function(r) {
    let s = Gv(r);
    for (; Yo(s) && !["html", "body"].includes(Ho(s)); ) {
      if (qP(s)) return s;
      s = s.parentNode;
    }
    return null;
  }(t) || e;
}
function tk(t) {
  return { width: t.offsetWidth, height: t.offsetHeight };
}
function YR(t) {
  return ["html", "body", "#document"].includes(Ho(t)) ? t.ownerDocument.body : Yo(t) && zv(t) ? t : YR(Gv(t));
}
function p2(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = YR(t), s = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = sl(r), o = s ? [i].concat(i.visualViewport || [], zv(r) ? r : []) : r, a = e.concat(o);
  return s ? a : a.concat(p2(Gv(o)));
}
function nk(t, e) {
  return e === "viewport" ? G0(function(n) {
    const r = sl(n), s = Da(n), i = r.visualViewport;
    let o = s.clientWidth, a = s.clientHeight, l = 0, c = 0;
    return i && (o = i.width, a = i.height, Math.abs(r.innerWidth / i.scale - i.width) < 0.01 && (l = i.offsetLeft, c = i.offsetTop)), { width: o, height: a, x: l, y: c };
  }(t)) : Rm(e) ? function(n) {
    const r = Xc(n), s = r.top + n.clientTop, i = r.left + n.clientLeft;
    return { top: s, left: i, x: i, y: s, right: i + n.clientWidth, bottom: s + n.clientHeight, width: n.clientWidth, height: n.clientHeight };
  }(e) : G0(function(n) {
    var r;
    const s = Da(n), i = Uv(n), o = (r = n.ownerDocument) == null ? void 0 : r.body, a = zd(s.scrollWidth, s.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = zd(s.scrollHeight, s.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0);
    let c = -i.scrollLeft + GR(n);
    const u = -i.scrollTop;
    return Vv(o || s).direction === "rtl" && (c += zd(s.clientWidth, o ? o.clientWidth : 0) - a), { width: a, height: l, x: c, y: u };
  }(Da(t)));
}
function LSe(t) {
  const e = p2(Gv(t)), n = ["absolute", "fixed"].includes(Vv(t).position) && Yo(t) ? Z0(t) : t;
  return Rm(n) ? e.filter((r) => Rm(r) && function(s, i) {
    const o = i.getRootNode == null ? void 0 : i.getRootNode();
    if (s.contains(i)) return !0;
    if (o && UR(o)) {
      let a = i;
      do {
        if (a && s === a) return !0;
        a = a.parentNode || a.host;
      } while (a);
    }
    return !1;
  }(r, n) && Ho(r) !== "body") : [];
}
const FSe = { getElementRects: (t) => {
  let { reference: e, floating: n, strategy: r } = t;
  return { reference: RSe(e, Z0(n), r), floating: { ...tk(n), x: 0, y: 0 } };
}, convertOffsetParentRelativeRectToViewportRelativeRect: (t) => function(e) {
  let { rect: n, offsetParent: r, strategy: s } = e;
  const i = Yo(r), o = Da(r);
  if (r === o) return n;
  let a = { scrollLeft: 0, scrollTop: 0 };
  const l = { x: 0, y: 0 };
  if ((i || !i && s !== "fixed") && ((Ho(r) !== "body" || zv(o)) && (a = Uv(r)), Yo(r))) {
    const c = Xc(r, !0);
    l.x = c.x + r.clientLeft, l.y = c.y + r.clientTop;
  }
  return { ...n, x: n.x - a.scrollLeft + l.x, y: n.y - a.scrollTop + l.y };
}(t), getOffsetParent: (t) => {
  let { element: e } = t;
  return Z0(e);
}, isElement: (t) => Rm(t), getDocumentElement: (t) => {
  let { element: e } = t;
  return Da(e);
}, getClippingClientRect: (t) => function(e) {
  let { element: n, boundary: r, rootBoundary: s } = e;
  const i = [...r === "clippingParents" ? LSe(n) : [].concat(r), s], o = i[0], a = i.reduce((l, c) => {
    const u = nk(n, c);
    return l.top = zd(u.top, l.top), l.right = QP(u.right, l.right), l.bottom = QP(u.bottom, l.bottom), l.left = zd(u.left, l.left), l;
  }, nk(n, o));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}(t), getDimensions: (t) => {
  let { element: e } = t;
  return tk(e);
}, getClientRects: (t) => {
  let { element: e } = t;
  return e.getClientRects();
} }, BSe = (t, e, n) => ISe(t, e, { platform: FSe, ...n });
async function ZR({ placement: t, arrowSize: e, floatingOptions: n }, r, s, i, o) {
  if (!(s && i))
    return;
  const a = {
    offset: 2,
    flip: void 0,
    // здесь не null
    shift: { padding: 5 },
    arrow: { element: o, padding: 15 },
    hide: void 0
    // здесь не null
  };
  let l = 0;
  o ? (l = -Math.ceil(e / 2), a.offset -= l) : a.offset += 3;
  const c = [];
  c.push(DSe((n == null ? void 0 : n.offset) || a.offset)), c.push(NSe((n == null ? void 0 : n.flip) || a.flip)), c.push(OSe((n == null ? void 0 : n.shift) || a.shift)), o && c.push(CSe((n == null ? void 0 : n.arrow) || a.arrow)), c.push($Se((n == null ? void 0 : n.hide) || a.hide));
  const {
    x: u,
    y: d,
    placement: f,
    middlewareData: p
  } = await BSe(s, i, { placement: t, middleware: c });
  if (Object.assign(i.style, {
    left: u + "px",
    top: d + "px"
  }), o) {
    const { x: h, y: m } = p.arrow, v = {
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[f.split("-")[0]];
    Object.assign(o.style, {
      left: h != null ? h + "px" : "",
      top: m != null ? m + "px" : "",
      right: "",
      bottom: "",
      [v]: l + "px"
    });
  }
  p.hide.referenceHidden && (s.parentNode || r("hide"));
}
function jSe({ placement: t, arrowSize: e, canPopupResize: n, floatingOptions: r }, { anchorRef: s, popupRef: i, arrowRef: o, emit: a }) {
  let l = !1, c;
  const u = () => {
    ZR(
      { placement: t, arrowSize: e, floatingOptions: r },
      a,
      s.value,
      i.value,
      o.value
    );
  }, d = {
    resize: /* @__PURE__ */ new Set([window]),
    // это только для window
    scroll: /* @__PURE__ */ new Set([window])
  }, f = new AbortController();
  function p(m, v) {
    for (const y in m)
      m[y].forEach(
        (_) => _.addEventListener(y, v, { signal: f.signal })
      );
  }
  function h() {
    f.abort();
  }
  Io(async () => {
    if (await Ar(), !s.value) return;
    const m = p2(s.value), v = "pskit__scroller__popup";
    m.filter(
      (_) => {
        var w;
        return (w = _ == null ? void 0 : _.classList) == null ? void 0 : w.contains(v);
      }
    ).forEach((_) => d.scroll.add(_)), n && (c = new ResizeObserver(() => {
      if (!l) {
        l = !0;
        return;
      }
      u();
    }), c.observe(i.value)), u(), p(d, u);
  }), Nf(() => {
    n && c.disconnect(), h();
  });
}
const WSe = {
  name: "PopupFloating",
  mixins: [Vr],
  props: {
    placement: {
      type: String,
      default: "bottom",
      validator: (t) => [
        "top",
        "top-start",
        "top-end",
        "bottom",
        "bottom-start",
        "bottom-end",
        "right",
        "right-start",
        "right-end",
        "left",
        "left-start",
        "left-end"
      ].includes(t)
    },
    visible: {
      type: Boolean,
      default: !0
    },
    arrowVisible: {
      type: Boolean,
      default: !0
    },
    arrowSize: {
      type: Number,
      default: 15
    },
    classPopup: {
      type: [String, Array, Object],
      default: () => []
    },
    classPopupBody: {
      type: [String, Array, Object],
      default: () => []
    },
    /** Объект с опциями для FloatinUI.middleware
     *
     * { offset: options, arrow: options, myCustomMiddleware: options, ... }
     *
     * Официальная документация:
     * https://floating-ui.com/docs/middleware
     */
    floatingOptions: {
      type: Object,
      default: () => null
    },
    canPopupResize: {
      type: Boolean,
      default: !1
    },
    /** Когда рядом лежит несколько попапов с условным рендером,
     *  Vue может начать переиспользовать для них один компонент.
     *
     * Например, в src/modules/News/NewsPublished/NewsPublishedPanel.vue
     * два попапа лежат внутри компонентов-фильтров, но dom почти идентичный
     * и нет ключей key, плюс на попапах висит v-if,
     * поэтому Vue расшаривает один компонент между ними
     * (при этом нарушается позиционирование и внутренний лэйаут попапа)
     *
     * Чтобы этого избежать, по умолчанию даем всем попапам рандомный key:
     * это 8-символьная строка из букв и цифр
     * https://attacomsian.com/blog/javascript-generate-random-string
     *
     * Чтобы явно сказать Vue, что какие-то попапы нужно переиспользовать,
     * следует передавать им одинаковый ключ keyPopup
     */
    keyPopup: {
      type: String,
      default: () => Math.random().toString(16).substr(2, 8)
    },
    hideOnClickAway: {
      type: Boolean,
      default: !0
    }
  },
  setup(t, e) {
    const n = et(null), r = et(null), s = et(null);
    jSe(
      {
        placement: t.placement,
        arrowSize: t.arrowSize,
        floatingOptions: t.floatingOptions,
        canPopupResize: t.canPopupResize
      },
      { anchorRef: n, popupRef: r, arrowRef: s, emit: e.emit }
    );
    const i = {
      "--arrow-size": t.arrowSize + "px"
    }, o = (l) => {
      t.hideOnClickAway && e.emit("hide", { reason: "clickaway", target: l.target });
    }, a = qS();
    return or(
      () => t.visible,
      (l, c) => {
        l !== c && (l ? e.emit("visible", { id: a }) : e.emit("hidden", { id: a }));
      }
    ), Io(() => {
      t.visible && e.emit("visible", { id: a });
    }), {
      onClickAway: o,
      popupStyle: i,
      popupId: a,
      anchorRef: n,
      popupRef: r,
      arrowRef: s
    };
  }
};
var HSe = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "anchorRef", staticClass: "pskit__popup__anchor" }, [n("portal", { attrs: { to: "popups" } }, [n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.onClickAway, expression: "onClickAway" }, { name: "show", rawName: "v-show", value: e.visible, expression: "visible" }], key: e.keyPopup, ref: "popupRef", staticClass: "pskit__popup__popup", class: e.classPopup, style: e.popupStyle, attrs: { id: e.popupId } }, [n("div", { staticClass: "pskit__popup__body", class: e.classPopupBody }, [e._t("default")], 2), e.$slots.footer ? n("div", { staticClass: "pskit__popup__footer" }, [e._t("footer")], 2) : e._e(), n("div", { directives: [{ name: "show", rawName: "v-show", value: e.arrowVisible, expression: "arrowVisible" }], ref: "arrowRef", staticClass: "pskit__popup__arrow" })])])], 1);
}, VSe = [], zSe = /* @__PURE__ */ B(
  WSe,
  HSe,
  VSe,
  !1,
  null,
  null
);
const Ls = zSe.exports, USe = "_root_6d0pq_1", GSe = "_anchor_6d0pq_5", YSe = "_popup_6d0pq_10", ZSe = "_button_6d0pq_14", XSe = "_clear_6d0pq_27", KSe = "_menu_6d0pq_32", JSe = "_menuItem_6d0pq_40", qSe = "_menuTooltip_6d0pq_49", QSe = "_colorManager_6d0pq_61", e2e = "_modeLabel_6d0pq_65", t2e = {
  root: USe,
  anchor: GSe,
  popup: YSe,
  button: ZSe,
  clear: XSe,
  menu: KSe,
  menuItem: JSe,
  menuTooltip: qSe,
  colorManager: QSe,
  modeLabel: e2e
}, n2e = {
  name: "NewsPublishedCodesFilter",
  mixins: [Vr],
  components: {
    PsKitPopup: Ls,
    PbActionsButtonGroup: Ou,
    PbButton: nt,
    PbButtonSwitcher: rl,
    PbCodeManager: Hv,
    PbCodeColorManager: SSe
  },
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    values: {
      type: Array,
      default: () => []
    },
    withColorManager: {
      type: Boolean,
      default: !0
    },
    withModeToggle: {
      type: Boolean,
      default: !0
    },
    showDeprecatedCodes: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Jt("store"), n = {
      allCodeItems: le(() => e.getters["news/codes/allCodeItems"]),
      allCodeItemsActual: le(
        () => e.getters["news/codes/allCodeItemsActual"]
      )
    }, r = le(() => t.showDeprecatedCodes ? n.allCodeItems.value : n.allCodeItemsActual.value), s = et(Or(t.values));
    or(() => t.values, (S) => {
      s.value = S;
    });
    const {
      isSelected: i,
      isIncluded: o,
      isExcluded: a,
      isIgnored: l,
      isParentSelected: c,
      isParentIncluded: u,
      isParentExcluded: d,
      isParentIgnored: f,
      isParentAncestorIncluded: p,
      isParentAncestorExcluded: h,
      includeItem: m,
      excludeItem: v,
      ignoreItem: y,
      removeItem: _,
      removeChildren: w
    } = MR(r, s, et(!0));
    return {
      items: r,
      itemsSelected: s,
      isSelected: i,
      isIncluded: o,
      isExcluded: a,
      isIgnored: l,
      isParentSelected: c,
      isParentIncluded: u,
      isParentExcluded: d,
      isParentIgnored: f,
      isParentAncestorIncluded: p,
      isParentAncestorExcluded: h,
      includeItem: m,
      excludeItem: v,
      ignoreItem: y,
      removeItem: _,
      removeChildren: w
    };
  },
  data() {
    return {
      appliedColors: {},
      manager: {
        isVisible: !1,
        mode: "default",
        position: {
          top: 0,
          left: 0
        }
      },
      colorManager: {
        code: null,
        isVisible: !1,
        position: {
          top: 0,
          left: 0
        },
        selected: {
          color: null,
          includeChildren: !1
        }
      },
      modeButtons: [
        {
          type: "default",
          label: "Все",
          value: "default",
          testSelector: "switcher-button",
          testAttrs: "button__all"
        },
        {
          type: "selected",
          label: "Выбранные",
          value: "selected",
          testSelector: "switcher-button",
          testAttrs: "button__selected"
        },
        {
          type: "colored",
          label: "Выделенные цветом",
          value: "colored",
          testSelector: "switcher-button",
          testAttrs: "button__colored"
        }
      ]
    };
  },
  computed: {
    ...pe("userProfile", ["getColorsByType"]),
    buttonLabel() {
      const t = this.values.filter((e) => e.state !== "ignored").length;
      return `${t} ${Pv(t, ["код", "кода", "кодов"])}`;
    },
    codesColors() {
      const t = { ...this.getColorsByType("codes"), ...this.appliedColors };
      for (let e in t)
        t[e].value === null && delete t[e];
      return t;
    },
    codeHasChildren() {
      return this.colorManager.code ? !!this.items[this.colorManager.code].children.length : !1;
    }
  },
  methods: {
    ...ge(["setCodeManagerFocus"]),
    ...ge("userProfile", ["setProfileColors"]),
    toggleColorManager(t = null) {
      if (!this.withColorManager) return;
      if (!!this.colorManager.isVisible) {
        this.colorManager.isVisible = !1, this.colorManager.code = null, this.colorManager.selected = {
          color: null,
          includeChildren: !1
        }, this.showFilter();
        return;
      }
      this.manager.isVisible && this.hideFilter();
      const n = this.$refs.button.$el.getBoundingClientRect();
      this.colorManager.position = {
        top: n.bottom + 5,
        left: n.left - 5 + globalThis.scrollX
      }, this.colorManager.code = t, this.codesColors[t] && (this.colorManager.selected = {
        color: this.codesColors[t].value,
        includeChildren: this.codesColors[t].includeChildren
      }), this.colorManager.isVisible = !0;
    },
    hideFilter() {
      this.$nextTick(() => {
        this.manager.isVisible = !1, this.setCodeManagerFocus(!1), this.$emit("hidden");
      });
    },
    showFilter() {
      this.manager.isVisible = !0, this.setCodeManagerFocus(!0), this.$emit("visible");
    },
    clearFilter() {
      this.itemsSelected.value = [], this.$emit("update", this.itemsSelected.value);
    },
    applyColorToCode({ code: t, color: e, includeChildren: n }) {
      U.set(this.appliedColors, t, { value: e, includeChildren: n });
    },
    applyChanges() {
      if (this.$emit("update", Ow(this.itemsSelected)), this.withColorManager)
        for (let t in this.appliedColors) {
          const e = this.appliedColors[t], n = e.value ? e.value.replace(/^#/g, "") : null;
          this.setProfileColors({
            type: "codes",
            id: Number(t),
            color: n,
            includeChildren: e.includeChildren
          });
        }
      this.cleanupChanges(), this.hideFilter();
    },
    cancelChanges() {
      this.itemsSelected.value = Or(this.values), this.cleanupChanges(), this.hideFilter();
    },
    cleanupChanges() {
      this.$refs.manager.$refs.treeEnhanced.$refs.tree.$refs.searchField.clearQuery(), this.appliedColors = {}, this.manager.mode = "default";
    }
  }
};
var r2e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e._t("button", function() {
    return [n("PbButton", { ref: "button", class: e.$style.button, attrs: { "data-test-selector": "panel-news-published-codes-btn" }, on: { click: e.showFilter } }, [n("span", [e._v(e._s(e.values.length ? e.buttonLabel : "Коды"))]), n("PbButton", { directives: [{ name: "show", rawName: "v-show", value: e.values.length, expression: "values.length" }], class: e.$style.clear, attrs: { round: "", "data-test-selector": "panel-news-published-codes-clear-btn" }, on: { "!click": function(r) {
      return r.stopPropagation(), e.clearFilter.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "14" } })], 1)], 1)];
  }, null, { showFilter: e.showFilter, clearFilter: e.clearFilter }), e.manager.isVisible ? n("PsKitPopup", { class: e.$style.anchor, attrs: { visible: e.manager.isVisible, classPopup: e.$style.popup, arrowVisible: !1, placement: e.placement }, on: { hide: e.hideFilter } }, [n("PbCodeManager", { ref: "manager", style: { height: "min(80vh, 500px)" }, attrs: { mode: e.manager.mode, pickedCodes: e.itemsSelected, allCodes: e.items, visibleCodes: e.items, colors: e.codesColors, anchor: "top", isThemed: !1, isHighLighted: !0, withItemMenu: !0, withSelectedItems: !0, isSelectedItemsRemovable: !0, twoWaySelection: !0 }, on: { codeAdded: function(r) {
    return e.$emit("codeAdded", r);
  }, codeDeleted: (r) => {
    e.removeItem(r), e.removeChildren(r, "any");
  }, codeIncluded: e.includeItem, codeExcluded: e.excludeItem, codeIgnored: e.ignoreItem }, scopedSlots: e._u([{ key: "itemMenu", fn: function({ item: r, closeMenu: s }) {
    return [n("div", { class: e.$style.menu }, [!e.isIncluded(r) && !e.isParentIncluded(r) && !e.isParentIgnored(r) || !e.isIncluded(r) && e.isParentIgnored(r) && e.isParentAncestorIncluded(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.includeItem(r.id), s();
    } } }, [e._v(" Включить фильтр по коду ")]) : e._e(), !e.isExcluded(r) && !e.isParentExcluded(r) && !e.isParentIgnored(r) || !e.isExcluded(r) && e.isParentIgnored(r) && e.isParentAncestorExcluded(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.excludeItem(r.id), s();
    } } }, [n("span", [e._v("Исключить код")]), n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Приоритетное выполнение, новости с исключенным кодом будут скрыты", expression: `
                'Приоритетное выполнение, новости с исключенным кодом будут скрыты'
              ` }], class: e.$style.menuTooltip, attrs: { type: "font", name: "info", size: "12" } })], 1) : e._e(), !e.isIgnored(r) && !e.isParentIgnored(r) && e.isParentSelected(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.ignoreItem(r.id), s();
    } } }, [n("span", [e._v("Игнорировать код")]), n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Новости с игнорируемым кодом не будут включены в выборку", expression: `
                'Новости с игнорируемым кодом не будут включены в выборку'
              ` }], class: e.$style.menuTooltip, attrs: { type: "font", name: "info", size: "12" } })], 1) : e._e(), e.isIgnored(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.removeItem(r.id), s();
    } } }, [e._v(" Снять игнорирование кода ")]) : e._e(), e.isSelected(r) && !e.isIgnored(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.removeItem(r.id), e.removeChildren(r.id, "any"), s();
    } } }, [e._v(" Удалить код ")]) : e._e(), n("hr"), e.withColorManager ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.toggleColorManager(r.id), s();
    } } }, [n("span", { style: { marginRight: "6px" } }, [e._v(" Выделять материалы с кодом ")]), n("icon", { attrs: { name: "palette", size: "14" } })], 1) : e._e()])];
  } }, e.withModeToggle ? { key: "prefooter", fn: function() {
    return [n("span", { class: e.$style.modeLabel }, [e._v("Показывать: ")]), n("PbButtonSwitcher", { attrs: { buttons: e.modeButtons, activeButton: e.manager.mode }, on: { change: (r) => {
      e.manager.mode = r;
    } } })];
  }, proxy: !0 } : null, { key: "footer", fn: function() {
    return [n("PbActionsButtonGroup", { attrs: { applyFn: e.applyChanges, cancelFn: e.cancelChanges } })];
  }, proxy: !0 }], null, !0) })], 1) : e._e(), e.withColorManager ? n("portal", { attrs: { to: "newsTextEditorWidgets" } }, [e.colorManager.isVisible ? n("PbCodeColorManager", { attrs: { code: e.colorManager.code, position: e.colorManager.position, selected: e.colorManager.selected, hasChildren: e.codeHasChildren }, on: { close: e.toggleColorManager, applyColor: e.applyColorToCode } }) : e._e()], 1) : e._e()], 2);
}, s2e = [];
const rk = {
  $style: t2e
};
function i2e(t) {
  for (var e in rk)
    this[e] = rk[e];
}
var o2e = /* @__PURE__ */ B(
  n2e,
  r2e,
  s2e,
  !1,
  i2e,
  null
);
const XR = o2e.exports;
function a2e() {
}
var h2 = a2e, l2e = Wv, c2e = h2;
function Fm(t, e) {
  this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = void 0;
}
Fm.prototype = l2e(c2e.prototype);
Fm.prototype.constructor = Fm;
var m2 = Fm, sk = bu, u2e = $v, d2e = Wr, ik = sk ? sk.isConcatSpreadable : void 0;
function f2e(t) {
  return d2e(t) || u2e(t) || !!(ik && t && t[ik]);
}
var p2e = f2e, h2e = VS, m2e = p2e;
function KR(t, e, n, r, s) {
  var i = -1, o = t.length;
  for (n || (n = m2e), s || (s = []); ++i < o; ) {
    var a = t[i];
    e > 0 && n(a) ? e > 1 ? KR(a, e - 1, n, r, s) : h2e(s, a) : r || (s[s.length] = a);
  }
  return s;
}
var JR = KR, v2e = JR;
function g2e(t) {
  var e = t == null ? 0 : t.length;
  return e ? v2e(t, 1) : [];
}
var qR = g2e;
const y2e = /* @__PURE__ */ Et(qR);
function b2e(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var v2 = b2e, _2e = v2, ok = Math.max;
function w2e(t, e, n) {
  return e = ok(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, s = -1, i = ok(r.length - e, 0), o = Array(i); ++s < i; )
      o[s] = r[e + s];
    s = -1;
    for (var a = Array(e + 1); ++s < e; )
      a[s] = r[s];
    return a[e] = n(o), _2e(t, this, a);
  };
}
var QR = w2e;
function S2e(t) {
  return function() {
    return t;
  };
}
var I2e = S2e;
function E2e(t) {
  return t;
}
var Vf = E2e, x2e = I2e, ak = TR, C2e = Vf, T2e = ak ? function(t, e) {
  return ak(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: x2e(e),
    writable: !0
  });
} : C2e, P2e = T2e, k2e = 800, N2e = 16, $2e = Date.now;
function D2e(t) {
  var e = 0, n = 0;
  return function() {
    var r = $2e(), s = N2e - (r - n);
    if (n = r, s > 0) {
      if (++e >= k2e)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var eL = D2e, A2e = P2e, O2e = eL, M2e = O2e(A2e), g2 = M2e, R2e = qR, L2e = QR, F2e = g2;
function B2e(t) {
  return F2e(L2e(t, void 0, R2e), t + "");
}
var y2 = B2e, lk = R4, j2e = lk && new lk(), tL = j2e, ck = tL, W2e = q5, H2e = ck ? function(t) {
  return ck.get(t);
} : W2e, b2 = H2e, V2e = {}, z2e = V2e, uk = z2e, U2e = Object.prototype, G2e = U2e.hasOwnProperty;
function Y2e(t) {
  for (var e = t.name + "", n = uk[e], r = G2e.call(uk, e) ? n.length : 0; r--; ) {
    var s = n[r], i = s.func;
    if (i == null || i == t)
      return s.name;
  }
  return e;
}
var nL = Y2e, Z2e = Wv, X2e = h2, K2e = 4294967295;
function Bm(t) {
  this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = K2e, this.__views__ = [];
}
Bm.prototype = Z2e(X2e.prototype);
Bm.prototype.constructor = Bm;
var _2 = Bm, J2e = _2, q2e = m2, Q2e = Wf;
function eIe(t) {
  if (t instanceof J2e)
    return t.clone();
  var e = new q2e(t.__wrapped__, t.__chain__);
  return e.__actions__ = Q2e(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
}
var tIe = eIe, nIe = _2, dk = m2, rIe = h2, sIe = Wr, iIe = Pi, oIe = tIe, aIe = Object.prototype, lIe = aIe.hasOwnProperty;
function jm(t) {
  if (iIe(t) && !sIe(t) && !(t instanceof nIe)) {
    if (t instanceof dk)
      return t;
    if (lIe.call(t, "__wrapped__"))
      return oIe(t);
  }
  return new dk(t);
}
jm.prototype = rIe.prototype;
jm.prototype.constructor = jm;
var cIe = jm, uIe = _2, dIe = b2, fIe = nL, pIe = cIe;
function hIe(t) {
  var e = fIe(t), n = pIe[e];
  if (typeof n != "function" || !(e in uIe.prototype))
    return !1;
  if (t === n)
    return !0;
  var r = dIe(n);
  return !!r && t === r[0];
}
var rL = hIe, fk = m2, mIe = y2, vIe = b2, Oy = nL, gIe = Wr, pk = rL, yIe = "Expected a function", bIe = 8, _Ie = 32, wIe = 128, SIe = 256;
function IIe(t) {
  return mIe(function(e) {
    var n = e.length, r = n, s = fk.prototype.thru;
    for (t && e.reverse(); r--; ) {
      var i = e[r];
      if (typeof i != "function")
        throw new TypeError(yIe);
      if (s && !o && Oy(i) == "wrapper")
        var o = new fk([], !0);
    }
    for (r = o ? r : n; ++r < n; ) {
      i = e[r];
      var a = Oy(i), l = a == "wrapper" ? vIe(i) : void 0;
      l && pk(l[0]) && l[1] == (wIe | bIe | _Ie | SIe) && !l[4].length && l[9] == 1 ? o = o[Oy(l[0])].apply(o, l[3]) : o = i.length == 1 && pk(i) ? o[a]() : o.thru(i);
    }
    return function() {
      var c = arguments, u = c[0];
      if (o && c.length == 1 && gIe(u))
        return o.plant(u).value();
      for (var d = 0, f = n ? e[d].apply(this, c) : u; ++d < n; )
        f = e[d].call(this, f);
      return f;
    };
  });
}
var EIe = IIe, xIe = EIe, CIe = xIe(), TIe = CIe;
const w2 = /* @__PURE__ */ Et(TIe);
var sL = {};
(function(t) {
  t.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, t.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, t.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, t.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, t.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, t.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, t.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, t.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, t.realToAlias = function() {
    var e = Object.prototype.hasOwnProperty, n = t.aliasToReal, r = {};
    for (var s in n) {
      var i = n[s];
      e.call(r, i) ? r[i].push(s) : r[i] = [s];
    }
    return r;
  }(), t.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, t.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, t.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(sL);
var My, hk;
function S2() {
  return hk || (hk = 1, My = {}), My;
}
var Nr = sL, PIe = S2(), mk = Array.prototype.push;
function kIe(t, e) {
  return e == 2 ? function(n, r) {
    return t.apply(void 0, arguments);
  } : function(n) {
    return t.apply(void 0, arguments);
  };
}
function Ry(t, e) {
  return e == 2 ? function(n, r) {
    return t(n, r);
  } : function(n) {
    return t(n);
  };
}
function vk(t) {
  for (var e = t ? t.length : 0, n = Array(e); e--; )
    n[e] = t[e];
  return n;
}
function NIe(t) {
  return function(e) {
    return t({}, e);
  };
}
function $Ie(t, e) {
  return function() {
    for (var n = arguments.length, r = n - 1, s = Array(n); n--; )
      s[n] = arguments[n];
    var i = s[e], o = s.slice(0, e);
    return i && mk.apply(o, i), e != r && mk.apply(o, s.slice(e + 1)), t.apply(this, o);
  };
}
function Ly(t, e) {
  return function() {
    var n = arguments.length;
    if (n) {
      for (var r = Array(n); n--; )
        r[n] = arguments[n];
      var s = r[0] = e.apply(void 0, r);
      return t.apply(void 0, r), s;
    }
  };
}
function X0(t, e, n, r) {
  var s = typeof e == "function", i = e === Object(e);
  if (i && (r = n, n = e, e = void 0), n == null)
    throw new TypeError();
  r || (r = {});
  var o = {
    cap: "cap" in r ? r.cap : !0,
    curry: "curry" in r ? r.curry : !0,
    fixed: "fixed" in r ? r.fixed : !0,
    immutable: "immutable" in r ? r.immutable : !0,
    rearg: "rearg" in r ? r.rearg : !0
  }, a = s ? n : PIe, l = "curry" in r && r.curry, c = "fixed" in r && r.fixed, u = "rearg" in r && r.rearg, d = s ? n.runInContext() : void 0, f = s ? n : {
    ary: t.ary,
    assign: t.assign,
    clone: t.clone,
    curry: t.curry,
    forEach: t.forEach,
    isArray: t.isArray,
    isError: t.isError,
    isFunction: t.isFunction,
    isWeakMap: t.isWeakMap,
    iteratee: t.iteratee,
    keys: t.keys,
    rearg: t.rearg,
    toInteger: t.toInteger,
    toPath: t.toPath
  }, p = f.ary, h = f.assign, m = f.clone, v = f.curry, y = f.forEach, _ = f.isArray, w = f.isError, S = f.isFunction, E = f.isWeakMap, x = f.keys, T = f.rearg, C = f.toInteger, k = f.toPath, b = x(Nr.aryMethod), P = {
    castArray: function(z) {
      return function() {
        var q = arguments[0];
        return _(q) ? z(vk(q)) : z.apply(void 0, arguments);
      };
    },
    iteratee: function(z) {
      return function() {
        var q = arguments[0], ae = arguments[1], Ee = z(q, ae), Ae = Ee.length;
        return o.cap && typeof ae == "number" ? (ae = ae > 2 ? ae - 2 : 1, Ae && Ae <= ae ? Ee : Ry(Ee, ae)) : Ee;
      };
    },
    mixin: function(z) {
      return function(q) {
        var ae = this;
        if (!S(ae))
          return z(ae, Object(q));
        var Ee = [];
        return y(x(q), function(Ae) {
          S(q[Ae]) && Ee.push([Ae, ae.prototype[Ae]]);
        }), z(ae, Object(q)), y(Ee, function(Ae) {
          var Ue = Ae[1];
          S(Ue) ? ae.prototype[Ae[0]] = Ue : delete ae.prototype[Ae[0]];
        }), ae;
      };
    },
    nthArg: function(z) {
      return function(q) {
        var ae = q < 0 ? 1 : C(q) + 1;
        return v(z(q), ae);
      };
    },
    rearg: function(z) {
      return function(q, ae) {
        var Ee = ae ? ae.length : 0;
        return v(z(q, ae), Ee);
      };
    },
    runInContext: function(z) {
      return function(q) {
        return X0(t, z(q), r);
      };
    }
  };
  function N(z, q) {
    if (o.cap) {
      var ae = Nr.iterateeRearg[z];
      if (ae)
        return se(q, ae);
      var Ee = !s && Nr.iterateeAry[z];
      if (Ee)
        return L(q, Ee);
    }
    return q;
  }
  function D(z, q, ae) {
    return l || o.curry && ae > 1 ? v(q, ae) : q;
  }
  function H(z, q, ae) {
    if (o.fixed && (c || !Nr.skipFixed[z])) {
      var Ee = Nr.methodSpread[z], Ae = Ee && Ee.start;
      return Ae === void 0 ? p(q, ae) : $Ie(q, Ae);
    }
    return q;
  }
  function Y(z, q, ae) {
    return o.rearg && ae > 1 && (u || !Nr.skipRearg[z]) ? T(q, Nr.methodRearg[z] || Nr.aryRearg[ae]) : q;
  }
  function te(z, q) {
    q = k(q);
    for (var ae = -1, Ee = q.length, Ae = Ee - 1, Ue = m(Object(z)), qe = Ue; qe != null && ++ae < Ee; ) {
      var Qe = q[ae], Lt = qe[Qe];
      Lt != null && !(S(Lt) || w(Lt) || E(Lt)) && (qe[Qe] = m(ae == Ae ? Lt : Object(Lt))), qe = qe[Qe];
    }
    return Ue;
  }
  function A(z) {
    return O.runInContext.convert(z)(void 0);
  }
  function j(z, q) {
    var ae = Nr.aliasToReal[z] || z, Ee = Nr.remap[ae] || ae, Ae = r;
    return function(Ue) {
      var qe = s ? d : f, Qe = s ? d[Ee] : q, Lt = h(h({}, Ae), Ue);
      return X0(qe, ae, Qe, Lt);
    };
  }
  function L(z, q) {
    return V(z, function(ae) {
      return typeof ae == "function" ? Ry(ae, q) : ae;
    });
  }
  function se(z, q) {
    return V(z, function(ae) {
      var Ee = q.length;
      return kIe(T(Ry(ae, Ee), q), Ee);
    });
  }
  function V(z, q) {
    return function() {
      var ae = arguments.length;
      if (!ae)
        return z();
      for (var Ee = Array(ae); ae--; )
        Ee[ae] = arguments[ae];
      var Ae = o.rearg ? 0 : ae - 1;
      return Ee[Ae] = q(Ee[Ae]), z.apply(void 0, Ee);
    };
  }
  function ee(z, q, ae) {
    var Ee, Ae = Nr.aliasToReal[z] || z, Ue = q, qe = P[Ae];
    return qe ? Ue = qe(q) : o.immutable && (Nr.mutate.array[Ae] ? Ue = Ly(q, vk) : Nr.mutate.object[Ae] ? Ue = Ly(q, NIe(q)) : Nr.mutate.set[Ae] && (Ue = Ly(q, te))), y(b, function(Qe) {
      return y(Nr.aryMethod[Qe], function(Lt) {
        if (Ae == Lt) {
          var Yt = Nr.methodSpread[Ae], nn = Yt && Yt.afterRearg;
          return Ee = nn ? H(Ae, Y(Ae, Ue, Qe), Qe) : Y(Ae, H(Ae, Ue, Qe), Qe), Ee = N(Ae, Ee), Ee = D(Ae, Ee, Qe), !1;
        }
      }), !Ee;
    }), Ee || (Ee = Ue), Ee == q && (Ee = l ? v(Ee, 1) : function() {
      return q.apply(this, arguments);
    }), Ee.convert = j(Ae, q), Ee.placeholder = q.placeholder = ae, Ee;
  }
  if (!i)
    return ee(e, n, a);
  var O = n, K = [];
  return y(b, function(z) {
    y(Nr.aryMethod[z], function(q) {
      var ae = O[Nr.remap[q] || q];
      ae && K.push([q, ee(q, ae, O)]);
    });
  }), y(x(O), function(z) {
    var q = O[z];
    if (typeof q == "function") {
      for (var ae = K.length; ae--; )
        if (K[ae][0] == z)
          return;
      q.convert = j(z, q), K.push([z, q]);
    }
  }), y(K, function(z) {
    O[z[0]] = z[1];
  }), O.convert = A, O.placeholder = O, y(x(O), function(z) {
    y(Nr.realToAlias[z] || [], function(q) {
      O[q] = O[z];
    });
  }), O;
}
var DIe = X0, AIe = Vf, gk = tL, OIe = gk ? function(t, e) {
  return gk.set(t, e), t;
} : AIe, iL = OIe, MIe = Wv, RIe = Yi;
function LIe(t) {
  return function() {
    var e = arguments;
    switch (e.length) {
      case 0:
        return new t();
      case 1:
        return new t(e[0]);
      case 2:
        return new t(e[0], e[1]);
      case 3:
        return new t(e[0], e[1], e[2]);
      case 4:
        return new t(e[0], e[1], e[2], e[3]);
      case 5:
        return new t(e[0], e[1], e[2], e[3], e[4]);
      case 6:
        return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
      case 7:
        return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
    }
    var n = MIe(t.prototype), r = t.apply(n, e);
    return RIe(r) ? r : n;
  };
}
var Yv = LIe, FIe = Yv, BIe = Rs, jIe = 1;
function WIe(t, e, n) {
  var r = e & jIe, s = FIe(t);
  function i() {
    var o = this && this !== BIe && this instanceof i ? s : t;
    return o.apply(r ? n : this, arguments);
  }
  return i;
}
var HIe = WIe, VIe = Math.max;
function zIe(t, e, n, r) {
  for (var s = -1, i = t.length, o = n.length, a = -1, l = e.length, c = VIe(i - o, 0), u = Array(l + c), d = !r; ++a < l; )
    u[a] = e[a];
  for (; ++s < o; )
    (d || s < i) && (u[n[s]] = t[s]);
  for (; c--; )
    u[a++] = t[s++];
  return u;
}
var oL = zIe, UIe = Math.max;
function GIe(t, e, n, r) {
  for (var s = -1, i = t.length, o = -1, a = n.length, l = -1, c = e.length, u = UIe(i - a, 0), d = Array(u + c), f = !r; ++s < u; )
    d[s] = t[s];
  for (var p = s; ++l < c; )
    d[p + l] = e[l];
  for (; ++o < a; )
    (f || s < i) && (d[p + n[o]] = t[s++]);
  return d;
}
var aL = GIe;
function YIe(t, e) {
  for (var n = t.length, r = 0; n--; )
    t[n] === e && ++r;
  return r;
}
var ZIe = YIe, XIe = iL, KIe = eL, JIe = KIe(XIe), lL = JIe, qIe = /\{\n\/\* \[wrapped with (.+)\] \*/, QIe = /,? & /;
function eEe(t) {
  var e = t.match(qIe);
  return e ? e[1].split(QIe) : [];
}
var tEe = eEe, nEe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function rEe(t, e) {
  var n = e.length;
  if (!n)
    return t;
  var r = n - 1;
  return e[r] = (n > 1 ? "& " : "") + e[r], e = e.join(n > 2 ? ", " : " "), t.replace(nEe, `{
/* [wrapped with ` + e + `] */
`);
}
var sEe = rEe, iEe = i2, oEe = xv, aEe = 1, lEe = 2, cEe = 8, uEe = 16, dEe = 32, fEe = 64, pEe = 128, hEe = 256, mEe = 512, vEe = [
  ["ary", pEe],
  ["bind", aEe],
  ["bindKey", lEe],
  ["curry", cEe],
  ["curryRight", uEe],
  ["flip", mEe],
  ["partial", dEe],
  ["partialRight", fEe],
  ["rearg", hEe]
];
function gEe(t, e) {
  return iEe(vEe, function(n) {
    var r = "_." + n[0];
    e & n[1] && !oEe(t, r) && t.push(r);
  }), t.sort();
}
var yEe = gEe, bEe = tEe, _Ee = sEe, wEe = g2, SEe = yEe;
function IEe(t, e, n) {
  var r = e + "";
  return wEe(t, _Ee(r, SEe(bEe(r), n)));
}
var cL = IEe, EEe = rL, xEe = lL, CEe = cL, TEe = 1, PEe = 2, kEe = 4, NEe = 8, yk = 32, bk = 64;
function $Ee(t, e, n, r, s, i, o, a, l, c) {
  var u = e & NEe, d = u ? o : void 0, f = u ? void 0 : o, p = u ? i : void 0, h = u ? void 0 : i;
  e |= u ? yk : bk, e &= ~(u ? bk : yk), e & kEe || (e &= ~(TEe | PEe));
  var m = [
    t,
    e,
    s,
    p,
    d,
    h,
    f,
    a,
    l,
    c
  ], v = n.apply(void 0, m);
  return EEe(t) && xEe(v, m), v.placeholder = r, CEe(v, t, e);
}
var uL = $Ee;
function DEe(t) {
  var e = t;
  return e.placeholder;
}
var dL = DEe, AEe = Wf, OEe = Av, MEe = Math.min;
function REe(t, e) {
  for (var n = t.length, r = MEe(e.length, n), s = AEe(t); r--; ) {
    var i = e[r];
    t[r] = OEe(i, n) ? s[i] : void 0;
  }
  return t;
}
var LEe = REe, _k = "__lodash_placeholder__";
function FEe(t, e) {
  for (var n = -1, r = t.length, s = 0, i = []; ++n < r; ) {
    var o = t[n];
    (o === e || o === _k) && (t[n] = _k, i[s++] = n);
  }
  return i;
}
var I2 = FEe, BEe = oL, jEe = aL, WEe = ZIe, wk = Yv, HEe = uL, VEe = dL, zEe = LEe, UEe = I2, GEe = Rs, YEe = 1, ZEe = 2, XEe = 8, KEe = 16, JEe = 128, qEe = 512;
function fL(t, e, n, r, s, i, o, a, l, c) {
  var u = e & JEe, d = e & YEe, f = e & ZEe, p = e & (XEe | KEe), h = e & qEe, m = f ? void 0 : wk(t);
  function v() {
    for (var y = arguments.length, _ = Array(y), w = y; w--; )
      _[w] = arguments[w];
    if (p)
      var S = VEe(v), E = WEe(_, S);
    if (r && (_ = BEe(_, r, s, p)), i && (_ = jEe(_, i, o, p)), y -= E, p && y < c) {
      var x = UEe(_, S);
      return HEe(
        t,
        e,
        fL,
        v.placeholder,
        n,
        _,
        x,
        a,
        l,
        c - y
      );
    }
    var T = d ? n : this, C = f ? T[t] : t;
    return y = _.length, a ? _ = zEe(_, a) : h && y > 1 && _.reverse(), u && l < y && (_.length = l), this && this !== GEe && this instanceof v && (C = m || wk(C)), C.apply(T, _);
  }
  return v;
}
var pL = fL, QEe = v2, exe = Yv, txe = pL, nxe = uL, rxe = dL, sxe = I2, ixe = Rs;
function oxe(t, e, n) {
  var r = exe(t);
  function s() {
    for (var i = arguments.length, o = Array(i), a = i, l = rxe(s); a--; )
      o[a] = arguments[a];
    var c = i < 3 && o[0] !== l && o[i - 1] !== l ? [] : sxe(o, l);
    if (i -= c.length, i < n)
      return nxe(
        t,
        e,
        txe,
        s.placeholder,
        void 0,
        o,
        c,
        void 0,
        void 0,
        n - i
      );
    var u = this && this !== ixe && this instanceof s ? r : t;
    return QEe(u, this, o);
  }
  return s;
}
var axe = oxe, lxe = v2, cxe = Yv, uxe = Rs, dxe = 1;
function fxe(t, e, n, r) {
  var s = e & dxe, i = cxe(t);
  function o() {
    for (var a = -1, l = arguments.length, c = -1, u = r.length, d = Array(u + l), f = this && this !== uxe && this instanceof o ? i : t; ++c < u; )
      d[c] = r[c];
    for (; l--; )
      d[c++] = arguments[++a];
    return lxe(f, s ? n : this, d);
  }
  return o;
}
var pxe = fxe, hxe = oL, mxe = aL, Sk = I2, Ik = "__lodash_placeholder__", Fy = 1, vxe = 2, gxe = 4, Ek = 8, dd = 128, xk = 256, yxe = Math.min;
function bxe(t, e) {
  var n = t[1], r = e[1], s = n | r, i = s < (Fy | vxe | dd), o = r == dd && n == Ek || r == dd && n == xk && t[7].length <= e[8] || r == (dd | xk) && e[7].length <= e[8] && n == Ek;
  if (!(i || o))
    return t;
  r & Fy && (t[2] = e[2], s |= n & Fy ? 0 : gxe);
  var a = e[3];
  if (a) {
    var l = t[3];
    t[3] = l ? hxe(l, a, e[4]) : a, t[4] = l ? Sk(t[3], Ik) : e[4];
  }
  return a = e[5], a && (l = t[5], t[5] = l ? mxe(l, a, e[6]) : a, t[6] = l ? Sk(t[5], Ik) : e[6]), a = e[7], a && (t[7] = a), r & dd && (t[8] = t[8] == null ? e[8] : yxe(t[8], e[8])), t[9] == null && (t[9] = e[9]), t[0] = e[0], t[1] = s, t;
}
var _xe = bxe, wxe = B4, Ck = 1 / 0, Sxe = 17976931348623157e292;
function Ixe(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = wxe(t), t === Ck || t === -Ck) {
    var e = t < 0 ? -1 : 1;
    return e * Sxe;
  }
  return t === t ? t : 0;
}
var Exe = Ixe, xxe = Exe;
function Cxe(t) {
  var e = xxe(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var E2 = Cxe, Txe = iL, Pxe = HIe, kxe = axe, Nxe = pL, $xe = pxe, Dxe = b2, Axe = _xe, Oxe = lL, Mxe = cL, Tk = E2, Rxe = "Expected a function", Pk = 1, Lxe = 2, By = 8, jy = 16, Wy = 32, kk = 64, Nk = Math.max;
function Fxe(t, e, n, r, s, i, o, a) {
  var l = e & Lxe;
  if (!l && typeof t != "function")
    throw new TypeError(Rxe);
  var c = r ? r.length : 0;
  if (c || (e &= ~(Wy | kk), r = s = void 0), o = o === void 0 ? o : Nk(Tk(o), 0), a = a === void 0 ? a : Tk(a), c -= s ? s.length : 0, e & kk) {
    var u = r, d = s;
    r = s = void 0;
  }
  var f = l ? void 0 : Dxe(t), p = [
    t,
    e,
    n,
    r,
    s,
    u,
    d,
    i,
    o,
    a
  ];
  if (f && Axe(p, f), t = p[0], e = p[1], n = p[2], r = p[3], s = p[4], a = p[9] = p[9] === void 0 ? l ? 0 : t.length : Nk(p[9] - c, 0), !a && e & (By | jy) && (e &= ~(By | jy)), !e || e == Pk)
    var h = Pxe(t, e, n);
  else e == By || e == jy ? h = kxe(t, e, a) : (e == Wy || e == (Pk | Wy)) && !s.length ? h = $xe(t, e, n, r) : h = Nxe.apply(void 0, p);
  var m = f ? Txe : Oxe;
  return Mxe(m(h, p), t, e);
}
var x2 = Fxe, Bxe = x2, jxe = 128;
function Wxe(t, e, n) {
  return e = n ? void 0 : e, e = t && e == null ? t.length : e, Bxe(t, jxe, void 0, void 0, void 0, void 0, e);
}
var Hxe = Wxe, Vxe = u2, zxe = 4;
function Uxe(t) {
  return Vxe(t, zxe);
}
var Gxe = Uxe, Yxe = x2, Zxe = 8;
function C2(t, e, n) {
  e = n ? void 0 : e;
  var r = Yxe(t, Zxe, void 0, void 0, void 0, void 0, void 0, e);
  return r.placeholder = C2.placeholder, r;
}
C2.placeholder = {};
var Xxe = C2, Kxe = oc, Jxe = l2, qxe = Pi, Qxe = "[object Object]", eCe = Function.prototype, tCe = Object.prototype, hL = eCe.toString, nCe = tCe.hasOwnProperty, rCe = hL.call(Object);
function sCe(t) {
  if (!qxe(t) || Kxe(t) != Qxe)
    return !1;
  var e = Jxe(t);
  if (e === null)
    return !0;
  var n = nCe.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && hL.call(n) == rCe;
}
var iCe = sCe, oCe = oc, aCe = Pi, lCe = iCe, cCe = "[object DOMException]", uCe = "[object Error]";
function dCe(t) {
  if (!aCe(t))
    return !1;
  var e = oCe(t);
  return e == uCe || e == cCe || typeof t.message == "string" && typeof t.name == "string" && !lCe(t);
}
var fCe = dCe, pCe = Nu, hCe = Pi, mCe = "[object WeakMap]";
function vCe(t) {
  return hCe(t) && pCe(t) == mCe;
}
var gCe = vCe, yCe = HS, bCe = KS, _Ce = 1, wCe = 2;
function SCe(t, e, n, r) {
  var s = n.length, i = s, o = !r;
  if (t == null)
    return !i;
  for (t = Object(t); s--; ) {
    var a = n[s];
    if (o && a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++s < i; ) {
    a = n[s];
    var l = a[0], c = t[l], u = a[1];
    if (o && a[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var d = new yCe();
      if (r)
        var f = r(c, u, l, t, e, d);
      if (!(f === void 0 ? bCe(u, c, _Ce | wCe, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var ICe = SCe, ECe = Yi;
function xCe(t) {
  return t === t && !ECe(t);
}
var mL = xCe, CCe = mL, TCe = Pu;
function PCe(t) {
  for (var e = TCe(t), n = e.length; n--; ) {
    var r = e[n], s = t[r];
    e[n] = [r, s, CCe(s)];
  }
  return e;
}
var kCe = PCe;
function NCe(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var vL = NCe, $Ce = ICe, DCe = kCe, ACe = vL;
function OCe(t) {
  var e = DCe(t);
  return e.length == 1 && e[0][2] ? ACe(e[0][0], e[0][1]) : function(n) {
    return n === t || $Ce(n, t, e);
  };
}
var MCe = OCe;
function RCe(t, e) {
  return t != null && e in Object(t);
}
var LCe = RCe, FCe = Nv, BCe = $v, jCe = Wr, WCe = Av, HCe = GS, VCe = xu;
function zCe(t, e, n) {
  e = FCe(e, t);
  for (var r = -1, s = e.length, i = !1; ++r < s; ) {
    var o = VCe(e[r]);
    if (!(i = t != null && n(t, o)))
      break;
    t = t[o];
  }
  return i || ++r != s ? i : (s = t == null ? 0 : t.length, !!s && HCe(s) && WCe(o, s) && (jCe(t) || BCe(t)));
}
var UCe = zCe, GCe = LCe, YCe = UCe;
function ZCe(t, e) {
  return t != null && YCe(t, e, GCe);
}
var gL = ZCe, XCe = KS, KCe = T4, JCe = gL, qCe = BS, QCe = mL, eTe = vL, tTe = xu, nTe = 1, rTe = 2;
function sTe(t, e) {
  return qCe(t) && QCe(e) ? eTe(tTe(t), e) : function(n) {
    var r = KCe(n, t);
    return r === void 0 && r === e ? JCe(n, t) : XCe(e, r, nTe | rTe);
  };
}
var iTe = sTe;
function oTe(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var aTe = oTe, lTe = WS;
function cTe(t) {
  return function(e) {
    return lTe(e, t);
  };
}
var uTe = cTe, dTe = aTe, fTe = uTe, pTe = BS, hTe = xu;
function mTe(t) {
  return pTe(t) ? dTe(hTe(t)) : fTe(t);
}
var yL = mTe;
const vTe = /* @__PURE__ */ Et(yL);
var gTe = MCe, yTe = iTe, bTe = Vf, _Te = Wr, wTe = yL;
function STe(t) {
  return typeof t == "function" ? t : t == null ? bTe : typeof t == "object" ? _Te(t) ? yTe(t[0], t[1]) : gTe(t) : wTe(t);
}
var ta = STe, ITe = u2, ETe = ta, xTe = 1;
function CTe(t) {
  return ETe(typeof t == "function" ? t : ITe(t, xTe));
}
var TTe = CTe, PTe = x2, kTe = y2, NTe = 256, $Te = kTe(function(t, e) {
  return PTe(t, NTe, void 0, void 0, void 0, e);
}), DTe = $Te, ATe = Qa, OTe = Wf, MTe = Wr, RTe = Iu, LTe = C4, FTe = xu, BTe = Lf;
function jTe(t) {
  return MTe(t) ? ATe(t, FTe) : RTe(t) ? [t] : OTe(LTe(BTe(t)));
}
var WTe = jTe, HTe = {
  ary: Hxe,
  assign: PR,
  clone: Gxe,
  curry: Xxe,
  forEach: i2,
  isArray: Wr,
  isError: fCe,
  isFunction: TS,
  isWeakMap: gCe,
  iteratee: TTe,
  keys: XS,
  rearg: DTe,
  toInteger: E2,
  toPath: WTe
}, VTe = DIe, zTe = HTe;
function UTe(t, e, n) {
  return VTe(zTe, t, e, n);
}
var bL = UTe;
function GTe(t) {
  return function(e, n, r) {
    for (var s = -1, i = Object(e), o = r(e), a = o.length; a--; ) {
      var l = o[t ? a : ++s];
      if (n(i[l], l, i) === !1)
        break;
    }
    return e;
  };
}
var YTe = GTe, ZTe = YTe, XTe = ZTe(), KTe = XTe, JTe = KTe, qTe = Pu;
function QTe(t, e) {
  return t && JTe(t, e, qTe);
}
var _L = QTe, ePe = lc;
function tPe(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!ePe(n))
      return t(n, r);
    for (var s = n.length, i = e ? s : -1, o = Object(n); (e ? i-- : ++i < s) && r(o[i], i, o) !== !1; )
      ;
    return n;
  };
}
var nPe = tPe, rPe = _L, sPe = nPe, iPe = sPe(rPe), T2 = iPe, Hy, $k;
function oPe() {
  if ($k) return Hy;
  $k = 1;
  var t = T2;
  function e(n, r) {
    var s = [];
    return t(n, function(i, o, a) {
      r(i, o, a) && s.push(i);
    }), s;
  }
  return Hy = e, Hy;
}
var Vy, Dk;
function aPe() {
  if (Dk) return Vy;
  Dk = 1;
  var t = zS, e = oPe(), n = ta, r = Wr;
  function s(i, o) {
    var a = r(i) ? t : e;
    return a(i, n(o));
  }
  return Vy = s, Vy;
}
var lPe = bL, wL = lPe("filter", aPe());
wL.placeholder = S2();
var cPe = wL;
const P2 = /* @__PURE__ */ Et(cPe);
var zy, Ak;
function uPe() {
  if (Ak) return zy;
  Ak = 1;
  var t = T2, e = lc;
  function n(r, s) {
    var i = -1, o = e(r) ? Array(r.length) : [];
    return t(r, function(a, l, c) {
      o[++i] = s(a, l, c);
    }), o;
  }
  return zy = n, zy;
}
var Uy, Ok;
function dPe() {
  if (Ok) return Uy;
  Ok = 1;
  var t = Qa, e = ta, n = uPe(), r = Wr;
  function s(i, o) {
    var a = r(i) ? t : n;
    return a(i, e(o));
  }
  return Uy = s, Uy;
}
var fPe = bL, SL = fPe("map", dPe());
SL.placeholder = S2();
var pPe = SL;
const k2 = /* @__PURE__ */ Et(pPe), ba = (t, e) => {
  const n = (o) => o.state === e, r = ({ id: o }) => o, i = w2(P2(n), k2(r))(t);
  return fs(i) ? null : i.join(",");
}, hPe = {
  name: "PbPanelDynamicEntry",
  components: {
    PbEntryDate: nl,
    PbDateWidget: Hr
  },
  props: {
    body: {
      type: String,
      default: null
    },
    entry: {
      type: Object,
      default: null
    },
    dateMode: {
      type: Number,
      default: 0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isHighlighted: {
      type: Boolean,
      default: !1
    },
    isRevoked: {
      type: Boolean,
      default: !1
    },
    fontStyle: {
      type: Object,
      default: () => {
      }
    }
  }
};
var mPe = function() {
  var e = this, n = e._self._c;
  return e.entry ? n("div", { class: {
    "pb-panel-dynamic-entry": !0,
    compact: e.isCompact,
    selected: e.isSelected,
    highlighted: e.isHighlighted,
    revoked: e.isRevoked
  }, attrs: { "data-test-id": e.entry.id } }, [e.entry ? [e._t("default", function() {
    return [e._t("header", function() {
      return [n("PbEntryDate", { staticClass: "entry-date" }, [n("PbDateWidget", { attrs: { date: e.entry.status_modified_at, mode: e.dateMode }, on: { dateModeChanged: function(r) {
        return e.$emit("dateModeChanged", r);
      } } })], 1)];
    }, { props: { entry: e.entry, isSelected: e.isSelected } }), n("main", { style: e.fontStyle }, [e.body !== null ? [n("p", { staticClass: "text", domProps: { innerHTML: e._s(e.body) } })] : e._e()], 2), e._t("actions", function() {
      return [n("div", { staticClass: "action-block" }, [n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Открыть в отдельной панели", expression: "'Открыть в отдельной панели'" }], staticClass: "action mini-button show-more pb-action-button-old", attrs: { iconName: "button-icon-show-more", "data-test-selector": "entry-button-show-more" }, on: { click: function(r) {
        return e.$emit("openPanel", e.entry.id);
      } } })], 1)];
    }, { props: { entry: e.entry, isSelected: e.isSelected } }), e._t("extra", null, { props: { entry: e.entry, isSelected: e.isSelected } })];
  }, { props: { entry: e.entry, isSelected: e.isSelected } })] : e._e()], 2) : e._e();
}, vPe = [], gPe = /* @__PURE__ */ B(
  hPe,
  mPe,
  vPe,
  !1,
  null,
  "3e467911"
);
const Zv = gPe.exports, yPe = {
  name: "PbPanelListEntryActions",
  props: {
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "ffffff"
    }
  }
};
var bPe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { "list-entry-actions": !0, compact: e.isCompact }, style: { color: "#" + e.color } }, [e._t("default")], 2);
}, _Pe = [], wPe = /* @__PURE__ */ B(
  yPe,
  bPe,
  _Pe,
  !1,
  null,
  "30b860fc"
);
const Xv = wPe.exports, SPe = "_root_u0jld_1", IPe = "_helperDiv_u0jld_2", EPe = "_root_invertedColors_u0jld_17", xPe = "_helperDiv_invertedColors_u0jld_18", CPe = "_rootWrapper_u0jld_22", TPe = {
  root: SPe,
  helperDiv: IPe,
  root_invertedColors: EPe,
  helperDiv_invertedColors: xPe,
  rootWrapper: CPe
}, PPe = {
  name: "NewsCodesInline",
  props: {
    codes: {
      type: Array,
      default: () => []
    },
    preferableGroupIds: {
      type: Array,
      default: () => []
    },
    codesFilter: {
      type: Function,
      // eslint-disable-next-line
      default: (t) => !0
    },
    /** Список переменных, изменение которых должно вызывать обновление компонента
     * Подходят: строки, числа, булевы переменные, объекты, массивы
     * Не подходят: функции (+ нужно следить за реактивностью объектов)
     */
    updateKeys: {
      type: Array,
      default: () => []
    },
    tipGetter: {
      type: Function,
      default: (t) => t.name
    },
    nameGetter: {
      type: Function,
      default: (t) => t.name
    },
    delimiter: {
      type: String,
      default: ", "
    },
    invertedColors: {
      type: Boolean,
      default: !1
    }
  },
  mounted() {
    this.$data.$mounted = !0;
  },
  computed: {
    sortedCodes() {
      return fs(this.preferableGroupIds) ? this.codes : [...this.codes].sort((t, e) => {
        var s, i, o, a;
        const n = this.preferableGroupIds.includes(
          (i = (s = t.code) == null ? void 0 : s.category) == null ? void 0 : i.id
        ), r = this.preferableGroupIds.includes(
          (a = (o = e.code) == null ? void 0 : o.category) == null ? void 0 : a.id
        );
        return n && !r ? -1 : !n && r ? 1 : 0;
      });
    },
    filteredCodes() {
      return this.sortedCodes.filter((t) => this.codesFilter(t.code));
    },
    visibleCodesCount() {
      this.updateKeys;
      const t = this.$refs.helper;
      if (!t) return 0;
      t.textContent = "";
      const e = this.filteredCodes.map((r) => `<span>${this.nameGetter(r.code)}</span>`).join(this.delimiter);
      t.insertAdjacentHTML("beforeend", e);
      const n = [...t.children].filter((r) => r.offsetLeft < t.offsetWidth).length;
      return t.textContent = "", n;
    },
    visibleCodes() {
      return this.filteredCodes.slice(0, this.visibleCodesCount || 0);
    },
    restCodes() {
      return this.filteredCodes.slice(this.visibleCodesCount);
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_invertedColors]: this.invertedColors
      };
    }
  },
  data() {
    return {
      $mounted: !1
    };
  }
};
var kPe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.rootWrapper }, [n("div", { class: e.$style.helperDiv }, [n("div", { ref: "helper" })]), e.$data.$mounted ? n("div", { class: e.rootClass }, [n("div", e._l(e.visibleCodes, function({ code: r }, s) {
    return n("span", { key: r.id }, [n("span", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: {
      // TODO: решить, что делать с тултипом, сейчас он просто дублирует code.name (раньше он показывал полное имя)
      content: e.tipGetter(r),
      class: "NewsCodesInline-tooltip"
    }, expression: `{
            // TODO: решить, что делать с тултипом, сейчас он просто дублирует code.name (раньше он показывал полное имя)
            content: tipGetter(code),
            class: 'NewsCodesInline-tooltip',
          }` }] }, [e._v(e._s(e.nameGetter(r)))]), s !== e.visibleCodes.length - 1 ? n("span", [e._v(e._s(e.delimiter))]) : e._e()]);
  }), 0), n("div", [e.restCodes.length ? n("span", { class: e.$style.more }, [e._v(" +" + e._s(e.restCodes.length))]) : e._e()])]) : e._e()]);
}, NPe = [];
const Mk = {
  $style: TPe
};
function $Pe(t) {
  for (var e in Mk)
    this[e] = Mk[e];
}
var DPe = /* @__PURE__ */ B(
  PPe,
  kPe,
  NPe,
  !1,
  $Pe,
  null
);
const IL = DPe.exports, APe = {
  name: "AsoiNotesEmbargoListEntry",
  mixins: [ai],
  components: {
    PbDateWidget: Hr,
    PbEntryDate: nl,
    PbPanelDynamicEntry: Zv,
    MainActionButton: fn,
    PbPanelListEntryActions: Xv,
    PbNewsTypeButton: ea,
    NewsCodesInline: IL
  },
  props: {
    item: {
      type: Object,
      required: !0
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    dateMode: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "000"
    }
  },
  setup(t) {
    const e = Jt("store"), n = {
      getEntryById: e.getters.getAsoiNoteById("embargo"),
      getIsFeedCode: e.getters["news/codes/getIsFeedCode"],
      getIsPublicationCode: e.getters["news/codes/getIsPublicationCode"],
      getIsUrgentVersionType: e.getters["news/versions/getIsUrgentVersionType"],
      getIsUserHasAnyPermission: e.getters["auth/getIsUserHasAnyPermission"]
    }, r = le(() => {
      var u;
      return (u = t.item) == null ? void 0 : u.id;
    }), s = le(() => n.getEntryById(r.value)), i = le(() => {
      var u, d;
      return Ps((d = (u = s.value) == null ? void 0 : u.sender) == null ? void 0 : d.name);
    }), o = s, a = le(
      () => n.getIsUserHasAnyPermission(["4.3"])
    ), l = { "grid-column": "1 / -1" }, c = {
      panelColors: le(() => {
        var d;
        let u = (d = t.editorStyle) == null ? void 0 : d.backgroundColor;
        return (u === void 0 || u.toLowerCase() === "#ffffff") && (u = "#eeeeee"), `
          --bg-color: rgba(255, 235, 230, 1);
          --selected-bg-color: ${u};
        `;
      }),
      isUrgent: le(() => n.getIsUrgentVersionType(o.value.type_id)),
      newsTypeButtonColor: le(
        () => c.isUrgent.value ? "#D0021B" : "#b3b3b3"
      )
    };
    return {
      ...n,
      ...c,
      contentStyle: l,
      author: i,
      itemId: r,
      entry: s,
      version: o,
      actionable: a
    };
  }
};
var OPe = function() {
  var e = this, n = e._self._c;
  return n("PbPanelDynamicEntry", { staticClass: "news-embargo-list-entry", class: { compact: e.isCompact }, style: e.panelColors, attrs: { entry: e.entry, body: e.version.headline || e.version.body, dateMode: e.dateMode, isCompact: e.isCompact, isSelected: e.isSelected, isHighlighted: e.isUrgent, fontStyle: e.contentStyle }, scopedSlots: e._u([{ key: "header", fn: function() {
    return [e.version.type_id ? n("PbNewsTypeButton", { staticClass: "type", attrs: { typeId: e.version.type_id, iconSize: 18, color: e.newsTypeButtonColor, disabled: "" } }) : e._e(), n("div", { staticClass: "extra-block publishers" }, [n("span", [e._v(e._s(e.author))])]), e.version.publish_at === null ? n("div", { staticClass: "date" }, [n("span", [e._v("До звонка")])]) : n("PbEntryDate", { staticClass: "date" }, [n("pre", [e._v("До ")]), n("PbDateWidget", { attrs: { date: e.version.publish_at, mode: e.dateMode } })], 1)];
  }, proxy: !0 }, { key: "actions", fn: function() {
    return [e._v(e._s(null))];
  }, proxy: !0 }, { key: "extra", fn: function() {
    return [n("div", { staticClass: "extra-block codes" }, [n("NewsCodesInline", { key: e.entry.status_modified_at, attrs: { codes: e.entry.codes, codesFilter: e.getIsFeedCode, updateKeys: [e.isCompact] } })], 1), n("PbPanelListEntryActions", { staticClass: "extra-block actions", attrs: { color: e.color, isCompact: e.isCompact } }, [n("MainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.actionable, expression: "actionable" }, { name: "tooltip", rawName: "v-tooltip", value: "Взять в работу", expression: "'Взять в работу'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "news-item-button-add" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("pick", e.entry);
    } } }), n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Открыть в отдельной панели", expression: "'Открыть в отдельной панели'" }], staticClass: "action mini-button show-more pb-action-button-old", attrs: { iconName: "button-icon-show-more", "data-test-selector": "entry-button-show-more" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("openPanel", e.entry.id);
    } } })], 1)];
  }, proxy: !0 }]) });
}, MPe = [], RPe = /* @__PURE__ */ B(
  APe,
  OPe,
  MPe,
  !1,
  null,
  "c0b9dc07"
);
const LPe = RPe.exports, FPe = {
  name: "AsoiNotesEmbargoList",
  components: {
    WithTwoWayLoading: Lv,
    PanelList: Fv,
    AsoiNotesEmbargoListEntry: LPe
  },
  props: {
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#fff"
    },
    dateMode: {
      type: Number,
      default: 0
    },
    isFocused: {
      type: Function,
      default: () => !1
    },
    loadParams: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const t = Jt("store"), e = le(
      () => t.state.asoi.embargo.list.map((i) => ({ id: i }))
    ), n = {
      getEntryById: t.getters.getAsoiNoteById("embargo"),
      getPanelIndex: t.getters["panels/getPanelIndex"],
      getPanelIsActive: t.getters.getPanelIsActive
    }, r = le(
      () => [...e.value].sort((i, o) => (i = t.state.asoi.embargo.items[i.id], o = t.state.asoi.embargo.items[o.id], i.publish_at && !o.publish_at ? 1 : !i.publish_at && o.publish_at ? -1 : !i.publish_at && !o.publish_at ? new Date(i.created_at) - new Date(o.created_at) : new Date(i.publish_at) - new Date(o.publish_at)))
    );
    return {
      ...n,
      sortedItems: r,
      loadEntries: ({ params: i, replace: o }) => t.dispatch("loadAsoiNotesEmbargo", { params: i, replace: o })
    };
  },
  data() {
    return {
      stateName: "embargo"
    };
  },
  computed: {
    ...st({
      modal: (t) => t.uiState.modal,
      isDragging: (t) => t.uiState.panelsDragging
    }),
    initialLoaded() {
      return this.$store.state.asoi[this.stateName].initialLoaded;
    },
    active() {
      return this.panelId && this.getPanelIsActive(this.panelId);
    },
    sizeDeps() {
      return () => [];
    }
  },
  beforeDestroy() {
    this.setInitialLoaded(!1);
  },
  watch: {
    loadParams: {
      deep: !0,
      handler() {
        this.$refs.withLoading && this.active && this.$refs.withLoading.refresh();
      }
    }
  },
  methods: {
    ...ge("panels", ["hideSupply", "setPanelDateMode", "addPanel"]),
    ...ge([
      "setAsoiNoteAsRead",
      "pickAsoiNote",
      "deleteAsoiNote",
      "selectAsoiNote"
    ]),
    setInitialLoaded(t) {
      const n = {
        received: "asoiNotesSetInitialLoaded",
        sent: "asoiNotesSentSetInitialLoaded",
        embargo: "asoiNotesEmbargoSetInitialLoaded"
      }[this.stateName];
      this.$store.dispatch(n, t), this.$nextTick(() => {
        this.$refs.panelList && this.$refs.panelList.scrollToItem(0);
      });
    },
    async fetchData({ cursor: t, limit: e = 30, reverse: n = !1, replace: r = !1 }) {
      let s = [], i = {
        cursor: t,
        limit: e,
        reverse: n,
        ...this.loadParams
      };
      return s = await this.loadEntries({ params: i, replace: r }), s.data && (this.loaded = s.next_cursor === null), s;
    },
    pick(t) {
      this.panel && this.hideSupply({
        panelId: this.panel.id,
        supplyId: this.panel.supply.right[0].id
      }), this.pickAsoiNote({ note: t });
    },
    openPanel(t) {
      t.id && (t = t.id), this.addPanel({
        panel: {
          dataId: t,
          type: ve.asoiNoteEmbargo
        },
        position: this.getPanelIndex(this.panelId)
      });
      const e = this.getEntryById(t);
      e.is_read || this.setAsoiNoteAsRead(e);
    }
  }
};
var BPe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "embargo-list", attrs: { "data-test-selector": "asoi-embargo-list" } }, [n("WithTwoWayLoading", { ref: "withLoading", attrs: { hasNew: !1, isPaused: !1, active: !0, fetchData: e.fetchData, scrollToUnread: () => {
  }, initialLoaded: e.initialLoaded, maxLength: 90, entries: e.sortedItems, entryGetter: e.getEntryById, cursorField: "id", emptyText: "Заметок нет" }, on: { setPaused: () => {
  }, setHasNew: () => {
  }, initialLoaded: e.setInitialLoaded }, scopedSlots: e._u([{ key: "default", fn: function({ loadNext: r, loadPrev: s, refresh: i, hasNew: o, loaded: a, loading: l }) {
    return [e.sortedItems.length ? n("PanelList", { ref: "panelList", attrs: { entries: e.sortedItems, panelId: e.panelId, isCompact: e.isCompact, color: e.color, dateMode: e.dateMode, loaded: a, loading: l, isFocused: e.isFocused, modal: e.modal, active: !0, initialLoaded: e.initialLoaded, hasNew: o, isDragging: e.isDragging, sizeDeps: e.sizeDeps, minimalHeight: e.isCompact ? 38 : 165, emptyText: "Заметок нет", newItemsMessage: "Есть новые заметки" }, on: { select: e.selectAsoiNote, openPanel: e.openPanel, reachedEnd: s, reachedTop: r, unreadClick: i }, scopedSlots: e._u([{ key: "default", fn: function({ item: c, isSelected: u }) {
      return [n("AsoiNotesEmbargoListEntry", { attrs: { isSelected: u, color: e.color, isCompact: e.isCompact, dateMode: e.dateMode, item: c }, on: { pick: e.pick, openPanel: e.openPanel, "!dateModeChanged": function(d) {
        return e.setPanelDateMode({ panelId: e.panelId, mode: d });
      } } })];
    } }], null, !0) }) : e._e()];
  } }]) })], 1);
}, jPe = [], WPe = /* @__PURE__ */ B(
  FPe,
  BPe,
  jPe,
  !1,
  null,
  null
);
const HPe = WPe.exports, VPe = "_appBar_1uurj_1", zPe = "_rangeFilter_1uurj_15", UPe = {
  appBar: VPe,
  rangeFilter: zPe
}, Gy = "embargo", GPe = {
  name: "AsoiNotesEmbargoPanel",
  components: {
    Panel: bs,
    AsoiNotesEmbargoList: HPe,
    PbButton: nt,
    NewsPublishedCodesFilter: XR
  },
  props: {
    type: String,
    panel: {
      type: Object,
      required: !0
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    ...pe(["sessionTimeoutExpired", "getFiltersByNotetype"]),
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    ...pe("userProfile", ["getProfileFilters"]),
    userHasPermissions() {
      return this.getIsUserHasAllPermissions(["4.3"]);
    },
    appliedFilters() {
      return this.getFiltersByNotetype(Gy);
    },
    loadParams() {
      const t = this.appliedFilters.codes || [];
      return {
        code_ids: ba(t, "included"),
        code_excluded_ids: ba(t, "excluded"),
        code_ignored_ids: ba(t, "ignored")
      };
    }
  },
  created() {
    var n, r, s, i, o;
    const t = (r = (n = this.getProfileFilters) == null ? void 0 : n.asoi_embargo_notes) == null ? void 0 : r.codes, e = [];
    t && ((s = t == null ? void 0 : t.ids) == null || s.forEach(
      (a) => e.push({ id: a, state: "included" })
    ), (i = t == null ? void 0 : t.excludedIds) == null || i.forEach(
      (a) => e.push({ id: a, state: "excluded" })
    ), (o = t == null ? void 0 : t.ignoredIds) == null || o.forEach(
      (a) => e.push({ id: a, state: "ignored" })
    )), this.asoiNotesSetFilters({
      noteType: Gy,
      value: { codes: e }
    });
  },
  methods: {
    ...ge({
      resetInitialLoaded(t) {
        t("asoiNotesEmbargoSetInitialLoaded", !1);
      },
      asoiNotesSetFilters: "asoiNotesSetFilters"
    }),
    ...ge("userProfile", ["setProfileFilters"]),
    ...ge(["processAsoiNoteMessage", "setProfileFilters"]),
    getIsFocused() {
      return this.isFocused;
    },
    remove() {
      this.$store.dispatch("panels/removePanel", { panelId: this.panel.id });
    },
    handleCodesFilterUpdate(t) {
      const e = { ids: [], excludedIds: [], ignoredIds: [] }, n = t.reduce((r, s) => (s.state === "included" ? r.ids.push(s.id) : s.state === "excluded" ? r.excludedIds.push(s.id) : s.state === "ignored" && r.ignoredIds.push(s.id), r), e);
      this.setProfileFilters({
        type: "asoi_embargo_notes",
        value: {
          codes: n
        }
      }), this.asoiNotesSetFilters({
        noteType: Gy,
        value: { codes: Or(t) }
      });
    }
  }
};
var YPe = function() {
  var e = this, n = e._self._c;
  return n("Panel", { attrs: { title: "Эмбарго: Заметки АСОИ", panel: e.panel, isFocused: e.isFocused, userHasPermissions: e.userHasPermissions }, scopedSlots: e._u([{ key: "appBarActions", fn: function() {
    return [n("PbButton", { staticClass: "appbar-button close-button draggable-ignore", attrs: { round: "", "data-test-selector": "panel-button-close" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.remove.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)];
  }, proxy: !0 }, e.userHasPermissions ? { key: "appbar-extension", fn: function() {
    return [n("div", { class: [e.$style.appBar, "panel-toolbar-extension"], staticStyle: { overflow: "visible" }, attrs: { "data-test-selector": "news-published-list" } }, [n("NewsPublishedCodesFilter", { class: e.$style.codesFilter, attrs: { placement: "bottom-start", values: e.appliedFilters.codes || [] }, on: { update: e.handleCodesFilterUpdate } })], 1)];
  }, proxy: !0 } : null, { key: "content", fn: function() {
    return [n("AsoiNotesEmbargoList", { attrs: { panelId: e.panel.id, color: e.panel.settings.color, dateMode: e.panel.settings.dateMode, isCompact: e.panel.settings.compact, isFocused: e.getIsFocused, loadParams: e.loadParams } })];
  }, proxy: !0 }], null, !0) });
}, ZPe = [];
const Rk = {
  $style: UPe
};
function XPe(t) {
  for (var e in Rk)
    this[e] = Rk[e];
}
var KPe = /* @__PURE__ */ B(
  GPe,
  YPe,
  ZPe,
  !1,
  XPe,
  null
);
const JPe = KPe.exports, Wm = {
  FLOWS: "FLOWS",
  LEADS: "LEADS",
  USER_NEWSBREAKS: "USER_NEWSBREAKS",
  NEWS: "NEWS",
  SPECIFIC_NEWS: "SPECIFIC_NEWS",
  USER_NEWS: "USER_NEWS",
  USER_ASOI_NOTES: "USER_ASOI_NOTES",
  ASOI_NOTES: "ASOI_NOTES",
  // ---------> эмбарго заметки
  USER_PROFILE: "USER_PROFILE",
  FLOW_LEADS: "FLOW_LEADS",
  SOURCE_LEADS: "SOURCE_LEADS",
  USER_NOTIFICATIONS: "USER_NOTIFICATIONS"
};
class qPe {
  constructor() {
    this._channel = new BroadcastChannel("ps-legacy-bridge");
  }
  addOnMessage(e) {
    this._channel.addEventListener("message", async (n) => {
      var r;
      if (n.data.source === "ps-ui") {
        if (await e(n) === !1)
          return;
        (r = n == null ? void 0 : n.data) != null && r.uid && this.sendMessage({
          status: "ok",
          uid: n.data.uid
        });
      }
    });
  }
  sendMessage(e) {
    this._channel.postMessage({
      source: "publishing-ui",
      contextId: window.contextId,
      ...e
    });
  }
  /**
   * Send message to ps-ui Sentry
   * @param message String
   * @param type 'message' | 'error'
   * @param extra any - used for error only
   */
  sentrySend(e, n, r) {
    this.sendMessage({
      action: "sentry",
      content: {
        message: e,
        type: n,
        extra: r
      }
    });
  }
}
const Aa = new qPe();
function Kv() {
  function t(r) {
    Aa.sendMessage({
      action: "showShareModal",
      payload: r
    });
  }
  function e(r) {
    Aa.sendMessage({
      action: "gatewaySubscribe",
      payload: r
    });
  }
  function n(r) {
    Aa.sendMessage({
      action: "gatewayUnsubscribe",
      payload: r
    });
  }
  return {
    showShareModal: t,
    gatewaySubscribe: e,
    gatewayUnsubscribe: n
  };
}
const QPe = "_root_12k0g_1", eke = "_root_compact_12k0g_10", tke = {
  root: QPe,
  root_compact: eke
}, nke = {
  name: "PbEntryStatus",
  props: {
    attrs: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    compact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "rgba(255, 255, 255, .8)"
    }
  }
};
var rke = function() {
  var e = this, n = e._self._c;
  return n("span", e._b({ class: { [e.$style.root]: !0, [e.$style.root_compact]: e.compact }, attrs: { "data-test-selector": "entry-status", "data-test-attrs": `status__${e.isActive ? "unread" : "read"}` } }, "span", e.attrs, !1), [e.isActive ? n("i", { style: { color: e.color } }, [e._v(" ● ")]) : e._e()]);
}, ske = [];
const Lk = {
  $style: tke
};
function ike(t) {
  for (var e in Lk)
    this[e] = Lk[e];
}
var oke = /* @__PURE__ */ B(
  nke,
  rke,
  ske,
  !1,
  ike,
  null
);
const ake = oke.exports, lke = "_root_paoz4_1", cke = "_root_compact_paoz4_8", uke = {
  root: lke,
  root_compact: cke
}, dke = {
  name: "PbEntryOrigin",
  props: {
    attrs: {
      type: Object,
      default: () => ({})
    },
    compact: {
      type: Boolean,
      default: !1
    }
  }
};
var fke = function() {
  var e = this, n = e._self._c;
  return n("span", e._b({ class: { [e.$style.root]: !0, [e.$style.root_compact]: e.compact }, attrs: { "data-test-selector": "entry-origin" } }, "span", e.attrs, !1), [e._t("default")], 2);
}, pke = [];
const Fk = {
  $style: uke
};
function hke(t) {
  for (var e in Fk)
    this[e] = Fk[e];
}
var mke = /* @__PURE__ */ B(
  dke,
  fke,
  pke,
  !1,
  hke,
  null
);
const vke = mke.exports, gke = "_root_krzur_1", yke = "_root_compact_krzur_8", bke = "_header_krzur_14", _ke = "_text_krzur_20", wke = "_date_krzur_27", Ske = "_root_read_krzur_31", Ike = "_root_selected_krzur_31", Eke = "_deliveryStatus_krzur_45", xke = "_origin_krzur_61", Cke = "_forwardedList_krzur_84", Tke = "_footer_krzur_91", Pke = "_miniButton_krzur_104", kke = {
  root: gke,
  root_compact: yke,
  header: bke,
  text: _ke,
  date: wke,
  root_read: Ske,
  root_selected: Ike,
  deliveryStatus: Eke,
  origin: xke,
  forwardedList: Cke,
  footer: Tke,
  miniButton: Pke
};
function Yy(t, e) {
  return t && t.newsbreaks && t.newsbreaks.length ? t.newsbreaks.reduce((n, r) => (n = e(r), n), !1) : !1;
}
const Nke = {
  name: "LeadEntry",
  components: {
    DateWidget: Hr,
    MainActionButton: fn,
    PbEntryStatus: ake,
    PbEntryOrigin: vke,
    PbEntryDate: nl
  },
  props: {
    id: [Number, String],
    color: String,
    isSelected: Boolean,
    compact: Boolean,
    dateMode: Number
  },
  computed: {
    ...pe("newsbreaks", [
      "getNewsbreakMetaByNb",
      "isNewsbreakForwardedByNb",
      "isNewsbreakPickedByNb",
      "isNewsbreakRejectedByNb"
    ]),
    ...pe("leads", ["getLeadById"]),
    entry() {
      return this.getLeadById(this.id);
    },
    url() {
      return this.entry && this.entry.url ? this.entry.url : this.entry.source ? this.entry.source.url : null;
    },
    name() {
      return this.entry && this.entry.source ? this.entry.source.name : null;
    },
    text() {
      var t;
      return (t = this.entry) == null ? void 0 : t.clearedText;
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_selected]: this.isSelected,
        [this.$style.root_read]: this.entry && this.entry.is_read,
        [this.$style.root_compact]: this.compact
      };
    },
    testClass() {
      let t = [];
      return this.isSelected && t.push("selected"), this.entry && this.entry.is_read && t.push("read"), this.compact && t.push("compact"), t;
    },
    isForwarded() {
      return Yy(
        this.entry,
        this.isNewsbreakForwardedByNb
      );
    },
    isPicked() {
      return Yy(this.entry, this.isNewsbreakPickedByNb);
    },
    isRejected() {
      return Yy(
        this.entry,
        this.isNewsbreakRejectedByNb
      );
    }
  }
};
var $ke = function() {
  var e = this, n = e._self._c;
  return e.entry && e.compact ? n("div", { class: e.rootClass, attrs: { "data-test-selector": "lead-entry-compact", "data-test-id": e.id, "data-test-attrs": `entry-id__${e.id} ${e.testClass.join(" ")}` } }, [n("div", { class: e.$style.header }, [n("PbEntryStatus", { attrs: { attrs: {
    "data-test-selector": "lead-entry-compact-status"
  }, isActive: e.entry && !e.entry.is_read, color: e.color, compact: "" } }), n("PbEntryOrigin", { attrs: { attrs: {
    "data-test-selector": "lead-entry-compact-origin"
  }, compact: "" } }, [n("a", { attrs: { href: e.url, title: e.name, target: "_blank" } }, [e._v(e._s(e.name))])])], 1), n("div", { class: e.$style.text, attrs: { "data-test-selector": "lead-entry-compact-text" }, domProps: { innerHTML: e._s(e.text) } }), n("PbEntryDate", { class: e.$style.date, attrs: { compact: "" } }, [n("DateWidget", { attrs: { date: e.entry.created_at, mode: e.dateMode, "data-test-selector": "lead-entry-compact-date" }, on: { dateModeChanged: function(r) {
    return e.$emit("dateModeChanged", r);
  } } })], 1)], 1) : e.entry ? n("div", { class: e.rootClass, attrs: { "data-test-selector": "lead-entry-full", "data-test-id": e.id, "data-test-attrs": `entry-id__${e.id} ${e.testClass.join(" ")}` } }, [n("div", { class: e.$style.header }, [n("PbEntryStatus", { attrs: { attrs: {
    "data-test-selector": "lead-entry-full-status"
  }, isActive: e.entry && !e.entry.is_read, color: e.color } }), n("PbEntryOrigin", { class: e.$style.origin, attrs: { attrs: {
    "data-test-selector": "lead-entry-full-origin"
  } } }, [n("a", { attrs: { href: e.url, title: e.name, target: "_blank" } }, [e._v(" " + e._s(e.name) + " ")])]), n("PbEntryDate", { class: e.$style.date }, [n("DateWidget", { attrs: { date: e.entry.created_at, mode: e.dateMode, "data-test-selector": "lead-entry-full-date" }, on: { dateModeChanged: function(r) {
    return e.$emit("dateModeChanged", r);
  } } })], 1)], 1), n("div", { class: e.$style.body }, [n("div", { class: e.$style.text, attrs: { "data-test-selector": "lead-entry-full-text" }, domProps: { innerHTML: e._s(e.text) } }), n("div", { class: e.$style.deliveryStatus, attrs: { "data-test-selector": "lead-entry-full-delivery-status" } }, [e.isPicked && e.isForwarded ? n("span", { attrs: { "data-test-selector": "lead-entry-full-delivery-status-picked" } }, [e._v(" Передано и взято в работу ")]) : e.isPicked ? n("span", { attrs: { "data-test-selector": "lead-entry-full-delivery-status-picked" } }, [e._v(" Взято в работу ")]) : e.isForwarded || e.isRejected ? n("div", { class: e.$style.forwardedList, attrs: { "data-test-selector": "lead-entry-full-delivery-status-forwarded" } }, [n("span", [e._v("Передано")])]) : n("span", { attrs: { "data-test-selector": "lead-entry-full-delivery-status-empty" } }, [e._v(" Ещё не передано ")])])]), n("div", { directives: [{ name: "show", rawName: "v-show", value: e.isSelected, expression: "isSelected" }], class: e.$style.footer }, [n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["3.1"], expression: "['3.1']", arg: "all" }], staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-forward", "data-test-selector": "lead-entry-full-button-forward" }, nativeOn: { click: function(r) {
    return r.stopPropagation(), e.$emit("forward", e.entry);
  } } }, [e._v(" Отправить в работу ")]), n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["3.2"], expression: "['3.2']", arg: "all" }], staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "lead-entry-full-button-add" }, nativeOn: { click: function(r) {
    return r.stopPropagation(), e.$emit("pick", e.entry);
  } } }, [e._v(" Взять в работу ")]), n("MainActionButton", { class: [e.$style.miniButton, "show-more", "pb-action-button-old"], attrs: { iconName: "button-icon-show-more", title: "Открыть в отдельной панели", "data-test-selector": "lead-entry-full-button-show-more" }, nativeOn: { click: function(r) {
    return r.stopPropagation(), e.$emit("openPanel", e.entry);
  } } })], 1)]) : e._e();
}, Dke = [];
const Bk = {
  $style: kke
};
function Ake(t) {
  for (var e in Bk)
    this[e] = Bk[e];
}
var Oke = /* @__PURE__ */ B(
  Nke,
  $ke,
  Dke,
  !1,
  Ake,
  null
);
const Mke = Oke.exports;
var EL = { exports: {} }, xL = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, CL = { exports: {} }, Rke = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, Lke = Rke, Fke = Array.prototype.concat, Bke = Array.prototype.slice, jk = CL.exports = function(e) {
  for (var n = [], r = 0, s = e.length; r < s; r++) {
    var i = e[r];
    Lke(i) ? n = Fke.call(n, Bke.call(i)) : n.push(i);
  }
  return n;
};
jk.wrap = function(t) {
  return function() {
    return t(jk(arguments));
  };
};
var jke = CL.exports, Ud = xL, zf = jke, TL = Object.hasOwnProperty, PL = /* @__PURE__ */ Object.create(null);
for (var Zy in Ud)
  TL.call(Ud, Zy) && (PL[Ud[Zy]] = Zy);
var ti = EL.exports = {
  to: {},
  get: {}
};
ti.get = function(t) {
  var e = t.substring(0, 3).toLowerCase(), n, r;
  switch (e) {
    case "hsl":
      n = ti.get.hsl(t), r = "hsl";
      break;
    case "hwb":
      n = ti.get.hwb(t), r = "hwb";
      break;
    default:
      n = ti.get.rgb(t), r = "rgb";
      break;
  }
  return n ? { model: r, value: n } : null;
};
ti.get.rgb = function(t) {
  if (!t)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, n = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, r = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, s = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, i = /^(\w+)$/, o = [0, 0, 0, 1], a, l, c;
  if (a = t.match(n)) {
    for (c = a[2], a = a[1], l = 0; l < 3; l++) {
      var u = l * 2;
      o[l] = parseInt(a.slice(u, u + 2), 16);
    }
    c && (o[3] = parseInt(c, 16) / 255);
  } else if (a = t.match(e)) {
    for (a = a[1], c = a[3], l = 0; l < 3; l++)
      o[l] = parseInt(a[l] + a[l], 16);
    c && (o[3] = parseInt(c + c, 16) / 255);
  } else if (a = t.match(r)) {
    for (l = 0; l < 3; l++)
      o[l] = parseInt(a[l + 1], 0);
    a[4] && (a[5] ? o[3] = parseFloat(a[4]) * 0.01 : o[3] = parseFloat(a[4]));
  } else if (a = t.match(s)) {
    for (l = 0; l < 3; l++)
      o[l] = Math.round(parseFloat(a[l + 1]) * 2.55);
    a[4] && (a[5] ? o[3] = parseFloat(a[4]) * 0.01 : o[3] = parseFloat(a[4]));
  } else return (a = t.match(i)) ? a[1] === "transparent" ? [0, 0, 0, 0] : TL.call(Ud, a[1]) ? (o = Ud[a[1]], o[3] = 1, o) : null : null;
  for (l = 0; l < 3; l++)
    o[l] = Oa(o[l], 0, 255);
  return o[3] = Oa(o[3], 0, 1), o;
};
ti.get.hsl = function(t) {
  if (!t)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, n = t.match(e);
  if (n) {
    var r = parseFloat(n[4]), s = (parseFloat(n[1]) % 360 + 360) % 360, i = Oa(parseFloat(n[2]), 0, 100), o = Oa(parseFloat(n[3]), 0, 100), a = Oa(isNaN(r) ? 1 : r, 0, 1);
    return [s, i, o, a];
  }
  return null;
};
ti.get.hwb = function(t) {
  if (!t)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, n = t.match(e);
  if (n) {
    var r = parseFloat(n[4]), s = (parseFloat(n[1]) % 360 + 360) % 360, i = Oa(parseFloat(n[2]), 0, 100), o = Oa(parseFloat(n[3]), 0, 100), a = Oa(isNaN(r) ? 1 : r, 0, 1);
    return [s, i, o, a];
  }
  return null;
};
ti.to.hex = function() {
  var t = zf(arguments);
  return "#" + Np(t[0]) + Np(t[1]) + Np(t[2]) + (t[3] < 1 ? Np(Math.round(t[3] * 255)) : "");
};
ti.to.rgb = function() {
  var t = zf(arguments);
  return t.length < 4 || t[3] === 1 ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
};
ti.to.rgb.percent = function() {
  var t = zf(arguments), e = Math.round(t[0] / 255 * 100), n = Math.round(t[1] / 255 * 100), r = Math.round(t[2] / 255 * 100);
  return t.length < 4 || t[3] === 1 ? "rgb(" + e + "%, " + n + "%, " + r + "%)" : "rgba(" + e + "%, " + n + "%, " + r + "%, " + t[3] + ")";
};
ti.to.hsl = function() {
  var t = zf(arguments);
  return t.length < 4 || t[3] === 1 ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
};
ti.to.hwb = function() {
  var t = zf(arguments), e = "";
  return t.length >= 4 && t[3] !== 1 && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
};
ti.to.keyword = function(t) {
  return PL[t.slice(0, 3)];
};
function Oa(t, e, n) {
  return Math.min(Math.max(e, t), n);
}
function Np(t) {
  var e = Math.round(t).toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
var Wke = EL.exports, kL = { exports: {} }, Wl = xL, NL = {};
for (var Xy in Wl)
  Wl.hasOwnProperty(Xy) && (NL[Wl[Xy]] = Xy);
var Je = kL.exports = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
for (var Ws in Je)
  if (Je.hasOwnProperty(Ws)) {
    if (!("channels" in Je[Ws]))
      throw new Error("missing channels property: " + Ws);
    if (!("labels" in Je[Ws]))
      throw new Error("missing channel labels property: " + Ws);
    if (Je[Ws].labels.length !== Je[Ws].channels)
      throw new Error("channel and label counts mismatch: " + Ws);
    var Hke = Je[Ws].channels, Vke = Je[Ws].labels;
    delete Je[Ws].channels, delete Je[Ws].labels, Object.defineProperty(Je[Ws], "channels", { value: Hke }), Object.defineProperty(Je[Ws], "labels", { value: Vke });
  }
Je.rgb.hsl = function(t) {
  var e = t[0] / 255, n = t[1] / 255, r = t[2] / 255, s = Math.min(e, n, r), i = Math.max(e, n, r), o = i - s, a, l, c;
  return i === s ? a = 0 : e === i ? a = (n - r) / o : n === i ? a = 2 + (r - e) / o : r === i && (a = 4 + (e - n) / o), a = Math.min(a * 60, 360), a < 0 && (a += 360), c = (s + i) / 2, i === s ? l = 0 : c <= 0.5 ? l = o / (i + s) : l = o / (2 - i - s), [a, l * 100, c * 100];
};
Je.rgb.hsv = function(t) {
  var e, n, r, s, i, o = t[0] / 255, a = t[1] / 255, l = t[2] / 255, c = Math.max(o, a, l), u = c - Math.min(o, a, l), d = function(f) {
    return (c - f) / 6 / u + 1 / 2;
  };
  return u === 0 ? s = i = 0 : (i = u / c, e = d(o), n = d(a), r = d(l), o === c ? s = r - n : a === c ? s = 1 / 3 + e - r : l === c && (s = 2 / 3 + n - e), s < 0 ? s += 1 : s > 1 && (s -= 1)), [
    s * 360,
    i * 100,
    c * 100
  ];
};
Je.rgb.hwb = function(t) {
  var e = t[0], n = t[1], r = t[2], s = Je.rgb.hsl(t)[0], i = 1 / 255 * Math.min(e, Math.min(n, r));
  return r = 1 - 1 / 255 * Math.max(e, Math.max(n, r)), [s, i * 100, r * 100];
};
Je.rgb.cmyk = function(t) {
  var e = t[0] / 255, n = t[1] / 255, r = t[2] / 255, s, i, o, a;
  return a = Math.min(1 - e, 1 - n, 1 - r), s = (1 - e - a) / (1 - a) || 0, i = (1 - n - a) / (1 - a) || 0, o = (1 - r - a) / (1 - a) || 0, [s * 100, i * 100, o * 100, a * 100];
};
function zke(t, e) {
  return Math.pow(t[0] - e[0], 2) + Math.pow(t[1] - e[1], 2) + Math.pow(t[2] - e[2], 2);
}
Je.rgb.keyword = function(t) {
  var e = NL[t];
  if (e)
    return e;
  var n = 1 / 0, r;
  for (var s in Wl)
    if (Wl.hasOwnProperty(s)) {
      var i = Wl[s], o = zke(t, i);
      o < n && (n = o, r = s);
    }
  return r;
};
Je.keyword.rgb = function(t) {
  return Wl[t];
};
Je.rgb.xyz = function(t) {
  var e = t[0] / 255, n = t[1] / 255, r = t[2] / 255;
  e = e > 0.04045 ? Math.pow((e + 0.055) / 1.055, 2.4) : e / 12.92, n = n > 0.04045 ? Math.pow((n + 0.055) / 1.055, 2.4) : n / 12.92, r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  var s = e * 0.4124 + n * 0.3576 + r * 0.1805, i = e * 0.2126 + n * 0.7152 + r * 0.0722, o = e * 0.0193 + n * 0.1192 + r * 0.9505;
  return [s * 100, i * 100, o * 100];
};
Je.rgb.lab = function(t) {
  var e = Je.rgb.xyz(t), n = e[0], r = e[1], s = e[2], i, o, a;
  return n /= 95.047, r /= 100, s /= 108.883, n = n > 8856e-6 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, r = r > 8856e-6 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116, s = s > 8856e-6 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116, i = 116 * r - 16, o = 500 * (n - r), a = 200 * (r - s), [i, o, a];
};
Je.hsl.rgb = function(t) {
  var e = t[0] / 360, n = t[1] / 100, r = t[2] / 100, s, i, o, a, l;
  if (n === 0)
    return l = r * 255, [l, l, l];
  r < 0.5 ? i = r * (1 + n) : i = r + n - r * n, s = 2 * r - i, a = [0, 0, 0];
  for (var c = 0; c < 3; c++)
    o = e + 1 / 3 * -(c - 1), o < 0 && o++, o > 1 && o--, 6 * o < 1 ? l = s + (i - s) * 6 * o : 2 * o < 1 ? l = i : 3 * o < 2 ? l = s + (i - s) * (2 / 3 - o) * 6 : l = s, a[c] = l * 255;
  return a;
};
Je.hsl.hsv = function(t) {
  var e = t[0], n = t[1] / 100, r = t[2] / 100, s = n, i = Math.max(r, 0.01), o, a;
  return r *= 2, n *= r <= 1 ? r : 2 - r, s *= i <= 1 ? i : 2 - i, a = (r + n) / 2, o = r === 0 ? 2 * s / (i + s) : 2 * n / (r + n), [e, o * 100, a * 100];
};
Je.hsv.rgb = function(t) {
  var e = t[0] / 60, n = t[1] / 100, r = t[2] / 100, s = Math.floor(e) % 6, i = e - Math.floor(e), o = 255 * r * (1 - n), a = 255 * r * (1 - n * i), l = 255 * r * (1 - n * (1 - i));
  switch (r *= 255, s) {
    case 0:
      return [r, l, o];
    case 1:
      return [a, r, o];
    case 2:
      return [o, r, l];
    case 3:
      return [o, a, r];
    case 4:
      return [l, o, r];
    case 5:
      return [r, o, a];
  }
};
Je.hsv.hsl = function(t) {
  var e = t[0], n = t[1] / 100, r = t[2] / 100, s = Math.max(r, 0.01), i, o, a;
  return a = (2 - n) * r, i = (2 - n) * s, o = n * s, o /= i <= 1 ? i : 2 - i, o = o || 0, a /= 2, [e, o * 100, a * 100];
};
Je.hwb.rgb = function(t) {
  var e = t[0] / 360, n = t[1] / 100, r = t[2] / 100, s = n + r, i, o, a, l;
  s > 1 && (n /= s, r /= s), i = Math.floor(6 * e), o = 1 - r, a = 6 * e - i, i & 1 && (a = 1 - a), l = n + a * (o - n);
  var c, u, d;
  switch (i) {
    default:
    case 6:
    case 0:
      c = o, u = l, d = n;
      break;
    case 1:
      c = l, u = o, d = n;
      break;
    case 2:
      c = n, u = o, d = l;
      break;
    case 3:
      c = n, u = l, d = o;
      break;
    case 4:
      c = l, u = n, d = o;
      break;
    case 5:
      c = o, u = n, d = l;
      break;
  }
  return [c * 255, u * 255, d * 255];
};
Je.cmyk.rgb = function(t) {
  var e = t[0] / 100, n = t[1] / 100, r = t[2] / 100, s = t[3] / 100, i, o, a;
  return i = 1 - Math.min(1, e * (1 - s) + s), o = 1 - Math.min(1, n * (1 - s) + s), a = 1 - Math.min(1, r * (1 - s) + s), [i * 255, o * 255, a * 255];
};
Je.xyz.rgb = function(t) {
  var e = t[0] / 100, n = t[1] / 100, r = t[2] / 100, s, i, o;
  return s = e * 3.2406 + n * -1.5372 + r * -0.4986, i = e * -0.9689 + n * 1.8758 + r * 0.0415, o = e * 0.0557 + n * -0.204 + r * 1.057, s = s > 31308e-7 ? 1.055 * Math.pow(s, 1 / 2.4) - 0.055 : s * 12.92, i = i > 31308e-7 ? 1.055 * Math.pow(i, 1 / 2.4) - 0.055 : i * 12.92, o = o > 31308e-7 ? 1.055 * Math.pow(o, 1 / 2.4) - 0.055 : o * 12.92, s = Math.min(Math.max(0, s), 1), i = Math.min(Math.max(0, i), 1), o = Math.min(Math.max(0, o), 1), [s * 255, i * 255, o * 255];
};
Je.xyz.lab = function(t) {
  var e = t[0], n = t[1], r = t[2], s, i, o;
  return e /= 95.047, n /= 100, r /= 108.883, e = e > 8856e-6 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, n = n > 8856e-6 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, r = r > 8856e-6 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116, s = 116 * n - 16, i = 500 * (e - n), o = 200 * (n - r), [s, i, o];
};
Je.lab.xyz = function(t) {
  var e = t[0], n = t[1], r = t[2], s, i, o;
  i = (e + 16) / 116, s = n / 500 + i, o = i - r / 200;
  var a = Math.pow(i, 3), l = Math.pow(s, 3), c = Math.pow(o, 3);
  return i = a > 8856e-6 ? a : (i - 16 / 116) / 7.787, s = l > 8856e-6 ? l : (s - 16 / 116) / 7.787, o = c > 8856e-6 ? c : (o - 16 / 116) / 7.787, s *= 95.047, i *= 100, o *= 108.883, [s, i, o];
};
Je.lab.lch = function(t) {
  var e = t[0], n = t[1], r = t[2], s, i, o;
  return s = Math.atan2(r, n), i = s * 360 / 2 / Math.PI, i < 0 && (i += 360), o = Math.sqrt(n * n + r * r), [e, o, i];
};
Je.lch.lab = function(t) {
  var e = t[0], n = t[1], r = t[2], s, i, o;
  return o = r / 360 * 2 * Math.PI, s = n * Math.cos(o), i = n * Math.sin(o), [e, s, i];
};
Je.rgb.ansi16 = function(t) {
  var e = t[0], n = t[1], r = t[2], s = 1 in arguments ? arguments[1] : Je.rgb.hsv(t)[2];
  if (s = Math.round(s / 50), s === 0)
    return 30;
  var i = 30 + (Math.round(r / 255) << 2 | Math.round(n / 255) << 1 | Math.round(e / 255));
  return s === 2 && (i += 60), i;
};
Je.hsv.ansi16 = function(t) {
  return Je.rgb.ansi16(Je.hsv.rgb(t), t[2]);
};
Je.rgb.ansi256 = function(t) {
  var e = t[0], n = t[1], r = t[2];
  if (e === n && n === r)
    return e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232;
  var s = 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
  return s;
};
Je.ansi16.rgb = function(t) {
  var e = t % 10;
  if (e === 0 || e === 7)
    return t > 50 && (e += 3.5), e = e / 10.5 * 255, [e, e, e];
  var n = (~~(t > 50) + 1) * 0.5, r = (e & 1) * n * 255, s = (e >> 1 & 1) * n * 255, i = (e >> 2 & 1) * n * 255;
  return [r, s, i];
};
Je.ansi256.rgb = function(t) {
  if (t >= 232) {
    var e = (t - 232) * 10 + 8;
    return [e, e, e];
  }
  t -= 16;
  var n, r = Math.floor(t / 36) / 5 * 255, s = Math.floor((n = t % 36) / 6) / 5 * 255, i = n % 6 / 5 * 255;
  return [r, s, i];
};
Je.rgb.hex = function(t) {
  var e = ((Math.round(t[0]) & 255) << 16) + ((Math.round(t[1]) & 255) << 8) + (Math.round(t[2]) & 255), n = e.toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
Je.hex.rgb = function(t) {
  var e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!e)
    return [0, 0, 0];
  var n = e[0];
  e[0].length === 3 && (n = n.split("").map(function(a) {
    return a + a;
  }).join(""));
  var r = parseInt(n, 16), s = r >> 16 & 255, i = r >> 8 & 255, o = r & 255;
  return [s, i, o];
};
Je.rgb.hcg = function(t) {
  var e = t[0] / 255, n = t[1] / 255, r = t[2] / 255, s = Math.max(Math.max(e, n), r), i = Math.min(Math.min(e, n), r), o = s - i, a, l;
  return o < 1 ? a = i / (1 - o) : a = 0, o <= 0 ? l = 0 : s === e ? l = (n - r) / o % 6 : s === n ? l = 2 + (r - e) / o : l = 4 + (e - n) / o + 4, l /= 6, l %= 1, [l * 360, o * 100, a * 100];
};
Je.hsl.hcg = function(t) {
  var e = t[1] / 100, n = t[2] / 100, r = 1, s = 0;
  return n < 0.5 ? r = 2 * e * n : r = 2 * e * (1 - n), r < 1 && (s = (n - 0.5 * r) / (1 - r)), [t[0], r * 100, s * 100];
};
Je.hsv.hcg = function(t) {
  var e = t[1] / 100, n = t[2] / 100, r = e * n, s = 0;
  return r < 1 && (s = (n - r) / (1 - r)), [t[0], r * 100, s * 100];
};
Je.hcg.rgb = function(t) {
  var e = t[0] / 360, n = t[1] / 100, r = t[2] / 100;
  if (n === 0)
    return [r * 255, r * 255, r * 255];
  var s = [0, 0, 0], i = e % 1 * 6, o = i % 1, a = 1 - o, l = 0;
  switch (Math.floor(i)) {
    case 0:
      s[0] = 1, s[1] = o, s[2] = 0;
      break;
    case 1:
      s[0] = a, s[1] = 1, s[2] = 0;
      break;
    case 2:
      s[0] = 0, s[1] = 1, s[2] = o;
      break;
    case 3:
      s[0] = 0, s[1] = a, s[2] = 1;
      break;
    case 4:
      s[0] = o, s[1] = 0, s[2] = 1;
      break;
    default:
      s[0] = 1, s[1] = 0, s[2] = a;
  }
  return l = (1 - n) * r, [
    (n * s[0] + l) * 255,
    (n * s[1] + l) * 255,
    (n * s[2] + l) * 255
  ];
};
Je.hcg.hsv = function(t) {
  var e = t[1] / 100, n = t[2] / 100, r = e + n * (1 - e), s = 0;
  return r > 0 && (s = e / r), [t[0], s * 100, r * 100];
};
Je.hcg.hsl = function(t) {
  var e = t[1] / 100, n = t[2] / 100, r = n * (1 - e) + 0.5 * e, s = 0;
  return r > 0 && r < 0.5 ? s = e / (2 * r) : r >= 0.5 && r < 1 && (s = e / (2 * (1 - r))), [t[0], s * 100, r * 100];
};
Je.hcg.hwb = function(t) {
  var e = t[1] / 100, n = t[2] / 100, r = e + n * (1 - e);
  return [t[0], (r - e) * 100, (1 - r) * 100];
};
Je.hwb.hcg = function(t) {
  var e = t[1] / 100, n = t[2] / 100, r = 1 - n, s = r - e, i = 0;
  return s < 1 && (i = (r - s) / (1 - s)), [t[0], s * 100, i * 100];
};
Je.apple.rgb = function(t) {
  return [t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255];
};
Je.rgb.apple = function(t) {
  return [t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535];
};
Je.gray.rgb = function(t) {
  return [t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255];
};
Je.gray.hsl = Je.gray.hsv = function(t) {
  return [0, 0, t[0]];
};
Je.gray.hwb = function(t) {
  return [0, 100, t[0]];
};
Je.gray.cmyk = function(t) {
  return [0, 0, 0, t[0]];
};
Je.gray.lab = function(t) {
  return [t[0], 0, 0];
};
Je.gray.hex = function(t) {
  var e = Math.round(t[0] / 100 * 255) & 255, n = (e << 16) + (e << 8) + e, r = n.toString(16).toUpperCase();
  return "000000".substring(r.length) + r;
};
Je.rgb.gray = function(t) {
  var e = (t[0] + t[1] + t[2]) / 3;
  return [e / 255 * 100];
};
var $L = kL.exports, Hm = $L;
function Uke() {
  for (var t = {}, e = Object.keys(Hm), n = e.length, r = 0; r < n; r++)
    t[e[r]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return t;
}
function Gke(t) {
  var e = Uke(), n = [t];
  for (e[t].distance = 0; n.length; )
    for (var r = n.pop(), s = Object.keys(Hm[r]), i = s.length, o = 0; o < i; o++) {
      var a = s[o], l = e[a];
      l.distance === -1 && (l.distance = e[r].distance + 1, l.parent = r, n.unshift(a));
    }
  return e;
}
function Yke(t, e) {
  return function(n) {
    return e(t(n));
  };
}
function Zke(t, e) {
  for (var n = [e[t].parent, t], r = Hm[e[t].parent][t], s = e[t].parent; e[s].parent; )
    n.unshift(e[s].parent), r = Yke(Hm[e[s].parent][s], r), s = e[s].parent;
  return r.conversion = n, r;
}
var Xke = function(t) {
  for (var e = Gke(t), n = {}, r = Object.keys(e), s = r.length, i = 0; i < s; i++) {
    var o = r[i], a = e[o];
    a.parent !== null && (n[o] = Zke(o, e));
  }
  return n;
}, K0 = $L, Kke = Xke, Rc = {}, Jke = Object.keys(K0);
function qke(t) {
  var e = function(n) {
    return n == null ? n : (arguments.length > 1 && (n = Array.prototype.slice.call(arguments)), t(n));
  };
  return "conversion" in t && (e.conversion = t.conversion), e;
}
function Qke(t) {
  var e = function(n) {
    if (n == null)
      return n;
    arguments.length > 1 && (n = Array.prototype.slice.call(arguments));
    var r = t(n);
    if (typeof r == "object")
      for (var s = r.length, i = 0; i < s; i++)
        r[i] = Math.round(r[i]);
    return r;
  };
  return "conversion" in t && (e.conversion = t.conversion), e;
}
Jke.forEach(function(t) {
  Rc[t] = {}, Object.defineProperty(Rc[t], "channels", { value: K0[t].channels }), Object.defineProperty(Rc[t], "labels", { value: K0[t].labels });
  var e = Kke(t), n = Object.keys(e);
  n.forEach(function(r) {
    var s = e[r];
    Rc[t][r] = Qke(s), Rc[t][r].raw = qke(s);
  });
});
var eNe = Rc, kd = Wke, ei = eNe, N2 = [].slice, DL = [
  // to be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // gray conflicts with some method names, and has its own method defined.
  "gray",
  // shouldn't really be in color-convert either...
  "hex"
], J0 = {};
Object.keys(ei).forEach(function(t) {
  J0[N2.call(ei[t].labels).sort().join("")] = t;
});
var Vm = {};
function Xr(t, e) {
  if (!(this instanceof Xr))
    return new Xr(t, e);
  if (e && e in DL && (e = null), e && !(e in ei))
    throw new Error("Unknown model: " + e);
  var n, r;
  if (t == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (t instanceof Xr)
    this.model = t.model, this.color = t.color.slice(), this.valpha = t.valpha;
  else if (typeof t == "string") {
    var s = kd.get(t);
    if (s === null)
      throw new Error("Unable to parse color from string: " + t);
    this.model = s.model, r = ei[this.model].channels, this.color = s.value.slice(0, r), this.valpha = typeof s.value[r] == "number" ? s.value[r] : 1;
  } else if (t.length) {
    this.model = e || "rgb", r = ei[this.model].channels;
    var i = N2.call(t, 0, r);
    this.color = q0(i, r), this.valpha = typeof t[r] == "number" ? t[r] : 1;
  } else if (typeof t == "number")
    t &= 16777215, this.model = "rgb", this.color = [
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    var o = Object.keys(t);
    "alpha" in t && (o.splice(o.indexOf("alpha"), 1), this.valpha = typeof t.alpha == "number" ? t.alpha : 0);
    var a = o.sort().join("");
    if (!(a in J0))
      throw new Error("Unable to parse color from object: " + JSON.stringify(t));
    this.model = J0[a];
    var l = ei[this.model].labels, c = [];
    for (n = 0; n < l.length; n++)
      c.push(t[l[n]]);
    this.color = q0(c);
  }
  if (Vm[this.model])
    for (r = ei[this.model].channels, n = 0; n < r; n++) {
      var u = Vm[this.model][n];
      u && (this.color[n] = u(this.color[n]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
Xr.prototype = {
  toString: function() {
    return this.string();
  },
  toJSON: function() {
    return this[this.model]();
  },
  string: function(t) {
    var e = this.model in kd.to ? this : this.rgb();
    e = e.round(typeof t == "number" ? t : 1);
    var n = e.valpha === 1 ? e.color : e.color.concat(this.valpha);
    return kd.to[e.model](n);
  },
  percentString: function(t) {
    var e = this.rgb().round(typeof t == "number" ? t : 1), n = e.valpha === 1 ? e.color : e.color.concat(this.valpha);
    return kd.to.rgb.percent(n);
  },
  array: function() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function() {
    for (var t = {}, e = ei[this.model].channels, n = ei[this.model].labels, r = 0; r < e; r++)
      t[n[r]] = this.color[r];
    return this.valpha !== 1 && (t.alpha = this.valpha), t;
  },
  unitArray: function() {
    var t = this.rgb().color;
    return t[0] /= 255, t[1] /= 255, t[2] /= 255, this.valpha !== 1 && t.push(this.valpha), t;
  },
  unitObject: function() {
    var t = this.rgb().object();
    return t.r /= 255, t.g /= 255, t.b /= 255, this.valpha !== 1 && (t.alpha = this.valpha), t;
  },
  round: function(t) {
    return t = Math.max(t || 0, 0), new Xr(this.color.map(nNe(t)).concat(this.valpha), this.model);
  },
  alpha: function(t) {
    return arguments.length ? new Xr(this.color.concat(Math.max(0, Math.min(1, t))), this.model) : this.valpha;
  },
  // rgb
  red: er("rgb", 0, $r(255)),
  green: er("rgb", 1, $r(255)),
  blue: er("rgb", 2, $r(255)),
  hue: er(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(t) {
    return (t % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: er("hsl", 1, $r(100)),
  lightness: er("hsl", 2, $r(100)),
  saturationv: er("hsv", 1, $r(100)),
  value: er("hsv", 2, $r(100)),
  chroma: er("hcg", 1, $r(100)),
  gray: er("hcg", 2, $r(100)),
  white: er("hwb", 1, $r(100)),
  wblack: er("hwb", 2, $r(100)),
  cyan: er("cmyk", 0, $r(100)),
  magenta: er("cmyk", 1, $r(100)),
  yellow: er("cmyk", 2, $r(100)),
  black: er("cmyk", 3, $r(100)),
  x: er("xyz", 0, $r(100)),
  y: er("xyz", 1, $r(100)),
  z: er("xyz", 2, $r(100)),
  l: er("lab", 0, $r(100)),
  a: er("lab", 1),
  b: er("lab", 2),
  keyword: function(t) {
    return arguments.length ? new Xr(t) : ei[this.model].keyword(this.color);
  },
  hex: function(t) {
    return arguments.length ? new Xr(t) : kd.to.hex(this.rgb().round().color);
  },
  rgbNumber: function() {
    var t = this.rgb().color;
    return (t[0] & 255) << 16 | (t[1] & 255) << 8 | t[2] & 255;
  },
  luminosity: function() {
    for (var t = this.rgb().color, e = [], n = 0; n < t.length; n++) {
      var r = t[n] / 255;
      e[n] = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
  },
  contrast: function(t) {
    var e = this.luminosity(), n = t.luminosity();
    return e > n ? (e + 0.05) / (n + 0.05) : (n + 0.05) / (e + 0.05);
  },
  level: function(t) {
    var e = this.contrast(t);
    return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "";
  },
  isDark: function() {
    var t = this.rgb().color, e = (t[0] * 299 + t[1] * 587 + t[2] * 114) / 1e3;
    return e < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  negate: function() {
    for (var t = this.rgb(), e = 0; e < 3; e++)
      t.color[e] = 255 - t.color[e];
    return t;
  },
  lighten: function(t) {
    var e = this.hsl();
    return e.color[2] += e.color[2] * t, e;
  },
  darken: function(t) {
    var e = this.hsl();
    return e.color[2] -= e.color[2] * t, e;
  },
  saturate: function(t) {
    var e = this.hsl();
    return e.color[1] += e.color[1] * t, e;
  },
  desaturate: function(t) {
    var e = this.hsl();
    return e.color[1] -= e.color[1] * t, e;
  },
  whiten: function(t) {
    var e = this.hwb();
    return e.color[1] += e.color[1] * t, e;
  },
  blacken: function(t) {
    var e = this.hwb();
    return e.color[2] += e.color[2] * t, e;
  },
  grayscale: function() {
    var t = this.rgb().color, e = t[0] * 0.3 + t[1] * 0.59 + t[2] * 0.11;
    return Xr.rgb(e, e, e);
  },
  fade: function(t) {
    return this.alpha(this.valpha - this.valpha * t);
  },
  opaquer: function(t) {
    return this.alpha(this.valpha + this.valpha * t);
  },
  rotate: function(t) {
    var e = this.hsl(), n = e.color[0];
    return n = (n + t) % 360, n = n < 0 ? 360 + n : n, e.color[0] = n, e;
  },
  mix: function(t, e) {
    if (!t || !t.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
    var n = t.rgb(), r = this.rgb(), s = e === void 0 ? 0.5 : e, i = 2 * s - 1, o = n.alpha() - r.alpha(), a = ((i * o === -1 ? i : (i + o) / (1 + i * o)) + 1) / 2, l = 1 - a;
    return Xr.rgb(
      a * n.red() + l * r.red(),
      a * n.green() + l * r.green(),
      a * n.blue() + l * r.blue(),
      n.alpha() * s + r.alpha() * (1 - s)
    );
  }
};
Object.keys(ei).forEach(function(t) {
  if (DL.indexOf(t) === -1) {
    var e = ei[t].channels;
    Xr.prototype[t] = function() {
      if (this.model === t)
        return new Xr(this);
      if (arguments.length)
        return new Xr(arguments, t);
      var n = typeof arguments[e] == "number" ? e : this.valpha;
      return new Xr(rNe(ei[this.model][t].raw(this.color)).concat(n), t);
    }, Xr[t] = function(n) {
      return typeof n == "number" && (n = q0(N2.call(arguments), e)), new Xr(n, t);
    };
  }
});
function tNe(t, e) {
  return Number(t.toFixed(e));
}
function nNe(t) {
  return function(e) {
    return tNe(e, t);
  };
}
function er(t, e, n) {
  return t = Array.isArray(t) ? t : [t], t.forEach(function(r) {
    (Vm[r] || (Vm[r] = []))[e] = n;
  }), t = t[0], function(r) {
    var s;
    return arguments.length ? (n && (r = n(r)), s = this[t](), s.color[e] = r, s) : (s = this[t]().color[e], n && (s = n(s)), s);
  };
}
function $r(t) {
  return function(e) {
    return Math.max(0, Math.min(t, e));
  };
}
function rNe(t) {
  return Array.isArray(t) ? t : [t];
}
function q0(t, e) {
  for (var n = 0; n < e; n++)
    typeof t[n] != "number" && (t[n] = 0);
  return t;
}
var sNe = Xr;
const iNe = /* @__PURE__ */ Et(sNe), oNe = "_root_12tj0_1", aNe = "_date_12tj0_7", lNe = {
  root: oNe,
  date: aNe
}, cNe = {
  name: "PbDateDelimiter",
  props: {
    date: {
      type: [String, Date],
      required: !0
    },
    color: {
      type: String,
      default: "#eeeeee"
    }
  },
  computed: {
    formatted() {
      const t = new Date(this.date);
      if (mm(t))
        return "Сегодня";
      let e;
      C5(Date.now(), t) < 1 ? e = "Вчера" : e = M5(t, { locale: xn, addSuffix: !0 });
      const n = on(t, this.makeFormatString(t), {
        locale: xn
      });
      return `${e}, ${n}`;
    },
    fontColor() {
      const t = this.color.replace(/^#+/g, "#").replace(/^[a-h\d]+/g, "#$&");
      return iNe(t).isLight() ? "#000" : "#fff";
    }
  },
  methods: {
    makeFormatString(t) {
      let e = "";
      return (!H5(t) || !mm(t)) && (e += "d MMMM "), Rf(t) || (e += "yyyy "), e;
    }
  }
};
var uNe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "date-delimiter" } }, [n("div", { class: e.$style.date, style: { background: e.color, color: e.fontColor } }, [e._v(" " + e._s(e.formatted) + " ")])]);
}, dNe = [];
const Wk = {
  $style: lNe
};
function fNe(t) {
  for (var e in Wk)
    this[e] = Wk[e];
}
var pNe = /* @__PURE__ */ B(
  cNe,
  uNe,
  dNe,
  !1,
  fNe,
  null
);
const $2 = pNe.exports, hNe = "_root_1a7x2_1", mNe = {
  root: hNe
}, vNe = {
  name: "LeadsList",
  components: {
    PanelList: Fv,
    LeadEntry: Mke,
    PbDateDelimiter: $2,
    WithTwoWayLoading: Lv
  },
  props: {
    flow: Object,
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#fff"
    },
    dateMode: {
      type: Number,
      default: 0
    },
    isFocused: {
      type: Function,
      default: () => !1
    }
  },
  data() {
    return {
      currentDate: Date.now(),
      scrollPosition: 0
    };
  },
  computed: {
    ...st({
      modal: (t) => t.uiState.modal,
      isDragging: (t) => t.uiState.panelsDragging,
      maxLength: (t) => t.leads.maxLeadsListLength,
      leadsMap: (t) => t.flows.leadsMap
    }),
    ...pe("panels", ["getPanelIndex"]),
    ...pe(["getIsFlowLeadsActiveById"]),
    ...pe("leads", ["getLeadById"]),
    metaMap() {
      return this.leadsMap[this.flow.id] || {};
    },
    list() {
      return this.metaMap.list || [];
    },
    initialLoaded() {
      return this.metaMap.initialLoaded;
    },
    active() {
      return this.getIsFlowLeadsActiveById(this.flow.id);
    },
    items() {
      return this.list.map((t) => ({ id: t })) || [];
    },
    needDateDelimiter() {
      return (t, e) => {
        if (t && e !== void 0) {
          const n = this.getLeadById(t);
          if (n && n.id)
            if (this.items[e - 1]) {
              const r = this.getLeadById(this.items[e - 1].id);
              if (r && r.id)
                return !yo(
                  Tr(r.created_at),
                  Tr(n.created_at)
                );
            } else
              return !yo(Tr(n.created_at), /* @__PURE__ */ new Date());
        }
        return !1;
      };
    }
  },
  beforeDestroy() {
    this.setInitialLoaded(!1);
  },
  created() {
    this.readTimeout = null;
  },
  mounted() {
    this.setDayChangeTimer(), this.setPaused(!0);
  },
  methods: {
    ...ge({
      showShareModal: "showShareModal",
      selectFlowLead(t, e) {
        e.entry && (clearTimeout(this.readTimeout), this.readTimeout = setTimeout(() => {
          t("selectFlowLead", e);
        }, 200)), this.setHasSelected(!!e.entry);
      },
      loadFlowsLeads(t, e) {
        return t("loadFlowsLeads", { params: e, flowId: this.flow.id });
      },
      setPaused(t, e) {
        t("flowLeadsSetPaused", { flowId: this.flow.id, paused: e });
      },
      setHasNew(t, e) {
        t("flowLeadsSetHasNew", { flowId: this.flow.id, hasNew: e });
      },
      setHasSelected(t, e) {
        t("flowLeadsSetHasSelected", {
          flowId: this.flow.id,
          hasSelected: e
        });
      },
      setInitialLoaded(t, e) {
        t("flowLeadsSetInitialLoaded", {
          flowId: this.flow.id,
          initialLoaded: e
        }), this.$nextTick(() => {
          this.$refs.panelList && this.$refs.panelList.scrollToItem(0);
        });
      }
    }),
    ...ge("leads", ["pickLead", "markAsRead"]),
    ...ge("panels", ["setPanelDateMode", "addPanel"]),
    select(t) {
      const e = this.getLeadById(t);
      this.$refs.panelList.select(e);
    },
    pick(t) {
      const e = this.$store.state.userProfile.defaultNewsType || 3;
      this.pickLead({ leadId: t.id, typeId: e });
    },
    forward(t) {
      this.showShareModal({
        itemId: t.id,
        itemType: "lead",
        actionType: "forward",
        multipleMode: !0
      });
    },
    openPanel(t) {
      this.markAsRead(t.id), this.addPanel({
        panel: { type: ve.lead, dataId: t.id },
        position: this.getPanelIndex(this.panelId)
      });
    },
    scrollToEntry(t) {
      this.$refs.panelList.scrollToEntry(t);
    },
    scrollToUnread() {
      this.scrollPosition = 0, this.$nextTick(() => {
        this.$refs.panelList.scrollToItem(0), this.$refs.panelList.select(null);
      });
    },
    setDayChangeTimer() {
      setTimeout(() => {
        this.currentDate = Date.now(), this.setDayChangeTimer();
      }, _S(z5(), this.currentDate));
    },
    handleScroll({ scrollTop: t }) {
      this.scrollPosition = t, this.scrollPosition > 600 && !this.metaMap.paused && this.setPaused(!0), this.scrollPosition === 0 && !this.metaMap.paused && this.setHasNew(!1);
    }
  }
};
var gNe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("WithTwoWayLoading", { attrs: { hasNew: e.metaMap.hasNew, hasSelected: e.metaMap.hasSelected, isPaused: e.metaMap.paused, initialLoaded: e.metaMap.initialLoaded, active: e.active, fetchData: e.loadFlowsLeads, maxLength: e.maxLength, entries: e.items, cursorField: "created_at", scrollToUnread: e.scrollToUnread, entryGetter: e.getLeadById, emptyText: "Лидов нет" }, on: { setPaused: e.setPaused, setHasNew: e.setHasNew, initialLoaded: e.setInitialLoaded }, scopedSlots: e._u([{ key: "default", fn: function({ loadNext: r, loadPrev: s, hasNew: i, loaded: o, loading: a, refresh: l }) {
    return [n("PanelList", { ref: "panelList", attrs: { entries: e.items, panelId: e.panelId, isCompact: e.isCompact, loaded: o, loading: a, isFocused: e.isFocused, newItemsMessage: "Есть новые инфоповоды", active: e.active, initialLoaded: e.metaMap.initialLoaded, hasNew: i, hasNewIndicator: !0, hasFixedScroll: !0, isDragging: e.isDragging }, on: { select: e.selectFlowLead, openPanel: e.openPanel, reachedTop: r, reachedEnd: s, unreadClick: l, scroll: e.handleScroll }, scopedSlots: e._u([{ key: "default", fn: function({ index: c, item: u, isSelected: d }) {
      return [e.needDateDelimiter(u.id, c) ? n("PbDateDelimiter", { key: e.currentDate, attrs: { date: e.getLeadById(u.id).created_at, color: "#" + e.color } }) : e._e(), n("LeadEntry", { attrs: { color: "#" + e.color, compact: e.isCompact, dateMode: e.dateMode, id: u.id, isSelected: d }, on: { "!openPanel": function(f) {
        return e.openPanel(u);
      }, "!forward": function(f) {
        return e.forward(u);
      }, "!pick": function(f) {
        return e.pick(u);
      }, "!dateModeChanged": function(f) {
        return e.setPanelDateMode({ panelId: e.panelId, mode: f });
      } } })];
    } }], null, !0) })];
  } }]) })], 1);
}, yNe = [];
const Hk = {
  $style: mNe
};
function bNe(t) {
  for (var e in Hk)
    this[e] = Hk[e];
}
var _Ne = /* @__PURE__ */ B(
  vNe,
  gNe,
  yNe,
  !1,
  bNe,
  null
);
const wNe = _Ne.exports, SNe = "_root_1v35a_1", INe = {
  root: SNe
}, ENe = {
  name: "FlowUnreadBadge",
  components: {
    PbBadge: s2
  },
  props: {
    panel: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: "#333"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      initialCount: 0,
      initial: !1
    };
  },
  computed: {
    unread() {
      return this.$store.getters.getFlowPanelUnreadCount(this.panel);
    }
  }
};
var xNe = function() {
  var e = this, n = e._self._c;
  return n("PbBadge", { directives: [{ name: "show", rawName: "v-show", value: e.unread, expression: "unread" }], class: e.$style.root, attrs: { color: e.color, loading: e.loading, unread: e.unread }, on: { click: function(r) {
    return e.$emit("click");
  }, dblclick: function(r) {
    return e.$emit("dblclick");
  } } });
}, CNe = [];
const Vk = {
  $style: INe
};
function TNe(t) {
  for (var e in Vk)
    this[e] = Vk[e];
}
var PNe = /* @__PURE__ */ B(
  ENe,
  xNe,
  CNe,
  !1,
  TNe,
  null
);
const AL = PNe.exports, kNe = "_empty_6txk9_1", NNe = "_FlowUnreadBadge_6txk9_8", $Ne = "_closeButton_6txk9_12", DNe = {
  empty: kNe,
  FlowUnreadBadge: NNe,
  closeButton: $Ne
}, ANe = {
  name: "FlowPanel",
  components: {
    PbButton: nt,
    Panel: bs,
    LeadsList: wNe,
    FlowUnreadBadge: AL,
    PanelMenu: Rv
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    const { gatewaySubscribe: t, gatewayUnsubscribe: e } = Kv();
    return { gatewaySubscribe: t, gatewayUnsubscribe: e };
  },
  data() {
    return {
      availabilityStatus: null,
      menuShowed: !1,
      menuItems: [
        {
          label: "Закрыть панель",
          code: "close",
          handler: this.remove,
          enabled: !0
        }
      ]
    };
  },
  computed: {
    ...st({
      modal: (t) => t.uiState.modal
    }),
    ...pe([
      "flowForPanel",
      "getFlowPanelUnread",
      "sessionTimeoutExpired",
      "getPanelIsActive"
    ]),
    ...pe("panels", ["getIsPanelRightSupplyVisible"]),
    flow() {
      return this.flowForPanel(this.panel) || {};
    },
    isRightSupplyVisible() {
      return this.getIsPanelRightSupplyVisible(this.panel.id);
    },
    leadsMap() {
      return this.$store.state.flows.leadsMap[this.flow.id] || {};
    },
    isPaused() {
      return this.leadsMap.paused;
    },
    panelStyle() {
      let t = ["6px", "6px", "6px", "6px"];
      return this.isRightSupplyVisible && (t[1] = "0", t[2] = "0"), {
        borderRadius: t.join(" ")
      };
    },
    panelTitle() {
      return this.availabilityStatus === 403 ? "Поток недоступен" : this.availabilityStatus === 404 ? "Поток удалён" : this.panel.settings.name;
    },
    isActive() {
      return this.getPanelIsActive(this.panel.id);
    }
  },
  created() {
    this.fetchData(this.panel.dataId);
  },
  beforeDestroy() {
    this.unsubscribeFlowLeads();
  },
  methods: {
    ...ge("leads", ["pushLead"]),
    ...ge({
      markFlowAsRead: "markFlowAsRead",
      getFlow: "getFlow",
      setHasNew: "flowLeadsSetHasNew",
      resetInitialLoaded(t) {
        t("flowLeadsSetInitialLoaded", {
          flowId: this.flow.id,
          initialLoaded: !1
        });
      }
    }),
    ...ge("panels", ["removePanel"]),
    getIsFocused() {
      return this.isFocused;
    },
    subscribeFlowLeads() {
      this.flow && this.gatewaySubscribe({
        type: Wm.FLOW_LEADS,
        id: this.flow.id
      });
    },
    unsubscribeFlowLeads() {
      const t = Number(this.panel.dataId);
      this.gatewayUnsubscribe({
        type: Wm.FLOW_LEADS,
        id: t
      });
    },
    remove() {
      this.removePanel({ panelId: this.panel.id });
    },
    markAllAsRead() {
      this.markFlowAsRead(this.flow);
    },
    async scrollToUnread() {
      const t = this.getFlowPanelUnread(this.panel);
      t && this.$refs.leadsList && (this.$refs.leadsList.scrollToEntry(t[0]), this.$refs.leadsList.select(t[0].id));
    },
    async fetchData(t) {
      let e = this.$store.state.flows.items[t];
      e ? this.subscribeFlowLeads() : (e = await this.getFlow(t), e.errors ? this.availabilityStatus = e.status : this.subscribeFlowLeads()), this.setMenuItems(e);
    },
    setMenuItems(t) {
      this.menuItems.unshift({
        label: "Настройка потока",
        code: "flow_edit",
        handler: () => this.$router.push({ name: "flowEdit", params: { id: t.id } }).catch(() => null),
        enabled: !!t.id
      });
    }
  }
};
var ONe = function() {
  var e = this, n = e._self._c;
  return e.flow && e.flow.id ? n("Panel", { style: e.panelStyle, attrs: { panel: e.panel, title: e.flow.name, isFocused: e.isFocused, "data-test-selector": "panel-flow", "data-test-id": e.panel.id, "data-test-attrs": `entry-id__${e.panel.dataId}${e.isFocused ? " panel__focused" : ""}` }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [n("PanelMenu", { attrs: { items: e.menuItems, trigger: e.menuShowed, color: "#" + e.panel.settings.color }, on: { "update:trigger": function(r) {
      e.menuShowed = r;
    } } }, [n("span", { staticClass: "panel-id" }, [e._v(e._s(e.flow.id))])])];
  }, proxy: !0 }, { key: "appBar", fn: function() {
    return [n("FlowUnreadBadge", { class: e.$style.FlowUnreadBadge, attrs: { panel: e.panel, color: "#" + e.panel.settings.color }, on: { click: e.scrollToUnread, dblclick: e.markAllAsRead } })];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n("LeadsList", { ref: "leadsList", attrs: { flow: e.flow, panelId: e.panel.id, isCompact: e.panel.settings.compact, color: e.panel.settings.color, dateMode: e.panel.settings.dateMode, isFocused: e.getIsFocused }, on: { unreadClick: e.scrollToUnread } })];
  }, proxy: !0 }], null, !1, 1132414889) }) : n("Panel", { attrs: { panel: e.panel, title: e.panelTitle, isFocused: e.isFocused }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [n("PanelMenu", { attrs: { items: e.menuItems, trigger: e.menuShowed, color: "#" + e.panel.settings.color }, on: { "update:trigger": function(r) {
      e.menuShowed = r;
    } } }, [n("span", { staticClass: "panel-id" }, [e._v(e._s(e.panel.dataId))])])];
  }, proxy: !0 }, { key: "appBarActions", fn: function() {
    return [n("PbButton", { class: e.$style.closeButton, attrs: { round: "", "data-test-selector": "panel-button-close" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.remove.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n("h3", { class: e.$style.empty }, [e.availabilityStatus === 403 ? n("span", [e._v(" У вас нет доступа к этому потоку ")]) : e.availabilityStatus === 404 ? n("span", [e._v(" Этот поток был удалён ")]) : n("span", [e._v(" Этот поток был удалён или вы не имеете к нему доступа ")])])];
  }, proxy: !0 }]) });
}, MNe = [];
const zk = {
  $style: DNe
};
function RNe(t) {
  for (var e in zk)
    this[e] = zk[e];
}
var LNe = /* @__PURE__ */ B(
  ANe,
  ONe,
  MNe,
  !1,
  RNe,
  null
);
const FNe = LNe.exports, Jv = {
  computed: {
    activeTab: {
      get() {
        var t, e;
        return ((e = (t = this.tabs) == null ? void 0 : t[this.activeTabIndex]) == null ? void 0 : e.name) ?? "";
      },
      set(t) {
        var n;
        const e = (n = this.tabs) == null ? void 0 : n.findIndex((r) => r.name === t);
        e >= 0 && (this.activeTabIndex = e);
      }
    },
    activeTabIndex: {
      get() {
        var t;
        return Number(((t = this.panel) == null ? void 0 : t.settings.activeTabIndex) ?? 0);
      },
      set(t) {
        this.panel && this.setPanelActiveTabIndex({
          panelId: this.panel.id,
          activeTabIndex: t
        });
      }
    }
  },
  methods: {
    ...ge("panels", ["setPanelActiveTabIndex"])
  }
}, qv = {
  data() {
    return {
      elementFocused: !1
    };
  },
  computed: {
    isSelectionEnabled() {
      return this.loaded && this.elementFocused;
    }
  },
  watch: {
    isSelectionEnabled(t) {
      t ? this.$enableSelectionListener(this._uid) : this.$disableSelectionListener(this._uid);
    },
    isFocused(t) {
      t || this.$emit("fragmentSelected", null);
    }
  },
  created() {
    document.addEventListener("selectstart", this.selectStartHandler), this.$registerSelectionListener(this._uid, this.selectionHandler);
  },
  beforeDestroy() {
    document.removeEventListener("selectstart", this.selectStartHandler), this.$unregisterSelectionListener(this._uid, this.selectionHandler);
  },
  methods: {
    selectStartHandler() {
      this.$emit("fragmentSelected", null);
    },
    selectionHandler(t) {
      if (!t.isCollapsed && t.rangeCount) {
        const e = t.getRangeAt(0).cloneRange();
        this.expandRange(e), e.detach();
        const n = e.startContainer, r = e.endContainer, s = this.isWithin(
          n,
          this.$refs.selectionRangeContent
        ), i = this.isWithin(r, this.$refs.selectionRangeContent);
        s && i ? this.$emit("fragmentSelected", this.selectionHTML(e)) : (s || e.setStart(this.$refs.selectionRangeContent, 0), i || e.setEnd(
          this.$refs.selectionRangeContent,
          this.$refs.selectionRangeContent.childNodes.length
        ), this.$emit("fragmentSelected", this.selectionHTML(e)));
      } else
        this.$emit("fragmentSelected", null);
    },
    /**
     * Расширяет range если выделение началось внутри ссылки.
     * Ссылка выделяется целиком
     * @param {Range} range
     */
    expandRange(t) {
      const e = t.startContainer.parentNode, n = t.endContainer.parentNode;
      e === n && e.nodeName === "A" && n.nodeName === "A" && (t.setStartBefore(e), t.setEndAfter(n));
    },
    /**
     * Проверяет находится ли `child` внутри `parent`
     * @param {Node} child
     * @param {Node} parent
     * @returns {boolean}
     */
    isWithin(t, e) {
      let n = !1;
      return t.nodeType !== Node.ELEMENT_NODE ? n = !!(t.parentNode && this.traverseUp(t, e)) : n = !!(t.isSameNode(e) || this.traverseUp(t, e)), n;
    },
    /**
     * Поднимается по DOM наверх.
     * Возвращает `parent` если родитель найден или `null` если не найден
     * @param {Node} child
     * @param {Node} parent
     * @returns {Node|null}
     */
    traverseUp(t, e) {
      for (; t; ) {
        if (t === e) return t;
        t = t.parentNode;
      }
      return null;
    },
    /**
     * Возвращает валидный HTML для `range`
     * @param {Range} range
     * @returns {string}
     */
    selectionHTML(t) {
      const e = document.createElement("div");
      return e.appendChild(t.cloneContents()), e.innerHTML;
    }
  }
}, BNe = "_root_pxam8_1", jNe = "_body_pxam8_6", WNe = "_body_inverted_pxam8_11", HNe = {
  root: BNe,
  body: jNe,
  body_inverted: WNe
}, VNe = {
  name: "LeadAdditions",
  mixins: [qv],
  inject: ["getColorScheme"],
  props: {
    entry: {
      type: Object,
      required: !0
    },
    isFocused: {
      type: Boolean,
      default: !1
    },
    loaded: {
      type: Boolean,
      default: !1
    },
    isParentNewsPanel: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    errors() {
      return this.diff.errors || [];
    },
    bodyClass() {
      return {
        [this.$style.body]: !0,
        [this.$style.body_inverted]: this.isParentNewsPanel && this.getColorScheme().theme === "dark"
      };
    }
  },
  watch: {
    isFocused(t, e) {
      t !== e && this.$refs.entryBody && (t ? this.$refs.entryBody.focus() : this.$refs.entryBody.blur());
    }
  },
  methods: {
    handleFocus() {
      this.elementFocused = !0;
    },
    handleBlur() {
      this.elementFocused = !1;
    }
  }
};
var zNe = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "entryBody", class: e.$style.root }, [n("div", { ref: "selectionRangeContent", class: e.bodyClass, attrs: { tabindex: "-1", "data-test-selector": "panel-lead-additions-content" }, on: { focus: e.handleFocus, blur: e.handleBlur } }, [e.entry.parsedDiff && e.entry.parsedDiff.result ? [e._l(e.entry.parsedDiff.result, function(r, s) {
    return [r[0] === "+" ? n("ins", { key: s, domProps: { innerHTML: e._s(r[1]) } }) : n("span", { key: s, domProps: { innerHTML: e._s(r[1]) } })];
  })] : [e._v(" " + e._s(e.entry.body) + " ")]], 2)]);
}, UNe = [];
const Uk = {
  $style: HNe
};
function GNe(t) {
  for (var e in Uk)
    this[e] = Uk[e];
}
var YNe = /* @__PURE__ */ B(
  VNe,
  zNe,
  UNe,
  !1,
  GNe,
  null
);
const D2 = YNe.exports, ZNe = "_checkmark_1c1n9_1", XNe = "_checkmark_disabled_1c1n9_11", KNe = {
  checkmark: ZNe,
  checkmark_disabled: XNe
}, JNe = {
  name: "Checkmark",
  props: {
    type: {
      String,
      required: !0,
      validator(t) {
        return t === "single" || t === "double";
      }
    },
    color: {
      type: String
    }
  }
};
var qNe = function() {
  var e = this, n = e._self._c;
  return e.type === "single" ? n("svg", { class: [e.$style.checkmark, e.$style.checkmark_single], style: { color: `${e.color}` }, attrs: { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" } }, [n("path", { attrs: { d: "M3.373 16.706l-1.56 1.671 6.935 6.472 11.131-15.714-1.865-1.321-9.619 13.579z" } })]) : n("svg", { class: [e.$style.checkmark, e.$style.checkmark_double], style: { color: `${e.color}` }, attrs: { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" } }, [n("path", { attrs: { d: "M3.373 16.706l5.022 4.687 9.619-13.579 1.865 1.321-11.131 15.714-6.935-6.472 1.56-1.671zM15.527 19.516l2.011 1.877 9.619-13.579 1.865 1.321-11.131 15.714-3.923-3.662 1.56-1.671z" } })]);
}, QNe = [];
const Gk = {
  $style: KNe
};
function e3e(t) {
  for (var e in Gk)
    this[e] = Gk[e];
}
var t3e = /* @__PURE__ */ B(
  JNe,
  qNe,
  QNe,
  !1,
  e3e,
  null
);
const OL = t3e.exports, n3e = {
  name: "NewsbreakMeta",
  components: {
    Checkmark: OL
  },
  props: {
    status: {
      type: Object,
      required: !0
    }
  }
};
var r3e = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "entry-delivery-status" }, [n("span", { staticClass: "entry-delivery-status-title" }, [e._v(" " + e._s(e.status.name === "NOT_SET" ? "Передал(а) в работу" : e.status.label) + ": ")]), e._l(e.status.names, function(r, s) {
    return [n("span", { key: s }, [e._v(" " + e._s(r.name) + " "), e.status.name === "FORWARDED" ? n("Checkmark", { attrs: { type: r.isRead ? "double" : "single", "data-test-selector": "panel-newsbreak-delivery-status-forwarded-checkmark" } }) : e._e(), e.status.names.length > 1 && s < e.status.names.length - 1 ? [e._v(", ")] : e._e()], 2)];
  })], 2);
}, s3e = [], i3e = /* @__PURE__ */ B(
  n3e,
  r3e,
  s3e,
  !1,
  null,
  null
);
const ML = i3e.exports, o3e = "_root_5tuvm_1", a3e = "_task_5tuvm_18", l3e = "_task_selected_5tuvm_22", c3e = "_checkmark_5tuvm_25", u3e = "_taskInfo_5tuvm_32", d3e = "_taskDeliveryStatus_5tuvm_37", f3e = {
  root: o3e,
  task: a3e,
  task_selected: l3e,
  checkmark: c3e,
  taskInfo: u3e,
  taskDeliveryStatus: d3e
}, p3e = {
  name: "LeadNewsbreaks",
  components: {
    NewsbreakMeta: ML
  },
  props: {
    newsbreaks: {
      type: Array,
      required: !0
    },
    selectedNewsbreakId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ...pe("newsbreaks", ["getNewsbreakMetaByNb"]),
    meta() {
      return (t) => {
        const e = this.getNewsbreakMetaByNb(t), n = {};
        if (Object.keys(e).forEach((r) => {
          e[r].names.length > 0 && (n[r] = e[r]);
        }), n.NOT_SET) {
          const r = n.NOT_SET.names.filter(
            (s) => s.isForwardedBy
          );
          r.length ? e.NOT_SET.names = r : delete n.NOT_SET;
        }
        return n;
      };
    }
  }
};
var h3e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, e._l(e.newsbreaks, function(r) {
    return n("div", { key: r.id, class: {
      [e.$style.task]: !0,
      [e.$style.task_selected]: r.id === e.selectedNewsbreakId
    }, attrs: { "data-test-selector": "lead-newsbreak", "data-test-id": r.id, "data-test-attrs": `newsbreak-id__${r.id}` }, on: { click: function(s) {
      return e.$emit("newsbreakSelected", r.id);
    } } }, [r.fragment ? n("div", { class: e.$style.fragment, domProps: { innerHTML: e._s(r.fragment) } }) : n("div", { class: e.$style.taskInfo }, [e._v(" Передан весь текст инфоповода ")]), e._l(Object.keys(e.meta(r)), function(s) {
      return n("div", { key: s, class: e.$style.taskDeliveryStatus, attrs: { "data-test-selector": "lead-newsbreak-delivery-status", "data-test-attrs": `status__${s.toLowerCase()}` } }, [n("NewsbreakMeta", { attrs: { status: e.meta(r)[s] } })], 1);
    })], 2);
  }), 0);
}, m3e = [];
const Yk = {
  $style: f3e
};
function v3e(t) {
  for (var e in Yk)
    this[e] = Yk[e];
}
var g3e = /* @__PURE__ */ B(
  p3e,
  h3e,
  m3e,
  !1,
  v3e,
  null
);
const y3e = g3e.exports, b3e = "_root_1crt0_1", _3e = "_content_1crt0_10", w3e = "_patch_1crt0_22", S3e = "_empty_1crt0_26", I3e = {
  root: b3e,
  content: _3e,
  patch: w3e,
  empty: S3e
}, E3e = {
  name: "LeadDiff",
  mixins: [qv],
  components: {
    PbEmpty: tl
  },
  props: {
    entry: {
      type: Object,
      required: !0
    },
    isFocused: {
      type: Boolean,
      default: !1
    },
    loaded: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    chunks() {
      return this.entry.parsedDiff ? this.entry.parsedDiff.chunks : [];
    },
    errors() {
      return this.entry.parsedDiff ? this.entry.parsedDiff.errors : [];
    }
  },
  watch: {
    isFocused(t, e) {
      t !== e && this.$refs.entryBody && (t ? this.$refs.entryBody.focus() : this.$refs.entryBody.blur());
    }
  }
};
var x3e = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "entryBody", class: e.$style.root }, [e.loaded ? [!e.errors && e.chunks && e.chunks.length ? n("div", { ref: "selectionRangeContent", class: e.$style.content, attrs: { tabindex: "-1", "data-test-selector": "panel-lead-diff-content" }, on: { focus: function(r) {
    e.elementFocused = !0;
  }, blur: function(r) {
    e.elementFocused = !1;
  } } }, e._l(e.chunks, function(r, s) {
    return n("div", { key: s, class: e.$style.chunk }, [e._l(r, function(i, o) {
      return [i[0] && i[0] === "-" ? n("div", { key: o, class: e.$style.patch }, [n("del", { domProps: { innerHTML: e._s(i[1]) } })]) : e._e(), i[0] && i[0] === "+" ? n("div", { key: o, class: e.$style.patch }, [n("ins", { domProps: { innerHTML: e._s(i[1]) } })]) : e._e()];
    }), n("br")], 2);
  }), 0) : n("PbEmpty", { attrs: { text: "Для этого инфоповода нет разницы", "data-test-selector": "panel-lead-diff-empty" } })] : e._e()], 2);
}, C3e = [];
const Zk = {
  $style: I3e
};
function T3e(t) {
  for (var e in Zk)
    this[e] = Zk[e];
}
var P3e = /* @__PURE__ */ B(
  E3e,
  x3e,
  C3e,
  !1,
  T3e,
  null
);
const A2 = P3e.exports, k3e = {
  name: "LeadPanelFooter",
  components: {
    MainActionButton: fn
  },
  props: {
    lead: {
      type: [Object, null],
      required: !0
    },
    panelId: {
      type: [Number, String],
      required: !0
    },
    parentId: {
      type: [Number, String],
      default: null
    },
    color: {
      type: String,
      default: "#333"
    },
    isSupply: {
      type: Boolean,
      default: !1
    },
    forwardFragment: {
      type: [String, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disabledText: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...pe("panels", ["getPanelIndex"])
  },
  methods: {
    ...ge(["showShareModal"]),
    ...ge("leads", ["pickLead"]),
    ...ge("panels", ["addPanel"]),
    openPanel() {
      this.addPanel({
        panel: { type: ve.lead, dataId: this.lead.id },
        position: this.getPanelIndex(this.isSupply ? this.parentId : this.panelId)
      });
    },
    pick() {
      this.pickLead({
        leadId: this.lead.id,
        typeId: 1,
        fragment: this.forwardFragment
      }), this.$emit("removePanel", { panelId: this.panelId });
    },
    async forward(t) {
      await this.showShareModal({
        itemId: this.lead.id,
        itemType: "lead",
        actionType: "forward",
        multipleMode: !0,
        params: {
          forwardFragment: t
        }
      }), this.$emit("fragmentClear");
    }
  }
};
var N3e = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "entry-panel-footer" }, [e.lead ? n("div", { staticClass: "entry-panel-footer-row", style: { "background-color": "#" + e.color } }, [n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["3.1"], expression: "['3.1']", arg: "all" }], staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-forward", "data-test-selector": "panel-lead-button-forward" }, nativeOn: { click: function(r) {
    return e.forward(e.forwardFragment);
  } } }, [e.forwardFragment ? n("span", [e._v("Отправить фрагмент")]) : n("span", [e._v("Отправить в работу")])]), n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["3.2"], expression: "['3.2']", arg: "all" }], staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "panel-lead-button-add" }, nativeOn: { click: function(r) {
    return e.pick.apply(null, arguments);
  } } }, [e.forwardFragment ? n("span", [e._v("Взять фрагмент")]) : n("span", [e._v("Взять в работу")])]), e.isSupply ? n("MainActionButton", { staticClass: "mini-button show-more pb-action-button-old", attrs: { iconName: "button-icon-show-more", title: "Открыть в отдельной панели", "data-test-selector": "panel-lead-button-show-more" }, nativeOn: { click: function(r) {
    return e.openPanel.apply(null, arguments);
  } } }) : e._e()], 1) : e._e()]);
}, $3e = [], D3e = /* @__PURE__ */ B(
  k3e,
  N3e,
  $3e,
  !1,
  null,
  null
);
const A3e = D3e.exports, O3e = {
  name: "LeadNewsbreaksFooter",
  components: {
    MainActionButton: fn
  },
  props: {
    newsbreak: {
      type: Object,
      default: () => ({})
    },
    panelId: {
      type: [Number, String],
      required: !0
    },
    color: {
      type: String,
      default: "#333"
    },
    isSupply: {
      type: Boolean,
      default: !1
    },
    lead: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      rejectDialog: !1,
      rejectionId: null
    };
  },
  computed: {
    ...pe("newsbreaks", ["getNewsbreakMetaByNb"]),
    meta() {
      return this.getNewsbreakMetaByNb(this.newsbreak);
    }
  },
  methods: {
    ...ge(["showShareModal"]),
    ...ge("newsbreaks", ["pickNewsbreak", "rejectNewsbreak"]),
    pick() {
      const t = this.$store.state.userProfile.defaultNewsType || 3;
      this.pickNewsbreak({ newsbreakId: this.newsbreak.id, typeId: t }), this.$emit("removePanel", { panelId: this.panelId });
    },
    async forward() {
      await this.showShareModal({
        itemId: this.lead.id,
        itemType: "lead",
        actionType: "forward",
        multipleMode: !0,
        params: {
          forwardFragment: this.newsbreak.fragment
        }
      }), this.$emit("fragmentClear");
    },
    showRejectModal(t) {
      this.rejectionId = t, this.rejectDialog = !0;
    }
  }
};
var M3e = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "entry-panel-footer newsbreak-tasks-footer" }, [e.newsbreak ? n("div", { staticClass: "entry-panel-footer-row", style: { "background-color": "#" + e.color } }, [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { "data-test-selector": "panel-newsbreak-button-forward", disabled: !e.newsbreak.id, iconName: "button-icon-forward" }, nativeOn: { click: function(r) {
    return e.forward.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.newsbreak.fragment ? "Отправить фрагмент" : "Отправить  в работу") + " ")]), e.isSupply ? e._e() : n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { "data-test-selector": "panel-newsbreak-button-add", iconName: "button-icon-add", disabled: !e.newsbreak.id }, nativeOn: { click: function(r) {
    return e.pick.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.newsbreak.fragment ? "Взять фрагмент" : "Взять  в работу") + " ")])], 1) : e._e()]);
}, R3e = [], L3e = /* @__PURE__ */ B(
  O3e,
  M3e,
  R3e,
  !1,
  null,
  null
);
const F3e = L3e.exports;
function B3e(t, e = !1) {
  this.item = this.lead, this.loaded || (this.loaded = !0), e && (t.newsbreaks && t.newsbreaks.length ? this.activeTab = "LeadNewsbreaks" : this.activeTab = this.tabs[0].name), this.selectedNewsbreakId = null;
}
const j3e = {
  name: "LeadEntryPanel",
  mixins: [Jv],
  components: {
    LeadAdditions: D2,
    LeadDiff: A2,
    EntryPanel: e2,
    LeadNewsbreaks: y3e,
    LeadPanelFooter: A3e,
    LeadNewsbreaksFooter: F3e
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      default: null
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selectedNewsbreakId: null,
      loaded: !1,
      loading: !1,
      errors: [],
      forwardFragment: null,
      item: {}
    };
  },
  computed: {
    ...st({
      leads: (t) => t.leads.items,
      initialLoadedMap: (t) => t.leads.initialLoadedMap
    }),
    ...pe("references", ["premoderatedSourceTypes"]),
    lead() {
      return this.leads[this.panel.dataId] || {};
    },
    initialLoaded() {
      const t = this.initialLoadedMap[this.panel.dataId];
      return t ? t.initialLoaded : !1;
    },
    isFromPremoderatedSource() {
      return !this.lead || fs(this.lead) ? !1 : this.premoderatedSourceTypes.includes(this.lead.source.type_id);
    },
    title() {
      return this.item && this.item.title ? this.item.title.slice(0, 50) : this.lastError ? this.lastError : "";
    },
    diff() {
      return this.item.parsedDiff || {};
    },
    lastError() {
      return this.errors.length ? this.errors[this.errors.length - 1].title : null;
    },
    tabs() {
      const t = [{ name: "LeadAdditions", label: "Текст" }];
      return this.isFromPremoderatedSource || t.unshift({ name: "LeadDiff", label: "Разница" }), this.item && this.item.newsbreaks && this.item.newsbreaks.length && t.unshift({ name: "LeadNewsbreaks", label: "Инфоповоды" }), t;
    },
    selectedNewsbreak() {
      return this.item.newsbreaks && this.item.newsbreaks.find(
        (t) => t.id === this.selectedNewsbreakId
      ) || null;
    },
    url() {
      return this.item.source && this.item.source.url ? this.item.source.url : this.item.url;
    }
  },
  watch: {
    lead(t, e) {
      t && (t.id !== e.id || t.newsbreaks !== e.newsbreaks) && (clearTimeout(this.updateTimeout), this.updateTimeout = setTimeout(
        B3e.bind(this, t, t.id !== e.id),
        64
      ));
    },
    initialLoaded(t, e) {
      t !== e && t === !1 && this.initialLoad(!0);
    }
  },
  created() {
    this.updateTimeout = null, this.panel.supply || this.initialLoad();
  },
  beforeDestroy() {
    this.setInitialLoaded({ leadId: this.lead.id, value: !1 });
  },
  methods: {
    ...ge("leads", {
      getLead: "getLead",
      setInitialLoaded: "setLeadsInitialLoaded"
    }),
    ...ge("panels", ["setPanelDateMode"]),
    async initialLoad(t = !1) {
      await this.fetchData(t), this.item = this.lead, this.item.newsbreaks && this.item.newsbreaks.length && (this.activeTab = "LeadNewsbreaks"), this.setInitialLoaded({ leadId: this.lead.id, value: !0 });
    },
    setDateMode(t) {
      let e = this.parent && this.parent.id ? this.parent.id : this.panel.id;
      this.setPanelDateMode({ panelId: e, mode: t });
    },
    async fetchData(t = !1) {
      this.loaded = !1, this.loading = !0;
      let e = this.lead;
      return (!this.lead || !this.lead.id || t) && (e = await this.getLead(this.panel.dataId)), e.errors && (this.errors = e.errors), this.loaded = !0, this.loading = !1, e;
    },
    setFragmentSelected(t) {
      t ? this.forwardFragment = t : this.forwardFragment = null;
    }
  }
};
var W3e = function() {
  var e = this, n = e._self._c;
  return n("EntryPanel", { attrs: { title: e.title, entry: e.item, panel: e.panel, parent: e.parent, loading: !e.loaded, error: e.lastError, tabs: e.tabs, url: e.url, contentTitle: e.item.source ? e.item.source.name : e.item.name, activeTab: e.activeTab, isFocused: e.isFocused, resizeable: !1, "data-test-selector": "panel-lead", "data-test-id": e.panel.dataId, "data-test-attrs": `entry-id__${e.panel.dataId}` }, on: { "update:activeTab": function(r) {
    e.activeTab = r;
  }, "update:active-tab": function(r) {
    e.activeTab = r;
  } }, scopedSlots: e._u([e.activeTab === "LeadFragments" ? { key: "contentHeader", fn: function() {
    return [n("span")];
  }, proxy: !0 } : null, { key: "tabContent", fn: function() {
    return [n(e.activeTab, { tag: "component", attrs: { entry: e.item, newsbreaks: e.item.newsbreaks || [], loaded: e.loaded, selectedNewsbreakId: e.selectedNewsbreakId, isFocused: e.isFocused, "data-test-selector": "panel-lead-content" }, on: { fragmentSelected: function(r) {
      return e.setFragmentSelected(r);
    }, dateModeChanged: e.setDateMode, newsbreakSelected: function(r) {
      e.selectedNewsbreakId = r;
    } } })];
  }, proxy: !0 }, e.lastError ? null : { key: "entryFooter", fn: function() {
    return [e.activeTab === "LeadNewsbreaks" ? n("LeadNewsbreaksFooter", { attrs: { newsbreak: e.selectedNewsbreak, lead: e.item, color: e.parent ? e.parent.settings.color : e.panel.settings.color, isSupply: !!e.parent, panelId: e.panel.id, parentId: e.parent && e.parent.id } }) : n("LeadPanelFooter", { attrs: { lead: e.item, panelId: e.panel.id, parentId: e.parent && e.parent.id, color: e.parent ? e.parent.settings.color : e.panel.settings.color, isSupply: !!e.parent, disabled: e.activeTab === "LeadNewsbreaks" && e.selectedNewsbreakId === null, disabledText: "Выберите задачу из списка выше", forwardFragment: e.forwardFragment }, on: { fragmentClear: function(r) {
      return e.setFragmentSelected(null);
    } } })];
  }, proxy: !0 }], null, !0) });
}, H3e = [], V3e = /* @__PURE__ */ B(
  j3e,
  W3e,
  H3e,
  !1,
  null,
  null
);
const Xk = V3e.exports, z3e = "_root_13r73_1", U3e = {
  root: z3e
}, G3e = {
  name: "NewsbreakFragment",
  props: {
    fragment: {
      type: String,
      default: ""
    }
  }
};
var Y3e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, domProps: { innerHTML: e._s(e.fragment) } });
}, Z3e = [];
const Kk = {
  $style: U3e
};
function X3e(t) {
  for (var e in Kk)
    this[e] = Kk[e];
}
var K3e = /* @__PURE__ */ B(
  G3e,
  Y3e,
  Z3e,
  !1,
  X3e,
  null
);
const RL = K3e.exports, J3e = "_close_v1ql7_1", q3e = "_body_v1ql7_8", Q3e = "_form_v1ql7_14", e$e = "_label_v1ql7_18", t$e = "_field_v1ql7_23", n$e = "_error_v1ql7_34", r$e = "_footer_v1ql7_40", s$e = "_btn_v1ql7_45", i$e = "_btn_primary_v1ql7_52", o$e = {
  close: J3e,
  body: q3e,
  form: Q3e,
  label: e$e,
  field: t$e,
  error: n$e,
  footer: r$e,
  btn: s$e,
  btn_primary: i$e
}, a$e = {
  name: "DialogDispose",
  components: {
    PbModal: Au,
    PbButton: nt
  },
  props: {
    state: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: "Пожалуйста, укажите причину:"
    },
    confirmButtonLabel: {
      type: String,
      default: "Отклонить"
    },
    cancelButtonLabel: {
      type: String,
      default: "Отмена"
    },
    title: {
      type: String,
      default: "Отклонить материал"
    },
    reasonRequired: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      maxLength: 1e4,
      reason: "",
      error: null
    };
  },
  watch: {
    reason(t, e) {
      t !== e && t.length <= this.maxLength && (this.error = null);
    }
  },
  created() {
    this.$registerShortcut("Enter", this.handleEnter, {
      enabled: !0,
      capture: !0
    });
  },
  mounted() {
    this.$nextTick().then(
      this.$nextTick(() => {
        this.$refs.field && this.$refs.field.focus();
      })
    );
  },
  methods: {
    handleEnter(t) {
      if (t.composed && (t.ctrlKey || t.metaKey)) {
        if (t.stopPropagation(), t.preventDefault(), this.reasonRequired && !this.reason.trim().length)
          return !0;
        this.dispose();
        return;
      }
      return !0;
    },
    dispose() {
      if (this.reason.length > this.maxLength) {
        this.error = `Причина отклонения должна быть короче ${this.maxLength} символов`;
        return;
      }
      this.$emit("dispose", this.reason), this.close();
    },
    close() {
      this.$emit("update:state", !1);
    }
  }
};
var l$e = function() {
  var e = this, n = e._self._c;
  return n("PbModal", { attrs: { state: e.state, title: e.title, "max-width": 600, className: e.$style.root, "test-selector": "dialog-dispose" }, on: { close: e.close } }, [n("div", { class: e.$style.body }, [n("div", { class: e.$style.form }, [n("label", { class: e.$style.label, attrs: { for: "disposeReason" } }, [e._v(" " + e._s(e.label) + " ")]), n("textarea", { directives: [{ name: "model", rawName: "v-model", value: e.reason, expression: "reason" }], ref: "field", class: e.$style.field, attrs: { id: "disposeReason", "data-test-selector": "dialog-dispose-input", autofocus: "" }, domProps: { value: e.reason }, on: { input: function(r) {
    r.target.composing || (e.reason = r.target.value);
  } } }), e.error ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "dialog-dispose-error" } }, [e._v(" " + e._s(e.error) + " ")]) : e._e()]), n("div", { class: e.$style.footer }, [n("PbButton", { class: [e.$style.btn, e.$style.btn_primary], attrs: { disabled: e.reasonRequired && !e.reason.trim().length, "data-test-selector": "dialog-dispose-accept" }, on: { click: e.dispose } }, [e._v(" " + e._s(e.confirmButtonLabel) + " ")]), n("PbButton", { class: e.$style.btn, attrs: { "data-test-selector": "dialog-dispose-decline" }, on: { click: e.close } }, [e._v(" " + e._s(e.cancelButtonLabel) + " ")])], 1)])]);
}, c$e = [];
const Jk = {
  $style: o$e
};
function u$e(t) {
  for (var e in Jk)
    this[e] = Jk[e];
}
var d$e = /* @__PURE__ */ B(
  a$e,
  l$e,
  c$e,
  !1,
  u$e,
  null
);
const LL = d$e.exports, f$e = {
  name: "NewsbreakPanelFooter",
  components: {
    MainActionButton: fn,
    NewsbreakMeta: ML,
    DialogDispose: LL
  },
  props: {
    newsbreak: {
      type: Object,
      default: () => ({})
    },
    panelId: {
      type: [Number, String],
      required: !0
    },
    color: {
      type: String,
      default: "#333"
    },
    isSupply: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      rejectDialog: !1,
      rejectionId: null
    };
  },
  computed: {
    ...pe("newsbreaks", ["getNewsbreakMetaByNb"]),
    meta() {
      let t = this.getNewsbreakMetaByNb(this.newsbreak);
      if (t.NOT_SET) {
        const e = t.NOT_SET.names.filter(
          (n) => n.isForwardedBy
        );
        e.length ? t.NOT_SET.names = e : delete t.NOT_SET;
      }
      return t;
    }
  },
  watch: {
    rejectDialog(t) {
      this.modalSet(t);
    }
  },
  methods: {
    ...ge("newsbreaks", ["pickNewsbreak", "rejectNewsbreak"]),
    ...ge({ showShareModal: "showShareModal", modalSet: "setModal" }),
    ...ge({
      async reject(t, e) {
        await t("newsbreaks/rejectNewsbreak", {
          newsbreakId: this.rejectionId,
          reason: e
        }), this.rejectionId = null;
      }
    }),
    pick() {
      const t = this.$store.state.userProfile.defaultNewsType || 3;
      this.pickNewsbreak({ newsbreakId: this.newsbreak.id, typeId: t }), this.$emit("removePanel", { panelId: this.panelId });
    },
    async forward(t) {
      await this.showShareModal({
        itemId: this.newsbreak.id,
        itemType: "newsbreak",
        actionType: "forward",
        multipleMode: !0,
        params: {
          forwardFragment: t
        }
      }), this.$emit("fragmentClear");
    },
    showRejectModal() {
      this.rejectionId = this.newsbreak.id, this.rejectDialog = !0;
    }
  }
};
var p$e = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "entry-panel-footer" }, [e.newsbreak ? n("div", { staticClass: "entry-panel-footer-row", style: { "background-color": e.color } }, [e.isSupply ? e._e() : n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["3.4"], expression: "['3.4']", arg: "all" }], staticClass: "pb-action-button-old", attrs: { "data-test-selector": "panel-newsbreak-button-add", iconName: "button-icon-add", disabled: !e.newsbreak.id }, nativeOn: { click: function(r) {
    return e.pick.apply(null, arguments);
  } } }, [e._v(" Взять в работу ")]), n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["3.5"], expression: "['3.5']", arg: "all" }], staticClass: "reject-white pb-action-button-old", attrs: { iconName: "button-icon-delete", "data-test-selector": "task-entry-full-button-delete" }, on: { click: e.showRejectModal } }, [e._v(" Отклонить инфоповод ")])], 1) : e._e(), !e.isSupply && e.meta ? [e._l(Object.keys(e.meta), function(r) {
    return [e.meta[r].names.length ? n("div", { key: r, staticClass: "entry-panel-footer-row", attrs: { "data-test-selector": "panel-newsbreak-delivery-status", "data-test-attrs": `status__${e.meta[r].name.toLowerCase()}` } }, [n("NewsbreakMeta", { attrs: { status: e.meta[r] } })], 1) : e._e()];
  })] : e._e(), e.rejectDialog ? n("DialogDispose", { attrs: { slot: "dialogs", state: e.rejectDialog, reasonRequired: !0, confirmButtonLabel: "Отклонить инфоповод", title: "Отклонить инфоповод" }, on: { "update:state": function(r) {
    e.rejectDialog = r;
  }, dispose: e.reject }, slot: "dialogs" }) : e._e()], 2);
}, h$e = [], m$e = /* @__PURE__ */ B(
  f$e,
  p$e,
  h$e,
  !1,
  null,
  null
);
const v$e = m$e.exports, g$e = {
  name: "NewsbreakEntryPanel",
  mixins: [Jv],
  components: {
    EntryPanel: e2,
    NewsbreakPanelFooter: v$e,
    LeadDiff: A2,
    LeadAdditions: D2,
    NewsbreakFragment: RL
  },
  inject: ["getColorScheme"],
  provide() {
    return {
      toolbarStyles: () => ({
        color: "#fff",
        backgroundColor: "#333"
      })
    };
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      default: null
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      errors: [],
      loaded: !1,
      forwardFragment: null
    };
  },
  computed: {
    ...st({
      fullscreenPanel: (t) => t.panels.uiState.fullscreen,
      newsbreaks: (t) => t.newsbreaks.items,
      initialLoadedMap: (t) => t.newsbreaks.initialLoadedMap
    }),
    ...pe(["getNewsbreakLead"]),
    ...pe("references", ["premoderatedSourceTypes"]),
    initialLoaded() {
      const t = this.initialLoadedMap[this.panel.dataId];
      return t ? t.initialLoaded : !1;
    },
    isSupplyOfFullscreenPanel() {
      return this.parent && this.parent.id && this.parent.id === this.fullscreenPanel;
    },
    isFromPremoderatedSource() {
      return !this.lead || fs(this.lead) ? !1 : this.premoderatedSourceTypes.includes(this.lead.source.type_id);
    },
    isParentNewsPanel() {
      return this.panel.type === gt.newsItemNewsbreakSupply;
    },
    tabs() {
      const t = [{ name: "LeadAdditions", label: "Текст" }];
      return this.isFromPremoderatedSource || t.unshift({ name: "LeadDiff", label: "Разница" }), this.newsbreak.fragment && t.push({ name: "NewsbreakFragment", label: "Инфоповод" }), t;
    },
    lead() {
      return this.getNewsbreakLead(this.newsbreak.id);
    },
    diff() {
      return this.newsbreak.lead && this.newsbreak.lead.diff || {};
    },
    newsbreak() {
      return this.newsbreaks[this.panel.dataId] || {};
    },
    lastError() {
      return this.errors.length ? this.errors[this.errors.length - 1].title : null;
    },
    title() {
      if (this.newsbreak.id && this.newsbreak.fragment) {
        const t = document.createElement("div");
        return t.innerHTML = this.newsbreak.fragment, t.innerText.slice(0, 50);
      }
      return this.lead.id && this.lead.title ? this.lead.title.slice(0, 50) : this.lastError ? this.lastError : "";
    },
    url() {
      return this.lead.url;
    }
  },
  watch: {
    initialLoaded(t, e) {
      t !== e && t === !1 && this.initialLoad(!0);
    }
  },
  created() {
    this.initialLoad();
  },
  beforeDestroy() {
    this.setInitialLoaded({ newsbreakId: this.panel.dataId, value: !1 });
  },
  methods: {
    ...ge("newsbreaks", {
      reject: "rejectNewsbreak",
      pick: "pickNewsbreak",
      getNewsbreak: "getNewsbreak",
      setInitialLoaded: "newsbreaksSetInitialLoaded"
    }),
    ...ge("panels", {
      removePanel: "removePanel"
    }),
    pick({ entry: t, typeId: e }) {
      this.pick({ entry: t, typeId: e }), this.close();
    },
    async initialLoad(t) {
      (await this.fetchData(this.panel.dataId, t)).fragment && (this.activeTab = "NewsbreakFragment"), this.setInitialLoaded({ newsbreakId: this.panel.dataId, value: !0 });
    },
    async fetchData(t, e = !1) {
      this.loaded = !1;
      let n = this.newsbreak || {};
      return (!n.id || e) && (n = await this.getNewsbreak(t)), n.errors && (this.errors = n.errors), this.loaded = !0, n;
    },
    setFragmentSelected(t) {
      t ? this.forwardFragment = t : this.forwardFragment = null;
    }
  }
};
var y$e = function() {
  var e = this, n = e._self._c;
  return n("EntryPanel", { attrs: { title: e.title, entry: e.lead, panel: e.panel, parent: e.parent, loading: !e.loaded, error: e.lastError, tabs: e.tabs, url: e.url, contentTitle: e.lead.source ? e.lead.source.name : e.lead.name, activeTab: e.activeTab, isFocused: e.isFocused, resizeable: !1, "data-test-attrs": `entry-id__${e.panel.dataId}` }, on: { "update:activeTab": function(r) {
    e.activeTab = r;
  }, "update:active-tab": function(r) {
    e.activeTab = r;
  } }, scopedSlots: e._u([{ key: "tabContent", fn: function() {
    return [n(e.activeTab, { tag: "component", attrs: { entry: e.lead, fragment: e.newsbreak.fragment, loaded: e.loaded, isFocused: e.isFocused, isParentNewsPanel: e.isParentNewsPanel, "data-test-selector": "panel-newsbreak-content" }, on: { fragmentSelected: function(r) {
      return e.setFragmentSelected(r);
    } } })];
  }, proxy: !0 }, { key: "entryFooter", fn: function() {
    return [e.lastError ? e._e() : n("NewsbreakPanelFooter", { attrs: { newsbreak: e.newsbreak, panelId: e.panel.id, color: "#" + e.panel.settings.color, isSupply: !!e.parent, parentPanel: e.parent }, on: { removePanel: e.removePanel } })];
  }, proxy: !0 }]) });
}, b$e = [], _$e = /* @__PURE__ */ B(
  g$e,
  y$e,
  b$e,
  !1,
  null,
  null
);
const w$e = _$e.exports, S$e = "_root_i0759_1", I$e = {
  root: S$e
}, E$e = {
  name: "PbPanelListEntry",
  props: {
    entryData: Object,
    isSelected: Boolean,
    dateMode: Number,
    compact: Boolean,
    isRead: Boolean,
    classes: {
      type: Array,
      default: () => []
    },
    color: String
  }
};
var x$e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [
    e.$style.root,
    "entry",
    e.isSelected ? "selected" : null,
    e.compact ? "compact" : null,
    ...e.classes
  ] }, [e.compact ? [e._t("compact")] : [e._t("default")]], 2);
}, C$e = [];
const qk = {
  $style: I$e
};
function T$e(t) {
  for (var e in qk)
    this[e] = qk[e];
}
var P$e = /* @__PURE__ */ B(
  E$e,
  x$e,
  C$e,
  !1,
  T$e,
  null
);
const k$e = P$e.exports, N$e = "_root_1jmrq_1", $$e = "_status_1jmrq_13", D$e = "_origin_1jmrq_18", A$e = "_text_1jmrq_27", O$e = "_date_1jmrq_39", M$e = {
  root: N$e,
  status: $$e,
  origin: D$e,
  text: A$e,
  date: O$e
}, R$e = {
  name: "PbPanelListCompactEntry",
  components: {
    DateWidget: Hr
  },
  props: {
    isRead: {
      type: Boolean,
      default: !0
    },
    link: {
      type: Object,
      default: () => ({
        url: null,
        name: null,
        placeholder: "Без инфоповода"
      })
    },
    text: {
      type: String,
      default: null
    },
    textPlaceholder: {
      type: String,
      default: "Пусто"
    },
    dateMode: {
      type: Number,
      default: Boolean
    },
    date: {
      type: [String, Date],
      default: null
    },
    color: {
      type: String,
      default: "#f0f0f0"
    }
  },
  asyncComputed: {
    cleanText: {
      async get() {
        return await Kn.process("trimHTML", this.text);
      },
      default: ""
    }
  }
};
var L$e = function() {
  var e = this, n = e._self._c;
  return n("span", { class: [e.$style.root, "entry-compact"], attrs: { "data-test-selector": "news-entry-compact" } }, [e._t("left", function() {
    return [n("span", { class: [e.$style.status, "entry-status"], attrs: { "data-test-selector": "news-entry-compact-status", "data-test-attrs": `status__${e.isRead ? "read" : "unread"}` } }, [e.isRead ? e._e() : n("i", { style: { color: e.color } }, [e._v("●")])]), n("span", { class: [e.$style.origin, "entry-origin"], attrs: { "data-test-selector": "news-entry-compact-origin" } }, [e.link.url ? n("a", { attrs: { href: e.link.url, target: "_blank", title: e.link.name ? e.link.name : e.link.url } }, [e._v(" " + e._s(e.link.name ? e.link.name : null) + " ")]) : n("span", [e._v(e._s(e.link.placeholder))])])];
  }, null, e.$props), e._t("body", function() {
    return [n("span", { class: { [e.$style.text]: !0, "entry-text": !0, "no-text": !e.text }, attrs: { "data-test-selector": "news-entry-compact-text" } }, [e.text ? [e._v(e._s(e.cleanText))] : [e._v(e._s(e.textPlaceholder))]], 2)];
  }, null, e.$props), e._t("actions", null, null, e.$props), e._t("right", function() {
    return [n("span", { class: [e.$style.date, "entry-date"] }, [n("DateWidget", { attrs: { "data-test-selector": "news-entry-compact-date", date: e.date, mode: e.dateMode }, on: { dateModeChanged: function(r) {
      return e.$emit("dateModeChanged", r);
    } } })], 1)];
  }, null, e.$props)], 2);
}, F$e = [];
const Qk = {
  $style: M$e
};
function B$e(t) {
  for (var e in Qk)
    this[e] = Qk[e];
}
var j$e = /* @__PURE__ */ B(
  R$e,
  L$e,
  F$e,
  !1,
  B$e,
  null
);
const W$e = j$e.exports, H$e = "_root_14p2u_1", V$e = "_header_14p2u_13", z$e = "_body_14p2u_48", U$e = "_expansion_14p2u_63", G$e = "_footer_14p2u_67", Y$e = {
  root: H$e,
  header: V$e,
  body: z$e,
  expansion: U$e,
  footer: G$e
}, Z$e = {
  name: "PbPanelListEntryFull",
  props: {
    footerShowed: {
      type: Boolean,
      default: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    entryData: Object
  }
};
var X$e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, "entry-full"], attrs: { "data-test-selector": "entry-full" } }, [n("header", { class: [e.$style.header, "entry-header"] }, [e._t("header", null, null, e.entryData)], 2), n("main", { class: [e.$style.body, "entry-body"] }, [e._t("body"), n("div", { class: [e.$style.expansion, "expansion"], attrs: { "data-test-selector": "entry-expansion" } }, [e._t("expansion", null, null, e.entryData)], 2)], 2), e.footerShowed ? n("footer", { class: [e.$style.footer, "entry-footer"], attrs: { "data-test-selector": "entry-footer" } }, [e._t("footer", null, null, e.entryData)], 2) : e._e()]);
}, K$e = [];
const eN = {
  $style: Y$e
};
function J$e(t) {
  for (var e in eN)
    this[e] = eN[e];
}
var q$e = /* @__PURE__ */ B(
  Z$e,
  X$e,
  K$e,
  !1,
  J$e,
  null
);
const Q$e = q$e.exports, eDe = "_root_1t2nv_1", tDe = "__default_1t2nv_13", nDe = "_icon_1t2nv_20", rDe = {
  root: eDe,
  _default: tDe,
  icon: nDe
}, sDe = {
  name: "PbEmbargoBadge",
  props: {
    date: {
      type: [String, Date]
    },
    postponed: {
      type: Boolean,
      default: !1
    },
    defaultStyle: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    dateParsed() {
      return Tr(this.date);
    },
    formattedTime() {
      let t = "d MMMM ";
      return Rf(this.dateParsed) || (t += "yyyy "), t += "HH:mm:ss", Go(this.dateParsed, t);
    },
    formattedTitle() {
      return this.postponed ? "Эмбарго до звонка" : "Будет опубликована " + Go(this.dateParsed, "dd MMMM yyyy HH:mm");
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style._default]: this.defaultStyle
      };
    }
  }
};
var iDe = function() {
  var e = this, n = e._self._c;
  return n("span", { class: e.rootClass, attrs: { title: e.formattedTitle, "data-test-selector": "embargo-badge" } }, [n("span", { staticClass: "pb-embargo-badge__text" }, [e._v(" " + e._s(e.postponed ? "Эмбарго до звонка" : e.formattedTime) + " ")])]);
}, oDe = [];
const tN = {
  $style: rDe
};
function aDe(t) {
  for (var e in tN)
    this[e] = tN[e];
}
var lDe = /* @__PURE__ */ B(
  sDe,
  iDe,
  oDe,
  !1,
  aDe,
  null
);
const cDe = lDe.exports, uDe = {
  name: "NewsEntry",
  components: {
    Entry: k$e,
    DateWidget: Hr,
    Compact: W$e,
    Full: Q$e,
    EmbargoBadge: cDe
  },
  props: {
    item: {
      type: Object,
      required: !0
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    dateMode: {
      type: Number,
      default: 0
    },
    compact: {
      type: [Boolean, Number],
      default: !1
    },
    color: {
      type: String,
      default: "#f0f0f0"
    }
  },
  computed: {
    ...pe("references", ["newsStatusesByName", "newsTypesByName"]),
    ...pe("news", [
      "getNewsItemById",
      "getNewsItemIsRead",
      "newsItemGroupNames",
      "isNewsItemIsAssignedToMe",
      "isNewsItemScheduled",
      "getNewsItemCurrentVersion",
      "getIsNewsItemExpired"
    ]),
    ...pe("news/versions", ["versionAuthorsNames"]),
    newsItemUsers() {
      const t = this.item.id;
      return this.newsItemUserBindingNames(t) ?? [];
    },
    newsItemGroups() {
      const t = this.item.id;
      return this.newsItemGroupNames(t) ?? [];
    },
    showEmbargoInfo() {
      var e, n;
      return ![
        this.newsStatusesByName.PUBLISHED.id,
        this.newsStatusesByName.DISPOSED.id
      ].includes((e = this.version) == null ? void 0 : e.status_id) && this.isNewsItemScheduled((n = this.entry) == null ? void 0 : n.id);
    },
    embargoExpired() {
      return ![
        this.newsStatusesByName.PUBLISHED.id,
        this.newsStatusesByName.DISPOSED.id
      ].includes(this.version.status_id) && this.getIsNewsItemExpired(this.item.id);
    },
    entry() {
      return this.getNewsItemById(this.item.id) || {};
    },
    version() {
      return this.getNewsItemCurrentVersion(this.item.id) || {};
    },
    authors() {
      const t = [
        this.newsStatusesByName.WAITS_FOR_PUBLICATION.id,
        this.newsStatusesByName.PUBLISHED.id
      ], e = this.versionAuthorsNames(this.version.id);
      let n = e.join(", ");
      return t.includes(this.version.status_id) && this.entry.publisher ? n = this.formatUsername(this.entry.publisher.name) + " / " + n : n = (e.length > 1 ? "Авторы: " : "Автор: ") + n, n;
    },
    newsbreakURL() {
      return this.entry.newsbreak ? this.entry.newsbreak.lead.url ? this.entry.newsbreak.lead.url : this.entry.newsbreak.lead.source.url : null;
    },
    newsbreakName() {
      return this.entry.newsbreak && this.entry.newsbreak.lead.source ? this.entry.newsbreak.lead.source.name : null;
    },
    textHeader() {
      return this.version && this.version.headline ? I0(this.version.headline).slice(0, 140) : null;
    },
    textBody() {
      return this.version && this.version.body ? I0(this.version.body).slice(0, 120) : null;
    },
    text() {
      return this.textHeader ? this.textHeader : this.textBody ? this.textBody : "Пустая новость";
    },
    isRevoked() {
      var t;
      return ((t = this.entry) == null ? void 0 : t.is_revoked) ?? !1;
    },
    isRead() {
      return this.getNewsItemIsRead(this.item.id);
    }
  }
};
var dDe = function() {
  var e = this, n = e._self._c;
  return e.entry.id && e.version.id ? n("Entry", { class: { "embargo-expired": e.embargoExpired, _revoked: e.isRevoked }, attrs: { classes: ["entry-draft", `news-entry-type-${e.version.type_id}`], isSelected: e.isSelected, compact: !!e.compact, isRead: e.isRead, "data-test-selector": "news-entry", "data-test-id": e.entry.id, "data-test-attrs": `entry-id__${e.entry.id}${e.isSelected ? " selected" : ""}` }, scopedSlots: e._u([{ key: "compact", fn: function() {
    return [n("Compact", { attrs: { isRead: e.isRead, color: e.color, link: {
      url: e.newsbreakURL,
      name: e.newsbreakName,
      placeholder: "Без инфоповода"
    }, text: e.textHeader || e.textBody, textPlaceholder: "Пустая новость", dateMode: e.dateMode, date: e.entry.status_modified_at }, on: { dateModeChanged: function(r) {
      return e.$emit("dateModeChanged", r);
    } }, scopedSlots: e._u([{ key: "left", fn: function(r) {
      return [e._t("entry-compact-left", null, null, Object.assign(r, { entry: e.entry, entryVm: e._self })), e._t("before-text", null, { entry: e.entry })];
    } }, { key: "right", fn: function(r) {
      return [e._t("entry-compact-right", function() {
        return [e.showEmbargoInfo ? n("span", { staticClass: "entry-date" }, [e._v(" Будет опубликована "), n("EmbargoBadge", { attrs: { date: e.version.publish_at, postponed: e.version.is_postponed } }), n("span", { directives: [{ name: "show", rawName: "v-show", value: e.embargoExpired, expression: "embargoExpired" }], staticClass: "warning-icon", attrs: { "data-test-selector": e.embargoExpired ? "entry-expired" : null } }, [n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Вышло время публикации", expression: "'Вышло время публикации'" }], attrs: { name: "warning", size: "17" } })], 1)], 1) : e._e()];
      }, null, Object.assign(r, { entry: e.entry, entryVm: e._self }))];
    } }], null, !0) })];
  }, proxy: !0 }], null, !1, 2796286113) }, [n("Full", { attrs: { footerShowed: e.isSelected, entryData: Object.assign(e.$props, { entry: e.entry, version: e.version, isRead: e.isRead }) }, scopedSlots: e._u([{ key: "header", fn: function(r) {
    return [e._t("entry-header", function() {
      return [n("span", { staticClass: "entry-status", attrs: { "data-test-selector": "entry-status", "data-test-attrs": `status__${e.isRead ? "read" : "unread"}` } }, [n("i", { directives: [{ name: "show", rawName: "v-show", value: !e.isRead, expression: "!isRead" }], style: { color: "rgba(255, 255, 255, .8)" } }, [e._v("●")])]), n("span", { staticClass: "entry-date" }, [n("DateWidget", { attrs: { date: e.entry.status_modified_at, mode: e.dateMode }, on: { dateModeChanged: (s) => e.$emit("dateModeChanged", s) } })], 1)];
    }, null, Object.assign(r, { entryVm: e._self }))];
  } }, { key: "body", fn: function() {
    return [n("span", { directives: [{ name: "show", rawName: "v-show", value: e.embargoExpired, expression: "embargoExpired" }], staticClass: "warning-icon", attrs: { "data-test-selector": e.embargoExpired ? "entry-expired" : null } }, [n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Вышло время публикации", expression: "'Вышло время публикации'" }], attrs: { name: "warning", size: "17" } })], 1), e.version ? n("div", { staticClass: "entry-text", attrs: { "data-test-selector": "entry-text" } }, [e.textHeader ? n("b", [e._t("before-text", null, { entry: e.entry }), e._v(e._s(e.text) + " ")], 2) : e.textBody ? n("span", [e._t("before-text", null, { entry: e.entry }), e._v(e._s(e.text) + " ")], 2) : n("span", { staticClass: "no-text" }, [e._t("before-text", null, { entry: e.entry }), e._v(e._s(e.text) + " ")], 2)]) : e._e()];
  }, proxy: !0 }, { key: "expansion", fn: function(r) {
    return [e.showEmbargoInfo ? n("span", { staticClass: "news-item-embargo" }, [e._v(" Будет опубликована "), n("EmbargoBadge", { attrs: { date: e.version.publish_at, postponed: e.version.is_postponed } })], 1) : e._e(), n("span", { staticClass: "news-item-authors", attrs: { "data-test-selector": "entry-authors" } }, [e._v(" " + e._s(e.authors) + " ")]), e._t("entry-expansion", null, null, r)];
  } }, { key: "footer", fn: function(r) {
    return [e._t("entry-footer", null, null, r)];
  } }], null, !0) })], 1) : e._e();
}, fDe = [], pDe = /* @__PURE__ */ B(
  uDe,
  dDe,
  fDe,
  !1,
  null,
  null
);
const hDe = pDe.exports, mDe = "_root_vbfce_1", vDe = {
  root: mDe
}, gDe = {
  name: "NewsList",
  components: {
    PanelList: Fv,
    PbDateDelimiter: $2,
    NewsEntry: hDe,
    WithTwoWayLoading: Lv
  },
  props: {
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#fff"
    },
    dateMode: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      required: !0
    },
    isFocused: {
      type: Function,
      default: () => !1
    },
    items: {
      type: Array,
      default: () => []
    },
    loadMethod: {
      type: Function,
      required: !0
    },
    loadParams: {
      type: Object,
      default: () => ({})
    },
    cursorField: {
      type: String,
      default: "status_modified_at"
    },
    entryGetter: {
      type: Function,
      default: (t) => t
    },
    active: {
      type: Boolean,
      default: !0
    },
    hasDateDelimiters: {
      type: Boolean,
      default: !0
    },
    hasFixedScroll: {
      type: Boolean,
      default: !1
    },
    hasNewIndicator: {
      type: Boolean,
      default: !1
    },
    minimalItemHeight: {
      type: Number,
      default: null
    },
    showSpinnerOnSequentialLoads: {
      type: Boolean,
      default: !1
    },
    sizeDeps: {
      type: Function,
      default: () => []
    },
    autoselectIndex: {
      type: Number,
      default: null
    },
    removeSelection: {
      type: Boolean,
      default: !1
    },
    forceRefresh: {
      // флаг, по которому происходит принудительное обновление списка
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      currentDate: Date.now(),
      scrollPosition: 0
    };
  },
  computed: {
    ...st({
      modal: (t) => t.uiState.modal,
      isDragging: (t) => t.uiState.panelsDragging,
      maxLength: (t) => t.news.maxNewsListLength,
      sets: (t) => t.news.sets,
      originals: (t) => t.news.originals
    }),
    ...pe("news", [
      "getNewsItemById",
      "getIsPausedNewsSet",
      "getIsHasNewNewsSet",
      "getIsHasSelectedNewsSet"
    ]),
    listHasNew() {
      return this.getIsHasNewNewsSet(this.type);
    },
    listHasSelected() {
      return this.getIsHasSelectedNewsSet(this.type);
    },
    listIsPaused() {
      return this.getIsPausedNewsSet(this.type);
    },
    initialLoaded() {
      const t = this.sets[this.type] || this.originals;
      return t && t.initialLoaded;
    },
    needDateDelimiter() {
      return (t, e) => {
        if (t && e !== void 0) {
          const n = this.getNewsItemById(t);
          if (n && n.id)
            if (this.items[e - 1]) {
              const r = this.getNewsItemById(this.items[e - 1].id);
              if (r && r.id)
                return !yo(
                  Tr(r.status_modified_at),
                  Tr(n.status_modified_at)
                );
            } else
              return !yo(
                Tr(n.status_modified_at),
                /* @__PURE__ */ new Date()
              );
        }
        return !1;
      };
    }
  },
  watch: {
    items(t) {
      if (!this.hasNewIndicator) return;
      const e = t.length >= this.maxLength;
      setTimeout(() => {
        if (this.scrollPosition !== 0 && e) {
          this.setPaused(!0);
          return;
        }
      }, 100);
    },
    loadParams: {
      handler(t, e) {
        let n = !1;
        for (const r in { ...e, ...t })
          if (n = e[r] !== t[r]) break;
        n && this.$refs.withLoading && this.active && this.$refs.withLoading.refresh();
      },
      deep: !0
    },
    async forceRefresh(t) {
      t && (await this.$refs.withLoading.refresh(), this.$emit("refreshed"));
    }
  },
  created() {
    this.readTimeout = null;
  },
  beforeDestroy() {
    this.setInitialLoaded(!1);
  },
  mounted() {
    this.setDayChangeTimer();
  },
  methods: {
    ...ge("panels", {
      setPanelDateMode: "setPanelDateMode"
    }),
    ...ge("news", {
      setNewsItemAsRead(t, e) {
        if (e.entry) {
          const n = e.entry.id;
          clearTimeout(this.readTimeout), this.readTimeout = setTimeout(() => {
            t("setNewsItemAsRead", n);
          }, 200);
        }
        this.setHasSelected(!!e.entry);
      },
      setPaused(t, e) {
        return t("setNewsSetPaused", { setType: this.type, value: e });
      },
      setHasNew(t, e) {
        return t("setNewsSetHasNew", { setType: this.type, value: e });
      },
      setHasSelected(t, e) {
        return t("setNewsSetHasSelected", {
          setType: this.type,
          value: e
        });
      },
      setInitialLoaded(t, e) {
        t("setNewsSetInittialLoaded", { setType: this.type, value: e }), this.$nextTick(() => {
          this.$refs.panelList && this.$refs.panelList.scrollToItem(0);
        });
      }
    }),
    isActive() {
      return this.active && this.isFocused();
    },
    async fetchData({ cursor: t, limit: e = 30, reverse: n = !1, replace: r = !1 }) {
      let s = [], i = {
        cursor: t,
        limit: e,
        reverse: n,
        additional: this.loadParams
      };
      return s = await this.loadMethod({ params: i, replace: r, setType: this.type }), s.data && (this.loaded = s.next_cursor === null), s;
    },
    async scrollToUnread() {
      this.$refs.panelList && (this.scrollPosition = 0, this.$refs.panelList.scrollToItem(0));
    },
    setDayChangeTimer() {
      setTimeout(() => {
        this.currentDate = Date.now(), this.setDayChangeTimer();
      }, _S(z5(), this.currentDate));
    },
    handleItemSelect(t) {
      this.setNewsItemAsRead(t), this.$emit("selectItem", t);
    },
    handleScroll({ scrollTop: t }) {
      this.scrollPosition = t, this.scrollPosition === 0 && !this.listIsPaused && this.setHasNew(!1);
    }
  }
};
var yDe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "news-list" } }, [e._t("before"), n("WithTwoWayLoading", { ref: "withLoading", attrs: { hasNew: e.listHasNew, hasSelected: e.listHasSelected, isPaused: e.listIsPaused, fetchData: e.fetchData, active: e.active, initialLoaded: e.initialLoaded, scrollToUnread: e.scrollToUnread, maxLength: e.maxLength, entries: e.items, entryGetter: e.entryGetter, cursorField: e.cursorField, showSpinnerOnSequentialLoads: e.showSpinnerOnSequentialLoads, emptyText: "Новостей нет" }, on: { setPaused: e.setPaused, setHasNew: e.setHasNew, initialLoaded: e.setInitialLoaded }, scopedSlots: e._u([{ key: "default", fn: function({
    loadNext: r,
    loadPrev: s,
    refresh: i,
    hasNew: o,
    loaded: a,
    loading: l
  }) {
    return [e.items.length ? n("PanelList", { ref: "panelList", attrs: { entries: e.items, panelId: e.panelId, isCompact: e.isCompact, loaded: a, loading: l, isFocused: e.isActive, modal: e.modal, active: e.active, initialLoaded: e.initialLoaded, hasNew: o, hasNewIndicator: e.hasNewIndicator, isDragging: e.isDragging, sizeDeps: e.sizeDeps, hasFixedScroll: !0, minimalHeight: e.minimalItemHeight, autoselectIndex: e.autoselectIndex, removeSelection: e.removeSelection, emptyText: "Новостей нет", newItemsMessage: "Есть новые новости" }, on: { select: e.handleItemSelect, openPanel: function(c) {
      return e.$emit("openPanel", c);
    }, reachedEnd: s, reachedTop: r, unreadClick: function(c) {
      return i(!1);
    }, scroll: e.handleScroll }, scopedSlots: e._u([{ key: "default", fn: function({ item: c, index: u, isSelected: d, stripBase: f }) {
      return [e._t("news-entry-delimiter", function() {
        return [e.hasDateDelimiters && e.needDateDelimiter(c.id, u) ? n("PbDateDelimiter", { key: e.currentDate, attrs: { date: e.getNewsItemById(c.id).status_modified_at, color: "#" + e.color } }) : e._e()];
      }, null, { index: u, item: c, currentDate: e.currentDate }), e._t("news-list-entry", function() {
        return [n("NewsEntry", { attrs: { isSelected: d, color: "#" + e.color, compact: e.isCompact, item: c, dateMode: e.dateMode }, on: { openPanel: function(p) {
          return e.$emit("openPanel", c);
        }, "!dateModeChanged": function(p) {
          return e.setPanelDateMode({ panelId: e.panelId, mode: p });
        } }, scopedSlots: e._u([{ key: "entry-compact-left", fn: function(p) {
          return [e._t("news-entry-compact-left", null, null, p)];
        } }, { key: "entry-compact-right", fn: function(p) {
          return [e._t("news-entry-compact-right", null, null, p)];
        } }, { key: "entry-header", fn: function(p) {
          return [e._t("news-entry-header", null, null, p)];
        } }, { key: "before-text", fn: function(p) {
          return [e._t("news-entry-before-text", null, null, p)];
        } }, { key: "entry-expansion", fn: function(p) {
          return [e._t("news-entry-expansion", null, null, p)];
        } }, { key: "entry-footer", fn: function(p) {
          return [e._t("news-entry-footer", null, null, p)];
        } }], null, !0) })];
      }, null, { index: u, item: c, isSelected: d, stripBase: f })];
    } }], null, !0) }) : e._e()];
  } }]) }), e._t("news-list-footer")], 2);
}, bDe = [];
const nN = {
  $style: vDe
};
function _De(t) {
  for (var e in nN)
    this[e] = nN[e];
}
var wDe = /* @__PURE__ */ B(
  gDe,
  yDe,
  bDe,
  !1,
  _De,
  null
);
const Qv = wDe.exports, SDe = "_root_don6i_1", IDe = {
  root: SDe
}, EDe = {
  name: "NewsDisposedList",
  components: {
    NewsList: Qv,
    DateWidget: Hr,
    MainActionButton: fn,
    NewsTypeButton: ea,
    PbEntryDate: nl
  },
  props: {
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#fff"
    },
    dateMode: {
      type: Number,
      default: 0
    },
    isFocused: {
      type: Function,
      default: () => !1
    }
  },
  methods: {
    ...ge("news", {
      loadNewsDisposed(t, { params: e, replace: n }) {
        return t("loadNews", { params: e, setType: "disposed", replace: n });
      },
      pickNewsItemToEdit: "pickNewsItemToEdit"
    }),
    ...ge("panels", ["addPanel"]),
    openPanel(t) {
      this.addPanel({
        panel: { type: ve.newsItem, dataId: t.id },
        position: this.getPanelIndex(this.panelId)
      });
    }
  },
  computed: {
    ...st({
      items: (t) => t.news.sets.disposed.list.map((e) => ({ id: e }))
    }),
    ...pe("references", ["newsStatusesByName"]),
    ...pe("news", ["getNewsItemById"]),
    ...pe("panels", ["getPanelIndex"]),
    ...pe(["getPanelIsActive"]),
    active() {
      return this.panel && this.getPanelIsActive(this.panelId);
    }
  }
};
var xDe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("NewsList", { attrs: { type: "disposed", panelId: e.panelId, isCompact: e.isCompact, color: e.color, dateMode: e.dateMode, items: e.items, isFocused: e.isFocused, active: e.active, hasDateDelimiters: !0, entryGetter: e.getNewsItemById, hasNewIndicator: !0, loadMethod: e.loadNewsDisposed, "data-test-selector": "news-disposal-list" }, on: { openPanel: e.openPanel }, scopedSlots: e._u([{ key: "news-entry-header", fn: function({ entry: r, dateMode: s, entryVm: i }) {
    return [n("PbEntryDate", [n("DateWidget", { attrs: { date: r.status_modified_at, mode: s, "data-test-selector": "entry-date" }, on: { dateModeChanged: (o) => i.$emit("dateModeChanged", o) } })], 1)];
  } }, { key: "news-entry-compact-left", fn: function() {
    return [n("span")];
  }, proxy: !0 }, { key: "news-entry-expansion", fn: function({ entry: r, version: s }) {
    return [n("NewsTypeButton", { attrs: { typeId: s.type_id, disabled: !0, color: [1, 2].includes(s.type_id) ? "#D0021B" : "#848484", "data-test-selector": "entry-type-button", "data-test-attrs": `type__${s.type_id}`, "data-test-id": s.type_id } })];
  } }, { key: "news-entry-footer", fn: function({ entry: r }) {
    return [n("MainActionButton", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["2.14"], expression: "['2.14']", arg: "all" }], staticClass: "back-to-edit pb-action-button-old", attrs: { "data-test-selector": "entry-button-forward", iconName: "button-icon-forward" }, on: { click: function(s) {
      return e.pickNewsItemToEdit({ newsItemId: r.id });
    } } }, [e._v(" Вернуть в работу ")]), n("MainActionButton", { staticClass: "mini-button pb-action-button-old", attrs: { "data-test-selector": "entry-button-show-more", iconName: "button-icon-show-more", title: "Открыть в отдельной панели" }, on: { click: function(s) {
      return e.openPanel(r);
    } } })];
  } }]) })], 1);
}, CDe = [];
const rN = {
  $style: IDe
};
function TDe(t) {
  for (var e in rN)
    this[e] = rN[e];
}
var PDe = /* @__PURE__ */ B(
  EDe,
  xDe,
  CDe,
  !1,
  TDe,
  null
);
const kDe = PDe.exports, NDe = {
  name: "NewsDisposedPanel",
  components: {
    Panel: bs,
    PanelMenu: Rv,
    NewsDisposedList: kDe
  },
  props: {
    panel: Object,
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      menuShowed: !1,
      menuItems: [
        {
          label: "Закрыть панель",
          code: "close",
          handler: this.remove,
          enabled: !0
        }
      ]
    };
  },
  computed: {
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    userHasPermissions() {
      return this.getIsUserHasAllPermissions(["2.12"]);
    }
  },
  methods: {
    getIsFocused() {
      return this.isFocused;
    },
    remove() {
      this.$store.dispatch("panels/removePanel", { panelId: this.panel.id });
    }
  }
};
var $De = function() {
  var e = this, n = e._self._c;
  return n("Panel", { attrs: { title: "Отвал", panel: e.panel, isFocused: e.isFocused, userHasPermissions: e.userHasPermissions }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [n("PanelMenu", { attrs: { items: e.menuItems, trigger: e.menuShowed, color: "#" + e.panel.settings.color }, on: { "update:trigger": function(r) {
      e.menuShowed = r;
    }, click: function(r) {
      e.menuShowed = !e.menuShowed;
    } } })];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n("NewsDisposedList", { attrs: { panelId: e.panel.id, color: e.panel.settings.color, dateMode: e.panel.settings.dateMode, isCompact: e.panel.settings.compact, isFocused: e.getIsFocused } })];
  }, proxy: !0 }]) });
}, DDe = [], ADe = /* @__PURE__ */ B(
  NDe,
  $De,
  DDe,
  !1,
  null,
  null
);
const ODe = ADe.exports;
function uc({ newsItemIdRef: t }, e) {
  const n = {
    publicationCodes: e.getters["news/codes/publicationCodes"],
    getIsNewsItemPublished: e.getters["news/getIsNewsItemPublished"],
    getNewsItemPublishedBy: e.getters["news/getNewsItemPublishedBy"],
    getDraftForNewsItem: e.getters["news/getDraftForNewsItem"],
    isNewsItemPublishedByMe: e.getters["news/isNewsItemPublishedByMe"]
  }, r = le(() => e.state.news.drafts.publicationMap), s = le(
    () => n.getIsNewsItemPublished(t.value)
  ), i = le(
    () => n.getNewsItemPublishedBy(t.value)
  ), o = le(() => {
    var u;
    const l = (u = n.getDraftForNewsItem(t.value)) == null ? void 0 : u.id, c = Object.keys(r.value);
    return l ? c.includes(l) : !1;
  }), a = le(() => n.isNewsItemPublishedByMe(t.value));
  return {
    isPublished: s,
    publishedBy: i,
    publishMode: o,
    isPublishedByMe: a
  };
}
function Zi({ newsItemIdRef: t }, e, n = null) {
  const r = {
    newsStatusesByName: e.getters["references/newsStatusesByName"],
    getIsCurrentUserCanWork: e.getters["news/getIsCurrentUserCanWork"],
    getNewsItemCurrentVersion: e.getters["news/getNewsItemCurrentVersion"],
    getCanUserEditNewsItem: e.getters["news/getCanUserEditNewsItem"],
    getNewsItemById: e.getters["news/getNewsItemById"],
    getIsMyNewsVersion: e.getters["news/versions/getIsMyNewsVersion"],
    getCanUserEditNewsVersion: e.getters["news/versions/getCanUserEditNewsVersion"],
    getCanUserDeleteNewsVersion: e.getters["news/versions/getCanUserDeleteNewsVersion"],
    getIsRepublishDisabled: e.getters["news/versions/getIsRepublishDisabled"]
  }, s = le(() => r.getNewsItemById(t.value)), i = le(() => !n || !n.value ? r.getNewsItemCurrentVersion(t.value) : n.value), o = le(() => {
    var h;
    return (h = i == null ? void 0 : i.value) == null ? void 0 : h.type_id;
  }), a = le(
    () => r.getCanUserEditNewsItem(t.value)
  ), l = le(
    () => {
      var h, m;
      return ((h = i == null ? void 0 : i.value) == null ? void 0 : h.status_id) === ((m = r.newsStatusesByName.PUBLISHED) == null ? void 0 : m.id);
    }
  ), c = le(
    () => {
      var h;
      return r.getCanUserDeleteNewsVersion((h = i == null ? void 0 : i.value) == null ? void 0 : h.id);
    }
  ), u = le(() => {
    var h;
    return r.getIsMyNewsVersion((h = i == null ? void 0 : i.value) == null ? void 0 : h.id);
  }), d = le(
    () => r.getIsCurrentUserCanWork(t.value)
  ), f = le(
    () => r.getIsRepublishDisabled(t.value)
  ), p = le(() => s.value.status_modified_at);
  return {
    version: i,
    typeId: o,
    isEditable: a,
    isPublished: l,
    isRemovable: c,
    isMy: u,
    canWork: d,
    isRepublishDisabled: f,
    getNewsItemCurrentVersion: r.getNewsItemCurrentVersion,
    statusModifiedAt: p
  };
}
function dc({ draftRv: t, versionRv: e }, n) {
  const r = {
    newsStatuses: n.getters["references/newsStatuses"],
    getIsEmbargoFormVisible: n.getters["news/drafts/getIsEmbargoFormVisible"],
    getIsEmbargoValid: n.getters["news/drafts/getIsEmbargoValid"],
    getIsUserHasAnyPermission: n.getters["auth/getIsUserHasAnyPermission"]
  }, s = le(() => {
    var c, u, d, f;
    return ((u = r.newsStatuses[(c = e == null ? void 0 : e.value) == null ? void 0 : c.status_id]) == null ? void 0 : u.name) !== "PUBLISHED" && (!!((d = e == null ? void 0 : e.value) != null && d.publish_at) || !!((f = e == null ? void 0 : e.value) != null && f.is_postponed));
  }), i = le(() => {
    var c, u, d, f;
    return ((u = r.newsStatuses[(c = e == null ? void 0 : e.value) == null ? void 0 : c.status_id]) == null ? void 0 : u.name) === "WAITS_FOR_PUBLICATION" && (!!((d = e == null ? void 0 : e.value) != null && d.publish_at) || !!((f = e == null ? void 0 : e.value) != null && f.is_postponed));
  }), o = le(() => {
    var c;
    return (c = t == null ? void 0 : t.value) != null && c.id ? r.getIsEmbargoFormVisible(t.value.id) : s.value;
  }), a = le(() => {
    var c;
    return (c = t == null ? void 0 : t.value) != null && c.id ? r.getIsEmbargoValid(t.value.id) : !0;
  }), l = le(() => r.getIsUserHasAnyPermission(["2.9"]));
  return {
    isScheduled: s,
    isScheduledAndWaitsForPublication: i,
    isEmbargoFormVisible: o,
    isEmbargoValid: a,
    isUserHasEmbargoPermissions: l
  };
}
function FL() {
  return {
    calcOffset: ({ placement: n }) => {
      switch (n) {
        case "right-start":
          return [-20, 0];
        case "right-end":
          return [40, 0];
        case "left-end":
          return [-20, 0];
        case "left-start":
          return [-30, 0];
        default:
          return [0, 0];
      }
    },
    calcArrowPadding: ({ placement: n }) => {
      switch (n) {
        case "right-start":
          return 20;
        case "right-end":
          return -10;
        default:
          return 0;
      }
    }
  };
}
function O2(t, e) {
  return e.is_en ? !0 : e.children && e.children.length ? e.children.find((n) => O2(t, t[n])) : !1;
}
function MDe(t, e) {
  return e.children && (e.children = e.children.filter(
    (n) => O2(t, t[n])
  )), e;
}
function M2({ versionRv: t }, e) {
  const n = {
    publishMap: le(() => e.state.news.drafts.publicationMap),
    allCodes: e.getters["news/codes/allCodes"],
    publicationCodes: e.getters["news/codes/publicationCodes"],
    getIsPublicationCode: e.getters["news/codes/getIsPublicationCode"],
    getDraftForNewsItem: e.getters.getDraftForNewsItem,
    getIsNewsItemPublished: e.getters["news/getIsNewsItemPublished"],
    getNewsItemPublishedBy: e.getters["news/getNewsItemPublishedBy"]
  }, r = le(() => {
    const a = {};
    return Or(Object.values(n.publicationCodes)).filter(O2.bind(null, n.publicationCodes)).map(MDe.bind(null, n.publicationCodes)).forEach((l) => {
      a[l.id] = l;
    }), a;
  }), s = le(() => {
    var l, c;
    let a = {};
    return t.value.language_id === 2 ? a = { ...r.value } : a = { ...n.publicationCodes }, (c = (l = t == null ? void 0 : t.value) == null ? void 0 : l.codes) == null || c.forEach(({ code: u } = {}) => {
      if (n.getIsPublicationCode(u)) {
        const d = n.allCodes[u.id];
        a[u.id] = {
          ...d,
          track: [-1],
          pos: -1
        };
      }
    }), a;
  }), i = le(
    () => {
      var a;
      return ((a = t == null ? void 0 : t.value) == null ? void 0 : a.codes.map(({ code: l }) => l.id)) ?? [];
    }
  ), o = le(() => {
    var a;
    return ((a = i == null ? void 0 : i.value) == null ? void 0 : a.map((l) => s.value[l])) ?? [];
  });
  return {
    publicationCodes: n.publicationCodes,
    pickedCodesIds: i,
    pickedCodes: o,
    allCodes: s
  };
}
function RDe({ versionRv: t }, e) {
  const n = le(
    () => e.getters["news/codes/getCodesAvailableForRepublication"]
  ), { pickedCodesIds: r, pickedCodes: s, publicationCodes: i } = M2(
    { versionRv: t },
    e
  );
  return {
    pickedCodes: s,
    pickedCodesIds: r,
    publicationCodes: i,
    codesForRepublishing: n
  };
}
const LDe = {
  name: "NewsRepublishFooter",
  components: {
    PbActionsButtonGroup: Ou
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    applyAction() {
      this.$emit("apply");
    },
    cancelAction() {
      this.$emit("cancel");
    }
  }
};
var FDe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "news-republish-actions", attrs: { "data-test-selector": "news-republish-actions" } }, [n("PbActionsButtonGroup", { attrs: { disabled: e.disabled, applyFn: e.applyAction, cancelFn: e.cancelAction } })], 1);
}, BDe = [], jDe = /* @__PURE__ */ B(
  LDe,
  FDe,
  BDe,
  !1,
  null,
  null
);
const WDe = jDe.exports, HDe = "_NewsRepublishCtr_PbCodeManager_1jv1d_6", VDe = {
  "republish-popup": "_republish-popup_1jv1d_2",
  NewsRepublishCtr_PbCodeManager: HDe
}, zDe = {
  name: "NewsRepublishCtr",
  mixins: [Vr],
  components: {
    PbManagerSelectedItems: Ru,
    NewsRepublishFooter: WDe,
    PbCodeManager: Hv,
    PsKitPopup: Ls
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    visible: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "right-start"
    },
    action: {
      type: Function,
      required: !0
    },
    filterFn: {
      type: Function,
      default: () => !0
    },
    floatingOptions: {
      type: Object,
      default: () => ({})
    },
    // true только для эмбарго (по факту использования)
    onlyPublicactionCodes: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Jt("store"), n = {
      allCodes: e.getters["news/codes/allCodeItemsActual"],
      iptcCodeId: e.getters["news/codes/iptcCodeId"],
      regionsCodeId: e.getters["news/codes/regionsCodeId"],
      getIsPublicationCode: e.getters["news/codes/getIsPublicationCode"],
      getIsFeedCode: e.getters["news/codes/getIsFeedCode"]
    }, { version: r } = Zi(
      { newsItemIdRef: ts(t).newsItemId },
      e
    ), { codesForRepublishing: s, publicationCodes: i } = RDe(
      { versionRv: r },
      e
    ), { isScheduled: o, isScheduledAndWaitsForPublication: a } = dc({ versionRv: r }, e), l = le(() => {
      var h, m;
      return ((m = (h = r.value) == null ? void 0 : h.codes) == null ? void 0 : m.map(({ code: v }) => v)) ?? [];
    }), c = le(() => l.value.map(({ id: h } = {}) => h)), u = (h) => h.is_en && r.value.language_id === 1, d = (h) => h.track.includes(n.iptcCodeId) || h.track.includes(n.regionsCodeId) ? !0 : !h.children || !h.children.length, { calcOffset: f, calcArrowPadding: p } = FL();
    return {
      ...n,
      publishingCodes: t.onlyPublicactionCodes ? i : s,
      // .../api/v1/codes/profile/?type_id=1
      usedCodes: l,
      usedCodeIds: c,
      checkDisabled: u,
      isSelectable: d,
      isScheduled: o,
      calcOffset: f,
      calcArrowPadding: p,
      isScheduledAndWaitsForPublication: a
    };
  },
  data() {
    return {
      /* у переменной pickedCodes здесь два предназначения:
         1. Чтобы сравнивать выбранные коды с теми, которые уже есть в версии (usedCodes), и правильно определять, что были внесены изменения в коды (переменная hasChanges)
         2. Для отображения в интерфейсе того, что коды выбраны в дереве и в компоненте PbManagerSelectedItems
         Из-за этого возникает баг - нам нужно, чтобы pickedCodes всегда включала в себя usedCodes для правильного определения изменений, но при этом, если новость не под эмбарго, то в pickedCodes включать usedCodes не нужно, чтобы их не отображать.
         Возможный выход - разделить эту переменную на две для двух разных предназначений  */
      pickedCodes: this.isScheduled ? [...this.usedCodes] : [],
      loading: !1
    };
  },
  computed: {
    isDisabledApply() {
      return !this.hasChanges || this.loading || !this.hasPublicationCodes;
    },
    pickedCodesIds() {
      return this.pickedCodes.map((t) => t.id);
    },
    visiblePickedCodes() {
      return this.pickedCodes.filter((t) => this.publishingCodes[t.id]);
    },
    visiblePickedCodesIds() {
      return this.visiblePickedCodes.map((t) => t.id);
    },
    pickedCodesWithState() {
      return this.visiblePickedCodesIds.map((t) => ({ id: t, state: "included" }));
    },
    hasChanges() {
      return !$a(
        // новые выбранные
        [...this.pickedCodesIds].sort((t, e) => Number(t) - Number(e)),
        // из версии новости
        this.usedCodeIds.filter((t) => !!this.publishingCodes[t]).sort((t, e) => Number(t) - Number(e))
      );
    },
    hasPublicationCodes() {
      return [...this.pickedCodesIds, ...this.usedCodeIds].reduce(
        (t, e) => t || this.getIsPublicationCode(this.allCodes[e]) || this.getIsFeedCode(this.allCodes[e]) || this.isSubFeed(e),
        !1
      );
    },
    visibleCodes() {
      return Object.values(this.publishingCodes).reduce((t, e) => (this.filterFn(e) && !this.usedCodes.find((n) => n.id === e.id) && (t[e.id] = e), t), {});
    },
    noItemsText() {
      return this.isScheduledAndWaitsForPublication ? "Добавьте коды, чтобы продолжить" : "Коды не выбраны";
    }
  },
  methods: {
    isSubFeed(t) {
      var e;
      return ((e = this.allCodes[t]) == null ? void 0 : e.path.startsWith("907")) ?? !1;
    },
    addPubCode(t) {
      const e = this.allCodes[t];
      e && (this.pickedCodes = this.pickedCodes.concat([e]));
    },
    deletePubCode(t) {
      const e = this.pickedCodes.findIndex((n) => n.id === t);
      e !== -1 && this.pickedCodes.splice(e, 1);
    },
    async apply() {
      this.loading = !0;
      const t = await this.action({
        id: this.newsItemId,
        codeIds: [...this.pickedCodesIds]
      });
      if (this.loading = !1, t.errors) {
        this.pickedCodes = this.usedCodes.filter(
          ({ id: e }) => this.publishingCodes[e]
        );
        return;
      }
      this.$emit("hide");
    }
  }
};
var UDe = function() {
  var e = this, n = e._self._c;
  return n("PsKitPopup", { attrs: { classPopup: [e.$style["republish-popup"]], placement: e.position, visible: e.visible, floatingOptions: e.floatingOptions }, on: { hide: function(r) {
    return e.$emit("hide");
  } }, scopedSlots: e._u([{ key: "default", fn: function() {
    return [n("PbCodeManager", { class: e.$style.NewsRepublishCtr_PbCodeManager, attrs: { allCodes: e.allCodes, visibleCodes: e.visibleCodes, pickedCodes: e.pickedCodesIds, isSelectable: e.isSelectable, checkDisabled: e.checkDisabled, maxHeight: 500, disabledReason: "Неподходящий язык новости" }, on: { codeAdded: e.addPubCode, codeDeleted: e.deletePubCode }, scopedSlots: e._u([{ key: "prefooter", fn: function() {
      return [n("PbManagerSelectedItems", { attrs: { items: e.allCodes, availableItems: e.publishingCodes, selectedItems: e.pickedCodesWithState, title: "Добавленные коды", labels: ["name"], isRemovable: !0, noItemsText: e.noItemsText, isNoItemsWarn: e.isScheduledAndWaitsForPublication }, on: { remove: e.deletePubCode } })];
    }, proxy: !0 }]) })];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [n("NewsRepublishFooter", { attrs: { disabled: e.isDisabledApply }, on: { apply: e.apply, cancel: function(r) {
      return e.$emit("hide");
    } } })];
  }, proxy: !0 }]) });
}, GDe = [];
const sN = {
  $style: VDe
};
function YDe(t) {
  for (var e in sN)
    this[e] = sN[e];
}
var ZDe = /* @__PURE__ */ B(
  zDe,
  UDe,
  GDe,
  !1,
  YDe,
  null
);
const Uf = ZDe.exports;
function XDe({ store: t, newsItemIdRef: e }) {
  const n = {
    getIsUserHasAnyPermission: t.getters["auth/getIsUserHasAnyPermission"],
    getIsNewsItemExpired: t.getters["news/getIsNewsItemExpired"],
    getIsEmbargoEditable: t.getters["news/getIsEmbargoEditable"],
    getDraftForNewsItem: t.getters["news/getDraftForNewsItem"],
    getIsCurrentUserCanWork: t.getters["news/getIsCurrentUserCanWork"],
    getIsMyNewsVersion: t.getters["news/versions/getIsMyNewsVersion"],
    getIsMyDraft: t.getters["news/drafts/getIsMyDraft"]
  }, r = le(
    () => n.getIsNewsItemExpired(e.value)
  ), { isPublishedByMe: s } = uc({ newsItemIdRef: e }, t);
  return {
    isEditable: le(() => {
      const o = n.getDraftForNewsItem(e.value);
      return n.getIsEmbargoEditable(e.value) && n.getIsMyNewsVersion(e.value) || o && n.getIsMyDraft(o.id) || s.value || n.getIsUserHasAnyPermission(["2.9"]);
    }),
    isPublishedByMe: s,
    isEmbargoExpired: r
  };
}
const KDe = {
  components: {
    PbButton: nt
  },
  props: {
    isEditable: {
      type: Boolean,
      default: !1
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    isRemovable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["removeEmbargo"]
};
var JDe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-embargo-widget__info" }, [n("div", { staticClass: "pb-embargo-widget__title", attrs: { "data-test-selector": "embargo-form-title" } }, [n("icon", { attrs: { name: "embargo", color: "#a07368", size: 18 } }), n("span", [e._v("Эмбарго")])], 1), n("div", { staticClass: "pb-embargo-widget__actions" }, [e._t("default"), e.isRemovable && !e.isOpen ? n("PbButton", { staticClass: "pb-embargo-widget__remove", on: { click: function(r) {
    return e.$emit("removeEmbargo");
  } } }, [n("icon", { attrs: { name: "trash", color: "#a07368", size: 18 } })], 1) : e._e()], 2)]);
}, qDe = [], QDe = /* @__PURE__ */ B(
  KDe,
  JDe,
  qDe,
  !1,
  null,
  "398e8ce9"
);
const eAe = QDe.exports, tAe = {
  components: {
    PbDateWidget: Hr
  },
  props: {
    publishAt: {
      type: [String, null],
      default: null
    },
    isPostponed: {
      type: Boolean,
      default: !1
    },
    isEditable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["formOpened", "formClosed"],
  setup(t, e) {
    return {
      openForm: () => {
        t.isEditable && e.emit("formOpened");
      },
      closeForm: () => {
        e.emit("formClosed");
      },
      setPostponed: () => {
        e.emit("setPostponed");
      },
      openPicker: () => {
        e.emit("openPicker");
      }
    };
  }
};
var nAe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "mode-buttons-wrapper" }, [n("div", { class: { "mode-button": !0, editable: e.isEditable, datetime: !0 }, on: { click: e.openForm } }, [e.isPostponed || e.publishAt === null ? [e._v("До звонка")] : [n("PbDateWidget", { attrs: { date: e.publishAt, moscowTime: !0 }, on: { dateModeChanged: e.openForm } })]], 2)]);
}, rAe = [], sAe = /* @__PURE__ */ B(
  tAe,
  nAe,
  rAe,
  !1,
  null,
  "2711cbab"
);
const iAe = sAe.exports, oAe = {
  props: {
    dateTime: {
      type: String,
      required: !0
    },
    isPostponed: {
      type: Boolean,
      default: !1
    },
    isEditable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["formClosed", "postponed", "openPicker"],
  setup(t, e) {
    const n = le(() => t.dateTime ? on(Tr(t.dateTime), "dd MMMM yyyy", { locale: xn }) : ""), r = le(() => n.value.split(" ")[0] || "-"), s = le(() => n.value.split(" ")[1] || "-"), i = le(() => Rf(Tr(t.dateTime)) ? null : n.value.split(" ")[2]);
    return Io(() => {
      e.emit("mounted");
    }), {
      selectedDay: r,
      selectedMonth: s,
      nextYear: i
    };
  }
};
var aAe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-embargo-date-view" }, [n("div", { class: { "date-view": !0, disabled: e.isPostponed }, on: { click: function(r) {
    return e.$emit("openPicker");
  } } }, [n("span", { staticClass: "date-day" }, [e._v(" " + e._s(e.selectedDay) + " ")]), n("span", { staticClass: "date-month" }, [e._v(" " + e._s(e.selectedMonth) + " ")]), e.nextYear ? n("span", { staticClass: "date-year" }, [e._v(" " + e._s(e.nextYear) + " ")]) : e._e(), e._t("datepicker")], 2), n("div", { class: { time: !0, disabled: e.isPostponed } }, [e._t("timepicker")], 2), n("span", { staticClass: "time-tooltip" }, [n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Дата и время указываются по Москве", expression: "'Дата и время указываются по Москве'" }], attrs: { type: "font", name: "info", size: 18 } })], 1)]);
}, lAe = [], cAe = /* @__PURE__ */ B(
  oAe,
  aAe,
  lAe,
  !1,
  null,
  "35d39c69"
);
const uAe = cAe.exports, dAe = {
  components: {
    PbButton: nt
  },
  props: {
    date: {
      type: String,
      required: !0
    }
  },
  emits: ["close", "apply", "update"],
  setup(t, e) {
    const n = et(null);
    return {
      dateLocal: le({
        get() {
          return t.date;
        },
        set(o) {
          e.emit("update", o);
        }
      }),
      datepicker: n,
      handleBackClick: () => {
        const o = n.value.$refs.calendar;
        o.showPageRange(go(o.getPageDays()[0].date, 20));
      },
      handleForwardClick: () => {
        const o = n.value.$refs.calendar;
        o.showPageRange(
          gS(o.getPageDays()[0].date, 2 * 20)
        );
      }
    };
  }
};
var fAe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-embargo-datepicker" }, [n("div", { staticClass: "arrows-container" }, [n("PbButton", { staticClass: "arrow arrow-back", attrs: { "data-test-selector": "datepicker-back-btn" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.handleBackClick.apply(null, arguments);
  } } }, [n("icon", { staticClass: "arrow-icon", attrs: { name: "triangle-right", size: "7", color: "#848484" } })], 1), n("PbButton", { staticClass: "arrow arrow-forward", attrs: { "data-test-selector": "datepicker-forward-btn" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.handleForwardClick.apply(null, arguments);
  } } }, [n("icon", { staticClass: "arrow-icon", attrs: { name: "triangle-right", size: "7", color: "#848484" } })], 1)], 1), n("v-date-picker", { ref: "datepicker", attrs: { isRange: !1, "title-position": "left", locale: "ru-RU", "min-date": /* @__PURE__ */ new Date() }, scopedSlots: e._u([{ key: "header-left-button", fn: function() {
    return [e._v(" ")];
  }, proxy: !0 }, { key: "header-right-button", fn: function() {
    return [e._v(" ")];
  }, proxy: !0 }]), model: { value: e.dateLocal, callback: function(r) {
    e.dateLocal = r;
  }, expression: "dateLocal" } })], 1);
}, pAe = [], hAe = /* @__PURE__ */ B(
  dAe,
  fAe,
  pAe,
  !1,
  null,
  null
);
const mAe = hAe.exports, vAe = {
  name: "PbDefaultButton",
  components: {
    PbButton: nt
  },
  props: {
    type: {
      type: String,
      default: "default",
      validator: (t) => ["default", "primary"].includes(t)
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
};
var gAe = function() {
  var e = this, n = e._self._c;
  return n("PbButton", { class: { "pb-default-button": !0, [e.type]: !0 }, attrs: { disabled: e.disabled }, on: { click: function(r) {
    return e.$emit("click", r);
  } } }, [e._t("default")], 2);
}, yAe = [], bAe = /* @__PURE__ */ B(
  vAe,
  gAe,
  yAe,
  !1,
  null,
  "9849709e"
);
const BL = bAe.exports, _Ae = {
  name: "PbSimpleApply",
  components: {
    PbDefaultButton: BL
  },
  props: {
    applyDisabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, e) {
    return {
      apply: () => e.emit("apply"),
      cancel: () => e.emit("cancel")
    };
  }
};
var wAe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-simple-apply" }, [n("PbDefaultButton", { attrs: { disabled: e.applyDisabled, type: "primary" }, on: { click: e.apply } }, [e._v("Применить")]), n("PbDefaultButton", { on: { click: e.cancel } }, [e._v("Отмена")])], 1);
}, SAe = [], IAe = /* @__PURE__ */ B(
  _Ae,
  wAe,
  SAe,
  !1,
  null,
  "d19a67f5"
);
const jL = IAe.exports;
function EAe({ inputs: t, timeRv: e, isDropdownVisibleRef: n }) {
  const r = {
    start: null,
    end: null
  }, s = (o) => {
    var a, l, c;
    o.stopPropagation(), o.preventDefault(), (a = t.hours.value) == null || a.blur(), (l = t.minutes.value) == null || l.blur(), (c = t.seconds.value) == null || c.blur(), Object.keys(e).forEach((u) => {
      e[u] === null && (e[u] = "00");
    }), n.value = !1;
  };
  return {
    onKeydown: (o) => {
      var a, l, c, u, d, f, p, h, m, v, y, _, w, S, E, x;
      if (r.start = o.target.selectionStart, r.end = o.target.selectionEnd, o.key === "ArrowRight" || o.key === "ArrowLeft") {
        const T = o.target.name, C = e[T];
        if (o.key === "ArrowRight" && r.start === r.end && r.end === (C == null ? void 0 : C.toString().length))
          switch (o.stopPropagation(), o.preventDefault(), T) {
            case "hours":
              (a = t.minutes.value) == null || a.focus(), (l = t.minutes.value) == null || l.setSelectionRange(0, 0);
              break;
            case "minutes":
              (c = t.seconds.value) == null || c.focus(), (u = t.seconds.value) == null || u.setSelectionRange(0, 0);
              break;
          }
        if (o.key === "ArrowLeft" && o.target.selectionEnd === 0)
          switch (o.stopPropagation(), o.preventDefault(), T) {
            case "seconds":
              (d = t.minutes.value) == null || d.focus(), (v = t.minutes.value) == null || v.setSelectionRange(
                (p = (f = t.minutes) == null ? void 0 : f.value) == null ? void 0 : p.value.length,
                (m = (h = t.minutes) == null ? void 0 : h.value) == null ? void 0 : m.value.length
              );
              break;
            case "minutes":
              (y = t.hours.value) == null || y.focus(), (x = t.hours.value) == null || x.setSelectionRange(
                (w = (_ = t.hours) == null ? void 0 : _.value) == null ? void 0 : w.value.length,
                (E = (S = t.hours) == null ? void 0 : S.value) == null ? void 0 : E.value.length
              );
              break;
          }
      }
      o.key === "Enter" && s(o);
    }
  };
}
const xAe = {
  components: {
    PsKitPopup: Ls
  },
  props: {
    visible: {
      type: Boolean,
      required: !0
    },
    hours: {
      type: [String, Number],
      default: 0
    },
    minutes: {
      type: [String, Number],
      default: 0
    },
    seconds: {
      type: [String, Number],
      default: 0
    }
  },
  emits: ["select", "hide"],
  setup(t, { emit: e }) {
    return {
      select: (r, s) => {
        e("select", { type: r, value: s });
      }
    };
  }
};
var CAe = function() {
  var e = this, n = e._self._c;
  return e.visible ? n("PsKitPopup", { ref: "dropdown", attrs: { arrowVisible: !1, visible: e.visible, classPopup: "pskit-timepicker-dropdown", classPopupBody: "pskit-timepicker-dropdown-body", floatingOptions: { offset: { mainAxis: 2, crossAxis: 0 } }, placement: "bottom-start" }, on: { hide: function(r) {
    return e.$emit("hide");
  } } }, [n("div", { staticClass: "pskit-timepicker-list-wrapper" }, [n("ul", { ref: "hoursList", staticClass: "pskit-timepicker-list", attrs: { "data-test-selector": "timepicker-list-hours" } }, e._l(24, function(r) {
    return n("li", { key: r, class: {
      "pskit-timepicker-list-item": !0,
      active: r - 1 === parseInt(e.hours)
    }, attrs: { "data-test-selector": "timepicker-list-hours-item", "data-test-attrs": r }, on: { "!click": function(s) {
      return s.stopPropagation(), e.select("hours", r - 1);
    } } }, [e._v(" " + e._s(r - 1) + " ")]);
  }), 0), n("ul", { staticClass: "pskit-timepicker-list", attrs: { "data-test-selector": "timepicker-list-minutes" } }, e._l(60, function(r) {
    return n("li", { key: r, class: {
      "pskit-timepicker-list-item": !0,
      active: r - 1 === parseInt(e.minutes)
    }, attrs: { "data-test-selector": "timepicker-list-minutes-item", "data-test-attrs": r }, on: { "!click": function(s) {
      return s.stopPropagation(), e.select("minutes", r - 1);
    } } }, [e._v(" " + e._s(r - 1) + " ")]);
  }), 0), n("ul", { staticClass: "pskit-timepicker-list", attrs: { "data-test-selector": "timepicker-list-seconds" } }, e._l(60, function(r) {
    return n("li", { key: r, class: {
      "pskit-timepicker-list-item": !0,
      active: r - 1 === parseInt(e.seconds)
    }, attrs: { "data-test-selector": "timepicker-list-seconds-item", "data-test-attrs": r }, on: { "!click": function(s) {
      return s.stopPropagation(), e.select("seconds", r - 1);
    } } }, [e._v(" " + e._s(r - 1) + " ")]);
  }), 0)])]) : e._e();
}, TAe = [], PAe = /* @__PURE__ */ B(
  xAe,
  CAe,
  TAe,
  !1,
  null,
  null
);
const kAe = PAe.exports, NAe = {
  components: {
    Dropdown: kAe
  },
  emits: ["input"],
  props: {
    value: {
      type: [String, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { emit: e }) {
    const n = et(!1), r = Xn({
      hours: null,
      minutes: null,
      seconds: null
    }), s = Xn({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), i = le(() => Object.values(s).includes(!0)), o = et(null), a = et(null), l = et(null), c = (T) => {
      T.split("T")[1].split(":").forEach((C, k) => {
        r[Object.keys(r)[k]] = C;
      });
    };
    t.value && c(t.value);
    const u = () => {
      e(
        "change",
        Object.values(r).filter((T) => !!T).join(":")
      );
    }, d = (T, C, k, b) => {
      if (b === "")
        return null;
      if (b.length > 2) return !1;
      const P = parseInt(b);
      return !/^\d+$/g.test(b) || P === r[k] ? !1 : P >= T && P <= C ? b : !1;
    }, f = le({
      get() {
        return r.hours;
      },
      set(T) {
        const C = d(0, 23, "hours", T);
        C !== !1 && (r.hours = C);
      }
    }), p = le({
      get() {
        return r.minutes;
      },
      set(T) {
        const C = d(0, 59, "minutes", T);
        C !== !1 && (r.minutes = C);
      }
    }), h = le({
      get() {
        return r.seconds;
      },
      set(T) {
        const C = d(0, 59, "seconds", T);
        C !== !1 && (r.seconds = C);
      }
    }), m = {
      hours: f,
      minutes: p,
      seconds: h
    }, v = {
      hours: o,
      minutes: a,
      seconds: l
    }, y = (T) => {
      T.isTrusted && (T.target.value = r[T.target.name]);
    }, _ = (T) => {
      s[T.target.name] = !0;
    }, w = (T) => {
      s[T.target.name] = !1;
    }, { onKeydown: S } = EAe({
      inputs: v,
      timeRv: r,
      isDropdownVisibleRef: n
    }), E = () => {
      i.value || (n.value = !1);
    }, x = ({ type: T, value: C }) => {
      var k, b;
      m[T].value = C, (b = (k = v[T]) == null ? void 0 : k.value) == null || b.focus();
    };
    return Rw(() => {
      Object.keys(r).forEach((T) => {
        var C;
        s[T] === !1 && ((C = r[T]) == null ? void 0 : C.toString().length) === 1 && (r[T] = "0" + r[T]);
      });
    }), or(
      () => t.value,
      (T, C) => {
        T !== C && (Object.values(r).filter((k) => !!k).reduce((k, b) => b || null, null) || c(T));
      }
    ), or(i, (T, C) => {
      T !== C && (T === !0 && (n.value = T), T === !1 && Object.values(r).filter((k) => k !== null).length === 3 && u());
    }), or(n, (T, C) => {
      T !== C && T === !1 && Object.values(r).filter((k) => k !== null).length === 3 && u();
    }), {
      hours: f,
      minutes: p,
      seconds: h,
      isDropdownVisible: n,
      hoursInput: o,
      minutesInput: a,
      secondsInput: l,
      onInput: y,
      onFocus: _,
      onBlur: w,
      onKeydown: S,
      hideDropdown: E,
      select: x
    };
  }
};
var $Ae = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pskit-timepicker" }, [n("div", [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.hours, expression: "hours" }], ref: "hoursInput", attrs: { type: "text", name: "hours", placeholder: "--", autocomplete: "off", disabled: e.disabled }, domProps: { value: e.hours }, on: { input: [function(r) {
    r.target.composing || (e.hours = r.target.value);
  }, function(r) {
    return r.preventDefault(), r.stopPropagation(), e.onInput.apply(null, arguments);
  }], focus: e.onFocus, blur: e.onBlur, keydown: e.onKeydown } }), n("span", [e._v(":")]), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.minutes, expression: "minutes" }], ref: "minutesInput", attrs: { type: "text", name: "minutes", placeholder: "--", autocomplete: "off", disabled: e.disabled }, domProps: { value: e.minutes }, on: { input: [function(r) {
    r.target.composing || (e.minutes = r.target.value);
  }, function(r) {
    return r.preventDefault(), r.stopPropagation(), e.onInput.apply(null, arguments);
  }], focus: e.onFocus, blur: e.onBlur, keydown: e.onKeydown } }), n("span", [e._v(":")]), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.seconds, expression: "seconds" }], ref: "secondsInput", attrs: { type: "text", name: "seconds", placeholder: "--", autocomplete: "off", disabled: e.disabled }, domProps: { value: e.seconds }, on: { input: [function(r) {
    r.target.composing || (e.seconds = r.target.value);
  }, function(r) {
    return r.preventDefault(), r.stopPropagation(), e.onInput.apply(null, arguments);
  }], focus: e.onFocus, blur: e.onBlur, keydown: e.onKeydown } })]), n("Dropdown", { attrs: { visible: e.isDropdownVisible, hours: e.hours, minutes: e.minutes, seconds: e.seconds }, on: { select: e.select, hide: e.hideDropdown } })], 1);
}, DAe = [], AAe = /* @__PURE__ */ B(
  NAe,
  $Ae,
  DAe,
  !1,
  null,
  null
);
const OAe = AAe.exports, MAe = "_root_1wf0d_1", RAe = "_title_1wf0d_6", LAe = "_footer_1wf0d_11", FAe = "_btn_1wf0d_17", BAe = {
  root: MAe,
  title: RAe,
  footer: LAe,
  btn: FAe
}, jAe = {
  name: "DialogConfirmEmbargo",
  components: {
    PbModal: Au,
    PbButton: nt
  },
  props: {
    state: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: Number,
      default: 280
    },
    applyButtonLabel: {
      type: String,
      default: "Подтвердить эмбарго"
    },
    resetButtonLabel: {
      type: String,
      default: "Cбросить эмбарго"
    }
  },
  methods: {
    apply() {
      this.$emit("apply"), this.close();
    },
    reset() {
      this.$emit("reset"), this.close();
    },
    ignore() {
      this.$emit("ignore"), this.close();
    },
    close() {
      this.$emit("update:state", !1);
    }
  }
};
var WAe = function() {
  var e = this, n = e._self._c;
  return n("PbModal", { attrs: { state: e.state, maxWidth: e.maxWidth, hasHeader: !0, closeOnOverlayClick: !1 }, on: { close: e.ignore } }, [n("div", { class: e.$style.root }, [n("div", { class: e.$style.title }, [e._t("question")], 2), n("div", { class: e.$style.footer }, [n("PbButton", { class: [e.$style.btn, e.$style.btn_primary], on: { click: e.apply } }, [e._v(" " + e._s(e.applyButtonLabel) + " ")]), n("PbButton", { class: e.$style.btn, on: { click: e.reset } }, [e._v(" " + e._s(e.resetButtonLabel) + " ")])], 1)])]);
}, HAe = [];
const iN = {
  $style: BAe
};
function VAe(t) {
  for (var e in iN)
    this[e] = iN[e];
}
var zAe = /* @__PURE__ */ B(
  jAe,
  WAe,
  HAe,
  !1,
  VAe,
  null
);
const UAe = zAe.exports, GAe = {
  components: {
    PbEmbargoInfo: eAe,
    PbEmbargoModeButtons: iAe,
    PbEmbargoDateTimeForm: uAe,
    PbEmbargoDatepicker: mAe,
    PbCheckboxLabeled: qa,
    PsKitTimepicker: OAe,
    PsKitPopup: Ls,
    PbSimpleApply: jL,
    DialogConfirmEmbargo: UAe
  },
  props: {
    isEditable: {
      type: Boolean,
      default: !0
    },
    publishAt: {
      type: [String, null],
      default: null
    },
    isRemovable: {
      type: Boolean,
      default: !0
    },
    isPostponed: {
      type: Boolean,
      default: !1
    },
    autoOpen: {
      type: Boolean,
      default: !1
    },
    isConfirmDialogOpen: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "setPostponed",
    "setEmbargo",
    "removeEmbargo",
    "formClosed",
    "datePickerOpened",
    "ignoreNotSaved",
    "closeConfirmDialog",
    "setNotSaved"
  ],
  setup(t, e) {
    const n = et(
      t.isEditable && !(t.publishAt !== null || t.isPostponed)
    ), r = et(!1), s = et(t.publishAt), i = et(t.isPostponed), o = {
      shift: {
        mainAxis: !1,
        crossAxis: !1
      }
    }, a = le({
      get() {
        var k;
        return ((k = n.value ? s.value : t.publishAt) == null ? void 0 : k.split(
          "+"
        )[0]) ?? "";
      },
      set(k) {
        k ? s.value = k : s.value = null;
      }
    }), l = et(null), c = setInterval(() => {
      l.value = /* @__PURE__ */ new Date();
    }, 1e3);
    Nf(() => {
      clearInterval(c);
    });
    const u = le(() => !i.value && Iee(b0.zonedTimeToUtc(a.value, "Europe/Moscow"))), d = le(
      () => !!a.value || t.isPostponed
    ), f = le(
      () => !!s.value || i.value
    ), p = le({
      get() {
        return t.isConfirmDialogOpen;
      },
      set() {
        e.emit("closeConfirmDialog");
      }
    }), h = le(() => {
      let k;
      return i.value ? k = "звонка" : s.value && (k = on(new Date(s.value), "dd-MM-yyyy HH:mm:ss")), `Для новости задано эмбарго до ${k}`;
    });
    Io(() => {
      t.autoOpen && (n.value = !0);
    }), or(
      () => f.value,
      (k) => {
        e.emit("setNotSaved", k);
      }
    );
    const m = () => {
      n.value = !1, r.value = !1, s.value = null, e.emit("setNotSaved", !1);
    }, v = (k) => {
      const b = a.value ? on(new Date(a.value), "HH:mm:ssXXX") : "00:00:00", P = on(new Date(k), "yyyy-MM-dd");
      a.value = `${P}T${b}`, r.value = !1;
    }, y = (k) => {
      let b;
      a.value ? b = on(new Date(a.value), "yyyy-MM-dd") : b = Go(/* @__PURE__ */ new Date(), "yyyy-MM-dd"), (k == null ? void 0 : k.split(":").length) === 3 && (a.value = `${b}T${k}`);
    }, _ = () => {
      if (t.isPostponed) {
        n.value = !1;
        return;
      }
      const k = Rw(() => {
        t.isPostponed && (n.value = !1, k());
      });
      e.emit("setPostponed", !0);
    };
    return {
      isOpen: n,
      pickerIsOpen: r,
      popupFloatingOptions: o,
      dateTime: a,
      internalPostponed: i,
      embargoSet: d,
      wrongTime: u,
      internalConfirmOpen: p,
      confirmQuestion: h,
      setPostponed: _,
      applyEmbargo: () => {
        if (i.value)
          _();
        else {
          if (l.value = /* @__PURE__ */ new Date(), u.value) return;
          e.emit("setEmbargo", a.value + "+03:00");
        }
        m(), e.emit("formClosed");
      },
      openForm: () => {
        n.value = !0, t.publishAt !== a.value && (a.value = t.publishAt), i.value = t.isPostponed;
      },
      closeForm: () => {
        m(), d.value === !1 ? e.emit("removeEmbargo") : e.emit("formClosed");
      },
      updateDate: v,
      updateTime: y,
      openPicker: () => {
        i.value || (r.value = !0);
      },
      closePicker: () => {
        r.value = !1;
      },
      onDatePickerVisible: ({ id: k }) => {
        e.emit("datePickerOpened", { id: k });
      }
    };
  }
};
var YAe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-embargo-widget" }, [n("PbEmbargoInfo", { attrs: { isPostponed: e.isPostponed, isEditable: e.isEditable, isRemovable: e.isRemovable, isOpen: e.isOpen }, on: { removeEmbargo: function(r) {
    return e.$emit("removeEmbargo");
  } }, model: { value: e.dateTime, callback: function(r) {
    e.dateTime = r;
  }, expression: "dateTime" } }, [e.isOpen ? [n("PbEmbargoDateTimeForm", { attrs: { dateTime: e.dateTime, isEditable: e.isEditable, isPostponed: e.internalPostponed }, on: { formClosed: e.closeForm, openPicker: e.openPicker }, scopedSlots: e._u([{ key: "datepicker", fn: function() {
    return [e.pickerIsOpen ? n("PsKitPopup", { attrs: { visible: e.pickerIsOpen, placement: "bottom-start", arrowVisible: !0, floatingOptions: e.popupFloatingOptions }, on: { hide: e.closePicker, visible: e.onDatePickerVisible } }, [n("PbEmbargoDatepicker", { attrs: { date: e.dateTime }, on: { update: e.updateDate, close: e.closePicker, apply: e.applyEmbargo } })], 1) : e._e()];
  }, proxy: !0 }, { key: "timepicker", fn: function() {
    return [n("PsKitTimepicker", { attrs: { value: e.dateTime, withSeconds: !0, disabled: e.internalPostponed }, on: { change: e.updateTime } })];
  }, proxy: !0 }], null, !1, 3634187785) }), n("PbCheckboxLabeled", { staticClass: "pb-embargo-widget-postopone-button", attrs: { label: "До звонка" }, model: { value: e.internalPostponed, callback: function(r) {
    e.internalPostponed = r;
  }, expression: "internalPostponed" } })] : [n("PbEmbargoModeButtons", { attrs: { publishAt: e.publishAt, isPostponed: e.isPostponed, isEditable: e.isEditable }, on: { formOpened: e.openForm } })]], 2), e.wrongTime ? n("div", { staticClass: "datetime-error" }, [e._v(" Время публикации должно быть в будущем. ")]) : e._e(), e.isOpen ? [n("div", { staticClass: "footer" }, [n("PbSimpleApply", { attrs: { applyDisabled: e.wrongTime || !e.dateTime && !e.internalPostponed }, on: { cancel: e.closeForm, apply: e.applyEmbargo } })], 1)] : e._e(), n("DialogConfirmEmbargo", { attrs: { state: e.internalConfirmOpen, maxWidth: 400, acceptButtonLabel: "Подтвердить эмбарго", declineButtonLabel: "Cбросить эмбарго" }, on: { "update:state": function(r) {
    e.internalConfirmOpen = r;
  }, apply: e.applyEmbargo, reset: e.closeForm, ignore: function(r) {
    return e.$emit("ignoreNotSaved");
  } }, scopedSlots: e._u([{ key: "question", fn: function() {
    return [e._v(" " + e._s(e.confirmQuestion) + " ")];
  }, proxy: !0 }]) })], 2);
}, ZAe = [], XAe = /* @__PURE__ */ B(
  GAe,
  YAe,
  ZAe,
  !1,
  null,
  null
);
const WL = XAe.exports, KAe = {
  name: "NewsItemEmbargoCtr",
  components: {
    PbEmbargoWidget: WL
  },
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    isDraft: {
      type: Boolean,
      default: !1
    },
    autoOpen: {
      type: Boolean,
      default: !1
    },
    isRemovable: {
      type: Boolean,
      default: !0
    },
    isEditable: {
      type: Boolean,
      default: !0
    },
    inPopup: {
      type: Boolean,
      default: !1
    },
    isEmbargoConfirmOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, e) {
    const n = Jt("store"), r = {
      getDraftForNewsItem: n.getters["news/getDraftForNewsItem"]
    }, s = {
      rescheduleNewsItem: (...v) => n.dispatch("news/rescheduleNewsItem", ...v),
      updateEmbargo: (...v) => n.dispatch("news/drafts/updateEmbargo", ...v),
      updatePostponed: (...v) => n.dispatch("news/drafts/updatePostponed", ...v),
      saveDraft: (...v) => n.dispatch("news/drafts/saveDraft", ...v)
    }, i = le(() => t.newsItemId), o = le(() => t.version), {
      isEditable: a,
      isPublishedByMe: l,
      isEmbargoExpired: c
    } = XDe({
      store: n,
      newsItemIdRef: i
    }), u = le(
      () => t.isEditable && a.value
    ), d = async (v) => {
      t.isDraft ? (await s.updatePostponed({
        newsItemId: t.newsItemId,
        value: v
      }), s.saveDraft({ newsItemId: t.newsItemId })) : await s.rescheduleNewsItem({
        paramsList: [
          {
            id: t.newsItemId,
            is_postponed: v,
            publish_at: null
          }
        ]
      }), e.emit("postponed");
    }, f = (v) => {
      t.isDraft ? (s.updateEmbargo({
        newsItemId: t.newsItemId,
        value: v
      }), s.saveDraft({ newsItemId: t.newsItemId })) : s.rescheduleNewsItem({
        paramsList: [
          {
            id: t.newsItemId,
            is_postponed: !1,
            publish_at: v
          }
        ]
      }), e.emit("embargoSet");
    }, p = () => {
      t.isDraft && (f(null), d(!1)), e.emit("removeEmbargo");
    }, { isEmbargoValid: h } = dc(
      {
        versionRv: o,
        draftRv: t.isDraft ? le(() => r.getDraftForNewsItem) : null
      },
      n
    );
    return {
      embaroIsEditable: u,
      isEmbargoValid: h,
      isPublishedByMe: l,
      itemId: i,
      isEmbargoExpired: c,
      setEmbargo: f,
      setPostponed: d,
      cancel: () => {
        !o.value.publish_at && o.value.is_postponed === !1 && e.emit("removeEmbargo");
      },
      removeEmbargo: p
    };
  }
};
var JAe = function() {
  var e = this, n = e._self._c;
  return n("PbEmbargoWidget", { class: { "embargo-form": !0, "in-popup": e.inPopup }, attrs: { isEditable: e.embaroIsEditable, isRemovable: e.isRemovable, publishAt: e.version.publish_at, isPostponed: e.version.is_postponed, autoOpen: e.autoOpen, isConfirmDialogOpen: e.isEmbargoConfirmOpen }, on: { setPostponed: e.setPostponed, setEmbargo: e.setEmbargo, setNotSaved: function(r) {
    return e.$emit("setNotSaved", r);
  }, ignoreNotSaved: function(r) {
    return e.$emit("ignoreNotSaved");
  }, removeEmbargo: e.removeEmbargo, formClosed: function(r) {
    return e.$emit("formClosed");
  }, closeConfirmDialog: function(r) {
    return e.$emit("closeEmbargoConfirm");
  }, datePickerOpened: function(r) {
    return e.$emit("datePickerOpened", r);
  } } });
}, qAe = [], QAe = /* @__PURE__ */ B(
  KAe,
  JAe,
  qAe,
  !1,
  null,
  null
);
const Fu = QAe.exports, eOe = {
  name: "PsKitPopupDialog",
  components: {
    PsKitPopup: Ls,
    PbDefaultButton: BL
  },
  props: {
    placement: {
      type: String,
      default: "right-start"
    },
    visible: {
      type: Boolean,
      default: !1
    },
    classPopup: {
      type: Array,
      default: () => []
    },
    floatingOptions: {
      type: Object,
      default: () => ({})
    },
    buttons: {
      // [ {type: primary|default, onclick: Function, text: String}, ...]
      type: Array,
      default: () => []
    }
  }
};
var tOe = function() {
  var e = this, n = e._self._c;
  return n("PsKitPopup", { attrs: { classPopup: ["pskit__popup", ...e.classPopup], floatingOptions: e.floatingOptions, placement: e.placement, visible: e.visible }, on: { hide: function(r) {
    return e.$emit("hide");
  } } }, [n("div", { staticClass: "title" }, [e._t("title")], 2), n("div", { staticClass: "buttons" }, e._l(e.buttons, function(r) {
    return n("PbDefaultButton", { key: r.text, attrs: { type: r.type }, on: { click: r.onclick } }, [e._v(e._s(r.text))]);
  }), 1)]);
}, nOe = [], rOe = /* @__PURE__ */ B(
  eOe,
  tOe,
  nOe,
  !1,
  null,
  null
);
const R2 = rOe.exports, sOe = {
  name: "NewsEmbargoListEntry",
  mixins: [ai],
  components: {
    PbDateWidget: Hr,
    PbEntryDate: nl,
    PbPanelDynamicEntry: Zv,
    MainActionButton: fn,
    PbPanelListEntryActions: Xv,
    NewsRepublishCtr: Uf,
    PbCheckboxLabeled: qa,
    NewsItemEmbargoCtr: Fu,
    PsKitPopup: Ls,
    PsKitPopupDialog: R2
  },
  props: {
    item: {
      type: Object,
      required: !0
    },
    multiSelection: {
      type: Array,
      required: !0
    },
    forceDropCheckbox: Date,
    isSelected: {
      type: Boolean,
      default: !1
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      default: !1
    },
    dateMode: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "000"
    }
  },
  setup(t, e) {
    var D;
    const n = Jt("store"), r = {
      getNewsItemById: n.getters["news/getNewsItemById"],
      getIsPublicationCode: n.getters["news/codes/getIsPublicationCode"],
      getIsUserHasPublishingCodes: n.getters["news/codes/getIsUserHasPublishingCodes"],
      getIsUserHasAnyPermission: n.getters["auth/getIsUserHasAnyPermission"]
    }, s = le(() => {
      var H;
      return (H = t.item) == null ? void 0 : H.id;
    }), { isPublishedByMe: i, publishedBy: o } = uc(
      { newsItemIdRef: s },
      n
    ), a = Xn({
      visible: !1
    }), l = Xn({
      visible: !1,
      popupIds: [],
      popupNodes: []
    }), c = Xn({
      visible: !1
    }), u = Xn({
      visible: !1
    }), d = et(null), f = async () => {
      a.visible || document.body.click(), await Ar(), a.visible = !0;
    }, p = async () => {
      l.visible || document.body.click(), await Ar(), l.visible = !0;
    }, h = async () => {
      c.visible || document.body.click(), await Ar(), c.visible = !0;
    }, m = (H) => {
      document.body.click(), e.emit("publish", H);
    }, v = async () => {
      u.visible || document.body.click(), await Ar(), u.visible = !0;
    }, y = (H) => {
      document.body.click(), e.emit("pick", H);
    }, _ = le(() => r.getNewsItemById(s.value)), { version: w } = Zi({ newsItemIdRef: s }, n), S = le(() => {
      var Y, te;
      const H = (te = (Y = w.value) == null ? void 0 : Y.codes) == null ? void 0 : te.map(({ code: A }) => A);
      return H ? H.filter((A) => r.getIsPublicationCode(A)) : [];
    }), E = le(
      () => i.value || r.getIsUserHasAnyPermission(["2.9"])
    ), x = le(() => ({
      "grid-column": t.isCompact ? "2 / -2" : "1 / -1"
    })), T = et(t.multiSelection.includes((D = _.value) == null ? void 0 : D.id)), C = le(() => !!t.multiSelection.length), k = () => {
      var H;
      e.emit("multi-select", (H = _.value) == null ? void 0 : H.id);
    };
    return eM(() => {
      var H, Y;
      T.value = (Y = t.multiSelection) == null ? void 0 : Y.includes((H = _.value) == null ? void 0 : H.id);
    }), t.forceDropCheckbox && or(
      () => t.forceDropCheckbox,
      () => T.value = !1
    ), {
      ...r,
      itemId: s,
      republishManager: a,
      embargoForm: l,
      confirmPublish: c,
      confirmEdit: u,
      entry: _,
      version: w,
      actionable: E,
      publishedBy: o,
      codes: S,
      bodyStyle: x,
      isMultiSelected: T,
      listHasMultiSelected: C,
      registerPopup: async ({ id: H }) => {
        await Ar();
        const Y = document.getElementById(H);
        Y && l.popupNodes.push(Y);
      },
      handleMultiSelect: k,
      showRepublishManager: f,
      showEmbargoForm: p,
      showConfirmPublishDialog: h,
      showConfirmEditDialog: v,
      republishAnchorRef: d,
      republishAction: (...H) => n.dispatch("news/routeNewsPublicationCodes", ...H),
      onEmbargoFormClickAway: (H) => {
        l.popupNodes.reduce((te, A) => (te = te || ((A == null ? void 0 : A.contains(H.target)) ?? !1), te), !1) || (l.visible = !1, l.popupNodes = []);
      },
      publishConfirmHandle: m,
      editConfirmHandle: y
    };
  },
  computed: {
    ...pe("news/versions", ["getIsUrgentVersionType"]),
    selectedBackground() {
      let t = this.editorStyle.backgroundColor;
      return t.toLowerCase() === "ffffff" && (t = "eeeeee"), this.isSelected ? "#" + t : null;
    },
    panelColors() {
      let t = "rgba(255, 235, 230, 1)";
      this.listHasMultiSelected && (t = "#ffffff");
      let e = "var(--bg-color)";
      return this.isSelected ? e = "#f9f6f6" : this.listHasMultiSelected && (e = "rgba(255, 235, 230, 1)"), `
        --bg-color: ${t};
        --selected-bg-color: ${e};
      `;
    },
    isUrgent() {
      var t;
      return this.getIsUrgentVersionType((t = this.version) == null ? void 0 : t.type_id);
    }
  }
};
var iOe = function() {
  var e = this, n = e._self._c;
  return e.entry ? n("PbPanelDynamicEntry", { class: {
    "news-embargo-list-entry": !0,
    "in-use": e.republishManager.visible || e.embargoForm.visible,
    "hidden-actions": e.listHasMultiSelected,
    disabled: e.isDisabled
  }, style: e.panelColors, attrs: { entry: e.entry, body: e.version && (e.version.headline || e.version.body), dateMode: e.dateMode, isCompact: e.isCompact, isSelected: e.isSelected || e.isMultiSelected, isHighlighted: e.isUrgent, fontStyle: e.bodyStyle }, scopedSlots: e._u([{ key: "header", fn: function() {
    var r, s;
    return [n("div", { staticClass: "left-top-corner" }, [n("PbCheckboxLabeled", { attrs: { disabled: !e.actionable || e.isDisabled }, on: { change: e.handleMultiSelect }, model: { value: e.isMultiSelected, callback: function(i) {
      e.isMultiSelected = i;
    }, expression: "isMultiSelected" } })], 1), ((r = e.version) == null ? void 0 : r.publish_at) === null ? n("div", { staticClass: "date" }, [n("span", [e._v("До звонка")])]) : n("PbEntryDate", { staticClass: "date" }, [n("pre", [e._v("До ")]), n("PbDateWidget", { attrs: { date: (s = e.version) == null ? void 0 : s.publish_at, mode: e.dateMode, moscowTime: !0 } })], 1)];
  }, proxy: !0 }, { key: "actions", fn: function() {
    return [e._v(e._s(null))];
  }, proxy: !0 }, { key: "extra", fn: function() {
    return [n("div", { staticClass: "extra-block publishers" }, [n("span", [e._v(e._s(e.formatUsername(e.publishedBy.name)))])]), n("div", { staticClass: "extra-block codes" }, [e._l(e.codes, function(r, s) {
      return [e._v(" " + e._s(r.name)), n("span", { directives: [{ name: "show", rawName: "v-show", value: s < e.codes.length - 1, expression: "index < codes.length - 1" }], key: s }, [e._v(",")])];
    })], 2), n("PbPanelListEntryActions", { staticClass: "extra-block actions", attrs: { color: e.color, isCompact: e.isCompact } }, [n("MainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.actionable, expression: "actionable" }, { name: "tooltip", rawName: "v-tooltip", value: "Опубликовать немедленно", expression: "'Опубликовать немедленно'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-publish", "data-test-selector": "news-item-button-publish" }, on: { click: function(r) {
      return r.stopPropagation(), e.showConfirmPublishDialog.apply(null, arguments);
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.confirmPublish.visible ? n("PsKitPopupDialog", { attrs: { visible: e.confirmPublish.visible, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
        {
          type: "primary",
          text: "Да",
          onclick: () => e.publishConfirmHandle(e.entry.id)
        },
        { text: "Нет", onclick: () => e.confirmPublish.visible = !1 }
      ] }, on: { hide: function(r) {
        e.confirmPublish.visible = !1;
      } }, scopedSlots: e._u([{ key: "title", fn: function() {
        return [e._v(" Новость будет опубликована немедленно. Продолжить? ")];
      }, proxy: !0 }], null, !1, 3293570803) }) : e._e()];
    }, proxy: !0 }], null, !1, 3848784938) }), n("MainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.actionable, expression: "actionable" }, { name: "tooltip", rawName: "v-tooltip", value: "Взять в работу", expression: "'Взять в работу'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-edit", "data-test-selector": "news-item-button-add" }, on: { click: function(r) {
      return r.stopPropagation(), e.showConfirmEditDialog.apply(null, arguments);
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.confirmEdit.visible ? n("PsKitPopupDialog", { attrs: { visible: e.confirmEdit.visible, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
        {
          type: "primary",
          text: "Да",
          onclick: () => e.editConfirmHandle(e.entry.id)
        },
        { text: "Нет", onclick: () => e.confirmEdit.visible = !1 }
      ] }, on: { hide: function(r) {
        e.confirmEdit.visible = !1;
      } }, scopedSlots: e._u([{ key: "title", fn: function() {
        return [e._v(" Новость будет изъята из очереди отложенных и НЕ будет опубликована. Продолжить? ")];
      }, proxy: !0 }], null, !1, 2361793665) }) : e._e()];
    }, proxy: !0 }], null, !1, 3650401777) }), n("MainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.actionable, expression: "actionable" }, { name: "tooltip", rawName: "v-tooltip", value: "Изменить время публикации", expression: "'Изменить время публикации'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-embargo", "data-test-selector": "entry-button-embargo" }, on: { click: function(r) {
      return r.stopPropagation(), e.showEmbargoForm.apply(null, arguments);
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.embargoForm.visible ? n("PsKitPopup", { attrs: { visible: e.embargoForm.visible }, on: { hide: e.onEmbargoFormClickAway, visible: e.registerPopup } }, [n("NewsItemEmbargoCtr", { attrs: { newsItemId: e.itemId, version: e.version, isRemovable: !1, autoOpen: !0, inPopup: !0 }, on: { embargoSet: function(r) {
        e.embargoForm.visible = !1;
      }, postponed: function(r) {
        e.embargoForm.visible = !1;
      }, removeEmbargo: function(r) {
        e.embargoForm.visible = !1;
      }, formClosed: function(r) {
        e.embargoForm.visible = !1;
      }, datePickerOpened: e.registerPopup } })], 1) : e._e()];
    }, proxy: !0 }], null, !1, 2140753949) }), n("MainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.getIsUserHasPublishingCodes, expression: "getIsUserHasPublishingCodes" }, { name: "tooltip", rawName: "v-tooltip", value: "Изменить направления публикации", expression: "'Изменить направления публикации'" }], ref: "republishAnchor", staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-list", "data-test-selector": "entry-button-add-codes" }, on: { click: function(r) {
      return r.stopPropagation(), e.showRepublishManager.apply(null, arguments);
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.republishManager.visible ? n("NewsRepublishCtr", { attrs: { visible: e.republishManager.visible, newsItemId: e.itemId, action: e.republishAction, onlyPublicactionCodes: !0, position: "right" }, on: { hide: function(r) {
        e.republishManager.visible = !1;
      } } }) : e._e()];
    }, proxy: !0 }], null, !1, 1372709640) }), n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Открыть в отдельной панели", expression: "'Открыть в отдельной панели'" }], staticClass: "action mini-button pb-action-button-old show-more", attrs: { iconName: "button-icon-show-more", "data-test-selector": "entry-button-show-more" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("openPanel", { id: e.entry.id });
    } } })], 1)];
  }, proxy: !0 }], null, !1, 3721514502) }) : e._e();
}, oOe = [], aOe = /* @__PURE__ */ B(
  sOe,
  iOe,
  oOe,
  !1,
  null,
  "81f5b5b6"
);
const lOe = aOe.exports, HL = "PANELS_INIT", gh = "PANEL_FOCUS", L2 = "PANELS_CLEAR_FOCUS", Q0 = "PANEL_SET_WIDTH_SCALE", VL = "PANEL_SET_FULLSCREEN", e1 = "PANEL_SET_COMPACT", zL = "PANEL_SET_DATEMODE", UL = "PANEL_ADD", t1 = "PANELS_SET", zm = "PANEL_REMOVE", GL = "PANEL_SET_COLOR", YL = "PANEL_SET_NAME", ZL = "PANEL_SHOW_SUPPLY", XL = "PANEL_HIDE_SUPPLY", KL = "PANELS_SET_DESIRED_SCROLL_INDEX", JL = "PANEL_SET_DATA_ID", qL = "PANEL_SET_ACTIVE_TAB_INDEX", QL = "PANEL_FLOW_CLEAR_OLD_SUPPLY", e6 = "PANEL_ASOI_NOTES_CLEAR_OLD_SUPPLY", t6 = "PANEL_ASOI_NOTES_SENT_CLEAR_OLD_SUPPLY", n6 = "PANEL_PUBLISHED_SELECT_NEWS_ITEM", cOe = "PANEL_PUBLISHED_UNSELECT_NEWS_ITEM", r6 = "PANEL_PUBLISHED_SEARCH_SELECT_NEWS_ITEM", s6 = "PANELS_SET_UPDATING", i6 = "PANEL_LIST_SELECT_ENTRY", o6 = "PANEL_EMBARGO_SELECT_NEWS_ITEM", a6 = "PANEL_NOTIFICATION_ADD", l6 = "PANEL_NOTIFICATION_REMOVE", c6 = "PANEL_REMOVE_ALL_NEWS";
async function Gd(t) {
  t.value || document.body.click(), await Ar(), t.value = !t.value;
}
const uOe = {
  name: "NewsEmbargoListCtr",
  components: {
    NewsList: Qv,
    MainActionButton: fn,
    NewsEmbargoListEntry: lOe,
    PbButton: nt,
    PsKitPopupDialog: R2,
    PsKitPopup: Ls,
    PbEmbargoWidget: WL
  },
  props: {
    panelId: {
      type: [Number, String],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#fff"
    },
    dateMode: {
      type: Number,
      default: 0
    },
    isFocused: {
      type: Function,
      default: () => !1
    },
    forceRefresh: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Jt("store"), n = le(
      () => e.state.news.sets.embargo.displayedList.map((P) => ({ id: P }))
    ), r = le(
      () => e.state.news.sets.embargo.list.map((P) => ({ id: P }))
    ), s = {
      getNewsItemById: e.getters["news/getNewsItemById"],
      getNewsItemCurrentVersion: e.getters["news/getNewsItemCurrentVersion"],
      getPanelIndex: e.getters["panels/getPanelIndex"],
      getPanelIsActive: e.getters.getPanelIsActive,
      getDisplayedSetRemovedNews: e.getters["news/getDisplayedSetRemovedNews"]
    }, i = {
      reschedule: (...P) => e.dispatch("news/rescheduleNewsItem", ...P),
      pickToEdit: (...P) => e.dispatch("news/pickNewsItemToEdit", ...P),
      loadDelayedNews: (...P) => e.dispatch("news/loadDelayedNews", ...P),
      selectEmbargoNewsItem: (...P) => e.dispatch("news/selectEmbargoNewsItem", ...P),
      setPanelDateMode: (...P) => e.dispatch("panels/setPanelDateMode", ...P),
      addPanel: (...P) => e.dispatch("panels/addPanel", ...P)
    }, o = le(() => s.getPanelIsActive(t.panelId)), a = le(() => n.value.length !== r.value.length || !n.value.every(
      (N, D) => N.id === r.value[D].id
    ) ? n.value : [...n.value].sort((N, D) => {
      const H = s.getNewsItemCurrentVersion(N.id), Y = s.getNewsItemCurrentVersion(D.id), te = H && Y ? new Date(H.publish_at) - new Date(Y.publish_at) : 0;
      if (te === 0) {
        const A = s.getNewsItemById(N.id), j = s.getNewsItemById(D.id);
        return A && j ? new Date(A.status_modified_at) - new Date(j.status_modified_at) : 0;
      }
      return te;
    })), l = le(
      () => s.getDisplayedSetRemovedNews("embargo")
    ), c = (P) => l.value.includes(P), u = ({ params: P, replace: N }) => i.loadDelayedNews({ params: P, replace: N }), d = ({ entry: P, panelId: N }) => {
      if (!c(P.id))
        return i.selectEmbargoNewsItem({
          newsItemId: P.id,
          panelId: N
        });
    }, f = ({ id: P } = {}) => {
      i.addPanel({
        panel: { type: ve.newsItem, dataId: P },
        position: s.getPanelIndex(t.panelId)
      });
    };
    async function p(P) {
      await i.reschedule({
        paramsList: [
          {
            id: P,
            publish_at: null,
            is_postponed: !1
          }
        ]
      });
    }
    const h = et([]), m = le({
      get() {
        return h.value;
      },
      set(P) {
        h.value = P;
      }
    }), v = et(0);
    or(r, (P, N) => {
      var D, H;
      if ((P == null ? void 0 : P.length) !== (N == null ? void 0 : N.length)) {
        const Y = (D = r.value) == null ? void 0 : D.map((te) => te.id);
        m.value = ((H = m.value) == null ? void 0 : H.filter((te) => Y.includes(te))) ?? [], v.value = m.value.length;
      }
    });
    const y = et(!1), _ = et(!1), w = et(!1), S = Xn({ visible: !1, popupNodes: [] }), E = et(/* @__PURE__ */ new Date());
    function x() {
      m.value = [], v.value = 0, document.body.click(), E.value = /* @__PURE__ */ new Date();
    }
    async function T(P, N = !0, D = !0) {
      const H = P.map(
        async (Y) => await i.pickToEdit({ newsItemId: Y, needOpenPanel: D })
      );
      await Promise.all(H), N && x();
    }
    const C = {
      multiSelection: m,
      multiSelectionSize: v,
      multiSelectionDrop: x,
      forceDropCheckbox: E,
      togglePopupDelete: async () => await Gd(y),
      togglePopupConfirmPublish: async () => await Gd(_),
      togglePopupConfirmEdit: async () => await Gd(w),
      isDeleteDialogOpen: y,
      isConfirmPublishDialogOpen: _,
      isConfirmEditDialogOpen: w,
      embargoForm: S,
      multi_pickToEdit: T,
      async multi_publishNow(P) {
        const N = P.reduce((D, H) => (D.push({
          id: H,
          publish_at: null,
          is_postponed: !1
        }), D), []);
        i.reschedule({ paramsList: N }), x();
      },
      multiSelectHandler(P) {
        m.value.includes(P) ? m.value = m.value.filter(
          (N) => N !== P
        ) : m.value = m.value.concat([P]), v.value = m.value.length;
      },
      multi_setEmbargo(P) {
        const N = m.value.reduce((D, H) => (D.push({
          id: H,
          publish_at: P,
          is_postponed: !1
        }), D), []);
        i.reschedule({ paramsList: N }), C.embargoForm.visible = !1;
      },
      multi_setPostponed(P) {
        const N = m.value.reduce((D, H) => (D.push({
          id: H,
          publish_at: null,
          is_postponed: P
        }), D), []);
        i.reschedule({ paramsList: N }), C.embargoForm.visible = !1;
      },
      async multi_disposeNewsItem() {
        y.value = !1;
        const P = [
          e.dispatch(
            "news/disposeNewsItems",
            m.value.map((N) => ({
              id: N,
              reason: "Удалено из эмбраго"
            }))
          )
        ].concat(
          m.value.map(async (N) => {
            var D;
            e.commit(
              `panels/${zm}`,
              (D = e.getters["panels/getPanelByDataId"]("newsItem", N)) == null ? void 0 : D.id
            );
          })
        );
        return x(), Promise.all(P);
      }
    };
    return {
      ...s,
      ...i,
      displayedItems: n,
      active: o,
      isRemoved: c,
      sortedItems: a,
      loadNewsEmbargo: u,
      select: d,
      openPanel: f,
      publishNow: p,
      registerPopup: async ({ id: P }) => {
        await Ar();
        const N = document.getElementById(P);
        N && S.popupNodes.push(N);
      },
      onEmbargoFormClickAway: (P) => {
        S.popupNodes.reduce((D, H) => (D = D || ((H == null ? void 0 : H.contains(P.target)) ?? !1), D), !1) || (S.visible = !1, S.popupNodes = []);
      },
      ...C
    };
  }
};
var dOe = function() {
  var e = this, n = e._self._c;
  return n("NewsList", { staticClass: "embargo-list", attrs: { "data-test-selector": "news-embargo-list", type: "embargo", items: e.sortedItems, panelId: e.panelId, isCompact: e.isCompact, color: e.color, dateMode: e.dateMode, isFocused: e.isFocused, active: e.active, loadMethod: e.loadNewsEmbargo, hasDateDelimiters: !1, forceRefresh: e.forceRefresh, cursorField: "id" }, on: { openPanel: e.openPanel, refreshed: function(r) {
    return e.$emit("refreshed");
  }, selectItem: e.select }, nativeOn: { keyup: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "esc", 27, r.key, ["Esc", "Escape"]) ? null : e.multiSelectionDrop.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "news-list-entry", fn: function({ item: r, isSelected: s }) {
    return [n("NewsEmbargoListEntry", { attrs: { item: r, isSelected: s, isCompact: e.isCompact, dateMode: e.dateMode, color: e.color, isDisabled: e.isRemoved(r.id), multiSelection: e.multiSelection, forceDropCheckbox: e.forceDropCheckbox }, on: { openPanel: e.openPanel, publish: e.publishNow, pick: function(i) {
      return e.pickToEdit({ newsItemId: i });
    }, dateModeChanged: function(i) {
      return e.setPanelDateMode({ panelId: e.panelId, mode: i });
    }, "multi-select": e.multiSelectHandler } })];
  } }, { key: "news-list-footer", fn: function() {
    return [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.multiSelectionSize, expression: "multiSelectionSize" }], staticClass: "embargo-list__footer", attrs: { "data-test-selector": "news-embargo-list-footer" } }, [n("PbButton", { staticClass: "mini-button badge", on: { click: e.multiSelectionDrop } }, [n("icon", { attrs: { type: "font", name: "close", size: "20" } }), n("div", { staticClass: "counter" }, [e._v(" " + e._s(e.multiSelectionSize) + " ")])], 1), n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Опубликовать немедленно", expression: "'Опубликовать немедленно'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-publish", "data-test-selector": "button-publish" }, on: { click: e.togglePopupConfirmPublish }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.isConfirmPublishDialogOpen ? n("PsKitPopupDialog", { attrs: { visible: e.isConfirmPublishDialogOpen, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
        {
          type: "primary",
          text: "Да",
          onclick: () => e.multi_publishNow(e.multiSelection)
        },
        {
          text: "Нет",
          onclick: () => e.isConfirmPublishDialogOpen = !1
        }
      ] }, on: { hide: function(r) {
        e.isConfirmPublishDialogOpen = !1;
      } }, scopedSlots: e._u([{ key: "title", fn: function() {
        return [e._v(" Выделенные новости будут опубликованы немедленно. Продолжить? ")];
      }, proxy: !0 }], null, !1, 2058512546) }) : e._e()];
    }, proxy: !0 }]) }), n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Взять в работу", expression: "'Взять в работу'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-edit", "data-test-selector": "button-add" }, on: { click: e.togglePopupConfirmEdit }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.isConfirmEditDialogOpen ? n("PsKitPopupDialog", { attrs: { visible: e.isConfirmEditDialogOpen, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
        {
          type: "primary",
          text: "Да",
          onclick: () => e.multi_pickToEdit(e.multiSelection)
        },
        {
          text: "Нет",
          onclick: () => e.isConfirmEditDialogOpen = !1
        }
      ] }, on: { hide: function(r) {
        e.isConfirmEditDialogOpen = !1;
      } }, scopedSlots: e._u([{ key: "title", fn: function() {
        return [e._v(" Выделенные новости будут изъяты из очереди на публикацию. Продолжить? ")];
      }, proxy: !0 }], null, !1, 620036391) }) : e._e()];
    }, proxy: !0 }]) }), n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Изменить время публикации", expression: "'Изменить время публикации'" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-embargo", "data-test-selector": "button-embargo" }, on: { click: function(r) {
      r.stopPropagation(), e.embargoForm.visible = !0;
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.embargoForm.visible ? n("PsKitPopup", { attrs: { visible: e.embargoForm.visible, placement: "top", floatingOptions: { offset: 5 }, canPopupResize: !0 }, on: { hide: e.onEmbargoFormClickAway, visible: e.registerPopup } }, [n("PbEmbargoWidget", { attrs: { isEditable: !0, isRemovable: !1, autoOpen: !0 }, on: { setPostponed: e.multi_setPostponed, setEmbargo: e.multi_setEmbargo, formClosed: function(r) {
        e.embargoForm.visible = !1;
      }, removeEmbargo: function(r) {
        e.embargoForm.visible = !1;
      }, datePickerOpened: e.registerPopup } })], 1) : e._e()];
    }, proxy: !0 }]) }), n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Удалить", expression: "'Удалить'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.13"], expression: "['2.13']", arg: "all" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-trash", "data-test-selector": "button-delete" }, on: { click: function(r) {
      return r.stopPropagation(), e.togglePopupDelete.apply(null, arguments);
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.isDeleteDialogOpen ? n("PsKitPopupDialog", { attrs: { visible: e.isDeleteDialogOpen, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
        {
          type: "primary",
          text: "Удалить",
          onclick: e.multi_disposeNewsItem
        },
        { text: "Отмена", onclick: () => e.isDeleteDialogOpen = !1 }
      ] }, on: { hide: function(r) {
        e.isDeleteDialogOpen = !1;
      } }, scopedSlots: e._u([{ key: "title", fn: function() {
        return [e._v(" Вы уверены, что "), n("strong", [e._v("хотите удалить")]), e._v(" выбранные публикации? ")];
      }, proxy: !0 }], null, !1, 3887214487) }) : e._e()];
    }, proxy: !0 }]) })], 1)];
  }, proxy: !0 }]) });
}, fOe = [], pOe = /* @__PURE__ */ B(
  uOe,
  dOe,
  fOe,
  !1,
  null,
  null
);
const hOe = pOe.exports, mOe = "_root_12k0q_1", vOe = "_refresh_12k0q_1", gOe = "_indicator_12k0q_4", yOe = "_indicator__shortcut_12k0q_14", bOe = {
  root: mOe,
  refresh: vOe,
  indicator: gOe,
  indicator__shortcut: yOe
}, _Oe = {
  name: "NewsEmbargoPanel",
  components: {
    Panel: bs,
    NewsEmbargoListCtr: hOe,
    PbButton: nt
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      forceRefresh: !1
    };
  },
  computed: {
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    ...pe("news", ["getNotAddedToDisplayedSetNews"]),
    userHasPermissions() {
      return this.getIsUserHasAllPermissions(["2.8"]);
    },
    hasNewNews() {
      return !!this.getNotAddedToDisplayedSetNews("embargo").length;
    }
  },
  methods: {
    getIsFocused() {
      return this.isFocused;
    },
    remove() {
      this.$store.dispatch("panels/removePanel", { panelId: this.panel.id });
    }
  }
};
var wOe = function() {
  var e = this, n = e._self._c;
  return n("Panel", { class: e.$style.root, attrs: { title: "Эмбарго: Отложенные публикации", panel: e.panel, isFocused: e.isFocused, userHasPermissions: e.userHasPermissions }, scopedSlots: e._u([e.hasNewNews ? { key: "title-postfix", fn: function({ isMaximized: r }) {
    return [n("span", { class: {
      [e.$style.indicator]: !0,
      [e.$style.indicator__shortcut]: !r
    } })];
  } } : null, { key: "appBarActions", fn: function() {
    return [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Обновить", expression: "'Обновить'" }], class: e.$style.refresh, attrs: { round: "" }, on: { click: function(r) {
      r.preventDefault(), r.stopPropagation(), e.forceRefresh = !0;
    } } }, [n("icon", { attrs: { type: "font", name: "refresh", size: "24" } })], 1), n("PbButton", { staticClass: "appbar-button close-button draggable-ignore", attrs: { round: "", "data-test-selector": "panel-button-close" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.remove.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n("NewsEmbargoListCtr", { attrs: { panelId: e.panel.id, color: e.panel.settings.color, dateMode: e.panel.settings.dateMode, isCompact: e.panel.settings.compact, isFocused: e.getIsFocused, forceRefresh: e.forceRefresh }, on: { refreshed: function(r) {
      e.forceRefresh = !1;
    } } })];
  }, proxy: !0 }], null, !0) });
}, SOe = [];
const oN = {
  $style: bOe
};
function IOe(t) {
  for (var e in oN)
    this[e] = oN[e];
}
var EOe = /* @__PURE__ */ B(
  _Oe,
  wOe,
  SOe,
  !1,
  IOe,
  null
);
const xOe = EOe.exports;
var COe = Tv;
function TOe(t) {
  return t && t.length ? COe(t) : [];
}
var POe = TOe;
const un = /* @__PURE__ */ Et(POe), u6 = Object.freeze({
  ADMIN: {
    SUPERUSER: "1.1",
    USER_MGT: "1.2",
    USER_ACCESS_MGT: "1.3",
    NEWS_ROUTES_MGT: "1.4"
  },
  NEWS: {
    CREATION: "2.1",
    IN_WORK: "2.2",
    INCOMING: "2.3",
    USER: "2.4",
    PUBLISHING: "2.5",
    GROUPMATES_NEWS: "2.6",
    PUBLISHED: "2.7",
    EMBARGO: "2.8",
    EMBARGO_MGT: "2.9",
    REPUBLISH: "2.10",
    REVOKE: "2.11",
    RESTORE_REVOKED: "2.20",
    DUMP: "2.12",
    DUMP_SEND: "2.13",
    DUMP_EXTRACT: "2.14",
    SEARCH: "2.15",
    EXTENSION: "2.16",
    ORIGINALS: "2.17",
    FLASH_SEND: "2.18",
    CANVAS: "2.19"
  },
  LEADS: {
    SEND_WRK: "3.1",
    TAKE_WRK: "3.2"
  },
  INFOBREAKS: {
    LIST: "3.3",
    TAKE_WRK: "3.4",
    REJECT: "3.5"
  },
  ASOI: {
    INCOMING: "4.1",
    OUTGOING: "4.2",
    EMBARGO: "4.3"
  },
  ENTITIES: {
    MGT: "5.1"
  },
  AGENCY: {
    TASS: "6.1",
    RIA: "6.2",
    BNS: "6.3"
  }
});
function fc({ newsItemIdRef: t }, e) {
  const n = {
    newsEventTypesByName: e.getters["references/newsEventTypesByName"],
    getNewsItemById: e.getters["news/getNewsItemById"],
    getIsNewsItemIsRevocation: e.getters["news/getIsNewsItemIsRevocation"],
    newsItemEvents: e.getters["news/newsItemEvents"],
    getIsNewsItemRevoked: e.getters["news/getIsNewsItemRevoked"]
  }, r = {
    getNewsEvents: (d) => e.dispatch("panels/addPanelFromRoute", d),
    addPanelFromRoute: (d) => e.dispatch("panels/addPanelFromRoute", d)
  }, s = le(
    () => n.getIsNewsItemRevoked(t.value)
  ), i = le(
    () => n.getIsNewsItemIsRevocation(t.value)
  ), o = le(
    () => e.getters["auth/getIsUserHasAllPermissions"]([u6.NEWS.RESTORE_REVOKED])
  ), a = async (d) => {
    e.dispatch("news/republish", { newsItemId: t.value, query: d });
  }, l = le(() => {
    if (s.value) {
      const d = n.newsItemEvents(t.value);
      return d == null ? void 0 : d.find(
        (f) => {
          var p;
          return f.type_id === ((p = n.newsEventTypesByName.USED_FOR_REVOCATION) == null ? void 0 : p.id);
        }
      );
    }
    return null;
  });
  return {
    isRevoked: s,
    isRevocation: i,
    revokeEvent: l,
    fetchRevokeEvents: async () => {
      await r.getNewsEvents({ newsItemId: t.value });
    },
    navigateToRevocation: () => {
      if (l.value) {
        const f = {
          params: { id: l.value.description.replace(/[^0-9]/g, "") },
          meta: { type: "panel", panelType: "newsItem" }
        };
        r.addPanelFromRoute(f);
      }
    },
    canRestore: o,
    restoreRevoked: a
  };
}
function Bu({ newsItemIdRef: t }, e) {
  const n = {
    getDraftForNewsItem: e.getters.getDraftForNewsItem,
    getValidationErrors: e.getters["news/drafts/getValidationErrors"]
  }, r = {
    setValidationErrors: (...c) => e.dispatch("news/drafts/setValidationErrors", ...c),
    validateEmbargo: (...c) => e.dispatch("news/drafts/validateEmbargo", ...c),
    create: (...c) => e.dispatch("news/drafts/create", ...c),
    deleteDraft: (...c) => e.dispatch("news/drafts/deleteDraft", ...c),
    updateType: (...c) => e.dispatch("news/drafts/updateType", ...c),
    updateLang: (...c) => e.dispatch("news/drafts/updateLang", ...c),
    updateData: (...c) => e.dispatch("news/drafts/updateData", ...c),
    updatePostponed: (...c) => e.dispatch("news/drafts/updatePostponed", ...c),
    updateEmbargo: (...c) => e.dispatch("news/drafts/updateEmbargo", ...c),
    validate: (...c) => e.dispatch("news/drafts/validate", ...c),
    setEmbargoForm: (...c) => e.dispatch("news/drafts/setEmbargoForm", ...c),
    setEmbargoValid: (...c) => e.dispatch("news/drafts/setEmbargoValid", ...c),
    setBlockInitialized: (...c) => e.dispatch("news/drafts/setBlockInitialized", ...c),
    setBlockVisibility: (...c) => e.dispatch("news/drafts/setBlockVisibility", ...c),
    setBlockDisabled: (...c) => e.dispatch("news/drafts/setBlockDisabled", ...c)
  }, s = le(
    () => n.getDraftForNewsItem(t.value)
  ), i = le(() => {
    var c;
    return ((c = s.value) == null ? void 0 : c.version) ?? null;
  }), o = le({
    get: () => {
      var c;
      return n.getValidationErrors((c = s.value) == null ? void 0 : c.id) ?? [];
    },
    set: (c) => {
      var u;
      r.setValidationErrors({ draftId: (u = s.value) == null ? void 0 : u.id, errors: c });
    }
  });
  return {
    ...n,
    ...r,
    setNewsType: async (c) => {
      r.updateType({
        newsItemId: t.value,
        value: c
      });
    },
    validateDraft: async () => {
      var u, d, f;
      const c = await r.validate({
        newsItemId: t.value,
        draftId: (u = s.value) == null ? void 0 : u.id
      });
      c && c.errors ? (c.errors.filter((h) => h.source && h.source.pointer).map((h) => h.source.pointer).find((h) => h.includes("publish_at")) && r.setEmbargoValid({ draftId: (d = s.value) == null ? void 0 : d.id, value: !1 }), o.value = c.errors.filter(
        (h) => {
          var m, v;
          return h.source && !((v = (m = h.source) == null ? void 0 : m.pointer) != null && v.includes("publish_at")) || (h == null ? void 0 : h.code) === "NEWS_PARENT_CONFLICT" || (h == null ? void 0 : h.code) === "NEWS_CHILDREN_CONFLICT";
        }
      )) : (o.value = [], r.setEmbargoValid({ draftId: (f = s.value) == null ? void 0 : f.id, value: !0 }));
    },
    draftVersion: i,
    draft: s,
    validationErrors: o
  };
}
const kOe = "_add_qpl7i_1", NOe = "_empty_qpl7i_24", $Oe = {
  add: kOe,
  empty: NOe
}, DOe = {
  name: "NewsCodesRecommended",
  components: {
    NewsCodesList: $u
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const e = Jt("store"), { newsItemId: n } = ts(t), { draft: r } = Bu({ newsItemIdRef: n }, e);
    return {
      draft: r
    };
  },
  data() {
    return {
      selectedCodeIds: []
    };
  },
  computed: {
    ...pe("news/drafts", ["getDraftPredictedCodes"]),
    predictedCodes() {
      var t;
      return this.getDraftPredictedCodes((t = this.draft) == null ? void 0 : t.id);
    },
    recommendedCodes() {
      var t;
      if ((t = this.predictedCodes) != null && t.codes) {
        const e = Object.values(this.newsCodes).map((n) => n == null ? void 0 : n.id);
        return this.predictedCodes.codes.filter(({ code: n }) => {
          var r, s;
          return e.includes(n.id) && !((r = this.predictedCodes) != null && r.deleted.includes(n.id)) && !((s = this.predictedCodes) != null && s.added.includes(n.id));
        }).map((n) => n.code);
      }
      return [];
    },
    selectedCodesCount() {
      const t = this.selectedCodeIds.length;
      return t === 0 ? "все" : t + su(t, [" код", " кода", " кодов"]);
    }
  },
  created() {
    var t;
    this.setPredictedCodes({ draftId: (t = this.draft) == null ? void 0 : t.id, codes: [] }), this.$emit("predictCodes");
  },
  beforeDestroy() {
    var t;
    (t = this.predictedCodes) != null && t.deleted && this.predictedCodes.deleted.forEach((e) => {
      var n;
      this.removePredictedDeleted({ draftId: (n = this.draft) == null ? void 0 : n.id, codeId: e });
    });
  },
  watch: {
    draft(t, e) {
      t != null && t.id && (t == null ? void 0 : t.id) !== (e == null ? void 0 : e.id) && this.$emit("predictCodes");
    }
  },
  methods: {
    ...ge("news/drafts", {
      addCodes: "addCodes",
      setPredictedCodes: "setPredictedCodes",
      addPredictedAdded: "addPredictedAdded",
      addPredictedDeleted: "addPredictedDeleted",
      removePredictedDeleted: "removePredictedDeleted"
    }),
    async applySelected() {
      let t = this.selectedCodeIds;
      this.addPredictedAdded({ newsItemId: this.newsItemId, codeIds: t }), this.selectedCodeIds = [], await this.addCodes({ newsItemId: this.newsItemId, codeIds: t });
    },
    addRecommendedCode(t) {
      this.selectedCodeIds.push(t), setTimeout(() => {
        this.applySelected(), this.$emit("predictCodes");
      }, 1e3);
    },
    deleteRecommendedCode(t) {
      const e = this.selectedCodeIds.indexOf(t);
      e !== -1 && this.selectedCodeIds.splice(e, 1), this.addPredictedDeleted({ newsItemId: this.newsItemId, codeId: t }), this.$emit("predictCodes");
    }
  }
};
var AOe = function() {
  var e = this, n = e._self._c;
  return e.recommendedCodes.length > 0 ? n("div", { class: e.$style.root }, [n("NewsCodesList", { attrs: { codes: e.recommendedCodes, appliedCodeIds: e.selectedCodeIds, isEditable: !0, isApplicable: !0, newsCodes: e.newsCodes }, on: { codeChecked: e.addRecommendedCode, codeDeleted: e.deleteRecommendedCode } })], 1) : n("div", { class: e.$style.root }, [n("div", { class: e.$style.empty }, [e._v(" Вы добавили в новость или удалили все из рекомендованных кодов ")])]);
}, OOe = [];
const aN = {
  $style: $Oe
};
function MOe(t) {
  for (var e in aN)
    this[e] = aN[e];
}
var ROe = /* @__PURE__ */ B(
  DOe,
  AOe,
  OOe,
  !1,
  MOe,
  null
);
const LOe = ROe.exports;
var FOe = ta, BOe = Tv;
function jOe(t, e) {
  return t && t.length ? BOe(t, FOe(e)) : [];
}
var WOe = jOe;
const Gf = /* @__PURE__ */ Et(WOe);
function lN(t, e) {
  return t.sort((n, r) => {
    const s = n[e].toLowerCase(), i = r[e].toLowerCase();
    return s < i ? -1 : s > i ? 1 : 0;
  });
}
function HOe(t) {
  return lN(
    Gf(
      t.map((n) => n == null ? void 0 : n.category).filter((n) => n),
      "id"
    ),
    "name"
  ).reduce((n, r) => {
    n.push({ isGroup: !0, id: r.id, name: r.name });
    const s = lN(
      t.filter((i) => {
        var o;
        return ((o = i.category) == null ? void 0 : o.id) === r.id;
      }),
      "name"
    );
    return [...n, ...s];
  }, []);
}
function F2(t) {
  return {
    groupedCodes: le(() => HOe(t.value))
  };
}
const VOe = "_add_146rl_1", zOe = "_empty_146rl_21", UOe = {
  add: VOe,
  empty: zOe
}, GOe = {
  name: "NewsItemCodes",
  components: {
    NewsCodesList: $u
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    isEditable: {
      type: Boolean,
      default: !1
    },
    appliedCodeIds: {
      type: Array,
      default: () => []
    },
    codeItems: {
      type: Object,
      default: () => ({})
    },
    iptcCodeId: {
      type: [String, Number],
      default: null
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    colorScheme: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const e = le(() => t.version ? t.version.codes.map((r) => r.code) : []), { groupedCodes: n } = F2(e);
    return {
      versionCodes: e,
      groupedCodes: n
    };
  }
};
var YOe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [!e.isEditable && e.versionCodes.length === 0 ? n("div", { class: e.$style.empty }, [e._v(" Добавленных кодов нет ")]) : e._e(), n("NewsCodesList", { attrs: { codes: e.groupedCodes, appliedCodeIds: e.appliedCodeIds, isEditable: e.isEditable, newsCodes: e.newsCodes, colorScheme: e.colorScheme }, on: { codeDeleted: function(r) {
    return e.$emit("codeDeleted", r);
  } } })], 1);
}, ZOe = [];
const cN = {
  $style: UOe
};
function XOe(t) {
  for (var e in cN)
    this[e] = cN[e];
}
var KOe = /* @__PURE__ */ B(
  GOe,
  YOe,
  ZOe,
  !1,
  XOe,
  null
);
const d6 = KOe.exports, JOe = "_root_f2feg_1", qOe = "_button_f2feg_9", QOe = "_icon_f2feg_19", eMe = {
  root: JOe,
  button: qOe,
  icon: QOe
}, tMe = {
  name: "AnnotateEntities",
  components: { NewsCodesList: $u, PbButton: nt },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    versionCodes: {
      type: Array,
      required: !0
    },
    tickerCodes: {
      type: Array,
      required: !0
    }
  }
};
var nMe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("p", [e._v("Все биржевые коды будут проставлены для текста автоматически.")]), e.tickerCodes.length ? n("div", [n("p", [e._v("Эти коды будут удалены:")]), n("NewsCodesList", { attrs: { newsCodes: e.newsCodes, codes: e.tickerCodes, isEditable: !0 }, on: { codeDeleted: function(r) {
    return e.$emit("keepCodeId", r);
  } } })], 1) : e._e(), n("PbButton", { class: e.$style.button, attrs: { title: "Автопростановка кодов" }, on: { click: function(r) {
    return e.$emit("annotate");
  } } }, [n("icon", { class: e.$style.icon, attrs: { name: "magic-wand", size: "16" } }), e._v(" Автопростановка ")], 1)], 1);
}, rMe = [];
const uN = {
  $style: eMe
};
function sMe(t) {
  for (var e in uN)
    this[e] = uN[e];
}
var iMe = /* @__PURE__ */ B(
  tMe,
  nMe,
  rMe,
  !1,
  sMe,
  null
);
const oMe = iMe.exports, aMe = "_root_opxuf_1", lMe = "__loading_opxuf_1", cMe = "_section_opxuf_6", uMe = "_title_opxuf_14", dMe = "_button_opxuf_23", fMe = "_button_refresh_opxuf_31", pMe = "_button_close_opxuf_38", hMe = "_icon_opxuf_48", mMe = {
  root: aMe,
  _loading: lMe,
  section: cMe,
  title: uMe,
  button: dMe,
  button_refresh: fMe,
  button_close: pMe,
  icon: hMe
}, vMe = {
  name: "NewsCodes",
  components: {
    PbButton: nt,
    NewsCodesRecommended: LOe,
    NewsItemCodes: d6,
    AnnotateEntities: oMe
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    isEditable: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !0
    },
    codeItems: {
      type: Object,
      default: () => ({})
    },
    iptcCodeId: {
      type: [String, Number],
      default: null
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    tickerCodes: {
      type: Array,
      default: () => []
    },
    appliedCodeIds: {
      type: Array,
      default: () => []
    },
    showAnnotate: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    handleAnnotateClick() {
      this.tickerCodes.length ? this.$emit("showAnnotate") : this.$emit("annotate");
    }
  }
};
var gMe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { [e.$style.root]: !0, [e.$style._loading]: e.loading } }, [e.isEditable ? n("div", { class: e.$style.section }, [n("div", { class: e.$style.title }, [n("span", [e._v("Рекомендованные коды")]), n("PbButton", { class: [e.$style.button, e.$style.button_refresh], attrs: { title: "Обновить список рекомендованных кодов" }, on: { click: function(r) {
    return e.$emit("predictCodes");
  } } }, [n("icon", { attrs: { name: "refresh", size: "18" } })], 1)], 1), n("NewsCodesRecommended", { attrs: { newsItemId: e.newsItemId, newsCodes: e.newsCodes }, on: { predictCodes: function(r) {
    return e.$emit("predictCodes");
  } } })], 1) : e._e(), e.showAnnotate ? n("div", { class: e.$style.section }, [n("div", { class: e.$style.title }, [n("span", [e._v("Автопростановка кодов")]), n("PbButton", { class: e.$style.button_close, attrs: { round: "", title: "Скрыть автопростановку кодов" }, on: { click: function(r) {
    return e.$emit("hideAnnotate");
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "18" } })], 1)], 1), n("AnnotateEntities", { attrs: { newsItemId: e.newsItemId, newsCodes: e.newsCodes, versionCodes: e.version.codes, tickerCodes: e.tickerCodes }, on: { annotate: function(r) {
    return e.$emit("annotate");
  }, keepCodeId: function(r) {
    return e.$emit("keepCodeId", r);
  } } })], 1) : n("div", { class: e.$style.section }, [n("div", { class: e.$style.title }, [n("span", [e._v("Публикуемые коды")])]), e.isEditable ? n("div", { class: e.$style.title }, [n("PbButton", { class: e.$style.button, on: { click: function(r) {
    return e.$emit("showCodeManager", r);
  } } }, [e._v(" + Добавить код ")]), n("PbButton", { class: e.$style.button, attrs: { title: "Автопростановка кодов" }, on: { click: e.handleAnnotateClick } }, [n("icon", { class: e.$style.icon, attrs: { name: "magic-wand", size: "12" } }), e._v(" Автопростановка ")], 1)], 1) : e._e(), n("NewsItemCodes", { attrs: { newsItemId: e.newsItemId, isEditable: e.isEditable, version: e.version, codeItems: e.codeItems, iptcCodeId: e.iptcCodeId, newsCodes: e.newsCodes, appliedCodeIds: e.appliedCodeIds }, on: { codeDeleted: function(r) {
    return e.$emit("codeDeleted", r);
  } } })], 1)]);
}, yMe = [];
const dN = {
  $style: mMe
};
function bMe(t) {
  for (var e in dN)
    this[e] = dN[e];
}
var _Me = /* @__PURE__ */ B(
  vMe,
  gMe,
  yMe,
  !1,
  bMe,
  null
);
const wMe = _Me.exports, SMe = "_root_1ue4q_1", IMe = "_wrapper_1ue4q_9", EMe = "_header_1ue4q_19", xMe = "_header_icon_1ue4q_26", CMe = "_header_title_1ue4q_29", TMe = "_header_close_1ue4q_33", PMe = "_body_1ue4q_37", kMe = {
  root: SMe,
  wrapper: IMe,
  header: EMe,
  header_icon: xMe,
  header_title: CMe,
  header_close: TMe,
  body: PMe
}, NMe = {
  name: "NewsCodesManager",
  components: {
    PbManagerSelectedItems: Ru,
    PbButton: nt,
    PbCodeManager: Hv,
    PbActionsButtonGroup: Ou
  },
  mixins: [Vr],
  inject: ["getColorScheme"],
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    position: {
      type: Object,
      default: () => ({
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        wrapperWidth: 0
      })
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    versionCodes: {
      type: Array,
      required: !0
    },
    isSelectable: {
      type: Function,
      default: () => !0
    }
  },
  data() {
    return {
      loading: !0,
      codesSelected: []
    };
  },
  computed: {
    ...pe("news/codes", ["iptcCodeId", "getIsIptcCode"]),
    allCodes() {
      const t = { ...this.newsCodes };
      return this.versionCodes.length && this.codesSelected.forEach((e) => {
        const n = this.versionCodes.find((r) => r.id === e);
        n && (t[e] = n);
      }), t;
    },
    styleRoot() {
      return {
        top: this.position.top + "px",
        left: this.position.left + "px",
        width: this.position.width + "px",
        height: this.position.height + "px"
      };
    },
    styleWrapper() {
      return { width: this.position.wrapperWidth - 12 - 16 + "px" };
    },
    styleHeader() {
      const { color: t, backgroundColor: e } = this.getColorScheme();
      return {
        color: "#" + t,
        backgroundColor: E0("#" + e, 10)
      };
    },
    styleBody() {
      return { backgroundColor: "#" + this.getColorScheme().backgroundColor };
    },
    maxHeight() {
      return this.position.height - 83;
    },
    disabledCodeIds() {
      let t = [];
      return this.codesSelected.filter((n) => this.getIsIptcCode(n)).map((n) => this.newsCodes[n]).forEach((n) => {
        t = [...t, ...n.track];
      }), un(t);
    },
    checkDisabled() {
      return (t) => this.disabledCodeIds.includes(t.id) && t.id !== this.iptcCodeId;
    }
  },
  watch: {
    disabledCodeIds(t) {
      t.forEach((e) => this.deleteCode(e));
    }
  },
  mounted() {
    this.codesSelected = this.versionCodes.map((t) => t.id).filter((t) => !!this.newsCodes[t]);
  },
  methods: {
    hide() {
      this.codesSelected = [], this.$emit("hide");
    },
    addCode(t) {
      this.codesSelected.indexOf(t) === -1 && this.codesSelected.push(t);
    },
    deleteCode(t) {
      const e = this.codesSelected.indexOf(t);
      e !== -1 && this.codesSelected.splice(e, 1);
    },
    applyCodes() {
      this.$emit("applyCodes", this.codesSelected), this.hide();
    }
  }
};
var $Me = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, style: e.styleRoot }, [n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.hide, expression: "hide" }], class: e.$style.wrapper, style: e.styleWrapper }, [n("div", { class: e.$style.header, style: e.styleHeader }, [n("icon", { class: e.$style.header_icon, attrs: { name: "button-icon-chat", size: "24" } }), n("span", { class: e.$style.header_title }, [e._v(" Добавить код ")]), n("PbButton", { class: e.$style.header_close, attrs: { round: "", "data-test-selector": "close-button" }, on: { click: e.hide } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)], 1), n("div", { class: e.$style.body }, [n("PbCodeManager", { style: e.styleBody, attrs: { pickedCodes: e.codesSelected, allCodes: e.newsCodes, visibleCodes: e.newsCodes, maxHeight: e.maxHeight, isSelectable: e.isSelectable, checkDisabled: e.checkDisabled, fontSize: 16 }, on: { hide: e.hide, codeAdded: e.addCode, codeDeleted: e.deleteCode }, scopedSlots: e._u([Object.keys(e.newsCodes).length ? { key: "prefooter", fn: function() {
    return [n("PbManagerSelectedItems", { attrs: { availableItems: e.newsCodes, items: e.allCodes, selectedItems: e.codesSelected.map((r) => ({ id: r, state: "included" })), title: "Коды", labels: ["name"], isRemovable: !0, noItemsText: "Коды не выбраны" }, on: { remove: e.deleteCode } })];
  }, proxy: !0 } : null, { key: "footer", fn: function() {
    return [n("PbActionsButtonGroup", { attrs: { buttonsText: { apply: "Сохранить", cancel: "Отмена" }, applyFn: e.applyCodes, cancelFn: e.hide } })];
  }, proxy: !0 }], null, !0) })], 1)])]);
}, DMe = [];
const fN = {
  $style: kMe
};
function AMe(t) {
  for (var e in fN)
    this[e] = fN[e];
}
var OMe = /* @__PURE__ */ B(
  NMe,
  $Me,
  DMe,
  !1,
  AMe,
  null
);
const f6 = OMe.exports, MMe = {
  name: "NewsCodesCtr",
  mixins: [Vr],
  components: {
    NewsCodes: wMe,
    NewsCodesManager: f6
  },
  inject: ["getColorScheme"],
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    }
  },
  setup(t) {
    const e = Jt("store"), { newsItemId: n } = ts(t);
    let { draft: r, draftVersion: s } = Bu({ newsItemIdRef: n }, e);
    const { isEditable: i, version: o } = Zi(
      { newsItemIdRef: n },
      e,
      s
    ), { isRevocation: a } = fc({ newsItemIdRef: n }, e), l = et(!0), c = et(!1), u = et([]), d = Xn({
      isVisible: !1,
      position: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      query: ""
    });
    return {
      draft: r,
      version: o,
      isEditable: i,
      isRevocation: a,
      loading: l,
      showAnnotate: c,
      keepCodeIds: u,
      codeManager: d
    };
  },
  computed: {
    ...pe(["getLayoutLeftOffset"]),
    ...pe("news", ["getCanUserEditNewsItem"]),
    ...st("news/drafts", {
      publishMap: (t) => t.publicationMap
    }),
    ...pe("news/drafts", ["getDraftPredictedCodes"]),
    ...pe("news/codes", [
      "allCodeItems",
      "iptcCodeId",
      "regionsCodeId",
      "newsCodes",
      "getIsMoexCode",
      "getIsSpbCode"
    ]),
    isChangable() {
      var e;
      const t = Object.keys(this.publishMap).includes((e = this.draft) == null ? void 0 : e.id);
      return this.isEditable && !this.isRevocation && !t;
    },
    appliedCodeIds() {
      var e;
      const t = this.getDraftPredictedCodes((e = this.draft) == null ? void 0 : e.id);
      return (t == null ? void 0 : t.added) || [];
    },
    availableCodes() {
      var t;
      return (t = this.version) != null && t.codes && this.version.codes.forEach(({ code: e } = {}) => {
        e && (this.allCodeItems[e.id] || (this.allCodeItems[e.id] = e));
      }), this.allCodeItems;
    },
    isSelectable() {
      return (t) => t.track.includes(this.iptcCodeId) || t.track.includes(this.regionsCodeId) ? !0 : !t.children || !t.children.length;
    },
    versionCodes() {
      return this.version ? this.version.codes.map(({ code: t }) => t) : [];
    },
    tickerCodes() {
      return this.versionCodes ? this.versionCodes.filter((t) => {
        if ((this.getIsMoexCode(t.id) || this.getIsSpbCode(t.id)) && !this.keepCodeIds.includes(t.id))
          return t;
      }) : [];
    }
  },
  mounted() {
    (!this.isEditable || this.version) && (this.loading = !1), this.isEditable && window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...ge("news/drafts", {
      addCodes: "addCodes",
      deleteCodes: "deleteCodes",
      removePredictedAdded: "removePredictedAdded",
      annotate: "annotate",
      save: "saveDraft",
      async deleteCode(t, e) {
        this.removePredictedAdded({ newsItemId: this.newsItemId, codeId: e }), await t("deleteCodes", {
          newsItemId: this.newsItemId,
          codeIds: [e],
          inTextCheck: !0
        });
      },
      async predictCodes(t) {
        await t("predictCodes", { newsItemId: this.newsItemId });
      }
    }),
    ...ge(["setCodeManagerFocus"]),
    onResize(t = !1) {
      if (t || this.codeManager.isVisible) {
        const e = this.$el.closest(".panel-container"), n = e.getBoundingClientRect(), s = e.querySelector(".panel.newsItem").getBoundingClientRect(), i = document.querySelector("#legacy-app");
        this.codeManager.position = {
          top: n.top,
          left: n.left + i.scrollLeft - this.getLayoutLeftOffset,
          width: n.width,
          height: n.height,
          wrapperWidth: s.width
        };
      }
    },
    async applyCodes(t) {
      const e = Object.values(this.versionCodes).filter((r) => !!this.newsCodes[r.id] && !t.includes(r.id)).map(({ id: r }) => r);
      await this.deleteCodes({
        newsItemId: this.newsItemId,
        codeIds: e
      });
      const n = t.filter((r) => !e.includes(r));
      await this.addCodes({ newsItemId: this.newsItemId, codeIds: n }), this.predictCodes();
    },
    showCodeManager() {
      this.onResize(!0), this.codeManager.isVisible = !0, this.setCodeManagerFocus(!0);
    },
    hideCodeManager() {
      this.$nextTick(() => {
        this.codeManager.isVisible = !1, this.setCodeManagerFocus(!1);
      });
    },
    async handleAnnotate() {
      await this.annotate({
        newsItemId: this.newsItemId,
        keepCodeIds: this.keepCodeIds
      }), this.keepCodeIds = [], this.showAnnotate = !1, this.save({ newsItemId: this.newsItemId });
    },
    addKeepCodeId(t) {
      this.keepCodeIds.push(t), this.keepCodeIds = un(this.keepCodeIds);
    }
  }
};
var RMe = function() {
  var e = this, n = e._self._c;
  return n("div", [e.version ? n("NewsCodes", { attrs: { newsItemId: e.newsItemId, version: e.version, isEditable: e.isChangable, loading: e.loading, codeItems: e.availableCodes, iptcCodeId: e.iptcCodeId, newsCodes: e.newsCodes, tickerCodes: e.tickerCodes, appliedCodeIds: e.appliedCodeIds, showAnnotate: e.showAnnotate }, on: { showCodeManager: e.showCodeManager, predictCodes: e.predictCodes, setLoading: function(r) {
    e.loading = r;
  }, codeDeleted: e.deleteCode, annotate: e.handleAnnotate, showAnnotate: function(r) {
    e.showAnnotate = !0;
  }, hideAnnotate: function(r) {
    e.showAnnotate = !1;
  }, keepCodeId: function(r) {
    return e.addKeepCodeId(r);
  } } }) : e._e(), n("portal", { attrs: { to: "newsTextEditorWidgets" } }, [e.codeManager.isVisible ? n("NewsCodesManager", { attrs: { isVisible: e.codeManager.isVisible, position: e.codeManager.position, newsCodes: e.newsCodes, versionCodes: e.versionCodes, isSelectable: e.isSelectable }, on: { hide: e.hideCodeManager, applyCodes: e.applyCodes } }) : e._e()], 1)], 1);
}, LMe = [], FMe = /* @__PURE__ */ B(
  MMe,
  RMe,
  LMe,
  !1,
  null,
  null
);
const BMe = FMe.exports;
function jMe(t) {
  return t.replaceAll(/<\w*>/g, "").replaceAll(/<\/[p|div]>/g, `
`).replaceAll(/<\/\w+>/g, " ");
}
function WMe(t, e, n) {
  if (!t.value) return e.value;
  const r = {};
  for (const [u, d] of Object.entries(t.value)) {
    let f = [];
    n.value[u] && (f = n.value[u], f = f.split(""));
    var s, i, o, a, l = 0;
    const p = d.map((h) => {
      [s, i, o, ...a] = h;
      const m = [s - l, i, ...a];
      return l += o - i, m;
    });
    p.reverse();
    for (let h of p) {
      [s, i, ...a] = h;
      var c = a.map((m) => `<span class="diff" data-diff-type="${m[0]}">${jMe(m[1])}</span>`).join("");
      f.splice(s, i, ...c);
    }
    r[u] = f.join("");
  }
  return { ...e.value, ...r };
}
function HMe(t, e) {
  var a, l, c;
  if (!((a = t.value) != null && a.codes)) return [];
  const n = t.value.codes.map((u) => u.code.id), r = ((c = (l = e.value) == null ? void 0 : l.codes) == null ? void 0 : c.map((u) => u.code.id)) || [], s = r.filter((u) => !n.includes(u)), i = n.filter((u) => !r.includes(u));
  let o = [...e.value.codes || []];
  return t.value.codes.filter((u) => i.includes(u.code.id)).forEach((u) => o.push(u)), o = o.map((u) => ({ ...u.code })), o.forEach((u) => {
    i.includes(u.id) && (u.added = !0), s.includes(u.id) && (u.removed = !0);
  }), o;
}
function eg(t, e) {
  const n = le(() => e.getters["news/newsItemHistory/get"](t)), r = le(() => {
    var f;
    const d = (f = n.value) == null ? void 0 : f.history.findIndex(
      (p) => p.version.id === n.value.selectedVersion
    );
    return d === -1 ? {} : d === void 0 ? {} : d === 0 ? { ...n == null ? void 0 : n.value.history[d], prevVersion: {} } : {
      ...n == null ? void 0 : n.value.history[d],
      prevVersion: n == null ? void 0 : n.value.history[d - 1].version
    };
  }), s = le(() => r.value.diff), i = le(() => r.value.prevVersion), o = le(() => r.value.version), a = le(() => {
    var d;
    return ((d = o.value) == null ? void 0 : d.codes.map((f) => f.code)) || [];
  }), l = le(() => WMe(s, o, i)), c = le(() => HMe(o, i)), u = le(
    //TODO: диф пока скрыт, есть баги с разметкой. вернуть, когда будет готов бэк! (см комимит по тэгу #diff-hide)
    // () => store.getters['userProfile/getProfile'].newsEditor.showVersionDiff
    () => !1
  );
  return {
    typeId: le(() => {
      var d;
      return (d = o == null ? void 0 : o.value) == null ? void 0 : d.type_id;
    }),
    version: le(() => u.value ? l.value : o.value),
    codes: le(() => u.value ? c.value : a.value)
  };
}
const VMe = {
  name: "NewsCodesDiff",
  components: {
    NewsCodesListItem: eR
  },
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    }
  },
  setup(t) {
    const e = Jt("store"), { codes: n } = eg(t.newsItemId, e), { groupedCodes: r } = F2(n);
    return { groupedCodes: r };
  }
};
var zMe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "section" }, [n("div", { staticClass: "title" }, [e._v("Публикуемые коды")]), n("div", { staticClass: "codes" }, e._l(e.groupedCodes, function(r) {
    return n("NewsCodesListItem", { key: r.id, attrs: { code: r, isEditable: !1, isApplicable: !1 } });
  }), 1)]);
}, UMe = [], GMe = /* @__PURE__ */ B(
  VMe,
  zMe,
  UMe,
  !1,
  null,
  "03793ddf"
);
const YMe = GMe.exports, ZMe = "_link_1oidv_1", XMe = {
  link: ZMe
}, KMe = {
  name: "ChatMessageWithLink",
  props: {
    body: {
      type: String,
      default: ""
    }
  },
  computed: {
    nodes() {
      const t = document.createElement("div");
      return t.innerHTML = this.body, t.childNodes;
    }
  },
  methods: {
    ...ge("panels", ["addPanelFromRoute"]),
    navigate(t) {
      const e = {
        params: { id: t },
        meta: { type: "panel", panelType: "newsItem" }
      };
      this.addPanelFromRoute(e);
    }
  }
};
var JMe = function() {
  var e = this, n = e._self._c;
  return n("span", e._l(e.nodes, function(r, s) {
    return n("span", { key: s }, [r.nodeType === 1 ? n("a", { class: e.$style.link, on: { click: function(i) {
      return i.stopPropagation(), i.preventDefault(), e.navigate(r.dataset.newsId);
    } } }, [e._v(e._s(r.textContent))]) : n("span", [e._v(e._s(r.textContent))])]);
  }), 0);
}, qMe = [];
const pN = {
  $style: XMe
};
function QMe(t) {
  for (var e in pN)
    this[e] = pN[e];
}
var e5e = /* @__PURE__ */ B(
  KMe,
  JMe,
  qMe,
  !1,
  QMe,
  null
);
const t5e = e5e.exports, n5e = "_root_q2yfc_1", r5e = "_body_q2yfc_4", s5e = "_root_received_q2yfc_19", i5e = "_root_sent_q2yfc_27", o5e = "_icon_q2yfc_32", a5e = "_header_q2yfc_40", l5e = "_header_inverted_q2yfc_46", c5e = "_avatar_q2yfc_71", u5e = "_time_q2yfc_75", d5e = "_highlight_q2yfc_80", f5e = "_gradientBG_q2yfc_1", p5e = {
  root: n5e,
  body: r5e,
  root_received: s5e,
  root_sent: i5e,
  icon: o5e,
  header: a5e,
  header_inverted: l5e,
  avatar: c5e,
  time: u5e,
  highlight: d5e,
  gradientBG: f5e
}, h5e = {
  name: "ChatMessage",
  components: {
    ChatMessageWithLink: t5e,
    DateWidget: Hr
  },
  mixins: [Vr],
  inject: ["getColorScheme"],
  props: {
    message: {
      type: Object,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    dateMode: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...pe(["userId"]),
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_received]: this.message.user.id !== this.userId,
        [this.$style.root_sent]: this.message.user.id === this.userId,
        [this.$style.root_active]: this.active
      };
    },
    headerClass() {
      return {
        [this.$style.header]: !0,
        [this.$style.header_inverted]: this.getColorScheme().theme === "dark"
      };
    },
    avatarColor() {
      return e4(this.message.user.name, 40, 65);
    },
    initials() {
      const t = this.formatUsername(this.message.user.name).split(" ");
      let e = t[0].substring(0, 1).toUpperCase();
      return t.length > 1 && (e += t[t.length - 1].substring(0, 1).toUpperCase()), e;
    },
    highlightStyle() {
      return this.active ? { backgroundColor: this.getColorScheme().messageHighlightColor } : {};
    },
    hasLink() {
      return this.message.body.indexOf("data-news-id") !== -1;
    }
  },
  methods: {
    isRead(t) {
      return t.recipients.some(({ user: e }) => e.id !== this.userId);
    },
    handleBodyClickAway() {
      this.active && this.$emit("clickaway");
    }
  }
};
var m5e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass, attrs: { "data-test-selector": "chat-message", "data-test-id": e.message.id, "data-test-attrs": `type__${e.message.user.id === e.userId ? "sent" : "received"}` } }, [n("div", { class: e.$style.highlight, style: e.highlightStyle }), n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.handleBodyClickAway, expression: "handleBodyClickAway" }], ref: "body", class: e.$style.body, attrs: { "data-test-selector": "chat-message-body" } }, [e.hasLink ? n("ChatMessageWithLink", { attrs: { body: e.message.body } }) : n("span", [e._v(e._s(e.message.body))])], 1), n("div", { class: e.headerClass }, [n("span", { class: e.$style.username, attrs: { "data-test-selector": "chat-message-user", "data-test-attrs": `userId__${e.message.user.id}` } }, [e._v(" " + e._s(e.formatUsername(e.message.user.name)) + " ")]), n("time", { class: e.$style.time }, [n("DateWidget", { attrs: { date: e.message.created_at, mode: e.dateMode }, on: { dateModeChanged: function(r) {
    return e.$emit("dateModeChanged", r);
  } } })], 1), e.isRead(e.message) ? n("icon", { staticClass: "header__is-read", attrs: { name: "check", size: "12", color: "green" } }) : e._e()], 1)]);
}, v5e = [];
const hN = {
  $style: p5e
};
function g5e(t) {
  for (var e in hN)
    this[e] = hN[e];
}
var y5e = /* @__PURE__ */ B(
  h5e,
  m5e,
  v5e,
  !1,
  g5e,
  null
);
const b5e = y5e.exports, _5e = {
  props: {
    maxHeight: {
      type: String,
      default: "none"
    }
  },
  mounted() {
    this.resizeTextarea({ target: this.$el }), this.$el.addEventListener("input", this.resizeTextarea);
  },
  beforeDestroy() {
    this.$el.removeEventListener("input", this.resizeTextarea);
  },
  render() {
    return this.$slots.default[0];
  },
  methods: {
    resizeTextarea(t) {
      t.target.style.height = "auto", this.maxHeight === "none" || parseInt(this.maxHeight, 10) > t.target.scrollHeight ? (t.target.style.overflowY = "hidden", t.target.style.height = t.target.scrollHeight + "px") : (t.target.style.overflowY = "auto", t.target.style.height = this.maxHeight);
    }
  }
}, w5e = null, S5e = null;
var I5e = /* @__PURE__ */ B(
  _5e,
  w5e,
  S5e,
  !1,
  null,
  null
);
const E5e = I5e.exports, x5e = "_root_z5rvl_1", C5e = "_field_z5rvl_11", T5e = "_send_z5rvl_28", P5e = "_send_inverted_z5rvl_35", k5e = {
  root: x5e,
  field: C5e,
  send: T5e,
  send_inverted: P5e
}, N5e = {
  name: "NewsItemChatInput",
  components: {
    ResizeableTextarea: E5e,
    PbButton: nt
  },
  inject: ["getColorScheme"],
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    sending: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      value: ""
    };
  },
  computed: {
    buttonClass() {
      return {
        [this.$style.send]: !0,
        [this.$style.send_inverted]: this.getColorScheme().theme === "dark"
      };
    },
    buttonDisabled() {
      return this.value.trim().length === 0 || this.loading || this.sending || this.disabled;
    }
  },
  methods: {
    handleClick() {
      this.value.trim().length === 0 || this.disabled || (this.$emit("send", this.value.trim()), this.value = "", this.$nextTick(() => {
        this.$refs.textarea && (this.$refs.textarea.resizeTextarea({
          target: this.$refs.textarea.$el
        }), this.$refs.textarea.$el.focus());
      }));
    },
    handleEnter(t) {
      if (t.composed && (t.ctrlKey || t.metaKey)) {
        t.stopPropagation(), t.preventDefault(), this.handleClick();
        return;
      }
      return !0;
    },
    handleEsc(t) {
      t.stopPropagation(), t.preventDefault(), this.$nextTick(() => {
        this.$refs.textarea && (this.$refs.textarea.$el.blur(), this.$emit("blur"));
      });
    }
  }
};
var $5e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "newsItem-chat-input" } }, [n("ResizeableTextarea", { ref: "textarea", attrs: { maxHeight: "100px" } }, [n("textarea", { directives: [{ name: "model", rawName: "v-model", value: e.value, expression: "value" }], class: e.$style.field, attrs: { rows: "1", maxlength: "1000", placeholder: "Введите комментарий", "data-test-selector": "newsItem-chat-input-field" }, domProps: { value: e.value }, on: { focus: function(r) {
    return e.$emit("focus");
  }, blur: function(r) {
    return e.$emit("blur");
  }, keydown: [function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "enter", 13, r.key, "Enter") ? null : (r.stopPropagation(), e.handleEnter.apply(null, arguments));
  }, function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "esc", 27, r.key, ["Esc", "Escape"]) ? null : (r.stopPropagation(), e.handleEsc.apply(null, arguments));
  }, function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "up", 38, r.key, ["Up", "ArrowUp"]) ? null : (r.stopPropagation(), (() => {
    }).apply(null, arguments));
  }, function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "down", 40, r.key, ["Down", "ArrowDown"]) ? null : (r.stopPropagation(), (() => {
    }).apply(null, arguments));
  }], input: function(r) {
    r.target.composing || (e.value = r.target.value);
  } } })]), n("PbButton", { staticClass: "pb-action-button", class: e.buttonClass, style: { backgroundColor: "#" + e.getColorScheme().accentColor }, attrs: { active: "", disabled: e.buttonDisabled, title: "Отправить", "data-test-selector": "newsItem-chat-input-submit" }, on: { click: e.handleClick } }, [n("icon", { attrs: { name: "outline/enter", size: "13" } })], 1)], 1);
}, D5e = [];
const mN = {
  $style: k5e
};
function A5e(t) {
  for (var e in mN)
    this[e] = mN[e];
}
var O5e = /* @__PURE__ */ B(
  N5e,
  $5e,
  D5e,
  !1,
  A5e,
  null
);
const M5e = O5e.exports, R5e = "_root_1ffvq_1", L5e = "_scroller_1ffvq_5", F5e = "_afterContent_1ffvq_12", B5e = "_listLoadIndicator_1ffvq_16", j5e = {
  root: R5e,
  scroller: L5e,
  afterContent: F5e,
  listLoadIndicator: B5e
};
function p6(t, e, n, r, s, i, o, a, l = 0) {
  if (o && a) {
    const c = e(), u = o.position + a;
    if (u >= c.end) {
      const d = u - c.end;
      n(c.start + d);
    }
  } else l < 100 && setTimeout(() => {
    t(() => {
      let { view: c, height: u } = r(i);
      return p6(
        t,
        e,
        n,
        r,
        s,
        i,
        c,
        u,
        ++l
      );
    });
  }, 32);
}
function vN(t) {
  const e = this;
  (t.key === "ArrowUp" || t.key === "k") && (--e.selectedIndex === 0 && e.$emit("reachedTop"), e.$nextTick(() => {
    e.getVisibleIndexes().includes(e.selectedIndex) || e.scrollToItem(e.selectedIndex);
  })), (t.key === "ArrowDown" || t.key === "j") && (e.selectedIndex === null ? e.selectedIndex = 0 : e.selectedIndex < e.items.length - 1 && ++e.selectedIndex, e.$nextTick(() => {
    let { view: n, height: r } = e.getElementView(e.selectedIndex);
    e.selectedIndex === e.items.length - 1 && (r += 100), p6(
      e.$nextTick,
      e.getScroll,
      e.scrollToPosition,
      e.getElementView,
      e.navigationThrottle,
      e.selectedIndex,
      n,
      r
    );
  }));
}
const W5e = {
  name: "PbDynamicList",
  components: {
    DynamicScroller: Nm,
    DynamicScrollerItem: $m,
    PbCircularLoader: br
  },
  props: {
    /** Коллекция элементов списка. Должна быть массивом объектов с уникальных полем `id` */
    items: {
      type: Array,
      required: !0
    },
    /** Идентификатор выделенного элемента списка */
    selected: {
      type: [Number, String],
      default: null
    },
    /** Флаг, указывающий показывать ли индикатор загрузки в конце списка */
    showLoader: {
      type: Boolean,
      default: !1
    },
    /** Минимальная высота элемента списка */
    minItemHeight: {
      type: Number,
      default: null
    },
    /** Флаг, указывающий, что список выключен (в частности, не реагирует на нажатия клавиш) */
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },
    disabled: {
      type: Function,
      default: () => !1
    },
    /** Флаг, указывающий, что список приостановлен (в частности, не реагирует на нажатия клавиш) */
    paused: {
      type: Boolean,
      default: !1
    },
    /** Флаг, указывающий, нужно ли слушать и гененрировать события обновлнения элементов списка */
    emitUpdate: {
      type: Boolean,
      default: !1
    },
    /** Флаг, указывающий, включена ли навигация с клавиатуры */
    enableKeyboard: {
      type: Boolean,
      default: !1
    },
    /** Устанавливает троттлинг для нажатий клавиш навигации.
      `0` означает слушать нажатия без троттлинга.
    */
    navigationThrottle: {
      type: Number,
      default: 16
    },
    /** Функция принимающая элемент списка item в качестве аргумента.
      Возвращает список полей, изменение которых приведёт к пересчёту высот элементов списка.
    */
    sizeDeps: {
      type: Function,
      default: () => []
    },
    suppressClick: {
      type: Boolean,
      default: !1
    },
    /** Флаг, указывающий, сохраняется ли позиция скролла при добавлении новых элементов */
    hasFixedScroll: {
      type: Boolean,
      default: !1
    },
    itemClass: {
      type: [String, Array, Object],
      default: () => ""
    }
  },
  computed: {
    /** Вспомогательное хранилище для ID итемов */
    itemsIds() {
      return this.items.map(({ id: t }) => t);
    },
    /** Индекс выделенного элемента */
    selectedIndex: {
      get: function() {
        const t = this.items.findIndex(
          ({ id: e }) => this.selected === e
        );
        return t > -1 ? t : null;
      },
      set: function(t) {
        const e = this.items[t];
        e && this.$emit("select", e, t);
      }
    },
    /** Функция вычисления зависимостей для пересчёта высот */
    sizeDependencies() {
      return (t) => this.sizeDeps(t) || [];
    }
  },
  watch: {
    items(t, e) {
      if (this.hasFixedScroll && (this.scrollThisIteration = !1, this.previousItemsIds = e.map(({ id: n }) => n), !$a(this.itemsIds, this.previousItemsIds))) {
        if (this.reachedTop) {
          this.reachedTop = !1, this.scrollThisIteration = !0;
          return;
        }
        if (this.previousScroll !== 0) {
          if (this.previousSelected && this.selected !== this.previousSelected) {
            this.previousSelected = this.selected;
            return;
          }
          if (this.reachedBottom) {
            this.itemsIds.length !== this.previousItemsIds.length && (this.reachedBottom = !1);
            return;
          }
          this.scrollThisIteration = !0;
        }
      }
    },
    selected(t, e) {
      this.previousSelected = e, this.reachedTop = !1;
    },
    showLoader(t) {
      this.isBeingLoaded = t;
    }
  },
  created() {
    if (this.delayedClick = null, this.autoScroll = !1, this.clickedOnce = !1, this.isBeingLoaded = !1, this.isFocused = !1, this.previousItemsIds = this.items.map(({ id: t }) => t), this.previousHeight = 0, this.previousScroll = 0, this.previousSelected = null, this.reachedTop = !1, this.reachedBottom = !1, this.handleScroll = za(this.handleScroll, 50), this.navigationThrottle > 0) {
      const t = this;
      this.onNavigate = za(
        vN.bind(t),
        this.navigationThrottle
      );
    } else
      this.onNavigate = vN.bind(this);
    this.enableKeyboard && document.addEventListener("keydown", this.onNavigateHandler);
  },
  beforeUpdate() {
    const e = this.$refs.list.$el.querySelector(
      ".vue-recycle-scroller__item-wrapper"
    );
    this.previousHeight = e.clientHeight;
  },
  updated() {
    this.scrollThisIteration && this.$nextTick(() => {
      this.$nextTick(() => {
        const t = this.$refs.list.$el, n = t.querySelector(
          ".vue-recycle-scroller__item-wrapper"
        ).clientHeight, r = n - this.previousHeight, s = t.scrollTop + r;
        this.previousHeight = n, !(r < 0) && this.previousScroll !== s && (t.scrollTop = s, this.scrollThisIteration = !1);
      });
    });
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onNavigateHandler);
  },
  methods: {
    /**
     * Получить внутренниий view Dynamic Scroller'а и вычисленную высоту элемента
     * @param index индекс элемента в списке
     * @return {{view: *, height: *}}
     */
    getElementView(t) {
      const n = this.$refs.list.$refs.scroller.$_views, r = this.$refs.list.vscrollData.sizes, s = this.items[t].id;
      return { view: n.get(s), height: r[s] };
    },
    /**
     * Вернуть отсортированный список индексов видимых элементов списка.
     * @param includeHeight {boolean} Флаг, указывающий нужно ли учитывать высоту последнего элемента при расчёте видимости
     * @returns {number[]} Список индексов видимых элементов
     */
    getVisibleIndexes(t = !1) {
      const n = this.$refs.list.$refs.scroller.$_views, r = this.getScroll(), s = [], i = this.$refs.list.vscrollData.sizes;
      for (let o of n.entries()) {
        let a = t && i[o[0]] || 0;
        o[1].position + a > r.start && o[1].position + a < r.end && s.push(o[1].nr.index);
      }
      return s.sort((o, a) => o - a);
    },
    /**
     * Событие, сообщающее, что список достиг нижней границы
     * @param {boolean} isVisible
     * @event
     * */
    reachEnd(t) {
      t && (this.reachedBottom = !0, this.$emit("reachedEnd"));
    },
    /**
     * Событие, сообщающее, что список достиг верхней границы
     * @param {boolean} isVisible
     * @event
     * */
    reachTop(t) {
      this.autoScroll || t && this.$emit("reachedTop");
    },
    /**
     * Выделить элемент списка
     * @param item
     * @param index
     */
    select(t, e) {
      e !== void 0 && (this.selectedIndex = e), this.clickedOnce = !1;
    },
    /**
     * Обработка клика. Ловит событие клика и ждёт 200 мс, чтобы убедиться, что это одиночный, а не двойной клик.
     * @param event
     * @param data
     */
    clickHandler(t, e) {
      if (!this.suppressClick) {
        if (!this.delayedClick) {
          const n = this;
          this.delayedClick = jf(this.select.bind(n), 350);
        }
        this.clickedOnce ? (this.delayedClick.cancel(), this.clickedOnce = !1) : (this.delayedClick({ ...e.item }, e.index), this.clickedOnce = !0);
      }
    },
    /**
     * Обработка двойного клика.
     * @param event
     * @param data
     */
    doubleClickHandler(t, e) {
      this.clickedOnce = !1, this.$emit("dblclick", { item: e.item, index: e.index });
    },
    /**
     * Обработка навигации клавишами клавиатуры.
     * @param event
     */
    onNavigateHandler(t) {
      if (!(["j", "k"].includes(t.key) && t.target.tagName === "INPUT") && ["ArrowUp", "ArrowDown", "j", "k"].includes(t.key)) {
        if (this.disabled() || this.isBeingLoaded) return;
        t.stopPropagation(), t.preventDefault(), this.onNavigate(t);
      }
    },
    /**
     * Получть текущее положение списка
     * @typedef scroll
     * @property {number} start Верхняя граница
     * @property {number} end Нижняя граница
     *
     * @returns {scroll} Положение списка
     * @public
     */
    getScroll() {
      return this.$refs.list.$refs.scroller.getScroll();
    },
    /**
     * Обработчик события scroll на списке
     * @param {Object} $event нативный объект события
     */
    handleScroll(t) {
      this.$emit("scroll", t.target.scrollTop), this.previousScroll = t.target.scrollTop, this.reachedTop = t.target.scrollTop === 0 && this.isBeingLoaded;
    },
    /**
     * Прокрутить список до верхней границы указанного элемента
     * @param {number} index индекс элемента в списке
     * @public
     */
    scrollToItem(t) {
      this.autoScroll = !0, this.$refs.list && this.$refs.list.scrollToItem(t), this.$nextTick(() => {
        this.autoScroll = !1;
      });
    },
    scrollToPosition(t) {
      this.autoScroll = !0, this.$refs.list && this.$refs.list.$refs.scroller && this.$refs.list.$refs.scroller.scrollToPosition(t), this.$nextTick(() => {
        this.autoScroll = !1;
      });
    },
    scrollToTop() {
      this.scrollToItem(0);
    },
    scrollToBottom() {
      this.autoScroll = !0, this.$refs.list && this.$refs.list.scrollToBottom(), this.$nextTick(() => {
        this.autoScroll = !1;
      });
    },
    setFocused(t) {
      this.isFocused = t;
    },
    forceUpdate() {
      this.$refs.list && this.$refs.list.forceUpdate();
    }
  }
};
var H5e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("DynamicScroller", { ref: "list", class: [e.$style.scroller, "scroller"], attrs: { items: e.items, buffer: 600, minItemSize: e.minItemHeight, emitUpdate: e.emitUpdate, tabindex: "-1", "data-test-selector": "dynamic-list" }, nativeOn: { scroll: function(r) {
    return e.handleScroll.apply(null, arguments);
  }, focus: function(r) {
    return e.setFocused(!0);
  }, blur: function(r) {
    return e.setFocused(!1);
  } }, scopedSlots: e._u([{ key: "before", fn: function() {
    return [e._t("before-content")];
  }, proxy: !0 }, { key: "default", fn: function({ item: r, index: s, active: i }) {
    return [n("DynamicScrollerItem", { class: e.itemClass, attrs: { item: r, active: i, sizeDependencies: e.sizeDependencies(r), index: s } }, [n("div", { on: { click: function(o) {
      return e.clickHandler(o, { item: r, index: s });
    }, dblclick: function(o) {
      return o.preventDefault(), o.stopPropagation(), e.doubleClickHandler(o, { item: r, index: s });
    } } }, [s === 0 ? n("div", { directives: [{ name: "observe-visibility", rawName: "v-observe-visibility", value: e.reachTop, expression: "reachTop" }], key: r.id }) : e._e(), e._t("default", null, { index: s, item: r, active: i })], 2)])];
  } }, { key: "after", fn: function() {
    return [n("div", { directives: [{ name: "observe-visibility", rawName: "v-observe-visibility", value: e.reachEnd, expression: "reachEnd" }], class: e.$style.afterContent }, [e._t("after-content", function() {
      return [n("div", { class: e.$style.listLoadIndicator }, [n("PbCircularLoader", { directives: [{ name: "show", rawName: "v-show", value: e.showLoader, expression: "showLoader" }], attrs: { size: 30 } })], 1)];
    })], 2)];
  }, proxy: !0 }], null, !0) })], 1);
}, V5e = [];
const gN = {
  $style: j5e
};
function z5e(t) {
  for (var e in gN)
    this[e] = gN[e];
}
var U5e = /* @__PURE__ */ B(
  W5e,
  H5e,
  V5e,
  !1,
  z5e,
  null
);
const il = U5e.exports, G5e = "_root_1tap8_1", Y5e = "_messages_1tap8_8", Z5e = "_messagesList_1tap8_14", X5e = "_messagesItem_1tap8_22", K5e = "_messagesEmpty_1tap8_26", J5e = "_messagesEmpty_inverted_1tap8_34", q5e = "_loading_1tap8_38", Q5e = "_miniLoader_1tap8_44", e4e = "_noConnection_1tap8_50", t4e = {
  root: G5e,
  messages: Y5e,
  messagesList: Z5e,
  messagesItem: X5e,
  messagesEmpty: K5e,
  messagesEmpty_inverted: J5e,
  loading: q5e,
  miniLoader: Q5e,
  noConnection: e4e
};
function yN(t, e) {
  return t.map(({ id: r }) => r).findIndex((r) => Number(r) === Number(e)) !== -1;
}
const n4e = {
  name: "NewsItemChat",
  components: {
    PbDynamicList: il,
    PbCircularLoader: br,
    ChatMessage: b5e,
    NewsItemChatInput: M5e
  },
  inject: ["getColorScheme"],
  props: {
    newsItemId: {
      type: Number,
      required: !0
    },
    parentPanel: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      dateMode: 0,
      cursorPrev: null,
      highlightedCommentId: null,
      loading: !1,
      loaded: !1,
      sending: !1,
      scrolling: !1,
      isFirstLoad: !0
    };
  },
  computed: {
    ...st({
      chatMessages: (t) => t.chat.messagesMap
    }),
    messages() {
      let t = [];
      return this.chatMessages[this.newsItemId] && (t = Or(this.chatMessages[this.newsItemId].list)), t.sort(
        (e, n) => new Date(e.created_at) - new Date(n.created_at)
      );
    },
    initialLoaded() {
      return this.chatMessages[this.newsItemId] ? this.chatMessages[this.newsItemId].initialLoaded : !1;
    },
    sizeDeps() {
      return (t) => [t.body];
    },
    loaderColor() {
      return "#" + this.getColorScheme().accentColor;
    },
    messagesEmptyClass() {
      return {
        [this.$style.messagesEmpty]: !0,
        [this.$style.messagesEmpty_inverted]: this.getColorScheme().theme === "dark"
      };
    }
  },
  watch: {
    messages(t, e) {
      !this.loading && t.length - e.length === 1 && this.scrollToEnd();
    },
    $route(t, e) {
      if (t.hash === "" && e.hash.match(/comment-(\d+)/g) && (this.highlightedCommentId = null), t.hash !== e.hash && t.hash.match(/comment-(\d+)/g)) {
        const n = /comment-(\d+)/g.exec(t.hash), r = n && n[1] || null;
        if (!r) return;
        this.highlightedCommentId = r, this.$nextTick(() => {
          this.scrollToComment(this.highlightedCommentId);
        });
      }
    },
    initialLoaded(t, e) {
      t !== e && !t && (this.cursorPrev = null, this.fetchData({ cursor: null }));
    }
  },
  async mounted() {
    let t = !1;
    if (await this.fetchData({ cursor: this.cursorPrev }), this.$route.name === "newsItem" && this.$route.hash) {
      const e = this.$route.params.id;
      if (!(Number(e) === this.newsItemId)) return;
      const r = /comment-(\d+)/g.exec(this.$route.hash), s = r && r[1] || null;
      if (!s) return;
      this.highlightedCommentId = s, yN(this.messages, s) || (t = !0);
    }
    for (; t; ) {
      await this.fetchData({ cursor: this.cursorPrev });
      const e = yN(
        this.messages,
        this.highlightedCommentId
      );
      this.cursorPrev === null && !e && (t = !1, this.$router.replace(this.$route.path)), e && (t = !1);
    }
    this.$nextTick(() => {
      this.scrollToComment(this.highlightedCommentId), setTimeout(this.blurHighlightedComment, 5e3);
    });
  },
  beforeDestroy() {
    this.clearChatMessages(this.newsItemId);
  },
  methods: {
    ...ge({
      sendChatMessage(t, e) {
        t("sendChatMessage", e);
      },
      clearChatMessages: "clearChatMessages",
      markCommentAsRead: "markCommentAsRead",
      setFocused: "setPanelEditorFocus",
      setInitialLoaded(t, e) {
        t("chatSetInitialLoaded", {
          newsItemId: this.newsItemId,
          loaded: e
        });
      }
    }),
    focus() {
      this.setFocused({ panelId: this.parentPanel.id, focused: !0 });
    },
    blur() {
      this.setFocused({ panelId: this.parentPanel.id, focused: !1 });
    },
    blurHighlightedComment() {
      this.highlightedCommentId && (this.highlightedCommentId = null, this.$router.replace(this.$route.path));
    },
    scrollToComment(t) {
      this.$nextTick(() => {
        if (!this.$refs.list) return;
        const e = this.messages.findIndex((n) => n.id === +t);
        this.scrolling = !0, setTimeout(() => {
          this.$refs.list.scrollToItem(e);
        }, 100), setTimeout(() => {
          this.scrolling = !1;
        }, 200);
      });
    },
    scrollToEnd() {
      this.$nextTick(() => {
        this.$refs.list && (this.scrolling = !0, this.$refs.list.scrollToBottom(), setTimeout(() => {
          this.scrolling = !1;
        }, 200));
      });
    },
    async fetchData({ cursor: t, limit: e = 30, reverse: n = !0 }) {
      this.loading = !0;
      let r = { cursor: t, limit: e, reverse: n };
      try {
        const s = await this.$store.dispatch("getChatMessages", {
          newsItemId: this.newsItemId,
          params: r
        });
        return s.data && (this.loaded = s.next_cursor === null, this.cursorPrev = s.next_cursor, t || this.scrollToEnd()), s;
      } finally {
        this.loading = !1, this.isFirstLoad && (this.isFirstLoad = !1, this.setInitialLoaded(!0), this.markAsRead());
      }
    },
    async loadPrev() {
      if (this.loading || this.loaded || this.scrolling) return;
      this.loaded = !1;
      const t = this.messages[0].id, e = await this.fetchData({ cursor: this.cursorPrev });
      if (e.data && (this.loaded = e.next_cursor === null, this.cursorPrev = e.next_cursor, !this.loaded)) {
        const n = this.messages.findIndex((r) => r.id === t);
        this.$refs.list.scrollToItem(n);
      }
    },
    sendMessage(t) {
      this.sending = !0, this.sendChatMessage({ newsItemId: this.newsItemId, message: t }), this.sending = !1, this.scrollToEnd();
    },
    markAsRead() {
      var t;
      !this.loading && !this.scrolling && this.markCommentAsRead({
        newsItemId: this.newsItemId,
        lastCommentId: (t = this.messages.at(-1)) == null ? void 0 : t.id
      });
    }
  }
};
var r4e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "newsItem-chat", "data-test-id": e.newsItemId } }, [e.initialLoaded ? n("div", { class: e.$style.messages, attrs: { "data-test-selector": "newsItem-chat-messages" } }, [e.messages.length === 0 ? n("div", { class: e.messagesEmptyClass, attrs: { "data-test-selector": "newsItem-chat-messages-empty" } }, [e._v(" Нет комментариев ")]) : n("div", { class: e.$style.messagesList, attrs: { "data-test-selector": "newsItem-chat-messages-list" } }, [n("PbDynamicList", { ref: "list", attrs: { items: e.messages, itemClass: "messageContainer", minItemHeight: 1, suppressClick: !0, sizeDeps: e.sizeDeps }, on: { reachedTop: e.loadPrev, reachedEnd: e.markAsRead }, scopedSlots: e._u([{ key: "before-content", fn: function() {
    return [e.loading && !e.loaded ? n("div", { class: e.$style.miniLoader, attrs: { "data-test-selector": "newsItem-chat-messages-loader" } }, [n("PbCircularLoader", { attrs: { size: 15, color: e.loaderColor } })], 1) : e._e()];
  }, proxy: !0 }, { key: "default", fn: function({ item: r }) {
    return n("div", { class: e.$style.messagesItem }, [n("ChatMessage", { attrs: { active: e.highlightedCommentId === String(r.id), message: r, dateMode: e.dateMode }, on: { dateModeChanged: function(s) {
      e.dateMode = s;
    }, clickaway: e.blurHighlightedComment } })], 1);
  } }, { key: "after-content", fn: function() {
    return [n("span")];
  }, proxy: !0 }]) })], 1)]) : n("div", { class: e.$style.loading, attrs: { "data-test-selector": "newsItem-chat-loading" } }, [n("PbCircularLoader", { attrs: { color: e.loaderColor } })], 1), n("NewsItemChatInput", { attrs: { loading: e.loading, sending: e.sending, disabled: !1 }, on: { focus: e.focus, blur: e.blur, send: e.sendMessage } })], 1);
}, s4e = [];
const bN = {
  $style: t4e
};
function i4e(t) {
  for (var e in bN)
    this[e] = bN[e];
}
var o4e = /* @__PURE__ */ B(
  n4e,
  r4e,
  s4e,
  !1,
  i4e,
  null
);
const a4e = o4e.exports, l4e = "_root_sbtx2_1", c4e = "_tabsWrapper_sbtx2_10", u4e = {
  root: l4e,
  tabsWrapper: c4e
}, d4e = {
  name: "NewsItemExtensionPanel",
  mixins: [Jv, ai],
  components: {
    Panel: bs,
    PbTabs: QS,
    NewsCodesCtr: BMe,
    NewsCodesDiff: YMe,
    NewsItemChat: a4e
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object
    }
  },
  data() {
    return {
      tabs: [
        { name: "codes", label: "Коды" },
        { name: "chat", label: "Обсуждение" }
      ]
    };
  },
  computed: {
    ...st({
      chatMessages: (t) => t.chat.messagesMap
    }),
    ...pe(["userId"]),
    ...pe("news", ["getNewsItemById"]),
    newsItem() {
      return this.getNewsItemById(this.panel.dataId);
    },
    diffMode() {
      var t, e;
      return (e = (t = this.parent) == null ? void 0 : t.supply.left[0]) == null ? void 0 : e.settings.visible;
    },
    countUnreadMessages() {
      var t;
      return ((t = this.$store.getters.unreadMessages(this.panel.dataId, this.userId)) == null ? void 0 : t.length) ?? 0;
    },
    highlightedTabs() {
      return this.countUnreadMessages && this.activeTab !== "chat" ? ["chat"] : [];
    }
  }
};
var f4e = function() {
  var e = this, n = e._self._c;
  return n("Panel", { class: e.$style.root, attrs: { panel: e.panel, resizeable: !1, toolbarColor: e.editorStyle.backgroundColor, styles: {
    body: { borderLeft: "1px solid #" + e.getColorScheme().innerBorderColor }
  } }, scopedSlots: e._u([{ key: "main-toolbar", fn: function() {
    return [n("div", { class: e.$style.tabsWrapper }, [n("PbTabs", { staticStyle: { "background-color": "var(--theme-backgroundColor)" }, attrs: { tabs: e.tabs, height: "calc(2rem - 6px)", type: "centered", highlightedTabs: e.highlightedTabs }, scopedSlots: e._u([{ key: "default", fn: function({ tab: r }) {
      return [n("div", { attrs: { "data-test-attrs": `tab-name__${r.name}${r.name === e.activeTab ? " tab-active" : ""}`, "data-test-selector": "panel-newsItemAdditionalSupply-tabs-button" } }, [n("span", [e._v(e._s(r.label))]), r.name === "chat" && e.activeTab !== "chat" && e.countUnreadMessages ? n("span", [e._v(" (" + e._s(e.countUnreadMessages) + ") ")]) : e._e()])];
    } }]), model: { value: e.activeTab, callback: function(r) {
      e.activeTab = r;
    }, expression: "activeTab" } })], 1)];
  }, proxy: !0 }, e.newsItem ? { key: "content", fn: function() {
    return [e.activeTabIndex === 0 && !e.diffMode ? n("NewsCodesCtr", { attrs: { newsItemId: e.newsItem.id } }) : e._e(), e.activeTabIndex === 0 && e.diffMode ? n("NewsCodesDiff", { attrs: { newsItemId: e.newsItem.id } }) : e._e(), e.activeTabIndex === 1 ? n("NewsItemChat", { attrs: { newsItemId: e.newsItem.id, parentPanel: e.parent } }) : e._e()];
  }, proxy: !0 } : null], null, !0) });
}, p4e = [];
const _N = {
  $style: u4e
};
function h4e(t) {
  for (var e in _N)
    this[e] = _N[e];
}
var m4e = /* @__PURE__ */ B(
  d4e,
  f4e,
  p4e,
  !1,
  h4e,
  null
);
const v4e = m4e.exports, B2 = {
  color: "000000",
  accentColor: "BD985C",
  backgroundColor: "FFF6E6",
  editorControlBgColor: "FBE9CB",
  editorControlColor: "4D4D4D",
  innerBorderColor: "D0D0D0"
}, g4e = "_empty_c0ps9_1", y4e = {
  empty: g4e
}, b4e = {
  name: "CanvasCodesRecommended",
  components: {
    NewsCodesList: $u
  },
  props: {
    canvasId: {
      type: [String, Number],
      required: !0
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedCodeIds: []
    };
  },
  computed: {
    ...pe("canvases", ["getCanvasPredictedCodes"]),
    predictedCodes() {
      return this.getCanvasPredictedCodes(this.canvasId);
    },
    recommendedCodes() {
      var t;
      if ((t = this.predictedCodes) != null && t.codes) {
        const e = Object.values(this.newsCodes).map((n) => n == null ? void 0 : n.id);
        return this.predictedCodes.codes.filter(({ code: n }) => {
          var r, s;
          return e.includes(n.id) && !((r = this.predictedCodes) != null && r.deleted.includes(n.id)) && !((s = this.predictedCodes) != null && s.added.includes(n.id));
        }).map((n) => n.code);
      }
    }
  },
  created() {
    this.setPredictedCodes({ canvasId: this.canvasId, codes: [] }), this.$emit("predictCodes");
  },
  beforeDestroy() {
    var t;
    (t = this.predictedCodes) != null && t.deleted && this.predictedCodes.deleted.forEach((e) => {
      this.removePredictedDeleted({ canvasId: this.canvasId, codeId: e });
    });
  },
  methods: {
    ...ge("canvases", {
      addCodes: "addCodes",
      setPredictedCodes: "setPredictedCodes",
      addPredictedAdded: "addPredictedAdded",
      addPredictedDeleted: "addPredictedDeleted",
      removePredictedDeleted: "removePredictedDeleted"
    }),
    async applySelected() {
      let t = this.selectedCodeIds;
      this.addPredictedAdded({ canvasId: this.canvasId, codeIds: t }), this.selectedCodeIds = [], await this.addCodes({ canvasId: this.canvasId, codeIds: t });
    },
    addRecommendedCode(t) {
      this.selectedCodeIds.push(t), setTimeout(() => {
        this.applySelected(), this.$emit("predictCodes");
      }, 1e3);
    },
    deleteRecommendedCode(t) {
      const e = this.selectedCodeIds.indexOf(t);
      e !== -1 && this.selectedCodeIds.splice(e, 1), this.addPredictedDeleted({ canvasId: this.canvasId, codeId: t }), this.$emit("predictCodes");
    }
  }
};
var _4e = function() {
  var e = this, n = e._self._c;
  return e.recommendedCodes.length ? n("div", [n("NewsCodesList", { attrs: { codes: e.recommendedCodes, appliedCodeIds: e.selectedCodeIds, isEditable: !0, isApplicable: !0, newsCodes: e.newsCodes }, on: { codeChecked: e.addRecommendedCode, codeDeleted: e.deleteRecommendedCode } })], 1) : n("div", { class: e.$style.empty }, [e._v(" Вы добавили в новость или удалили все из рекомендованных кодов ")]);
}, w4e = [];
const wN = {
  $style: y4e
};
function S4e(t) {
  for (var e in wN)
    this[e] = wN[e];
}
var I4e = /* @__PURE__ */ B(
  b4e,
  _4e,
  w4e,
  !1,
  S4e,
  null
);
const E4e = I4e.exports, x4e = "_empty_14zam_1", C4e = {
  empty: x4e
}, T4e = {
  name: "CanvasAppliedCodes",
  components: {
    NewsCodesList: $u
  },
  props: {
    canvas: {
      type: Object,
      required: !0
    },
    appliedPredictedCodeIds: {
      type: Array,
      default: () => []
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    colorScheme: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const e = le(() => t.canvas.codes.map(({ code: r }) => r)), { groupedCodes: n } = F2(e);
    return { canvasCodes: e, groupedCodes: n };
  }
};
var P4e = function() {
  var e = this, n = e._self._c;
  return n("div", [e.canvasCodes.length ? e._e() : n("div", { class: e.$style.empty }, [e._v(" Добавленных кодов нет ")]), n("NewsCodesList", { attrs: { codes: e.groupedCodes, appliedCodeIds: e.appliedPredictedCodeIds, isEditable: !0, newsCodes: e.newsCodes, colorScheme: e.colorScheme }, on: { codeDeleted: function(r) {
    return e.$emit("codeDeleted", r);
  } } })], 1);
}, k4e = [];
const SN = {
  $style: C4e
};
function N4e(t) {
  for (var e in SN)
    this[e] = SN[e];
}
var $4e = /* @__PURE__ */ B(
  T4e,
  P4e,
  k4e,
  !1,
  N4e,
  null
);
const D4e = $4e.exports, A4e = "_root_opxuf_1", O4e = "__loading_opxuf_1", M4e = "_section_opxuf_6", R4e = "_title_opxuf_14", L4e = "_button_opxuf_23", F4e = "_button_refresh_opxuf_31", B4e = "_button_close_opxuf_38", j4e = "_icon_opxuf_48", W4e = {
  root: A4e,
  _loading: O4e,
  section: M4e,
  title: R4e,
  button: L4e,
  button_refresh: F4e,
  button_close: B4e,
  icon: j4e
}, H4e = {
  name: "CanvasCodes",
  components: {
    PbButton: nt,
    CanvasCodesRecommended: E4e,
    CanvasAppliedCodes: D4e
  },
  props: {
    canvas: {
      type: Object,
      required: !0
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    tickerCodes: {
      type: Array,
      default: () => []
    },
    appliedPredictedCodeIds: {
      type: Array,
      default: () => []
    }
  }
};
var V4e = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { [e.$style.root]: !0 } }, [n("div", { class: e.$style.section }, [n("div", { class: e.$style.title }, [n("span", [e._v("Рекомендованные коды")]), n("PbButton", { class: [e.$style.button, e.$style.button_refresh], attrs: { title: "Обновить список рекомендованных кодов" }, on: { click: function(r) {
    return e.$emit("predictCodes");
  } } }, [n("icon", { attrs: { name: "refresh", size: "18" } })], 1)], 1), n("CanvasCodesRecommended", { attrs: { canvasId: e.canvas.id, newsCodes: e.newsCodes }, on: { predictCodes: function(r) {
    return e.$emit("predictCodes");
  } } })], 1), n("div", { class: e.$style.section }, [n("div", { class: e.$style.title }, [n("span", [e._v("Публикуемые коды")])]), n("div", { class: e.$style.title }, [n("PbButton", { class: e.$style.button, on: { click: function(r) {
    return e.$emit("showCodeManager", r);
  } } }, [e._v(" + Добавить код ")])], 1), n("CanvasAppliedCodes", { attrs: { canvas: e.canvas, newsCodes: e.newsCodes, appliedPredictedCodeIds: e.appliedPredictedCodeIds }, on: { codeDeleted: function(r) {
    return e.$emit("codeDeleted", r);
  } } })], 1)]);
}, z4e = [];
const IN = {
  $style: W4e
};
function U4e(t) {
  for (var e in IN)
    this[e] = IN[e];
}
var G4e = /* @__PURE__ */ B(
  H4e,
  V4e,
  z4e,
  !1,
  U4e,
  null
);
const Y4e = G4e.exports, Z4e = {
  name: "CanvasCodesCtr",
  components: {
    CanvasCodes: Y4e,
    NewsCodesManager: f6
  },
  props: {
    canvasId: {
      type: [Number, String],
      required: !0
    }
  },
  setup() {
    return { codeManager: Xn({
      isVisible: !1,
      position: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      query: ""
    }) };
  },
  computed: {
    ...pe(["getLayoutLeftOffset"]),
    ...pe("canvases", ["getCanvasPredictedCodes", "getCurrentCanvas", "getCanvasCodes"]),
    ...pe("news/codes", ["regionsCodeId", "getCodesForCanvas"]),
    canvas() {
      return this.getCurrentCanvas;
    },
    appliedPredictedCodeIds() {
      const t = this.getCanvasPredictedCodes(this.canvasId);
      return (t == null ? void 0 : t.added) || [];
    },
    isSelectable() {
      return (t) => t.track.includes(this.iptcCodeId) || t.track.includes(this.regionsCodeId) ? !0 : !t.children || !t.children.length;
    },
    canvasCodes() {
      var t;
      return this.getCanvasCodes((t = this.canvas) == null ? void 0 : t.id);
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...ge("canvases", {
      addCodes: "addCodes",
      deleteCodes: "deleteCodes",
      removePredictedAdded: "removePredictedAdded",
      async deleteCode(t, e) {
        this.removePredictedAdded({ canvasId: this.canvasId, codeId: e }), await t("deleteCodes", {
          canvasId: this.canvasId,
          codeIds: [e],
          inTextCheck: !0
        });
      },
      async predictCodes(t) {
        await t("predictCodes", { canvasId: this.canvasId });
      }
    }),
    ...ge(["setCodeManagerFocus"]),
    onResize(t = !1) {
      if (t || this.codeManager.isVisible) {
        const e = this.$el.closest(".panel-container"), n = e.getBoundingClientRect(), s = e.querySelector(".panel.newsCanvas").getBoundingClientRect(), i = document.querySelector("#legacy-app");
        this.codeManager.position = {
          top: n.top,
          left: n.left + i.scrollLeft - this.getLayoutLeftOffset,
          width: n.width,
          height: n.height,
          wrapperWidth: s.width
        };
      }
    },
    async applyCodes(t) {
      await this.addCodes({ canvasId: this.canvasId, codeIds: t }), this.predictCodes();
    },
    showCodeManager() {
      this.onResize(!0), this.codeManager.isVisible = !0, this.setCodeManagerFocus(!0);
    },
    hideCodeManager() {
      this.codeManager.isVisible = !1, this.setCodeManagerFocus(!1);
    }
  }
};
var X4e = function() {
  var e = this, n = e._self._c;
  return n("div", [e.canvas ? n("CanvasCodes", { attrs: { canvas: e.canvas, newsCodes: e.getCodesForCanvas, appliedPredictedCodeIds: e.appliedPredictedCodeIds }, on: { predictCodes: e.predictCodes, codeDeleted: e.deleteCode, showCodeManager: e.showCodeManager, keepCodeId: function(r) {
    return e.addKeepCodeId(r);
  } } }) : e._e(), n("portal", { attrs: { to: "newsTextEditorWidgets" } }, [e.codeManager.isVisible ? n("NewsCodesManager", { attrs: { isVisible: e.codeManager.isVisible, position: e.codeManager.position, newsCodes: e.getCodesForCanvas, versionCodes: e.canvasCodes, isSelectable: e.isSelectable }, on: { hide: e.hideCodeManager, applyCodes: e.applyCodes } }) : e._e()], 1)], 1);
}, K4e = [], J4e = /* @__PURE__ */ B(
  Z4e,
  X4e,
  K4e,
  !1,
  null,
  null
);
const q4e = J4e.exports, Q4e = {
  name: "NewsCanvasCodesPanel",
  components: {
    Panel: bs,
    PbButton: nt,
    CanvasCodesCtr: q4e
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      canvasColors: B2
    };
  },
  computed: {
    ...pe("canvases", ["getCurrentCanvas"]),
    canvas() {
      return this.getCurrentCanvas;
    }
  }
};
var eRe = function() {
  var e = this, n = e._self._c;
  return n("Panel", { staticClass: "canvas-codes-panel", attrs: { title: "Коды", panel: e.panel, resizeable: !1, backgroundColor: `#${e.canvasColors.backgroundColor}`, styles: {
    body: { borderLeft: "1px solid #" + e.canvasColors.innerBorderColor }
  }, toolbarProps: {
    styleContent: { padding: "5px 15px" },
    styleRoot: {
      color: e.canvasColors.color,
      fontWeight: "400",
      borderLeft: "1px solid #" + e.canvasColors.innerBorderColor,
      borderBottom: "1px solid #" + e.canvasColors.innerBorderColor
    }
  }, toolbarColor: "inherit" }, scopedSlots: e._u([{ key: "pre-title", fn: function() {
    return [n("icon", { attrs: { name: "codes" } })];
  }, proxy: !0 }, { key: "appBarActions", fn: function() {
    return [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.bottom", value: "Закрыть коды", expression: "'Закрыть коды'", modifiers: { bottom: !0 } }], style: {
      color: "#" + e.canvasColors.editorControlColor,
      width: "22px",
      height: "22px"
    }, attrs: { round: "" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.$emit("hideSupply", {
        panelId: e.parent.id,
        supplyId: e.panel.id
      });
    } } }, [n("icon", { attrs: { name: "close", size: 10 } })], 1)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [e.canvas ? n("CanvasCodesCtr", { attrs: { canvasId: e.canvas.id } }) : e._e()];
  }, proxy: !0 }]) });
}, tRe = [], nRe = /* @__PURE__ */ B(
  Q4e,
  eRe,
  tRe,
  !1,
  null,
  null
);
const rRe = nRe.exports;
function h6({ newsItemIdRef: t }, e) {
  const n = {
    newsItemUserCanWorkNames: e.getters["news/newsItemUserCanWorkNames"],
    getNewsItemById: e.getters["news/getNewsItemById"]
  };
  return {
    relatedPeople: le(() => {
      const s = n.getNewsItemById(t.value);
      if (s != null && s.groups && (s != null && s.users)) {
        const i = s.groups.map(({ group: a }) => "группа " + a.name), o = n.newsItemUserCanWorkNames(t.value);
        return [...i, ...o].join(", ");
      }
      return "";
    })
  };
}
function m6({ draftRv: t, allCodesRv: e }, n) {
  const r = {
    publishMap: le(() => n.state.news.drafts.publicationMap)
  }, s = {
    addPubCode: (a) => n.dispatch("news/drafts/addPubCode", {
      draftId: t.value.id,
      codeId: a.id
    }),
    deletePubCode: (a) => n.dispatch("news/drafts/removePubCode", {
      draftId: t.value.id,
      codeId: a.id
    }),
    enablePublishMode: (a) => n.dispatch("news/drafts/enablePublishMode", a),
    disablePublishMode: (a) => n.dispatch("news/drafts/disablePublishMode", a)
  }, i = le(() => {
    var l;
    const a = (l = t == null ? void 0 : t.value) == null ? void 0 : l.id;
    return r.publishMap.value[a] ?? [];
  }), o = le(() => i.value.map((a) => e.value[a]) ?? []);
  return {
    ...s,
    pickedCodes: o,
    pickedCodesIds: i
  };
}
const sRe = {
  name: "NewsItemPublishCtr",
  components: {
    PbCodeManager: Hv,
    PbManagerSelectedItems: Ru,
    NewsItemEmbargoCtr: Fu
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    isPanelFocused: {
      type: Boolean,
      default: !1
    },
    isPanelMaximized: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Jt("store"), n = {
      isNewsItemExtension: e.getters["news/isNewsItemExtension"]
    }, r = {
      updateEmbargo: (...k) => e.dispatch("news/drafts/updateEmbargo", ...k),
      updatePostponed: (...k) => e.dispatch("news/drafts/updatePostponed", ...k),
      saveDraft: (...k) => e.dispatch("news/drafts/saveDraft", ...k)
    }, { newsItemId: s } = ts(t), { draft: i, draftVersion: o, setEmbargoForm: a, validateEmbargo: l } = Bu(
      { newsItemIdRef: s },
      e
    ), { isEditable: c } = Zi({ newsItemIdRef: s }, e, o), { isEmbargoFormVisible: u, isEmbargoValid: d, isScheduled: f } = dc(
      {
        draftRv: i,
        versionRv: o
      },
      e
    ), { allCodes: p, publicationCodes: h } = M2(
      { versionRv: o },
      e
    ), {
      pickedCodesIds: m,
      addPubCode: v,
      deletePubCode: y,
      pickedCodes: _
    } = m6({ draftRv: i, allCodesRv: p }, e), w = le(() => n.isNewsItemExtension(t.newsItemId) ? p.value : h.value);
    return {
      draft: i,
      isEditable: c,
      version: o,
      isEmbargoFormVisible: u,
      isEmbargoValid: d,
      isScheduled: f,
      allCodes: p,
      pickedCodes: _,
      publicationCodes: h,
      availableItems: w,
      pickedCodesIds: m,
      addCode: (k) => v({ id: k }),
      deleteCode: (k) => y({ id: k }),
      setEmbargoForm: a,
      validateEmbargo: l,
      setEmbargo: (k) => {
        r.updateEmbargo({
          newsItemId: t.newsItemId,
          value: k
        }), r.saveDraft({ newsItemId: t.newsItemId });
      },
      setPostponed: async (k) => {
        await r.updatePostponed({
          newsItemId: t.newsItemId,
          value: k
        }), r.saveDraft({ newsItemId: t.newsItemId });
      },
      cancel: () => {
        !o.value.publish_at && o.value.is_postponed === !1 && a({ draftId: i.value.id, value: !1 });
      }
    };
  },
  computed: {
    ...pe("news", ["newsItemLanguageName", "isNewsItemExtension"]),
    ...pe("references", ["codeTypeIds"]),
    ...pe({
      editorFocused: "editorInPanelFocused"
    }),
    publicationCodesLoaded() {
      return Object.keys(this.publicationCodes).length > 0;
    },
    isSelectable() {
      return (t) => !t.children || !t.children.length;
    }
  },
  watch: {
    isPanelFocused(t, e) {
      t !== e && t === !1 && this.$emit("editorFocus", !1);
    },
    "version.publish_at": function(t, e) {
      this.isPublished || t && t !== e && (this.validateEmbargo({ draftId: this.draft.id }), this.version.is_postponed || this.setEmbargoForm({ draftId: this.draft.id, value: !!t }));
    },
    "version.is_postponed": function(t, e) {
      this.isPublished || !this.draft || t !== e && (this.validateEmbargo({ draftId: this.draft.id }), t ? !this.isEmbargoFormVisible && !this.version.publish_at && this.setEmbargoForm({ draftId: this.draft.id, value: !0 }) : !this.isEditable && !this.publishMode && this.setEmbargoForm({ draftId: this.draft.id, value: !1 }));
    }
  },
  created() {
    this.publicationCodesLoaded || this.fetchProfileCodes(this.codeTypeIds.PUBLISH_NEWS);
  },
  mounted() {
    var e, n;
    document.addEventListener("keydown", this.keyboardHandler, {
      capture: !0
    });
    const t = Object.keys(this.allCodes);
    (n = (e = this.version) == null ? void 0 : e.codes) != null && n.length && this.version.codes.forEach(({ code: r }) => {
      t.includes("" + r.id) && this.addCode(r.id);
    });
  },
  beforeDestroy() {
    this.$emit("editorFocus", !1), document.removeEventListener("keydown", this.keyboardHandler, {
      capture: !0
    });
  },
  methods: {
    ...ge({
      setFocus: "setPanelEditorFocus"
    }),
    ...ge("news/codes", ["fetchProfileCodes"]),
    checkDisabled(t) {
      return t.is_en && this.version.language_id === 1 || !this.publicationCodes[t.id];
    },
    keyboardHandler(t) {
      if (t.type !== "keyup" && !(t.altKey || t.ctrlKey || t.metaKey || t.shiftKey) && this.isPanelFocused) {
        const e = lt(this.$refs, "codeManager.$refs.searchField");
        switch (t.key) {
          case "Enter":
            t.stopPropagation(), t.preventDefault(), this.editorFocused || (this.$emit("editorFocus", !0), e && e.focus());
            break;
          case "Escape":
            this.editorFocused && (this.$emit("editorFocus", !1), e && e.blur());
            break;
        }
      }
    }
  }
};
var iRe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "news-item-publish-wrapper" }, [e.isEmbargoFormVisible ? n("NewsItemEmbargoCtr", { attrs: { newsItemId: e.newsItemId, version: e.draft.version, isDraft: !0, isRemovable: !0, isEditable: !0, autoOpen: !1 }, on: { removeEmbargo: function(r) {
    return e.setEmbargoForm({ draftId: e.draft.id, value: !1 });
  } } }) : e._e(), n("PbCodeManager", { staticClass: "news-item-publish-manager", attrs: { pickedCodes: e.pickedCodesIds, allCodes: e.allCodes, visibleCodes: e.allCodes, checkDisabled: e.checkDisabled, isSelectable: e.isSelectable, maxHeight: 1e3, fontSize: 16, disabledReason: "Неподходящий язык новости" }, on: { codeAdded: e.addCode, codeDeleted: e.deleteCode } }), n("PbManagerSelectedItems", { staticClass: "news-item-publish-picked", attrs: { availableItems: e.availableItems, items: e.allCodes, selectedItems: e.pickedCodesIds.map((r) => ({ id: r, state: "included" })), title: "Коды", labels: ["name"], isRemovable: !0, noItemsText: "Коды не выбраны" }, on: { remove: e.deleteCode } })], 1);
}, oRe = [], aRe = /* @__PURE__ */ B(
  sRe,
  iRe,
  oRe,
  !1,
  null,
  "7d1707fe"
);
const lRe = aRe.exports, cRe = {
  mixins: [ai],
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    panelId: {
      type: [String, Number]
    },
    statusText: {
      type: String,
      default: ""
    },
    iconSize: {
      type: Number,
      default: 14.4
      // При четном width,hieght flex хорошо центрирует икноку только при размерах (n/10)em: 14.4px = 0.8em
    }
  },
  setup(t) {
    const { newsItemId: e } = ts(t), n = Jt("store"), { version: r } = Zi({ newsItemIdRef: e }, n), { version: s } = eg(t.newsItemId, n), i = {
      getIsPanelHistoryMode: n.getters["panels/getIsPanelHistoryMode"]
    };
    return {
      version: le(
        () => i.getIsPanelHistoryMode(t.panelId) ? s.value : r.value
      )
    };
  },
  computed: {
    ...pe("references", ["newsStatuses"]),
    ...pe("news/versions", ["getVersionStatus"]),
    statusIcon() {
      var r;
      const t = {
        DRAFT: "outline/edit",
        ON_EDIT: "outline/edit",
        WAITS_FOR_EDIT: "outline/embargo",
        WAITS_FOR_PUBLICATION: "outline/embargo",
        PUBLISHING: "outline/embargo",
        DISPOSED: "outline/trash",
        PUBLISHED: "outline/publish"
      }, e = t.ON_EDIT, n = this.newsStatuses[(r = this.version) == null ? void 0 : r.status_id];
      return n && n.name ? t[n.name] : e;
    },
    statusTextComputed() {
      return this.statusText ? this.statusText : this.getVersionStatus(this.version);
    }
  }
};
var uRe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "news-item-status", attrs: { "data-test-selector": "news-item-status" } }, [n("div", { staticClass: "status-icon-wrap" }, [e.statusIcon ? n("icon", { staticClass: "status-icon", attrs: { name: e.statusIcon, size: e.iconSize } }) : e._e()], 1), e.statusTextComputed ? n("div", { staticClass: "status-text" }, [e._v(" " + e._s(e.statusTextComputed) + " ")]) : e._e()]);
}, dRe = [], fRe = /* @__PURE__ */ B(
  cRe,
  uRe,
  dRe,
  !1,
  null,
  "6b96b49e"
);
const v6 = fRe.exports;
function Yf() {
  return {
    // Молния
    1: ["slugline", "headline"],
    // Экспресс
    2: ["slugline", "headline", "subheadline", "trashline", "dateline", "body"],
    // Новость
    3: ["slugline", "headline", "subheadline", "trashline", "dateline", "body"],
    // Выпуск
    4: ["slugline", "headline", "body"],
    // Анонс
    5: ["slugline", "headline", "subheadline", "body"],
    // Пресс-релиз
    6: ["slugline", "headline", "subheadline", "body"],
    // Сводка событий
    7: ["slugline", "headline", "subheadline", "body"],
    // Комментарий
    8: ["slugline", "headline", "body"],
    // Обзор
    9: ["slugline", "headline", "body"],
    // Служебное сообщение
    10: ["slugline", "headline", "subheadline", "trashline", "dateline", "body"]
  };
}
function Tc(t) {
  return {
    title: "Текст",
    type: "text",
    format: "plain",
    visible: !0,
    errors: [],
    warnings: [],
    maxSymbols: 1 / 0,
    initial: !0,
    initialized: !1,
    ...t
  };
}
function ju(t = void 0) {
  return [
    Tc({
      title: "Слаглайн",
      type: "slugline"
    }),
    Tc({
      maxSymbols: 200,
      title: "Заголовок",
      type: "headline"
    }),
    Tc({
      maxSymbols: 500,
      title: "Подзаголовок",
      type: "subheadline",
      visible: !1
    }),
    Tc({
      title: "Трешлайн",
      type: "trashline",
      visible: !1
    }),
    Tc({
      title: "Дейтлайн",
      type: "dateline",
      disabled: !0,
      visible: t !== 10
      // Для служебного сообщения прячем по дефолту это поле
    }),
    Tc({
      format: "html",
      title: "Текст",
      type: "body",
      visible: t !== 10
      // Для служебного сообщения прячем по дефолту это поле
    })
  ];
}
function g6({ newsItemIdRef: t }, e) {
  const n = {
    getNewsItemById: e.getters["news/getNewsItemById"],
    getNewsItemCurrentVersion: e.getters["news/getNewsItemCurrentVersion"],
    newsStatusesByName: e.getters["references/newsStatusesByName"]
  }, r = le(
    () => {
      var a;
      return (a = n.getNewsItemById(t.value)) == null ? void 0 : a.disposal_reason;
    }
  ), s = le(
    () => {
      var a;
      return (a = n.getNewsItemById(t.value)) == null ? void 0 : a.disposer;
    }
  ), i = le(() => {
    var a;
    return Ps((a = s == null ? void 0 : s.value) == null ? void 0 : a.name);
  }), o = le(
    () => {
      var a, l;
      return ((a = n.getNewsItemCurrentVersion(t.value)) == null ? void 0 : a.status_id) === ((l = n.newsStatusesByName.DISPOSED) == null ? void 0 : l.id);
    }
  );
  return {
    disposalReason: r,
    disposedBy: s,
    disposerName: i,
    isDisposed: o
  };
}
function Zr(t) {
  this.content = t;
}
Zr.prototype = {
  constructor: Zr,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, s = r.find(t), i = r.content.slice();
    return s == -1 ? i.push(n || t, e) : (i[s + 1] = e, n && (i[s] = n)), new Zr(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new Zr(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new Zr([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new Zr(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), s = r.content.slice(), i = r.find(t);
    return s.splice(i == -1 ? s.length : i, 0, e, n), new Zr(s);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = Zr.from(t), t.size ? new Zr(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = Zr.from(t), t.size ? new Zr(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = Zr.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Zr.from = function(t) {
  if (t instanceof Zr) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new Zr(e);
};
function y6(t, e, n) {
  for (var r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    var s = t.child(r), i = e.child(r);
    if (s == i) {
      n += s.nodeSize;
      continue;
    }
    if (!s.sameMarkup(i))
      return n;
    if (s.isText && s.text != i.text) {
      for (var o = 0; s.text[o] == i.text[o]; o++)
        n++;
      return n;
    }
    if (s.content.size || i.content.size) {
      var a = y6(s.content, i.content, n + 1);
      if (a != null)
        return a;
    }
    n += s.nodeSize;
  }
}
function b6(t, e, n, r) {
  for (var s = t.childCount, i = e.childCount; ; ) {
    if (s == 0 || i == 0)
      return s == i ? null : { a: n, b: r };
    var o = t.child(--s), a = e.child(--i), l = o.nodeSize;
    if (o == a) {
      n -= l, r -= l;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: n, b: r };
    if (o.isText && o.text != a.text) {
      for (var c = 0, u = Math.min(o.text.length, a.text.length); c < u && o.text[o.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (o.content.size || a.content.size) {
      var d = b6(o.content, a.content, n - 1, r - 1);
      if (d)
        return d;
    }
    n -= l, r -= l;
  }
}
var xe = function(e, n) {
  if (this.content = e, this.size = n || 0, n == null)
    for (var r = 0; r < e.length; r++)
      this.size += e[r].nodeSize;
}, tg = { firstChild: { configurable: !0 }, lastChild: { configurable: !0 }, childCount: { configurable: !0 } };
xe.prototype.nodesBetween = function(e, n, r, s, i) {
  s === void 0 && (s = 0);
  for (var o = 0, a = 0; a < n; o++) {
    var l = this.content[o], c = a + l.nodeSize;
    if (c > e && r(l, s + a, i, o) !== !1 && l.content.size) {
      var u = a + 1;
      l.nodesBetween(
        Math.max(0, e - u),
        Math.min(l.content.size, n - u),
        r,
        s + u
      );
    }
    a = c;
  }
};
xe.prototype.descendants = function(e) {
  this.nodesBetween(0, this.size, e);
};
xe.prototype.textBetween = function(e, n, r, s) {
  var i = "", o = !0;
  return this.nodesBetween(e, n, function(a, l) {
    a.isText ? (i += a.text.slice(Math.max(e, l) - l, n - l), o = !r) : a.isLeaf && s ? (i += s, o = !r) : !o && a.isBlock && (i += r, o = !0);
  }, 0), i;
};
xe.prototype.append = function(e) {
  if (!e.size)
    return this;
  if (!this.size)
    return e;
  var n = this.lastChild, r = e.firstChild, s = this.content.slice(), i = 0;
  for (n.isText && n.sameMarkup(r) && (s[s.length - 1] = n.withText(n.text + r.text), i = 1); i < e.content.length; i++)
    s.push(e.content[i]);
  return new xe(s, this.size + e.size);
};
xe.prototype.cut = function(e, n) {
  if (n == null && (n = this.size), e == 0 && n == this.size)
    return this;
  var r = [], s = 0;
  if (n > e)
    for (var i = 0, o = 0; o < n; i++) {
      var a = this.content[i], l = o + a.nodeSize;
      l > e && ((o < e || l > n) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, n - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, n - o - 1))), r.push(a), s += a.nodeSize), o = l;
    }
  return new xe(r, s);
};
xe.prototype.cutByIndex = function(e, n) {
  return e == n ? xe.empty : e == 0 && n == this.content.length ? this : new xe(this.content.slice(e, n));
};
xe.prototype.replaceChild = function(e, n) {
  var r = this.content[e];
  if (r == n)
    return this;
  var s = this.content.slice(), i = this.size + n.nodeSize - r.nodeSize;
  return s[e] = n, new xe(s, i);
};
xe.prototype.addToStart = function(e) {
  return new xe([e].concat(this.content), this.size + e.nodeSize);
};
xe.prototype.addToEnd = function(e) {
  return new xe(this.content.concat(e), this.size + e.nodeSize);
};
xe.prototype.eq = function(e) {
  if (this.content.length != e.content.length)
    return !1;
  for (var n = 0; n < this.content.length; n++)
    if (!this.content[n].eq(e.content[n]))
      return !1;
  return !0;
};
tg.firstChild.get = function() {
  return this.content.length ? this.content[0] : null;
};
tg.lastChild.get = function() {
  return this.content.length ? this.content[this.content.length - 1] : null;
};
tg.childCount.get = function() {
  return this.content.length;
};
xe.prototype.child = function(e) {
  var n = this.content[e];
  if (!n)
    throw new RangeError("Index " + e + " out of range for " + this);
  return n;
};
xe.prototype.maybeChild = function(e) {
  return this.content[e];
};
xe.prototype.forEach = function(e) {
  for (var n = 0, r = 0; n < this.content.length; n++) {
    var s = this.content[n];
    e(s, r, n), r += s.nodeSize;
  }
};
xe.prototype.findDiffStart = function(e, n) {
  return n === void 0 && (n = 0), y6(this, e, n);
};
xe.prototype.findDiffEnd = function(e, n, r) {
  return n === void 0 && (n = this.size), r === void 0 && (r = e.size), b6(this, e, n, r);
};
xe.prototype.findIndex = function(e, n) {
  if (n === void 0 && (n = -1), e == 0)
    return $p(0, e);
  if (e == this.size)
    return $p(this.content.length, e);
  if (e > this.size || e < 0)
    throw new RangeError("Position " + e + " outside of fragment (" + this + ")");
  for (var r = 0, s = 0; ; r++) {
    var i = this.child(r), o = s + i.nodeSize;
    if (o >= e)
      return o == e || n > 0 ? $p(r + 1, o) : $p(r, s);
    s = o;
  }
};
xe.prototype.toString = function() {
  return "<" + this.toStringInner() + ">";
};
xe.prototype.toStringInner = function() {
  return this.content.join(", ");
};
xe.prototype.toJSON = function() {
  return this.content.length ? this.content.map(function(e) {
    return e.toJSON();
  }) : null;
};
xe.fromJSON = function(e, n) {
  if (!n)
    return xe.empty;
  if (!Array.isArray(n))
    throw new RangeError("Invalid input for Fragment.fromJSON");
  return new xe(n.map(e.nodeFromJSON));
};
xe.fromArray = function(e) {
  if (!e.length)
    return xe.empty;
  for (var n, r = 0, s = 0; s < e.length; s++) {
    var i = e[s];
    r += i.nodeSize, s && i.isText && e[s - 1].sameMarkup(i) ? (n || (n = e.slice(0, s)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
  }
  return new xe(n || e, r);
};
xe.from = function(e) {
  if (!e)
    return xe.empty;
  if (e instanceof xe)
    return e;
  if (Array.isArray(e))
    return this.fromArray(e);
  if (e.attrs)
    return new xe([e], e.nodeSize);
  throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
};
Object.defineProperties(xe.prototype, tg);
var Ky = { index: 0, offset: 0 };
function $p(t, e) {
  return Ky.index = t, Ky.offset = e, Ky;
}
xe.empty = new xe([], 0);
function Um(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  var n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (var r = 0; r < t.length; r++)
      if (!Um(t[r], e[r]))
        return !1;
  } else {
    for (var s in t)
      if (!(s in e) || !Um(t[s], e[s]))
        return !1;
    for (var i in e)
      if (!(i in t))
        return !1;
  }
  return !0;
}
var Xt = function(e, n) {
  this.type = e, this.attrs = n;
};
Xt.prototype.addToSet = function(e) {
  for (var n, r = !1, s = 0; s < e.length; s++) {
    var i = e[s];
    if (this.eq(i))
      return e;
    if (this.type.excludes(i.type))
      n || (n = e.slice(0, s));
    else {
      if (i.type.excludes(this.type))
        return e;
      !r && i.type.rank > this.type.rank && (n || (n = e.slice(0, s)), n.push(this), r = !0), n && n.push(i);
    }
  }
  return n || (n = e.slice()), r || n.push(this), n;
};
Xt.prototype.removeFromSet = function(e) {
  for (var n = 0; n < e.length; n++)
    if (this.eq(e[n]))
      return e.slice(0, n).concat(e.slice(n + 1));
  return e;
};
Xt.prototype.isInSet = function(e) {
  for (var n = 0; n < e.length; n++)
    if (this.eq(e[n]))
      return !0;
  return !1;
};
Xt.prototype.eq = function(e) {
  return this == e || this.type == e.type && Um(this.attrs, e.attrs);
};
Xt.prototype.toJSON = function() {
  var e = { type: this.type.name };
  for (var n in this.attrs) {
    e.attrs = this.attrs;
    break;
  }
  return e;
};
Xt.fromJSON = function(e, n) {
  if (!n)
    throw new RangeError("Invalid input for Mark.fromJSON");
  var r = e.marks[n.type];
  if (!r)
    throw new RangeError("There is no mark type " + n.type + " in this schema");
  return r.create(n.attrs);
};
Xt.sameSet = function(e, n) {
  if (e == n)
    return !0;
  if (e.length != n.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!e[r].eq(n[r]))
      return !1;
  return !0;
};
Xt.setFrom = function(e) {
  if (!e || e.length == 0)
    return Xt.none;
  if (e instanceof Xt)
    return [e];
  var n = e.slice();
  return n.sort(function(r, s) {
    return r.type.rank - s.type.rank;
  }), n;
};
Xt.none = [];
function So(t) {
  var e = Error.call(this, t);
  return e.__proto__ = So.prototype, e;
}
So.prototype = Object.create(Error.prototype);
So.prototype.constructor = So;
So.prototype.name = "ReplaceError";
var He = function(e, n, r) {
  this.content = e, this.openStart = n, this.openEnd = r;
}, _6 = { size: { configurable: !0 } };
_6.size.get = function() {
  return this.content.size - this.openStart - this.openEnd;
};
He.prototype.insertAt = function(e, n) {
  var r = S6(this.content, e + this.openStart, n, null);
  return r && new He(r, this.openStart, this.openEnd);
};
He.prototype.removeBetween = function(e, n) {
  return new He(w6(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
};
He.prototype.eq = function(e) {
  return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
};
He.prototype.toString = function() {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")";
};
He.prototype.toJSON = function() {
  if (!this.content.size)
    return null;
  var e = { content: this.content.toJSON() };
  return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
};
He.fromJSON = function(e, n) {
  if (!n)
    return He.empty;
  var r = n.openStart || 0, s = n.openEnd || 0;
  if (typeof r != "number" || typeof s != "number")
    throw new RangeError("Invalid input for Slice.fromJSON");
  return new He(xe.fromJSON(e, n.content), r, s);
};
He.maxOpen = function(e, n) {
  n === void 0 && (n = !0);
  for (var r = 0, s = 0, i = e.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
    r++;
  for (var o = e.lastChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.lastChild)
    s++;
  return new He(e, r, s);
};
Object.defineProperties(He.prototype, _6);
function w6(t, e, n) {
  var r = t.findIndex(e), s = r.index, i = r.offset, o = t.maybeChild(s), a = t.findIndex(n), l = a.index, c = a.offset;
  if (i == e || o.isText) {
    if (c != n && !t.child(l).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (s != l)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(s, o.copy(w6(o.content, e - i - 1, n - i - 1)));
}
function S6(t, e, n, r) {
  var s = t.findIndex(e), i = s.index, o = s.offset, a = t.maybeChild(i);
  if (o == e || a.isText)
    return r && !r.canReplace(i, i, n) ? null : t.cut(0, e).append(n).append(t.cut(e));
  var l = S6(a.content, e - o - 1, n);
  return l && t.replaceChild(i, a.copy(l));
}
He.empty = new He(xe.empty, 0, 0);
function pRe(t, e, n) {
  if (n.openStart > t.depth)
    throw new So("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new So("Inconsistent open depths");
  return I6(t, e, n, 0);
}
function I6(t, e, n, r) {
  var s = t.index(r), i = t.node(r);
  if (s == e.index(r) && r < t.depth - n.openStart) {
    var o = I6(t, e, n, r + 1);
    return i.copy(i.content.replaceChild(s, o));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      var a = t.parent, l = a.content;
      return Vl(a, l.cut(0, t.parentOffset).append(n.content).append(l.cut(e.parentOffset)));
    } else {
      var c = hRe(n, t), u = c.start, d = c.end;
      return Vl(i, x6(t, u, d, e, r));
    }
  else return Vl(i, Gm(t, e, r));
}
function E6(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new So("Cannot join " + e.type.name + " onto " + t.type.name);
}
function n1(t, e, n) {
  var r = t.node(n);
  return E6(r, e.node(n)), r;
}
function Hl(t, e) {
  var n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Yd(t, e, n, r) {
  var s = (e || t).node(n), i = 0, o = e ? e.index(n) : s.childCount;
  t && (i = t.index(n), t.depth > n ? i++ : t.textOffset && (Hl(t.nodeAfter, r), i++));
  for (var a = i; a < o; a++)
    Hl(s.child(a), r);
  e && e.depth == n && e.textOffset && Hl(e.nodeBefore, r);
}
function Vl(t, e) {
  if (!t.type.validContent(e))
    throw new So("Invalid content for node " + t.type.name);
  return t.copy(e);
}
function x6(t, e, n, r, s) {
  var i = t.depth > s && n1(t, e, s + 1), o = r.depth > s && n1(n, r, s + 1), a = [];
  return Yd(null, t, s, a), i && o && e.index(s) == n.index(s) ? (E6(i, o), Hl(Vl(i, x6(t, e, n, r, s + 1)), a)) : (i && Hl(Vl(i, Gm(t, e, s + 1)), a), Yd(e, n, s, a), o && Hl(Vl(o, Gm(n, r, s + 1)), a)), Yd(r, null, s, a), new xe(a);
}
function Gm(t, e, n) {
  var r = [];
  if (Yd(null, t, n, r), t.depth > n) {
    var s = n1(t, e, n + 1);
    Hl(Vl(s, Gm(t, e, n + 1)), r);
  }
  return Yd(e, null, n, r), new xe(r);
}
function hRe(t, e) {
  for (var n = e.depth - t.openStart, r = e.node(n), s = r.copy(t.content), i = n - 1; i >= 0; i--)
    s = e.node(i).copy(xe.from(s));
  return {
    start: s.resolveNoCache(t.openStart + n),
    end: s.resolveNoCache(s.content.size - t.openEnd - n)
  };
}
var Vn = function(e, n, r) {
  this.pos = e, this.path = n, this.depth = n.length / 3 - 1, this.parentOffset = r;
}, Wu = { parent: { configurable: !0 }, doc: { configurable: !0 }, textOffset: { configurable: !0 }, nodeAfter: { configurable: !0 }, nodeBefore: { configurable: !0 } };
Vn.prototype.resolveDepth = function(e) {
  return e == null ? this.depth : e < 0 ? this.depth + e : e;
};
Wu.parent.get = function() {
  return this.node(this.depth);
};
Wu.doc.get = function() {
  return this.node(0);
};
Vn.prototype.node = function(e) {
  return this.path[this.resolveDepth(e) * 3];
};
Vn.prototype.index = function(e) {
  return this.path[this.resolveDepth(e) * 3 + 1];
};
Vn.prototype.indexAfter = function(e) {
  return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
};
Vn.prototype.start = function(e) {
  return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
};
Vn.prototype.end = function(e) {
  return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
};
Vn.prototype.before = function(e) {
  if (e = this.resolveDepth(e), !e)
    throw new RangeError("There is no position before the top-level node");
  return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
};
Vn.prototype.after = function(e) {
  if (e = this.resolveDepth(e), !e)
    throw new RangeError("There is no position after the top-level node");
  return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
};
Wu.textOffset.get = function() {
  return this.pos - this.path[this.path.length - 1];
};
Wu.nodeAfter.get = function() {
  var t = this.parent, e = this.index(this.depth);
  if (e == t.childCount)
    return null;
  var n = this.pos - this.path[this.path.length - 1], r = t.child(e);
  return n ? t.child(e).cut(n) : r;
};
Wu.nodeBefore.get = function() {
  var t = this.index(this.depth), e = this.pos - this.path[this.path.length - 1];
  return e ? this.parent.child(t).cut(0, e) : t == 0 ? null : this.parent.child(t - 1);
};
Vn.prototype.posAtIndex = function(e, n) {
  n = this.resolveDepth(n);
  for (var r = this.path[n * 3], s = n == 0 ? 0 : this.path[n * 3 - 1] + 1, i = 0; i < e; i++)
    s += r.child(i).nodeSize;
  return s;
};
Vn.prototype.marks = function() {
  var e = this.parent, n = this.index();
  if (e.content.size == 0)
    return Xt.none;
  if (this.textOffset)
    return e.child(n).marks;
  var r = e.maybeChild(n - 1), s = e.maybeChild(n);
  if (!r) {
    var i = r;
    r = s, s = i;
  }
  for (var o = r.marks, a = 0; a < o.length; a++)
    o[a].type.spec.inclusive === !1 && (!s || !o[a].isInSet(s.marks)) && (o = o[a--].removeFromSet(o));
  return o;
};
Vn.prototype.marksAcross = function(e) {
  var n = this.parent.maybeChild(this.index());
  if (!n || !n.isInline)
    return null;
  for (var r = n.marks, s = e.parent.maybeChild(e.index()), i = 0; i < r.length; i++)
    r[i].type.spec.inclusive === !1 && (!s || !r[i].isInSet(s.marks)) && (r = r[i--].removeFromSet(r));
  return r;
};
Vn.prototype.sharedDepth = function(e) {
  for (var n = this.depth; n > 0; n--)
    if (this.start(n) <= e && this.end(n) >= e)
      return n;
  return 0;
};
Vn.prototype.blockRange = function(e, n) {
  if (e === void 0 && (e = this), e.pos < this.pos)
    return e.blockRange(this);
  for (var r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
    if (e.pos <= this.end(r) && (!n || n(this.node(r))))
      return new C6(this, e, r);
};
Vn.prototype.sameParent = function(e) {
  return this.pos - this.parentOffset == e.pos - e.parentOffset;
};
Vn.prototype.max = function(e) {
  return e.pos > this.pos ? e : this;
};
Vn.prototype.min = function(e) {
  return e.pos < this.pos ? e : this;
};
Vn.prototype.toString = function() {
  for (var e = "", n = 1; n <= this.depth; n++)
    e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
  return e + ":" + this.parentOffset;
};
Vn.resolve = function(e, n) {
  if (!(n >= 0 && n <= e.content.size))
    throw new RangeError("Position " + n + " out of range");
  for (var r = [], s = 0, i = n, o = e; ; ) {
    var a = o.content.findIndex(i), l = a.index, c = a.offset, u = i - c;
    if (r.push(o, l, s + c), !u || (o = o.child(l), o.isText))
      break;
    i = u - 1, s += c + 1;
  }
  return new Vn(n, r, i);
};
Vn.resolveCached = function(e, n) {
  for (var r = 0; r < Jy.length; r++) {
    var s = Jy[r];
    if (s.pos == n && s.doc == e)
      return s;
  }
  var i = Jy[qy] = Vn.resolve(e, n);
  return qy = (qy + 1) % mRe, i;
};
Object.defineProperties(Vn.prototype, Wu);
var Jy = [], qy = 0, mRe = 12, C6 = function(e, n, r) {
  this.$from = e, this.$to = n, this.depth = r;
}, Hu = { start: { configurable: !0 }, end: { configurable: !0 }, parent: { configurable: !0 }, startIndex: { configurable: !0 }, endIndex: { configurable: !0 } };
Hu.start.get = function() {
  return this.$from.before(this.depth + 1);
};
Hu.end.get = function() {
  return this.$to.after(this.depth + 1);
};
Hu.parent.get = function() {
  return this.$from.node(this.depth);
};
Hu.startIndex.get = function() {
  return this.$from.index(this.depth);
};
Hu.endIndex.get = function() {
  return this.$to.indexAfter(this.depth);
};
Object.defineProperties(C6.prototype, Hu);
var vRe = /* @__PURE__ */ Object.create(null), jt = function(e, n, r, s) {
  this.type = e, this.attrs = n, this.content = r || xe.empty, this.marks = s || Xt.none;
}, li = { nodeSize: { configurable: !0 }, childCount: { configurable: !0 }, textContent: { configurable: !0 }, firstChild: { configurable: !0 }, lastChild: { configurable: !0 }, isBlock: { configurable: !0 }, isTextblock: { configurable: !0 }, inlineContent: { configurable: !0 }, isInline: { configurable: !0 }, isText: { configurable: !0 }, isLeaf: { configurable: !0 }, isAtom: { configurable: !0 } };
li.nodeSize.get = function() {
  return this.isLeaf ? 1 : 2 + this.content.size;
};
li.childCount.get = function() {
  return this.content.childCount;
};
jt.prototype.child = function(e) {
  return this.content.child(e);
};
jt.prototype.maybeChild = function(e) {
  return this.content.maybeChild(e);
};
jt.prototype.forEach = function(e) {
  this.content.forEach(e);
};
jt.prototype.nodesBetween = function(e, n, r, s) {
  s === void 0 && (s = 0), this.content.nodesBetween(e, n, r, s, this);
};
jt.prototype.descendants = function(e) {
  this.nodesBetween(0, this.content.size, e);
};
li.textContent.get = function() {
  return this.textBetween(0, this.content.size, "");
};
jt.prototype.textBetween = function(e, n, r, s) {
  return this.content.textBetween(e, n, r, s);
};
li.firstChild.get = function() {
  return this.content.firstChild;
};
li.lastChild.get = function() {
  return this.content.lastChild;
};
jt.prototype.eq = function(e) {
  return this == e || this.sameMarkup(e) && this.content.eq(e.content);
};
jt.prototype.sameMarkup = function(e) {
  return this.hasMarkup(e.type, e.attrs, e.marks);
};
jt.prototype.hasMarkup = function(e, n, r) {
  return this.type == e && Um(this.attrs, n || e.defaultAttrs || vRe) && Xt.sameSet(this.marks, r || Xt.none);
};
jt.prototype.copy = function(e) {
  return e === void 0 && (e = null), e == this.content ? this : new this.constructor(this.type, this.attrs, e, this.marks);
};
jt.prototype.mark = function(e) {
  return e == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, e);
};
jt.prototype.cut = function(e, n) {
  return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
};
jt.prototype.slice = function(e, n, r) {
  if (n === void 0 && (n = this.content.size), r === void 0 && (r = !1), e == n)
    return He.empty;
  var s = this.resolve(e), i = this.resolve(n), o = r ? 0 : s.sharedDepth(n), a = s.start(o), l = s.node(o), c = l.content.cut(s.pos - a, i.pos - a);
  return new He(c, s.depth - o, i.depth - o);
};
jt.prototype.replace = function(e, n, r) {
  return pRe(this.resolve(e), this.resolve(n), r);
};
jt.prototype.nodeAt = function(e) {
  for (var n = this; ; ) {
    var r = n.content.findIndex(e), s = r.index, i = r.offset;
    if (n = n.maybeChild(s), !n)
      return null;
    if (i == e || n.isText)
      return n;
    e -= i + 1;
  }
};
jt.prototype.childAfter = function(e) {
  var n = this.content.findIndex(e), r = n.index, s = n.offset;
  return { node: this.content.maybeChild(r), index: r, offset: s };
};
jt.prototype.childBefore = function(e) {
  if (e == 0)
    return { node: null, index: 0, offset: 0 };
  var n = this.content.findIndex(e), r = n.index, s = n.offset;
  if (s < e)
    return { node: this.content.child(r), index: r, offset: s };
  var i = this.content.child(r - 1);
  return { node: i, index: r - 1, offset: s - i.nodeSize };
};
jt.prototype.resolve = function(e) {
  return Vn.resolveCached(this, e);
};
jt.prototype.resolveNoCache = function(e) {
  return Vn.resolve(this, e);
};
jt.prototype.rangeHasMark = function(e, n, r) {
  var s = !1;
  return n > e && this.nodesBetween(e, n, function(i) {
    return r.isInSet(i.marks) && (s = !0), !s;
  }), s;
};
li.isBlock.get = function() {
  return this.type.isBlock;
};
li.isTextblock.get = function() {
  return this.type.isTextblock;
};
li.inlineContent.get = function() {
  return this.type.inlineContent;
};
li.isInline.get = function() {
  return this.type.isInline;
};
li.isText.get = function() {
  return this.type.isText;
};
li.isLeaf.get = function() {
  return this.type.isLeaf;
};
li.isAtom.get = function() {
  return this.type.isAtom;
};
jt.prototype.toString = function() {
  if (this.type.spec.toDebugString)
    return this.type.spec.toDebugString(this);
  var e = this.type.name;
  return this.content.size && (e += "(" + this.content.toStringInner() + ")"), T6(this.marks, e);
};
jt.prototype.contentMatchAt = function(e) {
  var n = this.type.contentMatch.matchFragment(this.content, 0, e);
  if (!n)
    throw new Error("Called contentMatchAt on a node with invalid content");
  return n;
};
jt.prototype.canReplace = function(e, n, r, s, i) {
  r === void 0 && (r = xe.empty), s === void 0 && (s = 0), i === void 0 && (i = r.childCount);
  var o = this.contentMatchAt(e).matchFragment(r, s, i), a = o && o.matchFragment(this.content, n);
  if (!a || !a.validEnd)
    return !1;
  for (var l = s; l < i; l++)
    if (!this.type.allowsMarks(r.child(l).marks))
      return !1;
  return !0;
};
jt.prototype.canReplaceWith = function(e, n, r, s) {
  if (s && !this.type.allowsMarks(s))
    return !1;
  var i = this.contentMatchAt(e).matchType(r), o = i && i.matchFragment(this.content, n);
  return o ? o.validEnd : !1;
};
jt.prototype.canAppend = function(e) {
  return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
};
jt.prototype.check = function() {
  if (!this.type.validContent(this.content))
    throw new RangeError("Invalid content for node " + this.type.name + ": " + this.content.toString().slice(0, 50));
  this.content.forEach(function(e) {
    return e.check();
  });
};
jt.prototype.toJSON = function() {
  var e = { type: this.type.name };
  for (var n in this.attrs) {
    e.attrs = this.attrs;
    break;
  }
  return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map(function(r) {
    return r.toJSON();
  })), e;
};
jt.fromJSON = function(e, n) {
  if (!n)
    throw new RangeError("Invalid input for Node.fromJSON");
  var r = null;
  if (n.marks) {
    if (!Array.isArray(n.marks))
      throw new RangeError("Invalid mark data for Node.fromJSON");
    r = n.marks.map(e.markFromJSON);
  }
  if (n.type == "text") {
    if (typeof n.text != "string")
      throw new RangeError("Invalid text node in JSON");
    return e.text(n.text, r);
  }
  var s = xe.fromJSON(e, n.content);
  return e.nodeType(n.type).create(n.attrs, s, r);
};
Object.defineProperties(jt.prototype, li);
var gRe = /* @__PURE__ */ function(t) {
  function e(r, s, i, o) {
    if (t.call(this, r, s, null, o), !i)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = i;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { textContent: { configurable: !0 }, nodeSize: { configurable: !0 } };
  return e.prototype.toString = function() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : T6(this.marks, JSON.stringify(this.text));
  }, n.textContent.get = function() {
    return this.text;
  }, e.prototype.textBetween = function(s, i) {
    return this.text.slice(s, i);
  }, n.nodeSize.get = function() {
    return this.text.length;
  }, e.prototype.mark = function(s) {
    return s == this.marks ? this : new e(this.type, this.attrs, this.text, s);
  }, e.prototype.withText = function(s) {
    return s == this.text ? this : new e(this.type, this.attrs, s, this.marks);
  }, e.prototype.cut = function(s, i) {
    return s === void 0 && (s = 0), i === void 0 && (i = this.text.length), s == 0 && i == this.text.length ? this : this.withText(this.text.slice(s, i));
  }, e.prototype.eq = function(s) {
    return this.sameMarkup(s) && this.text == s.text;
  }, e.prototype.toJSON = function() {
    var s = t.prototype.toJSON.call(this);
    return s.text = this.text, s;
  }, Object.defineProperties(e.prototype, n), e;
}(jt);
function T6(t, e) {
  for (var n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
var hs = function(e) {
  this.validEnd = e, this.next = [], this.wrapCache = [];
}, ng = { inlineContent: { configurable: !0 }, defaultType: { configurable: !0 }, edgeCount: { configurable: !0 } };
hs.parse = function(e, n) {
  var r = new rg(e, n);
  if (r.next == null)
    return hs.empty;
  var s = k6(r);
  r.next && r.err("Unexpected trailing text");
  var i = ERe(IRe(s));
  return xRe(i, r), i;
};
hs.prototype.matchType = function(e) {
  for (var n = 0; n < this.next.length; n += 2)
    if (this.next[n] == e)
      return this.next[n + 1];
  return null;
};
hs.prototype.matchFragment = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = e.childCount);
  for (var s = this, i = n; s && i < r; i++)
    s = s.matchType(e.child(i).type);
  return s;
};
ng.inlineContent.get = function() {
  var t = this.next[0];
  return t ? t.isInline : !1;
};
ng.defaultType.get = function() {
  for (var t = 0; t < this.next.length; t += 2) {
    var e = this.next[t];
    if (!(e.isText || e.hasRequiredAttrs()))
      return e;
  }
};
hs.prototype.compatible = function(e) {
  for (var n = 0; n < this.next.length; n += 2)
    for (var r = 0; r < e.next.length; r += 2)
      if (this.next[n] == e.next[r])
        return !0;
  return !1;
};
hs.prototype.fillBefore = function(e, n, r) {
  n === void 0 && (n = !1), r === void 0 && (r = 0);
  var s = [this];
  function i(o, a) {
    var l = o.matchFragment(e, r);
    if (l && (!n || l.validEnd))
      return xe.from(a.map(function(p) {
        return p.createAndFill();
      }));
    for (var c = 0; c < o.next.length; c += 2) {
      var u = o.next[c], d = o.next[c + 1];
      if (!(u.isText || u.hasRequiredAttrs()) && s.indexOf(d) == -1) {
        s.push(d);
        var f = i(d, a.concat(u));
        if (f)
          return f;
      }
    }
  }
  return i(this, []);
};
hs.prototype.findWrapping = function(e) {
  for (var n = 0; n < this.wrapCache.length; n += 2)
    if (this.wrapCache[n] == e)
      return this.wrapCache[n + 1];
  var r = this.computeWrapping(e);
  return this.wrapCache.push(e, r), r;
};
hs.prototype.computeWrapping = function(e) {
  for (var n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }]; r.length; ) {
    var s = r.shift(), i = s.match;
    if (i.matchType(e)) {
      for (var o = [], a = s; a.type; a = a.via)
        o.push(a.type);
      return o.reverse();
    }
    for (var l = 0; l < i.next.length; l += 2) {
      var c = i.next[l];
      !c.isLeaf && !c.hasRequiredAttrs() && !(c.name in n) && (!s.type || i.next[l + 1].validEnd) && (r.push({ match: c.contentMatch, type: c, via: s }), n[c.name] = !0);
    }
  }
};
ng.edgeCount.get = function() {
  return this.next.length >> 1;
};
hs.prototype.edge = function(e) {
  var n = e << 1;
  if (n >= this.next.length)
    throw new RangeError("There's no " + e + "th edge in this content match");
  return { type: this.next[n], next: this.next[n + 1] };
};
hs.prototype.toString = function() {
  var e = [];
  function n(r) {
    e.push(r);
    for (var s = 1; s < r.next.length; s += 2)
      e.indexOf(r.next[s]) == -1 && n(r.next[s]);
  }
  return n(this), e.map(function(r, s) {
    for (var i = s + (r.validEnd ? "*" : " ") + " ", o = 0; o < r.next.length; o += 2)
      i += (o ? ", " : "") + r.next[o].name + "->" + e.indexOf(r.next[o + 1]);
    return i;
  }).join(`
`);
};
Object.defineProperties(hs.prototype, ng);
hs.empty = new hs(!0);
var rg = function(e, n) {
  this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
}, P6 = { next: { configurable: !0 } };
P6.next.get = function() {
  return this.tokens[this.pos];
};
rg.prototype.eat = function(e) {
  return this.next == e && (this.pos++ || !0);
};
rg.prototype.err = function(e) {
  throw new SyntaxError(e + " (in content expression '" + this.string + "')");
};
Object.defineProperties(rg.prototype, P6);
function k6(t) {
  var e = [];
  do
    e.push(yRe(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function yRe(t) {
  var e = [];
  do
    e.push(bRe(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function bRe(t) {
  for (var e = SRe(t); ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = _Re(t, e);
    else
      break;
  return e;
}
function EN(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  var e = Number(t.next);
  return t.pos++, e;
}
function _Re(t, e) {
  var n = EN(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = EN(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function wRe(t, e) {
  var n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  var s = [];
  for (var i in n) {
    var o = n[i];
    o.groups.indexOf(e) > -1 && s.push(o);
  }
  return s.length == 0 && t.err("No node type or group '" + e + "' found"), s;
}
function SRe(t) {
  if (t.eat("(")) {
    var e = k6(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    var n = wRe(t, t.next).map(function(r) {
      return t.inline == null ? t.inline = r.isInline : t.inline != r.isInline && t.err("Mixing inline and block content"), { type: "name", value: r };
    });
    return t.pos++, n.length == 1 ? n[0] : { type: "choice", exprs: n };
  }
}
function IRe(t) {
  var e = [[]];
  return s(i(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(o, a, l) {
    var c = { term: l, to: a };
    return e[o].push(c), c;
  }
  function s(o, a) {
    o.forEach(function(l) {
      return l.to = a;
    });
  }
  function i(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce(function(y, _) {
        return y.concat(i(_, a));
      }, []);
    if (o.type == "seq")
      for (var l = 0; ; l++) {
        var c = i(o.exprs[l], a);
        if (l == o.exprs.length - 1)
          return c;
        s(c, a = n());
      }
    else if (o.type == "star") {
      var u = n();
      return r(a, u), s(i(o.expr, u), u), [r(u)];
    } else if (o.type == "plus") {
      var d = n();
      return s(i(o.expr, a), d), s(i(o.expr, d), d), [r(d)];
    } else {
      if (o.type == "opt")
        return [r(a)].concat(i(o.expr, a));
      if (o.type == "range") {
        for (var f = a, p = 0; p < o.min; p++) {
          var h = n();
          s(i(o.expr, f), h), f = h;
        }
        if (o.max == -1)
          s(i(o.expr, f), f);
        else
          for (var m = o.min; m < o.max; m++) {
            var v = n();
            r(f, v), s(i(o.expr, f), v), f = v;
          }
        return [r(f)];
      } else if (o.type == "name")
        return [r(a, null, o.value)];
    }
  }
}
function N6(t, e) {
  return e - t;
}
function xN(t, e) {
  var n = [];
  return r(e), n.sort(N6);
  function r(s) {
    var i = t[s];
    if (i.length == 1 && !i[0].term)
      return r(i[0].to);
    n.push(s);
    for (var o = 0; o < i.length; o++) {
      var a = i[o], l = a.term, c = a.to;
      !l && n.indexOf(c) == -1 && r(c);
    }
  }
}
function ERe(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return n(xN(t, 0));
  function n(r) {
    var s = [];
    r.forEach(function(l) {
      t[l].forEach(function(c) {
        var u = c.term, d = c.to;
        if (u) {
          var f = s.indexOf(u), p = f > -1 && s[f + 1];
          xN(t, d).forEach(function(h) {
            p || s.push(u, p = []), p.indexOf(h) == -1 && p.push(h);
          });
        }
      });
    });
    for (var i = e[r.join(",")] = new hs(r.indexOf(t.length - 1) > -1), o = 0; o < s.length; o += 2) {
      var a = s[o + 1].sort(N6);
      i.next.push(s[o], e[a.join(",")] || n(a));
    }
    return i;
  }
}
function xRe(t, e) {
  for (var n = 0, r = [t]; n < r.length; n++) {
    for (var s = r[n], i = !s.validEnd, o = [], a = 0; a < s.next.length; a += 2) {
      var l = s.next[a], c = s.next[a + 1];
      o.push(l.name), i && !(l.isText || l.hasRequiredAttrs()) && (i = !1), r.indexOf(c) == -1 && r.push(c);
    }
    i && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function $6(t) {
  var e = /* @__PURE__ */ Object.create(null);
  for (var n in t) {
    var r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function D6(t, e) {
  var n = /* @__PURE__ */ Object.create(null);
  for (var r in t) {
    var s = e && e[r];
    if (s === void 0) {
      var i = t[r];
      if (i.hasDefault)
        s = i.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = s;
  }
  return n;
}
function A6(t) {
  var e = /* @__PURE__ */ Object.create(null);
  if (t)
    for (var n in t)
      e[n] = new O6(t[n]);
  return e;
}
var Ns = function(e, n, r) {
  this.name = e, this.schema = n, this.spec = r, this.groups = r.group ? r.group.split(" ") : [], this.attrs = A6(r.attrs), this.defaultAttrs = $6(this.attrs), this.contentMatch = null, this.markSet = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
}, Zf = { isInline: { configurable: !0 }, isTextblock: { configurable: !0 }, isLeaf: { configurable: !0 }, isAtom: { configurable: !0 } };
Zf.isInline.get = function() {
  return !this.isBlock;
};
Zf.isTextblock.get = function() {
  return this.isBlock && this.inlineContent;
};
Zf.isLeaf.get = function() {
  return this.contentMatch == hs.empty;
};
Zf.isAtom.get = function() {
  return this.isLeaf || this.spec.atom;
};
Ns.prototype.hasRequiredAttrs = function() {
  for (var e in this.attrs)
    if (this.attrs[e].isRequired)
      return !0;
  return !1;
};
Ns.prototype.compatibleContent = function(e) {
  return this == e || this.contentMatch.compatible(e.contentMatch);
};
Ns.prototype.computeAttrs = function(e) {
  return !e && this.defaultAttrs ? this.defaultAttrs : D6(this.attrs, e);
};
Ns.prototype.create = function(e, n, r) {
  if (this.isText)
    throw new Error("NodeType.create can't construct text nodes");
  return new jt(this, this.computeAttrs(e), xe.from(n), Xt.setFrom(r));
};
Ns.prototype.createChecked = function(e, n, r) {
  if (n = xe.from(n), !this.validContent(n))
    throw new RangeError("Invalid content for node " + this.name);
  return new jt(this, this.computeAttrs(e), n, Xt.setFrom(r));
};
Ns.prototype.createAndFill = function(e, n, r) {
  if (e = this.computeAttrs(e), n = xe.from(n), n.size) {
    var s = this.contentMatch.fillBefore(n);
    if (!s)
      return null;
    n = s.append(n);
  }
  var i = this.contentMatch.matchFragment(n).fillBefore(xe.empty, !0);
  return i ? new jt(this, e, n.append(i), Xt.setFrom(r)) : null;
};
Ns.prototype.validContent = function(e) {
  var n = this.contentMatch.matchFragment(e);
  if (!n || !n.validEnd)
    return !1;
  for (var r = 0; r < e.childCount; r++)
    if (!this.allowsMarks(e.child(r).marks))
      return !1;
  return !0;
};
Ns.prototype.allowsMarkType = function(e) {
  return this.markSet == null || this.markSet.indexOf(e) > -1;
};
Ns.prototype.allowsMarks = function(e) {
  if (this.markSet == null)
    return !0;
  for (var n = 0; n < e.length; n++)
    if (!this.allowsMarkType(e[n].type))
      return !1;
  return !0;
};
Ns.prototype.allowedMarks = function(e) {
  if (this.markSet == null)
    return e;
  for (var n, r = 0; r < e.length; r++)
    this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
  return n ? n.length ? n : Xt.empty : e;
};
Ns.compile = function(e, n) {
  var r = /* @__PURE__ */ Object.create(null);
  e.forEach(function(o, a) {
    return r[o] = new Ns(o, n, a);
  });
  var s = n.spec.topNode || "doc";
  if (!r[s])
    throw new RangeError("Schema is missing its top node type ('" + s + "')");
  if (!r.text)
    throw new RangeError("Every schema needs a 'text' type");
  for (var i in r.text.attrs)
    throw new RangeError("The text node type should not have attributes");
  return r;
};
Object.defineProperties(Ns.prototype, Zf);
var O6 = function(e) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(e, "default"), this.default = e.default;
}, M6 = { isRequired: { configurable: !0 } };
M6.isRequired.get = function() {
  return !this.hasDefault;
};
Object.defineProperties(O6.prototype, M6);
var Ua = function(e, n, r, s) {
  this.name = e, this.schema = r, this.spec = s, this.attrs = A6(s.attrs), this.rank = n, this.excluded = null;
  var i = $6(this.attrs);
  this.instance = i && new Xt(this, i);
};
Ua.prototype.create = function(e) {
  return !e && this.instance ? this.instance : new Xt(this, D6(this.attrs, e));
};
Ua.compile = function(e, n) {
  var r = /* @__PURE__ */ Object.create(null), s = 0;
  return e.forEach(function(i, o) {
    return r[i] = new Ua(i, s++, n, o);
  }), r;
};
Ua.prototype.removeFromSet = function(e) {
  for (var n = 0; n < e.length; n++)
    e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
  return e;
};
Ua.prototype.isInSet = function(e) {
  for (var n = 0; n < e.length; n++)
    if (e[n].type == this)
      return e[n];
};
Ua.prototype.excludes = function(e) {
  return this.excluded.indexOf(e) > -1;
};
var pc = function(e) {
  this.spec = {};
  for (var n in e)
    this.spec[n] = e[n];
  this.spec.nodes = Zr.from(e.nodes), this.spec.marks = Zr.from(e.marks), this.nodes = Ns.compile(this.spec.nodes, this), this.marks = Ua.compile(this.spec.marks, this);
  var r = /* @__PURE__ */ Object.create(null);
  for (var s in this.nodes) {
    if (s in this.marks)
      throw new RangeError(s + " can not be both a node and a mark");
    var i = this.nodes[s], o = i.spec.content || "", a = i.spec.marks;
    i.contentMatch = r[o] || (r[o] = hs.parse(o, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.markSet = a == "_" ? null : a ? CN(this, a.split(" ")) : a == "" || !i.inlineContent ? [] : null;
  }
  for (var l in this.marks) {
    var c = this.marks[l], u = c.spec.excludes;
    c.excluded = u == null ? [c] : u == "" ? [] : CN(this, u.split(" "));
  }
  this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached = /* @__PURE__ */ Object.create(null), this.cached.wrappings = /* @__PURE__ */ Object.create(null);
};
pc.prototype.node = function(e, n, r, s) {
  if (typeof e == "string")
    e = this.nodeType(e);
  else if (e instanceof Ns) {
    if (e.schema != this)
      throw new RangeError("Node type from different schema used (" + e.name + ")");
  } else throw new RangeError("Invalid node type: " + e);
  return e.createChecked(n, r, s);
};
pc.prototype.text = function(e, n) {
  var r = this.nodes.text;
  return new gRe(r, r.defaultAttrs, e, Xt.setFrom(n));
};
pc.prototype.mark = function(e, n) {
  return typeof e == "string" && (e = this.marks[e]), e.create(n);
};
pc.prototype.nodeFromJSON = function(e) {
  return jt.fromJSON(this, e);
};
pc.prototype.markFromJSON = function(e) {
  return Xt.fromJSON(this, e);
};
pc.prototype.nodeType = function(e) {
  var n = this.nodes[e];
  if (!n)
    throw new RangeError("Unknown node type: " + e);
  return n;
};
function CN(t, e) {
  for (var n = [], r = 0; r < e.length; r++) {
    var s = e[r], i = t.marks[s], o = i;
    if (i)
      n.push(i);
    else
      for (var a in t.marks) {
        var l = t.marks[a];
        (s == "_" || l.spec.group && l.spec.group.split(" ").indexOf(s) > -1) && n.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
var Wi = function(e, n) {
  var r = this;
  this.schema = e, this.rules = n, this.tags = [], this.styles = [], n.forEach(function(s) {
    s.tag ? r.tags.push(s) : s.style && r.styles.push(s);
  }), this.normalizeLists = !this.tags.some(function(s) {
    if (!/^(ul|ol)\b/.test(s.tag) || !s.node)
      return !1;
    var i = e.nodes[s.node];
    return i.contentMatch.matchType(i);
  });
};
Wi.prototype.parse = function(e, n) {
  n === void 0 && (n = {});
  var r = new Hn(this, n, !1);
  return r.addAll(e, null, n.from, n.to), r.finish();
};
Wi.prototype.parseSlice = function(e, n) {
  n === void 0 && (n = {});
  var r = new Hn(this, n, !0);
  return r.addAll(e, null, n.from, n.to), He.maxOpen(r.finish());
};
Wi.prototype.matchTag = function(e, n, r) {
  for (var s = r ? this.tags.indexOf(r) + 1 : 0; s < this.tags.length; s++) {
    var i = this.tags[s];
    if (PRe(e, i.tag) && (i.namespace === void 0 || e.namespaceURI == i.namespace) && (!i.context || n.matchesContext(i.context))) {
      if (i.getAttrs) {
        var o = i.getAttrs(e);
        if (o === !1)
          continue;
        i.attrs = o;
      }
      return i;
    }
  }
};
Wi.prototype.matchStyle = function(e, n, r, s) {
  for (var i = s ? this.styles.indexOf(s) + 1 : 0; i < this.styles.length; i++) {
    var o = this.styles[i];
    if (!(o.style.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
    // or has an '=' sign after the prop, followed by the given
    // value.
    o.style.length > e.length && (o.style.charCodeAt(e.length) != 61 || o.style.slice(e.length + 1) != n))) {
      if (o.getAttrs) {
        var a = o.getAttrs(n);
        if (a === !1)
          continue;
        o.attrs = a;
      }
      return o;
    }
  }
};
Wi.schemaRules = function(e) {
  var n = [];
  function r(l) {
    for (var c = l.priority == null ? 50 : l.priority, u = 0; u < n.length; u++) {
      var d = n[u], f = d.priority == null ? 50 : d.priority;
      if (f < c)
        break;
    }
    n.splice(u, 0, l);
  }
  var s = function(l) {
    var c = e.marks[l].spec.parseDOM;
    c && c.forEach(function(u) {
      r(u = TN(u)), u.mark = l;
    });
  };
  for (var i in e.marks) s(i);
  var o = function(l) {
    var c = e.nodes[a].spec.parseDOM;
    c && c.forEach(function(u) {
      r(u = TN(u)), u.node = a;
    });
  };
  for (var a in e.nodes) o();
  return n;
};
Wi.fromSchema = function(e) {
  return e.cached.domParser || (e.cached.domParser = new Wi(e, Wi.schemaRules(e)));
};
var R6 = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, CRe = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, L6 = { ol: !0, ul: !0 }, j2 = 1, F6 = 2, Zd = 4;
function B6(t) {
  return (t ? j2 : 0) | (t === "full" ? F6 : 0);
}
var Ma = function(e, n, r, s, i, o, a) {
  this.type = e, this.attrs = n, this.solid = i, this.match = o || (a & Zd ? null : e.contentMatch), this.options = a, this.content = [], this.marks = r, this.activeMarks = Xt.none, this.pendingMarks = s, this.stashMarks = [];
};
Ma.prototype.findWrapping = function(e) {
  if (!this.match) {
    if (!this.type)
      return [];
    var n = this.type.contentMatch.fillBefore(xe.from(e));
    if (n)
      this.match = this.type.contentMatch.matchFragment(n);
    else {
      var r = this.type.contentMatch, s;
      return (s = r.findWrapping(e.type)) ? (this.match = r, s) : null;
    }
  }
  return this.match.findWrapping(e.type);
};
Ma.prototype.finish = function(e) {
  if (!(this.options & j2)) {
    var n = this.content[this.content.length - 1], r;
    n && n.isText && (r = /[ \t\r\n\u000c]+$/.exec(n.text)) && (n.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = n.withText(n.text.slice(0, n.text.length - r[0].length)));
  }
  var s = xe.from(this.content);
  return !e && this.match && (s = s.append(this.match.fillBefore(xe.empty, !0))), this.type ? this.type.create(this.attrs, s, this.marks) : s;
};
Ma.prototype.popFromStashMark = function(e) {
  for (var n = this.stashMarks.length - 1; n >= 0; n--)
    if (e.eq(this.stashMarks[n]))
      return this.stashMarks.splice(n, 1)[0];
};
Ma.prototype.applyPending = function(e) {
  for (var n = 0, r = this.pendingMarks; n < r.length; n++) {
    var s = r[n];
    (this.type ? this.type.allowsMarkType(s.type) : NRe(s.type, e)) && !s.isInSet(this.activeMarks) && (this.activeMarks = s.addToSet(this.activeMarks), this.pendingMarks = s.removeFromSet(this.pendingMarks));
  }
};
var Hn = function(e, n, r) {
  this.parser = e, this.options = n, this.isOpen = r;
  var s = n.topNode, i, o = B6(n.preserveWhitespace) | (r ? Zd : 0);
  s ? i = new Ma(
    s.type,
    s.attrs,
    Xt.none,
    Xt.none,
    !0,
    n.topMatch || s.type.contentMatch,
    o
  ) : r ? i = new Ma(null, null, Xt.none, Xt.none, !0, null, o) : i = new Ma(e.schema.topNodeType, null, Xt.none, Xt.none, !0, null, o), this.nodes = [i], this.open = 0, this.find = n.findPositions, this.needsBlock = !1;
}, W2 = { top: { configurable: !0 }, currentPos: { configurable: !0 } };
W2.top.get = function() {
  return this.nodes[this.open];
};
Hn.prototype.addDOM = function(e) {
  if (e.nodeType == 3)
    this.addTextNode(e);
  else if (e.nodeType == 1) {
    var n = e.getAttribute("style"), r = n ? this.readStyles(kRe(n)) : null, s = this.top;
    if (r != null)
      for (var i = 0; i < r.length; i++)
        this.addPendingMark(r[i]);
    if (this.addElement(e), r != null)
      for (var o = 0; o < r.length; o++)
        this.removePendingMark(r[o], s);
  }
};
Hn.prototype.addTextNode = function(e) {
  var n = e.nodeValue, r = this.top;
  if ((r.type ? r.type.inlineContent : r.content.length && r.content[0].isInline) || /[^ \t\r\n\u000c]/.test(n)) {
    if (r.options & j2)
      r.options & F6 || (n = n.replace(/\r?\n|\r/g, " "));
    else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
      var s = r.content[r.content.length - 1], i = e.previousSibling;
      (!s || i && i.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (n = n.slice(1));
    }
    n && this.insertNode(this.parser.schema.text(n)), this.findInText(e);
  } else
    this.findInside(e);
};
Hn.prototype.addElement = function(e, n) {
  var r = e.nodeName.toLowerCase(), s;
  L6.hasOwnProperty(r) && this.parser.normalizeLists && TRe(e);
  var i = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, n));
  if (i ? i.ignore : CRe.hasOwnProperty(r))
    this.findInside(e);
  else if (!i || i.skip || i.closeParent) {
    i && i.closeParent ? this.open = Math.max(0, this.open - 1) : i && i.skip.nodeType && (e = i.skip);
    var o, a = this.top, l = this.needsBlock;
    if (R6.hasOwnProperty(r))
      o = !0, a.type || (this.needsBlock = !0);
    else if (!e.firstChild) {
      this.leafFallback(e);
      return;
    }
    this.addAll(e), o && this.sync(a), this.needsBlock = l;
  } else
    this.addElementByRule(e, i, i.consuming === !1 ? s : null);
};
Hn.prototype.leafFallback = function(e) {
  e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`));
};
Hn.prototype.readStyles = function(e) {
  var n = Xt.none;
  e: for (var r = 0; r < e.length; r += 2)
    for (var s = null; ; ) {
      var i = this.parser.matchStyle(e[r], e[r + 1], this, s);
      if (!i)
        continue e;
      if (i.ignore)
        return null;
      if (n = this.parser.schema.marks[i.mark].create(i.attrs).addToSet(n), i.consuming === !1)
        s = i;
      else
        break;
    }
  return n;
};
Hn.prototype.addElementByRule = function(e, n, r) {
  var s = this, i, o, a, l;
  n.node ? (o = this.parser.schema.nodes[n.node], o.isLeaf ? this.insertNode(o.create(n.attrs)) || this.leafFallback(e) : i = this.enter(o, n.attrs, n.preserveWhitespace)) : (a = this.parser.schema.marks[n.mark], l = a.create(n.attrs), this.addPendingMark(l));
  var c = this.top;
  if (o && o.isLeaf)
    this.findInside(e);
  else if (r)
    this.addElement(e, r);
  else if (n.getContent)
    this.findInside(e), n.getContent(e, this.parser.schema).forEach(function(d) {
      return s.insertNode(d);
    });
  else {
    var u = n.contentElement;
    typeof u == "string" ? u = e.querySelector(u) : typeof u == "function" && (u = u(e)), u || (u = e), this.findAround(e, u, !0), this.addAll(u, i);
  }
  i && (this.sync(c), this.open--), l && this.removePendingMark(l, c);
};
Hn.prototype.addAll = function(e, n, r, s) {
  for (var i = r || 0, o = r ? e.childNodes[r] : e.firstChild, a = s == null ? null : e.childNodes[s]; o != a; o = o.nextSibling, ++i)
    this.findAtPoint(e, i), this.addDOM(o), n && R6.hasOwnProperty(o.nodeName.toLowerCase()) && this.sync(n);
  this.findAtPoint(e, i);
};
Hn.prototype.findPlace = function(e) {
  for (var n, r, s = this.open; s >= 0; s--) {
    var i = this.nodes[s], o = i.findWrapping(e);
    if (o && (!n || n.length > o.length) && (n = o, r = i, !o.length) || i.solid)
      break;
  }
  if (!n)
    return !1;
  this.sync(r);
  for (var a = 0; a < n.length; a++)
    this.enterInner(n[a], null, !1);
  return !0;
};
Hn.prototype.insertNode = function(e) {
  if (e.isInline && this.needsBlock && !this.top.type) {
    var n = this.textblockFromContext();
    n && this.enterInner(n);
  }
  if (this.findPlace(e)) {
    this.closeExtra();
    var r = this.top;
    r.applyPending(e.type), r.match && (r.match = r.match.matchType(e.type));
    for (var s = r.activeMarks, i = 0; i < e.marks.length; i++)
      (!r.type || r.type.allowsMarkType(e.marks[i].type)) && (s = e.marks[i].addToSet(s));
    return r.content.push(e.mark(s)), !0;
  }
  return !1;
};
Hn.prototype.enter = function(e, n, r) {
  var s = this.findPlace(e.create(n));
  return s && this.enterInner(e, n, !0, r), s;
};
Hn.prototype.enterInner = function(e, n, r, s) {
  this.closeExtra();
  var i = this.top;
  i.applyPending(e), i.match = i.match && i.match.matchType(e, n);
  var o = s == null ? i.options & ~Zd : B6(s);
  i.options & Zd && i.content.length == 0 && (o |= Zd), this.nodes.push(new Ma(e, n, i.activeMarks, i.pendingMarks, r, null, o)), this.open++;
};
Hn.prototype.closeExtra = function(e) {
  var n = this.nodes.length - 1;
  if (n > this.open) {
    for (; n > this.open; n--)
      this.nodes[n - 1].content.push(this.nodes[n].finish(e));
    this.nodes.length = this.open + 1;
  }
};
Hn.prototype.finish = function() {
  return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
};
Hn.prototype.sync = function(e) {
  for (var n = this.open; n >= 0; n--)
    if (this.nodes[n] == e) {
      this.open = n;
      return;
    }
};
W2.currentPos.get = function() {
  this.closeExtra();
  for (var t = 0, e = this.open; e >= 0; e--) {
    for (var n = this.nodes[e].content, r = n.length - 1; r >= 0; r--)
      t += n[r].nodeSize;
    e && t++;
  }
  return t;
};
Hn.prototype.findAtPoint = function(e, n) {
  if (this.find)
    for (var r = 0; r < this.find.length; r++)
      this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
};
Hn.prototype.findInside = function(e) {
  if (this.find)
    for (var n = 0; n < this.find.length; n++)
      this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
};
Hn.prototype.findAround = function(e, n, r) {
  if (e != n && this.find) {
    for (var s = 0; s < this.find.length; s++)
      if (this.find[s].pos == null && e.nodeType == 1 && e.contains(this.find[s].node)) {
        var i = n.compareDocumentPosition(this.find[s].node);
        i & (r ? 2 : 4) && (this.find[s].pos = this.currentPos);
      }
  }
};
Hn.prototype.findInText = function(e) {
  if (this.find)
    for (var n = 0; n < this.find.length; n++)
      this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
};
Hn.prototype.matchesContext = function(e) {
  var n = this;
  if (e.indexOf("|") > -1)
    return e.split(/\s*\|\s*/).some(this.matchesContext, this);
  var r = e.split("/"), s = this.options.context, i = !this.isOpen && (!s || s.parent.type == this.nodes[0].type), o = -(s ? s.depth + 1 : 0) + (i ? 0 : 1), a = function(l, c) {
    for (; l >= 0; l--) {
      var u = r[l];
      if (u == "") {
        if (l == r.length - 1 || l == 0)
          continue;
        for (; c >= o; c--)
          if (a(l - 1, c))
            return !0;
        return !1;
      } else {
        var d = c > 0 || c == 0 && i ? n.nodes[c].type : s && c >= o ? s.node(c - o).type : null;
        if (!d || d.name != u && d.groups.indexOf(u) == -1)
          return !1;
        c--;
      }
    }
    return !0;
  };
  return a(r.length - 1, this.open);
};
Hn.prototype.textblockFromContext = function() {
  var e = this.options.context;
  if (e)
    for (var n = e.depth; n >= 0; n--) {
      var r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
      if (r && r.isTextblock && r.defaultAttrs)
        return r;
    }
  for (var s in this.parser.schema.nodes) {
    var i = this.parser.schema.nodes[s];
    if (i.isTextblock && i.defaultAttrs)
      return i;
  }
};
Hn.prototype.addPendingMark = function(e) {
  var n = $Re(e, this.top.pendingMarks);
  n && this.top.stashMarks.push(n), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
};
Hn.prototype.removePendingMark = function(e, n) {
  for (var r = this.open; r >= 0; r--) {
    var s = this.nodes[r], i = s.pendingMarks.lastIndexOf(e);
    if (i > -1)
      s.pendingMarks = e.removeFromSet(s.pendingMarks);
    else {
      s.activeMarks = e.removeFromSet(s.activeMarks);
      var o = s.popFromStashMark(e);
      o && s.type && s.type.allowsMarkType(o.type) && (s.activeMarks = o.addToSet(s.activeMarks));
    }
    if (s == n)
      break;
  }
};
Object.defineProperties(Hn.prototype, W2);
function TRe(t) {
  for (var e = t.firstChild, n = null; e; e = e.nextSibling) {
    var r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && L6.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function PRe(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function kRe(t) {
  for (var e = /\s*([\w-]+)\s*:\s*([^;]+)/g, n, r = []; n = e.exec(t); )
    r.push(n[1], n[2].trim());
  return r;
}
function TN(t) {
  var e = {};
  for (var n in t)
    e[n] = t[n];
  return e;
}
function NRe(t, e) {
  var n = e.schema.nodes, r = function(o) {
    var a = n[o];
    if (a.allowsMarkType(t)) {
      var l = [], c = function(u) {
        l.push(u);
        for (var d = 0; d < u.edgeCount; d++) {
          var f = u.edge(d), p = f.type, h = f.next;
          if (p == e || l.indexOf(h) < 0 && c(h))
            return !0;
        }
      };
      if (c(a.contentMatch))
        return { v: !0 };
    }
  };
  for (var s in n) {
    var i = r(s);
    if (i) return i.v;
  }
}
function $Re(t, e) {
  for (var n = 0; n < e.length; n++)
    if (t.eq(e[n]))
      return e[n];
}
var ms = function(e, n) {
  this.nodes = e || {}, this.marks = n || {};
};
ms.prototype.serializeFragment = function(e, n, r) {
  var s = this;
  n === void 0 && (n = {}), r || (r = H2(n).createDocumentFragment());
  var i = r, o = null;
  return e.forEach(function(a) {
    if (o || a.marks.length) {
      o || (o = []);
      for (var l = 0, c = 0; l < o.length && c < a.marks.length; ) {
        var u = a.marks[c];
        if (!s.marks[u.type.name]) {
          c++;
          continue;
        }
        if (!u.eq(o[l]) || u.type.spec.spanning === !1)
          break;
        l += 2, c++;
      }
      for (; l < o.length; )
        i = o.pop(), o.pop();
      for (; c < a.marks.length; ) {
        var d = a.marks[c++], f = s.serializeMark(d, a.isInline, n);
        f && (o.push(d, i), i.appendChild(f.dom), i = f.contentDOM || f.dom);
      }
    }
    i.appendChild(s.serializeNode(a, n));
  }), r;
};
ms.prototype.serializeNode = function(e, n) {
  n === void 0 && (n = {});
  var r = ms.renderSpec(H2(n), this.nodes[e.type.name](e)), s = r.dom, i = r.contentDOM;
  if (i) {
    if (e.isLeaf)
      throw new RangeError("Content hole not allowed in a leaf node spec");
    n.onContent ? n.onContent(e, i, n) : this.serializeFragment(e.content, n, i);
  }
  return s;
};
ms.prototype.serializeNodeAndMarks = function(e, n) {
  n === void 0 && (n = {});
  for (var r = this.serializeNode(e, n), s = e.marks.length - 1; s >= 0; s--) {
    var i = this.serializeMark(e.marks[s], e.isInline, n);
    i && ((i.contentDOM || i.dom).appendChild(r), r = i.dom);
  }
  return r;
};
ms.prototype.serializeMark = function(e, n, r) {
  r === void 0 && (r = {});
  var s = this.marks[e.type.name];
  return s && ms.renderSpec(H2(r), s(e, n));
};
ms.renderSpec = function(e, n, r) {
  if (r === void 0 && (r = null), typeof n == "string")
    return { dom: e.createTextNode(n) };
  if (n.nodeType != null)
    return { dom: n };
  if (n.dom && n.dom.nodeType != null)
    return n;
  var s = n[0], i = s.indexOf(" ");
  i > 0 && (r = s.slice(0, i), s = s.slice(i + 1));
  var o = null, a = r ? e.createElementNS(r, s) : e.createElement(s), l = n[1], c = 1;
  if (l && typeof l == "object" && l.nodeType == null && !Array.isArray(l)) {
    c = 2;
    for (var u in l)
      if (l[u] != null) {
        var d = u.indexOf(" ");
        d > 0 ? a.setAttributeNS(u.slice(0, d), u.slice(d + 1), l[u]) : a.setAttribute(u, l[u]);
      }
  }
  for (var f = c; f < n.length; f++) {
    var p = n[f];
    if (p === 0) {
      if (f < n.length - 1 || f > c)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: a, contentDOM: a };
    } else {
      var h = ms.renderSpec(e, p, r), m = h.dom, v = h.contentDOM;
      if (a.appendChild(m), v) {
        if (o)
          throw new RangeError("Multiple content holes");
        o = v;
      }
    }
  }
  return { dom: a, contentDOM: o };
};
ms.fromSchema = function(e) {
  return e.cached.domSerializer || (e.cached.domSerializer = new ms(this.nodesFromSchema(e), this.marksFromSchema(e)));
};
ms.nodesFromSchema = function(e) {
  var n = j6(e.nodes);
  return n.text || (n.text = function(r) {
    return r.text;
  }), n;
};
ms.marksFromSchema = function(e) {
  return j6(e.marks);
};
function j6(t) {
  var e = {};
  for (var n in t) {
    var r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function H2(t) {
  return t.document || window.document;
}
var W6 = 65535, H6 = Math.pow(2, 16);
function DRe(t, e) {
  return t + e * H6;
}
function V6(t) {
  return t & W6;
}
function ARe(t) {
  return (t - (t & W6)) / H6;
}
var r1 = function(e, n, r) {
  n === void 0 && (n = !1), r === void 0 && (r = null), this.pos = e, this.deleted = n, this.recover = r;
}, qr = function(e, n) {
  n === void 0 && (n = !1), this.ranges = e, this.inverted = n;
};
qr.prototype.recover = function(e) {
  var n = 0, r = V6(e);
  if (!this.inverted)
    for (var s = 0; s < r; s++)
      n += this.ranges[s * 3 + 2] - this.ranges[s * 3 + 1];
  return this.ranges[r * 3] + n + ARe(e);
};
qr.prototype.mapResult = function(e, n) {
  return n === void 0 && (n = 1), this._map(e, n, !1);
};
qr.prototype.map = function(e, n) {
  return n === void 0 && (n = 1), this._map(e, n, !0);
};
qr.prototype._map = function(e, n, r) {
  for (var s = 0, i = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2, a = 0; a < this.ranges.length; a += 3) {
    var l = this.ranges[a] - (this.inverted ? s : 0);
    if (l > e)
      break;
    var c = this.ranges[a + i], u = this.ranges[a + o], d = l + c;
    if (e <= d) {
      var f = c ? e == l ? -1 : e == d ? 1 : n : n, p = l + s + (f < 0 ? 0 : u);
      if (r)
        return p;
      var h = e == (n < 0 ? l : d) ? null : DRe(a / 3, e - l);
      return new r1(p, n < 0 ? e != l : e != d, h);
    }
    s += u - c;
  }
  return r ? e + s : new r1(e + s);
};
qr.prototype.touches = function(e, n) {
  for (var r = 0, s = V6(n), i = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2, a = 0; a < this.ranges.length; a += 3) {
    var l = this.ranges[a] - (this.inverted ? r : 0);
    if (l > e)
      break;
    var c = this.ranges[a + i], u = l + c;
    if (e <= u && a == s * 3)
      return !0;
    r += this.ranges[a + o] - c;
  }
  return !1;
};
qr.prototype.forEach = function(e) {
  for (var n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2, s = 0, i = 0; s < this.ranges.length; s += 3) {
    var o = this.ranges[s], a = o - (this.inverted ? i : 0), l = o + (this.inverted ? 0 : i), c = this.ranges[s + n], u = this.ranges[s + r];
    e(a, a + c, l, l + u), i += u - c;
  }
};
qr.prototype.invert = function() {
  return new qr(this.ranges, !this.inverted);
};
qr.prototype.toString = function() {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
};
qr.offset = function(e) {
  return e == 0 ? qr.empty : new qr(e < 0 ? [0, -e, 0] : [0, 0, e]);
};
qr.empty = new qr([]);
var vs = function(e, n, r, s) {
  this.maps = e || [], this.from = r || 0, this.to = s ?? this.maps.length, this.mirror = n;
};
vs.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.maps.length), new vs(this.maps, this.mirror, e, n);
};
vs.prototype.copy = function() {
  return new vs(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
};
vs.prototype.appendMap = function(e, n) {
  this.to = this.maps.push(e), n != null && this.setMirror(this.maps.length - 1, n);
};
vs.prototype.appendMapping = function(e) {
  for (var n = 0, r = this.maps.length; n < e.maps.length; n++) {
    var s = e.getMirror(n);
    this.appendMap(e.maps[n], s != null && s < n ? r + s : null);
  }
};
vs.prototype.getMirror = function(e) {
  if (this.mirror) {
    for (var n = 0; n < this.mirror.length; n++)
      if (this.mirror[n] == e)
        return this.mirror[n + (n % 2 ? -1 : 1)];
  }
};
vs.prototype.setMirror = function(e, n) {
  this.mirror || (this.mirror = []), this.mirror.push(e, n);
};
vs.prototype.appendMappingInverted = function(e) {
  for (var n = e.maps.length - 1, r = this.maps.length + e.maps.length; n >= 0; n--) {
    var s = e.getMirror(n);
    this.appendMap(e.maps[n].invert(), s != null && s > n ? r - s - 1 : null);
  }
};
vs.prototype.invert = function() {
  var e = new vs();
  return e.appendMappingInverted(this), e;
};
vs.prototype.map = function(e, n) {
  if (n === void 0 && (n = 1), this.mirror)
    return this._map(e, n, !0);
  for (var r = this.from; r < this.to; r++)
    e = this.maps[r].map(e, n);
  return e;
};
vs.prototype.mapResult = function(e, n) {
  return n === void 0 && (n = 1), this._map(e, n, !1);
};
vs.prototype._map = function(e, n, r) {
  for (var s = !1, i = this.from; i < this.to; i++) {
    var o = this.maps[i], a = o.mapResult(e, n);
    if (a.recover != null) {
      var l = this.getMirror(i);
      if (l != null && l > i && l < this.to) {
        i = l, e = this.maps[l].recover(a.recover);
        continue;
      }
    }
    a.deleted && (s = !0), e = a.pos;
  }
  return r ? e : new r1(e, s);
};
function lu(t) {
  var e = Error.call(this, t);
  return e.__proto__ = lu.prototype, e;
}
lu.prototype = Object.create(Error.prototype);
lu.prototype.constructor = lu;
lu.prototype.name = "TransformError";
var ur = function(e) {
  this.doc = e, this.steps = [], this.docs = [], this.mapping = new vs();
}, V2 = { before: { configurable: !0 }, docChanged: { configurable: !0 } };
V2.before.get = function() {
  return this.docs.length ? this.docs[0] : this.doc;
};
ur.prototype.step = function(e) {
  var n = this.maybeStep(e);
  if (n.failed)
    throw new lu(n.failed);
  return this;
};
ur.prototype.maybeStep = function(e) {
  var n = e.apply(this.doc);
  return n.failed || this.addStep(e, n.doc), n;
};
V2.docChanged.get = function() {
  return this.steps.length > 0;
};
ur.prototype.addStep = function(e, n) {
  this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
};
Object.defineProperties(ur.prototype, V2);
function sg() {
  throw new Error("Override me");
}
var s1 = /* @__PURE__ */ Object.create(null), _s = function() {
};
_s.prototype.apply = function(e) {
  return sg();
};
_s.prototype.getMap = function() {
  return qr.empty;
};
_s.prototype.invert = function(e) {
  return sg();
};
_s.prototype.map = function(e) {
  return sg();
};
_s.prototype.merge = function(e) {
  return null;
};
_s.prototype.toJSON = function() {
  return sg();
};
_s.fromJSON = function(e, n) {
  if (!n || !n.stepType)
    throw new RangeError("Invalid input for Step.fromJSON");
  var r = s1[n.stepType];
  if (!r)
    throw new RangeError("No step type " + n.stepType + " defined");
  return r.fromJSON(e, n);
};
_s.jsonID = function(e, n) {
  if (e in s1)
    throw new RangeError("Duplicate use of step JSON ID " + e);
  return s1[e] = n, n.prototype.jsonID = e, n;
};
var Ts = function(e, n) {
  this.doc = e, this.failed = n;
};
Ts.ok = function(e) {
  return new Ts(e, null);
};
Ts.fail = function(e) {
  return new Ts(null, e);
};
Ts.fromReplace = function(e, n, r, s) {
  try {
    return Ts.ok(e.replace(n, r, s));
  } catch (i) {
    if (i instanceof So)
      return Ts.fail(i.message);
    throw i;
  }
};
var ol = /* @__PURE__ */ function(t) {
  function e(n, r, s, i) {
    t.call(this), this.from = n, this.to = r, this.slice = s, this.structure = !!i;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.apply = function(r) {
    return this.structure && i1(r, this.from, this.to) ? Ts.fail("Structure replace would overwrite content") : Ts.fromReplace(r, this.from, this.to, this.slice);
  }, e.prototype.getMap = function() {
    return new qr([this.from, this.to - this.from, this.slice.size]);
  }, e.prototype.invert = function(r) {
    return new e(this.from, this.from + this.slice.size, r.slice(this.from, this.to));
  }, e.prototype.map = function(r) {
    var s = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1);
    return s.deleted && i.deleted ? null : new e(s.pos, Math.max(s.pos, i.pos), this.slice);
  }, e.prototype.merge = function(r) {
    if (!(r instanceof e) || r.structure != this.structure)
      return null;
    if (this.from + this.slice.size == r.from && !this.slice.openEnd && !r.slice.openStart) {
      var s = this.slice.size + r.slice.size == 0 ? He.empty : new He(this.slice.content.append(r.slice.content), this.slice.openStart, r.slice.openEnd);
      return new e(this.from, this.to + (r.to - r.from), s, this.structure);
    } else if (r.to == this.from && !this.slice.openStart && !r.slice.openEnd) {
      var i = this.slice.size + r.slice.size == 0 ? He.empty : new He(r.slice.content.append(this.slice.content), r.slice.openStart, this.slice.openEnd);
      return new e(r.from, this.to, i, this.structure);
    } else
      return null;
  }, e.prototype.toJSON = function() {
    var r = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (r.slice = this.slice.toJSON()), this.structure && (r.structure = !0), r;
  }, e.fromJSON = function(r, s) {
    if (typeof s.from != "number" || typeof s.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new e(s.from, s.to, He.fromJSON(r, s.slice), !!s.structure);
  }, e;
}(_s);
_s.jsonID("replace", ol);
var Zo = /* @__PURE__ */ function(t) {
  function e(n, r, s, i, o, a, l) {
    t.call(this), this.from = n, this.to = r, this.gapFrom = s, this.gapTo = i, this.slice = o, this.insert = a, this.structure = !!l;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.apply = function(r) {
    if (this.structure && (i1(r, this.from, this.gapFrom) || i1(r, this.gapTo, this.to)))
      return Ts.fail("Structure gap-replace would overwrite content");
    var s = r.slice(this.gapFrom, this.gapTo);
    if (s.openStart || s.openEnd)
      return Ts.fail("Gap is not a flat range");
    var i = this.slice.insertAt(this.insert, s.content);
    return i ? Ts.fromReplace(r, this.from, this.to, i) : Ts.fail("Content does not fit in gap");
  }, e.prototype.getMap = function() {
    return new qr([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }, e.prototype.invert = function(r) {
    var s = this.gapTo - this.gapFrom;
    return new e(
      this.from,
      this.from + this.slice.size + s,
      this.from + this.insert,
      this.from + this.insert + s,
      r.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
      this.gapFrom - this.from,
      this.structure
    );
  }, e.prototype.map = function(r) {
    var s = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1), o = r.map(this.gapFrom, -1), a = r.map(this.gapTo, 1);
    return s.deleted && i.deleted || o < s.pos || a > i.pos ? null : new e(s.pos, i.pos, o, a, this.slice, this.insert, this.structure);
  }, e.prototype.toJSON = function() {
    var r = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (r.slice = this.slice.toJSON()), this.structure && (r.structure = !0), r;
  }, e.fromJSON = function(r, s) {
    if (typeof s.from != "number" || typeof s.to != "number" || typeof s.gapFrom != "number" || typeof s.gapTo != "number" || typeof s.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new e(
      s.from,
      s.to,
      s.gapFrom,
      s.gapTo,
      He.fromJSON(r, s.slice),
      s.insert,
      !!s.structure
    );
  }, e;
}(_s);
_s.jsonID("replaceAround", Zo);
function i1(t, e, n) {
  for (var r = t.resolve(e), s = n - e, i = r.depth; s > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, s--;
  if (s > 0)
    for (var o = r.node(i).maybeChild(r.indexAfter(i)); s > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, s--;
    }
  return !1;
}
function ORe(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function z2(t) {
  for (var e = t.parent, n = e.content.cutByIndex(t.startIndex, t.endIndex), r = t.depth; ; --r) {
    var s = t.$from.node(r), i = t.$from.index(r), o = t.$to.indexAfter(r);
    if (r < t.depth && s.canReplace(i, o, n))
      return r;
    if (r == 0 || s.type.spec.isolating || !ORe(s, i, o))
      break;
  }
}
ur.prototype.lift = function(t, e) {
  for (var n = t.$from, r = t.$to, s = t.depth, i = n.before(s + 1), o = r.after(s + 1), a = i, l = o, c = xe.empty, u = 0, d = s, f = !1; d > e; d--)
    f || n.index(d) > 0 ? (f = !0, c = xe.from(n.node(d).copy(c)), u++) : a--;
  for (var p = xe.empty, h = 0, m = s, v = !1; m > e; m--)
    v || r.after(m + 1) < r.end(m) ? (v = !0, p = xe.from(r.node(m).copy(p)), h++) : l++;
  return this.step(new Zo(
    a,
    l,
    i,
    o,
    new He(c.append(p), u, h),
    c.size - u,
    !0
  ));
};
ur.prototype.wrap = function(t, e) {
  for (var n = xe.empty, r = e.length - 1; r >= 0; r--)
    n = xe.from(e[r].type.create(e[r].attrs, n));
  var s = t.start, i = t.end;
  return this.step(new Zo(s, i, s, i, new He(n, 0, 0), e.length, !0));
};
ur.prototype.setBlockType = function(t, e, n, r) {
  var s = this;
  if (e === void 0 && (e = t), !n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  var i = this.steps.length;
  return this.doc.nodesBetween(t, e, function(o, a) {
    if (o.isTextblock && !o.hasMarkup(n, r) && MRe(s.doc, s.mapping.slice(i).map(a), n)) {
      s.clearIncompatible(s.mapping.slice(i).map(a, 1), n);
      var l = s.mapping.slice(i), c = l.map(a, 1), u = l.map(a + o.nodeSize, 1);
      return s.step(new Zo(
        c,
        u,
        c + 1,
        u - 1,
        new He(xe.from(n.create(r, null, o.marks)), 0, 0),
        1,
        !0
      )), !1;
    }
  }), this;
};
function MRe(t, e, n) {
  var r = t.resolve(e), s = r.index();
  return r.parent.canReplaceWith(s, s + 1, n);
}
ur.prototype.setNodeMarkup = function(t, e, n, r) {
  var s = this.doc.nodeAt(t);
  if (!s)
    throw new RangeError("No node at given position");
  e || (e = s.type);
  var i = e.create(n, null, r || s.marks);
  if (s.isLeaf)
    return this.replaceWith(t, t + s.nodeSize, i);
  if (!e.validContent(s.content))
    throw new RangeError("Invalid content for node type " + e.name);
  return this.step(new Zo(
    t,
    t + s.nodeSize,
    t + 1,
    t + s.nodeSize - 1,
    new He(xe.from(i), 0, 0),
    1,
    !0
  ));
};
function yh(t, e, n, r) {
  n === void 0 && (n = 1);
  var s = t.resolve(e), i = s.depth - n, o = r && r[r.length - 1] || s.parent;
  if (i < 0 || s.parent.type.spec.isolating || !s.parent.canReplace(s.index(), s.parent.childCount) || !o.type.validContent(s.parent.content.cutByIndex(s.index(), s.parent.childCount)))
    return !1;
  for (var a = s.depth - 1, l = n - 2; a > i; a--, l--) {
    var c = s.node(a), u = s.index(a);
    if (c.type.spec.isolating)
      return !1;
    var d = c.content.cutByIndex(u, c.childCount), f = r && r[l] || c;
    if (f != c && (d = d.replaceChild(0, f.type.create(f.attrs))), !c.canReplace(u + 1, c.childCount) || !f.type.validContent(d))
      return !1;
  }
  var p = s.indexAfter(i), h = r && r[0];
  return s.node(i).canReplaceWith(p, p, h ? h.type : s.node(i + 1).type);
}
ur.prototype.split = function(t, e, n) {
  e === void 0 && (e = 1);
  for (var r = this.doc.resolve(t), s = xe.empty, i = xe.empty, o = r.depth, a = r.depth - e, l = e - 1; o > a; o--, l--) {
    s = xe.from(r.node(o).copy(s));
    var c = n && n[l];
    i = xe.from(c ? c.type.create(c.attrs, i) : r.node(o).copy(i));
  }
  return this.step(new ol(t, t, new He(s.append(i), e, e), !0));
};
function z6(t, e) {
  var n = t.resolve(e), r = n.index();
  return RRe(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function RRe(t, e) {
  return t && e && !t.isLeaf && t.canAppend(e);
}
ur.prototype.join = function(t, e) {
  e === void 0 && (e = 1);
  var n = new ol(t - e, t + e, He.empty, !0);
  return this.step(n);
};
function LRe(t, e, n) {
  var r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (var s = r.depth - 1; s >= 0; s--) {
      var i = r.index(s);
      if (r.node(s).canReplaceWith(i, i, n))
        return r.before(s + 1);
      if (i > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (var o = r.depth - 1; o >= 0; o--) {
      var a = r.indexAfter(o);
      if (r.node(o).canReplaceWith(a, a, n))
        return r.after(o + 1);
      if (a < r.node(o).childCount)
        return null;
    }
}
function U6(t, e, n) {
  var r = t.resolve(e);
  if (!n.content.size)
    return e;
  for (var s = n.content, i = 0; i < n.openStart; i++)
    s = s.firstChild.content;
  for (var o = 1; o <= (n.openStart == 0 && n.size ? 2 : 1); o++)
    for (var a = r.depth; a >= 0; a--) {
      var l = a == r.depth ? 0 : r.pos <= (r.start(a + 1) + r.end(a + 1)) / 2 ? -1 : 1, c = r.index(a) + (l > 0 ? 1 : 0);
      if (o == 1 ? r.node(a).canReplace(c, c, s) : r.node(a).contentMatchAt(c).findWrapping(s.firstChild.type))
        return l == 0 ? r.pos : l < 0 ? r.before(a + 1) : r.after(a + 1);
    }
  return null;
}
function U2(t, e, n) {
  for (var r = [], s = 0; s < t.childCount; s++) {
    var i = t.child(s);
    i.content.size && (i = i.copy(U2(i.content, e, i))), i.isInline && (i = e(i, n, s)), r.push(i);
  }
  return xe.fromArray(r);
}
var G2 = /* @__PURE__ */ function(t) {
  function e(n, r, s) {
    t.call(this), this.from = n, this.to = r, this.mark = s;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.apply = function(r) {
    var s = this, i = r.slice(this.from, this.to), o = r.resolve(this.from), a = o.node(o.sharedDepth(this.to)), l = new He(U2(i.content, function(c, u) {
      return u.type.allowsMarkType(s.mark.type) ? c.mark(s.mark.addToSet(c.marks)) : c;
    }, a), i.openStart, i.openEnd);
    return Ts.fromReplace(r, this.from, this.to, l);
  }, e.prototype.invert = function() {
    return new Xf(this.from, this.to, this.mark);
  }, e.prototype.map = function(r) {
    var s = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1);
    return s.deleted && i.deleted || s.pos >= i.pos ? null : new e(s.pos, i.pos, this.mark);
  }, e.prototype.merge = function(r) {
    if (r instanceof e && r.mark.eq(this.mark) && this.from <= r.to && this.to >= r.from)
      return new e(
        Math.min(this.from, r.from),
        Math.max(this.to, r.to),
        this.mark
      );
  }, e.prototype.toJSON = function() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }, e.fromJSON = function(r, s) {
    if (typeof s.from != "number" || typeof s.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new e(s.from, s.to, r.markFromJSON(s.mark));
  }, e;
}(_s);
_s.jsonID("addMark", G2);
var Xf = /* @__PURE__ */ function(t) {
  function e(n, r, s) {
    t.call(this), this.from = n, this.to = r, this.mark = s;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.apply = function(r) {
    var s = this, i = r.slice(this.from, this.to), o = new He(U2(i.content, function(a) {
      return a.mark(s.mark.removeFromSet(a.marks));
    }), i.openStart, i.openEnd);
    return Ts.fromReplace(r, this.from, this.to, o);
  }, e.prototype.invert = function() {
    return new G2(this.from, this.to, this.mark);
  }, e.prototype.map = function(r) {
    var s = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1);
    return s.deleted && i.deleted || s.pos >= i.pos ? null : new e(s.pos, i.pos, this.mark);
  }, e.prototype.merge = function(r) {
    if (r instanceof e && r.mark.eq(this.mark) && this.from <= r.to && this.to >= r.from)
      return new e(
        Math.min(this.from, r.from),
        Math.max(this.to, r.to),
        this.mark
      );
  }, e.prototype.toJSON = function() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }, e.fromJSON = function(r, s) {
    if (typeof s.from != "number" || typeof s.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new e(s.from, s.to, r.markFromJSON(s.mark));
  }, e;
}(_s);
_s.jsonID("removeMark", Xf);
ur.prototype.addMark = function(t, e, n) {
  var r = this, s = [], i = [], o = null, a = null;
  return this.doc.nodesBetween(t, e, function(l, c, u) {
    if (l.isInline) {
      var d = l.marks;
      if (!n.isInSet(d) && u.type.allowsMarkType(n.type)) {
        for (var f = Math.max(c, t), p = Math.min(c + l.nodeSize, e), h = n.addToSet(d), m = 0; m < d.length; m++)
          d[m].isInSet(h) || (o && o.to == f && o.mark.eq(d[m]) ? o.to = p : s.push(o = new Xf(f, p, d[m])));
        a && a.to == f ? a.to = p : i.push(a = new G2(f, p, n));
      }
    }
  }), s.forEach(function(l) {
    return r.step(l);
  }), i.forEach(function(l) {
    return r.step(l);
  }), this;
};
ur.prototype.removeMark = function(t, e, n) {
  var r = this;
  n === void 0 && (n = null);
  var s = [], i = 0;
  return this.doc.nodesBetween(t, e, function(o, a) {
    if (o.isInline) {
      i++;
      var l = null;
      if (n instanceof Ua) {
        var c = n.isInSet(o.marks);
        c && (l = [c]);
      } else n ? n.isInSet(o.marks) && (l = [n]) : l = o.marks;
      if (l && l.length)
        for (var u = Math.min(a + o.nodeSize, e), d = 0; d < l.length; d++) {
          for (var f = l[d], p = void 0, h = 0; h < s.length; h++) {
            var m = s[h];
            m.step == i - 1 && f.eq(s[h].style) && (p = m);
          }
          p ? (p.to = u, p.step = i) : s.push({ style: f, from: Math.max(a, t), to: u, step: i });
        }
    }
  }), s.forEach(function(o) {
    return r.step(new Xf(o.from, o.to, o.style));
  }), this;
};
ur.prototype.clearIncompatible = function(t, e, n) {
  n === void 0 && (n = e.contentMatch);
  for (var r = this.doc.nodeAt(t), s = [], i = t + 1, o = 0; o < r.childCount; o++) {
    var a = r.child(o), l = i + a.nodeSize, c = n.matchType(a.type, a.attrs);
    if (!c)
      s.push(new ol(i, l, He.empty));
    else {
      n = c;
      for (var u = 0; u < a.marks.length; u++)
        e.allowsMarkType(a.marks[u].type) || this.step(new Xf(i, l, a.marks[u]));
    }
    i = l;
  }
  if (!n.validEnd) {
    var d = n.fillBefore(xe.empty, !0);
    this.replace(i, i, new He(d, 0, 0));
  }
  for (var f = s.length - 1; f >= 0; f--)
    this.step(s[f]);
  return this;
};
function Y2(t, e, n, r) {
  if (n === void 0 && (n = e), r === void 0 && (r = He.empty), e == n && !r.size)
    return null;
  var s = t.resolve(e), i = t.resolve(n);
  return G6(s, i, r) ? new ol(e, n, r) : new ki(s, i, r).fit();
}
ur.prototype.replace = function(t, e, n) {
  e === void 0 && (e = t), n === void 0 && (n = He.empty);
  var r = Y2(this.doc, t, e, n);
  return r && this.step(r), this;
};
ur.prototype.replaceWith = function(t, e, n) {
  return this.replace(t, e, new He(xe.from(n), 0, 0));
};
ur.prototype.delete = function(t, e) {
  return this.replace(t, e, He.empty);
};
ur.prototype.insert = function(t, e) {
  return this.replaceWith(t, t, e);
};
function G6(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
var ki = function(e, n, r) {
  this.$to = n, this.$from = e, this.unplaced = r, this.frontier = [];
  for (var s = 0; s <= e.depth; s++) {
    var i = e.node(s);
    this.frontier.push({
      type: i.type,
      match: i.contentMatchAt(e.indexAfter(s))
    });
  }
  this.placed = xe.empty;
  for (var o = e.depth; o > 0; o--)
    this.placed = xe.from(e.node(o).copy(this.placed));
}, Y6 = { depth: { configurable: !0 } };
Y6.depth.get = function() {
  return this.frontier.length - 1;
};
ki.prototype.fit = function() {
  for (; this.unplaced.size; ) {
    var e = this.findFittable();
    e ? this.placeNodes(e) : this.openMore() || this.dropNode();
  }
  var n = this.mustMoveInline(), r = this.placed.size - this.depth - this.$from.depth, s = this.$from, i = this.close(n < 0 ? this.$to : s.doc.resolve(n));
  if (!i)
    return null;
  for (var o = this.placed, a = s.depth, l = i.depth; a && l && o.childCount == 1; )
    o = o.firstChild.content, a--, l--;
  var c = new He(o, a, l);
  if (n > -1)
    return new Zo(s.pos, n, this.$to.pos, this.$to.end(), c, r);
  if (c.size || s.pos != this.$to.pos)
    return new ol(s.pos, i.pos, c);
};
ki.prototype.findFittable = function() {
  for (var e = 1; e <= 2; e++)
    for (var n = this.unplaced.openStart; n >= 0; n--) {
      var r = void 0, s = void 0;
      n ? (s = Z2(this.unplaced.content, n - 1).firstChild, r = s.content) : r = this.unplaced.content;
      for (var i = r.firstChild, o = this.depth; o >= 0; o--) {
        var a = this.frontier[o], l = a.type, c = a.match, u = void 0, d = void 0;
        if (e == 1 && (i ? c.matchType(i.type) || (d = c.fillBefore(xe.from(i), !1)) : l.compatibleContent(s.type)))
          return { sliceDepth: n, frontierDepth: o, parent: s, inject: d };
        if (e == 2 && i && (u = c.findWrapping(i.type)))
          return { sliceDepth: n, frontierDepth: o, parent: s, wrap: u };
        if (s && c.matchType(s.type))
          break;
      }
    }
};
ki.prototype.openMore = function() {
  var e = this.unplaced, n = e.content, r = e.openStart, s = e.openEnd, i = Z2(n, r);
  return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new He(
    n,
    r + 1,
    Math.max(s, i.size + r >= n.size - s ? r + 1 : 0)
  ), !0);
};
ki.prototype.dropNode = function() {
  var e = this.unplaced, n = e.content, r = e.openStart, s = e.openEnd, i = Z2(n, r);
  if (i.childCount <= 1 && r > 0) {
    var o = n.size - r <= r + i.size;
    this.unplaced = new He(
      ff(n, r - 1, 1),
      r - 1,
      o ? r - 1 : s
    );
  } else
    this.unplaced = new He(ff(n, r, 1), r, s);
};
ki.prototype.placeNodes = function(e) {
  for (var n = e.sliceDepth, r = e.frontierDepth, s = e.parent, i = e.inject, o = e.wrap; this.depth > r; )
    this.closeFrontierNode();
  if (o)
    for (var a = 0; a < o.length; a++)
      this.openFrontierNode(o[a]);
  var l = this.unplaced, c = s ? s.content : l.content, u = l.openStart - n, d = 0, f = [], p = this.frontier[r], h = p.match, m = p.type;
  if (i) {
    for (var v = 0; v < i.childCount; v++)
      f.push(i.child(v));
    h = h.matchFragment(i);
  }
  for (var y = c.size + n - (l.content.size - l.openEnd); d < c.childCount; ) {
    var _ = c.child(d), w = h.matchType(_.type);
    if (!w)
      break;
    d++, (d > 1 || u == 0 || _.content.size) && (h = w, f.push(Z6(
      _.mark(m.allowedMarks(_.marks)),
      d == 1 ? u : 0,
      d == c.childCount ? y : -1
    )));
  }
  var S = d == c.childCount;
  S || (y = -1), this.placed = Kf(this.placed, r, xe.from(f)), this.frontier[r].match = h, S && y < 0 && s && s.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
  for (var E = 0, x = c; E < y; E++) {
    var T = x.lastChild;
    this.frontier.push({ type: T.type, match: T.contentMatchAt(T.childCount) }), x = T.content;
  }
  this.unplaced = S ? n == 0 ? He.empty : new He(
    ff(l.content, n - 1, 1),
    n - 1,
    y < 0 ? l.openEnd : n - 1
  ) : new He(ff(l.content, n, d), l.openStart, l.openEnd);
};
ki.prototype.mustMoveInline = function() {
  if (!this.$to.parent.isTextblock || this.$to.end() == this.$to.pos)
    return -1;
  var e = this.frontier[this.depth], n;
  if (!e.type.isTextblock || !o1(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
    return -1;
  for (var r = this.$to, s = r.depth, i = this.$to.after(s); s > 1 && i == this.$to.end(--s); )
    ++i;
  return i;
};
ki.prototype.findCloseLevel = function(e) {
  e: for (var n = Math.min(this.depth, e.depth); n >= 0; n--) {
    var r = this.frontier[n], s = r.match, i = r.type, o = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), a = o1(e, n, i, s, o);
    if (a) {
      for (var l = n - 1; l >= 0; l--) {
        var c = this.frontier[l], u = c.match, d = c.type, f = o1(e, l, d, u, !0);
        if (!f || f.childCount)
          continue e;
      }
      return { depth: n, fit: a, move: o ? e.doc.resolve(e.after(n + 1)) : e };
    }
  }
};
ki.prototype.close = function(e) {
  var n = this.findCloseLevel(e);
  if (!n)
    return null;
  for (; this.depth > n.depth; )
    this.closeFrontierNode();
  n.fit.childCount && (this.placed = Kf(this.placed, n.depth, n.fit)), e = n.move;
  for (var r = n.depth + 1; r <= e.depth; r++) {
    var s = e.node(r), i = s.type.contentMatch.fillBefore(s.content, !0, e.index(r));
    this.openFrontierNode(s.type, s.attrs, i);
  }
  return e;
};
ki.prototype.openFrontierNode = function(e, n, r) {
  var s = this.frontier[this.depth];
  s.match = s.match.matchType(e), this.placed = Kf(this.placed, this.depth, xe.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
};
ki.prototype.closeFrontierNode = function() {
  var e = this.frontier.pop(), n = e.match.fillBefore(xe.empty, !0);
  n.childCount && (this.placed = Kf(this.placed, this.frontier.length, n));
};
Object.defineProperties(ki.prototype, Y6);
function ff(t, e, n) {
  return e == 0 ? t.cutByIndex(n) : t.replaceChild(0, t.firstChild.copy(ff(t.firstChild.content, e - 1, n)));
}
function Kf(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(
    t.childCount - 1,
    t.lastChild.copy(Kf(t.lastChild.content, e - 1, n))
  );
}
function Z2(t, e) {
  for (var n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function Z6(t, e, n) {
  if (e <= 0)
    return t;
  var r = t.content;
  return e > 1 && (r = r.replaceChild(0, Z6(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(xe.empty, !0)))), t.copy(r);
}
function o1(t, e, n, r, s) {
  var i = t.node(e), o = s ? t.indexAfter(e) : t.index(e);
  if (o == i.childCount && !n.compatibleContent(i.type))
    return null;
  var a = r.fillBefore(i.content, !0, o);
  return a && !FRe(n, i.content, o) ? a : null;
}
function FRe(t, e, n) {
  for (var r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
ur.prototype.replaceRange = function(t, e, n) {
  if (!n.size)
    return this.deleteRange(t, e);
  var r = this.doc.resolve(t), s = this.doc.resolve(e);
  if (G6(r, s, n))
    return this.step(new ol(t, e, n));
  var i = K6(r, this.doc.resolve(e));
  i[i.length - 1] == 0 && i.pop();
  var o = -(r.depth + 1);
  i.unshift(o);
  for (var a = r.depth, l = r.pos - 1; a > 0; a--, l--) {
    var c = r.node(a).type.spec;
    if (c.defining || c.isolating)
      break;
    i.indexOf(a) > -1 ? o = a : r.before(a) == l && i.splice(1, 0, -a);
  }
  for (var u = i.indexOf(o), d = [], f = n.openStart, p = n.content, h = 0; ; h++) {
    var m = p.firstChild;
    if (d.push(m), h == n.openStart)
      break;
    p = m.content;
  }
  f > 0 && d[f - 1].type.spec.defining && r.node(u).type != d[f - 1].type ? f -= 1 : f >= 2 && d[f - 1].isTextblock && d[f - 2].type.spec.defining && r.node(u).type != d[f - 2].type && (f -= 2);
  for (var v = n.openStart; v >= 0; v--) {
    var y = (v + f + 1) % (n.openStart + 1), _ = d[y];
    if (_)
      for (var w = 0; w < i.length; w++) {
        var S = i[(w + u) % i.length], E = !0;
        S < 0 && (E = !1, S = -S);
        var x = r.node(S - 1), T = r.index(S - 1);
        if (x.canReplaceWith(T, T, _.type, _.marks))
          return this.replace(
            r.before(S),
            E ? s.after(S) : e,
            new He(
              X6(n.content, 0, n.openStart, y),
              y,
              n.openEnd
            )
          );
      }
  }
  for (var C = this.steps.length, k = i.length - 1; k >= 0 && (this.replace(t, e, n), !(this.steps.length > C)); k--) {
    var b = i[k];
    k < 0 || (t = r.before(b), e = s.after(b));
  }
  return this;
};
function X6(t, e, n, r, s) {
  if (e < n) {
    var i = t.firstChild;
    t = t.replaceChild(0, i.copy(X6(i.content, e + 1, n, r, i)));
  }
  if (e > r) {
    var o = s.contentMatchAt(0), a = o.fillBefore(t).append(t);
    t = a.append(o.matchFragment(a).fillBefore(xe.empty, !0));
  }
  return t;
}
ur.prototype.replaceRangeWith = function(t, e, n) {
  if (!n.isInline && t == e && this.doc.resolve(t).parent.content.size) {
    var r = LRe(this.doc, t, n.type);
    r != null && (t = e = r);
  }
  return this.replaceRange(t, e, new He(xe.from(n), 0, 0));
};
ur.prototype.deleteRange = function(t, e) {
  for (var n = this.doc.resolve(t), r = this.doc.resolve(e), s = K6(n, r), i = 0; i < s.length; i++) {
    var o = s[i], a = i == s.length - 1;
    if (a && o == 0 || n.node(o).type.contentMatch.validEnd)
      return this.delete(n.start(o), r.end(o));
    if (o > 0 && (a || n.node(o - 1).canReplace(n.index(o - 1), r.indexAfter(o - 1))))
      return this.delete(n.before(o), r.after(o));
  }
  for (var l = 1; l <= n.depth && l <= r.depth; l++)
    if (t - n.start(l) == n.depth - l && e > n.end(l) && r.end(l) - e != r.depth - l)
      return this.delete(n.before(l), e);
  return this.delete(t, e);
};
function K6(t, e) {
  for (var n = [], r = Math.min(t.depth, e.depth), s = r; s >= 0; s--) {
    var i = t.start(s);
    if (i < t.pos - (t.depth - s) || e.end(s) > e.pos + (e.depth - s) || t.node(s).type.spec.isolating || e.node(s).type.spec.isolating)
      break;
    i == e.start(s) && n.push(s);
  }
  return n;
}
var a1 = /* @__PURE__ */ Object.create(null), yt = function(e, n, r) {
  this.ranges = r || [new J6(e.min(n), e.max(n))], this.$anchor = e, this.$head = n;
}, al = { anchor: { configurable: !0 }, head: { configurable: !0 }, from: { configurable: !0 }, to: { configurable: !0 }, $from: { configurable: !0 }, $to: { configurable: !0 }, empty: { configurable: !0 } };
al.anchor.get = function() {
  return this.$anchor.pos;
};
al.head.get = function() {
  return this.$head.pos;
};
al.from.get = function() {
  return this.$from.pos;
};
al.to.get = function() {
  return this.$to.pos;
};
al.$from.get = function() {
  return this.ranges[0].$from;
};
al.$to.get = function() {
  return this.ranges[0].$to;
};
al.empty.get = function() {
  for (var t = this.ranges, e = 0; e < t.length; e++)
    if (t[e].$from.pos != t[e].$to.pos)
      return !1;
  return !0;
};
yt.prototype.content = function() {
  return this.$from.node(0).slice(this.from, this.to, !0);
};
yt.prototype.replace = function(e, n) {
  n === void 0 && (n = He.empty);
  for (var r = n.content.lastChild, s = null, i = 0; i < n.openEnd; i++)
    s = r, r = r.lastChild;
  for (var o = e.steps.length, a = this.ranges, l = 0; l < a.length; l++) {
    var c = a[l], u = c.$from, d = c.$to, f = e.mapping.slice(o);
    e.replaceRange(f.map(u.pos), f.map(d.pos), l ? He.empty : n), l == 0 && q6(e, o, (r ? r.isInline : s && s.isTextblock) ? -1 : 1);
  }
};
yt.prototype.replaceWith = function(e, n) {
  for (var r = e.steps.length, s = this.ranges, i = 0; i < s.length; i++) {
    var o = s[i], a = o.$from, l = o.$to, c = e.mapping.slice(r), u = c.map(a.pos), d = c.map(l.pos);
    i ? e.deleteRange(u, d) : (e.replaceRangeWith(u, d, n), q6(e, r, n.isInline ? -1 : 1));
  }
};
yt.findFrom = function(e, n, r) {
  var s = e.parent.inlineContent ? new Mt(e) : Kc(e.node(0), e.parent, e.pos, e.index(), n, r);
  if (s)
    return s;
  for (var i = e.depth - 1; i >= 0; i--) {
    var o = n < 0 ? Kc(e.node(0), e.node(i), e.before(i + 1), e.index(i), n, r) : Kc(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, n, r);
    if (o)
      return o;
  }
};
yt.near = function(e, n) {
  return n === void 0 && (n = 1), this.findFrom(e, n) || this.findFrom(e, -n) || new Co(e.node(0));
};
yt.atStart = function(e) {
  return Kc(e, e, 0, 0, 1) || new Co(e);
};
yt.atEnd = function(e) {
  return Kc(e, e, e.content.size, e.childCount, -1) || new Co(e);
};
yt.fromJSON = function(e, n) {
  if (!n || !n.type)
    throw new RangeError("Invalid input for Selection.fromJSON");
  var r = a1[n.type];
  if (!r)
    throw new RangeError("No selection type " + n.type + " defined");
  return r.fromJSON(e, n);
};
yt.jsonID = function(e, n) {
  if (e in a1)
    throw new RangeError("Duplicate use of selection JSON ID " + e);
  return a1[e] = n, n.prototype.jsonID = e, n;
};
yt.prototype.getBookmark = function() {
  return Mt.between(this.$anchor, this.$head).getBookmark();
};
Object.defineProperties(yt.prototype, al);
yt.prototype.visible = !0;
var J6 = function(e, n) {
  this.$from = e, this.$to = n;
}, Mt = /* @__PURE__ */ function(t) {
  function e(r, s) {
    s === void 0 && (s = r), t.call(this, r, s);
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { $cursor: { configurable: !0 } };
  return n.$cursor.get = function() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }, e.prototype.map = function(s, i) {
    var o = s.resolve(i.map(this.head));
    if (!o.parent.inlineContent)
      return t.near(o);
    var a = s.resolve(i.map(this.anchor));
    return new e(a.parent.inlineContent ? a : o, o);
  }, e.prototype.replace = function(s, i) {
    if (i === void 0 && (i = He.empty), t.prototype.replace.call(this, s, i), i == He.empty) {
      var o = this.$from.marksAcross(this.$to);
      o && s.ensureMarks(o);
    }
  }, e.prototype.eq = function(s) {
    return s instanceof e && s.anchor == this.anchor && s.head == this.head;
  }, e.prototype.getBookmark = function() {
    return new pf(this.anchor, this.head);
  }, e.prototype.toJSON = function() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }, e.fromJSON = function(s, i) {
    if (typeof i.anchor != "number" || typeof i.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new e(s.resolve(i.anchor), s.resolve(i.head));
  }, e.create = function(s, i, o) {
    o === void 0 && (o = i);
    var a = s.resolve(i);
    return new this(a, o == i ? a : s.resolve(o));
  }, e.between = function(s, i, o) {
    var a = s.pos - i.pos;
    if ((!o || a) && (o = a >= 0 ? 1 : -1), !i.parent.inlineContent) {
      var l = t.findFrom(i, o, !0) || t.findFrom(i, -o, !0);
      if (l)
        i = l.$head;
      else
        return t.near(i, o);
    }
    return s.parent.inlineContent || (a == 0 ? s = i : (s = (t.findFrom(s, -o, !0) || t.findFrom(s, o, !0)).$anchor, s.pos < i.pos != a < 0 && (s = i))), new e(s, i);
  }, Object.defineProperties(e.prototype, n), e;
}(yt);
yt.jsonID("text", Mt);
var pf = function(e, n) {
  this.anchor = e, this.head = n;
};
pf.prototype.map = function(e) {
  return new pf(e.map(this.anchor), e.map(this.head));
};
pf.prototype.resolve = function(e) {
  return Mt.between(e.resolve(this.anchor), e.resolve(this.head));
};
var ct = /* @__PURE__ */ function(t) {
  function e(n) {
    var r = n.nodeAfter, s = n.node(0).resolve(n.pos + r.nodeSize);
    t.call(this, n, s), this.node = r;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.map = function(r, s) {
    var i = s.mapResult(this.anchor), o = i.deleted, a = i.pos, l = r.resolve(a);
    return o ? t.near(l) : new e(l);
  }, e.prototype.content = function() {
    return new He(xe.from(this.node), 0, 0);
  }, e.prototype.eq = function(r) {
    return r instanceof e && r.anchor == this.anchor;
  }, e.prototype.toJSON = function() {
    return { type: "node", anchor: this.anchor };
  }, e.prototype.getBookmark = function() {
    return new Ym(this.anchor);
  }, e.fromJSON = function(r, s) {
    if (typeof s.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new e(r.resolve(s.anchor));
  }, e.create = function(r, s) {
    return new this(r.resolve(s));
  }, e.isSelectable = function(r) {
    return !r.isText && r.type.spec.selectable !== !1;
  }, e;
}(yt);
ct.prototype.visible = !1;
yt.jsonID("node", ct);
var Ym = function(e) {
  this.anchor = e;
};
Ym.prototype.map = function(e) {
  var n = e.mapResult(this.anchor), r = n.deleted, s = n.pos;
  return r ? new pf(s, s) : new Ym(s);
};
Ym.prototype.resolve = function(e) {
  var n = e.resolve(this.anchor), r = n.nodeAfter;
  return r && ct.isSelectable(r) ? new ct(n) : yt.near(n);
};
var Co = /* @__PURE__ */ function(t) {
  function e(n) {
    t.call(this, n.resolve(0), n.resolve(n.content.size));
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.replace = function(r, s) {
    if (s === void 0 && (s = He.empty), s == He.empty) {
      r.delete(0, r.doc.content.size);
      var i = t.atStart(r.doc);
      i.eq(r.selection) || r.setSelection(i);
    } else
      t.prototype.replace.call(this, r, s);
  }, e.prototype.toJSON = function() {
    return { type: "all" };
  }, e.fromJSON = function(r) {
    return new e(r);
  }, e.prototype.map = function(r) {
    return new e(r);
  }, e.prototype.eq = function(r) {
    return r instanceof e;
  }, e.prototype.getBookmark = function() {
    return BRe;
  }, e;
}(yt);
yt.jsonID("all", Co);
var BRe = {
  map: function() {
    return this;
  },
  resolve: function(e) {
    return new Co(e);
  }
};
function Kc(t, e, n, r, s, i) {
  if (e.inlineContent)
    return Mt.create(t, n);
  for (var o = r - (s > 0 ? 0 : 1); s > 0 ? o < e.childCount : o >= 0; o += s) {
    var a = e.child(o);
    if (a.isAtom) {
      if (!i && ct.isSelectable(a))
        return ct.create(t, n - (s < 0 ? a.nodeSize : 0));
    } else {
      var l = Kc(t, a, n + s, s < 0 ? a.childCount : 0, s, i);
      if (l)
        return l;
    }
    n += a.nodeSize * s;
  }
}
function q6(t, e, n) {
  var r = t.steps.length - 1;
  if (!(r < e)) {
    var s = t.steps[r];
    if (s instanceof ol || s instanceof Zo) {
      var i = t.mapping.maps[r], o;
      i.forEach(function(a, l, c, u) {
        o == null && (o = u);
      }), t.setSelection(yt.near(t.doc.resolve(o), n));
    }
  }
}
var PN = 1, Dp = 2, kN = 4, jRe = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this, r.doc), this.time = Date.now(), this.curSelection = r.selection, this.curSelectionFor = 0, this.storedMarks = r.storedMarks, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null);
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { selection: { configurable: !0 }, selectionSet: { configurable: !0 }, storedMarksSet: { configurable: !0 }, isGeneric: { configurable: !0 }, scrolledIntoView: { configurable: !0 } };
  return n.selection.get = function() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }, e.prototype.setSelection = function(s) {
    if (s.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = s, this.curSelectionFor = this.steps.length, this.updated = (this.updated | PN) & ~Dp, this.storedMarks = null, this;
  }, n.selectionSet.get = function() {
    return (this.updated & PN) > 0;
  }, e.prototype.setStoredMarks = function(s) {
    return this.storedMarks = s, this.updated |= Dp, this;
  }, e.prototype.ensureMarks = function(s) {
    return Xt.sameSet(this.storedMarks || this.selection.$from.marks(), s) || this.setStoredMarks(s), this;
  }, e.prototype.addStoredMark = function(s) {
    return this.ensureMarks(s.addToSet(this.storedMarks || this.selection.$head.marks()));
  }, e.prototype.removeStoredMark = function(s) {
    return this.ensureMarks(s.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }, n.storedMarksSet.get = function() {
    return (this.updated & Dp) > 0;
  }, e.prototype.addStep = function(s, i) {
    t.prototype.addStep.call(this, s, i), this.updated = this.updated & ~Dp, this.storedMarks = null;
  }, e.prototype.setTime = function(s) {
    return this.time = s, this;
  }, e.prototype.replaceSelection = function(s) {
    return this.selection.replace(this, s), this;
  }, e.prototype.replaceSelectionWith = function(s, i) {
    var o = this.selection;
    return i !== !1 && (s = s.mark(this.storedMarks || (o.empty ? o.$from.marks() : o.$from.marksAcross(o.$to) || Xt.none))), o.replaceWith(this, s), this;
  }, e.prototype.deleteSelection = function() {
    return this.selection.replace(this), this;
  }, e.prototype.insertText = function(s, i, o) {
    o === void 0 && (o = i);
    var a = this.doc.type.schema;
    if (i == null)
      return s ? this.replaceSelectionWith(a.text(s), !0) : this.deleteSelection();
    if (!s)
      return this.deleteRange(i, o);
    var l = this.storedMarks;
    if (!l) {
      var c = this.doc.resolve(i);
      l = o == i ? c.marks() : c.marksAcross(this.doc.resolve(o));
    }
    return this.replaceRangeWith(i, o, a.text(s, l)), this.selection.empty || this.setSelection(yt.near(this.selection.$to)), this;
  }, e.prototype.setMeta = function(s, i) {
    return this.meta[typeof s == "string" ? s : s.key] = i, this;
  }, e.prototype.getMeta = function(s) {
    return this.meta[typeof s == "string" ? s : s.key];
  }, n.isGeneric.get = function() {
    for (var r in this.meta)
      return !1;
    return !0;
  }, e.prototype.scrollIntoView = function() {
    return this.updated |= kN, this;
  }, n.scrolledIntoView.get = function() {
    return (this.updated & kN) > 0;
  }, Object.defineProperties(e.prototype, n), e;
}(ur);
function NN(t, e) {
  return !e || !t ? t : t.bind(e);
}
var Nd = function(e, n, r) {
  this.name = e, this.init = NN(n.init, r), this.apply = NN(n.apply, r);
}, WRe = [
  new Nd("doc", {
    init: function(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply: function(e) {
      return e.doc;
    }
  }),
  new Nd("selection", {
    init: function(e, n) {
      return e.selection || yt.atStart(n.doc);
    },
    apply: function(e) {
      return e.selection;
    }
  }),
  new Nd("storedMarks", {
    init: function(e) {
      return e.storedMarks || null;
    },
    apply: function(e, n, r, s) {
      return s.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Nd("scrollToSelection", {
    init: function() {
      return 0;
    },
    apply: function(e, n) {
      return e.scrolledIntoView ? n + 1 : n;
    }
  })
], X2 = function(e, n) {
  var r = this;
  this.schema = e, this.fields = WRe.concat(), this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), n && n.forEach(function(s) {
    if (r.pluginsByKey[s.key])
      throw new RangeError("Adding different instances of a keyed plugin (" + s.key + ")");
    r.plugins.push(s), r.pluginsByKey[s.key] = s, s.spec.state && r.fields.push(new Nd(s.key, s.spec.state, s));
  });
}, gs = function(e) {
  this.config = e;
}, ig = { schema: { configurable: !0 }, plugins: { configurable: !0 }, tr: { configurable: !0 } };
ig.schema.get = function() {
  return this.config.schema;
};
ig.plugins.get = function() {
  return this.config.plugins;
};
gs.prototype.apply = function(e) {
  return this.applyTransaction(e).state;
};
gs.prototype.filterTransaction = function(e, n) {
  n === void 0 && (n = -1);
  for (var r = 0; r < this.config.plugins.length; r++)
    if (r != n) {
      var s = this.config.plugins[r];
      if (s.spec.filterTransaction && !s.spec.filterTransaction.call(s, e, this))
        return !1;
    }
  return !0;
};
gs.prototype.applyTransaction = function(e) {
  if (!this.filterTransaction(e))
    return { state: this, transactions: [] };
  for (var n = [e], r = this.applyInner(e), s = null; ; ) {
    for (var i = !1, o = 0; o < this.config.plugins.length; o++) {
      var a = this.config.plugins[o];
      if (a.spec.appendTransaction) {
        var l = s ? s[o].n : 0, c = s ? s[o].state : this, u = l < n.length && a.spec.appendTransaction.call(a, l ? n.slice(l) : n, c, r);
        if (u && r.filterTransaction(u, o)) {
          if (u.setMeta("appendedTransaction", e), !s) {
            s = [];
            for (var d = 0; d < this.config.plugins.length; d++)
              s.push(d < o ? { state: r, n: n.length } : { state: this, n: 0 });
          }
          n.push(u), r = r.applyInner(u), i = !0;
        }
        s && (s[o] = { state: r, n: n.length });
      }
    }
    if (!i)
      return { state: r, transactions: n };
  }
};
gs.prototype.applyInner = function(e) {
  if (!e.before.eq(this.doc))
    throw new RangeError("Applying a mismatched transaction");
  for (var n = new gs(this.config), r = this.config.fields, s = 0; s < r.length; s++) {
    var i = r[s];
    n[i.name] = i.apply(e, this[i.name], this, n);
  }
  for (var o = 0; o < hf.length; o++)
    hf[o](this, e, n);
  return n;
};
ig.tr.get = function() {
  return new jRe(this);
};
gs.create = function(e) {
  for (var n = new X2(e.schema || e.doc.type.schema, e.plugins), r = new gs(n), s = 0; s < n.fields.length; s++)
    r[n.fields[s].name] = n.fields[s].init(e, r);
  return r;
};
gs.prototype.reconfigure = function(e) {
  for (var n = new X2(e.schema || this.schema, e.plugins), r = n.fields, s = new gs(n), i = 0; i < r.length; i++) {
    var o = r[i].name;
    s[o] = this.hasOwnProperty(o) ? this[o] : r[i].init(e, s);
  }
  return s;
};
gs.prototype.toJSON = function(e) {
  var n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
  if (this.storedMarks && (n.storedMarks = this.storedMarks.map(function(o) {
    return o.toJSON();
  })), e && typeof e == "object")
    for (var r in e) {
      if (r == "doc" || r == "selection")
        throw new RangeError("The JSON fields `doc` and `selection` are reserved");
      var s = e[r], i = s.spec.state;
      i && i.toJSON && (n[r] = i.toJSON.call(s, this[s.key]));
    }
  return n;
};
gs.fromJSON = function(e, n, r) {
  if (!n)
    throw new RangeError("Invalid input for EditorState.fromJSON");
  if (!e.schema)
    throw new RangeError("Required config field 'schema' missing");
  var s = new X2(e.schema, e.plugins), i = new gs(s);
  return s.fields.forEach(function(o) {
    if (o.name == "doc")
      i.doc = jt.fromJSON(e.schema, n.doc);
    else if (o.name == "selection")
      i.selection = yt.fromJSON(i.doc, n.selection);
    else if (o.name == "storedMarks")
      n.storedMarks && (i.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
    else {
      if (r)
        for (var a in r) {
          var l = r[a], c = l.spec.state;
          if (l.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, a)) {
            i[o.name] = c.fromJSON.call(l, e, n[a], i);
            return;
          }
        }
      i[o.name] = o.init(e, i);
    }
  }), i;
};
gs.addApplyListener = function(e) {
  hf.push(e);
};
gs.removeApplyListener = function(e) {
  var n = hf.indexOf(e);
  n > -1 && hf.splice(n, 1);
};
Object.defineProperties(gs.prototype, ig);
var hf = [];
function Q6(t, e, n) {
  for (var r in t) {
    var s = t[r];
    s instanceof Function ? s = s.bind(e) : r == "handleDOMEvents" && (s = Q6(s, e, {})), n[r] = s;
  }
  return n;
}
var lr = function(e) {
  this.props = {}, e.props && Q6(e.props, this, this.props), this.spec = e, this.key = e.key ? e.key.key : e9("plugin");
};
lr.prototype.getState = function(e) {
  return e[this.key];
};
var Qy = /* @__PURE__ */ Object.create(null);
function e9(t) {
  return t in Qy ? t + "$" + ++Qy[t] : (Qy[t] = 0, t + "$");
}
var ci = function(e) {
  e === void 0 && (e = "key"), this.key = e9(e);
};
ci.prototype.get = function(e) {
  return e.config.pluginsByKey[this.key];
};
ci.prototype.getState = function(e) {
  return e[this.key];
};
var Fe = {};
if (typeof navigator < "u" && typeof document < "u") {
  var eb = /Edge\/(\d+)/.exec(navigator.userAgent), $N = /MSIE \d/.test(navigator.userAgent), tb = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
  Fe.mac = /Mac/.test(navigator.platform);
  var nb = Fe.ie = !!($N || tb || eb);
  Fe.ie_version = $N ? document.documentMode || 6 : tb ? +tb[1] : eb ? +eb[1] : null, Fe.gecko = !nb && /gecko\/(\d+)/i.test(navigator.userAgent), Fe.gecko_version = Fe.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var rb = !nb && /Chrome\/(\d+)/.exec(navigator.userAgent);
  Fe.chrome = !!rb, Fe.chrome_version = rb && +rb[1], Fe.safari = !nb && /Apple Computer/.test(navigator.vendor), Fe.ios = Fe.safari && (/Mobile\/\w+/.test(navigator.userAgent) || navigator.maxTouchPoints > 2), Fe.android = /Android \d/.test(navigator.userAgent), Fe.webkit = "webkitFontSmoothing" in document.documentElement.style, Fe.webkit_version = Fe.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}
var Ii = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, t9 = function(t) {
  var e = t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
}, DN = null, Lo = function(t, e, n) {
  var r = DN || (DN = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, Zm = function(t, e, n, r) {
  return n && (AN(t, e, n, r, -1) || AN(t, e, n, r, 1));
}, HRe = /^(img|br|input|textarea|hr)$/i;
function AN(t, e, n, r, s) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (s < 0 ? 0 : mo(t))) {
      var i = t.parentNode;
      if (i.nodeType != 1 || zRe(t) || HRe.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = Ii(t) + (s < 0 ? 0 : 1), t = i;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (s < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = s < 0 ? mo(t) : 0;
    } else
      return !1;
  }
}
function mo(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function VRe(t, e, n) {
  for (var r = e == 0, s = e == mo(t); r || s; ) {
    if (t == n)
      return !0;
    var i = Ii(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && i == 0, s = s && i == mo(t);
  }
}
function zRe(t) {
  for (var e, n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
var K2 = function(t) {
  var e = t.isCollapsed;
  return e && Fe.chrome && t.rangeCount && !t.getRangeAt(0).collapsed && (e = !1), e;
};
function Vc(t, e) {
  var n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function URe(t) {
  return {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function ca(t, e) {
  return typeof t == "number" ? t : t[e];
}
function GRe(t) {
  var e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function ON(t, e, n) {
  for (var r = t.someProp("scrollThreshold") || 0, s = t.someProp("scrollMargin") || 5, i = t.dom.ownerDocument, o = n || t.dom; o; o = t9(o))
    if (o.nodeType == 1) {
      var a = o == i.body || o.nodeType != 1, l = a ? URe(i) : GRe(o), c = 0, u = 0;
      if (e.top < l.top + ca(r, "top") ? u = -(l.top - e.top + ca(s, "top")) : e.bottom > l.bottom - ca(r, "bottom") && (u = e.bottom - l.bottom + ca(s, "bottom")), e.left < l.left + ca(r, "left") ? c = -(l.left - e.left + ca(s, "left")) : e.right > l.right - ca(r, "right") && (c = e.right - l.right + ca(s, "right")), c || u)
        if (a)
          i.defaultView.scrollBy(c, u);
        else {
          var d = o.scrollLeft, f = o.scrollTop;
          u && (o.scrollTop += u), c && (o.scrollLeft += c);
          var p = o.scrollLeft - d, h = o.scrollTop - f;
          e = { left: e.left - p, top: e.top - h, right: e.right - p, bottom: e.bottom - h };
        }
      if (a)
        break;
    }
}
function YRe(t) {
  for (var e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, s, i = (e.left + e.right) / 2, o = n + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    var a = t.root.elementFromPoint(i, o);
    if (!(a == t.dom || !t.dom.contains(a))) {
      var l = a.getBoundingClientRect();
      if (l.top >= n - 20) {
        r = a, s = l.top;
        break;
      }
    }
  }
  return { refDOM: r, refTop: s, stack: n9(t.dom) };
}
function n9(t) {
  for (var e = [], n = t.ownerDocument; t && (e.push({ dom: t, top: t.scrollTop, left: t.scrollLeft }), t != n); t = t9(t))
    ;
  return e;
}
function ZRe(t) {
  var e = t.refDOM, n = t.refTop, r = t.stack, s = e ? e.getBoundingClientRect().top : 0;
  r9(r, s == 0 ? 0 : s - n);
}
function r9(t, e) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n], s = r.dom, i = r.top, o = r.left;
    s.scrollTop != i + e && (s.scrollTop = i + e), s.scrollLeft != o && (s.scrollLeft = o);
  }
}
var Pc = null;
function XRe(t) {
  if (t.setActive)
    return t.setActive();
  if (Pc)
    return t.focus(Pc);
  var e = n9(t);
  t.focus(Pc == null ? {
    get preventScroll() {
      return Pc = { preventScroll: !0 }, !0;
    }
  } : void 0), Pc || (Pc = !1, r9(e, 0));
}
function s9(t, e) {
  for (var n, r = 2e8, s, i = 0, o = e.top, a = e.top, l = t.firstChild, c = 0; l; l = l.nextSibling, c++) {
    var u = void 0;
    if (l.nodeType == 1)
      u = l.getClientRects();
    else if (l.nodeType == 3)
      u = Lo(l).getClientRects();
    else
      continue;
    for (var d = 0; d < u.length; d++) {
      var f = u[d];
      if (f.top <= o && f.bottom >= a) {
        o = Math.max(f.bottom, o), a = Math.min(f.top, a);
        var p = f.left > e.left ? f.left - e.left : f.right < e.left ? e.left - f.right : 0;
        if (p < r) {
          n = l, r = p, s = p && n.nodeType == 3 ? { left: f.right < e.left ? f.right : f.left, top: e.top } : e, l.nodeType == 1 && p && (i = c + (e.left >= (f.left + f.right) / 2 ? 1 : 0));
          continue;
        }
      }
      !n && (e.left >= f.right && e.top >= f.top || e.left >= f.left && e.top >= f.bottom) && (i = c + 1);
    }
  }
  return n && n.nodeType == 3 ? KRe(n, s) : !n || r && n.nodeType == 1 ? { node: t, offset: i } : s9(n, s);
}
function KRe(t, e) {
  for (var n = t.nodeValue.length, r = document.createRange(), s = 0; s < n; s++) {
    r.setEnd(t, s + 1), r.setStart(t, s);
    var i = pa(r, 1);
    if (i.top != i.bottom && J2(e, i))
      return { node: t, offset: s + (e.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function J2(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function JRe(t, e) {
  var n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function qRe(t, e, n) {
  var r = s9(e, n), s = r.node, i = r.offset, o = -1;
  if (s.nodeType == 1 && !s.firstChild) {
    var a = s.getBoundingClientRect();
    o = a.left != a.right && n.left > (a.left + a.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(s, i, o);
}
function QRe(t, e, n, r) {
  for (var s = -1, i = e; i != t.dom; ) {
    var o = t.docView.nearestDesc(i, !0);
    if (!o)
      return null;
    if (o.node.isBlock && o.parent) {
      var a = o.dom.getBoundingClientRect();
      if (a.left > r.left || a.top > r.top)
        s = o.posBefore;
      else if (a.right < r.left || a.bottom < r.top)
        s = o.posAfter;
      else
        break;
    }
    i = o.dom.parentNode;
  }
  return s > -1 ? s : t.docView.posFromDOM(e, n);
}
function i9(t, e, n) {
  var r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (var s = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), i = s; ; ) {
      var o = t.childNodes[i];
      if (o.nodeType == 1)
        for (var a = o.getClientRects(), l = 0; l < a.length; l++) {
          var c = a[l];
          if (J2(e, c))
            return i9(o, e, c);
        }
      if ((i = (i + 1) % r) == s)
        break;
    }
  return t;
}
function eLe(t, e) {
  var n, r, s = t.root, i, o;
  if (s.caretPositionFromPoint)
    try {
      var a = s.caretPositionFromPoint(e.left, e.top);
      a && (n = a, i = n.offsetNode, o = n.offset);
    } catch {
    }
  if (!i && s.caretRangeFromPoint) {
    var l = s.caretRangeFromPoint(e.left, e.top);
    l && (r = l, i = r.startContainer, o = r.startOffset);
  }
  var c = s.elementFromPoint(e.left, e.top + 1), u;
  if (!c || !t.dom.contains(c.nodeType != 1 ? c.parentNode : c)) {
    var d = t.dom.getBoundingClientRect();
    if (!J2(e, d) || (c = i9(t.dom, e, d), !c))
      return null;
  }
  if (Fe.safari && c.draggable && (i = o = null), c = JRe(c, e), i) {
    if (Fe.gecko && i.nodeType == 1 && (o = Math.min(o, i.childNodes.length), o < i.childNodes.length)) {
      var f = i.childNodes[o], p;
      f.nodeName == "IMG" && (p = f.getBoundingClientRect()).right <= e.left && p.bottom > e.top && o++;
    }
    i == t.dom && o == i.childNodes.length - 1 && i.lastChild.nodeType == 1 && e.top > i.lastChild.getBoundingClientRect().bottom ? u = t.state.doc.content.size : (o == 0 || i.nodeType != 1 || i.childNodes[o - 1].nodeName != "BR") && (u = QRe(t, i, o, e));
  }
  u == null && (u = qRe(t, c, e));
  var h = t.docView.nearestDesc(c, !0);
  return { pos: u, inside: h ? h.posAtStart - h.border : -1 };
}
function pa(t, e) {
  var n = t.getClientRects();
  return n.length ? n[e < 0 ? 0 : n.length - 1] : t.getBoundingClientRect();
}
var tLe = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function o9(t, e, n) {
  var r = t.docView.domFromPos(e, n < 0 ? -1 : 1), s = r.node, i = r.offset, o = Fe.webkit || Fe.gecko;
  if (s.nodeType == 3)
    if (o && (tLe.test(s.nodeValue) || (n < 0 ? !i : i == s.nodeValue.length))) {
      var a = pa(Lo(s, i, i), n);
      if (Fe.gecko && i && /\s/.test(s.nodeValue[i - 1]) && i < s.nodeValue.length) {
        var l = pa(Lo(s, i - 1, i - 1), -1);
        if (l.top == a.top) {
          var c = pa(Lo(s, i, i + 1), -1);
          if (c.top != a.top)
            return fd(c, c.left < l.left);
        }
      }
      return a;
    } else {
      var u = i, d = i, f = n < 0 ? 1 : -1;
      return n < 0 && !i ? (d++, f = -1) : n >= 0 && i == s.nodeValue.length ? (u--, f = 1) : n < 0 ? u-- : d++, fd(pa(Lo(s, u, d), f), f < 0);
    }
  if (!t.state.doc.resolve(e).parent.inlineContent) {
    if (i && (n < 0 || i == mo(s))) {
      var p = s.childNodes[i - 1];
      if (p.nodeType == 1)
        return sb(p.getBoundingClientRect(), !1);
    }
    if (i < mo(s)) {
      var h = s.childNodes[i];
      if (h.nodeType == 1)
        return sb(h.getBoundingClientRect(), !0);
    }
    return sb(s.getBoundingClientRect(), n >= 0);
  }
  if (i && (n < 0 || i == mo(s))) {
    var m = s.childNodes[i - 1], v = m.nodeType == 3 ? Lo(m, mo(m) - (o ? 0 : 1)) : m.nodeType == 1 && (m.nodeName != "BR" || !m.nextSibling) ? m : null;
    if (v)
      return fd(pa(v, 1), !1);
  }
  if (i < mo(s)) {
    var y = s.childNodes[i], _ = y.nodeType == 3 ? Lo(y, 0, o ? 0 : 1) : y.nodeType == 1 ? y : null;
    if (_)
      return fd(pa(_, -1), !0);
  }
  return fd(pa(s.nodeType == 3 ? Lo(s) : s, -n), n >= 0);
}
function fd(t, e) {
  if (t.width == 0)
    return t;
  var n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function sb(t, e) {
  if (t.height == 0)
    return t;
  var n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function a9(t, e, n) {
  var r = t.state, s = t.root.activeElement;
  r != e && t.updateState(e), s != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), s != t.dom && s && s.focus();
  }
}
function nLe(t, e, n) {
  var r = e.selection, s = n == "up" ? r.$from : r.$to;
  return a9(t, e, function() {
    for (var i = t.docView.domFromPos(s.pos, n == "up" ? -1 : 1), o = i.node; ; ) {
      var a = t.docView.nearestDesc(o, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        o = a.dom;
        break;
      }
      o = a.dom.parentNode;
    }
    for (var l = o9(t, s.pos, 1), c = o.firstChild; c; c = c.nextSibling) {
      var u = void 0;
      if (c.nodeType == 1)
        u = c.getClientRects();
      else if (c.nodeType == 3)
        u = Lo(c, 0, c.nodeValue.length).getClientRects();
      else
        continue;
      for (var d = 0; d < u.length; d++) {
        var f = u[d];
        if (f.bottom > f.top && (n == "up" ? f.bottom < l.top + 1 : f.top > l.bottom - 1))
          return !1;
      }
    }
    return !0;
  });
}
var rLe = /[\u0590-\u08ac]/;
function sLe(t, e, n) {
  var r = e.selection, s = r.$head;
  if (!s.parent.isTextblock)
    return !1;
  var i = s.parentOffset, o = !i, a = i == s.parent.content.size, l = getSelection();
  return !rLe.test(s.parent.textContent) || !l.modify ? n == "left" || n == "backward" ? o : a : a9(t, e, function() {
    var c = l.getRangeAt(0), u = l.focusNode, d = l.focusOffset, f = l.caretBidiLevel;
    l.modify("move", n, "character");
    var p = s.depth ? t.docView.domAfterPos(s.before()) : t.dom, h = !p.contains(l.focusNode.nodeType == 1 ? l.focusNode : l.focusNode.parentNode) || u == l.focusNode && d == l.focusOffset;
    return l.removeAllRanges(), l.addRange(c), f != null && (l.caretBidiLevel = f), h;
  });
}
var MN = null, RN = null, LN = !1;
function iLe(t, e, n) {
  return MN == e && RN == n ? LN : (MN = e, RN = n, LN = n == "up" || n == "down" ? nLe(t, e, n) : sLe(t, e, n));
}
var Hi = 0, l9 = 1, Xm = 2, Zl = 3, Cn = function(e, n, r, s) {
  this.parent = e, this.children = n, this.dom = r, r.pmViewDesc = this, this.contentDOM = s, this.dirty = Hi;
}, To = { beforePosition: { configurable: !0 }, size: { configurable: !0 }, border: { configurable: !0 }, posBefore: { configurable: !0 }, posAtStart: { configurable: !0 }, posAfter: { configurable: !0 }, posAtEnd: { configurable: !0 }, contentLost: { configurable: !0 }, domAtom: { configurable: !0 } };
Cn.prototype.matchesWidget = function() {
  return !1;
};
Cn.prototype.matchesMark = function() {
  return !1;
};
Cn.prototype.matchesNode = function() {
  return !1;
};
Cn.prototype.matchesHack = function() {
  return !1;
};
To.beforePosition.get = function() {
  return !1;
};
Cn.prototype.parseRule = function() {
  return null;
};
Cn.prototype.stopEvent = function() {
  return !1;
};
To.size.get = function() {
  for (var t = 0, e = 0; e < this.children.length; e++)
    t += this.children[e].size;
  return t;
};
To.border.get = function() {
  return 0;
};
Cn.prototype.destroy = function() {
  this.parent = null, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = null);
  for (var e = 0; e < this.children.length; e++)
    this.children[e].destroy();
};
Cn.prototype.posBeforeChild = function(e) {
  for (var n = 0, r = this.posAtStart; n < this.children.length; n++) {
    var s = this.children[n];
    if (s == e)
      return r;
    r += s.size;
  }
};
To.posBefore.get = function() {
  return this.parent.posBeforeChild(this);
};
To.posAtStart.get = function() {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
};
To.posAfter.get = function() {
  return this.posBefore + this.size;
};
To.posAtEnd.get = function() {
  return this.posAtStart + this.size - 2 * this.border;
};
Cn.prototype.localPosFromDOM = function(e, n, r) {
  if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
    if (r < 0) {
      var s, i;
      if (e == this.contentDOM)
        s = e.childNodes[n - 1];
      else {
        for (; e.parentNode != this.contentDOM; )
          e = e.parentNode;
        s = e.previousSibling;
      }
      for (; s && !((i = s.pmViewDesc) && i.parent == this); )
        s = s.previousSibling;
      return s ? this.posBeforeChild(i) + i.size : this.posAtStart;
    } else {
      var o, a;
      if (e == this.contentDOM)
        o = e.childNodes[n];
      else {
        for (; e.parentNode != this.contentDOM; )
          e = e.parentNode;
        o = e.nextSibling;
      }
      for (; o && !((a = o.pmViewDesc) && a.parent == this); )
        o = o.nextSibling;
      return o ? this.posBeforeChild(a) : this.posAtEnd;
    }
  var l;
  if (e == this.dom && this.contentDOM)
    l = n > Ii(this.contentDOM);
  else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
    l = e.compareDocumentPosition(this.contentDOM) & 2;
  else if (this.dom.firstChild) {
    if (n == 0)
      for (var c = e; ; c = c.parentNode) {
        if (c == this.dom) {
          l = !1;
          break;
        }
        if (c.parentNode.firstChild != c)
          break;
      }
    if (l == null && n == e.childNodes.length)
      for (var u = e; ; u = u.parentNode) {
        if (u == this.dom) {
          l = !0;
          break;
        }
        if (u.parentNode.lastChild != u)
          break;
      }
  }
  return l ?? r > 0 ? this.posAtEnd : this.posAtStart;
};
Cn.prototype.nearestDesc = function(e, n) {
  for (var r = !0, s = e; s; s = s.parentNode) {
    var i = this.getDesc(s);
    if (i && (!n || i.node))
      if (r && i.nodeDOM && !(i.nodeDOM.nodeType == 1 ? i.nodeDOM.contains(e.nodeType == 1 ? e : e.parentNode) : i.nodeDOM == e))
        r = !1;
      else
        return i;
  }
};
Cn.prototype.getDesc = function(e) {
  for (var n = e.pmViewDesc, r = n; r; r = r.parent)
    if (r == this)
      return n;
};
Cn.prototype.posFromDOM = function(e, n, r) {
  for (var s = e; s; s = s.parentNode) {
    var i = this.getDesc(s);
    if (i)
      return i.localPosFromDOM(e, n, r);
  }
  return -1;
};
Cn.prototype.descAt = function(e) {
  for (var n = 0, r = 0; n < this.children.length; n++) {
    var s = this.children[n], i = r + s.size;
    if (r == e && i != r) {
      for (; !s.border && s.children.length; )
        s = s.children[0];
      return s;
    }
    if (e < i)
      return s.descAt(e - r - s.border);
    r = i;
  }
};
Cn.prototype.domFromPos = function(e, n) {
  if (!this.contentDOM)
    return { node: this.dom, offset: 0 };
  for (var r = 0, s = 0, i = !0; ; s++, i = !1) {
    for (; s < this.children.length && (this.children[s].beforePosition || this.children[s].dom.parentNode != this.contentDOM); )
      r += this.children[s++].size;
    var o = s == this.children.length ? null : this.children[s];
    if (r == e && (n == 0 || !o || !o.size || o.border || n < 0 && i) || o && o.domAtom && e < r + o.size)
      return {
        node: this.contentDOM,
        offset: o ? Ii(o.dom) : this.contentDOM.childNodes.length
      };
    if (!o)
      throw new Error("Invalid position " + e);
    var a = r + o.size;
    if (!o.domAtom && (n < 0 && !o.border ? a >= e : a > e) && (a > e || s + 1 >= this.children.length || !this.children[s + 1].beforePosition))
      return o.domFromPos(e - r - o.border, n);
    r = a;
  }
};
Cn.prototype.parseRange = function(e, n, r) {
  if (r === void 0 && (r = 0), this.children.length == 0)
    return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
  for (var s = -1, i = -1, o = r, a = 0; ; a++) {
    var l = this.children[a], c = o + l.size;
    if (s == -1 && e <= c) {
      var u = o + l.border;
      if (e >= u && n <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
        return l.parseRange(e, n, u);
      e = o;
      for (var d = a; d > 0; d--) {
        var f = this.children[d - 1];
        if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
          s = Ii(f.dom) + 1;
          break;
        }
        e -= f.size;
      }
      s == -1 && (s = 0);
    }
    if (s > -1 && (c > n || a == this.children.length - 1)) {
      n = c;
      for (var p = a + 1; p < this.children.length; p++) {
        var h = this.children[p];
        if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(-1)) {
          i = Ii(h.dom);
          break;
        }
        n += h.size;
      }
      i == -1 && (i = this.contentDOM.childNodes.length);
      break;
    }
    o = c;
  }
  return { node: this.contentDOM, from: e, to: n, fromOffset: s, toOffset: i };
};
Cn.prototype.emptyChildAt = function(e) {
  if (this.border || !this.contentDOM || !this.children.length)
    return !1;
  var n = this.children[e < 0 ? 0 : this.children.length - 1];
  return n.size == 0 || n.emptyChildAt(e);
};
Cn.prototype.domAfterPos = function(e) {
  var n = this.domFromPos(e, 0), r = n.node, s = n.offset;
  if (r.nodeType != 1 || s == r.childNodes.length)
    throw new RangeError("No node after pos " + e);
  return r.childNodes[s];
};
Cn.prototype.setSelection = function(e, n, r, s) {
  for (var i = Math.min(e, n), o = Math.max(e, n), a = 0, l = 0; a < this.children.length; a++) {
    var c = this.children[a], u = l + c.size;
    if (i > l && o < u)
      return c.setSelection(e - l - c.border, n - l - c.border, r, s);
    l = u;
  }
  var d = this.domFromPos(e, e ? -1 : 1), f = n == e ? d : this.domFromPos(n, n ? -1 : 1), p = r.getSelection(), h = !1;
  if ((Fe.gecko || Fe.safari) && e == n) {
    var m = d.node, v = d.offset;
    if (m.nodeType == 3)
      h = v && m.nodeValue[v - 1] == `
`, h && v == m.nodeValue.length && m.nextSibling && m.nextSibling.nodeName == "BR" && (d = f = { node: m.parentNode, offset: Ii(m) + 1 });
    else {
      var y = m.childNodes[v - 1];
      h = y && (y.nodeName == "BR" || y.contentEditable == "false");
    }
  }
  if (!(!(s || h && Fe.safari) && Zm(d.node, d.offset, p.anchorNode, p.anchorOffset) && Zm(f.node, f.offset, p.focusNode, p.focusOffset))) {
    var _ = !1;
    if ((p.extend || e == n) && !h) {
      p.collapse(d.node, d.offset);
      try {
        e != n && p.extend(f.node, f.offset), _ = !0;
      } catch (E) {
        if (!(E instanceof DOMException))
          throw E;
      }
    }
    if (!_) {
      if (e > n) {
        var w = d;
        d = f, f = w;
      }
      var S = document.createRange();
      S.setEnd(f.node, f.offset), S.setStart(d.node, d.offset), p.removeAllRanges(), p.addRange(S);
    }
  }
};
Cn.prototype.ignoreMutation = function(e) {
  return !this.contentDOM && e.type != "selection";
};
To.contentLost.get = function() {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
};
Cn.prototype.markDirty = function(e, n) {
  for (var r = 0, s = 0; s < this.children.length; s++) {
    var i = this.children[s], o = r + i.size;
    if (r == o ? e <= o && n >= r : e < o && n > r) {
      var a = r + i.border, l = o - i.border;
      if (e >= a && n <= l) {
        this.dirty = e == r || n == o ? Xm : l9, e == a && n == l && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = Zl : i.markDirty(e - a, n - a);
        return;
      } else
        i.dirty = Zl;
    }
    r = o;
  }
  this.dirty = Xm;
};
Cn.prototype.markParentsDirty = function() {
  for (var e = 1, n = this.parent; n; n = n.parent, e++) {
    var r = e == 1 ? Xm : l9;
    n.dirty < r && (n.dirty = r);
  }
};
To.domAtom.get = function() {
  return !1;
};
Object.defineProperties(Cn.prototype, To);
var Ga = [], oLe = /* @__PURE__ */ function(t) {
  function e(r, s, i, o) {
    var a, l = s.type.toDOM;
    if (typeof l == "function" && (l = l(i, function() {
      if (!a)
        return o;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    })), !s.type.spec.raw) {
      if (l.nodeType != 1) {
        var c = document.createElement("span");
        c.appendChild(l), l = c;
      }
      l.contentEditable = !1, l.classList.add("ProseMirror-widget");
    }
    t.call(this, r, Ga, l, null), this.widget = s, a = this;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { beforePosition: { configurable: !0 }, domAtom: { configurable: !0 } };
  return n.beforePosition.get = function() {
    return this.widget.type.side < 0;
  }, e.prototype.matchesWidget = function(s) {
    return this.dirty == Hi && s.type.eq(this.widget.type);
  }, e.prototype.parseRule = function() {
    return { ignore: !0 };
  }, e.prototype.stopEvent = function(s) {
    var i = this.widget.spec.stopEvent;
    return i ? i(s) : !1;
  }, e.prototype.ignoreMutation = function(s) {
    return s.type != "selection" || this.widget.spec.ignoreSelection;
  }, n.domAtom.get = function() {
    return !0;
  }, Object.defineProperties(e.prototype, n), e;
}(Cn), aLe = /* @__PURE__ */ function(t) {
  function e(r, s, i, o) {
    t.call(this, r, Ga, s, null), this.textDOM = i, this.text = o;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { size: { configurable: !0 } };
  return n.size.get = function() {
    return this.text.length;
  }, e.prototype.localPosFromDOM = function(s, i) {
    return s != this.textDOM ? this.posAtStart + (i ? this.size : 0) : this.posAtStart + i;
  }, e.prototype.domFromPos = function(s) {
    return { node: this.textDOM, offset: s };
  }, e.prototype.ignoreMutation = function(s) {
    return s.type === "characterData" && s.target.nodeValue == s.oldValue;
  }, Object.defineProperties(e.prototype, n), e;
}(Cn), q2 = /* @__PURE__ */ function(t) {
  function e(n, r, s, i) {
    t.call(this, n, [], s, i), this.mark = r;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.create = function(r, s, i, o) {
    var a = o.nodeViews[s.type.name], l = a && a(s, o, i);
    return (!l || !l.dom) && (l = ms.renderSpec(document, s.type.spec.toDOM(s, i))), new e(r, s, l.dom, l.contentDOM || l.dom);
  }, e.prototype.parseRule = function() {
    return { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }, e.prototype.matchesMark = function(r) {
    return this.dirty != Zl && this.mark.eq(r);
  }, e.prototype.markDirty = function(r, s) {
    if (t.prototype.markDirty.call(this, r, s), this.dirty != Hi) {
      for (var i = this.parent; !i.node; )
        i = i.parent;
      i.dirty < this.dirty && (i.dirty = this.dirty), this.dirty = Hi;
    }
  }, e.prototype.slice = function(r, s, i) {
    var o = e.create(this.parent, this.mark, !0, i), a = this.children, l = this.size;
    s < l && (a = u1(a, s, l, i)), r > 0 && (a = u1(a, 0, r, i));
    for (var c = 0; c < a.length; c++)
      a[c].parent = o;
    return o.children = a, o;
  }, e;
}(Cn), Jf = /* @__PURE__ */ function(t) {
  function e(r, s, i, o, a, l, c, u, d) {
    t.call(this, r, s.isLeaf ? Ga : [], a, l), this.nodeDOM = c, this.node = s, this.outerDeco = i, this.innerDeco = o, l && this.updateChildren(u, d);
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { size: { configurable: !0 }, border: { configurable: !0 }, domAtom: { configurable: !0 } };
  return e.create = function(s, i, o, a, l, c) {
    var u, d = l.nodeViews[i.type.name], f, p = d && d(i, l, function() {
      if (!f)
        return c;
      if (f.parent)
        return f.parent.posBeforeChild(f);
    }, o, a), h = p && p.dom, m = p && p.contentDOM;
    if (i.isText) {
      if (!h)
        h = document.createTextNode(i.text);
      else if (h.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else h || (u = ms.renderSpec(document, i.type.spec.toDOM(i)), h = u.dom, m = u.contentDOM);
    !m && !i.isText && h.nodeName != "BR" && (h.hasAttribute("contenteditable") || (h.contentEditable = !1), i.type.spec.draggable && (h.draggable = !0));
    var v = h;
    return h = p9(h, o, i), p ? f = new cLe(
      s,
      i,
      o,
      a,
      h,
      m,
      v,
      p,
      l,
      c + 1
    ) : i.isText ? new u9(s, i, o, a, h, v, l) : new e(s, i, o, a, h, m, v, l, c + 1);
  }, e.prototype.parseRule = function() {
    var s = this;
    if (this.node.type.spec.reparseInView)
      return null;
    var i = { node: this.node.type.name, attrs: this.node.attrs };
    return this.node.type.spec.code && (i.preserveWhitespace = "full"), this.contentDOM && !this.contentLost ? i.contentElement = this.contentDOM : i.getContent = function() {
      return s.contentDOM ? xe.empty : s.node.content;
    }, i;
  }, e.prototype.matchesNode = function(s, i, o) {
    return this.dirty == Hi && s.eq(this.node) && c1(i, this.outerDeco) && o.eq(this.innerDeco);
  }, n.size.get = function() {
    return this.node.nodeSize;
  }, n.border.get = function() {
    return this.node.isLeaf ? 0 : 1;
  }, e.prototype.updateChildren = function(s, i) {
    var o = this, a = this.node.inlineContent, l = i, c = a && s.composing && this.localCompositionNode(s, i), u = new na(this, c && c.node);
    pLe(this.node, this.innerDeco, function(d, f, p) {
      d.spec.marks ? u.syncToMarks(d.spec.marks, a, s) : d.type.side >= 0 && !p && u.syncToMarks(f == o.node.childCount ? Xt.none : o.node.child(f).marks, a, s), u.placeWidget(d, s, l);
    }, function(d, f, p, h) {
      u.syncToMarks(d.marks, a, s), u.findNodeMatch(d, f, p, h) || // Or try updating the next desc to reflect this node.
      u.updateNextNode(d, f, p, s, h) || // Or just add it as a new desc.
      u.addNode(d, f, p, s, l), l += d.nodeSize;
    }), u.syncToMarks(Ga, a, s), this.node.isTextblock && u.addTextblockHacks(), u.destroyRest(), (u.changed || this.dirty == Xm) && (c && this.protectLocalComposition(s, c), d9(this.contentDOM, this.children, s), Fe.ios && hLe(this.dom));
  }, e.prototype.localCompositionNode = function(s, i) {
    var o = s.state.selection, a = o.from, l = o.to;
    if (!(!(s.state.selection instanceof Mt) || a < i || l > i + this.node.content.size)) {
      var c = s.root.getSelection(), u = mLe(c.focusNode, c.focusOffset);
      if (!(!u || !this.dom.contains(u.parentNode))) {
        var d = u.nodeValue, f = vLe(this.node.content, d, a - i, l - i);
        return f < 0 ? null : { node: u, pos: f, text: d };
      }
    }
  }, e.prototype.protectLocalComposition = function(s, i) {
    var o = i.node, a = i.pos, l = i.text;
    if (!this.getDesc(o)) {
      for (var c = o; c.parentNode != this.contentDOM; c = c.parentNode) {
        for (; c.previousSibling; )
          c.parentNode.removeChild(c.previousSibling);
        for (; c.nextSibling; )
          c.parentNode.removeChild(c.nextSibling);
        c.pmViewDesc && (c.pmViewDesc = null);
      }
      var u = new aLe(this, c, o, l);
      s.compositionNodes.push(u), this.children = u1(this.children, a, a + l.length, s, u);
    }
  }, e.prototype.update = function(s, i, o, a) {
    return this.dirty == Zl || !s.sameMarkup(this.node) ? !1 : (this.updateInner(s, i, o, a), !0);
  }, e.prototype.updateInner = function(s, i, o, a) {
    this.updateOuterDeco(i), this.node = s, this.innerDeco = o, this.contentDOM && this.updateChildren(a, this.posAtStart), this.dirty = Hi;
  }, e.prototype.updateOuterDeco = function(s) {
    if (!c1(s, this.outerDeco)) {
      var i = this.nodeDOM.nodeType != 1, o = this.dom;
      this.dom = f9(
        this.dom,
        this.nodeDOM,
        l1(this.outerDeco, this.node, i),
        l1(s, this.node, i)
      ), this.dom != o && (o.pmViewDesc = null, this.dom.pmViewDesc = this), this.outerDeco = s;
    }
  }, e.prototype.selectNode = function() {
    this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }, e.prototype.deselectNode = function() {
    this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable");
  }, n.domAtom.get = function() {
    return this.node.isAtom;
  }, Object.defineProperties(e.prototype, n), e;
}(Cn);
function c9(t, e, n, r, s) {
  return p9(r, e, t), new Jf(null, t, e, n, r, r, r, s, 0);
}
var u9 = /* @__PURE__ */ function(t) {
  function e(r, s, i, o, a, l, c) {
    t.call(this, r, s, i, o, a, null, l, c);
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { domAtom: { configurable: !0 } };
  return e.prototype.parseRule = function() {
    for (var s = this.nodeDOM.parentNode; s && s != this.dom && !s.pmIsDeco; )
      s = s.parentNode;
    return { skip: s || !0 };
  }, e.prototype.update = function(s, i, o, a) {
    return this.dirty == Zl || this.dirty != Hi && !this.inParent() || !s.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(i), (this.dirty != Hi || s.text != this.node.text) && s.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = s.text, a.trackWrites == this.nodeDOM && (a.trackWrites = null)), this.node = s, this.dirty = Hi, !0);
  }, e.prototype.inParent = function() {
    for (var s = this.parent.contentDOM, i = this.nodeDOM; i; i = i.parentNode)
      if (i == s)
        return !0;
    return !1;
  }, e.prototype.domFromPos = function(s) {
    return { node: this.nodeDOM, offset: s };
  }, e.prototype.localPosFromDOM = function(s, i, o) {
    return s == this.nodeDOM ? this.posAtStart + Math.min(i, this.node.text.length) : t.prototype.localPosFromDOM.call(this, s, i, o);
  }, e.prototype.ignoreMutation = function(s) {
    return s.type != "characterData" && s.type != "selection";
  }, e.prototype.slice = function(s, i, o) {
    var a = this.node.cut(s, i), l = document.createTextNode(a.text);
    return new e(this.parent, a, this.outerDeco, this.innerDeco, l, l, o);
  }, n.domAtom.get = function() {
    return !1;
  }, Object.defineProperties(e.prototype, n), e;
}(Jf), lLe = /* @__PURE__ */ function(t) {
  function e() {
    t.apply(this, arguments);
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { domAtom: { configurable: !0 } };
  return e.prototype.parseRule = function() {
    return { ignore: !0 };
  }, e.prototype.matchesHack = function() {
    return this.dirty == Hi;
  }, n.domAtom.get = function() {
    return !0;
  }, Object.defineProperties(e.prototype, n), e;
}(Cn), cLe = /* @__PURE__ */ function(t) {
  function e(n, r, s, i, o, a, l, c, u, d) {
    t.call(this, n, r, s, i, o, a, l, u, d), this.spec = c;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.update = function(r, s, i, o) {
    if (this.dirty == Zl)
      return !1;
    if (this.spec.update) {
      var a = this.spec.update(r, s, i);
      return a && this.updateInner(r, s, i, o), a;
    } else return !this.contentDOM && !r.isLeaf ? !1 : t.prototype.update.call(this, r, s, i, o);
  }, e.prototype.selectNode = function() {
    this.spec.selectNode ? this.spec.selectNode() : t.prototype.selectNode.call(this);
  }, e.prototype.deselectNode = function() {
    this.spec.deselectNode ? this.spec.deselectNode() : t.prototype.deselectNode.call(this);
  }, e.prototype.setSelection = function(r, s, i, o) {
    this.spec.setSelection ? this.spec.setSelection(r, s, i) : t.prototype.setSelection.call(this, r, s, i, o);
  }, e.prototype.destroy = function() {
    this.spec.destroy && this.spec.destroy(), t.prototype.destroy.call(this);
  }, e.prototype.stopEvent = function(r) {
    return this.spec.stopEvent ? this.spec.stopEvent(r) : !1;
  }, e.prototype.ignoreMutation = function(r) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(r) : t.prototype.ignoreMutation.call(this, r);
  }, e;
}(Jf);
function d9(t, e, n) {
  for (var r = t.firstChild, s = !1, i = 0; i < e.length; i++) {
    var o = e[i], a = o.dom;
    if (a.parentNode == t) {
      for (; a != r; )
        r = FN(r), s = !0;
      r = r.nextSibling;
    } else
      s = !0, t.insertBefore(a, r);
    if (o instanceof q2) {
      var l = r ? r.previousSibling : t.lastChild;
      d9(o.contentDOM, o.children, n), r = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = FN(r), s = !0;
  s && n.trackWrites == t && (n.trackWrites = null);
}
function Xd(t) {
  t && (this.nodeName = t);
}
Xd.prototype = /* @__PURE__ */ Object.create(null);
var Dl = [new Xd()];
function l1(t, e, n) {
  if (t.length == 0)
    return Dl;
  for (var r = n ? Dl[0] : new Xd(), s = [r], i = 0; i < t.length; i++) {
    var o = t[i].type.attrs;
    if (o) {
      o.nodeName && s.push(r = new Xd(o.nodeName));
      for (var a in o) {
        var l = o[a];
        l != null && (n && s.length == 1 && s.push(r = new Xd(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + l : a == "style" ? r.style = (r.style ? r.style + ";" : "") + l : a != "nodeName" && (r[a] = l));
      }
    }
  }
  return s;
}
function f9(t, e, n, r) {
  if (n == Dl && r == Dl)
    return e;
  for (var s = e, i = 0; i < r.length; i++) {
    var o = r[i], a = n[i];
    if (i) {
      var l = void 0;
      a && a.nodeName == o.nodeName && s != t && (l = s.parentNode) && l.tagName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(s), a = Dl[0]), s = l;
    }
    uLe(s, a || Dl[0], o);
  }
  return s;
}
function uLe(t, e, n) {
  for (var r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (var s in n)
    s != "class" && s != "style" && s != "nodeName" && n[s] != e[s] && t.setAttribute(s, n[s]);
  if (e.class != n.class) {
    for (var i = e.class ? e.class.split(" ").filter(Boolean) : Ga, o = n.class ? n.class.split(" ").filter(Boolean) : Ga, a = 0; a < i.length; a++)
      o.indexOf(i[a]) == -1 && t.classList.remove(i[a]);
    for (var l = 0; l < o.length; l++)
      i.indexOf(o[l]) == -1 && t.classList.add(o[l]);
  }
  if (e.style != n.style) {
    if (e.style)
      for (var c = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, u; u = c.exec(e.style); )
        t.style.removeProperty(u[1]);
    n.style && (t.style.cssText += n.style);
  }
}
function p9(t, e, n) {
  return f9(t, t, Dl, l1(e, n, t.nodeType != 1));
}
function c1(t, e) {
  if (t.length != e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function FN(t) {
  var e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
var na = function(e, n) {
  this.top = e, this.lock = n, this.index = 0, this.stack = [], this.changed = !1, this.preMatch = dLe(e.node.content, e.children);
};
na.prototype.destroyBetween = function(e, n) {
  if (e != n) {
    for (var r = e; r < n; r++)
      this.top.children[r].destroy();
    this.top.children.splice(e, n - e), this.changed = !0;
  }
};
na.prototype.destroyRest = function() {
  this.destroyBetween(this.index, this.top.children.length);
};
na.prototype.syncToMarks = function(e, n, r) {
  for (var s = 0, i = this.stack.length >> 1, o = Math.min(i, e.length); s < o && (s == i - 1 ? this.top : this.stack[s + 1 << 1]).matchesMark(e[s]) && e[s].type.spec.spanning !== !1; )
    s++;
  for (; s < i; )
    this.destroyRest(), this.top.dirty = Hi, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
  for (; i < e.length; ) {
    this.stack.push(this.top, this.index + 1);
    for (var a = -1, l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++)
      if (this.top.children[l].matchesMark(e[i])) {
        a = l;
        break;
      }
    if (a > -1)
      a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
    else {
      var c = q2.create(this.top, e[i], n, r);
      this.top.children.splice(this.index, 0, c), this.top = c, this.changed = !0;
    }
    this.index = 0, i++;
  }
};
na.prototype.findNodeMatch = function(e, n, r, s) {
  var i = this.top.children, o = -1;
  if (s >= this.preMatch.index) {
    for (var a = this.index; a < i.length; a++)
      if (i[a].matchesNode(e, n, r)) {
        o = a;
        break;
      }
  } else
    for (var l = this.index, c = Math.min(i.length, l + 1); l < c; l++) {
      var u = i[l];
      if (u.matchesNode(e, n, r) && !this.preMatch.matched.has(u)) {
        o = l;
        break;
      }
    }
  return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
};
na.prototype.updateNextNode = function(e, n, r, s, i) {
  for (var o = this.index; o < this.top.children.length; o++) {
    var a = this.top.children[o];
    if (a instanceof Jf) {
      var l = this.preMatch.matched.get(a);
      if (l != null && l != i)
        return !1;
      var c = a.dom, u = this.lock && (c == this.lock || c.nodeType == 1 && c.contains(this.lock.parentNode)) && !(e.isText && a.node && a.node.isText && a.nodeDOM.nodeValue == e.text && a.dirty != Zl && c1(n, a.outerDeco));
      if (!u && a.update(e, n, r, s))
        return this.destroyBetween(this.index, o), a.dom != c && (this.changed = !0), this.index++, !0;
      break;
    }
  }
  return !1;
};
na.prototype.addNode = function(e, n, r, s, i) {
  this.top.children.splice(this.index++, 0, Jf.create(this.top, e, n, r, s, i)), this.changed = !0;
};
na.prototype.placeWidget = function(e, n, r) {
  var s = this.index < this.top.children.length ? this.top.children[this.index] : null;
  if (s && s.matchesWidget(e) && (e == s.widget || !s.widget.type.toDOM.parentNode))
    this.index++;
  else {
    var i = new oLe(this.top, e, n, r);
    this.top.children.splice(this.index++, 0, i), this.changed = !0;
  }
};
na.prototype.addTextblockHacks = function() {
  for (var e = this.top.children[this.index - 1]; e instanceof q2; )
    e = e.children[e.children.length - 1];
  if (!e || // Empty textblock
  !(e instanceof u9) || /\n$/.test(e.node.text))
    if (this.index < this.top.children.length && this.top.children[this.index].matchesHack())
      this.index++;
    else {
      var n = document.createElement("br");
      this.top.children.splice(this.index++, 0, new lLe(this.top, Ga, n, null)), this.changed = !0;
    }
};
function dLe(t, e) {
  for (var n = t.childCount, r = e.length, s = /* @__PURE__ */ new Map(); n > 0 && r > 0; r--) {
    var i = e[r - 1], o = i.node;
    if (o) {
      if (o != t.child(n - 1))
        break;
      --n, s.set(i, n);
    }
  }
  return { index: n, matched: s };
}
function fLe(t, e) {
  return t.type.side - e.type.side;
}
function pLe(t, e, n, r) {
  var s = e.locals(t), i = 0;
  if (s.length == 0) {
    for (var o = 0; o < t.childCount; o++) {
      var a = t.child(o);
      r(a, s, e.forChild(i, a), o), i += a.nodeSize;
    }
    return;
  }
  for (var l = 0, c = [], u = null, d = 0; ; ) {
    if (l < s.length && s[l].to == i) {
      for (var f = s[l++], p = void 0; l < s.length && s[l].to == i; )
        (p || (p = [f])).push(s[l++]);
      if (p) {
        p.sort(fLe);
        for (var h = 0; h < p.length; h++)
          n(p[h], d, !!u);
      } else
        n(f, d, !!u);
    }
    var m = void 0, v = void 0;
    if (u)
      v = -1, m = u, u = null;
    else if (d < t.childCount)
      v = d, m = t.child(d++);
    else
      break;
    for (var y = 0; y < c.length; y++)
      c[y].to <= i && c.splice(y--, 1);
    for (; l < s.length && s[l].from <= i && s[l].to > i; )
      c.push(s[l++]);
    var _ = i + m.nodeSize;
    if (m.isText) {
      var w = _;
      l < s.length && s[l].from < w && (w = s[l].from);
      for (var S = 0; S < c.length; S++)
        c[S].to < w && (w = c[S].to);
      w < _ && (u = m.cut(w - i), m = m.cut(0, w - i), _ = w, v = -1);
    }
    var E = c.length ? m.isInline && !m.isLeaf ? c.filter(function(x) {
      return !x.inline;
    }) : c.slice() : Ga;
    r(m, E, e.forChild(i, m), v), i = _;
  }
}
function hLe(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    var e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function mLe(t, e) {
  for (; ; ) {
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.childNodes.length > e && t.childNodes[e].nodeType == 3)
        return t.childNodes[e];
      t = t.childNodes[e - 1], e = mo(t);
    } else if (t.nodeType == 1 && e < t.childNodes.length)
      t = t.childNodes[e], e = 0;
    else
      return null;
  }
}
function vLe(t, e, n, r) {
  for (var s = 0, i = 0; s < t.childCount && i <= r; ) {
    var o = t.child(s++), a = i;
    if (i += o.nodeSize, !!o.isText) {
      for (var l = o.text; s < t.childCount; ) {
        var c = t.child(s++);
        if (i += c.nodeSize, !c.isText)
          break;
        l += c.text;
      }
      if (i >= n) {
        var u = l.lastIndexOf(e, r - a);
        if (u >= 0 && u + e.length + a >= n)
          return a + u;
      }
    }
  }
  return -1;
}
function u1(t, e, n, r, s) {
  for (var i = [], o = 0, a = 0; o < t.length; o++) {
    var l = t[o], c = a, u = a += l.size;
    c >= n || u <= e ? i.push(l) : (c < e && i.push(l.slice(0, e - c, r)), s && (i.push(s), s = null), u > n && i.push(l.slice(n - c, l.size, r)));
  }
  return i;
}
function h9(t, e) {
  var n = t.root.getSelection(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  var s = t.docView.nearestDesc(n.focusNode), i = s && s.size == 0, o = t.docView.posFromDOM(n.focusNode, n.focusOffset);
  if (o < 0)
    return null;
  var a = r.resolve(o), l, c;
  if (K2(n)) {
    for (l = a; s && !s.node; )
      s = s.parent;
    if (s && s.node.isAtom && ct.isSelectable(s.node) && s.parent && !(s.node.isInline && VRe(n.focusNode, n.focusOffset, s.dom))) {
      var u = s.posBefore;
      c = new ct(o == u ? a : r.resolve(u));
    }
  } else {
    var d = t.docView.posFromDOM(n.anchorNode, n.anchorOffset);
    if (d < 0)
      return null;
    l = r.resolve(d);
  }
  if (!c) {
    var f = e == "pointer" || t.state.selection.head < a.pos && !i ? 1 : -1;
    c = Q2(t, l, a, f);
  }
  return c;
}
function m9(t) {
  return t.editable ? t.hasFocus() : eI(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function hc(t, e) {
  var n = t.state.selection;
  if (v9(t, n), !!m9(t)) {
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      yLe(t);
    else {
      var r = n.anchor, s = n.head, i, o;
      BN && !(n instanceof Mt) && (n.$from.parent.inlineContent || (i = jN(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (o = jN(t, n.to))), t.docView.setSelection(r, s, t.root, e), BN && (i && WN(i), o && WN(o)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && gLe(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
var BN = Fe.safari || Fe.chrome && Fe.chrome_version < 63;
function jN(t, e) {
  var n = t.docView.domFromPos(e, 0), r = n.node, s = n.offset, i = s < r.childNodes.length ? r.childNodes[s] : null, o = s ? r.childNodes[s - 1] : null;
  if (Fe.safari && i && i.contentEditable == "false")
    return ib(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return ib(i);
    if (o)
      return ib(o);
  }
}
function ib(t) {
  return t.contentEditable = "true", Fe.safari && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function WN(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function gLe(t) {
  var e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.hideSelectionGuard);
  var n = t.root.getSelection(), r = n.anchorNode, s = n.anchorOffset;
  e.addEventListener("selectionchange", t.hideSelectionGuard = function() {
    (n.anchorNode != r || n.anchorOffset != s) && (e.removeEventListener("selectionchange", t.hideSelectionGuard), setTimeout(function() {
      (!m9(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function yLe(t) {
  var e = t.root.getSelection(), n = document.createRange(), r = t.cursorWrapper.dom, s = r.nodeName == "IMG";
  s ? n.setEnd(r.parentNode, Ii(r) + 1) : n.setEnd(r, 0), n.collapse(!1), e.removeAllRanges(), e.addRange(n), !s && !t.state.selection.visible && Fe.ie && Fe.ie_version <= 11 && (r.disabled = !0, r.disabled = !1);
}
function v9(t, e) {
  if (e instanceof ct) {
    var n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (HN(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    HN(t);
}
function HN(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = null);
}
function Q2(t, e, n, r) {
  return t.someProp("createSelectionBetween", function(s) {
    return s(t, e, n);
  }) || Mt.between(e, n, r);
}
function bLe(t) {
  return t.editable && t.root.activeElement != t.dom ? !1 : eI(t);
}
function eI(t) {
  var e = t.root.getSelection();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function _Le(t) {
  var e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.root.getSelection();
  return Zm(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function d1(t, e) {
  var n = t.selection, r = n.$anchor, s = n.$head, i = e > 0 ? r.max(s) : r.min(s), o = i.parent.inlineContent ? i.depth ? t.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return o && yt.findFrom(o, e);
}
function kl(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function VN(t, e, n) {
  var r = t.state.selection;
  if (r instanceof Mt) {
    if (!r.empty || n.indexOf("s") > -1)
      return !1;
    if (t.endOfTextblock(e > 0 ? "right" : "left")) {
      var s = d1(t.state, e);
      return s && s instanceof ct ? kl(t, s) : !1;
    } else if (!(Fe.mac && n.indexOf("m") > -1)) {
      var i = r.$head, o = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, a;
      if (!o || o.isText)
        return !1;
      var l = e < 0 ? i.pos - o.nodeSize : i.pos;
      return o.isAtom || (a = t.docView.descAt(l)) && !a.contentDOM ? ct.isSelectable(o) ? kl(t, new ct(e < 0 ? t.state.doc.resolve(i.pos - o.nodeSize) : i)) : Fe.webkit ? kl(t, new Mt(t.state.doc.resolve(e < 0 ? l : l + o.nodeSize))) : !1 : !1;
    }
  } else {
    if (r instanceof ct && r.node.isInline)
      return kl(t, new Mt(e > 0 ? r.$to : r.$from));
    var c = d1(t.state, e);
    return c ? kl(t, c) : !1;
  }
}
function Km(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Kd(t) {
  var e = t.pmViewDesc;
  return e && e.size == 0 && (t.nextSibling || t.nodeName != "BR");
}
function ob(t) {
  var e = t.root.getSelection(), n = e.focusNode, r = e.focusOffset;
  if (n) {
    var s, i, o = !1;
    for (Fe.gecko && n.nodeType == 1 && r < Km(n) && Kd(n.childNodes[r]) && (o = !0); ; )
      if (r > 0) {
        if (n.nodeType != 1)
          break;
        var a = n.childNodes[r - 1];
        if (Kd(a))
          s = n, i = --r;
        else if (a.nodeType == 3)
          n = a, r = n.nodeValue.length;
        else
          break;
      } else {
        if (g9(n))
          break;
        for (var l = n.previousSibling; l && Kd(l); )
          s = n.parentNode, i = Ii(l), l = l.previousSibling;
        if (l)
          n = l, r = Km(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    o ? f1(t, e, n, r) : s && f1(t, e, s, i);
  }
}
function ab(t) {
  var e = t.root.getSelection(), n = e.focusNode, r = e.focusOffset;
  if (n) {
    for (var s = Km(n), i, o; ; )
      if (r < s) {
        if (n.nodeType != 1)
          break;
        var a = n.childNodes[r];
        if (Kd(a))
          i = n, o = ++r;
        else
          break;
      } else {
        if (g9(n))
          break;
        for (var l = n.nextSibling; l && Kd(l); )
          i = l.parentNode, o = Ii(l) + 1, l = l.nextSibling;
        if (l)
          n = l, r = 0, s = Km(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = s = 0;
        }
      }
    i && f1(t, e, i, o);
  }
}
function g9(t) {
  var e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function f1(t, e, n, r) {
  if (K2(e)) {
    var s = document.createRange();
    s.setEnd(n, r), s.setStart(n, r), e.removeAllRanges(), e.addRange(s);
  } else e.extend && e.extend(n, r);
  t.domObserver.setCurSelection();
  var i = t.state;
  setTimeout(function() {
    t.state == i && hc(t);
  }, 50);
}
function zN(t, e, n) {
  var r = t.state.selection;
  if (r instanceof Mt && !r.empty || n.indexOf("s") > -1 || Fe.mac && n.indexOf("m") > -1)
    return !1;
  var s = r.$from, i = r.$to;
  if (!s.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    var o = d1(t.state, e);
    if (o && o instanceof ct)
      return kl(t, o);
  }
  if (!s.parent.inlineContent) {
    var a = e < 0 ? s : i, l = r instanceof Co ? yt.near(a, e) : yt.findFrom(a, e);
    return l ? kl(t, l) : !1;
  }
  return !1;
}
function UN(t, e) {
  if (!(t.state.selection instanceof Mt))
    return !0;
  var n = t.state.selection, r = n.$head, s = n.$anchor, i = n.empty;
  if (!r.sameParent(s))
    return !0;
  if (!i)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  var o = !r.textOffset && (e < 0 ? r.nodeBefore : r.nodeAfter);
  if (o && !o.isText) {
    var a = t.state.tr;
    return e < 0 ? a.delete(r.pos - o.nodeSize, r.pos) : a.delete(r.pos, r.pos + o.nodeSize), t.dispatch(a), !0;
  }
  return !1;
}
function GN(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function wLe(t) {
  if (!(!Fe.safari || t.state.selection.$head.parentOffset > 0)) {
    var e = t.root.getSelection(), n = e.focusNode, r = e.focusOffset;
    if (n && n.nodeType == 1 && r == 0 && n.firstChild && n.firstChild.contentEditable == "false") {
      var s = n.firstChild;
      GN(t, s, !0), setTimeout(function() {
        return GN(t, s, !1);
      }, 20);
    }
  }
}
function SLe(t) {
  var e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function ILe(t, e) {
  var n = e.keyCode, r = SLe(e);
  return n == 8 || Fe.mac && n == 72 && r == "c" ? UN(t, -1) || ob(t) : n == 46 || Fe.mac && n == 68 && r == "c" ? UN(t, 1) || ab(t) : n == 13 || n == 27 ? !0 : n == 37 ? VN(t, -1, r) || ob(t) : n == 39 ? VN(t, 1, r) || ab(t) : n == 38 ? zN(t, -1, r) || ob(t) : n == 40 ? wLe(t) || zN(t, 1, r) || ab(t) : r == (Fe.mac ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90);
}
function ELe(t, e, n) {
  var r = t.docView.parseRange(e, n), s = r.node, i = r.fromOffset, o = r.toOffset, a = r.from, l = r.to, c = t.root.getSelection(), u = null, d = c.anchorNode;
  if (d && t.dom.contains(d.nodeType == 1 ? d : d.parentNode) && (u = [{ node: d, offset: c.anchorOffset }], K2(c) || u.push({ node: c.focusNode, offset: c.focusOffset })), Fe.chrome && t.lastKeyCode === 8)
    for (var f = o; f > i; f--) {
      var p = s.childNodes[f - 1], h = p.pmViewDesc;
      if (p.nodeType == "BR" && !h) {
        o = f;
        break;
      }
      if (!h || h.size)
        break;
    }
  var m = t.state.doc, v = t.someProp("domParser") || Wi.fromSchema(t.state.schema), y = m.resolve(a), _ = null, w = v.parse(s, {
    topNode: y.parent,
    topMatch: y.parent.contentMatchAt(y.index()),
    topOpen: !0,
    from: i,
    to: o,
    preserveWhitespace: y.parent.type.spec.code ? "full" : !0,
    editableContent: !0,
    findPositions: u,
    ruleFromNode: xLe,
    context: y
  });
  if (u && u[0].pos != null) {
    var S = u[0].pos, E = u[1] && u[1].pos;
    E == null && (E = S), _ = { anchor: S + a, head: E + a };
  }
  return { doc: w, sel: _, from: a, to: l };
}
function xLe(t) {
  var e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (Fe.safari && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      var n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || Fe.safari && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
}
function CLe(t, e, n, r, s) {
  if (e < 0) {
    var i = t.lastSelectionTime > Date.now() - 50 ? t.lastSelectionOrigin : null, o = h9(t, i);
    if (o && !t.state.selection.eq(o)) {
      var a = t.state.tr.setSelection(o);
      i == "pointer" ? a.setMeta("pointer", !0) : i == "key" && a.scrollIntoView(), t.dispatch(a);
    }
    return;
  }
  var l = t.state.doc.resolve(e), c = l.sharedDepth(n);
  e = l.before(c + 1), n = t.state.doc.resolve(n).after(c + 1);
  var u = t.state.selection, d = ELe(t, e, n);
  if (Fe.chrome && t.cursorWrapper && d.sel && d.sel.anchor == t.cursorWrapper.deco.from) {
    var f = t.cursorWrapper.deco.type.toDOM.nextSibling, p = f && f.nodeValue ? f.nodeValue.length : 1;
    d.sel = { anchor: d.sel.anchor + p, head: d.sel.anchor + p };
  }
  var h = t.state.doc, m = h.slice(d.from, d.to), v, y;
  t.lastKeyCode === 8 && Date.now() - 100 < t.lastKeyCodeTime ? (v = t.state.selection.to, y = "end") : (v = t.state.selection.from, y = "start"), t.lastKeyCode = null;
  var _ = kLe(m.content, d.doc.content, d.from, v, y);
  if (!_)
    if (r && u instanceof Mt && !u.empty && u.$head.sameParent(u.$anchor) && !t.composing && !(d.sel && d.sel.anchor != d.sel.head))
      _ = { start: u.from, endA: u.to, endB: u.to };
    else if ((Fe.ios && t.lastIOSEnter > Date.now() - 225 || Fe.android) && s.some(function(te) {
      return te.nodeName == "DIV" || te.nodeName == "P";
    }) && t.someProp("handleKeyDown", function(te) {
      return te(t, Vc(13, "Enter"));
    })) {
      t.lastIOSEnter = 0;
      return;
    } else {
      if (d.sel) {
        var w = YN(t, t.state.doc, d.sel);
        w && !w.eq(t.state.selection) && t.dispatch(t.state.tr.setSelection(w));
      }
      return;
    }
  t.domChangeCount++, t.state.selection.from < t.state.selection.to && _.start == _.endB && t.state.selection instanceof Mt && (_.start > t.state.selection.from && _.start <= t.state.selection.from + 2 ? _.start = t.state.selection.from : _.endA < t.state.selection.to && _.endA >= t.state.selection.to - 2 && (_.endB += t.state.selection.to - _.endA, _.endA = t.state.selection.to)), Fe.ie && Fe.ie_version <= 11 && _.endB == _.start + 1 && _.endA == _.start && _.start > d.from && d.doc.textBetween(_.start - d.from - 1, _.start - d.from + 1) == "  " && (_.start--, _.endA--, _.endB--);
  var S = d.doc.resolveNoCache(_.start - d.from), E = d.doc.resolveNoCache(_.endB - d.from), x = S.sameParent(E) && S.parent.inlineContent, T;
  if ((Fe.ios && t.lastIOSEnter > Date.now() - 225 && (!x || s.some(function(te) {
    return te.nodeName == "DIV" || te.nodeName == "P";
  })) || !x && S.pos < d.doc.content.size && (T = yt.findFrom(d.doc.resolve(S.pos + 1), 1, !0)) && T.head == E.pos) && t.someProp("handleKeyDown", function(te) {
    return te(t, Vc(13, "Enter"));
  })) {
    t.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > _.start && PLe(h, _.start, _.endA, S, E) && t.someProp("handleKeyDown", function(te) {
    return te(t, Vc(8, "Backspace"));
  })) {
    Fe.android && Fe.chrome && t.domObserver.suppressSelectionUpdates();
    return;
  }
  Fe.chrome && Fe.android && _.toB == _.from && (t.lastAndroidDelete = Date.now()), Fe.android && !x && S.start() != E.start() && E.parentOffset == 0 && S.depth == E.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == _.endA && (_.endB -= 2, E = d.doc.resolveNoCache(_.endB - d.from), setTimeout(function() {
    t.someProp("handleKeyDown", function(te) {
      return te(t, Vc(13, "Enter"));
    });
  }, 20));
  var C = _.start, k = _.endA, b, P, N, D;
  if (x) {
    if (S.pos == E.pos)
      Fe.ie && Fe.ie_version <= 11 && S.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(function() {
        return hc(t);
      }, 20)), b = t.state.tr.delete(C, k), P = h.resolve(_.start).marksAcross(h.resolve(_.endA));
    else if (
      // Adding or removing a mark
      _.endA == _.endB && (D = h.resolve(_.start)) && (N = TLe(
        S.parent.content.cut(S.parentOffset, E.parentOffset),
        D.parent.content.cut(D.parentOffset, _.endA - D.start())
      ))
    )
      b = t.state.tr, N.type == "add" ? b.addMark(C, k, N.mark) : b.removeMark(C, k, N.mark);
    else if (S.parent.child(S.index()).isText && S.index() == E.index() - (E.textOffset ? 0 : 1)) {
      var H = S.parent.textBetween(S.parentOffset, E.parentOffset);
      if (t.someProp("handleTextInput", function(te) {
        return te(t, C, k, H);
      }))
        return;
      b = t.state.tr.insertText(H, C, k);
    }
  }
  if (b || (b = t.state.tr.replace(C, k, d.doc.slice(_.start - d.from, _.endB - d.from))), d.sel) {
    var Y = YN(t, b.doc, d.sel);
    Y && !(Fe.chrome && Fe.android && t.composing && Y.empty && (_.from != _.toB || t.lastAndroidDelete < Date.now() - 100) && (Y.head == C || Y.head == b.mapping.map(k) - 1) || Fe.ie && Y.empty && Y.head == C) && b.setSelection(Y);
  }
  P && b.ensureMarks(P), t.dispatch(b.scrollIntoView());
}
function YN(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : Q2(t, e.resolve(n.anchor), e.resolve(n.head));
}
function TLe(t, e) {
  for (var n = t.firstChild.marks, r = e.firstChild.marks, s = n, i = r, o, a, l, c = 0; c < r.length; c++)
    s = r[c].removeFromSet(s);
  for (var u = 0; u < n.length; u++)
    i = n[u].removeFromSet(i);
  if (s.length == 1 && i.length == 0)
    a = s[0], o = "add", l = function(p) {
      return p.mark(a.addToSet(p.marks));
    };
  else if (s.length == 0 && i.length == 1)
    a = i[0], o = "remove", l = function(p) {
      return p.mark(a.removeFromSet(p.marks));
    };
  else
    return null;
  for (var d = [], f = 0; f < e.childCount; f++)
    d.push(l(e.child(f)));
  if (xe.from(d).eq(t))
    return { mark: a, type: o };
}
function PLe(t, e, n, r, s) {
  if (!r.parent.isTextblock || // The content must have shrunk
  n - e <= s.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
  lb(r, !0, !1) < s.pos)
    return !1;
  var i = t.resolve(e);
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  var o = t.resolve(lb(i, !0, !0));
  return !o.parent.isTextblock || o.pos > n || lb(o, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function lb(t, e, n) {
  for (var r = t.depth, s = e ? t.end() : t.pos; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, s++, e = !1;
  if (n)
    for (var i = t.node(r).maybeChild(t.indexAfter(r)); i && !i.isLeaf; )
      i = i.firstChild, s++;
  return s;
}
function kLe(t, e, n, r, s) {
  var i = t.findDiffStart(e, n);
  if (i == null)
    return null;
  var o = t.findDiffEnd(e, n + t.size, n + e.size), a = o.a, l = o.b;
  if (s == "end") {
    var c = Math.max(0, i - Math.min(a, l));
    r -= a + c - i;
  }
  if (a < i && t.size < e.size) {
    var u = r <= i && r >= a ? i - r : 0;
    i -= u, l = i + (l - a), a = i;
  } else if (l < i) {
    var d = r <= i && r >= l ? i - r : 0;
    i -= d, a = i + (a - l), l = i;
  }
  return { start: i, endA: a, endB: l };
}
function y9(t, e) {
  for (var n = [], r = e.content, s = e.openStart, i = e.openEnd; s > 1 && i > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    s--, i--;
    var o = r.firstChild;
    n.push(o.type.name, o.attrs != o.type.defaultAttrs ? o.attrs : null), r = o.content;
  }
  var a = t.someProp("clipboardSerializer") || ms.fromSchema(t.state.schema), l = E9(), c = l.createElement("div");
  c.appendChild(a.serializeFragment(r, { document: l }));
  for (var u = c.firstChild, d; u && u.nodeType == 1 && (d = I9[u.nodeName.toLowerCase()]); ) {
    for (var f = d.length - 1; f >= 0; f--) {
      for (var p = l.createElement(d[f]); c.firstChild; )
        p.appendChild(c.firstChild);
      c.appendChild(p);
    }
    u = c.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", s + " " + i + " " + JSON.stringify(n));
  var h = t.someProp("clipboardTextSerializer", function(m) {
    return m(e);
  }) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: c, text: h };
}
function b9(t, e, n, r, s) {
  var i, o = s.parent.type.spec.code, a;
  if (!n && !e)
    return null;
  var l = e && (r || o || !n);
  if (l) {
    if (t.someProp("transformPastedText", function(p) {
      e = p(e, o || r);
    }), o)
      return new He(xe.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0);
    var c = t.someProp("clipboardTextParser", function(p) {
      return p(e, s, r);
    });
    c ? a = c : (i = document.createElement("div"), e.trim().split(/(?:\r\n?|\n)+/).forEach(function(p) {
      i.appendChild(document.createElement("p")).textContent = p;
    }));
  } else
    t.someProp("transformPastedHTML", function(p) {
      n = p(n);
    }), i = DLe(n);
  var u = i && i.querySelector("[data-pm-slice]"), d = u && /^(\d+) (\d+) (.*)/.exec(u.getAttribute("data-pm-slice"));
  if (!a) {
    var f = t.someProp("clipboardParser") || t.someProp("domParser") || Wi.fromSchema(t.state.schema);
    a = f.parseSlice(i, { preserveWhitespace: !!(l || d), context: s });
  }
  return d ? a = ALe($Le(a, +d[1], +d[2]), d[3]) : a = He.maxOpen(NLe(a.content, s), !1), t.someProp("transformPasted", function(p) {
    a = p(a);
  }), a;
}
function NLe(t, e) {
  if (t.childCount < 2)
    return t;
  for (var n = function(i) {
    var o = e.node(i), a = o.contentMatchAt(e.index(i)), l = void 0, c = [];
    if (t.forEach(function(u) {
      if (c) {
        var d = a.findWrapping(u.type), f;
        if (!d)
          return c = null;
        if (f = c.length && l.length && w9(d, l, u, c[c.length - 1], 0))
          c[c.length - 1] = f;
        else {
          c.length && (c[c.length - 1] = S9(c[c.length - 1], l.length));
          var p = _9(u, d);
          c.push(p), a = a.matchType(p.type, p.attrs), l = d;
        }
      }
    }), c)
      return { v: xe.from(c) };
  }, r = e.depth; r >= 0; r--) {
    var s = n(r);
    if (s) return s.v;
  }
  return t;
}
function _9(t, e, n) {
  n === void 0 && (n = 0);
  for (var r = e.length - 1; r >= n; r--)
    t = e[r].create(null, xe.from(t));
  return t;
}
function w9(t, e, n, r, s) {
  if (s < t.length && s < e.length && t[s] == e[s]) {
    var i = w9(t, e, n, r.lastChild, s + 1);
    if (i)
      return r.copy(r.content.replaceChild(r.childCount - 1, i));
    var o = r.contentMatchAt(r.childCount);
    if (o.matchType(s == t.length - 1 ? n.type : t[s + 1]))
      return r.copy(r.content.append(xe.from(_9(n, t, s + 1))));
  }
}
function S9(t, e) {
  if (e == 0)
    return t;
  var n = t.content.replaceChild(t.childCount - 1, S9(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(xe.empty, !0);
  return t.copy(n.append(r));
}
function p1(t, e, n, r, s, i) {
  var o = e < 0 ? t.firstChild : t.lastChild, a = o.content;
  return s < r - 1 && (a = p1(a, e, n, r, s + 1, i)), s >= n && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, t.childCount > 1 || i <= s).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore(xe.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, o.copy(a));
}
function $Le(t, e, n) {
  return e < t.openStart && (t = new He(p1(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new He(p1(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
var I9 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
}, ZN = null;
function E9() {
  return ZN || (ZN = document.implementation.createHTMLDocument("title"));
}
function DLe(t) {
  var e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  var n = E9().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), s;
  if ((s = r && I9[r[1].toLowerCase()]) && (t = s.map(function(o) {
    return "<" + o + ">";
  }).join("") + t + s.map(function(o) {
    return "</" + o + ">";
  }).reverse().join("")), n.innerHTML = t, s)
    for (var i = 0; i < s.length; i++)
      n = n.querySelector(s[i]) || n;
  return n;
}
function ALe(t, e) {
  if (!t.size)
    return t;
  var n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  for (var s = t.content, i = t.openStart, o = t.openEnd, a = r.length - 2; a >= 0; a -= 2) {
    var l = n.nodes[r[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    s = xe.from(l.create(r[a + 1], s)), i++, o++;
  }
  return new He(s, i, o);
}
var OLe = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, tI = Fe.ie && Fe.ie_version <= 11, nI = function() {
  this.anchorNode = this.anchorOffset = this.focusNode = this.focusOffset = null;
};
nI.prototype.set = function(e) {
  this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
};
nI.prototype.eq = function(e) {
  return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
};
var ui = function(e, n) {
  var r = this;
  this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = window.MutationObserver && new window.MutationObserver(function(s) {
    for (var i = 0; i < s.length; i++)
      r.queue.push(s[i]);
    Fe.ie && Fe.ie_version <= 11 && s.some(
      function(o) {
        return o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length;
      }
    ) ? r.flushSoon() : r.flush();
  }), this.currentSelection = new nI(), tI && (this.onCharData = function(s) {
    r.queue.push({ target: s.target, type: "characterData", oldValue: s.prevValue }), r.flushSoon();
  }), this.onSelectionChange = this.onSelectionChange.bind(this), this.suppressingSelectionUpdates = !1;
};
ui.prototype.flushSoon = function() {
  var e = this;
  this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(function() {
    e.flushingSoon = -1, e.flush();
  }, 20));
};
ui.prototype.forceFlush = function() {
  this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
};
ui.prototype.start = function() {
  this.observer && this.observer.observe(this.view.dom, OLe), tI && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
};
ui.prototype.stop = function() {
  var e = this;
  if (this.observer) {
    var n = this.observer.takeRecords();
    if (n.length) {
      for (var r = 0; r < n.length; r++)
        this.queue.push(n[r]);
      window.setTimeout(function() {
        return e.flush();
      }, 20);
    }
    this.observer.disconnect();
  }
  tI && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
};
ui.prototype.connectSelection = function() {
  this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
};
ui.prototype.disconnectSelection = function() {
  this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
};
ui.prototype.suppressSelectionUpdates = function() {
  var e = this;
  this.suppressingSelectionUpdates = !0, setTimeout(function() {
    return e.suppressingSelectionUpdates = !1;
  }, 50);
};
ui.prototype.onSelectionChange = function() {
  if (bLe(this.view)) {
    if (this.suppressingSelectionUpdates)
      return hc(this.view);
    if (Fe.ie && Fe.ie_version <= 11 && !this.view.state.selection.empty) {
      var e = this.view.root.getSelection();
      if (e.focusNode && Zm(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
        return this.flushSoon();
    }
    this.flush();
  }
};
ui.prototype.setCurSelection = function() {
  this.currentSelection.set(this.view.root.getSelection());
};
ui.prototype.ignoreSelectionChange = function(e) {
  if (e.rangeCount == 0)
    return !0;
  var n = e.getRangeAt(0).commonAncestorContainer, r = this.view.docView.nearestDesc(n);
  if (r && r.ignoreMutation({ type: "selection", target: n.nodeType == 3 ? n.parentNode : n }))
    return this.setCurSelection(), !0;
};
ui.prototype.flush = function() {
  if (!(!this.view.docView || this.flushingSoon > -1)) {
    var e = this.observer ? this.observer.takeRecords() : [];
    this.queue.length && (e = this.queue.concat(e), this.queue.length = 0);
    var n = this.view.root.getSelection(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && eI(this.view) && !this.ignoreSelectionChange(n), s = -1, i = -1, o = !1, a = [];
    if (this.view.editable)
      for (var l = 0; l < e.length; l++) {
        var c = this.registerMutation(e[l], a);
        c && (s = s < 0 ? c.from : Math.min(c.from, s), i = i < 0 ? c.to : Math.max(c.to, i), c.typeOver && (o = !0));
      }
    if (Fe.gecko && a.length > 1) {
      var u = a.filter(function(p) {
        return p.nodeName == "BR";
      });
      if (u.length == 2) {
        var d = u[0], f = u[1];
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      }
    }
    (s > -1 || r) && (s > -1 && (this.view.docView.markDirty(s, i), MLe(this.view)), this.handleDOMChange(s, i, o, a), this.view.docView.dirty ? this.view.updateState(this.view.state) : this.currentSelection.eq(n) || hc(this.view), this.currentSelection.set(n));
  }
};
ui.prototype.registerMutation = function(e, n) {
  if (n.indexOf(e.target) > -1)
    return null;
  var r = this.view.docView.nearestDesc(e.target);
  if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
  e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
    return null;
  if (e.type == "childList") {
    for (var s = 0; s < e.addedNodes.length; s++)
      n.push(e.addedNodes[s]);
    if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
      return { from: r.posBefore, to: r.posAfter };
    var i = e.previousSibling, o = e.nextSibling;
    if (Fe.ie && Fe.ie_version <= 11 && e.addedNodes.length)
      for (var a = 0; a < e.addedNodes.length; a++) {
        var l = e.addedNodes[a], c = l.previousSibling, u = l.nextSibling;
        (!c || Array.prototype.indexOf.call(e.addedNodes, c) < 0) && (i = c), (!u || Array.prototype.indexOf.call(e.addedNodes, u) < 0) && (o = u);
      }
    var d = i && i.parentNode == e.target ? Ii(i) + 1 : 0, f = r.localPosFromDOM(e.target, d, -1), p = o && o.parentNode == e.target ? Ii(o) : e.target.childNodes.length, h = r.localPosFromDOM(e.target, p, 1);
    return { from: f, to: h };
  } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : {
    from: r.posAtStart,
    to: r.posAtEnd,
    // An event was generated for a text change that didn't change
    // any text. Mark the dom change to fall back to assuming the
    // selection was typed over with an identical value if it can't
    // find another change.
    typeOver: e.target.nodeValue == e.oldValue
  };
};
var XN = !1;
function MLe(t) {
  XN || (XN = !0, getComputedStyle(t.dom).whiteSpace == "normal" && console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."));
}
var Vs = {}, $s = {};
function RLe(t) {
  t.shiftKey = !1, t.mouseDown = null, t.lastKeyCode = null, t.lastKeyCodeTime = 0, t.lastClick = { time: 0, x: 0, y: 0, type: "" }, t.lastSelectionOrigin = null, t.lastSelectionTime = 0, t.lastIOSEnter = 0, t.lastIOSEnterFallbackTimeout = null, t.lastAndroidDelete = 0, t.composing = !1, t.composingTimeout = null, t.compositionNodes = [], t.compositionEndedAt = -2e8, t.domObserver = new ui(t, function(r, s, i, o) {
    return CLe(t, r, s, i, o);
  }), t.domObserver.start(), t.domChangeCount = 0, t.eventHandlers = /* @__PURE__ */ Object.create(null);
  var e = function(r) {
    var s = Vs[r];
    t.dom.addEventListener(r, t.eventHandlers[r] = function(i) {
      FLe(t, i) && !sI(t, i) && (t.editable || !(i.type in $s)) && s(t, i);
    });
  };
  for (var n in Vs) e(n);
  Fe.safari && t.dom.addEventListener("input", function() {
    return null;
  }), rI(t);
}
function Xl(t, e) {
  t.lastSelectionOrigin = e, t.lastSelectionTime = Date.now();
}
function LLe(t) {
  t.domObserver.stop();
  for (var e in t.eventHandlers)
    t.dom.removeEventListener(e, t.eventHandlers[e]);
  clearTimeout(t.composingTimeout), clearTimeout(t.lastIOSEnterFallbackTimeout);
}
function rI(t) {
  t.someProp("handleDOMEvents", function(e) {
    for (var n in e)
      t.eventHandlers[n] || t.dom.addEventListener(n, t.eventHandlers[n] = function(r) {
        return sI(t, r);
      });
  });
}
function sI(t, e) {
  return t.someProp("handleDOMEvents", function(n) {
    var r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function FLe(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (var n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function BLe(t, e) {
  !sI(t, e) && Vs[e.type] && (t.editable || !(e.type in $s)) && Vs[e.type](t, e);
}
$s.keydown = function(t, e) {
  if (t.shiftKey = e.keyCode == 16 || e.shiftKey, !C9(t, e))
    if (t.domObserver.forceFlush(), t.lastKeyCode = e.keyCode, t.lastKeyCodeTime = Date.now(), Fe.ios && e.keyCode == 13 && !e.ctrlKey && !e.altKey && !e.metaKey) {
      var n = Date.now();
      t.lastIOSEnter = n, t.lastIOSEnterFallbackTimeout = setTimeout(function() {
        t.lastIOSEnter == n && (t.someProp("handleKeyDown", function(r) {
          return r(t, Vc(13, "Enter"));
        }), t.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", function(r) {
      return r(t, e);
    }) || ILe(t, e) ? e.preventDefault() : Xl(t, "key");
};
$s.keyup = function(t, e) {
  e.keyCode == 16 && (t.shiftKey = !1);
};
$s.keypress = function(t, e) {
  if (!(C9(t, e) || !e.charCode || e.ctrlKey && !e.altKey || Fe.mac && e.metaKey)) {
    if (t.someProp("handleKeyPress", function(s) {
      return s(t, e);
    })) {
      e.preventDefault();
      return;
    }
    var n = t.state.selection;
    if (!(n instanceof Mt) || !n.$from.sameParent(n.$to)) {
      var r = String.fromCharCode(e.charCode);
      t.someProp("handleTextInput", function(s) {
        return s(t, n.$from.pos, n.$to.pos, r);
      }) || t.dispatch(t.state.tr.insertText(r).scrollIntoView()), e.preventDefault();
    }
  }
};
function og(t) {
  return { left: t.clientX, top: t.clientY };
}
function jLe(t, e) {
  var n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function iI(t, e, n, r, s) {
  if (r == -1)
    return !1;
  for (var i = t.state.doc.resolve(r), o = function(c) {
    if (t.someProp(e, function(u) {
      return c > i.depth ? u(t, n, i.nodeAfter, i.before(c), s, !0) : u(t, n, i.node(c), i.before(c), s, !1);
    }))
      return { v: !0 };
  }, a = i.depth + 1; a > 0; a--) {
    var l = o(a);
    if (l) return l.v;
  }
  return !1;
}
function Jc(t, e, n) {
  t.focused || t.focus();
  var r = t.state.tr.setSelection(e);
  r.setMeta("pointer", !0), t.dispatch(r);
}
function WLe(t, e) {
  if (e == -1)
    return !1;
  var n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && ct.isSelectable(r) ? (Jc(t, new ct(n)), !0) : !1;
}
function HLe(t, e) {
  if (e == -1)
    return !1;
  var n = t.state.selection, r, s;
  n instanceof ct && (r = n.node);
  for (var i = t.state.doc.resolve(e), o = i.depth + 1; o > 0; o--) {
    var a = o > i.depth ? i.nodeAfter : i.node(o);
    if (ct.isSelectable(a)) {
      r && n.$from.depth > 0 && o >= n.$from.depth && i.before(n.$from.depth + 1) == n.$from.pos ? s = i.before(n.$from.depth) : s = i.before(o);
      break;
    }
  }
  return s != null ? (Jc(t, ct.create(t.state.doc, s)), !0) : !1;
}
function VLe(t, e, n, r, s) {
  return iI(t, "handleClickOn", e, n, r) || t.someProp("handleClick", function(i) {
    return i(t, e, r);
  }) || (s ? HLe(t, n) : WLe(t, n));
}
function zLe(t, e, n, r) {
  return iI(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", function(s) {
    return s(t, e, r);
  });
}
function ULe(t, e, n, r) {
  return iI(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", function(s) {
    return s(t, e, r);
  }) || GLe(t, n);
}
function GLe(t, e) {
  var n = t.state.doc;
  if (e == -1)
    return n.inlineContent ? (Jc(t, Mt.create(n, 0, n.content.size)), !0) : !1;
  for (var r = n.resolve(e), s = r.depth + 1; s > 0; s--) {
    var i = s > r.depth ? r.nodeAfter : r.node(s), o = r.before(s);
    if (i.inlineContent)
      Jc(t, Mt.create(n, o + 1, o + 1 + i.content.size));
    else if (ct.isSelectable(i))
      Jc(t, ct.create(n, o));
    else
      continue;
    return !0;
  }
}
function oI(t) {
  return Jm(t);
}
var x9 = Fe.mac ? "metaKey" : "ctrlKey";
Vs.mousedown = function(t, e) {
  t.shiftKey = e.shiftKey;
  var n = oI(t), r = Date.now(), s = "singleClick";
  r - t.lastClick.time < 500 && jLe(e, t.lastClick) && !e[x9] && (t.lastClick.type == "singleClick" ? s = "doubleClick" : t.lastClick.type == "doubleClick" && (s = "tripleClick")), t.lastClick = { time: r, x: e.clientX, y: e.clientY, type: s };
  var i = t.posAtCoords(og(e));
  i && (s == "singleClick" ? t.mouseDown = new ag(t, i, e, n) : (s == "doubleClick" ? zLe : ULe)(t, i.pos, i.inside, e) ? e.preventDefault() : Xl(t, "pointer"));
};
var ag = function(e, n, r, s) {
  var i = this;
  this.view = e, this.startDoc = e.state.doc, this.pos = n, this.event = r, this.flushed = s, this.selectNode = r[x9], this.allowDefault = r.shiftKey;
  var o, a;
  if (n.inside > -1)
    o = e.state.doc.nodeAt(n.inside), a = n.inside;
  else {
    var l = e.state.doc.resolve(n.pos);
    o = l.parent, a = l.depth ? l.before() : 0;
  }
  this.mightDrag = null;
  var c = s ? null : r.target, u = c ? e.docView.nearestDesc(c, !0) : null;
  this.target = u ? u.dom : null, (o.type.spec.draggable && o.type.spec.selectable !== !1 || e.state.selection instanceof ct && a == e.state.selection.from) && (this.mightDrag = {
    node: o,
    pos: a,
    addAttr: this.target && !this.target.draggable,
    setUneditable: this.target && Fe.gecko && !this.target.hasAttribute("contentEditable")
  }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(function() {
    return i.target.setAttribute("contentEditable", "false");
  }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Xl(e, "pointer");
};
ag.prototype.done = function() {
  this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.view.mouseDown = null;
};
ag.prototype.up = function(e) {
  if (this.done(), !!this.view.dom.contains(e.target.nodeType == 3 ? e.target.parentNode : e.target)) {
    var n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(og(e))), this.allowDefault || !n ? Xl(this.view, "pointer") : VLe(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : this.flushed || // Safari ignores clicks on draggable elements
    Fe.safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Fe.chrome && !(this.view.state.selection instanceof Mt) && (n.pos == this.view.state.selection.from || n.pos == this.view.state.selection.to) ? (Jc(this.view, yt.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : Xl(this.view, "pointer");
  }
};
ag.prototype.move = function(e) {
  !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0), Xl(this.view, "pointer");
};
Vs.touchdown = function(t) {
  oI(t), Xl(t, "pointer");
};
Vs.contextmenu = function(t) {
  return oI(t);
};
function C9(t, e) {
  return t.composing ? !0 : Fe.safari && Math.abs(e.timeStamp - t.compositionEndedAt) < 500 ? (t.compositionEndedAt = -2e8, !0) : !1;
}
var YLe = Fe.android ? 5e3 : -1;
$s.compositionstart = $s.compositionupdate = function(t) {
  if (!t.composing) {
    t.domObserver.flush();
    var e = t.state, n = e.selection.$from;
    if (e.selection.empty && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some(function(a) {
      return a.type.spec.inclusive === !1;
    })))
      t.markCursor = t.state.storedMarks || n.marks(), Jm(t, !0), t.markCursor = null;
    else if (Jm(t), Fe.gecko && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length)
      for (var r = t.root.getSelection(), s = r.focusNode, i = r.focusOffset; s && s.nodeType == 1 && i != 0; ) {
        var o = i < 0 ? s.lastChild : s.childNodes[i - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          r.collapse(o, o.nodeValue.length);
          break;
        } else
          s = o, i = -1;
      }
    t.composing = !0;
  }
  T9(t, YLe);
};
$s.compositionend = function(t, e) {
  t.composing && (t.composing = !1, t.compositionEndedAt = e.timeStamp, T9(t, 20));
};
function T9(t, e) {
  clearTimeout(t.composingTimeout), e > -1 && (t.composingTimeout = setTimeout(function() {
    return Jm(t);
  }, e));
}
function P9(t) {
  for (t.composing = !1; t.compositionNodes.length > 0; )
    t.compositionNodes.pop().markParentsDirty();
}
function Jm(t, e) {
  if (t.domObserver.forceFlush(), P9(t), e || t.docView.dirty) {
    var n = h9(t);
    return n && !n.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(n)) : t.updateState(t.state), !0;
  }
  return !1;
}
function ZLe(t, e) {
  if (t.dom.parentNode) {
    var n = t.dom.parentNode.appendChild(document.createElement("div"));
    n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
    var r = getSelection(), s = document.createRange();
    s.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(s), setTimeout(function() {
      n.parentNode && n.parentNode.removeChild(n), t.focus();
    }, 50);
  }
}
var cu = Fe.ie && Fe.ie_version < 15 || Fe.ios && Fe.webkit_version < 604;
Vs.copy = $s.cut = function(t, e) {
  var n = t.state.selection, r = e.type == "cut";
  if (!n.empty) {
    var s = cu ? null : e.clipboardData, i = n.content(), o = y9(t, i), a = o.dom, l = o.text;
    s ? (e.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", l)) : ZLe(t, a), r && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
  }
};
function XLe(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function KLe(t, e) {
  if (t.dom.parentNode) {
    var n = t.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
    n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus(), setTimeout(function() {
      t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? h1(t, r.value, null, e) : h1(t, r.textContent, r.innerHTML, e);
    }, 50);
  }
}
function h1(t, e, n, r) {
  var s = b9(t, e, n, t.shiftKey, t.state.selection.$from);
  if (t.someProp("handlePaste", function(a) {
    return a(t, r, s || He.empty);
  }))
    return !0;
  if (!s)
    return !1;
  var i = XLe(s), o = i ? t.state.tr.replaceSelectionWith(i, t.shiftKey) : t.state.tr.replaceSelection(s);
  return t.dispatch(o.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
$s.paste = function(t, e) {
  var n = cu ? null : e.clipboardData;
  n && h1(t, n.getData("text/plain"), n.getData("text/html"), e) ? e.preventDefault() : KLe(t, e);
};
var JLe = function(e, n) {
  this.slice = e, this.move = n;
}, k9 = Fe.mac ? "altKey" : "ctrlKey";
Vs.dragstart = function(t, e) {
  var n = t.mouseDown;
  if (n && n.done(), !!e.dataTransfer) {
    var r = t.state.selection, s = r.empty ? null : t.posAtCoords(og(e));
    if (!(s && s.pos >= r.from && s.pos <= (r instanceof ct ? r.to - 1 : r.to))) {
      if (n && n.mightDrag)
        t.dispatch(t.state.tr.setSelection(ct.create(t.state.doc, n.mightDrag.pos)));
      else if (e.target && e.target.nodeType == 1) {
        var i = t.docView.nearestDesc(e.target, !0);
        if (!i || !i.node.type.spec.draggable || i == t.docView)
          return;
        t.dispatch(t.state.tr.setSelection(ct.create(t.state.doc, i.posBefore)));
      }
    }
    var o = t.state.selection.content(), a = y9(t, o), l = a.dom, c = a.text;
    e.dataTransfer.clearData(), e.dataTransfer.setData(cu ? "Text" : "text/html", l.innerHTML), cu || e.dataTransfer.setData("text/plain", c), t.dragging = new JLe(o, !e[k9]);
  }
};
Vs.dragend = function(t) {
  var e = t.dragging;
  window.setTimeout(function() {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
$s.dragover = $s.dragenter = function(t, e) {
  return e.preventDefault();
};
$s.drop = function(t, e) {
  var n = t.dragging;
  if (t.dragging = null, !!e.dataTransfer) {
    var r = t.posAtCoords(og(e));
    if (r) {
      var s = t.state.doc.resolve(r.pos);
      if (s) {
        var i = n && n.slice || b9(
          t,
          e.dataTransfer.getData(cu ? "Text" : "text/plain"),
          cu ? null : e.dataTransfer.getData("text/html"),
          !1,
          s
        ), o = n && !e[k9];
        if (t.someProp("handleDrop", function(h) {
          return h(t, e, i || He.empty, o);
        })) {
          e.preventDefault();
          return;
        }
        if (i) {
          e.preventDefault();
          var a = i ? U6(t.state.doc, s.pos, i) : s.pos;
          a == null && (a = s.pos);
          var l = t.state.tr;
          o && l.deleteSelection();
          var c = l.mapping.map(a), u = i.openStart == 0 && i.openEnd == 0 && i.content.childCount == 1, d = l.doc;
          if (u ? l.replaceRangeWith(c, c, i.content.firstChild) : l.replaceRange(c, c, i), !l.doc.eq(d)) {
            var f = l.doc.resolve(c);
            if (u && ct.isSelectable(i.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(i.content.firstChild))
              l.setSelection(new ct(f));
            else {
              var p = l.mapping.map(a);
              l.mapping.maps[l.mapping.maps.length - 1].forEach(function(h, m, v, y) {
                return p = y;
              }), l.setSelection(Q2(t, f, l.doc.resolve(p)));
            }
            t.focus(), t.dispatch(l.setMeta("uiEvent", "drop"));
          }
        }
      }
    }
  }
};
Vs.focus = function(t) {
  t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(function() {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.root.getSelection()) && hc(t);
  }, 20));
};
Vs.blur = function(t) {
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), t.domObserver.currentSelection.set({}), t.focused = !1);
};
Vs.beforeinput = function(t, e) {
  if (Fe.chrome && Fe.android && e.inputType == "deleteContentBackward") {
    var n = t.domChangeCount;
    setTimeout(function() {
      if (t.domChangeCount == n && (t.dom.blur(), t.focus(), !t.someProp("handleKeyDown", function(i) {
        return i(t, Vc(8, "Backspace"));
      }))) {
        var r = t.state.selection, s = r.$cursor;
        s && s.pos > 0 && t.dispatch(t.state.tr.delete(s.pos - 1, s.pos).scrollIntoView());
      }
    }, 50);
  }
};
for (var KN in $s)
  Vs[KN] = $s[KN];
function mf(t, e) {
  if (t == e)
    return !0;
  for (var n in t)
    if (t[n] !== e[n])
      return !1;
  for (var r in e)
    if (!(r in t))
      return !1;
  return !0;
}
var vf = function(e, n) {
  this.spec = n || Vu, this.side = this.spec.side || 0, this.toDOM = e;
};
vf.prototype.map = function(e, n, r, s) {
  var i = e.mapResult(n.from + s, this.side < 0 ? -1 : 1), o = i.pos, a = i.deleted;
  return a ? null : new Qt(o - r, o - r, this);
};
vf.prototype.valid = function() {
  return !0;
};
vf.prototype.eq = function(e) {
  return this == e || e instanceof vf && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && mf(this.spec, e.spec));
};
var zi = function(e, n) {
  this.spec = n || Vu, this.attrs = e;
};
zi.prototype.map = function(e, n, r, s) {
  var i = e.map(n.from + s, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(n.to + s, this.spec.inclusiveEnd ? 1 : -1) - r;
  return i >= o ? null : new Qt(i, o, this);
};
zi.prototype.valid = function(e, n) {
  return n.from < n.to;
};
zi.prototype.eq = function(e) {
  return this == e || e instanceof zi && mf(this.attrs, e.attrs) && mf(this.spec, e.spec);
};
zi.is = function(e) {
  return e.type instanceof zi;
};
var gf = function(e, n) {
  this.spec = n || Vu, this.attrs = e;
};
gf.prototype.map = function(e, n, r, s) {
  var i = e.mapResult(n.from + s, 1);
  if (i.deleted)
    return null;
  var o = e.mapResult(n.to + s, -1);
  return o.deleted || o.pos <= i.pos ? null : new Qt(i.pos - r, o.pos - r, this);
};
gf.prototype.valid = function(e, n) {
  var r = e.content.findIndex(n.from), s = r.index, i = r.offset;
  return i == n.from && i + e.child(s).nodeSize == n.to;
};
gf.prototype.eq = function(e) {
  return this == e || e instanceof gf && mf(this.attrs, e.attrs) && mf(this.spec, e.spec);
};
var Qt = function(e, n, r) {
  this.from = e, this.to = n, this.type = r;
}, aI = { spec: { configurable: !0 }, inline: { configurable: !0 } };
Qt.prototype.copy = function(e, n) {
  return new Qt(e, n, this.type);
};
Qt.prototype.eq = function(e, n) {
  return n === void 0 && (n = 0), this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
};
Qt.prototype.map = function(e, n, r) {
  return this.type.map(e, this, n, r);
};
Qt.widget = function(e, n, r) {
  return new Qt(e, e, new vf(n, r));
};
Qt.inline = function(e, n, r, s) {
  return new Qt(e, n, new zi(r, s));
};
Qt.node = function(e, n, r, s) {
  return new Qt(e, n, new gf(r, s));
};
aI.spec.get = function() {
  return this.type.spec;
};
aI.inline.get = function() {
  return this.type instanceof zi;
};
Object.defineProperties(Qt.prototype, aI);
var qm = [], Vu = {}, Rt = function(e, n) {
  this.local = e && e.length ? e : qm, this.children = n && n.length ? n : qm;
};
Rt.create = function(e, n) {
  return n.length ? lg(n, e, 0, Vu) : es;
};
Rt.prototype.find = function(e, n, r) {
  var s = [];
  return this.findInner(e ?? 0, n ?? 1e9, s, 0, r), s;
};
Rt.prototype.findInner = function(e, n, r, s, i) {
  for (var o = 0; o < this.local.length; o++) {
    var a = this.local[o];
    a.from <= n && a.to >= e && (!i || i(a.spec)) && r.push(a.copy(a.from + s, a.to + s));
  }
  for (var l = 0; l < this.children.length; l += 3)
    if (this.children[l] < n && this.children[l + 1] > e) {
      var c = this.children[l] + 1;
      this.children[l + 2].findInner(e - c, n - c, r, s + c, i);
    }
};
Rt.prototype.map = function(e, n, r) {
  return this == es || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || Vu);
};
Rt.prototype.mapInner = function(e, n, r, s, i) {
  for (var o, a = 0; a < this.local.length; a++) {
    var l = this.local[a].map(e, r, s);
    l && l.type.valid(n, l) ? (o || (o = [])).push(l) : i.onRemove && i.onRemove(this.local[a].spec);
  }
  return this.children.length ? qLe(this.children, o, e, n, r, s, i) : o ? new Rt(o.sort(mc)) : es;
};
Rt.prototype.add = function(e, n) {
  return n.length ? this == es ? Rt.create(e, n) : this.addInner(e, n, 0) : this;
};
Rt.prototype.addInner = function(e, n, r) {
  var s = this, i, o = 0;
  e.forEach(function(c, u) {
    var d = u + r, f;
    if (f = $9(n, c, d)) {
      for (i || (i = s.children.slice()); o < i.length && i[o] < u; )
        o += 3;
      i[o] == u ? i[o + 2] = i[o + 2].addInner(c, f, d + 1) : i.splice(o, 0, u, u + c.nodeSize, lg(f, c, d + 1, Vu)), o += 3;
    }
  });
  for (var a = N9(o ? D9(n) : n, -r), l = 0; l < a.length; l++)
    a[l].type.valid(e, a[l]) || a.splice(l--, 1);
  return new Rt(
    a.length ? this.local.concat(a).sort(mc) : this.local,
    i || this.children
  );
};
Rt.prototype.remove = function(e) {
  return e.length == 0 || this == es ? this : this.removeInner(e, 0);
};
Rt.prototype.removeInner = function(e, n) {
  for (var r = this.children, s = this.local, i = 0; i < r.length; i += 3) {
    for (var o = void 0, a = r[i] + n, l = r[i + 1] + n, c = 0, u = void 0; c < e.length; c++)
      (u = e[c]) && u.from > a && u.to < l && (e[c] = null, (o || (o = [])).push(u));
    if (o) {
      r == this.children && (r = this.children.slice());
      var d = r[i + 2].removeInner(o, a + 1);
      d != es ? r[i + 2] = d : (r.splice(i, 3), i -= 3);
    }
  }
  if (s.length) {
    for (var f = 0, p = void 0; f < e.length; f++)
      if (p = e[f])
        for (var h = 0; h < s.length; h++)
          s[h].eq(p, n) && (s == this.local && (s = this.local.slice()), s.splice(h--, 1));
  }
  return r == this.children && s == this.local ? this : s.length || r.length ? new Rt(s, r) : es;
};
Rt.prototype.forChild = function(e, n) {
  if (this == es)
    return this;
  if (n.isLeaf)
    return Rt.empty;
  for (var r, s, i = 0; i < this.children.length; i += 3)
    if (this.children[i] >= e) {
      this.children[i] == e && (r = this.children[i + 2]);
      break;
    }
  for (var o = e + 1, a = o + n.content.size, l = 0; l < this.local.length; l++) {
    var c = this.local[l];
    if (c.from < a && c.to > o && c.type instanceof zi) {
      var u = Math.max(o, c.from) - o, d = Math.min(a, c.to) - o;
      u < d && (s || (s = [])).push(c.copy(u, d));
    }
  }
  if (s) {
    var f = new Rt(s.sort(mc));
    return r ? new _o([f, r]) : f;
  }
  return r || es;
};
Rt.prototype.eq = function(e) {
  if (this == e)
    return !0;
  if (!(e instanceof Rt) || this.local.length != e.local.length || this.children.length != e.children.length)
    return !1;
  for (var n = 0; n < this.local.length; n++)
    if (!this.local[n].eq(e.local[n]))
      return !1;
  for (var r = 0; r < this.children.length; r += 3)
    if (this.children[r] != e.children[r] || this.children[r + 1] != e.children[r + 1] || !this.children[r + 2].eq(e.children[r + 2]))
      return !1;
  return !0;
};
Rt.prototype.locals = function(e) {
  return lI(this.localsInner(e));
};
Rt.prototype.localsInner = function(e) {
  if (this == es)
    return qm;
  if (e.inlineContent || !this.local.some(zi.is))
    return this.local;
  for (var n = [], r = 0; r < this.local.length; r++)
    this.local[r].type instanceof zi || n.push(this.local[r]);
  return n;
};
var es = new Rt();
Rt.empty = es;
Rt.removeOverlap = lI;
var _o = function(e) {
  this.members = e;
};
_o.prototype.forChild = function(e, n) {
  if (n.isLeaf)
    return Rt.empty;
  for (var r = [], s = 0; s < this.members.length; s++) {
    var i = this.members[s].forChild(e, n);
    i != es && (i instanceof _o ? r = r.concat(i.members) : r.push(i));
  }
  return _o.from(r);
};
_o.prototype.eq = function(e) {
  if (!(e instanceof _o) || e.members.length != this.members.length)
    return !1;
  for (var n = 0; n < this.members.length; n++)
    if (!this.members[n].eq(e.members[n]))
      return !1;
  return !0;
};
_o.prototype.locals = function(e) {
  for (var n, r = !0, s = 0; s < this.members.length; s++) {
    var i = this.members[s].localsInner(e);
    if (i.length)
      if (!n)
        n = i;
      else {
        r && (n = n.slice(), r = !1);
        for (var o = 0; o < i.length; o++)
          n.push(i[o]);
      }
  }
  return n ? lI(r ? n : n.sort(mc)) : qm;
};
_o.from = function(e) {
  switch (e.length) {
    case 0:
      return es;
    case 1:
      return e[0];
    default:
      return new _o(e);
  }
};
function qLe(t, e, n, r, s, i, o) {
  for (var a = t.slice(), l = function(P, N, D, H) {
    for (var Y = 0; Y < a.length; Y += 3) {
      var te = a[Y + 1], A = void 0;
      te == -1 || P > te + i || (N >= a[Y] + i ? a[Y + 1] = -1 : D >= s && (A = H - D - (N - P)) && (a[Y] += A, a[Y + 1] += A));
    }
  }, c = 0; c < n.maps.length; c++)
    n.maps[c].forEach(l);
  for (var u = !1, d = 0; d < a.length; d += 3)
    if (a[d + 1] == -1) {
      var f = n.map(t[d] + i), p = f - s;
      if (p < 0 || p >= r.content.size) {
        u = !0;
        continue;
      }
      var h = n.map(t[d + 1] + i, -1), m = h - s, v = r.content.findIndex(p), y = v.index, _ = v.offset, w = r.maybeChild(y);
      if (w && _ == p && _ + w.nodeSize == m) {
        var S = a[d + 2].mapInner(n, w, f + 1, t[d] + i + 1, o);
        S != es ? (a[d] = p, a[d + 1] = m, a[d + 2] = S) : (a[d + 1] = -2, u = !0);
      } else
        u = !0;
    }
  if (u) {
    var E = QLe(
      a,
      t,
      e || [],
      n,
      s,
      i,
      o
    ), x = lg(E, r, 0, o);
    e = x.local;
    for (var T = 0; T < a.length; T += 3)
      a[T + 1] < 0 && (a.splice(T, 3), T -= 3);
    for (var C = 0, k = 0; C < x.children.length; C += 3) {
      for (var b = x.children[C]; k < a.length && a[k] < b; )
        k += 3;
      a.splice(k, 0, x.children[C], x.children[C + 1], x.children[C + 2]);
    }
  }
  return new Rt(e && e.sort(mc), a);
}
function N9(t, e) {
  if (!e || !t.length)
    return t;
  for (var n = [], r = 0; r < t.length; r++) {
    var s = t[r];
    n.push(new Qt(s.from + e, s.to + e, s.type));
  }
  return n;
}
function QLe(t, e, n, r, s, i, o) {
  function a(c, u) {
    for (var d = 0; d < c.local.length; d++) {
      var f = c.local[d].map(r, s, u);
      f ? n.push(f) : o.onRemove && o.onRemove(c.local[d].spec);
    }
    for (var p = 0; p < c.children.length; p += 3)
      a(c.children[p + 2], c.children[p] + u + 1);
  }
  for (var l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && a(t[l + 2], e[l] + i + 1);
  return n;
}
function $9(t, e, n) {
  if (e.isLeaf)
    return null;
  for (var r = n + e.nodeSize, s = null, i = 0, o = void 0; i < t.length; i++)
    (o = t[i]) && o.from > n && o.to < r && ((s || (s = [])).push(o), t[i] = null);
  return s;
}
function D9(t) {
  for (var e = [], n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function lg(t, e, n, r) {
  var s = [], i = !1;
  e.forEach(function(l, c) {
    var u = $9(t, l, c + n);
    if (u) {
      i = !0;
      var d = lg(u, l, n + c + 1, r);
      d != es && s.push(c, c + l.nodeSize, d);
    }
  });
  for (var o = N9(i ? D9(t) : t, -n).sort(mc), a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (r.onRemove && r.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || s.length ? new Rt(o, s) : es;
}
function mc(t, e) {
  return t.from - e.from || t.to - e.to;
}
function lI(t) {
  for (var e = t, n = 0; n < e.length - 1; n++) {
    var r = e[n];
    if (r.from != r.to)
      for (var s = n + 1; s < e.length; s++) {
        var i = e[s];
        if (i.from == r.from) {
          i.to != r.to && (e == t && (e = t.slice()), e[s] = i.copy(i.from, r.to), JN(e, s + 1, i.copy(r.to, i.to)));
          continue;
        } else {
          i.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, i.from), JN(e, s, r.copy(i.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function JN(t, e, n) {
  for (; e < t.length && mc(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function cI(t) {
  var e = [];
  return t.someProp("decorations", function(n) {
    var r = n(t.state);
    r && r != es && e.push(r);
  }), t.cursorWrapper && e.push(Rt.create(t.state.doc, [t.cursorWrapper.deco])), _o.from(e);
}
var Pr = function(e, n) {
  this._props = n, this.state = n.state, this.dispatch = this.dispatch.bind(this), this._root = null, this.focused = !1, this.trackWrites = null, this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : e.apply ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = M9(this), this.markCursor = null, this.cursorWrapper = null, O9(this), this.nodeViews = R9(this), this.docView = c9(this.state.doc, A9(this), cI(this), this.dom, this), this.lastSelectedViewDesc = null, this.dragging = null, RLe(this), this.pluginViews = [], this.updatePluginViews();
}, uI = { props: { configurable: !0 }, root: { configurable: !0 } };
uI.props.get = function() {
  if (this._props.state != this.state) {
    var t = this._props;
    this._props = {};
    for (var e in t)
      this._props[e] = t[e];
    this._props.state = this.state;
  }
  return this._props;
};
Pr.prototype.update = function(e) {
  e.handleDOMEvents != this._props.handleDOMEvents && rI(this), this._props = e, this.updateStateInner(e.state, !0);
};
Pr.prototype.setProps = function(e) {
  var n = {};
  for (var r in this._props)
    n[r] = this._props[r];
  n.state = this.state;
  for (var s in e)
    n[s] = e[s];
  this.update(n);
};
Pr.prototype.updateState = function(e) {
  this.updateStateInner(e, this.state.plugins != e.plugins);
};
Pr.prototype.updateStateInner = function(e, n) {
  var r = this, s = this.state, i = !1, o = !1;
  if (e.storedMarks && this.composing && (P9(this), o = !0), this.state = e, n) {
    var a = R9(this);
    t6e(a, this.nodeViews) && (this.nodeViews = a, i = !0), rI(this);
  }
  this.editable = M9(this), O9(this);
  var l = cI(this), c = A9(this), u = n ? "reset" : e.scrollToSelection > s.scrollToSelection ? "to selection" : "preserve", d = i || !this.docView.matchesNode(e.doc, c, l);
  (d || !e.selection.eq(s.selection)) && (o = !0);
  var f = u == "preserve" && o && this.dom.style.overflowAnchor == null && YRe(this);
  if (o) {
    this.domObserver.stop();
    var p = d && (Fe.ie || Fe.chrome) && !this.composing && !s.selection.empty && !e.selection.empty && e6e(s.selection, e.selection);
    if (d) {
      var h = Fe.chrome ? this.trackWrites = this.root.getSelection().focusNode : null;
      (i || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco([]), this.docView.destroy(), this.docView = c9(e.doc, c, l, this.dom, this)), h && !this.trackWrites && (p = !0);
    }
    p || !(this.mouseDown && this.domObserver.currentSelection.eq(this.root.getSelection()) && _Le(this)) ? hc(this, p) : (v9(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
  }
  if (this.updatePluginViews(s), u == "reset")
    this.dom.scrollTop = 0;
  else if (u == "to selection") {
    var m = this.root.getSelection().focusNode;
    this.someProp("handleScrollToSelection", function(v) {
      return v(r);
    }) || (e.selection instanceof ct ? ON(this, this.docView.domAfterPos(e.selection.from).getBoundingClientRect(), m) : ON(this, this.coordsAtPos(e.selection.head, 1), m));
  } else f && ZRe(f);
};
Pr.prototype.destroyPluginViews = function() {
  for (var e; e = this.pluginViews.pop(); )
    e.destroy && e.destroy();
};
Pr.prototype.updatePluginViews = function(e) {
  if (!e || e.plugins != this.state.plugins) {
    this.destroyPluginViews();
    for (var n = 0; n < this.state.plugins.length; n++) {
      var r = this.state.plugins[n];
      r.spec.view && this.pluginViews.push(r.spec.view(this));
    }
  } else
    for (var s = 0; s < this.pluginViews.length; s++) {
      var i = this.pluginViews[s];
      i.update && i.update(this, e);
    }
};
Pr.prototype.someProp = function(e, n) {
  var r = this._props && this._props[e], s;
  if (r != null && (s = n ? n(r) : r))
    return s;
  var i = this.state.plugins;
  if (i)
    for (var o = 0; o < i.length; o++) {
      var a = i[o].props[e];
      if (a != null && (s = n ? n(a) : a))
        return s;
    }
};
Pr.prototype.hasFocus = function() {
  return this.root.activeElement == this.dom;
};
Pr.prototype.focus = function() {
  this.domObserver.stop(), this.editable && XRe(this.dom), hc(this), this.domObserver.start();
};
uI.root.get = function() {
  var t = this._root;
  if (t == null) {
    for (var e = this.dom.parentNode; e; e = e.parentNode)
      if (e.nodeType == 9 || e.nodeType == 11 && e.host)
        return e.getSelection || (Object.getPrototypeOf(e).getSelection = function() {
          return document.getSelection();
        }), this._root = e;
  }
  return t || document;
};
Pr.prototype.posAtCoords = function(e) {
  return eLe(this, e);
};
Pr.prototype.coordsAtPos = function(e, n) {
  return n === void 0 && (n = 1), o9(this, e, n);
};
Pr.prototype.domAtPos = function(e, n) {
  return n === void 0 && (n = 0), this.docView.domFromPos(e, n);
};
Pr.prototype.nodeDOM = function(e) {
  var n = this.docView.descAt(e);
  return n ? n.nodeDOM : null;
};
Pr.prototype.posAtDOM = function(e, n, r) {
  r === void 0 && (r = -1);
  var s = this.docView.posFromDOM(e, n, r);
  if (s == null)
    throw new RangeError("DOM position not inside the editor");
  return s;
};
Pr.prototype.endOfTextblock = function(e, n) {
  return iLe(this, n || this.state, e);
};
Pr.prototype.destroy = function() {
  this.docView && (LLe(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], cI(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null);
};
Pr.prototype.dispatchEvent = function(e) {
  return BLe(this, e);
};
Pr.prototype.dispatch = function(e) {
  var n = this._props.dispatchTransaction;
  n ? n.call(this, e) : this.updateState(this.state.apply(e));
};
Object.defineProperties(Pr.prototype, uI);
function A9(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", function(n) {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (var r in n)
        r == "class" ? e.class += " " + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), [Qt.node(0, t.state.doc.content.size, e)];
}
function O9(t) {
  if (t.markCursor) {
    var e = document.createElement("img");
    e.setAttribute("mark-placeholder", "true"), t.cursorWrapper = { dom: e, deco: Qt.widget(t.state.selection.head, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function M9(t) {
  return !t.someProp("editable", function(e) {
    return e(t.state) === !1;
  });
}
function e6e(t, e) {
  var n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function R9(t) {
  var e = {};
  return t.someProp("nodeViews", function(n) {
    for (var r in n)
      Object.prototype.hasOwnProperty.call(e, r) || (e[r] = n[r]);
  }), e;
}
function t6e(t, e) {
  var n = 0, r = 0;
  for (var s in t) {
    if (t[s] != e[s])
      return !0;
    n++;
  }
  for (var i in e)
    r++;
  return n != r;
}
function n6e(t = {}) {
  return new lr({
    view(e) {
      return new r6e(e, t);
    }
  });
}
class r6e {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((s) => {
      let i = (o) => {
        this[s](o);
      };
      return e.dom.addEventListener(s, i), { name: s, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r;
    if (n) {
      let a = e.nodeBefore, l = e.nodeAfter;
      if (a || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (a ? a.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), d = a ? u.bottom : u.top;
          a && l && (d = (d + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: u.left, right: u.right, top: d - this.width / 2, bottom: d + this.width / 2 };
        }
      }
    }
    if (!r) {
      let a = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: a.left - this.width / 2, right: a.left + this.width / 2, top: a.top, bottom: a.bottom };
    }
    let s = this.editorView.dom.offsetParent;
    this.element || (this.element = s.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let i, o;
    if (!s || s == document.body && getComputedStyle(s).position == "static")
      i = -pageXOffset, o = -pageYOffset;
    else {
      let a = s.getBoundingClientRect();
      i = a.left - s.scrollLeft, o = a.top - s.scrollTop;
    }
    this.element.style.left = r.left - i + "px", this.element.style.top = r.top - o + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), s = r && r.type.spec.disableDropCursor, i = typeof s == "function" ? s(this.editorView, n, e) : s;
    if (n && !i) {
      let o = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = U6(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
var Ya = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Qm = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, s6e = typeof navigator < "u" && /Mac/.test(navigator.platform), i6e = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Kr = 0; Kr < 10; Kr++) Ya[48 + Kr] = Ya[96 + Kr] = String(Kr);
for (var Kr = 1; Kr <= 24; Kr++) Ya[Kr + 111] = "F" + Kr;
for (var Kr = 65; Kr <= 90; Kr++)
  Ya[Kr] = String.fromCharCode(Kr + 32), Qm[Kr] = String.fromCharCode(Kr);
for (var cb in Ya) Qm.hasOwnProperty(cb) || (Qm[cb] = Ya[cb]);
function o6e(t) {
  var e = s6e && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || i6e && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? Qm : Ya)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const a6e = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function l6e(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, s, i, o;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      s = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      a6e ? o = !0 : s = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), s && (n = "Ctrl-" + n), o && (n = "Meta-" + n), i && (n = "Shift-" + n), n;
}
function c6e(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[l6e(n)] = t[n];
  return e;
}
function ub(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function m1(t) {
  return new lr({ props: { handleKeyDown: dI(t) } });
}
function dI(t) {
  let e = c6e(t);
  return function(n, r) {
    let s = o6e(r), i, o = e[ub(s, r)];
    if (o && o(n.state, n.dispatch, n))
      return !0;
    if (s.length == 1 && s != " ") {
      if (r.shiftKey) {
        let a = e[ub(s, r, !1)];
        if (a && a(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || s.charCodeAt(0) > 127) && (i = Ya[r.keyCode]) && i != s) {
        let a = e[ub(i, r)];
        if (a && a(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
class ir extends yt {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return ir.valid(r) ? new ir(r) : yt.near(r);
  }
  content() {
    return He.empty;
  }
  eq(e) {
    return e instanceof ir && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new ir(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new fI(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.isTextblock || !u6e(e) || !d6e(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let s = n.contentMatchAt(e.index()).defaultType;
    return s && s.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e: for (; ; ) {
      if (!r && ir.valid(e))
        return e;
      let s = e.pos, i = null;
      for (let o = e.depth; ; o--) {
        let a = e.node(o);
        if (n > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
          i = a.child(n > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        s += n;
        let l = e.doc.resolve(s);
        if (ir.valid(l))
          return l;
      }
      for (; ; ) {
        let o = n > 0 ? i.firstChild : i.lastChild;
        if (!o) {
          if (i.isAtom && !i.isText && !ct.isSelectable(i)) {
            e = e.doc.resolve(s + i.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        i = o, s += n;
        let a = e.doc.resolve(s);
        if (ir.valid(a))
          return a;
      }
      return null;
    }
  }
}
ir.prototype.visible = !1;
ir.findFrom = ir.findGapCursorFrom;
yt.jsonID("gapcursor", ir);
class fI {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new fI(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return ir.valid(n) ? new ir(n) : yt.near(n);
  }
}
function u6e(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let s = r.child(n - 1); ; s = s.lastChild) {
      if (s.childCount == 0 && !s.inlineContent || s.isAtom || s.type.spec.isolating)
        return !0;
      if (s.inlineContent)
        return !1;
    }
  }
  return !0;
}
function d6e(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let s = r.child(n); ; s = s.firstChild) {
      if (s.childCount == 0 && !s.inlineContent || s.isAtom || s.type.spec.isolating)
        return !0;
      if (s.inlineContent)
        return !1;
    }
  }
  return !0;
}
function f6e() {
  return new lr({
    props: {
      decorations: v6e,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && ir.valid(n) ? new ir(n) : null;
      },
      handleClick: h6e,
      handleKeyDown: p6e,
      handleDOMEvents: { beforeinput: m6e }
    }
  });
}
const p6e = dI({
  ArrowLeft: Ap("horiz", -1),
  ArrowRight: Ap("horiz", 1),
  ArrowUp: Ap("vert", -1),
  ArrowDown: Ap("vert", 1)
});
function Ap(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, s, i) {
    let o = r.selection, a = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof Mt) {
      if (!i.endOfTextblock(n) || a.depth == 0)
        return !1;
      l = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let c = ir.findGapCursorFrom(a, e, l);
    return c ? (s && s(r.tr.setSelection(new ir(c))), !0) : !1;
  };
}
function h6e(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!ir.valid(r))
    return !1;
  let s = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return s && s.inside > -1 && ct.isSelectable(t.state.doc.nodeAt(s.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new ir(r))), !0);
}
function m6e(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof ir))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let s = xe.empty;
  for (let o = r.length - 1; o >= 0; o--)
    s = xe.from(r[o].createAndFill(null, s));
  let i = t.state.tr.replace(n.pos, n.pos, new He(s, 0, 0));
  return i.setSelection(Mt.near(i.doc.resolve(n.pos + 1))), t.dispatch(i), !1;
}
function v6e(t) {
  if (!(t.selection instanceof ir))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", Rt.create(t.doc, [Qt.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const L9 = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function g6e(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const y6e = (t, e, n) => {
  let r = g6e(t, n);
  if (!r)
    return !1;
  let s = F9(r);
  if (!s) {
    let o = r.blockRange(), a = o && z2(o);
    return a == null ? !1 : (e && e(t.tr.lift(o, a).scrollIntoView()), !0);
  }
  let i = s.nodeBefore;
  if (j9(t, s, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (uu(i, "end") || ct.isSelectable(i)))
    for (let o = r.depth; ; o--) {
      let a = Y2(t.doc, r.before(o), r.after(o), He.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = t.tr.step(a);
          l.setSelection(uu(i, "end") ? yt.findFrom(l.doc.resolve(l.mapping.map(s.pos, -1)), -1) : ct.create(l.doc, s.pos - i.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return i.isAtom && s.depth == r.depth - 1 ? (e && e(t.tr.delete(s.pos - i.nodeSize, s.pos).scrollIntoView()), !0) : !1;
};
function uu(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const b6e = (t, e, n) => {
  let { $head: r, empty: s } = t.selection, i = r;
  if (!s)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    i = F9(r);
  }
  let o = i && i.nodeBefore;
  return !o || !ct.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(ct.create(t.doc, i.pos - o.nodeSize)).scrollIntoView()), !0);
};
function F9(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function _6e(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const w6e = (t, e, n) => {
  let r = _6e(t, n);
  if (!r)
    return !1;
  let s = B9(r);
  if (!s)
    return !1;
  let i = s.nodeAfter;
  if (j9(t, s, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (uu(i, "start") || ct.isSelectable(i))) {
    let o = Y2(t.doc, r.before(), r.after(), He.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = t.tr.step(o);
        a.setSelection(uu(i, "start") ? yt.findFrom(a.doc.resolve(a.mapping.map(s.pos)), 1) : ct.create(a.doc, a.mapping.map(s.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && s.depth == r.depth - 1 ? (e && e(t.tr.delete(s.pos, s.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, S6e = (t, e, n) => {
  let { $head: r, empty: s } = t.selection, i = r;
  if (!s)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    i = B9(r);
  }
  let o = i && i.nodeAfter;
  return !o || !ct.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(ct.create(t.doc, i.pos)).scrollIntoView()), !0);
};
function B9(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const I6e = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function pI(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const E6e = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let s = n.node(-1), i = n.indexAfter(-1), o = pI(s.contentMatchAt(i));
  if (!o || !s.canReplaceWith(i, i, o))
    return !1;
  if (e) {
    let a = n.after(), l = t.tr.replaceWith(a, a, o.createAndFill());
    l.setSelection(yt.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, x6e = (t, e) => {
  let n = t.selection, { $from: r, $to: s } = n;
  if (n instanceof Co || r.parent.inlineContent || s.parent.inlineContent)
    return !1;
  let i = pI(s.parent.contentMatchAt(s.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && s.index() < s.parent.childCount ? r : s).pos, a = t.tr.insert(o, i.createAndFill());
    a.setSelection(Mt.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, C6e = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (yh(t.doc, i))
      return e && e(t.tr.split(i).scrollIntoView()), !0;
  }
  let r = n.blockRange(), s = r && z2(r);
  return s == null ? !1 : (e && e(t.tr.lift(r, s).scrollIntoView()), !0);
};
function T6e(t) {
  return (e, n) => {
    let { $from: r, $to: s } = e.selection;
    if (e.selection instanceof ct && e.selection.node.isBlock)
      return !r.parentOffset || !yh(e.doc, r.pos) ? !1 : (n && n(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.parent.isBlock)
      return !1;
    if (n) {
      let i = s.parentOffset == s.parent.content.size, o = e.tr;
      (e.selection instanceof Mt || e.selection instanceof Co) && o.deleteSelection();
      let a = r.depth == 0 ? null : pI(r.node(-1).contentMatchAt(r.indexAfter(-1))), l = i && a ? [{ type: a }] : void 0, c = yh(o.doc, o.mapping.map(r.pos), 1, l);
      if (!l && !c && yh(o.doc, o.mapping.map(r.pos), 1, a ? [{ type: a }] : void 0) && (a && (l = [{ type: a }]), c = !0), c && (o.split(o.mapping.map(r.pos), 1, l), !i && !r.parentOffset && r.parent.type != a)) {
        let u = o.mapping.map(r.before()), d = o.doc.resolve(u);
        a && r.node(-1).canReplaceWith(d.index(), d.index() + 1, a) && o.setNodeMarkup(o.mapping.map(r.before()), a);
      }
      n(o.scrollIntoView());
    }
    return !0;
  };
}
const P6e = T6e(), k6e = (t, e) => (e && e(t.tr.setSelection(new Co(t.doc))), !0);
function N6e(t, e, n) {
  let r = e.nodeBefore, s = e.nodeAfter, i = e.index();
  return !r || !s || !r.type.compatibleContent(s.type) ? !1 : !r.content.size && e.parent.canReplace(i - 1, i) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(i, i + 1) || !(s.isTextblock || z6(t.doc, e.pos)) ? !1 : (n && n(t.tr.clearIncompatible(e.pos, r.type, r.contentMatchAt(r.childCount)).join(e.pos).scrollIntoView()), !0);
}
function j9(t, e, n, r) {
  let s = e.nodeBefore, i = e.nodeAfter, o, a, l = s.type.spec.isolating || i.type.spec.isolating;
  if (!l && N6e(t, e, n))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (a = s.contentMatchAt(s.childCount)).findWrapping(i.type)) && a.matchType(o[0] || i.type).validEnd) {
    if (n) {
      let p = e.pos + i.nodeSize, h = xe.empty;
      for (let y = o.length - 1; y >= 0; y--)
        h = xe.from(o[y].create(null, h));
      h = xe.from(s.copy(h));
      let m = t.tr.step(new Zo(e.pos - 1, p, e.pos, p, new He(h, 1, 0), o.length, !0)), v = p + 2 * o.length;
      z6(m.doc, v) && m.join(v), n(m.scrollIntoView());
    }
    return !0;
  }
  let u = i.type.spec.isolating || r > 0 && l ? null : yt.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), f = d && z2(d);
  if (f != null && f >= e.depth)
    return n && n(t.tr.lift(d, f).scrollIntoView()), !0;
  if (c && uu(i, "start", !0) && uu(s, "end")) {
    let p = s, h = [];
    for (; h.push(p), !p.isTextblock; )
      p = p.lastChild;
    let m = i, v = 1;
    for (; !m.isTextblock; m = m.firstChild)
      v++;
    if (p.canReplace(p.childCount, p.childCount, m.content)) {
      if (n) {
        let y = xe.empty;
        for (let w = h.length - 1; w >= 0; w--)
          y = xe.from(h[w].copy(y));
        let _ = t.tr.step(new Zo(e.pos - h.length, e.pos + i.nodeSize, e.pos + v, e.pos + i.nodeSize - v, new He(y, h.length, 0), 0, !0));
        n(_.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function W9(t) {
  return function(e, n) {
    let r = e.selection, s = t < 0 ? r.$from : r.$to, i = s.depth;
    for (; s.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return s.node(i).isTextblock ? (n && n(e.tr.setSelection(Mt.create(e.doc, t < 0 ? s.start(i) : s.end(i)))), !0) : !1;
  };
}
const $6e = W9(-1), D6e = W9(1);
function A6e(t, e = null) {
  return function(n, r) {
    let s = !1;
    for (let i = 0; i < n.selection.ranges.length && !s; i++) {
      let { $from: { pos: o }, $to: { pos: a } } = n.selection.ranges[i];
      n.doc.nodesBetween(o, a, (l, c) => {
        if (s)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            s = !0;
          else {
            let u = n.doc.resolve(c), d = u.index();
            s = u.parent.canReplaceWith(d, d + 1, t);
          }
      });
    }
    if (!s)
      return !1;
    if (r) {
      let i = n.tr;
      for (let o = 0; o < n.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: l } } = n.selection.ranges[o];
        i.setBlockType(a, l, t, e);
      }
      r(i.scrollIntoView());
    }
    return !0;
  };
}
function hI(...t) {
  return function(e, n, r) {
    for (let s = 0; s < t.length; s++)
      if (t[s](e, n, r))
        return !0;
    return !1;
  };
}
let db = hI(L9, y6e, b6e), qN = hI(L9, w6e, S6e);
const Fo = {
  Enter: hI(I6e, x6e, C6e, P6e),
  "Mod-Enter": E6e,
  Backspace: db,
  "Mod-Backspace": db,
  "Shift-Backspace": db,
  Delete: qN,
  "Mod-Delete": qN,
  "Mod-a": k6e
}, H9 = {
  "Ctrl-h": Fo.Backspace,
  "Alt-Backspace": Fo["Mod-Backspace"],
  "Ctrl-d": Fo.Delete,
  "Ctrl-Alt-Backspace": Fo["Mod-Delete"],
  "Alt-Delete": Fo["Mod-Delete"],
  "Alt-d": Fo["Mod-Delete"],
  "Ctrl-a": $6e,
  "Ctrl-e": D6e
};
for (let t in Fo)
  H9[t] = Fo[t];
const O6e = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform ? os.platform() == "darwin" : !1, M6e = O6e ? H9 : Fo;
let zu = class {
  // :: (RegExp, union<string, (state: EditorState, match: [string], start: number, end: number) → ?Transaction>)
  /**
  Create an input rule. The rule applies when the user typed
  something and the text directly in front of the cursor matches
  `match`, which should end with `$`.
  
  The `handler` can be a string, in which case the matched text, or
  the first matched group in the regexp, is replaced by that
  string.
  
  Or a it can be a function, which will be called with the match
  array produced by
  [`RegExp.exec`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec),
  as well as the start and end of the matched range, and which can
  return a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) that describes the
  rule's effect, or null to indicate the input was not handled.
  */
  constructor(e, n, r = {}) {
    this.match = e, this.match = e, this.handler = typeof n == "string" ? R6e(n) : n, this.undoable = r.undoable !== !1, this.inCode = r.inCode || !1;
  }
};
function R6e(t) {
  return function(e, n, r, s) {
    let i = t;
    if (n[1]) {
      let o = n[0].lastIndexOf(n[1]);
      i += n[0].slice(o + n[1].length), r += o;
      let a = r - s;
      a > 0 && (i = n[0].slice(o - a, o) + i, r = s);
    }
    return e.tr.insertText(i, r, s);
  };
}
const L6e = 500;
function F6e({ rules: t }) {
  let e = new lr({
    state: {
      init() {
        return null;
      },
      apply(n, r) {
        let s = n.getMeta(this);
        return s || (n.selectionSet || n.docChanged ? null : r);
      }
    },
    props: {
      handleTextInput(n, r, s, i) {
        return QN(n, r, s, i, t, e);
      },
      handleDOMEvents: {
        compositionend: (n) => {
          setTimeout(() => {
            let { $cursor: r } = n.state.selection;
            r && QN(n, r.pos, r.pos, "", t, e);
          });
        }
      }
    },
    isInputRules: !0
  });
  return e;
}
function QN(t, e, n, r, s, i) {
  if (t.composing)
    return !1;
  let o = t.state, a = o.doc.resolve(e), l = a.parent.textBetween(Math.max(0, a.parentOffset - L6e), a.parentOffset, null, "￼") + r;
  for (let c = 0; c < s.length; c++) {
    let u = s[c];
    if (a.parent.type.spec.code) {
      if (!u.inCode)
        continue;
    } else if (u.inCode === "only")
      continue;
    let d = u.match.exec(l), f = d && u.handler(o, d, e - (d[0].length - r.length), n);
    if (f)
      return u.undoable && f.setMeta(i, { transform: f, from: e, to: n, text: r }), t.dispatch(f), !0;
  }
  return !1;
}
const B6e = (t, e) => {
  let n = t.plugins;
  for (let r = 0; r < n.length; r++) {
    let s = n[r], i;
    if (s.spec.isInputRules && (i = s.getState(t))) {
      if (e) {
        let o = t.tr, a = i.transform;
        for (let l = a.steps.length - 1; l >= 0; l--)
          o.step(a.steps[l].invert(a.docs[l]));
        if (i.text) {
          let l = o.doc.resolve(i.from).marks();
          o.replaceWith(i.from, i.to, t.schema.text(i.text, l));
        } else
          o.delete(i.from, i.to);
        e(o);
      }
      return !0;
    }
  }
  return !1;
};
new zu(/--$/, "—");
new zu(/\.\.\.$/, "…");
new zu(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "“");
new zu(/"$/, "”");
new zu(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "‘");
new zu(/'$/, "’");
function e3(t, e) {
  return t.createAndFill();
}
function j6e(t) {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((n) => {
    const r = t.nodes[n];
    r.spec.tableRole && (e[r.spec.tableRole] = r);
  }), t.cached.tableNodeTypes = e, e;
}
function W6e(t, e, n, r, s) {
  const i = j6e(t), o = [], a = [];
  for (let c = 0; c < n; c += 1) {
    const u = e3(i.cell);
    if (u && a.push(u), r) {
      const d = e3(i.header_cell);
      d && o.push(d);
    }
  }
  const l = [];
  for (let c = 0; c < e; c += 1)
    l.push(i.row.createChecked(null, r && c === 0 ? o : a));
  return i.table.createChecked(null, l);
}
function H6e(t, e) {
  return Array.isArray(t) && t.indexOf(e.type) > -1 || e.type === t;
}
function V6e(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function z6e(t) {
  return (e) => V6e(e.$from, t);
}
function U6e(t) {
  return t instanceof ct;
}
function G6e(t) {
  return function(e) {
    if (U6e(e)) {
      const {
        node: n
      } = e, {
        $from: r
      } = e;
      if (H6e(t, n))
        return {
          node: n,
          pos: r.pos,
          depth: r.depth
        };
    }
  };
}
function Y6e(t, e) {
  const {
    from: n,
    to: r
  } = t.selection;
  let s = [];
  t.doc.nodesBetween(n, r, (o) => {
    s = [...s, ...o.marks];
  });
  const i = s.find((o) => o.type.name === e.name);
  return i ? i.attrs : {};
}
function Z6e(t = null, e = null) {
  if (!t || !e)
    return !1;
  const n = t.parent.childAfter(t.parentOffset);
  if (!n.node)
    return !1;
  const r = n.node.marks.find((l) => l.type === e);
  if (!r)
    return !1;
  let s = t.index(), i = t.start() + n.offset, o = s + 1, a = i + n.node.nodeSize;
  for (; s > 0 && r.isInSet(t.parent.child(s - 1).marks); )
    s -= 1, i -= t.parent.child(s).nodeSize;
  for (; o < t.parent.childCount && r.isInSet(t.parent.child(o).marks); )
    a += t.parent.child(o).nodeSize, o += 1;
  return {
    from: i,
    to: a
  };
}
function X6e(t, e) {
  const {
    from: n,
    to: r
  } = t.selection;
  let s = [];
  t.doc.nodesBetween(n, r, (o) => {
    s = [...s, o];
  });
  const i = s.reverse().find((o) => o.type.name === e.name);
  return i ? i.attrs : {};
}
function K6e(t, e) {
  const {
    from: n,
    $from: r,
    to: s,
    empty: i
  } = t.selection;
  return i ? !!e.isInSet(t.storedMarks || r.marks()) : !!t.doc.rangeHasMark(n, s, e);
}
function J6e(t, e, n = {}) {
  const r = (i) => i.type === e, s = G6e(e)(t.selection) || z6e(r)(t.selection);
  return !Object.keys(n).length || !s ? !!s : s.node.hasMarkup(e, {
    ...s.node.attrs,
    ...n
  });
}
var V9 = function(e, n) {
  this.match = e, this.handler = typeof n == "string" ? q6e(n) : n;
};
function q6e(t) {
  return function(e, n, r, s) {
    var i = t;
    if (n[1]) {
      var o = n[0].lastIndexOf(n[1]);
      i += n[0].slice(o + n[1].length), r += o;
      var a = r - s;
      a > 0 && (i = n[0].slice(o - a, o) + i, r = s);
    }
    return e.tr.insertText(i, r, s);
  };
}
function Q6e(t, e) {
  for (var n = t.plugins, r = 0; r < n.length; r++) {
    var s = n[r], i = void 0;
    if (s.spec.isInputRules && (i = s.getState(t))) {
      if (e) {
        for (var o = t.tr, a = i.transform, l = a.steps.length - 1; l >= 0; l--)
          o.step(a.steps[l].invert(a.docs[l]));
        var c = o.doc.resolve(i.from).marks();
        e(o.replaceWith(i.from, i.to, t.schema.text(i.text, c)));
      }
      return !0;
    }
  }
  return !1;
}
function e9e(t) {
  return t.replace(/(?:^\w|[A-Z]|\b\w)/g, (e, n) => n === 0 ? e.toLowerCase() : e.toUpperCase()).replace(/\s+/g, "");
}
class t9e {
  constructor(e, {
    editor: n,
    extension: r,
    parent: s,
    node: i,
    view: o,
    decorations: a,
    getPos: l
  }) {
    this.component = e, this.editor = n, this.extension = r, this.parent = s, this.node = i, this.view = o, this.decorations = a, this.isNode = !!this.node.marks, this.isMark = !this.isNode, this.getPos = this.isMark ? this.getMarkPos : l, this.captureEvents = !0, this.dom = this.createDOM(), this.contentDOM = this.vm.$refs.content;
  }
  createDOM() {
    const e = U.extend(this.component), n = {
      editor: this.editor,
      node: this.node,
      view: this.view,
      getPos: () => this.getPos(),
      decorations: this.decorations,
      selected: !1,
      options: this.extension.options,
      updateAttrs: (r) => this.updateAttrs(r)
    };
    return typeof this.extension.setSelection == "function" && (this.setSelection = this.extension.setSelection), typeof this.extension.update == "function" && (this.update = this.extension.update), this.vm = new e({
      parent: this.parent,
      propsData: n
    }).$mount(), this.vm.$el;
  }
  update(e, n) {
    return e.type !== this.node.type ? !1 : (e === this.node && this.decorations === n || (this.node = e, this.decorations = n, this.updateComponentProps({
      node: e,
      decorations: n
    })), !0);
  }
  updateComponentProps(e) {
    if (!this.vm._props)
      return;
    const n = U.config.silent;
    U.config.silent = !0, Object.entries(e).forEach(([r, s]) => {
      this.vm._props[r] = s;
    }), U.config.silent = n;
  }
  updateAttrs(e) {
    if (!this.view.editable)
      return;
    const {
      state: n
    } = this.view, {
      type: r
    } = this.node, s = this.getPos(), i = {
      ...this.node.attrs,
      ...e
    }, o = this.isMark ? n.tr.removeMark(s.from, s.to, r).addMark(s.from, s.to, r.create(i)) : n.tr.setNodeMarkup(s, null, i);
    this.view.dispatch(o);
  }
  // prevent a full re-render of the vue component on update
  // we'll handle prop updates in `update()`
  ignoreMutation(e) {
    return e.type === "selection" ? !1 : this.contentDOM ? !this.contentDOM.contains(e.target) : !0;
  }
  // disable (almost) all prosemirror event listener for node views
  stopEvent(e) {
    if (typeof this.extension.stopEvent == "function")
      return this.extension.stopEvent(e);
    const n = !!this.extension.schema.draggable;
    if (n && e.type === "mousedown") {
      const a = e.target.closest && e.target.closest("[data-drag-handle]");
      a && (this.dom === a || this.dom.contains(a)) && (this.captureEvents = !1, document.addEventListener("dragend", () => {
        this.captureEvents = !0;
      }, {
        once: !0
      }));
    }
    const r = e.type === "copy", s = e.type === "paste", i = e.type === "cut", o = e.type.startsWith("drag") || e.type === "drop";
    return n && o || r || s || i ? !1 : this.captureEvents;
  }
  selectNode() {
    this.updateComponentProps({
      selected: !0
    });
  }
  deselectNode() {
    this.updateComponentProps({
      selected: !1
    });
  }
  getMarkPos() {
    const e = this.view.posAtDOM(this.dom), n = this.view.state.doc.resolve(e);
    return Z6e(n, this.node.type);
  }
  destroy() {
    this.vm.$destroy();
  }
}
class n9e {
  // Add an event listener for given event
  on(e, n) {
    return this._callbacks = this._callbacks || {}, this._callbacks[e] || (this._callbacks[e] = []), this._callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    this._callbacks = this._callbacks || {};
    const r = this._callbacks[e];
    return r && r.forEach((s) => s.apply(this, n)), this;
  }
  // Remove event listener for given event.
  // If fn is not provided, all event listeners for that event will be removed.
  // If neither is provided, all event listeners will be removed.
  off(e, n) {
    if (!arguments.length)
      this._callbacks = {};
    else {
      const r = this._callbacks ? this._callbacks[e] : null;
      r && (n ? this._callbacks[e] = r.filter((s) => s !== n) : delete this._callbacks[e]);
    }
    return this;
  }
}
class Xi {
  constructor(e = {}) {
    this.options = {
      ...this.defaultOptions,
      ...e
    };
  }
  init() {
    return null;
  }
  bindEditor(e = null) {
    this.editor = e;
  }
  get name() {
    return null;
  }
  get type() {
    return "extension";
  }
  get defaultOptions() {
    return {};
  }
  get plugins() {
    return [];
  }
  inputRules() {
    return [];
  }
  pasteRules() {
    return [];
  }
  keys() {
    return {};
  }
}
class r9e {
  constructor(e = [], n) {
    e.forEach((r) => {
      r.bindEditor(n), r.init();
    }), this.extensions = e;
  }
  get nodes() {
    return this.extensions.filter((e) => e.type === "node").reduce((e, {
      name: n,
      schema: r
    }) => ({
      ...e,
      [n]: r
    }), {});
  }
  get options() {
    const {
      view: e
    } = this;
    return this.extensions.reduce((n, r) => ({
      ...n,
      [r.name]: new Proxy(r.options, {
        set(s, i, o) {
          const a = s[i] !== o;
          return Object.assign(s, {
            [i]: o
          }), a && e.updateState(e.state), !0;
        }
      })
    }), {});
  }
  get marks() {
    return this.extensions.filter((e) => e.type === "mark").reduce((e, {
      name: n,
      schema: r
    }) => ({
      ...e,
      [n]: r
    }), {});
  }
  get plugins() {
    return this.extensions.filter((e) => e.plugins).reduce((e, {
      plugins: n
    }) => [...e, ...n], []);
  }
  keymaps({
    schema: e
  }) {
    const n = this.extensions.filter((s) => ["extension"].includes(s.type)).filter((s) => s.keys).map((s) => s.keys({
      schema: e
    })), r = this.extensions.filter((s) => ["node", "mark"].includes(s.type)).filter((s) => s.keys).map((s) => s.keys({
      type: e[`${s.type}s`][s.name],
      schema: e
    }));
    return [...n, ...r].map((s) => m1(s));
  }
  inputRules({
    schema: e,
    excludedExtensions: n
  }) {
    if (!(n instanceof Array) && n) return [];
    const r = n instanceof Array ? this.extensions.filter((o) => !n.includes(o.name)) : this.extensions, s = r.filter((o) => ["extension"].includes(o.type)).filter((o) => o.inputRules).map((o) => o.inputRules({
      schema: e
    })), i = r.filter((o) => ["node", "mark"].includes(o.type)).filter((o) => o.inputRules).map((o) => o.inputRules({
      type: e[`${o.type}s`][o.name],
      schema: e
    }));
    return [...s, ...i].reduce((o, a) => [...o, ...a], []);
  }
  pasteRules({
    schema: e,
    excludedExtensions: n
  }) {
    if (!(n instanceof Array) && n) return [];
    const r = n instanceof Array ? this.extensions.filter((o) => !n.includes(o.name)) : this.extensions, s = r.filter((o) => ["extension"].includes(o.type)).filter((o) => o.pasteRules).map((o) => o.pasteRules({
      schema: e
    })), i = r.filter((o) => ["node", "mark"].includes(o.type)).filter((o) => o.pasteRules).map((o) => o.pasteRules({
      type: e[`${o.type}s`][o.name],
      schema: e
    }));
    return [...s, ...i].reduce((o, a) => [...o, ...a], []);
  }
  commands({
    schema: e,
    view: n
  }) {
    return this.extensions.filter((r) => r.commands).reduce((r, s) => {
      const {
        name: i,
        type: o
      } = s, a = {}, l = s.commands({
        schema: e,
        ...["node", "mark"].includes(o) ? {
          type: e[`${o}s`][i]
        } : {}
      }), c = (d, f) => n.editable ? (n.focus(), d(f)(n.state, n.dispatch, n)) : !1, u = (d, f) => {
        Array.isArray(f) ? a[d] = (p) => f.forEach((h) => c(h, p)) : typeof f == "function" && (a[d] = (p) => c(f, p));
      };
      return typeof l == "object" ? Object.entries(l).forEach(([d, f]) => {
        u(d, f);
      }) : u(i, l), {
        ...r,
        ...a
      };
    }, {});
  }
}
function s9e(t) {
  if (process.env.NODE_ENV !== "test") {
    const e = document.createElement("style");
    e.type = "text/css", e.textContent = t;
    const {
      head: n
    } = document, {
      firstChild: r
    } = n;
    r ? n.insertBefore(e, r) : n.appendChild(e);
  }
}
function t3(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(parseInt(t, 10), e), n);
}
let Ki = class extends Xi {
  constructor(e = {}) {
    super(e);
  }
  get type() {
    return "node";
  }
  get view() {
    return null;
  }
  get schema() {
    return null;
  }
  command() {
    return () => {
    };
  }
};
class i9e extends Ki {
  get name() {
    return "doc";
  }
  get schema() {
    return {
      content: "block+"
    };
  }
}
class o9e extends Ki {
  get name() {
    return "paragraph";
  }
  get schema() {
    return {
      content: "inline*",
      group: "block",
      draggable: !1,
      parseDOM: [{
        tag: "p"
      }],
      toDOM: () => ["p", 0]
    };
  }
  commands({
    type: e
  }) {
    return () => A6e(e);
  }
}
class a9e extends Ki {
  get name() {
    return "text";
  }
  get schema() {
    return {
      group: "inline"
    };
  }
}
var l9e = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}
`;
class c9e extends n9e {
  constructor(e = {}) {
    super(), this.defaultOptions = {
      editorProps: {},
      editable: !0,
      autoFocus: null,
      extensions: [],
      content: "",
      topNode: "doc",
      emptyDocument: {
        type: "doc",
        content: [{
          type: "paragraph"
        }]
      },
      useBuiltInExtensions: !0,
      disableInputRules: !1,
      disablePasteRules: !1,
      dropCursor: {},
      enableDropCursor: !0,
      enableGapCursor: !0,
      parseOptions: {},
      injectCSS: !0,
      onInit: () => {
      },
      onTransaction: () => {
      },
      onUpdate: () => {
      },
      onFocus: () => {
      },
      onBlur: () => {
      },
      onPaste: () => {
      },
      onDrop: () => {
      }
    }, this.events = ["init", "transaction", "update", "focus", "blur", "paste", "drop"], this.init(e);
  }
  init(e = {}) {
    this.setOptions({
      ...this.defaultOptions,
      ...e
    }), this.focused = !1, this.selection = {
      from: 0,
      to: 0
    }, this.element = document.createElement("div"), this.extensions = this.createExtensions(), this.nodes = this.createNodes(), this.marks = this.createMarks(), this.schema = this.createSchema(), this.plugins = this.createPlugins(), this.keymaps = this.createKeymaps(), this.inputRules = this.createInputRules(), this.pasteRules = this.createPasteRules(), this.view = this.createView(), this.commands = this.createCommands(), this.setActiveNodesAndMarks(), this.options.injectCSS && s9e(l9e), this.options.autoFocus !== null && this.focus(this.options.autoFocus), this.events.forEach((n) => {
      this.on(n, this.options[e9e(`on ${n}`)] || (() => {
      }));
    }), this.emit("init", {
      view: this.view,
      state: this.state
    }), this.extensions.view = this.view;
  }
  setOptions(e) {
    this.options = {
      ...this.options,
      ...e
    }, this.view && this.state && this.view.updateState(this.state);
  }
  get builtInExtensions() {
    return this.options.useBuiltInExtensions ? [new i9e(), new a9e(), new o9e()] : [];
  }
  get state() {
    return this.view ? this.view.state : null;
  }
  createExtensions() {
    return new r9e([...this.builtInExtensions, ...this.options.extensions], this);
  }
  createPlugins() {
    return this.extensions.plugins;
  }
  createKeymaps() {
    return this.extensions.keymaps({
      schema: this.schema
    });
  }
  createInputRules() {
    return this.extensions.inputRules({
      schema: this.schema,
      excludedExtensions: this.options.disableInputRules
    });
  }
  createPasteRules() {
    return this.extensions.pasteRules({
      schema: this.schema,
      excludedExtensions: this.options.disablePasteRules
    });
  }
  createCommands() {
    return this.extensions.commands({
      schema: this.schema,
      view: this.view
    });
  }
  createNodes() {
    return this.extensions.nodes;
  }
  createMarks() {
    return this.extensions.marks;
  }
  createSchema() {
    return new pc({
      topNode: this.options.topNode,
      nodes: this.nodes,
      marks: this.marks
    });
  }
  createState() {
    return gs.create({
      schema: this.schema,
      doc: this.createDocument(this.options.content),
      plugins: [...this.plugins, F6e({
        rules: this.inputRules
      }), ...this.pasteRules, ...this.keymaps, m1({
        Backspace: B6e
      }), m1(M6e), ...this.options.enableDropCursor ? [n6e(this.options.dropCursor)] : [], ...this.options.enableGapCursor ? [f6e()] : [], new lr({
        key: new ci("editable"),
        props: {
          editable: () => this.options.editable
        }
      }), new lr({
        props: {
          attributes: {
            tabindex: 0
          },
          handleDOMEvents: {
            focus: (e, n) => {
              this.focused = !0, this.emit("focus", {
                event: n,
                state: e.state,
                view: e
              });
              const r = this.state.tr.setMeta("focused", !0);
              this.view.dispatch(r);
            },
            blur: (e, n) => {
              this.focused = !1, this.emit("blur", {
                event: n,
                state: e.state,
                view: e
              });
              const r = this.state.tr.setMeta("focused", !1);
              this.view.dispatch(r);
            }
          }
        }
      }), new lr({
        props: this.options.editorProps
      })]
    });
  }
  createDocument(e, n = this.options.parseOptions) {
    if (e === null)
      return this.schema.nodeFromJSON(this.options.emptyDocument);
    if (typeof e == "object")
      try {
        return this.schema.nodeFromJSON(e);
      } catch (r) {
        return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", r), this.schema.nodeFromJSON(this.options.emptyDocument);
      }
    if (typeof e == "string") {
      const r = `<div>${e}</div>`, i = new window.DOMParser().parseFromString(r, "text/html").body.firstElementChild;
      return Wi.fromSchema(this.schema).parse(i, n);
    }
    return !1;
  }
  createView() {
    return new Pr(this.element, {
      state: this.createState(),
      handlePaste: (...e) => {
        this.emit("paste", ...e);
      },
      handleDrop: (...e) => {
        this.emit("drop", ...e);
      },
      dispatchTransaction: this.dispatchTransaction.bind(this)
    });
  }
  setParentComponent(e = null) {
    e && this.view.setProps({
      nodeViews: this.initNodeViews({
        parent: e,
        extensions: [...this.builtInExtensions, ...this.options.extensions]
      })
    });
  }
  initNodeViews({
    parent: e,
    extensions: n
  }) {
    return n.filter((r) => ["node", "mark"].includes(r.type)).filter((r) => r.view).reduce((r, s) => {
      const i = (o, a, l, c) => {
        const u = s.view;
        return new t9e(u, {
          editor: this,
          extension: s,
          parent: e,
          node: o,
          view: a,
          getPos: l,
          decorations: c
        });
      };
      return {
        ...r,
        [s.name]: i
      };
    }, {});
  }
  dispatchTransaction(e) {
    const n = this.state.apply(e);
    this.view.updateState(n), this.selection = {
      from: this.state.selection.from,
      to: this.state.selection.to
    }, this.setActiveNodesAndMarks(), this.emit("transaction", {
      getHTML: this.getHTML.bind(this),
      getJSON: this.getJSON.bind(this),
      state: this.state,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emitUpdate(e);
  }
  emitUpdate(e) {
    this.emit("update", {
      getHTML: this.getHTML.bind(this),
      getJSON: this.getJSON.bind(this),
      state: this.state,
      transaction: e
    });
  }
  resolveSelection(e = null) {
    if (this.selection && e === null)
      return this.selection;
    if (e === "start" || e === !0)
      return {
        from: 0,
        to: 0
      };
    if (e === "end") {
      const {
        doc: n
      } = this.state;
      return {
        from: n.content.size,
        to: n.content.size
      };
    }
    return {
      from: e,
      to: e
    };
  }
  focus(e = null) {
    if (this.view.focused && e === null || e === !1)
      return;
    const {
      from: n,
      to: r
    } = this.resolveSelection(e);
    this.setSelection(n, r), setTimeout(() => this.view.focus(), 10);
  }
  setSelection(e = 0, n = 0) {
    const {
      doc: r,
      tr: s
    } = this.state, i = t3(e, 0, r.content.size), o = t3(n, 0, r.content.size), a = Mt.create(r, i, o), l = s.setSelection(a);
    this.view.dispatch(l);
  }
  blur() {
    this.view.dom.blur();
  }
  getSchemaJSON() {
    return JSON.parse(JSON.stringify({
      nodes: this.extensions.nodes,
      marks: this.extensions.marks
    }));
  }
  getHTML() {
    const e = document.createElement("div"), n = ms.fromSchema(this.schema).serializeFragment(this.state.doc.content);
    return e.appendChild(n), e.innerHTML;
  }
  getJSON() {
    return this.state.doc.toJSON();
  }
  setContent(e = {}, n = !1, r) {
    const {
      doc: s,
      tr: i
    } = this.state, o = this.createDocument(e, r), a = Mt.create(s, 0, s.content.size), l = i.setSelection(a).replaceSelectionWith(o, !1).setMeta("preventUpdate", !n);
    this.view.dispatch(l);
  }
  clearContent(e = !1) {
    this.setContent(this.options.emptyDocument, e);
  }
  setActiveNodesAndMarks() {
    this.activeMarks = Object.entries(this.schema.marks).reduce((e, [n, r]) => ({
      ...e,
      [n]: (s = {}) => K6e(this.state, r)
    }), {}), this.activeMarkAttrs = Object.entries(this.schema.marks).reduce((e, [n, r]) => ({
      ...e,
      [n]: Y6e(this.state, r)
    }), {}), this.activeNodes = Object.entries(this.schema.nodes).reduce((e, [n, r]) => ({
      ...e,
      [n]: (s = {}) => J6e(this.state, r, s)
    }), {});
  }
  getMarkAttrs(e = null) {
    return this.activeMarkAttrs[e];
  }
  getNodeAttrs(e = null) {
    return {
      ...X6e(this.state, this.schema.nodes[e])
    };
  }
  get isActive() {
    return Object.entries({
      ...this.activeMarks,
      ...this.activeNodes
    }).reduce((e, [n, r]) => ({
      ...e,
      [n]: (s = {}) => r(s)
    }), {});
  }
  registerPlugin(e = null, n) {
    const r = typeof n == "function" ? n(e, this.state.plugins) : [e, ...this.state.plugins], s = this.state.reconfigure({
      plugins: r
    });
    this.view.updateState(s);
  }
  unregisterPlugin(e = null) {
    if (!e || !this.view.docView)
      return;
    const n = this.state.reconfigure({
      plugins: this.state.plugins.filter((r) => !r.key.startsWith(`${e}$`))
    });
    this.view.updateState(n);
  }
  destroy() {
    this.view && this.view.destroy();
  }
}
var u9e = {
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  watch: {
    editor: {
      immediate: !0,
      handler(t) {
        t && t.element && this.$nextTick(() => {
          this.$el.appendChild(t.element.firstChild), t.setParentComponent(this);
        });
      }
    }
  },
  render(t) {
    return t("div");
  },
  beforeDestroy() {
    this.editor.element = this.$el;
  }
};
class d9e {
  constructor({
    options: e,
    editorView: n
  }) {
    this.options = {
      resizeObserver: !0,
      element: null,
      onUpdate: () => !1,
      ...e
    }, this.preventHide = !1, this.editorView = n, this.isActive = !1, this.top = 0, this.mousedownHandler = this.handleClick.bind(this), this.options.element.addEventListener("mousedown", this.mousedownHandler, {
      capture: !0
    }), this.focusHandler = ({
      view: r
    }) => {
      this.update(r);
    }, this.options.editor.on("focus", this.focusHandler), this.blurHandler = ({
      event: r
    }) => {
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      this.hide(r);
    }, this.options.editor.on("blur", this.blurHandler), this.options.resizeObserver && window.ResizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.isActive && this.update(this.editorView);
    }), this.resizeObserver.observe(this.editorView.dom));
  }
  handleClick() {
    this.preventHide = !0;
  }
  update(e, n) {
    const {
      state: r
    } = e;
    if (n && n.doc.eq(r.doc) && n.selection.eq(r.selection))
      return;
    if (!r.selection.empty) {
      this.hide();
      return;
    }
    const s = e.domAtPos(r.selection.anchor);
    if (!(s.node.innerHTML === "<br>" && s.node.tagName === "P" && s.node.parentNode === e.dom)) {
      this.hide();
      return;
    }
    const o = this.options.element.offsetParent;
    if (!o) {
      this.hide();
      return;
    }
    const a = o.getBoundingClientRect(), c = e.coordsAtPos(r.selection.anchor).top - a.top;
    this.isActive = !0, this.top = c, this.sendUpdate();
  }
  sendUpdate() {
    this.options.onUpdate({
      isActive: this.isActive,
      top: this.top
    });
  }
  hide(e) {
    e && e.relatedTarget && this.options.element.parentNode && this.options.element.parentNode.contains(e.relatedTarget) || (this.isActive = !1, this.sendUpdate());
  }
  destroy() {
    this.options.element.removeEventListener("mousedown", this.mousedownHandler), this.resizeObserver && this.resizeObserver.unobserve(this.editorView.dom), this.options.editor.off("focus", this.focusHandler), this.options.editor.off("blur", this.blurHandler);
  }
}
function f9e(t) {
  return new lr({
    key: new ci("floating_menu"),
    view(e) {
      return new d9e({
        editorView: e,
        options: t
      });
    }
  });
}
var p9e = {
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      menu: {
        isActive: !1,
        left: 0,
        bottom: 0
      }
    };
  },
  watch: {
    editor: {
      immediate: !0,
      handler(t) {
        t && this.$nextTick(() => {
          t.registerPlugin(f9e({
            editor: t,
            element: this.$el,
            onUpdate: (e) => {
              e.isActive && this.menu.isActive === !1 ? this.$emit("show", e) : !e.isActive && this.menu.isActive === !0 && this.$emit("hide", e), this.menu = e;
            }
          }));
        });
      }
    }
  },
  render() {
    return this.editor ? this.$scopedSlots.default({
      focused: this.editor.view.focused,
      focus: this.editor.focus,
      commands: this.editor.commands,
      isActive: this.editor.isActive,
      getMarkAttrs: this.editor.getMarkAttrs.bind(this.editor),
      getNodeAttrs: this.editor.getNodeAttrs.bind(this.editor),
      menu: this.menu
    }) : null;
  },
  beforeDestroy() {
    this.editor.unregisterPlugin("floating_menu");
  }
};
function mI(t) {
  return t instanceof Map ? t.clear = t.delete = t.set = function() {
    throw new Error("map is read-only");
  } : t instanceof Set && (t.add = t.clear = t.delete = function() {
    throw new Error("set is read-only");
  }), Object.freeze(t), Object.getOwnPropertyNames(t).forEach(function(e) {
    var n = t[e];
    typeof n == "object" && !Object.isFrozen(n) && mI(n);
  }), t;
}
var z9 = mI, h9e = mI;
z9.default = h9e;
class n3 {
  /**
   * @param {CompiledMode} mode
   */
  constructor(e) {
    e.data === void 0 && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function qc(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function Ca(t, ...e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r in t)
    n[r] = t[r];
  return e.forEach(function(r) {
    for (const s in r)
      n[s] = r[s];
  }), /** @type {T} */
  n;
}
const m9e = "</span>", r3 = (t) => !!t.kind;
class v9e {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(e, n) {
    this.buffer = "", this.classPrefix = n.classPrefix, e.walk(this);
  }
  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(e) {
    this.buffer += qc(e);
  }
  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(e) {
    if (!r3(e)) return;
    let n = e.kind;
    e.sublanguage || (n = `${this.classPrefix}${n}`), this.span(n);
  }
  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(e) {
    r3(e) && (this.buffer += m9e);
  }
  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }
  // helpers
  /**
   * Builds a span element
   *
   * @param {string} className */
  span(e) {
    this.buffer += `<span class="${e}">`;
  }
}
class vI {
  constructor() {
    this.rootNode = { children: [] }, this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  /** @param {Node} node */
  add(e) {
    this.top.children.push(e);
  }
  /** @param {string} kind */
  openNode(e) {
    const n = { kind: e, children: [] };
    this.add(n), this.stack.push(n);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); ) ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(e) {
    return this.constructor._walk(e, this.rootNode);
  }
  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(e, n) {
    return typeof n == "string" ? e.addText(n) : n.children && (e.openNode(n), n.children.forEach((r) => this._walk(e, r)), e.closeNode(n)), e;
  }
  /**
   * @param {Node} node
   */
  static _collapse(e) {
    typeof e != "string" && e.children && (e.children.every((n) => typeof n == "string") ? e.children = [e.children.join("")] : e.children.forEach((n) => {
      vI._collapse(n);
    }));
  }
}
class g9e extends vI {
  /**
   * @param {*} options
   */
  constructor(e) {
    super(), this.options = e;
  }
  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(e, n) {
    e !== "" && (this.openNode(n), this.addText(e), this.closeNode());
  }
  /**
   * @param {string} text
   */
  addText(e) {
    e !== "" && this.add(e);
  }
  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(e, n) {
    const r = e.root;
    r.kind = n, r.sublanguage = !0, this.add(r);
  }
  toHTML() {
    return new v9e(this, this.options).value();
  }
  finalize() {
    return !0;
  }
}
function y9e(t) {
  return new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
}
function yf(t) {
  return t ? typeof t == "string" ? t : t.source : null;
}
function b9e(...t) {
  return t.map((n) => yf(n)).join("");
}
function _9e(...t) {
  return "(" + t.map((n) => yf(n)).join("|") + ")";
}
function w9e(t) {
  return new RegExp(t.toString() + "|").exec("").length - 1;
}
function S9e(t, e) {
  const n = t && t.exec(e);
  return n && n.index === 0;
}
const I9e = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function E9e(t, e = "|") {
  let n = 0;
  return t.map((r) => {
    n += 1;
    const s = n;
    let i = yf(r), o = "";
    for (; i.length > 0; ) {
      const a = I9e.exec(i);
      if (!a) {
        o += i;
        break;
      }
      o += i.substring(0, a.index), i = i.substring(a.index + a[0].length), a[0][0] === "\\" && a[1] ? o += "\\" + String(Number(a[1]) + s) : (o += a[0], a[0] === "(" && n++);
    }
    return o;
  }).map((r) => `(${r})`).join(e);
}
const x9e = /\b\B/, U9 = "[a-zA-Z]\\w*", gI = "[a-zA-Z_]\\w*", yI = "\\b\\d+(\\.\\d+)?", G9 = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Y9 = "\\b(0b[01]+)", C9e = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", T9e = (t = {}) => {
  const e = /^#![ ]*\//;
  return t.binary && (t.begin = b9e(
    e,
    /.*\b/,
    t.binary,
    /\b.*/
  )), Ca({
    className: "meta",
    begin: e,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (n, r) => {
      n.index !== 0 && r.ignoreMatch();
    }
  }, t);
}, bf = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, P9e = {
  className: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [bf]
}, k9e = {
  className: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [bf]
}, Z9 = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
}, cg = function(t, e, n = {}) {
  const r = Ca(
    {
      className: "comment",
      begin: t,
      end: e,
      contains: []
    },
    n
  );
  return r.contains.push(Z9), r.contains.push({
    className: "doctag",
    begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
    relevance: 0
  }), r;
}, N9e = cg("//", "$"), $9e = cg("/\\*", "\\*/"), D9e = cg("#", "$"), A9e = {
  className: "number",
  begin: yI,
  relevance: 0
}, O9e = {
  className: "number",
  begin: G9,
  relevance: 0
}, M9e = {
  className: "number",
  begin: Y9,
  relevance: 0
}, R9e = {
  className: "number",
  begin: yI + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
  relevance: 0
}, L9e = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: "regexp",
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      bf,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [bf]
      }
    ]
  }]
}, F9e = {
  className: "title",
  begin: U9,
  relevance: 0
}, B9e = {
  className: "title",
  begin: gI,
  relevance: 0
}, j9e = {
  // excludes method names from keyword processing
  begin: "\\.\\s*" + gI,
  relevance: 0
}, W9e = function(t) {
  return Object.assign(
    t,
    {
      /** @type {ModeCallback} */
      "on:begin": (e, n) => {
        n.data._beginMatch = e[1];
      },
      /** @type {ModeCallback} */
      "on:end": (e, n) => {
        n.data._beginMatch !== e[1] && n.ignoreMatch();
      }
    }
  );
};
var Op = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MATCH_NOTHING_RE: x9e,
  IDENT_RE: U9,
  UNDERSCORE_IDENT_RE: gI,
  NUMBER_RE: yI,
  C_NUMBER_RE: G9,
  BINARY_NUMBER_RE: Y9,
  RE_STARTERS_RE: C9e,
  SHEBANG: T9e,
  BACKSLASH_ESCAPE: bf,
  APOS_STRING_MODE: P9e,
  QUOTE_STRING_MODE: k9e,
  PHRASAL_WORDS_MODE: Z9,
  COMMENT: cg,
  C_LINE_COMMENT_MODE: N9e,
  C_BLOCK_COMMENT_MODE: $9e,
  HASH_COMMENT_MODE: D9e,
  NUMBER_MODE: A9e,
  C_NUMBER_MODE: O9e,
  BINARY_NUMBER_MODE: M9e,
  CSS_NUMBER_MODE: R9e,
  REGEXP_MODE: L9e,
  TITLE_MODE: F9e,
  UNDERSCORE_TITLE_MODE: B9e,
  METHOD_GUARD: j9e,
  END_SAME_AS_BEGIN: W9e
});
function H9e(t, e) {
  t.input[t.index - 1] === "." && e.ignoreMatch();
}
function V9e(t, e) {
  e && t.beginKeywords && (t.begin = "\\b(" + t.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", t.__beforeBegin = H9e, t.keywords = t.keywords || t.beginKeywords, delete t.beginKeywords, t.relevance === void 0 && (t.relevance = 0));
}
function z9e(t, e) {
  Array.isArray(t.illegal) && (t.illegal = _9e(...t.illegal));
}
function U9e(t, e) {
  if (t.match) {
    if (t.begin || t.end) throw new Error("begin & end are not supported with match");
    t.begin = t.match, delete t.match;
  }
}
function G9e(t, e) {
  t.relevance === void 0 && (t.relevance = 1);
}
const Y9e = [
  "of",
  "and",
  "for",
  "in",
  "not",
  "or",
  "if",
  "then",
  "parent",
  // common variable name
  "list",
  // common variable name
  "value"
  // common variable name
], Z9e = "keyword";
function X9(t, e, n = Z9e) {
  const r = {};
  return typeof t == "string" ? s(n, t.split(" ")) : Array.isArray(t) ? s(n, t) : Object.keys(t).forEach(function(i) {
    Object.assign(
      r,
      X9(t[i], e, i)
    );
  }), r;
  function s(i, o) {
    e && (o = o.map((a) => a.toLowerCase())), o.forEach(function(a) {
      const l = a.split("|");
      r[l[0]] = [i, X9e(l[0], l[1])];
    });
  }
}
function X9e(t, e) {
  return e ? Number(e) : K9e(t) ? 0 : 1;
}
function K9e(t) {
  return Y9e.includes(t.toLowerCase());
}
function J9e(t, { plugins: e }) {
  function n(a, l) {
    return new RegExp(
      yf(a),
      "m" + (t.case_insensitive ? "i" : "") + (l ? "g" : "")
    );
  }
  class r {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    // @ts-ignore
    addRule(l, c) {
      c.position = this.position++, this.matchIndexes[this.matchAt] = c, this.regexes.push([c, l]), this.matchAt += w9e(l) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const l = this.regexes.map((c) => c[1]);
      this.matcherRe = n(E9e(l), !0), this.lastIndex = 0;
    }
    /** @param {string} s */
    exec(l) {
      this.matcherRe.lastIndex = this.lastIndex;
      const c = this.matcherRe.exec(l);
      if (!c)
        return null;
      const u = c.findIndex((f, p) => p > 0 && f !== void 0), d = this.matchIndexes[u];
      return c.splice(0, u), Object.assign(c, d);
    }
  }
  class s {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    // @ts-ignore
    getMatcher(l) {
      if (this.multiRegexes[l]) return this.multiRegexes[l];
      const c = new r();
      return this.rules.slice(l).forEach(([u, d]) => c.addRule(u, d)), c.compile(), this.multiRegexes[l] = c, c;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    // @ts-ignore
    addRule(l, c) {
      this.rules.push([l, c]), c.type === "begin" && this.count++;
    }
    /** @param {string} s */
    exec(l) {
      const c = this.getMatcher(this.regexIndex);
      c.lastIndex = this.lastIndex;
      let u = c.exec(l);
      if (this.resumingScanAtSamePosition() && !(u && u.index === this.lastIndex)) {
        const d = this.getMatcher(0);
        d.lastIndex = this.lastIndex + 1, u = d.exec(l);
      }
      return u && (this.regexIndex += u.position + 1, this.regexIndex === this.count && this.considerAll()), u;
    }
  }
  function i(a) {
    const l = new s();
    return a.contains.forEach((c) => l.addRule(c.begin, { rule: c, type: "begin" })), a.terminatorEnd && l.addRule(a.terminatorEnd, { type: "end" }), a.illegal && l.addRule(a.illegal, { type: "illegal" }), l;
  }
  function o(a, l) {
    const c = (
      /** @type CompiledMode */
      a
    );
    if (a.isCompiled) return c;
    [
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      U9e
    ].forEach((d) => d(a, l)), t.compilerExtensions.forEach((d) => d(a, l)), a.__beforeBegin = null, [
      V9e,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      z9e,
      // default to 1 relevance if not specified
      G9e
    ].forEach((d) => d(a, l)), a.isCompiled = !0;
    let u = null;
    if (typeof a.keywords == "object" && (u = a.keywords.$pattern, delete a.keywords.$pattern), a.keywords && (a.keywords = X9(a.keywords, t.case_insensitive)), a.lexemes && u)
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    return u = u || a.lexemes || /\w+/, c.keywordPatternRe = n(u, !0), l && (a.begin || (a.begin = /\B|\b/), c.beginRe = n(a.begin), a.endSameAsBegin && (a.end = a.begin), !a.end && !a.endsWithParent && (a.end = /\B|\b/), a.end && (c.endRe = n(a.end)), c.terminatorEnd = yf(a.end) || "", a.endsWithParent && l.terminatorEnd && (c.terminatorEnd += (a.end ? "|" : "") + l.terminatorEnd)), a.illegal && (c.illegalRe = n(
      /** @type {RegExp | string} */
      a.illegal
    )), a.contains || (a.contains = []), a.contains = [].concat(...a.contains.map(function(d) {
      return q9e(d === "self" ? a : d);
    })), a.contains.forEach(function(d) {
      o(
        /** @type Mode */
        d,
        c
      );
    }), a.starts && o(a.starts, l), c.matcher = i(c), c;
  }
  if (t.compilerExtensions || (t.compilerExtensions = []), t.contains && t.contains.includes("self"))
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return t.classNameAliases = Ca(t.classNameAliases || {}), o(
    /** @type Mode */
    t
  );
}
function K9(t) {
  return t ? t.endsWithParent || K9(t.starts) : !1;
}
function q9e(t) {
  return t.variants && !t.cachedVariants && (t.cachedVariants = t.variants.map(function(e) {
    return Ca(t, { variants: null }, e);
  })), t.cachedVariants ? t.cachedVariants : K9(t) ? Ca(t, { starts: t.starts ? Ca(t.starts) : null }) : Object.isFrozen(t) ? Ca(t) : t;
}
var Q9e = "10.7.3";
function e8e(t) {
  return !!(t || t === "");
}
function t8e(t) {
  const e = {
    props: ["language", "code", "autodetect"],
    data: function() {
      return {
        detectedLanguage: "",
        unknownLanguage: !1
      };
    },
    computed: {
      className() {
        return this.unknownLanguage ? "" : "hljs " + this.detectedLanguage;
      },
      highlighted() {
        if (!this.autoDetect && !t.getLanguage(this.language))
          return console.warn(`The language "${this.language}" you specified could not be found.`), this.unknownLanguage = !0, qc(this.code);
        let r = {};
        return this.autoDetect ? (r = t.highlightAuto(this.code), this.detectedLanguage = r.language) : (r = t.highlight(this.language, this.code, this.ignoreIllegals), this.detectedLanguage = this.language), r.value;
      },
      autoDetect() {
        return !this.language || e8e(this.autodetect);
      },
      ignoreIllegals() {
        return !0;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render(r) {
      return r("pre", {}, [
        r("code", {
          class: this.className,
          domProps: { innerHTML: this.highlighted }
        })
      ]);
    }
    // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };
  return { Component: e, VuePlugin: {
    install(r) {
      r.component("highlightjs", e);
    }
  } };
}
const n8e = {
  "after:highlightElement": ({ el: t, result: e, text: n }) => {
    const r = s3(t);
    if (!r.length) return;
    const s = document.createElement("div");
    s.innerHTML = e.value, e.value = r8e(r, s3(s), n);
  }
};
function v1(t) {
  return t.nodeName.toLowerCase();
}
function s3(t) {
  const e = [];
  return function n(r, s) {
    for (let i = r.firstChild; i; i = i.nextSibling)
      i.nodeType === 3 ? s += i.nodeValue.length : i.nodeType === 1 && (e.push({
        event: "start",
        offset: s,
        node: i
      }), s = n(i, s), v1(i).match(/br|hr|img|input/) || e.push({
        event: "stop",
        offset: s,
        node: i
      }));
    return s;
  }(t, 0), e;
}
function r8e(t, e, n) {
  let r = 0, s = "";
  const i = [];
  function o() {
    return !t.length || !e.length ? t.length ? t : e : t[0].offset !== e[0].offset ? t[0].offset < e[0].offset ? t : e : e[0].event === "start" ? t : e;
  }
  function a(u) {
    function d(f) {
      return " " + f.nodeName + '="' + qc(f.value) + '"';
    }
    s += "<" + v1(u) + [].map.call(u.attributes, d).join("") + ">";
  }
  function l(u) {
    s += "</" + v1(u) + ">";
  }
  function c(u) {
    (u.event === "start" ? a : l)(u.node);
  }
  for (; t.length || e.length; ) {
    let u = o();
    if (s += qc(n.substring(r, u[0].offset)), r = u[0].offset, u === t) {
      i.reverse().forEach(l);
      do
        c(u.splice(0, 1)[0]), u = o();
      while (u === t && u.length && u[0].offset === r);
      i.reverse().forEach(a);
    } else
      u[0].event === "start" ? i.push(u[0].node) : i.pop(), c(u.splice(0, 1)[0]);
  }
  return s + qc(n.substr(r));
}
const i3 = {}, fb = (t) => {
  console.error(t);
}, o3 = (t, ...e) => {
  console.log(`WARN: ${t}`, ...e);
}, pi = (t, e) => {
  i3[`${t}/${e}`] || (console.log(`Deprecated as of ${t}. ${e}`), i3[`${t}/${e}`] = !0);
}, pb = qc, a3 = Ca, l3 = Symbol("nomatch"), s8e = function(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), r = [];
  let s = !0;
  const i = /(^(<[^>]+>|\t|)+|\n)/gm, o = "Could not find the language '{}', did you forget to load/include a language module?", a = { disableAutodetect: !0, name: "Plain text", contains: [] };
  let l = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    tabReplace: null,
    useBR: !1,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: g9e
  };
  function c(O) {
    return l.noHighlightRe.test(O);
  }
  function u(O) {
    let K = O.className + " ";
    K += O.parentNode ? O.parentNode.className : "";
    const z = l.languageDetectRe.exec(K);
    if (z) {
      const q = Y(z[1]);
      return q || (o3(o.replace("{}", z[1])), o3("Falling back to no-highlight mode for this block.", O)), q ? z[1] : "no-highlight";
    }
    return K.split(/\s+/).find((q) => c(q) || Y(q));
  }
  function d(O, K, z, q) {
    let ae = "", Ee = "";
    typeof K == "object" ? (ae = O, z = K.ignoreIllegals, Ee = K.language, q = void 0) : (pi("10.7.0", "highlight(lang, code, ...args) has been deprecated."), pi("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), Ee = O, ae = K);
    const Ae = {
      code: ae,
      language: Ee
    };
    se("before:highlight", Ae);
    const Ue = Ae.result ? Ae.result : f(Ae.language, Ae.code, z, q);
    return Ue.code = Ae.code, se("after:highlight", Ue), Ue;
  }
  function f(O, K, z, q) {
    function ae(Ve, Ze) {
      const it = zn.case_insensitive ? Ze[0].toLowerCase() : Ze[0];
      return Object.prototype.hasOwnProperty.call(Ve.keywords, it) && Ve.keywords[it];
    }
    function Ee() {
      if (!dt.keywords) {
        Wt.addText(Tt);
        return;
      }
      let Ve = 0;
      dt.keywordPatternRe.lastIndex = 0;
      let Ze = dt.keywordPatternRe.exec(Tt), it = "";
      for (; Ze; ) {
        it += Tt.substring(Ve, Ze.index);
        const St = ae(dt, Ze);
        if (St) {
          const [ze, $t] = St;
          if (Wt.addText(it), it = "", _r += $t, ze.startsWith("_"))
            it += Ze[0];
          else {
            const Fs = zn.classNameAliases[ze] || ze;
            Wt.addKeyword(Ze[0], Fs);
          }
        } else
          it += Ze[0];
        Ve = dt.keywordPatternRe.lastIndex, Ze = dt.keywordPatternRe.exec(Tt);
      }
      it += Tt.substr(Ve), Wt.addText(it);
    }
    function Ae() {
      if (Tt === "") return;
      let Ve = null;
      if (typeof dt.subLanguage == "string") {
        if (!e[dt.subLanguage]) {
          Wt.addText(Tt);
          return;
        }
        Ve = f(dt.subLanguage, Tt, !0, xt[dt.subLanguage]), xt[dt.subLanguage] = /** @type {CompiledMode} */
        Ve.top;
      } else
        Ve = h(Tt, dt.subLanguage.length ? dt.subLanguage : null);
      dt.relevance > 0 && (_r += Ve.relevance), Wt.addSublanguage(Ve.emitter, Ve.language);
    }
    function Ue() {
      dt.subLanguage != null ? Ae() : Ee(), Tt = "";
    }
    function qe(Ve) {
      return Ve.className && Wt.openNode(zn.classNameAliases[Ve.className] || Ve.className), dt = Object.create(Ve, { parent: { value: dt } }), dt;
    }
    function Qe(Ve, Ze, it) {
      let St = S9e(Ve.endRe, it);
      if (St) {
        if (Ve["on:end"]) {
          const ze = new n3(Ve);
          Ve["on:end"](Ze, ze), ze.isMatchIgnored && (St = !1);
        }
        if (St) {
          for (; Ve.endsParent && Ve.parent; )
            Ve = Ve.parent;
          return Ve;
        }
      }
      if (Ve.endsWithParent)
        return Qe(Ve.parent, Ze, it);
    }
    function Lt(Ve) {
      return dt.matcher.regexIndex === 0 ? (Tt += Ve[0], 1) : (yn = !0, 0);
    }
    function Yt(Ve) {
      const Ze = Ve[0], it = Ve.rule, St = new n3(it), ze = [it.__beforeBegin, it["on:begin"]];
      for (const $t of ze)
        if ($t && ($t(Ve, St), St.isMatchIgnored))
          return Lt(Ze);
      return it && it.endSameAsBegin && (it.endRe = y9e(Ze)), it.skip ? Tt += Ze : (it.excludeBegin && (Tt += Ze), Ue(), !it.returnBegin && !it.excludeBegin && (Tt = Ze)), qe(it), it.returnBegin ? 0 : Ze.length;
    }
    function nn(Ve) {
      const Ze = Ve[0], it = K.substr(Ve.index), St = Qe(dt, Ve, it);
      if (!St)
        return l3;
      const ze = dt;
      ze.skip ? Tt += Ze : (ze.returnEnd || ze.excludeEnd || (Tt += Ze), Ue(), ze.excludeEnd && (Tt = Ze));
      do
        dt.className && Wt.closeNode(), !dt.skip && !dt.subLanguage && (_r += dt.relevance), dt = dt.parent;
      while (dt !== St.parent);
      return St.starts && (St.endSameAsBegin && (St.starts.endRe = St.endRe), qe(St.starts)), ze.returnEnd ? 0 : Ze.length;
    }
    function qt() {
      const Ve = [];
      for (let Ze = dt; Ze !== zn; Ze = Ze.parent)
        Ze.className && Ve.unshift(Ze.className);
      Ve.forEach((Ze) => Wt.openNode(Ze));
    }
    let rn = {};
    function sn(Ve, Ze) {
      const it = Ze && Ze[0];
      if (Tt += Ve, it == null)
        return Ue(), 0;
      if (rn.type === "begin" && Ze.type === "end" && rn.index === Ze.index && it === "") {
        if (Tt += K.slice(Ze.index, Ze.index + 1), !s) {
          const St = new Error("0 width match regex");
          throw St.languageName = O, St.badRule = rn.rule, St;
        }
        return 1;
      }
      if (rn = Ze, Ze.type === "begin")
        return Yt(Ze);
      if (Ze.type === "illegal" && !z) {
        const St = new Error('Illegal lexeme "' + it + '" for mode "' + (dt.className || "<unnamed>") + '"');
        throw St.mode = dt, St;
      } else if (Ze.type === "end") {
        const St = nn(Ze);
        if (St !== l3)
          return St;
      }
      if (Ze.type === "illegal" && it === "")
        return 1;
      if (qn > 1e5 && qn > Ze.index * 3)
        throw new Error("potential infinite loop, way more iterations than matches");
      return Tt += it, it.length;
    }
    const zn = Y(O);
    if (!zn)
      throw fb(o.replace("{}", O)), new Error('Unknown language: "' + O + '"');
    const ns = J9e(zn, { plugins: r });
    let Nt = "", dt = q || ns;
    const xt = {}, Wt = new l.__emitter(l);
    qt();
    let Tt = "", _r = 0, dr = 0, qn = 0, yn = !1;
    try {
      for (dt.matcher.considerAll(); ; ) {
        qn++, yn ? yn = !1 : dt.matcher.considerAll(), dt.matcher.lastIndex = dr;
        const Ve = dt.matcher.exec(K);
        if (!Ve) break;
        const Ze = K.substring(dr, Ve.index), it = sn(Ze, Ve);
        dr = Ve.index + it;
      }
      return sn(K.substr(dr)), Wt.closeAllNodes(), Wt.finalize(), Nt = Wt.toHTML(), {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(_r),
        value: Nt,
        language: O,
        illegal: !1,
        emitter: Wt,
        top: dt
      };
    } catch (Ve) {
      if (Ve.message && Ve.message.includes("Illegal"))
        return {
          illegal: !0,
          illegalBy: {
            msg: Ve.message,
            context: K.slice(dr - 100, dr + 100),
            mode: Ve.mode
          },
          sofar: Nt,
          relevance: 0,
          value: pb(K),
          emitter: Wt
        };
      if (s)
        return {
          illegal: !1,
          relevance: 0,
          value: pb(K),
          emitter: Wt,
          language: O,
          top: dt,
          errorRaised: Ve
        };
      throw Ve;
    }
  }
  function p(O) {
    const K = {
      relevance: 0,
      emitter: new l.__emitter(l),
      value: pb(O),
      illegal: !1,
      top: a
    };
    return K.emitter.addText(O), K;
  }
  function h(O, K) {
    K = K || l.languages || Object.keys(e);
    const z = p(O), q = K.filter(Y).filter(A).map(
      (qe) => f(qe, O, !1)
    );
    q.unshift(z);
    const ae = q.sort((qe, Qe) => {
      if (qe.relevance !== Qe.relevance) return Qe.relevance - qe.relevance;
      if (qe.language && Qe.language) {
        if (Y(qe.language).supersetOf === Qe.language)
          return 1;
        if (Y(Qe.language).supersetOf === qe.language)
          return -1;
      }
      return 0;
    }), [Ee, Ae] = ae, Ue = Ee;
    return Ue.second_best = Ae, Ue;
  }
  function m(O) {
    return l.tabReplace || l.useBR ? O.replace(i, (K) => K === `
` ? l.useBR ? "<br>" : K : l.tabReplace ? K.replace(/\t/g, l.tabReplace) : K) : O;
  }
  function v(O, K, z) {
    const q = K ? n[K] : z;
    O.classList.add("hljs"), q && O.classList.add(q);
  }
  const y = {
    "before:highlightElement": ({ el: O }) => {
      l.useBR && (O.innerHTML = O.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, `
`));
    },
    "after:highlightElement": ({ result: O }) => {
      l.useBR && (O.value = O.value.replace(/\n/g, "<br>"));
    }
  }, _ = /^(<[^>]+>|\t)+/gm, w = {
    "after:highlightElement": ({ result: O }) => {
      l.tabReplace && (O.value = O.value.replace(
        _,
        (K) => K.replace(/\t/g, l.tabReplace)
      ));
    }
  };
  function S(O) {
    let K = null;
    const z = u(O);
    if (c(z)) return;
    se(
      "before:highlightElement",
      { el: O, language: z }
    ), K = O;
    const q = K.textContent, ae = z ? d(q, { language: z, ignoreIllegals: !0 }) : h(q);
    se("after:highlightElement", { el: O, result: ae, text: q }), O.innerHTML = ae.value, v(O, z, ae.language), O.result = {
      language: ae.language,
      // TODO: remove with version 11.0
      re: ae.relevance,
      relavance: ae.relevance
    }, ae.second_best && (O.second_best = {
      language: ae.second_best.language,
      // TODO: remove with version 11.0
      re: ae.second_best.relevance,
      relavance: ae.second_best.relevance
    });
  }
  function E(O) {
    O.useBR && (pi("10.3.0", "'useBR' will be removed entirely in v11.0"), pi("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559")), l = a3(l, O);
  }
  const x = () => {
    if (x.called) return;
    x.called = !0, pi("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead."), document.querySelectorAll("pre code").forEach(S);
  };
  function T() {
    pi("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead."), C = !0;
  }
  let C = !1;
  function k() {
    if (document.readyState === "loading") {
      C = !0;
      return;
    }
    document.querySelectorAll("pre code").forEach(S);
  }
  function b() {
    C && k();
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", b, !1);
  function P(O, K) {
    let z = null;
    try {
      z = K(t);
    } catch (q) {
      if (fb("Language definition for '{}' could not be registered.".replace("{}", O)), s)
        fb(q);
      else
        throw q;
      z = a;
    }
    z.name || (z.name = O), e[O] = z, z.rawDefinition = K.bind(null, t), z.aliases && te(z.aliases, { languageName: O });
  }
  function N(O) {
    delete e[O];
    for (const K of Object.keys(n))
      n[K] === O && delete n[K];
  }
  function D() {
    return Object.keys(e);
  }
  function H(O) {
    pi("10.4.0", "requireLanguage will be removed entirely in v11."), pi("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
    const K = Y(O);
    if (K)
      return K;
    throw new Error("The '{}' language is required, but not loaded.".replace("{}", O));
  }
  function Y(O) {
    return O = (O || "").toLowerCase(), e[O] || e[n[O]];
  }
  function te(O, { languageName: K }) {
    typeof O == "string" && (O = [O]), O.forEach((z) => {
      n[z.toLowerCase()] = K;
    });
  }
  function A(O) {
    const K = Y(O);
    return K && !K.disableAutodetect;
  }
  function j(O) {
    O["before:highlightBlock"] && !O["before:highlightElement"] && (O["before:highlightElement"] = (K) => {
      O["before:highlightBlock"](
        Object.assign({ block: K.el }, K)
      );
    }), O["after:highlightBlock"] && !O["after:highlightElement"] && (O["after:highlightElement"] = (K) => {
      O["after:highlightBlock"](
        Object.assign({ block: K.el }, K)
      );
    });
  }
  function L(O) {
    j(O), r.push(O);
  }
  function se(O, K) {
    const z = O;
    r.forEach(function(q) {
      q[z] && q[z](K);
    });
  }
  function V(O) {
    return pi("10.2.0", "fixMarkup will be removed entirely in v11.0"), pi("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534"), m(O);
  }
  function ee(O) {
    return pi("10.7.0", "highlightBlock will be removed entirely in v12.0"), pi("10.7.0", "Please use highlightElement now."), S(O);
  }
  Object.assign(t, {
    highlight: d,
    highlightAuto: h,
    highlightAll: k,
    fixMarkup: V,
    highlightElement: S,
    // TODO: Remove with v12 API
    highlightBlock: ee,
    configure: E,
    initHighlighting: x,
    initHighlightingOnLoad: T,
    registerLanguage: P,
    unregisterLanguage: N,
    listLanguages: D,
    getLanguage: Y,
    registerAliases: te,
    requireLanguage: H,
    autoDetection: A,
    inherit: a3,
    addPlugin: L,
    // plugins for frameworks
    vuePlugin: t8e(t).VuePlugin
  }), t.debugMode = function() {
    s = !1;
  }, t.safeMode = function() {
    s = !0;
  }, t.versionString = Q9e;
  for (const O in Op)
    typeof Op[O] == "object" && z9(Op[O]);
  return Object.assign(t, Op), t.addPlugin(y), t.addPlugin(n8e), t.addPlugin(w), t;
};
s8e({});
var J9 = { exports: {} };
(function(t) {
  (function() {
    var e;
    e = t.exports = s, e.format = s, e.vsprintf = r, typeof console < "u" && typeof console.log == "function" && (e.printf = n);
    function n() {
      console.log(s.apply(null, arguments));
    }
    function r(i, o) {
      return s.apply(null, [i].concat(o));
    }
    function s(i) {
      for (var o = 1, a = [].slice.call(arguments), l = 0, c = i.length, u = "", d, f = !1, p, h, m = !1, v, y = function() {
        return a[o++];
      }, _ = function() {
        for (var w = ""; /\d/.test(i[l]); )
          w += i[l++], d = i[l];
        return w.length > 0 ? parseInt(w) : null;
      }; l < c; ++l)
        if (d = i[l], f)
          switch (f = !1, d == "." ? (m = !1, d = i[++l]) : d == "0" && i[l + 1] == "." ? (m = !0, l += 2, d = i[l]) : m = !0, v = _(), d) {
            case "b":
              u += parseInt(y(), 10).toString(2);
              break;
            case "c":
              p = y(), typeof p == "string" || p instanceof String ? u += p : u += String.fromCharCode(parseInt(p, 10));
              break;
            case "d":
              u += parseInt(y(), 10);
              break;
            case "f":
              h = String(parseFloat(y()).toFixed(v || 6)), u += m ? h : h.replace(/^0/, "");
              break;
            case "j":
              u += JSON.stringify(y());
              break;
            case "o":
              u += "0" + parseInt(y(), 10).toString(8);
              break;
            case "s":
              u += y();
              break;
            case "x":
              u += "0x" + parseInt(y(), 10).toString(16);
              break;
            case "X":
              u += "0x" + parseInt(y(), 10).toString(16).toUpperCase();
              break;
            default:
              u += d;
              break;
          }
        else d === "%" ? f = !0 : u += d;
      return u;
    }
  })();
})(J9);
var i8e = J9.exports, o8e = i8e, vc = ll(Error);
vc.eval = ll(EvalError);
vc.range = ll(RangeError);
vc.reference = ll(ReferenceError);
vc.syntax = ll(SyntaxError);
vc.type = ll(TypeError);
vc.uri = ll(URIError);
vc.create = ll;
function ll(t) {
  return e.displayName = t.displayName || t.name, e;
  function e(n) {
    return n && (n = o8e.apply(null, arguments)), new t(n);
  }
}
var g1, y1;
if (typeof WeakMap < "u") {
  let t = /* @__PURE__ */ new WeakMap();
  g1 = (e) => t.get(e), y1 = (e, n) => (t.set(e, n), n);
} else {
  const t = [];
  let n = 0;
  g1 = (r) => {
    for (let s = 0; s < t.length; s += 2)
      if (t[s] == r)
        return t[s + 1];
  }, y1 = (r, s) => (n == 10 && (n = 0), t[n++] = r, t[n++] = s);
}
var Kt = class {
  constructor(t, e, n, r) {
    this.width = t, this.height = e, this.map = n, this.problems = r;
  }
  // Find the dimensions of the cell at the given position.
  findCell(t) {
    for (let e = 0; e < this.map.length; e++) {
      const n = this.map[e];
      if (n != t)
        continue;
      const r = e % this.width, s = e / this.width | 0;
      let i = r + 1, o = s + 1;
      for (let a = 1; i < this.width && this.map[e + a] == n; a++)
        i++;
      for (let a = 1; o < this.height && this.map[e + this.width * a] == n; a++)
        o++;
      return { left: r, top: s, right: i, bottom: o };
    }
    throw new RangeError(`No cell with offset ${t} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(t) {
    for (let e = 0; e < this.map.length; e++)
      if (this.map[e] == t)
        return e % this.width;
    throw new RangeError(`No cell with offset ${t} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(t, e, n) {
    const { left: r, right: s, top: i, bottom: o } = this.findCell(t);
    return e == "horiz" ? (n < 0 ? r == 0 : s == this.width) ? null : this.map[i * this.width + (n < 0 ? r - 1 : s)] : (n < 0 ? i == 0 : o == this.height) ? null : this.map[r + this.width * (n < 0 ? i - 1 : o)];
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(t, e) {
    const {
      left: n,
      right: r,
      top: s,
      bottom: i
    } = this.findCell(t), {
      left: o,
      right: a,
      top: l,
      bottom: c
    } = this.findCell(e);
    return {
      left: Math.min(n, o),
      top: Math.min(s, l),
      right: Math.max(r, a),
      bottom: Math.max(i, c)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(t) {
    const e = [], n = {};
    for (let r = t.top; r < t.bottom; r++)
      for (let s = t.left; s < t.right; s++) {
        const i = r * this.width + s, o = this.map[i];
        n[o] || (n[o] = !0, !(s == t.left && s && this.map[i - 1] == o || r == t.top && r && this.map[i - this.width] == o) && e.push(o));
      }
    return e;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(t, e, n) {
    for (let r = 0, s = 0; ; r++) {
      const i = s + n.child(r).nodeSize;
      if (r == t) {
        let o = e + t * this.width;
        const a = (t + 1) * this.width;
        for (; o < a && this.map[o] < s; )
          o++;
        return o == a ? i - 1 : this.map[o];
      }
      s = i;
    }
  }
  // Find the table map for the given table node.
  static get(t) {
    return g1(t) || y1(t, a8e(t));
  }
};
function a8e(t) {
  if (t.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + t.type.name);
  const e = l8e(t), n = t.childCount, r = [];
  let s = 0, i = null;
  const o = [];
  for (let c = 0, u = e * n; c < u; c++)
    r[c] = 0;
  for (let c = 0, u = 0; c < n; c++) {
    const d = t.child(c);
    u++;
    for (let h = 0; ; h++) {
      for (; s < r.length && r[s] != 0; )
        s++;
      if (h == d.childCount)
        break;
      const m = d.child(h), { colspan: v, rowspan: y, colwidth: _ } = m.attrs;
      for (let w = 0; w < y; w++) {
        if (w + c >= n) {
          (i || (i = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: y - w
          });
          break;
        }
        const S = s + w * e;
        for (let E = 0; E < v; E++) {
          r[S + E] == 0 ? r[S + E] = u : (i || (i = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: v - E
          });
          const x = _ && _[E];
          if (x) {
            const T = (S + E) % e * 2, C = o[T];
            C == null || C != x && o[T + 1] == 1 ? (o[T] = x, o[T + 1] = 1) : C == x && o[T + 1]++;
          }
        }
      }
      s += v, u += m.nodeSize;
    }
    const f = (c + 1) * e;
    let p = 0;
    for (; s < f; )
      r[s++] == 0 && p++;
    p && (i || (i = [])).push({ type: "missing", row: c, n: p }), u++;
  }
  const a = new Kt(e, n, r, i);
  let l = !1;
  for (let c = 0; !l && c < o.length; c += 2)
    o[c] != null && o[c + 1] < n && (l = !0);
  return l && c8e(a, o, t), a;
}
function l8e(t) {
  let e = -1, n = !1;
  for (let r = 0; r < t.childCount; r++) {
    const s = t.child(r);
    let i = 0;
    if (n)
      for (let o = 0; o < r; o++) {
        const a = t.child(o);
        for (let l = 0; l < a.childCount; l++) {
          const c = a.child(l);
          o + c.attrs.rowspan > r && (i += c.attrs.colspan);
        }
      }
    for (let o = 0; o < s.childCount; o++) {
      const a = s.child(o);
      i += a.attrs.colspan, a.attrs.rowspan > 1 && (n = !0);
    }
    e == -1 ? e = i : e != i && (e = Math.max(e, i));
  }
  return e;
}
function c8e(t, e, n) {
  t.problems || (t.problems = []);
  const r = {};
  for (let s = 0; s < t.map.length; s++) {
    const i = t.map[s];
    if (r[i])
      continue;
    r[i] = !0;
    const o = n.nodeAt(i);
    if (!o)
      throw new RangeError(`No cell with offset ${i} found`);
    let a = null;
    const l = o.attrs;
    for (let c = 0; c < l.colspan; c++) {
      const u = (s + c) % t.width, d = e[u * 2];
      d != null && (!l.colwidth || l.colwidth[c] != d) && ((a || (a = u8e(l)))[c] = d);
    }
    a && t.problems.unshift({
      type: "colwidth mismatch",
      pos: i,
      colwidth: a
    });
  }
}
function u8e(t) {
  if (t.colwidth)
    return t.colwidth.slice();
  const e = [];
  for (let n = 0; n < t.colspan; n++)
    e.push(0);
  return e;
}
function c3(t, e) {
  if (typeof t == "string")
    return {};
  const n = t.getAttribute("data-colwidth"), r = n && /^\d+(,\d+)*$/.test(n) ? n.split(",").map((o) => Number(o)) : null, s = Number(t.getAttribute("colspan") || 1), i = {
    colspan: s,
    rowspan: Number(t.getAttribute("rowspan") || 1),
    colwidth: r && r.length == s ? r : null
  };
  for (const o in e) {
    const a = e[o].getFromDOM, l = a && a(t);
    l != null && (i[o] = l);
  }
  return i;
}
function u3(t, e) {
  const n = {};
  t.attrs.colspan != 1 && (n.colspan = t.attrs.colspan), t.attrs.rowspan != 1 && (n.rowspan = t.attrs.rowspan), t.attrs.colwidth && (n["data-colwidth"] = t.attrs.colwidth.join(","));
  for (const r in e) {
    const s = e[r].setDOMAttr;
    s && s(t.attrs[r], n);
  }
  return n;
}
function d8e(t) {
  const e = t.cellAttributes || {}, n = {
    colspan: { default: 1 },
    rowspan: { default: 1 },
    colwidth: { default: null }
  };
  for (const r in e)
    n[r] = { default: e[r].default };
  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: !0,
      group: t.tableGroup,
      parseDOM: [{ tag: "table" }],
      toDOM() {
        return ["table", ["tbody", 0]];
      }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{ tag: "tr" }],
      toDOM() {
        return ["tr", 0];
      }
    },
    table_cell: {
      content: t.cellContent,
      attrs: n,
      tableRole: "cell",
      isolating: !0,
      parseDOM: [
        { tag: "td", getAttrs: (r) => c3(r, e) }
      ],
      toDOM(r) {
        return ["td", u3(r, e), 0];
      }
    },
    table_header: {
      content: t.cellContent,
      attrs: n,
      tableRole: "header_cell",
      isolating: !0,
      parseDOM: [
        { tag: "th", getAttrs: (r) => c3(r, e) }
      ],
      toDOM(r) {
        return ["th", u3(r, e), 0];
      }
    }
  };
}
function ys(t) {
  let e = t.cached.tableNodeTypes;
  if (!e) {
    e = t.cached.tableNodeTypes = {};
    for (const n in t.nodes) {
      const r = t.nodes[n], s = r.spec.tableRole;
      s && (e[s] = r);
    }
  }
  return e;
}
var _a = new ci("selectingCells");
function Uu(t) {
  for (let e = t.depth - 1; e > 0; e--)
    if (t.node(e).type.spec.tableRole == "row")
      return t.node(0).resolve(t.before(e + 1));
  return null;
}
function f8e(t) {
  for (let e = t.depth; e > 0; e--) {
    const n = t.node(e).type.spec.tableRole;
    if (n === "cell" || n === "header_cell")
      return t.node(e);
  }
  return null;
}
function Ji(t) {
  const e = t.selection.$head;
  for (let n = e.depth; n > 0; n--)
    if (e.node(n).type.spec.tableRole == "row")
      return !0;
  return !1;
}
function ug(t) {
  const e = t.selection;
  if ("$anchorCell" in e && e.$anchorCell)
    return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell")
    return e.$anchor;
  const n = Uu(e.$head) || p8e(e.$head);
  if (n)
    return n;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function p8e(t) {
  for (let e = t.nodeAfter, n = t.pos; e; e = e.firstChild, n++) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell")
      return t.doc.resolve(n);
  }
  for (let e = t.nodeBefore, n = t.pos; e; e = e.lastChild, n--) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell")
      return t.doc.resolve(n - e.nodeSize);
  }
}
function b1(t) {
  return t.parent.type.spec.tableRole == "row" && !!t.nodeAfter;
}
function h8e(t) {
  return t.node(0).resolve(t.pos + t.nodeAfter.nodeSize);
}
function bI(t, e) {
  return t.depth == e.depth && t.pos >= e.start(-1) && t.pos <= e.end(-1);
}
function q9(t, e, n) {
  const r = t.node(-1), s = Kt.get(r), i = t.start(-1), o = s.nextCell(t.pos - i, e, n);
  return o == null ? null : t.node(0).resolve(i + o);
}
function Kl(t, e, n = 1) {
  const r = { ...t, colspan: t.colspan - n };
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(e, n), r.colwidth.some((s) => s > 0) || (r.colwidth = null)), r;
}
function Q9(t, e, n = 1) {
  const r = { ...t, colspan: t.colspan + n };
  if (r.colwidth) {
    r.colwidth = r.colwidth.slice();
    for (let s = 0; s < n; s++)
      r.colwidth.splice(e, 0, 0);
  }
  return r;
}
function m8e(t, e, n) {
  const r = ys(e.type.schema).header_cell;
  for (let s = 0; s < t.height; s++)
    if (e.nodeAt(t.map[n + s * t.width]).type != r)
      return !1;
  return !0;
}
var gn = class Ro extends yt {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(e, n = e) {
    const r = e.node(-1), s = Kt.get(r), i = e.start(-1), o = s.rectBetween(
      e.pos - i,
      n.pos - i
    ), a = e.node(0), l = s.cellsInRect(o).filter((u) => u != n.pos - i);
    l.unshift(n.pos - i);
    const c = l.map((u) => {
      const d = r.nodeAt(u);
      if (!d)
        throw RangeError(`No cell with offset ${u} found`);
      const f = i + u + 1;
      return new J6(
        a.resolve(f),
        a.resolve(f + d.content.size)
      );
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = n;
  }
  map(e, n) {
    const r = e.resolve(n.map(this.$anchorCell.pos)), s = e.resolve(n.map(this.$headCell.pos));
    if (b1(r) && b1(s) && bI(r, s)) {
      const i = this.$anchorCell.node(-1) != r.node(-1);
      return i && this.isRowSelection() ? Ro.rowSelection(r, s) : i && this.isColSelection() ? Ro.colSelection(r, s) : new Ro(r, s);
    }
    return Mt.between(r, s);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const e = this.$anchorCell.node(-1), n = Kt.get(e), r = this.$anchorCell.start(-1), s = n.rectBetween(
      this.$anchorCell.pos - r,
      this.$headCell.pos - r
    ), i = {}, o = [];
    for (let l = s.top; l < s.bottom; l++) {
      const c = [];
      for (let u = l * n.width + s.left, d = s.left; d < s.right; d++, u++) {
        const f = n.map[u];
        if (i[f])
          continue;
        i[f] = !0;
        const p = n.findCell(f);
        let h = e.nodeAt(f);
        if (!h)
          throw RangeError(`No cell with offset ${f} found`);
        const m = s.left - p.left, v = p.right - s.right;
        if (m > 0 || v > 0) {
          let y = h.attrs;
          if (m > 0 && (y = Kl(y, 0, m)), v > 0 && (y = Kl(
            y,
            y.colspan - v,
            v
          )), p.left < s.left) {
            if (h = h.type.createAndFill(y), !h)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(y)}`
              );
          } else
            h = h.type.create(y, h.content);
        }
        if (p.top < s.top || p.bottom > s.bottom) {
          const y = {
            ...h.attrs,
            rowspan: Math.min(p.bottom, s.bottom) - Math.max(p.top, s.top)
          };
          p.top < s.top ? h = h.type.createAndFill(y) : h = h.type.create(y, h.content);
        }
        c.push(h);
      }
      o.push(e.child(l).copy(xe.from(c)));
    }
    const a = this.isColSelection() && this.isRowSelection() ? e : o;
    return new He(xe.from(a), 1, 1);
  }
  replace(e, n = He.empty) {
    const r = e.steps.length, s = this.ranges;
    for (let o = 0; o < s.length; o++) {
      const { $from: a, $to: l } = s[o], c = e.mapping.slice(r);
      e.replace(
        c.map(a.pos),
        c.map(l.pos),
        o ? He.empty : n
      );
    }
    const i = yt.findFrom(
      e.doc.resolve(e.mapping.slice(r).map(this.to)),
      -1
    );
    i && e.setSelection(i);
  }
  replaceWith(e, n) {
    this.replace(e, new He(xe.from(n), 0, 0));
  }
  forEachCell(e) {
    const n = this.$anchorCell.node(-1), r = Kt.get(n), s = this.$anchorCell.start(-1), i = r.cellsInRect(
      r.rectBetween(
        this.$anchorCell.pos - s,
        this.$headCell.pos - s
      )
    );
    for (let o = 0; o < i.length; o++)
      e(n.nodeAt(i[o]), s + i[o]);
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const e = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(e, n) > 0)
      return !1;
    const r = e + this.$anchorCell.nodeAfter.attrs.rowspan, s = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, s) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(e, n = e) {
    const r = e.node(-1), s = Kt.get(r), i = e.start(-1), o = s.findCell(e.pos - i), a = s.findCell(n.pos - i), l = e.node(0);
    return o.top <= a.top ? (o.top > 0 && (e = l.resolve(i + s.map[o.left])), a.bottom < s.height && (n = l.resolve(
      i + s.map[s.width * (s.height - 1) + a.right - 1]
    ))) : (a.top > 0 && (n = l.resolve(i + s.map[a.left])), o.bottom < s.height && (e = l.resolve(
      i + s.map[s.width * (s.height - 1) + o.right - 1]
    ))), new Ro(e, n);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const e = this.$anchorCell.node(-1), n = Kt.get(e), r = this.$anchorCell.start(-1), s = n.colCount(this.$anchorCell.pos - r), i = n.colCount(this.$headCell.pos - r);
    if (Math.min(s, i) > 0)
      return !1;
    const o = s + this.$anchorCell.nodeAfter.attrs.colspan, a = i + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(o, a) == n.width;
  }
  eq(e) {
    return e instanceof Ro && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(e, n = e) {
    const r = e.node(-1), s = Kt.get(r), i = e.start(-1), o = s.findCell(e.pos - i), a = s.findCell(n.pos - i), l = e.node(0);
    return o.left <= a.left ? (o.left > 0 && (e = l.resolve(
      i + s.map[o.top * s.width]
    )), a.right < s.width && (n = l.resolve(
      i + s.map[s.width * (a.top + 1) - 1]
    ))) : (a.left > 0 && (n = l.resolve(i + s.map[a.top * s.width])), o.right < s.width && (e = l.resolve(
      i + s.map[s.width * (o.top + 1) - 1]
    ))), new Ro(e, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, n) {
    return new Ro(e.resolve(n.anchor), e.resolve(n.head));
  }
  static create(e, n, r = n) {
    return new Ro(e.resolve(n), e.resolve(r));
  }
  getBookmark() {
    return new v8e(this.$anchorCell.pos, this.$headCell.pos);
  }
};
gn.prototype.visible = !1;
yt.jsonID("cell", gn);
var v8e = class e8 {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new e8(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const n = e.resolve(this.anchor), r = e.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && r.index() < r.parent.childCount && bI(n, r) ? new gn(n, r) : yt.near(r, 1);
  }
};
function g8e(t) {
  if (!(t.selection instanceof gn))
    return null;
  const e = [];
  return t.selection.forEachCell((n, r) => {
    e.push(
      Qt.node(r, r + n.nodeSize, { class: "selectedCell" })
    );
  }), Rt.create(t.doc, e);
}
function y8e({ $from: t, $to: e }) {
  if (t.pos == e.pos || t.pos < t.pos - 6)
    return !1;
  let n = t.pos, r = e.pos, s = t.depth;
  for (; s >= 0 && !(t.after(s + 1) < t.end(s)); s--, n++)
    ;
  for (let i = e.depth; i >= 0 && !(e.before(i + 1) > e.start(i)); i--, r--)
    ;
  return n == r && /row|table/.test(t.node(s).type.spec.tableRole);
}
function b8e({ $from: t, $to: e }) {
  let n, r;
  for (let s = t.depth; s > 0; s--) {
    const i = t.node(s);
    if (i.type.spec.tableRole === "cell" || i.type.spec.tableRole === "header_cell") {
      n = i;
      break;
    }
  }
  for (let s = e.depth; s > 0; s--) {
    const i = e.node(s);
    if (i.type.spec.tableRole === "cell" || i.type.spec.tableRole === "header_cell") {
      r = i;
      break;
    }
  }
  return n !== r && e.parentOffset === 0;
}
function _8e(t, e, n) {
  const r = (e || t).selection, s = (e || t).doc;
  let i, o;
  if (r instanceof ct && (o = r.node.type.spec.tableRole)) {
    if (o == "cell" || o == "header_cell")
      i = gn.create(s, r.from);
    else if (o == "row") {
      const a = s.resolve(r.from + 1);
      i = gn.rowSelection(a, a);
    } else if (!n) {
      const a = Kt.get(r.node), l = r.from + 1, c = l + a.map[a.width * a.height - 1];
      i = gn.create(s, l + 1, c);
    }
  } else r instanceof Mt && y8e(r) ? i = Mt.create(s, r.from) : r instanceof Mt && b8e(r) && (i = Mt.create(s, r.$from.start(), r.$from.end()));
  return i && (e || (e = t.tr)).setSelection(i), e;
}
var w8e = new ci("fix-tables");
function t8(t, e, n, r) {
  const s = t.childCount, i = e.childCount;
  e:
    for (let o = 0, a = 0; o < i; o++) {
      const l = e.child(o);
      for (let c = a, u = Math.min(s, o + 3); c < u; c++)
        if (t.child(c) == l) {
          a = c + 1, n += l.nodeSize;
          continue e;
        }
      r(l, n), a < s && t.child(a).sameMarkup(l) ? t8(t.child(a), l, n + 1, r) : l.nodesBetween(0, l.content.size, r, n + 1), n += l.nodeSize;
    }
}
function n8(t, e) {
  let n;
  const r = (s, i) => {
    s.type.spec.tableRole == "table" && (n = S8e(t, s, i, n));
  };
  return e ? e.doc != t.doc && t8(e.doc, t.doc, 0, r) : t.doc.descendants(r), n;
}
function S8e(t, e, n, r) {
  const s = Kt.get(e);
  if (!s.problems)
    return r;
  r || (r = t.tr);
  const i = [];
  for (let l = 0; l < s.height; l++)
    i.push(0);
  for (let l = 0; l < s.problems.length; l++) {
    const c = s.problems[l];
    if (c.type == "collision") {
      const u = e.nodeAt(c.pos);
      if (!u)
        continue;
      const d = u.attrs;
      for (let f = 0; f < d.rowspan; f++)
        i[c.row + f] += c.n;
      r.setNodeMarkup(
        r.mapping.map(n + 1 + c.pos),
        null,
        Kl(d, d.colspan - c.n, c.n)
      );
    } else if (c.type == "missing")
      i[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const u = e.nodeAt(c.pos);
      if (!u)
        continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...u.attrs,
        rowspan: u.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const u = e.nodeAt(c.pos);
      if (!u)
        continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...u.attrs,
        colwidth: c.colwidth
      });
    }
  }
  let o, a;
  for (let l = 0; l < i.length; l++)
    i[l] && (o == null && (o = l), a = l);
  for (let l = 0, c = n + 1; l < s.height; l++) {
    const u = e.child(l), d = c + u.nodeSize, f = i[l];
    if (f > 0) {
      let p = "cell";
      u.firstChild && (p = u.firstChild.type.spec.tableRole);
      const h = [];
      for (let v = 0; v < f; v++) {
        const y = ys(t.schema)[p].createAndFill();
        y && h.push(y);
      }
      const m = (l == 0 || o == l - 1) && a == l ? c + 1 : d - 1;
      r.insert(r.mapping.map(m), h);
    }
    c = d;
  }
  return r.setMeta(w8e, { fixTables: !0 });
}
function Po(t) {
  const e = t.selection, n = ug(t), r = n.node(-1), s = n.start(-1), i = Kt.get(r);
  return { ...e instanceof gn ? i.rectBetween(
    e.$anchorCell.pos - s,
    e.$headCell.pos - s
  ) : i.findCell(n.pos - s), tableStart: s, map: i, table: r };
}
function _I(t, { map: e, tableStart: n, table: r }, s) {
  let i = s > 0 ? -1 : 0;
  m8e(e, r, s + i) && (i = s == 0 || s == e.width ? null : 0);
  for (let o = 0; o < e.height; o++) {
    const a = o * e.width + s;
    if (s > 0 && s < e.width && e.map[a - 1] == e.map[a]) {
      const l = e.map[a], c = r.nodeAt(l);
      t.setNodeMarkup(
        t.mapping.map(n + l),
        null,
        Q9(c.attrs, s - e.colCount(l))
      ), o += c.attrs.rowspan - 1;
    } else {
      const l = i == null ? ys(r.type.schema).cell : r.nodeAt(e.map[a + i]).type, c = e.positionAt(o, s, r);
      t.insert(t.mapping.map(n + c), l.createAndFill());
    }
  }
  return t;
}
function I8e(t, e) {
  if (!Ji(t))
    return !1;
  if (e) {
    const n = Po(t);
    e(_I(t.tr, n, n.left));
  }
  return !0;
}
function E8e(t, e) {
  if (!Ji(t))
    return !1;
  if (e) {
    const n = Po(t);
    e(_I(t.tr, n, n.right));
  }
  return !0;
}
function r8(t, { map: e, table: n, tableStart: r }, s) {
  const i = t.mapping.maps.length;
  for (let o = 0; o < e.height; ) {
    const a = o * e.width + s, l = e.map[a], c = n.nodeAt(l), u = c.attrs;
    if (s > 0 && e.map[a - 1] == l || s < e.width - 1 && e.map[a + 1] == l)
      t.setNodeMarkup(
        t.mapping.slice(i).map(r + l),
        null,
        Kl(u, s - e.colCount(l))
      );
    else {
      const d = t.mapping.slice(i).map(r + l);
      t.delete(d, d + c.nodeSize);
    }
    o += u.rowspan;
  }
}
function x8e(t, e) {
  if (!Ji(t))
    return !1;
  if (e) {
    const n = Po(t), r = t.tr;
    if (n.left == 0 && n.right == n.map.width)
      return !1;
    for (let s = n.right - 1; r8(r, n, s), s != n.left; s--) {
      const i = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!i)
        throw RangeError("No table found");
      n.table = i, n.map = Kt.get(i);
    }
    e(r);
  }
  return !0;
}
function C8e(t, e, n) {
  var r;
  const s = ys(e.type.schema).header_cell;
  for (let i = 0; i < t.width; i++)
    if (((r = e.nodeAt(t.map[i + n * t.width])) == null ? void 0 : r.type) != s)
      return !1;
  return !0;
}
function wI(t, { map: e, tableStart: n, table: r }, s) {
  var i;
  let o = n;
  for (let c = 0; c < s; c++)
    o += r.child(c).nodeSize;
  const a = [];
  let l = s > 0 ? -1 : 0;
  C8e(e, r, s + l) && (l = s == 0 || s == e.height ? null : 0);
  for (let c = 0, u = e.width * s; c < e.width; c++, u++)
    if (s > 0 && s < e.height && e.map[u] == e.map[u - e.width]) {
      const d = e.map[u], f = r.nodeAt(d).attrs;
      t.setNodeMarkup(n + d, null, {
        ...f,
        rowspan: f.rowspan + 1
      }), c += f.colspan - 1;
    } else {
      const d = l == null ? ys(r.type.schema).cell : (i = r.nodeAt(e.map[u + l * e.width])) == null ? void 0 : i.type, f = d == null ? void 0 : d.createAndFill();
      f && a.push(f);
    }
  return t.insert(o, ys(r.type.schema).row.create(null, a)), t;
}
function T8e(t, e) {
  if (!Ji(t))
    return !1;
  if (e) {
    const n = Po(t);
    e(wI(t.tr, n, n.top));
  }
  return !0;
}
function P8e(t, e) {
  if (!Ji(t))
    return !1;
  if (e) {
    const n = Po(t);
    e(wI(t.tr, n, n.bottom));
  }
  return !0;
}
function s8(t, { map: e, table: n, tableStart: r }, s) {
  let i = 0;
  for (let c = 0; c < s; c++)
    i += n.child(c).nodeSize;
  const o = i + n.child(s).nodeSize, a = t.mapping.maps.length;
  t.delete(i + r, o + r);
  const l = /* @__PURE__ */ new Set();
  for (let c = 0, u = s * e.width; c < e.width; c++, u++) {
    const d = e.map[u];
    if (!l.has(d)) {
      if (l.add(d), s > 0 && d == e.map[u - e.width]) {
        const f = n.nodeAt(d).attrs;
        t.setNodeMarkup(t.mapping.slice(a).map(d + r), null, {
          ...f,
          rowspan: f.rowspan - 1
        }), c += f.colspan - 1;
      } else if (s < e.height && d == e.map[u + e.width]) {
        const f = n.nodeAt(d), p = f.attrs, h = f.type.create(
          { ...p, rowspan: f.attrs.rowspan - 1 },
          f.content
        ), m = e.positionAt(s + 1, c, n);
        t.insert(t.mapping.slice(a).map(r + m), h), c += p.colspan - 1;
      }
    }
  }
}
function k8e(t, e) {
  if (!Ji(t))
    return !1;
  if (e) {
    const n = Po(t), r = t.tr;
    if (n.top == 0 && n.bottom == n.map.height)
      return !1;
    for (let s = n.bottom - 1; s8(r, n, s), s != n.top; s--) {
      const i = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!i)
        throw RangeError("No table found");
      n.table = i, n.map = Kt.get(n.table);
    }
    e(r);
  }
  return !0;
}
function d3(t) {
  const e = t.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function N8e({ width: t, height: e, map: n }, r) {
  let s = r.top * t + r.left, i = s, o = (r.bottom - 1) * t + r.left, a = s + (r.right - r.left - 1);
  for (let l = r.top; l < r.bottom; l++) {
    if (r.left > 0 && n[i] == n[i - 1] || r.right < t && n[a] == n[a + 1])
      return !0;
    i += t, a += t;
  }
  for (let l = r.left; l < r.right; l++) {
    if (r.top > 0 && n[s] == n[s - t] || r.bottom < e && n[o] == n[o + t])
      return !0;
    s++, o++;
  }
  return !1;
}
function f3(t, e) {
  const n = t.selection;
  if (!(n instanceof gn) || n.$anchorCell.pos == n.$headCell.pos)
    return !1;
  const r = Po(t), { map: s } = r;
  if (N8e(s, r))
    return !1;
  if (e) {
    const i = t.tr, o = {};
    let a = xe.empty, l, c;
    for (let u = r.top; u < r.bottom; u++)
      for (let d = r.left; d < r.right; d++) {
        const f = s.map[u * s.width + d], p = r.table.nodeAt(f);
        if (!(o[f] || !p))
          if (o[f] = !0, l == null)
            l = f, c = p;
          else {
            d3(p) || (a = a.append(p.content));
            const h = i.mapping.map(f + r.tableStart);
            i.delete(h, h + p.nodeSize);
          }
      }
    if (l == null || c == null)
      return !0;
    if (i.setNodeMarkup(l + r.tableStart, null, {
      ...Q9(
        c.attrs,
        c.attrs.colspan,
        r.right - r.left - c.attrs.colspan
      ),
      rowspan: r.bottom - r.top
    }), a.size) {
      const u = l + 1 + c.content.size, d = d3(c) ? l + 1 : u;
      i.replaceWith(d + r.tableStart, u + r.tableStart, a);
    }
    i.setSelection(
      new gn(i.doc.resolve(l + r.tableStart))
    ), e(i);
  }
  return !0;
}
function p3(t, e) {
  const n = ys(t.schema);
  return $8e(({ node: r }) => n[r.type.spec.tableRole])(t, e);
}
function $8e(t) {
  return (e, n) => {
    var r;
    const s = e.selection;
    let i, o;
    if (s instanceof gn) {
      if (s.$anchorCell.pos != s.$headCell.pos)
        return !1;
      i = s.$anchorCell.nodeAfter, o = s.$anchorCell.pos;
    } else {
      if (i = f8e(s.$from), !i)
        return !1;
      o = (r = Uu(s.$from)) == null ? void 0 : r.pos;
    }
    if (i == null || o == null || i.attrs.colspan == 1 && i.attrs.rowspan == 1)
      return !1;
    if (n) {
      let a = i.attrs;
      const l = [], c = a.colwidth;
      a.rowspan > 1 && (a = { ...a, rowspan: 1 }), a.colspan > 1 && (a = { ...a, colspan: 1 });
      const u = Po(e), d = e.tr;
      for (let p = 0; p < u.right - u.left; p++)
        l.push(
          c ? {
            ...a,
            colwidth: c && c[p] ? [c[p]] : null
          } : a
        );
      let f;
      for (let p = u.top; p < u.bottom; p++) {
        let h = u.map.positionAt(p, u.left, u.table);
        p == u.top && (h += i.nodeSize);
        for (let m = u.left, v = 0; m < u.right; m++, v++)
          m == u.left && p == u.top || d.insert(
            f = d.mapping.map(h + u.tableStart, 1),
            t({ node: i, row: p, col: m }).createAndFill(l[v])
          );
      }
      d.setNodeMarkup(
        o,
        t({ node: i, row: u.top, col: u.left }),
        l[0]
      ), s instanceof gn && d.setSelection(
        new gn(
          d.doc.resolve(s.$anchorCell.pos),
          f ? d.doc.resolve(f) : void 0
        )
      ), n(d);
    }
    return !0;
  };
}
function D8e(t, e) {
  return function(n, r) {
    if (!Ji(n))
      return !1;
    const s = ug(n);
    if (s.nodeAfter.attrs[t] === e)
      return !1;
    if (r) {
      const i = n.tr;
      n.selection instanceof gn ? n.selection.forEachCell((o, a) => {
        o.attrs[t] !== e && i.setNodeMarkup(a, null, {
          ...o.attrs,
          [t]: e
        });
      }) : i.setNodeMarkup(s.pos, null, {
        ...s.nodeAfter.attrs,
        [t]: e
      }), r(i);
    }
    return !0;
  };
}
function A8e(t) {
  return function(e, n) {
    if (!Ji(e))
      return !1;
    if (n) {
      const r = ys(e.schema), s = Po(e), i = e.tr, o = s.map.cellsInRect(
        t == "column" ? {
          left: s.left,
          top: 0,
          right: s.right,
          bottom: s.map.height
        } : t == "row" ? {
          left: 0,
          top: s.top,
          right: s.map.width,
          bottom: s.bottom
        } : s
      ), a = o.map((l) => s.table.nodeAt(l));
      for (let l = 0; l < o.length; l++)
        a[l].type == r.header_cell && i.setNodeMarkup(
          s.tableStart + o[l],
          r.cell,
          a[l].attrs
        );
      if (i.steps.length == 0)
        for (let l = 0; l < o.length; l++)
          i.setNodeMarkup(
            s.tableStart + o[l],
            r.header_cell,
            a[l].attrs
          );
      n(i);
    }
    return !0;
  };
}
function h3(t, e, n) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let s = 0; s < r.length; s++) {
    const i = e.table.nodeAt(r[s]);
    if (i && i.type !== n.header_cell)
      return !1;
  }
  return !0;
}
function SI(t, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? A8e(t) : function(n, r) {
    if (!Ji(n))
      return !1;
    if (r) {
      const s = ys(n.schema), i = Po(n), o = n.tr, a = h3("row", i, s), l = h3(
        "column",
        i,
        s
      ), u = (t === "column" ? a : t === "row" ? l : !1) ? 1 : 0, d = t == "column" ? {
        left: 0,
        top: u,
        right: 1,
        bottom: i.map.height
      } : t == "row" ? {
        left: u,
        top: 0,
        right: i.map.width,
        bottom: 1
      } : i, f = t == "column" ? l ? s.cell : s.header_cell : t == "row" ? a ? s.cell : s.header_cell : s.cell;
      i.map.cellsInRect(d).forEach((p) => {
        const h = p + i.tableStart, m = o.doc.nodeAt(h);
        m && o.setNodeMarkup(h, f, m.attrs);
      }), r(o);
    }
    return !0;
  };
}
var O8e = SI("row", {
  useDeprecatedLogic: !0
}), M8e = SI("column", {
  useDeprecatedLogic: !0
}), R8e = SI("cell", {
  useDeprecatedLogic: !0
});
function L8e(t, e) {
  if (e < 0) {
    const n = t.nodeBefore;
    if (n)
      return t.pos - n.nodeSize;
    for (let r = t.index(-1) - 1, s = t.before(); r >= 0; r--) {
      const i = t.node(-1).child(r), o = i.lastChild;
      if (o)
        return s - 1 - o.nodeSize;
      s -= i.nodeSize;
    }
  } else {
    if (t.index() < t.parent.childCount - 1)
      return t.pos + t.nodeAfter.nodeSize;
    const n = t.node(-1);
    for (let r = t.indexAfter(-1), s = t.after(); r < n.childCount; r++) {
      const i = n.child(r);
      if (i.childCount)
        return s + 1;
      s += i.nodeSize;
    }
  }
  return null;
}
function m3(t) {
  return function(e, n) {
    if (!Ji(e))
      return !1;
    const r = L8e(ug(e), t);
    if (r == null)
      return !1;
    if (n) {
      const s = e.doc.resolve(r);
      n(
        e.tr.setSelection(Mt.between(s, h8e(s))).scrollIntoView()
      );
    }
    return !0;
  };
}
function F8e(t, e) {
  const n = t.selection.$anchor;
  for (let r = n.depth; r > 0; r--)
    if (n.node(r).type.spec.tableRole == "table")
      return e && e(
        t.tr.delete(n.before(r), n.after(r)).scrollIntoView()
      ), !0;
  return !1;
}
function Mp(t, e) {
  const n = t.selection;
  if (!(n instanceof gn))
    return !1;
  if (e) {
    const r = t.tr, s = ys(t.schema).cell.createAndFill().content;
    n.forEachCell((i, o) => {
      i.content.eq(s) || r.replace(
        r.mapping.map(o + 1),
        r.mapping.map(o + i.nodeSize - 1),
        new He(s, 0, 0)
      );
    }), r.docChanged && e(r);
  }
  return !0;
}
function B8e(t) {
  if (!t.size)
    return null;
  let { content: e, openStart: n, openEnd: r } = t;
  for (; e.childCount == 1 && (n > 0 && r > 0 || e.child(0).type.spec.tableRole == "table"); )
    n--, r--, e = e.child(0).content;
  const s = e.child(0), i = s.type.spec.tableRole, o = s.type.schema, a = [];
  if (i == "row")
    for (let l = 0; l < e.childCount; l++) {
      let c = e.child(l).content;
      const u = l ? 0 : Math.max(0, n - 1), d = l < e.childCount - 1 ? 0 : Math.max(0, r - 1);
      (u || d) && (c = _1(
        ys(o).row,
        new He(c, u, d)
      ).content), a.push(c);
    }
  else if (i == "cell" || i == "header_cell")
    a.push(
      n || r ? _1(
        ys(o).row,
        new He(e, n, r)
      ).content : e
    );
  else
    return null;
  return j8e(o, a);
}
function j8e(t, e) {
  const n = [];
  for (let s = 0; s < e.length; s++) {
    const i = e[s];
    for (let o = i.childCount - 1; o >= 0; o--) {
      const { rowspan: a, colspan: l } = i.child(o).attrs;
      for (let c = s; c < s + a; c++)
        n[c] = (n[c] || 0) + l;
    }
  }
  let r = 0;
  for (let s = 0; s < n.length; s++)
    r = Math.max(r, n[s]);
  for (let s = 0; s < n.length; s++)
    if (s >= e.length && e.push(xe.empty), n[s] < r) {
      const i = ys(t).cell.createAndFill(), o = [];
      for (let a = n[s]; a < r; a++)
        o.push(i);
      e[s] = e[s].append(xe.from(o));
    }
  return { height: e.length, width: r, rows: e };
}
function _1(t, e) {
  const n = t.createAndFill();
  return new ur(n).replace(0, n.content.size, e).doc;
}
function W8e({ width: t, height: e, rows: n }, r, s) {
  if (t != r) {
    const i = [], o = [];
    for (let a = 0; a < n.length; a++) {
      const l = n[a], c = [];
      for (let u = i[a] || 0, d = 0; u < r; d++) {
        let f = l.child(d % l.childCount);
        u + f.attrs.colspan > r && (f = f.type.createChecked(
          Kl(
            f.attrs,
            f.attrs.colspan,
            u + f.attrs.colspan - r
          ),
          f.content
        )), c.push(f), u += f.attrs.colspan;
        for (let p = 1; p < f.attrs.rowspan; p++)
          i[a + p] = (i[a + p] || 0) + f.attrs.colspan;
      }
      o.push(xe.from(c));
    }
    n = o, t = r;
  }
  if (e != s) {
    const i = [];
    for (let o = 0, a = 0; o < s; o++, a++) {
      const l = [], c = n[a % e];
      for (let u = 0; u < c.childCount; u++) {
        let d = c.child(u);
        o + d.attrs.rowspan > s && (d = d.type.create(
          {
            ...d.attrs,
            rowspan: Math.max(1, s - d.attrs.rowspan)
          },
          d.content
        )), l.push(d);
      }
      i.push(xe.from(l));
    }
    n = i, e = s;
  }
  return { width: t, height: e, rows: n };
}
function H8e(t, e, n, r, s, i, o) {
  const a = t.doc.type.schema, l = ys(a);
  let c, u;
  if (s > e.width)
    for (let d = 0, f = 0; d < e.height; d++) {
      const p = n.child(d);
      f += p.nodeSize;
      const h = [];
      let m;
      p.lastChild == null || p.lastChild.type == l.cell ? m = c || (c = l.cell.createAndFill()) : m = u || (u = l.header_cell.createAndFill());
      for (let v = e.width; v < s; v++)
        h.push(m);
      t.insert(t.mapping.slice(o).map(f - 1 + r), h);
    }
  if (i > e.height) {
    const d = [];
    for (let h = 0, m = (e.height - 1) * e.width; h < Math.max(e.width, s); h++) {
      const v = h >= e.width ? !1 : n.nodeAt(e.map[m + h]).type == l.header_cell;
      d.push(
        v ? u || (u = l.header_cell.createAndFill()) : c || (c = l.cell.createAndFill())
      );
    }
    const f = l.row.create(null, xe.from(d)), p = [];
    for (let h = e.height; h < i; h++)
      p.push(f);
    t.insert(t.mapping.slice(o).map(r + n.nodeSize - 2), p);
  }
  return !!(c || u);
}
function v3(t, e, n, r, s, i, o, a) {
  if (o == 0 || o == e.height)
    return !1;
  let l = !1;
  for (let c = s; c < i; c++) {
    const u = o * e.width + c, d = e.map[u];
    if (e.map[u - e.width] == d) {
      l = !0;
      const f = n.nodeAt(d), { top: p, left: h } = e.findCell(d);
      t.setNodeMarkup(t.mapping.slice(a).map(d + r), null, {
        ...f.attrs,
        rowspan: o - p
      }), t.insert(
        t.mapping.slice(a).map(e.positionAt(o, h, n)),
        f.type.createAndFill({
          ...f.attrs,
          rowspan: p + f.attrs.rowspan - o
        })
      ), c += f.attrs.colspan - 1;
    }
  }
  return l;
}
function g3(t, e, n, r, s, i, o, a) {
  if (o == 0 || o == e.width)
    return !1;
  let l = !1;
  for (let c = s; c < i; c++) {
    const u = c * e.width + o, d = e.map[u];
    if (e.map[u - 1] == d) {
      l = !0;
      const f = n.nodeAt(d), p = e.colCount(d), h = t.mapping.slice(a).map(d + r);
      t.setNodeMarkup(
        h,
        null,
        Kl(
          f.attrs,
          o - p,
          f.attrs.colspan - (o - p)
        )
      ), t.insert(
        h + f.nodeSize,
        f.type.createAndFill(
          Kl(f.attrs, 0, o - p)
        )
      ), c += f.attrs.rowspan - 1;
    }
  }
  return l;
}
function y3(t, e, n, r, s) {
  let i = n ? t.doc.nodeAt(n - 1) : t.doc;
  if (!i)
    throw new Error("No table found");
  let o = Kt.get(i);
  const { top: a, left: l } = r, c = l + s.width, u = a + s.height, d = t.tr;
  let f = 0;
  function p() {
    if (i = n ? d.doc.nodeAt(n - 1) : d.doc, !i)
      throw new Error("No table found");
    o = Kt.get(i), f = d.mapping.maps.length;
  }
  H8e(d, o, i, n, c, u, f) && p(), v3(d, o, i, n, l, c, a, f) && p(), v3(d, o, i, n, l, c, u, f) && p(), g3(d, o, i, n, a, u, l, f) && p(), g3(d, o, i, n, a, u, c, f) && p();
  for (let h = a; h < u; h++) {
    const m = o.positionAt(h, l, i), v = o.positionAt(h, c, i);
    d.replace(
      d.mapping.slice(f).map(m + n),
      d.mapping.slice(f).map(v + n),
      new He(s.rows[h - a], 0, 0)
    );
  }
  p(), d.setSelection(
    new gn(
      d.doc.resolve(n + o.positionAt(a, l, i)),
      d.doc.resolve(n + o.positionAt(u - 1, c - 1, i))
    )
  ), e(d);
}
var V8e = dI({
  ArrowLeft: Rp("horiz", -1),
  ArrowRight: Rp("horiz", 1),
  ArrowUp: Rp("vert", -1),
  ArrowDown: Rp("vert", 1),
  "Shift-ArrowLeft": Lp("horiz", -1),
  "Shift-ArrowRight": Lp("horiz", 1),
  "Shift-ArrowUp": Lp("vert", -1),
  "Shift-ArrowDown": Lp("vert", 1),
  Backspace: Mp,
  "Mod-Backspace": Mp,
  Delete: Mp,
  "Mod-Delete": Mp
});
function bh(t, e, n) {
  return n.eq(t.selection) ? !1 : (e && e(t.tr.setSelection(n).scrollIntoView()), !0);
}
function Rp(t, e) {
  return (n, r, s) => {
    if (!s)
      return !1;
    const i = n.selection;
    if (i instanceof gn)
      return bh(
        n,
        r,
        yt.near(i.$headCell, e)
      );
    if (t != "horiz" && !i.empty)
      return !1;
    const o = i8(s, t, e);
    if (o == null)
      return !1;
    if (t == "horiz")
      return bh(
        n,
        r,
        yt.near(n.doc.resolve(i.head + e), e)
      );
    {
      const a = n.doc.resolve(o), l = q9(a, t, e);
      let c;
      return l ? c = yt.near(l, 1) : e < 0 ? c = yt.near(n.doc.resolve(a.before(-1)), -1) : c = yt.near(n.doc.resolve(a.after(-1)), 1), bh(n, r, c);
    }
  };
}
function Lp(t, e) {
  return (n, r, s) => {
    if (!s)
      return !1;
    const i = n.selection;
    let o;
    if (i instanceof gn)
      o = i;
    else {
      const l = i8(s, t, e);
      if (l == null)
        return !1;
      o = new gn(n.doc.resolve(l));
    }
    const a = q9(o.$headCell, t, e);
    return a ? bh(
      n,
      r,
      new gn(o.$anchorCell, a)
    ) : !1;
  };
}
function z8e(t, e) {
  const n = t.state.doc, r = Uu(n.resolve(e));
  return r ? (t.dispatch(t.state.tr.setSelection(new gn(r))), !0) : !1;
}
function U8e(t, e, n) {
  if (!Ji(t.state))
    return !1;
  let r = B8e(n);
  const s = t.state.selection;
  if (s instanceof gn) {
    r || (r = {
      width: 1,
      height: 1,
      rows: [
        xe.from(
          _1(ys(t.state.schema).cell, n)
        )
      ]
    });
    const i = s.$anchorCell.node(-1), o = s.$anchorCell.start(-1), a = Kt.get(i).rectBetween(
      s.$anchorCell.pos - o,
      s.$headCell.pos - o
    );
    return r = W8e(r, a.right - a.left, a.bottom - a.top), y3(t.state, t.dispatch, o, a, r), !0;
  } else if (r) {
    const i = ug(t.state), o = i.start(-1);
    return y3(
      t.state,
      t.dispatch,
      o,
      Kt.get(i.node(-1)).findCell(i.pos - o),
      r
    ), !0;
  } else
    return !1;
}
function G8e(t, e) {
  var n;
  if (e.ctrlKey || e.metaKey)
    return;
  const r = b3(t, e.target);
  let s;
  if (e.shiftKey && t.state.selection instanceof gn)
    i(t.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && r && (s = Uu(t.state.selection.$anchor)) != null && ((n = hb(t, e)) == null ? void 0 : n.pos) != s.pos)
    i(s, e), e.preventDefault();
  else if (!r)
    return;
  function i(l, c) {
    let u = hb(t, c);
    const d = _a.getState(t.state) == null;
    if (!u || !bI(l, u))
      if (d)
        u = l;
      else
        return;
    const f = new gn(l, u);
    if (d || !t.state.selection.eq(f)) {
      const p = t.state.tr.setSelection(f);
      d && p.setMeta(_a, l.pos), t.dispatch(p);
    }
  }
  function o() {
    t.root.removeEventListener("mouseup", o), t.root.removeEventListener("dragstart", o), t.root.removeEventListener("mousemove", a), _a.getState(t.state) != null && t.dispatch(t.state.tr.setMeta(_a, -1));
  }
  function a(l) {
    const c = l, u = _a.getState(t.state);
    let d;
    if (u != null)
      d = t.state.doc.resolve(u);
    else if (b3(t, c.target) != r && (d = hb(t, e), !d))
      return o();
    d && i(d, c);
  }
  t.root.addEventListener("mouseup", o), t.root.addEventListener("dragstart", o), t.root.addEventListener("mousemove", a);
}
function i8(t, e, n) {
  if (!(t.state.selection instanceof Mt))
    return null;
  const { $head: r } = t.state.selection;
  for (let s = r.depth - 1; s >= 0; s--) {
    const i = r.node(s);
    if ((n < 0 ? r.index(s) : r.indexAfter(s)) != (n < 0 ? 0 : i.childCount))
      return null;
    if (i.type.spec.tableRole == "cell" || i.type.spec.tableRole == "header_cell") {
      const a = r.before(s), l = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return t.endOfTextblock(l) ? a : null;
    }
  }
  return null;
}
function b3(t, e) {
  for (; e && e != t.dom; e = e.parentNode)
    if (e.nodeName == "TD" || e.nodeName == "TH")
      return e;
  return null;
}
function hb(t, e) {
  const n = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  return n && n ? Uu(t.state.doc.resolve(n.pos)) : null;
}
var Y8e = class {
  constructor(e, n) {
    this.node = e, this.cellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), _f(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, _f(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function _f(t, e, n, r, s, i) {
  var o;
  let a = 0, l = !0, c = e.firstChild;
  const u = t.firstChild;
  if (u) {
    for (let d = 0, f = 0; d < u.childCount; d++) {
      const { colspan: p, colwidth: h } = u.child(d).attrs;
      for (let m = 0; m < p; m++, f++) {
        const v = s == f ? i : h && h[m], y = v ? v + "px" : "";
        a += v || r, v || (l = !1), c ? (c.style.width != y && (c.style.width = y), c = c.nextSibling) : e.appendChild(document.createElement("col")).style.width = y;
      }
    }
    for (; c; ) {
      const d = c.nextSibling;
      (o = c.parentNode) == null || o.removeChild(c), c = d;
    }
    l ? (n.style.width = a + "px", n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = a + "px");
  }
}
var vi = new ci(
  "tableColumnResizing"
);
function o8({
  handleWidth: t = 5,
  cellMinWidth: e = 25,
  View: n = Y8e,
  lastColumnResizable: r = !0
} = {}) {
  const s = new lr({
    key: vi,
    state: {
      init(i, o) {
        var a, l;
        const c = (l = (a = s.spec) == null ? void 0 : a.props) == null ? void 0 : l.nodeViews, u = ys(o.schema).table.name;
        return n && c && (c[u] = (d, f) => new n(d, e, f)), new Z8e(-1, !1);
      },
      apply(i, o) {
        return o.apply(i);
      }
    },
    props: {
      attributes: (i) => {
        const o = vi.getState(i);
        return o && o.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (i, o) => {
          X8e(
            i,
            o,
            t,
            e,
            r
          );
        },
        mouseleave: (i) => {
          K8e(i);
        },
        mousedown: (i, o) => {
          J8e(i, o, e);
        }
      },
      decorations: (i) => {
        const o = vi.getState(i);
        if (o && o.activeHandle > -1)
          return r7e(i, o.activeHandle);
      },
      nodeViews: {}
    }
  });
  return s;
}
var Z8e = class _h {
  constructor(e, n) {
    this.activeHandle = e, this.dragging = n;
  }
  apply(e) {
    const n = this, r = e.getMeta(vi);
    if (r && r.setHandle != null)
      return new _h(r.setHandle, !1);
    if (r && r.setDragging !== void 0)
      return new _h(n.activeHandle, r.setDragging);
    if (n.activeHandle > -1 && e.docChanged) {
      let s = e.mapping.map(n.activeHandle, -1);
      return b1(e.doc.resolve(s)) || (s = -1), new _h(s, n.dragging);
    }
    return n;
  }
};
function X8e(t, e, n, r, s) {
  const i = vi.getState(t.state);
  if (i && !i.dragging) {
    const o = Q8e(e.target);
    let a = -1;
    if (o) {
      const { left: l, right: c } = o.getBoundingClientRect();
      e.clientX - l <= n ? a = _3(t, e, "left", n) : c - e.clientX <= n && (a = _3(t, e, "right", n));
    }
    if (a != i.activeHandle) {
      if (!s && a !== -1) {
        const l = t.state.doc.resolve(a), c = l.node(-1), u = Kt.get(c), d = l.start(-1);
        if (u.colCount(l.pos - d) + l.nodeAfter.attrs.colspan - 1 == u.width - 1)
          return;
      }
      a8(t, a);
    }
  }
}
function K8e(t) {
  const e = vi.getState(t.state);
  e && e.activeHandle > -1 && !e.dragging && a8(t, -1);
}
function J8e(t, e, n) {
  var r;
  const s = (r = t.dom.ownerDocument.defaultView) != null ? r : window, i = vi.getState(t.state);
  if (!i || i.activeHandle == -1 || i.dragging)
    return !1;
  const o = t.state.doc.nodeAt(i.activeHandle), a = q8e(t, i.activeHandle, o.attrs);
  t.dispatch(
    t.state.tr.setMeta(vi, {
      setDragging: { startX: e.clientX, startWidth: a }
    })
  );
  function l(u) {
    s.removeEventListener("mouseup", l), s.removeEventListener("mousemove", c);
    const d = vi.getState(t.state);
    d != null && d.dragging && (e7e(
      t,
      d.activeHandle,
      w3(d.dragging, u, n)
    ), t.dispatch(
      t.state.tr.setMeta(vi, { setDragging: null })
    ));
  }
  function c(u) {
    if (!u.which)
      return l(u);
    const d = vi.getState(t.state);
    if (d && d.dragging) {
      const f = w3(d.dragging, u, n);
      t7e(t, d.activeHandle, f, n);
    }
  }
  return s.addEventListener("mouseup", l), s.addEventListener("mousemove", c), e.preventDefault(), !0;
}
function q8e(t, e, { colspan: n, colwidth: r }) {
  const s = r && r[r.length - 1];
  if (s)
    return s;
  const i = t.domAtPos(e);
  let a = i.node.childNodes[i.offset].offsetWidth, l = n;
  if (r)
    for (let c = 0; c < n; c++)
      r[c] && (a -= r[c], l--);
  return a / l;
}
function Q8e(t) {
  for (; t && t.nodeName != "TD" && t.nodeName != "TH"; )
    t = t.classList && t.classList.contains("ProseMirror") ? null : t.parentNode;
  return t;
}
function _3(t, e, n, r) {
  const s = n == "right" ? -r : r, i = t.posAtCoords({
    left: e.clientX + s,
    top: e.clientY
  });
  if (!i)
    return -1;
  const { pos: o } = i, a = Uu(t.state.doc.resolve(o));
  if (!a)
    return -1;
  if (n == "right")
    return a.pos;
  const l = Kt.get(a.node(-1)), c = a.start(-1), u = l.map.indexOf(a.pos - c);
  return u % l.width == 0 ? -1 : c + l.map[u - 1];
}
function w3(t, e, n) {
  const r = e.clientX - t.startX;
  return Math.max(n, t.startWidth + r);
}
function a8(t, e) {
  t.dispatch(
    t.state.tr.setMeta(vi, { setHandle: e })
  );
}
function e7e(t, e, n) {
  const r = t.state.doc.resolve(e), s = r.node(-1), i = Kt.get(s), o = r.start(-1), a = i.colCount(r.pos - o) + r.nodeAfter.attrs.colspan - 1, l = t.state.tr;
  for (let c = 0; c < i.height; c++) {
    const u = c * i.width + a;
    if (c && i.map[u] == i.map[u - i.width])
      continue;
    const d = i.map[u], f = s.nodeAt(d).attrs, p = f.colspan == 1 ? 0 : a - i.colCount(d);
    if (f.colwidth && f.colwidth[p] == n)
      continue;
    const h = f.colwidth ? f.colwidth.slice() : n7e(f.colspan);
    h[p] = n, l.setNodeMarkup(o + d, null, { ...f, colwidth: h });
  }
  l.docChanged && t.dispatch(l);
}
function t7e(t, e, n, r) {
  const s = t.state.doc.resolve(e), i = s.node(-1), o = s.start(-1), a = Kt.get(i).colCount(s.pos - o) + s.nodeAfter.attrs.colspan - 1;
  let l = t.domAtPos(s.start(-1)).node;
  for (; l && l.nodeName != "TABLE"; )
    l = l.parentNode;
  l && _f(
    i,
    l.firstChild,
    l,
    r,
    a,
    n
  );
}
function n7e(t) {
  return Array(t).fill(0);
}
function r7e(t, e) {
  const n = [], r = t.doc.resolve(e), s = r.node(-1);
  if (!s)
    return Rt.empty;
  const i = Kt.get(s), o = r.start(-1), a = i.colCount(r.pos - o) + r.nodeAfter.attrs.colspan - 1;
  for (let l = 0; l < i.height; l++) {
    const c = a + l * i.width;
    if ((a == i.width - 1 || i.map[c] != i.map[c + 1]) && (l == 0 || i.map[c] != i.map[c - i.width])) {
      const u = i.map[c], d = o + u + s.nodeAt(u).nodeSize - 1, f = document.createElement("div");
      f.className = "column-resize-handle", n.push(Qt.widget(d, f));
    }
  }
  return Rt.create(t.doc, n);
}
function l8({
  allowTableNodeSelection: t = !1
} = {}) {
  return new lr({
    key: _a,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(e, n) {
        const r = e.getMeta(_a);
        if (r != null)
          return r == -1 ? null : r;
        if (n == null || !e.docChanged)
          return n;
        const { deleted: s, pos: i } = e.mapping.mapResult(n);
        return s ? null : i;
      }
    },
    props: {
      decorations: g8e,
      handleDOMEvents: {
        mousedown: G8e
      },
      createSelectionBetween(e) {
        return _a.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: z8e,
      handleKeyDown: V8e,
      handlePaste: U8e
    },
    appendTransaction(e, n, r) {
      return _8e(
        r,
        n8(r, n),
        t
      );
    }
  });
}
var ev = 200, jr = function() {
};
jr.prototype.append = function(e) {
  return e.length ? (e = jr.from(e), !this.length && e || e.length < ev && this.leafAppend(e) || this.length < ev && e.leafPrepend(this) || this.appendInner(e)) : this;
};
jr.prototype.prepend = function(e) {
  return e.length ? jr.from(e).append(this) : this;
};
jr.prototype.appendInner = function(e) {
  return new s7e(this, e);
};
jr.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? jr.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
jr.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
jr.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
jr.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var s = [];
  return this.forEach(function(i, o) {
    return s.push(e(i, o));
  }, n, r), s;
};
jr.from = function(e) {
  return e instanceof jr ? e : e && e.length ? new c8(e) : jr.empty;
};
var c8 = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(s, i) {
    return s == 0 && i == this.length ? this : new e(this.values.slice(s, i));
  }, e.prototype.getInner = function(s) {
    return this.values[s];
  }, e.prototype.forEachInner = function(s, i, o, a) {
    for (var l = i; l < o; l++)
      if (s(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(s, i, o, a) {
    for (var l = i - 1; l >= o; l--)
      if (s(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(s) {
    if (this.length + s.length <= ev)
      return new e(this.values.concat(s.flatten()));
  }, e.prototype.leafPrepend = function(s) {
    if (this.length + s.length <= ev)
      return new e(s.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(jr);
jr.empty = new c8([]);
var s7e = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, s, i, o) {
    var a = this.left.length;
    if (s < a && this.left.forEachInner(r, s, Math.min(i, a), o) === !1 || i > a && this.right.forEachInner(r, Math.max(s - a, 0), Math.min(this.length, i) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, s, i, o) {
    var a = this.left.length;
    if (s > a && this.right.forEachInvertedInner(r, s - a, Math.max(i, a) - a, o + a) === !1 || i < a && this.left.forEachInvertedInner(r, Math.min(s, a), i, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, s) {
    if (r == 0 && s == this.length)
      return this;
    var i = this.left.length;
    return s <= i ? this.left.slice(r, s) : r >= i ? this.right.slice(r - i, s - i) : this.left.slice(r, i).append(this.right.slice(0, s - i));
  }, e.prototype.leafAppend = function(r) {
    var s = this.right.leafAppend(r);
    if (s)
      return new e(this.left, s);
  }, e.prototype.leafPrepend = function(r) {
    var s = this.left.leafPrepend(r);
    if (s)
      return new e(s, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(jr);
const i7e = 500;
class Bi {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let s, i;
    n && (s = this.remapping(r, this.items.length), i = s.maps.length);
    let o = e.tr, a, l, c = [], u = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        s || (s = this.remapping(r, f + 1), i = s.maps.length), i--, u.push(d);
        return;
      }
      if (s) {
        u.push(new to(d.map));
        let p = d.step.map(s.slice(i)), h;
        p && o.maybeStep(p).doc && (h = o.mapping.maps[o.mapping.maps.length - 1], c.push(new to(h, void 0, void 0, c.length + u.length))), i--, h && s.appendMap(h, i);
      } else
        o.maybeStep(d.step);
      if (d.selection)
        return a = s ? d.selection.map(s.slice(i)) : d.selection, l = new Bi(this.items.slice(0, r).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, s) {
    let i = [], o = this.eventCount, a = this.items, l = !s && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), f = new to(e.mapping.maps[u], d, n), p;
      (p = l && l.merge(f)) && (f = p, u ? i.pop() : a = a.slice(0, a.length - 1)), i.push(f), n && (o++, n = void 0), s || (l = f);
    }
    let c = o - r.depth;
    return c > a7e && (a = o7e(a, c), o -= c), new Bi(a.append(i), o);
  }
  remapping(e, n) {
    let r = new vs();
    return this.items.forEach((s, i) => {
      let o = s.mirrorOffset != null && i - s.mirrorOffset >= e ? r.maps.length - s.mirrorOffset : void 0;
      r.appendMap(s.map, o);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Bi(this.items.append(e.map((n) => new to(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], s = Math.max(0, this.items.length - n), i = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((f) => {
      f.selection && a--;
    }, s);
    let l = n;
    this.items.forEach((f) => {
      let p = i.getMirror(--l);
      if (p == null)
        return;
      o = Math.min(o, p);
      let h = i.maps[p];
      if (f.step) {
        let m = e.steps[p].invert(e.docs[p]), v = f.selection && f.selection.map(i.slice(l + 1, p));
        v && a++, r.push(new to(h, m, v));
      } else
        r.push(new to(h));
    }, s);
    let c = [];
    for (let f = n; f < o; f++)
      c.push(new to(i.maps[f]));
    let u = this.items.slice(0, s).append(c).append(r), d = new Bi(u, a);
    return d.emptyItemCount() > i7e && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, s = [], i = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        s.push(o), o.selection && i++;
      else if (o.step) {
        let l = o.step.map(n.slice(r)), c = l && l.getMap();
        if (r--, c && n.appendMap(c, r), l) {
          let u = o.selection && o.selection.map(n.slice(r));
          u && i++;
          let d = new to(c.invert(), l, u), f, p = s.length - 1;
          (f = s.length && s[p].merge(d)) ? s[p] = f : s.push(d);
        }
      } else o.map && r--;
    }, this.items.length, 0), new Bi(jr.from(s.reverse()), i);
  }
}
Bi.empty = new Bi(jr.empty, 0);
function o7e(t, e) {
  let n;
  return t.forEach((r, s) => {
    if (r.selection && e-- == 0)
      return n = s, !1;
  }), t.slice(n);
}
class to {
  constructor(e, n, r, s) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = s;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new to(n.getMap().invert(), n, this.selection);
    }
  }
}
class ga {
  constructor(e, n, r, s, i) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = s, this.prevComposition = i;
  }
}
const a7e = 20;
function l7e(t, e, n, r) {
  let s = n.getMeta(Ra), i;
  if (s)
    return s.historyState;
  n.getMeta(d7e) && (t = new ga(t.done, t.undone, null, 0, -1));
  let o = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (o && o.getMeta(Ra))
    return o.getMeta(Ra).redo ? new ga(t.done.addTransform(n, void 0, r, wh(e)), t.undone, S3(n.mapping.maps), t.prevTime, t.prevComposition) : new ga(t.done, t.undone.addTransform(n, void 0, r, wh(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = n.getMeta("composition"), l = t.prevTime == 0 || !o && t.prevComposition != a && (t.prevTime < (n.time || 0) - r.newGroupDelay || !c7e(n, t.prevRanges)), c = o ? mb(t.prevRanges, n.mapping) : S3(n.mapping.maps);
    return new ga(t.done.addTransform(n, l ? e.selection.getBookmark() : void 0, r, wh(e)), Bi.empty, c, n.time, a ?? t.prevComposition);
  } else return (i = n.getMeta("rebased")) ? new ga(t.done.rebased(n, i), t.undone.rebased(n, i), mb(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new ga(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), mb(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function c7e(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, s) => {
    for (let i = 0; i < e.length; i += 2)
      r <= e[i + 1] && s >= e[i] && (n = !0);
  }), n;
}
function S3(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, s, i, o) => e.push(i, o));
  return e;
}
function mb(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let s = e.map(t[r], 1), i = e.map(t[r + 1], -1);
    s <= i && n.push(s, i);
  }
  return n;
}
function u7e(t, e, n) {
  let r = wh(e), s = Ra.get(e).spec.config, i = (n ? t.undone : t.done).popEvent(e, r);
  if (!i)
    return null;
  let o = i.selection.resolve(i.transform.doc), a = (n ? t.done : t.undone).addTransform(i.transform, e.selection.getBookmark(), s, r), l = new ga(n ? a : i.remaining, n ? i.remaining : a, null, 0, -1);
  return i.transform.setSelection(o).setMeta(Ra, { redo: n, historyState: l });
}
let vb = !1, I3 = null;
function wh(t) {
  let e = t.plugins;
  if (I3 != e) {
    vb = !1, I3 = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        vb = !0;
        break;
      }
  }
  return vb;
}
const Ra = new ci("history"), d7e = new ci("closeHistory");
function f7e(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new lr({
    key: Ra,
    state: {
      init() {
        return new ga(Bi.empty, Bi.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return l7e(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, s = r == "historyUndo" ? d8 : r == "historyRedo" ? f8 : null;
          return s ? (n.preventDefault(), s(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function u8(t, e) {
  return (n, r) => {
    let s = Ra.getState(n);
    if (!s || (t ? s.undone : s.done).eventCount == 0)
      return !1;
    if (r) {
      let i = u7e(s, n, t);
      i && r(e ? i.scrollIntoView() : i);
    }
    return !0;
  };
}
const d8 = u8(!1, !0), f8 = u8(!0, !0);
function p7e(t) {
  let e = Ra.getState(t);
  return e ? e.done.eventCount : 0;
}
var dg = d8e({
  tableGroup: "block",
  cellContent: "block+",
  cellAttributes: {
    background: {
      default: null,
      getFromDOM(t) {
        return t.style.backgroundColor || null;
      },
      setDOMAttr(t, e) {
        if (t) {
          const n = {
            style: `${e.style || ""}background-color: ${t};`
          };
          Object.assign(e, n);
        }
      }
    }
  }
});
class h7e extends Ki {
  get name() {
    return "table";
  }
  get defaultOptions() {
    return {
      resizable: !1
    };
  }
  get schema() {
    return dg.table;
  }
  commands({
    schema: e
  }) {
    return {
      createTable: ({
        rowsCount: n,
        colsCount: r,
        withHeaderRow: s
      }) => (i, o) => {
        const a = i.tr.selection.anchor + 1, l = W6e(e, n, r, s), c = i.tr.replaceSelectionWith(l).scrollIntoView(), u = c.doc.resolve(a);
        c.setSelection(Mt.near(u)), o(c);
      },
      addColumnBefore: () => I8e,
      addColumnAfter: () => E8e,
      deleteColumn: () => x8e,
      addRowBefore: () => T8e,
      addRowAfter: () => P8e,
      deleteRow: () => k8e,
      deleteTable: () => F8e,
      toggleCellMerge: () => (n, r) => {
        f3(n, r) || p3(n, r);
      },
      mergeCells: () => f3,
      splitCell: () => p3,
      toggleHeaderColumn: () => M8e,
      toggleHeaderRow: () => O8e,
      toggleHeaderCell: () => R8e,
      setCellAttr: ({
        name: n,
        value: r
      }) => D8e(n, r),
      fixTables: () => n8
    };
  }
  keys() {
    return {
      Tab: m3(1),
      "Shift-Tab": m3(-1)
    };
  }
  get plugins() {
    return [...this.options.resizable ? [o8()] : [], l8()];
  }
}
class m7e extends Ki {
  get name() {
    return "table_header";
  }
  get schema() {
    return dg.table_header;
  }
}
class v7e extends Ki {
  get name() {
    return "table_cell";
  }
  get schema() {
    return dg.table_cell;
  }
}
class g7e extends Ki {
  get name() {
    return "table_row";
  }
  get schema() {
    return dg.table_row;
  }
}
class y7e extends Xi {
  get name() {
    return "placeholder";
  }
  get defaultOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      emptyNodeText: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0
    };
  }
  get plugins() {
    return [new lr({
      props: {
        decorations: ({
          doc: e,
          plugins: n,
          selection: r
        }) => {
          const o = n.find((u) => u.key.startsWith("editable$")).props.editable() || !this.options.showOnlyWhenEditable, {
            anchor: a
          } = r, l = [], c = e.textContent.length === 0;
          return o ? (e.descendants((u, d) => {
            const f = a >= d && a <= d + u.nodeSize, p = u.content.size === 0;
            if ((f || !this.options.showOnlyCurrent) && p) {
              const h = [this.options.emptyNodeClass];
              c && h.push(this.options.emptyEditorClass);
              const m = Qt.node(d, d + u.nodeSize, {
                class: h.join(" "),
                "data-empty-text": typeof this.options.emptyNodeText == "function" ? this.options.emptyNodeText(u) : this.options.emptyNodeText
              });
              l.push(m);
            }
            return !1;
          }), Rt.create(e, l)) : !1;
        }
      }
    })];
  }
}
const b7e = (t, e) => (n) => {
  Array.isArray(t) || (t = [t]);
  for (let r = 0, s = t.length; r < s; r++) {
    const i = P7e(t[r])(n.selection);
    if (i) {
      const o = E7e(i.pos, e)(n);
      if (o !== n)
        return o;
    }
  }
  return n;
}, _7e = (t) => (e) => {
  if (I1(e.selection)) {
    const { $from: n, $to: r } = e.selection;
    if (t instanceof xe && n.parent.canReplace(n.index(), n.indexAfter(), t) || n.parent.canReplaceWith(
      n.index(),
      n.indexAfter(),
      t.type
    ))
      return Ei(
        e.replaceWith(n.pos, r.pos, t).setSelection(new ct(e.doc.resolve(n.pos)))
      );
  }
  return e;
}, w1 = (t, e = 1) => (n) => {
  const r = yt.findFrom(n.doc.resolve(t), e, !0);
  return r ? n.setSelection(r) : n;
}, S1 = (t) => t.type && t.type.spec.selectable, w7e = (t) => S1(t) && t.type.isLeaf, gb = (t, e, n) => w7e(t) ? n.setSelection(new ct(n.doc.resolve(e))) : w1(e)(n), S7e = (t, e, n) => (r) => {
  const s = typeof e == "number", { $from: i } = r.selection, o = s ? r.doc.resolve(e) : I1(r.selection) ? r.doc.resolve(i.pos + 1) : i, { parent: a } = o;
  if (I1(r.selection) && n) {
    const l = r;
    if (r = _7e(t)(r), l !== r)
      return r;
  }
  if (T7e(a)) {
    const l = r;
    if (r = b7e(a.type, t)(r), l !== r) {
      const c = S1(t) ? (
        // for selectable node, selection position would be the position of the replaced parent
        o.before(o.depth)
      ) : o.pos;
      return gb(t, c, r);
    }
  }
  if (E3(o, t)) {
    r.insert(o.pos, t);
    const l = s ? o.pos : S1(t) ? (
      // for atom nodes selection position after insertion is the previous pos
      r.selection.$anchor.pos - 1
    ) : r.selection.$anchor.pos;
    return Ei(gb(t, l, r));
  }
  for (let l = o.depth; l > 0; l--) {
    const c = o.after(l), u = r.doc.resolve(c);
    if (E3(u, t))
      return r.insert(c, t), Ei(gb(t, c, r));
  }
  return r;
}, I1 = (t) => t instanceof ct, I7e = (t, e) => Array.isArray(t) && t.indexOf(e.type) > -1 || e.type === t, Ei = (t) => Object.assign(Object.create(t), t).setTime(Date.now()), E7e = (t, e) => (n) => {
  const r = n.doc.nodeAt(t), s = n.doc.resolve(t);
  if (x7e(s, e)) {
    n = n.replaceWith(t, t + r.nodeSize, e);
    const i = n.selection.$from.pos - 1;
    return n = w1(Math.max(i, 0), -1)(n), n = w1(n.selection.$from.start())(n), Ei(n);
  }
  return n;
}, x7e = (t, e) => {
  const n = t.node(t.depth);
  return n && n.type.validContent(
    e instanceof xe ? e : xe.from(e)
  );
}, C7e = (t) => {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((n) => {
    const r = t.nodes[n];
    r.spec.tableRole && (e[r.spec.tableRole] = r);
  }), t.cached.tableNodeTypes = e, e;
}, E3 = (t, e) => {
  const n = t.index();
  return e instanceof xe ? t.parent.canReplace(n, n, e) : e instanceof jt ? t.parent.canReplaceWith(n, n, e.type) : !1;
}, T7e = (t) => !t || t.type.name === "paragraph" && t.nodeSize === 2, II = (t) => (e) => {
  const n = Kt.get(e.$anchorCell.node(-1)), r = e.$anchorCell.start(-1), s = n.cellsInRect(t), i = n.cellsInRect(
    n.rectBetween(
      e.$anchorCell.pos - r,
      e.$headCell.pos - r
    )
  );
  for (let o = 0, a = s.length; o < a; o++)
    if (i.indexOf(s[o]) === -1)
      return !1;
  return !0;
}, EI = (t) => ({ $from: e }) => p8(e, t), p8 = (t, e) => {
  for (let n = t.depth; n > 0; n--) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}, xI = (t) => (e) => !!EI(t)(e), P7e = (t) => (e) => EI((n) => I7e(t, n))(e), k7e = (t, e = !0) => {
  if (!t)
    throw new Error('Invalid "node" parameter');
  const n = [];
  return t.descendants((r, s) => {
    if (n.push({ node: r, pos: s }), !e)
      return !1;
  }), n;
}, fg = (t, e, n) => {
  if (t) {
    if (!e)
      throw new Error('Invalid "predicate" parameter');
  } else throw new Error('Invalid "node" parameter');
  return k7e(t, n).filter((r) => e(r.node));
}, wf = (t, e) => fg(t, (n) => n.isText, e), N7e = (t, e, n) => fg(t, (r) => !!e(r.attrs), n), h8 = (t, e, n) => fg(t, (r) => r.type === e, n), ra = (t) => EI(
  (e) => e.type.spec.tableRole && e.type.spec.tableRole === "table"
)(t), CI = (t) => t instanceof gn, $7e = (t) => (e) => {
  if (CI(e)) {
    const n = Kt.get(e.$anchorCell.node(-1));
    return II({
      left: t,
      right: t + 1,
      top: 0,
      bottom: n.height
    })(e);
  }
  return !1;
}, D7e = (t) => (e) => {
  if (CI(e)) {
    const n = Kt.get(e.$anchorCell.node(-1));
    return II({
      left: 0,
      right: n.width,
      top: t,
      bottom: t + 1
    })(e);
  }
  return !1;
}, A7e = (t) => {
  if (CI(t)) {
    const e = Kt.get(t.$anchorCell.node(-1));
    return II({
      left: 0,
      right: e.width,
      top: 0,
      bottom: e.height
    })(t);
  }
  return !1;
}, O7e = (t) => (e) => {
  const n = ra(e);
  if (n) {
    const r = Kt.get(n.node);
    return (Array.isArray(t) ? t : Array.from([t])).reduce((i, o) => {
      if (o >= 0 && o <= r.height - 1) {
        const a = r.cellsInRect({
          left: 0,
          right: r.width,
          top: o,
          bottom: o + 1
        });
        return i.concat(
          a.map((l) => {
            const c = n.node.nodeAt(l), u = l + n.start;
            return { pos: u, start: u + 1, node: c };
          })
        );
      }
    }, []);
  }
}, m8 = (t) => (e, n) => (r) => {
  const s = ra(r.selection), i = t === "row";
  if (s) {
    const o = Kt.get(s.node);
    if (e >= 0 && e < (i ? o.height : o.width)) {
      let a = i ? 0 : e, l = i ? e : 0, c = i ? o.width : e + 1, u = i ? e + 1 : o.height;
      if (n) {
        const y = z7e(r.selection.$from);
        if (!y)
          return r;
        const _ = o.findCell(y.pos - s.start);
        i ? (l = Math.min(l, _.top), u = Math.max(u, _.bottom)) : (a = Math.min(a, _.left), c = Math.max(c, _.right));
      }
      const d = o.cellsInRect({
        left: a,
        top: l,
        right: i ? c : a + 1,
        bottom: i ? l + 1 : u
      }), f = u - l === 1 ? d : o.cellsInRect({
        left: i ? a : c - 1,
        top: i ? u - 1 : l,
        right: c,
        bottom: u
      }), p = s.start + d[0], h = s.start + f[f.length - 1], m = r.doc.resolve(p), v = r.doc.resolve(h);
      return Ei(r.setSelection(new gn(v, m)));
    }
  }
  return r;
}, M7e = m8("column"), R7e = m8("row"), L7e = (t) => {
  const e = ra(t.selection);
  if (e) {
    const { map: n } = Kt.get(e.node);
    if (n && n.length) {
      const r = e.start + n[0], s = e.start + n[n.length - 1], i = t.doc.resolve(r), o = t.doc.resolve(s);
      return Ei(t.setSelection(new gn(o, i)));
    }
  }
  return t;
}, F7e = (t) => (e) => {
  const n = ra(e.selection);
  if (n) {
    const r = Kt.get(n.node);
    if (t >= 0 && t <= r.width)
      return Ei(
        _I(
          e,
          {
            map: r,
            tableStart: n.start,
            table: n.node
          },
          t
        )
      );
  }
  return e;
}, B7e = (t, e) => (n) => {
  const r = ra(n.selection);
  if (r) {
    const s = Kt.get(r.node);
    if (t >= 0 && t <= s.height)
      return Ei(
        wI(
          n,
          {
            map: s,
            tableStart: r.start,
            table: r.node
          },
          t
        )
      );
  }
  return n;
}, j7e = (t) => (e) => {
  const n = ra(e.selection);
  if (n) {
    const r = Kt.get(n.node);
    if (t >= 0 && t <= r.height) {
      const s = n.node, i = C7e(s.type.schema);
      let o = n.start;
      for (let u = 0; u < t + 1; u++)
        o += s.child(u).nodeSize;
      const a = s.child(t);
      let l = [], c = 0;
      if (a.forEach((u) => {
        u.attrs.rowspan === 1 && (c += u.attrs.colspan, l.push(
          i[u.type.spec.tableRole].createAndFill(
            u.attrs,
            u.marks
          )
        ));
      }), c < r.width) {
        let u = [];
        for (let d = t; d >= 0; d--) {
          let f = U7e(d, (p, h) => {
            const m = p.node.attrs.rowspan, v = d + m;
            return m > 1 && v > t;
          })(e);
          u.push(...f);
        }
        u.length && u.forEach((d) => {
          e = V7e(d, {
            rowspan: d.node.attrs.rowspan + 1
          })(e);
        });
      }
      return S7e(
        i.row.create(a.attrs, l),
        o
      )(e);
    }
  }
  return e;
}, W7e = (t) => (e) => {
  const n = ra(e.selection);
  if (n) {
    const r = Kt.get(n.node);
    if (t === 0 && r.width === 1)
      return TI(e);
    if (t >= 0 && t <= r.width)
      return r8(
        e,
        {
          map: r,
          tableStart: n.start,
          table: n.node
        },
        t
      ), Ei(e);
  }
  return e;
}, H7e = (t) => (e) => {
  const n = ra(e.selection);
  if (n) {
    const r = Kt.get(n.node);
    if (t === 0 && r.height === 1)
      return TI(e);
    if (t >= 0 && t <= r.height)
      return s8(
        e,
        {
          map: r,
          tableStart: n.start,
          table: n.node
        },
        t
      ), Ei(e);
  }
  return e;
}, TI = (t) => {
  const { $from: e } = t.selection;
  for (let n = e.depth; n > 0; n--)
    if (e.node(n).type.spec.tableRole === "table")
      return Ei(t.delete(e.before(n), e.after(n)));
  return t;
}, V7e = (t, e) => (n) => t ? (n.setNodeMarkup(t.pos, null, Object.assign({}, t.node.attrs, e)), Ei(n)) : n, z7e = (t) => p8(t, (n) => n.type.spec.tableRole && /cell/i.test(n.type.spec.tableRole)), U7e = (t, e) => (n) => {
  let r = [];
  const s = O7e(t)(n.selection);
  if (s)
    for (let i = s.length - 1; i >= 0; i--)
      e(s[i], n) && r.push(s[i]);
  return r;
};
function G7e(t, e) {
  return xI((n) => n === (e == null ? void 0 : e.firstChild))(t);
}
function Y7e(t, e) {
  return xI((n) => n === (e == null ? void 0 : e.lastChild))(t);
}
function Z7e(t) {
  var e;
  return ((e = t == null ? void 0 : t.firstChild) == null ? void 0 : e.type.name) === "table";
}
function X7e(t) {
  var e;
  return ((e = t == null ? void 0 : t.lastChild) == null ? void 0 : e.type.name) === "table";
}
const K7e = new RegExp("[Ѐ-ӿ]");
function J7e(t) {
  const e = wf(t);
  let n = [];
  return e.forEach(({ node: r, pos: s }) => {
    const i = r.text.split(/\s|-/), o = [];
    i.forEach((a, l) => {
      const c = o[l - 1] ? o[l - 1].endPos + 1 : 0;
      o.push({
        text: a,
        startPos: c,
        endPos: c + a.length
      });
    }), o.forEach((a) => {
      a.text.split("").find((c) => K7e.test(c)) && n.push(
        Qt.inline(s + a.startPos, s + a.endPos, {
          style: "background: rgba(255,67,67,0.1)"
        })
      );
    });
  }), Rt.create(t, n);
}
class q7e extends Xi {
  get name() {
    return "highlightWords";
  }
  get defaultOptions() {
    return {
      enabled: !1
    };
  }
  get plugins() {
    const e = this.options;
    return [
      new lr({
        props: {
          decorations(n) {
            return e.enabled ? J7e(n.doc).map(
              n.tr.mapping,
              n.doc
            ) : Rt.empty;
          }
        }
      })
    ];
  }
}
const Q7e = new RegExp("[Ѐ-ӿ]");
function eFe(t) {
  const e = wf(t);
  let n = [];
  return e.forEach(({ node: r, pos: s }) => {
    for (let i = 0; i < r.nodeSize; i++)
      Q7e.test(r.text[i]) && n.push(
        Qt.inline(s + i, s + i + 1, { style: "color: #ff5252" })
      );
  }), Rt.create(t, n);
}
class tFe extends Xi {
  get name() {
    return "highlightSymbols";
  }
  get defaultOptions() {
    return {
      enabled: !1
    };
  }
  get plugins() {
    const e = this.options;
    return [
      new lr({
        props: {
          decorations(n) {
            return e.enabled ? eFe(n.doc).map(
              n.tr.mapping,
              n.doc
            ) : Rt.empty;
          }
        }
      })
    ];
  }
}
const x3 = [
  "style",
  "class",
  "width",
  "height",
  "align",
  "background",
  "bgcolor",
  "border",
  "color",
  "colspan",
  "ping",
  "rowspan",
  "scope",
  "data-entity-id"
];
class nFe extends Xi {
  /**
   * Конструктор расширения для трансофрмации текста при вставке в редактор.
   * @param options
   * @param options.rules {Array<{ find: {RegExp}, replace: string }>}
   */
  constructor(e = {
    enabled: !1,
    rules: []
  }) {
    super(), this.options = e;
  }
  get name() {
    return "pasteTransformationExtension";
  }
  get defaultOptions() {
    return {
      enabled: !1,
      clearHTML: !1,
      rules: []
    };
  }
  get plugins() {
    const e = this.options;
    return [
      new lr({
        props: {
          transformPastedHTML(n) {
            const r = document.createElement("div");
            return r.innerHTML = n, e.clearHTML ? r.textContent : (r.querySelectorAll(x3.map((s) => `[${s}]`).join(",")).forEach(
              (s) => x3.forEach((i) => s.removeAttribute(i))
            ), r.innerHTML.replace(/&nbsp;/g, " "));
          },
          transformPastedText(n) {
            let r = n;
            return e.enabled && e.rules.length && e.rules.forEach(({ find: s, replace: i }) => {
              r = r.replace(s, i);
            }), r;
          }
        }
      })
    ];
  }
}
function C3(t, e) {
  e(t.tr.setMeta("textCase", !0));
}
function rFe(t, e) {
  const n = t.tr, r = t.selection;
  if (r instanceof gn)
    r.forEachCell((s, i) => {
      T3({
        state: t,
        transaction: n,
        selection: r,
        node: s,
        from: i,
        isTableSelection: !0,
        transformation: e
      });
    });
  else {
    const s = t.doc.cut(r.from, r.to);
    T3({
      state: t,
      transaction: n,
      selection: r,
      node: s,
      isAllSelection: r instanceof Co,
      transformation: e
    });
  }
  return n;
}
function T3({
  state: t,
  transaction: e,
  selection: n,
  node: r,
  from: s,
  isAllSelection: i,
  isTableSelection: o,
  transformation: a
}) {
  const l = wf(r), c = xI(
    (d) => d.type === t.schema.nodes.table
  )(n);
  if (!l.length) return;
  let u = [];
  l.forEach(({ node: d, pos: f }) => {
    const p = d.text;
    p && u.push({ node: d, pos: f, text: p });
  }), u.forEach(({ node: d, pos: f, text: p }) => {
    const h = ["UpperCase", "LowerCase"].includes(a) ? p[`to${a}`]() : lFe(p), m = t.schema.text(h), v = xe.from(m), y = new He(v, 0, 0), _ = o ? s : n.from, w = i ? 0 : o ? -1 : c ? 4 : 1;
    e.replace(
      _ + f - w,
      _ + f + d.nodeSize - w,
      y
    );
  });
}
function sFe(t, e) {
  let n = [];
  if (t instanceof gn)
    t.forEachCell((r) => {
      const s = wf(r);
      s.length && s.forEach(({ node: i, pos: o }) => {
        const a = i.text;
        a && n.push({ node: i, pos: o, text: a });
      });
    });
  else {
    const r = e.doc.cut(t.from, t.to), s = wf(r);
    if (!s.length) return;
    s.forEach(({ node: i, pos: o }) => {
      const a = i.text;
      a && n.push({ node: i, pos: o, text: a });
    });
  }
  return iFe(n);
}
function iFe(t) {
  const e = t.map(({ text: r }) => r).join("");
  return e.match(/([A-ZА-Я])/g) !== null && e.match(/([A-ZА-Я])/g).length > e.length / 2;
}
function oFe(t) {
  const e = ["UpperCase", "LowerCase", "CapitalCase"], n = e.findIndex((r) => r === t);
  return n !== -1 && n < e.length - 1 ? e[n + 1] : e[0];
}
function aFe(t, e) {
  return t && e ? t.ranges[0].$from.pos === e.ranges[0].$from.pos && t.ranges[0].$to.pos === e.ranges[0].$to.pos : !1;
}
function lFe(t) {
  return t.split(" ").map(fR).join(" ").replace(/["']([a-zа-я])/g, (r) => r.toUpperCase());
}
class cFe extends Xi {
  get name() {
    return "TextCase";
  }
  keys() {
    return {
      "Shift-F2": C3
    };
  }
  get plugins() {
    return [
      new lr({
        key: new ci("textCase"),
        state: {
          init() {
            return { selection: null, transformation: null, tr: !1 };
          },
          apply(e, n, r) {
            if (!e.getMeta("textCase"))
              return {
                ...n,
                tr: !1
              };
            const i = r.selection, o = n.transformation;
            let a, l;
            return aFe(n.selection, i) ? a = oFe(o) : (l = sFe(i, r), a = l ? "LowerCase" : "UpperCase"), {
              selection: i,
              transformation: a,
              tr: !0
            };
          }
        },
        view() {
          const e = this;
          return {
            update(n) {
              const r = e.key.get(n.state).getState(n.state);
              r.tr && r.transformation && n.dispatch(rFe(n.state, r.transformation));
            }
          };
        }
      })
    ];
  }
  commands() {
    return {
      transformCase: () => C3
    };
  }
}
const pg = {
  title: {
    type: String,
    default: ""
  },
  newsItemId: {
    type: [String, Number],
    default: null
  },
  block: {
    type: Object,
    required: !0
  },
  type: {
    type: String,
    default: null
  },
  enabled: {
    type: Boolean,
    default: !0
  },
  editableCanChange: {
    type: Boolean,
    default: !1
  },
  content: {
    type: String,
    default: ""
  },
  settings: {
    type: Object,
    default: () => ({})
  },
  editorExtensions: {
    type: Array,
    default: () => []
  },
  editorMenuItems: {
    type: Array,
    default: () => []
  },
  errorClasses: {
    type: Array,
    default: () => []
  },
  errors: {
    type: Array,
    default: () => []
  },
  langId: {
    type: Number,
    default: 1
  },
  typeId: {
    type: Number,
    default: 1
  },
  moexCodes: {
    type: Object,
    default: () => ({})
  },
  codes: {
    type: Array,
    default: () => []
  },
  entities: {
    type: Array,
    default: () => []
  },
  newsCodes: {
    type: Object,
    default: () => ({})
  },
  codeItems: {
    type: Object,
    default: () => ({})
  },
  isBig: {
    type: Boolean,
    default: !0
  },
  historyStack: {
    type: Object,
    default: null
  },
  useValidate: {
    type: Boolean,
    default: !0
  }
};
function uFe(t) {
  const e = f7e(t);
  return new lr({
    key: e.spec.key,
    state: {
      init() {
        return e.spec.state.init();
      },
      apply(n, r, s) {
        const i = e.spec.state.apply(n, r, s);
        if (n.getMeta("addToHistory") === !1)
          return i;
        if (n.docChanged && i.done.eventCount > p7e(s)) {
          const o = n.getMeta(this.key);
          if (!o) {
            const a = this.spec.config.editorType;
            this.spec.config.historyStack.undo.push(a);
          }
          o && o.redo || this.spec.config.historyStack.redo.splice(0);
        }
        return i;
      }
    },
    config: t
  });
}
class dFe extends Xi {
  get name() {
    return "globalHistory";
  }
  get plugins() {
    return [uFe(this.options)];
  }
  commands() {
    return {
      undo: () => d8,
      redo: () => f8
    };
  }
}
function P3(t, e, n = {}) {
  t.dom.dispatchEvent(
    new CustomEvent(e, {
      bubbles: !0,
      detail: {
        view: t,
        data: n
      }
    })
  );
}
class fFe extends Xi {
  get name() {
    return "selection-helper";
  }
  get plugins() {
    return [
      new lr({
        view() {
          return {
            update(e, n) {
              if (n && n.doc.eq(e.state.doc) && n.selection.eq(e.state.selection))
                return;
              if (e.state.selection.empty) {
                P3(e, "selectionChange", {
                  text: null,
                  pmSelection: e.state.selection,
                  from: e.state.selection.from,
                  to: e.state.selection.to
                });
                return;
              }
              const r = e.state.doc.cut(
                e.state.selection.from,
                e.state.selection.to
              );
              P3(e, "selectionChange", {
                text: r.textContent,
                pmSelection: e.state.selection,
                from: e.state.selection.from,
                to: e.state.selection.to
              });
            }
          };
        }
      })
    ];
  }
}
class pFe extends Xi {
  /**
   * Конструктор расширения для регистрации комбинаций клавиш
   * @param keybindings {Object} Комбинации клавиш в формате { [имя_клавиши]: [функция] }
   */
  constructor(e = {}) {
    super(), this.keybindings = e;
  }
  get name() {
    return "keybindings-handler";
  }
  keys() {
    return this.keybindings;
  }
}
const hFe = {
  name: "PbTextEditor",
  components: {
    EditorContent: u9e,
    EditorFloatingMenu: p9e,
    PbIcon: cc
  },
  props: {
    type: {
      type: String,
      required: !0
    },
    isBig: {
      type: Boolean,
      default: !0
    },
    content: {
      type: String,
      default: ""
    },
    editorExtensions: {
      type: Array,
      default: () => []
    },
    editorMenuItems: {
      type: Array,
      default: () => []
    },
    keybindings: {
      type: Object,
      default: () => ({})
    },
    editable: {
      type: Boolean,
      default: !0
    },
    editableCanChange: {
      type: Boolean,
      default: !1
    },
    newsItemId: {
      type: [String, Number],
      default: null
    },
    historyStack: Object
  },
  data() {
    let t = [];
    return (this.editable || this.editableCanChange) && (t = [
      new fFe(),
      new pFe(this.keybindings),
      new dFe({
        depth: 100,
        newGroupDelay: 500,
        editorType: this.type,
        historyStack: this.historyStack
      })
    ]), {
      defaultExtensions: t,
      focused: !1,
      editor: null,
      view: {},
      menuList: {
        isVisible: !1,
        position: {},
        timeout: null
      },
      draftScrollTop: 0
    };
  },
  computed: {
    extensions() {
      return [...this.editorExtensions, ...this.defaultExtensions];
    },
    views() {
      return this.editor ? this.editor.views : {};
    },
    processedContent() {
      return this.content || "";
    },
    menuListClass() {
      return (t, e) => ({
        "editor__floating-menu-list": !0,
        _bottom: this.isMenuAtBottom(t, e)
      });
    },
    editorFieldClass() {
      return [
        "editor__field",
        { disabled: !this.editable && this.editableCanChange }
      ];
    }
  },
  watch: {
    processedContent(t, e) {
      this.userInput ? this.userInput = !1 : t !== e && this.editor && this.editor.setContent(t);
    },
    "menuList.isVisible": function(t, e) {
      t !== e && t && this.calculateMenuPosition();
    },
    // При изменении размеров панели некорректно пересчитывается
    // позиция плавающего меню. Этот вотчер принудительно её сбрасывает.
    isBig(t, e) {
      t !== e && this.$refs.floatingMenu && this.$set(this.$refs.floatingMenu.menu, "top", 0);
    },
    draftScrollTop() {
      this.handleCalculatePosition();
    },
    async editable(t) {
      this.editor.setOptions({ editable: t });
    },
    newsItemId() {
      this.emitInitEditorStore();
    }
  },
  created() {
    this.state = null, this.view = null, this.scopedData = {}, this.userInput = !1;
  },
  mounted() {
    this.editor = new c9e({
      content: this.processedContent,
      editable: this.editable,
      extensions: this.extensions,
      onFocus: this.emitFocus,
      onBlur: this.emitBlur,
      onInit: this.init,
      onUpdate: this.emitUpdate,
      onDrop: this.emitDrop
    }), this.editorMenuItems.length && (this.handleHideMenu = za(this.hideMenu, 600, { leading: !1 }), this.handleCalculatePosition = za(this.calculateMenuPosition, 10), this.$nextTick(() => {
      this.$nextTick(() => {
        this.draft = this.editor.view.dom.closest(".news-draft"), this.draftScrollHandler = () => {
          this.draftScrollTop = this.draft.scrollTop;
        }, this.draft.addEventListener("scroll", this.draftScrollHandler);
      });
    }));
  },
  beforeDestroy() {
    this.editor.destroy(), this.editorMenuItems.length && this.draft.removeEventListener("scroll", this.draftScrollHandler);
  },
  methods: {
    emitUpdate(t) {
      this.userInput = !0, this.$emit("update", t.getHTML()), this.emitInitEditorStore();
    },
    emitFocus() {
      this.userInput = !0, this.$emit("focus");
    },
    emitBlur({ event: t, state: e, view: n } = {}) {
      this.userInput = !1;
      const r = t.explicitOriginalTarget || t.relatedTarget, s = r && r.nodeType === 1 && r.getAttribute("role") || void 0;
      s !== "editor-internal" && (["undo", "redo"].includes(s) ? this.$emit("editorBlur", { state: e, view: n, history: !0 }) : this.$emit("editorBlur", { state: e, view: n }));
    },
    emitDrop(t, e, n, r) {
      r || this.$emit("editorDrop");
    },
    emitInitEditorStore() {
      this.$emit("initEditorStore", {
        type: this.type,
        editor: {
          view: this.editor.view,
          state: this.editor.state,
          editor: this.editor
        }
      });
    },
    init() {
      this.$nextTick(() => {
        this.view = this.editor.view, this.state = this.editor.state, this.emitInitEditorStore();
      });
    },
    calculateMenuPosition() {
      this.$nextTick(() => {
        const t = this.$refs.button.getBoundingClientRect();
        this.menuList.position = {
          top: "auto",
          bottom: "auto",
          ...this.menuAtBottom ? { bottom: `${window.innerHeight - t.bottom}px` } : { top: `${t.top}px` },
          left: `${globalThis.scrollX + t.left + t.width}px`
        };
      });
    },
    isMenuAtBottom(t, e) {
      const n = t.closest(".news-draft"), r = t.closest(".editor-root");
      if (!n || !r)
        return !1;
      const s = n.offsetHeight, o = r.offsetTop - n.scrollTop + e + 200;
      return this.menuAtBottom = o > s, this.menuAtBottom;
    },
    forceInitEditor() {
      this.editor.initEditor();
    },
    forceUpdateEditor() {
      this.view.update(this.view.props);
    },
    focus() {
      this.view.focus();
    },
    blur() {
      this.view.blur();
    },
    hasFocus() {
      return this.view ? this.view.hasFocus() : !1;
    },
    bindScopedData(t) {
      this.scopedData = t;
    },
    handleMenuCommand(t, e) {
      this.$emit("editorMenuCommand", { commands: t, command: e }), this.hideMenu();
    },
    showMenu() {
      this.menuList.timeout && (clearTimeout(this.menuList.timeout), this.handleHideMenu.cancel()), this.menuList.isVisible = !0;
    },
    hideMenu() {
      this.menuList.timeout = setTimeout(() => {
        this.menuList.isVisible = !1;
      }, 0);
    }
  }
};
var mFe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-text-editor" }, [e._t("header"), n("main", [n("div", { staticClass: "editor__block-indicator" }, [e._t("indicators")], 2), e.editable ? n("EditorFloatingMenu", { ref: "floatingMenu", attrs: { editor: e.editor }, scopedSlots: e._u([{ key: "default", fn: function({ commands: r, isActive: s, menu: i }) {
    return [e.editorMenuItems.length ? n("div", { staticClass: "editor__floating-menu", class: { "is-active": i.isActive }, style: `top: ${i.top}px`, on: { mouseleave: e.handleHideMenu } }, [n("button", { ref: "button", staticClass: "editor__menu-button", on: { mouseenter: e.showMenu } }, [n("PbIcon", { attrs: { type: "font", name: "add", size: "15" } })], 1), n("portal", { attrs: { to: "newsTextEditorWidgets" } }, [e.editable && e.menuList.isVisible ? n("div", { class: e.menuListClass(e.editor.view.dom, i.top), style: e.menuList.position, on: { mouseenter: () => e.handleHideMenu.cancel() } }, e._l(e.editorMenuItems, function(o, a) {
      return n(o, { key: a, tag: "component", attrs: { hideMenu: e.handleHideMenu, menuAtBottom: e.isMenuAtBottom(e.editor.view.dom, i.top) }, on: { command: function(l) {
        return e.handleMenuCommand(r, l);
      } } });
    }), 1) : e._e()])], 1) : e._e()];
  } }], null, !1, 1699713862) }) : e._e(), n("div", { ref: "field", class: e.editorFieldClass, attrs: { "data-test-selector": "text-editor-field" } }, [n("EditorContent", { ref: "tiptap", attrs: { editor: e.editor } })], 1), e._t("editorAction")], 2), e._t("footer", null, null, e.scopedData)], 2);
}, vFe = [], gFe = /* @__PURE__ */ B(
  hFe,
  mFe,
  vFe,
  !1,
  null,
  null
);
const yFe = gFe.exports;
class PI extends Ki {
  constructor(e) {
    super(), this.options = e;
  }
  get name() {
    return "entity";
  }
  get defaultOptions() {
    return {
      checkIsCode: () => !1,
      getEntities: () => []
    };
  }
  get schema() {
    const e = this.options;
    return {
      attrs: {
        id: {},
        score: {},
        text: {
          default: ""
        },
        style: {
          default: e.style
        }
      },
      group: "inline",
      inline: !0,
      atom: !1,
      skip: !0,
      content: "text*",
      toDOM: (n) => [
        "span",
        {
          "data-entity-id": n.attrs.id,
          "data-entity-score": n.attrs.score,
          style: n.attrs.style
        },
        n.attrs.text
      ],
      parseDOM: [
        {
          tag: "span[data-entity-id]",
          getAttrs: (n) => {
            const r = {
              id: n.getAttribute("data-entity-id"),
              score: n.getAttribute("data-entity-score"),
              text: n.innerText
            };
            return r.id && e.getEntities().find(({ entity: i } = {}) => !e.checkIsCode(i)) ? r : !1;
          }
        }
      ]
    };
  }
}
const bFe = {
  name: "ForbiddenEntity",
  props: {
    node: {
      type: Object,
      required: !0
    },
    options: {
      type: [Object],
      required: !0
    }
  },
  computed: {
    entites() {
      var t, e;
      return ((e = (t = this.options) == null ? void 0 : t.getEntities()) == null ? void 0 : e.map(({ entity: n } = {}) => n)) ?? [];
    },
    entity() {
      return this.entites.find(
        (t) => t.id === parseInt(this.node.attrs.id)
      );
    },
    entityStyle() {
      return {
        color: "#ffffff",
        backgroundColor: this.options.getColor(this.entity) ?? this.options.defaultColor,
        padding: "0 2px"
      };
    },
    entityText() {
      const t = this.entity.list_ids.map((e) => {
        var n;
        return (n = this.options) == null ? void 0 : n.getEntityListType(e);
      });
      return this.entity && t ? `<div style="max-width: 400px;"><b>${this.entity.name}</b><br>Входит в списки запрещённых организаций:
        <ul style="list-style: inside;">${t.map(
        (e) => `<li>${e.description}`
      )}</ul></div>` : null;
    }
  }
};
var _Fe = function() {
  var e = this, n = e._self._c;
  return n("span", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: { html: !0, content: e.entityText }, expression: "{ html: true, content: entityText }" }], style: e.entityStyle, attrs: { "data-entity-id": e.node.attrs.id, "data-entity-score": e.node.attrs.score } }, [e._v(e._s(e.node.attrs.text))]);
}, wFe = [], SFe = /* @__PURE__ */ B(
  bFe,
  _Fe,
  wFe,
  !1,
  null,
  null
);
const IFe = SFe.exports;
class EFe extends PI {
  get name() {
    return "forbiddenEntity";
  }
  get defaultOptions() {
    return {
      getColor: () => "#F6C344",
      getEntityListType: () => null,
      defaultColor: "#F6C344",
      getEntities: () => []
    };
  }
  get schema() {
    const e = this.options;
    return {
      attrs: {
        id: {},
        score: {},
        style: {
          default: e.style
        },
        text: {
          default: ""
        }
      },
      group: "inline",
      inline: !0,
      content: "text*",
      selectable: !0,
      toDOM: super.schema.toDOM,
      parseDOM: [
        {
          tag: "span[data-entity-id]",
          getAttrs: (n) => {
            var s;
            const r = {
              id: n.getAttribute("data-entity-id"),
              score: n.getAttribute("data-entity-score"),
              text: n.innerText
            };
            return r.id && ((s = e.getEntities().find(({ entity: o } = {}) => parseInt(o == null ? void 0 : o.id, 10) === parseInt(r.id, 10))) == null ? void 0 : s.entity) ? r : !1;
          }
        }
      ]
    };
  }
  get view() {
    return IFe;
  }
}
const xFe = {
  name: "NotExistedEntity",
  props: {
    node: {
      type: Object,
      required: !0
    },
    options: {
      type: [Object],
      required: !0
    }
  }
};
var CFe = function() {
  var e = this, n = e._self._c;
  return n("span", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: {
    html: !0,
    content: "Данная сущность отсутствует"
  }, expression: `{
    html: true,
    content: 'Данная сущность отсутствует'
  }` }], style: e.options.style, attrs: { "data-entity-id": e.node.attrs.id, "data-entity-score": e.node.attrs.score } }, [e._v(e._s(e.node.attrs.text))]);
}, TFe = [], PFe = /* @__PURE__ */ B(
  xFe,
  CFe,
  TFe,
  !1,
  null,
  null
);
const kFe = PFe.exports;
class NFe extends PI {
  get name() {
    return "notExistedEntity";
  }
  get defaultOptions() {
    return {
      getEntities: () => [],
      style: "color: rgba(0, 0, 0, 0.4);"
    };
  }
  get schema() {
    const e = this.options;
    return {
      attrs: {
        id: {},
        score: {},
        style: {
          default: e.style
        },
        text: {
          default: ""
        }
      },
      group: "inline",
      inline: !0,
      content: "text*",
      selectable: !0,
      toDOM: super.schema.toDOM,
      parseDOM: [
        {
          tag: "span[data-entity-id]",
          getAttrs: (n) => {
            const r = {
              id: n.getAttribute("data-entity-id"),
              score: n.getAttribute("data-entity-score"),
              text: n.innerText
            };
            return e.getEntities().map(({ entity: i }) => i.id).includes(parseInt(r.id)) ? !1 : r;
          }
        }
      ]
    };
  }
  get view() {
    return kFe;
  }
}
const $Fe = "_root_1q4ej_1", DFe = "_NewsEditorIndicator__popup_1q4ej_15", AFe = {
  root: $Fe,
  NewsEditorIndicator__popup: DFe
}, OFe = {
  name: "NewsEditorIndicator",
  mixins: [q4],
  components: {
    PbTextCounters: Q4,
    PsKitPopup: Ls
  },
  props: {
    block: {
      type: Object,
      required: !0
    },
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      labels: {
        slugline: "SL",
        headline: "H1",
        subheadline: "H2",
        trashline: "TR",
        dateline: "DT",
        body: "TX"
      },
      popupVisible: !1
    };
  },
  computed: {
    type() {
      return this.block.type;
    }
  }
};
var MFe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.type, e.$style.root], attrs: { "data-test-selector": e.type, "data-test-attrs": `symbols__${e.symbolCounter} words__${e.wordCounter}` }, on: { mouseenter: function(r) {
    e.popupVisible = !0;
  }, mouseleave: function(r) {
    e.popupVisible = !1;
  } } }, [e._v(" " + e._s(e.labels[e.type]) + " "), e.popupVisible ? n("PsKitPopup", { attrs: { classPopup: [e.$style.NewsEditorIndicator__popup], placement: "top", visible: e.popupVisible, arrowSize: 8 }, on: { hide: function(r) {
    e.popupVisible = !1;
  } }, scopedSlots: e._u([{ key: "default", fn: function() {
    return [n("span", { staticClass: "editor__title", attrs: { "data-test-selector": "text-editor-title" } }, [e._v(" " + e._s(e.block.title) + " ")]), n("PbTextCounters", { attrs: { symbolCounter: e.symbolCounter, wordCounter: e.wordCounter } })];
  }, proxy: !0 }], null, !1, 2266124742) }) : e._e()], 1);
}, RFe = [];
const k3 = {
  $style: AFe
};
function LFe(t) {
  for (var e in k3)
    this[e] = k3[e];
}
var FFe = /* @__PURE__ */ B(
  OFe,
  MFe,
  RFe,
  !1,
  LFe,
  null
);
const BFe = FFe.exports, jFe = {
  name: "DisableSwitcher",
  props: {
    blockName: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    buttonClass() {
      return ["block-action", { disabled: this.disabled }];
    },
    iconName() {
      return this.disabled ? "lock" : "lock_open";
    },
    tooltipContent() {
      switch (this.blockName) {
        case "dateline":
          return "Поле предназначено для выходных данных. Здесь должны быть: город, дата, название агентства и дефис.";
        default:
          return "";
      }
    }
  }
};
var WFe = function() {
  var e = this, n = e._self._c;
  return n("button", { class: e.buttonClass, on: { click: function(r) {
    return e.$emit("updateDisable");
  } } }, [n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: {
    content: e.tooltipContent,
    style: { pointerEvents: "auto" }
  }, expression: `{
      content: tooltipContent,
      style: { pointerEvents: 'auto' }
    }` }], attrs: { type: "font", name: e.iconName, size: "18" } })], 1);
}, HFe = [], VFe = /* @__PURE__ */ B(
  jFe,
  WFe,
  HFe,
  !1,
  null,
  "3b0602b1"
);
const zFe = VFe.exports, UFe = {
  name: "NewsEditorDefaultBlock",
  components: {
    PbTextEditor: yFe,
    NewsEditorIndicator: BFe,
    DisableSwitcher: zFe
  },
  props: pg,
  data() {
    const t = this.block.title, e = (r) => {
      const s = this.getEntityListTypeById(r.list_ids[0]);
      return IJ[s.name];
    }, n = (r) => this.getEntityListTypeById(r);
    return {
      defaultExtensions: [
        this.hlWordsExt,
        this.hlSymbolsExt,
        new nFe({
          enabled: !0,
          clearHTML: ["slugline", "headline", "trashline"].includes(
            this.block.type
          ),
          rules: [
            { find: new RegExp("( ){2,}", "g"), replace: " " },
            { find: new RegExp("	", "g"), replace: "" },
            { find: new RegExp(`
`, "g"), replace: "" }
          ]
        }),
        new y7e({
          emptyNodeClass: "is-empty",
          emptyNodeText: t,
          showOnlyWhenEditable: !1
        }),
        new cFe(),
        new EFe({
          getEntityListType: n,
          getColor: e,
          style: "padding: 0 2px; background: #F6C344; color: #ffffff;",
          getEntities: this.getForbiddenEntities
        }),
        new NFe({
          getEntityListType: n,
          style: "color: rgba(0, 0, 0, 0.4);",
          getEntities: () => this.entities
        })
      ],
      defaultMenuItems: [],
      moexManager: {},
      editor: {}
    };
  },
  computed: {
    ...pe("references", [
      "newsTypesByName",
      "isForbiddenByEntity",
      "entityListTypesByName",
      "getEntityListTypeById"
    ]),
    extensions() {
      return [...this.defaultExtensions, ...this.editorExtensions];
    },
    menuItems() {
      return [...this.defaultMenuItems, ...this.editorMenuItems];
    },
    views() {
      return this.$refs.editor ? this.$refs.editor.views : {};
    },
    keybindings() {
      const t = typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
      let e = {
        "Mod-z": this.undoPressed,
        "Mod-я": this.undoPressed,
        "Shift-Mod-z": this.redoPressed,
        "Shift-Mod-я": this.redoPressed,
        Escape: (n, r, s) => (s.dom.blur(), this.$emit("escPressed"), !0),
        Tab: () => (this.$emit("navDown"), !0),
        "Shift-Tab": () => (this.$emit("navUp"), !0),
        "Alt-Enter": () => (this.$emit("altEnterPressed"), !0),
        ArrowUp: (n) => {
          var r, s;
          return (r = n == null ? void 0 : n.selection) != null && r.empty && G7e(n.selection, n.doc) && !Z7e(n.doc) && ((s = n.selection.$head) == null ? void 0 : s.nodeBefore) === null ? (this.$emit("navUp"), !0) : !1;
        },
        ArrowDown: (n) => {
          var r, s;
          return (r = n == null ? void 0 : n.selection) != null && r.empty && Y7e(n.selection, n.doc) && !X7e(n.doc) && ((s = n.selection.$head) == null ? void 0 : s.nodeAfter) === null ? (this.$emit("navDown"), !0) : !1;
        }
      };
      return t || (e["Mod-y"] = this.redoPressed, e["Mod-н"] = this.redoPressed), this.keys && (e = {
        ...e,
        ...this.keys
      }), e;
    },
    hasForbiddenEntities() {
      var t, e;
      return (e = (t = this.editor) == null ? void 0 : t.state) != null && e.doc ? h8(
        this.editor.state.doc,
        this.editor.schema.nodes.forbiddenEntity
      ).length > 0 : !1;
    },
    rootClass() {
      return [...this.errorClasses, "editor", this.type];
    }
  },
  watch: {
    errors() {
      this.$refs.editor && this.$refs.editor.forceUpdateEditor();
    },
    langId: {
      handler(t, e) {
        t !== e && (t === 2 ? (this.content === null || this.content && this.content.length < 1e4) && (this.hlSymbolsExt.options.enabled = !0, this.hlWordsExt.options.enabled = !0) : (this.hlSymbolsExt.options.enabled = !1, this.hlWordsExt.options.enabled = !1), this.$refs.editor && this.$refs.editor.forceUpdateEditor());
      },
      immediate: !0
    },
    hasForbiddenEntities(t) {
      t ? this.$emit("addValidationError", {
        code: "FORBIDDEN_ENTITY",
        detail: "Поле содержит название запрещённой организации",
        level: "warning"
      }) : this.$emit("removeValidationError", { code: "FORBIDDEN_ENTITY" });
    }
  },
  beforeCreate() {
    this.hlWordsExt = new q7e(), this.hlSymbolsExt = new tFe();
  },
  methods: {
    handleEditorBlur(t) {
      this.$emit("editorBlur", t);
    },
    focus() {
      this.$refs.editor && this.$refs.editor.focus();
    },
    hasFocus() {
      return this.$refs.editor ? this.$refs.editor.hasFocus() : !1;
    },
    getForbiddenEntities() {
      return this.entities.filter(
        ({ entity: t }) => this.isForbiddenByEntity(t)
      );
    },
    undoPressed() {
      return this.$emit("undoPressed", this.type), !0;
    },
    redoPressed() {
      return this.$emit("redoPressed", this.type), !0;
    },
    init(t) {
      this.editor = t.editor.editor, this.$emit("initEditorStore", t);
    }
  }
};
var GFe = function() {
  var e = this, n = e._self._c;
  return n("PbTextEditor", { ref: "editor", class: e.rootClass, attrs: { type: e.type, isBig: e.isBig, content: e.content, keybindings: e.keybindings, editorExtensions: e.extensions, editorMenuItems: e.menuItems, historyStack: e.historyStack, editable: e.enabled, editableCanChange: e.editableCanChange, newsItemId: e.newsItemId, "data-test-selector": "news-item-editor-field", "data-test-attrs": `type__${e.type}` }, on: { update: function(r) {
    return e.$emit("update", r);
  }, focus: function(r) {
    return e.$emit("focus");
  }, editorBlur: e.handleEditorBlur, editorDrop: function(r) {
    return e.$emit("editorDrop");
  }, initEditorStore: function(r) {
    return e.init(r);
  }, editorMenuCommand: function(r) {
    return e.$emit("editorMenuCommand", r);
  } }, scopedSlots: e._u([{ key: "header", fn: function() {
    return [n("header", [e._t("headerBlock", function() {
      return [e.errors.length ? e._l(e.errors, function(r, s) {
        return n("div", { key: `error-${s}`, attrs: { "data-test-selector": "text-editor-errors" } }, [n("span", { class: `${r.level}-message`, attrs: { "data-test-selector": `text-editor-${r.level}`, "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail) + " ")])]);
      }) : e._e()];
    })], 2)];
  }, proxy: !0 }, { key: "indicators", fn: function() {
    return [e._t("blockIdicator", function() {
      return [n("NewsEditorIndicator", { attrs: { block: e.block, content: e.content } })];
    })];
  }, proxy: !0 }, { key: "editorAction", fn: function() {
    return [e.editableCanChange ? n("DisableSwitcher", { attrs: { blockName: e.block.type, disabled: e.block.disabled }, on: { updateDisable: function(r) {
      return e.$emit("updateDisable", {
        blockName: e.block.type,
        value: !e.block.disabled
      });
    } } }) : e._e()];
  }, proxy: !0 }], null, !0) });
}, YFe = [], ZFe = /* @__PURE__ */ B(
  UFe,
  GFe,
  YFe,
  !1,
  null,
  null
);
const Xo = ZFe.exports, N3 = U.extend(Xo).extend({
  name: "NewsEditorDatelineBlock",
  data() {
    return {
      keys: {
        Enter: () => (this.$emit("navDown"), !0)
      }
    };
  },
  watch: {
    async type(t, e) {
      t !== e && await this.validate();
    },
    async content(t, e) {
      t !== e && await this.validateLength();
    }
  },
  methods: {
    handleEditorBlur(t) {
      this.validateHyphen(), this.$emit("editorBlur", t);
    },
    async validateLength() {
      (await Kn.process("trimHTML", this.content)).length > 80 ? this.$emit("addValidationError", {
        code: "UNRECOMMENDED_FORMAT",
        detail: "Рекомендуемый размер дейтлайна - не более 80 символов",
        level: "warning"
      }) : this.$emit("removeValidationError", { code: "UNRECOMMENDED_FORMAT" });
    },
    async validateHyphen() {
      const t = new RegExp(".*-$"), e = await Kn.process("trimHTML", this.content);
      t.test(e) ? this.$emit("removeValidationError", { code: "WRONG_FORMAT" }) : this.$emit("addValidationError", {
        code: "WRONG_FORMAT",
        detail: "Здесь должны быть: город, дата, название агентства и дефис",
        level: "error"
      });
    }
  }
}), XFe = new lr({
  key: new ci("sluglineRulesPlugin"),
  appendTransaction(t, e, n) {
    const r = t[t.length - 1], s = n.tr;
    if (r.docChanged && !r.isGeneric && (r.getMeta("uiEvent") === "paste" || r.getMeta("uiEvent") === "drop")) {
      const i = n.doc.textContent.replace(/\s/g, "-").toUpperCase();
      s.delete(1, n.doc.content.size), s.insertText(i, 1);
    }
    return s;
  }
}), KFe = new V9(
  new RegExp(/\s$/),
  (t, e, n, r) => t.tr.insertText("-", n, r).setMeta("sluglineSpaceReplace", !0)
), JFe = new V9(
  new RegExp(/[^\s]+$/),
  (t, e, n, r) => t.tr.insertText(e.input.toUpperCase(), n, r).setMeta("sluglineUppercase", !0)
);
class qFe extends Xi {
  get name() {
    return "sluglineRulesExtension";
  }
  get defaultOptions() {
    return {
      enabled: !0
    };
  }
  inputRules() {
    return [KFe, JFe];
  }
  get plugins() {
    return [XFe];
  }
}
class v8 extends Ki {
  get name() {
    return "doc";
  }
  get schema() {
    return {
      content: "paragraph{1}"
    };
  }
}
const $3 = U.extend(Xo).extend({
  name: "NewsEditorSluglineBlock",
  data() {
    return {
      keys: {
        Backspace: (t, e) => (Q6e(t, e), !1),
        Enter: () => (this.$emit("navDown"), !0)
      }
    };
  },
  computed: {
    extensions() {
      return [
        ...[...this.defaultExtensions].filter(
          (e) => e.name !== "TextCase"
        ),
        ...this.editorExtensions,
        new qFe(),
        new v8()
      ];
    }
  },
  watch: {
    async typeId(t, e) {
      t !== e && await this.validate();
    },
    async content(t, e) {
      t !== e && await this.validate();
    }
  },
  methods: {
    async validate() {
      const t = new RegExp("^([^-]{0,32})(-([^-]{0,32})){0,4}$"), e = await Kn.process("trimHTML", this.content);
      e.length > 64 ? this.$emit("addValidationError", {
        code: "STRING_TOO_LONG",
        detail: "Слаглайн не должен быть длиннее 64 символов.",
        level: "error"
      }) : this.$emit("removeValidationError", { code: "STRING_TOO_LONG" }), t.test(e) ? this.$emit("removeValidationError", { code: "WRONG_FORMAT" }) : this.$emit("addValidationError", {
        code: "WRONG_FORMAT",
        level: "error",
        detail: "В слаглайне не должно быть слов длиннее 32 символов. Максимальное количество слов — 5."
      });
    }
  }
}), D3 = U.extend(Xo).extend({
  name: "NewsEditorSubheadlineBlock",
  watch: {
    async typeId(t, e) {
      t !== e && await this.validate();
    },
    async content(t, e) {
      t !== e && await this.validate();
    }
  },
  methods: {
    async validate() {
      (await Kn.process("trimHTML", this.content)).length > 500 ? this.$emit("addValidationError", {
        code: "STRING_TOO_LONG",
        detail: "Подзаголовок не должен быть длиннее 500 символов.",
        level: "error"
      }) : this.$emit("removeValidationError", { code: "STRING_TOO_LONG" });
    }
  }
}), A3 = U.extend(Xo).extend({
  name: "NewsEditorInlineBlock",
  data() {
    return {
      keys: {
        Enter: () => (this.$emit("navDown"), !0)
      }
    };
  },
  computed: {
    extensions() {
      return [
        ...this.defaultExtensions,
        ...this.editorExtensions,
        new v8()
      ];
    }
  }
}), QFe = {
  name: "CodeEntity",
  props: {
    node: {
      type: Object,
      required: !0
    },
    options: {
      type: [Object],
      required: !0
    }
  },
  computed: {
    entityText() {
      var e, n;
      const { entity: t } = ((n = (e = this.options) == null ? void 0 : e.getEntities()) == null ? void 0 : n.find(({ entity: r } = {}) => r.id === parseInt(this.node.attrs.id))) ?? {};
      return t ? `${Object.values(t.properties).map(
        (r) => `<b>${r}</b> — `
      )}${t.name}` : null;
    }
  }
};
var eBe = function() {
  var e = this, n = e._self._c;
  return n("span", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: { html: !0, content: e.entityText }, expression: "{ html: true, content: entityText }" }], style: e.options.style, attrs: { "data-entity-id": e.node.attrs.id, "data-entity-score": e.node.attrs.score, "data-uid": e.node.attrs.uid } }, [e._v(e._s(e.node.attrs.text))]);
}, tBe = [], nBe = /* @__PURE__ */ B(
  QFe,
  eBe,
  tBe,
  !1,
  null,
  null
);
const rBe = nBe.exports;
class sBe extends Ki {
  constructor(e) {
    super(), this.options = e;
  }
  get name() {
    return "codeEntity";
  }
  get defaultOptions() {
    return {
      class: "editor__code",
      style: "color: #0069e4",
      getEntities: () => [],
      checkIsCode: () => !1
    };
  }
  get schema() {
    const e = this.options;
    return {
      attrs: {
        id: {},
        score: {},
        class: {
          default: e.class
        },
        style: {
          default: e.style
        },
        text: {
          default: ""
        },
        uid: {
          default: Math.round(Math.random() * 1e6)
        }
      },
      group: "inline",
      inline: !0,
      content: "text*",
      selectable: !0,
      toDOM: (n) => [
        "span",
        {
          class: n.attrs.class,
          style: n.attrs.style,
          "data-entity-id": n.attrs.id,
          "data-entity-score": n.attrs.score,
          "data-uid": n.attrs.uid
        },
        n.attrs.text
      ],
      parseDOM: [
        {
          tag: "span[data-entity-id]",
          getAttrs: (n) => {
            const r = {
              id: n.getAttribute("data-entity-id"),
              score: n.getAttribute("data-entity-score"),
              text: n.innerText,
              uid: n.getAttribute("data-uid") ?? Math.round(Math.random() * 1e6)
            };
            return r.id && e.getEntities().find(({ entity: i } = {}) => parseInt(i == null ? void 0 : i.id, 10) === parseInt(r.id, 10) && e.checkIsCode(i)) ? r : !1;
          }
        }
      ]
    };
  }
  get view() {
    return rBe;
  }
}
const iBe = {
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    },
    type: {
      type: String,
      default: null
    },
    fontSize: {
      type: Number,
      default: 16
    },
    hasFocus: {
      type: Function,
      default: () => !1
    },
    editor: {
      type: Object,
      default: () => ({})
    },
    entities: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    textSize() {
      return this.fontSize > 14 && this.fontSize < 24 ? this.fontSize * 0.75 : this.fontSize >= 24 ? 24 * 0.75 : this.fontSize <= 12 ? 12 * 0.75 : 16 * 0.75;
    },
    $_newsEditors() {
      return this.$store.$_newsEditors[this.newsItemId];
    },
    /**
     * Проверяет, содержится ли код в соседнем редакторе.
     * Используется для корректного удаления кода из текста.
     * @param {number} id Идентификатор кода
     * @returns {boolean}
     */
    isCodeExistsInAnotherEditor() {
      return (t) => {
        let e;
        this.type === "body" && (e = "background"), this.type === "background" && (e = "body"), this.type === "headline" && (e = "headline");
        const n = this.$store.$_newsEditors[e];
        return n ? N7e(
          n.editor.state.doc,
          (s) => Number(s.id) === t
        ).length > 0 : !1;
      };
    }
  },
  methods: {
    ...ge("news/drafts", {
      async deleteCode(t, e) {
        const n = e.detail.data.map((r) => Number(r.id)).filter((r) => !this.isCodeExistsInAnotherEditor(r));
        await t("deleteCodes", {
          newsItemId: this.newsItemId,
          codeIds: n,
          inTextCheck: !0
        }), await this.$nextTick(), this.save();
      },
      async addCode(t, e) {
        const n = e.detail.data.map((r) => Number(r.id));
        await t("addCodes", {
          newsItemId: this.newsItemId,
          codeIds: n,
          inTextCheck: !0
        }), await this.$nextTick(), this.save();
      },
      save(t) {
        return t("saveDraft", {
          newsItemId: this.newsItemId
        });
      }
    })
  }
}, oBe = {
  name: "WithEntities",
  inject: ["getColorScheme"],
  mixins: [iBe],
  computed: {
    extensions() {
      return [
        new sBe({
          class: "editor__code",
          style: "color: var(--theme-codeColorHighlight)",
          getEntities: () => this.entities,
          checkIsCode: this.checkIsCode
        }),
        new PI({
          getEntities: () => this.entities,
          style: "color: rgba(0, 0, 0, 0.4);",
          checkIsCode: this.checkIsCode
        })
      ];
    }
  },
  methods: {
    checkIsCode(t) {
      return t != null && t.properties ? !!Object.keys(t.properties).find((e) => ["MOEX_TICKER", "SPB_TICKER", "OKPO"].includes(e)) : !1;
    }
  }
};
var aBe = function() {
  var e = this, n = e._self._c;
  return n("div", [e._t("default", null, { extensions: e.extensions })], 2);
}, lBe = [], cBe = /* @__PURE__ */ B(
  oBe,
  aBe,
  lBe,
  !1,
  null,
  null
);
const g8 = cBe.exports;
function uBe(t, e) {
  if (t.curSelection.$from.nodeBefore && t.curSelection.$from.nodeBefore.type.name === "table" && t.curSelection.$to.nodeAfter === null && e.schema.nodes.paragraph)
    return e.tr.insert(
      t.curSelection.$to.pos,
      e.schema.nodes.paragraph.create()
    );
  if (t.curSelection.$from.nodeAfter && t.curSelection.$from.nodeAfter.type.name === "table" && t.curSelection.$to.nodeBefore === null && e.schema.nodes.paragraph) {
    const n = e.tr;
    return n.insert(
      t.curSelection.$from.pos,
      e.schema.nodes.paragraph.create()
    ).setSelection(
      Mt.create(
        n.doc,
        t.curSelection.$from.pos + 1,
        t.curSelection.$to.pos + 1
      )
    );
  }
  if (t.curSelection.$from.nodeAfter && t.curSelection.$from.nodeAfter.type.name === "table" && t.curSelection.$to.nodeBefore && t.curSelection.$from.nodeBefore.type.name === "table" && e.schema.nodes.paragraph) {
    const n = e.tr;
    return n.insert(
      t.curSelection.$from.pos,
      e.schema.nodes.paragraph.create()
    ).setSelection(
      Mt.create(
        n.doc,
        t.curSelection.$from.pos + 1,
        t.curSelection.$to.pos + 1
      )
    );
  }
  return null;
}
function dBe(t, e) {
  let n = !1;
  for (let r of t.steps)
    if (r.slice)
      for (let s of r.slice.content.content)
        s && s.type.name === "table" && (n = !0);
  if (n) {
    const r = e.tr, s = fg(
      t.doc,
      (o) => o.type && o.type.name === "table_cell"
    );
    let i = 0;
    return s.forEach(({ node: o, pos: a } = {}) => {
      if (o.content.size === 0) {
        const l = e.schema.nodes.paragraph.create();
        r.insert(a + 1 + i * l.nodeSize, l), i++;
      }
    }), r;
  }
}
class fBe {
  constructor(e, n) {
    this.node = e, this.cellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "table-wrapper";
    const r = document.createElement("div");
    r.className = "table-wrapper-before";
    const s = document.createElement("div");
    s.className = "table-wrapper-after", this.dom.appendChild(r), this.table = this.dom.appendChild(document.createElement("table")), this.dom.appendChild(s), this.colgroup = this.table.appendChild(document.createElement("colgroup")), _f(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type !== this.node.type ? !1 : (this.node = e, _f(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type === "attributes" && (e.target === this.table || this.colgroup.contains(e.target));
  }
}
class pBe {
  apply() {
    return this;
  }
}
const tv = new ci("tableLayout");
function hBe() {
  return new lr({
    key: tv,
    state: {
      init() {
        return new pBe();
      },
      apply(t, e) {
        return e.apply(t);
      }
    },
    appendTransaction(t, e, n) {
      const r = t[t.length - 1], s = r.doc;
      if (r.curSelection && r.curSelection.jsonID === "gapcursor") {
        const a = uBe(r, n);
        if (a) return a;
      }
      if (r.getMeta("uiEvent") === "paste") {
        const a = dBe(r, n);
        if (a) return a;
      }
      const o = r.getMeta(tv);
      if (!o || !o.type)
        return null;
      switch (o.type) {
        case "selectTable":
          return r.setSelection(new ct(s.resolve(o.pos))), L7e(r);
        case "selectRow":
          return r.setSelection(new ct(s.resolve(o.pos))), R7e(o.index)(r);
        case "selectColumn":
          return r.setSelection(new ct(s.resolve(o.pos))), M7e(o.index)(r);
        case "addColumn":
          return r.setSelection(new ct(s.resolve(o.pos))), F7e(o.index)(r);
        case "addRow":
          return r.setSelection(new ct(s.resolve(o.pos))), B7e(o.index)(r);
        case "removeColumn":
          return r.setSelection(new ct(s.resolve(o.pos))), W7e(o.index)(r);
        case "removeRow":
          return r.setSelection(new ct(s.resolve(o.pos))), H7e(o.index)(r);
        case "removeTable":
          return r.setSelection(new ct(s.resolve(o.pos))), TI(r);
        case "cloneRow":
          return j7e(o.index)(r);
      }
    },
    props: {
      nodeViews: {},
      handleClickOn(t, e, n, r, s, i) {
        var l, c, u;
        const o = i && ((l = s == null ? void 0 : s.target) == null ? void 0 : l.classList);
        if (!o) return !1;
        let a = null;
        if (o.contains("table-wrapper-before")) {
          const d = !!(t.state.doc.childBefore(r) && ((c = t.state.doc.childBefore(r).node) == null ? void 0 : c.type.name) === "table");
          (r === 0 || d) && (a = r);
        }
        if (o.contains("table-wrapper-after")) {
          const d = !!(t.state.doc.nodeAt(e + 1) && ((u = t.state.doc.nodeAt(e + 1)) == null ? void 0 : u.type.name) === "table");
          (t.state.doc.nodeAt(e + 1) === null || d) && (a = r + n.nodeSize);
        }
        if (a !== null) {
          const d = t.state.tr, f = t.state.schema.nodes.paragraph.create();
          d.insert(a, f);
          const p = Mt.create(
            d.doc,
            a + 1,
            a + 1
          );
          return d.setSelection(p), t.dispatch(d), !0;
        }
        return !1;
      }
    }
  });
}
class mBe extends h7e {
  get plugins() {
    const e = [];
    return this.options.editable && (e.push(hBe()), e.push(l8())), this.options.resizable && e.push(o8({ View: fBe })), e;
  }
}
const Mi = {
  selectTable: "table-control-entire",
  selectRow: "table-control-vertical",
  selectColumn: "table-control-horizontal",
  removeTable: "table-control-remove-table",
  removeRow: "table-control-remove-row",
  removeColumn: "table-control-remove-column",
  addRow: "table-control-add-row",
  addColumn: "table-control-add-column",
  cloneRow: "table-control-clone-row",
  cloneColumn: "table-control-clone-column"
};
function vBe(t, e, n, r) {
  const s = (o) => e.target.classList.contains(o);
  let i;
  if (s(Mi.selectTable) && (i = {
    type: "selectTable",
    pos: n
  }), s(Mi.removeTable) && (i = {
    type: "removeTable",
    pos: n
  }), s(Mi.selectRow) && (i = {
    type: "selectRow",
    pos: n,
    index: r
  }), s(Mi.removeRow) && (i = {
    type: "removeRow",
    pos: n,
    index: r
  }), s(Mi.addRow) && (i = {
    type: "addRow",
    pos: n,
    index: r
  }), s(Mi.cloneRow) && (i = {
    type: "cloneRow",
    index: r
  }), s(Mi.selectColumn) && (i = {
    type: "selectColumn",
    pos: n,
    index: r
  }), s(Mi.removeColumn) && (i = {
    type: "removeColumn",
    pos: n,
    index: r
  }), s(Mi.addColumn) && (i = {
    type: "addColumn",
    pos: n,
    index: r
  }), s(Mi.cloneColumn) && (i = {
    type: "cloneColumn",
    pos: n,
    index: r
  }), i)
    return t.state.tr.setMeta(tv, i);
}
const gBe = new ci("tables"), y8 = new lr({
  key: gBe,
  state: {
    init(t, e) {
      return Sh(e);
    },
    apply(t, e, n, r) {
      return bBe(t, e, n, r);
    }
  },
  props: {
    decorations(t) {
      return y8.getState(t);
    },
    handleClickOn(t, e, n, r, s) {
      if (!new RegExp(`(${Object.values(Mi).join("|")})`).test(s.target.className)) return !1;
      const a = s.target.className.match(/\s_(\d+)/), l = Array.isArray(a) && Number(a[1]);
      return t.hasFocus() || t.focus(), t.dispatch(vBe(t, s, r, l)), !0;
    }
  }
});
class yBe extends Xi {
  get name() {
    return "tables";
  }
  get plugins() {
    return this.options.editable ? [y8] : [];
  }
}
function Sh(t) {
  const e = [], n = h8(t.doc, t.schema.nodes.table), r = lt(ra(t.selection), "node");
  return n.forEach(({ node: s, pos: i }) => {
    const o = s, a = A7e(t.selection) && o.eq(r), l = s.childCount;
    s.forEach((c, u, d) => {
      const f = d, p = u, h = c.childCount;
      c.forEach((m, v, y) => {
        const _ = i + (p || 1) + v + 2, w = i + p + v + 3;
        if (f === 0 && y === 0 && (e.push(
          Qt.widget(
            _,
            _Be(a)
          )
        ), a && e.push(
          Qt.widget(_, wBe())
        )), f === 0) {
          const S = $7e(y)(t.selection) && o.eq(r);
          e.push(
            Qt.widget(
              _,
              SBe(y, S)
            )
          ), e.push(
            Qt.widget(
              _,
              O3(y)
            )
          ), y === h - 1 && e.push(
            Qt.widget(
              _,
              O3(y + 1, !0)
            )
          ), S && !a && e.push(
            Qt.widget(
              _,
              IBe(y)
            )
          );
        }
        if (y === 0) {
          const S = D7e(f)(t.selection) && o.eq(r);
          e.push(
            Qt.widget(
              w,
              EBe(f, S)
            )
          ), e.push(
            Qt.widget(
              w,
              M3(f)
            )
          ), f === l - 1 && e.push(
            Qt.widget(
              w,
              M3(f + 1, !0)
            )
          ), S && !a && e.push(
            Qt.widget(
              w,
              xBe(f)
            )
          );
        }
      });
    });
  }), Rt.create(t.doc, e);
}
function bBe(t, e, n, r) {
  return t.docChanged ? Sh(r) : t.getMeta("tableColumnResizing$") ? e : t.getMeta(tv) || t.getMeta("pointer") || t.selectionSet ? Sh(r) : e;
}
function _Be(t) {
  const e = document.createElement("button"), n = [
    "table-control-entire",
    ...t ? ["is-selected"] : []
  ];
  return e.classList.add(...n), e.setAttribute("role", "editor-internal"), e;
}
function wBe() {
  const t = document.createElement("div");
  t.className = "table-control-actions _entire";
  const e = document.createElement("button");
  return e.className = "table-control-remove-table", e.innerHTML = `
    <i class="pb-icon material-icons" style="font-size: 13px; color: inherit;">delete</i>
  `, t.appendChild(e), t.setAttribute("role", "editor-internal"), t;
}
function SBe(t, e) {
  const n = document.createElement("button"), r = [
    "table-control-horizontal",
    `_${t}`,
    ...e ? ["is-selected"] : []
  ];
  return n.classList.add(...r), n.addEventListener("mouseover", () => {
    n.classList.add("is-hovered");
  }), n.addEventListener("mouseleave", () => {
    n.classList.remove("is-hovered");
  }), n.setAttribute("role", "editor-internal"), n;
}
function O3(t, e = !1) {
  const n = document.createElement("button");
  return n.className = `table-control-add-column ${e ? "_last" : ""} _${t}`, n.innerText = "+", n.setAttribute("role", "editor-internal"), n;
}
function IBe(t) {
  const e = document.createElement("div");
  e.className = "table-control-actions _horizontal";
  const n = document.createElement("button");
  return n.className = `table-control-remove-column _${t}`, n.innerHTML = `
    <i class="pb-icon material-icons" style="font-size: 13px; color: inherit;">delete</i>
  `, e.appendChild(n), e.setAttribute("role", "editor-internal"), e;
}
function EBe(t, e) {
  const n = document.createElement("button"), r = [
    "table-control-vertical",
    `_${t}`,
    ...e ? ["is-selected"] : []
  ];
  return n.classList.add(...r), n.addEventListener("mouseover", () => {
    n.classList.add("is-hovered");
  }), n.addEventListener("mouseleave", () => {
    n.classList.remove("is-hovered");
  }), n.setAttribute("role", "editor-internal"), n;
}
function M3(t, e = !1) {
  const n = document.createElement("button");
  return n.className = `table-control-add-row ${e ? "_last" : ""} _${t}`, n.innerText = "+", n.setAttribute("role", "editor-internal"), n;
}
function xBe(t) {
  const e = document.createElement("div");
  e.className = "table-control-actions _vertical";
  const n = document.createElement("button");
  return n.className = `table-control-remove-row _${t}`, n.innerHTML = `
    <i class="pb-icon material-icons" style="font-size: 13px; color: inherit;">delete</i>
  `, n.setAttribute("role", "editor-internal"), e.appendChild(n), e.setAttribute("role", "editor-internal"), e;
}
const CBe = {
  components: {
    PbIcon: cc
  },
  props: {
    hideMenu: {
      type: Function,
      required: !0
    },
    menuAtBottom: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      menu: {
        isVisible: !1,
        timeout: null
      },
      isHoveredRow: null,
      isHoveredColumn: null
    };
  },
  computed: {
    gridRows() {
      const t = this.isHoveredRow + 1 >= 8 ? 8 : this.isHoveredRow + 1, n = (this.isHoveredRow >= 4 ? new Array(t) : new Array(4)).fill(1).map((r, s) => r + s);
      return this.menuAtBottom ? n.reverse() : n;
    },
    gridColumns() {
      const t = this.isHoveredColumn + 1 >= 10 ? 10 : this.isHoveredColumn + 1;
      return this.isHoveredColumn >= 4 ? new Array(t) : new Array(4);
    },
    buttonGridClass() {
      return (t, e) => ({
        "is-selected": this.isHoveredRow >= t && this.isHoveredColumn >= e
      });
    }
  },
  methods: {
    handleClick() {
      this.$emit("command", {
        name: "createTable",
        params: {
          rows: this.isHoveredRow,
          cols: this.isHoveredColumn
        }
      });
    },
    showGridMenu() {
      this.menu.timeout && clearTimeout(this.menu.timeout), this.menu.isVisible = !0, this.hideMenu.cancel();
    },
    hideGridMenu() {
      this.menu.timeout = setTimeout(() => {
        this.menu.isVisible = !1;
      }, 150), this.hideMenu();
    },
    setSelectedGrid(t, e) {
      this.isHoveredRow = t, this.isHoveredColumn = e;
    },
    clearSelectedGrid() {
      this.isHoveredRow = null, this.isHoveredColumn = null;
    }
  }
};
var TBe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "wrapper" }, [n("button", { ref: "button", staticClass: "editor__menu-item button", attrs: { "data-test-selector": "table-menu-button" }, on: { mouseenter: e.showGridMenu, mouseleave: e.hideGridMenu } }, [n("span", [e._v("Таблица")]), n("PbIcon", { staticClass: "icon", attrs: { type: "font", name: "keyboard_arrow_right", size: "18" } })], 1), n("transition", { attrs: { name: "fade" } }, [e.menu.isVisible ? n("div", { class: ["menu", e.menuAtBottom ? "_bottom" : ""], on: { mouseenter: e.showGridMenu, mouseleave: e.hideGridMenu } }, [n("div", { staticClass: "grid", attrs: { "data-test-selector": "table-menu-grid" } }, e._l(e.gridRows, function(r) {
    return n("div", { key: r, staticClass: "grid-row", attrs: { "data-test-selector": "table-menu-grid-row", "data-test-attrs": r } }, e._l(e.gridColumns.length, function(s) {
      return n("div", { key: `${r}x${s}` }, [n("button", { class: e.buttonGridClass(r, s), attrs: { "data-test-selector": "table-menu-size-button", "data-test-attrs": `${r}x${s}` }, on: { mouseenter: function(i) {
        return e.setSelectedGrid(r, s);
      }, mouseleave: e.clearSelectedGrid, click: e.handleClick } })]);
    }), 0);
  }), 0), n("transition", { attrs: { name: "fade", mode: "out-in" } }, [n("div", { key: `${e.isHoveredRow}x${e.isHoveredColumn}`, staticClass: "label" }, [e._v(" " + e._s(e.isHoveredRow) + " x " + e._s(e.isHoveredColumn) + " ")])])], 1) : e._e()])], 1);
}, PBe = [], kBe = /* @__PURE__ */ B(
  CBe,
  TBe,
  PBe,
  !1,
  null,
  "5824c815"
);
const NBe = kBe.exports, $Be = {
  props: {
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    return {
      extensions: [
        new mBe({ resizable: !0, editable: t.enabled }),
        new m7e(),
        new v7e(),
        new g7e(),
        new yBe({ editable: t.enabled })
      ],
      menuItems: [NBe]
    };
  },
  methods: {
    handleCommand({ commands: t, command: e }) {
      t && e.name === "createTable" && t.createTable({
        rowsCount: e.params.rows,
        colsCount: e.params.cols,
        withHeaderRow: !1
      });
    }
  }
};
var DBe = function() {
  var e = this, n = e._self._c;
  return n("div", [e._t("default", null, null, { extensions: e.extensions, menuItems: e.menuItems, handleCommand: e.handleCommand })], 2);
}, ABe = [], OBe = /* @__PURE__ */ B(
  $Be,
  DBe,
  ABe,
  !1,
  null,
  null
);
const MBe = OBe.exports, RBe = {
  name: "NewsEditorBodyBlock",
  components: {
    DefaultBlock: Xo,
    WithEntities: g8,
    WithTables: MBe
  },
  props: pg,
  data() {
    return {
      extensions: [],
      menuItems: [],
      editor: {}
    };
  },
  watch: {
    typeId(t, e) {
      t !== e && this.$forceUpdate();
    },
    langId(t, e) {
      t !== e && this.$forceUpdate();
    }
  },
  methods: {
    focus() {
      this.$refs.editor && this.$refs.editor.focus();
    },
    hasFocus() {
      return this.$refs.editor ? this.$refs.editor.hasFocus() : !1;
    },
    init(t) {
      this.editor = t.editor.editor, this.$emit("initEditorStore", t);
    }
  }
};
var LBe = function() {
  var e = this, n = e._self._c;
  return n("WithEntities", { staticClass: "editor-root with-in-text-codes", attrs: { newsItemId: e.newsItemId, type: e.type, editor: e.editor, fontSize: e.settings.fontSize, hasFocus: e.hasFocus, entities: e.entities }, scopedSlots: e._u([{ key: "default", fn: function(r) {
    return [n("WithTables", { attrs: { enabled: e.enabled }, scopedSlots: e._u([{ key: "default", fn: function(s) {
      return [n("DefaultBlock", e._g(e._b({ ref: "editor", attrs: { editorExtensions: [
        ...e.extensions,
        ...e.editorExtensions,
        ...r.extensions,
        ...s.extensions
      ], editorMenuItems: [...e.menuItems, ...s.menuItems] } }, "DefaultBlock", e.$props, !1), {
        ...e.$listeners,
        initEditorStore: e.init,
        editorMenuCommand: s.handleCommand
      }))];
    } }], null, !0) })];
  } }]) });
}, FBe = [], BBe = /* @__PURE__ */ B(
  RBe,
  LBe,
  FBe,
  !1,
  null,
  null
);
const R3 = BBe.exports, jBe = {
  name: "NewsEditorBodyBlock",
  components: {
    DefaultBlock: Xo,
    WithEntities: g8
  },
  props: pg,
  data() {
    return {
      extensions: [],
      editor: {}
    };
  },
  watch: {
    typeId(t, e) {
      t !== e && this.$forceUpdate();
    },
    async content(t, e) {
      this.useValidate && t !== e && await this.validateLength();
    }
  },
  methods: {
    focus() {
      this.$refs.editor && this.$refs.editor.focus();
    },
    hasFocus() {
      return this.$refs.editor ? this.$refs.editor.hasFocus() : !1;
    },
    init(t) {
      this.editor = t.editor.editor, this.$emit("initEditorStore", t);
    },
    async validateLength() {
      (await Kn.process("trimHTML", this.content)).length > 200 ? this.$emit("addValidationError", {
        code: "STRING_TOO_LONG",
        detail: "Строка не должна быть длиннее 200 символов.",
        level: "error"
      }) : this.$emit("removeValidationError", { code: "STRING_TOO_LONG" });
    }
  }
};
var WBe = function() {
  var e = this, n = e._self._c;
  return n("WithEntities", { staticClass: "editor-root with-in-text-codes", attrs: { newsItemId: e.newsItemId, type: e.type, editor: e.editor, fontSize: e.settings.fontSize, hasFocus: e.hasFocus, entities: e.entities }, scopedSlots: e._u([{ key: "default", fn: function(r) {
    return [n("DefaultBlock", e._g(e._b({ ref: "editor", attrs: { editorExtensions: [
      ...e.extensions,
      ...e.editorExtensions,
      ...r.extensions
    ] } }, "DefaultBlock", e.$props, !1), {
      ...e.$listeners,
      initEditorStore: e.init
    }))];
  } }]) });
}, HBe = [], VBe = /* @__PURE__ */ B(
  jBe,
  WBe,
  HBe,
  !1,
  null,
  null
);
const L3 = VBe.exports, zBe = {
  name: "NewsEditorBlock",
  components: {
    DefaultBlock: Xo,
    SubheadlineBlock: D3,
    SluglineBlock: $3,
    DatelineBlock: N3,
    InlineBlock: A3,
    BodyBlock: R3,
    HeaderBlock: L3
  },
  props: pg,
  data() {
    return {};
  },
  computed: {
    compName() {
      switch (this.type) {
        case "slugline":
          return $3;
        case "headline":
          return L3;
        case "subheadline":
          return D3;
        case "trashline":
          return A3;
        case "dateline":
          return N3;
        case "body":
          return R3;
        default:
          return Xo;
      }
    }
  },
  watch: {
    isFocused(t, e) {
      t !== e && t && this.focus();
    }
  },
  methods: {
    focus() {
      this.$refs.component && this.$refs.component.focus();
    },
    hasFocus() {
      return this.$refs.component ? this.$refs.component.hasFocus() : !1;
    }
  }
};
var UBe = function() {
  var e = this, n = e._self._c;
  return n(e.compName, e._g(e._b({ ref: "component", tag: "component" }, "component", e.$props, !1), e.$listeners));
}, GBe = [], YBe = /* @__PURE__ */ B(
  zBe,
  UBe,
  GBe,
  !1,
  null,
  "d407684e"
);
const b8 = YBe.exports;
class ZBe extends Ki {
  constructor(e) {
    super(), this.options = e || this.defaultOptions;
  }
  get name() {
    return this.constructor.name;
  }
  get defaultOptions() {
    return {
      style: {
        "+": "background-color: #D2E2C1; color: #225E18;",
        "-": "background-color: #F5DBC8; color: #AB0000;"
        // '=': 'background-color: #fff'
      }
    };
  }
  get schema() {
    return {
      attrs: {
        difftype: "",
        // +, -, =
        text: {
          default: ""
        }
      },
      group: "inline",
      inline: !0,
      atom: !1,
      skip: !0,
      content: "text*",
      toDOM: (e) => [
        "span",
        {
          class: "diff",
          style: this.options.style[e.attrs.difftype],
          "data-diff-type": e.attrs.difftype
        },
        e.attrs.text
      ],
      parseDOM: [
        {
          tag: "span.diff",
          getAttrs: (e) => ({
            difftype: e.getAttribute("data-diff-type"),
            text: e.innerText
          })
        }
      ]
    };
  }
}
const XBe = {
  name: "NewsItemView",
  components: {
    NewsEditorBlock: b8
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    blocks: {
      type: Array,
      default: () => []
    },
    visibleBlocks: {
      type: Array,
      default: () => []
    },
    typeId: {
      type: Number,
      default: 1
    },
    isBig: {
      type: Boolean,
      default: !1
    },
    isPanelFocused: {
      type: Boolean,
      default: !1
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    isRevoked: {
      type: Boolean,
      default: !1
    },
    revokeEvent: {
      type: Object,
      default: null
    },
    codeItems: {
      type: Object,
      default: () => ({})
    },
    userProfile: {
      type: Object,
      default: () => ({})
    },
    moexCodesNews: {
      type: Object,
      default: () => ({})
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    },
    disposeReason: {
      type: String,
      default: null
    },
    disposedBy: {
      type: String,
      default: null
    },
    isDisposed: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      extensions: [new ZBe()]
    };
  },
  computed: {
    codes() {
      return this.version && this.version.codes ? this.version.codes.map(({ code: t }) => t.id) : [];
    }
  }
};
var KBe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: {
    "news-draft": !0,
    [`type-${e.typeId}`]: !0,
    big: e.isBig
  }, attrs: { "data-test-selector": "news-item-draft", "data-test-id": e.newsItemId, "data-test-attrs": `type__${e.version.type_id}${e.isBig ? " maximized" : ""}` } }, [e.isRevoked && e.revokeEvent ? n("div", { staticClass: "notification", attrs: { "data-test-selector": "news-item-revoked" } }, [n("div", { staticClass: "flex justify-between" }, [n("div", { staticClass: "flex-initial self-center" }, [e._v(" Новость аннулирована"), n("br"), e._v(" Аннулировал: "), n("span", { attrs: { "data-test-selector": "news-item-revoked-user" } }, [e._v(e._s(e.formatUsername(e.revokeEvent.user.name)))])]), n("div", { staticClass: "flex-none" }, [n("MainActionButton", { staticClass: "mini-button button-icon-show-more pb-action-button-old", attrs: { iconName: "button-icon-show-more", title: "Перейти к новости-аннулированию", "data-test-selector": "entry-button-show-more" }, on: { click: e.navigateToRevocation } })], 1)])]) : e._e(), e.isDisposed ? n("div", { staticClass: "notification", attrs: { "data-test-selector": "news-item-disposed" } }, [e._v(" Новость в отвале "), n("div", { attrs: { "data-test-selector": "news-item-disposed-user" } }, [e._v(" Отправил в отвал: " + e._s(e.disposedBy) + " ")]), e.disposeReason ? n("div", { attrs: { "data-test-selector": "news-item-disposed-reason" } }, [e._v(" Причина: " + e._s(e.disposeReason) + " ")]) : e._e()]) : e._e(), e.visibleBlocks && e.visibleBlocks.length ? e._l(e.visibleBlocks, function(r) {
    return n("NewsEditorBlock", { key: r.type, attrs: { "data-test-selector": "news-item-edit-block", "data-test-attrs": `type__${r.type}`, block: r, codeItems: e.codeItems, codes: e.codes, content: e.version[r.type], enabled: !1, entities: e.version.entities, id: e.version.id, isBig: e.isBig, langId: e.version.language_id, moexCodes: e.moexCodesNews, newsCodes: e.newsCodes, newsItemId: e.newsItemId, settings: e.settings, title: r.title, type: r.type, typeId: e.version.type_id, editorExtensions: e.extensions }, on: { initEditorStore: function(s) {
      return e.$emit("initEditorStore", s);
    }, altEnterPressed: function(s) {
      return e.$emit("editorToggleSupply");
    } } });
  }) : e._e()], 2);
}, JBe = [], qBe = /* @__PURE__ */ B(
  XBe,
  KBe,
  JBe,
  !1,
  null,
  null
);
const kI = qBe.exports, QBe = "_root_1vmwe_1", eje = {
  root: QBe
}, tje = {
  name: "NewsItemDate",
  components: {
    DateWidget: Hr
  },
  props: {
    date: {
      type: String,
      required: !0
    }
  }
};
var nje = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "news-item-date" } }, [n("DateWidget", { attrs: { date: e.date } })], 1);
}, rje = [];
const F3 = {
  $style: eje
};
function sje(t) {
  for (var e in F3)
    this[e] = F3[e];
}
var ije = /* @__PURE__ */ B(
  tje,
  nje,
  rje,
  !1,
  sje,
  null
);
const NI = ije.exports, oje = {
  name: "NewsItemVersionCtr",
  mixins: [
    /**
     * computed:
     *   colorScheme
     *   colorSchemeName
     */
    ai
  ],
  components: {
    NewsItemView: kI,
    NewsItemEmbargoCtr: Fu,
    NewsItemDate: NI
  },
  props: {
    newsItemId: {
      type: [String, Number],
      default: null
    },
    isBig: {
      type: Boolean,
      default: !0
    }
  },
  setup(t, e) {
    const { newsItemId: n } = ts(t), r = Jt("store"), { version: s, typeId: i, statusModifiedAt: o } = Zi(
      { newsItemIdRef: n },
      r
    ), { isDisposed: a, disposerName: l, disposalReason: c } = g6(
      { newsItemIdRef: n },
      r
    ), {
      isEmbargoFormVisible: u,
      isEmbargoValid: d,
      isUserHasEmbargoPermissions: f
    } = dc({ versionRv: s }, r), { isRevoked: p, revokeEvent: h } = fc({ newsItemIdRef: n }, r), { isPublishedByMe: m } = uc({ newsItemIdRef: n }, r), v = le(
      () => !!(m.value || f)
    );
    return {
      version: s,
      typeId: i,
      statusModifiedAt: o,
      isDisposed: a,
      disposerName: l,
      disposalReason: c,
      isEmbargoFormVisible: u,
      isEmbargoValid: d,
      isEmbargoEditable: v,
      isRevoked: p,
      revokeEvent: h
    };
  },
  data() {
    return {
      blocks: ju(),
      blockPresets: Yf()
    };
  },
  computed: {
    ...st("news/codes", {
      codeItems: (t) => t.items
    }),
    visibleBlocks() {
      const t = this.blockPresets[this.typeId];
      return this.blocks.filter(
        (e) => t.includes(e.type) && this.version[e.type]
      );
    }
  }
};
var aje = function() {
  var e = this, n = e._self._c;
  return e.version ? n("div", [n("NewsItemDate", { style: {
    border: "1px solid #" + e.getColorScheme().innerBorderColor,
    borderTop: "0",
    backgroundColor: e.editorStyle.backgroundColor,
    color: e.editorStyle.color
  }, attrs: { date: e.statusModifiedAt } }), e.isEmbargoFormVisible ? n("NewsItemEmbargoCtr", { attrs: { newsItemId: e.newsItemId, version: e.version, isRemovable: !1, isEditable: !1 } }) : e._e(), n("NewsItemView", { ref: "scrollableArea", class: `theme-${e.colorSchemeName}`, style: e.editorStyle, attrs: { newsItemId: e.newsItemId, isBig: e.isBig, typeId: e.typeId, codeItems: e.codeItems, blocks: e.blocks, version: e.version, disposeReason: e.disposalReason, visibleBlocks: e.visibleBlocks, disposedBy: e.disposerName, isDisposed: e.isDisposed, isRevoked: e.isRevoked, revokeEvent: e.revokeEvent }, on: { initEditorStore: function(r) {
    return e.$emit("initEditorStore", r);
  } } })], 1) : e._e();
}, lje = [], cje = /* @__PURE__ */ B(
  oje,
  aje,
  lje,
  !1,
  null,
  null
);
const uje = cje.exports, dje = {
  name: "NewsItemVersionCtr",
  mixins: [ai],
  components: {
    NewsItemView: kI,
    NewsItemEmbargoCtr: Fu,
    NewsItemDate: NI
  },
  props: {
    newsItemId: {
      type: [String, Number],
      default: null
    },
    isBig: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const e = Jt("store"), { newsItemId: n } = ts(t), { isDisposed: r, disposerName: s, disposalReason: i } = g6(
      { newsItemIdRef: n },
      e
    ), { isRevoked: o, revokeEvent: a } = fc({ newsItemIdRef: n }, e), { version: l, typeId: c } = eg(t.newsItemId, e), { isEmbargoFormVisible: u, isEmbargoValid: d } = dc(
      { versionRv: l },
      e
    ), f = ju(), p = Yf(), h = {
      codeItems: e.state.news.codes.items,
      news: e.state.news.items,
      newsStatusesByName: e.getters["references/newsStatusesByName"]
    }, m = le(
      () => l.value.status_id === h.newsStatusesByName.PUBLISHED.id
    ), v = le(() => h.news[t.newsItemId]), y = le(
      () => m.value ? v.value.status_modified_at : l.value.created_at
    ), _ = le(() => {
      const w = p[c.value];
      return f.filter(
        (S) => w.includes(S.type) && l.value[S.type]
      );
    });
    return {
      version: l,
      typeId: c,
      date: y,
      isDisposed: r,
      disposerName: s,
      disposalReason: i,
      isEmbargoFormVisible: u,
      isEmbargoValid: d,
      isRevoked: o,
      revokeEvent: a,
      blocks: f,
      visibleBlocks: _,
      ...h
    };
  }
};
var fje = function() {
  var e = this, n = e._self._c;
  return e.version ? n("div", [n("NewsItemDate", { style: {
    border: "1px solid #" + e.getColorScheme().innerBorderColor,
    borderTop: "0",
    backgroundColor: e.editorStyle.backgroundColor,
    color: e.editorStyle.color
  }, attrs: { date: e.date } }), e.isEmbargoFormVisible ? n("NewsItemEmbargoCtr", { attrs: { newsItemId: e.newsItemId, version: e.version, isEditable: !1, isEmbargoValid: e.isEmbargoValid, publishMode: !1, fullSize: !e.isBig } }) : e._e(), n("NewsItemView", { ref: "scrollableArea", class: `theme-${e.colorSchemeName}`, style: e.editorStyle, attrs: { newsItemId: e.newsItemId, isBig: e.isBig, typeId: e.typeId, codeItems: e.codeItems, blocks: e.blocks, version: e.version, disposeReason: e.disposalReason, visibleBlocks: e.visibleBlocks, disposedBy: e.disposerName, isDisposed: e.isDisposed, isRevoked: e.isRevoked, revokeEvent: e.revokeEvent }, on: { initEditorStore: function(r) {
    return e.$emit("initEditorStore", r);
  } } })], 1) : e._e();
}, pje = [], hje = /* @__PURE__ */ B(
  dje,
  fje,
  pje,
  !1,
  null,
  null
);
const mje = hje.exports;
function _8({ draftRv: t }, e) {
  const n = {
    getIsEmbargoNotSaved: e.getters["news/drafts/getIsEmbargoNotSaved"],
    getIsEmbargoConfirmOpen: e.getters["news/drafts/getIsEmbargoConfirmOpen"],
    getEmbargoStateController: e.getters["news/drafts/getEmbargoStateController"]
  }, r = {
    setEmbargoNotSaved: (...c) => e.dispatch("news/drafts/setEmbargoNotSaved", ...c),
    setEmbargoConfirmOpen: (...c) => e.dispatch("news/drafts/setEmbargoConfirmOpen", ...c),
    setEmbargoStateController: (...c) => e.dispatch("news/drafts/setEmbargoStateController", ...c)
  }, s = le(() => {
    var c;
    return (c = t == null ? void 0 : t.value) != null && c.id ? n.getIsEmbargoNotSaved(t.value.id) : !1;
  }), i = le(() => {
    var c;
    return (c = t == null ? void 0 : t.value) != null && c.id ? n.getIsEmbargoConfirmOpen(t.value.id) : !1;
  }), o = le(() => {
    var c;
    return (c = t == null ? void 0 : t.value) != null && c.id ? n.getEmbargoStateController(t.value.id) : null;
  });
  return {
    ...r,
    isEmbargoNotSaved: s,
    isEmbargoConfirmOpen: i,
    ignoreEmbargoNotSaved: () => {
      var c, u;
      o.value && (o.value.abort(), r.setEmbargoStateController((c = t == null ? void 0 : t.value) == null ? void 0 : c.id)), r.setEmbargoConfirmOpen({ draftId: (u = t == null ? void 0 : t.value) == null ? void 0 : u.id, value: !1 });
    },
    embargoStateController: o,
    handleNotSavedEmbargo: () => s.value ? new Promise((c, u) => {
      var f;
      const d = or(
        () => s.value,
        () => {
          d(), c();
        }
      );
      o.value.signal.addEventListener("abort", () => {
        d(), u();
      }), r.setEmbargoConfirmOpen({
        draftId: (f = t == null ? void 0 : t.value) == null ? void 0 : f.id,
        value: !0
      });
    }) : null
  };
}
function vje() {
  this.stack.undo.splice(0), this.stack.redo.splice(0);
}
function gje() {
  return U.observable({
    editors: U.observable({}),
    register({ id: t, stack: e, commands: n }) {
      if (this.editors[t])
        return this.editors[t];
      const r = {
        id: t,
        stack: e
      };
      return r.clear = vje.bind(r), r.unregister = this.unregister.bind(this, t), Object.entries(n).forEach(([s, i]) => {
        r[s] = i;
      }), U.set(this.editors, t, r), r;
    },
    unregister(t) {
      var e;
      (e = this.editors[t]) == null || e.clear(), delete this.editors[t];
    }
  });
}
const $I = gje();
function w8(t, e) {
  const n = {
    undo: [],
    redo: []
  }, r = () => {
    var o;
    if (n.undo.length > 0) {
      const a = n.undo.pop();
      n.redo.push(a);
      const l = ((o = e["editor-" + a].value[0]) == null ? void 0 : o.$refs.component) || e["editor-" + a].value.$refs.editor;
      l && lt(
        l,
        ["body"].includes(a) ? "editor" : "$refs.editor.editor"
      ).commands.undo();
    }
  }, s = () => {
    var o;
    if (n.redo.length > 0) {
      const a = n.redo.pop();
      n.undo.push(a);
      const l = ((o = e["editor-" + a].value[0]) == null ? void 0 : o.$refs.component) || e["editor-" + a].value.$refs.editor;
      l && lt(
        l,
        ["body"].includes(a) ? "editor" : "$refs.editor.editor"
      ).commands.redo();
    }
  };
  return $I.register({
    id: t,
    stack: n,
    commands: {
      undo: r,
      redo: s
    }
  });
}
const yje = {
  name: "NewsItemEditor",
  components: {
    NewsEditorBlock: b8
  },
  mixins: [Vr, qv],
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    draftId: {
      type: [String, Number],
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    blocks: {
      type: Array,
      default: () => []
    },
    visibleBlocks: {
      type: Array,
      default: () => []
    },
    blockPresets: {
      type: Object,
      default: () => ({})
    },
    typeId: {
      type: Number,
      default: 1
    },
    isBig: {
      type: Boolean,
      default: !1
    },
    isPanelFocused: {
      type: Boolean,
      default: !1
    },
    errors: {
      type: Array,
      default: () => []
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    isRevocation: {
      type: Boolean,
      default: !1
    },
    codeItems: {
      type: Object,
      default: () => ({})
    },
    userProfile: {
      type: Object,
      default: () => ({})
    },
    moexCodesNews: {
      type: Object,
      default: () => ({})
    },
    newsCodes: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const e = {
      selectionRangeContent: et(null)
    };
    for (let r of t.blocks)
      e[`editor-${r.type}`] = et(null);
    return {
      history: Xn(w8(t.draftId, e)),
      ...e
    };
  },
  data() {
    return {
      historyHook: !1,
      blockFocuses: {
        slugline: !1,
        headline: !1,
        subheadline: !1,
        trashline: !1,
        dateline: !1,
        body: !1,
        background: !1
      },
      blockDrag: null,
      focusedEditorIndex: null,
      elementFocused: !1,
      isBlocksMenuVisible: !1,
      isInitializing: !0,
      codesInEditors: [],
      loaded: !1
    };
  },
  computed: {
    isEditorFocused() {
      return this.focusedEditorIndex !== null;
    },
    codes() {
      return this.version && this.version.codes ? this.version.codes.map(({ code: t }) => t.id) : [];
    },
    blockByName() {
      return (t) => this.visibleBlocks.find(({ type: e } = {}) => e === t) ?? {};
    },
    blockErrorClasses() {
      return (t) => {
        var e, n, r;
        return (e = this.getBlockErrors(t)) != null && e.filter((s) => s.level === "error").length ? ["with-errors"] : (r = (n = this.getBlockErrors(t)) == null ? void 0 : n.filter((s) => s.level === "warning")) != null && r.length ? ["with-warnings"] : [];
      };
    },
    hotkeysEnabled() {
      return this.isPanelFocused && !this.isEditorFocused;
    },
    getBlockErrors() {
      return (t) => this.errors.filter((e) => e.block === t);
    },
    getBlockEnabled() {
      return (t) => t.disabled ? !1 : this.isRevocation ? this.version.type_id === 1 && t.type === "headline" ? !0 : ![
        "slugline",
        "headline",
        "subheadline",
        "trashline",
        "dateline"
      ].includes(t.type) : !0;
    },
    getEditableCanChange() {
      return (t) => t.disabled !== void 0;
    },
    allInitialized() {
      return this.typeId ? !this.blocks.filter(({ type: t }) => this.blockPresets[this.typeId].includes(t)).find(({ initialized: t }) => t === !1) : !1;
    },
    useValidate() {
      return (t) => !(this.isRevocation && t.type === "headline");
    }
  },
  watch: {
    hotkeysEnabled(t, e) {
      t !== e && (t ? this.$enableShortcut("Enter") : this.$disableShortcut("Enter"));
    },
    typeId: function(t, e) {
      t !== void 0 && e !== void 0 && t !== e && (this.blocks.forEach((n) => {
        n.errors = [];
      }), this.switchType(t));
    },
    isPanelFocused: function(t, e) {
      t !== e && (t ? this.allInitialized && this.isInitializing && (this.isInitializing = !1, this.focusInitial()) : Object.keys(this.blockFocuses).forEach((n) => {
        this.blockFocuses[n] = !1;
      }));
    },
    errors(t) {
      const e = t.filter((r) => r.block), n = this.blockPresets[this.typeId].find(
        (r) => e.find((s) => s.block === r)
      );
      n && this.scrollToBlock(n);
    },
    blockFocuses: {
      handler: function(t) {
        if (this.historyHook) {
          this.historyHook = !1;
          return;
        }
        const e = Object.values(t).find((n) => n);
        this.$emit("editorFocus", !!e);
      },
      deep: !0
    },
    "version.language_id": function(t, e) {
      t !== e && e !== void 0 && this.blocks.forEach((n) => {
        n.errors = [];
      });
    },
    async allInitialized(t, e) {
      t && t !== e && (await this.$nextTick(), this.isPanelFocused && this.isInitializing && (this.isInitializing = !1, this.focusInitial()));
    }
  },
  created() {
    this.$registerShortcut("Enter", this.enterHandler, {
      enabled: this.hotkeysEnabled
    });
  },
  async mounted() {
    await this.initializeFields(), this.switchType(this.version.type_id, !0), this.loaded = !0;
  },
  beforeDestroy() {
    this.history.unregister();
  },
  methods: {
    addNewsCode(t) {
      this.$emit("addNewsCode", [t]);
    },
    async initializeFields() {
      if (this.isRevocation) return;
      const t = Object.keys(this.version).reduce((n, r) => {
        const s = this.blockByName(r);
        return s.type && n.push(s), n;
      }, []), e = async (n) => {
        const r = this.version[n.type], s = await Kn.process("trimHTML", r);
        if (n.type === "slugline" && ["МОЛНИЯ", "FLASH"].includes(s))
          return;
        const i = this.blockPresets[this.typeId].find(
          (o) => o === n.type
        );
        n.type === "dateline" && r !== null && (this.$emit("blockInitialized", n.type), i && this.$emit("blockVisibilityChanged", {
          blockName: n.type,
          value: !0
        })), s !== "" && (this.$emit("blockInitialized", n.type), i && this.$emit("blockVisibilityChanged", {
          blockName: n.type,
          value: !0
        }));
      };
      for (let n of t)
        await e(n);
    },
    enterHandler(t) {
      t.stopPropagation(), t.preventDefault(), !(t.altKey || t.ctrlKey || t.metaKey || t.shiftKey) && this.focusNextEditor();
    },
    /**
     * Метод смены типа новости
     * @param typeId - тип новости
     */
    switchType(t, e = !1) {
      var n;
      e || Object.keys(this.blockFocuses).forEach((r) => {
        this.blockFocuses[r] = !1;
      }), (n = this.history) != null && n.id && this.history.clear();
    },
    /**
     * Метод добавления блока в текущий набор
     * @param {Object} block - объект блока
     */
    addBlock(t) {
      this.isBlocksMenuVisible = !1, this.blockPresets[this.typeId].find(
        (r) => r === t.type
      ) && (this.$emit("blockVisibilityChanged", {
        blockName: t.type,
        value: !0
      }), this.isInitializing || this.$nextTick(() => {
        this.$nextTick(() => {
          this.$refs[`editor-${t.type}`][0].focus();
        });
      }));
    },
    /**
     * Обработчик события `blur` текстовых полей.
     * Отключает режим редактирования в случае, если ни у одного редактора нет фокуса.
     *
     * @param {string} block Имя блока редактора
     * @param {{ state: EditorState, view: EditorView, history?: boolean }} event Данные эвента
     */
    blurHandler(t, e) {
      e.history && (this.historyHook = !0), this.blockDrag = e, this.blockFocuses[t] = !1, Object.keys(this.$refs).every((r) => this.$refs[r][0] ? this.$refs[r][0].hasFocus() === !1 : !0) && this.unsetFocusedEditorIndex();
    },
    /*
     * Обработчик события `drop` текстовых полей.
     * Удаляет перетаскиваемый слайс из исходного блока при дропе в конечный блок
     */
    dropHandler() {
      setTimeout(() => {
        if (!this.blockDrag)
          return;
        const { state: t, view: e } = this.blockDrag, n = t.tr;
        t.selection.replace(n), e.dispatch(n);
      }, 0);
    },
    /**
     * Вызывает метод `focus` следующего редактора
     * @param {string} block - текущий редактор
     */
    focusNextEditor(t) {
      const e = this.visibleBlocks.map((s) => s.type);
      let n = e.indexOf(t) + 1;
      if (this.isRevocation && (n = e.indexOf("body")), !e[n])
        return;
      for (; this.visibleBlocks[n].disabled; )
        if (n++, !e[n])
          return;
      const r = this.$refs[`editor-${e[n]}`];
      r && r[0] && (this.scrollToBlock(e[n], !0), r[0].focus());
    },
    /**
     * Вызывает метод `focus` предыдущего редактора
     * @param {string} block - текущий редактор
     */
    focusPrevEditor(t) {
      const e = this.visibleBlocks.map((s) => s.type);
      let n = e.indexOf(t) - 1;
      if (this.isRevocation && (n = e.indexOf("body")), !e[n])
        return;
      for (; this.visibleBlocks[n].disabled; )
        if (n--, !e[n])
          return;
      const r = this.$refs[`editor-${e[n]}`];
      r && r[0] && (this.scrollToBlock(e[n], !0), r[0].focus());
    },
    /**
     * Устанавливает значение опции `focusedEditorIndex`
     * @param {string} block - текущий редактор
     */
    setFocusedEditorIndex(t) {
      this.isRevocation && (t = "body"), this.blockFocuses[t] = !0, this.focusedEditorIndex = this.blockPresets[this.typeId].indexOf(t), this.elementFocused = !0, setTimeout(() => {
        this.blockDrag = null;
      }, 10);
    },
    /**
     * Сбрасывает значение опции `focusedEditorIndex`
     */
    unsetFocusedEditorIndex() {
      this.focusedEditorIndex = null, this.elementFocused = !1;
    },
    /**
     * Метод обновления локального состояния `version`
     * @param {string} blockType - тип текстового блока редактора
     * @param {string} text - новое значение
     */
    update(t, e) {
      this.$emit("update", { [t]: e });
    },
    /**
     * Ставит фокус в пустое поле редактора
     */
    focusInitial() {
      this.typeId === 1 && this.blockByName("body").initial && this.focusNextEditor("slugline"), [2, 3].includes(this.typeId) && (this.blockByName("headline").initial ? this.focusNextEditor("slugline") : this.blockByName("body").initial && this.focusNextEditor("dateline"));
    },
    addValidationError(t, e) {
      this.errors.find(
        (n) => n.block === e && n.code === t.code
      ) || this.$emit("addInternalError", {
        block: e,
        internal: !0,
        ...t
      });
    },
    removeValidationError(t, e) {
      this.errors.find(
        (n) => n.block === e && n.code === t.code
      ) && this.$emit("removeInternalError", {
        block: e,
        internal: !0,
        ...t
      });
    },
    init(t) {
      const { type: e } = t;
      this.$emit("initEditorStore", t);
      const n = this.blockByName(e);
      n && this.$emit("blockInitialized", n.type);
    },
    scrollToBlock(t, e = !1) {
      const n = this.$refs[`editor-${t}`];
      n && n[0] && n[0].$el.scrollIntoView({
        behavior: e ? "smooth" : "auto",
        block: "nearest",
        inline: "nearest"
      });
    }
  }
};
var bje = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "selectionRangeContent", class: {
    "news-draft": !0,
    [`type-${e.version.type_id}`]: !0,
    big: e.isBig
  }, attrs: { "data-test-selector": "news-item-draft", "data-test-id": e.newsItemId, "data-test-attrs": `type__${e.version.type_id}${e.isBig ? " maximized" : ""}` } }, [e.visibleBlocks && e.visibleBlocks.length ? e._l(e.visibleBlocks, function(r) {
    return n("NewsEditorBlock", { key: r.type, ref: `editor-${r.type}`, refInFor: !0, attrs: { "data-test-selector": "news-item-edit-block", "data-test-attrs": `type__${r.type}`, block: r, codeItems: e.codeItems, codes: e.codes, content: e.version[r.type], enabled: e.getBlockEnabled(r), editableCanChange: e.getEditableCanChange(r), entities: e.version.entities, errorClasses: e.blockErrorClasses(r.type), errors: e.getBlockErrors(r.type), historyStack: e.history.stack, id: e.version.id, isBig: e.isBig, langId: e.version.language_id, maxSymbols: r.maxSymbols, moexCodes: e.moexCodesNews, newsCodes: e.newsCodes, newsItemId: e.newsItemId, settings: e.settings, title: r.title, type: r.type, typeId: e.version.type_id, useValidate: e.useValidate(r) }, on: { initEditorStore: function(s) {
      return e.init(s);
    }, update: function(s) {
      return e.update(r.type, s);
    }, addValidationError: function(s) {
      return e.addValidationError(s, r.type);
    }, removeValidationError: function(s) {
      return e.removeValidationError(s, r.type);
    }, focus: function(s) {
      return e.setFocusedEditorIndex(r.type);
    }, editorBlur: function(s) {
      return e.blurHandler(r.type, s);
    }, editorDrop: e.dropHandler, navDown: function(s) {
      return e.focusNextEditor(r.type);
    }, navUp: function(s) {
      return e.focusPrevEditor(r.type);
    }, escPressed: function(s) {
      return e.unsetFocusedEditorIndex();
    }, altEnterPressed: function(s) {
      return e.$emit("editorToggleSupply");
    }, undoPressed: e.history.undo, redoPressed: e.history.redo, codeAdded: e.addNewsCode, updateDisable: function(s) {
      return e.$emit("blockDisabledChanged", s);
    } } });
  }) : e._e()], 2);
}, _je = [], wje = /* @__PURE__ */ B(
  yje,
  bje,
  _je,
  !1,
  null,
  null
);
const Sje = wje.exports, Ije = {
  name: "NewsItemDraftCtr",
  mixins: [
    V4,
    /**
     * computed:
     *   colorScheme
     *   colorSchemeName
     *   settings
     *   editorStyle
     */
    ai
  ],
  components: {
    NewsItemEditor: Sje,
    NewsItemEmbargoCtr: Fu,
    NewsItemDate: NI
  },
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    },
    isPanelMaximized: {
      type: Boolean,
      default: !0
    },
    isPanelFocused: {
      type: Boolean,
      default: !1
    },
    panelId: {
      type: [String, Number],
      required: !0
    }
  },
  setup(t, e) {
    const { newsItemId: n } = ts(t), r = Jt("store"), {
      draft: s,
      draftVersion: i,
      create: o,
      updateData: a,
      setNewsType: l,
      validationErrors: c,
      validateEmbargo: u,
      validateDraft: d,
      setEmbargoForm: f,
      setBlockInitialized: p,
      setBlockVisibility: h,
      setBlockDisabled: m
    } = Bu({ newsItemIdRef: n }, r), { typeId: v, isEditable: y, getNewsItemCurrentVersion: _ } = Zi(
      { newsItemIdRef: n },
      r,
      i
    ), { isEmbargoFormVisible: w, isEmbargoValid: S, isScheduled: E } = dc(
      {
        draftRv: s,
        versionRv: i
      },
      r
    ), x = le(() => t.newsItemId), { publishMode: T } = uc({ newsItemIdRef: x }, r), { isRevocation: C } = fc({ newsItemIdRef: n }, r), {
      isEmbargoConfirmOpen: k,
      setEmbargoConfirmOpen: b,
      setEmbargoNotSaved: P,
      ignoreEmbargoNotSaved: N
    } = _8({ draftRv: s }, r);
    return {
      draft: s,
      version: i,
      typeId: v,
      isEditable: y,
      getNewsItemCurrentVersion: _,
      create: o,
      setNewsType: l,
      updateData: a,
      validationErrors: c,
      isEmbargoFormVisible: w,
      isEmbargoValid: S,
      isScheduled: E,
      validateDraft: d,
      validateEmbargo: u,
      setEmbargoForm: f,
      setEmbargoNotSaved: P,
      isEmbargoConfirmOpen: k,
      setEmbargoConfirmOpen: b,
      ignoreEmbargoNotSaved: N,
      setBlockInitialized: p,
      setBlockVisibility: h,
      setBlockDisabled: m,
      publishMode: T,
      isRevocation: C
    };
  },
  computed: {
    ...st({
      userProfile: (t) => t.userProfile
    }),
    ...st("news/codes", {
      codeItems: (t) => t.items
    }),
    ...st("news/drafts", {
      blocks: (t) => t.blocks,
      blockPresets: (t) => t.presets
    }),
    ...pe("news/codes", ["moexCodes", "newsCodes"]),
    ...pe("news/drafts", ["getVisibleBlocks"]),
    ...pe("references", ["codeTypeIds"]),
    ...pe(["isEditorFocused"]),
    visibleBlocks() {
      var t;
      return this.getVisibleBlocks((t = this.draft) == null ? void 0 : t.id);
    },
    moexCodesNews() {
      return this.moexCodes("NEWS_OR_ISSUE");
    },
    editorFocused() {
      return this.isEditorFocused(this.panelId);
    }
  },
  watch: {
    "version.publish_at": function(t, e) {
      this.isPublished || t && t !== e && (this.validateEmbargo({ draftId: this.draft.id }), this.version.is_postponed || this.setEmbargoForm({ draftId: this.draft.id, value: !!t }));
    },
    "version.is_postponed": function(t, e) {
      this.isPublished || !this.draft || t !== e && (this.validateEmbargo({ draftId: this.draft.id }), t ? !this.isEmbargoFormVisible && !this.version.publish_at && this.setEmbargoForm({ draftId: this.draft.id, value: !0 }) : !this.isEditable && !this.publishMode && this.setEmbargoForm({ draftId: this.draft.id, value: !1 }));
    },
    "version.status_id": function(t, e) {
      if (t && t !== e) {
        if (this.isPublished) {
          this.setEmbargoForm({ draftId: this.draft.id, value: !1 });
          return;
        }
        this.validateEmbargo({ draftId: this.draft.id });
      }
    },
    isPanelFocused(t) {
      t && !this.editorFocused ? (this.$enableShortcut("ArrowDown"), this.$enableShortcut("ArrowUp")) : (this.$disableShortcut("ArrowDown"), this.$disableShortcut("ArrowUp"));
    },
    editorFocused(t, e) {
      e === !0 && t === !1 && this.save();
    }
  },
  mounted() {
    var t, e;
    if (!this.draft) {
      const n = this.getNewsItemCurrentVersion(this.newsItemId);
      this.create({ newsItemId: this.newsItemId, version: n });
    }
    this.newsCodes || this.fetchProfileCodes(this.codeTypeIds.NEWS_OR_ISSUE), ((t = this.version) != null && t.publish_at || (e = this.version) != null && e.is_postponed) && this.setEmbargoForm({ draftId: this.draft.id, value: !0 });
  },
  methods: {
    ...ge({
      setEditorFocus: "setPanelEditorFocus"
    }),
    ...ge("news/codes", ["fetchProfileCodes"]),
    ...ge("news/drafts", {
      addCodes: "addCodes",
      save(t) {
        t("saveDraft", {
          newsItemId: this.newsItemId,
          draftId: this.draft.id
        });
      }
    }),
    updateDraftData(t) {
      this.validationErrors.length && this.validationErrors.filter(
        (n) => Object.keys(t).includes(n.block) && !n.internal && n.level === "error"
      ).length && (this.validationErrors = this.validationErrors.filter(
        (n) => !Object.keys(t).includes(n.block) || n.internal
      )), this.updateData({ draftId: this.draft.id, data: t });
    },
    editorFocusHandler(t) {
      this.setEditorFocus({ panelId: this.panelId, focused: t }), t ? (this.$disableShortcut("ArrowDown"), this.$disableShortcut("ArrowUp")) : (this.$enableShortcut("ArrowDown"), this.$enableShortcut("ArrowUp"));
    },
    addInternalError(t) {
      this.validationErrors = [...this.validationErrors, t];
    },
    removeInternalError(t) {
      this.validationErrors = this.validationErrors.filter(
        (e) => !e.internal || e.code !== t.code
      );
    }
  }
};
var Eje = function() {
  var e = this, n = e._self._c;
  return e.draft && e.version ? n("div", [n("NewsItemDate", { style: {
    border: "1px solid #" + e.getColorScheme().innerBorderColor,
    borderTop: "0",
    backgroundColor: e.editorStyle.backgroundColor,
    color: e.editorStyle.color
    // TODO peter: здесь неплохо бы вставить opacity 0.8 - Время слишком яркое
  }, attrs: { date: e.version.created_at } }), e.isEmbargoFormVisible ? n("NewsItemEmbargoCtr", { attrs: { newsItemId: e.newsItemId, version: e.version, isDraft: !0, isEditable: !0, fullSize: !e.isPanelMaximized, isEmbargoConfirmOpen: e.isEmbargoConfirmOpen }, on: { validateEmbargo: e.validateEmbargo, removeEmbargo: function(r) {
    return e.setEmbargoForm({ draftId: e.draft.id, value: !1 });
  }, setNotSaved: function(r) {
    return e.setEmbargoNotSaved({ draftId: e.draft.id, value: r });
  }, ignoreNotSaved: e.ignoreEmbargoNotSaved, closeEmbargoConfirm: function(r) {
    return e.setEmbargoConfirmOpen({ draftId: e.draft.id, value: !1 });
  }, focus: function(r) {
    return e.editorFocusHandler(!0);
  }, blur: function(r) {
    return e.editorFocusHandler(!1);
  } } }) : e._e(), n("NewsItemEditor", { ref: "scrollableArea", class: `theme-${e.colorSchemeName}`, style: e.editorStyle, attrs: { errors: e.validationErrors, newsItemId: e.newsItemId, isBig: e.isPanelMaximized, settings: e.settings, isPanelFocused: e.isPanelFocused, isRevocation: e.isRevocation, codeItems: e.codeItems, userProfile: e.userProfile, version: e.version, blocks: e.blocks, blockPresets: e.blockPresets, visibleBlocks: e.visibleBlocks, typeId: e.typeId, draftId: e.draft.id, moexCodesNews: e.moexCodesNews, newsCodes: e.newsCodes }, on: { initEditorStore: function(r) {
    return e.$emit("initEditorStore", r);
  }, blockInitialized: function(r) {
    return e.setBlockInitialized({
      draftId: e.draft.id,
      blockName: r,
      value: !0
    });
  }, blockVisibilityChanged: function(r) {
    return e.setBlockVisibility({
      draftId: e.draft.id,
      blockName: r.blockName,
      value: r.value
    });
  }, blockDisabledChanged: function(r) {
    return e.setBlockDisabled({
      draftId: e.draft.id,
      blockName: r.blockName,
      value: r.value
    });
  }, addInternalError: e.addInternalError, removeInternalError: e.removeInternalError, editorFocus: e.editorFocusHandler, editorToggleSupply: function(r) {
    return e.$emit("editorToggleSupply");
  }, update: e.updateDraftData, fragmentSelected: function(r) {
    return e.$emit("fragmentSelected", r);
  } } })], 1) : e._e();
}, xje = [], Cje = /* @__PURE__ */ B(
  Ije,
  Eje,
  xje,
  !1,
  null,
  null
);
const Tje = Cje.exports;
function Pje({ newsItemIdRef: t }, e) {
  const n = {
    getNewsItemById: e.getters["news/getNewsItemById"]
  };
  return {
    newsbreak: le(
      () => {
        var s;
        return (s = n.getNewsItemById(t == null ? void 0 : t.value)) == null ? void 0 : s.newsbreak;
      }
    )
  };
}
function S8({ newsItemIdRef: t, versionRv: e, publishModeRef: n = { value: !1 } }, r) {
  const s = {
    newsLangs: r.getters["references/newsLangs"]
  }, i = {
    updateDraftLang: (l) => r.dispatch("news/drafts/updateLang", l)
  };
  return {
    newsLang: le(() => {
      var l, c;
      return s.newsLangs && ((l = e == null ? void 0 : e.value) != null && l.language_id) ? s.newsLangs[(c = e.value) == null ? void 0 : c.language_id] : null;
    }),
    toggleLang: async () => {
      var c;
      if (n.value) return;
      const l = ((c = e == null ? void 0 : e.value) == null ? void 0 : c.language_id) === 1 ? 2 : 1;
      i.updateDraftLang({
        newsItemId: t.value,
        value: l
      });
    }
  };
}
const kje = "_root_10mgz_1", Nje = "_icon_10mgz_7", $je = "_menu_10mgz_12", Dje = "_arrow_10mgz_19", Aje = "_content_10mgz_33", Oje = "_item_10mgz_49", Mje = "_disabled_10mgz_69", Rje = "_inactive_10mgz_74", Lje = "_label_10mgz_81", Fje = "_remove_10mgz_85", Bje = "_removeButton_10mgz_92", jje = "_subheader_10mgz_97", Wje = "_divider_10mgz_104", Hje = "_menuPopup_10mgz_112", Vje = {
  root: kje,
  icon: Nje,
  menu: $je,
  arrow: Dje,
  content: Aje,
  item: Oje,
  disabled: Mje,
  inactive: Rje,
  label: Lje,
  remove: Fje,
  removeButton: Bje,
  subheader: jje,
  divider: Wje,
  menuPopup: Hje
}, zje = {
  name: "NewsItemPanelMenu",
  mixins: [ai],
  components: { PsKitPopup: Ls, PbButton: nt },
  inject: ["getColorScheme"],
  props: {
    panelId: {
      type: [Number, String],
      required: !0
    },
    parentId: {
      type: [String, Number, null],
      default: null
    },
    newsItemId: {
      type: [String, Number],
      default: null
    },
    publishedBy: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    publishMode: {
      type: Boolean,
      default: !1
    },
    excludeSections: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "right-start"
    }
  },
  setup(t) {
    const { publishMode: e, newsItemId: n } = ts(
      t
    ), r = Jt("store"), s = r.getters["news/getNewsItemById"](n.value).parent_rel_type_id === 3, { version: i, isEditable: o, isRemovable: a } = Zi(
      { newsItemIdRef: n },
      r,
      null
    ), { newsbreak: l } = Pje({ newsItemIdRef: n }, r), { newsLang: c, toggleLang: u } = S8(
      {
        newsItemIdRef: n,
        versionRv: i,
        publishModeRef: e
      },
      r
    ), { isRevoked: d, isRevocation: f } = fc({ newsItemIdRef: n }, r), { calcOffset: p, calcArrowPadding: h } = FL(), { showShareModal: m } = Kv();
    return {
      isRevokee: s,
      isEditable: o,
      isRemovable: a,
      version: i,
      newsbreak: l,
      newsLang: c,
      toggleLang: u,
      isRevoked: d,
      isRevocation: f,
      calcOffset: p,
      calcArrowPadding: h,
      showShareModal: m
    };
  },
  data() {
    return {
      menuShowed: !1
    };
  },
  computed: {
    ...st({
      panels: (t) => t.panels.data,
      windowParams: (t) => t.uiState.windowParams
    }),
    ...pe("news", [
      "newsItemLanguageName",
      "newsItemVersionLanguageName",
      "getCanUserEditNewsItem",
      "getIsNewsItemWorkable"
    ]),
    ...pe("references", [
      "newsTypes",
      "newsStatuses",
      "newsLangs",
      "newsStatusesByName"
    ]),
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    panel() {
      return this.panels.find(({ id: t } = {}) => t === this.panelId);
    },
    maxHeight() {
      return this.windowParams.height - 180 - 5;
    },
    menuItems() {
      const t = [], e = (r) => !(!this.version && r !== "withClose" || this.excludeSections.includes(r));
      return [
        "withNewsbreak",
        // Панель инфоповода
        // 'withDelete', // Удаление
        "withRecall",
        // Отозвать новость
        "withRevoke",
        // Аннулирование
        "withLang",
        // Язык
        "withAuthors",
        // Авторы
        "withEditor",
        // Редактор
        "withHistory",
        // История
        "withRelations",
        "withASOI",
        // Отправить в АСОИ
        "withCopyText",
        // Копировать текст новости
        "withForbiddenEntities",
        // Разметить запрещённые сущности
        "withClose"
        // Закрытие панели
      ].forEach((r) => {
        e(r) && this[r](t);
      }), t;
    },
    supplyShowed() {
      return this.panel.supply && this.panel.supply.left[0] ? this.panel.supply.left[0].settings.visible : !1;
    },
    panelColor() {
      return "#" + this.getColorScheme().accentColor;
    },
    elementColor() {
      return this.getColorScheme().theme === "dark" ? "rgba(255,255,255, .87)" : "rgba(0,0,0, .87)";
    }
  },
  methods: {
    ...ge(["setModal"]),
    ...ge("news", ["deleteAuthor", "recallNewsItem"]),
    ...ge("news/drafts", ["annotateForbidden"]),
    ...ge("authorsModal", ["showAuthorsModal"]),
    ...ge(["showHistoryModal", "showRelationsModal"]),
    ...ge("panels", [
      "removePanel",
      "toggleSupplyOfType",
      "hideSupply"
    ]),
    handler(t) {
      this.disabled || t.handler && (t.enabled && t.handler(), this.$emit("hide"));
    },
    toggleMenu() {
      this.disabled || (this.menuShowed = !this.menuShowed);
    },
    showDeleteDialog() {
      this.$emit("showDeleteDialog");
    },
    removeAuthor(t) {
      this.deleteAuthor({ newsItemId: this.newsItemId, userId: t });
    },
    copyText() {
      this.$emit("copyText");
    },
    revoke() {
      this.$emit("revoke");
    },
    withEditor(t) {
      this.publishedBy && (t.push({
        subheader: !0,
        label: "Редактор",
        code: "editor"
      }), t.push({
        label: this.formatUsername(this.publishedBy.name),
        enabled: !0,
        inactive: !0,
        code: `editor_${this.publishedBy.id}`
      }), t.push({ divider: !0 }));
    },
    withNewsbreak(t) {
      var e, n, r;
      if (this.newsbreak) {
        if (!((r = (n = (e = this.panel) == null ? void 0 : e.supply) == null ? void 0 : n.left) == null ? void 0 : r.find(
          (o) => o.type === gt.newsItemNewsbreakSupply
        ))) return;
        const i = () => this.toggleSupplyOfType({
          panelId: this.panel.id,
          type: gt.newsItemNewsbreakSupply,
          hideOthers: !0
        });
        this.supplyShowed ? t.push({
          label: "Скрыть инфоповод",
          code: "hide_newsbreak",
          handler: i,
          enabled: !0
        }) : t.push({
          label: "Показать инфоповод",
          code: "show_newsbreak",
          handler: i,
          enabled: !0
        });
      }
    },
    withAuthors(t) {
      this.version && this.version.authors && (t.push({
        subheader: !0,
        label: this.version.authors.length > 1 ? "Авторы" : "Автор",
        code: "authors"
      }), this.version.authors.forEach((e) => {
        t.push({
          label: this.formatUsername(e.user.name),
          enabled: !0,
          inactive: !0,
          is_removable: this.isEditable ? e.is_removable : !1,
          id: e.user.id,
          code: `author_${e.user.id}`
        });
      }), this.isRevocation || t.push({
        label: "Добавить…",
        enabled: this.isEditable,
        handler: this.showAuthorsModal.bind(this, this.newsItemId),
        code: "add_author"
      }), t.push({ divider: !0 }));
    },
    withLang(t) {
      var e;
      t.push({
        subheader: !0,
        label: `Язык: ${(e = this.newsLang) == null ? void 0 : e.description}`,
        code: "current_lang"
      }), t.push({
        label: "Сменить язык",
        code: "change_lang",
        handler: this.toggleLang.bind(this),
        enabled: this.isEditable && !this.isRevocation
      }), t.push({ divider: !0 });
    },
    withClose(t) {
      const e = {
        label: "Закрыть панель",
        code: "close",
        handler: this.removePanel.bind(this, { panelId: this.panelId }),
        enabled: !0
      };
      this.parentId !== null && (e.handler = this.hideSupply.bind(this, {
        panelId: this.parentId,
        supplyId: this.panelId
      })), t.push(e);
    },
    withRecall(t) {
      const e = ["WAITS_FOR_EDIT"], n = this.newsStatuses[this.version.status_id].name;
      e.includes(n) && t.push({
        label: "Отозвать новость",
        code: "recall",
        handler: this.recallNewsItem.bind(this, {
          newsItemId: this.newsItemId
        }),
        enabled: !0
      });
    },
    withRevoke(t) {
      this.version.status_id === this.newsStatusesByName.PUBLISHED.id && !this.isRevoked && !this.isRevokee && (this.getIsNewsItemWorkable(this.newsItemId) || this.getIsUserHasAllPermissions(["2.11"])) && (t.push({
        label: "Аннулировать",
        code: "revoke",
        handler: this.revoke.bind(this),
        enabled: !0
      }), t.push({ divider: !0 }));
    },
    withHistory(t) {
      t.push({
        label: "Посмотреть историю работы",
        code: "show_history",
        handler: this.showHistoryModal.bind(this, {
          itemId: this.newsItemId,
          itemType: "news"
        }),
        enabled: !0
      });
    },
    withRelations(t) {
      t.push({
        label: "Посмотреть связанные материалы",
        code: "show_relations",
        handler: this.showRelationsModal.bind(this, this.newsItemId),
        enabled: !0
      }), t.push({ divider: !0 });
    },
    withASOI(t) {
      t.push({
        label: "Отправить в АСОИ…",
        code: "send_to_asoi",
        handler: () => {
          this.showShareModal({
            itemId: this.newsItemId,
            itemType: "newsItem",
            actionType: "sendToAsoi"
          }), this.setModal(!0);
        },
        enabled: !0
      }), t.push({ divider: !0 });
    },
    withCopyText(t) {
      t.push({
        label: "Копировать текст новости",
        code: "copy_text",
        handler: this.copyText.bind(this),
        enabled: !0
      });
    },
    withForbiddenEntities(t) {
      t.push({
        label: "Выделить запрещённые организации",
        code: "forbidden_entities",
        handler: () => this.annotateForbidden({ newsItemId: this.newsItemId }),
        enabled: this.isEditable
      });
    }
  }
};
var Uje = function() {
  var e = this, n = e._self._c;
  return n("PsKitPopup", { attrs: { classPopup: e.$style.menuPopup, placement: e.position, visible: e.visible, floatingOptions: { offset: { crossAxis: -15, mainAxis: 10 } } }, on: { hide: function(r) {
    return e.$emit("hide");
  } }, scopedSlots: e._u([{ key: "default", fn: function() {
    return [n("div", { class: e.$style.content, style: { maxHeight: e.maxHeight } }, [e._l(e.menuItems, function(r, s) {
      return [r.divider ? n("hr", { key: s, staticClass: "divider" }) : r.subheader ? n("div", { key: s, class: e.$style.subheader, attrs: { "data-test-selector": "panel-menu-item", "data-test-id": r.id, "data-test-attrs": `item__subheader item-code__${r.code} item-id__${r.id}` } }, [e._v(" " + e._s(r.label) + " ")]) : n("div", { key: s, class: {
        [e.$style.item]: !0,
        [e.$style.inactive]: r.inactive,
        [e.$style.disabled]: !r.enabled
      }, attrs: { "data-test-selector": "panel-menu-item", "data-test-attrs": `item-code__${r.code} item-id__${r.id}` }, on: { click: function(i) {
        return i.stopPropagation(), i.preventDefault(), e.handler(r);
      } } }, [n("span", { class: e.$style.label }, [e._v(e._s(r.label))]), r.is_removable ? n("span", { class: e.$style.remove, attrs: { "data-role": "menu-remove" } }, [n("PbButton", { class: e.$style.removeButton, attrs: { round: "", "data-test-selector": "panel-menu-item-remove" }, on: { click: function(i) {
        return i.preventDefault(), i.stopPropagation(), e.$emit("remove", { id: r.id, code: r.code });
      } } }, [n("icon", { attrs: { name: "close", size: "7" } })], 1)], 1) : e._e()])];
    })], 2)];
  }, proxy: !0 }]) });
}, Gje = [];
const B3 = {
  $style: Vje
};
function Yje(t) {
  for (var e in B3)
    this[e] = B3[e];
}
var Zje = /* @__PURE__ */ B(
  zje,
  Uje,
  Gje,
  !1,
  Yje,
  null
);
const I8 = Zje.exports, Xje = "_root_j7sj6_1", Kje = "_body_j7sj6_5", Jje = "_right_j7sj6_24", qje = "_left_j7sj6_28", Qje = "_arrow_j7sj6_32", eWe = {
  root: Xje,
  body: Kje,
  right: Jje,
  left: qje,
  arrow: Qje
}, tWe = {
  name: "PbSelectVertical",
  mixins: [Vr],
  props: {
    position: {
      type: String,
      default: "left",
      validator: (t) => ["left", "right"].includes(t)
    },
    trigger: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    keyField: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    onClick(t) {
      this.disabled || (this.$emit("update:trigger", t), this.$emit("toggle"));
    }
  }
};
var nWe = function() {
  var e = this, n = e._self._c;
  return n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: () => e.onClick(!1), expression: "() => onClick(false)" }], class: e.$style.root }, [n("div", { class: e.$style.trigger, on: { click: function(r) {
    return e.onClick(!e.trigger);
  } } }, [e._t("selected")], 2), n("transition", { attrs: { name: "fade" } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.trigger, expression: "trigger" }], class: [e.$style.body, e.$style[e.position]] }, [n("div", { class: e.$style.arrow }), n("ul", e._l(e.items, function(r, s) {
    return n("li", { key: e.keyField !== null ? r[e.keyField] : s, on: { click: function(i) {
      return e.onClick(!1);
    } } }, [e._t("item", null, { item: r, index: s })], 2);
  }), 0)])])], 1);
}, rWe = [];
const j3 = {
  $style: eWe
};
function sWe(t) {
  for (var e in j3)
    this[e] = j3[e];
}
var iWe = /* @__PURE__ */ B(
  tWe,
  nWe,
  rWe,
  !1,
  sWe,
  null
);
const oWe = iWe.exports, aWe = {
  "type-button": "_type-button_e8il2_1",
  "type-button__red": "_type-button__red_e8il2_5",
  "type-button__blue": "_type-button__blue_e8il2_9"
}, lWe = {
  name: "NewsItemTypeSwitcher",
  components: {
    PbSelectVertical: oWe,
    NewsTypeButton: ea
  },
  props: {
    types: {
      type: Array,
      required: !0
    },
    typeId: {
      type: [Number, String],
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    newsTypes: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      menuShowed: !1
    };
  },
  computed: {
    contentClass() {
      return this.typeId < 3 ? this.$style["type-button__red"] : this.$style["type-button__blue"];
    }
  }
};
var cWe = function() {
  var e = this, n = e._self._c;
  return n("PbSelectVertical", { attrs: { trigger: e.menuShowed, items: e.types, keyField: "id", disabled: e.disabled }, on: { "update:trigger": function(r) {
    e.menuShowed = r;
  } }, scopedSlots: e._u([{ key: "selected", fn: function() {
    return [n("NewsTypeButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: e.newsTypes[e.typeId] && e.newsTypes[e.typeId].description, expression: "newsTypes[typeId] && newsTypes[typeId].description", modifiers: { right: !0 } }], attrs: { typeId: e.typeId, showLabel: !1, color: e.typeId < 3 ? "#d0021b" : "#0069E4", contentClass: e.contentClass, "data-test-selector": "news-type-button", "data-test-id": e.typeId, "data-test-attrs": `type__${e.typeId}` } })];
  }, proxy: !0 }, { key: "item", fn: function({ item: r }) {
    return [n("NewsTypeButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.left", value: e.newsTypes[r.id] && e.newsTypes[r.id].description, expression: "newsTypes[item.id] && newsTypes[item.id].description", modifiers: { left: !0 } }], staticClass: "draggable-ignore", attrs: { typeId: r.id, active: r.id === e.typeId, showLabel: !1, "data-test-selector": "news-type-button", "data-test-id": r.id, "data-test-attrs": `type__${r.id}` }, on: { click: function(s) {
      return e.$emit("setNewsType", r.id);
    } } })];
  } }]) });
}, uWe = [];
const W3 = {
  $style: aWe
};
function dWe(t) {
  for (var e in W3)
    this[e] = W3[e];
}
var fWe = /* @__PURE__ */ B(
  lWe,
  cWe,
  uWe,
  !1,
  dWe,
  null
);
const pWe = fWe.exports, hWe = "_root_18l5g_1", mWe = {
  root: hWe
}, vWe = {
  name: "NewsItemLang",
  props: {
    newsLang: {
      type: Object,
      required: !0
    }
  }
};
var gWe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { attrs: { title: e.newsLang.description, "data-test-selector": "panel-news-item-lang" } }, [e._v(" " + e._s(e.newsLang.name) + " ")])]);
}, yWe = [];
const H3 = {
  $style: mWe
};
function bWe(t) {
  for (var e in H3)
    this[e] = H3[e];
}
var _We = /* @__PURE__ */ B(
  vWe,
  gWe,
  yWe,
  !1,
  bWe,
  null
);
const wWe = _We.exports, SWe = "_root_lu9pi_1", IWe = {
  root: SWe
}, EWe = {
  name: "NewsItemAddBlock",
  components: {
    PbButton: nt
  },
  props: {
    type: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: "Текст"
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      symbols: {
        subheadline: "H2",
        trashline: "Tr",
        dateline: "Dt",
        body: "Tx"
      }
    };
  }
};
var xWe = function() {
  var e = this, n = e._self._c;
  return n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: `Добавить ${e.title.toLowerCase()}`, expression: "`Добавить ${title.toLowerCase()}`", modifiers: { right: !0 } }], class: e.$style.root, attrs: { disabled: !e.enabled, "data-test-selector": "add-block", "data-test-attrs": `type__${e.type}` }, on: { click: function(r) {
    return e.$emit("addBlock", e.type);
  } } }, [e._v(" " + e._s(e.symbols[e.type]) + " ")]);
}, CWe = [];
const V3 = {
  $style: IWe
};
function TWe(t) {
  for (var e in V3)
    this[e] = V3[e];
}
var PWe = /* @__PURE__ */ B(
  EWe,
  xWe,
  CWe,
  !1,
  TWe,
  null
);
const kWe = PWe.exports, NWe = "_root_hkcib_1", $We = {
  root: NWe,
  "pb-main-action-button": "_pb-main-action-button_hkcib_12",
  "back-to-edit": "_back-to-edit_hkcib_15",
  "pb-icon": "_pb-icon_hkcib_19"
}, DWe = {
  name: "ToolbarVertical",
  props: {
    classes: {
      type: Array,
      default: () => []
    }
  }
};
var AWe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, ...e.classes] }, [e._t("default")], 2);
}, OWe = [];
const z3 = {
  $style: $We
};
function MWe(t) {
  for (var e in z3)
    this[e] = z3[e];
}
var RWe = /* @__PURE__ */ B(
  DWe,
  AWe,
  OWe,
  !1,
  MWe,
  null
);
const DI = RWe.exports, LWe = "_divider_9imzf_1", FWe = "_btnAddBlock_9imzf_8", BWe = "_control_9imzf_9", jWe = "_redo_9imzf_16", WWe = {
  divider: LWe,
  btnAddBlock: FWe,
  control: BWe,
  redo: jWe,
  "chat-toggle-button": "_chat-toggle-button_9imzf_20",
  "chat-unread-sign": "_chat-unread-sign_9imzf_24"
}, HWe = {
  name: "PanelActions",
  components: {
    NewsItemLang: wWe,
    NewsItemPanelMenu: I8,
    NewsItemTypeSwitcher: pWe,
    NewsItemAddBlock: kWe,
    PbButton: nt,
    ToolbarVertical: DI
  },
  props: {
    newsItemId: [String, Number],
    panelId: [String, Number],
    parentId: {
      type: [String, Number, null],
      default: null
    },
    types: {
      type: Array,
      required: !0
    },
    typeId: {
      type: [Number, String],
      required: !0
    },
    isEditable: {
      type: Boolean,
      default: !1
    },
    isMaximized: {
      type: Boolean,
      default: !0
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    undoable: {
      type: Boolean,
      default: !1
    },
    redoable: {
      type: Boolean,
      default: !1
    },
    newsTypes: {
      type: Object,
      default: () => ({})
    },
    publishMode: {
      type: Boolean,
      default: !1
    },
    publishedBy: {
      type: [Object, null],
      default: null
    },
    newsLang: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    chatHasUnread: {
      type: Boolean,
      default: !1
    },
    editorStyle: {
      type: Object,
      default: () => ({})
    },
    colorScheme: {
      type: Object,
      default: () => ({})
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    // blocksMenuItems: {
    //   type: Array,
    //   default: () => []
    // },
    blocksToAdd: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return {
      menuVisible: et(!1),
      isSupply: le(() => t.parentId !== null)
    };
  }
};
var VWe = function() {
  var e = this, n = e._self._c;
  return n("ToolbarVertical", { class: e.$style.root, style: {
    border: "1px solid #" + e.colorScheme.innerBorderColor
  } }, [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Действия с новостью", expression: "'Действия с новостью'", modifiers: { right: !0 } }], class: [e.$style.control, e.$style.icon], attrs: { disabled: e.disabled }, on: { click: function(r) {
    r.preventDefault(), e.menuVisible = !0;
  } } }, [n("icon", { attrs: { type: "font", name: "menu", size: 22 } }), e.menuVisible ? n("NewsItemPanelMenu", { attrs: { newsItemId: e.newsItemId, panelId: e.panelId, parentId: e.parentId, publishedBy: e.publishedBy, publishMode: e.publishMode, visible: e.menuVisible, position: "left-start" }, on: { copyText: function(r) {
    return e.$emit("copyText");
  }, revoke: function(r) {
    return e.$emit("revoke");
  }, remove: function(r) {
    return e.$emit("remove", r);
  }, hide: function(r) {
    e.menuVisible = !1;
  } } }) : e._e()], 1), n("hr", { class: e.$style.divider }), e.typeId ? n("NewsItemTypeSwitcher", { class: e.$style.control, attrs: { typeId: e.typeId, types: e.types, newsTypes: e.newsTypes, disabled: !e.isEditable || e.publishMode }, on: { setNewsType: function(r) {
    return e.$emit("setNewsType", r);
  } } }) : e._e(), e.newsLang.name === "EN" ? n("NewsItemLang", { attrs: { newsLang: e.newsLang } }) : e._e(), e._l(e.blocksToAdd, function(r) {
    return n("NewsItemAddBlock", { key: r.type, class: e.$style.btnAddBlock, attrs: { title: r.title, type: r.type, enabled: r.enabled }, on: { addBlock: function(s) {
      return e.$emit("addBlock", s);
    } } });
  }), e.isSupply ? e._e() : [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Отменить ввод текста", expression: "'Отменить ввод текста'", modifiers: { right: !0 } }], staticClass: "undo", class: { _disabled: !e.undoable, [e.$style.control]: !0 }, attrs: { disabled: !e.undoable || e.publishMode, role: "undo" }, on: { click: function(r) {
    return e.$emit("undo");
  } } }, [n("icon", { attrs: { name: "undo", size: "16" } })], 1), n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Повторить ввод текста", expression: "'Повторить ввод текста'", modifiers: { right: !0 } }], class: {
    _disabled: !e.redoable,
    [e.$style.redo]: !0,
    [e.$style.control]: !0
  }, attrs: { disabled: !e.redoable || e.publishMode, role: "redo" }, on: { click: function(r) {
    return e.$emit("redo");
  } } }, [n("icon", { attrs: { name: "undo", size: "16" } })], 1), n("hr", { class: e.$style.divider }), n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Показать коды", expression: "'Показать коды'", modifiers: { right: !0 } }], class: e.$style.control, on: { click: function(r) {
    return e.$emit("toggleRightSupply", { activeTabIndex: 0 });
  } } }, [n("icon", { attrs: { name: "outline/topics", size: "16" } })], 1), n("span", { class: e.$style["chat-toggle-button"] }, [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Показать чат", expression: "'Показать чат'", modifiers: { right: !0 } }], class: e.$style.control, on: { click: function(r) {
    return e.$emit("toggleRightSupply", { activeTabIndex: 1 });
  } } }, [n("icon", { attrs: { name: "outline/chat-and-codes", size: "24" } })], 1), e.chatHasUnread ? n("span", { staticClass: "chat-unread-sign", style: { borderColor: e.editorStyle.backgroundColor } }) : e._e()], 1)]], 2);
}, zWe = [];
const U3 = {
  $style: WWe
};
function UWe(t) {
  for (var e in U3)
    this[e] = U3[e];
}
var GWe = /* @__PURE__ */ B(
  HWe,
  VWe,
  zWe,
  !1,
  UWe,
  null
);
const E8 = GWe.exports;
function Cl(t, e, n = 0) {
  if (!t) return "";
  let r = "";
  return t.type === "table" ? (r += YWe(t), r) : (t.type === "paragraph" && n !== 0 && (r += `
`, e !== "subheadline" && (r += "	")), t.type === "text" ? (r += t.text, r) : (t.content && Array.isArray(t.content) && t.content.forEach((s) => {
    r += Cl(s, e, n++);
  }), r));
}
function x8(t, e = 0) {
  if (!t) return "";
  let n = "";
  return t.type === "paragraph" && (e !== 0 || !t.content) && (n += " "), t.type === "text" ? (n += t.text, n) : (t.content && Array.isArray(t.content) && t.content.forEach((r) => {
    n += x8(r, e++);
  }), n);
}
function YWe(t) {
  let e = `
`;
  return t.content && Array.isArray(t.content) && t.content.forEach((n) => {
    n.content && n.content.forEach((r) => {
      e += x8(r) + "	";
    }), e += `
`;
  }), e;
}
function ZWe(t, e) {
  const n = le(
    () => {
      var i;
      return (i = e.getters["news/getNewsItemCurrentVersion"](t.value)) == null ? void 0 : i.type_id;
    }
  ), r = le(
    () => {
      var i;
      return (i = e.getters["references/newsTypes"][n.value]) == null ? void 0 : i.name;
    }
  );
  function s() {
    var p, h, m, v, y, _;
    const i = e.$_newsEditors[t.value], o = Cl(
      (p = i.slugline) == null ? void 0 : p.view.state.doc.toJSON(),
      "slugline"
    ), a = Cl((h = i.body) == null ? void 0 : h.view.state.doc.toJSON(), "body"), l = Cl(
      (m = i.headline) == null ? void 0 : m.view.state.doc.toJSON(),
      "headline"
    ), c = Cl(
      (v = i.subheadline) == null ? void 0 : v.view.state.doc.toJSON(),
      "subheadline"
    ), u = Cl(
      (y = i.dateline) == null ? void 0 : y.view.state.doc.toJSON(),
      "dateline"
    ), d = Cl(
      (_ = i.trashline) == null ? void 0 : _.view.state.doc.toJSON(),
      "trashline"
    );
    let f = "";
    switch (r.value) {
      case "FLASH":
        f = `${o}
${l}`;
        break;
      case "EXPRESS":
        f = `${o}
${l}
${c ? c + `
` : ""}${d ? d + `
` : ""}	${u} ${a}`;
        break;
      case "NEWS":
        f = `${o}
${l}
${c ? c + `
` : ""}${d ? d + `
` : ""}	${u} ${a}`;
        break;
      default:
        f = `${o}
${l}
	${u} ${a}`;
        break;
    }
    try {
      const w = document.createElement("textarea");
      w.id = "copy-holder", w.innerHTML = f, document.body.appendChild(w), w.select(), document.execCommand("copy"), document.querySelector("#copy-holder").remove(), e.dispatch("addMessage", {
        type: "success",
        text: "Текст новости скопирован в буфер обмена"
      });
    } catch {
      e.dispatch("addMessage", {
        type: "error",
        text: "Ошибка копирования текста новости"
      });
    }
  }
  return { copyText: s };
}
const G3 = el.getParser(globalThis.navigator.userAgent), XWe = Yf(), KWe = {
  name: "PanelActionsCtr",
  mixins: [ai],
  components: { PanelActions: E8 },
  props: {
    newsItemId: {
      type: [String, Number],
      default: null
    },
    panelId: {
      type: [String, Number],
      required: !0
    },
    parentId: {
      type: [String, Number, null],
      default: null
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    isMaximized: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, e) {
    const { newsItemId: n } = ts(t), r = Jt("store");
    r.dispatch("getChatMessages", {
      newsItemId: n.value,
      params: {
        cursor: null,
        limit: 100
      }
    });
    const {
      updateType: s,
      setBlockVisibility: i,
      draft: o,
      draftVersion: a,
      setNewsType: l
    } = Bu({ newsItemIdRef: n }, r), c = Zi({ newsItemIdRef: n }, r, a), u = eg(t.newsItemId, r), d = {
      historyMode: le(
        () => r.getters["panels/getIsPanelHistoryMode"](t.panelId)
      )
    }, f = le(
      () => d.historyMode.value ? u.version.value : c.version.value
    ), p = le(
      () => d.historyMode.value ? u.typeId.value : c.typeId.value
    ), h = le(
      () => d.historyMode.value ? !1 : c.isEditable.value
    ), { newsLang: m } = S8({ newsItemIdRef: n, versionRv: f }, r), { publishedBy: v, publishMode: y } = uc(
      { newsItemIdRef: n },
      r
    ), { copyText: _ } = ZWe(n, r);
    return {
      updateType: s,
      setBlockVisibility: i,
      draft: o,
      setNewsType: l,
      version: f,
      typeId: p,
      isEditable: h,
      newsLang: m,
      publishedBy: v,
      publishMode: y,
      copyText: _,
      ...d
    };
  },
  computed: {
    ...st({
      chatMessages: (t) => t.chat.messagesMap
    }),
    ...st("news/drafts", {
      blocks: (t) => t.blocks
    }),
    ...pe(["userId"]),
    ...pe("news/drafts", ["getUnusedBlocks"]),
    ...pe("references", ["newsTypes"]),
    types() {
      return Object.entries(this.newsTypes).map(([t, e]) => ({
        id: Number(t),
        ...e
      }));
    },
    history() {
      return this.draft ? $I.editors[this.draft.id] : null;
    },
    undoable() {
      var t, e, n;
      return !this.historyMode && !!((n = (e = (t = this.history) == null ? void 0 : t.stack) == null ? void 0 : e.undo) != null && n.length);
    },
    redoable() {
      var t, e, n;
      return !this.historyMode && !!((n = (e = (t = this.history) == null ? void 0 : t.stack) == null ? void 0 : e.redo) != null && n.length);
    },
    blocksToAdd() {
      if (!this.historyMode && this.draft) {
        const t = XWe[this.typeId], e = this.getUnusedBlocks(this.draft.id), n = e.map((s) => s.type);
        return ["subheadline", "trashline"].concat(this.typeId === 10 ? ["dateline", "body"] : []).filter((s) => t.includes(s)).map((s) => {
          var i;
          return {
            title: (i = e.find((o) => o.type === s)) == null ? void 0 : i.title,
            type: s,
            enabled: n.includes(s)
          };
        });
      }
      return [];
    },
    chatHasUnread() {
      var t;
      return ((t = this.$store.getters.unreadMessages(this.newsItemId, this.userId)) == null ? void 0 : t.length) > 0;
    },
    isMobile() {
      return G3.isOS("ios") || G3.isOS("android");
    }
  },
  methods: {
    ...ge(["addMessage"]),
    ...ge("news", ["revokeNewsItem", "deleteAuthor"]),
    ...ge("news/drafts", {
      addBlock(t, e) {
        this.setBlockVisibility({
          newsItemId: this.newsItemId,
          blockName: e,
          value: !0
        });
      }
    }),
    undo() {
      this.history && this.history.undo();
    },
    redo() {
      this.history && this.history.redo();
    },
    revoke() {
      this.revokeNewsItem({ newsItemId: this.newsItemId });
    },
    remove(t) {
      t.code.includes("author") && this.deleteAuthor({ userId: t.id, newsItemId: this.newsItemId });
    }
  }
};
var JWe = function() {
  var e = this, n = e._self._c;
  return e.newsItemId !== null && e.version ? n("PanelActions", { attrs: { chatHasUnread: e.chatHasUnread, editorStyle: e.editorStyle, colorScheme: e.getColorScheme(), blocksToAdd: e.blocksToAdd, isEditable: e.isEditable, isFullscreen: e.isFullscreen, isMaximized: e.isMaximized, isMobile: e.isMobile, newsItemId: e.newsItemId, newsLang: e.newsLang, newsTypes: e.newsTypes, panelId: e.panelId, parentId: e.parentId, publishMode: e.publishMode, publishedBy: e.publishedBy, redoable: e.redoable, typeId: e.typeId, types: e.types, undoable: e.undoable }, on: { setNewsType: e.setNewsType, showDeleteDialog: function(r) {
    return e.$emit("showDeleteDialog");
  }, toggleRightSupply: function(r) {
    return e.$emit("toggleRightSupply", r);
  }, addBlock: e.addBlock, undo: e.undo, redo: e.redo, copyText: e.copyText, revoke: e.revoke, remove: e.remove } }) : e._e();
}, qWe = [], QWe = /* @__PURE__ */ B(
  KWe,
  JWe,
  qWe,
  !1,
  null,
  null
);
const eHe = QWe.exports, tHe = "_root_10umv_1", nHe = "_right_10umv_14", rHe = "_left_10umv_20", sHe = "_wrapper_10umv_42", iHe = "_ios_10umv_54", oHe = {
  root: tHe,
  right: nHe,
  left: rHe,
  wrapper: sHe,
  ios: iHe
}, aHe = el.getParser(globalThis.navigator.userAgent), lHe = {
  name: "ToolbarWrapper",
  mixins: [Vr],
  props: {
    position: {
      type: String,
      default: "left"
    }
  },
  data() {
    return {
      hover: !1
    };
  },
  computed: {
    isIos() {
      return aHe.isOS("ios");
    }
  },
  methods: {
    // В браузерах на базе Chromium pointer-events обрабатывается некорректно.
    // Если высота тела панели меньше высоты блока с тулбарами, то прокрутка тулбара не работает.
    // Поэтому мы добавляем и убираем соответствующие стили при наведении на область с тулбарами
    setPointerEvents() {
      this.hover = !0;
    },
    removePointerEvents() {
      this.hover = !1;
    }
  }
};
var cHe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "draggable-handle", class: {
    [e.$style.root]: !0,
    [e.$style[e.position]]: !0,
    [e.$style.ios]: e.isIos
  }, style: {
    pointerEvents: e.hover ? "auto" : "none"
  } }, [n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.removePointerEvents, expression: "removePointerEvents" }], class: e.$style.wrapper, on: { touchstart: e.setPointerEvents, mouseover: e.setPointerEvents, mouseleave: e.removePointerEvents, click: e.setPointerEvents } }, [e._t("default")], 2)]);
}, uHe = [];
const Y3 = {
  $style: oHe
};
function dHe(t) {
  for (var e in Y3)
    this[e] = Y3[e];
}
var fHe = /* @__PURE__ */ B(
  lHe,
  cHe,
  uHe,
  !1,
  dHe,
  null
);
const hg = fHe.exports, pHe = {
  name: "PanelToolbar",
  components: {
    PanelActionsCtr: eHe,
    ToolbarWrapper: hg
  },
  props: {
    newsItemId: {
      type: [String, Number, null],
      required: !0
    },
    panelId: {
      type: [String, Number],
      required: !0
    },
    parentId: {
      type: [String, Number, null],
      default: null
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    isMaximized: {
      type: Boolean,
      default: !1
    },
    notFound: {
      type: Boolean,
      default: !1
    },
    publishMode: {
      type: Boolean,
      default: !1
    },
    selectedFragment: {
      type: [String, null],
      default: null
    }
  }
};
var hHe = function() {
  var e = this, n = e._self._c;
  return n("ToolbarWrapper", { attrs: { position: "right" } }, [n("div", [e.publishMode ? e._e() : n("PanelActionsCtr", { attrs: { newsItemId: e.notFound ? null : e.newsItemId, panelId: e.panelId, parentId: e.parentId, isFullscreen: e.isFullscreen, isMaximized: e.isMaximized }, on: { showDeleteDialog: function(r) {
    return e.$emit("showDeleteDialog");
  }, toggleRightSupply: function(r) {
    return e.$emit("toggleRightSupply", r);
  } } })], 1)]);
}, mHe = [], vHe = /* @__PURE__ */ B(
  pHe,
  hHe,
  mHe,
  !1,
  null,
  null
);
const gHe = vHe.exports, yHe = "_root_1l64a_1", bHe = "_fullscreen_1l64a_6", _He = "_publishMode_1l64a_10", wHe = {
  root: yHe,
  fullscreen: bHe,
  publishMode: _He
}, SHe = {
  name: "EditorToolbar",
  components: {
    ToolbarWrapper: hg,
    ToolbarVertical: DI,
    MainActionButton: fn
  },
  props: {
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    publishMode: {
      type: Boolean,
      default: !1
    }
  }
};
var IHe = function() {
  var e = this, n = e._self._c;
  return n("ToolbarWrapper", [e.publishMode ? n("ToolbarVertical", { attrs: { classes: [
    e.$style.root,
    e.isFullscreen ? [e.$style.fullscreen] : null,
    e.publishMode ? [e.$style.publishMode] : null
  ] } }, [n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.left-start", value: "Вернуться к тексту", expression: "'Вернуться к тексту'", modifiers: { "left-start": !0 } }], staticClass: "back pb-action-button-old", attrs: { iconName: "button-icon-arrow-left", "data-test-selector": "news-item-button-back" }, on: { click: function(r) {
    return e.$emit("back");
  } } })], 1) : e._e()], 1);
}, EHe = [];
const Z3 = {
  $style: wHe
};
function xHe(t) {
  for (var e in Z3)
    this[e] = Z3[e];
}
var CHe = /* @__PURE__ */ B(
  SHe,
  IHe,
  EHe,
  !1,
  xHe,
  null
);
const THe = CHe.exports, PHe = {
  name: "EditorToolbarCtr",
  components: {
    EditorToolbar: THe
  },
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    publishMode: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    ...ge("news/drafts", {
      disablePublishMode: "disablePublishMode"
    })
  }
};
var kHe = function() {
  var e = this, n = e._self._c;
  return n("EditorToolbar", { attrs: { isFullscreen: e.isFullscreen, publishMode: e.publishMode }, on: { back: function(r) {
    return e.disablePublishMode({ newsItemId: e.newsItemId });
  } } });
}, NHe = [], $He = /* @__PURE__ */ B(
  PHe,
  kHe,
  NHe,
  !1,
  null,
  null
);
const DHe = $He.exports, AHe = {};
var OHe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "root" }, [e._t("default")], 2);
}, MHe = [], RHe = /* @__PURE__ */ B(
  AHe,
  OHe,
  MHe,
  !1,
  null,
  "4a4370b5"
);
const LHe = RHe.exports, cl = {
  components: {
    MainActionButton: fn,
    VersionActionsWrap: LHe
  },
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    },
    isMy: {
      type: Boolean,
      default: !1
    },
    isRevoked: {
      type: Boolean,
      default: !1
    },
    isRemovable: {
      type: Boolean,
      default: !1
    },
    userCanChangeCodes: {
      type: Boolean,
      default: !1
    },
    userCanEditEmbargo: {
      type: Boolean,
      default: !1
    },
    tooltipPosition: {
      type: String,
      default: "bottom"
    },
    buttonProps: {
      type: Object,
      default: () => ({})
    },
    isFlash: {
      type: Boolean,
      default: !1
    },
    hasDefaultRecipient: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    flashBtnTooltip() {
      return this.isFlash ? this.hasDefaultRecipient ? "Молния на выпуск" : "Задайте получателя по умолчанию" : "Измените тип материала на молнию";
    }
  }
}, FHe = {
  name: "DraftActions",
  mixins: [cl],
  components: {
    MainActionButton: fn
  },
  props: {
    isWide: {
      type: Boolean,
      default: !1
    },
    embargoMode: {
      type: Boolean,
      default: !1
    },
    embargoValid: {
      type: Boolean,
      default: !1
    },
    isRevoked: {
      type: Boolean,
      default: !1
    },
    isRevocation: {
      type: Boolean,
      default: !1
    },
    isOriginalVisible: {
      type: Boolean,
      default: !1
    },
    isFromASOI: {
      type: Boolean,
      default: !1
    },
    selectedFragment: {
      type: [String, null],
      default: null
    }
  }
  // computed: {
  //   flashBtnTooltip() {
  //     if (!this.isFlash) {
  //       return 'Измените тип материала на молнию'
  //     }
  //     if (!this.hasDefaultRecipient) {
  //       return 'Задайте получателя по умолчанию'
  //     }
  //     return 'Молния на выпуск'
  //   }
  // }
};
var BHe = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", { attrs: { "data-test-selector": "news-item-footer" } }, [e.isMy ? [n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Опубликовать", expression: "'Опубликовать'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.5"], expression: "['2.5']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "solid/publish", disabled: e.embargoMode && !e.embargoValid, "data-test-selector": "news-item-button-publish" }, nativeOn: { click: function(r) {
    return e.$emit("action", "prePublish");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Опубликовать ")]), e.isRevocation ? e._e() : n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Отправить", expression: "'Отправить'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/to-edit", disabled: !e.embargoValid, "data-test-selector": "news-item-button-editors" }, nativeOn: { click: function(r) {
    return e.$emit("action", "sendToEdit");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Отправить ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Запланировать публикацию (эмбарго)", expression: "'Запланировать публикацию (эмбарго)'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/embargo", disabled: e.embargoMode, "data-test-selector": "news-item-button-embargo" }, nativeOn: { click: function(r) {
    return e.$emit("action", "embargo");
  } } }, "MainActionButton", e.buttonProps, !1)), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Удалить без возможности восстановления", expression: "'Удалить без возможности восстановления'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/trash", "data-test-selector": "news-item-button-delete" }, nativeOn: { click: function(r) {
    return e.$emit("action", "delete");
  } } }, "MainActionButton", e.buttonProps, !1))] : e._e(), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Расширить", expression: "'Расширить'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/bonds", "data-test-selector": "news-item-button-extend" }, nativeOn: { click: function(r) {
    return e.$emit("action", "extend");
  } } }, "MainActionButton", e.isMy ? e.buttonProps : { size: 18 }, !1), [e.isMy ? e._e() : [e._v(" Расширить ")]], 2), e.isMy ? n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: e.flashBtnTooltip, expression: "flashBtnTooltip", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.18"], expression: "['2.18']", arg: "all" }], staticClass: "pb-action-button", attrs: { iconName: "outline/exclamation", buttonStyle: { backgroundColor: "#d0021b" }, falselyDisabled: !e.isFlash || !e.hasDefaultRecipient, "data-test-selector": "news-item-button-flash" }, on: { click: function(r) {
    return e.$emit("action", "sendToDefaultRecipientToEdit");
  } } }, "MainActionButton", e.buttonProps, !1)) : e._e()], 2);
}, jHe = [], WHe = /* @__PURE__ */ B(
  FHe,
  BHe,
  jHe,
  !1,
  null,
  null
);
const HHe = WHe.exports, VHe = {
  name: "WaitEditActions",
  mixins: [cl]
};
var zHe = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", { attrs: { "data-test-selector": "news-item-footer" } }, [n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Взять в работу", expression: "'Взять в работу'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/edit", isTextHidden: !1, "data-test-selector": "news-item-button-add" }, nativeOn: { click: function(r) {
    return e.$emit("action", "pickToEdit");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Взять в работу ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Расширить", expression: "'Расширить'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/bonds", "data-test-selector": "news-item-button-extend" }, nativeOn: { click: function(r) {
    return e.$emit("action", "extend");
  } } }, "MainActionButton", e.buttonProps, !1))], 1);
}, UHe = [], GHe = /* @__PURE__ */ B(
  VHe,
  zHe,
  UHe,
  !1,
  null,
  null
);
const YHe = GHe.exports, ZHe = {
  name: "EditActions",
  mixins: [cl],
  props: {
    embargoMode: {
      type: Boolean,
      default: !1
    },
    embargoValid: {
      type: Boolean,
      default: !1
    },
    isOriginalVisible: {
      type: Boolean,
      default: !1
    }
  }
};
var XHe = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", { attrs: { "data-test-selector": "news-item-actions" } }, [n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Опубликовать", expression: "'Опубликовать'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.5"], expression: "['2.5']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/publish", "data-test-selector": "news-item-button-publish" }, nativeOn: { click: function(r) {
    return e.$emit("action", "prePublish");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Опубликовать ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Запланировать публикацию (эмбарго)", expression: "'Запланировать публикацию (эмбарго)'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/embargo", disabled: e.embargoMode, "data-test-selector": "news-item-button-embargo" }, nativeOn: { click: function(r) {
    return e.$emit("action", "embargo");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Запланировать публикацию ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Отправить", expression: "'Отправить'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/to-edit", disabled: !e.embargoValid, "data-test-selector": "news-item-button-editors" }, nativeOn: { click: function(r) {
    return e.$emit("action", "sendToEdit");
  } } }, "MainActionButton", e.buttonProps, !1)), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Отправить в отвал", expression: "'Отправить в отвал'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.13"], expression: "['2.13']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/trash", "data-test-selector": "news-item-button-delete" }, nativeOn: { click: function(r) {
    return e.$emit("action", "dispose");
  } } }, "MainActionButton", e.buttonProps, !1)), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Расширить", expression: "'Расширить'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/bonds", "data-test-selector": "news-item-button-extend" }, nativeOn: { click: function(r) {
    return e.$emit("action", "extend");
  } } }, "MainActionButton", e.buttonProps, !1)), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: e.flashBtnTooltip, expression: "flashBtnTooltip", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.18"], expression: "['2.18']", arg: "all" }], staticClass: "pb-action-button", attrs: { iconName: "outline/exclamation", buttonStyle: { backgroundColor: "#d0021b" }, falselyDisabled: !e.isFlash || !e.hasDefaultRecipient, "data-test-selector": "news-item-button-flash" }, on: { click: function(r) {
    return e.$emit("action", "sendToDefaultRecipientToEdit");
  } } }, "MainActionButton", e.buttonProps, !1))], 1);
}, KHe = [], JHe = /* @__PURE__ */ B(
  ZHe,
  XHe,
  KHe,
  !1,
  null,
  null
);
const qHe = JHe.exports, QHe = {
  name: "PublishActions",
  mixins: [Vr, cl],
  components: {
    MainActionButton: fn
  },
  props: {
    newsItemId: {
      type: [Number, String],
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    codes: {
      type: Array,
      default: () => []
    },
    validationErrors: {
      type: Array,
      default: () => []
    },
    embargoMode: {
      type: Boolean,
      default: !1
    },
    embargoValid: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      publishListShowed: !1
    };
  },
  watch: {
    "codes.length": function(t) {
      t === 0 && (this.publishListShowed = !1);
    }
  },
  computed: {
    itemsCount() {
      return this.codes.length ? `${this.codes.length} ${su(this.codes.length, [
        "направление",
        "направления",
        "направлений"
      ])}` : "";
    },
    enabled() {
      return this.codes.length > 0 && this.validationErrors.length === 0 ? this.embargoMode ? this.embargoValid && !this.publishEmbargoError : !0 : !1;
    },
    publishEmbargoError() {
      return !!(this.embargoMode && this.version.publish_at === null && !this.version.is_postponed);
    },
    publishTooltipText() {
      return this.codes.length ? `Опубликовать материал на ${this.itemsCount}` : "Опубликовать материал";
    },
    listTooltipText() {
      return this.codes.length ? `Выбрано ${this.itemsCount}` : "Показать список выбранных направлений публикации";
    }
  }
};
var eVe = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", [n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: e.publishTooltipText, expression: "publishTooltipText", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "solid/publish", disabled: !e.enabled, isTextHidden: !1, "data-test-selector": "news-item-button-publish" }, on: { click: function(r) {
    return e.$emit("action", "publish");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Опубликовать ")]), n("span", { directives: [{ name: "show", rawName: "v-show", value: e.codes.length, expression: "codes.length" }, { name: "on-clickaway", rawName: "v-on-clickaway", value: () => {
    e.publishListShowed = !1;
  }, expression: `
      () => {
        publishListShowed = false
      }
    ` }], staticClass: "news-item-footer-selected-codes", attrs: { "data-test-selector": "news-item-publish-selected-codes" } })], 1);
}, tVe = [], nVe = /* @__PURE__ */ B(
  QHe,
  eVe,
  tVe,
  !1,
  null,
  "8ffcf1be"
);
const rVe = nVe.exports;
function C8({ newsItemId: t }, e) {
  const n = {
    getIsPublicationCode: le(
      () => e.getters["news/codes/getIsPublicationCode"]
    ),
    getNewsItemCurrentVersion: e.getters["news/getNewsItemCurrentVersion"],
    newsStatuses: e.getters["references/newsStatuses"]
  }, r = {
    republishUneditedNewsItem: (...c) => e.dispatch("news/republishUneditedNewsItem", ...c),
    republish: (...c) => e.dispatch("news/republish", ...c)
  }, s = et(!1), i = le(
    () => n.getNewsItemCurrentVersion(t.value)
  ), o = le(
    () => {
      var c, u, d;
      return ((d = (u = n.newsStatuses) == null ? void 0 : u[(c = i.value) == null ? void 0 : c.status_id]) == null ? void 0 : d.name) === "PUBLISHED";
    }
  );
  return {
    republishManagerVisible: s,
    republishNewsItem: () => r.republish({ newsItemId: t.value }),
    toggleRepublishManager: () => {
      Gd(s);
    },
    republishAction: r.republishUneditedNewsItem,
    getIsPublicationCode: n.getIsPublicationCode,
    isReleased: o
  };
}
const sVe = {
  name: "PublishedActions",
  mixins: [cl],
  components: {
    NewsRepublishCtr: Uf
  },
  props: {
    isRepublishDisabled: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const e = Jt("store"), {
      republishManagerVisible: n,
      republishNewsItem: r,
      toggleRepublishManager: s,
      republishAction: i,
      getIsPublicationCode: o
    } = C8({ newsItemId: t.newsItemId }, e);
    return {
      republishManagerVisible: n,
      republishNewsItem: r,
      toggleRepublishManager: s,
      republishAction: i,
      getIsPublicationCode: o,
      defaultPopupPosition: "bottom",
      compact: !0,
      size: 18
    };
  }
};
var iVe = function() {
  var e = this, n = e._self._c;
  return e.isRevoked ? e._e() : n("VersionActionsWrap", { attrs: { "data-test-selector": "news-item-footer" } }, [e.isRevoked ? e._e() : n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Повтор", expression: "'Повтор'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/republish", disabled: e.isRepublishDisabled, isTextHidden: !1, "data-test-selector": "news-item-button-republish" }, nativeOn: { click: function(r) {
    return e.$emit("action", "republish");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Повтор ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Добавить коды", expression: "'Добавить коды'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }], staticClass: "pb-action-button", attrs: { size: e.size, active: "", iconName: "outline/plus", "data-test-selector": "entry-button-add-codes" }, on: { click: function(r) {
    return r.stopPropagation(), e.toggleRepublishManager.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "extension", fn: function() {
    return [e.republishManagerVisible ? n("NewsRepublishCtr", { class: ["republish-widget", e.defaultPopupPosition], attrs: { visible: e.republishManagerVisible, newsItemId: e.newsItemId, action: e.republishAction, position: e.defaultPopupPosition }, on: { hide: function(r) {
      e.republishManagerVisible = !1;
    } } }) : e._e()];
  }, proxy: !0 }], null, !1, 3567423489) }, "MainActionButton", e.buttonProps, !1), [e._v(" Добавить коды ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Расширить", expression: "'Расширить'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/bonds", "data-test-selector": "news-item-button-extend" }, nativeOn: { click: function(r) {
    return e.$emit("action", "extend");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Расширить ")]), e.isRevoked ? e._e() : n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Отправить", expression: "'Отправить'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "send", disabled: e.isRepublishDisabled, isTextHidden: !1, "data-test-selector": "news-item-button-share" }, nativeOn: { click: function(r) {
    return e.$emit("action", "share");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Отправить ")])], 1);
}, oVe = [], aVe = /* @__PURE__ */ B(
  sVe,
  iVe,
  oVe,
  !1,
  null,
  null
);
const lVe = aVe.exports, cVe = {
  name: "EmbargoActions",
  mixins: [cl],
  components: {
    NewsRepublishCtr: Uf,
    NewsItemEmbargoCtr: Fu,
    PsKitPopup: Ls,
    PsKitPopupDialog: R2
  },
  props: {
    republishAction: {
      type: Function,
      required: !0
    }
  },
  setup(t) {
    const e = Jt("store"), n = Xn({
      visible: !1
    }), r = Xn({
      visible: !1,
      popupNodes: []
    }), s = Xn({
      visible: !1
    }), i = Xn({
      visible: !1
    }), { newsItemId: o } = ts(t), { version: a } = Zi({ newsItemIdRef: o }, e);
    return {
      republishManager: n,
      embargoForm: r,
      confirmPublish: s,
      confirmEdit: i,
      version: a,
      registerPopup: async ({ id: u }) => {
        await Ar();
        const d = document.getElementById(u);
        d && r.popupNodes.push(d);
      },
      onEmbargoFormClickAway: (u) => {
        r.popupNodes.reduce((f, p) => (f = f || ((p == null ? void 0 : p.contains(u.target)) ?? !1), f), !1) || (r.visible = !1, r.popupNodes = []);
      }
    };
  }
};
var uVe = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", { attrs: { "data-test-selector": "news-item-footer" } }, [n("MainActionButton", e._b({ directives: [{ name: "show", rawName: "v-show", value: e.userCanEditEmbargo, expression: "userCanEditEmbargo /** permission=2.9 */" }, { name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Опубликовать немедленно", expression: "'Опубликовать немедленно'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "solid/publish", "data-test-selector": "news-item-button-publish" }, on: { click: function(r) {
    e.confirmPublish.visible = !e.confirmPublish.visible;
  } }, scopedSlots: e._u([{ key: "extension", fn: function() {
    return [e.confirmPublish.visible ? n("PsKitPopupDialog", { attrs: { visible: e.confirmPublish.visible, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
      {
        type: "primary",
        text: "Да",
        onclick: () => e.$emit("action", "reschedule")
      },
      { text: "Нет", onclick: () => e.confirmPublish.visible = !1 }
    ] }, on: { hide: function(r) {
      e.confirmPublish.visible = !1;
    } }, scopedSlots: e._u([{ key: "title", fn: function() {
      return [e._v(" Новость будет опубликована немедленно. Продолжить? ")];
    }, proxy: !0 }], null, !1, 3293570803) }) : e._e()];
  }, proxy: !0 }]) }, "MainActionButton", e.buttonProps, !1), [e._v(" Опубликовать немедленно ")]), n("MainActionButton", e._b({ directives: [{ name: "show", rawName: "v-show", value: e.userCanEditEmbargo, expression: "userCanEditEmbargo" }, { name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Взять в работу", expression: "'Взять в работу'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/edit", "data-test-selector": "news-item-button-add" }, on: { click: function(r) {
    e.confirmEdit.visible = !e.confirmEdit.visible;
  } }, scopedSlots: e._u([{ key: "extension", fn: function() {
    return [e.confirmEdit.visible ? n("PsKitPopupDialog", { attrs: { visible: e.confirmEdit.visible, placement: "top", classPopup: ["popup-dispose"], floatingOptions: { offset: 5 }, buttons: [
      {
        type: "primary",
        text: "Да",
        onclick: () => e.$emit("action", "pickToEdit")
      },
      { text: "Нет", onclick: () => e.confirmEdit.visible = !1 }
    ] }, on: { hide: function(r) {
      e.confirmEdit.visible = !1;
    } }, scopedSlots: e._u([{ key: "title", fn: function() {
      return [e._v(" Новость будет изъята из очереди отложенных и НЕ будет опубликована. Продолжить? ")];
    }, proxy: !0 }], null, !1, 2361793665) }) : e._e()];
  }, proxy: !0 }]) }, "MainActionButton", e.buttonProps, !1)), n("MainActionButton", e._b({ directives: [{ name: "show", rawName: "v-show", value: e.userCanEditEmbargo, expression: "userCanEditEmbargo" }, { name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Изменить время публикации", expression: "'Изменить время публикации'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/embargo", "data-test-selector": "news-item-button-embargo" }, on: { click: function(r) {
    e.embargoForm.visible = !e.embargoForm.visible;
  } }, scopedSlots: e._u([{ key: "extension", fn: function() {
    return [e.embargoForm.visible ? n("PsKitPopup", { attrs: { visible: e.embargoForm.visible, floatingOptions: { offset: 5 }, canPopupResize: !0 }, on: { hide: e.onEmbargoFormClickAway, visible: e.registerPopup } }, [n("NewsItemEmbargoCtr", { attrs: { newsItemId: e.newsItemId, version: e.version, autoOpen: !0, inPopup: !0, isEditable: !0, isRemovable: !0 }, on: { datePickerOpened: e.registerPopup, embargoSet: function(r) {
      e.embargoForm.visible = !1;
    }, removeEmbargo: function(r) {
      e.embargoForm.visible = !1;
    }, postponed: function(r) {
      e.embargoForm.visible = !1;
    }, formClosed: function(r) {
      e.embargoForm.visible = !1;
    } } })], 1) : e._e()];
  }, proxy: !0 }]) }, "MainActionButton", e.buttonProps, !1)), n("div", { directives: [{ name: "show", rawName: "v-show", value: e.userCanChangeCodes, expression: "userCanChangeCodes" }], staticClass: "republish-wrapper" }, [n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Изменить направления публикации", expression: "'Изменить направления публикации'", arg: e.tooltipPosition }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/pub-codes", isTextHidden: e.userCanEditEmbargo, "data-test-selector": "entry-button-add-codes" }, on: { click: function(r) {
    e.republishManager.visible = !e.republishManager.visible;
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Изменить направления публикации ")]), e.republishManager.visible ? n("NewsRepublishCtr", { staticClass: "republish-widget", attrs: { position: "bottom", visible: e.republishManager.visible, newsItemId: e.newsItemId, action: e.republishAction, onlyPublicactionCodes: !0 }, on: { hide: function(r) {
    e.republishManager.visible = !1;
  } } }) : e._e()], 1), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Расширить", expression: "'Расширить'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/bonds", "data-test-selector": "news-item-button-extend" }, nativeOn: { click: function(r) {
    return e.$emit("action", "extend");
  } } }, "MainActionButton", e.buttonProps, !1)), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Повтор", expression: "'Повтор'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/republish", isTextHidden: !0, "data-test-selector": "news-item-button-republish" }, nativeOn: { click: function(r) {
    return e.$emit("action", "republish");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Повтор ")])], 1);
}, dVe = [], fVe = /* @__PURE__ */ B(
  cVe,
  uVe,
  dVe,
  !1,
  null,
  null
);
const pVe = fVe.exports, hVe = {
  name: "DisposedActions",
  mixins: [cl]
};
var mVe = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", { directives: [{ name: "permissions", rawName: "v-permissions:any", value: ["2.14", "2.16"], expression: "['2.14', '2.16']", arg: "any" }] }, [n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Вернуть в работу", expression: "'Вернуть в работу'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.14"], expression: "['2.14']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "button-icon-forward", isTextHidden: !1, "data-test-selector": "news-item-button-forward" }, nativeOn: { click: function(r) {
    return e.$emit("action", "pickToEdit");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Вернуть в работу ")]), n("MainActionButton", e._b({ directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Расширить", expression: "'Расширить'", arg: e.tooltipPosition }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { active: "", iconName: "outline/bonds", "data-test-selector": "news-item-button-extend" }, nativeOn: { click: function(r) {
    return e.$emit("action", "extend");
  } } }, "MainActionButton", e.buttonProps, !1))], 1);
}, vVe = [], gVe = /* @__PURE__ */ B(
  hVe,
  mVe,
  vVe,
  !1,
  null,
  null
);
const yVe = gVe.exports, bVe = {
  name: "HistoryActions",
  mixins: [cl]
};
var _Ve = function() {
  var e = this, n = e._self._c;
  return n("VersionActionsWrap", [n("MainActionButton", e._b({ staticClass: "pb-action-button", attrs: { active: "", iconName: "", "data-test-selector": "news-item-button-restore", isTextHidden: !1 }, nativeOn: { click: function(r) {
    return e.$emit("action", "restoreVersionById");
  } } }, "MainActionButton", e.buttonProps, !1), [e._v(" Восстановить эту версию ")])], 1);
}, wVe = [], SVe = /* @__PURE__ */ B(
  bVe,
  _Ve,
  wVe,
  !1,
  null,
  null
);
const IVe = SVe.exports, EVe = "_root_1mawf_1", xVe = "_title_1mawf_6", CVe = "_footer_1mawf_11", TVe = "_btn_1mawf_17", PVe = "_btn_active_1mawf_27", kVe = {
  root: EVe,
  title: xVe,
  footer: CVe,
  btn: TVe,
  btn_active: PVe
}, NVe = {
  name: "DialogConfirm",
  components: {
    PbModal: Au,
    PbButton: nt
  },
  props: {
    state: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: Number,
      default: 280
    },
    acceptButtonLabel: {
      type: String,
      default: "Да"
    },
    declineButtonLabel: {
      type: String,
      default: "Отмена"
    },
    initActiveButton: {
      type: String,
      default: void 0,
      validator: (t) => ["agree", "close"].includes(t)
    }
  },
  data() {
    return {
      activeButton: this.initActiveButton
    };
  },
  watch: {
    state(t) {
      if (this.activeButton)
        this.activeButton = this.initActiveButton;
      else
        return;
      this.setModal(t), t ? this.$enableShortcuts() : this.$disableShortcuts();
    }
  },
  created() {
    this.activeButton && (this.$registerShortcut("Enter", this.handleEnter, {
      enabled: !1
    }), ["ArrowLeft", "ArrowRight"].forEach((t) => {
      this.$registerShortcut(t, this.switchActiveButton, {
        enabled: !1
      });
    }));
  },
  methods: {
    ...ge(["setModal"]),
    handleEnter(t) {
      t.preventDefault(), this.activeButton === "agree" ? this.agree() : this.close();
    },
    switchActiveButton(t) {
      t.preventDefault(), this.activeButton = this.activeButton === "agree" ? "close" : "agree";
    },
    agree() {
      this.$emit("agree"), this.close();
    },
    close() {
      this.$emit("update:state", !1);
    }
  }
};
var $Ve = function() {
  var e = this, n = e._self._c;
  return n("PbModal", { attrs: { state: e.state, maxWidth: e.maxWidth, hasHeader: !1, "data-test-selector": "dialog-confirm" }, on: { close: e.close } }, [n("div", { class: e.$style.root }, [n("div", { class: e.$style.title, attrs: { "data-test-selector": "dialog-confirm-title" } }, [e._t("question")], 2), n("div", { class: e.$style.footer }, [n("PbButton", { class: [e.$style.btn, e.$style.btn_primary], attrs: { active: e.activeButton === "agree", activeClass: e.$style.btn_active, "data-test-selector": "dialog-confirm-accept" }, on: { click: e.agree } }, [e._v(" " + e._s(e.acceptButtonLabel) + " ")]), n("PbButton", { class: e.$style.btn, attrs: { active: e.activeButton === "close", activeClass: e.$style.btn_active, "data-test-selector": "dialog-confirm-decline" }, on: { click: e.close } }, [e._v(" " + e._s(e.declineButtonLabel) + " ")])], 1)])]);
}, DVe = [];
const X3 = {
  $style: kVe
};
function AVe(t) {
  for (var e in X3)
    this[e] = X3[e];
}
var OVe = /* @__PURE__ */ B(
  NVe,
  $Ve,
  DVe,
  !1,
  AVe,
  null
);
const Gu = OVe.exports;
function T8(t, e) {
  const n = {
    addPanelFromRoute: (...a) => t.dispatch("panels/addPanelFromRoute", ...a)
  }, r = () => {
    e("close", !1);
  };
  return {
    close: r,
    handleEsc: (a) => a.composed ? (a.stopPropagation(), a.preventDefault(), r(), !1) : !0,
    removeLinks: () => {
      e("removeLinks"), r();
    },
    handleNewsClick: (a) => {
      const l = {
        params: { id: a },
        meta: { type: "panel", panelType: "newsItem" }
      };
      n.addPanelFromRoute(l);
    }
  };
}
const MVe = {
  name: "PbDialogParentConflict",
  components: {
    PbButton: nt
  },
  props: {
    parentId: {
      type: [String, Number, null],
      default: null
    },
    parentHeader: {
      type: String,
      required: !0
    }
  },
  setup(t, e) {
    const n = Jt("store"), r = e.emit, {
      close: s,
      handleEsc: i,
      removeLinks: o,
      handleNewsClick: a
    } = T8(n, r);
    return {
      close: s,
      handleEsc: i,
      removeLinks: o,
      handleNewsClick: a
    };
  },
  created() {
    this.$registerShortcut("Escape", this.handleEsc, {
      enabled: !0,
      capture: !0
    });
  }
};
var RVe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: ["pb-dialog-links-conflict", "draggable-ignore"], attrs: { "data-test-selector": "dialog-parent-conflict" } }, [n("div", { staticClass: "header", attrs: { "data-test-selector": "dialog-parent-conflict-title" } }, [e._v(" Родительская новость не опубликована ")]), n("div", { staticClass: "body", attrs: { "data-test-selector": "dialog-parent-conflict-text" } }, [e._v(" Новость является расширением к "), n("b", { on: { click: function(r) {
    return e.handleNewsClick(e.parentId);
  } } }, [e._v(e._s(e.parentHeader))]), e._v(" и не может быть опубликована раньше."), n("br"), n("br"), e._v("Удалите связь между новостями или сначала опубликуйте "), n("b", { on: { click: function(r) {
    return e.handleNewsClick(e.parentId);
  } } }, [e._v(e._s(e.parentHeader))])]), n("div", { staticClass: "footer", attrs: { "data-test-selector": "dialog-parent-conflict-actions" } }, [n("PbButton", { class: ["button", "button_primary"], attrs: { "data-test-selector": "dialog-parent-conflict-accept" }, on: { click: e.removeLinks } }, [e._v(" Удалить связь и опубликовать ")]), n("PbButton", { staticClass: "button", attrs: { "data-test-selector": "dialog-parent-conflict-decline" }, on: { click: e.close } }, [e._v(" Отмена ")])], 1)]);
}, LVe = [], FVe = /* @__PURE__ */ B(
  MVe,
  RVe,
  LVe,
  !1,
  null,
  "fcc80b76"
);
const BVe = FVe.exports, jVe = {
  name: "PbDialogChildrenConflict",
  components: {
    PbButton: nt
  },
  props: {
    conflictedChildren: {
      type: Array,
      default: () => []
    }
  },
  setup(t, e) {
    const n = Jt("store"), r = e.emit, {
      close: s,
      handleEsc: i,
      removeLinks: o,
      handleNewsClick: a
    } = T8(n, r);
    return {
      close: s,
      handleEsc: i,
      removeLinks: o,
      handleNewsClick: a
    };
  },
  created() {
    this.$registerShortcut("Escape", this.handleEsc, {
      enabled: !0,
      capture: !0
    });
  }
};
var WVe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: ["pb-dialog-links-conflict", "draggable-ignore"], attrs: { "data-test-selector": "dialog-children-conflict" } }, [n("div", { staticClass: "header", attrs: { "data-test-selector": "dialog-children-conflict-title" } }, [e._v(" Есть дочерние новости, которые будут опубликованы раньше ")]), n("div", { staticClass: "body", attrs: { "data-test-selector": "dialog-children-conflict-text" } }, [e._v(" У новости есть расширения: "), n("ul", e._l(e.conflictedChildren, function(r) {
    return n("li", { key: r.id }, [n("a", { attrs: { href: "javascript:;" }, on: { click: function(s) {
      return e.handleNewsClick(r.id);
    } } }, [e._v(e._s(r.headline))])]);
  }), 0), e._v(" Новость не может быть опубликована позже них. "), n("br"), n("br"), e._v("Удалите связь между новостями или сначала измените время публикации дочерних новостей. ")]), n("div", { staticClass: "footer", attrs: { "data-test-selector": "dialog-children-conflict-actions" } }, [n("PbButton", { class: ["button", "button_primary"], attrs: { "data-test-selector": "dialog-children-conflict-accept" }, on: { click: e.removeLinks } }, [e._v(" Удалить связи и опубликовать ")]), n("PbButton", { staticClass: "button", attrs: { "data-test-selector": "dialog-children-conflict-decline" }, on: { click: e.close } }, [e._v(" Отмена ")])], 1)]);
}, HVe = [], VVe = /* @__PURE__ */ B(
  jVe,
  WVe,
  HVe,
  !1,
  null,
  "d9332f79"
);
const zVe = VVe.exports, UVe = "_confirmText_ansj7_1", GVe = {
  confirmText: UVe
}, YVe = {
  name: "VersionActionsCtr",
  components: {
    DraftActions: HHe,
    WaitEditActions: YHe,
    EditActions: qHe,
    PublishedActions: lVe,
    EmbargoActions: pVe,
    DisposedActions: yVe,
    PublishActions: rVe,
    HistoryActions: IVe,
    DialogConfirm: Gu,
    PbDialogParentConflict: BVe,
    PbDialogChildrenConflict: zVe
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    newsItemId: {
      type: [Number, String],
      default: null
    },
    newsItemParentId: {
      type: [Number, String, null],
      default: null
    },
    selectedFragment: {
      type: [String, null],
      default: null
    },
    buttonProps: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const e = Jt("store"), n = {
      getIsUserHasPublishingCodes: e.getters["news/codes/getIsUserHasPublishingCodes"],
      allCodeItems: e.getters["news/codes/allCodeItemsActual"]
    }, { newsItemId: r } = ts(t), {
      draft: s,
      validationErrors: i,
      draftVersion: o,
      setEmbargoForm: a,
      setEmbargoValid: l,
      validateDraft: c
    } = Bu({ newsItemIdRef: r }, e), { version: u, isMy: d, isRepublishDisabled: f, isRemovable: p } = Zi(
      { newsItemIdRef: r },
      e,
      o
    ), { relatedPeople: h } = h6({ newsItemIdRef: r }, e), {
      isScheduled: m,
      isEmbargoFormVisible: v,
      isEmbargoValid: y,
      isUserHasEmbargoPermissions: _
    } = dc(
      {
        draftRv: s,
        versionRv: u
      },
      e
    ), { isPublishedByMe: w, publishMode: S } = uc(
      { newsItemIdRef: r },
      e
    ), { allCodes: E } = M2({ versionRv: o }, e), { handleNotSavedEmbargo: x } = _8({ draftRv: s }, e), { deletePubCode: T, pickedCodes: C, enablePublishMode: k } = m6({ draftRv: s, allCodesRv: E }, e), { isRevoked: b, isRevocation: P } = fc({ newsItemIdRef: r }, e), { showShareModal: N } = Kv(), D = et([]), H = et(!1), Y = et(null);
    return {
      ...n,
      draft: s,
      version: u,
      isMy: d,
      validationErrors: i,
      validateDraft: c,
      rescheduleError: Y,
      relatedPeople: h,
      setEmbargoForm: a,
      setEmbargoValid: l,
      isScheduled: m,
      isEmbargoFormVisible: v,
      isEmbargoValid: y,
      handleNotSavedEmbargo: x,
      isUserHasEmbargoPermissions: _,
      publishMode: S,
      isRepublishDisabled: f,
      isPublishedByMe: w,
      pickedCodes: C,
      enablePublishMode: k,
      deletePubCode: T,
      isRevoked: b,
      isRevocation: P,
      isRemovable: p,
      embargoPublicationErrorCodeIds: D,
      isConfirmDialogOpen: H,
      showShareModal: N
    };
  },
  computed: {
    ...st({
      chatMessagesMap: (t) => t.chat.messagesMap
    }),
    ...pe("references", ["newsStatuses", "newsTypesByName"]),
    ...pe("panels", ["getPanelIndex", "getIsHistorySupplyVisible"]),
    ...pe("news", [
      "getDisposalDialogState",
      "getIsNewsItemBindedToUser",
      "getIsNewsItemWorkable",
      "getIsNewsItemFromASOI"
    ]),
    ...pe(["getNewsItemPanel"]),
    ...pe("userProfile", [
      "getDefaultRecipientId",
      "getDefaultRecipientUserId",
      "getDefaultRecipientGroupId"
    ]),
    panelIndex() {
      const t = this.getNewsItemPanel(this.newsItemId);
      return this.getPanelIndex(t == null ? void 0 : t.id);
    },
    status() {
      var e;
      const t = ((e = this.version) == null ? void 0 : e.status_id) ?? 0;
      return this.newsStatuses[t];
    },
    isFlash() {
      var t;
      return ((t = this.version) == null ? void 0 : t.type_id) === this.newsTypesByName.FLASH.id;
    },
    isVisible() {
      return !(!this.newsItemId || this.isRevoked || this.isVisibleHistorySupply);
    },
    isVisibleHistorySupply() {
      return this.getIsHistorySupplyVisible(this.panel.id);
    },
    isBinded() {
      return this.getIsNewsItemWorkable(this.newsItemId);
    },
    isFromASOI() {
      return this.getIsNewsItemFromASOI(this.newsItemId);
    },
    hasDefaultRecipient() {
      return this.getDefaultRecipientId !== null && this.getDefaultRecipientId !== void 0;
    },
    toggleSupplyTitle() {
      return "Чат и коды";
    },
    userCanEditEmbargo() {
      return this.isPublishedByMe || this.isUserHasEmbargoPermissions;
    },
    actionsComponent() {
      var t;
      if (this.isVisibleHistorySupply) return "HistoryActions";
      switch ((t = this.status) == null ? void 0 : t.name) {
        case "DRAFT":
          return "DraftActions";
        case "WAITS_FOR_EDIT":
          return this.isBinded ? "WaitEditActions" : "DraftActions";
        case "ON_EDIT":
          return this.isMy ? "EditActions" : "DraftActions";
        case "DISPOSED":
          return "DisposedActions";
        case "WAITS_FOR_PUBLICATION":
        case "PUBLISHING":
          return this.isScheduled && (this.userCanEditEmbargo || this.getIsUserHasPublishingCodes) ? "EmbargoActions" : "DraftActions";
        case "PUBLISHED":
          return "PublishedActions";
        default:
          return "DraftActions";
      }
    },
    embargoPublicationErrorCodes() {
      return this.embargoPublicationErrorCodeIds.map(
        (e) => this.allCodeItems[e].name
      ).map((e) => `<b>${e}</b>`).join(", ");
    },
    confirmText() {
      return `В вашей новости ${this.embargoPublicationErrorCodeIds.length > 1 ? "повторяются ленты" : "повторяется лента"} <span>${this.embargoPublicationErrorCodes}</span>, на ${this.embargoPublicationErrorCodeIds.length > 1 ? "которые" : "которую"} будет опубликована отложенная публикация из АСОИ.<br><br>
      Все равно опубликовать?`;
    },
    parentConflict() {
      var e;
      let t = null;
      return (e = this.validationErrors) != null && e.length && (t = this.validationErrors.find(
        (n) => n.code === "NEWS_PARENT_CONFLICT"
      )), t ? {
        parentId: this.newsItemParentId,
        parentHeader: t.meta.parent_headline
      } : this.rescheduleError ? {
        parentId: this.newsItemParentId,
        parentHeader: this.rescheduleError.meta.parent_headline
      } : null;
    },
    conflictedChildren() {
      const t = this.validationErrors.find(
        (e) => e.code === "NEWS_CHILDREN_CONFLICT"
      );
      return t ? t.meta.children : [];
    }
  },
  methods: {
    ...ge(["addMessage", "setModal"]),
    ...ge("news", {
      pickToEdit: "pickNewsItemToEdit",
      setDisposalDialog: "setDisposalDialog",
      publish: "publish",
      publishRevocation: "publishRevocation",
      republish: "republish",
      async reschedule(t, e) {
        e.supressError = !0;
        const n = await t("rescheduleNewsItem", e);
        if (n.status === 400) {
          const r = n.errors.find(
            (s) => s.code === "NEWS_PARENT_CONFLICT"
          );
          r && (this.rescheduleError = r);
        }
        n.errors || (this.rescheduleError = null);
      },
      createFlashFromFragment: "createFlashFromFragment",
      sendNewsItemToEdit: "sendNewsItemToEdit",
      extendNewsItem: "extendNewsItem"
    }),
    ...ge("news/links", ["removeNewsItemLink"]),
    async republishAction(...t) {
      return this.$store.dispatch("news/routeNewsPublicationCodes", ...t);
    },
    async onPrePublish() {
      await this.validateDraft(), this.validationErrors.length === 0 && (this.isRevocation ? this.publishNewsRevocation() : this.enablePublishMode({ newsItemId: this.newsItemId }));
    },
    async publishNewsRevocation() {
      const t = await this.publishRevocation({
        newsItemId: this.newsItemId
      });
      let e = "Новость аннулирована";
      this.version && (this.version.publish_at !== null || this.version.is_postponed) && (e = "Аннулирование запланировано"), this.afterPublication(t, e);
    },
    async publishNewsItem(t, e = !1) {
      if (!t.length) return;
      const n = {
        newsItemId: this.newsItemId,
        pubCodes: t,
        allowEmbargoCodes: e
      }, r = await this.publish(n);
      let s = "Новость опубликована";
      this.version && (this.version.publish_at !== null || this.version.is_postponed) && (s = "Опубликование запланировано"), this.afterPublication(r, s);
    },
    async afterPublication(t, e) {
      if (this.embargoPublicationErrorCodeIds = [], t.errors) {
        if (t.errors.map((s) => s.source && s.source.pointer).find((s) => s.includes("publish_at"))) {
          this.setEmbargoValid({ draftId: this.draft.id, value: !1 });
          return;
        }
        const r = t.errors.find(
          (s) => s.code === "EMBARGO_PUBLICATION_ERROR"
        );
        if (r) {
          this.embargoPublicationErrorCodeIds = r.meta.code_ids, this.isConfirmDialogOpen = !0;
          return;
        }
      }
      t.errors || this.addMessage({ text: e, type: "success" }), (!t.status || t.status < 300) && t.errors && t.errors.forEach((n) => {
        this.addMessage({ text: e, type: "success" }), this.addMessage({ text: n.detail || n.title, type: "info" });
      });
    },
    clearParentError() {
      this.validationErrors = this.validationErrors.filter(
        (t) => t.code !== "NEWS_PARENT_CONFLICT"
      ), this.rescheduleError = null;
    },
    async removeParentLink() {
      await this.removeNewsItemLink({
        newsItemId: this.newsItemParentId,
        childNewsItemId: this.newsItemId,
        linkTypeId: 4
      }), this.clearParentError(), this.draft ? this.onPrePublish() : this.reschedule({
        paramsList: [
          {
            id: this.newsItemId,
            publish_at: null,
            is_postponed: !1
          }
        ]
      });
    },
    clearChildrenError() {
      this.validationErrors = this.validationErrors.filter(
        (t) => t.code !== "NEWS_CHILDREN_CONFLICT"
      );
    },
    async removeChildrenLinks() {
      await Promise.all(
        this.conflictedChildren.map(
          (t) => this.removeNewsItemLink({
            newsItemId: this.newsItemId,
            childNewsItemId: t.id,
            linkTypeId: 4
          })
        )
      ), this.clearChildrenError(), this.onPrePublish();
    },
    // eslint-disable-next-line complexity
    async onAction(t) {
      if ([
        "sendToEdit",
        "prePublish",
        "republish",
        "sendToDefaultRecipientToEdit"
      ].includes(t))
        try {
          await this.handleNotSavedEmbargo();
        } catch {
          return;
        }
      switch (t) {
        case "share":
          this.showShareModal({
            itemId: this.newsItemId,
            itemType: "newsItem",
            actionType: "sendToEdit",
            params: {
              hasKeepOriginal: !1
            }
          });
          break;
        case "sendToEdit":
          this.showShareModal({
            itemId: this.newsItemId,
            itemType: "newsItem",
            actionType: "sendToEdit",
            params: { canSetDefault: !0 }
          }), this.setModal(!0);
          break;
        case "embargo":
          this.setEmbargoForm({
            draftId: this.draft.id,
            value: !this.isEmbargoFormVisible
          });
          break;
        case "prePublish":
          this.onPrePublish();
          break;
        case "publish":
          this.isRevocation ? this.publishNewsRevocation(this.pickedCodes) : this.publishNewsItem(this.pickedCodes);
          break;
        case "republish":
          this.republish({ newsItemId: this.newsItemId });
          break;
        case "reschedule":
          this.reschedule({
            paramsList: [
              {
                id: this.newsItemId,
                publish_at: null,
                is_postponed: !1
              }
            ]
          });
          break;
        case "dispose":
          this.setDisposalDialog({ id: this.newsItemId, value: !0 });
          break;
        case "pickToEdit":
          this.pickToEdit({ newsItemId: this.newsItemId });
          break;
        case "sendFragmentAsFlash":
          this.createFlashFromFragment({
            type_id: 1,
            slugline: "МОЛНИЯ",
            body: this.selectedFragment ?? this.version.body,
            panelIndex: this.panelIndex
          });
          break;
        case "sendToDefaultRecipientToEdit":
          this.sendNewsItemToEdit({
            newsItemId: this.newsItemId,
            recipients: [
              {
                type: this.getDefaultRecipientGroupId ? "group" : "user",
                id: this.getDefaultRecipientGroupId || this.getDefaultRecipientUserId
              }
            ]
          });
          break;
        case "extend":
          this.extendNewsItem({
            newsItemId: this.newsItemId,
            panelIndex: this.panelIndex
          });
          break;
        case "routePublicationCodes":
          break;
        case "delete":
          this.$emit("showDeleteDialog");
          break;
      }
    }
  }
};
var ZVe = function() {
  var e = this, n = e._self._c;
  return e.isVisible ? n("div", [e.newsItemId !== null && e.publishMode ? n("PublishActions", { attrs: { newsItemId: e.newsItemId, version: e.version, codes: e.pickedCodes, validationErrors: e.validationErrors, embargoMode: e.isEmbargoFormVisible, embargoValid: e.isEmbargoValid, status: e.status, buttonProps: e.buttonProps }, on: { codeRemoved: e.deletePubCode, action: e.onAction } }) : e.newsItemId !== null ? n(e.actionsComponent, { tag: "component", attrs: { newsItemId: e.newsItemId, isMy: e.isMy, isFlash: e.isFlash, isFromASOI: e.isFromASOI, embargoMode: e.isEmbargoFormVisible, embargoValid: e.isEmbargoValid, status: e.status, isRevoked: e.isRevoked, isRevocation: e.isRevocation, isOriginalPopupVisible: !1, isRepublishDisabled: e.isRepublishDisabled, selectedFragment: e.selectedFragment, userCanChangeCodes: e.getIsUserHasPublishingCodes, userCanEditEmbargo: e.userCanEditEmbargo, republishAction: e.republishAction, buttonProps: e.buttonProps, isRemovable: e.isRemovable, hasDefaultRecipient: e.hasDefaultRecipient }, on: { action: e.onAction } }) : e._e(), n("DialogConfirm", { attrs: { state: e.isConfirmDialogOpen, maxWidth: 400, acceptButtonLabel: "Опубликовать" }, on: { "update:state": function(r) {
    e.isConfirmDialogOpen = r;
  }, agree: function(r) {
    return e.publishNewsItem(e.pickedCodes, !0);
  } }, scopedSlots: e._u([{ key: "question", fn: function() {
    return [n("div", { class: e.$style.confirmText, domProps: { innerHTML: e._s(e.confirmText) } })];
  }, proxy: !0 }], null, !1, 2541345970) }), e.parentConflict ? n("PbDialogParentConflict", { attrs: { parentId: e.parentConflict.parentId, parentHeader: e.parentConflict.parentHeader }, on: { removeLinks: e.removeParentLink, close: e.clearParentError } }) : e._e(), e.conflictedChildren.length ? n("PbDialogChildrenConflict", { attrs: { conflictedChildren: e.conflictedChildren }, on: { close: e.clearChildrenError, removeLinks: e.removeChildrenLinks } }) : e._e()], 1) : e._e();
}, XVe = [];
const K3 = {
  $style: GVe
};
function KVe(t) {
  for (var e in K3)
    this[e] = K3[e];
}
var JVe = /* @__PURE__ */ B(
  YVe,
  ZVe,
  XVe,
  !1,
  KVe,
  null
);
const qVe = JVe.exports, QVe = {
  components: { PbButton: nt },
  props: {
    sizeTools: {
      type: Object,
      required: !0
    },
    btnStyle: {
      type: Object,
      default: () => ({})
    },
    visibleButtons: {
      type: Array,
      default: () => ["fullscreen", "minmax", "close"]
    }
  },
  setup(t) {
    const e = {
      // state: [iconName, tooltip]
      minimize: ["outline/minimize", "Выйти из полноэкранного режима"],
      maximize: ["outline/maximize", "Полноэкранный режим"],
      compress: ["outline/compress", "Сжать"],
      expand: ["outline/expand", "Расширить"]
    }, n = {
      fullscreen: {
        stateSwitch: "isFullscreen",
        states: ["minimize", "maximize"],
        // [isFullscreen==0, isFullscreen==1]
        iconType: "svg",
        iconSize: "12",
        disabled: le(() => t.sizeTools.isSupply),
        dataTestSelector: "panel-button-fullscreen",
        onClick: () => t.sizeTools.toggleFullscreen()
      },
      minmax: {
        stateSwitch: "isMaximized",
        states: ["compress", "expand"],
        iconType: "svg",
        iconSize: "15",
        disabled: le(() => t.sizeTools.isFullscreen),
        dataTestSelector: "panel-button-maximize",
        onClick: () => t.sizeTools.toggleMaximized()
      },
      close: {
        iconName: "close",
        iconType: "font",
        iconSize: "16",
        tooltip: "Закрыть панель",
        dataTestSelector: "panel-button-close",
        onClick: () => t.sizeTools.closePanel()
      }
    }, r = t.visibleButtons.map((s) => n[s]);
    return r.forEach((s) => {
      if (!s.stateSwitch) return;
      const [i, o] = s.states;
      s.iconName = le(
        () => t.sizeTools[s.stateSwitch] ? e[i][0] : e[o][0]
      );
    }), { buttons: r.map(Xn) };
  }
};
var eze = function() {
  var e = this, n = e._self._c;
  return n("div", e._l(e.buttons, function(r) {
    return n("PbButton", { key: r.dataTestSelector, staticClass: "panel-button draggable-ignore", style: e.btnStyle, attrs: { round: "", disabled: r.disabled, "data-test-selector": r.dataTestSelector }, on: { click: function(s) {
      return s.preventDefault(), s.stopPropagation(), r.onClick.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: r.iconType, name: r.iconName, size: r.iconSize } })], 1);
  }), 1);
}, tze = [], nze = /* @__PURE__ */ B(
  QVe,
  eze,
  tze,
  !1,
  null,
  null
);
const AI = nze.exports, rze = {
  components: {
    // PbCheckboxLabeled
  },
  props: {
    iconSize: {
      type: Number,
      default: 17
    },
    showCheckbox: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    toggleLeftSupply() {
      this.$emit("toggleLeftSupply", gt.newsItemVersionsSupply);
    }
  }
  // setup(props, ctx) {
  //   const store = inject('store')
  //   const bindings = {
  //     showVersionDiff: computed(
  //       () => store.state.userProfile.newsEditor.showVersionDiff
  //     )
  //   }
  //   const actions = {
  //     setProfileEditorSettings: (...args) =>
  //       store.dispatch('userProfile/setProfileEditorSettings', ...args)
  //   }
  //   const showVersionDiff = computed({
  //     get() {
  //       return bindings.showVersionDiff
  //     },
  //     set(bool) {
  //       actions.setProfileEditorSettings({
  //         editorSettings: { showVersionDiff: bool }
  //       })
  //     }
  //   })
  //   return { showVersionDiff }
  // },
};
var sze = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "root" }, [n("button", { staticClass: "btn", on: { click: function(r) {
    return r.stopPropagation(), r.preventDefault(), e.toggleLeftSupply.apply(null, arguments);
  } } }, [n("icon", { attrs: { type: "svg", name: "outline/history", size: e.iconSize } }), n("span", { staticClass: "btn-text" }, [e._v("История работы")])], 1)]);
}, ize = [], oze = /* @__PURE__ */ B(
  rze,
  sze,
  ize,
  !1,
  null,
  "cec220f6"
);
const aze = oze.exports, lze = {
  functional: !0,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    show: {
      type: Boolean,
      default: !1
    }
  },
  render(t, e) {
    var n;
    return e.props.show ? t(e.props.tag, e.data, e.children) : (n = e.slots().default) == null ? void 0 : n[0];
  }
}, cze = "_root_uu2te_1", uze = "_newsDraftWrapper_uu2te_22", dze = "_newsLangIndicator_uu2te_49", fze = "_disabled_uu2te_59", pze = "_dialogDeleteWrapper_uu2te_63", hze = "_dialogDeleteWrapper_alignLeft_uu2te_71", mze = "_dialogDeleteWrapper_alignCenter_uu2te_76", vze = "_closeButton_uu2te_80", gze = {
  root: cze,
  newsDraftWrapper: uze,
  "news-item-body": "_news-item-body_uu2te_29",
  "publish-mode": "_publish-mode_uu2te_43",
  newsLangIndicator: dze,
  disabled: fze,
  dialogDeleteWrapper: pze,
  dialogDeleteWrapper_alignLeft: hze,
  dialogDeleteWrapper_alignCenter: mze,
  closeButton: vze,
  "left-toolbar": "_left-toolbar_uu2te_86",
  "right-toolbar": "_right-toolbar_uu2te_90"
}, yze = {
  name: "NewsItemPanel",
  mixins: [ai],
  // withActiveTabIndex удалён, т.к. не используется
  components: {
    Panel: bs,
    NewsItemVersionCtr: uje,
    NewsItemDraftCtr: Tje,
    NewsItemPublishCtr: lRe,
    PanelToolbar: gHe,
    EditorToolbarCtr: DHe,
    NewsItemStatus: v6,
    DialogDispose: LL,
    DialogDelete: nR,
    NewsItemPanelControls: AI,
    VersionActionsCtr: qVe,
    PbCheckboxLabeled: qa,
    NewsItemVersionDiff: mje,
    NewsItemActionsHistory: aze,
    ConditionalWrapper: lze
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parentId: {
      type: [String, Number, null],
      default: null
    },
    newsItemId: {
      type: [String, Number],
      required: !0
    },
    newsItem: {
      type: Object,
      default: null
    },
    newsItemParentId: {
      type: [Number, String, null],
      default: null
    },
    isPanelFocused: {
      type: Boolean,
      default: !1
    },
    isPanelFullscreen: {
      type: Boolean,
      default: !1
    },
    isPanelMaximized: {
      type: Boolean,
      default: !1
    },
    isEditable: {
      type: Boolean,
      default: !1
    },
    isPublished: {
      type: Boolean,
      default: !1
    },
    isRightSupplyVisible: {
      type: Boolean,
      default: !1
    },
    draftTypeId: {
      type: [String, Number],
      default: null
    },
    disposeDialog: {
      type: Boolean,
      default: !1
    },
    publishMode: {
      type: Boolean,
      default: !1
    },
    historyMode: {
      type: Boolean,
      default: !1
    },
    selectedVersion: Number,
    notFound: {
      type: Boolean,
      default: !1
    },
    panelStyle: {
      type: Object,
      default: () => ({})
    },
    profileEditorSettings: {
      type: Object,
      default: () => ({})
    }
  },
  provide() {
    const t = this;
    return {
      getScrollableArea: () => t.$refs ? t.$refs.scrollableArea : null,
      toolbarStyles: () => ({
        color: this.getColorScheme().theme === "dark" ? "#FFF" : "#000"
      })
    };
  },
  data() {
    return {
      deleteDialog: !1,
      dateMode: 0,
      undoable: !1,
      redoable: !1,
      scaleFactors: Cr.newsItem,
      selectedFragment: null
    };
  },
  computed: {
    deleteDialogClass() {
      return {
        [this.$style.dialogDeleteWrapper]: !0,
        [this.$style.dialogDeleteWrapper_alignLeft]: !this.isPanelMaximized && !this.isPanelFullscreen && !this.isRightSupplyVisible,
        [this.$style.dialogDeleteWrapper_alignCenter]: this.isRightSupplyVisible
      };
    },
    modifiedDate() {
      var t;
      return (t = this.newsItem) == null ? void 0 : t.status_modified_at;
    },
    contentView() {
      return this.historyMode ? "history" : this.isEditable ? this.publishMode ? "publish" : "draft" : "version";
    }
  },
  methods: {
    closePanel() {
      this.parentId ? this.$store.dispatch("panels/hideSupply", {
        panelId: this.parentId,
        supplyId: this.panel.id
      }) : this.$store.dispatch("panels/removePanel", { panelId: this.panel.id });
    },
    showDeleteDialog() {
      this.deleteDialog = !0;
    },
    setFragmentSelected(t) {
      this.selectedFragment = t ?? null;
    }
  }
};
var bze = function() {
  var e = this, n = e._self._c;
  return e.panel && e.panel.dataId !== void 0 ? n("Panel", { class: { [e.$style.root]: !0 }, style: e.panelStyle, attrs: { panel: e.panel, isFocused: e.isPanelFocused, isFullscreen: e.isPanelFullscreen, "data-test-attrs": `entry-id__${e.panel.dataId}`, hasTitleBar: !0, resizeable: !1, toolbarProps: {
    styleContent: { padding: "5px 0" },
    styleRoot: {
      borderBottom: "1px solid #" + e.getColorScheme().innerBorderColor
    }
  }, toolbarColor: "inherit" }, scopedSlots: e._u([{ key: "appBarActions", fn: function(r) {
    return [n("div", { staticClass: "header-wrap" }, [n("VersionActionsCtr", { staticClass: "news-actions", attrs: { panel: e.panel, newsItemId: e.notFound ? null : e.newsItemId, newsItemParentId: e.newsItemParentId, selectedFragment: e.selectedFragment, buttonProps: {
      size: 18,
      isTextHidden: !(r.isMaximized || r.isFullscreen)
    } }, on: { showDeleteDialog: e.showDeleteDialog } }), e._t("newsItemStatus", function() {
      return [!e.notFound && (!e.isEditable || e.historyMode) ? n("NewsItemStatus", { staticClass: "news-status", attrs: { newsItemId: e.newsItemId, panelId: e.panel.id } }) : e._e()];
    }), n("div", { staticClass: "header__end" }, [e._t("header-end"), n("PbCheckboxLabeled", { directives: [{ name: "show", rawName: "v-show", value: r.isMaximized || r.isFullscreen, expression: "sizeTools.isMaximized || sizeTools.isFullscreen" }], attrs: { label: "закрыть редактор", iconProps: { size: 14 }, styleLabel: {
      marginLeft: "3px",
      marginRight: "15px",
      color: e.getColorScheme().editorControlColor,
      position: "relative",
      bottom: "1px",
      fontSize: "14px"
    } }, on: { change: function(s) {
      return e.$emit("setCloseOnSubmit", s);
    } }, model: { value: e.profileEditorSettings.closeOnSubmit, callback: function(s) {
      e.$set(e.profileEditorSettings, "closeOnSubmit", s);
    }, expression: "profileEditorSettings.closeOnSubmit" } }), n("NewsItemPanelControls", { staticClass: "service-buttons", attrs: { sizeTools: { ...r, closePanel: e.closePanel }, btnStyle: {
      backgroundColor: e.getColorScheme().editorControlBgColor,
      color: e.getColorScheme().editorControlColor,
      width: "22px",
      height: "22px",
      marginRight: "5px"
    } } })], 2)], 2)];
  } }, e.notFound ? { key: "content", fn: function() {
    return [n("div", { ref: "scrollableArea", staticClass: "no-content" }, [n("h3", [e._v("Новость не найдена")])]), e._t("panelToolbar", function() {
      return [n("PanelToolbar", { class: e.$style["right-toolbar"], attrs: { newsItemId: e.newsItemId, panelId: e.panel.id, notFound: e.notFound } })];
    })];
  }, proxy: !0 } : { key: "content", fn: function() {
    return [e.newsItem ? n("div", { class: e.$style.newsDraftWrapper, attrs: { "data-test-selector": "news-item-version" } }, [e.publishMode ? n("EditorToolbarCtr", { class: e.$style["left-toolbar"], attrs: { isFullscreen: e.isPanelFullscreen, publishMode: e.publishMode, newsItemId: e.panel.dataId } }) : e._e(), n("div", { class: {
      [e.$style["news-item-body"]]: !0,
      [e.$style["publish-mode"]]: e.publishMode
    } }, [e._t("newsContent", function() {
      return [e.contentView === "publish" ? n("NewsItemPublishCtr", { ref: "scrollableArea", attrs: { newsItemId: e.newsItemId, fullSize: !e.isPanelMaximized && !e.isPanelFullscreen, isPanelFocused: e.isPanelFocused, isPanelMaximized: e.isPanelMaximized } }) : e._e(), n("conditional-wrapper", { attrs: { show: e.contentView !== "publish" && e.contentView !== "version", tag: "keep-alive" } }, [e.contentView === "draft" ? n("NewsItemDraftCtr", { attrs: { newsItemId: e.panel.dataId, panelId: e.panel.id, isPanelMaximized: e.isPanelMaximized, isPanelFocused: e.isPanelFocused }, on: { initEditorStore: function(r) {
        return e.$emit("initEditorStore", r);
      }, editorToggleSupply: function(r) {
        return e.$emit("editorToggleSupply");
      }, fragmentSelected: function(r) {
        return e.setFragmentSelected(r);
      } } }) : e._e()], 1), e.contentView === "version" ? n("NewsItemVersionCtr", { ref: "scrollableArea", class: `theme-${e.settings.colorScheme}`, style: e.editorStyle, attrs: { newsItemId: e.newsItemId, isBig: e.isPanelMaximized }, on: { initEditorStore: function(r) {
        return e.$emit("initEditorStore", r);
      } } }) : e._e(), e.contentView === "history" ? n("NewsItemVersionDiff", { ref: "scrollableArea", class: `theme-${e.settings.colorScheme}`, style: e.editorStyle, attrs: { newsItemId: e.newsItemId, versionId: e.selectedVersion, isBig: e.isPanelMaximized, showDiff: !0 } }) : e._e()];
    })], 2), e._t("panelToolbar", function() {
      return [n("PanelToolbar", { class: e.$style["right-toolbar"], attrs: { newsItemId: e.newsItemId, panelId: e.panel.id, parentId: e.parentId, publishMode: e.publishMode, isFullscreen: e.isPanelFullscreen, isMaximized: e.isPanelMaximized, selectedFragment: e.selectedFragment }, on: { showDeleteDialog: e.showDeleteDialog, toggleRightSupply: function(r) {
        return e.$emit("toggleRightSupply", r);
      } } })];
    })], 2) : e._e()];
  }, proxy: !0 }, e.notFound ? null : { key: "footer", fn: function() {
    return [e._t("newsFooter", function() {
      return [e.parentId ? e._e() : n("NewsItemActionsHistory", { attrs: { newsItemId: e.newsItemId, panelId: e.panel.id, showCheckbox: e.panel.supply && e.panel.supply.left[0] ? e.panel.supply.left[0].settings.visible : null }, on: { toggleLeftSupply: function(r) {
        return e.$emit("toggleLeftSupply", r);
      } } })];
    })];
  }, proxy: !0 }, { key: "dialogs", fn: function() {
    return [e.disposeDialog ? n("DialogDispose", { attrs: { state: e.disposeDialog, confirmButtonLabel: "Отклонить новость" }, on: { "update:state": function(r) {
      return e.$emit("update:disposeDialog");
    }, dispose: function(r) {
      return e.$emit("dispose", r);
    } } }) : e._e(), n("transition", { attrs: { name: "fade", appear: "" } }, [e.deleteDialog ? n("div", { class: e.deleteDialogClass, attrs: { "data-test-selector": "news-item-delete-dialog" } }, [n("DialogDelete", { attrs: { state: e.deleteDialog }, on: { "update:state": function(r) {
      e.deleteDialog = r;
    }, delete: function(r) {
      return e.$emit("remove");
    } }, scopedSlots: e._u([{ key: "title", fn: function() {
      return [e._v(" Удаление новости / Отправка в отвал ")];
    }, proxy: !0 }, { key: "default", fn: function() {
      return [e._v(" Новость будет удалена без возможности восстановления или отправлена в отвал, если есть связанные заметки, отправленнные в АСОИ ")];
    }, proxy: !0 }], null, !1, 2295661895) })], 1) : e._e()])];
  }, proxy: !0 }], null, !0) }) : e._e();
}, _ze = [];
const J3 = {
  $style: gze
};
function wze(t) {
  for (var e in J3)
    this[e] = J3[e];
}
var Sze = /* @__PURE__ */ B(
  yze,
  bze,
  _ze,
  !1,
  wze,
  null
);
const OI = Sze.exports, Ize = {
  name: "NewsItemPanelCtr",
  components: {
    NewsItemPanel: OI,
    MainActionButton: fn
  },
  props: {
    panel: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    const e = Jt("store"), n = ts(t).newsItemId || le(() => t.panel.dataId), { relatedPeople: r } = h6({ newsItemIdRef: n }, e), { isPublished: s, publishMode: i } = uc({ newsItemIdRef: n }, e), { gatewaySubscribe: o, gatewayUnsubscribe: a } = Kv(), { isRevoked: l, canRestore: c, restoreRevoked: u } = fc({ newsItemIdRef: n }, e);
    return {
      relatedPeople: r,
      isPublished: s,
      publishMode: i,
      gatewaySubscribe: o,
      gatewayUnsubscribe: a,
      isRevoked: l,
      canRestore: c,
      restoreRevoked: u
    };
  },
  data() {
    return {
      scaleFactors: Cr.newsItem,
      notFound: !1
    };
  },
  computed: {
    ...st("news", {
      news: (t) => t.items,
      initialLoadedMap: (t) => t.initialLoadedMap
    }),
    ...st({
      focusedPanel: (t) => t.panels.uiState.focused,
      fullscreenPanel: (t) => t.panels.uiState.fullscreen,
      settings: (t) => t.userProfile.newsEditor,
      fontSize: (t) => t.userProfile.newsEditor.fontSize
    }),
    ...pe([
      "isEditorFocused",
      "sessionTimeoutExpired",
      "getDraftVersionForNewsItem"
    ]),
    ...pe("references", ["newsStatusesByName", "newsParentRelTypes"]),
    ...pe("panels", [
      "getPanelVisibleSupplies",
      "getIsPanelRightSupplyVisible",
      "getRightPanelActiveTabIndex",
      "getIsHistorySupplyVisible"
    ]),
    ...pe("news", [
      "isNewsItemScheduled",
      "getIsNewsItemIsRevocation",
      "getIsNewsItemPublished",
      "getCanUserEditNewsItem",
      "getDisposalDialogState",
      "getNewsItemById"
    ]),
    ...pe("news/drafts", ["getDraftTypeId"]),
    ...pe({ getNewsItemHistory: "news/newsItemHistory/get" }),
    initialLoaded() {
      const t = this.initialLoadedMap[this.panel.dataId];
      return t ? t.initialLoaded : !1;
    },
    disposeDialog: {
      get() {
        return this.getDisposalDialogState(this.panel.dataId);
      },
      set(t) {
        this.setDisposalDialog({ id: this.panel.dataId, value: t });
      }
    },
    newsItem() {
      return this.news[this.panel.dataId];
    },
    newsItemId() {
      return Number(this.panel.dataId);
    },
    newsItemParentId() {
      var t;
      return ((t = this.newsItem) == null ? void 0 : t.parent_id) || null;
    },
    isPanelFocused() {
      return this.focusedPanel === this.panel.id;
    },
    isPanelFullscreen() {
      return this.fullscreenPanel === this.panel.id;
    },
    isPanelMaximized() {
      return this.panel.settings.widthScaleFactor > this.scaleFactors.default;
    },
    isEditable() {
      return this.getCanUserEditNewsItem(this.panel.dataId);
    },
    isRightSupplyVisible() {
      return this.getIsPanelRightSupplyVisible(this.panel.id);
    },
    isLeftSupplyVisible() {
      var t;
      return (t = this.panel.supply) == null ? void 0 : t.left.some((e) => e.settings.visible);
    },
    isHistorySupplyVisible() {
      return this.getIsHistorySupplyVisible(this.panel.id);
    },
    selectedVersion() {
      var t;
      return (t = this.getNewsItemHistory(this.panel.dataId)) == null ? void 0 : t.selectedVersion;
    },
    historyMode() {
      return !!(this.isHistorySupplyVisible && this.selectedVersion);
    },
    draftTypeId() {
      var t, e;
      return this.isEditable ? this.getDraftTypeId(this.panel.dataId) : (e = (t = this.newsItem) == null ? void 0 : t.version) == null ? void 0 : e.type_id;
    },
    panelStyle() {
      let t = ["6px", "6px", "6px", "6px"];
      return this.isLeftSupplyVisible && (t[0] = "0", t[3] = "0"), this.isRightSupplyVisible && (t[1] = "0", t[2] = "0"), {
        borderRadius: t.join(" ")
      };
    }
  },
  watch: {
    disposeDialog: function(t) {
      this.modalSet(t);
    },
    initialLoaded(t, e) {
      t !== e && t === !1 && this.initialLoad(!0);
    },
    $route(t) {
      if (!(t.params.id && this.newsItemId === Number(t.params.id))) return;
      t.hash && t.hash.match(/comment-(\d+)/g) && (this.isRightSupplyVisible ? this.setPanelActiveTabIndex({
        panelId: this.panel.supply.right[0].id,
        activeTabIndex: 1
        // вкладка "Обсуждение"
      }) : this.toggleRightSupply());
    }
  },
  mounted() {
    this.getNewsItemById(this.panel.dataId) ? (this.setInitialLoaded(!0), this.subscribeComments()) : this.initialLoad();
  },
  beforeDestroy() {
    this.deleteDraft({ newsItemId: this.panel.dataId }), delete this.$store.$_newsEditors[this.newsItemId], this.setInitialLoaded(!1), this.unsubscribeComments();
  },
  methods: {
    ...ge({
      setChatLoaded(t, e) {
        t("chatSetInitialLoaded", {
          newsItemId: this.panel.dataId,
          loaded: e
        });
      },
      modalSet: "setModal"
    }),
    ...ge("news", {
      getNewsItem: "getNewsItem",
      remove: "deleteNewsItem",
      processNewsMessage: "processNewsMessage",
      setDisposalDialog: "setDisposalDialog",
      dispose: "disposeNewsItem",
      setInitialLoaded(t, e) {
        t("setNewsItemInitialLoaded", {
          newsItemId: this.panel.dataId,
          value: e
        });
      }
    }),
    ...ge("news/drafts", {
      deleteDraft: "deleteDraft"
    }),
    ...ge({
      addMessage: "addMessage",
      setEditorFocus: "setPanelEditorFocus"
    }),
    ...ge("panels", [
      "removePanel",
      "showSupply",
      "hideSupply",
      "toggleSupplyOfType",
      "setPanelActiveTabIndex"
    ]),
    ...ge("userProfile", ["setProfileEditorSettings"]),
    setCloseOnSubmit(t) {
      this.setProfileEditorSettings({ editorSettings: { closeOnSubmit: t } });
    },
    async removeNewsItem() {
      const t = await this.remove({
        newsItemId: this.newsItem.id,
        panelId: this.panel.id,
        setFocusOnParent: !1
      });
      t.errors && console.error("Remove news item error:", t.errors);
    },
    async initialLoad(t) {
      await this.fetchData(t), this.setInitialLoaded(!0);
    },
    subscriptionHandler({ payload: t, subId: e } = {}) {
      this.processNewsMessage({ payload: t, subId: e });
    },
    async fetchData() {
      var e;
      let t = {};
      if ((e = this.panel) != null && e.dataId) {
        if (t = await this.getNewsItem(this.panel.dataId), t.errors && t.errors.length) {
          if (t.status === 404)
            return this.notFound = !0, t;
        } else
          this.subscribeComments();
        return t;
      }
    },
    /* Подписываемся на тип сообщений SPECIFIC_NEWS, в котором нас интересует только получение комментариев.
    * Все остальные типы событий новости (type_id) дублируют те, что приходят с сообщениями типа NEWS.
    */
    subscribeComments() {
      this.newsItem && this.newsItem.id && this.gatewaySubscribe({
        type: Wm.SPECIFIC_NEWS,
        id: this.newsItem.id
      });
    },
    unsubscribeComments() {
      const t = Number(this.panel.dataId);
      this.gatewayUnsubscribe({
        type: Wm.SPECIFIC_NEWS,
        id: t
      });
    },
    toggleRightSupply({ activeTabIndex: t } = {}) {
      const e = this.panel.id, n = this.panel.supply.right[0].id, r = {
        panelId: e,
        supplyId: n
      }, s = this.getRightPanelActiveTabIndex(e);
      !this.isRightSupplyVisible || s !== t ? (t !== void 0 && this.setPanelActiveTabIndex({
        panelId: n,
        activeTabIndex: t
      }), this.showSupply(r)) : this.hideSupply(r);
    },
    toggleLeftSupply(t) {
      this.toggleSupplyOfType({
        panelId: this.panel.id,
        type: t,
        hideOthers: !0
      });
    },
    initEditorStore(t) {
      const { type: e, editor: n } = t;
      this.$store.$_newsEditors[this.newsItemId] || (this.$store.$_newsEditors[this.newsItemId] = {}), this.$store.$_newsEditors[this.newsItemId][e] = n;
    }
  }
};
var Eze = function() {
  var e = this, n = e._self._c;
  return n("NewsItemPanel", { attrs: { disposeDialog: e.disposeDialog, draftTypeId: e.draftTypeId, initialLoaded: e.initialLoaded, isEditable: e.isEditable, isPanelFocused: e.isPanelFocused, isPanelFullscreen: e.isPanelFullscreen, isPanelMaximized: e.isPanelMaximized, isPublished: e.isPublished, isRightSupplyVisible: e.isRightSupplyVisible, newsItem: e.newsItem, newsItemId: e.newsItemId, newsItemParentId: e.newsItemParentId, notFound: e.notFound, panel: e.panel, publishMode: e.publishMode, historyMode: e.historyMode, selectedVersion: e.selectedVersion, panelStyle: e.panelStyle, profileEditorSettings: e.settings }, on: { "update:disposeDialog": function(r) {
    e.disposeDialog = r;
  }, "update:dispose-dialog": function(r) {
    e.disposeDialog = r;
  }, initEditorStore: e.initEditorStore, editorToggleSupply: function(r) {
    return e.$emit("editorToggleSupply");
  }, toggleRightSupply: e.toggleRightSupply, toggleLeftSupply: e.toggleLeftSupply, setCloseOnSubmit: e.setCloseOnSubmit, dispose: function(r) {
    return e.dispose({
      newsItemId: e.newsItem.id,
      reason: r,
      panelId: e.panel.id
    });
  }, remove: function(r) {
    return e.remove({
      newsItemId: e.newsItem.id,
      panelId: e.panel.id,
      setFocusOnParent: !1
    });
  } }, scopedSlots: e._u([{ key: "header-end", fn: function() {
    return [e.isRevoked && e.canRestore ? n("MainActionButton", { staticClass: "pb-action-button", attrs: { isTextHidden: !(e.isPanelMaximized || e.isPanelFullscreen), title: "Восстановить", active: "", size: "18", iconName: "outline/recovery", "data-test-selector": "toolbar-revoked-restore" }, nativeOn: { click: function(r) {
      return (() => e.restoreRevoked(e.isHistorySupplyVisible ? { version_id: e.selectedVersion } : {})).apply(null, arguments);
    } } }, [e._v(" Восстановить ")]) : e._e()];
  }, proxy: !0 }]) });
}, xze = [], Cze = /* @__PURE__ */ B(
  Ize,
  Eze,
  xze,
  !1,
  null,
  null
);
const Tze = Cze.exports;
function q3(t) {
  return on(Tr(t), "dd MMM yyyy-HH:mm:ss", { locale: xn }).replace(
    /-/,
    `\r
`
  );
}
const Q3 = {
  slugline: "SL",
  headline: "H1",
  subheadline: "H2",
  trashline: "TR",
  dateline: "DT",
  body: "TX"
}, Pze = {
  components: {
    Panel: bs,
    PbLoader: br
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object
    }
  },
  setup(t) {
    const e = Jt("store"), n = {
      getHistory: e.getters["news/newsItemHistory/get"],
      eventRefs: e.state.references.NewsEvent.Type,
      getIsStatusWaiting: e.getters["news/versions/getIsStatusWaiting"],
      getVersionUserName: e.getters["news/versions/getVersionUserName"],
      newsStatusesByName: e.getters["references/newsStatusesByName"],
      news: e.state.news.items
    }, r = {
      $store: e,
      ...ge("news/newsItemHistory", ["setSelectedVersion"]),
      ...ge("news/newsItemHistory", { fetchData: "update" }),
      ...ge("panels", ["hideSupply"])
    }, s = le(() => n.getHistory(t.panel.dataId)), i = le(() => {
      var f;
      return (f = s.value) == null ? void 0 : f.initialLoaded;
    }), o = le(() => {
      var f;
      return (f = s.value) == null ? void 0 : f.history;
    }), a = le(() => {
      var f;
      return (f = s.value) == null ? void 0 : f.selectedVersion;
    });
    r.fetchData(t.panel.dataId), or(
      () => i.value,
      (f, p) => {
        p !== f && !f && r.fetchData(t.panel.dataId);
      }
    );
    const l = le(() => {
      let f = null;
      return o.value.map(({ version: p, diff: h }) => {
        var _, w;
        const m = {
          id: p.id,
          creator: Ps(((_ = p.user) == null ? void 0 : _.name) || ((w = f == null ? void 0 : f.user) == null ? void 0 : w.name))
        }, v = p.status_id === n.newsStatusesByName.PUBLISHED.id, y = n.news[t.panel.dataId];
        if (m.created_at = q3(v && y ? y.status_modified_at : p.created_at), m.status = n.eventRefs[p.status_id].description, n.getIsStatusWaiting(p.status_id)) {
          const S = n.getVersionUserName(p);
          S && (m.recipient = S);
        }
        return m.diffs = Object.keys(Q3).map((S) => ({ type: Q3[S], active: h && !!h[S] })), f = p, m;
      }).reverse();
    }), c = et(null);
    function u() {
      const f = c.value.$el, p = f.getElementsByClassName("panel-body")[0];
      p && p.scrollHeight > p.clientHeight && f.classList.add("has-scrollbar");
    }
    return Io(u), or(() => o.value, u), {
      entries: l,
      versions: o,
      selectedVersion: a,
      initialLoaded: i,
      _root: c,
      ...{
        onClick: (f) => r.setSelectedVersion({
          newsItemId: t.panel.dataId,
          versionId: f
        }),
        closePanel() {
          r.hideSupply({
            panelId: t.parent.id,
            supplyId: t.panel.id
          });
        },
        isSelected: (f) => f === a.value
      }
    };
  }
};
var kze = function() {
  var e = this, n = e._self._c;
  return n("Panel", { ref: "_root", staticClass: "NewsItemHistoryPanel", attrs: { panel: e.panel, resizeable: !1 }, scopedSlots: e._u([{ key: "main-toolbar", fn: function() {
    return [n("div", { staticClass: "header" })];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n("div", { staticClass: "btn-close", on: { click: e.closePanel } }, [n("icon", { attrs: { name: "close", size: "13" } })], 1), e.initialLoaded ? n("div", { staticClass: "versions" }, e._l(e.entries, function(r) {
      return n("div", { key: r.id, staticClass: "version", class: { selected: e.isSelected(r.id) }, on: { click: function(s) {
        return e.onClick(r.id);
      } } }, [n("div", { staticClass: "date" }, [e._v(e._s(r.created_at))]), n("div", { staticClass: "creator" }, [e._v(" " + e._s(r.creator) + " "), n("i", { attrs: { type: "font", name: "close", size: "12" } })]), n("div", { staticClass: "status", attrs: { "need-arrow": r.recipient } }, [e._v(e._s(r.status))]), r.recipient ? n("div", { staticClass: "recipient" }, [e._v(e._s(r.recipient))]) : e._e(), n("div", { staticClass: "diffs" }, e._l(r.diffs, function(s) {
        return n("div", { key: s.type, staticClass: "block-indicator", class: { active: s.active } }, [e._v(" " + e._s(s.type) + " ")]);
      }), 0)]);
    }), 0) : n("PbLoader")];
  }, proxy: !0 }]) });
}, Nze = [], $ze = /* @__PURE__ */ B(
  Pze,
  kze,
  Nze,
  !1,
  null,
  "4fc90996"
);
const Dze = $ze.exports;
function Aze() {
  const t = {
    store: {},
    modules: {}
  };
  return t.dependenciesMap = {}, t.init = (e, n) => {
    t.store = e, t.modules = n;
  }, t.getDeps = (e) => {
    if (!t.store || !t.modules)
      throw new Error("Store deps not initialized");
    const n = {}, r = t.dependenciesMap[e];
    return r && Object.entries(r).forEach(([s, i]) => {
      var a;
      let o;
      s === "root" ? o = t.store._modules.root : o = t.store._modules.get(
        (a = t.modules[s]) == null ? void 0 : a.path
      ), o && (n[s] = {}, i != null && i.getters && i.getters.forEach((l) => {
        n[s][l] = o.context.getters[l];
      }), i != null && i.actions && i.actions.forEach((l) => {
        n[s][l] = (...c) => o.context.dispatch(l, ...c);
      }));
    }), n;
  }, t;
}
const E1 = Aze(), rt = {
  INITIAL: 0,
  IN_PROGRESS: 1,
  READY: 2,
  ERROR: 3
}, zc = {}, mi = {};
function Oze(t, e) {
  return `${zc[t].path.join("/")}/${e}`;
}
function Mze(t) {
  const e = t.split("/");
  return e.length > 1 && e[e.length - 1] === "init";
}
function Rze(t) {
  const e = t.split("/");
  return e.length > 1 && e[e.length - 1] === "reset";
}
function e$(t) {
  return ({ commit: e }) => (e(`${t.toUpperCase()}_INIT`, rt.READY), rt.READY);
}
function t$(t) {
  return ({ commit: e }) => (e(`${t.toUpperCase()}_RESET`), rt.INITIAL);
}
function Lze() {
  return (t, e) => {
    t.init = e;
  };
}
function Fze() {
  return (t) => {
    t.init = rt.INITIAL;
  };
}
async function Bze(t, e = []) {
  Object.entries(mi).forEach(([n, r]) => {
    e.includes(n) || (t.dispatch(Oze(n, "reset")), r.status = rt.INITIAL, r.initPromise = null);
  });
}
function Dn(t, e) {
  let n = {};
  const r = t[t.length - 1];
  n.state = {
    init: rt.INITIAL,
    ...e.state
  }, n.mutations = Object.assign(
    {
      [`${r.toUpperCase()}_INIT`]: Lze(),
      [`${r.toUpperCase()}_RESET`]: Fze()
    },
    e.mutations
  );
  let s = {};
  return e.namespaced ? (s.init = e$(r), s.reset = t$(r)) : (s[`${r}/init`] = e$(r), s[`${r}/reset`] = t$(r)), n.actions = Object.assign(s, e.actions), n.dependencies = Object.assign(
    { root: null },
    e.dependencies
  ), e.namespaced && (n.getters = Object.assign(
    {
      isInitialized: (i) => i.init === rt.READY
    },
    e.getters
  )), n = {
    ...e,
    ...n
  }, zc[r] = {
    path: t,
    options: n
  }, n;
}
const jze = (t, e = { triggers: [], exclude: [] }) => {
  E1.init(t, zc);
  const n = t.dispatch;
  Object.keys(zc).forEach((i) => {
    mi[i] = {
      status: rt.INITIAL,
      initPromise: null
    };
    const o = zc[i].options;
    if (o.dependencies) {
      const a = {};
      Object.keys(o.dependencies).forEach((l) => {
        a[l] = o.dependencies[l];
      }), E1.dependenciesMap[i] = a;
    }
  });
  function r(i) {
    return new Promise((o, a) => {
      const l = zc[i].path;
      n.call(t, `${l.join("/")}/init`).then((c) => {
        mi[i].status = rt.READY, c === rt.INITIAL && (mi[i].status = rt.INITIAL, mi[i].initPromise = null), o(c);
      }).catch((c) => {
        a(c);
      });
    });
  }
  function s(i) {
    mi[i].status = rt.INITIAL, mi[i].initPromise = null;
  }
  return t.dispatch = async function(o, a) {
    var u, d;
    const l = o.split("/").slice(0, -1), c = l[l.length - 1];
    return e.triggers.includes(o) && Bze(t, [...e.exclude, c]), Mze(o) ? ((((u = mi[c]) == null ? void 0 : u.status) === rt.INITIAL || ((d = mi[c]) == null ? void 0 : d.status) === rt.ERROR) && (mi[c].status = rt.IN_PROGRESS, mi[c].initPromise = r(c)), mi[c].initPromise) : (Rze(o) && s(c), n.call(t, o, a));
  }, t;
};
function Wze(t, e) {
  return new Promise((n) => {
    if (e.init === rt.READY) return n(!0);
    if (e.init === rt.INITIAL) return n(!1);
    if (e.init === rt.IN_PROGRESS) {
      const r = t.watch(
        () => e.init,
        (s) => {
          if (s === rt.READY || s === rt.ERROR)
            return r(), n(s === rt.READY);
        }
      );
    }
  });
}
const Ie = E1.getDeps;
function hi(t) {
  return {
    name: "NewsGuard",
    computed: {
      initialized() {
        return this.$store.state.news.init === rt.READY && this.$store.state.news.versions.init === rt.READY && this.$store.state.news.drafts.init === rt.READY;
      }
    },
    render(e) {
      return this.initialized ? e(t, { props: this.$attrs }) : null;
    }
  };
}
const Hze = "_root_kd27b_1", Vze = "_tabsItem_kd27b_5", zze = "_tabBar_kd27b_11", Uze = "_fullscreen_kd27b_17", Gze = {
  root: Hze,
  tabsItem: Vze,
  tabBar: zze,
  fullscreen: Uze
}, Yze = {
  name: "NewsNewsbreakPanel",
  components: {
    Panel: bs,
    Tabs: QS,
    LeadDiff: A2,
    NewsbreakFragment: RL,
    LeadAdditions: D2
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      required: !0
    },
    tabs: {
      type: Array,
      default: () => []
    },
    newsbreak: {
      type: Object,
      default: () => ({})
    },
    lead: {
      type: Object,
      default: () => ({})
    },
    activeTab: {
      type: String,
      required: !0
    },
    loaded: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "#000"
    },
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    currentTab: {
      get() {
        return this.activeTab;
      },
      set(t) {
        this.$emit("update:activeTab", t);
      }
    },
    panelStyle() {
      return {
        color: this.color,
        backgroundColor: this.backgroundColor
      };
    }
  },
  data() {
    return {};
  }
};
var Zze = function() {
  var e = this, n = e._self._c;
  return n("Panel", { class: e.$style.root, style: e.panelStyle, attrs: { hasTitleBar: !1, panel: e.panel, resizible: !1 }, scopedSlots: e._u([{ key: "main-toolbar", fn: function() {
    return [n("div", { class: {
      [e.$style.tabBar]: !0,
      [e.$style.fullscreen]: e.isFullscreen
    } }, [n("Tabs", { attrs: { tabs: e.tabs, type: "centered", height: "calc(2rem - 6px)" }, model: { value: e.currentTab, callback: function(r) {
      e.currentTab = r;
    }, expression: "currentTab" } })], 1)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n(e.activeTab, { tag: "component", class: e.$style.tabsItem, attrs: { entry: e.lead, fragment: e.newsbreak.fragment, isParentNewsPanel: !0, loaded: e.loaded } })];
  }, proxy: !0 }]) });
}, Xze = [];
const n$ = {
  $style: Gze
};
function Kze(t) {
  for (var e in n$)
    this[e] = n$[e];
}
var Jze = /* @__PURE__ */ B(
  Yze,
  Zze,
  Xze,
  !1,
  Kze,
  null
);
const qze = Jze.exports, Qze = {
  name: "NewsNewsbreakPanelCtr",
  mixins: [Jv, ai],
  components: {
    NewsNewsbreakPanel: qze
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      required: !0
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loaded: !1
    };
  },
  computed: {
    ...st({
      fullscreenPanel: (t) => t.panels.uiState.fullscreen,
      newsbreaks: (t) => t.newsbreaks.items,
      initialLoadedMap: (t) => t.newsbreaks.initialLoadedMap
    }),
    ...pe(["getNewsbreakLead"]),
    ...pe("references", ["premoderatedSourceTypes"]),
    initialLoaded() {
      const t = this.initialLoadedMap[this.panel.dataId];
      return t ? t.initialLoaded : !1;
    },
    isSupplyOfFullscreenPanel() {
      return this.parent && this.parent.id && this.parent.id === this.fullscreenPanel;
    },
    isFromPremoderatedSource() {
      return !this.lead || fs(this.lead) ? !1 : this.premoderatedSourceTypes.includes(this.lead.source.type_id);
    },
    tabs() {
      const t = [{ name: "LeadAdditions", label: "Текст" }];
      return this.isFromPremoderatedSource || t.unshift({ name: "LeadDiff", label: "Разница" }), this.newsbreak.fragment && t.push({ name: "NewsbreakFragment", label: "Инфоповод" }), t;
    },
    lead() {
      return this.getNewsbreakLead(this.newsbreak.id);
    },
    diff() {
      return this.newsbreak.lead && this.newsbreak.lead.diff || {};
    },
    newsbreak() {
      return this.newsbreaks[this.panel.dataId] || {};
    },
    lastError() {
      return this.errors.length ? this.errors[this.errors.length - 1].title : null;
    }
  },
  watch: {
    initialLoaded(t, e) {
      t !== e && t === !1 && this.initialLoad(!0);
    }
  },
  created() {
    this.initialLoad();
  },
  beforeDestroy() {
    this.setInitialLoaded({ newsbreakId: this.panel.dataId, value: !1 });
  },
  methods: {
    ...ge("newsbreaks", {
      getNewsbreak: "getNewsbreak",
      setInitialLoaded: "newsbreaksSetInitialLoaded"
    }),
    ...ge("panels", {
      removePanel: "removePanel"
    }),
    async initialLoad(t) {
      (await this.fetchData(this.panel.dataId, t)).fragment && (this.activeTab = "NewsbreakFragment"), this.setInitialLoaded({ newsbreakId: this.panel.dataId, value: !0 });
    },
    async fetchData(t, e = !1) {
      this.loaded = !1;
      let n = this.newsbreak || {};
      return (!n.id || e) && (n = await this.getNewsbreak(t)), n.errors && (this.errors = n.errors), this.loaded = !0, n;
    }
  }
};
var eUe = function() {
  var e = this, n = e._self._c;
  return n("NewsNewsbreakPanel", { attrs: { activeTab: e.activeTab, backgroundColor: e.editorStyle.backgroundColor, color: e.editorStyle.color, isFullscreen: e.isFullscreen, lead: e.lead, loaded: e.loaded, newsbreak: e.newsbreak, panel: e.panel, parent: e.parent, tabs: e.tabs }, on: { "update:activeTab": function(r) {
    e.activeTab = r;
  }, "update:active-tab": function(r) {
    e.activeTab = r;
  } } });
}, tUe = [], nUe = /* @__PURE__ */ B(
  Qze,
  eUe,
  tUe,
  !1,
  null,
  null
);
const rUe = nUe.exports;
function Fp(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var P8 = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(t, e) {
  (function(n) {
    t.exports = n();
  })(function() {
    return function n(r, s, i) {
      function o(c, u) {
        if (!s[c]) {
          if (!r[c]) {
            var d = typeof Fp == "function" && Fp;
            if (!u && d) return d(c, !0);
            if (a) return a(c, !0);
            var f = new Error("Cannot find module '" + c + "'");
            throw f.code = "MODULE_NOT_FOUND", f;
          }
          var p = s[c] = { exports: {} };
          r[c][0].call(p.exports, function(h) {
            var m = r[c][1][h];
            return o(m || h);
          }, p, p.exports, n, r, s, i);
        }
        return s[c].exports;
      }
      for (var a = typeof Fp == "function" && Fp, l = 0; l < i.length; l++) o(i[l]);
      return o;
    }({ 1: [function(n, r, s) {
      (function(i) {
        var o = i.MutationObserver || i.WebKitMutationObserver, a;
        if (o) {
          var l = 0, c = new o(h), u = i.document.createTextNode("");
          c.observe(u, {
            characterData: !0
          }), a = function() {
            u.data = l = ++l % 2;
          };
        } else if (!i.setImmediate && typeof i.MessageChannel < "u") {
          var d = new i.MessageChannel();
          d.port1.onmessage = h, a = function() {
            d.port2.postMessage(0);
          };
        } else "document" in i && "onreadystatechange" in i.document.createElement("script") ? a = function() {
          var v = i.document.createElement("script");
          v.onreadystatechange = function() {
            h(), v.onreadystatechange = null, v.parentNode.removeChild(v), v = null;
          }, i.document.documentElement.appendChild(v);
        } : a = function() {
          setTimeout(h, 0);
        };
        var f, p = [];
        function h() {
          f = !0;
          for (var v, y, _ = p.length; _; ) {
            for (y = p, p = [], v = -1; ++v < _; )
              y[v]();
            _ = p.length;
          }
          f = !1;
        }
        r.exports = m;
        function m(v) {
          p.push(v) === 1 && !f && a();
        }
      }).call(this, typeof vr < "u" ? vr : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 2: [function(n, r, s) {
      var i = n(1);
      function o() {
      }
      var a = {}, l = ["REJECTED"], c = ["FULFILLED"], u = ["PENDING"];
      r.exports = d;
      function d(E) {
        if (typeof E != "function")
          throw new TypeError("resolver must be a function");
        this.state = u, this.queue = [], this.outcome = void 0, E !== o && m(this, E);
      }
      d.prototype.catch = function(E) {
        return this.then(null, E);
      }, d.prototype.then = function(E, x) {
        if (typeof E != "function" && this.state === c || typeof x != "function" && this.state === l)
          return this;
        var T = new this.constructor(o);
        if (this.state !== u) {
          var C = this.state === c ? E : x;
          p(T, C, this.outcome);
        } else
          this.queue.push(new f(T, E, x));
        return T;
      };
      function f(E, x, T) {
        this.promise = E, typeof x == "function" && (this.onFulfilled = x, this.callFulfilled = this.otherCallFulfilled), typeof T == "function" && (this.onRejected = T, this.callRejected = this.otherCallRejected);
      }
      f.prototype.callFulfilled = function(E) {
        a.resolve(this.promise, E);
      }, f.prototype.otherCallFulfilled = function(E) {
        p(this.promise, this.onFulfilled, E);
      }, f.prototype.callRejected = function(E) {
        a.reject(this.promise, E);
      }, f.prototype.otherCallRejected = function(E) {
        p(this.promise, this.onRejected, E);
      };
      function p(E, x, T) {
        i(function() {
          var C;
          try {
            C = x(T);
          } catch (k) {
            return a.reject(E, k);
          }
          C === E ? a.reject(E, new TypeError("Cannot resolve promise with itself")) : a.resolve(E, C);
        });
      }
      a.resolve = function(E, x) {
        var T = v(h, x);
        if (T.status === "error")
          return a.reject(E, T.value);
        var C = T.value;
        if (C)
          m(E, C);
        else {
          E.state = c, E.outcome = x;
          for (var k = -1, b = E.queue.length; ++k < b; )
            E.queue[k].callFulfilled(x);
        }
        return E;
      }, a.reject = function(E, x) {
        E.state = l, E.outcome = x;
        for (var T = -1, C = E.queue.length; ++T < C; )
          E.queue[T].callRejected(x);
        return E;
      };
      function h(E) {
        var x = E && E.then;
        if (E && (typeof E == "object" || typeof E == "function") && typeof x == "function")
          return function() {
            x.apply(E, arguments);
          };
      }
      function m(E, x) {
        var T = !1;
        function C(N) {
          T || (T = !0, a.reject(E, N));
        }
        function k(N) {
          T || (T = !0, a.resolve(E, N));
        }
        function b() {
          x(k, C);
        }
        var P = v(b);
        P.status === "error" && C(P.value);
      }
      function v(E, x) {
        var T = {};
        try {
          T.value = E(x), T.status = "success";
        } catch (C) {
          T.status = "error", T.value = C;
        }
        return T;
      }
      d.resolve = y;
      function y(E) {
        return E instanceof this ? E : a.resolve(new this(o), E);
      }
      d.reject = _;
      function _(E) {
        var x = new this(o);
        return a.reject(x, E);
      }
      d.all = w;
      function w(E) {
        var x = this;
        if (Object.prototype.toString.call(E) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var T = E.length, C = !1;
        if (!T)
          return this.resolve([]);
        for (var k = new Array(T), b = 0, P = -1, N = new this(o); ++P < T; )
          D(E[P], P);
        return N;
        function D(H, Y) {
          x.resolve(H).then(te, function(A) {
            C || (C = !0, a.reject(N, A));
          });
          function te(A) {
            k[Y] = A, ++b === T && !C && (C = !0, a.resolve(N, k));
          }
        }
      }
      d.race = S;
      function S(E) {
        var x = this;
        if (Object.prototype.toString.call(E) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var T = E.length, C = !1;
        if (!T)
          return this.resolve([]);
        for (var k = -1, b = new this(o); ++k < T; )
          P(E[k]);
        return b;
        function P(N) {
          x.resolve(N).then(function(D) {
            C || (C = !0, a.resolve(b, D));
          }, function(D) {
            C || (C = !0, a.reject(b, D));
          });
        }
      }
    }, { 1: 1 }], 3: [function(n, r, s) {
      (function(i) {
        typeof i.Promise != "function" && (i.Promise = n(2));
      }).call(this, typeof vr < "u" ? vr : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { 2: 2 }], 4: [function(n, r, s) {
      var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(M) {
        return typeof M;
      } : function(M) {
        return M && typeof Symbol == "function" && M.constructor === Symbol && M !== Symbol.prototype ? "symbol" : typeof M;
      };
      function o(M, J) {
        if (!(M instanceof J))
          throw new TypeError("Cannot call a class as a function");
      }
      function a() {
        try {
          if (typeof indexedDB < "u")
            return indexedDB;
          if (typeof webkitIndexedDB < "u")
            return webkitIndexedDB;
          if (typeof mozIndexedDB < "u")
            return mozIndexedDB;
          if (typeof OIndexedDB < "u")
            return OIndexedDB;
          if (typeof msIndexedDB < "u")
            return msIndexedDB;
        } catch {
          return;
        }
      }
      var l = a();
      function c() {
        try {
          if (!l || !l.open)
            return !1;
          var M = typeof openDatabase < "u" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), J = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
          return (!M || J) && typeof indexedDB < "u" && // some outdated implementations of IDB that appear on Samsung
          // and HTC Android devices <4.4 are missing IDBKeyRange
          // See: https://github.com/mozilla/localForage/issues/128
          // See: https://github.com/mozilla/localForage/issues/272
          typeof IDBKeyRange < "u";
        } catch {
          return !1;
        }
      }
      function u(M, J) {
        M = M || [], J = J || {};
        try {
          return new Blob(M, J);
        } catch (ie) {
          if (ie.name !== "TypeError")
            throw ie;
          for (var F = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, oe = new F(), ce = 0; ce < M.length; ce += 1)
            oe.append(M[ce]);
          return oe.getBlob(J.type);
        }
      }
      typeof Promise > "u" && n(3);
      var d = Promise;
      function f(M, J) {
        J && M.then(function(F) {
          J(null, F);
        }, function(F) {
          J(F);
        });
      }
      function p(M, J, F) {
        typeof J == "function" && M.then(J), typeof F == "function" && M.catch(F);
      }
      function h(M) {
        return typeof M != "string" && (console.warn(M + " used as a key, but it is not a string."), M = String(M)), M;
      }
      function m() {
        if (arguments.length && typeof arguments[arguments.length - 1] == "function")
          return arguments[arguments.length - 1];
      }
      var v = "local-forage-detect-blob-support", y = void 0, _ = {}, w = Object.prototype.toString, S = "readonly", E = "readwrite";
      function x(M) {
        for (var J = M.length, F = new ArrayBuffer(J), oe = new Uint8Array(F), ce = 0; ce < J; ce++)
          oe[ce] = M.charCodeAt(ce);
        return F;
      }
      function T(M) {
        return new d(function(J) {
          var F = M.transaction(v, E), oe = u([""]);
          F.objectStore(v).put(oe, "key"), F.onabort = function(ce) {
            ce.preventDefault(), ce.stopPropagation(), J(!1);
          }, F.oncomplete = function() {
            var ce = navigator.userAgent.match(/Chrome\/(\d+)/), ie = navigator.userAgent.match(/Edge\//);
            J(ie || !ce || parseInt(ce[1], 10) >= 43);
          };
        }).catch(function() {
          return !1;
        });
      }
      function C(M) {
        return typeof y == "boolean" ? d.resolve(y) : T(M).then(function(J) {
          return y = J, y;
        });
      }
      function k(M) {
        var J = _[M.name], F = {};
        F.promise = new d(function(oe, ce) {
          F.resolve = oe, F.reject = ce;
        }), J.deferredOperations.push(F), J.dbReady ? J.dbReady = J.dbReady.then(function() {
          return F.promise;
        }) : J.dbReady = F.promise;
      }
      function b(M) {
        var J = _[M.name], F = J.deferredOperations.pop();
        if (F)
          return F.resolve(), F.promise;
      }
      function P(M, J) {
        var F = _[M.name], oe = F.deferredOperations.pop();
        if (oe)
          return oe.reject(J), oe.promise;
      }
      function N(M, J) {
        return new d(function(F, oe) {
          if (_[M.name] = _[M.name] || ee(), M.db)
            if (J)
              k(M), M.db.close();
            else
              return F(M.db);
          var ce = [M.name];
          J && ce.push(M.version);
          var ie = l.open.apply(l, ce);
          J && (ie.onupgradeneeded = function(Se) {
            var ke = ie.result;
            try {
              ke.createObjectStore(M.storeName), Se.oldVersion <= 1 && ke.createObjectStore(v);
            } catch (Oe) {
              if (Oe.name === "ConstraintError")
                console.warn('The database "' + M.name + '" has been upgraded from version ' + Se.oldVersion + " to version " + Se.newVersion + ', but the storage "' + M.storeName + '" already exists.');
              else
                throw Oe;
            }
          }), ie.onerror = function(Se) {
            Se.preventDefault(), oe(ie.error);
          }, ie.onsuccess = function() {
            var Se = ie.result;
            Se.onversionchange = function(ke) {
              ke.target.close();
            }, F(Se), b(M);
          };
        });
      }
      function D(M) {
        return N(M, !1);
      }
      function H(M) {
        return N(M, !0);
      }
      function Y(M, J) {
        if (!M.db)
          return !0;
        var F = !M.db.objectStoreNames.contains(M.storeName), oe = M.version < M.db.version, ce = M.version > M.db.version;
        if (oe && (M.version !== J && console.warn('The database "' + M.name + `" can't be downgraded from version ` + M.db.version + " to version " + M.version + "."), M.version = M.db.version), ce || F) {
          if (F) {
            var ie = M.db.version + 1;
            ie > M.version && (M.version = ie);
          }
          return !0;
        }
        return !1;
      }
      function te(M) {
        return new d(function(J, F) {
          var oe = new FileReader();
          oe.onerror = F, oe.onloadend = function(ce) {
            var ie = btoa(ce.target.result || "");
            J({
              __local_forage_encoded_blob: !0,
              data: ie,
              type: M.type
            });
          }, oe.readAsBinaryString(M);
        });
      }
      function A(M) {
        var J = x(atob(M.data));
        return u([J], { type: M.type });
      }
      function j(M) {
        return M && M.__local_forage_encoded_blob;
      }
      function L(M) {
        var J = this, F = J._initReady().then(function() {
          var oe = _[J._dbInfo.name];
          if (oe && oe.dbReady)
            return oe.dbReady;
        });
        return p(F, M, M), F;
      }
      function se(M) {
        k(M);
        for (var J = _[M.name], F = J.forages, oe = 0; oe < F.length; oe++) {
          var ce = F[oe];
          ce._dbInfo.db && (ce._dbInfo.db.close(), ce._dbInfo.db = null);
        }
        return M.db = null, D(M).then(function(ie) {
          return M.db = ie, Y(M) ? H(M) : ie;
        }).then(function(ie) {
          M.db = J.db = ie;
          for (var Se = 0; Se < F.length; Se++)
            F[Se]._dbInfo.db = ie;
        }).catch(function(ie) {
          throw P(M, ie), ie;
        });
      }
      function V(M, J, F, oe) {
        oe === void 0 && (oe = 1);
        try {
          var ce = M.db.transaction(M.storeName, J);
          F(null, ce);
        } catch (ie) {
          if (oe > 0 && (!M.db || ie.name === "InvalidStateError" || ie.name === "NotFoundError"))
            return d.resolve().then(function() {
              if (!M.db || ie.name === "NotFoundError" && !M.db.objectStoreNames.contains(M.storeName) && M.version <= M.db.version)
                return M.db && (M.version = M.db.version + 1), H(M);
            }).then(function() {
              return se(M).then(function() {
                V(M, J, F, oe - 1);
              });
            }).catch(F);
          F(ie);
        }
      }
      function ee() {
        return {
          // Running localForages sharing a database.
          forages: [],
          // Shared database.
          db: null,
          // Database readiness (promise).
          dbReady: null,
          // Deferred operations on the database.
          deferredOperations: []
        };
      }
      function O(M) {
        var J = this, F = {
          db: null
        };
        if (M)
          for (var oe in M)
            F[oe] = M[oe];
        var ce = _[F.name];
        ce || (ce = ee(), _[F.name] = ce), ce.forages.push(J), J._initReady || (J._initReady = J.ready, J.ready = L);
        var ie = [];
        function Se() {
          return d.resolve();
        }
        for (var ke = 0; ke < ce.forages.length; ke++) {
          var Oe = ce.forages[ke];
          Oe !== J && ie.push(Oe._initReady().catch(Se));
        }
        var Re = ce.forages.slice(0);
        return d.all(ie).then(function() {
          return F.db = ce.db, D(F);
        }).then(function(fe) {
          return F.db = fe, Y(F, J._defaultConfig.version) ? H(F) : fe;
        }).then(function(fe) {
          F.db = ce.db = fe, J._dbInfo = F;
          for (var Pe = 0; Pe < Re.length; Pe++) {
            var Ct = Re[Pe];
            Ct !== J && (Ct._dbInfo.db = F.db, Ct._dbInfo.version = F.version);
          }
        });
      }
      function K(M, J) {
        var F = this;
        M = h(M);
        var oe = new d(function(ce, ie) {
          F.ready().then(function() {
            V(F._dbInfo, S, function(Se, ke) {
              if (Se)
                return ie(Se);
              try {
                var Oe = ke.objectStore(F._dbInfo.storeName), Re = Oe.get(M);
                Re.onsuccess = function() {
                  var fe = Re.result;
                  fe === void 0 && (fe = null), j(fe) && (fe = A(fe)), ce(fe);
                }, Re.onerror = function() {
                  ie(Re.error);
                };
              } catch (fe) {
                ie(fe);
              }
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function z(M, J) {
        var F = this, oe = new d(function(ce, ie) {
          F.ready().then(function() {
            V(F._dbInfo, S, function(Se, ke) {
              if (Se)
                return ie(Se);
              try {
                var Oe = ke.objectStore(F._dbInfo.storeName), Re = Oe.openCursor(), fe = 1;
                Re.onsuccess = function() {
                  var Pe = Re.result;
                  if (Pe) {
                    var Ct = Pe.value;
                    j(Ct) && (Ct = A(Ct));
                    var zt = M(Ct, Pe.key, fe++);
                    zt !== void 0 ? ce(zt) : Pe.continue();
                  } else
                    ce();
                }, Re.onerror = function() {
                  ie(Re.error);
                };
              } catch (Pe) {
                ie(Pe);
              }
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function q(M, J, F) {
        var oe = this;
        M = h(M);
        var ce = new d(function(ie, Se) {
          var ke;
          oe.ready().then(function() {
            return ke = oe._dbInfo, w.call(J) === "[object Blob]" ? C(ke.db).then(function(Oe) {
              return Oe ? J : te(J);
            }) : J;
          }).then(function(Oe) {
            V(oe._dbInfo, E, function(Re, fe) {
              if (Re)
                return Se(Re);
              try {
                var Pe = fe.objectStore(oe._dbInfo.storeName);
                Oe === null && (Oe = void 0);
                var Ct = Pe.put(Oe, M);
                fe.oncomplete = function() {
                  Oe === void 0 && (Oe = null), ie(Oe);
                }, fe.onabort = fe.onerror = function() {
                  var zt = Ct.error ? Ct.error : Ct.transaction.error;
                  Se(zt);
                };
              } catch (zt) {
                Se(zt);
              }
            });
          }).catch(Se);
        });
        return f(ce, F), ce;
      }
      function ae(M, J) {
        var F = this;
        M = h(M);
        var oe = new d(function(ce, ie) {
          F.ready().then(function() {
            V(F._dbInfo, E, function(Se, ke) {
              if (Se)
                return ie(Se);
              try {
                var Oe = ke.objectStore(F._dbInfo.storeName), Re = Oe.delete(M);
                ke.oncomplete = function() {
                  ce();
                }, ke.onerror = function() {
                  ie(Re.error);
                }, ke.onabort = function() {
                  var fe = Re.error ? Re.error : Re.transaction.error;
                  ie(fe);
                };
              } catch (fe) {
                ie(fe);
              }
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function Ee(M) {
        var J = this, F = new d(function(oe, ce) {
          J.ready().then(function() {
            V(J._dbInfo, E, function(ie, Se) {
              if (ie)
                return ce(ie);
              try {
                var ke = Se.objectStore(J._dbInfo.storeName), Oe = ke.clear();
                Se.oncomplete = function() {
                  oe();
                }, Se.onabort = Se.onerror = function() {
                  var Re = Oe.error ? Oe.error : Oe.transaction.error;
                  ce(Re);
                };
              } catch (Re) {
                ce(Re);
              }
            });
          }).catch(ce);
        });
        return f(F, M), F;
      }
      function Ae(M) {
        var J = this, F = new d(function(oe, ce) {
          J.ready().then(function() {
            V(J._dbInfo, S, function(ie, Se) {
              if (ie)
                return ce(ie);
              try {
                var ke = Se.objectStore(J._dbInfo.storeName), Oe = ke.count();
                Oe.onsuccess = function() {
                  oe(Oe.result);
                }, Oe.onerror = function() {
                  ce(Oe.error);
                };
              } catch (Re) {
                ce(Re);
              }
            });
          }).catch(ce);
        });
        return f(F, M), F;
      }
      function Ue(M, J) {
        var F = this, oe = new d(function(ce, ie) {
          if (M < 0) {
            ce(null);
            return;
          }
          F.ready().then(function() {
            V(F._dbInfo, S, function(Se, ke) {
              if (Se)
                return ie(Se);
              try {
                var Oe = ke.objectStore(F._dbInfo.storeName), Re = !1, fe = Oe.openKeyCursor();
                fe.onsuccess = function() {
                  var Pe = fe.result;
                  if (!Pe) {
                    ce(null);
                    return;
                  }
                  M === 0 || Re ? ce(Pe.key) : (Re = !0, Pe.advance(M));
                }, fe.onerror = function() {
                  ie(fe.error);
                };
              } catch (Pe) {
                ie(Pe);
              }
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function qe(M) {
        var J = this, F = new d(function(oe, ce) {
          J.ready().then(function() {
            V(J._dbInfo, S, function(ie, Se) {
              if (ie)
                return ce(ie);
              try {
                var ke = Se.objectStore(J._dbInfo.storeName), Oe = ke.openKeyCursor(), Re = [];
                Oe.onsuccess = function() {
                  var fe = Oe.result;
                  if (!fe) {
                    oe(Re);
                    return;
                  }
                  Re.push(fe.key), fe.continue();
                }, Oe.onerror = function() {
                  ce(Oe.error);
                };
              } catch (fe) {
                ce(fe);
              }
            });
          }).catch(ce);
        });
        return f(F, M), F;
      }
      function Qe(M, J) {
        J = m.apply(this, arguments);
        var F = this.config();
        M = typeof M != "function" && M || {}, M.name || (M.name = M.name || F.name, M.storeName = M.storeName || F.storeName);
        var oe = this, ce;
        if (!M.name)
          ce = d.reject("Invalid arguments");
        else {
          var ie = M.name === F.name && oe._dbInfo.db, Se = ie ? d.resolve(oe._dbInfo.db) : D(M).then(function(ke) {
            var Oe = _[M.name], Re = Oe.forages;
            Oe.db = ke;
            for (var fe = 0; fe < Re.length; fe++)
              Re[fe]._dbInfo.db = ke;
            return ke;
          });
          M.storeName ? ce = Se.then(function(ke) {
            if (ke.objectStoreNames.contains(M.storeName)) {
              var Oe = ke.version + 1;
              k(M);
              var Re = _[M.name], fe = Re.forages;
              ke.close();
              for (var Pe = 0; Pe < fe.length; Pe++) {
                var Ct = fe[Pe];
                Ct._dbInfo.db = null, Ct._dbInfo.version = Oe;
              }
              var zt = new d(function(bt, On) {
                var hn = l.open(M.name, Oe);
                hn.onerror = function(Ur) {
                  var Qi = hn.result;
                  Qi.close(), On(Ur);
                }, hn.onupgradeneeded = function() {
                  var Ur = hn.result;
                  Ur.deleteObjectStore(M.storeName);
                }, hn.onsuccess = function() {
                  var Ur = hn.result;
                  Ur.close(), bt(Ur);
                };
              });
              return zt.then(function(bt) {
                Re.db = bt;
                for (var On = 0; On < fe.length; On++) {
                  var hn = fe[On];
                  hn._dbInfo.db = bt, b(hn._dbInfo);
                }
              }).catch(function(bt) {
                throw (P(M, bt) || d.resolve()).catch(function() {
                }), bt;
              });
            }
          }) : ce = Se.then(function(ke) {
            k(M);
            var Oe = _[M.name], Re = Oe.forages;
            ke.close();
            for (var fe = 0; fe < Re.length; fe++) {
              var Pe = Re[fe];
              Pe._dbInfo.db = null;
            }
            var Ct = new d(function(zt, bt) {
              var On = l.deleteDatabase(M.name);
              On.onerror = function() {
                var hn = On.result;
                hn && hn.close(), bt(On.error);
              }, On.onblocked = function() {
                console.warn('dropInstance blocked for database "' + M.name + '" until all open connections are closed');
              }, On.onsuccess = function() {
                var hn = On.result;
                hn && hn.close(), zt(hn);
              };
            });
            return Ct.then(function(zt) {
              Oe.db = zt;
              for (var bt = 0; bt < Re.length; bt++) {
                var On = Re[bt];
                b(On._dbInfo);
              }
            }).catch(function(zt) {
              throw (P(M, zt) || d.resolve()).catch(function() {
              }), zt;
            });
          });
        }
        return f(ce, J), ce;
      }
      var Lt = {
        _driver: "asyncStorage",
        _initStorage: O,
        _support: c(),
        iterate: z,
        getItem: K,
        setItem: q,
        removeItem: ae,
        clear: Ee,
        length: Ae,
        key: Ue,
        keys: qe,
        dropInstance: Qe
      };
      function Yt() {
        return typeof openDatabase == "function";
      }
      var nn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", qt = "~~local_forage_type~", rn = /^~~local_forage_type~([^~]+)~/, sn = "__lfsc__:", zn = sn.length, ns = "arbf", Nt = "blob", dt = "si08", xt = "ui08", Wt = "uic8", Tt = "si16", _r = "si32", dr = "ur16", qn = "ui32", yn = "fl32", Ve = "fl64", Ze = zn + ns.length, it = Object.prototype.toString;
      function St(M) {
        var J = M.length * 0.75, F = M.length, oe, ce = 0, ie, Se, ke, Oe;
        M[M.length - 1] === "=" && (J--, M[M.length - 2] === "=" && J--);
        var Re = new ArrayBuffer(J), fe = new Uint8Array(Re);
        for (oe = 0; oe < F; oe += 4)
          ie = nn.indexOf(M[oe]), Se = nn.indexOf(M[oe + 1]), ke = nn.indexOf(M[oe + 2]), Oe = nn.indexOf(M[oe + 3]), fe[ce++] = ie << 2 | Se >> 4, fe[ce++] = (Se & 15) << 4 | ke >> 2, fe[ce++] = (ke & 3) << 6 | Oe & 63;
        return Re;
      }
      function ze(M) {
        var J = new Uint8Array(M), F = "", oe;
        for (oe = 0; oe < J.length; oe += 3)
          F += nn[J[oe] >> 2], F += nn[(J[oe] & 3) << 4 | J[oe + 1] >> 4], F += nn[(J[oe + 1] & 15) << 2 | J[oe + 2] >> 6], F += nn[J[oe + 2] & 63];
        return J.length % 3 === 2 ? F = F.substring(0, F.length - 1) + "=" : J.length % 3 === 1 && (F = F.substring(0, F.length - 2) + "=="), F;
      }
      function $t(M, J) {
        var F = "";
        if (M && (F = it.call(M)), M && (F === "[object ArrayBuffer]" || M.buffer && it.call(M.buffer) === "[object ArrayBuffer]")) {
          var oe, ce = sn;
          M instanceof ArrayBuffer ? (oe = M, ce += ns) : (oe = M.buffer, F === "[object Int8Array]" ? ce += dt : F === "[object Uint8Array]" ? ce += xt : F === "[object Uint8ClampedArray]" ? ce += Wt : F === "[object Int16Array]" ? ce += Tt : F === "[object Uint16Array]" ? ce += dr : F === "[object Int32Array]" ? ce += _r : F === "[object Uint32Array]" ? ce += qn : F === "[object Float32Array]" ? ce += yn : F === "[object Float64Array]" ? ce += Ve : J(new Error("Failed to get type for BinaryArray"))), J(ce + ze(oe));
        } else if (F === "[object Blob]") {
          var ie = new FileReader();
          ie.onload = function() {
            var Se = qt + M.type + "~" + ze(this.result);
            J(sn + Nt + Se);
          }, ie.readAsArrayBuffer(M);
        } else
          try {
            J(JSON.stringify(M));
          } catch (Se) {
            console.error("Couldn't convert value into a JSON string: ", M), J(null, Se);
          }
      }
      function Fs(M) {
        if (M.substring(0, zn) !== sn)
          return JSON.parse(M);
        var J = M.substring(Ze), F = M.substring(zn, Ze), oe;
        if (F === Nt && rn.test(J)) {
          var ce = J.match(rn);
          oe = ce[1], J = J.substring(ce[0].length);
        }
        var ie = St(J);
        switch (F) {
          case ns:
            return ie;
          case Nt:
            return u([ie], { type: oe });
          case dt:
            return new Int8Array(ie);
          case xt:
            return new Uint8Array(ie);
          case Wt:
            return new Uint8ClampedArray(ie);
          case Tt:
            return new Int16Array(ie);
          case dr:
            return new Uint16Array(ie);
          case _r:
            return new Int32Array(ie);
          case qn:
            return new Uint32Array(ie);
          case yn:
            return new Float32Array(ie);
          case Ve:
            return new Float64Array(ie);
          default:
            throw new Error("Unkown type: " + F);
        }
      }
      var zs = {
        serialize: $t,
        deserialize: Fs,
        stringToBuffer: St,
        bufferToString: ze
      };
      function fr(M, J, F, oe) {
        M.executeSql("CREATE TABLE IF NOT EXISTS " + J.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], F, oe);
      }
      function ln(M) {
        var J = this, F = {
          db: null
        };
        if (M)
          for (var oe in M)
            F[oe] = typeof M[oe] != "string" ? M[oe].toString() : M[oe];
        var ce = new d(function(ie, Se) {
          try {
            F.db = openDatabase(F.name, String(F.version), F.description, F.size);
          } catch (ke) {
            return Se(ke);
          }
          F.db.transaction(function(ke) {
            fr(ke, F, function() {
              J._dbInfo = F, ie();
            }, function(Oe, Re) {
              Se(Re);
            });
          }, Se);
        });
        return F.serializer = zs, ce;
      }
      function wn(M, J, F, oe, ce, ie) {
        M.executeSql(F, oe, ce, function(Se, ke) {
          ke.code === ke.SYNTAX_ERR ? Se.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [J.storeName], function(Oe, Re) {
            Re.rows.length ? ie(Oe, ke) : fr(Oe, J, function() {
              Oe.executeSql(F, oe, ce, ie);
            }, ie);
          }, ie) : ie(Se, ke);
        }, ie);
      }
      function sa(M, J) {
        var F = this;
        M = h(M);
        var oe = new d(function(ce, ie) {
          F.ready().then(function() {
            var Se = F._dbInfo;
            Se.db.transaction(function(ke) {
              wn(ke, Se, "SELECT * FROM " + Se.storeName + " WHERE key = ? LIMIT 1", [M], function(Oe, Re) {
                var fe = Re.rows.length ? Re.rows.item(0).value : null;
                fe && (fe = Se.serializer.deserialize(fe)), ce(fe);
              }, function(Oe, Re) {
                ie(Re);
              });
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function ws(M, J) {
        var F = this, oe = new d(function(ce, ie) {
          F.ready().then(function() {
            var Se = F._dbInfo;
            Se.db.transaction(function(ke) {
              wn(ke, Se, "SELECT * FROM " + Se.storeName, [], function(Oe, Re) {
                for (var fe = Re.rows, Pe = fe.length, Ct = 0; Ct < Pe; Ct++) {
                  var zt = fe.item(Ct), bt = zt.value;
                  if (bt && (bt = Se.serializer.deserialize(bt)), bt = M(bt, zt.key, Ct + 1), bt !== void 0) {
                    ce(bt);
                    return;
                  }
                }
                ce();
              }, function(Oe, Re) {
                ie(Re);
              });
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function ia(M, J, F, oe) {
        var ce = this;
        M = h(M);
        var ie = new d(function(Se, ke) {
          ce.ready().then(function() {
            J === void 0 && (J = null);
            var Oe = J, Re = ce._dbInfo;
            Re.serializer.serialize(J, function(fe, Pe) {
              Pe ? ke(Pe) : Re.db.transaction(function(Ct) {
                wn(Ct, Re, "INSERT OR REPLACE INTO " + Re.storeName + " (key, value) VALUES (?, ?)", [M, fe], function() {
                  Se(Oe);
                }, function(zt, bt) {
                  ke(bt);
                });
              }, function(Ct) {
                if (Ct.code === Ct.QUOTA_ERR) {
                  if (oe > 0) {
                    Se(ia.apply(ce, [M, Oe, F, oe - 1]));
                    return;
                  }
                  ke(Ct);
                }
              });
            });
          }).catch(ke);
        });
        return f(ie, F), ie;
      }
      function oa(M, J, F) {
        return ia.apply(this, [M, J, F, 1]);
      }
      function An(M, J) {
        var F = this;
        M = h(M);
        var oe = new d(function(ce, ie) {
          F.ready().then(function() {
            var Se = F._dbInfo;
            Se.db.transaction(function(ke) {
              wn(ke, Se, "DELETE FROM " + Se.storeName + " WHERE key = ?", [M], function() {
                ce();
              }, function(Oe, Re) {
                ie(Re);
              });
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function Us(M) {
        var J = this, F = new d(function(oe, ce) {
          J.ready().then(function() {
            var ie = J._dbInfo;
            ie.db.transaction(function(Se) {
              wn(Se, ie, "DELETE FROM " + ie.storeName, [], function() {
                oe();
              }, function(ke, Oe) {
                ce(Oe);
              });
            });
          }).catch(ce);
        });
        return f(F, M), F;
      }
      function pr(M) {
        var J = this, F = new d(function(oe, ce) {
          J.ready().then(function() {
            var ie = J._dbInfo;
            ie.db.transaction(function(Se) {
              wn(Se, ie, "SELECT COUNT(key) as c FROM " + ie.storeName, [], function(ke, Oe) {
                var Re = Oe.rows.item(0).c;
                oe(Re);
              }, function(ke, Oe) {
                ce(Oe);
              });
            });
          }).catch(ce);
        });
        return f(F, M), F;
      }
      function aa(M, J) {
        var F = this, oe = new d(function(ce, ie) {
          F.ready().then(function() {
            var Se = F._dbInfo;
            Se.db.transaction(function(ke) {
              wn(ke, Se, "SELECT key FROM " + Se.storeName + " WHERE id = ? LIMIT 1", [M + 1], function(Oe, Re) {
                var fe = Re.rows.length ? Re.rows.item(0).key : null;
                ce(fe);
              }, function(Oe, Re) {
                ie(Re);
              });
            });
          }).catch(ie);
        });
        return f(oe, J), oe;
      }
      function No(M) {
        var J = this, F = new d(function(oe, ce) {
          J.ready().then(function() {
            var ie = J._dbInfo;
            ie.db.transaction(function(Se) {
              wn(Se, ie, "SELECT key FROM " + ie.storeName, [], function(ke, Oe) {
                for (var Re = [], fe = 0; fe < Oe.rows.length; fe++)
                  Re.push(Oe.rows.item(fe).key);
                oe(Re);
              }, function(ke, Oe) {
                ce(Oe);
              });
            });
          }).catch(ce);
        });
        return f(F, M), F;
      }
      function $o(M) {
        return new d(function(J, F) {
          M.transaction(function(oe) {
            oe.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(ce, ie) {
              for (var Se = [], ke = 0; ke < ie.rows.length; ke++)
                Se.push(ie.rows.item(ke).name);
              J({
                db: M,
                storeNames: Se
              });
            }, function(ce, ie) {
              F(ie);
            });
          }, function(oe) {
            F(oe);
          });
        });
      }
      function Zt(M, J) {
        J = m.apply(this, arguments);
        var F = this.config();
        M = typeof M != "function" && M || {}, M.name || (M.name = M.name || F.name, M.storeName = M.storeName || F.storeName);
        var oe = this, ce;
        return M.name ? ce = new d(function(ie) {
          var Se;
          M.name === F.name ? Se = oe._dbInfo.db : Se = openDatabase(M.name, "", "", 0), M.storeName ? ie({
            db: Se,
            storeNames: [M.storeName]
          }) : ie($o(Se));
        }).then(function(ie) {
          return new d(function(Se, ke) {
            ie.db.transaction(function(Oe) {
              function Re(zt) {
                return new d(function(bt, On) {
                  Oe.executeSql("DROP TABLE IF EXISTS " + zt, [], function() {
                    bt();
                  }, function(hn, Ur) {
                    On(Ur);
                  });
                });
              }
              for (var fe = [], Pe = 0, Ct = ie.storeNames.length; Pe < Ct; Pe++)
                fe.push(Re(ie.storeNames[Pe]));
              d.all(fe).then(function() {
                Se();
              }).catch(function(zt) {
                ke(zt);
              });
            }, function(Oe) {
              ke(Oe);
            });
          });
        }) : ce = d.reject("Invalid arguments"), f(ce, J), ce;
      }
      var ul = {
        _driver: "webSQLStorage",
        _initStorage: ln,
        _support: Yt(),
        iterate: ws,
        getItem: sa,
        setItem: oa,
        removeItem: An,
        clear: Us,
        length: pr,
        key: aa,
        keys: No,
        dropInstance: Zt
      };
      function rs() {
        try {
          return typeof localStorage < "u" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
          !!localStorage.setItem;
        } catch {
          return !1;
        }
      }
      function X(M, J) {
        var F = M.name + "/";
        return M.storeName !== J.storeName && (F += M.storeName + "/"), F;
      }
      function R() {
        var M = "_localforage_support_test";
        try {
          return localStorage.setItem(M, !0), localStorage.removeItem(M), !1;
        } catch {
          return !0;
        }
      }
      function Z() {
        return !R() || localStorage.length > 0;
      }
      function ne(M) {
        var J = this, F = {};
        if (M)
          for (var oe in M)
            F[oe] = M[oe];
        return F.keyPrefix = X(M, J._defaultConfig), Z() ? (J._dbInfo = F, F.serializer = zs, d.resolve()) : d.reject();
      }
      function we(M) {
        var J = this, F = J.ready().then(function() {
          for (var oe = J._dbInfo.keyPrefix, ce = localStorage.length - 1; ce >= 0; ce--) {
            var ie = localStorage.key(ce);
            ie.indexOf(oe) === 0 && localStorage.removeItem(ie);
          }
        });
        return f(F, M), F;
      }
      function be(M, J) {
        var F = this;
        M = h(M);
        var oe = F.ready().then(function() {
          var ce = F._dbInfo, ie = localStorage.getItem(ce.keyPrefix + M);
          return ie && (ie = ce.serializer.deserialize(ie)), ie;
        });
        return f(oe, J), oe;
      }
      function Le(M, J) {
        var F = this, oe = F.ready().then(function() {
          for (var ce = F._dbInfo, ie = ce.keyPrefix, Se = ie.length, ke = localStorage.length, Oe = 1, Re = 0; Re < ke; Re++) {
            var fe = localStorage.key(Re);
            if (fe.indexOf(ie) === 0) {
              var Pe = localStorage.getItem(fe);
              if (Pe && (Pe = ce.serializer.deserialize(Pe)), Pe = M(Pe, fe.substring(Se), Oe++), Pe !== void 0)
                return Pe;
            }
          }
        });
        return f(oe, J), oe;
      }
      function Xe(M, J) {
        var F = this, oe = F.ready().then(function() {
          var ce = F._dbInfo, ie;
          try {
            ie = localStorage.key(M);
          } catch {
            ie = null;
          }
          return ie && (ie = ie.substring(ce.keyPrefix.length)), ie;
        });
        return f(oe, J), oe;
      }
      function je(M) {
        var J = this, F = J.ready().then(function() {
          for (var oe = J._dbInfo, ce = localStorage.length, ie = [], Se = 0; Se < ce; Se++) {
            var ke = localStorage.key(Se);
            ke.indexOf(oe.keyPrefix) === 0 && ie.push(ke.substring(oe.keyPrefix.length));
          }
          return ie;
        });
        return f(F, M), F;
      }
      function vt(M) {
        var J = this, F = J.keys().then(function(oe) {
          return oe.length;
        });
        return f(F, M), F;
      }
      function Pt(M, J) {
        var F = this;
        M = h(M);
        var oe = F.ready().then(function() {
          var ce = F._dbInfo;
          localStorage.removeItem(ce.keyPrefix + M);
        });
        return f(oe, J), oe;
      }
      function De(M, J, F) {
        var oe = this;
        M = h(M);
        var ce = oe.ready().then(function() {
          J === void 0 && (J = null);
          var ie = J;
          return new d(function(Se, ke) {
            var Oe = oe._dbInfo;
            Oe.serializer.serialize(J, function(Re, fe) {
              if (fe)
                ke(fe);
              else
                try {
                  localStorage.setItem(Oe.keyPrefix + M, Re), Se(ie);
                } catch (Pe) {
                  (Pe.name === "QuotaExceededError" || Pe.name === "NS_ERROR_DOM_QUOTA_REACHED") && ke(Pe), ke(Pe);
                }
            });
          });
        });
        return f(ce, F), ce;
      }
      function Q(M, J) {
        if (J = m.apply(this, arguments), M = typeof M != "function" && M || {}, !M.name) {
          var F = this.config();
          M.name = M.name || F.name, M.storeName = M.storeName || F.storeName;
        }
        var oe = this, ce;
        return M.name ? ce = new d(function(ie) {
          M.storeName ? ie(X(M, oe._defaultConfig)) : ie(M.name + "/");
        }).then(function(ie) {
          for (var Se = localStorage.length - 1; Se >= 0; Se--) {
            var ke = localStorage.key(Se);
            ke.indexOf(ie) === 0 && localStorage.removeItem(ke);
          }
        }) : ce = d.reject("Invalid arguments"), f(ce, J), ce;
      }
      var _e = {
        _driver: "localStorageWrapper",
        _initStorage: ne,
        _support: rs(),
        iterate: Le,
        getItem: be,
        setItem: De,
        removeItem: Pt,
        clear: we,
        length: vt,
        key: Xe,
        keys: je,
        dropInstance: Q
      }, Be = function(J, F) {
        return J === F || typeof J == "number" && typeof F == "number" && isNaN(J) && isNaN(F);
      }, Ht = function(J, F) {
        for (var oe = J.length, ce = 0; ce < oe; ) {
          if (Be(J[ce], F))
            return !0;
          ce++;
        }
        return !1;
      }, at = Array.isArray || function(M) {
        return Object.prototype.toString.call(M) === "[object Array]";
      }, Vt = {}, pn = {}, bn = {
        INDEXEDDB: Lt,
        WEBSQL: ul,
        LOCALSTORAGE: _e
      }, zr = [bn.INDEXEDDB._driver, bn.WEBSQL._driver, bn.LOCALSTORAGE._driver], _n = ["dropInstance"], wr = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(_n), Bs = {
        description: "",
        driver: zr.slice(),
        name: "localforage",
        // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
        // we can use without a prompt.
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };
      function dl(M, J) {
        M[J] = function() {
          var F = arguments;
          return M.ready().then(function() {
            return M[J].apply(M, F);
          });
        };
      }
      function fl() {
        for (var M = 1; M < arguments.length; M++) {
          var J = arguments[M];
          if (J)
            for (var F in J)
              J.hasOwnProperty(F) && (at(J[F]) ? arguments[0][F] = J[F].slice() : arguments[0][F] = J[F]);
        }
        return arguments[0];
      }
      var Zu = function() {
        function M(J) {
          o(this, M);
          for (var F in bn)
            if (bn.hasOwnProperty(F)) {
              var oe = bn[F], ce = oe._driver;
              this[F] = ce, Vt[ce] || this.defineDriver(oe);
            }
          this._defaultConfig = fl({}, Bs), this._config = fl({}, this._defaultConfig, J), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function() {
          });
        }
        return M.prototype.config = function(F) {
          if ((typeof F > "u" ? "undefined" : i(F)) === "object") {
            if (this._ready)
              return new Error("Can't call config() after localforage has been used.");
            for (var oe in F) {
              if (oe === "storeName" && (F[oe] = F[oe].replace(/\W/g, "_")), oe === "version" && typeof F[oe] != "number")
                return new Error("Database version must be a number.");
              this._config[oe] = F[oe];
            }
            return "driver" in F && F.driver ? this.setDriver(this._config.driver) : !0;
          } else return typeof F == "string" ? this._config[F] : this._config;
        }, M.prototype.defineDriver = function(F, oe, ce) {
          var ie = new d(function(Se, ke) {
            try {
              var Oe = F._driver, Re = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!F._driver) {
                ke(Re);
                return;
              }
              for (var fe = wr.concat("_initStorage"), Pe = 0, Ct = fe.length; Pe < Ct; Pe++) {
                var zt = fe[Pe], bt = !Ht(_n, zt);
                if ((bt || F[zt]) && typeof F[zt] != "function") {
                  ke(Re);
                  return;
                }
              }
              var On = function() {
                for (var Qi = function(bg) {
                  return function() {
                    var ep = new Error("Method " + bg + " is not implemented by the current driver"), Gs = d.reject(ep);
                    return f(Gs, arguments[arguments.length - 1]), Gs;
                  };
                }, gc = 0, yg = _n.length; gc < yg; gc++) {
                  var Ku = _n[gc];
                  F[Ku] || (F[Ku] = Qi(Ku));
                }
              };
              On();
              var hn = function(Qi) {
                Vt[Oe] && console.info("Redefining LocalForage driver: " + Oe), Vt[Oe] = F, pn[Oe] = Qi, Se();
              };
              "_support" in F ? F._support && typeof F._support == "function" ? F._support().then(hn, ke) : hn(!!F._support) : hn(!0);
            } catch (Ur) {
              ke(Ur);
            }
          });
          return p(ie, oe, ce), ie;
        }, M.prototype.driver = function() {
          return this._driver || null;
        }, M.prototype.getDriver = function(F, oe, ce) {
          var ie = Vt[F] ? d.resolve(Vt[F]) : d.reject(new Error("Driver not found."));
          return p(ie, oe, ce), ie;
        }, M.prototype.getSerializer = function(F) {
          var oe = d.resolve(zs);
          return p(oe, F), oe;
        }, M.prototype.ready = function(F) {
          var oe = this, ce = oe._driverSet.then(function() {
            return oe._ready === null && (oe._ready = oe._initDriver()), oe._ready;
          });
          return p(ce, F, F), ce;
        }, M.prototype.setDriver = function(F, oe, ce) {
          var ie = this;
          at(F) || (F = [F]);
          var Se = this._getSupportedDrivers(F);
          function ke() {
            ie._config.driver = ie.driver();
          }
          function Oe(Pe) {
            return ie._extend(Pe), ke(), ie._ready = ie._initStorage(ie._config), ie._ready;
          }
          function Re(Pe) {
            return function() {
              var Ct = 0;
              function zt() {
                for (; Ct < Pe.length; ) {
                  var bt = Pe[Ct];
                  return Ct++, ie._dbInfo = null, ie._ready = null, ie.getDriver(bt).then(Oe).catch(zt);
                }
                ke();
                var On = new Error("No available storage method found.");
                return ie._driverSet = d.reject(On), ie._driverSet;
              }
              return zt();
            };
          }
          var fe = this._driverSet !== null ? this._driverSet.catch(function() {
            return d.resolve();
          }) : d.resolve();
          return this._driverSet = fe.then(function() {
            var Pe = Se[0];
            return ie._dbInfo = null, ie._ready = null, ie.getDriver(Pe).then(function(Ct) {
              ie._driver = Ct._driver, ke(), ie._wrapLibraryMethodsWithReady(), ie._initDriver = Re(Se);
            });
          }).catch(function() {
            ke();
            var Pe = new Error("No available storage method found.");
            return ie._driverSet = d.reject(Pe), ie._driverSet;
          }), p(this._driverSet, oe, ce), this._driverSet;
        }, M.prototype.supports = function(F) {
          return !!pn[F];
        }, M.prototype._extend = function(F) {
          fl(this, F);
        }, M.prototype._getSupportedDrivers = function(F) {
          for (var oe = [], ce = 0, ie = F.length; ce < ie; ce++) {
            var Se = F[ce];
            this.supports(Se) && oe.push(Se);
          }
          return oe;
        }, M.prototype._wrapLibraryMethodsWithReady = function() {
          for (var F = 0, oe = wr.length; F < oe; F++)
            dl(this, wr[F]);
        }, M.prototype.createInstance = function(F) {
          return new M(F);
        }, M;
      }(), Xu = new Zu();
      r.exports = Xu;
    }, { 3: 3 }] }, {}, [4])(4);
  });
})(P8);
var sUe = P8.exports;
const wl = /* @__PURE__ */ Et(sUe), iUe = el.getParser(globalThis.navigator.userAgent);
function oUe() {
  let t;
  return iUe.isEngine("webkit") ? t = {
    name: "publishing",
    driver: [
      wl.INDEXEDDB,
      wl.LOCALSTORAGE,
      wl.WEBSQL
    ],
    storeName: "publishing",
    description: "Database to store publishing data"
  } : t = {
    name: "publishing",
    driver: [
      wl.INDEXEDDB,
      wl.WEBSQL,
      wl.LOCALSTORAGE
    ],
    storeName: "publishing",
    description: "Database to store publishing data"
  }, wl.createInstance(t);
}
function pd(t = !0) {
  let e;
  return t === !1 ? e = sessionStorage : e = localStorage, {
    setItem(n, r) {
      return new Promise((s, i) => {
        try {
          e.setItem(n, r), s();
        } catch (o) {
          i(o);
        }
      });
    },
    getItem(n) {
      return new Promise((r, s) => {
        try {
          const i = e.getItem(n);
          r(i);
        } catch (i) {
          s(i);
        }
      });
    },
    clear() {
      return new Promise((n, r) => {
        try {
          e.clear(), n();
        } catch (s) {
          r(s);
        }
      });
    },
    ready() {
      return Promise.resolve();
    }
  };
}
const ni = {
  auth: {
    credsStorage: pd(!0),
    /**
     * Содержит промис, который указывает на состояние обновления токена.
     * Все запросы ожидают разрешения этого промиса.
     * Служит для создания очереди запросов, чтобы обновление токена не происходило несколько раз
     * @type {Promise}
     */
    refresh: Promise.resolve(null),
    init(t) {
      t === !0 ? this.credsStorage = pd(!0) : t === !1 ? this.credsStorage = pd(!1) : sessionStorage.getItem("accessToken") ? this.credsStorage = pd(!1) : this.credsStorage = pd(!0);
    },
    /**
     * @return {number} Id пользователя из локального хранилища
     */
    get userId() {
      return this.credsStorage.ready().then(() => this.credsStorage.getItem("userId"));
    },
    /**
     * @return {boolean} Флаг, указывающий авторизован ли пользователь
     */
    get isAuthorized() {
      return this.credsStorage.ready().then(
        () => Promise.all([
          this.credsStorage.getItem("userId"),
          this.credsStorage.getItem("accessToken")
        ]).then(
          (t) => !!(t[0] !== null && t[0] !== void 0 && t[1])
        )
      );
    },
    /**
     * @return {string} access_token пользователя из локального хранилища
     */
    get accessToken() {
      return this.credsStorage.ready().then(() => this.credsStorage.getItem("accessToken"));
    },
    /**
     * @return {string} refresh_token пользователя из локального хранилища
     */
    get refreshToken() {
      return this.credsStorage.ready().then(() => this.credsStorage.getItem("refreshToken"));
    },
    /**
     * @return {string} Имя пользователя из локального хранилища
     */
    get userLogin() {
      return this.credsStorage.ready().then(() => this.credsStorage.getItem("login"));
    },
    /**
     * @return {Array} Список кодов доступа, определяющих, какие элементы интерфейса доступны пользователю
     */
    get permissions() {
      return this.credsStorage.ready().then(
        () => this.credsStorage.getItem("permissions").then((t) => t ? t.split(",") : [])
      );
    },
    /**
     * @return {boolean} Флаг, указывающий сохранять ли авторизацию между сессиями из локального хранилища
     */
    get keepLoggedIn() {
      return this.credsStorage.ready().then(() => this.credsStorage.getItem("keepLoggedIn"));
    },
    /**
     * @return {Object} объект из локального хранилища содержащий все данные авторизации
     */
    get userData() {
      return Promise.all([
        this.userId,
        this.accessToken,
        this.refreshToken,
        this.userLogin,
        this.keepLoggedIn,
        this.isAuthorized,
        this.permissions
      ]).then((t) => ({
        userId: t[0],
        accessToken: t[1],
        refreshToken: t[2],
        userLogin: t[3],
        keepLoggedIn: t[4],
        authorized: t[5],
        permissions: t[6]
      }));
    },
    /**
     * Записывает данные авторизации в хранилище.
     * @param {Object} creds Данные авторизации
     * returns    {Promise<Objects[]>} результат записи всех полей в хранилище
     */
    async setCreds(t) {
      await this.credsStorage.ready();
      const e = Object.entries(t).map(
        ([n, r]) => this.credsStorage.setItem(n, r)
      );
      return Promise.all(e);
    }
  },
  appData: {
    dataStorage: oUe(),
    get references() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("references"));
    },
    get profile() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("profile"));
    },
    get panels() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("panels"));
    },
    get accessToken() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("accessToken"));
    },
    get refreshToken() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("refreshToken"));
    },
    async getCodes() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("codes"));
    },
    async getProfileCodes(t) {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem(`codes/profile/${t}`));
    },
    async getPushSubscriptionId() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("pushSubscriptionId"));
    },
    async getPushDeviceToken() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("pushDeviceToken"));
    },
    async getSearchParams() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("searchParams"));
    },
    async getMetrics() {
      return this.dataStorage.ready().then(() => this.dataStorage.getItem("metrics"));
    },
    async setData(t, e = null) {
      await this.dataStorage.ready();
      const n = Object.entries(t).map(([r, s]) => {
        const i = {
          data: s,
          lastModified: e
        };
        return this.dataStorage.setItem(r, i);
      });
      return Promise.all(n);
    },
    async saveMetric(t, e) {
      await this.dataStorage.ready();
      const n = await this.dataStorage.getItem("metrics") ?? {};
      n[t] || (n[t] = []), n[t].push(e), await this.dataStorage.setItem("metrics", n);
    },
    async clearMetrics() {
      await this.dataStorage.setItem("metrics", {});
    },
    clear() {
      return this.dataStorage.clear();
    }
  },
  /**
   * Удаляет данные авторизации из локального хранилища
   * @return {Promise} Результат очистки локального хранилища
   */
  async logout() {
    try {
      return this.auth.credsStorage.clear(), this.appData.dataStorage.clear(), !0;
    } catch (t) {
      return console.error(t), !1;
    }
  }
};
var aUe = o2, lUe = Nv, cUe = Av, r$ = Yi, uUe = xu;
function dUe(t, e, n, r) {
  if (!r$(t))
    return t;
  e = lUe(e, t);
  for (var s = -1, i = e.length, o = i - 1, a = t; a != null && ++s < i; ) {
    var l = uUe(e[s]), c = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return t;
    if (s != o) {
      var u = a[l];
      c = r ? r(u, l, a) : void 0, c === void 0 && (c = r$(u) ? u : cUe(e[s + 1]) ? [] : {});
    }
    aUe(a, l, c), a = a[l];
  }
  return t;
}
var fUe = dUe, pUe = WS, hUe = fUe, mUe = Nv;
function vUe(t, e, n) {
  for (var r = -1, s = e.length, i = {}; ++r < s; ) {
    var o = e[r], a = pUe(t, o);
    n(a, o) && hUe(i, mUe(o, t), a);
  }
  return i;
}
var k8 = vUe, gUe = k8, yUe = gL;
function bUe(t, e) {
  return gUe(t, e, function(n, r) {
    return yUe(t, r);
  });
}
var _Ue = bUe, wUe = _Ue, SUe = y2, IUe = SUe(function(t, e) {
  return t == null ? {} : wUe(t, e);
}), EUe = IUe;
const xUe = /* @__PURE__ */ Et(EUe);
var CUe = Ev, TUe = xv, PUe = $S, kUe = Qa, NUe = Tu, s$ = Cv, $Ue = Math.min;
function DUe(t, e, n) {
  for (var r = n ? PUe : TUe, s = t[0].length, i = t.length, o = i, a = Array(i), l = 1 / 0, c = []; o--; ) {
    var u = t[o];
    o && e && (u = kUe(u, NUe(e))), l = $Ue(u.length, l), a[o] = !n && (e || s >= 120 && u.length >= 120) ? new CUe(o && u) : void 0;
  }
  u = t[0];
  var d = -1, f = a[0];
  e:
    for (; ++d < s && c.length < l; ) {
      var p = u[d], h = e ? e(p) : p;
      if (p = n || p !== 0 ? p : 0, !(f ? s$(f, h) : r(c, h, n))) {
        for (o = i; --o; ) {
          var m = a[o];
          if (!(m ? s$(m, h) : r(t[o], h, n)))
            continue e;
        }
        f && f.push(h), c.push(p);
      }
    }
  return c;
}
var AUe = DUe, OUe = Vf, MUe = QR, RUe = g2;
function LUe(t, e) {
  return RUe(MUe(t, e, OUe), t + "");
}
var MI = LUe, FUe = lc, BUe = Pi;
function jUe(t) {
  return BUe(t) && FUe(t);
}
var N8 = jUe, WUe = N8;
function HUe(t) {
  return WUe(t) ? t : [];
}
var VUe = HUe, zUe = Qa, UUe = AUe, GUe = MI, YUe = VUe, ZUe = GUe(function(t) {
  var e = zUe(t, YUe);
  return e.length && e[0] === t[0] ? UUe(e) : [];
}), XUe = ZUe;
const nv = /* @__PURE__ */ Et(XUe);
var $8 = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(vr, function() {
    return function(n) {
      function r(i) {
        if (s[i]) return s[i].exports;
        var o = s[i] = { i, l: !1, exports: {} };
        return n[i].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }
      var s = {};
      return r.m = n, r.c = s, r.i = function(i) {
        return i;
      }, r.d = function(i, o, a) {
        r.o(i, o) || Object.defineProperty(i, o, { configurable: !1, enumerable: !0, get: a });
      }, r.n = function(i) {
        var o = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(o, "a", o), o;
      }, r.o = function(i, o) {
        return Object.prototype.hasOwnProperty.call(i, o);
      }, r.p = ".", r(r.s = 10);
    }([function(n, r) {
      n.exports = { "#": { pattern: /\d/ }, X: { pattern: /[0-9a-zA-Z]/ }, S: { pattern: /[a-zA-Z]/ }, A: { pattern: /[a-zA-Z]/, transform: function(s) {
        return s.toLocaleUpperCase();
      } }, a: { pattern: /[a-zA-Z]/, transform: function(s) {
        return s.toLocaleLowerCase();
      } }, "!": { escape: !0 } };
    }, function(n, r, s) {
      function i(c) {
        var u = document.createEvent("Event");
        return u.initEvent(c, !0, !0), u;
      }
      var o = s(2), a = s(0), l = s.n(a);
      r.a = function(c, u) {
        var d = u.value;
        if ((Array.isArray(d) || typeof d == "string") && (d = { mask: d, tokens: l.a }), c.tagName.toLocaleUpperCase() !== "INPUT") {
          var f = c.getElementsByTagName("input");
          if (f.length !== 1) throw new Error("v-mask directive requires 1 input, found " + f.length);
          c = f[0];
        }
        c.oninput = function(h) {
          if (h.isTrusted) {
            var m = c.selectionEnd, v = c.value[m - 1];
            for (c.value = s.i(o.a)(c.value, d.mask, !0, d.tokens); m < c.value.length && c.value.charAt(m - 1) !== v; ) m++;
            c === document.activeElement && (c.setSelectionRange(m, m), setTimeout(function() {
              c.setSelectionRange(m, m);
            }, 0)), c.dispatchEvent(i("input"));
          }
        };
        var p = s.i(o.a)(c.value, d.mask, !0, d.tokens);
        p !== c.value && (c.value = p, c.dispatchEvent(i("input")));
      };
    }, function(n, r, s) {
      var i = s(6), o = s(5);
      r.a = function(a, l) {
        var c = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], u = arguments[3];
        return Array.isArray(l) ? s.i(o.a)(i.a, l, u)(a, l, c, u) : s.i(i.a)(a, l, c, u);
      };
    }, function(n, r, s) {
      function i(f) {
        f.component(u.a.name, u.a), f.directive("mask", l.a);
      }
      Object.defineProperty(r, "__esModule", { value: !0 });
      var o = s(0), a = s.n(o), l = s(1), c = s(7), u = s.n(c);
      s.d(r, "TheMask", function() {
        return u.a;
      }), s.d(r, "mask", function() {
        return l.a;
      }), s.d(r, "tokens", function() {
        return a.a;
      }), s.d(r, "version", function() {
        return d;
      });
      var d = "0.11.1";
      r.default = i, typeof window < "u" && window.Vue && window.Vue.use(i);
    }, function(n, r, s) {
      Object.defineProperty(r, "__esModule", { value: !0 });
      var i = s(1), o = s(0), a = s.n(o), l = s(2);
      r.default = { name: "TheMask", props: { value: [String, Number], mask: { type: [String, Array], required: !0 }, masked: { type: Boolean, default: !1 }, tokens: { type: Object, default: function() {
        return a.a;
      } } }, directives: { mask: i.a }, data: function() {
        return { lastValue: null, display: this.value };
      }, watch: { value: function(c) {
        c !== this.lastValue && (this.display = c);
      }, masked: function() {
        this.refresh(this.display);
      } }, computed: { config: function() {
        return { mask: this.mask, tokens: this.tokens, masked: this.masked };
      } }, methods: { onInput: function(c) {
        c.isTrusted || this.refresh(c.target.value);
      }, refresh: function(u) {
        this.display = u;
        var u = s.i(l.a)(u, this.mask, this.masked, this.tokens);
        u !== this.lastValue && (this.lastValue = u, this.$emit("input", u));
      } } };
    }, function(n, r, s) {
      function i(o, a, l) {
        return a = a.sort(function(c, u) {
          return c.length - u.length;
        }), function(c, u) {
          for (var d = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], f = 0; f < a.length; ) {
            var p = a[f];
            f++;
            var h = a[f];
            if (!(h && o(c, h, !0, l).length > p.length)) return o(c, p, d, l);
          }
          return "";
        };
      }
      r.a = i;
    }, function(n, r, s) {
      function i(o, a) {
        var l = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], c = arguments[3];
        o = o || "", a = a || "";
        for (var u = 0, d = 0, f = ""; u < a.length && d < o.length; ) {
          var p = a[u], h = c[p], m = o[d];
          h && !h.escape ? (h.pattern.test(m) && (f += h.transform ? h.transform(m) : m, u++), d++) : (h && h.escape && (u++, p = a[u]), l && (f += p), m === p && d++, u++);
        }
        for (var v = ""; u < a.length && l; ) {
          var p = a[u];
          if (c[p]) {
            v = "";
            break;
          }
          v += p, u++;
        }
        return f + v;
      }
      r.a = i;
    }, function(n, r, s) {
      var i = s(8)(s(4), s(9), null, null);
      n.exports = i.exports;
    }, function(n, r) {
      n.exports = function(s, i, o, a) {
        var l, c = s = s || {}, u = typeof s.default;
        u !== "object" && u !== "function" || (l = s, c = s.default);
        var d = typeof c == "function" ? c.options : c;
        if (i && (d.render = i.render, d.staticRenderFns = i.staticRenderFns), o && (d._scopeId = o), a) {
          var f = d.computed || (d.computed = {});
          Object.keys(a).forEach(function(p) {
            var h = a[p];
            f[p] = function() {
              return h;
            };
          });
        }
        return { esModule: l, exports: c, options: d };
      };
    }, function(n, r) {
      n.exports = { render: function() {
        var s = this, i = s.$createElement;
        return (s._self._c || i)("input", { directives: [{ name: "mask", rawName: "v-mask", value: s.config, expression: "config" }], attrs: { type: "text" }, domProps: { value: s.display }, on: { input: s.onInput } });
      }, staticRenderFns: [] };
    }, function(n, r, s) {
      n.exports = s(3);
    }]);
  });
})($8);
var mg = $8.exports;
const KUe = "_root_1dwgr_1", JUe = "_input_1dwgr_5", qUe = "_dropdown_1dwgr_13", QUe = "_dropdownBody_1dwgr_24", eGe = "_listWrapper_1dwgr_29", tGe = "_list_1dwgr_29", nGe = "_listItem_1dwgr_45", rGe = "_listItem_active_1dwgr_52", sGe = {
  root: KUe,
  input: JUe,
  dropdown: qUe,
  dropdownBody: QUe,
  listWrapper: eGe,
  list: tGe,
  listItem: nGe,
  listItem_active: rGe
}, i$ = "--:--", iGe = {
  name: "PbTimepicker",
  directives: {
    mask: mg.mask
  },
  components: {
    PsKitPopup: Ls
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: [String, null],
      default: null
    },
    placeholder: {
      type: String,
      default: i$
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    interval: {
      type: Number,
      default: 1,
      validator: (t) => t > 0 && t < 61
    },
    scrollToCurrentHour: {
      type: Boolean,
      default: !0
    },
    withSeconds: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      time: this.value,
      tokens: {
        H: { pattern: /[0-2]/ },
        // Старший разряд часов
        h: { pattern: /[0-3]/ },
        // Младший разряд часов
        M: { pattern: /[0-5]/ },
        // Старший разряд минут,
        S: { pattern: /[0-5]/ },
        // Старший разряд секунд,
        "#": { pattern: /\d/ }
        // Младший разряд минут (любое число)
      },
      isDropdownVisible: !1,
      correctTimeRegex: this.withSeconds ? /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/ : /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
      hours: [],
      minutes: []
    };
  },
  computed: {
    $placeholder() {
      return this.placeholder !== i$ ? this.placeholder : this.withSeconds ? "--:--:--" : "--:--";
    },
    mask() {
      let t;
      return this.time && this.time.length > 0 ? (t = parseInt(this.time[0]) < 2 ? "H#:M#" : "Hh:M#", this.withSeconds && (t += ":S#"), t) : this.withSeconds ? "H#:M#:S#" : "H#:M#";
    },
    currentHour() {
      return this.time ? this.time.split(":")[0] : null;
    },
    currentMinute() {
      return this.time ? this.time.split(":")[1] : null;
    }
  },
  watch: {
    isDropdownVisible(t) {
      if (t && this.scrollToCurrentHour) {
        const e = (/* @__PURE__ */ new Date()).getHours();
        this.$refs.hoursList && this.$nextTick(() => {
          this.$refs.hoursList.scrollTop = 16 * e;
        });
      }
    },
    value(t) {
      this.time = t;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.hours = [];
      for (let t = 0; t < 24; t++)
        this.hours.push(t < 10 ? `0${t}` : String(t));
      this.minutes = [];
      for (let t = 0; t < 60; t += this.interval)
        this.minutes.push(t < 10 ? `0${t}` : String(t));
    },
    update() {
      this.correctTimeRegex.test(this.time) && this.$emit("input", this.time);
    },
    select(t, e) {
      const [n, r, s] = this.time ? this.time.split(":") : ["00", "00", "00"];
      t === "hour" && (this.time = e + ":" + r), t === "minute" && (this.time = n + ":" + e), this.withSeconds && (this.time = this.time + ":" + s), this.update();
    },
    toggleDropdown(t) {
      this.disabled || (this.correctTimeRegex.test(this.time) || (this.time = this.value), this.isDropdownVisible ? (this.isDropdownVisible = !1, this.update()) : t && t.target.closest(".pb-timepicker") && (this.isDropdownVisible = !0));
    },
    openDropdown(t) {
      this.disabled || (this.correctTimeRegex.test(this.time) || (this.time = this.value), t && t.target.closest(".pb-timepicker") && (this.isDropdownVisible = !0));
    },
    closeDropdown() {
      this.disabled || this.isDropdownVisible && (this.isDropdownVisible = !1, this.correctTimeRegex.test(this.time) || (this.time = this.value), this.update());
    }
  }
};
var oGe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, "pb-timepicker"] }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.time, expression: "time" }, { name: "mask", rawName: "v-mask", value: { mask: e.mask, tokens: e.tokens }, expression: "{ mask, tokens }" }], class: e.$style.input, attrs: { placeholder: e.$placeholder, disabled: e.disabled, type: "tel", "data-test-selector": "timepicker-input" }, domProps: { value: e.time }, on: { input: [function(r) {
    r.target.composing || (e.time = r.target.value);
  }, e.update], focus: function(r) {
    return e.$emit("focus");
  }, blur: function(r) {
    return e.$emit("blur");
  }, keydown: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "tab", 9, r.key, "Tab") && e._k(r.keyCode, "enter", 13, r.key, "Enter") ? null : e.toggleDropdown.apply(null, arguments);
  }, click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.openDropdown.apply(null, arguments);
  } } }), e.isDropdownVisible ? n("PsKitPopup", { ref: "dropdown", attrs: { arrowVisible: !1, visible: e.isDropdownVisible, classPopup: e.$style.dropdown, classPopupBody: e.$style.dropdownBody, floatingOptions: { offset: { mainAxis: 0, crossAxis: 0 } }, placement: "bottom-start" }, on: { hide: e.toggleDropdown } }, [n("div", { class: e.$style.listWrapper }, [n("ul", { ref: "hoursList", class: [e.$style.list, e.$style.list_hours], attrs: { "data-test-selector": "timepicker-list-hours" } }, e._l(e.hours, function(r) {
    return n("li", { key: r, class: {
      [e.$style.listItem]: !0,
      [e.$style.listItem_active]: r === e.currentHour
    }, attrs: { "data-test-selector": "timepicker-list-hours-item", "data-test-attrs": r }, on: { "!click": function(s) {
      return s.stopPropagation(), e.select("hour", r);
    } } }, [e._v(" " + e._s(r) + " ")]);
  }), 0), n("ul", { class: [e.$style.list, e.$style.list_minutes], attrs: { "data-test-selector": "timepicker-list-minutes" } }, e._l(e.minutes, function(r) {
    return n("li", { key: r, class: {
      [e.$style.listItem]: !0,
      [e.$style.listItem_active]: r === e.currentMinute
    }, attrs: { "data-test-selector": "timepicker-list-minutes-item", "data-test-attrs": r }, on: { "!click": function(s) {
      return s.stopPropagation(), e.select("minute", r);
    } } }, [e._v(" " + e._s(r) + " ")]);
  }), 0)])]) : e._e()], 1);
}, aGe = [];
const o$ = {
  $style: sGe
};
function lGe(t) {
  for (var e in o$)
    this[e] = o$[e];
}
var cGe = /* @__PURE__ */ B(
  iGe,
  oGe,
  aGe,
  !1,
  lGe,
  null
);
const uGe = cGe.exports, dGe = {
  name: "PbDateInput",
  directives: { mask: mg.mask },
  props: {
    value: {
      type: String,
      required: !0
    },
    format: {
      type: Object,
      default: () => ({
        string: "dd.MM.yyyy",
        divider: ".",
        day: "dd",
        month: "MM",
        year: "yyyy"
      })
    }
  },
  setup(t, e) {
    const n = et(null), r = et(null), s = et(null), i = le(
      () => t.value ? S0(t.value, t.format.string, /* @__PURE__ */ new Date()) : null
    ), o = (S) => S === "" || S === null, a = et(
      i.value ? on(i.value, t.format.year, { locale: xn }) : null
    ), l = et(
      i.value ? on(i.value, t.format.month, { locale: xn }) : null
    ), c = et(
      i.value ? on(i.value, t.format.day, { locale: xn }) : null
    ), u = le(
      () => o(c.value) || o(l.value) || o(a.value)
    ), d = le(
      () => o(c.value) && o(l.value) && o(a.value)
    ), f = () => {
      e.emit(
        "input",
        on(
          Ed(/* @__PURE__ */ new Date(), {
            date: +c.value,
            month: l.value - 1,
            year: +a.value
          }),
          t.format.string,
          { locale: xn }
        )
      );
    };
    or(a, async (S) => {
      if (await Ar(), d.value)
        return e.emit("input", null);
      u.value || (S == null ? void 0 : S.length) === 4 && S === a.value && f();
    }), or(l, async (S) => {
      if (await Ar(), d.value)
        return e.emit("input", null);
      u.value || (S == null ? void 0 : S.length) === 2 && S === l.value && f();
    }), or(c, async (S) => {
      if (await Ar(), d.value)
        return e.emit("input", null);
      u.value || (S == null ? void 0 : S.length) === 2 && S === c.value && f();
    }), or(i, (S) => {
      if (S) {
        const E = on(S, t.format.day, {
          locale: xn
        }), x = on(S, t.format.month, {
          locale: xn
        }), T = on(S, t.format.year, {
          locale: xn
        });
        E !== c.value && (c.value = E), x !== l.value && (l.value = x), T !== a.value && (a.value = T);
      } else
        c.value = null, l.value = null, a.value = null;
    });
    const p = {
      Y: { pattern: /[1-2]/ },
      y: { pattern: /[0]/ },
      k: { pattern: /[0-9]/ },
      l: { pattern: /[9]/ },
      u: { pattern: /[8-9]/ },
      j: { pattern: /[0-2]/ },
      M: { pattern: /[0, 1]/ },
      m: { pattern: /[0-2]/ },
      D: { pattern: /[0-3]/ },
      d: { pattern: /[0, 1]/ },
      c: { pattern: /[1-9]/ },
      "#": { pattern: /\d/ }
    }, h = le(() => {
      var E;
      const S = ["D", "#"];
      return ((E = c == null ? void 0 : c.value) == null ? void 0 : E.length) > 0 && (c.value[0] == 3 && (S[1] = "d"), c.value[0] == 0 && (S[1] = "c")), S.join("");
    }), m = le(() => {
      var E;
      const S = ["M", "#"];
      return ((E = l == null ? void 0 : l.value) == null ? void 0 : E.length) > 0 && l.value[0] == 1 && (S[1] = "m"), S.join("");
    }), v = le(() => {
      var E;
      const S = ["Y", "y", "j", "#"];
      return ((E = a == null ? void 0 : a.value) == null ? void 0 : E.length) > 0 && a.value[0] == 1 && (S[1] = "l", S[2] = "u"), a.value && a.value.split("").slice(0, 3).join("") == 198 && (S[3] = "l"), S.join("");
    });
    return {
      day: c,
      month: l,
      year: a,
      tokens: p,
      dayMask: h,
      monthMask: m,
      yearMask: v,
      monthInput: n,
      yearInput: r,
      dayInput: s,
      onInput: async (S) => {
        switch (S) {
          case "day":
            await Ar(), c.value.length === 2 && n.value.focus();
            break;
          case "month":
            await Ar(), l.value.length === 2 && r.value.focus();
            break;
        }
      },
      onFocus: (S) => {
        var E, x, T;
        switch (S) {
          case "day":
            (E = s.value) == null || E.select();
            break;
          case "month":
            (x = n.value) == null || x.select();
            break;
          case "year":
            (T = r.value) == null || T.select();
        }
      },
      onKeydown: (S, E) => {
        if (["ArrowLeft", "ArrowRight"].includes(E.key))
          switch (S) {
            case "day":
              E.key === "ArrowRight" && (s.value.selectionEnd === 2 || s.value.value) && (E.preventDefault(), n.value.setSelectionRange(0, 0), n.value.focus());
              break;
            case "month":
              E.key === "ArrowRight" && (n.value.selectionEnd === 2 || n.value.value) && (E.preventDefault(), r.value.setSelectionRange(0, 0), r.value.focus()), E.key === "ArrowLeft" && n.value.selectionEnd === 0 && (E.preventDefault(), s.value.setSelectionRange(3, 3), s.value.focus());
              break;
            case "year":
              E.key === "ArrowLeft" && r.value.selectionEnd === 0 && (E.preventDefault(), n.value.setSelectionRange(3, 3), n.value.focus());
          }
      }
    };
  }
};
var fGe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "input-group", attrs: { "data-test-attrs": `${e.day}${e.format.divider}${e.month}${e.format.divider}${e.year}` } }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.day, expression: "day" }, { name: "mask", rawName: "v-mask", value: { mask: e.dayMask, tokens: e.tokens }, expression: "{ mask: dayMask, tokens }" }], ref: "dayInput", staticClass: "width-two", attrs: { type: "text", placeholder: "дд", size: "1", "data-test-selector": "date-input-day", "data-test-attrs": e.day }, domProps: { value: e.day }, on: { "!keydown": function(r) {
    return r.stopPropagation(), e.onKeydown("day", r);
  }, input: [function(r) {
    r.target.composing || (e.day = r.target.value);
  }, function(r) {
    return e.onInput("day", r);
  }], focus: function(r) {
    return e.onFocus("day");
  } } }), n("span", { staticClass: "divider" }, [e._v(e._s(e.format.divider))]), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.month, expression: "month" }, { name: "mask", rawName: "v-mask", value: { mask: e.monthMask, tokens: e.tokens }, expression: "{ mask: monthMask, tokens }" }], ref: "monthInput", staticClass: "width-two", attrs: { type: "text", placeholder: "мм", size: "1", "data-test-selector": "date-input-month", "data-test-attrs": e.month }, domProps: { value: e.month }, on: { "!keydown": function(r) {
    return r.stopPropagation(), e.onKeydown("month", r);
  }, input: [function(r) {
    r.target.composing || (e.month = r.target.value);
  }, function(r) {
    return e.onInput("month", r);
  }], focus: function(r) {
    return e.onFocus("month");
  } } }), n("span", { staticClass: "divider" }, [e._v(e._s(e.format.divider))]), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.year, expression: "year" }, { name: "mask", rawName: "v-mask", value: { mask: e.yearMask, tokens: e.tokens }, expression: "{ mask: yearMask, tokens }" }], ref: "yearInput", staticClass: "width-four", attrs: { type: "text", placeholder: "гггг", size: "3", "data-test-selector": "date-input-year", "data-test-attrs": e.year }, domProps: { value: e.year }, on: { "!keydown": function(r) {
    return r.stopPropagation(), e.onKeydown("year", r);
  }, focus: function(r) {
    return e.onFocus("year");
  }, input: function(r) {
    r.target.composing || (e.year = r.target.value);
  } } })]);
}, pGe = [], hGe = /* @__PURE__ */ B(
  dGe,
  fGe,
  pGe,
  !1,
  null,
  "b018a288"
);
const mGe = hGe.exports, vGe = {
  components: {
    PbButton: nt
  },
  props: {
    currentYear: {
      type: [String, Number],
      default: null
    }
  }
};
var gGe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "shortcuts" }, [n("PbButton", { staticClass: "shortcut-button", attrs: { "data-test-selector": "range-shortcut-btn", "data-test-attrs": "1" }, on: { click: function(r) {
    return e.$emit("shortcutClicked", 1);
  } } }, [e._v(" Cегодня ")]), n("PbButton", { staticClass: "shortcut-button", attrs: { "data-test-selector": "range-shortcut-btn", "data-test-attrs": "7" }, on: { click: function(r) {
    return e.$emit("shortcutClicked", 7);
  } } }, [e._v(" 7д. ")]), n("PbButton", { staticClass: "shortcut-button", attrs: { "data-test-selector": "range-shortcut-btn", "data-test-attrs": "30" }, on: { click: function(r) {
    return e.$emit("shortcutClicked", 30);
  } } }, [e._v(" 30д. ")]), e.currentYear ? n("PbButton", { staticClass: "shortcut-button", attrs: { "data-test-selector": "range-shortcut-btn", "data-test-attrs": "365" }, on: { click: function(r) {
    return e.$emit("shortcutClicked", 365);
  } } }, [e._v(" " + e._s(e.currentYear) + " ")]) : e._e(), n("PbButton", { staticClass: "shortcut-button", attrs: { "data-test-selector": "range-shortcut-clear-btn" }, on: { click: function(r) {
    return e.$emit("shortcutClicked", 0);
  } } }, [e._v(" Сброс ")])], 1);
}, yGe = [], bGe = /* @__PURE__ */ B(
  vGe,
  gGe,
  yGe,
  !1,
  null,
  "2c54c105"
);
const _Ge = bGe.exports, wGe = {
  components: {
    PbButton: nt
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    hasErrors: {
      type: Boolean,
      default: !1
    }
  }
};
var SGe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "footer" }, [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: e.hasErrors ? "Выбран некорректный период" : "", expression: "hasErrors ? 'Выбран некорректный период' : ''" }], staticClass: "action action-primary", attrs: { disabled: e.disabled, "data-test-selector": "datepicker-apply-btn" }, on: { click: function(r) {
    return e.$emit("apply");
  } } }, [e._v(" Применить ")]), n("PbButton", { staticClass: "action", attrs: { "data-test-selector": "datepicker-cancel-btn" }, on: { click: function(r) {
    return e.$emit("cancel");
  } } }, [e._v(" Отмена ")])], 1);
}, IGe = [], EGe = /* @__PURE__ */ B(
  wGe,
  SGe,
  IGe,
  !1,
  null,
  "ad609b4c"
);
const xGe = EGe.exports, CGe = "_root_n6z8o_1", TGe = "_datepicker_n6z8o_6", PGe = "_header_n6z8o_14", kGe = "_body_n6z8o_23", NGe = "_inputGroup_n6z8o_29", $Ge = "_input_n6z8o_29", DGe = "_input_time_n6z8o_42", AGe = "_input_error_n6z8o_47", OGe = "_button_n6z8o_66", MGe = "_clear_n6z8o_77", RGe = "_wrapper_n6z8o_82", LGe = "_modal_n6z8o_86", FGe = "_widget_n6z8o_91", BGe = "_arrowsContainer_n6z8o_96", jGe = "_arrow_n6z8o_96", WGe = "_arrow_back_n6z8o_115", HGe = {
  root: CGe,
  datepicker: TGe,
  header: PGe,
  body: kGe,
  inputGroup: NGe,
  input: $Ge,
  input_time: DGe,
  input_error: AGe,
  button: OGe,
  clear: MGe,
  wrapper: RGe,
  modal: LGe,
  widget: FGe,
  arrowsContainer: BGe,
  arrow: jGe,
  arrow_back: WGe
}, a$ = (t) => t.split(".").reverse().join("-"), VGe = {
  name: "PbDatepicker",
  mixins: [Vr],
  directives: { mask: mg.mask },
  components: {
    PsKitPopup: Ls,
    PbButton: nt,
    PbTimepicker: uGe,
    PbDateInput: mGe,
    PbDatepickerShortcuts: _Ge,
    PbDatepickerFooter: xGe
  },
  props: {
    mode: {
      type: String,
      default: "range",
      validator: (t) => ["single", "range"].includes(t)
    },
    placeholder: {
      type: String,
      default: "Дата и время"
    },
    values: {
      type: Object,
      default: () => ({
        start: null,
        end: null
      }),
      validator: (t) => nv(["start", "end"], Object.keys(t)).length === 2
    },
    withTime: {
      type: Boolean,
      default: !0
    },
    placement: {
      type: String,
      default: "bottom"
    }
  },
  setup(t, { emit: e }) {
    const n = Xn({
      isVisible: !1,
      position: {
        top: 0,
        left: 0
      }
    }), r = "dd.MM.yyyy", s = /\d{2}\.\d{2}\.\d{4}/, i = /\d{2}:\d{2}/, o = Xn({
      dateStart: !1,
      dateEnd: !1,
      timeStart: !1,
      timeEnd: !1
    }), a = Xn({
      startDate: t.values.start ? new Date(t.values.start) : null,
      endDate: t.values.end ? new Date(t.values.end) : null,
      startTime: t.values.start ? new Date(t.values.start) : null,
      endTime: t.values.end ? new Date(t.values.end) : null
    }), l = () => {
      a.startDate = t.values.start ? new Date(t.values.start) : null, a.endDate = t.values.end ? new Date(t.values.end) : null, a.startTime = t.values.start ? new Date(t.values.start) : null, a.endTime = t.values.end ? new Date(t.values.end) : null;
    }, c = le({
      get: () => {
        const S = a.startDate ? new Date(a.startDate) : null;
        S && a.startTime && S.setHours(
          a.startTime.getHours(),
          a.startTime.getMinutes(),
          a.startTime.getSeconds()
        );
        const E = a.endDate ? new Date(a.endDate) : null;
        return E && a.endTime && E.setHours(
          a.endTime.getHours(),
          a.endTime.getMinutes(),
          a.endTime.getSeconds()
        ), {
          start: S,
          end: E
        };
      },
      set: (S) => {
        a.startDate = S.start, a.endDate = S.end;
        const E = !yo(S.start, t.values.start) || !yo(S.end, t.values.end);
        a.startTime = E ? Ed(S.start, {
          hours: 0,
          minutes: 0,
          seconds: 0
        }) : t.values.start, a.endTime = E ? Ed(S.end, {
          hours: 23,
          minutes: 59,
          seconds: 59
        }) : t.values.end;
      }
    });
    or(a, () => {
      !c.value.start || !c.value.end || (yo(c.value.start, c.value.end) ? (o.dateStart = !1, o.dateEnd = !1, YC(c.value.start, c.value.end) ? (o.timeStart = !0, o.timeEnd = !0) : (o.timeStart = !1, o.timeEnd = !1)) : (o.timeStart = !1, o.timeEnd = !1, YC(c.value.start, c.value.end) ? (o.dateStart = !0, o.dateEnd = !0) : (o.dateStart = !1, o.dateEnd = !1)));
    });
    const d = le({
      get: () => a.startDate ? on(a.startDate, "dd.MM.yyyy", { locale: xn }) : "",
      set: (S) => {
        if (S === null) {
          a.startDate = null;
          return;
        }
        if (s.test(S)) {
          const E = a$(S);
          a.startDate = Tr(E);
        }
      }
    }), f = le({
      get: () => a.endDate ? on(a.endDate, "dd.MM.yyyy", { locale: xn }) : "",
      set: (S) => {
        if (S === null) {
          a.endDate = null;
          return;
        }
        if (s.test(S)) {
          const E = a$(S);
          a.endDate = Tr(E);
        }
      }
    }), p = le({
      get: () => a.startTime && on(a.startTime, "HH:mm", { locale: xn }),
      set: (S) => {
        if (i.test(S)) {
          const E = S.split(":");
          a.startTime = Ed(/* @__PURE__ */ new Date(), {
            hours: E[0],
            minutes: E[1],
            seconds: "00"
          });
        }
      }
    }), h = le({
      get: () => a.endTime && on(a.endTime, "HH:mm", { locale: xn }),
      set: (S) => {
        if (i.test(S)) {
          const E = S.split(":");
          a.endTime = Ed(/* @__PURE__ */ new Date(), {
            hours: E[0],
            minutes: E[1],
            seconds: "59"
          });
        }
      }
    }), m = {
      Y: { pattern: /[1-2]/ },
      y: { pattern: /[0]/ },
      k: { pattern: /[0-9]/ },
      l: { pattern: /[9]/ },
      u: { pattern: /[8-9]/ },
      j: { pattern: /[0-2]/ },
      M: { pattern: /[0, 1]/ },
      m: { pattern: /[0-2]/ },
      D: { pattern: /[0-3]/ },
      d: { pattern: /[0, 1]/ },
      c: { pattern: /[1-9]/ },
      "#": { pattern: /\d/ }
    }, v = {
      start: { timeAdjust: "00:00:00" },
      end: { timeAdjust: "23:59:59" }
    };
    or(
      () => n.isVisible,
      (S, E) => {
        S !== E && l();
      }
    );
    const y = () => {
      n.isVisible = !1;
    }, _ = () => {
      n.isVisible = !0;
    }, w = le(() => n.isVisible);
    return {
      dateEnd: f,
      dateFormat: r,
      datepicker: n,
      dateRegex: s,
      dateStart: d,
      errors: o,
      internalValues: a,
      range: c,
      timeEnd: h,
      timeStart: p,
      tokens: m,
      datepickerModelConfig: v,
      // positionStyles,
      resetInternalValues: l,
      showDatepicker: _,
      hideDatepicker: y,
      isVisible: w
    };
  },
  computed: {
    classDate() {
      return (t) => ({
        [this.$style.input]: !0,
        // [this.$style.input_date]: true,
        [this.$style.input_error]: this.errors[t]
      });
    },
    classTime() {
      return (t) => ({
        [this.$style.input]: !0,
        [this.$style.input_time]: !0,
        [this.$style.input_error]: this.errors[t]
      });
    },
    currentYear() {
      return xQ(/* @__PURE__ */ new Date());
    },
    hasErrors() {
      return Object.values(this.errors).includes(!0);
    },
    hasRange() {
      return !!(this.range.start && this.range.end);
    },
    isSelected() {
      return !!(this.values.start || this.values.end);
    },
    rangeFormatted() {
      let t = "";
      const e = this.values.start || null, n = this.values.end || null;
      return e && (t = on(e, this.dateFormat, { locale: xn })), e && n && (t += " – " + on(n, this.dateFormat, { locale: xn })), t;
    }
  },
  methods: {
    handleBackClick() {
      const t = this.$refs.datepicker.$refs.calendar;
      t.showPageRange(go(t.getPageDays()[0].date, 20));
    },
    handleForwardClick() {
      const t = this.$refs.datepicker.$refs.calendar;
      t.showPageRange(
        gS(t.getPageDays()[0].date, 2 * 20)
      );
    },
    handleShortcutClick(t) {
      let e = bi(), n = Yc();
      switch (t) {
        case 7:
          e = go(bi(), 6);
          break;
        case 30:
          e = go(bi(), 30);
          break;
        case 365:
          e = Tq(/* @__PURE__ */ new Date());
          break;
        case 0:
          this.clearDates();
          return;
      }
      this.internalValues.startDate = e, this.internalValues.startTime = e, this.internalValues.endDate = n, this.internalValues.endTime = n;
    },
    clearDates(t = !1) {
      this.internalValues.startDate = null, this.internalValues.endDate = null, this.internalValues.startTime = null, this.internalValues.endTime = null, this.errors.dateStart = !1, this.errors.dateEnd = !1, this.errors.timeStart = !1, this.errors.timeEnd = !1, t && this.applyChanges();
    },
    applyChanges() {
      this.$emit("rangeSelected", {
        start: this.range.start && on(this.range.start, "yyyy-MM-dd'T'HH:mm:ssXXX"),
        end: this.range.end && on(this.range.end, "yyyy-MM-dd'T'HH:mm:ssXXX")
      }), this.hideDatepicker();
    },
    cancelChanges() {
      this.internalValues.startDate = this.values.start ? new Date(this.values.start) : null, this.internalValues.endDate = this.values.end ? new Date(this.values.end) : null, this.internalValues.startTime = this.values.start ? new Date(this.values.start) : null, this.internalValues.endTime = this.values.end ? new Date(this.values.end) : null, this.hideDatepicker();
    }
  }
};
var zGe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, "draggable-ignore"] }, [e._t("button", function() {
    return [n("PbButton", { class: e.$style.button, on: { click: e.showDatepicker } }, [n("span", [e._v(e._s(e.isSelected ? e.rangeFormatted : e.placeholder))]), n("PbButton", { directives: [{ name: "show", rawName: "v-show", value: e.isSelected, expression: "isSelected" }], class: e.$style.clear, attrs: { round: "" }, on: { "!click": function(r) {
      return r.stopPropagation(), e.clearDates(!0);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "14" } })], 1)], 1)];
  }, null, { showDatepicker: e.showDatepicker, clearRange: e.clearDates }), e.isVisible ? n("PsKitPopup", { class: e.$style.datepicker, attrs: { visible: e.isVisible, placement: e.placement, arrowVisible: !1 }, on: { hide: e.hideDatepicker } }, [e._t("inputs", function() {
    return [e.mode === "range" ? n("div", { class: e.$style.header }, [n("div", { class: e.$style.inputGroup }, [n("PbDateInput", { class: e.classDate("dateStart"), attrs: { "data-test-selector": "date-input-start" }, model: { value: e.dateStart, callback: function(r) {
      e.dateStart = r;
    }, expression: "dateStart" } }), e.withTime ? n("PbTimepicker", { class: e.classTime("timeStart"), attrs: { "data-test-selector": "time-input-start" }, model: { value: e.timeStart, callback: function(r) {
      e.timeStart = r;
    }, expression: "timeStart" } }) : e._e()], 1), n("span", [e._v(" - ")]), n("div", { class: e.$style.inputGroup }, [n("PbDateInput", { class: e.classDate("dateEnd"), attrs: { "data-test-selector": "date-input-end" }, model: { value: e.dateEnd, callback: function(r) {
      e.dateEnd = r;
    }, expression: "dateEnd" } }), e.withTime ? n("PbTimepicker", { class: e.classTime("timeEnd"), attrs: { "data-test-selector": "time-input-end" }, model: { value: e.timeEnd, callback: function(r) {
      e.timeEnd = r;
    }, expression: "timeEnd" } }) : e._e()], 1)]) : e._e()];
  }), n("div", { class: e.$style.body }, [n("v-date-picker", { ref: "datepicker", class: e.$style.widget, attrs: { "is-range": e.mode === "range", "model-config": e.datepickerModelConfig, locale: "ru-RU", "min-date": /* @__PURE__ */ new Date("01/01/1989"), "max-date": /* @__PURE__ */ new Date() }, scopedSlots: e._u([{ key: "header-left-button", fn: function() {
    return [e._v(" ")];
  }, proxy: !0 }, { key: "header-right-button", fn: function() {
    return [e._v(" ")];
  }, proxy: !0 }], null, !1, 1406554130), model: { value: e.range, callback: function(r) {
    e.range = r;
  }, expression: "range" } }), n("div", { class: e.$style.arrowsContainer }, [n("PbButton", { class: [e.$style.arrow, e.$style.arrow_back], attrs: { "data-test-selector": "datepicker-back-btn" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.handleBackClick.apply(null, arguments);
  } } }, [n("icon", { class: e.$style.arrowIcon, attrs: { name: "triangle-right", size: "7", color: "#848484" } })], 1), n("PbButton", { class: [e.$style.arrow, e.$style.arrow_forward], attrs: { "data-test-selector": "datepicker-forward-btn" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.handleForwardClick.apply(null, arguments);
  } } }, [n("icon", { class: e.$style.arrowIcon, attrs: { name: "triangle-right", size: "7", color: "#848484" } })], 1)], 1)], 1), e._t("shortcuts", function() {
    return [n("PbDatepickerShortcuts", { attrs: { currentYear: e.currentYear }, on: { shortcutClicked: e.handleShortcutClick } })];
  }), e._t("footer", function() {
    return [n("PbDatepickerFooter", { attrs: { disabled: e.hasErrors || !e.hasRange, hasErrors: e.hasErrors }, on: { apply: e.applyChanges, cancel: e.cancelChanges } })];
  })], 2) : e._e()], 2);
}, UGe = [];
const l$ = {
  $style: HGe
};
function GGe(t) {
  for (var e in l$)
    this[e] = l$[e];
}
var YGe = /* @__PURE__ */ B(
  VGe,
  zGe,
  UGe,
  !1,
  GGe,
  null
);
const D8 = YGe.exports, ZGe = "_root_18eg8_1", XGe = "_title_18eg8_6", KGe = "_icon_18eg8_15", JGe = "_icon_reversed_18eg8_18", qGe = "_content_18eg8_22", QGe = "_content_collapsed_18eg8_29", eYe = {
  root: ZGe,
  title: XGe,
  icon: KGe,
  icon_reversed: JGe,
  content: qGe,
  content_collapsed: QGe
}, tYe = {
  name: "PbDropdownGroup",
  props: {
    collapsed: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      isCollapsed: this.collapsed
    };
  },
  computed: {
    contentClass() {
      return {
        [this.$style.content]: !0,
        [this.$style.content_collapsed]: this.isCollapsed
      };
    },
    iconClass() {
      return {
        [this.$style.icon]: !0,
        [this.$style.icon_reversed]: !this.isCollapsed
      };
    }
  }
};
var nYe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.title, on: { click: function(r) {
    e.isCollapsed = !e.isCollapsed;
  } } }, [n("span", [e._v(e._s(e.title))]), n("icon", { class: e.iconClass, attrs: { name: "arrow-down", size: 8 } })], 1), n("div", { class: e.contentClass }, [e._t("default")], 2)]);
}, rYe = [];
const c$ = {
  $style: eYe
};
function sYe(t) {
  for (var e in c$)
    this[e] = c$[e];
}
var iYe = /* @__PURE__ */ B(
  tYe,
  nYe,
  rYe,
  !1,
  sYe,
  null
);
const oYe = iYe.exports;
var aYe = z4, lYe = G4;
function cYe(t, e, n) {
  var r = e && n || 0;
  typeof t == "string" && (e = t === "binary" ? new Array(16) : null, t = null), t = t || {};
  var s = t.random || (t.rng || aYe)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e)
    for (var i = 0; i < 16; ++i)
      e[r + i] = s[i];
  return e || lYe(s);
}
var uYe = cYe, dYe = Y4, A8 = uYe, RI = A8;
RI.v1 = dYe;
RI.v4 = A8;
var fYe = RI;
const O8 = /* @__PURE__ */ Et(fYe), pYe = "_root_13reg_1", hYe = "_option_13reg_6", mYe = "_input_13reg_16", vYe = "_check_13reg_24", gYe = "_icon_13reg_28", yYe = "_label_13reg_49", bYe = {
  root: pYe,
  option: hYe,
  input: mYe,
  check: vYe,
  icon: gYe,
  label: yYe
}, _Ye = {
  name: "PbRadioGroup",
  props: {
    name: {
      type: String,
      default: () => O8()
    },
    options: {
      type: Array,
      required: !0
    },
    value: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      checked: this.value || [this.options[0].id]
    };
  },
  watch: {
    checked(t, e) {
      if (e.length === 1 && e[0] == 0 && t.length >= 2) {
        this.checked = t.filter((n) => n != 0);
        return;
      } else if (e.length >= 1 && e[0] != 0 && ~t.findIndex((n) => n == 0)) {
        this.checked = t.filter((n) => n == 0);
        return;
      } else if (t.length === 0) {
        this.checked = [0];
        return;
      }
      this.$emit("input", t);
    }
  },
  computed: {
    isOptionDisabled() {
      return (t) => t !== 0 ? !1 : this.checked.length === 1 && this.checked[0] == 0;
    }
  }
};
var wYe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, e._l(e.options, function(r) {
    return n("label", { key: r.id, class: e.$style.option }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.checked, expression: "checked" }], class: e.$style.input, attrs: { type: "checkbox", name: e.name, disabled: e.isOptionDisabled(r.id) }, domProps: { checked: e.checked === r.id, value: r.id, checked: Array.isArray(e.checked) ? e._i(e.checked, r.id) > -1 : e.checked }, on: { change: function(s) {
      var i = e.checked, o = s.target, a = !!o.checked;
      if (Array.isArray(i)) {
        var l = r.id, c = e._i(i, l);
        o.checked ? c < 0 && (e.checked = i.concat([l])) : c > -1 && (e.checked = i.slice(0, c).concat(i.slice(c + 1)));
      } else
        e.checked = a;
    } } }), n("span", { class: e.$style.check }, [n("icon", { class: e.$style.icon, attrs: { name: "check-2", size: 8 } })], 1), n("span", { class: e.$style.label }, [e._v(e._s(r.label))])]);
  }), 0);
}, SYe = [];
const u$ = {
  $style: bYe
};
function IYe(t) {
  for (var e in u$)
    this[e] = u$[e];
}
var EYe = /* @__PURE__ */ B(
  _Ye,
  wYe,
  SYe,
  !1,
  IYe,
  null
);
const xYe = EYe.exports, CYe = "_root_2cli9_1", TYe = "_root_hasError_2cli9_4", PYe = "_input_2cli9_4", kYe = "_root_hasLabel_2cli9_7", NYe = "_label_2cli9_11", $Ye = "_field_2cli9_32", DYe = "_postfix_2cli9_43", AYe = "_error_2cli9_48", OYe = {
  root: CYe,
  root_hasError: TYe,
  input: PYe,
  root_hasLabel: kYe,
  label: NYe,
  field: $Ye,
  postfix: DYe,
  error: AYe
}, MYe = {
  name: "PbTextField",
  directives: { mask: mg.mask },
  props: {
    attrs: [Object],
    errors: {
      type: [String, Array],
      default: ""
    },
    inputClass: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    mask: {
      type: [String, Array],
      default: ""
    },
    postfix: {
      type: String,
      default: ""
    },
    rules: [Array, Function],
    type: {
      type: String,
      default: "text"
    },
    value: [String, Number],
    width: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      errorsValidation: ""
    };
  },
  watch: {
    value(t, e) {
      t !== e && this.validate(t);
    }
  },
  computed: {
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_hasError]: this.error,
        [this.$style.root_hasLabel]: this.label
      };
    },
    errorsExternal() {
      return Array.isArray(this.errors) ? this.errors : [this.errors];
    }
  },
  methods: {
    handleInput(t) {
      this.internalChange = !0;
      const e = t.target.value;
      this.validate(e), this.$emit("input", e);
    },
    validate(t) {
      if (!this.rules)
        return;
      const e = Array.isArray(this.rules) ? this.rules : [this.rules], n = [];
      e.forEach((r) => {
        n.push(r(t));
      }), this.errorsValidation = n.filter((r) => typeof r == "string" && r !== "").join(`
\r`);
    }
  }
};
var RYe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass }, [e.label ? n("span", { class: e.$style.label }, [e._v(e._s(e.label))]) : e._e(), n("div", { class: e.$style.field }, [e.mask ? n("input", e._b({ directives: [{ name: "mask", rawName: "v-mask", value: e.mask, expression: "mask" }], class: [e.$style.input, e.inputClass], style: { width: e.width }, attrs: { type: e.type }, domProps: { value: e.value }, on: { input: e.handleInput } }, "input", e.attrs, !1)) : n("input", e._b({ class: [e.$style.input, e.inputClass], style: { width: e.width }, attrs: { type: e.type }, domProps: { value: e.value }, on: { input: e.handleInput } }, "input", e.attrs, !1)), e.postfix ? n("span", { class: e.$style.postfix }, [e._v(e._s(e.postfix))]) : e._e()]), e.errors || e.errorsValidation ? n("div", { class: e.$style.error }, [e.errorsValidation ? n("div", [e._v(e._s(e.errorsValidation))]) : e._e(), e.errorsExternal.length ? n("div", e._l(e.errorsExternal, function(r) {
    return n("span", { key: r }, [e._v(e._s(r))]);
  }), 0) : e._e()]) : e._e()]);
}, LYe = [];
const d$ = {
  $style: OYe
};
function FYe(t) {
  for (var e in d$)
    this[e] = d$[e];
}
var BYe = /* @__PURE__ */ B(
  MYe,
  RYe,
  LYe,
  !1,
  FYe,
  null
);
const vg = BYe.exports, jYe = "_root_twx2f_1", WYe = "_block_twx2f_6", HYe = "_subblock_twx2f_17", VYe = "_button_twx2f_23", zYe = "_title_twx2f_30", UYe = "__full_twx2f_39", GYe = "__contrast_twx2f_42", YYe = "__centered_twx2f_45", ZYe = "_values_twx2f_50", XYe = "_queries_twx2f_57", KYe = "_queryGroup_twx2f_63", JYe = "_query_twx2f_63", qYe = "_queryTitle_twx2f_76", QYe = "_groupRemove_twx2f_84", eZe = "_queryRemove_twx2f_92", tZe = "_inputWrap_twx2f_100", nZe = "_input_twx2f_100", rZe = "_operator_twx2f_113", sZe = "_groupOperator_twx2f_114", iZe = "_selectDropdown_twx2f_177", oZe = "_buttonAddQuery_twx2f_182", aZe = "_switchers_twx2f_187", lZe = "_switcher_twx2f_187", cZe = "_switcher_active_twx2f_198", uZe = "_switcherContent_twx2f_203", dZe = "_datepickerButton_twx2f_216", fZe = "_datepickerButton_active_twx2f_219", pZe = "_params_twx2f_223", hZe = "_paramsColumn_twx2f_230", mZe = {
  root: jYe,
  block: WYe,
  subblock: HYe,
  button: VYe,
  title: zYe,
  _full: UYe,
  _contrast: GYe,
  _centered: YYe,
  values: ZYe,
  queries: XYe,
  queryGroup: KYe,
  query: JYe,
  queryTitle: qYe,
  groupRemove: QYe,
  queryRemove: eZe,
  inputWrap: tZe,
  input: nZe,
  operator: rZe,
  groupOperator: sZe,
  selectDropdown: iZe,
  buttonAddQuery: oZe,
  switchers: aZe,
  switcher: lZe,
  switcher_active: cZe,
  switcherContent: uZe,
  datepickerButton: dZe,
  datepickerButton_active: fZe,
  params: pZe,
  paramsColumn: hZe
}, vZe = {
  name: "PbSearchForm",
  components: {
    PbButton: nt,
    PbButtonSwitcher: rl,
    PbDatepicker: D8,
    PbDropdownGroup: oYe,
    PbRadioGroup: xYe,
    PbTextField: vg
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    selected: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const t = {};
    return t.query = fs(this.selected.query) ? [[{ operator: "", string: "" }]] : this.selected.query, t.queryGroupOperators = this.selected.queryGroupOperators || [], t.settings = fs(this.selected) ? {
      interval: 0,
      range: null,
      field: null,
      type: null,
      language: null,
      status: null,
      link: null,
      sorting: "relevance"
    } : xUe(this.selected, [
      "interval",
      "range",
      "field",
      "type",
      "language",
      "status",
      "link",
      "sorting"
    ]), {
      buttons: {
        interval: [
          {
            type: "today",
            label: "Сегодня",
            value: 0,
            testSelector: "switcher-button",
            testAttrs: "button__today"
          },
          {
            type: "yesterday",
            label: "Вчера",
            value: 1,
            testSelector: "switcher-button",
            testAttrs: "button__yesterday"
          },
          {
            type: "week",
            label: "7 дней",
            value: 7,
            testSelector: "switcher-button",
            testAttrs: "button__week"
          },
          {
            type: "month",
            label: "Месяц",
            value: 30,
            testSelector: "switcher-button",
            testAttrs: "button__month"
          },
          {
            type: "alltime",
            label: "Все время",
            value: 999,
            testSelector: "switcher-button",
            testAttrs: "button__alltime"
          }
        ],
        sorting: [
          {
            type: "relevance",
            label: "Релевантности",
            value: "relevance",
            testSelector: "switcher-button",
            testAttrs: "button__sort-by-relevance"
          },
          {
            type: "date",
            label: "Дате",
            value: "date",
            testSelector: "switcher-button",
            testAttrs: "button__sort-by-date"
          }
        ]
      },
      operators: ["И", "ИЛИ", "И НЕ", "ИЛИ НЕ"],
      firstOperators: [" ", "НЕ"],
      groupOperators: ["И", "ИЛИ"],
      ...t
    };
  },
  computed: {
    datepickerButtonClass() {
      return {
        [this.$style.button]: !0,
        [this.$style.datepickerButton]: !0,
        [this.$style.datepickerButton_active]: this.settings.interval === "custom"
      };
    },
    intervalTitle() {
      const t = (e) => on(e, "dd MMMM yyyy", {
        locale: xn
      });
      switch (this.settings.interval) {
        case "custom":
          return `C ${t(
            S0(
              this.settings.range.start,
              "yyyy-MM-dd'T'HH:mm:ssXXX",
              /* @__PURE__ */ new Date()
            )
          )} - по ${t(
            S0(
              this.settings.range.end,
              "yyyy-MM-dd'T'HH:mm:ssXXX",
              /* @__PURE__ */ new Date()
            )
          )}`;
        case 0:
          return `За сегодня (${t(/* @__PURE__ */ new Date())})`;
        case 1:
          return `За вчера (${t(go(/* @__PURE__ */ new Date(), 1))})`;
        case 7:
          return `За последние 7 дней (с ${t(go(/* @__PURE__ */ new Date(), 7))})`;
        case 30:
          return `За последний месяц (с ${t(
            Vee(/* @__PURE__ */ new Date(), 1)
          )})`;
        case 999:
          return "За все время";
        default:
          return "Сегодня";
      }
    },
    dateRange() {
      var t, e, n, r, s, i, o, a;
      return {
        start: (e = (t = this.selected) == null ? void 0 : t.range) != null && e.start ? new Date((r = (n = this.selected) == null ? void 0 : n.range) == null ? void 0 : r.start) : null,
        end: (i = (s = this.selected) == null ? void 0 : s.range) != null && i.end ? new Date((a = (o = this.selected) == null ? void 0 : o.range) == null ? void 0 : a.end) : null
      };
    }
  },
  watch: {
    query: {
      handler(t) {
        this.$emit("change", { query: t });
        for (let [e, n] of t.entries())
          n[n.length - 1].string !== "" ? U.set(this.query, e, [
            ...this.query[e],
            {
              operator: "И",
              string: ""
            }
          ]) : n[n.length - 2] && n[n.length - 2].string === "" && U.set(this.query, e, this.query[e].slice(0, -1));
      },
      deep: !0
    },
    queryGroupOperators(t) {
      this.$emit("change", { queryGroupOperators: t });
    },
    "settings.interval"(t) {
      const e = {};
      switch (t) {
        case 0:
          e.start = bi(), e.end = Yc();
          break;
        case 1:
          e.start = U5(), e.end = Pq();
          break;
        case 7:
          e.start = go(bi(), 6), e.end = Yc();
          break;
        case 30:
          e.start = go(bi(), 30), e.end = Yc();
          break;
        case 999:
          e.start = null, e.end = null;
          break;
      }
      this.$emit("change", { interval: t, range: e });
    },
    "settings.range"(t) {
      this.$emit("change", { range: t });
    },
    "settings.field"(t) {
      this.$emit("change", { field: t });
    },
    "settings.status"(t) {
      this.$emit("change", { status: t });
    },
    "settings.type"(t) {
      this.$emit("change", { type: t });
    },
    "settings.language"(t) {
      this.$emit("change", { language: t });
    },
    "settings.link"(t) {
      this.$emit("change", { link: t });
    },
    "settings.sorting"(t) {
      this.$emit("change", { sorting: t });
    }
  },
  methods: {
    addQueryGroup() {
      const t = this.query.length - 1;
      U.set(this.query, t + 1, [{ operator: "", string: "" }]), U.set(this.queryGroupOperators, t, "И");
    },
    removeQueryGroup(t) {
      U.delete(this.query, t);
    },
    removeQuery(t, e) {
      U.delete(this.query[t], e);
    },
    handleRangeSelect(t) {
      t.start && t.end ? this.settings.interval = "custom" : this.settings.interval = 999, this.settings.range = t;
    }
  }
};
var gZe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("section", { class: e.$style.block }, [n("PbDropdownGroup", { attrs: { title: e.intervalTitle } }, [n("PbButtonSwitcher", { class: e.$style.switchers, attrs: { buttons: e.buttons.interval, "button-class": e.$style.switcher, "active-class": e.$style.switcher_active, "content-class": e.$style.switcherContent }, model: { value: e.settings.interval, callback: function(r) {
    e.$set(e.settings, "interval", r);
  }, expression: "settings.interval" } }), n("PbDatepicker", { attrs: { values: e.dateRange, placement: "bottom-end", "data-test-selector": "panel-news-search-datepicker" }, on: { rangeSelected: e.handleRangeSelect }, scopedSlots: e._u([{ key: "button", fn: function({ showDatepicker: r }) {
    return [n("PbButton", { class: e.datepickerButtonClass, on: { click: r } }, [n("icon", { attrs: { name: "calendar", size: 12 } }), n("span", [e._v("Точная дата и время")])], 1)];
  } }]) })], 1)], 1), n("section", { class: e.$style.block }, [n("div", { class: e.$style.queries }, [e._l(e.query, function(r, s) {
    return n("div", { key: s, class: e.$style.queryGroup }, [n("div", { class: e.$style.queryTitle }, [s !== 0 ? n("v-select", { class: e.$style.groupOperator, attrs: { options: e.groupOperators, clearable: !1, searchable: !1, filterable: !1 }, scopedSlots: e._u([{ key: "open-indicator", fn: function({ attributes: i }) {
      return [n("icon", e._b({ class: e.$style.selectDropdown, attrs: { name: "arrow-down", size: 6 } }, "icon", i, !1))];
    } }], null, !0), model: { value: e.queryGroupOperators[s - 1], callback: function(i) {
      e.$set(e.queryGroupOperators, s - 1, i);
    }, expression: "queryGroupOperators[groupIndex - 1]" } }) : e._e(), n("span", [e._v("Группа " + e._s(s + 1))]), s !== 0 ? n("PbButton", { class: e.$style.groupRemove, on: { click: function(i) {
      return e.removeQueryGroup(s);
    } } }, [n("icon", { attrs: { name: "recycle-bin", size: 18 } })], 1) : e._e()], 1), e._l(r, function(i, o) {
      return n("div", { key: `${s}-${o}`, class: e.$style.query }, [n("v-select", { class: e.$style.operator, attrs: { options: o !== 0 ? e.operators : e.firstOperators, clearable: !1, searchable: !1, filterable: !1 }, scopedSlots: e._u([{ key: "open-indicator", fn: function({ attributes: a }) {
        return [n("icon", e._b({ class: e.$style.selectDropdown, attrs: { name: "arrow-down", size: 8 } }, "icon", a, !1))];
      } }], null, !0), model: { value: i.operator, callback: function(a) {
        e.$set(i, "operator", a);
      }, expression: "query.operator" } }), n("PbTextField", { class: e.$style.inputWrap, attrs: { inputClass: e.$style.input, value: i.string }, on: { input: (a) => i.string = a } }), o !== 0 ? n("PbButton", { class: e.$style.queryRemove, attrs: { disabled: i.string === "" }, on: { click: function(a) {
        return e.removeQuery(s, o);
      } } }, [n("icon", { attrs: { name: "recycle-bin", size: 18 } })], 1) : e._e()], 1);
    })], 2);
  }), n("PbButton", { class: [e.$style.button, e.$style.buttonAddQuery], on: { click: e.addQueryGroup } }, [e._v(" + Группа " + e._s(e.query.length + 1) + " ")])], 2)]), n("section", { class: e.$style.block }, [n("div", { class: e.$style.subblock }, [n("div", { class: e.$style.title }, [e._v("Коды")]), n("div", { class: e.$style.values }, [e._t("codeManager"), e._t("codeManagerSelected")], 2)]), n("div", { class: e.$style.subblock }, [n("div", { class: e.$style.title }, [e._v("Пользователи")]), n("div", { class: e.$style.values }, [e._t("authorManager"), e._t("authorManagerSelected")], 2)])]), n("section", { class: e.$style.block }, [n("div", { class: e.$style.title }, [e._v("Область поиска")]), n("div", { class: e.$style.params }, [n("div", { class: e.$style.paramsColumn }, [n("PbDropdownGroup", { class: e.$style.paramsGroup, attrs: { title: "Где искать" } }, [n("PbRadioGroup", { attrs: { name: "target", options: e.options.targets }, model: { value: e.settings.field, callback: function(r) {
    e.$set(e.settings, "field", r);
  }, expression: "settings.field" } })], 1), n("PbDropdownGroup", { class: e.$style.paramsGroup, attrs: { title: "Тип материала" } }, [n("PbRadioGroup", { attrs: { name: "type", options: e.options.types }, model: { value: e.settings.type, callback: function(r) {
    e.$set(e.settings, "type", r);
  }, expression: "settings.type" } })], 1), n("PbDropdownGroup", { class: e.$style.paramsGroup, attrs: { title: "Язык" } }, [n("PbRadioGroup", { attrs: { name: "language", options: e.options.languages }, model: { value: e.settings.language, callback: function(r) {
    e.$set(e.settings, "language", r);
  }, expression: "settings.language" } })], 1)], 1), n("div", { class: e.$style.paramsColumn }, [n("PbDropdownGroup", { class: e.$style.paramsGroup, attrs: { title: "Статус новости" } }, [n("PbRadioGroup", { attrs: { name: "status", options: e.options.statuses }, model: { value: e.settings.status, callback: function(r) {
    e.$set(e.settings, "status", r);
  }, expression: "settings.status" } })], 1), n("PbDropdownGroup", { class: e.$style.paramsGroup, attrs: { title: "Тип связей" } }, [n("PbRadioGroup", { attrs: { name: "link", options: e.options.links }, model: { value: e.settings.link, callback: function(r) {
    e.$set(e.settings, "link", r);
  }, expression: "settings.link" } })], 1)], 1)])]), n("section", { class: e.$style.block }, [n("div", { class: [e.$style.title, e.$style._full] }, [e._v("Параметры поиска")]), n("div", { class: [e.$style.title, e.$style._contrast, e.$style._centered] }, [e._v(" Сортировать по: ")]), n("PbButtonSwitcher", { class: e.$style.switchers, attrs: { buttons: e.buttons.sorting, buttonClass: e.$style.switcher, activeClass: e.$style.switcher_active, contentClass: e.$style.switcherContent }, model: { value: e.settings.sorting, callback: function(r) {
    e.$set(e.settings, "sorting", r);
  }, expression: "settings.sorting" } })], 1)]);
}, yZe = [];
const f$ = {
  $style: mZe
};
function bZe(t) {
  for (var e in f$)
    this[e] = f$[e];
}
var _Ze = /* @__PURE__ */ B(
  vZe,
  gZe,
  yZe,
  !1,
  bZe,
  null
);
const wZe = _Ze.exports, SZe = "_manager_khzig_1", IZe = "_root_khzig_1", EZe = "_tree_khzig_8", xZe = "_selected_khzig_11", CZe = "_selectedList_khzig_14", TZe = "_footer_khzig_17", PZe = "_checkbox_khzig_23", kZe = "_search_khzig_27", NZe = {
  manager: SZe,
  root: IZe,
  tree: EZe,
  selected: xZe,
  selectedList: CZe,
  footer: TZe,
  checkbox: PZe,
  search: kZe
}, $Ze = {
  name: "PbAuthorManager",
  components: {
    PbVirtualTreeEnhanced: jR,
    PbManagerSelectedItems: Ru
  },
  props: {
    query: {
      type: String,
      default: ""
    },
    selectedAuthors: {
      type: Array,
      required: !0
    },
    allAuthors: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: "Авторы"
    },
    fontSize: {
      type: Number,
      default: 12
    },
    isSelectable: {
      type: Function,
      default: () => !0
    },
    isHighLighted: {
      type: Boolean,
      default: !1
    },
    isThemed: {
      type: Boolean,
      default: !0
    },
    withItemMenu: {
      type: Boolean,
      default: !1
    },
    twoWaySelection: {
      type: Boolean,
      default: !1
    },
    trackShift: {
      type: Number,
      default: 1
    },
    showSelected: {
      type: Boolean,
      default: !0
    },
    searchPlaceholder: {
      type: String,
      default: "Поиск по пользователям"
    }
  },
  computed: {
    selectedAuthorsWithState() {
      return this.twoWaySelection ? this.selectedAuthors : this.selectedAuthors.map((t) => ({ id: t, state: "included" }));
    },
    itemTitle() {
      return (t) => {
        if (t.isGroup)
          return `${t.code} - ${t.name}`;
        const e = `${t.last_name || ""} ${t.first_name || ""} ${t.patronymic || ""}`;
        return `${t.code}${e.replace(/\s/g, "") ? " - " + e : ""}`;
      };
    },
    style() {
      return {
        "font-size": this.fontSize + "px !important"
      };
    }
  },
  errorCaptured(t) {
    return console.error(t), !1;
  },
  methods: {
    include(t) {
      this.$emit("authorIncluded", t);
    },
    exclude(t) {
      this.$emit("authorExcluded", t);
    },
    ignore(t) {
      this.$emit("authorIgnored", t);
    },
    select(t) {
      this.$emit("authorAdded", t);
    },
    unselect(t) {
      this.$emit("authorDeleted", t);
    }
  }
};
var DZe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, e.$style.manager], style: e.style, attrs: { "data-test-selector": "authors-manager" }, on: { keydown: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "esc", 27, r.key, ["Esc", "Escape"]) ? null : (r.preventDefault(), r.stopPropagation(), e.$emit("hide"));
  } } }, [n("PbVirtualTreeEnhanced", { ref: "treeEnhanced", class: e.$style.tree, attrs: { items: e.allAuthors, selectedItems: e.selectedAuthors, features: {
    search: !0,
    selection: !0,
    highlight: e.isHighLighted,
    menu: e.withItemMenu
  }, search: {
    placeholder: e.searchPlaceholder,
    fields: [
      "name",
      "first_name",
      "last_name",
      "patronymic",
      "code"
    ],
    minimalQueryLength: 1
  }, sortField: "code", trackShift: e.trackShift, titleName: e.itemTitle, margin: { value: 1.3, unit: "rem", drop: 1.3 }, searchFieldClass: e.$style.search, isSelectable: e.isSelectable, isThemed: e.isThemed, twoWaySelection: e.twoWaySelection }, on: { select: e.select, "select:included": e.include, "select:excluded": e.exclude, "select:ignored": e.ignore, unselect: e.unselect }, scopedSlots: e._u([{ key: "search", fn: function() {
    return [e._t("search")];
  }, proxy: !0 }, { key: "itemMenu", fn: function({ item: r, closeMenu: s }) {
    return [e._t("itemMenu", null, null, { item: r, closeMenu: s })];
  } }], null, !0), model: { value: e.query, callback: function(r) {
    e.query = r;
  }, expression: "query" } }), e.showSelected && e.selectedAuthors.length ? n("div", { class: e.$style.selected }, [n("PbManagerSelectedItems", { class: e.$style.selectedList, attrs: { availableItems: e.allAuthors, items: e.allAuthors, selectedItems: e.selectedAuthorsWithState, title: "Добавленные пользователи/группы", labels: ["name", "code"], isRemovable: !0 }, on: { remove: e.unselect } })], 1) : e._e(), e.$slots.footer ? n("div", { class: e.$style.footer }, [e._t("footer")], 2) : e._e()], 1);
}, AZe = [];
const p$ = {
  $style: NZe
};
function OZe(t) {
  for (var e in p$)
    this[e] = p$[e];
}
var MZe = /* @__PURE__ */ B(
  $Ze,
  DZe,
  AZe,
  !1,
  OZe,
  null
);
const M8 = MZe.exports, RZe = "_root_9hqt1_1", LZe = "_anchor_9hqt1_5", FZe = "_popup_9hqt1_10", BZe = "_button_9hqt1_14", jZe = "_clear_9hqt1_27", WZe = "_menu_9hqt1_32", HZe = "_menuItem_9hqt1_40", VZe = "_menuTooltip_9hqt1_49", zZe = {
  root: RZe,
  anchor: LZe,
  popup: FZe,
  button: BZe,
  clear: jZe,
  menu: WZe,
  menuItem: HZe,
  menuTooltip: VZe
}, UZe = {
  name: "NewsPublishedAuthorsFilter",
  mixins: [Vr],
  components: {
    PsKitPopup: Ls,
    PbActionsButtonGroup: Ou,
    PbButton: nt,
    PbAuthorManager: M8
  },
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    values: {
      type: Array,
      default: () => []
    },
    showBlockedUsers: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Jt("store"), n = le(
      () => t.showBlockedUsers ? e.getters.getMailGroupsAndUsers : e.getters.getMailGroupsAndNonBlockedUsers
    ), r = et(Or(t.values));
    or(() => t.values, (w) => {
      r.value = w;
    });
    const {
      isSelected: s,
      isIncluded: i,
      isExcluded: o,
      isIgnored: a,
      isParentSelected: l,
      isParentIncluded: c,
      isParentExcluded: u,
      isParentIgnored: d,
      isParentAncestorIncluded: f,
      isParentAncestorExcluded: p,
      includeItem: h,
      excludeItem: m,
      ignoreItem: v,
      removeItem: y,
      removeChildren: _
    } = MR(n, r, et(!0));
    return {
      items: n,
      itemsSelected: r,
      isSelected: s,
      isIncluded: i,
      isExcluded: o,
      isIgnored: a,
      isParentSelected: l,
      isParentIncluded: c,
      isParentExcluded: u,
      isParentIgnored: d,
      isParentAncestorIncluded: f,
      isParentAncestorExcluded: p,
      includeItem: h,
      excludeItem: m,
      ignoreItem: v,
      removeItem: y,
      removeChildren: _
    };
  },
  data() {
    return {
      manager: {
        isVisible: !1,
        position: {
          top: 0,
          left: 0
        }
      }
    };
  },
  computed: {
    buttonLabel() {
      const t = this.values.filter((e) => e.state !== "ignored").length;
      return `${t} ${Pv(t, ["польз.", "польз.", "польз."])}`;
    }
  },
  methods: {
    hideFilter() {
      this.$nextTick(() => {
        this.manager.isVisible = !1, this.$emit("hidden");
      });
    },
    showFilter() {
      this.manager.isVisible = !0, this.$emit("visible");
    },
    clearFilter() {
      this.itemsSelected.value = [], this.$emit("update", this.itemsSelected.value);
    },
    applyChanges() {
      this.$emit("update", Ow(this.itemsSelected)), this.cleanupChanges(), this.hideFilter();
    },
    cancelChanges() {
      this.itemsSelected.value = Or(this.values), this.cleanupChanges(), this.hideFilter();
    },
    cleanupChanges() {
      this.$refs.manager.$refs.treeEnhanced.$refs.tree.$refs.searchField.clearQuery();
    }
  }
};
var GZe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e._t("button", function() {
    return [n("PbButton", { ref: "button", class: e.$style.button, attrs: { title: "Пользователь является автором новости или выпускающим редактором", "data-test-selector": "panel-news-published-authors-btn" }, on: { click: e.showFilter } }, [n("span", [e._v(e._s(e.values.length ? e.buttonLabel : "Польз."))]), n("PbButton", { directives: [{ name: "show", rawName: "v-show", value: e.values.length, expression: "values.length" }], class: e.$style.clear, attrs: { round: "", "data-test-selector": "panel-news-published-authors-clear-btn" }, on: { "!click": function(r) {
      return r.stopPropagation(), e.clearFilter.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "14" } })], 1)], 1)];
  }, null, { showFilter: e.showFilter, clearFilter: e.clearFilter }), e.manager.isVisible ? n("PsKitPopup", { class: e.$style.anchor, attrs: { visible: e.manager.isVisible, classPopup: e.$style.popup, arrowVisible: !1, placement: e.placement }, on: { hide: e.hideFilter } }, [n("PbAuthorManager", { ref: "manager", style: { height: "min(80vh, 500px)" }, attrs: { selectedAuthors: e.itemsSelected, allAuthors: e.items, anchor: "top", isThemed: !1, isHighLighted: !0, withItemMenu: !0, twoWaySelection: !0 }, on: { authorDeleted: (r) => {
    e.removeItem(r), e.removeChildren(r, "any");
  }, authorIncluded: e.includeItem, authorExcluded: e.excludeItem, authorIgnored: e.ignoreItem }, scopedSlots: e._u([{ key: "itemMenu", fn: function({ item: r, closeMenu: s }) {
    return [n("div", { class: e.$style.menu }, [!e.isIncluded(r) && !e.isParentIncluded(r) && !e.isParentIgnored(r) || !e.isIncluded(r) && e.isParentIgnored(r) && e.isParentAncestorIncluded(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.includeItem(r.id), s();
    } } }, [e._v(" Включить фильтр по " + e._s(r.children.length ? "группе" : "автору") + " ")]) : e._e(), !e.isExcluded(r) && !e.isParentExcluded(r) && !e.isParentIgnored(r) || !e.isExcluded(r) && e.isParentIgnored(r) && e.isParentAncestorExcluded(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.excludeItem(r.id), s();
    } } }, [n("span", [e._v(" Исключить " + e._s(r.children.length ? "группу" : "автора") + " ")]), n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Приоритетное выполнение, новости с исключенными группой/автором будут скрыты", expression: `
                'Приоритетное выполнение, новости с исключенными группой/автором будут скрыты'
              ` }], class: e.$style.menuTooltip, attrs: { type: "font", name: "info", size: "12" } })], 1) : e._e(), !e.isIgnored(r) && !e.isParentIgnored(r) && e.isParentSelected(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.ignoreItem(r.id), s();
    } } }, [n("span", [e._v("Игнорировать")]), n("icon", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Новости с игнорируемой группой/автором не будут включены в выборку", expression: `
                'Новости с игнорируемой группой/автором не будут включены в выборку'
              ` }], class: e.$style.menuTooltip, attrs: { type: "font", name: "info", size: "12" } })], 1) : e._e(), e.isIgnored(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.removeItem(r.id), s();
    } } }, [e._v(" Снять игнорирование ")]) : e._e(), e.isSelected(r) ? n("div", { class: e.$style.menuItem, on: { click: () => {
      e.removeItem(r.id), s();
    } } }, [e._v(" Удалить " + e._s(r.children.length ? "группу" : "автора") + " ")]) : e._e()])];
  } }, { key: "footer", fn: function() {
    return [n("PbActionsButtonGroup", { attrs: { applyFn: e.applyChanges, cancelFn: e.cancelChanges } })];
  }, proxy: !0 }], null, !1, 3773744210) })], 1) : e._e()], 2);
}, YZe = [];
const h$ = {
  $style: zZe
};
function ZZe(t) {
  for (var e in h$)
    this[e] = h$[e];
}
var XZe = /* @__PURE__ */ B(
  UZe,
  GZe,
  YZe,
  !1,
  ZZe,
  null
);
const KZe = XZe.exports, JZe = "_form_9d0ca_1", qZe = "_loader_9d0ca_5", QZe = "_button_9d0ca_14", eXe = "_button_multiple_9d0ca_20", tXe = "_formOverlay_9d0ca_24", nXe = "_selectedList_9d0ca_33", rXe = "_footer_9d0ca_41", sXe = "_submitButton_9d0ca_47", iXe = {
  form: JZe,
  loader: qZe,
  button: QZe,
  button_multiple: eXe,
  formOverlay: tXe,
  selectedList: nXe,
  footer: rXe,
  submitButton: sXe
}, oXe = {
  HEADLINE_SUBHEADLINE: "в заголовке и подзаголовке",
  BODY: "в теле",
  BACKGROUND: "в бэкграунде",
  SLUGLINE_TRASHLINE_DATELINE: "в слаглайне, трешлайне и дейтлайне"
}, m$ = {
  WAITS_FOR_EDIT: "ожидают взятия в работу",
  DISPOSED: "в отвале",
  WAITS_FOR_PUBLICATION: "отложенная публикация / эмбарго",
  PUBLISHED: "опубликованные"
}, v$ = {
  REPUBLICATION: "переопубликование",
  REVOCATION: "аннулирование"
}, aXe = {
  name: "NewsSearchPanel",
  components: {
    PbButton: nt,
    PbCircularLoader: br,
    PbManagerSelectedItems: Ru,
    PbPanel: bs,
    PbPanelMenu: Rv,
    PbSearchForm: wZe,
    NewsPublishedAuthorsFilter: KZe,
    NewsPublishedCodesFilter: XR
  },
  props: {
    panel: Object,
    isFocused: Boolean
  },
  data() {
    return {
      isLoadingParams: !0,
      menuShowed: !1,
      menuItems: [
        {
          label: "Закрыть панель",
          code: "close",
          handler: this.remove,
          enabled: !0
        }
      ],
      overlay: !1,
      selected: {
        query: [],
        queryGroupOperators: [],
        codes: [],
        authors: [],
        interval: 0,
        range: null,
        field: null,
        type: null,
        language: null,
        status: null,
        link: null,
        sorting: "relevance"
      }
    };
  },
  computed: {
    ...pe("references", [
      "newsSearchTargets",
      "newsStatuses",
      "newsTypes",
      "newsLangs",
      "newsLinkTypes"
    ]),
    ...pe("news/codes", ["allCodeItems"]),
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    ...pe(["getGroupsAndUsers"]),
    userHasPermissions() {
      return this.getIsUserHasAllPermissions(["2.15"]);
    },
    options() {
      const t = [
        { id: 0, label: "во всех полях" },
        ...Object.entries(this.newsSearchTargets).map(([i, o]) => ({
          id: i,
          label: oXe[o.name]
        }))
      ], e = [
        { id: 0, label: "любой статус" },
        ...Object.entries(this.newsStatuses).reduce((i, [o, a]) => m$[a.name] ? [
          ...i,
          {
            id: o,
            label: m$[a.name]
          }
        ] : i, [])
      ], n = [
        { id: 0, label: "любой тип" },
        ...Object.entries(this.newsTypes).reduce((i, [o, a]) => [
          ...i,
          {
            id: o,
            label: a.description.toLowerCase()
          }
        ], [])
      ], r = [
        { id: 0, label: "любой язык" },
        ...Object.entries(this.newsLangs).map(([i, o]) => ({
          id: i,
          label: o.description.toLowerCase()
        }))
      ], s = [
        { id: 0, label: "любой тип" },
        ...Object.entries(this.newsLinkTypes).reduce((i, [o, a]) => v$[a.name] ? [
          ...i,
          {
            id: o,
            label: v$[a.name]
          }
        ] : i, [])
      ];
      return {
        targets: t,
        statuses: e,
        types: n,
        languages: r,
        links: s
      };
    }
  },
  async beforeCreate() {
    this.isLoadingParams = !0;
  },
  async created() {
    this.setSettingSearchParams(!0);
    const t = await ni.appData.getSearchParams();
    t && !$a(this.selected, t.data) && (this.selected = t.data), this.setSearchParams(Or(this.selected)), this.isLoadingParams = !1, this.$nextTick(() => {
      this.setSettingSearchParams(!1);
    });
  },
  methods: {
    ...ge("news/search", [
      "search",
      "setSearchParams",
      "setSettingSearchParams"
    ]),
    ...ge("panels", ["showSupply", "removePanel"]),
    getManagersPosition() {
      const t = this.$refs.panel.$el.getBoundingClientRect();
      return {
        top: t.top + 60,
        left: globalThis.scrollX + t.left + 105
      };
    },
    remove() {
      this.removePanel({ panelId: this.panel.id });
    },
    setSelectedAuthors(t) {
      this.selected.authors = t, this.saveParamsToDB();
    },
    setSelectedCodes(t) {
      this.selected.codes = t, this.saveParamsToDB();
    },
    toggleOverlay(t) {
      this.overlay = t;
    },
    handleParamsChange(t) {
      this.selected = {
        ...this.selected,
        ...t
      }, this.saveParamsToDB();
    },
    handleSubmit() {
      const t = this.panel, e = t.supply.right[0].id;
      this.setSearchParams(Or(this.selected)), this.showSupply({
        panelId: t.id,
        supplyId: e
      });
    },
    saveParamsToDB() {
      ni.appData.setData({
        searchParams: this.selected
      });
    },
    removeSelectedItem(t, e) {
      Object.hasOwn(this.selected, t) && (this.selected[t] = this.selected[t].filter((n) => n.id != e), this.saveParamsToDB());
    }
  }
};
var lXe = function() {
  var e = this, n = e._self._c;
  return n("PbPanel", { ref: "panel", attrs: { panel: e.panel, isFocused: e.isFocused, resizeable: !1, userHasPermissions: e.userHasPermissions, title: "Поиск" }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [n("PbPanelMenu", { attrs: { items: e.menuItems, trigger: e.menuShowed, color: "#" + e.panel.settings.color }, on: { "update:trigger": function(r) {
      e.menuShowed = r;
    }, click: function(r) {
      e.menuShowed = !e.menuShowed;
    } } })];
  }, proxy: !0 }, { key: "appBarActions", fn: function() {
    return [n("PbButton", { staticClass: "appbar-button close-button draggable-ignore", attrs: { round: "", "data-test-selector": "panel-button-close" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.remove.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [e.isLoadingParams ? n("div", { class: e.$style.loader }, [n("PbCircularLoader")], 1) : n("PbSearchForm", { class: e.$style.form, attrs: { options: e.options, selected: e.selected }, on: { change: e.handleParamsChange }, scopedSlots: e._u([{ key: "codeManager", fn: function() {
      return [n("NewsPublishedCodesFilter", { attrs: { placement: "right", withColorManager: !1, withModeToggle: !1, showDeprecatedCodes: !0, values: e.selected.codes }, on: { update: e.setSelectedCodes, visible: function(r) {
        return e.toggleOverlay(!0);
      }, hidden: function(r) {
        return e.toggleOverlay(!1);
      } }, scopedSlots: e._u([{ key: "button", fn: function({ showFilter: r, clearFilter: s }) {
        return [n("PbButton", { class: [e.$style.button, e.$style.button_multiple], on: { click: r } }, [e._v(" + Добавить код ")]), e.selected.codes.length ? n("PbButton", { class: e.$style.button, on: { click: s } }, [e._v(" Сбросить коды ")]) : e._e()];
      } }], null, !1, 288720069) })];
    }, proxy: !0 }, e.selected.codes.length ? { key: "codeManagerSelected", fn: function() {
      return [n("PbManagerSelectedItems", { class: e.$style.selectedList, attrs: { items: e.allCodeItems, "selected-items": e.selected.codes, labels: ["name"] }, on: { remove: (r) => e.removeSelectedItem("codes", r) } })];
    }, proxy: !0 } : null, { key: "authorManager", fn: function() {
      return [n("NewsPublishedAuthorsFilter", { attrs: { placement: "right", showBlockedUsers: !0, values: e.selected.authors }, on: { update: e.setSelectedAuthors, visible: function(r) {
        return e.toggleOverlay(!0);
      }, hidden: function(r) {
        return e.toggleOverlay(!1);
      } }, scopedSlots: e._u([{ key: "button", fn: function({ showFilter: r, clearFilter: s }) {
        return [n("PbButton", { class: [e.$style.button, e.$style.button_multiple], on: { click: r } }, [e._v(" + Добавить пользователя ")]), e.selected.authors.length ? n("PbButton", { class: e.$style.button, on: { click: s } }, [e._v(" Сбросить пользователей ")]) : e._e()];
      } }], null, !1, 3527818165) })];
    }, proxy: !0 }, e.selected.authors.length ? { key: "authorManagerSelected", fn: function() {
      return [n("PbManagerSelectedItems", { class: e.$style.selectedList, attrs: { items: e.getGroupsAndUsers, selectedItems: e.selected.authors, labels: ["name", "code"] }, on: { remove: (r) => e.removeSelectedItem("authors", r) } })];
    }, proxy: !0 } : null], null, !0) }), n("transition", { attrs: { name: "fade" } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.overlay, expression: "overlay" }], class: e.$style.formOverlay })])];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [n("div", { class: e.$style.footer }, [n("PbButton", { class: e.$style.submitButton, on: { click: e.handleSubmit } }, [n("icon", { attrs: { name: "button-icon-loupe", size: 22 } }), n("span", [e._v("Найти материалы")])], 1)], 1)];
  }, proxy: !0 }]) });
}, cXe = [];
const g$ = {
  $style: iXe
};
function uXe(t) {
  for (var e in g$)
    this[e] = g$[e];
}
var dXe = /* @__PURE__ */ B(
  aXe,
  lXe,
  cXe,
  !1,
  uXe,
  null
);
const fXe = dXe.exports, pXe = {
  name: "NewsOriginalsEntry",
  components: {
    DateWidget: Hr,
    PbEntryDate: nl,
    NewsTypeButton: ea,
    PbPanelDynamicEntry: Zv,
    PbMainActionButton: fn,
    PbPanelListEntryActions: Xv
  },
  props: {
    entry: {
      type: Object,
      default: () => ({})
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    ...pe("news/versions", ["getIsUrgentVersionType"]),
    sender() {
      var t;
      return (t = this.entry.sender) == null ? void 0 : t.code;
    },
    recipient() {
      var t, e;
      return ((t = this.entry.recipient_user) == null ? void 0 : t.code) || ((e = this.entry.recipient_group) == null ? void 0 : e.code);
    },
    isUrgent() {
      return this.getIsUrgentVersionType(this.entry.type_id);
    },
    isTypeOfFlash() {
      return this.entry.type_id === 1;
    },
    newsTypeButtonColor() {
      return this.isUrgent ? "#D0021B" : "#b3b3b3";
    },
    fontStyle() {
      return this.isTypeOfFlash ? { textTransform: "uppercase" } : {};
    }
  }
};
var hXe = function() {
  var e = this, n = e._self._c;
  return n("PbPanelDynamicEntry", { staticClass: "news-original-list-entry", attrs: { entry: e.entry, body: e.entry.headline || e.entry.body, isCompact: e.isCompact, isSelected: e.isSelected, isHighlighted: e.isUrgent, fontStyle: e.fontStyle }, scopedSlots: e._u([{ key: "header", fn: function() {
    return [n("NewsTypeButton", { staticClass: "type", attrs: { typeId: e.entry.type_id, iconSize: 18, color: e.newsTypeButtonColor, disabled: "" } }), n("div", { staticClass: "users" }, [n("span", { staticClass: "sender" }, [e._v(e._s(e.sender))]), e._v(" " + e._s(e.recipient) + " ")]), n("PbEntryDate", { staticClass: "date" }, [n("DateWidget", { attrs: { date: e.entry.created_at } })], 1)];
  }, proxy: !0 }, { key: "actions", fn: function() {
    return [n("div", { staticClass: "actions-block" }, [n("PbPanelListEntryActions", { staticClass: "actions", attrs: { color: "00946B", isCompact: e.isCompact } }, [n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Открыть в отдельной панели", expression: "'Открыть в отдельной панели'" }], staticClass: "action mini-button pb-action-button-old show-more", attrs: { iconName: "button-icon-show-more", "data-test-selector": "entry-button-open-in-separate-panel" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("openInSeparatePanel");
    } } })], 1)], 1)];
  }, proxy: !0 }]) });
}, mXe = [], vXe = /* @__PURE__ */ B(
  pXe,
  hXe,
  mXe,
  !1,
  null,
  "34225a3d"
);
const gXe = vXe.exports, yXe = {}, bXe = {
  name: "NewsOriginalsList",
  components: {
    NewsList: Qv,
    NewsOriginalsEntry: gXe,
    PbDateDelimiter: $2
  },
  props: {
    panelId: {
      type: [String, Number],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    isFocused: {
      type: Function,
      default: () => !1
    },
    loadParams: {
      type: Object,
      default: () => ({})
    },
    forceRefresh: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      openedItem: null
    };
  },
  computed: {
    ...st({
      originals: (t) => t.news.originals.list
    }),
    ...st("news/versions", {
      versions: (t) => t.items
    }),
    ...pe("news", ["getNewsItemCurrentVersion"]),
    ...pe("news/versions", ["getSortedVersions"]),
    ...pe(["getPanelIsActive"]),
    ...pe("news/newsItemHistory", { getHistory: "get" }),
    active() {
      return this.getPanelIsActive(this.panelId);
    },
    items() {
      return this.originals.map((t) => this.versions[t]);
    },
    sortedItems() {
      return this.getSortedVersions([...this.items]);
    },
    openedItemHistory() {
      var t;
      return this.getHistory((t = this.openedItem) == null ? void 0 : t.news_id) || null;
    },
    needDateDelimiter() {
      return (t, e) => {
        if (this.items[e - 1]) {
          const n = this.items[e - 1];
          if (n && n.id)
            return !yo(
              Tr(n.created_at),
              Tr(t.created_at)
            );
        } else
          return !yo(Tr(t.created_at), /* @__PURE__ */ new Date());
      };
    }
  },
  watch: {
    openedItemHistory(t) {
      t && this.setSelectedVersion({
        newsItemId: this.openedItem.news_id,
        versionId: this.openedItem.id
      });
    }
  },
  methods: {
    ...ge("news", {
      loadNewsOriginals(t, { params: e, replace: n }) {
        return t("loadOriginals", { params: e, replace: n });
      }
    }),
    ...ge("news", ["openOriginalsNewsItem"]),
    ...ge("news/newsItemHistory", ["setSelectedVersion"]),
    ...ge("panels", ["toggleSupplyOfType"]),
    async openInSeparatePanel(t) {
      this.openedItem = t;
      const e = await this.openOriginalsNewsItem({
        newsId: t.news_id,
        panelId: this.panelId
      });
      this.toggleSupplyOfType({
        panelId: e.id,
        type: gt.newsItemVersionsSupply
      });
    }
  }
};
var _Xe = function() {
  var e = this, n = e._self._c;
  return n("NewsList", { attrs: { type: "originals", items: e.sortedItems, panelId: e.panelId, isCompact: e.isCompact, isFocused: e.isFocused, active: e.active, loadMethod: e.loadNewsOriginals, loadParams: e.loadParams, forceRefresh: e.forceRefresh }, on: { openPanel: e.openInSeparatePanel, refreshed: function(r) {
    return e.$emit("refreshed");
  } }, scopedSlots: e._u([{ key: "news-entry-delimiter", fn: function({ item: r, index: s, currentDate: i }) {
    return [e.needDateDelimiter(r, s) ? n("PbDateDelimiter", { key: i, attrs: { date: r.created_at, color: "#fff" } }) : e._e()];
  } }, { key: "news-list-entry", fn: function({ item: r }) {
    return [n("NewsOriginalsEntry", { attrs: { entry: r, isCompact: e.isCompact }, on: { openInSeparatePanel: function(s) {
      return e.openInSeparatePanel(r);
    } } })];
  } }]) });
}, wXe = [];
const y$ = {
  $style: yXe
};
function SXe(t) {
  for (var e in y$)
    this[e] = y$[e];
}
var IXe = /* @__PURE__ */ B(
  bXe,
  _Xe,
  wXe,
  !1,
  SXe,
  null
);
const EXe = IXe.exports, xXe = "_root_9hqt1_1", CXe = "_anchor_9hqt1_5", TXe = "_popup_9hqt1_10", PXe = "_button_9hqt1_14", kXe = "_clear_9hqt1_27", NXe = "_menu_9hqt1_32", $Xe = "_menuItem_9hqt1_40", DXe = "_menuTooltip_9hqt1_49", AXe = {
  root: xXe,
  anchor: CXe,
  popup: TXe,
  button: PXe,
  clear: kXe,
  menu: NXe,
  menuItem: $Xe,
  menuTooltip: DXe
}, OXe = {
  name: "NewsOriginalsParticipantsFilter",
  components: { PbButton: nt, PsKitPopup: Ls, PbAuthorManager: M8, PbActionsButtonGroup: Ou },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "recipients",
      validator: (t) => ["senders", "recipients"].includes(t)
    },
    placement: {
      type: String,
      default: "bottom-start"
    }
  },
  data() {
    return {
      manager: {
        isVisible: !1,
        position: {
          top: 0,
          left: 0
        }
      },
      itemsSelected: [...this.values]
    };
  },
  computed: {
    ...pe(["getMailGroupsAndRegisteredUsers", "getUserAndUserGroups"]),
    items() {
      return this.type === "senders" ? this.getMailGroupsAndRegisteredUsers : this.getUserAndUserGroups;
    },
    buttonLabel() {
      const t = this.values.length;
      return t === 0 ? this.type === "recipients" ? "Получ." : "Отпр." : this.type === "recipients" ? `${t} получ.` : `${t} отпр.`;
    },
    trackItemsShift() {
      return this.type === "senders" ? 1 : 2;
    }
  },
  methods: {
    addItem(t) {
      this.itemsSelected.push(t);
    },
    removeItem(t) {
      this.itemsSelected = this.itemsSelected.filter((e) => e !== t);
    },
    clearFilter() {
      this.itemsSelected = [], this.$emit("update", this.itemsSelected);
    },
    applyChanges() {
      this.$emit("update", this.itemsSelected), this.cleanupChanges(), this.hideFilter();
    },
    cancelChanges() {
      this.itemsSelected = Or(this.values), this.cleanupChanges(), this.hideFilter();
    },
    cleanupChanges() {
      this.$refs.manager.$refs.treeEnhanced.$refs.tree.$refs.searchField.clearQuery();
    },
    showFilter() {
      this.manager.isVisible = !0, this.$emit("visible");
    },
    hideFilter() {
      this.$nextTick(() => {
        this.manager.isVisible = !1, this.$emit("hidden");
      });
    },
    isSelectable(t) {
      return this.type === "senders" ? t.isUser : !0;
    }
  }
};
var MXe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e._t("button", function() {
    return [n("PbButton", { ref: "button", class: e.$style.button, on: { click: e.showFilter } }, [n("span", [e._v(e._s(e.buttonLabel))]), n("PbButton", { directives: [{ name: "show", rawName: "v-show", value: e.values.length, expression: "values.length" }], class: e.$style.clear, attrs: { round: "" }, on: { "!click": function(r) {
      return r.stopPropagation(), e.clearFilter.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "14" } })], 1)], 1)];
  }, null, { showFilter: e.showFilter, clearFilter: e.clearFilter }), e.manager.isVisible ? n("PsKitPopup", { class: e.$style.anchor, attrs: { visible: e.manager.isVisible, classPopup: e.$style.popup, arrowVisible: !1, placement: e.placement }, on: { hide: e.hideFilter } }, [n("PbAuthorManager", { ref: "manager", style: { height: "min(80vh, 500px)" }, attrs: { selectedAuthors: e.itemsSelected, allAuthors: e.items, anchor: "top", isThemed: !1, isSelectable: e.isSelectable, trackShift: e.trackItemsShift }, on: { authorAdded: e.addItem, authorDeleted: e.removeItem }, scopedSlots: e._u([{ key: "footer", fn: function() {
    return [n("PbActionsButtonGroup", { attrs: { applyFn: e.applyChanges, cancelFn: e.cancelChanges } })];
  }, proxy: !0 }], null, !1, 2910861601) })], 1) : e._e()], 2);
}, RXe = [];
const b$ = {
  $style: AXe
};
function LXe(t) {
  for (var e in b$)
    this[e] = b$[e];
}
var FXe = /* @__PURE__ */ B(
  OXe,
  MXe,
  RXe,
  !1,
  LXe,
  null
);
const BXe = FXe.exports, jXe = "_root_1574i_1", WXe = "_datePicker_1574i_1", HXe = "_refresh_1574i_4", VXe = {
  root: jXe,
  datePicker: WXe,
  refresh: HXe
}, zXe = {
  name: "NewsOriginalsPanel",
  components: {
    PbPanel: bs,
    PbButton: nt,
    PbDatepicker: D8,
    NewsOriginalsList: EXe,
    NewsOriginalsParticipantsFilter: BXe
  },
  props: {
    panel: Object,
    isFocused: Boolean
  },
  data() {
    return {
      forceRefresh: !1
    };
  },
  computed: {
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    ...pe(["getUserAndUserGroups"]),
    ...pe("news", { appliedFilters: "getAppliedFiltersOriginalsSet" }),
    ...pe("userProfile", ["getSendersFilters", "getRecipientsFilters"]),
    appliedRange() {
      var t, e, n, r;
      return {
        start: (e = (t = this.appliedFilters) == null ? void 0 : t.range) != null && e.start ? new Date(this.appliedFilters.range.start) : bi(),
        end: (r = (n = this.appliedFilters) == null ? void 0 : n.range) != null && r.end ? new Date(this.appliedFilters.range.end) : Yc()
      };
    },
    userHasPermissions() {
      return this.getIsUserHasAllPermissions(["2.17"]);
    },
    requestParams() {
      const t = this.appliedFilters.senders || [], e = this.appliedFilters.recipients || Object.keys(this.getUserAndUserGroups), n = e.filter((s) => !/G$/g.test(s)).map((s) => parseInt(s)), r = e.filter((s) => /G$/g.test(s)).map((s) => parseInt(s));
      return {
        limit: 30,
        from_dt: lt(this.appliedFilters, "range.start", bi()),
        to_dt: lt(this.appliedFilters, "range.end", Yc()),
        sender_ids: t.join(","),
        recipient_user_ids: n.join(","),
        recipient_group_ids: r.join(",")
      };
    }
  },
  created() {
    this.applyProfileFilters();
  },
  methods: {
    ...ge("panels", ["removePanel"]),
    ...ge("news", ["setOriginalsFilters", "loadOriginals"]),
    ...ge("userProfile", ["setProfileFilters"]),
    applyProfileFilters() {
      let t = {};
      const e = this.getSendersFilters;
      e && (t.senders = [...e.ids || []]);
      const n = this.getRecipientsFilters;
      if (n.users || n.groups) {
        const r = lt(n, "groups.ids") || [], s = lt(n, "users.ids") || [];
        t.recipients = [...r.map((i) => `${i}G`), ...s];
      }
      this.setOriginalsFilters(t);
    },
    handleRangeUpdate(t) {
      this.setOriginalsFilters({ range: t });
    },
    handleSendersFilterUpdate(t) {
      this.setProfileFilters({
        type: ve.originals,
        value: { senders: { ids: [...t] } }
      }), this.setOriginalsFilters({ senders: [...t] });
    },
    handleRecipientsFilterUpdate(t) {
      const e = [], n = [];
      t.forEach((r) => {
        /G$/g.test(r) ? n.push(parseInt(r)) : e.push(r);
      }), this.setProfileFilters({
        type: ve.originals,
        value: {
          recipientUsers: { ids: e },
          recipientGroups: { ids: n }
        }
      }), this.setOriginalsFilters({ recipients: [...t] });
    },
    remove() {
      this.removePanel({ panelId: this.panel.id });
    },
    getIsFocused() {
      return this.isFocused;
    }
  }
};
var UXe = function() {
  var e = this, n = e._self._c;
  return n("PbPanel", { class: e.$style.root, attrs: { panel: e.panel, isFocused: e.isFocused, userHasPermissions: e.userHasPermissions, title: "Лента оригиналов" }, scopedSlots: e._u([{ key: "appBarActions", fn: function() {
    return [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Обновить", expression: "'Обновить'" }], class: e.$style.refresh, attrs: { round: "" }, on: { click: function(r) {
      r.preventDefault(), r.stopPropagation(), e.forceRefresh = !0;
    } } }, [n("icon", { attrs: { type: "font", name: "refresh", size: "24" } })], 1), n("PbButton", { attrs: { round: "" }, on: { click: function(r) {
      return r.preventDefault(), r.stopPropagation(), e.remove.apply(null, arguments);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)];
  }, proxy: !0 }, e.userHasPermissions ? { key: "appbar-extension", fn: function() {
    return [n("div", { class: [e.$style.appBar, "panel-toolbar-extension"] }, [n("PbDatepicker", { class: e.$style.datePicker, attrs: { values: e.appliedRange, placement: "bottom-start" }, on: { rangeSelected: e.handleRangeUpdate } }), n("NewsOriginalsParticipantsFilter", { attrs: { values: e.appliedFilters.senders || [], type: "senders" }, on: { update: e.handleSendersFilterUpdate } }), n("NewsOriginalsParticipantsFilter", { attrs: { values: e.appliedFilters.recipients || [] }, on: { update: e.handleRecipientsFilterUpdate } })], 1)];
  }, proxy: !0 } : null, { key: "content", fn: function() {
    return [n("NewsOriginalsList", { attrs: { panelId: e.panel.id, isFocused: e.getIsFocused, isCompact: e.panel.settings.compact, loadParams: e.requestParams, forceRefresh: e.forceRefresh }, on: { refreshed: function(r) {
      e.forceRefresh = !1;
    } } })];
  }, proxy: !0 }], null, !0) });
}, GXe = [];
const _$ = {
  $style: VXe
};
function YXe(t) {
  for (var e in _$)
    this[e] = _$[e];
}
var ZXe = /* @__PURE__ */ B(
  zXe,
  UXe,
  GXe,
  !1,
  YXe,
  null
);
const XXe = ZXe.exports, KXe = {
  name: "NewsPublishedActions",
  props: {
    size: {
      type: Number,
      default: 18
    },
    newsItemId: {
      type: Number,
      default: null
    },
    defaultPopupPosition: {
      type: String,
      default: "right"
    },
    compact: {
      type: Boolean,
      default: !1
    }
  },
  components: { PbMainActionButton: fn, NewsRepublishCtr: Uf, NewsItemPanelMenu: I8 },
  setup(t) {
    const e = Jt("store"), {
      republishManagerVisible: n,
      republishNewsItem: r,
      toggleRepublishManager: s,
      republishAction: i,
      getIsPublicationCode: o,
      isReleased: a
    } = C8(
      { newsItemId: Mw(t, "newsItemId") },
      e
    ), l = et(!1);
    function c() {
      Gd(l);
    }
    return {
      republishManagerVisible: n,
      republishNewsItem: r,
      toggleRepublishManager: s,
      republishAction: i,
      getIsPublicationCode: o,
      isReleased: a,
      revoke: () => e.dispatch("news/revokeNewsItem", { newsItemId: t.newsItemId }),
      menuVisible: l,
      toggleMenu: c
    };
  }
};
var JXe = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "root NewsPublishedActions" }, [n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Повтор", expression: "'Повтор'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }, { name: "show", rawName: "v-show", value: e.isReleased, expression: "isReleased" }], staticClass: "pb-action-button", attrs: { iconName: "outline/republish", size: e.size, "data-test-selector": "entry-button-republish" }, on: { click: function(r) {
    return e.$emit("republish");
  } } }, [e._v("Повтор ")]), n("PbMainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.isReleased, expression: "isReleased" }, { name: "tooltip", rawName: "v-tooltip", value: "Добавить коды", expression: "'Добавить коды'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }], staticClass: "pb-action-button", attrs: { iconName: "outline/plus", size: e.size, "data-test-selector": "entry-button-add-codes" }, on: { click: function(r) {
    return r.stopPropagation(), e.toggleRepublishManager.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "extension", fn: function() {
    return [e.republishManagerVisible ? n("NewsRepublishCtr", { attrs: { visible: e.republishManagerVisible, newsItemId: e.newsItemId, action: e.republishAction, position: e.defaultPopupPosition }, on: { hide: function(r) {
      e.republishManagerVisible = !1;
    } } }) : e._e()];
  }, proxy: !0 }]) }, [e._v(e._s(e.compact ? null : "Добавить коды") + " ")]), n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Расширить", expression: "'Расширить'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "pb-action-button", attrs: { iconName: "outline/bonds", size: e.size, "data-test-selector": "entry-button-extend" }, on: { click: function(r) {
    return e.$emit("extend");
  } } }, [e._v(e._s(e.compact ? null : "Расширить") + " ")]), n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Действия с новостью", expression: "'Действия с новостью'" }], staticClass: "pb-action-button right", attrs: { iconName: "outline/menu-burger", size: e.size, "data-test-selector": "entry-button-menu", isTextHidden: !0 }, on: { click: function(r) {
    return r.stopPropagation(), e.toggleMenu.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "extension", fn: function() {
    return [e.menuVisible ? n("NewsItemPanelMenu", { attrs: { newsItemId: e.newsItemId, panelId: "none", parentId: "none", excludeSections: [
      "withNewsbreak",
      "withDelete",
      "withClose",
      "withForbiddenEntities",
      "withRecall",
      "withLang",
      "withCopyText"
    ], visible: e.menuVisible, position: "bottom" }, on: { revoke: e.revoke, hide: function(r) {
      e.menuVisible = !1;
    } } }) : e._e()];
  }, proxy: !0 }]) }), n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Открыть в отдельной панели", expression: "'Открыть в отдельной панели'" }], staticClass: "pb-action-button", attrs: { iconName: "outline/open-out", size: e.size, "data-test-selector": "entry-button-open-in-separate-panel" }, on: { click: function(r) {
    return e.$emit("openInSeparatePanel");
  } } })], 1);
}, qXe = [], QXe = /* @__PURE__ */ B(
  KXe,
  JXe,
  qXe,
  !1,
  null,
  "bc7d8891"
);
const eKe = QXe.exports;
function tKe(t) {
  return Object.entries(t).map(([e, n]) => `${e.replace(/[A-Z]/g, (s) => `-${s.toLowerCase()}`)}:${n}`).join(";");
}
function nKe(t, e) {
  const n = `.${e}{${tKe(t)}}`;
  var r = document.createElement("style");
  r.styleSheet ? r.styleSheet.cssText = n : r.appendChild(document.createTextNode(n)), document.getElementsByTagName("head")[0].appendChild(r);
}
function R8(t) {
  t.$destroy(), t.$el.remove();
}
function rKe() {
  const t = /* @__PURE__ */ new WeakMap();
  function e(n) {
    if (t.has(n)) {
      const { tt: r, aborter: s } = t.get(n);
      r && R8(r), s && s.abort(), t.delete(n);
    }
  }
  return { gStore: t, moveGarbage: e };
}
function sKe(t, e, n) {
  let r;
  function s() {
    r = setTimeout(t, n);
  }
  function i() {
    clearTimeout(r), e();
  }
  return { wrappedShow: s, wrappedHide: i };
}
const iKe = {
  position: "absolute",
  // required
  backgroundColor: "#000",
  color: "#fff",
  borderRadius: "8px",
  zIndex: 102,
  // для того, чтобы перекрывал z-index панели задач
  padding: "10px",
  pointerEvents: "none",
  // text
  width: "max-content",
  maxWidth: "40vw",
  textAlign: "center",
  // animation
  opacity: 0,
  transition: "opacity 100ms 10ms"
};
let x1;
function oKe(t) {
  return {
    install(e, n = {}) {
      const r = {
        ...iKe,
        ...n.style || {}
      }, s = "PskitTooltip", i = s, o = i + "Component", a = 100;
      nKe(r, s);
      const l = i + "__container", c = document.createElement("span");
      c.id = l, document.body.appendChild(c), c.style = "position: relative;";
      const u = e.component(o, {
        props: {
          value: {
            type: [String, Object],
            // String | { html: Boolean, content: String }
            required: !0
          }
        },
        setup(h) {
          const m = {
            class: s,
            domProps: {}
          };
          let v;
          return typeof h.value == "string" || h.value instanceof String ? v = { content: h.value } : v = { ...h.value }, v.class && (m.class = [m.class, v.class]), v.style && (m.style = [m.style, v.style]), v.html ? m.domProps.innerHTML = v.content : m.domProps.innerText = v.content, () => t("span", m);
        }
      }), { gStore: d, moveGarbage: f } = rKe();
      function p(h, m) {
        const v = [
          "top",
          "top-start",
          "top-end",
          "right",
          "right-start",
          "right-end",
          "bottom",
          "bottom-start",
          "bottom-end",
          "left",
          "left-start",
          "left-end"
        ], _ = m.arg || Object.keys(m.modifiers || {}).find(
          (P) => v.includes(P)
        ) || "top";
        let w;
        const S = new AbortController();
        d.set(h, { aborter: S });
        function E() {
          if (!d.has(h))
            return;
          w = new u({
            propsData: { value: m.value }
          }).$mount(), c.appendChild(w.$el), m.value.trigger === "click" && document.addEventListener("mousedown", T, !0), d.get(h).tt = w;
          const P = {
            anchor: h,
            floating: w.$el,
            arrow: null
          };
          ZR(
            { placement: _ },
            () => null,
            P.anchor,
            P.floating,
            P.arrow
          ), w.$el.style.opacity = 1;
        }
        function x() {
          w && (R8(w), delete d.get(h).tt, w = null);
        }
        function T(P) {
          w && !w.$el.contains(P.target) && (P.stopPropagation(), x(), document.removeEventListener("mousedown", T, !0));
        }
        const { wrappedShow: C, wrappedHide: k } = sKe(E, x, a);
        if ({
          hover: [
            ["mouseenter", C],
            ["mouseleave", k],
            ["click", k]
          ],
          click: [["mousedown", C]],
          manual: []
        }[m.value.trigger || "hover"].forEach(
          ([P, N]) => h.addEventListener(P, N, { signal: S.signal })
        ), m.value.trigger === "manual") {
          if (!Object.prototype.hasOwnProperty.call(m.value, "shown"))
            throw new Error(
              "PskitTooltip DefinitionError: опция trigger=manual требует задания поля shown для ручного управления тултипом."
            );
          d.get(h).hide = k, d.get(h).show = C;
        }
      }
      x1 = {
        bind(h, m) {
          p(h, m);
        },
        update(h, m) {
          if ((typeof m.value == "string" || m.value instanceof String ? m.value !== m.oldValue : m.oldValue.content !== m.value.content) && (f(h), p(h, m)), m.value.trigger !== "manual") return;
          const { hide: y, show: _ } = d.get(h);
          m.value.shown ? _() : y();
        },
        unbind(h) {
          f(h);
        }
      }, e.directive("tooltip", x1);
    }
  };
}
const aKe = {
  mounted() {
    this.$nextTick(() => {
      this.markupEntities();
    });
  },
  methods: {
    markupEntities() {
      if (!this.version.entities) return;
      const t = this.version.entities.map((n) => n.entity);
      this.$el.querySelectorAll("span[data-entity-id]").forEach((n) => {
        const r = parseInt(n.getAttribute("data-entity-id"), 10), s = t.find((a) => a.id === r);
        let i, o;
        s.is_forbidden ? (i = "padding: 0 2px; background: #F6C344; color: #ffffff;", o = `Запрещённая организация: <b>${s.name}</b>`) : (i = "color: #0069e4", o = `${Object.values(s.properties).map(
          (a) => `${a} — `
        )}${s.name}`), n.setAttribute("style", i), x1.bind(n, {
          value: {
            html: !0,
            content: o
          }
        });
      });
    }
  }
}, lKe = "_root_1a0rb_1", cKe = "_root_expandable_1a0rb_10", uKe = "_total_1a0rb_10", dKe = "_more_1a0rb_11", fKe = "_fade_1a0rb_26", pKe = "_root_expanded_1a0rb_34", hKe = "_root_invertedColors_1a0rb_39", mKe = "_delimiter_1a0rb_39", vKe = "_codes_1a0rb_40", gKe = {
  root: lKe,
  root_expandable: cKe,
  total: uKe,
  more: dKe,
  fade: fKe,
  root_expanded: pKe,
  root_invertedColors: hKe,
  delimiter: mKe,
  codes: vKe
}, yKe = {
  name: "PbEntryCodes",
  props: {
    codes: {
      type: Array,
      default: () => []
    },
    preferableGroupIds: {
      type: Array,
      default: () => []
    },
    compact: {
      type: Boolean,
      default: !0
    },
    expandable: {
      type: Boolean,
      default: !1
    },
    invertedColors: {
      type: Boolean,
      default: !1
    },
    collapseOnExpanded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      isExpanded: !1
    };
  },
  computed: {
    sortedCodes() {
      return fs(this.preferableGroupIds) ? this.codes : [...this.codes].sort((t, e) => {
        var s, i, o, a;
        const n = this.preferableGroupIds.includes(
          (i = (s = t.code) == null ? void 0 : s.category) == null ? void 0 : i.id
        ), r = this.preferableGroupIds.includes(
          (a = (o = e.code) == null ? void 0 : o.category) == null ? void 0 : a.id
        );
        return n && !r ? -1 : !n && r ? 1 : 0;
      });
    },
    visible() {
      const t = this.compact ? 25 : 75;
      return this.sortedCodes.reduce(
        (e, n, r) => {
          if (e.codes < r)
            return e;
          const s = n.code.name;
          return e.symbols + s.length <= t && (e.symbols += s.length, e.codes += 1), e;
        },
        { codes: 0, symbols: 0 }
      );
    },
    visibleCodes() {
      return this.sortedCodes.slice(0, this.visible.codes || 0).map((t) => ({
        id: t.code.id,
        name: t.code.name,
        category: t.code.category.name
      }));
    },
    restCodes() {
      return this.sortedCodes.slice(this.visible.codes).map((t) => t.code.name);
    },
    rootClass() {
      return {
        [this.$style.root]: !0,
        [this.$style.root_expandable]: this.expandable,
        [this.$style.root_expanded]: this.isExpanded,
        [this.$style.root_invertedColors]: this.invertedColors
      };
    }
  },
  methods: {
    pluralize: Pv,
    handleToggle() {
      this.expandable && (this.isExpanded = !this.isExpanded, this.$emit("expandEntryCodes", this.isExpanded));
    }
  }
};
var bKe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.rootClass }, [e.expandable && !e.isExpanded ? n("span", { class: e.$style.fade }) : e._e(), !e.isExpanded || !e.collapseOnExpanded ? n("span", { class: e.$style.codes }, [e._l(e.visibleCodes, function(r, s) {
    return n("span", { key: r.id }, [n("span", { attrs: { title: r.category } }, [e._v(e._s(r.name))]), s !== e.visibleCodes.length - 1 ? n("span", [e._v(e._s(", "))]) : e._e()]);
  }), e.isExpanded && e.restCodes.length ? n("span", [e.visibleCodes.length ? n("span", [e._v(e._s(", "))]) : e._e(), e._v(e._s(e.restCodes.join(", ")))]) : e._e()], 2) : e._e(), e.restCodes.length && e.visibleCodes.length && !e.isExpanded ? n("span", { class: e.$style.more, on: { click: e.handleToggle } }, [e.expandable ? e._e() : n("span", { class: e.$style.delimiter }, [e._v(", ")]), e._v("Еще " + e._s(e.restCodes.length) + " ")]) : e._e(), e.isExpanded && e.collapseOnExpanded ? n("span", { class: e.$style.more, on: { click: e.handleToggle } }, [e._v(" Свернуть ")]) : e._e(), !e.visibleCodes.length && e.restCodes.length && !this.isExpanded ? n("span", { class: e.$style.total, on: { click: e.handleToggle } }, [e._v(" " + e._s(e.restCodes.length) + " " + e._s(e.pluralize(e.restCodes.length, ["код", "кода", "кодов"])) + " ")]) : e._e()]);
}, _Ke = [];
const w$ = {
  $style: gKe
};
function wKe(t) {
  for (var e in w$)
    this[e] = w$[e];
}
var SKe = /* @__PURE__ */ B(
  yKe,
  bKe,
  _Ke,
  !1,
  wKe,
  null
);
const IKe = SKe.exports;
function EKe(t, e) {
  function n(r) {
    r.code === "ShiftRight" && e.value && (document.activeElement === t.value ? t.value.blur() : t.value.focus());
  }
  return Io(() => {
    document.addEventListener("keydown", n);
  }), Nf(() => {
    document.removeEventListener("keydown", n);
  }), {};
}
const xKe = "_root_uwla3_1", CKe = "_contentWrapper_uwla3_5", TKe = "_content_uwla3_5", PKe = "_contentInner_uwla3_31", kKe = "_codes_uwla3_39", NKe = "_codesDetails_uwla3_49", $Ke = "_headline_uwla3_55", DKe = "_type_uwla3_62", AKe = "_date_uwla3_66", OKe = "_author_uwla3_67", MKe = "_editor_uwla3_68", RKe = "_subheadline_uwla3_78", LKe = "_slugline_uwla3_85", FKe = "_dateline_uwla3_86", BKe = "_trashline_uwla3_87", jKe = "_body_uwla3_96", WKe = "_footer_uwla3_121", HKe = "_republishWidget_uwla3_127", VKe = "_closeButton_uwla3_136", zKe = "_highlight_uwla3_140", UKe = {
  root: xKe,
  contentWrapper: CKe,
  content: TKe,
  contentInner: PKe,
  codes: kKe,
  codesDetails: NKe,
  headline: $Ke,
  type: DKe,
  date: AKe,
  author: OKe,
  editor: MKe,
  subheadline: RKe,
  slugline: LKe,
  dateline: FKe,
  trashline: BKe,
  body: jKe,
  footer: WKe,
  republishWidget: HKe,
  closeButton: VKe,
  highlight: zKe
}, GKe = {
  name: "NewsPublishedItemView",
  mixins: [aKe],
  components: {
    NewsItemCodes: d6,
    PbEntryCodes: IKe,
    PbDateWidget: Hr,
    PbCircularLoader: br
  },
  props: {
    newsItem: {
      type: Object,
      required: !0
    },
    version: {
      type: Object,
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    const t = Jt("store"), e = le(() => t.getters["panels/focusedPanel"].type === "published"), n = et(null);
    return EKe(n, e), { content: n };
  },
  data() {
    return { isCodesExpanded: !1 };
  },
  computed: {
    ...st("news/codes", { codeItems: (t) => t.items }),
    ...pe("news/codes", [
      "newsCodes",
      "iptcCodeId",
      "ipoiCodeId",
      "ptCodeId"
    ]),
    preferableCodeGroupIds() {
      return [this.ipoiCodeId, this.ptCodeId];
    },
    authors() {
      return this.version.authors.map(
        (t) => `${this.formatUsername(t.user.name)} (${t.user.code})`
      ).join(" / ");
    },
    editors() {
      const t = this.newsItem.publisher;
      return `${this.formatUsername(t.name)} (${t.code})`;
    }
  },
  watch: {
    newsItem(t, e) {
      t.id !== e.id && (this.isCodesExpanded = !1, this.$refs.content.scrollTop = 0, this.$nextTick(() => {
        this.markupEntities();
      }));
    }
  },
  methods: {
    handleCodesToggle(t) {
      this.isCodesExpanded = t;
    }
  }
};
var YKe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.contentWrapper }, [n("div", { ref: "content", class: e.$style.content, attrs: { tabindex: "-1" } }, [!e.newsItem || !e.version || !e.newsItem.id || !e.version.id ? n("PbCircularLoader", { attrs: { size: 30 } }) : n("div", { class: e.$style.contentInner }, [e.version.slugline ? n("div", { class: e.$style.slugline, domProps: { innerHTML: e._s(e.version.slugline) } }) : e._e(), e.version.headline ? n("h3", { class: e.$style.headline, domProps: { innerHTML: e._s(e.version.headline) } }) : e._e(), e.newsItem.status_modified_at ? n("div", { class: e.$style.date }, [n("PbDateWidget", { attrs: { date: e.newsItem.status_modified_at, highlightColor: "#0069e4" } })], 1) : e._e(), e.version.authors ? n("div", { class: e.$style.author }, [n("span", [e._v("Автор: ")]), n("span", { class: e.$style.highlight, attrs: { "data-test-selector": "authors-list" } }, [e._v(" " + e._s(e.authors) + " ")])]) : e._e(), e.newsItem.publisher ? n("div", { class: e.$style.editor }, [n("span", [e._v("Редактор: ")]), n("span", { class: e.$style.highlight, attrs: { "data-test-selector": "editors-list" } }, [e._v(" " + e._s(e.editors) + " ")])]) : e._e(), e.version.subheadline ? n("div", { class: e.$style.subheadline, domProps: { innerHTML: e._s(e.version.subheadline) } }) : e._e(), e.version.trashline ? n("div", { class: e.$style.trashline, domProps: { innerHTML: e._s(e.version.trashline) } }, [e._v(" " + e._s(e.version.trashline) + " ")]) : e._e(), e.version.dateline ? n("div", { class: e.$style.dateline, domProps: { innerHTML: e._s(e.version.dateline) } }, [e._v(" " + e._s(e.version.dateline) + " ")]) : e._e(), e.version.body ? n("div", { class: e.$style.body, domProps: { innerHTML: e._s(e.version.body) } }) : e._e()])], 1), e.version.codes ? n("div", { key: e.newsItem.id, class: e.$style.codes }, [n("transition", { attrs: { name: "fade-in" } }, [n("NewsItemCodes", { directives: [{ name: "show", rawName: "v-show", value: e.isCodesExpanded, expression: "isCodesExpanded" }], class: e.$style.codesDetails, attrs: { newsItemId: e.newsItem.id, isEditable: !1, version: e.version, codeItems: e.codeItems, iptcCodeId: e.iptcCodeId, newsCodes: e.newsCodes, colorScheme: { groupColor: "000", codeColor: "0069e4" } } })], 1), n("PbEntryCodes", { key: e.newsItem.id, attrs: { codes: e.version.codes, preferableGroupIds: e.preferableCodeGroupIds, compact: e.isCompact, collapseOnExpanded: !0, expandable: "" }, on: { expandEntryCodes: e.handleCodesToggle } })], 1) : e._e()]);
}, ZKe = [];
const S$ = {
  $style: UKe
};
function XKe(t) {
  for (var e in S$)
    this[e] = S$[e];
}
var KKe = /* @__PURE__ */ B(
  GKe,
  YKe,
  ZKe,
  !1,
  XKe,
  null
);
const JKe = KKe.exports;
function qKe({ newsItem: t, version: e }, { throttleTime: n = 300, debounceTime: r = 300 } = {}) {
  let s = null, i = /* @__PURE__ */ new Date();
  const o = et(t.value), a = et(e.value);
  function l(u, d) {
    o.value = u, a.value = d;
  }
  const c = or(
    () => t.value,
    (u, d) => {
      if ((u == null ? void 0 : u.id) !== (d == null ? void 0 : d.id)) {
        const f = i;
        i = /* @__PURE__ */ new Date(), clearTimeout(s), i - f > n ? l(u, e.value) : s = setTimeout(() => l(u, e.value), r);
      }
    }
  );
  return {
    newsItem_debounced: o,
    version_debounced: a,
    cancelDebounce: c
  };
}
const QKe = "_root_uwla3_1", eJe = "_contentWrapper_uwla3_5", tJe = "_content_uwla3_5", nJe = "_contentInner_uwla3_31", rJe = "_codes_uwla3_39", sJe = "_codesDetails_uwla3_49", iJe = "_headline_uwla3_55", oJe = "_type_uwla3_62", aJe = "_date_uwla3_66", lJe = "_author_uwla3_67", cJe = "_editor_uwla3_68", uJe = "_subheadline_uwla3_78", dJe = "_slugline_uwla3_85", fJe = "_dateline_uwla3_86", pJe = "_trashline_uwla3_87", hJe = "_body_uwla3_96", mJe = "_footer_uwla3_121", vJe = "_republishWidget_uwla3_127", gJe = "_closeButton_uwla3_136", yJe = "_highlight_uwla3_140", bJe = {
  root: QKe,
  contentWrapper: eJe,
  content: tJe,
  contentInner: nJe,
  codes: rJe,
  codesDetails: sJe,
  headline: iJe,
  type: oJe,
  date: aJe,
  author: lJe,
  editor: cJe,
  subheadline: uJe,
  slugline: dJe,
  dateline: fJe,
  trashline: pJe,
  body: hJe,
  footer: mJe,
  republishWidget: vJe,
  closeButton: gJe,
  highlight: yJe
}, _Je = {
  name: "NewsPublishedSupplyPanel",
  components: {
    PbPanel: bs,
    NewsPublishedActions: eKe,
    NewsPublishedItemView: JKe,
    NewsItemPanelControls: AI
  },
  props: {
    panel: { type: Object, required: !0 },
    parent: { type: Object, default: null },
    isFocused: { type: Boolean, default: !1 },
    withHighlight: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = Jt("store"), n = {
      $store: e,
      ...pe("references", ["newsTypesByName"]),
      ...pe("panels", ["getParentPanelIndex"]),
      ...pe("news/codes", ["getIsPublicationCode"]),
      ...pe("news", ["getNewsItemById", "getNewsItemCurrentVersion"]),
      ...pe("news/search", ["getSearchNewsVersion"])
    };
    for (const v in n)
      typeof n[v] == "function" && (n[v] = n[v]());
    const r = {
      $store: e,
      ...ge("news", [
        "openPublishedNewsItem",
        "republish",
        "extendNewsItem"
      ]),
      ...ge("panels", ["hideSupply"])
    };
    function s() {
      r.hideSupply({
        panelId: t.parent.id,
        supplyId: t.panel.id
      });
    }
    function i() {
      r.openPublishedNewsItem({
        entry: u.value,
        panelId: t.parent.id
      });
    }
    function o() {
      r.republish({ newsItemId: u.value.id });
    }
    function a() {
      r.extendNewsItem({
        newsItemId: u.value.id,
        panelIndex: n.getParentPanelIndex(t.panel.id)
      });
    }
    const l = le(
      () => n.getNewsItemById(t.panel.dataId)
    ), c = le(() => {
      var v;
      return ((v = t == null ? void 0 : t.parent) == null ? void 0 : v.type) === "search" ? n.getSearchNewsVersion(t.panel.dataId) || {} : n.getNewsItemCurrentVersion(t.panel.dataId) || {};
    }), { newsItem_debounced: u, version_debounced: d } = qKe({
      newsItem: l,
      version: c
    }), f = le(
      () => t.panel.settings.widthScaleFactor <= c4.newsItem.default
    ), p = le(
      () => d.value.type_id === n.newsTypesByName.EXPRESS.id
    ), h = qO(), m = le(() => ({
      [h.root]: !0,
      withHighlight: t.withHighlight,
      // для глобальных стилей
      [h.root_express]: p.value
    }));
    return {
      closeSupplyPanel: s,
      openInSeparatePanel: i,
      rootClass: m,
      isCompact: f,
      isExpress: p,
      newsItem_debounced: u,
      version_debounced: d,
      republishNewsItem: o,
      extendNewsItem: a
    };
  }
};
var wJe = function() {
  var e = this, n = e._self._c;
  return e.version_debounced && e.newsItem_debounced ? n("PbPanel", { class: e.rootClass, attrs: { panel: e.panel, backgroundColor: "#f2f2f2", toolbarColor: "#f2f2f2", toolbarProps: { styleRoot: { borderBottom: "1px solid #C9D4E1" } }, resizeable: !1 }, scopedSlots: e._u([{ key: "menu", fn: function() {
    return [n("NewsPublishedActions", { attrs: { newsItemId: e.newsItem_debounced.id, defaultPopupPosition: "bottom", compact: e.isCompact }, on: { republish: e.republishNewsItem, openInSeparatePanel: e.openInSeparatePanel, extend: e.extendNewsItem } })];
  }, proxy: !0 }, { key: "appBarActions", fn: function({ toggleMaximized: r }) {
    return [n("NewsItemPanelControls", { attrs: { sizeTools: { closePanel: e.closeSupplyPanel, toggleMaximized: r }, btnStyle: {
      backgroundColor: "#CADFF9",
      color: "var(--theme-editorControlColor)",
      width: "22px",
      height: "22px",
      marginRight: "5px"
    }, visibleButtons: ["close"] } })];
  } }, { key: "content", fn: function() {
    return [n("NewsPublishedItemView", { attrs: { newsItem: e.newsItem_debounced, version: e.version_debounced, isCompact: e.isCompact } })];
  }, proxy: !0 }], null, !1, 3414936836) }) : e._e();
}, SJe = [];
const I$ = {
  $style: bJe
};
function IJe(t) {
  for (var e in I$)
    this[e] = I$[e];
}
var EJe = /* @__PURE__ */ B(
  _Je,
  wJe,
  SJe,
  !1,
  IJe,
  null
);
const E$ = EJe.exports, xJe = (t, e) => {
  let n = "";
  for (let [r, s] of t.entries()) {
    n = n + "(";
    for (let i of s)
      i.string !== "" && (i.operator === "И" && (n = n + "&"), i.operator === "ИЛИ" && (n = n + "||"), i.operator === "И НЕ" && (n = n + "&!"), i.operator === "ИЛИ НЕ" && (n = n + "||!"), i.operator === "НЕ" && (n = n + "!"), n = n + i.string);
    n = n + ")", r < t.length - 1 && (n = n + (e[r] === "И" ? "&" : "||"));
  }
  return n;
}, CJe = "_root_8etl9_1", TJe = "_counter_8etl9_8", PJe = "_tooltip_8etl9_14", kJe = "_item_8etl9_30", NJe = "_tag_8etl9_34", $Je = "_tag_inprogress_8etl9_37", DJe = "_tag_published_8etl9_40", AJe = "_tag_waiting_8etl9_43", OJe = "_user_8etl9_47", MJe = {
  root: CJe,
  counter: TJe,
  tooltip: PJe,
  item: kJe,
  tag: NJe,
  tag_inprogress: $Je,
  tag_published: DJe,
  tag_waiting: AJe,
  user: OJe
}, RJe = (t) => {
  if (t != null && t.groups && (t != null && t.users)) {
    const e = t.groups.map(({ group: r }) => r.code), n = t.users.filter((r) => r.can_work).map(({ user: r }) => r.code);
    return [...e, ...n].join(", ");
  }
  return "";
}, LJe = {
  name: "NewsRepublishStatus",
  components: {
    PbCircularLoader: br
  },
  inject: ["panelId"],
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    }
  },
  data() {
    return {
      tooltip: {
        isLoading: !1,
        isVisible: !1,
        position: {
          top: 0,
          left: 0
        },
        visiblilityTimer: null
      }
    };
  },
  computed: {
    ...pe("references", ["newsStatusesByName"]),
    ...pe("news", ["getNewsItemById", "getNewsItemCurrentVersion"]),
    ...pe("news/links", [
      "getChildLinksById",
      "getPublishedChildLinksById"
    ]),
    children() {
      return this.getChildLinksById(this.newsItemId).filter(
        (t) => !t.is_disposed
      );
    },
    publishedChildren() {
      return this.getPublishedChildLinksById(this.newsItemId);
    },
    hasChildren() {
      return this.publishedChildren.length || this.children.length;
    },
    childrenInProgress() {
      return this.children.length - this.publishedChildren.length;
    },
    childStatusWaitForEdit() {
      return (t) => this.getNewsItemCurrentVersion(t.news_id).status_id === this.newsStatusesByName.WAITS_FOR_EDIT.id;
    },
    childStatusWaitForPublication() {
      return (t) => this.getNewsItemCurrentVersion(t.news_id).status_id === this.newsStatusesByName.WAITS_FOR_PUBLICATION.id;
    },
    childStatusWaiting() {
      return (t) => this.childStatusWaitForEdit(t) || this.childStatusWaitForPublication(t);
    },
    iconName() {
      return this.publishedChildren.length ? "republish-active" : this.children.length ? "republish-work" : "republish-none";
    },
    tooltipData() {
      return (t) => t.is_published ? this.getNewsItemById(t.news_id) : this.getNewsItemCurrentVersion(t.news_id);
    },
    tooltipUserData() {
      return (t) => {
        const e = this.getNewsItemById(t.news_id), n = this.getNewsItemCurrentVersion(t.news_id);
        return t.is_published || this.childStatusWaitForPublication(t) ? lt(e, "publisher.code") : this.childStatusWaiting(t) ? RJe(e) : lt(n, "user.code");
      };
    }
  },
  watch: {
    async "tooltip.isVisible"(t) {
      if (!t) return;
      this.children.reduce((n, r) => (n.push(!!this.tooltipData(r)), n), []).filter((n) => !!n).length === this.children.length || (this.tooltip.isLoading = !0, await this.fetchLinkedNews(this.newsItemId)), this.tooltip.isLoading = !1;
    }
  },
  methods: {
    ...ge("news", ["openPublishedNewsItem"]),
    ...ge("news/links", ["fetchLinkedNews"]),
    hideTooltip() {
      this.tooltip.visiblilityTimer = setTimeout(() => {
        this.tooltip.isVisible = !1;
      }, 50);
    },
    showTooltip() {
      this.tooltip.visiblilityTimer && clearTimeout(this.tooltip.visiblilityTimer);
      const t = this.$refs.root.getBoundingClientRect();
      this.tooltip.position = {
        top: `${t.top + 16}px`,
        left: `${t.left + globalThis.scrollX}px`
      }, this.tooltip.isVisible = !0;
    },
    clearTimeout() {
      this.tooltip.visiblilityTimer && clearTimeout(this.tooltip.visiblilityTimer);
    },
    openInPanel(t) {
      this.openPublishedNewsItem({
        entry: this.getNewsItemById(t.news_id),
        panelId: this.panelId
      });
    }
  }
};
var FJe = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "root", class: e.$style.root, attrs: { "data-test-selector": "republish-status", "data-test-attrs": e.iconName }, on: { mouseenter: e.showTooltip, mouseleave: e.hideTooltip } }, [n("icon", { class: e.$style.icon, attrs: { name: e.iconName, size: "14" } }), e.childrenInProgress ? n("div", { class: e.$style.counter }, [e._v(" " + e._s(e.childrenInProgress) + " ")]) : e._e(), e.tooltip.isVisible ? n("portal", { attrs: { to: "tooltips" } }, [n("div", { key: `republish-${e.newsItemId}`, class: e.$style.tooltip, style: { top: e.tooltip.position.top, left: e.tooltip.position.left }, on: { mouseenter: e.clearTimeout, mouseleave: e.hideTooltip } }, [e.tooltip.isLoading ? n("PbCircularLoader", { class: e.$style.loader, attrs: { size: 12 } }) : e.hasChildren ? n("table", e._l(e.children, function(r) {
    return n("tr", { key: r.news_id, class: e.$style.item }, [r.is_published ? n("td", { class: [e.$style.tag, e.$style.tag_published] }, [e._v(" Выпущено ")]) : e.childStatusWaitForEdit(r) ? n("td", { class: [e.$style.tag, e.$style.tag_waiting] }, [e._v(" Ожидает ред. ")]) : e.childStatusWaitForPublication(r) ? n("td", { class: [e.$style.tag, e.$style.tag_waiting] }, [e._v(" Ожидает опубл. ")]) : n("td", { class: [e.$style.tag, e.$style.tag_inprogress] }, [e._v(" В работе ")]), n("td", { class: e.$style.user, on: { "!click": function(s) {
      return s.stopPropagation(), e.openInPanel(r);
    } } }, [e._v(" " + e._s(e.tooltipUserData(r)) + " ")])]);
  }), 0) : n("div", [e._v("Нет переопубликованных новостей")])], 1)]) : e._e()], 1);
}, BJe = [];
const x$ = {
  $style: MJe
};
function jJe(t) {
  for (var e in x$)
    this[e] = x$[e];
}
var WJe = /* @__PURE__ */ B(
  LJe,
  FJe,
  BJe,
  !1,
  jJe,
  null
);
const HJe = WJe.exports, VJe = "_root_1blbg_1", zJe = "_counter_1blbg_8", UJe = "_tooltip_1blbg_15", GJe = "_item_1blbg_31", YJe = "_tag_1blbg_35", ZJe = "_tag_inprogress_1blbg_38", XJe = "_tag_published_1blbg_41", KJe = "_tag_waiting_1blbg_44", JJe = "_user_1blbg_48", qJe = {
  root: VJe,
  counter: zJe,
  tooltip: UJe,
  item: GJe,
  tag: YJe,
  tag_inprogress: ZJe,
  tag_published: XJe,
  tag_waiting: KJe,
  user: JJe
}, QJe = (t) => {
  if (t != null && t.groups && (t != null && t.users)) {
    const e = t.groups.map(({ group: r }) => r.code), n = t.users.filter((r) => r.can_work).map(({ user: r }) => r.code);
    return [...e, ...n].join(", ");
  }
  return "";
}, eqe = {
  name: "NewsExtensionStatus",
  components: {
    PbCircularLoader: br,
    PbNewsTypeButton: ea
  },
  inject: ["panelId"],
  props: {
    newsItemId: {
      type: [String, Number],
      required: !0
    }
  },
  data() {
    return {
      tooltip: {
        isLoading: !1,
        isVisible: !1,
        position: {
          top: 0,
          left: 0
        },
        visiblilityTimer: null
      }
    };
  },
  computed: {
    ...pe("references", ["newsStatusesByName", "newsTypesByName"]),
    ...pe("news", ["getNewsItemById", "getNewsItemCurrentVersion"]),
    ...pe("news/links", ["getNewsItemExtensions"]),
    extensionLinks() {
      return this.getNewsItemExtensions(this.newsItemId);
    },
    extensionsCount() {
      return this.extensionLinks.length;
    },
    childTypeId() {
      return (t) => {
        var e;
        return (e = this.getNewsItemCurrentVersion(t.news_id)) == null ? void 0 : e.type_id;
      };
    },
    childTypeButtonColor() {
      return (t) => [
        this.newsTypesByName.FLASH.id,
        this.newsTypesByName.EXPRESS.id
      ].includes(this.childTypeId(t)) ? "#D0021B" : this.isSelected ? "#0069e4" : "#b3b3b3";
    },
    childStatusWaitForEdit() {
      return (t) => {
        var e;
        return ((e = this.getNewsItemCurrentVersion(t.news_id)) == null ? void 0 : e.status_id) === this.newsStatusesByName.WAITS_FOR_EDIT.id;
      };
    },
    childStatusWaitForPublication() {
      return (t) => {
        var e;
        return ((e = this.getNewsItemCurrentVersion(t.news_id)) == null ? void 0 : e.status_id) === this.newsStatusesByName.WAITS_FOR_PUBLICATION.id;
      };
    },
    childStatusWaiting() {
      return (t) => this.childStatusWaitForEdit(t) || this.childStatusWaitForPublication(t);
    },
    tooltipData() {
      return (t) => t.is_published ? this.getNewsItemById(t.news_id) : this.getNewsItemCurrentVersion(t.news_id);
    },
    tooltipUserData() {
      return (t) => {
        const e = this.getNewsItemById(t.news_id), n = this.getNewsItemCurrentVersion(t.news_id);
        return t.is_published || this.childStatusWaitForPublication(t) ? lt(e, "publisher.code") : this.childStatusWaiting(t) ? QJe(e) : lt(n, "user.code");
      };
    }
  },
  watch: {
    async "tooltip.isVisible"(t) {
      if (!t) return;
      this.extensionLinks.reduce((n, r) => (n.push(!!this.tooltipData(r)), n), []).filter((n) => !!n).length === this.extensionLinks.length || (this.tooltip.isLoading = !0, await this.fetchLinkedNews(this.newsItemId)), this.tooltip.isLoading = !1;
    }
  },
  methods: {
    ...ge("news", ["openPublishedNewsItem"]),
    ...ge("news/links", ["fetchLinkedNews"]),
    hideTooltip() {
      this.tooltip.visiblilityTimer = setTimeout(() => {
        this.tooltip.isVisible = !1;
      }, 50);
    },
    showTooltip() {
      this.tooltip.visiblilityTimer && clearTimeout(this.tooltip.visiblilityTimer);
      const t = this.$refs.root.getBoundingClientRect();
      this.tooltip.position = {
        top: `${t.top + 16}px`,
        left: `${t.left + globalThis.scrollX}px`
      }, this.tooltip.isVisible = !0;
    },
    clearTimeout() {
      this.tooltip.visiblilityTimer && clearTimeout(this.tooltip.visiblilityTimer);
    },
    openInPanel(t) {
      this.openPublishedNewsItem({
        entry: this.getNewsItemById(t.news_id),
        panelId: this.panelId
      });
    }
  }
};
var tqe = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "root", class: e.$style.root, on: { mouseenter: e.showTooltip, mouseleave: e.hideTooltip } }, [n("icon", { attrs: { name: "extension", color: "#d31515", size: "14" } }), e.extensionsCount ? n("div", { class: e.$style.counter }, [e._v(" " + e._s(e.extensionsCount) + " ")]) : e._e(), e.tooltip.isVisible ? n("portal", { attrs: { to: "tooltips" } }, [n("div", { key: `extension-${e.newsItemId}`, class: e.$style.tooltip, style: { top: e.tooltip.position.top, left: e.tooltip.position.left }, on: { mouseenter: e.clearTimeout, mouseleave: e.hideTooltip } }, [e.tooltip.isLoading ? n("PbCircularLoader", { class: e.$style.loader, attrs: { size: 12 } }) : e.extensionsCount ? n("table", e._l(e.extensionLinks, function(r) {
    return n("tr", { key: r.news_id, class: e.$style.item }, [r.is_published ? n("td", { class: [e.$style.tag, e.$style.tag_published] }, [e._v(" Выпущено ")]) : e.childStatusWaitForEdit(r) ? n("td", { class: [e.$style.tag, e.$style.tag_waiting] }, [e._v(" Ожидает ред. ")]) : e.childStatusWaitForPublication(r) ? n("td", { class: [e.$style.tag, e.$style.tag_waiting] }, [e._v(" Ожидает опубл. ")]) : n("td", { class: [e.$style.tag, e.$style.tag_inprogress] }, [e._v(" В работе ")]), n("td", { class: e.$style.user, on: { "!click": function(s) {
      return s.stopPropagation(), e.openInPanel(r);
    } } }, [e.childTypeId(r) ? n("PbNewsTypeButton", { attrs: { typeId: e.childTypeId(r), iconSize: 14, buttonStyle: "height: auto;", color: e.childTypeButtonColor(r), disabled: "" } }) : e._e(), e._v(e._s(e.tooltipUserData(r)) + " ")], 1)]);
  }), 0) : n("div", [e._v("Нет расширений")])], 1)]) : e._e()], 1);
}, nqe = [];
const C$ = {
  $style: qJe
};
function rqe(t) {
  for (var e in C$)
    this[e] = C$[e];
}
var sqe = /* @__PURE__ */ B(
  eqe,
  tqe,
  nqe,
  !1,
  rqe,
  null
);
const iqe = sqe.exports, oqe = "_root_677g8_1", aqe = "_list_677g8_8", lqe = "_item_677g8_12", cqe = "_more_677g8_19", uqe = {
  root: oqe,
  list: aqe,
  item: lqe,
  more: cqe
}, dqe = {
  name: "NewsCodesColorBullets",
  props: {
    codeIds: {
      type: Array,
      default: () => []
    },
    allCodeItems: {
      type: Object,
      default: () => ({})
    },
    codeColors: {
      type: Object,
      default: () => ({})
    },
    maxItems: {
      type: Number,
      default: 3
    }
  },
  computed: {
    visibleCodeIds() {
      return this.codeIds.slice(0, this.maxItems);
    },
    codeColor() {
      return (t) => this.codeColors[t] ? this.codeColors[t].value : this.allCodeItems[t].track.reduce((n, r) => {
        var s;
        return n || ((s = this.codeColors[r]) == null ? void 0 : s.value) || null;
      }, null);
    },
    tooltipContent() {
      let t = "";
      return this.codeIds.forEach((e) => {
        const n = this.allCodeItems[e].name, r = this.codeColor(e);
        t += `<span class="bullet" style="background: ${r}"></span>`, t += `&nbsp;${n}<br>`;
      }), t;
    }
  }
};
var fqe = function() {
  var e = this, n = e._self._c;
  return n("div", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: {
    html: !0,
    content: e.tooltipContent,
    class: "NewsCodesColorBullets"
  }, expression: `{
    html: true,
    content: tooltipContent,
    class: 'NewsCodesColorBullets',
  }` }], class: e.$style.root, attrs: { "data-test-selector": "news-codes-color-bullets" } }, [n("ul", { class: e.$style.list }, e._l(e.visibleCodeIds, function(r) {
    return n("li", { key: r, class: e.$style.item, style: { background: e.codeColor(r) }, attrs: { "data-test-selector": "bullet" } });
  }), 0), e.visibleCodeIds.length < e.codeIds.length ? n("div", { class: e.$style.more, attrs: { "data-test-selector": "bullet-more" } }, [e._v(" +" + e._s(e.codeIds.length - e.visibleCodeIds.length) + " ")]) : e._e()]);
}, pqe = [];
const T$ = {
  $style: uqe
};
function hqe(t) {
  for (var e in T$)
    this[e] = T$[e];
}
var mqe = /* @__PURE__ */ B(
  dqe,
  fqe,
  pqe,
  !1,
  hqe,
  null
);
const vqe = mqe.exports;
function gqe({ item: t, codeColors: e, isSelected: n }, r) {
  const s = {
    getIsUrgentVersionType: r.getters["news/versions/getIsUrgentVersionType"],
    getNewsItemById: r.getters["news/getNewsItemById"],
    getNewsItemCurrentVersion: r.getters["news/getNewsItemCurrentVersion"],
    getNewsItemColorsByType: r.getters["news/getNewsItemColorsByType"],
    allCodeItems: r.getters["news/codes/allCodeItems"],
    getIsUserHasPublishingCodes: r.getters["news/codes/getIsUserHasPublishingCodes"],
    getIsFeedCode: r.getters["news/codes/getIsFeedCode"],
    /**
     * [PUB-2859]
     * Устаревшая логика. Коды переопубликования теперь не ограничены префиксом 902.
     **/
    // republishManagerFilter: store.getters['news/codes/getIsPublicationCode'],
    getSearchNewsVersion: r.getters["news/search/getSearchNewsVersion"],
    getIsNewsItemRevoked: r.getters["news/getIsNewsItemRevoked"],
    newsStatuses: r.getters["references/newsStatuses"]
  }, i = le(() => {
    var _;
    return (_ = t.value) == null ? void 0 : _.id;
  }), o = le(() => s.getNewsItemById(i.value) ?? null), a = le(() => {
    if (!l.value.length) return {};
    let _;
    const w = l.value.at(-1);
    return e.value[w] ? _ = e.value[w].value : _ = s.allCodeItems[w].track.reduce((S, E) => {
      var x;
      return S || ((x = e.value[E]) == null ? void 0 : x.value) || null;
    }, null), { color: _ };
  }), l = le(() => s.getNewsItemColorsByType("codes")(i.value) || []), c = le(() => p.value ? "#D0021B" : n.value ? "#0069e4" : "#b3b3b3"), u = Jt("versionType", "regular"), d = le(() => u === "search" ? s.getSearchNewsVersion(i.value) || {} : s.getNewsItemCurrentVersion(i.value) || {}), f = le(() => s.getIsNewsItemRevoked(i.value)), p = le(
    () => s.getIsUrgentVersionType(d.value.type_id)
  ), h = le(
    () => {
      var _, w, S;
      return ((S = (w = s.newsStatuses) == null ? void 0 : w[(_ = d.value) == null ? void 0 : _.status_id]) == null ? void 0 : S.name) === "PUBLISHED";
    }
  ), m = Xn({ visible: !1 });
  return {
    ...s,
    entry: o,
    republishManager: m,
    showRepublishManager: async () => {
      m.visible || document.body.click(), await Ar(), m.visible = !0;
    },
    republishAction: (..._) => r.dispatch("news/republishUneditedNewsItem", ..._),
    fontStyle: a,
    highlightedCodes: l,
    newsTypeButtonColor: c,
    version: d,
    versionType: u,
    isRevoked: f,
    isUrgent: p,
    isReleased: h
  };
}
const yqe = {
  name: "NewsPublishedEntry",
  components: {
    PbNewsTypeButton: ea,
    PbDateWidget: Hr,
    PbEntryDate: nl,
    NewsRepublishStatus: HJe,
    NewsExtensionStatus: iqe,
    PbPanelDynamicEntry: Zv,
    PbMainActionButton: fn,
    PbPanelListEntryActions: Xv,
    NewsRepublishCtr: Uf,
    NewsCodesInline: IL,
    NewsCodesColorBullets: vqe
  },
  props: {
    item: {
      type: Object,
      required: !0
    },
    dateMode: {
      type: Number,
      default: 0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    codeColors: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = Jt("store"), {
      entry: n,
      fontStyle: r,
      highlightedCodes: s,
      version: i,
      isRevoked: o,
      isReleased: a,
      isUrgent: l,
      allCodeItems: c,
      republishManager: u,
      showRepublishManager: d,
      republishAction: f,
      getIsUserHasPublishingCodes: p,
      getIsFeedCode: h,
      newsTypeButtonColor: m
    } = gqe(ts(t), e);
    return {
      entry: n,
      fontStyle: r,
      highlightedCodes: s,
      version: i,
      isRevoked: o,
      isUrgent: l,
      isReleased: a,
      allCodeItems: c,
      republishManager: u,
      showRepublishManager: d,
      republishAction: f,
      getIsUserHasPublishingCodes: p,
      getIsFeedCode: h,
      newsTypeButtonColor: m
    };
  }
  // computed: {
  //   codeColorTitle() {
  //     return id => {
  //       if (this.codeColors[id]) {
  //         return this.allCodeItems[id].name
  //       }
  //       const parent = this.allCodeItems[id].track.reduce((acc, curr) => {
  //         if (acc) return acc
  //         if (this.codeColors[curr]) return curr
  //         return null
  //       }, null)
  //       if (parent) {
  //         return this.allCodeItems[parent].name
  //       }
  //       return null
  //     }
  //   },
  // }
};
var bqe = function() {
  var e = this, n = e._self._c;
  return n("PbPanelDynamicEntry", { class: {
    "news-published-list-entry": !0,
    "in-use": e.republishManager.visible
  }, attrs: { entry: e.entry, body: e.version.headline || e.version.body, dateMode: e.dateMode, isCompact: e.isCompact, isSelected: e.isSelected, isHighlighted: e.isUrgent, isRevoked: e.isRevoked, fontStyle: e.fontStyle }, scopedSlots: e._u([{ key: "header", fn: function() {
    return [e.version.type_id ? n("PbNewsTypeButton", { staticClass: "type", attrs: { typeId: e.version.type_id, iconSize: 18, color: e.newsTypeButtonColor, disabled: "" } }) : e._e(), n("NewsRepublishStatus", { staticClass: "republish", attrs: { newsItemId: e.entry.id } }), n("NewsExtensionStatus", { staticClass: "extension", attrs: { newsItemId: e.entry.id } }), e.entry.publisher ? n("span", { staticClass: "authors" }, [e._v(" " + e._s(e.entry.publisher.code) + " ")]) : e._e(), n("PbEntryDate", { staticClass: "date" }, [n("PbDateWidget", { attrs: { date: e.entry.status_modified_at, mode: e.dateMode }, on: { dateModeChanged: function(r) {
      return e.$emit("dateModeChanged", r);
    } } })], 1), n("NewsCodesColorBullets", { staticClass: "codes-color-bullets", attrs: { codeIds: e.highlightedCodes, allCodeItems: e.allCodeItems, codeColors: e.codeColors } })];
  }, proxy: !0 }, { key: "actions", fn: function() {
    return [n("div", { staticClass: "actions-block" }, [n("PbPanelListEntryActions", { staticClass: "published-actions", attrs: { color: "0069e4", isCompact: e.isCompact } }, [n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Повтор", expression: "'Повтор'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }, { name: "show", rawName: "v-show", value: e.isReleased, expression: "isReleased" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-republish", "data-test-selector": "entry-button-republish" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("republish");
    } } }), n("PbMainActionButton", { directives: [{ name: "show", rawName: "v-show", value: e.isReleased, expression: "isReleased" }, { name: "tooltip", rawName: "v-tooltip", value: "Добавить коды", expression: "'Добавить коды'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.10"], expression: "['2.10']", arg: "all" }], ref: "republishAnchor", staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "entry-button-add-codes" }, on: { click: function(r) {
      return r.stopPropagation(), e.showRepublishManager.apply(null, arguments);
    } }, scopedSlots: e._u([{ key: "extension", fn: function() {
      return [e.republishManager.visible ? n("NewsRepublishCtr", { attrs: { visible: e.republishManager.visible, newsItemId: e.item.id, action: e.republishAction, position: "right" }, on: { hide: function(r) {
        e.republishManager.visible = !1;
      } } }) : e._e()];
    }, proxy: !0 }]) }), n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Расширить", expression: "'Расширить'" }, { name: "permissions", rawName: "v-permissions:all", value: ["2.16"], expression: "['2.16']", arg: "all" }], staticClass: "action mini-button pb-action-button-old", attrs: { iconName: "button-icon-extend", "data-test-selector": "entry-button-extend" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("extend");
    } } }), n("PbMainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Открыть в отдельной панели", expression: "'Открыть в отдельной панели'" }], staticClass: "action mini-button pb-action-button-old show-more", attrs: { iconName: "button-icon-show-more", "data-test-selector": "entry-button-open-in-separate-panel" }, on: { click: function(r) {
      return r.stopPropagation(), e.$emit("openInSeparatePanel");
    } } })], 1)], 1)];
  }, proxy: !0 }, { key: "extra", fn: function() {
    return [n("NewsCodesInline", { key: e.entry.status_modified_at, attrs: { codes: e.version.codes, codesFilter: e.getIsFeedCode, updateKeys: [e.isCompact] } })];
  }, proxy: !0 }]) });
}, _qe = [], wqe = /* @__PURE__ */ B(
  yqe,
  bqe,
  _qe,
  !1,
  null,
  "c7474e97"
);
const Sqe = wqe.exports, Iqe = "_root_jvijh_1", Eqe = {
  root: Iqe
}, xqe = {
  name: "NewsSearchList",
  components: {
    NewsList: Qv,
    NewsPublishedEntry: Sqe
  },
  provide() {
    return {
      panelId: this.panelId,
      versionType: "search"
    };
  },
  props: {
    panelId: {
      type: [String, Number],
      required: !0
    },
    parentPanelId: {
      type: [String, Number],
      required: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    },
    isFocused: {
      type: Function,
      default: () => !1
    },
    isSortedByRelevance: {
      type: Boolean,
      default: !1
    },
    isSuspended: {
      type: Boolean,
      default: !1
    },
    dateMode: {
      type: Number,
      default: 0
    },
    loadParams: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const e = {
      $store: Jt("store"),
      ...ge("news/search", ["selectSearchNewsItem"])
    };
    function n({ entry: r, panelId: s }) {
      e.selectSearchNewsItem({ entry: r, panelId: s });
    }
    return {
      onSelect: n
    };
  },
  computed: {
    ...st({
      items: (t) => t.news.sets.search.list
    }),
    ...pe("news/codes", ["allCodeItems"]),
    ...pe("news", ["getNewsItemById", "getNewsSortedByModified"]),
    ...pe("panels", ["getRootPanelById", "getPanelIndex"]),
    ...pe("userProfile", ["getColorsByType"]),
    ...pe(["getPanelIsActive"]),
    active() {
      return this.getPanelIsActive(this.panelId) && !this.isSuspended;
    },
    sortedItems() {
      return this.getNewsSortedByModified([...this.items]).map((t) => ({ id: t }));
    },
    unsortedItems() {
      return this.items.map((t) => ({ id: t }));
    },
    sizeDependencies() {
      return (t) => {
        var e;
        return [((e = this.selectedEntry) == null ? void 0 : e.id) === (t == null ? void 0 : t.id)];
      };
    },
    codeColors() {
      return this.getColorsByType("codes");
    }
  },
  methods: {
    ...ge("news", {
      loadNewsSearch(t, { params: e, replace: n }) {
        return t("loadNews", { params: e, setType: "search", replace: n });
      },
      republish: "republish",
      openPublishedNewsItem: "openPublishedNewsItem",
      extend: "extendNewsItem"
    }),
    ...ge("panels", {
      setPanelDateMode: "setPanelDateMode",
      setPanelWidthScaleFactor: "setPanelWidthScaleFactor"
    }),
    openInSeparatePanel(t) {
      this.openPublishedNewsItem({ entry: t, panelId: this.panelId });
    },
    republishNewsItem(t) {
      this.republish({ newsItemId: t.id });
    },
    extendNewsItem(t) {
      const e = this.getPanelIndex(this.parentPanelId);
      this.extend({ newsItemId: t.id, panelIndex: e });
    }
  }
};
var Cqe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "news-published-list" } }, [n("NewsList", { attrs: { type: "search", items: e.isSortedByRelevance ? e.unsortedItems : e.sortedItems, panelId: e.panelId, isFocused: e.isFocused, active: e.active, color: "#fff", hasDateDelimiters: !e.isSortedByRelevance, hasFixedScroll: !1, hasNewIndicator: !1, minimalItemHeight: 64, loadMethod: e.loadNewsSearch, sizeDeps: e.sizeDependencies, loadParams: e.loadParams, showSpinnerOnSequentialLoads: !0 }, on: { openPanel: e.openInSeparatePanel, selectItem: e.onSelect }, scopedSlots: e._u([{ key: "news-list-entry", fn: function({ item: r, isSelected: s }) {
    return [n("NewsPublishedEntry", { class: e.$style.entry, attrs: { item: r, isCompact: e.isCompact, isSelected: s, dateMode: e.dateMode, codeColors: e.codeColors }, on: { dateModeChanged: function(i) {
      return e.setPanelDateMode({ panelId: e.parentPanelId, mode: i });
    }, openInSeparatePanel: function(i) {
      return e.openInSeparatePanel(r);
    }, republish: function(i) {
      return e.republishNewsItem(r);
    }, extend: function(i) {
      return e.extendNewsItem(r);
    } } })];
  } }]) })], 1);
}, Tqe = [];
const P$ = {
  $style: Eqe
};
function Pqe(t) {
  for (var e in P$)
    this[e] = P$[e];
}
var kqe = /* @__PURE__ */ B(
  xqe,
  Cqe,
  Tqe,
  !1,
  Pqe,
  null
);
const Nqe = kqe.exports, $qe = {
  name: "NewsSearchSupplyPanel",
  components: {
    PbPanel: bs,
    NewsSearchList: Nqe
  },
  props: {
    panel: { type: Object, required: !0 },
    parent: { type: Object, default: null },
    isFocused: { type: Boolean, default: !1 }
  },
  computed: {
    ...pe("news/search", ["getSearchParams", "getSettingSearchParams"]),
    ...pe(["getGroupsAndUsers"]),
    isSortedByRelevance() {
      return this.getSearchParams.sorting === "relevance";
    },
    isSuspendedLoading() {
      return this.getSettingSearchParams;
    },
    requestParams() {
      const t = this.getSearchParams, e = t.query.reduce((l, c) => (c.length && c.length === 1 && c[0].string === "" || l.push(c), l), []);
      let n, r;
      switch (t.interval) {
        case 0:
          n = bi();
          break;
        case 1:
          n = U5(), r = bi();
          break;
        case 7:
          n = go(bi(), 7), r = /* @__PURE__ */ new Date();
          break;
        case 30:
          n = go(bi(), 30), r = /* @__PURE__ */ new Date();
          break;
        case 999:
          n = null, r = null;
          break;
        case "custom":
          n = t.range.start, r = t.range.end;
      }
      const s = t.codes || [], i = (t.authors || []).reduce(
        (l, c) => (/G$/g.test(c.id) ? this.getGroupsAndUsers[c.id].children.forEach((d) => {
          t.authors.find((p) => p.id === d) || l.push({ id: d, state: c.state });
        }) : l.push({ id: c.id, state: c.state }), l),
        []
      ), o = (l) => {
        if (!Array.isArray(l)) return l;
        if (!(l.length === 1 && l[0] == 0))
          return l.join(",");
      }, a = {
        query: xJe(e, t.queryGroupOperators),
        code_ids: ba(s, "included"),
        code_excluded_ids: ba(s, "excluded"),
        code_ignored_ids: ba(s, "ignored"),
        user_ids: ba(i, "included"),
        user_excluded_ids: ba(i, "excluded"),
        target_ids: o(t.field),
        status_ids: o(t.status),
        type_ids: o(t.type),
        language_ids: o(t.language),
        link_type_ids: o(t.link),
        sort_by_relevance: this.isSortedByRelevance
      };
      return n !== null && (a.from_dt = n), r !== null && (a.to_dt = r), a;
    }
  },
  methods: {
    getIsFocused() {
      return this.isFocused;
    }
  }
};
var Dqe = function() {
  var e = this, n = e._self._c;
  return n("PbPanel", { attrs: { panel: e.panel, title: "Результаты поиска", backgroundColor: "#fff" }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [n("NewsSearchList", { attrs: { panelId: e.panel.id, parentPanelId: e.parent.id, isFocused: e.getIsFocused, isCompact: e.panel.settings.compact, isSuspended: e.isSuspendedLoading, isSortedByRelevance: e.isSortedByRelevance, dateMode: e.panel.settings.dateMode, loadParams: e.requestParams } })];
  }, proxy: !0 }]) });
}, Aqe = [], Oqe = /* @__PURE__ */ B(
  $qe,
  Dqe,
  Aqe,
  !1,
  null,
  null
);
const Mqe = Oqe.exports, Rqe = {
  name: "NewsEmbargoSupplyCtr",
  mixins: [ai],
  components: {
    NewsItemPanel: OI
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    parent: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      newsItem: {}
    };
  },
  watch: {
    "panel.dataId"(t, e) {
      t !== e && (clearTimeout(this.updateTimeout), this.updateTimeout = setTimeout(() => {
        this.newsItem = this.getNewsItemById(t) || {};
      }, 300));
    },
    "version.status_id"(t, e) {
      t !== e && t !== 8 && this.hideSupply({ panelId: this.parent.id, supplyId: this.panel.id });
    }
  },
  computed: {
    ...pe("news", ["getNewsItemById", "getNewsItemCurrentVersion"]),
    panelStyle() {
      return {
        color: this.editorStyle.color,
        backgroundColor: this.editorStyle.backgroundColor
      };
    },
    version() {
      return this.getNewsItemCurrentVersion(this.panel.dataId) ?? {};
    },
    newsItemParentId() {
      var t;
      return ((t = this.newsItem) == null ? void 0 : t.parent_id) || null;
    }
  },
  created() {
    this.updateTimeout = null, this.newsItem = this.getNewsItemById(this.panel.dataId) || {};
  },
  methods: {
    ...ge("panels", ["hideSupply"]),
    initEditorStore(t) {
      const { type: e, editor: n } = t;
      this.$store.$_newsEditors[this.newsItem.id] || (this.$store.$_newsEditors[this.newsItem.id] = {}), this.$store.$_newsEditors[this.newsItem.id][e] = n;
    }
  }
};
var Lqe = function() {
  var e = this, n = e._self._c;
  return e.newsItem.id ? n("NewsItemPanel", { attrs: { panel: e.panel, newsItemId: e.newsItem.id, newsItem: e.newsItem, panelStyle: e.panelStyle, newsItemParentId: e.newsItemParentId, parentId: e.parent.id }, on: { initEditorStore: e.initEditorStore } }) : e._e();
}, Fqe = [], Bqe = /* @__PURE__ */ B(
  Rqe,
  Lqe,
  Fqe,
  !1,
  null,
  null
);
const jqe = Bqe.exports, Wqe = {
  name: "CanvasEditor",
  components: {
    DefaultBlock: Xo
  },
  mixins: [qv],
  props: {
    canvas: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const t = {
      type: "body",
      title: "Текст",
      format: "html",
      visible: !0,
      errors: [],
      warnings: [],
      maxSymbols: 1 / 0,
      initial: !0,
      initialized: !1
    }, e = {};
    e[`editor-${t.type}`] = et(null);
    const n = Xn(w8(ve.newsCanvas, e));
    return {
      block: t,
      history: n,
      ...e
    };
  },
  data() {
    return {
      content: this.canvas.body ?? "",
      loaded: !1,
      // нужно для корректной работы fragmentSelectionMixin
      elementFocused: !1
      // нужно для корректной работы fragmentSelectionMixin
    };
  },
  async mounted() {
    this.loaded = !0;
  },
  beforeDestroy() {
    this.history.unregister(), delete this.$store.$_newsEditors.canvas;
  },
  methods: {
    handleFocus() {
      this.$emit("focus"), this.elementFocused = !0;
    },
    handleBlur() {
      this.$emit("blur"), this.elementFocused = !1;
    },
    initEditorStore(t) {
      const { type: e, editor: n } = t;
      this.$store.$_newsEditors.canvas || (this.$store.$_newsEditors.canvas = {}), this.$store.$_newsEditors.canvas[e] = n;
    }
  }
};
var Hqe = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "selectionRangeContent", staticClass: "canvas-editor" }, [n("DefaultBlock", { ref: `editor-${e.block.type}`, attrs: { block: e.block, type: e.block.type, content: e.content, historyStack: e.history.stack }, on: { update: function(r) {
    return e.$emit("update", r);
  }, fragmentSelected: function(r) {
    return e.$emit("fragmentSelected", r);
  }, focus: e.handleFocus, editorBlur: e.handleBlur, initEditorStore: e.initEditorStore } })], 1);
}, Vqe = [], zqe = /* @__PURE__ */ B(
  Wqe,
  Hqe,
  Vqe,
  !1,
  null,
  null
);
const Uqe = zqe.exports, Gqe = {
  name: "CanvasPanelToolbar",
  components: {
    ToolbarWrapper: hg,
    ToolbarVertical: DI,
    PbButton: nt
  },
  props: {
    isRightSupplyVisible: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      canvasColors: B2
    };
  },
  computed: {
    history() {
      return $I.editors[ve.newsCanvas] ?? null;
    },
    undoable() {
      var t, e, n;
      return !!((n = (e = (t = this.history) == null ? void 0 : t.stack) == null ? void 0 : e.undo) != null && n.length);
    },
    redoable() {
      var t, e, n;
      return !!((n = (e = (t = this.history) == null ? void 0 : t.stack) == null ? void 0 : e.redo) != null && n.length);
    }
  },
  methods: {
    undo() {
      this.history && this.history.undo();
    },
    redo() {
      this.history && this.history.redo();
    }
  }
};
var Yqe = function() {
  var e = this, n = e._self._c;
  return n("ToolbarWrapper", { attrs: { position: "right" } }, [n("ToolbarVertical", { style: {
    border: "1px solid #" + e.canvasColors.innerBorderColor
  } }, [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Отменить ввод текста", expression: "'Отменить ввод текста'", modifiers: { right: !0 } }], staticClass: "control undo", class: { _disabled: !e.undoable }, attrs: { disabled: !e.undoable, role: "undo" }, on: { click: e.undo } }, [n("icon", { attrs: { name: "undo", size: "16" } })], 1), n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Повторить ввод текста", expression: "'Повторить ввод текста'", modifiers: { right: !0 } }], staticClass: "control redo", class: { _disabled: !e.redoable }, attrs: { disabled: !e.redoable, role: "redo" }, on: { click: e.redo } }, [n("icon", { attrs: { name: "undo", size: "16" } })], 1), n("hr", { staticClass: "divider" }), n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.right", value: "Показать коды", expression: "'Показать коды'", modifiers: { right: !0 } }], staticClass: "control", attrs: { activeClass: "control_active", active: e.isRightSupplyVisible }, on: { click: function(r) {
    return e.$emit("toggleRightSupply");
  } } }, [n("icon", { attrs: { name: "codes" } })], 1)], 1)], 1);
}, Zqe = [], Xqe = /* @__PURE__ */ B(
  Gqe,
  Yqe,
  Zqe,
  !1,
  null,
  null
);
const Kqe = Xqe.exports, Jqe = {
  name: "NewsCanvasPanel",
  components: {
    Panel: bs,
    MainActionButton: fn,
    NewsItemPanelControls: AI,
    CanvasEditor: Uqe,
    CanvasPanelToolbar: Kqe,
    DialogConfirm: Gu
  },
  props: {
    panel: {
      type: Object,
      required: !0
    },
    isFocused: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selectedFragment: null,
      isConfirmDialogOpen: !1,
      canvasColors: B2
    };
  },
  created() {
    this.$registerShortcut("Enter", this.handleEnter, { enabled: this.isFocused });
  },
  mounted() {
    this.fetchData(), document.addEventListener("selectstart", this.preventSelection, {
      capture: !0
    });
  },
  beforeDestroy() {
    document.removeEventListener("selectstart", this.preventSelection);
  },
  watch: {
    isFocused(t) {
      t ? this.$enableShortcut("Enter") : this.$disableShortcut("Enter");
    },
    isConfirmDialogOpen(t) {
      var e, n, r, s, i, o;
      t ? (r = (n = (e = this.$store.$_newsEditors.canvas) == null ? void 0 : e.body) == null ? void 0 : n.view) == null || r.dom.blur() : (o = (i = (s = this.$store.$_newsEditors.canvas) == null ? void 0 : s.body) == null ? void 0 : i.view) == null || o.dom.focus();
    }
  },
  computed: {
    ...st({
      fullscreenPanel: (t) => t.panels.uiState.fullscreen
    }),
    ...pe("panels", ["getIsPanelRightSupplyVisible"]),
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    ...pe("canvases", ["getCurrentCanvas", "getCanvasCodes"]),
    isPanelFullscreen() {
      return this.fullscreenPanel === this.panel.id;
    },
    isRightSupplyVisible() {
      return this.getIsPanelRightSupplyVisible(this.panel.id);
    },
    userHasPermissions() {
      return this.getIsUserHasAllPermissions([u6.NEWS.CANVAS]);
    },
    canvas() {
      return this.getCurrentCanvas;
    },
    canvasCodes() {
      var t;
      return this.getCanvasCodes((t = this.canvas) == null ? void 0 : t.id);
    }
  },
  methods: {
    ...ge(["addMessage"]),
    ...ge("panels", [
      "showSupply",
      "hideSupply"
    ]),
    ...ge({
      setPanelFocus: "setPanelEditorFocus"
    }),
    ...ge("canvases", [
      "fetchCanvas",
      "updateCanvasBody",
      "publishFlashFromCanvasFragment"
    ]),
    async fetchData() {
      this.fetchCanvas();
    },
    focusHandler(t) {
      this.setPanelFocus({ panelId: this.panel.id, focused: t });
    },
    closePanel() {
      this.$store.dispatch("panels/removePanel", { panelId: this.panel.id });
    },
    handleEnter(t) {
      t.stopPropagation(), t.ctrlKey && (this.isConfirmDialogOpen = !0);
    },
    publishFragmentAsFlash() {
      if (this.isConfirmDialogOpen = !1, !this.canvasCodes.length) {
        this.addMessage({ text: "Необходимо выбрать коды публикации", type: "warning" });
        return;
      }
      this.publishFlashFromCanvasFragment({
        type_id: 1,
        slugline: "МОЛНИЯ",
        headline: this.selectedFragment ?? this.canvas.body,
        language_id: 1
      });
    },
    toggleRightSupply() {
      const t = {
        panelId: this.panel.id,
        supplyId: this.panel.supply.right[0].id
      };
      this.isRightSupplyVisible ? this.hideSupply(t) : this.showSupply(t);
    },
    updateCanvas(t) {
      this.updateCanvasBody({ canvasId: this.canvas.id, body: t });
    },
    preventSelection(t) {
      this.isConfirmDialogOpen && t.preventDefault();
    },
    setFragmentSelected(t) {
      this.selectedFragment = t ?? null;
    }
  }
};
var qqe = function() {
  var e = this, n = e._self._c;
  return n("Panel", { staticClass: "canvas-panel", staticStyle: { "border-radius": "6px 6px 6px 6px" }, attrs: { panel: e.panel, isFocused: e.isFocused, userHasPermissions: e.userHasPermissions, isFullscreen: e.isPanelFullscreen, hasTitleBar: !0, resizeable: !1, backgroundColor: "#" + e.canvasColors.backgroundColor, toolbarProps: {
    styleContent: { padding: "5px 15px" },
    styleRoot: {
      borderBottom: "1px solid #" + e.canvasColors.innerBorderColor
    }
  }, toolbarColor: "inherit" }, scopedSlots: e._u([{ key: "appBarActions", fn: function({ isMaximized: r, isFullscreen: s, toggleMaximized: i, toggleFullscreen: o }) {
    return [n("div", { staticClass: "canvas-panel__appbar" }, [n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip:bottom", value: "Молния на ленту", expression: "'Молния на ленту'", arg: "bottom" }], staticClass: "pb-action-button draggable-ignore", attrs: { iconName: "outline/flash", buttonStyle: { backgroundColor: "#" + e.canvasColors.accentColor }, size: 18 }, nativeOn: { click: function(a) {
      e.isConfirmDialogOpen = !0;
    } } }), n("NewsItemPanelControls", { attrs: { sizeTools: { isMaximized: r, isFullscreen: s, toggleMaximized: i, toggleFullscreen: o, closePanel: e.closePanel }, btnStyle: {
      backgroundColor: "#" + e.canvasColors.editorControlBgColor,
      color: "#" + e.canvasColors.editorControlColor,
      width: "22px",
      height: "22px",
      marginRight: "5px"
    } } })], 1)];
  } }, { key: "content", fn: function() {
    return [n("div", { staticClass: "canvas-panel__body-wrapper" }, [n("div", { staticClass: "canvas-panel__body" }, [n("h3", { staticClass: "canvas-panel__title" }, [e._v("Холст")]), e.canvas ? n("CanvasEditor", { attrs: { canvas: e.canvas }, on: { update: e.updateCanvas, focus: function(r) {
      return e.focusHandler(!0);
    }, blur: function(r) {
      return e.focusHandler(!1);
    }, fragmentSelected: function(r) {
      return e.setFragmentSelected(r);
    } } }) : e._e(), n("CanvasPanelToolbar", { staticClass: "canvas-panel__right-toolbar", attrs: { isRightSupplyVisible: e.isRightSupplyVisible }, on: { toggleRightSupply: e.toggleRightSupply } })], 1)]), n("DialogConfirm", { attrs: { state: e.isConfirmDialogOpen, acceptButtonLabel: "Да", declineButtonLabel: "Нет", initActiveButton: "agree" }, on: { "update:state": function(r) {
      e.isConfirmDialogOpen = r;
    }, agree: e.publishFragmentAsFlash }, scopedSlots: e._u([{ key: "question", fn: function() {
      return [n("h3", [e._v("Опубликовать молнию?")])];
    }, proxy: !0 }]) })];
  }, proxy: !0 }]) });
}, Qqe = [], eQe = /* @__PURE__ */ B(
  Jqe,
  qqe,
  Qqe,
  !1,
  null,
  null
);
const tQe = eQe.exports, nQe = "_root_19jem_1", rQe = "_badge_19jem_15", sQe = "_icon_19jem_19", iQe = {
  root: nQe,
  badge: rQe,
  icon: sQe
}, oQe = {
  name: "TasksBadge",
  components: {
    PbBadge: s2,
    PbIcon: cc
  },
  computed: {
    ...pe("news", ["newsUnread"]),
    ...pe("newsbreaks", ["getNewsbreaksUnreadCount"]),
    unreadCount() {
      return this.getNewsbreaksUnreadCount + this.newsUnread("inProgress") + this.newsUnread("waiting");
    },
    backgroundColor() {
      return this.unreadCount ? "#D0021B" : "#fff";
    },
    color() {
      return this.unreadCount ? "#fff" : "#000";
    }
  }
};
var aQe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, on: { click: function(r) {
    return e.$emit("expand");
  } } }, [n("PbBadge", { class: e.$style.badge, attrs: { bgColor: e.backgroundColor, color: e.color, alwaysVisible: !0, unread: e.unreadCount } }), n("PbIcon", { class: e.$style.icon, attrs: { type: "font", name: "keyboard_arrow_right" } })], 1);
}, lQe = [];
const k$ = {
  $style: iQe
};
function cQe(t) {
  for (var e in k$)
    this[e] = k$[e];
}
var uQe = /* @__PURE__ */ B(
  oQe,
  aQe,
  lQe,
  !1,
  cQe,
  null
);
const dQe = uQe.exports, fQe = "_root_1o7t6_1", pQe = "_root_fullscreen_1o7t6_16", hQe = "_fullscreen_1o7t6_21", mQe = "_supply_1o7t6_76", vQe = "_tasks_fullscreen_1o7t6_80", gQe = "_tasks_fullscreen_active_1o7t6_88", yQe = "_badge_1o7t6_92", bQe = {
  root: fQe,
  root_fullscreen: pQe,
  fullscreen: hQe,
  "panel-container": "_panel-container_1o7t6_33",
  supply: mQe,
  tasks_fullscreen: vQe,
  tasks_fullscreen_active: gQe,
  badge: yQe
}, N$ = el.getParser(globalThis.navigator.userAgent), _Qe = {
  name: "Panels",
  components: {
    TasksBadge: dQe,
    Draggable: Ioe,
    [ve.disposed]: hi(ODe),
    [ve.search]: hi(fXe),
    [ve.awaitingPublication]: hi(xOe),
    [ve.asoiNotesEmbargo]: JPe,
    [ve.asoiNotes]: Sye,
    [ve.asoiNote]: Dy,
    [ve.asoiNoteEmbargo]: Dy,
    [ve.flow]: FNe,
    [ve.lead]: Xk,
    [ve.newsbreak]: w$e,
    [ve.newsItem]: hi(Tze),
    [ve.originals]: hi(XXe),
    [ve.newsCanvas]: tQe,
    [gt.delayedSupply]: hi(jqe),
    [gt.asoiNoteSupply]: Dy,
    [gt.leadSupply]: Xk,
    [gt.newsItemNewsbreakSupply]: hi(rUe),
    [gt.newsItemAdditionalSupply]: hi(v4e),
    [gt.newsItemVersionsSupply]: hi(Dze),
    [gt.publishedSupply]: hi(E$),
    [gt.searchSupply]: hi(Mqe),
    [gt.searchSecondSupply]: hi(E$),
    [gt.newsCanvasSupply]: rRe
  },
  inject: ["getColorScheme"],
  props: {
    disabled: Boolean
  },
  data() {
    return {
      draggableOpts: {
        animation: 300,
        handle: ".draggable-handle",
        filter: ".draggable-ignore",
        forceFallback: N$.isBrowser("firefox"),
        delay: 150
      },
      fullscreenShowTasks: !1,
      panelScrollDuration: 300,
      viewportHeight: 0
    };
  },
  computed: {
    ...st({
      isDragging: (t) => t.uiState.panelsDragging,
      desiredScrollIndex: (t) => t.panels.uiState.desiredScrollIndex,
      focused: (t) => t.panels.uiState.focused,
      fullscreen: (t) => t.panels.uiState.fullscreen,
      codeManagerFocused: (t) => t.uiState.codeManagerFocused,
      modal: (t) => t.uiState.modal,
      isTaskPanelOpen: (t) => t.uiState.isTaskPanelOpen
    }),
    ...pe({
      editorFocused: "editorInPanelFocused"
    }),
    ...pe("panels", {
      getPanelIndex: "getPanelIndex",
      getPanelVisibleSupplies: "getPanelVisibleSupplies",
      getIsPanelNewsType: "getIsPanelNewsType"
    }),
    panels: {
      get() {
        return this.$store.state.panels.data;
      },
      set(t) {
        this.setPanels(t);
      }
    },
    focusedIndex() {
      let t = this.panels.findIndex(({ id: e }) => e === this.focused);
      return t === -1 && (t = 0), t;
    },
    shortCutDisabled() {
      return this.disabled || this.modal || this.editorFocused || this.codeManagerFocused;
    },
    isRightSupplyHidden() {
      return (t) => {
        const e = lt(t.supply, "right", []);
        return e.length && !lt(e, "0.settings.visible", !1);
      };
    },
    panelMainComponent() {
      return (t) => [ve.asoiNotes, ve.asoiNotesSent].includes(t) ? ve.asoiNotes : [ve.asoiNote, ve.asoiNoteSent].includes(t) ? ve.asoiNote : t;
    },
    panelMinHeight() {
      return N$.isOS("android") ? this.viewportHeight - 100 + "px" : null;
    },
    borderColor() {
      return (t) => {
        let e = "#" + t.settings.color;
        return t.type === ve.newsItem && (e = "#" + this.getColorScheme().accentColor), this.focused === t.id ? e : "transparent";
      };
    },
    additionalSupplyProps() {
      return (t) => t.type === gt.searchSecondSupply ? {
        withHighlight: !0
      } : {};
    }
  },
  watch: {
    focused(t) {
      t && t !== this.fullscreen && this.setPanelFullscreen({ panel: null, fullscreen: !1 });
    },
    fullscreen(t, e) {
      t !== e && !t ? (this.panelScrollDuration = 0, this.fullscreenShowTasks = !1, this.$enableShortcuts()) : (this.$disableShortcuts(), this.$enableShortcut("Enter"));
    },
    panels(t, e) {
      const n = t.map((s) => s.id), r = e.map((s) => s.id);
      !$a(n, r) && this.fullscreen && this.setPanelFullscreen({ panel: null, fullscreen: !1 });
    },
    desiredScrollIndex: {
      handler(t) {
        t !== null && (this.scrollToPanel(t), this.setDesiredScrollIndex(null), this.panelScrollDuration = 300);
      },
      immediate: !0
    },
    shortCutDisabled(t, e) {
      t !== e && (t ? this.$disableShortcuts() : this.$enableShortcuts());
    }
  },
  created() {
    this.globalWrapper = document.querySelector("#legacy-app"), globalThis.addEventListener("orientationchange", this.onOrientationChange), this.onOrientationChange(null, !0), this.onFullscreenToggle = za(this.onFullscreenToggle, 200, {
      trailing: !1
    }), this.onPanelsChoosed = za(this.onPanelsChoosed, 500, {
      trailing: !1
    });
  },
  mounted() {
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].forEach((n) => {
      this.$registerShortcut(n, this.onPanelsChoosed, {
        enabled: !this.disable
      });
    }), ["ArrowLeft", "ArrowRight", "h", "l"].forEach((n) => {
      this.$registerShortcut(n, this.onPanelsNavigate, {
        enabled: !this.disable
      });
    }), this.$registerShortcut("Enter", this.onFullscreenToggle);
  },
  beforeDestroy() {
    globalThis.removeEventListener(
      "orientationchange",
      this.onOrientationChange
    );
  },
  methods: {
    ...ge({
      modalSet: "setModal",
      setPanelsDragging: "setPanelsDragging"
    }),
    ...ge("panels", [
      "setDesiredScrollIndex",
      "setPanelFocused",
      "setPanelFullscreen",
      "setPanels",
      "hideSupply"
    ]),
    $get: lt,
    onDragStart() {
      this.modalSet(!0), this.setPanelsDragging(!0);
    },
    onDragEnd() {
      this.modalSet(!1), this.setPanelsDragging(!1);
    },
    focus(t, e) {
      t === null && (t = lt(this.panels[e], "id")), t !== this.focused && this.setPanelFocused(t);
    },
    calculatePanelOffset(t) {
      let e = 20;
      for (let n = 0; n < t; n++) {
        const r = this.panels[n], s = r.settings.widthScaleFactor || 1;
        e += ji * s + 10;
        const i = this.getPanelVisibleSupplies(r);
        i.length > 0 && i.forEach((o) => {
          e += ji * o.settings.widthScaleFactor;
        }), e += 20;
      }
      return e;
    },
    scrollToPanel(t) {
      if (!this.globalWrapper) return;
      const e = this.globalWrapper.scrollLeft, n = this.globalWrapper.getBoundingClientRect().width, r = e + n, s = this.calculatePanelOffset(t), i = this.panels[t], o = n / 10;
      if (i) {
        const a = i.settings.widthScaleFactor || 1;
        let l = ji * a + 10;
        const c = this.getPanelVisibleSupplies(i);
        c.length > 0 && c.forEach((f) => {
          l += ji * f.settings.widthScaleFactor;
        });
        const u = s + l, d = s;
        if (r < u && l < n - 40) {
          const p = Math.abs(
            u + n + 20 - e
          ) / o * 16;
          jC(u - n + 20, 0, p);
        } else if (e > d || r < u) {
          const p = Math.abs(d - 20 - r) / o * 16;
          jC(d - 20, 0, p);
        }
      }
    },
    onPanelsChoosed(t) {
      if (t.target.nodeName !== "INPUT" && !(t.altKey || t.ctrlKey || t.metaKey || t.shiftKey) && +t.key - 1 < this.panels.length) {
        t.stopPropagation(), t.preventDefault();
        const e = +t.key == 0 ? this.panels.length - 1 : +t.key - 1;
        this.focus(null, e);
      }
    },
    onPanelsNavigate(t) {
      ["h", "l", "ArrowLeft", "ArrowRight"].includes(t.key) && ["INPUT", "TEXTAREA"].includes(t.target.tagName) || t.altKey || t.ctrlKey || t.metaKey || t.shiftKey || (t.stopPropagation(), t.preventDefault(), (t.key === "ArrowLeft" || t.key === "h") && this.focusedIndex > 0 && this.focus(null, this.focusedIndex - 1), (t.key === "ArrowRight" || t.key === "l") && this.focusedIndex < this.panels.length - 1 && this.focus(null, this.focusedIndex + 1));
    },
    onOrientationChange(t, e = !1) {
      if (e)
        this.viewportHeight = globalThis.innerHeight;
      else {
        const n = () => {
          this.viewportHeight = globalThis.innerHeight, window.removeEventListener("resize", n);
        };
        window.addEventListener("resize", n);
      }
    },
    onFullscreenToggle(t) {
      if (!t.altKey && !t.synthetic) return;
      const e = this.panels.find((n) => n.id === this.focused);
      this.getIsPanelNewsType(e) && (this.fullscreen ? (this.setPanelFullscreen({
        panel: null,
        fullscreen: !1
      }), this.setDesiredScrollIndex(this.focusedIndex)) : this.setPanelFullscreen({
        panel: e,
        fullscreen: !0
      }));
    },
    toggleTasks(t) {
      this.fullscreenShowTasks = t, t ? this.focus(this.panels[0].id, 0) : this.focus(this.fullscreen, this.getPanelIndex({ id: this.fullscreen }));
    }
  }
};
var wQe = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { [e.$style.root]: !0, [e.$style.root_fullscreen]: e.fullscreen } }, [e.fullscreen ? n("div", [n("div", { class: e.$style.fullscreen })]) : e._e(), n("Draggable", e._b({ staticClass: "draggable-container", class: { _dragging: e.isDragging }, on: { choose: e.onDragStart, unchoose: e.onDragEnd }, model: { value: e.panels, callback: function(r) {
    e.panels = r;
  }, expression: "panels" } }, "Draggable", e.draggableOpts, !1), [e._l(e.panels, function(r, s) {
    return [r.type !== "tasks" ? n("div", { key: r.id, ref: `panel${s + 1}`, refInFor: !0, class: {
      "panel-container": !0,
      [e.$style["panel-container"]]: !0,
      focused: e.focused === r.id,
      fullscreen: e.fullscreen === r.id,
      "with-task-panel": e.isTaskPanelOpen,
      [r.type]: !0
    }, style: {
      "border-color": e.borderColor(r),
      "min-height": e.panelMinHeight
    }, attrs: { "data-test-selector": "panel-container", "data-test-attrs": `panel-id__${r.id}`, "data-test-id": r.id }, on: { click: function(i) {
      return e.focus(r.id, 1);
    } } }, [r.supply && r.supply.left ? e._l(r.supply.left, function(i) {
      return i.settings && i.settings.visible ? n(i.type, { key: i.id, tag: "component", class: e.$style.supply, attrs: { isFullscreen: !!e.fullscreen, panel: i, parent: r, isFocused: e.focused === r.id } }) : e._e();
    }) : e._e(), n(e.panelMainComponent(r.type), { tag: "component", class: {
      "has-supply-right-hidden": e.isRightSupplyHidden(r)
    }, attrs: { panel: r, type: r.type, isFocused: e.focused === r.id && !e.modal, isFullscreen: e.fullscreen === r.id }, on: { editorToggleSupply: function(i) {
      return e.onFullscreenToggle({ synthetic: !0 });
    } } }), r.supply && r.supply.right ? e._l(r.supply.right, function(i) {
      return i.settings && i.settings.visible ? n(i.type, e._b({ key: i.id, tag: "component", class: {
        [e.$style.supply]: !0,
        "is-visible": i.settings.visible
      }, attrs: { panel: i, parent: r, isFocused: e.focused === r.id }, on: { hideSupply: e.hideSupply } }, "component", e.additionalSupplyProps(i), !1)) : e._e();
    }) : e._e()], 2) : e._e()];
  })], 2)], 1);
}, SQe = [];
const $$ = {
  $style: bQe
};
function IQe(t) {
  for (var e in $$)
    this[e] = $$[e];
}
var EQe = /* @__PURE__ */ B(
  _Qe,
  wQe,
  SQe,
  !1,
  IQe,
  null
);
const xQe = EQe.exports, CQe = "_root_1qzwq_2", TQe = "_toggle_1qzwq_12", PQe = "_toggle_active_1qzwq_22", kQe = "_container_1qzwq_27", NQe = "_actions_1qzwq_42", $Qe = "_action_1qzwq_42", DQe = "_actionButton_1qzwq_60", AQe = "_actionButtonInner_1qzwq_67", OQe = "_actionIcon_1qzwq_74", MQe = "_actionIcon_settings_1qzwq_83", RQe = "_actionName_1qzwq_87", LQe = "_user_1qzwq_92", FQe = "_userItem_1qzwq_100", BQe = "_userAction_1qzwq_109", jQe = "_panelsIcon_1qzwq_117", WQe = "_plusIcon_1qzwq_135", HQe = "_searchIcon_1qzwq_156", VQe = {
  root: CQe,
  toggle: TQe,
  toggle_active: PQe,
  container: kQe,
  actions: NQe,
  action: $Qe,
  actionButton: DQe,
  actionButtonInner: AQe,
  actionIcon: OQe,
  actionIcon_settings: MQe,
  actionName: RQe,
  user: LQe,
  userItem: FQe,
  userAction: BQe,
  panelsIcon: jQe,
  plusIcon: WQe,
  searchIcon: HQe
}, zQe = {
  name: "MainMenu",
  components: { PbButton: nt },
  mixins: [Vr],
  props: {
    leftPos: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      showed: !1
    };
  },
  computed: {
    ...pe("userProfile", ["usernameFormatted"]),
    authData() {
      return this.$store.state.auth;
    }
  },
  methods: {
    ...ge({
      create: "news/createNewsItem"
    }),
    createNewsDraft() {
      this.showed = !1, this.create();
    },
    openManager() {
      this.showed = !1, this.$router.push({ name: "flowsManager" }).catch(() => null);
    },
    openSettings() {
      this.showed = !1, this.$router.push({ name: "settings" }).catch(() => null);
    },
    openSearch() {
      this.showed = !1, this.$router.push({ name: "search" }).catch(() => null);
    }
  }
};
var UQe = function() {
  var e = this, n = e._self._c;
  return n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: () => {
    e.showed = !1;
  }, expression: `
    () => {
      showed = false
    }
  ` }], class: e.$style.root, style: { left: `${e.leftPos}px` }, attrs: { "data-test-selector": "main-menu-container" } }, [e.showed ? n("div", { class: e.$style.container }, [n("div", { class: e.$style.actions }, [n("div", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["2.1"], expression: "['2.1']", arg: "all" }], class: e.$style.action }, [n("PbButton", { class: e.$style.actionButton, attrs: { "data-test-selector": "main-menu-create-draft-button" }, on: { click: e.createNewsDraft } }, [n("div", { class: e.$style.actionButtonInner }, [n("div", { class: e.$style.actionIcon }, [n("span", { class: e.$style.plusIcon })]), n("span", { class: e.$style.actionName }, [e._v("Новый материал")])])])], 1), n("div", { class: e.$style.action }, [n("PbButton", { class: e.$style.actionButton, attrs: { "data-test-selector": "main-menu-manager-button" }, on: { click: e.openManager } }, [n("div", { class: e.$style.actionButtonInner }, [n("div", { class: e.$style.actionIcon }, [n("span", { class: e.$style.panelsIcon }, [n("i"), n("i"), n("i")])]), n("span", { class: e.$style.actionName }, [e._v("Потоки и источники")])])])], 1), n("div", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["2.15"], expression: "['2.15']", arg: "all" }], class: e.$style.action }, [n("PbButton", { class: e.$style.actionButton, attrs: { "data-test-selector": "main-menu-search-button" }, on: { click: e.openSearch } }, [n("div", { class: e.$style.actionButtonInner }, [n("div", { class: e.$style.actionIcon }, [n("span", { class: e.$style.searchIcon }, [n("icon", { attrs: { name: "loupe", size: 56 } })], 1)]), n("span", { class: e.$style.actionName }, [e._v("Поиск")])])])], 1), n("div", { class: e.$style.action }, [n("PbButton", { class: e.$style.actionButton, attrs: { "data-test-selector": "main-menu-settings-button" }, on: { click: e.openSettings } }, [n("div", { class: e.$style.actionButtonInner }, [n("div", { class: [e.$style.actionIcon, e.$style.actionIcon_settings] }, [n("icon", { attrs: { name: "menu-button-settings", size: 88 } })], 1), n("span", { class: e.$style.actionName }, [e._v("Настройки")])])])], 1)]), n("div", { class: e.$style.user }, [n("div", { class: e.$style.userItem }, [e.usernameFormatted ? n("span", { attrs: { "data-test-selector": "main-menu-username" } }, [e._v(e._s(e.usernameFormatted))]) : n("span", { attrs: { "data-test-selector": "main-menu-username" } }, [e._v(e._s(e.authData.login))])]), n("div", { directives: [{ name: "permissions", rawName: "v-permissions:all", value: ["1.1"], expression: "['1.1']", arg: "all" }], class: e.$style.userItem }, [n("a", { class: e.$style.userAction, attrs: { href: "/admin" } }, [e._v(" Панель администратора ")])]), n("div", { class: e.$style.userItem }, [n("span", { class: e.$style.userAction, attrs: { "data-test-selector": "main-menu-logout-button" }, on: { click: function(r) {
    return e.$emit("logout");
  } } }, [e._v(" Выход ")])])])]) : e._e(), n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Главное меню", expression: "'Главное меню'" }], class: { [e.$style.toggle]: !0, [e.$style.toggle_active]: e.showed }, attrs: { round: "", "data-test-selector": "main-menu-button" }, on: { click: function(r) {
    e.showed = !e.showed;
  } } }, [n("icon", { attrs: { type: "font", name: "apps", size: "24" } })], 1)], 1);
}, GQe = [];
const D$ = {
  $style: VQe
};
function YQe(t) {
  for (var e in D$)
    this[e] = D$[e];
}
var ZQe = /* @__PURE__ */ B(
  zQe,
  UQe,
  GQe,
  !1,
  YQe,
  null
);
const XQe = ZQe.exports, KQe = "_root_1wlsb_1", JQe = "_root_theme_dark_1wlsb_11", qQe = "_btn_1wlsb_15", QQe = "_published_meny_item_1wlsb_21", eet = {
  root: KQe,
  root_theme_dark: JQe,
  btn: qQe,
  published_meny_item: QQe
}, tet = {
  name: "PbQuickActions",
  components: {
    PbButton: nt
  },
  data() {
    return {
      publishedMenuVisible: !1
    };
  },
  props: {
    buttons: {
      type: Array,
      required: !0
    }
  },
  methods: {
    toggleMenu() {
      this.publishedMenuVisible = !this.publishedMenuVisible;
    }
  }
};
var net = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, e._l(e.buttons, function(r) {
    return n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: r.title, expression: "button.title" }], key: r.name, attrs: { buttonClass: e.$style.btn, disabled: r.disabled, "data-test-selector": `quick-action-${r.name}` }, on: { click: r.handler, menu: function(s) {
      return s.stopPropagation(), s.preventDefault(), e.toggleMenu.apply(null, arguments);
    } } }, [n("icon", { attrs: { name: `quick-actions-${r.name}`, size: r.size, color: r.color } })], 1);
  }), 1);
}, ret = [];
const A$ = {
  $style: eet
};
function set(t) {
  for (var e in A$)
    this[e] = A$[e];
}
var iet = /* @__PURE__ */ B(
  tet,
  net,
  ret,
  !1,
  set,
  null
);
const oet = iet.exports, aet = {
  name: "QuickActionsCtr",
  components: {
    PbQuickActions: oet
  },
  computed: {
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    buttons() {
      const t = [];
      return this.getIsUserHasAllPermissions(["2.7"]) && t.push({
        name: "published",
        title: "Выпущено",
        handler: () => window.open("/published"),
        size: 20,
        color: "#2f80ed"
      }), this.getIsUserHasAllPermissions(["2.8"]) && t.push({
        name: ve.awaitingPublication,
        title: "Отложенные публикации",
        handler: () => this.addPanel({ panel: { type: ve.awaitingPublication } }),
        size: 20
      }), this.getIsUserHasAllPermissions(["4.1"]) && t.push({
        name: ve.asoiNotes,
        title: "Заметки из АСОИ",
        handler: () => this.addPanel({ panel: { type: ve.asoiNotes } }),
        size: 38
      }), this.getIsUserHasAllPermissions(["4.3"]) && t.push({
        name: ve.asoiNotesEmbargo,
        title: "Отложенные заметки АСОИ",
        handler: () => this.addPanel({ panel: { type: ve.asoiNotesEmbargo } }),
        size: 38
      }), this.getIsUserHasAllPermissions(["2.1"]) && t.push({
        name: "flash",
        title: "Создать молнию",
        handler: () => this.createNewsItem({ payload: { typeId: 1 } }),
        size: 20
      }), this.getIsUserHasAllPermissions(["2.17"]) && t.push({
        name: "originals",
        title: "Лента оригиналов",
        handler: () => this.addPanel({ panel: { type: ve.originals } }),
        size: 24
      }), t;
    }
  },
  methods: {
    ...ge("news", ["createNewsItem"]),
    ...ge("panels", ["addPanel"])
  }
};
var cet = function() {
  var e = this, n = e._self._c;
  return n("PbQuickActions", { attrs: { buttons: e.buttons } });
}, uet = [], det = /* @__PURE__ */ B(
  aet,
  cet,
  uet,
  !1,
  null,
  null
);
const fet = det.exports, pet = "_root_1biud_1", het = {
  root: pet
}, met = {
  name: "QuickActions",
  components: {
    QuickActionsCtr: fet
  },
  props: {
    leftPos: {
      type: Number,
      required: !0
    }
  }
};
var vet = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("QuickActionsCtr")], 1);
}, get = [];
const O$ = {
  $style: het
};
function yet(t) {
  for (var e in O$)
    this[e] = O$[e];
}
var bet = /* @__PURE__ */ B(
  met,
  vet,
  get,
  !1,
  yet,
  null
);
const _et = bet.exports, wet = "_root_1usrz_1", Iet = "_contentBorder_1usrz_10", Eet = "_entryId_1usrz_24", xet = "_name_1usrz_34", Cet = {
  root: wet,
  contentBorder: Iet,
  entryId: Eet,
  name: xet
}, Tet = {
  name: "InfoscrollPanelContent",
  props: {
    id: [String, Number],
    name: String,
    color: {
      type: String,
      default: "#fff"
    },
    bgColor: String,
    borderColor: String,
    content: {
      type: [String, null],
      default: null
    },
    panel: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...st({
      focused: (t) => t.panels.uiState.focused
    }),
    borderColorActual() {
      return this.borderColor ? this.borderColor : this.bgColor.startsWith("#333") ? "#848484" : this.bgColor;
    },
    backgroundColor() {
      return this.focused === this.panel.id ? this.bgColor.startsWith("#333") ? E0("#333333", 40) : E0(this.bgColor, -40) : "transparent";
    }
  },
  asyncComputed: {
    nameClean: {
      async get() {
        return (await Kn.process("trimHTML", this.name)).slice(0, 50) || "Пусто";
      },
      default: "Пусто"
    }
  }
};
var Pet = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, style: { backgroundColor: e.bgColor } }, [n("span", { class: e.$style.contentBorder, style: {
    borderColor: e.borderColorActual,
    background: e.backgroundColor
  } }, [e.id ? n("span", { class: e.$style.entryId, style: { borderColor: e.borderColorActual } }, [e._v(" " + e._s(e.id) + " ")]) : e._e(), n("span", { class: e.$style.name }, [e._v(e._s(e.nameClean))]), e._t("default")], 2)]);
}, ket = [];
const M$ = {
  $style: Cet
};
function Net(t) {
  for (var e in M$)
    this[e] = M$[e];
}
var $et = /* @__PURE__ */ B(
  Tet,
  Pet,
  ket,
  !1,
  Net,
  null
);
const qi = $et.exports, Det = "_counter_49r2t_1", Aet = {
  counter: Det
}, Oet = {
  name: "infoscrollPanelFlow",
  components: {
    InfoscrollPanelContent: qi,
    FlowUnreadBadge: AL
  },
  props: {
    panel: Object,
    default: () => ({})
  },
  computed: {
    flow() {
      return this.$store.getters.flowForPanel(this.panel);
    }
  }
};
var Met = function() {
  var e = this, n = e._self._c;
  return e.flow ? n("div", [n("InfoscrollPanelContent", { attrs: { id: e.panel.dataId, name: e.flow.name, bgColor: "#" + e.panel.settings.color, panel: e.panel } }, [n("FlowUnreadBadge", { class: e.$style.counter, attrs: { panel: e.panel, color: "#333333" } })], 1)], 1) : n("div", [n("InfoscrollPanelContent", { attrs: { id: e.panel.dataId, name: "Поток удалён", bgColor: e.panel.settings.color, panel: e.panel } })], 1);
}, Ret = [];
const R$ = {
  $style: Aet
};
function Let(t) {
  for (var e in R$)
    this[e] = R$[e];
}
var Fet = /* @__PURE__ */ B(
  Oet,
  Met,
  Ret,
  !1,
  Let,
  null
);
const Bet = Fet.exports, jet = {
  name: "InfoscrollPanelEntry",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  },
  computed: {
    ...st({
      newsbreaks: (t) => t.newsbreaks.items,
      leads: (t) => t.leads.items,
      asoi: (t) => t.asoi
    }),
    asoiNotes() {
      return (t) => this.asoi[t].items;
    },
    entry() {
      if (this.panel.type === ve.lead)
        return this.leads[this.panel.dataId] || {};
      if (this.panel.type === ve.newsbreak)
        return this.newsbreaks[this.panel.dataId] || {};
      if (this.panel.type === ve.asoiNote) {
        const t = zue;
        return this.asoiNotes(t)[this.panel.dataId] || {};
      }
      if (this.panel.type === ve.asoiNoteSent) {
        const t = Mv;
        return this.asoiNotes(t)[this.panel.dataId] || {};
      }
      return {};
    },
    name() {
      if (this.panel.type === ve.lead) {
        const t = this.leads[this.panel.dataId];
        if (t)
          return t.title;
      }
      if (this.panel.type === ve.newsbreak) {
        const t = this.newsbreaks[this.panel.dataId];
        if (t) {
          if (t.fragment)
            return t.fragment;
          if (t.lead)
            return t.lead.title;
        }
      }
      if ([ve.asoiNote, ve.asoiNoteSent, ve.asoiNoteEmbargo].includes(
        this.panel.type
      )) {
        const t = au(this.panel.type), e = this.asoiNotes(t)[this.panel.dataId];
        return e && e.headline ? e.headline.slice(0, 50) : e && e.body ? e.body.slice(0, 50) : "Пустая заметка";
      }
      return "Пусто";
    },
    borderColor() {
      return this.panel.settings.color === "333333" ? null : this.panel.settings.color;
    }
  }
};
var Wet = function() {
  var e = this, n = e._self._c;
  return n("div", [n("InfoscrollPanelContent", { attrs: { name: e.name, bgColor: "#" + e.panel.settings.color, borderColor: "#" + e.borderColor, panel: e.panel } })], 1);
}, Het = [], Vet = /* @__PURE__ */ B(
  jet,
  Wet,
  Het,
  !1,
  null,
  null
);
const Bp = Vet.exports, zet = {
  computed: {
    ...pe("news", ["getNewsItemCurrentVersion"]),
    ...pe(["getDraftForNewsItem"])
  },
  asyncComputed: {
    title: {
      async get() {
        var t;
        if (this.newsItemId) {
          const e = this.getDraftForNewsItem(this.newsItemId), n = (e == null ? void 0 : e.version) ?? this.getNewsItemCurrentVersion(this.newsItemId);
          if (n) {
            let r = "", s = "";
            n.type_id === 1 ? s = (t = n.body) == null ? void 0 : t.toUpperCase() : s = (n == null ? void 0 : n.headline) ?? (n == null ? void 0 : n.header);
            const o = await Kn.process("trimHTML", s);
            return n.authors.length && n.authors.map(({ user: l }) => Ps(l.name)).forEach((l, c) => {
              r += l, c < n.authors.length - 1 && (r += ", ");
            }), o && (r += ": "), o && (r += o), r;
          }
        }
        return "";
      },
      default: ""
    }
  }
}, Uet = {
  name: "InfoscrollPanelDraft",
  mixins: [zet],
  props: {
    panel: Object
  },
  inject: ["getColorScheme"],
  components: {
    InfoscrollPanelContent: qi
  },
  computed: {
    newsItemId() {
      return this.panel.dataId;
    },
    backgroundColor() {
      return "#" + (this.getColorScheme() || {}).accentColor;
    },
    borderColor() {
      return "#" + (this.getColorScheme() || {}).backgroundColor;
    }
  }
};
var Get = function() {
  var e = this, n = e._self._c;
  return n("div", [n("infoscroll-panel-content", { attrs: { name: e.title, bgColor: e.backgroundColor, borderColor: e.borderColor, panel: e.panel } })], 1);
}, Yet = [], Zet = /* @__PURE__ */ B(
  Uet,
  Get,
  Yet,
  !1,
  null,
  null
);
const Xet = Zet.exports, Ket = {
  name: "InfoscrollPanelDisposed",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var Jet = function() {
  var e = this, n = e._self._c;
  return n("div", [n("infoscroll-panel-content", { attrs: { name: "Отвал", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, qet = [], Qet = /* @__PURE__ */ B(
  Ket,
  Jet,
  qet,
  !1,
  null,
  null
);
const ett = Qet.exports, ttt = {
  name: "InfoscrollPanelEmbargo",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var ntt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("infoscroll-panel-content", { attrs: { name: "Отложенные", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, rtt = [], stt = /* @__PURE__ */ B(
  ttt,
  ntt,
  rtt,
  !1,
  null,
  null
);
const itt = stt.exports, ott = "_counter_49r2t_1", att = {
  counter: ott
}, ltt = {
  name: "InfoscrollPanelAsoiNotes",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi,
    AsoiNotesUnreadBadge: CR
  }
};
var ctt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("InfoscrollPanelContent", { attrs: { name: "Заметки из АСОИ", bgColor: "#" + e.panel.settings.color, panel: e.panel } }, [n("AsoiNotesUnreadBadge", { class: e.$style.counter, attrs: { panel: e.panel, color: "#333333" } })], 1)], 1);
}, utt = [];
const L$ = {
  $style: att
};
function dtt(t) {
  for (var e in L$)
    this[e] = L$[e];
}
var ftt = /* @__PURE__ */ B(
  ltt,
  ctt,
  utt,
  !1,
  dtt,
  null
);
const ptt = ftt.exports, htt = {
  name: "InfoscrollPanelAsoiSent",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var mtt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("InfoscrollPanelContent", { attrs: { name: "Отпр. в АСОИ", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, vtt = [], gtt = /* @__PURE__ */ B(
  htt,
  mtt,
  vtt,
  !1,
  null,
  null
);
const ytt = gtt.exports, btt = {
  name: "InfoscrollPanelPublished",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var _tt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("infoscroll-panel-content", { attrs: { name: "Поиск", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, wtt = [], Stt = /* @__PURE__ */ B(
  btt,
  _tt,
  wtt,
  !1,
  null,
  null
);
const Itt = Stt.exports, Ett = {
  name: "InfoscrollPanelAsoiNotesEmbargo",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var xtt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("InfoscrollPanelContent", { attrs: { name: "Отложенные заметки АСОИ", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, Ctt = [], Ttt = /* @__PURE__ */ B(
  Ett,
  xtt,
  Ctt,
  !1,
  null,
  null
);
const Ptt = Ttt.exports, ktt = {
  name: "InfoscrollPanelPublished",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var Ntt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("infoscroll-panel-content", { attrs: { name: "Лента оригиналов", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, $tt = [], Dtt = /* @__PURE__ */ B(
  ktt,
  Ntt,
  $tt,
  !1,
  null,
  null
);
const Att = Dtt.exports, Ott = {
  name: "InfoscrollPanelCanvas",
  props: {
    panel: Object
  },
  components: {
    InfoscrollPanelContent: qi
  }
};
var Mtt = function() {
  var e = this, n = e._self._c;
  return n("div", [n("infoscroll-panel-content", { attrs: { name: "Холст", bgColor: "#" + e.panel.settings.color, panel: e.panel } })], 1);
}, Rtt = [], Ltt = /* @__PURE__ */ B(
  Ott,
  Mtt,
  Rtt,
  !1,
  null,
  null
);
const Ftt = Ltt.exports, Btt = "_root_1v3u5_1", jtt = {
  root: Btt
}, Wtt = {
  name: "InfoscrollPanel",
  components: {
    [ve.disposed]: ett,
    [ve.search]: Itt,
    [ve.awaitingPublication]: itt,
    [ve.asoiNote]: Bp,
    [ve.asoiNotes]: ptt,
    [ve.asoiNotesSent]: ytt,
    [ve.asoiNotesEmbargo]: Ptt,
    [ve.asoiNoteEmbargo]: Bp,
    [ve.flow]: Bet,
    [ve.lead]: Bp,
    [ve.newsbreak]: Bp,
    [ve.newsItem]: Xet,
    [ve.originals]: Att,
    [ve.newsCanvas]: Ftt
  },
  props: {
    panel: {
      type: Object,
      required: !0
    }
  },
  computed: {
    ...st({
      focused: (t) => t.panels.uiState.focused
    }),
    ...pe("panels", ["getPanelVisibleSupplies"]),
    panelWidth() {
      const t = this.panel.settings.widthScaleFactor || 1, e = ji * t, n = 2.1014492754;
      let r = e / n;
      const s = this.getPanelVisibleSupplies(this.panel);
      if (s.length > 0) {
        const i = s.reduce((o, a) => (o += a.settings.widthScaleFactor * ji, o), 0);
        r += i / n;
      }
      return r += 10 / n, r;
    },
    panelType() {
      return (t) => ve.asoiNoteSent === t ? "asoiNote" : t;
    }
  }
};
var Htt = function() {
  var e = this, n = e._self._c;
  return n(e.panelType(e.panel.type), { tag: "component", class: {
    [e.$style.root]: !0,
    focused: e.panel.id === e.focused
  }, style: { width: e.panelWidth + "px" }, attrs: { panel: e.panel, "data-test-selector": "infoscroll-panel" } });
}, Vtt = [];
const F$ = {
  $style: jtt
};
function ztt(t) {
  for (var e in F$)
    this[e] = F$[e];
}
var Utt = /* @__PURE__ */ B(
  Wtt,
  Htt,
  Vtt,
  !1,
  ztt,
  null
);
const Gtt = Utt.exports, Ytt = "_root_1a9av_1", Ztt = {
  root: Ytt
}, Xtt = {
  name: "infoscrollScrollbar",
  data() {
    return {
      size: {
        width: "0px",
        left: "0px"
      }
    };
  },
  mounted() {
    this.globalWrapper = document.querySelector("#legacy-app"), window.addEventListener("resize", this.onResize), this.globalWrapper.addEventListener("scroll", this.onScroll, {
      passive: !0
    }), this.onResize();
  },
  computed: {
    ...st({
      isTaskPanelOpen: (t) => t.uiState.isTaskPanelOpen
    })
  },
  watch: {
    isTaskPanelOpen() {
      this.onResize();
    }
  },
  methods: {
    onResize() {
      const t = this.globalWrapper.offsetWidth / 2.1014492754;
      this.size.width = t + "px", this.$nextTick(() => {
        this.$refs.scrollbar && this.$emit("setPosition", {
          left: this.$refs.scrollbar.getBoundingClientRect().x,
          right: this.$refs.scrollbar.getBoundingClientRect().x + parseFloat(this.size.width)
        });
      });
    },
    onScroll() {
      const t = this.globalWrapper.scrollLeft / 2.1014492754 + this.$parent.$_meta.wrapperOffset;
      this.size.left = t + "px", this.$nextTick(() => {
        this.$refs.scrollbar && this.$emit("setPosition", {
          left: this.$refs.scrollbar.getBoundingClientRect().x,
          right: this.$refs.scrollbar.getBoundingClientRect().x + parseFloat(this.size.width)
        });
      });
    }
  }
};
var Ktt = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "scrollbar", class: e.$style.root, style: e.size });
}, Jtt = [];
const B$ = {
  $style: Ztt
};
function qtt(t) {
  for (var e in B$)
    this[e] = B$[e];
}
var Qtt = /* @__PURE__ */ B(
  Xtt,
  Ktt,
  Jtt,
  !1,
  qtt,
  null
);
const ent = Qtt.exports;
function tnt(t, e = "vertical") {
  return {
    get scroll() {
      return t === global ? e === "vertical" ? globalThis.scrollY : globalThis.scrollX : e === "vertical" ? t.scrollTop : t.scrollLeft;
    },
    scrollTo(n) {
      t === global ? globalThis.scrollTo({
        [e === "vertical" ? "top" : "left"]: n,
        behavior: "auto"
      }) : e === "vertical" ? t.scrollTop = n : t.scrollLeft = n;
    }
  };
}
function nnt({
  direction: t = "vertical",
  duration: e = 200,
  el: n = global,
  pos: r = 0
}) {
  return new Promise((s) => {
    n = tnt(n, t);
    let i = null;
    const o = n.scroll, a = r - o;
    let l;
    const c = (u) => {
      i === null && (i = u);
      const d = u - i, f = d / e - 1, p = f * f * f + 1, h = Math.round(o + a * p);
      d < e && h !== r ? (n.scrollTo(h), l = requestAnimationFrame(c)) : (n.scrollTo(r), cancelAnimationFrame(l), s());
    };
    l = requestAnimationFrame(c);
  });
}
const rnt = "_root_9bdjq_1", snt = {
  root: rnt
}, yb = el.getParser(globalThis.navigator.userAgent), int = {
  name: "infoscrollWrapper",
  props: {
    rootLeft: {
      type: Number,
      default: 306
    }
  },
  data() {
    return {
      left: "0px"
    };
  },
  mounted() {
    this.globalWrapper = document.querySelector("#legacy-app"), this.globalWrapper.addEventListener("scroll", this.onWindowScroll, { passive: !0 }), this.setOffset();
  },
  beforeDestroy() {
    this.globalWrapper.removeEventListener("scroll", this.onWindowScroll);
  },
  methods: {
    onScroll(t) {
      if (Math.abs(t.deltaX) === 0) {
        t.stopPropagation(), t.preventDefault();
        let e = 3;
        yb.isOS("macos") ? e = 10 : (yb.isBrowser("chrome") && (e = 3), yb.isBrowser("firefox") && (e = 50)), nnt({
          direction: "horizontal",
          pos: this.globalWrapper.scrollLeft + t.deltaY * e * 2,
          el: this.globalWrapper,
          duration: 300
        });
      }
    },
    setOffset() {
      if (!this.$refs.wrapperNode) return;
      const t = window.innerWidth - this.rootLeft;
      let e = "0px";
      if (this.$refs.wrapperNode.offsetWidth > t) {
        const n = (this.globalWrapper.scrollLeft + window.innerWidth) / 2.1014492754, r = -(n - t);
        n > t ? e = r + "px" : e = "0px";
      }
      this.left = e, this.$emit("setPosition", e);
    },
    onWindowScroll() {
      this.setOffset();
    }
  }
};
var ont = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "wrapperNode", class: e.$style.root, style: { left: e.left }, on: { wheel: e.onScroll } }, [e._t("default")], 2);
}, ant = [];
const j$ = {
  $style: snt
};
function lnt(t) {
  for (var e in j$)
    this[e] = j$[e];
}
var cnt = /* @__PURE__ */ B(
  int,
  ont,
  ant,
  !1,
  lnt,
  null
);
const unt = cnt.exports, dnt = "_root_1okv8_1", fnt = {
  root: dnt
};
function W$(t) {
  return t.type.startsWith("touch");
}
function H$(t) {
  return t.type.startsWith("touch") && t.touches.length > 0 && (t.clientX = t.touches[0].clientX, t.clientY = t.touches[0].clientY), t;
}
const pnt = {
  name: "Infoscroll",
  components: {
    Panel: Gtt,
    Scrollbar: ent,
    Wrapper: unt
  },
  props: {
    leftPos: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      observer: null,
      prevHeaderEl: null
    };
  },
  computed: {
    ...st({
      panels: (t) => t.panels.data
    })
  },
  created() {
    this.$_meta = {};
  },
  mounted() {
    this.globalWrapper = document.querySelector("#legacy-app");
  },
  methods: {
    ...ge("panels", ["setPanelFocused", "setDesiredScrollIndex"]),
    focus(t) {
      this.setPanelFocused(t);
    },
    getScrollbarPosition({ left: t, right: e }) {
      this.$_meta.scrollBarLeft = parseFloat(t), this.$_meta.scrollBarRight = parseFloat(e);
    },
    setWrapperPosition(t) {
      this.$_meta.wrapperOffset = parseFloat(t);
    },
    onDragStart(t) {
      t = H$(t), t.clientX >= this.$_meta.scrollBarLeft && t.clientX <= this.$_meta.scrollBarRight && (W$(t) ? (window.addEventListener("touchmove", this.onDrag, { passive: !1 }), window.addEventListener("touchend", this.onDragEnd)) : (window.addEventListener("mousemove", this.onDrag), window.addEventListener("mouseup", this.onDragEnd)), this.$_meta.drags = !0, t.stopPropagation(), t.preventDefault(), this.$_meta.lastPosition = t.clientX);
    },
    onDragEnd(t) {
      W$(t) ? (window.removeEventListener("touchmove", this.onDrag, { passive: !1 }), window.removeEventListener("touchend", this.onDragEnd)) : (window.removeEventListener("mousemove", this.onDrag), window.removeEventListener("mouseup", this.onDragEnd)), this.$_meta.drags && (this.$_meta.drags = !1);
    },
    onDrag(t) {
      t = H$(t), this.$_meta.drags && (t.stopPropagation(), t.preventDefault(), this.$_meta.scrollBarRight > this.$_meta.wrapperOffset + (this.$_meta.wrapperWidth ?? 0) ? this.globalWrapper.scrollTo(
        this.globalWrapper.scrollLeft + (t.clientX - this.$_meta.lastPosition) * 2.1014492754 + Math.abs(this.$_meta.wrapperWidth ?? 0),
        0
      ) : this.globalWrapper.scrollTo(
        this.globalWrapper.scrollLeft + (t.clientX - this.$_meta.lastPosition) * 2.1014492754,
        0
      ), this.$_meta.lastPosition = t.clientX);
    }
  }
};
var hnt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "infoscroll" }, on: { "!mousedown": function(r) {
    return e.onDragStart.apply(null, arguments);
  }, touchstart: e.onDragStart } }, [n("Wrapper", { attrs: { rootLeft: e.leftPos }, on: { setPosition: e.setWrapperPosition } }, e._l(e.panels, function(r, s) {
    return n("Panel", { key: r.id, attrs: { panel: r }, nativeOn: { click: function(i) {
      return e.focus(r.id, s);
    } } });
  }), 1), n("Scrollbar", { on: { setPosition: e.getScrollbarPosition } })], 1);
}, mnt = [];
const V$ = {
  $style: fnt
};
function vnt(t) {
  for (var e in V$)
    this[e] = V$[e];
}
var gnt = /* @__PURE__ */ B(
  pnt,
  hnt,
  mnt,
  !1,
  vnt,
  null
);
const ynt = gnt.exports, bnt = "_container_136fl_1", _nt = "_modal_136fl_15", wnt = "_close_136fl_28", Snt = "_backdrop_136fl_35", Int = "_content_136fl_41", Ent = "_footer_136fl_45", xnt = "_dark_136fl_53", Cnt = "_centered_136fl_57", Tnt = {
  container: bnt,
  modal: _nt,
  close: wnt,
  backdrop: Snt,
  content: Int,
  footer: Ent,
  dark: xnt,
  centered: Cnt
}, Pnt = {
  name: "PbModalCentered",
  mixins: [Du],
  components: {
    Toolbar: xo,
    PbButton: nt
  },
  props: {
    title: String,
    maxWidth: {
      type: Number,
      default: 1240
    },
    minWidth: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: "80%"
    },
    toolbarFontSize: {
      type: String,
      default: "20px"
    },
    allowEventPropagOnClick: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onContainerClick(t) {
      this.allowEventPropagOnClick || t.stopPropagation();
    }
  }
};
var knt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.container, on: { click: e.onContainerClick } }, [n("transition", { attrs: { name: e.transition, appear: "" } }, [n("div", { class: e.$style.centered, style: {
    "max-width": e.maxWidth + "px",
    "min-width": e.minWidth + "px",
    height: e.height
  } }, [n("div", { class: e.$style.modal }, [n("Toolbar", { attrs: { title: e.title, fontSize: e.toolbarFontSize } }, [e._t("topBar"), e.closeable ? n("PbButton", { class: e.$style.close, attrs: { round: "", "data-test-selector": "close-modal-button" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.close.apply(null, arguments);
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1) : e._e()], 2), e.$slots.content ? n("div", { class: e.$style.content }, [e._t("content")], 2) : e._e(), e.$slots.footer ? n("div", { class: e.$style.footer }, [e._t("footer")], 2) : e._e()], 1)])]), e.closeable && e.withBackdrop ? n("div", { class: e.$style.modalBackdrop, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.close();
  } } }) : e._e()], 1);
}, Nnt = [];
const z$ = {
  $style: Tnt
};
function $nt(t) {
  for (var e in z$)
    this[e] = z$[e];
}
var Dnt = /* @__PURE__ */ B(
  Pnt,
  knt,
  Nnt,
  !1,
  $nt,
  null
);
const LI = Dnt.exports, Ant = "_root_1qgus_1", Ont = "_remove_1qgus_11", Mnt = {
  root: Ant,
  remove: Ont
}, Rnt = {
  name: "PbChip",
  props: {
    isRemovable: {
      type: Boolean,
      default: !0
    },
    bgColor: {
      type: String,
      default: "#fff"
    },
    textColor: {
      type: String,
      default: "#000"
    }
  },
  computed: {
    style() {
      return `background: ${this.bgColor}; color: ${this.textColor}`;
    }
  }
};
var Lnt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, style: e.style }, [e._t("before"), e._t("default"), e.isRemovable ? n("icon", { class: e.$style.remove, attrs: { type: "font", name: "close", size: "14" }, nativeOn: { click: function(r) {
    return e.$emit("remove");
  } } }) : e._e()], 2);
}, Fnt = [];
const U$ = {
  $style: Mnt
};
function Bnt(t) {
  for (var e in U$)
    this[e] = U$[e];
}
var jnt = /* @__PURE__ */ B(
  Rnt,
  Lnt,
  Fnt,
  !1,
  Bnt,
  null
);
const L8 = jnt.exports, Wnt = "_root_1e0au_1", Hnt = {
  root: Wnt
}, Vnt = {
  name: "PbCheckbox",
  props: {
    isSelected: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 18
    }
  }
};
var znt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, on: { click: function(r) {
    return e.$emit("click");
  } } }, [n("div", { style: { height: e.size + "px", width: e.size + "px" }, attrs: { "data-test-selector": "checkbox", "data-test-attrs": e.isSelected ? "checkbox__checked" : "checkbox__unchecked" } }, [n("icon", { attrs: { name: e.isSelected ? "check_circle" : "check_circle_outline", size: e.size } })], 1)]);
}, Unt = [];
const G$ = {
  $style: Hnt
};
function Gnt(t) {
  for (var e in G$)
    this[e] = G$[e];
}
var Ynt = /* @__PURE__ */ B(
  Vnt,
  znt,
  Unt,
  !1,
  Gnt,
  null
);
const Znt = Ynt.exports, Xnt = "_root_1gmkg_1", Knt = "_root_selected_1gmkg_11", Jnt = "_checkbox_1gmkg_19", qnt = "_info_1gmkg_23", Qnt = "_meta_1gmkg_28", ert = "_status_1gmkg_33", trt = "_avatar_1gmkg_38", nrt = "_avatarImage_1gmkg_52", rrt = "_avatarPlaceholder_1gmkg_58", srt = {
  root: Xnt,
  root_selected: Knt,
  checkbox: Jnt,
  info: qnt,
  meta: Qnt,
  status: ert,
  avatar: trt,
  avatarImage: nrt,
  avatarPlaceholder: rrt
}, irt = {
  name: "PbUsersListEntry",
  components: {
    PbCheckbox: Znt
  },
  props: {
    id: {
      type: Number,
      required: !0
    },
    entry: {
      type: Object,
      required: !0
    },
    isCheckable: Boolean,
    isSelected: Boolean,
    isChecked: Boolean,
    useLayoutTranslation: {
      type: Boolean,
      default: !1
    },
    searchQuery: String
  },
  computed: {
    initials() {
      return this.entry.is_group ? "" : this.getInitials(this.name);
    },
    name() {
      return this.formatUsername(this.entry.name);
    },
    code() {
      return this.entry.code || "";
    },
    status() {
      return this.entry.is_online ? "Онлайн" : this.entry.last_seen ? `Последнее посещение ${this.getFormattedDate(
        this.entry.last_seen
      )}` : "";
    },
    avatarColor() {
      return e4(this.entry.name, 40, 90);
    },
    highlightHTML() {
      return (t) => {
        if (this.searchQuery.length) {
          const e = this.formatUsername(this.searchQuery), n = i4(e);
          let r = ym(e);
          this.useLayoutTranslation && (r += "|" + ym(n));
          const s = new RegExp(r, "gi");
          return this[t].replace(s, '<span class="highlight">$&</span>');
        } else
          return this[t];
      };
    }
  },
  methods: {
    getInitials(t) {
      const e = t.split(" ");
      let n = e[0].substring(0, 1).toUpperCase();
      return e.length > 1 && (n += e[e.length - 1].substring(0, 1).toUpperCase()), n;
    },
    getFormattedDate(t) {
      t = new Date(t);
      const e = on(t, "HH:mm", { locale: xn });
      return mm(t) ? `в ${e}` : C5(Date.now(), t) < 1 ? `вчера в ${e}` : Rf(t) ? `${on(t, "d MMMM", { locale: xn })} в ${e}` : `${on(t, "d MMMM yyyy", { locale: xn })} в ${e}`;
    }
  }
};
var ort = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { [e.$style.root]: !0, [e.$style.root_selected]: e.isSelected }, attrs: { "data-test-selector": "users-list-item", "data-test-attrs": `item-id__${e.entry.id} ${e.entry.is_group ? "group" : "user"}`, "data-test-id": e.entry.id }, on: { click: function(r) {
    return r.stopPropagation(), r.preventDefault(), e.$emit("toggle");
  } } }, [e.isCheckable ? n("PbCheckbox", { class: e.$style.checkbox, attrs: { isSelected: e.isChecked } }) : e._e(), n("div", { class: e.$style.info }, [n("div", { class: e.$style.name, attrs: { "data-test-selector": `users-list-item-name-${e.entry.is_group ? "group" : "user"}` }, domProps: { innerHTML: e._s(e.highlightHTML("name")) } }), e.entry.is_group ? e._e() : [n("div", { class: e.$style.meta, attrs: { "data-test-selector": "users-list-item-meta-user" } }, [e._v(" Пользователь • "), n("span", { domProps: { innerHTML: e._s(e.highlightHTML(["code"])) } })]), n("div", { class: e.$style.status }, [e._v(e._s(e.status))])], e.entry.is_group ? n("div", { class: e.$style.meta, attrs: { "data-test-selector": "users-list-item-meta-group" } }, [e._v(" Группа • "), n("span", { domProps: { innerHTML: e._s(e.highlightHTML("code")) } })]) : e._e()], 2), e.entry.is_group ? e._e() : n("div", { class: e.$style.avatar, style: { background: e.avatarColor }, attrs: { "data-test-selector": "users-list-item-avatar" } }, [e.entry.image ? n("img", { class: e.$style.avatarImage, attrs: { src: e.entry.image, alt: e.name } }) : n("span", { class: e.$style.avatarPlaceholder }, [e._v(e._s(e.initials))])])], 1);
}, art = [];
const Y$ = {
  $style: srt
};
function lrt(t) {
  for (var e in Y$)
    this[e] = Y$[e];
}
var crt = /* @__PURE__ */ B(
  irt,
  ort,
  art,
  !1,
  lrt,
  null
);
const urt = crt.exports, drt = "_root_iilje_1", frt = "_item_iilje_7", prt = {
  root: drt,
  item: frt
}, hrt = {
  name: "PbUsersList",
  components: {
    PbDynamicList: il,
    PbUsersListEntry: urt,
    PbCircularLoader: br,
    PbEmpty: tl
  },
  props: {
    entries: {
      type: Array,
      default: () => []
    },
    searchQuery: {
      type: String,
      default: ""
    },
    checkedItems: {
      type: Array,
      default: () => []
    },
    multipleMode: {
      type: Boolean,
      default: !1
    },
    loaded: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    enableKeyboard: {
      type: Boolean,
      default: !0
    },
    useLayoutTranslation: {
      type: Boolean,
      default: !1
    },
    minItemHeight: {
      type: Number,
      default: 67
    }
  },
  data() {
    return {
      selectedEntry: null
    };
  },
  computed: {
    entriesIndexed() {
      return this.entries.map((t, e) => ({ id: e, entry: t }));
    },
    sizeDeps() {
      return () => [];
    },
    isEntryChecked() {
      return (t) => this.checkedItems.some(
        (e) => e.is_group === t.is_group && e.id === t.id
      );
    }
  },
  activated() {
    const t = this.$getShortcuts("Enter");
    this.enableKeyboard && (t.length ? this.$enableShortcut("Enter") : this.$registerShortcut("Enter", this.handleEnter, {
      enabled: !0,
      capture: !0
    }));
  },
  deactivated() {
    this.enableKeyboard && this.$disableShortcut("Enter"), this.selectedEntry = null;
  },
  methods: {
    toggleEntry(t) {
      let e = this.checkedItems;
      if (this.multipleMode) {
        const n = e.findIndex((r) => r.is_group === t.is_group && r.id === t.id);
        n >= 0 ? e.splice(n, 1) : e.push(t);
      } else
        e = [t];
      this.$emit("selected", e);
    },
    handleEnter(t) {
      if (t.preventDefault(), t.composed && (t.ctrlKey || t.metaKey))
        this.checkedItems.length && this.$emit("submit");
      else {
        const n = this.entriesIndexed.find(
          ({ id: r }) => r === this.selectedEntry
        );
        n && n.entry && this.toggleEntry(n.entry);
      }
    },
    scrollToTop() {
      this.$refs.list && this.$refs.list.scrollToTop();
    }
  }
};
var mrt = function() {
  var e = this, n = e._self._c;
  return e.entries ? n("div", { class: e.$style.root, attrs: { "data-test-selector": "users-list" } }, [e.entries.length ? n("PbDynamicList", { ref: "list", class: e.$style.list, attrs: { items: e.entriesIndexed, minItemHeight: e.minItemHeight, selected: e.selectedEntry, showLoader: e.loading && !e.loaded, suppressClick: !0, enableKeyboard: e.enableKeyboard, sizeDeps: e.sizeDeps }, on: { select: function(r) {
    e.selectedEntry = r ? r.id : null;
  }, reachedEnd: function(r) {
    return e.$emit("loadMore");
  } }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, index: s, selected: i }) {
    return [e._t("default", function() {
      return [n("div", { class: e.$style.item }, [n("PbUsersListEntry", { attrs: { id: r.id, entry: r.entry, searchQuery: e.searchQuery, isCheckable: !0, isSelected: r.id === e.selectedEntry, isChecked: e.isEntryChecked(r.entry), useLayoutTranslation: e.useLayoutTranslation }, on: { toggle: function(o) {
        return e.toggleEntry(r.entry);
      } } })], 1)];
    }, { item: r, index: s, isSelected: i })];
  } }], null, !0) }) : e._e(), !e.entries.length && e.loading ? n("PbCircularLoader", { attrs: { size: 50 } }) : e._e(), e.loaded && !e.entries.length ? e._t("empty", function() {
    return [e.loaded && !e.entries.length ? n("PbEmpty", { class: e.$style.list, attrs: { text: "Ничего не найдено" } }) : e._e()];
  }) : e._e()], 2) : e._e();
}, vrt = [];
const Z$ = {
  $style: prt
};
function grt(t) {
  for (var e in Z$)
    this[e] = Z$[e];
}
var yrt = /* @__PURE__ */ B(
  hrt,
  mrt,
  vrt,
  !1,
  grt,
  null
);
const F8 = yrt.exports, brt = "_menuPopup_shu8t_1", _rt = "_actions_shu8t_6", wrt = "_radioGroup_shu8t_10", Srt = "_radioLabel_shu8t_17", Irt = "_select_shu8t_31", Ert = {
  menuPopup: brt,
  actions: _rt,
  radioGroup: wrt,
  radioLabel: Srt,
  select: Irt
}, xrt = {
  name: "SettingsMenu",
  components: { PsKitPopup: Ls, PbSimpleApply: jL },
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    selectedRecipient: {
      type: Object,
      default: null
    },
    defaultRecipient: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      option: null
    };
  },
  computed: {
    canSetDefault() {
      var t;
      return this.selectedRecipient && this.selectedRecipient.id !== ((t = this.defaultRecipient) == null ? void 0 : t.id);
    }
  },
  watch: {
    visible(t) {
      t || this.reset();
    }
  },
  methods: {
    applyChanges() {
      this.option && this.$emit("apply", {
        option: this.option
      });
    },
    cancelChanges() {
      this.$emit("hide");
    },
    reset() {
      this.option = null;
    }
  }
};
var Crt = function() {
  var e = this, n = e._self._c;
  return n("PsKitPopup", { attrs: { classPopup: e.$style.menuPopup, placement: "bottom", visible: e.visible, floatingOptions: { offset: { crossAxis: -23, mainAxis: 10 } } }, on: { hide: e.cancelChanges }, scopedSlots: e._u([{ key: "default", fn: function() {
    return [n("div", { class: e.$style.radioGroup }, [n("div", [n("label", { class: e.$style.radioLabel }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.option, expression: "option" }], attrs: { type: "radio", name: "save", value: "save", disabled: !e.canSetDefault }, domProps: { checked: e._q(e.option, "save") }, on: { change: function(r) {
      e.option = "save";
    } } }), n("span", [e._v("Сохранить выбранного пользователя (группу) по умолчанию "), e.selectedRecipient && e.canSetDefault ? n("span", { staticStyle: { "font-weight": "700" } }, [e._v("(" + e._s(e.selectedRecipient.name) + ")")]) : e._e()])])]), n("label", { class: e.$style.radioLabel }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.option, expression: "option" }], attrs: { type: "radio", name: "reset", value: "reset", disabled: !e.defaultRecipient }, domProps: { checked: e._q(e.option, "reset") }, on: { change: function(r) {
      e.option = "reset";
    } } }), n("span", [e._v("Удалить сохраненного пользователя (группу) по умолчанию "), e.defaultRecipient ? n("span", { staticStyle: { "font-weight": "700" } }, [e._v("(" + e._s(e.defaultRecipient.name) + ")")]) : e._e()])])]), n("PbSimpleApply", { class: e.$style.actions, attrs: { applyDisabled: !e.option }, on: { apply: e.applyChanges, cancel: e.cancelChanges } })];
  }, proxy: !0 }]) });
}, Trt = [];
const X$ = {
  $style: Ert
};
function Prt(t) {
  for (var e in X$)
    this[e] = X$[e];
}
var krt = /* @__PURE__ */ B(
  xrt,
  Crt,
  Trt,
  !1,
  Prt,
  null
);
const Nrt = krt.exports, $rt = "_content_169l3_1", Drt = "_selected_169l3_8", Art = "_search_169l3_25", Ort = "_commentField_169l3_30", Mrt = "_commentCount_169l3_40", Rrt = "_list_169l3_48", Lrt = "_settings_169l3_55", Frt = {
  content: $rt,
  selected: Drt,
  search: Art,
  commentField: Ort,
  commentCount: Mrt,
  list: Rrt,
  settings: Lrt
}, Brt = {
  name: "ShareModal",
  components: {
    ModalCentered: LI,
    Toolbar: xo,
    PbChip: L8,
    SearchField: Mu,
    PbUsersList: F8,
    MainActionButton: fn,
    PbButton: nt,
    SettingsMenu: Nrt
  },
  provide() {
    return {
      toolbarStyles: {
        boxShadow: "none"
      }
    };
  },
  data() {
    return {
      selected: [],
      searchQuery: "",
      loading: !1,
      offset: 0,
      limit: 20,
      asoiComment: "",
      settingsMenuVisible: !1
    };
  },
  computed: {
    ...st({
      itemType: (t) => t.shareModal.itemType,
      actionType: (t) => t.shareModal.actionType,
      itemId: (t) => t.shareModal.itemId,
      multipleMode: (t) => t.shareModal.multipleMode,
      params: (t) => t.shareModal.params,
      recipientsList: (t) => t.shareModal.recipientsList || [],
      groupsAndUsers: (t) => t.people.groupsAndUsers
    }),
    ...pe(["getUserById", "getGroupById", "getDefaultRecipient"]),
    ...pe("userProfile", ["getDefaultRecipientId"]),
    title() {
      let t = "Отправить ";
      switch (this.itemType === "newsItem" && (t += "новость"), this.itemType === "lead" && (t += "инфоповод"), this.actionType) {
        case "sendToASOI":
          t += " в АСОИ";
          break;
      }
      return t;
    },
    recipients() {
      return this.recipientsList.map((t) => this.getFullData(t));
    },
    filteredRecipients() {
      if (!this.searchQuery) return this.recipients;
      const t = Iie(this.searchQuery);
      return this.recipients.filter((e) => t.every(
        (n) => n.test(Ps(e.name || "")) || n.test(e.first_name || "") || n.test(e.last_name || "") || n.test(e.patronymic || "") || n.test(e.code || "")
      ));
    },
    defaultRecipient() {
      if (this.getDefaultRecipient)
        return this.getFullData(this.getDefaultRecipient);
    },
    selectedRecipient() {
      if (this.selected.length)
        return this.getFullData(this.selected[0]);
    },
    canSetDefaultRecipient() {
      var t;
      return !!((t = this.params) != null && t.canSetDefault);
    }
  },
  watch: {
    defaultRecipient(t) {
      var e;
      (e = this.params) != null && e.canSetDefault && t && (this.selected = [t]);
    }
  },
  activated() {
    this.fetchData(), this.$refs.searchField && this.$refs.searchField.focus();
  },
  deactivated() {
    this.reset();
  },
  methods: {
    ...ge({
      hideShareModal: "hideShareModal",
      shareDispatcher: "shareDispatcher",
      getRecipients: "getRecipients",
      clearList: "clearList",
      setRecipientsList: "shareModalSetRecipients",
      addRecipientsToList: "shareModalAddRecipients",
      addMessage: "addMessage"
    }),
    ...ge("userProfile", [
      "setProfileDefaultRecipientGroup",
      "setProfileDefaultRecipientUser"
    ]),
    handleSearch(t) {
      this.searchQuery = t || "";
    },
    async fetchData() {
      var n, r;
      this.loading = !0;
      const t = await this.getRecipients(!!((n = this.params) != null && n.forASOI)), e = ((r = this.params) == null ? void 0 : r.canSetDefault) && t.find((s) => s.id === this.getDefaultRecipientId) || null;
      this.setRecipientsList({ recipients: t, defaultRecipient: e }), this.loading = !1;
    },
    reset() {
      this.selected = [], this.searchQuery = "", this.asoiComment = "", this.$refs.searchField && (this.$refs.searchField.query = ""), this.clearList();
    },
    updateSelected(t) {
      this.selected = t;
    },
    removeFromSelected(t) {
      this.selected = this.selected.filter(({ id: e, name: n }) => e !== t.id || n !== t.name);
    },
    share() {
      const t = {
        groupIds: this.selected.filter(({ is_group: e }) => e).map((e) => e.id),
        userIds: this.selected.filter(({ is_group: e }) => !e).map((e) => e.id)
      };
      this.asoiComment && this.asoiComment.length > 0 && (t.asoiComment = this.asoiComment.trim()), this.shareDispatcher(t), this.settingsMenuVisible = !1;
    },
    async applySettings({ option: t }) {
      if (t === "save") {
        const e = this.selected[0];
        if (!e) return;
        e.is_group ? this.setProfileDefaultRecipientGroup(e.id) : this.setProfileDefaultRecipientUser(e.id), this.addMessage({
          type: "success",
          text: "Получатель по умолчанию успешно сохранен"
        });
      } else t === "reset" && (this.getDefaultRecipient.is_group ? this.setProfileDefaultRecipientGroup(null) : this.setProfileDefaultRecipientUser(null), this.addMessage({
        type: "success",
        text: "Получатель по умолчанию удален"
      }), this.selected = []);
      this.settingsMenuVisible = !1;
    },
    getFullData(t) {
      return t.is_group ? this.getGroupById(t.id) : this.getUserById(t.id);
    },
    closeModal() {
      this.settingsMenuVisible = !1, this.hideShareModal();
    }
  }
};
var jrt = function() {
  var e = this, n = e._self._c;
  return n("ModalCentered", { class: e.$style.root, attrs: { maxWidth: 440, minWidth: 290, toolbarHeight: 56, toolbarFontSize: "1rem", title: e.title, allowEventPropagOnClick: e.canSetDefaultRecipient, "data-test-selector": "share-modal", "data-test-attrs": `type__${e.itemType} action__${e.actionType}` }, on: { close: e.closeModal }, scopedSlots: e._u([e.canSetDefaultRecipient ? { key: "topBar", fn: function() {
    return [n("PbButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: "Настройки", expression: "'Настройки'" }], class: e.$style.settings, attrs: { round: "" }, on: { click: function(r) {
      r.stopPropagation(), e.settingsMenuVisible = !e.settingsMenuVisible;
    } } }, [n("icon", { attrs: { type: "font", name: "settings", size: "20" } }), n("SettingsMenu", { attrs: { visible: e.settingsMenuVisible, selectedRecipient: e.selectedRecipient, defaultRecipient: e.defaultRecipient }, on: { apply: e.applySettings, hide: function(r) {
      e.settingsMenuVisible = !1;
    } } })], 1)];
  }, proxy: !0 } : null, { key: "content", fn: function() {
    return [n("div", { class: e.$style.content }, [e.multipleMode && e.selected.length ? n("transition-group", { class: e.$style.selected, attrs: { tag: "div", name: "slide-y-reverse-transition", appear: "" } }, e._l(e.selected, function(r, s) {
      return n("PbChip", { key: s + "-" + r.id, attrs: { textColor: "#246cdc" }, on: { remove: function(i) {
        return e.removeFromSelected(r);
      } } }, [n("label", [e._v(e._s(r.name))])]);
    }), 1) : e._e(), e.params && e.params.hasComment ? n("toolbar", { class: e.$style.comment, attrs: { "data-test-selector": "share-modal__asoi-comment" } }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.asoiComment, expression: "asoiComment" }], class: e.$style.commentField, attrs: { type: "text", maxlength: "450", placeholder: "Комментарий", "data-test-selector": "share-modal__asoi-comment-field" }, domProps: { value: e.asoiComment }, on: { input: function(r) {
      r.target.composing || (e.asoiComment = r.target.value);
    } } }), e.asoiComment.length > 0 ? n("span", { class: e.$style.commentCount, attrs: { title: "Максимальная длина комментария", "data-test-selector": "share-modal__asoi-comment-count" } }, [e._v(" " + e._s(e.asoiComment.length) + " / 450 ")]) : e._e()]) : e._e(), n("toolbar", { class: e.$style.search }, [n("SearchField", { ref: "searchField", attrs: { initialQuery: e.searchQuery, autofocus: "", dark: "", rounded: "", slim: "", placeholder: "Поиск по имени", "data-test-selector": "share-modal-search-field" }, on: { input: e.handleSearch } })], 1), n("div", { class: e.$style.list }, [n("PbUsersList", { ref: "usersList", attrs: { entries: e.filteredRecipients, searchQuery: e.searchQuery, multipleMode: e.multipleMode, loaded: !0, loading: e.loading, checkedItems: e.selected, useLayoutTranslation: !0 }, on: { selected: function(r) {
      return e.updateSelected(r);
    }, submit: e.share } })], 1)], 1)];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-send", disabled: !e.selected.length, "data-test-selector": "share-modal-button-share" }, nativeOn: { click: function(r) {
      return e.share.apply(null, arguments);
    } } }, [e._v(" Отправить выбранным ")])];
  }, proxy: !0 }], null, !0) });
}, Wrt = [];
const K$ = {
  $style: Frt
};
function Hrt(t) {
  for (var e in K$)
    this[e] = K$[e];
}
var Vrt = /* @__PURE__ */ B(
  Brt,
  jrt,
  Wrt,
  !1,
  Hrt,
  null
);
const zrt = Vrt.exports, Urt = "_content_bzp3f_1", Grt = "_selected_bzp3f_8", Yrt = "_search_bzp3f_25", Zrt = "_list_bzp3f_30", Xrt = {
  content: Urt,
  selected: Grt,
  search: Yrt,
  list: Zrt
}, Krt = {
  name: "AuthorsModal",
  components: {
    ModalCentered: LI,
    Toolbar: xo,
    PbChip: L8,
    SearchField: Mu,
    PbUsersList: F8,
    MainActionButton: fn
  },
  provide() {
    return {
      toolbarStyles: {
        boxShadow: "none"
      }
    };
  },
  data() {
    return {
      selected: [],
      searchQuery: "",
      loading: !1,
      loaded: !1,
      offset: 0,
      limit: 20
    };
  },
  computed: {
    ...st({
      newsItemId: (t) => t.authorsModal.itemId,
      usersList: (t) => t.authorsModal.usersList
    }),
    ...pe("news", ["getNewsItemCurrentVersion"]),
    ...pe(["getUserById"]),
    version() {
      return this.getNewsItemCurrentVersion(this.newsItemId) || {};
    },
    users() {
      if (this.newsItemId && this.version) {
        const t = this.version.authors.map(({ user: e }) => e.id);
        return this.usersList.filter((e) => !t.includes(e)).map((e) => this.getUserById(e));
      }
      return [];
    }
  },
  activated() {
    this.fetchData(!0), this.$refs.searchField && this.$refs.searchField.focus();
  },
  deactivated() {
    this.reset();
  },
  methods: {
    ...ge("authorsModal", {
      hide: "hideAuthorsModal",
      setUsersList: "authorsModalUsersSet",
      addUsersToList: "authorsModalUsersAdd"
    }),
    ...ge({
      getUsers: "getUsers"
    }),
    ...ge("news", {
      addAuthors: "addAuthors"
    }),
    loadMore() {
      this.loaded || this.fetchData();
    },
    handleSearch(t) {
      this.searchQuery = t || "", this.loaded = !1, this.offset = 0, this.fetchData(!0);
    },
    async fetchData(t = !1) {
      if (this.loading) return;
      this.loading = !0;
      const e = {
        offset: this.offset,
        limit: this.limit
      };
      this.searchQuery && (e.search = this.searchQuery);
      const n = await this.getUsers(e);
      n.errors || (this.loaded = n.length < this.limit, this.offset += n.length, t ? (this.setUsersList(n), this.$refs.usersList.scrollToTop()) : this.addUsersToList(n)), this.loading = !1;
    },
    reset() {
      this.selected = [], this.offset = 0, this.searchQuery = "", this.loaded = !1, this.loading = !1, this.$refs.searchField && (this.$refs.searchField.query = "");
    },
    updateSelected(t) {
      this.selected = t;
    },
    removeFromSelected(t) {
      this.selected = this.selected.filter(({ id: e }) => e !== t.id);
    },
    async submit() {
      const t = this.selected.map(({ id: e }) => e);
      await this.addAuthors({ newsItemId: this.newsItemId, userIds: t }), this.hide();
    }
  }
};
var Jrt = function() {
  var e = this, n = e._self._c;
  return n("ModalCentered", { class: e.$style.root, attrs: { maxWidth: 440, minWidth: 290, toolbarHeight: 56, toolbarFontSize: "1rem", title: "Добавить авторов к новости", "data-test-selector": "authors-modal" }, on: { close: function(r) {
    return e.hide();
  } }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [n("div", { class: e.$style.content }, [e.selected.length ? n("transition-group", { class: e.$style.selected, attrs: { tag: "div", name: "slide-y-reverse-transition", appear: "" } }, e._l(e.selected, function(r) {
      return n("PbChip", { key: r.id, attrs: { textColor: "#246cdc" }, on: { remove: function(s) {
        return e.removeFromSelected(r);
      } } }, [n("label", [e._v(e._s(r.name))])]);
    }), 1) : e._e(), n("toolbar", { class: e.$style.search }, [n("SearchField", { ref: "searchField", attrs: { initialQuery: e.searchQuery, autofocus: "", dark: "", rounded: "", slim: "", placeholder: "Поиск по имени", "data-test-selector": "authors-modal-search-field" }, on: { input: e.handleSearch } })], 1), n("div", { class: e.$style.list }, [n("PbUsersList", { ref: "usersList", attrs: { entries: e.users, searchQuery: e.searchQuery, multipleMode: !0, loaded: e.loaded, loading: e.loading, checkedItems: e.selected, useLayoutTranslation: !0 }, on: { selected: function(r) {
      return e.updateSelected(r);
    }, submit: e.submit, loadMore: e.loadMore } })], 1)], 1)];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", disabled: !e.selected.length, "data-test-selector": "authors-modal-button-submit" }, nativeOn: { click: function(r) {
      return e.submit.apply(null, arguments);
    } } }, [e._v(" Добавить " + e._s(e.selected.length > 1 ? "авторов" : "автора") + " ")])];
  }, proxy: !0 }]) });
}, qrt = [];
const J$ = {
  $style: Xrt
};
function Qrt(t) {
  for (var e in J$)
    this[e] = J$[e];
}
var est = /* @__PURE__ */ B(
  Krt,
  Jrt,
  qrt,
  !1,
  Qrt,
  null
);
const tst = est.exports;
function nst(t) {
  return t && t.replaceAll ? t.replaceAll(/\.(?!\d+)/g, "") : t;
}
const rst = "_body_q0xju_1", sst = "_loader_q0xju_5", ist = "_more_q0xju_9", ost = {
  body: rst,
  loader: sst,
  more: ist
}, ast = {
  name: "HistoryModal",
  components: {
    PbLoader: br,
    PbModal: Au,
    PbTable: t2
  },
  mixins: [Du],
  props: {
    state: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "История работы над"
    }
  },
  data() {
    return {
      tableHead: ["Дата и время", "Пользователь", "Действие", "Описание"]
    };
  },
  computed: {
    ...st({
      isLoading: (t) => t.historyModal.isLoading,
      eventRefs: (t) => t.references.NewsEvent.Type,
      hasMore: (t) => t.historyModal.cursor,
      tableData: (t) => t.historyModal.data,
      type: (t) => t.historyModal.itemType
    }),
    composedTitle() {
      const t = this.type === "news" ? "новостью" : "...";
      return `${this.title} ${t}`;
    },
    composedTableData() {
      return !this.tableData || !this.tableData.length ? [] : this.tableData.map((t) => {
        const e = new String(nst(t.description || ""));
        return e.style = { textAlign: "left" }, [
          on(
            Tr(t.created_at),
            "dd MMM yyyy-HH:mm:ss",
            {
              locale: xn
            }
          ).replace(/-/, `\r
`),
          this.formatUsername(t.user.name),
          this.eventRefs[t.type_id].description,
          e
        ];
      });
    },
    showLoader() {
      return this.isLoading && !this.hasMore;
    }
  },
  methods: {
    ...ge(["hideHistoryModal", "loadItemHistory"]),
    close() {
      this.state && (this.$emit("update:state", !1), this.hideHistoryModal());
    }
  }
};
var lst = function() {
  var e = this, n = e._self._c;
  return n("PbModal", { attrs: { state: e.state, title: e.composedTitle, "max-width": 800, "data-test-id": "dialog-history", "data-test-attrs": `type__${e.type}` }, on: { close: e.close } }, [n("div", { class: e.$style.body }, [n("transition", { attrs: { name: "fade", mode: "out-in" } }, [e.showLoader ? n("PbLoader", { class: e.$style.loader }) : n("div", [n("PbTable", { attrs: { head: e.tableHead, data: e.composedTableData } }), e.hasMore ? n("button", { class: e.$style.more, attrs: { disabled: e.isLoading }, on: { click: e.loadItemHistory } }, [n("transition", { attrs: { name: "fade", mode: "out-in" } }, [this.isLoading ? n("PbLoader", { attrs: { size: 17 } }) : n("span", [e._v("Загрузить еще")])], 1)], 1) : e._e()], 1)], 1)], 1)]);
}, cst = [];
const q$ = {
  $style: ost
};
function ust(t) {
  for (var e in q$)
    this[e] = q$[e];
}
var dst = /* @__PURE__ */ B(
  ast,
  lst,
  cst,
  !1,
  ust,
  null
);
const fst = dst.exports;
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: B8,
  setPrototypeOf: Q$,
  isFrozen: pst,
  getPrototypeOf: hst,
  getOwnPropertyDescriptor: mst
} = Object;
let {
  freeze: Ds,
  seal: xi,
  create: j8
} = Object, {
  apply: C1,
  construct: T1
} = typeof Reflect < "u" && Reflect;
Ds || (Ds = function(e) {
  return e;
});
xi || (xi = function(e) {
  return e;
});
C1 || (C1 = function(e, n, r) {
  return e.apply(n, r);
});
T1 || (T1 = function(e, n) {
  return new e(...n);
});
const jp = As(Array.prototype.forEach), vst = As(Array.prototype.lastIndexOf), eD = As(Array.prototype.pop), hd = As(Array.prototype.push), gst = As(Array.prototype.splice), Ih = As(String.prototype.toLowerCase), bb = As(String.prototype.toString), tD = As(String.prototype.match), md = As(String.prototype.replace), yst = As(String.prototype.indexOf), bst = As(String.prototype.trim), Ri = As(Object.prototype.hasOwnProperty), Is = As(RegExp.prototype.test), vd = _st(TypeError);
function As(t) {
  return function(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      r[s - 1] = arguments[s];
    return C1(t, e, r);
  };
}
function _st(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return T1(t, n);
  };
}
function Ot(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ih;
  Q$ && Q$(t, null);
  let r = e.length;
  for (; r--; ) {
    let s = e[r];
    if (typeof s == "string") {
      const i = n(s);
      i !== s && (pst(e) || (e[r] = i), s = i);
    }
    t[s] = !0;
  }
  return t;
}
function wst(t) {
  for (let e = 0; e < t.length; e++)
    Ri(t, e) || (t[e] = null);
  return t;
}
function Tl(t) {
  const e = j8(null);
  for (const [n, r] of B8(t))
    Ri(t, n) && (Array.isArray(r) ? e[n] = wst(r) : r && typeof r == "object" && r.constructor === Object ? e[n] = Tl(r) : e[n] = r);
  return e;
}
function gd(t, e) {
  for (; t !== null; ) {
    const r = mst(t, e);
    if (r) {
      if (r.get)
        return As(r.get);
      if (typeof r.value == "function")
        return As(r.value);
    }
    t = hst(t);
  }
  function n() {
    return null;
  }
  return n;
}
const nD = Ds(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), _b = Ds(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), wb = Ds(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Sst = Ds(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Sb = Ds(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Ist = Ds(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), rD = Ds(["#text"]), sD = Ds(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ib = Ds(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), iD = Ds(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Wp = Ds(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Est = xi(/\{\{[\w\W]*|[\w\W]*\}\}/gm), xst = xi(/<%[\w\W]*|[\w\W]*%>/gm), Cst = xi(/\$\{[\w\W]*/gm), Tst = xi(/^data-[\-\w.\u00B7-\uFFFF]+$/), Pst = xi(/^aria-[\-\w]+$/), W8 = xi(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), kst = xi(/^(?:\w+script|data):/i), Nst = xi(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), H8 = xi(/^html$/i), $st = xi(/^[a-z][.\w]*(-[.\w]+)+$/i);
var oD = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Pst,
  ATTR_WHITESPACE: Nst,
  CUSTOM_ELEMENT: $st,
  DATA_ATTR: Tst,
  DOCTYPE_NAME: H8,
  ERB_EXPR: xst,
  IS_ALLOWED_URI: W8,
  IS_SCRIPT_OR_DATA: kst,
  MUSTACHE_EXPR: Est,
  TMPLIT_EXPR: Cst
});
const yd = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, Dst = function() {
  return typeof window > "u" ? null : window;
}, Ast = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const s = "data-tt-policy-suffix";
  n && n.hasAttribute(s) && (r = n.getAttribute(s));
  const i = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(i, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, aD = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function V8() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Dst();
  const e = (De) => V8(De);
  if (e.version = "3.2.4", e.removed = [], !t || !t.document || t.document.nodeType !== yd.document || !t.Element)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const r = n, s = r.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: o,
    Node: a,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: p
  } = t, h = l.prototype, m = gd(h, "cloneNode"), v = gd(h, "remove"), y = gd(h, "nextSibling"), _ = gd(h, "childNodes"), w = gd(h, "parentNode");
  if (typeof o == "function") {
    const De = n.createElement("template");
    De.content && De.content.ownerDocument && (n = De.content.ownerDocument);
  }
  let S, E = "";
  const {
    implementation: x,
    createNodeIterator: T,
    createDocumentFragment: C,
    getElementsByTagName: k
  } = n, {
    importNode: b
  } = r;
  let P = aD();
  e.isSupported = typeof B8 == "function" && typeof w == "function" && x && x.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: N,
    ERB_EXPR: D,
    TMPLIT_EXPR: H,
    DATA_ATTR: Y,
    ARIA_ATTR: te,
    IS_SCRIPT_OR_DATA: A,
    ATTR_WHITESPACE: j,
    CUSTOM_ELEMENT: L
  } = oD;
  let {
    IS_ALLOWED_URI: se
  } = oD, V = null;
  const ee = Ot({}, [...nD, ..._b, ...wb, ...Sb, ...rD]);
  let O = null;
  const K = Ot({}, [...sD, ...Ib, ...iD, ...Wp]);
  let z = Object.seal(j8(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), q = null, ae = null, Ee = !0, Ae = !0, Ue = !1, qe = !0, Qe = !1, Lt = !0, Yt = !1, nn = !1, qt = !1, rn = !1, sn = !1, zn = !1, ns = !0, Nt = !1;
  const dt = "user-content-";
  let xt = !0, Wt = !1, Tt = {}, _r = null;
  const dr = Ot({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let qn = null;
  const yn = Ot({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ve = null;
  const Ze = Ot({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), it = "http://www.w3.org/1998/Math/MathML", St = "http://www.w3.org/2000/svg", ze = "http://www.w3.org/1999/xhtml";
  let $t = ze, Fs = !1, zs = null;
  const fr = Ot({}, [it, St, ze], bb);
  let ln = Ot({}, ["mi", "mo", "mn", "ms", "mtext"]), wn = Ot({}, ["annotation-xml"]);
  const sa = Ot({}, ["title", "style", "font", "a", "script"]);
  let ws = null;
  const ia = ["application/xhtml+xml", "text/html"], oa = "text/html";
  let An = null, Us = null;
  const pr = n.createElement("form"), aa = function(Q) {
    return Q instanceof RegExp || Q instanceof Function;
  }, No = function() {
    let Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Us && Us === Q)) {
      if ((!Q || typeof Q != "object") && (Q = {}), Q = Tl(Q), ws = // eslint-disable-next-line unicorn/prefer-includes
      ia.indexOf(Q.PARSER_MEDIA_TYPE) === -1 ? oa : Q.PARSER_MEDIA_TYPE, An = ws === "application/xhtml+xml" ? bb : Ih, V = Ri(Q, "ALLOWED_TAGS") ? Ot({}, Q.ALLOWED_TAGS, An) : ee, O = Ri(Q, "ALLOWED_ATTR") ? Ot({}, Q.ALLOWED_ATTR, An) : K, zs = Ri(Q, "ALLOWED_NAMESPACES") ? Ot({}, Q.ALLOWED_NAMESPACES, bb) : fr, Ve = Ri(Q, "ADD_URI_SAFE_ATTR") ? Ot(Tl(Ze), Q.ADD_URI_SAFE_ATTR, An) : Ze, qn = Ri(Q, "ADD_DATA_URI_TAGS") ? Ot(Tl(yn), Q.ADD_DATA_URI_TAGS, An) : yn, _r = Ri(Q, "FORBID_CONTENTS") ? Ot({}, Q.FORBID_CONTENTS, An) : dr, q = Ri(Q, "FORBID_TAGS") ? Ot({}, Q.FORBID_TAGS, An) : {}, ae = Ri(Q, "FORBID_ATTR") ? Ot({}, Q.FORBID_ATTR, An) : {}, Tt = Ri(Q, "USE_PROFILES") ? Q.USE_PROFILES : !1, Ee = Q.ALLOW_ARIA_ATTR !== !1, Ae = Q.ALLOW_DATA_ATTR !== !1, Ue = Q.ALLOW_UNKNOWN_PROTOCOLS || !1, qe = Q.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Qe = Q.SAFE_FOR_TEMPLATES || !1, Lt = Q.SAFE_FOR_XML !== !1, Yt = Q.WHOLE_DOCUMENT || !1, rn = Q.RETURN_DOM || !1, sn = Q.RETURN_DOM_FRAGMENT || !1, zn = Q.RETURN_TRUSTED_TYPE || !1, qt = Q.FORCE_BODY || !1, ns = Q.SANITIZE_DOM !== !1, Nt = Q.SANITIZE_NAMED_PROPS || !1, xt = Q.KEEP_CONTENT !== !1, Wt = Q.IN_PLACE || !1, se = Q.ALLOWED_URI_REGEXP || W8, $t = Q.NAMESPACE || ze, ln = Q.MATHML_TEXT_INTEGRATION_POINTS || ln, wn = Q.HTML_INTEGRATION_POINTS || wn, z = Q.CUSTOM_ELEMENT_HANDLING || {}, Q.CUSTOM_ELEMENT_HANDLING && aa(Q.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (z.tagNameCheck = Q.CUSTOM_ELEMENT_HANDLING.tagNameCheck), Q.CUSTOM_ELEMENT_HANDLING && aa(Q.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (z.attributeNameCheck = Q.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), Q.CUSTOM_ELEMENT_HANDLING && typeof Q.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (z.allowCustomizedBuiltInElements = Q.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Qe && (Ae = !1), sn && (rn = !0), Tt && (V = Ot({}, rD), O = [], Tt.html === !0 && (Ot(V, nD), Ot(O, sD)), Tt.svg === !0 && (Ot(V, _b), Ot(O, Ib), Ot(O, Wp)), Tt.svgFilters === !0 && (Ot(V, wb), Ot(O, Ib), Ot(O, Wp)), Tt.mathMl === !0 && (Ot(V, Sb), Ot(O, iD), Ot(O, Wp))), Q.ADD_TAGS && (V === ee && (V = Tl(V)), Ot(V, Q.ADD_TAGS, An)), Q.ADD_ATTR && (O === K && (O = Tl(O)), Ot(O, Q.ADD_ATTR, An)), Q.ADD_URI_SAFE_ATTR && Ot(Ve, Q.ADD_URI_SAFE_ATTR, An), Q.FORBID_CONTENTS && (_r === dr && (_r = Tl(_r)), Ot(_r, Q.FORBID_CONTENTS, An)), xt && (V["#text"] = !0), Yt && Ot(V, ["html", "head", "body"]), V.table && (Ot(V, ["tbody"]), delete q.tbody), Q.TRUSTED_TYPES_POLICY) {
        if (typeof Q.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw vd('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof Q.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw vd('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        S = Q.TRUSTED_TYPES_POLICY, E = S.createHTML("");
      } else
        S === void 0 && (S = Ast(p, s)), S !== null && typeof E == "string" && (E = S.createHTML(""));
      Ds && Ds(Q), Us = Q;
    }
  }, $o = Ot({}, [..._b, ...wb, ...Sst]), Zt = Ot({}, [...Sb, ...Ist]), ul = function(Q) {
    let _e = w(Q);
    (!_e || !_e.tagName) && (_e = {
      namespaceURI: $t,
      tagName: "template"
    });
    const Be = Ih(Q.tagName), Ht = Ih(_e.tagName);
    return zs[Q.namespaceURI] ? Q.namespaceURI === St ? _e.namespaceURI === ze ? Be === "svg" : _e.namespaceURI === it ? Be === "svg" && (Ht === "annotation-xml" || ln[Ht]) : !!$o[Be] : Q.namespaceURI === it ? _e.namespaceURI === ze ? Be === "math" : _e.namespaceURI === St ? Be === "math" && wn[Ht] : !!Zt[Be] : Q.namespaceURI === ze ? _e.namespaceURI === St && !wn[Ht] || _e.namespaceURI === it && !ln[Ht] ? !1 : !Zt[Be] && (sa[Be] || !$o[Be]) : !!(ws === "application/xhtml+xml" && zs[Q.namespaceURI]) : !1;
  }, rs = function(Q) {
    hd(e.removed, {
      element: Q
    });
    try {
      w(Q).removeChild(Q);
    } catch {
      v(Q);
    }
  }, X = function(Q, _e) {
    try {
      hd(e.removed, {
        attribute: _e.getAttributeNode(Q),
        from: _e
      });
    } catch {
      hd(e.removed, {
        attribute: null,
        from: _e
      });
    }
    if (_e.removeAttribute(Q), Q === "is")
      if (rn || sn)
        try {
          rs(_e);
        } catch {
        }
      else
        try {
          _e.setAttribute(Q, "");
        } catch {
        }
  }, R = function(Q) {
    let _e = null, Be = null;
    if (qt)
      Q = "<remove></remove>" + Q;
    else {
      const Vt = tD(Q, /^[\r\n\t ]+/);
      Be = Vt && Vt[0];
    }
    ws === "application/xhtml+xml" && $t === ze && (Q = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + Q + "</body></html>");
    const Ht = S ? S.createHTML(Q) : Q;
    if ($t === ze)
      try {
        _e = new f().parseFromString(Ht, ws);
      } catch {
      }
    if (!_e || !_e.documentElement) {
      _e = x.createDocument($t, "template", null);
      try {
        _e.documentElement.innerHTML = Fs ? E : Ht;
      } catch {
      }
    }
    const at = _e.body || _e.documentElement;
    return Q && Be && at.insertBefore(n.createTextNode(Be), at.childNodes[0] || null), $t === ze ? k.call(_e, Yt ? "html" : "body")[0] : Yt ? _e.documentElement : at;
  }, Z = function(Q) {
    return T.call(
      Q.ownerDocument || Q,
      Q,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, ne = function(Q) {
    return Q instanceof d && (typeof Q.nodeName != "string" || typeof Q.textContent != "string" || typeof Q.removeChild != "function" || !(Q.attributes instanceof u) || typeof Q.removeAttribute != "function" || typeof Q.setAttribute != "function" || typeof Q.namespaceURI != "string" || typeof Q.insertBefore != "function" || typeof Q.hasChildNodes != "function");
  }, we = function(Q) {
    return typeof a == "function" && Q instanceof a;
  };
  function be(De, Q, _e) {
    jp(De, (Be) => {
      Be.call(e, Q, _e, Us);
    });
  }
  const Le = function(Q) {
    let _e = null;
    if (be(P.beforeSanitizeElements, Q, null), ne(Q))
      return rs(Q), !0;
    const Be = An(Q.nodeName);
    if (be(P.uponSanitizeElement, Q, {
      tagName: Be,
      allowedTags: V
    }), Q.hasChildNodes() && !we(Q.firstElementChild) && Is(/<[/\w]/g, Q.innerHTML) && Is(/<[/\w]/g, Q.textContent) || Q.nodeType === yd.progressingInstruction || Lt && Q.nodeType === yd.comment && Is(/<[/\w]/g, Q.data))
      return rs(Q), !0;
    if (!V[Be] || q[Be]) {
      if (!q[Be] && je(Be) && (z.tagNameCheck instanceof RegExp && Is(z.tagNameCheck, Be) || z.tagNameCheck instanceof Function && z.tagNameCheck(Be)))
        return !1;
      if (xt && !_r[Be]) {
        const Ht = w(Q) || Q.parentNode, at = _(Q) || Q.childNodes;
        if (at && Ht) {
          const Vt = at.length;
          for (let pn = Vt - 1; pn >= 0; --pn) {
            const bn = m(at[pn], !0);
            bn.__removalCount = (Q.__removalCount || 0) + 1, Ht.insertBefore(bn, y(Q));
          }
        }
      }
      return rs(Q), !0;
    }
    return Q instanceof l && !ul(Q) || (Be === "noscript" || Be === "noembed" || Be === "noframes") && Is(/<\/no(script|embed|frames)/i, Q.innerHTML) ? (rs(Q), !0) : (Qe && Q.nodeType === yd.text && (_e = Q.textContent, jp([N, D, H], (Ht) => {
      _e = md(_e, Ht, " ");
    }), Q.textContent !== _e && (hd(e.removed, {
      element: Q.cloneNode()
    }), Q.textContent = _e)), be(P.afterSanitizeElements, Q, null), !1);
  }, Xe = function(Q, _e, Be) {
    if (ns && (_e === "id" || _e === "name") && (Be in n || Be in pr))
      return !1;
    if (!(Ae && !ae[_e] && Is(Y, _e))) {
      if (!(Ee && Is(te, _e))) {
        if (!O[_e] || ae[_e]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(je(Q) && (z.tagNameCheck instanceof RegExp && Is(z.tagNameCheck, Q) || z.tagNameCheck instanceof Function && z.tagNameCheck(Q)) && (z.attributeNameCheck instanceof RegExp && Is(z.attributeNameCheck, _e) || z.attributeNameCheck instanceof Function && z.attributeNameCheck(_e)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            _e === "is" && z.allowCustomizedBuiltInElements && (z.tagNameCheck instanceof RegExp && Is(z.tagNameCheck, Be) || z.tagNameCheck instanceof Function && z.tagNameCheck(Be)))
          ) return !1;
        } else if (!Ve[_e]) {
          if (!Is(se, md(Be, j, ""))) {
            if (!((_e === "src" || _e === "xlink:href" || _e === "href") && Q !== "script" && yst(Be, "data:") === 0 && qn[Q])) {
              if (!(Ue && !Is(A, md(Be, j, "")))) {
                if (Be)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, je = function(Q) {
    return Q !== "annotation-xml" && tD(Q, L);
  }, vt = function(Q) {
    be(P.beforeSanitizeAttributes, Q, null);
    const {
      attributes: _e
    } = Q;
    if (!_e || ne(Q))
      return;
    const Be = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: O,
      forceKeepAttr: void 0
    };
    let Ht = _e.length;
    for (; Ht--; ) {
      const at = _e[Ht], {
        name: Vt,
        namespaceURI: pn,
        value: bn
      } = at, zr = An(Vt);
      let _n = Vt === "value" ? bn : bst(bn);
      if (Be.attrName = zr, Be.attrValue = _n, Be.keepAttr = !0, Be.forceKeepAttr = void 0, be(P.uponSanitizeAttribute, Q, Be), _n = Be.attrValue, Nt && (zr === "id" || zr === "name") && (X(Vt, Q), _n = dt + _n), Lt && Is(/((--!?|])>)|<\/(style|title)/i, _n)) {
        X(Vt, Q);
        continue;
      }
      if (Be.forceKeepAttr || (X(Vt, Q), !Be.keepAttr))
        continue;
      if (!qe && Is(/\/>/i, _n)) {
        X(Vt, Q);
        continue;
      }
      Qe && jp([N, D, H], (Bs) => {
        _n = md(_n, Bs, " ");
      });
      const wr = An(Q.nodeName);
      if (Xe(wr, zr, _n)) {
        if (S && typeof p == "object" && typeof p.getAttributeType == "function" && !pn)
          switch (p.getAttributeType(wr, zr)) {
            case "TrustedHTML": {
              _n = S.createHTML(_n);
              break;
            }
            case "TrustedScriptURL": {
              _n = S.createScriptURL(_n);
              break;
            }
          }
        try {
          pn ? Q.setAttributeNS(pn, Vt, _n) : Q.setAttribute(Vt, _n), ne(Q) ? rs(Q) : eD(e.removed);
        } catch {
        }
      }
    }
    be(P.afterSanitizeAttributes, Q, null);
  }, Pt = function De(Q) {
    let _e = null;
    const Be = Z(Q);
    for (be(P.beforeSanitizeShadowDOM, Q, null); _e = Be.nextNode(); )
      be(P.uponSanitizeShadowNode, _e, null), Le(_e), vt(_e), _e.content instanceof i && De(_e.content);
    be(P.afterSanitizeShadowDOM, Q, null);
  };
  return e.sanitize = function(De) {
    let Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _e = null, Be = null, Ht = null, at = null;
    if (Fs = !De, Fs && (De = "<!-->"), typeof De != "string" && !we(De))
      if (typeof De.toString == "function") {
        if (De = De.toString(), typeof De != "string")
          throw vd("dirty is not a string, aborting");
      } else
        throw vd("toString is not a function");
    if (!e.isSupported)
      return De;
    if (nn || No(Q), e.removed = [], typeof De == "string" && (Wt = !1), Wt) {
      if (De.nodeName) {
        const bn = An(De.nodeName);
        if (!V[bn] || q[bn])
          throw vd("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (De instanceof a)
      _e = R("<!---->"), Be = _e.ownerDocument.importNode(De, !0), Be.nodeType === yd.element && Be.nodeName === "BODY" || Be.nodeName === "HTML" ? _e = Be : _e.appendChild(Be);
    else {
      if (!rn && !Qe && !Yt && // eslint-disable-next-line unicorn/prefer-includes
      De.indexOf("<") === -1)
        return S && zn ? S.createHTML(De) : De;
      if (_e = R(De), !_e)
        return rn ? null : zn ? E : "";
    }
    _e && qt && rs(_e.firstChild);
    const Vt = Z(Wt ? De : _e);
    for (; Ht = Vt.nextNode(); )
      Le(Ht), vt(Ht), Ht.content instanceof i && Pt(Ht.content);
    if (Wt)
      return De;
    if (rn) {
      if (sn)
        for (at = C.call(_e.ownerDocument); _e.firstChild; )
          at.appendChild(_e.firstChild);
      else
        at = _e;
      return (O.shadowroot || O.shadowrootmode) && (at = b.call(r, at, !0)), at;
    }
    let pn = Yt ? _e.outerHTML : _e.innerHTML;
    return Yt && V["!doctype"] && _e.ownerDocument && _e.ownerDocument.doctype && _e.ownerDocument.doctype.name && Is(H8, _e.ownerDocument.doctype.name) && (pn = "<!DOCTYPE " + _e.ownerDocument.doctype.name + `>
` + pn), Qe && jp([N, D, H], (bn) => {
      pn = md(pn, bn, " ");
    }), S && zn ? S.createHTML(pn) : pn;
  }, e.setConfig = function() {
    let De = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    No(De), nn = !0;
  }, e.clearConfig = function() {
    Us = null, nn = !1;
  }, e.isValidAttribute = function(De, Q, _e) {
    Us || No({});
    const Be = An(De), Ht = An(Q);
    return Xe(Be, Ht, _e);
  }, e.addHook = function(De, Q) {
    typeof Q == "function" && hd(P[De], Q);
  }, e.removeHook = function(De, Q) {
    if (Q !== void 0) {
      const _e = vst(P[De], Q);
      return _e === -1 ? void 0 : gst(P[De], _e, 1)[0];
    }
    return eD(P[De]);
  }, e.removeHooks = function(De) {
    P[De] = [];
  }, e.removeAllHooks = function() {
    P = aD();
  }, e;
}
var lD = V8();
const Ost = "_root_fg8w3_1", Mst = "_vertical_fg8w3_9", Rst = "_header_fg8w3_29", Lst = "_source_fg8w3_53", Fst = "_icon_fg8w3_61", Bst = "_date_fg8w3_66", jst = "_body_fg8w3_71", Wst = "__revoked_fg8w3_83", Hst = "__express_fg8w3_90", Vst = "__flash_fg8w3_94", zst = "_footer_fg8w3_99", Ust = {
  root: Ost,
  vertical: Mst,
  header: Rst,
  source: Lst,
  icon: Fst,
  date: Bst,
  body: jst,
  _revoked: Wst,
  _express: Hst,
  _flash: Vst,
  footer: zst
}, Gst = {
  name: "RelationsEntry",
  components: {
    NewsTypeButton: ea,
    DateWidget: Hr
  },
  props: {
    type: {
      type: String,
      required: !0,
      validator: (t) => ["newsItem", "newsbreak", "asoiNote", "thumb"].includes(t)
    },
    entry: {
      type: Object,
      required: !0
    },
    isCurrent: {
      type: Boolean,
      default: !1
    },
    hasHorizontalLine: {
      type: Boolean,
      default: !0
    },
    dateMode: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...pe("references", ["newsTypesByName"]),
    isFlash() {
      return this.type === "newsItem" && this.entry.type_id === this.newsTypesByName.FLASH.id;
    },
    isExpress() {
      return this.type === "newsItem" && this.entry.type_id === this.newsTypesByName.EXPRESS.id;
    }
  }
};
var Yst = function() {
  var e = this, n = e._self._c;
  return e.type === "thumb" ? n("div", { class: {
    [e.$style.root]: !0,
    [e.type]: !0
  } }) : n("div", { class: {
    [e.$style.root]: !0,
    [e.type]: !0,
    _current: e.isCurrent,
    _horizontal: e.hasHorizontalLine,
    [e.$style._revoked]: e.entry.is_revoked,
    [e.$style._express]: e.isExpress,
    [e.$style._flash]: e.isFlash
  } }, [n("span", { class: e.$style.vertical }), n("div", { class: e.$style.header }, [["newsItem", "asoiNote"].includes(e.type) ? n("NewsTypeButton", { class: e.$style.icon, attrs: { typeId: e.entry.type_id, disabled: !0, color: [1, 2].includes(e.entry.type_id) ? "#D0021B" : null, "data-test-selector": "entry-type-button", "data-test-attrs": `type__${e.entry.type_id}` } }) : e._e(), e.type === "newsbreak" ? n("div", { class: e.$style.source }, [e._v(" " + e._s(e.entry.source) + " ")]) : e._e(), n("DateWidget", { class: e.$style.date, attrs: { date: e.entry.date, mode: e.dateMode }, on: { dateModeChanged: function(r) {
    return e.$emit("dateModeChanged", r);
  } } })], 1), n("div", { class: e.$style.body }, [n("span", { domProps: { innerHTML: e._s(e.entry.body) }, on: { click: function(r) {
    return e.$emit("click", e.entry);
  } } })]), n("div", { class: e.$style.footer, attrs: { title: e.entry.meta } }, [e._v(" " + e._s(e.entry.meta) + " ")])]);
}, Zst = [];
const cD = {
  $style: Ust
};
function Xst(t) {
  for (var e in cD)
    this[e] = cD[e];
}
var Kst = /* @__PURE__ */ B(
  Gst,
  Yst,
  Zst,
  !1,
  Xst,
  null
);
const Jst = Kst.exports, qst = "_loader_ok0zt_1", Qst = "_container_ok0zt_5", eit = "_col_ok0zt_10", tit = {
  loader: qst,
  container: Qst,
  col: eit
}, nit = {
  name: "NewsItemRelations",
  components: {
    PbLoader: br,
    RelationsEntry: Jst
  },
  data() {
    return {
      dateMode: 0
    };
  },
  computed: {
    ...st({
      newsItemId: (t) => t.relationsModal.itemId,
      isLoading: (t) => t.relationsModal.isLoading,
      data: (t) => t.relationsModal.data
    }),
    ...pe("references", [
      "newsStatusesByName",
      "newsLinkTypes",
      "newsLinkTypeByName"
    ]),
    ...pe("newsbreaks", ["getNewsbreakStatusByNb"]),
    ...pe("news", ["getNewsItemById", "getNewsItemCurrentVersion"]),
    ...pe("news/versions", ["versionAuthorsNames"]),
    currentNewsItem() {
      const t = this.getNewsItemCurrentVersion(this.newsItemId);
      return {
        ...this.getNewsItemById(this.newsItemId),
        version: t
      };
    },
    newsbreak() {
      var t;
      return (t = this.data) == null ? void 0 : t.newsbreak;
    },
    asoiNote() {
      var t;
      return (t = this.data) == null ? void 0 : t.asoi_note;
    },
    outgoingAsoiNotes() {
      var t;
      return (t = this.data) == null ? void 0 : t.outgoing_asoi_notes;
    },
    childLinks() {
      var t;
      return (t = this.data) == null ? void 0 : t.child_links;
    },
    parentLinks() {
      var t;
      return (t = this.data) == null ? void 0 : t.parent_links;
    },
    /**
     * Возвращает ids валидных родительских ( @see leftItems ) и дочерних ( @see rightItems ) связей
     * @returns {Array} [id1, id2, ...]
     */
    validLinkTypes() {
      return [
        this.newsLinkTypeByName.REPUBLICATION.id,
        this.newsLinkTypeByName.REPUBLICATION_UNEDITED.id,
        this.newsLinkTypeByName.REVOCATION.id,
        this.newsLinkTypeByName.EXTENSION.id
      ];
    },
    leftItems() {
      const t = [], e = this.parentLinks.filter((n) => this.validLinkTypes.includes(n.type_id)).map((n) => ({ type: "newsItem", entry: n.news }));
      return this.newsbreak && t.push({
        type: "newsbreak",
        entry: this.newsbreak,
        hasHorizontalLine: !(this.asoiNote || e.length > 0)
      }), this.asoiNote && t.push({ type: "asoiNote", entry: this.asoiNote }), Array.prototype.push.apply(t, e), t.map((n) => this.prepareItem(n));
    },
    centerItems() {
      const e = [this.prepareItem({
        type: "newsItem",
        entry: this.currentNewsItem,
        isCurrent: !0,
        hasHorizontalLine: this.rightItems.length > 0
      })];
      return this.leftItems.length > 1 && e.unshift({ entry: {}, type: "thumb" }), e;
    },
    rightItems() {
      const t = [], e = this.childLinks.filter((n) => this.validLinkTypes.includes(n.type_id)).map((n) => ({ type: "newsItem", entry: n.news }));
      if (Array.prototype.push.apply(t, e), this.outgoingAsoiNotes) {
        const n = this.outgoingAsoiNotes.map((r) => ({ type: "asoiNote", entry: r }));
        Array.prototype.push.apply(t, n);
      }
      return t.map((n) => this.prepareItem(n));
    }
  },
  methods: {
    ...ge("panels", ["addPanelFromRoute"]),
    prepareItem(t) {
      const e = {};
      switch (e.id = t.entry.id, e.type = t.type, e.meta = this.prepareMeta(t), t.type) {
        case "newsItem": {
          e.type_id = t.entry.version.type_id, e.date = t.entry.status_modified_at, e.body = this.prepareNewsItemText(t.entry.version), e.is_revoked = t.entry.is_revoked;
          break;
        }
        case "asoiNote":
          e.type_id = t.entry.type_id, e.date = t.entry.created_at, e.body = this.prepareNewsItemText(t.entry) || "Пустая заметка";
          break;
        case "newsbreak": {
          e.source = t.entry.lead.source.name, e.date = t.entry.created_at, e.body = t.entry.lead.clearedText;
          break;
        }
        default:
          return t;
      }
      return {
        type: t.type,
        entry: e,
        isCurrent: t.isCurrent,
        hasHorizontalLine: t.hasHorizontalLine
      };
    },
    prepareMeta(t) {
      switch (t.type) {
        case "newsItem": {
          const e = [
            this.newsStatusesByName.WAITS_FOR_PUBLICATION.id,
            this.newsStatusesByName.PUBLISHED.id
          ], n = this.versionAuthorsNames(t.entry.version.id);
          let r = n.join(", ");
          return e.includes(t.entry.version.status_id) && t.entry.publisher ? r = t.entry.publisher.name + " / " + r : r = (n.length > 1 ? "Авторы: " : "Автор: ") + r, r;
        }
        case "newsbreak": {
          const e = this.getNewsbreakStatusByNb(this.newsbreak), n = e.names.map(({ name: r }) => r).join(", ");
          return `${e.label}: ${n}`;
        }
        case "asoiNote":
          return t.entry.recipient_name ? "Кому: " + t.entry.recipient_name : t.entry.sender ? "Отправитель: " + t.entry.sender.name : "";
      }
    },
    prepareNewsItemText(t) {
      return t.headline ? lD.sanitize(t.headline, { ALLOWED_TAGS: ["p"] }).slice(0, 140) : t.body ? lD.sanitize(t.body, { ALLOWED_TAGS: ["p"] }).slice(0, 120) : "Пустая новость";
    },
    clickHandler(t) {
      this.$emit("hide");
      const e = {
        params: { id: t.id },
        meta: { type: "panel", panelType: t.type }
      };
      this.addPanelFromRoute(e);
    }
  }
};
var rit = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e.isLoading ? n("PbLoader", { class: e.$style.loader }) : n("div", { class: e.$style.container }, [n("div", { class: e.$style.col }, e._l(e.leftItems, function(r, s) {
    return n("RelationsEntry", { key: s, attrs: { type: r.type, entry: r.entry, hasHorizontalLine: r.hasHorizontalLine, dateMode: e.dateMode }, on: { click: e.clickHandler } });
  }), 1), n("div", { class: e.$style.col }, e._l(e.centerItems, function(r, s) {
    return n("RelationsEntry", { key: s, attrs: { type: r.type, entry: r.entry, isCurrent: r.isCurrent, hasHorizontalLine: r.hasHorizontalLine, dateMode: e.dateMode }, on: { click: e.clickHandler } });
  }), 1), n("div", { class: e.$style.col }, e._l(e.rightItems, function(r, s) {
    return n("RelationsEntry", { key: s, attrs: { type: r.type, entry: r.entry, hasHorizontalLine: !1, dateMode: e.dateMode }, on: { click: e.clickHandler } });
  }), 1)])], 1);
}, sit = [];
const uD = {
  $style: tit
};
function iit(t) {
  for (var e in uD)
    this[e] = uD[e];
}
var oit = /* @__PURE__ */ B(
  nit,
  rit,
  sit,
  !1,
  iit,
  null
);
const ait = oit.exports, lit = "_root_yq5z5_1", cit = {
  root: lit
}, uit = {
  name: "RelationsModal",
  components: {
    PbModal: Au,
    NewsItemRelations: ait
  },
  mixins: [Du],
  props: {
    state: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    ...ge(["hideRelationsModal"]),
    close() {
      this.state && (this.$emit("update:state", !1), this.hideRelationsModal());
    }
  }
};
var dit = function() {
  var e = this, n = e._self._c;
  return n("PbModal", { attrs: { state: e.state, title: "История материала", minWidth: 840, maxWidth: 840, "data-test-id": "dialog-relations" }, on: { close: e.close } }, [n("div", { class: e.$style.root }, [n("transition", { attrs: { name: "fade", mode: "out-in" } }, [n("NewsItemRelations", { on: { hide: e.close } })], 1)], 1)]);
}, fit = [];
const dD = {
  $style: cit
};
function pit(t) {
  for (var e in dD)
    this[e] = dD[e];
}
var hit = /* @__PURE__ */ B(
  uit,
  dit,
  fit,
  !1,
  pit,
  null
);
const mit = hit.exports, vit = {
  name: "TheHackerInterface",
  computed: {
    ...st({
      leadsLength: (t) => Object.keys(t.leads.items).length,
      leadRefs: (t) => t.leads.refs
    })
  },
  methods: {
    setExpiredAccessToken() {
      ni.auth.setCreds({
        accessToken: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NTU0NTcxNDEsIm5iZiI6MTU1NTQ1NzE0MSwianRpIjoiYjZjNTQyZTMtYmU4MC00NWYwLThkOTktZGU1MDFkYjJkN2Y1IiwiZXhwIjoxNTU1NDU4MDQxLCJpZGVudGl0eSI6NCwiZnJlc2giOmZhbHNlLCJ0eXBlIjoiYWNjZXNzIn0.-vpo_G1EroycUiLcB4m5NSzHCXJ2_3JBfnn5u45wM4c"
      });
    },
    setExpiredRefreshToken() {
      ni.auth.setCreds({
        refreshToken: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NTU0NTcxNDEsIm5iZiI6MTU1NTQ1NzE0MSwianRpIjoiZjIzZmUyYTktNjdjOC00ZTJhLTgyZTAtZjEwNjUxMTYwMTIzIiwiZXhwIjoxNTU2NjY2NzQxLCJpZGVudGl0eSI6NCwidHlwZSI6InJlZnJlc2gifQ.Fe_vPr-z42vCPS_Fqzt4nB6CNNeBDVndeXptdvCtMQw"
      });
    },
    async saveMetrics() {
      const t = await ni.appData.getMetrics(), e = document.createElement("a"), n = new Blob([JSON.stringify(t)], { type: "text/json" });
      e.href = URL.createObjectURL(n), e.download = "metrics.json", e.click();
    },
    async clearMetrics() {
      ni.appData.clearMetrics();
    }
  }
};
var git = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "hacker-interface" }, [n("div", [n("button", { staticClass: "hi-btn", on: { click: e.setExpiredAccessToken } }, [e._v(" Expire Access ")]), n("button", { staticClass: "hi-btn", on: { click: e.setExpiredRefreshToken } }, [e._v(" Expire Refresh ")]), n("button", { staticClass: "hi-btn", on: { click: function(r) {
    return e.$router.push({ name: "swagger" });
  } } }, [e._v(" Открыть Swagger ")]), n("button", { staticClass: "hi-btn", on: { click: e.saveMetrics } }, [e._v("Сохранить метрики")]), n("button", { staticClass: "hi-btn", on: { click: e.clearMetrics } }, [e._v("Очистить метрики")])])]);
}, yit = [], bit = /* @__PURE__ */ B(
  vit,
  git,
  yit,
  !1,
  null,
  "a7049395"
);
const _it = bit.exports, fD = "ps-open-legacy-tabs", pD = 1e4, wit = !!(navigator.standalone || window.matchMedia("(display-mode: standalone)").matches);
class Sit {
  getOpened() {
    return JSON.parse(localStorage.getItem(fD) ?? '{ "tabs": [] }');
  }
  saveOpened(e) {
    localStorage.setItem(fD, JSON.stringify(e));
  }
  startCurrentTabRegistration() {
    this.registerCurrentTabOnce(), setInterval(() => {
      this.registerCurrentTabOnce();
    }, pD);
  }
  registerCurrentTabOnce() {
    const e = this.getOpened(), n = e.tabs.findIndex((r) => r.id === window.contextId);
    n >= 0 ? e.tabs[n].time = Date.now() : e.tabs.push({
      // if we'll replace `push` with `unshift` - will change strategy
      id: window.contextId,
      time: Date.now(),
      isPwa: wit
    }), this.saveOpened(e);
  }
  unregisterCurrentTab() {
    const e = this.getOpened(), n = e.tabs.findIndex((r) => r.id === window.contextId);
    n >= 0 && e.tabs.splice(n, 1), this.saveOpened(e);
  }
  removeObsolete(e) {
    const n = Date.now() - 3 * pD;
    e.tabs = e.tabs.filter((r) => r.time > n);
  }
  shouldOpenNewsInCurrentTab(e) {
    const n = this.getOpened();
    if (this.removeObsolete(n), this.saveOpened(n), !window.contextId)
      return console.error("shouldOpenNewsInCurrentTab: no contextId set!"), !1;
    if (!n.tabs.length || window.contextId === e)
      return !0;
    if (!n.tabs.find((r) => r.id === e)) {
      const r = n.tabs.findIndex((s) => s.isPwa);
      if (r >= 0) {
        if (n.tabs[r].id === window.contextId)
          return !0;
      } else if (n.tabs.length)
        return n.tabs[0].id === window.contextId;
    }
    return !1;
  }
  hasEditorTabs() {
    const e = this.getOpened();
    return this.removeObsolete(e), this.saveOpened(e), e.tabs.length > 0;
  }
  isCurrentTabRegistered() {
    const e = this.getOpened();
    return this.removeObsolete(e), this.saveOpened(e), !!e.tabs.find((n) => n.id === window.contextId);
  }
}
const rv = new Sit(), Iit = "data:image/png;base64,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", Eit = {
  name: "Workspace",
  components: {
    Panels: xQe,
    MainMenu: XQe,
    QuickActions: _et,
    Infoscroll: ynt,
    ShareModal: zrt,
    AuthorsModal: tst,
    HistoryModal: fst,
    RelationsModal: mit,
    HackerInterface: _it,
    MainActionButton: fn
  },
  provide() {
    return {
      getColorScheme: () => s4(this.colorScheme)
    };
  },
  data() {
    return {
      flowsIds: [],
      initialized: !OS,
      hackerInterfaceEnabled: !1,
      observer: null,
      taskPanel: null,
      headerLeftPos: 0
    };
  },
  computed: {
    ...st({
      disabled: (t) => t.uiState.modal,
      shareModalVisible: (t) => t.shareModal.isVisible,
      authorsModalVisible: (t) => t.authorsModal.isVisible,
      historyModalVisible: (t) => t.historyModal.isVisible,
      relationsModalVisible: (t) => t.relationsModal.isVisible,
      hackerInterface: (t) => t.appData["c00lH@cker"],
      panels: (t) => t.panels.data,
      online: (t) => t.uiState.online,
      userProfile: (t) => t.userProfile
    }),
    ...pe("userProfile", ["colorScheme"]),
    ...pe("references", [
      "codeTypeIds",
      "leadsEventsTypes",
      "flowEventTypes"
    ]),
    ...pe(["userId"]),
    ...pe("panels", [
      "getNewsItemPanelsCount"
    ]),
    mainMenuLeftPos() {
      return this.headerLeftPos;
    },
    quickActionsLeftPos() {
      return this.headerLeftPos + 40;
    },
    infoScrollLeftPos() {
      return this.quickActionsLeftPos + 246 + 10;
    }
  },
  watch: {
    async $route(t, e) {
      if (e.path === t.path || !["newsItem", "search", "asoiNote"].includes(t.name)) return;
      await this.focusPanelByRoute(t) || (await this.addPanelFromRoute(t), await this.focusPanelByRoute(t));
    }
  },
  created() {
    this.hackerInterfaceEnabled = Pie;
  },
  async mounted() {
    await this.initialize(), rv.startCurrentTabRegistration(), this.loading = !1;
  },
  beforeDestroy() {
    rv.unregisterCurrentTab(), this.observer && this.taskPanel && this.observer.unobserve(this.taskPanel);
  },
  methods: {
    ...ge(["setInitialLoaded", "getFlows", "deleteFlow"]),
    ...ge("references", ["getRefs"]),
    ...ge("leads", ["pushLead"]),
    ...ge("panels", {
      focusPanelByRoute: "focusPanelByRoute",
      addPanelFromRoute: "addPanelFromRoute",
      setPanels: "setPanels",
      focusPanel: "setPanelFocused",
      panelsSetUpdating: "panelsSetUpdating"
    }),
    ...ge("notifications", ["processGatewayNotification"]),
    closeAllNewsPanels() {
      this.$store.commit(`panels/${c6}`), this.panels.length ? this.$store.dispatch("panels/setPanelFocused", this.panels[0].id) : (this.$router.replace({ path: "/tasks" }).catch(() => null), this.$store.commit(`panels/${L2}`)), this.$store.dispatch("userProfile/updateProfile");
    },
    async initialize() {
      await this.$store.dispatch("panels/init"), await this.$store.dispatch("flows/init"), await this.$store.dispatch("news/init"), await this.$store.dispatch("news/versions/init"), await this.$store.dispatch("news/drafts/init"), await this.$store.dispatch("news/search/init"), await this.$store.dispatch("newsbreaks/init"), await this.$store.dispatch("notifications/init"), await this.$store.dispatch("leads/init"), await this.$store.dispatch("sources/init"), await this.$store.dispatch("canvases/init"), this.$route.meta && this.$route.meta.type === "panel" && (await this.focusPanelByRoute(this.$route) || (await this.addPanelFromRoute(this.$route), this.focusPanelByRoute(this.$route))), this.initialized = !0, this.setInitialLoaded(!0);
    }
  }
};
var xit = function() {
  var e = this, n = e._self._c;
  return n("transition", { attrs: { name: "fade-transition", mode: "out-in", appear: "", duration: { enter: 20, leave: 500 } } }, [e.initialized ? n("div", { key: "workspace", attrs: { id: "workspace" } }, [e.hackerInterfaceEnabled && e.hackerInterface ? n("HackerInterface") : e._e(), n("div", { attrs: { id: "workspace-header" } }, [n("MainMenu", { attrs: { leftPos: e.mainMenuLeftPos }, on: { logout: function(r) {
    return e.$emit("logout");
  } } }), n("QuickActions", { attrs: { leftPos: e.quickActionsLeftPos } }), n("Infoscroll", { attrs: { leftPos: e.infoScrollLeftPos } }), e.getNewsItemPanelsCount ? n("MainActionButton", { directives: [{ name: "tooltip", rawName: "v-tooltip:[tooltipPosition]", value: "Закрыть все новости", expression: "'Закрыть все новости'", arg: e.tooltipPosition }], staticClass: "pb-action-button pb-action-button--close-all-news", attrs: { active: "", iconName: "close", size: "12", "data-test-selector": "panels-close-all-news" }, nativeOn: { click: function(r) {
    return e.closeAllNewsPanels.apply(null, arguments);
  } } }, [e._v(" Закрыть все ")]) : e._e()], 1), n("div", { attrs: { id: "workspace-wrapper" } }, [n("Panels", { attrs: { disabled: e.disabled } })], 1), n("KeepAlive", [e.shareModalVisible ? n("ShareModal") : e._e()], 1), n("KeepAlive", [e.authorsModalVisible ? n("AuthorsModal") : e._e()], 1), n("HistoryModal", { attrs: { state: e.historyModalVisible } }), n("RelationsModal", { attrs: { state: e.relationsModalVisible } }), n("router-view", { attrs: { name: "modal" } }), n("portal-target", { attrs: { name: "newsTextEditorWidgets", multiple: "" } }), n("portal-target", { attrs: { name: "tooltips", transition: "fade", multiple: "" } }), n("portal-target", { attrs: { name: "popups", multiple: "" } })], 1) : n("div", { key: "splash", attrs: { id: "splash", "data-test-selector": "splash-logo" } }, [n("div", [n("img", { attrs: { src: Iit, alt: "Interfax" } })])])]);
}, Cit = [], Tit = /* @__PURE__ */ B(
  Eit,
  xit,
  Cit,
  !1,
  null,
  null
);
const z8 = Tit.exports, Pit = "_container_168ir_1", kit = "_modal_168ir_15", Nit = "_close_168ir_28", $it = "_backdrop_168ir_35", Dit = "_content_168ir_41", Ait = "_footer_168ir_45", Oit = "_dark_168ir_53", Mit = "_big_168ir_57", Rit = {
  container: Pit,
  modal: kit,
  close: Nit,
  backdrop: $it,
  content: Dit,
  footer: Ait,
  dark: Oit,
  big: Mit
}, Lit = {
  name: "big-modal",
  mixins: [Du],
  components: {
    PbButton: nt,
    Toolbar: xo
  },
  props: {
    title: String
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
var Fit = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.container, on: { click: function(r) {
    return r.stopPropagation(), (() => {
    }).apply(null, arguments);
  } } }, [n("transition", { attrs: { name: "fade-transition", appear: "" } }, [n("div", { class: e.$style.big }, [n("div", { class: e.$style.modal }, [n("Toolbar", { attrs: { title: e.title, fontSize: "20px" } }, [e._t("topBar"), e.closeable ? n("PbButton", { class: e.$style.close, attrs: { round: "", "data-test-selector": "close-modal-button" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.close.apply(null, arguments);
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1) : e._e()], 2), n("div", { class: e.$style.content }, [e._t("content")], 2)], 1)])]), e.closeable && e.withBackdrop ? n("div", { class: e.$style.backdrop, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.close();
  } } }) : e._e()], 1);
}, Bit = [];
const hD = {
  $style: Rit
};
function jit(t) {
  for (var e in hD)
    this[e] = hD[e];
}
var Wit = /* @__PURE__ */ B(
  Lit,
  Fit,
  Bit,
  !1,
  jit,
  null
);
const U8 = Wit.exports, Hit = "_btn_blg64_5", Vit = "_btn_active_blg64_10", zit = {
  switch: "_switch_blg64_1",
  btn: Hit,
  btn_active: Vit
}, Uit = {
  name: "manager",
  components: {
    PbButtonSwitcher: rl,
    BigModal: U8
  },
  data() {
    return {
      toggleButtons: [
        {
          type: "flows",
          value: "flowsManager",
          label: "Потоки",
          testSelector: "manager-flows-button"
        },
        {
          type: "sources",
          value: "sourcesManager",
          label: "Источники",
          testSelector: "manager-sources-button"
        }
      ]
    };
  },
  computed: {
    ...pe("panels", ["focusedPanel"]),
    slug: {
      get: function() {
        return this.$route.name.indexOf("flow") !== -1 ? "flowsManager" : this.$route.name.indexOf("source") !== -1 ? "sourcesManager" : this.$route.name;
      },
      set(t) {
        this.$router.push({ name: t }).catch(() => null);
      }
    }
  },
  watch: {
    slug: function(t, e) {
      t !== e ? this.$router.push({ name: t }).catch(() => null) : this.slug = e;
    }
  },
  mounted() {
    this.modalSet(!0);
  },
  beforeDestroy() {
    this.modalSet(!1);
  },
  methods: {
    ...ge("panels", ["setPanelFocused"]),
    ...ge({ modalSet: "setModal" }),
    close() {
      this.modalSet(!1), this.focusedPanel ? this.setPanelFocused(this.focusedPanel.id) : this.setPanelFocused(0);
    }
  }
};
var Git = function() {
  var e = this, n = e._self._c;
  return n("big-modal", { attrs: { "data-test-selector": "manager-modal" }, on: { close: e.close }, scopedSlots: e._u([{ key: "topBar", fn: function() {
    return [n("PbButtonSwitcher", { class: e.$style.switch, attrs: { buttonClass: e.$style.btn, activeClass: e.$style.btn_active, buttons: e.toggleButtons, height: 24 }, model: { value: e.slug, callback: function(r) {
      e.slug = r;
    }, expression: "slug" } })];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [n("router-view", { attrs: { name: "manager" } })];
  }, proxy: !0 }]) });
}, Yit = [];
const mD = {
  $style: zit
};
function Zit(t) {
  for (var e in mD)
    this[e] = mD[e];
}
var Xit = /* @__PURE__ */ B(
  Uit,
  Git,
  Yit,
  !1,
  Zit,
  null
);
const Kit = Xit.exports, G8 = /* @__PURE__ */ new WeakMap(), P1 = /* @__PURE__ */ new WeakMap();
function Ln(t) {
  const e = G8.get(t);
  return console.assert(
    e != null,
    "'this' is expected an Event object, but got",
    t
  ), e;
}
function vD(t) {
  if (t.passiveListener != null) {
    typeof console < "u" && typeof console.error == "function" && console.error(
      "Unable to preventDefault inside passive event listener invocation.",
      t.passiveListener
    );
    return;
  }
  t.event.cancelable && (t.canceled = !0, typeof t.event.preventDefault == "function" && t.event.preventDefault());
}
function du(t, e) {
  G8.set(this, {
    eventTarget: t,
    event: e,
    eventPhase: 2,
    currentTarget: t,
    canceled: !1,
    stopped: !1,
    immediateStopped: !1,
    passiveListener: null,
    timeStamp: e.timeStamp || Date.now()
  }), Object.defineProperty(this, "isTrusted", { value: !1, enumerable: !0 });
  const n = Object.keys(e);
  for (let r = 0; r < n.length; ++r) {
    const s = n[r];
    s in this || Object.defineProperty(this, s, Y8(s));
  }
}
du.prototype = {
  /**
   * The type of this event.
   * @type {string}
   */
  get type() {
    return Ln(this).event.type;
  },
  /**
   * The target of this event.
   * @type {EventTarget}
   */
  get target() {
    return Ln(this).eventTarget;
  },
  /**
   * The target of this event.
   * @type {EventTarget}
   */
  get currentTarget() {
    return Ln(this).currentTarget;
  },
  /**
   * @returns {EventTarget[]} The composed path of this event.
   */
  composedPath() {
    const t = Ln(this).currentTarget;
    return t == null ? [] : [t];
  },
  /**
   * Constant of NONE.
   * @type {number}
   */
  get NONE() {
    return 0;
  },
  /**
   * Constant of CAPTURING_PHASE.
   * @type {number}
   */
  get CAPTURING_PHASE() {
    return 1;
  },
  /**
   * Constant of AT_TARGET.
   * @type {number}
   */
  get AT_TARGET() {
    return 2;
  },
  /**
   * Constant of BUBBLING_PHASE.
   * @type {number}
   */
  get BUBBLING_PHASE() {
    return 3;
  },
  /**
   * The target of this event.
   * @type {number}
   */
  get eventPhase() {
    return Ln(this).eventPhase;
  },
  /**
   * Stop event bubbling.
   * @returns {void}
   */
  stopPropagation() {
    const t = Ln(this);
    t.stopped = !0, typeof t.event.stopPropagation == "function" && t.event.stopPropagation();
  },
  /**
   * Stop event bubbling.
   * @returns {void}
   */
  stopImmediatePropagation() {
    const t = Ln(this);
    t.stopped = !0, t.immediateStopped = !0, typeof t.event.stopImmediatePropagation == "function" && t.event.stopImmediatePropagation();
  },
  /**
   * The flag to be bubbling.
   * @type {boolean}
   */
  get bubbles() {
    return !!Ln(this).event.bubbles;
  },
  /**
   * The flag to be cancelable.
   * @type {boolean}
   */
  get cancelable() {
    return !!Ln(this).event.cancelable;
  },
  /**
   * Cancel this event.
   * @returns {void}
   */
  preventDefault() {
    vD(Ln(this));
  },
  /**
   * The flag to indicate cancellation state.
   * @type {boolean}
   */
  get defaultPrevented() {
    return Ln(this).canceled;
  },
  /**
   * The flag to be composed.
   * @type {boolean}
   */
  get composed() {
    return !!Ln(this).event.composed;
  },
  /**
   * The unix time of this event.
   * @type {number}
   */
  get timeStamp() {
    return Ln(this).timeStamp;
  },
  /**
   * The target of this event.
   * @type {EventTarget}
   * @deprecated
   */
  get srcElement() {
    return Ln(this).eventTarget;
  },
  /**
   * The flag to stop event bubbling.
   * @type {boolean}
   * @deprecated
   */
  get cancelBubble() {
    return Ln(this).stopped;
  },
  set cancelBubble(t) {
    if (!t)
      return;
    const e = Ln(this);
    e.stopped = !0, typeof e.event.cancelBubble == "boolean" && (e.event.cancelBubble = !0);
  },
  /**
   * The flag to indicate cancellation state.
   * @type {boolean}
   * @deprecated
   */
  get returnValue() {
    return !Ln(this).canceled;
  },
  set returnValue(t) {
    t || vD(Ln(this));
  },
  /**
   * Initialize this event object. But do nothing under event dispatching.
   * @param {string} type The event type.
   * @param {boolean} [bubbles=false] The flag to be possible to bubble up.
   * @param {boolean} [cancelable=false] The flag to be possible to cancel.
   * @deprecated
   */
  initEvent() {
  }
};
Object.defineProperty(du.prototype, "constructor", {
  value: du,
  configurable: !0,
  writable: !0
});
typeof window < "u" && typeof window.Event < "u" && (Object.setPrototypeOf(du.prototype, window.Event.prototype), P1.set(window.Event.prototype, du));
function Y8(t) {
  return {
    get() {
      return Ln(this).event[t];
    },
    set(e) {
      Ln(this).event[t] = e;
    },
    configurable: !0,
    enumerable: !0
  };
}
function Jit(t) {
  return {
    value() {
      const e = Ln(this).event;
      return e[t].apply(e, arguments);
    },
    configurable: !0,
    enumerable: !0
  };
}
function qit(t, e) {
  const n = Object.keys(e);
  if (n.length === 0)
    return t;
  function r(s, i) {
    t.call(this, s, i);
  }
  r.prototype = Object.create(t.prototype, {
    constructor: { value: r, configurable: !0, writable: !0 }
  });
  for (let s = 0; s < n.length; ++s) {
    const i = n[s];
    if (!(i in t.prototype)) {
      const a = typeof Object.getOwnPropertyDescriptor(e, i).value == "function";
      Object.defineProperty(
        r.prototype,
        i,
        a ? Jit(i) : Y8(i)
      );
    }
  }
  return r;
}
function Z8(t) {
  if (t == null || t === Object.prototype)
    return du;
  let e = P1.get(t);
  return e == null && (e = qit(Z8(Object.getPrototypeOf(t)), t), P1.set(t, e)), e;
}
function Qit(t, e) {
  const n = Z8(Object.getPrototypeOf(e));
  return new n(t, e);
}
function eot(t) {
  return Ln(t).immediateStopped;
}
function tot(t, e) {
  Ln(t).eventPhase = e;
}
function not(t, e) {
  Ln(t).currentTarget = e;
}
function gD(t, e) {
  Ln(t).passiveListener = e;
}
const X8 = /* @__PURE__ */ new WeakMap(), yD = 1, bD = 2, Eh = 3;
function xh(t) {
  return t !== null && typeof t == "object";
}
function Jd(t) {
  const e = X8.get(t);
  if (e == null)
    throw new TypeError(
      "'this' is expected an EventTarget object, but got another value."
    );
  return e;
}
function rot(t) {
  return {
    get() {
      let n = Jd(this).get(t);
      for (; n != null; ) {
        if (n.listenerType === Eh)
          return n.listener;
        n = n.next;
      }
      return null;
    },
    set(e) {
      typeof e != "function" && !xh(e) && (e = null);
      const n = Jd(this);
      let r = null, s = n.get(t);
      for (; s != null; )
        s.listenerType === Eh ? r !== null ? r.next = s.next : s.next !== null ? n.set(t, s.next) : n.delete(t) : r = s, s = s.next;
      if (e !== null) {
        const i = {
          listener: e,
          listenerType: Eh,
          passive: !1,
          once: !1,
          next: null
        };
        r === null ? n.set(t, i) : r.next = i;
      }
    },
    configurable: !0,
    enumerable: !0
  };
}
function K8(t, e) {
  Object.defineProperty(
    t,
    `on${e}`,
    rot(e)
  );
}
function _D(t) {
  function e() {
    Ko.call(this);
  }
  e.prototype = Object.create(Ko.prototype, {
    constructor: {
      value: e,
      configurable: !0,
      writable: !0
    }
  });
  for (let n = 0; n < t.length; ++n)
    K8(e.prototype, t[n]);
  return e;
}
function Ko() {
  if (this instanceof Ko) {
    X8.set(this, /* @__PURE__ */ new Map());
    return;
  }
  if (arguments.length === 1 && Array.isArray(arguments[0]))
    return _D(arguments[0]);
  if (arguments.length > 0) {
    const t = new Array(arguments.length);
    for (let e = 0; e < arguments.length; ++e)
      t[e] = arguments[e];
    return _D(t);
  }
  throw new TypeError("Cannot call a class as a function");
}
Ko.prototype = {
  /**
   * Add a given listener to this event target.
   * @param {string} eventName The event name to add.
   * @param {Function} listener The listener to add.
   * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
   * @returns {void}
   */
  addEventListener(t, e, n) {
    if (e == null)
      return;
    if (typeof e != "function" && !xh(e))
      throw new TypeError("'listener' should be a function or an object.");
    const r = Jd(this), s = xh(n), o = (s ? !!n.capture : !!n) ? yD : bD, a = {
      listener: e,
      listenerType: o,
      passive: s && !!n.passive,
      once: s && !!n.once,
      next: null
    };
    let l = r.get(t);
    if (l === void 0) {
      r.set(t, a);
      return;
    }
    let c = null;
    for (; l != null; ) {
      if (l.listener === e && l.listenerType === o)
        return;
      c = l, l = l.next;
    }
    c.next = a;
  },
  /**
   * Remove a given listener from this event target.
   * @param {string} eventName The event name to remove.
   * @param {Function} listener The listener to remove.
   * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
   * @returns {void}
   */
  removeEventListener(t, e, n) {
    if (e == null)
      return;
    const r = Jd(this), i = (xh(n) ? !!n.capture : !!n) ? yD : bD;
    let o = null, a = r.get(t);
    for (; a != null; ) {
      if (a.listener === e && a.listenerType === i) {
        o !== null ? o.next = a.next : a.next !== null ? r.set(t, a.next) : r.delete(t);
        return;
      }
      o = a, a = a.next;
    }
  },
  /**
   * Dispatch a given event.
   * @param {Event|{type:string}} event The event to dispatch.
   * @returns {boolean} `false` if canceled.
   */
  dispatchEvent(t) {
    if (t == null || typeof t.type != "string")
      throw new TypeError('"event.type" should be a string.');
    const e = Jd(this), n = t.type;
    let r = e.get(n);
    if (r == null)
      return !0;
    const s = Qit(this, t);
    let i = null;
    for (; r != null; ) {
      if (r.once ? i !== null ? i.next = r.next : r.next !== null ? e.set(n, r.next) : e.delete(n) : i = r, gD(
        s,
        r.passive ? r.listener : null
      ), typeof r.listener == "function")
        try {
          r.listener.call(this, s);
        } catch (o) {
          typeof console < "u" && typeof console.error == "function" && console.error(o);
        }
      else r.listenerType !== Eh && typeof r.listener.handleEvent == "function" && r.listener.handleEvent(s);
      if (eot(s))
        break;
      r = r.next;
    }
    return gD(s, null), tot(s, 0), not(s, null), !s.defaultPrevented;
  }
};
Object.defineProperty(Ko.prototype, "constructor", {
  value: Ko,
  configurable: !0,
  writable: !0
});
typeof window < "u" && typeof window.EventTarget < "u" && Object.setPrototypeOf(Ko.prototype, window.EventTarget.prototype);
class qf extends Ko {
  /**
   * AbortSignal cannot be constructed directly.
   */
  constructor() {
    throw super(), new TypeError("AbortSignal cannot be constructed directly");
  }
  /**
   * Returns `true` if this `AbortSignal`'s `AbortController` has signaled to abort, and `false` otherwise.
   */
  get aborted() {
    const e = sv.get(this);
    if (typeof e != "boolean")
      throw new TypeError(`Expected 'this' to be an 'AbortSignal' object, but got ${this === null ? "null" : typeof this}`);
    return e;
  }
}
K8(qf.prototype, "abort");
function sot() {
  const t = Object.create(qf.prototype);
  return Ko.call(t), sv.set(t, !1), t;
}
function iot(t) {
  sv.get(t) === !1 && (sv.set(t, !0), t.dispatchEvent({ type: "abort" }));
}
const sv = /* @__PURE__ */ new WeakMap();
Object.defineProperties(qf.prototype, {
  aborted: { enumerable: !0 }
});
typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol" && Object.defineProperty(qf.prototype, Symbol.toStringTag, {
  configurable: !0,
  value: "AbortSignal"
});
let FI = class {
  /**
   * Initialize this controller.
   */
  constructor() {
    J8.set(this, sot());
  }
  /**
   * Returns the `AbortSignal` object associated with this object.
   */
  get signal() {
    return wD(this);
  }
  /**
   * Abort and signal to any observers that the associated activity is to be aborted.
   */
  abort() {
    iot(wD(this));
  }
};
const J8 = /* @__PURE__ */ new WeakMap();
function wD(t) {
  const e = J8.get(t);
  if (e == null)
    throw new TypeError(`Expected 'this' to be an 'AbortController' object, but got ${t === null ? "null" : typeof t}`);
  return e;
}
Object.defineProperties(FI.prototype, {
  signal: { enumerable: !0 },
  abort: { enumerable: !0 }
});
typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol" && Object.defineProperty(FI.prototype, Symbol.toStringTag, {
  configurable: !0,
  value: "AbortController"
});
const bd = typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : (
  /* otherwise */
  void 0
);
bd && (typeof bd.AbortController > "u" && (bd.AbortController = FI), typeof bd.AbortSignal > "u" && (bd.AbortSignal = qf));
class ks {
  constructor(e, n) {
    this.abortController = n || new AbortController(), e instanceof Promise ? this.promise = e : this.promise = new Promise((r, s) => e(r, s, this.abortController.signal));
  }
  then(...e) {
    return new ks(this.promise.then(...e), this.abortController);
  }
  catch(...e) {
    return new ks(this.promise.catch(...e), this.abortController);
  }
  finally(...e) {
    return this.promise.finally(...e);
  }
  abort() {
    return this.abortController.abort();
  }
}
ks.resolve = function(t = null, ...e) {
  return new ks(Promise.resolve(...e), t);
};
ks.reject = function(t = null, e) {
  return new ks(Promise.reject(e), t);
};
ks.race = function(t = null, ...e) {
  return new ks(Promise.race(...e), t);
};
ks.all = function(t = null, ...e) {
  return new ks(Promise.all(...e), t);
};
function oot() {
  const t = {
    register(e) {
      return this.interceptors.push(e), () => this.unregister(e);
    },
    unregister(e) {
      const n = this.interceptors.indexOf(e);
      n >= 0 && this.interceptors.splice(n, 1);
    },
    clear() {
      this.interceptors = [];
    },
    interceptRequest(e) {
      let n = ks.resolve(e.abortController, e);
      return this.interceptors.forEach(({ request: r, requestError: s } = {}) => {
        typeof r == "function" && (n = n.then((i) => r(i))), typeof s == "function" && (n = n.catch(s));
      }), n;
    },
    async interceptResponseError(e, n) {
      let r = ks.reject(e, n);
      const s = this.interceptors.slice().reverse();
      for (let { responseError: i } of s)
        typeof i == "function" && (r = r.catch(i));
      return r;
    },
    interceptResponse(e, n) {
      let r = ks.resolve(e, n);
      return this.interceptors.slice().reverse().forEach(({ response: i, responseError: o }) => {
        typeof i == "function" && (r = r.then(i));
      }), r;
    }
  };
  return t.interceptors = [], t;
}
function aot(t) {
  return t.includes("json") ? "json" : t.includes("text") ? "text" : "blob";
}
async function lot(t, e) {
  let n = null, r = null;
  if (t instanceof e) {
    if (t.status === 204 && t.ok)
      return { body: n, error: r };
    const s = t.headers.get("Content-Type");
    if (s)
      switch (aot(s)) {
        case "json":
          try {
            n = await t.json();
          } catch (i) {
            r = i;
          }
          break;
        case "text":
          try {
            n = await t.text();
          } catch (i) {
            r = i;
          }
          break;
        default:
          try {
            n = await t.blob();
          } catch (i) {
            r = i;
          }
          break;
      }
    else
      r = t;
  } else
    r = t;
  return { body: n, error: r };
}
function cot(t) {
  return async (e, n) => {
    let { body: r, error: s } = await lot(e, t), i = !1;
    return e.name === "AbortError" && (i = !0), new Proxy(e, {
      get(o, a) {
        switch (a) {
          case "request":
            return n;
          case "body":
            return r;
          case "cancel":
            return i;
          case "error":
            return s;
          case "raw":
            return e;
          default:
            return o[a];
        }
      },
      set(o, a, l) {
        return a === "body" ? (r = l, !0) : a === "cancel" ? (o.cancel = l, !0) : !1;
      }
    });
  };
}
var q8 = Jo, Yu = Cf(), uot = eO, dot = ii, Hp = q8("%WeakMap%", !0), Vp = q8("%Map%", !0), fot = Yu("WeakMap.prototype.get", !0), pot = Yu("WeakMap.prototype.set", !0), hot = Yu("WeakMap.prototype.has", !0), mot = Yu("Map.prototype.get", !0), vot = Yu("Map.prototype.set", !0), got = Yu("Map.prototype.has", !0), BI = function(t, e) {
  for (var n = t, r; (r = n.next) !== null; n = r)
    if (r.key === e)
      return n.next = r.next, r.next = /** @type {NonNullable<typeof list.next>} */
      t.next, t.next = r, r;
}, yot = function(t, e) {
  var n = BI(t, e);
  return n && n.value;
}, bot = function(t, e, n) {
  var r = BI(t, e);
  r ? r.value = n : t.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: e,
    next: t.next,
    value: n
  };
}, _ot = function(t, e) {
  return !!BI(t, e);
}, wot = function() {
  var e, n, r, s = {
    assert: function(i) {
      if (!s.has(i))
        throw new dot("Side channel does not contain " + uot(i));
    },
    get: function(i) {
      if (Hp && i && (typeof i == "object" || typeof i == "function")) {
        if (e)
          return fot(e, i);
      } else if (Vp) {
        if (n)
          return mot(n, i);
      } else if (r)
        return yot(r, i);
    },
    has: function(i) {
      if (Hp && i && (typeof i == "object" || typeof i == "function")) {
        if (e)
          return hot(e, i);
      } else if (Vp) {
        if (n)
          return got(n, i);
      } else if (r)
        return _ot(r, i);
      return !1;
    },
    set: function(i, o) {
      Hp && i && (typeof i == "object" || typeof i == "function") ? (e || (e = new Hp()), pot(e, i, o)) : Vp ? (n || (n = new Vp()), vot(n, i, o)) : (r || (r = { key: {}, next: null }), bot(r, i, o));
    }
  };
  return s;
}, Sot = String.prototype.replace, Iot = /%20/g, Eb = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, jI = {
  default: Eb.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return Sot.call(t, Iot, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: Eb.RFC1738,
  RFC3986: Eb.RFC3986
}, Eot = jI, xb = Object.prototype.hasOwnProperty, Nl = Array.isArray, eo = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), xot = function(e) {
  for (; e.length > 1; ) {
    var n = e.pop(), r = n.obj[n.prop];
    if (Nl(r)) {
      for (var s = [], i = 0; i < r.length; ++i)
        typeof r[i] < "u" && s.push(r[i]);
      n.obj[n.prop] = s;
    }
  }
}, Q8 = function(e, n) {
  for (var r = n && n.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, s = 0; s < e.length; ++s)
    typeof e[s] < "u" && (r[s] = e[s]);
  return r;
}, Cot = function t(e, n, r) {
  if (!n)
    return e;
  if (typeof n != "object") {
    if (Nl(e))
      e.push(n);
    else if (e && typeof e == "object")
      (r && (r.plainObjects || r.allowPrototypes) || !xb.call(Object.prototype, n)) && (e[n] = !0);
    else
      return [e, n];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(n);
  var s = e;
  return Nl(e) && !Nl(n) && (s = Q8(e, r)), Nl(e) && Nl(n) ? (n.forEach(function(i, o) {
    if (xb.call(e, o)) {
      var a = e[o];
      a && typeof a == "object" && i && typeof i == "object" ? e[o] = t(a, i, r) : e.push(i);
    } else
      e[o] = i;
  }), e) : Object.keys(n).reduce(function(i, o) {
    var a = n[o];
    return xb.call(i, o) ? i[o] = t(i[o], a, r) : i[o] = a, i;
  }, s);
}, Tot = function(e, n) {
  return Object.keys(n).reduce(function(r, s) {
    return r[s] = n[s], r;
  }, e);
}, Pot = function(t, e, n) {
  var r = t.replace(/\+/g, " ");
  if (n === "iso-8859-1")
    return r.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}, Cb = 1024, kot = function(e, n, r, s, i) {
  if (e.length === 0)
    return e;
  var o = e;
  if (typeof e == "symbol" ? o = Symbol.prototype.toString.call(e) : typeof e != "string" && (o = String(e)), r === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(p) {
      return "%26%23" + parseInt(p.slice(2), 16) + "%3B";
    });
  for (var a = "", l = 0; l < o.length; l += Cb) {
    for (var c = o.length >= Cb ? o.slice(l, l + Cb) : o, u = [], d = 0; d < c.length; ++d) {
      var f = c.charCodeAt(d);
      if (f === 45 || f === 46 || f === 95 || f === 126 || f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || i === Eot.RFC1738 && (f === 40 || f === 41)) {
        u[u.length] = c.charAt(d);
        continue;
      }
      if (f < 128) {
        u[u.length] = eo[f];
        continue;
      }
      if (f < 2048) {
        u[u.length] = eo[192 | f >> 6] + eo[128 | f & 63];
        continue;
      }
      if (f < 55296 || f >= 57344) {
        u[u.length] = eo[224 | f >> 12] + eo[128 | f >> 6 & 63] + eo[128 | f & 63];
        continue;
      }
      d += 1, f = 65536 + ((f & 1023) << 10 | c.charCodeAt(d) & 1023), u[u.length] = eo[240 | f >> 18] + eo[128 | f >> 12 & 63] + eo[128 | f >> 6 & 63] + eo[128 | f & 63];
    }
    a += u.join("");
  }
  return a;
}, Not = function(e) {
  for (var n = [{ obj: { o: e }, prop: "o" }], r = [], s = 0; s < n.length; ++s)
    for (var i = n[s], o = i.obj[i.prop], a = Object.keys(o), l = 0; l < a.length; ++l) {
      var c = a[l], u = o[c];
      typeof u == "object" && u !== null && r.indexOf(u) === -1 && (n.push({ obj: o, prop: c }), r.push(u));
    }
  return xot(n), e;
}, $ot = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, Dot = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Aot = function(e, n) {
  return [].concat(e, n);
}, Oot = function(e, n) {
  if (Nl(e)) {
    for (var r = [], s = 0; s < e.length; s += 1)
      r.push(n(e[s]));
    return r;
  }
  return n(e);
}, e7 = {
  arrayToObject: Q8,
  assign: Tot,
  combine: Aot,
  compact: Not,
  decode: Pot,
  encode: kot,
  isBuffer: Dot,
  isRegExp: $ot,
  maybeMap: Oot,
  merge: Cot
}, t7 = wot, Ch = e7, qd = jI, Mot = Object.prototype.hasOwnProperty, n7 = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, n) {
    return e + "[" + n + "]";
  },
  repeat: function(e) {
    return e;
  }
}, io = Array.isArray, Rot = Array.prototype.push, r7 = function(t, e) {
  Rot.apply(t, io(e) ? e : [e]);
}, Lot = Date.prototype.toISOString, SD = qd.default, Dr = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Ch.encode,
  encodeValuesOnly: !1,
  format: SD,
  formatter: qd.formatters[SD],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return Lot.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Fot = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, Tb = {}, Bot = function t(e, n, r, s, i, o, a, l, c, u, d, f, p, h, m, v, y, _) {
  for (var w = e, S = _, E = 0, x = !1; (S = S.get(Tb)) !== void 0 && !x; ) {
    var T = S.get(e);
    if (E += 1, typeof T < "u") {
      if (T === E)
        throw new RangeError("Cyclic object value");
      x = !0;
    }
    typeof S.get(Tb) > "u" && (E = 0);
  }
  if (typeof u == "function" ? w = u(n, w) : w instanceof Date ? w = p(w) : r === "comma" && io(w) && (w = Ch.maybeMap(w, function(se) {
    return se instanceof Date ? p(se) : se;
  })), w === null) {
    if (o)
      return c && !v ? c(n, Dr.encoder, y, "key", h) : n;
    w = "";
  }
  if (Fot(w) || Ch.isBuffer(w)) {
    if (c) {
      var C = v ? n : c(n, Dr.encoder, y, "key", h);
      return [m(C) + "=" + m(c(w, Dr.encoder, y, "value", h))];
    }
    return [m(n) + "=" + m(String(w))];
  }
  var k = [];
  if (typeof w > "u")
    return k;
  var b;
  if (r === "comma" && io(w))
    v && c && (w = Ch.maybeMap(w, c)), b = [{ value: w.length > 0 ? w.join(",") || null : void 0 }];
  else if (io(u))
    b = u;
  else {
    var P = Object.keys(w);
    b = d ? P.sort(d) : P;
  }
  var N = l ? n.replace(/\./g, "%2E") : n, D = s && io(w) && w.length === 1 ? N + "[]" : N;
  if (i && io(w) && w.length === 0)
    return D + "[]";
  for (var H = 0; H < b.length; ++H) {
    var Y = b[H], te = typeof Y == "object" && typeof Y.value < "u" ? Y.value : w[Y];
    if (!(a && te === null)) {
      var A = f && l ? Y.replace(/\./g, "%2E") : Y, j = io(w) ? typeof r == "function" ? r(D, A) : D : D + (f ? "." + A : "[" + A + "]");
      _.set(e, E);
      var L = t7();
      L.set(Tb, _), r7(k, t(
        te,
        j,
        r,
        s,
        i,
        o,
        a,
        l,
        r === "comma" && v && io(w) ? null : c,
        u,
        d,
        f,
        p,
        h,
        m,
        v,
        y,
        L
      ));
    }
  }
  return k;
}, jot = function(e) {
  if (!e)
    return Dr;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var n = e.charset || Dr.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = qd.default;
  if (typeof e.format < "u") {
    if (!Mot.call(qd.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    r = e.format;
  }
  var s = qd.formatters[r], i = Dr.filter;
  (typeof e.filter == "function" || io(e.filter)) && (i = e.filter);
  var o;
  if (e.arrayFormat in n7 ? o = e.arrayFormat : "indices" in e ? o = e.indices ? "indices" : "repeat" : o = Dr.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var a = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : Dr.allowDots : !!e.allowDots;
  return {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : Dr.addQueryPrefix,
    allowDots: a,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : Dr.allowEmptyArrays,
    arrayFormat: o,
    charset: n,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : Dr.charsetSentinel,
    commaRoundTrip: e.commaRoundTrip,
    delimiter: typeof e.delimiter > "u" ? Dr.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : Dr.encode,
    encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : Dr.encodeDotInKeys,
    encoder: typeof e.encoder == "function" ? e.encoder : Dr.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : Dr.encodeValuesOnly,
    filter: i,
    format: r,
    formatter: s,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : Dr.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : Dr.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : Dr.strictNullHandling
  };
}, Wot = function(t, e) {
  var n = t, r = jot(e), s, i;
  typeof r.filter == "function" ? (i = r.filter, n = i("", n)) : io(r.filter) && (i = r.filter, s = i);
  var o = [];
  if (typeof n != "object" || n === null)
    return "";
  var a = n7[r.arrayFormat], l = a === "comma" && r.commaRoundTrip;
  s || (s = Object.keys(n)), r.sort && s.sort(r.sort);
  for (var c = t7(), u = 0; u < s.length; ++u) {
    var d = s[u];
    r.skipNulls && n[d] === null || r7(o, Bot(
      n[d],
      d,
      a,
      l,
      r.allowEmptyArrays,
      r.strictNullHandling,
      r.skipNulls,
      r.encodeDotInKeys,
      r.encode ? r.encoder : null,
      r.filter,
      r.sort,
      r.allowDots,
      r.serializeDate,
      r.format,
      r.formatter,
      r.encodeValuesOnly,
      r.charset,
      c
    ));
  }
  var f = o.join(r.delimiter), p = r.addQueryPrefix === !0 ? "?" : "";
  return r.charsetSentinel && (r.charset === "iso-8859-1" ? p += "utf8=%26%2310003%3B&" : p += "utf8=%E2%9C%93&"), f.length > 0 ? p + f : "";
}, fu = e7, k1 = Object.prototype.hasOwnProperty, Hot = Array.isArray, nr = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: fu.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1
}, Vot = function(t) {
  return t.replace(/&#(\d+);/g, function(e, n) {
    return String.fromCharCode(parseInt(n, 10));
  });
}, s7 = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, zot = "utf8=%26%2310003%3B", Uot = "utf8=%E2%9C%93", Got = function(e, n) {
  var r = { __proto__: null }, s = n.ignoreQueryPrefix ? e.replace(/^\?/, "") : e;
  s = s.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var i = n.parameterLimit === 1 / 0 ? void 0 : n.parameterLimit, o = s.split(n.delimiter, i), a = -1, l, c = n.charset;
  if (n.charsetSentinel)
    for (l = 0; l < o.length; ++l)
      o[l].indexOf("utf8=") === 0 && (o[l] === Uot ? c = "utf-8" : o[l] === zot && (c = "iso-8859-1"), a = l, l = o.length);
  for (l = 0; l < o.length; ++l)
    if (l !== a) {
      var u = o[l], d = u.indexOf("]="), f = d === -1 ? u.indexOf("=") : d + 1, p, h;
      f === -1 ? (p = n.decoder(u, nr.decoder, c, "key"), h = n.strictNullHandling ? null : "") : (p = n.decoder(u.slice(0, f), nr.decoder, c, "key"), h = fu.maybeMap(
        s7(u.slice(f + 1), n),
        function(v) {
          return n.decoder(v, nr.decoder, c, "value");
        }
      )), h && n.interpretNumericEntities && c === "iso-8859-1" && (h = Vot(h)), u.indexOf("[]=") > -1 && (h = Hot(h) ? [h] : h);
      var m = k1.call(r, p);
      m && n.duplicates === "combine" ? r[p] = fu.combine(r[p], h) : (!m || n.duplicates === "last") && (r[p] = h);
    }
  return r;
}, Yot = function(t, e, n, r) {
  for (var s = r ? e : s7(e, n), i = t.length - 1; i >= 0; --i) {
    var o, a = t[i];
    if (a === "[]" && n.parseArrays)
      o = n.allowEmptyArrays && (s === "" || n.strictNullHandling && s === null) ? [] : [].concat(s);
    else {
      o = n.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = a.charAt(0) === "[" && a.charAt(a.length - 1) === "]" ? a.slice(1, -1) : a, c = n.decodeDotInKeys ? l.replace(/%2E/g, ".") : l, u = parseInt(c, 10);
      !n.parseArrays && c === "" ? o = { 0: s } : !isNaN(u) && a !== c && String(u) === c && u >= 0 && n.parseArrays && u <= n.arrayLimit ? (o = [], o[u] = s) : c !== "__proto__" && (o[c] = s);
    }
    s = o;
  }
  return s;
}, Zot = function(e, n, r, s) {
  if (e) {
    var i = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, o = /(\[[^[\]]*])/, a = /(\[[^[\]]*])/g, l = r.depth > 0 && o.exec(i), c = l ? i.slice(0, l.index) : i, u = [];
    if (c) {
      if (!r.plainObjects && k1.call(Object.prototype, c) && !r.allowPrototypes)
        return;
      u.push(c);
    }
    for (var d = 0; r.depth > 0 && (l = a.exec(i)) !== null && d < r.depth; ) {
      if (d += 1, !r.plainObjects && k1.call(Object.prototype, l[1].slice(1, -1)) && !r.allowPrototypes)
        return;
      u.push(l[1]);
    }
    if (l) {
      if (r.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + r.depth + " and strictDepth is true");
      u.push("[" + i.slice(l.index) + "]");
    }
    return Yot(u, n, r, s);
  }
}, Xot = function(e) {
  if (!e)
    return nr;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.decodeDotInKeys < "u" && typeof e.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.decoder !== null && typeof e.decoder < "u" && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = typeof e.charset > "u" ? nr.charset : e.charset, r = typeof e.duplicates > "u" ? nr.duplicates : e.duplicates;
  if (r !== "combine" && r !== "first" && r !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var s = typeof e.allowDots > "u" ? e.decodeDotInKeys === !0 ? !0 : nr.allowDots : !!e.allowDots;
  return {
    allowDots: s,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : nr.allowEmptyArrays,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : nr.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : nr.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : nr.arrayLimit,
    charset: n,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : nr.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : nr.comma,
    decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : nr.decodeDotInKeys,
    decoder: typeof e.decoder == "function" ? e.decoder : nr.decoder,
    delimiter: typeof e.delimiter == "string" || fu.isRegExp(e.delimiter) ? e.delimiter : nr.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : nr.depth,
    duplicates: r,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : nr.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : nr.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : nr.plainObjects,
    strictDepth: typeof e.strictDepth == "boolean" ? !!e.strictDepth : nr.strictDepth,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : nr.strictNullHandling
  };
}, Kot = function(t, e) {
  var n = Xot(e);
  if (t === "" || t === null || typeof t > "u")
    return n.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var r = typeof t == "string" ? Got(t, n) : t, s = n.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = Object.keys(r), o = 0; o < i.length; ++o) {
    var a = i[o], l = Zot(a, r[a], n, typeof t == "string");
    s = fu.merge(s, l, n);
  }
  return n.allowSparse === !0 ? s : fu.compact(s);
}, Jot = Wot, qot = Kot, Qot = jI, eat = {
  formats: Qot,
  parse: qot,
  stringify: Jot
};
const i7 = /* @__PURE__ */ Et(eat);
function tat(t) {
  return new Proxy(t, {
    get(n, r) {
      return r === "raw" ? typeof t.raw == "function" ? t.raw.bind(n) : t : r === Symbol.iterator ? n[Symbol.iterator].bind(n) : typeof n[r] == "function" ? new Proxy(n[r], {
        apply(s, i, o) {
          return s.call(n, ...o);
        }
      }) : n.has(r) ? n.get(r) : n[r];
    },
    set(n, r, s) {
      return n.has(r) ? n.set(r, s) : n.append(r, s), !0;
    },
    deleteProperty(n, r) {
      return n.has(r) && n.delete(r), !0;
    },
    has(n, r) {
      return n.has(r);
    },
    ownKeys(n) {
      return n.keys();
    },
    enumerate(n) {
      return n.keys();
    }
  });
}
function ID(t, e, n, r, s) {
  return new Proxy(t, {
    get(i, o) {
      if (typeof i[o] == "function")
        return new Proxy(i[o], {
          apply(a, l, c) {
            return a.call(i, ...c);
          }
        });
      switch (o) {
        case "raw":
          return t.raw ? t.raw : t;
        case "headers":
          return tat(i[o]);
        case "abortController":
          return n;
        case "params":
          const a = i.url.split("?")[1];
          return a ? i7.parse(a) : null;
        case "body":
          return e;
        case "url":
          return s;
        case "isBinary":
          return r;
        default:
          return i[o];
      }
    },
    set(i, o, a) {
      switch (o) {
        case "headers":
          for (let l of i.headers.keys())
            i.headers.delete(l);
          return a && typeof a == "object" && Object.entries(a).forEach(([l, c]) => {
            i.headers.append(l, c);
          }), !0;
        default:
          i[o] = a;
      }
    }
  });
}
function nat(t, e, n) {
  return (r) => {
    let s = null;
    if (r instanceof t) {
      let i;
      r.abortController && !r.abortController.signal.aborted ? i = r.abortController : i = new e();
      const o = i.signal && typeof i.signal == "object" && Object.getPrototypeOf(i.signal);
      o.constructor.name !== "AbortSignal" && Object.defineProperty(o.constructor, "name", {
        value: "AbortSignal",
        configurable: !0
      });
      const a = r.raw ? r.raw.clone() : r.clone(), l = new t(a, {
        signal: i.signal
      });
      s = ID(l, r.body, i, r.isBinary, r.url);
    } else {
      let { baseUri: i, path: o, mode: a, method: l, globalHeaders: c, headers: u, params: d, body: f, arrayFormat: p, abortController: h } = r;
      const m = `${i}${o}${d ? "?" + i7.stringify(d, { arrayFormat: p }) : ""}`;
      l ? l = l === "del" ? "DELETE" : l.toUpperCase() : l = "GET";
      let v = !1;
      if (l !== "GET" && l !== "HEAD") {
        const S = globalThis.Blob || null, E = globalThis.FormData || null;
        v = [S, E].reduce((x, T) => x || T && f instanceof T, !1), v || (f = JSON.stringify(f));
      }
      const y = h.signal && typeof h.signal == "object" && Object.getPrototypeOf(h.signal);
      y.constructor.name !== "AbortSignal" && Object.defineProperty(y.constructor, "name", {
        value: "AbortSignal",
        configurable: !0
      });
      const _ = new t(m, {
        method: l,
        body: f,
        mode: a,
        signal: h.signal
      });
      s = ID(_, f, h, v, m);
      let w = Object.assign({}, c, u);
      s.headers = w;
    }
    return s;
  };
}
const rat = ["get", "head", "post", "put", "del", "delete", "options", "patch"];
function sat(t = {
  parseErr: null,
  headers: {},
  baseUri: "",
  mode: "cors",
  arrayFormat: "indices",
  auth: {},
  timeout: 0
}, e = null) {
  const n = {
    opts: t
  }, r = e || globalThis.fetch, s = e && e.Request || globalThis.Request, i = e && e.Response || globalThis.Response;
  e && e.Headers || globalThis.Headers;
  const o = nat(s, AbortController), a = cot(i);
  n.interceptor = oot();
  const l = (d = "/", f = {}) => {
    if (f && (typeof f != "object" || Array.isArray(f)))
      throw new TypeError("`options` must be an object");
    if (f = {
      ...n.opts,
      ...f
    }, typeof d != "string")
      throw new TypeError("`path` must be a string");
    const p = new AbortController();
    return o({
      baseUri: f.baseUri,
      path: d,
      mode: f.mode,
      method: f.method,
      globalHeaders: n.opts.headers,
      headers: f.headers,
      params: f.params,
      body: f.body,
      arrayFormat: n.opts.arrayFormat,
      abortController: p
    });
  }, c = (d) => {
    let f = !1;
    const p = d.timeout || n.opts.timeout;
    return new ks(async (m, v) => {
      let y = null;
      const _ = (S) => setTimeout(() => {
        f = !0, S.abortController.abort();
      }, p), w = o(d);
      try {
        d = await n.interceptor.interceptRequest(d);
        let S = null;
        if (r === e) {
          const x = Object.getOwnPropertySymbols(d), T = d[x[1]].parsedURL.href;
          p > 0 && (y = _(d)), S = await r(T, d.raw), clearTimeout(y);
        } else {
          p > 0 && (y = _(d));
          const { cache: x, credentials: T, headers: C, integrity: k, mode: b, redirect: P, referrer: N, method: D, signal: H } = d, Y = { cache: x, credentials: T, headers: C, integrity: k, mode: b, redirect: P, referrer: N, method: D, signal: H };
          d.method.toLowerCase() !== "get" && d.method.toLowerCase() !== "head" && (d.isBinary ? Y.body = await d.blob() : Y.body = await d.text()), S = await r(d.url, Y), clearTimeout(y);
        }
        let E = await a(S, w);
        E = await n.interceptor.interceptResponse(d.abortController, E), m(E);
      } catch (S) {
        S.code === 20 && f && (S = new Error("Timeout exceeded"));
        let E;
        E = await a(S, w);
        try {
          E = await n.interceptor.interceptResponseError(d.abortController, E), m(E);
        } catch (x) {
          v(x);
        }
      }
    }, d.abortController);
  }, u = (d) => (f = "/", p = {}) => {
    const h = l(f, {
      ...p,
      method: d
    });
    return n.req(h);
  };
  return n.req = (d) => c(o(d)), rat.forEach((d) => {
    n[d] = u(d);
  }), n;
}
function iat({
  baseUri: t = "",
  reqInterceptor: e = (s) => s,
  resInterceptor: n = (s) => s,
  modules: r = { default: {} }
}) {
  const s = sat(
    {
      baseUri: t,
      timeout: 4e4,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Version": u4,
        "Cache-Control": "no-store"
      },
      mode: "cors"
    }
  );
  s.refresher = Promise.resolve(null), s.getRefresher = () => s.refresher, s.timeoutRetries = {}, s.interceptor.register({
    async request(o) {
      return e(o, s);
    },
    async response(o) {
      return n(o, s);
    },
    responseError(o) {
      return o.name && o.name === "AbortError" ? (o.cancel = !0, Promise.reject(o)) : !o.response && o.message === "Network Error" ? Promise.reject(o) : o;
    }
  });
  const i = {};
  return i.apiHandler = s, Object.entries(r.default).forEach(([o, a]) => {
    i[o] = {}, Object.prototype.hasOwnProperty.call(a, "default") && (a = a.default);
    for (let l in a)
      if (Object.prototype.hasOwnProperty.call(a, l) && l && (typeof a[l] == "function" && (i[o][l] = a[l].bind(i.apiHandler)), typeof a[l] == "object")) {
        i[o][l] = {};
        for (let c in a[l])
          c && (i[o][l][c] = a[l][c].bind(
            i.apiHandler
          ));
      }
  }), i;
}
const oat = () => Or({
  messageHubInitialized: !1,
  initialLoaded: !1,
  init: rt.INITIAL,
  appData: {
    "c00lH@cker": !1,
    version: u4
  },
  contextId: null
}), aat = {
  isInitialLoaded: (t) => t.initialLoaded,
  getDraftForNewsItem: (t) => (e) => t.news.drafts.items[t.news.drafts.newsMap[e]],
  getDraftVersionForNewsItem: (t, e) => (n) => {
    var r;
    return (r = e.getDraftForNewsItem(n)) == null ? void 0 : r.version;
  },
  /**
   * Получить потоки, добавленные на рабочую область. Возвращает список id потоков
   * @param {VuexState} state Глобальное состояние
   * @returns {ID[]} Список идентификаторов потоков
   */
  flowsAddedOnWorkspace: (t) => {
    if (t.panels)
      return t.panels.data.filter(({ type: e }) => e === "flow").map(({ dataId: e }) => +e);
  },
  /**
   * Получить непрочитанные лиды для панели с потоком.
   * Возвращает список непрочитанных лидов
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(panel: Panel): Lead[]}
   */
  getFlowPanelUnread: (t, e) => (n) => {
    if (n) {
      const r = e.flowForPanel(n);
      if (r) {
        const s = e.getflowLeads(r.id);
        if (s)
          return s.filter((i) => i ? !i.is_read : !1);
      }
    }
    return [];
  },
  /**
   * Получить количество непрочитанных инфовоподов в панели потока.
   * Возвращает число, если инфодовов меньше 100 и "99+", если больше
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(panel: Panel): number | string}
   */
  getFlowPanelUnreadCount: (t, e) => (n) => {
    const r = e.getFlowPanelUnread(n).length;
    return r > 99 ? "99+" : r;
  },
  /**
   * Возвращает панель для новости с переданным id
   * @param {VuexState} state Глобальное состояние
   * @returns {function(newsItemId: ID): boolean}
   */
  getNewsItemPanel: (t) => (e) => t.panels.data.find(
    ({ type: n, dataId: r }) => n === "newsItem" && r === e.toString()
  ),
  getIsNewsItemPanelFocused: (t, e) => (n) => {
    const r = e.getNewsItemPanel(n);
    return r ? t.uiState.focusedEditorsMap[r.id] === !0 : !1;
  },
  // /**
  //  * Возвращает лид по его id
  //  * @param {VuexState} state Глобальное состояние
  //  * @returns {function(id: ID): Object}
  //  */
  // getLeadById: state => id => state.leads.items[id],
  // /**
  //  * Возвращает типы кодов в виде оъекта {имя_типа: иденитификатор_типа}
  //  * @param {VuexState} state Глобальное состояние
  //  * @returns {Object}
  //  */
  // codeTypeIds: state => {
  //   const result = {}
  //   if (state.references.Profile && state.references.Profile.Type) {
  //     Object.keys(state.references.Profile.Type).forEach(typeId => {
  //       const type = state.references.Profile.Type[typeId]
  //       result[type.name] = typeId
  //     })
  //   }
  //   return result
  // },
  /**
   * Возвращает id текущего залогиненого пользователя
   * @param {VuexState} state Глобальное состояние
   * @returns {ID}
   */
  userId: (t) => parseInt(t.auth.userId),
  /**
   * Возвращает флаг, указывающий, открыто ли модальное окно
   * @param {VuexState} state Глобальное состояние
   * @returns {boolean}
   */
  isModal: (t) => t.uiState.modal,
  /**
   * Принимает id лидов и возвращает список id лидов, отсортированный по дате
   * @param {VuexState} state Глобальное состояние
   * @returns {function(ids: ID[]): ID[]}
   */
  getSortedLeadIds: (t) => (e) => e.sort((n, r) => new Date(t.leads.items[r].created_at) - new Date(t.leads.items[n].created_at)),
  /**
   * Принимает id инфоповода и возвращает лид, привязанный к этому инфоповоду
   * @param {VuexState} state Глобальное состояние
   * @returns {function(newsbreakId: ID): Object}
   */
  getNewsbreakLead: (t) => (e) => {
    const n = t.newsbreaks.leadsMap[e];
    return t.leads.items[n] || {};
  },
  /**
   * Возвращает индекс панели, которая сейчас в фокусе
   * @param {VuexState} state Глобальное состояние
   * @returns {number}
   */
  focusedPanelIndex: (t) => t.panels.data.findIndex(
    (e) => e.id === t.panels.uiState.focused
  ),
  /**
   * Принимает id потока и возвразщает список источнико, включённых в этот поток
   * @param {VuexState} state Глобальное состояние
   * @returns {function(flowId: ID): Object[]}
   */
  getFlowSources: (t) => (e) => {
    const n = t.flows.sourceMap[e];
    let r = [];
    return n && n.length && (r = n.map((s) => ({ source: t.sources.items[s] }))), r;
  },
  /**
   * Узнать, активна ли панель с переданным id
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(id: number): boolean}
   */
  // eslint-disable-next-line
  getPanelIsActive: (t) => (e) => !(t.uiState.modal || t.uiState.needAuth),
  /**
   * Указывает, активна ли панель задач
   * @param {VuexState} state Глобальное состояние
   * @returns {boolean}
   */
  isTaskPanelActive: (t) => !(t.uiState.modal || t.uiState.needAuth),
  /**
   * Возвращает набор объектов, отображающих элементы рабочей области,
   * данные для которых могут быть обновлены.
   * Возвращает список реактивных объектов вида `{ initialLoaded: true }`
   * Полученные объекты можно передать в мутацию и там модифицировать
   * @type {Function}
   * @param      {VuexState} state Глобальное состояние
   * @returns {Object[]} Список объектов вида `{ initialLoaded: boolean }`
   */
  workspaceRefrehsable: (t) => {
    const e = [];
    return e.push(
      t.newsbreaks,
      t.news.sets.my,
      t.news.sets.waiting,
      t.news.sets.inProgress
    ), t.panels.data.forEach((n) => {
      switch (n.type) {
        case ve.published:
          e.push(t.news.sets.published);
          break;
        case ve.awaitingPublication:
          e.push(t.news.sets.embargo);
          break;
        case ve.disposed:
          e.push(t.news.sets.disposed);
          break;
        case ve.flow:
          e.push(t.flows.leadsMap[n.dataId]);
          break;
        case ve.lead:
          e.push(t.leads.initialLoadedMap[n.dataId]);
          break;
        case ve.newsbreak:
          e.push(t.newsbreaks.initialLoadedMap[n.dataId]);
          break;
        case ve.newsItem:
          e.push(t.news.initialLoadedMap[n.dataId]), e.push(t.chat.messagesMap[n.dataId]), e.push(t.news.newsItemHistory.newsItems[n.dataId]);
          break;
        case ve.asoiNotesEmbargo:
          e.push(t.asoi.embargo);
          break;
        case ve.asoiNotes:
          e.push(t.asoi.received);
          break;
        case ve.asoiNotesSent:
          e.push(t.asoi.sent);
          break;
      }
    }), e.filter((n) => !!n);
  }
}, ED = "SET_INITIAL_LOADED", o7 = "FLOWS_INIT", $d = "FLOWS_ADD", a7 = "FLOWS_SET", l7 = "FLOWS_SELECT", c7 = "FLOW_DELETE", u7 = "FLOW_LEADS_SET", d7 = "FLOW_LEADS_APPEND", N1 = "FLOW_LEADS_UNSHIFT", f7 = "FLOW_LEADS_REMOVE", p7 = "FLOW_LEADS_SET_PAUSED", $1 = "FLOW_LEADS_SET_INITIAL_LOADED", h7 = "FLOW_LEADS_SET_HASNEW", m7 = "FLOW_LEADS_SET_HASSELECTED", v7 = "FLOW_ADD_SOURCES", g7 = "FLOW_SET_SOURCES", no = "SOURCES_ADD", Pl = "SOURCES_DIR_MAP_UPDATE", y7 = "SOURCES_DIR_MAP_REPLACE", Th = "SOURCES_DIR_REMOVE_CHILDREN", Dd = "SOURCES_DIR_ADD_CHILDREN", lat = "SOURCES_SET", Ad = "SOURCES_SELECT", b7 = "SOURCES_SELECT_MULTIPLE", _7 = "SOURCES_RENAME", Ph = "SOURCES_DELETE", Od = "SOURCES_UPDATE_PARENT", w7 = "SOURCES_SET_PICKED", S7 = "SOURCES_RESET_STATE", I7 = "SOURCES_ADD_LOGS", E7 = "SOURCES_SET_LOGS", x7 = "SOURCES_SET_ERRORS", D1 = "SOURCES_LIST_ADD", C7 = "SOURCES_LIST_REPLACE", A1 = "SOURCES_LIST_REMOVE", O1 = "SOURCES_LIST_MOVE", kh = "SOURCES_LIST_MOVE_TO_INDEX", Nh = "SOURCES_LIST_DIR_OPEN", T7 = "SOURCES_LIST_DIR_CLOSE", P7 = "SOURCES_LIST_DIR_LOADING", k7 = "SOURCES_LIST_DIR_LOADED", N7 = "SOURCES_LIST_EL_REPLACE", $7 = "SOURCES_LIST_STATE_BACKUP", D7 = "SOURCES_LIST_STATE_REVERT", A7 = "SOURCES_LIST_STATE_CLEAR", M1 = "REFERENCES_INIT", R1 = "SET_REFERENCES", Vi = "MODAL_SET", Qd = "MESSAGE_ADD", Qf = "MESSAGE_REMOVE", O7 = "SET_EDITOR_FOCUS", M7 = "REMOVE_PANEL_EDITOR_FOCUS", R7 = "SET_CODE_MANAGER_FOCUS", L7 = "CHAT_INIT", $h = "CHAT_MESSAGES_ADD", F7 = "CHAT_MESSAGES_CLEAR", B7 = "CHAT_MESSAGES_SET_INITIAL_LOADED", j7 = "CHAT_MESSAGES_SET_READ", L1 = "USERS_ADD", W7 = "USERS_SET", F1 = "GROUPS_ADD", H7 = "GROUPS_SET", cat = "USERS_CLEAR", uat = "GROUPS_CLEAR", V7 = "SET_GROUPS_AND_USERS", z7 = "ASOI_NOTES_INIT", B1 = "ASOI_NOTES_LIST_SET", Md = "ASOI_NOTES_LIST_ADD", dat = "ASOI_NOTES_LIST_CLEAR", Rd = "ASOI_NOTES_DELETE", j1 = "ASOI_NOTES_MARK_AS_READ", U7 = "ASOI_NOTES_INCREMENT_REF_COUNTER", G7 = "ASOI_NOTES_DECREMENT_REF_COUNTER", Y7 = "ASOI_NOTES_SET_INITIAL_LOADED", fat = "ASOI_NOTES_SENT_ITEMS_ADD", Z7 = "ASOI_NOTES_SENT_LIST_SET", Dh = "ASOI_NOTES_SENT_LIST_ADD", X7 = "ASOI_NOTES_SENT_INCREMENT_REF_COUNTER", K7 = "ASOI_NOTES_SENT_DECREMENT_REF_COUNTER", J7 = "ASOI_NOTES_SENT_SET_INITIAL_LOADED", q7 = "ASOI_NOTES_SENT_HISTORY_SET", Q7 = "ASOI_NOTES_EMBARGO_LIST_SET", Lc = "ASOI_NOTES_EMBARGO_LIST_ADD", eF = "ASOI_NOTES_EMBARGO_SET_INITIAL_LOADED", tF = "ASOI_NOTES_EMBARGO_INCREMENT_REF_COUNTER", nF = "ASOI_NOTES_EMBARGO_DECREMENT_REF_COUNTER", W1 = "ASOI_NOTES_EMBARGO_MARK_AS_READ", rF = "ASOI_NOTES_SET_FILTERS", sF = "SHARE_MODAL_SHOW", H1 = "SHARE_MODAL_HIDE", iF = "SHARE_MODAL_SET_RECIPIENTS", oF = "SHARE_MODAL_ADD_RECIPIENTS", aF = "SHARE_MODAL_CLEAR_RECIPIENTS", lF = "HISTORY_MODAL_SHOW", V1 = "HISTORY_MODAL_HIDE", pat = "HISTORY_MODAL_SET_DATA", cF = "HISTORY_MODAL_APPEND_DATA", uF = "HISTORY_MODAL_SET_CURSOR", z1 = "HISTORY_MODAL_SET_LOADING", dF = "RELATIONS_MODAL_SHOW", U1 = "RELATIONS_MODAL_HIDE", fF = "RELATIONS_MODAL_SET_DATA", Ah = "RELATIONS_MODAL_SET_LOADING", xD = "TOGGLE_HACKER_INTERFACE", hat = "MESSAGE_HUB_INITIALIZED", CD = "APP_INIT", pF = "SET_NEED_AUTH", hF = "SET_WINDOW_PARAMS", mF = "SET_VISIBILITY", vF = "SET_ONLINE", mat = "SET_SW_UPDATER_VISIBLE", gF = "RELOAD_WORKSPACE_DATA", yF = "SET_IS_INSTALLED", bF = "SET_PANELS_DRAGGING", _F = "SET_SELECTED_ENTRY", wF = "SET_TASK_PANEL_OPEN";
function Pb(t, e, n) {
  e.forEach((r) => U.set(t[n].items, r.id, r)), t[n].list = e.map((r) => r.id);
}
function kb(t, e, n) {
  e.forEach((i) => U.set(t[n].items, i.id, i));
  const r = e.map((i) => i.id);
  let s = un([...t[n].list, ...r]);
  s = s.sort((i, o) => new Date(t[n].items[o].created_at) - new Date(t[n].items[i].created_at)), t[n].list = s;
}
function Nb(t, e, n) {
  for (let r = 0; r < e.length; r++)
    t[n].refs[e[r]] !== void 0 ? t[n].refs[e[r]]++ : U.set(t[n].refs, e[r], 1);
}
function $b(t, e, n) {
  for (let r = 0; r < e.length; r++)
    t[n].refs[e[r]] && t[n].refs[e[r]] > 0 ? t[n].refs[e[r]]-- : U.set(t[n].refs, e[r], 0);
}
function TD(t, e, n) {
  U.set(t[n].items[e], "is_read", !0);
}
function PD(t, e, n) {
  t[n].list.splice(t[n].list.indexOf(e), 1), U.delete(t[n].items, e), U.delete(t[n].refs, e);
}
const kc = "received", zp = "sent", Nc = "embargo", vat = {
  [z7](t, e) {
    t.init = e;
  },
  [B1](t, e) {
    e.forEach((n) => {
      U.set(t.received.items, n.id, n);
    }), t.received.list = e.map((n) => n.id);
  },
  [B1]: (t, e) => Pb(t, e, kc),
  [Md]: (t, e) => kb(t, e, kc),
  [Y7](t, e) {
    t.received.initialLoaded = e;
  },
  [dat](t) {
    t.received.items = {}, t.received.list = [], t.received.refs = {};
  },
  [Rd](t, e) {
    t.received.items[e] && PD(t, e, kc), t.embargo.items[e] && PD(t, e, Nc);
  },
  [j1]: (t, e) => TD(t, e, kc),
  [U7]: (t, e) => Nb(t, e, kc),
  [G7]: (t, e) => $b(t, e, kc),
  [fat](t, e) {
    e.forEach((n) => {
      U.set(t.sent.items, n.id, n);
    });
  },
  [Z7]: (t, e) => Pb(t, e, zp),
  [Dh]: (t, e) => kb(t, e, zp),
  [X7]: (t, e) => Nb(t, e, zp),
  [K7]: (t, e) => $b(t, e, zp),
  [J7](t, e) {
    t.sent.initialLoaded = e;
  },
  [q7](t, e) {
    t.sent.history = e;
  },
  [Q7]: (t, e) => Pb(t, e, Nc),
  [Lc]: (t, e) => kb(t, e, Nc),
  [tF]: (t, e) => Nb(t, e, Nc),
  [nF]: (t, e) => $b(t, e, Nc),
  [eF](t, e) {
    t.embargo.initialLoaded = e;
  },
  [W1]: (t, e) => TD(t, e, Nc),
  [rF](t, { NOTETYPE: e, value: n }) {
    if (!n) {
      t[e].filters = {};
      return;
    }
    t[e].filters = {
      ...t[e].filters,
      ...n
    };
  }
}, gat = {
  "asoi/init"({ commit: t }) {
    t(z7, rt.READY);
  },
  async loadAsoiNotes({ commit: t }, { params: e, replace: n = !1 }) {
    const r = await $e.asoi.fetchMore(e);
    return r.errors || t(n ? B1 : Md, r.data), r;
  },
  async loadAsoiNotesSent({ commit: t }, { params: e, replace: n = !1 }) {
    const r = await $e.asoi.fetchMore({ ...e, is_outgoing: !0 });
    return r.errors || t(n ? Z7 : Dh, r.data), r;
  },
  async loadAsoiNotesEmbargo({ commit: t }, { params: e, replace: n = !1 }) {
    const r = await $e.asoi.fetchMoreEmbargo({ ...e });
    return r.errors || t(n ? Q7 : Lc, r.data), r;
  },
  async loadAsoiNotesSentHistory({ commit: t }, { id: e, recepientId: n, isGroup: r }) {
    const s = await $e.asoi.fetchHistory(e, n, r);
    return s.errors || t(q7, s.data), s;
  },
  async getAsoiNote({ commit: t, getters: e }, { id: n, isOutgoingPanel: r = !1 }) {
    const s = Ie("asoi"), i = s.panels.getPanelNotification(n), o = await $e.asoi.fetchOne(n, i);
    if (i && s.panels.removePanelNotification(n), o.errors)
      o.status === 404 && (r ? s.panels.clearAsoiSentNoteOldSupply() : s.panels.clearAsoiNoteOldSupply());
    else {
      const a = e.isOutgoingByNote(o), l = e.isEmbargoByNote(o);
      a ? t(Dh, [o]) : l ? t(Lc, [o]) : t(Md, [o]);
    }
    return o;
  },
  async setAsoiNoteAsRead({ commit: t, getters: e }, n) {
    const r = await $e.asoi.setAsRead(n.id);
    return r.errors || (e.isEmbargoByNote(n) ? t(W1, n.id) : t(j1, n.id)), r;
  },
  async pickAsoiNote({ commit: t, getters: e }, { note: n, notificationId: r = null }) {
    const s = await $e.asoi.pick(n.id, r), i = Ie("asoi");
    return s.errors ? i.messages.addMessage({
      type: "error",
      text: "Заметка взята в работу или удалена другим пользователем"
    }) : (i.news.createNewsItem({ payload: s, notificationId: r }), e.isEmbargoByNote(n) || t(Rd, n.id)), s;
  },
  async deleteAsoiNote({ commit: t }, e) {
    const n = await $e.asoi.remove(e.id);
    return n.errors ? Ie("asoi").messages.addMessage({
      type: "error",
      text: "Заметка взята в работу или удалена другим пользователем"
    }) : t(Rd, e.id), n;
  },
  selectAsoiNote({ dispatch: t, getters: e }, { entry: n, panelId: r }) {
    if (!n) return;
    const s = Ie("asoi"), i = s.panels.getPanelById(r), o = au(i.type), a = e.getAsoiNoteById(o)(n.id);
    if (a)
      return a.is_read || t("setAsoiNoteAsRead", a), s.panels.selectPanelListEntry({ entryId: a.id, panelId: r });
  },
  processAsoiNoteMessage({ commit: t, getters: e }, n) {
    var l, c, u, d;
    const r = Ie("asoi"), s = (c = r.references.asoiNoteEventTypes) == null ? void 0 : c[(l = n.payload) == null ? void 0 : l.type_id];
    if (!s) return;
    const i = n.payload.note, o = e.isOutgoingByNote(i), a = e.isEmbargoByNote(i);
    if (r.panels.getAsoiPanels.length !== 0)
      switch (s.name) {
        case "CREATED":
          o ? t(Dh, [i]) : a ? t(Lc, [i]) : t(Md, [i]);
          break;
        case "READ":
          (u = n.payload) != null && u.user && ((d = n.payload) != null && d.user.id) && n.payload.user.id === r.auth.getUserId && (a ? (t(Lc, [i]), t(W1, i.id)) : (t(Md, [i]), t(j1, i.id)));
          break;
        case "PICKED":
          a || t(Rd, i.id);
          break;
        case "DELETED":
        case "READ_IN_ASOI":
        case "DELETED_IN_ASOI":
          t(Rd, i.id);
          break;
        case "CODES_CHANGED":
        case "PUBLICATION_TIME_CHANGED":
          a && t(Lc, [i]);
          break;
      }
  },
  asoiNotesSetInitialLoaded({ commit: t }, e) {
    t(Y7, e);
  },
  asoiNotesSentSetInitialLoaded({ commit: t }, e) {
    t(J7, e);
  },
  asoiNotesEmbargoSetInitialLoaded({ commit: t }, e) {
    t(eF, e);
  },
  asoiNotesSetFilters({ commit: t }, { noteType: e, value: n }) {
    t(rF, { NOTETYPE: e, value: n });
  }
}, yat = {
  /**
   * Получить количество непрочитанных в панели заметок.
   * @param state
   * @returns {number}
   */
  getAsoiNotesUnreadCount: (t) => {
    const e = Object.values(t.received.items).filter(
      ({ is_read: n }) => !n
    ).length;
    return e > 99 ? "99+" : e;
  },
  /**
   * Получить заметку по её идентификатору
   * @param state
   * @returns {function(ID): (Object)}
   */
  getAsoiNoteById: (t) => (e) => (n) => t[e].items[n] || {},
  /**
   * Получить отправителя заметки по её идентификатору
   * @param state
   * @returns {function(ID): ({}|null)}
   */
  getAsoiNoteSender: (t) => (e) => (n) => t[e].items[n] && t[e].items[n].sender ? t[e].items[n].sender : null,
  /**
   * Получить получателя заметки по её идентификатору
   * @param state
   * @returns {function(ID): {name: string}[] | string | null}
   */
  getAsoiNoteRecipientName: (t) => (e) => (n) => {
    if (!t[e].items[n])
      return null;
    let r = [];
    return t[e].items[n].is_outgoing ? (r = [
      ...t[e].items[n].recipient_groups.map((s) => ({
        ...s.group,
        isGroup: !0
      }))
    ], r = [
      ...r,
      ...t[e].items[n].recipient_users.map((s) => s.user)
    ], r) : t[e].items[n].recipient_name || null;
  },
  /**
   * Получить авторов заметки по её идентификатору
   * @param state
   * @returns {function(ID): (String[]|null)}
   */
  getAsoiNoteAuthors: (t) => (e) => (n) => t[e].items[n] && t[e].items[n].authors ? t[e].items[n].authors.map((r) => Ps(r.user.name)) : [],
  isOutgoingByNote: () => (t) => t == null ? void 0 : t.is_outgoing,
  isEmbargoByNote: () => (t) => (t == null ? void 0 : t.publish_at) || (t == null ? void 0 : t.is_postponed),
  getFiltersByNotetype: (t) => (e) => t[e].filters || {}
};
function Db() {
  return {
    items: {},
    list: [],
    refs: {},
    initialLoaded: !1,
    filters: null
  };
}
const bat = Dn(["asoi"], {
  state: {
    received: Db(),
    sent: { ...Db(), history: [] },
    embargo: { ...Db(), history: [] }
  },
  mutations: vat,
  actions: gat,
  getters: yat,
  dependencies: {
    auth: {
      getters: ["getUserId"]
    },
    news: {
      actions: ["createNewsItem"]
    },
    references: {
      getters: ["asoiNoteEventTypes"]
    },
    panels: {
      getters: ["getPanelById", "getAsoiPanels", "getPanelNotification"],
      actions: [
        "selectPanelListEntry",
        "clearAsoiSentNoteOldSupply",
        "clearAsoiNoteOldSupply",
        "removePanelNotification"
      ]
    },
    messages: {
      actions: ["addMessage"]
    }
  }
});
function SF() {
  return {
    init: rt.INITIAL,
    isLoggedIn: !1,
    isAuthorized: !1,
    keepLoggedIn: !1,
    login: null,
    permissions: [],
    userId: null,
    accessToken: null,
    refreshToken: null
  };
}
const _at = {
  /**
   * DEPRECATED
   * Возвращает id текущего залогиненого пользователя
   * @param {VuexState} state Глобальное состояние
   * @returns {ID}
   */
  userId: (t) => parseInt(t.userId),
  /**
   * Возвращает id текущего залогиненого пользователя
   * @param {VuexState} state Глобальное состояние
   * @returns {ID}
   */
  getUserId: (t) => parseInt(t.userId),
  /**
   * Получить флаг, сообщающий авторизован ли пользователь
   * @param state
   * @returns {boolean}
   */
  isAuthorized: (t) => t.isAuthorized,
  isLoggedIn: (t) => t.isLoggedIn,
  /**
   * Получить полное имя пользователя
   * @returns {string}
   */
  getUserLogin: (t) => t.login,
  userLogin: (t) => t.username,
  getUserPermissions: (t) => t.permissions,
  getUserHasSuperUserPermissions: (t, e) => (n) => e.getUserPermissions.includes("1.1") ? n.every((r) => !["2.6", "2.9", "2.11"].includes(r)) : !1,
  getIsUserHasAllPermissions: (t, e) => (n) => !!e.getUserPermissions && n.reduce((r, s) => e.getUserHasSuperUserPermissions(n) ? !0 : r === !1 ? !1 : !!e.getUserPermissions.includes("" + s), !0),
  getIsUserHasAnyPermission: (t, e) => (n) => !!e.getUserPermissions && n.reduce((r, s) => !!(e.getUserHasSuperUserPermissions(n) || r === !0 || e.getUserPermissions.includes("" + s)), !1)
}, IF = "AUTH_INIT", EF = "SET_USER_ID", xF = "SET_USER_LOGIN", WI = "SET_IS_LOGGED_IN", Oh = "SET_IS_AUTHORIZED", wat = "SET_KEEP_LOGGED_IN", Mh = "SET_TOKENS", Sat = "LOGIN", HI = "LOGOUT", CF = "CLEAR_USER_DATA", TF = "SET_PERMISSIONS", PF = "UNMOUNT", Iat = {
  async start({ commit: t }, { accessToken: e, refreshToken: n, userId: r, login: s, permissions: i }) {
    return t(Mh, { accessToken: e, refreshToken: n }), t(EF, r), t(xF, s), t(Oh, !0), t(TF, i), t(WI, !0), t(IF, rt.READY), rt.READY;
  },
  async refresh({ state: t, commit: e, dispatch: n }) {
    let r;
    const s = Ie("auth");
    try {
      r = await $e.auth.refresh(t.refreshToken), e(Mh, {
        accessToken: r.body.data.access_token,
        refreshToken: r.body.data.refresh_token
      });
    } catch (i) {
      s.uiState.getIsNeedAuth || await s.uiState.setNeedAuth(!0), s.root.isInitialLoaded ? e(Oh, !1) : n("logout"), n("reset"), r = i;
    }
    return r;
  },
  updateTokens({ commit: t }, { accessToken: e, refreshToken: n }) {
    t(Mh, { accessToken: e, refreshToken: n });
  },
  async logout({ dispatch: t, commit: e }) {
    const n = Ie("auth");
    await t("reset"), e(HI), n.userProfile.clearProfile();
  },
  setAuthorizationStatus({ commit: t }, e) {
    t(Oh, e);
  },
  clearUserData({ commit: t }) {
    t(CF);
  }
}, Eat = {
  [IF](t, e) {
    t.init = e;
  },
  [EF](t, e) {
    t.userId = e;
  },
  [wat](t, e) {
    t.keepLoggedIn = e;
  },
  [Mh](t, { accessToken: e, refreshToken: n }) {
    t.accessToken = e, t.refreshToken = n;
  },
  [Oh](t, e) {
    t.isAuthorized = e;
  },
  [WI](t, e) {
    t.isLoggedIn = e;
  },
  [TF](t, e) {
    t.permissions = e;
  },
  [xF](t, e) {
    t.login = e;
  },
  [CF](t) {
    const e = SF();
    Object.keys(t).forEach((n) => {
      t[n] = e[n];
    });
  },
  [HI](t) {
    t.isLoggedIn = !1, t.isAuthorized = !1;
  },
  [Sat]() {
  },
  [PF]() {
  }
}, xat = Dn(["auth"], {
  namespaced: !0,
  state: SF(),
  getters: _at,
  actions: Iat,
  mutations: Eat,
  dependencies: {
    root: {
      getters: ["isInitialLoaded"]
    },
    uiState: {
      getters: ["getIsNeedAuth"],
      actions: ["setNeedAuth", "reloadWorkspaceData"]
    },
    userProfile: {
      actions: ["clearProfile"]
    }
  }
}), kF = "AUTHORS_MODAL_SHOW", NF = "AUTHORS_MODAL_HIDE", $F = "AUTHORS_MODAL_USERS_SET", DF = "AUTHORS_MODAL_USERS_ADD", AF = "AUTHORS_MODAL_INIT", Cat = {
  [AF](t, e) {
    t.init = e;
  },
  [kF](t, e) {
    t.isVisible = !0, t.itemId = e;
  },
  [NF](t) {
    t.isVisible = !1, t.itemId = null, t.usersList = [];
  },
  [$F](t, e) {
    U.set(
      t,
      "usersList",
      e.map((n) => n.id)
    );
  },
  [DF](t, e) {
    const n = e.map((r) => r.id);
    t.usersList = un(t.usersList.concat(n).reverse()).reverse();
  }
}, Tat = {
  "authorsModal/init"({ commit: t }) {
    t(AF, rt.READY);
  },
  showAuthorsModal({ commit: t }, e) {
    Ie("authorsModal").uiState.setModal(!0), t(kF, e);
  },
  hideAuthorsModal({ commit: t }) {
    Ie("authorsModal").uiState.setModal(!0), t(NF);
  },
  authorsModalUsersSet({ commit: t }, e) {
    t($F, e);
  },
  authorsModalUsersAdd({ commit: t }, e) {
    t(DF, e);
  }
}, Pat = Dn(["authorsModal"], {
  namespaced: !0,
  state: {
    isVisible: !1,
    itemId: null,
    usersList: []
  },
  mutations: Cat,
  actions: Tat,
  dependencies: {
    auth: null,
    uiState: {
      actions: ["setModal"]
    }
  }
}), kat = {
  getCanvasById: (t) => (e) => t.items[e],
  getCurrentCanvas: (t, e) => e.getCanvasById(t.set[t.set.length - 1]),
  getCanvasCodes: (t) => (e) => {
    const n = t.items[e];
    return n ? n.codes.map(({ code: r }) => r) : [];
  },
  getCanvasPredictedCodes: (t) => (e) => t.predictCodesMap[e]
}, OF = "CANVASES_ADD", MF = "CANVAS_CODES_ADD", G1 = "CANVAS_CODES_DELETE", Y1 = "CANVAS_CODES_PREDICT_SET", RF = "CANVAS_CODES_PREDICT_ADD_ADDED", LF = "CANVAS_CODES_PREDICT_ADD_DELETED", FF = "CANVAS_CODES_PREDICT_REMOVE_ADDED", BF = "CANVAS_CODES_PREDICT_REMOVE_DELETED", Nat = {
  async fetchCanvas({ commit: t }) {
    const e = await $e.canvases.fetchCanvas();
    return e.errors || await t(OF, [e]), e;
  },
  updateCanvasBody({ state: t }, { canvasId: e, body: n }) {
    U.set(t.items, e, { ...t.items[e], body: n });
  },
  async addCodes({ state: t, commit: e }, { canvasId: n, codeIds: r }) {
    const s = Ie("canvases"), i = t.items[n];
    if (!i) return;
    const o = i.codes.map(({ code: c }) => c.id), a = r.filter((c) => !o.includes(c));
    if (a.length === 0)
      return null;
    const l = await $e.canvases.addCodes(a);
    return l.errors ? l.errors.length && l.errors.forEach((c) => {
      var u;
      if (c.code === "UNPROCESSABLE_ENTITY" && c.source && /data\/attributes\/(\d+)\/code\/id/.test(c.source.pointer)) {
        const d = /data\/attributes\/(\d+)\/code\/id/.exec(
          c.source.pointer
        ), f = d && +d[1], p = a[f], h = (u = s.codes.allCodes[p]) == null ? void 0 : u.name;
        if (h) {
          const m = {
            text: `Не удалось добавить код:<br>Код "${h}" отсутствует в профиле пользователя`,
            render: "html",
            type: "error",
            timeout: 8e3
          };
          s.messages.addMessage(m);
        }
      }
    }) : e(MF, { canvasId: n, codes: [...i.codes, ...l] }), l;
  },
  async deleteCodes({ state: t, commit: e }, { canvasId: n, codeIds: r }) {
    const s = t.items[n];
    if (!s) return;
    const i = s.codes.map(({ code: l }) => l.id), o = r.filter((l) => i.includes(l));
    if (o.length === 0)
      return;
    e(G1, { canvasId: n, codeIds: o });
    const a = await $e.canvases.deleteCodes(o);
    return a.errors || e(G1, { canvasId: n, codeIds: o }), a;
  },
  async saveCanvas({ state: t }, { canvasId: e }) {
    const n = t.items[e];
    return n ? await $e.canvases.updateCanvas(e, n.body) : void 0;
  },
  async predictCodes({ state: t, commit: e }, { canvasId: n, limit: r = 8 }) {
    var l;
    const s = t.items[n];
    if (!s) return;
    const i = ((l = t.predictCodesMap[n]) == null ? void 0 : l.deleted) ?? [], o = {
      limit: r,
      exclude_code_ids: i,
      news: {
        body: s.body || ""
      }
    }, a = await $e.codes.predictCodes(o);
    return a && a.data && e(Y1, { canvasId: n, codes: a.data }), a;
  },
  setPredictedCodes({ commit: t }, { canvasId: e, codes: n }) {
    t(Y1, { canvasId: e, codes: n });
  },
  addPredictedAdded({ commit: t }, { canvasId: e, codeIds: n }) {
    t(RF, { canvasId: e, codeIds: n });
  },
  addPredictedDeleted({ commit: t }, { canvasId: e, codeId: n }) {
    t(LF, { canvasId: e, codeId: n });
  },
  removePredictedAdded({ commit: t }, { canvasId: e, codeId: n }) {
    t(FF, { canvasId: e, codeId: n });
  },
  removePredictedDeleted({ commit: t }, { canvasId: e, codeId: n }) {
    t(BF, { canvasId: e, codeId: n });
  },
  async annotate({ state: t, dispatch: e }, { canvasId: n, keepCodeIds: r = [] }) {
  },
  async publishFlashFromCanvasFragment(t, e) {
    const n = Ie("canvases"), r = await $e.canvases.publish(e);
    if (r.errors)
      r.errors.length && r.errors.forEach((s) => {
        const i = {
          type: "error",
          text: `Не удалось опубликовать новость: ${s.detail}`
        };
        n.messages.addMessage(i);
      });
    else return n.messages.addMessage({ type: "success", text: "Новость опубликована" }), r;
  }
}, $at = {
  [OF](t, e) {
    e.forEach((n) => {
      U.set(t.items, n.id, n), t.set.includes(n.id) || t.set.push(n.id);
    });
  },
  [MF](t, { canvasId: e, codes: n }) {
    t.items[e] && U.set(t.items, e, { ...t.items[e], codes: n });
  },
  [G1](t, { canvasId: e, codeIds: n }) {
    if (!t.items[e]) return;
    const s = t.items[e].codes.filter(({ code: i }) => !n.includes(i.id));
    U.set(t.items, e, { ...t.items[e], codes: s });
  },
  [Y1](t, { canvasId: e, codes: n }) {
    const r = n.sort((i, o) => o.proba - i.proba);
    t.items[e] && (t.predictCodesMap[e] ? U.set(t.predictCodesMap[e], "codes", r) : U.set(t.predictCodesMap, e, {
      codes: r,
      added: [],
      deleted: []
    }));
  },
  [RF](t, { canvasId: e, codeIds: n }) {
    var i;
    const r = t.items[e], s = (i = t.predictCodesMap[e]) == null ? void 0 : i.added;
    !r || !s || n.forEach((o) => {
      t.predictCodesMap[e].added.find((a) => a === o) || t.predictCodesMap[e].added.push(o);
    });
  },
  [LF](t, { canvasId: e, codeId: n }) {
    var i;
    const r = t.items[e], s = (i = t.predictCodesMap[e]) == null ? void 0 : i.deleted;
    !r || !s || t.predictCodesMap[e].deleted.find((o) => o === n) || t.predictCodesMap[e].deleted.push(n);
  },
  [FF](t, { canvasId: e, codeId: n }) {
    var i;
    const r = t.items[e], s = (i = t.predictCodesMap[e]) == null ? void 0 : i.added;
    !r || !s || (t.predictCodesMap[e].added = t.predictCodesMap[e].added.filter((o) => o !== n));
  },
  [BF](t, { canvasId: e, codeId: n }) {
    var i;
    const r = t.items[e], s = (i = t.predictCodesMap[e]) == null ? void 0 : i.deleted;
    !r || !s || (t.predictCodesMap[e].deleted = t.predictCodesMap[e].deleted.filter((o) => o !== n));
  }
}, Dat = Dn(["canvases"], {
  namespaced: !0,
  state: {
    set: [],
    items: {},
    predictCodesMap: {}
  },
  getters: kat,
  actions: Nat,
  mutations: $at,
  dependencies: {
    messages: {
      actions: ["addMessage"]
    },
    codes: {
      getters: ["allCodes"]
    }
  }
});
function Aat() {
  return {
    list: [],
    initialLoaded: !1
  };
}
const Oat = {
  [L7](t, e) {
    t.init = e;
  },
  [$h](t, { newsItemId: e, messages: n }) {
    t.messagesMap[e] || U.set(t.messagesMap, e, Aat()), U.set(
      t.messagesMap[e],
      "list",
      Gf(t.messagesMap[e].list.concat(n), "id")
    );
  },
  [B7](t, { newsItemId: e, loaded: n }) {
    t.messagesMap[e] && (t.messagesMap[e].initialLoaded = n);
  },
  [j7](t, { newsItemId: e, messages: n }) {
    const r = Object.groupBy(n ?? [], (s) => s.id);
    t.messagesMap[e] && U.set(
      t.messagesMap[e],
      "list",
      t.messagesMap[e].list.map((s) => {
        var i;
        return ((i = r[s.id]) == null ? void 0 : i[0]) ?? s;
      })
    );
  },
  [F7](t, e) {
    U.delete(t.messagesMap, e);
  }
}, Mat = {
  "chat/init"({ commit: t }) {
    t(L7, rt.READY);
  },
  async getChatMessages({ commit: t }, { newsItemId: e, params: n }) {
    const r = await $e.chat.fetchComments(e, n);
    return r.errors || t($h, { newsItemId: e, messages: r.data }), r;
  },
  async sendChatMessage({ state: t, commit: e }, { newsItemId: n, message: r }) {
    const s = await $e.chat.sendComment(n, r);
    return s && !s.errors && (e($h, { newsItemId: n, messages: [s.data] }), t.messagesMap[n].list.length === 1 && Ie("chat").news.setNewsItemFirstComment({
      newsItemId: n,
      comment: r
    })), s;
  },
  addChatMessage({ state: t, commit: e, dispatch: n }, { newsItemId: r, message: s }) {
    e($h, { newsItemId: r, messages: [s] });
    const i = Ie("chat"), o = i.panels.getPanelByDataId("newsItem", r), a = i.panels.getIsPanelRightSupplyVisible(
      o == null ? void 0 : o.id
    ), l = i.panels.getRightPanelActiveTabIndex(o == null ? void 0 : o.id) === 1;
    o && a && l && n("markCommentAsRead", { newsItemId: r, lastCommentId: s.id });
  },
  updateChatReadMessage({ commit: t }, { newsItemId: e, messages: n }) {
    t(j7, { newsItemId: e, messages: n });
  },
  clearChatMessages({ commit: t }, e) {
    t(F7, e);
  },
  async markCommentAsRead({ dispatch: t }, { newsItemId: e, lastCommentId: n }) {
    if (n) {
      const { data: r } = await $e.chat.markCommentAsRead(e, n);
      t("updateChatReadMessage", { newsItemId: e, messages: r });
    }
  },
  chatSetInitialLoaded({ commit: t }, { newsItemId: e, loaded: n }) {
    t(B7, { newsItemId: e, loaded: n });
  }
}, Rat = Dn(["chat"], {
  state: {
    messagesMap: {}
  },
  actions: Mat,
  mutations: Oat,
  getters: {
    unreadMessages: (t) => (e, n) => {
      var r, s;
      return (s = (r = t.messagesMap[e]) == null ? void 0 : r.list) == null ? void 0 : s.filter((i) => {
        const o = i.user.id !== n, a = i.recipients.some(({ user: l }) => l.id === n);
        return o && !a;
      });
    }
  },
  dependencies: {
    panels: {
      getters: ["getIsPanelRightSupplyVisible", "getRightPanelActiveTabIndex", "getPanelByDataId"]
    },
    news: {
      actions: ["setNewsItemFirstComment"]
    }
  }
}), Ab = (t) => ({
  list: t.list || [],
  paused: t.paused || !1,
  hasNew: t.hasNew || !1,
  hasSelected: t.hasSelected || !1,
  initialLoaded: t.initialLoaded || !1
}), Lat = {
  [o7](t, e) {
    t.init = e;
  },
  [$d](t, e) {
    t.list = un(t.list.concat(e.map((n) => n.id))), e.forEach((n) => {
      U.set(t.items, n.id, n);
    });
  },
  [a7](t, e) {
    t.list = e.map((n) => n.id), e.forEach((n) => {
      U.set(t.items, n.id, n);
    });
  },
  [l7](t, e) {
    t.selected = e || { id: null };
  },
  [u7](t, e) {
    const n = t.leadsMap[e.flowId];
    if (!n) {
      U.set(
        t.leadsMap,
        e.flowId,
        Ab({ list: un(e.leadIds) })
      );
      return;
    }
    n.list = e.leadIds;
  },
  [d7](t, e) {
    const n = t.leadsMap[e.flowId];
    if (!n) {
      U.set(
        t.leadsMap,
        e.flowId,
        Ab({ list: un(e.leadIds) })
      );
      return;
    }
    n.list = un(n.list.concat(e.leadIds));
  },
  [N1](t, e) {
    const n = t.leadsMap[e.flowId];
    if (n) {
      let r = [...n.list];
      r.unshift(...e.leadIds), r = un(r), r.length > t.maxLeadsListLength && r.splice(t.maxLeadsListLength), U.set(n, "list", r);
    } else
      U.set(
        t.leadsMap,
        e.flowId,
        Ab({ list: un(e.leadIds) })
      );
  },
  [p7](t, e) {
    const n = t.leadsMap[e.flowId];
    n && (n.paused = e.paused);
  },
  [h7](t, { flowId: e, hasNew: n }) {
    const r = t.leadsMap[e];
    r && (r.hasNew = n);
  },
  [m7](t, e) {
    const n = t.leadsMap[e.flowId];
    n && (n.hasSelected = e.hasSelected);
  },
  [$1](t, { flowId: e, initialLoaded: n }) {
    const r = t.leadsMap[e];
    r && (r.initialLoaded = n);
  },
  [f7](t, e) {
    U.delete(t.leadsMap, e);
  },
  [c7](t, e) {
    t.list = t.list.filter((n) => n !== e), U.delete(t.items, e);
  },
  [v7](t, { flowId: e, sources: n }) {
    t.sourceMap[e] || U.set(t.sourceMap, e, []);
    const r = t.sourceMap[e].concat(n);
    U.set(t.sourceMap, e, un(r.reverse()).reverse());
  },
  [g7](t, { flowId: e, sources: n }) {
    U.set(t.sourceMap, e, n);
  }
};
var Fat = Ev, Bat = xv, jat = $S, Wat = Qa, Hat = Tu, Vat = Cv, zat = 200;
function Uat(t, e, n, r) {
  var s = -1, i = Bat, o = !0, a = t.length, l = [], c = e.length;
  if (!a)
    return l;
  n && (e = Wat(e, Hat(n))), r ? (i = jat, o = !1) : e.length >= zat && (i = Vat, o = !1, e = new Fat(e));
  e:
    for (; ++s < a; ) {
      var u = t[s], d = n == null ? u : n(u);
      if (u = r || u !== 0 ? u : 0, o && d === d) {
        for (var f = c; f--; )
          if (e[f] === d)
            continue e;
        l.push(u);
      } else i(e, d, r) || l.push(u);
    }
  return l;
}
var Gat = Uat, Yat = Gat, Zat = JR, kD = Tv;
function Xat(t, e, n) {
  var r = t.length;
  if (r < 2)
    return r ? kD(t[0]) : [];
  for (var s = -1, i = Array(r); ++s < r; )
    for (var o = t[s], a = -1; ++a < r; )
      a != s && (i[s] = Yat(i[s] || o, t[a], e, n));
  return kD(Zat(i, 1), e, n);
}
var Kat = Xat, Jat = zS, qat = MI, Qat = Kat, elt = N8, tlt = qat(function(t) {
  return Qat(Jat(t, elt));
}), nlt = tlt;
const Rh = /* @__PURE__ */ Et(nlt), Ob = /* @__PURE__ */ new Map();
async function Z1({ name: t, request: e }) {
  if (!t || !e)
    return e;
  const n = Ob.get(t);
  n && await n, Ob.set(t, e);
  const r = await e;
  return Ob.delete(t), r;
}
const rlt = {
  async "flows/init"({ dispatch: t, commit: e }) {
    e(o7, rt.READY);
    const r = Ie("flows").panels.getFlowPanels;
    r != null && r.length && await t("getFlows", {
      ids: r.map(({ dataId: s }) => s).join(","),
      offset: 0,
      limit: 100
    });
  },
  async getFlows({ commit: t }, e = {}) {
    const n = await Z1({
      name: "flows/fetchMore",
      request: $e.flows.fetchMore(e)
    });
    if (!n.errors && !n.cancelled) {
      e.offset ? t($d, n) : t(a7, n);
      const r = Ie("flows");
      n.forEach((s) => {
        const i = r.panels.getPanelForFlow(s.id);
        i && (r.panels.setPanelColor({
          panelId: i.id,
          color: s.color
        }), r.panels.setPanelName({
          panelId: i.id,
          name: s.name
        }));
      });
    }
    return n;
  },
  async getFlowsPublic({ dispatch: t }, e = {}) {
    return t("getFlows", { is_public: !0, ...e });
  },
  async getFlowsMy({ dispatch: t }, e) {
    return t("getFlows", { is_my: !0, ...e });
  },
  async getFlowsMyPrivate({ dispatch: t }, e) {
    return t("getFlows", { is_my: !0, is_public: !1, ...e });
  },
  async getFlow({ commit: t }, e) {
    const n = await $e.flows.fetchOne(e);
    if (!n.errors) {
      t($d, [n]);
      const r = Ie("flows"), s = r.panels.getPanelForFlow(n.id);
      s && (r.panels.setPanelColor({
        panelId: s.id,
        color: n.color
      }), r.panels.setPanelName({ panelId: s.id, name: n.name }));
    }
    return n;
  },
  selectFlow({ commit: t }, e) {
    t(l7, e);
  },
  async saveFlow({ dispatch: t }, { flow: e, storedSources: n }) {
    let r;
    e.color && (r = e.color[0] === "#" ? e.color.slice(1, e.color.length) : e.color);
    const s = {
      name: e.name && e.name.replace(/\s+/g, " ").trim(),
      color: r,
      is_public: e.is_public,
      sources: e.id ? e.sources : e.sources.map((o) => ({ source: { id: o.source.id } }))
    };
    let i;
    return e.id ? i = await t("updateFlow", {
      flowId: e.id,
      data: s,
      storedSources: n
    }) : i = t("createFlow", s), i;
  },
  async createFlow({ commit: t }, e) {
    e.name && (e.name = e.name.replace(/\s+/g, " "));
    const n = await $e.flows.create(e);
    return n.is_my = !0, n.errors || t($d, [n]), n;
  },
  async updateFlow({ commit: t }, { flowId: e, data: n, storedSources: r }) {
    const s = r.map(({ source: u }) => u.id), i = n.sources.map(({ source: u }) => u.id), o = Rh(s, i);
    n.sources = o.map((u) => {
      let d = { source: {} };
      const f = n.sources.find(({ source: h }) => h.id === u), p = r.find(({ source: h }) => h.id === u);
      return p && (d = p.source), f && (d = f.source), i.indexOf(u) === -1 ? {
        id: u,
        _action: "DELETE",
        _index: d._index
      } : s.indexOf(u) === -1 ? {
        id: u,
        _action: "CREATE",
        _index: d._index
      } : null;
    });
    const a = await $e.flows.update(e, n);
    if (a.errors) return a;
    t($d, [a]);
    const l = Ie("flows"), c = l.panels.getPanelForFlow(e);
    return c && (l.panels.setPanelColor({ panelId: c.id, color: n.color }), l.panels.setPanelName({ panelId: c.id, name: n.name }), t($1, { flowId: e, initialLoaded: !1 })), a;
  },
  async deleteFlow({ commit: t }, e) {
    await $e.flows.remove(e), t(c7, e);
    const n = Ie("flows"), r = n.panels.getPanelForFlow(e);
    r && n.panels.removePanel({ panelId: r.id });
  },
  async markFlowAsRead({ state: t }, e) {
    const n = await $e.flows.setFlowAsRead(e.id);
    if (!n.errors) {
      const r = t.leadsMap[e.id].list;
      if (!r || r.length === 0) return n;
      const s = Ie("flows");
      r.forEach((i) => s.leads.markAsRead(i));
    }
    return n;
  },
  async fetchFlowSources({ commit: t }, { flowId: e, offset: n, limit: r }) {
    const s = await $e.flows.fetchFlowSources(e, { offset: n, limit: r });
    if (!s.errors) {
      t(
        no,
        s.map(({ source: o = {} }) => o)
      );
      const i = s.map(({ source: o = {} }) => o.id);
      n === 0 ? t(g7, { flowId: e, sources: i }) : t(v7, { flowId: e, sources: i });
    }
    return s;
  },
  async saveFlowSource(t, { flowId: e, sourceId: n }) {
    const r = {
      sources: [
        {
          id: n,
          _action: "CREATE",
          _index: 0
        }
      ]
    };
    return $e.flows.update(e, r);
  },
  async loadFlowsLeads({ commit: t }, { params: e, flowId: n }) {
    const { cursor: r, limit: s, reverse: i = !1, replace: o = !1 } = e, a = Ie("flows"), l = await a.leads.loadLeads({
      flowId: n,
      cursor: r,
      reverse: i,
      limit: s
    });
    if (l && l.data && !l.errors) {
      let c = l.data.map(({ id: u }) => u);
      o ? t(u7, { flowId: n, leadIds: c }) : i ? t(N1, {
        flowId: n,
        leadIds: a.root.getSortedLeadIds(c)
      }) : t(d7, { flowId: n, leadIds: c });
    }
    return l;
  },
  selectFlowLead(t, { entry: e, panelId: n }) {
    const r = Ie("flows"), s = r.leads.getLeadById(e.id);
    if (s) {
      s.is_read || r.leads.markAsRead(s.id), r.panels.selectPanelListEntry({ entryId: s.id, panelId: n });
      const i = r.panels.getPanelIndex(n);
      r.root.focusedPanelIndex !== i && r.panels.setDesiredScrollIndex(i);
    }
  },
  flowLeadsRemove({ commit: t }, e) {
    t(f7, e);
  },
  flowLeadsUnshift({ commit: t }, { flowId: e, leadIds: n }) {
    t(N1, { flowId: e, leadIds: n });
  },
  flowLeadsSetHasNew({ commit: t }, { flowId: e, hasNew: n }) {
    t(h7, { flowId: e, hasNew: n });
  },
  flowLeadsSetInitialLoaded({ commit: t }, { flowId: e, initialLoaded: n }) {
    t($1, { flowId: e, initialLoaded: n });
  },
  flowLeadsSetPaused({ commit: t }, { flowId: e, paused: n }) {
    t(p7, { flowId: e, paused: n });
  },
  flowLeadsSetHasSelected({ commit: t }, { flowId: e, hasSelected: n }) {
    t(m7, { flowId: e, hasSelected: n });
  }
}, slt = {
  /**
   * Получить поток для панели. Возвращает функцию, которая принимает объект панели и возвращает поток
   * @param state
   * @returns {function(*): ({id: *} | undefined | *)}
   */
  flowForPanel: (t) => (e) => t.items[e.dataId],
  getflowLeadsIds: (t) => (e) => {
    const n = t.leadsMap[e];
    return n ? n.list : [];
  },
  /**
   * Получить список инфоповодов для потока. Возвращает функцию, которая принимает id потока и возвращает список инфоповодов
   * @param state
   * @returns {function(*): (any[])}
   */
  getflowLeads: (t, { getflowLeadsIds: e }) => (n) => {
    const r = Ie("flows");
    return e(n).map((s) => r.leads.getLeadItems[s]);
  },
  /**
   * Узнать, активен ли список лидов для потока с переданным id.
   * @returns {function(flowId: string | number): boolean}
   */
  getIsFlowLeadsActiveById: () => (t) => {
    const e = Ie("flows"), n = e.panels.getPanelForFlow(t);
    return n ? e.root.getPanelIsActive(n.id) : !1;
  }
}, ilt = Dn(["flows"], {
  state: {
    items: {},
    list: [],
    leadsMap: {},
    sourceMap: {},
    selected: {},
    maxLeadsListLength: 90
  },
  actions: rlt,
  mutations: Lat,
  getters: slt,
  dependencies: {
    auth: null,
    root: {
      getters: ["focusedPanelIndex", "getSortedLeadIds", "getPanelIsActive"]
    },
    panels: {
      getters: ["getPanelForFlow", "getPanelIndex", "getFlowPanels"],
      actions: [
        "setDesiredScrollIndex",
        "setPanelColor",
        "setPanelName",
        "removePanel",
        "selectPanelListEntry"
      ]
    },
    leads: {
      getters: ["getSortedLeadIds", "getLeadById", "getLeadItems"],
      actions: ["loadLeads", "markAsRead"]
    }
  }
}), olt = {
  [lF](t, { itemId: e, itemType: n }) {
    t.isVisible = !0, t.itemId = e, t.itemType = n;
  },
  [V1](t) {
    t.isVisible = !1, t.data = null, t.cursor = null;
  },
  [pat](t, e) {
    t.data = e;
  },
  [cF](t, e) {
    Array.isArray(t.data) || (t.data = []), t.data = [...t.data, ...e];
  },
  [uF](t, e) {
    t.cursor = e;
  },
  [z1](t, e) {
    t.isLoading = e;
  }
}, alt = {
  showHistoryModal({ commit: t, dispatch: e }, { itemId: n, itemType: r }) {
    t(Vi, !0), t(lF, { itemId: n, itemType: r }), e("loadItemHistory");
  },
  hideHistoryModal({ commit: t }) {
    t(Vi, !1), t(V1);
  },
  async loadItemHistory({ commit: t, state: e }) {
    try {
      t(z1, !0);
      const n = await $e.news.fetchEvents(e.itemId, {
        cursor: e.cursor
      });
      t(cF, n.data), t(uF, n.next_cursor), t(z1, !1);
    } catch {
      t(Vi, !1), t(V1);
    }
  }
}, llt = Dn(["historyModal"], {
  state: {
    isVisible: !1,
    isLoading: !0,
    itemId: null,
    itemType: null,
    data: null,
    cursor: null
  },
  mutations: olt,
  actions: alt,
  dependencies: {
    news: null
  }
}), clt = "LEADS_INIT", jF = "LEADS_PUSH", X1 = "LEADS_ADD", WF = "LEADS_MARK_AS_READ", HF = "LEADS_SET_READ_FORWARDED", ult = "LEADS_DELETE", VF = "LEADS_SET_INITIAL_LOADED", dlt = "FLOW_NEWSBREAKS_CLEAR_UNUSED", zF = "LEADS_INCREMENT_REF_COUNTER", UF = "LEADS_DECREMENT_REF_COUNTER", flt = {
  [clt](t, e) {
    t.init = e;
  },
  [jF](t, e) {
    var s;
    e.name = ((s = e.source) == null ? void 0 : s.name) ?? null;
    const n = t.items[e.id] || {}, r = df(n, e);
    U.set(t.items, e.id, r);
  },
  [zF](t, e) {
    for (let n = 0; n < e.length; n++)
      t.refs[e[n]] !== void 0 ? t.refs[e[n]]++ : U.set(t.refs, e[n], 1);
  },
  [UF](t, e) {
    for (let n = 0; n < e.length; n++)
      t.refs[e[n]] && t.refs[e[n]] > 0 ? t.refs[e[n]]-- : U.set(t.refs, e[n], 0);
  },
  [ult](t, e) {
    U.delete(t.items, e), U.delete(t.refs, e), U.delete(t.initialLoadedMap, e);
  },
  [X1](t, e) {
    e.forEach((n) => {
      n.name = n.source ? n.source.name : null, U.set(t.items, n.id, n);
    });
  },
  [WF](t, e) {
    const n = { ...t.items[e] };
    n && (n.is_read = !0), U.set(t.items, e, n);
  },
  [HF](t, e) {
    const n = t.items[e.lead.id];
    n && (t.items[e.lead.id] = {
      ...n,
      is_read_by_not_me: !0,
      picked_by: e.picked_by
    });
  },
  [VF](t, { leadId: e, value: n }) {
    U.set(t.initialLoadedMap, e, { initialLoaded: n });
  }
}, plt = {
  async pushLead({ commit: t }, { payload: e, subId: n = null }) {
    globalThis.requestIdleCallback(
      () => {
        let r = e.lead || e;
        t(jF, r);
        let s;
        n !== null ? s = parseInt(n.split(".")[1]) : s = lt(e, "metaHeaders.subscription"), s && Ie("leads").flows.flowLeadsUnshift({
          flowId: s,
          leadIds: [r.id]
        });
      },
      { timeout: 5e3 }
    );
  },
  async getLead({ commit: t }, e) {
    let n = {};
    return e != null && (n = await $e.leads.fetchOne(e), n.errors ? n.status === 404 && Ie("leads").panels.clearLeadsOldSupply() : (n.name = n.body, t(X1, [n]))), n;
  },
  markAsRead({ commit: t }, e) {
    return t(WF, e), $e.leads.setAsRead(e);
  },
  async forwardLead(t, { lead: e, userIds: n, groupIds: r, fragment: s }) {
    return $e.leads.forward(e.id, { userIds: n, groupIds: r, fragment: s });
  },
  loadLeads({ commit: t }, { flowId: e, cursor: n, reverse: r, limit: s }) {
    return new Promise((i) => {
      $e.leads.fetchMore({
        flow_id: e,
        cursor: n,
        reverse: r,
        limit: s
      }).then((o) => {
        o.errors ? i(o) : globalThis.requestIdleCallback(
          () => {
            t(X1, o.data), i(o);
          },
          { timeout: 5e3 }
        );
      });
    });
  },
  // FIXME: Нигде не используется?
  setLeadReadForwarded({ commit: t }, e) {
    e.user.id !== Ie("leads").auth.getUserId && t(HF, e);
  },
  async pickLead(t, { leadId: e, typeId: n = 3, fragment: r = null }) {
    const s = Ie("leads");
    n = s.userProfile.getDefaultNewsTypeId || n;
    const i = await $e.leads.pick(e, { typeId: n, fragment: r });
    return i.errors || s.news.createNewsItem({ payload: i }), i;
  },
  setLeadsInitialLoaded({ commit: t }, { leadId: e, value: n }) {
    t(VF, { leadId: e, value: n });
  }
}, hlt = {
  getLeadItems: (t) => t.items,
  /**
   * Возвращает лид по его id
   * @param {VuexState} state Глобальное состояние
   * @returns {function(id: ID): Object}
   */
  getLeadById: (t) => (e) => t.items[e]
}, mlt = Dn(["leads"], {
  namespaced: !0,
  state: {
    items: {},
    refs: {},
    initialLoadedMap: {},
    maxLeadsListLength: 90
  },
  actions: plt,
  mutations: flt,
  getters: hlt,
  dependencies: {
    auth: {
      getters: ["getUserId"]
    },
    userProfile: {
      getters: ["getDefaultNewsTypeId"]
    },
    news: {
      actions: ["createNewsItem"]
    },
    panels: {
      actions: ["clearLeadsOldSupply"]
    },
    flows: {
      actions: ["flowLeadsUnshift"]
    }
  }
}), vlt = {
  [Qd](t, e) {
    e.single && t.messages.find((n) => n.code === e.code) || t.messages.push(e);
  },
  [Qf](t, e) {
    if (e == null)
      t.messages.shift();
    else {
      const n = t.messages.findIndex((r) => r === e);
      t.messages.splice(n, 1);
    }
  }
}, ro = {
  GENERIC: "GENERIC",
  LOST_CONNECTION: "LOST_CONNECTION",
  RECONNECT: "RECONNECT"
}, La = /* @__PURE__ */ new Map();
function ND(t, { state: e, commit: n }) {
  e.messages.forEach((r) => {
    r.type === t && (n(Qf, r), clearTimeout(La.get(r)), La.delete(r));
  });
}
function $D(t, { state: e, commit: n }) {
  e.messages.forEach((r) => {
    t.includes(r.code) && (n(Qf, r), clearTimeout(La.get(r)), La.delete(r));
  });
}
function glt(t) {
  return {
    id: Date.now() + Math.random(),
    code: ro.GENERIC,
    single: !1,
    closable: !0,
    text: "",
    timeout: 5e3,
    title: null,
    type: "info",
    render: "string",
    ...t
  };
}
function ylt(t, e) {
  return setTimeout(() => {
    e(Qf, t), La.delete(t);
  }, t.timeout);
}
const blt = {
  addMessage({ state: t, commit: e }, n) {
    const r = glt(n);
    t.messages.find(({ id: s }) => s === n.id) || (e(Qd, r), r.timeout < 1 / 0 && La.set(r, ylt(r, e)));
  },
  removeMessage({ commit: t }, e) {
    t(Qf, e), clearTimeout(La.get(e)), La.delete(e);
  },
  removeErrorMessages: ND.bind(void 0, "error"),
  removeWarningMessages: ND.bind(void 0, "warning"),
  clearConnectionMessages: $D.bind(void 0, [
    ro.LOST_CONNECTION,
    ro.RECONNECT
  ]),
  addLostConnectionMessage({ commit: t, state: e }) {
    $D([ro.LOST_CONNECTION, ro.RECONNECT], {
      commit: t,
      state: e
    }), t(Qd, {
      code: ro.LOST_CONNECTION,
      type: "error",
      title: "Потеряно подключение к серверу",
      text: "Нет связи с сервером. Попробуйте обновить страницу",
      timeout: 1 / 0,
      closable: !1,
      single: !0
    });
  },
  addReconnectMessage({ commit: t, state: e }) {
    e.messages.find(
      (n) => n.code === ro.RECONNECT || n.code === ro.LOST_CONNECTION
    ) || t(Qd, {
      type: "warning",
      text: "Потеряно подключение к серверу. Пытаемся восстановить соединение",
      single: !0,
      code: ro.RECONNECT,
      timeout: 1 / 0
    });
  }
}, _lt = Dn(["messages"], {
  state: {
    messages: []
  },
  actions: blt,
  mutations: vlt
}), wlt = {
  async addAuthors({ dispatch: t }, { newsItemId: e, userIds: n }) {
    const r = await $e.news.addAuthors(e, n);
    return r.errors || t("drafts/addAuthors", { newsItemId: e, authors: r }), r;
  },
  async deleteAuthor({ dispatch: t }, { newsItemId: e, userId: n }) {
    const r = await $e.news.deleteAuthor(e, n);
    return r.errors || t("drafts/deleteAuthor", { newsItemId: e, userId: n }), r;
  }
}, Slt = "NEWS_INIT", GF = "NEWS_ADD", Ilt = "NEWS_CLEAR_UNUSED", YF = "NEWS_INCREMENT_REF_COUNTER", ZF = "NEWS_DECREMENT_REF_COUNTER", Elt = "NEWS_ITEM_SET_TYPE", XF = "NEWS_ITEM_ADD", KF = "NEWS_ITEM_DELETE", JF = "NEWS_ITEM_ADD_EVENTS", qF = "NEWS_ITEM_SET_INITIAL_LOADED", VI = "NEWS_ITEM_SET_EMBARGO_EXPIRED", QF = "NEWS_ITEM_SET_REVOKED", eB = "NEWS_ITEM_SET_FIRST_COMMENT", tB = "NEWS_LIST_SET", nB = "NEWS_LIST_APPEND", rB = "NEWS_LIST_PREPEND", ao = "NEWS_LIST_UNSHIFT", xlt = "NEWS_LIST_PUSH", zI = "NEWS_LIST_REMOVE", sB = "NEWS_LIST_SET_FILTERS", iB = "NEWS_LIST_SET_PAUSED", K1 = "NEWS_LIST_SET_HASNEW", oB = "NEWS_LIST_SET_HASSELECTED", aB = "NEWS_LIST_SET_INITIAL_LOADED", lB = "NEWS_ITEM_SET_DISPOSAL_DIALOG", cB = "NEWS_SET_COLORS_MAP", uB = "ORIGINALS_SET", dB = "ORIGINALS_APPEND", fB = "ORIGINALS_SET_FILTERS", Clt = {
  async setNewsCodesColorMap({ commit: t, getters: e }, n) {
    const r = async (i) => {
      const o = await Kn.process("newsColors", {
        type: "codes",
        all: e["codes/allCodeItems"],
        selected: Ie("news").userProfile.getColorsByType("codes"),
        data: e.getNewsItemCurrentVersion(i)
      });
      t(cB, {
        type: "codes",
        id: i,
        colors: o
      });
    }, s = n.map(r);
    await Promise.all(s);
  }
}, Tlt = {
  async getNewsEvents({ commit: t }, { newsItemId: e, limit: n, cursor: r }) {
    const s = await $e.news.fetchEvents(e, { limit: n, cursor: r });
    return s.errors || t(JF, { newsItemId: e, events: s.data }), s;
  }
};
function Plt(t) {
  return {
    type: "save",
    handler: () => Promise.resolve(),
    resolver: () => Promise.resolve(),
    ...t
  };
}
function ua(t, e, n) {
  return (r) => (t.busy = !1, e.forEach((s) => {
    s !== n && s.resolver(r);
  }), r);
}
function klt(t, e = 500) {
  const n = {
    timer: null,
    events: [],
    busy: !1,
    priority: 1
  };
  return n.timer = setInterval(t(n), e), n;
}
function Nlt(t, e = 500) {
  const n = {};
  return {
    createQueue(r) {
      return n[r] || (n[r] = klt(t, e)), n[r];
    },
    deleteQueue(r) {
      n[r] && (clearInterval(n[r].timer), delete n[r]);
    },
    addEvent(r, s) {
      let i = n[r];
      i || (i = this.createQueue(r)), i.events.unshift(Plt(s));
    },
    waitForAllEventsHandled(r) {
      return new Promise((s) => {
        var i;
        if (!((i = n[r]) != null && i.events.length))
          s();
        else {
          const o = setInterval(() => {
            var a;
            (a = n[r]) != null && a.events.length || (clearInterval(o), s());
          }, e);
        }
      });
    }
  };
}
function $lt(t) {
  return () => {
    if (t.busy || t.events.length === 0) return;
    t.busy = !0;
    const e = t.events.slice();
    t.events.splice(0);
    const n = e.find((i) => i.type === "delete");
    if (n) {
      n.handler().then(ua(t, e, n)).catch(ua(t, e, n));
      return;
    }
    const r = e.filter((i) => i.type === "status");
    if (r.length) {
      r[0].handler().then(ua(t, e, r[0])).catch(ua(t, e, r[0]));
      return;
    }
    const s = e.find((i) => i.type === "annotation");
    if (s) {
      s.handler().then(ua(t, e, s)).catch(ua(t, e, s));
      return;
    }
    e[0].handler().then(ua(t, e, e[0])).catch(ua(t, e, e[0]));
  };
}
const Al = Nlt($lt, 300), Dlt = {
  // Молния
  1: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "publish_at",
    "is_postponed"
  ],
  // Экспресс
  2: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "subheadline",
    "trashline",
    "dateline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Новость
  3: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "subheadline",
    "trashline",
    "dateline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Выпуск
  4: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Анонс
  5: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "subheadline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Пресс-релиз
  6: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "subheadline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Сводка событий
  7: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "subheadline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Комментарий
  8: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Обзор
  9: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "body",
    "publish_at",
    "is_postponed"
  ],
  // Служебное сообщение
  10: [
    "type_id",
    "language_id",
    "slugline",
    "headline",
    "subheadline",
    "trashline",
    "dateline",
    "body",
    "publish_at",
    "is_postponed"
  ]
};
function Alt(t) {
  const e = {};
  return Dlt[t.type_id].forEach((n) => {
    e[n] = t[n];
  }), e;
}
async function vo(t) {
  const e = Or(t);
  return e.dateline !== "" && (e.dateline = e.dateline ?? null), Alt(e);
}
const Olt = {
  async createNewsItem({ commit: t, dispatch: e }, { payload: n = null, notificationId: r = null } = {}) {
    let s = n;
    const i = Ie("news");
    if (!s || !s.id) {
      const o = (s == null ? void 0 : s.typeId) || i.userProfile.getDefaultNewsTypeId || 3;
      s = await $e.news.create({ type_id: o }, r);
    }
    s.errors || (await e("setNewsItem", s), t(ao, { setType: "my", id: s.id }), t(ao, { setType: "inProgress", id: s.id }), r && i.panels.addPanelNotification({
      panelId: s.id,
      notificationId: r
    }), i.panels.addPanel({
      panel: { type: ve.newsItem, dataId: s.id },
      position: 0
    }), i.panels.setDesiredScrollIndex(0));
  },
  deleteNewsItem({ dispatch: t }, { newsItemId: e }) {
    return new Promise((n) => {
      Al.addEvent(e, {
        type: "delete",
        handler: async () => {
          const r = await $e.news.remove(e);
          return r.errors || t("clearDeletedNewsItem", { newsItemId: e }), n(r), r;
        },
        resolver(r) {
          n(r);
        }
      });
    });
  },
  async clearDeletedNewsItem({ state: t, commit: e, dispatch: n }, { newsItemId: r }) {
    const s = Ie("news"), i = s.root.getNewsItemPanel(r);
    n("drafts/deleteDraft", { newsItemId: r }), i && s.panels.removePanel({ panelId: i.id }), Object.keys(t.sets).forEach((o) => {
      e(zI, { setType: o, id: r });
    }), e(KF, r);
  },
  async getNewsItem({ dispatch: t }, e) {
    const n = Ie("news"), r = n.panels.getPanelNotification(e), s = await $e.news.fetchOne(e, r);
    return r && n.panels.removePanelNotification(e), s.errors || await t("setNewsItem", s), s;
  },
  async setNewsItem({ state: t, commit: e, dispatch: n, getters: r }, s) {
    var l, c, u, d, f, p;
    const i = Ie("news"), o = { ...s }, a = ((l = o == null ? void 0 : o.version) == null ? void 0 : l.status_id) === ((u = (c = i == null ? void 0 : i.references) == null ? void 0 : c.newsStatusesByName.PUBLISHED) == null ? void 0 : u.id);
    if ((d = o.child_links) != null && d.length || (f = o.parent_links) != null && f.length) {
      const h = {}, m = o.child_links, v = o.parent_links;
      m != null && m.length && (h[o.id] = m), v != null && v.length && v.forEach((y) => {
        h[y.news_id] = [
          ...h[y.news_id] || [],
          {
            type_id: y.type_id,
            news_id: o.id,
            is_published: a,
            is_disposed: !!o.disposer
          }
        ];
      }), await n("links/addNewsLinks", h);
    }
    if (o.version) {
      const h = Or(s.version);
      if (await n("versions/setVersion", { version: h, newsItemId: o.id }), await n("versions/addNewsItemVersion", {
        newsItemId: o.id,
        versionId: h.id,
        versionNum: h.number
      }), a)
        try {
          await n("setNewsCodesColorMap", [o.id]);
        } catch (m) {
          console.warn("Error while setting news colors", m);
        }
    }
    return (p = o == null ? void 0 : o.newsbreak) != null && p.lead && i.leads.pushLead({
      payload: o.newsbreak.lead
    }), delete o.version, e(XF, o), o;
  },
  async setNewsItemAsRead({ dispatch: t, getters: e }, n) {
    const r = e.getNewsItemCurrentVersion(n);
    if (r) {
      const s = Ie("news").references.newsStatuses[r.status_id].name;
      if (!["WAITS_FOR_EDIT"].includes(s) || e.getNewsItemIsRead(n))
        return;
      const i = await $e.news.setAsRead(n);
      i.errors || t("setNewsItem", i.data);
    }
  },
  async setType({ commit: t }, { itemId: e, typeId: n } = {}) {
    t(Elt, { itemId: e, typeId: n });
  },
  async sendNewsItemToASOI({ dispatch: t, getters: e }, { newsItemId: n, user_ids: r, group_ids: s, comment: i }) {
    const o = e.getNewsItemCurrentVersion(n), a = Ie("news"), l = await $e.news.sendToASOI({
      newsItemId: n,
      version: await vo(o),
      user_ids: r,
      group_ids: s,
      comment: i
    });
    if (l.message || l.errors) {
      if (l.errors) {
        const c = e.getDraftForNewsItem(n);
        c && t("drafts/setValidationErrors", {
          draftId: c.id,
          errors: l.errors
        }), a.messages.addMessage({
          type: "error",
          text: "Ошибка отправки новости в АСОИ"
        });
      }
    } else
      l.errors || a.messages.addMessage({
        type: "success",
        text: "Новость отправлена в АСОИ"
      });
    return l;
  },
  async rescheduleNewsItem({ dispatch: t, getters: e }, { paramsList: n, supressError: r = !1 }) {
    const s = Ie("news"), i = await $e.news.reschedule(n);
    return i.errors ? i.status === 400 && (r || i == null || i.errors.forEach((o) => {
      var u;
      let a = o.title, l = "string", c = 5e3;
      if (o.code === "NEWS_PARENT_CONFLICT") {
        const d = o.source.pointer.split("/"), f = d[d.length - 2], p = e.getNewsItemById((u = n[f]) == null ? void 0 : u.id);
        a = `
              Дочерняя новость не может быть опубликована раньше родительской: ${p != null && p.parent_id ? `<a href="https://${globalThis.location.host}/news/${p.parent_id}">«${o.meta.parent_headline}»</a>` : `«${o.meta.parent_headline}»`}.
              Для удаления связи с родительской необходимо открыть новость в отдельной панели и опубликовать оттуда.
              `, l = "html", c = 1e4;
      }
      s.messages.addMessage({
        type: "error",
        text: a,
        render: l,
        timeout: c
      });
    })) : i.forEach((o) => {
      var a, l;
      t("setNewsItem", o), ((a = o == null ? void 0 : o.version) == null ? void 0 : a.publish_at) === null && ((l = o == null ? void 0 : o.version) == null ? void 0 : l.is_postponed) === !1 && t("removeNewsItemFromSet", {
        setType: "embargo",
        newsItemId: o.id
      });
    }), i;
  },
  async revokeNewsItem({ commit: t, dispatch: e }, { newsItemId: n }) {
    const r = await $e.news.revoke(n), s = Ie("news");
    return !r.errors && r.data && (await e("setNewsItem", r.data), t(ao, { setType: "my", id: r.data.id }), t(ao, { setType: "inProgress", id: r.data.id }), s.panels.addPanel({
      panel: { type: ve.newsItem, dataId: r.data.id },
      position: 0
    }), s.panels.setDesiredScrollIndex(0)), r.errors && r.status === 403 && s.messages.addMessage({
      type: "error",
      text: "Вы не можете аннулировать эту новость"
    }), r;
  },
  setDisposalDialog({ commit: t }, { id: e, value: n }) {
    t(lB, { id: e, value: n });
  },
  setNewsItemFirstComment({ commit: t }, { newsItemId: e, comment: n }) {
    t(eB, { newsItemId: e, comment: n });
  },
  async createFlashFromFragment({ dispatch: t }, e) {
    const { type_id: n, body: r, panelIndex: s, slugline: i } = e, o = await $e.news.create({ type_id: n, body: r, slugline: i });
    if (!o.errors) {
      await t("setNewsItem", o);
      const a = Ie("news"), l = a.userProfile.getDefaultRecipientId, c = a.userProfile.getDefaultRecipientUserId, u = a.userProfile.getDefaultRecipientGroupId;
      l == null ? a.shareModal.showShareModal({
        itemId: o.id,
        itemType: "newsItem",
        actionType: "sendFragmentAsFlash",
        params: { panelIndex: s }
      }) : t("sendFlashFragmentToEdit", {
        newsItemId: o.id,
        groupId: u,
        userId: c
      });
    }
  },
  async sendFlashFragmentToEdit({ dispatch: t }, e) {
    const { newsItemId: n, groupId: r, userId: s } = e;
    await t("sendNewsItemToEdit", {
      newsItemId: n,
      groupId: r,
      userId: s
    }), Ie("news").messages.addMessage({
      type: "success",
      text: "Молния отправлена, доступна во вклдаке «Мои»"
    });
  },
  setNewsEmbargoExpired({ commit: t }, e) {
    t(VI, e);
  },
  setNewsItemInitialLoaded({ commit: t }, { newsItemId: e, value: n }) {
    t(qF, { newsItemId: e, value: n });
  },
  async extendNewsItem({ commit: t, dispatch: e }, { newsItemId: n, panelIndex: r }) {
    const s = Ie("news"), i = await $e.news.extend(n);
    return !i.errors && i.data && (await e("setNewsItem", i.data), t(ao, { setType: "my", id: i.data.id }), t(ao, { setType: "inProgress", id: i.data.id }), s.panels.addPanel({
      panel: {
        type: ve.newsItem,
        dataId: i.data.id
      },
      position: r,
      goToPanel: !0
    })), i;
  }
}, Mlt = {
  openPublishedNewsItem({ getters: t }, { entry: e, panelId: n }) {
    const r = Ie("news"), s = t.getNewsItemById(e.id), i = r.panels.getPanelByDataId("newsItem", s.id);
    if (!fs(i)) {
      r.panels.setPanelFocused(i.id), r.panels.setDesiredScrollIndex(r.panels.getPanelIndex(n));
      return;
    }
    r.panels.addPanel({
      panel: { type: ve.newsItem, dataId: s.id },
      position: r.panels.getPanelIndex(n)
    });
  },
  selectPublishedNewsItem(t, { entry: e, panelId: n }) {
    if (!e) return;
    const r = Ie("news"), s = r.panels.getPanelIndex(n), i = r.panels.getPanelById(n);
    r.panels.selectPublishedPanelNewsItem({ entry: e, panel: i }), r.panels.setDesiredScrollIndex(s);
  },
  async republishUneditedNewsItem({ dispatch: t }, { id: e, codeIds: n }) {
    const r = await $e.news.republishUnedited(e, n), s = Ie("news");
    return r.errors ? r.errors.forEach((i) => {
      s.messages.addMessage({
        type: "error",
        text: i.detail || i.title
      });
    }) : (await t("setNewsItem", r.data), t("updateNewsItemSets", { newsItem: r.data }), s.messages.addMessage({
      type: "success",
      text: "Новость переопубликована без изменений"
    })), r;
  }
}, Rlt = {
  selectEmbargoNewsItem({ getters: t }, { newsItemId: e, panelId: n }) {
    if (!e) return;
    const r = Ie("news"), s = r.panels.getPanelById(n), i = r.panels.getPanelIndex(n), o = t.getNewsItemById(e);
    r.panels.selectEmbargoNewsItem({ entry: o, panel: s }), r.panels.setDesiredScrollIndex(i);
  },
  async routeNewsPublicationCodes({ dispatch: t, getters: e }, { id: n, codeIds: r }) {
    const s = await $e.news.routePublicationCodes(n, r);
    if (!s.errors) {
      const i = e.getNewsItemCurrentVersion(n);
      i && t("versions/setVersion", { version: { ...i, codes: s } }), Ie("news").messages.addMessage({
        text: "Направления публикации изменены",
        type: "success"
      });
    }
    return s;
  }
}, Llt = {
  async addNews({ dispatch: t, commit: e, getters: n }, { news: r, reverse: s, replace: i, setType: o }) {
    const a = Ie("news"), l = [], c = [], u = [], d = {};
    return r.forEach((f) => {
      const p = f.version, h = p.status_id === a.references.newsStatusesByName.PUBLISHED.id, m = f.child_links;
      m.length && (d[f.id] = m);
      const v = f.parent_links;
      v.length && v.forEach((y) => {
        d[y.news_id] = [
          ...d[y.news_id] || [],
          {
            type_id: y.type_id,
            news_id: f.id,
            is_published: h
          }
        ];
      }), delete f.version, c.push(p), l.push(f), u.push({
        newsItemId: f.id,
        versionId: p.id,
        versionNum: p.number
      });
    }), t("links/addNewsLinks", d), t("versions/setVersions", c), t("versions/addNewsItemsVersions", u), o === "published" && await t(
      "setNewsCodesColorMap",
      r.map(({ id: f }) => f)
    ), e(GF, l), i ? e(tB, { setType: o, ids: r.map(({ id: f }) => f) }) : s ? e(rB, {
      setType: o,
      ids: o === "embargo" ? r.map(({ id: f }) => f) : n.getSortedNews(r.map(({ id: f }) => f))
    }) : e(nB, { setType: o, ids: r.map(({ id: f }) => f) }), r;
  },
  async loadNews({ dispatch: t }, { params: e, setType: n, replace: r = !1 }) {
    let s;
    if (["my", "published", "inProgress", "waiting", "disposed"].includes(n) ? s = await $e.news.fetchMoreSpecific(e, n) : n === "search" ? s = await $e.news.search(e) : s = await $e.news.fetchMore(e), !s.errors && s.data)
      if (n === "search") {
        const [i, o] = await Kn.process(
          "newsSearchVersions",
          s.data
        );
        await t("addNews", {
          news: i,
          reverse: e.reverse,
          replace: r,
          setType: n
        }), t("search/addSearchVersions", o);
      } else
        await t("addNews", {
          news: s.data,
          reverse: e.reverse,
          replace: r,
          setType: n
        });
    return s;
  },
  async loadDelayedNews({ dispatch: t }, { params: e, replace: n = !1 }) {
    const r = await $e.news.fetchMoreSpecific(e, "delayed");
    return !r.errors && r.data && t("addNews", {
      news: r.data,
      reverse: e.reverse,
      replace: n,
      setType: "embargo"
    }), r;
  },
  addNewsItemToSet({ state: t, commit: e }, { setType: n, newsItem: r }) {
    t.sets[n].paused ? t.sets[n].hasNew || e(K1, { setType: n, value: !0 }) : e(ao, { setType: n, id: r.id });
  },
  removeNewsItemFromSet({ commit: t }, { setType: e, newsItemId: n }) {
    t(zI, { setType: e, id: n });
  },
  /**
   * Раскладывает по вкладкам новость в зависимости от её статуса или других условий в полях `predicates`
   */
  updateNewsItemSets({ state: t, dispatch: e }, { newsItem: n, subId: r }) {
    const s = t.sets;
    Object.keys(s).filter((i) => i !== "search").forEach((i) => {
      const o = s[i].predicates;
      o && (o.map(
        (l) => l(this, n, r)
      ).indexOf(!1) !== -1 ? e("removeNewsItemFromSet", {
        setType: i,
        newsItemId: n.id
      }) : e("addNewsItemToSet", { setType: i, newsItem: n }));
    });
  },
  setNewsSetFilters({ commit: t }, { setType: e, value: n }) {
    t(sB, { setType: e, value: n });
  },
  setNewsSetInittialLoaded({ commit: t }, { setType: e, value: n }) {
    t(aB, { setType: e, value: n });
  },
  setNewsSetPaused({ commit: t }, { setType: e, value: n }) {
    t(iB, { setType: e, value: n });
  },
  setNewsSetHasNew({ commit: t }, { setType: e, value: n }) {
    t(K1, { setType: e, value: n });
  },
  setNewsSetHasSelected({ commit: t }, { setType: e, value: n }) {
    t(oB, { setType: e, value: n });
  }
};
function Up(t, e) {
  return new Promise((n, r) => {
    Al.addEvent(t, {
      type: "status",
      handler: e(n, r),
      resolver: (s) => n(s)
    });
  });
}
async function DD(t, e) {
  const { closeOnSubmit: n } = t.userProfile.getProfile.newsEditor, r = t.panels.getPanelByDataId("newsItem", e);
  "id" in r && n && await t.panels.removePanel({ panelId: r.id });
}
const pB = {
  sendNewsItemToEdit({ dispatch: t, getters: e }, { newsItemId: n, recipients: r, keep_original: s = !1, comment: i = "" }) {
    return Up(n, (o) => async () => {
      var f;
      const a = e.getNewsItemCurrentVersion(n), l = ((f = e.getDraftForNewsItem(n)) == null ? void 0 : f.version) ?? a, u = a.status_id !== 10 && a.status_id !== 8 ? { version: await vo(l) } : {}, d = await $e.news.send({
        newsItemId: n,
        ...u,
        recipients: r,
        keep_original: s,
        comment: i
      });
      return d.errors || (await t("setNewsItem", d.data), t("updateNewsItemSets", { newsItem: d.data }), s || (t("drafts/deleteDraft", { newsItemId: n }), DD(Ie("news"), n))), o(d), d;
    });
  },
  async pickNewsItemToEdit({ getters: t, dispatch: e }, { newsItemId: n, needOpenPanel: r = !0, notificationId: s = null }) {
    const i = Ie("news"), o = await vo(
      t.getNewsItemCurrentVersion(n)
    ), a = await $e.news.pick(n, o, s);
    return a.errors ? a.status === 403 && i.messages.addMessage({
      type: "error",
      text: "Действие над новостью запрещено"
    }) : (r && i.panels.addPanel({
      panel: { type: ve.newsItem, dataId: a.data.id },
      position: 0
    }), await e("setNewsItem", a.data), await e("drafts/setDraftVersion", {
      newsItemId: n,
      version: a.data.version
    }), await e("updateNewsItemSets", { newsItem: a.data }), e("addNewsItemToSet", {
      newsItem: a.data,
      setType: "my"
    })), a;
  },
  publishRevocation({ dispatch: t, commit: e, getters: n }, { newsItemId: r }) {
    return Up(r, (s) => async () => {
      var a;
      const i = await vo(
        (a = n.getDraftForNewsItem(r)) == null ? void 0 : a.version
      ), o = await $e.news.publish(r, {
        ...i
      });
      return o.errors || (await t("setNewsItem", o.data), n.getIsNewsItemIsRevocation(o.data.id) && e(QF, {
        newsItemId: o.data.parent_id,
        value: !0
      })), (!o.errors || o.errors && (!o.status || o.status === 200)) && (await t("updateNewsItemSets", { newsItem: o.data }), t("drafts/deleteDraft", { newsItemId: r })), s(o), o;
    });
  },
  publish({ dispatch: t, getters: e }, { newsItemId: n, pubCodes: r = null, allowEmbargoCodes: s = !1 }) {
    return Up(n, (i) => async () => {
      var d;
      let o = [];
      const a = Ie("news"), l = a.root.getDraftForNewsItem(n);
      l.version && l.version.codes && (o = o.concat(r.map(({ id: f } = {}) => ({ id: +f }))));
      const c = await vo(l.version), u = await $e.news.publish(
        n,
        {
          ...c,
          codes: o
        },
        s
      );
      return u.errors || (await t("setNewsItem", u.data), t("drafts/disablePublishMode", { newsItemId: n }), t("drafts/deleteDraft", { newsItemId: n }), DD(a, n)), !u.errors || u.errors && (!u.status || u.status === 200) ? await t("updateNewsItemSets", { newsItem: u.data }) : (d = u.errors) != null && d.length && u.errors.forEach((f) => {
        var h, m;
        const p = {
          type: "error",
          text: `Не удалось опубликовать новость: ${f.detail}`
        };
        if (f.code === "UNPROCESSABLE_ENTITY" && f.source && f.source.pointer.includes("/data/attributes/codes")) {
          const v = /data\/attributes\/codes\/(\d+)\/id/.exec(
            f.source.pointer
          ), y = v && +v[1], _ = (h = o[y]) == null ? void 0 : h.id, w = (m = e["codes/allCodes"][_]) == null ? void 0 : m.name;
          w && (p.text = `Не удалось опубликовать новость:<br>Код "${w}" отсутствует в профиле пользователя`, p.render = "html", p.timeout = 8e3);
        }
        a.messages.addMessage(p);
      }), i(u), u;
    });
  },
  async republish({ commit: t, dispatch: e }, { newsItemId: n, query: r }) {
    const s = await $e.news.republish(n, r), i = Ie("news");
    if (!s.errors && s.data) {
      await e("setNewsItem", s.data), e("links/addNewsLinks", {
        [n]: [
          {
            news_id: s.data.id,
            type_id: 1,
            is_published: !1
          }
        ]
      }), t(ao, { setType: "my", id: s.data.id }), t(ao, { setType: "inProgress", id: s.data.id });
      const o = i.panels.getPanelByDataId("newsItem", n);
      o && o.id ? (i.panels.setPanelDataId({
        panelId: o.id,
        dataId: s.data.id
      }), i.panels.setPanelFocused(o.id)) : (i.panels.addPanel({
        panel: { type: ve.newsItem, dataId: s.data.id },
        position: 0
      }), i.panels.setDesiredScrollIndex(0));
    }
    return s;
  },
  async disposeNewsItems({ dispatch: t }, e) {
    const n = Ie("news");
    n.uiState.setModal(!1);
    const r = await $e.news.dispose(e);
    return r.errors || r.data.forEach(async (s) => {
      await t("setNewsItem", s), t("drafts/deleteDraft", { newsItemId: s.id }), await t("updateNewsItemSets", { newsItem: s }), await n.panels.removePanel({
        panelId: n.root.getNewsItemPanel(s.id)
      });
    }), r;
  },
  disposeNewsItem({ getters: t, dispatch: e }, { reason: n, panelId: r, newsItemId: s }) {
    return Up(s, (i) => async () => {
      const o = Ie("news");
      o.uiState.setModal(!1);
      const a = await vo(
        t.getNewsItemCurrentVersion(s)
      ), l = await $e.news.dispose([
        { id: s, version: a, reason: n }
      ]);
      return l.errors || (await e("setNewsItem", l.data[0]), await e("updateNewsItemSets", { newsItem: l.data[0] }), e("drafts/deleteDraft", { newsItemId: s }), await o.panels.removePanel({ panelId: r })), i(l), l;
    });
  },
  async recallNewsItem({ dispatch: t }, { newsItemId: e }) {
    const n = await $e.news.recall(e);
    return n.errors || (await t("setNewsItem", n.data), t("updateNewsItemSets", { newsItem: n.data })), n.errors && n.status === 403 && Ie("news").messages.addMessage({
      type: "error",
      text: "Вы не можете отозвать эту новость"
    }), n;
  }
};
async function Flt(t, e, n) {
  await t("setNewsItem", e.news), await t("updateNewsItemSets", { newsItem: e.news, subId: n });
}
function Blt({ addChatMessage: t }, { payload: e, subId: n }) {
  const r = n.split(".")[1];
  t({ newsItemId: r, message: e.news_comment });
}
function jlt({ updateChatReadMessage: t }, { payload: e, subId: n }) {
  const r = n.split(".")[1];
  t({ newsItemId: r, messages: [e.news_comment] });
}
async function Wlt(t, e) {
  e && e.version && (e.version.publish_at !== null || e.version.is_postponed) && (await t("setNewsItem", e), t("updateNewsItemSets", { newsItem: e }), t("addNewsItemToSet", { setType: "embargo", newsItem: e }));
}
async function Hlt(t, e) {
  await t("setNewsItem", e.news);
}
async function Vlt(t, e) {
  await t("setNewsItem", e.news), await t("updateNewsItemSets", { newsItem: e.news });
}
async function zlt(t, e, n) {
  await t("setNewsItem", e.news), await t("updateNewsItemSets", { newsItem: e.news, subId: n });
}
async function Ult(t, e, n, r = null) {
  await t("setNewsItem", e.news), await t("updateNewsItemSets", { newsItem: e.news, subId: n }), await t("drafts/setDraftVersion", {
    newsItemId: e.news.id,
    version: e.news.version,
    timestamp: r ? new Date(r).valueOf() : null
  });
}
async function Glt(t, e, n) {
  var o;
  const r = t.getNewsItemById(n.news.id);
  if (!r) return;
  const s = t.getNewsItemCurrentVersion(r.id), i = s ? `новости
      <a href="${globalThis.location.origin}/news/${n.news.id}">
      «${s.headline ?? s.slugline}»</a>` : `<a href="${globalThis.location.origin}/news/${n.news.id}">новости</a>`;
  e({
    id: `asoi-duplicate-${n.news.id}`,
    type: "error",
    title: "Дубликат новости в АСОИ",
    render: "html",
    text: `Пользователь ${(o = n == null ? void 0 : n.user) == null ? void 0 : o.name} создал в ${on(
      Date.now(),
      "HH:mm"
    )} в АСОИ дубликат вашей ${i}.`,
    timeout: 1 / 0
  });
}
const Ylt = {
  async processNewsMessage({ getters: t, dispatch: e }, { payload: n, subId: r, datetime: s = null } = {}) {
    var o, a;
    const i = Ie("news");
    switch ((a = (o = i.references.newsEventTypes) == null ? void 0 : o[n.type_id]) == null ? void 0 : a.name) {
      case "READ":
        await Hlt(e, n);
        break;
      case "SCHEDULED":
        await Wlt(e, n.news);
        break;
      case "UPDATED":
      case "PICKED_FOR_EDIT":
        await Ult(e, n, r, s);
        break;
      case "DELETED":
        e("clearDeletedNewsItem", { newsItemId: n.news.id });
        break;
      case "DISPOSED":
        await zlt(e, n, r);
        break;
      case "PUBLISHED":
        await Vlt(e, n);
        break;
      case "DUPLICATED_IN_ASOI":
        await Glt(t, i.messages.addMessage, n);
        break;
      case "COMMENT_ADDED":
        Blt(
          { addChatMessage: i.chat.addChatMessage },
          { payload: n, subId: r }
        );
        break;
      case "COMMENT_READ":
        jlt(
          { updateChatReadMessage: i.chat.updateChatReadMessage },
          { payload: n, subId: r }
        );
        break;
      default:
        await Flt(e, n, r);
    }
  }
};
function Dt(t, { newsItemId: e, draftId: n }) {
  let r = null;
  return n ? r = t.items[n] : e && (r = t.items[t.newsMap[e]]), r;
}
const Zlt = {
  syncDraft({ state: t, dispatch: e }, n) {
    const r = Dt(t.drafts, { newsItemId: n }), s = t.versions.newsMap[n];
    if (r && s.length) {
      const i = t.versions.items[s[s.length - 1]];
      r.version.number >= i.number ? e("versions/setVersion", {
        version: {
          id: i.id,
          ...r.version
        },
        newsItemId: n
      }) : e("drafts/setDraftVersion", { draftId: r.id, version: i });
    }
  }
}, Xlt = {
  async loadOriginals({ dispatch: t }, { params: e, replace: n = !1 }) {
    let r = await $e.news.fetchMoreSpecific(e, "originals");
    return !r.errors && r.data && t("addOriginals", {
      versions: r.data,
      replace: n
    }), r;
  },
  addOriginals({ dispatch: t, commit: e }, { versions: n, replace: r }) {
    t("versions/setVersions", n), r ? e(
      uB,
      n.map(({ id: s }) => s)
    ) : e(
      dB,
      n.map(({ id: s }) => s)
    );
  },
  async openOriginalsNewsItem(t, { newsId: e, panelId: n }) {
    const r = Ie("news"), s = r.panels.getPanelByDataId("newsItem", e);
    if (!fs(s)) {
      r.panels.setPanelFocused(s.id), r.panels.setDesiredScrollIndex(r.panels.getPanelIndex(n));
      return;
    }
    return await r.panels.addPanel({
      panel: { type: ve.newsItem, dataId: e },
      position: r.panels.getPanelIndex(n)
    });
  },
  setOriginalsFilters({ commit: t }, e) {
    t(fB, e);
  }
}, Klt = {
  ...wlt,
  ...Clt,
  ...Rlt,
  ...Tlt,
  ...Olt,
  ...Mlt,
  ...Llt,
  ...pB,
  ...Ylt,
  ...Zlt,
  ...Xlt
}, Jlt = {
  /**
   * Получить список id пользователей, которые в данный момент работают с новостью
   * @returns    {number[]}
   */
  newsItemUserIds: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.users) == null ? void 0 : r.map(({ user: s } = {}) => s.id)) ?? [];
  },
  /**
   * Получить список полных имён пользователей, которые в данный момент работают с новостью
   * @returns    {string[]}
   */
  newsItemUserNames: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.users) == null ? void 0 : r.map(({ user: s } = {}) => Ps(s.name))) ?? [];
  },
  /**
   * Получить список id групп, которые в данный момент работают с новостью
   * @returns    {number[]}
   */
  newsItemGroupIds: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.groups) == null ? void 0 : r.map(({ group: s } = {}) => s.id)) ?? [];
  },
  /**
   * Получить список названий групп, которые в данный момент работают с новостью
   * @returns    {string[]}
   */
  newsItemGroupNames: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.groups) == null ? void 0 : r.map(({ group: s } = {}) => s.name)) ?? [];
  },
  /**
   * Возвращает русское имя языка для переданной новости
   * @param state
   * @returns {function(*): string}
   */
  newsItemLanguageName: () => (t) => ["русский", "английский"][Number(t.version.language_id) - 1],
  /**
   * Возвращает русское имя языка для переданной версии новости
   * @param state
   * @returns {function(*): string}
   */
  newsItemVersionLanguageName: () => (t) => ["русский", "английский"][Number(t.language_id) - 1],
  getDraftForNewsItem: (t) => (e) => {
    var n, r;
    return ((r = t == null ? void 0 : t.drafts) == null ? void 0 : r.items[(n = t.drafts) == null ? void 0 : n.newsMap[e]]) ?? null;
  },
  getNewsItemCurrentVersion: (t) => (e) => {
    const n = t.versions.newsMap[e];
    return n ? t.versions.items[n[n.length - 1]] : null;
  },
  getNewsItemPrevVersion: (t) => (e) => {
    const n = t.versions.newsMap[e];
    return n ? t.versions.items[n[n.length - 2]] : null;
  },
  /**
   * Возвращает признак, является ли текущий пользователь создателем новости
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(newsItem: NewsItem): boolean}
   */
  getIsNewsItemCreator: (t, e) => (n) => n.creator.id === e.userId,
  /**
   * Возвращает признак, состоит ли пользователь в группах,
   * указанных в поле `creator` объекта новости
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(newsItem: NewsItem): boolean}
   */
  getIsNewsItemCreatorGroups: () => (t) => {
    const e = t.creator.group_ids.map((n) => ({ group: { id: n } }));
    return Ie("news").userProfile.isUserInGroups(e);
  },
  /**
   * Возвращает события для новости с переданным id
   * @param state
   * @returns {function(*): *}
   */
  newsItemEvents: (t) => (e) => t.events[e],
  getNewsItemById: (t) => (e) => t.items[e],
  getNewsItemIsRead: (t) => (e) => {
    const n = t.items[e];
    return n && n.users.length ? !!n.users.find(
      (r) => r.user.id === Ie("news").auth.getUserId && r.is_read
    ) : !1;
  },
  getDisposalDialogState: (t) => (e) => t.disposalDialogMap[e],
  /**
   * Проверяет, что новость с данным `id` это новость-аннулирование
   *
   * @param state
   * @returns {function(id: ID): boolean}
   */
  getIsNewsItemIsRevocation: (t) => (e) => {
    const n = t.items[e], r = Ie("news");
    return n && r.references.newsParentRelTypes[n.parent_rel_type_id] ? r.references.newsParentRelTypes[n.parent_rel_type_id].name === "REVOCATION" : !1;
  },
  /**
   * Проверяет, что новость с данным `id` аннулирована
   *
   * @param state
   * @returns {function(id: ID): boolean}
   */
  getIsNewsItemRevoked: (t) => (e) => {
    const n = t.items[e];
    return (n == null ? void 0 : n.is_revoked) ?? !1;
  },
  /**
   * Проверяет, запланирована ли новость
   *
   * @param state
   * @returns {function(newsItem: NewsItem): boolean}
   */
  isNewsItemScheduled: (t, e) => (n) => {
    const r = e.getNewsItemCurrentVersion(n);
    return r ? r.publish_at !== null || r.is_postponed : !1;
  },
  getIsNewsItemPublished: (t) => (e) => {
    var n;
    return !!((n = t.items[e]) != null && n.publisher);
  },
  getNewsItemPublishedBy: (t) => (e) => {
    const n = t.items[e];
    return n && n.publisher ? n.publisher : null;
  },
  isNewsItemPublishedByMe: (t) => (e) => {
    const n = t.items[e];
    return n && n.publisher ? n.publisher.id === Ie("news").auth.getUserId : !1;
  },
  isNewsItemExtension: (t) => (e) => {
    const n = t.items[e];
    return !!(n && n.parent_rel_type_id === Ie("news").references.newsParentRelTypesByName.EXTENSION.id);
  },
  getIsNewsItemFromASOI: (t) => (e) => {
    const n = t.items[e];
    return n && !!n.asoi_note_id;
  },
  getIsNewsItemExpired: (t) => (e) => t.expired.includes(e),
  getNewsItemColorsByType: (t) => (e) => (n) => t.colorsMap[e][n],
  getIsEmbargoEditable: (t, e) => (n) => {
    const r = e.getNewsItemCurrentVersion(n);
    return [1, 3, 6, 8].includes(r.status_id);
  }
};
var qlt = Qa, Qlt = ta, ect = k8, tct = NR;
function nct(t, e) {
  if (t == null)
    return {};
  var n = qlt(tct(t), function(r) {
    return [r];
  });
  return e = Qlt(e), ect(t, n, function(r, s) {
    return e(r, s[0]);
  });
}
var rct = nct;
const pu = /* @__PURE__ */ Et(rct), sct = w2(
  k2((t) => !!t),
  P2((t) => !!t)
), ict = {
  newsUnread: (t, e) => (n) => t.sets[n].list.filter((r) => {
    const s = e.getNewsItemById(r), i = e.getNewsItemCurrentVersion(r);
    return s && i ? n === "inProgress" ? Ie("news").references.newsStatuses[i.status_id].name === "WAITS_FOR_EDIT" && !e.getNewsItemIsRead(r) : !e.getNewsItemIsRead(r) : !1;
  }).length,
  getSortedNews: (t) => (e) => e.sort((n, r) => new Date(t.items[r].created_at) - new Date(t.items[n].created_at)),
  getNewsSortedByModified: (t) => (e) => e.sort((n, r) => new Date(t.items[r].status_modified_at) - new Date(t.items[n].status_modified_at)),
  getNewsSetListByType: (t) => (e) => t.sets[e].list,
  getIsPausedNewsSet: (t) => (e) => e === "originals" ? t.originals.paused : t.sets[e].paused,
  getIsHasNewNewsSet: (t) => (e) => e === "originals" ? t.originals.hasNew : t.sets[e].hasNew,
  getIsHasSelectedNewsSet: (t) => (e) => e === "originals" ? !1 : t.sets[e].hasSelected,
  getAppliedFiltersNewsSet: (t) => (e) => lt(t.sets[e], "filters") ? pu(t.sets[e].filters, (n) => fs(n) ? !1 : !fs(sct(n))) : {},
  getHasAppliedFiltersNewsSet: (t, e) => (n) => !fs(e.getAppliedFiltersNewsSet(n)),
  getIsNewsItemInSet: (t) => (e, n) => t.sets[e].list.includes(n),
  getNewsCountByNewsType: (t, e) => (n, r) => t.sets[n].list.filter((s) => {
    const i = e.getNewsItemById(s), o = e.getNewsItemCurrentVersion(s);
    if (i && o) {
      if (n === "inProgress") {
        const a = Ie("news").versions.getIsMyNewsVersion(
          o.id
        );
        return o.type_id === r && a;
      }
      return o.type_id === r;
    }
    return !1;
  }).length,
  // Получить новые новости, которые не попали в отображаемый список (для списков, которые не обновляются автоматически)
  getNotAddedToDisplayedSetNews: (t) => (e) => t.sets[e].displayedList ? t.sets[e].list.filter(
    (n) => !t.sets[e].displayedList.includes(n)
  ) : [],
  // Получить удаленные в отображаемом списке новости (для списков, которые не обновляются автоматически)
  getDisplayedSetRemovedNews: (t) => (e) => t.sets[e].displayedList ? t.sets[e].displayedList.filter(
    (n) => !t.sets[e].list.includes(n)
  ) : []
}, oct = {
  /**
   * Получить список id пользователей, которым новость назначена в работу (имеет тип связи "BINDING")
   * @returns    {number[]}
   */
  newsItemUserCanWorkIds: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.users) == null ? void 0 : r.filter((s) => s.can_work).map(({ user: s } = {}) => s.id)) ?? [];
  },
  /**
   * Получить список полных имён пользователей, которым новость назначена в работу (имеет тип связи "BINDING")
   * @returns    {string[]}
   */
  newsItemUserCanWorkNames: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.users) == null ? void 0 : r.filter((s) => s.can_work).map(({ user: s } = {}) => Ps(s.name))) ?? [];
  },
  getIsCurrentUserCanWork: (t, e) => (n) => {
    const r = e.newsItemUserCanWorkIds(n);
    return r ? r.includes(Ie("news").auth.getUserId) : !1;
  },
  /**
   * Возвращает флаг, показывающий, назначена ли новость текущему пользователю
   * @returns    {boolean}
   */
  isNewsItemIsAssignedToMe: (t, e) => (n) => {
    const r = e.getNewsItemCurrentVersion(n), s = Ie("news");
    if (r) {
      const i = s.references.newsStatuses[r.status_id];
      if (["WAITS_FOR_EDIT"].includes(i.name))
        return !!e.newsItemUserCanWorkIds(n).find((o) => o === s.auth.getUserId);
    }
    return !1;
  },
  getUserIsParticipant: () => (t) => {
    var e;
    return t ? !!((e = t.users) != null && e.find(
      (n) => n.user.id === Ie("news").auth.getUserId && n.is_participant
    )) : !1;
  },
  getIsParticipantById: (t) => (e) => {
    const n = t.items[e];
    return n ? !!n.users.find(
      (r) => r.user.id === Ie("news").auth.getUserId && r.is_participant
    ) : !1;
  },
  /**
   * Возвращает признак того, есть ли текущий пользователь в списке
   * пользователей новости или находится в одной из групп новости
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(newsItem: NewsItem): boolean}
   */
  getIsNewsItemRelatedToUser: () => (t) => {
    const e = Ie("news");
    return t.users.find(
      ({ user: n } = {}) => n.id === e.auth.getUserId.userId
    ) ? !0 : e.userProfile.isUserInGroups(t.groups);
  },
  /**
   * Возвращает признак привязки (BINDING) пользователя к новости
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(newsItem: NewsItem): boolean}
   */
  getIsNewsItemBindedToUser: (t, e) => (n) => !!e.newsItemUserCanWorkIds(n).find((r) => Ie("news").auth.getUserId === r),
  getIsNewsItemWorkable: (t, e) => (n) => {
    const r = t.items[n];
    if (r) {
      const s = e.getIsCurrentUserCanWork(n), i = Ie("news").userProfile.isUserInGroups(
        r.groups
      );
      return s || i;
    }
    return !1;
  },
  getCanUserEditNewsItem: (t, e) => (n) => {
    var s;
    const r = e.getNewsItemCurrentVersion(n);
    if (r) {
      const i = Ie("news").references.newsStatuses[r.status_id], o = ["DRAFT", "ON_EDIT"].includes(i.name), a = e.getIsCurrentUserCanWork(n), l = ((s = r.user) == null ? void 0 : s.id) === parseInt(Ie("news").auth.getUserId);
      return o && (a || l);
    }
    return !1;
  },
  getCanUserRevokeNewsItem: (t, e) => (n) => e.getIsNewsItemWorkable(n)
}, act = w2(
  k2((t) => !!t),
  P2((t) => !!t)
), lct = {
  getAppliedFiltersOriginalsSet: (t) => pu(t.originals.filters, (e) => fs(e) ? !1 : !fs(act(e)))
}, cct = {
  getNewsItems: (t) => t.items,
  ...oct,
  ...Jlt,
  ...ict,
  ...lct
}, uct = {
  [cB](t, { type: e, id: n, colors: r }) {
    if (!r || !r.length) {
      U.delete(t.colorsMap[e], n);
      return;
    }
    t.colorsMap[e] || U.set(t, "colorsMap", e), U.set(t.colorsMap[e], n, r);
  }
}, dct = {
  [JF](t, e) {
    const n = t.events[e.newsItemId] || [], r = Gf(n.concat(e.events).reverse(), "id");
    U.set(t.events, e.newsItemId, r);
  }
}, fct = {
  [XF](t, e) {
    const n = t.items[e.id] || {};
    U.set(t.items, e.id, { ...n, ...e });
  },
  [KF](t, e) {
    U.delete(t.items, e), U.delete(t.initialLoadedMap, e);
  },
  [qF](t, { newsItemId: e, value: n }) {
    U.set(t.initialLoadedMap, e, { initialLoaded: n });
  },
  [GF](t, e) {
    e.forEach((n) => {
      const r = t.items[n.id] || {};
      U.set(t.items, n.id, { ...r, ...n });
    });
  },
  [VI](t, e) {
    t.expired = e;
  },
  [eB](t, e) {
    const n = t.items[e.newsItemId];
    n && n.id && (n.first_comment = {
      body: e.comment
    });
  },
  [YF](t, e) {
    for (let n = 0; n < e.length; n++)
      t.refs[e[n]] !== void 0 ? t.refs[e[n]]++ : U.set(t.refs, e[n], 1);
  },
  [ZF](t, e) {
    for (let n = 0; n < e.length; n++)
      t.refs[e[n]] && t.refs[e[n]] > 0 ? t.refs[e[n]]-- : U.set(t.refs, e[n], 0);
  },
  [lB](t, { id: e, value: n }) {
    U.set(t.disposalDialogMap, e, n);
  },
  [QF](t, { newsItemId: e, value: n }) {
    const r = t.items[e];
    r && (r.is_revoked = n);
  }
}, $c = "list", Dc = "displayedList", AD = 100, pct = {
  [nB](t, { listType: e = $c, setType: n, ids: r }) {
    const s = un(
      t.sets[n][e].concat(r).reverse()
    ).reverse();
    t.sets[n][e] = s, t.sets[n][Dc] && (t.sets[n][Dc] = [...s]);
  },
  [rB](t, { listType: e = $c, setType: n, ids: r }) {
    let s = [...t.sets[n][e]];
    s.unshift(...r), s = un(s), s.length > t.maxNewsListLength && s.splice(t.maxNewsListLength), t.sets[n][e] = s, t.sets[n][Dc] && (t.sets[n][Dc] = [...s]);
  },
  [tB](t, { listType: e = $c, setType: n, ids: r }) {
    t.sets[n][e] = r, t.sets[n][Dc] && (t.sets[n][Dc] = [...r]);
  },
  [ao](t, { listType: e = $c, setType: n, id: r }) {
    t.sets[n][e].includes(r) || (t.sets[n][e].unshift(r), t.sets[n][e].length > AD && (t.sets[n][e].length = AD));
  },
  [xlt](t, { listType: e = $c, setType: n, id: r }) {
    t.sets[n][e].includes(r) || t.sets[n][e].push(r);
  },
  [zI](t, { listType: e = $c, setType: n, id: r }) {
    const s = t.sets[n][e].indexOf(r);
    s !== -1 && t.sets[n][e].splice(s, 1);
  },
  [iB](t, { setType: e, value: n }) {
    e !== "originals" && (t.sets[e].paused = n);
  },
  [K1](t, { setType: e, value: n }) {
    e !== "originals" && (t.sets[e].hasNew = n);
  },
  [oB](t, { setType: e, value: n }) {
    e !== "originals" && (t.sets[e].hasSelected = n);
  },
  [aB](t, { setType: e, value: n }) {
    e === "originals" ? t.originals.initialLoaded = n : t.sets[e].initialLoaded = n;
  },
  [sB](t, { setType: e, value: n }) {
    if (!n) {
      t.sets[e].filters = {};
      return;
    }
    t.sets[e].filters = {
      ...t.sets[e].filters,
      ...n
    };
  }
}, hct = {
  [uB](t, e) {
    t.originals.list = e;
  },
  [dB](t, e) {
    t.originals.list = un(
      t.originals.list.concat(e).reverse()
    ).reverse();
  },
  [fB](t, e) {
    if (!e) {
      t.originals.filters = {};
      return;
    }
    t.originals.filters = {
      ...t.originals.filters,
      ...e
    };
  }
}, mct = {
  [Slt](t, e) {
    t.init = e;
  },
  ...uct,
  ...dct,
  ...fct,
  ...pct,
  ...hct
};
function _d(t, e, n) {
  if (n.version) {
    const r = n.version.status_id, s = e.getters["references/newsStatuses"][r].name;
    return t.includes(s);
  }
  return !1;
}
function vct(t, e) {
  const n = t.getters["userProfile/isUserInGroups"](
    e.groups
  );
  return t.getters["news/getIsNewsItemBindedToUser"](e.id) || n;
}
function gct(t, e) {
  const n = t.getters.userId, r = e.users.find(({ user: s }) => s.id === n);
  return r ? r.is_participant : !1;
}
function yct(t, e) {
  const n = t.getters["news/codes/allCodeItems"];
  if (!e.version) return !1;
  const r = t.getters["news/getHasAppliedFiltersNewsSet"](
    "published"
  ), s = t.getters["news/getAppliedFiltersNewsSet"]("published");
  if (!r || !(s != null && s.codes)) return !0;
  const o = e.version.codes.map((f) => n[f.code.id]).filter((f) => !!f).map((f) => [
    f.id,
    ...f.track.slice(1).reverse()
  ]);
  let a = !!s.codes.filter((f) => f.state === "included" && n[f.id].track.slice(1).reverse().reduce((p, h) => p === !1 ? !1 : !s.codes.find(({ id: m }) => m === h), !0)).length;
  const l = o.reduce((f, p) => {
    const h = p.reduce(
      (m, v) => {
        const y = s.codes.find(({ id: _ }) => _ === v);
        return y && (y.state === "included" ? (m.isIgnored && (m.ignoredState = "included"), m.isIncluded = !m.isExcluded && !m.isIgnored) : y.state === "excluded" ? (m.isIgnored && (m.ignoredState = "excluded"), m.isExcluded = !m.isIncluded && !m.isIgnored) : y.state === "ignored" && (m.isIgnored = !m.isIncluded && !m.isExcluded)), m;
      },
      {
        isIncluded: !1,
        isExcluded: !1,
        isIgnored: !1,
        ignoredState: null
      }
    );
    return f.push(h), f;
  }, []), c = !!l.map((f) => f.isIncluded).filter((f) => !!f).length, u = !!l.map((f) => f.isExcluded).filter((f) => !!f).length, d = !!l.map((f) => f.isIgnored).filter((f) => !!f).length;
  if (u)
    return !1;
  if (c)
    return !0;
  if (d) {
    const f = l.filter((h) => h.isIgnored === !0).reduce((h, m) => {
      const v = m.ignoredState === "included" ? !1 : m.ignoredState === "excluded" ? !0 : null;
      return h.push(v), h;
    }, []).filter((h) => h !== null);
    return un(f).length === 2 ? a : f[0];
  }
  return !a;
}
function bct(t, e) {
  var p;
  const n = t.getters.getGroupsAndUsers, r = { ids: [], excludedIds: [], ignoredIds: [] }, s = t.getters["news/getAppliedFiltersNewsSet"]("published");
  if (!(s != null && s.authors)) return !0;
  const i = s.authors, o = (h, m, v, y) => {
    var _;
    if (/G$/g.test(v)) {
      const w = (_ = n[v]) == null ? void 0 : _.children;
      if (!w)
        return;
      w.forEach((S) => {
        const E = i.find((x) => x.id === S);
        E && E.state !== y || h[m].push(S);
      });
    } else
      h[m].push(v);
  }, a = i.reduce((h, m) => (m.state === "included" ? o(h, "ids", m.id, "included") : m.state === "excluded" ? o(
    h,
    "excludedIds",
    m.id,
    "excluded"
  ) : m.state === "ignored" && o(
    h,
    "ignoredIds",
    m.id,
    "ignored"
  ), h), r), l = e.version;
  if (!e || !l) return !1;
  const c = l.authors.map((h) => h.user.id), u = (p = e.publisher) == null ? void 0 : p.id, d = [...c, ...u ? [u] : []];
  return nv(a.excludedIds, d).length ? !1 : !(a.ids.length && !nv(a.ids, d).length);
}
function _ct(t, e) {
  const n = t.getters["news/getAppliedFiltersNewsSet"]("published");
  return n != null && n.range ? Cee(new Date(e.status_modified_at), {
    start: Tr(n.range.start),
    end: Tr(n.range.end) || Date.now()
  }) : !0;
}
function wct(t, e) {
  const n = t.getters["news/getAppliedFiltersNewsSet"]("published");
  return n != null && n.hideRepublications ? e.parent_rel_type_id !== t.getters["references/newsLinkTypeByName"].REPUBLICATION.id && e.parent_rel_type_id !== t.getters["references/newsLinkTypeByName"].REPUBLICATION_UNEDITED.id : !0;
}
function Sct(t, e) {
  return e.origin_id === null;
}
function Ict(t, e) {
  var n, r;
  return ((r = (n = e.version) == null ? void 0 : n.user) == null ? void 0 : r.id) === t.getters.userId;
}
function Ect(t, e) {
  var r, s, i, o;
  const n = (r = t.getters["references/newsLinkTypes"][e.parent_rel_type_id]) == null ? void 0 : r.name;
  return n === "REPUBLICATION" || n === "REPUBLICATION_UNEDITED" ? ((s = e.version.user) == null ? void 0 : s.id) === t.getters.userId || ((i = e.version.recipient_user) == null ? void 0 : i.id) === t.getters.userId || t.getters["userProfile/isUserInGroup"](
    (o = e.version.recipient_group) == null ? void 0 : o.id
  ) : !0;
}
function xct(t, e) {
  var s, i, o, a, l;
  const n = ((i = (s = t.getters["userProfile/getWaitingFilters"]) == null ? void 0 : s.groups) == null ? void 0 : i.ids) ?? [], r = ((a = (o = t.getters["userProfile/getWaitingFilters"]) == null ? void 0 : o.users) == null ? void 0 : a.ids) ?? [];
  if (n != null && n.length || r != null && r.length) {
    let c = !1, u = !1;
    if (n != null && n.length && (c = ((l = e.groups) == null ? void 0 : l.length) > 0 && e.groups.map((d) => d.group.id).reduce((d, f) => (d === !0 || (d = n.includes(f)), d), !1)), r != null && r.length) {
      const d = t.getters["news/newsItemUserCanWorkIds"](
        e.id
      );
      u = !!r.find((f) => d.includes(f));
    }
    return c || u;
  } else
    return vct(t, e);
}
const Cct = (t, e) => {
  var o, a;
  const n = Ict(t, e), r = t.getters["auth/getUserPermissions"].includes(
    "2.6"
  ), s = ((a = (o = e.version) == null ? void 0 : o.user) == null ? void 0 : a.group_ids) || [], i = t.getters["userProfile/isUserInGroups"](
    s.map((l) => ({ group: { id: l } }))
  );
  return n || r && i;
}, Tct = (t, e) => t.getters["news/isNewsItemScheduled"](e.id), Pct = {
  init: rt.INITIAL,
  items: {},
  colorsMap: {
    codes: {}
  },
  disposalDialogMap: {},
  initialLoadedMap: {},
  events: {},
  refs: {},
  expired: [],
  originals: {
    list: [],
    filters: {},
    hasNew: !1,
    hasSelected: !1,
    paused: !0,
    initialLoaded: !1
  },
  sets: {
    my: {
      list: [],
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: [
        gct,
        Sct,
        Ect
      ]
    },
    waiting: {
      list: [],
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: [
        _d.bind(null, ["WAITS_FOR_EDIT"]),
        xct
      ]
    },
    inProgress: {
      list: [],
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: [
        _d.bind(null, ["DRAFT", "ON_EDIT"]),
        Cct
      ]
    },
    disposed: {
      list: [],
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: [_d.bind(null, ["DISPOSED"])]
    },
    published: {
      list: [],
      filters: {},
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: [
        _d.bind(null, [
          "PUBLISHED"
        ]),
        _ct,
        yct,
        bct,
        wct
      ]
    },
    embargo: {
      list: [],
      displayedList: [],
      // для отображения списка, который не должен обновляться автоматически
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: [
        _d.bind(null, ["WAITS_FOR_PUBLICATION"]),
        Tct
      ]
    },
    search: {
      list: [],
      hasNew: !1,
      hasSelected: !1,
      paused: !1,
      initialLoaded: !1,
      predicates: []
    }
  },
  autoSaveInterval: 1e4,
  maxNewsListLength: 90
}, J1 = "CODES_SET_ALL", hB = "CODES_SET_PROFILE", OD = "CODES_INIT", kct = "CODES_SET_PROFILE_WITH_PROFILE_CATEGORY", Nct = {
  async init({ commit: t, dispatch: e }) {
    t(OD, rt.IN_PROGRESS);
    const r = Ie("codes").references.codeTypeIds;
    await Promise.all([
      e("fetchCodes"),
      e("fetchProfileCodes", r.NEWS_OR_ISSUE),
      e("fetchProfileCodes", r.PUBLISH_NEWS)
    ]), t(OD, rt.READY);
  },
  async fetchCodes({ commit: t }) {
    let e;
    if (Ie("codes").uiState.getIsOnline)
      e = await $e.codes.fetchAll(), e && !e.errors && (await ni.appData.setData({
        codes: e
      }), t(J1, e));
    else {
      const n = await ni.appData.getCodes();
      n && (e = n, t(J1, n));
    }
    return e;
  },
  async fetchProfileCodes({ commit: t }, e = 4) {
    const n = Ie("codes"), r = n.references.getCodeType(e);
    let s;
    return n.uiState.getIsOnline && (s = await $e.codes.fetchProfile(e), s.data && !s.data.errors && t(hB, {
      codes: s.data,
      typeName: r.name || "DEFAULT"
    })), s;
  }
}, $ct = {
  CODES_INIT(t, e) {
    t.init = e;
  },
  [J1](t, e) {
    U.set(t, "items", e);
  },
  [hB](t, { codes: e, typeName: n }) {
    U.set(t.profiles, n, e);
  },
  [kct](t, { codes: e, typeName: n }) {
    U.set(t.profilesWithProfileCategory, n, e);
  }
}, Dct = {
  iptc: ["900"],
  moex: ["905"],
  spb: ["910"],
  feed: ["950", "951"],
  // информационная продукция интерфакс
  publication: ["902"],
  // направления публикаций
  publicationTechnical: ["9029"]
  // + не упомянут subFeed: ['907']
}, ha = {};
Object.entries(Dct).forEach(([t, e]) => {
  ha[t] = (n) => e.some((r) => {
    var s;
    return (s = n == null ? void 0 : n.path) == null ? void 0 : s.startsWith(r);
  });
});
const da = {
  allCodes: "000000000000000000",
  // "Все коды"
  iptc: "900000000000000000",
  // "IPTC"
  regions: "082000000000000000",
  // "Административно-территориальные образования"
  ipOfInterfax: "950000000000000000",
  // "Информационная продукция ЗАО "Интерфакс"
  publicationsType: "902000000000000000",
  // "Направления публикаций",
  technicalPublications: "902900000000000000"
  // "Технологические направления"
}, Act = {
  getCodeIdByPath: (t) => (e) => {
    const n = Object.values(t.items).find(
      (r) => r.path === String(e)
    );
    return n ? n.id : null;
  },
  ipoiCodeId(t, e) {
    return e.getCodeIdByPath(da.ipOfInterfax);
  },
  regionsCodeId(t, e) {
    return e.getCodeIdByPath(da.regions);
  },
  ptCodeId(t, e) {
    return e.getCodeIdByPath(da.publicationsType);
  },
  ptechCodeId: (t, e) => e.getCodeIdByPath(da.technicalPublications),
  iptcCodeId(t, e) {
    return e.getCodeIdByPath(da.iptc);
  },
  allCodeItems(t, e) {
    const n = { ...e.allCodes }, r = e.getCodeIdByPath(da.allCodes);
    return r !== null && delete n[r], n;
  },
  allCodeItemsActual(t, e) {
    const n = { ...e.allActualCodes }, r = e.getCodeIdByPath(da.allCodes);
    return r !== null && delete n[r], n;
  },
  getProfileCodeItems: (t, e) => (n) => {
    const r = t.profiles[n], s = e.getCodeIdByPath(da.allCodes);
    return s !== null && r[s] ? delete r[s] : delete r[-1], r;
  },
  getProfileCodeItemsWithProfileCategory: (t) => (e) => t.profilesWithProfileCategory[e],
  moexCodes: (t, e) => (n) => {
    const r = {};
    if (!t.profiles[n] || !t.profiles[n].length)
      return {};
    const s = e.getProfileCodeItems(n);
    return Object.values(s).forEach((i) => {
      ha.moex(i) && (r[i.id] = i);
    }), r;
  },
  getIsIptcCode: (t) => (e) => {
    const n = t.items[e];
    if (n) return ha.iptc(n);
  },
  getIsMoexCode: (t) => (e) => {
    const n = t.items[e];
    return ha.moex(n);
  },
  getIsSpbCode: (t) => (e) => {
    const n = t.items[e];
    return ha.spb(n);
  },
  getIsPublicationCode: () => (t) => ha.publication(t),
  getIsFeedCode: () => (t) => ha.feed(t),
  newsCodes: (t, e) => e.getProfileCodeItems("NEWS_OR_ISSUE"),
  publicationCodes: (t, e) => e.getProfileCodeItems("PUBLISH_NEWS"),
  newsCodesWithCategory: (t, e) => e.getProfileCodeItemsWithProfileCategory("NEWS_OR_ISSUE"),
  publicationCodesWithCategory: (t, e) => e.getProfileCodeItemsWithProfileCategory("PUBLISH_NEWS"),
  allCodes: (t) => t.items,
  allActualCodes: (t) => {
    const e = {};
    return Object.entries(t.items).forEach(([n, r]) => {
      r.is_deprecated || (e[n] = r);
    }), e;
  },
  /**
   * Возвращает флаг, указывающий, что пользователь имеет в своём профиле коды,
   * не относящиеся к "Техническим направлениям" публикации
   *
   * @return     {boolean} Имеет ли пользователь не-технические направления публикации
   */
  getIsUserHasPublishingCodes: (t, e) => {
    const n = e.getProfileCodeItems("PUBLISH_NEWS"), s = Object.values(n).some((i) => {
      var o;
      return !(ha.publicationTechnical(i) || (o = i.children) != null && o.length);
    });
    return n && s;
  },
  /**
   * Возвращает коды, доступные для добавления к опубликованной новости.
   * Если у пользователя в профиле для опубликования есть коды кроме
   * "Технических направлений", пользователь может добавлять любые коды,
   * иначе — только коды из профиля "Направления публикации",
   * т.е. только технические направления.
   *
   * @param      {<type>}  Геттеры кодов
   * @return     {Object}  Объект с кодами, доступными для добавления
   *                       к опубликованной новости
   */
  getCodesAvailableForRepublication: (t, e) => {
    if (e.getIsUserHasPublishingCodes) {
      const n = { ...e.publicationCodes };
      return Object.entries(n).forEach(([r, s]) => {
        n[r] = {
          ...s,
          /*
            Нам нужно перенести все направления публикации в начало списка, но
            сохранить их внутренний порядок.
          */
          pos: s.pos - 1e5
          // ха-ха, каждый раз при вычислении этого computed!
        };
      }), Object.assign(n, e.newsCodes);
    }
    return e.publicationCodes;
  },
  /**
   * Возвращает коды, доступные для добавления к холсту.
   * Список состоит из кодов профилей пользователя обоих типов (PUBLISH_NEWS и NEWS_OR_ISSUE)
   *
   * @param      {<type>}  Геттеры кодов
   * @return     {Object}  Объект с кодами, доступными для добавления
   *                       к опубликованной новости
   */
  getCodesForCanvas: (t, e) => {
    const n = { ...e.publicationCodesWithCategory };
    return Object.entries(n).forEach(([r, s]) => {
      n[r] = {
        ...s,
        /*
          Нам нужно перенести все направления публикации в начало списка, но
          сохранить их внутренний порядок.
        */
        pos: s.pos - 1e5
      };
    }), Object.assign(n, e.newsCodesWithCategory);
  }
  // TODO: Проверить коды в тексте
  // isCodeInText: state => (newsItemId, codeId) => {
  //   return (
  //     !!state.draftsTextCodesMap[newsItemId] &&
  //     state.draftsTextCodesMap[newsItemId].includes(codeId)
  //   )
  // }
}, Oct = Dn(["news", "codes"], {
  namespaced: !0,
  state: {
    items: {},
    profiles: {},
    profilesWithProfileCategory: {},
    predict: {},
    predictMoex: {},
    newsVersionMap: {}
  },
  actions: Nct,
  getters: Act,
  mutations: $ct,
  dependencies: {
    news: null,
    references: {
      getters: ["codeTypeIds", "getCodeType"]
    },
    uiState: {
      getters: ["getIsOnline"]
    }
  }
}), Mct = {
  getDraftTypeId: (t) => (e) => {
    var r, s;
    const n = t.newsMap[e];
    return (s = (r = t.items[n]) == null ? void 0 : r.version) == null ? void 0 : s.type_id;
  },
  getIsEmbargoFormVisible: (t) => (e) => t.embargoFormsMap[e],
  getIsEmbargoValid: (t) => (e) => t.embargoValidMap[e] ?? !0,
  getIsEmbargoNotSaved: (t) => (e) => {
    var n;
    return ((n = t.embargoStateMap[e]) == null ? void 0 : n.notSaved) || !1;
  },
  getIsEmbargoConfirmOpen: (t) => (e) => {
    var n;
    return ((n = t.embargoStateMap[e]) == null ? void 0 : n.confirmOpen) || !1;
  },
  getEmbargoStateController: (t) => (e) => {
    var n;
    return (n = t.embargoStateMap[e]) == null ? void 0 : n.controller;
  },
  getValidationErrors: (t) => (e) => t.validationErrorsMap[e],
  codesForDraft: (t) => (e) => {
    const n = t.items[e];
    return n ? n.version.codes.map((r) => (r = r.code, r)) : [];
  },
  inTextCodesForNewsItem: (t) => (e) => {
    const n = Dt(t, { newsItemId: e });
    return t.textCodesMap[n == null ? void 0 : n.id];
  },
  getDraftPredictedCodes: (t) => (e) => t.predictCodesMap[e],
  getAvailableBlocks: (t) => (e) => {
    const n = Dt(t, { draftId: e });
    if (n) {
      const r = t.presets[n.version.type_id] ?? [];
      return (t.blocksMap[n.id] ?? []).filter((i) => r.includes(i.type));
    }
    return [];
  },
  getVisibleBlocks: (t) => (e) => {
    const n = Dt(t, { draftId: e });
    if (n) {
      const r = t.presets[n.version.type_id] ?? [];
      return (t.blocksMap[n.id] ?? []).filter(
        (i) => r.includes(i.type) && i.visible
      );
    }
    return [];
  },
  getUnusedBlocks: (t) => (e) => {
    const n = Dt(t, { draftId: e });
    if (n) {
      const r = t.presets[n.version.type_id] ?? [];
      return (t.blocksMap[n.id] ?? []).filter(
        (i) => r.includes(i.type) && i.visible === !1
      );
    }
    return [];
  },
  getIsMyDraft: (t) => (e) => {
    var n, r, s;
    return ((s = (r = (n = t.items[e]) == null ? void 0 : n.version) == null ? void 0 : r.user) == null ? void 0 : s.id) === Ie("drafts").auth.getUserId;
  }
}, mB = "DRAFT_INIT", vB = "DRAFT_DELETE", gB = "DRAFT_CREATE", yB = "DRAFT_SET_VERSION", Rct = "DRAFT_SET_SYNCED", bB = "DRAFT_SET_NEWS_MAP", _B = "DRAFT_BLOCKS_SET_MAP", wB = "DRAFT_BLOCK_SET_VISIBILITY", SB = "DRAFT_BLOCK_SET_INITIALIZED", IB = "DRAFT_BLOCK_SET_DISABLED", EB = "DRAFT_UPDATE_DATA_FIELDS", xB = "DRAFT_UPDATE_LANG", CB = "DRAFT_UPDATE_TYPE", q1 = "DRAFT_SET_POSTPONED", Q1 = "DRAFT_SET_EMBARGO", TB = "DRAFT_CODES_ADD", Lct = "DRAFT_CODES_SET", ew = "DRAFT_CODES_DELETE", Fct = "DRAFT_INTEXT_CODES_SET", PB = "DRAFT_INTEXT_CODES_ADD", kB = "DRAFT_INTEXT_CODES_DELETE", Bct = "DRAFT_INTEXT_CODES_CLEAR", tw = "NEWS_CODES_PREDICT_SET", NB = "NEWS_CODES_PREDICT_ADD_ADDED", $B = "NEWS_CODES_PREDICT_ADD_DELETED", DB = "NEWS_CODES_PREDICT_REMOVE_ADDED", AB = "NEWS_CODES_PREDICT_REMOVE_DELETED", OB = "DRAFT_AUTHORS_ADD", MB = "DRAFT_AUTHORS_DELETE", RB = "DRAFT_SET_VALIDATION", LB = "DRAFT_SET_EMBARGO_FORM", Fc = "DRAFT_SET_EMBARGO_VALID", FB = "DRAFT_EMBARGO_SAVE_STATE_SET_MAP", BB = "DRAFT_EMBARGO_SAVE_STATE_SET_NOT_SAVED", jB = "DRAFT_EMBARGO_SAVE_STATE_SET_CONFIRM_OPEN", WB = "DRAFT_EMBARGO_SAVE_STATE_SET_CONTROLLER", HB = "DRAFT_ADD_PUB_CODE", VB = "DRAFT_DELETE_PUB_CODE", zB = "DRAFT_SET_PUB_MODE", UB = "DRAFT_REMOVE_PUB_MODE", GB = "DRAFT_SET_LAST_UPDATE ";
function YB(...t) {
  return (e) => t.reduce((n, r) => n.then(r), Promise.resolve(e));
}
async function ZB(t) {
  return t.type_id === 1 ? t.slugline !== void 0 && (t.slugline === null || t.slugline.trim().length === 0 || t.slugline.trim() === "МОЛНИЯ" || t.slugline.trim() === "FLASH") && (t.language_id === 1 ? t.slugline = "МОЛНИЯ" : t.slugline = "FLASH") : t.slugline && (t.slugline.trim() === "МОЛНИЯ" || t.slugline.trim() === "FLASH") && (t.slugline = ""), t;
}
function jct(t, e) {
  return t = t && `${t}. `, e = e && ` ${e}`, `${t}${on(/* @__PURE__ */ new Date(), "d MMMM", { locale: xn })}.${e} -`;
}
async function UI(t, e, n, r = !1) {
  if (n.dateline === "" || t)
    return n.dateline = "", n;
  if (n.type_id === 10 && !r)
    return n.dateline = null, n;
  if (n.dateline !== null)
    return n;
  const s = e.default_dateline_city || "", i = e.default_dateline_agency || "";
  return n.dateline = n.type_id === 1 ? null : jct(s, i), n;
}
async function Wct(t) {
  let e = await Kn.process("trimHTML", t.body);
  return t.type_id === 1 ? e && e.length === 0 && (t.body = "<br><br>ИНТЕРФАКС") : e === "ИНТЕРФАКС" && (t.body = ""), t;
}
async function Hct(t) {
  return t.publish_at !== null && (t.publish_at = Go(t.publish_at)), t;
}
async function Vct(t, e = {}, { isRevocation: n = !1, userProfile: r = null }) {
  return e = {
    id: null,
    news_id: null,
    parent_news_id: null,
    created_at: Date.now().toLocaleString(),
    user: {},
    authors: [],
    status_id: 1,
    type_id: 1,
    language_id: 1,
    number: 1,
    slugline: null,
    header: null,
    trashline: null,
    dateline: null,
    body: null,
    background: null,
    publish_at: null,
    is_postponed: !1,
    codes: [],
    ...e
  }, e = await YB(
    Hct,
    ZB,
    UI.bind(null, n, r),
    Wct
  )(e), {
    id: qS(),
    newsItemId: t,
    synced: !1,
    version: e
  };
}
async function Mb(t, e, n = null, r = null) {
  const s = Dt(t, { draftId: n, newsItemId: r });
  if (s) {
    if ([2, 3, 5, 6, 7].includes(s.version.type_id)) {
      let i = ["subheadline"];
      (s.version.type_id === 2 || s.version.type_id === 3) && i.push("trashline"), i.forEach(async (o) => {
        (await Kn.process("trimHTML", s.version[o])).length && e("setBlockVisibility", {
          draftId: n,
          newsItemId: r,
          blockName: o,
          value: !0
        });
      });
    }
    if ([10].includes(s.version.type_id)) {
      const i = ["dateline", "body"];
      ["subheadline", "trashline", "dateline", "body"].forEach(async (a) => {
        await Kn.process("trimHTML", s.version[a]) ? e("setBlockVisibility", {
          draftId: n,
          newsItemId: r,
          blockName: a,
          value: !0
        }) : i.includes(a) && e("setBlockVisibility", {
          draftId: n,
          newsItemId: r,
          blockName: a,
          value: !1
        });
      });
    }
    [10].includes(s.version.type_id) || ["dateline", "body"].forEach(async (o) => {
      e("setBlockVisibility", {
        draftId: n,
        newsItemId: r,
        blockName: o,
        value: !0
      });
    });
  }
}
async function MD(t, e, n, r) {
  const s = Ie("drafts"), i = Dt(t, { draftId: n, newsItemId: r });
  r = r ?? i.newsItemId;
  const { slugline: o, dateline: a } = await YB(
    ZB,
    UI.bind(
      null,
      s.news.getIsNewsItemIsRevocation(r),
      s.userProfile.getProfile
    )
  )({ ...i.version });
  return e("updateData", {
    draftId: n,
    newsItemId: r,
    data: { slugline: o, dateline: a }
  });
}
const zct = {
  async create({ commit: t, dispatch: e, state: n }, { newsItemId: r, version: s } = {}) {
    const i = Ie("drafts"), o = await Vct(r, s, {
      userProfile: i.userProfile.getProfile,
      isRevocation: i.news.getIsNewsItemIsRevocation(r)
    });
    return Al.createQueue(r), t(gB, { newsItemId: r, draft: o }), t(_B, { newsItemId: r, typeId: o.version.type_id }), Mb(n, e, o.id, r), o;
  },
  setDraftForNewsItem({ commit: t }, { newsItemId: e, draftId: n } = {}) {
    t(bB, { newsItemId: e, draftId: n });
  },
  setDraftVersion({ state: t, commit: e, dispatch: n }, { draftId: r = null, newsItemId: s = null, version: i, timestamp: o = null } = {}) {
    const a = Dt(t, { draftId: r, newsItemId: s });
    if (a) {
      if (o = o || 0, t.updatesMap[a.id] > o)
        return;
      e(yB, { draftId: a.id, version: i }), e(GB, { draftId: r, timestamp: o }), Mb(t, n, r, s);
    }
  },
  saveDraft({ state: t, dispatch: e }, { newsItemId: n = null, draftId: r = null } = {}) {
    const s = Dt(t, { newsItemId: n, draftId: r });
    n === null && (n = s.newsItemId);
    const i = Ie("drafts");
    return new Promise((o) => {
      s ? Al.addEvent(n, {
        type: "save",
        handler: async () => {
          const a = await vo(s.version), l = i.news.getNewsItemCurrentVersion(n);
          if (![1, 3, 6].includes(l.status_id))
            return o(null);
          const c = await $e.news.update(n, a);
          if (c != null && c.errors)
            c.errors.forEach((u) => {
              Ie("drafts").messages.addMessage({
                type: "error",
                text: u.detail || u.title
              });
            });
          else {
            const u = c.version;
            s.version.entities.length !== u.entities.length && e("setDraftVersion", {
              draftId: s.id,
              version: u,
              timestamp: Date.now()
            });
          }
          return o(c), c;
        },
        resolver(a) {
          o(a);
        }
      }) : o(null);
    });
  },
  async updateLang({ dispatch: t, commit: e, state: n }, { draftId: r = null, newsItemId: s = null, value: i } = {}) {
    e(xB, { draftId: r, newsItemId: s, value: i }), await MD(n, t, r, s), t("saveDraft", { newsItemId: s, draftId: r });
  },
  async updateType({ state: t, dispatch: e, commit: n }, { draftId: r = null, newsItemId: s = null, value: i } = {}) {
    console.log("updateType"), n(CB, { draftId: r, newsItemId: s, value: i }), await MD(t, e, r, s), await Mb(t, e, r, s), e("saveDraft", { newsItemId: s, draftId: r });
  },
  async setBlockVisibility({ state: t, commit: e, dispatch: n }, { draftId: r, newsItemId: s, blockName: i, value: o } = {}) {
    const a = Ie("drafts"), l = Dt(t, { newsItemId: s, draftId: r });
    if (l) {
      if (l.version.type_id === 10 && i === "dateline" && o) {
        const c = await UI.bind(
          null,
          a.news.getIsNewsItemIsRevocation(s),
          a.userProfile.getProfile
        )({ ...l.version }, !0);
        n("updateData", {
          draftId: r,
          newsItemId: s,
          data: { dateline: c.dateline }
        });
      }
      e(wB, {
        draftId: r,
        newsItemId: s,
        blockName: i,
        value: o
      });
    }
  },
  setBlockInitialized({ commit: t }, e) {
    t(SB, e);
  },
  setBlockDisabled({ commit: t }, { draftId: e, newsItemId: n, blockName: r, value: s } = {}) {
    t(IB, {
      draftId: e,
      newsItemId: n,
      blockName: r,
      value: s
    });
  },
  updateData({ commit: t }, { draftId: e = null, newsItemId: n = null, data: r } = {}) {
    t(EB, { draftId: e, newsItemId: n, data: r });
  },
  async deleteDraft({ commit: t }, { newsItemId: e, draftId: n } = {}) {
    await Al.waitForAllEventsHandled(e), Al.deleteQueue(e), t(vB, { newsItemId: e, draftId: n });
  },
  addAuthors({ commit: t }, { newsItemId: e = null, draftId: n = null, authors: r } = {}) {
    t(OB, { newsItemId: e, draftId: n, authors: r });
  },
  deleteAuthor({ commit: t }, { newsItemId: e = null, draftId: n = null, userId: r } = {}) {
    t(MB, { newsItemId: e, draftId: n, userId: r });
  },
  setValidationErrors({ state: t, commit: e }, { draftId: n, errors: r } = {}) {
    r.forEach((s) => {
      var i, o;
      if (!s.block && ((i = s.source) != null && i.pointer)) {
        const a = (o = s.source) == null ? void 0 : o.pointer.split("/"), l = a[a.length - 1], c = Object.values(t.presets);
        s.level = "error";
        for (let u of c)
          if (u.includes(l)) {
            s.block = l;
            break;
          }
      }
    }), e(RB, { draftId: n, errors: r });
  },
  async validate({ state: t }, { newsItemId: e, draftId: n } = {}) {
    let r = t.items[n];
    const s = await vo(r.version);
    return $e.news.validate(e, s);
  },
  async annotateForbidden({ state: t, dispatch: e }, { newsItemId: n }) {
    const r = Dt(t, { newsItemId: n });
    if (!r) return;
    const s = await vo(r.version), i = await $e.news.annotateForbidden(n, {
      version: s
    });
    i.errors || await e("setDraftVersion", {
      draftId: r.id,
      version: i.version,
      timestamp: Date.now()
    });
  }
}, Uct = {
  async addCodes({ state: t, commit: e, getters: n }, { draftId: r = null, newsItemId: s = null, codeIds: i, inTextCheck: o = !1 }) {
    if (r || (s ?? null) && (r = t.newsMap[s]), s === null && (r ?? null) && (s = t.items[r].newsItemId), !r || !s) return;
    o && e(PB, { draftId: r, codeIds: i });
    const a = n.codesForDraft(r).map((u) => u.id), l = un(
      i.filter((u) => !a.includes(u))
    );
    return l.length === 0 ? null : (l.forEach((u) => {
      const d = Ie("drafts").codes.allCodes[u];
      e(TB, { draftId: r, code: d });
    }), (await $e.news.addCodes(s, l)).errors && l.forEach((u) => {
      e(ew, { draftId: r, codeId: u });
    }), l);
  },
  async deleteCodes({ state: t, commit: e, getters: n }, { newsItemId: r = null, draftId: s = null, codeIds: i, inTextCheck: o = !1 }) {
    if ((r ?? null) && (s = t.newsMap[r]), r === null && s && (r = t.items[s].newsItemId), !s || !r) return;
    const a = n.codesForDraft(s).map((u) => u.id), l = un(
      i.filter((u) => a.includes(u))
    );
    return o && i.forEach((u) => {
      e(kB, { draftId: s, codeId: u });
    }), l.length === 0 ? void 0 : (l.forEach((u) => {
      e(ew, { draftId: s, codeId: u });
    }), await $e.news.deleteCodes(r, l));
  },
  async predictCodes({ state: t, commit: e }, { newsItemId: n = null, draftId: r = null, limit: s = 8 }) {
    var d;
    const i = Dt(t, { newsItemId: n, draftId: r });
    if (!i) return;
    const o = i.version.codes.map(({ code: f }) => f.id), a = ((d = t.predictCodesMap[i.id]) == null ? void 0 : d.deleted) ?? [], l = un([...o, ...a]), c = {
      limit: s,
      exclude_code_ids: l,
      news: {
        slugline: i.version.slugline || "",
        headline: i.version.headline || "",
        subheadline: i.version.subheadine || "",
        trashline: i.version.trashline || "",
        dateline: i.version.dateline || "",
        body: i.version.body || ""
      }
    }, u = await $e.codes.predictCodes(c);
    return u.data.forEach((f) => !f.code.name && (f.code.name = f.code.name_ru)), u && u.data && e(tw, { draftId: i.id, codes: u.data }), u;
  },
  setPredictedCodes({ commit: t }, { newsItemId: e, draftId: n, codes: r }) {
    t(tw, { newsItemId: e, draftId: n, codes: r });
  },
  addPredictedAdded({ commit: t }, { newsItemId: e, draftId: n, codeIds: r }) {
    t(NB, { newsItemId: e, draftId: n, codeIds: r });
  },
  removePredictedAdded({ commit: t }, { newsItemId: e, draftId: n, codeId: r }) {
    t(DB, { newsItemId: e, draftId: n, codeId: r });
  },
  addPredictedDeleted({ commit: t }, { newsItemId: e, draftId: n, codeId: r }) {
    t($B, { newsItemId: e, draftId: n, codeId: r });
  },
  removePredictedDeleted({ commit: t }, { newsItemId: e, draftId: n, codeId: r }) {
    t(AB, { newsItemId: e, draftId: n, codeId: r });
  },
  async annotate({ state: t, dispatch: e }, { newsItemId: n, keepCodeIds: r = [] }) {
    const s = Dt(t, { newsItemId: n });
    if (s)
      return new Promise((i) => {
        Al.addEvent(n, {
          type: "annotation",
          handler: async () => {
            const o = await vo(s.version), a = await $e.news.annotate(n, {
              version: o,
              keep_code_ids: r
            });
            return a != null && a.errors ? a.errors.forEach((l) => {
              Ie("drafts").messages.addMessage({
                type: "error",
                text: l.detail || l.title
              });
            }) : (await e("setDraftVersion", {
              draftId: s.id,
              version: a.version,
              timestamp: Date.now()
            }), e("predictCodes", { draftId: s.id })), i(a), a;
          }
        });
      });
  }
}, Gct = {
  setEmbargoForm({ commit: t }, { draftId: e, value: n }) {
    t(LB, { draftId: e, value: n }), n && t(FB, e);
  },
  setEmbargoValid({ commit: t }, { draftId: e, value: n }) {
    t(Fc, { draftId: e, value: n });
  },
  validateEmbargo({ state: t, commit: e }, { draftId: n = null, newsItemId: r = null } = {}) {
    const s = Dt(t, { draftId: n, newsItemId: r });
    if (s != null && s.version) {
      if (n === null && (n = s.id), s.version.publish_at === null) {
        e(Fc, { draftId: n, value: !0 });
        return;
      }
      const i = /* @__PURE__ */ new Date();
      new Date(s.version.publish_at) <= i && !s.version.is_postponed ? e(Fc, { draftId: n, value: !1 }) : e(Fc, { draftId: n, value: !0 });
    } else
      e(Fc, { draftId: n, value: !0 });
  },
  async updateEmbargo({ dispatch: t, commit: e }, { draftId: n = null, newsItemId: r = null, value: s }) {
    e(Q1, { draftId: n, newsItemId: r, value: s }), e(q1, { draftId: n, newsItemId: r, value: !1 }), t("validateEmbargo", { draftId: n, newsItemId: r });
  },
  updatePostponed({ dispatch: t, commit: e }, { draftId: n = null, newsItemId: r = null, value: s }) {
    e(q1, { draftId: n, newsItemId: r, value: s }), e(Q1, { draftId: n, newsItemId: r, value: null }), t("validateEmbargo", { draftId: n, newsItemId: r });
  },
  setEmbargoNotSaved({ commit: t }, { draftId: e, value: n }) {
    t(BB, { draftId: e, value: n });
  },
  setEmbargoConfirmOpen({ commit: t }, { draftId: e, value: n }) {
    t(jB, { draftId: e, value: n });
  },
  setEmbargoStateController({ commit: t }, e) {
    t(WB, e);
  }
}, Yct = {
  addPubCode({ commit: t }, { draftId: e, codeId: n }) {
    t(HB, { id: e, codeId: n });
  },
  removePubCode({ commit: t }, { draftId: e, codeId: n }) {
    t(VB, { id: e, codeId: n });
  },
  enablePublishMode({ commit: t }, { newsItemId: e = null, draftId: n = null }) {
    t(zB, { newsItemId: e, draftId: n });
  },
  disablePublishMode({ commit: t }, { newsItemId: e = null, draftId: n = null }) {
    t(UB, { newsItemId: e, draftId: n });
  }
}, Zct = {
  init({ commit: t }) {
    t(mB, rt.READY);
  },
  ...zct,
  ...Uct,
  ...Gct,
  ...Yct
};
function RD(t, e) {
  const n = t.user.name.toLowerCase(), r = e.user.name.toLowerCase();
  return n === r ? 0 : n > r ? 1 : -1;
}
function Xct(t) {
  const e = t.slice(), n = e.filter((s) => !s.is_removable).sort(RD), r = e.filter((s) => s.is_removable).sort(RD);
  return [...n, ...r];
}
const Kct = {
  [yB](t, { draftId: e, version: n } = {}) {
    t.items[e] && (n.publish_at !== null && (n.publish_at = Go(n.publish_at)), t.items[e].version = n);
  },
  [_B](t, { newsItemId: e, typeId: n }) {
    const r = Dt(t, { newsItemId: e });
    r && U.set(t.blocksMap, r.id, ju(n));
  },
  [wB](t, { draftId: e, newsItemId: n, blockName: r, value: s } = {}) {
    const i = Dt(t, { draftId: e, newsItemId: n });
    if (i) {
      const a = t.blocksMap[i.id].find((l) => l.type === r);
      a && (a.visible = s);
    }
  },
  [SB](t, { draftId: e, blockName: n, value: r } = {}) {
    const s = Dt(t, { draftId: e });
    if (s) {
      const o = t.blocksMap[s.id].find((a) => a.type === n);
      o && (o.initialized = r);
    }
  },
  [IB](t, { draftId: e, newsItemId: n, blockName: r, value: s } = {}) {
    const i = Dt(t, { draftId: e, newsItemId: n });
    if (i) {
      const a = t.blocksMap[i.id].find((l) => l.type === r);
      a && (a.disabled = s);
    }
  },
  [Rct](t, { draftId: e, synced: n }) {
    t.items[e] && (t.items[e].synced = n);
  },
  [gB](t, { newsItemId: e, draft: n }) {
    U.set(t.items, n.id, n), U.set(t.newsMap, e, n.id), U.set(t.embargoFormsMap, n.id, !1), U.set(t.textCodesMap, n.id, []), U.set(t.validationErrorsMap, n.id, []);
  },
  [bB](t, { newsItemId: e, draftId: n }) {
    U.set(t.newsMap, e, n);
  },
  [vB](t, { draftId: e, newsItemId: n }) {
    !n && e && (n = Object.keys(t.newsMap).find(
      (r) => t.newsMap[r] === e
    )), e || (e = t.newsMap[n]), U.delete(t.items, e), U.delete(t.newsMap, n), U.delete(t.embargoFormsMap, e), U.delete(t.embargoValidMap, e), U.delete(t.textCodesMap, e), U.delete(t.validationErrorsMap, e), U.delete(t.embargoStateMap, e), U.delete(t.updatesMap, e);
  },
  [EB](t, { draftId: e = null, newsItemId: n = null, data: r = {} }) {
    const s = Dt(t, { newsItemId: n, draftId: e });
    if (s) {
      s.version.publish_at !== null && (s.version.publish_at = Go(s.version.publish_at)), Object.entries(r).forEach(([o, a]) => {
        s.version[o] ? s.version[o] = a : U.set(s.version, o, a);
      });
      const i = Date.now();
      U.set(t.updatesMap, e, i);
    }
  },
  [RB](t, { draftId: e, errors: n } = {}) {
    U.set(t.validationErrorsMap, e, n);
  },
  [OB](t, { newsItemId: e, draftId: n, authors: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s != null && s.version && U.set(
      s.version,
      "authors",
      Xct(Gf([...s.version.authors, ...r], "user.id"))
    );
  },
  [MB](t, { newsItemId: e, draftId: n, userId: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s != null && s.version && (s.version.authors = s.version.authors.filter(
      ({ user: i }) => i.id !== r
    ));
  },
  [CB](t, { newsItemId: e = null, draftId: n = null, value: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s && (s.version.type_id = r);
  },
  [xB](t, { newsItemId: e = null, draftId: n = null, value: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s && (s.version.language_id = r);
  },
  [q1](t, { newsItemId: e = null, draftId: n = null, value: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s && (s.version.is_postponed = r);
  },
  [Q1](t, { newsItemId: e = null, draftId: n = null, value: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s && (s.version.publish_at = r);
  },
  [LB](t, { draftId: e, value: n }) {
    U.set(t.embargoFormsMap, e, n);
  },
  [Fc](t, { draftId: e, value: n }) {
    U.set(t.embargoValidMap, e, n);
  },
  [FB](t, e) {
    U.set(t.embargoStateMap, e, {
      notSaved: !1,
      confirmOpen: !1,
      controller: new AbortController()
    });
  },
  [BB](t, { draftId: e, value: n }) {
    U.set(t.embargoStateMap, e, {
      ...t.embargoStateMap[e],
      notSaved: n
    });
  },
  [jB](t, { draftId: e, value: n }) {
    U.set(t.embargoStateMap, e, {
      ...t.embargoStateMap[e],
      confirmOpen: n
    });
  },
  [WB](t, e) {
    U.set(t.embargoStateMap, e, {
      ...t.embargoStateMap[e],
      controller: new AbortController()
    });
  },
  [GB](t, { draftId: e, timestamp: n }) {
    U.set(t.updatesMap, e, n);
  }
}, Jct = {
  [Fct](t, { draftId: e = null, newsItemId: n = null, codeIds: r = [] }) {
    const s = Dt(t, { newsItemId: n, draftId: e });
    s && U.set(t.textCodesMap, s.id, r);
  },
  [PB](t, { draftId: e = null, newsItemId: n = null, codeIds: r }) {
    const s = Dt(t, { newsItemId: n, draftId: e });
    if (!s) return;
    t.textCodesMap[s.id] || U.set(t.textCodesMap, s.id, []);
    const i = un(t.textCodesMap[s.id].concat(r));
    t.textCodesMap[s.id] = i;
  },
  [kB](t, { newsItemId: e = null, draftId: n = null, codeId: r }) {
    const s = Dt(t, { newsItemId: e, draftId: n });
    s && t.textCodesMap[s.id] && (t.textCodesMap[s.id] = t.textCodesMap[s.id].filter((i) => i !== r));
  },
  [Bct](t, { draftId: e = null, newsItemId: n = null, codeId: r }) {
    const s = Dt(t, { newsItemId: n, draftId: e });
    s && t.textCodesMap[s.id] && (t.textCodesMap[s.id] = t.textCodesMap[s.id].filter((i) => i !== r));
  },
  [TB](t, { draftId: e = null, newsItemId: n = null, code: r }) {
    var a, l;
    const s = r.id, i = Dt(t, { newsItemId: n, draftId: e }), o = (l = (a = t.items[i.id]) == null ? void 0 : a.version) == null ? void 0 : l.codes;
    o != null && o.find(({ code: c }) => c.id === s) || t.items[i.id].version.codes.push({ code: { ...r } });
  },
  [ew](t, { draftId: e = null, newsItemId: n = null, codeId: r }) {
    const s = Dt(t, { newsItemId: n, draftId: e });
    if (!s) return;
    const i = s.version.codes.filter(
      ({ code: o }) => o.id !== r
    );
    U.set(s.version, "codes", i);
  },
  [Lct](t, { draftId: e = null, newsItemId: n = null, codes: r }) {
    const s = Dt(t, { newsItemId: n, draftId: e });
    s && (t.newsMap[s.id].codes = r);
  },
  [tw](t, { newsItemId: e = null, draftId: n = null, codes: r }) {
    const s = r.sort((o, a) => a.proba - o.proba), i = Dt(t, { newsItemId: e, draftId: n });
    i && (t.predictCodesMap[i.id] ? U.set(t.predictCodesMap[i.id], "codes", s) : U.set(t.predictCodesMap, n, {
      codes: s,
      added: [],
      deleted: []
    }));
  },
  [NB](t, { newsItemId: e = null, draftId: n = null, codeIds: r }) {
    var o;
    const s = Dt(t, { newsItemId: e, draftId: n });
    (o = t.predictCodesMap[s == null ? void 0 : s.id]) != null && o.added && r.forEach((a) => {
      t.predictCodesMap[s.id].added.find((l) => l === a) || t.predictCodesMap[s.id].added.push(a);
    });
  },
  [$B](t, { newsItemId: e = null, draftId: n = null, codeId: r }) {
    var o;
    const s = Dt(t, { newsItemId: e, draftId: n });
    (o = t.predictCodesMap[s == null ? void 0 : s.id]) != null && o.deleted && (t.predictCodesMap[s.id].deleted.find((a) => a === r) || t.predictCodesMap[s.id].deleted.push(r));
  },
  [DB](t, { newsItemId: e = null, draftId: n = null, codeId: r }) {
    var o;
    const s = Dt(t, { newsItemId: e, draftId: n });
    (o = t.predictCodesMap[s == null ? void 0 : s.id]) != null && o.added && (t.predictCodesMap[s.id].added = t.predictCodesMap[s.id].added.filter((a) => a !== r));
  },
  [AB](t, { newsItemId: e = null, draftId: n = null, codeId: r }) {
    var o;
    const s = Dt(t, { newsItemId: e, draftId: n });
    (o = t.predictCodesMap[s == null ? void 0 : s.id]) != null && o.deleted && (t.predictCodesMap[s.id].deleted = t.predictCodesMap[s.id].deleted.filter((a) => a !== r));
  }
}, qct = {
  [zB](t, { newsItemId: e, draftId: n }) {
    const r = Dt(t, { newsItemId: e, draftId: n });
    r && U.set(t.publicationMap, r.id, []);
  },
  [UB](t, { newsItemId: e, draftId: n }) {
    const r = Dt(t, { newsItemId: e, draftId: n });
    r && U.delete(t.publicationMap, r.id);
  },
  [HB](t, { id: e, codeId: n }) {
    t.publicationMap[e] || U.set(t.publicationMap, e, []), t.publicationMap[e].includes(n) || t.publicationMap[e].push(n);
  },
  [VB](t, { id: e, codeId: n }) {
    const r = t.publicationMap[e].findIndex(
      (s) => s === n
    );
    t.publicationMap[e].splice(r, 1);
  }
}, Qct = {
  [mB](t, e) {
    t.init = e;
  },
  ...Kct,
  ...Jct,
  ...qct
}, eut = Dn(["news", "drafts"], {
  namespaced: !0,
  state: {
    presets: Yf(),
    blocks: ju(),
    updatesMap: {},
    items: {},
    newsMap: {},
    blocksMap: {},
    embargoFormsMap: {},
    embargoValidMap: {},
    embargoStateMap: {},
    publicationMap: {},
    textCodesMap: {},
    predictCodesMap: {},
    validationErrorsMap: {}
  },
  actions: Zct,
  getters: Mct,
  mutations: Qct,
  dependencies: {
    root: {
      getters: ["getIsNewsItemPanelFocused"]
    },
    auth: {
      getters: ["getUserId"]
    },
    userProfile: {
      getters: ["getProfile"]
    },
    news: {
      getters: ["getIsNewsItemIsRevocation", "getNewsItemCurrentVersion"]
    },
    codes: {
      getters: ["allCodes"]
    },
    messages: {
      actions: ["addMessage"]
    },
    uiState: {
      getters: ["isEditorFocused"]
    }
  }
}), XB = "ADD_NEWS_LINKS", KB = "REMOVE_NEWS_LINKS", JB = "SET_NEWS_ITEM_LINKS", qB = "REMOVE_NEWS_ITEM_LINK", tut = {
  async fetchLinkedNews(t, e) {
    const n = await $e.news.fetchLinkedNews(e);
    if (n.errors) return;
    const r = Ie("links");
    ["child_links", "parent_links"].forEach((s) => {
      n.data[s].forEach((i) => {
        r.news.getNewsItemById(i.news.id) || r.news.setNewsItem(i.news);
      });
    });
  },
  addNewsLinks({ commit: t }, e) {
    t(XB, e);
  },
  removeNewsLinks({ commit: t }, e) {
    t(KB, e);
  },
  async removeNewsItemLink({ commit: t }, { newsItemId: e, childNewsItemId: n, linkTypeId: r }) {
    const s = await $e.news.deleteNewsItemLink(
      e,
      n,
      r
    );
    return s.errors || t(qB, { newsItemId: e, childNewsItemId: n, linkTypeId: r }), s;
  }
}, nut = {
  getChildLinksById: (t) => (e) => {
    const n = Ie("links");
    return (t.map[e] || []).filter(
      (r) => ["REPUBLICATION", "REPUBLICATION_UNEDITED"].map((s) => n.references.newsLinkTypeByName[s].id).includes(r.type_id)
    );
  },
  getHasChildLinksById: (t, e) => (n) => e.getChildLinksById(n).length,
  getPublishedChildLinksById: (t, e) => (n) => e.getChildLinksById(n).filter((r) => r.is_published),
  getHasPublishedChildLinksById: (t, e) => (n) => e.getPublishedChildLinksById(n).length,
  getNewsItemExtensions: (t) => (e) => {
    const n = Ie("links");
    return (t.map[e] || []).filter(
      (r) => r.type_id === n.references.newsLinkTypeByName.EXTENSION.id
    );
  }
}, rut = {
  [XB](t, e) {
    const n = {};
    Object.keys(e).forEach((r) => {
      n[r] = AS(
        [...e[r], ...t.map[r] || []],
        (s, i) => s.news_id === i.news_id
      );
    }), t.map = {
      ...t.map,
      ...n
    };
  },
  [KB](t, e) {
    e.forEach((n) => {
      t.map[n] && delete t.map[n], Object.keys(t.map).forEach((r) => {
        t.map[r] = t.map[r].filter((s) => s.news_id !== n);
      });
    });
  },
  [JB](t, { newsItemId: e, links: n }) {
    t.map[e] && U.set(t.map, e, n);
  },
  [qB](t, { newsItemId: e, childNewsItemId: n, linkTypeId: r }) {
    if (t.map[e]) {
      const s = t.map[e].findIndex(
        (i) => i.news_id === n && i.type_id === r
      );
      s !== -1 && t.map[e].splice(s, 1);
    }
  }
}, sut = Dn(["news", "links"], {
  namespaced: !0,
  state: {
    map: {}
  },
  actions: tut,
  getters: nut,
  mutations: rut,
  dependencies: {
    references: {
      getters: ["newsLinkTypeByName"]
    },
    news: {
      getters: ["getNewsItemById"],
      actions: ["setNewsItem"]
    }
  }
}), QB = "SET_NEWS_SEARCH_PARAMS", ej = "SET_NEWS_SEARCH_IS_SETTING_PARAMS", tj = "SET_NEWS_SEARCH_VERSIONS", iut = {
  addSearchVersions({ commit: t }, e) {
    t(tj, e);
  },
  setSearchParams({ commit: t }, e) {
    t(QB, e);
  },
  setSettingSearchParams({ commit: t }, e) {
    t(ej, e);
  },
  selectSearchNewsItem(t, { entry: e, panelId: n }) {
    if (!e) return;
    const r = Ie("search"), s = r.panels.getRootPanelById(n), i = r.news.getNewsItemById(e.id);
    r.panels.selectPublishedSearchNewsItem({
      entry: i,
      panel: s
    });
    const o = r.panels.getPanelIndex(n);
    r.panels.setDesiredScrollIndex(o);
  }
}, out = {
  getSearchNewsVersion(t) {
    return (e) => t.versions[e] || null;
  },
  getSearchParams(t) {
    return t.params;
  },
  getSettingSearchParams(t) {
    return t.isSettingParams;
  }
}, aut = {
  [QB](t, e) {
    t.params = {
      ...t.params,
      ...e
    };
  },
  [ej](t, e) {
    t.isSettingParams = e;
  },
  [tj](t, e) {
    t.versions = {
      ...t.versions,
      ...e
    };
  }
}, lut = Dn(["news", "search"], {
  namespaced: !0,
  state: {
    isFetching: !1,
    isSettingParams: !1,
    params: {
      query: [],
      queryGroupOperators: [],
      codes: [],
      authors: [],
      interval: 0,
      range: null,
      field: null,
      type: null,
      language: null,
      status: null,
      link: null
    },
    versions: {}
  },
  actions: iut,
  getters: out,
  mutations: aut,
  dependencies: {
    news: {
      getters: ["getNewsItemById"]
    },
    panels: {
      getters: ["getRootPanelById", "getPanelIndex"],
      actions: [
        "selectPanelListEntry",
        "setDesiredScrollIndex",
        "selectPublishedSearchNewsItem"
      ]
    }
  }
}), Lh = "SET_NEWS_VERSION", nj = "SET_NEWS_VERSIONS", rj = "NEWS_ITEM_VERSION_PUSH", nw = "NEWS_ITEM_VERSION_UNSHIFT", sj = "NEWS_ITEM_VERSIONS_PUSH", cut = {
  setVersion({ commit: t }, { newsItemId: e, version: n }) {
    t(Lh, { newsItemId: e, version: n });
  },
  setVersions({ commit: t }, e) {
    t(nj, e);
  },
  addNewsItemVersion({ commit: t }, { newsItemId: e, versionId: n, versionNum: r }) {
    t(rj, { newsItemId: e, versionId: n, versionNum: r });
  },
  addNewsItemsVersions({ commit: t }, e) {
    t(sj, e);
  },
  async getPrevious({ commit: t }, e) {
    const n = await $e.news.fetchPreviousVersion(e);
    return n.status !== 404 && (t(Lh, n), t(nw, {
      newsItemId: e,
      versionId: n.id
    })), n;
  },
  async getPreviousFromASOI({ commit: t }, e) {
    const n = await $e.news.fetchPreviousVersionFromASOI(e);
    return n.status !== 404 && (t(Lh, n), t(nw, {
      newsItemId: e,
      versionId: n.id
    })), n;
  }
};
function LD(t, e) {
  e.publish_at !== null && (e.publish_at = Go(e.publish_at)), U.set(t.items, e.id, e);
}
function FD(t, { newsItemId: e, versionId: n, versionNum: r }) {
  if (!t.newsMap[e])
    U.set(t.newsMap, e, [n]);
  else if (!t.newsMap[e].includes(n)) {
    const [s] = t.newsMap[e].slice(-1), i = t.items[s];
    i || console.error("Version.id is pushed, but version object not set!"), r > ((i == null ? void 0 : i.number) ?? 0) ? t.newsMap[e].push(n) : t.newsMap[e].splice(t.newsMap[e].length - 1, 0, n);
  }
}
const uut = {
  [Lh](t, { version: e, newsItemId: n }) {
    LD(t, e);
  },
  [rj](t, e) {
    FD(t, e);
  },
  [nw](t, { newsItemId: e, versionId: n }) {
    t.newsMap[e] || U.set(t.newsMap, e, []), !t.newsMap[e].includes(n) && t.newsMap[e].unshift(n);
  },
  [nj](t, e) {
    e.forEach((n) => LD(t, n));
  },
  [sj](t, e) {
    e.forEach((n) => FD(t, n));
  }
}, dut = {
  /**
   * Получить список id авторов версии новости
   * @returns    {number[]}
   */
  versionAuthorsIds: (t) => (e) => {
    var r;
    const n = t.items[e];
    return (r = n == null ? void 0 : n.authors) == null ? void 0 : r.map(({ user: s } = {}) => s.id);
  },
  /**
   * Получить список полных имён авторов версии новости
   * @returns    {string[]}
   */
  versionAuthorsNames: (t) => (e) => {
    var r;
    const n = t.items[e];
    return ((r = n == null ? void 0 : n.authors) == null ? void 0 : r.map(({ user: s } = {}) => Ps(s.name))) ?? [];
  },
  /**
   * Проверить, принадлежит ли версия новости с переданным id текущему пользователю
   * @returns    {boolean}
   */
  getIsMyNewsVersion: (t) => (e) => {
    var r;
    const n = t.items[e];
    return (r = n == null ? void 0 : n.user) != null && r.id ? n.user.id === parseInt(Ie("versions").auth.getUserId) : !1;
  },
  /**
   * Проверить может ли текущий пользователь удалить новость
   * @returns    {boolean}
   */
  getCanUserDeleteNewsVersion: (t, e) => (n) => {
    const r = t.items[n];
    return e.getIsMyNewsVersion(n) && r.status_id === Ie("versions").references.newsStatusesByName.DRAFT.id;
  },
  /**
   * Проверить может ли текущий пользователь редактировать новость
   * @returns    {boolean}
   */
  getCanUserEditNewsVersion: (t, e) => (n) => {
    const r = t.items[n];
    if (r && r.status_id) {
      const s = Ie("versions").references.newsStatuses[r.status_id], i = ["DRAFT", "ON_EDIT"].includes(s.name);
      return e.getIsMyNewsVersion(n) && i;
    }
    return !1;
  },
  getIsRepublishDisabled: (t) => (e) => {
    const n = t.newsMap[e];
    if (n != null && n.length) {
      const r = t.items[n[0]];
      if (r)
        return r.type_id === Ie("versions").references.newsTypesByName.ISSUE.id;
    }
    return !0;
  },
  /**
   * Проверяет, что версия с данным `id` является экспрессом или молнией
   *
   * @returns {function(type_id: ID): boolean}
   */
  getIsUrgentVersionType: () => (t) => {
    const e = Ie("versions");
    return [
      e.references.newsTypesByName.EXPRESS.id,
      e.references.newsTypesByName.FLASH.id
    ].includes(t);
  },
  /**
   * Возвращает автора\получателя версии
   *
   * @returns {function(version: Object): String}
   */
  getVersionUserName: () => (t) => {
    var e, n, r;
    return Ps((e = t == null ? void 0 : t.user) == null ? void 0 : e.name) || ((n = t == null ? void 0 : t.recipient_group) == null ? void 0 : n.name) || Ps((r = t == null ? void 0 : t.recipient_user) == null ? void 0 : r.name) || "";
  },
  /**
   * Возвращает статус версии с именем автора\получателя
   *
   * @returns {function(version: Object): String}
   */
  getVersionStatus: (t, e) => (n) => {
    const r = Ie("versions"), s = r.references.newsStatuses[n == null ? void 0 : n.status_id];
    if (!s || !s.name) return null;
    let i = e.getVersionUserName(n);
    const o = (a, l) => a + (l ? ": " : "") + l;
    switch (s.name) {
      case "DRAFT":
        return o("В работе", i);
      case "WAITS_FOR_EDIT":
      case "ON_EDIT":
        return o(s.description, i);
      case "WAITS_FOR_PUBLICATION":
        return r.news.isNewsItemScheduled(n.news_id) ? "Отложено" : s.description;
      case "PUBLISHED":
        return r.news.getIsNewsItemRevoked(n.news_id) ? "Аннулирована" : s.description;
      default:
        return s.description;
    }
  },
  getIsStatusWaiting: () => (t) => [2, 4, 5].includes(t),
  getSortedVersions: (t) => (e) => e.sort((n, r) => new Date(t.items[r.id].created_at) - new Date(t.items[n.id].created_at))
}, fut = Dn(["news", "versions"], {
  namespaced: !0,
  state: {
    items: {},
    // version.id -> version
    newsMap: {},
    // news.id -> version.id[], MUST be ordered!
    versionNumbers: {},
    // version.id -> version.number
    blocksMap: {},
    // draft.id -> block[]
    blocks: ju()
  },
  actions: cut,
  getters: dut,
  mutations: uut,
  dependencies: {
    auth: {
      getters: ["getUserId"]
    },
    references: {
      getters: ["newsTypesByName", "newsStatuses", "newsStatusesByName"]
    },
    news: {
      getters: ["getIsNewsItemRevoked", "isNewsItemScheduled"]
    }
  }
}), BD = "NEWSITEM_HISTORY_CREATE", jD = "NEWSITEM_HISTORY_REMOVE", WD = "NEWSITEM_HISTORY_REMOVE_ALL", HD = "NEWSITEM_HISTORY_SET_HISTORY", Rb = "NEWSITEM_HISTORY_SET_SELECTED_VERSION", Lb = "NEWSITEM_HISTORY_SET_INITIAL_LOADED", put = Dn(["news", "newsItemHistory"], {
  namespaced: !0,
  state: {
    newsItems: {
      // Структура стора
      // ----------------------------------
      // newsItemId: {
      //   history: [{diff, version},...],
      //   selectedVersion,
      //   initialLoaded,
      // }
      // ----------------------------------
    }
  },
  getters: {
    get: (t) => (e) => t.newsItems[e]
  },
  mutations: {
    [BD](t, { newsItemId: e, history: n = [] }) {
      U.set(t.newsItems, e, { history: n, selectedVersion: null });
    },
    [jD](t, e) {
      U.delete(t.newsItems, e);
    },
    [WD](t) {
      t.newsItems = {};
    },
    [HD](t, { newsItemId: e, history: n }) {
      n && U.set(t.newsItems[e], "history", n);
    },
    [Rb](t, { newsItemId: e, versionId: n }) {
      n && U.set(t.newsItems[e], "selectedVersion", n);
    },
    [Lb](t, { newsItemId: e, value: n }) {
      U.set(t.newsItems[e], "initialLoaded", n);
    }
  },
  actions: {
    // нет отдельного метода create(), используется всегда update()
    async update({ state: t, commit: e }, n) {
      var s;
      const r = await $e.news.fetchHistory(n);
      if (r.status !== 404) {
        if (!t.newsItems[n]) {
          e(BD, { newsItemId: n });
          const o = (s = r.data.at(-1)) == null ? void 0 : s.version.id;
          e(Rb, { newsItemId: n, versionId: o });
        }
        const i = r.data.map((o) => (o.version.publish_at !== null && (o.version.publish_at = Go(o.version.publish_at)), o));
        e(HD, { newsItemId: n, history: i }), e(Lb, { newsItemId: n, value: !0 });
      }
    },
    setSelectedVersion({ commit: t }, { newsItemId: e, versionId: n }) {
      t(Rb, { newsItemId: e, versionId: n });
    },
    setInitialLoaded({ commit: t }, { newsItemId: e, value: n }) {
      t(Lb, { newsItemId: e, value: n });
    },
    remove({ commit: t }, e) {
      t(jD, e);
    },
    removeAll({ commit: t }) {
      t(WD);
    }
  }
}), hut = Dn(["news"], {
  namespaced: !0,
  state: Pct,
  actions: Klt,
  mutations: mct,
  getters: cct,
  modules: {
    codes: Oct,
    drafts: eut,
    links: sut,
    search: lut,
    versions: fut,
    newsItemHistory: put
  },
  dependencies: {
    root: { getters: ["getNewsItemPanel", "getDraftForNewsItem"] },
    auth: { getters: ["getUserId"] },
    userProfile: {
      getters: [
        "getColorsByType",
        "getDefaultNewsTypeId",
        "isUserInGroups",
        "isUserInGroup",
        "getProfile",
        "getDefaultRecipientId",
        "getDefaultRecipientUserId",
        "getDefaultRecipientGroupId"
      ]
    },
    references: {
      getters: [
        "newsEventTypes",
        "newsStatuses",
        "newsStatusesByName",
        "newsParentRelTypes",
        "newsParentRelTypesByName"
      ]
    },
    uiState: { actions: ["setModal"] },
    chat: { actions: ["addChatMessage", "updateChatReadMessage"] },
    leads: { actions: ["pushLead"] },
    messages: { actions: ["addMessage"] },
    shareModal: { actions: ["showShareModal"] },
    panels: {
      getters: [
        "getPanelIndex",
        "getPanelById",
        "getNewsItemPanelsCount",
        "getPanelByDataId",
        "getPanelNotification"
      ],
      actions: [
        "setPanelFocused",
        "setDesiredScrollIndex",
        "addPanel",
        "removePanel",
        "selectPublishedPanelNewsItem",
        "setPanelDataId",
        "selectEmbargoNewsItem",
        "addPanelNotification",
        "removePanelNotification"
      ]
    },
    versions: {
      getters: ["getIsMyNewsVersion"]
    }
  }
}), Fh = "NEWSBREAKS_ADD", ij = "NEWSBREAKS_MARK_AS_READ", oj = "NEWSBREAKS_DELETE", aj = "NEWSBREAKS_SET_INITIAL_LOADED", lj = "NEWSBREAK_LIST_APPEND", cj = "NEWSBREAK_LIST_SET", uj = "NEWSBREAK_LIST_UNSHIFT", dj = "NEWSBREAK_LIST_SET_NEWS_SHOWED", mut = "NEWSBREAK_LIST_POP", fj = "NEWSBREAK_LIST_REMOVE", pj = "NEWSBREAK_LIST_SET_PAUSED", rw = "NEWSBREAK_LIST_SET_HASNEW", hj = "NEWSBREAK_LIST_SET_SELECTED", mj = "NEWSBREAKS_SET_LEAD", vut = "NEWSBREAKS_SET_NEWS", GI = "NEWSBREAKS_ADD_NEWS", gut = "NEWSBREAKS_REMOVE_NEWS_ITEM", vj = "NEWSBREAK_LIST_PREPEND", gj = "NEWSBREAKS_INCREMENT_REF_COUNTER", yj = "NEWSBREAKS_DECREMENT_REF_COUNTER", bj = "NEWSBREAK_LIST_SET_INITIAL_LOADED", yut = "NEWSBREAKS_CLEAR_UNUSED", but = {
  [Fh](t, e) {
    e.forEach((n) => {
      U.set(t.items, n.id, n), t.uiState.newsShowedMap[n.id] || U.set(t.uiState.newsShowedMap, n.id, null);
    });
  },
  [ij](t, e) {
    const n = t.items[e];
    n && U.set(n, "is_read", !0);
  },
  [oj](t, e) {
    U.delete(t.items, e), U.delete(t.initialLoadedMap, e), U.delete(t.newsMap, e), U.delete(t.leadsMap, e), U.delete(t.uiState.newsShowedMap, e);
  },
  [aj](t, { newsbreakId: e, value: n }) {
    U.set(t.initialLoadedMap, e, { initialLoaded: n });
  },
  [mj](t, { newsbreakId: e, leadId: n }) {
    U.set(t.leadsMap, e, n);
  },
  [vut](t, { newsbreakId: e, newsIds: n }) {
    U.set(t.newsMap, e, n);
  },
  [GI](t, { newsbreakId: e, newsIds: n }) {
    t.newsMap[e] ? t.newsMap[e] = un(
      t.newsMap[e].concat(n).reverse()
    ).reverse() : U.set(t.newsMap, e, n);
  },
  [gut](t, { newsbreakId: e, newsId: n }) {
    t.newsMap[e] && t.newsMap[e].splice(
      t.newsMap[e].indexOf(n),
      1
    );
  },
  [lj](t, e) {
    t.list = un(t.list.concat(e));
  },
  [cj](t, e) {
    t.list = e;
  },
  [vj](t, e) {
    let n = [...t.list];
    n.unshift(...e), n = un(n), n.length > t.maxNewsbreakListLength && n.splice(t.maxNewsbreakListLength), t.list = n;
  },
  [uj](t, e) {
    t.list.includes(e) || t.list.unshift(e);
  },
  [dj](t, { newsbreakId: e, newsTypeId: n }) {
    U.set(t.uiState.newsShowedMap, e, n);
  },
  [mut](t) {
    t.list.pop();
  },
  [fj](t, e) {
    t.list = t.list.filter((n) => n !== e);
  },
  [pj](t, e) {
    t.paused = e;
  },
  [rw](t, e) {
    t.hasNew = e;
  },
  [bj](t, e) {
    t.initialLoaded = e;
  },
  [hj](t, e) {
    t.uiState.selected = e;
  },
  [gj](t, e) {
    for (let n = 0; n < e.length; n++)
      t.refs[e[n]] !== void 0 ? t.refs[e[n]]++ : U.set(t.refs, e[n], 1);
  },
  [yj](t, e) {
    for (let n = 0; n < e.length; n++)
      t.refs[e[n]] && t.refs[e[n]] > 0 ? t.refs[e[n]]-- : U.set(t.refs, e[n], 0);
  }
};
async function Fb(t, e) {
  const n = Ie("newsbreaks");
  if (e.lead) {
    const r = await Kn.process("leads", e.lead);
    n.leads.pushLead({ payload: r }), t(mj, {
      newsbreakId: e.id,
      leadId: e.lead.id
    });
  }
  e.news && e.news.length && (e.news.forEach(() => {
    n.news.setNewsItem(e.news);
  }), t(GI, {
    newsbreakId: e.id,
    newsIds: e.news.map(({ id: r }) => r)
  }));
}
const _ut = {
  async addNewsbreaks({ commit: t, getters: e }, { newsbreaks: n, reverse: r, replace: s }) {
    n && (t(Fh, n), s ? t(
      cj,
      n.map((i) => i.id)
    ) : r ? t(
      vj,
      e.getSortedNewsbreakIds(n.map((i) => i.id))
    ) : t(
      lj,
      n.map((i) => i.id)
    ), n.forEach((i) => {
      Fb(t, i);
    }));
  },
  async unshiftNewsbreak({ state: t, commit: e }, n) {
    t.paused ? e(rw, !0) : (e(Fh, [n]), e(uj, n.id), Fb(e, n));
  },
  async markNewsbreakAsRead({ commit: t }, e) {
    const n = await $e.newsbreaks.setAsRead(e);
    return n.errors || t(ij, e), n;
  },
  async rejectNewsbreak({ dispatch: t }, { newsbreakId: e, reason: n }) {
    const r = await $e.newsbreaks.reject(e, n);
    return r.errors ? r : t("deleteNewsbreak", e);
  },
  async deleteNewsbreak({ commit: t, getters: e }, n) {
    t(fj, n), t(oj, n);
    const r = e.getPanelForNewsbreakById(n);
    r && Ie("newsbreaks").panels.removePanel({ panelId: r.id });
  },
  async getNewsbreak({ commit: t }, e) {
    const n = await $e.newsbreaks.fetchOne(e);
    return n.errors ? n : (t(Fh, [n.data]), Fb(t, n.data), n.data);
  },
  async loadNewsbreaks({ dispatch: t }, { cursor: e, limit: n, reverse: r = !1, replace: s = !1 }) {
    const i = await $e.newsbreaks.fetchMore({ cursor: e, limit: n, reverse: r });
    return i.errors || t("addNewsbreaks", { newsbreaks: i.data, reverse: r, replace: s }), i;
  },
  async pickNewsbreak({ commit: t }, { newsbreakId: e, typeId: n }) {
    const r = await $e.newsbreaks.pick(e, {
      news_type_id: n
    });
    return r.errors || (Ie("newsbreaks").news.createNewsItem({ payload: r }), t(GI, {
      newsbreakId: e,
      newsIds: [r.id]
    })), r;
  },
  setNewsbreakNewsShowed({ commit: t }, { newsbreakId: e, newsTypeId: n }) {
    t(dj, { newsbreakId: e, newsTypeId: n });
  },
  processNewsbreakMessage({ dispatch: t }, { payload: e } = {}) {
    const n = Ie("newsbreaks");
    switch (n.references.newsbreakEventTypes[e.type_id].name) {
      case "READ":
        return t("unshiftNewsbreak", e.newsbreak);
      case "FORWARDED":
        return t("unshiftNewsbreak", e.newsbreak);
      case "PICKED":
        if (t("unshiftNewsbreak", e.newsbreak), e.newsbreak.news && e.newsbreak.news.length) {
          const s = { ...e.newsbreak }, i = s.news;
          delete s.news, i.forEach((o) => {
            n.news.setNewsItem({ ...o, newsbreak: s }), n.news.updateNewsItemSets({ newsItem: o });
          });
        }
        break;
      case "REJECTED":
        return t("deleteNewsbreak", e.newsbreak.id);
    }
  },
  newsbreakListSetInitialLoaded({ commit: t }, e) {
    t(bj, e);
  },
  newsbreakListSetPaused({ commit: t }, e) {
    t(pj, e);
  },
  newsbreakListSetHasNew({ commit: t }, e) {
    t(rw, e);
  },
  newsbreakListSetSelected({ commit: t }, e) {
    t(hj, e);
  },
  newsbreaksSetInitialLoaded({ commit: t }, { newsbreakId: e, value: n }) {
    t(aj, { newsbreakId: e, value: n });
  }
}, wut = {
  /** Получить количество непрочитанных инфоповодов для списка задач */
  getNewsbreaksUnreadCount: (t, e) => Object.values(t.items).filter(
    (n) => !e.getNewsbreakIsRead(n.id)
  ).length || 0,
  /**
   * Принимает id инфоповода и список новостей, привязанных к этому инфоповоду
   * @param {VuexState} state Глобальное состояние
   * @returns {function(newsbreakId: ID): NewsItem[]}
   */
  getNewsbreakNews: (t) => (e) => {
    const n = t.newsMap[e], r = Ie("newsbreaks").news.getNewsItems;
    return n ? n.filter((s) => !!r[s]).map((s) => r[s]) : [];
  },
  /**
   * Возвращает список всех новостей для ИП,
   * у которых в поле `creator` присутствует пользователь или его группа
   * @param {VuexState} state Глобальное состояние
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {function(newsbreakId: ID): NewsItem[]}
   */
  getNewsbreakNewsRelatedToUser: (t, e) => (n) => {
    const r = Ie("newsbreaks");
    return e.getNewsbreakNews(n).filter((i) => r.news.getIsNewsItemRelatedToUser(i) || r.news.getIsNewsItemCreator(i) || r.news.getIsNewsItemCreatorGroups(i));
  },
  getSortedNewsbreakIds: (t) => (e) => e.sort((n, r) => new Date(t.items[r].created_at) - new Date(t.items[n].created_at)),
  getNewsbreakMetaForCurrentUser: (t) => (e) => {
    const n = t.items[e], s = Ie("newsbreaks").auth.userId;
    return n ? n.users.filter((i) => i.user.id === s) : null;
  },
  getNewsbreakIsRead: (t, e) => (n) => {
    const r = e.getNewsbreakMetaForCurrentUser(n);
    return r && r.length ? r.find((s) => !s.is_forwarded_by && s.is_read) : !1;
  },
  getNewsbreakMetaByNb: () => (t) => {
    const n = Ie("newsbreaks").references.newsbreakStatuses;
    if (t && n) {
      const r = {};
      return Object.keys(n).forEach((s) => {
        r[n[s].name] = {
          name: n[s].name,
          label: n[s].description,
          names: []
        };
      }), t.users && t.users.length && t.users.forEach((s) => {
        r[n[s.status_id].name].names.push({
          name: Ps(s.user.name),
          isRead: s.is_read,
          isForwardedBy: !!s.is_forwarded_by
        });
      }), t.groups && t.groups.length && t.groups.forEach((s) => {
        n[s.status_id].name === "FORWARDED" && r[n[s.status_id].name].names.push({
          name: `группа ${s.group.name}`,
          isRead: s.is_read,
          isForwardedBy: !!s.is_forwarded_by
        });
      }), r;
    }
    return null;
  },
  isNewsbreakForwardedByNb: (t, e) => (n) => {
    const r = e.getNewsbreakMetaByNb(n);
    return r ? r.FORWARDED && r.FORWARDED.names.length > 0 : !1;
  },
  isNewsbreakPickedByNb: (t, e) => (n) => {
    const r = e.getNewsbreakMetaByNb(n);
    return r ? r.PICKED && r.PICKED.names.length > 0 : !1;
  },
  isNewsbreakRejectedByNb: (t, e) => (n) => {
    const r = e.getNewsbreakMetaByNb(n);
    return r ? r.REJECTED && r.REJECTED.names.length > 0 : !1;
  },
  getNewsbreakById: (t) => (e) => t.items[e] || {},
  getNewsbreakStatusByNb: (t, e) => (n) => {
    const r = e.getNewsbreakMetaByNb(n);
    let s = { names: [] };
    if (r) {
      r.REJECTED.names.length && (s = r.REJECTED), r.PICKED.names.length && (s = r.PICKED);
      const i = r.NOT_SET.names.filter(
        (o) => o.isForwardedBy
      );
      r.NOT_SET.names.length && i.length && (s = {
        label: "Передал(а)",
        name: r.NOT_SET.name,
        names: r.NOT_SET.names.filter((o) => o.isForwardedBy)
      });
    }
    return s;
  },
  getPanelForNewsbreakById: () => (t) => Ie("newsbreaks").panels.getPanelByDataId("newsbreak", t) ?? null
}, Sut = Dn(["newsbreaks"], {
  namespaced: !0,
  state: {
    list: [],
    paused: !1,
    hasNew: !1,
    initialLoaded: !1,
    initialLoadedMap: {},
    items: {},
    refs: {},
    leadsMap: {},
    newsMap: {},
    uiState: {
      selected: null,
      newsShowedMap: {}
    },
    maxNewsbreakListLength: 90
  },
  actions: _ut,
  mutations: but,
  getters: wut,
  dependencies: {
    leads: {
      actions: ["pushLead"]
    },
    panels: { getters: ["getPanelByDataId"], actions: ["removePanel"] },
    references: { getters: ["newsbreakEventTypes", "newsbreakStatuses"] },
    news: {
      getters: [
        "getNewsItems",
        "getIsNewsItemRelatedToUser",
        "getIsNewsItemCreator",
        "getIsNewsItemCreatorGroups"
      ],
      actions: ["setNewsItem", "createNewsItem", "updateNewsItemSets"]
    },
    auth: { getters: ["userId"] }
  }
}), sw = "NOTIFICATIONS_SET_DATA", _j = "NOTIFICATION_RESET_DATA", iw = "NOTIFICATIONS_SET_LOADED", ow = "NOTIFICATIONS_SET_LOADING", Gp = "NOTIFICATIONS_INIT", wj = "SET_OBJECT_LINK", Sj = "DELETE_OBJECT_LINK", Ij = "CLEAR_OBJECT_LINKS", Bb = {
  100: { objectType: "news_comment" },
  101: { objectType: "news" },
  102: { objectType: "news" },
  103: { objectType: "news" },
  104: { objectType: "news" },
  105: { objectType: "news" },
  106: { objectType: "news" },
  107: { objectType: "news" },
  200: { objectType: "asoi_note" }
}, VD = 1.5 * 60 * 60 * 1e3, Iut = [2, 3, 4, 5, 6, 7, 8, 9, 10, 13, 16, 201], zD = ({
  state: t,
  dispatch: e,
  objectType: n,
  dataPath: r,
  message: s
}) => {
  var o, a;
  const i = t.objectLinks.objectsMap[n][(a = (o = s.payload) == null ? void 0 : o[r]) == null ? void 0 : a.id];
  n === "news" && !Iut.includes(s.payload.type_id) || i && i.forEach((l) => {
    const c = t.objectLinks.items[l];
    c && e("unregisterObjectNotifications", {
      objectType: n,
      objectId: c.objectId
    });
  });
}, Eut = async (t) => {
  const e = t.type_id, n = t.news_comment_id, r = t.news_id, s = Date.parse(t.timestamp), i = `${e}:${r}:${n}`;
  return {
    typeId: e,
    objectId: r,
    commentId: n,
    title: t.title,
    body: t.body,
    tag: i,
    timestamp: s
  };
}, xut = (t) => {
  const e = Date.parse(t.timestamp), n = `${t.type_id}:${t.note_id}`;
  return {
    typeId: t.type_id,
    objectId: t.note_id,
    title: t.title,
    body: t.body,
    tag: n,
    timestamp: e
  };
}, Cut = (t) => {
  const e = t.news_id, n = Date.parse(t.timestamp), r = `${t.type_id}:${e}`;
  return {
    typeId: t.type_id,
    objectId: e,
    title: t.title,
    body: t.body,
    tag: r,
    timestamp: n
  };
};
async function jb(t, e) {
  const {
    tag: n,
    typeId: r,
    objectId: s,
    title: i,
    body: o,
    timestamp: a,
    commentId: l
  } = await e(t);
  let c = [];
  switch (r) {
    case 101:
      c.push({
        action: "take-in-work",
        title: "Взять в работу"
      });
      break;
    case 102:
      c.push({
        action: "take-in-work",
        title: "Взять в работу"
      });
      break;
    case 200:
      c.push({
        action: "take-asoi-note-in-work",
        title: "Взять в работу"
      });
      break;
  }
  const u = {
    body: o,
    data: {
      notificationId: O8(),
      typeId: r,
      objectId: s,
      commentId: l
    },
    actions: c,
    tag: n,
    requireInteraction: r !== 100,
    renotify: !0,
    silent: !1,
    timestamp: a,
    vibrate: [50, 100, 50]
  }, d = await navigator.serviceWorker.getRegistration();
  return (await d.getNotifications({ tag: n })).length || await (d == null ? void 0 : d.showNotification(i, u)), u;
}
const Tut = {
  async init({ dispatch: t, commit: e }) {
    e(Gp, rt.IN_PROGRESS);
    try {
      (await t("fetchNotificationsSettings")).data && await t("subscribeToPushEvents"), e(Gp, rt.READY);
    } catch {
      e(Gp, rt.ERROR);
    }
  },
  reset({ dispatch: t, commit: e }) {
    t("unregisterAllNotifications"), t("clearObjectLinks"), e(_j), e(Gp, rt.INITIAL);
  },
  async fetchNotificationsSettings({ commit: t }) {
    t(iw, !1), t(ow, !0);
    const e = await $e.notifications.fetch();
    return e.errors || t(sw, e.data), t(iw, !0), t(ow, !1), e;
  },
  async saveNotificationsSettings({ commit: t }, { email: e, push: n, gateway: r }) {
    const s = await $e.notifications.save({
      via_email: e,
      via_push: n,
      via_gateway: r
    });
    return s.errors || t(sw, s.data), s;
  },
  addObjectLink({ commit: t }, { notificationId: e, type: n, tag: r, objectId: s, timeoutId: i }) {
    t(wj, {
      notificationId: e,
      type: n,
      tag: r,
      objectId: s,
      timeoutId: i,
      timestamp: Date.now()
    });
  },
  removeObjectLink({ commit: t }, e) {
    t(Sj, e);
  },
  clearObjectLinks({ commit: t }) {
    t(Ij);
  },
  async registerNotification({ dispatch: t }, e) {
    var o, a;
    const n = e.data.objectId, r = e.data.typeId, s = Ie("notifications");
    ((o = Bb[r]) == null ? void 0 : o.objectType) === "news" && (s.news.getNewsItemById(n) || s.news.getNewsItem(n));
    const i = setTimeout(async () => {
      const c = await (await navigator.serviceWorker.getRegistration()).getNotifications({
        tag: e.tag
      });
      c != null && c.length ? c.forEach((u) => {
        var d;
        u.close(), t("unregisterNotification", {
          id: e.data.notificationId,
          tag: e.tag,
          timeoutId: i,
          objectType: (d = Bb[r]) == null ? void 0 : d.objectType,
          objectId: n
        });
      }) : clearTimeout(i);
    }, VD);
    t("addObjectLink", {
      notificationId: e.data.notificationId,
      type: (a = Bb[r]) == null ? void 0 : a.objectType,
      tag: e.tag,
      objectId: n,
      timestamp: Date.now(),
      timeoutId: i
    });
  },
  unregisterNotification({ state: t, dispatch: e }, { id: n, tag: r, timeoutId: s, objectType: i, objectId: o }) {
    clearTimeout(s), e("removeObjectLink", n), e("removeNotification", { tag: r, id: n });
  },
  unregisterObjectNotifications({ state: t, dispatch: e }, { objectType: n, objectId: r }) {
    var s;
    (s = t.objectLinks.objectsMap[n][r]) != null && s.length && t.objectLinks.objectsMap[n][r].forEach((o) => {
      const a = t.objectLinks.items[o];
      e("unregisterNotification", {
        tag: a.tag,
        objectType: n,
        objectId: r,
        id: o,
        timeoutId: a.timeoutId
      });
    });
  },
  unregisterObjectNotificationsByType({ state: t, dispatch: e }, n) {
    Object.keys(t.objectLinks.objectsMap[n]).forEach((r) => {
      t.objectLinks.objectsMap[n][r].forEach((i) => {
        const o = t.objectLinks.items[i];
        e("unregisterNotification", {
          tag: o.tag,
          objectType: n,
          objectId: r,
          id: i,
          timeoutId: o.timeoutId
        });
      });
    });
  },
  unregisterAllNotifications({ state: t, dispatch: e }) {
    Object.keys(t.objectLinks.objectsMap).forEach((n) => {
      e("unregisterObjectNotificationsByType", n);
    });
  },
  async removeNotification(t, { tag: e, id: n }) {
    const s = await (await navigator.serviceWorker.getRegistration()).getNotifications({
      tag: e
    });
    s.length && s.forEach((i) => {
      i.data.notificationId === n && i.close();
    });
  },
  async removeAllNotifications({ dispatch: t }) {
    t("clearObjectLinks");
    const e = await navigator.serviceWorker.getRegistration();
    if (e) {
      const n = await e.getNotifications();
      n == null || n.forEach((r) => r == null ? void 0 : r.close());
    }
  },
  async processAsoiNotification({ state: t, dispatch: e }, n) {
    return zD({
      state: t,
      dispatch: e,
      objectType: "asoi_note",
      dataPath: "note",
      message: n
    }), n;
  },
  async processGatewayNotification({ dispatch: t }, e) {
    const n = Ie("notifications");
    let r = {};
    if (n.references.notificationTypes[e.payload.type_id].name === "ASOI_NOTES")
      r = await jb(
        e.payload,
        xut
      );
    else if (n.references.notificationTypes[e.payload.type_id].name === "NEWS_COMMENTS") {
      r = await jb(
        e.payload,
        Eut
      );
      const s = setTimeout(async () => {
        const o = await (await navigator.serviceWorker.getRegistration()).getNotifications({
          tag: r.tag
        });
        o != null && o.length && o.forEach((a) => {
          a.close();
        }), clearTimeout(s);
      }, VD);
      return;
    } else
      r = await jb(
        e.payload,
        Cut
      );
    t("registerNotification", r);
  },
  async processNewsNotification({ state: t, dispatch: e }, n) {
    return zD({
      state: t,
      dispatch: e,
      objectType: "news",
      dataPath: "news",
      message: n
    }), n;
  },
  subscribeToPushEvents({ state: t, dispatch: e }) {
    navigator.serviceWorker.onmessage = async (n) => {
      if (n.data && n.data.type === "PUSH_EVENT") {
        const r = n.data.data, s = n.data.action, i = r.objectId, o = Ie("notifications");
        if (s === "click")
          switch (r.typeId) {
            case 100: {
              const l = r.commentId;
              o.news.getNewsItemById(i) || await o.news.getNewsItem(i), cs.push({
                path: `/news/${i}#comment-${l}`
              });
              break;
            }
            case 200:
              if (o.asoi.getAsoiNoteById(i) || await o.asoi.getAsoiNote(i), cs.currentRoute.path === `/notes/${i}`) break;
              cs.push({
                path: `/notes/${i}`
              });
              break;
            default:
              if (o.news.getNewsItemById(i) || await o.news.getNewsItem(i), cs.currentRoute.path === `/news/${i}`) break;
              cs.push({
                path: `/news/${i}`
              });
          }
        switch (s) {
          case "take-in-work":
            o.news.pickNewsItemToEdit({ newsItemId: i });
            break;
          case "take-asoi-note-in-work":
            o.asoi.pickAsoiNote({ note: { id: i } });
            break;
        }
        const a = t.objectLinks.items[r.notificationId];
        a && e("unregisterNotification", {
          id: r.notificationId,
          objectId: i,
          objectType: a.type,
          tag: n.data.tag,
          timeoutId: a.timeoutId
        });
      }
    }, this.$messageHub.sendPushReady();
  }
}, Put = {
  getIsPushSubscribed: (t) => t.push.isSubscribed,
  isPushNotificationsSubscriptionNeeded: (t) => t.subscriptions.viaPush.length > 0 && !t.push.isSubscribed,
  getPushApns: (t) => t.push.apns,
  getPushKey: (t) => t.push.key,
  getNotificationLinkMapped: (t) => {
    const e = {};
    return Object.entries(t.objectLinks).forEach(([n, r]) => {
      !n || !r || (e[r.objectId] = {
        notificationTag: n,
        ...r
      });
    }), e;
  }
}, kut = {
  [_j](t) {
    U.set(t.subscriptions, "viaEmail", []), U.set(t.subscriptions, "viaPush", []), U.set(t.subscriptions, "viaGateway", []);
  },
  [sw](t, e) {
    t.subscriptions.viaEmail = e.via_email, t.subscriptions.viaPush = e.via_push, t.subscriptions.viaGateway = e.via_gateway;
  },
  [iw](t, e) {
    t.loaded = e;
  },
  [ow](t, e) {
    t.loading = e;
  },
  [wj](t, { notificationId: e, type: n, tag: r, objectId: s, timestamp: i, timeoutId: o }) {
    switch (U.set(t.objectLinks.items, e, {
      type: n,
      tag: r,
      objectId: s,
      timestamp: i,
      timeoutId: o
    }), n) {
      case "news":
        t.objectLinks.objectsMap.news[s] || U.set(t.objectLinks.objectsMap.news, s, []), t.objectLinks.objectsMap.news[s].push(e);
        break;
      case "asoi_note":
        t.objectLinks.objectsMap.asoi_note[s] || U.set(t.objectLinks.objectsMap.asoi_note, s, []), t.objectLinks.objectsMap.asoi_note[s].push(e);
        break;
    }
  },
  [Sj](t, e) {
    const n = t.objectLinks.items[e], { objectId: r, type: s } = n;
    t.objectLinks.objectsMap[s][r] && (t.objectLinks.objectsMap[s][r] = t.objectLinks.objectsMap[s][r].filter((i) => i !== e)), t.objectLinks.objectsMap[s][r].length === 0 && U.delete(t.objectLinks.objectsMap[s], r), U.delete(t.objectLinks.items, e);
  },
  [Ij](t) {
    U.set(t.objectLinks, {});
  }
}, Nut = Dn(["notifications"], {
  namespaced: !0,
  state: {
    loaded: !1,
    loading: !1,
    subscriptions: {
      viaEmail: [],
      viaPush: [],
      viaGateway: []
    },
    // Связи уведомлений с объектами в сторе: новостями, заметками из АСОИ и т.д.
    objectLinks: {
      items: {},
      objectsMap: {
        news: {},
        asoi_note: {}
      }
    }
  },
  actions: Tut,
  getters: Put,
  mutations: kut,
  dependencies: {
    root: null,
    auth: {
      getters: ["getUserId"]
    },
    references: {
      getters: ["notificationTypes"]
    },
    userProfile: {
      getters: ["isUserInGroups"]
    },
    news: {
      actions: ["pickNewsItemToEdit", "getNewsItem", "processNewsMessage"],
      getters: ["getNewsItemById", "getNewsItemCurrentVersion"]
    },
    messages: {
      actions: ["addMessage"]
    },
    asoi: {
      actions: ["pickAsoiNote", "getAsoiNote"],
      getters: ["getAsoiNoteById"]
    }
  }
});
var $ut = ta, Dut = lc, Aut = Pu;
function Out(t) {
  return function(e, n, r) {
    var s = Object(e);
    if (!Dut(e)) {
      var i = $ut(n);
      e = Aut(e), n = function(a) {
        return i(s[a], a, s);
      };
    }
    var o = t(e, n, r);
    return o > -1 ? s[i ? e[o] : o] : void 0;
  };
}
var Mut = Out, Rut = X5, Lut = ta, Fut = E2, But = Math.max;
function jut(t, e, n) {
  var r = t == null ? 0 : t.length;
  if (!r)
    return -1;
  var s = n == null ? 0 : Fut(n);
  return s < 0 && (s = But(r + s, 0)), Rut(t, Lut(e), s);
}
var Ej = jut;
const Wut = /* @__PURE__ */ Et(Ej);
var Hut = Mut, Vut = Ej, zut = Hut(Vut), Uut = zut;
const xj = /* @__PURE__ */ Et(Uut);
function Gut(t, e) {
  const n = lt(t.supply, "left", []), r = lt(t.supply, "right", []);
  return n.length && n.findIndex((s) => s.id === e) !== -1 ? "left" : r.length && r.findIndex((s) => s.id === e) !== -1 ? "right" : null;
}
function Wb({ state: t, panel: e, supplyId: n }) {
  const r = Gut(e, n), s = xj(t.data, { id: e.id }), i = Wut(s.supply[r], { id: n });
  return { fullPath: s.supply[r][i], path: s, side: r, index: i };
}
function Yut({ state: t }) {
  return t.data.reduce((e, n) => (e.push({ id: n.id, isSupply: !1 }), ["left", "right"].forEach((r) => {
    lt(n.supply, r) && (e = [
      ...e,
      ...n.supply[r].map((s) => ({
        id: s.id,
        isSupply: !0,
        parentId: n.id
      }))
    ]);
  }), e), []);
}
const Zut = {
  [HL](t, e) {
    t.init = e;
  },
  [t1](t, e) {
    t.data = e;
  },
  [s6](t, e) {
    t.updatingByGateway = e;
  },
  [KL](t, e) {
    t.uiState.desiredScrollIndex = e;
  },
  [UL](t, { panel: e, position: n }) {
    const s = t.data.slice();
    s.splice(n, 0, e), t.data = s;
  },
  [zm](t, e) {
    t.data = t.data.filter(({ id: n }) => n !== e);
  },
  [c6](t) {
    t.data = t.data.filter(({ type: e }) => e !== "newsItem");
  },
  [gh](t, e) {
    t.uiState.focused = e;
  },
  [L2](t) {
    t.uiState.focused = null;
  },
  [Q0](t, { panel: e, scaleFactor: n }) {
    e && (e.settings.widthScaleFactor = n);
  },
  [VL](t, { panel: e, fullscreen: n }) {
    U.set(t.uiState, "fullscreen", n ? e.id : null);
  },
  [e1](t, { panel: e, compact: n }) {
    e && (e.settings.compact = n);
  },
  [zL](t, { panelId: e, mode: n }) {
    const r = t.data.find(({ id: s }) => s === e);
    U.set(r.settings, "dateMode", n), r.supply && [...r.supply.left, ...r.supply.right].forEach((i) => {
      U.set(i.settings, "dateMode", n);
    });
  },
  [GL](t, { panelId: e, color: n }) {
    const r = t.data.find(({ id: s }) => s === e);
    U.set(r.settings, "color", n), r.supply && [...r.supply.left, ...r.supply.right].forEach((i) => {
      U.set(i.settings, "color", n);
    });
  },
  [YL](t, { panelId: e, name: n }) {
    const r = t.data.find(({ id: s }) => s === e);
    U.set(r.settings, "name", n);
  },
  [ZL](t, { panelId: e, supplyId: n }) {
    const r = t.data.find(({ id: i }) => i === e), { fullPath: s } = Wb({ state: t, panel: r, supplyId: n });
    U.set(s.settings, "visible", !0);
  },
  [XL](t, { panelId: e, supplyId: n }) {
    const r = t.data.find(({ id: i }) => i === e), { fullPath: s } = Wb({ state: t, panel: r, supplyId: n });
    U.set(s.settings, "visible", !1);
  },
  [JL](t, { panelId: e, dataId: n }) {
    const r = t.data.find(({ id: s }) => s === e);
    if (U.set(r, "dataId", String(n)), r.type === ve.newsItem)
      for (const s of [...r.supply.right, ...r.supply.left])
        [gt.newsItemAdditionalSupply, gt.newsItemVersionsSupply].includes(
          s.type
        ) && U.set(s, "dataId", String(n));
  },
  [qL](t, { panelId: e, activeTabIndex: n }) {
    const r = Yut({ state: t }).find(({ id: s }) => s === e);
    if (r.isSupply) {
      const s = t.data.find(({ id: o }) => o === r.parentId), { fullPath: i } = Wb({
        state: t,
        panel: s,
        supplyId: r.id
      });
      U.set(i.settings, "activeTabIndex", n);
    } else {
      const s = t.data.find(({ id: i }) => i === e);
      U.set(s.settings, "activeTabIndex", n);
    }
  },
  [i6](t, { entryId: e, panelId: n }) {
    const r = t.data.find(({ id: s }) => s === n);
    if (U.set(r.supply.right[0], "dataId", String(e)), !r.supply.right[0].settings.visible) {
      const s = t.data.find(({ id: i }) => i === n);
      U.set(s.supply.right[0].settings, "visible", !0);
    }
  },
  [QL](t, e) {
    const n = t.data.filter(({ type: r }) => r === "flow").find((r) => r.supply.right[0].dataId === e);
    n && n.id && U.set(n.supply.right[0], "dataId", null);
  },
  [e6](t) {
    const e = t.data.find(({ type: n }) => n === ve.asoiNotes);
    e && e.id && U.set(e.supply.right[0], "dataId", null);
  },
  [t6](t) {
    const e = t.data.find(({ type: n }) => n === ve.asoiNotesSent);
    e && e.id && U.set(e.supply.right[0], "dataId", null);
  },
  [n6](t, { entry: e, panel: n }) {
    if (U.set(n.supply.right[0], "dataId", String(e.id)), !n.supply.right[0].settings.visible) {
      const r = t.data.find(({ id: s }) => s === n.id);
      U.set(r.supply.right[0].settings, "visible", !0);
    }
  },
  [cOe](t, { panel: e }) {
    if (U.set(e.supply.right[0], "dataId", null), e.supply.right[0].settings.visible) {
      const n = t.data.find(({ id: r }) => r === e.id);
      U.set(n.supply.right[0].settings, "visible", !1);
    }
  },
  [r6](t, { entry: e, panel: n }) {
    if (U.set(n.supply.right[1], "dataId", String(e.id)), !n.supply.right[1].settings.visible) {
      const r = t.data.find(({ id: s }) => s === n.id);
      U.set(r.supply.right[1].settings, "visible", !0);
    }
  },
  [o6](t, { entry: e, panel: n }) {
    if (U.set(n.supply.right[0], "dataId", String(e.id)), !n.supply.right[0].settings.visible) {
      const r = t.data.find(({ id: s }) => s === n.id);
      U.set(r.supply.right[0].settings, "visible", !0);
    }
  },
  [a6](t, { panelId: e, notificationId: n }) {
    t.panelsNotifications[e] = n;
  },
  [l6](t, e) {
    delete t.panelsNotifications[e];
  }
};
function Xut(t) {
  return t.skipCook ? t.route : {
    path: t.path,
    name: t.panel,
    alias: t.alias,
    components: { default: z8 },
    meta: {
      type: "panel",
      panelType: t.panel,
      workspace: !0
    }
  };
}
const Cj = [
  { path: "/search", panel: ve.search },
  { path: "/disposed", panel: ve.disposed },
  { path: "/embargo", panel: ve.awaitingPublication },
  { path: "/notes", panel: ve.asoiNotes },
  { path: "/notes/sent", panel: ve.asoiNotesSent },
  { path: "/notes/embargo", panel: ve.asoiNotesEmbargo },
  { path: "/originals", panel: ve.originals },
  { path: "/canvas", panel: ve.newsCanvas },
  /*
   * NOTE: Динамические пути должны быть в конце,
   * чтобы статические опрелелялись в первую очередь.
   * К примеру, /notes/sent должен быть приоритетнее /note/:id
   */
  { path: "/notes/embargo/:id", panel: ve.asoiNoteEmbargo },
  { path: "/notes/sent/:id", panel: ve.asoiNoteSent },
  { path: "/notes/:id", panel: ve.asoiNote },
  { path: "/newsbreaks/:id", panel: ve.newsbreak },
  { path: "/flows/:id", panel: ve.flow },
  { path: "/leads/:id", panel: ve.lead },
  { path: "/news/:id", panel: ve.newsItem, alias: "/n/:id" }
], Kut = Cj.map(Xut), Tj = {};
Cj.forEach((t) => Tj[t.panel] = t.path);
const Jut = 20, qut = {
  async init({ commit: t }) {
    t(HL, rt.READY);
  },
  async focusPanelByRoute({ state: t, commit: e, getters: n, dispatch: r }, s) {
    let i = null;
    if (s && s.meta && s.meta.type === "panel") {
      const o = t.data.filter(
        (a) => a.type === s.meta.panelType
      );
      if (s.params && s.params.id ? i = o.find(
        (a) => String(a.dataId) === String(s.params.id)
      ) : i = o[0], i) {
        const a = n.getPanelIndex(i.id);
        e(gh, i.id), await r("setDesiredScrollIndex", a);
      }
    }
    return i ?? null;
  },
  addPanelFromRoute({ dispatch: t }, e) {
    if (!(!e.meta || e.meta.type !== "panel"))
      return t("addPanel", {
        panel: {
          type: e.meta.panelType,
          dataId: e.params.id
        },
        position: 0,
        goToPanel: !0
      });
  },
  setPanelFocused({ state: t, commit: e }, n) {
    const r = t.data.find((s) => s.id === n);
    if (t.uiState.modal) {
      e(gh, r.id);
      return;
    }
    if (r && r.type) {
      let s = Tj[r.type];
      if (!s)
        return console.error(`Unknown panel type: ${r.type}`);
      s.includes(":") && (s = cs.currentRoute.name === r.type && cs.currentRoute.params.id === r.dataId ? cs.currentRoute.fullPath : s.replace(":id", r.dataId)), cs.replace({ path: s }).catch(() => null);
    } else
      cs.replace({ path: "/tasks" }).catch(() => null);
  },
  setDesiredScrollIndex({ commit: t }, e) {
    t(KL, e);
  },
  togglePanelSize({ commit: t, dispatch: e, getters: n }, { panel: r, scaleFactor: s, compact: i }) {
    t(Q0, { panel: r, scaleFactor: s }), t(e1, { panel: r, compact: i });
    const o = n.getPanelIndex(r.id);
    (o ?? null) && e("setDesiredScrollIndex", o);
  },
  setPanelFullscreen({ commit: t }, { panel: e, fullscreen: n }) {
    t(VL, { panel: e, fullscreen: n });
  },
  setPanelCompact({ commit: t }, { panel: e, compact: n }) {
    t(e1, { panel: e, compact: n });
  },
  setPanelWidthScaleFactor({ commit: t }, { panel: e, scaleFactor: n }) {
    t(Q0, { panel: e, scaleFactor: n });
  },
  setPanelDateMode({ commit: t }, e) {
    t(zL, e);
  },
  setPanelColor({ commit: t }, { panelId: e, color: n }) {
    t(GL, { panelId: e, color: n });
  },
  setPanelName({ commit: t }, { panelId: e, name: n }) {
    t(YL, { panelId: e, name: n });
  },
  setPanelDataId({ commit: t }, { panelId: e, dataId: n }) {
    t(JL, { panelId: e, dataId: n });
  },
  setPanelActiveTabIndex({ commit: t }, { panelId: e, activeTabIndex: n }) {
    t(qL, { panelId: e, activeTabIndex: n });
  },
  async addPanel({ state: t, commit: e, dispatch: n, getters: r }, { panel: s, position: i = 0, goToPanel: o = !0 }) {
    var u;
    const a = Ie("panels");
    let c = t.data.find((d) => {
      const f = d.type === s.type, p = d.dataId == s.dataId;
      return f && p;
    });
    if (!c) {
      let d = {};
      if (s.type === ve.newsItem) {
        if (!s.dataId) return;
        const p = Ie("panels"), h = await p.news.getNewsItem(s.dataId);
        if (!h) return;
        d = {
          newsItem: h,
          newsbreakId: (u = h.newsbreak) == null ? void 0 : u.id,
          isWide: p.userProfile.defaultPanelWidth === 2,
          isAdditionalSupplyAlwaysVisible: p.userProfile.isAdditionalSupplyAlwaysVisible
          // color: getColorSchemeByName(deps.userProfile.colorScheme).accentColor
        };
      }
      if (s.type === ve.flow) {
        const p = Ie("panels").flows.flowForPanel(s);
        d = { color: p == null ? void 0 : p.color, name: p == null ? void 0 : p.name };
      }
      if (c = UT(
        {
          id: r.getPanelIdMax + 1,
          type: s.type,
          dataId: s.dataId
        },
        d
      ), c.type === "newsItem" && r.getNewsItemPanelsCount >= Jut) {
        const { id: p } = t.data.findLast((h) => h.type === "newsItem");
        e(zm, p);
      }
      e(UL, { panel: c, position: i === 0 ? i : ++i });
    }
    if (o)
      if (c.id === t.uiState.focused) {
        const f = r.getPanelIndex(c.id);
        n("setDesiredScrollIndex", f);
      } else
        setTimeout(() => n("setPanelFocused", c.id), 10);
    else {
      const d = r.getPanelIndex(c);
      e(gh, c.id), n("setDesiredScrollIndex", d);
    }
    return a.userProfile.defaultPanelWidth > Cr.common.wide && r.getIsPanelFullscreenResizable(c) && setTimeout(() => {
      n("setPanelFullscreen", {
        panel: c,
        fullscreen: !0
      });
    }, 10), c;
  },
  async removePanel({ state: t, commit: e, dispatch: n }, { panelId: r, setFocusOnParent: s = !0 }) {
    const i = t.data.findIndex(({ id: l }) => l === r), o = t.data.find(({ id: l }) => l === r), a = Ie("panels");
    if (o && o.type === ve.newsItem) {
      const l = a.news.getNewsItemById(o.dataId), c = a.news.getNewsItemCurrentVersion(o.dataId), u = a.references.newsStatuses;
      l && c && u[c.status_id].name !== "PUBLISHED" && a.drafts.saveDraft({ newsItemId: o.dataId });
    }
    s && i !== -1 && t.data.length !== 1 ? n("setPanelFocused", t.data[Math.abs(i - 1)].id) : i !== -1 && t.data.length === 1 && (cs.replace({ path: "/tasks" }).catch(() => null), e(L2)), o && o.type === ve.flow && await a.flows.flowLeadsRemove(o.dataId), a.uiState.removePanelEditorFocus(r), e(zm, r);
  },
  setPanels({ commit: t }, e) {
    t(t1, e);
  },
  showSupply({ commit: t, dispatch: e, getters: n }, { panelId: r, supplyId: s }) {
    t(ZL, { panelId: r, supplyId: s });
    const i = n.getPanelIndex(r);
    (i ?? null) && e("setDesiredScrollIndex", i);
  },
  hideSupply({ commit: t }, { panelId: e, supplyId: n }) {
    t(XL, { panelId: e, supplyId: n });
  },
  toggleSupplyOfType({ dispatch: t, getters: e }, { panelId: n, type: r, hideOthers: s = !1 }) {
    var o;
    const i = e.getPanelById(n);
    for (const a in i.supply) {
      const l = (o = i.supply[a]) == null ? void 0 : o.find((c) => c.type === r);
      if (l)
        return l.settings.visible ? t("hideSupply", { panelId: n, supplyId: l.id }) : (s && i.supply[a].filter((c) => c.settings.visible).forEach((c) => t("hideSupply", { panelId: n, supplyId: c.id })), t("showSupply", { panelId: n, supplyId: l.id }));
    }
  },
  hideSupplyOfType({ dispatch: t, getters: e }, { panelId: n, type: r }) {
    var i;
    const s = e.getPanelById(n);
    for (const o in s.supply) {
      const a = (i = s.supply[o]) == null ? void 0 : i.find((l) => l.type === r);
      if (a)
        return a.settings.visible ? t("hideSupply", { panelId: n, supplyId: a.id }) : void 0;
    }
  },
  selectPublishedPanelNewsItem({ commit: t }, { entry: e, panel: n }) {
    t(n6, { entry: e, panel: n });
  },
  resetPanels({ commit: t }) {
    const e = UT({ id: 0, type: "tasks" });
    t(t1, [e]);
  },
  panelsSetUpdating({ commit: t }, e) {
    t(s6, e);
  },
  selectPanelListEntry({ commit: t }, { panelId: e, entryId: n }) {
    Ie("panels").uiState.setSelectedEntry({ panelId: e, entryId: n }), t(i6, { panelId: e, entryId: n });
  },
  selectPublishedSearchNewsItem({ commit: t }, { entry: e, panel: n }) {
    t(r6, { entry: e, panel: n });
  },
  selectEmbargoNewsItem({ commit: t }, { entry: e, panel: n }) {
    t(o6, { entry: e, panel: n });
  },
  clearAsoiNoteOldSupply({ commit: t }) {
    t(e6);
  },
  clearAsoiSentNoteOldSupply({ commit: t }) {
    t(t6);
  },
  clearLeadsOldSupply({ commit: t }) {
    t(QL);
  },
  // если действие выполняется по клику из уведомления,
  // сохраняем его notificationId для передачи в запрос при открытии панели
  addPanelNotification({ commit: t }, { panelId: e, notificationId: n }) {
    t(a6, { panelId: e, notificationId: n });
  },
  removePanelNotification({ commit: t }, e) {
    t(l6, e);
  }
};
var Qut = Iu;
function edt(t, e, n) {
  for (var r = -1, s = t.length; ++r < s; ) {
    var i = t[r], o = e(i);
    if (o != null && (a === void 0 ? o === o && !Qut(o) : n(o, a)))
      var a = o, l = i;
  }
  return l;
}
var tdt = edt;
function ndt(t, e) {
  return t > e;
}
var rdt = ndt, sdt = tdt, idt = rdt, odt = Vf;
function adt(t) {
  return t && t.length ? sdt(t, odt, idt) : void 0;
}
var ldt = adt;
const cdt = /* @__PURE__ */ Et(ldt), udt = {
  getPanels: (t) => t.data,
  getPanelById: (t) => (e) => t.data.find(({ id: n }) => n === e),
  getRootPanelById: (t, e) => (n) => {
    var r, s;
    if (e.getPanelById(n))
      return e.getPanelById(n);
    for (let i of t.data)
      if ([
        ...((r = i == null ? void 0 : i.supply) == null ? void 0 : r.left) || [],
        ...((s = i == null ? void 0 : i.supply) == null ? void 0 : s.right) || []
      ].find(({ id: l }) => l === n))
        return e.getPanelById(i.id);
  },
  /**
   * Получить индекс панели в списке панелей. Возвращает функцию, которая принимает объект панели и возвращает индекс
   * @param state
   * @returns {function(Panel): number}
   */
  getPanelIndex: (t) => (e) => t.data.findIndex(({ id: n }) => e === Number(n)),
  getParentPanelIndex: (t, e) => (n) => {
    const r = e.getPanelIndex(n);
    if (r !== -1) return r;
    const s = e.getRootPanelById(n);
    return e.getPanelIndex(s.id);
  },
  /**
   * Получить панель в фокусе
   * @param state
   * @returns {Panel}
   */
  focusedPanel: (t) => t.data.find((e) => e.id === t.uiState.focused),
  /**
   * Получить панель по её dataId
   * @param state
   * @returns {function(string, ID): (Panel|{})}
   */
  getPanelByDataId: (t) => (e, n) => t.data.find(
    (r) => e === r.type && String(r.dataId) === String(n)
  ) || {},
  getNewsItemPanelsCount: (t) => t.data.filter(({ type: e }) => e === "newsItem").length,
  /**
   * Получить панель для потока. Возвращает функцию, которая принимает id потока и возвращает панель
   * @param {VuexState} state Глобальное состояние
   * @returns {function(flowId: ID): (Panel | undefined)}
   */
  getPanelForFlow: (t) => (e) => t.data.filter(({ type: n }) => n === "flow").find((n) => +n.dataId === e),
  /**
   * Получить все supply для панели
   * @param state
   * @returns {function(Panel): Array}
   */
  getPanelSupplies: (t) => (e) => {
    const n = t.data.find(({ id: r }) => r === e.id);
    return n && n.supply ? [...n.supply.left, ...n.supply.right] : [];
  },
  /**
   * Получить все видимые supply для панели
   * @param state
   * @returns {function(Panel): Array}
   */
  getPanelVisibleSupplies: (t) => (e) => {
    const n = t.data.find(({ id: r }) => r === e.id);
    return n && n.supply ? [...n.supply.left, ...n.supply.right].filter(
      (s) => s ? s.settings.visible : !1
    ) : [];
  },
  getIsPanelRightSupplyVisible: (t) => (e) => {
    const n = t.data.find(({ id: r } = {}) => r === e);
    if (n && n.supply) {
      const r = [...n.supply.right], s = r.length > 0 && r[0];
      return s && s.settings.visible === !0;
    }
    return !1;
  },
  getRightPanelActiveTabIndex: (t) => (e) => {
    var r;
    const n = t.data.find(({ id: s } = {}) => s === e);
    if (n && n.supply) {
      const s = [...n.supply.right], i = s.length > 0 && s[0];
      return (r = i == null ? void 0 : i.settings) == null ? void 0 : r.activeTabIndex;
    }
    return null;
  },
  getIsPanelFullscreenResizable: () => (t) => t.type === ve.newsItem,
  /**
   * Получить максимальный (последний) идентификатор панели
   * @param state
   * @param getters
   * @returns {number}
   */
  getPanelIdMax: (t, e) => {
    const n = [];
    return t.data.forEach((r) => {
      n.push(r.id);
      const s = e.getPanelSupplies(r).map(({ id: i }) => i);
      Array.prototype.push.apply(n, s);
    }), cdt(n) || 0;
  },
  /**
   * Получить список видимых панелей.
   * Получает данные о размере и положении прокрутки окна,
   * и вычисляет видимые панели, используя данные о настройках панелей.
   * @param state {VuexState}     Состояние модуля
   * @returns number[]
   */
  visiblePanels: (t) => {
    const e = Ie("panels"), n = [];
    for (let r = 0; r < t.data.length; r++) {
      const s = t.data[r];
      let i = ji * s.settings.widthScaleFactor;
      s.supply && [...s.supply.left, ...s.supply.right].filter((o) => o.settings.visible).forEach((o) => {
        i += ji * o.settings.widthScaleFactor;
      }), r === 0 ? n[r] = [20] : n[r] = [n[r - 1][1] + 20], n[r].push(n[r][0] + i);
    }
    return t.data.filter((r, s) => {
      const i = n[s], o = e.uiState.getWindowParams.scrollLeft, a = o + e.uiState.getWindowParams.width;
      return !(i[0] > a || i[1] < o);
    }).map(({ id: r }) => r);
  },
  getIsPanelVisible: (t, e) => (n) => e.visiblePanels.includes(n),
  getIsPanelHistoryMode: (t, e) => (n) => e.getIsHistorySupplyVisible(n),
  getIsHistorySupplyVisible: (t, e) => (n) => {
    var r, s, i, o;
    return (o = (i = (s = (r = e.getPanelById(n)) == null ? void 0 : r.supply) == null ? void 0 : s.left) == null ? void 0 : i.find((a) => a.type === gt.newsItemVersionsSupply)) == null ? void 0 : o.settings.visible;
  },
  getIsPanelNewsType: () => (t) => [
    ve.newsItem,
    gt.newsItemAdditionalSupply,
    gt.newsItemNewsbreakSupply,
    gt.delayedSupply,
    gt.searchSecondSupply
  ].includes(t.type),
  getIsPanelCanvas: () => (t) => t.type === ve.newsCanvas,
  getIsFullscreen: (t) => t.uiState.fullscreen !== null,
  getFlowPanels: (t) => t.data.filter(({ type: e }) => e === "flow"),
  getAsoiPanels: (t) => t.data.filter(({ type: e }) => e.toLowerCase().includes("asoi")),
  getPanelNotification: (t) => (e) => t.panelsNotifications[e] || null
}, ddt = Dn(["panels"], {
  namespaced: !0,
  state: {
    data: [],
    uiState: {
      selectedEntriesMap: {},
      focused: null,
      fullscreen: null,
      desiredScrollIndex: null
    },
    updatingByGateway: !1,
    panelsNotifications: {}
  },
  actions: qut,
  mutations: Zut,
  getters: udt,
  dependencies: {
    references: {
      getters: ["newsStatuses"]
    },
    auth: null,
    userProfile: {
      getters: [
        "defaultPanelWidth",
        "colorScheme",
        "isAdditionalSupplyAlwaysVisible"
      ]
    },
    uiState: {
      getters: ["getWindowParams"],
      actions: ["removePanelEditorFocus", "setSelectedEntry"]
    },
    flows: {
      getters: ["flowForPanel"],
      actions: ["flowLeadsRemove"]
    },
    leads: null,
    news: {
      getters: ["getNewsItemById", "getNewsItemCurrentVersion"],
      actions: ["drafts/saveDraft", "getNewsItem"]
    },
    drafts: {
      actions: ["saveDraft"]
    }
  }
}), fdt = {
  [W7](t, e) {
    U.set(t.users, "list", e.map(({ id: n }) => n)), t.users.items = {}, e.forEach((n) => {
      U.set(t.users.items, n.id, n);
    });
  },
  [L1](t, e) {
    const n = e.map(({ id: r }) => r);
    t.users.list = un(t.users.list.concat(n).reverse()).reverse(), e.forEach((r) => {
      U.set(t.users.items, r.id, r);
    });
  },
  [cat](t) {
    t.users.list = [], t.users.items = {};
  },
  [H7](t, e) {
    U.set(t.groups, "list", e.map(({ id: n }) => n)), t.groups.items = {}, e.forEach((n) => {
      U.set(t.groups.items, n.id, n);
    });
  },
  [F1](t, e) {
    const n = e.map(({ id: r }) => r);
    t.groups.list = un(t.groups.list.concat(n).reverse()).reverse(), e.forEach((r) => {
      U.set(t.groups.items, r.id, r);
    });
  },
  [uat](t) {
    t.groups.list = [], t.groups.items = {};
  },
  [V7](t, e) {
    t.groupsAndUsers = e;
  }
}, pdt = {
  async "people/init"({ commit: t, dispatch: e }) {
    t("PEOPLE_INIT", rt.IN_PROGRESS), await e("fetchGroupsAndUsers"), t("PEOPLE_INIT", rt.READY);
  },
  async getUsers({ commit: t }, e = { offset: 0, limit: 100 }) {
    const n = e.replace;
    delete e.replace;
    const r = await $e.user.fetchUsers(e);
    return r.errors || (n && !e.offset ? t(W7, r) : t(L1, r)), r;
  },
  async getGroups({ commit: t }, e = { offset: 0, limit: 100 }) {
    const n = e.replace;
    delete e.replace;
    const r = await $e.user.fetchGroups(e);
    return r.errors || (r.forEach((s) => s.is_group = !0), n && !e.offset ? t(H7, r) : t(F1, r)), r;
  },
  async getRecipients({ state: t, commit: e }, n = !1) {
    const r = Object.values(t.groupsAndUsers).filter((a) => a.isGroup ? n ? a.is_mail : a.is_mail && !a.is_hidden : n ? a.asoi_mailbox_id !== null && !a.is_blocked : a.asoi_mailbox_id !== null && a.is_active), s = (a, l) => {
      const c = a.name.toLowerCase(), u = l.name.toLowerCase();
      return c < u ? -1 : c > u ? 1 : 0;
    }, i = r.filter(({ isGroup: a }) => a).map((a) => ({ ...a, is_group: !0, id: +a.id.replace("G", "") })).sort(s), o = r.filter(({ isUser: a }) => a).map((a) => ({ ...a, is_group: !1 })).sort(s);
    return e(F1, i), e(L1, o), [...i, ...o];
  },
  async fetchGroupsAndUsers({ commit: t }) {
    const e = await $e.user.fetchGroupsAndUsers();
    return e && !e.errors && t(V7, e), e;
  }
}, hdt = {
  getAllUserIds: (t) => Object.keys(t.users.items),
  getAllUsers: (t) => t.users.list.map((e) => t.users.items[e]),
  getUserById: (t) => (e) => t.users.items[e],
  getAllGroupIds: (t) => Object.keys(t.groups.items),
  getAllGroups: (t) => t.groups.list.map((e) => t.groups.items[e]),
  getGroupById: (t) => (e) => t.groups.items[e],
  getGroupsAndUsers: (t) => t.groupsAndUsers,
  getMailGroupsAndUsers: (t) => {
    const e = {};
    return Object.entries(t.groupsAndUsers).forEach(([n, r]) => {
      r.isGroup && !r.is_mail || (e[n] = r);
    }), e;
  },
  getMailGroupsAndNonBlockedUsers: (t) => {
    const e = {};
    return Object.entries(t.groupsAndUsers).forEach(([n, r]) => {
      r.isGroup && !r.is_mail || r.isUser && r.is_blocked || (e[n] = r);
    }), e;
  },
  // зарегистрированные пользователи (есть first_name и last_name) и группы, в которых есть хотя бы один зарегистрированнный пользователь
  getMailGroupsAndRegisteredUsers: (t) => {
    const e = {};
    return Object.entries(t.groupsAndUsers).forEach(([n, r]) => {
      r.isUser && (r.is_blocked || !r.first_name || !r.last_name) || r.isGroup && (!r.is_mail || r.children.map((i) => t.groupsAndUsers[i]).every(
        ({ first_name: i, last_name: o }) => !i || !o
      )) || (e[n] = r);
    }), e;
  },
  // пользователь и группы, в которых он состоит
  getUserAndUserGroups: (t) => {
    const e = Ie("people"), n = {};
    return Object.entries(t.groupsAndUsers).forEach(([r, s]) => {
      s.isGroup && !s.is_mail || s.isUser && s.id !== e.auth.getUserId || (s.id === e.auth.getUserId || e.userProfile.isUserInGroup(parseInt(s.id))) && (n[r] = s);
    }), n;
  }
}, mdt = Dn(["people"], {
  // TODO: Сделать модуль namespaced
  // namespaced: true,
  state: {
    users: {
      list: [],
      items: {}
    },
    groups: {
      list: [],
      items: {}
    },
    groupsAndUsers: {}
  },
  actions: pdt,
  mutations: fdt,
  getters: hdt,
  dependencies: {
    auth: {
      getters: ["getUserId"]
    },
    userProfile: {
      getters: ["isUserInGroup"]
    }
  }
}), vdt = {
  async init({ state: t, dispatch: e, commit: n }) {
    await Wze(this, t) || (n(M1, rt.IN_PROGRESS), n(M1, rt.READY));
  },
  async getRefs({ commit: t }) {
    let e = await ni.appData.references, n;
    return Ie("references").uiState.getIsOnline ? (n = await $e.references.fetch({
      lastModified: e == null ? void 0 : e.lastModified
    }), n.status === 304 ? n = e : n.data && !n.data.errors && await ni.appData.setData(
      {
        references: n.data
      },
      n.lastModified
    ), n.data && !n.data.errors && t(R1, n.data)) : e && (n = e, t(R1, e.data)), n;
  }
};
function Oi(t) {
  const e = {};
  return t && Object.keys(t).forEach((n) => {
    e[t[n].name] = {
      id: Number(n),
      description: t[n].description
    };
  }), e;
}
const gdt = {
  /**
   * Возвращает типы кодов в виде оъекта {имя_типа: иденитификатор_типа}
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  codeTypeIds: (t) => {
    var n;
    const e = {};
    return (n = t.Profile) != null && n.Type && Object.keys(t.Profile.Type).forEach((r) => {
      const s = t.Profile.Type[r];
      e[s.name] = r;
    }), e;
  },
  /**
   * Возвращает типы событий потоков
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  flowEventTypes: (t) => lt(t, "FlowEvent.Type"),
  /**
   * Возвращает типы событий лидов
   * @param {VuexState} state Глобальное состояние
   * @returns {Object} Объект с типами событий
   */
  leadsEventsTypes: (t) => lt(t, "NewsbreakEvent.Type"),
  /**
   * Возвращает статусы новостей
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsStatuses: (t) => lt(t, "News.Status"),
  /**
   * Возвращает статусы новости в виде объекта, в виде { имя_статуса: объект_статуса }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsStatusesByName: (t) => {
    var e;
    return Oi((e = t.News) == null ? void 0 : e.Status);
  },
  /**
   * Возвращает типы сущностей
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  entitiesTypesByName: (t) => {
    var e;
    return Oi((e = t.Entity) == null ? void 0 : e.Type);
  },
  entityListTypesByName: (t) => {
    var e;
    return Oi((e = t.Entity) == null ? void 0 : e.List);
  },
  isForbiddenByEntity: (t) => (e) => {
    var r;
    const n = Object.keys(
      ((r = t == null ? void 0 : t.Entity) == null ? void 0 : r.List) ?? {}
    ).map((s) => parseInt(s, 10));
    return e.list_ids.find(
      (s) => n.includes(s)
    );
  },
  getEntityListTypeById: (t) => (e) => {
    var n;
    return (n = t.Entity) == null ? void 0 : n.List[e];
  },
  /**
   * Возвращает типы связей новостей
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsLinkTypes: (t) => lt(t, "NewsLink.Type"),
  /**
   * Возвращает типы связей новостей в виде объекта, в виде { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsLinkTypeByName: (t) => Oi(lt(t, "NewsLink.Type")),
  /**
   * Возвращает типы новостей
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsTypes: (t) => lt(t, "News.Type"),
  /**
   * Принимает id типа кода и возвращает объект типа
   * @param {VuexState} state Глобальное состояние
   * @returns {function(typeId: number): Object}
   */
  getCodeType: (t) => (e) => lt(t, `Profile.Type[${e}]`),
  /**
   * Возвращает типы новостей в виде объекта, в виде { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsTypesByName: (t) => Oi(lt(t, "News.Type")),
  /**
   * Возвращает типы событий новостей
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsEventTypes: (t) => lt(t, "NewsEvent.Type"),
  /**
   * Возвращает типы событий новостей в виде объекта { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsEventTypesByName: (t) => Oi(lt(t, "NewsEvent.Type")),
  /**
   * Возвращает типы связей новостей с родительскими
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsParentRelTypes: (t) => lt(t, "NewsParentRel.Type"),
  /**
   * Возвращает типы связи новостей с родительскими в виде объекта { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsParentRelTypesByName: (t) => Oi(lt(t, "NewsParentRel.Type")),
  /**
   * Возвращает языки новостей
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsLangs: (t) => lt(t, "News.Language"),
  /**
   * Возвращает типы событий задач
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsbreakEventTypes: (t) => lt(t, "NewsbreakEvent.Type"),
  /**
   * Возвращает типы событий задач в виде объекта, в виде { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsbreakEventTypesByName: (t) => Oi(lt(t, "NewsbreakEvent.Type")),
  /**
   * Возвращает статусы инфоповода
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsbreakStatuses: (t) => lt(t, "Newsbreak.Status"),
  /**
   * Возвращает типы источников в виде объекта, в виде
   * { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  sourcesTypes: (t) => Oi(lt(t, "Source.Type")),
  /**
   * Возвращает типы источников, запрещенные для редактирования
   * @param {VuexGetters} getters Глобальные геттеры
   * @returns {Array<Number>}
   */
  premoderatedSourceTypes: (t, e) => {
    const n = e.sourcesTypes;
    return [n.TASS, n.RIA].map(vTe("id"));
  },
  /**
   * Возвращает типы событий для заметок АСОИ
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  asoiNoteEventTypes: (t) => lt(t, "ASOINoteEvent.Type"),
  /**
   * Возвращает типы событий уведомлений
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  notificationTypes: (t) => lt(t, "Notification.Type"),
  /**
   * Возвращает типы событий уведомлений в виде объекта
   * { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  notificationTypesByName: (t) => Oi(lt(t, "Notification.Type")),
  /**
   * Возвращает типы полей для поиска по новостям
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsSearchTargets: (t) => lt(t, "NewsFTS.Target"),
  /**
   * Возвращает типы полей для поиска по новостям в виде объекта
   * { имя_типа: объект_типа }
   * @param {VuexState} state Глобальное состояние
   * @returns {Object}
   */
  newsSearchTargetsByName: (t) => Oi(lt(t, "NewsFTS.Target"))
}, ydt = {
  [R1](t, e) {
    Object.keys(e).forEach((n) => {
      U.set(t, n, e[n]);
    });
  },
  [M1](t, e) {
    t.init = e;
  }
}, bdt = Dn(["references"], {
  namespaced: !0,
  state: {},
  actions: vdt,
  getters: gdt,
  mutations: ydt,
  dependencies: {
    auth: {
      getters: ["getUserId"]
    },
    references: {
      getters: ["newsTypesByName"]
    },
    uiState: {
      getters: ["getIsOnline"]
    }
  }
}), _dt = {
  [dF](t, e) {
    t.itemId = Number(e), t.isVisible = !0;
  },
  [U1](t) {
    t.isVisible = !1, t.data = null, t.itemId = null, t.isLoading = !0;
  },
  [fF](t, e) {
    t.data = e;
  },
  [Ah](t, e) {
    t.isLoading = e;
  }
};
async function wdt(t) {
  return t.newsbreak && (t.newsbreak = await Kn.process("newsbreaks", t.newsbreak)), t;
}
const Sdt = {
  "relationsModal/init"() {
  },
  showRelationsModal({ commit: t, dispatch: e }, n) {
    t(Vi, !0), t(dF, n), e("fetchRelations", n);
  },
  hideRelationsModal({ commit: t }) {
    t(Vi, !1), t(U1);
  },
  async fetchRelations({ commit: t }, e) {
    t(Ah, !0);
    const n = await $e.news.fetchRelations(e);
    if (n.errors)
      t(Vi, !1), t(U1), t(Ah, !0);
    else {
      const r = await wdt(n.data);
      t(fF, r), t(Ah, !1);
    }
  }
}, Idt = Dn(["relationsModal"], {
  state: {
    isVisible: !1,
    isLoading: !0,
    itemId: null,
    data: null
  },
  mutations: _dt,
  actions: Sdt,
  dependencies: {
    news: null,
    auth: null
  }
}), Edt = {
  getDefaultRecipient: (t) => {
    const e = Ie("shareModal").userProfile.getDefaultRecipientId;
    return t.recipientsList.find((n) => n.id === e) || null;
  }
}, xdt = {
  [sF](t, { itemId: e, itemType: n, actionType: r, params: s, multipleMode: i = !1 }) {
    t.isVisible = !0, t.itemId = e, t.itemType = n, t.actionType = r, t.params = s, t.multipleMode = i;
  },
  [H1](t) {
    t.isVisible = !1, t.itemId = null, t.itemType = null, t.actionType = null, t.params = {}, t.multipleMode = !1;
  },
  [oF](t, e) {
    const n = e.map((s) => ({
      id: s.id,
      is_group: s.is_group || !1
    })), r = AS(
      t.recipientsList.concat(n).reverse(),
      $a
    ).reverse();
    U.set(t, "recipientsList", r);
  },
  [aF](t) {
    U.set(t, "recipientsList", []);
  },
  [iF](t, e) {
    U.set(
      t,
      "recipientsList",
      e.map((n) => ({
        id: n.id,
        is_group: n.isGroup || !1
      }))
    );
  }
};
function Cdt(t, e, n, r) {
  for (var s = n - 1, i = t.length; ++s < i; )
    if (r(t[s], e))
      return s;
  return -1;
}
var Tdt = Cdt, Pdt = Qa, kdt = K5, Ndt = Tdt, $dt = Tu, Ddt = Wf, Adt = Array.prototype, UD = Adt.splice;
function Odt(t, e, n, r) {
  var s = r ? Ndt : kdt, i = -1, o = e.length, a = t;
  for (t === e && (e = Ddt(e)), n && (a = Pdt(t, $dt(n))); ++i < o; )
    for (var l = 0, c = e[i], u = n ? n(c) : c; (l = s(a, u, l, r)) > -1; )
      a !== t && UD.call(a, l, 1), UD.call(t, l, 1);
  return t;
}
var Mdt = Odt, Rdt = Mdt;
function Ldt(t, e) {
  return t && t.length && e && e.length ? Rdt(t, e) : t;
}
var Fdt = Ldt, Bdt = MI, jdt = Fdt, Wdt = Bdt(jdt), Hdt = Wdt;
const Vdt = /* @__PURE__ */ Et(Hdt), zdt = {
  showShareModal({ commit: t }, { itemId: e, itemType: n, actionType: r, params: s, multipleMode: i = !1 }) {
    t(Vi, !0), t(sF, {
      itemId: e,
      itemType: n,
      actionType: r,
      params: s,
      multipleMode: i
    });
  },
  hideShareModal({ state: t, commit: e }) {
    t.actionType === "sendFragmentAsFlash" && Ie("shareModal").news.deleteNewsItem({ newsItemId: t.itemId }), e(Vi, !1), e(H1);
  },
  clearList({ commit: t }) {
    t(aF);
  },
  shareDispatcher({ state: t, commit: e }, { groupIds: n, userIds: r, asoiComment: s }) {
    const i = t.itemType, o = t.actionType, a = t.params, l = Ie("shareModal");
    if (i === "newsItem")
      switch (o) {
        case "sendToEdit":
          l.news.sendNewsItemToEdit({
            newsItemId: t.itemId,
            groupId: n[0],
            userId: r[0]
          });
          break;
        case "sendToASOI":
          l.news.sendNewsItemToASOI({
            newsItemId: t.itemId,
            groupIds: n,
            userIds: r,
            asoiComment: s
          });
          break;
        case "sendFragmentAsFlash":
          l.news.sendFlashFragmentToEdit({
            newsItemId: t.itemId,
            groupId: n[0],
            userId: r[0],
            panelIndex: (a == null ? void 0 : a.panelIndex) || 0
          });
          break;
      }
    if (i === "lead") {
      const c = l.leads.getLeadById(t.itemId);
      switch (o) {
        case "forward":
          a != null && a.forwardFragment ? l.leads.forwardLead({
            lead: c,
            groupIds: n,
            userIds: r,
            fragment: a.forwardFragment
          }) : l.leads.forwardLead({ lead: c, groupIds: n, userIds: r });
          break;
      }
    }
    e(Vi, !1), e(H1);
  },
  shareModalSetRecipients({ commit: t }, { recipients: e, defaultRecipient: n = null }) {
    n && (e = [n, ...Vdt(e, n)]), t(iF, e);
  },
  shareModalAddRecipients({ commit: t }, e) {
    t(oF, e);
  }
}, Udt = Dn(["shareModal"], {
  state: {
    isVisible: !1,
    itemId: null,
    itemType: null,
    actionType: null,
    params: {},
    multipleMode: !1,
    recipientsList: []
  },
  getters: Edt,
  actions: zdt,
  mutations: xdt,
  dependencies: {
    leads: {
      getters: ["getLeadById"],
      actions: ["forwardLead"]
    },
    news: {
      actions: [
        "deleteNewsItem",
        "sendNewsItemToEdit",
        "sendNewsItemToASOI",
        "sendFlashFragmentToEdit"
      ]
    },
    userProfile: {
      getters: ["getDefaultRecipientId"]
    }
  }
}), Gdt = {
  [no](t, e) {
    const n = {};
    e.forEach((r) => {
      U.set(n, r.id, r);
    }), t.items = { ...t.items, ...n };
  },
  [lat](t, e) {
    const n = {};
    e.forEach((r) => {
      U.set(n, r.id, r);
    }), t.items = n;
  },
  [Pl](t, e) {
    e.forEach((n) => {
      const s = {
        ...t.dirMap[n.id] || {
          parent_id: null,
          type_id: 0
        }
      };
      if (n.parent_id !== null) {
        const i = t.dirMap[n.parent_id];
        i && i.level !== void 0 && i.level !== null ? s.level = i.level + 1 : s.level = 0;
      } else
        s.level = 0;
      U.set(t.dirMap, n.id, s);
    });
  },
  [y7](t, e) {
    const n = {};
    e.forEach((r) => {
      U.set(n, r.id, { level: 0 });
    }), t.dirMap = n;
  },
  [Dd](t, e) {
    const { dirId: n, childrenIds: r } = e, s = t.dirMap[n], i = s && s.children ? un(s.children.concat(r)) : r;
    s || U.set(t.dirMap, n, {}), U.set(t.dirMap[n], "children", i);
  },
  [Th](t, e) {
    const { dirId: n, childrenIds: r } = e, s = t.dirMap[n];
    s && s.children && (s.children = s.children.filter(
      (i) => !r.includes(i)
    ));
  },
  [Ad](t, e) {
    t.selected = e ? [e] : [];
  },
  [_7](t, e) {
    const { id: n, name: r } = e, s = t.items[n];
    s && s.name && (s.name = r);
  },
  [b7](t, e) {
    const n = t.selected.includes(e);
    t.selected.length === 1 && n || (n ? t.selected = t.selected.filter((r) => r !== e) : t.selected = un(t.selected.concat(e)));
  },
  [Ph](t, e) {
    U.delete(t.items, e), U.delete(t.dirMap, e), U.delete(t.opened, t.opened.indexOf(e)), U.delete(t.selected, t.selected.indexOf(e));
  },
  [w7](t, { source: e, value: n }) {
    const r = xj(t.items, ["id", e.id]);
    r && U.set(r, "in_flow", n);
  },
  [Od](t, e) {
    const { newParentId: n, childrenIds: r } = e;
    r.forEach((s) => {
      const i = t.items[s];
      i && (i.parent_id = n);
    });
  },
  [S7](t) {
    t.selected = [], t.opened = [], t.dirMap = {}, t.mainList = [];
  }
};
function Bh(t, e) {
  let n = [];
  return n = Object.keys(t.items).filter((r) => t.items[r].parent_id === e).map((r) => +r), n.forEach((r) => {
    t.opened.includes(r) && (n = n.concat(Bh(t, r)));
  }), n;
}
const Ydt = {
  [D1](t, e) {
    let { parentId: n, sourceIds: r, index: s } = e;
    if (n = n || null, s = s ?? null, s === null && n !== null) {
      const i = t.mainList.indexOf(n);
      i !== -1 && (s = i + 1);
    }
    s === null ? t.mainList = un(t.mainList.concat(r)) : t.mainList = un([
      ...t.mainList.slice(0, s),
      ...r,
      ...t.mainList.slice(s)
    ]);
  },
  [N7](t, e) {
    const { oldId: n, newId: r } = e, s = t.mainList.indexOf(n);
    s !== -1 && U.set(t.mainList, s, r);
  },
  [C7](t, e) {
    t.mainList = e;
  },
  [A1](t, e) {
    function n(s, i) {
      const o = s.indexOf(i);
      if (o !== -1)
        if (t.items[i].type_id === 0) {
          s.splice(o, 1);
          const l = t.dirMap[i];
          l && l.children && l.children.length && l.children.forEach((c) => {
            n(s, c);
          });
        } else
          s.splice(o, 1);
    }
    let r = [...t.mainList];
    e.forEach((s) => {
      n(r, s);
    }), t.mainList = r;
  },
  [Nh](t, e) {
    t.opened.findIndex((r) => r === e) === -1 && t.opened.push(e);
  },
  [T7](t, e) {
    const n = t.opened.indexOf(e), r = Bh(t, e);
    n !== -1 && (t.opened = t.opened.filter(
      (s) => ![e, ...r].includes(s)
    ));
  },
  [P7](t, e) {
    U.set(t.dirMap[e], "loading", !0);
  },
  [k7](t, e) {
    U.set(t.dirMap[e], "loading", !1);
  },
  [O1](t, e) {
    let { newParentId: n, sourceIds: r } = e, s = [...t.mainList], i = {};
    r.forEach((a) => {
      const l = s.indexOf(a);
      let c = [];
      if (s.splice(l, 1), t.items[a].parent_id = n, t.items[a].type_id === 0 && t.opened.includes(a)) {
        c = Bh(t, a);
        const u = c.length;
        s.splice(l, u);
      }
      i[a] = c;
    }), r = Object.keys(i).reduce(
      (a, l) => [...a, +l, ...i[l]],
      []
    );
    const o = s.indexOf(n);
    t.mainList = un([
      ...s.slice(0, o + 1),
      ...r,
      ...s.slice(o)
    ]);
  },
  [kh](t, e) {
    let { dragSourceIds: n, dropSourceId: r } = e, s = [...t.mainList], i = {};
    n.forEach((a) => {
      const l = s.indexOf(a);
      let c = [];
      if (s.splice(l, 1), t.items[a].parent_id = r ? t.items[r].parent_id : null, t.items[a].type_id === 0 && t.opened.includes(a)) {
        c = Bh(t, a);
        const u = c.length;
        s.splice(l, u);
      }
      i[a] = c;
    }), n = Object.keys(i).reduce(
      (a, l) => [...a, +l, ...i[l]],
      []
    );
    const o = s.indexOf(r);
    t.mainList = [
      ...s.slice(0, o),
      ...n,
      ...s.slice(o)
    ];
  },
  [$7](t, e = []) {
    t.mainListStateBackup.dirMap = Or(t.dirMap), t.mainListStateBackup.mainList = [...t.mainList], t.mainListStateBackup.opened = [...t.opened], t.mainListStateBackup.selected = [...t.selected], t.mainListStateBackup.items = {}, e.forEach((n) => {
      t.mainListStateBackup.items[n] = Or(t.items[n]);
    });
  },
  [D7](t) {
    t.dirMap = Or(t.mainListStateBackup.dirMap), t.mainList = [...t.mainListStateBackup.mainList], t.opened = [...t.mainListStateBackup.opened], t.selected = [...t.mainListStateBackup.selected], t.mainListStateBackup.items && Object.keys(t.mainListStateBackup.items).forEach((e) => {
      U.set(t.items, e, t.mainListStateBackup.items[e]);
    }), t.mainListStateBackup = {};
  },
  [A7](t) {
    t.mainListStateBackup = {};
  }
}, Zdt = {
  [I7](t, e) {
    t.logs[e.sourceId] || U.set(t.logs, e.sourceId, []);
    let n = [...t.logs[e.sourceId]];
    n = n.concat(e.logs), U.set(t.logs, e.sourceId, n);
  },
  [E7](t, e) {
    t.logs[e.sourceId] || U.set(t.logs, e.sourceId, []), U.set(t.logs, e.sourceId, e.logs);
  },
  [x7](t, e) {
    t.errors[e.sourceId] || U.set(t.errors, e.sourceId, []), U.set(t.errors, e.sourceId, e.errors);
  }
}, Xdt = {
  ...Gdt,
  ...Ydt,
  ...Zdt
}, Kdt = {
  async getSources({ commit: t }, e) {
    const n = await Z1({
      name: "sources/fetchMore",
      request: $e.sources.fetchMore(e)
    });
    if (!n.errors && !n.cancelled) {
      t(no, n);
      const r = n.map((i) => i.id), s = n.filter((i) => i.type_id === 0);
      return e.directory_id && t(Dd, {
        dirId: e.directory_id,
        childrenIds: r
      }), t(Pl, s), t(D1, {
        sourceIds: r,
        parentId: e.directory_id
      }), n;
    }
  },
  async replaceSources({ state: t, commit: e }, n) {
    const r = await Z1({
      name: "sources/fetchMore",
      request: $e.sources.fetchMore(n)
    });
    if (!r.errors && !r.cancelled)
      return e(no, r), e(
        y7,
        r.filter((s) => s.type_id === 0)
      ), e(
        C7,
        r.map((s) => s.id)
      ), e(Ad, t.mainList[0] || null), r;
  },
  async getSource({ commit: t }, e) {
    const n = await $e.sources.fetchOne(e);
    return n.errors || (n.data.web_blocks = n.data.web_blocks.map((r, s) => (r._index = s, r)), t(no, [n.data])), n;
  },
  selectSource({ commit: t }, { sourceId: e, multipleMode: n }) {
    t(n ? b7 : Ad, e);
  },
  async renameSource({ commit: t, dispatch: e, getters: n }, { id: r, name: s }) {
    const i = { ...n.getSourceById(r), name: s };
    delete i.modified_at;
    const o = await $e.sources.update(r, i);
    return o.errors ? o.errors.forEach((a) => {
      e("addMessage", {
        type: "error",
        message: a.detail || a.title
      });
    }) : t(_7, { id: r, name: s }), o;
  },
  async moveSource({ state: t, commit: e }, { newParentId: n, sourceIds: r, dropSourceId: s = null }) {
    const i = r.map((l) => t.items[l]), o = i.filter((l) => l.parent_id !== null).map((l) => t.items[l.parent_id]), a = i.filter((l) => l.type_id === 0);
    if (n !== null) {
      const l = await $e.sources.update(n, {
        children: r.map((c) => ({ id: c }))
      });
      if (!l.errors) {
        e(no, [l]), e(Od, { newParentId: n, childrenIds: r }), e(Pl, a), e(Dd, {
          dirId: n,
          childrenIds: r
        }), o.forEach((u) => {
          e(Th, {
            dirId: u.id,
            childrenIds: r
          });
        }), n === s ? e(O1, { newParentId: n, sourceIds: r }) : e(kh, {
          dragSourceIds: r,
          dropSourceId: s
        });
        const c = Object.keys(t.items).filter((u) => t.items[u].type_id === 0).map((u) => +u);
        e(
          Pl,
          c.map((u) => t.items[u])
        );
      }
      return l;
    } else
      await r.forEach(async (l) => {
        (await $e.sources.update(l, { parent_id: null })).errors || (e(Od, { newParentId: n, childrenIds: r }), o.forEach((u) => {
          e(Th, {
            dirId: u.id,
            childrenIds: r
          });
        }), e(Pl, a), e(kh, {
          dragSourceIds: r,
          dropSourceId: s
        }));
      });
  },
  moveSourceToIndex({ state: t, commit: e }, { dropSourceId: n }) {
    e(kh, {
      dragSourceIds: t.selected,
      dropSourceId: n
    });
  },
  async getSourceChildren({ commit: t, dispatch: e }, n) {
    return t(P7, n), e("getSources", { directory_id: n });
  },
  openDirectory({ commit: t }, e) {
    t(k7, e), t(Nh, e);
  },
  closeDirectory({ state: t, commit: e }, n) {
    const r = t.dirMap[n], s = r && r.children || [];
    e(T7, n), e(A1, s);
  },
  async saveSource({ dispatch: t }, e) {
    return e.type_id === 2 ? e.web_blocks = [] : (e.web_blocks = e.web_blocks.filter(
      (n) => n.xpath && n.xpath.length
    ), e.id && e.web_blocks.forEach((n) => {
      n._action || (n._action = "UPDATE");
    })), e.name = e.name.replace(/\s+/g, " ").trim(), e.url = e.url.replace(/\s+/g, " ").trim(), e.id ? t("updateSource", e) : t("createSource", e);
  },
  async updateSource({ commit: t }, e) {
    delete e.modified_at;
    const n = e.id;
    delete e.id;
    const r = await $e.sources.update(n, e);
    return r.errors || t(no, [r]), r;
  },
  async createSource({ dispatch: t, commit: e }, n) {
    const r = n.flow;
    delete n.flow, delete n.id, n.type_id === 2 && delete n.web_blocks;
    const s = await $e.sources.create(n);
    let i = {};
    return r && s && !s.errors && (i = await t("saveFlowSource", {
      flowId: n.flow,
      sourceId: s.id
    })), s.errors || e(no, [s]), i.errors && e(Qd, {
      type: "error",
      message: "Не удалось добавить источник в поток"
    }), s;
  },
  abortSourceDirProcess({ commit: t }) {
    t(D7), t(Ph, "tmp");
  },
  createDirectory({ state: t, commit: e }, n) {
    const { parentId: r, dropId: s } = n;
    e($7, t.selected);
    const i = {
      type_id: 0,
      id: "tmp",
      name: "Новая папка",
      parent_id: r || null
    };
    e(no, [i]);
    let o = 0;
    return s != null ? o = t.mainList.indexOf(s) : r != null ? t.mainList.indexOf(r) !== -1 && (o = t.mainList.indexOf(r) + 1) : o = t.mainList.indexOf(t.selected[t.selected.length - 1]), e(D1, { parentId: r, sourceIds: ["tmp"], index: o }), e(Pl, [i]), e(Od, {
      newParentId: r,
      childrenIds: t.selected
    }), e(Dd, {
      dirId: "tmp",
      childrenIds: t.selected
    }), r && e(Th, {
      dirId: r,
      childrenIds: t.selected
    }), e(O1, { newParentId: "tmp", sourceIds: t.selected }), e(Nh, "tmp"), e(Ad, "tmp"), { id: "tmp", index: o };
  },
  async submitDirectory({ state: t, commit: e, dispatch: n }, r) {
    const s = { ...t.items.tmp };
    s.name = r, s.id = null;
    const i = t.dirMap.tmp.children;
    s.children = i.map((a) => ({ id: a }));
    const o = await $e.sources.create(s);
    return o.errors ? o.errors.forEach((a) => {
      n("addMessage", {
        text: a.detail || a.title,
        type: "warning"
      });
    }) : (e(no, [o]), e(Pl, [o]), e(Od, {
      newParentId: o.id,
      childrenIds: i
    }), e(N7, { oldId: "tmp", newId: o.id }), e(Dd, {
      dirId: o.id,
      childrenIds: i
    }), e(Nh, o.id), e(Ph, "tmp"), e(A7), e(Ad, o.id)), o;
  },
  async deleteSources({ commit: t, dispatch: e }, n) {
    await n.forEach(async (r) => {
      const s = await $e.sources.remove(r);
      s.errors ? s.errors.forEach((i) => {
        e("addMessage", {
          text: i.detail || i.title,
          type: "warning"
        });
      }) : (t(A1, [r]), t(Ph, r));
    });
  },
  async getSourceLogs({ commit: t }, { id: e, params: n }) {
    const r = await $e.sources.fetchLogs(e, n);
    return r.errors || t(I7, { sourceId: e, logs: r.data }), r;
  },
  async replaceSourceLogs({ commit: t }, { id: e, params: n }) {
    const r = await $e.sources.fetchLogs(e, n);
    return r.errors || t(E7, { sourceId: e, logs: r.data }), r;
  },
  async replaceSourceErrors({ commit: t }, e) {
    const n = await $e.sources.fetchErrors(e);
    n.errors || t(x7, { sourceId: e, errors: n });
  },
  sourcesResetState({ commit: t }) {
    t(S7);
  },
  sourcesSetPicked({ commit: t }, { source: e, value: n }) {
    t(w7, { source: e, value: n });
  }
}, Jdt = {
  getSourcesSelected: (t) => t.selected,
  getSourceById: (t) => (e) => t.items[e],
  getSourceRoot: (t) => (e) => {
    const n = t.items[e];
    if (!n || n.parent_id === null) return null;
    const r = function(i) {
      if (i.parent_id !== null) {
        const o = t.items[i.parent_id];
        return r(o);
      } else
        return i;
    }, s = t.items[n.parent_id];
    return r(s);
  }
}, qdt = Dn(["sources"], {
  state: {
    items: {},
    tree: {
      root: {
        children: []
      }
    },
    treeItems: {},
    mainList: [],
    mainListStateBackup: {},
    selected: [],
    opened: [],
    dirMap: {},
    logs: {},
    errors: {}
  },
  actions: Kdt,
  mutations: Xdt,
  getters: Jdt,
  dependencies: {
    auth: null
  }
}), Qdt = {
  [Vi](t, e) {
    t.modal = e;
  },
  [O7](t, { panelId: e, focused: n }) {
    U.set(t.focusedEditorsMap, e, n);
  },
  [R7](t, e) {
    t.codeManagerFocused = e;
  },
  [pF](t, e) {
    t.needAuth = e;
  },
  [bF](t, e) {
    t.panelsDragging = e;
  },
  [M7](t, e) {
    U.delete(t.focusedEditorsMap, e);
  },
  [mat](t, e) {
    t.swUpdateVisible = e;
  },
  [hF](t, e) {
    t.windowParams = e;
  },
  [mF](t, e) {
    t.visible = e;
  },
  [vF](t, e) {
    t.online = e;
  },
  [gF](t, e) {
    e.forEach((n) => {
      n && U.set(n, "initialLoaded", !1);
    });
  },
  [yF](t, e) {
    t.isInstalled = e;
  },
  UI_STATE_INIT(t, e) {
    t.init = e;
  },
  [_F](t, { panelId: e, entryId: n }) {
    U.set(t.selectedEntriesMap, e, n);
  },
  [wF](t, e) {
    t.isTaskPanelOpen = e;
  }
}, eft = {
  editorInPanelFocused: (t) => !!Object.keys(t.focusedEditorsMap).find(
    (e) => t.focusedEditorsMap[e]
  ),
  isEditorFocused: (t) => (e) => t.focusedEditorsMap[e],
  getIsOnline: (t) => t.online,
  getWindowParams: (t) => t.windowParams,
  getIsNeedAuth: (t) => t.needAuth,
  getLayoutLeftOffset: (t) => t.isTaskPanelOpen ? 354 : 66
}, tft = {
  "uiState/init"({ commit: t }) {
    t("UI_STATE_INIT", rt.IN_PROGRESS), t("SET_ONLINE", globalThis.navigator.onLine), t("UI_STATE_INIT", rt.READY);
  },
  setPanelEditorFocus({ commit: t }, { panelId: e, focused: n }) {
    t(O7, { panelId: e, focused: n }), n && Ie("uiState").panels.focusedPanel !== e && Ie("uiState").panels.setPanelFocused(e);
  },
  setPanelsDragging({ commit: t }, e) {
    t(bF, e);
  },
  removePanelEditorFocus({ commit: t }, e) {
    t(M7, e);
  },
  reloadWorkspaceData({ commit: t }) {
    t(gF, Ie("uiState").root.workspaceRefrehsable);
  },
  setModal({ commit: t }, e) {
    t(Vi, e);
  },
  setSelectedEntry({ commit: t }, { panelId: e, entryId: n }) {
    t(_F, { panelId: e, entryId: n });
  },
  setNeedAuth({ commit: t }, e) {
    t(pF, e);
  },
  setCodeManagerFocus({ commit: t }, e) {
    t(R7, e);
  },
  setWindowParams({ commit: t }, e) {
    t(hF, e);
  },
  setVisibility({ commit: t }, e) {
    t(mF, e);
  },
  setOnline({ commit: t }, e) {
    t(vF, e);
  },
  setInstalled({ commit: t }, e) {
    t(yF, e);
  },
  setTaskPanelOpen({ commit: t }, e) {
    t(wF, e);
  }
}, nft = Dn(["uiState"], {
  state: {
    needAuth: !1,
    modal: !1,
    codeManagerFocused: !1,
    panelsDragging: !1,
    focusedEditorsMap: {},
    swUpdateVisible: !1,
    selectedEntriesMap: {},
    windowParams: {
      height: 0,
      width: 0,
      scrollLeft: 0,
      scrollTop: 0
    },
    visible: !1,
    online: !1,
    isInstalled: !1,
    isTaskPanelOpen: !1
  },
  mutations: Qdt,
  getters: eft,
  actions: tft,
  dependencies: {
    root: {
      getters: ["workspaceRefrehsable"]
    },
    panels: {
      getters: ["focusedPanel"],
      actions: ["setPanelFocused"]
    }
  }
});
function Pj() {
  return {
    init: rt.INITIAL,
    colors: {
      codes: []
    },
    default_dateline_agency: "",
    default_dateline_city: "",
    defaultColorScheme: "white",
    default_news_type_id: 3,
    filters: {},
    groups: [],
    name: "",
    code: "",
    newsEditor: {
      closeOnSubmit: !1,
      fontFamily: "PT Astra Sans",
      fontSize: 18,
      fullscreenNarrowMode: !0,
      colorScheme: null,
      lineHeight: 150,
      defaultWidthMode: 2,
      alwaysVisibleAdditionalSupply: !1
    },
    publishedPanelMode: 1,
    default_recipient_group_id: null,
    default_recipient_user_id: null,
    soundNotifications: {
      enabled: !0,
      sound: "notification-1"
    }
  };
}
const jh = "PROFILE_INIT", kj = "PROFILE_SET_EDITOR_SETTINGS", aw = "PROFILE_SET", Nj = "PROFILE_SET_COLORS", $j = "PROFILE_SET_FILTERS", Dj = "PROFILE_SET_PUBLISHED_PANEL_MODE", Aj = "PROFILE_SET_SOUND_NOTIFICATIONS", Oj = "PROFILE_CLEAR", lw = "PROFILE_SET_DEFAULT_RECIPIENT_GROUP", cw = "PROFILE_SET_DEFAULT_RECIPIENT_USER", rft = {
  [jh](t, e) {
    t.init = e;
  },
  [aw](t, e) {
    const n = {
      ...t,
      ...e,
      newsEditor: {
        ...t.newsEditor,
        ...e.newsEditor
      }
    };
    delete n.panels, Object.entries(n).forEach(([r, s]) => {
      U.set(t, r, s);
    });
  },
  [kj](t, {
    editorSettings: e,
    default_news_type_id: n,
    default_dateline_agency: r,
    default_dateline_city: s
  }) {
    t.newsEditor = {
      ...t.newsEditor,
      ...e
    }, t.default_news_type_id = n || 3, t.default_dateline_agency = r, t.default_dateline_city = s;
  },
  [$j](t, { type: e, value: n }) {
    t.filters = {
      ...t.filters || {},
      [e]: {
        ...lt(t.filters, e, {}),
        ...n || {}
      }
    };
  },
  [Nj](t, { type: e, id: n, color: r, includeChildren: s }) {
    t.colors || (t.colors = {}), t.colors[e] || (t.colors[e] = []), t.colors[e] = t.colors[e].filter((i) => i.id !== n), r !== null && (t.colors = {
      ...t.colors || {},
      [e]: [
        ...lt(t.colors, e, []),
        {
          id: n,
          color: r,
          includeChildren: s
        }
      ]
    });
  },
  [Dj](t, e) {
    t.publishedPanelMode = e;
  },
  [Aj](t, e) {
    U.set(t, "soundNotifications", e);
  },
  [Oj](t) {
    Object.entries(Pj()).forEach(([e, n]) => {
      U.set(t, e, n);
    });
  },
  [lw](t, e) {
    t.default_recipient_group_id = e;
  },
  [cw](t, e) {
    t.default_recipient_user_id = e;
  }
};
function sft(t) {
  if (!t) return t;
  const e = t.filter(({ type: n }) => n === "search");
  return e != null && e.length && e.forEach((n) => {
    n.supply.right.forEach((r) => {
      r != null && r.settings && r.settings.visible && (r.settings.visible = !1);
    });
  }), t;
}
function GD(t, e, n, r, s, i, o = !0) {
  let a = t == null ? void 0 : t.data, l = a != null && a.panels ? [...a.panels.filter((f) => f.type !== "tasks")] : [...r];
  const c = lt(a, "fullscreen.panelId"), u = lt(a, "fullscreen.narrow");
  delete a.panels, delete a.fullscreen, o && (l = sft(l));
  const d = { ...a };
  if (s(l), c) {
    const f = n.name === "newsItem", p = l.find((m) => m.id === c), h = p && p.dataId;
    f && h === n.params.id ? i({
      panel: p,
      fullscreen: !0
    }) : i({
      panel: null,
      fullscreen: !1
    });
  }
  return d.newsEditor && u !== null && (d.newsEditor.fullscreenNarrowMode = u), d.newsEditor && d.newsEditor.defaultWidthMode === null && (d.newsEditor.defaultWidthMode = Cr.newsItem.wide), a = d, {
    profile: a,
    panels: l
  };
}
const ift = {
  async init({ commit: t }) {
    return t(jh, rt.IN_PROGRESS), Ie("userProfile").auth.isAuthorized ? (t(jh, rt.READY), rt.READY) : (t(jh, rt.INITIAL), rt.INITIAL);
  },
  async installProfile({ commit: t, dispatch: e }, { profile: n, initial: r = !1 }) {
    const s = Ie("userProfile");
    n.panels.forEach((a) => {
      var l;
      (a == null ? void 0 : a.type) === "newsItem" && ((l = a == null ? void 0 : a.settings) == null ? void 0 : l.widthScaleFactor) !== Cr.newsItem.default && (a.settings.widthScaleFactor = Cr.newsItem.wide);
    });
    const i = GD(
      { data: n },
      e,
      cs.currentRoute,
      s.panels.getPanels,
      () => null,
      s.panels.setPanelFullscreen,
      r
    );
    n = i.profile;
    const o = i.panels;
    t(aw, n), s.panels.setPanels(o);
  },
  triggerProfileUpdate(t, e) {
  },
  updateProfile({ state: t, dispatch: e }) {
    const n = Ie("userProfile"), r = GD(
      { data: Or(t) },
      e,
      cs.currentRoute,
      n.panels.getPanels,
      () => null,
      n.panels.setPanelFullscreen,
      !1
    ), s = r.profile;
    s.panels = r.panels, e("triggerProfileUpdate", s);
  },
  setProfileFilters({ commit: t, dispatch: e }, { type: n, value: r }) {
    t($j, { type: n, value: r }), e("updateProfile");
  },
  setProfileColors({ commit: t, dispatch: e }, { type: n, id: r, color: s, includeChildren: i }) {
    t(Nj, { type: n, id: r, color: s, includeChildren: i });
    const o = Ie("userProfile");
    switch (n) {
      case "codes":
        o.news.setNewsCodesColorMap(
          o.news.getNewsSetListByType("published")
        );
    }
    e("updateProfile");
  },
  setProfile({ commit: t }, e) {
    t(aw, e);
  },
  clearProfile({ commit: t }) {
    t(Oj);
  },
  setProfileEditorSettings({ commit: t, dispatch: e }, {
    editorSettings: n,
    default_news_type_id: r,
    default_dateline_agency: s,
    default_dateline_city: i
  }) {
    t(kj, {
      editorSettings: n,
      default_news_type_id: r,
      default_dateline_agency: s,
      default_dateline_city: i
    }), e("updateProfile");
  },
  setProfilePublishedPanelSettings({ commit: t, dispatch: e }, { mode: n, settings: r }) {
    t(Dj, n), t(Aj, r), e("updateProfile");
  },
  setProfileDefaultRecipientGroup({ commit: t, dispatch: e }, n) {
    t(lw, n), t(cw, null), e("updateProfile");
  },
  setProfileDefaultRecipientUser({ commit: t, dispatch: e }, n) {
    t(cw, n), t(lw, null), e("updateProfile");
  }
};
function oft(t, e, n, r) {
  for (var s = -1, i = t == null ? 0 : t.length; ++s < i; ) {
    var o = t[s];
    e(r, o, n(o), t);
  }
  return r;
}
var aft = oft, lft = T2;
function cft(t, e, n, r) {
  return lft(t, function(s, i, o) {
    e(r, s, n(s), o);
  }), r;
}
var uft = cft, dft = aft, fft = uft, pft = ta, hft = Wr;
function mft(t, e) {
  return function(n, r) {
    var s = hft(n) ? dft : fft, i = e ? e() : {};
    return s(n, t, pft(r), i);
  };
}
var vft = mft, gft = Bv, yft = vft, bft = yft(function(t, e, n) {
  gft(t, n, e);
}), _ft = bft;
const wft = /* @__PURE__ */ Et(_ft);
var Sft = Bv, Ift = _L, Eft = ta;
function xft(t, e) {
  var n = {};
  return e = Eft(e), Ift(t, function(r, s, i) {
    Sft(n, s, e(r, s, i));
  }), n;
}
var Cft = xft;
const Tft = /* @__PURE__ */ Et(Cft), Pft = {
  isUserInGroups: (t) => (e) => {
    let n = !1;
    return e.forEach(({ group: r }) => {
      const s = r.id;
      t.groups.find(({ group: i }) => s === i.id) && (n = !0);
    }), n;
  },
  isUserInGroup: (t) => (e) => !!t.groups.find(({ group: n }) => e === n.id),
  usernameFormatted: (t) => Ps(t.name),
  userName: (t) => t.name,
  // formatUsername??
  getProfile: (t) => t,
  colorScheme: (t) => t.newsEditor.colorScheme || t.defaultColorScheme,
  defaultPanelWidth: (t) => {
    var e;
    return (e = t.newsEditor) == null ? void 0 : e.defaultWidthMode;
  },
  getCodeFilters: (t) => {
    var e, n;
    return ((n = (e = t.filters) == null ? void 0 : e.published) == null ? void 0 : n.codes) ?? null;
  },
  getAuthorsFilters: (t) => {
    var e, n, r, s;
    return {
      authors: ((n = (e = t.filters) == null ? void 0 : e.published) == null ? void 0 : n.authors) ?? null,
      groups: ((s = (r = t.filters) == null ? void 0 : r.published) == null ? void 0 : s.authorGroups) ?? null
    };
  },
  getHideRepublicationsFilter: (t) => {
    var e, n;
    return ((n = (e = t.filters) == null ? void 0 : e.published) == null ? void 0 : n.hideRepublications) ?? !1;
  },
  getSendersFilters: (t) => {
    var e, n;
    return ((n = (e = t.filters) == null ? void 0 : e.originals) == null ? void 0 : n.senders) ?? null;
  },
  getRecipientsFilters: (t) => {
    var e, n, r, s;
    return {
      users: (n = (e = t.filters) == null ? void 0 : e.originals) == null ? void 0 : n.recipientUsers,
      groups: (s = (r = t.filters) == null ? void 0 : r.originals) == null ? void 0 : s.recipientGroups
    };
  },
  getProfileFilters: (t) => t.filters,
  getWaitingFilters: (t) => t.filters.news_waiting,
  getColorsByType: (t) => (e) => Tft(wft(lt(t, `colors.${e}`, {}), "id"), (n) => ({
    value: `#${n.color}`,
    includeChildren: n.includeChildren
  })),
  getDefaultNewsTypeId: (t) => t.default_news_type_id,
  getDefaultDateline: (t) => ({
    city: t.default_dateline_city,
    agency: t.default_dateline_agency
  }),
  isAdditionalSupplyAlwaysVisible: (t) => {
    var e;
    return (e = t.newsEditor) == null ? void 0 : e.alwaysVisibleAdditionalSupply;
  },
  getDefaultRecipientId: (t) => t.default_recipient_group_id || t.default_recipient_user_id,
  getDefaultRecipientUserId: (t) => t.default_recipient_user_id,
  getDefaultRecipientGroupId: (t) => t.default_recipient_group_id,
  getUserGroups: (t) => t.groups,
  getGroupItems: (t) => {
    const e = BR({
      id: 0,
      children: t.groups.map(({ group: n }) => ({
        children: [],
        isGroup: !0,
        ...n
      }))
    });
    return delete e[0], e;
  }
}, kft = Dn(["userProfile"], {
  namespaced: !0,
  state: Pj(),
  actions: ift,
  mutations: rft,
  getters: Pft,
  dependencies: {
    auth: {
      getters: ["isAuthorized", "getUserId", "getUserLogin"]
    },
    panels: {
      actions: ["setPanels", "setPanelFullscreen"],
      getters: ["getPanels"]
    },
    news: {
      getters: ["getNewsSetListByType"],
      actions: ["setNewsCodesColorMap"]
    },
    uiState: {
      getters: ["getIsOnline"]
    }
  }
}), Nft = [
  ...Object.keys(pB).map((t) => `news/${t}`),
  "news/drafts/addCodes",
  "news/drafts/deleteCodes",
  "news/drafts/addAuthors",
  "news/drafts/deleteAuthor",
  "news/drafts/validateEmbargo"
], $ft = ["news/drafts/saveDraft"], Dft = (t) => (t.subscribeAction({
  before: (e) => {
    if ($ft.includes(e.type)) {
      const n = e.payload.newsItemId || e.payload;
      t.dispatch("news/syncDraft", n);
    }
  },
  after: (e) => {
    if (Nft.includes(e.type)) {
      const n = e.payload.newsItemId || e.payload.id || e.payload;
      t.dispatch("news/syncDraft", n);
    }
    if (e.type === "news/setNewsItem") {
      const n = e.payload.newsItemId || e.payload.id || e.payload;
      Dt(t.state.news.drafts, { newsItemId: n }) && t.dispatch("news/syncDraft", n);
    }
  }
}), t), Aft = (t) => {
  function e() {
    const n = t.state.news.expired, r = Object.values(t.state.news.items).filter((s) => {
      const i = t.getters["news/getNewsItemCurrentVersion"](s.id);
      if (i) {
        if (i.publish_at === null) return !1;
        const o = /* @__PURE__ */ new Date();
        return new Date(i.publish_at) <= o && !i.is_postponed;
      }
      return !1;
    }).map((s) => s.id);
    Q5(n, r) || t.commit(`news/${VI}`, r);
  }
  return setInterval(() => {
    Promise.resolve().then(e);
  }, 3e3), t;
}, Gr = {
  $gcNewsbreaksList: (t) => t.newsbreaks ? [...t.newsbreaks.list] : [],
  $gcNewsbreakLeadsList: (t) => t.newsbreaks ? Object.values(t.newsbreaks.items).filter((e) => e.lead).map((e) => e.lead.id) : [],
  $gcPanels: (t) => t.panels ? [...t.panels.data] : [],
  $gcFlowSupplyLeads: (t, e) => t.panels ? t.panels.data.filter(({ type: n }) => n === "flow").reduce((n, r) => {
    const s = e["panels/getPanelVisibleSupplies"](r);
    return Array.prototype.push.apply(
      n,
      s.map(({ dataId: i }) => i)
    ), n;
  }, []) : [],
  $gcFlowsLeadsMap: (t) => t.flows ? { ...t.flows.leadsMap } : {},
  $gcNewsNewsbreaks: (t) => t.news ? Object.keys(t.news.items).filter((e) => t.news.items[e].newsbreak).map((e) => t.news.items[e].newsbreak.id) : [],
  $gcNewsMy: (t) => t.news ? [...t.news.sets.my.list] : [],
  $gcNewsWaiting: (t) => t.news ? [...t.news.sets.waiting.list] : [],
  $gcNewsInProgress: (t) => t.news ? [...t.news.sets.inProgress.list] : [],
  $gcNewsDisposed: (t) => t.news ? [...t.news.sets.disposed.list] : [],
  $gcNewsEmbargo: (t) => t.news ? [
    ...t.news.sets.embargo.list,
    ...t.news.sets.embargo.displayedList.filter((e) => !t.news.sets.embargo.list.includes(e))
  ] : [],
  $gcNewsPublished: (t) => t.news ? [...t.news.sets.published.list] : [],
  $gcNewsFromNewsbreaks: (t) => t.newsbreaks ? y2e(Object.values(t.newsbreaks.newsMap)) : [],
  $gcAsoiNotesReceived: (t) => t.asoi ? [...t.asoi.received.list] : [],
  $gcAsoiNotesSent: (t) => t.asoi ? [...t.asoi.sent.list] : [],
  $gcNewsSearch: (t) => t.news ? [...t.news.sets.search.list] : []
}, Ks = {
  NEWS_INCREMENT_REF_COUNTER: `news/${YF}`,
  NEWS_DECREMENT_REF_COUNTER: `news/${ZF}`,
  LEADS_INCREMENT_REF_COUNTER: `leads/${zF}`,
  LEADS_DECREMENT_REF_COUNTER: `leads/${UF}`,
  NEWSBREAKS_INCREMENT_REF_COUNTER: `newsbreaks/${gj}`,
  NEWSBREAKS_DECREMENT_REF_COUNTER: `newsbreaks/${yj}`,
  ASOI_NOTES_INCREMENT_REF_COUNTER: U7,
  ASOI_NOTES_DECREMENT_REF_COUNTER: G7,
  ASOI_NOTES_SENT_INCREMENT_REF_COUNTER: X7,
  ASOI_NOTES_SENT_DECREMENT_REF_COUNTER: K7,
  ASOI_NOTES_EMBARGO_INCREMENT_REF_COUNTER: tF,
  ASOI_NOTES_EMBARGO_DECREMENT_REF_COUNTER: nF
}, Hb = {
  NEWS_CLEAR_UNUSED: `news/${Ilt}`,
  LEADS_CLEAR_UNUSED: `leads/${dlt}`,
  NEWSBREAKS_CLEAR_UNUSED: `newsbreaks/${yut}`
}, Oft = (t) => {
  const e = {};
  function n(s, i) {
    i.length !== 0 && globalThis.requestIdleCallback(
      () => {
        let o = Ks[`${s.toUpperCase()}_DECREMENT_REF_COUNTER`];
        t.commit(o, i);
      },
      { timeout: 5e3 }
    );
  }
  function r(s, i, o) {
    const a = Rh(i, o), l = [];
    for (let c of a)
      if (o.includes(c) && !i.includes(c) && l.push(c), i.includes(c) && !o.includes(c)) {
        const u = Ks[`${s.toUpperCase()}_INCREMENT_REF_COUNTER`];
        t.commit(u, [c]);
      }
    n(s, l);
  }
  return t.watch(Gr.$gcNewsbreakLeadsList, (s, i) => {
    r("leads", s, i);
  }), t.watch(Gr.$gcFlowsLeadsMap, (s, i) => {
    const o = Rh(Object.keys(s), Object.keys(i));
    let a = [];
    for (let l of o) {
      if (Object.keys(s).includes(l) && !Object.keys(i).includes(l) && (t.commit(
        Ks.LEADS_INCREMENT_REF_COUNTER,
        s[l].list
      ), !e[l])) {
        const c = (u) => (d) => [
          ...d.flows.leadsMap[u].list
        ];
        t.getters[`flow${l}LeadsList`] = c(l), e[l] = [
          t.watch(
            t.getters[`flow${l}LeadsList`],
            r.bind(null, "leads")
          )
        ];
      }
      Object.keys(i).includes(l) && !Object.keys(s).includes(l) && (i[l] && (a = a.concat(i[l].list)), e[l].forEach((c) => c()), delete e[l]);
    }
    n("leads", un(a));
  }), t.watch(Gr.$gcPanels, (s, i) => {
    if (s && s.length !== i.length) {
      const o = Rh(s, i), a = o.filter((d) => d.type === ve.lead);
      for (let d of a)
        i.includes(d) && !s.includes(d) && n("leads", [d.dataId]), s.includes(d) && !i.includes(d) && t.commit(Ks.LEADS_INCREMENT_REF_COUNTER, [d.dataId]);
      const l = o.filter((d) => d.type === ve.newsbreak);
      for (let d of l)
        i.includes(d) && !s.includes(d) && n("newsbreaks", [d.dataId]), s.includes(d) && !i.includes(d) && t.commit(Ks.NEWSBREAKS_INCREMENT_REF_COUNTER, [
          d.dataId
        ]);
      const c = o.filter((d) => d.type === ve.newsItem);
      for (let d of c)
        i.includes(d) && !s.includes(d) && n("news", [d.dataId]), s.includes(d) && !i.includes(d) && t.commit(Ks.NEWS_INCREMENT_REF_COUNTER, [d.dataId]);
      const u = o.filter(
        (d) => [ve.asoiNote, ve.asoiNoteSent, ve.asoiNoteEmbargo].includes(
          d.type
        )
      );
      for (let d of u) {
        if (i.includes(d) && !s.includes(d)) {
          const p = ("asoi_notes_" + au(d.type)).replace("_received", "");
          n(p, [d.dataId]);
        }
        if (s.includes(d) && !i.includes(d)) {
          const f = H4(d.type) ? Ks.ASOI_NOTES_SENT_INCREMENT_REF_COUNTER : Ks.ASOI_NOTES_INCREMENT_REF_COUNTER;
          t.commit(f, [d.dataId]);
        }
      }
    }
  }), t.watch(Gr.$gcNewsNewsbreaks, r.bind(null, "newsbreaks")), t.watch(Gr.$gcFlowSupplyLeads, r.bind(null, "leads")), t.watch(Gr.$gcNewsbreaksList, r.bind(null, "newsbreaks")), t.watch(Gr.$gcNewsMy, r.bind(null, "news")), t.watch(Gr.$gcNewsWaiting, r.bind(null, "news")), t.watch(Gr.$gcNewsInProgress, r.bind(null, "news")), t.watch(Gr.$gcNewsDisposed, r.bind(null, "news")), t.watch(Gr.$gcNewsPublished, r.bind(null, "news")), t.watch(Gr.$gcNewsEmbargo, r.bind(null, "news")), t.watch(Gr.$gcNewsFromNewsbreaks, r.bind(null, "news")), t.watch(
    Gr.$gcAsoiNotesReceived,
    r.bind(null, "asoi_notes")
  ), t.watch(
    Gr.$gcAsoiNotesSent,
    r.bind(null, "asoi_notes_sent")
  ), t.watch(Gr.$gcNewsSearch, r.bind(null, "news")), t.subscribe((s, i) => {
    switch (s.type) {
      case Hb.LEADS_CLEAR_UNUSED:
        n("leads", s.payload);
        break;
      case Hb.NEWSBREAKS_CLEAR_UNUSED:
        n("newsbreaks", s.payload);
        break;
      case Hb.NEWS_CLEAR_UNUSED:
        n("news", s.payload);
        break;
      case Ks.LEADS_DECREMENT_REF_COUNTER:
        for (let o = 0; o < s.payload.length; o++)
          i.leads.refs[s.payload[o]] === 0 && (delete i.leads.items[s.payload[o]], delete i.leads.refs[s.payload[o]]);
        break;
      case Ks.NEWSBREAKS_DECREMENT_REF_COUNTER:
        for (let o = 0; o < s.payload.length; o++)
          i.newsbreaks.refs[s.payload[o]] === 0 && (delete i.newsbreaks.refs[s.payload[o]], delete i.newsbreaks.items[s.payload[o]], delete i.newsbreaks.uiState.newsShowedMap[s.payload[o]], i.auth.isLoggedIn && i.auth.isAuthorized && s.payload[o] && i.newsbreaks.newsMap[s.payload[o]] && U.delete(i.newsbreaks.newsMap[s.payload[o]]));
        break;
      case Ks.NEWS_DECREMENT_REF_COUNTER:
        for (let o = 0; o < s.payload.length; o++)
          if (i.news.refs[s.payload[o]] === 0) {
            const a = i.news.versions.newsMap[s.payload[o]];
            a && a.forEach((c) => {
              delete i.news.versions.items[c], delete i.news.search.versions[s.payload[o]];
            }), delete i.news.versions.newsMap[s.payload[o]];
            const l = i.news.drafts.newsMap[s.payload[o]];
            l && (delete i.news.drafts.embargoFormsMap[l], delete i.news.drafts.embargoValidMap[l], delete i.news.drafts.publicationMap[l], delete i.news.drafts.textCodesMap[l], delete i.news.drafts.predictCodesMap[l], delete i.news.drafts.validationErrorsMap[l], delete i.news.drafts.newsMap[l], delete i.news.drafts.items[l], delete i.news.drafts.embargoStateMap[l]), delete i.news.items[s.payload[o]], delete i.news.refs[s.payload[o]], delete i.news.links.map[s.payload[o]], Object.keys(i.news.links.map).forEach((c) => {
              const u = i.news.links.map[c].filter(
                (d) => d.news_id !== s.payload[o]
              );
              t.commit(`news/links/${JB}`, {
                newsItemId: c,
                links: u
              });
            });
          }
        break;
      case Ks.ASOI_NOTES_DECREMENT_REF_COUNTER:
        for (let o = 0; o < s.payload.length; o++)
          i.asoi.received.refs[s.payload[o]] === 0 && (delete i.asoi.received.refs[s.payload[o]], delete i.asoi.received.list[s.payload[o]], delete i.asoi.received.items[s.payload[o]]);
        break;
      case Ks.ASOI_NOTES_SENT_DECREMENT_REF_COUNTER:
        for (let o = 0; o < s.payload.length; o++)
          i.asoi.sent.refs[s.payload[o]] === 0 && (delete i.asoi.sent.refs[s.payload[o]], delete i.asoi.sent.list[s.payload[o]], delete i.asoi.sent.items[s.payload[o]]);
        break;
    }
  }), t;
}, Mft = (t) => (jze(t, {
  // TODO: перенести в конфиг модуля
  triggers: ["auth/logout"],
  exclude: ["uiState", "auth"]
}), t), Rft = (t) => {
  const e = {};
  function n(s) {
    e[s] = setInterval(() => {
      t.dispatch("news/drafts/saveDraft", { newsItemId: s });
    }, t.state.news.autoSaveInterval);
  }
  function r(s) {
    clearInterval(e[s]), delete e[s];
  }
  return t.subscribeAction({
    before: (s, i) => {
      if (t.getters["news/isInitialized"]) {
        if (s.type === "panels/removePanel") {
          const o = i.panels.data.find(
            (a) => s.payload.panelId === a.id
          );
          o && r(o.dataId);
        }
        if (s.type === "setPanelEditorFocus") {
          const o = i.uiState.focusedEditorsMap[s.payload.panelId], a = i.panels.data.find(
            (u) => s.payload.panelId === u.id
          ), l = a ? i.news.drafts.newsMap[a.dataId] : null, c = i.news.drafts.items[l];
          if (c) {
            if (i.references.News.Status[c.version.status_id].name === "PUBLISHED") {
              r(c.newsItemId);
              return;
            }
            s.payload.focused !== o && !i.news.drafts.publicationMap[c.id] && (s.payload.focused ? (r(c.newsItemId), n(c.newsItemId)) : (t.dispatch("news/drafts/saveDraft", { draftId: c.id }), r(c.newsItemId)));
          }
        }
      }
    },
    after: (s) => {
      var i, o;
      t.getters["news/isInitialized"] && t.getters["news/isInitialized"] && (t.getters["news/getCanUserEditNewsItem"]((i = s.payload) == null ? void 0 : i.id) || r((o = s.payload) == null ? void 0 : o.id));
    }
  }), t;
}, Lft = (t) => {
  let e = null;
  function n(s) {
    e && r(), e = setInterval(() => {
      t.dispatch("canvases/saveCanvas", { canvasId: s });
    }, t.state.news.autoSaveInterval);
  }
  function r() {
    clearInterval(e), e = null;
  }
  return t.subscribeAction({
    before: (s, i) => {
      if (t.getters["canvases/isInitialized"]) {
        if (s.type === "setPanelEditorFocus") {
          const o = i.panels.data.find(
            (c) => s.payload.panelId === c.id
          );
          if ((o == null ? void 0 : o.type) !== ve.newsCanvas)
            return;
          const a = i.uiState.focusedEditorsMap[s.payload.panelId], l = t.getters["canvases/getCurrentCanvas"];
          l && s.payload.focused !== a && (s.payload.focused ? n(l.id) : (t.dispatch("canvases/saveCanvas", { canvasId: l.id }), r()));
        }
        if (s.type === "panels/removePanel") {
          const o = i.panels.data.find(
            (a) => s.payload.panelId === a.id
          );
          (o == null ? void 0 : o.type) === ve.newsCanvas && r();
        }
      }
    }
  }), t;
}, Fft = (t) => (t.$_newsEditors = {}, t), Bft = (t) => (t.watch(
  (e) => {
    var n;
    return (n = e.panels) == null ? void 0 : n.uiState.fullscreen;
  },
  (e, n) => {
    e !== n && t.dispatch("userProfile/updateProfile");
  },
  { flush: "post" }
), t.subscribeAction({
  after: (e) => {
    [
      "panels/addPanel",
      "panels/removePanel",
      "panels/togglePanelSize",
      "panels/setPanelCompact",
      "panels/setPanelWidthScaleFactor",
      "panels/setPanelColor",
      "panels/setPanelName",
      "panels/setPanelActiveTabIndex",
      "panels/showSupply",
      "panels/hideSupply"
    ].includes(e.type) && t.dispatch("userProfile/updateProfile");
  }
}), t);
function YD(t) {
  const e = s4(t);
  for (const n in e) {
    let r = e[n];
    /^([a-fA-F0-9]{2}){3,4}$/.test(r) && (r = "#" + r), document.documentElement.style.setProperty(`--theme-${n}`, r);
  }
}
function jft(t) {
  const e = () => t.getters["userProfile/colorScheme"];
  return YD(e()), t.watch(e, YD), t;
}
const ZD = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
class Wft {
  constructor() {
    Ao(this, "_onVisibilityChange_handler", this._onVisibilityChange.bind(this));
    Ao(this, "_debounced_detectActivity", jf(this.detectActivity.bind(this), 500, {
      leading: !0,
      trailing: !0
    }));
    this._timer = null, this._timeout = uT, this._timeStamp = null, this._idleDetController = new AbortController();
  }
  async watch() {
    ZD.forEach(
      (e) => document.addEventListener(e, this._debounced_detectActivity, !0)
    ), document.addEventListener(
      "visibilitychange",
      this._onVisibilityChange_handler
    ), this._runIdleDetector();
  }
  stopWatch() {
    this._debounced_detectActivity.cancel(), ZD.forEach(
      (e) => document.removeEventListener(e, this._debounced_detectActivity, !0)
    ), document.removeEventListener(
      "visibilitychange",
      this._onVisibilityChange_handler
    ), this._stopIdleDetector(), this._stopUpdate();
  }
  detectActivity() {
    this._setTimestamp(), this._timer || (this.sendUpdate(), this._timer = setInterval(() => this._update(), this._timeout));
  }
  sendUpdate() {
    if (Fa.$sessionId)
      try {
        $e.user.sendUserOnlineStatus();
      } catch (e) {
        console.error(e);
      }
  }
  _setTimestamp() {
    this._timeStamp = Date.now();
  }
  _onVisibilityChange() {
    document.visibilityState === "visible" ? this.detectActivity() : this._stopUpdate();
  }
  _update() {
    Date.now() - this._timeStamp > this._timeout ? this._stopUpdate() : this.sendUpdate();
  }
  _stopUpdate() {
    clearInterval(this._timer), this._timer = null;
  }
  _runIdleDetector() {
    if (!("IdleDetector" in window))
      return;
    const e = async () => {
      try {
        if (await window.IdleDetector.requestPermission() !== "granted") {
          Fa.dispatch("addMessage", {
            type: "warning",
            text: "Разрешение на обнаружение активности нужно для определения и отображения вашего онлайн статуса другим пользователям"
          });
          return;
        }
        const r = this._idleDetController.signal, s = new window.IdleDetector();
        s.addEventListener("change", () => {
          const i = s.userState, o = s.screenState;
          i === "active" && o === "unlocked" ? this.detectActivity() : this._stopUpdate();
        }), await s.start({
          threshold: uT,
          signal: r
        });
      } catch (n) {
        console.error(n.name, n.message);
      }
    };
    document.addEventListener(
      "pointerdown",
      // https://developer.mozilla.org/en-US/docs/Web/Security/User_activation
      e,
      {
        once: !0,
        passive: !0
      }
    );
  }
  _stopIdleDetector() {
    this._idleDetController.abort();
  }
}
const Vb = new Wft();
function Hft(t) {
  t.subscribe((e) => {
    switch (e.type) {
      case `auth/${WI}`:
        e.payload === !0 && (Vb.detectActivity(), Vb.watch());
        break;
      case `auth/${HI}`:
      case `auth/${PF}`:
        Vb.stopWatch();
        break;
    }
  });
}
const Vft = (t) => {
  function e(s) {
    var i, o, a, l, c, u;
    if (s.payload.data && [
      (i = t.getters["references/newsStatusesByName"].PUBLISHED) == null ? void 0 : i.id,
      10
      // TODO: PUBLISHTED, добавляем руками для уверенности
    ].includes(s.payload.data.type_id))
      return !0;
    if (s.subType && s.fromContext && s.fromContext === window.contextId) {
      const d = ["NEWS", "USER_NEWS"];
      return d.includes(s.subType) && ((a = (o = s.payload) == null ? void 0 : o.data) == null ? void 0 : a.type_id) === 2 && ((u = (c = (l = s.payload) == null ? void 0 : l.data) == null ? void 0 : c.news) == null ? void 0 : u.parent_rel_type_id) === 6 ? !0 : !d.includes(s.subType) && !s.subType.includes("SPECIFIC_NEWS");
    }
    return !0;
  }
  async function n(s) {
    var i, o, a, l, c, u, d, f, p, h, m;
    if (e(s.data.message))
      switch (s.data.message.subType) {
        case "NEWS":
        case "USER_NEWS":
          t.dispatch("news/processNewsMessage", {
            payload: s.data.message.payload.data,
            subId: s.data.message.subKey,
            datetime: ((o = (i = s == null ? void 0 : s.data.message) == null ? void 0 : i.payload) == null ? void 0 : o.datetime) ?? null
          });
          break;
        case "ASOI_NOTES":
          t.dispatch("processAsoiNoteMessage", {
            payload: s.data.message.payload.data
          });
          break;
        case "USER_ASOI_NOTES":
          t.dispatch("processAsoiNoteMessage", {
            payload: await Kn.process("asoiNotes", s.data.message.payload.data)
          });
          break;
        case "USER_NEWSBREAKS":
          break;
        case "USER_NOTIFICATIONS":
          if (((u = (c = (l = (a = s == null ? void 0 : s.data) == null ? void 0 : a.message) == null ? void 0 : l.payload) == null ? void 0 : c.data) == null ? void 0 : u.type_id) === 100) {
            const v = (p = (f = (d = s == null ? void 0 : s.data) == null ? void 0 : d.message) == null ? void 0 : f.payload) == null ? void 0 : p.data.news_id;
            t.dispatch("getChatMessages", {
              newsItemId: v,
              params: {
                cursor: null,
                limit: 100
              }
            });
          }
          break;
        case "FLOW":
          t.dispatch("leads/pushLead", {
            payload: await Kn.process("leads", s.data.message.payload.data.lead),
            subId: s.data.message.subKey
          });
          break;
        case "SPECIFIC_NEWS":
          t.dispatch("news/processNewsMessage", {
            payload: s.data.message.payload.data,
            subId: s.data.message.subKey,
            datetime: ((m = (h = s == null ? void 0 : s.data.message) == null ? void 0 : h.payload) == null ? void 0 : m.datetime) ?? null
          });
          break;
      }
  }
  async function r(s) {
    if (t.state.init === 0)
      return !1;
    if (["openNewsItem", "openCanvas"].includes(s.data.action))
      if (rv.shouldOpenNewsInCurrentTab(s.data.contextId))
        window.extensionId && chrome.runtime.sendMessage(
          window.extensionId,
          {
            event: "focusTab",
            timestamp: s.data.timestamp
            // set in src/ContextApp/services/legacyBridge.ts
          }
        );
      else
        return !0;
    switch (s.data.action) {
      case "openNewsItem":
        t.dispatch("panels/addPanel", {
          panel: { type: ve.newsItem, dataId: s.data.id }
        });
        break;
      case "updateToken":
        t.dispatch("auth/updateTokens", {
          accessToken: s.data.accessToken,
          refreshToken: s.data.refreshToken
        });
        break;
      case "sendNews":
        s.data.contextId === window.contextId && t.dispatch("news/sendNewsItemToEdit", s.data.payload);
        break;
      case "sendToAsoi":
        s.data.contextId === window.contextId && t.dispatch("news/sendNewsItemToASOI", s.data.payload);
        break;
      case "hideShareModal":
        s.data.contextId === window.contextId && t.dispatch("setModal", !1);
        break;
      case "openCanvas":
        t.dispatch("panels/addPanel", { panel: { type: ve.newsCanvas, dataId: ve.newsCanvas } });
        break;
      case "gateway":
        await n(s);
        break;
    }
    return !0;
  }
  return Aa.addOnMessage(r), t.subscribeAction({
    after: (s) => {
      s.type === "auth/logout" && Aa.sendMessage({
        action: "oldLogout"
      }), s.type === "userProfile/triggerProfileUpdate" && Aa.sendMessage({
        action: "updateProfile",
        profile: s.payload
      });
    }
  }), t;
};
U.use(a5);
const Mj = new a5.Store({
  // strict: true,
  state: oat(),
  mutations: {
    [xD](t) {
      t.appData["c00lH@cker"] = !t.appData["c00lH@cker"];
    },
    [ED](t, e) {
      t.initialLoaded = e;
    },
    [hat](t) {
      t.messageHubInitialized = !0;
    },
    [CD](t, e) {
      t.init = e;
    }
  },
  actions: {
    toggleHackerInterface({ commit: t }) {
      t(xD);
    },
    setInitialLoaded({ commit: t }, e) {
      t(ED, e);
    },
    appInit({ commit: t }, e) {
      t(CD, e);
    }
  },
  getters: {
    ...aat,
    ...Gr,
    initialized: (t) => t.initialLoaded && t.messageHubInitialized
  },
  modules: {
    asoi: bat,
    auth: xat,
    authorsModal: Pat,
    canvases: Dat,
    chat: Rat,
    flows: ilt,
    historyModal: llt,
    leads: mlt,
    messages: _lt,
    news: hut,
    newsbreaks: Sut,
    notifications: Nut,
    panels: ddt,
    people: mdt,
    references: bdt,
    relationsModal: Idt,
    shareModal: Udt,
    sources: qdt,
    uiState: nft,
    userProfile: kft
  },
  plugins: [
    Mft,
    jft,
    Dft,
    Aft,
    Oft,
    Rft,
    Lft,
    Fft,
    Bft,
    Hft,
    Vft
  ]
}), zft = () => Mj, Fa = Mj;
async function Uft(t, e) {
  return !C0.isAuth(t.url) && !C0.isNonGuardedRoute(t.url) && (await e.getRefresher(), t.headers.Authorization = `Bearer ${Fa.state.auth.accessToken}`, t.headers["X-Session-ID"] = Fa.$sessionId, t.headers["X-Correlation-Id"] = `${Fa.$sessionId}--${window.contextId}`), t;
}
async function Gft(t, e, n) {
  const s = n + JSON.stringify(t.request.params);
  return e.timeoutRetries[s] || (e.timeoutRetries[s] = 0), e.timeoutRetries[s] < 3 ? (e.timeoutRetries[s]++, await T0(2e3), e.req(t.request)) : (delete e.timeoutRetries[s], t.body = { data: { errors: [{ title: "Таймаут запроса" }] } }, Promise.reject(t));
}
var YI = { exports: {} }, Yft = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function ZI(t) {
  this.message = t;
}
ZI.prototype = new Error();
ZI.prototype.name = "InvalidCharacterError";
function Zft(t) {
  var e = String(t).replace(/=+$/, "");
  if (e.length % 4 == 1)
    throw new ZI("'atob' failed: The string to be decoded is not correctly encoded.");
  for (
    var n = 0, r, s, i = 0, o = "";
    // get next character
    s = e.charAt(i++);
    // character found in table? initialize bit storage and add its ascii value;
    ~s && (r = n % 4 ? r * 64 + s : s, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    n++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * n & 6)) : 0
  )
    s = Yft.indexOf(s);
  return o;
}
var Xft = typeof window < "u" && window.atob && window.atob.bind(window) || Zft, Rj = Xft;
function Kft(t) {
  return decodeURIComponent(Rj(t).replace(/(.)/g, function(e, n) {
    var r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
var Jft = function(t) {
  var e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return Kft(e);
  } catch {
    return Rj(e);
  }
}, qft = Jft;
function Sf(t) {
  this.message = t;
}
Sf.prototype = new Error();
Sf.prototype.name = "InvalidTokenError";
YI.exports = function(t, e) {
  if (typeof t != "string")
    throw new Sf("Invalid token specified");
  e = e || {};
  var n = e.header === !0 ? 0 : 1;
  try {
    return JSON.parse(qft(t.split(".")[n]));
  } catch (r) {
    throw new Sf("Invalid token specified: " + r.message);
  }
};
YI.exports.InvalidTokenError = Sf;
var Qft = YI.exports;
const ept = /* @__PURE__ */ Et(Qft);
async function tpt(t) {
  var n, r;
  if ((r = (n = t.body) == null ? void 0 : n.data) != null && r.errors)
    return t;
  let e;
  try {
    e = ept(t.body.data.access_token);
  } catch (s) {
    t.body = { data: { errors: [s] } };
  }
  if (!t.body.data.errors) {
    const s = JSON.parse(t.request.body);
    t.body.data = {
      accessToken: t.body.data.access_token,
      login: s.username,
      permissions: e.permissions,
      refreshToken: t.body.data.refresh_token,
      userId: e.sub ? Number(e.sub) : null
    };
  }
  return t;
}
async function npt(t, e, n) {
  var r, s, i;
  if (t.body.errors && t.body.errors.length && (t.body.errors[0].code === "JWT_INVALID_TOKEN" || t.body.errors[0].code === "JWT_EXPIRED_TOKEN")) {
    let o;
    try {
      o = await n.getRefresher();
    } catch {
      o = null;
    }
    if (o === null && (n.refresher = e.dispatch("auth/refresh"), o = await n.getRefresher()), (r = o.body) != null && r.data)
      return n.refresher = Promise.resolve(null), t.request.headers.Authorization = `Bearer ${(i = (s = o.body) == null ? void 0 : s.data) == null ? void 0 : i.access_token}`, n.req(t.request);
  }
  return t;
}
function zb(t) {
  Fa.dispatch("addMessage", { type: "error", text: t.detail || t.title });
}
function Lj(t) {
  const e = {};
  return t.forEach((n) => {
    const r = n.source.pointer.split("/"), s = r[r.length - 1];
    e[s] || U.set(e, s, []), e[s].push({ title: n.title, detail: n.detail });
  }), e;
}
function Me(t) {
  let e = !1;
  if (t.cancel)
    return { cancelled: !0, errors: [] };
  if (t.raw && t.raw.message && t.raw.message === "Failed to fetch")
    return zb({
      title: "Нет связи с сервером. Проверьте подключение к сети."
    }), { errors: [] };
  const n = [];
  if (t.status >= 500)
    return zb({ title: "Ошибка на сервере" }), { status: 500, errors: [{ title: "Ошибка на сервере" }] };
  const r = lt(t, "body.errors");
  return t.status === 403 ? { status: 403, errors: r } : t.status === 404 ? { status: 404, errors: r } : (r && r.length && r.forEach((s) => {
    switch (s.code) {
      case "AUTH_INVALID_PASSWORD":
        n.push(s);
        break;
      case "AUTH_USER_NOT_FOUND":
        n.push(s);
        break;
      case "JWT_EXPIRED_TOKEN":
        n.push(s);
        break;
      case "NEWS_PARENT_CONFLICT":
        e = !0, n.push(s);
        break;
    }
    lt(s, "source.pointer") ? n.push(s) : (e || zb(s), e = !1);
  }), n.length ? { status: t.status, errors: n } : { status: t.status || null, errors: [] });
}
const { isAuth: rpt, isLogin: spt, getDataKey: ipt } = C0;
async function opt(t, e) {
  if (t.ok) {
    if (spt(t.request.url))
      return e.refresher = Promise.resolve(null), tpt(t);
    const n = ipt(t.request.url, t.request.method);
    n && t.body && (t.body.data = await Kn.process(n, t.body.data));
  } else if (t.status > 399) {
    const n = t.request.url.replace(d4, "");
    if (t.error && t.error.code === "ECONNABORTED")
      return Gft(t.err, e, n);
    if (t.status === 401 && !rpt(t.request.url))
      return npt(t, Fa, e);
    if (t.status === 429)
      return await T0(2e3), e.req(t.request);
    if (t.status === 409 && n.indexOf("news") !== -1)
      return await T0(4e3), e.req(t.request);
    t.body = Me(t);
  }
  return t;
}
function apt(t, e) {
  const n = {};
  return e && (n.headers = {
    "X-Notification-ID": e
  }), this.get(`/asoi_notes/${t}/`, n).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function lpt(t) {
  return (t.cursor === void 0 || t.cursor === null) && delete t.cursor, this.get("/asoi_notes/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
function cpt(t) {
  return (t.cursor === void 0 || t.cursor === null) && delete t.cursor, this.get("/asoi_notes/embargo/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
function upt(t, e, n) {
  return this.get(`/asoi_notes/${t}/history/`, {
    params: {
      ...n ? { group_id: e } : { user_id: e }
    }
  }).then((r) => r.body || r).catch((r) => Me(r));
}
function dpt(t) {
  return this.del(`/asoi_notes/${t}/`).then((e) => e.body || e).catch((e) => Me(e));
}
function fpt(t) {
  return this.post(`/asoi_notes/${t}/read/`).then((e) => e.body || e).catch((e) => Me(e));
}
function ppt(t, e) {
  const n = {};
  return e && (n.headers = {
    "X-Notification-ID": e
  }), this.post(`/asoi_notes/${t}/pick/`, n).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
const hpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchHistory: upt,
  fetchMore: lpt,
  fetchMoreEmbargo: cpt,
  fetchOne: apt,
  pick: ppt,
  remove: dpt,
  setAsRead: fpt
}, Symbol.toStringTag, { value: "Module" })), mpt = "auth";
function vpt(t) {
  return this.post("/auth/", {
    body: {
      // keepLoggedIn: userData.keepLoggedIn,
      username: t.username,
      password: t.password
    }
  }).then((e) => e.body.data || e.body).catch((e) => Me(e, { type: mpt, params: { ...t } }));
}
function gpt(t) {
  return this.post("/auth/refresh/", {
    headers: {
      Authorization: `Bearer ${t}`
    }
  });
}
function ypt(t) {
  return this.post("/auth/lost_password/", {
    body: {
      username: t.username
    }
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function bpt(t) {
  return this.post("/auth/reset_password/", {
    body: {
      token: t.token
    }
  }).then((e) => e.body || e).catch((e) => Me(e));
}
const _pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  login: vpt,
  refresh: gpt,
  requestPasswordReset: ypt,
  resetPassword: bpt
}, Symbol.toStringTag, { value: "Module" }));
function wpt() {
  return this.get("/news/canvas/").then((t) => t.body.data || t.body).catch((t) => Me(t));
}
function Spt(t, e) {
  return this.patch("/news/canvas/", { body: { body: e } }).then((n) => n.body.data || n.body).catch(
    (n) => Me(n, { type, object: { id: t } })
  );
}
function Ipt(t) {
  const e = t.map((n) => ({ code: { id: n } }));
  return this.post("/news/canvas/codes/", {
    body: e
  }).then((n) => n.body.data || n.body).catch((n) => Me(n, { type, object: { id } }));
}
function Ept(t) {
  return this.del("/news/canvas/codes/", {
    params: {
      ids: t.join(",")
    }
  }).then((e) => e.body || e).catch((e) => Me(e, { type, object: { id } }));
}
function xpt(t) {
  return this.post("/news/canvas/publish/", { body: t }).then((e) => e.body ? e.body : e).catch((e) => Me(e, { type, object: { id } }));
}
const Cpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCodes: Ipt,
  deleteCodes: Ept,
  fetchCanvas: wpt,
  publish: xpt,
  updateCanvas: Spt
}, Symbol.toStringTag, { value: "Module" })), Tpt = "chat";
function Ppt(t, e) {
  return (e.cursor === void 0 || e.cursor === null) && delete e.cursor, this.get(`/news/${t}/comments/`, { params: e }).then((n) => n.body || n).catch((n) => Me(n));
}
function kpt(t, e) {
  return this.post(`/news/${t}/comments/`, { body: { body: e } }).then((n) => n.body || n).catch((n) => Me(n));
}
function Npt(t, e) {
  return this.post(`/news/${t}/comments/${e}/read/`).then((n) => n.body || n).catch((n) => this.networkErrorHandler(n, { type: Tpt, object: { id: t, commentId: e } }));
}
const $pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchComments: Ppt,
  markCommentAsRead: Npt,
  sendComment: kpt
}, Symbol.toStringTag, { value: "Module" }));
function Dpt() {
  return this.get("/codes/").then((t) => {
    var e;
    return ((e = t.body) == null ? void 0 : e.data) ?? t.body;
  }).catch((t) => Me(t));
}
function Apt(t) {
  const e = {
    type_id: t
  };
  return this.get("/codes/profile/", e).then((n) => {
    var r;
    return {
      data: ((r = n.body) == null ? void 0 : r.data) ?? n.body
    };
  }).catch((n) => Me(n));
}
function Opt(t) {
  return this.post("/predict/", {
    baseUri: Aie,
    body: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
const Mpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchAll: Dpt,
  fetchProfile: Apt,
  predictCodes: Opt
}, Symbol.toStringTag, { value: "Module" }));
function Rpt(t) {
  return this.get("/entities/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
function Lpt(t) {
  return this.get("/entities/tickers/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
const Fpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchEntities: Rpt,
  fetchTickerEntities: Lpt
}, Symbol.toStringTag, { value: "Module" }));
function Bpt(t) {
  return (t == null ? void 0 : t.offset) === 0 && delete t.offset, this.get("/flows/", {
    params: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function jpt(t) {
  return this.get(`/flows/${t}/`).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function Wpt(t) {
  return this.post("/flows/", {
    body: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function Hpt(t, e) {
  return this.patch(`/flows/${t}/`, {
    body: e
  }).then((n) => n.body.data || n.body).catch((n) => Me(n));
}
function Vpt(t) {
  return this.delete(`/flows/${t}/`).then(() => !0).catch((e) => Me(e));
}
function zpt(t, e) {
  return (e == null ? void 0 : e.offset) === 0 && delete e.offset, this.get(`/flows/${t}/sources/`, {
    params: e
  }).then((n) => n.body.data || n.body).catch((n) => Me(n));
}
function Upt(t) {
  return this.post(`/flows/${t}/read_all/`).then(() => !0).catch((e) => Me(e));
}
const Gpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: Wpt,
  fetchFlowSources: zpt,
  fetchMore: Bpt,
  fetchOne: jpt,
  remove: Vpt,
  setFlowAsRead: Upt,
  update: Hpt
}, Symbol.toStringTag, { value: "Module" }));
function Ypt(t) {
  return this.get(`/leads/${t}/`).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function Zpt(t) {
  return t.cursor === null && delete t.cursor, this.get("/leads/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
function Xpt(t) {
  return this.post(`/leads/${t}/read/`).then((e) => e).catch((e) => Me(e));
}
function Kpt(t, { typeId: e, fragment: n }) {
  const r = {}, s = {};
  return n && (s.fragment = n), e && (r.news_type_id = e), this.post(`/leads/${t}/pick/`, {
    params: r,
    body: s
  }).then((i) => i.body.data || i.body).catch((i) => Me(i));
}
function Jpt(t, e) {
  const { userIds: n, groupIds: r, fragment: s } = e;
  return this.post(`/leads/${t}/forward/`, {
    body: {
      user_ids: n,
      group_ids: r,
      fragment: s
    }
  }).then((i) => i).catch((i) => Me(i));
}
function qpt(t) {
  return this.get(`/leads/${t}/diff/`).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
const Qpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchMore: Zpt,
  fetchOne: Ypt,
  forward: Jpt,
  loadDiff: qpt,
  pick: Kpt,
  setAsRead: Xpt
}, Symbol.toStringTag, { value: "Module" })), gg = "news";
function eht(t, e) {
  const n = {};
  return e && (n.headers = {
    "X-Notification-ID": e
  }), this.get(`/news/${t}/`, n).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function tht(t) {
  return t.status_ids && t.status_ids.length && (t.status_ids = t.status_ids.join(",")), (t.cursor === void 0 || t.cursor === null) && delete t.cursor, this.get("/news/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
function nht(t, e) {
  return e = {
    inProgress: "in_progress",
    waiting: "waiting",
    originals: "original"
  }[e] || e, this.get(`/news/${e}/`, {
    params: {
      ...pu(t, (r, s) => r && s !== "additional"),
      ...t.additional ? pu(t.additional, (r) => !!r) : {}
    }
  }).then((r) => r.body || r).catch((r) => Me(r));
}
function rht(t, e) {
  const n = {
    body: t
  };
  return e && (n.headers = {
    "X-Notification-ID": e
  }), this.post("/news/", n).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function sht(t, e) {
  return this.patch(`/news/${t}/`, { body: e }).then((n) => n.body.data || n.body).catch(
    (n) => Me(n, { type: gg, object: { id: t, ...e } })
  );
}
function iht(t) {
  return this.post(`/news/${t}/read/`).then((e) => e.body || e).catch((e) => Me(e));
}
function oht(t) {
  return this.del(`/news/${t}/`).then((e) => e.body || e).catch((e) => Me(e));
}
function aht(t) {
  const { newsItemId: e, version: n, groupId: r, userId: s } = t, i = { version: n };
  return r && (i.group_id = r), s && (i.user_id = s), this.post(`/news/${e}/require_edit/`, {
    body: i
  }).then((o) => o.body || o).catch(
    (o) => Me(o)
  );
}
function lht(t) {
  const {
    newsItemId: e,
    version: n,
    recipients: r,
    comment: s = "",
    keep_original: i = !1
  } = t, o = {
    version: n,
    comment: s,
    recipients: r,
    keep_original: i
  };
  return this.post(`/news/${e}/send/`, {
    body: o
  }).then((a) => a.body || a).catch(
    (a) => this.networkErrorHandler(a, { type: gg, object: { newsItemId: e, version: n } })
  );
}
function cht(t) {
  return this.get(`/news/${t}/authors/`).then((e) => e.body || e).catch((e) => Me(e));
}
function uht(t, e) {
  const n = e ? e.map((r) => ({ user: { id: r } })) : [];
  return this.post(`/news/${t}/authors/`, {
    body: n
  }).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function dht(t, e) {
  return this.del(`/news/${t}/authors/${e}/`).then((n) => n.body || n).catch((n) => Me(n));
}
function fht(t, e) {
  const n = e.map((r) => ({ code: { id: r } }));
  return this.post(`/news/${t}/codes/`, {
    body: n
  }).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function pht(t, e) {
  return this.del(`/news/${t}/codes/`, {
    params: {
      ids: e.join(",")
    }
  }).then((n) => n.body || n).catch((n) => Me(n));
}
function hht(t, e) {
  const n = e.map((r) => ({ code: { id: r } }));
  return this.patch(`/news/${t}/route_codes/`, {
    body: n
  }).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function mht(t, e, n) {
  const r = {
    body: e
  };
  return n && (r.headers = {
    "X-Notification-ID": n
  }), this.post(`/news/${t}/pick/`, r).then((s) => s.body || s).catch((s) => Me(s));
}
function vht(t, e) {
  return this.post(`/news/${t}/validate/`, {
    body: e
  }).then((n) => n.body || n).catch((n) => Me(n));
}
function ght(t, e, n = !1) {
  const r = n ? "?allow_embargo_codes=1" : "";
  return this.post(`/news/${t}/publish/${r}`, {
    body: e
  }).then((s) => s.body ? s.body : s).catch((s) => Me(s));
}
function yht(t, e = {}) {
  const n = new URLSearchParams(e);
  return this.post(`/news/${t}/republish/?${n}`).then((r) => r.body ? r.body : r).catch((r) => Me(r));
}
function bht(t, e) {
  const n = { codes: e.map((r) => ({ id: r })) };
  return this.post(`/news/${t}/republish/unedited/`, {
    body: n
  }).then((r) => r.body ? r.body : r).catch((r) => Me(r));
}
function _ht(t) {
  return this.post("/news/dispose/", {
    body: t
  }).then((e) => e.body || e).catch((e) => Me(e, { type: gg, object: { id, version } }));
}
function wht(t) {
  const { newsItemId: e, version: n, user_ids: r, group_ids: s, comment: i = "" } = t, o = {
    version: n,
    user_ids: r,
    group_ids: s,
    comment: i
  };
  return this.post(`/news/${e}/send_to_asoi/`, {
    body: o
  }).then((a) => a.body || a).catch(
    (a) => Me(a, { type: gg, object: { newsItemId: e, ...n } })
  );
}
function Sht(t, e) {
  const n = e.cursor || void 0, r = e.limit || 100;
  return this.get(`/news/${t}/events/`, {
    params: {
      limit: r,
      cursor: n
    }
  }).then((s) => s.body || s).catch((s) => Me(s));
}
function Iht(t) {
  return this.post("/news/reschedule/", {
    body: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function Eht(t) {
  return this.post(`/news/${t}/revoke/`).then((e) => e.body || e).catch((e) => Me(e));
}
function xht(t) {
  return this.get(`/news/${t}/original/`).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function Cht(t) {
  return this.get(`/news/${t}/asoi_note/`).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function Tht(t, e) {
  const { version: n, keep_code_ids: r } = e;
  return this.post(`/news/${t}/annotate/`, {
    body: {
      news: n,
      keep_code_ids: r
    }
  }).then((s) => s.body.data || s.body).catch((s) => Me(s));
}
function Pht(t, e) {
  const { version: n } = e;
  return this.post(`/news/${t}/annotate_forbidden/`, {
    body: n
  }).then((r) => r.body.data || r.body).catch((r) => Me(r));
}
function kht(t) {
  return this.get(`/news/${t}/relations/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Nht(t) {
  const e = {
    limit: 30,
    cursor: void 0,
    reverse: !1
  };
  return this.get("/news/search/", {
    params: {
      ...e,
      ...pu(t, (n, r) => n && r !== "additional"),
      ...t.additional ? pu(t.additional, (n) => !!n) : {}
    }
  }).then((n) => n.body || n).catch((n) => Me(n));
}
function $ht(t) {
  return this.get(`/news/${t}/links/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Dht(t, e, n) {
  return this.del(`/news/${t}/links/${e}/${n}/`).then((r) => r.body || r).catch((r) => Me(r));
}
function Aht(t) {
  return this.post(`/news/${t}/recall/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Oht(t) {
  return this.get(`/news/${t}/versions/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Mht(t) {
  return this.post(`/news/${t}/extend/`).then((e) => e.body || e).catch((e) => Me(e));
}
const Rht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAuthors: uht,
  addCodes: fht,
  annotate: Tht,
  annotateForbidden: Pht,
  create: rht,
  deleteAuthor: dht,
  deleteCodes: pht,
  deleteNewsItemLink: Dht,
  dispose: _ht,
  extend: Mht,
  fetchAuthors: cht,
  fetchEvents: Sht,
  fetchHistory: Oht,
  fetchLinkedNews: $ht,
  fetchMore: tht,
  fetchMoreSpecific: nht,
  fetchOne: eht,
  fetchPreviousVersion: xht,
  fetchPreviousVersionFromASOI: Cht,
  fetchRelations: kht,
  pick: mht,
  publish: ght,
  recall: Aht,
  remove: oht,
  republish: yht,
  republishUnedited: bht,
  reschedule: Iht,
  revoke: Eht,
  routePublicationCodes: hht,
  search: Nht,
  send: lht,
  sendToASOI: wht,
  sendToEdit: aht,
  setAsRead: iht,
  update: sht,
  validate: vht
}, Symbol.toStringTag, { value: "Module" }));
function Lht(t) {
  return t.cursor === null && delete t.cursor, this.get("/newsbreaks/", {
    params: t
  }).then((e) => e.body || e).catch((e) => Me(e));
}
function Fht(t) {
  return this.get(`/newsbreaks/${t}/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Bht(t, e) {
  return this.post(`/newsbreaks/${t}/pick/`, {
    params: e
  }).then((n) => n.body.data || n.body).catch((n) => Me(n));
}
function jht(t) {
  return this.post(`/newsbreaks/${t}/read/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Wht(t, e) {
  return this.post(`/newsbreaks/${t}/reject/`, {
    body: { reason: e }
  }).then((n) => n.body || n).catch((n) => Me(n));
}
const Hht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchMore: Lht,
  fetchOne: Fht,
  pick: Bht,
  reject: Wht,
  setAsRead: jht
}, Symbol.toStringTag, { value: "Module" })), Vht = el.getParser(window.navigator.userAgent), zht = Vht.satisfies({
  safari: ">=8"
});
async function Uht() {
  let t;
  if (zht) {
    const e = await ni.appData.getPushDeviceToken();
    t = {
      apns_device_token: e == null ? void 0 : e.data
    };
  } else {
    const e = await ni.appData.getPushSubscriptionId();
    t = {
      push_subscription_id: (e == null ? void 0 : e.data) || void 0
    };
  }
  return this.get("/notifications/", { params: t }).then((e) => e.body || e).catch((e) => Me(e));
}
function Ght(t) {
  return this.post("/notifications/", { body: { ...t } }).then((e) => e.body || e).catch((e) => Me(e));
}
function Yht(t) {
  return this.post("/notifications/subscriptions/", { body: { ...t } }).then((e) => e.body || e).catch((e) => Me(e));
}
function Zht(t) {
  return this.delete(`/notifications/subscriptions/${t}/`).then((e) => e.body || e).catch((e) => Me(e));
}
const Xht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  deletePushSubscription: Zht,
  fetch: Uht,
  save: Ght,
  savePushSubscription: Yht
}, Symbol.toStringTag, { value: "Module" })), Kht = "sources";
function Jht(t) {
  return (t == null ? void 0 : t.offset) === 0 && delete t.offset, this.get("/sources/", { params: t }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function qht(t) {
  return this.get(`/sources/${t}/`).then((e) => e.body || e).catch((e) => Me(e));
}
function Qht(t) {
  return this.post("/sources/", {
    body: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function emt(t, e) {
  return this.patch(`/sources/${t}/`, {
    body: e
  }).then((n) => n.body.data || n.body).catch((n) => Me(n, { type: Kht, object: { id: t, ...e } }));
}
function tmt(t) {
  return this.delete(`/sources/${t}/`).then((e) => e.body || e).catch((e) => Me(e));
}
function nmt(t, e) {
  return e.cursor || delete e.cursor, this.get(`/sources/${t}/logs/`, {
    params: e
  }).then((n) => n.body || n).catch((n) => Me(n));
}
function rmt(t) {
  return this.get(`/sources/${t}/errors/`).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
const smt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: Qht,
  fetchErrors: rmt,
  fetchLogs: nmt,
  fetchMore: Jht,
  fetchOne: qht,
  remove: tmt,
  update: emt
}, Symbol.toStringTag, { value: "Module" })), imt = "user";
function omt(t) {
  return this.patch("/profile/", {
    body: t
  }).catch((e) => Me(e, { type: imt, object: { ...t } }));
}
function amt() {
  return this.get("/profile/").then((t) => ({
    data: t.body.data || t.body
  })).catch((t) => Me(t));
}
function lmt(t) {
  return (t == null ? void 0 : t.offset) === 0 && delete t.offset, t.exclude_ids && Array.isArray(t.exclude_ids) && (t.exclude_ids = t.exclude_ids.join(",")), (t == null ? void 0 : t.desc) === !1 && delete t.desc, this.get("/users/", {
    params: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function cmt(t) {
  return (t == null ? void 0 : t.offset) === 0 && delete t.offset, t.exclude_ids && Array.isArray(t.exclude_ids) && (t.exclude_ids = t.exclude_ids.join(",")), this.get("/groups/", {
    params: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function umt(t) {
  return (t == null ? void 0 : t.offset) === 0 && delete t.offset, this.get("/recipients/", {
    params: t
  }).then((e) => e.body.data || e.body).catch((e) => Me(e));
}
function dmt() {
  return this.get("/groups_and_users/").then((t) => {
    var e;
    return ((e = t.body) == null ? void 0 : e.data) ?? t.body;
  }).catch((t) => Me(t));
}
function fmt() {
  return this.post("/users/statuses/online/").then((t) => {
    var e;
    return ((e = t.body) == null ? void 0 : e.data) ?? t.body;
  }).catch((t) => Me(t));
}
const pmt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchGroups: cmt,
  fetchGroupsAndUsers: dmt,
  fetchRecipients: umt,
  fetchUsers: lmt,
  profileFetch: amt,
  profilePatch: omt,
  sendUserOnlineStatus: fmt
}, Symbol.toStringTag, { value: "Module" })), hmt = {
  asoi: hpt,
  auth: _pt,
  canvases: Cpt,
  chat: $pt,
  codes: Mpt,
  entities: Fpt,
  flows: Gpt,
  leads: Qpt,
  news: Rht,
  newsbreaks: Hht,
  notifications: Xht,
  sources: smt,
  user: pmt
}, mmt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hmt
}, Symbol.toStringTag, { value: "Module" })), Sl = {}, vmt = iat({
  baseUri: d4,
  reqInterceptor: (t, e) => (!new RegExp(/.*check\/$/, "ig").test(t.url) && !new RegExp(/.*online\/$/, "ig").test(t.url) && (Sl[t.url] = {
    timestamp: Date.now()
  }), Uft(t, e)),
  resInterceptor: (t, e) => {
    var n;
    try {
      Sl[t.request.url] && (Sl[t.request.url].span && (Sl[t.request.url].span.attributes["x-request-id"] = t.headers.get("x-request-id"), Sl[t.request.url].span.attributes.end = performance.now(), (n = Sl[t.request.url].span) == null || n.finish()), delete Sl[t.request.url]);
    } catch (r) {
      console.error("Metrics interceptor error", r);
    }
    return opt(t, e);
  },
  modules: mmt
}), $e = vmt, gmt = "_root_5xac5_1", ymt = "_wrapper_5xac5_8", bmt = "_helper_5xac5_14", _mt = "_helperBlock_5xac5_21", wmt = "_helperIcon_5xac5_26", Smt = "_info_5xac5_44", Imt = "_infoShade_5xac5_50", Emt = "_info_collapsed_5xac5_58", xmt = "_collapse_5xac5_65", Cmt = "_search_5xac5_73", Tmt = "_content_5xac5_77", Pmt = "_loader_5xac5_81", kmt = "_error_5xac5_86", Nmt = "_reload_5xac5_95", $mt = "_tableWrapper_5xac5_106", Dmt = "_tableLoader_5xac5_110", Amt = "_table_5xac5_106", Omt = "_paginationWrapper_5xac5_126", Mmt = "_pagination_5xac5_126", Rmt = "_paginationItem_5xac5_136", Lmt = "_paginationLink_5xac5_142", Fmt = "_paginationArrow_5xac5_149", Bmt = "_paginationArrowLink_5xac5_149", jmt = {
  root: gmt,
  wrapper: ymt,
  helper: bmt,
  helperBlock: _mt,
  helperIcon: wmt,
  info: Smt,
  infoShade: Imt,
  info_collapsed: Emt,
  collapse: xmt,
  search: Cmt,
  content: Tmt,
  loader: Pmt,
  error: kmt,
  reload: Nmt,
  tableWrapper: $mt,
  tableLoader: Dmt,
  table: Amt,
  paginationWrapper: Omt,
  pagination: Mmt,
  paginationItem: Rmt,
  paginationLink: Lmt,
  paginationArrow: Fmt,
  paginationArrowLink: Bmt
}, Wmt = {
  name: "TheEntities",
  components: {
    PbCircularLoader: br,
    PbSearchField: Mu,
    PbTable: t2
  },
  data() {
    const t = new String("Как писать");
    return t.id = "name", t.sortable = !0, t.style = { width: "75%" }, {
      collapsed: !0,
      currentPage: 1,
      pageSize: 50,
      searchQuery: "",
      sortingColumn: "name",
      sortingOrder: "asc",
      isError: !1,
      isLoading: !1,
      isInitialLoading: !0,
      tableHead: [t, "Тикеры"],
      tableData: [],
      tableTotal: 0
    };
  },
  async created() {
    await this.fetchData(), this.isInitialLoading = !1;
  },
  methods: {
    async fetchData() {
      this.isLoading = !0, this.isError = !1;
      const t = (this.currentPage - 1) * this.pageSize, e = this.searchQuery, n = this.sortingOrder === "desc", r = {
        limit: this.pageSize,
        ...t ? { offset: t } : {},
        ...e ? { search: e } : {},
        desc: n
      }, s = await $e.entities.fetchTickerEntities(r);
      !s || !s.data ? this.isError = !0 : (this.tableTotal = isNaN(s.total) ? this.tableTotal : s.total, this.setTableData(s.data)), this.isLoading = !1;
    },
    handlePageChange(t) {
      this.currentPage = t, this.fetchData();
    },
    async handleReloadClick() {
      this.isInitialLoading = !0, await this.fetchData(), this.isInitialLoading = !1;
    },
    handleSearchInput(t) {
      this.searchQuery = t, this.currentPage = 1, this.fetchData();
    },
    handleSortingChange(t) {
      this.sortingOrder = t.order, this.currentPage = 1, this.fetchData();
    },
    setTableData(t) {
      if (!t || !t.length) {
        const e = new String("Таких организаций не найдено");
        e.style = {
          padding: "50px 0",
          fontSize: "18px",
          fontWeight: "700"
        }, e.colspan = 2, this.tableData = [[e]];
        return;
      }
      this.tableData = t.map((e) => {
        const n = e.patterns.reduce((s, i) => s + `\r
` + i.pattern, "").replace(/^\r\n/g, ""), r = Object.keys(e.properties).map((s) => {
          const i = { label: "MOEX: ", value: e.properties[s] };
          return s === "SPB_TICKER" && (i.label = "SPB: "), i;
        });
        return [n, r];
      });
    }
  }
};
var Hmt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.helper }, [n("p", { class: e.$style.helperBlock }, [n("icon", { class: e.$style.helperIcon, attrs: { type: "font", name: "warning", size: "32" } }), n("span", [e._v(" В справочнике приведены те варианты написания наименований юридических лиц, которые нужно использовать, чтобы в молниях и новостях алгоритм проставлял биржевые тикеры и связанные с ними отраслевые и страновые коды. ")])], 1), n("div", { class: { [e.$style.info]: !0, [e.$style.info_collapsed]: e.collapsed } }, [n("transition", { attrs: { name: "fade" } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.collapsed, expression: "collapsed" }], class: e.$style.infoShade })]), n("p", [e._v(" В молниях использование кавычек (есть они или нет) не важно – алгоритм все равно проставит тикер. ")]), n("p", [e._v(' В остальных новостях это играет определяющую роль: если в справочнике написано Сбербанк (без кавычек), а вы будете использовать в новости вариант ПАО «Сбербанк», то код не проставится. И наоборот, если справочник требует писать "Нижнекамскнефтехим" в кавычках, а вы напишете Нижнекамскнефтехим (без кавычек), то тикер тоже не проставится. ')]), n("p", [e._v(' Звездочка в конце наименования (например, "ВНИПИгаздобыч*) означает, что у этого юридического лица алгоритм сможет проставить тикер при использовании наименования в любом падеже, то есть с любым окончанием. Если звездочки нет, то алгоритм сработает при написании наименования в тех вариантах, которые приведены в справочнике. Например, если написать группа "Илим" или группы "Илим", то сработает, а если использовать группой «Илим», то нет. ')]), n("p", [e._v(" Если в справочнике есть звездочка в конце слова, то вторая кавычка отброшена. Это технический момент, не обращайте внимания – на письме нужно ставить обе кавычки, как требуют правила русского языка. ")]), n("p", [e._v(' Похожую функцию звездочка выполняет в начале наименования. Например, если в справочнике указано *АО "СМП", то алгоритм сработает, если будет написано и ПАО "СМП", и АО "СМП", и ЗАО "СМП". ')]), n("p", [e._v(' Если наименование в справочнике приведено с организационно-правовой формой (например, ПАО "ГАЗ"), то так и надо писать. Если вы напишете просто «ГАЗ», то тикер не проставится. ')]), n("p", [e._v(" В некоторых случаях биржевой тикер, наоборот, не требуется. Например, если вы пишете о рейтинге, который присваивает S&P, то код этой компании в новости не нужен, а если о ней самой как об эмитенте – то нужен. Во втором случае нужно использовать именно тот вариант написания, который приведен в справочнике (S&P Global Inc.), в первом - любой другой в принципе допустимый вариант написания, например S&P globalThis. ")])], 1), n("button", { class: e.$style.collapse, on: { click: function(r) {
    e.collapsed = !e.collapsed;
  } } }, [e._v(" " + e._s(e.collapsed ? "Показать еще" : "Свернуть") + " ")]), n("p", [e._v(" Если тикер не нужен, то необходимо выбрать любой другой допустимый вариант написания, например: ")]), n("div", { class: e.$style.helperBlock }, [e._m(0), e._m(1)])]), n("PbSearchField", { class: e.$style.search, attrs: { autofocus: !0 }, on: { input: e.handleSearchInput } }), n("div", { class: e.$style.content }, [n("transition", { attrs: { name: "fade", mode: "out-in" } }, [e.isInitialLoading ? n("PbCircularLoader", { class: e.$style.loader }) : e.isError ? n("div", { class: e.$style.error }, [n("span", [e._v(" Ошибка загрузки данных. Попробуйте повторить запрос. ")]), n("span", { class: e.$style.reload, on: { click: e.handleReloadClick } }, [n("icon", { attrs: { name: "reload", size: 48 } })], 1)]) : n("div", { class: e.$style.tableWrapper }, [n("transition", { attrs: { name: "fade" } }, [e.isLoading ? n("div", { class: e.$style.tableLoader }, [n("PbCircularLoader")], 1) : e._e()]), n("PbTable", { class: e.$style.table, attrs: { head: e.tableHead, allowHtml: !1, data: e.tableData, disabled: e.tableTotal === 0, maxHeight: null, withCopying: !0, sort: { by: e.sortingColumn, order: e.sortingOrder } }, on: { changeSorting: e.handleSortingChange } }), n("div", { class: e.$style.paginationWrapper }, [e.tableTotal ? n("paginate", { attrs: { pageCount: Math.ceil(e.tableTotal / e.pageSize), pageRange: 3, marginPages: 2, clickHandler: e.handlePageChange, prevText: "Назад", nextText: "Вперед", containerClass: e.$style.pagination, pageClass: e.$style.paginationItem, pageLinkClass: e.$style.paginationLink, prevClass: e.$style.paginationArrow, nextClass: e.$style.paginationArrow, prevLinkClass: e.$style.paginationArrowLink, nextLinkClass: e.$style.paginationArrowLink }, model: { value: e.currentPage, callback: function(r) {
    e.currentPage = r;
  }, expression: "currentPage" } }) : e._e()], 1)], 1)], 1)], 1)], 1)]);
}, Vmt = [function() {
  var t = this, e = t._self._c;
  return e("table", [e("tr", [e("td", [t._v("S&P Global Inc.")]), e("td", [t._v("-")]), e("td", [t._v("код проставится")])]), e("tr", [e("td", [t._v("S&P Global")]), e("td", [t._v("-")]), e("td", [t._v("код не проставится")])])]);
}, function() {
  var t = this, e = t._self._c;
  return e("table", [e("tr", [e("td", [t._v('"Московская биржа"')]), e("td", [t._v("-")]), e("td", [t._v("код проставится")])]), e("tr", [e("td", [t._v(" Московская биржа")]), e("td", [t._v("-")]), e("td", [t._v("код не проставится")])])]);
}];
const XD = {
  $style: jmt
};
function zmt(t) {
  for (var e in XD)
    this[e] = XD[e];
}
var Umt = /* @__PURE__ */ B(
  Wmt,
  Hmt,
  Vmt,
  !1,
  zmt,
  null
);
const Gmt = Umt.exports, Ymt = "_root_7s4i2_1", Zmt = {
  root: Ymt
}, Xmt = {
  name: "LinkButton",
  directives: {
    rippler: hS
  },
  props: {
    label: String,
    to: [String, Object],
    exact: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
var Kmt = function() {
  var e = this, n = e._self._c;
  return n("router-link", { directives: [{ name: "rippler", rawName: "v-rippler" }], class: e.$style.root, attrs: { to: e.to, exact: e.exact } }, [e._t("default")], 2);
}, Jmt = [];
const KD = {
  $style: Zmt
};
function qmt(t) {
  for (var e in KD)
    this[e] = KD[e];
}
var Qmt = /* @__PURE__ */ B(
  Xmt,
  Kmt,
  Jmt,
  !1,
  qmt,
  null
);
const XI = Qmt.exports, evt = "_root_36xzg_1", tvt = {
  root: evt
}, nvt = {
  name: "TheFlows",
  components: {
    Toolbar: xo,
    LinkButton: XI
  }
};
var rvt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "manager-flows-container" } }, [n("toolbar", [n("LinkButton", { attrs: { to: { name: "flowsPublic" }, "data-test-selector": "manager-flows-button-public" } }, [e._v(" Общие ")]), n("LinkButton", { attrs: { to: { name: "flowsMy" }, "data-test-selector": "manager-flows-button-my" } }, [e._v(" Мои ")]), n("LinkButton", { attrs: { to: { name: "flowsSpecial" }, "data-test-selector": "manager-flows-button-special" } }, [e._v(" Интерфакс ")]), n("LinkButton", { attrs: { to: { name: "flowCreate" }, "data-test-selector": "manager-flows-button-create" } }, [e._v(" Создание ")])], 1), n("router-view", { attrs: { name: "flows" } })], 1);
}, svt = [];
const JD = {
  $style: tvt
};
function ivt(t) {
  for (var e in JD)
    this[e] = JD[e];
}
var ovt = /* @__PURE__ */ B(
  nvt,
  rvt,
  svt,
  !1,
  ivt,
  null
);
const avt = ovt.exports, lvt = "_root_13xrh_1", cvt = "_wrapper_13xrh_9", uvt = "_list_13xrh_17", dvt = "_info_13xrh_24", fvt = "_footer_13xrh_28", pvt = {
  root: lvt,
  wrapper: cvt,
  list: uvt,
  info: dvt,
  footer: fvt
}, hvt = {
  name: "PbFlowsViewer"
};
var mvt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.list }, [e._t("list")], 2), n("div", { class: e.$style.info }, [e._t("info")], 2)]), n("div", { class: e.$style.footer }, [e._t("footer")], 2)]);
}, vvt = [];
const qD = {
  $style: pvt
};
function gvt(t) {
  for (var e in qD)
    this[e] = qD[e];
}
var yvt = /* @__PURE__ */ B(
  hvt,
  mvt,
  vvt,
  !1,
  gvt,
  null
);
const Fj = yvt.exports, bvt = "_root_1igai_1", _vt = "_root_selected_1igai_8", wvt = "_entryId_1igai_23", Svt = "_name_1igai_31", Ivt = "_footer_1igai_35", Evt = "_sourceType_1igai_39", xvt = {
  root: bvt,
  root_selected: _vt,
  entryId: wvt,
  name: Svt,
  footer: Ivt,
  sourceType: Evt
}, Cvt = {
  name: "flowsListItem",
  props: {
    entry: Object,
    index: Number,
    itemType: {
      type: String,
      default: ""
    },
    selectedIndex: Number
  },
  computed: {
    isSelected() {
      return this.isSpecial ? this.index === this.selectedIndex : this.$store.state.flows.selected.id === this.entry.id;
    },
    isSpecial() {
      return this.itemType === "special";
    },
    sourceTypes() {
      return this.$store.state.references.Source.Type;
    },
    sourcesCountFormatted() {
      const t = this.entry.source_count || 0;
      return t + su(t, [" источник", " источника", " источников"]);
    }
  }
};
var Tvt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { [e.$style.root]: !0, [e.$style.root_selected]: e.isSelected }, style: { "background-color": `#${e.entry.color}` }, attrs: { "data-test-selector": "flows-list-item", "data-test-attrs": `item-id__${e.entry.id}`, "data-test-id": e.entry.id } }, [n("div", { staticClass: "flows-entry-header" }, [e.isSpecial ? e._e() : n("span", { class: e.$style.entryId, style: { color: `#${e.entry.color}` }, attrs: { "data-test-selector": "entry-id" } }, [e._v(" " + e._s(e.entry.id) + " ")]), n("span", { class: e.$style.name, attrs: { "data-test-selector": "entry-name" } }, [n("span", [e._v(e._s(e.entry.name))])])]), e.isSpecial ? e._e() : n("div", { class: e.$style.footer, attrs: { "data-test-selector": "entry-footer" } }, [n("span", { attrs: { "data-test-selector": "flow-sources-counter" } }, [e._v(" " + e._s(e.sourcesCountFormatted) + " ")]), e.entry.source_count ? n("span", { class: e.$style.sourceType }, e._l(e.entry.source_type_ids, function(r) {
    return n("span", { key: r, attrs: { "data-test-selector": "flow-source-type", "data-test-id": r } }, [e._v(" • " + e._s(e.sourceTypes[r].description) + " ")]);
  }), 0) : e._e()])]);
}, Pvt = [];
const QD = {
  $style: xvt
};
function kvt(t) {
  for (var e in QD)
    this[e] = QD[e];
}
var Nvt = /* @__PURE__ */ B(
  Cvt,
  Tvt,
  Pvt,
  !1,
  kvt,
  null
);
const Bj = Nvt.exports, $vt = "_root_1y47h_1", Dvt = "_entries_1y47h_8", Avt = {
  root: $vt,
  entries: Dvt
}, Ovt = {
  name: "flowsList",
  components: {
    FlowListItem: Bj,
    PbDynamicList: il,
    SearchField: Mu,
    PbEmpty: tl
  },
  data() {
    return {
      loading: !1,
      loaded: !1,
      offset: 0,
      limit: 30,
      query: ""
    };
  },
  computed: {
    ...st({
      flowsItems: (t) => t.flows.items,
      flowsList: (t) => t.flows.list,
      selected: (t) => t.flows.selected || { id: null }
    }),
    entries() {
      return this.flowsList.map((t) => this.flowsItems[t] || { id: null });
    },
    sizeDeps() {
      return () => [];
    }
  },
  watch: {
    "$route.name": function() {
      this.query = "", this.$refs.searchField.query = "", this.offset = 0, this.fetchData(!0);
    }
  },
  mounted() {
    this.fetchData(!0);
  },
  methods: {
    ...ge({
      getFlowsPublic: "getFlowsPublic",
      getFlowsMy: "getFlowsMyPrivate",
      selectFlow: "selectFlow"
    }),
    async fetchData(t = !1) {
      this.loading = !0;
      const e = {
        offset: this.offset,
        limit: this.limit
      };
      this.query.length && (e.search = this.query);
      const n = await this[`get${Tve(this.$route.name)}`](e);
      n && (this.loaded = n.length < this.limit, this.offset = this.offset + n.length, t && this.select(this.flowsItems[this.flowsList[0]]), this.loading = !1);
    },
    loadMore() {
      this.loaded || this.fetchData();
    },
    select(t) {
      this.selectFlow(t ? this.flowsItems[t.id] : { id: null });
    },
    handleSearch(t) {
      this.query = t || "", this.loaded = !1, this.offset = 0, this.fetchData(!0);
    }
  }
};
var Mvt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "flows-list" } }, [n("SearchField", { ref: "searchField", attrs: { placeholder: "Поиск по названию потока", "data-test-selector": "flows-search-field" }, on: { input: function(r) {
    return e.handleSearch(r);
  } } }), !e.flowsList || !e.flowsList.length ? n("PbEmpty", { attrs: { text: "Нет потоков", "data-test-selector": "flows-list-empty" } }) : n("div", { class: e.$style.entries }, [n("PbDynamicList", { ref: "entriesList", attrs: { items: e.entries, selected: e.selected.id, sizeDeps: e.sizeDeps, minItemHeight: 83, showLoader: !e.loaded, enableKeyboard: !0 }, on: { select: e.select, reachedEnd: e.loadMore }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, index: s }) {
    return n("FlowListItem", { attrs: { index: s, entry: r } });
  } }]) })], 1)], 1);
}, Rvt = [];
const eA = {
  $style: Avt
};
function Lvt(t) {
  for (var e in eA)
    this[e] = eA[e];
}
var Fvt = /* @__PURE__ */ B(
  Ovt,
  Mvt,
  Rvt,
  !1,
  Lvt,
  null
);
const Bvt = Fvt.exports, jvt = "_root_5rjre_1", Wvt = "_content_5rjre_6", Hvt = "_list_5rjre_10", Vvt = "_block_5rjre_14", zvt = "_block_headline_5rjre_24", Uvt = "_errors_5rjre_42", Gvt = "_sourceName_5rjre_46", Yvt = "_sourceId_5rjre_55", Zvt = "_sourceUrl_5rjre_63", Xvt = {
  root: jvt,
  content: Wvt,
  list: Hvt,
  block: Vvt,
  block_headline: zvt,
  errors: Uvt,
  sourceName: Gvt,
  sourceId: Yvt,
  sourceUrl: Zvt
}, Kvt = {
  name: "FlowInfo",
  components: {
    PbDynamicList: il
  },
  data() {
    return {
      flow: {
        sources: []
      },
      loading: !1,
      offset: 0,
      limit: 100,
      loaded: !1,
      total: 0
    };
  },
  computed: {
    ...pe(["getFlowSources"]),
    selectedFlow() {
      return this.$store.state.flows.selected;
    },
    sizeDeps() {
      return () => [];
    },
    sourceItems() {
      const t = this.getFlowSources(this.flow.id);
      return t ? t.map(({ source: e }) => e) : [];
    }
  },
  watch: {
    selectedFlow: function(t, e) {
      t && e && t.id !== e.id && (clearTimeout(this.updateTimeout), this.updateTimeout = setTimeout(() => {
        this.flow = t, this.offset = 0, this.fetchData(), this.$refs.entriesList && this.$refs.entriesList.scrollToTop();
      }, 64));
    }
  },
  created() {
    this.updateTimeout = null;
  },
  mounted() {
    this.fetchData().then(() => {
      this.flow = this.selectedFlow;
    });
  },
  methods: {
    async fetchData() {
      if (this.loading || !this.selectedFlow || !this.selectedFlow.id) return;
      this.loading = !0;
      const t = this.offset;
      let e = this.limit;
      const n = await this.$store.dispatch("fetchFlowSources", {
        flowId: this.selectedFlow.id,
        offset: t,
        limit: e
      });
      if (n)
        return this.$nextTick(() => {
          this.loaded = n.length === 0 || n.length < this.limit, this.offset = this.offset + n.length, this.loading = !1;
        }), n;
    },
    loadMore() {
      this.loaded || this.fetchData();
    }
  }
};
var Jvt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "flow-info" } }, [e.flow && e.flow.id ? n("div", { class: e.$style.content }, [n("div", { class: [e.$style.block, e.$style.block_headline] }, [n("h2", { attrs: { "data-test-selector": "flow-name" } }, [e._v(e._s(e.flow.name))])]), e.sourceItems && e.sourceItems ? n("div", { class: e.$style.list, attrs: { "data-test-selector": "flow-sources" } }, [n("PbDynamicList", { ref: "entriesList", attrs: { items: e.sourceItems, sizeDeps: e.sizeDeps, minItemHeight: 80, showLoader: !e.loaded }, on: { reachedEnd: e.loadMore }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, index: s }) {
    return [n("div", { class: e.$style.block, attrs: { index: s, "data-test-selector": "flow-sources-item", "data-test-attrs": `item-id__${r.id}`, "data-test-id": r.id } }, [n("div", { class: e.$style.sourceName, attrs: { "data-test-selector": "source-name" } }, [n("span", { class: e.$style.sourceId }, [e._v(e._s(r.id))]), n("span", { attrs: { title: r.name } }, [e._v(e._s(r.name))])]), n("div", [n("a", { class: e.$style.sourceUrl, attrs: { href: r.url, target: "_blank", "data-test-selector": "source-url" } }, [e._v(" " + e._s(r.url) + " ")])])])];
  } }], null, !1, 3359415822) })], 1) : e._e()]) : e._e()]);
}, qvt = [];
const tA = {
  $style: Xvt
};
function Qvt(t) {
  for (var e in tA)
    this[e] = tA[e];
}
var egt = /* @__PURE__ */ B(
  Kvt,
  Jvt,
  qvt,
  !1,
  Qvt,
  null
);
const tgt = egt.exports, ngt = "_root_1tauy_1", rgt = {
  root: ngt
}, sgt = {
  name: "flowsActions",
  components: {
    MainActionButton: fn,
    DialogConfirm: Gu
  },
  data() {
    return {
      removeDialog: !1
    };
  },
  computed: {
    flowsItems() {
      return this.$store.state.flows.items;
    },
    flowsList() {
      return this.$store.state.flows.list;
    },
    selectedFlowId() {
      return this.$store.state.flows.selected.id;
    },
    isAdded() {
      return this.$store.getters.flowsAddedOnWorkspace.indexOf(
        this.selectedFlowId
      ) !== -1;
    }
  },
  methods: {
    addToWorkspace() {
      this.$store.dispatch("panels/addPanel", {
        panel: { type: "flow", dataId: this.selectedFlowId },
        position: 0,
        goToPanel: !1
      }), this.$store.dispatch("addMessage", {
        type: "success",
        text: "Поток добавлен на рабочую область"
      });
    },
    edit() {
      this.$router.push({
        name: "flowEdit",
        params: {
          id: this.selectedFlowId
        }
      }).catch(() => null);
    },
    async remove() {
      await this.$store.dispatch("deleteFlow", this.selectedFlowId), this.$store.dispatch("selectFlow", this.flowsItems[this.flowsList[0]]);
    }
  }
};
var igt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e.selectedFlowId ? n("div", { class: e.$style.content }, [e.isAdded ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { disabled: "", iconName: "button-icon-add", "data-test-selector": "flows-button-already-added" }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [n("icon", { attrs: { type: "font", name: "done", size: "24" } })];
  }, proxy: !0 }], null, !1, 375664491) }, [e._v("Поток уже добавлен на рабочую область ")]) : n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "flows-button-add-to-workspace" }, nativeOn: { click: function(r) {
    return e.addToWorkspace.apply(null, arguments);
  } } }, [e._v(" Добавить поток на рабочую область ")]), n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-edit", "data-test-selector": "flows-button-edit" }, nativeOn: { click: function(r) {
    return e.edit.apply(null, arguments);
  } } }, [e._v(" Изменить поток ")]), n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-delete", "data-test-selector": "flows-button-remove" }, nativeOn: { click: function(r) {
    e.removeDialog = !0;
  } } }, [e._v(" Удалить поток ")])], 1) : e._e(), n("DialogConfirm", { attrs: { state: e.removeDialog }, on: { "update:state": function(r) {
    e.removeDialog = r;
  }, agree: e.remove }, scopedSlots: e._u([{ key: "question", fn: function() {
    return [n("h3", [e._v("Удалить поток?")])];
  }, proxy: !0 }]) })], 1);
}, ogt = [];
const nA = {
  $style: rgt
};
function agt(t) {
  for (var e in nA)
    this[e] = nA[e];
}
var lgt = /* @__PURE__ */ B(
  sgt,
  igt,
  ogt,
  !1,
  agt,
  null
);
const cgt = lgt.exports, ugt = {
  name: "TheFlowsViewer",
  components: {
    PbFlowsViewer: Fj,
    FlowsList: Bvt,
    FlowInfo: tgt,
    FlowsActions: cgt
  }
};
var dgt = function() {
  var e = this, n = e._self._c;
  return n("PbFlowsViewer", { scopedSlots: e._u([{ key: "list", fn: function() {
    return [n("FlowsList")];
  }, proxy: !0 }, { key: "info", fn: function() {
    return [n("FlowInfo")];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [n("FlowsActions")];
  }, proxy: !0 }]) });
}, fgt = [], pgt = /* @__PURE__ */ B(
  ugt,
  dgt,
  fgt,
  !1,
  null,
  null
);
const rA = pgt.exports, hgt = "_root_1foyo_1", mgt = "_entries_1foyo_8", vgt = {
  root: hgt,
  entries: mgt
}, ggt = {
  name: "flowsListSpecial",
  components: {
    FlowListItem: Bj,
    PbDynamicList: il,
    PbEmpty: tl
  },
  props: {
    entries: {
      type: Array,
      required: !0
    },
    selected: Object,
    selectedIndex: Number
  },
  computed: {
    sizeDeps() {
      return () => [];
    }
  },
  methods: {
    select(t, e) {
      this.$emit("select", e);
    }
  }
};
var ygt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "flows-list-special" } }, [!e.entries || !e.entries.length ? n("PbEmpty", { attrs: { text: "Нет потоков", "data-test-selector": "flows-special-list-empty" } }) : n("div", { class: e.$style.entries }, [n("PbDynamicList", { attrs: { items: e.entries, selected: e.selected.id, sizeDeps: e.sizeDeps, minItemHeight: 83, enableKeyboard: !0 }, on: { select: e.select }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, index: s }) {
    return [n("FlowListItem", { attrs: { index: s, entry: r, selectedIndex: e.selectedIndex, itemType: "special", "data-test-selector": "flows-list-item", "data-test-attrs": `item-id__${r.id}`, "data-test-id": r.id } })];
  } }]) })], 1)], 1);
}, bgt = [];
const sA = {
  $style: vgt
};
function _gt(t) {
  for (var e in sA)
    this[e] = sA[e];
}
var wgt = /* @__PURE__ */ B(
  ggt,
  ygt,
  bgt,
  !1,
  _gt,
  null
);
const Sgt = wgt.exports, Igt = "_root_1tauy_1", Egt = {
  root: Igt
}, xgt = {
  name: "flowsActionsSpecial",
  components: {
    MainActionButton: fn
  },
  props: {
    entries: {
      type: Array,
      required: !0
    },
    selected: Object
  },
  computed: {
    selectedFlowPanelId() {
      if (this.selected && this.selected.type) {
        const t = this.$store.state.panels.data.find(
          (e) => e.type === this.selected.type
        );
        return t ? t.id : null;
      }
      return null;
    }
  },
  methods: {
    ...ge("panels", ["addPanel"]),
    ...ge(["addMessage"]),
    addToWorkspace() {
      this.addPanel({ panel: { type: this.selected.type }, goToPanel: !1 }), this.addMessage({
        type: "success",
        text: "Поток добавлен на рабочую область"
      });
    }
  }
};
var Cgt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [e.entries.length ? n("div", { class: e.$style.content }, [e.selectedFlowPanelId ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", disabled: !0, "data-test-selector": "flows-button-already-added" }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [n("icon", { attrs: { type: "font", name: "done", size: "24" } })];
  }, proxy: !0 }], null, !1, 375664491) }, [e._v("Поток уже добавлен на рабочую область ")]) : n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "flows-button-add-to-workspace" }, nativeOn: { click: function(r) {
    return e.addToWorkspace.apply(null, arguments);
  } } }, [e._v(" Добавить поток на рабочую область ")])], 1) : e._e()]);
}, Tgt = [];
const iA = {
  $style: Egt
};
function Pgt(t) {
  for (var e in iA)
    this[e] = iA[e];
}
var kgt = /* @__PURE__ */ B(
  xgt,
  Cgt,
  Tgt,
  !1,
  Pgt,
  null
);
const Ngt = kgt.exports, $gt = "_info_65kge_1", Dgt = "_infoContent_65kge_6", Agt = "_infoTitle_65kge_10", Ogt = {
  info: $gt,
  infoContent: Dgt,
  infoTitle: Agt
}, Mgt = {
  name: "TheFlowsSpecial",
  components: {
    PbFlowsViewer: Fj,
    FlowsListSpecial: Sgt,
    FlowsActionsSpecial: Ngt
  },
  data() {
    return {
      selectedIndex: 0
    };
  },
  computed: {
    ...pe("auth", ["getIsUserHasAllPermissions"]),
    entries() {
      const t = [];
      this.getIsUserHasAllPermissions(["4.1"]) && t.push({
        id: 2,
        type: ve.asoiNotes,
        name: "Заметки из АСОИ"
      }), this.getIsUserHasAllPermissions(["4.2"]) && t.push({
        id: 3,
        type: ve.asoiNotesSent,
        name: "Отправленные в АСОИ"
      }), this.getIsUserHasAllPermissions(["4.3"]) && t.push({
        id: 6,
        type: ve.asoiNotesEmbargo,
        name: "Отложенные заметки АСОИ"
      }), this.getIsUserHasAllPermissions(["2.12"]) && t.push({
        id: 4,
        type: ve.disposed,
        name: "Отвал"
      }), this.getIsUserHasAllPermissions(["2.8"]) && t.push({
        id: 5,
        type: ve.awaitingPublication,
        name: "Отложенные публикации"
      }), this.getIsUserHasAllPermissions(["2.17"]) && t.push({
        id: 7,
        type: ve.originals,
        name: "Лента оригиналов"
      });
      const e = JS.getColorMap();
      return t.forEach((n) => n.color = e[n.type]), t;
    },
    selected() {
      return this.entries[this.selectedIndex];
    }
  },
  methods: {
    select(t) {
      this.selectedIndex = t;
    }
  }
};
var Rgt = function() {
  var e = this, n = e._self._c;
  return n("PbFlowsViewer", { scopedSlots: e._u([{ key: "list", fn: function() {
    return [n("FlowsListSpecial", { attrs: { entries: e.entries, selected: e.selected, selectedIndex: e.selectedIndex }, on: { select: function(r) {
      return e.select(r);
    } } })];
  }, proxy: !0 }, { key: "info", fn: function() {
    return [n("div", { class: e.$style.info }, [e.selected && e.selected.name ? n("div", { class: e.$style.infoContent }, [n("div", { class: e.$style.infoTitle }, [n("h2", { attrs: { "data-test-selector": "flow-name" } }, [e._v(e._s(e.selected.name))])])]) : e._e()])];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [n("FlowsActionsSpecial", { attrs: { entries: e.entries, selected: e.selected } })];
  }, proxy: !0 }]) });
}, Lgt = [];
const oA = {
  $style: Ogt
};
function Fgt(t) {
  for (var e in oA)
    this[e] = oA[e];
}
var Bgt = /* @__PURE__ */ B(
  Mgt,
  Rgt,
  Lgt,
  !1,
  Fgt,
  null
);
const jgt = Bgt.exports, Wgt = "_root_efync_1", Hgt = "_name_efync_12", Vgt = "_sources_efync_16", zgt = "_sources_noSwitcher_efync_20", Ugt = "_sources_empty_efync_23", Ggt = "_sourceName_efync_31", Ygt = "_blockLine_efync_52", Zgt = "_errors_efync_77", Xgt = "_sourceId_efync_83", Kgt = "_sourceUrl_efync_90", Jgt = "_sourcesList_efync_99", qgt = "_paletteMenu_efync_118", Qgt = "_paletteMenuToggle_efync_124", eyt = "_paletteMenuToggle_showed_efync_141", tyt = "_paletteMenuDropdown_efync_145", nyt = {
  root: Wgt,
  name: Hgt,
  sources: Vgt,
  sources_noSwitcher: zgt,
  sources_empty: Ugt,
  sourceName: Ggt,
  blockLine: Ygt,
  errors: Zgt,
  sourceId: Xgt,
  sourceUrl: Kgt,
  sourcesList: Jgt,
  paletteMenu: qgt,
  paletteMenuToggle: Qgt,
  paletteMenuToggle_showed: eyt,
  paletteMenuDropdown: tyt
}, ryt = {
  name: "FlowEditor",
  components: {
    PbDynamicList: il,
    PbPalette: WR,
    PbButtonSwitcher: rl
  },
  props: {
    flow: {
      type: Object,
      default: () => ({ sources: [] })
    },
    loaded: {
      type: Boolean,
      default: !1
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      paletteShowed: !1,
      colors: Oie,
      buttons: [
        {
          type: "public",
          label: "Публичный",
          value: !0,
          testSelector: "switcher-button",
          testAttrs: "button__public"
        },
        {
          type: "private",
          label: "Приватный",
          value: !1,
          testSelector: "switcher-button",
          testAttrs: "button__private"
        }
      ]
    };
  },
  computed: {
    color() {
      return this.flow.color ? this.flow.color[0] === "#" ? this.flow.color : "#" + this.flow.color : "rgb(56, 56, 56)";
    },
    sources() {
      return this.flow.sources ? this.flow.sources.map(({ source: t }) => t) : [];
    },
    sizeDeps() {
      return () => [];
    }
  },
  watch: {
    paletteShowed: function(t) {
      t ? document.addEventListener("mousedown", this.clickOutsidePalette) : document.removeEventListener("mousedown", this.clickOutsidePalette);
    }
  },
  mounted() {
    this.$refs.name.focus();
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.clickOutsidePalette);
  },
  methods: {
    togglePalette() {
      this.paletteShowed = !this.paletteShowed;
    },
    clickOutsidePalette(t) {
      this.$refs.palette.contains(t.target) || (this.paletteShowed = !1);
    },
    removeSource(t) {
      this.$emit("unpickSource", t);
    },
    pickColor(t) {
      this.flow.color = t, this.paletteShowed = !1;
    },
    loadMore() {
      this.$emit("loadMore");
    }
  }
};
var syt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "flow-editor-container" } }, [n("div", { class: [e.$style.blockLine, e.$style.name] }, [n("h2", [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.flow.name, expression: "flow.name" }], ref: "name", attrs: { type: "text", placeholder: "Введите название потока", "data-test-selector": "flow-editor-field-name" }, domProps: { value: e.flow.name }, on: { input: function(r) {
    r.target.composing || e.$set(e.flow, "name", r.target.value);
  } } })]), n("div", { ref: "palette", class: e.$style.paletteMenu }, [n("div", { class: {
    [e.$style.paletteMenuToggle]: !0,
    [e.$style.paletteMenuToggle_showed]: e.paletteShowed
  }, style: { "background-color": e.color }, attrs: { "data-test-selector": "flow-editor-field-palette" }, on: { click: e.togglePalette } }), n("transition", { attrs: { name: "fade-transition", duration: 200 } }, [e.paletteShowed ? n("div", { class: e.$style.paletteMenuDropdown }, [n("PbPalette", { attrs: { usedColors: e.colors, picked: e.flow.color }, on: { pickColor: e.pickColor } })], 1) : e._e()])], 1), e.errors.name ? n("div", { class: e.$style.errors, attrs: { "data-test-selector": "flow-editor-errors" } }, e._l(e.errors.name, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "flow-editor-error", "data-test-attrs": `error-index__${s}` } }, [e._v(e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e()]), e.flow.is_my ? n("div", { class: e.$style.blockLine }, [n("PbButtonSwitcher", { attrs: { buttons: e.buttons }, model: { value: e.flow.is_public, callback: function(r) {
    e.$set(e.flow, "is_public", r);
  }, expression: "flow.is_public" } })], 1) : e._e(), e.sources && e.sources.length ? n("div", { class: {
    [e.$style.sources]: !0,
    [e.$style.sources_noSwitcher]: !e.flow.is_my
  }, attrs: { "data-test-selector": "flow-editor-sources" } }, [e.errors.id && e.errors.id.length ? n("div", { class: e.$style.blockLine }, [n("div", { class: e.$style.errors, attrs: { "data-test-selector": "flow-editor-sources-errors" } }, e._l(e.errors.id, function(r, s) {
    return n("span", { key: r.title, staticClass: "error-message", attrs: { "data-test-selector": "flow-editor-sources-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0)]) : e._e(), n("PbDynamicList", { ref: "entriesList", attrs: { items: e.sources, minItemHeight: 97, sizeDeps: e.sizeDeps, showLoader: !e.loaded }, on: { reachedEnd: e.loadMore }, scopedSlots: e._u([{ key: "default", fn: function({ item: r }) {
    return [n("div", { class: e.$style.blockLine, attrs: { "data-test-selector": "flow-editor-sources-item", "data-test-attrs": `item-id__${r.id}` } }, [n("div", { class: e.$style.sourceName }, [n("span", { attrs: { title: r.name } }, [e._v(e._s(r.name))]), n("i", { attrs: { "data-test-selector": "flow-editor-source-remove" }, on: { click: function(s) {
      return e.removeSource(r);
    } } }, [e._v(" ⨯ ")])]), n("div", [n("a", { class: e.$style.sourceUrl, attrs: { href: r.url, target: "_blank" } }, [e._v(" " + e._s(r.url) + " ")])])])];
  } }], null, !1, 3121745990) })], 1) : n("div", { class: [e.$style.sources, e.$style.sources_empty] }, [n("h3", [e._v("Выберите источники из списка")]), n("div", { class: e.$style.errors, attrs: { "data-test-selector": "flow-editor-sources-errors" } }, e._l(e.errors.sources, function(r, s) {
    return n("span", { key: r.title, staticClass: "error-message", attrs: { "data-test-selector": "flow-editor-sources-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0)])]);
}, iyt = [];
const aA = {
  $style: nyt
};
function oyt(t) {
  for (var e in aA)
    this[e] = aA[e];
}
var ayt = /* @__PURE__ */ B(
  ryt,
  syt,
  iyt,
  !1,
  oyt,
  null
);
const lyt = ayt.exports, cyt = "_root_fpycs_1", uyt = {
  root: cyt
}, dyt = {
  name: "flowsActions",
  components: {
    MainActionButton: fn,
    DialogConfirm: Gu
  },
  props: {
    flow: Object
  },
  data() {
    return {
      removeDialog: !1
    };
  },
  computed: {
    isAdded() {
      return this.$store.getters.flowsAddedOnWorkspace.indexOf(this.flow.id) !== -1;
    }
  },
  methods: {
    addToWorkspace() {
      this.$emit("addToWorkspace");
    },
    save() {
      this.$emit("save");
    },
    remove() {
      this.$emit("remove");
    }
  }
};
var fyt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-save", "data-test-selector": "flow-button-save" }, nativeOn: { click: function(r) {
    return e.save.apply(null, arguments);
  } } }, [e._v(" Сохранить поток ")]), e.isAdded ? e._e() : n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", "data-test-selector": "flow-button-add-to-workspace" }, nativeOn: { click: function(r) {
    return e.addToWorkspace.apply(null, arguments);
  } } }, [e._v(" Добавить поток на рабочую область ")]), e.isAdded ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-add", disabled: !0, "data-test-selector": "flow-button-already-added" }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [n("icon", { attrs: { type: "font", name: "done", size: "24" } })];
  }, proxy: !0 }], null, !1, 375664491) }, [e._v("Поток уже добавлен на рабочую область ")]) : e._e(), e.$route.name === "flowEdit" ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-delete", "data-test-selector": "flow-button-remove" }, nativeOn: { click: function(r) {
    e.removeDialog = !0;
  } } }, [e._v(" Удалить поток ")]) : e._e(), n("DialogConfirm", { attrs: { state: e.removeDialog }, on: { "update:state": function(r) {
    e.removeDialog = r;
  }, agree: e.remove }, scopedSlots: e._u([{ key: "question", fn: function() {
    return [n("h3", [e._v("Удалить поток?")])];
  }, proxy: !0 }]) })], 1);
}, pyt = [];
const lA = {
  $style: uyt
};
function hyt(t) {
  for (var e in lA)
    this[e] = lA[e];
}
var myt = /* @__PURE__ */ B(
  dyt,
  fyt,
  pyt,
  !1,
  hyt,
  null
);
const vyt = myt.exports;
var jj = { exports: {} };
(function(t) {
  t.exports = function(e) {
    function n(s) {
      if (r[s]) return r[s].exports;
      var i = r[s] = { i: s, l: !1, exports: {} };
      return e[s].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    var r = {};
    return n.m = e, n.c = r, n.d = function(s, i, o) {
      n.o(s, i) || Object.defineProperty(s, i, { configurable: !1, enumerable: !0, get: o });
    }, n.n = function(s) {
      var i = s && s.__esModule ? function() {
        return s.default;
      } : function() {
        return s;
      };
      return n.d(i, "a", i), i;
    }, n.o = function(s, i) {
      return Object.prototype.hasOwnProperty.call(s, i);
    }, n.p = "", n(n.s = 19);
  }([function(e, n) {
    var r = e.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
    typeof __g == "number" && (__g = r);
  }, function(e, n) {
    var r = e.exports = { version: "2.5.3" };
    typeof __e == "number" && (__e = r);
  }, function(e, n) {
    e.exports = function(r) {
      return typeof r == "object" ? r !== null : typeof r == "function";
    };
  }, function(e, n, r) {
    var s = r(23), i = r(28);
    e.exports = r(4) ? function(o, a, l) {
      return s.f(o, a, i(1, l));
    } : function(o, a, l) {
      return o[a] = l, o;
    };
  }, function(e, n, r) {
    e.exports = !r(6)(function() {
      return Object.defineProperty({}, "a", { get: function() {
        return 7;
      } }).a != 7;
    });
  }, function(e, n, r) {
    var s = r(0), i = r(1), o = r(3), a = r(29), l = r(8), c = function(u, d, f) {
      var p, h, m, v, y = u & c.F, _ = u & c.G, w = u & c.S, S = u & c.P, E = u & c.B, x = _ ? s : w ? s[d] || (s[d] = {}) : (s[d] || {}).prototype, T = _ ? i : i[d] || (i[d] = {}), C = T.prototype || (T.prototype = {});
      _ && (f = d);
      for (p in f) h = !y && x && x[p] !== void 0, m = (h ? x : f)[p], v = E && h ? l(m, s) : S && typeof m == "function" ? l(Function.call, m) : m, x && a(x, p, m, u & c.U), T[p] != m && o(T, p, v), S && C[p] != m && (C[p] = m);
    };
    s.core = i, c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, e.exports = c;
  }, function(e, n) {
    e.exports = function(r) {
      try {
        return !!r();
      } catch {
        return !0;
      }
    };
  }, function(e, n) {
    var r = 0, s = Math.random();
    e.exports = function(i) {
      return "Symbol(".concat(i === void 0 ? "" : i, ")_", (++r + s).toString(36));
    };
  }, function(e, n, r) {
    var s = r(31);
    e.exports = function(i, o, a) {
      if (s(i), o === void 0) return i;
      switch (a) {
        case 1:
          return function(l) {
            return i.call(o, l);
          };
        case 2:
          return function(l, c) {
            return i.call(o, l, c);
          };
        case 3:
          return function(l, c, u) {
            return i.call(o, l, c, u);
          };
      }
      return function() {
        return i.apply(o, arguments);
      };
    };
  }, function(e, n, r) {
    var s = r(10);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function(i) {
      return s(i) == "String" ? i.split("") : Object(i);
    };
  }, function(e, n) {
    var r = {}.toString;
    e.exports = function(s) {
      return r.call(s).slice(8, -1);
    };
  }, function(e, n) {
    e.exports = function(r) {
      if (r == null) throw TypeError("Can't call method on  " + r);
      return r;
    };
  }, function(e, n, r) {
    var s = r(13), i = Math.min;
    e.exports = function(o) {
      return o > 0 ? i(s(o), 9007199254740991) : 0;
    };
  }, function(e, n) {
    var r = Math.ceil, s = Math.floor;
    e.exports = function(i) {
      return isNaN(i = +i) ? 0 : (i > 0 ? s : r)(i);
    };
  }, function(e, n, r) {
    var s = r(15)("unscopables"), i = Array.prototype;
    i[s] == null && r(3)(i, s, {}), e.exports = function(o) {
      i[s][o] = !0;
    };
  }, function(e, n, r) {
    var s = r(35)("wks"), i = r(7), o = r(0).Symbol, a = typeof o == "function";
    (e.exports = function(l) {
      return s[l] || (s[l] = a && o[l] || (a ? o : i)("Symbol." + l));
    }).store = s;
  }, function(e, n) {
    e.exports = function(r, s, i, o, a) {
      var l, c = r = r || {}, u = typeof r.default;
      u !== "object" && u !== "function" || (l = r, c = r.default);
      var d = typeof c == "function" ? c.options : c;
      s && (d.render = s.render, d.staticRenderFns = s.staticRenderFns), o && (d._scopeId = o);
      var f;
      if (a ? (f = function(m) {
        m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, m || typeof __VUE_SSR_CONTEXT__ > "u" || (m = __VUE_SSR_CONTEXT__), i && i.call(this, m), m && m._registeredComponents && m._registeredComponents.add(a);
      }, d._ssrRegister = f) : i && (f = i), f) {
        var p = d.functional, h = p ? d.render : d.beforeCreate;
        p ? d.render = function(m, v) {
          return f.call(v), h(m, v);
        } : d.beforeCreate = h ? [].concat(h, f) : [f];
      }
      return { esModule: l, exports: c, options: d };
    };
  }, function(e, n, r) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.default = { data: void 0 };
  }, function(e, n, r) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var s = function(i) {
      return i.reduce(function(o, a) {
        return (o[a] = a) && o;
      }, {});
    };
    n.events = s(["drag", "dragend", "dragenter", "dragleave", "dragstart", "dragover", "drop"]), n.dropEffects = s(["copy", "move", "link", "none"]), n.effectsAllowed = s(["none", "copy", "copyLink", "copyMove", "link", "linkMove", "move", "all", "uninitialized"]);
  }, function(e, n, r) {
    r(20), e.exports = r(43);
  }, function(e, n, r) {
    r(21), r(36);
  }, function(e, n, r) {
    r(22), e.exports = r(1).Array.includes;
  }, function(e, n, r) {
    var s = r(5), i = r(32)(!0);
    s(s.P, "Array", { includes: function(o) {
      return i(this, o, arguments.length > 1 ? arguments[1] : void 0);
    } }), r(14)("includes");
  }, function(e, n, r) {
    var s = r(24), i = r(25), o = r(27), a = Object.defineProperty;
    n.f = r(4) ? Object.defineProperty : function(l, c, u) {
      if (s(l), c = o(c, !0), s(u), i) try {
        return a(l, c, u);
      } catch {
      }
      if ("get" in u || "set" in u) throw TypeError("Accessors not supported!");
      return "value" in u && (l[c] = u.value), l;
    };
  }, function(e, n, r) {
    var s = r(2);
    e.exports = function(i) {
      if (!s(i)) throw TypeError(i + " is not an object!");
      return i;
    };
  }, function(e, n, r) {
    e.exports = !r(4) && !r(6)(function() {
      return Object.defineProperty(r(26)("div"), "a", { get: function() {
        return 7;
      } }).a != 7;
    });
  }, function(e, n, r) {
    var s = r(2), i = r(0).document, o = s(i) && s(i.createElement);
    e.exports = function(a) {
      return o ? i.createElement(a) : {};
    };
  }, function(e, n, r) {
    var s = r(2);
    e.exports = function(i, o) {
      if (!s(i)) return i;
      var a, l;
      if (o && typeof (a = i.toString) == "function" && !s(l = a.call(i)) || typeof (a = i.valueOf) == "function" && !s(l = a.call(i)) || !o && typeof (a = i.toString) == "function" && !s(l = a.call(i))) return l;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function(e, n) {
    e.exports = function(r, s) {
      return { enumerable: !(1 & r), configurable: !(2 & r), writable: !(4 & r), value: s };
    };
  }, function(e, n, r) {
    var s = r(0), i = r(3), o = r(30), a = r(7)("src"), l = Function.toString, c = ("" + l).split("toString");
    r(1).inspectSource = function(u) {
      return l.call(u);
    }, (e.exports = function(u, d, f, p) {
      var h = typeof f == "function";
      h && (o(f, "name") || i(f, "name", d)), u[d] !== f && (h && (o(f, a) || i(f, a, u[d] ? "" + u[d] : c.join(String(d)))), u === s ? u[d] = f : p ? u[d] ? u[d] = f : i(u, d, f) : (delete u[d], i(u, d, f)));
    })(Function.prototype, "toString", function() {
      return typeof this == "function" && this[a] || l.call(this);
    });
  }, function(e, n) {
    var r = {}.hasOwnProperty;
    e.exports = function(s, i) {
      return r.call(s, i);
    };
  }, function(e, n) {
    e.exports = function(r) {
      if (typeof r != "function") throw TypeError(r + " is not a function!");
      return r;
    };
  }, function(e, n, r) {
    var s = r(33), i = r(12), o = r(34);
    e.exports = function(a) {
      return function(l, c, u) {
        var d, f = s(l), p = i(f.length), h = o(u, p);
        if (a && c != c) {
          for (; p > h; ) if ((d = f[h++]) != d) return !0;
        } else for (; p > h; h++) if ((a || h in f) && f[h] === c) return a || h || 0;
        return !a && -1;
      };
    };
  }, function(e, n, r) {
    var s = r(9), i = r(11);
    e.exports = function(o) {
      return s(i(o));
    };
  }, function(e, n, r) {
    var s = r(13), i = Math.max, o = Math.min;
    e.exports = function(a, l) {
      return a = s(a), a < 0 ? i(a + l, 0) : o(a, l);
    };
  }, function(e, n, r) {
    var s = r(0), i = s["__core-js_shared__"] || (s["__core-js_shared__"] = {});
    e.exports = function(o) {
      return i[o] || (i[o] = {});
    };
  }, function(e, n, r) {
    r(37), e.exports = r(1).Array.find;
  }, function(e, n, r) {
    var s = r(5), i = r(38)(5), o = !0;
    "find" in [] && Array(1).find(function() {
      o = !1;
    }), s(s.P + s.F * o, "Array", { find: function(a) {
      return i(this, a, arguments.length > 1 ? arguments[1] : void 0);
    } }), r(14)("find");
  }, function(e, n, r) {
    var s = r(8), i = r(9), o = r(39), a = r(12), l = r(40);
    e.exports = function(c, u) {
      var d = c == 1, f = c == 2, p = c == 3, h = c == 4, m = c == 6, v = c == 5 || m, y = u || l;
      return function(_, w, S) {
        for (var E, x, T = o(_), C = i(T), k = s(w, S, 3), b = a(C.length), P = 0, N = d ? y(_, b) : f ? y(_, 0) : void 0; b > P; P++) if ((v || P in C) && (E = C[P], x = k(E, P, T), c)) {
          if (d) N[P] = x;
          else if (x) switch (c) {
            case 3:
              return !0;
            case 5:
              return E;
            case 6:
              return P;
            case 2:
              N.push(E);
          }
          else if (h) return !1;
        }
        return m ? -1 : p || h ? h : N;
      };
    };
  }, function(e, n, r) {
    var s = r(11);
    e.exports = function(i) {
      return Object(s(i));
    };
  }, function(e, n, r) {
    var s = r(41);
    e.exports = function(i, o) {
      return new (s(i))(o);
    };
  }, function(e, n, r) {
    var s = r(2), i = r(42), o = r(15)("species");
    e.exports = function(a) {
      var l;
      return i(a) && (l = a.constructor, typeof l != "function" || l !== Array && !i(l.prototype) || (l = void 0), s(l) && (l = l[o]) === null && (l = void 0)), l === void 0 ? Array : l;
    };
  }, function(e, n, r) {
    var s = r(10);
    e.exports = Array.isArray || function(i) {
      return s(i) == "Array";
    };
  }, function(e, n, r) {
    function s(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function i(f) {
      f.component("drag", a.default), f.component("drop", c.default);
    }
    Object.defineProperty(n, "__esModule", { value: !0 }), n.Drop = n.Drag = void 0, n.install = i;
    var o = r(44), a = s(o), l = r(47), c = s(l);
    n.Drag = a.default, n.Drop = c.default;
    var u = { version: "1.1.4", install: i };
    n.default = u;
    var d = null;
    typeof window < "u" ? d = window.Vue : typeof vr < "u" && (d = vr.Vue), d && d.use(u);
  }, function(e, n, r) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var s = r(45), i = r.n(s), o = r(46), a = r(16), l = a(i.a, o.a, null, null, "319bdce9");
    n.default = l.exports;
  }, function(e, n, r) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var s = r(17), i = function(a) {
      return a && a.__esModule ? a : { default: a };
    }(s), o = r(18);
    n.default = { props: { draggable: { type: Boolean, default: !0 }, transferData: {}, dropEffect: { validator: function(a) {
      return a in o.dropEffects;
    } }, effectAllowed: { validator: function(a) {
      return a in o.effectsAllowed;
    } }, image: String, imageXOffset: { type: Number, default: 0 }, imageYOffset: { type: Number, default: 0 }, hideImageHtml: { type: Boolean, default: !0 }, tag: { type: String, default: "div" } }, data: function() {
      return { dragging: !1 };
    }, computed: { events: function() {
      return o.events;
    }, scopedData: function() {
      return this.dragging && this.transferData;
    }, hideImageStyle: function() {
      return { position: "fixed", top: "-1000px" };
    } }, methods: { emitEvent: function(a, l) {
      var c = l.dataTransfer;
      if ([o.events.dragenter, o.events.dragover].includes(a) && this.dropEffect && (c.dropEffect = this.dropEffect), a === o.events.dragstart) {
        if (this.effectAllowed && (c.effectAllowed = this.effectAllowed), this.image || this.$slots.image) {
          var u = void 0;
          this.image ? (u = new Image(), u.src = this.image) : this.$slots.image && (u = this.$slots.image[0].elm), c.setDragImage && c.setDragImage(u, this.imageXOffset, this.imageYOffset);
        }
        this.transferData !== void 0 && (i.default.data = this.transferData, l.dataTransfer.setData("text", "")), this.dragging = !0;
      }
      this.$emit(a, this.transferData, l), a === o.events.dragend && (i.default.data = void 0, this.dragging = !1);
    } } };
  }, function(e, n, r) {
    var s = function() {
      var a = this, l = a.$createElement, c = a._self._c || l;
      return c(a.tag, { tag: "component", attrs: { draggable: a.draggable }, on: { drag: function(u) {
        a.emitEvent(a.events.drag, u);
      }, dragstart: function(u) {
        a.emitEvent(a.events.dragstart, u);
      }, dragenter: function(u) {
        a.emitEvent(a.events.dragenter, u);
      }, dragleave: function(u) {
        a.emitEvent(a.events.dragleave, u);
      }, dragend: function(u) {
        a.emitEvent(a.events.dragend, u);
      } } }, [a._t("default", null, { transferData: a.scopedData }), a._v(" "), a.hideImageHtml ? c("div", { style: a.hideImageStyle }, [a._t("image", null, { transferData: a.scopedData })], 2) : a._t("image", null, { transferData: a.scopedData })], 2);
    }, i = [], o = { render: s, staticRenderFns: i };
    n.a = o;
  }, function(e, n, r) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var s = r(48), i = r.n(s), o = r(49), a = r(16), l = a(i.a, o.a, null, null, "49fe8924");
    n.default = l.exports;
  }, function(e, n, r) {
    Object.defineProperty(n, "__esModule", { value: !0 });
    var s = r(17), i = function(l) {
      return l && l.__esModule ? l : { default: l };
    }(s), o = r(18), a = /* @__PURE__ */ new Set();
    n.default = { data: function() {
      return { transferData: void 0, isDraggingOver: !1 };
    }, props: { tag: { type: String, default: "div" } }, computed: { events: function() {
      return o.events;
    }, scopedData: function() {
      return this.isDraggingOver && this.transferData;
    } }, methods: { emitEvent: function(l, c) {
      this.transferData = i.default.data, this.$emit(l, this.transferData, c), l === o.events.dragenter && (a.size || c.target === this.$el) && a.add(c.target), l === o.events.dragleave && a.delete(c.target), l === o.events.drop && a.clear(), this.isDraggingOver = !!a.size;
    } } };
  }, function(e, n, r) {
    var s = function() {
      var a = this, l = a.$createElement;
      return (a._self._c || l)(a.tag, { tag: "component", on: { dragenter: function(c) {
        a.emitEvent(a.events.dragenter, c);
      }, dragleave: function(c) {
        a.emitEvent(a.events.dragleave, c);
      }, dragover: function(c) {
        c.preventDefault(), a.emitEvent(a.events.dragover, c);
      }, drop: function(c) {
        c.preventDefault(), a.emitEvent(a.events.drop, c);
      } } }, [a._t("default", null, { transferData: a.scopedData })], 2);
    }, i = [], o = { render: s, staticRenderFns: i };
    n.a = o;
  }]);
})(jj);
var If = jj.exports;
const gyt = "_root_dj3di_1", yyt = "_entry_dj3di_5", byt = "_head_dj3di_11", _yt = "_icon_dj3di_23", wyt = "_name_dj3di_32", Syt = {
  root: gyt,
  entry: yyt,
  head: byt,
  icon: _yt,
  name: wyt
}, Iyt = {
  name: "SourcesListPlaceholder",
  components: {
    Drop: If.Drop
  },
  props: {
    entry: Object
  },
  data() {
    return {
      over: !1
    };
  },
  errorCaptured(t) {
    console.error(t);
  },
  methods: {
    onDragEnter(t) {
      t && (this.over = !0, this.$emit("placeholderEnter", this.entry.id));
    },
    onDragOver(t, e) {
      e.stopPropagation(), t && (this.over || (this.over = !0), this.$emit("placeholderEnter", this.entry.id));
    },
    onDragLeave(t) {
      t && (this.over = !1, this.$emit("placeholderLeave"));
    },
    onDrop(t, e) {
      t && (e.stopPropagation(), this.over = !1, t.entry.id !== this.entry.id && (t.entry.parent_id === this.entry.parent_id ? this.$emit("moveToIndex", {
        dragSourceId: t.entry.id,
        dropSourceId: this.entry.id
      }) : this.$emit("move", {
        newParentId: this.entry.parent_id,
        dropSourceId: this.entry.id
      }), this.$emit("placeholderLeave")));
    }
  }
};
var Eyt = function() {
  var e = this, n = e._self._c;
  return n("drop", { class: [e.$style.root, "drop-placeholder"], on: { dragenter: e.onDragEnter, dragover: e.onDragOver, dragleave: e.onDragLeave, drop: e.onDrop }, scopedSlots: e._u([{ key: "default", fn: function(r) {
    return [e.over ? n("div", { class: e.$style.entry, style: {
      height: r.transferData ? r.transferData.vm.height + "px" : "2px"
    } }, [n("div", { class: e.$style.head }, [n("div", { class: e.$style.icon }, [n("icon", { class: {
      "is-opened": r.transferData ? r.transferData.vm.isOpened : !1
    }, attrs: { name: r.transferData ? r.transferData.vm.iconName : "source-leaf-icon", size: 15 } })], 1), n("div", { class: e.$style.name }, [n("span", [e._v(" " + e._s(r.transferData ? r.transferData.entry.name : null) + " ")])])])]) : e._e()];
  } }]) });
}, xyt = [];
const cA = {
  $style: Syt
};
function Cyt(t) {
  for (var e in cA)
    this[e] = cA[e];
}
var Tyt = /* @__PURE__ */ B(
  Iyt,
  Eyt,
  xyt,
  !1,
  Cyt,
  null
);
const Pyt = Tyt.exports, kyt = "_root_1q6jn_1", Nyt = "_root_selected_1q6jn_6", $yt = "_root_highlighted_1q6jn_6", Dyt = "_head_1q6jn_6", Ayt = "_children_1q6jn_16", Oyt = "_headIcon_1q6jn_42", Myt = "_headIcon_opened_1q6jn_45", Ryt = "_headIcon_picked_1q6jn_45", Lyt = "_icon_1q6jn_49", Fyt = "_name_1q6jn_58", Byt = "_input_1q6jn_71", jyt = "_empty_1q6jn_83", Wyt = "_loading_1q6jn_94", Hyt = {
  root: kyt,
  root_selected: Nyt,
  root_highlighted: $yt,
  head: Dyt,
  children: Ayt,
  headIcon: Oyt,
  headIcon_opened: Myt,
  headIcon_picked: Ryt,
  icon: Lyt,
  name: Fyt,
  input: Byt,
  empty: jyt,
  loading: Wyt
}, Vyt = {
  name: "SourcesListItem",
  components: {
    Drag: If.Drag,
    Drop: If.Drop,
    SourcesListPlaceholder: Pyt,
    PbCircularLoader: br
  },
  props: {
    mode: {
      type: String
    },
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    pickedSources: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isRenaming: !1,
      over: !1
    };
  },
  computed: {
    ...st({
      dirMap: (t) => t.sources.dirMap,
      opened: (t) => t.sources.opened,
      selected: (t) => t.sources.selected,
      active: (t) => t.sources.active
    }),
    ...pe(["getSourceById"]),
    ...pe("references", ["premoderatedSourceTypes"]),
    entry() {
      return this.getSourceById(this.item.id);
    },
    isDirectory() {
      return this.entry && this.entry.type_id === 0;
    },
    isOfPremoderatedType() {
      return this.entry && this.premoderatedSourceTypes.includes(this.entry.type_id);
    },
    isOpened() {
      return this.entry && this.opened.includes(this.entry.id);
    },
    isSelected() {
      return this.entry && this.$store.state.sources.selected.includes(this.entry.id);
    },
    isActive() {
      return this.entry && this.active === this.entry.id;
    },
    isTmp() {
      return this.entry && this.entry.id === "tmp";
    },
    isPicked() {
      if (!this.entry) return !1;
      const t = this.pickedSources.find(
        ({ source: e }) => e.id === this.entry.id
      );
      return t && t._action === "DELETE" ? !1 : !!t;
    },
    isDraggable() {
      return this.mode === "sources" && this.isRenaming === !1 && !this.isLoading && !this.isOfPremoderatedType;
    },
    isDroppable() {
      return !this.isOfPremoderatedType;
    },
    isLoading() {
      const t = this.entry;
      return t && this.dirMap[t.id] && this.dirMap[t.id].loading ? this.dirMap[t.id].loading : !1;
    },
    hasChildren() {
      const t = this.entry;
      return t && this.dirMap[t.id] && this.dirMap[t.id].children ? !!this.dirMap[t.id].children.length : !1;
    },
    iconName() {
      return this.isDraggable ? this.isDirectory ? "list-bullet-arrow-down" : "source-leaf-icon" : this.isDirectory ? "list-bullet-arrow-down" : this.isPicked ? "minus" : "plus";
    },
    parentDirMap() {
      return !this.entry || this.entry.parent_id === null ? null : this.entry && this.dirMap[this.entry.parent_id];
    },
    level() {
      if (this.entry) {
        if (this.isDirectory && this.dirMap[this.entry.id])
          return this.dirMap[this.entry.id].level;
        if (this.entry.parent_id === null)
          return 0;
        if (this.parentDirMap) {
          const t = this.parentDirMap.level !== null && this.parentDirMap.level !== void 0 && this.opened.includes(this.entry.parent_id) ? this.parentDirMap.level : null;
          return t !== null ? t + 1 : 0;
        }
        return 0;
      }
      return 0;
    }
  },
  methods: {
    ...ge(["renameSource"]),
    select(t) {
      this.entry && this.$emit("select", {
        id: this.entry.id,
        ctrlPressed: t.ctrlKey || t.metaKey
      });
    },
    handleIconClick() {
      this.isTmp || (this.isDirectory ? this.toggle() : this.mode !== "sources" && this.pick());
    },
    handleBlur() {
      this.isRenaming = !1;
    },
    toggle() {
      this.entry && this.$emit("toggle", this.entry.id);
    },
    pick() {
      this.$emit("pick", this.entry);
    },
    onDoubleClick(t = !1) {
      this.isTmp && !t || this.isDirectory && (this.isRenaming = !0, this.$nextTick(() => {
        this.$refs.nameInput.focus();
      }));
    },
    async rename(t) {
      if (!this.entry) return;
      ({ ...this.entry });
      const e = t.target.value;
      await this.renameSource({ id: this.entry.id, name: e }), this.isRenaming = !1;
    },
    // Drag & Drop Handlers
    onDragEnter(t, e) {
      !t || !this.entry || (e.stopPropagation(), this.over = !0, t.entry.id !== this.entry.id && setTimeout(() => {
        this.over && this.isDirectory && !this.isOpened && this.toggle();
      }, 500));
    },
    onDragOver(t, e) {
      e.stopPropagation(), t && (this.over || (this.over = !0));
    },
    onDragLeave() {
      this.over = !1;
    },
    onDragStart(t, e) {
      t && (t.entry.parent_id && e.stopPropagation(), this.selected.includes(t.entry.id) || this.$emit("select", {
        id: t.entry.id,
        ctrlPressed: !1
      }));
    },
    onDrop(t, e) {
      !t || !this.entry || (e.stopPropagation(), this.over = !1, t.entry.id !== this.entry.id && (this.isDirectory ? t.entry.parent_id !== this.entry.id && this.$emit("move", {
        newParentId: this.entry.id,
        dropSourceId: this.entry.id
      }) : this.$emit("merge", { dropSourceId: this.entry.id })));
    },
    onDragEnd() {
      this.over && (this.over = !1);
    }
  }
};
var zyt = function() {
  var e = this, n = e._self._c;
  return e.entry ? n("div", { style: {
    "min-height": "25px",
    "margin-left": e.level * 20 + "px"
  } }, [n("SourcesListPlaceholder", { attrs: { entry: e.entry }, on: { placeholderEnter: function(r) {
    return e.$emit("placeholderEnter", r);
  }, placeholderLeave: function(r) {
    return e.$emit("placeholderLeave");
  }, moveToIndex: function(r) {
    return e.$emit("moveToIndex", r);
  }, move: function(r) {
    return e.$emit("move", r);
  } } }), n("drag", { staticClass: "drag", attrs: { draggable: e.isDraggable, transferData: { entry: e.entry, index: e.index, vm: e._self }, "effect-allowed": "move" }, on: { dragstart: e.onDragStart, dragend: e.onDragEnd } }, [e.isDroppable ? n("drop", { staticClass: "drop", class: { over: e.over }, on: { dragenter: e.onDragEnter, dragover: e.onDragOver, dragleave: e.onDragLeave, drop: e.onDrop } }, [n("div", { class: {
    [e.$style.root]: !0,
    [e.$style.root_selected]: e.isSelected,
    [e.$style.root_highlighted]: e.isOfPremoderatedType
  }, attrs: { "data-test-selector": "source-entry", "data-test-id": e.item.id, "data-test-attrs": `item-id__${e.item.id}${e.isPicked ? " picked" : ""}${e.isOpened ? " opened" : ""}` } }, [n("div", { class: e.$style.head, on: { click: function(r) {
    return e.select(r);
  } } }, [n("div", { class: e.$style.icon, on: { click: function(r) {
    return r.stopPropagation(), e.handleIconClick();
  } } }, [n("icon", { class: {
    [e.$style.headIcon]: !0,
    [e.$style.headIcon_opened]: e.isOpened,
    [e.$style.headIcon_picked]: e.isPicked
  }, attrs: { name: e.iconName, size: 15 } })], 1), n("div", { class: e.$style.name, on: { dblclick: function(r) {
    return e.onDoubleClick();
  } } }, [e.isDirectory && e.isRenaming ? n("span", [n("input", { ref: "nameInput", class: e.$style.input, attrs: { type: "text" }, domProps: { value: e.entry.name }, on: { keyup: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "enter", 13, r.key, "Enter") ? null : e.rename(r);
  }, focusout: e.handleBlur } })]) : n("span", [e._v(e._s(e.entry.name))])])])]), e.isLoading ? n("div", { class: e.$style.loading }, [n("PbCircularLoader", { attrs: { width: 2, size: 15 } })], 1) : e._e(), e.isOpened && !e.isLoading && !e.hasChildren ? n("div", { class: e.$style.empty }, [e._v(" <нет источников> ")]) : e._e()]) : [n("div", { class: {
    [e.$style.root]: !0,
    [e.$style.root_selected]: e.isSelected,
    [e.$style.root_highlighted]: e.isOfPremoderatedType
  }, attrs: { "data-test-selector": "source-entry", "data-test-id": e.item.id, "data-test-attrs": `item-id__${e.item.id}${e.isPicked ? " picked" : ""}${e.isOpened ? " opened" : ""}` } }, [n("div", { class: e.$style.head, on: { click: function(r) {
    return e.select(r);
  } } }, [n("div", { class: e.$style.icon, on: { click: function(r) {
    return r.stopPropagation(), e.handleIconClick();
  } } }, [n("icon", { class: {
    [e.$style.headIcon]: !0,
    [e.$style.headIcon_opened]: e.isOpened,
    [e.$style.headIcon_picked]: e.isPicked
  }, attrs: { name: e.iconName, size: 15 } })], 1), n("div", { class: e.$style.name, on: { dblclick: function(r) {
    return e.onDoubleClick();
  } } }, [e.isDirectory && e.isRenaming ? n("span", [n("input", { ref: "nameInput", class: e.$style.input, attrs: { type: "text" }, domProps: { value: e.entry.name }, on: { keyup: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "enter", 13, r.key, "Enter") ? null : e.rename(r);
  }, focusout: e.handleBlur } })]) : n("span", [e._v(e._s(e.entry.name))])])])]), e.isLoading ? n("div", { class: e.$style.loading }, [n("PbCircularLoader", { attrs: { width: 2, size: 15 } })], 1) : e._e(), e.isOpened && !e.isLoading && !e.hasChildren ? n("div", { class: e.$style.empty }, [e._v(" <нет источников> ")]) : e._e()]], 2)], 1) : e._e();
}, Uyt = [];
const uA = {
  $style: Hyt
};
function Gyt(t) {
  for (var e in uA)
    this[e] = uA[e];
}
var Yyt = /* @__PURE__ */ B(
  Vyt,
  zyt,
  Uyt,
  !1,
  Gyt,
  null
);
const Zyt = Yyt.exports, Xyt = "_root_8brk6_1", Kyt = "_entries_8brk6_9", Jyt = {
  root: Xyt,
  entries: Kyt
}, qyt = {
  name: "SourcesList",
  components: {
    SearchField: Mu,
    Drop: If.Drop,
    SourcesListItem: Zyt,
    PbDynamicList: il,
    PbEmpty: tl
  },
  props: {
    mode: String,
    flowId: {
      type: [Number, String],
      default: null
    },
    useSelection: {
      type: Boolean,
      default: !0
    },
    pickedSources: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !1,
      replacing: !1,
      offset: 0,
      limit: 100,
      entryHeight: 25,
      loaded: !1,
      total: 0,
      query: "",
      searchFieldFocused: !1,
      dragOverId: null
    };
  },
  computed: {
    ...st({
      dirMap: (t) => t.sources.dirMap,
      selected: (t) => t.sources.selected,
      opened: (t) => t.sources.opened,
      items: (t) => t.sources.items,
      list: (t) => t.sources.mainList || []
    }),
    items() {
      return this.list.map((t) => ({ id: t }));
    },
    buffer() {
      return this.entryHeight * 40;
    },
    sizeDeps() {
      return () => [];
    }
  },
  mounted() {
    this.fetchData(!0);
  },
  beforeDestroy() {
    this.sourcesResetState();
  },
  methods: {
    ...ge([
      "closeDirectory",
      "getSourceChildren",
      "openDirectory",
      "moveSource",
      "moveSourceToIndex",
      "replaceSources",
      "getSources",
      "selectSource",
      "createDirectory",
      "sourcesResetState"
    ]),
    /**
     * Выделение источников
     * @param {Object} event - объект события
     * @param {ID} event.id - идентификатор источника
     * @param {boolean} event.ctrlPressed - признак нажатия клавиши Ctrl для множественного выделения
     */
    select(t) {
      this.mode === "sources" && this.useSelection && this.selectSource({
        sourceId: t.id,
        multipleMode: t.ctrlPressed
      });
    },
    /**
     * Развернуть/свернуть директорию
     * @param {ID} sourceId - идентификатор директории
     */
    async toggleItem(t) {
      this.opened.includes(t) ? this.closeDirectory(t) : (await this.getSourceChildren(t), this.openDirectory(t));
    },
    /**
     * Перемещение источников
     * @param {Object} data - объект события
     * @param {?ID} data.newParentId - идентификатор нового родителя, может быть null
     * @param {ID=} data.dropSourceId - опциональный идентификатор для установки нового индекса в списке
     */
    move({ newParentId: t, dropSourceId: e }) {
      this.moveSource({ newParentId: t, sourceIds: this.selected, dropSourceId: e });
    },
    /**
     * Объединение источников с созданием новой директории
     * @param {Object} data - объект события
     * @param {ID} data.dropSourceId - идентификатор источника-приемника
     */
    merge(t) {
      this.selected.includes(t.dropSourceId) || this.select({ id: t.dropSourceId, ctrlPressed: !0 });
      const e = this.$store.getters.getSourceById(
        t.dropSourceId
      ).parent_id, n = t.dropSourceId;
      this.createDirectory({ parentId: e, dropId: n }), this.$emit("createDirectory");
    },
    /**
     * Простое перемещение по индексу в списке
     * @param {Object} data - объект события
     * @param {ID} data.dragSourceId - идентификатор перетаскиваемого источника
     * @param {ID} data.dropSourceId - идентификатор источника-приемника
     */
    moveToIndex(t) {
      this.moveSourceToIndex(t);
    },
    /**
     * Обработчик дропа на родительскую область (дроп в корень)
     */
    onDrop() {
      this.moveSource({ newParentId: null, sourceIds: this.selected });
    },
    async fetchData(t = !1) {
      this.loading = !0;
      const e = this.offset;
      let n = this.limit, r = {
        offset: e,
        limit: n
      };
      this.flowId && (r.check_in_flow_id = this.flowId), this.query && (r.search = this.query);
      let s;
      t ? s = await this.replaceSources(r) : s = await this.getSources(r), s && (this.loaded = s.length === 0 || s.length < this.limit, this.offset = this.offset + s.length, !this.selected.length && this.useSelection && s[0] && (this.select({ id: s[0].id, ctrlPressed: !1 }), this.$refs.entriesList.scrollToTop()), this.loading = !1, this.$refs.entriesList && this.$refs.entriesList.forceUpdate());
    },
    pick(t) {
      this.$emit("pick", t);
    },
    loadMore() {
      this.loaded || this.fetchData();
    },
    handleSearch(t) {
      this.query = t || "", this.loaded = !1, this.offset = 0, this.fetchData(!0);
    },
    scrollToItem(t) {
      const e = this.list.indexOf(t.id);
      this.$refs.entriesList && this.$refs.entriesList.scrollToItem(e);
    }
  }
};
var Qyt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "sources-list" } }, [n("SearchField", { ref: "searchField", attrs: { placeholder: "Поиск по названию источника", "data-test-selector": "sources-list-search-field" }, on: { input: function(r) {
    return e.handleSearch(r);
  }, focus: function(r) {
    e.searchFieldFocused = !0;
  }, blur: function(r) {
    e.searchFieldFocused = !1;
  } } }), !e.items || !e.items.length ? n("PbEmpty", { attrs: { text: "Нет источников" } }) : n("Drop", { class: [e.$style.entries, "drop"], on: { drop: e.onDrop } }, [n("PbDynamicList", { ref: "entriesList", attrs: { items: e.items, sizeDeps: e.sizeDeps, minItemHeight: 25, showLoader: e.loading, enableKeyboard: !1 }, on: { reachedEnd: e.loadMore }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, index: s }) {
    return n("SourcesListItem", { attrs: { mode: e.mode, index: s, item: r, pickedSources: e.pickedSources, "data-test-selector": "sources-list-item", "data-test-attrs": `item-id__${r.id}`, "data-test-id": r.id }, on: { placeholderEnter: function(i) {
      e.dragOverId = i;
    }, placeholderLeave: function(i) {
      e.dragOverId = null;
    }, select: function(i) {
      return e.select(i);
    }, toggle: function(i) {
      return e.toggleItem(i);
    }, move: function(i) {
      return e.move(i);
    }, merge: function(i) {
      return e.merge(i);
    }, pick: function(i) {
      return e.pick(i);
    }, moveToIndex: function(i) {
      return e.moveToIndex(i);
    } } });
  } }]) })], 1)], 1);
}, ebt = [];
const dA = {
  $style: Jyt
};
function tbt(t) {
  for (var e in dA)
    this[e] = dA[e];
}
var nbt = /* @__PURE__ */ B(
  qyt,
  Qyt,
  ebt,
  !1,
  tbt,
  null
);
const Wj = nbt.exports, rbt = "_root_bbacg_1", sbt = "_flow_bbacg_5", ibt = "_wrapper_bbacg_12", obt = "_editor_bbacg_18", abt = "_sources_bbacg_23", lbt = "_footer_bbacg_29", cbt = "_error_bbacg_36", ubt = {
  root: rbt,
  flow: sbt,
  wrapper: ibt,
  editor: obt,
  sources: abt,
  footer: lbt,
  error: cbt
}, fA = () => ({
  id: null,
  is_public: !0,
  is_my: !0,
  name: "",
  color: "#333333",
  sources: []
}), dbt = {
  name: "TheFlow",
  components: {
    FlowEditor: lyt,
    FlowActions: vyt,
    SourcesList: Wj
  },
  data() {
    return {
      loading: !1,
      flow: {
        sources: []
      },
      offset: 0,
      limit: 100,
      formErrors: {
        name: [],
        sources: [],
        color: [],
        is_public: []
      },
      errors: [],
      sourcesLoaded: !1,
      storedSources: []
    };
  },
  computed: {
    ...pe(["getFlowSources"]),
    ...st({
      existedFlow: (t) => t.flows.items[(void 0).$route.params.id]
    }),
    lastError() {
      return this.errors.length ? this.errors[this.errors.length - 1].title : null;
    },
    sources() {
      return this.getFlowSources(this.flow.id);
    }
  },
  watch: {
    "$route.name": function(t, e) {
      t !== e && t === "flowCreate" && (this.flow = fA(), this.storedSources = [], this.errors = []);
    },
    "flow.name": function(t, e) {
      t !== e && (this.formErrors.name = []);
    },
    "flow.sources": function(t, e) {
      (t == null ? void 0 : t.length) !== (e == null ? void 0 : e.length) && (this.formErrors.id = []);
    }
  },
  mounted() {
    this.$route.params.id ? this.fetchData(this.$route.params.id) : (this.flow = fA(), this.sourcesLoaded = !0);
  },
  methods: {
    ...ge(["getFlow", "sourcesSetPicked", "fetchFlowSources"]),
    async fetchData(t) {
      if (this.loading) return;
      this.loading = !0;
      const e = await this.$store.dispatch("getFlow", t);
      if (e.errors)
        this.errors = e.errors;
      else {
        const n = { ...e };
        n.color = "#" + n.color, this.flow = n, await this.fetchSources(n);
      }
      this.loading = !1;
    },
    loadMoreSources() {
      this.loading || this.fetchSources(this.flow);
    },
    async fetchSources(t) {
      if (!t.id || this.sourcesLoaded) return;
      const e = await this.fetchFlowSources({
        flowId: t.id,
        offset: this.offset,
        limit: this.limit
      });
      e && (this.storedSources = [...this.storedSources, ...e], this.sourcesLoaded = e.length === 0, this.makeFlowSources(this.storedSources), this.offset = this.offset + e.length, this.loading = !1);
    },
    pick(t) {
      const e = [...this.flow.sources], n = [...this.storedSources], r = Math.max(
        ...[...n, ...e].map(({ source: s }) => s._index || 0)
      );
      e.map(({ source: s }) => s.id).indexOf(t.id) === -1 ? (t._index = r + 1, this.flow.id ? e.unshift({ source: t }) : e.push({ source: t }), this.flow.sources = Gf(e, "source.id"), this.sourcesSetPicked({ source: t, value: !0 })) : this.unpick(t);
    },
    unpick(t) {
      this.sourcesSetPicked({ source: t, value: !1 }), this.flow.sources = this.flow.sources.filter(
        ({ source: e }) => e.id !== t.id
      );
    },
    async save() {
      if (!this.flow.sources.length)
        return U.set(this.formErrors, "sources", [{ title: "Добавьте источники" }]), { errors: { title: "Добавьте источники" } };
      const t = await this.$store.dispatch("saveFlow", {
        flow: this.flow,
        storedSources: this.storedSources
      });
      return t.errors || (this.$router.push({ name: t.is_public ? "flowsPublic" : "flowsMy" }).catch(() => null), this.$store.dispatch("addMessage", {
        type: "success",
        text: "Поток сохранён"
      })), t.errors && t.errors.length && (this.formErrors = {
        ...this.formErrors,
        ...Lj(t.errors)
      }), t;
    },
    async remove() {
      const t = this.flow.is_public ? "flowsPublic" : "flowsMy";
      await this.$store.dispatch("deleteFlow", this.flow.id), this.$store.dispatch("addMessage", {
        type: "success",
        text: "Поток удалён"
      }), this.$router.push({ name: t }).catch(() => null);
    },
    async addToWorkspace() {
      const t = await this.save();
      t.errors || (this.$store.dispatch("panels/addPanel", {
        panel: { type: "flow", dataId: t.id },
        goToPanel: !1
      }), this.$store.dispatch("addMessage", {
        type: "success",
        text: "Поток добавлен на рабочую область"
      }));
    },
    makeFlowSources(t) {
      t = t || this.sources, this.$set(
        this.flow,
        "sources",
        t.map((e, n) => (e.source._index = n, e))
      );
    }
  }
};
var fbt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: [e.$style.root, "flow"], attrs: { "data-test-selector": "manager-flow-container" } }, [n("div", { class: e.$style.flow }, [e.lastError ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "manager-flow-error" } }, [n("h3", [e._v(e._s(e.lastError))])]) : n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.editor }, [n("FlowEditor", { attrs: { flow: e.flow, loaded: e.sourcesLoaded, errors: e.formErrors }, on: { "update:flow": function(r) {
    e.flow = r;
  }, unpickSource: e.unpick, "update:errors": function(r) {
    e.formErrors = r;
  }, loadMore: e.loadMoreSources } })], 1), n("div", { class: e.$style.sources }, [Object.keys(this.flow).length ? n("SourcesList", { attrs: { mode: "flows", pickedSources: e.flow.sources, flowId: e.flow.id, useSelection: !1 }, on: { pick: e.pick } }) : e._e()], 1)]), e.lastError ? e._e() : n("div", { class: e.$style.footer }, [n("FlowActions", { attrs: { flow: e.flow }, on: { save: e.save, remove: e.remove, addToWorkspace: e.addToWorkspace } })], 1)])]);
}, pbt = [];
const pA = {
  $style: ubt
};
function hbt(t) {
  for (var e in pA)
    this[e] = pA[e];
}
var mbt = /* @__PURE__ */ B(
  dbt,
  fbt,
  pbt,
  !1,
  hbt,
  null
);
const hA = mbt.exports, vbt = {
  name: "TheSettings",
  components: {
    Toolbar: xo,
    LinkButton: XI,
    BigModal: U8
  },
  computed: {
    ...pe("panels", ["focusedPanel"])
  },
  mounted() {
    this.modalSet(!0);
  },
  beforeDestroy() {
    this.modalSet(!1);
  },
  methods: {
    ...ge("panels", ["setPanelFocused"]),
    ...ge({ modalSet: "setModal" }),
    close() {
      this.modalSet(!1), this.focusedPanel ? this.setPanelFocused(this.focusedPanel.id) : this.setPanelFocused(0);
    }
  }
};
var gbt = function() {
  var e = this, n = e._self._c;
  return n("BigModal", { attrs: { title: "Настройки", "data-test-selector": "settings-modal" }, on: { close: e.close }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [n("div", { staticClass: "modal-content modal-content__settings", attrs: { "data-test-selector": "settings-container" } }, [n("Toolbar", { staticClass: "settings-toolbar" }, [n("LinkButton", { attrs: { to: { name: "editorSettings" }, "data-test-selector": "settings-button-text-editor" } }, [e._v(" Текстовый редактор ")]), n("LinkButton", { attrs: { to: { name: "notificationsSettings" }, "data-test-selector": "settings-button-notifications" } }, [e._v(" Уведомления ")]), n("LinkButton", { attrs: { to: { name: "panelsSettings" }, "data-test-selector": "settings-button-panels" } }, [e._v(" Выпущено ")])], 1), n("keep-alive", [n("router-view", { attrs: { name: "settings" } })], 1)], 1)];
  }, proxy: !0 }]) });
}, ybt = [], bbt = /* @__PURE__ */ B(
  vbt,
  gbt,
  ybt,
  !1,
  null,
  null
);
const _bt = bbt.exports, wbt = "_root_vtcy3_1", Sbt = "_root_disabled_vtcy3_15", Ibt = "_root_increase_vtcy3_22", Ebt = "_root_decrease_vtcy3_25", xbt = "_label_vtcy3_33", Cbt = "_symbol_vtcy3_37", Tbt = {
  root: wbt,
  root_disabled: Sbt,
  root_increase: Ibt,
  root_decrease: Ebt,
  label: xbt,
  symbol: Cbt
}, Pbt = {
  name: "PbTextSizeButton",
  props: {
    symbol: {
      type: String,
      default: "+",
      validator: (t) => t === "+" || t === "-"
    },
    color: {
      type: String,
      default: "#000000"
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    style() {
      return this.enabled ? {
        color: this.color,
        borderColor: this.color
      } : {};
    }
  }
};
var kbt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: {
    [e.$style.root]: !0,
    [e.$style.root_increase]: e.symbol === "+",
    [e.$style.root_decrease]: e.symbol === "-",
    [e.$style.root_disabled]: !e.enabled
  }, style: e.style, attrs: { ripple: "" }, on: { click: function(r) {
    e.enabled && e.$emit("click");
  } } }, [n("div", { class: e.$style.label }, [e._v("Aa")]), n("div", { class: e.$style.symbol }, [e._v(e._s(e.symbol))])]);
}, Nbt = [];
const mA = {
  $style: Tbt
};
function $bt(t) {
  for (var e in mA)
    this[e] = mA[e];
}
var Dbt = /* @__PURE__ */ B(
  Pbt,
  kbt,
  Nbt,
  !1,
  $bt,
  null
);
const Abt = Dbt.exports, Obt = "_form_1d8nb_1", Mbt = "_formRow_1d8nb_5", Rbt = "_label_1d8nb_10", Lbt = "_formRow_heading_1d8nb_22", Fbt = "_formRow_fontSize_1d8nb_26", Bbt = "_colLeft_1d8nb_30", jbt = "_colRight_1d8nb_33", Wbt = "_textSizeWidget_1d8nb_37", Hbt = "_formRow_lineHeight_1d8nb_42", Vbt = "_active_1d8nb_56", zbt = "_formRow_noDelimiter_1d8nb_59", Ubt = "_switchButton_1d8nb_62", Gbt = "_switchButton_active_1d8nb_74", Ybt = "_formRow_dateline_1d8nb_79", Zbt = "_formRow_editorWidth_1d8nb_87", Xbt = "_widthLabel_1d8nb_91", Kbt = "_colorScheme_1d8nb_95", Jbt = "_colorSchemeButton_1d8nb_104", qbt = "_colorSchemeButton_selected_1d8nb_116", Qbt = "_colorSchemeMark_1d8nb_120", e_t = {
  form: Obt,
  formRow: Mbt,
  label: Rbt,
  formRow_heading: Lbt,
  formRow_fontSize: Fbt,
  colLeft: Bbt,
  colRight: jbt,
  textSizeWidget: Wbt,
  formRow_lineHeight: Hbt,
  active: Vbt,
  formRow_noDelimiter: zbt,
  switchButton: Ubt,
  switchButton_active: Gbt,
  formRow_dateline: Ybt,
  formRow_editorWidth: Zbt,
  widthLabel: Xbt,
  colorScheme: Kbt,
  colorSchemeButton: Jbt,
  colorSchemeButton_selected: qbt,
  colorSchemeMark: Qbt
}, t_t = {
  name: "EditorSettingsForm",
  components: {
    PbButton: nt,
    PbButtonSwitcher: rl,
    PbCheckmark: OL,
    PbSizeToggle: K4,
    PbTextField: vg,
    TextSizeButton: Abt,
    PbCheckboxLabeled: qa
  },
  inject: ["getColorScheme"],
  props: {
    schemes: {
      type: Array,
      default: () => []
    },
    fonts: {
      type: Array,
      default: () => []
    },
    sizes: {
      type: Array,
      default: () => []
    },
    lineHeights: {
      type: Array,
      default: () => []
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    newsTypes: {
      type: Object,
      default: () => ({})
    },
    defaultNewsType: Number,
    dateline: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    currentScheme: {
      get() {
        return this.schemes.find(({ name: t }) => t === this.settings.colorScheme) || this.getColorScheme() || {};
      },
      set(t) {
        const e = this.schemes.find(({ name: n }) => n === t);
        this.$emit("update:settings", {
          ...this.settings,
          colorScheme: e.name
        });
      }
    },
    currentSettings: {
      get() {
        return this.settings;
      },
      set(t) {
        this.$emit("update:settings", {
          ...this.settings,
          ...t
        });
      }
    },
    defaultNewsTypeValues() {
      return Object.entries(this.newsTypes).map(([t, e]) => ({
        id: Number(t),
        label: e.description,
        icon: "newstype-" + e.name.toLowerCase()
      }));
    },
    defaultWidthLabel() {
      return this.settings.defaultWidthMode === 1 ? "Узкая панель" : this.settings.defaultWidthMode === 2 ? "Широкая панель" : "Полноэкранный режим";
    }
  },
  methods: {
    increaseFont() {
      if (this.settings.fontSize === "" || this.settings.fontSize < 8) {
        this.settings.fontSize = 8;
        return;
      }
      this.settings.fontSize < 32 && this.settings.fontSize++;
    },
    decreaseFont() {
      if (this.settings.fontSize > 32) {
        this.settings.fontSize = 32;
        return;
      }
      this.settings.fontSize > 8 && this.settings.fontSize--;
    },
    selectTheme(t) {
      this.$emit("update:settings", {
        ...this.settings,
        colorScheme: t.name
      });
    },
    toggleDefaultWidth() {
      this.settings.defaultWidthMode = this.settings.defaultWidthMode < 3 ? this.settings.defaultWidthMode + 1 : 1;
    }
  }
};
var n_t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.form, attrs: { "data-test-selector": "settings-editor-form" } }, [n("div", { class: [e.$style.formRow, e.$style.formRow_heading], attrs: { "data-test-selector": "field-text-title" } }, [n("h4", [e._v("Текст")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_font], attrs: { "data-test-selector": "field-font" } }, [n("label", [e._v("Шрифт")]), n("v-select", { attrs: { options: e.fonts, clearable: !1, searchable: !1 }, model: { value: e.settings.fontFamily, callback: function(r) {
    e.$set(e.settings, "fontFamily", r);
  }, expression: "settings.fontFamily" } })], 1), n("div", { class: [e.$style.formRow, e.$style.formRow_fontSize], attrs: { "data-test-selector": "field-font-size" } }, [n("label", [e._v("Размер")]), n("div", [n("div", { class: e.$style.colLeft }, [n("PbTextField", { attrs: { mask: "##", rules: [
    (r) => r > 7 && r < 33 || "Значение должно быть между 8 и 32."
  ] }, model: { value: e.settings.fontSize, callback: function(r) {
    e.$set(e.settings, "fontSize", e._n(r));
  }, expression: "settings.fontSize" } })], 1), n("div", { class: e.$style.colRight }, [n("TextSizeButton", { class: e.$style.textSizeWidget, attrs: { color: "#2B71DD", symbol: "+", enabled: e.settings.fontSize < 32 }, on: { click: e.increaseFont } }), n("TextSizeButton", { class: e.$style.textSizeWidget, attrs: { color: "#2B71DD", symbol: "-", enabled: e.settings.fontSize > 8 }, on: { click: e.decreaseFont } })], 1)])]), n("div", { class: [e.$style.formRow, e.$style.formRow_lineHeight], attrs: { "data-test-selector": "field-line-height" } }, [n("label", [e._v("Междустрочное расстояние")]), n("PbButtonSwitcher", { attrs: { height: 28 }, model: { value: e.settings.lineHeight, callback: function(r) {
    e.$set(e.settings, "lineHeight", r);
  }, expression: "settings.lineHeight" } }, e._l(e.lineHeights, function(r, s) {
    return n("PbButton", { key: r, class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: e.settings.lineHeight === r, "data-test-selector": "line-height-button", "data-test-attrs": `height__${r}` }, on: { click: function(i) {
      e.settings.lineHeight = r;
    } } }, [n("span", { style: { height: 6 + (s + 2) * 3 + "px" } }, [n("i"), n("i"), n("i")])]);
  }), 1)], 1), n("div", { class: [e.$style.formRow, e.$style.formRow_heading], attrs: { "data-test-selector": "settings-editor-fields-scheme-title" } }, [n("h4", [e._v("Цветовая схема")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_colorScheme], attrs: { "data-test-selector": "settings-editor-fields-scheme" } }, [n("div", { class: e.$style.colorScheme }, e._l(e.schemes, function(r) {
    return n("button", { key: r.name, class: {
      [e.$style.colorSchemeButton]: !0,
      [e.$style.colorSchemeButton_selected]: r.name === e.currentScheme.name
    }, style: {
      color: r.controlColor,
      background: r.control,
      borderColor: "#" + r.borderColor
    }, attrs: { name: r.label }, on: { click: function(s) {
      return e.selectTheme(r);
    } } }, [r.name === e.currentScheme.name ? n("PbCheckmark", { class: e.$style.colorSchemeMark, style: { fill: r.borderColor }, attrs: { type: "single" } }) : e._e(), n("span", [e._v(e._s(r.label))])], 1);
  }), 0)]), n("div", { class: [e.$style.formRow, e.$style.formRow_heading], attrs: { "data-test-selector": "field-default-news-type-title" } }, [n("h4", [e._v("Тип новости по умолчанию")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_newsType], attrs: { "data-test-selector": "field-default-news-type" } }, [n("v-select", { attrs: { value: e.defaultNewsTypeValues.find((r) => r.id === e.defaultNewsType), options: e.defaultNewsTypeValues, clearable: !1, searchable: !1, "data-test-selector": "field-default-news-type-selector" }, on: { input: function(r) {
    return e.$emit("newsTypeSet", r.id);
  } }, scopedSlots: e._u([{ key: "selected-option", fn: function({ icon: r, label: s }) {
    return [n("div", { attrs: { "data-test-selector": "field-default-news-type-selected", "data-test-attrs": s } }, [n("icon", { attrs: { name: r } }), e._v(" " + e._s(s) + " ")], 1)];
  } }, { key: "option", fn: function({ icon: r, label: s }) {
    return [n("div", { attrs: { "data-test-selector": "field-default-news-type-item", "data-test-attrs": s } }, [n("icon", { attrs: { name: r } }), e._v(" " + e._s(s) + " ")], 1)];
  } }]) })], 1), n("div", { class: [e.$style.formRow, e.$style.formRow_heading] }, [n("h4", [e._v("Дейтлайн")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_dateline] }, [n("label", { attrs: { for: "datelineCity" } }, [e._v("Город")]), n("div", [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.dateline.city, expression: "dateline.city" }], attrs: { id: "datelineCity", type: "text", "data-test-selector": "dateline-city" }, domProps: { value: e.dateline.city }, on: { input: function(r) {
    r.target.composing || e.$set(e.dateline, "city", r.target.value);
  } } })])]), n("div", { class: [e.$style.formRow, e.$style.formRow_dateline] }, [n("label", { attrs: { for: "datelineAgency" } }, [e._v("Агентство")]), n("div", [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.dateline.agency, expression: "dateline.agency" }], attrs: { id: "datelineAgency", type: "text", "data-test-selector": "dateline-agency" }, domProps: { value: e.dateline.agency }, on: { input: function(r) {
    r.target.composing || e.$set(e.dateline, "agency", r.target.value);
  } } })])]), n("div", { class: [e.$style.formRow, e.$style.formRow_heading], attrs: { "data-test-selector": "field-text-title" } }, [n("h4", [e._v("Полноэкранный режим")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_lineHeight], attrs: { "data-test-selector": "field-line-height" } }, [n("label", { class: e.$style.label }, [e._v("Поля")]), n("PbButtonSwitcher", { attrs: { height: 28 }, model: { value: e.settings.fullscreenNarrowMode, callback: function(r) {
    e.$set(e.settings, "fullscreenNarrowMode", r);
  }, expression: "settings.fullscreenNarrowMode" } }, [n("PbButton", { class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: e.settings.fullscreenNarrowMode === !1, "data-test-selector": "fullscreen-narrow-mode-button", "data-test-attrs": "fullscreen-narrow-mode__false" }, on: { click: function(r) {
    e.settings.fullscreenNarrowMode = !1;
  } } }, [e._v(" Узкие ")]), n("PbButton", { class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: e.settings.fullscreenNarrowMode === !0, "data-test-selector": "fullscreen-narrow-mode-button", "data-test-attrs": "fullscreen-narrow-mode__true" }, on: { click: function(r) {
    e.settings.fullscreenNarrowMode = !0;
  } } }, [e._v(" Широкие ")])], 1)], 1), n("div", { class: [e.$style.formRow, e.$style.formRow_heading], attrs: { "data-test-selector": "field-text-title" } }, [n("h4", [e._v("Ширина редактора по умолчанию")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_editorWidth], attrs: { "data-test-selector": "field-line-height" } }, [n("label", { class: e.$style.label }, [e._v(e._s(e.defaultWidthLabel))]), n("PbSizeToggle", { attrs: { modesCount: 3, size: 26, isMaximized: e.settings.defaultWidthMode === 2, isFullscreen: e.settings.defaultWidthMode === 3 }, on: { click: e.toggleDefaultWidth } })], 1), n("div", { class: e.$style.formRow, attrs: { "data-test-selector": "field-additional-supply" } }, [n("PbCheckboxLabeled", { attrs: { styleLabel: { color: "#000" }, "data-test-selector": "toggle-additional-supply-checkbox", label: "Всегда открывать панель с кодами" }, model: { value: e.settings.alwaysVisibleAdditionalSupply, callback: function(r) {
    e.$set(e.settings, "alwaysVisibleAdditionalSupply", r);
  }, expression: "settings.alwaysVisibleAdditionalSupply" } })], 1)]);
}, r_t = [];
const vA = {
  $style: e_t
};
function s_t(t) {
  for (var e in vA)
    this[e] = vA[e];
}
var i_t = /* @__PURE__ */ B(
  t_t,
  n_t,
  r_t,
  !1,
  s_t,
  null
);
const o_t = i_t.exports, a_t = "_root_142f9_1", l_t = "_panel_142f9_13", c_t = "_formRow_142f9_22", u_t = "_formRow_heading_142f9_27", d_t = "_formRow_preview_142f9_31", f_t = "_newsDraftWrapper_142f9_36", p_t = {
  root: a_t,
  panel: l_t,
  formRow: c_t,
  formRow_heading: u_t,
  formRow_preview: d_t,
  newsDraftWrapper: f_t
}, h_t = {
  authors: [
    {
      is_removable: !1,
      user: { id: 1, name: "" }
    }
  ],
  background: "<p>Содержит общую информацию, необходимую для понимания новости: предыстория события, основные данные о компании или ньюсмейкера.</p>",
  body: "<p>ЛИД состоит максимум из пяти строк. Он должен сообщить без излишних деталей главный смысл сообщения, содержать элемент времени и указывать источник информации. ЦИТАТА - подкрепляет лид. Она исключительно важна, так как большинству клиентов важно не только знать, что сказал ньюсмейкер, но и как именно он это сказал, в каком контексте. КОНТЕКСТ - необходим для понимания ситуации. ДЕТАЛИ - второстепенные, но интересные детали</p>",
  codes: [],
  created_at: "2019-05-29T16:30:16.792077+00:00",
  dateline: "“Москва. 10 января. ИНТЕРФАКС - ”, здесь указывается не место действия, а место откуда передается информация.",
  headline: "Излагает суть новости изъявительным предложением в количестве не более 76 знаков. Заголовок, как правило, должен отвечать на вопрос “Кто и что сделал?”",
  subheadline: "Дополняет заголовок дополнительной информацией",
  id: 1,
  language_id: 0,
  news_id: 1,
  number: 1,
  slugline: "МЕСТО-СУБЪЕКТ-ПОВОД",
  status_id: 8,
  trashline: "Технический элемент текста новости. Используется при публикации расширенных версий",
  type_id: 3,
  user: { id: 1, name: "" }
}, m_t = {
  name: "PbEditorSettingsPreview",
  components: {
    NewsItemPanel: OI,
    NewsItemView: kI,
    ToolbarWrapper: hg,
    PanelActions: E8,
    NewsItemStatus: v6
  },
  inject: ["getColorScheme"],
  provide() {
    return {
      getColorScheme: () => this.currentScheme,
      isEditorPreview: !0,
      toolbarStyles: () => ({
        color: this.currentScheme.theme === "dark" ? "#FFF" : "#000"
      })
    };
  },
  props: {
    settings: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    typeId: Number,
    dateline: {
      type: Object,
      default: () => ({})
    },
    schemes: {
      type: Array,
      default: () => []
    },
    newsTypes: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: Object,
      default: () => ({})
    },
    statusText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      exampleNews: {
        created_at: "2019-05-29T16:30:16.792077+00:00",
        creator: {
          group_ids: [1],
          id: 1
        },
        groups: [],
        id: 1,
        newsbreak: null,
        publisher: null,
        status_modified_at: "2019-05-29T16:30:16.792077+00:00",
        users: [
          {
            type_id: 1,
            is_read: !0,
            user: this.user
          }
        ],
        version: {
          ...h_t,
          authors: [
            {
              is_removable: !1,
              user: this.user
            }
          ],
          user: this.user
        }
      },
      examplePanel: {
        id: 0,
        dataId: 1,
        type: "newsItem",
        settings: {
          widthScaleFactor: 2,
          color: "F5A623",
          dateMode: 0
        }
      },
      types: [
        { id: 1, description: "Молния", name: "FLASH" },
        { id: 2, description: "Экспресс", name: "EXPRESS" },
        { id: 3, description: "Новость", name: "NEWS" }
      ],
      newsLang: { description: "Русский", name: "RU" },
      blocks: ju(),
      blockPresets: Yf()
    };
  },
  computed: {
    newsItem() {
      const t = this.exampleNews;
      return this.typeId && (t.version.type_id = this.typeId), t.version.dateline = this.datelineExample, t;
    },
    datelineExample() {
      const t = this.dateline.city && `${this.dateline.city}. `, e = this.dateline.agency && ` ${this.dateline.agency}`;
      return `“${t}10 января.${e} - ”, здесь указывается не место действия, а место откуда передается информация.`;
    },
    currentScheme() {
      return this.schemes.find(({ name: t }) => t === this.settings.colorScheme) || this.getColorScheme() || {};
    },
    // TODO: повтор src/lib/legacy/src/modules/News/NewsItemPanel/mixins/withColorScheme.js
    // ...но тут более полная версия
    editorStyle() {
      const t = {};
      return this.settings.fontFamily.toLowerCase().indexOf("sans") !== -1 && (t.fontFamily = this.settings.fontFamily + ", PT Sans, Verdana, sans-serif"), this.settings.fontFamily.toLowerCase().indexOf("serif") !== -1 && (t.fontFamily = this.settings.fontFamily + ", Georgia, serif"), t.lineHeight = this.settings.lineHeight / 100 + "em", t.fontSize = this.settings.fontSize, this.settings.fontSize < 8 && (t.fontSize = 8), this.settings.fontSize > 32 && (t.fontSize = 32), t.fontSize = t.fontSize + "px", t.color = "#" + this.currentScheme.color, t.backgroundColor = "#" + this.currentScheme.backgroundColor, t;
    },
    panelStyle() {
      let t = ["6px", "6px", "6px", "6px"];
      return {
        color: this.editorStyle.color,
        backgroundColor: this.editorStyle.backgroundColor,
        borderRadius: t.join(" "),
        overflow: "hidden"
      };
    },
    titleString() {
      return this.formatUsername(this.user.name) + ": " + this.exampleNews.version.headline;
    },
    visibleBlocks() {
      const t = this.blockPresets[this.typeId];
      return this.blocks.filter(
        (e) => t.includes(e.type) && this.newsItem.version[e.type]
      );
    }
  },
  watch: {
    typeId(t, e) {
      t !== e && (this.exampleNews.version.type_id = t);
    }
  }
};
var v_t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: [e.$style.formRow, e.$style.formRow_heading], attrs: { "data-test-selector": "field-preview-title" } }, [n("h4", [e._v("Предпросмотр")])]), n("div", { class: [e.$style.formRow, e.$style.formRow_preview], attrs: { "data-test-selector": "field-preview" } }, [n("NewsItemPanel", { style: { width: "100%" }, attrs: { panel: e.examplePanel, newsItem: e.newsItem, newsItemId: e.exampleNews.id, panelStyle: e.panelStyle }, scopedSlots: e._u([{ key: "newsItemStatus", fn: function() {
    return [n("NewsItemStatus", { staticClass: "news-status", attrs: { newsItemId: e.exampleNews.id, statusText: e.statusText } })];
  }, proxy: !0 }, { key: "newsContent", fn: function() {
    return [n("NewsItemView", { style: e.editorStyle, attrs: { newsItemId: e.exampleNews.id, isBig: !0, blocks: e.blocks, typeId: e.typeId, visibleBlocks: e.visibleBlocks, version: e.exampleNews.version, isRevoked: !1 } })];
  }, proxy: !0 }, { key: "panelToolbar", fn: function() {
    return [n("ToolbarWrapper", { attrs: { position: "right" } }, [n("div", [n("PanelActions", { attrs: { disabled: !0, isEditable: !1, isFullscreen: !1, isMaximized: !1, newsItemId: e.newsItem.id, newsLang: e.newsLang, newsTypes: e.newsTypes, panelId: e.examplePanel.id, publishMode: !1, redoable: !1, typeId: e.typeId, types: e.types, undoable: !1 } })], 1)])];
  }, proxy: !0 }]) })], 1)]);
}, g_t = [];
const gA = {
  $style: p_t
};
function y_t(t) {
  for (var e in gA)
    this[e] = gA[e];
}
var b_t = /* @__PURE__ */ B(
  m_t,
  v_t,
  g_t,
  !1,
  y_t,
  null
);
const __t = b_t.exports, w_t = "_root_ch9ci_1", S_t = {
  root: w_t
}, I_t = {
  name: "EditorSettingsActions",
  components: {
    MainActionButton: fn
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
};
var E_t = function() {
  var e = this, n = e._self._c;
  return n("MainActionButton", { staticClass: "pb-action-button-old", class: e.$style.root, attrs: { disabled: e.disabled, iconName: "button-icon-save", "data-test-selector": "editor-settings-button-save" }, nativeOn: { click: function(r) {
    return e.$emit("save");
  } } }, [e._v(" Сохранить настройки редактора ")]);
}, x_t = [];
const yA = {
  $style: S_t
};
function C_t(t) {
  for (var e in yA)
    this[e] = yA[e];
}
var T_t = /* @__PURE__ */ B(
  I_t,
  E_t,
  x_t,
  !1,
  C_t,
  null
);
const P_t = T_t.exports, k_t = "_root_1ti16_1", N_t = "_footer_1ti16_5", $_t = "_wrapper_1ti16_12", D_t = "_settings_1ti16_22", A_t = "_preview_1ti16_23", O_t = {
  root: k_t,
  footer: N_t,
  wrapper: $_t,
  settings: D_t,
  preview: A_t
}, M_t = {
  name: "TheEditorSettings",
  components: {
    EditorSettings: o_t,
    EditorPreview: __t,
    EditorSettingsActions: P_t
  },
  data() {
    return {
      settings: {},
      schemes: P0,
      lineHeights: Rie,
      fonts: Mie,
      defaultNewsType: 3,
      dateline: {
        city: "",
        agency: ""
      }
    };
  },
  computed: {
    ...st({
      profileSettings: (t) => t.userProfile.newsEditor,
      user: (t) => ({ id: t.auth.userId, name: t.userProfile.name })
    }),
    ...pe("references", ["newsTypes", "newsStatusesByName"]),
    ...pe("userProfile", [
      "getDefaultNewsTypeId",
      "getDefaultDateline"
    ]),
    status() {
      return this.newsStatusesByName.ON_EDIT;
    },
    statusText() {
      return `${this.status.description}: ${this.formatUsername(
        this.user.name
      )}`;
    },
    valid() {
      return this.settings.fontSize > 7 && this.settings.fontSize <= 32;
    }
  },
  created() {
    this.settings = { ...this.profileSettings }, this.getDefaultNewsTypeId && (this.defaultNewsType = this.getDefaultNewsTypeId), this.dateline = { ...this.getDefaultDateline };
  },
  methods: {
    ...ge("panels", ["setPanelFocused"]),
    ...ge({ modalSet: "setModal" }),
    ...ge("userProfile", ["setProfileEditorSettings"]),
    save() {
      (this.settings.fontSize === "" || this.settings.fontSize < 8) && (this.settings.fontSize = 8), this.settings.fontSize > 32 && (this.settings.fontSize = 32), this.settings.fontSize = parseInt(this.settings.fontSize, 10), this.setProfileEditorSettings({
        editorSettings: this.settings,
        default_news_type_id: this.defaultNewsType,
        default_dateline_agency: this.dateline.agency,
        default_dateline_city: this.dateline.city
      }), this.$store.dispatch("addMessage", {
        type: "success",
        text: "Настройки редактора успешно сохранены"
      });
    }
  }
};
var R_t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.settings }, [n("EditorSettings", { attrs: { fonts: e.fonts, schemes: e.schemes, lineHeights: e.lineHeights, settings: e.settings, dateline: e.dateline, newsTypes: e.newsTypes, defaultNewsType: e.defaultNewsType }, on: { "update:settings": function(r) {
    e.settings = r;
  }, "update:dateline": function(r) {
    e.dateline = r;
  }, newsTypeSet: function(r) {
    e.defaultNewsType = r;
  } } })], 1), n("div", { class: e.$style.preview }, [n("EditorPreview", { attrs: { settings: e.settings, user: e.user, typeId: e.defaultNewsType, dateline: e.dateline, newsTypes: e.newsTypes, schemes: e.schemes, status: e.status, statusText: e.statusText } })], 1)]), n("div", { class: e.$style.footer }, [n("EditorSettingsActions", { attrs: { disabled: !e.valid }, on: { save: e.save } })], 1)]);
}, L_t = [];
const bA = {
  $style: O_t
};
function F_t(t) {
  for (var e in bA)
    this[e] = bA[e];
}
var B_t = /* @__PURE__ */ B(
  M_t,
  R_t,
  L_t,
  !1,
  F_t,
  null
);
const j_t = B_t.exports, W_t = {
  name: "TheSources",
  components: {
    Toolbar: xo,
    LinkButton: XI
  }
};
var H_t = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "modal-content", attrs: { "data-test-selector": "manager-sources-container" } }, [n("Toolbar", [n("LinkButton", { attrs: { to: { name: "sourcesManager" }, exact: !0, "data-test-selector": "manager-sources-button-all" } }, [e._v(" Все ")]), n("LinkButton", { attrs: { to: { name: "sourceCreate" }, "data-test-selector": "manager-sources-button-create" } }, [e._v(" Создание ")])], 1), n("router-view", { attrs: { name: "sources" } })], 1);
}, V_t = [], z_t = /* @__PURE__ */ B(
  W_t,
  H_t,
  V_t,
  !1,
  null,
  null
);
const U_t = z_t.exports, G_t = "_root_n6o8o_1", Y_t = "_header_n6o8o_8", Z_t = "_content_n6o8o_23", X_t = "_row_n6o8o_30", K_t = "_label_n6o8o_36", J_t = "_field_n6o8o_42", q_t = "_url_n6o8o_47", Q_t = "_webblocks_n6o8o_51", e0t = "_webblocksRow_n6o8o_59", t0t = "_excluded_n6o8o_62", n0t = "_webblocksCol_n6o8o_66", r0t = {
  root: G_t,
  header: Y_t,
  content: Z_t,
  row: X_t,
  label: K_t,
  field: J_t,
  url: q_t,
  webblocks: Q_t,
  webblocksRow: e0t,
  excluded: t0t,
  webblocksCol: n0t
}, s0t = {
  name: "sourceInfo",
  data() {
    return {
      sourceInfoTab: 1
    };
  },
  computed: {
    source() {
      const t = this.$store.state.sources.selected[0];
      return this.$store.getters.getSourceById(t) || {};
    },
    webblockType() {
      let t;
      if (this.source) {
        const e = this.$store.state.references.Source ? this.$store.state.references.Source.Type[this.source.type_id] : {};
        if (t = e ? e.description : "", t)
          return t.toUpperCase();
      }
      return "";
    },
    intervalFormatted() {
      return xJ(this.source.interval);
    },
    sourcesCount() {
      return Object.keys(this.$store.state.sources.items).filter((t) => {
        const e = this.$store.state.sources.items[t];
        return e.parent_id === this.source.id && e.type_id !== 0;
      }).length;
    },
    sourcesCountFormatted() {
      return this.sourcesCount + su(this.sourcesCount, [" источник", " источника", " источников"]);
    },
    dirCount() {
      return Object.keys(this.$store.state.sources.items).filter((t) => {
        const e = this.$store.state.sources.items[t];
        return e.parent_id === this.source.id && e.type_id === 0;
      }).length;
    },
    dirCountFormatted() {
      return this.dirCount + su(this.dirCount, [" директория", " директории", " директорий"]);
    },
    modifiedFormatted() {
      return on(Tr(this.source.modified_at), "d MMMM yyyy", {
        locale: xn
      });
    }
  }
};
var i0t = function() {
  var e = this, n = e._self._c;
  return e.source && e.source.id ? n("div", { class: e.$style.root }, [n("div", { class: e.$style.header, attrs: { "data-test-selector": "source-name" } }, [n("h2", [e._v(e._s(e.source.name))])]), e.source.type_id !== 0 ? n("div", { class: e.$style.content }, [n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-type" } }, [n("div", { class: e.$style.label }, [e._v("Тип")]), n("div", { class: e.$style.field }, [e._v(" " + e._s(e.webblockType) + " "), e.source.is_dynamic ? n("span", [e._v("(динамический контент)")]) : e._e()])]), e.source.url ? n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-url" } }, [n("div", { class: e.$style.label }, [e._v("URL")]), n("div", { class: e.$style.field }, [n("a", { class: e.$style.url, attrs: { href: e.source.url, target: "_blank" } }, [e._v(e._s(e.source.url))])])]) : e._e(), n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-intervals" } }, [n("div", { class: e.$style.label }, [e._v("Обновляется")]), n("div", { class: e.$style.field }, [e._v("Каждые " + e._s(e.intervalFormatted))])]), e.source.web_blocks && e.source.web_blocks.length ? n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-webblocks" } }, [n("div", { class: e.$style.label }, [e._v("Структура")]), n("div", { class: e.$style.field }, [n("table", { class: e.$style.webblocks }, e._l(e.source.web_blocks, function(r) {
    return n("tr", { key: r.name, class: {
      [e.$style.webblocksRow]: !0,
      [e.$style.webblocksRow_excluded]: r.is_excluded
    } }, [n("td", { class: e.$style.webblocksCol }, [n("small", [e._v("Название")]), n("span", [e._v(e._s(r.name && r.name.length ? r.name : "Без названия"))])]), n("td", { class: e.$style.webblocksCol }, [n("small", [e._v("XPath")]), n("span", { attrs: { title: r.xpath } }, [e._v(e._s(r.xpath))])])]);
  }), 0)])]) : e._e()]) : n("div", { class: e.$style.content }, [e.sourcesCount ? n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-dir-source-count" } }, [n("div", { class: e.$style.label }, [e._v(e._s(e.sourcesCountFormatted))])]) : e._e(), e.dirCount ? n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-dir-dir-count" } }, [n("div", { class: e.$style.label }, [e._v(e._s(e.dirCountFormatted))])]) : e._e(), n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-dir-modified" } }, [n("div", { class: e.$style.label }, [e._v("Изменена " + e._s(e.modifiedFormatted))])])])]) : e._e();
}, o0t = [];
const _A = {
  $style: r0t
};
function a0t(t) {
  for (var e in _A)
    this[e] = _A[e];
}
var l0t = /* @__PURE__ */ B(
  s0t,
  i0t,
  o0t,
  !1,
  a0t,
  null
);
const c0t = l0t.exports, u0t = "_root_1mexr_1", d0t = "_header_1mexr_8", f0t = "_content_1mexr_23", p0t = "_contentWrapper_1mexr_30", h0t = "_errors_1mexr_37", m0t = "_showMore_1mexr_41", v0t = "_wrapper_1mexr_52", g0t = "_list_1mexr_57", y0t = "_entry_1mexr_63", b0t = "_entryHeader_1mexr_82", _0t = "_entryDate_1mexr_90", w0t = "_entryDesc_1mexr_95", S0t = {
  root: u0t,
  header: d0t,
  content: f0t,
  contentWrapper: p0t,
  errors: h0t,
  showMore: m0t,
  wrapper: v0t,
  list: g0t,
  entry: y0t,
  entryHeader: b0t,
  entryDate: _0t,
  entryDesc: w0t
}, I0t = {
  name: "SourceLogs",
  components: {
    PbButton: nt,
    PbDynamicList: il,
    DateWidget: Hr,
    PbEmpty: tl
  },
  data() {
    return {
      loaded: !1,
      loading: !1,
      cursor: null,
      limit: 100,
      isExpanded: !1
    };
  },
  computed: {
    errors() {
      return this.$store.state.sources.errors[this.source.id] || [];
    },
    logs() {
      return this.$store.state.sources.logs[this.source.id] || [];
    },
    source() {
      const t = this.$store.state.sources.selected[0];
      return this.$store.getters.getSourceById(t) || {};
    },
    logCode() {
      return (t) => this.$store.state.references.SourceLog.Type[t];
    },
    sizeDeps() {
      return () => [];
    }
  },
  watch: {
    source: function(t, e) {
      t && t.id !== e.id && (this.cursor = null, this.isExpanded = !1, this.$store.dispatch("replaceSourceErrors", this.source.id));
    },
    isExpanded: function(t) {
      t && this.fetchData(!0);
    }
  },
  mounted() {
    this.$store.dispatch("replaceSourceErrors", this.source.id);
  },
  methods: {
    loadMore() {
      this.loaded || this.fetchData();
    },
    toggleLogs() {
      this.isExpanded = !this.isExpanded;
    },
    async fetchData(t = !1) {
      if (this.loading) return;
      this.loading = !0;
      let e = {
        cursor: this.cursor,
        limit: this.limit
      }, n;
      t ? n = await this.$store.dispatch("replaceSourceLogs", {
        id: this.source.id,
        params: e
      }) : n = await this.$store.dispatch("getSourceLogs", {
        id: this.source.id,
        params: e
      }), n.data && this.$nextTick(() => {
        this.loaded = n.next_cursor === null, this.cursor = n.next_cursor, this.loading = !1;
      });
    }
  }
};
var E0t = function() {
  var e = this, n = e._self._c;
  return e.source && e.source.id ? n("div", { class: e.$style.root, attrs: { "data-test-selector": "source-logs-container" } }, [n("div", { class: e.$style.header, attrs: { "data-test-selector": "source-name" } }, [n("h2", [e._v(e._s(e.source.name))])]), n("div", { class: e.$style.content }, [n("div", { class: e.$style.contentWrapper }, [e.errors && e.errors.length ? n("div", { class: e.$style.errors, attrs: { "data-test-selector": "source-logs-errors" } }, e._l(e.errors, function(r, s) {
    return n("div", { key: r.id, class: e.$style.entry, attrs: { "data-test-selector": "source-logs-error", "data-test-attrs": `error-index__${s}` } }, [n("div", { class: e.$style.entryHeader }, [n("div", { staticClass: "error", attrs: { "data-test-selector": "source-logs-error-code" } }, [e._v(" " + e._s(e.logCode(r.type_id).description) + " ")]), n("div", { class: e.$style.entryDate }, [n("DateWidget", { attrs: { date: r.created_at, mode: 0, "data-test-selector": "source-logs-error-date" } })], 1)]), n("div", { class: e.$style.entryDesc, attrs: { "data-test-selector": "source-logs-error-description" } }, [e._v(" " + e._s(r.description) + " ")]), r.web_block_xpath ? n("div", { class: e.$style.entryDesc, attrs: { title: r.web_block_xpath, "data-test-selector": "source-logs-error-xpath" } }, [e._v(" XPath: " + e._s(r.web_block_xpath) + " ")]) : e._e()]);
  }), 0) : n("div", { class: e.$style.errors, attrs: { "data-test-selector": "source-logs-errors-empty" } }, [n("div", { class: e.$style.entry }, [n("div", { staticClass: "success" }, [e._v("Ошибок нет")])])]), e.isExpanded ? e._e() : n("PbButton", { class: e.$style.showMore, attrs: { "data-test-selector": "source-logs-errors-button-all-logs" }, on: { click: e.toggleLogs } }, [e._v(" Все логи ")]), n("div", { class: e.$style.wrapper, attrs: { "data-test-selector": "source-logs-errors-all-logs" } }, [e.isExpanded ? n("div", { class: e.$style.list }, [e.loaded && (!e.logs || !e.logs.length) ? n("PbEmpty", { attrs: { text: "Нет логов", "data-test-selector": "source-logs-errors-all-logs-empty" } }) : n("PbDynamicList", { attrs: { items: e.logs, minItemHeight: 96, sizeDeps: e.sizeDeps, showLoader: !e.loaded }, on: { select: () => {
  }, reachedEnd: e.loadMore }, scopedSlots: e._u([{ key: "default", fn: function({ item: r }) {
    return [n("div", { class: e.$style.entry, attrs: { "data-test-selector": "source-logs-errors-all-logs-item", "data-test-attrs": `item-id__${r.id}`, "data-test-id": r.id } }, [r.type_id === 0 ? [n("div", { class: e.$style.entryHeader }, [n("div", { staticClass: "success" }, [e._v(" Ошибки исправлены ")]), n("div", { class: e.$style.entryDate }, [n("DateWidget", { attrs: { date: r.entry.created_at, mode: 0 } })], 1)]), n("div", { class: e.$style.entryDesc }, [e._v(e._s(r.description))])] : [n("div", { class: e.$style.entryHeader }, [n("div", { staticClass: "error" }, [e._v(" Ошибка № " + e._s(r.id) + ": " + e._s(e.logCode(r.type_id).description) + " ")]), n("div", { class: e.$style.entryDate }, [n("DateWidget", { attrs: { date: r.created_at, mode: 0 } })], 1)]), n("div", { class: e.$style.entryDesc }, [e._v(e._s(r.description))]), r.web_block_xpath ? n("div", { class: e.$style.entryDesc }, [e._v(" XPath: " + e._s(r.web_block_xpath) + " ")]) : e._e()]], 2)];
  } }], null, !1, 831476989) })], 1) : e._e()])], 1)])]) : e._e();
}, x0t = [];
const wA = {
  $style: S0t
};
function C0t(t) {
  for (var e in wA)
    this[e] = wA[e];
}
var T0t = /* @__PURE__ */ B(
  I0t,
  E0t,
  x0t,
  !1,
  C0t,
  null
);
const P0t = T0t.exports, k0t = "_wrapper_1w9ra_1", N0t = "_content_1w9ra_5", $0t = "_remove_1w9ra_10", D0t = {
  wrapper: k0t,
  content: N0t,
  remove: $0t
}, A0t = {
  name: "sourcesActions",
  components: {
    Drop: If.Drop,
    MainActionButton: fn,
    DialogConfirm: Gu
  },
  props: {
    isSelectedOfPremoderatedType: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      removeDialog: !1
    };
  },
  computed: {
    ...st({
      sources: (t) => t.sources.items,
      list: (t) => t.sources.mainList,
      selected: (t) => t.sources.selected
    }),
    multipleMode() {
      return this.selected.length > 1;
    },
    countFormatted() {
      const t = this.selected.length;
      return t + su(t, [" источник", " источника", " источников"]);
    }
  },
  methods: {
    ...ge(["deleteSources", "selectSource", "createDirectory"]),
    edit() {
      this.$router.push({
        name: "sourceEdit",
        params: { id: this.selected[0] }
      }).catch(() => null);
    },
    remove() {
      this.deleteSources(this.selected), this.selectSource({ sourceId: this.list[0], multipleMode: !1 });
    },
    makeDirectory() {
      const t = this.sources[this.selected[0]];
      let e = null;
      t && (e = t.parent_id), this.createDirectory({ parentId: e }), this.$emit("createDirectory");
    },
    onDrop() {
      this.removeDialog = !0;
    }
  }
};
var O0t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [Object.keys(e.sources).length ? n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.content }, [e.multipleMode && !e.isSelectedOfPremoderatedType ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-create-button", "data-test-selector": "sources-button-create" }, nativeOn: { click: function(r) {
    return e.makeDirectory.apply(null, arguments);
  } } }, [e._v("Создать папку")]) : e.isSelectedOfPremoderatedType ? e._e() : n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-edit", disabled: e.sources[e.selected[0]] && e.sources[e.selected[0]].type_id === 0, "data-test-selector": "sources-button-edit" }, nativeOn: { click: function(r) {
    return e.edit.apply(null, arguments);
  } } }, [e._v("Изменить источник")]), e.isSelectedOfPremoderatedType ? e._e() : n("drop", { class: [e.$style.remove, "dragarea-remove"], attrs: { "data-trash": "" }, on: { drop: e.onDrop } }, [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-trash", mini: "", title: "Удалить " + (e.multipleMode ? e.countFormatted : "источник"), disabled: !e.selected.length, "data-test-selector": "sources-button-remove" }, nativeOn: { click: function(r) {
    e.removeDialog = !0;
  } } })], 1)], 1)]) : e._e(), n("DialogConfirm", { attrs: { state: e.removeDialog }, on: { "update:state": function(r) {
    e.removeDialog = r;
  }, agree: e.remove }, scopedSlots: e._u([{ key: "question", fn: function() {
    return [n("h3", [n("span", [e._v("Удалить " + e._s(e.multipleMode ? e.countFormatted : "источник") + "?")])])];
  }, proxy: !0 }]) })], 1);
}, M0t = [];
const SA = {
  $style: D0t
};
function R0t(t) {
  for (var e in SA)
    this[e] = SA[e];
}
var L0t = /* @__PURE__ */ B(
  A0t,
  O0t,
  M0t,
  !1,
  R0t,
  null
);
const F0t = L0t.exports, B0t = "_content_1j2tn_1", j0t = "_field_1j2tn_9", W0t = {
  content: B0t,
  field: j0t
}, H0t = {
  name: "SourceDirCreation",
  components: {
    ModalCentered: LI,
    MainActionButton: fn,
    TextField: vg,
    Toolbar: xo
  },
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      name: ""
    };
  },
  created() {
    this.$registerShortcut("Escape", this.bindEsc, { capture: !0 }), this.$registerShortcut("Enter", this.bindEnter, { capture: !0 });
  },
  methods: {
    bindEsc(t) {
      t.stopPropagation(), t.preventDefault(), this.close();
    },
    bindEnter(t) {
      t.stopPropagation(), t.preventDefault(), this.$emit("submit", this.name);
    },
    close() {
      this.$emit("abort");
    }
  }
};
var V0t = function() {
  var e = this, n = e._self._c;
  return n("ModalCentered", { class: e.$style.root, attrs: { title: "Создание директории", maxWidth: 440, minWidth: 290, height: "250px", toolbarFontSize: "1rem", "data-test-selector": "sources-dir-creation" }, on: { close: function(r) {
    return e.$emit("abort");
  } }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [n("div", { class: e.$style.content }, [n("TextField", { ref: "field", class: e.$style.field, attrs: { label: "Имя директории", errors: e.errors, attrs: {
      autofocus: !0,
      "data-test-selector": "sources-dir-creation-fields-name",
      id: "new-directory-name",
      name: "new-directory-name"
    } }, model: { value: e.name, callback: function(r) {
      e.name = r;
    }, expression: "name" } })], 1), n("Toolbar", { class: e.$style.footer, attrs: { fontSize: "1rem", align: "space-between" } }, [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-save", "data-test-selector": "sources-dir-creation-button-create" }, nativeOn: { click: function(r) {
      return e.$emit("submit", e.name);
    } } }, [e._v(" Создать директорию ")]), n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-delete", "data-test-selector": "sources-dir-creation-button-abort" }, nativeOn: { click: function(r) {
      return e.$emit("abort");
    } } }, [e._v(" Отмена ")])], 1)];
  }, proxy: !0 }]) });
}, z0t = [];
const IA = {
  $style: W0t
};
function U0t(t) {
  for (var e in IA)
    this[e] = IA[e];
}
var G0t = /* @__PURE__ */ B(
  H0t,
  V0t,
  z0t,
  !1,
  U0t,
  null
);
const Y0t = G0t.exports, Z0t = "_root_4hhoe_1", X0t = "_content_4hhoe_5", K0t = "_wrapper_4hhoe_13", J0t = "_list_4hhoe_20", q0t = "_multiple_4hhoe_27", Q0t = "_info_4hhoe_34", e1t = "_switcher_4hhoe_38", t1t = "_footer_4hhoe_45", n1t = {
  root: Z0t,
  content: X0t,
  wrapper: K0t,
  list: J0t,
  multiple: q0t,
  info: Q0t,
  switcher: e1t,
  footer: t1t
}, r1t = {
  name: "TheSourcesViewer",
  components: {
    PbButtonSwitcher: rl,
    SourcesList: Wj,
    SourceInfo: c0t,
    SourcesActions: F0t,
    SourceLogs: P0t,
    SourceDirCreation: Y0t
  },
  data() {
    return {
      view: "info",
      dirCreationDialog: !1,
      errors: {
        dirCreation: []
      }
    };
  },
  computed: {
    ...pe("references", ["premoderatedSourceTypes"]),
    ...pe({
      getSourceById: "getSourceById",
      selectedSources: "getSourcesSelected"
    }),
    footerBackground() {
      return this.selectedSources.length > 1 && !this.isSelectedOfPremoderatedType ? "#272727" : "#0069e4";
    },
    isSelectedOfPremoderatedType() {
      return !!nv(this.premoderatedSourceTypes, this.selectedTypes).length;
    },
    selectedTypes() {
      const t = this.selectedSources.length && this.selectedSources.map(this.getSourceById);
      return t ? un(t.map((e) => e.type_id)) : null;
    },
    selectedSourcesText() {
      return `Выбрано ${this.selectedSources.length} ${Pv(
        this.selectedSources.length,
        ["источник", "источникa", "источников"]
      )}`;
    },
    switches() {
      const t = {
        type: "logs",
        label: "Логи",
        value: "logs",
        testSelector: "switcher-button",
        testAttrs: "button__logs"
      };
      return [
        {
          type: "info",
          label: "Инфо",
          value: "info",
          testSelector: "switcher-button",
          testAttrs: "button__info"
        },
        ...this.isSelectedOfPremoderatedType ? [] : [t]
      ];
    }
  },
  methods: {
    ...ge(["submitDirectory", "abortSourceDirProcess"]),
    async submitDir(t) {
      const e = await this.submitDirectory(t);
      e.errors ? this.errors.dirCreation = e.errors.map((n) => n.detail) : (this.$refs.sourcesList && this.$refs.sourcesList.scrollToItem(e), this.dirCreationDialog = !1, this.errors.dirCreation = []);
    },
    createDir() {
      this.dirCreationDialog = !0;
    },
    abort() {
      this.abortSourceDirProcess(), this.errors.dirCreation = [], this.dirCreationDialog = !1;
    }
  }
};
var s1t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.content }, [n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.list }, [n("SourcesList", { ref: "sourcesList", attrs: { mode: "sources" }, on: { createDirectory: e.createDir } })], 1), e.selectedSources.length <= 1 ? n("div", { class: e.$style.info }, [e.selectedTypes && !e.selectedTypes.includes(0) ? n("div", { class: e.$style.switcher }, [n("PbButtonSwitcher", { attrs: { buttons: e.switches }, model: { value: e.view, callback: function(r) {
    e.view = r;
  }, expression: "view" } })], 1) : e._e(), e.view === "info" || e.selectedTypes.includes(0) ? n("SourceInfo") : e.view === "logs" ? n("SourceLogs") : e._e()], 1) : n("div", { class: e.$style.multiple }, [e._v(e._s(e.selectedSourcesText))])]), n("div", { class: e.$style.footer, style: { background: e.footerBackground } }, [n("SourcesActions", { attrs: { isSelectedOfPremoderatedType: e.isSelectedOfPremoderatedType }, on: { createDirectory: e.createDir } })], 1)]), e.dirCreationDialog ? n("SourceDirCreation", { attrs: { errors: e.errors.dirCreation }, on: { abort: e.abort, submit: e.submitDir } }) : e._e()], 1);
}, i1t = [];
const EA = {
  $style: n1t
};
function o1t(t) {
  for (var e in EA)
    this[e] = EA[e];
}
var a1t = /* @__PURE__ */ B(
  r1t,
  s1t,
  i1t,
  !1,
  o1t,
  null
);
const l1t = a1t.exports, c1t = "_root_1nqne_1", u1t = "_title_1nqne_17", d1t = "_list_1nqne_21", f1t = "_item_1nqne_25", p1t = "_item_highlighted_1nqne_34", h1t = "_item_excluded_1nqne_38", m1t = "_item_withError_1nqne_45", v1t = "_block_1nqne_49", g1t = "_icon_1nqne_56", y1t = "_input_1nqne_61", b1t = "_name_1nqne_71", _1t = "_remove_1nqne_76", w1t = "_xpath_1nqne_84", S1t = "_noContent_1nqne_89", I1t = "_root_readonly_1nqne_96", E1t = {
  root: c1t,
  title: u1t,
  list: d1t,
  item: f1t,
  item_highlighted: p1t,
  item_excluded: h1t,
  item_withError: m1t,
  block: v1t,
  icon: g1t,
  input: y1t,
  name: b1t,
  remove: _1t,
  xpath: w1t,
  noContent: S1t,
  root_readonly: I1t
}, x1t = {
  name: "SourceBlockList",
  components: { PbButton: nt },
  props: {
    webBlocks: {
      type: Array,
      default: () => [],
      required: !0
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    blockErrors: {
      type: Object,
      default: () => ({})
    },
    highlightedBlock: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      renaming: null,
      nameBackup: ""
    };
  },
  computed: {
    ...st({
      hackerMode: (t) => t.appData["c00lH@cker"]
    }),
    errorForBlock() {
      return (t) => this.blockErrors[t.xpath];
    }
  },
  created() {
    this.delayedClick = null, this.clickedOnce = !1;
  },
  methods: {
    rename(t) {
      t.name.trim() === "" && (t.name = this.nameBackup), this.renaming = null, this.nameBackup = "";
    },
    undoRename(t) {
      t.name = this.nameBackup, this.renaming = null, this.nameBackup = "";
    },
    showInput(t, e) {
      this.nameBackup = t.name, this.renaming = t, this.$nextTick(() => {
        const n = this.$refs["input-" + e];
        n && n[0] && (n[0].select(), n[0].focus());
      });
    },
    select() {
      this.clickedOnce = !1;
    },
    clickHandler(t, e) {
      if (!this.readonly) {
        if (!this.delayedClick) {
          const n = this;
          this.delayedClick = jf(this.select.bind(n), 200);
        }
        this.clickedOnce ? (this.delayedClick.cancel(), this.clickedOnce = !1) : (this.delayedClick(e), this.clickedOnce = !0);
      }
    },
    doubleClickHandler(t, e, n) {
      this.readonly || (this.clickedOnce = !1, this.showInput(e, n));
    }
  }
};
var C1t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: { [e.$style.root]: !0, [e.$style.root_readonly]: e.readonly } }, [e.title ? n("p", { class: e.$style.title }, [e._v(e._s(e.title))]) : e._e(), e.webBlocks.length ? n("ul", { class: e.$style.list }, e._l(e.webBlocks, function(r, s) {
    return n("li", { key: r.xpath, class: {
      [e.$style.item]: !0,
      [e.$style.item_withError]: !!e.errorForBlock(r),
      [e.$style.item_excluded]: r.is_excluded,
      [e.$style.item_highlighted]: r === e.highlightedBlock
    }, attrs: { "data-test-selector": "source-editor-block", "data-test-attrs": `xpath__${r.xpath}` }, on: { mouseover: function(i) {
      return e.$emit("hover", r);
    }, mouseleave: function(i) {
      return e.$emit("hover", null);
    }, click: function(i) {
      return i.stopPropagation(), i.preventDefault(), e.clickHandler.apply(null, arguments);
    }, dblclick: function(i) {
      return e.doubleClickHandler(i, r, s);
    } } }, [n("div", { class: e.$style.block }, [e.readonly ? e._e() : n("icon", { class: e.$style.icon, attrs: { name: "source-leaf-icon", size: 18 } }), e.renaming === r ? n("input", { directives: [{ name: "model", rawName: "v-model", value: r.name, expression: "block.name" }], ref: "input-" + s, refInFor: !0, class: e.$style.input, attrs: { type: "text" }, domProps: { value: r.name }, on: { keydown: [function(i) {
      return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), i.preventDefault(), e.rename(r));
    }, function(i) {
      return !i.type.indexOf("key") && e._k(i.keyCode, "esc", 27, i.key, ["Esc", "Escape"]) ? null : (i.stopPropagation(), i.preventDefault(), e.undoRename(r));
    }], blur: function(i) {
      return e.rename(r);
    }, focusout: function(i) {
      return e.rename(r);
    }, input: function(i) {
      i.target.composing || e.$set(r, "name", i.target.value);
    } } }) : n("span", { class: e.$style.name, attrs: { title: "XPath: " + r.xpath } }, [e._v(" " + e._s(r.name && r.name !== "" ? r.name : "Без названия") + " ")]), !e.readonly && e.renaming !== r ? n("PbButton", { class: e.$style.remove, attrs: { round: "" }, on: { click: function(i) {
      return e.$emit("removeBlock", r);
    } } }, [n("icon", { attrs: { type: "font", name: "close", size: "16" } })], 1) : e._e()], 1), e.hackerMode && !e.readonly ? n("small", { class: e.$style.xpath }, [e._v(" " + e._s(r.xpath) + " ")]) : e._e(), e.errorForBlock(r) ? n("small", { class: e.$style.error }, [e._v(" " + e._s(e.errorForBlock(r).label) + " ")]) : e._e()]);
  }), 0) : e.readonly ? e._e() : n("div", { class: e.$style.noContent }, [n("h3", [e._v("Блоки не выбраны.")])])]);
}, T1t = [];
const xA = {
  $style: E1t
};
function P1t(t) {
  for (var e in xA)
    this[e] = xA[e];
}
var k1t = /* @__PURE__ */ B(
  x1t,
  C1t,
  T1t,
  !1,
  P1t,
  null
);
const Hj = k1t.exports;
function CA(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%40/gi, "@").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function N1t(t, e) {
  if (typeof e != "object")
    return t;
  let n = "";
  const r = Object.entries(e);
  return r.length && (n += "?", r.forEach(([s, i], o) => {
    i != null && (n += `${CA(s)}=${CA(i)}`, r[o + 1] && (n += "&"));
  })), t + n;
}
const $1t = [
  "inline-block",
  "block",
  "flex",
  "table",
  "table-row",
  "table-cell",
  "grid",
  "list-item",
  "table-header-group",
  "table-footer-group",
  "table-caption",
  "table-row-group"
], D1t = ["div", "p", "article", "table", "a", "time"];
function TA(t, e) {
  try {
    if (D1t.includes(e.tagName.toLowerCase()))
      return !0;
    const n = t.getComputedStyle(e);
    return $1t.includes(n.display) && e.tagName.toLowerCase() !== "body";
  } catch {
    return !1;
  }
}
function uw(t, e) {
  if (e === t) return uw(t, e.body);
  if (!e.parentNode || e === t.body) return e.tagName.toLowerCase();
  let n = 0, r = e.parentNode.childNodes;
  for (let s = 0; s < r.length; s++) {
    let i = r[s];
    if (i === e) {
      const o = e.tagName.toLowerCase(), a = ["thead", "tbody", "tfoot"].includes(o) ? "" : o + "[" + (n + 1) + "]";
      return uw(t, e.parentNode) + "/" + a;
    }
    i.nodeType === 1 && i.tagName === e.tagName && n++;
  }
}
function dw(t, e, n) {
  return e === t || !e.parentNode ? !1 : n.includes(e.parentNode) ? !0 : dw(t, e.parentNode, n);
}
function wd(t) {
  return t.split("/").reduce((e, n, r, s) => n.includes("table") ? s[r + 1] !== void 0 && s[r + 1] !== "" ? e + "table//" : e + n + "/" : n.includes("html") || n === "" ? e + "/" : r !== s.length - 1 && s[r + 1] !== "" ? e + n + "/" : e + n, "");
}
function A1t(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
const O1t = "_root_1pmby_1", M1t = "_topbar_1pmby_21", R1t = "_url_1pmby_40", L1t = "_iframeWrapper_1pmby_55", F1t = "_iframeWrapper_allSiteSelected_1pmby_66", B1t = "_allSiteSelectedFrame_1pmby_66", j1t = "_iframeContainer_1pmby_70", W1t = "_allSiteButton_1pmby_97", H1t = "_allSiteButton_allSiteSelected_1pmby_107", V1t = "_frameLoader_1pmby_111", z1t = "_listWrapper_1pmby_120", U1t = "_iframeError_1pmby_128", G1t = {
  root: O1t,
  topbar: M1t,
  url: R1t,
  iframeWrapper: L1t,
  iframeWrapper_allSiteSelected: F1t,
  allSiteSelectedFrame: B1t,
  iframeContainer: j1t,
  allSiteButton: W1t,
  allSiteButton_allSiteSelected: H1t,
  frameLoader: V1t,
  listWrapper: z1t,
  iframeError: U1t
}, Y1t = {
  name: "SourceBlockChooser",
  components: {
    PbButton: nt,
    SourceBlockList: Hj,
    PbCircularLoader: br
  },
  props: {
    url: {
      type: String,
      required: !0
    },
    userAgent: {
      type: String,
      default: null
    },
    usesProxy: {
      type: Boolean,
      default: !1
    },
    isDynamic: {
      type: Boolean,
      default: !1
    },
    timeout: {
      type: Number,
      default: 30
    },
    dynamicWaitingTime: {
      type: Number,
      default: 5
    },
    webBlocks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      proxyURL: Die,
      highlightedElement: null,
      highlighter: null,
      selectedElements: [],
      selectors: [],
      blockErrors: {},
      // headersLoaded: true,
      frameLoaded: !1,
      errors: [],
      allSiteSelected: !1
    };
  },
  computed: {
    frameURL() {
      return N1t(this.proxyURL, {
        url: this.url.trim(),
        user_agent: this.userAgent,
        uses_proxy: this.usesProxy,
        timeout: this.timeout,
        is_dynamic: this.isDynamic,
        dynamic_waiting_time: this.dynamicWaitingTime
      });
    },
    highlightedBlock() {
      if (!this.highlightedElement || this.highlightedElement.tagName.toLowerCase() === "html")
        return null;
      const t = this.calculateXPath(this.highlightedElement);
      return this.visibleWebBlocks.find(
        (e) => wd(e.xpath) === wd(t)
      );
    },
    visibleWebBlocks() {
      return this.webBlocks.filter(
        ({ _action: t, xpath: e }) => t !== "DELETE" && e !== "/*"
      );
    },
    addedWebBlocks() {
      return this.visibleWebBlocks.filter(({ is_excluded: t }) => !t);
    }
  },
  created() {
    this.iframeWindow = null, this.$registerShortcut("Escape", this.close, {
      enabled: !0,
      capture: !0
    });
  },
  beforeDestroy() {
    this.addedWebBlocks.length || this.toggleAllSite();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const t = this.$refs.frame;
        this.iframeWindow = t.contentWindow;
        const e = t.contentWindow.document, n = t.contentWindow.document.querySelector(
          "html>body>pre"
        );
        if (n) {
          try {
            const s = JSON.parse(n.textContent);
            s && (s.title = "Ошибка получения данных для предварительного просмотра сайта", this.errors.push(s), this.frameLoaded = !0);
          } catch {
            this.errors[0] = {
              title: "Ошибка получения данных для предварительного просмотра сайта",
              detail: n.textContent
            };
          }
          this.frameLoaded = !0;
        }
        e.addEventListener(
          "mouseover",
          this.highlight.bind(this, t.contentWindow)
        ), e.addEventListener(
          "click",
          this.handleClick.bind(this, t.contentWindow)
        ), e.body.onmouseleave = this.clearHighlight, this.highlighter = e.createElement("div"), this.highlighter.id = "ifx-highlighter";
        const r = e.createElement("style");
        r.innerHTML = `
          *::before,
          *::after {
            pointer-events: none !important;
          }
          #ifx-highlighter {
            border-width: 1px;
            border-style: solid;
            pointer-events: none;
            position: fixed;
            z-index: 9999999990;
            transition: top .15s ease .08s,
                        left .15s ease .08s,
                        width .15s ease .1s,
                        height .15s ease .1s;
          }
          *.ifx-selected {
            background: rgba(25, 118, 210, 0.3) !important;
            border-radius: 0 !important;
            position: absolute;
            pointer-events: none;
            z-index: 9999999991;
          }
          *.ifx-excluded {
            background: rgba(255, 82, 82, 0.3) !important;
            position: absolute;
            pointer-events: none;
            z-index: 9999999992;
          }
        `, this.visibleWebBlocks.forEach((s) => {
          const i = this.findElementByXpath(s.xpath);
          i ? s.xpath.includes("@id") ? U.set(this.blockErrors, s.xpath, {
            label: "Блок не найден на странице"
          }) : this.selectElement(i, s.is_excluded) : U.set(this.blockErrors, s.xpath, {
            label: "Блок не найден на странице"
          });
        }), e.body.appendChild(r), e.body.appendChild(this.highlighter), this.frameLoaded = !0, (!this.addedWebBlocks.length || this.addedWebBlocks.find((s) => s.xpath === "/*")) && this.toggleAllSite();
      });
    },
    addInitialBlocks() {
    },
    toggleAllSite(t = !0) {
      this.visibleWebBlocks.forEach((e) => {
        t && (e.xpath === "/*" || e.is_excluded) || this.removeBlock(e);
      }), this.allSiteSelected = t;
    },
    highlightByBlock(t) {
      if (!t) return this.clearHighlight();
      const e = this.findElementByXpath(wd(t.xpath));
      e && this.highlight(this.iframeWindow, { target: e });
    },
    highlight(t, e) {
      const n = e.target;
      if (!(n && n.tagName.toLowerCase() === "html") && TA(t, n)) {
        this.highlightedElement = n;
        const r = n.getBoundingClientRect();
        dw(t.document, n, this.selectedElements) || this.allSiteSelected ? (this.highlighter.style.background = "rgba(255, 82, 82, 0.1)", this.highlighter.style.borderColor = "rgba(255, 82, 82, 0.5)") : (this.highlighter.style.background = "rgba(25, 118, 210, 0.1)", this.highlighter.style.borderColor = "rgba(25, 118, 210, 0.5)"), this.highlighter.style.top = r.top + "px", this.highlighter.style.left = r.left + "px", this.highlighter.style.height = r.height + "px", this.highlighter.style.width = r.width + "px";
      }
    },
    clearHighlight() {
      this.highlightedElement = null, this.highlighter && (this.highlighter.style.top = 0, this.highlighter.style.left = 0, this.highlighter.style.height = 0, this.highlighter.style.width = 0);
    },
    handleClick(t, e) {
      const n = e.target;
      dw(t.document, n, this.selectedElements) || this.allSiteSelected ? this.toggleSelected(t, n, !0) : this.toggleSelected(t, n);
    },
    toggleSelected(t, e, n = !1) {
      this.selectedElements.includes(e) ? this.removeBlockByElement(e) : TA(t, e) && this.addWebBlock(e, n), this.addedWebBlocks.length || this.toggleAllSite(!0);
    },
    findElementByXpath(t) {
      if (!this.iframeWindow) return null;
      let e = null;
      try {
        e = this.iframeWindow.document.evaluate(
          wd(t),
          this.iframeWindow.document,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;
      } catch {
        e = null;
      }
      return e;
    },
    selectElement(t, e = !1) {
      if (!this.iframeWindow || t.tagName.toLowerCase() === "html")
        return !1;
      const n = this.iframeWindow.document.createElement("div");
      n.dataset.xpath = this.calculateXPath(t), e ? n.classList.add("ifx-excluded") : n.classList.add("ifx-selected");
      const r = t.getBoundingClientRect();
      return n.style.top = r.top + this.iframeWindow.pageYOffset + "px", n.style.left = r.left + this.iframeWindow.pageXOffset + "px", n.style.height = r.height + "px", n.style.width = r.width + "px", this.iframeWindow.document.body.appendChild(n), this.selectedElements.push(t), this.selectors.push(n), !0;
    },
    unselectElement(t) {
      const e = this.calculateXPath(t), n = this.selectors.find(
        (r) => r.dataset.xpath === e
      );
      this.selectedElements.splice(this.selectedElements.indexOf(t), 1), this.selectors.splice(this.selectors.indexOf(n), 1), this.iframeWindow.document.body.removeChild(n);
    },
    calculateXPath(t) {
      return wd("//" + uw(this.iframeWindow.document, t));
    },
    generateName() {
      const t = this.visibleWebBlocks.filter(
        (n) => new RegExp(/^Блок \d+( \(автоискл\.\))?$/, "g").test(n.name)
      ).map((n) => n.name);
      if (!t.length) return "Блок 1";
      const e = t.map((n) => parseInt(n.slice(5), 10));
      return `Блок ${Math.max(...e) + 1}`;
    },
    addWebBlock(t, e = !1, n = !1) {
      if (!this.selectElement(t, e)) return;
      const s = {
        name: this.generateName() + (n ? " (автоискл.)" : ""),
        xpath: this.calculateXPath(t),
        is_excluded: e
      };
      this.visibleWebBlocks.map((o) => o.xpath).includes(s.xpath) || (this.excludeContainedChildren(s.xpath), this.$emit("addBlock", s));
    },
    excludeContainedChildren(t) {
      this.visibleWebBlocks.forEach((e) => {
        if (e.is_excluded) return;
        new RegExp("^" + A1t(t)).test(e.xpath) && this.removeBlock(e);
      });
    },
    // addDeepHidden(element) {
    //   const hiddenChildren = getDeepHidden(element)
    //   if (hiddenChildren.length > 0) {
    //     hiddenChildren.forEach(el => {
    //       if (!this.selectedElements.includes(el)) {
    //         this.addWebBlock(el, true, true)
    //       }
    //     })
    //   }
    // },
    removeBlock(t) {
      const e = this.findElementByXpath(t.xpath);
      if (e)
        try {
          this.unselectElement(e);
        } catch (n) {
          console.warn(n);
        }
      this.removeWebBlock(t);
    },
    removeBlockByElement(t) {
      this.unselectElement(t);
      const e = this.calculateXPath(t), n = this.visibleWebBlocks.find(
        (r) => r.xpath === e
      );
      this.removeWebBlock(n);
    },
    removeWebBlock(t) {
      delete this.blockErrors[t.xpath], t && this.$emit("removeBlock", t);
    },
    close() {
      this.$emit("close");
    }
  }
};
var Z1t = function() {
  var e = this, n = e._self._c;
  return n("transition", { attrs: { name: "slide-y-reverse-transition", appear: "" } }, [n("div", { class: e.$style.root, attrs: { "data-test-selector": "source-block-chooser" } }, [n("div", { class: e.$style.topbar }, [n("div", { class: e.$style.url }, [n("input", { attrs: { type: "url", readonly: "" }, domProps: { value: e.url } })]), n("PbButton", { attrs: { round: "" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.close.apply(null, arguments);
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1)], 1), n("div", { class: {
    [e.$style.iframeWrapper]: !0,
    [e.$style.iframeWrapper_allSiteSelected]: e.allSiteSelected
  } }, [e.errors.length ? e._e() : n("div", { class: e.$style.iframeContainer }, [n("div", { class: e.$style.allSiteSelectedFrame }), n("iframe", { ref: "frame", attrs: { src: e.frameURL, sandbox: "allow-same-origin allow-scripts" }, on: { load: e.init } })]), e.errors.length > 0 ? n("div", { class: e.$style.iframeError }, [e._l(e.errors, function(r) {
    return [r.title ? n("h2", { key: r.title }, [e._v(e._s(r.title))]) : e._e(), r.detail ? n("h3", { key: r.detail }, [e._v(e._s(r.detail))]) : e._e()];
  })], 2) : e._e(), e.frameLoaded ? e._e() : n("div", { class: e.$style.frameLoader }, [n("PbCircularLoader", { attrs: { size: 100 } })], 1), e.errors.length ? e._e() : n("div", { class: {
    [e.$style.allSiteButton]: !0,
    [e.$style.allSiteButton_allSiteSelected]: e.allSiteSelected
  }, on: { click: function(r) {
    return e.toggleAllSite(!e.allSiteSelected);
  } } }, [e._v(" " + e._s(e.allSiteSelected ? "Мониторится вся страница. Нажмите, чтобы выключить." : "Мониторить всю страницу") + " ")])]), n("div", { class: e.$style.listWrapper }, [n("SourceBlockList", { attrs: { webBlocks: e.visibleWebBlocks, blockErrors: e.blockErrors, highlightedBlock: e.highlightedBlock }, on: { removeBlock: e.removeBlock, hover: e.highlightByBlock } })], 1)])]);
}, X1t = [];
const PA = {
  $style: G1t
};
function K1t(t) {
  for (var e in PA)
    this[e] = PA[e];
}
var J1t = /* @__PURE__ */ B(
  Y1t,
  Z1t,
  X1t,
  !1,
  K1t,
  null
);
const q1t = J1t.exports, Q1t = "_root_1igz8_1", ewt = "_title_1igz8_6", twt = "_row_1igz8_19", nwt = "_row_refresh_1igz8_25", rwt = "_row_flow_1igz8_25", swt = "_row_ua_1igz8_25", iwt = "_row_timeout_1igz8_25", owt = "_fields_1igz8_28", awt = "_label_1igz8_34", lwt = "_error_1igz8_41", cwt = "_input_1igz8_58", uwt = "_button_1igz8_63", dwt = "_additional_1igz8_74", fwt = "_additionalToggle_1igz8_78", pwt = {
  root: Q1t,
  title: ewt,
  row: twt,
  row_refresh: nwt,
  row_flow: rwt,
  row_ua: swt,
  row_timeout: iwt,
  fields: owt,
  "row_dynamic-waiting": "_row_dynamic-waiting_1igz8_31",
  label: awt,
  error: lwt,
  input: cwt,
  button: uwt,
  additional: dwt,
  additionalToggle: fwt
}, hwt = {
  name: "sourceEditor",
  components: {
    PbButtonSwitcher: rl,
    PbButton: nt,
    PbCheckbox: qa,
    PbIcon: cc,
    PbTextField: vg,
    SourceBlockList: Hj,
    SourceBlockChooser: q1t
  },
  props: {
    source: Object,
    sourceTypes: Array,
    flows: {
      type: Object,
      default: () => {
      }
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chooserShowed: !1,
      intervals: [
        {
          label: "5 секунд",
          value: 5,
          testSelector: "switcher-button",
          testAttrs: "button__5"
        },
        {
          label: "10 секунд",
          value: 10,
          testSelector: "switcher-button",
          testAttrs: "button__10"
        },
        {
          label: "30 секунд",
          value: 30,
          testSelector: "switcher-button",
          testAttrs: "button__30"
        },
        {
          label: "1 минуту",
          value: 60,
          testSelector: "switcher-button",
          testAttrs: "button__60"
        },
        {
          label: "5 минут",
          value: 300,
          testSelector: "switcher-button",
          testAttrs: "button__300"
        },
        {
          label: "12 часов",
          value: 43200,
          testSelector: "switcher-button",
          testAttrs: "button__43200"
        },
        {
          label: "24 часа",
          value: 86400,
          testSelector: "switcher-button",
          testAttrs: "button__86400"
        }
      ]
    };
  },
  computed: {
    visibleWebBlocks() {
      return this.source.web_blocks.filter((t) => t._action !== "DELETE");
    },
    addedWebBlocks() {
      return this.visibleWebBlocks.filter(({ is_excluded: t }) => !t);
    },
    flowsSorted() {
      return Object.values(this.flows).sort((t, e) => {
        const n = t.name.toLowerCase(), r = e.name.toLowerCase();
        return n < r ? -1 : n > r ? 1 : 0;
      });
    },
    chooserEnabled() {
      const t = Object.keys(this.errors).some(
        (e) => this.errors[e].length > 0
      );
      return this.source.url && this.source.url !== "" && !t;
    },
    blocksTitle() {
      if (this.addedWebBlocks.length)
        return null;
      let t = "Мониторится вся страница.";
      return this.visibleWebBlocks.length && (t += " Исключены следующие блоки:"), t;
    }
  },
  methods: {
    // setFinalURL(url) {
    //   this.source.url = url
    // },
    addWebBlock(t) {
      let e = { ...t };
      if (this.source.id) {
        const n = this.source.web_blocks.map(({ _index: r }) => r).pop() || 0;
        e = {
          ...e,
          _index: n + 1,
          _action: "CREATE"
        };
      }
      this.source.web_blocks.push(e);
    },
    removeWebBlock(t) {
      let e = [...this.source.web_blocks];
      t.id ? t._action = "DELETE" : e = e.filter(({ xpath: n }) => n !== t.xpath), this.source.web_blocks = e;
    },
    showBlockChooser() {
      this.chooserShowed = !0;
    },
    blockChooserErrorHandler(t) {
      t && this.$emit("chooserErrors", t), this.chooserShowed = !1;
    }
  }
};
var mwt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root, attrs: { "data-test-selector": "source-editor-container" } }, [n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-editor-fields-name" } }, [n("h2", { class: e.$style.title }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.source.name, expression: "source.name" }], ref: "name", attrs: { type: "text", placeholder: "Введите название источника" }, domProps: { value: e.source.name }, on: { input: function(r) {
    r.target.composing || e.$set(e.source, "name", r.target.value);
  } } })])]), e.errors.name ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "source-editor-fields-name-errors" } }, e._l(e.errors.name, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "source-editor-fields-name-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e(), n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-editor-fields-type" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorType" } }, [e._v("Тип")]), n("span", { class: e.$style.fields }, [n("PbButtonSwitcher", { attrs: { id: "sourceEditorType", buttons: e.sourceTypes }, model: { value: e.source.type_id, callback: function(r) {
    e.$set(e.source, "type_id", r);
  }, expression: "source.type_id" } })], 1)]), n("div", { class: [e.$style.row, e.$style.row_url], attrs: { "data-test-selector": "source-editor-fields-url" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorURL" } }, [e._v("URL")]), n("span", { class: e.$style.fields }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.source.url, expression: "source.url" }], ref: "url", class: e.$style.input, attrs: { id: "sourceEditorURL", type: "url", placeholder: "Введите URL" }, domProps: { value: e.source.url }, on: { input: function(r) {
    r.target.composing || e.$set(e.source, "url", r.target.value);
  } } })])]), e.errors.url ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "source-editor-fields-name-errors" } }, e._l(e.errors.url, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "source-editor-fields-url-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e(), e.source.type_id === 1 ? n("div", { class: [e.$style.row, e.$style.row_dynamic], attrs: { "data-test-selector": "source-editor-fields-dynamic" } }, [n("label", { class: e.$style.label }), n("span", { class: e.$style.fields }, [n("PbCheckbox", { attrs: { label: "Динамический контент", "data-test-selector": "source-editor-fields-dynamic-checkbox" }, model: { value: e.source.is_dynamic, callback: function(r) {
    e.$set(e.source, "is_dynamic", r);
  }, expression: "source.is_dynamic" } })], 1)]) : e._e(), e.errors.is_dynamic ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "source-editor-fields-dynamic-errors" } }, e._l(e.errors.is_dynamic, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "source-editor-fields-dynamic-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e(), e.source.type_id !== 2 ? n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-editor-fields-blocks" } }, [n("label", { class: e.$style.label }, [e._v("Блоки")]), n("span", { class: e.$style.fields }, [n("SourceBlockList", { attrs: { webBlocks: e.visibleWebBlocks, readonly: !0, title: e.blocksTitle } }), n("PbButton", { class: e.$style.button, attrs: { disabled: !e.chooserEnabled, "data-test-selector": "block-chooser-button" }, on: { click: e.showBlockChooser } }, [e._v(" Настроить ")])], 1)]) : e._e(), n("div", { class: [e.$style.row, e.$style.row_refresh], attrs: { "data-test-selector": "source-editor-fields-intervals" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorInterval" } }, [e._v(" Обновлять ")]), n("span", { class: e.$style.fields }, [n("PbButtonSwitcher", { attrs: { id: "sourceEditorInterval", buttons: e.intervals }, model: { value: e.source.interval, callback: function(r) {
    e.$set(e.source, "interval", r);
  }, expression: "source.interval" } })], 1)]), e.source.id ? e._e() : n("div", { class: [e.$style.row, e.$style.row_flow], attrs: { "data-test-selector": "source-editor-fields-flow-chooser" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorFlow" } }, [e._v("Поток")]), n("span", { class: e.$style.fields }, [n("v-select", { attrs: { options: e.flowsSorted, reduce: (r) => r.id, clearable: !1, searchable: !1, id: "sourceEditorFlow", label: "name" }, model: { value: e.source.flow, callback: function(r) {
    e.$set(e.source, "flow", r);
  }, expression: "source.flow" } })], 1)]), e.source.type_id !== 0 ? n("v-collapse-wrapper", { class: e.$style.additional }, [n("div", { directives: [{ name: "collapse-toggle", rawName: "v-collapse-toggle" }], class: e.$style.additionalToggle }, [n("span", [e._v("Специальные настройки")]), n("PbIcon", { attrs: { type: "font", name: "arrow_drop_down" } })], 1), n("div", { directives: [{ name: "collapse-content", rawName: "v-collapse-content" }], class: e.$style.additionalContent }, [n("div", { class: e.$style.row, attrs: { "data-test-selector": "source-editor-fields-proxy" } }, [n("PbCheckbox", { attrs: { label: "Использовать прокси" }, model: { value: e.source.uses_proxy, callback: function(r) {
    e.$set(e.source, "uses_proxy", r);
  }, expression: "source.uses_proxy" } })], 1), n("div", { class: [e.$style.row, e.$style.row_ua], attrs: { "data-test-selector": "source-editor-fields-user-agent" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorUserAgent" } }, [e._v(" User Agent ")]), n("span", { class: e.$style.fields }, [n("PbTextField", { attrs: { attrs: {
    id: "sourceEditorUserAgent",
    maxlength: 255
  }, rules: [
    (r) => r && r.length < 256 || r === null || r === "" || "Максимум 255 символов"
  ] }, model: { value: e.source.user_agent, callback: function(r) {
    e.$set(e.source, "user_agent", r);
  }, expression: "source.user_agent" } }), e.errors.user_agent ? n("div", { class: e.$style.errors, attrs: { "data-test-selector": "source-editor-fields-user-agent-errors" } }, e._l(e.errors.user_agent, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "source-editor-fields-user-agent-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e()], 1)]), n("div", { class: [e.$style.row, e.$style.row_timeout], attrs: { "data-test-selector": "source-editor-fields-timeout" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorTimeout" } }, [e._v(" Таймаут опроса страницы ")]), n("span", { class: e.$style.fields }, [n("PbTextField", { attrs: { postfix: "сек.", width: "145px", attrs: { id: "sourceEditorTimeout" }, mask: "##", rules: [
    (r) => r > 0 && r < 61 || r === null || r === "" || "Укажите таймаут опроса в диапазоне от 1 до 60 сек."
  ] }, model: { value: e.source.timeout, callback: function(r) {
    e.$set(e.source, "timeout", e._n(r));
  }, expression: "source.timeout" } }), e.errors.timeout ? n("div", { class: e.$style.errors, attrs: { "data-test-selector": "source-editor-fields-timeout-errors" } }, e._l(e.errors.timeout, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "source-editor-fields-timeout-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e()], 1)]), e.source.type_id === 1 && e.source.is_dynamic ? n("div", { class: [e.$style.row, e.$style.row_dynamicWaiting], attrs: { "data-test-selector": "source-editor-fields-dynamic-waiting-time" } }, [n("label", { class: e.$style.label, attrs: { for: "sourceEditorWaitingTime" } }, [e._v(" Время ожидания загрузки динамического контента ")]), n("span", { class: e.$style.fields }, [n("PbTextField", { attrs: { postfix: "сек.", width: "145px", attrs: { id: "sourceEditorWaitingTime" }, mask: "##", rules: [
    (r) => r > 0 && r < 16 || r === null || r === "" || "Укажите время ожидания в диапазоне от 1 до 15 сек."
  ] }, model: { value: e.source.dynamic_waiting_time, callback: function(r) {
    e.$set(e.source, "dynamic_waiting_time", e._n(r));
  }, expression: "source.dynamic_waiting_time" } }), e.errors.dynamic_waiting_time ? n("div", { class: e.$style.errors, attrs: { "data-test-selector": "source-editor-fields-dynamic-waiting-time-errors" } }, e._l(e.errors.dynamic_waiting_time, function(r, s) {
    return n("span", { key: s, staticClass: "error-message", attrs: { "data-test-selector": "source-editor-fields-dynamic-waiting-time-error", "data-test-attrs": `error-index__${s}` } }, [e._v(" " + e._s(r.detail || r.title) + " ")]);
  }), 0) : e._e()], 1)]) : e._e()])]) : e._e(), e.chooserShowed ? n("SourceBlockChooser", { attrs: { url: e.source.url, userAgent: e.source.user_agent, usesProxy: e.source.uses_proxy, isDynamic: e.source.is_dynamic, timeout: e.source.timeout, dynamicWaitingTime: e.source.dynamic_waiting_time, webBlocks: e.source.web_blocks }, on: { close: function(r) {
    e.chooserShowed = !1;
  }, errorCaptured: function(r) {
    return e.blockChooserErrorHandler(r);
  }, addBlock: e.addWebBlock, removeBlock: e.removeWebBlock } }) : e._e()], 1);
}, vwt = [];
const kA = {
  $style: pwt
};
function gwt(t) {
  for (var e in kA)
    this[e] = kA[e];
}
var ywt = /* @__PURE__ */ B(
  hwt,
  mwt,
  vwt,
  !1,
  gwt,
  null
);
const bwt = ywt.exports, _wt = "_root_z0iv1_1", wwt = {
  root: _wt
}, Swt = {
  name: "sourceActions",
  components: {
    MainActionButton: fn,
    DialogConfirm: Gu
  },
  props: {
    source: Object
  },
  data() {
    return {
      removeDialog: !1
    };
  },
  methods: {
    save() {
      this.$emit("save");
    },
    remove() {
      this.$emit("remove");
    }
  }
};
var Iwt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-save", "data-test-selector": "source-button-save" }, nativeOn: { click: function(r) {
    return e.save.apply(null, arguments);
  } } }, [e._v(" Сохранить источник ")]), e.$route.name === "sourceEdit" ? n("MainActionButton", { staticClass: "pb-action-button-old", attrs: { iconName: "button-icon-trash", "data-test-selector": "source-button-edit" }, nativeOn: { click: function(r) {
    e.removeDialog = !0;
  } } }, [e._v(" Удалить источник ")]) : e._e(), n("DialogConfirm", { attrs: { state: e.removeDialog }, on: { "update:state": function(r) {
    e.removeDialog = r;
  }, agree: e.remove }, scopedSlots: e._u([{ key: "question", fn: function() {
    return [n("h3", [e._v("Удалить источник?")])];
  }, proxy: !0 }]) })], 1);
}, Ewt = [];
const NA = {
  $style: wwt
};
function xwt(t) {
  for (var e in NA)
    this[e] = NA[e];
}
var Cwt = /* @__PURE__ */ B(
  Swt,
  Iwt,
  Ewt,
  !1,
  xwt,
  null
);
const Twt = Cwt.exports, Pwt = "_root_uihrt_1", kwt = "_wrapper_uihrt_8", Nwt = "_editor_uihrt_14", $wt = "_footer_uihrt_20", Dwt = "_error_uihrt_26", Awt = {
  root: Pwt,
  wrapper: kwt,
  editor: Nwt,
  footer: $wt,
  error: Dwt
}, Ub = () => ({
  id: null,
  name: "",
  interval: 10,
  is_dynamic: !1,
  dynamic_waiting_time: 5,
  timeout: 30,
  type_id: 1,
  url: "",
  flow: null,
  user_agent: null,
  uses_proxy: !1,
  web_blocks: []
}), Owt = {
  name: "TheSource",
  components: {
    SourceEditor: bwt,
    SourceActions: Twt
  },
  data() {
    return {
      loading: !1,
      source: Ub(),
      formErrors: {
        name: [],
        url: [],
        web_blocks: [],
        timeout: [],
        dynamic_waiting_time: [],
        user_agent: []
      },
      errors: []
    };
  },
  computed: {
    ...st({
      sources: (t) => t.sources.items,
      flows: (t) => t.flows.items
    }),
    ...pe("references", ["premoderatedSourceTypes"]),
    existedSource() {
      return this.sources[+this.$route.params.id];
    },
    types() {
      const t = lt(this.$store.state, "references.Source.Type"), e = this.premoderatedSourceTypes;
      return t ? J4(
        Object.keys(t).filter((n) => ![...e, 0].includes(+n)).map((n) => ({
          type: t[n].description.toLowerCase(),
          value: +n,
          label: t[n].description.toUpperCase(),
          testSelector: "switcher-button",
          testAttrs: `button__${t[n].description.toLowerCase()}`
        }))
      ) : [];
    },
    lastError() {
      return this.errors.length ? this.errors[this.errors.length - 1].title : null;
    }
  },
  watch: {
    existedSource: function(t) {
      t && (this.source = Or(t));
    },
    "$route.name": function(t, e) {
      t !== e && t === "sourceCreate" && (this.source = Ub(), this.errors = []);
    },
    "source.name": function(t, e) {
      t !== e && (this.formErrors.name = []);
    },
    "source.url": function(t, e) {
      t !== e && (this.formErrors.url = []);
    },
    "source.timeout": function(t, e) {
      t !== e && (this.formErrors.timeout = []);
    },
    "source.type_id": function(t) {
      this.source.is_dynamic = t === 2 ? null : !1;
    }
  },
  created() {
    this.$route.params.id ? this.fetchData(this.$route.params.id) : (this.source = Ub(), this.fetchFlows());
  },
  methods: {
    ...ge([
      "getSource",
      "getFlows",
      "addMessage",
      "saveSource",
      "selectSource",
      "deleteSources"
    ]),
    async fetchData(t) {
      this.loading = !0;
      const e = await this.getSource(t);
      e.errors && (this.errors = e.errors), this.loading = !1;
    },
    async fetchFlows() {
      await this.getFlows({ offset: 0, limit: 100 });
    },
    async save() {
      const t = await this.saveSource(this.source);
      t.errors || (this.$router.push({ name: "sourcesManager" }).catch(() => null), this.addMessage({ type: "success", text: "Источник сохранён" })), t.errors && this.setFormErrors(t.errors);
    },
    setFormErrors(t) {
      this.formErrors = Lj(t);
    },
    remove() {
      this.deleteSources([this.source.id]).errors || (this.$router.push({ name: "sourcesManager" }), this.selectSource({ source: this.sources[0], multipleMode: !1 }));
    }
  }
};
var Mwt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "modal-content", attrs: { "data-test-selector": "manager-source-container" } }, [n("div", { class: e.$style.root }, [e.lastError ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "manager-source-error" } }, [n("h3", [e._v(e._s(e.lastError))])]) : n("div", { class: e.$style.wrapper }, [n("div", { class: e.$style.editor }, [n("SourceEditor", { attrs: { source: e.source, errors: e.formErrors, sourceTypes: e.types, flows: e.flows }, on: { "update:source": function(r) {
    e.source = r;
  }, chooserErrors: function(r) {
    return e.setFormErrors(r);
  } } })], 1)]), e.lastError ? e._e() : n("div", { class: e.$style.footer }, [n("SourceActions", { attrs: { source: e.source }, on: { save: e.save, remove: e.remove } })], 1)])]);
}, Rwt = [];
const $A = {
  $style: Awt
};
function Lwt(t) {
  for (var e in $A)
    this[e] = $A[e];
}
var Fwt = /* @__PURE__ */ B(
  Owt,
  Mwt,
  Rwt,
  !1,
  Lwt,
  null
);
const DA = Fwt.exports, Bwt = {
  name: "NotificationsSettings",
  components: {
    PbCheckboxLabeled: qa,
    PbCircularLoader: br,
    MainActionButton: fn,
    PbIcon: cc
  },
  setup() {
    const t = Jt("store"), e = {
      email: le(() => t.state.auth.login),
      loaded: le(() => t.state.notifications.loaded),
      loading: le(() => t.state.notifications.loading),
      subscriptions: le(() => t.state.notifications.subscriptions),
      notificationTypes: le(
        () => t.getters["references/notificationTypes"]
      )
    }, n = {
      setNotificationEventsEmail: (...f) => t.dispatch("userProfile/setNotificationEventsEmail", ...f),
      setNotificationEventsPush: (...f) => t.dispatch("userProfile/setNotificationEventsPush", ...f),
      saveNotificationsSettings: (...f) => t.dispatch("notifications/saveNotificationsSettings", ...f),
      addMessage: (...f) => t.dispatch("addMessage", ...f)
    }, r = le(() => {
      const f = Object.keys(e.notificationTypes.value);
      return f.sort((p, h) => p - h), f.map((p) => ({
        ...e.notificationTypes.value[p],
        id: parseInt(p)
      }));
    }), s = [
      { name: "viaEmail", label: "E-mail" },
      // { name: 'viaPush', label: 'Push' },
      { name: "viaGateway", label: "Push" }
    ], i = le(
      () => `Ваш E-mail: <b>${e.email.value}</b>`
    ), o = Xn({
      viaEmail: [],
      viaPush: [],
      viaGateway: []
    }), a = le(
      () => !$a(
        o.viaEmail,
        e.subscriptions.value.viaEmail
      ) || !$a(
        o.viaPush,
        e.subscriptions.value.viaPush
      ) || !$a(
        o.viaGateway,
        e.subscriptions.value.viaGateway
      )
    ), l = async (f, p, h) => {
      if (h === !0) {
        if (!o[f].includes(p)) {
          const m = o[f].concat([p]);
          m.sort((v, y) => v - y), o[f] = m;
        }
      } else
        o[f].includes(p) && o[f].splice(
          o[f].indexOf(p),
          1
        );
    }, c = (f, p) => {
      p ? o[f] = r.value.map(({ id: h }) => h) : o[f] = [];
    }, u = () => {
      o.viaEmail = [...e.subscriptions.value.viaEmail], o.viaPush = [...e.subscriptions.value.viaPush], o.viaGateway = [
        ...e.subscriptions.value.viaGateway
      ];
    }, d = async () => {
      const f = await n.saveNotificationsSettings({
        email: o.viaEmail,
        push: o.viaPush,
        gateway: o.viaGateway
      });
      f.errors ? f.errors.forEach((p) => {
        n.addMessage({
          type: "error",
          text: p.detail
        });
      }) : (n.addMessage({
        type: "success",
        text: "Настройки уведомлений успешно сохранены"
      }), u());
    };
    return Io(() => {
      u();
    }), {
      ...e,
      savingEnabled: a,
      channels: s,
      notifications: r,
      tooltipEmail: i,
      selectedEventTypes: o,
      updateSetting: l,
      updateChannel: c,
      save: d
    };
  }
};
var jwt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "root" }, [n("div", { staticClass: "body" }, [e.loaded ? n("table", [n("thead", [n("tr", [n("th"), e._l(e.channels, function(r) {
    return n("th", { key: r.name }, [n("PbCheckboxLabeled", { staticClass: "option", attrs: { checked: e.selectedEventTypes[r.name].length > 0 && e.selectedEventTypes[r.name].length === e.notifications.length, "data-test-selector": "channel" }, on: { change: function(s) {
      return e.updateChannel(r.name, s);
    } } }), n("span", { staticClass: "description" }, [e._v(e._s(r.label))]), n("PbIcon", { directives: [{ name: "show", rawName: "v-show", value: r.name !== "viaGateway", expression: "channel.name !== 'viaGateway'" }, { name: "tooltip", rawName: "v-tooltip", value: {
      content: r.name === "viaEmail" ? e.tooltipEmail : "",
      html: !0,
      autoHide: !0
    }, expression: `{
                content: channel.name === 'viaEmail' ? tooltipEmail : '',
                html: true,
                autoHide: true
              }` }], staticClass: "tooltip", attrs: { type: "font", name: "info", size: 22 } })], 1);
  })], 2)]), n("tbody", e._l(e.notifications, function(r) {
    return n("tr", { key: r.id }, [n("td", [e._v(e._s(r.description))]), e._l(e.channels, function(s) {
      return n("td", { key: s.name, staticClass: "description", attrs: { "data-test-selector": "notification-description", "data-test-id": r.id } }, [e._v(" " + e._s(r.desc) + " "), n("PbCheckboxLabeled", { attrs: { checked: e.selectedEventTypes[s.name].includes(r.id), "data-test-selector": "via-email-checkbox", "data-test-id": r.id }, on: { change: function(i) {
        return e.updateSetting(s.name, r.id, i);
      } } })], 1);
    })], 2);
  }), 0)]) : n("div", { staticClass: "loader" }, [n("PbCircularLoader", { attrs: { size: 30 } })], 1)]), n("div", { staticClass: "footer" }, [n("MainActionButton", { staticClass: "pb-action-button-old action-button", attrs: { disabled: !e.savingEnabled, iconName: "button-icon-save", "data-test-selector": "notifications-settings-button-save" }, nativeOn: { click: function(r) {
    return e.save.apply(null, arguments);
  } } }, [e._v(" Сохранить настройки уведомлений ")])], 1)]);
}, Wwt = [], Hwt = /* @__PURE__ */ B(
  Bwt,
  jwt,
  Wwt,
  !1,
  null,
  "c143dc7b"
);
const Vwt = Hwt.exports, zwt = "_form_duhzi_1", Uwt = "_formRow_duhzi_5", Gwt = "_label_duhzi_10", Ywt = "_formRow_heading_duhzi_22", Zwt = "_formRow_fontSize_duhzi_26", Xwt = "_colLeft_duhzi_30", Kwt = "_colRight_duhzi_33", Jwt = "_textSizeWidget_duhzi_37", qwt = "_formRow_lineHeight_duhzi_42", Qwt = "_active_duhzi_56", eSt = "_formRow_noDelimiter_duhzi_59", tSt = "_switchButton_duhzi_62", nSt = "_switchButton_active_duhzi_74", rSt = "_formRow_dateline_duhzi_79", sSt = "_formRow_editorWidth_duhzi_87", iSt = "_widthLabel_duhzi_91", oSt = "_colorScheme_duhzi_95", aSt = "_colorSchemeButton_duhzi_104", lSt = "_colorSchemeButton_selected_duhzi_116", cSt = "_colorSchemeMark_duhzi_120", uSt = "_root_duhzi_125", dSt = "_body_duhzi_142", fSt = "_footer_duhzi_147", pSt = "_loader_duhzi_177", hSt = {
  form: zwt,
  formRow: Uwt,
  label: Gwt,
  formRow_heading: Ywt,
  formRow_fontSize: Zwt,
  colLeft: Xwt,
  colRight: Kwt,
  textSizeWidget: Jwt,
  formRow_lineHeight: qwt,
  active: Qwt,
  formRow_noDelimiter: eSt,
  switchButton: tSt,
  switchButton_active: nSt,
  formRow_dateline: rSt,
  formRow_editorWidth: sSt,
  widthLabel: iSt,
  colorScheme: oSt,
  colorSchemeButton: aSt,
  colorSchemeButton_selected: lSt,
  colorSchemeMark: cSt,
  root: uSt,
  body: dSt,
  footer: fSt,
  "select-wrapper": "_select-wrapper_duhzi_155",
  "play-sound-btn": "_play-sound-btn_duhzi_159",
  "play-sound-btn__label": "_play-sound-btn__label_duhzi_165",
  "sound-settings": "_sound-settings_duhzi_171",
  loader: pSt
}, mSt = {
  name: "PanelsSettings",
  components: {
    PbCircularLoader: br,
    MainActionButton: fn,
    PbButton: nt,
    PbButtonSwitcher: rl
  },
  setup() {
    var m;
    const t = Jt("store"), e = {
      $store: t,
      ...ge("userProfile", ["setProfilePublishedPanelSettings"])
    }, n = le(() => t.state.initialLoaded), r = et(t.state.userProfile.publishedPanelMode), s = "notification-1", i = "/sounds", o = "mp3", a = Array.from({ length: 10 }, (v, y) => y + 1).map((v) => ({
      label: `Уведомление ${v}`,
      sound: `notification-${v}`
    })), l = et(
      t.state.userProfile.soundNotifications ? t.state.userProfile.soundNotifications.enabled : !0
    ), c = ((m = t.state.userProfile.soundNotifications) == null ? void 0 : m.sound) ?? s, u = et(
      a.find((v) => v.sound === c) ?? a[0]
    ), d = le(() => f(u.value.sound));
    function f(v) {
      const y = new URL(`${i}/${v}.${o}`, import.meta.url).href;
      return new Audio(y);
    }
    function p() {
      d.value.play();
    }
    async function h() {
      e.setProfilePublishedPanelSettings({
        mode: r.value,
        settings: {
          enabled: l.value,
          sound: u.value.sound
        }
      }), t.dispatch("addMessage", {
        type: "success",
        text: "Настройки успешно сохранены"
      });
    }
    return {
      loaded: n,
      publishedPanelMode: r,
      isNotificationsEnabled: l,
      notificationOption: u,
      notificationOptions: a,
      playSound: p,
      save: h
    };
  }
};
var vSt = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.body }, [e.loaded ? n("div", { class: e.$style.form }, [n("div", { class: [e.$style.formRow, e.$style.formRow_lineHeight, e.$style.formRow_noDelimiter], attrs: { "data-test-selector": "field-line-height" } }, [n("label", { class: e.$style.label }, [e._v("Звуковые уведомления")]), n("PbButtonSwitcher", { attrs: { height: 28 }, model: { value: e.isNotificationsEnabled, callback: function(r) {
    e.isNotificationsEnabled = r;
  }, expression: "isNotificationsEnabled" } }, [n("PbButton", { class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: e.isNotificationsEnabled, "data-test-selector": "btn-published-panel-notifications-enabled" }, on: { click: function(r) {
    e.isNotificationsEnabled = !0;
  } } }, [e._v(" Включены ")]), n("PbButton", { class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: !e.isNotificationsEnabled, "data-test-selector": "btn-published-panel-notifications-disabled" }, on: { click: function(r) {
    e.isNotificationsEnabled = !1;
  } } }, [e._v(" Выключены ")])], 1)], 1), n("div", { class: [e.$style.formRow, e.$style.formRow_lineHeight], attrs: { "data-test-selector": "field-line-height" } }, [n("label", { class: e.$style.label }, [e._v("Выберите звук уведомления")]), n("div", { class: e.$style["sound-settings"] }, [n("div", { class: e.$style["select-wrapper"] }, [n("v-select", { attrs: { label: "label", options: e.notificationOptions, clearable: !1, searchable: !1, "data-test-selector": "btn-settings-sound-selection" }, model: { value: e.notificationOption, callback: function(r) {
    e.notificationOption = r;
  }, expression: "notificationOption" } })], 1), n("MainActionButton", { class: e.$style["play-sound-btn"], attrs: { size: 20, iconName: "play-sound", "data-test-selector": "btn-settings-play-sound" }, nativeOn: { click: function(r) {
    return e.playSound.apply(null, arguments);
  } } }, [n("span", { class: e.$style["play-sound-btn__label"] }, [e._v("Прослушать")])])], 1)]), n("div", { class: [e.$style.formRow, e.$style.formRow_lineHeight], attrs: { "data-test-selector": "field-line-height" } }, [n("label", { class: e.$style.label }, [e._v("Вид панели")]), n("PbButtonSwitcher", { attrs: { height: 28 }, model: { value: e.publishedPanelMode, callback: function(r) {
    e.publishedPanelMode = r;
  }, expression: "publishedPanelMode" } }, [n("PbButton", { class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: e.publishedPanelMode === 1 || e.publishedPanelMode === null, "data-test-selector": "btn-published-panel-mode-vertical" }, on: { click: function(r) {
    e.publishedPanelMode = 1;
  } } }, [e._v(" Вертикальная ")]), n("PbButton", { class: e.$style.switchButton, attrs: { activeClass: e.$style.switchButton_active, active: e.publishedPanelMode === 2, "data-test-selector": "btn-published-panel-mode-horizontal" }, on: { click: function(r) {
    e.publishedPanelMode = 2;
  } } }, [e._v(" Горизонтальная ")])], 1)], 1)]) : n("div", { class: e.$style.loader }, [n("PbCircularLoader", { attrs: { size: 30 } })], 1)]), n("div", { class: e.$style.footer }, [n("MainActionButton", { staticClass: "pb-action-button-old", class: e.$style["play-sound"], attrs: { iconName: "button-icon-save", "data-test-selector": "panels-settings-button-save" }, nativeOn: { click: function(r) {
    return e.save.apply(null, arguments);
  } } }, [e._v(" Сохранить настройки ")])], 1)]);
}, gSt = [];
const AA = {
  $style: hSt
};
function ySt(t) {
  for (var e in AA)
    this[e] = AA[e];
}
var bSt = /* @__PURE__ */ B(
  mSt,
  vSt,
  gSt,
  !1,
  ySt,
  null
);
const _St = bSt.exports, wSt = "_root_10rga_1", SSt = "_wrapper_10rga_10", ISt = "_title_10rga_16", ESt = "_field_10rga_17", xSt = "_label_10rga_40", CSt = "_input_10rga_41", TSt = "_error_10rga_60", PSt = "_button_10rga_69", kSt = "_link_10rga_80", NSt = "_success_10rga_95", $St = {
  root: wSt,
  wrapper: SSt,
  title: ISt,
  field: ESt,
  label: xSt,
  input: CSt,
  error: TSt,
  button: PSt,
  link: kSt,
  success: NSt
}, DSt = {
  name: "AuthResetPasswordForm",
  components: {
    PbButton: nt
  },
  data() {
    return {
      username: "",
      errors: {
        username: ""
      },
      isSuccessfullySent: !1
    };
  },
  watch: {
    username: function(t, e) {
      t !== e && (this.errors.username = "");
    }
  },
  mounted() {
    this.$refs.username.focus();
  },
  methods: {
    ...ge("auth", ["requestPasswordReset"]),
    async handleResetPassword() {
      if (!this.username) {
        this.errors.username = "Введите логин";
        return;
      }
      const t = await this.requestPasswordReset({
        username: this.username
      });
      t.errors && t.errors.forEach((e) => {
        e.code === "NOT_FOUND" ? this.errors.username = e.detail : e.code === "UNPROCESSABLE_ENTITY" ? e.source && e.source.pointer === "/data/attributes/username" && (this.errors.username = e.detail) : e.code === "AUTH_USER_BLOCKED" && (this.errors.username = e.title);
      }), t.errors.length || (this.isSuccessfullySent = !0);
    }
  }
};
var ASt = function() {
  var e = this, n = e._self._c;
  return n("section", { class: e.$style.root, attrs: { "data-test-selector": "reset-password-form" } }, [n("div", { class: e.$style.wrapper }, [n("h1", { class: e.$style.title, attrs: { "data-test-selector": "reset-password-form-title" } }, [e._v(" Восстановление пароля ")]), e.isSuccessfullySent ? n("div", { class: e.$style.success, attrs: { "data-test-selector": "reset-password-form-success-message" } }, [e._v(" Ссылка на восстановление пароля направлена вам на почту. ")]) : n("form", { class: e.$style.form }, [n("div", { class: e.$style.field }, [n("label", { class: e.$style.label, attrs: { for: "username" } }, [e._v("Логин")]), n("input", { directives: [{ name: "model", rawName: "v-model.trim", value: e.username, expression: "username", modifiers: { trim: !0 } }], ref: "username", class: e.$style.input, attrs: { id: "username", name: "username", type: "email", title: "Логин", autocomplete: "email", maxlength: "255", "data-test-selector": "username-field" }, domProps: { value: e.username }, on: { input: function(r) {
    r.target.composing || (e.username = r.target.value.trim());
  }, blur: function(r) {
    return e.$forceUpdate();
  } } }), e.errors.username ? n("div", { class: e.$style.error, attrs: { "data-test-selector": "username-error" } }, [e._v(" " + e._s(e.errors.username) + " ")]) : e._e()]), n("div", { class: e.$style.field }, [n("PbButton", { class: e.$style.button, attrs: { "data-test-selector": "submit-button" }, on: { click: e.handleResetPassword } }, [e._v(" Отправить запрос на восстановление ")])], 1)])]), n("div", { class: e.$style.link }, [n("router-link", { attrs: { to: { name: "login" }, "data-test-selector": "reset-password-form-back-btn" } }, [e._v(" Вернуться")]), e._v(" " + e._s(" ") + "к форме входа в систему ")], 1)]);
}, OSt = [];
const OA = {
  $style: $St
};
function MSt(t) {
  for (var e in OA)
    this[e] = OA[e];
}
var RSt = /* @__PURE__ */ B(
  DSt,
  ASt,
  OSt,
  !1,
  MSt,
  null
);
const LSt = RSt.exports, FSt = "_root_128wd_1", BSt = "_wrapper_128wd_10", jSt = "_title_128wd_16", WSt = "_field_128wd_17", HSt = "_block_128wd_36", VSt = "_loader_128wd_42", zSt = "_button_128wd_48", USt = "_link_128wd_59", GSt = {
  root: FSt,
  wrapper: BSt,
  title: jSt,
  field: WSt,
  block: HSt,
  loader: VSt,
  button: zSt,
  link: USt
}, YSt = {
  name: "AuthResetPasswordComplete",
  components: {
    PbButton: nt,
    PbLoader: br
  },
  data() {
    return {
      isFetching: !1,
      isFetched: !1,
      isSuccess: !1
    };
  },
  methods: {
    ...ge("auth", ["resetPassword"]),
    async handleRequestReset() {
      this.isFetching = !0;
      const t = this.$route.params.token, e = await this.resetPassword({ token: t });
      this.isFetching = !1, this.isFetched = !0, !lt(e, "errors.length") && e.status >= 200 && e.status <= 300 && (this.isSuccess = !0);
    }
  }
};
var ZSt = function() {
  var e = this, n = e._self._c;
  return n("section", { class: e.$style.root, attrs: { "data-test-selector": "reset-password-form" } }, [n("div", { class: e.$style.wrapper }, [n("h1", { class: e.$style.title, attrs: { "data-test-selector": "reset-password-form-title" } }, [e._v(" Восстановление пароля ")]), !e.isFetching && !e.isFetched ? n("div", { class: e.$style.block }, [n("PbButton", { class: e.$style.button, attrs: { "data-test-selector": "submit-button" }, on: { click: e.handleRequestReset } }, [e._v(" Сбросить пароль и отправить новый по почте ")])], 1) : e._e(), e.isFetching ? n("div", { class: e.$style.block }, [n("span", { class: e.$style.loader }, [n("PbLoader", { attrs: { size: 24 } })], 1), n("span", [e._v("Отправка запроса на сброс пароля...")])]) : e._e(), e.isFetched && !e.isSuccess ? n("div", { class: e.$style.block, attrs: { "data-test-selector": "reset-password-form-failed-message" } }, [e._v(" Что-то пошло не так. "), n("br"), e._v(" Проверьте правильность и актуальность ссылки из письма. ")]) : e._e(), e.isFetched && e.isSuccess ? n("div", { class: e.$style.block, attrs: { "data-test-selector": "reset-password-form-password-sent-message" } }, [e._v(" Новый пароль отправлен вам на почту. ")]) : e._e()]), n("div", { class: e.$style.link }, [n("router-link", { attrs: { to: { name: "login" }, "data-test-selector": "reset-password-form-back-btn" } }, [e._v(" Вернуться")]), e._v(" " + e._s(" ") + "к форме входа в систему ")], 1)]);
}, XSt = [];
const MA = {
  $style: GSt
};
function KSt(t) {
  for (var e in MA)
    this[e] = MA[e];
}
var JSt = /* @__PURE__ */ B(
  YSt,
  ZSt,
  XSt,
  !1,
  KSt,
  null
);
const RA = JSt.exports;
U.use(qM);
const qSt = [
  {
    path: "/new",
    name: "new"
  },
  {
    path: "/new/*",
    name: "newSystem"
  },
  {
    path: "/sentry*",
    name: "sentry"
  },
  {
    path: "/login",
    name: "login",
    components: { default: x_ },
    meta: {
      component: d5
    }
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    components: { default: x_ },
    meta: {
      component: LSt
    },
    children: [
      {
        path: ":token",
        name: "resetPasswordComplete",
        meta: {
          component: RA
        },
        components: {
          default: RA
        }
      }
    ]
  },
  {
    path: "/",
    name: "workspace",
    alias: "/tasks",
    // redirect: '/tasks',
    meta: {
      workspace: !0
    },
    components: {
      default: z8
    },
    children: [
      {
        path: "manager",
        name: "manager",
        components: {
          modal: Kit
        },
        children: [
          // #################
          // Потоки
          // #################
          {
            path: "flows",
            name: "flowsManager",
            components: {
              manager: avt
            },
            redirect: "flows/public",
            children: [
              {
                path: "public",
                name: "flowsPublic",
                components: {
                  flows: rA
                }
              },
              {
                path: "my",
                name: "flowsMy",
                components: {
                  flows: rA
                }
              },
              {
                path: "special",
                name: "flowsSpecial",
                components: {
                  flows: jgt
                }
              },
              {
                path: "new",
                name: "flowCreate",
                components: {
                  flows: hA
                }
              },
              {
                path: ":id/edit",
                name: "flowEdit",
                components: {
                  flows: hA
                }
              }
            ]
          },
          // #################
          // Источники
          // #################
          {
            path: "sources",
            components: {
              manager: U_t
            },
            children: [
              {
                path: "",
                name: "sourcesManager",
                components: {
                  sources: l1t
                }
              },
              {
                path: "new",
                name: "sourceCreate",
                components: {
                  sources: DA
                }
              },
              {
                path: ":id/edit",
                name: "sourceEdit",
                components: {
                  sources: DA
                }
              }
            ]
          }
        ]
      },
      // #################
      // Настройки
      // #################
      {
        path: "settings",
        name: "settings",
        redirect: "settings/editor",
        components: {
          modal: _bt
        },
        children: [
          {
            path: "editor",
            name: "editorSettings",
            components: {
              settings: j_t
            }
          },
          {
            path: "notifications",
            name: "notificationsSettings",
            components: {
              settings: Vwt
            }
          },
          {
            path: "panels",
            name: "panelsSettings",
            components: { settings: _St }
          }
        ]
      },
      ...Kut
    ]
  },
  {
    path: "/entities",
    name: "entities",
    components: { default: Gmt }
  }
], cs = new qM({
  routes: qSt,
  mode: "history",
  base: "/legacy/"
}), QSt = ["login", "resetPassword", "resetPasswordComplete"];
cs.beforeEach(async (t, e, n) => QSt.includes(t.name) ? n({ name: "workspace" }) : (cs.app.$store.dispatch("panels/focusPanelByRoute", t), n()));
var Vj = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(typeof self < "u" ? self : vr, function() {
    return (() => {
      var n = { 646: (o) => {
        o.exports = function(a) {
          if (Array.isArray(a)) {
            for (var l = 0, c = new Array(a.length); l < a.length; l++) c[l] = a[l];
            return c;
          }
        };
      }, 713: (o) => {
        o.exports = function(a, l, c) {
          return l in a ? Object.defineProperty(a, l, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[l] = c, a;
        };
      }, 860: (o) => {
        o.exports = function(a) {
          if (Symbol.iterator in Object(a) || Object.prototype.toString.call(a) === "[object Arguments]") return Array.from(a);
        };
      }, 206: (o) => {
        o.exports = function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        };
      }, 319: (o, a, l) => {
        var c = l(646), u = l(860), d = l(206);
        o.exports = function(f) {
          return c(f) || u(f) || d();
        };
      }, 8: (o) => {
        function a(l) {
          return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o.exports = a = function(c) {
            return typeof c;
          } : o.exports = a = function(c) {
            return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
          }, a(l);
        }
        o.exports = a;
      } }, r = {};
      function s(o) {
        var a = r[o];
        if (a !== void 0) return a.exports;
        var l = r[o] = { exports: {} };
        return n[o](l, l.exports, s), l.exports;
      }
      s.n = (o) => {
        var a = o && o.__esModule ? () => o.default : () => o;
        return s.d(a, { a }), a;
      }, s.d = (o, a) => {
        for (var l in a) s.o(a, l) && !s.o(o, l) && Object.defineProperty(o, l, { enumerable: !0, get: a[l] });
      }, s.o = (o, a) => Object.prototype.hasOwnProperty.call(o, a), s.r = (o) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
      };
      var i = {};
      return (() => {
        s.r(i), s.d(i, { VueSelect: () => T, default: () => k, mixins: () => C });
        var o = s(319), a = s.n(o), l = s(8), c = s.n(l), u = s(713), d = s.n(u);
        const f = { props: { autoscroll: { type: Boolean, default: !0 } }, watch: { typeAheadPointer: function() {
          this.autoscroll && this.maybeAdjustScroll();
        }, open: function(b) {
          var P = this;
          this.autoscroll && b && this.$nextTick(function() {
            return P.maybeAdjustScroll();
          });
        } }, methods: { maybeAdjustScroll: function() {
          var b, P = ((b = this.$refs.dropdownMenu) === null || b === void 0 ? void 0 : b.children[this.typeAheadPointer]) || !1;
          if (P) {
            var N = this.getDropdownViewport(), D = P.getBoundingClientRect(), H = D.top, Y = D.bottom, te = D.height;
            if (H < N.top) return this.$refs.dropdownMenu.scrollTop = P.offsetTop;
            if (Y > N.bottom) return this.$refs.dropdownMenu.scrollTop = P.offsetTop - (N.height - te);
          }
        }, getDropdownViewport: function() {
          return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : { height: 0, top: 0, bottom: 0 };
        } } }, p = { data: function() {
          return { typeAheadPointer: -1 };
        }, watch: { filteredOptions: function() {
          for (var b = 0; b < this.filteredOptions.length; b++) if (this.selectable(this.filteredOptions[b])) {
            this.typeAheadPointer = b;
            break;
          }
        }, open: function(b) {
          b && this.typeAheadToLastSelected();
        }, selectedValue: function() {
          this.open && this.typeAheadToLastSelected();
        } }, methods: { typeAheadUp: function() {
          for (var b = this.typeAheadPointer - 1; b >= 0; b--) if (this.selectable(this.filteredOptions[b])) {
            this.typeAheadPointer = b;
            break;
          }
        }, typeAheadDown: function() {
          for (var b = this.typeAheadPointer + 1; b < this.filteredOptions.length; b++) if (this.selectable(this.filteredOptions[b])) {
            this.typeAheadPointer = b;
            break;
          }
        }, typeAheadSelect: function() {
          var b = this.filteredOptions[this.typeAheadPointer];
          b && this.selectable(b) && this.select(b);
        }, typeAheadToLastSelected: function() {
          var b = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
          b !== -1 && (this.typeAheadPointer = b);
        } } }, h = { props: { loading: { type: Boolean, default: !1 } }, data: function() {
          return { mutableLoading: !1 };
        }, watch: { search: function() {
          this.$emit("search", this.search, this.toggleLoading);
        }, loading: function(b) {
          this.mutableLoading = b;
        } }, methods: { toggleLoading: function() {
          var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
          return this.mutableLoading = b ?? !this.mutableLoading;
        } } };
        function m(b, P, N, D, H, Y, te, A) {
          var j, L = typeof b == "function" ? b.options : b;
          return P && (L.render = P, L.staticRenderFns = N, L._compiled = !0), { exports: b, options: L };
        }
        const v = { Deselect: m({}, function() {
          var b = this.$createElement, P = this._self._c || b;
          return P("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10" } }, [P("path", { attrs: { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" } })]);
        }, []).exports, OpenIndicator: m({}, function() {
          var b = this.$createElement, P = this._self._c || b;
          return P("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "10" } }, [P("path", { attrs: { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" } })]);
        }, []).exports }, y = { inserted: function(b, P, N) {
          var D = N.context;
          if (D.appendToBody) {
            var H = D.$refs.toggle.getBoundingClientRect(), Y = H.height, te = H.top, A = H.left, j = H.width, L = window.scrollX || window.pageXOffset, se = window.scrollY || window.pageYOffset;
            b.unbindPosition = D.calculatePosition(b, D, { width: j + "px", left: L + A + "px", top: se + te + Y + "px" }), document.body.appendChild(b);
          }
        }, unbind: function(b, P, N) {
          N.context.appendToBody && (b.unbindPosition && typeof b.unbindPosition == "function" && b.unbindPosition(), b.parentNode && b.parentNode.removeChild(b));
        } }, _ = function(b) {
          var P = {};
          return Object.keys(b).sort().forEach(function(N) {
            P[N] = b[N];
          }), JSON.stringify(P);
        };
        var w = 0;
        const S = function() {
          return ++w;
        };
        function E(b, P) {
          var N = Object.keys(b);
          if (Object.getOwnPropertySymbols) {
            var D = Object.getOwnPropertySymbols(b);
            P && (D = D.filter(function(H) {
              return Object.getOwnPropertyDescriptor(b, H).enumerable;
            })), N.push.apply(N, D);
          }
          return N;
        }
        function x(b) {
          for (var P = 1; P < arguments.length; P++) {
            var N = arguments[P] != null ? arguments[P] : {};
            P % 2 ? E(Object(N), !0).forEach(function(D) {
              d()(b, D, N[D]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(N)) : E(Object(N)).forEach(function(D) {
              Object.defineProperty(b, D, Object.getOwnPropertyDescriptor(N, D));
            });
          }
          return b;
        }
        const T = m({ components: x({}, v), directives: { appendToBody: y }, mixins: [f, p, h], props: { value: {}, components: { type: Object, default: function() {
          return {};
        } }, options: { type: Array, default: function() {
          return [];
        } }, disabled: { type: Boolean, default: !1 }, clearable: { type: Boolean, default: !0 }, deselectFromDropdown: { type: Boolean, default: !1 }, searchable: { type: Boolean, default: !0 }, multiple: { type: Boolean, default: !1 }, placeholder: { type: String, default: "" }, transition: { type: String, default: "vs__fade" }, clearSearchOnSelect: { type: Boolean, default: !0 }, closeOnSelect: { type: Boolean, default: !0 }, label: { type: String, default: "label" }, autocomplete: { type: String, default: "off" }, reduce: { type: Function, default: function(b) {
          return b;
        } }, selectable: { type: Function, default: function(b) {
          return !0;
        } }, getOptionLabel: { type: Function, default: function(b) {
          return c()(b) === "object" ? b.hasOwnProperty(this.label) ? b[this.label] : console.warn('[vue-select warn]: Label key "option.'.concat(this.label, '" does not') + " exist in options object ".concat(JSON.stringify(b), `.
`) + "https://vue-select.org/api/props.html#getoptionlabel") : b;
        } }, getOptionKey: { type: Function, default: function(b) {
          if (c()(b) !== "object") return b;
          try {
            return b.hasOwnProperty("id") ? b.id : _(b);
          } catch (P) {
            return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, b, P);
          }
        } }, onTab: { type: Function, default: function() {
          this.selectOnTab && !this.isComposing && this.typeAheadSelect();
        } }, taggable: { type: Boolean, default: !1 }, tabindex: { type: Number, default: null }, pushTags: { type: Boolean, default: !1 }, filterable: { type: Boolean, default: !0 }, filterBy: { type: Function, default: function(b, P, N) {
          return (P || "").toLocaleLowerCase().indexOf(N.toLocaleLowerCase()) > -1;
        } }, filter: { type: Function, default: function(b, P) {
          var N = this;
          return b.filter(function(D) {
            var H = N.getOptionLabel(D);
            return typeof H == "number" && (H = H.toString()), N.filterBy(D, H, P);
          });
        } }, createOption: { type: Function, default: function(b) {
          return c()(this.optionList[0]) === "object" ? d()({}, this.label, b) : b;
        } }, resetOnOptionsChange: { default: !1, validator: function(b) {
          return ["function", "boolean"].includes(c()(b));
        } }, clearSearchOnBlur: { type: Function, default: function(b) {
          var P = b.clearSearchOnSelect, N = b.multiple;
          return P && !N;
        } }, noDrop: { type: Boolean, default: !1 }, inputId: { type: String }, dir: { type: String, default: "auto" }, selectOnTab: { type: Boolean, default: !1 }, selectOnKeyCodes: { type: Array, default: function() {
          return [13];
        } }, searchInputQuerySelector: { type: String, default: "[type=search]" }, mapKeydown: { type: Function, default: function(b, P) {
          return b;
        } }, appendToBody: { type: Boolean, default: !1 }, calculatePosition: { type: Function, default: function(b, P, N) {
          var D = N.width, H = N.top, Y = N.left;
          b.style.top = H, b.style.left = Y, b.style.width = D;
        } }, dropdownShouldOpen: { type: Function, default: function(b) {
          var P = b.noDrop, N = b.open, D = b.mutableLoading;
          return !P && N && !D;
        } }, uid: { type: [String, Number], default: function() {
          return S();
        } } }, data: function() {
          return { search: "", open: !1, isComposing: !1, pushedTags: [], _value: [] };
        }, computed: { isTrackingValues: function() {
          return this.value === void 0 || this.$options.propsData.hasOwnProperty("reduce");
        }, selectedValue: function() {
          var b = this.value;
          return this.isTrackingValues && (b = this.$data._value), b != null && b !== "" ? [].concat(b) : [];
        }, optionList: function() {
          return this.options.concat(this.pushTags ? this.pushedTags : []);
        }, searchEl: function() {
          return this.$scopedSlots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
        }, scope: function() {
          var b = this, P = { search: this.search, loading: this.loading, searching: this.searching, filteredOptions: this.filteredOptions };
          return { search: { attributes: x({ disabled: this.disabled, placeholder: this.searchPlaceholder, tabindex: this.tabindex, readonly: !this.searchable, id: this.inputId, "aria-autocomplete": "list", "aria-labelledby": "vs".concat(this.uid, "__combobox"), "aria-controls": "vs".concat(this.uid, "__listbox"), ref: "search", type: "search", autocomplete: this.autocomplete, value: this.search }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? { "aria-activedescendant": "vs".concat(this.uid, "__option-").concat(this.typeAheadPointer) } : {}), events: { compositionstart: function() {
            return b.isComposing = !0;
          }, compositionend: function() {
            return b.isComposing = !1;
          }, keydown: this.onSearchKeyDown, keypress: this.onSearchKeyPress, blur: this.onSearchBlur, focus: this.onSearchFocus, input: function(N) {
            return b.search = N.target.value;
          } } }, spinner: { loading: this.mutableLoading }, noOptions: { search: this.search, loading: this.mutableLoading, searching: this.searching }, openIndicator: { attributes: { ref: "openIndicator", role: "presentation", class: "vs__open-indicator" } }, listHeader: P, listFooter: P, header: x({}, P, { deselect: this.deselect }), footer: x({}, P, { deselect: this.deselect }) };
        }, childComponents: function() {
          return x({}, v, {}, this.components);
        }, stateClasses: function() {
          return { "vs--open": this.dropdownOpen, "vs--single": !this.multiple, "vs--multiple": this.multiple, "vs--searching": this.searching && !this.noDrop, "vs--searchable": this.searchable && !this.noDrop, "vs--unsearchable": !this.searchable, "vs--loading": this.mutableLoading, "vs--disabled": this.disabled };
        }, searching: function() {
          return !!this.search;
        }, dropdownOpen: function() {
          return this.dropdownShouldOpen(this);
        }, searchPlaceholder: function() {
          return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
        }, filteredOptions: function() {
          var b = [].concat(this.optionList);
          if (!this.filterable && !this.taggable) return b;
          var P = this.search.length ? this.filter(b, this.search, this) : b;
          if (this.taggable && this.search.length) {
            var N = this.createOption(this.search);
            this.optionExists(N) || P.unshift(N);
          }
          return P;
        }, isValueEmpty: function() {
          return this.selectedValue.length === 0;
        }, showClearButton: function() {
          return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
        } }, watch: { options: function(b, P) {
          var N = this;
          !this.taggable && (typeof N.resetOnOptionsChange == "function" ? N.resetOnOptionsChange(b, P, N.selectedValue) : N.resetOnOptionsChange) && this.clearSelection(), this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value);
        }, value: { immediate: !0, handler: function(b) {
          this.isTrackingValues && this.setInternalValueFromOptions(b);
        } }, multiple: function() {
          this.clearSelection();
        }, open: function(b) {
          this.$emit(b ? "open" : "close");
        }, search: function(b) {
          b.length && (this.open = !0);
        } }, created: function() {
          this.mutableLoading = this.loading, this.$on("option:created", this.pushTag);
        }, methods: { setInternalValueFromOptions: function(b) {
          var P = this;
          Array.isArray(b) ? this.$data._value = b.map(function(N) {
            return P.findOptionFromReducedValue(N);
          }) : this.$data._value = this.findOptionFromReducedValue(b);
        }, select: function(b) {
          this.$emit("option:selecting", b), this.isOptionSelected(b) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(b) : (this.taggable && !this.optionExists(b) && this.$emit("option:created", b), this.multiple && (b = this.selectedValue.concat(b)), this.updateValue(b), this.$emit("option:selected", b)), this.onAfterSelect(b);
        }, deselect: function(b) {
          var P = this;
          this.$emit("option:deselecting", b), this.updateValue(this.selectedValue.filter(function(N) {
            return !P.optionComparator(N, b);
          })), this.$emit("option:deselected", b);
        }, clearSelection: function() {
          this.updateValue(this.multiple ? [] : null);
        }, onAfterSelect: function(b) {
          var P = this;
          this.closeOnSelect && (this.open = !this.open), this.clearSearchOnSelect && (this.search = ""), this.noDrop && this.multiple && this.$nextTick(function() {
            return P.$refs.search.focus();
          });
        }, updateValue: function(b) {
          var P = this;
          this.value === void 0 && (this.$data._value = b), b !== null && (b = Array.isArray(b) ? b.map(function(N) {
            return P.reduce(N);
          }) : this.reduce(b)), this.$emit("input", b);
        }, toggleDropdown: function(b) {
          var P = b.target !== this.searchEl;
          P && b.preventDefault();
          var N = [].concat(a()(this.$refs.deselectButtons || []), a()([this.$refs.clearButton]));
          this.searchEl === void 0 || N.filter(Boolean).some(function(D) {
            return D.contains(b.target) || D === b.target;
          }) ? b.preventDefault() : this.open && P ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
        }, isOptionSelected: function(b) {
          var P = this;
          return this.selectedValue.some(function(N) {
            return P.optionComparator(N, b);
          });
        }, isOptionDeselectable: function(b) {
          return this.isOptionSelected(b) && this.deselectFromDropdown;
        }, optionComparator: function(b, P) {
          return this.getOptionKey(b) === this.getOptionKey(P);
        }, findOptionFromReducedValue: function(b) {
          var P = this, N = [].concat(a()(this.options), a()(this.pushedTags)).filter(function(D) {
            return JSON.stringify(P.reduce(D)) === JSON.stringify(b);
          });
          return N.length === 1 ? N[0] : N.find(function(D) {
            return P.optionComparator(D, P.$data._value);
          }) || b;
        }, closeSearchOptions: function() {
          this.open = !1, this.$emit("search:blur");
        }, maybeDeleteValue: function() {
          if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
            var b = null;
            this.multiple && (b = a()(this.selectedValue.slice(0, this.selectedValue.length - 1))), this.updateValue(b);
          }
        }, optionExists: function(b) {
          var P = this;
          return this.optionList.some(function(N) {
            return P.optionComparator(N, b);
          });
        }, normalizeOptionForSlot: function(b) {
          return c()(b) === "object" ? b : d()({}, this.label, b);
        }, pushTag: function(b) {
          this.pushedTags.push(b);
        }, onEscape: function() {
          this.search.length ? this.search = "" : this.open = !1;
        }, onSearchBlur: function() {
          if (!this.mousedown || this.searching) {
            var b = this.clearSearchOnSelect, P = this.multiple;
            return this.clearSearchOnBlur({ clearSearchOnSelect: b, multiple: P }) && (this.search = ""), void this.closeSearchOptions();
          }
          this.mousedown = !1, this.search.length !== 0 || this.options.length !== 0 || this.closeSearchOptions();
        }, onSearchFocus: function() {
          this.open = !0, this.$emit("search:focus");
        }, onMousedown: function() {
          this.mousedown = !0;
        }, onMouseUp: function() {
          this.mousedown = !1;
        }, onSearchKeyDown: function(b) {
          var P = this, N = function(Y) {
            return Y.preventDefault(), !P.isComposing && P.typeAheadSelect();
          }, D = { 8: function(Y) {
            return P.maybeDeleteValue();
          }, 9: function(Y) {
            return P.onTab();
          }, 27: function(Y) {
            return P.onEscape();
          }, 38: function(Y) {
            if (Y.preventDefault(), P.open) return P.typeAheadUp();
            P.open = !0;
          }, 40: function(Y) {
            if (Y.preventDefault(), P.open) return P.typeAheadDown();
            P.open = !0;
          } };
          this.selectOnKeyCodes.forEach(function(Y) {
            return D[Y] = N;
          });
          var H = this.mapKeydown(D, this);
          if (typeof H[b.keyCode] == "function") return H[b.keyCode](b);
        }, onSearchKeyPress: function(b) {
          this.open || b.keyCode !== 32 || (b.preventDefault(), this.open = !0);
        } } }, function() {
          var b = this, P = b.$createElement, N = b._self._c || P;
          return N("div", { staticClass: "v-select", class: b.stateClasses, attrs: { dir: b.dir } }, [b._t("header", null, null, b.scope.header), b._v(" "), N("div", { ref: "toggle", staticClass: "vs__dropdown-toggle", attrs: { id: "vs" + b.uid + "__combobox", role: "combobox", "aria-expanded": b.dropdownOpen.toString(), "aria-owns": "vs" + b.uid + "__listbox", "aria-label": "Search for option" }, on: { mousedown: function(D) {
            return b.toggleDropdown(D);
          } } }, [N("div", { ref: "selectedOptions", staticClass: "vs__selected-options" }, [b._l(b.selectedValue, function(D) {
            return b._t("selected-option-container", [N("span", { key: b.getOptionKey(D), staticClass: "vs__selected" }, [b._t("selected-option", [b._v(`
            ` + b._s(b.getOptionLabel(D)) + `
          `)], null, b.normalizeOptionForSlot(D)), b._v(" "), b.multiple ? N("button", { ref: "deselectButtons", refInFor: !0, staticClass: "vs__deselect", attrs: { disabled: b.disabled, type: "button", title: "Deselect " + b.getOptionLabel(D), "aria-label": "Deselect " + b.getOptionLabel(D) }, on: { click: function(H) {
              return b.deselect(D);
            } } }, [N(b.childComponents.Deselect, { tag: "component" })], 1) : b._e()], 2)], { option: b.normalizeOptionForSlot(D), deselect: b.deselect, multiple: b.multiple, disabled: b.disabled });
          }), b._v(" "), b._t("search", [N("input", b._g(b._b({ staticClass: "vs__search" }, "input", b.scope.search.attributes, !1), b.scope.search.events))], null, b.scope.search)], 2), b._v(" "), N("div", { ref: "actions", staticClass: "vs__actions" }, [N("button", { directives: [{ name: "show", rawName: "v-show", value: b.showClearButton, expression: "showClearButton" }], ref: "clearButton", staticClass: "vs__clear", attrs: { disabled: b.disabled, type: "button", title: "Clear Selected", "aria-label": "Clear Selected" }, on: { click: b.clearSelection } }, [N(b.childComponents.Deselect, { tag: "component" })], 1), b._v(" "), b._t("open-indicator", [b.noDrop ? b._e() : N(b.childComponents.OpenIndicator, b._b({ tag: "component" }, "component", b.scope.openIndicator.attributes, !1))], null, b.scope.openIndicator), b._v(" "), b._t("spinner", [N("div", { directives: [{ name: "show", rawName: "v-show", value: b.mutableLoading, expression: "mutableLoading" }], staticClass: "vs__spinner" }, [b._v("Loading...")])], null, b.scope.spinner)], 2)]), b._v(" "), N("transition", { attrs: { name: b.transition } }, [b.dropdownOpen ? N("ul", { directives: [{ name: "append-to-body", rawName: "v-append-to-body" }], key: "vs" + b.uid + "__listbox", ref: "dropdownMenu", staticClass: "vs__dropdown-menu", attrs: { id: "vs" + b.uid + "__listbox", role: "listbox", tabindex: "-1" }, on: { mousedown: function(D) {
            return D.preventDefault(), b.onMousedown(D);
          }, mouseup: b.onMouseUp } }, [b._t("list-header", null, null, b.scope.listHeader), b._v(" "), b._l(b.filteredOptions, function(D, H) {
            return N("li", { key: b.getOptionKey(D), staticClass: "vs__dropdown-option", class: { "vs__dropdown-option--deselect": b.isOptionDeselectable(D) && H === b.typeAheadPointer, "vs__dropdown-option--selected": b.isOptionSelected(D), "vs__dropdown-option--highlight": H === b.typeAheadPointer, "vs__dropdown-option--disabled": !b.selectable(D) }, attrs: { id: "vs" + b.uid + "__option-" + H, role: "option", "aria-selected": H === b.typeAheadPointer || null }, on: { mouseover: function(Y) {
              b.selectable(D) && (b.typeAheadPointer = H);
            }, click: function(Y) {
              Y.preventDefault(), Y.stopPropagation(), b.selectable(D) && b.select(D);
            } } }, [b._t("option", [b._v(`
          ` + b._s(b.getOptionLabel(D)) + `
        `)], null, b.normalizeOptionForSlot(D))], 2);
          }), b._v(" "), b.filteredOptions.length === 0 ? N("li", { staticClass: "vs__no-options" }, [b._t("no-options", [b._v(`
          Sorry, no matching options.
        `)], null, b.scope.noOptions)], 2) : b._e(), b._v(" "), b._t("list-footer", null, null, b.scope.listFooter)], 2) : N("ul", { staticStyle: { display: "none", visibility: "hidden" }, attrs: { id: "vs" + b.uid + "__listbox", role: "listbox" } })]), b._v(" "), b._t("footer", null, null, b.scope.footer)], 2);
        }, []).exports, C = { ajax: h, pointer: p, pointerScroll: f }, k = T;
      })(), i;
    })();
  });
})(Vj);
var e2t = Vj.exports;
const zj = /* @__PURE__ */ Et(e2t);
var Uj = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(typeof self < "u" ? self : vr, function() {
    return function(n) {
      function r(i) {
        if (s[i]) return s[i].exports;
        var o = s[i] = { i, l: !1, exports: {} };
        return n[i].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }
      var s = {};
      return r.m = n, r.c = s, r.d = function(i, o, a) {
        r.o(i, o) || Object.defineProperty(i, o, { configurable: !1, enumerable: !0, get: a });
      }, r.n = function(i) {
        var o = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(o, "a", o), o;
      }, r.o = function(i, o) {
        return Object.prototype.hasOwnProperty.call(i, o);
      }, r.p = "/", r(r.s = 4);
    }([function(n, r, s) {
      var i = "v-collapse", o = { prefix: i, basename: "collapse", togglerClassDefault: i + "-toggler", contentClassDefault: i + "-content", contentClassEnd: i + "-content-end" }, a = function(u, d) {
        u.classList.toggle(d.contentClassEnd);
      }, l = function(u, d) {
        u.classList.remove(d.contentClassEnd);
      }, c = function(u, d) {
        u.classList.add(d.contentClassEnd);
      };
      n.exports = { defaults: o, toggleElement: a, closeElement: l, openElement: c };
    }, function(n, r) {
      n.exports = function(s, i, o, a, l, c) {
        var u, d = s = s || {}, f = typeof s.default;
        f !== "object" && f !== "function" || (u = s, d = s.default);
        var p = typeof d == "function" ? d.options : d;
        i && (p.render = i.render, p.staticRenderFns = i.staticRenderFns, p._compiled = !0), o && (p.functional = !0), l && (p._scopeId = l);
        var h;
        if (c ? (h = function(y) {
          y = y || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, y || typeof __VUE_SSR_CONTEXT__ > "u" || (y = __VUE_SSR_CONTEXT__), a && a.call(this, y), y && y._registeredComponents && y._registeredComponents.add(c);
        }, p._ssrRegister = h) : a && (h = a), h) {
          var m = p.functional, v = m ? p.render : p.beforeCreate;
          m ? (p._injectStyles = h, p.render = function(y, _) {
            return h.call(_), v(y, _);
          }) : p.beforeCreate = v ? [].concat(v, h) : [h];
        }
        return { esModule: u, exports: d, options: p };
      };
    }, function(n, r, s) {
      Object.defineProperty(r, "__esModule", { value: !0 });
      var i = s(0);
      r.default = { data: function() {
        return { nodes: {}, status: !1 };
      }, props: ["active"], watch: { active: function(o) {
        o != null && (this.status = o);
      }, status: function(o, a) {
        if (this.$emit("onStatusChange", { vm: this, status: o, old_status: a }), this.$parent.onlyOneActive === !1) (0, i.toggleElement)(this.nodes.content, this.$options.$vc.settings);
        else if (o === !0 && a === !1) {
          var l = this.$parent.$children.filter(function(c) {
            return c.status === !0;
          });
          l.length > 1 && l.forEach((function(c) {
            c.close(), (0, i.closeElement)(c.nodes.content, this.$options.$vc.settings);
          }).bind(this)), (0, i.openElement)(this.nodes.content, this.$options.$vc.settings), this.open();
        } else a === !0 && o === !1 && ((0, i.closeElement)(this.nodes.content, this.$options.$vc.settings), this.close());
      } }, methods: { toggle: function() {
        this.$emit("beforeToggle", this), this.status = !this.status, this.$emit("afterToggle", this);
      }, close: function() {
        this.$emit("beforeClose", this), this.status = !1, this.$emit("afterClose", this);
      }, open: function() {
        this.$emit("beforeOpen", this), this.status = !0, this.$emit("afterOpen", this);
      } }, mounted: function() {
        var o = this;
        this.nodes.toggle = this.$el.querySelector("." + this.$options.$vc.settings.togglerClassDefault), this.nodes.content = this.$el.querySelector("." + this.$options.$vc.settings.contentClassDefault), this.$emit("afterNodesBinding", { vm: this, nodes: this.nodes }), this.nodes.toggle !== null && this.nodes.toggle.addEventListener("click", function() {
          o.toggle();
        }), this.active != null && (this.status = this.active);
      } };
    }, function(n, r, s) {
      Object.defineProperty(r, "__esModule", { value: !0 }), s(0), r.default = { data: function() {
        return {};
      }, props: { onlyOneActive: { default: !1, type: Boolean } }, computed: { elements: function() {
        return this.$children;
      }, elements_count: function() {
        return this.$children.length;
      }, active_elements: function() {
        return this.$children.filter(function(i) {
          return i.status === !0;
        });
      } }, methods: { closeAll: function() {
        this.$children.forEach(function(i) {
          i.close();
        });
      }, openAll: function() {
        this.$children.forEach(function(i) {
          i.open();
        });
      } } };
    }, function(n, r, s) {
      function i(f) {
        return f && f.__esModule ? f : { default: f };
      }
      Object.defineProperty(r, "__esModule", { value: !0 });
      var o = s(5), a = i(o), l = s(8), c = i(l), u = s(0), d = {};
      d.install = function(f, p) {
        var h = Object.assign(u.defaults, p);
        f.component(h.prefix + "-wrapper", a.default), f.component(h.prefix + "-group", c.default), f.mixin({ created: function() {
          this.$options.$vc = { settings: h };
        } }), f.directive(h.basename + "-content", { bind: function(m, v, y, _) {
          y.elm.classList.add(y.context.$options.$vc.settings.contentClassDefault);
        } }), f.directive(h.basename + "-toggle", { bind: function(m, v, y, _) {
          y.elm.classList.add(y.context.$options.$vc.settings.togglerClassDefault);
        }, inserted: function(m, v, y, _) {
          v.value != null && y.elm.addEventListener("click", (function() {
            y.context.$refs[v.value].status = !y.context.$refs[v.value].status;
          }).bind(this));
        } });
      }, typeof window < "u" && window.Vue && window.Vue.use(d), r.default = d;
    }, function(n, r, s) {
      function i(p) {
        s(6);
      }
      Object.defineProperty(r, "__esModule", { value: !0 });
      var o = s(2), a = s.n(o);
      for (var l in o) l !== "default" && function(p) {
        s.d(r, p, function() {
          return o[p];
        });
      }(l);
      var c = s(7), u = s(1), d = i, f = u(a.a, c.a, !1, d, null, null);
      r.default = f.exports;
    }, function(n, r) {
    }, function(n, r, s) {
      var i = function() {
        var l = this, c = l.$createElement;
        return (l._self._c || c)("div", { class: "vc-" + l.$options.$vc.settings.basename }, [l._t("default")], 2);
      }, o = [], a = { render: i, staticRenderFns: o };
      r.a = a;
    }, function(n, r, s) {
      Object.defineProperty(r, "__esModule", { value: !0 });
      var i = s(3), o = s.n(i);
      for (var a in i) a !== "default" && function(d) {
        s.d(r, d, function() {
          return i[d];
        });
      }(a);
      var l = s(9), c = s(1), u = c(o.a, l.a, !1, null, null, null);
      r.default = u.exports;
    }, function(n, r, s) {
      var i = function() {
        var l = this, c = l.$createElement;
        return (l._self._c || c)("div", { staticClass: "v-collapse-group" }, [l._t("default")], 2);
      }, o = [], a = { render: i, staticRenderFns: o };
      r.a = a;
    }]);
  });
})(Uj);
var t2t = Uj.exports;
const n2t = /* @__PURE__ */ Et(t2t);
var Gj = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r(n2);
  })(vr, function(n) {
    n = n && n.hasOwnProperty("default") ? n.default : n;
    var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
      return typeof x;
    } : function(x) {
      return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
    }, s = Object.assign || function(x) {
      for (var T = 1; T < arguments.length; T++) {
        var C = arguments[T];
        for (var k in C)
          Object.prototype.hasOwnProperty.call(C, k) && (x[k] = C[k]);
      }
      return x;
    }, i = function(x) {
      if (Array.isArray(x)) {
        for (var T = 0, C = Array(x.length); T < x.length; T++) C[T] = x[T];
        return C;
      } else
        return Array.from(x);
    };
    function o(x) {
      for (var T = x.hasAttributes() ? x.attributes : [], C = {}, k = 0; k < T.length; k++) {
        var b = T[k];
        b.value && (C[b.name] = b.value === "" ? !0 : b.value);
      }
      var P = void 0, N = void 0;
      C.class && (P = C.class, delete C.class), C.style && (N = C.style, delete C.style);
      var D = {
        attrs: C,
        class: P,
        style: N
      };
      return D;
    }
    function a(x) {
      return Array.isArray(x) || (typeof x > "u" ? "undefined" : r(x)) === "object" ? Object.freeze(x) : x;
    }
    function l(x) {
      var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return x.reduce(function(C, k) {
        var b = k.passengers[0];
        return b = typeof b == "function" ? b(T) : k.passengers, C.concat(b);
      }, []);
    }
    function c(x, T) {
      return x.map(function(C, k) {
        return [k, C];
      }).sort((function(C, k) {
        return this(C[1], k[1]) || C[0] - k[0];
      }).bind(T)).map(function(C) {
        return C[1];
      });
    }
    var u = {}, d = n.extend({
      data: function() {
        return { transports: u };
      },
      methods: {
        open: function(T) {
          var C = T.to, k = T.from, b = T.passengers;
          if (!(!C || !k || !b)) {
            T.passengers = a(b);
            var P = Object.keys(this.transports);
            P.indexOf(C) === -1 && n.set(this.transports, C, []);
            var N = this.getTransportIndex(T), D = this.transports[C].slice(0);
            N === -1 ? D.push(T) : D[N] = T, this.transports[C] = c(D, function(H, Y) {
              return H.order - Y.order;
            });
          }
        },
        close: function(T) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, k = T.to, b = T.from;
          if (!(!k || !b) && this.transports[k])
            if (C)
              this.transports[k] = [];
            else {
              var P = this.getTransportIndex(T);
              if (P >= 0) {
                var N = this.transports[k].slice(0);
                N.splice(P, 1), this.transports[k] = N;
              }
            }
        },
        hasTarget: function(T) {
          return this.transports.hasOwnProperty(T);
        },
        hasContentFor: function(T) {
          return this.transports[T] ? this.getContentFor(T).length > 0 : !1;
        },
        getSourceFor: function(T) {
          return this.transports[T] && this.transports[T][0].from;
        },
        getContentFor: function(T) {
          var C = this.transports[T];
          if (C)
            return l(C);
        },
        getTransportIndex: function(T) {
          var C = T.to, k = T.from;
          for (var b in this.transports[C])
            if (this.transports[C][b].from === k)
              return b;
          return -1;
        }
      }
    }), f = new d(u), p = /^(attrs|props|on|nativeOn|class|style|hook)$/, h = function(T) {
      return T.reduce(function(C, k) {
        var b, P, N, D, H;
        for (N in k)
          if (b = C[N], P = k[N], b && p.test(N))
            if (N === "class" && (typeof b == "string" && (H = b, C[N] = b = {}, b[H] = !0), typeof P == "string" && (H = P, k[N] = P = {}, P[H] = !0)), N === "on" || N === "nativeOn" || N === "hook")
              for (D in P)
                b[D] = m(b[D], P[D]);
            else if (Array.isArray(b))
              C[N] = b.concat(P);
            else if (Array.isArray(P))
              C[N] = [b].concat(P);
            else
              for (D in P)
                b[D] = P[D];
          else
            C[N] = k[N];
        return C;
      }, {});
    };
    function m(x, T) {
      return function() {
        x && x.apply(this, arguments), T && T.apply(this, arguments);
      };
    }
    var v = {
      abstract: !1,
      name: "portalTarget",
      props: {
        attributes: { type: Object, default: function() {
          return {};
        } },
        multiple: { type: Boolean, default: !1 },
        name: { type: String, required: !0 },
        slim: { type: Boolean, default: !1 },
        slotProps: { type: Object, default: function() {
          return {};
        } },
        tag: { type: String, default: "div" },
        transition: { type: [Boolean, String, Object], default: !1 },
        transitionEvents: { type: Object, default: function() {
          return {};
        } }
      },
      data: function() {
        return {
          transports: f.transports,
          firstRender: !0
        };
      },
      created: function() {
        this.transports[this.name] || this.$set(this.transports, this.name, []);
      },
      mounted: function() {
        var T = this;
        this.unwatch = this.$watch("ownTransports", this.emitChange), this.$nextTick(function() {
          T.transition && (T.firstRender = !1);
        }), this.$options.abstract && (this.$options.abstract = !1);
      },
      updated: function() {
        this.$options.abstract && (this.$options.abstract = !1);
      },
      beforeDestroy: function() {
        this.unwatch();
      },
      computed: {
        ownTransports: function() {
          var T = this.transports[this.name] || [];
          return this.multiple ? T : T.length === 0 ? [] : [T[T.length - 1]];
        },
        passengers: function() {
          return l(this.ownTransports, this.slotProps);
        },
        hasAttributes: function() {
          return Object.keys(this.attributes).length > 0;
        },
        withTransition: function() {
          return !!this.transition;
        },
        transitionData: function() {
          var T = this.transition, C = {};
          return this.firstRender && r(this.transition) === "object" && !this.transition.appear ? (C.props = { name: "__notranstition__portal-vue__" }, C) : (typeof T == "string" ? C.props = { name: T } : (typeof T > "u" ? "undefined" : r(T)) === "object" && (C.props = T), this.renderSlim && (C.props.tag = this.tag), C.on = this.transitionEvents, C);
        },
        transportedClasses: function() {
          return this.ownTransports.map(function(T) {
            return T.class;
          }).reduce(function(T, C) {
            return T.concat(C);
          }, []);
        }
      },
      methods: {
        emitChange: function(T, C) {
          if (this.multiple)
            this.$emit("change", [].concat(i(T)), [].concat(i(C)));
          else {
            var k = T.length === 0 ? void 0 : T[0], b = C.length === 0 ? void 0 : C[0];
            this.$emit("change", s({}, k), s({}, b));
          }
        },
        // can't be a computed prop because it has to "react" to $slot changes.
        children: function() {
          return this.passengers.length !== 0 ? this.passengers : this.$slots.default || [];
        },
        noWrapper: function() {
          var T = !this.hasAttributes && this.slim;
          return T && this.children().length > 1 && console.warn("[portal-vue]: PortalTarget with `slim` option received more than one child element."), T;
        }
      },
      render: function(T) {
        this.$options.abstract = !0;
        var C = this.noWrapper(), k = this.children(), b = C ? "transition" : "transition-group", P = this.tag;
        return this.withTransition ? T(
          b,
          h([this.transitionData, { class: "vue-portal-target" }]),
          [k]
        ) : C ? k[0] : T(
          P,
          h([{
            class: "vue-portal-target " + this.transportedClasses.join(" ")
          }, this.attributes]),
          [k]
        );
      }
    }, y = typeof window < "u", _ = 1, w = {
      abstract: !1,
      name: "portal",
      props: {
        /* global HTMLElement */
        disabled: { type: Boolean, default: !1 },
        name: { type: String, default: function() {
          return String(_++);
        } },
        order: { type: Number, default: 0 },
        slim: { type: Boolean, default: !1 },
        slotProps: { type: Object, default: function() {
          return {};
        } },
        tag: { type: [String], default: "DIV" },
        targetEl: { type: y ? [String, HTMLElement] : String },
        targetClass: { type: String },
        to: {
          type: String,
          default: function() {
            return String(Math.round(Math.random() * 1e7));
          }
        }
      },
      mounted: function() {
        this.targetEl && this.mountToTarget(), this.disabled || this.sendUpdate(), this.$options.abstract && (this.$options.abstract = !1);
      },
      updated: function() {
        this.disabled ? this.clear() : this.sendUpdate(), this.$options.abstract && (this.$options.abstract = !1);
      },
      beforeDestroy: function() {
        this.clear(), this.mountedComp && this.mountedComp.$destroy();
      },
      watch: {
        to: function(T, C) {
          C && C !== T && this.clear(C), this.sendUpdate();
        },
        targetEl: function(T, C) {
          T && this.mountToTarget();
        }
      },
      methods: {
        normalizedSlots: function() {
          return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
        },
        sendUpdate: function() {
          var T = this.normalizedSlots();
          T ? f.open({
            from: this.name,
            to: this.to,
            passengers: [].concat(i(T)),
            class: this.targetClass && this.targetClass.split(" "),
            order: this.order
          }) : this.clear();
        },
        clear: function(T) {
          f.close({
            from: this.name,
            to: T || this.to
          });
        },
        mountToTarget: function() {
          var T = void 0, C = this.targetEl;
          if (typeof C == "string")
            T = document.querySelector(C);
          else if (C instanceof HTMLElement)
            T = C;
          else {
            console.warn("[vue-portal]: value of targetEl must be of type String or HTMLElement");
            return;
          }
          if (T) {
            var k = new n(s({}, v, {
              parent: this,
              propsData: {
                name: this.to,
                tag: T.tagName,
                attributes: o(T)
              }
            }));
            k.$mount(T), this.mountedComp = k;
          } else
            console.warn("[vue-portal]: The specified targetEl " + C + " was not found");
        },
        normalizeChildren: function(T) {
          return typeof T == "function" ? T(this.slotProps) : T;
        }
      },
      render: function(T) {
        var C = this.$slots.default || this.$scopedSlots.default || [], k = this.tag;
        return C.length && this.disabled ? (this.$options.abstract = !0, C.length <= 1 && this.slim ? C[0] : T(k, [this.normalizeChildren(C)])) : T(k, {
          class: "v-portal",
          style: "display: none",
          key: "v-portal-placeholder"
        });
      }
    };
    function S(x) {
      var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      x.component(T.portalName || "Portal", w), x.component(T.portalTargetName || "PortalTarget", v);
    }
    typeof window < "u" && window.Vue && window.Vue.use({ install: S });
    var E = {
      install: S,
      Portal: w,
      PortalTarget: v,
      Wormhole: f
    };
    return E;
  });
})(Gj);
var r2t = Gj.exports;
const s2t = /* @__PURE__ */ Et(r2t);
var Yj = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r(n2);
  })(typeof self < "u" ? self : vr, function(n) {
    return function(r) {
      var s = {};
      function i(o) {
        if (s[o]) return s[o].exports;
        var a = s[o] = { i: o, l: !1, exports: {} };
        return r[o].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
      }
      return i.m = r, i.c = s, i.d = function(o, a, l) {
        i.o(o, a) || Object.defineProperty(o, a, { enumerable: !0, get: l });
      }, i.r = function(o) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
      }, i.t = function(o, a) {
        if (1 & a && (o = i(o)), 8 & a || 4 & a && typeof o == "object" && o && o.__esModule) return o;
        var l = /* @__PURE__ */ Object.create(null);
        if (i.r(l), Object.defineProperty(l, "default", { enumerable: !0, value: o }), 2 & a && typeof o != "string") for (var c in o) i.d(l, c, (function(u) {
          return o[u];
        }).bind(null, c));
        return l;
      }, i.n = function(o) {
        var a = o && o.__esModule ? function() {
          return o.default;
        } : function() {
          return o;
        };
        return i.d(a, "a", a), a;
      }, i.o = function(o, a) {
        return Object.prototype.hasOwnProperty.call(o, a);
      }, i.p = "", i(i.s = "fb15");
    }({ "00ee": function(r, s, i) {
      var o = i("b622"), a = o("toStringTag"), l = {};
      l[a] = "z", r.exports = String(l) === "[object z]";
    }, "00fd": function(r, s, i) {
      var o = i("9e69"), a = Object.prototype, l = a.hasOwnProperty, c = a.toString, u = o ? o.toStringTag : void 0;
      function d(f) {
        var p = l.call(f, u), h = f[u];
        try {
          f[u] = void 0;
          var m = !0;
        } catch {
        }
        var v = c.call(f);
        return m && (p ? f[u] = h : delete f[u]), v;
      }
      r.exports = d;
    }, "03dd": function(r, s, i) {
      var o = i("eac5"), a = i("57a5"), l = Object.prototype, c = l.hasOwnProperty;
      function u(d) {
        if (!o(d)) return a(d);
        var f = [];
        for (var p in Object(d)) c.call(d, p) && p != "constructor" && f.push(p);
        return f;
      }
      r.exports = u;
    }, "0459": function(r, s, i) {
      i("643d");
    }, "04f8": function(r, s, i) {
      var o = i("2d00"), a = i("d039"), l = i("da84"), c = l.String;
      r.exports = !!Object.getOwnPropertySymbols && !a(function() {
        var u = Symbol("symbol detection");
        return !c(u) || !(Object(u) instanceof Symbol) || !Symbol.sham && o && o < 41;
      });
    }, "0621": function(r, s, i) {
      var o = i("9e69"), a = i("d370"), l = i("6747"), c = o ? o.isConcatSpreadable : void 0;
      function u(d) {
        return l(d) || a(d) || !!(c && d && d[c]);
      }
      r.exports = u;
    }, "06cf": function(r, s, i) {
      var o = i("83ab"), a = i("c65b"), l = i("d1e7"), c = i("5c6c"), u = i("fc6a"), d = i("a04b"), f = i("1a2d"), p = i("0cfb"), h = Object.getOwnPropertyDescriptor;
      s.f = o ? h : function(m, v) {
        if (m = u(m), v = d(v), p) try {
          return h(m, v);
        } catch {
        }
        if (f(m, v)) return c(!a(l.f, m, v), m[v]);
      };
    }, "0733": function(r, s, i) {
      i.d(s, "a", function() {
        return l;
      });
      var o = i("2fa3"), a = i("9404");
      const l = function(c, u, { maxSwipeTime: d, minHorizontalSwipeDistance: f, maxVerticalSwipeDistance: p }) {
        if (!c || !c.addEventListener || !Object(a.k)(u)) return null;
        let h = 0, m = 0, v = null, y = !1;
        function _(S) {
          const E = S.changedTouches[0];
          h = E.screenX, m = E.screenY, v = (/* @__PURE__ */ new Date()).getTime(), y = !0;
        }
        function w(S) {
          if (!y) return;
          y = !1;
          const E = S.changedTouches[0], x = E.screenX - h, T = E.screenY - m;
          if ((/* @__PURE__ */ new Date()).getTime() - v < d && Math.abs(x) >= f && Math.abs(T) <= p) {
            const k = { toLeft: !1, toRight: !1 };
            x < 0 ? k.toLeft = !0 : k.toRight = !0, u(k);
          }
        }
        return Object(o.k)(c, "touchstart", _, { passive: !0 }), Object(o.k)(c, "touchend", w, { passive: !0 }), function() {
          Object(o.j)(c, "touchstart", _), Object(o.j)(c, "touchend", w);
        };
      };
    }, "07c7": function(r, s) {
      function i() {
        return !1;
      }
      r.exports = i;
    }, "07fa": function(r, s, i) {
      var o = i("50c4");
      r.exports = function(a) {
        return o(a.length);
      };
    }, "083a": function(r, s, i) {
      var o = i("0d51"), a = TypeError;
      r.exports = function(l, c) {
        if (!delete l[c]) throw new a("Cannot delete property " + o(c) + " of " + o(l));
      };
    }, "0840": function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-svg-icon[data-v-63f7b5ec]{display:inline-block;stroke:currentColor;stroke-width:0}.vc-svg-icon path[data-v-63f7b5ec]{fill:currentColor}", ""]), r.exports = s;
    }, "087d": function(r, s) {
      function i(o, a) {
        for (var l = -1, c = a.length, u = o.length; ++l < c; ) o[u + l] = a[l];
        return o;
      }
      r.exports = i;
    }, "08cc": function(r, s, i) {
      var o = i("1a8c");
      function a(l) {
        return l === l && !o(l);
      }
      r.exports = a;
    }, "0b07": function(r, s, i) {
      var o = i("34ac"), a = i("3698");
      function l(c, u) {
        var d = a(c, u);
        return o(d) ? d : void 0;
      }
      r.exports = l;
    }, "0cfb": function(r, s, i) {
      var o = i("83ab"), a = i("d039"), l = i("cc12");
      r.exports = !o && !a(function() {
        return Object.defineProperty(l("div"), "a", { get: function() {
          return 7;
        } }).a !== 7;
      });
    }, "0d24": function(r, s, i) {
      (function(o) {
        var a = i("2b3e"), l = i("07c7"), c = s && !s.nodeType && s, u = c && typeof o == "object" && o && !o.nodeType && o, d = u && u.exports === c, f = d ? a.Buffer : void 0, p = f ? f.isBuffer : void 0, h = p || l;
        o.exports = h;
      }).call(this, i("62e4")(r));
    }, "0d26": function(r, s, i) {
      var o = i("e330"), a = Error, l = o("".replace), c = function(f) {
        return String(new a(f).stack);
      }("zxcasd"), u = /\n\s*at [^:]*:[^\n]*/, d = u.test(c);
      r.exports = function(f, p) {
        if (d && typeof f == "string" && !a.prepareStackTrace) for (; p--; ) f = l(f, u, "");
        return f;
      };
    }, "0d51": function(r, s, i) {
      var o = String;
      r.exports = function(a) {
        try {
          return o(a);
        } catch {
          return "Object";
        }
      };
    }, "0f0f": function(r, s, i) {
      var o = i("8eeb"), a = i("9934");
      function l(c, u) {
        return c && o(u, a(u), c);
      }
      r.exports = l;
    }, "0f5c": function(r, s, i) {
      var o = i("159a");
      function a(l, c, u) {
        return l == null ? l : o(l, c, u);
      }
      r.exports = a;
    }, "0f62": function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-pane-container{width:100%;position:relative}.vc-pane-container.in-transition{overflow:hidden}.vc-pane-layout{display:grid}.vc-arrow{display:flex;justify-content:center;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none;pointer-events:auto;color:var(--gray-600);border-width:2px;border-style:solid;border-radius:var(--rounded);border-color:transparent}.vc-arrow:hover{background:var(--gray-200)}.vc-arrow:focus{border-color:var(--gray-300)}.vc-arrow.is-disabled{opacity:.25;pointer-events:none;cursor:not-allowed}.vc-day-popover-container{color:var(--white);background-color:var(--gray-800);border:1px solid;border-color:var(--gray-700);border-radius:var(--rounded);font-size:var(--text-xs);font-weight:var(--font-medium);padding:4px 8px;box-shadow:var(--shadow)}.vc-day-popover-header{font-size:var(--text-xs);color:var(--gray-300);font-weight:var(--font-semibold);text-align:center}.vc-arrows-container{width:100%;position:absolute;top:0;display:flex;justify-content:space-between;padding:8px 10px;pointer-events:none}.vc-arrows-container.title-left{justify-content:flex-end}.vc-arrows-container.title-right{justify-content:flex-start}.vc-is-dark .vc-arrow{color:var(--white)}.vc-is-dark .vc-arrow:hover{background:var(--gray-800)}.vc-is-dark .vc-arrow:focus{border-color:var(--gray-700)}.vc-is-dark .vc-day-popover-container{color:var(--gray-800);background-color:var(--white);border-color:var(--gray-100)}.vc-is-dark .vc-day-popover-header{color:var(--gray-700)}", ""]), r.exports = s;
    }, "100e": function(r, s, i) {
      var o = i("cd9d"), a = i("2286"), l = i("c1c9");
      function c(u, d) {
        return l(a(u, d, o), u + "");
      }
      r.exports = c;
    }, 1041: function(r, s, i) {
      var o = i("8eeb"), a = i("a029");
      function l(c, u) {
        return o(c, a(c), u);
      }
      r.exports = l;
    }, "116a": function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".none-enter-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c]{transition-duration:0s}.fade-enter-active[data-v-5be4b00c],.fade-leave-active[data-v-5be4b00c],.slide-down-enter-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-enter-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-enter-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-enter-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{transition:transform var(--slide-duration) var(--slide-timing),opacity var(--slide-duration) var(--slide-timing);backface-visibility:hidden}.fade-leave-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{position:absolute;width:100%}.fade-enter[data-v-5be4b00c],.fade-leave-to[data-v-5be4b00c],.none-enter[data-v-5be4b00c],.none-leave-to[data-v-5be4b00c],.slide-down-enter[data-v-5be4b00c],.slide-down-leave-to[data-v-5be4b00c],.slide-left-enter[data-v-5be4b00c],.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{opacity:0}.slide-left-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c]{transform:translateX(var(--slide-translate))}.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c]{transform:translateX(calc(var(--slide-translate)*-1))}.slide-down-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c]{transform:translateY(var(--slide-translate))}.slide-down-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{transform:translateY(calc(var(--slide-translate)*-1))}", ""]), r.exports = s;
    }, 1205: function(r, s, i) {
      var o = i("b7f0");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("181b238b", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, 1290: function(r, s) {
      function i(o) {
        var a = typeof o;
        return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? o !== "__proto__" : o === null;
      }
      r.exports = i;
    }, 1310: function(r, s) {
      function i(o) {
        return o != null && typeof o == "object";
      }
      r.exports = i;
    }, 1315: function(r, s, i) {
      i.d(s, "a", function() {
        return h;
      }), i("13d5");
      var o = i("8bbf"), a = i.n(o), l = i("9404");
      function c(m) {
        return Object(l.n)(m) && (m = { min: m }), Object(l.h)(m) || (m = [m]), m.map(function(v) {
          return Object(l.e)(v, "raw") ? v.raw : Object(l.q)(v, function(y, _) {
            return _ = Object(l.d)({ min: "min-width", max: "max-width" }, _, _), `(${_}: ${y})`;
          }).join(" and ");
        }).join(", ");
      }
      var u = i("85a9");
      let d = !1, f = !1, p = null;
      function h(m = u, v) {
        p && !v || d || (d = !0, f = !0, p = new a.a({ data() {
          return { matches: [], queries: [] };
        }, methods: { refreshQueries() {
          var y = this;
          window && window.matchMedia && (this.queries = Object(l.r)(m, function(_) {
            const w = window.matchMedia(c(_));
            return Object(l.k)(w.addEventListener) ? w.addEventListener("change", y.refreshMatches) : w.addListener(y.refreshMatches), w;
          }), this.refreshMatches());
        }, refreshMatches() {
          this.matches = Object(l.w)(this.queries).filter(function(y) {
            return y[1].matches;
          }).map(function(y) {
            return y[0];
          });
        } } }), d = !1);
      }
      a.a.mixin({ beforeCreate() {
        d || h();
      }, mounted() {
        f && p && (p.refreshQueries(), f = !1);
      }, computed: { $screens() {
        return function(m, v) {
          return p.matches.reduce(function(y, _) {
            return Object(l.e)(m, _) ? m[_] : y;
          }, Object(l.o)(v) ? m.default : v);
        };
      } } });
    }, 1368: function(r, s, i) {
      var o = i("da03"), a = function() {
        var c = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
        return c ? "Symbol(src)_1." + c : "";
      }();
      function l(c) {
        return !!a && a in c;
      }
      r.exports = l;
    }, "13d2": function(r, s, i) {
      var o = i("e330"), a = i("d039"), l = i("1626"), c = i("1a2d"), u = i("83ab"), d = i("5e77").CONFIGURABLE, f = i("8925"), p = i("69f3"), h = p.enforce, m = p.get, v = String, y = Object.defineProperty, _ = o("".slice), w = o("".replace), S = o([].join), E = u && !a(function() {
        return y(function() {
        }, "length", { value: 8 }).length !== 8;
      }), x = String(String).split("String"), T = r.exports = function(C, k, b) {
        _(v(k), 0, 7) === "Symbol(" && (k = "[" + w(v(k), /^Symbol\(([^)]*)\)/, "$1") + "]"), b && b.getter && (k = "get " + k), b && b.setter && (k = "set " + k), (!c(C, "name") || d && C.name !== k) && (u ? y(C, "name", { value: k, configurable: !0 }) : C.name = k), E && b && c(b, "arity") && C.length !== b.arity && y(C, "length", { value: b.arity });
        try {
          b && c(b, "constructor") && b.constructor ? u && y(C, "prototype", { writable: !1 }) : C.prototype && (C.prototype = void 0);
        } catch {
        }
        var P = h(C);
        return c(P, "source") || (P.source = S(x, typeof k == "string" ? k : "")), C;
      };
      Function.prototype.toString = T(function() {
        return l(this) && m(this).source || f(this);
      }, "toString");
    }, "13d5": function(r, s, i) {
      var o = i("23e7"), a = i("d58f").left, l = i("a640"), c = i("2d00"), u = i("605d"), d = !u && c > 79 && c < 83, f = d || !l("reduce");
      o({ target: "Array", proto: !0, forced: f }, { reduce: function(p) {
        var h = arguments.length;
        return a(this, p, h, h > 1 ? arguments[1] : void 0);
      } });
    }, "14d9": function(r, s, i) {
      var o = i("23e7"), a = i("7b0b"), l = i("07fa"), c = i("3a34"), u = i("3511"), d = i("d039"), f = d(function() {
        return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
      }), p = function() {
        try {
          Object.defineProperty([], "length", { writable: !1 }).push();
        } catch (m) {
          return m instanceof TypeError;
        }
      }, h = f || !p();
      o({ target: "Array", proto: !0, arity: 1, forced: h }, { push: function(m) {
        var v = a(this), y = l(v), _ = arguments.length;
        u(y + _);
        for (var w = 0; w < _; w++) v[y] = arguments[w], y++;
        return c(v, y), y;
      } });
    }, "159a": function(r, s, i) {
      var o = i("32b3"), a = i("e2e4"), l = i("c098"), c = i("1a8c"), u = i("f4d6");
      function d(f, p, h, m) {
        if (!c(f)) return f;
        p = a(p, f);
        for (var v = -1, y = p.length, _ = y - 1, w = f; w != null && ++v < y; ) {
          var S = u(p[v]), E = h;
          if (S === "__proto__" || S === "constructor" || S === "prototype") return f;
          if (v != _) {
            var x = w[S];
            E = m ? m(x, S, w) : void 0, E === void 0 && (E = c(x) ? x : l(p[v + 1]) ? [] : {});
          }
          o(w, S, E), w = w[S];
        }
        return f;
      }
      r.exports = d;
    }, "15f3": function(r, s, i) {
      var o = i("89d9"), a = i("8604");
      function l(c, u) {
        return o(c, u, function(d, f) {
          return a(c, f);
        });
      }
      r.exports = l;
    }, 1626: function(r, s, i) {
      var o = i("8ea1"), a = o.all;
      r.exports = o.IS_HTMLDDA ? function(l) {
        return typeof l == "function" || l === a;
      } : function(l) {
        return typeof l == "function";
      };
    }, 1838: function(r, s, i) {
      var o = i("c05f"), a = i("9b02"), l = i("8604"), c = i("f608"), u = i("08cc"), d = i("20ec"), f = i("f4d6"), p = 1, h = 2;
      function m(v, y) {
        return c(v) && u(y) ? d(f(v), y) : function(_) {
          var w = a(_, v);
          return w === void 0 && w === y ? l(_, v) : o(y, w, p | h);
        };
      }
      r.exports = m;
    }, "18d8": function(r, s, i) {
      var o = i("234d"), a = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, l = /\\(\\)?/g, c = o(function(u) {
        var d = [];
        return u.charCodeAt(0) === 46 && d.push(""), u.replace(a, function(f, p, h, m) {
          d.push(h ? m.replace(l, "$1") : p || f);
        }), d;
      });
      r.exports = c;
    }, "1a2d": function(r, s, i) {
      var o = i("e330"), a = i("7b0b"), l = o({}.hasOwnProperty);
      r.exports = Object.hasOwn || function(c, u) {
        return l(a(c), u);
      };
    }, "1a2d0": function(r, s, i) {
      var o = i("42a2"), a = i("1310"), l = "[object Map]";
      function c(u) {
        return a(u) && o(u) == l;
      }
      r.exports = c;
    }, "1a8c": function(r, s) {
      function i(o) {
        var a = typeof o;
        return o != null && (a == "object" || a == "function");
      }
      r.exports = i;
    }, "1bac": function(r, s, i) {
      var o = i("7d1f"), a = i("a029"), l = i("9934");
      function c(u) {
        return o(u, l, a);
      }
      r.exports = c;
    }, "1c3c": function(r, s, i) {
      var o = i("9e69"), a = i("2474"), l = i("9638"), c = i("a2be"), u = i("edfa"), d = i("ac41"), f = 1, p = 2, h = "[object Boolean]", m = "[object Date]", v = "[object Error]", y = "[object Map]", _ = "[object Number]", w = "[object RegExp]", S = "[object Set]", E = "[object String]", x = "[object Symbol]", T = "[object ArrayBuffer]", C = "[object DataView]", k = o ? o.prototype : void 0, b = k ? k.valueOf : void 0;
      function P(N, D, H, Y, te, A, j) {
        switch (H) {
          case C:
            if (N.byteLength != D.byteLength || N.byteOffset != D.byteOffset) return !1;
            N = N.buffer, D = D.buffer;
          case T:
            return !(N.byteLength != D.byteLength || !A(new a(N), new a(D)));
          case h:
          case m:
          case _:
            return l(+N, +D);
          case v:
            return N.name == D.name && N.message == D.message;
          case w:
          case E:
            return N == D + "";
          case y:
            var L = u;
          case S:
            var se = Y & f;
            if (L || (L = d), N.size != D.size && !se) return !1;
            var V = j.get(N);
            if (V) return V == D;
            Y |= p, j.set(N, D);
            var ee = c(L(N), L(D), Y, te, A, j);
            return j.delete(N), ee;
          case x:
            if (b) return b.call(N) == b.call(D);
        }
        return !1;
      }
      r.exports = P;
    }, "1c6b": function(r, s, i) {
      i("7d87");
    }, "1cec": function(r, s, i) {
      var o = i("0b07"), a = i("2b3e"), l = o(a, "Promise");
      r.exports = l;
    }, "1d80": function(r, s, i) {
      var o = i("7234"), a = TypeError;
      r.exports = function(l) {
        if (o(l)) throw new a("Can't call method on " + l);
        return l;
      };
    }, "1efc": function(r, s) {
      function i(o) {
        var a = this.has(o) && delete this.__data__[o];
        return this.size -= a ? 1 : 0, a;
      }
      r.exports = i;
    }, "1fc8": function(r, s, i) {
      var o = i("4245");
      function a(l, c) {
        var u = o(this, l), d = u.size;
        return u.set(l, c), this.size += u.size == d ? 0 : 1, this;
      }
      r.exports = a;
    }, "20ec": function(r, s) {
      function i(o, a) {
        return function(l) {
          return l != null && l[o] === a && (a !== void 0 || o in Object(l));
        };
      }
      r.exports = i;
    }, 2286: function(r, s, i) {
      var o = i("85e3"), a = Math.max;
      function l(c, u, d) {
        return u = a(u === void 0 ? c.length - 1 : u, 0), function() {
          for (var f = arguments, p = -1, h = a(f.length - u, 0), m = Array(h); ++p < h; ) m[p] = f[u + p];
          p = -1;
          for (var v = Array(u + 1); ++p < u; ) v[p] = f[p];
          return v[u] = d(m), o(c, this, v);
        };
      }
      r.exports = l;
    }, "22f3": function(r, s, i) {
      i.d(s, "a", function() {
        return c;
      }), i("14d9");
      var o = i("cfe5"), a = i("2fa3"), l = i("9404");
      class c {
        constructor({ key: d, hashcode: f, highlight: p, content: h, dot: m, bar: v, popover: y, dates: _, excludeDates: w, excludeMode: S, customData: E, order: x, pinPage: T }, C, k) {
          this.key = Object(l.o)(d) ? Object(a.c)() : d, this.hashcode = f, this.customData = E, this.order = x || 0, this.dateOpts = { order: x, locale: k }, this.pinPage = T, p && (this.highlight = C.normalizeHighlight(p)), h && (this.content = C.normalizeContent(h)), m && (this.dot = C.normalizeDot(m)), v && (this.bar = C.normalizeBar(v)), y && (this.popover = y), this.dates = k.normalizeDates(_, this.dateOpts), this.hasDates = !!Object(a.b)(this.dates), this.excludeDates = k.normalizeDates(w, this.dateOpts), this.hasExcludeDates = !!Object(a.b)(this.excludeDates), this.excludeMode = S || "intersects", this.hasExcludeDates && !this.hasDates && (this.dates.push(new o.a({}, this.dateOpts)), this.hasDates = !0), this.isComplex = Object(l.v)(this.dates, function(b) {
            return b.isComplex;
          });
        }
        intersectsDate(d) {
          return d = d instanceof o.a ? d : new o.a(d, this.dateOpts), !this.excludesDate(d) && (this.dates.find(function(f) {
            return f.intersectsDate(d);
          }) || !1);
        }
        includesDate(d) {
          return d = d instanceof o.a ? d : new o.a(d, this.dateOpts), !this.excludesDate(d) && (this.dates.find(function(f) {
            return f.includesDate(d);
          }) || !1);
        }
        excludesDate(d) {
          var f = this;
          return d = d instanceof o.a ? d : new o.a(d, this.dateOpts), this.hasExcludeDates && this.excludeDates.find(function(p) {
            return f.excludeMode === "intersects" && p.intersectsDate(d) || f.excludeMode === "includes" && p.includesDate(d);
          });
        }
        intersectsDay(d) {
          return !this.excludesDay(d) && (this.dates.find(function(f) {
            return f.intersectsDay(d);
          }) || !1);
        }
        excludesDay(d) {
          return this.hasExcludeDates && this.excludeDates.find(function(f) {
            return f.intersectsDay(d);
          });
        }
      }
    }, "234d": function(r, s, i) {
      var o = i("e380"), a = 500;
      function l(c) {
        var u = o(c, function(f) {
          return d.size === a && d.clear(), f;
        }), d = u.cache;
        return u;
      }
      r.exports = l;
    }, "23a5": function(r) {
      r.exports = JSON.parse('{"maxSwipeTime":300,"minHorizontalSwipeDistance":60,"maxVerticalSwipeDistance":80}');
    }, "23cb": function(r, s, i) {
      var o = i("5926"), a = Math.max, l = Math.min;
      r.exports = function(c, u) {
        var d = o(c);
        return d < 0 ? a(d + u, 0) : l(d, u);
      };
    }, "23da": function(r, s, i) {
      var o = i("3963");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("9371b050", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, "23e7": function(r, s, i) {
      var o = i("da84"), a = i("06cf").f, l = i("9112"), c = i("cb2d"), u = i("6374"), d = i("e893"), f = i("94ca");
      r.exports = function(p, h) {
        var m, v, y, _, w, S, E = p.target, x = p.global, T = p.stat;
        if (v = x ? o : T ? o[E] || u(E, {}) : (o[E] || {}).prototype, v) for (y in h) {
          if (w = h[y], p.dontCallGetSet ? (S = a(v, y), _ = S && S.value) : _ = v[y], m = f(x ? y : E + (T ? "." : "#") + y, p.forced), !m && _ !== void 0) {
            if (typeof w == typeof _) continue;
            d(w, _);
          }
          (p.sham || _ && _.sham) && l(w, "sham", !0), c(v, y, w, p);
        }
      };
    }, 2411: function(r, s, i) {
      var o = i("f909"), a = i("2ec1"), l = a(function(c, u, d, f) {
        o(c, u, d, f);
      });
      r.exports = l;
    }, "241c": function(r, s, i) {
      var o = i("ca84"), a = i("7839"), l = a.concat("length", "prototype");
      s.f = Object.getOwnPropertyNames || function(c) {
        return o(c, l);
      };
    }, "242e": function(r, s, i) {
      var o = i("72af"), a = i("ec69");
      function l(c, u) {
        return c && o(c, u, a);
      }
      r.exports = l;
    }, 2474: function(r, s, i) {
      var o = i("2b3e"), a = o.Uint8Array;
      r.exports = a;
    }, 2478: function(r, s, i) {
      var o = i("4245");
      function a(l) {
        return o(this, l).get(l);
      }
      r.exports = a;
    }, "24fb": function(r, s, i) {
      function o(l, c) {
        var u = l[1] || "", d = l[3];
        if (!d) return u;
        if (c && typeof btoa == "function") {
          var f = a(d), p = d.sources.map(function(h) {
            return "/*# sourceURL=".concat(d.sourceRoot || "").concat(h, " */");
          });
          return [u].concat(p).concat([f]).join(`
`);
        }
        return [u].join(`
`);
      }
      function a(l) {
        var c = btoa(unescape(encodeURIComponent(JSON.stringify(l)))), u = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(c);
        return "/*# ".concat(u, " */");
      }
      r.exports = function(l) {
        var c = [];
        return c.toString = function() {
          return this.map(function(u) {
            var d = o(u, l);
            return u[2] ? "@media ".concat(u[2], " {").concat(d, "}") : d;
          }).join("");
        }, c.i = function(u, d, f) {
          typeof u == "string" && (u = [[null, u, ""]]);
          var p = {};
          if (f) for (var h = 0; h < this.length; h++) {
            var m = this[h][0];
            m != null && (p[m] = !0);
          }
          for (var v = 0; v < u.length; v++) {
            var y = [].concat(u[v]);
            f && p[y[0]] || (d && (y[2] ? y[2] = "".concat(d, " and ").concat(y[2]) : y[2] = d), c.push(y));
          }
        }, c;
      };
    }, 2524: function(r, s, i) {
      var o = i("6044"), a = "__lodash_hash_undefined__";
      function l(c, u) {
        var d = this.__data__;
        return this.size += this.has(c) ? 0 : 1, d[c] = o && u === void 0 ? a : u, this;
      }
      r.exports = l;
    }, "253c": function(r, s, i) {
      var o = i("3729"), a = i("1310"), l = "[object Arguments]";
      function c(u) {
        return a(u) && o(u) == l;
      }
      r.exports = c;
    }, 2593: function(r, s, i) {
      var o = i("15f3"), a = i("c6cf"), l = a(function(c, u) {
        return c == null ? {} : o(c, u);
      });
      r.exports = l;
    }, "26e8": function(r, s) {
      function i(o, a) {
        return o != null && a in Object(o);
      }
      r.exports = i;
    }, 2745: function(r, s, i) {
      i("5332");
    }, "28c9": function(r, s) {
      function i() {
        this.__data__ = [], this.size = 0;
      }
      r.exports = i;
    }, "29ae": function(r, s, i) {
      i.d(s, "a", function() {
        return Fs;
      }), i.d(s, "b", function() {
        return rs;
      }), i("14d9"), i("d9e2"), i("13d5");
      var o = i("2cfd"), a = i.n(o), l = i("5465"), c = i.n(l);
      function u(X, R) {
        var Z = m(R);
        return Z.formatToParts ? f(Z, X) : p(Z, X);
      }
      var d = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 };
      function f(X, R) {
        try {
          for (var Z = X.formatToParts(R), ne = [], we = 0; we < Z.length; we++) {
            var be = d[Z[we].type];
            be >= 0 && (ne[be] = parseInt(Z[we].value, 10));
          }
          return ne;
        } catch (Le) {
          if (Le instanceof RangeError) return [NaN];
          throw Le;
        }
      }
      function p(X, R) {
        var Z = X.format(R).replace(/\u200E/g, ""), ne = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(Z);
        return [ne[3], ne[1], ne[2], ne[4], ne[5], ne[6]];
      }
      var h = {};
      function m(X) {
        if (!h[X]) {
          var R = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: "America/New_York", year: "numeric", month: "numeric", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Z = R === "06/25/2014, 00:00:00" || R === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
          h[X] = Z ? new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: X, year: "numeric", month: "numeric", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : new Intl.DateTimeFormat("en-US", { hourCycle: "h23", timeZone: X, year: "numeric", month: "numeric", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
        }
        return h[X];
      }
      function v(X, R, Z, ne, we, be, Le) {
        var Xe = /* @__PURE__ */ new Date(0);
        return Xe.setUTCFullYear(X, R, Z), Xe.setUTCHours(ne, we, be, Le), Xe;
      }
      var y = 36e5, _ = 6e4, w = { timezone: /([Z+-].*)$/, timezoneZ: /^(Z)$/, timezoneHH: /^([+-]\d{2})$/, timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/ };
      function S(X, R, Z) {
        var ne, we, be;
        if (!X || (ne = w.timezoneZ.exec(X), ne)) return 0;
        if (ne = w.timezoneHH.exec(X), ne) return be = parseInt(ne[1], 10), C(be) ? -be * y : NaN;
        if (ne = w.timezoneHHMM.exec(X), ne) {
          be = parseInt(ne[1], 10);
          var Le = parseInt(ne[2], 10);
          return C(be, Le) ? (we = Math.abs(be) * y + Le * _, be > 0 ? -we : we) : NaN;
        }
        if (b(X)) {
          R = new Date(R || Date.now());
          var Xe = E(R), je = x(Xe, X), vt = T(R, je, X);
          return -vt;
        }
        return NaN;
      }
      function E(X) {
        return v(X.getFullYear(), X.getMonth(), X.getDate(), X.getHours(), X.getMinutes(), X.getSeconds(), X.getMilliseconds());
      }
      function x(X, R) {
        var Z = u(X, R), ne = v(Z[0], Z[1] - 1, Z[2], Z[3] % 24, Z[4], Z[5], 0).getTime(), we = X.getTime(), be = we % 1e3;
        return we -= be >= 0 ? be : 1e3 + be, ne - we;
      }
      function T(X, R, Z) {
        var ne = X.getTime(), we = ne - R, be = x(new Date(we), Z);
        if (R === be) return R;
        we -= be - R;
        var Le = x(new Date(we), Z);
        return be === Le ? be : Math.max(be, Le);
      }
      function C(X, R) {
        return -23 <= X && X <= 23 && (R == null || 0 <= R && R <= 59);
      }
      var k = {};
      function b(X) {
        if (k[X]) return !0;
        try {
          return new Intl.DateTimeFormat(void 0, { timeZone: X }), k[X] = !0, !0;
        } catch {
          return !1;
        }
      }
      var P = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, N = P, D = 36e5, H = 6e4, Y = 2, te = { dateTimePattern: /^([0-9W+-]+)(T| )(.*)/, datePattern: /^([0-9W+-]+)(.*)/, plainTime: /:/, YY: /^(\d{2})$/, YYY: [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/], YYYY: /^(\d{4})/, YYYYY: [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/], MM: /^-(\d{2})$/, DDD: /^-?(\d{3})$/, MMDD: /^-?(\d{2})-?(\d{2})$/, Www: /^-?W(\d{2})$/, WwwD: /^-?W(\d{2})-?(\d{1})$/, HH: /^(\d{2}([.,]\d*)?)$/, HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/, HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/, timeZone: N };
      function A(X, R) {
        if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
        if (X === null) return /* @__PURE__ */ new Date(NaN);
        var Z = R || {}, ne = Z.additionalDigits == null ? Y : a()(Z.additionalDigits);
        if (ne !== 2 && ne !== 1 && ne !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
        if (X instanceof Date || typeof X == "object" && Object.prototype.toString.call(X) === "[object Date]") return new Date(X.getTime());
        if (typeof X == "number" || Object.prototype.toString.call(X) === "[object Number]") return new Date(X);
        if (typeof X != "string" && Object.prototype.toString.call(X) !== "[object String]") return /* @__PURE__ */ new Date(NaN);
        var we = j(X), be = L(we.date, ne), Le = be.year, Xe = be.restDateString, je = se(Xe, Le);
        if (isNaN(je)) return /* @__PURE__ */ new Date(NaN);
        if (je) {
          var vt, Pt = je.getTime(), De = 0;
          if (we.time && (De = V(we.time), isNaN(De))) return /* @__PURE__ */ new Date(NaN);
          if (we.timeZone || Z.timeZone) {
            if (vt = S(we.timeZone || Z.timeZone, new Date(Pt + De)), isNaN(vt)) return /* @__PURE__ */ new Date(NaN);
          } else vt = c()(new Date(Pt + De)), vt = c()(new Date(Pt + De + vt));
          return new Date(Pt + De + vt);
        }
        return /* @__PURE__ */ new Date(NaN);
      }
      function j(X) {
        var R, Z = {}, ne = te.dateTimePattern.exec(X);
        if (ne ? (Z.date = ne[1], R = ne[3]) : (ne = te.datePattern.exec(X), ne ? (Z.date = ne[1], R = ne[2]) : (Z.date = null, R = X)), R) {
          var we = te.timeZone.exec(R);
          we ? (Z.time = R.replace(we[1], ""), Z.timeZone = we[1].trim()) : Z.time = R;
        }
        return Z;
      }
      function L(X, R) {
        var Z, ne = te.YYY[R], we = te.YYYYY[R];
        if (Z = te.YYYY.exec(X) || we.exec(X), Z) {
          var be = Z[1];
          return { year: parseInt(be, 10), restDateString: X.slice(be.length) };
        }
        if (Z = te.YY.exec(X) || ne.exec(X), Z) {
          var Le = Z[1];
          return { year: 100 * parseInt(Le, 10), restDateString: X.slice(Le.length) };
        }
        return { year: null };
      }
      function se(X, R) {
        if (R === null) return null;
        var Z, ne, we, be;
        if (X.length === 0) return ne = /* @__PURE__ */ new Date(0), ne.setUTCFullYear(R), ne;
        if (Z = te.MM.exec(X), Z) return ne = /* @__PURE__ */ new Date(0), we = parseInt(Z[1], 10) - 1, q(R, we) ? (ne.setUTCFullYear(R, we), ne) : /* @__PURE__ */ new Date(NaN);
        if (Z = te.DDD.exec(X), Z) {
          ne = /* @__PURE__ */ new Date(0);
          var Le = parseInt(Z[1], 10);
          return ae(R, Le) ? (ne.setUTCFullYear(R, 0, Le), ne) : /* @__PURE__ */ new Date(NaN);
        }
        if (Z = te.MMDD.exec(X), Z) {
          ne = /* @__PURE__ */ new Date(0), we = parseInt(Z[1], 10) - 1;
          var Xe = parseInt(Z[2], 10);
          return q(R, we, Xe) ? (ne.setUTCFullYear(R, we, Xe), ne) : /* @__PURE__ */ new Date(NaN);
        }
        if (Z = te.Www.exec(X), Z) return be = parseInt(Z[1], 10) - 1, Ee(R, be) ? ee(R, be) : /* @__PURE__ */ new Date(NaN);
        if (Z = te.WwwD.exec(X), Z) {
          be = parseInt(Z[1], 10) - 1;
          var je = parseInt(Z[2], 10) - 1;
          return Ee(R, be, je) ? ee(R, be, je) : /* @__PURE__ */ new Date(NaN);
        }
        return null;
      }
      function V(X) {
        var R, Z, ne;
        if (R = te.HH.exec(X), R) return Z = parseFloat(R[1].replace(",", ".")), Ae(Z) ? Z % 24 * D : NaN;
        if (R = te.HHMM.exec(X), R) return Z = parseInt(R[1], 10), ne = parseFloat(R[2].replace(",", ".")), Ae(Z, ne) ? Z % 24 * D + ne * H : NaN;
        if (R = te.HHMMSS.exec(X), R) {
          Z = parseInt(R[1], 10), ne = parseInt(R[2], 10);
          var we = parseFloat(R[3].replace(",", "."));
          return Ae(Z, ne, we) ? Z % 24 * D + ne * H + 1e3 * we : NaN;
        }
        return null;
      }
      function ee(X, R, Z) {
        R = R || 0, Z = Z || 0;
        var ne = /* @__PURE__ */ new Date(0);
        ne.setUTCFullYear(X, 0, 4);
        var we = ne.getUTCDay() || 7, be = 7 * R + Z + 1 - we;
        return ne.setUTCDate(ne.getUTCDate() + be), ne;
      }
      var O = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], K = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function z(X) {
        return X % 400 === 0 || X % 4 === 0 && X % 100 !== 0;
      }
      function q(X, R, Z) {
        if (R < 0 || R > 11) return !1;
        if (Z != null) {
          if (Z < 1) return !1;
          var ne = z(X);
          if (ne && Z > K[R] || !ne && Z > O[R]) return !1;
        }
        return !0;
      }
      function ae(X, R) {
        if (R < 1) return !1;
        var Z = z(X);
        return !(Z && R > 366) && !(!Z && R > 365);
      }
      function Ee(X, R, Z) {
        return !(R < 0 || R > 52) && (Z == null || !(Z < 0 || Z > 6));
      }
      function Ae(X, R, Z) {
        return (X == null || !(X < 0 || X >= 25)) && (R == null || !(R < 0 || R >= 60)) && (Z == null || !(Z < 0 || Z >= 60));
      }
      var Ue = i("fd3a"), qe = i("fe1f"), Qe = i("8c86"), Lt = {};
      function Yt() {
        return Lt;
      }
      function nn(X, R) {
        var Z, ne, we, be, Le, Xe, je, vt;
        Object(Qe.a)(1, arguments);
        var Pt = Yt(), De = Object(qe.a)((Z = (ne = (we = (be = R == null ? void 0 : R.weekStartsOn) !== null && be !== void 0 ? be : R == null || (Le = R.locale) === null || Le === void 0 || (Xe = Le.options) === null || Xe === void 0 ? void 0 : Xe.weekStartsOn) !== null && we !== void 0 ? we : Pt.weekStartsOn) !== null && ne !== void 0 ? ne : (je = Pt.locale) === null || je === void 0 || (vt = je.options) === null || vt === void 0 ? void 0 : vt.weekStartsOn) !== null && Z !== void 0 ? Z : 0);
        if (!(De >= 0 && De <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        var Q = Object(Ue.a)(X), _e = Q.getDay(), Be = (_e < De ? 7 : 0) + _e - De;
        return Q.setDate(Q.getDate() - Be), Q.setHours(0, 0, 0, 0), Q;
      }
      function qt(X) {
        return Object(Qe.a)(1, arguments), nn(X, { weekStartsOn: 1 });
      }
      function rn(X) {
        Object(Qe.a)(1, arguments);
        var R = Object(Ue.a)(X), Z = R.getFullYear(), ne = /* @__PURE__ */ new Date(0);
        ne.setFullYear(Z + 1, 0, 4), ne.setHours(0, 0, 0, 0);
        var we = qt(ne), be = /* @__PURE__ */ new Date(0);
        be.setFullYear(Z, 0, 4), be.setHours(0, 0, 0, 0);
        var Le = qt(be);
        return R.getTime() >= we.getTime() ? Z + 1 : R.getTime() >= Le.getTime() ? Z : Z - 1;
      }
      function sn(X) {
        Object(Qe.a)(1, arguments);
        var R = rn(X), Z = /* @__PURE__ */ new Date(0);
        Z.setFullYear(R, 0, 4), Z.setHours(0, 0, 0, 0);
        var ne = qt(Z);
        return ne;
      }
      var zn = 6048e5;
      function ns(X) {
        Object(Qe.a)(1, arguments);
        var R = Object(Ue.a)(X), Z = qt(R).getTime() - sn(R).getTime();
        return Math.round(Z / zn) + 1;
      }
      function Nt(X, R) {
        var Z, ne, we, be, Le, Xe, je, vt;
        Object(Qe.a)(1, arguments);
        var Pt = Object(Ue.a)(X), De = Pt.getFullYear(), Q = Yt(), _e = Object(qe.a)((Z = (ne = (we = (be = R == null ? void 0 : R.firstWeekContainsDate) !== null && be !== void 0 ? be : R == null || (Le = R.locale) === null || Le === void 0 || (Xe = Le.options) === null || Xe === void 0 ? void 0 : Xe.firstWeekContainsDate) !== null && we !== void 0 ? we : Q.firstWeekContainsDate) !== null && ne !== void 0 ? ne : (je = Q.locale) === null || je === void 0 || (vt = je.options) === null || vt === void 0 ? void 0 : vt.firstWeekContainsDate) !== null && Z !== void 0 ? Z : 1);
        if (!(_e >= 1 && _e <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        var Be = /* @__PURE__ */ new Date(0);
        Be.setFullYear(De + 1, 0, _e), Be.setHours(0, 0, 0, 0);
        var Ht = nn(Be, R), at = /* @__PURE__ */ new Date(0);
        at.setFullYear(De, 0, _e), at.setHours(0, 0, 0, 0);
        var Vt = nn(at, R);
        return Pt.getTime() >= Ht.getTime() ? De + 1 : Pt.getTime() >= Vt.getTime() ? De : De - 1;
      }
      function dt(X, R) {
        var Z, ne, we, be, Le, Xe, je, vt;
        Object(Qe.a)(1, arguments);
        var Pt = Yt(), De = Object(qe.a)((Z = (ne = (we = (be = R == null ? void 0 : R.firstWeekContainsDate) !== null && be !== void 0 ? be : R == null || (Le = R.locale) === null || Le === void 0 || (Xe = Le.options) === null || Xe === void 0 ? void 0 : Xe.firstWeekContainsDate) !== null && we !== void 0 ? we : Pt.firstWeekContainsDate) !== null && ne !== void 0 ? ne : (je = Pt.locale) === null || je === void 0 || (vt = je.options) === null || vt === void 0 ? void 0 : vt.firstWeekContainsDate) !== null && Z !== void 0 ? Z : 1), Q = Nt(X, R), _e = /* @__PURE__ */ new Date(0);
        _e.setFullYear(Q, 0, De), _e.setHours(0, 0, 0, 0);
        var Be = nn(_e, R);
        return Be;
      }
      var xt = 6048e5;
      function Wt(X, R) {
        Object(Qe.a)(1, arguments);
        var Z = Object(Ue.a)(X), ne = nn(Z, R).getTime() - dt(Z, R).getTime();
        return Math.round(ne / xt) + 1;
      }
      function Tt(X) {
        var R = new Date(Date.UTC(X.getFullYear(), X.getMonth(), X.getDate(), X.getHours(), X.getMinutes(), X.getSeconds(), X.getMilliseconds()));
        return R.setUTCFullYear(X.getFullYear()), X.getTime() - R.getTime();
      }
      var _r = 6048e5;
      function dr(X, R, Z) {
        Object(Qe.a)(2, arguments);
        var ne = nn(X, Z), we = nn(R, Z), be = ne.getTime() - Tt(ne), Le = we.getTime() - Tt(we);
        return Math.round((be - Le) / _r);
      }
      function qn(X) {
        Object(Qe.a)(1, arguments);
        var R = Object(Ue.a)(X), Z = R.getMonth();
        return R.setFullYear(R.getFullYear(), Z + 1, 0), R.setHours(0, 0, 0, 0), R;
      }
      function yn(X) {
        Object(Qe.a)(1, arguments);
        var R = Object(Ue.a)(X);
        return R.setDate(1), R.setHours(0, 0, 0, 0), R;
      }
      function Ve(X, R) {
        return Object(Qe.a)(1, arguments), dr(qn(X), yn(X), R) + 1;
      }
      var Ze = i("f7f1"), it = i("cfe5"), St = i("f15d"), ze = i("2fa3"), $t = i("9404");
      const Fs = { DATE_TIME: 1, DATE: 2, TIME: 3 }, zs = { 1: ["year", "month", "day", "hours", "minutes", "seconds", "milliseconds"], 2: ["year", "month", "day"], 3: ["hours", "minutes", "seconds", "milliseconds"] }, fr = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, ln = /\d\d?/, wn = /\d{3}/, sa = /\d{4}/, ws = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, ia = /\[([^]*?)\]/gm, oa = function() {
      }, An = function(X) {
        return function(R, Z, ne) {
          const we = ne[X].indexOf(Z.charAt(0).toUpperCase() + Z.substr(1).toLowerCase());
          ~we && (R.month = we);
        };
      }, Us = ["L", "iso"], pr = 7, aa = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], No = [{ value: 0, label: "00" }, { value: 1, label: "01" }, { value: 2, label: "02" }, { value: 3, label: "03" }, { value: 4, label: "04" }, { value: 5, label: "05" }, { value: 6, label: "06" }, { value: 7, label: "07" }, { value: 8, label: "08" }, { value: 9, label: "09" }, { value: 10, label: "10" }, { value: 11, label: "11" }, { value: 12, label: "12" }, { value: 13, label: "13" }, { value: 14, label: "14" }, { value: 15, label: "15" }, { value: 16, label: "16" }, { value: 17, label: "17" }, { value: 18, label: "18" }, { value: 19, label: "19" }, { value: 20, label: "20" }, { value: 21, label: "21" }, { value: 22, label: "22" }, { value: 23, label: "23" }], $o = { D(X) {
        return X.day;
      }, DD(X) {
        return Object(ze.m)(X.day);
      }, Do(X, R) {
        return R.DoFn(X.day);
      }, d(X) {
        return X.weekday - 1;
      }, dd(X) {
        return Object(ze.m)(X.weekday - 1);
      }, W(X, R) {
        return R.dayNamesNarrow[X.weekday - 1];
      }, WW(X, R) {
        return R.dayNamesShorter[X.weekday - 1];
      }, WWW(X, R) {
        return R.dayNamesShort[X.weekday - 1];
      }, WWWW(X, R) {
        return R.dayNames[X.weekday - 1];
      }, M(X) {
        return X.month;
      }, MM(X) {
        return Object(ze.m)(X.month);
      }, MMM(X, R) {
        return R.monthNamesShort[X.month - 1];
      }, MMMM(X, R) {
        return R.monthNames[X.month - 1];
      }, YY(X) {
        return String(X.year).substr(2);
      }, YYYY(X) {
        return Object(ze.m)(X.year, 4);
      }, h(X) {
        return X.hours % 12 || 12;
      }, hh(X) {
        return Object(ze.m)(X.hours % 12 || 12);
      }, H(X) {
        return X.hours;
      }, HH(X) {
        return Object(ze.m)(X.hours);
      }, m(X) {
        return X.minutes;
      }, mm(X) {
        return Object(ze.m)(X.minutes);
      }, s(X) {
        return X.seconds;
      }, ss(X) {
        return Object(ze.m)(X.seconds);
      }, S(X) {
        return Math.round(X.milliseconds / 100);
      }, SS(X) {
        return Object(ze.m)(Math.round(X.milliseconds / 10), 2);
      }, SSS(X) {
        return Object(ze.m)(X.milliseconds, 3);
      }, a(X, R) {
        return X.hours < 12 ? R.amPm[0] : R.amPm[1];
      }, A(X, R) {
        return X.hours < 12 ? R.amPm[0].toUpperCase() : R.amPm[1].toUpperCase();
      }, Z() {
        return "Z";
      }, ZZ(X) {
        const R = X.timezoneOffset;
        return `${R > 0 ? "-" : "+"}${Object(ze.m)(Math.floor(Math.abs(R) / 60), 2)}`;
      }, ZZZ(X) {
        const R = X.timezoneOffset;
        return `${R > 0 ? "-" : "+"}${Object(ze.m)(100 * Math.floor(Math.abs(R) / 60) + Math.abs(R) % 60, 4)}`;
      }, ZZZZ(X) {
        const R = X.timezoneOffset;
        return `${R > 0 ? "-" : "+"}${Object(ze.m)(Math.floor(Math.abs(R) / 60), 2)}:${Object(ze.m)(Math.abs(R) % 60, 2)}`;
      } }, Zt = { D: [ln, function(X, R) {
        X.day = R;
      }], Do: [new RegExp(ln.source + ws.source), function(X, R) {
        X.day = parseInt(R, 10);
      }], d: [ln, oa], W: [ws, oa], M: [ln, function(X, R) {
        X.month = R - 1;
      }], MMM: [ws, An("monthNamesShort")], MMMM: [ws, An("monthNames")], YY: [ln, function(X, R) {
        const Z = /* @__PURE__ */ new Date(), ne = +Z.getFullYear().toString().substr(0, 2);
        X.year = `${R > 68 ? ne - 1 : ne}${R}`;
      }], YYYY: [sa, function(X, R) {
        X.year = R;
      }], S: [/\d/, function(X, R) {
        X.millisecond = 100 * R;
      }], SS: [/\d{2}/, function(X, R) {
        X.millisecond = 10 * R;
      }], SSS: [wn, function(X, R) {
        X.millisecond = R;
      }], h: [ln, function(X, R) {
        X.hour = R;
      }], m: [ln, function(X, R) {
        X.minute = R;
      }], s: [ln, function(X, R) {
        X.second = R;
      }], a: [ws, function(X, R, Z) {
        const ne = R.toLowerCase();
        ne === Z.amPm[0] ? X.isPm = !1 : ne === Z.amPm[1] && (X.isPm = !0);
      }], Z: [/[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/, function(X, R) {
        R === "Z" && (R = "+00:00");
        const Z = ("" + R).match(/([+-]|\d\d)/gi);
        if (Z) {
          const ne = 60 * Z[1] + parseInt(Z[2], 10);
          X.timezoneOffset = Z[0] === "+" ? ne : -ne;
        }
      }] };
      function ul(X, R) {
        const Z = new Intl.DateTimeFormat().resolvedOptions().locale;
        let ne;
        Object($t.n)(X) ? ne = X : Object($t.e)(X, "id") && (ne = X.id), ne = (ne || Z).toLowerCase();
        const we = Object.keys(R), be = function(Xe) {
          return we.find(function(je) {
            return je.toLowerCase() === Xe;
          });
        };
        ne = be(ne) || be(ne.substring(0, 2)) || Z;
        const Le = { ...R["en-IE"], ...R[ne], id: ne };
        return X = Object($t.m)(X) ? Object($t.c)(X, Le) : Le, X;
      }
      Zt.DD = Zt.D, Zt.dd = Zt.d, Zt.WWWW = Zt.WWW = Zt.WW = Zt.W, Zt.MM = Zt.M, Zt.mm = Zt.m, Zt.hh = Zt.H = Zt.HH = Zt.h, Zt.ss = Zt.s, Zt.A = Zt.a, Zt.ZZZZ = Zt.ZZZ = Zt.ZZ = Zt.Z;
      class rs {
        constructor(R, { locales: Z = St.a, timezone: ne } = {}) {
          const { id: we, firstDayOfWeek: be, masks: Le } = ul(R, Z);
          this.id = we, this.daysInWeek = pr, this.firstDayOfWeek = Object($t.a)(be, 1, pr), this.masks = Le, this.timezone = ne || void 0, this.dayNames = this.getDayNames("long"), this.dayNamesShort = this.getDayNames("short"), this.dayNamesShorter = this.dayNamesShort.map(function(Xe) {
            return Xe.substring(0, 2);
          }), this.dayNamesNarrow = this.getDayNames("narrow"), this.monthNames = this.getMonthNames("long"), this.monthNamesShort = this.getMonthNames("short"), this.amPm = ["am", "pm"], this.monthData = {}, this.getMonthComps = this.getMonthComps.bind(this), this.parse = this.parse.bind(this), this.format = this.format.bind(this), this.toPage = this.toPage.bind(this);
        }
        format(R, Z) {
          var ne = this;
          if (R = this.normalizeDate(R), !R) return "";
          Z = this.normalizeMasks(Z)[0];
          const we = [];
          Z = Z.replace(ia, function(Xe, je) {
            return we.push(je), "??";
          });
          const be = /Z$/.test(Z) ? "utc" : this.timezone, Le = this.getDateParts(R, be);
          return Z = Z.replace(fr, function(Xe) {
            return Xe in $o ? $o[Xe](Le, ne) : Xe.slice(1, Xe.length - 1);
          }), Z.replace(/\?\?/g, function() {
            return we.shift();
          });
        }
        parse(R, Z) {
          var ne = this;
          return this.normalizeMasks(Z).map(function(be) {
            if (typeof be != "string") throw new Error("Invalid mask in fecha.parse");
            let Le = R;
            if (Le.length > 1e3) return !1;
            let Xe = !0;
            const je = {};
            if (be.replace(fr, function(De) {
              if (Zt[De]) {
                const Q = Zt[De], _e = Le.search(Q[0]);
                ~_e ? Le.replace(Q[0], function(Be) {
                  return Q[1](je, Be, ne), Le = Le.substr(_e + Be.length), Be;
                }) : Xe = !1;
              }
              return Zt[De] ? "" : De.slice(1, De.length - 1);
            }), !Xe) return !1;
            const vt = /* @__PURE__ */ new Date();
            let Pt;
            return je.isPm === !0 && je.hour != null && +je.hour != 12 ? je.hour = +je.hour + 12 : je.isPm === !1 && +je.hour == 12 && (je.hour = 0), je.timezoneOffset != null ? (je.minute = +(je.minute || 0) - +je.timezoneOffset, Pt = new Date(Date.UTC(je.year || vt.getFullYear(), je.month || 0, je.day || 1, je.hour || 0, je.minute || 0, je.second || 0, je.millisecond || 0))) : Pt = ne.getDateFromParts({ year: je.year || vt.getFullYear(), month: (je.month || 0) + 1, day: je.day || 1, hours: je.hour || 0, minutes: je.minute || 0, seconds: je.second || 0, milliseconds: je.millisecond || 0 }), Pt;
          }).find(function(be) {
            return be;
          }) || new Date(R);
        }
        normalizeMasks(R) {
          var Z = this;
          return (Object(ze.b)(R) && R || [Object($t.n)(R) && R || "YYYY-MM-DD"]).map(function(ne) {
            return Us.reduce(function(we, be) {
              return we.replace(be, Z.masks[be] || "");
            }, ne);
          });
        }
        normalizeDate(R, Z = {}) {
          let ne = null, { type: we, fillDate: be } = Z;
          const { mask: Le, patch: Xe, time: je } = Z, vt = we === "auto" || !we;
          if (Object($t.l)(R) ? (we = "number", ne = /* @__PURE__ */ new Date(+R)) : Object($t.n)(R) ? (we = "string", ne = R ? this.parse(R, Le || "iso") : null) : Object($t.m)(R) ? (we = "object", ne = this.getDateFromParts(R)) : (we = "date", ne = Object($t.j)(R) ? new Date(R.getTime()) : null), ne && Xe) {
            be = be == null ? /* @__PURE__ */ new Date() : this.normalizeDate(be);
            const Pt = { ...this.getDateParts(be), ...Object($t.t)(this.getDateParts(ne), zs[Xe]) };
            ne = this.getDateFromParts(Pt);
          }
          return vt && (Z.type = we), ne && !isNaN(ne.getTime()) ? (je && (ne = this.adjustTimeForDate(ne, { timeAdjust: je })), ne) : null;
        }
        denormalizeDate(R, { type: Z, mask: ne } = {}) {
          switch (Z) {
            case "number":
              return R ? R.getTime() : NaN;
            case "string":
              return R ? this.format(R, ne || "iso") : "";
            default:
              return R ? new Date(R) : null;
          }
        }
        hourIsValid(R, Z, ne) {
          if (!Z) return !0;
          if (Object($t.h)(Z)) return Z.includes(R);
          if (Object($t.m)(Z)) {
            const we = Z.min || 0, be = Z.max || 24;
            return we <= R && be >= R;
          }
          return Z(R, ne);
        }
        getHourOptions(R, Z) {
          var ne = this;
          return No.filter(function(we) {
            return ne.hourIsValid(we.value, R, Z);
          });
        }
        getMinuteOptions(R) {
          const Z = [];
          R = R > 0 ? R : 1;
          for (let ne = 0; ne <= 59; ne += R) Z.push({ value: ne, label: Object(ze.m)(ne, 2) });
          return Z;
        }
        nearestOptionValue(R, Z) {
          if (R == null) return R;
          const ne = Z.reduce(function(we, be) {
            if (be.disabled) return we;
            if (isNaN(we)) return be.value;
            const Le = Math.abs(we - R);
            return Math.abs(be.value - R) < Le ? be.value : we;
          }, NaN);
          return isNaN(ne) ? R : ne;
        }
        adjustTimeForDate(R, { timeAdjust: Z, validHours: ne, minuteIncrement: we }) {
          if (!Z && !ne && !we) return R;
          const be = this.getDateParts(R);
          if (Z) if (Z === "now") {
            const Le = this.getDateParts(/* @__PURE__ */ new Date());
            be.hours = Le.hours, be.minutes = Le.minutes, be.seconds = Le.seconds, be.milliseconds = Le.milliseconds;
          } else {
            const Le = /* @__PURE__ */ new Date(`2000-01-01T${Z}Z`);
            be.hours = Le.getUTCHours(), be.minutes = Le.getUTCMinutes(), be.seconds = Le.getUTCSeconds(), be.milliseconds = Le.getUTCMilliseconds();
          }
          if (ne) {
            const Le = this.getHourOptions(ne, be);
            be.hours = this.nearestOptionValue(be.hours, Le);
          }
          if (we) {
            const Le = this.getMinuteOptions(we);
            be.minutes = this.nearestOptionValue(be.minutes, Le);
          }
          return R = this.getDateFromParts(be), R;
        }
        normalizeDates(R, Z) {
          return Z = Z || {}, Z.locale = this, (Object($t.h)(R) ? R : [R]).map(function(ne) {
            return ne && (ne instanceof it.a ? ne : new it.a(ne, Z));
          }).filter(function(ne) {
            return ne;
          });
        }
        getDateParts(R, Z = this.timezone) {
          if (!R) return null;
          let ne = R;
          if (Z) {
            const bn = new Date(R.toLocaleString("en-US", { timeZone: Z }));
            bn.setMilliseconds(R.getMilliseconds());
            const zr = bn.getTime() - R.getTime();
            ne = new Date(R.getTime() + zr);
          }
          const we = ne.getMilliseconds(), be = ne.getSeconds(), Le = ne.getMinutes(), Xe = ne.getHours(), je = ne.getMonth() + 1, vt = ne.getFullYear(), Pt = this.getMonthComps(je, vt), De = ne.getDate(), Q = Pt.days - De + 1, _e = ne.getDay() + 1, Be = Math.floor((De - 1) / 7 + 1), Ht = Math.floor((Pt.days - De) / 7 + 1), at = Math.ceil((De + Math.abs(Pt.firstWeekday - Pt.firstDayOfWeek)) / 7), Vt = Pt.weeks - at + 1, pn = { milliseconds: we, seconds: be, minutes: Le, hours: Xe, day: De, dayFromEnd: Q, weekday: _e, weekdayOrdinal: Be, weekdayOrdinalFromEnd: Ht, week: at, weekFromEnd: Vt, month: je, year: vt, date: R, isValid: !0 };
          return pn.timezoneOffset = this.getTimezoneOffset(pn), pn;
        }
        getDateFromParts(R) {
          if (!R) return null;
          const Z = /* @__PURE__ */ new Date(), { year: ne = Z.getFullYear(), month: we = Z.getMonth() + 1, day: be = Z.getDate(), hours: Le = 0, minutes: Xe = 0, seconds: je = 0, milliseconds: vt = 0 } = R;
          if (this.timezone) {
            const Pt = `${Object(ze.m)(ne, 4)}-${Object(ze.m)(we, 2)}-${Object(ze.m)(be, 2)}T${Object(ze.m)(Le, 2)}:${Object(ze.m)(Xe, 2)}:${Object(ze.m)(je, 2)}.${Object(ze.m)(vt, 3)}`;
            return A(Pt, { timeZone: this.timezone });
          }
          return new Date(ne, we - 1, be, Le, Xe, je, vt);
        }
        getTimezoneOffset(R) {
          const { year: Z, month: ne, day: we, hours: be = 0, minutes: Le = 0, seconds: Xe = 0, milliseconds: je = 0 } = R;
          let vt;
          const Pt = new Date(Date.UTC(Z, ne - 1, we, be, Le, Xe, je));
          if (this.timezone) {
            const De = `${Object(ze.m)(Z, 4)}-${Object(ze.m)(ne, 2)}-${Object(ze.m)(we, 2)}T${Object(ze.m)(be, 2)}:${Object(ze.m)(Le, 2)}:${Object(ze.m)(Xe, 2)}.${Object(ze.m)(je, 3)}`;
            vt = A(De, { timeZone: this.timezone });
          } else vt = new Date(Z, ne - 1, we, be, Le, Xe, je);
          return (vt - Pt) / 6e4;
        }
        toPage(R, Z) {
          return Object($t.l)(R) ? Object(ze.a)(Z, R) : Object($t.n)(R) ? this.getDateParts(this.normalizeDate(R)) : Object($t.j)(R) ? this.getDateParts(R) : Object($t.m)(R) ? R : null;
        }
        getMonthDates(R = 2e3) {
          const Z = [];
          for (let ne = 0; ne < 12; ne++) Z.push(new Date(R, ne, 15));
          return Z;
        }
        getMonthNames(R) {
          const Z = new Intl.DateTimeFormat(this.id, { month: R, timezome: "UTC" });
          return this.getMonthDates().map(function(ne) {
            return Z.format(ne);
          });
        }
        getWeekdayDates(R = this.firstDayOfWeek) {
          const Z = [], be = 5 + R - 1;
          for (let Le = 0; Le < pr; Le++) Z.push(this.getDateFromParts({ year: 2020, month: 1, day: be + Le, hours: 12 }));
          return Z;
        }
        getDayNames(R) {
          const Z = new Intl.DateTimeFormat(this.id, { weekday: R, timeZone: this.timezone });
          return this.getWeekdayDates(1).map(function(ne) {
            return Z.format(ne);
          });
        }
        getMonthComps(R, Z) {
          const ne = `${R}-${Z}`;
          let we = this.monthData[ne];
          if (!we) {
            const be = Z % 4 === 0 && Z % 100 !== 0 || Z % 400 === 0, Le = new Date(Z, R - 1, 1), Xe = Le.getDay() + 1, je = R === 2 && be ? 29 : aa[R - 1], vt = this.firstDayOfWeek - 1, Pt = Ve(Le, { weekStartsOn: vt }), De = [], Q = [];
            for (let _e = 0; _e < Pt; _e++) {
              const Be = Object(Ze.a)(Le, 7 * _e);
              De.push(Wt(Be, { weekStartsOn: vt })), Q.push(ns(Be));
            }
            we = { firstDayOfWeek: this.firstDayOfWeek, inLeapYear: be, firstWeekday: Xe, days: je, weeks: Pt, month: R, year: Z, weeknumbers: De, isoWeeknumbers: Q }, this.monthData[ne] = we;
          }
          return we;
        }
        getThisMonthComps() {
          const { month: R, year: Z } = this.getDateParts(/* @__PURE__ */ new Date());
          return this.getMonthComps(R, Z);
        }
        getPrevMonthComps(R, Z) {
          return R === 1 ? this.getMonthComps(12, Z - 1) : this.getMonthComps(R - 1, Z);
        }
        getNextMonthComps(R, Z) {
          return R === 12 ? this.getMonthComps(1, Z + 1) : this.getMonthComps(R + 1, Z);
        }
        getDayId(R) {
          return this.format(R, "YYYY-MM-DD");
        }
        getCalendarDays({ weeks: R, monthComps: Z, prevMonthComps: ne, nextMonthComps: we }) {
          var be = this;
          const Le = [], { firstDayOfWeek: Xe, firstWeekday: je, isoWeeknumbers: vt, weeknumbers: Pt } = Z, De = je + (je < Xe ? pr : 0) - Xe;
          let Q = !0, _e = !1, Be = !1;
          const Ht = new Intl.DateTimeFormat(this.id, { weekday: "long", year: "numeric", month: "long", day: "numeric" });
          let at = ne.days - De + 1, Vt = ne.days - at + 1, pn = Math.floor((at - 1) / pr + 1), bn = 1, zr = ne.weeks, _n = 1, wr = ne.month, Bs = ne.year;
          const dl = /* @__PURE__ */ new Date(), fl = dl.getDate(), Zu = dl.getMonth() + 1, Xu = dl.getFullYear(), M = function(J, F, oe) {
            return function(ce, ie, Se, ke) {
              return be.normalizeDate({ year: J, month: F, day: oe, hours: ce, minutes: ie, seconds: Se, milliseconds: ke });
            };
          };
          for (let J = 1; J <= R; J++) {
            for (let F = 1, oe = Xe; F <= pr; F++, oe += oe === pr ? 1 - pr : 1) {
              Q && oe === je && (at = 1, Vt = Z.days, pn = Math.floor((at - 1) / pr + 1), bn = Math.floor((Z.days - at) / pr + 1), zr = 1, _n = Z.weeks, wr = Z.month, Bs = Z.year, Q = !1, _e = !0);
              const ce = M(Bs, wr, at), ie = { start: ce(0, 0, 0), end: ce(23, 59, 59, 999) }, Se = ie.start, ke = `${Object(ze.m)(Bs, 4)}-${Object(ze.m)(wr, 2)}-${Object(ze.m)(at, 2)}`, Oe = F, Re = pr - F, fe = Pt[J - 1], Pe = vt[J - 1], Ct = at === fl && wr === Zu && Bs === Xu, zt = _e && at === 1, bt = _e && at === Z.days, On = J === 1, hn = J === R, Ur = F === 1, Qi = F === pr;
              Le.push({ id: ke, label: at.toString(), ariaLabel: Ht.format(new Date(Bs, wr - 1, at)), day: at, dayFromEnd: Vt, weekday: oe, weekdayPosition: Oe, weekdayPositionFromEnd: Re, weekdayOrdinal: pn, weekdayOrdinalFromEnd: bn, week: zr, weekFromEnd: _n, weeknumber: fe, isoWeeknumber: Pe, month: wr, year: Bs, dateFromTime: ce, date: Se, range: ie, isToday: Ct, isFirstDay: zt, isLastDay: bt, inMonth: _e, inPrevMonth: Q, inNextMonth: Be, onTop: On, onBottom: hn, onLeft: Ur, onRight: Qi, classes: ["id-" + ke, "day-" + at, "day-from-end-" + Vt, "weekday-" + oe, "weekday-position-" + Oe, "weekday-ordinal-" + pn, "weekday-ordinal-from-end-" + bn, "week-" + zr, "week-from-end-" + _n, { "is-today": Ct, "is-first-day": zt, "is-last-day": bt, "in-month": _e, "in-prev-month": Q, "in-next-month": Be, "on-top": On, "on-bottom": hn, "on-left": Ur, "on-right": Qi }] }), _e && bt ? (_e = !1, Be = !0, at = 1, Vt = we.days, pn = 1, bn = Math.floor((we.days - at) / pr + 1), zr = 1, _n = we.weeks, wr = we.month, Bs = we.year) : (at++, Vt--, pn = Math.floor((at - 1) / pr + 1), bn = Math.floor((Z.days - at) / pr + 1));
            }
            zr++, _n--;
          }
          return Le;
        }
      }
    }, "29f3": function(r, s) {
      var i = Object.prototype, o = i.toString;
      function a(l) {
        return o.call(l);
      }
      r.exports = a;
    }, "2af9": function(r, s, i) {
      i.r(s), i.d(s, "Calendar", function() {
        return rE;
      }), i.d(s, "CalendarNav", function() {
        return tE;
      }), i.d(s, "DatePicker", function() {
        return fH;
      }), i.d(s, "Popover", function() {
        return hn;
      }), i("d9e2"), i("14d9"), i("13d5");
      var o = i("f7f1"), a = i("fe1f"), l = i("fd3a"), c = i("8c86");
      function u(g, I) {
        Object(c.a)(2, arguments);
        var $ = Object(l.a)(g), W = Object(a.a)(I);
        if (isNaN(W)) return /* @__PURE__ */ new Date(NaN);
        if (!W) return $;
        var G = $.getDate(), re = new Date($.getTime());
        re.setMonth($.getMonth() + W + 1, 0);
        var ue = re.getDate();
        return G >= ue ? re : ($.setFullYear(re.getFullYear(), re.getMonth(), G), $);
      }
      function d(g, I) {
        Object(c.a)(2, arguments);
        var $ = Object(a.a)(I);
        return u(g, 12 * $);
      }
      function f(g) {
        if (g == null) return window;
        if (g.toString() !== "[object Window]") {
          var I = g.ownerDocument;
          return I && I.defaultView || window;
        }
        return g;
      }
      function p(g) {
        var I = f(g).Element;
        return g instanceof I || g instanceof Element;
      }
      function h(g) {
        var I = f(g).HTMLElement;
        return g instanceof I || g instanceof HTMLElement;
      }
      function m(g) {
        if (typeof ShadowRoot > "u") return !1;
        var I = f(g).ShadowRoot;
        return g instanceof I || g instanceof ShadowRoot;
      }
      var v = Math.max, y = Math.min, _ = Math.round;
      function w() {
        var g = navigator.userAgentData;
        return g != null && g.brands && Array.isArray(g.brands) ? g.brands.map(function(I) {
          return I.brand + "/" + I.version;
        }).join(" ") : navigator.userAgent;
      }
      function S() {
        return !/^((?!chrome|android).)*safari/i.test(w());
      }
      function E(g, I, $) {
        I === void 0 && (I = !1), $ === void 0 && ($ = !1);
        var W = g.getBoundingClientRect(), G = 1, re = 1;
        I && h(g) && (G = g.offsetWidth > 0 && _(W.width) / g.offsetWidth || 1, re = g.offsetHeight > 0 && _(W.height) / g.offsetHeight || 1);
        var ue = p(g) ? f(g) : window, de = ue.visualViewport, he = !S() && $, ye = (W.left + (he && de ? de.offsetLeft : 0)) / G, Ne = (W.top + (he && de ? de.offsetTop : 0)) / re, tt = W.width / G, ft = W.height / re;
        return { width: tt, height: ft, top: Ne, right: ye + tt, bottom: Ne + ft, left: ye, x: ye, y: Ne };
      }
      function x(g) {
        var I = f(g), $ = I.pageXOffset, W = I.pageYOffset;
        return { scrollLeft: $, scrollTop: W };
      }
      function T(g) {
        return { scrollLeft: g.scrollLeft, scrollTop: g.scrollTop };
      }
      function C(g) {
        return g !== f(g) && h(g) ? T(g) : x(g);
      }
      function k(g) {
        return g ? (g.nodeName || "").toLowerCase() : null;
      }
      function b(g) {
        return ((p(g) ? g.ownerDocument : g.document) || window.document).documentElement;
      }
      function P(g) {
        return E(b(g)).left + x(g).scrollLeft;
      }
      function N(g) {
        return f(g).getComputedStyle(g);
      }
      function D(g) {
        var I = N(g), $ = I.overflow, W = I.overflowX, G = I.overflowY;
        return /auto|scroll|overlay|hidden/.test($ + G + W);
      }
      function H(g) {
        var I = g.getBoundingClientRect(), $ = _(I.width) / g.offsetWidth || 1, W = _(I.height) / g.offsetHeight || 1;
        return $ !== 1 || W !== 1;
      }
      function Y(g, I, $) {
        $ === void 0 && ($ = !1);
        var W = h(I), G = h(I) && H(I), re = b(I), ue = E(g, G, $), de = { scrollLeft: 0, scrollTop: 0 }, he = { x: 0, y: 0 };
        return (W || !W && !$) && ((k(I) !== "body" || D(re)) && (de = C(I)), h(I) ? (he = E(I, !0), he.x += I.clientLeft, he.y += I.clientTop) : re && (he.x = P(re))), { x: ue.left + de.scrollLeft - he.x, y: ue.top + de.scrollTop - he.y, width: ue.width, height: ue.height };
      }
      function te(g) {
        var I = E(g), $ = g.offsetWidth, W = g.offsetHeight;
        return Math.abs(I.width - $) <= 1 && ($ = I.width), Math.abs(I.height - W) <= 1 && (W = I.height), { x: g.offsetLeft, y: g.offsetTop, width: $, height: W };
      }
      function A(g) {
        return k(g) === "html" ? g : g.assignedSlot || g.parentNode || (m(g) ? g.host : null) || b(g);
      }
      function j(g) {
        return ["html", "body", "#document"].indexOf(k(g)) >= 0 ? g.ownerDocument.body : h(g) && D(g) ? g : j(A(g));
      }
      function L(g, I) {
        var $;
        I === void 0 && (I = []);
        var W = j(g), G = W === (($ = g.ownerDocument) == null ? void 0 : $.body), re = f(W), ue = G ? [re].concat(re.visualViewport || [], D(W) ? W : []) : W, de = I.concat(ue);
        return G ? de : de.concat(L(A(ue)));
      }
      function se(g) {
        return ["table", "td", "th"].indexOf(k(g)) >= 0;
      }
      function V(g) {
        return h(g) && N(g).position !== "fixed" ? g.offsetParent : null;
      }
      function ee(g) {
        var I = /firefox/i.test(w()), $ = /Trident/i.test(w());
        if ($ && h(g)) {
          var W = N(g);
          if (W.position === "fixed") return null;
        }
        var G = A(g);
        for (m(G) && (G = G.host); h(G) && ["html", "body"].indexOf(k(G)) < 0; ) {
          var re = N(G);
          if (re.transform !== "none" || re.perspective !== "none" || re.contain === "paint" || ["transform", "perspective"].indexOf(re.willChange) !== -1 || I && re.willChange === "filter" || I && re.filter && re.filter !== "none") return G;
          G = G.parentNode;
        }
        return null;
      }
      function O(g) {
        for (var I = f(g), $ = V(g); $ && se($) && N($).position === "static"; ) $ = V($);
        return $ && (k($) === "html" || k($) === "body" && N($).position === "static") ? I : $ || ee(g) || I;
      }
      var K = "top", z = "bottom", q = "right", ae = "left", Ee = "auto", Ae = [K, z, q, ae], Ue = "start", qe = "end", Qe = "clippingParents", Lt = "viewport", Yt = "popper", nn = "reference", qt = Ae.reduce(function(g, I) {
        return g.concat([I + "-" + Ue, I + "-" + qe]);
      }, []), rn = [].concat(Ae, [Ee]).reduce(function(g, I) {
        return g.concat([I, I + "-" + Ue, I + "-" + qe]);
      }, []), sn = "beforeRead", zn = "read", ns = "afterRead", Nt = "beforeMain", dt = "main", xt = "afterMain", Wt = "beforeWrite", Tt = "write", _r = "afterWrite", dr = [sn, zn, ns, Nt, dt, xt, Wt, Tt, _r];
      function qn(g) {
        var I = /* @__PURE__ */ new Map(), $ = /* @__PURE__ */ new Set(), W = [];
        function G(re) {
          $.add(re.name);
          var ue = [].concat(re.requires || [], re.requiresIfExists || []);
          ue.forEach(function(de) {
            if (!$.has(de)) {
              var he = I.get(de);
              he && G(he);
            }
          }), W.push(re);
        }
        return g.forEach(function(re) {
          I.set(re.name, re);
        }), g.forEach(function(re) {
          $.has(re.name) || G(re);
        }), W;
      }
      function yn(g) {
        var I = qn(g);
        return dr.reduce(function($, W) {
          return $.concat(I.filter(function(G) {
            return G.phase === W;
          }));
        }, []);
      }
      function Ve(g) {
        var I;
        return function() {
          return I || (I = new Promise(function($) {
            Promise.resolve().then(function() {
              I = void 0, $(g());
            });
          })), I;
        };
      }
      function Ze(g) {
        var I = g.reduce(function($, W) {
          var G = $[W.name];
          return $[W.name] = G ? Object.assign({}, G, W, { options: Object.assign({}, G.options, W.options), data: Object.assign({}, G.data, W.data) }) : W, $;
        }, {});
        return Object.keys(I).map(function($) {
          return I[$];
        });
      }
      var it = { placement: "bottom", modifiers: [], strategy: "absolute" };
      function St() {
        for (var g = arguments.length, I = new Array(g), $ = 0; $ < g; $++) I[$] = arguments[$];
        return !I.some(function(W) {
          return !(W && typeof W.getBoundingClientRect == "function");
        });
      }
      function ze(g) {
        g === void 0 && (g = {});
        var I = g, $ = I.defaultModifiers, W = $ === void 0 ? [] : $, G = I.defaultOptions, re = G === void 0 ? it : G;
        return function(ue, de, he) {
          he === void 0 && (he = re);
          var ye = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, it, re), modifiersData: {}, elements: { reference: ue, popper: de }, attributes: {}, styles: {} }, Ne = [], tt = !1, ft = { state: ye, setOptions: function(wt) {
            var Tn = typeof wt == "function" ? wt(ye.options) : wt;
            Sn(), ye.options = Object.assign({}, re, ye.options, Tn), ye.scrollParents = { reference: p(ue) ? L(ue) : ue.contextElement ? L(ue.contextElement) : [], popper: L(de) };
            var Mn = yn(Ze([].concat(W, ye.options.modifiers)));
            return ye.orderedModifiers = Mn.filter(function(Qn) {
              return Qn.enabled;
            }), _t(), ft.update();
          }, forceUpdate: function() {
            if (!tt) {
              var wt = ye.elements, Tn = wt.reference, Mn = wt.popper;
              if (St(Tn, Mn)) {
                ye.rects = { reference: Y(Tn, O(Mn), ye.options.strategy === "fixed"), popper: te(Mn) }, ye.reset = !1, ye.placement = ye.options.placement, ye.orderedModifiers.forEach(function(Rr) {
                  return ye.modifiersData[Rr.name] = Object.assign({}, Rr.data);
                });
                for (var Qn = 0; Qn < ye.orderedModifiers.length; Qn++) if (ye.reset !== !0) {
                  var Sr = ye.orderedModifiers[Qn], cn = Sr.fn, In = Sr.options, Rn = In === void 0 ? {} : In, Ir = Sr.name;
                  typeof cn == "function" && (ye = cn({ state: ye, options: Rn, name: Ir, instance: ft }) || ye);
                } else ye.reset = !1, Qn = -1;
              }
            }
          }, update: Ve(function() {
            return new Promise(function(wt) {
              ft.forceUpdate(), wt(ye);
            });
          }), destroy: function() {
            Sn(), tt = !0;
          } };
          if (!St(ue, de)) return ft;
          function _t() {
            ye.orderedModifiers.forEach(function(wt) {
              var Tn = wt.name, Mn = wt.options, Qn = Mn === void 0 ? {} : Mn, Sr = wt.effect;
              if (typeof Sr == "function") {
                var cn = Sr({ state: ye, name: Tn, instance: ft, options: Qn }), In = function() {
                };
                Ne.push(cn || In);
              }
            });
          }
          function Sn() {
            Ne.forEach(function(wt) {
              return wt();
            }), Ne = [];
          }
          return ft.setOptions(he).then(function(wt) {
            !tt && he.onFirstUpdate && he.onFirstUpdate(wt);
          }), ft;
        };
      }
      var $t = { passive: !0 };
      function Fs(g) {
        var I = g.state, $ = g.instance, W = g.options, G = W.scroll, re = G === void 0 || G, ue = W.resize, de = ue === void 0 || ue, he = f(I.elements.popper), ye = [].concat(I.scrollParents.reference, I.scrollParents.popper);
        return re && ye.forEach(function(Ne) {
          Ne.addEventListener("scroll", $.update, $t);
        }), de && he.addEventListener("resize", $.update, $t), function() {
          re && ye.forEach(function(Ne) {
            Ne.removeEventListener("scroll", $.update, $t);
          }), de && he.removeEventListener("resize", $.update, $t);
        };
      }
      var zs = { name: "eventListeners", enabled: !0, phase: "write", fn: function() {
      }, effect: Fs, data: {} };
      function fr(g) {
        return g.split("-")[0];
      }
      function ln(g) {
        return g.split("-")[1];
      }
      function wn(g) {
        return ["top", "bottom"].indexOf(g) >= 0 ? "x" : "y";
      }
      function sa(g) {
        var I, $ = g.reference, W = g.element, G = g.placement, re = G ? fr(G) : null, ue = G ? ln(G) : null, de = $.x + $.width / 2 - W.width / 2, he = $.y + $.height / 2 - W.height / 2;
        switch (re) {
          case K:
            I = { x: de, y: $.y - W.height };
            break;
          case z:
            I = { x: de, y: $.y + $.height };
            break;
          case q:
            I = { x: $.x + $.width, y: he };
            break;
          case ae:
            I = { x: $.x - W.width, y: he };
            break;
          default:
            I = { x: $.x, y: $.y };
        }
        var ye = re ? wn(re) : null;
        if (ye != null) {
          var Ne = ye === "y" ? "height" : "width";
          switch (ue) {
            case Ue:
              I[ye] = I[ye] - ($[Ne] / 2 - W[Ne] / 2);
              break;
            case qe:
              I[ye] = I[ye] + ($[Ne] / 2 - W[Ne] / 2);
              break;
          }
        }
        return I;
      }
      function ws(g) {
        var I = g.state, $ = g.name;
        I.modifiersData[$] = sa({ reference: I.rects.reference, element: I.rects.popper, strategy: "absolute", placement: I.placement });
      }
      var ia = { name: "popperOffsets", enabled: !0, phase: "read", fn: ws, data: {} }, oa = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
      function An(g, I) {
        var $ = g.x, W = g.y, G = I.devicePixelRatio || 1;
        return { x: _($ * G) / G || 0, y: _(W * G) / G || 0 };
      }
      function Us(g) {
        var I, $ = g.popper, W = g.popperRect, G = g.placement, re = g.variation, ue = g.offsets, de = g.position, he = g.gpuAcceleration, ye = g.adaptive, Ne = g.roundOffsets, tt = g.isFixed, ft = ue.x, _t = ft === void 0 ? 0 : ft, Sn = ue.y, wt = Sn === void 0 ? 0 : Sn, Tn = typeof Ne == "function" ? Ne({ x: _t, y: wt }) : { x: _t, y: wt };
        _t = Tn.x, wt = Tn.y;
        var Mn = ue.hasOwnProperty("x"), Qn = ue.hasOwnProperty("y"), Sr = ae, cn = K, In = window;
        if (ye) {
          var Rn = O($), Ir = "clientHeight", Rr = "clientWidth";
          if (Rn === f($) && (Rn = b($), N(Rn).position !== "static" && de === "absolute" && (Ir = "scrollHeight", Rr = "scrollWidth")), Rn = Rn, G === K || (G === ae || G === q) && re === qe) {
            cn = z;
            var ss = tt && Rn === In && In.visualViewport ? In.visualViewport.height : Rn[Ir];
            wt -= ss - W.height, wt *= he ? 1 : -1;
          }
          if (G === ae || (G === K || G === z) && re === qe) {
            Sr = q;
            var is = tt && Rn === In && In.visualViewport ? In.visualViewport.width : Rn[Rr];
            _t -= is - W.width, _t *= he ? 1 : -1;
          }
        }
        var kr, Ni = Object.assign({ position: de }, ye && oa), di = Ne === !0 ? An({ x: _t, y: wt }, f($)) : { x: _t, y: wt };
        return _t = di.x, wt = di.y, he ? Object.assign({}, Ni, (kr = {}, kr[cn] = Qn ? "0" : "", kr[Sr] = Mn ? "0" : "", kr.transform = (In.devicePixelRatio || 1) <= 1 ? "translate(" + _t + "px, " + wt + "px)" : "translate3d(" + _t + "px, " + wt + "px, 0)", kr)) : Object.assign({}, Ni, (I = {}, I[cn] = Qn ? wt + "px" : "", I[Sr] = Mn ? _t + "px" : "", I.transform = "", I));
      }
      function pr(g) {
        var I = g.state, $ = g.options, W = $.gpuAcceleration, G = W === void 0 || W, re = $.adaptive, ue = re === void 0 || re, de = $.roundOffsets, he = de === void 0 || de, ye = { placement: fr(I.placement), variation: ln(I.placement), popper: I.elements.popper, popperRect: I.rects.popper, gpuAcceleration: G, isFixed: I.options.strategy === "fixed" };
        I.modifiersData.popperOffsets != null && (I.styles.popper = Object.assign({}, I.styles.popper, Us(Object.assign({}, ye, { offsets: I.modifiersData.popperOffsets, position: I.options.strategy, adaptive: ue, roundOffsets: he })))), I.modifiersData.arrow != null && (I.styles.arrow = Object.assign({}, I.styles.arrow, Us(Object.assign({}, ye, { offsets: I.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: he })))), I.attributes.popper = Object.assign({}, I.attributes.popper, { "data-popper-placement": I.placement });
      }
      var aa = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: pr, data: {} };
      function No(g) {
        var I = g.state;
        Object.keys(I.elements).forEach(function($) {
          var W = I.styles[$] || {}, G = I.attributes[$] || {}, re = I.elements[$];
          h(re) && k(re) && (Object.assign(re.style, W), Object.keys(G).forEach(function(ue) {
            var de = G[ue];
            de === !1 ? re.removeAttribute(ue) : re.setAttribute(ue, de === !0 ? "" : de);
          }));
        });
      }
      function $o(g) {
        var I = g.state, $ = { popper: { position: I.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
        return Object.assign(I.elements.popper.style, $.popper), I.styles = $, I.elements.arrow && Object.assign(I.elements.arrow.style, $.arrow), function() {
          Object.keys(I.elements).forEach(function(W) {
            var G = I.elements[W], re = I.attributes[W] || {}, ue = Object.keys(I.styles.hasOwnProperty(W) ? I.styles[W] : $[W]), de = ue.reduce(function(he, ye) {
              return he[ye] = "", he;
            }, {});
            h(G) && k(G) && (Object.assign(G.style, de), Object.keys(re).forEach(function(he) {
              G.removeAttribute(he);
            }));
          });
        };
      }
      var Zt = { name: "applyStyles", enabled: !0, phase: "write", fn: No, effect: $o, requires: ["computeStyles"] };
      function ul(g, I, $) {
        var W = fr(g), G = [ae, K].indexOf(W) >= 0 ? -1 : 1, re = typeof $ == "function" ? $(Object.assign({}, I, { placement: g })) : $, ue = re[0], de = re[1];
        return ue = ue || 0, de = (de || 0) * G, [ae, q].indexOf(W) >= 0 ? { x: de, y: ue } : { x: ue, y: de };
      }
      function rs(g) {
        var I = g.state, $ = g.options, W = g.name, G = $.offset, re = G === void 0 ? [0, 0] : G, ue = rn.reduce(function(Ne, tt) {
          return Ne[tt] = ul(tt, I.rects, re), Ne;
        }, {}), de = ue[I.placement], he = de.x, ye = de.y;
        I.modifiersData.popperOffsets != null && (I.modifiersData.popperOffsets.x += he, I.modifiersData.popperOffsets.y += ye), I.modifiersData[W] = ue;
      }
      var X = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: rs }, R = { left: "right", right: "left", bottom: "top", top: "bottom" };
      function Z(g) {
        return g.replace(/left|right|bottom|top/g, function(I) {
          return R[I];
        });
      }
      var ne = { start: "end", end: "start" };
      function we(g) {
        return g.replace(/start|end/g, function(I) {
          return ne[I];
        });
      }
      function be(g, I) {
        var $ = f(g), W = b(g), G = $.visualViewport, re = W.clientWidth, ue = W.clientHeight, de = 0, he = 0;
        if (G) {
          re = G.width, ue = G.height;
          var ye = S();
          (ye || !ye && I === "fixed") && (de = G.offsetLeft, he = G.offsetTop);
        }
        return { width: re, height: ue, x: de + P(g), y: he };
      }
      function Le(g) {
        var I, $ = b(g), W = x(g), G = (I = g.ownerDocument) == null ? void 0 : I.body, re = v($.scrollWidth, $.clientWidth, G ? G.scrollWidth : 0, G ? G.clientWidth : 0), ue = v($.scrollHeight, $.clientHeight, G ? G.scrollHeight : 0, G ? G.clientHeight : 0), de = -W.scrollLeft + P(g), he = -W.scrollTop;
        return N(G || $).direction === "rtl" && (de += v($.clientWidth, G ? G.clientWidth : 0) - re), { width: re, height: ue, x: de, y: he };
      }
      function Xe(g, I) {
        var $ = I.getRootNode && I.getRootNode();
        if (g.contains(I)) return !0;
        if ($ && m($)) {
          var W = I;
          do {
            if (W && g.isSameNode(W)) return !0;
            W = W.parentNode || W.host;
          } while (W);
        }
        return !1;
      }
      function je(g) {
        return Object.assign({}, g, { left: g.x, top: g.y, right: g.x + g.width, bottom: g.y + g.height });
      }
      function vt(g, I) {
        var $ = E(g, !1, I === "fixed");
        return $.top = $.top + g.clientTop, $.left = $.left + g.clientLeft, $.bottom = $.top + g.clientHeight, $.right = $.left + g.clientWidth, $.width = g.clientWidth, $.height = g.clientHeight, $.x = $.left, $.y = $.top, $;
      }
      function Pt(g, I, $) {
        return I === Lt ? je(be(g, $)) : p(I) ? vt(I, $) : je(Le(b(g)));
      }
      function De(g) {
        var I = L(A(g)), $ = ["absolute", "fixed"].indexOf(N(g).position) >= 0, W = $ && h(g) ? O(g) : g;
        return p(W) ? I.filter(function(G) {
          return p(G) && Xe(G, W) && k(G) !== "body";
        }) : [];
      }
      function Q(g, I, $, W) {
        var G = I === "clippingParents" ? De(g) : [].concat(I), re = [].concat(G, [$]), ue = re[0], de = re.reduce(function(he, ye) {
          var Ne = Pt(g, ye, W);
          return he.top = v(Ne.top, he.top), he.right = y(Ne.right, he.right), he.bottom = y(Ne.bottom, he.bottom), he.left = v(Ne.left, he.left), he;
        }, Pt(g, ue, W));
        return de.width = de.right - de.left, de.height = de.bottom - de.top, de.x = de.left, de.y = de.top, de;
      }
      function _e() {
        return { top: 0, right: 0, bottom: 0, left: 0 };
      }
      function Be(g) {
        return Object.assign({}, _e(), g);
      }
      function Ht(g, I) {
        return I.reduce(function($, W) {
          return $[W] = g, $;
        }, {});
      }
      function at(g, I) {
        I === void 0 && (I = {});
        var $ = I, W = $.placement, G = W === void 0 ? g.placement : W, re = $.strategy, ue = re === void 0 ? g.strategy : re, de = $.boundary, he = de === void 0 ? Qe : de, ye = $.rootBoundary, Ne = ye === void 0 ? Lt : ye, tt = $.elementContext, ft = tt === void 0 ? Yt : tt, _t = $.altBoundary, Sn = _t !== void 0 && _t, wt = $.padding, Tn = wt === void 0 ? 0 : wt, Mn = Be(typeof Tn != "number" ? Tn : Ht(Tn, Ae)), Qn = ft === Yt ? nn : Yt, Sr = g.rects.popper, cn = g.elements[Sn ? Qn : ft], In = Q(p(cn) ? cn : cn.contextElement || b(g.elements.popper), he, Ne, ue), Rn = E(g.elements.reference), Ir = sa({ reference: Rn, element: Sr, strategy: "absolute", placement: G }), Rr = je(Object.assign({}, Sr, Ir)), ss = ft === Yt ? Rr : Rn, is = { top: In.top - ss.top + Mn.top, bottom: ss.bottom - In.bottom + Mn.bottom, left: In.left - ss.left + Mn.left, right: ss.right - In.right + Mn.right }, kr = g.modifiersData.offset;
        if (ft === Yt && kr) {
          var Ni = kr[G];
          Object.keys(is).forEach(function(di) {
            var pl = [q, z].indexOf(di) >= 0 ? 1 : -1, hl = [K, z].indexOf(di) >= 0 ? "y" : "x";
            is[di] += Ni[hl] * pl;
          });
        }
        return is;
      }
      function Vt(g, I) {
        I === void 0 && (I = {});
        var $ = I, W = $.placement, G = $.boundary, re = $.rootBoundary, ue = $.padding, de = $.flipVariations, he = $.allowedAutoPlacements, ye = he === void 0 ? rn : he, Ne = ln(W), tt = Ne ? de ? qt : qt.filter(function(Sn) {
          return ln(Sn) === Ne;
        }) : Ae, ft = tt.filter(function(Sn) {
          return ye.indexOf(Sn) >= 0;
        });
        ft.length === 0 && (ft = tt);
        var _t = ft.reduce(function(Sn, wt) {
          return Sn[wt] = at(g, { placement: wt, boundary: G, rootBoundary: re, padding: ue })[fr(wt)], Sn;
        }, {});
        return Object.keys(_t).sort(function(Sn, wt) {
          return _t[Sn] - _t[wt];
        });
      }
      function pn(g) {
        if (fr(g) === Ee) return [];
        var I = Z(g);
        return [we(g), I, we(I)];
      }
      function bn(g) {
        var I = g.state, $ = g.options, W = g.name;
        if (!I.modifiersData[W]._skip) {
          for (var G = $.mainAxis, re = G === void 0 || G, ue = $.altAxis, de = ue === void 0 || ue, he = $.fallbackPlacements, ye = $.padding, Ne = $.boundary, tt = $.rootBoundary, ft = $.altBoundary, _t = $.flipVariations, Sn = _t === void 0 || _t, wt = $.allowedAutoPlacements, Tn = I.options.placement, Mn = fr(Tn), Qn = Mn === Tn, Sr = he || (Qn || !Sn ? [Z(Tn)] : pn(Tn)), cn = [Tn].concat(Sr).reduce(function(vl, Do) {
            return vl.concat(fr(Do) === Ee ? Vt(I, { placement: Do, boundary: Ne, rootBoundary: tt, padding: ye, flipVariations: Sn, allowedAutoPlacements: wt }) : Do);
          }, []), In = I.rects.reference, Rn = I.rects.popper, Ir = /* @__PURE__ */ new Map(), Rr = !0, ss = cn[0], is = 0; is < cn.length; is++) {
            var kr = cn[is], Ni = fr(kr), di = ln(kr) === Ue, pl = [K, z].indexOf(Ni) >= 0, hl = pl ? "width" : "height", Zs = at(I, { placement: kr, boundary: Ne, rootBoundary: tt, altBoundary: ft, padding: ye }), $i = pl ? di ? q : ae : di ? z : K;
            In[hl] > Rn[hl] && ($i = Z($i));
            var ip = Z($i), ml = [];
            if (re && ml.push(Zs[Ni] <= 0), de && ml.push(Zs[$i] <= 0, Zs[ip] <= 0), ml.every(function(vl) {
              return vl;
            })) {
              ss = kr, Rr = !1;
              break;
            }
            Ir.set(kr, ml);
          }
          if (Rr) for (var op = Sn ? 3 : 1, Eg = function(vl) {
            var Do = cn.find(function(lp) {
              var qu = Ir.get(lp);
              if (qu) return qu.slice(0, vl).every(function(yc) {
                return yc;
              });
            });
            if (Do) return ss = Do, "break";
          }, Ju = op; Ju > 0; Ju--) {
            var ap = Eg(Ju);
            if (ap === "break") break;
          }
          I.placement !== ss && (I.modifiersData[W]._skip = !0, I.placement = ss, I.reset = !0);
        }
      }
      var zr = { name: "flip", enabled: !0, phase: "main", fn: bn, requiresIfExists: ["offset"], data: { _skip: !1 } };
      function _n(g) {
        return g === "x" ? "y" : "x";
      }
      function wr(g, I, $) {
        return v(g, y(I, $));
      }
      function Bs(g, I, $) {
        var W = wr(g, I, $);
        return W > $ ? $ : W;
      }
      function dl(g) {
        var I = g.state, $ = g.options, W = g.name, G = $.mainAxis, re = G === void 0 || G, ue = $.altAxis, de = ue !== void 0 && ue, he = $.boundary, ye = $.rootBoundary, Ne = $.altBoundary, tt = $.padding, ft = $.tether, _t = ft === void 0 || ft, Sn = $.tetherOffset, wt = Sn === void 0 ? 0 : Sn, Tn = at(I, { boundary: he, rootBoundary: ye, padding: tt, altBoundary: Ne }), Mn = fr(I.placement), Qn = ln(I.placement), Sr = !Qn, cn = wn(Mn), In = _n(cn), Rn = I.modifiersData.popperOffsets, Ir = I.rects.reference, Rr = I.rects.popper, ss = typeof wt == "function" ? wt(Object.assign({}, I.rects, { placement: I.placement })) : wt, is = typeof ss == "number" ? { mainAxis: ss, altAxis: ss } : Object.assign({ mainAxis: 0, altAxis: 0 }, ss), kr = I.modifiersData.offset ? I.modifiersData.offset[I.placement] : null, Ni = { x: 0, y: 0 };
        if (Rn) {
          if (re) {
            var di, pl = cn === "y" ? K : ae, hl = cn === "y" ? z : q, Zs = cn === "y" ? "height" : "width", $i = Rn[cn], ip = $i + Tn[pl], ml = $i - Tn[hl], op = _t ? -Rr[Zs] / 2 : 0, Eg = Qn === Ue ? Ir[Zs] : Rr[Zs], Ju = Qn === Ue ? -Rr[Zs] : -Ir[Zs], ap = I.elements.arrow, vl = _t && ap ? te(ap) : { width: 0, height: 0 }, Do = I.modifiersData["arrow#persistent"] ? I.modifiersData["arrow#persistent"].padding : _e(), lp = Do[pl], qu = Do[hl], yc = wr(0, Ir[Zs], vl[Zs]), pH = Sr ? Ir[Zs] / 2 - op - yc - lp - is.mainAxis : Eg - yc - lp - is.mainAxis, hH = Sr ? -Ir[Zs] / 2 + op + yc + qu + is.mainAxis : Ju + yc + qu + is.mainAxis, xg = I.elements.arrow && O(I.elements.arrow), mH = xg ? cn === "y" ? xg.clientTop || 0 : xg.clientLeft || 0 : 0, iE = (di = kr == null ? void 0 : kr[cn]) != null ? di : 0, vH = $i + pH - iE - mH, gH = $i + hH - iE, oE = wr(_t ? y(ip, vH) : ip, $i, _t ? v(ml, gH) : ml);
            Rn[cn] = oE, Ni[cn] = oE - $i;
          }
          if (de) {
            var aE, yH = cn === "x" ? K : ae, bH = cn === "x" ? z : q, gl = Rn[In], cp = In === "y" ? "height" : "width", lE = gl + Tn[yH], cE = gl - Tn[bH], Cg = [K, ae].indexOf(Mn) !== -1, uE = (aE = kr == null ? void 0 : kr[In]) != null ? aE : 0, dE = Cg ? lE : gl - Ir[cp] - Rr[cp] - uE + is.altAxis, fE = Cg ? gl + Ir[cp] + Rr[cp] - uE - is.altAxis : cE, pE = _t && Cg ? Bs(dE, gl, fE) : wr(_t ? dE : lE, gl, _t ? fE : cE);
            Rn[In] = pE, Ni[In] = pE - gl;
          }
          I.modifiersData[W] = Ni;
        }
      }
      var fl = { name: "preventOverflow", enabled: !0, phase: "main", fn: dl, requiresIfExists: ["offset"] }, Zu = function(g, I) {
        return g = typeof g == "function" ? g(Object.assign({}, I.rects, { placement: I.placement })) : g, Be(typeof g != "number" ? g : Ht(g, Ae));
      };
      function Xu(g) {
        var I, $ = g.state, W = g.name, G = g.options, re = $.elements.arrow, ue = $.modifiersData.popperOffsets, de = fr($.placement), he = wn(de), ye = [ae, q].indexOf(de) >= 0, Ne = ye ? "height" : "width";
        if (re && ue) {
          var tt = Zu(G.padding, $), ft = te(re), _t = he === "y" ? K : ae, Sn = he === "y" ? z : q, wt = $.rects.reference[Ne] + $.rects.reference[he] - ue[he] - $.rects.popper[Ne], Tn = ue[he] - $.rects.reference[he], Mn = O(re), Qn = Mn ? he === "y" ? Mn.clientHeight || 0 : Mn.clientWidth || 0 : 0, Sr = wt / 2 - Tn / 2, cn = tt[_t], In = Qn - ft[Ne] - tt[Sn], Rn = Qn / 2 - ft[Ne] / 2 + Sr, Ir = wr(cn, Rn, In), Rr = he;
          $.modifiersData[W] = (I = {}, I[Rr] = Ir, I.centerOffset = Ir - Rn, I);
        }
      }
      function M(g) {
        var I = g.state, $ = g.options, W = $.element, G = W === void 0 ? "[data-popper-arrow]" : W;
        G != null && (typeof G != "string" || (G = I.elements.popper.querySelector(G), G)) && Xe(I.elements.popper, G) && (I.elements.arrow = G);
      }
      var J = { name: "arrow", enabled: !0, phase: "main", fn: Xu, effect: M, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
      function F(g, I, $) {
        return $ === void 0 && ($ = { x: 0, y: 0 }), { top: g.top - I.height - $.y, right: g.right - I.width + $.x, bottom: g.bottom - I.height + $.y, left: g.left - I.width - $.x };
      }
      function oe(g) {
        return [K, q, z, ae].some(function(I) {
          return g[I] >= 0;
        });
      }
      function ce(g) {
        var I = g.state, $ = g.name, W = I.rects.reference, G = I.rects.popper, re = I.modifiersData.preventOverflow, ue = at(I, { elementContext: "reference" }), de = at(I, { altBoundary: !0 }), he = F(ue, W), ye = F(de, G, re), Ne = oe(he), tt = oe(ye);
        I.modifiersData[$] = { referenceClippingOffsets: he, popperEscapeOffsets: ye, isReferenceHidden: Ne, hasPopperEscaped: tt }, I.attributes.popper = Object.assign({}, I.attributes.popper, { "data-popper-reference-hidden": Ne, "data-popper-escaped": tt });
      }
      var ie, Se, ke = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: ce }, Oe = [zs, ia, aa, Zt, X, zr, fl, J, ke], Re = ze({ defaultModifiers: Oe }), fe = i("2fa3"), Pe = i("9404"), Ct = { name: "Popover", render(g) {
        return g("div", { class: ["vc-popover-content-wrapper", { "is-interactive": this.isInteractive }], ref: "popover" }, [g("transition", { props: { name: this.transition, appear: !0 }, on: { beforeEnter: this.beforeEnter, afterEnter: this.afterEnter, beforeLeave: this.beforeLeave, afterLeave: this.afterLeave } }, [this.isVisible && g("div", { attrs: { tabindex: -1 }, class: ["vc-popover-content", "direction-" + this.direction, this.contentClass] }, [this.content, g("span", { class: ["vc-popover-caret", "direction-" + this.direction, "align-" + this.alignment] })])])]);
      }, props: { id: { type: String, required: !0 }, contentClass: String }, data() {
        return { ref: null, opts: null, data: null, transition: "slide-fade", placement: "bottom", positionFixed: !1, modifiers: [], isInteractive: !1, isHovered: !1, isFocused: !1, showDelay: 0, hideDelay: 110, autoHide: !1, popperEl: null };
      }, computed: { content() {
        var g = this;
        return Object(Pe.k)(this.$scopedSlots.default) && this.$scopedSlots.default({ direction: this.direction, alignment: this.alignment, data: this.data, updateLayout: this.setupPopper, hide: function(I) {
          return g.hide(I);
        } }) || this.$slots.default;
      }, popperOptions() {
        return { placement: this.placement, strategy: this.positionFixed ? "fixed" : "absolute", modifiers: [{ name: "onUpdate", enabled: !0, phase: "afterWrite", fn: this.onPopperUpdate }, ...this.modifiers || []], onFirstUpdate: this.onPopperUpdate };
      }, isVisible() {
        return !(!this.ref || !this.content);
      }, direction() {
        return this.placement && this.placement.split("-")[0] || "bottom";
      }, alignment() {
        const g = this.direction === "left" || this.direction === "right";
        let I = this.placement.split("-");
        return I = I.length > 1 ? I[1] : "", ["start", "top", "left"].includes(I) ? g ? "top" : "left" : ["end", "bottom", "right"].includes(I) ? g ? "bottom" : "right" : g ? "middle" : "center";
      }, state() {
        return this.$popovers[this.id];
      } }, watch: { opts(g, I) {
        I && I.callback && I.callback({ ...I, completed: !g, reason: g ? "Overridden by action" : null });
      } }, mounted() {
        this.popoverEl = this.$refs.popover, this.addEvents();
      }, beforeDestroy() {
        this.destroyPopper(), this.removeEvents(), this.popoverEl = null;
      }, methods: { addEvents() {
        Object(fe.k)(this.popoverEl, "click", this.onClick), Object(fe.k)(this.popoverEl, "mouseover", this.onMouseOver), Object(fe.k)(this.popoverEl, "mouseleave", this.onMouseLeave), Object(fe.k)(this.popoverEl, "focusin", this.onFocusIn), Object(fe.k)(this.popoverEl, "focusout", this.onFocusOut), Object(fe.k)(document, "keydown", this.onDocumentKeydown), Object(fe.k)(document, "click", this.onDocumentClick), Object(fe.k)(document, "show-popover", this.onDocumentShowPopover), Object(fe.k)(document, "hide-popover", this.onDocumentHidePopover), Object(fe.k)(document, "toggle-popover", this.onDocumentTogglePopover), Object(fe.k)(document, "update-popover", this.onDocumentUpdatePopover);
      }, removeEvents() {
        Object(fe.j)(this.popoverEl, "click", this.onClick), Object(fe.j)(this.popoverEl, "mouseover", this.onMouseOver), Object(fe.j)(this.popoverEl, "mouseleave", this.onMouseLeave), Object(fe.j)(this.popoverEl, "focusin", this.onFocusIn), Object(fe.j)(this.popoverEl, "focusout", this.onFocusOut), Object(fe.j)(document, "keydown", this.onDocumentKeydown), Object(fe.j)(document, "click", this.onDocumentClick), Object(fe.j)(document, "show-popover", this.onDocumentShowPopover), Object(fe.j)(document, "hide-popover", this.onDocumentHidePopover), Object(fe.j)(document, "toggle-popover", this.onDocumentTogglePopover), Object(fe.j)(document, "update-popover", this.onDocumentUpdatePopover);
      }, onClick(g) {
        g.stopPropagation();
      }, onMouseOver() {
        this.isHovered = !0, this.isInteractive && this.show();
      }, onMouseLeave() {
        this.isHovered = !1, !this.autoHide || this.isFocused || this.ref && this.ref === document.activeElement || this.hide();
      }, onFocusIn() {
        this.isFocused = !0, this.isInteractive && this.show();
      }, onFocusOut(g) {
        g.relatedTarget && Object(fe.e)(this.popoverEl, g.relatedTarget) || (this.isFocused = !1, !this.isHovered && this.autoHide && this.hide());
      }, onDocumentClick(g) {
        this.$refs.popover && this.ref && (Object(fe.e)(this.popoverEl, g.target) || Object(fe.e)(this.ref, g.target) || this.hide());
      }, onDocumentKeydown(g) {
        g.key !== "Esc" && g.key !== "Escape" || this.hide();
      }, onDocumentShowPopover({ detail: g }) {
        g.id && g.id === this.id && this.show(g);
      }, onDocumentHidePopover({ detail: g }) {
        g.id && g.id === this.id && this.hide(g);
      }, onDocumentTogglePopover({ detail: g }) {
        g.id && g.id === this.id && this.toggle(g);
      }, onDocumentUpdatePopover({ detail: g }) {
        g.id && g.id === this.id && this.update(g);
      }, show(g = {}) {
        var I = this;
        g.action = "show";
        const $ = g.ref || this.ref, W = g.showDelay >= 0 ? g.showDelay : this.showDelay;
        if (!$) return void (g.callback && g.callback({ completed: !1, reason: "Invalid reference element provided" }));
        clearTimeout(this.timeout), this.opts = g;
        const G = function() {
          Object.assign(I, g), I.setupPopper(), I.opts = null;
        };
        W > 0 ? this.timeout = setTimeout(function() {
          return G();
        }, W) : G();
      }, hide(g = {}) {
        var I = this;
        g.action = "hide";
        const $ = g.ref || this.ref, W = g.hideDelay >= 0 ? g.hideDelay : this.hideDelay;
        if (!this.ref || $ !== this.ref) return void (g.callback && g.callback({ ...g, completed: !1, reason: this.ref ? "Invalid reference element provided" : "Popover already hidden" }));
        const G = function() {
          I.ref = null, I.opts = null;
        };
        clearTimeout(this.timeout), this.opts = g, W > 0 ? this.timeout = setTimeout(G, W) : G();
      }, toggle(g = {}) {
        this.isVisible && g.ref === this.ref ? this.hide(g) : this.show(g);
      }, update(g = {}) {
        Object.assign(this, g), this.setupPopper();
      }, setupPopper() {
        var g = this;
        this.$nextTick(function() {
          g.ref && g.$refs.popover && (g.popper && g.popper.reference !== g.ref && g.destroyPopper(), g.popper ? g.popper.update() : g.popper = Re(g.ref, g.popoverEl, g.popperOptions));
        });
      }, onPopperUpdate(g) {
        g.placement ? this.placement = g.placement : g.state && (this.placement = g.state.placement);
      }, beforeEnter(g) {
        this.$emit("beforeShow", g);
      }, afterEnter(g) {
        this.$emit("afterShow", g);
      }, beforeLeave(g) {
        this.$emit("beforeHide", g);
      }, afterLeave(g) {
        this.destroyPopper(), this.$emit("afterHide", g);
      }, destroyPopper() {
        this.popper && (this.popper.destroy(), this.popper = null);
      } } }, zt = Ct;
      i("2745");
      function bt(g, I, $, W, G, re, ue, de) {
        var he, ye = typeof g == "function" ? g.options : g;
        return I && (ye.render = I, ye.staticRenderFns = $, ye._compiled = !0), re && (ye._scopeId = "data-v-" + re), { exports: g, options: ye };
      }
      var On = bt(zt, ie, Se, !1, null, "03f17c2c"), hn = On.exports, Ur = function() {
        var g = this, I = g._self._c;
        return I("div", { staticClass: "vc-day-popover-row" }, [g.indicator ? I("div", { staticClass: "vc-day-popover-row-indicator" }, [I("span", { class: g.indicator.class, style: g.indicator.style })]) : g._e(), I("div", { staticClass: "vc-day-popover-row-content" }, [g._t("default", function() {
          return [g._v(g._s(g.attribute.popover ? g.attribute.popover.label : "No content provided"))];
        })], 2)]);
      }, Qi = [], gc = i("51ec");
      const yg = { inject: ["sharedState"], mixins: [gc.a], computed: { masks() {
        return this.sharedState.masks;
      }, theme() {
        return this.sharedState.theme;
      }, locale() {
        return this.sharedState.locale;
      }, dayPopoverId() {
        return this.sharedState.dayPopoverId;
      } }, methods: { format(g, I) {
        return this.locale.format(g, I);
      }, pageForDate(g) {
        return this.locale.getDateParts(this.locale.normalizeDate(g));
      } } }, Ku = ["base", "start", "end", "startEnd"], qI = ["class", "contentClass", "style", "contentStyle", "color", "fillMode"], bg = { color: "blue", isDark: !1, highlight: { base: { fillMode: "light" }, start: { fillMode: "solid" }, end: { fillMode: "solid" } }, dot: { base: { fillMode: "solid" }, start: { fillMode: "solid" }, end: { fillMode: "solid" } }, bar: { base: { fillMode: "solid" }, start: { fillMode: "solid" }, end: { fillMode: "solid" } }, content: { base: {}, start: {}, end: {} } };
      class ep {
        constructor(I) {
          Object.assign(this, bg, I);
        }
        normalizeAttr({ config: I, type: $ }) {
          let W = this.color, G = {};
          const re = this[$];
          if (I === !0 || Object(Pe.n)(I)) W = Object(Pe.n)(I) ? I : W, G = { ...re };
          else {
            if (!Object(Pe.m)(I)) return null;
            G = Object(Pe.f)(I, Ku) ? { ...I } : { base: { ...I }, start: { ...I }, end: { ...I } };
          }
          return Object(Pe.b)(G, { start: G.startEnd, end: G.startEnd }, re), Object(Pe.w)(G).forEach(function([ue, de]) {
            let he = W;
            de === !0 || Object(Pe.n)(de) ? (he = Object(Pe.n)(de) ? de : he, G[ue] = { color: he }) : Object(Pe.m)(de) && (Object(Pe.f)(de, qI) ? G[ue] = { ...de } : G[ue] = {}), Object(Pe.e)(G, ue + ".color") || Object(Pe.u)(G, ue + ".color", he);
          }), G;
        }
        normalizeHighlight(I) {
          var $ = this;
          const W = this.normalizeAttr({ config: I, type: "highlight" });
          return Object(Pe.w)(W).forEach(function([G, re]) {
            const ue = Object(Pe.b)(re, { isDark: $.isDark, color: $.color });
            re.style = { ...$.getHighlightBgStyle(ue), ...re.style }, re.contentStyle = { ...$.getHighlightContentStyle(ue), ...re.contentStyle };
          }), W;
        }
        getHighlightBgStyle({ fillMode: I, color: $, isDark: W }) {
          switch (I) {
            case "outline":
            case "none":
              return { backgroundColor: W ? "var(--gray-900)" : "var(--white)", border: "2px solid", borderColor: W ? `var(--${$}-200)` : `var(--${$}-700)`, borderRadius: "var(--rounded-full)" };
            case "light":
              return { backgroundColor: W ? `var(--${$}-800)` : `var(--${$}-200)`, opacity: W ? 0.75 : 1, borderRadius: "var(--rounded-full)" };
            case "solid":
              return { backgroundColor: W ? `var(--${$}-500)` : `var(--${$}-600)`, borderRadius: "var(--rounded-full)" };
            default:
              return { borderRadius: "var(--rounded-full)" };
          }
        }
        getHighlightContentStyle({ fillMode: I, color: $, isDark: W }) {
          switch (I) {
            case "outline":
            case "none":
              return { fontWeight: "var(--font-bold)", color: W ? `var(--${$}-100)` : `var(--${$}-900)` };
            case "light":
              return { fontWeight: "var(--font-bold)", color: W ? `var(--${$}-100)` : `var(--${$}-900)` };
            case "solid":
              return { fontWeight: "var(--font-bold)", color: "var(--white)" };
            default:
              return "";
          }
        }
        bgAccentHigh({ color: I, isDark: $ }) {
          return { backgroundColor: $ ? `var(--${I}-500)` : `var(--${I}-600)` };
        }
        contentAccent({ color: I, isDark: $ }) {
          return I ? { fontWeight: "var(--font-bold)", color: $ ? `var(--${I}-100)` : `var(--${I}-900)` } : null;
        }
        normalizeDot(I) {
          return this.normalizeNonHighlight("dot", I, this.bgAccentHigh);
        }
        normalizeBar(I) {
          return this.normalizeNonHighlight("bar", I, this.bgAccentHigh);
        }
        normalizeContent(I) {
          return this.normalizeNonHighlight("content", I, this.contentAccent);
        }
        normalizeNonHighlight(I, $, W) {
          var G = this;
          const re = this.normalizeAttr({ type: I, config: $ });
          return Object(Pe.w)(re).forEach(function([ue, de]) {
            Object(Pe.b)(de, { isDark: G.isDark, color: G.color }), de.style = { ...W(de), ...de.style };
          }), re;
        }
      }
      var Gs = i("29ae"), eW = i("1315"), tW = i("22f3");
      const nW = { mixins: [gc.a], props: { color: String, isDark: Boolean, firstDayOfWeek: Number, masks: Object, locale: [String, Object], timezone: String, minDate: null, maxDate: null, minDateExact: null, maxDateExact: null, disabledDates: null, availableDates: null, theme: null }, computed: { $theme() {
        return this.theme instanceof ep ? this.theme : new ep({ color: this.passedProp("color", "blue"), isDark: this.passedProp("isDark", !1) });
      }, $locale() {
        if (this.locale instanceof Gs.b) return this.locale;
        const g = Object(Pe.m)(this.locale) ? this.locale : { id: this.locale, firstDayOfWeek: this.firstDayOfWeek, masks: this.masks };
        return new Gs.b(g, { locales: this.$locales, timezone: this.timezone });
      }, disabledDates_() {
        const g = this.normalizeDates(this.disabledDates), { minDate: I, minDateExact: $, maxDate: W, maxDateExact: G } = this;
        if ($ || I) {
          const re = $ ? this.normalizeDate($) : this.normalizeDate(I, { time: "00:00:00" });
          g.push({ start: null, end: new Date(re.getTime() - 1e3) });
        }
        if (G || W) {
          const re = G ? this.normalizeDate(G) : this.normalizeDate(W, { time: "23:59:59" });
          g.push({ start: new Date(re.getTime() + 1e3), end: null });
        }
        return g;
      }, availableDates_() {
        return this.normalizeDates(this.availableDates);
      }, disabledAttribute() {
        return new tW.a({ key: "disabled", dates: this.disabledDates_, excludeDates: this.availableDates_, excludeMode: "includes", order: 100 }, this.$theme, this.$locale);
      } }, created() {
        Object(eW.a)(this.$defaults.screens);
      }, methods: { formatDate(g, I) {
        return this.$locale ? this.$locale.format(g, I) : "";
      }, parseDate(g, I) {
        if (!this.$locale) return null;
        const $ = this.$locale.parse(g, I);
        return Object(Pe.j)($) ? $ : null;
      }, normalizeDate(g, I) {
        return this.$locale ? this.$locale.normalizeDate(g, I) : g;
      }, normalizeDates(g) {
        return this.$locale.normalizeDates(g, { isFullDay: !0 });
      }, pageForDate(g) {
        return this.$locale.getDateParts(this.normalizeDate(g));
      }, pageForThisMonth() {
        return this.pageForDate(/* @__PURE__ */ new Date());
      } } }, rW = { methods: { safeScopedSlot(g, I, $ = null) {
        return Object(Pe.k)(this.$scopedSlots[g]) ? this.$scopedSlots[g](I) : $;
      } } }, tp = yg, QI = nW, _g = rW;
      var sW = { name: "PopoverRow", mixins: [tp], props: { attribute: Object }, computed: { indicator() {
        const { highlight: g, dot: I, bar: $, popover: W } = this.attribute;
        if (W && W.hideIndicator) return null;
        if (g) {
          const { color: G, isDark: re } = g.start;
          return { style: { ...this.theme.bgAccentHigh({ color: G, isDark: !re }), width: "10px", height: "5px", borderRadius: "3px" } };
        }
        if (I) {
          const { color: G, isDark: re } = I.start;
          return { style: { ...this.theme.bgAccentHigh({ color: G, isDark: !re }), width: "5px", height: "5px", borderRadius: "50%" } };
        }
        if ($) {
          const { color: G, isDark: re } = $.start;
          return { style: { ...this.theme.bgAccentHigh({ color: G, isDark: !re }), width: "10px", height: "3px" } };
        }
        return null;
      } } }, iW = sW, oW = (i("ca17"), bt(iW, Ur, Qi, !1, null, "eb5afd1a")), aW = oW.exports, lW = function() {
        var g = this, I = g._self._c;
        return I("div", { staticClass: "vc-nav-container" }, [I("div", { staticClass: "vc-nav-header" }, [I("span", { staticClass: "vc-nav-arrow is-left", class: { "is-disabled": !g.prevItemsEnabled }, attrs: { role: "button", tabindex: g.prevItemsEnabled ? 0 : void 0 }, on: { click: g.movePrev, keydown: function($) {
          return g.onSpaceOrEnter($, g.movePrev);
        } } }, [g._t("nav-left-button", function() {
          return [I("svg-icon", { attrs: { name: "left-arrow", width: "20px", height: "24px" } })];
        })], 2), I("span", { staticClass: "vc-nav-title vc-grid-focus", style: { whiteSpace: "nowrap" }, attrs: { role: "button", tabindex: "0" }, on: { click: g.toggleMode, keydown: function($) {
          return g.onSpaceOrEnter($, g.toggleMode);
        } } }, [g._v(" " + g._s(g.title) + " ")]), I("span", { staticClass: "vc-nav-arrow is-right", class: { "is-disabled": !g.nextItemsEnabled }, attrs: { role: "button", tabindex: g.nextItemsEnabled ? 0 : void 0 }, on: { click: g.moveNext, keydown: function($) {
          return g.onSpaceOrEnter($, g.moveNext);
        } } }, [g._t("nav-right-button", function() {
          return [I("svg-icon", { attrs: { name: "right-arrow", width: "20px", height: "24px" } })];
        })], 2)]), I("div", { staticClass: "vc-nav-items" }, g._l(g.activeItems, function($) {
          return I("span", { key: $.label, class: g.getItemClasses($), attrs: { role: "button", "data-id": $.id, "aria-label": $.ariaLabel, tabindex: $.isDisabled ? void 0 : 0 }, on: { click: $.click, keydown: function(W) {
            return g.onSpaceOrEnter(W, $.click);
          } } }, [g._v(" " + g._s($.label) + " ")]);
        }), 0)]);
      }, cW = [], uW = function() {
        var g = this, I = g._self._c;
        return I("svg", g._g({ staticClass: "vc-svg-icon", attrs: { width: g.width, height: g.height, viewBox: g.viewBox } }, g.$listeners), [I("path", { attrs: { d: g.path } })]);
      }, dW = [];
      const np = "26px", fW = "0 0 32 32", pW = { "left-arrow": { viewBox: "0 -1 16 34", path: "M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z" }, "right-arrow": { viewBox: "-5 -1 16 34", path: "M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z" } };
      var hW = { props: ["name"], data() {
        return { width: np, height: np, viewBox: fW, path: "", isBaseline: !1 };
      }, mounted() {
        this.updateIcon();
      }, watch: { name() {
        this.updateIcon();
      } }, methods: { updateIcon() {
        const g = pW[this.name];
        g && (this.width = g.width || np, this.height = g.height || np, this.viewBox = g.viewBox, this.path = g.path);
      } } }, mW = hW, vW = (i("52ca"), bt(mW, uW, dW, !1, null, "63f7b5ec")), eE = vW.exports;
      const wg = 12;
      var gW = { name: "CalendarNav", components: { SvgIcon: eE }, mixins: [tp], props: { value: { type: Object, default: function() {
        return { month: 0, year: 0 };
      } }, validator: { type: Function, default: function() {
        return function() {
          return !0;
        };
      } } }, data() {
        return { monthMode: !0, yearIndex: 0, yearGroupIndex: 0, onSpaceOrEnter: fe.l };
      }, computed: { month() {
        return this.value && this.value.month || 0;
      }, year() {
        return this.value && this.value.year || 0;
      }, title() {
        return this.monthMode ? this.yearIndex : `${this.firstYear} - ${this.lastYear}`;
      }, monthItems() {
        return this.getMonthItems(this.yearIndex);
      }, yearItems() {
        return this.getYearItems(this.yearGroupIndex);
      }, prevItemsEnabled() {
        return this.monthMode ? this.prevMonthItemsEnabled : this.prevYearItemsEnabled;
      }, nextItemsEnabled() {
        return this.monthMode ? this.nextMonthItemsEnabled : this.nextYearItemsEnabled;
      }, prevMonthItemsEnabled() {
        return this.getMonthItems(this.yearIndex - 1).some(function(g) {
          return !g.isDisabled;
        });
      }, nextMonthItemsEnabled() {
        return this.getMonthItems(this.yearIndex + 1).some(function(g) {
          return !g.isDisabled;
        });
      }, prevYearItemsEnabled() {
        return this.getYearItems(this.yearGroupIndex - 1).some(function(g) {
          return !g.isDisabled;
        });
      }, nextYearItemsEnabled() {
        return this.getYearItems(this.yearGroupIndex + 1).some(function(g) {
          return !g.isDisabled;
        });
      }, activeItems() {
        return this.monthMode ? this.monthItems : this.yearItems;
      }, firstYear() {
        return Object(Pe.g)(this.yearItems.map(function(g) {
          return g.year;
        }));
      }, lastYear() {
        return Object(Pe.p)(this.yearItems.map(function(g) {
          return g.year;
        }));
      } }, watch: { year() {
        this.yearIndex = this.year;
      }, yearIndex(g) {
        this.yearGroupIndex = this.getYearGroupIndex(g);
      }, value() {
        this.focusFirstItem();
      } }, created() {
        this.yearIndex = this.year;
      }, mounted() {
        this.focusFirstItem();
      }, methods: { focusFirstItem() {
        var g = this;
        this.$nextTick(function() {
          const I = g.$el.querySelector(".vc-nav-item:not(.is-disabled)");
          I && I.focus();
        });
      }, getItemClasses({ isActive: g, isCurrent: I, isDisabled: $ }) {
        const W = ["vc-nav-item"];
        return g ? W.push("is-active") : I && W.push("is-current"), $ && W.push("is-disabled"), W;
      }, getYearGroupIndex(g) {
        return Math.floor(g / wg);
      }, getMonthItems(g) {
        var I = this;
        const { month: $, year: W } = this.pageForDate(/* @__PURE__ */ new Date());
        return this.locale.getMonthDates().map(function(G, re) {
          const ue = re + 1;
          return { month: ue, year: g, id: `${g}.${Object(fe.m)(ue, 2)}`, label: I.locale.format(G, I.masks.navMonths), ariaLabel: I.locale.format(G, "MMMM YYYY"), isActive: ue === I.month && g === I.year, isCurrent: ue === $ && g === W, isDisabled: !I.validator({ month: ue, year: g }), click: function() {
            return I.monthClick(ue, g);
          } };
        });
      }, getYearItems(g) {
        var I = this;
        const { _: $, year: W } = this.pageForDate(/* @__PURE__ */ new Date()), G = g * wg, re = G + wg, ue = [];
        for (let de = G; de < re; de += 1) {
          let he = !1;
          for (let ye = 1; ye < 12 && (he = this.validator({ month: ye, year: de }), !he); ye++) ;
          ue.push({ year: de, id: de, label: de, ariaLabel: de, isActive: de === this.year, isCurrent: de === W, isDisabled: !he, click: function() {
            return I.yearClick(de);
          } });
        }
        return ue;
      }, monthClick(g, I) {
        this.validator({ month: g, year: I }) && this.$emit("input", { month: g, year: I });
      }, yearClick(g) {
        this.yearIndex = g, this.monthMode = !0, this.focusFirstItem();
      }, toggleMode() {
        this.monthMode = !this.monthMode;
      }, movePrev() {
        this.prevItemsEnabled && (this.monthMode && this.movePrevYear(), this.movePrevYearGroup());
      }, moveNext() {
        this.nextItemsEnabled && (this.monthMode && this.moveNextYear(), this.moveNextYearGroup());
      }, movePrevYear() {
        this.yearIndex--;
      }, moveNextYear() {
        this.yearIndex++;
      }, movePrevYearGroup() {
        this.yearGroupIndex--;
      }, moveNextYearGroup() {
        this.yearGroupIndex++;
      } } }, yW = gW, bW = (i("dc9e"), bt(yW, lW, cW, !1, null, null)), tE = bW.exports;
      i("3c65");
      function Sg(g) {
        document && document.dispatchEvent(new CustomEvent("show-popover", { detail: g }));
      }
      function Ig(g) {
        document && document.dispatchEvent(new CustomEvent("hide-popover", { detail: g }));
      }
      function nE(g) {
        document && document.dispatchEvent(new CustomEvent("toggle-popover", { detail: g }));
      }
      function _W(g) {
        document && document.dispatchEvent(new CustomEvent("update-popover", { detail: g }));
      }
      function rp(g) {
        const { visibility: I } = g, $ = I === "click", W = I === "hover", G = I === "hover-focus", re = I === "focus";
        g.autoHide = !$;
        let ue = !1, de = !1;
        return { click(he) {
          $ && (g.ref = he.target, nE(g), he.stopPropagation());
        }, mousemove(he) {
          g.ref = he.currentTarget, ue || (ue = !0, (W || G) && Sg(g));
        }, mouseleave(he) {
          g.ref = he.target, ue && (ue = !1, (W || G && !de) && Ig(g));
        }, focusin(he) {
          g.ref = he.currentTarget, de || (de = !0, (re || G) && Sg(g));
        }, focusout(he) {
          g.ref = he.currentTarget, de && !Object(fe.e)(g.ref, he.relatedTarget) && (de = !1, (re || G && !ue) && Ig(g));
        } };
      }
      var wW, SW, IW, EW, xW, CW, TW, PW, kW = { name: "CalendarDay", mixins: [tp, _g], render(g) {
        var I = this;
        const $ = function() {
          return I.hasBackgrounds && g("div", { class: "vc-highlights vc-day-layer" }, I.backgrounds.map(function({ key: ue, wrapperClass: de, class: he, style: ye }) {
            return g("div", { key: ue, class: de }, [g("div", { class: he, style: ye })]);
          }));
        }, W = function() {
          return I.safeScopedSlot("day-content", { day: I.day, attributes: I.day.attributes, attributesMap: I.day.attributesMap, dayProps: I.dayContentProps, dayEvents: I.dayContentEvents }) || g("span", { class: I.dayContentClass, style: I.dayContentStyle, attrs: { ...I.dayContentProps }, on: I.dayContentEvents, ref: "content" }, [I.day.label]);
        }, G = function() {
          return I.hasDots && g("div", { class: "vc-day-layer vc-day-box-center-bottom" }, [g("div", { class: "vc-dots" }, I.dots.map(function({ key: ue, class: de, style: he }) {
            return g("span", { key: ue, class: de, style: he });
          }))]);
        }, re = function() {
          return I.hasBars && g("div", { class: "vc-day-layer vc-day-box-center-bottom" }, [g("div", { class: "vc-bars" }, I.bars.map(function({ key: ue, class: de, style: he }) {
            return g("span", { key: ue, class: de, style: he });
          }))]);
        };
        return g("div", { class: ["vc-day", ...this.day.classes, { "vc-day-box-center-center": !this.$scopedSlots["day-content"] }, { "is-not-in-month": !this.inMonth }] }, [$(), W(), G(), re()]);
      }, inject: ["sharedState"], props: { day: { type: Object, required: !0 } }, data() {
        return { glyphs: {}, dayContentEvents: {} };
      }, computed: { label() {
        return this.day.label;
      }, startTime() {
        return this.day.range.start.getTime();
      }, endTime() {
        return this.day.range.end.getTime();
      }, inMonth() {
        return this.day.inMonth;
      }, isDisabled() {
        return this.day.isDisabled;
      }, backgrounds() {
        return this.glyphs.backgrounds;
      }, hasBackgrounds() {
        return !!Object(fe.b)(this.backgrounds);
      }, content() {
        return this.glyphs.content;
      }, dots() {
        return this.glyphs.dots;
      }, hasDots() {
        return !!Object(fe.b)(this.dots);
      }, bars() {
        return this.glyphs.bars;
      }, hasBars() {
        return !!Object(fe.b)(this.bars);
      }, popovers() {
        return this.glyphs.popovers;
      }, hasPopovers() {
        return !!Object(fe.b)(this.popovers);
      }, dayContentClass() {
        return ["vc-day-content vc-focusable", { "is-disabled": this.isDisabled }, Object(Pe.d)(Object(Pe.p)(this.content), "class") || ""];
      }, dayContentStyle() {
        return Object(Pe.d)(Object(Pe.p)(this.content), "style");
      }, dayContentProps() {
        let g;
        return this.day.isFocusable ? g = "0" : this.day.inMonth && (g = "-1"), { tabindex: g, "aria-label": this.day.ariaLabel, "aria-disabled": this.day.isDisabled ? "true" : "false", role: "button" };
      }, dayEvent() {
        return { ...this.day, el: this.$refs.content, popovers: this.popovers };
      } }, watch: { theme() {
        this.refresh();
      }, popovers() {
        this.refreshPopovers();
      } }, mounted() {
        this.refreshPopovers();
      }, methods: { getDayEvent(g) {
        return { ...this.dayEvent, event: g };
      }, click(g) {
        this.$emit("dayclick", this.getDayEvent(g));
      }, mouseenter(g) {
        this.$emit("daymouseenter", this.getDayEvent(g));
      }, mouseleave(g) {
        this.$emit("daymouseleave", this.getDayEvent(g));
      }, focusin(g) {
        this.$emit("dayfocusin", this.getDayEvent(g));
      }, focusout(g) {
        this.$emit("dayfocusout", this.getDayEvent(g));
      }, keydown(g) {
        this.$emit("daykeydown", this.getDayEvent(g));
      }, refresh() {
        var g = this;
        if (!this.day.refresh) return;
        this.day.refresh = !1;
        const I = { backgrounds: [], dots: [], bars: [], popovers: [], content: [] };
        this.$set(this.day, "attributes", Object.values(this.day.attributesMap || {}).sort(function($, W) {
          return $.order - W.order;
        })), this.day.attributes.forEach(function($) {
          const { targetDate: W } = $, { isDate: G, isComplex: re, startTime: ue, endTime: de } = W, he = g.startTime <= ue, ye = g.endTime >= de, Ne = he && ye, tt = he || ye, ft = { isDate: G, isComplex: re, onStart: he, onEnd: ye, onStartAndEnd: Ne, onStartOrEnd: tt };
          g.processHighlight($, ft, I), g.processNonHighlight($, "content", ft, I.content), g.processNonHighlight($, "dot", ft, I.dots), g.processNonHighlight($, "bar", ft, I.bars), g.processPopover($, I);
        }), this.glyphs = I;
      }, processHighlight({ key: g, highlight: I }, { isDate: $, isComplex: W, onStart: G, onEnd: re, onStartAndEnd: ue }, { backgrounds: de, content: he }) {
        if (!I) return;
        const { base: ye, start: Ne, end: tt } = I;
        $ || W || ue ? (de.push({ key: g, wrapperClass: "vc-day-layer vc-day-box-center-center", class: ["vc-highlight", Ne.class], style: Ne.style }), he.push({ key: g + "-content", class: Ne.contentClass, style: Ne.contentStyle })) : G ? (de.push({ key: g + "-base", wrapperClass: "vc-day-layer vc-day-box-right-center", class: ["vc-highlight vc-highlight-base-start", ye.class], style: ye.style }), de.push({ key: g, wrapperClass: "vc-day-layer vc-day-box-center-center", class: ["vc-highlight", Ne.class], style: Ne.style }), he.push({ key: g + "-content", class: Ne.contentClass, style: Ne.contentStyle })) : re ? (de.push({ key: g + "-base", wrapperClass: "vc-day-layer vc-day-box-left-center", class: ["vc-highlight vc-highlight-base-end", ye.class], style: ye.style }), de.push({ key: g, wrapperClass: "vc-day-layer vc-day-box-center-center", class: ["vc-highlight", tt.class], style: tt.style }), he.push({ key: g + "-content", class: tt.contentClass, style: tt.contentStyle })) : (de.push({ key: g + "-middle", wrapperClass: "vc-day-layer vc-day-box-center-center", class: ["vc-highlight vc-highlight-base-middle", ye.class], style: ye.style }), he.push({ key: g + "-content", class: ye.contentClass, style: ye.contentStyle }));
      }, processNonHighlight(g, I, { isDate: $, onStart: W, onEnd: G }, re) {
        if (!g[I]) return;
        const { key: ue } = g, de = "vc-" + I, { base: he, start: ye, end: Ne } = g[I];
        $ || W ? re.push({ key: ue, class: [de, ye.class], style: ye.style }) : G ? re.push({ key: ue, class: [de, Ne.class], style: Ne.style }) : re.push({ key: ue, class: [de, he.class], style: he.style });
      }, processPopover(g, { popovers: I }) {
        const { key: $, customData: W, popover: G } = g;
        if (!G) return;
        const re = Object(Pe.b)({ key: $, customData: W, attribute: g }, { ...G }, { visibility: G.label ? "hover" : "click", placement: "bottom", isInteractive: !G.label });
        I.splice(0, 0, re);
      }, refreshPopovers() {
        let g = {};
        Object(fe.b)(this.popovers) && (g = rp(Object(Pe.b)({ id: this.dayPopoverId, data: this.day }, ...this.popovers))), this.dayContentEvents = Object(fe.h)({ click: this.click, mouseenter: this.mouseenter, mouseleave: this.mouseleave, focusin: this.focusin, focusout: this.focusout, keydown: this.keydown }, g), _W({ id: this.dayPopoverId, data: this.day });
      } } }, NW = kW, $W = (i("8ab2"), bt(NW, wW, SW, !1, null, "4420d078")), DW = $W.exports, AW = { name: "CalendarPane", mixins: [tp, _g], render(g) {
        var I = this;
        const $ = this.safeScopedSlot("header", this.page) || g("div", { class: "vc-header align-" + this.titlePosition }, [g("div", { class: "vc-title", on: this.navPopoverEvents }, [this.safeScopedSlot("header-title", this.page, this.page.title)])]), W = this.weekdayLabels.map(function(Ne, tt) {
          return g("div", { key: tt + 1, class: "vc-weekday" }, [Ne]);
        }), G = this.showWeeknumbers_.startsWith("left"), re = this.showWeeknumbers_.startsWith("right");
        G ? W.unshift(g("div", { class: "vc-weekday" })) : re && W.push(g("div", { class: "vc-weekday" }));
        const ue = function(Ne) {
          return g("div", { class: ["vc-weeknumber"] }, [g("span", { class: ["vc-weeknumber-content", "is-" + I.showWeeknumbers_], on: { click: function(tt) {
            I.$emit("weeknumberclick", { weeknumber: Ne, days: I.page.days.filter(function(ft) {
              return ft[I.weeknumberKey] === Ne;
            }), event: tt });
          } } }, [Ne])]);
        }, de = [], { daysInWeek: he } = this.locale;
        this.page.days.forEach(function(Ne, tt) {
          const ft = tt % he;
          (G && ft === 0 || re && ft === he) && de.push(ue(Ne[I.weeknumberKey])), de.push(g(DW, { attrs: { day: Ne }, on: { ...I.$listeners }, scopedSlots: I.$scopedSlots, key: Ne.id, ref: "days", refInFor: !0 })), re && ft === he - 1 && de.push(ue(Ne[I.weeknumberKey]));
        });
        const ye = g("div", { class: { "vc-weeks": !0, "vc-show-weeknumbers": this.showWeeknumbers_, "is-left": G, "is-right": re } }, [W, de]);
        return g("div", { class: ["vc-pane", "row-from-end-" + this.rowFromEnd, "column-from-end-" + this.columnFromEnd], ref: "pane" }, [$, ye]);
      }, inheritAttrs: !1, props: { page: Object, position: Number, row: Number, rowFromEnd: Number, column: Number, columnFromEnd: Number, titlePosition: String, navVisibility: String, showWeeknumbers: [Boolean, String], showIsoWeeknumbers: [Boolean, String] }, computed: { weeknumberKey() {
        return this.showWeeknumbers ? "weeknumber" : "isoWeeknumber";
      }, showWeeknumbers_() {
        const g = this.showWeeknumbers || this.showIsoWeeknumbers;
        return g == null ? "" : Object(Pe.i)(g) ? g ? "left" : "" : g.startsWith("right") ? this.columnFromEnd > 1 ? "right" : g : this.column > 1 ? "left" : g;
      }, navVisibility_() {
        return this.propOrDefault("navVisibility", "navVisibility");
      }, navPlacement() {
        switch (this.titlePosition) {
          case "left":
            return "bottom-start";
          case "right":
            return "bottom-end";
          default:
            return "bottom";
        }
      }, navPopoverEvents() {
        const { sharedState: g, navVisibility_: I, navPlacement: $, page: W, position: G } = this;
        return rp({ id: g.navPopoverId, visibility: I, placement: $, modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }], data: { page: W, position: G }, isInteractive: !0 });
      }, weekdayLabels() {
        var g = this;
        return this.locale.getWeekdayDates().map(function(I) {
          return g.format(I, g.masks.weekdays);
        });
      } }, methods: { refresh() {
        this.$refs.days.forEach(function(g) {
          return g.refresh();
        });
      } } }, OW = AW, MW = (i("f954"), i("4638"), bt(OW, IW, EW, !1, null, "74ad501d")), RW = MW.exports, LW = { name: "CustomTransition", render(g) {
        return g("transition", { props: { name: this.name_, appear: this.appear }, on: { beforeEnter: this.beforeEnter, afterEnter: this.afterEnter } }, [this.$slots.default]);
      }, props: { name: String, appear: Boolean }, computed: { name_() {
        return this.name || "none";
      } }, methods: { beforeEnter(g) {
        this.$emit("beforeEnter", g), this.$emit("beforeTransition", g);
      }, afterEnter(g) {
        this.$emit("afterEnter", g), this.$emit("afterTransition", g);
      } } }, FW = LW, BW = (i("0459"), bt(FW, xW, CW, !1, null, "5be4b00c")), jW = BW.exports, WW = i("9349"), HW = i("0733"), VW = (i("3ee2"), { name: "Calendar", render(g) {
        var I = this;
        const $ = this.pages.map(function(ue, de) {
          const he = de + 1, ye = Math.ceil((de + 1) / I.columns), Ne = I.rows - ye + 1, tt = he % I.columns || I.columns, ft = I.columns - tt + 1;
          return g(RW, { attrs: { ...I.$attrs, attributes: I.store }, props: { page: ue, position: he, row: ye, rowFromEnd: Ne, column: tt, columnFromEnd: ft, titlePosition: I.titlePosition_ }, on: { ...I.$listeners, dayfocusin: function(_t) {
            I.lastFocusedDay = _t, I.$emit("dayfocusin", _t);
          }, dayfocusout: function(_t) {
            I.lastFocusedDay = null, I.$emit("dayfocusout", _t);
          } }, scopedSlots: I.$scopedSlots, key: ue.key, ref: "pages", refInFor: !0 });
        }), W = function(ue) {
          const de = function() {
            return I.move(ue ? -I.step_ : I.step_);
          }, he = function(Ne) {
            return Object(fe.l)(Ne, de);
          }, ye = ue ? !I.canMovePrev : !I.canMoveNext;
          return g("div", { class: ["vc-arrow", "is-" + (ue ? "left" : "right"), { "is-disabled": ye }], attrs: { role: "button" }, on: { click: de, keydown: he } }, [(ue ? I.safeScopedSlot("header-left-button", { click: de }) : I.safeScopedSlot("header-right-button", { click: de })) || g(eE, { props: { name: ue ? "left-arrow" : "right-arrow" } })]);
        }, G = function() {
          return g(hn, { props: { id: I.sharedState.navPopoverId, contentClass: "vc-nav-popover-container" }, ref: "navPopover", scopedSlots: { default: function({ data: ue }) {
            const { position: de, page: he } = ue;
            return g(tE, { props: { value: he, position: de, validator: function(ye) {
              return I.canMove(ye, { position: de });
            } }, on: { input: function(ye) {
              return I.move(ye, { position: de });
            } }, scopedSlots: I.$scopedSlots });
          } } });
        }, re = function() {
          return g(hn, { props: { id: I.sharedState.dayPopoverId, contentClass: "vc-day-popover-container" }, scopedSlots: { default: function({ data: ue, updateLayout: de, hide: he }) {
            const ye = ue.attributes ? Object.values(ue.attributes).filter(function(_t) {
              return _t.popover;
            }) : [], Ne = I.$locale.masks, tt = I.formatDate, ft = tt(ue.date, Ne.dayPopover);
            return I.safeScopedSlot("day-popover", { day: ue, attributes: ye, masks: Ne, format: tt, dayTitle: ft, updateLayout: de, hide: he }) || g("div", [Ne.dayPopover && g("div", { class: ["vc-day-popover-header"] }, [ft]), ye.map(function(_t) {
              return g(aW, { key: _t.key, props: { attribute: _t } });
            })]);
          } } });
        };
        return g("div", { attrs: { "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, class: ["vc-container", "vc-" + this.$theme.color, { "vc-is-expanded": this.isExpanded, "vc-is-dark": this.$theme.isDark }], on: { keydown: this.handleKeydown, mouseup: function(ue) {
          return ue.preventDefault();
        } }, ref: "container" }, [G(), g("div", { class: ["vc-pane-container", { "in-transition": this.inTransition }] }, [g(jW, { props: { name: this.transitionName }, on: { beforeEnter: function() {
          I.inTransition = !0;
        }, afterEnter: function() {
          I.inTransition = !1;
        } } }, [g("div", { class: "vc-pane-layout", style: { gridTemplateColumns: `repeat(${this.columns}, 1fr)` }, attrs: { ...this.$attrs }, key: Object(fe.b)(this.pages) ? this.pages[0].key : "" }, $)]), g("div", { class: ["vc-arrows-container title-" + this.titlePosition_] }, [W(!0), W(!1)]), this.$scopedSlots.footer && this.$scopedSlots.footer()]), re()]);
      }, mixins: [QI, _g], provide() {
        return { sharedState: this.sharedState };
      }, props: { rows: { type: Number, default: 1 }, columns: { type: Number, default: 1 }, step: Number, titlePosition: String, isExpanded: Boolean, fromDate: Date, toDate: Date, fromPage: Object, toPage: Object, minPage: Object, maxPage: Object, transition: String, attributes: [Object, Array], trimWeeks: Boolean, disablePageSwipe: Boolean }, data() {
        return { pages: [], store: null, lastFocusedDay: null, focusableDay: (/* @__PURE__ */ new Date()).getDate(), transitionName: "", inTransition: !1, sharedState: { navPopoverId: Object(fe.c)(), dayPopoverId: Object(fe.c)(), theme: {}, masks: {}, locale: {} } };
      }, computed: { titlePosition_() {
        return this.propOrDefault("titlePosition", "titlePosition");
      }, firstPage() {
        return Object(Pe.g)(this.pages);
      }, lastPage() {
        return Object(Pe.p)(this.pages);
      }, minPage_() {
        return this.minPage || this.pageForDate(this.minDate);
      }, maxPage_() {
        return this.maxPage || this.pageForDate(this.maxDate);
      }, count() {
        return this.rows * this.columns;
      }, step_() {
        return this.step || this.count;
      }, canMovePrev() {
        return this.canMove(-this.step_);
      }, canMoveNext() {
        return this.canMove(this.step_);
      } }, watch: { $locale() {
        this.refreshLocale(), this.refreshPages({ page: this.firstPage, ignoreCache: !0 }), this.initStore();
      }, $theme() {
        this.refreshTheme(), this.initStore();
      }, fromDate() {
        this.refreshPages();
      }, fromPage(g) {
        const I = this.pages && this.pages[0];
        Object(fe.q)(g, I) || this.refreshPages();
      }, toPage(g) {
        const I = this.pages && this.pages[this.pages.length - 1];
        Object(fe.q)(g, I) || this.refreshPages();
      }, count() {
        this.refreshPages();
      }, attributes: { handler(g) {
        const { adds: I, deletes: $ } = this.store.refresh(g);
        this.refreshAttrs(this.pages, I, $);
      }, deep: !0 }, pages(g) {
        this.refreshAttrs(g, this.store.list, null, !0);
      }, disabledAttribute() {
        this.refreshDisabledDays();
      }, lastFocusedDay(g) {
        g && (this.focusableDay = g.day, this.refreshFocusableDays());
      }, inTransition(g) {
        g ? this.$emit("transition-start") : (this.$emit("transition-end"), this.transitionPromise && (this.transitionPromise.resolve(!0), this.transitionPromise = null));
      } }, created() {
        this.refreshLocale(), this.refreshTheme(), this.initStore(), this.refreshPages();
      }, mounted() {
        var g = this;
        this.disablePageSwipe || (this.removeHandlers = Object(HW.a)(this.$refs.container, function({ toLeft: I, toRight: $ }) {
          I ? g.moveNext() : $ && g.movePrev();
        }, this.$defaults.touch));
      }, destroyed() {
        this.pages = [], this.store.destroy(), this.store = null, this.sharedState = null, this.removeHandlers && this.removeHandlers();
      }, methods: { refreshLocale() {
        this.sharedState.locale = this.$locale, this.sharedState.masks = this.$locale.masks;
      }, refreshTheme() {
        this.sharedState.theme = this.$theme;
      }, canMove(g, I = {}) {
        var $ = this;
        const W = this.$locale.toPage(g, this.firstPage);
        let { position: G } = I;
        if (Object(Pe.l)(g) && (G = 1), !W) return Promise.reject(new Error("Invalid argument provided: " + g));
        if (!G) if (Object(fe.o)(W, this.firstPage)) G = -1;
        else {
          if (!Object(fe.n)(W, this.lastPage)) return Promise.resolve(!0);
          G = 1;
        }
        return Object.assign(I, this.getTargetPageRange(W, { position: G, force: !0 })), Object(fe.s)(I.fromPage, I.toPage).some(function(re) {
          return Object(fe.p)(re, $.minPage_, $.maxPage_);
        });
      }, movePrev(g) {
        return this.move(-this.step_, g);
      }, moveNext(g) {
        return this.move(this.step_, g);
      }, move(g, I = {}) {
        const $ = this.canMove(g, I);
        return I.force || $ ? (this.$refs.navPopover.hide({ hideDelay: 0 }), I.fromPage && !Object(fe.q)(I.fromPage, this.firstPage) ? this.refreshPages({ ...I, page: I.fromPage, position: 1, force: !0 }) : Promise.resolve(!0)) : Promise.reject(new Error("Move target is disabled: " + JSON.stringify(I)));
      }, focusDate(g, I = {}) {
        var $ = this;
        return this.move(g, I).then(function() {
          const W = $.$el.querySelector(`.id-${$.$locale.getDayId(g)}.in-month .vc-focusable`);
          return W ? (W.focus(), Promise.resolve(!0)) : Promise.resolve(!1);
        });
      }, showPageRange(g, I) {
        let $, W;
        if (Object(Pe.j)(g)) $ = this.pageForDate(g);
        else {
          if (!Object(Pe.m)(g)) return Promise.reject(new Error("Invalid page range provided."));
          {
            const { month: ue, year: de } = g, { from: he, to: ye } = g;
            Object(Pe.l)(ue) && Object(Pe.l)(de) ? $ = g : (he || ye) && ($ = Object(Pe.j)(he) ? this.pageForDate(he) : he, W = Object(Pe.j)(ye) ? this.pageForDate(ye) : ye);
          }
        }
        const G = this.lastPage;
        let re = $;
        return Object(fe.n)(W, G) && (re = Object(fe.a)(W, -(this.pages.length - 1))), Object(fe.o)(re, $) && (re = $), this.refreshPages({ ...I, page: re });
      }, getTargetPageRange(g, { position: I, force: $ } = {}) {
        let W = null, G = null;
        if (Object(fe.r)(g)) {
          let re = 0;
          I = +I, isNaN(I) || (re = I > 0 ? 1 - I : -(this.count + I)), W = Object(fe.a)(g, re);
        } else W = this.getDefaultInitialPage();
        return G = Object(fe.a)(W, this.count - 1), $ || (Object(fe.o)(W, this.minPage_) ? W = this.minPage_ : Object(fe.n)(G, this.maxPage_) && (W = Object(fe.a)(this.maxPage_, 1 - this.count)), G = Object(fe.a)(W, this.count - 1)), { fromPage: W, toPage: G };
      }, getDefaultInitialPage() {
        let g = this.fromPage || this.pageForDate(this.fromDate);
        if (!Object(fe.r)(g)) {
          const I = this.toPage || this.pageForDate(this.toPage);
          Object(fe.r)(I) && (g = Object(fe.a)(I, 1 - this.count));
        }
        return Object(fe.r)(g) || (g = this.getPageForAttributes()), Object(fe.r)(g) || (g = this.pageForThisMonth()), g;
      }, refreshPages({ page: g, position: I = 1, force: $, transition: W, ignoreCache: G } = {}) {
        var re = this;
        return new Promise(function(ue, de) {
          const { fromPage: he, toPage: ye } = re.getTargetPageRange(g, { position: I, force: $ }), Ne = [];
          for (let tt = 0; tt < re.count; tt++) Ne.push(re.buildPage(Object(fe.a)(he, tt), G));
          re.refreshDisabledDays(Ne), re.refreshFocusableDays(Ne), re.transitionName = re.getPageTransition(re.pages[0], Ne[0], W), re.pages = Ne, re.$emit("update:from-page", he), re.$emit("update:to-page", ye), re.transitionName && re.transitionName !== "none" ? re.transitionPromise = { resolve: ue, reject: de } : ue(!0);
        });
      }, refreshDisabledDays(g) {
        var I = this;
        this.getPageDays(g).forEach(function($) {
          $.isDisabled = !!I.disabledAttribute && I.disabledAttribute.intersectsDay($);
        });
      }, refreshFocusableDays(g) {
        var I = this;
        this.getPageDays(g).forEach(function($) {
          $.isFocusable = $.inMonth && $.day === I.focusableDay;
        });
      }, getPageDays(g = this.pages) {
        return g.reduce(function(I, $) {
          return I.concat($.days);
        }, []);
      }, getPageTransition(g, I, $ = this.transition) {
        if ($ === "none") return $;
        if ($ === "fade" || !$ && this.count > 1 || !Object(fe.r)(g) || !Object(fe.r)(I)) return "fade";
        const W = Object(fe.o)(I, g);
        return $ === "slide-v" ? W ? "slide-down" : "slide-up" : W ? "slide-right" : "slide-left";
      }, getPageForAttributes() {
        let g = null;
        const I = this.store.pinAttr;
        if (I && I.hasDates) {
          let [$] = I.dates;
          $ = $.start || $.date, g = this.pageForDate($);
        }
        return g;
      }, buildPage({ month: g, year: I }, $) {
        var W = this;
        const G = `${I.toString()}-${g.toString()}`;
        let re = this.pages.find(function(ue) {
          return ue.key === G;
        });
        if (!re || $) {
          const ue = new Date(I, g - 1, 15), de = this.$locale.getMonthComps(g, I), he = this.$locale.getPrevMonthComps(g, I), ye = this.$locale.getNextMonthComps(g, I);
          re = { key: G, month: g, year: I, weeks: this.trimWeeks ? de.weeks : 6, title: this.$locale.format(ue, this.$locale.masks.title), shortMonthLabel: this.$locale.format(ue, "MMM"), monthLabel: this.$locale.format(ue, "MMMM"), shortYearLabel: I.toString().substring(2), yearLabel: I.toString(), monthComps: de, prevMonthComps: he, nextMonthComps: ye, canMove: function(Ne) {
            return W.canMove(Ne);
          }, move: function(Ne) {
            return W.move(Ne);
          }, moveThisMonth: function() {
            return W.moveThisMonth();
          }, movePrevMonth: function() {
            return W.move(he);
          }, moveNextMonth: function() {
            return W.move(ye);
          }, refresh: !0 }, re.days = this.$locale.getCalendarDays(re);
        }
        return re;
      }, initStore() {
        this.store = new WW.a(this.$theme, this.$locale, this.attributes), this.refreshAttrs(this.pages, this.store.list, [], !0);
      }, refreshAttrs(g = [], I = [], $ = [], W) {
        var G = this;
        Object(fe.b)(g) && (g.forEach(function(re) {
          re.days.forEach(function(ue) {
            let de = {};
            W ? ue.refresh = !0 : Object(Pe.f)(ue.attributesMap, $) ? (de = Object(Pe.s)(ue.attributesMap, $), ue.refresh = !0) : de = ue.attributesMap || {}, I.forEach(function(he) {
              const ye = he.intersectsDay(ue);
              if (ye) {
                const Ne = { ...he, targetDate: ye };
                de[he.key] = Ne, ue.refresh = !0;
              }
            }), ue.refresh && (ue.attributesMap = de);
          });
        }), this.$nextTick(function() {
          G.$refs.pages.forEach(function(re) {
            return re.refresh();
          });
        }));
      }, handleKeydown(g) {
        const I = this.lastFocusedDay;
        I != null && (I.event = g, this.handleDayKeydown(I));
      }, handleDayKeydown(g) {
        const { dateFromTime: I, event: $ } = g, W = I(12);
        let G = null;
        switch ($.key) {
          case "ArrowLeft":
            G = Object(o.a)(W, -1);
            break;
          case "ArrowRight":
            G = Object(o.a)(W, 1);
            break;
          case "ArrowUp":
            G = Object(o.a)(W, -7);
            break;
          case "ArrowDown":
            G = Object(o.a)(W, 7);
            break;
          case "Home":
            G = Object(o.a)(W, 1 - g.weekdayPosition);
            break;
          case "End":
            G = Object(o.a)(W, g.weekdayPositionFromEnd);
            break;
          case "PageUp":
            G = $.altKey ? d(W, -1) : u(W, -1);
            break;
          case "PageDown":
            G = $.altKey ? d(W, 1) : u(W, 1);
            break;
        }
        G && ($.preventDefault(), this.focusDate(G).catch(function() {
        }));
      } } }), zW = VW, UW = (i("1c6b"), bt(zW, TW, PW, !1, null, null)), rE = UW.exports, GW = function() {
        var g = this, I = g._self._c;
        return I("div", { staticClass: "vc-time-picker", class: [{ "vc-disabled": g.isDisabled, "vc-bordered": g.showBorder }] }, [I("div", [I("svg", { staticClass: "vc-time-icon", attrs: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", viewBox: "0 0 24 24", stroke: "currentColor" } }, [I("path", { attrs: { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" } })])]), I("div", { staticClass: "vc-date-time" }, [g.date ? I("div", { staticClass: "vc-date" }, [I("span", { staticClass: "vc-weekday" }, [g._v(" " + g._s(g.locale.format(g.date, "WWW")) + " ")]), I("span", { staticClass: "vc-month" }, [g._v(" " + g._s(g.locale.format(g.date, "MMM")) + " ")]), I("span", { staticClass: "vc-day" }, [g._v(" " + g._s(g.locale.format(g.date, "D")) + " ")]), I("span", { staticClass: "vc-year" }, [g._v(" " + g._s(g.locale.format(g.date, "YYYY")) + " ")])]) : g._e(), I("div", { staticClass: "vc-time" }, [I("time-select", { attrs: { options: g.hourOptions_ }, model: { value: g.hours, callback: function($) {
          g.hours = g._n($);
        }, expression: "hours" } }), I("span", { staticStyle: { margin: "0 4px" } }, [g._v(":")]), I("time-select", { attrs: { options: g.minuteOptions }, model: { value: g.minutes, callback: function($) {
          g.minutes = g._n($);
        }, expression: "minutes" } }), g.is24hr ? g._e() : I("div", { staticClass: "vc-am-pm", class: { "vc-disabled": !(g.hours >= 0) } }, [I("button", { class: { active: g.isAM, "vc-disabled": g.amDisabled }, attrs: { type: "button" }, on: { click: function($) {
          $.preventDefault(), g.isAM = !0;
        } } }, [g._v(" AM ")]), I("button", { class: { active: !g.isAM, "vc-disabled": g.pmDisabled }, attrs: { type: "button" }, on: { click: function($) {
          $.preventDefault(), g.isAM = !1;
        } } }, [g._v(" PM ")])])], 1)])]);
      }, YW = [], ZW = function() {
        var g = this, I = g._self._c;
        return I("div", { staticClass: "vc-select" }, [I("select", g._b({ directives: [{ name: "model", rawName: "v-model", value: g.model, expression: "model" }], on: { change: function($) {
          var W = Array.prototype.filter.call($.target.options, function(G) {
            return G.selected;
          }).map(function(G) {
            var re = "_value" in G ? G._value : G.value;
            return re;
          });
          g.model = $.target.multiple ? W : W[0];
        } } }, "select", g.$attrs, !1), g._l(g.options, function($) {
          return I("option", { key: $.value, attrs: { disabled: $.disabled }, domProps: { value: $.value } }, [g._v(" " + g._s($.label) + " ")]);
        }), 0), I("div", { staticClass: "vc-select-arrow" }, [I("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" } }, [I("path", { attrs: { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" } })])])]);
      }, XW = [], KW = { inheritAttrs: !1, props: { options: Array, value: Number }, computed: { model: { get() {
        return this.value;
      }, set(g) {
        this.$emit("input", g);
      } } } }, JW = KW, qW = (i("47c6"), bt(JW, ZW, XW, !1, null, "7b2eaf0a")), QW = qW.exports;
      const eH = [{ value: 0, label: "12" }, { value: 1, label: "1" }, { value: 2, label: "2" }, { value: 3, label: "3" }, { value: 4, label: "4" }, { value: 5, label: "5" }, { value: 6, label: "6" }, { value: 7, label: "7" }, { value: 8, label: "8" }, { value: 9, label: "9" }, { value: 10, label: "10" }, { value: 11, label: "11" }], tH = [{ value: 12, label: "12" }, { value: 13, label: "1" }, { value: 14, label: "2" }, { value: 15, label: "3" }, { value: 16, label: "4" }, { value: 17, label: "5" }, { value: 18, label: "6" }, { value: 19, label: "7" }, { value: 20, label: "8" }, { value: 21, label: "9" }, { value: 22, label: "10" }, { value: 23, label: "11" }];
      var nH = { name: "TimePicker", components: { TimeSelect: QW }, props: { value: { type: Object, required: !0 }, locale: { type: Object, required: !0 }, theme: { type: Object, required: !0 }, is24hr: { type: Boolean, default: !0 }, showBorder: Boolean, isDisabled: Boolean, hourOptions: Array, minuteOptions: Array }, computed: { date() {
        let g = this.locale.normalizeDate(this.value);
        return this.value.hours === 24 && (g = new Date(g.getTime() - 1)), g;
      }, hours: { get() {
        return this.value.hours;
      }, set(g) {
        this.updateValue(g, this.minutes);
      } }, minutes: { get() {
        return this.value.minutes;
      }, set(g) {
        this.updateValue(this.hours, g);
      } }, isAM: { get() {
        return this.value.hours < 12;
      }, set(g) {
        let I = this.hours;
        g && I >= 12 ? I -= 12 : !g && I < 12 && (I += 12), this.updateValue(I, this.minutes);
      } }, amHourOptions() {
        var g = this;
        return eH.filter(function(I) {
          return g.hourOptions.some(function($) {
            return $.value === I.value;
          });
        });
      }, pmHourOptions() {
        var g = this;
        return tH.filter(function(I) {
          return g.hourOptions.some(function($) {
            return $.value === I.value;
          });
        });
      }, hourOptions_() {
        return this.is24hr ? this.hourOptions : this.isAM ? this.amHourOptions : this.pmHourOptions;
      }, amDisabled() {
        return !Object(fe.b)(this.amHourOptions);
      }, pmDisabled() {
        return !Object(fe.b)(this.pmHourOptions);
      } }, methods: { updateValue(g, I) {
        g === this.hours && I === this.minutes || this.$emit("input", { ...this.value, hours: g, minutes: I, seconds: 0, milliseconds: 0 });
      } } }, rH = nH, sH = (i("e177"), bt(rH, GW, YW, !1, null, "f4e11af8")), iH = sH.exports;
      const sE = { type: "auto", mask: "iso", timeAdjust: "" }, oH = [sE, sE], sp = { DATE: "date", DATE_TIME: "datetime", TIME: "time" }, Ys = { NONE: 0, START: 1, END: 2, BOTH: 3 };
      var aH, lH, cH = { name: "DatePicker", render(g) {
        var I = this;
        const $ = function() {
          if (!I.dateParts) return null;
          const re = I.isRange ? I.dateParts : [I.dateParts[0]];
          return g("div", [...re.map(function(ue, de) {
            const he = I.$locale.getHourOptions(I.modelConfig_[de].validHours, ue), ye = I.$locale.getMinuteOptions(I.modelConfig_[de].minuteIncrement, ue);
            return g(iH, { props: { value: ue, locale: I.$locale, theme: I.$theme, is24hr: I.is24hr, minuteIncrement: I.minuteIncrement, showBorder: !I.isTime, isDisabled: I.isDateTime && !ue.isValid || I.isDragging, hourOptions: he, minuteOptions: ye }, on: { input: function(Ne) {
              return I.onTimeInput(Ne, de === 0);
            } } });
          }), I.$scopedSlots.footer && I.$scopedSlots.footer()]);
        }, W = function() {
          return g(rE, { attrs: { ...I.$attrs, attributes: I.attributes_, theme: I.$theme, locale: I.$locale }, props: { minDate: I.minDateExact || I.minDate, maxDate: I.maxDateExact || I.maxDate, disabledDates: I.disabledDates, availableDates: I.availableDates }, on: { ...I.$listeners, dayclick: I.onDayClick, daykeydown: I.onDayKeydown, daymouseenter: I.onDayMouseEnter }, scopedSlots: { ...I.$scopedSlots, footer: I.isDateTime ? $ : I.$scopedSlots.footer }, ref: "calendar" });
        }, G = function() {
          return I.isTime ? g("div", { class: ["vc-container", "vc-" + I.$theme.color, { "vc-is-dark": I.$theme.isDark }] }, [$()]) : W();
        };
        return this.$scopedSlots.default && g("span", [this.$scopedSlots.default(this.slotArgs), g(hn, { props: { id: this.datePickerPopoverId, placement: "bottom-start", contentClass: "vc-container" + (this.isDark ? " vc-is-dark" : "") }, on: { beforeShow: function(re) {
          return I.$emit("popoverWillShow", re);
        }, afterShow: function(re) {
          return I.$emit("popoverDidShow", re);
        }, beforeHide: function(re) {
          return I.$emit("popoverWillHide", re);
        }, afterHide: function(re) {
          return I.$emit("popoverDidHide", re);
        } }, scopedSlots: { default() {
          return G();
        } }, ref: "popover" })]) || G();
      }, mixins: [QI], props: { mode: { type: String, default: sp.DATE }, value: { type: null, required: !0 }, modelConfig: { type: Object, default: function() {
        return {};
      } }, is24hr: Boolean, minuteIncrement: Number, isRequired: Boolean, isRange: Boolean, updateOnInput: Boolean, inputDebounce: Number, popover: { type: Object, default: function() {
        return {};
      } }, dragAttribute: Object, selectAttribute: Object, attributes: Array, validHours: [Object, Array, Function] }, data() {
        return { value_: null, dateParts: null, activeDate: "", dragValue: null, inputValues: ["", ""], updateTimeout: null, watchValue: !0, datePickerPopoverId: Object(fe.c)() };
      }, computed: { updateOnInput_() {
        return this.propOrDefault("updateOnInput", "datePicker.updateOnInput");
      }, inputDebounce_() {
        return this.propOrDefault("inputDebounce", "datePicker.inputDebounce");
      }, isDate() {
        return this.mode.toLowerCase() === sp.DATE;
      }, isDateTime() {
        return this.mode.toLowerCase() === sp.DATE_TIME;
      }, isTime() {
        return this.mode.toLowerCase() === sp.TIME;
      }, isDragging() {
        return !!this.dragValue && this.isRange;
      }, modelConfig_() {
        return this.normalizeConfig(this.modelConfig, oH);
      }, inputMask() {
        const g = this.$locale.masks;
        return this.isTime ? this.is24hr ? g.inputTime24hr : g.inputTime : this.isDateTime ? this.is24hr ? g.inputDateTime24hr : g.inputDateTime : this.$locale.masks.input;
      }, inputMaskHasTime() {
        return /[Hh]/g.test(this.inputMask);
      }, inputMaskHasDate() {
        return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask);
      }, inputMaskPatch() {
        return this.inputMaskHasTime && this.inputMaskHasDate ? Gs.a.DATE_TIME : this.inputMaskHasDate ? Gs.a.DATE : this.inputMaskHasTime ? Gs.a.TIME : void 0;
      }, slotArgs() {
        var g = this;
        const { isRange: I, isDragging: $, updateValue: W, showPopover: G, hidePopover: re, togglePopover: ue } = this, de = I ? { start: this.inputValues[0], end: this.inputValues[1] } : this.inputValues[0], he = [!0, !1].map(function(Ne) {
          return { input: g.onInputInput(Ne), change: g.onInputChange(Ne), keyup: g.onInputKeyup, ...rp({ ...g.popover_, id: g.datePickerPopoverId, callback: function(tt) {
            tt.action === "show" && tt.completed && g.onInputShow(Ne);
          } }) };
        }), ye = I ? { start: he[0], end: he[1] } : he[0];
        return { inputValue: de, inputEvents: ye, isDragging: $, updateValue: W, showPopover: G, hidePopover: re, togglePopover: ue, getPopoverTriggerEvents: rp };
      }, popover_() {
        return this.propOrDefault("popover", "datePicker.popover", "merge");
      }, selectAttribute_() {
        if (!this.hasValue(this.value_)) return null;
        const g = { key: "select-drag", ...this.selectAttribute, dates: this.value_, pinPage: !0 }, { dot: I, bar: $, highlight: W, content: G } = g;
        return I || $ || W || G || (g.highlight = !0), g;
      }, dragAttribute_() {
        if (!this.isRange || !this.hasValue(this.dragValue)) return null;
        const g = { key: "select-drag", ...this.dragAttribute, dates: this.dragValue }, { dot: I, bar: $, highlight: W, content: G } = g;
        return I || $ || W || G || (g.highlight = { startEnd: { fillMode: "outline" } }), g;
      }, attributes_() {
        const g = Object(Pe.h)(this.attributes) ? [...this.attributes] : [];
        return this.dragAttribute_ ? g.push(this.dragAttribute_) : this.selectAttribute_ && g.push(this.selectAttribute_), g;
      } }, watch: { inputMask() {
        this.formatInput();
      }, value(g) {
        this.watchValue && this.forceUpdateValue(g, { config: this.modelConfig_, notify: !1, formatInput: !0, hidePopover: !1 });
      }, value_() {
        this.refreshDateParts();
      }, dragValue() {
        this.refreshDateParts();
      }, timezone() {
        this.refreshDateParts(), this.forceUpdateValue(this.value_, { formatInput: !0 });
      } }, created() {
        this.value_ = this.normalizeValue(this.value, this.modelConfig_, Gs.a.DATE_TIME, Ys.BOTH), this.forceUpdateValue(this.value, { config: this.modelConfig_, formatInput: !0, hidePopover: !1 }), this.refreshDateParts();
      }, mounted() {
        Object(fe.k)(document, "keydown", this.onDocumentKeyDown), Object(fe.k)(document, "click", this.onDocumentClick);
      }, destroyed() {
        Object(fe.j)(document, "keydown", this.onDocumentKeyDown), Object(fe.j)(document, "click", this.onDocumentClick);
      }, methods: { getDateParts(g) {
        return this.$locale.getDateParts(g);
      }, getDateFromParts(g) {
        return this.$locale.getDateFromParts(g);
      }, refreshDateParts() {
        var g = this;
        const I = this.dragValue || this.value_, $ = [];
        this.isRange ? (I && I.start ? $.push(this.getDateParts(I.start)) : $.push({}), I && I.end ? $.push(this.getDateParts(I.end)) : $.push({})) : I ? I && I.start ? $.push(this.getDateParts(I.start)) : $.push(this.getDateParts(I)) : $.push({}), this.$nextTick(function() {
          return g.dateParts = $;
        });
      }, onDocumentKeyDown(g) {
        this.dragValue && g.key === "Escape" && (this.dragValue = null);
      }, onDocumentClick(g) {
        document.body.contains(g.target) && !Object(fe.e)(this.$el, g.target) && (this.dragValue = null, this.formatInput());
      }, onDayClick(g) {
        this.handleDayClick(g), this.$emit("dayclick", g);
      }, onDayKeydown(g) {
        switch (g.event.key) {
          case " ":
          case "Enter":
            this.handleDayClick(g), g.event.preventDefault();
            break;
          case "Escape":
            this.hidePopover();
        }
        this.$emit("daykeydown", g);
      }, handleDayClick(g) {
        const { keepVisibleOnInput: I, visibility: $ } = this.popover_, W = { patch: Gs.a.DATE, adjustTime: !0, formatInput: !0, hidePopover: this.isDate && !I && $ !== "visible" };
        this.isRange ? (this.isDragging ? this.dragTrackingValue.end = g.date : this.dragTrackingValue = { ...g.range }, W.isDragging = !this.isDragging, W.rangePriority = W.isDragging ? Ys.NONE : Ys.BOTH, W.hidePopover = W.hidePopover && !W.isDragging, this.updateValue(this.dragTrackingValue, W)) : (W.clearIfEqual = !this.isRequired, this.updateValue(g.date, W));
      }, onDayMouseEnter(g) {
        this.isDragging && (this.dragTrackingValue.end = g.date, this.updateValue(this.dragTrackingValue, { patch: Gs.a.DATE, adjustTime: !0, formatInput: !0, hidePopover: !1, rangePriority: Ys.NONE }));
      }, onTimeInput(g, I) {
        var $ = this;
        let W = null;
        if (this.isRange) {
          const G = I ? g : this.dateParts[0], re = I ? this.dateParts[1] : g;
          W = { start: G, end: re };
        } else W = g;
        this.updateValue(W, { patch: Gs.a.TIME, rangePriority: I ? Ys.START : Ys.END }).then(function() {
          return $.adjustPageRange(I);
        });
      }, onInputInput(g) {
        var I = this;
        return function($) {
          I.updateOnInput_ && I.onInputUpdate($.target.value, g, { formatInput: !1, hidePopover: !1, debounce: I.inputDebounce_ });
        };
      }, onInputChange(g) {
        var I = this;
        return function($) {
          I.onInputUpdate($.target.value, g, { formatInput: !0, hidePopover: !1 });
        };
      }, onInputUpdate(g, I, $) {
        var W = this;
        this.inputValues.splice(I ? 0 : 1, 1, g);
        const G = this.isRange ? { start: this.inputValues[0], end: this.inputValues[1] || this.inputValues[0] } : g, re = { type: "string", mask: this.inputMask };
        this.updateValue(G, { ...$, config: re, patch: this.inputMaskPatch, rangePriority: I ? Ys.START : Ys.END }).then(function() {
          return W.adjustPageRange(I);
        });
      }, onInputShow(g) {
        this.adjustPageRange(g);
      }, onInputKeyup(g) {
        g.key === "Escape" && this.updateValue(this.value_, { formatInput: !0, hidePopover: !0 });
      }, normalizeConfig(g, I = this.modelConfig_) {
        var $ = this;
        return g = Object(Pe.h)(g) ? g : [g.start || g, g.end || g], I.map(function(W, G) {
          return { validHours: $.validHours, minuteIncrement: $.minuteIncrement, ...W, ...g[G] };
        });
      }, updateValue(g, I = {}) {
        var $ = this;
        return clearTimeout(this.updateTimeout), new Promise(function(W) {
          const { debounce: G, ...re } = I;
          G > 0 ? $.updateTimeout = setTimeout(function() {
            $.forceUpdateValue(g, re), W($.value_);
          }, G) : ($.forceUpdateValue(g, re), W($.value_));
        });
      }, forceUpdateValue(g, { config: I = this.modelConfig_, patch: $ = Gs.a.DATE_TIME, clearIfEqual: W = !1, formatInput: G = !0, hidePopover: re = !1, isDragging: ue = this.isDragging, rangePriority: de = Ys.BOTH } = {}) {
        var he = this;
        I = this.normalizeConfig(I);
        let ye = this.normalizeValue(g, I, $, de);
        !ye && this.isRequired && (ye = this.value_), ye = this.adjustTimeForValue(ye, I);
        const Ne = this.valueIsDisabled(ye);
        if (Ne) {
          if (ue) return;
          ye = this.value_, re = !1;
        }
        const tt = ue ? "dragValue" : "value_";
        let ft = !this.valuesAreEqual(this[tt], ye);
        if (Ne || ft || !W || (ye = null, ft = !0), ft) {
          this.$set(this, tt, ye), ue || (this.dragValue = null);
          const _t = this.denormalizeValue(ye), Sn = this.isDragging ? "drag" : "input";
          this.watchValue = !1, this.$emit(Sn, _t), this.$nextTick(function() {
            return he.watchValue = !0;
          });
        }
        re && this.hidePopover(), G && this.formatInput();
      }, hasValue(g) {
        return this.isRange ? Object(Pe.m)(g) && !!g.start && !!g.end : !!g;
      }, normalizeValue(g, I, $, W) {
        if (!this.hasValue(g)) return null;
        if (this.isRange) {
          const G = {}, re = g.start > g.end ? g.end : g.start;
          G.start = this.normalizeDate(re, { ...I[0], fillDate: this.value_ && this.value_.start || I[0].fillDate, patch: $ });
          const ue = g.start > g.end ? g.start : g.end;
          return G.end = this.normalizeDate(ue, { ...I[1], fillDate: this.value_ && this.value_.end || I[1].fillDate, patch: $ }), this.sortRange(G, W);
        }
        return this.normalizeDate(g, { ...I[0], fillDate: this.value_ || I[0].fillDate, patch: $ });
      }, adjustTimeForValue(g, I) {
        return this.hasValue(g) ? this.isRange ? { start: this.$locale.adjustTimeForDate(g.start, I[0]), end: this.$locale.adjustTimeForDate(g.end, I[1]) } : this.$locale.adjustTimeForDate(g, I[0]) : null;
      }, sortRange(g, I = Ys.NONE) {
        const { start: $, end: W } = g;
        if ($ > W) switch (I) {
          case Ys.START:
            return { start: $, end: $ };
          case Ys.END:
            return { start: W, end: W };
          case Ys.BOTH:
            return { start: W, end: $ };
        }
        return { start: $, end: W };
      }, denormalizeValue(g, I = this.modelConfig_) {
        return this.isRange ? this.hasValue(g) ? { start: this.$locale.denormalizeDate(g.start, I[0]), end: this.$locale.denormalizeDate(g.end, I[1]) } : null : this.$locale.denormalizeDate(g, I[0]);
      }, valuesAreEqual(g, I) {
        if (this.isRange) {
          const $ = this.hasValue(g), W = this.hasValue(I);
          return !$ && !W || $ === W && Object(fe.d)(g.start, I.start) && Object(fe.d)(g.end, I.end);
        }
        return Object(fe.d)(g, I);
      }, valueIsDisabled(g) {
        return this.hasValue(g) && this.disabledAttribute && this.disabledAttribute.intersectsDate(g);
      }, formatInput() {
        var g = this;
        this.$nextTick(function() {
          const I = g.normalizeConfig({ type: "string", mask: g.inputMask }), $ = g.denormalizeValue(g.dragValue || g.value_, I);
          g.isRange ? g.inputValues = [$ && $.start, $ && $.end] : g.inputValues = [$, ""];
        });
      }, showPopover(g = {}) {
        Sg({ ref: this.$el, ...this.popover_, ...g, isInteractive: !0, id: this.datePickerPopoverId });
      }, hidePopover(g = {}) {
        Ig({ hideDelay: 10, ...this.popover_, ...g, id: this.datePickerPopoverId });
      }, togglePopover(g) {
        nE({ ref: this.$el, ...this.popover_, ...g, isInteractive: !0, id: this.datePickerPopoverId });
      }, adjustPageRange(g) {
        var I = this;
        this.$nextTick(function() {
          const $ = I.$refs.calendar, W = I.getPageForValue(g), G = g ? 1 : -1;
          W && $ && !Object(fe.p)(W, $.firstPage, $.lastPage) && $.move(W, { position: G, transition: "fade" });
        });
      }, getPageForValue(g) {
        return this.hasValue(this.value_) ? this.pageForDate(this.isRange ? this.value_[g ? "start" : "end"] : this.value_) : null;
      }, move(g, I) {
        return this.$refs.calendar ? this.$refs.calendar.move(g, I) : Promise.reject(new Error("Navigation disabled while calendar is not yet displayed"));
      }, focusDate(g, I) {
        return this.$refs.calendar ? this.$refs.calendar.focusDate(g, I) : Promise.reject(new Error("Navigation disabled while calendar is not yet displayed"));
      } } }, uH = cH, dH = bt(uH, aH, lH, !1, null, null), fH = dH.exports;
    }, "2b10": function(r, s) {
      function i(o, a, l) {
        var c = -1, u = o.length;
        a < 0 && (a = -a > u ? 0 : u + a), l = l > u ? u : l, l < 0 && (l += u), u = a > l ? 0 : l - a >>> 0, a >>>= 0;
        for (var d = Array(u); ++c < u; ) d[c] = o[c + a];
        return d;
      }
      r.exports = i;
    }, "2b3e": function(r, s, i) {
      var o = i("585a"), a = typeof self == "object" && self && self.Object === Object && self, l = o || a || Function("return this")();
      r.exports = l;
    }, "2ba4": function(r, s, i) {
      var o = i("40d5"), a = Function.prototype, l = a.apply, c = a.call;
      r.exports = typeof Reflect == "object" && Reflect.apply || (o ? c.bind(l) : function() {
        return c.apply(l, arguments);
      });
    }, "2cfd": function(r, s, i) {
      function o(a) {
        if (a === null || a === !0 || a === !1) return NaN;
        var l = Number(a);
        return isNaN(l) ? l : l < 0 ? Math.ceil(l) : Math.floor(l);
      }
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = o, r.exports = s.default;
    }, "2d00": function(r, s, i) {
      var o, a, l = i("da84"), c = i("342f"), u = l.process, d = l.Deno, f = u && u.versions || d && d.version, p = f && f.v8;
      p && (o = p.split("."), a = o[0] > 0 && o[0] < 4 ? 1 : +(o[0] + o[1])), !a && c && (o = c.match(/Edge\/(\d+)/), (!o || o[1] >= 74) && (o = c.match(/Chrome\/(\d+)/), o && (a = +o[1]))), r.exports = a;
    }, "2d7c": function(r, s) {
      function i(o, a) {
        for (var l = -1, c = o == null ? 0 : o.length, u = 0, d = []; ++l < c; ) {
          var f = o[l];
          a(f, l, o) && (d[u++] = f);
        }
        return d;
      }
      r.exports = i;
    }, "2dcb": function(r, s, i) {
      var o = i("91e9"), a = o(Object.getPrototypeOf, Object);
      r.exports = a;
    }, "2ec1": function(r, s, i) {
      var o = i("100e"), a = i("9aff");
      function l(c) {
        return o(function(u, d) {
          var f = -1, p = d.length, h = p > 1 ? d[p - 1] : void 0, m = p > 2 ? d[2] : void 0;
          for (h = c.length > 3 && typeof h == "function" ? (p--, h) : void 0, m && a(d[0], d[1], m) && (h = p < 3 ? void 0 : h, p = 1), u = Object(u); ++f < p; ) {
            var v = d[f];
            v && c(u, v, f, h);
          }
          return u;
        });
      }
      r.exports = l;
    }, "2fa3": function(r, s, i) {
      i.d(s, "m", function() {
        return a;
      }), i.d(s, "f", function() {
        return l;
      }), i.d(s, "h", function() {
        return c;
      }), i.d(s, "r", function() {
        return u;
      }), i.d(s, "o", function() {
        return d;
      }), i.d(s, "n", function() {
        return f;
      }), i.d(s, "p", function() {
        return p;
      }), i.d(s, "q", function() {
        return h;
      }), i.d(s, "a", function() {
        return m;
      }), i.d(s, "s", function() {
        return v;
      }), i.d(s, "d", function() {
        return y;
      }), i.d(s, "b", function() {
        return _;
      }), i.d(s, "i", function() {
        return w;
      }), i.d(s, "k", function() {
        return S;
      }), i.d(s, "j", function() {
        return E;
      }), i.d(s, "e", function() {
        return x;
      }), i.d(s, "l", function() {
        return T;
      }), i.d(s, "c", function() {
        return C;
      }), i.d(s, "g", function() {
        return k;
      }), i("14d9");
      var o = i("9404");
      const a = function(b, P, N = "0") {
        for (b = b != null ? String(b) : "", P = P || 2; b.length < P; ) b = `${N}${b}`;
        return b;
      }, l = function(b, P) {
        return Object(o.k)(b) ? b(P) : b;
      }, c = function(...b) {
        const P = {};
        return b.forEach(function(N) {
          return Object.entries(N).forEach(function([D, H]) {
            P[D] ? Object(o.h)(P[D]) ? P[D].push(H) : P[D] = [P[D], H] : P[D] = H;
          });
        }), P;
      }, u = function(b) {
        return !!(b && b.month && b.year);
      }, d = function(b, P) {
        return !(!u(b) || !u(P)) && (b.year === P.year ? b.month < P.month : b.year < P.year);
      }, f = function(b, P) {
        return !(!u(b) || !u(P)) && (b.year === P.year ? b.month > P.month : b.year > P.year);
      }, p = function(b, P, N) {
        return !!b && !d(b, P) && !f(b, N);
      }, h = function(b, P) {
        return !(!b && P) && !(b && !P) && (!b && !P || b.month === P.month && b.year === P.year);
      }, m = function({ month: b, year: P }, N) {
        const D = N > 0 ? 1 : -1;
        for (let H = 0; H < Math.abs(N); H++) b += D, b > 12 ? (b = 1, P++) : b < 1 && (b = 12, P--);
        return { month: b, year: P };
      }, v = function(b, P) {
        if (!u(b) || !u(P)) return [];
        const N = [];
        for (; !f(b, P); ) N.push(b), b = m(b, 1);
        return N;
      };
      function y(b, P) {
        const N = Object(o.j)(b), D = Object(o.j)(P);
        return !N && !D || N === D && b.getTime() === P.getTime();
      }
      const _ = function(b) {
        return Object(o.h)(b) && b.length;
      }, w = function(b, P, N) {
        const D = [];
        return N.forEach(function(H) {
          const Y = H.name || H.toString(), te = H.mixin, A = H.validate;
          if (Object.prototype.hasOwnProperty.call(b, Y)) {
            const j = A ? A(b[Y]) : b[Y];
            P[Y] = te && Object(o.m)(j) ? { ...te, ...j } : j, D.push(Y);
          }
        }), { target: P, assigned: D.length ? D : null };
      }, S = function(b, P, N, D) {
        b && P && N && b.addEventListener(P, N, D);
      }, E = function(b, P, N, D) {
        b && P && b.removeEventListener(P, N, D);
      }, x = function(b, P) {
        return !!b && !!P && (b === P || b.contains(P));
      }, T = function(b, P) {
        b.key !== " " && b.key !== "Enter" || (P(b), b.preventDefault());
      }, C = function() {
        function b() {
          return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
        }
        return `${b() + b()}-${b()}-${b()}-${b()}-${b()}${b()}${b()}`;
      };
      function k(b) {
        let P, N = 0, D = 0;
        if (b.length === 0) return N;
        for (D = 0; D < b.length; D++) P = b.charCodeAt(D), N = (N << 5) - N + P, N |= 0;
        return N;
      }
    }, "2fcc": function(r, s) {
      function i(o) {
        var a = this.__data__, l = a.delete(o);
        return this.size = a.size, l;
      }
      r.exports = i;
    }, "2feb": function(r, s, i) {
      var o = i("d798");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("010e9ae0", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, 3092: function(r, s, i) {
      var o = i("4284"), a = i("badf"), l = i("361d"), c = i("6747"), u = i("9aff");
      function d(f, p, h) {
        var m = c(f) ? o : l;
        return h && u(f, p, h) && (p = void 0), m(f, a(p, 3));
      }
      r.exports = d;
    }, "30c9": function(r, s, i) {
      var o = i("9520"), a = i("b218");
      function l(c) {
        return c != null && a(c.length) && !o(c);
      }
      r.exports = l;
    }, "32b3": function(r, s, i) {
      var o = i("872a"), a = i("9638"), l = Object.prototype, c = l.hasOwnProperty;
      function u(d, f, p) {
        var h = d[f];
        c.call(d, f) && a(h, p) && (p !== void 0 || f in d) || o(d, f, p);
      }
      r.exports = u;
    }, "32f4": function(r, s, i) {
      var o = i("2d7c"), a = i("d327"), l = Object.prototype, c = l.propertyIsEnumerable, u = Object.getOwnPropertySymbols, d = u ? function(f) {
        return f == null ? [] : (f = Object(f), o(u(f), function(p) {
          return c.call(f, p);
        }));
      } : a;
      r.exports = d;
    }, "342f": function(r, s, i) {
      r.exports = typeof navigator < "u" && String(navigator.userAgent) || "";
    }, "34ac": function(r, s, i) {
      var o = i("9520"), a = i("1368"), l = i("1a8c"), c = i("dc57"), u = /[\\^$.*+?()[\]{}|]/g, d = /^\[object .+?Constructor\]$/, f = Function.prototype, p = Object.prototype, h = f.toString, m = p.hasOwnProperty, v = RegExp("^" + h.call(m).replace(u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      function y(_) {
        if (!l(_) || a(_)) return !1;
        var w = o(_) ? v : d;
        return w.test(c(_));
      }
      r.exports = y;
    }, "34e9": function(r, s, i) {
      (function(o) {
        var a = i("2af9"), l = i("ed08");
        function c(f, p) {
          if (c.installed) return;
          c.installed = !0;
          const h = l.setupCalendar(p);
          Object.entries(a).forEach(function([m, v]) {
            f.component(`${h.componentPrefix}${m}`, v);
          });
        }
        i.d(s, "c", function() {
          return a.Calendar;
        }), i.d(s, "d", function() {
          return a.CalendarNav;
        }), i.d(s, "f", function() {
          return a.DatePicker;
        }), i.d(s, "h", function() {
          return a.Popover;
        }), i.d(s, "a", function() {
          return l.Attribute;
        }), i.d(s, "b", function() {
          return l.AttributeStore;
        }), i.d(s, "e", function() {
          return l.DateInfo;
        }), i.d(s, "g", function() {
          return l.Locale;
        }), i.d(s, "i", function() {
          return l.addHorizontalSwipeHandler;
        }), i.d(s, "j", function() {
          return l.addPages;
        }), i.d(s, "k", function() {
          return l.arrayHasItems;
        }), i.d(s, "l", function() {
          return l.createGuid;
        }), i.d(s, "m", function() {
          return l.datesAreEqual;
        }), i.d(s, "o", function() {
          return l.elementContains;
        }), i.d(s, "p", function() {
          return l.evalFn;
        }), i.d(s, "q", function() {
          return l.hash;
        }), i.d(s, "r", function() {
          return l.mergeEvents;
        }), i.d(s, "s", function() {
          return l.mixinOptionalProps;
        }), i.d(s, "t", function() {
          return l.off;
        }), i.d(s, "u", function() {
          return l.on;
        }), i.d(s, "v", function() {
          return l.onSpaceOrEnter;
        }), i.d(s, "w", function() {
          return l.pad;
        }), i.d(s, "x", function() {
          return l.pageIsAfterPage;
        }), i.d(s, "y", function() {
          return l.pageIsBeforePage;
        }), i.d(s, "z", function() {
          return l.pageIsBetweenPages;
        }), i.d(s, "A", function() {
          return l.pageIsEqualToPage;
        }), i.d(s, "B", function() {
          return l.pageIsValid;
        }), i.d(s, "C", function() {
          return l.pageRangeToArray;
        }), i.d(s, "D", function() {
          return l.setupCalendar;
        });
        const u = { install: c, ...a, ...l };
        let d = null;
        typeof window < "u" ? d = window.Vue : typeof o < "u" && (d = o.Vue), d && d.use(u), s.n = u;
      }).call(this, i("c8ba"));
    }, 3511: function(r, s, i) {
      var o = TypeError, a = 9007199254740991;
      r.exports = function(l) {
        if (l > a) throw o("Maximum allowed index exceeded");
        return l;
      };
    }, "361d": function(r, s, i) {
      var o = i("48a0");
      function a(l, c) {
        var u;
        return o(l, function(d, f, p) {
          return u = c(d, f, p), !u;
        }), !!u;
      }
      r.exports = a;
    }, 3698: function(r, s) {
      function i(o, a) {
        return o == null ? void 0 : o[a];
      }
      r.exports = i;
    }, 3729: function(r, s, i) {
      var o = i("9e69"), a = i("00fd"), l = i("29f3"), c = "[object Null]", u = "[object Undefined]", d = o ? o.toStringTag : void 0;
      function f(p) {
        return p == null ? p === void 0 ? u : c : d && d in Object(p) ? a(p) : l(p);
      }
      r.exports = f;
    }, 3818: function(r, s, i) {
      var o = i("7e64"), a = i("8057"), l = i("32b3"), c = i("5b01"), u = i("0f0f"), d = i("e538"), f = i("4359"), p = i("54eb"), h = i("1041"), m = i("a994"), v = i("1bac"), y = i("42a2"), _ = i("c87c"), w = i("c2b6"), S = i("fa21"), E = i("6747"), x = i("0d24"), T = i("cc45"), C = i("1a8c"), k = i("d7ee"), b = i("ec69"), P = i("9934"), N = 1, D = 2, H = 4, Y = "[object Arguments]", te = "[object Array]", A = "[object Boolean]", j = "[object Date]", L = "[object Error]", se = "[object Function]", V = "[object GeneratorFunction]", ee = "[object Map]", O = "[object Number]", K = "[object Object]", z = "[object RegExp]", q = "[object Set]", ae = "[object String]", Ee = "[object Symbol]", Ae = "[object WeakMap]", Ue = "[object ArrayBuffer]", qe = "[object DataView]", Qe = "[object Float32Array]", Lt = "[object Float64Array]", Yt = "[object Int8Array]", nn = "[object Int16Array]", qt = "[object Int32Array]", rn = "[object Uint8Array]", sn = "[object Uint8ClampedArray]", zn = "[object Uint16Array]", ns = "[object Uint32Array]", Nt = {};
      function dt(xt, Wt, Tt, _r, dr, qn) {
        var yn, Ve = Wt & N, Ze = Wt & D, it = Wt & H;
        if (Tt && (yn = dr ? Tt(xt, _r, dr, qn) : Tt(xt)), yn !== void 0) return yn;
        if (!C(xt)) return xt;
        var St = E(xt);
        if (St) {
          if (yn = _(xt), !Ve) return f(xt, yn);
        } else {
          var ze = y(xt), $t = ze == se || ze == V;
          if (x(xt)) return d(xt, Ve);
          if (ze == K || ze == Y || $t && !dr) {
            if (yn = Ze || $t ? {} : S(xt), !Ve) return Ze ? h(xt, u(yn, xt)) : p(xt, c(yn, xt));
          } else {
            if (!Nt[ze]) return dr ? xt : {};
            yn = w(xt, ze, Ve);
          }
        }
        qn || (qn = new o());
        var Fs = qn.get(xt);
        if (Fs) return Fs;
        qn.set(xt, yn), k(xt) ? xt.forEach(function(ln) {
          yn.add(dt(ln, Wt, Tt, ln, xt, qn));
        }) : T(xt) && xt.forEach(function(ln, wn) {
          yn.set(wn, dt(ln, Wt, Tt, wn, xt, qn));
        });
        var zs = it ? Ze ? v : m : Ze ? P : b, fr = St ? void 0 : zs(xt);
        return a(fr || xt, function(ln, wn) {
          fr && (wn = ln, ln = xt[wn]), l(yn, wn, dt(ln, Wt, Tt, wn, xt, qn));
        }), yn;
      }
      Nt[Y] = Nt[te] = Nt[Ue] = Nt[qe] = Nt[A] = Nt[j] = Nt[Qe] = Nt[Lt] = Nt[Yt] = Nt[nn] = Nt[qt] = Nt[ee] = Nt[O] = Nt[K] = Nt[z] = Nt[q] = Nt[ae] = Nt[Ee] = Nt[rn] = Nt[sn] = Nt[zn] = Nt[ns] = !0, Nt[L] = Nt[se] = Nt[Ae] = !1, r.exports = dt;
    }, 3852: function(r, s, i) {
      var o = i("96f3"), a = i("e2c0");
      function l(c, u) {
        return c != null && a(c, u, o);
      }
      r.exports = l;
    }, "386f": function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-time-picker[data-v-f4e11af8]{display:flex;align-items:center;padding:8px}.vc-time-picker.vc-invalid[data-v-f4e11af8]{pointer-events:none;opacity:.5}.vc-time-picker.vc-bordered[data-v-f4e11af8]{border-top:1px solid var(--gray-400)}.vc-date-time[data-v-f4e11af8]{margin-left:8px}.vc-disabled[data-v-f4e11af8]{pointer-events:none;opacity:.5}.vc-time-icon[data-v-f4e11af8]{width:16px;height:16px;color:var(--gray-600)}.vc-date[data-v-f4e11af8]{display:flex;align-items:center;font-size:var(--text-sm);font-weight:var(--font-semibold);text-transform:uppercase;padding:0 0 4px 4px;margin-top:-4px}.vc-date .vc-weekday[data-v-f4e11af8]{color:var(--gray-700);letter-spacing:var(--tracking-wide)}.vc-date .vc-month[data-v-f4e11af8]{color:var(--accent-600);margin-left:8px}.vc-date .vc-day[data-v-f4e11af8]{color:var(--accent-600);margin-left:4px}.vc-date .vc-year[data-v-f4e11af8]{color:var(--gray-500);margin-left:8px}.vc-am-pm[data-v-f4e11af8],.vc-time[data-v-f4e11af8]{display:flex;align-items:center}.vc-am-pm[data-v-f4e11af8]{background:var(--gray-200);margin-left:8px;padding:4px;border-radius:var(--rounded);height:30px}.vc-am-pm button[data-v-f4e11af8]{color:var(--gray-900);font-size:var(--text-sm);font-weight:var(--font-medium);padding:0 4px;background:transparent;border:2px solid transparent;border-radius:var(--rounded);line-height:var(--leading-snug)}.vc-am-pm button[data-v-f4e11af8]:hover{color:var(--gray-600)}.vc-am-pm button[data-v-f4e11af8]:focus{border-color:var(--accent-400)}.vc-am-pm button.active[data-v-f4e11af8]{background:var(--accent-600);color:var(--white)}.vc-am-pm button.active[data-v-f4e11af8]:hover{background:var(--accent-500)}.vc-am-pm button.active[data-v-f4e11af8]:focus{border-color:var(--accent-400)}.vc-is-dark .vc-time-picker[data-v-f4e11af8]{border-color:var(--gray-700)}.vc-is-dark .vc-time-icon[data-v-f4e11af8],.vc-is-dark .vc-weekday[data-v-f4e11af8]{color:var(--gray-400)}.vc-is-dark .vc-day[data-v-f4e11af8],.vc-is-dark .vc-month[data-v-f4e11af8]{color:var(--accent-400)}.vc-is-dark .vc-year[data-v-f4e11af8]{color:var(--gray-500)}.vc-is-dark .vc-am-pm[data-v-f4e11af8]{background:var(--gray-700)}.vc-is-dark .vc-am-pm[data-v-f4e11af8]:focus{border-color:var(--accent-500)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]{color:var(--gray-100)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]:hover{color:var(--gray-400)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]:focus{border-color:var(--accent-500)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]{background:var(--accent-500);color:var(--white)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]:hover{background:var(--accent-600)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]:focus{border-color:var(--accent-500)}", ""]), r.exports = s;
    }, 3963: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-day[data-v-4420d078]{position:relative;min-height:32px;z-index:1}.vc-day.is-not-in-month *[data-v-4420d078]{opacity:0;pointer-events:none}.vc-day-layer[data-v-4420d078]{position:absolute;left:0;right:0;top:0;bottom:0;pointer-events:none}.vc-day-box-center-center[data-v-4420d078]{display:flex;justify-content:center;align-items:center;transform-origin:50% 50%}.vc-day-box-left-center[data-v-4420d078]{display:flex;justify-content:flex-start;align-items:center;transform-origin:0 50%}.vc-day-box-right-center[data-v-4420d078]{display:flex;justify-content:flex-end;align-items:center;transform-origin:100% 50%}.vc-day-box-center-bottom[data-v-4420d078]{display:flex;justify-content:center;align-items:flex-end}.vc-day-content[data-v-4420d078]{display:flex;justify-content:center;align-items:center;font-size:var(--text-sm);font-weight:var(--font-medium);width:28px;height:28px;line-height:28px;border-radius:var(--rounded-full);-webkit-user-select:none;user-select:none;cursor:pointer}.vc-day-content[data-v-4420d078]:hover{background-color:rgba(204,214,224,.3)}.vc-day-content[data-v-4420d078]:focus{font-weight:var(--font-bold);background-color:rgba(204,214,224,.4)}.vc-day-content.is-disabled[data-v-4420d078]{color:var(--gray-400)}.vc-is-dark .vc-day-content[data-v-4420d078]:hover{background-color:rgba(114,129,151,.3)}.vc-is-dark .vc-day-content[data-v-4420d078]:focus{background-color:rgba(114,129,151,.4)}.vc-is-dark .vc-day-content.is-disabled[data-v-4420d078]{color:var(--gray-600)}.vc-highlights[data-v-4420d078]{overflow:hidden;pointer-events:none;z-index:-1}.vc-highlight[data-v-4420d078]{width:28px;height:28px}.vc-highlight.vc-highlight-base-start[data-v-4420d078]{width:50%!important;border-radius:0!important;border-right-width:0!important}.vc-highlight.vc-highlight-base-end[data-v-4420d078]{width:50%!important;border-radius:0!important;border-left-width:0!important}.vc-highlight.vc-highlight-base-middle[data-v-4420d078]{width:100%;border-radius:0!important;border-left-width:0!important;border-right-width:0!important;margin:0 -1px}.vc-dots[data-v-4420d078]{display:flex;justify-content:center;align-items:center}.vc-dot[data-v-4420d078]{width:5px;height:5px;border-radius:50%;transition:all var(--day-content-transition-time)}.vc-dot[data-v-4420d078]:not(:last-child){margin-right:3px}.vc-bars[data-v-4420d078]{display:flex;justify-content:flex-start;align-items:center;width:75%}.vc-bar[data-v-4420d078]{flex-grow:1;height:3px;transition:all var(--day-content-transition-time)}", ""]), r.exports = s;
    }, "39ff": function(r, s, i) {
      var o = i("0b07"), a = i("2b3e"), l = o(a, "WeakMap");
      r.exports = l;
    }, "3a34": function(r, s, i) {
      var o = i("83ab"), a = i("e8b5"), l = TypeError, c = Object.getOwnPropertyDescriptor, u = o && !function() {
        if (this !== void 0) return !0;
        try {
          Object.defineProperty([], "length", { writable: !1 }).length = 1;
        } catch (d) {
          return d instanceof TypeError;
        }
      }();
      r.exports = u ? function(d, f) {
        if (a(d) && !c(d, "length").writable) throw new l("Cannot set read only .length");
        return d.length = f;
      } : function(d, f) {
        return d.length = f;
      };
    }, "3a9b": function(r, s, i) {
      var o = i("e330");
      r.exports = o({}.isPrototypeOf);
    }, "3b4a": function(r, s, i) {
      var o = i("0b07"), a = function() {
        try {
          var l = o(Object, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }();
      r.exports = a;
    }, "3bb4": function(r, s, i) {
      var o = i("08cc"), a = i("ec69");
      function l(c) {
        for (var u = a(c), d = u.length; d--; ) {
          var f = u[d], p = c[f];
          u[d] = [f, p, o(p)];
        }
        return u;
      }
      r.exports = l;
    }, "3bbe": function(r, s, i) {
      var o = i("1626"), a = String, l = TypeError;
      r.exports = function(c) {
        if (typeof c == "object" || o(c)) return c;
        throw new l("Can't set " + a(c) + " as a prototype");
      };
    }, "3c65": function(r, s, i) {
      var o = i("23e7"), a = i("7b0b"), l = i("07fa"), c = i("3a34"), u = i("083a"), d = i("3511"), f = [].unshift(0) !== 1, p = function() {
        try {
          Object.defineProperty([], "length", { writable: !1 }).unshift();
        } catch (m) {
          return m instanceof TypeError;
        }
      }, h = f || !p();
      o({ target: "Array", proto: !0, arity: 1, forced: h }, { unshift: function(m) {
        var v = a(this), y = l(v), _ = arguments.length;
        if (_) {
          d(y + _);
          for (var w = y; w--; ) {
            var S = w + _;
            w in v ? v[S] = v[w] : u(v, S);
          }
          for (var E = 0; E < _; E++) v[E] = arguments[E];
        }
        return c(v, y + _);
      } });
    }, "3ee2": function(r, s, i) {
      var o = i("dc8c");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("72fef618", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, "3eea": function(r, s, i) {
      var o = i("7948"), a = i("3818"), l = i("4bb5"), c = i("e2e4"), u = i("8eeb"), d = i("e0e7"), f = i("c6cf"), p = i("1bac"), h = 1, m = 2, v = 4, y = f(function(_, w) {
        var S = {};
        if (_ == null) return S;
        var E = !1;
        w = o(w, function(T) {
          return T = c(T, _), E || (E = T.length > 1), T;
        }), u(_, p(_), S), E && (S = a(S, h | m | v, d));
        for (var x = w.length; x--; ) l(S, w[x]);
        return S;
      });
      r.exports = y;
    }, "3f84": function(r, s, i) {
      var o = i("85e3"), a = i("100e"), l = i("e031"), c = i("2411"), u = a(function(d) {
        return d.push(void 0, l), o(c, void 0, d);
      });
      r.exports = u;
    }, "40d5": function(r, s, i) {
      var o = i("d039");
      r.exports = !o(function() {
        var a = (function() {
        }).bind();
        return typeof a != "function" || a.hasOwnProperty("prototype");
      });
    }, "41c3": function(r, s, i) {
      var o = i("1a8c"), a = i("eac5"), l = i("ec8c"), c = Object.prototype, u = c.hasOwnProperty;
      function d(f) {
        if (!o(f)) return l(f);
        var p = a(f), h = [];
        for (var m in f) (m != "constructor" || !p && u.call(f, m)) && h.push(m);
        return h;
      }
      r.exports = d;
    }, 4245: function(r, s, i) {
      var o = i("1290");
      function a(l, c) {
        var u = l.__data__;
        return o(c) ? u[typeof c == "string" ? "string" : "hash"] : u.map;
      }
      r.exports = a;
    }, 4284: function(r, s) {
      function i(o, a) {
        for (var l = -1, c = o == null ? 0 : o.length; ++l < c; ) if (a(o[l], l, o)) return !0;
        return !1;
      }
      r.exports = i;
    }, "42a2": function(r, s, i) {
      var o = i("b5a7"), a = i("79bc"), l = i("1cec"), c = i("c869"), u = i("39ff"), d = i("3729"), f = i("dc57"), p = "[object Map]", h = "[object Object]", m = "[object Promise]", v = "[object Set]", y = "[object WeakMap]", _ = "[object DataView]", w = f(o), S = f(a), E = f(l), x = f(c), T = f(u), C = d;
      (o && C(new o(new ArrayBuffer(1))) != _ || a && C(new a()) != p || l && C(l.resolve()) != m || c && C(new c()) != v || u && C(new u()) != y) && (C = function(k) {
        var b = d(k), P = b == h ? k.constructor : void 0, N = P ? f(P) : "";
        if (N) switch (N) {
          case w:
            return _;
          case S:
            return p;
          case E:
            return m;
          case x:
            return v;
          case T:
            return y;
        }
        return b;
      }), r.exports = C;
    }, 4359: function(r, s) {
      function i(o, a) {
        var l = -1, c = o.length;
        for (a || (a = Array(c)); ++l < c; ) a[l] = o[l];
        return a;
      }
      r.exports = i;
    }, 4416: function(r, s) {
      function i(o) {
        var a = o == null ? 0 : o.length;
        return a ? o[a - 1] : void 0;
      }
      r.exports = i;
    }, "44ad": function(r, s, i) {
      var o = i("e330"), a = i("d039"), l = i("c6b6"), c = Object, u = o("".split);
      r.exports = a(function() {
        return !c("z").propertyIsEnumerable(0);
      }) ? function(d) {
        return l(d) === "String" ? u(d, "") : c(d);
      } : c;
    }, 4638: function(r, s, i) {
      i("6562");
    }, "47c6": function(r, s, i) {
      i("1205");
    }, "485a": function(r, s, i) {
      var o = i("c65b"), a = i("1626"), l = i("861d"), c = TypeError;
      r.exports = function(u, d) {
        var f, p;
        if (d === "string" && a(f = u.toString) && !l(p = o(f, u)) || a(f = u.valueOf) && !l(p = o(f, u)) || d !== "string" && a(f = u.toString) && !l(p = o(f, u))) return p;
        throw new c("Can't convert object to primitive value");
      };
    }, "48a0": function(r, s, i) {
      var o = i("242e"), a = i("950a"), l = a(o);
      r.exports = l;
    }, "499e": function(r, s, i) {
      function o(C, k) {
        for (var b = [], P = {}, N = 0; N < k.length; N++) {
          var D = k[N], H = D[0], Y = D[1], te = D[2], A = D[3], j = { id: C + ":" + N, css: Y, media: te, sourceMap: A };
          P[H] ? P[H].parts.push(j) : b.push(P[H] = { id: H, parts: [j] });
        }
        return b;
      }
      i.r(s), i.d(s, "default", function() {
        return y;
      });
      var a = typeof document < "u";
      if (typeof DEBUG < "u" && DEBUG && !a) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
      var l = {}, c = a && (document.head || document.getElementsByTagName("head")[0]), u = null, d = 0, f = !1, p = function() {
      }, h = null, m = "data-vue-ssr-id", v = typeof navigator < "u" && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
      function y(C, k, b, P) {
        f = b, h = P || {};
        var N = o(C, k);
        return _(N), function(D) {
          for (var H = [], Y = 0; Y < N.length; Y++) {
            var te = N[Y], A = l[te.id];
            A.refs--, H.push(A);
          }
          for (D ? (N = o(C, D), _(N)) : N = [], Y = 0; Y < H.length; Y++)
            if (A = H[Y], A.refs === 0) {
              for (var j = 0; j < A.parts.length; j++) A.parts[j]();
              delete l[A.id];
            }
        };
      }
      function _(C) {
        for (var k = 0; k < C.length; k++) {
          var b = C[k], P = l[b.id];
          if (P) {
            P.refs++;
            for (var N = 0; N < P.parts.length; N++) P.parts[N](b.parts[N]);
            for (; N < b.parts.length; N++) P.parts.push(S(b.parts[N]));
            P.parts.length > b.parts.length && (P.parts.length = b.parts.length);
          } else {
            var D = [];
            for (N = 0; N < b.parts.length; N++) D.push(S(b.parts[N]));
            l[b.id] = { id: b.id, refs: 1, parts: D };
          }
        }
      }
      function w() {
        var C = document.createElement("style");
        return C.type = "text/css", c.appendChild(C), C;
      }
      function S(C) {
        var k, b, P = document.querySelector("style[" + m + '~="' + C.id + '"]');
        if (P) {
          if (f) return p;
          P.parentNode.removeChild(P);
        }
        if (v) {
          var N = d++;
          P = u || (u = w()), k = x.bind(null, P, N, !1), b = x.bind(null, P, N, !0);
        } else P = w(), k = T.bind(null, P), b = function() {
          P.parentNode.removeChild(P);
        };
        return k(C), function(D) {
          if (D) {
            if (D.css === C.css && D.media === C.media && D.sourceMap === C.sourceMap) return;
            k(C = D);
          } else b();
        };
      }
      var E = /* @__PURE__ */ function() {
        var C = [];
        return function(k, b) {
          return C[k] = b, C.filter(Boolean).join(`
`);
        };
      }();
      function x(C, k, b, P) {
        var N = b ? "" : P.css;
        if (C.styleSheet) C.styleSheet.cssText = E(k, N);
        else {
          var D = document.createTextNode(N), H = C.childNodes;
          H[k] && C.removeChild(H[k]), H.length ? C.insertBefore(D, H[k]) : C.appendChild(D);
        }
      }
      function T(C, k) {
        var b = k.css, P = k.media, N = k.sourceMap;
        if (P && C.setAttribute("media", P), h.ssrId && C.setAttribute(m, k.id), N && (b += `
/*# sourceURL=` + N.sources[0] + " */", b += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(N)))) + " */"), C.styleSheet) C.styleSheet.cssText = b;
        else {
          for (; C.firstChild; ) C.removeChild(C.firstChild);
          C.appendChild(document.createTextNode(b));
        }
      }
    }, "49f4": function(r, s, i) {
      var o = i("6044");
      function a() {
        this.__data__ = o ? o(null) : {}, this.size = 0;
      }
      r.exports = a;
    }, "4bb5": function(r, s, i) {
      var o = i("e2e4"), a = i("4416"), l = i("8296"), c = i("f4d6");
      function u(d, f) {
        return f = o(f, d), d = l(d, f), d == null || delete d[c(a(f))];
      }
      r.exports = u;
    }, "4cef": function(r, s) {
      var i = /\s/;
      function o(a) {
        for (var l = a.length; l-- && i.test(a.charAt(l)); ) ;
        return l;
      }
      r.exports = o;
    }, "4cfe": function(r, s) {
      function i(o) {
        return o === void 0;
      }
      r.exports = i;
    }, "4d64": function(r, s, i) {
      var o = i("fc6a"), a = i("23cb"), l = i("07fa"), c = function(u) {
        return function(d, f, p) {
          var h, m = o(d), v = l(m), y = a(p, v);
          if (u && f !== f) {
            for (; v > y; ) if (h = m[y++], h !== h) return !0;
          } else for (; v > y; y++) if ((u || y in m) && m[y] === f) return u || y || 0;
          return !u && -1;
        };
      };
      r.exports = { includes: c(!0), indexOf: c(!1) };
    }, "4d8c": function(r, s, i) {
      var o = i("5c69");
      function a(l) {
        var c = l == null ? 0 : l.length;
        return c ? o(l, 1) : [];
      }
      r.exports = a;
    }, "4f50": function(r, s, i) {
      var o = i("b760"), a = i("e538"), l = i("c8fe"), c = i("4359"), u = i("fa21"), d = i("d370"), f = i("6747"), p = i("dcbe"), h = i("0d24"), m = i("9520"), v = i("1a8c"), y = i("60ed"), _ = i("73ac"), w = i("8adb"), S = i("8de2");
      function E(x, T, C, k, b, P, N) {
        var D = w(x, C), H = w(T, C), Y = N.get(H);
        if (Y) o(x, C, Y);
        else {
          var te = P ? P(D, H, C + "", x, T, N) : void 0, A = te === void 0;
          if (A) {
            var j = f(H), L = !j && h(H), se = !j && !L && _(H);
            te = H, j || L || se ? f(D) ? te = D : p(D) ? te = c(D) : L ? (A = !1, te = a(H, !0)) : se ? (A = !1, te = l(H, !0)) : te = [] : y(H) || d(H) ? (te = D, d(D) ? te = S(D) : v(D) && !m(D) || (te = u(H))) : A = !1;
          }
          A && (N.set(H, te), b(te, H, k, P, N), N.delete(H)), o(x, C, te);
        }
      }
      r.exports = E;
    }, "501e": function(r, s, i) {
      var o = i("3729"), a = i("1310"), l = "[object Number]";
      function c(u) {
        return typeof u == "number" || a(u) && o(u) == l;
      }
      r.exports = c;
    }, "50c4": function(r, s, i) {
      var o = i("5926"), a = Math.min;
      r.exports = function(l) {
        return l > 0 ? a(o(l), 9007199254740991) : 0;
      };
    }, "50d8": function(r, s) {
      function i(o, a) {
        for (var l = -1, c = Array(o); ++l < o; ) c[l] = a(l);
        return c;
      }
      r.exports = i;
    }, "51ec": function(r, s, i) {
      i.d(s, "b", function() {
        return m;
      }), i.d(s, "a", function() {
        return v;
      });
      var o = i("8bbf"), a = i.n(o), l = i("9404"), c = i("23a5"), u = i("7efe"), d = i("85a9"), f = i("f15d");
      const p = { componentPrefix: "v", navVisibility: "click", titlePosition: "center", transition: "slide-h", touch: c, masks: u, screens: d, locales: f.a, datePicker: { updateOnInput: !0, inputDebounce: 1e3, popover: { visibility: "hover-focus", placement: "bottom-start", keepVisibleOnInput: !1, isInteractive: !0 } } };
      let h = null;
      const m = function(y) {
        return h || (h = new a.a({ data() {
          return { defaults: Object(l.c)(y, p) };
        }, computed: { locales() {
          var _ = this;
          return Object(l.r)(this.defaults.locales, function(w) {
            return w.masks = Object(l.c)(w.masks, _.defaults.masks), w;
          });
        } } })), h.defaults;
      }, v = { beforeCreate() {
        m();
      }, computed: { $defaults() {
        return h.defaults;
      }, $locales() {
        return h.locales;
      } }, methods: { propOrDefault(y, _, w) {
        return this.passedProp(y, Object(l.d)(this.$defaults, _), w);
      }, passedProp(y, _, w) {
        if (Object(l.e)(this.$options.propsData, y)) {
          const S = this[y];
          return Object(l.m)(S) && w === "merge" ? Object(l.c)(S, _) : S;
        }
        return _;
      } } };
    }, "52ca": function(r, s, i) {
      i("bfb3");
    }, 5332: function(r, s, i) {
      var o = i("d8e2");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("ecf39550", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, "53ca": function(r, s, i) {
      function o(a) {
        return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
          return typeof l;
        } : function(l) {
          return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
        }, o(a);
      }
      i.d(s, "a", function() {
        return o;
      });
    }, 5465: function(r, s, i) {
      function o(a) {
        var l = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
        return l.setUTCFullYear(a.getFullYear()), a.getTime() - l.getTime();
      }
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = o, r.exports = s.default;
    }, "54eb": function(r, s, i) {
      var o = i("8eeb"), a = i("32f4");
      function l(c, u) {
        return o(c, a(c), u);
      }
      r.exports = l;
    }, "55a3": function(r, s) {
      function i(o) {
        return this.__data__.has(o);
      }
      r.exports = i;
    }, "55ed": function(r, s, i) {
      var o = i("386f");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("557943a7", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, 5692: function(r, s, i) {
      var o = i("c430"), a = i("c6cd");
      (r.exports = function(l, c) {
        return a[l] || (a[l] = c !== void 0 ? c : {});
      })("versions", []).push({ version: "3.33.0", mode: o ? "pure" : "global", copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE", source: "https://github.com/zloirock/core-js" });
    }, "56ef": function(r, s, i) {
      var o = i("d066"), a = i("e330"), l = i("241c"), c = i("7418"), u = i("825a"), d = a([].concat);
      r.exports = o("Reflect", "ownKeys") || function(f) {
        var p = l.f(u(f)), h = c.f;
        return h ? d(p, h(f)) : p;
      };
    }, "577e": function(r, s, i) {
      var o = i("f5df"), a = String;
      r.exports = function(l) {
        if (o(l) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
        return a(l);
      };
    }, "57a5": function(r, s, i) {
      var o = i("91e9"), a = o(Object.keys, Object);
      r.exports = a;
    }, "585a": function(r, s, i) {
      (function(o) {
        var a = typeof o == "object" && o && o.Object === Object && o;
        r.exports = a;
      }).call(this, i("c8ba"));
    }, 5926: function(r, s, i) {
      var o = i("b42e");
      r.exports = function(a) {
        var l = +a;
        return l !== l || l === 0 ? 0 : o(l);
      };
    }, "59ed": function(r, s, i) {
      var o = i("1626"), a = i("0d51"), l = TypeError;
      r.exports = function(c) {
        if (o(c)) return c;
        throw new l(a(c) + " is not a function");
      };
    }, "5b01": function(r, s, i) {
      var o = i("8eeb"), a = i("ec69");
      function l(c, u) {
        return c && o(u, a(u), c);
      }
      r.exports = l;
    }, "5c69": function(r, s, i) {
      var o = i("087d"), a = i("0621");
      function l(c, u, d, f, p) {
        var h = -1, m = c.length;
        for (d || (d = a), p || (p = []); ++h < m; ) {
          var v = c[h];
          u > 0 && d(v) ? u > 1 ? l(v, u - 1, d, f, p) : o(p, v) : f || (p[p.length] = v);
        }
        return p;
      }
      r.exports = l;
    }, "5c6c": function(r, s, i) {
      r.exports = function(o, a) {
        return { enumerable: !(1 & o), configurable: !(2 & o), writable: !(4 & o), value: a };
      };
    }, "5d89": function(r, s, i) {
      var o = i("f8af");
      function a(l, c) {
        var u = c ? o(l.buffer) : l.buffer;
        return new l.constructor(u, l.byteOffset, l.byteLength);
      }
      r.exports = a;
    }, "5e2e": function(r, s, i) {
      var o = i("28c9"), a = i("69d5"), l = i("b4c0"), c = i("fba5"), u = i("67ca");
      function d(f) {
        var p = -1, h = f == null ? 0 : f.length;
        for (this.clear(); ++p < h; ) {
          var m = f[p];
          this.set(m[0], m[1]);
        }
      }
      d.prototype.clear = o, d.prototype.delete = a, d.prototype.get = l, d.prototype.has = c, d.prototype.set = u, r.exports = d;
    }, "5e77": function(r, s, i) {
      var o = i("83ab"), a = i("1a2d"), l = Function.prototype, c = o && Object.getOwnPropertyDescriptor, u = a(l, "name"), d = u && (function() {
      }).name === "something", f = u && (!o || o && c(l, "name").configurable);
      r.exports = { EXISTS: u, PROPER: d, CONFIGURABLE: f };
    }, 6044: function(r, s, i) {
      var o = i("0b07"), a = o(Object, "create");
      r.exports = a;
    }, "605d": function(r, s, i) {
      var o = i("da84"), a = i("c6b6");
      r.exports = a(o.process) === "process";
    }, "60ed": function(r, s, i) {
      var o = i("3729"), a = i("2dcb"), l = i("1310"), c = "[object Object]", u = Function.prototype, d = Object.prototype, f = u.toString, p = d.hasOwnProperty, h = f.call(Object);
      function m(v) {
        if (!l(v) || o(v) != c) return !1;
        var y = a(v);
        if (y === null) return !0;
        var _ = p.call(y, "constructor") && y.constructor;
        return typeof _ == "function" && _ instanceof _ && f.call(_) == h;
      }
      r.exports = m;
    }, 6220: function(r, s, i) {
      var o = i("b1d2"), a = i("b047"), l = i("99d3"), c = l && l.isDate, u = c ? a(c) : o;
      r.exports = u;
    }, "62e4": function(r, s) {
      r.exports = function(i) {
        return i.webpackPolyfill || (i.deprecate = function() {
        }, i.paths = [], i.children || (i.children = []), Object.defineProperty(i, "loaded", { enumerable: !0, get: function() {
          return i.l;
        } }), Object.defineProperty(i, "id", { enumerable: !0, get: function() {
          return i.i;
        } }), i.webpackPolyfill = 1), i;
      };
    }, 6374: function(r, s, i) {
      var o = i("da84"), a = Object.defineProperty;
      r.exports = function(l, c) {
        try {
          a(o, l, { value: c, configurable: !0, writable: !0 });
        } catch {
          o[l] = c;
        }
        return c;
      };
    }, "642a": function(r, s, i) {
      var o = i("966f"), a = i("3bb4"), l = i("20ec");
      function c(u) {
        var d = a(u);
        return d.length == 1 && d[0][2] ? l(d[0][0], d[0][1]) : function(f) {
          return f === u || o(f, u, d);
        };
      }
      r.exports = c;
    }, "643d": function(r, s, i) {
      var o = i("116a");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("d4127e08", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, 6562: function(r, s, i) {
      var o = i("9419");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("0ba08e60", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, "656b": function(r, s, i) {
      var o = i("e2e4"), a = i("f4d6");
      function l(c, u) {
        u = o(u, c);
        for (var d = 0, f = u.length; c != null && d < f; ) c = c[a(u[d++])];
        return d && d == f ? c : void 0;
      }
      r.exports = l;
    }, 6679: function(r, s, i) {
      var o = i("3729"), a = i("1310"), l = "[object Boolean]";
      function c(u) {
        return u === !0 || u === !1 || a(u) && o(u) == l;
      }
      r.exports = c;
    }, 6747: function(r, s) {
      var i = Array.isArray;
      r.exports = i;
    }, "67ca": function(r, s, i) {
      var o = i("cb5a");
      function a(l, c) {
        var u = this.__data__, d = o(u, l);
        return d < 0 ? (++this.size, u.push([l, c])) : u[d][1] = c, this;
      }
      r.exports = a;
    }, "69d5": function(r, s, i) {
      var o = i("cb5a"), a = Array.prototype, l = a.splice;
      function c(u) {
        var d = this.__data__, f = o(d, u);
        if (f < 0) return !1;
        var p = d.length - 1;
        return f == p ? d.pop() : l.call(d, f, 1), --this.size, !0;
      }
      r.exports = c;
    }, "69f3": function(r, s, i) {
      var o, a, l, c = i("cdce"), u = i("da84"), d = i("861d"), f = i("9112"), p = i("1a2d"), h = i("c6cd"), m = i("f772"), v = i("d012"), y = "Object already initialized", _ = u.TypeError, w = u.WeakMap, S = function(C) {
        return l(C) ? a(C) : o(C, {});
      }, E = function(C) {
        return function(k) {
          var b;
          if (!d(k) || (b = a(k)).type !== C) throw new _("Incompatible receiver, " + C + " required");
          return b;
        };
      };
      if (c || h.state) {
        var x = h.state || (h.state = new w());
        x.get = x.get, x.has = x.has, x.set = x.set, o = function(C, k) {
          if (x.has(C)) throw new _(y);
          return k.facade = C, x.set(C, k), k;
        }, a = function(C) {
          return x.get(C) || {};
        }, l = function(C) {
          return x.has(C);
        };
      } else {
        var T = m("state");
        v[T] = !0, o = function(C, k) {
          if (p(C, T)) throw new _(y);
          return k.facade = C, f(C, T, k), k;
        }, a = function(C) {
          return p(C, T) ? C[T] : {};
        }, l = function(C) {
          return p(C, T);
        };
      }
      r.exports = { set: o, get: a, has: l, enforce: S, getterFor: E };
    }, "6f19": function(r, s, i) {
      var o = i("9112"), a = i("0d26"), l = i("b980"), c = Error.captureStackTrace;
      r.exports = function(u, d, f, p) {
        l && (c ? c(u, d) : o(u, "stack", a(f, p)));
      };
    }, "6f6c": function(r, s) {
      var i = /\w*$/;
      function o(a) {
        var l = new a.constructor(a.source, i.exec(a));
        return l.lastIndex = a.lastIndex, l;
      }
      r.exports = o;
    }, "6fcd": function(r, s, i) {
      var o = i("50d8"), a = i("d370"), l = i("6747"), c = i("0d24"), u = i("c098"), d = i("73ac"), f = Object.prototype, p = f.hasOwnProperty;
      function h(m, v) {
        var y = l(m), _ = !y && a(m), w = !y && !_ && c(m), S = !y && !_ && !w && d(m), E = y || _ || w || S, x = E ? o(m.length, String) : [], T = x.length;
        for (var C in m) !v && !p.call(m, C) || E && (C == "length" || w && (C == "offset" || C == "parent") || S && (C == "buffer" || C == "byteLength" || C == "byteOffset") || u(C, T)) || x.push(C);
        return x;
      }
      r.exports = h;
    }, 7156: function(r, s, i) {
      var o = i("1626"), a = i("861d"), l = i("d2bb");
      r.exports = function(c, u, d) {
        var f, p;
        return l && o(f = u.constructor) && f !== d && a(p = f.prototype) && p !== d.prototype && l(c, p), c;
      };
    }, 7234: function(r, s, i) {
      r.exports = function(o) {
        return o == null;
      };
    }, 7282: function(r, s, i) {
      var o = i("e330"), a = i("59ed");
      r.exports = function(l, c, u) {
        try {
          return o(a(Object.getOwnPropertyDescriptor(l, c)[u]));
        } catch {
        }
      };
    }, "72af": function(r, s, i) {
      var o = i("99cd"), a = o();
      r.exports = a;
    }, "72f0": function(r, s) {
      function i(o) {
        return function() {
          return o;
        };
      }
      r.exports = i;
    }, "73ac": function(r, s, i) {
      var o = i("743f"), a = i("b047"), l = i("99d3"), c = l && l.isTypedArray, u = c ? a(c) : o;
      r.exports = u;
    }, 7418: function(r, s, i) {
      s.f = Object.getOwnPropertySymbols;
    }, "743f": function(r, s, i) {
      var o = i("3729"), a = i("b218"), l = i("1310"), c = "[object Arguments]", u = "[object Array]", d = "[object Boolean]", f = "[object Date]", p = "[object Error]", h = "[object Function]", m = "[object Map]", v = "[object Number]", y = "[object Object]", _ = "[object RegExp]", w = "[object Set]", S = "[object String]", E = "[object WeakMap]", x = "[object ArrayBuffer]", T = "[object DataView]", C = "[object Float32Array]", k = "[object Float64Array]", b = "[object Int8Array]", P = "[object Int16Array]", N = "[object Int32Array]", D = "[object Uint8Array]", H = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", te = "[object Uint32Array]", A = {};
      function j(L) {
        return l(L) && a(L.length) && !!A[o(L)];
      }
      A[C] = A[k] = A[b] = A[P] = A[N] = A[D] = A[H] = A[Y] = A[te] = !0, A[c] = A[u] = A[x] = A[d] = A[T] = A[f] = A[p] = A[h] = A[m] = A[v] = A[y] = A[_] = A[w] = A[S] = A[E] = !1, r.exports = j;
    }, 7530: function(r, s, i) {
      var o = i("1a8c"), a = Object.create, l = /* @__PURE__ */ function() {
        function c() {
        }
        return function(u) {
          if (!o(u)) return {};
          if (a) return a(u);
          c.prototype = u;
          var d = new c();
          return c.prototype = void 0, d;
        };
      }();
      r.exports = l;
    }, "76dd": function(r, s, i) {
      var o = i("ce86");
      function a(l) {
        return l == null ? "" : o(l);
      }
      r.exports = a;
    }, 7839: function(r, s, i) {
      r.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }, 7948: function(r, s) {
      function i(o, a) {
        for (var l = -1, c = o == null ? 0 : o.length, u = Array(c); ++l < c; ) u[l] = a(o[l], l, o);
        return u;
      }
      r.exports = i;
    }, "79bc": function(r, s, i) {
      var o = i("0b07"), a = i("2b3e"), l = o(a, "Map");
      r.exports = l;
    }, "7a48": function(r, s, i) {
      var o = i("6044"), a = Object.prototype, l = a.hasOwnProperty;
      function c(u) {
        var d = this.__data__;
        return o ? d[u] !== void 0 : l.call(d, u);
      }
      r.exports = c;
    }, "7b0b": function(r, s, i) {
      var o = i("1d80"), a = Object;
      r.exports = function(l) {
        return a(o(l));
      };
    }, "7b83": function(r, s, i) {
      var o = i("7c64"), a = i("93ed"), l = i("2478"), c = i("a524"), u = i("1fc8");
      function d(f) {
        var p = -1, h = f == null ? 0 : f.length;
        for (this.clear(); ++p < h; ) {
          var m = f[p];
          this.set(m[0], m[1]);
        }
      }
      d.prototype.clear = o, d.prototype.delete = a, d.prototype.get = l, d.prototype.has = c, d.prototype.set = u, r.exports = d;
    }, "7b97": function(r, s, i) {
      var o = i("7e64"), a = i("a2be"), l = i("1c3c"), c = i("b1e5"), u = i("42a2"), d = i("6747"), f = i("0d24"), p = i("73ac"), h = 1, m = "[object Arguments]", v = "[object Array]", y = "[object Object]", _ = Object.prototype, w = _.hasOwnProperty;
      function S(E, x, T, C, k, b) {
        var P = d(E), N = d(x), D = P ? v : u(E), H = N ? v : u(x);
        D = D == m ? y : D, H = H == m ? y : H;
        var Y = D == y, te = H == y, A = D == H;
        if (A && f(E)) {
          if (!f(x)) return !1;
          P = !0, Y = !1;
        }
        if (A && !Y) return b || (b = new o()), P || p(E) ? a(E, x, T, C, k, b) : l(E, x, D, T, C, k, b);
        if (!(T & h)) {
          var j = Y && w.call(E, "__wrapped__"), L = te && w.call(x, "__wrapped__");
          if (j || L) {
            var se = j ? E.value() : E, V = L ? x.value() : x;
            return b || (b = new o()), k(se, V, T, C, b);
          }
        }
        return !!A && (b || (b = new o()), c(E, x, T, C, k, b));
      }
      r.exports = S;
    }, "7c64": function(r, s, i) {
      var o = i("e24b"), a = i("5e2e"), l = i("79bc");
      function c() {
        this.size = 0, this.__data__ = { hash: new o(), map: new (l || a)(), string: new o() };
      }
      r.exports = c;
    }, "7d1f": function(r, s, i) {
      var o = i("087d"), a = i("6747");
      function l(c, u, d) {
        var f = u(c);
        return a(c) ? f : o(f, d(c));
      }
      r.exports = l;
    }, "7d87": function(r, s, i) {
      var o = i("0f62");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("d0e2b3b8", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, "7e64": function(r, s, i) {
      var o = i("5e2e"), a = i("efb6"), l = i("2fcc"), c = i("802a"), u = i("55a3"), d = i("d02c");
      function f(p) {
        var h = this.__data__ = new o(p);
        this.size = h.size;
      }
      f.prototype.clear = a, f.prototype.delete = l, f.prototype.get = c, f.prototype.has = u, f.prototype.set = d, r.exports = f;
    }, "7ed2": function(r, s) {
      var i = "__lodash_hash_undefined__";
      function o(a) {
        return this.__data__.set(a, i), this;
      }
      r.exports = o;
    }, "7efe": function(r) {
      r.exports = JSON.parse('{"title":"MMMM YYYY","weekdays":"W","navMonths":"MMM","input":["L","YYYY-MM-DD","YYYY/MM/DD"],"inputDateTime":["L h:mm A","YYYY-MM-DD h:mm A","YYYY/MM/DD h:mm A"],"inputDateTime24hr":["L HH:mm","YYYY-MM-DD HH:mm","YYYY/MM/DD HH:mm"],"inputTime":["h:mm A"],"inputTime24hr":["HH:mm"],"dayPopover":"WWW, MMM D, YYYY","data":["L","YYYY-MM-DD","YYYY/MM/DD"],"iso":"YYYY-MM-DDTHH:mm:ss.SSSZ"}');
    }, "802a": function(r, s) {
      function i(o) {
        return this.__data__.get(o);
      }
      r.exports = i;
    }, 8057: function(r, s) {
      function i(o, a) {
        for (var l = -1, c = o == null ? 0 : o.length; ++l < c && a(o[l], l, o) !== !1; ) ;
        return o;
      }
      r.exports = i;
    }, "825a": function(r, s, i) {
      var o = i("861d"), a = String, l = TypeError;
      r.exports = function(c) {
        if (o(c)) return c;
        throw new l(a(c) + " is not an object");
      };
    }, 8296: function(r, s, i) {
      var o = i("656b"), a = i("2b10");
      function l(c, u) {
        return u.length < 2 ? c : o(c, a(u, 0, -1));
      }
      r.exports = l;
    }, 8384: function(r, s) {
      function i(o, a, l) {
        return o === o && (l !== void 0 && (o = o <= l ? o : l), a !== void 0 && (o = o >= a ? o : a)), o;
      }
      r.exports = i;
    }, "83ab": function(r, s, i) {
      var o = i("d039");
      r.exports = !o(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] !== 7;
      });
    }, 8518: function(r, s, i) {
      var o = i("b3ff");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("22adb7aa", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, "85a9": function(r) {
      r.exports = JSON.parse('{"sm":"640px","md":"768px","lg":"1024px","xl":"1280px"}');
    }, "85e3": function(r, s) {
      function i(o, a, l) {
        switch (l.length) {
          case 0:
            return o.call(a);
          case 1:
            return o.call(a, l[0]);
          case 2:
            return o.call(a, l[0], l[1]);
          case 3:
            return o.call(a, l[0], l[1], l[2]);
        }
        return o.apply(a, l);
      }
      r.exports = i;
    }, 8604: function(r, s, i) {
      var o = i("26e8"), a = i("e2c0");
      function l(c, u) {
        return c != null && a(c, u, o);
      }
      r.exports = l;
    }, "861d": function(r, s, i) {
      var o = i("1626"), a = i("8ea1"), l = a.all;
      r.exports = a.IS_HTMLDDA ? function(c) {
        return typeof c == "object" ? c !== null : o(c) || c === l;
      } : function(c) {
        return typeof c == "object" ? c !== null : o(c);
      };
    }, "872a": function(r, s, i) {
      var o = i("3b4a");
      function a(l, c, u) {
        c == "__proto__" && o ? o(l, c, { configurable: !0, enumerable: !0, value: u, writable: !0 }) : l[c] = u;
      }
      r.exports = a;
    }, 8925: function(r, s, i) {
      var o = i("e330"), a = i("1626"), l = i("c6cd"), c = o(Function.toString);
      a(l.inspectSource) || (l.inspectSource = function(u) {
        return c(u);
      }), r.exports = l.inspectSource;
    }, "89d9": function(r, s, i) {
      var o = i("656b"), a = i("159a"), l = i("e2e4");
      function c(u, d, f) {
        for (var p = -1, h = d.length, m = {}; ++p < h; ) {
          var v = d[p], y = o(u, v);
          f(y, v) && a(m, l(v, u), y);
        }
        return m;
      }
      r.exports = c;
    }, "8ab2": function(r, s, i) {
      i("23da");
    }, "8adb": function(r, s) {
      function i(o, a) {
        if ((a !== "constructor" || typeof o[a] != "function") && a != "__proto__") return o[a];
      }
      r.exports = i;
    }, "8bbf": function(r, s) {
      r.exports = n;
    }, "8c86": function(r, s, i) {
      function o(a, l) {
        if (l.length < a) throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + l.length + " present");
      }
      i.d(s, "a", function() {
        return o;
      });
    }, "8d74": function(r, s, i) {
      var o = i("4cef"), a = /^\s+/;
      function l(c) {
        return c && c.slice(0, o(c) + 1).replace(a, "");
      }
      r.exports = l;
    }, "8de2": function(r, s, i) {
      var o = i("8eeb"), a = i("9934");
      function l(c) {
        return o(c, a(c));
      }
      r.exports = l;
    }, "8ea1": function(r, s, i) {
      var o = typeof document == "object" && document.all, a = typeof o > "u" && o !== void 0;
      r.exports = { all: o, IS_HTMLDDA: a };
    }, "8eeb": function(r, s, i) {
      var o = i("32b3"), a = i("872a");
      function l(c, u, d, f) {
        var p = !d;
        d || (d = {});
        for (var h = -1, m = u.length; ++h < m; ) {
          var v = u[h], y = f ? f(d[v], c[v], v, d, c) : void 0;
          y === void 0 && (y = c[v]), p ? a(d, v, y) : o(d, v, y);
        }
        return d;
      }
      r.exports = l;
    }, "90e3": function(r, s, i) {
      var o = i("e330"), a = 0, l = Math.random(), c = o(1 .toString);
      r.exports = function(u) {
        return "Symbol(" + (u === void 0 ? "" : u) + ")_" + c(++a + l, 36);
      };
    }, 9112: function(r, s, i) {
      var o = i("83ab"), a = i("9bf2"), l = i("5c6c");
      r.exports = o ? function(c, u, d) {
        return a.f(c, u, l(1, d));
      } : function(c, u, d) {
        return c[u] = d, c;
      };
    }, "91e9": function(r, s) {
      function i(o, a) {
        return function(l) {
          return o(a(l));
        };
      }
      r.exports = i;
    }, 9349: function(r, s, i) {
      i.d(s, "a", function() {
        return l;
      }), i("14d9");
      var o = i("22f3"), a = i("2fa3");
      class l {
        constructor(u, d, f) {
          this.theme = u, this.locale = d, this.map = {}, this.refresh(f, !0);
        }
        destroy() {
          this.theme = null, this.locale = null, this.map = {}, this.list = [], this.pinAttr = null;
        }
        refresh(u, d) {
          var f = this;
          const p = {}, h = [];
          let m = null;
          const v = [], y = d ? /* @__PURE__ */ new Set() : new Set(Object.keys(this.map));
          return Object(a.b)(u) && u.forEach(function(_, w) {
            if (!_ || !_.dates) return;
            const S = _.key ? _.key.toString() : w.toString(), E = _.order || 0, x = Object(a.g)(JSON.stringify(_));
            let T = f.map[S];
            !d && T && T.hashcode === x ? y.delete(S) : (T = new o.a({ key: S, order: E, hashcode: x, ..._ }, f.theme, f.locale), v.push(T)), T && T.pinPage && (m = T), p[S] = T, h.push(T);
          }), this.map = p, this.list = h, this.pinAttr = m, { adds: v, deletes: Array.from(y) };
        }
      }
    }, "93ed": function(r, s, i) {
      var o = i("4245");
      function a(l) {
        var c = o(this, l).delete(l);
        return this.size -= c ? 1 : 0, c;
      }
      r.exports = a;
    }, 9404: function(r, s, i) {
      i.d(s, "j", function() {
        return Lt;
      }), i.d(s, "m", function() {
        return Yt;
      }), i.d(s, "e", function() {
        return nn;
      }), i.d(s, "f", function() {
        return qt;
      }), i.d(s, "v", function() {
        return rn;
      });
      var o = i("6679"), a = i.n(o);
      i.d(s, "i", function() {
        return a.a;
      });
      var l = i("501e"), c = i.n(l);
      i.d(s, "l", function() {
        return c.a;
      });
      var u = i("e2a0"), d = i.n(u);
      i.d(s, "n", function() {
        return d.a;
      });
      var f = i("dcbe"), p = i.n(f);
      i.d(s, "h", function() {
        return p.a;
      });
      var h = i("9520"), m = i.n(h);
      i.d(s, "k", function() {
        return m.a;
      });
      var v = i("4cfe"), y = i.n(v);
      i.d(s, "o", function() {
        return y.a;
      });
      var _ = i("6220"), w = i.n(_), S = i("f678"), E = i.n(S);
      i.d(s, "a", function() {
        return E.a;
      });
      var x = i("9b02"), T = i.n(x);
      i.d(s, "d", function() {
        return T.a;
      });
      var C = i("0f5c"), k = i.n(C);
      i.d(s, "u", function() {
        return k.a;
      });
      var b = i("9e86"), P = i.n(b);
      i.d(s, "r", function() {
        return P.a;
      });
      var N = i("f542"), D = i.n(N);
      i.d(s, "w", function() {
        return D.a;
      });
      var H = i("95ae"), Y = i.n(H);
      i.d(s, "b", function() {
        return Y.a;
      });
      var te = i("3f84"), A = i.n(te);
      i.d(s, "c", function() {
        return A.a;
      });
      var j = i("2593"), L = i.n(j);
      i.d(s, "t", function() {
        return L.a;
      });
      var se = i("3eea"), V = i.n(se);
      i.d(s, "s", function() {
        return V.a;
      });
      var ee = i("3852"), O = i.n(ee), K = i("dd61"), z = i.n(K);
      i.d(s, "q", function() {
        return z.a;
      });
      var q = i("a59b"), ae = i.n(q);
      i.d(s, "g", function() {
        return ae.a;
      });
      var Ee = i("4416"), Ae = i.n(Ee);
      i.d(s, "p", function() {
        return Ae.a;
      });
      var Ue = i("3092"), qe = i.n(Ue);
      const Qe = function(sn) {
        return Object.prototype.toString.call(sn).slice(8, -1);
      }, Lt = function(sn) {
        return w()(sn) && !isNaN(sn.getTime());
      }, Yt = function(sn) {
        return Qe(sn) === "Object";
      }, nn = O.a, qt = function(sn, zn) {
        return qe()(zn, function(ns) {
          return O()(sn, ns);
        });
      }, rn = qe.a;
    }, 9419: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-nav-popover-container{color:var(--white);font-size:var(--text-sm);font-weight:var(--font-semibold);background-color:var(--gray-800);border:1px solid;border-color:var(--gray-700);border-radius:var(--rounded-lg);padding:4px;box-shadow:var(--shadow)}.vc-is-dark .vc-nav-popover-container{color:var(--gray-800);background-color:var(--white);border-color:var(--gray-100)}", ""]), r.exports = s;
    }, "94ca": function(r, s, i) {
      var o = i("d039"), a = i("1626"), l = /#|\.prototype\./, c = function(h, m) {
        var v = d[u(h)];
        return v === p || v !== f && (a(m) ? o(m) : !!m);
      }, u = c.normalize = function(h) {
        return String(h).replace(l, ".").toLowerCase();
      }, d = c.data = {}, f = c.NATIVE = "N", p = c.POLYFILL = "P";
      r.exports = c;
    }, "950a": function(r, s, i) {
      var o = i("30c9");
      function a(l, c) {
        return function(u, d) {
          if (u == null) return u;
          if (!o(u)) return l(u, d);
          for (var f = u.length, p = c ? f : -1, h = Object(u); (c ? p-- : ++p < f) && d(h[p], p, h) !== !1; ) ;
          return u;
        };
      }
      r.exports = a;
    }, 9520: function(r, s, i) {
      var o = i("3729"), a = i("1a8c"), l = "[object AsyncFunction]", c = "[object Function]", u = "[object GeneratorFunction]", d = "[object Proxy]";
      function f(p) {
        if (!a(p)) return !1;
        var h = o(p);
        return h == c || h == u || h == l || h == d;
      }
      r.exports = f;
    }, "95ae": function(r, s, i) {
      var o = i("100e"), a = i("9638"), l = i("9aff"), c = i("9934"), u = Object.prototype, d = u.hasOwnProperty, f = o(function(p, h) {
        p = Object(p);
        var m = -1, v = h.length, y = v > 2 ? h[2] : void 0;
        for (y && l(h[0], h[1], y) && (v = 1); ++m < v; )
          for (var _ = h[m], w = c(_), S = -1, E = w.length; ++S < E; ) {
            var x = w[S], T = p[x];
            (T === void 0 || a(T, u[x]) && !d.call(p, x)) && (p[x] = _[x]);
          }
        return p;
      });
      r.exports = f;
    }, 9638: function(r, s) {
      function i(o, a) {
        return o === a || o !== o && a !== a;
      }
      r.exports = i;
    }, "966f": function(r, s, i) {
      var o = i("7e64"), a = i("c05f"), l = 1, c = 2;
      function u(d, f, p, h) {
        var m = p.length, v = m, y = !h;
        if (d == null) return !v;
        for (d = Object(d); m--; ) {
          var _ = p[m];
          if (y && _[2] ? _[1] !== d[_[0]] : !(_[0] in d)) return !1;
        }
        for (; ++m < v; ) {
          _ = p[m];
          var w = _[0], S = d[w], E = _[1];
          if (y && _[2]) {
            if (S === void 0 && !(w in d)) return !1;
          } else {
            var x = new o();
            if (h) var T = h(S, E, w, d, f, x);
            if (!(T === void 0 ? a(E, S, l | c, h, x) : T)) return !1;
          }
        }
        return !0;
      }
      r.exports = u;
    }, "96f3": function(r, s) {
      var i = Object.prototype, o = i.hasOwnProperty;
      function a(l, c) {
        return l != null && o.call(l, c);
      }
      r.exports = a;
    }, "97d3": function(r, s, i) {
      var o = i("48a0"), a = i("30c9");
      function l(c, u) {
        var d = -1, f = a(c) ? Array(c.length) : [];
        return o(c, function(p, h, m) {
          f[++d] = u(p, h, m);
        }), f;
      }
      r.exports = l;
    }, 9934: function(r, s, i) {
      var o = i("6fcd"), a = i("41c3"), l = i("30c9");
      function c(u) {
        return l(u) ? o(u, !0) : a(u);
      }
      r.exports = c;
    }, "99cd": function(r, s) {
      function i(o) {
        return function(a, l, c) {
          for (var u = -1, d = Object(a), f = c(a), p = f.length; p--; ) {
            var h = f[o ? p : ++u];
            if (l(d[h], h, d) === !1) break;
          }
          return a;
        };
      }
      r.exports = i;
    }, "99d3": function(r, s, i) {
      (function(o) {
        var a = i("585a"), l = s && !s.nodeType && s, c = l && typeof o == "object" && o && !o.nodeType && o, u = c && c.exports === l, d = u && a.process, f = function() {
          try {
            var p = c && c.require && c.require("util").types;
            return p || d && d.binding && d.binding("util");
          } catch {
          }
        }();
        o.exports = f;
      }).call(this, i("62e4")(r));
    }, "9aff": function(r, s, i) {
      var o = i("9638"), a = i("30c9"), l = i("c098"), c = i("1a8c");
      function u(d, f, p) {
        if (!c(p)) return !1;
        var h = typeof f;
        return !!(h == "number" ? a(p) && l(f, p.length) : h == "string" && f in p) && o(p[f], d);
      }
      r.exports = u;
    }, "9b02": function(r, s, i) {
      var o = i("656b");
      function a(l, c, u) {
        var d = l == null ? void 0 : o(l, c);
        return d === void 0 ? u : d;
      }
      r.exports = a;
    }, "9bf2": function(r, s, i) {
      var o = i("83ab"), a = i("0cfb"), l = i("aed9"), c = i("825a"), u = i("a04b"), d = TypeError, f = Object.defineProperty, p = Object.getOwnPropertyDescriptor, h = "enumerable", m = "configurable", v = "writable";
      s.f = o ? l ? function(y, _, w) {
        if (c(y), _ = u(_), c(w), typeof y == "function" && _ === "prototype" && "value" in w && v in w && !w[v]) {
          var S = p(y, _);
          S && S[v] && (y[_] = w.value, w = { configurable: m in w ? w[m] : S[m], enumerable: h in w ? w[h] : S[h], writable: !1 });
        }
        return f(y, _, w);
      } : f : function(y, _, w) {
        if (c(y), _ = u(_), c(w), a) try {
          return f(y, _, w);
        } catch {
        }
        if ("get" in w || "set" in w) throw new d("Accessors not supported");
        return "value" in w && (y[_] = w.value), y;
      };
    }, "9e69": function(r, s, i) {
      var o = i("2b3e"), a = o.Symbol;
      r.exports = a;
    }, "9e86": function(r, s, i) {
      var o = i("872a"), a = i("242e"), l = i("badf");
      function c(u, d) {
        var f = {};
        return d = l(d, 3), a(u, function(p, h, m) {
          o(f, h, d(p, h, m));
        }), f;
      }
      r.exports = c;
    }, a029: function(r, s, i) {
      var o = i("087d"), a = i("2dcb"), l = i("32f4"), c = i("d327"), u = Object.getOwnPropertySymbols, d = u ? function(f) {
        for (var p = []; f; ) o(p, l(f)), f = a(f);
        return p;
      } : c;
      r.exports = d;
    }, a04b: function(r, s, i) {
      var o = i("c04e"), a = i("d9b5");
      r.exports = function(l) {
        var c = o(l, "string");
        return a(c) ? c : c + "";
      };
    }, a2be: function(r, s, i) {
      var o = i("d612"), a = i("4284"), l = i("c584"), c = 1, u = 2;
      function d(f, p, h, m, v, y) {
        var _ = h & c, w = f.length, S = p.length;
        if (w != S && !(_ && S > w)) return !1;
        var E = y.get(f), x = y.get(p);
        if (E && x) return E == p && x == f;
        var T = -1, C = !0, k = h & u ? new o() : void 0;
        for (y.set(f, p), y.set(p, f); ++T < w; ) {
          var b = f[T], P = p[T];
          if (m) var N = _ ? m(P, b, T, p, f, y) : m(b, P, T, f, p, y);
          if (N !== void 0) {
            if (N) continue;
            C = !1;
            break;
          }
          if (k) {
            if (!a(p, function(D, H) {
              if (!l(k, H) && (b === D || v(b, D, h, m, y))) return k.push(H);
            })) {
              C = !1;
              break;
            }
          } else if (b !== P && !v(b, P, h, m, y)) {
            C = !1;
            break;
          }
        }
        return y.delete(f), y.delete(p), C;
      }
      r.exports = d;
    }, a2db: function(r, s, i) {
      var o = i("9e69"), a = o ? o.prototype : void 0, l = a ? a.valueOf : void 0;
      function c(u) {
        return l ? Object(l.call(u)) : {};
      }
      r.exports = c;
    }, a3fd: function(r, s, i) {
      var o = i("7948");
      function a(l, c) {
        return o(c, function(u) {
          return [u, l[u]];
        });
      }
      r.exports = a;
    }, a454: function(r, s, i) {
      var o = i("72f0"), a = i("3b4a"), l = i("cd9d"), c = a ? function(u, d) {
        return a(u, "toString", { configurable: !0, enumerable: !1, value: o(d), writable: !0 });
      } : l;
      r.exports = c;
    }, a524: function(r, s, i) {
      var o = i("4245");
      function a(l) {
        return o(this, l).has(l);
      }
      r.exports = a;
    }, a59b: function(r, s) {
      function i(o) {
        return o && o.length ? o[0] : void 0;
      }
      r.exports = i;
    }, a640: function(r, s, i) {
      var o = i("d039");
      r.exports = function(a, l) {
        var c = [][a];
        return !!c && o(function() {
          c.call(null, l || function() {
            return 1;
          }, 1);
        });
      };
    }, a994: function(r, s, i) {
      var o = i("7d1f"), a = i("32f4"), l = i("ec69");
      function c(u) {
        return o(u, l, a);
      }
      r.exports = c;
    }, ab36: function(r, s, i) {
      var o = i("861d"), a = i("9112");
      r.exports = function(l, c) {
        o(c) && "cause" in c && a(l, "cause", c.cause);
      };
    }, ac41: function(r, s) {
      function i(o) {
        var a = -1, l = Array(o.size);
        return o.forEach(function(c) {
          l[++a] = c;
        }), l;
      }
      r.exports = i;
    }, aeb0: function(r, s, i) {
      var o = i("9bf2").f;
      r.exports = function(a, l, c) {
        c in a || o(a, c, { configurable: !0, get: function() {
          return l[c];
        }, set: function(u) {
          l[c] = u;
        } });
      };
    }, aed9: function(r, s, i) {
      var o = i("83ab"), a = i("d039");
      r.exports = o && a(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: !1 }).prototype !== 42;
      });
    }, b047: function(r, s) {
      function i(o) {
        return function(a) {
          return o(a);
        };
      }
      r.exports = i;
    }, b0b5: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-nav-header{display:flex;justify-content:space-between}.vc-nav-arrow{display:flex;justify-content:center;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none;line-height:var(--leading-snug);border-width:2px;border-style:solid;border-color:transparent;border-radius:var(--rounded)}.vc-nav-arrow.is-left{margin-right:auto}.vc-nav-arrow.is-right{margin-left:auto}.vc-nav-arrow.is-disabled{opacity:.25;pointer-events:none;cursor:not-allowed}.vc-nav-arrow:hover{background-color:var(--gray-900)}.vc-nav-arrow:focus{border-color:var(--accent-600)}.vc-nav-title{color:var(--accent-100);font-weight:var(--font-bold);line-height:var(--leading-snug);padding:4px 8px;border-radius:var(--rounded);border-width:2px;border-style:solid;border-color:transparent;-webkit-user-select:none;user-select:none}.vc-nav-title:hover{background-color:var(--gray-900)}.vc-nav-title:focus{border-color:var(--accent-600)}.vc-nav-items{display:grid;grid-template-columns:repeat(3,1fr);grid-row-gap:2px;grid-column-gap:5px}.vc-nav-item{width:48px;text-align:center;line-height:var(--leading-snug);font-weight:var(--font-semibold);padding:4px 0;cursor:pointer;border-color:transparent;border-width:2px;border-style:solid;border-radius:var(--rounded);-webkit-user-select:none;user-select:none}.vc-nav-item:hover{color:var(--white);background-color:var(--gray-900);box-shadow:var(--shadow-inner)}.vc-nav-item.is-active{color:var(--accent-900);background:var(--accent-100);font-weight:var(--font-bold);box-shadow:var(--shadow)}.vc-nav-item.is-current{color:var(--accent-100);font-weight:var(--bold);border-color:var(--accent-100)}.vc-nav-item:focus{border-color:var(--accent-600)}.vc-nav-item.is-disabled{opacity:.25;pointer-events:none}.vc-is-dark .vc-nav-title{color:var(--gray-900)}.vc-is-dark .vc-nav-title:hover{background-color:var(--gray-200)}.vc-is-dark .vc-nav-title:focus{border-color:var(--accent-400)}.vc-is-dark .vc-nav-arrow:hover{background-color:var(--gray-200)}.vc-is-dark .vc-nav-arrow:focus{border-color:var(--accent-400)}.vc-is-dark .vc-nav-item:hover{color:var(--gray-900);background-color:var(--gray-200);box-shadow:none}.vc-is-dark .vc-nav-item.is-active{color:var(--white);background:var(--accent-500)}.vc-is-dark .vc-nav-item.is-current{color:var(--accent-600);border-color:var(--accent-500)}.vc-is-dark .vc-nav-item:focus{border-color:var(--accent-400)}", ""]), r.exports = s;
    }, b1d2: function(r, s, i) {
      var o = i("3729"), a = i("1310"), l = "[object Date]";
      function c(u) {
        return a(u) && o(u) == l;
      }
      r.exports = c;
    }, b1e5: function(r, s, i) {
      var o = i("a994"), a = 1, l = Object.prototype, c = l.hasOwnProperty;
      function u(d, f, p, h, m, v) {
        var y = p & a, _ = o(d), w = _.length, S = o(f), E = S.length;
        if (w != E && !y) return !1;
        for (var x = w; x--; ) {
          var T = _[x];
          if (!(y ? T in f : c.call(f, T))) return !1;
        }
        var C = v.get(d), k = v.get(f);
        if (C && k) return C == f && k == d;
        var b = !0;
        v.set(d, f), v.set(f, d);
        for (var P = y; ++x < w; ) {
          T = _[x];
          var N = d[T], D = f[T];
          if (h) var H = y ? h(D, N, T, f, d, v) : h(N, D, T, d, f, v);
          if (!(H === void 0 ? N === D || m(N, D, p, h, v) : H)) {
            b = !1;
            break;
          }
          P || (P = T == "constructor");
        }
        if (b && !P) {
          var Y = d.constructor, te = f.constructor;
          Y == te || !("constructor" in d) || !("constructor" in f) || typeof Y == "function" && Y instanceof Y && typeof te == "function" && te instanceof te || (b = !1);
        }
        return v.delete(d), v.delete(f), b;
      }
      r.exports = u;
    }, b218: function(r, s) {
      var i = 9007199254740991;
      function o(a) {
        return typeof a == "number" && a > -1 && a % 1 == 0 && a <= i;
      }
      r.exports = o;
    }, b3ff: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-pane[data-v-74ad501d]{min-width:250px}.vc-header[data-v-74ad501d]{display:flex;justify-content:center;align-items:center;padding:10px 18px 0 18px}.vc-header.align-left[data-v-74ad501d]{justify-content:flex-start}.vc-header.align-right[data-v-74ad501d]{justify-content:flex-end}.vc-title[data-v-74ad501d]{font-size:var(--text-lg);color:var(--gray-800);font-weight:var(--font-semibold);line-height:28px;cursor:pointer;-webkit-user-select:none;user-select:none;white-space:nowrap}.vc-title[data-v-74ad501d]:hover{opacity:.75}.vc-weeknumber[data-v-74ad501d]{position:relative}.vc-weeknumber[data-v-74ad501d],.vc-weeknumber-content[data-v-74ad501d]{display:flex;justify-content:center;align-items:center}.vc-weeknumber-content[data-v-74ad501d]{font-size:var(--text-xs);font-weight:var(--font-medium);font-style:italic;width:28px;height:28px;margin-top:2px;color:var(--gray-500);-webkit-user-select:none;user-select:none}.vc-weeknumber-content.is-left-outside[data-v-74ad501d]{position:absolute;left:var(--weeknumber-offset)}.vc-weeknumber-content.is-right-outside[data-v-74ad501d]{position:absolute;right:var(--weeknumber-offset)}.vc-weeks[data-v-74ad501d]{display:grid;grid-template-columns:repeat(7,1fr);position:relative;-webkit-overflow-scrolling:touch;padding:5px;min-width:250px}.vc-weeks.vc-show-weeknumbers[data-v-74ad501d]{grid-template-columns:auto repeat(7,1fr)}.vc-weeks.vc-show-weeknumbers.is-right[data-v-74ad501d]{grid-template-columns:repeat(7,1fr) auto}.vc-weekday[data-v-74ad501d]{text-align:center;color:var(--gray-500);font-size:var(--text-sm);font-weight:var(--font-bold);line-height:14px;padding-top:4px;padding-bottom:8px;cursor:default;-webkit-user-select:none;user-select:none}.vc-is-dark .vc-header[data-v-74ad501d]{color:var(--gray-200)}.vc-is-dark .vc-title[data-v-74ad501d]{color:var(--gray-100)}.vc-is-dark .vc-weekday[data-v-74ad501d]{color:var(--accent-200)}", ""]), r.exports = s;
    }, b42e: function(r, s, i) {
      var o = Math.ceil, a = Math.floor;
      r.exports = Math.trunc || function(l) {
        var c = +l;
        return (c > 0 ? a : o)(c);
      };
    }, b4b0: function(r, s, i) {
      var o = i("8d74"), a = i("1a8c"), l = i("ffd6"), c = NaN, u = /^[-+]0x[0-9a-f]+$/i, d = /^0b[01]+$/i, f = /^0o[0-7]+$/i, p = parseInt;
      function h(m) {
        if (typeof m == "number") return m;
        if (l(m)) return c;
        if (a(m)) {
          var v = typeof m.valueOf == "function" ? m.valueOf() : m;
          m = a(v) ? v + "" : v;
        }
        if (typeof m != "string") return m === 0 ? m : +m;
        m = o(m);
        var y = d.test(m);
        return y || f.test(m) ? p(m.slice(2), y ? 2 : 8) : u.test(m) ? c : +m;
      }
      r.exports = h;
    }, b4c0: function(r, s, i) {
      var o = i("cb5a");
      function a(l) {
        var c = this.__data__, u = o(c, l);
        return u < 0 ? void 0 : c[u][1];
      }
      r.exports = a;
    }, b5a7: function(r, s, i) {
      var o = i("0b07"), a = i("2b3e"), l = o(a, "DataView");
      r.exports = l;
    }, b622: function(r, s, i) {
      var o = i("da84"), a = i("5692"), l = i("1a2d"), c = i("90e3"), u = i("04f8"), d = i("fdbf"), f = o.Symbol, p = a("wks"), h = d ? f.for || f : f && f.withoutSetter || c;
      r.exports = function(m) {
        return l(p, m) || (p[m] = u && l(f, m) ? f[m] : h("Symbol." + m)), p[m];
      };
    }, b760: function(r, s, i) {
      var o = i("872a"), a = i("9638");
      function l(c, u, d) {
        (d !== void 0 && !a(c[u], d) || d === void 0 && !(u in c)) && o(c, u, d);
      }
      r.exports = l;
    }, b7f0: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-select[data-v-7b2eaf0a]{position:relative}.vc-select select[data-v-7b2eaf0a]{flex-grow:1;display:block;-webkit-appearance:none;appearance:none;width:52px;height:30px;font-size:var(--text-base);font-weight:var(--font-medium);text-align:left;background-color:var(--gray-200);border:2px solid;border-color:var(--gray-200);color:var(--gray-900);padding:0 20px 0 8px;border-radius:var(--rounded);line-height:var(--leading-tight);text-indent:0;cursor:pointer;-moz-padding-start:3px;background-image:none}.vc-select select[data-v-7b2eaf0a]:hover{color:var(--gray-600)}.vc-select select[data-v-7b2eaf0a]:focus{outline:0;border-color:var(--accent-400);background-color:var(--white)}.vc-select-arrow[data-v-7b2eaf0a]{display:flex;align-items:center;pointer-events:none;position:absolute;top:0;bottom:0;right:0;padding:0 4px 0 0;color:var(--gray-500)}.vc-select-arrow svg[data-v-7b2eaf0a]{width:16px;height:16px;fill:currentColor}.vc-is-dark select[data-v-7b2eaf0a]{background:var(--gray-700);color:var(--gray-100);border-color:var(--gray-700)}.vc-is-dark select[data-v-7b2eaf0a]:hover{color:var(--gray-400)}.vc-is-dark select[data-v-7b2eaf0a]:focus{border-color:var(--accent-500);background-color:var(--gray-800)}", ""]), r.exports = s;
    }, b980: function(r, s, i) {
      var o = i("d039"), a = i("5c6c");
      r.exports = !o(function() {
        var l = new Error("a");
        return !("stack" in l) || (Object.defineProperty(l, "stack", a(1, 7)), l.stack !== 7);
      });
    }, badf: function(r, s, i) {
      var o = i("642a"), a = i("1838"), l = i("cd9d"), c = i("6747"), u = i("f9ce");
      function d(f) {
        return typeof f == "function" ? f : f == null ? l : typeof f == "object" ? c(f) ? a(f[0], f[1]) : o(f) : u(f);
      }
      r.exports = d;
    }, bbc0: function(r, s, i) {
      var o = i("6044"), a = "__lodash_hash_undefined__", l = Object.prototype, c = l.hasOwnProperty;
      function u(d) {
        var f = this.__data__;
        if (o) {
          var p = f[d];
          return p === a ? void 0 : p;
        }
        return c.call(f, d) ? f[d] : void 0;
      }
      r.exports = u;
    }, bfb3: function(r, s, i) {
      var o = i("0840");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("1d8413e8", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, c04e: function(r, s, i) {
      var o = i("c65b"), a = i("861d"), l = i("d9b5"), c = i("dc4a"), u = i("485a"), d = i("b622"), f = TypeError, p = d("toPrimitive");
      r.exports = function(h, m) {
        if (!a(h) || l(h)) return h;
        var v, y = c(h, p);
        if (y) {
          if (m === void 0 && (m = "default"), v = o(y, h, m), !a(v) || l(v)) return v;
          throw new f("Can't convert object to primitive value");
        }
        return m === void 0 && (m = "number"), u(h, m);
      };
    }, c05f: function(r, s, i) {
      var o = i("7b97"), a = i("1310");
      function l(c, u, d, f, p) {
        return c === u || (c == null || u == null || !a(c) && !a(u) ? c !== c && u !== u : o(c, u, d, f, l, p));
      }
      r.exports = l;
    }, c098: function(r, s) {
      var i = 9007199254740991, o = /^(?:0|[1-9]\d*)$/;
      function a(l, c) {
        var u = typeof l;
        return c = c ?? i, !!c && (u == "number" || u != "symbol" && o.test(l)) && l > -1 && l % 1 == 0 && l < c;
      }
      r.exports = a;
    }, c1c9: function(r, s, i) {
      var o = i("a454"), a = i("f3c1"), l = a(o);
      r.exports = l;
    }, c2b6: function(r, s, i) {
      var o = i("f8af"), a = i("5d89"), l = i("6f6c"), c = i("a2db"), u = i("c8fe"), d = "[object Boolean]", f = "[object Date]", p = "[object Map]", h = "[object Number]", m = "[object RegExp]", v = "[object Set]", y = "[object String]", _ = "[object Symbol]", w = "[object ArrayBuffer]", S = "[object DataView]", E = "[object Float32Array]", x = "[object Float64Array]", T = "[object Int8Array]", C = "[object Int16Array]", k = "[object Int32Array]", b = "[object Uint8Array]", P = "[object Uint8ClampedArray]", N = "[object Uint16Array]", D = "[object Uint32Array]";
      function H(Y, te, A) {
        var j = Y.constructor;
        switch (te) {
          case w:
            return o(Y);
          case d:
          case f:
            return new j(+Y);
          case S:
            return a(Y, A);
          case E:
          case x:
          case T:
          case C:
          case k:
          case b:
          case P:
          case N:
          case D:
            return u(Y, A);
          case p:
            return new j();
          case h:
          case y:
            return new j(Y);
          case m:
            return l(Y);
          case v:
            return new j();
          case _:
            return c(Y);
        }
      }
      r.exports = H;
    }, c3fc: function(r, s, i) {
      var o = i("42a2"), a = i("1310"), l = "[object Set]";
      function c(u) {
        return a(u) && o(u) == l;
      }
      r.exports = c;
    }, c430: function(r, s, i) {
      r.exports = !1;
    }, c584: function(r, s) {
      function i(o, a) {
        return o.has(a);
      }
      r.exports = i;
    }, c65b: function(r, s, i) {
      var o = i("40d5"), a = Function.prototype.call;
      r.exports = o ? a.bind(a) : function() {
        return a.apply(a, arguments);
      };
    }, c6b6: function(r, s, i) {
      var o = i("e330"), a = o({}.toString), l = o("".slice);
      r.exports = function(c) {
        return l(a(c), 8, -1);
      };
    }, c6cd: function(r, s, i) {
      var o = i("da84"), a = i("6374"), l = "__core-js_shared__", c = o[l] || a(l, {});
      r.exports = c;
    }, c6cf: function(r, s, i) {
      var o = i("4d8c"), a = i("2286"), l = i("c1c9");
      function c(u) {
        return l(a(u, void 0, o), u + "");
      }
      r.exports = c;
    }, c869: function(r, s, i) {
      var o = i("0b07"), a = i("2b3e"), l = o(a, "Set");
      r.exports = l;
    }, c87c: function(r, s) {
      var i = Object.prototype, o = i.hasOwnProperty;
      function a(l) {
        var c = l.length, u = new l.constructor(c);
        return c && typeof l[0] == "string" && o.call(l, "index") && (u.index = l.index, u.input = l.input), u;
      }
      r.exports = a;
    }, c8ba: function(r, s) {
      var i;
      i = /* @__PURE__ */ function() {
        return this;
      }();
      try {
        i = i || new Function("return this")();
      } catch {
        typeof window == "object" && (i = window);
      }
      r.exports = i;
    }, c8fe: function(r, s, i) {
      var o = i("f8af");
      function a(l, c) {
        var u = c ? o(l.buffer) : l.buffer;
        return new l.constructor(u, l.byteOffset, l.length);
      }
      r.exports = a;
    }, ca17: function(r, s, i) {
      i("2feb");
    }, ca84: function(r, s, i) {
      var o = i("e330"), a = i("1a2d"), l = i("fc6a"), c = i("4d64").indexOf, u = i("d012"), d = o([].push);
      r.exports = function(f, p) {
        var h, m = l(f), v = 0, y = [];
        for (h in m) !a(u, h) && a(m, h) && d(y, h);
        for (; p.length > v; ) a(m, h = p[v++]) && (~c(y, h) || d(y, h));
        return y;
      };
    }, cb2d: function(r, s, i) {
      var o = i("1626"), a = i("9bf2"), l = i("13d2"), c = i("6374");
      r.exports = function(u, d, f, p) {
        p || (p = {});
        var h = p.enumerable, m = p.name !== void 0 ? p.name : d;
        if (o(f) && l(f, m, p), p.global) h ? u[d] = f : c(d, f);
        else {
          try {
            p.unsafe ? u[d] && (h = !0) : delete u[d];
          } catch {
          }
          h ? u[d] = f : a.f(u, d, { value: f, enumerable: !1, configurable: !p.nonConfigurable, writable: !p.nonWritable });
        }
        return u;
      };
    }, cb5a: function(r, s, i) {
      var o = i("9638");
      function a(l, c) {
        for (var u = l.length; u--; ) if (o(l[u][0], c)) return u;
        return -1;
      }
      r.exports = a;
    }, cc12: function(r, s, i) {
      var o = i("da84"), a = i("861d"), l = o.document, c = a(l) && a(l.createElement);
      r.exports = function(u) {
        return c ? l.createElement(u) : {};
      };
    }, cc45: function(r, s, i) {
      var o = i("1a2d0"), a = i("b047"), l = i("99d3"), c = l && l.isMap, u = c ? a(c) : o;
      r.exports = u;
    }, cd9d: function(r, s) {
      function i(o) {
        return o;
      }
      r.exports = i;
    }, cdce: function(r, s, i) {
      var o = i("da84"), a = i("1626"), l = o.WeakMap;
      r.exports = a(l) && /native code/.test(String(l));
    }, ce86: function(r, s, i) {
      var o = i("9e69"), a = i("7948"), l = i("6747"), c = i("ffd6"), u = 1 / 0, d = o ? o.prototype : void 0, f = d ? d.toString : void 0;
      function p(h) {
        if (typeof h == "string") return h;
        if (l(h)) return a(h, p) + "";
        if (c(h)) return f ? f.call(h) : "";
        var m = h + "";
        return m == "0" && 1 / h == -u ? "-0" : m;
      }
      r.exports = p;
    }, cebd: function(r, s) {
      function i(o) {
        var a = -1, l = Array(o.size);
        return o.forEach(function(c) {
          l[++a] = [c, c];
        }), l;
      }
      r.exports = i;
    }, cfe5: function(r, s, i) {
      i.d(s, "a", function() {
        return d;
      }), i("13d5");
      var o = i("f7f1"), a = i("2fa3"), l = i("9404"), c = i("29ae");
      const u = 864e5;
      class d {
        constructor(p, { order: h = 0, locale: m, isFullDay: v } = {}) {
          if (this.isDateInfo = !0, this.order = h, this.locale = m instanceof c.b ? m : new c.b(m), this.firstDayOfWeek = this.locale.firstDayOfWeek, !Object(l.m)(p)) {
            const S = this.locale.normalizeDate(p);
            p = v ? { start: S, end: S } : { startOn: S, endOn: S };
          }
          let y = null, _ = null;
          if (p.start ? y = this.locale.normalizeDate(p.start, { ...this.opts, time: "00:00:00" }) : p.startOn && (y = this.locale.normalizeDate(p.startOn, this.opts)), p.end ? _ = this.locale.normalizeDate(p.end, { ...this.opts, time: "23:59:59" }) : p.endOn && (_ = this.locale.normalizeDate(p.endOn, this.opts)), y && _ && y > _) {
            const S = y;
            y = _, _ = S;
          } else y && p.span >= 1 && (_ = Object(o.a)(y, p.span - 1));
          this.start = y, this.startTime = y ? y.getTime() : NaN, this.end = _, this.endTime = _ ? _.getTime() : NaN, this.isDate = this.startTime && this.startTime === this.endTime, this.isRange = !this.isDate;
          const w = Object(a.i)(p, {}, d.patternProps);
          if (w.assigned && (this.on = { and: w.target }), p.on) {
            const S = (Object(l.h)(p.on) ? p.on : [p.on]).map(function(E) {
              if (Object(l.k)(E)) return E;
              const x = Object(a.i)(E, {}, d.patternProps);
              return x.assigned ? x.target : null;
            }).filter(function(E) {
              return E;
            });
            S.length && (this.on = { ...this.on, or: S });
          }
          this.isComplex = !!this.on;
        }
        get opts() {
          return { order: this.order, locale: this.locale };
        }
        toDateInfo(p) {
          return p.isDateInfo ? p : new d(p, this.opts);
        }
        startOfWeek(p) {
          const h = p.getDay() + 1, m = h >= this.firstDayOfWeek ? this.firstDayOfWeek - h : -(7 - (this.firstDayOfWeek - h));
          return Object(o.a)(p, m);
        }
        diffInDays(p, h) {
          return Math.round((h - p) / u);
        }
        diffInWeeks(p, h) {
          return this.diffInDays(this.startOfWeek(p), this.startOfWeek(h));
        }
        diffInYears(p, h) {
          return h.getUTCFullYear() - p.getUTCFullYear();
        }
        diffInMonths(p, h) {
          return 12 * this.diffInYears(p, h) + (h.getMonth() - p.getMonth());
        }
        static get patterns() {
          return { dailyInterval: { test: function(p, h, m) {
            return m.diffInDays(m.start || /* @__PURE__ */ new Date(), p.date) % h === 0;
          } }, weeklyInterval: { test: function(p, h, m) {
            return m.diffInWeeks(m.start || /* @__PURE__ */ new Date(), p.date) % h === 0;
          } }, monthlyInterval: { test: function(p, h, m) {
            return m.diffInMonths(m.start || /* @__PURE__ */ new Date(), p.date) % h === 0;
          } }, yearlyInterval: { test: function() {
            return function(p, h, m) {
              return m.diffInYears(m.start || /* @__PURE__ */ new Date(), p.date) % h === 0;
            };
          } }, days: { validate: function(p) {
            return Object(l.h)(p) ? p : [parseInt(p, 10)];
          }, test: function(p, h) {
            return h.includes(p.day) || h.includes(-p.dayFromEnd);
          } }, weekdays: { validate: function(p) {
            return Object(l.h)(p) ? p : [parseInt(p, 10)];
          }, test: function(p, h) {
            return h.includes(p.weekday);
          } }, ordinalWeekdays: { validate: function(p) {
            return Object.keys(p).reduce(function(h, m) {
              const v = p[m];
              return v && (h[m] = Object(l.h)(v) ? v : [parseInt(v, 10)]), h;
            }, {});
          }, test: function(p, h) {
            return Object.keys(h).map(function(m) {
              return parseInt(m, 10);
            }).find(function(m) {
              return h[m].includes(p.weekday) && (m === p.weekdayOrdinal || m === -p.weekdayOrdinalFromEnd);
            });
          } }, weekends: { validate: function(p) {
            return p;
          }, test: function(p) {
            return p.weekday === 1 || p.weekday === 7;
          } }, workweek: { validate: function(p) {
            return p;
          }, test: function(p) {
            return p.weekday >= 2 && p.weekday <= 6;
          } }, weeks: { validate: function(p) {
            return Object(l.h)(p) ? p : [parseInt(p, 10)];
          }, test: function(p, h) {
            return h.includes(p.week) || h.includes(-p.weekFromEnd);
          } }, months: { validate: function(p) {
            return Object(l.h)(p) ? p : [parseInt(p, 10)];
          }, test: function(p, h) {
            return h.includes(p.month);
          } }, years: { validate: function(p) {
            return Object(l.h)(p) ? p : [parseInt(p, 10)];
          }, test: function(p, h) {
            return h.includes(p.year);
          } } };
        }
        static get patternProps() {
          return Object.keys(d.patterns).map(function(p) {
            return { name: p, validate: d.patterns[p].validate };
          });
        }
        static testConfig(p, h, m) {
          return Object(l.k)(p) ? p(h) : Object(l.m)(p) ? Object.keys(p).every(function(v) {
            return d.patterns[v].test(h, p[v], m);
          }) : null;
        }
        iterateDatesInRange({ start: p, end: h }, m) {
          if (!p || !h || !Object(l.k)(m)) return null;
          p = this.locale.normalizeDate(p, { ...this.opts, time: "00:00:00" });
          const v = { i: 0, date: p, day: this.locale.getDateParts(p), finished: !1 };
          let y = null;
          for (; !v.finished && v.date <= h; v.i++) y = m(v), v.date = Object(o.a)(v.date, 1), v.day = this.locale.getDateParts(v.date);
          return y;
        }
        shallowIntersectingRange(p) {
          return this.rangeShallowIntersectingRange(this, this.toDateInfo(p));
        }
        rangeShallowIntersectingRange(p, h) {
          if (!this.dateShallowIntersectsDate(p, h)) return null;
          const m = p.toRange(), v = h.toRange();
          let y = null, _ = null;
          return m.start ? y = v.start ? m.start > v.start ? m.start : v.start : m.start : v.start && (y = v.start), m.end ? _ = v.end ? m.end < v.end ? m.end : v.end : m.end : v.end && (_ = v.end), { start: y, end: _ };
        }
        intersectsDate(p) {
          var h = this;
          const m = this.toDateInfo(p);
          if (!this.shallowIntersectsDate(m)) return null;
          if (!this.on) return this;
          const v = this.rangeShallowIntersectingRange(this, m);
          let y = !1;
          return this.iterateDatesInRange(v, function(_) {
            h.matchesDay(_.day) && (y = y || m.matchesDay(_.day), _.finished = y);
          }), y;
        }
        shallowIntersectsDate(p) {
          return this.dateShallowIntersectsDate(this, this.toDateInfo(p));
        }
        dateShallowIntersectsDate(p, h) {
          return p.isDate ? h.isDate ? p.startTime === h.startTime : this.dateShallowIncludesDate(h, p) : h.isDate ? this.dateShallowIncludesDate(p, h) : !(p.start && h.end && p.start > h.end) && !(p.end && h.start && p.end < h.start);
        }
        includesDate(p) {
          var h = this;
          const m = this.toDateInfo(p);
          if (!this.shallowIncludesDate(m)) return !1;
          if (!this.on) return !0;
          const v = this.rangeShallowIntersectingRange(this, m);
          let y = !0;
          return this.iterateDatesInRange(v, function(_) {
            h.matchesDay(_.day) && (y = y && m.matchesDay(_.day), _.finished = !y);
          }), y;
        }
        shallowIncludesDate(p) {
          return this.dateShallowIncludesDate(this, p.isDate ? p : new d(p, this.opts));
        }
        dateShallowIncludesDate(p, h) {
          return p.isDate ? h.isDate ? p.startTime === h.startTime : !(!h.startTime || !h.endTime) && p.startTime === h.startTime && p.startTime === h.endTime : h.isDate ? !(p.start && h.start < p.start) && !(p.end && h.start > p.end) : !(p.start && (!h.start || h.start < p.start)) && !(p.end && (!h.end || h.end > p.end));
        }
        intersectsDay(p) {
          return this.shallowIntersectsDate(p.range) && this.matchesDay(p) ? this : null;
        }
        matchesDay(p) {
          var h = this;
          return !this.on || !(this.on.and && !d.testConfig(this.on.and, p, this)) && !(this.on.or && !this.on.or.some(function(m) {
            return d.testConfig(m, p, h);
          }));
        }
        toRange() {
          return new d({ start: this.start, end: this.end }, this.opts);
        }
        compare(p) {
          if (this.order !== p.order) return this.order - p.order;
          if (this.isDate !== p.isDate) return this.isDate ? 1 : -1;
          if (this.isDate) return 0;
          const h = this.start - p.start;
          return h !== 0 ? h : this.end - p.end;
        }
      }
    }, d012: function(r, s, i) {
      r.exports = {};
    }, d02c: function(r, s, i) {
      var o = i("5e2e"), a = i("79bc"), l = i("7b83"), c = 200;
      function u(d, f) {
        var p = this.__data__;
        if (p instanceof o) {
          var h = p.__data__;
          if (!a || h.length < c - 1) return h.push([d, f]), this.size = ++p.size, this;
          p = this.__data__ = new l(h);
        }
        return p.set(d, f), this.size = p.size, this;
      }
      r.exports = u;
    }, d039: function(r, s, i) {
      r.exports = function(o) {
        try {
          return !!o();
        } catch {
          return !0;
        }
      };
    }, d066: function(r, s, i) {
      var o = i("da84"), a = i("1626"), l = function(c) {
        return a(c) ? c : void 0;
      };
      r.exports = function(c, u) {
        return arguments.length < 2 ? l(o[c]) : o[c] && o[c][u];
      };
    }, d1e7: function(r, s, i) {
      var o = {}.propertyIsEnumerable, a = Object.getOwnPropertyDescriptor, l = a && !o.call({ 1: 2 }, 1);
      s.f = l ? function(c) {
        var u = a(this, c);
        return !!u && u.enumerable;
      } : o;
    }, d2bb: function(r, s, i) {
      var o = i("7282"), a = i("825a"), l = i("3bbe");
      r.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var c, u = !1, d = {};
        try {
          c = o(Object.prototype, "__proto__", "set"), c(d, []), u = d instanceof Array;
        } catch {
        }
        return function(f, p) {
          return a(f), l(p), u ? c(f, p) : f.__proto__ = p, f;
        };
      }() : void 0);
    }, d327: function(r, s) {
      function i() {
        return [];
      }
      r.exports = i;
    }, d370: function(r, s, i) {
      var o = i("253c"), a = i("1310"), l = Object.prototype, c = l.hasOwnProperty, u = l.propertyIsEnumerable, d = o(/* @__PURE__ */ function() {
        return arguments;
      }()) ? o : function(f) {
        return a(f) && c.call(f, "callee") && !u.call(f, "callee");
      };
      r.exports = d;
    }, d58f: function(r, s, i) {
      var o = i("59ed"), a = i("7b0b"), l = i("44ad"), c = i("07fa"), u = TypeError, d = function(f) {
        return function(p, h, m, v) {
          o(h);
          var y = a(p), _ = l(y), w = c(y), S = f ? w - 1 : 0, E = f ? -1 : 1;
          if (m < 2) for (; ; ) {
            if (S in _) {
              v = _[S], S += E;
              break;
            }
            if (S += E, f ? S < 0 : w <= S) throw new u("Reduce of empty array with no initial value");
          }
          for (; f ? S >= 0 : w > S; S += E) S in _ && (v = h(v, _[S], S, y));
          return v;
        };
      };
      r.exports = { left: d(!1), right: d(!0) };
    }, d612: function(r, s, i) {
      var o = i("7b83"), a = i("7ed2"), l = i("dc0f");
      function c(u) {
        var d = -1, f = u == null ? 0 : u.length;
        for (this.__data__ = new o(); ++d < f; ) this.add(u[d]);
      }
      c.prototype.add = c.prototype.push = a, c.prototype.has = l, r.exports = c;
    }, d798: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-day-popover-row[data-v-eb5afd1a]{--day-content-transition-time:0.13s ease-in;display:flex;align-items:center;transition:all var(--day-content-transition-time)}.vc-day-popover-row[data-v-eb5afd1a]:not(:first-child){margin-top:3px}.vc-day-popover-row-indicator[data-v-eb5afd1a]{display:flex;justify-content:center;align-items:center;flex-grow:0;width:15px;margin-right:3px}.vc-day-popover-row-indicator span[data-v-eb5afd1a]{transition:all var(--day-content-transition-time)}.vc-day-popover-row-content[data-v-eb5afd1a]{display:flex;align-items:center;flex-wrap:none;flex-grow:1;width:max-content}", ""]), r.exports = s;
    }, d7ee: function(r, s, i) {
      var o = i("c3fc"), a = i("b047"), l = i("99d3"), c = l && l.isSet, u = c ? a(c) : o;
      r.exports = u;
    }, d8e2: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, '.vc-popover-content-wrapper[data-v-03f17c2c]{--popover-horizontal-content-offset:8px;--popover-vertical-content-offset:10px;--popover-slide-translation:15px;--popover-transition-time:0.14s ease-in-out;--popover-caret-horizontal-offset:18px;--popover-caret-vertical-offset:8px;position:absolute;display:block;outline:none;z-index:10}.vc-popover-content-wrapper[data-v-03f17c2c]:not(.is-interactive){pointer-events:none}.vc-popover-content[data-v-03f17c2c]{position:relative;outline:none;z-index:10;box-shadow:var(--shadow-lg)}.vc-popover-content.direction-bottom[data-v-03f17c2c]{margin-top:var(--popover-vertical-content-offset)}.vc-popover-content.direction-top[data-v-03f17c2c]{margin-bottom:var(--popover-vertical-content-offset)}.vc-popover-content.direction-left[data-v-03f17c2c]{margin-right:var(--popover-horizontal-content-offset)}.vc-popover-content.direction-right[data-v-03f17c2c]{margin-left:var(--popover-horizontal-content-offset)}.vc-popover-caret[data-v-03f17c2c]{content:"";position:absolute;display:block;width:12px;height:12px;border-top:inherit;border-left:inherit;background-color:inherit;-webkit-user-select:none;user-select:none;z-index:-1}.vc-popover-caret.direction-bottom[data-v-03f17c2c]{top:0}.vc-popover-caret.direction-bottom.align-left[data-v-03f17c2c]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-center[data-v-03f17c2c]{transform:translateX(-50%) translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-right[data-v-03f17c2c]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-top[data-v-03f17c2c]{top:100%}.vc-popover-caret.direction-top.align-left[data-v-03f17c2c]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-center[data-v-03f17c2c]{transform:translateX(-50%) translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-right[data-v-03f17c2c]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-left[data-v-03f17c2c]{left:100%}.vc-popover-caret.direction-left.align-top[data-v-03f17c2c]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-middle[data-v-03f17c2c]{transform:translateY(-50%) translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-bottom[data-v-03f17c2c]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-right[data-v-03f17c2c]{left:0}.vc-popover-caret.direction-right.align-top[data-v-03f17c2c]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-middle[data-v-03f17c2c]{transform:translateY(-50%) translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-bottom[data-v-03f17c2c]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.align-left[data-v-03f17c2c]{left:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-center[data-v-03f17c2c]{left:50%}.vc-popover-caret.align-right[data-v-03f17c2c]{right:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-top[data-v-03f17c2c]{top:var(--popover-caret-vertical-offset)}.vc-popover-caret.align-middle[data-v-03f17c2c]{top:50%}.vc-popover-caret.align-bottom[data-v-03f17c2c]{bottom:var(--popover-caret-vertical-offset)}.fade-enter-active[data-v-03f17c2c],.fade-leave-active[data-v-03f17c2c],.slide-fade-enter-active[data-v-03f17c2c],.slide-fade-leave-active[data-v-03f17c2c]{transition:all var(--popover-transition-time);pointer-events:none}.fade-enter[data-v-03f17c2c],.fade-leave-to[data-v-03f17c2c],.slide-fade-enter[data-v-03f17c2c],.slide-fade-leave-to[data-v-03f17c2c]{opacity:0}.slide-fade-enter.direction-bottom[data-v-03f17c2c],.slide-fade-leave-to.direction-bottom[data-v-03f17c2c]{transform:translateY(calc(var(--popover-slide-translation)*-1))}.slide-fade-enter.direction-top[data-v-03f17c2c],.slide-fade-leave-to.direction-top[data-v-03f17c2c]{transform:translateY(var(--popover-slide-translation))}.slide-fade-enter.direction-left[data-v-03f17c2c],.slide-fade-leave-to.direction-left[data-v-03f17c2c]{transform:translateX(var(--popover-slide-translation))}.slide-fade-enter.direction-right[data-v-03f17c2c],.slide-fade-leave-to.direction-right[data-v-03f17c2c]{transform:translateX(calc(var(--popover-slide-translation)*-1))}', ""]), r.exports = s;
    }, d9b5: function(r, s, i) {
      var o = i("d066"), a = i("1626"), l = i("3a9b"), c = i("fdbf"), u = Object;
      r.exports = c ? function(d) {
        return typeof d == "symbol";
      } : function(d) {
        var f = o("Symbol");
        return a(f) && l(f.prototype, u(d));
      };
    }, d9e2: function(r, s, i) {
      var o = i("23e7"), a = i("da84"), l = i("2ba4"), c = i("e5cb"), u = "WebAssembly", d = a[u], f = new Error("e", { cause: 7 }).cause !== 7, p = function(m, v) {
        var y = {};
        y[m] = c(m, v, f), o({ global: !0, constructor: !0, arity: 1, forced: f }, y);
      }, h = function(m, v) {
        if (d && d[m]) {
          var y = {};
          y[m] = c(u + "." + m, v, f), o({ target: u, stat: !0, constructor: !0, arity: 1, forced: f }, y);
        }
      };
      p("Error", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), p("EvalError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), p("RangeError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), p("ReferenceError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), p("SyntaxError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), p("TypeError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), p("URIError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), h("CompileError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), h("LinkError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      }), h("RuntimeError", function(m) {
        return function(v) {
          return l(m, this, arguments);
        };
      });
    }, da03: function(r, s, i) {
      var o = i("2b3e"), a = o["__core-js_shared__"];
      r.exports = a;
    }, da84: function(r, s, i) {
      (function(o) {
        var a = function(l) {
          return l && l.Math === Math && l;
        };
        r.exports = a(typeof globalThis == "object" && globalThis) || a(typeof window == "object" && window) || a(typeof self == "object" && self) || a(typeof o == "object" && o) || /* @__PURE__ */ function() {
          return this;
        }() || this || Function("return this")();
      }).call(this, i("c8ba"));
    }, dc0f: function(r, s) {
      function i(o) {
        return this.__data__.has(o);
      }
      r.exports = i;
    }, dc4a: function(r, s, i) {
      var o = i("59ed"), a = i("7234");
      r.exports = function(l, c) {
        var u = l[c];
        return a(u) ? void 0 : o(u);
      };
    }, dc57: function(r, s) {
      var i = Function.prototype, o = i.toString;
      function a(l) {
        if (l != null) {
          try {
            return o.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      r.exports = a;
    }, dc8c: function(r, s, i) {
      var o = i("24fb");
      s = o(!1), s.push([r.i, ".vc-container{--white:#fff;--black:#000;--gray-100:#f7fafc;--gray-200:#edf2f7;--gray-300:#e2e8f0;--gray-400:#cbd5e0;--gray-500:#a0aec0;--gray-600:#718096;--gray-700:#4a5568;--gray-800:#2d3748;--gray-900:#1a202c;--red-100:#fff5f5;--red-200:#fed7d7;--red-300:#feb2b2;--red-400:#fc8181;--red-500:#f56565;--red-600:#e53e3e;--red-700:#c53030;--red-800:#9b2c2c;--red-900:#742a2a;--orange-100:#fffaf0;--orange-200:#feebc8;--orange-300:#fbd38d;--orange-400:#f6ad55;--orange-500:#ed8936;--orange-600:#dd6b20;--orange-700:#c05621;--orange-800:#9c4221;--orange-900:#7b341e;--yellow-100:ivory;--yellow-200:#fefcbf;--yellow-300:#faf089;--yellow-400:#f6e05e;--yellow-500:#ecc94b;--yellow-600:#d69e2e;--yellow-700:#b7791f;--yellow-800:#975a16;--yellow-900:#744210;--green-100:#f0fff4;--green-200:#c6f6d5;--green-300:#9ae6b4;--green-400:#68d391;--green-500:#48bb78;--green-600:#38a169;--green-700:#2f855a;--green-800:#276749;--green-900:#22543d;--teal-100:#e6fffa;--teal-200:#b2f5ea;--teal-300:#81e6d9;--teal-400:#4fd1c5;--teal-500:#38b2ac;--teal-600:#319795;--teal-700:#2c7a7b;--teal-800:#285e61;--teal-900:#234e52;--blue-100:#ebf8ff;--blue-200:#bee3f8;--blue-300:#90cdf4;--blue-400:#63b3ed;--blue-500:#4299e1;--blue-600:#3182ce;--blue-700:#2b6cb0;--blue-800:#2c5282;--blue-900:#2a4365;--indigo-100:#ebf4ff;--indigo-200:#c3dafe;--indigo-300:#a3bffa;--indigo-400:#7f9cf5;--indigo-500:#667eea;--indigo-600:#5a67d8;--indigo-700:#4c51bf;--indigo-800:#434190;--indigo-900:#3c366b;--purple-100:#faf5ff;--purple-200:#e9d8fd;--purple-300:#d6bcfa;--purple-400:#b794f4;--purple-500:#9f7aea;--purple-600:#805ad5;--purple-700:#6b46c1;--purple-800:#553c9a;--purple-900:#44337a;--pink-100:#fff5f7;--pink-200:#fed7e2;--pink-300:#fbb6ce;--pink-400:#f687b3;--pink-500:#ed64a6;--pink-600:#d53f8c;--pink-700:#b83280;--pink-800:#97266d;--pink-900:#702459}.vc-container.vc-red{--accent-100:var(--red-100);--accent-200:var(--red-200);--accent-300:var(--red-300);--accent-400:var(--red-400);--accent-500:var(--red-500);--accent-600:var(--red-600);--accent-700:var(--red-700);--accent-800:var(--red-800);--accent-900:var(--red-900)}.vc-container.vc-orange{--accent-100:var(--orange-100);--accent-200:var(--orange-200);--accent-300:var(--orange-300);--accent-400:var(--orange-400);--accent-500:var(--orange-500);--accent-600:var(--orange-600);--accent-700:var(--orange-700);--accent-800:var(--orange-800);--accent-900:var(--orange-900)}.vc-container.vc-yellow{--accent-100:var(--yellow-100);--accent-200:var(--yellow-200);--accent-300:var(--yellow-300);--accent-400:var(--yellow-400);--accent-500:var(--yellow-500);--accent-600:var(--yellow-600);--accent-700:var(--yellow-700);--accent-800:var(--yellow-800);--accent-900:var(--yellow-900)}.vc-container.vc-green{--accent-100:var(--green-100);--accent-200:var(--green-200);--accent-300:var(--green-300);--accent-400:var(--green-400);--accent-500:var(--green-500);--accent-600:var(--green-600);--accent-700:var(--green-700);--accent-800:var(--green-800);--accent-900:var(--green-900)}.vc-container.vc-teal{--accent-100:var(--teal-100);--accent-200:var(--teal-200);--accent-300:var(--teal-300);--accent-400:var(--teal-400);--accent-500:var(--teal-500);--accent-600:var(--teal-600);--accent-700:var(--teal-700);--accent-800:var(--teal-800);--accent-900:var(--teal-900)}.vc-container.vc-blue{--accent-100:var(--blue-100);--accent-200:var(--blue-200);--accent-300:var(--blue-300);--accent-400:var(--blue-400);--accent-500:var(--blue-500);--accent-600:var(--blue-600);--accent-700:var(--blue-700);--accent-800:var(--blue-800);--accent-900:var(--blue-900)}.vc-container.vc-indigo{--accent-100:var(--indigo-100);--accent-200:var(--indigo-200);--accent-300:var(--indigo-300);--accent-400:var(--indigo-400);--accent-500:var(--indigo-500);--accent-600:var(--indigo-600);--accent-700:var(--indigo-700);--accent-800:var(--indigo-800);--accent-900:var(--indigo-900)}.vc-container.vc-purple{--accent-100:var(--purple-100);--accent-200:var(--purple-200);--accent-300:var(--purple-300);--accent-400:var(--purple-400);--accent-500:var(--purple-500);--accent-600:var(--purple-600);--accent-700:var(--purple-700);--accent-800:var(--purple-800);--accent-900:var(--purple-900)}.vc-container.vc-pink{--accent-100:var(--pink-100);--accent-200:var(--pink-200);--accent-300:var(--pink-300);--accent-400:var(--pink-400);--accent-500:var(--pink-500);--accent-600:var(--pink-600);--accent-700:var(--pink-700);--accent-800:var(--pink-800);--accent-900:var(--pink-900)}.vc-container{--font-normal:400;--font-medium:500;--font-semibold:600;--font-bold:700;--text-xs:12px;--text-sm:14px;--text-base:16px;--text-lg:18px;--leading-snug:1.375;--rounded:0.25rem;--rounded-lg:0.5rem;--rounded-full:9999px;--shadow:0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06);--shadow-lg:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);--shadow-inner:inset 0 2px 4px 0 rgba(0,0,0,0.06);--slide-translate:22px;--slide-duration:0.15s;--slide-timing:ease;--day-content-transition-time:0.13s ease-in;--weeknumber-offset:-34px;position:relative;display:inline-flex;width:max-content;height:max-content;font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;color:var(--gray-900);background-color:var(--white);border:1px solid;border-color:var(--gray-400);border-radius:var(--rounded-lg);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent}.vc-container,.vc-container *{box-sizing:border-box}.vc-container:focus,.vc-container :focus{outline:none}.vc-container [role=button],.vc-container button{cursor:pointer}.vc-container.vc-is-expanded{min-width:100%}.vc-container .vc-container{border:none}.vc-container.vc-is-dark{color:var(--gray-100);background-color:var(--gray-900);border-color:var(--gray-700)}", ""]), r.exports = s;
    }, dc9e: function(r, s, i) {
      i("eb68");
    }, dcbe: function(r, s, i) {
      var o = i("30c9"), a = i("1310");
      function l(c) {
        return a(c) && o(c);
      }
      r.exports = l;
    }, dd61: function(r, s, i) {
      var o = i("7948"), a = i("badf"), l = i("97d3"), c = i("6747");
      function u(d, f) {
        var p = c(d) ? o : l;
        return p(d, a(f, 3));
      }
      r.exports = u;
    }, e031: function(r, s, i) {
      var o = i("f909"), a = i("1a8c");
      function l(c, u, d, f, p, h) {
        return a(c) && a(u) && (h.set(u, c), o(c, u, void 0, l, h), h.delete(u)), c;
      }
      r.exports = l;
    }, e0e7: function(r, s, i) {
      var o = i("60ed");
      function a(l) {
        return o(l) ? void 0 : l;
      }
      r.exports = a;
    }, e177: function(r, s, i) {
      i("55ed");
    }, e24b: function(r, s, i) {
      var o = i("49f4"), a = i("1efc"), l = i("bbc0"), c = i("7a48"), u = i("2524");
      function d(f) {
        var p = -1, h = f == null ? 0 : f.length;
        for (this.clear(); ++p < h; ) {
          var m = f[p];
          this.set(m[0], m[1]);
        }
      }
      d.prototype.clear = o, d.prototype.delete = a, d.prototype.get = l, d.prototype.has = c, d.prototype.set = u, r.exports = d;
    }, e2a0: function(r, s, i) {
      var o = i("3729"), a = i("6747"), l = i("1310"), c = "[object String]";
      function u(d) {
        return typeof d == "string" || !a(d) && l(d) && o(d) == c;
      }
      r.exports = u;
    }, e2c0: function(r, s, i) {
      var o = i("e2e4"), a = i("d370"), l = i("6747"), c = i("c098"), u = i("b218"), d = i("f4d6");
      function f(p, h, m) {
        h = o(h, p);
        for (var v = -1, y = h.length, _ = !1; ++v < y; ) {
          var w = d(h[v]);
          if (!(_ = p != null && m(p, w))) break;
          p = p[w];
        }
        return _ || ++v != y ? _ : (y = p == null ? 0 : p.length, !!y && u(y) && c(w, y) && (l(p) || a(p)));
      }
      r.exports = f;
    }, e2e4: function(r, s, i) {
      var o = i("6747"), a = i("f608"), l = i("18d8"), c = i("76dd");
      function u(d, f) {
        return o(d) ? d : a(d, f) ? [d] : l(c(d));
      }
      r.exports = u;
    }, e330: function(r, s, i) {
      var o = i("40d5"), a = Function.prototype, l = a.call, c = o && a.bind.bind(l, l);
      r.exports = o ? c : function(u) {
        return function() {
          return l.apply(u, arguments);
        };
      };
    }, e380: function(r, s, i) {
      var o = i("7b83"), a = "Expected a function";
      function l(c, u) {
        if (typeof c != "function" || u != null && typeof u != "function") throw new TypeError(a);
        var d = function() {
          var f = arguments, p = u ? u.apply(this, f) : f[0], h = d.cache;
          if (h.has(p)) return h.get(p);
          var m = c.apply(this, f);
          return d.cache = h.set(p, m) || h, m;
        };
        return d.cache = new (l.Cache || o)(), d;
      }
      l.Cache = o, r.exports = l;
    }, e391: function(r, s, i) {
      var o = i("577e");
      r.exports = function(a, l) {
        return a === void 0 ? arguments.length < 2 ? "" : l : o(a);
      };
    }, e3f8: function(r, s, i) {
      var o = i("656b");
      function a(l) {
        return function(c) {
          return o(c, l);
        };
      }
      r.exports = a;
    }, e538: function(r, s, i) {
      (function(o) {
        var a = i("2b3e"), l = s && !s.nodeType && s, c = l && typeof o == "object" && o && !o.nodeType && o, u = c && c.exports === l, d = u ? a.Buffer : void 0, f = d ? d.allocUnsafe : void 0;
        function p(h, m) {
          if (m) return h.slice();
          var v = h.length, y = f ? f(v) : new h.constructor(v);
          return h.copy(y), y;
        }
        o.exports = p;
      }).call(this, i("62e4")(r));
    }, e5cb: function(r, s, i) {
      var o = i("d066"), a = i("1a2d"), l = i("9112"), c = i("3a9b"), u = i("d2bb"), d = i("e893"), f = i("aeb0"), p = i("7156"), h = i("e391"), m = i("ab36"), v = i("6f19"), y = i("83ab"), _ = i("c430");
      r.exports = function(w, S, E, x) {
        var T = "stackTraceLimit", C = x ? 2 : 1, k = w.split("."), b = k[k.length - 1], P = o.apply(null, k);
        if (P) {
          var N = P.prototype;
          if (!_ && a(N, "cause") && delete N.cause, !E) return P;
          var D = o("Error"), H = S(function(Y, te) {
            var A = h(x ? te : Y, void 0), j = x ? new P(Y) : new P();
            return A !== void 0 && l(j, "message", A), v(j, H, j.stack, 2), this && c(N, this) && p(j, this, H), arguments.length > C && m(j, arguments[C]), j;
          });
          if (H.prototype = N, b !== "Error" ? u ? u(H, D) : d(H, D, { name: !0 }) : y && T in P && (f(H, P, T), f(H, P, "prepareStackTrace")), d(H, P), !_) try {
            N.name !== b && l(N, "name", b), N.constructor = H;
          } catch {
          }
          return H;
        }
      };
    }, e893: function(r, s, i) {
      var o = i("1a2d"), a = i("56ef"), l = i("06cf"), c = i("9bf2");
      r.exports = function(u, d, f) {
        for (var p = a(d), h = c.f, m = l.f, v = 0; v < p.length; v++) {
          var y = p[v];
          o(u, y) || f && o(f, y) || h(u, y, m(d, y));
        }
      };
    }, e8b5: function(r, s, i) {
      var o = i("c6b6");
      r.exports = Array.isArray || function(a) {
        return o(a) === "Array";
      };
    }, eac5: function(r, s) {
      var i = Object.prototype;
      function o(a) {
        var l = a && a.constructor, c = typeof l == "function" && l.prototype || i;
        return a === c;
      }
      r.exports = o;
    }, eb68: function(r, s, i) {
      var o = i("b0b5");
      o.__esModule && (o = o.default), typeof o == "string" && (o = [[r.i, o, ""]]), o.locals && (r.exports = o.locals);
      var a = i("499e").default;
      a("06cf7692", o, !0, { sourceMap: !1, shadowMode: !1 });
    }, ec47: function(r, s, i) {
      var o = i("a3fd"), a = i("42a2"), l = i("edfa"), c = i("cebd"), u = "[object Map]", d = "[object Set]";
      function f(p) {
        return function(h) {
          var m = a(h);
          return m == u ? l(h) : m == d ? c(h) : o(h, p(h));
        };
      }
      r.exports = f;
    }, ec69: function(r, s, i) {
      var o = i("6fcd"), a = i("03dd"), l = i("30c9");
      function c(u) {
        return l(u) ? o(u) : a(u);
      }
      r.exports = c;
    }, ec8c: function(r, s) {
      function i(o) {
        var a = [];
        if (o != null) for (var l in Object(o)) a.push(l);
        return a;
      }
      r.exports = i;
    }, ed08: function(r, s, i) {
      i.r(s), i.d(s, "Locale", function() {
        return o.b;
      }), i.d(s, "DateInfo", function() {
        return a.a;
      }), i.d(s, "Attribute", function() {
        return l.a;
      }), i.d(s, "AttributeStore", function() {
        return c.a;
      }), i.d(s, "setupCalendar", function() {
        return f;
      }), i.d(s, "pad", function() {
        return p.m;
      }), i.d(s, "evalFn", function() {
        return p.f;
      }), i.d(s, "mergeEvents", function() {
        return p.h;
      }), i.d(s, "pageIsValid", function() {
        return p.r;
      }), i.d(s, "pageIsBeforePage", function() {
        return p.o;
      }), i.d(s, "pageIsAfterPage", function() {
        return p.n;
      }), i.d(s, "pageIsBetweenPages", function() {
        return p.p;
      }), i.d(s, "pageIsEqualToPage", function() {
        return p.q;
      }), i.d(s, "addPages", function() {
        return p.a;
      }), i.d(s, "pageRangeToArray", function() {
        return p.s;
      }), i.d(s, "datesAreEqual", function() {
        return p.d;
      }), i.d(s, "arrayHasItems", function() {
        return p.b;
      }), i.d(s, "mixinOptionalProps", function() {
        return p.i;
      }), i.d(s, "on", function() {
        return p.k;
      }), i.d(s, "off", function() {
        return p.j;
      }), i.d(s, "elementContains", function() {
        return p.e;
      }), i.d(s, "onSpaceOrEnter", function() {
        return p.l;
      }), i.d(s, "createGuid", function() {
        return p.c;
      }), i.d(s, "hash", function() {
        return p.g;
      }), i.d(s, "addHorizontalSwipeHandler", function() {
        return h.a;
      });
      var o = i("29ae"), a = i("cfe5"), l = i("22f3"), c = i("9349"), u = i("51ec"), d = i("1315"), f = function(m) {
        const v = Object(u.b)(m);
        return Object(d.a)(v.screens, !0), v;
      }, p = i("2fa3"), h = i("0733");
    }, edfa: function(r, s) {
      function i(o) {
        var a = -1, l = Array(o.size);
        return o.forEach(function(c, u) {
          l[++a] = [u, c];
        }), l;
      }
      r.exports = i;
    }, ef5d: function(r, s) {
      function i(o) {
        return function(a) {
          return a == null ? void 0 : a[o];
        };
      }
      r.exports = i;
    }, efb6: function(r, s, i) {
      var o = i("5e2e");
      function a() {
        this.__data__ = new o(), this.size = 0;
      }
      r.exports = a;
    }, f15d: function(r, s, i) {
      var o = i("9404");
      const a = { ar: { dow: 7, L: "D/‏M/‏YYYY" }, bg: { dow: 2, L: "D.MM.YYYY" }, ca: { dow: 2, L: "DD/MM/YYYY" }, "zh-CN": { dow: 2, L: "YYYY/MM/DD" }, "zh-TW": { dow: 1, L: "YYYY/MM/DD" }, hr: { dow: 2, L: "DD.MM.YYYY" }, cs: { dow: 2, L: "DD.MM.YYYY" }, da: { dow: 2, L: "DD.MM.YYYY" }, nl: { dow: 2, L: "DD-MM-YYYY" }, "en-US": { dow: 1, L: "MM/DD/YYYY" }, "en-AU": { dow: 2, L: "DD/MM/YYYY" }, "en-CA": { dow: 1, L: "YYYY-MM-DD" }, "en-GB": { dow: 2, L: "DD/MM/YYYY" }, "en-IE": { dow: 2, L: "DD-MM-YYYY" }, "en-NZ": { dow: 2, L: "DD/MM/YYYY" }, "en-ZA": { dow: 1, L: "YYYY/MM/DD" }, eo: { dow: 2, L: "YYYY-MM-DD" }, et: { dow: 2, L: "DD.MM.YYYY" }, fi: { dow: 2, L: "DD.MM.YYYY" }, fr: { dow: 2, L: "DD/MM/YYYY" }, "fr-CA": { dow: 1, L: "YYYY-MM-DD" }, "fr-CH": { dow: 2, L: "DD.MM.YYYY" }, de: { dow: 2, L: "DD.MM.YYYY" }, he: { dow: 1, L: "DD.MM.YYYY" }, id: { dow: 2, L: "DD/MM/YYYY" }, it: { dow: 2, L: "DD/MM/YYYY" }, ja: { dow: 1, L: "YYYY年M月D日" }, ko: { dow: 1, L: "YYYY.MM.DD" }, lv: { dow: 2, L: "DD.MM.YYYY" }, lt: { dow: 2, L: "DD.MM.YYYY" }, mk: { dow: 2, L: "D.MM.YYYY" }, nb: { dow: 2, L: "D. MMMM YYYY" }, nn: { dow: 2, L: "D. MMMM YYYY" }, pl: { dow: 2, L: "DD.MM.YYYY" }, pt: { dow: 2, L: "DD/MM/YYYY" }, ro: { dow: 2, L: "DD.MM.YYYY" }, ru: { dow: 2, L: "DD.MM.YYYY" }, sk: { dow: 2, L: "DD.MM.YYYY" }, "es-ES": { dow: 2, L: "DD/MM/YYYY" }, "es-MX": { dow: 2, L: "DD/MM/YYYY" }, sv: { dow: 2, L: "YYYY-MM-DD" }, th: { dow: 1, L: "DD/MM/YYYY" }, tr: { dow: 2, L: "DD.MM.YYYY" }, uk: { dow: 2, L: "DD.MM.YYYY" }, vi: { dow: 2, L: "DD/MM/YYYY" } };
      a.en = a["en-US"], a.es = a["es-ES"], a.no = a.nb, a.zh = a["zh-CN"], Object(o.w)(a).forEach(function([l, { dow: c, L: u }]) {
        a[l] = { id: l, firstDayOfWeek: c, masks: { L: u } };
      }), s.a = a;
    }, f3c1: function(r, s) {
      var i = 800, o = 16, a = Date.now;
      function l(c) {
        var u = 0, d = 0;
        return function() {
          var f = a(), p = o - (f - d);
          if (d = f, p > 0) {
            if (++u >= i) return arguments[0];
          } else u = 0;
          return c.apply(void 0, arguments);
        };
      }
      r.exports = l;
    }, f4d6: function(r, s, i) {
      var o = i("ffd6"), a = 1 / 0;
      function l(c) {
        if (typeof c == "string" || o(c)) return c;
        var u = c + "";
        return u == "0" && 1 / c == -a ? "-0" : u;
      }
      r.exports = l;
    }, f542: function(r, s, i) {
      var o = i("ec47"), a = i("ec69"), l = o(a);
      r.exports = l;
    }, f5df: function(r, s, i) {
      var o = i("00ee"), a = i("1626"), l = i("c6b6"), c = i("b622"), u = c("toStringTag"), d = Object, f = l(/* @__PURE__ */ function() {
        return arguments;
      }()) === "Arguments", p = function(h, m) {
        try {
          return h[m];
        } catch {
        }
      };
      r.exports = o ? l : function(h) {
        var m, v, y;
        return h === void 0 ? "Undefined" : h === null ? "Null" : typeof (v = p(m = d(h), u)) == "string" ? v : f ? l(m) : (y = l(m)) === "Object" && a(m.callee) ? "Arguments" : y;
      };
    }, f608: function(r, s, i) {
      var o = i("6747"), a = i("ffd6"), l = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/;
      function u(d, f) {
        if (o(d)) return !1;
        var p = typeof d;
        return !(p != "number" && p != "symbol" && p != "boolean" && d != null && !a(d)) || c.test(d) || !l.test(d) || f != null && d in Object(f);
      }
      r.exports = u;
    }, f678: function(r, s, i) {
      var o = i("8384"), a = i("b4b0");
      function l(c, u, d) {
        return d === void 0 && (d = u, u = void 0), d !== void 0 && (d = a(d), d = d === d ? d : 0), u !== void 0 && (u = a(u), u = u === u ? u : 0), o(a(c), u, d);
      }
      r.exports = l;
    }, f772: function(r, s, i) {
      var o = i("5692"), a = i("90e3"), l = o("keys");
      r.exports = function(c) {
        return l[c] || (l[c] = a(c));
      };
    }, f7f1: function(r, s, i) {
      i.d(s, "a", function() {
        return c;
      });
      var o = i("fe1f"), a = i("fd3a"), l = i("8c86");
      function c(u, d) {
        Object(l.a)(2, arguments);
        var f = Object(a.a)(u), p = Object(o.a)(d);
        return isNaN(p) ? /* @__PURE__ */ new Date(NaN) : (p && f.setDate(f.getDate() + p), f);
      }
    }, f8af: function(r, s, i) {
      var o = i("2474");
      function a(l) {
        var c = new l.constructor(l.byteLength);
        return new o(c).set(new o(l)), c;
      }
      r.exports = a;
    }, f909: function(r, s, i) {
      var o = i("7e64"), a = i("b760"), l = i("72af"), c = i("4f50"), u = i("1a8c"), d = i("9934"), f = i("8adb");
      function p(h, m, v, y, _) {
        h !== m && l(m, function(w, S) {
          if (_ || (_ = new o()), u(w)) c(h, m, S, v, p, y, _);
          else {
            var E = y ? y(f(h, S), w, S + "", h, m, _) : void 0;
            E === void 0 && (E = w), a(h, S, E);
          }
        }, d);
      }
      r.exports = p;
    }, f954: function(r, s, i) {
      i("8518");
    }, f9ce: function(r, s, i) {
      var o = i("ef5d"), a = i("e3f8"), l = i("f608"), c = i("f4d6");
      function u(d) {
        return l(d) ? o(c(d)) : a(d);
      }
      r.exports = u;
    }, fa21: function(r, s, i) {
      var o = i("7530"), a = i("2dcb"), l = i("eac5");
      function c(u) {
        return typeof u.constructor != "function" || l(u) ? {} : o(a(u));
      }
      r.exports = c;
    }, fb15: function(r, s, i) {
      if (i.r(s), i.d(s, "Calendar", function() {
        return l.c;
      }), i.d(s, "CalendarNav", function() {
        return l.d;
      }), i.d(s, "DatePicker", function() {
        return l.f;
      }), i.d(s, "Popover", function() {
        return l.h;
      }), i.d(s, "Locale", function() {
        return l.g;
      }), i.d(s, "DateInfo", function() {
        return l.e;
      }), i.d(s, "Attribute", function() {
        return l.a;
      }), i.d(s, "AttributeStore", function() {
        return l.b;
      }), i.d(s, "setupCalendar", function() {
        return l.D;
      }), i.d(s, "pad", function() {
        return l.w;
      }), i.d(s, "evalFn", function() {
        return l.p;
      }), i.d(s, "mergeEvents", function() {
        return l.r;
      }), i.d(s, "pageIsValid", function() {
        return l.B;
      }), i.d(s, "pageIsBeforePage", function() {
        return l.y;
      }), i.d(s, "pageIsAfterPage", function() {
        return l.x;
      }), i.d(s, "pageIsBetweenPages", function() {
        return l.z;
      }), i.d(s, "pageIsEqualToPage", function() {
        return l.A;
      }), i.d(s, "addPages", function() {
        return l.j;
      }), i.d(s, "pageRangeToArray", function() {
        return l.C;
      }), i.d(s, "datesAreEqual", function() {
        return l.m;
      }), i.d(s, "arrayHasItems", function() {
        return l.k;
      }), i.d(s, "mixinOptionalProps", function() {
        return l.s;
      }), i.d(s, "on", function() {
        return l.u;
      }), i.d(s, "off", function() {
        return l.t;
      }), i.d(s, "elementContains", function() {
        return l.o;
      }), i.d(s, "onSpaceOrEnter", function() {
        return l.v;
      }), i.d(s, "createGuid", function() {
        return l.l;
      }), i.d(s, "hash", function() {
        return l.q;
      }), i.d(s, "addHorizontalSwipeHandler", function() {
        return l.i;
      }), typeof window < "u") {
        var o = window.document.currentScript, a = o && o.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
        a && (i.p = a[1]);
      }
      var l = i("34e9");
      s.default = l.n;
    }, fba5: function(r, s, i) {
      var o = i("cb5a");
      function a(l) {
        return o(this.__data__, l) > -1;
      }
      r.exports = a;
    }, fc6a: function(r, s, i) {
      var o = i("44ad"), a = i("1d80");
      r.exports = function(l) {
        return o(a(l));
      };
    }, fd3a: function(r, s, i) {
      i.d(s, "a", function() {
        return l;
      });
      var o = i("53ca"), a = i("8c86");
      function l(c) {
        Object(a.a)(1, arguments);
        var u = Object.prototype.toString.call(c);
        return c instanceof Date || Object(o.a)(c) === "object" && u === "[object Date]" ? new Date(c.getTime()) : typeof c == "number" || u === "[object Number]" ? new Date(c) : (typeof c != "string" && u !== "[object String]" || typeof console > "u" || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
      }
    }, fdbf: function(r, s, i) {
      var o = i("04f8");
      r.exports = o && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }, fe1f: function(r, s, i) {
      function o(a) {
        if (a === null || a === !0 || a === !1) return NaN;
        var l = Number(a);
        return isNaN(l) ? l : l < 0 ? Math.ceil(l) : Math.floor(l);
      }
      i.d(s, "a", function() {
        return o;
      });
    }, ffd6: function(r, s, i) {
      var o = i("3729"), a = i("1310"), l = "[object Symbol]";
      function c(u) {
        return typeof u == "symbol" || a(u) && o(u) == l;
      }
      r.exports = c;
    } });
  });
})(Yj);
var i2t = Yj.exports;
const o2t = /* @__PURE__ */ Et(i2t);
var Zj = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(vr, function() {
    return function(n) {
      function r(i) {
        if (s[i]) return s[i].exports;
        var o = s[i] = { i, l: !1, exports: {} };
        return n[i].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }
      var s = {};
      return r.m = n, r.c = s, r.i = function(i) {
        return i;
      }, r.d = function(i, o, a) {
        r.o(i, o) || Object.defineProperty(i, o, { configurable: !1, enumerable: !0, get: a });
      }, r.n = function(i) {
        var o = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(o, "a", o), o;
      }, r.o = function(i, o) {
        return Object.prototype.hasOwnProperty.call(i, o);
      }, r.p = "/", r(r.s = 89);
    }([function(n, r) {
      n.exports = function(s) {
        try {
          return !!s();
        } catch {
          return !0;
        }
      };
    }, function(n, r, s) {
      var i = s(35), o = Function.prototype, a = o.call, l = i && o.bind.bind(a, a);
      n.exports = i ? l : function(c) {
        return function() {
          return a.apply(c, arguments);
        };
      };
    }, function(n, r, s) {
      var i = s(59), o = i.all;
      n.exports = i.IS_HTMLDDA ? function(a) {
        return typeof a == "function" || a === o;
      } : function(a) {
        return typeof a == "function";
      };
    }, function(n, r, s) {
      var i = s(4), o = s(43).f, a = s(30), l = s(11), c = s(33), u = s(95), d = s(66);
      n.exports = function(f, p) {
        var h, m, v, y, _, w = f.target, S = f.global, E = f.stat;
        if (h = S ? i : E ? i[w] || c(w, {}) : (i[w] || {}).prototype) for (m in p) {
          if (y = p[m], f.dontCallGetSet ? (_ = o(h, m), v = _ && _.value) : v = h[m], !d(S ? m : w + (E ? "." : "#") + m, f.forced) && v !== void 0) {
            if (typeof y == typeof v) continue;
            u(y, v);
          }
          (f.sham || v && v.sham) && a(y, "sham", !0), l(h, m, y, f);
        }
      };
    }, function(n, r, s) {
      (function(i) {
        var o = function(a) {
          return a && a.Math == Math && a;
        };
        n.exports = o(typeof globalThis == "object" && globalThis) || o(typeof window == "object" && window) || o(typeof self == "object" && self) || o(typeof i == "object" && i) || /* @__PURE__ */ function() {
          return this;
        }() || Function("return this")();
      }).call(r, s(139));
    }, function(n, r, s) {
      var i = s(0);
      n.exports = !i(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }, function(n, r, s) {
      var i = s(8), o = String, a = TypeError;
      n.exports = function(l) {
        if (i(l)) return l;
        throw a(o(l) + " is not an object");
      };
    }, function(n, r, s) {
      var i = s(1), o = s(14), a = i({}.hasOwnProperty);
      n.exports = Object.hasOwn || function(l, c) {
        return a(o(l), c);
      };
    }, function(n, r, s) {
      var i = s(2), o = s(59), a = o.all;
      n.exports = o.IS_HTMLDDA ? function(l) {
        return typeof l == "object" ? l !== null : i(l) || l === a;
      } : function(l) {
        return typeof l == "object" ? l !== null : i(l);
      };
    }, function(n, r, s) {
      var i = s(4), o = s(47), a = s(7), l = s(75), c = s(72), u = s(76), d = o("wks"), f = i.Symbol, p = f && f.for, h = u ? f : f && f.withoutSetter || l;
      n.exports = function(m) {
        if (!a(d, m) || !c && typeof d[m] != "string") {
          var v = "Symbol." + m;
          c && a(f, m) ? d[m] = f[m] : d[m] = u && p ? p(v) : h(v);
        }
        return d[m];
      };
    }, function(n, r, s) {
      var i = s(123);
      n.exports = function(o) {
        return i(o.length);
      };
    }, function(n, r, s) {
      var i = s(2), o = s(13), a = s(104), l = s(33);
      n.exports = function(c, u, d, f) {
        f || (f = {});
        var p = f.enumerable, h = f.name !== void 0 ? f.name : u;
        if (i(d) && a(d, h, f), f.global) p ? c[u] = d : l(u, d);
        else {
          try {
            f.unsafe ? c[u] && (p = !0) : delete c[u];
          } catch {
          }
          p ? c[u] = d : o.f(c, u, { value: d, enumerable: !1, configurable: !f.nonConfigurable, writable: !f.nonWritable });
        }
        return c;
      };
    }, function(n, r, s) {
      var i = s(35), o = Function.prototype.call;
      n.exports = i ? o.bind(o) : function() {
        return o.apply(o, arguments);
      };
    }, function(n, r, s) {
      var i = s(5), o = s(62), a = s(77), l = s(6), c = s(50), u = TypeError, d = Object.defineProperty, f = Object.getOwnPropertyDescriptor;
      r.f = i ? a ? function(p, h, m) {
        if (l(p), h = c(h), l(m), typeof p == "function" && h === "prototype" && "value" in m && "writable" in m && !m.writable) {
          var v = f(p, h);
          v && v.writable && (p[h] = m.value, m = { configurable: "configurable" in m ? m.configurable : v.configurable, enumerable: "enumerable" in m ? m.enumerable : v.enumerable, writable: !1 });
        }
        return d(p, h, m);
      } : d : function(p, h, m) {
        if (l(p), h = c(h), l(m), o) try {
          return d(p, h, m);
        } catch {
        }
        if ("get" in m || "set" in m) throw u("Accessors not supported");
        return "value" in m && (p[h] = m.value), p;
      };
    }, function(n, r, s) {
      var i = s(24), o = Object;
      n.exports = function(a) {
        return o(i(a));
      };
    }, function(n, r, s) {
      var i = s(1), o = i({}.toString), a = i("".slice);
      n.exports = function(l) {
        return a(o(l), 8, -1);
      };
    }, function(n, r, s) {
      var i = s(0), o = s(9), a = s(23), l = o("species");
      n.exports = function(c) {
        return a >= 51 || !i(function() {
          var u = [], d = u.constructor = {};
          return d[l] = function() {
            return { foo: 1 };
          }, u[c](Boolean).foo !== 1;
        });
      };
    }, function(n, r, s) {
      var i = s(4), o = s(2), a = function(l) {
        return o(l) ? l : void 0;
      };
      n.exports = function(l, c) {
        return arguments.length < 2 ? a(i[l]) : i[l] && i[l][c];
      };
    }, function(n, r, s) {
      var i = s(15);
      n.exports = Array.isArray || function(o) {
        return i(o) == "Array";
      };
    }, function(n, r, s) {
      var i = s(39), o = s(24);
      n.exports = function(a) {
        return i(o(a));
      };
    }, function(n, r, s) {
      var i = s(29), o = String;
      n.exports = function(a) {
        if (i(a) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
        return o(a);
      };
    }, function(n, r, s) {
      var i = s(100), o = s(1), a = s(39), l = s(14), c = s(10), u = s(28), d = o([].push), f = function(p) {
        var h = p == 1, m = p == 2, v = p == 3, y = p == 4, _ = p == 6, w = p == 7, S = p == 5 || _;
        return function(E, x, T, C) {
          for (var k, b, P = l(E), N = a(P), D = i(x, T), H = c(N), Y = 0, te = C || u, A = h ? te(E, H) : m || w ? te(E, 0) : void 0; H > Y; Y++) if ((S || Y in N) && (k = N[Y], b = D(k, Y, P), p)) if (h) A[Y] = b;
          else if (b) switch (p) {
            case 3:
              return !0;
            case 5:
              return k;
            case 6:
              return Y;
            case 2:
              d(A, k);
          }
          else switch (p) {
            case 4:
              return !1;
            case 7:
              d(A, k);
          }
          return _ ? -1 : v || y ? y : A;
        };
      };
      n.exports = { forEach: f(0), map: f(1), filter: f(2), some: f(3), every: f(4), find: f(5), findIndex: f(6), filterReject: f(7) };
    }, function(n, r) {
      var s = TypeError;
      n.exports = function(i) {
        if (i > 9007199254740991) throw s("Maximum allowed index exceeded");
        return i;
      };
    }, function(n, r, s) {
      var i, o, a = s(4), l = s(97), c = a.process, u = a.Deno, d = c && c.versions || u && u.version, f = d && d.v8;
      f && (i = f.split("."), o = i[0] > 0 && i[0] < 4 ? 1 : +(i[0] + i[1])), !o && l && (!(i = l.match(/Edge\/(\d+)/)) || i[1] >= 74) && (i = l.match(/Chrome\/(\d+)/)) && (o = +i[1]), n.exports = o;
    }, function(n, r, s) {
      var i = s(40), o = TypeError;
      n.exports = function(a) {
        if (i(a)) throw o("Can't call method on " + a);
        return a;
      };
    }, function(n, r, s) {
      var i = s(2), o = s(74), a = TypeError;
      n.exports = function(l) {
        if (i(l)) return l;
        throw a(o(l) + " is not a function");
      };
    }, function(n, r, s) {
      var i = s(0);
      n.exports = function(o, a) {
        var l = [][o];
        return !!l && i(function() {
          l.call(null, a || function() {
            return 1;
          }, 1);
        });
      };
    }, function(n, r, s) {
      var i = s(5), o = s(18), a = TypeError, l = Object.getOwnPropertyDescriptor, c = i && !function() {
        if (this !== void 0) return !0;
        try {
          Object.defineProperty([], "length", { writable: !1 }).length = 1;
        } catch (u) {
          return u instanceof TypeError;
        }
      }();
      n.exports = c ? function(u, d) {
        if (o(u) && !l(u, "length").writable) throw a("Cannot set read only .length");
        return u.length = d;
      } : function(u, d) {
        return u.length = d;
      };
    }, function(n, r, s) {
      var i = s(94);
      n.exports = function(o, a) {
        return new (i(o))(a === 0 ? 0 : a);
      };
    }, function(n, r, s) {
      var i = s(51), o = s(2), a = s(15), l = s(9), c = l("toStringTag"), u = Object, d = a(/* @__PURE__ */ function() {
        return arguments;
      }()) == "Arguments", f = function(p, h) {
        try {
          return p[h];
        } catch {
        }
      };
      n.exports = i ? a : function(p) {
        var h, m, v;
        return p === void 0 ? "Undefined" : p === null ? "Null" : typeof (m = f(h = u(p), c)) == "string" ? m : d ? a(h) : (v = a(h)) == "Object" && o(h.callee) ? "Arguments" : v;
      };
    }, function(n, r, s) {
      var i = s(5), o = s(13), a = s(31);
      n.exports = i ? function(l, c, u) {
        return o.f(l, c, a(1, u));
      } : function(l, c, u) {
        return l[c] = u, l;
      };
    }, function(n, r) {
      n.exports = function(s, i) {
        return { enumerable: !(1 & s), configurable: !(2 & s), writable: !(4 & s), value: i };
      };
    }, function(n, r, s) {
      var i = s(50), o = s(13), a = s(31);
      n.exports = function(l, c, u) {
        var d = i(c);
        d in l ? o.f(l, d, a(0, u)) : l[d] = u;
      };
    }, function(n, r, s) {
      var i = s(4), o = Object.defineProperty;
      n.exports = function(a, l) {
        try {
          o(i, a, { value: l, configurable: !0, writable: !0 });
        } catch {
          i[a] = l;
        }
        return l;
      };
    }, function(n, r) {
      n.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }, function(n, r, s) {
      var i = s(0);
      n.exports = !i(function() {
        var o = (function() {
        }).bind();
        return typeof o != "function" || o.hasOwnProperty("prototype");
      });
    }, function(n, r, s) {
      var i = s(5), o = s(7), a = Function.prototype, l = i && Object.getOwnPropertyDescriptor, c = o(a, "name"), u = c && (function() {
      }).name === "something", d = c && (!i || i && l(a, "name").configurable);
      n.exports = { EXISTS: c, PROPER: u, CONFIGURABLE: d };
    }, function(n, r, s) {
      var i = s(15), o = s(1);
      n.exports = function(a) {
        if (i(a) === "Function") return o(a);
      };
    }, function(n, r) {
      n.exports = {};
    }, function(n, r, s) {
      var i = s(1), o = s(0), a = s(15), l = Object, c = i("".split);
      n.exports = o(function() {
        return !l("z").propertyIsEnumerable(0);
      }) ? function(u) {
        return a(u) == "String" ? c(u, "") : l(u);
      } : l;
    }, function(n, r) {
      n.exports = function(s) {
        return s == null;
      };
    }, function(n, r, s) {
      var i = s(17), o = s(2), a = s(44), l = s(76), c = Object;
      n.exports = l ? function(u) {
        return typeof u == "symbol";
      } : function(u) {
        var d = i("Symbol");
        return o(d) && a(d.prototype, c(u));
      };
    }, function(n, r, s) {
      var i, o = s(6), a = s(107), l = s(34), c = s(38), u = s(101), d = s(60), f = s(70), p = f("IE_PROTO"), h = function() {
      }, m = function(w) {
        return "<script>" + w + "<\/script>";
      }, v = function(w) {
        w.write(m("")), w.close();
        var S = w.parentWindow.Object;
        return w = null, S;
      }, y = function() {
        var w, S = d("iframe");
        return S.style.display = "none", u.appendChild(S), S.src = "javascript:", w = S.contentWindow.document, w.open(), w.write(m("document.F=Object")), w.close(), w.F;
      }, _ = function() {
        try {
          i = new ActiveXObject("htmlfile");
        } catch {
        }
        _ = typeof document < "u" ? document.domain && i ? v(i) : y() : v(i);
        for (var w = l.length; w--; ) delete _.prototype[l[w]];
        return _();
      };
      c[p] = !0, n.exports = Object.create || function(w, S) {
        var E;
        return w !== null ? (h.prototype = o(w), E = new h(), h.prototype = null, E[p] = w) : E = _(), S === void 0 ? E : a.f(E, S);
      };
    }, function(n, r, s) {
      var i = s(5), o = s(12), a = s(110), l = s(31), c = s(19), u = s(50), d = s(7), f = s(62), p = Object.getOwnPropertyDescriptor;
      r.f = i ? p : function(h, m) {
        if (h = c(h), m = u(m), f) try {
          return p(h, m);
        } catch {
        }
        if (d(h, m)) return l(!o(a.f, h, m), h[m]);
      };
    }, function(n, r, s) {
      var i = s(1);
      n.exports = i({}.isPrototypeOf);
    }, function(n, r, s) {
      var i = s(12), o = s(1), a = s(20), l = s(69), c = s(117), u = s(47), d = s(42), f = s(64).get, p = s(118), h = s(119), m = u("native-string-replace", String.prototype.replace), v = RegExp.prototype.exec, y = v, _ = o("".charAt), w = o("".indexOf), S = o("".replace), E = o("".slice), x = function() {
        var k = /a/, b = /b*/g;
        return i(v, k, "a"), i(v, b, "a"), k.lastIndex !== 0 || b.lastIndex !== 0;
      }(), T = c.BROKEN_CARET, C = /()??/.exec("")[1] !== void 0;
      (x || C || T || p || h) && (y = function(k) {
        var b, P, N, D, H, Y, te, A = this, j = f(A), L = a(k), se = j.raw;
        if (se) return se.lastIndex = A.lastIndex, b = i(y, se, L), A.lastIndex = se.lastIndex, b;
        var V = j.groups, ee = T && A.sticky, O = i(l, A), K = A.source, z = 0, q = L;
        if (ee && (O = S(O, "y", ""), w(O, "g") === -1 && (O += "g"), q = E(L, A.lastIndex), A.lastIndex > 0 && (!A.multiline || A.multiline && _(L, A.lastIndex - 1) !== `
`) && (K = "(?: " + K + ")", q = " " + q, z++), P = new RegExp("^(?:" + K + ")", O)), C && (P = new RegExp("^" + K + "$(?!\\s)", O)), x && (N = A.lastIndex), D = i(v, ee ? P : A, q), ee ? D ? (D.input = E(D.input, z), D[0] = E(D[0], z), D.index = A.lastIndex, A.lastIndex += D[0].length) : A.lastIndex = 0 : x && D && (A.lastIndex = A.global ? D.index + D[0].length : N), C && D && D.length > 1 && i(m, D[0], P, function() {
          for (H = 1; H < arguments.length - 2; H++) arguments[H] === void 0 && (D[H] = void 0);
        }), D && V) for (D.groups = Y = d(null), H = 0; H < V.length; H++) te = V[H], Y[te[0]] = D[te[1]];
        return D;
      }), n.exports = y;
    }, function(n, r, s) {
      var i = s(4), o = s(33), a = i["__core-js_shared__"] || o("__core-js_shared__", {});
      n.exports = a;
    }, function(n, r, s) {
      var i = s(103), o = s(46);
      (n.exports = function(a, l) {
        return o[a] || (o[a] = l !== void 0 ? l : {});
      })("versions", []).push({ version: "3.26.1", mode: i ? "pure" : "global", copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }, function(n, r, s) {
      var i = s(49), o = Math.max, a = Math.min;
      n.exports = function(l, c) {
        var u = i(l);
        return u < 0 ? o(u + c, 0) : a(u, c);
      };
    }, function(n, r, s) {
      var i = s(105);
      n.exports = function(o) {
        var a = +o;
        return a !== a || a === 0 ? 0 : i(a);
      };
    }, function(n, r, s) {
      var i = s(73), o = s(41);
      n.exports = function(a) {
        var l = i(a, "string");
        return o(l) ? l : l + "";
      };
    }, function(n, r, s) {
      var i = s(9), o = i("toStringTag"), a = {};
      a[o] = "z", n.exports = String(a) === "[object z]";
    }, function(n, r, s) {
      var i = s(5), o = s(4), a = s(1), l = s(66), c = s(11), u = s(7), d = s(102), f = s(44), p = s(41), h = s(73), m = s(0), v = s(67).f, y = s(43).f, _ = s(13).f, w = s(122), S = s(71).trim, E = o.Number, x = E.prototype, T = o.TypeError, C = a("".slice), k = a("".charCodeAt), b = function(te) {
        var A = h(te, "number");
        return typeof A == "bigint" ? A : P(A);
      }, P = function(te) {
        var A, j, L, se, V, ee, O, K, z = h(te, "number");
        if (p(z)) throw T("Cannot convert a Symbol value to a number");
        if (typeof z == "string" && z.length > 2) {
          if (z = S(z), (A = k(z, 0)) === 43 || A === 45) {
            if ((j = k(z, 2)) === 88 || j === 120) return NaN;
          } else if (A === 48) {
            switch (k(z, 1)) {
              case 66:
              case 98:
                L = 2, se = 49;
                break;
              case 79:
              case 111:
                L = 8, se = 55;
                break;
              default:
                return +z;
            }
            for (V = C(z, 2), ee = V.length, O = 0; O < ee; O++) if ((K = k(V, O)) < 48 || K > se) return NaN;
            return parseInt(V, L);
          }
        }
        return +z;
      };
      if (l("Number", !E(" 0o1") || !E("0b1") || E("+0x1"))) {
        for (var N, D = function(te) {
          var A = arguments.length < 1 ? 0 : E(b(te)), j = this;
          return f(x, j) && m(function() {
            w(j);
          }) ? d(Object(A), j, D) : A;
        }, H = i ? v(E) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), Y = 0; H.length > Y; Y++) u(E, N = H[Y]) && !u(D, N) && _(D, N, y(E, N));
        D.prototype = x, x.constructor = D, c(o, "Number", D, { constructor: !0 });
      }
    }, function(n, r, s) {
      var i = s(3), o = s(45);
      i({ target: "RegExp", proto: !0, forced: /./.exec !== o }, { exec: o });
    }, function(n, r, s) {
      function i(L) {
        return L !== 0 && (!(!Array.isArray(L) || L.length !== 0) || !L);
      }
      function o(L) {
        return function() {
          return !L.apply(void 0, arguments);
        };
      }
      function a(L, se) {
        return L === void 0 && (L = "undefined"), L === null && (L = "null"), L === !1 && (L = "false"), L.toString().toLowerCase().indexOf(se.trim()) !== -1;
      }
      function l(L, se, V, ee) {
        return L.filter(function(O) {
          return a(ee(O, V), se);
        });
      }
      function c(L) {
        return L.filter(function(se) {
          return !se.$isLabel;
        });
      }
      function u(L, se) {
        return function(V) {
          return V.reduce(function(ee, O) {
            return O[L] && O[L].length ? (ee.push({ $groupLabel: O[se], $isLabel: !0 }), ee.concat(O[L])) : ee;
          }, []);
        };
      }
      function d(L, se, V, ee, O) {
        return function(K) {
          return K.map(function(z) {
            var q;
            if (!z[V]) return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
            var ae = l(z[V], L, se, O);
            return ae.length ? (q = {}, s.i(p.a)(q, ee, z[ee]), s.i(p.a)(q, V, ae), q) : [];
          });
        };
      }
      var f = s(88), p = s(87), h = s(129), m = (s.n(h), s(82)), v = (s.n(m), s(81)), y = (s.n(v), s(83)), _ = (s.n(y), s(84)), w = (s.n(_), s(128)), S = (s.n(w), s(135)), E = (s.n(S), s(127)), x = (s.n(E), s(132)), T = (s.n(x), s(131)), C = (s.n(T), s(125)), k = (s.n(C), s(130)), b = (s.n(k), s(52)), P = (s.n(b), s(53)), N = (s.n(P), s(85)), D = (s.n(N), s(134)), H = (s.n(D), s(80)), Y = (s.n(H), s(79)), te = (s.n(Y), s(133)), A = (s.n(te), s(126)), j = (s.n(A), function() {
        for (var L = arguments.length, se = new Array(L), V = 0; V < L; V++) se[V] = arguments[V];
        return function(ee) {
          return se.reduce(function(O, K) {
            return K(O);
          }, ee);
        };
      });
      r.a = { data: function() {
        return { search: "", isOpen: !1, preferredOpenDirection: "below", optimizedHeight: this.maxHeight };
      }, props: { internalSearch: { type: Boolean, default: !0 }, options: { type: Array, required: !0 }, multiple: { type: Boolean, default: !1 }, value: { type: null, default: function() {
        return [];
      } }, trackBy: { type: String }, label: { type: String }, searchable: { type: Boolean, default: !0 }, clearOnSelect: { type: Boolean, default: !0 }, hideSelected: { type: Boolean, default: !1 }, placeholder: { type: String, default: "Select option" }, allowEmpty: { type: Boolean, default: !0 }, resetAfter: { type: Boolean, default: !1 }, closeOnSelect: { type: Boolean, default: !0 }, customLabel: { type: Function, default: function(L, se) {
        return i(L) ? "" : se ? L[se] : L;
      } }, taggable: { type: Boolean, default: !1 }, tagPlaceholder: { type: String, default: "Press enter to create a tag" }, tagPosition: { type: String, default: "top" }, max: { type: [Number, Boolean], default: !1 }, id: { default: null }, optionsLimit: { type: Number, default: 1e3 }, groupValues: { type: String }, groupLabel: { type: String }, groupSelect: { type: Boolean, default: !1 }, blockKeys: { type: Array, default: function() {
        return [];
      } }, preserveSearch: { type: Boolean, default: !1 }, preselectFirst: { type: Boolean, default: !1 }, preventAutofocus: { type: Boolean, default: !1 } }, mounted: function() {
        !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
      }, computed: { internalValue: function() {
        return this.value || this.value === 0 ? Array.isArray(this.value) ? this.value : [this.value] : [];
      }, filteredOptions: function() {
        var L = this.search || "", se = L.toLowerCase().trim(), V = this.options.concat();
        return V = this.internalSearch ? this.groupValues ? this.filterAndFlat(V, se, this.label) : l(V, se, this.label, this.customLabel) : this.groupValues ? u(this.groupValues, this.groupLabel)(V) : V, V = this.hideSelected ? V.filter(o(this.isSelected)) : V, this.taggable && se.length && !this.isExistingOption(se) && (this.tagPosition === "bottom" ? V.push({ isTag: !0, label: L }) : V.unshift({ isTag: !0, label: L })), V.slice(0, this.optionsLimit);
      }, valueKeys: function() {
        var L = this;
        return this.trackBy ? this.internalValue.map(function(se) {
          return se[L.trackBy];
        }) : this.internalValue;
      }, optionKeys: function() {
        var L = this;
        return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map(function(se) {
          return L.customLabel(se, L.label).toString().toLowerCase();
        });
      }, currentOptionLabel: function() {
        return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
      } }, watch: { internalValue: function() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("input", this.multiple ? [] : null));
      }, search: function() {
        this.$emit("search-change", this.search, this.id);
      } }, methods: { getValue: function() {
        return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
      }, filterAndFlat: function(L, se, V) {
        return j(d(se, V, this.groupValues, this.groupLabel, this.customLabel), u(this.groupValues, this.groupLabel))(L);
      }, flatAndStrip: function(L) {
        return j(u(this.groupValues, this.groupLabel), c)(L);
      }, updateSearch: function(L) {
        this.search = L;
      }, isExistingOption: function(L) {
        return !!this.options && this.optionKeys.indexOf(L) > -1;
      }, isSelected: function(L) {
        var se = this.trackBy ? L[this.trackBy] : L;
        return this.valueKeys.indexOf(se) > -1;
      }, isOptionDisabled: function(L) {
        return !!L.$isDisabled;
      }, getOptionLabel: function(L) {
        if (i(L)) return "";
        if (L.isTag) return L.label;
        if (L.$isLabel) return L.$groupLabel;
        var se = this.customLabel(L, this.label);
        return i(se) ? "" : se;
      }, select: function(L, se) {
        if (L.$isLabel && this.groupSelect) return void this.selectGroup(L);
        if (!(this.blockKeys.indexOf(se) !== -1 || this.disabled || L.$isDisabled || L.$isLabel) && (!this.max || !this.multiple || this.internalValue.length !== this.max) && (se !== "Tab" || this.pointerDirty)) {
          if (L.isTag) this.$emit("tag", L.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
          else {
            if (this.isSelected(L)) return void (se !== "Tab" && this.removeElement(L));
            this.multiple ? this.$emit("input", this.internalValue.concat([L]), this.id) : this.$emit("input", L, this.id), this.$emit("select", L, this.id), this.clearOnSelect && (this.search = "");
          }
          this.closeOnSelect && this.deactivate();
        }
      }, selectGroup: function(L) {
        var se = this, V = this.options.find(function(z) {
          return z[se.groupLabel] === L.$groupLabel;
        });
        if (V) {
          if (this.wholeGroupSelected(V)) {
            this.$emit("remove", V[this.groupValues], this.id);
            var ee = this.trackBy ? V[this.groupValues].map(function(z) {
              return z[se.trackBy];
            }) : V[this.groupValues], O = this.internalValue.filter(function(z) {
              return ee.indexOf(se.trackBy ? z[se.trackBy] : z) === -1;
            });
            this.$emit("input", O, this.id);
          } else {
            var K = V[this.groupValues].filter(function(z) {
              return !(se.isOptionDisabled(z) || se.isSelected(z));
            });
            this.max && K.splice(this.max - this.internalValue.length), this.$emit("select", K, this.id), this.$emit("input", this.internalValue.concat(K), this.id);
          }
          this.closeOnSelect && this.deactivate();
        }
      }, wholeGroupSelected: function(L) {
        var se = this;
        return L[this.groupValues].every(function(V) {
          return se.isSelected(V) || se.isOptionDisabled(V);
        });
      }, wholeGroupDisabled: function(L) {
        return L[this.groupValues].every(this.isOptionDisabled);
      }, removeElement: function(L) {
        var se = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        if (!this.disabled && !L.$isDisabled) {
          if (!this.allowEmpty && this.internalValue.length <= 1) return void this.deactivate();
          var V = s.i(f.a)(L) === "object" ? this.valueKeys.indexOf(L[this.trackBy]) : this.valueKeys.indexOf(L);
          if (this.multiple) {
            var ee = this.internalValue.slice(0, V).concat(this.internalValue.slice(V + 1));
            this.$emit("input", ee, this.id);
          } else this.$emit("input", null, this.id);
          this.$emit("remove", L, this.id), this.closeOnSelect && se && this.deactivate();
        }
      }, removeLastElement: function() {
        this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
      }, activate: function() {
        var L = this;
        this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(function() {
          return L.$refs.search && L.$refs.search.focus();
        })) : this.preventAutofocus || this.$el !== void 0 && this.$el.focus(), this.$emit("open", this.id));
      }, deactivate: function() {
        this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && this.$refs.search !== void 0 && this.$refs.search.blur() : this.$el !== void 0 && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
      }, toggle: function() {
        this.isOpen ? this.deactivate() : this.activate();
      }, adjustPosition: function() {
        if (typeof window < "u") {
          var L = this.$el.getBoundingClientRect().top, se = window.innerHeight - this.$el.getBoundingClientRect().bottom;
          se > this.maxHeight || se > L || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(se - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(L - 40, this.maxHeight));
        }
      } } };
    }, function(n, r, s) {
      var i = s(52), o = (s.n(i), s(53)), a = (s.n(o), s(85)), l = (s.n(a), s(82)), c = (s.n(l), s(81)), u = (s.n(c), s(83)), d = (s.n(u), s(84)), f = (s.n(d), s(79));
      s.n(f), r.a = { data: function() {
        return { pointer: 0, pointerDirty: !1 };
      }, props: { showPointer: { type: Boolean, default: !0 }, optionHeight: { type: Number, default: 40 } }, computed: { pointerPosition: function() {
        return this.pointer * this.optionHeight;
      }, visibleElements: function() {
        return this.optimizedHeight / this.optionHeight;
      } }, watch: { filteredOptions: function() {
        this.pointerAdjust();
      }, isOpen: function() {
        this.pointerDirty = !1;
      }, pointer: function() {
        this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
      } }, methods: { optionHighlight: function(p, h) {
        return { "multiselect__option--highlight": p === this.pointer && this.showPointer, "multiselect__option--selected": this.isSelected(h) };
      }, groupHighlight: function(p, h) {
        var m = this;
        if (!this.groupSelect) return ["multiselect__option--disabled", { "multiselect__option--group": h.$isLabel }];
        var v = this.options.find(function(y) {
          return y[m.groupLabel] === h.$groupLabel;
        });
        return v && !this.wholeGroupDisabled(v) ? ["multiselect__option--group", { "multiselect__option--highlight": p === this.pointer && this.showPointer }, { "multiselect__option--group-selected": this.wholeGroupSelected(v) }] : "multiselect__option--disabled";
      }, addPointerElement: function() {
        var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Enter", h = p.key;
        this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], h), this.pointerReset();
      }, pointerForward: function() {
        this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
      }, pointerBackward: function() {
        this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
      }, pointerReset: function() {
        this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
      }, pointerAdjust: function() {
        this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
      }, pointerSet: function(p) {
        this.pointer = p, this.pointerDirty = !0;
      } } };
    }, function(n, r, s) {
      var i = s(52), o = (s.n(i), s(80)), a = (s.n(o), s(54)), l = s(55);
      r.a = { name: "vue-multiselect", mixins: [a.a, l.a], props: { name: { type: String, default: "" }, selectLabel: { type: String, default: "Press enter to select" }, selectGroupLabel: { type: String, default: "Press enter to select group" }, selectedLabel: { type: String, default: "Selected" }, deselectLabel: { type: String, default: "Press enter to remove" }, deselectGroupLabel: { type: String, default: "Press enter to deselect group" }, showLabels: { type: Boolean, default: !0 }, limit: { type: Number, default: 99999 }, maxHeight: { type: Number, default: 300 }, limitText: { type: Function, default: function(c) {
        return "and ".concat(c, " more");
      } }, loading: { type: Boolean, default: !1 }, disabled: { type: Boolean, default: !1 }, openDirection: { type: String, default: "" }, showNoOptions: { type: Boolean, default: !0 }, showNoResults: { type: Boolean, default: !0 }, tabindex: { type: Number, default: 0 } }, computed: { hasOptionGroup: function() {
        return this.groupValues && this.groupLabel && this.groupSelect;
      }, isSingleLabelVisible: function() {
        return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
      }, isPlaceholderVisible: function() {
        return !(this.internalValue.length || this.searchable && this.isOpen);
      }, visibleValues: function() {
        return this.multiple ? this.internalValue.slice(0, this.limit) : [];
      }, singleValue: function() {
        return this.internalValue[0];
      }, deselectLabelText: function() {
        return this.showLabels ? this.deselectLabel : "";
      }, deselectGroupLabelText: function() {
        return this.showLabels ? this.deselectGroupLabel : "";
      }, selectLabelText: function() {
        return this.showLabels ? this.selectLabel : "";
      }, selectGroupLabelText: function() {
        return this.showLabels ? this.selectGroupLabel : "";
      }, selectedLabelText: function() {
        return this.showLabels ? this.selectedLabel : "";
      }, inputStyle: function() {
        return this.searchable || this.multiple && this.value && this.value.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
      }, contentStyle: function() {
        return this.options.length ? { display: "inline-block" } : { display: "block" };
      }, isAbove: function() {
        return this.openDirection === "above" || this.openDirection === "top" || this.openDirection !== "below" && this.openDirection !== "bottom" && this.preferredOpenDirection === "above";
      }, showSearchInput: function() {
        return this.searchable && (!this.hasSingleSelectedSlot || !this.visibleSingleValue && this.visibleSingleValue !== 0 || this.isOpen);
      } } };
    }, function(n, r, s) {
      var i = s(19), o = s(48), a = s(10), l = function(c) {
        return function(u, d, f) {
          var p, h = i(u), m = a(h), v = o(f, m);
          if (c && d != d) {
            for (; m > v; ) if ((p = h[v++]) != p) return !0;
          } else for (; m > v; v++) if ((c || v in h) && h[v] === d) return c || v || 0;
          return !c && -1;
        };
      };
      n.exports = { includes: l(!0), indexOf: l(!1) };
    }, function(n, r, s) {
      var i = s(74), o = TypeError;
      n.exports = function(a, l) {
        if (!delete a[l]) throw o("Cannot delete property " + i(l) + " of " + i(a));
      };
    }, function(n, r) {
      var s = typeof document == "object" && document.all, i = s === void 0 && s !== void 0;
      n.exports = { all: s, IS_HTMLDDA: i };
    }, function(n, r, s) {
      var i = s(4), o = s(8), a = i.document, l = o(a) && o(a.createElement);
      n.exports = function(c) {
        return l ? a.createElement(c) : {};
      };
    }, function(n, r, s) {
      var i = s(25), o = s(40);
      n.exports = function(a, l) {
        var c = a[l];
        return o(c) ? void 0 : i(c);
      };
    }, function(n, r, s) {
      var i = s(5), o = s(0), a = s(60);
      n.exports = !i && !o(function() {
        return Object.defineProperty(a("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(n, r, s) {
      var i = s(1), o = s(2), a = s(46), l = i(Function.toString);
      o(a.inspectSource) || (a.inspectSource = function(c) {
        return l(c);
      }), n.exports = a.inspectSource;
    }, function(n, r, s) {
      var i, o, a, l = s(124), c = s(4), u = s(8), d = s(30), f = s(7), p = s(46), h = s(70), m = s(38), v = c.TypeError, y = c.WeakMap, _ = function(x) {
        return a(x) ? o(x) : i(x, {});
      }, w = function(x) {
        return function(T) {
          var C;
          if (!u(T) || (C = o(T)).type !== x) throw v("Incompatible receiver, " + x + " required");
          return C;
        };
      };
      if (l || p.state) {
        var S = p.state || (p.state = new y());
        S.get = S.get, S.has = S.has, S.set = S.set, i = function(x, T) {
          if (S.has(x)) throw v("Object already initialized");
          return T.facade = x, S.set(x, T), T;
        }, o = function(x) {
          return S.get(x) || {};
        }, a = function(x) {
          return S.has(x);
        };
      } else {
        var E = h("state");
        m[E] = !0, i = function(x, T) {
          if (f(x, E)) throw v("Object already initialized");
          return T.facade = x, d(x, E, T), T;
        }, o = function(x) {
          return f(x, E) ? x[E] : {};
        }, a = function(x) {
          return f(x, E);
        };
      }
      n.exports = { set: i, get: o, has: a, enforce: _, getterFor: w };
    }, function(n, r, s) {
      var i = s(1), o = s(0), a = s(2), l = s(29), c = s(17), u = s(63), d = function() {
      }, f = [], p = c("Reflect", "construct"), h = /^\s*(?:class|function)\b/, m = i(h.exec), v = !h.exec(d), y = function(w) {
        if (!a(w)) return !1;
        try {
          return p(d, f, w), !0;
        } catch {
          return !1;
        }
      }, _ = function(w) {
        if (!a(w)) return !1;
        switch (l(w)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }
        try {
          return v || !!m(h, u(w));
        } catch {
          return !0;
        }
      };
      _.sham = !0, n.exports = !p || o(function() {
        var w;
        return y(y.call) || !y(Object) || !y(function() {
          w = !0;
        }) || w;
      }) ? _ : y;
    }, function(n, r, s) {
      var i = s(0), o = s(2), a = /#|\.prototype\./, l = function(p, h) {
        var m = u[c(p)];
        return m == f || m != d && (o(h) ? i(h) : !!h);
      }, c = l.normalize = function(p) {
        return String(p).replace(a, ".").toLowerCase();
      }, u = l.data = {}, d = l.NATIVE = "N", f = l.POLYFILL = "P";
      n.exports = l;
    }, function(n, r, s) {
      var i = s(68), o = s(34), a = o.concat("length", "prototype");
      r.f = Object.getOwnPropertyNames || function(l) {
        return i(l, a);
      };
    }, function(n, r, s) {
      var i = s(1), o = s(7), a = s(19), l = s(57).indexOf, c = s(38), u = i([].push);
      n.exports = function(d, f) {
        var p, h = a(d), m = 0, v = [];
        for (p in h) !o(c, p) && o(h, p) && u(v, p);
        for (; f.length > m; ) o(h, p = f[m++]) && (~l(v, p) || u(v, p));
        return v;
      };
    }, function(n, r, s) {
      var i = s(6);
      n.exports = function() {
        var o = i(this), a = "";
        return o.hasIndices && (a += "d"), o.global && (a += "g"), o.ignoreCase && (a += "i"), o.multiline && (a += "m"), o.dotAll && (a += "s"), o.unicode && (a += "u"), o.unicodeSets && (a += "v"), o.sticky && (a += "y"), a;
      };
    }, function(n, r, s) {
      var i = s(47), o = s(75), a = i("keys");
      n.exports = function(l) {
        return a[l] || (a[l] = o(l));
      };
    }, function(n, r, s) {
      var i = s(1), o = s(24), a = s(20), l = s(78), c = i("".replace), u = "[" + l + "]", d = RegExp("^" + u + u + "*"), f = RegExp(u + u + "*$"), p = function(h) {
        return function(m) {
          var v = a(o(m));
          return 1 & h && (v = c(v, d, "")), 2 & h && (v = c(v, f, "")), v;
        };
      };
      n.exports = { start: p(1), end: p(2), trim: p(3) };
    }, function(n, r, s) {
      var i = s(23), o = s(0);
      n.exports = !!Object.getOwnPropertySymbols && !o(function() {
        var a = Symbol();
        return !String(a) || !(Object(a) instanceof Symbol) || !Symbol.sham && i && i < 41;
      });
    }, function(n, r, s) {
      var i = s(12), o = s(8), a = s(41), l = s(61), c = s(113), u = s(9), d = TypeError, f = u("toPrimitive");
      n.exports = function(p, h) {
        if (!o(p) || a(p)) return p;
        var m, v = l(p, f);
        if (v) {
          if (h === void 0 && (h = "default"), m = i(v, p, h), !o(m) || a(m)) return m;
          throw d("Can't convert object to primitive value");
        }
        return h === void 0 && (h = "number"), c(p, h);
      };
    }, function(n, r) {
      var s = String;
      n.exports = function(i) {
        try {
          return s(i);
        } catch {
          return "Object";
        }
      };
    }, function(n, r, s) {
      var i = s(1), o = 0, a = Math.random(), l = i(1 .toString);
      n.exports = function(c) {
        return "Symbol(" + (c === void 0 ? "" : c) + ")_" + l(++o + a, 36);
      };
    }, function(n, r, s) {
      var i = s(72);
      n.exports = i && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }, function(n, r, s) {
      var i = s(5), o = s(0);
      n.exports = i && o(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: !1 }).prototype != 42;
      });
    }, function(n, r) {
      n.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
    }, function(n, r, s) {
      var i = s(3), o = s(21).find, a = s(91), l = !0;
      "find" in [] && Array(1).find(function() {
        l = !1;
      }), i({ target: "Array", proto: !0, forced: l }, { find: function(c) {
        return o(this, c, arguments.length > 1 ? arguments[1] : void 0);
      } }), a("find");
    }, function(n, r, s) {
      var i = s(3), o = s(18), a = s(65), l = s(8), c = s(48), u = s(10), d = s(19), f = s(32), p = s(9), h = s(16), m = s(93), v = h("slice"), y = p("species"), _ = Array, w = Math.max;
      i({ target: "Array", proto: !0, forced: !v }, { slice: function(S, E) {
        var x, T, C, k = d(this), b = u(k), P = c(S, b), N = c(E === void 0 ? b : E, b);
        if (o(k) && (x = k.constructor, (a(x) && (x === _ || o(x.prototype)) || l(x) && (x = x[y]) === null) && (x = void 0), x === _ || x === void 0)) return m(k, P, N);
        for (T = new (x === void 0 ? _ : x)(w(N - P, 0)), C = 0; P < N; P++, C++) P in k && f(T, C, k[P]);
        return T.length = C, T;
      } });
    }, function(n, r, s) {
      var i = s(1), o = s(11), a = Date.prototype, l = i(a.toString), c = i(a.getTime);
      String(/* @__PURE__ */ new Date(NaN)) != "Invalid Date" && o(a, "toString", function() {
        var u = c(this);
        return u === u ? l(this) : "Invalid Date";
      });
    }, function(n, r, s) {
      var i = s(11), o = s(98), a = Error.prototype;
      a.toString !== o && i(a, "toString", o);
    }, function(n, r, s) {
      var i = s(51), o = s(11), a = s(112);
      i || o(Object.prototype, "toString", a, { unsafe: !0 });
    }, function(n, r, s) {
      var i = s(36).PROPER, o = s(11), a = s(6), l = s(20), c = s(0), u = s(116), d = RegExp.prototype, f = d.toString, p = c(function() {
        return f.call({ source: "a", flags: "b" }) != "/a/b";
      }), h = i && f.name != "toString";
      (p || h) && o(RegExp.prototype, "toString", function() {
        var m = a(this);
        return "/" + l(m.source) + "/" + l(u(m));
      }, { unsafe: !0 });
    }, function(n, r, s) {
      var i = s(12), o = s(99), a = s(6), l = s(40), c = s(24), u = s(120), d = s(20), f = s(61), p = s(115);
      o("search", function(h, m, v) {
        return [function(y) {
          var _ = c(this), w = l(y) ? void 0 : f(y, h);
          return w ? i(w, y, _) : new RegExp(y)[h](d(_));
        }, function(y) {
          var _ = a(this), w = d(y), S = v(m, _, w);
          if (S.done) return S.value;
          var E = _.lastIndex;
          u(E, 0) || (_.lastIndex = 0);
          var x = p(_, w);
          return u(_.lastIndex, E) || (_.lastIndex = E), x === null ? -1 : x.index;
        }];
      });
    }, function(n, r, s) {
      function i(d) {
        s(136);
      }
      var o = s(56), a = s(138), l = s(137), c = i, u = l(o.a, a.a, !1, c, null, null);
      r.a = u.exports;
    }, function(n, r, s) {
      function i(o, a, l) {
        return a in o ? Object.defineProperty(o, a, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = l, o;
      }
      r.a = i;
    }, function(n, r, s) {
      function i(o) {
        "@babel/helpers - typeof";
        return (i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
          return typeof a;
        } : function(a) {
          return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
        })(o);
      }
      r.a = i;
    }, function(n, r, s) {
      Object.defineProperty(r, "__esModule", { value: !0 });
      var i = s(86), o = s(54), a = s(55);
      s.d(r, "Multiselect", function() {
        return i.a;
      }), s.d(r, "multiselectMixin", function() {
        return o.a;
      }), s.d(r, "pointerMixin", function() {
        return a.a;
      }), r.default = i.a;
    }, function(n, r, s) {
      var i = s(2), o = String, a = TypeError;
      n.exports = function(l) {
        if (typeof l == "object" || i(l)) return l;
        throw a("Can't set " + o(l) + " as a prototype");
      };
    }, function(n, r, s) {
      var i = s(9), o = s(42), a = s(13).f, l = i("unscopables"), c = Array.prototype;
      c[l] == null && a(c, l, { configurable: !0, value: o(null) }), n.exports = function(u) {
        c[l][u] = !0;
      };
    }, function(n, r, s) {
      var i = s(25), o = s(14), a = s(39), l = s(10), c = TypeError, u = function(d) {
        return function(f, p, h, m) {
          i(p);
          var v = o(f), y = a(v), _ = l(v), w = d ? _ - 1 : 0, S = d ? -1 : 1;
          if (h < 2) for (; ; ) {
            if (w in y) {
              m = y[w], w += S;
              break;
            }
            if (w += S, d ? w < 0 : _ <= w) throw c("Reduce of empty array with no initial value");
          }
          for (; d ? w >= 0 : _ > w; w += S) w in y && (m = p(m, y[w], w, v));
          return m;
        };
      };
      n.exports = { left: u(!1), right: u(!0) };
    }, function(n, r, s) {
      var i = s(1);
      n.exports = i([].slice);
    }, function(n, r, s) {
      var i = s(18), o = s(65), a = s(8), l = s(9), c = l("species"), u = Array;
      n.exports = function(d) {
        var f;
        return i(d) && (f = d.constructor, (o(f) && (f === u || i(f.prototype)) || a(f) && (f = f[c]) === null) && (f = void 0)), f === void 0 ? u : f;
      };
    }, function(n, r, s) {
      var i = s(7), o = s(114), a = s(43), l = s(13);
      n.exports = function(c, u, d) {
        for (var f = o(u), p = l.f, h = a.f, m = 0; m < f.length; m++) {
          var v = f[m];
          i(c, v) || d && i(d, v) || p(c, v, h(u, v));
        }
      };
    }, function(n, r, s) {
      var i = s(15), o = s(4);
      n.exports = i(o.process) == "process";
    }, function(n, r, s) {
      var i = s(17);
      n.exports = i("navigator", "userAgent") || "";
    }, function(n, r, s) {
      var i = s(5), o = s(0), a = s(6), l = s(42), c = s(106), u = Error.prototype.toString, d = o(function() {
        if (i) {
          var f = l(Object.defineProperty({}, "name", { get: function() {
            return this === f;
          } }));
          if (u.call(f) !== "true") return !0;
        }
        return u.call({ message: 1, name: 2 }) !== "2: 1" || u.call({}) !== "Error";
      });
      n.exports = d ? function() {
        var f = a(this), p = c(f.name, "Error"), h = c(f.message);
        return p ? h ? p + ": " + h : p : h;
      } : u;
    }, function(n, r, s) {
      s(53);
      var i = s(37), o = s(11), a = s(45), l = s(0), c = s(9), u = s(30), d = c("species"), f = RegExp.prototype;
      n.exports = function(p, h, m, v) {
        var y = c(p), _ = !l(function() {
          var x = {};
          return x[y] = function() {
            return 7;
          }, ""[p](x) != 7;
        }), w = _ && !l(function() {
          var x = !1, T = /a/;
          return p === "split" && (T = {}, T.constructor = {}, T.constructor[d] = function() {
            return T;
          }, T.flags = "", T[y] = /./[y]), T.exec = function() {
            return x = !0, null;
          }, T[y](""), !x;
        });
        if (!_ || !w || m) {
          var S = i(/./[y]), E = h(y, ""[p], function(x, T, C, k, b) {
            var P = i(x), N = T.exec;
            return N === a || N === f.exec ? _ && !b ? { done: !0, value: S(T, C, k) } : { done: !0, value: P(C, T, k) } : { done: !1 };
          });
          o(String.prototype, p, E[0]), o(f, y, E[1]);
        }
        v && u(f[y], "sham", !0);
      };
    }, function(n, r, s) {
      var i = s(37), o = s(25), a = s(35), l = i(i.bind);
      n.exports = function(c, u) {
        return o(c), u === void 0 ? c : a ? l(c, u) : function() {
          return c.apply(u, arguments);
        };
      };
    }, function(n, r, s) {
      var i = s(17);
      n.exports = i("document", "documentElement");
    }, function(n, r, s) {
      var i = s(2), o = s(8), a = s(111);
      n.exports = function(l, c, u) {
        var d, f;
        return a && i(d = c.constructor) && d !== u && o(f = d.prototype) && f !== u.prototype && a(l, f), l;
      };
    }, function(n, r) {
      n.exports = !1;
    }, function(n, r, s) {
      var i = s(0), o = s(2), a = s(7), l = s(5), c = s(36).CONFIGURABLE, u = s(63), d = s(64), f = d.enforce, p = d.get, h = Object.defineProperty, m = l && !i(function() {
        return h(function() {
        }, "length", { value: 8 }).length !== 8;
      }), v = String(String).split("String"), y = n.exports = function(_, w, S) {
        String(w).slice(0, 7) === "Symbol(" && (w = "[" + String(w).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), S && S.getter && (w = "get " + w), S && S.setter && (w = "set " + w), (!a(_, "name") || c && _.name !== w) && (l ? h(_, "name", { value: w, configurable: !0 }) : _.name = w), m && S && a(S, "arity") && _.length !== S.arity && h(_, "length", { value: S.arity });
        try {
          S && a(S, "constructor") && S.constructor ? l && h(_, "prototype", { writable: !1 }) : _.prototype && (_.prototype = void 0);
        } catch {
        }
        var E = f(_);
        return a(E, "source") || (E.source = v.join(typeof w == "string" ? w : "")), _;
      };
      Function.prototype.toString = y(function() {
        return o(this) && p(this).source || u(this);
      }, "toString");
    }, function(n, r) {
      var s = Math.ceil, i = Math.floor;
      n.exports = Math.trunc || function(o) {
        var a = +o;
        return (a > 0 ? i : s)(a);
      };
    }, function(n, r, s) {
      var i = s(20);
      n.exports = function(o, a) {
        return o === void 0 ? arguments.length < 2 ? "" : a : i(o);
      };
    }, function(n, r, s) {
      var i = s(5), o = s(77), a = s(13), l = s(6), c = s(19), u = s(109);
      r.f = i && !o ? Object.defineProperties : function(d, f) {
        l(d);
        for (var p, h = c(f), m = u(f), v = m.length, y = 0; v > y; ) a.f(d, p = m[y++], h[p]);
        return d;
      };
    }, function(n, r) {
      r.f = Object.getOwnPropertySymbols;
    }, function(n, r, s) {
      var i = s(68), o = s(34);
      n.exports = Object.keys || function(a) {
        return i(a, o);
      };
    }, function(n, r, s) {
      var i = {}.propertyIsEnumerable, o = Object.getOwnPropertyDescriptor, a = o && !i.call({ 1: 2 }, 1);
      r.f = a ? function(l) {
        var c = o(this, l);
        return !!c && c.enumerable;
      } : i;
    }, function(n, r, s) {
      var i = s(1), o = s(6), a = s(90);
      n.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var l, c = !1, u = {};
        try {
          l = i(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), l(u, []), c = u instanceof Array;
        } catch {
        }
        return function(d, f) {
          return o(d), a(f), c ? l(d, f) : d.__proto__ = f, d;
        };
      }() : void 0);
    }, function(n, r, s) {
      var i = s(51), o = s(29);
      n.exports = i ? {}.toString : function() {
        return "[object " + o(this) + "]";
      };
    }, function(n, r, s) {
      var i = s(12), o = s(2), a = s(8), l = TypeError;
      n.exports = function(c, u) {
        var d, f;
        if (u === "string" && o(d = c.toString) && !a(f = i(d, c)) || o(d = c.valueOf) && !a(f = i(d, c)) || u !== "string" && o(d = c.toString) && !a(f = i(d, c))) return f;
        throw l("Can't convert object to primitive value");
      };
    }, function(n, r, s) {
      var i = s(17), o = s(1), a = s(67), l = s(108), c = s(6), u = o([].concat);
      n.exports = i("Reflect", "ownKeys") || function(d) {
        var f = a.f(c(d)), p = l.f;
        return p ? u(f, p(d)) : f;
      };
    }, function(n, r, s) {
      var i = s(12), o = s(6), a = s(2), l = s(15), c = s(45), u = TypeError;
      n.exports = function(d, f) {
        var p = d.exec;
        if (a(p)) {
          var h = i(p, d, f);
          return h !== null && o(h), h;
        }
        if (l(d) === "RegExp") return i(c, d, f);
        throw u("RegExp#exec called on incompatible receiver");
      };
    }, function(n, r, s) {
      var i = s(12), o = s(7), a = s(44), l = s(69), c = RegExp.prototype;
      n.exports = function(u) {
        var d = u.flags;
        return d !== void 0 || "flags" in c || o(u, "flags") || !a(c, u) ? d : i(l, u);
      };
    }, function(n, r, s) {
      var i = s(0), o = s(4), a = o.RegExp, l = i(function() {
        var d = a("a", "y");
        return d.lastIndex = 2, d.exec("abcd") != null;
      }), c = l || i(function() {
        return !a("a", "y").sticky;
      }), u = l || i(function() {
        var d = a("^r", "gy");
        return d.lastIndex = 2, d.exec("str") != null;
      });
      n.exports = { BROKEN_CARET: u, MISSED_STICKY: c, UNSUPPORTED_Y: l };
    }, function(n, r, s) {
      var i = s(0), o = s(4), a = o.RegExp;
      n.exports = i(function() {
        var l = a(".", "s");
        return !(l.dotAll && l.exec(`
`) && l.flags === "s");
      });
    }, function(n, r, s) {
      var i = s(0), o = s(4), a = o.RegExp;
      n.exports = i(function() {
        var l = a("(?<a>b)", "g");
        return l.exec("b").groups.a !== "b" || "b".replace(l, "$<a>c") !== "bc";
      });
    }, function(n, r) {
      n.exports = Object.is || function(s, i) {
        return s === i ? s !== 0 || 1 / s == 1 / i : s != s && i != i;
      };
    }, function(n, r, s) {
      var i = s(36).PROPER, o = s(0), a = s(78), l = "​᠎";
      n.exports = function(c) {
        return o(function() {
          return !!a[c]() || l[c]() !== l || i && a[c].name !== c;
        });
      };
    }, function(n, r, s) {
      var i = s(1);
      n.exports = i(1 .valueOf);
    }, function(n, r, s) {
      var i = s(49), o = Math.min;
      n.exports = function(a) {
        return a > 0 ? o(i(a), 9007199254740991) : 0;
      };
    }, function(n, r, s) {
      var i = s(4), o = s(2), a = i.WeakMap;
      n.exports = o(a) && /native code/.test(String(a));
    }, function(n, r, s) {
      var i = s(3), o = s(0), a = s(18), l = s(8), c = s(14), u = s(10), d = s(22), f = s(32), p = s(28), h = s(16), m = s(9), v = s(23), y = m("isConcatSpreadable"), _ = v >= 51 || !o(function() {
        var E = [];
        return E[y] = !1, E.concat()[0] !== E;
      }), w = h("concat"), S = function(E) {
        if (!l(E)) return !1;
        var x = E[y];
        return x !== void 0 ? !!x : a(E);
      };
      i({ target: "Array", proto: !0, arity: 1, forced: !_ || !w }, { concat: function(E) {
        var x, T, C, k, b, P = c(this), N = p(P, 0), D = 0;
        for (x = -1, C = arguments.length; x < C; x++) if (b = x === -1 ? P : arguments[x], S(b)) for (k = u(b), d(D + k), T = 0; T < k; T++, D++) T in b && f(N, D, b[T]);
        else d(D + 1), f(N, D++, b);
        return N.length = D, N;
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(21).every;
      i({ target: "Array", proto: !0, forced: !s(26)("every") }, { every: function(a) {
        return o(this, a, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(21).filter;
      i({ target: "Array", proto: !0, forced: !s(16)("filter") }, { filter: function(a) {
        return o(this, a, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(37), a = s(57).indexOf, l = s(26), c = o([].indexOf), u = !!c && 1 / c([1], 1, -0) < 0, d = l("indexOf");
      i({ target: "Array", proto: !0, forced: u || !d }, { indexOf: function(f) {
        var p = arguments.length > 1 ? arguments[1] : void 0;
        return u ? c(this, f, p) || 0 : a(this, f, p);
      } });
    }, function(n, r, s) {
      s(3)({ target: "Array", stat: !0 }, { isArray: s(18) });
    }, function(n, r, s) {
      var i = s(3), o = s(21).map;
      i({ target: "Array", proto: !0, forced: !s(16)("map") }, { map: function(a) {
        return o(this, a, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(14), a = s(10), l = s(27), c = s(22), u = s(0), d = u(function() {
        return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
      }), f = !function() {
        try {
          Object.defineProperty([], "length", { writable: !1 }).push();
        } catch (p) {
          return p instanceof TypeError;
        }
      }();
      i({ target: "Array", proto: !0, arity: 1, forced: d || f }, { push: function(p) {
        var h = o(this), m = a(h), v = arguments.length;
        c(m + v);
        for (var y = 0; y < v; y++) h[m] = arguments[y], m++;
        return l(h, m), m;
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(92).left, a = s(26), l = s(23), c = s(96), u = a("reduce"), d = !c && l > 79 && l < 83;
      i({ target: "Array", proto: !0, forced: !u || d }, { reduce: function(f) {
        var p = arguments.length;
        return o(this, f, p, p > 1 ? arguments[1] : void 0);
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(14), a = s(48), l = s(49), c = s(10), u = s(27), d = s(22), f = s(28), p = s(32), h = s(58), m = s(16), v = m("splice"), y = Math.max, _ = Math.min;
      i({ target: "Array", proto: !0, forced: !v }, { splice: function(w, S) {
        var E, x, T, C, k, b, P = o(this), N = c(P), D = a(w, N), H = arguments.length;
        for (H === 0 ? E = x = 0 : H === 1 ? (E = 0, x = N - D) : (E = H - 2, x = _(y(l(S), 0), N - D)), d(N + E - x), T = f(P, x), C = 0; C < x; C++) (k = D + C) in P && p(T, C, P[k]);
        if (T.length = x, E < x) {
          for (C = D; C < N - x; C++) k = C + x, b = C + E, k in P ? P[b] = P[k] : h(P, b);
          for (C = N; C > N - x + E; C--) h(P, C - 1);
        } else if (E > x) for (C = N - x; C > D; C--) k = C + x - 1, b = C + E - 1, k in P ? P[b] = P[k] : h(P, b);
        for (C = 0; C < E; C++) P[C + D] = arguments[C + 2];
        return u(P, N - x + E), T;
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(14), a = s(10), l = s(27), c = s(58), u = s(22), d = [].unshift(0) !== 1, f = !function() {
        try {
          Object.defineProperty([], "length", { writable: !1 }).unshift();
        } catch (p) {
          return p instanceof TypeError;
        }
      }();
      i({ target: "Array", proto: !0, arity: 1, forced: d || f }, { unshift: function(p) {
        var h = o(this), m = a(h), v = arguments.length;
        if (v) {
          u(m + v);
          for (var y = m; y--; ) {
            var _ = y + v;
            y in h ? h[_] = h[y] : c(h, _);
          }
          for (var w = 0; w < v; w++) h[w] = arguments[w];
        }
        return l(h, m + v);
      } });
    }, function(n, r, s) {
      var i = s(3), o = s(71).trim;
      i({ target: "String", proto: !0, forced: s(121)("trim") }, { trim: function() {
        return o(this);
      } });
    }, function(n, r) {
    }, function(n, r) {
      n.exports = function(s, i, o, a, l, c) {
        var u, d = s = s || {}, f = typeof s.default;
        f !== "object" && f !== "function" || (u = s, d = s.default);
        var p = typeof d == "function" ? d.options : d;
        i && (p.render = i.render, p.staticRenderFns = i.staticRenderFns, p._compiled = !0), o && (p.functional = !0), l && (p._scopeId = l);
        var h;
        if (c ? (h = function(y) {
          y = y || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, y || typeof __VUE_SSR_CONTEXT__ > "u" || (y = __VUE_SSR_CONTEXT__), a && a.call(this, y), y && y._registeredComponents && y._registeredComponents.add(c);
        }, p._ssrRegister = h) : a && (h = a), h) {
          var m = p.functional, v = m ? p.render : p.beforeCreate;
          m ? (p._injectStyles = h, p.render = function(y, _) {
            return h.call(_), v(y, _);
          }) : p.beforeCreate = v ? [].concat(v, h) : [h];
        }
        return { esModule: u, exports: d, options: p };
      };
    }, function(n, r, s) {
      var i = function() {
        var l = this, c = l.$createElement, u = l._self._c || c;
        return u("div", { staticClass: "multiselect", class: { "multiselect--active": l.isOpen, "multiselect--disabled": l.disabled, "multiselect--above": l.isAbove, "multiselect--has-options-group": l.hasOptionGroup }, attrs: { tabindex: l.searchable ? -1 : l.tabindex, role: "combobox", "aria-owns": "listbox-" + l.id }, on: { focus: function(d) {
          return l.activate();
        }, blur: function(d) {
          !l.searchable && l.deactivate();
        }, keydown: [function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "down", 40, d.key, ["Down", "ArrowDown"]) || d.target !== d.currentTarget ? null : (d.preventDefault(), l.pointerForward());
        }, function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "up", 38, d.key, ["Up", "ArrowUp"]) || d.target !== d.currentTarget ? null : (d.preventDefault(), l.pointerBackward());
        }], keypress: function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "enter", 13, d.key, "Enter") && l._k(d.keyCode, "tab", 9, d.key, "Tab") ? null : (d.stopPropagation(), d.target !== d.currentTarget ? null : l.addPointerElement(d));
        }, keyup: function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "esc", 27, d.key, ["Esc", "Escape"]) ? null : l.deactivate();
        } } }, [l._t("caret", function() {
          return [u("div", { staticClass: "multiselect__select", on: { mousedown: function(d) {
            return d.preventDefault(), d.stopPropagation(), l.toggle();
          } } })];
        }, { toggle: l.toggle }), l._v(" "), l._t("clear", null, { search: l.search }), l._v(" "), u("div", { ref: "tags", staticClass: "multiselect__tags" }, [l._t("selection", function() {
          return [u("div", { directives: [{ name: "show", rawName: "v-show", value: l.visibleValues.length > 0, expression: "visibleValues.length > 0" }], staticClass: "multiselect__tags-wrap" }, [l._l(l.visibleValues, function(d, f) {
            return [l._t("tag", function() {
              return [u("span", { key: f, staticClass: "multiselect__tag" }, [u("span", { domProps: { textContent: l._s(l.getOptionLabel(d)) } }), l._v(" "), u("i", { staticClass: "multiselect__tag-icon", attrs: { tabindex: "1" }, on: { keypress: function(p) {
                return !p.type.indexOf("key") && l._k(p.keyCode, "enter", 13, p.key, "Enter") ? null : (p.preventDefault(), l.removeElement(d));
              }, mousedown: function(p) {
                return p.preventDefault(), l.removeElement(d);
              } } })])];
            }, { option: d, search: l.search, remove: l.removeElement })];
          })], 2), l._v(" "), l.internalValue && l.internalValue.length > l.limit ? [l._t("limit", function() {
            return [u("strong", { staticClass: "multiselect__strong", domProps: { textContent: l._s(l.limitText(l.internalValue.length - l.limit)) } })];
          })] : l._e()];
        }, { search: l.search, remove: l.removeElement, values: l.visibleValues, isOpen: l.isOpen }), l._v(" "), u("transition", { attrs: { name: "multiselect__loading" } }, [l._t("loading", function() {
          return [u("div", { directives: [{ name: "show", rawName: "v-show", value: l.loading, expression: "loading" }], staticClass: "multiselect__spinner" })];
        })], 2), l._v(" "), l.searchable ? u("input", { ref: "search", staticClass: "multiselect__input", style: l.inputStyle, attrs: { name: l.name, id: l.id, type: "text", autocomplete: "off", spellcheck: "false", placeholder: l.placeholder, disabled: l.disabled, tabindex: l.tabindex, "aria-controls": "listbox-" + l.id }, domProps: { value: l.search }, on: { input: function(d) {
          return l.updateSearch(d.target.value);
        }, focus: function(d) {
          return d.preventDefault(), l.activate();
        }, blur: function(d) {
          return d.preventDefault(), l.deactivate();
        }, keyup: function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "esc", 27, d.key, ["Esc", "Escape"]) ? null : l.deactivate();
        }, keydown: [function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "down", 40, d.key, ["Down", "ArrowDown"]) ? null : (d.preventDefault(), l.pointerForward());
        }, function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "up", 38, d.key, ["Up", "ArrowUp"]) ? null : (d.preventDefault(), l.pointerBackward());
        }, function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "delete", [8, 46], d.key, ["Backspace", "Delete", "Del"]) ? null : (d.stopPropagation(), l.removeLastElement());
        }], keypress: function(d) {
          return !d.type.indexOf("key") && l._k(d.keyCode, "enter", 13, d.key, "Enter") ? null : (d.preventDefault(), d.stopPropagation(), d.target !== d.currentTarget ? null : l.addPointerElement(d));
        } } }) : l._e(), l._v(" "), l.isSingleLabelVisible ? u("span", { staticClass: "multiselect__single", on: { mousedown: function(d) {
          return d.preventDefault(), l.toggle.apply(null, arguments);
        } } }, [l._t("singleLabel", function() {
          return [[l._v(l._s(l.currentOptionLabel))]];
        }, { option: l.singleValue })], 2) : l._e(), l._v(" "), l.isPlaceholderVisible ? u("span", { staticClass: "multiselect__placeholder", on: { mousedown: function(d) {
          return d.preventDefault(), l.toggle.apply(null, arguments);
        } } }, [l._t("placeholder", function() {
          return [l._v(`
          ` + l._s(l.placeholder) + `
        `)];
        })], 2) : l._e()], 2), l._v(" "), u("transition", { attrs: { name: "multiselect" } }, [u("div", { directives: [{ name: "show", rawName: "v-show", value: l.isOpen, expression: "isOpen" }], ref: "list", staticClass: "multiselect__content-wrapper", style: { maxHeight: l.optimizedHeight + "px" }, attrs: { tabindex: "-1" }, on: { focus: l.activate, mousedown: function(d) {
          d.preventDefault();
        } } }, [u("ul", { staticClass: "multiselect__content", style: l.contentStyle, attrs: { role: "listbox", id: "listbox-" + l.id } }, [l._t("beforeList"), l._v(" "), l.multiple && l.max === l.internalValue.length ? u("li", [u("span", { staticClass: "multiselect__option" }, [l._t("maxElements", function() {
          return [l._v("Maximum of " + l._s(l.max) + " options selected. First remove a selected option to select another.")];
        })], 2)]) : l._e(), l._v(" "), !l.max || l.internalValue.length < l.max ? l._l(l.filteredOptions, function(d, f) {
          return u("li", { key: f, staticClass: "multiselect__element", attrs: { id: l.id + "-" + f, role: d && (d.$isLabel || d.$isDisabled) ? null : "option" } }, [d && (d.$isLabel || d.$isDisabled) ? l._e() : u("span", { staticClass: "multiselect__option", class: l.optionHighlight(f, d), attrs: { "data-select": d && d.isTag ? l.tagPlaceholder : l.selectLabelText, "data-selected": l.selectedLabelText, "data-deselect": l.deselectLabelText }, on: { click: function(p) {
            return p.stopPropagation(), l.select(d);
          }, mouseenter: function(p) {
            return p.target !== p.currentTarget ? null : l.pointerSet(f);
          } } }, [l._t("option", function() {
            return [u("span", [l._v(l._s(l.getOptionLabel(d)))])];
          }, { option: d, search: l.search, index: f })], 2), l._v(" "), d && (d.$isLabel || d.$isDisabled) ? u("span", { staticClass: "multiselect__option", class: l.groupHighlight(f, d), attrs: { "data-select": l.groupSelect && l.selectGroupLabelText, "data-deselect": l.groupSelect && l.deselectGroupLabelText }, on: { mouseenter: function(p) {
            if (p.target !== p.currentTarget) return null;
            l.groupSelect && l.pointerSet(f);
          }, mousedown: function(p) {
            return p.preventDefault(), l.selectGroup(d);
          } } }, [l._t("option", function() {
            return [u("span", [l._v(l._s(l.getOptionLabel(d)))])];
          }, { option: d, search: l.search, index: f })], 2) : l._e()]);
        }) : l._e(), l._v(" "), u("li", { directives: [{ name: "show", rawName: "v-show", value: l.showNoResults && l.filteredOptions.length === 0 && l.search && !l.loading, expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)" }] }, [u("span", { staticClass: "multiselect__option" }, [l._t("noResult", function() {
          return [l._v("No elements found. Consider changing the search query.")];
        }, { search: l.search })], 2)]), l._v(" "), u("li", { directives: [{ name: "show", rawName: "v-show", value: l.showNoOptions && (l.options.length === 0 || l.hasOptionGroup === !0 && l.filteredOptions.length === 0) && !l.search && !l.loading, expression: "showNoOptions && ((options.length === 0 || (hasOptionGroup === true && filteredOptions.length === 0)) && !search && !loading)" }] }, [u("span", { staticClass: "multiselect__option" }, [l._t("noOptions", function() {
          return [l._v("List is empty.")];
        })], 2)]), l._v(" "), l._t("afterList")], 2)])])], 2);
      }, o = [], a = { render: i, staticRenderFns: o };
      r.a = a;
    }, function(n, r) {
      var s;
      s = /* @__PURE__ */ function() {
        return this;
      }();
      try {
        s = s || Function("return this")() || (0, eval)("this");
      } catch {
        typeof window == "object" && (s = window);
      }
      n.exports = s;
    }]);
  });
})(Zj);
var a2t = Zj.exports;
const l2t = /* @__PURE__ */ Et(a2t);
var Xj = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(vr, function() {
    return function(n) {
      function r(i) {
        if (s[i]) return s[i].exports;
        var o = s[i] = { exports: {}, id: i, loaded: !1 };
        return n[i].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
      }
      var s = {};
      return r.m = n, r.c = s, r.p = "", r(0);
    }([function(n, r, s) {
      function i(l) {
        return l && l.__esModule ? l : { default: l };
      }
      var o = s(1), a = i(o);
      n.exports = a.default;
    }, function(n, r, s) {
      s(2);
      var i = s(6)(s(7), s(8), "data-v-82963a40", null);
      n.exports = i.exports;
    }, function(n, r, s) {
      var i = s(3);
      typeof i == "string" && (i = [[n.id, i, ""]]), s(5)(i, {}), i.locals && (n.exports = i.locals);
    }, function(n, r, s) {
      r = n.exports = s(4)(), r.push([n.id, "a[data-v-82963a40]{cursor:pointer}", ""]);
    }, function(n, r) {
      n.exports = function() {
        var s = [];
        return s.toString = function() {
          for (var i = [], o = 0; o < this.length; o++) {
            var a = this[o];
            a[2] ? i.push("@media " + a[2] + "{" + a[1] + "}") : i.push(a[1]);
          }
          return i.join("");
        }, s.i = function(i, o) {
          typeof i == "string" && (i = [[null, i, ""]]);
          for (var a = {}, l = 0; l < this.length; l++) {
            var c = this[l][0];
            typeof c == "number" && (a[c] = !0);
          }
          for (l = 0; l < i.length; l++) {
            var u = i[l];
            typeof u[0] == "number" && a[u[0]] || (o && !u[2] ? u[2] = o : o && (u[2] = "(" + u[2] + ") and (" + o + ")"), s.push(u));
          }
        }, s;
      };
    }, function(n, r, s) {
      function i(E, x) {
        for (var T = 0; T < E.length; T++) {
          var C = E[T], k = p[C.id];
          if (k) {
            k.refs++;
            for (var b = 0; b < k.parts.length; b++) k.parts[b](C.parts[b]);
            for (; b < C.parts.length; b++) k.parts.push(u(C.parts[b], x));
          } else {
            for (var P = [], b = 0; b < C.parts.length; b++) P.push(u(C.parts[b], x));
            p[C.id] = { id: C.id, refs: 1, parts: P };
          }
        }
      }
      function o(E) {
        for (var x = [], T = {}, C = 0; C < E.length; C++) {
          var k = E[C], b = k[0], P = k[1], N = k[2], D = k[3], H = { css: P, media: N, sourceMap: D };
          T[b] ? T[b].parts.push(H) : x.push(T[b] = { id: b, parts: [H] });
        }
        return x;
      }
      function a(E, x) {
        var T = v(), C = w[w.length - 1];
        if (E.insertAt === "top") C ? C.nextSibling ? T.insertBefore(x, C.nextSibling) : T.appendChild(x) : T.insertBefore(x, T.firstChild), w.push(x);
        else {
          if (E.insertAt !== "bottom") throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
          T.appendChild(x);
        }
      }
      function l(E) {
        E.parentNode.removeChild(E);
        var x = w.indexOf(E);
        x >= 0 && w.splice(x, 1);
      }
      function c(E) {
        var x = document.createElement("style");
        return x.type = "text/css", a(E, x), x;
      }
      function u(E, x) {
        var T, C, k;
        if (x.singleton) {
          var b = _++;
          T = y || (y = c(x)), C = d.bind(null, T, b, !1), k = d.bind(null, T, b, !0);
        } else T = c(x), C = f.bind(null, T), k = function() {
          l(T);
        };
        return C(E), function(P) {
          if (P) {
            if (P.css === E.css && P.media === E.media && P.sourceMap === E.sourceMap) return;
            C(E = P);
          } else k();
        };
      }
      function d(E, x, T, C) {
        var k = T ? "" : C.css;
        if (E.styleSheet) E.styleSheet.cssText = S(x, k);
        else {
          var b = document.createTextNode(k), P = E.childNodes;
          P[x] && E.removeChild(P[x]), P.length ? E.insertBefore(b, P[x]) : E.appendChild(b);
        }
      }
      function f(E, x) {
        var T = x.css, C = x.media, k = x.sourceMap;
        if (C && E.setAttribute("media", C), k && (T += `
/*# sourceURL=` + k.sources[0] + " */", T += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(k)))) + " */"), E.styleSheet) E.styleSheet.cssText = T;
        else {
          for (; E.firstChild; ) E.removeChild(E.firstChild);
          E.appendChild(document.createTextNode(T));
        }
      }
      var p = {}, h = function(E) {
        var x;
        return function() {
          return typeof x > "u" && (x = E.apply(this, arguments)), x;
        };
      }, m = h(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
      }), v = h(function() {
        return document.head || document.getElementsByTagName("head")[0];
      }), y = null, _ = 0, w = [];
      n.exports = function(E, x) {
        x = x || {}, typeof x.singleton > "u" && (x.singleton = m()), typeof x.insertAt > "u" && (x.insertAt = "bottom");
        var T = o(E);
        return i(T, x), function(C) {
          for (var k = [], b = 0; b < T.length; b++) {
            var P = T[b], N = p[P.id];
            N.refs--, k.push(N);
          }
          if (C) {
            var D = o(C);
            i(D, x);
          }
          for (var b = 0; b < k.length; b++) {
            var N = k[b];
            if (N.refs === 0) {
              for (var H = 0; H < N.parts.length; H++) N.parts[H]();
              delete p[N.id];
            }
          }
        };
      };
      var S = /* @__PURE__ */ function() {
        var E = [];
        return function(x, T) {
          return E[x] = T, E.filter(Boolean).join(`
`);
        };
      }();
    }, function(n, r) {
      n.exports = function(s, i, o, a) {
        var l, c = s = s || {}, u = typeof s.default;
        u !== "object" && u !== "function" || (l = s, c = s.default);
        var d = typeof c == "function" ? c.options : c;
        if (i && (d.render = i.render, d.staticRenderFns = i.staticRenderFns), o && (d._scopeId = o), a) {
          var f = d.computed || (d.computed = {});
          Object.keys(a).forEach(function(p) {
            var h = a[p];
            f[p] = function() {
              return h;
            };
          });
        }
        return { esModule: l, exports: c, options: d };
      };
    }, function(n, r) {
      Object.defineProperty(r, "__esModule", { value: !0 }), r.default = { props: { value: { type: Number }, pageCount: { type: Number, required: !0 }, forcePage: { type: Number }, clickHandler: { type: Function, default: function() {
      } }, pageRange: { type: Number, default: 3 }, marginPages: { type: Number, default: 1 }, prevText: { type: String, default: "Prev" }, nextText: { type: String, default: "Next" }, breakViewText: { type: String, default: "…" }, containerClass: { type: String }, pageClass: { type: String }, pageLinkClass: { type: String }, prevClass: { type: String }, prevLinkClass: { type: String }, nextClass: { type: String }, nextLinkClass: { type: String }, breakViewClass: { type: String }, breakViewLinkClass: { type: String }, activeClass: { type: String, default: "active" }, disabledClass: { type: String, default: "disabled" }, noLiSurround: { type: Boolean, default: !1 }, firstLastButton: { type: Boolean, default: !1 }, firstButtonText: { type: String, default: "First" }, lastButtonText: { type: String, default: "Last" }, hidePrevNext: { type: Boolean, default: !1 } }, beforeUpdate: function() {
        this.forcePage !== void 0 && this.forcePage !== this.selected && (this.selected = this.forcePage);
      }, computed: { selected: { get: function() {
        return this.value || this.innerValue;
      }, set: function(s) {
        this.innerValue = s;
      } }, pages: function() {
        var s = this, i = {};
        if (this.pageCount <= this.pageRange) for (var o = 0; o < this.pageCount; o++) {
          var a = { index: o, content: o + 1, selected: o === this.selected - 1 };
          i[o] = a;
        }
        else {
          for (var l = Math.floor(this.pageRange / 2), c = function(v) {
            var y = { index: v, content: v + 1, selected: v === s.selected - 1 };
            i[v] = y;
          }, u = function(v) {
            var y = { disabled: !0, breakView: !0 };
            i[v] = y;
          }, d = 0; d < this.marginPages; d++) c(d);
          var f = 0;
          this.selected - l > 0 && (f = this.selected - 1 - l);
          var p = f + this.pageRange - 1;
          p >= this.pageCount && (p = this.pageCount - 1, f = p - this.pageRange + 1);
          for (var h = f; h <= p && h <= this.pageCount - 1; h++) c(h);
          f > this.marginPages && u(f - 1), p + 1 < this.pageCount - this.marginPages && u(p + 1);
          for (var m = this.pageCount - 1; m >= this.pageCount - this.marginPages; m--) c(m);
        }
        return i;
      } }, data: function() {
        return { innerValue: 1 };
      }, methods: { handlePageSelected: function(s) {
        this.selected !== s && (this.innerValue = s, this.$emit("input", s), this.clickHandler(s));
      }, prevPage: function() {
        this.selected <= 1 || this.handlePageSelected(this.selected - 1);
      }, nextPage: function() {
        this.selected >= this.pageCount || this.handlePageSelected(this.selected + 1);
      }, firstPageSelected: function() {
        return this.selected === 1;
      }, lastPageSelected: function() {
        return this.selected === this.pageCount || this.pageCount === 0;
      }, selectFirstPage: function() {
        this.selected <= 1 || this.handlePageSelected(1);
      }, selectLastPage: function() {
        this.selected >= this.pageCount || this.handlePageSelected(this.pageCount);
      } } };
    }, function(n, r) {
      n.exports = { render: function() {
        var s = this, i = s.$createElement, o = s._self._c || i;
        return s.noLiSurround ? o("div", { class: s.containerClass }, [s.firstLastButton ? o("a", { class: [s.pageLinkClass, s.firstPageSelected() ? s.disabledClass : ""], attrs: { tabindex: "0" }, domProps: { innerHTML: s._s(s.firstButtonText) }, on: { click: function(a) {
          s.selectFirstPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.selectFirstPage() : null;
        } } }) : s._e(), s._v(" "), s.firstPageSelected() && s.hidePrevNext ? s._e() : o("a", { class: [s.prevLinkClass, s.firstPageSelected() ? s.disabledClass : ""], attrs: { tabindex: "0" }, domProps: { innerHTML: s._s(s.prevText) }, on: { click: function(a) {
          s.prevPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.prevPage() : null;
        } } }), s._v(" "), s._l(s.pages, function(a) {
          return [a.breakView ? o("a", { class: [s.pageLinkClass, s.breakViewLinkClass, a.disabled ? s.disabledClass : ""], attrs: { tabindex: "0" } }, [s._t("breakViewContent", [s._v(s._s(s.breakViewText))])], 2) : a.disabled ? o("a", { class: [s.pageLinkClass, a.selected ? s.activeClass : "", s.disabledClass], attrs: { tabindex: "0" } }, [s._v(s._s(a.content))]) : o("a", { class: [s.pageLinkClass, a.selected ? s.activeClass : ""], attrs: { tabindex: "0" }, on: { click: function(l) {
            s.handlePageSelected(a.index + 1);
          }, keyup: function(l) {
            return "button" in l || !s._k(l.keyCode, "enter", 13) ? void s.handlePageSelected(a.index + 1) : null;
          } } }, [s._v(s._s(a.content))])];
        }), s._v(" "), s.lastPageSelected() && s.hidePrevNext ? s._e() : o("a", { class: [s.nextLinkClass, s.lastPageSelected() ? s.disabledClass : ""], attrs: { tabindex: "0" }, domProps: { innerHTML: s._s(s.nextText) }, on: { click: function(a) {
          s.nextPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.nextPage() : null;
        } } }), s._v(" "), s.firstLastButton ? o("a", { class: [s.pageLinkClass, s.lastPageSelected() ? s.disabledClass : ""], attrs: { tabindex: "0" }, domProps: { innerHTML: s._s(s.lastButtonText) }, on: { click: function(a) {
          s.selectLastPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.selectLastPage() : null;
        } } }) : s._e()], 2) : o("ul", { class: s.containerClass }, [s.firstLastButton ? o("li", { class: [s.pageClass, s.firstPageSelected() ? s.disabledClass : ""] }, [o("a", { class: s.pageLinkClass, attrs: { tabindex: s.firstPageSelected() ? -1 : 0 }, domProps: { innerHTML: s._s(s.firstButtonText) }, on: { click: function(a) {
          s.selectFirstPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.selectFirstPage() : null;
        } } })]) : s._e(), s._v(" "), s.firstPageSelected() && s.hidePrevNext ? s._e() : o("li", { class: [s.prevClass, s.firstPageSelected() ? s.disabledClass : ""] }, [o("a", { class: s.prevLinkClass, attrs: { tabindex: s.firstPageSelected() ? -1 : 0 }, domProps: { innerHTML: s._s(s.prevText) }, on: { click: function(a) {
          s.prevPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.prevPage() : null;
        } } })]), s._v(" "), s._l(s.pages, function(a) {
          return o("li", { class: [s.pageClass, a.selected ? s.activeClass : "", a.disabled ? s.disabledClass : "", a.breakView ? s.breakViewClass : ""] }, [a.breakView ? o("a", { class: [s.pageLinkClass, s.breakViewLinkClass], attrs: { tabindex: "0" } }, [s._t("breakViewContent", [s._v(s._s(s.breakViewText))])], 2) : a.disabled ? o("a", { class: s.pageLinkClass, attrs: { tabindex: "0" } }, [s._v(s._s(a.content))]) : o("a", { class: s.pageLinkClass, attrs: { tabindex: "0" }, on: { click: function(l) {
            s.handlePageSelected(a.index + 1);
          }, keyup: function(l) {
            return "button" in l || !s._k(l.keyCode, "enter", 13) ? void s.handlePageSelected(a.index + 1) : null;
          } } }, [s._v(s._s(a.content))])]);
        }), s._v(" "), s.lastPageSelected() && s.hidePrevNext ? s._e() : o("li", { class: [s.nextClass, s.lastPageSelected() ? s.disabledClass : ""] }, [o("a", { class: s.nextLinkClass, attrs: { tabindex: s.lastPageSelected() ? -1 : 0 }, domProps: { innerHTML: s._s(s.nextText) }, on: { click: function(a) {
          s.nextPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.nextPage() : null;
        } } })]), s._v(" "), s.firstLastButton ? o("li", { class: [s.pageClass, s.lastPageSelected() ? s.disabledClass : ""] }, [o("a", { class: s.pageLinkClass, attrs: { tabindex: s.lastPageSelected() ? -1 : 0 }, domProps: { innerHTML: s._s(s.lastButtonText) }, on: { click: function(a) {
          s.selectLastPage();
        }, keyup: function(a) {
          return "button" in a || !s._k(a.keyCode, "enter", 13) ? void s.selectLastPage() : null;
        } } })]) : s._e()], 2);
      }, staticRenderFns: [] };
    }]);
  });
})(Xj);
var c2t = Xj.exports;
const u2t = /* @__PURE__ */ Et(c2t);
function Yp(t, e, n) {
  t.$set(t.$data._asyncComputed[e], "state", n), t.$set(t.$data._asyncComputed[e], "updating", n === "updating"), t.$set(t.$data._asyncComputed[e], "error", n === "error"), t.$set(t.$data._asyncComputed[e], "success", n === "success");
}
function d2t(t) {
  return typeof t == "function" ? t : t.get;
}
function fw(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function KI(t) {
  return fw(t, "lazy") && t.lazy;
}
function f2t(t, e) {
  return t[JI + e];
}
var JI = "async_computed$lazy_active$", Ef = "async_computed$lazy_data$";
function p2t(t, e, n) {
  t[JI + e] = !1, t[Ef + e] = n;
}
function h2t(t) {
  return {
    get: function() {
      return this[JI + t] = !0, this[Ef + t];
    },
    set: function(n) {
      this[Ef + t] = n;
    }
  };
}
function m2t(t, e, n) {
  t[Ef + e] = n;
}
function v2t(t, e) {
  return t[Ef + e];
}
var g2t = function(e) {
  return function() {
    var r = this;
    return e.watch.forEach(function(s) {
      var i = s.split(".");
      if (i.length === 1)
        r[s];
      else
        try {
          var o = r;
          i.forEach(function(a) {
            o = o[a];
          });
        } catch (a) {
          throw console.error("AsyncComputed: bad path: ", s), a;
        }
    }), e.get.call(this);
  };
}, y2t = function(e) {
  return function() {
    return e.watch.call(this), e.get.call(this);
  };
};
function b2t(t) {
  if (typeof t.watch == "function")
    return y2t(t);
  if (Array.isArray(t.watch))
    return t.watch.forEach(function(e) {
      if (typeof e != "string")
        throw new Error("AsyncComputed: watch elemnts must be strings");
    }), g2t(t);
  throw Error("AsyncComputed: watch should be function or an array");
}
var Kj = typeof Symbol == "function" ? Symbol("did-not-update") : {}, _2t = function(e, n) {
  return function() {
    return e.shouldUpdate.call(this) ? n.call(this) : Kj;
  };
}, w2t = function(e) {
  return Kj === e;
}, Jj = "_async_computed$", qj = {
  install: function(e, n) {
    n = n || {}, e.config.optionMergeStrategies.asyncComputed = e.config.optionMergeStrategies.computed, e.mixin({
      data: function() {
        return {
          _asyncComputed: {}
        };
      },
      computed: {
        $asyncComputed: function() {
          return this.$data._asyncComputed;
        }
      },
      beforeCreate: function() {
        var s = this.$options.asyncComputed || {};
        if (Object.keys(s).length) {
          for (var i in s) {
            var o = E2t(i, s[i]);
            this.$options.computed[Jj + i] = o;
          }
          this.$options.data = I2t(this.$options, n);
        }
      },
      created: function() {
        for (var s in this.$options.asyncComputed || {}) {
          var i = this.$options.asyncComputed[s], o = Qj.call(this, i, n);
          KI(i) ? m2t(this, s, o) : this[s] = o;
        }
        for (var a in this.$options.asyncComputed || {})
          S2t(this, a, n, e);
      }
    });
  }
};
function S2t(t, e, n, r) {
  var s = 0, i = function(a) {
    var l = ++s;
    w2t(a) || ((!a || !a.then) && (a = Promise.resolve(a)), Yp(t, e, "updating"), a.then(function(c) {
      l === s && (Yp(t, e, "success"), t[e] = c);
    }).catch(function(c) {
      if (l === s && (Yp(t, e, "error"), r.set(t.$data._asyncComputed[e], "exception", c), n.errorHandler !== !1)) {
        var u = n.errorHandler === void 0 ? console.error.bind(console, "Error evaluating async computed property:") : n.errorHandler;
        n.useRawError ? u(c, t, c.stack) : u(c.stack);
      }
    }));
  };
  r.set(t.$data._asyncComputed, e, {
    exception: null,
    update: function() {
      t._isDestroyed || i(d2t(t.$options.asyncComputed[e]).apply(t));
    }
  }), Yp(t, e, "updating"), t.$watch(Jj + e, i, { immediate: !0 });
}
function I2t(t, e) {
  var n = t.data, r = t.asyncComputed || {};
  return function(i) {
    var o = (typeof n == "function" ? n.call(this, i) : n) || {};
    for (var a in r) {
      var l = this.$options.asyncComputed[a], c = Qj.call(this, l, e);
      KI(l) ? (p2t(o, a, c), this.$options.computed[a] = h2t(a)) : o[a] = c;
    }
    return o;
  };
}
function E2t(t, e) {
  if (typeof e == "function") return e;
  var n = e.get;
  if (fw(e, "watch") && (n = b2t(e)), fw(e, "shouldUpdate") && (n = _2t(e, n)), KI(e)) {
    var r = n;
    n = function() {
      return f2t(this, t) ? r.call(this) : v2t(this, t);
    };
  }
  return n;
}
function Qj(t, e) {
  var n = null;
  return "default" in t ? n = t.default : "default" in e && (n = e.default), typeof n == "function" ? n.call(this) : n;
}
typeof window < "u" && window.Vue && window.Vue.use(qj);
if (typeof window < "u") {
  let t = function() {
    var e = document.body, n = document.getElementById("__svg__icons__dom__1748855794570__");
    n || (n = document.createElementNS("http://www.w3.org/2000/svg", "svg"), n.style.position = "absolute", n.style.width = "0", n.style.height = "0", n.id = "__svg__icons__dom__1748855794570__", n.setAttribute("xmlns", "http://www.w3.org/2000/svg"), n.setAttribute("xmlns:link", "http://www.w3.org/1999/xlink")), n.innerHTML = '<symbol  viewBox="0 0 9 5" id="pub-arrow-down"><path d="M4.5 4.7.7 1.4l.6-.8 3.2 2.7L7.7.6l.6.8z" /></symbol><symbol viewBox="0 0 11 34"  id="pub-arrow-left-thin"><path d="M10.824 31.294a1.5 1.5 0 1 1-2.648 1.412l-8-15a1.5 1.5 0 0 1 0-1.412l8-15a1.5 1.5 0 1 1 2.648 1.412L3.2 17l7.624 14.294Z" /></symbol><symbol  viewBox="0 0 768 768" id="pub-arrow-right-rounded"><path d="M403.913 384.001 184.868 615.419c-32.993 34.853-32.993 91.373 0 126.227s86.486 34.854 119.479 0l278.785-294.533c32.993-34.857 32.993-91.37 0-126.227L304.347 26.354c-32.994-34.856-86.486-34.856-119.479 0s-32.993 91.37 0 126.227l219.045 231.418z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-add-to-list"><path d="M22.405 6.42c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574zM7 13h10v-2H7v2zm0 4h10v-2H7v2zm0-8h10V7H7v2z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-add"><path d="M13 11V7h-2v4H7v2h4v4h2v-4h4v-2h-4zm9.405-4.58c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574z" /></symbol><symbol  viewBox="0 0 768 768" id="pub-button-icon-arrow-left"><path d="M562.561 716.949C501.089 731.551 438.885 736.663 384 735.933c-54.886.731-117.089-4.381-178.561-18.984 0 0-108.308-22.634-146.362-120.473C40.782 550.477 32.732 466.511 32 384.005c.732-82.506 9.514-166.472 27.077-212.471C97.131 73.695 205.439 51.061 205.439 51.061 266.179 35.728 329.115 31.347 384 32.077c54.886-.73 117.089 4.381 178.561 18.984 0 0 108.308 22.634 146.362 120.473 17.563 45.999 26.345 129.965 27.077 212.471-.732 82.506-9.514 166.472-27.077 212.471-38.054 97.839-146.362 120.473-146.362 120.473zM363.801 384l115.773-115.773c17.438-17.438 17.438-45.711 0-63.148s-45.711-17.438-63.148 0L269.079 352.426c-17.438 17.438-17.438 45.711 0 63.148l147.347 147.347c17.438 17.438 45.711 17.438 63.148 0s17.438-45.711 0-63.149L363.801 383.999z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-chat"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.405 6.42s-.708-3.385-3.765-4.574C17.202 1.297 14.578 1.023 12 1c-2.578.023-5.202.297-6.64.846C2.303 3.036 1.596 6.42 1.596 6.42 1.139 8.341.98 10.285 1.002 12c-.022 1.715.114 3.682.594 5.58 0 0 .707 3.385 3.764 4.574 1.438.549 4.062.823 6.64.846 2.578-.023 5.202-.274 6.64-.846 3.057-1.19 3.765-4.574 3.765-4.574.456-1.921.616-3.865.593-5.58.023-1.715-.137-3.659-.593-5.58zM12 6a6 6 0 0 1 6 6v5a1 1 0 0 1-1 1h-5a6 6 0 0 1 0-12zm0 2a4 4 0 0 1 4 4v4h-4a4 4 0 0 1 0-8z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-children"><path d="M22.4 6.4c-.5-2-1.9-3.7-3.8-4.6-2.1-.6-4.4-.9-6.6-.8-2.2-.1-4.5.2-6.6.8-1.9.9-3.3 2.6-3.8 4.6C1.2 8.2 1 10.1 1 12c0 1.9.2 3.8.6 5.6.5 2 1.9 3.7 3.8 4.6 2.1.6 4.4.9 6.6.8 2.2.1 4.5-.2 6.6-.8 1.9-.9 3.3-2.6 3.8-4.6.4-1.8.6-3.7.6-5.6 0-1.9-.2-3.8-.6-5.6z" /><path class="st0" d="M17.4 18.9h-1.6l-.3-1.9H8.6l-.2 1.9H6.8V15h1.1l.2-.4c.1-.3.2-.5.3-.8l.3-1.2c.1-.5.2-1 .3-1.6.2-.7.3-1.3.3-2 .1-.9.1-1.7 0-2.6h6.6V15h1.4l.1 3.9zM13.7 15V8.4h-2.3c0 .5 0 1.1-.1 1.6 0 .6-.1 1.2-.2 1.8-.1.6-.2 1.1-.4 1.7-.1.5-.3 1-.6 1.5h3.6z" fill="#0069E4" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-create-button"><path d="M21.405 5.42c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.708 3.385-3.765 4.574-1.438.572-4.062.823-6.64.846-2.578-.023-5.202-.297-6.64-.846C1.303 19.964.596 16.58.596 16.58.116 14.682-.02 12.715.002 11-.02 9.285.14 7.341.596 5.42c0 0 .707-3.385 3.764-4.574C5.798.297 8.422.023 11 0c2.578.023 5.202.297 6.64.846 3.057 1.19 3.765 4.574 3.765 4.574Zm-9.349 2.247a1 1 0 0 1-.963-.733l-.266-.958A1.333 1.333 0 0 0 9.542 5H6.333C5.597 5 5 5.597 5 6.333v9.334C5 16.403 5.597 17 6.333 17h9.334c.736 0 1.333-.597 1.333-1.333V9c0-.736-.597-1.333-1.333-1.333h-3.61Z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-delete"><path d="M22.405 6.42c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574zm-8.748 5.823 2.828-2.828-1.414-1.414-2.828 2.828-2.828-2.828-1.414 1.414 2.828 2.828-2.828 2.828 1.414 1.414 2.828-2.828 2.828 2.828 1.414-1.414-2.828-2.828z" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-duplicate"><path d="M9 9H5v8h8v-4h4V5H9v4Zm0 2v2h2v2H7v-4h2Zm7.58 10.405c-1.921.456-3.865.616-5.58.593-1.715.023-3.659-.137-5.58-.593 0 0-3.385-.708-4.574-3.765C.274 16.202.023 13.578 0 11c.023-2.578.297-5.202.846-6.64C2.036 1.303 5.42.596 5.42.596 7.318.116 9.285-.02 11 .002c1.715-.022 3.659.137 5.58.594 0 0 3.385.707 4.574 3.764.549 1.438.823 4.062.846 6.64-.023 2.578-.297 5.202-.846 6.64-1.19 3.057-4.574 3.765-4.574 3.765ZM11 7h4v4h-4V7Z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-edit"><path d="m7.386 16.616 1.94-.392-1.55-1.55-.39 1.942zm2.706-1.158 7.376-7.377-1.55-1.55-.746.747 1.542 1.541-.766.766-1.542-1.541-5.863 5.864 1.55 1.55z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 0 0-7 7v8a7 7 0 0 0 7 7h8a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7H8zM6 18l.78-3.86L15.917 5 19 8.082l-9.14 9.14L6 18z" /></symbol><symbol  viewBox="0 0 768 768" id="pub-button-icon-editors"><path d="M716.949 205.439c14.602 61.472 19.714 123.676 18.984 178.561.731 54.886-4.381 117.089-18.984 178.562 0 0-22.634 108.307-120.473 146.362-45.999 18.295-129.965 26.345-212.471 27.077-82.506-.732-166.472-9.514-212.471-27.077C73.695 670.87 51.061 562.562 51.061 562.562 35.728 501.822 31.347 438.886 32.077 384c-.73-54.886 4.381-117.089 18.984-178.561 0 0 22.634-108.308 120.473-146.362C217.533 41.514 301.499 32.732 384.005 32c82.506.732 166.472 9.514 212.471 27.077 97.839 38.054 120.473 146.362 120.473 146.362zM384 544c66.194 0 135.871-46.761 209.034-140.283 9.062-11.583 9.062-27.851 0-39.434C519.871 270.761 450.194 224 384 224s-135.872 46.761-209.034 140.283c-9.061 11.583-9.061 27.851 0 39.434C248.129 497.239 317.807 544 384 544z" /><path d="M384 480c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-embargo"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.75 12a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0zm5.5-3.5v4.75h4.25v-1.5h-2.75V8.5h-1.5z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 0 0-7 7v8a7 7 0 0 0 7 7h8a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7H8zm4 3.25a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-extend"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 0 0-7 7v8a7 7 0 0 0 7 7h8a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7H8Zm8.492 4.69c.04-.197-.07-.393-.244-.439l-2.851-.742c-.175-.045-.35.078-.39.275-.04.197.069.394.244.44l2.086.542L9.5 9.878l.345.622 5.836-4.112L15.2 8.74c-.04.197.069.394.244.44.175.045.35-.078.39-.276l.658-3.213Zm3.904 6.022a.45.45 0 0 1 0 .576l-2.258 2.593a.323.323 0 0 1-.502 0 .451.451 0 0 1 0-.576l1.652-1.898H9.5v-.814h9.788l-1.652-1.898a.451.451 0 0 1 0-.576.323.323 0 0 1 .502 0l2.258 2.593ZM8 11.998a1.999 1.999 0 0 1-2 1.998 1.999 1.999 0 1 1 2-1.998Zm8.248 6.75c.175-.045.284-.241.244-.439l-.658-3.214c-.04-.197-.215-.32-.39-.274-.175.045-.284.242-.244.44l.482 2.351L9.845 13.5l-.345.621 5.837 4.113-2.086.542c-.175.046-.284.243-.244.44.04.197.215.32.39.275l2.85-.742Z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-flash"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.998 12c.023-1.715-.137-3.659-.593-5.58 0 0-.708-3.385-3.765-4.574C17.202 1.297 14.578 1.023 12 1c-2.579.023-5.203.297-6.64.846C2.302 3.035 1.595 6.42 1.595 6.42 1.139 8.341.979 10.285 1.002 12c-.023 1.715.114 3.682.593 5.58 0 0 .708 3.385 3.765 4.574 1.438.549 4.062.823 6.64.846 2.579-.023 5.203-.274 6.64-.846 3.058-1.189 3.765-4.574 3.765-4.574.456-1.921.616-3.865.593-5.58zM12.116 4.62l-6.403 9.895h4.581l-.87 4.348 1.27.525 7.07-10.606-4.795.6.431-4.312-1.284-.45zm-3.83 8.495L11.72 7.81l-.318 3.179 3.502-.438-3.412 5.117.511-2.553H8.287z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-forward"><path d="m13 9.805 2.503 2.545 1.397-1.4L11.95 6 7 10.95l1.42 1.4L11 9.71V17h2V9.805zm9.405-3.385c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-list"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 0 0-7 7v8a7 7 0 0 0 7 7h8a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7H8zm0 6H6v2h2V7zm0 4H6v2h2v-2zm-2 4h2v2H6v-2zm12-8h-8v2h8V7zm-8 4h8v2h-8v-2zm8 4h-8v2h8v-2z" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-loupe"><path d="M7 .5a7 7 0 0 0-7 7v8a7 7 0 0 0 7 7h8a7 7 0 0 0 7-7v-8a7 7 0 0 0-7-7Z" transform="translate(0 -.5)" style="fill-rule:evenodd" /><path d="m10.16 13.5-4 3.94-.57-.56 4-3.94Z" transform="translate(0 -.5)" style="fill:#0069e4;fill-rule:evenodd" /><path d="M12.57 13.5a3.16 3.16 0 1 0-3.21-3.16 3.19 3.19 0 0 0 3.21 3.16Zm0 .79a4 4 0 1 0-4-3.95 4 4 0 0 0 4 3.95Z" transform="translate(0 -.5)" style="fill:#0069e4;fill-rule:evenodd" /><path d="M8.15 10.34a4.43 4.43 0 1 1 4.42 4.34 4.48 4.48 0 0 1-2.36-.68l-4.07 4L5 16.88l4-3.95a4.26 4.26 0 0 1-.85-2.59Zm4.42-2.76a2.76 2.76 0 1 0 2.82 2.76 2.78 2.78 0 0 0-2.82-2.76Z" transform="translate(0 -.5)" style="fill:#0069e4;fill-rule:evenodd" /><path d="m10.16 13.5-4 3.94-.57-.56 4-3.94Z" transform="translate(0 -.5)" style="stroke:#0069e4;fill-rule:evenodd" /><path d="M12.57 13.5a3.16 3.16 0 1 0-3.21-3.16 3.19 3.19 0 0 0 3.21 3.16Zm0 .79a4 4 0 1 0-4-3.95 4 4 0 0 0 4 3.95Z" transform="translate(0 -.5)" style="stroke:#0069e4;fill-rule:evenodd" /><path d="M8.15 10.34a4.43 4.43 0 1 1 4.42 4.34 4.48 4.48 0 0 1-2.36-.68l-4.07 4L5 16.88l4-3.95a4.26 4.26 0 0 1-.85-2.59Zm4.42-2.76a2.76 2.76 0 1 0 2.82 2.76 2.78 2.78 0 0 0-2.82-2.76Z" transform="translate(0 -.5)" style="fill:#0069e4;stroke:#0069e4;fill-rule:evenodd" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-more"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.64.846c3.057 1.19 3.765 4.574 3.765 4.574.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.708 3.385-3.765 4.574-1.438.572-4.062.823-6.64.846-2.578-.023-5.202-.297-6.64-.846C1.303 19.964.596 16.58.596 16.58.116 14.682-.02 12.715.002 11-.02 9.285.14 7.341.596 5.42c0 0 .707-3.385 3.764-4.574C5.798.297 8.422.023 11 0c2.578.023 5.202.297 6.64.846ZM7 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm8-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-move"><path d="m13.32 12.175-2.409 2.373a1.102 1.102 0 0 0-.011 1.559l.006.006a1.113 1.113 0 0 0 1.573 0L16.9 11.69a1.467 1.467 0 0 0 0-2.074l-3.638-3.639a1.25 1.25 0 0 0-1.768 0l-.005.006a1.25 1.25 0 0 0 .017 1.773l2.225 2.17H5.524a1.124 1.124 0 1 0 0 2.248h7.796Zm3.26 9.23c-1.921.456-3.865.616-5.58.593-1.715.023-3.659-.137-5.58-.593 0 0-3.385-.708-4.574-3.765C.274 16.202.023 13.578 0 11c.023-2.578.297-5.202.846-6.64C2.036 1.303 5.42.596 5.42.596 7.318.116 9.285-.02 11 .002c1.715-.022 3.659.137 5.58.594 0 0 3.385.707 4.574 3.764.549 1.438.823 4.062.846 6.64-.023 2.578-.297 5.202-.846 6.64-1.19 3.057-4.574 3.765-4.574 3.765Z" /></symbol><symbol  viewBox="0 0 23 22" id="pub-button-icon-original"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.457.846c3.057 1.19 3.764 4.574 3.764 4.574.457 1.921.617 3.865.594 5.58.023 1.715-.137 3.659-.594 5.58 0 0-.707 3.385-3.764 4.574-1.438.572-4.062.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.19-3.764-4.574-3.764-4.574C.933 14.682.796 12.715.819 11c-.023-1.715.137-3.659.594-5.58 0 0 .707-3.385 3.764-4.574C6.615.297 9.24.023 11.817 0c2.578.023 5.202.297 6.64.846ZM7.817 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2h-8Zm-1 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-parents"><path d="M22.1 6.4c-.5-2-1.9-3.7-3.8-4.6-2.1-.6-4.3-.9-6.6-.8-2.2-.1-4.5.2-6.6.8-1.9.9-3.3 2.6-3.8 4.6C.9 8.2.7 10.1.7 12c0 1.9.2 3.8.6 5.6.5 2 1.9 3.7 3.8 4.6 2.2.6 4.4.9 6.6.9 2.2.1 4.5-.2 6.6-.9 1.9-.9 3.3-2.5 3.8-4.6.4-1.8.6-3.7.6-5.6 0-1.9-.2-3.8-.6-5.6z" /><path d="M8.7 6.5c.5-.1 1-.2 1.5-.2s1.1-.1 1.6-.1h.9c.3 0 .6.1.9.2.3.1.6.1.9.3.3.1.5.2.7.4.4.3.7.7.9 1.1.2.5.3 1 .3 1.6 0 .6-.1 1.2-.4 1.7-.2.5-.6.9-1 1.1-.4.3-.9.5-1.4.7-.5.1-1.1.2-1.6.2h-1V17H8.7V6.5zm3.2 1.7h-.6l-.4.1v3.2h.9c.3 0 .6 0 .8-.1.2 0 .5-.1.7-.3.2-.1.4-.3.5-.5.1-.3.2-.6.2-.9 0-.3 0-.5-.2-.8-.1-.2-.3-.4-.4-.5-.2-.1-.4-.2-.7-.2h-.8z" fill="#0069e4" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-publish"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 0 0-7 7v8a7 7 0 0 0 7 7h8a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7H8Zm6.75 16.917L18 6 5 12.5l3.908.95 5.665-3.915-4.226 4.46 4.403 3.922ZM9.875 19v-3.972L11.64 16.6 9.875 19Z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-republish"><path d="M16 1H8C4.1 1 1 4.1 1 8v8c0 3.9 3.1 7 7 7h8c3.9 0 7-3.1 7-7V8c0-3.9-3.1-7-7-7zm2.4 12.8-1.9-1.9c0 .7-.1 1.3-.3 2-.4 1.2-1.2 2.3-2.2 3-1 .8-2.3 1.2-3.6 1.2-1.3 0-2.5-.4-3.6-1.2-1-.8-1.8-1.8-2.2-3s-.4-2.5 0-3.7C5 9 5.8 7.9 6.8 7.2c1-.8 2.3-1.2 3.6-1.2v1.5c-1 0-1.9.3-2.7.9S6.3 9.8 6 10.7c-.3.9-.3 1.9 0 2.8.3.9.9 1.7 1.7 2.3.8.6 1.7.9 2.7.9 1 0 1.9-.3 2.7-.9.8-.6 1.4-1.4 1.7-2.3.2-.5.2-1.1.2-1.6l-2 2-1-1.3 3.8-3.8 3.8 3.8-1.2 1.2z" style="fill-rule:evenodd;clip-rule:evenodd" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-rework"><path d="m18 11.935 1.721 1.721 1.414-1.414-4.243-4.243-4.243 4.243 1.414 1.414 1.927-1.927a4 4 0 1 1-1.821-3.091l1.087-1.679A6 6 0 1 0 18 11.999v-.065zm4.405-5.515c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-save"><path d="M22.405 6.42c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574zM8.031 10.969l-1.414 1.414 4.78 4.78 6.656-8.888-1.601-1.199-5.273 7.041-3.149-3.149z" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-send"><path d="M22.405 6.42s-.708-3.385-3.765-4.574C17.202 1.297 14.578 1.023 12 1c-2.578.023-5.202.297-6.64.846C2.303 3.036 1.596 6.42 1.596 6.42 1.139 8.341.98 10.285 1.002 12c-.022 1.715.114 3.682.594 5.58 0 0 .707 3.385 3.764 4.574 1.438.549 4.062.823 6.64.846 2.578-.023 5.202-.274 6.64-.846 3.057-1.19 3.765-4.574 3.765-4.574.456-1.921.616-3.865.593-5.58.023-1.715-.137-3.659-.593-5.58zM16.99 7.904a1 1 0 0 1 1 1.483l-4.815 8.533a1 1 0 0 1-1.7.068l-1.72-2.551L15.468 10l-7.245 3.167-1.649-2.445a1 1 0 0 1 .7-1.55l9.716-1.268z" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-share"><path d="m12 8.805 2.503 2.544 1.396-1.4L10.95 5 6 9.95l1.42 1.4L10 8.71V16h2V8.805Zm9.405-3.385c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.708 3.385-3.765 4.574-1.438.572-4.062.823-6.64.846-2.578-.023-5.202-.297-6.64-.846C1.303 19.964.596 16.58.596 16.58.116 14.682-.02 12.715.002 11-.02 9.285.14 7.341.596 5.42c0 0 .707-3.385 3.764-4.574C5.798.297 8.422.023 11 0c2.578.023 5.202.297 6.64.846 3.057 1.19 3.765 4.574 3.765 4.574Z" fill="#FFF" fill-rule="nonzero" /></symbol><symbol  viewBox="0 0 24 24" id="pub-button-icon-show-more"><path d="M22.405 6.42c.456 1.921.616 3.865.593 5.58.023 1.715-.137 3.659-.593 5.58 0 0-.707 3.385-3.765 4.574-1.437.572-4.061.823-6.64.846-2.578-.023-5.202-.297-6.64-.846-3.057-1.189-3.765-4.574-3.765-4.574-.479-1.898-.616-3.865-.593-5.58-.023-1.715.137-3.659.593-5.58 0 0 .707-3.385 3.765-4.574C6.797 1.297 9.421 1.023 12 1c2.578.023 5.202.297 6.64.846 3.057 1.189 3.765 4.574 3.765 4.574zm-7.353 4.013-.03 2.569L17 13V7h-6l.014 1.994 2.691-.042-3.155 3.155 1.414 1.414 3.088-3.088zM9 15V7H7v10h10v-2H9z" /></symbol><symbol  viewBox="0 0 22 22" id="pub-button-icon-trash"><path d="M16.58 21.405c-1.921.456-3.865.616-5.58.593-1.715.023-3.659-.137-5.58-.593 0 0-3.385-.708-4.574-3.765C.274 16.202.023 13.578 0 11c.023-2.578.297-5.202.846-6.64C2.036 1.303 5.42.596 5.42.596 7.318.116 9.285-.02 11 .002c1.715-.022 3.659.137 5.58.594 0 0 3.385.707 4.574 3.764.549 1.438.823 4.062.846 6.64-.023 2.578-.297 5.202-.846 6.64-1.19 3.057-4.574 3.765-4.574 3.765ZM6 5a1 1 0 0 0-.98 1.19l1.94 10a1 1 0 0 0 .982.81h6.116a1 1 0 0 0 .982-.81l1.941-10A.999.999 0 0 0 15.999 5H6.001Zm6 6 2 2-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2 1 1-2 2Z" /></symbol><symbol viewBox="0 0 15 16"  id="pub-calendar"><g opacity=".8"><path d="M6.094 3.625c0-.345.28-.625.625-.625H8.28c.345 0 .625.28.625.625v1.563c0 .345-.28.625-.625.625H6.72a.625.625 0 0 1-.625-.625V3.625ZM2.5 7.219c0-.345.28-.625.625-.625h1.563c.345 0 .625.28.625.625V8.78c0 .345-.28.625-.625.625H3.125a.625.625 0 0 1-.625-.625V7.22ZM6.719 6.594a.625.625 0 0 0-.625.625V8.78c0 .345.28.625.625.625H8.28c.345 0 .625-.28.625-.625V7.22a.625.625 0 0 0-.625-.625H6.72ZM9.688 7.219c0-.345.28-.625.624-.625h1.563c.345 0 .625.28.625.625V8.78c0 .345-.28.625-.625.625h-1.563a.625.625 0 0 1-.624-.625V7.22ZM3.125 10.188a.625.625 0 0 0-.625.624v1.563c0 .345.28.625.625.625h1.563c.345 0 .625-.28.625-.625v-1.563a.625.625 0 0 0-.625-.624H3.125ZM6.094 10.813c0-.346.28-.626.625-.626H8.28c.345 0 .625.28.625.626v1.562c0 .345-.28.625-.625.625H6.72a.625.625 0 0 1-.625-.625v-1.563ZM10.313 3a.625.625 0 0 0-.626.625v1.563c0 .345.28.625.626.625h1.562c.345 0 .625-.28.625-.625V3.625A.625.625 0 0 0 11.875 3h-1.563Z" /></g></symbol><symbol viewBox="0 0 8 7"  id="pub-check-2"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.301 6.947C1.326 5.817.624 4.649 0 3.519a1.5 1.5 0 0 1 .507-.867c.078-.075.156-.113.312.038l1.443 1.582c.039.076.117.076.156 0C4.134 2.69 5.811.77 7.332.053c.078-.037.39-.075.429-.037.312.226.312.904.039 1.28-1.521 1.997-3.081 3.88-5.187 5.688-.117.038-.273 0-.312-.037Z" /></symbol><symbol  viewBox="0 0 7 7" id="pub-check"><path d="m6.145 1.147-3.63 3.64-1.66-1.664a.5.5 0 0 0-.708 0 .504.504 0 0 0 0 .71l2.014 2.02a.499.499 0 0 0 .708 0l3.984-3.995a.503.503 0 0 0 0-.71.5.5 0 0 0-.708 0z" /></symbol><symbol  viewBox="0 0 18 18" id="pub-check_circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0ZM4 9.192l1.127-1.127 2.508 2.508 4.2-5.609 1.276.955L7.808 13 4 9.192Z" /></symbol><symbol  viewBox="0 0 18 18" id="pub-check_circle_outline"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16Zm9-8A9 9 0 1 1 0 9a9 9 0 0 1 18 0ZM5.127 8.065 4 9.192 7.808 13l5.303-7.08-1.275-.956-4.201 5.61-2.508-2.509Z" /></symbol><symbol  viewBox="0 0 13 13" id="pub-check_code"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.164 10.924C2.824 9.31 1.858 7.64 1 6.027c.107-.538.375-.969.697-1.238.107-.107.215-.161.43.054l1.983 2.26c.054.108.161.108.215 0C6.685 4.843 8.99 2.1 11.08 1.076c.108-.054.537-.108.59-.054.43.323.43 1.292.054 1.83-2.092 2.852-4.236 5.543-7.132 8.126-.161.053-.376 0-.43-.054z" /></symbol><symbol  viewBox="0 0 16 16" id="pub-clock"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-2A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm1-7V4H7v5h5V7H9Z" fill="#000" fill-rule="nonzero" /></symbol><symbol  viewBox="0 0 7 7" id="pub-close"><path d="M7 .7 6.3 0 3.5 2.8.7 0 0 .7l2.8 2.8L0 6.3l.7.7 2.8-2.8L6.3 7l.7-.7-2.8-2.8L7 .7z" /></symbol><symbol fill="none"  viewBox="0 0 24 20" id="pub-codes"><path d="m11.283 3.374-5.28-.35-2.897 4.568 2.783 5.125 10.796 6.233 5.408-9.367L11.297 3.35l-.014.024ZM7.66 9.088a1.34 1.34 0 0 1-.495-1.847 1.34 1.34 0 0 1 1.847-.495c.656.379.873 1.191.495 1.847a1.339 1.339 0 0 1-1.847.495Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></symbol><symbol fill="none"  viewBox="0 0 15 15" id="pub-copy"><g stroke="currentColor" stroke-width="1.333" stroke-linecap="square"><path d="M12.817 5.667h-6c-.736 0-1.333.597-1.333 1.333v6c0 .736.597 1.333 1.333 1.333h6c.736 0 1.333-.597 1.333-1.333V7c0-.736-.597-1.333-1.333-1.333Z" /><path d="M2.817 9.667H2.15A1.333 1.333 0 0 1 .817 8.333v-6A1.333 1.333 0 0 1 2.15 1h6a1.333 1.333 0 0 1 1.334 1.333V3" /></g></symbol><symbol  viewBox="0 0 21 11" id="pub-editor-settings"><path d="m20.656 4.583-6.334 6.087c-.23.22-.53.33-.83.33-.3 0-.601-.11-.83-.33l-3.32-3.19a1.096 1.096 0 0 1 0-1.594 1.208 1.208 0 0 1 1.66 0l2.49 2.392 5.505-5.29a1.208 1.208 0 0 1 1.66 0 1.098 1.098 0 0 1 0 1.595zM4.894 2.22h1.158v5.814H4.62V5.815H2.585v.008h-1.16v2.211H0V2.227h1.151V1.114h1.158V0h1.426v1.1h1.16v1.12h-.001zm-.275.257H3.46v-1.1h-.883V2.49H1.426v1.956H3.46v-.008h1.16V2.476zm4.354 5.558H6.532V0h4.894v1.113h1.158v2.483h-1.158v.842h1.158v2.283l-1.108-1.065a1.769 1.769 0 0 0-.325-.244V4.71H7.958v1.954h.525c-.056.488.107.994.49 1.37zM7.958 3.332h3.192V1.377H7.958v1.955zm6.257 3.68.361-.348h-.079V5.551h-.008V1.377h3.194V2.49h1.325c.035-.02.071-.038.108-.055V1.114h-1.158V0h-3.744v1.114h-1.15v5.815h1.15v.082z" /></symbol><symbol fill="none"  viewBox="0 0 19 19" id="pub-embargo"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 18a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0 1a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z" fill="#A07368" /><path d="M9.5 4.75V9.5h4.75" stroke="currentColor" stroke-width="1.5" /></symbol><symbol viewBox="0 0 48 48"  id="pub-empty-document"><g fill-rule="evenodd"><path d="M12 16v20c0 1.105.896 1.998 2.001 1.998h19.997A1.999 1.999 0 0 0 36 36V10c0-1.104-.896-2-2.002-2H20l-8 8Zm9-5h11c.551 0 1 .449 1 1v21.998A1 1 0 0 1 32 35H16a1 1 0 0 1-1-1.002V17h6v-6Z" /></g></symbol><symbol  viewBox="0 0 512 512" id="pub-expand"><path d="M105.361 361.392 361.393 105.36l-73.388-73.359h191.996v191.996l-73.36-73.388-256.032 256.032 73.388 73.36H32.001V288.005l73.359 73.389z" /></symbol><symbol  viewBox="0 0 14 14" id="pub-extension"><path d="M6 7.003a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.004.5c.135-.139.125-.875-.005-1-.067-.065 3 0 3 0l.005-1.501c0-.11 2 2 2 2 .039.038-2 2.101-2 2l-.005-1.499s-3.06.067-2.995 0ZM5.383 9.596c.193-.003.707-.53.704-.71-.002-.094 2.12 2.12 2.12 2.12s.989-.98 1.066-1.058c.077-.077 0 2.829 0 2.829 0 .055-2.9.071-2.829 0l1.057-1.064S5.289 9.597 5.383 9.596Zm.709-4.469c-.003-.193-.53-.706-.71-.703-.093.001 2.12-2.121 2.12-2.121L6.446 1.238c-.078-.078 2.828 0 2.828 0 .055 0 .072 2.9 0 2.828L8.21 3.01S6.093 5.22 6.092 5.127Z" /><path d="M7.004 7.503c.135-.139.125-.875-.005-1-.067-.065 3 0 3 0l.005-1.501c0-.11 2 2 2 2 .039.038-2 2.101-2 2l-.005-1.499s-3.06.067-2.995 0ZM5.383 9.596c.193-.003.707-.53.704-.71-.002-.094 2.12 2.12 2.12 2.12s.989-.98 1.066-1.058c.077-.077 0 2.829 0 2.829 0 .055-2.9.071-2.829 0l1.057-1.064S5.289 9.597 5.383 9.596Zm.709-4.469c-.003-.193-.53-.706-.71-.703-.093.001 2.12-2.121 2.12-2.121L6.446 1.238c-.078-.078 2.828 0 2.828 0 .055 0 .072 2.9 0 2.828L8.21 3.01S6.093 5.22 6.092 5.127Z" /></symbol><symbol  viewBox="0 0 512 512" id="pub-eye"><path d="M256 416c-68.704 0-141.024-46.752-216.96-140.288-9.376-11.584-9.376-27.84 0-39.424C114.976 142.752 187.296 96 256 96s141.024 46.752 216.96 140.288c9.376 11.584 9.376 27.84 0 39.424C397.024 369.248 324.704 416 256 416zm0-64c55.04 0 99.648-42.976 99.648-96S311.04 160 256 160s-99.648 42.976-99.648 96S200.96 352 256 352zm0-32c-36.672 0-66.432-28.64-66.432-64s29.76-64 66.432-64 66.432 28.64 66.432 64-29.76 64-66.432 64z" /></symbol><symbol  viewBox="0 0 15 15" id="pub-list-arrow-closed"><path d="M7.5 15c-1.9 0-3.6-.2-4.5-.6-.7-.3-1.3-.8-1.8-1.4-.3-.4-.5-.7-.6-1.2-.1-.2-.1-.4-.2-.5C.1 10.2 0 8.9 0 7.5c0-1.3.1-2.6.4-3.8 0-.1.1-.3.2-.5.1-.5.3-.9.6-1.2C1.7 1.3 2.3.9 3 .6 3.9.2 5.6 0 7.5 0s3.6.2 4.5.6c.7.3 1.3.8 1.8 1.4.2.4.5.7.6 1.2.1.2.1.4.2.5.3 1.2.4 2.5.4 3.8 0 1.3-.1 2.6-.4 3.8 0 .1-.1.3-.2.5l-.6 1.2c-.5.7-1.1 1.1-1.8 1.4-.8.4-2.5.6-4.5.6zm0-14c-1.8 0-3.4.2-4.2.5-.5.2-.9.6-1.3 1.1-.2.3-.4.6-.5.9-.1.2-.1.3-.1.4C1.1 5 1 6.3 1 7.5c0 1.3.1 2.5.4 3.6 0 .1.1.2.1.4.1.3.3.7.5.9.4.5.8.9 1.3 1.1.8.3 2.4.5 4.2.5 1.8 0 3.4-.2 4.2-.5.5-.2 1-.6 1.3-1.1.2-.3.4-.6.5-.9.1-.2.1-.3.1-.4.3-1.1.4-2.4.4-3.6 0-1.2-.1-2.5-.4-3.6 0-.1-.1-.2-.1-.4-.1-.3-.3-.7-.5-.9-.4-.5-.8-.9-1.3-1.1-.8-.3-2.4-.5-4.2-.5z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 10 4 6h7z" /></symbol><symbol  viewBox="0 0 15 15" id="pub-list-arrow-opened"><g data-name="09-Sources-•-Edit-❇️"><path d="M7.5 15a14.82 14.82 0 0 1-4.5-.58A3.82 3.82 0 0 1 1.19 13a5.15 5.15 0 0 1-.62-1.16 4.12 4.12 0 0 1-.16-.54A14.52 14.52 0 0 1 0 7.5a15.22 15.22 0 0 1 .41-3.8 3.69 3.69 0 0 1 .16-.53A5 5 0 0 1 1.19 2 3.82 3.82 0 0 1 3 .58 14.92 14.92 0 0 1 7.5 0a14.87 14.87 0 0 1 4.5.58A3.82 3.82 0 0 1 13.81 2a5 5 0 0 1 .62 1.17 3.69 3.69 0 0 1 .16.53A15.17 15.17 0 0 1 15 7.5a15.35 15.35 0 0 1-.41 3.81 4.11 4.11 0 0 1-.16.52 5 5 0 0 1-.62 1.17A3.82 3.82 0 0 1 12 14.42a14.44 14.44 0 0 1-4.5.58zm0-14a14.43 14.43 0 0 0-4.17.51A2.9 2.9 0 0 0 2 2.58a3.81 3.81 0 0 0-.49.94 3.42 3.42 0 0 0-.13.39A15.56 15.56 0 0 0 1 7.5a13.8 13.8 0 0 0 .38 3.58 2.9 2.9 0 0 0 .13.4 4.19 4.19 0 0 0 .49.94 2.9 2.9 0 0 0 1.33 1.07A14.33 14.33 0 0 0 7.5 14a13.89 13.89 0 0 0 4.16-.51A2.88 2.88 0 0 0 13 12.42a4 4 0 0 0 .49-.94 3.42 3.42 0 0 0 .13-.39A15.56 15.56 0 0 0 14 7.5a15.21 15.21 0 0 0-.38-3.57 2.87 2.87 0 0 0-.13-.39 3.64 3.64 0 0 0-.49-.96 2.9 2.9 0 0 0-1.33-1.07A14.33 14.33 0 0 0 7.5 1z" /><path fill-rule="evenodd" d="m9.5 7.5-4 3.5V4l4 3.5z" /></g></symbol><symbol  viewBox="0 0 15 15" id="pub-list-bullet-arrow-down"><path d="M7.509 0c1.834.016 3.575.217 4.518.577l.003.001c.742.289 1.33.786 1.782 1.42a5.138 5.138 0 0 1 .781 1.694l.002.007c.29 1.222.42 2.526.404 3.794a15.784 15.784 0 0 1-.404 3.806c-.027.126-.08.31-.165.536-.15.396-.353.795-.618 1.168-.451.633-1.04 1.13-1.783 1.42-.932.37-2.64.56-4.529.577h-.009c-1.834-.016-3.574-.217-4.518-.577l-.003-.001c-.742-.289-1.33-.786-1.782-1.42a5.137 5.137 0 0 1-.78-1.687c-.3-1.197-.424-2.486-.406-3.808C-.015 6.226.115 4.923.405 3.7c.027-.126.08-.31.165-.536.15-.396.353-.795.618-1.168.452-.633 1.04-1.13 1.785-1.42l.003-.001C3.916.216 5.658.016 7.5 0h.009ZM3.334 1.51c-.54.21-.978.572-1.331 1.068a4.138 4.138 0 0 0-.621 1.336l-.003.013A14.778 14.778 0 0 0 1.002 7.5v.013c-.017 1.26.1 2.466.378 3.567l.003.01.002.01a4.138 4.138 0 0 0 .618 1.322c.353.496.792.858 1.328 1.067.767.292 2.352.494 4.165.511 1.878-.017 3.421-.212 4.165-.508h.004c.54-.211.979-.574 1.332-1.07a4.137 4.137 0 0 0 .621-1.336l.003-.013c.27-1.137.394-2.362.378-3.573v-.013a14.742 14.742 0 0 0-.378-3.56l-.001-.007-.005-.02a4.137 4.137 0 0 0-.618-1.322c-.353-.496-.792-.858-1.328-1.067-.766-.293-2.351-.495-4.164-.511-1.823.016-3.408.219-4.17.51Z" /><path d="M7.5 10 4 6h7l-3.5 4Z" /></symbol><symbol viewBox="0 0 52 52"  id="pub-loupe"><path d="M52 45.24 38.132 31.473a20.271 20.271 0 0 0 3.203-10.961C41.337 9.204 32.064 0 20.667 0 9.271 0 0 9.204 0 20.514 0 31.826 9.27 41.03 20.667 41.03c3.86 0 7.468-1.055 10.563-2.888L45.192 52 52 45.24ZM7.701 20.514c0-7.091 5.817-12.866 12.964-12.866 7.149 0 12.966 5.772 12.966 12.866 0 7.096-5.817 12.868-12.966 12.868-7.147 0-12.964-5.772-12.964-12.868Z" /></symbol><symbol  viewBox="0 0 16 16" id="pub-magic-wand"><path d="M4.951 2.743 6.856 3.81 5.79 1.905 6.856 0 4.951 1.067 3.047 0l1.066 1.905L3.047 3.81 4.95 2.743zm9.143 7.467L12.19 9.143l1.066 1.905-1.066 1.904 1.904-1.066L16 12.952l-1.067-1.904L16 9.143l-1.905 1.066zM15.999 0l-1.905 1.067L12.19 0l1.066 1.905L12.19 3.81l1.904-1.067L16 3.81l-1.067-1.905L16 0zm-5.79 4.038a.737.737 0 0 0-1.067 0L.228 12.952a.737.737 0 0 0 0 1.067l1.752 1.752a.737.737 0 0 0 1.067 0l8.914-8.914a.736.736 0 0 0 0-1.067l-1.752-1.752zm-.839 4.19-1.6-1.6L9.6 4.8l1.6 1.6-1.83 1.829z" /></symbol><symbol  viewBox="0 0 768 768" id="pub-menu-button-settings"><path d="M767.927 384c.796-59.875-4.779-127.735-20.71-194.794 0 0-24.692-118.154-131.425-159.667C565.611 10.379 474.01.798 384.005 0c-90.006.798-181.606 10.378-231.786 29.539C45.485 71.052 20.793 189.206 20.793 189.206 4.863 256.266-.712 324.125.084 384c-.796 59.876 3.982 128.533 20.709 194.794 0 0 24.692 118.154 131.426 159.668 50.18 19.159 141.779 28.74 231.786 29.539 90.006-.799 181.607-9.58 231.787-29.539 106.733-41.513 131.425-159.668 131.425-159.668 15.931-67.06 21.505-134.919 20.71-194.794zM631.39 346.287c7.416 0 15.992 5.527 16.82 12.882 2.215 19.815 2.188 39.826-.116 59.499-.91 7.658-7.812 13.435-15.313 12.826l-3.236-.083c-23.128 0-44.63 14.248-53.524 35.467-9.46 22.541-3.55 48.777 14.659 65.267 5.711 5.167 6.392 13.889 1.564 19.883a260.485 260.485 0 0 1-42.326 41.845c-6.025 4.655-14.573 3.976-19.746-1.651-15.566-17.099-43.264-23.536-64.796-14.742-22.273 9.12-36.675 31.546-35.797 55.793.255 7.612-5.365 14.146-12.953 14.983a259.553 259.553 0 0 1-28.72 1.591c-10.085 0-20.144-.582-30.141-1.749-7.641-.88-13.293-7.583-12.84-15.282 1.39-24.515-12.815-47.339-35.397-56.785-21.559-9.049-49.57-2.642-65.224 14.672-5.196 5.726-13.918 6.407-19.913 1.577a259.833 259.833 0 0 1-41.39-41.874c-4.717-5.978-4.006-14.572 1.591-19.714 17.896-16.405 23.776-42.395 14.63-64.695-9.175-22.328-31.05-36.433-53.833-35.852-7.498 0-16.335-5.479-17.156-12.865-2.216-19.815-2.189-39.843.112-59.499.907-7.541 6.817-13.11 15.113-12.843 25.565 0 47.897-13.859 56.928-35.365 9.46-22.556 3.58-48.789-14.63-65.279-5.68-5.168-6.391-13.877-1.561-19.886 12.385-15.454 26.646-29.542 42.326-41.844 5.993-4.67 14.6-3.977 19.745 1.661 15.563 17.117 43.379 23.482 64.766 14.746 22.303-9.135 36.678-31.561 35.826-55.821-.255-7.599 5.369-14.132 12.955-14.969a261.207 261.207 0 0 1 58.859.155c7.673.894 13.298 7.585 12.84 15.281-1.39 24.501 12.814 47.327 35.341 56.801 21.646 9.032 49.658 2.613 65.254-14.658 5.171-5.725 13.92-6.391 19.883-1.606 15.23 12.2 29.177 26.275 41.448 41.858 4.717 5.978 4.034 14.586-1.591 19.727-17.869 16.391-23.746 42.398-14.631 64.696 8.922 21.773 30.199 35.851 54.176 35.851zm-330.024 42.487c0 48.123 39.145 87.267 87.269 87.267 48.122 0 87.267-39.143 87.267-87.267 0-48.121-39.145-87.267-87.267-87.267-48.124 0-87.269 39.146-87.269 87.267z" /></symbol><symbol viewBox="0 0 13 3"  id="pub-menu-no-border"><path d="M2.919.74S2.822.277 2.405.114C2.21.041 1.852.003 1.5 0 1.148.003.79.04.595.115.178.278.08.74.08.74a3.156 3.156 0 0 0-.08.761c-.004.234.015.502.08.76 0 0 .097.462.514.625.196.074.553.112.905.115.352-.003.71-.037.905-.115.417-.163.514-.624.514-.624.062-.262.084-.527.08-.761a3.156 3.156 0 0 0-.08-.76ZM7.919.74S7.822.277 7.405.114C7.21.041 6.852.003 6.5 0c-.352.003-.71.04-.905.115C5.178.278 5.08.74 5.08.74a3.156 3.156 0 0 0-.08.761c-.004.234.015.502.08.76 0 0 .097.462.514.625.196.074.553.112.905.115.352-.003.71-.037.905-.115.417-.163.514-.624.514-.624.062-.262.084-.527.08-.761a3.156 3.156 0 0 0-.08-.76ZM12.919.74s-.097-.462-.514-.625C12.21.041 11.852.003 11.5 0c-.352.003-.71.04-.905.115-.417.163-.514.624-.514.624a3.158 3.158 0 0 0-.08.761c-.004.234.015.502.08.76 0 0 .097.462.514.625.196.074.553.112.905.115.352-.003.71-.037.905-.115.417-.163.514-.624.514-.624.062-.262.084-.527.08-.761a3.158 3.158 0 0 0-.08-.76Z" /></symbol><symbol fill="none"  viewBox="0 0 15 16" id="pub-menu"><path d="m14.3 4.257.002.008a15.48 15.48 0 0 1 .397 3.731v.008c.015 1.149-.092 2.45-.397 3.731l-.002.008v.003l-.004.016a4.006 4.006 0 0 1-.094.32 4.99 4.99 0 0 1-.371.83c-.36.642-.956 1.36-1.913 1.731l-.002.001c-.922.367-2.659.54-4.416.556-1.753-.016-3.493-.204-4.419-.557-.956-.372-1.551-1.09-1.912-1.73a4.993 4.993 0 0 1-.448-1.085 2.511 2.511 0 0 1-.017-.066L.7 11.746v-.003l-.003-.012C.379 10.47.287 9.156.302 8.004v-.008c-.016-1.149.091-2.45.396-3.731L.7 4.257v-.003l.004-.016.017-.066a4.996 4.996 0 0 1 .449-1.085c.36-.64.955-1.358 1.91-1.73C4.008 1.004 5.748.816 7.5.8c1.753.016 3.493.204 4.42.557.955.372 1.55 1.09 1.91 1.73a4.991 4.991 0 0 1 .45 1.085l.016.066.004.016v.003Z" stroke="currentColor" /><path d="M5.246 7.493s-.065-.308-.343-.416c-.13-.05-.369-.075-.603-.077-.235.002-.473.027-.604.077-.278.108-.342.416-.342.416A2.104 2.104 0 0 0 3.3 8c-.002.156.01.335.054.507 0 0 .064.308.342.416.13.05.37.075.604.077.234-.002.473-.025.603-.077.278-.108.343-.416.343-.416.041-.174.056-.351.054-.507a2.103 2.103 0 0 0-.054-.507ZM8.446 7.493s-.064-.308-.342-.416c-.13-.05-.37-.075-.604-.077-.234.002-.473.027-.603.077-.278.108-.343.416-.343.416A2.104 2.104 0 0 0 6.5 8c-.002.156.01.335.054.507 0 0 .065.308.343.416.13.05.369.075.603.077.235-.002.473-.025.604-.077.278-.108.342-.416.342-.416.042-.174.056-.351.054-.507a2.103 2.103 0 0 0-.054-.507ZM11.646 7.493s-.064-.308-.342-.416c-.13-.05-.37-.075-.604-.077-.234.002-.473.027-.603.077-.278.108-.342.416-.342.416A2.103 2.103 0 0 0 9.7 8c-.002.156.01.335.054.507 0 0 .064.308.342.416.13.05.37.075.604.077.234-.002.472-.025.603-.077.278-.108.342-.416.342-.416.042-.174.056-.351.054-.507a2.101 2.101 0 0 0-.054-.507Z" fill="#000" /></symbol><symbol  viewBox="0 0 480 480" id="pub-minus"><path d="M467.008 118.24c9.952 41.92 13.44 84.352 12.96 121.76.48 37.408-3.008 79.84-12.96 121.728 0 0-15.424 73.856-82.144 99.808C353.504 474.016 296.256 479.488 240 480c-56.256-.512-113.504-6.496-144.864-18.464-66.688-25.952-82.112-99.808-82.112-99.808C2.528 320.32-.416 277.408.064 240c-.48-37.408 2.976-79.84 12.96-121.76 0 0 15.424-73.856 82.112-99.776C126.496 6.464 183.744.512 240 0c56.256.512 113.504 6.464 144.864 18.464 66.72 25.92 82.144 99.776 82.144 99.776zM352 224H128v32h224v-32z" /></symbol><symbol  viewBox="0 0 512 512" id="pub-narrow"><path d="M480 224.008H287.991V32L480 224.008zM32 287.991h192.008V480L32 287.991z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-announcement"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.611 13.056 17 15H3l1.389-1.944L6 4l4-1 4 1 1.611 9.056ZM8 16h4v1l-4 1v-2Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-comment"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 8V6H9v2H7v1h2v2h1V9h2V8h-2Zm-4 6-3 3V4l13-1v11H6Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-express"><path fill-rule="evenodd" clip-rule="evenodd" d="m4 5.5 12-3v3l-12 2v-2Zm0 5 12-3v3l-12 2v-2Zm0 5 12-3v3l-12 2v-2Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-flash"><path fill-rule="evenodd" clip-rule="evenodd" d="m15 7-4.5 1.5L11 2 4 13l4.5-1.5L8 18l7-11Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-issue"><path d="M9 3H5v14l10-1V7l-5-4v5l5-1v1L9 9V3Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-news"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 3 3 4v13l14-1V3Zm-2 3L5 7v1l10-1V6ZM5 10l10-1v1L5 11v-1Zm10 2L5 13v1l10-1v-1Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-press_release"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 9.467v.47l-1 .066v1.067l1-.067v.864l-1 .066V13l1-.067v1.2l1-.066v-1.2l3-.2V11.6l-3 .2v-.863l3-.2v-.004l1-.066V6l-5 .333v3.134ZM3 4l14-1v13L3 17V4Zm6 3.269 3-.2V9.73l-3 .2V7.27Z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-review"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 14.382 4.997 18l1.765-6.062L1.905 8.11l6.094-.129L10 2l2.001 5.982 6.094.13-4.857 3.826L15.003 18 10 14.382Z" /></symbol><symbol  viewBox="0 0 14 14" id="pub-newstype-service_message"><path class="st0" d="M7 1.6C4 1.6 1.6 4 1.6 7S4 12.4 7 12.4 12.4 10 12.4 7 10 1.6 7 1.6zm.5 8.1h-1V6.5h1.1v3.2zm0-4.3h-1V4.3h1.1v1.1z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-newstype-summary"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4h5v5H4V4Zm0 7h5v5H4v-5Zm7-7h5v12h-5V4Z" /></symbol><symbol viewBox="0 0 14 14" fill="none"  id="pub-palette"><path d="M14 7a7.002 7.002 0 0 0-2.05-4.95L7 7h7Z" fill="#F2E454" /><path d="M14 7a7.002 7.002 0 0 1-2.05 4.95L7 7h7Z" fill="#C2D765" /><path d="M11.95 11.95A6.998 6.998 0 0 1 7 14V7l4.95 4.95Z" fill="#81BE9F" /><path d="M2.05 11.95A7 7 0 0 0 7 14V7l-4.95 4.95Z" fill="#789FD1" /><path d="M0 7a7 7 0 0 0 2.05 4.95L7 7H0Z" fill="#9E8EBF" /><path d="M2.05 2.05A7 7 0 0 0 0 7h7L2.05 2.05Z" fill="#CB87A4" /><path d="M2.05 2.05A7 7 0 0 1 7 0v7L2.05 2.05Z" fill="#E37D66" /><path d="M11.95 2.05A7 7 0 0 0 7 0v7l4.95-4.95Z" fill="#EEAC4D" /></symbol><symbol  viewBox="0 0 19 15" id="pub-play-sound"><path d="M9.42 14.822c.549 0 .939-.39.939-.93V1.16c0-.54-.39-.98-.955-.98-.39 0-.647.175-1.07.573l-3.545 3.32a.29.29 0 0 1-.207.075H2.208c-1.13 0-1.735.623-1.735 1.818v3.088c0 1.204.606 1.818 1.735 1.818h2.374a.29.29 0 0 1 .207.075l3.545 3.353c.373.366.697.523 1.087.523Zm6.982-1.627c.307.208.689.133.913-.182C18.377 11.552 19 9.543 19 7.493c0-2.05-.614-4.076-1.685-5.52-.224-.316-.606-.39-.913-.183-.307.208-.357.598-.116.938.904 1.278 1.427 2.997 1.427 4.765 0 1.768-.54 3.47-1.427 4.764-.233.34-.191.73.116.938ZM13.33 11.03c.274.19.664.133.888-.191.639-.838 1.02-2.075 1.02-3.345s-.381-2.499-1.02-3.346c-.224-.323-.614-.39-.888-.19-.34.232-.39.647-.133.987.481.664.755 1.586.755 2.549 0 .963-.282 1.876-.755 2.548-.25.349-.208.747.133.988Z" /></symbol><symbol  viewBox="0 0 480 480" id="pub-plus"><path d="M352 224H128v32h224v-32z" /><path d="M224 128v224h32V128h-32z" /><path d="M32.064 233.28c-.128-36.288 3.904-72.448 12.064-107.744 1.024-4.352 2.368-8.736 4.032-12.864 4.064-10.752 9.408-20.96 16.032-30.24C74.688 67.2 89.504 55.328 106.528 48.384c17.472-5.952 35.584-9.856 53.856-11.424 26.528-3.264 53.088-4.832 79.712-4.928 26.56.096 53.088 1.664 79.552 4.928 18.368 1.568 36.48 5.472 53.856 11.424 17.12 7.072 31.776 18.816 42.336 34.048 6.592 9.28 11.968 19.488 16 30.24 1.568 4.032 2.912 8.16 3.904 12.448v.32l.128.096a470.634 470.634 0 0 1 12.096 107.424v13.76c.224 36.288-3.936 72.448-12.096 107.744-1.024 4.352-2.336 8.736-4.032 12.864-4.032 10.752-9.408 20.96-16 30.24-10.56 15.232-25.312 27.104-42.464 34.048-17.12 6.176-34.944 9.952-52.96 11.52-26.752 3.168-53.632 4.736-80.512 4.832-26.56-.096-53.088-1.664-79.52-4.928-18.368-1.568-36.512-5.472-53.856-11.424-17.152-7.04-31.84-18.816-42.336-34.048-6.624-9.28-11.968-19.488-16.032-30.24-1.664-4.128-2.912-8.288-3.904-12.544C35.744 319.84 31.712 284 32.064 248.064V233.28zM467.008 118.4l-.128-.352v-.128c-1.216-5.696-3.008-11.296-5.152-16.8-5.024-13.088-11.52-25.632-19.68-37.056-14.24-20.48-34.176-36.384-57.248-45.568a264.156 264.156 0 0 0-61.792-13.44A726.607 726.607 0 0 0 240.096 0a726.832 726.832 0 0 0-82.976 5.056c-21.056 1.984-41.76 6.368-61.792 13.312-23.2 9.312-43.104 25.216-57.344 45.696-8.064 11.424-14.688 23.968-19.712 37.056-2.144 5.6-3.904 11.456-5.28 17.28C4.288 156.096-.096 194.656.032 233.376v.128l.096 6.72-.096 7.488A469.304 469.304 0 0 0 13.12 362.176c1.344 5.6 3.008 11.2 5.28 16.704a164.308 164.308 0 0 0 19.584 37.056c14.24 20.48 34.144 36.384 57.344 45.6a265.211 265.211 0 0 0 61.696 13.44c27.552 3.232 55.2 4.928 82.88 5.024 27.968-.096 56-1.792 83.776-5.024 20.8-1.792 41.312-6.272 61.024-13.44 23.168-9.216 43.104-25.12 57.344-45.6 8.16-11.424 14.752-23.968 19.68-37.056a129.729 129.729 0 0 0 5.28-17.28c8.832-37.696 13.088-76.224 12.992-114.976v-.128l-.096-6.72.096-6.72A500.846 500.846 0 0 0 467.008 118.4z" /></symbol><symbol  viewBox="0 0 38 20" id="pub-quick-actions-asoiNotes"><path fill-rule="evenodd" clip-rule="evenodd" d="M36 1H2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h34a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" /><path d="M9.186 11.594h-2.75L5.837 13H4.435L7.33 6.335h1.03L11.266 13H9.78l-.595-1.406zM6.91 10.485h1.807l-.581-1.381-.298-.855h-.04l-.302.864-.586 1.372zm10.738 2.012a4.426 4.426 0 0 1-.616.293 5.891 5.891 0 0 1-.62.195 4.525 4.525 0 0 1-1.098.147c-.215 0-.44-.01-.674-.03a3.818 3.818 0 0 1-1.372-.332 2.422 2.422 0 0 1-.596-.385 3.096 3.096 0 0 1-.806-1.094 3.767 3.767 0 0 1-.23-.737 4.568 4.568 0 0 1-.077-.874c0-.498.083-.956.249-1.372.169-.417.423-.793.761-1.128a2.82 2.82 0 0 1 .542-.415c.199-.118.41-.214.635-.288a4.845 4.845 0 0 1 1.46-.225 5.334 5.334 0 0 1 2.344.537l-.405 1.191a4.406 4.406 0 0 0-.933-.376 3.59 3.59 0 0 0-.952-.126c-.296 0-.583.037-.86.112-.276.075-.52.215-.732.42-.189.185-.34.421-.454.708a2.58 2.58 0 0 0-.171.962c0 .37.059.708.176 1.01.12.303.288.544.503.723.123.104.247.189.37.254a2.191 2.191 0 0 0 .831.215c.156.013.324.02.503.02a2.94 2.94 0 0 0 .947-.157c.16-.049.313-.106.459-.17.15-.07.29-.142.42-.22l.396 1.142zM18.756 9.7c0-.548.08-1.034.24-1.46.159-.43.383-.792.673-1.085a2.914 2.914 0 0 1 1.05-.669 3.76 3.76 0 0 1 1.357-.234c.527 0 .996.083 1.406.249.414.166.764.4 1.05.703.287.303.505.666.654 1.089.15.42.225.885.225 1.396 0 .515-.075.983-.225 1.407-.15.423-.367.786-.654 1.089a2.922 2.922 0 0 1-1.05.703 3.72 3.72 0 0 1-1.406.249 3.83 3.83 0 0 1-1.357-.23 2.968 2.968 0 0 1-1.05-.674 3.011 3.011 0 0 1-.674-1.079 4.134 4.134 0 0 1-.24-1.455zm1.48-.01c0 .38.043.71.131.99.088.28.212.512.371.694.163.182.357.317.581.405.228.088.48.132.757.132.316 0 .59-.057.82-.17.235-.115.427-.27.577-.47a1.96 1.96 0 0 0 .337-.703 3.32 3.32 0 0 0 .112-.879c0-.312-.038-.603-.112-.874a1.91 1.91 0 0 0-.337-.698 1.567 1.567 0 0 0-.576-.469 1.836 1.836 0 0 0-.82-.17c-.278 0-.53.043-.758.131a1.504 1.504 0 0 0-.58.406c-.16.182-.284.413-.372.693a3.255 3.255 0 0 0-.132.981zm11.088-.342.064-.791h-.035l-.483.786L28.038 13h-1.035V6.379h1.396v3.564l-.083.835h.05l.512-.815 2.798-3.584h1.055V13h-1.407V9.348z" /></symbol><symbol  viewBox="0 0 39 19" id="pub-quick-actions-asoiNotesEmbargo"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.4 17.845a8.345 8.345 0 1 0 0-16.69 8.345 8.345 0 0 0 0 16.69Zm0 1.155a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M9.534 4.75h1.732v3.884h3.884v1.732H9.534V4.75ZM24.29 8.328 27.917.632h.837l3.638 7.696h-1.596l-.871-1.862h-3.231l-.87 1.862H24.29Zm4.075-5.196-.057-.164-.065.185-.924 1.979h1.98l-.934-2Zm10.532 4.37-.163.119a3.62 3.62 0 0 1-.484.287l-.002.001a5.113 5.113 0 0 1-.666.27 5.564 5.564 0 0 1-.832.203 5.432 5.432 0 0 1-.965.083 4.23 4.23 0 0 1-1.407-.234 3.27 3.27 0 0 1-1.183-.725l-.001-.001a3.502 3.502 0 0 1-.807-1.233V6.27c-.196-.5-.29-1.081-.29-1.74 0-.46.05-.881.15-1.258v-.003c.103-.37.243-.705.42-.999a3.25 3.25 0 0 1 .635-.765c.24-.21.497-.38.773-.513.275-.134.56-.233.851-.297.292-.063.583-.094.87-.094a5.81 5.81 0 0 1 1.729.252 4.044 4.044 0 0 1 1.067.496l.166.12-.623 1.255-.23-.153a3.429 3.429 0 0 0-.332-.19l-.002-.002a3.174 3.174 0 0 0-.453-.19h-.001a4.031 4.031 0 0 0-.574-.148 3.58 3.58 0 0 0-.669-.059c-.277 0-.55.045-.82.135a1.886 1.886 0 0 0-.702.423c-.2.192-.37.449-.502.78-.125.316-.193.717-.193 1.21 0 .438.063.813.183 1.13.126.317.293.578.5.785.21.206.456.363.74.47.284.108.593.162.925.162.154 0 .326-.012.515-.039.19-.03.379-.071.569-.125.19-.052.374-.118.547-.197a1.92 1.92 0 0 0 .429-.26l.24-.197.592 1.243ZM24.22 13.771v-.002c0-.6.076-1.144.232-1.627.16-.485.39-.902.695-1.245.308-.347.686-.61 1.128-.788.443-.181.942-.27 1.492-.27.594 0 1.121.094 1.574.288a2.97 2.97 0 0 1 1.123.822c.297.35.513.77.65 1.253.14.476.21 1 .21 1.567 0 .6-.078 1.146-.238 1.633a3.43 3.43 0 0 1-.694 1.25l-.001.001a3.044 3.044 0 0 1-1.133.786 3.98 3.98 0 0 1-1.491.265h-.002c-.588-.004-1.109-.099-1.558-.293a3 3 0 0 1-1.117-.816 3.43 3.43 0 0 1-.656-1.252 5.706 5.706 0 0 1-.214-1.572Zm5.429 1.062c.072-.323.11-.677.11-1.064 0-.427-.046-.8-.134-1.121a2.224 2.224 0 0 0-.382-.8l-.001-.003a1.552 1.552 0 0 0-.605-.477 2.084 2.084 0 0 0-.87-.167c-.388 0-.696.07-.936.197h-.002c-.249.13-.447.305-.598.526a2.32 2.32 0 0 0-.341.813c-.073.32-.11.664-.11 1.032 0 .41.045.774.133 1.095.088.321.215.587.378.803.166.215.369.379.61.495.241.115.528.176.866.176.393 0 .705-.066.946-.185a1.56 1.56 0 0 0 .6-.514c.155-.221.268-.488.335-.804v-.002Zm7.451-2.092v4.826h1.497V9.971h-.992l-3.608 4.808-.025.039V9.97h-1.503v7.596h.988l3.618-4.787.025-.039Z" /></symbol><symbol  viewBox="0 0 19 19" id="pub-quick-actions-awaitingPublication"><path d="M10.25 8.75v-4h-1.5v5.5h5.5v-1.5h-4z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.5a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0zm-1 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z" /></symbol><symbol  viewBox="0 0 15 20" id="pub-quick-actions-flash"><path fill-rule="evenodd" clip-rule="evenodd" d="m7.914.728.917.322-.604 6.043 5.795-.725-8.606 12.91-.906-.376 1.213-6.069H.081L7.914.728zM1.919 11.833h5.024l-.957 4.787 5.992-8.988-4.871.609.523-5.234-5.71 8.826z" /></symbol><symbol  viewBox="0 0 25 16" id="pub-quick-actions-monitoring"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.01 16C6.945 16 2.424 11.789 0 7.576 2.418 3.473 6.943 0 12.01 0c5.135 0 9.635 3.453 11.999 7.564C21.768 11.994 17.283 16 12.01 16zM1.168 7.584C2.011 8.915 6.186 15 12.01 15c6.305 0 10.112-6.103 10.851-7.405C22.089 6.397 18.255 1 12.01 1 5.894 1 1.985 6.355 1.168 7.584z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" /></symbol><symbol  viewBox="0 0 18.5 15" id="pub-quick-actions-originals"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 .8H1.5c-.4 0-.8.3-.8.8v12c0 .4.3.8.8.8H17c.4 0 .8-.3.8-.8v-12c0-.5-.4-.8-.8-.8zM1.5 0C.7 0 0 .7 0 1.5v12c0 .8.7 1.5 1.5 1.5H17c.8 0 1.5-.7 1.5-1.5v-12C18.5.7 17.8 0 17 0H1.5zm0 0" /><path d="M8.6 10H7.5V5.6H6.2l-.1.5c-.1 1.2-.3 2.1-.4 2.6-.1.5-.3.8-.5 1-.2.2-.5.3-.9.3-.2 0-.4 0-.5-.1V9c.1 0 .3.1.4.1.1 0 .2-.1.3-.2.1-.1.1-.3.2-.7.1-.2.2-.7.3-1.5s.2-1.4.3-2h3.3V10zM14.7 7.3c0 .9-.2 1.5-.7 2-.4.5-1 .7-1.8.7s-1.4-.2-1.9-.7c-.4-.5-.7-1.1-.7-2 0-.9.2-1.6.7-2 .4-.5 1.1-.7 1.9-.7s1.4.2 1.9.7c.4.5.6 1.1.6 2zm-3.8 0c0 .6.1 1 .3 1.3s.6.4 1 .4c.9 0 1.3-.6 1.3-1.8 0-1.2-.4-1.8-1.3-1.8-.4 0-.8.2-1 .5-.2.4-.3.8-.3 1.4z" /></symbol><symbol  viewBox="0 0 20 20" id="pub-quick-actions-published"><path d="M4 5h12v2H4V5zm0 4h12v2H4V9zm12 4H4v2h12v-2z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M0 2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm2-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" /></symbol><symbol viewBox="0 0 16 20"  id="pub-recycle-bin"><path d="M4.772 6.897c.232 0 .421.195.421.435v7.826c0 .24-.189.435-.421.435a.428.428 0 0 1-.421-.435V7.332c0-.24.189-.435.421-.435ZM11.257 6.897c.233 0 .421.195.421.435v7.826c0 .24-.188.435-.42.435a.428.428 0 0 1-.422-.435V7.332c0-.24.189-.435.421-.435Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M.842 18.696V3.478H0v-.87h5.053V.87c0-.48.378-.87.842-.87h4.21c.463 0 .842.39.842.87v1.739H16v.87h-.842v15.217c0 .72-.566 1.304-1.263 1.304H2.105c-.697 0-1.263-.584-1.263-1.304Zm13.474-.435V3.478H1.684v14.783c0 .48.377.87.842.87h10.948c.465 0 .842-.39.842-.87Zm-4.21-15.652V.869H5.894v1.74h4.21Z" /><path d="M8.047 6.897c.232 0 .42.195.42.435v7.826c0 .24-.188.435-.42.435a.428.428 0 0 1-.421-.435V7.332c0-.24.189-.435.42-.435Z" /></symbol><symbol  viewBox="0 0 16 13" id="pub-refresh"><path d="M16 6h-5l2.5 3L16 6z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M10.84.845C12.849 2.047 14 4.31 14 6.1h-1.02c0-1.39-.937-3.313-2.648-4.337C8.673.771 6.21.588 3.077 2.827L2.5 1.954C5.89-.47 8.778-.39 10.84.844z" /><path d="M0 7h5L2.5 4 0 7z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M5.16 12.155C3.15 10.954 2 8.69 2 6.9h1.019c0 1.39.938 3.313 2.65 4.337 1.657.992 4.12 1.175 7.253-1.064l.578.873c-3.391 2.424-6.278 2.343-8.34 1.11z" /></symbol><symbol  viewBox="0 0 13 10" id="pub-reload"><path d="M9.514 4.949V5A4.757 4.757 0 1 1 7.34 1.004l-.862 1.331a3.171 3.171 0 1 0 1.444 2.45L6.394 6.315 5.272 5.192 8.636 1.83 12 5.192l-1.121 1.122-1.365-1.365Z" /></symbol><symbol viewBox="0 0 14 14" fill="none"  id="pub-republish-active"><path d="m5 6.481 2.5 2.5 5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M10.024 2.324a.4.4 0 0 0-.098-.685L6.389.222a.4.4 0 0 0-.545.428l.131.915a6 6 0 1 0 6.996 6.147 1 1 0 0 0-1.998-.077 4 4 0 1 1-4.713-4.09l.126.877a.4.4 0 0 0 .643.257l2.995-2.355Z" fill="#47DE00" /></symbol><symbol viewBox="0 0 13 15" fill="none"  id="pub-republish-none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.276 2.806a.4.4 0 0 0-.098-.686L5.64.703a.4.4 0 0 0-.544.428l.131.915a6 6 0 1 0 6.996 6.148 1 1 0 0 0-1.999-.078 4 4 0 1 1-4.712-4.09l.126.877a.4.4 0 0 0 .643.258l2.995-2.355Z" fill="#000" /><circle cx="6.5" cy="7.981" r="1.5" fill="#000" /></symbol><symbol viewBox="0 0 13 14" fill="none"  id="pub-republish-work"><path d="m7.5 8.481 3.751-5.519" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M9.275 2.806a.4.4 0 0 0-.098-.686L5.64.703a.4.4 0 0 0-.545.428l.131.915a6 6 0 1 0 6.996 6.147 1 1 0 0 0-1.998-.077 4 4 0 1 1-4.713-4.09l.126.877a.4.4 0 0 0 .643.258l2.995-2.355Z" fill="#F90" /><circle cx="5" cy="8.481" r="1" fill="#F90" /></symbol><symbol fill="none"  viewBox="0 0 20 18" id="pub-send"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 0v6C4.22 7.13 1.11 12.33 0 18c2.78-3.97 6.44-6 12-6v6l8-9-8-9Z" fill="currentColor" /></symbol><symbol  viewBox="0 0 480 480" id="pub-source-leaf-icon-inverted"><path d="m467.008 118.4-.128-.352v-.128c-1.216-5.696-3.008-11.296-5.152-16.8-5.024-13.088-11.52-25.632-19.68-37.056-14.24-20.48-34.176-36.384-57.248-45.568a264.156 264.156 0 0 0-61.792-13.44A726.607 726.607 0 0 0 240.096 0a726.832 726.832 0 0 0-82.976 5.056c-21.056 1.984-41.76 6.368-61.792 13.312-23.2 9.312-43.104 25.216-57.344 45.696-8.064 11.424-14.688 23.968-19.712 37.056-2.144 5.6-3.904 11.456-5.28 17.28C4.288 156.096-.096 194.656.032 233.376v.128l.096 6.72-.096 7.488A469.304 469.304 0 0 0 13.12 362.176c1.344 5.6 3.008 11.2 5.28 16.704a164.308 164.308 0 0 0 19.584 37.056c14.24 20.48 34.144 36.384 57.344 45.6a265.211 265.211 0 0 0 61.696 13.44c27.552 3.232 55.2 4.928 82.88 5.024 27.968-.096 56-1.792 83.776-5.024 20.8-1.792 41.312-6.272 61.024-13.44 23.168-9.216 43.104-25.12 57.344-45.6 8.16-11.424 14.752-23.968 19.68-37.056a129.729 129.729 0 0 0 5.28-17.28c8.832-37.696 13.088-76.224 12.992-114.976v-.128l-.096-6.72.096-6.72A500.846 500.846 0 0 0 467.008 118.4zM160 240c0-44.16 35.84-80 80-80s80 35.84 80 80-35.84 80-80 80-80-35.84-80-80z" /></symbol><symbol  viewBox="0 0 480 480" id="pub-source-leaf-icon"><path d="M160 240c0-44.16 35.84-80 80-80s80 35.84 80 80-35.84 80-80 80-80-35.84-80-80z" /><path d="M32.064 233.28c-.128-36.288 3.904-72.448 12.064-107.744 1.024-4.352 2.368-8.736 4.032-12.864 4.064-10.752 9.408-20.96 16.032-30.24C74.688 67.2 89.504 55.328 106.528 48.384c17.472-5.952 35.584-9.856 53.856-11.424 26.528-3.264 53.088-4.832 79.712-4.928 26.56.096 53.088 1.664 79.552 4.928 18.368 1.568 36.48 5.472 53.856 11.424 17.12 7.072 31.776 18.816 42.336 34.048 6.592 9.28 11.968 19.488 16 30.24 1.568 4.032 2.912 8.16 3.904 12.448v.32l.128.096a470.634 470.634 0 0 1 12.096 107.424v13.76c.224 36.288-3.936 72.448-12.096 107.744-1.024 4.352-2.336 8.736-4.032 12.864-4.032 10.752-9.408 20.96-16 30.24-10.56 15.232-25.312 27.104-42.464 34.048-17.12 6.176-34.944 9.952-52.96 11.52-26.752 3.168-53.632 4.736-80.512 4.832-26.56-.096-53.088-1.664-79.52-4.928-18.368-1.568-36.512-5.472-53.856-11.424-17.152-7.04-31.84-18.816-42.336-34.048-6.624-9.28-11.968-19.488-16.032-30.24-1.664-4.128-2.912-8.288-3.904-12.544C35.744 319.84 31.712 284 32.064 248.064V233.28zM467.008 118.4l-.128-.352v-.128c-1.216-5.696-3.008-11.296-5.152-16.8-5.024-13.088-11.52-25.632-19.68-37.056-14.24-20.48-34.176-36.384-57.248-45.568a264.156 264.156 0 0 0-61.792-13.44A726.607 726.607 0 0 0 240.096 0a726.832 726.832 0 0 0-82.976 5.056c-21.056 1.984-41.76 6.368-61.792 13.312-23.2 9.312-43.104 25.216-57.344 45.696-8.064 11.424-14.688 23.968-19.712 37.056-2.144 5.6-3.904 11.456-5.28 17.28C4.288 156.096-.096 194.656.032 233.376v.128l.096 6.72-.096 7.488A469.304 469.304 0 0 0 13.12 362.176c1.344 5.6 3.008 11.2 5.28 16.704a164.308 164.308 0 0 0 19.584 37.056c14.24 20.48 34.144 36.384 57.344 45.6a265.211 265.211 0 0 0 61.696 13.44c27.552 3.232 55.2 4.928 82.88 5.024 27.968-.096 56-1.792 83.776-5.024 20.8-1.792 41.312-6.272 61.024-13.44 23.168-9.216 43.104-25.12 57.344-45.6 8.16-11.424 14.752-23.968 19.68-37.056a129.729 129.729 0 0 0 5.28-17.28c8.832-37.696 13.088-76.224 12.992-114.976v-.128l-.096-6.72.096-6.72A500.846 500.846 0 0 0 467.008 118.4z" /></symbol><symbol fill="none"  viewBox="0 0 13 17" id="pub-trash"><path d="M8 6v7M5 6v7M1.182 3v13h10.636V3M1.182 3h10.636M1.182 3H0m11.818 0H13M9 3V1H4v2" stroke="currentColor" stroke-width="1.5" /></symbol><symbol  viewBox="0 0 768 768" id="pub-triangle-right"><path d="M594.286 384 192 736V32z" /></symbol><symbol  viewBox="0 0 16 16" id="pub-undo"><path d="M7.8 6.753a5.438 5.438 0 0 0-3.278 1.102l1.593 1.587a.473.473 0 0 1-.338.81H1.663A.659.659 0 0 1 1 9.594V5.493a.473.473 0 0 1 .568-.466.475.475 0 0 1 .243.13l1.461 1.458a7.217 7.217 0 0 1 7.56-.959 7.201 7.201 0 0 1 4.117 5.45c.06.393.09.59-.041.742-.132.152-.35.152-.785.152-.386 0-.579 0-.7-.1s-.163-.31-.246-.733a5.463 5.463 0 0 0-1.58-2.889A5.49 5.49 0 0 0 7.8 6.753z" /></symbol><symbol  viewBox="0 0 17 17" id="pub-warning"><path d="M1.118 16h14.764c.861 0 1.39-.916.973-1.666L9.459 1.562a1.1 1.1 0 0 0-1.918 0L.145 14.334C-.272 15.056.257 16 1.118 16zM8.486 5.505c.473 0 .862.389.834.86l-.139 4.86a.706.706 0 0 1-.695.694.688.688 0 0 1-.695-.695l-.139-4.858c0-.472.361-.861.834-.861zm0 6.997c.473 0 .862.388.862.86s-.39.861-.862.861a.866.866 0 0 1-.862-.86c0-.445.39-.861.862-.861z" /></symbol><symbol viewBox="0 0 19 20" fill="none"  id="outline/pub-bonds"><circle cx="2" cy="10" r="2" fill="currentColor" /><path d="M18.283 10.283a.4.4 0 0 0 0-.566l-2.546-2.545a.4.4 0 0 0-.565.565L17.434 10l-2.262 2.263a.4.4 0 0 0 .565.565l2.546-2.545ZM6 10.4h12v-.8H6v.8ZM14.39 2.09a.4.4 0 0 0-.3-.48L10.582.8a.4.4 0 0 0-.18.78l3.118.72-.72 3.118a.4.4 0 0 0 .78.18l.81-3.508ZM6.212 7.34l8-5-.424-.68-8 5 .424.68ZM14.39 17.91a.4.4 0 0 1-.3.48l-3.508.81a.4.4 0 0 1-.18-.78l3.118-.72-.72-3.118a.4.4 0 0 1 .78-.18l.81 3.508Zm-8.178-5.25 8 5-.424.68-8-5 .424-.68Z" fill="currentColor" /></symbol><symbol viewBox="0 0 22 22" fill="none"  id="outline/pub-chat-and-codes"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 15v-4a4 4 0 1 0-4 4h4ZM11 5a6 6 0 1 0 0 12h6v-6a6 6 0 0 0-6-6Z" fill="#4F4F4F" /><path fill-rule="evenodd" clip-rule="evenodd" d="M21 1H1v20h20V1ZM0 0v22h22V0H0Z" fill="#4F4F4F" /></symbol><symbol viewBox="0 0 16 16" fill="none"  id="outline/pub-checked-un"><rect x=".5" y=".5" width="15" height="15" rx="5" fill="#fff" stroke-width="1.2" stroke="currentColor" /></symbol><symbol viewBox="0 0 20 20" fill="none"  id="outline/pub-checked"><rect width="20" height="20" rx="6" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M8.164 14.924C6.824 13.31 5.858 11.64 5 10.027c.107-.538.375-.969.697-1.238.107-.107.215-.161.43.054l1.983 2.26c.054.108.161.108.215 0 2.36-2.26 4.665-5.004 6.756-6.027.108-.054.537-.108.59-.054.43.323.43 1.292.054 1.83-2.091 2.852-4.236 5.543-7.132 8.126-.161.053-.376 0-.43-.054Z" fill="#fff" /></symbol><symbol viewBox="-1 0 19 15" fill="none"  id="outline/pub-circle-arrow"><path d="M7.5 0a7.5 7.5 0 1 0 7.135 5.188l-1.712.555A5.702 5.702 0 1 1 7.5 1.799V0Z" fill="#fff" /><path d="m10 9 4-4 4 4" stroke="currentColor" stroke-width="2" /></symbol><symbol viewBox="0 -4.2 17 17" fill="none"  id="outline/pub-compress"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m4.172.465 3.182 3.181a.5.5 0 0 1 0 .708L4.172 7.536a.5.5 0 1 1-.708-.708L5.793 4.5H0v-1h5.793L3.464 1.172a.5.5 0 1 1 .708-.707ZM12.828 7.535 9.646 4.353a.5.5 0 0 1 0-.707L12.828.464a.5.5 0 1 1 .708.707l-2.329 2.328H17v1h-5.793l2.329 2.329a.5.5 0 1 1-.708.707Z" /></symbol><symbol viewBox="-1 -1 21 21" fill="none"  id="outline/pub-edit"><path d="M1.14 13.358 0 19l5.643-1.138L19 4.505 14.496 0 1.139 13.358Zm3.721 3.046-2.835.573.57-2.837 2.265 2.264Zm11.9-11.9L5.98 15.283 3.717 13.02l8.57-8.571 2.252 2.253 1.12-1.12-2.254-2.253 1.09-1.09 2.266 2.264Z" fill="currentColor" /></symbol><symbol fill="none"  viewBox="0 0 20 20" id="outline/pub-embargo"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" /><path d="M10 5v5h5" stroke="currentColor" stroke-width="2" /></symbol><symbol viewBox="-2 0 15 14" fill="none"  id="outline/pub-enter"><path d="M1.85 1a.85.85 0 0 0-.525-.785l.058-.139-.058.139a.85.85 0 0 0-.65 0L.617.076l.058.139A.85.85 0 0 0 .15 1v8.003a.85.85 0 0 0 .85.85h8.948l-.256.256L7.4 12.402a.85.85 0 0 0 1.202 1.203l3.999-4a.852.852 0 0 0 0-1.203l-4-4V4.4A.85.85 0 0 0 7.4 5.603l2.293 2.294.256.256H1.85V1Z" fill="currentColor" stroke="currentColor" stroke-width=".3" /></symbol><symbol  viewBox="0 0 22 20" id="outline/pub-exclamation"><path d="M12.9 12.6H9.1L6.8.3h8.4l-2.3 12.3zm-2.6-1.5h1.3l1.7-9.3H8.6l1.7 9.3zM13.8 19.8H8.2v-5.9h5.7v5.9zm-4.1-1.5h2.7v-2.9H9.7v2.9z" /></symbol><symbol viewBox="0 -4.2 17 17" fill="none"  id="outline/pub-expand"><path fill-rule="evenodd" clip-rule="evenodd" d="m13.672.465 3.182 3.181a.5.5 0 0 1 0 .708l-3.182 3.182a.5.5 0 1 1-.708-.708L15.293 4.5H9.5v-1h5.793l-2.329-2.328a.5.5 0 1 1 .708-.707ZM3.328 7.535.146 4.353a.5.5 0 0 1 0-.707L3.328.464a.5.5 0 1 1 .708.707L1.707 3.499H7.5v1H1.707l2.329 2.329a.5.5 0 1 1-.708.707Z" fill="currentColor" /></symbol><symbol viewBox="0 0 15 19" fill="none"  id="outline/pub-flash"><path d="m8.046 1 1.2.435-.5 5.176L14 5.931 6.233 18l-1.185-.509 1.006-5.21H1L8.046 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" /></symbol><symbol fill="none"  viewBox="0 0 18 20" id="outline/pub-hand"><path d="M7.25 0C6.112 0 5.187.94 5.186 2.095v8.34l-1.8-1.01c-.985-.552-2.05-.433-2.781.31-.39.395-.605.921-.605 1.482 0 .56.215 1.086.59 1.465l4.683 5.102A7.353 7.353 0 0 0 10.543 20C14.655 20 18 16.603 18 12.428V9.163c0-1.156-.925-2.096-2.064-2.096-.32 0-.623.077-.894.21-.222-.914-1.034-1.593-2.001-1.593-.414 0-.798.125-1.122.338a2.056 2.056 0 0 0-1.774-1.03c-.296 0-.577.065-.832.18V2.095C9.313.938 8.388 0 7.25 0Zm.832 2.096v7.671a.62.62 0 0 0 .616.626.62.62 0 0 0 .616-.626v-2.68a.84.84 0 0 1 .832-.845.84.84 0 0 1 .831.844v3.027a.62.62 0 0 0 .616.626c.34 0 .616-.28.616-.626V7.778a.84.84 0 0 1 .832-.844.84.84 0 0 1 .832.844v2.681a.62.62 0 0 0 .616.625.62.62 0 0 0 .616-.625V9.162a.84.84 0 0 1 .832-.845.84.84 0 0 1 .832.845v3.266c0 3.485-2.793 6.32-6.225 6.32a6.139 6.139 0 0 1-4.4-1.849l-4.669-5.085a.875.875 0 0 1 0-1.195c.479-.486 1.08-.23 1.315-.098l2.396 1.343v.898a.62.62 0 0 0 .616.626.62.62 0 0 0 .616-.626v-1.255l.001-.01-.001-.01V2.095a.84.84 0 0 1 .832-.846.84.84 0 0 1 .832.846Z" fill="#fff" /></symbol><symbol viewBox="0 0 20 19" fill="none"  id="outline/pub-history"><path d="M18.989 5H15v10.857c0 1.588-1.155 2.974-2.692 3.128-.101.01-.201.015-.3.015H3a3 3 0 0 1-3-3c0-.657.219-1.282.614-1.802A.5.5 0 0 1 1.012 14H3V3a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3c0 .657-.218 1.28-.613 1.802A.5.5 0 0 1 18.99 5ZM15 4h3.723c.18-.304.277-.645.277-1a2 2 0 1 0-4 0v1ZM9.764 18a2.984 2.984 0 0 1-.589-3H1.277c-.18.304-.277.645-.277 1a2 2 0 0 0 2 2h6.764ZM14 3.008V3c0-.768.289-1.47.763-2H6a2 2 0 0 0-2 2v11h6.012a.5.5 0 0 1 .398.802A1.97 1.97 0 0 0 10 16a2 2 0 0 0 2.208 1.99C13.216 17.889 14 16.947 14 15.857V3.008ZM5.5 5a.5.5 0 0 1 0-1h6.458a.5.5 0 0 1 0 1H5.5Zm0 2a.5.5 0 0 1 0-1h6.458a.5.5 0 0 1 0 1H5.5Zm0 2a.5.5 0 0 1 0-1h6.458a.5.5 0 0 1 0 1H5.5Zm0 2a.5.5 0 0 1 0-1h6.458a.5.5 0 0 1 0 1H5.5Z" fill="currentColor" /></symbol><symbol fill="none"  viewBox="0 0 13 13" id="outline/pub-maximize"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5.5H5v1H1.5V5h-1V.5Zm11 1H8v-1h4.5V5h-1V1.5Zm-10 10V8h-1v4.5H5v-1H1.5Zm10 0V8h1v4.5H8v-1h3.5Z" fill="currentColor" /></symbol><symbol viewBox="-2 -2 18 18" fill="none"  id="outline/pub-menu-burger"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 2.333H0V0h14v2.333ZM14 8.167H0V5.833h14v2.334ZM14 14H0v-2.333h14V14Z" fill="currentColor" /></symbol><symbol viewBox="0 0 13 13" fill="none"  id="outline/pub-minimize"><path d="M13 4H9V0M9 13V9h4M0 9h4v4M4 0v4H0" stroke="currentColor" stroke-width="1.4" /></symbol><symbol viewBox="-3 -3 21 21" fill="none"  id="outline/pub-open-out"><path d="M12.78 5.104 8.1 9.8 6.6 8.3l4.794-4.779L7.1 3.6V1.5h7.7v7.7h-2.1z" fill="currentColor" /><path d="M3.6 12.7V1.5H1.5v13.3h13.3v-2.1z" fill="currentColor" /></symbol><symbol viewBox="0 0 16.5 14.5"  id="outline/pub-original"><path style="fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round" d="M3.25 3.25h10M3.25 11.25h10M3.25 7.25h8" /></symbol><symbol viewBox="-3 -3 20 20" fill="none"  id="outline/pub-plus"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 14H5.5V0H8v14Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M14 8.333H0V6h14v2.333Z" fill="currentColor" /></symbol><symbol viewBox="-2 0 19 13" fill="none"  id="outline/pub-pub-codes"><path d="M5 0h12v2.6H5V0ZM5 5.2h12v2.6H5V5.2ZM5 10.4h12V13H5v-2.6ZM0 0h3v2.6H0V0ZM0 5.2h3v2.6H0V5.2ZM0 10.4h3V13H0v-2.6Z" fill="currentColor" /></symbol><symbol viewBox="0 -1 21 20" fill="none"  id="outline/pub-publish"><path d="m0 10.5 9.625 2.713 6.125-7.088-7.136 4.963-3.774-1.052 13.442-6.72-3.477 12.749-3.281-2.922-1.899 2.56v-.673l-1.75-.49V21l3.914-5.277 3.961 3.527L21 0 0 10.5Z" fill="currentColor" /></symbol><symbol viewBox="0 0 22 19" fill="none"  id="outline/pub-recovery"><path d="m5.079 13.153-1.08 5.345 5.347-1.078L22 4.766 17.733.498 5.079 13.153Zm3.526 2.886-2.686.543.54-2.688 2.146 2.145ZM19.878 4.764 9.666 14.978 7.52 12.832l8.118-8.12 2.135 2.135 1.06-1.06L16.7 3.652l1.033-1.033 2.145 2.145ZM8.35 3.957v.041c0 .846-.298 1.668-.848 2.335a4.05 4.05 0 0 1-2.185 1.352 4.24 4.24 0 0 1-2.603-.2 3.95 3.95 0 0 1-1.925-1.67 3.627 3.627 0 0 1-.436-2.434c.145-.834.58-1.6 1.236-2.175a4.138 4.138 0 0 1 2.387-1A4.207 4.207 0 0 1 6.511.8l-.73 1.065a2.805 2.805 0 0 0-3.313.302 2.491 2.491 0 0 0-.8 1.484c-.082.566.04 1.141.346 1.633.307.493.78.872 1.344 1.078a2.83 2.83 0 0 0 1.761.058 2.678 2.678 0 0 0 1.42-.988c.341-.47.505-1.037.464-1.607L5.71 5.05l-.95-.898 2.847-2.69 2.847 2.69-.949.897L8.35 3.957Z" fill="currentColor" /></symbol><symbol  viewBox="0 0 19 16" id="outline/pub-republish"><g clip-path="url(#outline/pub-republish_a)"><path d="M7.646.5a7.5 7.5 0 1 0 7.135 5.188l-1.711.555a5.7 5.7 0 1 1-5.424-3.944V.5Z" /><path clip-rule="evenodd" d="m14.146 4.086 4.708 4.707-1.415 1.414-3.293-3.293-3.292 3.293-1.415-1.414 4.707-4.707Z" /></g><defs><clipPath id="outline/pub-republish_a"><path transform="translate(.146 .5)" d="M0 0h18.707v15H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 22 20" fill="none"  id="outline/pub-to-edit"><path d="M5.08 14.155 4 19.5l5.346-1.078L22 5.768 17.733 1.5 5.079 14.155Zm3.526 2.886-2.687.543.54-2.688 2.147 2.145ZM19.878 5.766 9.666 15.98l-2.145-2.146 8.119-8.12 2.134 2.135 1.06-1.06L16.7 4.653l1.033-1.033 2.145 2.145Z" fill="currentColor" /><path d="M4.884 1.5 8.312 5m0 0L4.885 8.5M8.312 5h-8" stroke="currentColor" stroke-width="1.5" /></symbol><symbol viewBox="0 0 14 14" fill="none"  id="outline/pub-topics"><rect x="1.102" y=".5" width="2.5" height="2.5" rx=".5" stroke-width=".9" stroke="currentColor" /><rect x="1.102" y="5.75" width="2.5" height="2.5" rx=".5" stroke-width=".9" stroke="currentColor" /><rect x="1.102" y="11" width="2.5" height="2.5" rx=".5" stroke-width=".9" stroke="currentColor" /><path stroke="currentColor" stroke-width="1.3" d="M5.852 1.975h7.875M5.852 7.225h7.875M5.852 12.475h7.875" /></symbol><symbol fill="none"  viewBox="0 0 16 20" id="outline/pub-trash"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.542 19.5H2.458c-.874 0-1.583-.71-1.583-1.583V4.458H.083V2.875h4.75V1.687C4.833 1.034 5.367.5 6.021.5h3.958c.654 0 1.188.531 1.188 1.188v1.187h4.75v1.583h-.792v13.459c0 .874-.71 1.583-1.583 1.583Zm0-15.042H2.458v13.063c0 .218.178.396.396.396h10.292a.396.396 0 0 0 .396-.396V4.458ZM6.417 7.625a.792.792 0 0 0-1.583 0v7.125a.792.792 0 0 0 1.583 0V7.625Zm4.75 0a.792.792 0 0 0-1.583 0v7.125a.792.792 0 0 0 1.583 0V7.625ZM9.584 2.083H6.417v.792h3.167v-.792Z" fill="#fff" /></symbol><symbol viewBox="0 0 17 19" fill="none"  id="solid/pub-bell"><path d="M11.166 3.093c-.547-.294-.884-.84-.883-1.427v-.002C10.283.743 9.484 0 8.5 0c-.984 0-1.782.745-1.782 1.663v.003c0 .589-.337 1.133-.885 1.427C1.866 5.219 4.145 12.276 0 13.523v1.372h17v-1.371c-4.146-1.248-1.866-8.305-5.834-10.431Zm-5.718 9.45h-1.6c1.058-2.149.747-7.065 3.292-8.353-1.497 1.62-.808 5.883-1.692 8.353Zm-.382 3.115h7.1c0 1.253-2.184 3.342-3.525 3.342-1.342 0-3.575-2.09-3.575-3.342Z" fill="currentColor" /></symbol><symbol fill="none"  viewBox="0 0 20 19" id="solid/pub-panel-published"><rect width="20" height="19" rx="2" fill="#fff" /><path d="M5.5 5.5h4.75m4.75 0h-4.75m0 0v4m0 0H15m-4.75 0v4H15" stroke-width="1.2" stroke="currentColor" /><path fill="#0069E4" d="M5 4h2v3H5zM14 4h2v3h-2zM14 8h2v3h-2zM14 12h2v3h-2z" /></symbol><symbol viewBox="0 -1 21 20" fill="none"  id="solid/pub-publish"><path d="m19 0-4.75 17.417-6.435-5.731 6.176-6.519-8.28 5.722L0 9.5 19 0ZM7.125 13.195V19l2.58-3.508-2.58-2.297Z" fill="currentColor" /></symbol>', e.insertBefore(n, e.firstChild);
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", t) : t();
}
const x2t = {
  enabled: !0,
  capture: !1
};
class C2t {
  /**
   * Создаёт экземпляр класса GlobalShortcuts
   * @param options {Object} Глобальные параметры
   * @param options.event {string} Тип события, которое будут слушать обработчики. По умочанию 'keydown'
   * @param options.debug {boolean} Флаг, указывающий включить или выключить debug-режим
   */
  constructor(e = { event: "keydown", debug: !1 }) {
    Ao(this, "listeners");
    Ao(this, "shortcuts");
    Ao(this, "event");
    Ao(this, "debug");
    this.event = e.event, this.debug = e.debug, this.listeners = {}, this.shortcuts = {};
  }
  /**
   * Добавляет глобальный обработчик на клавишу.
   * Пользовательские обработчики будут вызываться в этом глобальном обработчике
   * @param key {string} Имя клавиши для
   * @returns {Object}
   */
  addShortcut(e, n = void 0) {
    const r = (s) => {
      if (s.key === e) {
        const i = this.listeners[e].find(
          (o) => o.options.capture && o.options.enabled
        );
        if (i)
          return i.handler(s);
        this.listeners[e].forEach((o) => {
          if (o.options.enabled)
            return o.handler(s);
        });
      }
    };
    return document.addEventListener(this.event, r, n), r;
  }
  /**
   * Удаляет глобальный обработчик для клавиши.
   * Удаляет все пользовательские обработчики для этой клавиши
   * @param key Имя клавиши
   */
  removeShortcut(e) {
    const n = this.shortcuts[e];
    document.removeEventListener(this.event, n), delete this.shortcuts[e], delete this.listeners[e];
  }
  /**
   * Возвращает все обработчики, зарегистрированные компонентом
   * @param component {Object} Экземпляр Vue компонента
   * @returns {Array} Список обработчиков
   */
  getComponentListeners(e) {
    const n = [];
    return Object.keys(this.listeners).forEach((r) => {
      this.listeners[r].forEach((i) => {
        i.component === e && n.push(i);
      });
    }), n;
  }
  /**
   * Возвращает обработчики, зарегистрированные компонентом для конкретной клавиши
   * @param component {Object} Экземпляр Vue компонента
   * @param key {string} Имя клавиши
   * @returns {Array} Список обработчиков
   */
  getComponentKeyListeners(e, n) {
    const r = this.listeners[n];
    return r ? r.filter((s) => s.component === e) : [];
  }
  /**
   * Регистрирует пользовательский обработчик нажатия клавиши
   * @param component {Object} Экземпляр Vue компонента
   * @param key {string} Имя клавиши
   * @param handler {Function} Функция-обработчик
   * @param options {Object} Параметры обработчика
   * @param nativeOptions {object} Опции метода addEventListener
   */
  registerComponentKey(e, n, r, s, i) {
    const o = {
      ...x2t,
      ...s
    }, a = { handler: r, options: o, component: e };
    this.listeners[n] || (this.listeners[n] = []), this.listeners[n].push(a), this.shortcuts[n] || (this.shortcuts[n] = this.addShortcut(n, i));
  }
  /**
   * Удаляет пользовательский обработчик нажатия клавиши
   * @param component {Object} Экземпляр Vue компонента
   * @param key {string} Имя клавиши
   */
  unregisterComponentKey(e, n) {
    this.listeners[n] = this.listeners[n].filter(
      (r) => r.component === e
    ), this.listeners[n].length === 0 && this.removeShortcut(n);
  }
  /**
   * Включает пользовательский обработчик нажатия клавиши
   * @param component {Object} Экземпляр Vue компонента
   * @param key {string} Имя клавиши
   */
  enableComponentKey(e, n) {
    this.getComponentKeyListeners(e, n).forEach((r) => {
      r.options.enabled = !0;
    });
  }
  /**
   * Выключает пользовательский обработчик нажатия клавиши
   * @param component {Object} Экземпляр Vue компонента
   * @param key {string} Имя клавиши
   */
  disableComponentKey(e, n) {
    this.getComponentKeyListeners(e, n).forEach((r) => {
      r.options.enabled = !1;
    });
  }
  /**
   * Включает все пользовательские обработчики нажатия клавиши данного компонента
   * @param component {Object} Экземпляр Vue компонента
   */
  enableComponentShortcuts(e) {
    this.getComponentListeners(e).forEach((n) => {
      n.options.enabled = !0;
    });
  }
  /**
   * Выключает все пользовательские обработчики нажатия клавиши данного компонента
   * @param component {Object} Экземпляр Vue компонента
   */
  disableComponentShortcuts(e) {
    this.getComponentListeners(e).forEach((n) => {
      n.options.enabled = !1;
    });
  }
  /**
   * Удаляет все пользовательские обработчики нажатия клавиши данного компонента
   * @param component {Object} Экземпляр Vue компонента
   */
  unregisterComponentShortcuts(e) {
    Object.keys(this.listeners).forEach((n) => {
      this.listeners[n] && (this.listeners[n] = this.listeners[n].filter(
        (r) => r.component !== e
      )), this.listeners[n].length === 0 && this.removeShortcut(n);
    });
  }
}
const T2t = {
  install(t, e) {
    t.prototype.$shortcuts = new C2t(e), t.mixin({
      methods: {
        /**
         * Регистрирует пользовательский обработчик нажатия клавиши для текущего компонента.
         * @param key {string} Имя клавиши
         * @param handler {Function} Функция-обработчик
         * @param options {Object} Параметры обработчика
         * @param nativeOptions {Object} Опции метода addEventListener
         */
        $registerShortcut(n, r, s, i = void 0) {
          this.$shortcuts.registerComponentKey(this, n, r, s, i);
        },
        /**
         * Удаляет пользовательский обработчик нажатия клавиши для текущего компонента
         * @param key {string} Имя клавиши
         */
        $unregisterShortcut(n) {
          this.$shortcuts.unregisterComponentKey(this, n);
        },
        /**
         * Включает пользовательский обработчик нажатия клавиши для текущего компонента
         * @param key {string} Имя клавиши
         */
        $enableShortcut(n) {
          this.$shortcuts.enableComponentKey(this, n);
        },
        /**
         * Выключает пользовательский обработчик нажатия клавиши для текущего компонента
         * @param key {string} Имя клавиши
         */
        $disableShortcut(n) {
          this.$shortcuts.disableComponentKey(this, n);
        },
        /**
         * Включает все пользовательские обработчики нажатия клавиши текущего компонента
         */
        $enableShortcuts() {
          this.$shortcuts.enableComponentShortcuts(this);
        },
        /**
         * Вылючает все пользовательские обработчики нажатия клавиши текущего компонента
         */
        $disableShortcuts() {
          this.$shortcuts.disableComponentShortcuts(this);
        },
        /**
         * Возвращает обработчики, зарегистрированные компонентом.
         * Если указан key, возвращает список обработчиков для этой клавиши
         * @param key {string} Имя клавиши
         * @returns {Array} Список обработчиков
         */
        $getShortcuts(n) {
          return n ? this.$shortcuts.getComponentKeyListeners(this, n) : this.$shortcuts.getComponentListeners(this);
        }
      },
      beforeDestroy() {
        this.$shortcuts.unregisterComponentShortcuts(this);
      }
    });
  }
};
class P2t {
  constructor(e = 1e4) {
    this.listeners = [], this._timer = setInterval(() => {
      this.listeners.forEach(
        (n) => globalThis.requestIdleCallback(() => n())
      );
    }, e);
  }
  registerListener(e) {
    this.listeners.push(e);
  }
  unregisterListener(e) {
    this.listeners = this.listeners.filter((n) => n === e);
  }
}
const k2t = {
  install(t, e) {
    t.prototype.$timer = new P2t(e.interval);
  }
};
class N2t {
  /**
   * Создаёт экземпляр класса SelectionHelper
   * @param options {Object} Глобальные параметры
   */
  constructor(e) {
    Ao(this, "options");
    Ao(this, "listeners");
    this.options = e, this.listeners = {};
  }
  /**
   * Добавляет в объект `listeners` глобальный обработчик на выделение.
   * @param id {ID} Идентификатор обработчика
   * @param handler {Function} Функция-обработчик
   */
  addListener(e, n) {
    const r = () => {
      if (this.listeners[e].enabled)
        return n(window.getSelection());
    };
    this.listeners[e] = {
      enabled: !1,
      // отключен по-умолчанию
      handler: r
    }, document.addEventListener("selectionchange", this.listeners[e].handler);
  }
  /**
   * Удаляет глобальный обработчик из объекта `listeners`
   * @param id {ID} Идентификатор обработчика
   */
  removeListener(e) {
    this.listeners[e] && (document.removeEventListener(
      "selectionchange",
      this.listeners[e].handler
    ), delete this.listeners[e]);
  }
  /**
   * Разрешает запуск обработчика
   * @param id {ID} Идентификатор обработчика
   */
  enableListener(e) {
    this.listeners[e] && (this.listeners[e].enabled = !0);
  }
  /**
   * Запрещает запуск обработчика
   * @param id {ID} Идентификатор обработчика
   */
  disableListener(e) {
    this.listeners[e] && (this.listeners[e].enabled = !1);
  }
}
const $2t = {
  install(t, e) {
    t.prototype.$selectionHelper = new N2t(e), t.mixin({
      methods: {
        /**
         * Регистрирует пользовательский обработчик выделения
         * @param id {ID} Идентификатор обработчика (обычно _uid компонента)
         * @param handler {Function} Функция-обработчик
         */
        $registerSelectionListener(n, r) {
          this.$selectionHelper.addListener(n, r);
        },
        /**
         * Удаляет пользовательский обработчик выделения
         * @param id {ID} Идентификатор обработчика (обычно _uid компонента)
         */
        $unregisterSelectionListener(n) {
          this.$selectionHelper.removeListener(n);
        },
        /**
         * Разрешает запуск обработчика
         * @param id {ID} Идентификатор обработчика
         */
        $enableSelectionListener(n) {
          this.$selectionHelper.enableListener(n);
        },
        /**
         * Запрещает запуск обработчика
         * @param id {ID} Идентификатор обработчика
         */
        $disableSelectionListener(n) {
          this.$selectionHelper.disableListener(n);
        }
      }
    });
  }
}, D2t = {
  methods: { formatUsername: Ps }
}, A2t = (t, e, n) => {
  var s, i;
  const r = (s = n.context) == null ? void 0 : s.$root.$store;
  if ((i = e.value) != null && i.length) {
    let o = !0;
    e.arg === "any" ? o = r.getters["auth/getIsUserHasAnyPermission"](e.value) : o = r.getters["auth/getIsUserHasAllPermissions"](
      e.value
    ), o === !1 ? t.style.display = "none" : t.style.display = "";
  }
}, O2t = {
  name: "permissions",
  bind: A2t
};
/*!
 * vue2-transitions v0.3.0
 * (c) 2019-present cristij <joracristi@gmail.com>
 * Released under the MIT License.
 */
var ko = {
  inheritAttrs: !1,
  props: {
    /**
     * Transition duration. Number for specifying the same duration for enter/leave transitions
     * Object style {enter: 300, leave: 300} for specifying explicit durations for enter/leave
     */
    duration: {
      type: [Number, Object],
      default: 300
    },
    /**
     * Transition delay. Number for specifying the same delay for enter/leave transitions
     * Object style {enter: 300, leave: 300} for specifying explicit durations for enter/leave
     */
    delay: {
      type: [Number, Object],
      default: 0
    },
    /**
     * Whether the component should be a `transition-group` component.
     */
    group: Boolean,
    /**
     * Transition tag, in case the component is a `transition-group`
     */
    tag: {
      type: String,
      default: "span"
    },
    /**
     *  Transform origin property https://tympanus.net/codrops/css_reference/transform-origin/.
     *  Can be specified with styles as well but it's shorter with this prop
     */
    origin: {
      type: String,
      default: ""
    },
    /**
     * Element styles that are applied during transition. These styles are applied on @beforeEnter and @beforeLeave hooks
     */
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "ease-out"
        };
      }
    }
  },
  computed: {
    componentType: function() {
      return this.group ? "transition-group" : "transition";
    },
    hooks: function() {
      return Object.assign({
        beforeEnter: this.beforeEnter,
        afterEnter: this.cleanUpStyles,
        beforeLeave: this.beforeLeave,
        leave: this.leave,
        afterLeave: this.cleanUpStyles
      }, this.$listeners);
    }
  },
  methods: {
    beforeEnter: function(e) {
      var n = this.duration.enter ? this.duration.enter : this.duration;
      e.style.animationDuration = n + "ms";
      var r = this.delay.enter ? this.delay.enter : this.delay;
      e.style.animationDelay = r + "ms", this.setStyles(e);
    },
    cleanUpStyles: function(e) {
      var n = this;
      Object.keys(this.styles).forEach(function(r) {
        var s = n.styles[r];
        s && (e.style[r] = "");
      }), e.style.animationDuration = "", e.style.animationDelay = "";
    },
    beforeLeave: function(e) {
      var n = this.duration.leave ? this.duration.leave : this.duration;
      e.style.animationDuration = n + "ms";
      var r = this.delay.leave ? this.delay.leave : this.delay;
      e.style.animationDelay = r + "ms", this.setStyles(e);
    },
    leave: function(e) {
      this.setAbsolutePosition(e);
    },
    setStyles: function(e) {
      var n = this;
      this.setTransformOrigin(e), Object.keys(this.styles).forEach(function(r) {
        var s = n.styles[r];
        s && (e.style[r] = s);
      });
    },
    setAbsolutePosition: function(e) {
      return this.group && (e.style.position = "absolute"), this;
    },
    setTransformOrigin: function(e) {
      return this.origin && (e.style.transformOrigin = this.origin), this;
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = " @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } } .fadeIn { animation-name: fadeIn; } @keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } } .fadeOut { animation-name: fadeOut; } .fade-move { transition: transform .3s ease-out; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var pw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "fadeIn", "move-class": "fade-move", "leave-active-class": "fadeOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "fade-transition",
  mixins: [ko]
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".zoom-move { transition: transform .3s ease-out; } @keyframes zoomIn { from { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); } 50% { opacity: 1; } } .zoomIn { animation-name: zoomIn; } @keyframes zoomOut { from { opacity: 1; } 50% { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); } to { opacity: 0; } } .zoomOut { animation-name: zoomOut; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var hw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "zoomIn", "move-class": "zoom-move", "leave-active-class": "zoomOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "zoom-center-transition",
  mixins: [ko]
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".zoom-move { transition: transform .3s ease-out; } @keyframes zoomInX { from { opacity: 0; transform: scaleX(0); } 50% { opacity: 1; } } .zoomInX { animation-name: zoomInX; } @keyframes zoomOutX { from { opacity: 1; } 50% { opacity: 0; transform: scaleX(0); } to { opacity: 0; } } .zoomOutX { animation-name: zoomOutX; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var mw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "zoomInX", "move-class": "zoom-move", "leave-active-class": "zoomOutX" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "zoom-x-transition",
  props: {
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.55,0,.1,1)"
        };
      }
    }
  },
  mixins: [ko]
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".zoom-move { transition: transform .3s ease-out; } @keyframes zoomInY { from { opacity: 0; transform: scaleY(0); } 50% { opacity: 1; tranform: scaleY(1); } } .zoomInY { animation-name: zoomInY; } @keyframes zoomOutY { from { opacity: 1; } 50% { opacity: 0; transform: scaleY(0); } to { opacity: 0; } } .zoomOutY { animation-name: zoomOutY; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var vw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "zoomInY", "move-class": "zoom-move", "leave-active-class": "zoomOutY" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "zoom-y-transition",
  mixins: [ko],
  props: {
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.55,0,.1,1)"
        };
      }
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = " .collapse-move { transition: transform .3s ease-in-out; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var gw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "move-class": "collapse-move" }, on: { "before-enter": t.beforeEnter, "after-enter": t.afterEnter, enter: t.enter, "before-leave": t.beforeLeave, leave: t.leave, "after-leave": t.afterLeave } }, "component", t.$attrs, !1), t.$listeners), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "collapse-transition",
  mixins: [ko],
  methods: {
    transitionStyle: function(e) {
      e === void 0 && (e = 300);
      var n = e / 1e3, r = n + "s height ease-in-out, " + n + "s padding-top ease-in-out, " + n + "s padding-bottom ease-in-out";
      return r;
    },
    beforeEnter: function(e) {
      var n = this.duration.enter ? this.duration.enter : this.duration;
      e.style.transition = this.transitionStyle(n), e.dataset || (e.dataset = {}), e.dataset.oldPaddingTop = e.style.paddingTop, e.dataset.oldPaddingBottom = e.style.paddingBottom, e.style.height = "0", e.style.paddingTop = 0, e.style.paddingBottom = 0, this.setStyles(e);
    },
    enter: function(e) {
      e.dataset.oldOverflow = e.style.overflow, e.scrollHeight !== 0 ? (e.style.height = e.scrollHeight + "px", e.style.paddingTop = e.dataset.oldPaddingTop, e.style.paddingBottom = e.dataset.oldPaddingBottom) : (e.style.height = "", e.style.paddingTop = e.dataset.oldPaddingTop, e.style.paddingBottom = e.dataset.oldPaddingBottom), e.style.overflow = "hidden";
    },
    afterEnter: function(e) {
      e.style.transition = "", e.style.height = "", e.style.overflow = e.dataset.oldOverflow;
    },
    beforeLeave: function(e) {
      e.dataset || (e.dataset = {}), e.dataset.oldPaddingTop = e.style.paddingTop, e.dataset.oldPaddingBottom = e.style.paddingBottom, e.dataset.oldOverflow = e.style.overflow, e.style.height = e.scrollHeight + "px", e.style.overflow = "hidden", this.setStyles(e);
    },
    leave: function(e) {
      var n = this.duration.leave ? this.duration.leave : this.duration;
      e.scrollHeight !== 0 && (e.style.transition = this.transitionStyle(n), e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0), this.setAbsolutePosition(e);
    },
    afterLeave: function(e) {
      e.style.transition = "", e.style.height = "", e.style.overflow = e.dataset.oldOverflow, e.style.paddingTop = e.dataset.oldPaddingTop, e.style.paddingBottom = e.dataset.oldPaddingBottom;
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = " @keyframes scaleIn { from { opacity: 0; transform: scale(0) } to { opacity: 1; } } .scaleIn { animation-name: scaleIn; } @keyframes scaleOut { from { opacity: 1; } to { opacity: 0; transform: scale(0); } } .scaleOut { animation-name: scaleOut; } .scale-move { transition: transform .3s cubic-bezier(.25, .8, .50, 1); } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var yw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "scaleIn", "move-class": "scale-move", "leave-active-class": "scaleOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "scale-transition",
  mixins: [ko],
  props: {
    origin: {
      type: String,
      default: "top left"
    },
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.25,.8,.50,1)"
        };
      }
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".slide-move { transition: transform .3s; } @keyframes slideYIn { from { opacity: 0; transform: translateY(-15px); } to { opacity: 1; } } .slideYIn { animation-name: slideYIn; } @keyframes slideYOut { from { opacity: 1; } to { opacity: 0; transform: translateY(-15px); } } .slideYOut { animation-name: slideYOut; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var bw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, type: "animation", "enter-active-class": "slideYIn", "move-class": "slide-move", "leave-active-class": "slideYOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "slide-y-up-transition",
  mixins: [ko],
  props: {
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.25,.8,.50,1)"
        };
      }
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".slide-move { transition: transform .3s; } @keyframes slideYDownIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; } } .slideYDownIn { animation-name: slideYDownIn; } @keyframes slideYDownOut { from { opacity: 1; } to { opacity: 0; transform: translateY(15px); } } .slideYDownOut { animation-name: slideYDownOut; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var _w = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "slideYDownIn", "leave-active-class": "slideYDownOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "slide-y-down-transition",
  mixins: [ko],
  props: {
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.25,.8,.50,1)"
        };
      }
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".slide-move { transition: transform .3s; } @keyframes slideXLeftIn { from { opacity: 0; transform: translateX(-15px); } to { opacity: 1; } } .slideXLeftIn { animation-name: slideXLeftIn; } @keyframes slideXLeftOut { from { opacity: 1; } to { opacity: 0; transform: translateX(-15px); } } .slideXLeftOut { animation-name: slideXLeftOut; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var ww = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "slideXLeftIn", "move-class": "slide-move", "leave-active-class": "slideXLeftOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "slide-x-left-transition",
  mixins: [ko],
  props: {
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.25,.8,.50,1)"
        };
      }
    }
  }
};
(function() {
  if (typeof document < "u") {
    var t = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style"), n = ".slide-move { transition: transform .3s; } @keyframes slideXRightIn { from { opacity: 0; transform: translateX(15px); } to { opacity: 1; } } .slideXRightIn { animation-name: slideXRightIn; } @keyframes slideXRightOut { from { opacity: 1; } to { opacity: 0; transform: translateX(15px); } } .slideXRightOut { animation-name: slideXRightOut; } ";
    e.type = "text/css", e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n)), t.appendChild(e);
  }
})();
var Sw = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n(t.componentType, t._g(t._b({ tag: "component", attrs: { tag: t.tag, "enter-active-class": "slideXRightIn", "move-class": "slide-move", "leave-active-class": "slideXRightOut" } }, "component", t.$attrs, !1), t.hooks), [t._t("default")], 2);
  },
  staticRenderFns: [],
  name: "slide-x-right-transition",
  mixins: [ko],
  props: {
    styles: {
      type: Object,
      default: function() {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.25,.8,.50,1)"
        };
      }
    }
  }
}, ri = {};
ri[pw.name] = pw;
ri[hw.name] = hw;
ri[mw.name] = mw;
ri[vw.name] = vw;
ri[gw.name] = gw;
ri[yw.name] = yw;
ri[bw.name] = bw;
ri[_w.name] = _w;
ri[ww.name] = ww;
ri[Sw.name] = Sw;
function M2t(t, e) {
  e && e.components ? e.components.forEach(function(n) {
    return t.component(n.name, ri[n.name]);
  }) : Object.keys(ri).forEach(function(n) {
    t.component(n, ri[n]);
  });
}
typeof window < "u" && window.Vue && window.Vue.use({ install: M2t });
const R2t = "_root_1h5mn_1", L2t = "_close_1h5mn_14", F2t = "_icon_1h5mn_22", B2t = "_title_1h5mn_26", j2t = "_text_1h5mn_32", W2t = {
  root: R2t,
  close: L2t,
  icon: F2t,
  title: B2t,
  text: j2t
}, H2t = {
  name: "PbToastMessage",
  components: {
    ZoomCenterTransition: hw,
    ZoomXTransition: mw,
    ZoomYTransition: vw,
    CollapseTransition: gw,
    ScaleTransition: yw,
    SlideXLeftTransition: ww,
    SlideXRightTransition: Sw,
    SlideYUpTransition: bw,
    SlideYDownTransition: _w,
    FadeTransition: pw,
    PbButton: nt
  },
  props: {
    message: {
      type: Object,
      required: !0
    },
    transition: {
      type: String,
      default: "slide-x-right",
      validator(t) {
        return [
          "fade",
          "zoom-center",
          "zoom-x",
          "zoom-y",
          "collapse",
          "scale",
          "slide-x-left",
          "slide-x-right",
          "slide-y-up",
          "slide-y-down"
        ].includes(t);
      }
    }
  },
  computed: {
    transitionComponent() {
      return `${this.transition}-transition`;
    }
  },
  methods: {
    triggerNavigation(t) {
      t.target.href && t.target.href.includes(globalThis.location.host) && (t.stopPropagation(), t.preventDefault(), this.$emit("triggerNavigation", { url: t.target.href }));
    }
  }
};
var V2t = function() {
  var e = this, n = e._self._c;
  return n(e.transitionComponent, { tag: "component", attrs: { appear: "" } }, [n("div", { class: [e.$style.root, e.message.type], attrs: { "data-test-selector": "message", "data-test-id": e.message.id, "data-test-attrs": `type__${e.message.type}` } }, [e._t("default", function() {
    return [n("div", { class: e.$style.icon, attrs: { "data-test-selector": "message-icon" } }, [e._t("icon", null, { message: e.message })], 2), n("div", { staticClass: "message-wrapper", attrs: { "data-test-selector": "message-title" }, on: { "!click": function(r) {
      return e.triggerNavigation.apply(null, arguments);
    } } }, [e._t("title", function() {
      return [e.message.title ? n("div", { class: e.$style.title }, [e._v(" " + e._s(e.message.title) + " ")]) : e._e()];
    }, { title: e.message.title }), e._t("text", function() {
      return [e.message.text ? [e.message.render === "html" ? n("div", { class: e.$style.text, attrs: { "data-test-selector": "message-text" }, domProps: { innerHTML: e._s(e.message.text) } }) : n("div", { class: e.$style.text, attrs: { "data-test-selector": "message-text" } }, [e._v(" " + e._s(e.message.text) + " ")])] : e._e()];
    }, { text: e.message.text }), e._t("actions", null, { message: e.message })], 2)];
  }, { message: e.message }), e.message.closable ? n("PbButton", { class: e.$style.close, attrs: { round: "", "data-test-selector": "close-message-button" }, on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.$emit("close", e.message);
  } } }, [n("icon", { attrs: { type: "font", name: "close", size: "24" } })], 1) : e._e()], 2)]);
}, z2t = [];
const LA = {
  $style: W2t
};
function U2t(t) {
  for (var e in LA)
    this[e] = LA[e];
}
var G2t = /* @__PURE__ */ B(
  H2t,
  V2t,
  z2t,
  !1,
  U2t,
  null
);
const Y2t = G2t.exports, Z2t = "_root_ciyet_1", X2t = "_messages_ciyet_10", K2t = {
  root: Z2t,
  messages: X2t
}, J2t = {
  name: "PbToast",
  components: {
    ToastMessage: Y2t
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
};
var q2t = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e.$style.root }, [n("div", { class: e.$style.messages, attrs: { "data-test-selector": "messages-wrapper" } }, e._l(e.messages, function(r) {
    return n("ToastMessage", { key: r.id, attrs: { message: r }, on: { close: function(s) {
      return e.$emit("close", s);
    }, triggerNavigation: function(s) {
      return e.$emit("triggerNavigation", s);
    } }, scopedSlots: e._u([{ key: "icon", fn: function({ message: s }) {
      return [e._t("icon", null, { message: s })];
    } }, { key: "default", fn: function({ message: s }) {
      return [e._t("default", null, { message: s })];
    } }, { key: "title", fn: function({ title: s }) {
      return [e._t("title", null, { title: s })];
    } }, { key: "text", fn: function({ text: s, render: i }) {
      return [e._t("text", null, { title: s, render: i })];
    } }, { key: "actions", fn: function({ message: s }) {
      return [e._t("actions", null, { message: s })];
    } }], null, !0) });
  }), 1)]);
}, Q2t = [];
const FA = {
  $style: K2t
};
function eIt(t) {
  for (var e in FA)
    this[e] = FA[e];
}
var tIt = /* @__PURE__ */ B(
  J2t,
  q2t,
  Q2t,
  !1,
  eIt,
  null
);
const nIt = tIt.exports, rIt = {
  name: "message",
  components: {
    // PbButton,
    PbCircularLoader: br,
    PbToast: nIt
  },
  data() {
    return {
      colors: {
        error: "error",
        success: "success",
        info: "info"
      },
      needReload: !1,
      messageCodes: ro
    };
  },
  computed: {
    ...st({
      messages: (t) => t.messages.messages
    })
  },
  created() {
    this.timer = null;
  },
  methods: {
    ...ge(["removeMessage"]),
    reload() {
      window.location.reload();
    },
    triggerNavigation(t) {
      const e = new URL(t.url).pathname;
      e && e !== this.$route.path && this.$router.push(e);
    }
  }
};
var sIt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "pb-messages", attrs: { "data-test-selector": "messages" } }, [n("PbToast", { attrs: { messages: e.messages }, on: { close: e.removeMessage, triggerNavigation: e.triggerNavigation }, scopedSlots: e._u([{ key: "icon", fn: function({ message: r }) {
    return [r.code === e.messageCodes.RECONNECT ? n("PbCircularLoader", { attrs: { size: 20, color: "white" } }) : e._e()];
  } }]) })], 1);
}, iIt = [], oIt = /* @__PURE__ */ B(
  rIt,
  sIt,
  iIt,
  !1,
  null,
  null
);
const aIt = oIt.exports, lIt = el.getParser(globalThis.navigator.userAgent), cIt = {
  name: "TheMain",
  components: {
    TheMessage: aIt,
    Auth: x_
  },
  computed: {
    ...st({
      messageHubInitialized: (t) => t.messageHubInitialized,
      isOnline: (t) => t.uiState.online,
      initialLoaded: (t) => t.initialLoaded,
      references: (t) => t.references
    }),
    ...pe("auth", ["isAuthorized", "isLoggedIn"])
  },
  watch: {
    async isLoggedIn(t, e) {
      t !== e && t === !1 && (await this.$nextTick(), this.clearUserData());
    }
  },
  async created() {
    document.addEventListener("keyup", (t) => {
      t.composed && t.ctrlKey && t.altKey && t.code === "KeyH" && this.$store.dispatch("toggleHackerInterface");
    }), this.initProfile();
  },
  mounted() {
    this.setVisibility(document.visibilityState === "visible");
    const t = {
      height: globalThis.innerHeight,
      width: globalThis.innerWidth,
      scrollLeft: globalThis.scrollX,
      scrollTop: globalThis.scrollY
    };
    this.setWindowParams(t), window.addEventListener("resize", async () => {
      requestAnimationFrame(() => {
        this.setWindowParams({
          ...t,
          height: globalThis.innerHeight,
          width: globalThis.innerWidth
        });
      });
    });
    const e = za(() => {
      globalThis.requestIdleCallback(() => {
        this.setWindowParams({
          ...t,
          height: globalThis.innerHeight,
          width: globalThis.innerWidth
        });
      });
    }, 500), n = () => {
      this.setVisibility(document.visibilityState === "visible");
    };
    window.addEventListener("offline", () => {
      this.setOnline(!1);
    }), document.addEventListener("visibilitychange", n);
    const r = document.getElementById("legacy-app");
    r && (r.addEventListener("scroll", e, { passive: !0 }), lIt.isOS("android") && window.matchMedia("(display-mode: standalone)").matches && this.setInstalled(!0));
  },
  methods: {
    ...ge("auth", {
      logout: "logout",
      initAuth: "init",
      clearUserData: "clearUserData"
    }),
    ...ge("userProfile", {
      initProfile: "init"
    }),
    ...ge({
      setWindowParams: "setWindowParams",
      setVisibility: "setVisibility",
      setOnline: "setOnline",
      setInstalled: "setInstalled"
    })
  }
};
var uIt = function() {
  var e = this, n = e._self._c;
  return n("main", { staticClass: "legacy-application flex" }, [n("section", { staticClass: "flex flex-auto", attrs: { id: "content" } }, [n("router-view", { on: { logout: e.logout } }), n("TheMessage")], 1), n("portal-target", { attrs: { name: "modal", transition: "fade" } })], 1);
}, dIt = [], fIt = /* @__PURE__ */ B(
  cIt,
  uIt,
  dIt,
  !1,
  null,
  null
);
const pIt = fIt.exports, hIt = {
  name: "App",
  components: {
    TheMain: pIt
  },
  setup() {
    const t = zft();
    BO("store", t);
    const e = le(
      () => t.state.uiState.init === rt.READY
    ), n = {
      $store: t,
      ...ge({
        UIInit: "uiState/init",
        appInit: "appInit"
      })
    };
    return n.appInit(rt.READY), n.UIInit(), setInterval(() => {
      const r = Object.keys(t.state.news.items ?? {}).length;
      r > 1e3 && Aa.sentrySend("Legacy news store is big!", "message", { newsCount: r });
    }, 5 * 60 * 1e3), { initialized: e };
  },
  errorCaptured(t) {
    Aa.sentrySend(t.message, "error", t);
  }
};
var mIt = function() {
  var e = this, n = e._self._c;
  return e.initialized ? n("TheMain") : e._e();
}, vIt = [], gIt = /* @__PURE__ */ B(
  hIt,
  mIt,
  vIt,
  !1,
  null,
  null
);
const yIt = gIt.exports;
function bIt(t) {
  function e(s) {
    if (s.data.userId) {
      const i = t.$store.getters["auth/getUserId"];
      return i && String(i) !== s.data.userId;
    } else if (s.data.username)
      return (t.$store.getters["auth/getUserLogin"] ?? "").toLowerCase() !== s.data.username.toLowerCase();
    return !1;
  }
  function n() {
    return t.$store.getters["auth/isAuthorized"];
  }
  function r(s) {
    t.$store.dispatch("panels/addPanelNotification", {
      panelId: s.data.id,
      notificationId: s.data.notificationId
    });
  }
  window.addEventListener("message", async (s) => {
    var i;
    if (((i = s.data) == null ? void 0 : i.event) === "openNotificationLink") {
      if (e(s)) {
        t.$store.dispatch("addMessage", {
          text: "Для использования уведомлений выполните вход в ИС от того же пользователя, что и в приложении для уведомлений",
          type: "error",
          timeout: 1 / 0
        });
        return;
      }
      if (s.data.action === null)
        switch (r(s), s.data.type) {
          case "comment":
            await t.$router.push({
              path: `/news/${s.data.id}#comment-${s.data.commentId}`
            }).catch(() => null);
            break;
          case "news":
            await t.$router.push({
              path: `/news/${s.data.id}`
            }).catch(() => null);
            break;
          case "note":
            await t.$router.push({
              path: `/notes/${s.data.id}`
            }).catch(() => null);
            break;
          default:
            await t.$router.push({
              path: `/news/${s.data.id}`
            }).catch(() => null);
        }
      if (s.data.action === "pick") {
        if (n() || t.$store.dispatch("addMessage", {
          text: "Для взятия новости/заметки в работу выполните вход в ИС, а после еще раз нажмите на уведомление",
          type: "error",
          timeout: 1e4
        }), s.data.type === "news") {
          if (!n()) {
            r(s), await t.$router.push({
              path: `/news/${s.data.id}`
            }).catch(() => null);
            return;
          }
          let o = t.$store.getters["news/getNewsItemCurrentVersion"](s.data.id);
          if (!o) {
            const a = await t.$store.dispatch(
              "news/getNewsItem",
              s.data.id
            );
            o = a == null ? void 0 : a.version;
          }
          [2, 5, 4].includes(o.status_id) && (r(s), await t.$store.dispatch("news/pickNewsItemToEdit", {
            newsItemId: s.data.id,
            notificationId: s.data.notificationId
          }));
        }
        if (s.data.type === "note") {
          if (!n()) {
            r(s), await t.$router.push({
              path: `/notes/${s.data.id}`
            }).catch(() => null);
            return;
          }
          await t.$store.dispatch("pickAsoiNote", {
            note: { id: s.data.id },
            notificationId: s.data.notificationId
          });
        }
      }
    }
  });
}
const _It = function(t, { timeout: e = 5e3 } = {}) {
  const n = Date.now();
  return setTimeout(function() {
    t({
      didTimeout: !1,
      timeRemaining: function() {
        return Math.max(0, e - (Date.now() - n));
      }
    });
  }, 1);
};
globalThis.requestIdleCallback = globalThis.requestIdleCallback || _It;
U.config.productionTip = !1;
U.config.performance = OS;
U.config.devtools = OS;
U.use(qj);
U.use(gR);
U.use(T2t);
U.use(k2t, {
  interval: 1e4
});
U.use($2t);
U.use(s2t);
U.use(n2t);
U.use(o2t, {
  locales: {
    "ru-RU": {
      firstDayOfWeek: 2
    }
  }
});
U.use(oKe(JO));
U.mixin(D2t);
U.component("icon", cc);
U.component("v-select", zj);
U.component("multiselect", l2t);
U.component("paginate", u2t);
U.directive("ripple", hS);
U.directive("permissions", O2t);
zj.props.components.default = () => ({
  OpenIndicator: {
    render: (t) => t("span", "▾")
  }
});
ni.auth.init();
function CIt() {
  let t = new U({
    router: cs,
    store: Fa,
    render: (e) => e(yIt)
  });
  return bIt(t), t;
}
window.addEventListener("beforeunload", () => {
  rv.unregisterCurrentTab();
});
export {
  CIt as default
};
//# sourceMappingURL=publishing-ui.mjs.map
